!function(e){function r(e,r,o){return 4===arguments.length?t.apply(this,arguments):void n(e,{declarative:!0,deps:r,declare:o})}function t(e,r,t,o){n(e,{declarative:!1,deps:r,executingRequire:t,execute:o})}function n(e,r){r.name=e,e in v||(v[e]=r),r.normalizedDeps=r.deps}function o(e,r){if(r[e.groupIndex]=r[e.groupIndex]||[],-1==g.call(r[e.groupIndex],e)){r[e.groupIndex].push(e);for(var t=0,n=e.normalizedDeps.length;n>t;t++){var a=e.normalizedDeps[t],u=v[a];if(u&&!u.evaluated){var d=e.groupIndex+(u.declarative!=e.declarative);if(void 0===u.groupIndex||u.groupIndex<d){if(void 0!==u.groupIndex&&(r[u.groupIndex].splice(g.call(r[u.groupIndex],u),1),0==r[u.groupIndex].length))throw new TypeError("Mixed dependency cycle detected");u.groupIndex=d}o(u,r)}}}}function a(e){var r=v[e];r.groupIndex=0;var t=[];o(r,t);for(var n=!!r.declarative==t.length%2,a=t.length-1;a>=0;a--){for(var u=t[a],i=0;i<u.length;i++){var s=u[i];n?d(s):l(s)}n=!n}}function u(e){return y[e]||(y[e]={name:e,dependencies:[],exports:{},importers:[]})}function d(r){if(!r.module){var t=r.module=u(r.name),n=r.module.exports,o=r.declare.call(e,function(e,r){if(t.locked=!0,"object"==typeof e)for(var o in e)n[o]=e[o];else n[e]=r;for(var a=0,u=t.importers.length;u>a;a++){var d=t.importers[a];if(!d.locked)for(var i=0;i<d.dependencies.length;++i)d.dependencies[i]===t&&d.setters[i](n)}return t.locked=!1,r},{id:r.name});t.setters=o.setters,t.execute=o.execute;for(var a=0,i=r.normalizedDeps.length;i>a;a++){var l,s=r.normalizedDeps[a],c=v[s],f=y[s];f?l=f.exports:c&&!c.declarative?l=c.esModule:c?(d(c),f=c.module,l=f.exports):l=p(s),f&&f.importers?(f.importers.push(t),t.dependencies.push(f)):t.dependencies.push(null),t.setters[a]&&t.setters[a](l)}}}function i(e){var r,t=v[e];if(t)t.declarative?f(e,[]):t.evaluated||l(t),r=t.module.exports;else if(r=p(e),!r)throw new Error("Unable to load dependency "+e+".");return(!t||t.declarative)&&r&&r.__useDefault?r["default"]:r}function l(r){if(!r.module){var t={},n=r.module={exports:t,id:r.name};if(!r.executingRequire)for(var o=0,a=r.normalizedDeps.length;a>o;o++){var u=r.normalizedDeps[o],d=v[u];d&&l(d)}r.evaluated=!0;var c=r.execute.call(e,function(e){for(var t=0,n=r.deps.length;n>t;t++)if(r.deps[t]==e)return i(r.normalizedDeps[t]);throw new TypeError("Module "+e+" not declared as a dependency.")},t,n);void 0!==c&&(n.exports=c),t=n.exports,t&&t.__esModule?r.esModule=t:r.esModule=s(t)}}function s(r){var t={};if(("object"==typeof r||"function"==typeof r)&&r!==e)if(m)for(var n in r)"default"!==n&&c(t,r,n);else{var o=r&&r.hasOwnProperty;for(var n in r)"default"===n||o&&!r.hasOwnProperty(n)||(t[n]=r[n])}return t["default"]=r,x(t,"__useDefault",{value:!0}),t}function c(e,r,t){try{var n;(n=Object.getOwnPropertyDescriptor(r,t))&&x(e,t,n)}catch(o){return e[t]=r[t],!1}}function f(r,t){var n=v[r];if(n&&!n.evaluated&&n.declarative){t.push(r);for(var o=0,a=n.normalizedDeps.length;a>o;o++){var u=n.normalizedDeps[o];-1==g.call(t,u)&&(v[u]?f(u,t):p(u))}n.evaluated||(n.evaluated=!0,n.module.execute.call(e))}}function p(e){if(I[e])return I[e];if("@node/"==e.substr(0,6))return I[e]=s(D(e.substr(6)));var r=v[e];if(!r)throw"Module "+e+" not present.";return a(e),f(e,[]),v[e]=void 0,r.declarative&&x(r.module.exports,"__esModule",{value:!0}),I[e]=r.declarative?r.module.exports:r.esModule}var v={},g=Array.prototype.indexOf||function(e){for(var r=0,t=this.length;t>r;r++)if(this[r]===e)return r;return-1},m=!0;try{Object.getOwnPropertyDescriptor({a:0},"a")}catch(h){m=!1}var x;!function(){try{Object.defineProperty({},"a",{})&&(x=Object.defineProperty)}catch(e){x=function(e,r,t){try{e[r]=t.value||t.get.call(e)}catch(n){}}}}();var y={},D="undefined"!=typeof System&&System._nodeRequire||"undefined"!=typeof require&&"undefined"!=typeof require.resolve&&"undefined"!=typeof process&&process.platform&&require,I={"@empty":{}};return function(e,n,o,a){return function(u){u(function(u){for(var d={_nodeRequire:D,register:r,registerDynamic:t,get:p,set:function(e,r){I[e]=r},newModule:function(e){return e}},i=0;i<n.length;i++)(function(e,r){r&&r.__esModule?I[e]=r:I[e]=s(r)})(n[i],arguments[i]);a(d);var l=p(e[0]);if(e.length>1)for(var i=1;i<e.length;i++)p(e[i]);return o?l["default"]:l})}}}("undefined"!=typeof self?self:global)

(["1"], [], false, function($__System) {
var require = this.require, exports = this.exports, module = this.module;
!function(e){function r(e,r){for(var n=e.split(".");n.length;)r=r[n.shift()];return r}function n(n){if("string"==typeof n)return r(n,e);if(!(n instanceof Array))throw new Error("Global exports must be a string or array.");for(var t={},o=!0,f=0;f<n.length;f++){var i=r(n[f],e);o&&(t["default"]=i,o=!1),t[n[f].split(".").pop()]=i}return t}function t(r){if(Object.keys)Object.keys(e).forEach(r);else for(var n in e)a.call(e,n)&&r(n)}function o(r){t(function(n){if(-1==l.call(s,n)){try{var t=e[n]}catch(o){s.push(n)}r(n,t)}})}var f,i=$__System,a=Object.prototype.hasOwnProperty,l=Array.prototype.indexOf||function(e){for(var r=0,n=this.length;n>r;r++)if(this[r]===e)return r;return-1},s=["_g","sessionStorage","localStorage","clipboardData","frames","frameElement","external","mozAnimationStartTime","webkitStorageInfo","webkitIndexedDB","mozInnerScreenY","mozInnerScreenX"];i.set("@@global-helpers",i.newModule({prepareGlobal:function(r,t,i){var a=e.define;e.define=void 0;var l;if(i){l={};for(var s in i)l[s]=e[s],e[s]=i[s]}return t||(f={},o(function(e,r){f[e]=r})),function(){var r;if(t)r=n(t);else{r={};var i,s;o(function(e,n){f[e]!==n&&"undefined"!=typeof n&&(r[e]=n,"undefined"!=typeof i?s||i===n||(s=!0):i=n)}),r=s?r:i}if(l)for(var u in l)e[u]=l[u];return e.define=a,r}}}))}("undefined"!=typeof self?self:global);
!function(e){function n(e,n){e=e.replace(l,"");var r=e.match(u),t=(r[1].split(",")[n]||"require").replace(s,""),i=p[t]||(p[t]=new RegExp(a+t+f,"g"));i.lastIndex=0;for(var o,c=[];o=i.exec(e);)c.push(o[2]||o[3]);return c}function r(e,n,t,o){if("object"==typeof e&&!(e instanceof Array))return r.apply(null,Array.prototype.splice.call(arguments,1,arguments.length-1));if("string"==typeof e&&"function"==typeof n&&(e=[e]),!(e instanceof Array)){if("string"==typeof e){var l=i.get(e);return l.__useDefault?l["default"]:l}throw new TypeError("Invalid require")}for(var a=[],f=0;f<e.length;f++)a.push(i["import"](e[f],o));Promise.all(a).then(function(e){n&&n.apply(null,e)},t)}function t(t,l,a){"string"!=typeof t&&(a=l,l=t,t=null),l instanceof Array||(a=l,l=["require","exports","module"].splice(0,a.length)),"function"!=typeof a&&(a=function(e){return function(){return e}}(a)),void 0===l[l.length-1]&&l.pop();var f,u,s;-1!=(f=o.call(l,"require"))&&(l.splice(f,1),t||(l=l.concat(n(a.toString(),f)))),-1!=(u=o.call(l,"exports"))&&l.splice(u,1),-1!=(s=o.call(l,"module"))&&l.splice(s,1);var p={name:t,deps:l,execute:function(n,t,o){for(var p=[],c=0;c<l.length;c++)p.push(n(l[c]));o.uri=o.id,o.config=function(){},-1!=s&&p.splice(s,0,o),-1!=u&&p.splice(u,0,t),-1!=f&&p.splice(f,0,function(e,t,l){return"string"==typeof e&&"function"!=typeof t?n(e):r.call(i,e,t,l,o.id)});var d=a.apply(-1==u?e:t,p);return"undefined"==typeof d&&o&&(d=o.exports),"undefined"!=typeof d?d:void 0}};if(t)c.anonDefine||c.isBundle?c.anonDefine&&c.anonDefine.name&&(c.anonDefine=null):c.anonDefine=p,c.isBundle=!0,i.registerDynamic(p.name,p.deps,!1,p.execute);else{if(c.anonDefine&&!c.anonDefine.name)throw new Error("Multiple anonymous defines in module "+t);c.anonDefine=p}}var i=$__System,o=Array.prototype.indexOf||function(e){for(var n=0,r=this.length;r>n;n++)if(this[n]===e)return n;return-1},l=/(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm,a="(?:^|[^$_a-zA-Z\\xA0-\\uFFFF.])",f="\\s*\\(\\s*(\"([^\"]+)\"|'([^']+)')\\s*\\)",u=/\(([^\)]*)\)/,s=/^\s+|\s+$/g,p={};t.amd={};var c={isBundle:!1,anonDefine:null};i.amdDefine=t,i.amdRequire=r}("undefined"!=typeof self?self:global);
$__System.registerDynamic("2", ["3"], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {
    /* */
    "format global";
    "deps angular";
    /*!
     * angular-translate - v2.11.0 - 2016-03-20
     * 
     * Copyright (c) 2016 The angular-translate team, Pascal Precht; Licensed MIT
     */

    (function (root, factory) {
      if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module unless amdModuleId is set
        define([], function () {
          return factory();
        });
      } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
      } else {
        factory();
      }
    })(this, function () {

      /**
       * @ngdoc overview
       * @name pascalprecht.translate
       *
       * @description
       * The main module which holds everything together.
       */
      runTranslate.$inject = ['$translate'];
      $translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
      $translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
      translateDirective.$inject = ['$translate', '$q', '$interpolate', '$compile', '$parse', '$rootScope'];
      translateCloakDirective.$inject = ['$translate', '$rootScope'];
      translateFilterFactory.$inject = ['$parse', '$translate'];
      $translationCache.$inject = ['$cacheFactory'];
      angular.module('pascalprecht.translate', ['ng']).run(runTranslate);

      function runTranslate($translate) {

        'use strict';

        var key = $translate.storageKey(),
            storage = $translate.storage();

        var fallbackFromIncorrectStorageValue = function () {
          var preferred = $translate.preferredLanguage();
          if (angular.isString(preferred)) {
            $translate.use(preferred);
            // $translate.use() will also remember the language.
            // So, we don't need to call storage.put() here.
          } else {
            storage.put(key, $translate.use());
          }
        };

        fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

        if (storage) {
          if (!storage.get(key)) {
            fallbackFromIncorrectStorageValue();
          } else {
            $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
          }
        } else if (angular.isString($translate.preferredLanguage())) {
          $translate.use($translate.preferredLanguage());
        }
      }

      runTranslate.displayName = 'runTranslate';

      /**
       * @ngdoc object
       * @name pascalprecht.translate.$translateSanitizationProvider
       *
       * @description
       *
       * Configurations for $translateSanitization
       */
      angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

      function $translateSanitizationProvider() {

        'use strict';

        var $sanitize,
            currentStrategy = null,
            // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
        hasConfiguredStrategy = false,
            hasShownNoStrategyConfiguredWarning = false,
            strategies;

        /**
         * Definition of a sanitization strategy function
         * @callback StrategyFunction
         * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
         * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
         * @return {string|object}
         */

        /**
         * @ngdoc property
         * @name strategies
         * @propertyOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Following strategies are built-in:
         * <dl>
         *   <dt>sanitize</dt>
         *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
         *   <dt>escape</dt>
         *   <dd>Escapes HTML in the translation</dd>
         *   <dt>sanitizeParameters</dt>
         *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
         *   <dt>escapeParameters</dt>
         *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
         *   <dt>escaped</dt>
         *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
         * </dl>
         *
         */

        strategies = {
          sanitize: function (value, mode) {
            if (mode === 'text') {
              value = htmlSanitizeValue(value);
            }
            return value;
          },
          escape: function (value, mode) {
            if (mode === 'text') {
              value = htmlEscapeValue(value);
            }
            return value;
          },
          sanitizeParameters: function (value, mode) {
            if (mode === 'params') {
              value = mapInterpolationParameters(value, htmlSanitizeValue);
            }
            return value;
          },
          escapeParameters: function (value, mode) {
            if (mode === 'params') {
              value = mapInterpolationParameters(value, htmlEscapeValue);
            }
            return value;
          }
        };
        // Support legacy strategy name 'escaped' for backwards compatibility.
        // TODO should be removed in 3.0
        strategies.escaped = strategies.escapeParameters;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Adds a sanitization strategy to the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @param {StrategyFunction} strategyFunction - strategy function
         * @returns {object} this
         */
        this.addStrategy = function (strategyName, strategyFunction) {
          strategies[strategyName] = strategyFunction;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Removes a sanitization strategy from the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @returns {object} this
         */
        this.removeStrategy = function (strategyName) {
          delete strategies[strategyName];
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
         *
         * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
         * @returns {object} this
         */
        this.useStrategy = function (strategy) {
          hasConfiguredStrategy = true;
          currentStrategy = strategy;
          return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translateSanitization
         * @requires $injector
         * @requires $log
         *
         * @description
         * Sanitizes interpolation parameters and translated texts.
         *
         */
        this.$get = ['$injector', '$log', function ($injector, $log) {

          var cachedStrategyMap = {};

          var applyStrategies = function (value, mode, selectedStrategies) {
            angular.forEach(selectedStrategies, function (selectedStrategy) {
              if (angular.isFunction(selectedStrategy)) {
                value = selectedStrategy(value, mode);
              } else if (angular.isFunction(strategies[selectedStrategy])) {
                value = strategies[selectedStrategy](value, mode);
              } else if (angular.isString(strategies[selectedStrategy])) {
                if (!cachedStrategyMap[strategies[selectedStrategy]]) {
                  try {
                    cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
                  } catch (e) {
                    cachedStrategyMap[strategies[selectedStrategy]] = function () {};
                    throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
                  }
                }
                value = cachedStrategyMap[strategies[selectedStrategy]](value, mode);
              } else {
                throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
              }
            });
            return value;
          };

          // TODO: should be removed in 3.0
          var showNoStrategyConfiguredWarning = function () {
            if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
              $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
              hasShownNoStrategyConfiguredWarning = true;
            }
          };

          if ($injector.has('$sanitize')) {
            $sanitize = $injector.get('$sanitize');
          }

          return {
            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translateSanitization#useStrategy
             * @methodOf pascalprecht.translate.$translateSanitization
             *
             * @description
             * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
             *
             * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
             */
            useStrategy: function (self) {
              return function (strategy) {
                self.useStrategy(strategy);
              };
            }(this),

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translateSanitization#sanitize
             * @methodOf pascalprecht.translate.$translateSanitization
             *
             * @description
             * Sanitizes a value.
             *
             * @param {string|object} value The value which should be sanitized.
             * @param {string} mode The current sanitization mode, either 'params' or 'text'.
             * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
             * @returns {string|object} sanitized value
             */
            sanitize: function (value, mode, strategy) {
              if (!currentStrategy) {
                showNoStrategyConfiguredWarning();
              }

              if (arguments.length < 3) {
                strategy = currentStrategy;
              }

              if (!strategy) {
                return value;
              }

              var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
              return applyStrategies(value, mode, selectedStrategies);
            }
          };
        }];

        var htmlEscapeValue = function (value) {
          var element = angular.element('<div></div>');
          element.text(value); // not chainable, see #1044
          return element.html();
        };

        var htmlSanitizeValue = function (value) {
          if (!$sanitize) {
            throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
          }
          return $sanitize(value);
        };

        var mapInterpolationParameters = function (value, iteratee, stack) {
          if (angular.isObject(value)) {
            var result = angular.isArray(value) ? [] : {};

            if (!stack) {
              stack = [];
            } else {
              if (stack.indexOf(value) > -1) {
                throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
              }
            }

            stack.push(value);
            angular.forEach(value, function (propertyValue, propertyKey) {
              result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
            });
            stack.splice(-1, 1); // remove last

            return result;
          } else if (angular.isNumber(value)) {
            return value;
          } else {
            return iteratee(value);
          }
        };
      }

      /**
       * @ngdoc object
       * @name pascalprecht.translate.$translateProvider
       * @description
       *
       * $translateProvider allows developers to register translation-tables, asynchronous loaders
       * and similar to configure translation behavior directly inside of a module.
       *
       */
      angular.module('pascalprecht.translate').constant('pascalprechtTranslateOverrider', {}).provider('$translate', $translate);

      function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

        'use strict';

        var $translationTable = {},
            $preferredLanguage,
            $availableLanguageKeys = [],
            $languageKeyAliases,
            $fallbackLanguage,
            $fallbackWasString,
            $uses,
            $nextLang,
            $storageFactory,
            $storageKey = $STORAGE_KEY,
            $storagePrefix,
            $missingTranslationHandlerFactory,
            $interpolationFactory,
            $interpolatorFactories = [],
            $loaderFactory,
            $cloakClassName = 'translate-cloak',
            $loaderOptions,
            $notFoundIndicatorLeft,
            $notFoundIndicatorRight,
            $postCompilingEnabled = false,
            $forceAsyncReloadEnabled = false,
            $nestedObjectDelimeter = '.',
            $isReady = false,
            loaderCache,
            directivePriority = 0,
            statefulFilter = true,
            postProcessFn,
            uniformLanguageTagResolver = 'default',
            languageTagResolver = {
          'default': function (tag) {
            return (tag || '').split('-').join('_');
          },
          java: function (tag) {
            var temp = (tag || '').split('-').join('_');
            var parts = temp.split('_');
            return parts.length > 1 ? parts[0].toLowerCase() + '_' + parts[1].toUpperCase() : temp;
          },
          bcp47: function (tag) {
            var temp = (tag || '').split('_').join('-');
            var parts = temp.split('-');
            return parts.length > 1 ? parts[0].toLowerCase() + '-' + parts[1].toUpperCase() : temp;
          },
          'iso639-1': function (tag) {
            var temp = (tag || '').split('_').join('-');
            var parts = temp.split('-');
            return parts[0].toLowerCase();
          }
        };

        var version = '2.11.0';

        // tries to determine the browsers language
        var getFirstBrowserLanguage = function () {

          // internal purpose only
          if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
            return pascalprechtTranslateOverrider.getLocale();
          }

          var nav = $windowProvider.$get().navigator,
              browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
              i,
              language;

          // support for HTML 5.1 "navigator.languages"
          if (angular.isArray(nav.languages)) {
            for (i = 0; i < nav.languages.length; i++) {
              language = nav.languages[i];
              if (language && language.length) {
                return language;
              }
            }
          }

          // support for other well known properties in browsers
          for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
            language = nav[browserLanguagePropertyKeys[i]];
            if (language && language.length) {
              return language;
            }
          }

          return null;
        };
        getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

        // tries to determine the browsers locale
        var getLocale = function () {
          var locale = getFirstBrowserLanguage() || '';
          if (languageTagResolver[uniformLanguageTagResolver]) {
            locale = languageTagResolver[uniformLanguageTagResolver](locale);
          }
          return locale;
        };
        getLocale.displayName = 'angular-translate/service: getLocale';

        /**
         * @name indexOf
         * @private
         *
         * @description
         * indexOf polyfill. Kinda sorta.
         *
         * @param {array} array Array to search in.
         * @param {string} searchElement Element to search for.
         *
         * @returns {int} Index of search element.
         */
        var indexOf = function (array, searchElement) {
          for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === searchElement) {
              return i;
            }
          }
          return -1;
        };

        /**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */
        var trim = function () {
          return this.toString().replace(/^\s+|\s+$/g, '');
        };

        var negotiateLocale = function (preferred) {
          if (!preferred) {
            return;
          }

          var avail = [],
              locale = angular.lowercase(preferred),
              i = 0,
              n = $availableLanguageKeys.length;

          for (; i < n; i++) {
            avail.push(angular.lowercase($availableLanguageKeys[i]));
          }

          // Check for an exact match in our list of available keys
          if (indexOf(avail, locale) > -1) {
            return preferred;
          }

          if ($languageKeyAliases) {
            var alias;
            for (var langKeyAlias in $languageKeyAliases) {
              if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
                var hasWildcardKey = false;
                var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) && angular.lowercase(langKeyAlias) === angular.lowercase(preferred);

                if (langKeyAlias.slice(-1) === '*') {
                  hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length - 1);
                }
                if (hasExactKey || hasWildcardKey) {
                  alias = $languageKeyAliases[langKeyAlias];
                  if (indexOf(avail, angular.lowercase(alias)) > -1) {
                    return alias;
                  }
                }
              }
            }
          }

          // Check for a language code without region
          var parts = preferred.split('_');

          if (parts.length > 1 && indexOf(avail, angular.lowercase(parts[0])) > -1) {
            return parts[0];
          }

          // If everything fails, return undefined.
          return;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translations
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a new translation table for specific language key.
         *
         * To register a translation table for specific language, pass a defined language
         * key as first parameter.
         *
         * <pre>
         *  // register translation table for language: 'de_DE'
         *  $translateProvider.translations('de_DE', {
         *    'GREETING': 'Hallo Welt!'
         *  });
         *
         *  // register another one
         *  $translateProvider.translations('en_US', {
         *    'GREETING': 'Hello world!'
         *  });
         * </pre>
         *
         * When registering multiple translation tables for for the same language key,
         * the actual translation table gets extended. This allows you to define module
         * specific translation which only get added, once a specific module is loaded in
         * your app.
         *
         * Invoking this method with no arguments returns the translation table which was
         * registered with no language key. Invoking it with a language key returns the
         * related translation table.
         *
         * @param {string} langKey A language key.
         * @param {object} translationTable A plain old JavaScript object that represents a translation table.
         *
         */
        var translations = function (langKey, translationTable) {

          if (!langKey && !translationTable) {
            return $translationTable;
          }

          if (langKey && !translationTable) {
            if (angular.isString(langKey)) {
              return $translationTable[langKey];
            }
          } else {
            if (!angular.isObject($translationTable[langKey])) {
              $translationTable[langKey] = {};
            }
            angular.extend($translationTable[langKey], flatObject(translationTable));
          }
          return this;
        };

        this.translations = translations;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#cloakClassName
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the class name for `translate-cloak` directive.
         * Default class name is `translate-cloak`.
         *
         * @param {string} name translate-cloak class name
         */
        this.cloakClassName = function (name) {
          if (!name) {
            return $cloakClassName;
          }
          $cloakClassName = name;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the delimiter for namespaced translations.
         * Default delimiter is `.`.
         *
         * @param {string} delimiter namespace separator
         */
        this.nestedObjectDelimeter = function (delimiter) {
          if (!delimiter) {
            return $nestedObjectDelimeter;
          }
          $nestedObjectDelimeter = delimiter;
          return this;
        };

        /**
         * @name flatObject
         * @private
         *
         * @description
         * Flats an object. This function is used to flatten given translation data with
         * namespaces, so they are later accessible via dot notation.
         */
        var flatObject = function (data, path, result, prevKey) {
          var key, keyWithPath, keyWithShortPath, val;

          if (!path) {
            path = [];
          }
          if (!result) {
            result = {};
          }
          for (key in data) {
            if (!Object.prototype.hasOwnProperty.call(data, key)) {
              continue;
            }
            val = data[key];
            if (angular.isObject(val)) {
              flatObject(val, path.concat(key), result, key);
            } else {
              keyWithPath = path.length ? '' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key : key;
              if (path.length && key === prevKey) {
                // Create shortcut path (foo.bar == foo.bar.bar)
                keyWithShortPath = '' + path.join($nestedObjectDelimeter);
                // Link it to original path
                result[keyWithShortPath] = '@:' + keyWithPath;
              }
              result[keyWithPath] = val;
            }
          }
          return result;
        };
        flatObject.displayName = 'flatObject';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#addInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Adds interpolation services to angular-translate, so it can manage them.
         *
         * @param {object} factory Interpolation service factory
         */
        this.addInterpolation = function (factory) {
          $interpolatorFactories.push(factory);
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use interpolation functionality of messageformat.js.
         * This is useful when having high level pluralization and gender selection.
         */
        this.useMessageFormatInterpolation = function () {
          return this.useInterpolation('$translateMessageFormatInterpolation');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which interpolation style to use as default, application-wide.
         * Simply pass a factory/service name. The interpolation service has to implement
         * the correct interface.
         *
         * @param {string} factory Interpolation service name.
         */
        this.useInterpolation = function (factory) {
          $interpolationFactory = factory;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Simply sets a sanitation strategy type.
         *
         * @param {string} value Strategy type.
         */
        this.useSanitizeValueStrategy = function (value) {
          $translateSanitizationProvider.useStrategy(value);
          return this;
        };

        /**
          * @ngdoc function
          * @name pascalprecht.translate.$translateProvider#preferredLanguage
          * @methodOf pascalprecht.translate.$translateProvider
          *
          * @description
          * Tells the module which of the registered translation tables to use for translation
          * at initial startup by passing a language key. Similar to `$translateProvider#use`
          * only that it says which language to **prefer**.
          *
          * @param {string} langKey A language key.
          */
        this.preferredLanguage = function (langKey) {
          if (langKey) {
            setupPreferredLanguage(langKey);
            return this;
          }
          return $preferredLanguage;
        };
        var setupPreferredLanguage = function (langKey) {
          if (langKey) {
            $preferredLanguage = langKey;
          }
          return $preferredLanguage;
        };
        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found. E.g. when
         * setting the indicator as 'X' and one tries to translate a translation id
         * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
         *
         * Internally this methods sets a left indicator and a right indicator using
         * `$translateProvider.translationNotFoundIndicatorLeft()` and
         * `$translateProvider.translationNotFoundIndicatorRight()`.
         *
         * **Note**: These methods automatically add a whitespace between the indicators
         * and the translation id.
         *
         * @param {string} indicator An indicator, could be any string.
         */
        this.translationNotFoundIndicator = function (indicator) {
          this.translationNotFoundIndicatorLeft(indicator);
          this.translationNotFoundIndicatorRight(indicator);
          return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found left to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorLeft = function (indicator) {
          if (!indicator) {
            return $notFoundIndicatorLeft;
          }
          $notFoundIndicatorLeft = indicator;
          return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found right to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorRight = function (indicator) {
          if (!indicator) {
            return $notFoundIndicatorRight;
          }
          $notFoundIndicatorRight = indicator;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#fallbackLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which of the registered translation tables to use when missing translations
         * at initial startup by passing a language key. Similar to `$translateProvider#use`
         * only that it says which language to **fallback**.
         *
         * @param {string||array} langKey A language key.
         *
         */
        this.fallbackLanguage = function (langKey) {
          fallbackStack(langKey);
          return this;
        };

        var fallbackStack = function (langKey) {
          if (langKey) {
            if (angular.isString(langKey)) {
              $fallbackWasString = true;
              $fallbackLanguage = [langKey];
            } else if (angular.isArray(langKey)) {
              $fallbackWasString = false;
              $fallbackLanguage = langKey;
            }
            if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }

            return this;
          } else {
            if ($fallbackWasString) {
              return $fallbackLanguage[0];
            } else {
              return $fallbackLanguage;
            }
          }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#use
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Set which translation table to use for translation by given language key. When
         * trying to 'use' a language which isn't provided, it'll throw an error.
         *
         * You actually don't have to use this method since `$translateProvider#preferredLanguage`
         * does the job too.
         *
         * @param {string} langKey A language key.
         */
        this.use = function (langKey) {
          if (langKey) {
            if (!$translationTable[langKey] && !$loaderFactory) {
              // only throw an error, when not loading translation data asynchronously
              throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
            }
            $uses = langKey;
            return this;
          }
          return $uses;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#resolveClientLocale
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
         *
         * @returns {string} the current client/browser language key
         */
        this.resolveClientLocale = function () {
          return getLocale();
        };

        /**
          * @ngdoc function
          * @name pascalprecht.translate.$translateProvider#storageKey
          * @methodOf pascalprecht.translate.$translateProvider
          *
          * @description
          * Tells the module which key must represent the choosed language by a user in the storage.
          *
          * @param {string} key A key for the storage.
          */
        var storageKey = function (key) {
          if (!key) {
            if ($storagePrefix) {
              return $storagePrefix + $storageKey;
            }
            return $storageKey;
          }
          $storageKey = key;
          return this;
        };

        this.storageKey = storageKey;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useUrlLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
         *
         * @param {string} url Url
         * @param {Object=} options Optional configuration object
         */
        this.useUrlLoader = function (url, options) {
          return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
         *
         * @param {Object=} options Optional configuration object
         */
        this.useStaticFilesLoader = function (options) {
          return this.useLoader('$translateStaticFilesLoader', options);
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use any other service as loader.
         *
         * @param {string} loaderFactory Factory name to use
         * @param {Object=} options Optional configuration object
         */
        this.useLoader = function (loaderFactory, options) {
          $loaderFactory = loaderFactory;
          $loaderOptions = options || {};
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLocalStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
         *
         */
        this.useLocalStorage = function () {
          return this.useStorage('$translateLocalStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useCookieStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
         */
        this.useCookieStorage = function () {
          return this.useStorage('$translateCookieStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use custom service as storage layer.
         */
        this.useStorage = function (storageFactory) {
          $storageFactory = storageFactory;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#storagePrefix
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets prefix for storage key.
         *
         * @param {string} prefix Storage key prefix
         */
        this.storagePrefix = function (prefix) {
          if (!prefix) {
            return prefix;
          }
          $storagePrefix = prefix;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use built-in log handler when trying to translate
         * a translation Id which doesn't exist.
         *
         * This is actually a shortcut method for `useMissingTranslationHandler()`.
         *
         */
        this.useMissingTranslationHandlerLog = function () {
          return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Expects a factory name which later gets instantiated with `$injector`.
         * This method can be used to tell angular-translate to use a custom
         * missingTranslationHandler. Just build a factory which returns a function
         * and expects a translation id as argument.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.useMissingTranslationHandler('customHandler');
         *  });
         *
         *  app.factory('customHandler', function (dep1, dep2) {
         *    return function (translationId) {
         *      // something with translationId and dep1 and dep2
         *    };
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.useMissingTranslationHandler = function (factory) {
          $missingTranslationHandlerFactory = factory;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#usePostCompiling
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If post compiling is enabled, all translated values will be processed
         * again with AngularJS' $compile.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.usePostCompiling(true);
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.usePostCompiling = function (value) {
          $postCompilingEnabled = !!value;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#forceAsyncReload
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If force async reload is enabled, async loader will always be called
         * even if $translationTable already contains the language key, adding
         * possible new entries to the $translationTable.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.forceAsyncReload(true);
         *  });
         * </pre>
         *
         * @param {boolean} value - valid values are true or false
         */
        this.forceAsyncReload = function (value) {
          $forceAsyncReloadEnabled = !!value;
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which language tag should be used as a result when determining
         * the current browser language.
         *
         * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
         *
         * <pre>
         * $translateProvider
         *   .uniformLanguageTag('bcp47')
         *   .determinePreferredLanguage()
         * </pre>
         *
         * The resolver currently supports:
         * * default
         *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_us
         * * java
         *     like default, but the second part will be always in uppercase
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_US
         * * BCP 47 (RFC 4646 & 4647)
         *     en-US => en-US
         *     en_US => en-US
         *     en-us => en-US
         *
         * See also:
         * * http://en.wikipedia.org/wiki/IETF_language_tag
         * * http://www.w3.org/International/core/langtags/
         * * http://tools.ietf.org/html/bcp47
         *
         * @param {string|object} options - options (or standard)
         * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
         */
        this.uniformLanguageTag = function (options) {

          if (!options) {
            options = {};
          } else if (angular.isString(options)) {
            options = {
              standard: options
            };
          }

          uniformLanguageTagResolver = options.standard;

          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to try to determine on its own which language key
         * to set as preferred language. When `fn` is given, angular-translate uses it
         * to determine a language key, otherwise it uses the built-in `getLocale()`
         * method.
         *
         * The `getLocale()` returns a language key in the format `[lang]_[country]` or
         * `[lang]` depending on what the browser provides.
         *
         * Use this method at your own risk, since not all browsers return a valid
         * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
         *
         * @param {Function=} fn Function to determine a browser's locale
         */
        this.determinePreferredLanguage = function (fn) {

          var locale = fn && angular.isFunction(fn) ? fn() : getLocale();

          if (!$availableLanguageKeys.length) {
            $preferredLanguage = locale;
          } else {
            $preferredLanguage = negotiateLocale(locale) || locale;
          }

          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a set of language keys the app will work with. Use this method in
         * combination with
         * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
         * When available languages keys are registered, angular-translate
         * tries to find the best fitting language key depending on the browsers locale,
         * considering your language key convention.
         *
         * @param {object} languageKeys Array of language keys the your app will use
         * @param {object=} aliases Alias map.
         */
        this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
          if (languageKeys) {
            $availableLanguageKeys = languageKeys;
            if (aliases) {
              $languageKeyAliases = aliases;
            }
            return this;
          }
          return $availableLanguageKeys;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoaderCache
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a cache for internal $http based loaders.
         * {@link pascalprecht.translate.$translationCache $translationCache}.
         * When false the cache will be disabled (default). When true or undefined
         * the cache will be a default (see $cacheFactory). When an object it will
         * be treat as a cache object itself: the usage is $http({cache: cache})
         *
         * @param {object} cache boolean, string or cache-object
         */
        this.useLoaderCache = function (cache) {
          if (cache === false) {
            // disable cache
            loaderCache = undefined;
          } else if (cache === true) {
            // enable cache using AJS defaults
            loaderCache = true;
          } else if (typeof cache === 'undefined') {
            // enable cache using default
            loaderCache = '$translationCache';
          } else if (cache) {
            // enable cache using given one (see $cacheFactory)
            loaderCache = cache;
          }
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#directivePriority
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets the default priority of the translate directive. The standard value is `0`.
         * Calling this function without an argument will return the current value.
         *
         * @param {number} priority for the translate-directive
         */
        this.directivePriority = function (priority) {
          if (priority === undefined) {
            // getter
            return directivePriority;
          } else {
            // setter with chaining
            directivePriority = priority;
            return this;
          }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#statefulFilter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
         * have to explicit define this behavior.
         * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
         * meaning being stateful.
         * Calling this function without an argument will return the current value.
         *
         * @param {boolean} state - defines the state of the filter
         */
        this.statefulFilter = function (state) {
          if (state === undefined) {
            // getter
            return statefulFilter;
          } else {
            // setter with chaining
            statefulFilter = state;
            return this;
          }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#postProcess
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * The post processor will be intercept right after the translation result. It can modify the result.
         *
         * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
         */
        this.postProcess = function (fn) {
          if (fn) {
            postProcessFn = fn;
          } else {
            postProcessFn = undefined;
          }
          return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translate
         * @requires $interpolate
         * @requires $log
         * @requires $rootScope
         * @requires $q
         *
         * @description
         * The `$translate` service is the actual core of angular-translate. It expects a translation id
         * and optional interpolate parameters to translate contents.
         *
         * <pre>
         *  $translate('HEADLINE_TEXT').then(function (translation) {
         *    $scope.translatedText = translation;
         *  });
         * </pre>
         *
         * @param {string|array} translationId A token which represents a translation id
         *                                     This can be optionally an array of translation ids which
         *                                     results that the function returns an object where each key
         *                                     is the translation id and the value the translation.
         * @param {object=} interpolateParams An object hash for dynamic values
         * @param {string} interpolationId The id of the interpolation to use
         * @param {string} forceLanguage A language to be used instead of the current language
         * @returns {object} promise
         */
        this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

          var Storage,
              defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
              pendingLoader = false,
              interpolatorHashMap = {},
              langPromises = {},
              fallbackIndex,
              startFallbackIteration;

          var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage) {
            if (!$uses && $preferredLanguage) {
              $uses = $preferredLanguage;
            }
            var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
            negotiateLocale(forceLanguage) || forceLanguage : $uses;

            // Check forceLanguage is present
            if (forceLanguage) {
              loadTranslationsIfMissing(forceLanguage);
            }

            // Duck detection: If the first argument is an array, a bunch of translations was requested.
            // The result is an object.
            if (angular.isArray(translationId)) {
              // Inspired by Q.allSettled by Kris Kowal
              // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
              // This transforms all promises regardless resolved or rejected
              var translateAll = function (translationIds) {
                var results = {}; // storing the actual results
                var promises = []; // promises to wait for
                // Wraps the promise a) being always resolved and b) storing the link id->value
                var translate = function (translationId) {
                  var deferred = $q.defer();
                  var regardless = function (value) {
                    results[translationId] = value;
                    deferred.resolve([translationId, value]);
                  };
                  // we don't care whether the promise was resolved or rejected; just store the values
                  $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage).then(regardless, regardless);
                  return deferred.promise;
                };
                for (var i = 0, c = translationIds.length; i < c; i++) {
                  promises.push(translate(translationIds[i]));
                }
                // wait for all (including storing to results)
                return $q.all(promises).then(function () {
                  // return the results
                  return results;
                });
              };
              return translateAll(translationId);
            }

            var deferred = $q.defer();

            // trim off any whitespace
            if (translationId) {
              translationId = trim.apply(translationId);
            }

            var promiseToWaitFor = function () {
              var promise = $preferredLanguage ? langPromises[$preferredLanguage] : langPromises[uses];

              fallbackIndex = 0;

              if ($storageFactory && !promise) {
                // looks like there's no pending promise for $preferredLanguage or
                // $uses. Maybe there's one pending for a language that comes from
                // storage.
                var langKey = Storage.get($storageKey);
                promise = langPromises[langKey];

                if ($fallbackLanguage && $fallbackLanguage.length) {
                  var index = indexOf($fallbackLanguage, langKey);
                  // maybe the language from storage is also defined as fallback language
                  // we increase the fallback language index to not search in that language
                  // as fallback, since it's probably the first used language
                  // in that case the index starts after the first element
                  fallbackIndex = index === 0 ? 1 : 0;

                  // but we can make sure to ALWAYS fallback to preferred language at least
                  if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                    $fallbackLanguage.push($preferredLanguage);
                  }
                }
              }
              return promise;
            }();

            if (!promiseToWaitFor) {
              // no promise to wait for? okay. Then there's no loader registered
              // nor is a one pending for language that comes from storage.
              // We can just translate.
              determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses).then(deferred.resolve, deferred.reject);
            } else {
              var promiseResolved = function () {
                // $uses may have changed while waiting
                if (!forceLanguage) {
                  uses = $uses;
                }
                determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses).then(deferred.resolve, deferred.reject);
              };
              promiseResolved.displayName = 'promiseResolved';

              promiseToWaitFor['finally'](promiseResolved);
            }
            return deferred.promise;
          };

          /**
           * @name applyNotFoundIndicators
           * @private
           *
           * @description
           * Applies not fount indicators to given translation id, if needed.
           * This function gets only executed, if a translation id doesn't exist,
           * which is why a translation id is expected as argument.
           *
           * @param {string} translationId Translation id.
           * @returns {string} Same as given translation id but applied with not found
           * indicators.
           */
          var applyNotFoundIndicators = function (translationId) {
            // applying notFoundIndicators
            if ($notFoundIndicatorLeft) {
              translationId = [$notFoundIndicatorLeft, translationId].join(' ');
            }
            if ($notFoundIndicatorRight) {
              translationId = [translationId, $notFoundIndicatorRight].join(' ');
            }
            return translationId;
          };

          /**
           * @name useLanguage
           * @private
           *
           * @description
           * Makes actual use of a language by setting a given language key as used
           * language and informs registered interpolators to also use the given
           * key as locale.
           *
           * @param {key} Locale key.
           */
          var useLanguage = function (key) {
            $uses = key;

            // make sure to store new language key before triggering success event
            if ($storageFactory) {
              Storage.put($translate.storageKey(), $uses);
            }

            $rootScope.$emit('$translateChangeSuccess', { language: key });

            // inform default interpolator
            defaultInterpolator.setLocale($uses);

            var eachInterpolator = function (interpolator, id) {
              interpolatorHashMap[id].setLocale($uses);
            };
            eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

            // inform all others too!
            angular.forEach(interpolatorHashMap, eachInterpolator);
            $rootScope.$emit('$translateChangeEnd', { language: key });
          };

          /**
           * @name loadAsync
           * @private
           *
           * @description
           * Kicks of registered async loader using `$injector` and applies existing
           * loader options. When resolved, it updates translation tables accordingly
           * or rejects with given language key.
           *
           * @param {string} key Language key.
           * @return {Promise} A promise.
           */
          var loadAsync = function (key) {
            if (!key) {
              throw 'No language key specified for loading.';
            }

            var deferred = $q.defer();

            $rootScope.$emit('$translateLoadingStart', { language: key });
            pendingLoader = true;

            var cache = loaderCache;
            if (typeof cache === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }

            var loaderOptions = angular.extend({}, $loaderOptions, {
              key: key,
              $http: angular.extend({}, {
                cache: cache
              }, $loaderOptions.$http)
            });

            var onLoaderSuccess = function (data) {
              var translationTable = {};
              $rootScope.$emit('$translateLoadingSuccess', { language: key });

              if (angular.isArray(data)) {
                angular.forEach(data, function (table) {
                  angular.extend(translationTable, flatObject(table));
                });
              } else {
                angular.extend(translationTable, flatObject(data));
              }
              pendingLoader = false;
              deferred.resolve({
                key: key,
                table: translationTable
              });
              $rootScope.$emit('$translateLoadingEnd', { language: key });
            };
            onLoaderSuccess.displayName = 'onLoaderSuccess';

            var onLoaderError = function (key) {
              $rootScope.$emit('$translateLoadingError', { language: key });
              deferred.reject(key);
              $rootScope.$emit('$translateLoadingEnd', { language: key });
            };
            onLoaderError.displayName = 'onLoaderError';

            $injector.get($loaderFactory)(loaderOptions).then(onLoaderSuccess, onLoaderError);

            return deferred.promise;
          };

          if ($storageFactory) {
            Storage = $injector.get($storageFactory);

            if (!Storage.get || !Storage.put) {
              throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
            }
          }

          // if we have additional interpolations that were added via
          // $translateProvider.addInterpolation(), we have to map'em
          if ($interpolatorFactories.length) {
            var eachInterpolationFactory = function (interpolatorFactory) {
              var interpolator = $injector.get(interpolatorFactory);
              // setting initial locale for each interpolation service
              interpolator.setLocale($preferredLanguage || $uses);
              // make'em recognizable through id
              interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
            };
            eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

            angular.forEach($interpolatorFactories, eachInterpolationFactory);
          }

          /**
           * @name getTranslationTable
           * @private
           *
           * @description
           * Returns a promise that resolves to the translation table
           * or is rejected if an error occurred.
           *
           * @param langKey
           * @returns {Q.promise}
           */
          var getTranslationTable = function (langKey) {
            var deferred = $q.defer();
            if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
              deferred.resolve($translationTable[langKey]);
            } else if (langPromises[langKey]) {
              var onResolve = function (data) {
                translations(data.key, data.table);
                deferred.resolve(data.table);
              };
              onResolve.displayName = 'translationTableResolver';
              langPromises[langKey].then(onResolve, deferred.reject);
            } else {
              deferred.reject();
            }
            return deferred.promise;
          };

          /**
           * @name getFallbackTranslation
           * @private
           *
           * @description
           * Returns a promise that will resolve to the translation
           * or be rejected if no translation was found for the language.
           * This function is currently only used for fallback language translation.
           *
           * @param langKey The language to translate to.
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {Q.promise}
           */
          var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator) {
            var deferred = $q.defer();

            var onResolve = function (translationTable) {
              if (Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
                Interpolator.setLocale(langKey);
                var translation = translationTable[translationId];
                if (translation.substr(0, 2) === '@:') {
                  getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator).then(deferred.resolve, deferred.reject);
                } else {
                  var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams);
                  interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

                  deferred.resolve(interpolatedValue);
                }
                Interpolator.setLocale($uses);
              } else {
                deferred.reject();
              }
            };
            onResolve.displayName = 'fallbackTranslationResolver';

            getTranslationTable(langKey).then(onResolve, deferred.reject);

            return deferred.promise;
          };

          /**
           * @name getFallbackTranslationInstant
           * @private
           *
           * @description
           * Returns a translation
           * This function is currently only used for fallback language translation.
           *
           * @param langKey The language to translate to.
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {string} translation
           */
          var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator) {
            var result,
                translationTable = $translationTable[langKey];

            if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
              Interpolator.setLocale(langKey);
              result = Interpolator.interpolate(translationTable[translationId], interpolateParams);
              if (result.substr(0, 2) === '@:') {
                return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator);
              }
              Interpolator.setLocale($uses);
            }

            return result;
          };

          /**
           * @name translateByHandler
           * @private
           *
           * Translate by missing translation handler.
           *
           * @param translationId
           * @param interpolateParams
           * @param defaultTranslationText
           * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
           * absent
           */
          var translateByHandler = function (translationId, interpolateParams, defaultTranslationText) {
            // If we have a handler factory - we might also call it here to determine if it provides
            // a default text for a translationid that can't be found anywhere in our tables
            if ($missingTranslationHandlerFactory) {
              var resultString = $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText);
              if (resultString !== undefined) {
                return resultString;
              } else {
                return translationId;
              }
            } else {
              return translationId;
            }
          };

          /**
           * @name resolveForFallbackLanguage
           * @private
           *
           * Recursive helper function for fallbackTranslation that will sequentially look
           * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
           *
           * @param fallbackLanguageIndex
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {Q.promise} Promise that will resolve to the translation.
           */
          var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText) {
            var deferred = $q.defer();

            if (fallbackLanguageIndex < $fallbackLanguage.length) {
              var langKey = $fallbackLanguage[fallbackLanguageIndex];
              getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator).then(function (data) {
                deferred.resolve(data);
              }, function () {
                // Look in the next fallback language for a translation.
                // It delays the resolving by passing another promise to resolve.
                return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText).then(deferred.resolve, deferred.reject);
              });
            } else {
              // No translation found in any fallback language
              // if a default translation text is set in the directive, then return this as a result
              if (defaultTranslationText) {
                deferred.resolve(defaultTranslationText);
              } else {
                // if no default translation is set and an error handler is defined, send it to the handler
                // and then return the result
                if ($missingTranslationHandlerFactory) {
                  deferred.resolve(translateByHandler(translationId, interpolateParams));
                } else {
                  deferred.reject(translateByHandler(translationId, interpolateParams));
                }
              }
            }
            return deferred.promise;
          };

          /**
           * @name resolveForFallbackLanguageInstant
           * @private
           *
           * Recursive helper function for fallbackTranslation that will sequentially look
           * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
           *
           * @param fallbackLanguageIndex
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {string} translation
           */
          var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
            var result;

            if (fallbackLanguageIndex < $fallbackLanguage.length) {
              var langKey = $fallbackLanguage[fallbackLanguageIndex];
              result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator);
              if (!result) {
                result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
              }
            }
            return result;
          };

          /**
           * Translates with the usage of the fallback languages.
           *
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {Q.promise} Promise, that resolves to the translation.
           */
          var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText) {
            // Start with the fallbackLanguage with index 0
            return resolveForFallbackLanguage(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, defaultTranslationText);
          };

          /**
           * Translates with the usage of the fallback languages.
           *
           * @param translationId
           * @param interpolateParams
           * @param Interpolator
           * @returns {String} translation
           */
          var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator) {
            // Start with the fallbackLanguage with index 0
            return resolveForFallbackLanguageInstant(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator);
          };

          var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses) {

            var deferred = $q.defer();

            var table = uses ? $translationTable[uses] : $translationTable,
                Interpolator = interpolationId ? interpolatorHashMap[interpolationId] : defaultInterpolator;

            // if the translation id exists, we can just interpolate it
            if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
              var translation = table[translationId];

              // If using link, rerun $translate with linked translationId and return it
              if (translation.substr(0, 2) === '@:') {

                $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses).then(deferred.resolve, deferred.reject);
              } else {
                //
                var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams);
                resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
                deferred.resolve(resolvedTranslation);
              }
            } else {
              var missingTranslationHandlerTranslation;
              // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
              if ($missingTranslationHandlerFactory && !pendingLoader) {
                missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
              }

              // since we couldn't translate the inital requested translation id,
              // we try it now with one or more fallback languages, if fallback language(s) is
              // configured.
              if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText).then(function (translation) {
                  deferred.resolve(translation);
                }, function (_translationId) {
                  deferred.reject(applyNotFoundIndicators(_translationId));
                });
              } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                // looks like the requested translation id doesn't exists.
                // Now, if there is a registered handler for missing translations and no
                // asyncLoader is pending, we execute the handler
                if (defaultTranslationText) {
                  deferred.resolve(defaultTranslationText);
                } else {
                  deferred.resolve(missingTranslationHandlerTranslation);
                }
              } else {
                if (defaultTranslationText) {
                  deferred.resolve(defaultTranslationText);
                } else {
                  deferred.reject(applyNotFoundIndicators(translationId));
                }
              }
            }
            return deferred.promise;
          };

          var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses) {

            var result,
                table = uses ? $translationTable[uses] : $translationTable,
                Interpolator = defaultInterpolator;

            // if the interpolation id exists use custom interpolator
            if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
              Interpolator = interpolatorHashMap[interpolationId];
            }

            // if the translation id exists, we can just interpolate it
            if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
              var translation = table[translationId];

              // If using link, rerun $translate with linked translationId and return it
              if (translation.substr(0, 2) === '@:') {
                result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses);
              } else {
                result = Interpolator.interpolate(translation, interpolateParams);
              }
            } else {
              var missingTranslationHandlerTranslation;
              // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
              if ($missingTranslationHandlerFactory && !pendingLoader) {
                missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
              }

              // since we couldn't translate the inital requested translation id,
              // we try it now with one or more fallback languages, if fallback language(s) is
              // configured.
              if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                fallbackIndex = 0;
                result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator);
              } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                // looks like the requested translation id doesn't exists.
                // Now, if there is a registered handler for missing translations and no
                // asyncLoader is pending, we execute the handler
                result = missingTranslationHandlerTranslation;
              } else {
                result = applyNotFoundIndicators(translationId);
              }
            }

            return result;
          };

          var clearNextLangAndPromise = function (key) {
            if ($nextLang === key) {
              $nextLang = undefined;
            }
            langPromises[key] = undefined;
          };

          var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses) {
            var fn = postProcessFn;

            if (fn) {

              if (typeof fn === 'string') {
                // getting on-demand instance
                fn = $injector.get(fn);
              }
              if (fn) {
                return fn(translationId, translation, resolvedTranslation, interpolateParams, uses);
              }
            }

            return resolvedTranslation;
          };

          var loadTranslationsIfMissing = function (key) {
            if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
              langPromises[key] = loadAsync(key).then(function (translation) {
                translations(translation.key, translation.table);
              });
            }
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#preferredLanguage
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the language key for the preferred language.
           *
           * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
           *
           * @return {string} preferred language key
           */
          $translate.preferredLanguage = function (langKey) {
            if (langKey) {
              setupPreferredLanguage(langKey);
            }
            return $preferredLanguage;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#cloakClassName
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the configured class name for `translate-cloak` directive.
           *
           * @return {string} cloakClassName
           */
          $translate.cloakClassName = function () {
            return $cloakClassName;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#nestedObjectDelimeter
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the configured delimiter for nested namespaces.
           *
           * @return {string} nestedObjectDelimeter
           */
          $translate.nestedObjectDelimeter = function () {
            return $nestedObjectDelimeter;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#fallbackLanguage
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the language key for the fallback languages or sets a new fallback stack.
           *
           * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
           *
           * @return {string||array} fallback language key
           */
          $translate.fallbackLanguage = function (langKey) {
            if (langKey !== undefined && langKey !== null) {
              fallbackStack(langKey);

              // as we might have an async loader initiated and a new translation language might have been defined
              // we need to add the promise to the stack also. So - iterate.
              if ($loaderFactory) {
                if ($fallbackLanguage && $fallbackLanguage.length) {
                  for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                    if (!langPromises[$fallbackLanguage[i]]) {
                      langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                    }
                  }
                }
              }
              $translate.use($translate.use());
            }
            if ($fallbackWasString) {
              return $fallbackLanguage[0];
            } else {
              return $fallbackLanguage;
            }
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#useFallbackLanguage
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Sets the first key of the fallback language stack to be used for translation.
           * Therefore all languages in the fallback array BEFORE this key will be skipped!
           *
           * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
           * get back to the whole stack
           */
          $translate.useFallbackLanguage = function (langKey) {
            if (langKey !== undefined && langKey !== null) {
              if (!langKey) {
                startFallbackIteration = 0;
              } else {
                var langKeyPosition = indexOf($fallbackLanguage, langKey);
                if (langKeyPosition > -1) {
                  startFallbackIteration = langKeyPosition;
                }
              }
            }
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#proposedLanguage
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the language key of language that is currently loaded asynchronously.
           *
           * @return {string} language key
           */
          $translate.proposedLanguage = function () {
            return $nextLang;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#storage
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns registered storage.
           *
           * @return {object} Storage
           */
          $translate.storage = function () {
            return Storage;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#negotiateLocale
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns a language key based on available languages and language aliases. If a
           * language key cannot be resolved, returns undefined.
           *
           * If no or a falsy key is given, returns undefined.
           *
           * @param {string} [key] Language key
           * @return {string|undefined} Language key or undefined if no language key is found.
           */
          $translate.negotiateLocale = negotiateLocale;

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#use
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Tells angular-translate which language to use by given language key. This method is
           * used to change language at runtime. It also takes care of storing the language
           * key in a configured store to let your app remember the choosed language.
           *
           * When trying to 'use' a language which isn't available it tries to load it
           * asynchronously with registered loaders.
           *
           * Returns promise object with loaded language file data or string of the currently used language.
           *
           * If no or a falsy key is given it returns the currently used language key.
           * The returned string will be ```undefined``` if setting up $translate hasn't finished.
           * @example
           * $translate.use("en_US").then(function(data){
           *   $scope.text = $translate("HELLO");
           * });
           *
           * @param {string} [key] Language key
           * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
           */
          $translate.use = function (key) {
            if (!key) {
              return $uses;
            }

            var deferred = $q.defer();

            $rootScope.$emit('$translateChangeStart', { language: key });

            // Try to get the aliased language key
            var aliasedKey = negotiateLocale(key);
            // Ensure only registered language keys will be loaded
            if ($availableLanguageKeys.length > 0 && !aliasedKey) {
              return $q.reject(key);
            }

            if (aliasedKey) {
              key = aliasedKey;
            }

            // if there isn't a translation table for the language we've requested,
            // we load it asynchronously
            $nextLang = key;
            if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
              langPromises[key] = loadAsync(key).then(function (translation) {
                translations(translation.key, translation.table);
                deferred.resolve(translation.key);
                if ($nextLang === key) {
                  useLanguage(translation.key);
                }
                return translation;
              }, function (key) {
                $rootScope.$emit('$translateChangeError', { language: key });
                deferred.reject(key);
                $rootScope.$emit('$translateChangeEnd', { language: key });
                return $q.reject(key);
              });
              langPromises[key]['finally'](function () {
                clearNextLangAndPromise(key);
              });
            } else if (langPromises[key]) {
              // we are already loading this asynchronously
              // resolve our new deferred when the old langPromise is resolved
              langPromises[key].then(function (translation) {
                if ($nextLang === translation.key) {
                  useLanguage(translation.key);
                }
                deferred.resolve(translation.key);
                return translation;
              }, function (key) {
                // find first available fallback language if that request has failed
                if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0) {
                  return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
                } else {
                  return deferred.reject(key);
                }
              });
            } else {
              deferred.resolve(key);
              useLanguage(key);
            }

            return deferred.promise;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#resolveClientLocale
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
           *
           * @returns {string} the current client/browser language key
           */
          $translate.resolveClientLocale = function () {
            return getLocale();
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#storageKey
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the key for the storage.
           *
           * @return {string} storage key
           */
          $translate.storageKey = function () {
            return storageKey();
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#isPostCompilingEnabled
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns whether post compiling is enabled or not
           *
           * @return {bool} storage key
           */
          $translate.isPostCompilingEnabled = function () {
            return $postCompilingEnabled;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns whether force async reload is enabled or not
           *
           * @return {boolean} forceAsyncReload value
           */
          $translate.isForceAsyncReloadEnabled = function () {
            return $forceAsyncReloadEnabled;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#refresh
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
           * the module will drop all existent translation tables and load new version of those which
           * are currently in use.
           *
           * Refresh means that the module will drop target translation table and try to load it again.
           *
           * In case there are no loaders registered the refresh() method will throw an Error.
           *
           * If the module is able to refresh translation tables refresh() method will broadcast
           * $translateRefreshStart and $translateRefreshEnd events.
           *
           * @example
           * // this will drop all currently existent translation tables and reload those which are
           * // currently in use
           * $translate.refresh();
           * // this will refresh a translation table for the en_US language
           * $translate.refresh('en_US');
           *
           * @param {string} langKey A language key of the table, which has to be refreshed
           *
           * @return {promise} Promise, which will be resolved in case a translation tables refreshing
           * process is finished successfully, and reject if not.
           */
          $translate.refresh = function (langKey) {
            if (!$loaderFactory) {
              throw new Error('Couldn\'t refresh translation table, no loader registered!');
            }

            var deferred = $q.defer();

            function resolve() {
              deferred.resolve();
              $rootScope.$emit('$translateRefreshEnd', { language: langKey });
            }

            function reject() {
              deferred.reject();
              $rootScope.$emit('$translateRefreshEnd', { language: langKey });
            }

            $rootScope.$emit('$translateRefreshStart', { language: langKey });

            if (!langKey) {
              // if there's no language key specified we refresh ALL THE THINGS!
              var tables = [],
                  loadingKeys = {};

              // reload registered fallback languages
              if ($fallbackLanguage && $fallbackLanguage.length) {
                for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                  tables.push(loadAsync($fallbackLanguage[i]));
                  loadingKeys[$fallbackLanguage[i]] = true;
                }
              }

              // reload currently used language
              if ($uses && !loadingKeys[$uses]) {
                tables.push(loadAsync($uses));
              }

              var allTranslationsLoaded = function (tableData) {
                $translationTable = {};
                angular.forEach(tableData, function (data) {
                  translations(data.key, data.table);
                });
                if ($uses) {
                  useLanguage($uses);
                }
                resolve();
              };
              allTranslationsLoaded.displayName = 'refreshPostProcessor';

              $q.all(tables).then(allTranslationsLoaded, reject);
            } else if ($translationTable[langKey]) {

              var oneTranslationsLoaded = function (data) {
                translations(data.key, data.table);
                if (langKey === $uses) {
                  useLanguage($uses);
                }
                resolve();
              };
              oneTranslationsLoaded.displayName = 'refreshPostProcessor';

              loadAsync(langKey).then(oneTranslationsLoaded, reject);
            } else {
              reject();
            }
            return deferred.promise;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#instant
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns a translation instantly from the internal state of loaded translation. All rules
           * regarding the current language, the preferred language of even fallback languages will be
           * used except any promise handling. If a language was not found, an asynchronous loading
           * will be invoked in the background.
           *
           * @param {string|array} translationId A token which represents a translation id
           *                                     This can be optionally an array of translation ids which
           *                                     results that the function's promise returns an object where
           *                                     each key is the translation id and the value the translation.
           * @param {object} interpolateParams Params
           * @param {string} interpolationId The id of the interpolation to use
           * @param {string} forceLanguage A language to be used instead of the current language
           *
           * @return {string|object} translation
           */
          $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage) {

            // we don't want to re-negotiate $uses
            var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
            negotiateLocale(forceLanguage) || forceLanguage : $uses;

            // Detect undefined and null values to shorten the execution and prevent exceptions
            if (translationId === null || angular.isUndefined(translationId)) {
              return translationId;
            }

            // Check forceLanguage is present
            if (forceLanguage) {
              loadTranslationsIfMissing(forceLanguage);
            }

            // Duck detection: If the first argument is an array, a bunch of translations was requested.
            // The result is an object.
            if (angular.isArray(translationId)) {
              var results = {};
              for (var i = 0, c = translationId.length; i < c; i++) {
                results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage);
              }
              return results;
            }

            // We discarded unacceptable values. So we just need to verify if translationId is empty String
            if (angular.isString(translationId) && translationId.length < 1) {
              return translationId;
            }

            // trim off any whitespace
            if (translationId) {
              translationId = trim.apply(translationId);
            }

            var result,
                possibleLangKeys = [];
            if ($preferredLanguage) {
              possibleLangKeys.push($preferredLanguage);
            }
            if (uses) {
              possibleLangKeys.push(uses);
            }
            if ($fallbackLanguage && $fallbackLanguage.length) {
              possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
            }
            for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
              var possibleLangKey = possibleLangKeys[j];
              if ($translationTable[possibleLangKey]) {
                if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
                  result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses);
                }
              }
              if (typeof result !== 'undefined') {
                break;
              }
            }

            if (!result && result !== '') {
              if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
                result = applyNotFoundIndicators(translationId);
              } else {
                // Return translation of default interpolator if not found anything.
                result = defaultInterpolator.interpolate(translationId, interpolateParams);
                if ($missingTranslationHandlerFactory && !pendingLoader) {
                  result = translateByHandler(translationId, interpolateParams);
                }
              }
            }

            return result;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#versionInfo
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the current version information for the angular-translate library
           *
           * @return {string} angular-translate version
           */
          $translate.versionInfo = function () {
            return version;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#loaderCache
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns the defined loaderCache.
           *
           * @return {boolean|string|object} current value of loaderCache
           */
          $translate.loaderCache = function () {
            return loaderCache;
          };

          // internal purpose only
          $translate.directivePriority = function () {
            return directivePriority;
          };

          // internal purpose only
          $translate.statefulFilter = function () {
            return statefulFilter;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#isReady
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns whether the service is "ready" to translate (i.e. loading 1st language).
           *
           * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
           *
           * @return {boolean} current value of ready
           */
          $translate.isReady = function () {
            return $isReady;
          };

          var $onReadyDeferred = $q.defer();
          $onReadyDeferred.promise.then(function () {
            $isReady = true;
          });

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#onReady
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * Returns whether the service is "ready" to translate (i.e. loading 1st language).
           *
           * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
           *
           * @param {Function=} fn Function to invoke when service is ready
           * @return {object} Promise resolved when service is ready
           */
          $translate.onReady = function (fn) {
            var deferred = $q.defer();
            if (angular.isFunction(fn)) {
              deferred.promise.then(fn);
            }
            if ($isReady) {
              deferred.resolve();
            } else {
              $onReadyDeferred.promise.then(deferred.resolve);
            }
            return deferred.promise;
          };

          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
           * @methodOf pascalprecht.translate.$translate
           *
           * @description
           * This function simply returns the registered language keys being defined before in the config phase
           * With this, an application can use the array to provide a language selection dropdown or similar
           * without any additional effort
           *
           * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
           */
          $translate.getAvailableLanguageKeys = function () {
            if ($availableLanguageKeys.length > 0) {
              return $availableLanguageKeys;
            }
            return null;
          };

          // Whenever $translateReady is being fired, this will ensure the state of $isReady
          var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
            $onReadyDeferred.resolve();
            globalOnReadyListener(); // one time only
            globalOnReadyListener = null;
          });
          var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
            $onReadyDeferred.resolve();
            globalOnChangeListener(); // one time only
            globalOnChangeListener = null;
          });

          if ($loaderFactory) {

            // If at least one async loader is defined and there are no
            // (default) translations available we should try to load them.
            if (angular.equals($translationTable, {})) {
              if ($translate.use()) {
                $translate.use($translate.use());
              }
            }

            // Also, if there are any fallback language registered, we start
            // loading them asynchronously as soon as we can.
            if ($fallbackLanguage && $fallbackLanguage.length) {
              var processAsyncResult = function (translation) {
                translations(translation.key, translation.table);
                $rootScope.$emit('$translateChangeEnd', { language: translation.key });
                return translation;
              };
              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                var fallbackLanguageId = $fallbackLanguage[i];
                if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
                  langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
                }
              }
            }
          } else {
            $rootScope.$emit('$translateReady', { language: $translate.use() });
          }

          return $translate;
        }];
      }

      $translate.displayName = 'displayName';

      /**
       * @ngdoc object
       * @name pascalprecht.translate.$translateDefaultInterpolation
       * @requires $interpolate
       *
       * @description
       * Uses angular's `$interpolate` services to interpolate strings against some values.
       *
       * Be aware to configure a proper sanitization strategy.
       *
       * See also:
       * * {@link pascalprecht.translate.$translateSanitization}
       *
       * @return {object} $translateDefaultInterpolation Interpolator service
       */
      angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

      function $translateDefaultInterpolation($interpolate, $translateSanitization) {

        'use strict';

        var $translateInterpolator = {},
            $locale,
            $identifier = 'default';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Sets current locale (this is currently not use in this interpolation).
         *
         * @param {string} locale Language key or locale.
         */
        $translateInterpolator.setLocale = function (locale) {
          $locale = locale;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Returns an identifier for this interpolation service.
         *
         * @returns {string} $identifier
         */
        $translateInterpolator.getInterpolationIdentifier = function () {
          return $identifier;
        };

        /**
         * @deprecated will be removed in 3.0
         * @see {@link pascalprecht.translate.$translateSanitization}
         */
        $translateInterpolator.useSanitizeValueStrategy = function (value) {
          $translateSanitization.useStrategy(value);
          return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Interpolates given string agains given interpolate params using angulars
         * `$interpolate` service.
         *
         * @returns {string} interpolated string.
         */
        $translateInterpolator.interpolate = function (string, interpolationParams) {
          interpolationParams = interpolationParams || {};
          interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params');

          var interpolatedText = $interpolate(string)(interpolationParams);
          interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text');

          return interpolatedText;
        };

        return $translateInterpolator;
      }

      $translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

      angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

      angular.module('pascalprecht.translate')
      /**
       * @ngdoc directive
       * @name pascalprecht.translate.directive:translate
       * @requires $compile
       * @requires $filter
       * @requires $interpolate
       * @restrict AE
       *
       * @description
       * Translates given translation id either through attribute or DOM content.
       * Internally it uses `translate` filter to translate translation id. It possible to
       * pass an optional `translate-values` object literal as string into translation id.
       *
       * @param {string=} translate Translation id which could be either string or interpolated string.
       * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
       * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
       * @param {string=} translate-default will be used unless translation was successful
       * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
       * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
       *
       * @example
         <example module="ngView">
          <file name="index.html">
            <div ng-controller="TranslateCtrl">
      
              <pre translate="TRANSLATION_ID"></pre>
              <pre translate>TRANSLATION_ID</pre>
              <pre translate translate-attr-title="TRANSLATION_ID"></pre>
              <pre translate="{{translationId}}"></pre>
              <pre translate>{{translationId}}</pre>
              <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
              <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
              <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
              <pre translate translate-values="{{values}}">WITH_VALUES</pre>
              <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
      
            </div>
          </file>
          <file name="script.js">
            angular.module('ngView', ['pascalprecht.translate'])
      
            .config(function ($translateProvider) {
      
              $translateProvider.translations('en',{
                'TRANSLATION_ID': 'Hello there!',
                'WITH_VALUES': 'The following value is dynamic: {{value}}'
              }).preferredLanguage('en');
      
            });
      
            angular.module('ngView').controller('TranslateCtrl', function ($scope) {
              $scope.translationId = 'TRANSLATION_ID';
      
              $scope.values = {
                value: 78
              };
            });
          </file>
          <file name="scenario.js">
            it('should translate', function () {
              inject(function ($rootScope, $compile) {
                $rootScope.translationId = 'TRANSLATION_ID';
      
                element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
                $rootScope.$digest();
                expect(element.text()).toBe('Hello there!');
      
                element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
                $rootScope.$digest();
                expect(element.text()).toBe('Hello there!');
      
                element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
                $rootScope.$digest();
                expect(element.text()).toBe('Hello there!');
      
                element = $compile('<p translate>{{translationId}}</p>')($rootScope);
                $rootScope.$digest();
                expect(element.text()).toBe('Hello there!');
      
                element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
                $rootScope.$digest();
                expect(element.attr('title')).toBe('Hello there!');
              });
            });
          </file>
         </example>
       */
      .directive('translate', translateDirective);
      function translateDirective($translate, $q, $interpolate, $compile, $parse, $rootScope) {

        'use strict';

        /**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */

        var trim = function () {
          return this.toString().replace(/^\s+|\s+$/g, '');
        };

        return {
          restrict: 'AE',
          scope: true,
          priority: $translate.directivePriority(),
          compile: function (tElement, tAttr) {

            var translateValuesExist = tAttr.translateValues ? tAttr.translateValues : undefined;

            var translateInterpolation = tAttr.translateInterpolation ? tAttr.translateInterpolation : undefined;

            var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

            var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
                watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

            return function linkFn(scope, iElement, iAttr) {

              scope.interpolateParams = {};
              scope.preText = '';
              scope.postText = '';
              scope.translateNamespace = getTranslateNamespace(scope);
              var translationIds = {};

              var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
                // initial setup
                if (iAttr.translateValues) {
                  angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
                }
                // initially fetch all attributes if existing and fill the params
                if (translateValueExist) {
                  for (var attr in tAttr) {
                    if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                      var attributeName = angular.lowercase(attr.substr(14, 1)) + attr.substr(15);
                      interpolateParams[attributeName] = tAttr[attr];
                    }
                  }
                }
              };

              // Ensures any change of the attribute "translate" containing the id will
              // be re-stored to the scope's "translationId".
              // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
              var observeElementTranslation = function (translationId) {

                // Remove any old watcher
                if (angular.isFunction(observeElementTranslation._unwatchOld)) {
                  observeElementTranslation._unwatchOld();
                  observeElementTranslation._unwatchOld = undefined;
                }

                if (angular.equals(translationId, '') || !angular.isDefined(translationId)) {
                  var iElementText = trim.apply(iElement.text());

                  // Resolve translation id by inner html if required
                  var interpolateMatches = iElementText.match(interpolateRegExp);
                  // Interpolate translation id if required
                  if (angular.isArray(interpolateMatches)) {
                    scope.preText = interpolateMatches[1];
                    scope.postText = interpolateMatches[3];
                    translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
                    var watcherMatches = iElementText.match(watcherRegExp);
                    if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                      observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                        translationIds.translate = newValue;
                        updateTranslations();
                      });
                    }
                  } else {
                    // do not assigne the translation id if it is empty.
                    translationIds.translate = !iElementText ? undefined : iElementText;
                  }
                } else {
                  translationIds.translate = translationId;
                }
                updateTranslations();
              };

              var observeAttributeTranslation = function (translateAttr) {
                iAttr.$observe(translateAttr, function (translationId) {
                  translationIds[translateAttr] = translationId;
                  updateTranslations();
                });
              };

              // initial setup with values
              initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

              var firstAttributeChangedEvent = true;
              iAttr.$observe('translate', function (translationId) {
                if (typeof translationId === 'undefined') {
                  // case of element "<translate>xyz</translate>"
                  observeElementTranslation('');
                } else {
                  // case of regular attribute
                  if (translationId !== '' || !firstAttributeChangedEvent) {
                    translationIds.translate = translationId;
                    updateTranslations();
                  }
                }
                firstAttributeChangedEvent = false;
              });

              for (var translateAttr in iAttr) {
                if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr') {
                  observeAttributeTranslation(translateAttr);
                }
              }

              iAttr.$observe('translateDefault', function (value) {
                scope.defaultText = value;
                updateTranslations();
              });

              if (translateValuesExist) {
                iAttr.$observe('translateValues', function (interpolateParams) {
                  if (interpolateParams) {
                    scope.$parent.$watch(function () {
                      angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                    });
                  }
                });
              }

              if (translateValueExist) {
                var observeValueAttribute = function (attrName) {
                  iAttr.$observe(attrName, function (value) {
                    var attributeName = angular.lowercase(attrName.substr(14, 1)) + attrName.substr(15);
                    scope.interpolateParams[attributeName] = value;
                  });
                };
                for (var attr in iAttr) {
                  if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                    observeValueAttribute(attr);
                  }
                }
              }

              // Master update function
              var updateTranslations = function () {
                for (var key in translationIds) {
                  if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
                    updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
                  }
                }
              };

              // Put translation processing function outside loop
              var updateTranslation = function (translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
                if (translationId) {
                  // if translation id starts with '.' and translateNamespace given, prepend namespace
                  if (translateNamespace && translationId.charAt(0) === '.') {
                    translationId = translateNamespace + translationId;
                  }

                  $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage).then(function (translation) {
                    applyTranslation(translation, scope, true, translateAttr);
                  }, function (translationId) {
                    applyTranslation(translationId, scope, false, translateAttr);
                  });
                } else {
                  // as an empty string cannot be translated, we can solve this using successful=false
                  applyTranslation(translationId, scope, false, translateAttr);
                }
              };

              var applyTranslation = function (value, scope, successful, translateAttr) {
                if (!successful) {
                  if (typeof scope.defaultText !== 'undefined') {
                    value = scope.defaultText;
                  }
                }
                if (translateAttr === 'translate') {
                  // default translate into innerHTML
                  if (successful || !successful && typeof iAttr.translateKeepContent === 'undefined') {
                    iElement.empty().append(scope.preText + value + scope.postText);
                  }
                  var globallyEnabled = $translate.isPostCompilingEnabled();
                  var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
                  var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
                  if (globallyEnabled && !locallyDefined || locallyEnabled) {
                    $compile(iElement.contents())(scope);
                  }
                } else {
                  // translate attribute
                  var attributeName = iAttr.$attr[translateAttr];
                  if (attributeName.substr(0, 5) === 'data-') {
                    // ensure html5 data prefix is stripped
                    attributeName = attributeName.substr(5);
                  }
                  attributeName = attributeName.substr(15);
                  iElement.attr(attributeName, value);
                }
              };

              if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
                scope.$watch('interpolateParams', updateTranslations, true);
              }

              // Replaced watcher on translateLanguage with event listener
              var unbindTranslateLanguage = scope.$on('translateLanguageChanged', updateTranslations);

              // Ensures the text will be refreshed after the current language was changed
              // w/ $translate.use(...)
              var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

              // ensure translation will be looked up at least one
              if (iElement.text().length) {
                if (iAttr.translate) {
                  observeElementTranslation(iAttr.translate);
                } else {
                  observeElementTranslation('');
                }
              } else if (iAttr.translate) {
                // ensure attribute will be not skipped
                observeElementTranslation(iAttr.translate);
              }
              updateTranslations();
              scope.$on('$destroy', function () {
                unbindTranslateLanguage();
                unbind();
              });
            };
          }
        };
      }

      /**
       * Returns the scope's namespace.
       * @private
       * @param scope
       * @returns {string}
       */
      function getTranslateNamespace(scope) {
        'use strict';

        if (scope.translateNamespace) {
          return scope.translateNamespace;
        }
        if (scope.$parent) {
          return getTranslateNamespace(scope.$parent);
        }
      }

      translateDirective.displayName = 'translateDirective';

      angular.module('pascalprecht.translate')
      /**
       * @ngdoc directive
       * @name pascalprecht.translate.directive:translateCloak
       * @requires $rootScope
       * @requires $translate
       * @restrict A
       *
       * $description
       * Adds a `translate-cloak` class name to the given element where this directive
       * is applied initially and removes it, once a loader has finished loading.
       *
       * This directive can be used to prevent initial flickering when loading translation
       * data asynchronously.
       *
       * The class name is defined in
       * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
       *
       * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
       *                                  or hiding the cloak. Basically it relies on the translation
       *                                  resolve.
       */
      .directive('translateCloak', translateCloakDirective);

      function translateCloakDirective($translate, $rootScope) {

        'use strict';

        return {
          compile: function (tElement) {
            var applyCloak = function () {
              tElement.addClass($translate.cloakClassName());
            },
                removeCloak = function () {
              tElement.removeClass($translate.cloakClassName());
            };
            $translate.onReady(function () {
              removeCloak();
            });
            applyCloak();

            return function linkFn(scope, iElement, iAttr) {
              if (iAttr.translateCloak && iAttr.translateCloak.length) {
                // Register a watcher for the defined translation allowing a fine tuned cloak
                iAttr.$observe('translateCloak', function (translationId) {
                  $translate(translationId).then(removeCloak, applyCloak);
                });
                // Register for change events as this is being another indicicator revalidating the cloak)
                $rootScope.$on('$translateChangeSuccess', function () {
                  $translate(iAttr.translateCloak).then(removeCloak, applyCloak);
                });
              }
            };
          }
        };
      }

      translateCloakDirective.displayName = 'translateCloakDirective';

      angular.module('pascalprecht.translate')
      /**
       * @ngdoc directive
       * @name pascalprecht.translate.directive:translateNamespace
       * @restrict A
       *
       * @description
       * Translates given translation id either through attribute or DOM content.
       * Internally it uses `translate` filter to translate translation id. It possible to
       * pass an optional `translate-values` object literal as string into translation id.
       *
       * @param {string=} translate namespace name which could be either string or interpolated string.
       *
       * @example
         <example module="ngView">
          <file name="index.html">
            <div translate-namespace="CONTENT">
      
              <div>
                  <h1 translate>.HEADERS.TITLE</h1>
                  <h1 translate>.HEADERS.WELCOME</h1>
              </div>
      
              <div translate-namespace=".HEADERS">
                  <h1 translate>.TITLE</h1>
                  <h1 translate>.WELCOME</h1>
              </div>
      
            </div>
          </file>
          <file name="script.js">
            angular.module('ngView', ['pascalprecht.translate'])
      
            .config(function ($translateProvider) {
      
              $translateProvider.translations('en',{
                'TRANSLATION_ID': 'Hello there!',
                'CONTENT': {
                  'HEADERS': {
                      TITLE: 'Title'
                  }
                },
                'CONTENT.HEADERS.WELCOME': 'Welcome'
              }).preferredLanguage('en');
      
            });
      
          </file>
         </example>
       */
      .directive('translateNamespace', translateNamespaceDirective);

      function translateNamespaceDirective() {

        'use strict';

        return {
          restrict: 'A',
          scope: true,
          compile: function () {
            return {
              pre: function (scope, iElement, iAttrs) {
                scope.translateNamespace = getTranslateNamespace(scope);

                if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
                  scope.translateNamespace += iAttrs.translateNamespace;
                } else {
                  scope.translateNamespace = iAttrs.translateNamespace;
                }
              }
            };
          }
        };
      }

      /**
       * Returns the scope's namespace.
       * @private
       * @param scope
       * @returns {string}
       */
      function getTranslateNamespace(scope) {
        'use strict';

        if (scope.translateNamespace) {
          return scope.translateNamespace;
        }
        if (scope.$parent) {
          return getTranslateNamespace(scope.$parent);
        }
      }

      translateNamespaceDirective.displayName = 'translateNamespaceDirective';

      angular.module('pascalprecht.translate')
      /**
       * @ngdoc directive
       * @name pascalprecht.translate.directive:translateLanguage
       * @restrict A
       *
       * @description
       * Forces the language to the directives in the underlying scope.
       *
       * @param {string=} translate language that will be negotiated.
       *
       * @example
         <example module="ngView">
          <file name="index.html">
            <div>
      
              <div>
                  <h1 translate>HELLO</h1>
              </div>
      
              <div translate-language="de">
                  <h1 translate>HELLO</h1>
              </div>
      
            </div>
          </file>
          <file name="script.js">
            angular.module('ngView', ['pascalprecht.translate'])
      
            .config(function ($translateProvider) {
      
              $translateProvider
                .translations('en',{
                  'HELLO': 'Hello world!'
                })
                .translations('de',{
                  'HELLO': 'Hallo Welt!'
                })
                .translations(.preferredLanguage('en');
      
            });
      
          </file>
         </example>
       */
      .directive('translateLanguage', translateLanguageDirective);

      function translateLanguageDirective() {

        'use strict';

        return {
          restrict: 'A',
          scope: true,
          compile: function () {
            return function linkFn(scope, iElement, iAttrs) {

              iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
                scope.translateLanguage = newTranslateLanguage;
              });

              scope.$watch('translateLanguage', function () {
                scope.$broadcast('translateLanguageChanged');
              });
            };
          }
        };
      }

      translateLanguageDirective.displayName = 'translateLanguageDirective';

      angular.module('pascalprecht.translate')
      /**
       * @ngdoc filter
       * @name pascalprecht.translate.filter:translate
       * @requires $parse
       * @requires pascalprecht.translate.$translate
       * @function
       *
       * @description
       * Uses `$translate` service to translate contents. Accepts interpolate parameters
       * to pass dynamized values though translation.
       *
       * @param {string} translationId A translation id to be translated.
       * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
       *
       * @returns {string} Translated text.
       *
       * @example
         <example module="ngView">
          <file name="index.html">
            <div ng-controller="TranslateCtrl">
      
              <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
              <pre>{{ translationId | translate }}</pre>
              <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
              <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
      
            </div>
          </file>
          <file name="script.js">
            angular.module('ngView', ['pascalprecht.translate'])
      
            .config(function ($translateProvider) {
      
              $translateProvider.translations('en', {
                'TRANSLATION_ID': 'Hello there!',
                'WITH_VALUES': 'The following value is dynamic: {{value}}'
              });
              $translateProvider.preferredLanguage('en');
      
            });
      
            angular.module('ngView').controller('TranslateCtrl', function ($scope) {
              $scope.translationId = 'TRANSLATION_ID';
      
              $scope.values = {
                value: 78
              };
            });
          </file>
         </example>
       */
      .filter('translate', translateFilterFactory);

      function translateFilterFactory($parse, $translate) {

        'use strict';

        var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
          if (!angular.isObject(interpolateParams)) {
            interpolateParams = $parse(interpolateParams)(this);
          }

          return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
        };

        if ($translate.statefulFilter()) {
          translateFilter.$stateful = true;
        }

        return translateFilter;
      }

      translateFilterFactory.displayName = 'translateFilterFactory';

      angular.module('pascalprecht.translate')

      /**
       * @ngdoc object
       * @name pascalprecht.translate.$translationCache
       * @requires $cacheFactory
       *
       * @description
       * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
       * can load translation tables directly into the cache by consuming the
       * `$translationCache` service directly.
       *
       * @return {object} $cacheFactory object.
       */
      .factory('$translationCache', $translationCache);

      function $translationCache($cacheFactory) {

        'use strict';

        return $cacheFactory('translations');
      }

      $translationCache.displayName = '$translationCache';
      return 'pascalprecht.translate';
    });
  })(this);

  return _retrieveGlobal();
});
$__System.registerDynamic("4", ["2"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("2");
});
$__System.register('5', ['3'], function (_export) {
	'use strict';

	var angular, ajaxModule;
	return {
		setters: [function (_2) {
			angular = _2['default'];
		}],
		execute: function () {
			ajaxModule = angular.module('ajax', []).service('Programmer', ['$http', function ($http) {
				this.area = function (areaId, siteId) {
					return $http({
						method: 'POST',
						url: '{AREA_PROGRAMMER}',
						data: {
							area_id: areaId,
							site_id: siteId
						}
					})['catch'](function (error) {
						throw error;
					});
				};
			}]).config(['$httpProvider', function ($httpProvider) {
				$httpProvider.interceptors.push('HttpRequestTimeoutInterceptor');
			}]).factory('HttpRequestTimeoutInterceptor', ['$q', 'HttpPendingRequestsService', function ($q, HttpPendingRequestsService) {
				return {
					request: function request(config) {
						config = config || {};

						if (config.timeout === undefined && !config.noCancelOnRouteChange) {
							config.timeout = HttpPendingRequestsService.newTimeout();
						}

						return config;
					}
				};
			}]).factory('prefix', ['$document', '$location', '$rootScope', 'LcFn', '_', function ($document, $location, $rootScope, LcFn, _) {

				var protocol = $location.protocol();
				var host = $location.host();
				var port = $location.port() || '';

				var environments = ['wombat', 'beta', 'dev', 'staging', 'stage', 'control', 'qa'];
				//Port 9001 is for testing by selenium driver
				//Port 9002 is for local docker setup
				var devPorts = [3000, 9000, 9001, 9002, 8080];

				if ($location.$$search.env && environments.indexOf($location.$$search.env) > -1) {
					$rootScope.backEndUrl = 'https://' + $location.$$search.env + '.lightcloud.com/';
					$rootScope.envionmentSpoof = true;
				} else if ($location.$$search.fqdn) {
					$rootScope.backEndUrl = 'https://' + $location.$$search.fqdn + '/';
					$rootScope.envionmentSpoof = true;
				} else if (devPorts.indexOf(port) > -1) {
					$rootScope.dev = true;
					$rootScope.backEndUrl = 'https://dev.lightcloud.com/';

					//This is used for docker
					if (port === 9002) {
						$rootScope.backEndUrl = 'http://localhost:8001/';
					}
				} else {
					$rootScope.backEndUrl = protocol + '://' + host + ':' + port + '/';
				}

				var currentEnv = environments.find(function (elem) {
					return $rootScope.backEndUrl.indexOf(elem) !== -1;
				});

				if (currentEnv === 'control' && !$location.$$search.debug) {
					// - Disable console output for production
					//LcFn.prepConsole();
				} else {
						(function () {
							// - Set Favicon for non-production
							var faviconColors = {
								wombat: 'purple',
								dev: 'red',
								stage: 'green',
								qa: 'blue'
							};

							var envColor = faviconColors[currentEnv] ? faviconColors[currentEnv] : 'black';

							// - Remove fallback
							angular.element('#fallback-favicon').remove();

							var icons = _.filter($document.find('link'), function (linkElement) {
								return linkElement.sizes[0];
							});

							_.each(icons, function (icon) {
								return LcFn.replaceFavicon(icon, envColor);
							});
						})();
					}

				var apiUrl = $rootScope.backEndUrl + 'api/v1/';

				return {
					request: function request(config) {
						if (config.url.indexOf('{AREA_PROGRAMMER}') > -1) {
							if (LcFn.programmerURIs[currentEnv]) {
								config.url = LcFn.programmerURIs[currentEnv];
							} else {
								console.error('Cannot find ' + config.url + ' for ' + currentEnv);
							}
							return config;
						} else if (config.url.indexOf('nrel.gov') >= 0 || config.url.indexOf('languages') >= 0 || config.url.indexOf('salesforce') >= 0 || config.url.indexOf('html') >= 0 || config.url.indexOf('favicon') >= 0) {
							return config;
						} else {
							config.url = apiUrl + config.url;
							return config;
						}
					}
				};
			}]).factory('apiKey', ['Local', function (Local) {
				return {
					request: function request(config) {

						//This is api path - not current url
						if (config.url.indexOf('login') > -1 || config.url.indexOf('password-reset') > -1 || config.url.indexOf('password_reset') > -1) {
							//No Custom headers
						} else if (config.url.indexOf('salesforce') > -1) {
								config.headers = {
									'Content-Type': 'application/x-www-form-urlencoded'
								};
							} else if (config.url.indexOf('nrel.gov') > -1) {
								// Needs to be 'simple' request to avoid CORS issues
							} else {
									var username = Local.get('lcUser') ? Local.get('lcUser').username : null;

									config.headers = {
										'Accept': '*/*',
										'Authorization': 'ApiKey ' + username + ':' + Local.get('apiKey'),
										'Content-Type': 'application/json'
									};
									config.xsrfCookieName = 'csrftoken';
									config.xsrfHeaderName = 'X-CSRFToken';

									//
									// Temp - Add Auth Header to req body for Programmer until Ian's service accepts headers
									//
									if (config.url.indexOf('execute-api') > -1) {
										config.data.authorization = config.headers.Authorization;
									}
								}

						return config;
					}
				};
			}]).factory('responses', ['$window', '$location', '$q', '$rootScope', 'moment', 'Local', 'Track', function ($window, $location, $q, $rootScope, moment, Local, Track) {

				var ResponseTimer = function ResponseTimer() {
					this.start = moment().valueOf();
				};

				var timer;

				return {
					request: function request(_request) {
						timer = new ResponseTimer();
						return _request;
					},
					response: function response(_response) {
						if (_response && _response.data && _response.data.error) {
							// - CDEP --Messages.popUp(response.data.error);
						}
						if (_response && _response.status && _response.status === 200) {
							//Global object update on all AJAX?
							//Maybe in the future
						}

						return _response || $q.when(_response);
					},
					responseError: function responseError(rejection) {

						if (rejection.status === 401) {
							// || rejection.status === 0
							if ($location.path() !== '/login') {
								// - CDEP --Messages.popUp('You have been logged out');
								Local.clearAll();
								$location.path('/login');
							}
						} else if (rejection.status === 403) {
							//
							// Don't go home any more 403 should only be returned for no permissions - just show error response
							//
							console.log('Not allowed');
							//$location.path('/home');
						} else if ($location.path() !== '/login') {
								//Ajax error popup here - to replace dev errors                   
								//@TODO REPLACE - CDEP - Messages.popUp(rejection);

								//

								console.log('Ajax Error');
								Track.event('send', 'event', 'Errors', 'AJAX Error', rejection);
							}

						//
						// Detect no internet connection (chrome, firefox and safari all return -1)
						//
						// Ignore cancelled ajax on route change
						//
						if (rejection.status === -1 && rejection.config.url.indexOf('salesforce') === -1 && (rejection.config.timeout && !rejection.config.timeout.isGloballyCancelled)) {

							var message = {
								type: 'error',
								title: 'Error',
								body: 'No Connection to Server'
							};

							$rootScope.$broadcast('notifications:showMessageModal', message);
						}

						return $q.reject(rejection);
					}
				};
			}]).service('HttpPendingRequestsService', ['$q', function ($q) {
				var cancelPromises = [];

				function newTimeout() {
					var cancelPromise = $q.defer();

					cancelPromises.push(cancelPromise);

					return cancelPromise.promise;
				}

				function cancelAll() {
					angular.forEach(cancelPromises, function (cancelPromise) {
						// console.log('Cancelling old promise')
						// console.log(cancelPromise)
						cancelPromise.promise.isGloballyCancelled = true;
						cancelPromise.resolve();
					});
					cancelPromises.length = 0;
				}

				function getOutstanding() {
					return cancelPromises;
				}

				return {
					newTimeout: newTimeout,
					cancelAll: cancelAll,
					getOutstanding: getOutstanding
				};
			}]);

			_export('default', ajaxModule);
		}
	};
});

$__System.register('6', [], function (_export) {
	'use strict';

	function Areas($http, Track, LcCache) {

		this.get = function (siteId) {
			return $http({
				url: 'site/' + siteId + '/areas/'
			}).then(function (result) {
				return result.data.areas.map(areasResponseMapping);
			});
		};

		this.update = function (area) {
			return $http({
				method: 'PUT',
				url: 'area/' + area.id + '/',
				data: {
					id_string: area.id_string,
					description: area.id_string, //Set desc to name...
					site_id: area.site_id
				}
			}).then(function (result) {
				LcCache.updateSessionSiteSectionChild('areas', [areasResponseMapping(result.data)]);

				return areasResponseMapping(result.data);
			});
		};

		this.create = function (area) {
			return $http({
				method: 'POST',
				url: 'area/',
				data: {
					id_string: area.id_string,
					description: area.id_string, //Set desc to name...
					site_id: area.site_id
				}
			}).then(function (result) {
				Track.event('Area: Created', 'Area ' + area.id_string);
				LcCache.updateSessionSiteSectionChild('areas', [areasResponseMapping(result.data)]);

				return areasResponseMapping(result.data);
			});
		};

		this.del = function (area) {
			return $http({
				method: 'DELETE',
				url: 'area/' + area.id + '/'
			}).then(function () {
				LcCache.removeSessionSiteSectionChild('areas', [area]);
				Track.event('Area: Deleted', 'Area ' + area.id);
			});
		};

		this.toggleArea = function (areaId, state) {
			return $http({
				method: 'POST',
				url: 'area/' + areaId + '/command/',
				data: {
					'lightsOn': state
				}
			}).success(function () {
				Track.event('Area: Toggled', 'Area ' + areaId + ' turned to ' + state);
			});
		};

		this.assignNodes = function (areaId, assignGroupIds, allDevices) {
			return $http({
				method: 'POST',
				url: 'area/' + areaId + '/assign/',
				data: { nodes: assignGroupIds }
			}).success(function () {
				//Track.event('Area:  Nodes added', 'Nodes '+zones.map(function(obj){return obj.id;}).join(', ')+' added to Area '+areaId);

				var updatedDevices = _.map(assignGroupIds, function (id) {
					var match = _.find(allDevices, { id: id });
					match.area = areaId;
					return match;
				});

				LcCache.updateSessionSiteSectionChild('devices', updatedDevices);
			});
		};

		this.unassignNodes = function (areaId, assignGroupIds, allDevices) {
			return $http({
				method: 'POST',
				url: 'area/' + areaId + '/unassign/',
				data: { nodes: assignGroupIds }
			}).success(function () {
				//Track.event('Area:  Nodes added', 'Nodes '+zones.map(function(obj){return obj.id;}).join(', ')+' added to Area '+areaId);

				var updatedDevices = _.map(assignGroupIds, function (id) {
					var match = _.find(allDevices, { id: id });
					match.area = null;
					return match;
				});

				LcCache.updateSessionSiteSectionChild('devices', updatedDevices);
			});
		};

		function areasResponseMapping(area) {
			function Area(area) {
				this.id = area.id;
				this.id_string = area.id_string;
				this.description = area.description;
				this.siteId = area.site_id;
				this.state = area.is_on;
				this.uuid = area.uuid;
			}

			return new Area(area);
		}

		function areaRequestMapping(area) {
			return angular.toJson({
				id_string: area.id_string,
				description: area.id_string,
				site_id: area.siteId
			});
		}

		this.createGroupControl = function (group) {
			return $http({
				method: 'POST',
				url: 'group/',
				data: {
					id_string: group.id_string,
					description: group.id_string, //Set desc to name...
					site_id: group.site_id,
					object_type: 'zone'
				}
			}).then(function (result) {
				// Track.event('Area: Created', 'Area '+area.id_string);
				// LcCache.updateSessionSiteSectionChild('areas',[areasResponseMapping(result.data)]);

				return areasResponseMapping(result.data);
			});
		};

		this.getGroupControl = function (siteId) {
			return $http({
				url: 'site/' + siteId + '/groups/'
			}).then(function (result) {
				return result.data.groups.map(areasResponseMapping);
			});
		};

		this.assignGroupControlNodes = function (groupControlId, assignZonesIds, zones) {
			return $http({
				method: 'POST',
				url: 'group/' + groupControlId + '/assign/',
				data: { zones: assignZonesIds }
			});
		};

		this.groupControlOperate = function (group) {
			return $http({
				method: 'POST',
				url: 'group/' + group.id + '/command/',
				data: {
					'lightsOn': group.state,
					'dimLevel': group.dim_level
				}
			});
		};

		this.delGroupControl = function (group) {
			return $http({
				method: 'DELETE',
				url: 'group/' + group.id + '/'
			});
		};
	}

	return {
		setters: [],
		execute: function () {
			Areas.$inject = ['$http', 'Track', 'LcCache'];
			_export('default', Areas);
		}
	};
});

$__System.register('7', ['3', '6'], function (_export) {
    'use strict';

    var angular, areasService, areasModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            areasService = _2['default'];
        }],
        execute: function () {
            areasModule = angular.module('areas', []).service('Areas', areasService);

            _export('default', areasModule);
        }
    };
});

$__System.register('8', [], function (_export) {
	'use strict';

	function Automations($rootScope, $http, Track, LcCache, LcFn, _) {

		this.get = function (siteId) {
			return $http({
				//return $http.get({
				url: 'site/' + siteId + '/behaviors/'
			}).then(function (result) {
				return result.data.behaviors.map(automationTransform);
			});
		};

		this.create = function (behavior) {
			return $http({
				url: 'behaviors/create_behavior/',
				method: 'POST',
				data: behavior,
				transformRequest: $http.defaults.transformResponse.concat([this.automationRequestMapping])
			}).then(function (data, status) {
				if (data.data.error) {
					throw data.data.error.error_msg;
				} else {
					Track.event('Behavior: Created', 'Behavior ' + behavior.id);
					LcCache.updateSessionSiteSectionChild('automations', [data.data.body.behavior].map(automationTransform));
					return data;
				}
			}, function (data, status) {
				return data;
			});
		};

		this.update = function (behavior) {
			return $http({
				url: 'behaviors/update_behavior/',
				method: 'POST',
				data: behavior,
				transformRequest: $http.defaults.transformResponse.concat([this.automationRequestMapping])
			}).then(function (data, status) {
				if (data.data.error) {
					throw data.data.error.error_msg;
				} else {
					Track.event('Behavior: Updated', 'Behavior ' + behavior.id);
					LcCache.updateSessionSiteSectionChild('automations', [data.data.body.behavior].map(automationTransform));
					return data;
				}
			}, function (data, status) {
				return data;
			});
		};

		this['delete'] = function (behavior) {
			return $http({
				url: 'behaviors/delete_behavior/',
				method: 'POST',
				data: {
					'behavior_id': behavior.id
				}
			}).then(function (data, status) {
				LcCache.removeSessionSiteSectionChild('automations', [behavior]);
				Track.event('Behavior: Deleted', 'Behavior ' + behavior.id);
			});
		};

		this.automationRequestMapping = function (automation) {
			function convertCriteria(criteria) {

				criteria = legacyDaylightOutHandler(criteria);

				if (criteria.length) {
					_.each(criteria, function (criteriaObj) {
						//Foot to Lux
						if (criteriaObj.attribute === 'dim_level') {
							criteriaObj.threshold = LcFn.footToLux(criteriaObj.threshold);
						} else if (criteriaObj.attribute === 'closed_loop_dim') {
							criteriaObj.threshold = LcFn.footClosedToLux(criteriaObj.threshold);
						} else {
							//Update shared automation criteria
							criteriaObj.threshold = criteria[0].threshold;
							criteriaObj.attribute = criteria[0].attribute;
							criteriaObj.operator = criteria[0].operator;
							criteriaObj.value = criteria[0].value;
						}
					});
				}
				return criteria;
			}

			var cleanAutomation = angular.copy(automation);

			//Re-map Actions
			cleanAutomation.actions.forEach(function (action, index) {
				var actionMins = action.minutes || 0,
				    actionSeconds = action.seconds || 0;

				action.timeout = actionMins || actionSeconds ? actionMins * 60 + actionSeconds : 0;

				//DOUBLE ACTION OBJECT REMAPPING ONLY
				if (action.dimmable && angular.isDefined(action.dim_level)) {
					//Dim command
					cleanAutomation.actions.push({
						object_type: action.object_type,
						object_action: 'dim_level',
						object_id: action.object_id,
						action_parameter: parseInt(action.dim_level),
						timeout: action.timeout
					});
				}
			});

			function legacyDaylightOutHandler(criteria) {
				if (criteria.length === 2 && criteria[0].attribute === 'dim_level') {
					if (criteria[0].threshold === null || criteria[0].threshold === 0) {
						criteria.splice(0, 1);
					} else if (criteria[1].threshold === null || criteria[1].threshold === 0) {
						criteria.pop();
					}
				}
				return criteria;
			}

			//Clean before send
			var actions = cleanAutomation.actions.map(function (action) {
				return {
					action_parameter: action.action_parameter,
					object_action: action.object_action,
					object_id: action.object_id,
					object_type: action.object_type,
					timeout: action.timeout
				};
			});

			var sendAutomation = _.pickBy({
				actions: actions,
				behavior_id: cleanAutomation.id || null,
				criteria: convertCriteria(cleanAutomation.criteria),
				enabled: true, //Always true for now - Carlos will decode status if schedules present
				name: cleanAutomation.name,
				//
				//
				// @refactor - get rid of this!
				//
				//
				site_id: $rootScope.currentSite.id
			});
			//due to group_id a necessary attribute, _pickBy will ignore it
			sendAutomation.group_id = cleanAutomation.group_id ? cleanAutomation.group_id : '';
			//losing id transformation in this method
			sendAutomation.id = cleanAutomation.behavior_id;

			return angular.toJson(sendAutomation);
		};

		function automationTransform(automation) {

			automation = legacyDaylightInHandler(automation);

			return {
				actions: automation.actions,
				id: automation.behavior_id,
				criteria: automation.criteria,
				enabled: automation.enabled,
				group_id: automation.group_id,
				name: automation.name,
				site_id: automation.site_id,
				uuid: automation.uuid
			};
		}

		function legacyDaylightInHandler(automation) {
			if (automation.criteria && automation.criteria[0].attribute === 'dim_level') {
				if (automation.criteria.length === 1) {
					var secondCriteria = angular.copy(automation.criteria[0]);

					if (automation.criteria[0].operator === '>=') {
						secondCriteria.operator = '<';
						secondCriteria.threshold = LcFn.footToLux(LcFn.defaults.daylightingMax);
						automation.criteria.push(secondCriteria);
					} else {
						secondCriteria.operator = '>=';
						secondCriteria.threshold = 0;
						automation.criteria.splice(0, 0, secondCriteria);
					}
				} else if (automation.criteria.length === 2) {
					//order should be '>=' then '<'
					if (automation.criteria[0].operator === '<') {
						var temp = angular.copy(automation.criteria[0]);
						automation.criteria[0] = angular.copy(automation.criteria[1]);
						automation.criteria[1] = angular.copy(temp);
					}
				}
			}

			return automation;
		}
	}

	return {
		setters: [],
		execute: function () {
			Automations.$inject = ['$rootScope', '$http', 'Track', 'LcCache', 'LcFn', '_'];
			_export('default', Automations);
		}
	};
});

$__System.register('9', ['3', '8'], function (_export) {
    'use strict';

    var angular, automationsService, automationsModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            automationsService = _2['default'];
        }],
        execute: function () {
            automationsModule = angular.module('automations', []).service('Automations', automationsService);

            _export('default', automationsModule);
        }
    };
});

$__System.registerDynamic("a", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = { "AF": "Afghanistan", "AX": "Aland Islands", "AL": "Albania", "DZ": "Algeria", "AS": "American Samoa", "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AQ": "Antarctica", "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia", "BQ": "Bonaire, Saint Eustatius and Saba ", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BV": "Bouvet Island", "BR": "Brazil", "IO": "British Indian Ocean Territory", "VG": "British Virgin Islands", "BN": "Brunei", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambodia", "CM": "Cameroon", "CA": "Canada", "CV": "Cape Verde", "KY": "Cayman Islands", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile", "CN": "China", "CX": "Christmas Island", "CC": "Cocos Islands", "CO": "Colombia", "KM": "Comoros", "CK": "Cook Islands", "CR": "Costa Rica", "HR": "Croatia", "CU": "Cuba", "CW": "Curacao", "CY": "Cyprus", "CZ": "Czech Republic", "CD": "Democratic Republic of the Congo", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic", "TL": "East Timor", "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia", "ET": "Ethiopia", "FK": "Falkland Islands", "FO": "Faroe Islands", "FJ": "Fiji", "FI": "Finland", "FR": "France", "GF": "French Guiana", "PF": "French Polynesia", "TF": "French Southern Territories", "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany", "GH": "Ghana", "GI": "Gibraltar", "GR": "Greece", "GL": "Greenland", "GD": "Grenada", "GP": "Guadeloupe", "GU": "Guam", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea", "GW": "Guinea-Bissau", "GY": "Guyana", "HT": "Haiti", "HM": "Heard Island and McDonald Islands", "HN": "Honduras", "HK": "Hong Kong", "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IR": "Iran", "IQ": "Iraq", "IE": "Ireland", "IM": "Isle of Man", "IL": "Israel", "IT": "Italy", "CI": "Ivory Coast", "JM": "Jamaica", "JP": "Japan", "JE": "Jersey", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "XK": "Kosovo", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Laos", "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macao", "MK": "Macedonia", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MH": "Marshall Islands", "MQ": "Martinique", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "FM": "Micronesia", "MD": "Moldova", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MS": "Montserrat", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NC": "New Caledonia", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NU": "Niue", "NF": "Norfolk Island", "KP": "North Korea", "MP": "Northern Mariana Islands", "NO": "Norway", "OM": "Oman", "XX": "Other", "PK": "Pakistan", "PW": "Palau", "PS": "Palestinian Territory", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines", "PN": "Pitcairn", "PL": "Poland", "PT": "Portugal", "PR": "Puerto Rico", "QA": "Qatar", "CG": "Republic of the Congo", "RE": "Reunion", "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "BL": "Saint Barthelemy", "SH": "Saint Helena", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia", "MF": "Saint Martin", "PM": "Saint Pierre and Miquelon", "VC": "Saint Vincent and the Grenadines", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tome and Principe", "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SX": "Sint Maarten", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa", "GS": "South Georgia and the South Sandwich Islands", "KR": "South Korea", "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan", "SR": "Suriname", "SJ": "Svalbard and Jan Mayen", "SZ": "Swaziland", "SE": "Sweden", "CH": "Switzerland", "SY": "Syria", "TW": "Taiwan", "TJ": "Tajikistan", "TZ": "Tanzania", "TH": "Thailand", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad and Tobago", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TC": "Turks and Caicos Islands", "TV": "Tuvalu", "VI": "U.S. Virgin Islands", "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "US": "United States", "UM": "United States Minor Outlying Islands", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VA": "Vatican", "VE": "Venezuela", "VN": "Vietnam", "WF": "Wallis and Futuna", "EH": "Western Sahara", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe" };
});
$__System.registerDynamic("b", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = { "AL": "Alabama", "AK": "Alaska", "AS": "American Samoa", "AZ": "Arizona", "AR": "Arkansas", "CA": "California", "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware", "DC": "District Of Columbia", "FM": "Federated States Of Micronesia", "FL": "Florida", "GA": "Georgia", "GU": "Guam", "HI": "Hawaii", "ID": "Idaho", "IL": "Illinois", "IN": "Indiana", "IA": "Iowa", "KS": "Kansas", "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MH": "Marshall Islands", "MD": "Maryland", "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi", "MO": "Missouri", "MT": "Montana", "NE": "Nebraska", "NV": "Nevada", "NH": "New Hampshire", "NJ": "New Jersey", "NM": "New Mexico", "NY": "New York", "NC": "North Carolina", "ND": "North Dakota", "MP": "Northern Mariana Islands", "OH": "Ohio", "OK": "Oklahoma", "OR": "Oregon", "PW": "Palau", "PA": "Pennsylvania", "PR": "Puerto Rico", "RI": "Rhode Island", "SC": "South Carolina", "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah", "VT": "Vermont", "VI": "Virgin Islands", "VA": "Virginia", "WA": "Washington", "WV": "West Virginia", "WI": "Wisconsin", "WY": "Wyoming" };
});
$__System.register('c', ['a', 'b'], function (_export) {
    'use strict';

    var countryCodes, usStateCodes;
    return {
        setters: [function (_a) {
            countryCodes = _a['default'];
        }, function (_b) {
            usStateCodes = _b['default'];
        }],
        execute: function () {

            angular.module('common-directives', []).directive('stringToNumber', function () {
                return {
                    require: 'ngModel',
                    link: function link(scope, element, attrs, ngModel) {
                        ngModel.$parsers.push(function (value) {
                            return '' + value;
                        });
                        ngModel.$formatters.push(function (value) {
                            return parseFloat(value);
                        });
                    }
                };
            })

            // .directive('title', ['$rootScope', '$timeout', '$state',
            //     function($rootScope, $timeout, $state) {
            //         return {
            //             restrict: 'E',
            //             template: 'Lightcloud - {{title}}',
            //             link: function(scope, element) {

            //                 //Stop {{title}} bug?
            //                 scope.title = scope.title ? scope.title : '';

            //                 var listener = function(event, toState) {
            //                     $timeout(function() {
            //                         scope.title = $state.current.title ? ' - '+$state.current.title : '';
            //                     });
            //                 };

            //                 $rootScope.$on('$stateChangeSuccess', listener);
            //             }
            //         };
            //     }
            // ])

            .directive('googleMap', function () {
                return {
                    template: '<div class="google-map">\n                            <iframe width="100%" height="350" frameborder="0" style="border:0"></iframe>\n                            <div class="placeholder"><span>Loading Map</span></div>\n                          </div>',
                    restrict: 'E',
                    scope: {
                        lat: '=',
                        lng: '='
                    },
                    link: function postLink(scope, element) {

                        scope.$watch('lat', function () {
                            var mapFrame = element.find('iframe');
                            if (scope.lat && scope.lng) {
                                scope.pbcode = '!1m10!1m8!1m3!1d12089.705257668827!2d' + scope.lng.toFixed(8) + '!3d' + scope.lat.toFixed(8) + '!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1457125538035';
                                mapFrame.attr('src', 'https://www.google.com/maps/embed?pb=' + scope.pbcode);
                            }
                        });
                    }
                };
            }).directive('clickToRename', function ($parse) {
                return {
                    template: '<strong ng-if="!renaming">{{value}}</strong><input type="text" ng-if="renaming" ng-blur="reset()" ng-model="value" value="{{value}}" />',
                    restrict: 'A',
                    scope: {
                        value: '<',
                        onUpdate: '&?'
                    },
                    link: function link(scope, elm, attrs) {
                        var delay = 700,
                            clicks = 0,
                            timer = null;

                        var reset = function reset() {
                            clearTimeout(timer);
                            clicks = 0;
                            scope.renaming = false;
                            elm.unbind('keydown.renamefield');
                        };

                        elm.bind('click', function (e) {
                            clicks++; //count clicks

                            if (!scope.renaming) {
                                if (clicks === 1) {
                                    timer = setTimeout(function () {
                                        clicks = 0;
                                    }, delay);
                                } else {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    console.log('Rename!');
                                    scope.renaming = true;
                                }
                            } else {
                                e.preventDefault();
                                e.stopPropagation();

                                elm.bind('keydown.renamefield', function (e) {
                                    if (e.key === 'Enter') {
                                        scope.onUpdate(scope.value);
                                        reset();
                                    } else if (e.key === 'Escape') {
                                        reset();
                                    }
                                });

                                elm.bind('blur', function (e) {
                                    console.log('blur');
                                    reset();
                                });
                            }
                        });
                    }
                };
            }).directive('lcMaxInput', function ($parse) {
                return {
                    restrict: 'A',
                    scope: {
                        lcMaxInputLength: '='
                    },
                    link: function link(scope, elm, attrs) {
                        elm.bind('keypress', function (e) {
                            if (elm[0].value.length >= scope.lcMaxInputLength) {
                                e.preventDefault();
                                return false;
                            }
                        });
                    }
                };
            })

            //ng-options="country.code as country.name for country in countries track by country.name"
            .directive('lcSelect', function ($parse) {
                return {
                    restrict: 'E',
                    template: function template(tElement, tAttrs) {
                        //nq-required="false" having no effect
                        return '<div class="lc-select">\n                        <select class="no-user-styles" ng-change="update()" ng-model="selection" ' + (tAttrs.disabled ? '' : 'ng-required="optionsRequired"') + ' ng-disabled="disabled">\n                            <option value="">-- {{::placeholder}} --</option>\n                            <option ng-repeat="(selectedVal,selectedName) in options track by selectedName | orderBy: \'selectedName\'" value="{{selectedVal}}">{{selectedName}}</option>\n                        </select>\n                    </div>';
                    },
                    scope: {
                        disabled: '<',
                        optionsDefault: '<',
                        optionsList: '<',
                        optionsName: '@',
                        optionsRequired: '<',
                        placeholder: '@',
                        selection: '=',
                        onUpdate: '&'
                    },
                    link: function link(scope, elm, attrs) {
                        //_(countryCodes).toPairs().sortBy(1).fromPairs().value();

                        var options = {
                            state: usStateCodes,
                            country: countryCodes
                        };

                        scope.options = scope.optionsList ? scope.optionsList : options[scope.optionsName];

                        scope.required = scope.disabled ? false : scope.optionsRequired;

                        if (scope.optionsDefault) {
                            scope.selection = scope.optionsDefault;
                        }

                        scope.update = function () {
                            scope.onUpdate({ selection: scope.selection });
                        };
                    }
                };
            }).directive('resize', function ($document) {

                return function ($scope, $element, $attrs) {

                    $element.on('mousedown', function (event) {
                        event.preventDefault();

                        $document.on('mousemove', mousemove);
                        $document.on('mouseup', mouseup);
                    });

                    function mousemove(event) {
                        if ($attrs.resizer == 'vertical') {
                            // Handle vertical resizer
                            var x = event.pageX;

                            if ($attrs.resizerMax && x > $attrs.resizerMax) {
                                x = parseInt($attrs.resizerMax);
                            }

                            $element.css({
                                left: x + 'px'
                            });

                            $($attrs.resizerLeft).css({
                                width: x + 'px'
                            });

                            $($attrs.resizerRight).css({
                                left: x + parseInt($attrs.resizerWidth) + 'px'
                            });
                        } else {
                            // Handle horizontal resizer
                            var y = window.innerHeight - event.pageY;

                            $element.css({
                                bottom: y + 'px'
                            });

                            $($attrs.resizerTop).css({
                                bottom: y + parseInt($attrs.resizerHeight) + 'px'
                            });
                            $($attrs.resizerBottom).css({
                                height: y + 'px'
                            });
                        }
                    }

                    function mouseup() {
                        $document.unbind('mousemove', mousemove);
                        $document.unbind('mouseup', mouseup);
                    }
                };
            })

            // .directive('mainMenu',['$rootScope',function($rootScope){

            //     return {

            //         restrict : 'C',
            //         link : function(scope,element){

            //            scope.$on('domEvent:closeOthers',function(e,originatorEl){

            //              (function() {

            //                 if(originatorEl.parents('.main-menu').length == 1){

            //                 }else if(originatorEl.hasClass('mainMenu') && !$rootScope.showMainMenu){

            //                     $rootScope.showMainMenu = true;
            //                     $rootScope.$apply();

            //                 } else {

            //                     $rootScope.showMainMenu = false;
            //                     $rootScope.$apply();

            //                  }

            //                 })();

            //             });

            //         }

            //     }

            // }])

            .directive('focused', [function () {
                var FOCUS_CLASS = 'focused';
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function link(scope, element, attrs, ctrl) {

                        scope.$watch(attrs.ngModel, function (val) {
                            if (val) {
                                element.parent().children('label').addClass('hidden');
                            } else {
                                element.parent().children('label').removeClass('hidden');
                            }
                        });
                        ctrl.$focused = false;
                        element.bind('focus', function (evt) {
                            element.parent().children('label').addClass(FOCUS_CLASS);
                            scope.$apply(function () {
                                ctrl.$focused = true;
                            });
                        }).bind('blur', function (evt) {
                            element.parent().children('label').removeClass(FOCUS_CLASS);
                            scope.$apply(function () {
                                ctrl.$focused = false;
                            });
                        });
                    }
                };
            }]).directive('match', function () {
                return {
                    require: 'ngModel',
                    restrict: 'A',
                    scope: {
                        match: '='
                    },
                    link: function link(scope, elem, attrs, ctrl) {
                        scope.$watch(function () {
                            return ctrl.$pristine && angular.isUndefined(ctrl.$modelValue) || scope.match === ctrl.$modelValue;
                        }, function (currentValue) {
                            ctrl.$setValidity('match', currentValue);
                        });
                    }
                };
            }).directive('droptip', function () {
                return {
                    restrict: 'A',
                    transclude: true,
                    template: '<span ng-transclude></span>\n                            <label class="tooltip">\n                            <span ng-bind="::tip"></span>\n                            </label>\n                        ',
                    scope: {
                        tip: '@'
                    }

                };
            }).directive('help', function () {
                return {
                    restrict: 'A',
                    link: function link(scope, element, attrs) {

                        var helpTextDiv = angular.element(angular.element('#' + attrs.helpDiv).selector),
                            helpTextParent = helpTextDiv.parent(),
                            iconPosition = angular.element(element).position(),
                            arrow = helpTextDiv.find('.arrow');

                        function setBoxPositions(arrow, helpTextDiv, positions) {
                            arrow.css(positions.arrow);
                            helpTextDiv.css(positions.div);
                        }

                        /**
                         * toggle visibility on the help element
                         * @param {boolean} show - override toggle and show if true, hide if false
                         */
                        function toggleHelp(show) {
                            //if we can't find the element, abort
                            if (!helpTextDiv[0]) return;

                            if (typeof show !== 'boolean') show = !helpTextDiv.is(':visible');

                            if (show) {
                                helpTextDiv.css({
                                    'width': Math.min(helpTextParent.width(), 600)
                                });

                                helpTextDiv.show();

                                // Box needs to be visible before offsetHeight has value
                                var defaultPositions = {
                                    arrow: { 'left': iconPosition.left / 2 },
                                    div: { 'top': 0 - helpTextDiv[0].offsetHeight }
                                };

                                setBoxPositions(arrow, helpTextDiv, defaultPositions);
                            } else {
                                helpTextDiv.hide();
                            }
                        }

                        angular.element(element).on({
                            'mouseenter': function mouseenter() {
                                return toggleHelp(true);
                            },
                            'mouseleave': function mouseleave() {
                                return toggleHelp(false);
                            },
                            'click': toggleHelp
                        });
                    }
                };
            })

            // .directive('swiper', ['Areas','Scenes','$rootScope', function(Areas,Scenes,$rootScope){

            //     return {

            //         restrict : 'A',
            //         replace: false,
            //         transclude: true,
            //         template: '<div class="scenes-selection-reveal-left hidden">\
            //                     <div class="scene-selection-close">X</div>\
            //                         <ul class="scene-list">\
            //                             <li ng-show="!scenes">Loading Scenes...</li>\
            //                             <li class="dropdown-options-item" ng-click="chooseScene(scene);"  ng-bind="scene.name" ng-repeat="scene in scenes"></li>\
            //                         </ul>\
            //                     </div>\
            //                 </div>\
            //                 <div ng-transclude></div>',
            //         scope:{
            //             currentArea : '@',
            //             selectedScene: '@'
            //         },
            //         link : function(scope,element){ //$parent.selectedScene = scene; closeSnapper()

            //             function setupSnapper(id, element){
            //                 scope.cachedArea = id;
            //                 //snapRemote.getSnapper([id]).then(function(snapper) {
            //                 snapper.on('open', function() {
            //                     var $overlay = element.find('.scenes-selection-reveal-left');

            //                     $overlay.removeClass('hidden');  //.css('left', 0);

            //                     $overlay.on('click', function(obj){
            //                         $overlay.addClass('hidden');
            //                         snapper.close();
            //                     })

            //                     Scenes.getForArea(id).success(function(scenes){
            //                         scope.scenes = scenes;
            //                     });
            //                 });
            //                 //});
            //             }

            //             if($rootScope.mobile){ //Directive only useful on mobile- probably a better way to do this
            //                 scope.chooseScene = function(scene){
            //                     scope.selectedScene = scene;

            //                     if(scope.selectedScene.default){
            //                         Areas.toggleArea(scope.selectedScene.actions[0].systemId,scope.selectedScene.actions[0].lightsOn).success(function(){
            //                             //$rootScope.$broadcast('areaToggled',$scope.selectedScene.actions[0].systemId);
            //                         });
            //                     }else{
            //                         Scenes.activate(scope.selectedScene);
            //                     }
            //                 }

            //                 element.on('touchstart mousedown', function() {
            //                     if(!(scope.cachedArea == scope.currentarea)){ //Set up handler only once - could use a closure
            //                         setupSnapper(scope.currentarea, element);
            //                     }
            //                 },{passive:true});

            //             }

            //         }

            //     }

            // }])

            .directive('phoneCode', ['$interval', 'moment', 'Local', 'Users', function ($interval, moment, Local, Users) {
                return {
                    restrict: 'E',
                    template: '<div class="phone-code">                      <div ng-if="user.phoneCode">                      <span>Phone Code: {{user.phoneCode}}</span>                    </div>                    <button type="button" class="btn blue" ng-disabled="user.phoneCodeMessage !== \'Generate Phone Code\' || pending" ng-click="generatePhoneCode(user.id)">{{user.phoneCodeMessage}}</button>',
                    scope: {
                        user: '='
                    },
                    link: function link(scope, element) {

                        var remainingInterval;

                        scope.$watch('user', function (user) {
                            init();
                        });

                        scope.$on('$destroy', function () {
                            $interval.cancel(remainingInterval);
                        });

                        function init() {
                            $interval.cancel(remainingInterval);

                            if (!scope.user) {
                                scope.user = {};
                            }

                            scope.user.phoneCodeMessage = 'Generate Phone Code';
                        }

                        function setTimer(seconds) {
                            remainingInterval = $interval(function () {
                                if (seconds > 0) {
                                    scope.user.phoneCodeMessage = 'Expires ' + moment().utc().to(moment().add(seconds, 'seconds'));
                                } else {
                                    scope.user.phoneCodeMessage = 'Generate Phone Code';
                                    scope.user.phoneCode = null;
                                    $interval.cancel(remainingInterval);
                                }
                            }, 1000);
                        }

                        scope.generatePhoneCode = function (id) {
                            var userId = id || angular.fromJson(Local.get('lcUser')).id; //Context dependent

                            Users.getPhoneCode(userId).success(function (response) {
                                scope.user.phoneCode = response.token;

                                setTimer(response.ttl);
                            });
                        };
                    }
                };
            }]);
        }
    };
});

$__System.registerDynamic('d', [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {
    'use strict';

    angular.module('common-factories', []).factory('focus', function ($timeout, $window) {
      return function (id) {
        // timeout makes sure that it is invoked after any other event has been triggered.
        // e.g. click events that need to run before the focus or
        // inputs elements that are in a disabled state but are enabled when those events
        // are triggered.
        $timeout(function () {
          var element = $window.document.getElementById(id);
          if (element) element.focus();
        });
      };
    });
  })(this);

  return _retrieveGlobal();
});
$__System.registerDynamic('e', [], false, function ($__require, $__exports, $__module) {
    var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

    (function ($__global) {
        'use strict';

        angular.module('common-filters', []).filter('startFrom', function () {
            return function (input, start) {
                start = +start; //parse to int
                return input ? input.slice(start) : [];
            };
        }).filter('pctToTime', function () {
            return function (pct) {
                var totalMinutes = pct * 1440;
                var hours = Math.floor(totalMinutes / 60);
                var minutes = Math.floor(totalMinutes) % 60;
                return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2);
            };
        }).filter('timeToPct', function () {
            return function (time) {
                var hours = parseInt(time.split(':')[0]);
                var minutes = parseInt(time.split(':')[1]);
                var totalMinutes = hours * 60 + minutes;
                return totalMinutes / 1440;
            };
        }).filter('cleanMac', function () {
            return function (mac) {
                return String(mac).replace('[', '').replace(']!', '');
            };
        }).filter('lastFourMac', function () {
            return function (mac) {
                return String(mac).substr(String(mac).length - 5);
            };
        });
    })(this);

    return _retrieveGlobal();
});
$__System.register('f', ['10', '11', '12', '13', '14'], function (_export) {
	var moment, _, _createClass, _classCallCheck, _defineProperty, LcFnService;

	return {
		setters: [function (_6) {
			moment = _6['default'];
		}, function (_5) {
			_ = _5['default'];
		}, function (_2) {
			_createClass = _2['default'];
		}, function (_3) {
			_classCallCheck = _3['default'];
		}, function (_4) {
			_defineProperty = _4['default'];
		}],
		execute: function () {

			//
			// Globalish helper funcs
			//
			'use strict';

			LcFnService = (function () {
				function LcFnService() {
					_classCallCheck(this, LcFnService);

					this.nonAuthStates = ['login', 'password-reset'];
					this.nonSiteCallRoutes = ['agreement', 'login', 'password-reset']; //Don't ask for sites list for these states
					this.notSelectionStates = ['login', 'customer-service', 'customer-service.site', 'global', 'activity']; //These states use the full screen - no left nav
					this.baseUserExclusionList = ['commissioning', 'commissioning.area', 'devices', 'devices.device', 'site-scenes', 'customer-service']; //Deny access to non staff etc

					this.programmerURIs = {
						'dev': 'https://za7lvg1802.execute-api.us-west-2.amazonaws.com/dev/generate_program',
						'staging': 'https://q2h7i2h8r5.execute-api.us-west-2.amazonaws.com/staging/generate_program',
						'qa': 'https://lpalx20lah.execute-api.us-west-2.amazonaws.com/qa/generate_program',
						'control': 'https://07ai0k6boe.execute-api.us-west-2.amazonaws.com/control/generate_program'
					};

					this.defaults = {
						blink: {
							value: 4,
							blink_duration: 1,
							ramp_down_time: 1,
							time_to_off: 0
						},
						closeLoopLcLuxVal: 10.7,
						daylightingMax: 1250,
						heartbeat: {
							gatewayHeartbeatPeriod: 6,
							heartbeat_timeout: 15,
							heartbeat_missed_light_level: 100,
							heartbeat_missed_state: 1
						},
						heartbeatPeriod: 6,
						magicLcLuxVal: 2.6909787627956,
						offToUnoccupied: 10,
						powerReportFrequency: 1440,
						sensor: {
							sensor_sensitivity: 'high',
							motion_timeout: 15,
							occupancy_led_enable: true
						},
						turnOffTimeDelay: 30,
						zoneManualOverrideDefault: 60
					};

					this.defaultSceneFadeTime = 4;

					this.defaultCct = {
						min: 2700,
						max: 6500,
						reported: 3500,
						transition: 360
					};
				}

				_createClass(LcFnService, [{
					key: 'getName',
					value: function getName(item) {
						return item ? item.name || item.id_string || item.description || item.email || (item.settings ? item.settings.id_string : false) : 'Item Missing';
					}
				}, {
					key: 'getDeviceArea',
					value: function getDeviceArea(areaId, deviceId, deviceAreaId, zones) {
						/*
          By default, use the area tied to the device's associated zone, if one exists
          This will render device.area on the device useless apart from Dimmers / Touch etc
          Probably smarter on the BE
       */

						var matchingZone = _.find(zones, ['node', deviceId]);

						return matchingZone && matchingZone.area === areaId || !matchingZone && deviceAreaId === areaId;
					}
				}, {
					key: 'getDeviceUnassigned',
					value: function getDeviceUnassigned(deviceId, deviceAreaId, zones) {
						/*
          By default, use the area tied to the device's associated zone, if one exists
          This will render device.area on the device useless apart from Dimmers / Touch etc
          Probably smarter on the BE
       */
						var matchingZone = _.find(zones, ['node', deviceId]);

						return matchingZone && matchingZone.area === null || !matchingZone && deviceAreaId === null;
					}
				}, {
					key: 'getDomainTld',
					value: function getDomainTld() {
						return window.location.hostname.split('.')[window.location.hostname.split('.').length - 1];
					}
				}, {
					key: 'getTimeOfDay',
					value: function getTimeOfDay() {
						var period = 'evening';
						var hour = moment().hour();

						if (hour > 5 && hour < 12) {
							period = 'morning';
						} else if (hour > 11 && hour < 19) {
							period = 'afternoon';
						}

						return period;
					}
				}, {
					key: 'isOrgAdmin',
					value: function isOrgAdmin(user, org) {
						// - Default no
						var isAdmin = false;

						if (user) {
							// - Sometimes called with null user?
							if (user.is_superuser || user.org_admin) {
								// - Superuser override & old backend user perm
								isAdmin = true;
							} else if (user && user.permissions && org) {
								if (_.find(user.permissions, function (perm) {
									// - Find org admin for this orgId
									return perm.permission === 'org_admin' && perm.object_id === org.id;
								})) {
									isAdmin = true;
								}
							}
						}

						return isAdmin;
					}
				}, {
					key: 'isSmartShiftType',
					value: function isSmartShiftType(sceneOrSchedule) {
						//
						// Hack to derive Scene / Schedule type by name
						// Replace this BE with flag in future
						//
						return this.getName(sceneOrSchedule).toString().indexOf('[SHIFT]') > -1;
					}
				}, {
					key: 'prepConsole',
					value: function prepConsole() {
						//No logging in prod

						window.logHoist = {
							log: console.log,
							info: console.info,
							warn: console.warn
						};

						console.log = function () {};
						console.info = function () {};
						console.warn = function () {};
					}
				}, {
					key: 'cmpVersion',
					value: function cmpVersion(a, b) {
						var i,
						    cmp,
						    len,
						    re = /(\.0)+[^\.]*$/;
						a = (a + '').replace(re, '').split('.');
						b = (b + '').replace(re, '').split('.');
						len = Math.min(a.length, b.length);
						for (i = 0; i < len; i++) {
							cmp = parseInt(a[i], 10) - parseInt(b[i], 10);
							if (cmp !== 0) {
								return cmp;
							}
						}
						return a.length - b.length;
					}
				}, {
					key: 'ltVersion',
					value: function ltVersion(a, b) {
						return this.cmpVersion(a, b) < 0;
					}
				}, {
					key: 'luxToFoot',
					value: function luxToFoot(value) {
						return typeof value === 'undefined' || 0 ? 0 : (value / this.defaults.magicLcLuxVal).toFixed(2);
					}
				}, {
					key: 'footToLux',
					value: function footToLux(value) {
						return typeof value === 'undefined' || 0 ? 0 : (value * this.defaults.magicLcLuxVal).toFixed(2);
					}
				}, {
					key: 'luxClosedToFoot',
					value: function luxClosedToFoot(value) {
						return typeof value === 'undefined' || 0 ? 0 : (value / this.defaults.closeLoopLcLuxVal).toFixed(2);
					}
				}, {
					key: 'footClosedToLux',
					value: function footClosedToLux(value) {
						return typeof value === 'undefined' || 0 ? 0 : (value * this.defaults.closeLoopLcLuxVal).toFixed(2);
					}
				}, {
					key: 'bringToFront',
					value: function bringToFront(array, key, match, markActive) {
						var itemIndex = _.findIndex(array, _defineProperty({}, key, match));

						if (itemIndex > -1) {
							var item = array[itemIndex];
							if (markActive) {
								item.active = true;
							}
							array.splice(itemIndex, 1);
							array.unshift(item);
						}

						return array;
					}
				}, {
					key: 'removeFromLists',
					value: function removeFromLists(ids, lists, optionalItem) {
						// args: Array of Item IDs, Array of Lists, items to add
						_.each(ids, function (itemId) {
							_.each(lists, function (list) {
								var index = _.findIndex(list, { 'id': itemId });
								if (index > -1) {
									list.splice(index, 1);

									//swap for apply
									if (optionalItem) {
										list.push(optionalItem);
									}
								}
							});
						});
					}
				}, {
					key: 'replaceFavicon',
					value: function replaceFavicon(element, color) {
						var faviconSize = element.sizes[0].split('x')[0] || '32';

						var canvas = document.createElement('canvas');
						canvas.width = faviconSize;
						canvas.height = faviconSize;

						var context = canvas.getContext('2d');
						var img = document.createElement('img');
						img.src = element.href;

						img.onload = function () {
							// Draw Original Favicon as Background
							context.drawImage(img, 0, 0, faviconSize, faviconSize);

							// Draw Notification Circle
							context.beginPath();
							context.lineWidth = '3';
							context.strokeStyle = color;
							context.arc(canvas.width / 2, canvas.width / 2, canvas.width / 2.3, 0, 2 * Math.PI);
							context.stroke();

							// Draw Notification Number
							// context.font = '12px "helvetica", sans-serif';
							// context.textAlign = "center";
							// context.textBaseline = "middle";
							// context.fillStyle = '#FFFFFF';
							// context.fillText(2, canvas.width - faviconSize / 2, faviconSize / 2);

							// Replace favicon
							element.href = canvas.toDataURL('image/png');
						};
					}
				}, {
					key: 'mobileCheck',
					value: function mobileCheck() {
						var check = false;
						(function (a, b) {
							if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
						})(navigator.userAgent || navigator.vendor || window.opera);
						return check;
					}
				}]);

				return LcFnService;
			})();

			_export('default', LcFnService);
		}
	};
});

$__System.register("15", ["3", "c", "d", "e", "f"], function (_export) {
	"use strict";

	var angular, commonDirectives, commonFactories, commonFilters, lcFnService, commonModule;
	return {
		setters: [function (_) {
			angular = _["default"];
		}, function (_c) {
			commonDirectives = _c["default"];
		}, function (_d) {
			commonFactories = _d["default"];
		}, function (_e) {
			commonFilters = _e["default"];
		}, function (_f) {
			lcFnService = _f["default"];
		}],
		execute: function () {
			commonModule = angular.module('common', ['common-directives', 'common-factories', 'common-filters']).service('LcFn', lcFnService);

			_export("default", commonModule);
		}
	};
});

$__System.register('16', [], function (_export) {
	'use strict';

	function Devices($http, $q, Device, _) {

		this.get = function (siteId) {
			return $http({
				//return $http.get({
				url: 'site/' + siteId + '/nodes/'
			}).then(function (result) {
				return result.data ? result.data.nodes : [];
			});
		};

		this.getAuditData = function (data) {
			return $http({
				method: 'POST',
				url: 'audit/get_audit_log/',
				data: data
			});
		};

		this.getAuditDataMostRecent = function (uuid, type, count) {
			return $http({
				method: 'POST',
				url: 'audit/get_audit_log_by_most_recent/',
				data: {
					object_uuid: uuid,
					object_type: type,
					max_count: count
				}
			});
		};

		//Admin-devices here for now
		this.indicate = function (deviceId) {
			return $http({
				method: 'POST',
				url: 'node/' + deviceId + '/command/',
				data: {
					'indicate': 3
				}
			});
		};

		this.update = function update(device) {
			/* Accepts proto device and calls .update - for use with undo service */
			return device.update();
		};

		this.updateGroup = function (devices, key, value, zones) {
			var updateDevicesGroup = _.map(devices, function (device) {
				if (device.constructor.name !== 'Device') {
					device = new Device(device, zones);
				}

				//
				// Difference to zones service is the settings obj
				//
				device.settings[key] = value;
				return device.update(zones);
			});

			return $q.all(updateDevicesGroup);
		};

		this.getDefinitions = function () {
			return $http({
				url: 'device_def/get_devices/'
			});
		};

		this.createDefinition = function (device) {
			return $http({
				method: 'POST',
				url: 'device_def/create_device/',
				data: device
			});
		};

		this.updateDefinition = function (device) {
			return $http({
				method: 'POST',
				url: 'device_def/update_device/',
				data: device
			});
		};

		this.deleteDefinition = function (device) {
			return $http({
				method: 'POST',
				url: 'device_def/delete_device/',
				data: device
			});
		};

		this.getAllSchedules = function () {
			return $http({
				url: 'firmware/get_all/'
			});
		};

		this.getSchedule = function (uuid) {
			return $http({
				url: 'firmware/get_entry/',
				data: { 'uuid': uuid }
			});
		};

		this.createSchedule = function (schedule) {
			return $http({
				method: 'POST',
				url: 'firmware/add_entry/',
				data: schedule
			});
		};

		this.updateSchedule = function (schedule) {
			return $http({
				method: 'POST',
				url: 'firmware/update_entry/',
				data: schedule
			});
		};

		this.deleteSchedule = function (schedule) {
			return $http({
				method: 'POST',
				url: 'firmware/delete_entry/',
				data: schedule
			});
		};

		this.getAllowedProperties = function () {
			return $http({
				url: 'node/allowed_node_properties/'
			});
		};

		this.getControlConfigs = function (siteId) {
			return $http({
				url: 'site/' + siteId + '/controls/',
				transformResponse: $http.defaults.transformResponse.concat(function returnFunc(data) {
					return data.controls;
				})
			});
		};

		this.getMultiControlConfigs = function (siteId, deviceId) {
			return $http({
				url: 'site/' + siteId + '/controls/'
			}).then(function (result) {
				//return _.filter(result.data.controls, {node: deviceId}).map(parseMultiConfigs);
				//
				// Are these multi configs unique?
				//
				return _.find(result.data.controls, { node: deviceId });
			});
		};

		this.setControlConfig = function (id, groups) {
			return $http({
				method: 'PUT',
				url: 'control/' + id + '/',
				data: groups
			});
		};

		this.createControlConfig = function (groups) {
			return $http({
				method: 'POST',
				url: 'control/',
				data: groups
			});
		};

		this.dependencies = function (deviceId) {
			return $http({
				url: 'device/' + deviceId + '/dependencies/'
			});
		};

		this.getAllUpdateInfo = function (siteId) {
			return $http({
				url: 'site/' + siteId + '/firmware_status/'
			}).then(function (response) {
				return response.data;
			});
		};

		this.getGlobalUpdateInfo = function () {
			return $http({
				url: 'firmware_version_status/'
			}).then(function (response) {
				return response.data;
			});
		};

		// function parseMultiConfigs(config){
		// 	function getOldObjects(sets){
		// 		let objectSet = [];

		// 		_.each(sets, (set,key) => {
		// 			if(_.isArray(set)){
		// 				//
		// 				_.each(set, val => {
		// 					objectSet.push(mapConfigObj(val,key));
		// 				});
		// 			}
		// 		});

		// 		return objectSet;
		// 	}

		// 	function mapConfigObj(val,key){
		// 		return {
		// 			object_type : key,
		// 			object_id 	: val.id,
		// 			position 	: val.position
		// 		};
		// 	}

		// 	return getOldObjects(config);
		// }
	}

	return {
		setters: [],
		execute: function () {
			Devices.$inject = ['$http', '$q', 'Device', '_'];
			_export('default', Devices);
		}
	};
});

$__System.register('17', [], function (_export) {
	'use strict';

	function deviceFactory($rootScope, $http, Track, Messages, devicesDefinitionsValue, LcCache, _) {

		function Device(deviceProps, gateway) {

			if (!gateway) {
				var self = this;

				self.has_sense = deviceProps.has_sense;
				self.offline_notification_enabled = deviceProps.offline_notification_enabled;
				self.offline_notification_threshold = deviceProps.offline_notification_threshold;
				self.settings = cleanCrappyJson(deviceProps.device_specific_json);

				_.merge(self, {
					area: deviceProps.area,
					id: deviceProps.id,
					uuid: deviceProps.uuid,
					device_type: deviceProps.device_type,
					className: deviceProps.device_type.model.toLowerCase().replace(/ /g, '-'),
					mac_addr: deviceProps.mac_addr.replace('!', ''),
					gateway: deviceProps.gateway,
					fixture_catalog_info: deviceProps.fixture_catalog_info,

					isActuator: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].isActuator : false,
					isControllerType: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].isControllerType : false,
					isDimmable: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].isDimmable : false,
					isLcSense: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].isLcSense : false,
					isSensor: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].isSensor : false,
					monitorsPower: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].monitorsPower : false,
					modes: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].modes : false,

					control: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].control : false,
					controlBtnSets: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].controlBtnSets : false,
					controlLegacy: angular.isDefined(devicesDefinitionsValue.types[deviceProps.device_type.lcp_type]) ? devicesDefinitionsValue.types[deviceProps.device_type.lcp_type].controlLegacy : false,

					// Still used? @todo				
					zone_id: deviceProps.zone_id,

					daylight_value: deviceProps.daylight_value,
					daylight_average_value: deviceProps.daylight_average_value,
					daylight_average_since_last_value: deviceProps.daylight_average_since_last_value,

					node_health: deviceProps.node_health,
					node_state: deviceProps.node_state,

					ajaxPending: false,
					ajaxError: false,
					ajaxResult: '',

					last_firmware_version: deviceProps.last_firmware_version,
					nextFirmwareUuid: false
				});

				self = devicesDefinitionsValue.featureSettings(self);

				_.merge(self.settings, {
					id_string: deviceProps.id_string,
					description: deviceProps.description
				});

				devicesDefinitionsValue.evilConverter(self, self.settings, 'in');
			} else {
				for (var prop in deviceProps) {
					this[prop] = deviceProps[prop];
				}
			}
		}

		function cleanCrappyJson(json) {
			var settings = angular.fromJson(json);

			var clean = _.each(settings, function (v, key, obj) {
				obj[key] = v === 'False' || v === '0' || v === false ? 0 : v === 'True' || v === '1' || v === true ? 1 : v;
			});

			return clean || {};
		}

		Device.prototype.update = function () {
			var self = this;

			var deviceSettings = angular.copy(self.settings);

			delete deviceSettings.id_string;
			delete deviceSettings.description;

			devicesDefinitionsValue.evilConverter(self, deviceSettings, 'out');

			//
			// Node settings outside of 'device-specific'
			//
			var updated_device = {
				description: self.settings.description,
				device_specific_json: angular.toJson(deviceSettings),
				has_sense: self.has_sense,
				id_string: self.settings.id_string,
				mac_addr: self.mac_addr,
				offline_notification_enabled: self.offline_notification_enabled,
				offline_notification_threshold: parseInt(self.offline_notification_threshold),
				uuid: self.uuid
			};

			return ajax(self, 'PUT', 'node/' + self.id + '/', updated_device, null).then(function (device) {
				Track.event('Device: Updated', 'Device ' + self.id);

				LcCache.updateSessionSiteSectionChild('devices', [device]);

				return device;
			});
		};

		Device.prototype.indicate = function () {
			return ajax(this, 'POST', 'node/' + this.id + '/command/', { 'indicate': 3 }, null);
		};

		Device.prototype.checkUpdate = function () {
			return ajax(this, 'POST', 'firmware/device_upgrades/', { 'device_uuid': this.uuid }, 'getUpdateStatus').then(function (self) {
				return self;
			});
		};

		Device.prototype.upgrade = function () {
			var _this = this;

			var container = {};
			container[this.id] = 'PREPARING';
			$rootScope.$broadcast('event:socket:deviceStatus', container);
			return ajax(this, 'POST', 'firmware/apply_upgrade/', { 'device_uuid': this.uuid, 'firmware_uuid': this.nextFirmwareUuid }, 'applyUpdate').then(function (self) {
				Track.event('Device: Updated', 'Device ' + _this.id);
				return self;
			})['catch'](function () {
				container[_this.id] = 'FAILED';
				$rootScope.$broadcast('event:socket:deviceStatus', container);
			});
		};

		// Call API to get firmware upgrade status when navigating to a device
		Device.prototype.getFirmwareUpgradeStatus = function () {
			return ajax(this, 'POST', 'firmware/get_firmware_upgrade_status/', { 'device_uuid': this.uuid }, 'getFirmwareUpgradeStatus');
		};

		Device.prototype['delete'] = function () {
			return ajax(this, 'DELETE', 'node/' + this.id + '/', null, null).then(function (self) {
				Track.event('Device: Deleted', 'Device ' + self.id);
				LcCache.removeSessionSiteSectionChild('devices', [self]);
				return self;
			});
		};

		function ajax(self, method, path, payload, auxFunc) {
			self.ajaxPending = true;
			self.ajaxError = false;

			return $http({
				method: method,
				url: path,
				data: payload
			}).then(function (result) {
				self.ajaxPending = false;
				self.ajaxError = false;
				self.ajaxResult = result;

				//@todo Master Error handling should go here - and be better!
				if (angular.isDefined(result.error)) {
					self.ajaxError = result.error.error_msg;
				} else {
					//@todo Update specific stuff goes here - and should be moved!
					if (auxFunc === 'getUpdateStatus') {
						if (angular.isDefined(result.data.upgrades)) {
							if (result.data.upgrades.length) {
								self.nextFirmwareUuid = result.data.upgrades[0].uuid;
							} else {
								self.nextFirmwareUuid = 0;
							}
						}
					} else if (auxFunc === 'applyUpdate') {
						self.nextFirmwareUuid = 'in progress';
					} else if (auxFunc === 'getFirmwareUpgradeStatus') {

						// Broadcast the update status to the socket if it is not FAILED
						if (angular.isDefined(result.data) && angular.isArray(result.data) && result.data.length > 0) {
							// Get the latest status
							var latestStatus = result.data[result.data.length - 1];
							var container = {};
							// Set the update status to the latest status if not FAILED
							container[self.id] = latestStatus.status === 'FAILED' ? 'FAILED' : latestStatus.step;
							$rootScope.$broadcast('event:socket:deviceStatus', container);
							// If the update status is not FAILED and the step is not COMPLETE then set the next firmware uuid to in progress
							if (latestStatus.status !== 'FAILED' && latestStatus.step !== 'COMPLETE') {
								self.nextFirmwareUuid = 'in progress';
							}
						}
					}
				}

				return self;
			})['catch'](function (error) {
				//Only if FE can't reach BE (e.g loss of network)
				self.ajaxPending = false;
				self.ajaxError = true;
				self.ajaxResult = error;
				Messages.popUp(error.error);

				return self;
			});
		}

		return Device;
	}

	return {
		setters: [],
		execute: function () {
			deviceFactory.$inject = ['$rootScope', '$http', 'Track', 'Messages', 'devicesDefinitionsValue', 'LcCache', '_'];
			_export('default', deviceFactory);
		}
	};
});

$__System.register('18', ['11'], function (_export) {
	'use strict';

	var _, oldControllerModes, defaultDevices, deviceDefinitions;

	function replaceOptions(device, arrayOfOptionPairs) {
		var newDevice = angular.copy(device);

		_.each(arrayOfOptionPairs, function (propSet) {
			newDevice[propSet.propName] = propSet.propVals;
		});

		return newDevice;
	}

	/*
 
 	Per Wizard - All new devices have NO modes! Default to none.
 
  */
	return {
		setters: [function (_2) {
			_ = _2['default'];
		}],
		execute: function () {
			oldControllerModes = [{ name: 'controller' }, { name: 'repeater' }, { name: 'trigger' }, {
				name: 'advance_trigger',
				conditions: {
					'super': true,
					minFirmware: 1.29
				}
			}, {
				name: 'advance_trigger_no_actuator',
				conditions: {
					'super': true,
					minFirmware: 1.29
				}
			}];
			defaultDevices = {
				ceiling: { //Ceiling
					isActuator: true,
					isControllerType: false,
					isDimmable: true,
					isLcSense: false,
					isRGB: false,
					isSensor: true,
					automations: {
						supported: true
					},
					control: false,
					controlLegacy: false,
					daylighting: {
						supported: true,
						disabledModes: ['occupancy', 'vacancy']
					},
					modes: [{ name: 'occupancy' }, { name: 'vacancy' }, { name: 'no_actuator' }]
				},
				mynewtController: {
					isActuator: true,
					isControllerType: true,
					isDimmable: true,
					isLcSense: true,
					isRGB: false,
					isSensor: false,
					automations: {
						supported: true,
						disabledModes: ['controller', 'repeater']
					},
					control: false,
					controlLegacy: false,
					daylighting: {
						supported: true
					},
					modes: []
				},
				originalController: {
					isActuator: true,
					isControllerType: true,
					isDimmable: true,
					isLcSense: false,
					isRGB: false,
					isSensor: false,
					automations: {
						supported: true,
						disabledModes: ['controller', 'repeater']
					},
					control: false,
					controlLegacy: false,
					daylighting: {
						supported: false
					},
					modes: []
				},
				phaseCut: { //Wall Switch V2 (phase cut)
					isActuator: true,
					isControllerType: true,
					isDimmable: true,
					isLcSense: false,
					isRGB: false,
					isSensor: false,
					automations: {
						supported: false // - No automations for now per Mike
					},
					control: true, //
					controlLegacy: false,
					controlBtnSets: [2, 4, 8], // This is user selected now, default to 2 - No keypad interface for now
					daylighting: {
						supported: false
					}
				},
				'switch': { //Wall Switch
					isActuator: false,
					isControllerType: false,
					isDimmable: false,
					isLcSense: false,
					isRGB: false,
					isSensor: false,
					automations: {
						supported: true
					},
					control: true,
					controlLegacy: true,
					controlBtnSets: [2],
					daylighting: {
						supported: false
					},
					modes: [{ name: 'dimmer' }, { name: 'switch' }, { name: 'scene' }]
				}
			};
			deviceDefinitions = {

				types: {
					2: { //Daylight Harvester
						isActuator: false,
						isControllerType: false,
						isDimmable: false,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: true
						},
						control: false,
						controlLegacy: false,
						daylighting: {
							supported: false
						}
					},
					4: replaceOptions(defaultDevices.originalController, [{ propName: 'modes', propVals: oldControllerModes }]), //Controller
					5: defaultDevices['switch'],
					6: { //Touch
						isActuator: false,
						isControllerType: false,
						isDimmable: false,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: false,
							disabledModes: []
						},
						control: true,
						controlLegacy: true,
						controlBtnSets: [],
						daylighting: {
							supported: false
						}
					},
					17: defaultDevices.ceiling,
					18: defaultDevices.ceiling, //Ceiling High Bay
					19: defaultDevices.phaseCut,
					20: defaultDevices.originalController, //Fixture Controller
					21: defaultDevices.originalController, //Twistlock
					22: replaceOptions(defaultDevices.originalController, [{ propName: 'modes', propVals: oldControllerModes }]), //480v
					23: defaultDevices.mynewtController, //Mini
					24: { // 5 Button Keypad
						isActuator: true,
						isControllerType: true,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: true
						},
						control: false, //@todo - Off for now - will be true when ready
						controlLegacy: false,
						controlBtnSets: [5],
						daylighting: {
							supported: false
						}
					},
					25: { //Outlet
						isActuator: true,
						isControllerType: true,
						isDimmable: false,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: false
						},
						control: false,
						controlLegacy: false,
						daylighting: {
							supported: false
						},
						modes: []
					},
					33: defaultDevices.originalController, // Dimmable Lamp
					34: defaultDevices.originalController, //Lamps were behaving like CS for mike /china test - now OG controller
					35: defaultDevices.mynewtController, //LCLC3GEN2	
					37: defaultDevices.mynewtController, //Now Mini ask OG Mike
					48: replaceOptions(defaultDevices['switch'], [//DimmerSense
					{ propName: 'isLcSense', propVals: true }, { propName: 'daylighting', propVals: { supported: true } }, { propName: 'controlLegacy', propVals: false }]),
					//
					// Temp disable alt faceplates for Dimmer Bridge - [{propName: 'controlBtnSets', propVals: [2,3]}] - hide all control interface jason 3/27/25
					//
					50: replaceOptions(defaultDevices.phaseCut, [//Dimmer Bridge - 10/23/25 revert Zahir dimming disable - tbd why
					{ propName: 'control', propVals: false }, { propName: 'isDimmable', propVals: false }, { propName: 'isRGB', propVals: false }, // Off for now
					{ propName: 'monitorsPower', propVals: false }]),
					52: defaultDevices.mynewtController, // Sensor 2.0	
					53: defaultDevices.mynewtController, // High Bay Sensor 2.0			
					54: defaultDevices.mynewtController, //Smart Driver - Ning Feb 25
					55: defaultDevices.mynewtController, //Driver Plus		
					56: replaceOptions(defaultDevices['switch'], [{ propName: 'controlLegacy', propVals: false }]), //Dimmer V2
					57: { // LcShow
						isActuator: false,
						isControllerType: false,
						isDimmable: false,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: false
						},
						control: false,
						controlLegacy: false,
						daylighting: {
							supported: false
						},
						modes: []
					},
					//58 : defaultDevices.mynewtController, // Smart Driver - no more according to Ning
					58: replaceOptions(defaultDevices['switch'], [{ propName: 'controlLegacy', propVals: false }, { propName: 'controlBtnSets', propVals: [5] }]), //Remote
					59: replaceOptions(defaultDevices.mynewtController, [{ propName: 'isLcSense', propVals: false }]), //Controller v2
					60: defaultDevices.mynewtController, // LCLC/AUX (controller with no relay)
					61: defaultDevices.mynewtController, // LCLC/MINI (controller mini)
					62: replaceOptions(defaultDevices.mynewtController, [{ propName: 'isRGB', propVals: true }]), // LCCONTROL/AUX

					99: { //Gateway
						isActuator: false,
						isControllerType: false,
						isDimmable: false,
						isLcSense: false,
						isRGB: false,
						isSensor: false,
						automations: {
							supported: false,
							disabledModes: []
						},
						control: false,
						controlLegacy: false,
						daylighting: {
							supported: false
						}
					}
				},
				conversions: {
					blink_time_pre_unoccupied: {
						out: function out(value, device) {
							if (device.isSensor || device.settings.device_mode === 'advance_trigger') {
								//Hacking for Chilla
								//detect timeout change to adjust pre-unoccupied time lenght
								return device.settings.turn_off_time_delay === 1 ? 51 : 111;
							} else {
								return value;
							}
						}
					},
					motion_timeout: {
						'in': function _in(value) {
							return value / 60;
						},
						out: function out(value) {
							return value * 60;
						}
					},
					pir_sensitivity: {
						'in': function _in(value) {
							return value ? Math.floor(100 - (value - 5500) / 195) : 0;
						},
						out: function out(value) {
							return value ? (100 - value) * 195 + 5500 : 0;
						}
					},
					vacancies_mode_return_time: {
						'in': function _in(value) {
							return value >= 30 ? 30 : value;
						}
					},
					heartbeat_timeout: {
						out: function out(value) {
							// Convert boolean to integer, true is default of 15 and false 0
							if (typeof value === 'boolean') {
								return value ? 15 : 0;
							}
							return !isNaN(value) ? value : 0;
						}
					},
					off_to_unoccupied_timeout: {
						out: function out(value) {
							// Convert boolean to integer, true is default of 10 and false 0
							if (typeof value === 'boolean') {
								return value ? 10 : 0;
							}
							return !isNaN(value) ? value : 0;
						}
					}
				},
				evilConverter: function evilConverter(device, settings, direction) {
					_.each(settings, function (value, key) {
						if (deviceDefinitions.conversions[key] && deviceDefinitions.conversions[key][direction]) {
							settings[key] = deviceDefinitions.conversions[key][direction](settings[key], device);
						}
					});
					return settings;
				},
				featureSettings: function featureSettings(device) {
					var features = ['automations', 'daylighting'];

					_.each(features, function (feature) {
						var support = deviceDefinitions.featureSupport(device, feature);
						var enabled = support,
						    featureSupportKey = feature + '_supported',
						    featureEnabledKey = feature + '_enabled';

						if (support) {
							enabled = deviceDefinitions.featureEnabled(device, feature);
						}

						device[featureSupportKey] = support;
						device[featureEnabledKey] = enabled;
					});

					return device;
				},
				featureSupport: function featureSupport(device, featureName) {
					return device.device_type ? angular.isDefined(deviceDefinitions.types[device.device_type.lcp_type]) ? deviceDefinitions.types[device.device_type.lcp_type][featureName].supported : false : false;
				},
				featureEnabled: function featureEnabled(device, featureName) {
					var enabled = true;

					if (device.device_type) {
						if (deviceDefinitions.types[device.device_type.lcp_type][featureName].disabledModes) {
							if (deviceDefinitions.types[device.device_type.lcp_type][featureName].disabledModes.indexOf(device.settings.device_mode) > -1) {
								enabled = false;
							}
						}
					}

					return enabled;
				}
			};

			_export('default', deviceDefinitions);
		}
	};
});

$__System.register('19', ['3', '16', '17', '18'], function (_export) {
    'use strict';

    var angular, DevicesService, DeviceFactory, devicesDefinitionsValue, devicesModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            DevicesService = _2['default'];
        }, function (_3) {
            DeviceFactory = _3['default'];
        }, function (_4) {
            devicesDefinitionsValue = _4['default'];
        }],
        execute: function () {
            devicesModule = angular.module('devices', []).service('Devices', DevicesService).factory('Device', DeviceFactory).value('devicesDefinitionsValue', devicesDefinitionsValue);

            _export('default', devicesModule);
        }
    };
});

$__System.registerDynamic("1a", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"energy gutters\">\n    <p class=\"loading-spinner-label relative\" ng-if=\"eB.ajaxPending\" translate=\"common.loadingEllipsis\" translate=\"common.loadingEllipsis\">Loading...</p>\n\n    <div class=\"energy\">\n      <!-- <section class=\"main-body\">\n        <h2 class=\"overview-heading\">\n            <span>Energy Reporting is temporarily disabled while we work to improve performance.</span>\n        </h2>\n      </section> -->\n\n      <section class=\"main-body\" ng-if=\"eB.noData\">\n          <h2 class=\"overview-heading\">\n              <span translate=\"energy.noEnergyData\">No recorded energy data for this selection.</span>\n          </h2>\n      </section>\n\n        <div ng-if=\"!eB.ajaxPending && !eB.noData\">\n       \n            <section class=\"main-body quarters\">\n                <section class=\"quarter\">\n                    <h2 class=\"overview-heading\">\n                        <span translate=\"energy.currentDemand\">current demand</span>\n                    </h2>\n                    <h1>{{eB.demand.currentDemand}}</h1><span>W</span>\n                </section>\n\n                <section class=\"quarter\">\n                    <h2 class=\"overview-heading\">\n                        <span translate=\"energy.last7Days\">last 7 days</span>\n                    </h2>\n                    <h1>{{eB.thisWeek}}</h1><span>kWh</span>\n                </section>\n\n                <section class=\"quarter\">\n                    <h2 class=\"overview-heading\">\n                        <span translate=\"energy.last30Days\">last 30 days</span>\n                    </h2>\n                    <h1>{{eB.thisMonth}}</h1><span>kWh</span>\n                </section>\n\n                <section class=\"quarter\">\n                    <h2 class=\"overview-heading\">\n                        <span translate=\"energy.currentYear\">current year</span> \n                    </h2>\n                    <h1>{{eB.thisYear}}</h1><span>kWh</span>\n                </section>\n            </section>\n          \n            <section class=\"main-body\">    \n                <h2 class=\"overview-heading chart-heading\">\n                    <span ng-bind=\"eB.itemCollection.title\"></span><span translate=\"energy.energyUsage\">energy usage</span>\n                </h2>\n\n                <nav class=\"timescale right\">\n                    <div class=\"contrast-buttons\">\n                        <div ng-repeat=\"(key, period) in eB.periods\" ng-class=\"{selected: period.selected}\" ng-click=\"eB.selectPeriod(period)\">{{period.label}}</div> \n                    </div>\n\n                    <div class=\"contrast-buttons custom-range\" ng-if=\"eB.periods.custom.showDropDown\">\n                        <div class=\"range\">\n                            <div class=\"content\">\n                                <input type=\"date\" placeholder=\"yyyy-mm-dd\" ng-model=\"eB.periods.custom.selectedStart\" value=\"\" min=\"{{eB.getDateOnly(eB.periods.custom.floor)}}\" max=\"\">\n                                <span>to</span>\n                                <input type=\"date\" placeholder=\"yyyy-mm-dd\" ng-model=\"eB.periods.custom.selectedEnd\" value=\"\" min=\"{{eB.getDateOnly(eB.periods.custom.selectedStart)}}\" max=\"\">\n                            </div>\n                        </div>\n                    </div>\n                </nav>\n            </section>\n        </div>\n\n        <section class=\"main-body\" ng-if=\"eB.itemCollection.group.length\">\n            <!--\n            <nav class=\"chart-nav\">\n                <nav class=\"tense contrast-buttons\">\n                    <div ng-class=\"{selected: baseline}\" ng-click=\"baseline = !baseline\">Toggle Baseline</div>\n                    <div ng-class=\"{selected: !projection}\" ng-click=\"projection = !projection\">Historic</div>\n                    <div class=\"disabled greyed\" ng-disabled=\"true\" ng-class=\"{active: projection}\">Projection</div>\n                </nav>\n            </nav>\n            -->\n\n            <energy-base-chart chart-data=\"eB.chartData\" chart-height=375 chart-top=30 id=\"DChart\" ng-if=\"eB.chartData && !eB.noData\"></energy-base-chart>\n\n            <h2 class=\"overview-heading\">\n                <span translate=\"energy.energyReport\">Energy Reports</span>\n            </h2>\n            <energy-reports-dropdown period=\"eB.selectedPeriod\" collection=\"eB.itemCollection.group\" site=\"eB.sessionData\"></energy-reports-dropdown>\n\n            <h2 class=\"overview-heading\" ng-if=\"eB.requestsHistory\">\n              <span translate=\"energy.energyReportRequestHistory\">Energy Reports Requests History</span>\n          </h2>\n          <energy-report-request-history period=\"eB.selectedPeriod\" request-history=\"eB.requestsHistory\" format-date=\"eB.formatDate\" ng-if=\"eB.requestsHistory\"></energy-report-request-history>\n          <energy-by-zone gmt-offset=\"eB.sessionData.locality.gmt_offset\" is-super-user=\"eB.isSuperUser\" tz-readable=\"eB.sessionData.locality.friendly_tz_name\" zone-collection=\"eB.itemCollection.group\"></energy-by-zone>\n        </section>\n    </div>\n</div>";
});
$__System.register('1b', ['1a'], function (_export) {
    'use strict';

    var energyBaseTemplate, energyBaseComponent;
    return {
        setters: [function (_a) {
            energyBaseTemplate = _a['default'];
        }],
        execute: function () {
            energyBaseComponent = {
                template: energyBaseTemplate,
                bindings: {
                    energyData: '<',
                    itemCollection: '<',
                    sessionData: '<',
                    user: '<',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'eB',
                controller: function controller($scope, Energy, moment, $q, _) {
                    //
                    // 	Component only instanciated on energyData promise resolve
                    // 	- we have access to energyData here
                    //
                    var eB = this;

                    eB.$onInit = function () {
                        //
                        // TZ stuff
                        //
                        eB.gmtOffset = eB.sessionData.locality.gmt_offset;
                        eB.siteTZcode = eB.sessionData.locality.three_letter_tz_code;
                        eB.tzReadable = eB.sessionData.locality.friendly_tz_name;
                        eB.isSuperUser = eB.user.is_superuser;

                        var timings = {
                            nearestHourUnix: getNewTimezoneRelativeMoment(eB.gmtOffset).startOf('day').unix(),
                            endOfMonthUnix: getNewTimezoneRelativeMoment(eB.gmtOffset).endOf('month').unix()
                        };

                        eB.onSelectionUpdate({ selection: eB.itemCollection });

                        eB.noReport = false;

                        eB.periods = {
                            // custom:  {
                            //     label: 'Custom',
                            //     custom: true,
                            //     selectedStart: null,
                            //     selectedEnd: null,
                            //     showDropDown: false,
                            //     // Maximum depth is one year per DM requirements
                            //     floor: moment.unix(timings.nearestHourUnix).subtract(1, 'years')//.format('ddd MMM Do YYYY')
                            // },
                            last7: {
                                split: 'day',
                                selected: true,
                                label: 'Last 7 Days',
                                start: getNewTimezoneRelativeMoment(eB.gmtOffset).startOf('day').subtract(8, 'days').unix(),
                                end: timings.nearestHourUnix,
                                momentFormat: 'ddd Do'
                            },
                            last30: {
                                split: 'day',
                                selected: false,
                                label: 'Last 30 Days',
                                start: getNewTimezoneRelativeMoment(eB.gmtOffset).startOf('day').subtract(30, 'days').unix(),
                                end: timings.nearestHourUnix,
                                momentFormat: 'D'
                            },
                            currentYear: {
                                label: 'Current Year',
                                split: 'month',
                                selected: false,
                                start: getNewTimezoneRelativeMoment(eB.gmtOffset).startOf('year').unix(),
                                end: timings.endOfMonthUnix,
                                momentFormat: 'MMM'
                            }
                        };

                        //7 day is the default view on first load
                        eB.selectedPeriod = eB.periods['last7'];

                        //Get initial energy
                        if (eB.itemCollection.group.length) {
                            getInitialEnergy(eB.itemCollection.group, eB.siteTZcode);
                        } else {
                            eB.noData = true;
                        }

                        Energy.getRequestHistory().then(function (data) {
                            eB.requestsHistory = data;
                            eB.formatDate = function (date) {
                                return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                            };
                        });
                    };

                    eB.startDateSelected = function (model, date) {
                        $scope.$broadcast('pickerUpdate', 'pickerEndDate', {
                            minDate: moment(date).add(1, 'days')
                        });
                        //maxDate: moment(date).add(2, 'years')
                        customRange();
                    };

                    eB.endDateSelected = function (model, date) {
                        $scope.$broadcast('pickerUpdate', 'pickerStartDate', {
                            maxDate: moment(date).subtract(1, 'days')
                        });
                        //minDate: moment(date).subtract(2,'years')
                        customRange();
                    };

                    eB.selectPeriod = function (selectedPeriod) {
                        eB.periods = _.mapValues(eB.periods, function (period) {
                            period.selected = period === selectedPeriod ? true : false;return period;
                        });

                        //- No custom for now
                        /*
                            if(selectedPeriod.custom){
                                eB.periods.custom.showDropDown = true;
                            } else { 
                                eB.periods.custom.showDropDown = false;
                                getPeriodEnergyBySeconds(eB.itemCollection.group, selectedPeriod).then(result=>{
                                    eB.chartData = result;
                                });
                            }
                        */

                        getPeriodEnergyBySeconds(eB.itemCollection.group, selectedPeriod, eB.siteTZcode).then(function (result) {
                            eB.chartData = result;
                        });
                    };

                    eB.getDateOnly = function (date) {
                        return moment(date).format('YYYY-MM-DD');
                    };

                    function getNewTimezoneRelativeMoment(gmtOffset) {
                        return new moment.utc().zone(gmtOffset);
                    }

                    //@todo - replace below with getBySeconds - cache this and re-use for the nav elements
                    function getInitialEnergy(collection, tzCode) {

                        eB.ajaxPending = true;
                        eB.demand = Energy.getDemand(collection);
                        eB.maxDemand = Energy.getDemand(collection).maxDemand;

                        //
                        // 3 Reqs of the apocolypse - replace this with a summary API
                        //

                        var summaryAndInitialChartAjax = [getPeriodByName('week', collection), getPeriodByName('month', collection), getPeriodByName('year', collection), getPeriodEnergyBySeconds(collection, eB.selectedPeriod, tzCode).then(function (result) {
                            /* Do nothing... for now but maybe use this info later 
                            eB.thisYear = Math.round(_.reduce(data, function(total, item) {
                              return total + item[3];
                            }, 0));
                            */
                            return result;
                        })];

                        $q.all(summaryAndInitialChartAjax).then(function (results) {
                            eB.thisWeek = results[0];
                            eB.thisMonth = results[1];
                            eB.thisYear = results[2];
                            eB.chartData = results[3];

                            eB.ajaxPending = false;

                            //Don't even bother with charts etc if no data present - looks silly
                            eB.noData = _.every(results, function (result) {
                                return result === 0 || result.data && result.data.length === 0;
                            });
                        });
                    }

                    function getPeriodByName(periodName, collection) {
                        return Energy.getByPeriod(periodName, collection).then(function (result) {
                            return result.total_energy.toFixed(2);
                        });
                    }

                    function getPeriodEnergyBySeconds(collection, period, tzCode) {
                        var promises = [Energy.getBySeconds(period.split, period.start, period.end, collection, false, false, tzCode)];

                        //If one of the zones in the collection is missing the real power - ask for synthetic
                        if (_.find(collection, function (zone) {
                            return zone.power_reporting !== '1';
                        })) {
                            promises.push(Energy.getBySeconds(period.split, period.start, period.end, collection, true, false, tzCode));
                        }

                        eB.ajaxPending = true;
                        eB.chartData = null;

                        //Year optional
                        return $q.all(promises).then(function (results) {
                            eB.selectedPeriod = period;

                            // Only show month when we know it
                            if (eB.selectedPeriod.label === 'Last 30 Days') {
                                //eB.thisMonth = calculateMonthUsage(results);
                            }

                            eB.ajaxPending = false;

                            return splitData(results, period);
                        });
                    }

                    function reSortBackend(dataSet) {
                        return _.orderBy(dataSet, function (dataPoint) {
                            return dataPoint[0];
                        });
                    }

                    function splitData(results, period) {
                        var data = [];

                        // - Re-order for BE
                        var realUsage = reSortBackend(results[0].combined),
                            syntheticUsage = results[1] ? reSortBackend(results[1].combined) : null;

                        //
                        // Backend sometimes sends empty array, sometimes sends array full of days but all data empty
                        // Don't bother to format for empty results
                        //
                        if (isUsefulData(realUsage) || isUsefulData(syntheticUsage)) {

                            //period.Split return into months (for current and past year)
                            data = realUsage.map(function (value, k) {
                                var dataPoint = {
                                    periodType: period.split,
                                    period: moment.utc(value[2].split(' to')[0]).format(period.momentFormat),
                                    realUsage: value[3]
                                };

                                if (syntheticUsage) {
                                    // This was 'energy_by_period'
                                    _.extend(dataPoint, { syntheticUsage: (syntheticUsage[k] ? syntheticUsage[k][3] : 0) || 0 });
                                }

                                return dataPoint;
                            });
                        }

                        return {
                            period: period,
                            data: data
                        };
                    }

                    function isUsefulData(data) {
                        return data.length > 0 && !_.every(data, function (item) {
                            return item[3] === 0;
                        });
                    }

                    function customRange() {
                        if (eB.periods.custom.selectedStart && eB.periods.custom.selectedEnd) {

                            var custom = {
                                split: 'day',
                                start: moment(eB.periods.custom.selectedStart).unix(),
                                end: moment(eB.periods.custom.selectedEnd).unix(),
                                momentFormat: 'Do MMM YY' //Change per count?
                            };

                            getPeriodEnergyBySeconds(eB.itemCollection.group, custom, eB.siteTZcode).then(function (result) {
                                eB.chartData = result;
                            });
                        }
                    }
                }
            };

            _export('default', energyBaseComponent);
        }
    };
});

$__System.register('1c', ['11', '1d'], function (_export) {
  'use strict';

  var _, d3, energyBaseChartComponent;

  return {
    setters: [function (_2) {
      _ = _2['default'];
    }, function (_d) {
      d3 = _d['default'];
    }],
    execute: function () {
      energyBaseChartComponent = {
        bindings: {
          chartData: '<',
          chartHeight: '<',
          chartTop: '<'
        },
        controllerAs: 'eBCC',
        controller: function controller($element, $attrs, $window) {
          var eBCC = this;

          eBCC.$onChanges = function (changes) {
            if (changes.chartData.currentValue) {
              drawChart(changes.chartData.currentValue);
            }
          };

          eBCC.$onInit = function () {
            //
            eBCC.windowWatcher = d3.select($window).on('resize.' + $attrs.id, debounceResize);
          };

          eBCC.$onDestroy = function () {
            removeWatch();
          };

          function drawChart(chartData) {
            d3.select($element[0]).selectAll('svg').remove();

            //setting structure for D3 chart
            var width = $element[0].parentElement.clientWidth * 0.95,
                height = width * 0.4,
                margin = {
              top: eBCC.chartTop,
              right: 0, //width * 0.025,
              bottom: 40,
              left: width * 0.025
            };

            //fixed size
            var svg = d3.select($element[0]).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('font-family', 'Brandon Grotesque');

            var chartVars = [{
              legend: 'Real Usage',
              name: 'realUsage',
              color: '#37a72e'
            }];

            if (chartData.data[0] && angular.isDefined(chartData.data[0].syntheticUsage)) {
              console.log('Synthetic Usage');
              chartVars.push({
                legend: 'Self-reported Usage',
                name: 'syntheticUsage',
                color: '#579652'
              });
            }

            var tooltipText = {
              realUsage: 'Device Power Reports',
              syntheticUsage: 'Self-reported (Watts field)'
            };

            var dataset = d3.layout.stack()(chartVars.map(function (energy) {
              return chartData.data.map(function (d) {
                return { x: d.period, y: +d[energy.name], energyType: energy.name };
              });
            }));

            // Set x, y and colors
            var x = d3.scale.ordinal().domain(dataset[0].map(function (d) {
              return d.x || 0;
            })).rangeRoundBands([0, width], 0.01);

            var y = d3.scale.linear().domain([0, d3.max(dataset, function (d) {
              return d3.max(d, function (d) {
                return d.y0 + d.y;
              });
            })]).range([height, 0]);

            // Define and draw axes
            var yAxis = d3.svg.axis().scale(y).orient('left').ticks(5).tickSize(-width, 0, 0).tickFormat(function (d) {
              return d; // + ' kWh';
            });

            var xAxis = d3.svg.axis().scale(x).orient('bottom').ticks(d3.time.months, 2).tickValues(x.domain().filter(function (d, i) {
              return !(i % Math.floor(x.domain().length / 5));
            })).tickFormat(function (item) {
              return isNumeric(item) ? getOrdinalNum(item) : item;
            });

            function isNumeric(n) {
              return !isNaN(parseFloat(n)) && isFinite(n);
            }

            function getOrdinalNum(n) {
              return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : '');
            }

            svg.append('g').attr('class', 'y axis').attr('transform', 'translate(' + margin.left + ',0)').call(yAxis);
            // .selectAll('.tick text')
            // .call(function(t){               
            //   t.each(function(d){ // for each one
            //     var self = d3.select(this);
            //     var s = self.text().split(' ');  // get the text and split it
            //     self.text(''); // clear it out
            //     self.append('tspan') // insert two tspans
            //       .attr('x', 0)
            //       .attr('dy','.8em')
            //       .text(s[0]);
            //     self.append('tspan')
            //       .attr('x', 0)
            //       .attr('dy','.8em')
            //       .text(s[1]);
            //   });
            //  });

            svg.append('g').attr('class', 'x axis').attr('transform', 'translate(' + margin.left + ',' + height + ')').call(xAxis);

            if (chartData.data.length) {
              // Create groups for each series, rects for each segment
              var groups = svg.selectAll('g.energy-usage').data(dataset).enter().append('g').attr('class', 'energy-usage').attr('transform', 'translate(' + margin.left + ',0)').style('fill', function (d, i) {
                return chartVars[i].color;
              });

              var rect = groups.selectAll('rect').data(function (d) {
                return d;
              }).enter().append('rect').attr('class', 'graph-plot').attr('x', function (d) {
                return x(d.x);
              }).attr('y', function (d) {
                return y(d.y0 + d.y);
              }).attr('height', function (d) {
                return y(d.y0) - y(d.y0 + d.y);
              }).attr('width', x.rangeBand()).on('mouseenter', function (d) {
                tooltip.style('display', null);
                tooltip.select('.line-1').text('Usage: ' + d.y.toFixed(2) + ' kWh');
                tooltip.select('.line-2').text('Date: ' + (isNumeric(d.x) ? getOrdinalNum(d.x) : d.x));
                tooltip.select('.line-3').text('Source: ' + tooltipText[d.energyType]);
              }).on('mouseleave', function () {
                tooltip.style('display', 'none');
              }).on('mousemove', function () {
                var offset = 40,
                    legendWidth = 150,
                    legendHeight = 50,
                    mouseX = d3.mouse(this)[0],
                    mouseY = d3.mouse(this)[1];

                var xPosition = mouseX > width - legendWidth ? mouseX - (legendWidth - offset) : mouseX + offset;
                var yPosition = mouseY > height - legendHeight ? mouseY - offset : mouseY;

                tooltip.attr('transform', 'translate(' + xPosition + ',' + yPosition + ')');
              });

              // Prep the tooltip bits, initial display is hidden
              var tooltip = svg.append('g').attr('class', 'tooltip').style('display', 'none').style('pointer-events', 'none');
              // tooltip.append('rect')
              //   .attr('x', 0)
              //   .attr('width', 18)
              //   .attr('height', 18)
              //   .attr()
              //   .style('fill', function(d, i) {
              //     return chartVars[i].color;
              // });

              tooltip.append('text').attr('x', 20).attr('dy', '1.2em').style('text-anchor', 'start').attr('font-size', '12px').attr('font-weight', 'bold').append('svg:tspan').attr('x', 0).attr('dy', 5).attr('class', 'line-1');
              tooltip.select('text').append('svg:tspan').attr('x', 0).attr('dy', 20).attr('class', 'line-2');
              tooltip.select('text').append('svg:tspan').attr('x', 0).attr('dy', 20).attr('class', 'line-3');
            } else {
              //Draw legend
              var legend = svg.selectAll('.legend').data(_.map(chartVars, 'color')).enter().append('g').attr('class', 'legend').attr('transform', function (d, i) {
                return 'translate(-' + (width / 2 + margin.left * 2) + ',' + height / 2 + ')';
              });

              legend.append('rect').attr('x', width - 18).attr('width', 18).attr('height', 18).style('fill', function (d, i) {
                return chartVars[i].color;
              });

              legend.append('text').attr('x', width + 5).attr('y', 9).attr('dy', '.35em').style('text-anchor', 'start').text(function (d, i) {
                return 'No data for this period.'; //chartVars[i].legend;
              });
            }
          }

          var debounceResize = _.debounce(resize, 200);

          function resize() {
            drawChart(eBCC.chartData);
          }

          function removeWatch() {
            d3.select($window).on('resize.' + $attrs.id, null);
          }
        }
      };

      _export('default', energyBaseChartComponent);
    }
  };
});

$__System.register('1e', [], function (_export) {
  'use strict';

  var energyReportsRequestsHistoryComponent;
  return {
    setters: [],
    execute: function () {
      energyReportsRequestsHistoryComponent = {
        template: '\n  <div class="left-nav-group-list-wrapper request-history-table-wrapper">\n    <table id="request-history-table" class="table">\n      <thead>\n      <tr>\n        <th colspan="3">Description</th>\n        <th colspan="3">Date Created</th>\n        <th colspan="2">Type</th>\n        <th colspan="2">Scope</th>\n        <th colspan="1">Units</th>\n        <th colspan="1">Slice By</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat="row in eRRH.requestHistory">\n        <td colspan="3"> <a href="#" data-result={{row}} class="report-download" ng-click="eRRH.download($event)">{{row.description}}</a></td>\n        <td colspan="3">{{eRRH.formatDate(row.created_on)}}</td>\n        <td colspan="2">{{row.parameters.report_type}}</td>\n        <td colspan="2">{{row.parameters.report_scope}}</td>\n        <td colspan="1">{{row.parameters.units}}</td>\n        <td colspan="1">{{row.parameters.slice_by}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>',
        bindings: {
          requestHistory: '<',
          formatDate: '<'
        },
        controllerAs: 'eRRH',
        controller: function controller() {

          var eRRH = this;

          eRRH.$onInit = function () {};

          eRRH.download = function (event) {
            event.preventDefault();
            var data = JSON.parse(angular.element(event.currentTarget).attr('data-result'));
            if (data.results) {
              if (data.results.jobs.length > 0) {
                data.results.jobs.forEach(function (value, idx) {
                  setTimeout(function () {
                    window.open(value.s3_url, '_self');
                  }, idx * 2000);
                });
              }
            }
          };
        }
      };

      _export('default', energyReportsRequestsHistoryComponent);
    }
  };
});

$__System.register('1f', ['20', '21'], function (_export) {
  var _toConsumableArray, _Object$assign, energyReportsDropdownComponent;

  return {
    setters: [function (_2) {
      _toConsumableArray = _2['default'];
    }, function (_3) {
      _Object$assign = _3['default'];
    }],
    execute: function () {
      'use strict';

      energyReportsDropdownComponent = {
        template: '\n    <div class="dropdown" ng-class="{open: eRDC.drop}">\n      <h2 ng-click="eRDC.drop = !eRDC.drop;">\n        <span translate="">Select Report</span>\n      </h2>\n      <ul ng-if="eRDC.drop">\n        <li class="energy-report" ng-repeat="report in eRDC.reports" ng-if="report.visible && report.service == \'asyncReport\' && report.path != \'daily_energy_report\'">\n          <span translate="energy.{{::report.title}}">Generate Report for </span>          <span translate="">from</span>\n          <div class="lc-select-sentence" >\n            <input type="date" ng-change="eRDC.clearDownload(report)" ng-model="report.startDate" max="{{report.maxDate}}" /> to\n            <input type="date" ng-change="eRDC.clearDownload(report)" ng-model="report.endDate" class="no-user-styles" max="{{report.maxDate}}" />\n          </div>\n\n          <div class="inline" ng-if="report.syntheticAvailable">\n            <span translate="">using</span>\n\n            <div class="lc-select-sentence">\n                <select ng-model="report.synthetic" ng-change="eRDC.clearDownload(report)">\n                  <option value="false" ng-selected="!report.synthetic" translate="energy.reportReal">Device Power Data</option>\n                  <option value="true" ng-selected="report.synthetic" translate="energy.reportSynth">Self-Reported Watts Field</option>\n                </select>\n            </div>\n          </div>\n\n          <a class="download right" href="" ng-if="!report.downloadLink" ng-click="eRDC.getReport(eRDC.site.id, eRDC.site.id_string, eRDC.period, eRDC.collection, report)"><span translate="">Generate</span></a>\n\n          <i class="loading-spinner right" ng-show="report.pending"></i>\n\n          <a class="download right" ng-click="report.downloadLink " ng-if="report.downloadLink" href="{{report.downloadLink}}" target="_blank" download="{{report.downloadLinkName}}" translate="">Download</a>\n        </li>\n\n\n        <li class="energy-report" ng-repeat="report in eRDC.reports" ng-if="report.visible && (report.service !== \'asyncReport\' || report.path == \'daily_energy_report\')">\n\n            <span translate="energy.{{::report.title}}">Generate Report for </span>            <span translate="">from</span>\n            <div class="lc-select-sentence" >\n              <select ng-model="report.month" ng-change="eRDC.clearDownload(report)">\n                <option ng-if="report.year == eRDC.thisYear" ng-repeat="(key,month) in eRDC.monthsThisYear" value="{{key}}" ng-selected="report.month == key" translate="" >{{month}}</option>\n                <option ng-if="report.year != eRDC.thisYear" ng-repeat="(key,month) in eRDC.months" value="{{key}}" ng-selected="report.month === key" translate="" >{{month}}</option>\n              </select>\n              <select ng-model="report.year" ng-options="year as year for year in eRDC.years" class="no-user-styles" ng-change="eRDC.clearDownload(report)"></select>\n            </div>\n\n            <div class="inline" ng-if="report.syntheticAvailable">\n              <span translate="">using</span>\n\n              <div class="lc-select-sentence">\n                  <select ng-model="report.synthetic" ng-change="eRDC.clearDownload(report)">\n                    <option value="false" ng-selected="!report.synthetic" translate="energy.reportReal">Device Power Data</option>\n                    <option value="true" ng-selected="report.synthetic" translate="energy.reportSynth">Self-Reported Watts Field</option>\n                  </select>\n              </div>\n            </div>\n\n          <a class="download right" href="" ng-if="!report.downloadLink" ng-click="eRDC.getReport(eRDC.site.id, eRDC.site.id_string, eRDC.period, eRDC.collection, report)"><span translate="">Generate</span></a>\n\n          <i class="loading-spinner right" ng-show="report.pending"></i>\n\n          <a class="download right" ng-click="report.downloadLink " ng-if="report.downloadLink" href="{{report.downloadLink}}" target="_blank" download="{{report.downloadLinkName}}" translate="">Download</a>\n        </li>\n      </ul>\n    </div>',
        bindings: {
          period: '<',
          collection: '<',
          site: '<'
        },
        controllerAs: 'eRDC',
        controller: function controller(Energy, $sce, moment, $timeout, Modals, Messages, _) {

          var eRDC = this;

          eRDC.yearsOfHistory = 5; //About the age of Lightcloud?

          eRDC.thisMonth = moment().utc().month();
          eRDC.thisYear = moment().utc().year();

          eRDC.months = moment.monthsShort();
          eRDC.monthsThisYear = moment.monthsShort().slice(0, eRDC.thisMonth + 1);
          eRDC.years = _.map([].concat(_toConsumableArray(Array(eRDC.yearsOfHistory))), function (v, k) {
            return moment().year(eRDC.thisYear - k).format('YYYY');
          });

          var DefaultReport = function DefaultReport() {
            this.service = 'report';
            this.mime = 'text/csv';
            this.month = eRDC.thisMonth.toString();
            this.year = eRDC.thisYear.toString();
            this.startDate = new Date(moment().startOf('month').unix() * 1000);
            this.endDate = new Date(moment().unix() * 1000);
            this.synthetic = false;
            this.syntheticAvailable = true;
            this.visible = true;
            this.maxDate = moment().format('YYYY-MM-DD');
          };

          eRDC.reports = {
            usage_csv: _.merge(new DefaultReport(), {
              title: 'usageCSVReport',
              service: 'asyncReport',
              path: 'zone_energy_report'
            }),
            month: _.merge(new DefaultReport(), {
              title: 'monthlyUsagePdf',
              service: 'asyncReport',
              path: 'daily_energy_report'
            }),
            fifteen: _.merge(new DefaultReport(), {
              title: 'fifteenMinuteReport',
              path: 'fifteen_minute_energy_report',
              syntheticAvailable: true,
              visible: true, //eRDC.site ? eRDC.site.support_15_min_power : false,
              service: 'asyncReport'
            })
          };

          eRDC.$onInit = function () {
            //
          };

          eRDC.getReport = function (siteId, siteName, period, collection, report) {
            var _this = this;

            var periodMonth = moment().utc().month(report.month).year(report.year),
                startMonth = periodMonth.startOf('month').unix(),
                endMonth = periodMonth.endOf('month').unix(),
                startDate = isDailyAsyncReport(report) ? periodMonth.startOf('month').format('YYYY-MM-DD') : moment(report.startDate).format('YYYY-MM-DD'),
                endDate = isDailyAsyncReport(report) ? null : moment(report.endDate).format('YYYY-MM-DD');

            var ajaxArgs = {
              getBySeconds: [period.split, startMonth, endMonth, collection, report.synthetic, true],
              report: [siteId, report.month, report.year, report.path, report.synthetic],
              asyncReport: [report.path, period.split, startDate, endDate, collection, report.synthetic, siteId, eRDC.site.org.id]
            };

            if (!report.pending) {
              Modals.openLoad('Sending Request');

              if (hasReportBeenUpdated(eRDC.previousReport, report)) {
                Modals.closeLoad('The request has already been sent, please check your email!');
              } else {
                (function () {
                  var alertMessage = '';
                  Energy[report.service].apply(_this, ajaxArgs[report.service]).then(function (response) {
                    if (response['id']) {
                      report.sent = true;
                      var recipient = response['parameters']['recipient'][0];
                      alertMessage = 'Energy Report will be sent to ' + recipient + ' shortly.';
                      Modals.openLoad(alertMessage, true);
                      // only set if request successful
                      eRDC.previousReport = _Object$assign({}, report);
                    }

                    if (report.service !== 'asyncReport') {
                      generateDownload(siteName, response, report);
                    }
                  })['catch'](function (error) {
                    if ('data' in error && typeof error.data.text === 'function') {
                      error.data.text().then(function (message) {
                        alertMessage = 'Something went wrong (' + message + '), please try again.';
                        Messages.errorToast(alertMessage, true);
                      });
                    } else {
                      alertMessage = error.data.text;
                      Messages.errorToast(alertMessage, true);
                    }
                  })['finally'](function () {
                    report.pending = false;

                    $timeout(function () {
                      Modals.closeLoad(alertMessage, true);
                    }, 5000);
                    scope.$apply();
                  });
                })();
              }
            };
          };

          function hasReportBeenUpdated(currentReport, newReport) {
            var hasUpdated = currentReport && currentReport.synthetic === newReport.synthetic && currentReport.path === newReport.path;

            if (currentReport && isDailyAsyncReport(newReport)) {
              hasUpdated = hasUpdated && (currentReport.month === newReport.month && currentReport.year === newReport.year);
            } else {
              hasUpdated = hasUpdated && currentReport.startDate.getTime() === newReport.startDate.getTime() && currentReport.endDate.getTime() === newReport.endDate.getTime();
            }

            return hasUpdated;
          }

          function isDailyAsyncReport(report) {
            if (!report) return false;
            return report.service === 'asyncReport' && report.path === 'daily_energy_report';
          }

          eRDC.clearDownload = function (report) {
            report.downloadLink = false;
          };

          function generateDownload(siteName, response, report) {
            report.downloadLink = $sce.trustAsResourceUrl(URL.createObjectURL(response));
            report.downloadLinkName = prettifyDownloadName(report, siteName, report.month, report.year);
          }

          function prettifyDownloadName(report, siteName, reportMonth, year) {
            var month = parseInt(reportMonth) + 1;

            return (siteName + '-' + report.title + '-' + month + '-' + year + '.' + report.mime.split('/')[1]).replace(/ /g, '-');
          }
        }
      };

      _export('default', energyReportsDropdownComponent);
    }
  };
});

$__System.register('22', ['10', '11', '1d'], function (_export) {
   'use strict';

   var moment, _, d3, zoneEnergyChartComponent;

   return {
      setters: [function (_2) {
         moment = _2['default'];
      }, function (_3) {
         _ = _3['default'];
      }, function (_d) {
         d3 = _d['default'];
      }],
      execute: function () {
         zoneEnergyChartComponent = {
            bindings: {
               gmtOffset: '<',
               stateObject: '<'
            },
            controller: function controller($element, $attrs) {
               var zEC = this;

               function generating(zoneData) {

                  var data = angular.copy(zoneData.chartData);
                  var offset = zEC.gmtOffset || 0;

                  _.each(data, function (obj) {
                     obj.date = moment.unix(obj.date).valueOf();
                  });

                  var minDate = data[0].date,
                      maxDate = data[data.length - 1].date;

                  var debounceSumRange = _.debounce(function (from, to) {
                     sumRange(from, to);
                  }, 300);

                  function sumRange(from, to) {
                     zEC.rangeTotal = 0;
                     _.each(data, function (d) {
                        if (moment(d.date).isBetween(moment(from), moment(to))) {
                           zEC.rangeTotal = zEC.rangeTotal + d.power;
                        }
                     });
                  }

                  debounceSumRange(minDate, maxDate);

                  var margin = {
                     top: 50,
                     right: 50,
                     bottom: 50,
                     left: 50
                  },
                      navigatorMarginTop = 90,
                      navigatorHeight = 60,
                      width = $element[0].parentElement.clientWidth,
                      width = width - margin.left - margin.right,
                      height = 200;

                  var xScale = d3.time.scale().domain([minDate, maxDate]).range([0, width]);

                  // This fake ordianal scale is used only because of its
                  // `rangeBands` method to automatially calculate the width
                  // of columns of column chart
                  // var fakeOrdinalXScale = d3.scale.ordinal()
                  //    .domain(_.map(data, 'date'))
                  //    .rangeBands([0, width], 0, 0);

                  var yScale = d3.scale.linear().domain([0, 100]) //getMaxValue(data, 'dim')
                  .range([height, 0]);

                  var yLineScale = d3.scale.linear().domain([0, zoneData.zone.power_draws_by_decile_as_dictionary[100]]) //getMaxValue(data, 'dim')
                  .range([height, 0]);

                  var xAxis = d3.svg.axis().scale(xScale).orient('bottom').tickSize(-height).tickFormat(function (d) {
                     return moment(d).utcOffset(offset).format('ddd HH:mm');
                  });

                  var yAxisDim = d3.svg.axis().scale(yScale).orient('left').ticks(2).tickSize(-width);

                  var zoom = d3.behavior.zoom().x(xScale);

                  var svg = d3.select($element[0]).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom + navigatorHeight + navigatorMarginTop);

                  svg.append('rect').attr('width', 10).attr('height', 10).attr('x', width - 60).attr('y', 25).attr('class', 'line blue');

                  svg.append('text').attr('x', width - 40).attr('y', 35).text('Zone On');

                  var mainGroup = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                  var area = d3.svg.area().x(function (d) {
                     return xScale(d.date);
                  }).y0(height).y1(function (d) {
                     return yScale(d.dim);
                  });

                  // Clip-path
                  var chartsContainer = mainGroup.append('g').attr('clip-path', 'url(#plotAreaClip)').call(zoom);

                  chartsContainer.append('clipPath').attr('id', 'plotAreaClip').append('rect').attr({
                     width: width,
                     height: height
                  });

                  chartsContainer.append('path').data(data).attr('class', 'area').attr('d', area);

                  // Line chart
                  var lineDim = d3.svg.line().interpolate('step-after').x(function (d) {
                     return xScale(d.date);
                  }).y(function (d) {
                     return yScale(d.dim);
                  });

                  var lineDimGroup = chartsContainer.append('path').attr('class', 'line blue').data(data).attr('d', lineDim(data));

                  // Axis
                  mainGroup.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis).selectAll('text').style('text-anchor', 'end').attr('dx', '-.8em').attr('dy', '.15em').attr('transform', 'rotate(-90)');

                  mainGroup.append('g').attr('class', 'y axis yAxisDim').call(yAxisDim);

                  //draw label for Y
                  mainGroup.append('text').attr('class', 'y label').attr('text-anchor', 'end').attr('x', -60).attr('y', -35).attr('dy', '.75em').attr('transform', 'rotate(-90)').text('Dim Level');

                  //Unused for now - use dim instead
                  // function getPowerRange(){
                  //   return zoneData.zone.power_draws_by_decile_as_dictionary[100] || zoneData.zone.watts || 100;
                  // }

                  // Navigator
                  var navXScale = d3.time.scale().domain([minDate, maxDate]).range([0, width]);

                  var navYScale = d3.scale.linear()
                  //.domain([0, getMaxValue(data, 'dim') || 1])
                  .domain([0, 100]).range([navigatorHeight, 0]);

                  var navXAxis = d3.svg.axis().scale(navXScale).ticks(7).tickFormat(function (d) {
                     return moment(d).format('MMM D');
                  }).orient('bottom');

                  var navData = d3.svg.area().interpolate('step-after').x(function (d) {
                     return navXScale(d.date);
                  }).y0(navigatorHeight).y1(function (d) {
                     return navYScale(d.dim);
                  });

                  var navigatorGroup = svg.append('g').attr('class', 'navigator').attr('width', width + margin.left + margin.right).attr('height', navigatorHeight + margin.top + margin.bottom).attr('transform', 'translate(' + margin.left + ',' + (margin.top + height + navigatorMarginTop) + ')');

                  navigatorGroup.append('path').attr('class', 'data').attr('d', navData(data));

                  svg.append('g').attr('class', 'x nav-axis').attr('transform', 'translate(' + margin.left + ',' + (margin.top + height + navigatorHeight + navigatorMarginTop) + ')').call(navXAxis);

                  // Navigator viewport
                  var navViewport = d3.svg.brush().x(navXScale).extent(xScale.domain()).on('brush', display);

                  navigatorGroup.append('g').attr('class', 'nav-viewport').call(navViewport).selectAll('rect').attr('height', navigatorHeight);

                  navigatorGroup.selectAll('.resize').append('rect').attr({
                     rx: 2,
                     ry: 2,
                     width: 10,
                     height: navigatorHeight / 2,
                     x: -5,
                     y: navigatorHeight / 4,
                     fill: 'gray',
                     'fill-opacity': 1
                  });

                  navigatorGroup.selectAll('.resize').append('circle').attr({
                     cx: 0,
                     cy: navigatorHeight / 3,
                     r: 2,
                     fill: 'whitesmoke',
                     'fill-opacity': 1
                  });

                  navigatorGroup.selectAll('.resize').append('circle').attr({
                     cx: 0,
                     cy: navigatorHeight / 2,
                     r: 2,
                     fill: 'whitesmoke',
                     'fill-opacity': 1
                  });

                  navigatorGroup.selectAll('.resize').append('circle').attr({
                     cx: 0,
                     cy: navigatorHeight / 1.5,
                     r: 2,
                     fill: 'whitesmoke',
                     'fill-opacity': 1
                  });

                  function display() {
                     var viewportExtent = navViewport.empty() ? navXScale.domain() : navViewport.extent();

                     zoomToPeriod(viewportExtent[0], viewportExtent[1]);
                  }

                  function zoomToPeriod(from, to) {
                     debounceSumRange(from, to);
                     chartsContainer.call(zoom.x(xScale.domain([from, to])));
                     //fakeOrdinalXScale.domain(getDateRange(from, to));
                     updateAxis();
                     updateCharts();
                  }

                  function updateCharts() {
                     lineDimGroup.data([data]).attr('d', lineDim);

                     lineDimGroup.exit().remove();
                  }

                  function updateAxis() {
                     mainGroup.select('.x.axis').call(xAxis).selectAll('text').style('text-anchor', 'end').attr('dx', '-.8em').attr('dy', '.15em').attr('transform', 'rotate(-90)');

                     mainGroup.select('.y.axis.yAxisDim').call(yAxisDim);
                     //mainGroup.select('.y.axis.yAxisPower').call(yAxisPower);

                     navViewport.extent(xScale.domain());
                     navigatorGroup.select('.nav-viewport').call(navViewport);
                  }
               }

               var debounceResize = _.debounce(resize, 200);

               function removeExisting() {
                  d3.select($element[0]).selectAll('svg').remove();
               }

               function resize() {
                  //clear old one first, then generating new one
                  removeExisting();
                  generating(zEC.stateObject);
               }

               function removeWatch() {
                  d3.select(window).on('resize.' + $attrs.id, null);
               }

               this.$onChanges = function (changes) {
                  if (changes.stateObject.currentValue) {
                     removeExisting();
                     generating(changes.stateObject.currentValue);
                     zEC.windowWatcher = d3.select(window).on('resize.' + $attrs.id, debounceResize);
                  }
               };

               this.$onInit = function () {
                  //
               };

               this.$onDestroy = function () {
                  removeWatch();
               };
            }
         };

         _export('default', zoneEnergyChartComponent);
      }
   };
});

$__System.register('23', [], function (_export) {
    'use strict';

    var energyByZoneComponent;
    return {
        setters: [],
        execute: function () {
            energyByZoneComponent = {
                template: '\n        <section class="overview-energy-container">\n            <h2 class="overview-heading">\n                <span translate="energy.zoneStateHistory">Zone State History</span>\n            </h2>\n\n            <div class="overview-zones-list-wrapper">\n                <div class="overview-zones-list">\n                    <div class="overview-zone demand zone-graph" ng-repeat="zone in eBZ.zoneCollection | orderBy:\'zone.full_power_reading\'" ng-class="{expanded: zone.expanded}">\n                        <span class="zone-name">\n                            {{::zone.id_string}}\n                            <energy-icon full-power="zone.full_power_reading" power-reporting="zone.power_reporting"></energy-icon>\n                        </span>\n                        <span class="zone-power" ng-if="eBZ.isSuperUser && (zone.full_power_reading || zone.watts)">\n                            <!--<span class="zone-demand-percentage">\n                                <span class="description" translate="energy.zonesShareOfAreaUsage">zones share of area usage: </span>{{:: eBZ.getUsagePercent(zone, maxDemand)}}%\n                            </span>-->\n                            <span class="zone-demand gray smallcaps">\n                                {{\'common.max\' | translate}} {{:: zone.full_power_reading ? zone.full_power_reading : zone.watts}}W\n                            </span>\n                            <!--<progress value="{{:: eBZ.getUsagePercent(zone, maxDemand)}}" max="100"></progress>-->\n                        </span>\n                        <div class="zone-details-drop" ng-click="eBZ.zoneDetail(zone)" ng-class="{dropped: zone.expanded}">\n                            <i class="lc-dropdown"></i>\n                        </div>\n                        <zone-energy-chart class="chart" ng-if="zone.expanded" id="zone-energy-{{::zone.id}}" gmt-offset="eBZ.gmtOffset" state-object="zone.stateObject">\n                            <div class="no-data" ng-if="zone.stateObject.length == 0">No Data for this period</div>\n                            <div class="no-data" ng-if="!zone.stateObject">\n                                <p class="loading-spinner"></p>\n                            </div>\n                            <span class="time-note">{{::\'energy.allTimes\' | translate }} {{eBZ.tzReadable}}</span>\n                        </zone-energy-chart>\n                    </div>\n                    <p class="loading-spinner-label relative" ng-hide="eBZ.zoneCollection !== undefined" translate="common.loadingEllipsis">Loading...</p>\n                </div>\n            </div>\n        </section>\n    ',
                bindings: {
                    gmtOffset: '<',
                    isSuperUser: '<',
                    tzReadable: '<',
                    zoneCollection: '<'
                },
                controllerAs: 'eBZ',
                controller: function controller(Zones, moment, _) {
                    var eBZ = this;

                    eBZ.$onInit = function () {
                        //
                    };

                    eBZ.zoneDetail = function (zone) {
                        if (!zone.expanded) {
                            zone.expanded = true;

                            zone.rangeStart = moment().utc().startOf('minute').subtract(zoneStateData.params.days, 'day').toDate();
                            zone.rangeEnd = moment().utc().startOf('minute').toDate();

                            Zones.zoneStateChanges(zone.id, zoneStateData.params.start, moment().unix()).success(function (response) {
                                zone.stateObject = response.length ? zoneStateData.prepare(response, zone) : [];
                            });
                        } else {
                            zone.expanded = false;
                        }
                    };

                    var zoneStateData = {
                        params: {
                            now: moment().utc(),
                            days: 7,
                            start: moment().utc().subtract(7, 'day').unix()
                        },
                        data: { chartData: [], weekDays: [], zone: null },
                        nearestDecile: function nearestDecile(value) {
                            value = Math.round(value / 10) * 10;
                            return this.data.zone.power_draws_by_decile_as_dictionary[value] ? this.data.zone.power_draws_by_decile_as_dictionary[value] : 0;
                        },
                        buildWeekDays: function buildWeekDays() {
                            _(zoneStateData.params.days).times(function (index) {
                                zoneStateData.data.weekDays.push(zoneStateData.params.now.subtract(index + 1, 'day').format('ddd'));
                            });
                        },
                        dataPoints: function dataPoints(response) {
                            function dataPoint(power, dim, date) {
                                return {
                                    power: zoneStateData.nearestDecile(power),
                                    dim: dim,
                                    date: date
                                };
                            }

                            function checkInitial(point) {
                                var dim = 0;

                                if (point.initial_zone_state || point.after_zone_state) {
                                    dim = point.initial_dim_level > -1 ? point.initial_dim_level : point.after_dim_level;
                                }

                                return dim;
                            }

                            function clearHistorial(point) {
                                return point.initial_zone_state ? zoneStateData.params.start : point.timestamp;
                            }

                            var data = [];

                            var first = response[0];
                            var last = response[response.length - 1];

                            //Push fake 0,0 item to account for area chart
                            data.push(dataPoint(first.initial_zone_state, 0, zoneStateData.params.start - 1));

                            if (response.length == 1) {
                                data.push(dataPoint(first.initial_zone_state, checkInitial(first), zoneStateData.params.start));
                                data.push(dataPoint(first.initial_zone_state, checkInitial(first), moment().utc().unix()));
                            } else {
                                _.map(response, function (point) {
                                    data.push(dataPoint(checkInitial(point), checkInitial(point), clearHistorial(point)));
                                });
                            }

                            //Push fake 0,100 item to account for area chart
                            data.push(dataPoint(checkInitial(last), 0, moment().utc().unix() + 1));

                            this.data.chartData = data;
                        },
                        prepare: function prepare(response, zone) {
                            zoneStateData.data.zone = zone;
                            this.buildWeekDays();
                            this.dataPoints(response);
                            return this.data;
                        }
                    };
                }
            };

            _export('default', energyByZoneComponent);
        }
    };
});

$__System.register('24', [], function (_export) {
    'use strict';

    var energyIconComponent;
    return {
        setters: [],
        execute: function () {
            energyIconComponent = {
                template: '\n        <i class="zone-smart-shifting" \n            ng-if="eIC.smartShift"\n            title="Zone Smart Shifting"\n            help\n            data-help-div="smart-shifting"\n        ></i>\n        <i\n            class="zone-watts"\n            ng-if="::eIC.watts || eIC.powerReporting"\n            ng-class="{ready: eIC.fullPower !== null, collecting: eIC.powerReporting && (eIC.fullPower === null)}"\n            tooltip\n            title="{{::eIC.fullPower !== null ? \'Actual Power Reporting\' :  eIC.powerReporting && (eIC.fullPower === null) ? \'Power Usage data is being collected - check back soon\' :  \'Demand estimated from self-reported input watts\'}}"\n            help\n            data-help-div="power"\n        ></i>\n        <i class="zone-no-reporting"\n            ng-if="::!eIC.watts && !eIC.powerReporting"\n            title="Zone not Power Reporting - Enable Power Monitoring or enter a value in the Input Watts field"\n            help\n            data-help-div="not-reporting"\n        ></i>\n    ',
                bindings: {
                    fullPower: '<',
                    powerReporting: '<',
                    smartShift: '<',
                    watts: '<'
                },
                controllerAs: 'eIC'
            };

            _export('default', energyIconComponent);
        }
    };
});

$__System.register('25', ['12', '13', '1d'], function (_export) {
    var _createClass, _classCallCheck, d3, EnergyDoubleChartDirective;

    return {
        setters: [function (_) {
            _createClass = _['default'];
        }, function (_2) {
            _classCallCheck = _2['default'];
        }, function (_d) {
            d3 = _d['default'];
        }],
        execute: function () {
            'use strict';

            EnergyDoubleChartDirective = (function () {
                function EnergyDoubleChartDirective() {
                    _classCallCheck(this, EnergyDoubleChartDirective);

                    this.restrict = 'E';
                    this.scope = {
                        chartDataOld: '<',
                        chartDataNew: '<',
                        chartHeight: '<',
                        chartTop: '<'
                    };
                }

                _createClass(EnergyDoubleChartDirective, [{
                    key: 'link',
                    value: function link(scope, $element) {

                        function generating(dataOld, dataNew) {

                            //setting structure for D3 chart
                            var margin = {
                                top: scope.chartTop,
                                right: 20,
                                bottom: 40,
                                left: 50
                            },
                                fullWidth = $element[0].parentElement.clientWidth,
                                width = fullWidth - margin.left - margin.right,
                                height = scope.chartHeight - margin.top - margin.bottom;

                            var x = d3.scale.ordinal().rangeRoundBands([0, width], 0.8);

                            var y = d3.scale.linear().range([height, 0]);

                            var xAxis = d3.svg.axis().scale(x).orient('bottom').outerTickSize(3).innerTickSize(-height);

                            var yAxis = d3.svg.axis().scale(y).orient('left').ticks(5).outerTickSize(3).innerTickSize(-width);

                            //fixed size
                            var svg = d3.select($element[0]).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom)
                            //.attr('class', 'graph-svg-component')
                            .append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('font-family', 'Brandon Grotesque');

                            //clear previous svg
                            svg.selectAll('*').remove();

                            dataOld.forEach(function (d) {
                                d.usage = +d.usage;
                            });

                            dataNew.forEach(function (d) {
                                d.usage = +d.usage;
                            });

                            x.domain(dataNew.map(function (d) {
                                return d.month;
                            }));

                            var yOldMax = d3.max(dataOld, function (d) {
                                return d.usage;
                            });

                            var yNewMax = d3.max(dataNew, function (d) {
                                return d.usage;
                            });

                            if (yOldMax <= yNewMax) {
                                y.domain([0, yNewMax]);
                            } else {
                                y.domain([0, yOldMax]);
                            }

                            //draw axises
                            svg.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);

                            svg.append('g').attr('class', 'y axis').call(yAxis);
                            //.append('text')
                            //.attr('class', 'y-label');

                            //draw bars
                            svg.selectAll('.barNew').data(dataNew).enter().append('rect').attr('class', 'barNew').attr('x', function (d) {
                                return x(d.month);
                            }).attr('width', x.rangeBand() / 2).attr('y', function (d) {
                                return y(d.usage);
                            }).attr('transform', 'translate(' + x.rangeBand() / 2 * 1.5 + ',0)').transition().ease('elastic').duration(100).delay(function (d, i) {
                                return i * 100;
                            }).attr('y', function (d, i) {
                                return y(d.usage);
                            }).attr('height', function (d) {
                                return height - y(d.usage);
                            });

                            svg.selectAll('.barOld').data(dataOld).enter().append('rect').attr('class', 'barOld').attr('x', function (d) {
                                return x(d.month);
                            }).attr('width', x.rangeBand() / 2).attr('y', function (d) {
                                return y(d.usage);
                            }).attr('transform', 'translate(' + -x.rangeBand() / 4 + ',0)').transition().ease('elastic').duration(100).delay(function (d, i) {
                                return i * 100;
                            }).attr('y', function (d, i) {
                                return y(d.usage);
                            }).attr('height', function (d) {
                                return height - y(d.usage);
                            });

                            svg.append('rect').attr('x', width - 80).attr('y', 5).attr('width', 20).attr('height', 5);
                            svg.append('text').attr('x', width - 55).attr('y', 10).style('font-size', '10px').text('Current Week');

                            svg.append('rect').attr('x', width - 80).attr('y', 15).attr('width', 20).style('fill', 'rgb(160,160,160)').attr('height', 5);
                            svg.append('text').attr('x', width - 40).attr('y', 20).style('font-size', '10px').text('Last Week');

                            svg.selectAll('.x text').attr('y', 20);

                            svg.selectAll('.y text').attr('x', -20);

                            svg.select('.y-label').attr('y', -12).attr('dy', '0.61em').style('text-anchor', 'end').attr('transform', 'rotate(-90)').text('kWh');

                            if (scope.chartHeight > 300) {
                                svg.select('.y-label').attr('x', -275);
                            } else {
                                svg.select('.y-label').attr('x', -100);
                            }

                            svg.selectAll('.y line').attr('stroke', 'rgb(171,169,175)');

                            //choose the first tick
                            d3.selection.prototype.first = function () {
                                return d3.select(this[0][0]);
                            };

                            svg.selectAll('.y line').first().attr('stroke', 'rgb(40,45,50)');

                            //draw triangle
                            svg.append('path').attr('d', function () {
                                var x = -48,
                                    y = 420;
                                return 'M ' + x + ' ' + y + ' l 6 6 l -12 0 z';
                            });
                        }

                        scope.$watchGroup(['chartDataOld', 'chartDataNew'], function (newValues) {
                            if (newValues) {
                                d3.selectAll('svg').remove();
                                generating(newValues[0], newValues[1]);
                                scope.windowWatcher = d3.select(window).on('resize', resize);
                            }
                        });

                        function resize() {
                            //clear old one first, then generating new one
                            d3.selectAll('svg').remove();
                            generating(scope.chartDataOld, scope.chartDataNew);
                        }

                        function removeWatch() {
                            d3.select(window).on('resize', null);
                        }

                        scope.$on('$destroy', removeWatch);
                    }
                }]);

                return EnergyDoubleChartDirective;
            })();

            _export('EnergyDoubleChartDirective', EnergyDoubleChartDirective);
        }
    };
});

$__System.register('26', [], function (_export) {
  'use strict';

  var energyStates;
  return {
    setters: [],
    execute: function () {
      energyStates = {
        parent: 'site',
        name: "Energy",
        url: '/energy/{userSelectedFilter}',
        resolve: {
          //Resolve site data
          energyData: function energyData($stateParams, $state$, $transition$, Energy, initialSessionData) {

            var to = $transition$.to();
            var toParams = $transition$.params("to");
            var from = $transition$.from();
            var fromParams = $transition$.params("from");

            //return Energy.getByPeriod('week',initialSessionData.zones); - make this call within component for now
            return {};
          },
          //
          // Ideally on a dynamic state update we would re-resolve the itemCollection
          // ui-router parent resolves are 'retained' - so no update will happen
          // see https://github.com/angular-ui/ui-router/issues/2520 / 2424 / 3210 /
          //
          // Changing leftMenuSpecialContext var will prompt a master change
          //
          sessionData: function sessionData(Session) {
            return Session.getSiteData(false);
          },
          itemCollection: function itemCollection(sessionData, StructureService) {
            return StructureService.itemCollection(sessionData, 'zones');
          }
        },

        component: 'energyBase',

        params: {},

        title: 'Energy'
      };

      _export('energyStates', energyStates);
    }
  };
});

$__System.register('27', [], function (_export) {
	'use strict';

	function Energy($http, _) {
		this.asyncReport = function (type, slice, startDate, endDate, collection, synthetic, siteId, orgId) {
			var data = {
				report_type: type,
				org_id: orgId,
				synthetic: synthetic === true || synthetic === 'true',
				units: "kWh",
				start_date: startDate,
				zone_ids: collection.map(function (a) {
					return a.id;
				}),
				slice_by: slice
			};

			if (endDate) {
				data['end_date'] = endDate;
			}

			return $http({
				url: 'energy-async/',
				method: 'POST',
				data: data
			}).then(function (response) {
				return response.data;
			});
		};

		this.getBySeconds = function (slice, start, end, collection, synthetic, report, tz) {
			var httpParams = {
				url: 'energy/',
				params: {
					end_seconds: end - 1, //end + 18000, //Add 5 hours per Bruce to push into next data bucket
					slice_by: slice,
					start_seconds: start,
					synthetic: synthetic || false,
					tz: tz,
					zones: getIdRange(collection)
				}
			};

			if (report) {
				httpParams.responseType = 'blob';
				httpParams.params.download = true;
			}

			return $http(httpParams).then(function (response) {
				return response.data;
			});
		};

		this.getByPeriod = function (period, collection, slice) {
			return $http({
				url: 'energy/',
				params: {
					time_period: period,
					slice_by: slice,
					zones: getIdRange(collection)
					//[collectionName]: getIdRange(collection) //ES2015 wont get past esprima in grunt :(
				}
			}).then(function (response) {
				return response.data;
			});
		};

		this.report = function (siteId, month, year, path, synthetic) {
			return $http({
				method: 'POST',
				url: 'site/' + siteId + '/' + path + '/',
				responseType: 'blob',
				data: {
					month: parseInt(month),
					year: parseInt(year),
					download: true,
					synthetic: synthetic === true || synthetic === 'true' //ng-option passes string
				}
			}).then(function (response) {
				// Return Blob
				return response.data;
			}, function (error) {
				throw error;
			});
		};

		this.getRequestHistory = function () {
			return $http({
				dataType: 'json',
				url: 'energy-async/'
			}).then(function (response) {
				if (response.data && response.data.length > 0) {
					return response.data;
				}
				return false;
			});
		};

		this.getDemand = function (zones) {
			var maxDemand = 0,
			    currentDemand = 0;
			var zonesNotReporting = [],
			    zonesWithDemand = [];

			_.each(zones, function (zone, key) {

				//Some zones report null full power BUT they show power for 100 decile
				if (zone.full_power_reading === null) {
					zone.full_power_reading = zone.power_draws_by_decile_as_dictionary[100] ? zone.power_draws_by_decile_as_dictionary[100] : null;
				}

				if (!zone.full_power_reading && !zone.watts) {
					//We know nothing
					zonesNotReporting.push(zone);
				} else {
					var load = 0;

					if (zone.full_power_reading) {
						//Work it out
						load = parseFloat(zone.full_power_reading) || 0;

						if (zone.is_dimmable && zone.reported_dim_level !== 100) {

							var nearestDecile = (zone.reported_dim_level / 10 * 10).toFixed(2);

							if (zone.power_draws_by_decile_as_dictionary[nearestDecile]) {
								//Use power dictionary when we have it
								load = parseFloat(zone.power_draws_by_decile_as_dictionary[nearestDecile]) || 0;
							} else {
								load = zone.reported_dim_level / 100 * load;
							}
						}

						maxDemand = maxDemand + (parseFloat(zone.full_power_reading) || 0);
					} else {
						//We only have watts
						maxDemand = maxDemand + (parseFloat(zone.watts) || 0);

						load = parseFloat(zone.watts) || 0;
						if (zone.is_dimmable && zone.reported_dim_level !== 100) {
							load = zone.reported_dim_level / 100 * load;
						}
					}

					//Curent demand
					if (zone.zone_state) {
						currentDemand = currentDemand + load;
					}

					zonesWithDemand.push(zone);
				}
			});

			return {
				maxDemand: maxDemand.toFixed(2),
				currentDemand: currentDemand.toFixed(2),
				notReporting: zonesNotReporting,
				zonesWithDemand: zonesWithDemand
			};
		};

		function getIdRange(collection) {
			return _.map(collection, 'id').toString().replace(/,/g, '-');
		}
	}

	return {
		setters: [],
		execute: function () {
			Energy.$inject = ['$http', '_'];
			_export('default', Energy);
		}
	};
});

$__System.register("28", ["3", "22", "23", "24", "25", "26", "27", "1b", "1c", "1e", "1f"], function (_export) {
    //import zoneEnergyChartDirective from "./zoneEnergyChartDirective";

    "use strict";

    //import chartRangeDirective from "./chartRangeDirective";

    var angular, zoneEnergyChartComponent, energyByZoneComponent, energyIconComponent, EnergyDoubleChartDirective, energyStates, energyService, energyBaseComponent, energyBaseChartComponent, energyReportsRequestsHistoryComponent, energyReportsDropdownComponent, energyModule;
    return {
        setters: [function (_) {
            angular = _["default"];
        }, function (_2) {
            zoneEnergyChartComponent = _2["default"];
        }, function (_3) {
            energyByZoneComponent = _3["default"];
        }, function (_4) {
            energyIconComponent = _4["default"];
        }, function (_5) {
            EnergyDoubleChartDirective = _5.EnergyDoubleChartDirective;
        }, function (_6) {
            energyStates = _6.energyStates;
        }, function (_7) {
            energyService = _7["default"];
        }, function (_b) {
            energyBaseComponent = _b["default"];
        }, function (_c) {
            energyBaseChartComponent = _c["default"];
        }, function (_e) {
            energyReportsRequestsHistoryComponent = _e["default"];
        }, function (_f) {
            energyReportsDropdownComponent = _f["default"];
        }],
        execute: function () {
            energyModule = angular.module('energy', []).service('Energy', energyService).component('energyBase', energyBaseComponent).component('energyBaseChart', energyBaseChartComponent)

            //.directive('chartRangeDirective', () => new chartRangeDirective)
            .component('energyIcon', energyIconComponent).component('energyReportsDropdown', energyReportsDropdownComponent).component('energyReportRequestHistory', energyReportsRequestsHistoryComponent).directive('energyDoubleChartDirective', function () {
                return new EnergyDoubleChartDirective();
            }).component('zoneEnergyChart', zoneEnergyChartComponent).component('energyByZone', energyByZoneComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(energyStates);
            }]);

            _export("default", energyModule);
        }
    };
});

$__System.registerDynamic("29", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"url-404-container\">\n\t<header class=\"main-header\">404 not found</header>\n\t<div class=\"content\">\n\t\t<div class=\"logo\">\n\t\t\t<i class=\"bad-url\"></i>\n\t\t</div>\n\t\t<h1 class=\"404-head\">Page Not Found</h1>\n\t\t<h2>visit the Lightcloud <a href=\"\" ng-click=\"homepage()\">homepage</a></h2>\n\t\t<h2>or <a href=\"\" ng-click=\"login()\">login</a> to control your lights</h2>\n\t</div>\n</div>\n";
});
$__System.register('2a', ['29'], function (_export) {
    /**
     * Created by yuchao on 3/5/18.
     */
    'use strict';
    var errorBaseTemplate, errorBaseComponent;
    return {
        setters: [function (_) {
            errorBaseTemplate = _['default'];
        }],
        execute: function () {
            errorBaseComponent = {
                template: errorBaseTemplate,
                bindings: {},
                controllerAs: 'eB',
                controller: function controller($scope, Login, $window) {

                    var eB = this;

                    eB.homepage = function () {
                        $window.location.herf = 'http://www.rabweb.com';
                    };

                    eB.login = function () {
                        Login.logout();
                    };
                }
            };

            _export('default', errorBaseComponent);
        }
    };
});

$__System.register('2b', [], function (_export) {
    /**
     * Created by yuchao on 3/5/18.
     */
    'use strict';
    var errorStates;
    return {
        setters: [],
        execute: function () {
            errorStates = {
                name: "Error",
                url: '/error',

                component: 'errorBase',

                params: {},

                leftNav: null,

                title: '404'
            };

            _export('errorStates', errorStates);
        }
    };
});

$__System.register("2c", ["3", "2a", "2b"], function (_export) {
    "use strict";

    var angular, errorBaseComponent, errorStates, errorModule;
    return {
        setters: [function (_) {
            angular = _["default"];
        }, function (_a) {
            errorBaseComponent = _a["default"];
        }, function (_b) {
            errorStates = _b.errorStates;
        }],
        execute: function () {
            errorModule = angular.module('error', []).component('errorBase', errorBaseComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(errorStates);
            }]);

            _export("default", errorModule);
        }
    };
});

$__System.register('2d', [], function (_export) {
    'use strict';

    function Home($http, $q) {

        this.getUtilityRates = function (lat, lon) {
            var devKey = 'Z7orozVMgEb17hqCjq8FsqxSSANAN9Ua7dDXw3LO';

            //
            //
            // - Using NY power data while in development
            //
            //
            var tempExampleResponse = { 'inputs': { 'lat': '40.7127', 'lon': '-74.0059' }, 'errors': [], 'warnings': [], 'version': '3.1.0', 'metadata': { 'sources': ['Ventyx Research (2012)'] }, 'outputs': { 'company_id': '4226', 'utility_name': 'Consolidated Edison Co of New York Inc', 'utility_info': [{ 'company_id': '4226', 'utility_name': 'Consolidated Edison Co of New York Inc' }], 'commercial': 0.1155, 'industrial': 0.106, 'residential': 0.2321 } };

            return $q.resolve(utilityResponse(tempExampleResponse));

            // return $http({
            //     url : `https://developer.nrel.gov/api/utility_rates/v3.json?api_key=${devKey}&lat=${lat}&lon=${lon}`,
            // }).then(result =>{
            //     return utilityResponse(result.data);
            // });  
        };

        function utilityResponse(data) {
            return {
                rates: {
                    commercial: data.outputs.commercial,
                    industrial: data.outputs.industrial,
                    residential: data.outputs.residential
                },
                utilities: data.outputs.utility_info,
                sources: data.metadata.sources
            };
        }
    }

    return {
        setters: [],
        execute: function () {
            Home.$inject = ['$http', '$q'];
            _export('default', Home);
        }
    };
});

$__System.register('2e', [], function (_export) {
    'use strict';

    //
    //
    // Route isn't under masterParent - so replicates some lightweight functionality
    //
    //
    var homeMasterComponent;
    return {
        setters: [],
        execute: function () {
            homeMasterComponent = {
                template: '\n        <section class="overview-container home-page">\n\n            <section class="main-body welcome-screen">\n                <h1>{{::hM.initialSessionData.org.name}}</h1>\n                <h2></h2>\n                <home-messages org="hM.currentOrg"></home-messages>\n                <home-org-browser ng-if="hM.multiOrgUser" org-uuid="hM.currentOrg.uuid"></home-org-browser>\n            </section>\n\n\n        <!-- Old\n            <section class="main-left home-chart-container">\n                <home-chart ng-if="hM.chartData" chart-data="hM.chartData" on-select-item="hM.selectItem(type,id);"></home-chart>\n                <span class="no-sites" ng-if="hM.sites.length === 0">No Sites</span>\n            </section>\n\n            <section class="main-right welcome-screen">\n                <h1>{{::hM.initialSessionData.org.name}}</h1>\n                <h2></h2>\n                <home-savings sites="hM.sites" chart-data="hM.chartData" demand=""></home-savings>\n                <home-messages org-uuid="hM.currentOrg.uuid"></home-messages>\n                <home-org-browser ng-if="hM.multiOrgUser" org-uuid="hM.currentOrg.uuid"></home-org-browser>\n            </div>\n        -->\n\n        </section>\n    ',
                bindings: {
                    //
                    // Bindings inherited from $state and lcAuthApp
                    //
                    initialSessionSitesListPromise: '<',
                    initialSessionData: '<',
                    menuOpen: '<',
                    itemCollection: '<',
                    user: '<',
                    onSessionDataChange: '&',
                    onClearToBase: '&'
                },
                controllerAs: 'hM',
                controller: function controller($q, $state, SessionAdapter, _) {

                    var hM = this;

                    hM.$onInit = function () {
                        hM.initialSessionSitesListPromise.promise.then(function (siteList) {
                            //
                            // List could be from any org
                            //

                            hM.sites = siteList;

                            if (siteList.length > 0) {
                                // Cap the site count at 10 for now, 10 sites is still 20 extra reqs to BE
                                prepareChartData(_.take(siteList, 10)).then(function (result) {
                                    //
                                    hM.chartData = result;
                                });
                            }
                        });

                        hM.onSessionDataChange({ data: hM.initialSessionData });

                        hM.currentOrg = hM.initialSessionData.org;
                    };

                    hM.$onChanges = function (changes) {
                        //
                        // User object from LS is async
                        //
                        if (changes.user && changes.user.currentValue) {
                            //
                            hM.multiOrgUser = hM.user.is_superuser || checkMultiOrg(hM.user);
                        }
                    };

                    hM.selectionUpdate = function (selection) {
                        hM.selection = selection;
                    };

                    hM.clearToBase = function (createNew) {
                        console.log('Clear command from masterRight - will triger ui-route change');
                        hM.onClearToBase({ createNew: createNew });
                    };

                    hM.selectItem = function (type, id) {
                        console.log(type, id);
                        //return $state.go('')
                    };

                    function checkMultiOrg(user) {
                        return _.filter(user.permissions || [], function (perm) {
                            return perm.permission === 'org_admin' || perm.permission === 'org_user';
                        }).length > 1;
                    }

                    function getCurrentOrg(sites) {
                        // For future org toggling?
                        //
                        return sites[0] ? sites[0].org : null;
                    }

                    function getTotalEnergy(set, key) {
                        return _.reduce(set, function (result, val) {
                            return result + val[key];
                        }, 0);
                    }

                    function getSetState(set) {
                        return _.find(set, 'state') ? true : false;
                    }

                    function mapChartItem(item, type, children) {
                        return {
                            id_string: item.id_string || item.name,
                            id: item.id,
                            type: type,
                            children: children,
                            state: getSetState(children),
                            currentDraw: getTotalEnergy(children, 'currentDraw'),
                            maxDraw: getTotalEnergy(children, 'maxDraw')
                        };
                    }

                    function prepareChartData(sites) {
                        return getChartData(sites).then(function (chartSites) {
                            hM.currentOrg = getCurrentOrg(sites);

                            return mapChartItem(hM.currentOrg, 'org', chartSites);
                        });
                    }

                    function getSiteData(site) {
                        function getMaxDraw(zone) {
                            var maxDraw = zone.max_usage || zone.full_power_reading || zone.watts || 0;

                            return Math.round((maxDraw > -1 ? maxDraw : 0) * 100) / 100; //0 for future ?
                        }

                        function getCurrentDraw(zone) {
                            var currentDraw = zone.current_usage || zone.energy_load || 0;

                            return Math.round((currentDraw > -1 ? currentDraw : 0) * 100) / 100; //0 for future ?
                        }

                        function mapZones(zones) {
                            return _.map(zones, function (zone) {
                                return {
                                    id_string: zone.id_string,
                                    id: zone.id,
                                    type: 'zone',
                                    state: zone.zone_state,
                                    currentDraw: getCurrentDraw(zone),
                                    maxDraw: getMaxDraw(zone),
                                    dim: zone.reported_dim_level,
                                    is_dimmable: zone.is_dimmable,
                                    trim_high: zone.trim_high
                                };
                            });
                        }

                        function mapArea(area, allZones) {
                            var zones = mapZones(_.filter(allZones, { area: area.id }));

                            return mapChartItem(area, 'area', zones);
                        }

                        function mapAllAreas(areasAndZones) {
                            var areas = areasAndZones[0].map(function (area) {
                                return mapArea(area, areasAndZones[1]);
                            });

                            var noAreaZones = _.filter(areasAndZones[1], { area: null });

                            if (noAreaZones.length) {
                                areas.push(mapArea({ id_string: 'No Area', id: 0 }, mapZones(noAreaZones)));
                            }

                            return areas;
                        }

                        function mapSite(areasAndZones) {
                            var areas = mapAllAreas(areasAndZones);

                            return mapChartItem(site, 'site', areas);
                        }

                        return $q.all([SessionAdapter.fetchers.areas(site.id), SessionAdapter.fetchers.zones(site.id)]).then(function (areasAndZones) {
                            return mapSite(areasAndZones);
                        })['catch'](function (error) {
                            console.log('Failed to fetch site data ', error);
                        });
                    }

                    function getChartData(sites) {
                        return $q.all(_.map(sites, function (site) {
                            return getSiteData(site);
                        }));
                    }
                }
            };

            _export('default', homeMasterComponent);
        }
    };
});

$__System.register('2f', [], function (_export) {
    'use strict';

    var homeSavingsComponent;
    return {
        setters: [],
        execute: function () {
            homeSavingsComponent = {
                template: '\n        <div class="home-box">\n            <h2 class="overview-heading white">\n                <span translate="home.currentCost">Current Cost</span>\n            </h2>\n\n            <span ng-if="hS.currentDailyCost === null" translate="home.calculating">Calculating</span>\n            <div ng-if="hS.currentDailyCost !== null">\n                <h1>${{::hS.currentDailyCost}}</h1>\n                <h3 translate="home.perHour">per hour</h3>\n            </div>\n        </div>\n\n        <div class="home-box">\n            <h2 class="overview-heading white">\n                <span translate="home.lightcloudSavings">Lightcloud Savings</span>\n            </h2>\n\n            <span ng-if="!hS.lightcloudSavings" translate-off="home.calculating">Collecting Data</span>\n            <div ng-if="hS.lightcloudSavings">\n                <h1>${{::hS.lightcloudSavings}}</h1>\n                <h3 translate="home.allTime">all time</h3>\n            </div>\n        </div>\n\n        <div class="home-box">\n            <h2 class="overview-heading white">\n                <span translate="home.potentialSavings">Potential Savings</span>\n            </h2>\n\n            <span ng-if="!hS.potentialSavings" translate-off="home.calculating">Collecting Data</span>\n            <div ng-if="hS.potentialSavings">\n                <h1>${{::hS.potentialSavings}}</h1>\n                <h3 translate="home.perHour">per hour</h3>\n            </div>\n        </div>\n    ',
                bindings: {
                    chartData: '<',
                    sites: '<'
                },
                controllerAs: 'hS',
                controller: function controller(Home) {
                    var hS = this;

                    hS.$onInit = function () {
                        //
                        hS.currentDailyCost = null;
                    };

                    hS.$onChanges = function (changes) {
                        if (hS.sites && hS.chartData) {
                            // - Start with only first site for simplicity
                            getUtilityRates(hS.sites[0]).then(function (rates) {
                                calculateCostsSavings(hS.chartData, rates);
                            });
                        }
                    };

                    hS.$onDestroy = function () {
                        //
                    };

                    function getUtilityRates(site) {
                        var lat = site.locality.lat,
                            lng = site.locality.lng;

                        return Home.getUtilityRates(lat, lng).then(function (result) {
                            return result;
                        });
                    }

                    function calculateCostsSavings(siteData, rateData) {
                        var baseRate = rateData.rates.commercial;

                        hS.currentDailyCost = calculateCurrentDailyCost(siteData.currentDraw, baseRate);
                        hS.lightcloudSavings = calculateLightcloudSavings(siteData, baseRate);
                        hS.potentialSavings = getPotentialSavings(siteData, baseRate);
                    }

                    function calculateCurrentDailyCost(draw, rate) {
                        var dollarPerHour = draw / 1000 * rate;
                        //let dollarPerMonth = dollarPerHour * 24 * 31;
                        return Math.round(dollarPerHour * 100) / 100;
                    }

                    function calculateLightcloudSavings(data, rate) {}

                    function getPotentialSavings(data, rate) {
                        console.log(data);
                    }
                }
            };

            _export('default', homeSavingsComponent);
        }
    };
});

$__System.register('30', [], function (_export) {
    'use strict';

    var homeMessagesComponent;
    return {
        setters: [],
        execute: function () {
            homeMessagesComponent = {
                template: '\n        <section class="notifications-log-list-parent">\n            <notifications-log-list heading="{{:: \'home.latestActivity\' | translate}}" pending="hM.ajaxPending" messages="hM.notificationMsgs" filter-text="" filter-category=""></notifications-log-list>\n\n            <h2 class="overview-heading white" ng-click="hM.popModal(\'csOrgActivity\',{selectedOrg: hM.org});">\n                <span translate="home.viewAllActivity">View All Activity</span>\n            </h2>\n        </section>\n    ',
                bindings: {
                    org: '<'
                },
                controllerAs: 'hM',
                controller: function controller($scope, Messages, Modals, $state, _) {
                    var hM = this;

                    var socketMsgWatcher = $scope.$on('notifications:new-message', addOrgMessage);

                    hM.$onInit = function () {
                        //
                    };

                    hM.$onChanges = function (changes) {
                        if (changes.org && changes.org.currentValue) {
                            // - Start with only 5 (for speed)
                            getOrgHistoricalMessages(changes.org.currentValue.uuid, 5);
                        }
                    };

                    hM.$onDestroy = function () {
                        socketMsgWatcher();
                    };

                    //
                    // @todo - Change these popup funcs to stateful modals
                    //
                    hM.popModal = function (name, inputs) {
                        Modals.showModal({
                            name: name,
                            inputs: inputs
                        }).then(function (route) {
                            if (route) {
                                $state.go(route.path, route.params);
                            }
                        });
                    };

                    function getOrgHistoricalMessages(id, messageCount) {
                        hM.ajaxPending = true;
                        Messages.getOrgNotifications(id, messageCount).then(function (notifications) {
                            hM.notificationMsgs = notifications;

                            hM.categories = _.map(_.groupBy(notifications, 'subject_type'), function (group, key) {
                                return key;
                            });

                            hM.ajaxPending = false;
                        });
                    }

                    function addOrgMessage(scope, messages) {
                        _.each(messages, function (message) {
                            hM.notificationMsgs = _.take(hM.notificationMsgs, 9);
                            hM.notificationMsgs.unshift(message);
                        });
                    }
                }
            };

            _export('default', homeMessagesComponent);
        }
    };
});

$__System.register('31', [], function (_export) {
    'use strict';

    var homeOrgBrowserComponent;
    return {
        setters: [],
        execute: function () {
            homeOrgBrowserComponent = {
                template: '\n        <div class="home-box org-switcher">\n            <h2 class="overview-heading white drop" ng-class="{dropped: hOBC.drop}" ng-click="hOBC.toggleDrop()">\n                <span translate="home.viewMyOtherOrgs">View My Other Organizations</span>\n            </h2>\n\n            <div ng-if="hOBC.drop">\n                <ul>\n                    <li ng-repeat="org in hOBC.orgs" ng-class="::{\'selected\': org.selected}">\n                        <div class="left">\n                            <a ui-sref="Home({siteId: null, orgId:org.id, orgObject: org})">{{::org.name}}</a>\n                        </div>\n                        <div class="right">\n                            <span>{{::org.sites}} {{::\'common.sites\' | translate}}</span>\n                            <span>{{::org.users}} {{::\'common.users\' | translate}}</span>\n                            <!--<span><a ui-sref="MultiSite({orgUuid:org.uuid})"> Org Scenes</a></span>-->\n                        </div>\n                    </li>\n                </ul>\n                <p class="loading-spinner-label relative" ng-if="hOBC.ajaxPending" translate="common.loadingEllipsis" translate="common.loadingEllipsis">Loading...</p>\n            </div>\n        </div>\n    ',
                bindings: {
                    orgUuid: '<'
                },
                controllerAs: 'hOBC',
                controller: function controller(Orgs, _) {
                    var hOBC = this;

                    hOBC.$onInit = function () {
                        //
                    };

                    hOBC.$onChanges = function (changes) {
                        //
                    };

                    hOBC.toggleDrop = function () {
                        hOBC.drop = !hOBC.drop;

                        if (hOBC.drop) {
                            getOrgs();
                        }
                    };

                    function getOrgs() {
                        Orgs.getAll().then(function (orgs) {
                            hOBC.orgs = mapCurrentOrg(orgs, hOBC.orgUuid);
                        });
                    }

                    function mapCurrentOrg(orgs, uuid) {
                        return _.map(orgs, function (org) {
                            if (org.uuid === uuid) {
                                org.selected = true;
                            }
                            return org;
                        });
                    }
                }
            };

            _export('default', homeOrgBrowserComponent);
        }
    };
});

$__System.register('32', ['1d'], function (_export) {
    'use strict';

    var d3, homeChartComponent;
    return {
        setters: [function (_d) {
            d3 = _d['default'];
        }],
        execute: function () {
            homeChartComponent = {
                bindings: {
                    chartData: '<',
                    onSelectItem: '&'
                },
                controllerAs: 'hC',
                controller: function controller($window, $element, $q, SessionAdapter, _) {
                    var hC = this;

                    hC.$onChanges = function (changes) {
                        if (changes.chartData.currentValue) {

                            reDraw(hC.chartData);

                            var debounceResize = _.debounce(reDraw, 200);

                            hC.windowWatcher = d3.select($window).on('resize', debounceResize);
                        }
                    };

                    hC.$onInit = function () {
                        //
                    };

                    hC.$onDestroy = function () {
                        removeWatch();
                    };

                    function draw(chartData) {

                        // Dimensions of sunburst.
                        var width = $element[0].parentElement.clientWidth; //d3.select($element[0])[0].parentNode.offsetWidth /2;
                        var height = width * 0.8;
                        var radius = Math.min(width, height) / 2;

                        // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
                        var b = {
                            w: null, h: 30, s: 3, t: 10
                        };

                        function getColor(item) {
                            var colorFromId = ('00' + item.id).slice(-2);
                            var alpha = item.state ? 1 : 0.2;
                            var rgba = 'rgba(' + colorFromId + ', 1' + colorFromId + ', 1,' + alpha + ')';

                            return {
                                rgb: 'rgb(' + colorFromId + ', 1' + colorFromId + ', 1)',
                                rgba: rgba,
                                alpha: alpha
                            };
                        }

                        // Total size of all segments; we set this later, after loading the data.
                        var totalSize = 0;

                        // Holder
                        d3.select($element[0]).append('svg:svg').attr('id', 'main-chart-holder').attr('width', width).attr('height', height + b.h * 2);

                        // Center
                        d3.select('#main-chart-holder').append('svg:g').attr('id', 'chart-center-holder').attr('width', width).attr('transform', 'translate(' + width / 2 + ',' + height / 1.8 + ')').append('svg:text').attr('id', 'center-text').append('svg:tspan').attr('dy', '0.35em').attr('text-anchor', 'middle').text(function (d) {
                            return Math.round(chartData.currentDraw * 100) / 100 + 'w';
                        }).style('font-size', function (d) {
                            return width / (this.getComputedTextLength() / 4) + 'px';
                        });

                        // centerSub
                        d3.select('#center-text').append('svg:tspan').attr('dy', '2em').attr('dx', 0).attr('x', 0).attr('text-anchor', 'middle').text(function (d) {
                            return 'Current Demand';
                        });

                        var vis = d3.select('#main-chart-holder').append('svg:g').append('svg:g').attr('id', 'container').attr('transform', 'translate(' + width / 2 + ',' + (height / 2 + b.h * 2) + ')');

                        var partition = d3.layout.partition().size([2 * Math.PI, radius * radius]).value(function (d) {
                            return d.currentDraw + 1;
                        }); //+1 is so that zones with no currentDraw values will still display

                        var arc = d3.svg.arc().startAngle(function (d) {
                            return d.x;
                        }).endAngle(function (d) {
                            return d.x + d.dx;
                        }).innerRadius(function (d) {
                            return Math.sqrt(d.y);
                        }).outerRadius(function (d) {
                            var inner = Math.sqrt(d.y);
                            var outer = Math.sqrt(d.y + d.dy);

                            var gradedRadial = inner + (outer - inner) / 100 * d.dim;

                            return d.dim ? gradedRadial : outer;
                        });

                        createVisualization(chartData);

                        // Main function to draw and set up the visualization, once we have the data.
                        function createVisualization(json) {

                            // Basic setup of page elements.
                            //initializeBreadcrumbTrail();
                            //drawLegend();
                            //d3.select('#togglelegend').on('click', toggleLegend);

                            // Bounding circle underneath the sunburst, to make it easier to detect
                            // when the mouse leaves the parent g.
                            vis.append('svg:circle').attr('r', radius).style('opacity', 0);

                            // For efficiency, filter nodes to keep only those large enough to see.
                            var nodes = partition.nodes(json).filter(function (d) {
                                return d.dx > 0.005; // 0.005 radians = 0.29 degrees
                            });

                            var path = vis.data([json]).selectAll('path').data(nodes).enter().append('svg:path').attr('display', function (d) {
                                return d.depth ? null : 'none';
                            }).attr('title', function (d) {
                                return d.id_string;
                            }).attr('class', 'segment').attr('id', function (d) {
                                return 'segment_' + d.type + '_' + d.id;
                            }).attr('d', arc).attr('fill-rule', 'evenodd').style('fill', function (d) {
                                // - Store color on item ?
                                d.color = getColor(d);
                                return d.color.rgba;
                            }).style('opacity', 1).on('mouseover', mouseover).on('click', function (d) {
                                return hC.onSelectItem({ type: d.type, id: d.id });
                            });

                            vis.selectAll('.segText').data(_.filter(nodes, function (d) {
                                return d.type === 'area' || d.type === 'site';
                            })).enter().append('text').attr('class', 'segText').attr('x', 10) //Move the text from the start angle of the arc
                            .attr('dy', 20) //Move the text down
                            .append('textPath').attr('xlink:href', function (d, i) {
                                return '#segment_' + d.type + '_' + d.id;
                            }).text(function (d) {
                                return d.id_string;
                            }).style('display', function (d) {
                                //console.log(this.getComputedTextLength());
                                // - Quick and dirty hide too long names, make this better
                                return d.value > 10 ? 'block' : 'none';
                            });

                            // Add the mouseleave handler to the bounding circle.
                            d3.select('#container').on('mouseleave', mouseleave);

                            // Get total size of the tree = value of root node from partition.
                            totalSize = path.node().__data__.value;
                        }

                        // Fade all but the current sequence, and show it in the breadcrumb trail.
                        function mouseover(d) {
                            var percentage = (100 * d.value / totalSize).toPrecision(3);
                            var percentageString = percentage + '%';
                            if (percentage < 0.1) {
                                percentageString = '< 0.1%';
                            }

                            d3.select('#percentage').text(percentageString);

                            d3.select('#explanation').style('visibility', '');

                            var sequenceArray = getAncestors(d);
                            // - updateBreadcrumbs(sequenceArray, percentageString);

                            // Fade all the segments.
                            d3.selectAll('path').style('opacity', 0.3);

                            // Then highlight only those that are an ancestor of the current segment.
                            vis.selectAll('path').filter(function (node) {
                                return sequenceArray.indexOf(node) >= 0;
                            }).style('opacity', 1);
                        }

                        // Restore everything to full opacity when moving off the visualization.
                        function mouseleave(d) {
                            // Hide the breadcrumb trail
                            d3.select('#trail').style('visibility', 'hidden');

                            // Deactivate all segments during transition.
                            d3.selectAll('path').on('mouseover', null);

                            // Transition each segment to full opacity and then reactivate it.
                            d3.selectAll('path').transition().duration(1000).style('opacity', 1).each('end', function () {
                                d3.select(this).on('mouseover', mouseover);
                            });

                            d3.select('#explanation').style('visibility', 'hidden');
                        }

                        // Given a node in a partition layout, return an array of all of its ancestor
                        // nodes, highest first, but excluding the root.
                        function getAncestors(node) {
                            var path = [];
                            var current = node;
                            while (current.parent) {
                                path.unshift(current);
                                current = current.parent;
                            }
                            return path;
                        }
                    }

                    function removeExisting() {
                        d3.select($element[0]).selectAll('svg').remove();
                    }

                    function reDraw(chartData) {
                        //clear old one first, then generating new one
                        removeExisting();
                        draw(chartData || hC.chartData);
                    }

                    function removeWatch() {
                        d3.select($window).on('resize', null);
                    }
                }
            };

            _export('default', homeChartComponent);

            /*
            function initializeBreadcrumbTrail() {
               // Add the svg area.
               // 
               // 
               // 
               var trail = d3.select('#main-chart-holder').insert('svg:g','g')
                       .attr('width', width)
                       .attr('height', b.h)
                       .attr('id', 'trail');
                   // Add the label at the end, for the percentage.
                   trail.append('svg:text')
                       .attr('id', 'endlabel')
                       .style('fill', 'white');
            }
            function getBreadCrumbTextWidth(d){
               //console.log(d.id_string.length)
                //return (d.id_string.length * 15);
               //
               return width / 5;
            }
            // Generate a string that describes the points of a breadcrumb polygon.
            function breadcrumbPoints(d, i) {
               let width = getBreadCrumbTextWidth(d);
                var points = [];
               points.push('0,0');
               points.push(width + ',0');
               points.push(width + b.t + ',' + (b.h / 2));
               points.push(width + ',' + b.h);
               points.push('0,' + b.h);
                if (i > 0) { // Leftmost breadcrumb; don't include 6th vertex.
                   points.push(b.t + ',' + (b.h / 2));
               }
                return points.join(' ');
            }
            // Update the breadcrumb trail to show the current sequence and percentage.
            function updateBreadcrumbs(nodeArray, percentageString) {
                function wrap() {
                   let padding = 1;
                    var self = d3.select(this),
                       textLength = self.node().getComputedTextLength(),
                       text = self.text();
                   while (textLength > (width - 2 * padding) && text.length > 0) {
                       text = text.slice(0, -1);
                       self.text(text + '...');
                       textLength = self.node().getComputedTextLength();
                   }
               } 
                // Data join; key function combines id_string and depth (= position in sequence).
               var g = d3.select('#trail')
                 .selectAll('g')
                 .data(nodeArray, function(d) { return d.id_string + d.depth; });
                // Add breadcrumb and label for entering nodes.
               var entering = g.enter().append('svg:g');
                entering.append('svg:text')
                   .attr('x', 20)
                   .attr('y', b.h / 2)
                   .attr('dy', '0.35em')
                   .attr('text-anchor', 'left')
                   .style('fill', 'white')
                   .text(function(d) { return d.id_string; })
                   .each(wrap);
                entering.append('svg:polygon')
                   .attr('points', breadcrumbPoints)
                   .style('fill', function(d) {
                       return d.color.rgb; 
               });
                entering.append('svg:text')
                   .attr('x', 20)
                   .attr('y', b.h / 2)
                   .attr('dy', '0.35em')
                   .attr('text-anchor', 'left')
                   .style('fill', 'white')
                   .text(function(d) { return d.id_string; })
                   .each(wrap);
                // Set position for entering and updating nodes.
               g.attr('transform', function(d, i) {
                   return 'translate(' + i * (getBreadCrumbTextWidth(d) + b.s) + ', 0)';
               });
                // Remove exiting nodes.
               g.exit().remove();
                //Update box width for id string length
               d3.select('#trail').select('#endlabel');
                  // Now move and update the percentage at the end.
               d3.select('#trail').select('#endlabel')
                   .attr('x', function(d) { 
                       return (nodeArray.length + 0.5) * getBreadCrumbTextWidth(d);
                   })
                   .attr('y', b.h / 2)
                   .attr('dy', '0.35em')
                   .attr('text-anchor', 'left')
                   .style('fill', 'black')
                   .text(percentageString);
                // Make the breadcrumb trail visible, if it's hidden.
               d3.select('#trail')
                   .style('visibility', '');
            }
            
            function drawLegend() {
                // Dimensions of legend item: width, height, spacing, radius of rounded rect.
               var li = {
               w: 75, h: 30, s: 3, r: 3
               };
                var legend = d3.select('#legend').append('svg:svg')
                 .attr('width', li.w)
                 .attr('height', d3.keys(colors).length * (li.h + li.s));
                var g = legend.selectAll('g')
                 .data(d3.entries(colors))
                 .enter().append('svg:g')
                 .attr('transform', function(d, i) {
                         return 'translate(0,' + i * (li.h + li.s) + ')';
                      });
                g.append('svg:rect')
                 .attr('rx', li.r)
                 .attr('ry', li.r)
                 .attr('width', li.w)
                 .attr('height', li.h)
                 .style('fill', function(d) { return d.value; });
                g.append('svg:text')
                 .attr('x', li.w / 2)
                 .attr('y', li.h / 2)
                 .attr('dy', '0.35em')
                 .attr('text-anchor', 'left')
                 .text(function(d) { return d.key; });
            }
            function toggleLegend() {
             var legend = d3.select('#legend');
             if (legend.style('visibility') === 'hidden') {
               legend.style('visibility', '');
             } else {
               legend.style('visibility', 'hidden');
             }
            }
            */
        }
    };
});

$__System.register('33', [], function (_export) {
  'use strict';

  var homeStates;
  return {
    setters: [],
    execute: function () {
      homeStates = [{
        name: 'Home',
        url: '/home/{orgId:[0-9]{1,24}}',
        resolve: {
          org: function org($stateParams, $transition$, LcCache, Orgs, Sites, Local, _) {
            //
            // - Allow the home state to be passed an org object (from search results)
            //
            if ($stateParams.orgObject) {
              LcCache.setCurrentOrg($stateParams.orgObject);
            }

            function getOrgFromId(id) {
              return Orgs.get(id).then(function (org) {
                return org;
              });
            }

            function getOrgObjectFromUserOrSites() {
              // - New user has no org sometimes :(
              function fetchOrgFromSites() {
                return Sites.get().then(function (sites) {
                  return sites[0] ? sites[0].org : {};
                });
              }

              var user = Local.get('lcUser');

              var firstOrgPerm = _.find(user.permissions, function (perm) {
                return perm.permission === 'org_admin' || perm.permission === 'org_user';
              });

              //
              // User could be RAB Super user - no perms explicitly set
              // give them Org #1 (per DM req)
              //
              if (!firstOrgPerm && user.is_superuser) {
                firstOrgPerm = { object_id: 1 };
              }

              return firstOrgPerm ? getOrgFromId(firstOrgPerm.object_id) : fetchOrgFromSites(); //Try sites API if no explicit perms
            }

            return $stateParams.orgId ? getOrgFromId($stateParams.orgId) : LcCache.getCurrentOrg() ? LcCache.getCurrentOrg() : getOrgObjectFromUserOrSites();
          },
          orgId: function orgId(org, $stateParams) {
            //$stateParams.orgId = org.id;
          },
          //Resolve site data
          initialSessionData: function initialSessionData(org, $stateParams, $state$, $transition$, $q, Session, Orgs, LcCache) {
            // If transitioning from a site, retain that site as current so user can go back and forth between top tabs
            var siteData = undefined;

            if ($stateParams.siteId) {
              siteData = LcCache.getSessionSiteData();
            } else {
              siteData = { org: org };
              LcCache.setSessionSiteData(siteData);
            }

            LcCache.setCurrentOrg(org);

            return siteData;
          },
          initialSessionSitesListPromise: function initialSessionSitesListPromise(initialSessionData, Session, $q) {
            var sitesListDeferred = $q.defer();

            Session.getSitesList(initialSessionData.id, initialSessionData.org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            })['catch'](function (error) {
              sitesListDeferred.reject(error);
            });

            return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
          },
          initialSelectedIds: function initialSelectedIds($stateParams, Session) {
            return Session.getUrlParamsUserSelection();
          },
          viewNavContext: function viewNavContext($transition$) {
            var to = $transition$.to();
            //
            // Some views will require different arrangements than default listed below
            //
            // - 'default' ('grouped-zones' view)
            // - 'devices'
            // - 'scenes'
            //
            //
            return to.params.leftMenuSpecialContext ? to.params.leftMenuSpecialContext : 'default';
          }
        },
        component: 'homeBase',
        params: {
          siteId: null,
          orgId: {
            value: null, //For old setting states
            dynamic: true
          },
          orgObject: null
        },
        title: 'Home'
      }];

      _export('homeStates', homeStates);
    }
  };
});

$__System.register('34', ['3', '30', '31', '32', '33', '2d', '2e', '2f'], function (_export) {
			'use strict';

			var angular, homeMessagesComponent, homeOrgBrowserComponent, homeChartComponent, homeStates, homeService, homeBaseComponent, homeSavingsComponent, homeModule;
			return {
						setters: [function (_) {
									angular = _['default'];
						}, function (_2) {
									homeMessagesComponent = _2['default'];
						}, function (_3) {
									homeOrgBrowserComponent = _3['default'];
						}, function (_4) {
									homeChartComponent = _4['default'];
						}, function (_5) {
									homeStates = _5.homeStates;
						}, function (_d) {
									homeService = _d['default'];
						}, function (_e) {
									homeBaseComponent = _e['default'];
						}, function (_f) {
									homeSavingsComponent = _f['default'];
						}],
						execute: function () {
									homeModule = angular.module('home', []).service('Home', homeService).component('homeBase', homeBaseComponent).component('homeSavings', homeSavingsComponent).component('homeMessages', homeMessagesComponent).component('homeOrgBrowser', homeOrgBrowserComponent).component('homeChart', homeChartComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
												homeStates.forEach(function (state) {
															return $stateRegistry.register(state);
												});
									}]);

									_export('default', homeModule);
						}
			};
});

$__System.register('35', [], function (_export) {
	'use strict';

	function Login($http, $state, Local, Sockets, Modals) {

		// this.login = function(username,password){
		// 	return $http({
		// 		url : 'authn/login/',
		// 		method : 'POST',
		// 		data : {
		// 			user : username,
		// 			password : password
		// 		}
		// 	})
		// }

		this.login = function (username, password, authy_token, signatures) {
			return $http({
				url: 'authn/login/',
				method: 'POST',
				data: {
					user: username,
					password: password,
					signatures: signatures,
					authy_token: authy_token ? authy_token : undefined
				}
			});
		};

		this.logout = function () {
			return $http({
				url: 'authn/logout/',
				method: 'POST'
			}).then(function (result) {
				logoutCleanup();
			});
		};

		this.reset = function (email) {
			return $http({
				url: 'user/password_reset/',
				method: 'POST',
				data: {
					email: email
				}
			});
		};

		this.newPassword = function (resetObj) {
			return $http({
				url: 'user/password_reset_confirm/',
				method: 'POST',
				data: resetObj
			});
		};

		this.validateToken = function (t, u) {
			return $http({
				method: 'POST',
				url: 'audit/check_password_token/',
				data: {
					token: t,
					uidb64: u
				}
			});
		};

		this.logoutCleanup = logoutCleanup;

		function logoutCleanup() {
			//
			// All Logout cleanup stuff moved here
			//
			//
			Local.clearAll();
			Sockets.disconnect();
			Modals.closeModals();
			$('.overlay').hide();
			//.socketOpen = true; //For zombie sockets set in Sockets service
			//
			// Feel like this is a bit hacky - could be built into route config?
			//
			$state.go('login');
		}
	}

	return {
		setters: [],
		execute: function () {
			Login.$inject = ['$http', '$state', 'Local', 'Sockets', 'Modals'];
			_export('default', Login);
		}
	};
});

$__System.registerDynamic("36", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"login-container\">\n    <div class=\"login-wrapper\">\n        <i class=\"logo-lg\"></i>\n        <div>\n            <form class=\"login-form\">\n                <div class=\"lang-switch\">\n                    <select ng-change=\"lB.switchLang(lB.language)\" ng-model=\"lB.language\">\n                        <option value=\"en\">English</option>\n                        <option value=\"zh\">中文</option>\n                        <option value=\"es\">Español</option>\n                        <!-- <option value=\"fr\">français</option> -->\n                    </select>\n                    <div class=\"triangle\"></div>\n                </div>\n                <fieldset>\n                    <input type=\"text\" autocomplete=\"email\" name=\"usernameInput\" ng-model=\"lB.username\" autocorrect=\"off\" autocapitalize=\"off\" placeholder=\"{{'login.emailAddress' | translate}}\" autofocus/>\n                    <input type=\"password\" autocomplete=\"current-password\" ng-model=\"lB.password\" placeholder=\"{{'login.password' | translate}}\"/>\n\n                    <p ng-class=\"{show:lB.errors.unauthorized}\" class=\"login-error password-error\" translate=\"login.incorrect\">Your email or password was incorrect.</p>\n                    <p ng-class=\"{show:lB.errors.accountLockedOut}\" class=\"login-error password-error\" translate=\"login.accountLockedOut\">Your account has been locked. Please contact your administrator</p>\n                    <p ng-class=\"{show:lB.errors.badConnection}\" class=\"login-error password-error\" translate=\"login.noConnection\">No connection to server</p>\n\n\n                    <div class=\"login-buttons\">\n                        <button id=\"login\" class=\"btn black login\" ng-click=\"lB.login(lB.username, lB.password, lB.tfaCode)\" ng-disabled=\"lB.signingIn\" translate>{{lB.signingIn ? 'login.signingIn' : 'login.signIn'}}\n                        </button>\n                        <a class=\"password-reset\" href=\"\" ng-click=\"lB.forgetPasswordClick()\" translate=\"login.forgotYourPassword\">Forgot password?</a>\n                        <button class=\"btn blue login\" ng-if=\"$root.dev\" ng-click=\"lB.username = $root.devCreds.user; lB.password = $root.devCreds.pass; lB.login(lB.username, lB.password, lB.tfaCode);\">Rab Dev Login</button>\n                    </div>\n                </fieldset>\n            </form>\n\n            <div class=\"reset-form show\" ng-show=\"lB.tfaActive\" ng-form name=\"validationForm\">\n\n                <h2><p translate=\"login.validationCodeHasBeenSentToYourPhone\">Validation Code has been sent to your phone</p></h2>\n                <fieldset>\n                    <input type=\"text\" placeholder=\"{{'login.validationCode' | translate}}\" ng-model=\"lB.tfaCode\" ng-minlength=\"7\" ng-maxlength=\"7\" ng-required=\"true\" ng-keyup=\"lB.formEnter($event,1)\" autofocus id=\"tfaInput\"/>\n                    <p class=\"error\" ng-show=\"lB.regexFail\">Please input a valid seven-digit number</p>\n                    <p class=\"error\" ng-show=\"lB.errors.tfaFailed\">Validation failed, please try again</p>\n                    <a class=\"cancel-reset\" ng-class=\"{success: lB.resetSuccess}\" ng-click=\"lB.tfaBackAction()\" translate=\"common.back\" ng-disabled=\"lB.signingIn\">Back</a>\n                    <button class=\"btn blue login\" ng-click=\"lB.tfaLogin(validationForm)\" ng-disabled=\"lB.signingIn || validationForm.$invalid\" translate>{{'common.confirm'}}\n                    </button>\n                </fieldset>\n            </div>\n\n            <agreement ng-if=\"lB.agreements.length\" agreements=\"lB.agreements\" on-non-optional-disagree=\"lB.disagree()\" on-final-answer=\"lB.agree(signatures)\"></agreement>\n        </div>\n\n        <div class=\"rab-logo-container\">\n            <i class=\"rab-logo black\" ng-class=\"{'rab-logo-ca': lB.domainTld === 'ca'}\"></i>      \n        </div>\n    </div>\n</section>\n\n<section class=\"reset-container\" ng-if=\"lB.$state.includes('password-reset') || lB.showForgotPassword\">\n    <form class=\"reset-form\" ng-if=\"lB.showForgotPassword\" name=\"resetPassForm\">\n        <h1 translate=\"login.forgotYourPassword\">Forgot Password?</h1>\n        <fieldset>\n            <p class=\"reset-success\" ng-class=\"{show:lB.resetSuccess}\" translate=\"login.passwordResetEmailSent\">The password reset email has been sent.</p>\n            <input type=\"email\" name=\"resetEmailInput\" ng-model=\"lB.email\" ng-hide=\"lB.resetSuccess\" placeholder=\"{{'login.emailAddress' | translate}}\" minlength=\"3\" required ng-keyup=\"lB.formEnter($event,2)\"/>\n            <a class=\"cancel-reset\" ng-class=\"{success: lB.resetSuccess}\" ng-click=\"lB.resetBackAction()\" translate=\"common.back\">Back</a>\n            <button id=\"reset\" class=\"btn blue\"  ng-disabled=\"lB.pendindReset || resetPassForm.$invalid\" ng-class=\"{'loading' : lB.pendingReset}\" ng-hide=\"lB.resetSuccess\" ng-click=\"lB.reset(resetPassForm)\" translate=\"login.resetPassword\">Reset Password\n            </button>\n        </fieldset>\n    </form>\n</section>\n\n\n\n\n";
});
$__System.register('37', ['36'], function (_export) {
    'use strict';

    var loginBaseTemplate, loginBaseComponent;
    return {
        setters: [function (_2) {
            loginBaseTemplate = _2['default'];
        }],
        execute: function () {
            loginBaseComponent = {
                template: loginBaseTemplate,
                bindings: {
                    //
                },
                controllerAs: 'lB',
                controller: function controller($timeout, $state, $translate, $rootScope, $sce, $q, Login, Session, Orgs, Track, Local, Modals, LcFn, moment, _) {

                    var lB = this;

                    lB.$onInit = function () {

                        //@y move this to directive please
                        $timeout(function () {
                            $('input[name="usernameInput"]').focus();
                        }, 100);

                        if ($rootScope.currentLanguage) {
                            lB.language = $rootScope.currentLanguage;
                        } else {
                            lB.language = 'en';
                        }

                        lB.domainTld = LcFn.getDomainTld();
                    };

                    //
                    // Defaults
                    //

                    lB.signaturesData = angular.copy($state.params.signaturesData);
                    lB.tfaCode = angular.copy($state.params.tfaCode);

                    lB.errors = {};
                    lB.signingIn = false;

                    lB.tfaActive = false;
                    lB.tfaErrMsg = false;

                    lB.tfaRegex = /^(\d{7})$/;

                    lB.signatures = [];

                    //
                    // Scope funcs
                    //

                    lB.login = function (username, password, tfaCode, signatures) {

                        lB.errors.unauthorized = false;
                        lB.errors.accountLockedOut = false;
                        lB.errors.tfaFailed = false;

                        Track.event('Login', 'Login From App at /login', lB.username);

                        lB.signingIn = true;

                        doLogin(username, password, tfaCode, signatures);
                    };

                    lB.agree = function (signatures) {
                        lB.login(lB.username, lB.password, lB.tfaCode, signatures);
                    };

                    lB.disagree = function () {
                        lB.agreements = [];

                        Login.logout();
                    };

                    lB.reset = function (resetPassForm) {
                        if (resetPassForm.resetEmailInput.$valid) {
                            lB.pendingReset = true;
                            Login.reset(lB.email).success(function () {
                                lB.resetSuccess = true;
                                lB.pendingReset = false;
                            }).error(function (data, status) {
                                lB.resetSuccess = false;
                                lB.pendingReset = false;
                            });
                        }
                    };

                    lB.switchLang = function (langkey) {
                        $translate.use(langkey);
                        $rootScope.currentLanguage = langkey; //@refactor
                    };

                    lB.resetBackAction = function () {
                        lB.email = '';
                        lB.resetSuccess = false;
                        lB.showForgotPassword = !lB.showForgotPassword;
                    };

                    lB.tfaBackAction = function () {
                        lB.tfaCode = null;
                        lB.tfaActive = false;
                        lB.regexFail = false;
                    };

                    lB.tfaLogin = function () {
                        if (lB.tfaRegex.test(lB.tfaCode)) {
                            lB.regexFail = false;
                            lB.errors.tfaFailed = false;
                            lB.login(lB.username, lB.password, lB.tfaCode);
                        } else {
                            lB.regexFail = true;
                            lB.tfaCode = null;
                        }
                    };

                    lB.formEnter = function (event, state) {
                        if (event.keyCode === 13) {
                            if (state === 1) {
                                if (lB.tfaRegex.test(lB.tfaCode)) {
                                    lB.tfaLogin();
                                }
                            } else if (state === 2) {
                                lB.reset();
                            }
                        }
                    };

                    lB.forgetPasswordClick = function () {
                        lB.showForgotPassword = !lB.showForgotPassword;

                        $timeout(function () {
                            $('input[name="resetEmailInput"]').focus();
                        }, 50);
                    };

                    //for blocking alpha letter input
                    $('#tfaInput').keydown(function (e) {
                        // Allow: backspace, delete, tab, escape, enter
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                        // Allow: Ctrl+A, Command+A
                        e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) ||
                        // Allow: home, end, left, right, down, up
                        e.keyCode >= 35 && e.keyCode <= 40) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    });

                    function doLogin(username, password, tfaCode, signatures) {
                        return Login.login(username, password, tfaCode, signatures).then(function (response) {
                            //
                            // Let's work with old and new backend
                            //
                            return response.data.user.org ? $q.resolve({ user: response.data.user, org: response.data.user.org, key: response.data.temp_key }) : getOrgObjectForUser(response.data);
                        }).then(function (result) {
                            //
                            // Set user object & session
                            //
                            var user = _.extend(result.user, { org: result.org });

                            return dataSuccess(user, result.key);
                        }).then(function () {
                            //
                            // Welcome new uesrs
                            //
                            return isNewUser() ? Modals.showModal({ name: 'welcomeSetting' }) : true;
                        }).then(function () {
                            //
                            // Go last
                            //
                            return Session.goLastUrl();
                        })['catch'](function (response) {
                            //
                            // Bail to error code handler
                            //
                            return dataFail(response);
                        });
                    }

                    function getOrgObjectForUser(loginResponse) {
                        //Set apiKey here
                        Local.set('apiKey', loginResponse.temp_key);
                        Local.set('lcUser', loginResponse.user);

                        var firstOrgPerm = _.find(loginResponse.user.permissions, function (perm) {
                            return perm.permission === 'org_admin' || perm.permission === 'org_user';
                        });

                        //
                        // User could be RAB Super user - no perms explicitly set
                        // give them Org #1 (per DM req)
                        //
                        if (!firstOrgPerm && loginResponse.user.is_superuser) {
                            firstOrgPerm = { object_id: 1 };
                        }

                        return firstOrgPerm ? Orgs.get(firstOrgPerm.object_id).then(function (org) {
                            return { user: loginResponse.user, org: org, key: loginResponse.temp_key };
                        }) : $q.resolve({ user: loginResponse.user, org: {}, key: loginResponse.temp_key }); //Return empty object if no org permissions have been set?
                    }

                    function isNewUser() {
                        return Local.get('lcUser').last_login === null || moment(Local.get('lcUser').date_joined).add(5, 'minutes').isAfter(Local.get('lcUser').last_login);
                    }

                    function dataSuccess(user, key) {
                        Local.clearLS();

                        //@todo - move user object to lcUser
                        Local.set('apiKey', key);
                        Local.set('lcUser', user);

                        //One-time rootScope user binding done here on login
                        $rootScope.user = user;
                    }

                    function dataFail(response) {
                        console.log(response);
                        if (response.status === 400) {
                            lB.errors.unauthorized = true;
                        } else if (response.status === 423) {
                            lB.errors.accountLockedOut = true;
                        } else if (response.status === 401) {
                            lB.tfaActive = true;
                            lB.signingIn = true;
                            $timeout(function () {
                                $('#tfaInput').focus();
                            }, 50);
                        } else if (response.status === 403) {

                            lB.errors.tfaFailed = true;
                            lB.tfaActive = true;
                            lB.tfaCode = null;
                            $timeout(function () {
                                $('#tfaInput').focus();
                            }, 50);
                        } else if (response.status === 428) {
                            if (response.data.pending_signatures) {

                                lB.agreements = _.map(response.data.pending_signatures, function (signature) {
                                    return {
                                        content: $sce.trustAsHtml(signature.content),
                                        id: signature.id,
                                        name: $sce.trustAsHtml(signature.name),
                                        only_org_admins: signature.only_org_admins,
                                        optional: signature.optional,
                                        publish_date: $sce.trustAsHtml(signature.publish_date)
                                    };
                                });
                            } else {
                                lB.errors.badConnection = true;
                            }
                        } else {
                            lB.errors.badConnection = true;
                        }

                        lB.signingIn = false;
                        Local.clearLS();
                    }
                }
            };

            _export('default', loginBaseComponent);
        }
    };
});

$__System.registerDynamic("38", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"reset-wrapper\">\n\t<header class=\"main-header\">\n\t\t<h1>{{rB.title}}</h1>\n\t</header>\n\t<form class=\"new-password-form\">\n\t\t<fieldset>\n\t\t\t<div ng-if=\"rB.welcome\" class=\"reset-welcome\">\n\t\t\t\t<h1>Welcome to Lightcloud</h1>\n\t\t\t</div>\t\t\n\t\t\t<div ng-hide=\"rB.resetSuccess\" class=\"input-field half\">\n\t\t\t\t<input type=\"password\" ng-min=\"8\" placeholder=\"{{'login.newPassword' | translate}}\" name=\"password1\" ng-model=\"rB.password1\" />\n\t\t\t</div>\n\t\t\t<br/>\n\t\t\t<div ng-hide=\"rB.resetSuccess\" class=\"input-field half\">\n\t\t\t\t<input type=\"password\" ng-min=\"8\" placeholder=\"{{'login.reenterPassword' | translate}}\" name=\"password2\" ng-model=\"rB.password2\" />\n\t\t\t</div>\n\t\t\t<div ng-if=\"rB.welcome\">\n\t\t\t\t<p translate=\"login.passwordError\">Password must be minimum 8 characters, one uppercase, one lowercase and one number</p>\n\t\t\t</div>\n\t\t\t<p ng-class=\"{show:rB.samePassword}\" ng-if=\"rB.samePassword\" class=\"login-error\" translate=\"login.samePassword\">Error! New password must be different from existing one.</p>\n\t\t\t<p ng-class=\"{show:rB.breakRules}\" ng-if=\"rB.breakRules\" class=\"login-error\" translate=\"login.passwordError\">Error! Password must be minimum 12 characters, one uppercase, one lowercase and one number.</p>\t\t\t\t\n\t\t\t<p ng-class=\"{show:rB.misMatch}\" ng-if=\"rB.misMatch\" class=\"login-error\" translate=\"login.passwordMatching\">Error! Please make sure the passwords you entered are matching.</p>\n\t\t\t<p ng-class=\"{show:rB.resetSuccess}\" ng-if=\"rB.resetSuccess\" class=\"reset-success\" translate=\"login.passwordRest\">Success! Please try logging in with your new password.</p>\n\t\t\t<br/>\n\t\t\t<button id=\"reset\" class=\"btn blue\" ng-disabled=\"rB.pendingReset || rB.inValidatedToken\" ng-class=\"{'loading' : rB.pendingReset}\" ng-hide=\"rB.resetSuccess\" ng-click=\"rB.reset()\">{{rB.btnLabel}}</button>\n\t\t\t<p ng-class=\"{show:rB.inValidatedToken}\" ng-if=\"rB.inValidatedToken\" class=\"login-error\" translate=\"login.expired\">Sorry, the request has been expired. Please submit your request again.</p>\n\t\t\t\n\t\t</fieldset>\n\t\t<button ng-show=\"rB.resetSuccess\" class=\"login-link\" ng-disabled=\"true\" >{{'login.goingToLogin' | translate}}{{rB.count}}s</button>\n\t</form>\n</div>\n";
});
$__System.register('39', ['38'], function (_export) {
    'use strict';

    var resetBaseTemplate, resetBaseComponent;
    return {
        setters: [function (_) {
            resetBaseTemplate = _['default'];
        }],
        execute: function () {
            resetBaseComponent = {
                template: resetBaseTemplate,
                bindings: {
                    //
                },
                controllerAs: 'rB',
                controller: function controller($timeout, $state, $rootScope, $interval, $location, Local, Login) {

                    var rB = this;

                    var loginRedirect = undefined;

                    rB.$onInit = function () {
                        validateToken();

                        rB.resetPass = true;
                        rB.welcome = false;

                        //for password set or reset
                        rB.btnLabel = 'Reset Password';
                        rB.title = 'Password Reset';

                        if ($location.search()['new'] === 'true') {
                            rB.btnLabel = 'Set Password';
                            rB.title = 'Set Password';
                            rB.welcome = true;
                        }
                    };

                    rB.$onDestroy = function () {
                        $interval.cancel(loginRedirect);
                    };

                    rB.reset = function () {
                        rB.misMatch = false;
                        rB.breakRules = false;
                        rB.samePassword = false;

                        var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z` ~ ! @ # $ % ^ * ( ) _ + - = { } | \[ \] & \ : " ; ' < > ? , . /]{8,}$/;

                        if (rB.password1 !== rB.password2) {
                            rB.misMatch = true;
                            rB.resetSuccess = false;
                        } else if (!reg.test(rB.password1) && !reg.test(rB.password2)) {
                            rB.resetSuccess = false;
                            rB.breakRules = true;
                        } else {
                            rB.pendingReset = true;

                            var resetObj = {
                                uidb64: $location.search().u,
                                token: $location.search().t,
                                password1: rB.password1,
                                password2: rB.password2
                            };

                            Login.newPassword(resetObj).success(function () {
                                rB.misMatch = false;
                                rB.resetSuccess = true;
                                rB.resetPass = false;
                                rB.pendingReset = false;
                                rB.breakRules = false;
                                rB.samePassword = false;

                                rB.count = 3;

                                loginRedirect = $interval(function () {
                                    rB.count--;
                                    if (rB.count == 0) {
                                        Login.logout();
                                    }
                                }, 1000, rB.count);
                            }).error(function (data) {
                                //rB.misMatch = true; //should be generic error
                                rB.resetSuccess = false;
                                rB.pendingReset = false;

                                // handles specific backend error - checks if error response is the newPassword === existingPassword case
                                if (data && data.error && data.error.includes('different from existing one')) {
                                    rB.samePassword = true;
                                }
                            });
                        }
                    };

                    function validateToken() {
                        console.log('now come to validation');
                        var validateTokenT = $location.search().t;
                        var validateTokenU = $location.search().u;

                        Login.validateToken(validateTokenT, validateTokenU).success(function () {
                            console.log('this token is ok');
                        }).error(function (data, status) {
                            if (status === 417) {

                                rB.inValidatedToken = true;

                                setTimeout(function () {

                                    rB.inValidatedToken = false;
                                    $rootScope.passwordReset = true;
                                    //$state.go('login');
                                }, 3000);
                            }
                        });
                    }
                }
            };

            _export('default', resetBaseComponent);
        }
    };
});

$__System.register('3a', [], function (_export) {
    'use strict';

    var agreementComponent;
    return {
        setters: [],
        execute: function () {
            agreementComponent = {
                template: '\n        <div class="user-agreement-container">\n            <div class="user-agreement-background">\n                <div class="user-agreement-wrapper"> \n                    <header>\n                        <p class="title" ng-hide="aC.submitted">Please read the following license agreement: {{ aC.agreements[0].name }}. Scroll below to view the rest of this agreement.</p>\n                    </header>\n\n                    <div class="agreement-content">\n                        <div ng-bind-html="aC.agreements[0].content"></div>\n                    </div>\n             \n                    <footer>\n                        <p class="title" ng-hide="aC.submitted">Click "I Agree" if you accept the terms of the preceeding license agreement. If "I Disagree" is clicked, it will quit the App.</p>\n                        <button class="btn blue close right" ng-click="aC.answer(aC.agreements[0],true);" ng-disabled="aC.submitted">I Agree</button>\n                        <button class="btn black close left" ng-click="aC.answer(aC.agreements[0],false);" ng-disabled="aC.submitted">I Disagree</button>\n                    </footer>\n                </div>\n            </div>\n        </div>\n    ',
                bindings: {
                    agreements: '<',
                    onNonOptionalDisagree: '&',
                    onFinalAnswer: '&'
                },
                controllerAs: 'aC',
                controller: function controller() {

                    var aC = this;

                    aC.$onInit = function () {
                        aC.signatures = [];
                    };

                    aC.answer = function (agreement, answer) {
                        if (!agreement.optional && !answer) {
                            aC.onNonOptionalDisagree();
                        } else {
                            aC.signatures.push({
                                id: agreement.id,
                                opt_out: !answer
                            });

                            aC.agreements.splice(0, 1);

                            if (aC.agreements.length === 0) {
                                aC.submitted = true;

                                aC.onFinalAnswer({ signatures: aC.signatures });
                            }
                        }
                    };
                }
            };

            _export('default', agreementComponent);
        }
    };
});

$__System.register('3b', [], function (_export) {
	'use strict';

	var loginStates;
	return {
		setters: [],
		execute: function () {
			loginStates = [{
				name: 'login',
				url: '/login',
				resolve: {},

				component: 'loginBase',

				params: {
					username: null,
					signaturesData: null,
					tfaCode: null
				},

				title: 'Login'
			}, {
				name: 'password-reset',
				url: '/password-reset?u&t',

				component: 'resetBase',

				title: 'Password reset'
			}];

			_export('loginStates', loginStates);
		}
	};
});

$__System.register('3c', ['3', '35', '37', '39', '3a', '3b'], function (_export) {
    'use strict';

    var angular, LoginService, loginBaseComponent, resetBaseComponent, agreementComponent, loginStates, loginModule;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_3) {
            LoginService = _3['default'];
        }, function (_4) {
            loginBaseComponent = _4['default'];
        }, function (_5) {
            resetBaseComponent = _5['default'];
        }, function (_a) {
            agreementComponent = _a['default'];
        }, function (_b) {
            loginStates = _b.loginStates;
        }],
        execute: function () {
            loginModule = angular.module('login', []).service('Login', LoginService).component('loginBase', loginBaseComponent).component('resetBase', resetBaseComponent).component('agreement', agreementComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                _.each(loginStates, function (state) {
                    $stateRegistry.register(state);
                });
            }]);

            _export('default', loginModule);
        }
    };
});

$__System.registerDynamic("3d", [], true, function ($__require, exports, module) {
	/* */
	"format cjs";
	/******/
	var global = this || self,
	    GLOBAL = global;
	(function (modules) {
		// webpackBootstrap
		/******/ // The module cache
		/******/var installedModules = {};
		/******/
		/******/ // The require function
		/******/function __webpack_require__(moduleId) {
			/******/
			/******/ // Check if module is in cache
			/******/if (installedModules[moduleId])
				/******/return installedModules[moduleId].exports;
			/******/
			/******/ // Create a new module (and put it into the cache)
			/******/var module = installedModules[moduleId] = {
				/******/exports: {},
				/******/id: moduleId,
				/******/loaded: false
				/******/ };
			/******/
			/******/ // Execute the module function
			/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
			/******/
			/******/ // Flag the module as loaded
			/******/module.loaded = true;
			/******/
			/******/ // Return the exports of the module
			/******/return module.exports;
			/******/
		}
		/******/
		/******/
		/******/ // expose the modules object (__webpack_modules__)
		/******/__webpack_require__.m = modules;
		/******/
		/******/ // expose the module cache
		/******/__webpack_require__.c = installedModules;
		/******/
		/******/ // __webpack_public_path__
		/******/__webpack_require__.p = "";
		/******/
		/******/ // Load entry module and return exports
		/******/return __webpack_require__(0);
		/******/
	})(
	/************************************************************************/
	/******/[
	/* 0 */
	/***/function (module, exports) {

		'use strict';

		var _module = angular.module('angularModalService', []);

		_module.factory('ModalService', ['$animate', '$document', '$compile', '$controller', '$http', '$rootScope', '$q', '$templateRequest', '$timeout', function ($animate, $document, $compile, $controller, $http, $rootScope, $q, $templateRequest, $timeout) {

			function ModalService() {

				var self = this;

				//  Track open modals.
				self.openModals = [];

				//  Returns a promise which gets the template, either
				//  from the template parameter or via a request to the
				//  template url parameter.
				var getTemplate = function getTemplate(template, templateUrl) {
					var deferred = $q.defer();
					if (template) {
						deferred.resolve(template);
					} else if (templateUrl) {
						$templateRequest(templateUrl, true).then(function (template) {
							deferred.resolve(template);
						}, function (error) {
							deferred.reject(error);
						});
					} else {
						deferred.reject("No template or templateUrl has been specified.");
					}
					return deferred.promise;
				};

				//  Adds an element to the DOM as the last child of its container
				//  like append, but uses $animate to handle animations. Returns a
				//  promise that is resolved once all animation is complete.
				var appendChild = function appendChild(parent, child) {
					var children = parent.children();
					if (children.length > 0) {
						return $animate.enter(child, parent, children[children.length - 1]);
					}
					return $animate.enter(child, parent);
				};

				//  Close all modals, providing the given result to the close promise.
				self.closeModals = function (result, delay) {
					while (self.openModals.length) {
						self.openModals[0].close(result, delay);
						self.openModals.splice(0, 1);
					}
				};

				self.showModal = function (options) {

					//  Get the body of the document, we'll add the modal to this.
					var body = angular.element($document[0].body);

					//  Create a deferred we'll resolve when the modal is ready.
					var deferred = $q.defer();

					//  Validate the input parameters.
					var controllerName = options.controller;
					if (!controllerName) {
						deferred.reject("No controller has been specified.");
						return deferred.promise;
					}

					//  Get the actual html of the template.
					getTemplate(options.template, options.templateUrl).then(function (template) {

						//  The main modal object we will build.
						var modal = {};

						//  Create a new scope for the modal.
						var modalScope = (options.scope || $rootScope).$new(),
						    rootScopeOnClose = null,
						    locationChangeSuccess = options.locationChangeSuccess;

						//  Allow locationChangeSuccess event registration to be configurable.
						//  True (default) = event registered immediately
						//  # (greater than 0) = event registered with delay
						//  False = disabled
						if (locationChangeSuccess === false) {
							rootScopeOnClose = angular.noop;
						} else if (angular.isNumber(locationChangeSuccess) && locationChangeSuccess >= 0) {
							$timeout(function () {
								rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);
							}, locationChangeSuccess);
						} else {
							rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);
						}

						//  Create the inputs object to the controller - this will include
						//  the scope, as well as all inputs provided.
						//  We will also create a deferred that is resolved with a provided
						//  close function. The controller can then call 'close(result)'.
						//  The controller can also provide a delay for closing - this is
						//  helpful if there are closing animations which must finish first.
						var closeDeferred = $q.defer();
						var closedDeferred = $q.defer();
						var inputs = {
							$scope: modalScope,
							close: function close(result, delay) {
								//  If we have a pre-close function, call it.
								if (typeof options.preClose === 'function') options.preClose(modal, result, delay);

								if (delay === undefined || delay === null) delay = 0;
								$timeout(function () {

									cleanUpClose(result);
								}, delay);
							}
						};

						//  If we have provided any inputs, pass them to the controller.
						if (options.inputs) angular.extend(inputs, options.inputs);

						//  Compile then link the template element, building the actual element.
						//  Set the $element on the inputs so that it can be injected if required.
						var linkFn = $compile(template);
						var modalElement = linkFn(modalScope);
						inputs.$element = modalElement;

						//  Create the controller, explicitly specifying the scope to use.
						var controllerObjBefore = modalScope[options.controllerAs];
						var modalController = $controller(options.controller, inputs, false, options.controllerAs);

						if (options.controllerAs && controllerObjBefore) {
							angular.extend(modalController, controllerObjBefore);
						}

						//  Then, append the modal to the dom.
						if (options.appendElement) {
							// append to custom append element
							appendChild(options.appendElement, modalElement);
						} else {
							// append to body when no custom append element is specified
							appendChild(body, modalElement);
						}

						// Finally, append any custom classes to the body
						if (options.bodyClass) {
							body[0].classList.add(options.bodyClass);
						}

						//  Populate the modal object...
						modal.controller = modalController;
						modal.scope = modalScope;
						modal.element = modalElement;
						modal.close = closeDeferred.promise;
						modal.closed = closedDeferred.promise;

						//  ...which is passed to the caller via the promise.
						deferred.resolve(modal);

						// Clear previous input focus to avoid open multiple modals on enter
						document.activeElement.blur();

						//  We can track this modal in our open modals.
						self.openModals.push({ modal: modal, close: inputs.close });

						function cleanUpClose(result) {

							//  Resolve the 'close' promise.
							closeDeferred.resolve(result);

							//  Remove the custom class from the body
							if (options.bodyClass) {
								body[0].classList.remove(options.bodyClass);
							}

							//  Let angular remove the element and wait for animations to finish.
							$animate.leave(modalElement).then(function () {
								//  Resolve the 'closed' promise.
								closedDeferred.resolve(result);

								//  We can now clean up the scope
								modalScope.$destroy();

								//  Remove the modal from the set of open modals.
								for (var i = 0; i < self.openModals.length; i++) {
									if (self.openModals[i].modal === modal) {
										self.openModals.splice(i, 1);
										break;
									}
								}

								//  Unless we null out all of these objects we seem to suffer
								//  from memory leaks, if anyone can explain why then I'd
								//  be very interested to know.
								inputs.close = null;
								deferred = null;
								closeDeferred = null;
								modal = null;
								inputs = null;
								modalElement = null;
								modalScope = null;
							});

							// remove event watcher
							rootScopeOnClose && rootScopeOnClose();
						}
					}).then(null, function (error) {
						// 'catch' doesn't work in IE8.
						deferred.reject(error);
					});

					return deferred.promise;
				};
			}

			return new ModalService();
		}]);

		/***/
	}
	/******/]);
	
});
$__System.registerDynamic("3e", ["3d"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("3d");
});
$__System.register('3f', ['3', '40', '3e'], function (_export) {
    // @ todo Remove jQuery
    'use strict';

    var angular, $, modalsLegacy;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_3) {
            $ = _3['default'];
        }, function (_e) {}],
        execute: function () {
            modalsLegacy = angular.module('modals-legacy', ['angularModalService'])

            // .provider('ModalService', function(){
            //     this.$get = [function () {
            //         return ModalService;
            //     }];
            // })

            .directive('confirmationModal', ['$rootScope', '$sce', function ($rootScope, $sce) {

                return {

                    restrict: 'E',
                    template: '<div class="confirmation-modal">\n                            <div class="confirmation-message"></div>\n                            <div class="confirmation-btn-group">\n                                <button class="btn reject" ng-click="reject()" ng-bind="rejectLabel"></button>\n                                <button class="btn orange resolve" ng-click="resolve()" ng-bind="resolveLabel"></button>\n                            </div>\n                        </div>',
                    replace: false,
                    scope: true,
                    link: function link(scope, element) {

                        var $overlay = $('.modal-overlay');

                        scope.$on("event:showConfirmModal", function (event, rejectLabel, resolveLabel, confirmMsg, deferred) {
                            scope.rejectLabel = rejectLabel;
                            scope.resolveLabel = resolveLabel;
                            scope.confirmMsg = $sce.trustAsHtml(confirmMsg);

                            $('.confirmation-message').html(confirmMsg);

                            scope.deferred = deferred;
                            //scope.$apply();
                            $overlay.fadeIn(300);
                        });

                        scope.reject = function () {
                            scope.deferred.reject();
                            $overlay.fadeOut(300);
                        };

                        scope.resolve = function () {
                            scope.deferred.resolve();
                            $overlay.fadeOut(300);
                        };
                    }
                };
            }]).directive('loadingModal', ['$rootScope', '$timeout', 'Messages', function ($rootScope, $timeout, Messages) {

                return {

                    restrict: 'E',
                    replace: true,
                    template: '<div class="screen-block grey-cover">\n                          <div class="loading-modal">\n                            <div class="loading-mark"></div>\n                            <p class="message" ng-bind="message"></p>\n                            <div class="spinner"></div>\n                          </div>\n                        </div>',
                    link: function link(scope, element) {

                        var listener;
                        var el = $(element);
                        var child = el.find('.loading-modal');

                        function zombie() {
                            el.fadeOut(400);

                            Messages.popUp({ error_msg: 'Request timed out' }, 'Request Failure');
                        }

                        scope.$on('event:openLoadingModal', function (event, pendingMessage) {
                            child.removeClass('completed');
                            child.removeClass('fail');
                            child.removeClass('welcomed');

                            scope.message = pendingMessage;
                            el.fadeIn(400, function () {});

                            listener = $timeout(function () {
                                zombie();
                            }, 60000); //For zombie ajax
                        });

                        scope.$on('event:closeLoadingModal', function (event, endMessage, success) {
                            var fadeOutDelay = 400;

                            if (angular.isUndefined(success)) {
                                //
                                // Take longer with failures so user can process why...
                                //                    
                                child.addClass('fail');
                                fadeOutDelay = 2000;
                            }
                            child.removeClass('welcomed');

                            scope.message = endMessage;
                            $timeout.cancel(listener);
                            el.delay(fadeOutDelay).fadeOut(400);
                        });

                        scope.$on('event:initOpenLoadingModal', function (event, pendingMessage) {
                            child.removeClass('completed');
                            child.removeClass('fail');
                            child.addClass('welcomed');

                            scope.message = pendingMessage;
                            el.fadeIn(400, function () {});

                            listener = $timeout(function () {
                                zombie();
                            }, 60000); //For zombie ajax
                        });

                        scope.$on('event:initCloseLoadingModal', function (event, endMessage, success) {
                            if (angular.isDefined(success)) {
                                child.addClass('completed');
                            } else {
                                child.addClass('fail');
                            }
                            child.addClass('welcomed');

                            scope.message = endMessage;
                            $timeout.cancel(listener);
                            el.delay(1000).fadeOut(400);
                        });
                    }
                };
            }])

            //  Multiselect is used in the following places now:
            //
            // - Scenes add zone to scene
            // - Control Device selection
            // - Update Devices selection
            // - settings
            // - users
            // - automationsCtrl
            //

            .directive('multiSelectModal', ['$rootScope', 'Messages', '$filter', '_', function ($rootScope, Messages, $filter, _) {
                return {
                    restrict: 'E',
                    replace: true,
                    template: '<div class="overlay">\n                          <div class="select-modal multi-select-modal {{::cssClass}}">\n                            <h2 class="header">\n                              <span ng-bind="::title"></span>\n                              <button class="btn-x"></button>\n                            </h2>\n                            <div class="search-input-wrapper">\n                              <i class="fa fa-search"></i>\n                              <input class="search" type="search" ng-model="selectSearch" placeholder="Search">\n                            </div>\n                            <div class="select-list-container">\n                              <div class="select-list">\n                                <div class="select-list-item" ng-repeat="section in sections" >\n                                  <header>\n                                     <h2 class="area-title caps" ng-bind="::section.subtitle"></h2>\n                                  </header>\n                                  <div class="area-subs">\n                                    <div class="zones" ng-repeat="area in section.areas"\n                                         ng-show="(area.children | filter:selectSearch).length || areaMatches(area, selectSearch)">\n                                      <header class="area-sub-title">\n                                        <button class="btn-select"\n                                          ng-class="{selected: groupSelected(areaMatches(area, selectSearch) ? area.children : (area.children | filter:selectSearch))}"\n                                          ng-hide="cssClass == \'control\' || max === 1"\n                                          ng-click="toggleAll(areaMatches(area, selectSearch) ? area.children : (area.children | filter:selectSearch))">\n                                        </button>\n                                        <h2>{{area.id_string}}</h2>\n                                      </header>\n                                      <div class="select-list-item multi child"\n                                           ng-repeat="child in (areaMatches(area, selectSearch) ? area.children : (area.children | filter:selectSearch))"\n                                           ng-click="multiSelectItem(child, sections)"\n                                           ng-class="{highlighted: child.is_local_zone, blocked: child.block_selection_dimming || child.block_selection_gateway}">\n                                        <button class="btn-select" ng-if="::!child.block_selection_dimming && !child.block_selection_gateway" ng-class="{selected:child.selected}"></button>\n                                        <h2 class="item-name" ng-bind="::child.id_string || child.name || child.settings.id_string || child.description"></h2>\n                                        <span class="description zone-helper" ng-if="child.deviceZones[0]">\n                                          <span class="">{{::child.deviceZones[0].areaName ? child.deviceZones[0].areaName +" > " : ""}}{{::child.deviceZones[0].id_string}}</span>\n                                        </span>\n                                        <span class="description trim-warn" ng-if="section.subtitle===\'automations\'">ID: {{child.id}}</span>\n                                        <span class="description trim-warn" ng-if="child.block_selection_dimming">No Dimming</span>\n                                        <span class="description trim-warn" ng-if="child.block_selection_gateway">Device on different gateway</span>\n                                        <span class="description trim-warn" ng-if="child.is_local_zone">Local Zone</span>\n                                        <span class="description trim-warn" ng-if="::!child.block_selection_dimming && !child.block_selection_gateway && child.trim_high && child.trim_high !== 100">Max trim {{::child.trim_high}}</span>\n                                      </div>\n                                    </div>\n                                  </div>\n                                </div>\n                               \n                              </div>\n                            </div>\n                            <footer>\n                              <div class="error errorMsg">{{errorMsg}}</div>\n                              <button class="btn bottom-right" ng-click="done()" translate="common.done">Done</button>\n                            </footer>\n                          </div>\n                        </div>',
                    controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
                        //Controller goes here
                    }],
                    link: function link(scope, element) {

                        var el = $(element);
                        var $modal = el.find('.select-modal');
                        var $close = el.find('.btn-x');

                        scope.items = [];

                        // checks to see if area match filter string
                        scope.areaMatches = function (area, filter) {
                            if (!filter) return false;
                            filter = filter.toLowerCase();
                            return area.id_string && area.id_string.toLowerCase().indexOf(filter) !== -1 || area.name && area.name.toLowerCase().indexOf(filter) !== -1;
                        };

                        scope.$on('event:showMultiSelectModal', function (event, promise, allSections, title, cssClass, max) {
                            scope.deferred = promise;
                            scope.cssClass = cssClass;
                            scope.max = max || false;

                            scope.title = title;

                            var selectionGroups = angular.copy(allSections);

                            var selected = _.flatten(_.map(selectionGroups, 'selected'));

                            scope.selectedItems = _.map(selected, function (item, key) {
                                return _.extend({}, item, { selected: true, list_position: key }); //Mark existing selection
                            });

                            scope.sections = _.map(selectionGroups, function (section) {
                                return {
                                    subtitle: section.type,
                                    areas: _.map(section.areas, function (area) {

                                        //
                                        // Remove user-hidden zones from this list
                                        //
                                        if (section.type === 'zones') {
                                            area.zones = _.filter(area.zones, function (zone) {
                                                return !(angular.isDefined(zone.visible_in_control) && !zone.visible_in_control);
                                            });
                                        }

                                        // Area object will have 'zones' or 'scenes' array - reference with 'area[collection]'
                                        //_.unionBy(_.filter(scope.selectedItems, {'area': area.id}), area[collection], 'id'); //Keep originals - we need to retain zone settings (ie dim)
                                        area.children = _.map(area[section.type], function (item) {
                                            item.lcType = section.type.slice(0, -1);
                                            var match = _.find(scope.selectedItems, ['id', item.id]);

                                            return _.merge(item, match);
                                        });

                                        return area;
                                    })
                                };
                            });

                            el.fadeIn(300, function () {
                                $modal.addClass('show');
                            });
                        });

                        scope.groupSelected = function (group) {
                            group = _.filter(group, function (item) {
                                return !item.block_selection_dimming && !item.block_selection_gateway;
                            });
                            return group.length ? _.every(group, 'selected') : false;
                        };

                        scope.toggleAll = function (group) {
                            group = _.filter(group, function (item) {
                                return !item.block_selection_dimming && !item.block_selection_gateway;
                            });

                            if (scope.max && _.countBy(scope.selectedItems, 'selected')['true'] + group.length > scope.max) {
                                Messages.popUp('Maximum ' + scope.max + ' ' + scope.collection);
                            } else {
                                if (_.countBy(group, 'selected')['true'] === group.length) {
                                    _.each(group, function (item) {
                                        item.selected = false;
                                        scope.selectedItems.splice(scope.selectedItems.indexOf(item), 1);
                                    });
                                } else {
                                    _.each(group, function (item) {
                                        if (!item.selected && !item.block_selection_dimming && !item.block_selection_gateway) {
                                            item.selected = true;
                                            scope.selectedItems.push(item);
                                        }
                                    });
                                }
                            }
                        };

                        scope.multiSelectItem = function (item, sections) {
                            //handle max here
                            if (!item.block_selection_dimming && !item.block_selection_gateway) {
                                //if only want to select one, we should take different approach

                                if (scope.max === 1 && scope.selectedItems.length === 1 && !item.selected) {
                                    //because they are at different section
                                    _.forEach(sections, function (section) {
                                        _.forEach(section.areas, function (area) {
                                            _.forEach(area.children, function (child) {
                                                if (child === item) {
                                                    child.selected = true;
                                                } else {
                                                    child.selected = false;
                                                }
                                            });
                                        });
                                    });
                                } else {
                                    if (item.selected) {
                                        item.selected = false;
                                        scope.selectedItems.splice(scope.selectedItems.indexOf(item), 1);
                                    } else {
                                        if (scope.max && _.countBy(scope.selectedItems, 'selected')['true'] === scope.max) {
                                            $rootScope.$broadcast('notifications:error', "Can't select more than " + scope.max + " zones");
                                        } else {
                                            item.selected = true;
                                            scope.selectedItems.push(item);
                                        }
                                    }
                                }
                            }
                        };

                        scope.done = function () {
                            scope.deferred.resolve(_.orderBy(_.filter(_.flatten(_.map(_.flatten(_.map(scope.sections, 'areas')), 'children')), 'selected'), ['list_position'])); //Scene doesn't know / need / care about area

                            closeModal();
                        };

                        $close.on('click', function () {
                            closeModal();
                            resetAll();
                            scope.errorMsg = null;
                        });

                        function resetAll() {
                            scope.selectedItems = [];
                            scope.sections = [];
                        }

                        function closeModal() {
                            $modal.removeClass('show');
                            setTimeout(function () {
                                el.fadeOut();
                            }, 100);
                        }
                    }
                };
            }]).directive('dependenciesModal', ['$rootScope', '$state', 'Automations', '_', function ($rootScope, $state, Automations, _) {

                return {

                    restrict: 'E',
                    template: '<div class="overlay">\n                          <div class="select-modal dependencies">\n                              <h2 class="header">\n                                <span ng-bind="confirmMsg"></span>\n                                <button class="btn-x" ng-click="reject()"></button>\n                              </h2>\n                              <div class="search-input-wrapper">\n                                <i class="fa fa-search"></i>\n                                <input class="search" type="search" ng-model="selectSearch" placeholder="Search">\n                              </div>\n                              <div class="select-list-container">\n                                <div class="select-list">\n                                  <div class="select-list-item">\n                                    <header>\n                                       <h2 class="area-title caps">Deletion will affect the following</h2>\n                                    </header>\n                                    <div class="area-subs">\n                                      <div class="zones" ng-repeat="(type, set) in dependencies" ng-show="set.length">\n                                        <h2 class="area-sub-title">{{humanName(type)}}</h2>\n                                        <div class="select-list-item multi child" ng-repeat="details in set | filter: selectSearch" ng-click="gotoItem(dependencies, type, details)">\n                                          <h2 class="item-name">{{details[1]}}</h2>\n                                          <span class="description del-device">{{details[0]}}</span>\n                                          <span class="goto">View</span>\n                                        </div>\n                                      </div>\n                                    </div>\n                                  </div>\n                                </div>\n                              </div>\n                              <footer>\n                                <button class="btn bottom-left reject" ng-click="reject()" ng-bind="rejectLabel"></button>\n                                <button class="btn orange bottom-right resolve" ng-click="resolve()" ng-bind="resolveLabel"></button>\n                              </footer>\n                          </div>\n                        </div>',
                    replace: true,
                    scope: true,
                    link: function link(scope, element) {

                        var el = $(element);
                        var $modal = el.find('.select-modal');

                        scope.humanName = humanName;

                        function humanName(name) {
                            return name.replace('affected_', '');
                        }

                        scope.gotoItem = function (dependencies, type, details) {
                            var areaId = dependencies.affected_area ? dependencies.affected_area[0][0] : null;
                            var siteId = $rootScope.currentSite.id;
                            var itemId = details[0];

                            type = humanName(type);

                            if (type === 'area') {
                                $state.go('area.overview', { siteId: siteId, areaId: areaId });
                            } else if (type === 'scenes') {
                                $state.go('area.scenes.scene', { siteId: siteId, areaId: areaId, sceneId: itemId });
                            } else if (type === 'schedules') {
                                $state.go('area.schedules.schedule', { siteId: siteId, areaId: areaId, scheduleId: itemId });
                            } else if (type === 'behaviors') {
                                scope.pending = true;

                                Automations.get(siteId).then(function (response) {
                                    var match = _.find(response, { behavior_id: itemId });
                                    scope.affectedBehaviorId = match ? match.criteria.length ? match.criteria.length[0].device_id : null : null;

                                    //If not the device we're looking at - goto
                                    if (scope.affectedBehaviorId !== $state.params.deviceId) {
                                        $state.go('devices.device', { deviceId: scope.affectedBehaviorId });
                                    } else {
                                        scope.deferred.reject();
                                        closeModal();
                                    }
                                });
                            }
                        };

                        scope.$on('event:showDependenciesModal', function (event, deferred, rejectLabel, resolveLabel, confirmMsg, dependencies) {
                            scope.dependencies = dependencies;

                            scope.rejectLabel = rejectLabel;
                            scope.resolveLabel = resolveLabel;
                            scope.confirmMsg = confirmMsg;
                            scope.deferred = deferred;

                            el.fadeIn(300, function () {
                                $modal.addClass('show');
                            });
                        });

                        scope.closeModal = closeModal;

                        function closeModal() {
                            $modal.removeClass('show');
                            setTimeout(function () {
                                el.fadeOut();
                            }, 400);
                        }

                        scope.reject = function () {
                            scope.deferred.reject();
                            closeModal();
                        };

                        scope.resolve = function () {
                            scope.deferred.resolve();
                            closeModal();
                        };
                    }
                };
            }]);

            _export('default', modalsLegacy);
        }
    };
});

$__System.register('41', [], function (_export) {
  'use strict';

  function renameModalCtrl($scope, selectedObject, cleanObject, title, action, close, existingNames) {

    $scope.selectedObject = selectedObject;
    $scope.cleanObject = cleanObject;
    $scope.title = title;
    $scope.close = close;
    $scope.action = action;
    $scope.existingNames = existingNames;

    var result = true;

    $scope.save = function () {
      $scope.error = false;
      $scope.uniqueNameError = false;

      //No save on same name ?

      // if(selectedObject.name == cleanObject.name){
      // 	$scope.error = false;
      // 	close();
      // } else

      if (_.find($scope.areas, { name: selectedObject.name })) {
        $scope.error = true;
      }

      // ensure scene name is not a duplicate
      if ($scope.existingNames.length > 0) {
        for (var i = 0; i < $scope.existingNames.length; i++) {
          if (typeof $scope.existingNames[i] == 'string' && typeof $scope.selectedObject.name == 'string') {
            if ($scope.existingNames[i].toLowerCase() == $scope.selectedObject.name.toLowerCase()) {
              $scope.uniqueNameError = true;
            }
          }
        }
      }

      if ($scope.error === false && $scope.uniqueNameError === false) {
        close(result);
      }
    };
  }

  return {
    setters: [],
    execute: function () {
      renameModalCtrl.$inject = ['$scope', 'selectedObject', 'cleanObject', 'title', 'action', 'close', 'existingNames'];
      _export('default', renameModalCtrl);
    }
  };
});

$__System.register('42', [], function (_export) {
	'use strict';

	function welcomeSettingCtrl($rootScope, $scope, Users, Local, close) {

		$scope.save = save;

		$scope.changeSetting = function () {
			$scope.setting = !$scope.setting;
		};

		$scope.user = Local.get('lcUser');
		$scope.pending = false;

		if ($scope.user.user_security_question || $scope.user.user_security_answer || $scope.user.user_security_pin_code) {
			$scope.title = "Please verify your security information";
		} else {
			$scope.title = "Please add your own security information";
		}

		function save(user, form) {

			$rootScope.blockEnterKey = false;
			$scope.pending = true;
			$scope.passwordError = false;
			$scope.errorMsg = false;
			$scope.submitted = false;

			if (form.$valid) {
				if (user.id) {
					if ($rootScope.currentOrg) {
						user.org_uuid = $rootScope.currentOrg.uuid;
					} else {
						user.org_uuid = Local.get('lcUser').org.uuid;
					}
					$rootScope.$broadcast('event:initOpenLoadingModal', 'Updating User');

					Users.update(user).success(function (user) {
						userSuccess(user);
						Local.set('lcUser', user);
					}).error(function (data) {
						if (data.error) {
							$scope.passwordError = true;
							$scope.errorMsg = false; // Ensure only password error shows
							console.log("password not correct");
						}
						$rootScope.$broadcast('event:initCloseLoadingModal', 'Update Failed');
						$scope.pending = false;
						$scope.submitted = false;
					});
				}
			} else {
				$scope.errorMsg = true;
				$scope.passwordError = false;
				$scope.pending = false;
				$scope.submitted = false;
			}
		}

		function userSuccess(user) {
			$rootScope.$broadcast('event:updateUsers');
			$rootScope.$broadcast('event:initCloseLoadingModal', 'Success', true);
			close([user]);
			$scope.pending = false;
		}
	}

	return {
		setters: [],
		execute: function () {
			welcomeSettingCtrl.$inject = ['$rootScope', '$scope', 'Users', 'Local', 'close'];
			_export('default', welcomeSettingCtrl);
		}
	};
});

$__System.register('43', [], function (_export) {
	'use strict';

	function csOrgEditModalCtrl($rootScope, $scope, $q, $state, LcCache, Orgs, close, selectedOrg) {

		$scope.pending = false;
		$scope.error = false;

		var cached = angular.copy(selectedOrg);
		$scope.org = angular.copy(cached);

		$scope.close = function () {
			if (selectedOrg && JSON.stringify($scope.org) !== JSON.stringify(cached)) {
				var deferred = $q.defer(),
				    promise = deferred.promise;

				$rootScope.$broadcast('event:showConfirmModal', 'No, Go Back', 'Yes, Close', 'Quit without saving changes?', deferred);

				promise.then(function () {
					close();
				});
			} else {
				close();
			}
		};

		$scope.updateOrg = function (org) {
			//@todo This check below will be negated by a restful put to /org/
			return (org.uuid ? Orgs.update(org) : Orgs.create(org)).then(function () {
				$scope.pending = false;
				$rootScope.currentOrg = org;

				// Get current site ID from session cache to preserve site context
				var currentSiteData = LcCache.getSessionSiteData();
				var currentSiteId = currentSiteData && currentSiteData.id ? currentSiteData.id : null;

				$state.go('Home', { orgObject: org, orgId: org.id, siteId: currentSiteId });

				// - @replace below
				close();
			});
		};

		$scope.deleteOrg = function () {
			delete $rootScope.currentOrg;
			LcCache.setCurrentOrg(null);

			// Assuming super user, will default to RAB
			// If deleting last org however...
			$state.go('Home', { siteId: null, orgId: null, orgObject: null });

			close();
		};
	}

	return {
		setters: [],
		execute: function () {
			csOrgEditModalCtrl.$inject = ['$rootScope', '$scope', '$q', '$state', 'LcCache', 'Orgs', 'close', 'selectedOrg'];
			_export('default', csOrgEditModalCtrl);
		}
	};
});

$__System.register('44', [], function (_export) {
	'use strict';

	function csSalesforceCaseModalCtrl($rootScope, $scope, Local, Orgs, close) {

		$scope.pending = false;
		$scope.error = false;

		$scope.saveCase = function (sfCase, sfCaseForm) {

			// ---- Add User & Site Details ----
			//
			//	'Salesforce Org/Account Id- "AccountId" on the Case'
			//	'Salesforce User/Contact Id- "ContactId" on the Case'
			//
			// ---------------------------------

			sfCase.AccountId = $rootScope.currentOrg ? $rootScope.currentOrg.id : null;
			sfCase.ContactId = Local.get('lcUser') ? Local.get('lcUser').id : null;

			Modals.openLoad('Submitting Case');
			Orgs.submitSalesforceCase(sfCase).then(function () {
				//We don't know if it worked or not :'(
			})['finally'](function () {
				Modals.closeLoad('Case Submitted', true);
				$scope.close();
			});
		};

		$scope.close = function () {
			close();
		};
	}

	return {
		setters: [],
		execute: function () {
			csSalesforceCaseModalCtrl.$inject = ['$rootScope', '$scope', 'Local', 'Orgs', 'close'];
			_export('default', csSalesforceCaseModalCtrl);
		}
	};
});

$__System.register('45', [], function (_export) {
	'use strict';

	function csOrgActivityModalCtrl($rootScope, $scope, $anchorScroll, close, selectedOrg, Messages, moment, _) {

		// @refactor - remove
		$scope.org = selectedOrg || $rootScope.currentOrg || null;

		$scope.close = close;
		$scope.ajaxPending = false;
		$scope.error = false;

		var messageCount = 1000;

		var watcher = function watcher() {};

		if ($scope.org) {
			getOrgHistoricalMessages($scope.org.uuid);

			watcher = $scope.$on('notifications:new-message', addOrgMessage);
			$scope.$on('$destroy', watcher);
		}

		$scope.scrollToTop = function () {
			$anchorScroll('topElementForScroll');
		};

		$scope.clearFilter = function () {
			$scope.filterByCategory = '';
		};

		function getOrgHistoricalMessages(id) {
			$scope.ajaxPending = true;
			Messages.getOrgNotifications(id, messageCount).then(function (notifications) {
				$scope.notificationMsgs = notifications;

				$scope.categories = _.map(_.groupBy(notifications, 'subject_type'), function (group, key) {
					return key;
				});

				$scope.ajaxPending = false;
			});
		}

		function addOrgMessage(scope, message) {
			if (message) {

				$scope.notificationMsgs ? $scope.notificationMsgs.unshift(message[0]) : $scope.notificationMsgs = [message[0]];
			}
		}
	}

	return {
		setters: [],
		execute: function () {
			csOrgActivityModalCtrl.$inject = ['$rootScope', '$scope', '$anchorScroll', 'close', 'selectedOrg', 'Messages', 'moment', '_'];
			_export('default', csOrgActivityModalCtrl);
		}
	};
});

$__System.register('46', [], function (_export) {
    'use strict';

    function csOrgSiteInfoModalCtrl(_, $rootScope, $scope, $q, $state, close, Orgs, Sites, selectedOrg, site, isSuperUser, isOrgAdmin, Local, LcCache) {

        var cacheListener = $rootScope.$on('event:refreshGateways', init);

        $scope.$on('$destroy', function () {
            cacheListener();
        });

        init();

        function init() {
            $scope.oSIM = {
                isOrgAdmin: isOrgAdmin,
                isSuperUser: isSuperUser,
                sites: [],
                blueConnecting: false,
                blueForm: {
                    email: '',
                    password: ''
                },
                blueError: null
            };

            // Pre-populate email with current user's email
            var currentUser = Local.get('lcUser');
            if (currentUser && currentUser.email) {
                $scope.oSIM.blueForm.email = currentUser.email;
            }

            var currentSite = site || $scope.currentSite || {};

            getOrgsList().then(function (list) {
                $scope.oSIM.orgsList = list;
                $scope.oSIM.allOrgsKeyedByName = _.mapValues(_.keyBy(list, 'uuid'), function (org) {
                    return org.name;
                });
            });

            getCurrentOrg(site.org_uuid).then(function (currentOrg) {
                $scope.oSIM.currentOrg = currentOrg;
                if (currentOrg) {
                    $rootScope.currentOrg = currentOrg;
                    LcCache.setCurrentOrg(currentOrg);
                }
                getOrgSites(currentOrg, currentSite.id);
            });
        }

        function getOrgsList() {
            return Orgs.getAll();
        }

        function getCurrentOrg(orgUuid) {
            return selectedOrg ? $q.resolve(selectedOrg) : Orgs.getByUuid(orgUuid);
        }

        function getOrgSites(currentOrg, optSiteId) {
            $scope.oSIM.pending = true;

            return Orgs.getSites(currentOrg.uuid).then(function (sites) {
                var match = _.find(sites, { id: optSiteId });

                if (match) {
                    match.showGateways = true;
                    sites.splice(_.findIndex(sites, ['id', optSiteId]), 1);
                    sites.unshift(match);
                }

                $scope.oSIM.sites = sites;
                $scope.oSIM.pending = false;

                return sites;
            });
        }

        $scope.oSIM.updateSite = function (site, transition) {
            return (site.id ? Sites.update(site) : Sites.create(site)).then(function () {
                if (transition) {
                    $scope.oSIM.close({ path: 'Overview', params: { siteId: transition.target, userSelectedFilter: null, leftMenuSpecialContext: 'overview' } });
                }
            });
        };

        $scope.oSIM.deleteSite = function (site) {
            return Sites['delete'](site).then(function () {
                $scope.oSIM.getFreshOrgSites().then(function (sites) {
                    console.log('Redirecting');
                    //Goto no site or first site
                    //@refactor - when we have router v1 we can do this a lot better
                    if (sites.length === 0) {
                        $state.go('Home');
                    } else {
                        $state.go('Overview', { siteId: sites[0].id, userSelectedFilter: null, leftMenuSpecialContext: 'default' });
                    }
                });
            });
        };

        $scope.oSIM.indicate = function (site) {
            site.ajaxPending = true;

            Sites.indicate(site).success(function () {
                site.ajaxPending = false;
            }).error(function () {
                site.ajaxPending = false;
            });
        };

        $scope.oSIM.close = function (route) {
            //Unmark sites - could avoid this with angular.copy(sites) on init instead
            $scope.oSIM.sites = _.map($scope.oSIM.sites, function (site) {
                site.showSite = false;
                site.showGateways = false;

                return site;
            });

            close(route);
        };

        $scope.oSIM.getFreshOrgSites = function (currentOrg) {
            $scope.oSIM.pending = true;

            // If currentOrg is provided, update it
            var orgToUse = currentOrg || $scope.oSIM.currentOrg || LcCache.getCurrentOrg();

            if (orgToUse && orgToUse.uuid) {
                // Refresh the org to get latest blue_authenticated status
                return Orgs.getByUuid(orgToUse.uuid).then(function (updatedOrg) {
                    $scope.oSIM.currentOrg = updatedOrg;
                    return getOrgSites(updatedOrg, null);
                })['finally'](function () {
                    $scope.oSIM.pending = false;
                });
            } else {
                return getOrgSites(orgToUse, null)['finally'](function () {
                    $scope.oSIM.pending = false;
                });
            }
        };

        $scope.oSIM.panicOperate = function (site) {
            site.ajaxPending = true;
            site.is_panic_mode = !site.is_panic_mode;

            Sites.update(site).then(function () {
                $rootScope.$broadcast('event:panicMode', site.is_panic_mode);
                site.ajaxPending = false;
            })['catch'](function (err) {
                console.log(err);
                site.is_panic_mode = !site.is_panic_mode;
                site.ajaxPending = false;
            });
        };

        $scope.oSIM.connectLightcloudBlue = function (formData) {
            $scope.oSIM.blueConnecting = true;
            $scope.oSIM.blueError = null; // Clear any previous errors

            // Get current organization information
            var currentOrg = $scope.oSIM.currentOrg || LcCache.getCurrentOrg();

            if (!currentOrg) {
                console.error('Unable to get current organization information');
                $scope.oSIM.blueConnecting = false;
                return;
            }

            // Prepare authentication data from form
            var authData = {
                email: formData.email,
                password: formData.password,
                org: currentOrg.uuid //orgUuid sent as 'org' per pete
            };

            // Make API call to authenticate with Lightcloud Blue using Orgs service
            Orgs.connectLightcloudBlue(authData).then(function (response) {
                console.log('Lightcloud Blue authentication response:', response);
                $scope.oSIM.blueConnecting = false;
                $scope.oSIM.blueError = null; // Clear any errors on success

                // Refresh the org to get updated blue_authenticated flag
                return Orgs.getByUuid(currentOrg.uuid).then(function (updatedOrg) {
                    $scope.oSIM.currentOrg = updatedOrg;
                    $rootScope.currentOrg = updatedOrg;
                    LcCache.setCurrentOrg(updatedOrg);
                });
            })['catch'](function (error) {
                console.error('Lightcloud Blue authentication error:', error);
                $scope.oSIM.blueConnecting = false;

                // Check for 403 status code
                if (error.status === 403) {
                    $scope.oSIM.blueError = 'Incorrect Email or Password';
                } else {
                    $scope.oSIM.blueError = 'An error occurred while connecting. Please try again.';
                }
            });
        };

        $scope.oSIM.logoutLightcloudBlue = function () {
            $scope.oSIM.blueConnecting = true;
            $scope.oSIM.blueError = null;

            // Get current organization information
            var currentOrg = $scope.oSIM.currentOrg || LcCache.getCurrentOrg();

            if (!currentOrg) {
                console.error('Unable to get current organization information');
                $scope.oSIM.blueConnecting = false;
                return;
            }

            // Make API call to logout from Lightcloud Blue using Orgs service
            Orgs.logoutLightcloudBlue(currentOrg.uuid).then(function (response) {
                console.log('Lightcloud Blue logout response:', response);
                $scope.oSIM.blueConnecting = false;

                // Refresh the org to get updated blue_authenticated flag
                return Orgs.getByUuid(currentOrg.uuid).then(function (updatedOrg) {
                    $scope.oSIM.currentOrg = updatedOrg;
                    $rootScope.currentOrg = updatedOrg;
                    LcCache.setCurrentOrg(updatedOrg);
                });
            })['catch'](function (error) {
                console.error('Lightcloud Blue logout error:', error);
                $scope.oSIM.blueConnecting = false;
                $scope.oSIM.blueError = 'An error occurred while logging out. Please try again.';
            });
        };

        $scope.oSIM.toggleGateways = function (site) {
            site.showGateways = !site.showGateways;
            site.showSite = false;
        };

        $scope.oSIM.discoverDevices = function (orgUuid) {
            Orgs.getBlueDevices(orgUuid).then(function (response) {
                console.log('Lightcloud Blue discoverDevices response:', response);
                $scope.oSIM.blueConnecting = false;
                $scope.oSIM.blueError = null; // Clear any errors on success
            })['catch'](function (error) {
                console.error('Lightcloud Blue discoverDevices error:', error);
                $scope.oSIM.blueConnecting = false;

                // Check for 401 status code
                if (error.status === 401) {
                    $scope.oSIM.blueError = 'Org not authenticated for Blue';
                } else {
                    $scope.oSIM.blueError = 'An error occurred while connecting. Please try again.';
                }
            });
        };
    }

    return {
        setters: [],
        execute: function () {
            csOrgSiteInfoModalCtrl.$inject = ['_', '$rootScope', '$scope', '$q', '$state', 'close', 'Orgs', 'Sites', 'selectedOrg', 'site', 'isSuperUser', 'isOrgAdmin', 'Local', 'LcCache'];
            _export('default', csOrgSiteInfoModalCtrl);
        }
    };
});

$__System.register('47', [], function (_export) {
	'use strict';

	function csOrgGatewaysModalCtrl($rootScope, $scope, close, selectedOrg, isSuperUser, Orgs, Sites, Devices, Modals, _) {

		$scope.org = selectedOrg || null;
		$scope.isSuperUser = isSuperUser || false;

		$scope.close = close;
		$scope.pending = false;
		$scope.error = false;

		$scope.getFreshGateways = getFreshGateways;

		init();

		function init() {
			getFreshGateways();
		}

		$scope.toggleCommission = function (gateway) {
			if (!gateway.wizard) {
				gateway.showDetails = false;

				gateway.wizard = {
					step: 1
				};
			} else {
				gateway.wizard = null;
			}

			return gateway; //>< ?
		};

		function getFreshGateways() {
			$scope.pending = true;

			Orgs.listGateways().then(function (gateways) {
				$scope.gatewayList = _.filter(gateways, { site: null });

				$scope.categories = _.map(_.groupBy($scope.gatewayList, 'gateway_version'), function (group, key) {
					return key;
				});
			})['finally'](function () {
				$scope.pending = false;
			});
		}

		//@todo combine
		$scope.indicate = function (gateway) {
			Devices.indicate(gateway.id);
		};

		$scope.updateGateway = function (gateway) {
			var gatewayIndex = _.findIndex($scope.gatewayList, { uuid: gateway.uuid });

			gateway.showDetails = true;

			if (gatewayIndex > -1) {
				$scope.gatewayList.splice(gatewayIndex, 1, gateway);
			}
		};

		$scope.clearFilter = function () {
			delete $scope.filterByCategory;
		};
	}

	return {
		setters: [],
		execute: function () {
			csOrgGatewaysModalCtrl.$inject = ['$rootScope', '$scope', 'close', 'selectedOrg', 'isSuperUser', 'Orgs', 'Sites', 'Devices', 'Modals', '_'];
			_export('default', csOrgGatewaysModalCtrl);
		}
	};
});

$__System.register('48', [], function (_export) {
    'use strict';

    function userConfirmPasswordCtrl($scope, close) {

        $scope.cancel = function () {
            $scope.current_password = null;
            close();
        };

        $scope.save = function () {
            $scope.currentPasswordSubmited = true;
            close($scope.current_password);
        };

        $scope.formEnter = function (event) {
            if (event.keyCode == 13 && $scope.currentPasswordForm.$valid) {
                $scope.save();
            }
        };
    }

    return {
        setters: [],
        execute: function () {
            userConfirmPasswordCtrl.$inject = ['$scope', 'close'];
            _export('default', userConfirmPasswordCtrl);
        }
    };
});

$__System.register('49', [], function (_export) {
    'use strict';

    function twoFactorAuthCtrl($scope, Users, user, close) {

        $scope.user = user;

        $scope.getCodeSuccess = false;
        $scope.validateSuccess = false;
        $scope.getCodeFail = false;
        $scope.validateFail = false;

        $scope.pending = false;

        var tempCell = user.authy_cell_no;
        setTimeout(function () {
            $("input[name='authyCellNum']").focus();
        }, 50);
        $scope.getMobileCode = function () {

            $scope.pending = true;
            $scope.getCodeFail = false;
            $scope.validateFail = false;
            Users.requestAuthyPhoneVerification($scope.user.authy_cell_no, $scope.user.authy_country_code).success(function (data) {

                $scope.getCodeSuccess = true;
                $scope.pending = false;
                setTimeout(function () {
                    $("input[name='authyCode']").focus();
                }, 50);
            }).error(function (err) {

                $scope.getCodeFail = true;
                $scope.pending = false;
            });
        };

        $scope.validateMobileCode = function () {

            $scope.pending = true;
            $scope.validateFail = false;
            Users.authyPhoneValidation($scope.user.authy_cell_no, $scope.authyCode, $scope.user.authy_country_code).success(function (data) {

                $scope.validateSuccess = true;
                $scope.user.validateSuccess = true;
                $scope.pending = false;

                setTimeout(function () {
                    close($scope.user);
                }, 1500);
            }).error(function (err) {

                $scope.validateFail = true;
                //go back to state 1
                $scope.authyCode = null;
                $scope.getCodeSuccess = false;
                $scope.pending = false;
            });
        };

        $scope.cancel = function () {
            $scope.user.authy_cell_no = tempCell;
            close();
        };

        $scope.save = function () {
            close($scope.user);
        };

        //need to load after DOM ready
        angular.element(document).ready(function () {
            //for blocking alpha letter input
            $("input").keydown(function (e) {
                // Allow: backspace, delete, tab, escape, enter
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: Ctrl+A, Command+A
                e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) ||
                // Allow: home, end, left, right, down, up
                e.keyCode >= 35 && e.keyCode <= 40) {
                    // let it happen, don't do anything
                    return;
                }
                // Ensure that it is a number and stop the keypress
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {

                    e.preventDefault();
                }
            });
        });

        $scope.formEnter = function (event, state) {

            if (event.keyCode == 13) {
                if (state == 1 && $scope.mobileForm.$valid) {
                    $scope.getMobileCode();
                } else if (state == 2 && $scope.validationForm.$valid) {
                    $scope.validateMobileCode();
                }
            }
        };
    }

    return {
        setters: [],
        execute: function () {
            twoFactorAuthCtrl.$inject = ['$scope', 'Users', 'user', 'close'];
            _export('default', twoFactorAuthCtrl);
        }
    };
});

$__System.register('4a', [], function (_export) {
	'use strict';

	function colorWheelModalCtrl($scope, $timeout, initialHue, close, onColorSelected) {

		var cWM = this;
		cWM.initialHue = initialHue || 0;
		cWM.selectedHue = cWM.initialHue;
		cWM.selectedColor = 'hsl(' + cWM.selectedHue + ', 100%, 50%)';
		cWM.selectedRgb = '255, 0, 0';
		cWM.close = close;
		cWM.onColorSelected = onColorSelected;
		cWM.isMouseDown = false;
		cWM.canvas = null;
		cWM.ctx = null;
		cWM.centerX = 150;
		cWM.centerY = 150;
		cWM.radius = 130;

		// Initialize color wheel after DOM is ready
		$timeout(function () {
			cWM.initColorWheel();
		}, 0);

		cWM.initColorWheel = function () {
			cWM.canvas = document.getElementById('color-wheel-canvas');
			if (!cWM.canvas) return;

			cWM.ctx = cWM.canvas.getContext('2d');
			cWM.drawColorWheel();
			cWM.updateSelectionFromHue(cWM.initialHue);

			// Add event listeners directly to canvas for better mouse handling
			cWM.canvas.addEventListener('mousedown', function (e) {
				cWM.onMouseDown(e);
				$scope.$apply();
			});

			cWM.canvas.addEventListener('mousemove', function (e) {
				if (cWM.isMouseDown) {
					cWM.onMouseMove(e);
					$scope.$apply();
				}
			});

			cWM.canvas.addEventListener('mouseup', function (e) {
				cWM.onMouseUp(e);
				$scope.$apply();
			});

			cWM.canvas.addEventListener('mouseleave', function (e) {
				cWM.onMouseUp(e);
				$scope.$apply();
			});
		};

		cWM.drawColorWheel = function () {
			if (!cWM.ctx) return;

			var imageData = cWM.ctx.createImageData(cWM.canvas.width, cWM.canvas.height);
			var data = imageData.data;

			for (var y = 0; y < cWM.canvas.height; y++) {
				for (var x = 0; x < cWM.canvas.width; x++) {
					var dx = x - cWM.centerX;
					var dy = y - cWM.centerY;
					var distance = Math.sqrt(dx * dx + dy * dy);
					var angle = Math.atan2(dy, dx);

					var index = (y * cWM.canvas.width + x) * 4;

					if (distance <= cWM.radius && distance >= cWM.radius - 40) {
						// Convert angle to hue (0-360)
						var hue = (angle + Math.PI) / (2 * Math.PI) * 360;
						if (hue < 0) hue += 360;

						// Convert HSL to RGB
						var rgb = cWM.hslToRgb(hue / 360, 1, 0.5);

						data[index] = rgb[0]; // R
						data[index + 1] = rgb[1]; // G
						data[index + 2] = rgb[2]; // B
						data[index + 3] = 255; // A
					} else {
							data[index] = 255; // R
							data[index + 1] = 255; // G
							data[index + 2] = 255; // B
							data[index + 3] = 0; // A (transparent)
						}
				}
			}

			cWM.ctx.putImageData(imageData, 0, 0);

			// Draw center circle (white/black gradient for brightness)
			var gradient = cWM.ctx.createRadialGradient(cWM.centerX, cWM.centerY, 0, cWM.centerX, cWM.centerY, cWM.radius - 40);
			gradient.addColorStop(0, 'white');
			gradient.addColorStop(1, 'rgba(0,0,0,0.3)');
			cWM.ctx.fillStyle = gradient;
			cWM.ctx.beginPath();
			cWM.ctx.arc(cWM.centerX, cWM.centerY, cWM.radius - 40, 0, Math.PI * 2);
			cWM.ctx.fill();
		};

		cWM.hslToRgb = function (h, s, l) {
			var r = undefined,
			    g = undefined,
			    b = undefined;
			if (s === 0) {
				r = g = b = l;
			} else {
				var hue2rgb = function hue2rgb(p, q, t) {
					if (t < 0) t += 1;
					if (t > 1) t -= 1;
					if (t < 1 / 6) return p + (q - p) * 6 * t;
					if (t < 1 / 2) return q;
					if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
					return p;
				};
				var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
				var p = 2 * l - q;
				r = hue2rgb(p, q, h + 1 / 3);
				g = hue2rgb(p, q, h);
				b = hue2rgb(p, q, h - 1 / 3);
			}
			return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
		};

		cWM.getMousePos = function (e) {
			var rect = cWM.canvas.getBoundingClientRect();
			return {
				x: e.clientX - rect.left,
				y: e.clientY - rect.top
			};
		};

		cWM.updateSelectionFromPosition = function (x, y) {
			var dx = x - cWM.centerX;
			var dy = y - cWM.centerY;
			var distance = Math.sqrt(dx * dx + dy * dy);

			if (distance <= cWM.radius && distance >= cWM.radius - 40) {
				var angle = Math.atan2(dy, dx);
				var hue = (angle + Math.PI) / (2 * Math.PI) * 360;
				if (hue < 0) hue += 360;

				cWM.selectedHue = Math.round(hue);
				cWM.updateColorDisplay();
			}
		};

		cWM.updateSelectionFromHue = function (hue) {
			cWM.selectedHue = Math.round(hue);
			cWM.updateColorDisplay();
		};

		cWM.updateColorDisplay = function () {
			var rgb = cWM.hslToRgb(cWM.selectedHue / 360, 1, 0.5);
			cWM.selectedColor = 'rgb(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ')';
			cWM.selectedRgb = rgb[0] + ', ' + rgb[1] + ', ' + rgb[2];

			// Redraw to show selection indicator
			cWM.drawColorWheel();
			cWM.drawSelectionIndicator();
		};

		cWM.drawSelectionIndicator = function () {
			if (!cWM.ctx) return;

			var angle = cWM.selectedHue / 360 * 2 * Math.PI - Math.PI;
			var indicatorRadius = cWM.radius - 20;
			var x = cWM.centerX + Math.cos(angle) * indicatorRadius;
			var y = cWM.centerY + Math.sin(angle) * indicatorRadius;

			// Draw selection circle
			cWM.ctx.strokeStyle = '#000';
			cWM.ctx.lineWidth = 3;
			cWM.ctx.beginPath();
			cWM.ctx.arc(x, y, 8, 0, Math.PI * 2);
			cWM.ctx.stroke();

			cWM.ctx.strokeStyle = '#fff';
			cWM.ctx.lineWidth = 2;
			cWM.ctx.beginPath();
			cWM.ctx.arc(x, y, 8, 0, Math.PI * 2);
			cWM.ctx.stroke();
		};

		cWM.onMouseDown = function (e) {
			cWM.isMouseDown = true;
			var pos = cWM.getMousePos(e);
			cWM.updateSelectionFromPosition(pos.x, pos.y);
		};

		cWM.onMouseMove = function (e) {
			if (cWM.isMouseDown) {
				var pos = cWM.getMousePos(e);
				cWM.updateSelectionFromPosition(pos.x, pos.y);
			}
		};

		cWM.onMouseUp = function (e) {
			cWM.isMouseDown = false;
		};

		cWM.apply = function () {
			if (cWM.onColorSelected) {
				cWM.onColorSelected(cWM.selectedHue);
			}
			cWM.close(true);
		};
	}

	return {
		setters: [],
		execute: function () {
			colorWheelModalCtrl.$inject = ['$scope', '$timeout', 'initialHue', 'close', 'onColorSelected'];
			_export('default', colorWheelModalCtrl);
		}
	};
});

$__System.registerDynamic("4b", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\t<div class=\"rename-area-modal\">\n\t\t<h1>{{title}}</h1>\n\t\t<input type=\"text\" placeholder=\"Enter name here\" ng-model=\"selectedObject.name\"  />\n\t\t<p class=\"error\" ng-show=\"error\" translate=\"area.unique\">Must be unique</p>\n    <p class=\"error\" ng-show=\"uniqueNameError\" translate=\"common.uniqueName\">Must be unique</p>\n\t\t<button class=\"btn black cancel\" ng-click=\"close(false)\" translate=\"common.cancel\">Cancel</button>\n\t\t<button class=\"btn blue rename\" ng-click=\"save(true)\" ng-disabled=\"!selectedObject.name.length\">{{action}}</button>\n\t</div>\n</div>";
});
$__System.registerDynamic("4c", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\n\t<div class=\"fixture-health-container\">\n\n\t\t<div class=\"error\">\n\t\t\t<h3 translate=\"zones.faultDetected\">Fault Detected In This Zone</h3>\n\t\t</div>\n\n\t\t<footer>\n\t\t\t<button class=\"btn cancel\" ng-click=\"cancel()\" translate=\"common.cancel\" ng-disabled = \"pending\">Cancel</button>\n\t\t\t<button class=\"btn confirm orange\" ng-click=\"clearNotification()\" translate=\"common.confirm\" ng-disabled = \"pending\">Confirm</button>\n\t\t</footer>\n\t</div>\n</div>";
});
$__System.registerDynamic("4d", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\t<div class=\"welcome-setting-modal\">\n\t\t<header>\n\t\t\t<li ng-if=\"!setting\"></li>\n\t\t\t<h1>{{!setting ? '':'Security Settings'}}</h1>\n\t\t</header>\n\t\t<section class=\"welcome-message\" ng-show=\"!setting\">\n\t\t\t<p>Welcome to Lightcloud</p>\n\t\t\t<p style=\"text-align: left; font-size: 1.2em;\">Lightcloud™ is designed from the ground up to be the most intuitive, advanced and secure networked control system that delivers the energy savings you need today and long into the future. Combine this with complimentary lighting design services and your energy bill doesn’t stand a chance.</p>\n\t\t</section>\n\t\t<section class=\"welcome-setting\" ng-show=\"setting\">\n\t\t\t<h1>{{title}}</h1>\n\t\t\t<p>The following security questions are for your protection. Lightcloud support will ask you for the answer to your security question and pin when you call us to make changes to your account. We use this information to verify your identity.</p>\n\t\t\t<form name=\"userForm\" novalidate>\n\t\t\t\t<div class=\"input-field full\">\n\t\t\t\t\t<label>Security Question</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Example: 'What's the model of your first car?'\" name=\"securityQuestion\" ng-model=\"user.user_security_question\" ng-minlength=\"1\" ng-maxlength=\"250\" ng-required=\"true\" focused />\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"input-field full\">\n\t\t\t\t\t<label>Answer</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Example: 'McLaren P1'\" name=\"securityAnswer\" ng-model=\"user.user_security_answer\" ng-minlength=\"1\" ng-maxlength=\"250\" ng-required=\"true\" focused />\n\t\t\t\t</div> \n\n\t\t\t\t<div class=\"input-field full\">\n\t\t\t\t\t<label>Security Pin</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"minimum 4 characters\" name=\"securityPin\" ng-model=\"user.user_security_pin_code\" ng-minlength=\"4\" ng-maxlength=\"32\" ng-required=\"true\" focused />\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"input-field full\">\n\t\t\t\t\t<label>Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"please input your password again\" name=\"securityPin\" ng-model=\"user.password_logged_in_user\" ng-maxlength=\"32\" ng-required=\"true\" focused />\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"input-field full\" ng-if=\"errorMsg\">\n\t\t\t\t\t<label style=\"color: red;\">For your security, please provide all of the information requested above.</label>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class=\"input-field full\" ng-if=\"passwordError\">\n\t\t\t\t\t<label style=\"color: red;\">The password you entered is incorrect.</label>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</section>\n\t\t<footer>\n\t\t\t<button class=\"btn blue explore right\" ng-click=\"changeSetting()\" ng-if=\"!setting\">Continue</button>\n\t\t\t<button class=\"btn blue save right\" ng-click=\"save(user, userForm);submitted=true\" ng-disabled=\"pending\" ng-if=\"setting\" ng-bind=\"pending ? 'Working' : 'Save'\"></button>\n\t\t</footer>\n\t</div>\n</div>";
});
$__System.registerDynamic("4e", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\t<div class=\"scene-select-modal\">\n\n\t\t<header>\n\t\t\t<h1 translate=\"scenes.selectScene\" >Select Scene</h1>\n\t\t\t<button class=\"btn-x close\" ng-click=\"close()\"></button>\n\t\t</header>\n\n\t\t<div class=\"scene-selector\">\n\n\t\t\t<ul>\n\t\t\t\t<li class=\"scene-check\" ng-class=\"{'disabled' : modalPending && !scene.pending || sceneApplied}\" ng-repeat=\"scene in scenes\" ng-click=\"modalPending ? null : activate(scene);\">\n\t\t\t\t\t<span class=\"name\">\n\t\t\t\t\t\t{{scene.name}}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"demand\">\n\t\t\t\t\t\t<span class=\"grey\" translate=\"scenes.demand\">Demand: </span>\n\t\t\t\t\t\t<span>{{scene.placeholder == 'on' ? scene.maxDemand : scene.demand}}W</span>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"fa fa-circle-o check\"></span>\n\t\t\t\n\t\t\t\t</li>\n\t\t\t</ul>\n\n\n\t\t</div>\n\t\t<footer>\n\t\t\t<button ng-disabled=\"modalPending\" class=\"btn cancel\" ng-click=\"close()\" translate=\"common.cancel\">Cancel</button>\n\t\t\t<div class=\"manage\"><i class=\"cog\"></i><span translate=\"scenes.manageScenes\" ng-click=\"close()\" ui-sref=\"Scenes({siteId:siteId, userSelectedFilter: null, leftMenuSpecialContext: 'scenes'})\">Manage Scenes</span></div>\n\t\t</footer>\n\t</div>\n</div>";
});
$__System.registerDynamic("4f", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-modal\">\n\t<button class=\"btn-x close\" ng-click=\"close()\"><span>close</span></button>\n\t<section class=\"center\">\n\t\t<header>\n\t\t\t<h1>{{org.id ? 'Edit Organization' : 'Create Organization'}}</h1>\n\t\t</header>\n\t\t<section class=\"form\">\n\t\t\t<cs-org-edit-form org=\"org\" on-org-delete=\"deleteOrg(org)\" on-org-update=\"updateOrg(org)\"></cs-org-edit-form>\n\t\t</section>\n\t</section>\n</div>";
});
$__System.registerDynamic("50", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-modal\">\n\t<button class=\"btn-x close\" ng-click=\"close()\"><span>close</span></button>\n\t<section class=\"center\">\n\t\t<header>\n\t\t\t<h1>Add Salesforce Case</h1>\n\t\t</header>\n\t\t<section class=\"form\">\n\t\t\t<form name=\"sfForm\" ng-submit=\"saveCase(case, sfForm)\" novalidate>\n\t\t\t\t<section class=\"title\">\n\t\t\t\t\t<h3>Contact details</h3>\n\t\t\t\t\t<input placeholder=\"First Name\" id=\"firstName\" maxlength=\"80\" ng-model=\"case.firstName\" name=\"firstName\" size=\"20\" type=\"text\" ng-required=\"submitted\" ng-disabled=\"pending\" focused/>\n\t\t\t\t\t<input placeholder=\"Last Name\" id=\"lastName\" maxlength=\"80\" ng-model=\"case.lastName\" name=\"firstName\" size=\"20\" type=\"text\" ng-required=\"submitted\" ng-disabled=\"pending\" focused/>\n\t\t\t\t\t<input placeholder=\"Email\" id=\"email\" maxlength=\"80\" ng-model=\"case.email\" name=\"email\" size=\"20\" type=\"email\" ng-required=\"submitted\" ng-disabled=\"pending\" focused/>\n\t\t\t\t\t<input placeholder=\"Phone\" id=\"phone\" maxlength=\"40\" ng-model=\"case.phone\" name=\"phone\" size=\"20\" type=\"tel\" ng-required=\"submitted\" ng-disabled=\"pending\" focused/>\n\t\t\t\t</section>\n\n\t\t\t\t<section class=\"description\">\n\t\t\t\t\t<h3>Case</h3>\n\t\t\t\t\t<input placeholder=\"Subject\" id=\"subject\" maxlength=\"80\" ng-model=\"case.subject\" name=\"subject\" size=\"20\" type=\"text\" ng-required=\"submitted\" ng-disabled=\"pending\" focused/>\n\t\t\t\t\t<div class=\"lc-select\">\n\t\t\t\t\t\t<select ng-model=\"case.status\" class=\"no-user-styles\" name=\"statusSelect\" ng-required=\"submitted\" ng-disabled=\"pending\">\n\t\t\t\t\t\t\t<option value=\"\" disabled selected>Please select a case status</option>\n\t\t\t\t\t\t\t<option value=\"new\" translate>New</option>\n\t\t\t\t\t\t\t<option value=\"in progress\">In Progress</option>\n\t\t\t\t\t\t\t<option value=\"waiting for end user\">Waiting for End User</option>\n\t\t\t\t\t\t\t<option value=\"closed\">Closed</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"error-msg\">\n\t\t\t\t\t\t<span class=\"error\" ng-show=\"sfForm.statusSelect.$invalid\">Please select a case status</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<textarea placeholder=\"Description\" ng-model=\"case.description\" name=\"description\" ng-required=\"submitted\"  ng-disabled=\"pending\" focused></textarea>\n\t\t\t\t\t<div class=\"error-msg\">\n\t\t\t\t\t\t<span class=\"error\" ng-show=\"sfForm.description.$invalid\">Please input case description</span>\n\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<button type=\"submit\" class=\"btn blue save\" ng-disabled=\"pending\" ng-bind=\"pending ? 'Saving' : 'Save'\" ng-click=\"submitted = true\"></button>\n\t\t\t</form>\n\t\t</section>\n\t</section>\n</div>\n";
});
$__System.registerDynamic("51", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-modal activity-log cs-modal-searchable\">\n\t<button class=\"btn-x close\" ng-click=\"close()\"><span>close</span></button>\n\t<section class=\"center\">\n\t\t<header>\n\t\t\t<h2 class=\"org-name\" id=\"topElementForScroll\">{{$root.currentOrg.name}}</h2>\n\t\t\t<h1>Activity Log</h1>\n\t\t</header>\n\t\t<section class=\"filter\">\n\t\t\t<div class=\"search\">\n\t\t\t\t<h3 class=\"gray\" translate=\"common.search\">Search</h3>\n\t\t\t\t<i class=\"fa fa-search\"></i>\n\t\t\t\t<input class=\"search-input\" type=\"search\" placeholder=\"Search Activity\" ng-model=\"activitySearch\">\n\t\t\t</div>\n\t\t\t<div class=\"filterBy\">\n\t\t\t\t<h3 class=\"gray inlineB left\">Filter By</h3>\n\t\t\t\t<h3 class=\"gray inlineB right clear-filter\" ng-show=\"filterByCategory\" ng-click=\"clearFilter()\">clear</h3>\n\t\t\t\t<div class=\"lc-select\">\n\t\t\t\t\t<select ng-model=\"filterByCategory\" ng-options=\"category for category in categories\" class=\"no-user-styles\"></select>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t</section>  \n\t\t<section class=\"notifications-log-list-parent\">\n\t\t\t<notifications-log-list heading=\"\" pending=\"ajaxPending\" messages=\"notificationMsgs\" filter-text=\"activitySearch\" filter-category=\"filterByCategory\"></notifications-log-list>\n\t\t</section>\n\t</section>\n\t<button class=\"btn-top\" ng-click=\"scrollToTop()\"><span>top</span></button>\n</div>";
});
$__System.registerDynamic("52", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-modal\">\n\t<button class=\"btn-x close\" ng-click=\"oSIM.close()\"><span>close</span></button>\n\t<section class=\"full\">\n\t\t<header class=\"main\">\n\t\t\t<h2 class=\"org-name\">{{$root.currentOrg.name}}</h2>\n\t\t\t<h1>Site Information</h1>\n\t\t</header>\n\t\t<section class=\"results\">\n            <h2 class=\"overview-heading cog light\">\n                <a class=\"cog\" href=\"\" ng-click=\"oSIM.getFreshOrgSites($root.currentOrg)\"><span class=\"SEdit\" translate=\"site.refreshSiteList\">Refresh Site List</span><i class=\"lc-refresh\" ng-class=\"{'pending': oSIM.pending}\"></i></a>\n                <span>{{sites.length == 1 ? '1 Site' : sites.length + ' sites'}}</span>\n            </h2>\n\n            <section class=\"sites\">\n\t\t        <div class=\"site\" id=\"site-{{site.id}}\" ng-repeat=\"site in oSIM.sites\" ng-class=\"{selected: (site.showGateways || site.showSite), 'is-blue': site.is_blue}\" ng-init=\"\">\n\t\t\t        <header ng-class=\"{panic: site.is_panic_mode}\">\n\t\t\t\t\t\t<div class=\"left\">\n\t\t\t\t\t\t\t<h1>{{site.id_string}}</h1>\n\t\t\t\t\t\t\t<p>{{site.address.address1}} {{site.address.address2? site.address.address2:''}} {{site.address.city ? site.address.city +', ':''}}{{site.address.state}} {{site.address.postal_code}}</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"right\">\n\t\t\t\t\t\t\t<button class=\"btn blue\" ng-if=\"site.is_blue\" ng-click=\"oSIM.discoverDevices(site.org_uuid)\">Sync devices</button>\n\t\t\t\t\t\t\t<button class=\"btn green show-gateways\" ng-if=\"!site.is_blue\" ng-disabled=\"site.gateways.length == 0\" ng-click=\"oSIM.toggleGateways(site)\" ng-class=\"{selected: site.showGateways}\">{{site.gateways.length > 0 ? 'Gateways' : 'No Gateways'}}</button>\n\t\t\t\t\t\t\t<button class=\"btn black\" ng-click=\"site.showSite = !site.showSite; site.showGateways = false;\" ng-class=\"{selected: site.showSite}\">Edit Site</button>\n\t\t\t\t\t\t\t<button class=\"btn blue\" ng-click=\"oSIM.close({path: 'Overview', params: {siteId:site.id, userSelectedFilter: null, leftMenuSpecialContext: 'overview'}})\">Go to Site</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!--hide this emergency mode for moment-->\n\n\t\t\t\t\t\t<!--<div class=\"panic\" ng-class=\"{extended: selected}\" ng-click=\"selected = true\" ng-mouseleave=\"selected=false\">-->\n\t\t\t\t\t\t\t<!--<span>{{site.is_panic_mode ? \"STOP\" : \"EMERGENCY\"}}</span>-->\n\t\t\t\t\t\t\t<!--<div class=\"confirm\" ng-if=\"selected\">-->\n\t\t\t\t\t\t\t\t<!--<p>{{site.is_panic_mode ? \"Are you sure emergency is dismissed\" : \"Are you sure to active Emergency Mode\"}}</p>-->\n\t\t\t\t\t\t\t\t<!--<button class=\"btn\" ng-disabled=\"site.ajaxPending || site.indicating\" ng-click=\"panicOperate(site)\">Confirm</button>-->\n\t\t\t\t\t\t\t<!--</div>-->\n\t\t\t\t\t\t<!--</div>-->\n\n\t\t\t\t\t\t<!--end of emergency mode-->\n\t\t\t\t    </header>\n\n\t\t\t\t    <div class=\"gateways\" ng-if=\"!site.is_blue && site.showGateways\">\n\n\t    \t\t\t    <section class=\"main-left\">\n\t\t\t\t\t\t\t<h2 class=\"overview-heading white\"> \n\t\t\t\t\t\t       <span translate=\"customerService.gateways\">Gateways</span>\n\t\t\t\t\t\t    </h2>\n\t\t\t\t\t\t\t<div class=\"white-pill-item no-icon cs-gateway\" ng-class=\"{showDetails: gateway.showDetails}\" ng-repeat=\"gateway in site.gateways\">\n\t\t\t            \t\t<div class=\"gateway-box\">\n\t\t\t\t\t\t\t\t\t<div class=\"device-icon lc-gateway\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"network caps\"  ng-if=\"gateway\" ng-class=\"{'atnt': gateway.gateway_type == 1, 'verizon': gateway.gateway_type == 2}\">\n\t\t\t\t\t\t\t\t\t\t\t{{::gateway.gateway_type == 0 ? 'Wifi' : gateway.gateway_type == 1 ? 'AT&T' : gateway.gateway_type == 2 ? 'Verizon' : 'Unknown'}}\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<!-- Alt bridge badge\n\t\t\t\t\t\t\t\t\t\t<span class=\"network bridge caps\" ng-if=\"gateway.lte_bridge_connection\" translate=\"site.bridged\">Bridged</span>\n\t\t\t\t\t\t\t\t\t\t</span>-->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"gateway-text\">\n\t\t\t\t\t\t\t\t\t\t<h1>{{gateway.id_string === '' ? 'Gateway '+gateway.id : gateway.id_string}}</h1>\n\t\t\t\t\t\t\t\t\t\t<h2 class=\"mac\">{{gateway.mac_addr | cleanMac}}</h2>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"gateway-text\">\n\t\t\t\t\t\t\t\t\t\t<h1>v {{gateway.gateway_version}}</h1>\n\t\t\t\t\t\t\t          <h2 class=\"mac\">\n\t\t\t\t\t\t\t            <span>{{gateway.ip_address}}</span>\n\t\t\t\t\t\t\t            <span>&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t            <span>Add Devices Mode: <span ng-class=\"{green: gateway.setup_mode, red: !gateway.setup_mode}\">{{gateway.setup_mode ? 'On':'Off'}}</span></span>\n\t\t\t\t\t\t\t\t\t\t<span ng-if=\"gateway.lte_bridge_connection\">\n\t\t\t\t\t\t\t\t\t\t\t<span>&nbsp;|&nbsp;</span>\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"green\">LTE Bridge</span>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t          </h2>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class=\"btn green indicate\" ng-class=\"{indicating: site.indicating}\" ng-disabled=\"site.ajaxPending || site.indicating\" ng-click=\"oSIM.indicate(site)\" translate=\"common.indicate\">Indicate</button>\n\t\t\t\t\t\t\t\t<button class=\"btn btn-edit edit cs-gateway\" ng-if=\"oSIM.isOrgAdmin\" ng-click=\"gateway.showDetails = !gateway.showDetails;\" translate=\"customerService.details\">Details</button>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<cs-gateway-details gateway=\"gateway\" is-super-user=\"oSIM.isSuperUser\" parent-site=\"site\" on-update=\"oSIM.getFreshOrgSites($root.currentOrg,site.id)\" ng-if=\"gateway.showDetails\"></cs-gateway-details>\n\t\t\t\t\t\t   \t</div>\n\t\t\t\t\t\t</section>\n\n\t\t\t\t\t\t<section class=\"main-right\">\n\t\t\t\t\t\t\t<h2 class=\"overview-heading white\"> \n\t\t\t\t\t           <span translate=\"common.location\">Location</span>\n\t\t\t\t\t        </h2>\n\t\t\t\t\t\t\t<google-map lat=\"site.locality.lat\" lng=\"site.locality.lng\"></google-map>\n\t\t\t\t\t\t</section>\n\n\t\t\t        </div>\n\n\t\t\t        <div class=\"edit-site\" ng-if=\"site.showSite\">\n\t\t\t\t\t\t<section class=\"main-body\">\n\t\t\t\t\t\t\t<cs-site-edit-form site=\"site\" orgs-list=\"oSIM.allOrgsKeyedByName\" on-site-delete=\"oSIM.deleteSite(site,transition)\" on-site-update=\"oSIM.updateSite(site,transition)\"></cs-site-edit-form>\n\t\t\t\t\t\t</section>\n\t\t\t        </div>\n\t\t        </div>\t\n\t\t    </section>\n\t\t</section>\n\n\t\t<section class=\"results\" ng-if=\"oSIM.isOrgAdmin\">\n            <h2 class=\"overview-heading light left\">\n                <span>Connect to Blue</span>\n            </h2>\n\n\t\t    <!-- Lightcloud Blue Site Connection Section -->\n\t\t    <section class=\"blue-site-connection sites\" ng-if=\"!oSIM.currentOrg || !oSIM.currentOrg.blue_authenticated\">\n\t\t    \t<div class=\"site is-blue\" style=\"padding: 20px;\">\n\t\t\t        <form class=\"blue-connection-form\" ng-submit=\"oSIM.connectLightcloudBlue(oSIM.blueForm)\" novalidate>\n\t\t\t            <div class=\"form-group\">\n\t\t\t                <label for=\"blueEmail\">Email:</label>\n\t\t\t                <input type=\"email\" \n\t\t\t                       id=\"blueEmail\" \n\t\t\t                       ng-model=\"oSIM.blueForm.email\" \n\t\t\t                       placeholder=\"Enter your email address\"\n\t\t\t                       required \n\t\t\t                       ng-disabled=\"oSIM.blueConnecting\"\n\t\t\t                       ng-class=\"{'error': oSIM.blueError}\" />\n\t\t\t            </div>\n\t\t\t            <div class=\"form-group\">\n\t\t\t                <label for=\"bluePassword\">Password:</label>\n\t\t\t                <input type=\"password\" \n\t\t\t                       id=\"bluePassword\" \n\t\t\t                       ng-model=\"oSIM.blueForm.password\" \n\t\t\t                       placeholder=\"Enter your password\"\n\t\t\t                       required \n\t\t\t                       ng-disabled=\"oSIM.blueConnecting\"\n\t\t\t                       ng-class=\"{'error': oSIM.blueError}\" />\n\t\t\t            </div>\n\t\t\t            <div class=\"error-message\" ng-if=\"oSIM.blueError\" style=\"color: #d32f2f; font-size: 14px; margin-bottom: 15px; padding: 8px 12px; background-color: #ffebee; border-left: 4px solid #d32f2f; border-radius: 4px;\">\n\t\t\t                <i class=\"fa fa-exclamation-triangle\" style=\"margin-right: 8px;\"></i>{{oSIM.blueError}}\n\t\t\t            </div>\n\t\t\t            <div class=\"form-actions\">\n\t\t\t                <button type=\"submit\" \n\t\t\t                        class=\"btn blue\" \n\t\t\t                        ng-disabled=\"oSIM.blueConnecting || !oSIM.blueForm.email || !oSIM.blueForm.password\">\n\t\t\t                    <span ng-if=\"!oSIM.blueConnecting\">Connect Lightcloud Blue Site</span>\n\t\t\t                    <span ng-if=\"oSIM.blueConnecting\">Connecting...</span>\n\t\t\t                </button>\n\t\t\t            </div>\n\t\t\t        </form>\n\t\t\t    </div>\n\t\t    </section>\n\t\t    \n\t\t    <!-- Lightcloud Blue Logout Section -->\n\t\t    <section class=\"blue-site-connection sites\" ng-if=\"oSIM.currentOrg && oSIM.currentOrg.blue_authenticated\">\n\t\t    \t<div class=\"site is-blue\" style=\"padding: 20px;\">\n\t\t    \t\t<div class=\"blue-logout-section\">\n\t\t    \t\t\t<p style=\"margin-bottom: 15px;\">Connected to Lightcloud Blue</p>\n\t\t    \t\t\t<div class=\"error-message\" ng-if=\"oSIM.blueError\" style=\"color: #d32f2f; font-size: 14px; margin-bottom: 15px; padding: 8px 12px; background-color: #ffebee; border-left: 4px solid #d32f2f; border-radius: 4px;\">\n\t\t\t                <i class=\"fa fa-exclamation-triangle\" style=\"margin-right: 8px;\"></i>{{oSIM.blueError}}\n\t\t\t            </div>\n\t\t    \t\t\t<button class=\"btn blue\" \n\t\t    \t\t\t        ng-click=\"oSIM.logoutLightcloudBlue()\" \n\t\t    \t\t\t        ng-disabled=\"oSIM.blueConnecting\">\n\t\t    \t\t\t\t<span ng-if=\"!oSIM.blueConnecting\">Logout</span>\n\t\t    \t\t\t\t<span ng-if=\"oSIM.blueConnecting\">Logging out...</span>\n\t\t    \t\t\t</button>\n\t\t    \t\t</div>\n\t\t    \t</div>\n\t\t    </section>\n\t\t</section>\n\t</section>\n</div>\n";
});
$__System.registerDynamic("53", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-modal cs-modal-searchable\">\n\t<button class=\"btn-x close\" ng-click=\"close()\"><span>close</span></button>\n\t<section class=\"full\">\n\t\t<header class=\"main\">\n\t\t\t<!-- <h2 class=\"org-name\">{{$root.currentOrg.name}}</h2> -->\n\t\t\t<h1>Unassigned Gateways</h1>\n\t\t</header>\n\t\t<section class=\"filter\">\n\t\t\t<div class=\"search\">\n\t\t\t\t<h3 class=\"gray\" translate=\"common.search\">Search</h3>\n\t\t\t\t<i class=\"fa fa-search\"></i>\n\t\t\t\t<input class=\"search-input\" type=\"search\" placeholder=\"Search Gateways\" ng-model=\"gatewaySearch\">\n\t\t\t</div>\n\t\t\t<div class=\"filterBy\">\n\t\t\t\t<h3 class=\"gray inlineB left\">Filter By</h3>\n\t\t\t\t<h3 class=\"gray inlineB right clear-filter\" ng-show=\"filterByCategory\" ng-click=\"clearFilter()\">clear</h3>\n\t\t\t\t<div class=\"lc-select\">\n\t\t\t\t\t<select ng-model=\"filterByCategory\" ng-options=\"category for category in categories\" class=\"no-user-styles\"></select>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t</section> \t\t\n\t\t<section class=\"results\">\n            <h2 class=\"overview-heading cog light\">\n                <a class=\"cog\" href=\"\" ng-click=\"getFreshGateways()\">\n                \t<span class=\"SEdit\" translate=\"site.refreshGatewayList\">Refresh Gateway List</span><i class=\"lc-refresh\" ng-class=\"{'pending': pending}\"></i>\n                </a>\n                <span>{{gatewayList.length == 1 ? '1 Gateway' : gatewayList.length + ' gateways'}}</span>\n            </h2>\n            <section class=\"sites\">\n\t\t        <div class=\"site\" ng-repeat=\"gateway in gatewayList | filter:gatewaySearch | filter: {gateway_version: filterByCategory}\" ng-class=\"{selected: gateway.showDetails || gateway.wizard.step, getewayUpdating: gateway.gateway_health == 4}\">\n\t\t\t        <header>\n\t\t\t\t\t\t<cs-gateway-box gateway=\"gateway\"></cs-gateway-box>\n\t\t\t\t        <div class=\"right\">\n\t\t\t\t        \t<button class=\"btn green\" ng-disabled=\"true\" ng-click=\"indicate(gateway)\">Indicate</button>\n\t\t\t\t        \t<button class=\"btn show-gateways\" ng-click=\"gateway.showDetails = !gateway.showDetails; gateway.wizard = null;\" ng-class=\"{selected: gateway.showDetails}\">Details</button>\n\t\t\t\t        \t<button class=\"btn blue\" ng-click=\"toggleCommission(gateway);\" ng-class=\"{selected: gateway.wizard.step}\">Commissioning</button>\n\t\t\t\t        </div>\n\t\t\t\t    </header>\n\n\t\t\t\t    <div class=\"gateways\" ng-if=\"gateway.showDetails\">\n\t\t\t\t\t\t<section class=\"main-body\">\n\t\t\t\t\t\t\t<h2 class=\"overview-heading white\"> \n\t\t\t\t\t\t       <span translate=\"customerService.gateways\">Gateway Details</span>\n\t\t\t\t\t\t    </h2>\n\t\t\t\t\t\t\t<cs-gateway-details gateway=\"gateway\" is-super-user=\"isSuperUser\" on-update=\"updateGateway(updatedGateway);\"></cs-gateway-details>\n\t\t\t\t\t\t</section>\n\t\t\t        </div>\n\n\t\t\t        <gateway-assign-wizard ng-if=\"gateway.wizard.step\" current-org=\"currentOrg\" gateway=\"gateway\" gateway-list=\"gatewayList\"></gateway-assign-wizard>\n\t\t        </div>\n\t\t    </section>\n\t\t</section>\n\t</section>\n</div>";
});
$__System.registerDynamic("54", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\t<div class=\"grey-modal manager\">\n\t\t<header>\n\t\t\t<div class=\"zone-icon\"></div>\n\t\t\t<h1 class=\"title\">Rates as of {{rateObject.humanMonth}} {{rateObject.as_of_year}}</h1>\n\t\t\t<button class=\"btn-x close\" ng-click=\"close()\" ng-disabled=\"pending\"></button>\n\t\t</header>\n\n\t\t<section class=\"zone-details customer-service-wrapper \">\n\t\t\t\n\t\t\t<div class=\"outer-scope\">\n\t\t\t\t<div class=\"customer-service-orgs\">\n\t\t\t\t\t<div class=\"headings\">\n\t\t\t\t\t\t<div class=\"col1 col\">Device Name</div>\n\t\t\t\t\t\t<div class=\"col\">Monthly Rate</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p class=\"loading-spinner-label\" ng-hide=\"rateObject\" translate=\"common.loadingEllipsis\">Loading...</p>\n\n\t\t\t\t\t<form ng-if=\"rateObject\" name=\"ratesForm\">\n\t\t\t\t\t<!-- no changing the date for now - ask jason -->\n\t\t\t\t\t<!--<div class=\"\">\n\t\t\t\t\t\t\t<h2 ng-if=\"!editMode\">{{rateObject.humanMonth}}</h2>\n\t\t\t\t\t\t\t<select ng-if=\"editMode\" ng-model=\"rateObject.as_of_month\">\n\t\t\t\t\t\t\t\t<option value=\"1\">Jan</option>\n\t\t\t\t\t\t\t\t<option value=\"2\">Feb</option>\n\t\t\t\t\t\t\t\t<option value=\"3\">Mar</option>\n\t\t\t\t\t\t\t\t<option value=\"4\">Apr</option>\n\t\t\t\t\t\t\t\t<option value=\"5\">May</option>\n\t\t\t\t\t\t\t\t<option value=\"6\">Jun</option>\n\t\t\t\t\t\t\t\t<option value=\"7\">Jul</option>\n\t\t\t\t\t\t\t\t<option value=\"8\">Aug</option>\n\t\t\t\t\t\t\t\t<option value=\"9\">Sep</option>\n\t\t\t\t\t\t\t\t<option value=\"10\">Oct</option>\n\t\t\t\t\t\t\t\t<option value=\"11\">Nov</option>\n\t\t\t\t\t\t\t\t<option value=\"12\">Dec</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"\">\n\t\t\t\t\t\t\t<input ng-if=\"editMode\" type=\"text\" placeholder=\"As of Year\" ng-model=\"rateObject.as_of_year\" class=\"\">\n\t\t\t\t\t\t\t<h2 ng-if=\"!editMode\">{{rateObject.as_of_year}}</h2>\n\t\t\t\t\t\t</div> -->\n\t\t\t\t\t\t\n\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"orgs-list global-form\" ng-repeat=\"(key, rate) in rateObject.rates\">\n\t\t\t\t\t\t\t<div class=\"org rates\">\n\t\t\t\t\t\t\t\t<div class=\"col1 col\">\n\t\t\t\t\t\t\t\t\t<span>{{rate.deviceName}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col\">\n\t\t\t\t\t\t\t\t\t<span>$</span>\n\t\t\t\t\t\t\t\t\t<input ng-if=\"rateObject.editMode\" type=\"number\" placeholder=\"Rate\" ng-model=\"rate.monthly_rate\" class=\"\">\n\t\t\t\t\t\t\t\t\t<span ng-if=\"!rateObject.editMode\">{{rate.monthly_rate}}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<button class=\"btn red cancel\" ng-click=\"close()\" ng-disabled=\"pending\">Cancel</button>\n\t\t\t<button class=\"btn right blue indicate\" ng-disabled=\"pending || rateObject.editMode\" ng-click=\"rateObject.editMode = !rateObject.editMode\">Edit Rates</button>\n\t\t\t<button type=\"button\" ng-click=\"save()\" class=\"btn blue save\" ng-disabled=\"pending || ratesForm.$pristine\" ng-bind=\"pending ? 'Working' : 'Save'\"></button>\n\t\t\t\n\n\n\t\t</section>\n\t</div>\n</div>";
});
$__System.registerDynamic("55", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n    <div class=\"fixture-health-container\">\n\n        <div class=\"item\">\n            <span>Please Input Your Current Password</span>\n        </div>\n\n        <div class=\"item\">\n            <form name=\"currentPasswordForm\" autocomplete=\"off\" autofocus>\n                <input type=\"password\" placeholder=\"Current Password\" name=\"current_password\" ng-model=\"current_password\" ng-maxlength=\"254\" ng-required=\"true\" minlength=\"1\" autocomplete=\"off\" ng-keyup=\"formEnter($event)\" ng-model-options=\"{ debounce: 1000 }\" autofocus />\n            </form>\n        </div>\n\n        <footer>\n            <button class=\"btn cancel\" ng-click=\"cancel()\" translate=\"common.cancel\">Cancel</button>\n            <button class=\"btn confirm orange\" ng-disabled=\"currentPasswordForm.$invalid\" ng-click=\"save()\">Confirm</button>\n        </footer>\n    </div>\n</div>";
});
$__System.registerDynamic("56", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n    <div class=\"fixture-health-container auth-info\" ng-class=\"{'auth-expand': getCodeSuccess && !validateSuccess}\">\n\n        <h4 translate=\"login.twoFactorAuth\">Two Factor Authentication</h4>\n\n        <div class=\"item\" ng-form name=\"mobileForm\">\n            <label translate=\"login.mobileNumberForAuth\">Mobile Number for Authentication</label>\n\n            <input type=\"tel\" ng-pattern=\"/^([0-9]( |-)?)?(\\(?[0-9]{3}\\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/\" placeholder=\"{{'login.mobileNumber' | translate}}\" name=\"authyCellNum\" ng-model=\"user.authy_cell_no\" ng-minlength=\"10\" ng-maxlength=\"20\" ng-required=\"true\" ng-disabled=\"getCodeSuccess || pending\"  required ng-model-options=\"{ debounce: 1000 }\" autofocus ng-keyup=\"formEnter($event,1)\"/>\n        </div>\n\n        <div class=\"item\" ng-show=\"getCodeSuccess || validateSuccess\" ng-form name=\"validationForm\">\n            <label translate=\"login.verificationCode\">Verification Code</label>\n            <input type=\"text\" placeholder=\"{{'login.verificationCode' | translate}}\" name=\"authyCode\" ng-model=\"authyCode\" ng-minlength=\"4\" ng-maxlength=\"4\" ng-required=\"true\"  ng-model-options=\"{ debounce: 1000 }\"  ng-keyup=\"formEnter($event,2)\" ng-disabled=\"validateSuccess || pending\"/>\n        </div>\n\n        <div class=\"item message\">\n            <span class=\"msg\" ng-show=\"getCodeSuccess && !validateSuccess && !validateFail\" translate=\"login.verificationCodeHasBeenSentToYourPhone\">Verification code has sent to your phone.</span>\n            <span class=\"msg\" ng-show=\"validateSuccess\" translate=\"login.thisMobileNumberHasBeenVerified\">This mobile number has been verified.</span>\n            <span class=\"error msg\" ng-show=\"getCodeFail\" translate=\"login.getVerificationCodeFailed\">Get verification code failed, please try again.</span>\n            <span class=\"error msg\" ng-show=\"validateFail\" translate=\"login.verifyPhoneNumberFailed\">Verify phone number failed, please try again.</span>\n        </div>\n\n        <footer ng-hide=\"validateSuccess\">\n            <button class=\"btn cancel\" ng-click=\"cancel()\" translate=\"common.cancel\" ng-disable=\"pending\">Cancel</button>\n            <button class=\"btn confirm orange\" ng-click=\"getMobileCode()\" ng-show=\"!(getCodeSuccess || validateSuccess)\" ng-disabled=\"pending || mobileForm.$invalid\" translate=\"login.getVerificationCode\">Get Verification Code</button>\n            <button class=\"btn confirm orange\" ng-click=\"validateMobileCode()\" ng-show=\"(getCodeSuccess && !validateSuccess)\" ng-disabled=\"pending || validationForm.$invalid\" translate=\"login.verifyPhoneNumber\">Verify Phone Number</button>\n            <button class=\"btn confirm orange\" ng-click=\"save()\" ng-show=\"validateSuccess\" ng-disabled=\"pending\">Done</button>\n        </footer>\n\n    </div>\n</div>";
});
$__System.registerDynamic("57", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"overlay\">\n\t<div class=\"color-wheel-modal\">\n\t\t<h1>Select Color</h1>\n\t\t<div class=\"color-wheel-container\">\n\t\t\t<canvas id=\"color-wheel-canvas\" width=\"300\" height=\"300\"></canvas>\n\t\t\t<div class=\"color-preview\" ng-style=\"{'background-color': cWM.selectedColor}\"></div>\n\t\t</div>\n\t\t<div class=\"color-info\">\n\t\t\t<div class=\"hue-value\">Hue: {{cWM.selectedHue}}°</div>\n\t\t\t<div class=\"rgb-value\">RGB: {{cWM.selectedRgb}}</div>\n\t\t</div>\n\t\t<button class=\"btn black cancel\" ng-click=\"cWM.close(false)\" translate=\"common.cancel\">Cancel</button>\n\t\t<button class=\"btn blue\" ng-click=\"cWM.apply()\" translate=\"common.apply\">Apply</button>\n\t</div>\n</div>\n\n";
});
$__System.register('58', ['12', '13', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '59', '5a', '4a', '4b', '4c', '4d', '4e', '4f'], function (_export) {
      var _createClass, _classCallCheck, renameModalCtrl, welcomeSettingModalCtrl, csOrgEditModalCtrl, csSalesforceCaseModalCtrl, csOrgActivityModalCtrl, csOrgSiteInfoModalCtrl, csOrgGatewaysModalCtrl, userConfirmPasswordModalCtrl, twoFactorAuthModalCtrl, csSalesforceCaseModalTmpl, csOrgActivityModalTmpl, csOrgSiteInfoModalTmpl, csOrgGatewaysModalTmpl, ratesModalTmpl, userConfirmPasswordModalTmpl, twoFactorAuthModalTmpl, colorWheelModalTmpl, overviewScenesModalCtrl, ratesModalCtrl, colorWheelModalCtrl, renameModalTmpl, zoneDismissAlertModalTmpl, welcomeSettingModalTmpl, overviewScenesModalTmpl, csOrgEditModalTmpl, modalControllers, modalTemplates, Modals;

      return {
            setters: [function (_2) {
                  _createClass = _2['default'];
            }, function (_3) {
                  _classCallCheck = _3['default'];
            }, function (_4) {
                  renameModalCtrl = _4['default'];
            }, function (_5) {
                  welcomeSettingModalCtrl = _5['default'];
            }, function (_7) {
                  csOrgEditModalCtrl = _7['default'];
            }, function (_8) {
                  csSalesforceCaseModalCtrl = _8['default'];
            }, function (_9) {
                  csOrgActivityModalCtrl = _9['default'];
            }, function (_10) {
                  csOrgSiteInfoModalCtrl = _10['default'];
            }, function (_11) {
                  csOrgGatewaysModalCtrl = _11['default'];
            }, function (_12) {
                  userConfirmPasswordModalCtrl = _12['default'];
            }, function (_13) {
                  twoFactorAuthModalCtrl = _13['default'];
            }, function (_14) {
                  csSalesforceCaseModalTmpl = _14['default'];
            }, function (_15) {
                  csOrgActivityModalTmpl = _15['default'];
            }, function (_16) {
                  csOrgSiteInfoModalTmpl = _16['default'];
            }, function (_17) {
                  csOrgGatewaysModalTmpl = _17['default'];
            }, function (_18) {
                  ratesModalTmpl = _18['default'];
            }, function (_19) {
                  userConfirmPasswordModalTmpl = _19['default'];
            }, function (_20) {
                  twoFactorAuthModalTmpl = _20['default'];
            }, function (_21) {
                  colorWheelModalTmpl = _21['default'];
            }, function (_6) {
                  overviewScenesModalCtrl = _6['default'];
            }, function (_a) {
                  ratesModalCtrl = _a['default'];
            }, function (_a2) {
                  colorWheelModalCtrl = _a2['default'];
            }, function (_b) {
                  renameModalTmpl = _b['default'];
            }, function (_c) {
                  zoneDismissAlertModalTmpl = _c['default'];
            }, function (_d) {
                  welcomeSettingModalTmpl = _d['default'];
            }, function (_e) {
                  overviewScenesModalTmpl = _e['default'];
            }, function (_f) {
                  csOrgEditModalTmpl = _f['default'];
            }],
            execute: function () {
                  //Modal Controllers
                  'use strict';

                  //Modal Templates
                  modalControllers = {
                        renameModalCtrl: renameModalCtrl,
                        welcomeSettingModalCtrl: welcomeSettingModalCtrl,
                        overviewScenesModalCtrl: overviewScenesModalCtrl,
                        csOrgEditModalCtrl: csOrgEditModalCtrl,
                        csSalesforceCaseModalCtrl: csSalesforceCaseModalCtrl,
                        csOrgActivityModalCtrl: csOrgActivityModalCtrl,
                        csOrgSiteInfoModalCtrl: csOrgSiteInfoModalCtrl,
                        csOrgGatewaysModalCtrl: csOrgGatewaysModalCtrl,
                        ratesModalCtrl: ratesModalCtrl,
                        userConfirmPasswordModalCtrl: userConfirmPasswordModalCtrl,
                        twoFactorAuthModalCtrl: twoFactorAuthModalCtrl,
                        colorWheelModalCtrl: colorWheelModalCtrl
                  };
                  modalTemplates = {
                        renameModalTmpl: renameModalTmpl,
                        zoneDismissAlertModalTmpl: zoneDismissAlertModalTmpl,
                        welcomeSettingModalTmpl: welcomeSettingModalTmpl,
                        overviewScenesModalTmpl: overviewScenesModalTmpl,
                        csOrgEditModalTmpl: csOrgEditModalTmpl,
                        csSalesforceCaseModalTmpl: csSalesforceCaseModalTmpl,
                        csOrgActivityModalTmpl: csOrgActivityModalTmpl,
                        csOrgSiteInfoModalTmpl: csOrgSiteInfoModalTmpl,
                        csOrgGatewaysModalTmpl: csOrgGatewaysModalTmpl,
                        ratesModalTmpl: ratesModalTmpl,
                        userConfirmPasswordModalTmpl: userConfirmPasswordModalTmpl,
                        twoFactorAuthModalTmpl: twoFactorAuthModalTmpl,
                        colorWheelModalTmpl: colorWheelModalTmpl
                  };

                  Modals = (function () {
                        function Modals($rootScope, $q, $compile, $document, ModalService) {
                              _classCallCheck(this, Modals);

                              this.$rootScope = $rootScope;
                              this.$q = $q;
                              this.$compile = $compile;
                              this.$document = $document;
                              this.ModalService = ModalService;
                        }

                        _createClass(Modals, [{
                              key: 'closeModals',
                              value: function closeModals() {
                                    this.ModalService.closeModals();
                              }
                        }, {
                              key: 'openLoad',
                              value: function openLoad(message) {
                                    this.$rootScope.$broadcast('event:openLoadingModal', message);
                              }
                        }, {
                              key: 'closeLoad',
                              value: function closeLoad(message, success) {
                                    this.$rootScope.$broadcast('event:closeLoadingModal', message, success);
                              }
                        }, {
                              key: 'showMulti',
                              value: function showMulti(allItems, title, cssClass, max) {
                                    var deferred = this.$q.defer();

                                    // Add to dom once, can remove from all components now - hotreloaded breaks this for now
                                    //

                                    if (angular.element(document).find('.lc-modal-msm').length === 0) {
                                          var node = angular.element('<multi-select-modal class="lc-modal-msm"></multi-select-modal>');

                                          angular.element(document.body).append(node);
                                          this.$compile(node)(this.$rootScope);
                                    }
                                    //                                                  allItems, title, class
                                    this.$rootScope.$broadcast('event:showMultiSelectModal', deferred, allItems, title, cssClass, max);

                                    return deferred.promise;
                              }
                        }, {
                              key: 'showDeps',
                              value: function showDeps(rejectLabel, resolveLabel, confirmMsg, dependencies) {
                                    var deferred = this.$q.defer();

                                    //
                                    // Add to dom once, can remove from all components now
                                    //
                                    if (angular.element(document).find('.lc-modal-dpm').length === 0) {
                                          var node = angular.element('<dependencies-modal class="lc-modal-dpm"></dependencies-modal>');

                                          angular.element(document.body).append(node);
                                          this.$compile(node)(this.$rootScope);
                                    }

                                    this.$rootScope.$broadcast('event:showDependenciesModal', deferred, rejectLabel, resolveLabel, confirmMsg, dependencies);

                                    return deferred.promise;
                              }
                        }, {
                              key: 'confirm',
                              value: function confirm(scope, cancel, action, string) {
                                    var _this = this;

                                    //
                                    //
                                    // @refactor Can we get rid of jquery here ?
                                    //
                                    //
                                    return this.$q(function (resolve, reject) {
                                          var $confModal = $(document.createElement('confirmation-modal'));
                                          _this.$compile($confModal)(scope);
                                          $('.modal-overlay').html($confModal);

                                          var deferred = _this.$q.defer();
                                          var promise = deferred.promise;

                                          _this.$rootScope.$broadcast('event:showConfirmModal', cancel, action, string, deferred);

                                          promise.then(function () {
                                                resolve(true);
                                          })['catch'](function (e) {
                                                reject();
                                          });
                                    });
                              }
                        }, {
                              key: 'showModal',
                              value: function showModal(legacyObj) {
                                    var modalTmplName = (legacyObj.template || legacyObj.name) + 'ModalTmpl';
                                    var modalCtrlName = (legacyObj.controller || legacyObj.name) + 'ModalCtrl';

                                    var newModalObj = {
                                          template: modalTemplates[modalTmplName],
                                          controller: modalControllers[modalCtrlName],
                                          inputs: _.extend({ existingNames: [] }, legacyObj.inputs)
                                    };

                                    if (legacyObj.controllerAs) {
                                          _.extend(newModalObj, { controllerAs: legacyObj.controllerAs });
                                    }

                                    //
                                    //
                                    // @refactor Can we get rid of jquery here ?
                                    //
                                    //

                                    return this.ModalService.showModal(newModalObj).then(function (modal) {
                                          $(modal.element).appendTo('body').fadeIn();
                                          return modal.close;
                                    });
                              }
                        }]);

                        return Modals;
                  })();

                  Modals.$inject = ['$rootScope', '$q', '$compile', '$document', 'ModalService'];

                  _export('default', Modals);
            }
      };
});

$__System.register('5b', ['3', '58'], function (_export) {
  'use strict';

  //import './modals.scss';
  //import './_select-modal.scss!sass';
  //import './_select-modal.scss';
  //import './_select-modal.scss';

  //Migrate old directives from legacy to here
  var angular, modalsService, modalsNewModule;
  return {
    setters: [function (_) {
      angular = _['default'];
    }, function (_2) {
      modalsService = _2['default'];
    }],
    execute: function () {
      modalsNewModule = angular.module('modals-new', []).service('Modals', modalsService);

      _export('default', modalsNewModule);
    }
  };
});

(function() {
var define = $__System.amdDefine;
(function(global, factory) {
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = global.document ? factory(global, true) : function(w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }
      return factory(w);
    };
  } else {
    factory(global);
  }
}(typeof window !== "undefined" ? window : this, function(window, noGlobal) {
  var arr = [];
  var document = window.document;
  var slice = arr.slice;
  var concat = arr.concat;
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var support = {};
  var version = "2.2.3",
      jQuery = function(selector, context) {
        return new jQuery.fn.init(selector, context);
      },
      rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      rmsPrefix = /^-ms-/,
      rdashAlpha = /-([\da-z])/gi,
      fcamelCase = function(all, letter) {
        return letter.toUpperCase();
      };
  jQuery.fn = jQuery.prototype = {
    jquery: version,
    constructor: jQuery,
    selector: "",
    length: 0,
    toArray: function() {
      return slice.call(this);
    },
    get: function(num) {
      return num != null ? (num < 0 ? this[num + this.length] : this[num]) : slice.call(this);
    },
    pushStack: function(elems) {
      var ret = jQuery.merge(this.constructor(), elems);
      ret.prevObject = this;
      ret.context = this.context;
      return ret;
    },
    each: function(callback) {
      return jQuery.each(this, callback);
    },
    map: function(callback) {
      return this.pushStack(jQuery.map(this, function(elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function() {
      return this.pushStack(slice.apply(this, arguments));
    },
    first: function() {
      return this.eq(0);
    },
    last: function() {
      return this.eq(-1);
    },
    eq: function(i) {
      var len = this.length,
          j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function() {
      return this.prevObject || this.constructor();
    },
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };
  jQuery.extend = jQuery.fn.extend = function() {
    var options,
        name,
        src,
        copy,
        copyIsArray,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[i] || {};
      i++;
    }
    if (typeof target !== "object" && !jQuery.isFunction(target)) {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      if ((options = arguments[i]) != null) {
        for (name in options) {
          src = target[name];
          copy = options[name];
          if (target === copy) {
            continue;
          }
          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && jQuery.isArray(src) ? src : [];
            } else {
              clone = src && jQuery.isPlainObject(src) ? src : {};
            }
            target[name] = jQuery.extend(deep, clone, copy);
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  };
  jQuery.extend({
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    isReady: true,
    error: function(msg) {
      throw new Error(msg);
    },
    noop: function() {},
    isFunction: function(obj) {
      return jQuery.type(obj) === "function";
    },
    isArray: Array.isArray,
    isWindow: function(obj) {
      return obj != null && obj === obj.window;
    },
    isNumeric: function(obj) {
      var realStringObj = obj && obj.toString();
      return !jQuery.isArray(obj) && (realStringObj - parseFloat(realStringObj) + 1) >= 0;
    },
    isPlainObject: function(obj) {
      var key;
      if (jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) {
        return false;
      }
      if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype || {}, "isPrototypeOf")) {
        return false;
      }
      for (key in obj) {}
      return key === undefined || hasOwn.call(obj, key);
    },
    isEmptyObject: function(obj) {
      var name;
      for (name in obj) {
        return false;
      }
      return true;
    },
    type: function(obj) {
      if (obj == null) {
        return obj + "";
      }
      return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    },
    globalEval: function(code) {
      var script,
          indirect = eval;
      code = jQuery.trim(code);
      if (code) {
        if (code.indexOf("use strict") === 1) {
          script = document.createElement("script");
          script.text = code;
          document.head.appendChild(script).parentNode.removeChild(script);
        } else {
          indirect(code);
        }
      }
    },
    camelCase: function(string) {
      return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    },
    nodeName: function(elem, name) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    },
    each: function(obj, callback) {
      var length,
          i = 0;
      if (isArrayLike(obj)) {
        length = obj.length;
        for (; i < length; i++) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      } else {
        for (i in obj) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      }
      return obj;
    },
    trim: function(text) {
      return text == null ? "" : (text + "").replace(rtrim, "");
    },
    makeArray: function(arr, results) {
      var ret = results || [];
      if (arr != null) {
        if (isArrayLike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }
      return ret;
    },
    inArray: function(elem, arr, i) {
      return arr == null ? -1 : indexOf.call(arr, elem, i);
    },
    merge: function(first, second) {
      var len = +second.length,
          j = 0,
          i = first.length;
      for (; j < len; j++) {
        first[i++] = second[j];
      }
      first.length = i;
      return first;
    },
    grep: function(elems, callback, invert) {
      var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert;
      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);
        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }
      return matches;
    },
    map: function(elems, callback, arg) {
      var length,
          value,
          i = 0,
          ret = [];
      if (isArrayLike(elems)) {
        length = elems.length;
        for (; i < length; i++) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      }
      return concat.apply([], ret);
    },
    guid: 1,
    proxy: function(fn, context) {
      var tmp,
          args,
          proxy;
      if (typeof context === "string") {
        tmp = fn[context];
        context = fn;
        fn = tmp;
      }
      if (!jQuery.isFunction(fn)) {
        return undefined;
      }
      args = slice.call(arguments, 2);
      proxy = function() {
        return fn.apply(context || this, args.concat(slice.call(arguments)));
      };
      proxy.guid = fn.guid = fn.guid || jQuery.guid++;
      return proxy;
    },
    now: Date.now,
    support: support
  });
  if (typeof Symbol === "function") {
    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
  }
  jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  function isArrayLike(obj) {
    var length = !!obj && "length" in obj && obj.length,
        type = jQuery.type(obj);
    if (type === "function" || jQuery.isWindow(obj)) {
      return false;
    }
    return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
  }
  var Sizzle = (function(window) {
    var i,
        support,
        Expr,
        getText,
        isXML,
        tokenize,
        compile,
        select,
        outermostContext,
        sortInput,
        hasDuplicate,
        setDocument,
        document,
        docElem,
        documentIsHTML,
        rbuggyQSA,
        rbuggyMatches,
        matches,
        contains,
        expando = "sizzle" + 1 * new Date(),
        preferredDoc = window.document,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        sortOrder = function(a, b) {
          if (a === b) {
            hasDuplicate = true;
          }
          return 0;
        },
        MAX_NEGATIVE = 1 << 31,
        hasOwn = ({}).hasOwnProperty,
        arr = [],
        pop = arr.pop,
        push_native = arr.push,
        push = arr.push,
        slice = arr.slice,
        indexOf = function(list, elem) {
          var i = 0,
              len = list.length;
          for (; i < len; i++) {
            if (list[i] === elem) {
              return i;
            }
          }
          return -1;
        },
        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        whitespace = "[\\x20\\t\\r\\n\\f]",
        identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + "*([*^$|!~]?=)" + whitespace + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
        pseudos = ":(" + identifier + ")(?:\\((" + "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + ".*" + ")\\)|)",
        rwhitespace = new RegExp(whitespace + "+", "g"),
        rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
        rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
        rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
        rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
        rpseudo = new RegExp(pseudos),
        ridentifier = new RegExp("^" + identifier + "$"),
        matchExpr = {
          "ID": new RegExp("^#(" + identifier + ")"),
          "CLASS": new RegExp("^\\.(" + identifier + ")"),
          "TAG": new RegExp("^(" + identifier + "|[*])"),
          "ATTR": new RegExp("^" + attributes),
          "PSEUDO": new RegExp("^" + pseudos),
          "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
          "bool": new RegExp("^(?:" + booleans + ")$", "i"),
          "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        },
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,
        rnative = /^[^{]+\{\s*\[native \w/,
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        rsibling = /[+~]/,
        rescape = /'|\\/g,
        runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
        funescape = function(_, escaped, escapedWhitespace) {
          var high = "0x" + escaped - 0x10000;
          return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        },
        unloadHandler = function() {
          setDocument();
        };
    try {
      push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);
      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {apply: arr.length ? function(target, els) {
          push_native.apply(target, slice.call(els));
        } : function(target, els) {
          var j = target.length,
              i = 0;
          while ((target[j++] = els[i++])) {}
          target.length = j - 1;
        }};
    }
    function Sizzle(selector, context, results, seed) {
      var m,
          i,
          elem,
          nid,
          nidselect,
          match,
          groups,
          newSelector,
          newContext = context && context.ownerDocument,
          nodeType = context ? context.nodeType : 9;
      results = results || [];
      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      }
      if (!seed) {
        if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
          setDocument(context);
        }
        context = context || document;
        if (documentIsHTML) {
          if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
            if ((m = match[1])) {
              if (nodeType === 9) {
                if ((elem = context.getElementById(m))) {
                  if (elem.id === m) {
                    results.push(elem);
                    return results;
                  }
                } else {
                  return results;
                }
              } else {
                if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                  results.push(elem);
                  return results;
                }
              }
            } else if (match[2]) {
              push.apply(results, context.getElementsByTagName(selector));
              return results;
            } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
              push.apply(results, context.getElementsByClassName(m));
              return results;
            }
          }
          if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
            if (nodeType !== 1) {
              newContext = context;
              newSelector = selector;
            } else if (context.nodeName.toLowerCase() !== "object") {
              if ((nid = context.getAttribute("id"))) {
                nid = nid.replace(rescape, "\\$&");
              } else {
                context.setAttribute("id", (nid = expando));
              }
              groups = tokenize(selector);
              i = groups.length;
              nidselect = ridentifier.test(nid) ? "#" + nid : "[id='" + nid + "']";
              while (i--) {
                groups[i] = nidselect + " " + toSelector(groups[i]);
              }
              newSelector = groups.join(",");
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
            }
            if (newSelector) {
              try {
                push.apply(results, newContext.querySelectorAll(newSelector));
                return results;
              } catch (qsaError) {} finally {
                if (nid === expando) {
                  context.removeAttribute("id");
                }
              }
            }
          }
        }
      }
      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }
    function createCache() {
      var keys = [];
      function cache(key, value) {
        if (keys.push(key + " ") > Expr.cacheLength) {
          delete cache[keys.shift()];
        }
        return (cache[key + " "] = value);
      }
      return cache;
    }
    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }
    function assert(fn) {
      var div = document.createElement("div");
      try {
        return !!fn(div);
      } catch (e) {
        return false;
      } finally {
        if (div.parentNode) {
          div.parentNode.removeChild(div);
        }
        div = null;
      }
    }
    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
          i = arr.length;
      while (i--) {
        Expr.attrHandle[arr[i]] = handler;
      }
    }
    function siblingCheck(a, b) {
      var cur = b && a,
          diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
      if (diff) {
        return diff;
      }
      if (cur) {
        while ((cur = cur.nextSibling)) {
          if (cur === b) {
            return -1;
          }
        }
      }
      return a ? 1 : -1;
    }
    function createInputPseudo(type) {
      return function(elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }
    function createButtonPseudo(type) {
      return function(elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }
    function createPositionalPseudo(fn) {
      return markFunction(function(argument) {
        argument = +argument;
        return markFunction(function(seed, matches) {
          var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length;
          while (i--) {
            if (seed[(j = matchIndexes[i])]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }
    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    support = Sizzle.support = {};
    isXML = Sizzle.isXML = function(elem) {
      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
      return documentElement ? documentElement.nodeName !== "HTML" : false;
    };
    setDocument = Sizzle.setDocument = function(node) {
      var hasCompare,
          parent,
          doc = node ? node.ownerDocument || node : preferredDoc;
      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      }
      document = doc;
      docElem = document.documentElement;
      documentIsHTML = !isXML(document);
      if ((parent = document.defaultView) && parent.top !== parent) {
        if (parent.addEventListener) {
          parent.addEventListener("unload", unloadHandler, false);
        } else if (parent.attachEvent) {
          parent.attachEvent("onunload", unloadHandler);
        }
      }
      support.attributes = assert(function(div) {
        div.className = "i";
        return !div.getAttribute("className");
      });
      support.getElementsByTagName = assert(function(div) {
        div.appendChild(document.createComment(""));
        return !div.getElementsByTagName("*").length;
      });
      support.getElementsByClassName = rnative.test(document.getElementsByClassName);
      support.getById = assert(function(div) {
        docElem.appendChild(div).id = expando;
        return !document.getElementsByName || !document.getElementsByName(expando).length;
      });
      if (support.getById) {
        Expr.find["ID"] = function(id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var m = context.getElementById(id);
            return m ? [m] : [];
          }
        };
        Expr.filter["ID"] = function(id) {
          var attrId = id.replace(runescape, funescape);
          return function(elem) {
            return elem.getAttribute("id") === attrId;
          };
        };
      } else {
        delete Expr.find["ID"];
        Expr.filter["ID"] = function(id) {
          var attrId = id.replace(runescape, funescape);
          return function(elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        };
      }
      Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag);
        } else if (support.qsa) {
          return context.querySelectorAll(tag);
        }
      } : function(tag, context) {
        var elem,
            tmp = [],
            i = 0,
            results = context.getElementsByTagName(tag);
        if (tag === "*") {
          while ((elem = results[i++])) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }
          return tmp;
        }
        return results;
      };
      Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };
      rbuggyMatches = [];
      rbuggyQSA = [];
      if ((support.qsa = rnative.test(document.querySelectorAll))) {
        assert(function(div) {
          docElem.appendChild(div).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
          if (div.querySelectorAll("[msallowcapture^='']").length) {
            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
          }
          if (!div.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }
          if (!div.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }
          if (!div.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }
          if (!div.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }
        });
        assert(function(div) {
          var input = document.createElement("input");
          input.setAttribute("type", "hidden");
          div.appendChild(input).setAttribute("name", "D");
          if (div.querySelectorAll("[name=d]").length) {
            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
          }
          if (!div.querySelectorAll(":enabled").length) {
            rbuggyQSA.push(":enabled", ":disabled");
          }
          div.querySelectorAll("*,:x");
          rbuggyQSA.push(",.*:");
        });
      }
      if ((support.matchesSelector = rnative.test((matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)))) {
        assert(function(div) {
          support.disconnectedMatch = matches.call(div, "div");
          matches.call(div, "[s!='']:x");
          rbuggyMatches.push("!=", pseudos);
        });
      }
      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
      hasCompare = rnative.test(docElem.compareDocumentPosition);
      contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
        var adown = a.nodeType === 9 ? a.documentElement : a,
            bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function(a, b) {
        if (b) {
          while ((b = b.parentNode)) {
            if (b === a) {
              return true;
            }
          }
        }
        return false;
      };
      sortOrder = hasCompare ? function(a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) {
          return compare;
        }
        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
        if (compare & 1 || (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
          if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
            return -1;
          }
          if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
            return 1;
          }
          return sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0;
        }
        return compare & 4 ? -1 : 1;
      } : function(a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var cur,
            i = 0,
            aup = a.parentNode,
            bup = b.parentNode,
            ap = [a],
            bp = [b];
        if (!aup || !bup) {
          return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0;
        } else if (aup === bup) {
          return siblingCheck(a, b);
        }
        cur = a;
        while ((cur = cur.parentNode)) {
          ap.unshift(cur);
        }
        cur = b;
        while ((cur = cur.parentNode)) {
          bp.unshift(cur);
        }
        while (ap[i] === bp[i]) {
          i++;
        }
        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
      };
      return document;
    };
    Sizzle.matches = function(expr, elements) {
      return Sizzle(expr, null, null, elements);
    };
    Sizzle.matchesSelector = function(elem, expr) {
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      }
      expr = expr.replace(rattributeQuotes, "='$1']");
      if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr);
          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {}
      }
      return Sizzle(expr, document, null, [elem]).length > 0;
    };
    Sizzle.contains = function(context, elem) {
      if ((context.ownerDocument || context) !== document) {
        setDocument(context);
      }
      return contains(context, elem);
    };
    Sizzle.attr = function(elem, name) {
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      }
      var fn = Expr.attrHandle[name.toLowerCase()],
          val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };
    Sizzle.error = function(msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };
    Sizzle.uniqueSort = function(results) {
      var elem,
          duplicates = [],
          j = 0,
          i = 0;
      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);
      if (hasDuplicate) {
        while ((elem = results[i++])) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }
        while (j--) {
          results.splice(duplicates[j], 1);
        }
      }
      sortInput = null;
      return results;
    };
    getText = Sizzle.getText = function(elem) {
      var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;
      if (!nodeType) {
        while ((node = elem[i++])) {
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        if (typeof elem.textContent === "string") {
          return elem.textContent;
        } else {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }
      return ret;
    };
    Expr = Sizzle.selectors = {
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {dir: "parentNode"},
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {dir: "previousSibling"}
      },
      preFilter: {
        "ATTR": function(match) {
          match[1] = match[1].replace(runescape, funescape);
          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }
          return match.slice(0, 4);
        },
        "CHILD": function(match) {
          match[1] = match[1].toLowerCase();
          if (match[1].slice(0, 3) === "nth") {
            if (!match[3]) {
              Sizzle.error(match[0]);
            }
            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +((match[7] + match[8]) || match[3] === "odd");
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }
          return match;
        },
        "PSEUDO": function(match) {
          var excess,
              unquoted = !match[6] && match[2];
          if (matchExpr["CHILD"].test(match[0])) {
            return null;
          }
          if (match[3]) {
            match[2] = match[4] || match[5] || "";
          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          }
          return match.slice(0, 3);
        }
      },
      filter: {
        "TAG": function(nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function() {
            return true;
          } : function(elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        "CLASS": function(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        "ATTR": function(name, operator, check) {
          return function(elem) {
            var result = Sizzle.attr(elem, name);
            if (result == null) {
              return operator === "!=";
            }
            if (!operator) {
              return true;
            }
            result += "";
            return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
          };
        },
        "CHILD": function(type, what, argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
              forward = type.slice(-4) !== "last",
              ofType = what === "of-type";
          return first === 1 && last === 0 ? function(elem) {
            return !!elem.parentNode;
          } : function(elem, context, xml) {
            var cache,
                uniqueCache,
                outerCache,
                node,
                nodeIndex,
                start,
                dir = simple !== forward ? "nextSibling" : "previousSibling",
                parent = elem.parentNode,
                name = ofType && elem.nodeName.toLowerCase(),
                useCache = !xml && !ofType,
                diff = false;
            if (parent) {
              if (simple) {
                while (dir) {
                  node = elem;
                  while ((node = node[dir])) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  }
                  start = dir = type === "only" && !start && "nextSibling";
                }
                return true;
              }
              start = [forward ? parent.firstChild : parent.lastChild];
              if (forward && useCache) {
                node = parent;
                outerCache = node[expando] || (node[expando] = {});
                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                cache = uniqueCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = nodeIndex && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];
                while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    uniqueCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                }
              } else {
                if (useCache) {
                  node = elem;
                  outerCache = node[expando] || (node[expando] = {});
                  uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                  cache = uniqueCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex;
                }
                if (diff === false) {
                  while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                      if (useCache) {
                        outerCache = node[expando] || (node[expando] = {});
                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                        uniqueCache[type] = [dirruns, diff];
                      }
                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
              }
              diff -= last;
              return diff === first || (diff % first === 0 && diff / first >= 0);
            }
          };
        },
        "PSEUDO": function(pseudo, argument) {
          var args,
              fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
          if (fn[expando]) {
            return fn(argument);
          }
          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
              var idx,
                  matched = fn(seed, argument),
                  i = matched.length;
              while (i--) {
                idx = indexOf(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function(elem) {
              return fn(elem, 0, args);
            };
          }
          return fn;
        }
      },
      pseudos: {
        "not": markFunction(function(selector) {
          var input = [],
              results = [],
              matcher = compile(selector.replace(rtrim, "$1"));
          return matcher[expando] ? markFunction(function(seed, matches, context, xml) {
            var elem,
                unmatched = matcher(seed, null, xml, []),
                i = seed.length;
            while (i--) {
              if ((elem = unmatched[i])) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function(elem, context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results);
            input[0] = null;
            return !results.pop();
          };
        }),
        "has": markFunction(function(selector) {
          return function(elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        "contains": markFunction(function(text) {
          text = text.replace(runescape, funescape);
          return function(elem) {
            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
          };
        }),
        "lang": markFunction(function(lang) {
          if (!ridentifier.test(lang || "")) {
            Sizzle.error("unsupported lang: " + lang);
          }
          lang = lang.replace(runescape, funescape).toLowerCase();
          return function(elem) {
            var elemLang;
            do {
              if ((elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);
            return false;
          };
        }),
        "target": function(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        "root": function(elem) {
          return elem === docElem;
        },
        "focus": function(elem) {
          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        "enabled": function(elem) {
          return elem.disabled === false;
        },
        "disabled": function(elem) {
          return elem.disabled === true;
        },
        "checked": function(elem) {
          var nodeName = elem.nodeName.toLowerCase();
          return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
        },
        "selected": function(elem) {
          if (elem.parentNode) {
            elem.parentNode.selectedIndex;
          }
          return elem.selected === true;
        },
        "empty": function(elem) {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }
          return true;
        },
        "parent": function(elem) {
          return !Expr.pseudos["empty"](elem);
        },
        "header": function(elem) {
          return rheader.test(elem.nodeName);
        },
        "input": function(elem) {
          return rinputs.test(elem.nodeName);
        },
        "button": function(elem) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === "button" || name === "button";
        },
        "text": function(elem) {
          var attr;
          return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        "first": createPositionalPseudo(function() {
          return [0];
        }),
        "last": createPositionalPseudo(function(matchIndexes, length) {
          return [length - 1];
        }),
        "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        "even": createPositionalPseudo(function(matchIndexes, length) {
          var i = 0;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "odd": createPositionalPseudo(function(matchIndexes, length) {
          var i = 1;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; --i >= 0; ) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; ++i < length; ) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        })
      }
    };
    Expr.pseudos["nth"] = Expr.pseudos["eq"];
    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }
    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    }
    function setFilters() {}
    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();
    tokenize = Sizzle.tokenize = function(selector, parseOnly) {
      var matched,
          match,
          tokens,
          type,
          soFar,
          groups,
          preFilters,
          cached = tokenCache[selector + " "];
      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }
      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;
      while (soFar) {
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            soFar = soFar.slice(match[0].length) || soFar;
          }
          groups.push((tokens = []));
        }
        matched = false;
        if ((match = rcombinators.exec(soFar))) {
          matched = match.shift();
          tokens.push({
            value: matched,
            type: match[0].replace(rtrim, " ")
          });
          soFar = soFar.slice(matched.length);
        }
        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }
        if (!matched) {
          break;
        }
      }
      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
    };
    function toSelector(tokens) {
      var i = 0,
          len = tokens.length,
          selector = "";
      for (; i < len; i++) {
        selector += tokens[i].value;
      }
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
          checkNonElements = base && dir === "parentNode",
          doneName = done++;
      return combinator.first ? function(elem, context, xml) {
        while ((elem = elem[dir])) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
      } : function(elem, context, xml) {
        var oldCache,
            uniqueCache,
            outerCache,
            newCache = [dirruns, doneName];
        if (xml) {
          while ((elem = elem[dir])) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while ((elem = elem[dir])) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});
              uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
              if ((oldCache = uniqueCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                return (newCache[2] = oldCache[2]);
              } else {
                uniqueCache[dir] = newCache;
                if ((newCache[2] = matcher(elem, context, xml))) {
                  return true;
                }
              }
            }
          }
        }
      };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1 ? function(elem, context, xml) {
        var i = matchers.length;
        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }
        return true;
      } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0,
          len = contexts.length;
      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;
      for (; i < len; i++) {
        if ((elem = unmatched[i])) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);
            if (mapped) {
              map.push(i);
            }
          }
        }
      }
      return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }
      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }
      return markFunction(function(seed, results, context, xml) {
        var temp,
            i,
            elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
            matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        }
        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml);
          i = temp.length;
          while (i--) {
            if ((elem = temp[i])) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }
        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              temp = [];
              i = matcherOut.length;
              while (i--) {
                if ((elem = matcherOut[i])) {
                  temp.push((matcherIn[i] = elem));
                }
              }
              postFinder(null, (matcherOut = []), temp, xml);
            }
            i = matcherOut.length;
            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          }
        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }
    function matcherFromTokens(tokens) {
      var checkContext,
          matcher,
          j,
          len = tokens.length,
          leadingRelative = Expr.relative[tokens[0].type],
          implicitRelative = leadingRelative || Expr.relative[" "],
          i = leadingRelative ? 1 : 0,
          matchContext = addCombinator(function(elem) {
            return elem === checkContext;
          }, implicitRelative, true),
          matchAnyContext = addCombinator(function(elem) {
            return indexOf(checkContext, elem) > -1;
          }, implicitRelative, true),
          matchers = [function(elem, context, xml) {
            var ret = (!leadingRelative && (xml || context !== outermostContext)) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
            checkContext = null;
            return ret;
          }];
      for (; i < len; i++) {
        if ((matcher = Expr.relative[tokens[i].type])) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
          if (matcher[expando]) {
            j = ++i;
            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }
            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({value: tokens[i - 2].type === " " ? "*" : ""})).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens((tokens = tokens.slice(j))), j < len && toSelector(tokens));
          }
          matchers.push(matcher);
        }
      }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function(seed, context, xml, results, outermost) {
            var elem,
                j,
                matcher,
                matchedCount = 0,
                i = "0",
                unmatched = seed && [],
                setMatched = [],
                contextBackup = outermostContext,
                elems = seed || byElement && Expr.find["TAG"]("*", outermost),
                dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                len = elems.length;
            if (outermost) {
              outermostContext = context === document || context || outermost;
            }
            for (; i !== len && (elem = elems[i]) != null; i++) {
              if (byElement && elem) {
                j = 0;
                if (!context && elem.ownerDocument !== document) {
                  setDocument(elem);
                  xml = !documentIsHTML;
                }
                while ((matcher = elementMatchers[j++])) {
                  if (matcher(elem, context || document, xml)) {
                    results.push(elem);
                    break;
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                }
              }
              if (bySet) {
                if ((elem = !matcher && elem)) {
                  matchedCount--;
                }
                if (seed) {
                  unmatched.push(elem);
                }
              }
            }
            matchedCount += i;
            if (bySet && i !== matchedCount) {
              j = 0;
              while ((matcher = setMatchers[j++])) {
                matcher(unmatched, setMatched, context, xml);
              }
              if (seed) {
                if (matchedCount > 0) {
                  while (i--) {
                    if (!(unmatched[i] || setMatched[i])) {
                      setMatched[i] = pop.call(results);
                    }
                  }
                }
                setMatched = condense(setMatched);
              }
              push.apply(results, setMatched);
              if (outermost && !seed && setMatched.length > 0 && (matchedCount + setMatchers.length) > 1) {
                Sizzle.uniqueSort(results);
              }
            }
            if (outermost) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }
            return unmatched;
          };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    compile = Sizzle.compile = function(selector, match) {
      var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[selector + " "];
      if (!cached) {
        if (!match) {
          match = tokenize(selector);
        }
        i = match.length;
        while (i--) {
          cached = matcherFromTokens(match[i]);
          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        }
        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
        cached.selector = selector;
      }
      return cached;
    };
    select = Sizzle.select = function(selector, context, results, seed) {
      var i,
          tokens,
          token,
          type,
          find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize((selector = compiled.selector || selector));
      results = results || [];
      if (match.length === 1) {
        tokens = match[0] = match[0].slice(0);
        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
          if (!context) {
            return results;
          } else if (compiled) {
            context = context.parentNode;
          }
          selector = selector.slice(tokens.shift().value.length);
        }
        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
        while (i--) {
          token = tokens[i];
          if (Expr.relative[(type = token.type)]) {
            break;
          }
          if ((find = Expr.find[type])) {
            if ((seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context))) {
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);
              if (!selector) {
                push.apply(results, seed);
                return results;
              }
              break;
            }
          }
        }
      }
      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    };
    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
    support.detectDuplicates = !!hasDuplicate;
    setDocument();
    support.sortDetached = assert(function(div1) {
      return div1.compareDocumentPosition(document.createElement("div")) & 1;
    });
    if (!assert(function(div) {
      div.innerHTML = "<a href='#'></a>";
      return div.firstChild.getAttribute("href") === "#";
    })) {
      addHandle("type|href|height|width", function(elem, name, isXML) {
        if (!isXML) {
          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }
      });
    }
    if (!support.attributes || !assert(function(div) {
      div.innerHTML = "<input/>";
      div.firstChild.setAttribute("value", "");
      return div.firstChild.getAttribute("value") === "";
    })) {
      addHandle("value", function(elem, name, isXML) {
        if (!isXML && elem.nodeName.toLowerCase() === "input") {
          return elem.defaultValue;
        }
      });
    }
    if (!assert(function(div) {
      return div.getAttribute("disabled") == null;
    })) {
      addHandle(booleans, function(elem, name, isXML) {
        var val;
        if (!isXML) {
          return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        }
      });
    }
    return Sizzle;
  })(window);
  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;
  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  var dir = function(elem, dir, until) {
    var matched = [],
        truncate = until !== undefined;
    while ((elem = elem[dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        if (truncate && jQuery(elem).is(until)) {
          break;
        }
        matched.push(elem);
      }
    }
    return matched;
  };
  var siblings = function(n, elem) {
    var matched = [];
    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }
    return matched;
  };
  var rneedsContext = jQuery.expr.match.needsContext;
  var rsingleTag = (/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/);
  var risSimple = /^.[^:#\[\.,]*$/;
  function winnow(elements, qualifier, not) {
    if (jQuery.isFunction(qualifier)) {
      return jQuery.grep(elements, function(elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    }
    if (qualifier.nodeType) {
      return jQuery.grep(elements, function(elem) {
        return (elem === qualifier) !== not;
      });
    }
    if (typeof qualifier === "string") {
      if (risSimple.test(qualifier)) {
        return jQuery.filter(qualifier, elements, not);
      }
      qualifier = jQuery.filter(qualifier, elements);
    }
    return jQuery.grep(elements, function(elem) {
      return (indexOf.call(qualifier, elem) > -1) !== not;
    });
  }
  jQuery.filter = function(expr, elems, not) {
    var elem = elems[0];
    if (not) {
      expr = ":not(" + expr + ")";
    }
    return elems.length === 1 && elem.nodeType === 1 ? jQuery.find.matchesSelector(elem, expr) ? [elem] : [] : jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
      return elem.nodeType === 1;
    }));
  };
  jQuery.fn.extend({
    find: function(selector) {
      var i,
          len = this.length,
          ret = [],
          self = this;
      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function() {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }
      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      }
      ret = this.pushStack(len > 1 ? jQuery.unique(ret) : ret);
      ret.selector = this.selector ? this.selector + " " + selector : selector;
      return ret;
    },
    filter: function(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function(selector) {
      return !!winnow(this, typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  });
  var rootjQuery,
      rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      init = jQuery.fn.init = function(selector, context, root) {
        var match,
            elem;
        if (!selector) {
          return this;
        }
        root = root || rootjQuery;
        if (typeof selector === "string") {
          if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
            match = [null, selector, null];
          } else {
            match = rquickExpr.exec(selector);
          }
          if (match && (match[1] || !context)) {
            if (match[1]) {
              context = context instanceof jQuery ? context[0] : context;
              jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
              if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                for (match in context) {
                  if (jQuery.isFunction(this[match])) {
                    this[match](context[match]);
                  } else {
                    this.attr(match, context[match]);
                  }
                }
              }
              return this;
            } else {
              elem = document.getElementById(match[2]);
              if (elem && elem.parentNode) {
                this.length = 1;
                this[0] = elem;
              }
              this.context = document;
              this.selector = selector;
              return this;
            }
          } else if (!context || context.jquery) {
            return (context || root).find(selector);
          } else {
            return this.constructor(context).find(selector);
          }
        } else if (selector.nodeType) {
          this.context = this[0] = selector;
          this.length = 1;
          return this;
        } else if (jQuery.isFunction(selector)) {
          return root.ready !== undefined ? root.ready(selector) : selector(jQuery);
        }
        if (selector.selector !== undefined) {
          this.selector = selector.selector;
          this.context = selector.context;
        }
        return jQuery.makeArray(selector, this);
      };
  init.prototype = jQuery.fn;
  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
      guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
      };
  jQuery.fn.extend({
    has: function(target) {
      var targets = jQuery(target, this),
          l = targets.length;
      return this.filter(function() {
        var i = 0;
        for (; i < l; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function(selectors, context) {
      var cur,
          i = 0,
          l = this.length,
          matched = [],
          pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? jQuery(selectors, context || this.context) : 0;
      for (; i < l; i++) {
        for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
          if (cur.nodeType < 11 && (pos ? pos.index(cur) > -1 : cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
            matched.push(cur);
            break;
          }
        }
      }
      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
    },
    index: function(elem) {
      if (!elem) {
        return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
      }
      if (typeof elem === "string") {
        return indexOf.call(jQuery(elem), this[0]);
      }
      return indexOf.call(this, elem.jquery ? elem[0] : elem);
    },
    add: function(selector, context) {
      return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });
  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1) {}
    return cur;
  }
  jQuery.each({
    parent: function(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function(elem) {
      return dir(elem, "parentNode");
    },
    parentsUntil: function(elem, i, until) {
      return dir(elem, "parentNode", until);
    },
    next: function(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function(elem) {
      return dir(elem, "nextSibling");
    },
    prevAll: function(elem) {
      return dir(elem, "previousSibling");
    },
    nextUntil: function(elem, i, until) {
      return dir(elem, "nextSibling", until);
    },
    prevUntil: function(elem, i, until) {
      return dir(elem, "previousSibling", until);
    },
    siblings: function(elem) {
      return siblings((elem.parentNode || {}).firstChild, elem);
    },
    children: function(elem) {
      return siblings(elem.firstChild);
    },
    contents: function(elem) {
      return elem.contentDocument || jQuery.merge([], elem.childNodes);
    }
  }, function(name, fn) {
    jQuery.fn[name] = function(until, selector) {
      var matched = jQuery.map(this, fn, until);
      if (name.slice(-5) !== "Until") {
        selector = until;
      }
      if (selector && typeof selector === "string") {
        matched = jQuery.filter(selector, matched);
      }
      if (this.length > 1) {
        if (!guaranteedUnique[name]) {
          jQuery.uniqueSort(matched);
        }
        if (rparentsprev.test(name)) {
          matched.reverse();
        }
      }
      return this.pushStack(matched);
    };
  });
  var rnotwhite = (/\S+/g);
  function createOptions(options) {
    var object = {};
    jQuery.each(options.match(rnotwhite) || [], function(_, flag) {
      object[flag] = true;
    });
    return object;
  }
  jQuery.Callbacks = function(options) {
    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
    var firing,
        memory,
        fired,
        locked,
        list = [],
        queue = [],
        firingIndex = -1,
        fire = function() {
          locked = options.once;
          fired = firing = true;
          for (; queue.length; firingIndex = -1) {
            memory = queue.shift();
            while (++firingIndex < list.length) {
              if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                firingIndex = list.length;
                memory = false;
              }
            }
          }
          if (!options.memory) {
            memory = false;
          }
          firing = false;
          if (locked) {
            if (memory) {
              list = [];
            } else {
              list = "";
            }
          }
        },
        self = {
          add: function() {
            if (list) {
              if (memory && !firing) {
                firingIndex = list.length - 1;
                queue.push(memory);
              }
              (function add(args) {
                jQuery.each(args, function(_, arg) {
                  if (jQuery.isFunction(arg)) {
                    if (!options.unique || !self.has(arg)) {
                      list.push(arg);
                    }
                  } else if (arg && arg.length && jQuery.type(arg) !== "string") {
                    add(arg);
                  }
                });
              })(arguments);
              if (memory && !firing) {
                fire();
              }
            }
            return this;
          },
          remove: function() {
            jQuery.each(arguments, function(_, arg) {
              var index;
              while ((index = jQuery.inArray(arg, list, index)) > -1) {
                list.splice(index, 1);
                if (index <= firingIndex) {
                  firingIndex--;
                }
              }
            });
            return this;
          },
          has: function(fn) {
            return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
          },
          empty: function() {
            if (list) {
              list = [];
            }
            return this;
          },
          disable: function() {
            locked = queue = [];
            list = memory = "";
            return this;
          },
          disabled: function() {
            return !list;
          },
          lock: function() {
            locked = queue = [];
            if (!memory) {
              list = memory = "";
            }
            return this;
          },
          locked: function() {
            return !!locked;
          },
          fireWith: function(context, args) {
            if (!locked) {
              args = args || [];
              args = [context, args.slice ? args.slice() : args];
              queue.push(args);
              if (!firing) {
                fire();
              }
            }
            return this;
          },
          fire: function() {
            self.fireWith(this, arguments);
            return this;
          },
          fired: function() {
            return !!fired;
          }
        };
    return self;
  };
  jQuery.extend({
    Deferred: function(func) {
      var tuples = [["resolve", "done", jQuery.Callbacks("once memory"), "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), "rejected"], ["notify", "progress", jQuery.Callbacks("memory")]],
          state = "pending",
          promise = {
            state: function() {
              return state;
            },
            always: function() {
              deferred.done(arguments).fail(arguments);
              return this;
            },
            then: function() {
              var fns = arguments;
              return jQuery.Deferred(function(newDefer) {
                jQuery.each(tuples, function(i, tuple) {
                  var fn = jQuery.isFunction(fns[i]) && fns[i];
                  deferred[tuple[1]](function() {
                    var returned = fn && fn.apply(this, arguments);
                    if (returned && jQuery.isFunction(returned.promise)) {
                      returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                    } else {
                      newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
                    }
                  });
                });
                fns = null;
              }).promise();
            },
            promise: function(obj) {
              return obj != null ? jQuery.extend(obj, promise) : promise;
            }
          },
          deferred = {};
      promise.pipe = promise.then;
      jQuery.each(tuples, function(i, tuple) {
        var list = tuple[2],
            stateString = tuple[3];
        promise[tuple[1]] = list.add;
        if (stateString) {
          list.add(function() {
            state = stateString;
          }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
        }
        deferred[tuple[0]] = function() {
          deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments);
          return this;
        };
        deferred[tuple[0] + "With"] = list.fireWith;
      });
      promise.promise(deferred);
      if (func) {
        func.call(deferred, deferred);
      }
      return deferred;
    },
    when: function(subordinate) {
      var i = 0,
          resolveValues = slice.call(arguments),
          length = resolveValues.length,
          remaining = length !== 1 || (subordinate && jQuery.isFunction(subordinate.promise)) ? length : 0,
          deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
          updateFunc = function(i, contexts, values) {
            return function(value) {
              contexts[i] = this;
              values[i] = arguments.length > 1 ? slice.call(arguments) : value;
              if (values === progressValues) {
                deferred.notifyWith(contexts, values);
              } else if (!(--remaining)) {
                deferred.resolveWith(contexts, values);
              }
            };
          },
          progressValues,
          progressContexts,
          resolveContexts;
      if (length > 1) {
        progressValues = new Array(length);
        progressContexts = new Array(length);
        resolveContexts = new Array(length);
        for (; i < length; i++) {
          if (resolveValues[i] && jQuery.isFunction(resolveValues[i].promise)) {
            resolveValues[i].promise().progress(updateFunc(i, progressContexts, progressValues)).done(updateFunc(i, resolveContexts, resolveValues)).fail(deferred.reject);
          } else {
            --remaining;
          }
        }
      }
      if (!remaining) {
        deferred.resolveWith(resolveContexts, resolveValues);
      }
      return deferred.promise();
    }
  });
  var readyList;
  jQuery.fn.ready = function(fn) {
    jQuery.ready.promise().done(fn);
    return this;
  };
  jQuery.extend({
    isReady: false,
    readyWait: 1,
    holdReady: function(hold) {
      if (hold) {
        jQuery.readyWait++;
      } else {
        jQuery.ready(true);
      }
    },
    ready: function(wait) {
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      }
      jQuery.isReady = true;
      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      }
      readyList.resolveWith(document, [jQuery]);
      if (jQuery.fn.triggerHandler) {
        jQuery(document).triggerHandler("ready");
        jQuery(document).off("ready");
      }
    }
  });
  function completed() {
    document.removeEventListener("DOMContentLoaded", completed);
    window.removeEventListener("load", completed);
    jQuery.ready();
  }
  jQuery.ready.promise = function(obj) {
    if (!readyList) {
      readyList = jQuery.Deferred();
      if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
        window.setTimeout(jQuery.ready);
      } else {
        document.addEventListener("DOMContentLoaded", completed);
        window.addEventListener("load", completed);
      }
    }
    return readyList.promise(obj);
  };
  jQuery.ready.promise();
  var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
        len = elems.length,
        bulk = key == null;
    if (jQuery.type(key) === "object") {
      chainable = true;
      for (i in key) {
        access(elems, fn, i, key[i], true, emptyGet, raw);
      }
    } else if (value !== undefined) {
      chainable = true;
      if (!jQuery.isFunction(value)) {
        raw = true;
      }
      if (bulk) {
        if (raw) {
          fn.call(elems, value);
          fn = null;
        } else {
          bulk = fn;
          fn = function(elem, key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }
      if (fn) {
        for (; i < len; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }
    return chainable ? elems : bulk ? fn.call(elems) : len ? fn(elems[0], key) : emptyGet;
  };
  var acceptData = function(owner) {
    return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
  };
  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }
  Data.uid = 1;
  Data.prototype = {
    register: function(owner, initial) {
      var value = initial || {};
      if (owner.nodeType) {
        owner[this.expando] = value;
      } else {
        Object.defineProperty(owner, this.expando, {
          value: value,
          writable: true,
          configurable: true
        });
      }
      return owner[this.expando];
    },
    cache: function(owner) {
      if (!acceptData(owner)) {
        return {};
      }
      var value = owner[this.expando];
      if (!value) {
        value = {};
        if (acceptData(owner)) {
          if (owner.nodeType) {
            owner[this.expando] = value;
          } else {
            Object.defineProperty(owner, this.expando, {
              value: value,
              configurable: true
            });
          }
        }
      }
      return value;
    },
    set: function(owner, data, value) {
      var prop,
          cache = this.cache(owner);
      if (typeof data === "string") {
        cache[data] = value;
      } else {
        for (prop in data) {
          cache[prop] = data[prop];
        }
      }
      return cache;
    },
    get: function(owner, key) {
      return key === undefined ? this.cache(owner) : owner[this.expando] && owner[this.expando][key];
    },
    access: function(owner, key, value) {
      var stored;
      if (key === undefined || ((key && typeof key === "string") && value === undefined)) {
        stored = this.get(owner, key);
        return stored !== undefined ? stored : this.get(owner, jQuery.camelCase(key));
      }
      this.set(owner, key, value);
      return value !== undefined ? value : key;
    },
    remove: function(owner, key) {
      var i,
          name,
          camel,
          cache = owner[this.expando];
      if (cache === undefined) {
        return;
      }
      if (key === undefined) {
        this.register(owner);
      } else {
        if (jQuery.isArray(key)) {
          name = key.concat(key.map(jQuery.camelCase));
        } else {
          camel = jQuery.camelCase(key);
          if (key in cache) {
            name = [key, camel];
          } else {
            name = camel;
            name = name in cache ? [name] : (name.match(rnotwhite) || []);
          }
        }
        i = name.length;
        while (i--) {
          delete cache[name[i]];
        }
      }
      if (key === undefined || jQuery.isEmptyObject(cache)) {
        if (owner.nodeType) {
          owner[this.expando] = undefined;
        } else {
          delete owner[this.expando];
        }
      }
    },
    hasData: function(owner) {
      var cache = owner[this.expando];
      return cache !== undefined && !jQuery.isEmptyObject(cache);
    }
  };
  var dataPriv = new Data();
  var dataUser = new Data();
  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      rmultiDash = /[A-Z]/g;
  function dataAttr(elem, key, data) {
    var name;
    if (data === undefined && elem.nodeType === 1) {
      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
      data = elem.getAttribute(name);
      if (typeof data === "string") {
        try {
          data = data === "true" ? true : data === "false" ? false : data === "null" ? null : +data + "" === data ? +data : rbrace.test(data) ? jQuery.parseJSON(data) : data;
        } catch (e) {}
        dataUser.set(elem, key, data);
      } else {
        data = undefined;
      }
    }
    return data;
  }
  jQuery.extend({
    hasData: function(elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function(elem, name, data) {
      return dataUser.access(elem, name, data);
    },
    removeData: function(elem, name) {
      dataUser.remove(elem, name);
    },
    _data: function(elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function(elem, name) {
      dataPriv.remove(elem, name);
    }
  });
  jQuery.fn.extend({
    data: function(key, value) {
      var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes;
      if (key === undefined) {
        if (this.length) {
          data = dataUser.get(elem);
          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
            i = attrs.length;
            while (i--) {
              if (attrs[i]) {
                name = attrs[i].name;
                if (name.indexOf("data-") === 0) {
                  name = jQuery.camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }
            dataPriv.set(elem, "hasDataAttrs", true);
          }
        }
        return data;
      }
      if (typeof key === "object") {
        return this.each(function() {
          dataUser.set(this, key);
        });
      }
      return access(this, function(value) {
        var data,
            camelKey;
        if (elem && value === undefined) {
          data = dataUser.get(elem, key) || dataUser.get(elem, key.replace(rmultiDash, "-$&").toLowerCase());
          if (data !== undefined) {
            return data;
          }
          camelKey = jQuery.camelCase(key);
          data = dataUser.get(elem, camelKey);
          if (data !== undefined) {
            return data;
          }
          data = dataAttr(elem, camelKey, undefined);
          if (data !== undefined) {
            return data;
          }
          return;
        }
        camelKey = jQuery.camelCase(key);
        this.each(function() {
          var data = dataUser.get(this, camelKey);
          dataUser.set(this, camelKey, value);
          if (key.indexOf("-") > -1 && data !== undefined) {
            dataUser.set(this, key, value);
          }
        });
      }, null, value, arguments.length > 1, null, true);
    },
    removeData: function(key) {
      return this.each(function() {
        dataUser.remove(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function(elem, type, data) {
      var queue;
      if (elem) {
        type = (type || "fx") + "queue";
        queue = dataPriv.get(elem, type);
        if (data) {
          if (!queue || jQuery.isArray(data)) {
            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }
        return queue || [];
      }
    },
    dequeue: function(elem, type) {
      type = type || "fx";
      var queue = jQuery.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = jQuery._queueHooks(elem, type),
          next = function() {
            jQuery.dequeue(elem, type);
          };
      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }
      if (fn) {
        if (type === "fx") {
          queue.unshift("inprogress");
        }
        delete hooks.stop;
        fn.call(elem, next, hooks);
      }
      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    _queueHooks: function(elem, type) {
      var key = type + "queueHooks";
      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {empty: jQuery.Callbacks("once memory").add(function() {
          dataPriv.remove(elem, [type + "queue", key]);
        })});
    }
  });
  jQuery.fn.extend({
    queue: function(type, data) {
      var setter = 2;
      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }
      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }
      return data === undefined ? this : this.each(function() {
        var queue = jQuery.queue(this, type, data);
        jQuery._queueHooks(this, type);
        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function(type) {
      return this.each(function() {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function(type) {
      return this.queue(type || "fx", []);
    },
    promise: function(type, obj) {
      var tmp,
          count = 1,
          defer = jQuery.Deferred(),
          elements = this,
          i = this.length,
          resolve = function() {
            if (!(--count)) {
              defer.resolveWith(elements, [elements]);
            }
          };
      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }
      type = type || "fx";
      while (i--) {
        tmp = dataPriv.get(elements[i], type + "queueHooks");
        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }
      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var isHidden = function(elem, el) {
    elem = el || elem;
    return jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument, elem);
  };
  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
        scale = 1,
        maxIterations = 20,
        currentValue = tween ? function() {
          return tween.cur();
        } : function() {
          return jQuery.css(elem, prop, "");
        },
        initial = currentValue(),
        unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
        initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
    if (initialInUnit && initialInUnit[3] !== unit) {
      unit = unit || initialInUnit[3];
      valueParts = valueParts || [];
      initialInUnit = +initial || 1;
      do {
        scale = scale || ".5";
        initialInUnit = initialInUnit / scale;
        jQuery.style(elem, prop, initialInUnit + unit);
      } while (scale !== (scale = currentValue() / initial) && scale !== 1 && --maxIterations);
    }
    if (valueParts) {
      initialInUnit = +initialInUnit || +initial || 0;
      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
      if (tween) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }
    return adjusted;
  }
  var rcheckableType = (/^(?:checkbox|radio)$/i);
  var rtagName = (/<([\w:-]+)/);
  var rscriptType = (/^$|\/(?:java|ecma)script/i);
  var wrapMap = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;
  function getAll(context, tag) {
    var ret = typeof context.getElementsByTagName !== "undefined" ? context.getElementsByTagName(tag || "*") : typeof context.querySelectorAll !== "undefined" ? context.querySelectorAll(tag || "*") : [];
    return tag === undefined || tag && jQuery.nodeName(context, tag) ? jQuery.merge([context], ret) : ret;
  }
  function setGlobalEval(elems, refElements) {
    var i = 0,
        l = elems.length;
    for (; i < l; i++) {
      dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
  }
  var rhtml = /<|&#?\w+;/;
  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
        tmp,
        tag,
        wrap,
        contains,
        j,
        fragment = context.createDocumentFragment(),
        nodes = [],
        i = 0,
        l = elems.length;
    for (; i < l; i++) {
      elem = elems[i];
      if (elem || elem === 0) {
        if (jQuery.type(elem) === "object") {
          jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
        } else if (!rhtml.test(elem)) {
          nodes.push(context.createTextNode(elem));
        } else {
          tmp = tmp || fragment.appendChild(context.createElement("div"));
          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
          j = wrap[0];
          while (j--) {
            tmp = tmp.lastChild;
          }
          jQuery.merge(nodes, tmp.childNodes);
          tmp = fragment.firstChild;
          tmp.textContent = "";
        }
      }
    }
    fragment.textContent = "";
    i = 0;
    while ((elem = nodes[i++])) {
      if (selection && jQuery.inArray(elem, selection) > -1) {
        if (ignored) {
          ignored.push(elem);
        }
        continue;
      }
      contains = jQuery.contains(elem.ownerDocument, elem);
      tmp = getAll(fragment.appendChild(elem), "script");
      if (contains) {
        setGlobalEval(tmp);
      }
      if (scripts) {
        j = 0;
        while ((elem = tmp[j++])) {
          if (rscriptType.test(elem.type || "")) {
            scripts.push(elem);
          }
        }
      }
    }
    return fragment;
  }
  (function() {
    var fragment = document.createDocumentFragment(),
        div = fragment.appendChild(document.createElement("div")),
        input = document.createElement("input");
    input.setAttribute("type", "radio");
    input.setAttribute("checked", "checked");
    input.setAttribute("name", "t");
    div.appendChild(input);
    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
  })();
  var rkeyEvent = /^key/,
      rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
  function returnTrue() {
    return true;
  }
  function returnFalse() {
    return false;
  }
  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }
  function on(elem, types, selector, data, fn, one) {
    var origFn,
        type;
    if (typeof types === "object") {
      if (typeof selector !== "string") {
        data = data || selector;
        selector = undefined;
      }
      for (type in types) {
        on(elem, type, selector, data, types[type], one);
      }
      return elem;
    }
    if (data == null && fn == null) {
      fn = selector;
      data = selector = undefined;
    } else if (fn == null) {
      if (typeof selector === "string") {
        fn = data;
        data = undefined;
      } else {
        fn = data;
        data = selector;
        selector = undefined;
      }
    }
    if (fn === false) {
      fn = returnFalse;
    } else if (!fn) {
      return elem;
    }
    if (one === 1) {
      origFn = fn;
      fn = function(event) {
        jQuery().off(event);
        return origFn.apply(this, arguments);
      };
      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
    }
    return elem.each(function() {
      jQuery.event.add(this, types, fn, data, selector);
    });
  }
  jQuery.event = {
    global: {},
    add: function(elem, types, handler, data, selector) {
      var handleObjIn,
          eventHandle,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.get(elem);
      if (!elemData) {
        return;
      }
      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }
      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      }
      if (!(events = elemData.events)) {
        events = elemData.events = {};
      }
      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function(e) {
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
        };
      }
      types = (types || "").match(rnotwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();
        if (!type) {
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        special = jQuery.event.special[type] || {};
        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn);
        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0;
          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle);
            }
          }
        }
        if (special.add) {
          special.add.call(elem, handleObj);
          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        }
        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        }
        jQuery.event.global[type] = true;
      }
    },
    remove: function(elem, types, handler, selector, mappedTypes) {
      var j,
          origCount,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
      if (!elemData || !(events = elemData.events)) {
        return;
      }
      types = (types || "").match(rnotwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();
        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
        origCount = j = handlers.length;
        while (j--) {
          handleObj = handlers[j];
          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);
            if (handleObj.selector) {
              handlers.delegateCount--;
            }
            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        }
        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }
          delete events[type];
        }
      }
      if (jQuery.isEmptyObject(events)) {
        dataPriv.remove(elem, "handle events");
      }
    },
    dispatch: function(event) {
      event = jQuery.event.fix(event);
      var i,
          j,
          ret,
          matched,
          handleObj,
          handlerQueue = [],
          args = slice.call(arguments),
          handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
          special = jQuery.event.special[event.type] || {};
      args[0] = event;
      event.delegateTarget = this;
      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      }
      handlerQueue = jQuery.event.handlers.call(this, event, handlers);
      i = 0;
      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;
        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }
      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }
      return event.result;
    },
    handlers: function(event, handlers) {
      var i,
          matches,
          sel,
          handleObj,
          handlerQueue = [],
          delegateCount = handlers.delegateCount,
          cur = event.target;
      if (delegateCount && cur.nodeType && (event.type !== "click" || isNaN(event.button) || event.button < 1)) {
        for (; cur !== this; cur = cur.parentNode || this) {
          if (cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click")) {
            matches = [];
            for (i = 0; i < delegateCount; i++) {
              handleObj = handlers[i];
              sel = handleObj.selector + " ";
              if (matches[sel] === undefined) {
                matches[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
              }
              if (matches[sel]) {
                matches.push(handleObj);
              }
            }
            if (matches.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matches
              });
            }
          }
        }
      }
      if (delegateCount < handlers.length) {
        handlerQueue.push({
          elem: this,
          handlers: handlers.slice(delegateCount)
        });
      }
      return handlerQueue;
    },
    props: ("altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " + "metaKey relatedTarget shiftKey target timeStamp view which").split(" "),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function(event, original) {
        if (event.which == null) {
          event.which = original.charCode != null ? original.charCode : original.keyCode;
        }
        return event;
      }
    },
    mouseHooks: {
      props: ("button buttons clientX clientY offsetX offsetY pageX pageY " + "screenX screenY toElement").split(" "),
      filter: function(event, original) {
        var eventDoc,
            doc,
            body,
            button = original.button;
        if (event.pageX == null && original.clientX != null) {
          eventDoc = event.target.ownerDocument || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;
          event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        }
        if (!event.which && button !== undefined) {
          event.which = (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
        }
        return event;
      }
    },
    fix: function(event) {
      if (event[jQuery.expando]) {
        return event;
      }
      var i,
          prop,
          copy,
          type = event.type,
          originalEvent = event,
          fixHook = this.fixHooks[type];
      if (!fixHook) {
        this.fixHooks[type] = fixHook = rmouseEvent.test(type) ? this.mouseHooks : rkeyEvent.test(type) ? this.keyHooks : {};
      }
      copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;
      event = new jQuery.Event(originalEvent);
      i = copy.length;
      while (i--) {
        prop = copy[i];
        event[prop] = originalEvent[prop];
      }
      if (!event.target) {
        event.target = document;
      }
      if (event.target.nodeType === 3) {
        event.target = event.target.parentNode;
      }
      return fixHook.filter ? fixHook.filter(event, originalEvent) : event;
    },
    special: {
      load: {noBubble: true},
      focus: {
        trigger: function() {
          if (this !== safeActiveElement() && this.focus) {
            this.focus();
            return false;
          }
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function() {
          if (this === safeActiveElement() && this.blur) {
            this.blur();
            return false;
          }
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function() {
          if (this.type === "checkbox" && this.click && jQuery.nodeName(this, "input")) {
            this.click();
            return false;
          }
        },
        _default: function(event) {
          return jQuery.nodeName(event.target, "a");
        }
      },
      beforeunload: {postDispatch: function(event) {
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }}
    }
  };
  jQuery.removeEvent = function(elem, type, handle) {
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle);
    }
  };
  jQuery.Event = function(src, props) {
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    }
    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type;
      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && src.returnValue === false ? returnTrue : returnFalse;
    } else {
      this.type = src;
    }
    if (props) {
      jQuery.extend(this, props);
    }
    this.timeStamp = src && src.timeStamp || jQuery.now();
    this[jQuery.expando] = true;
  };
  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;
      if (e) {
        e.preventDefault();
      }
    },
    stopPropagation: function() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;
      if (e) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;
      if (e) {
        e.stopImmediatePropagation();
      }
      this.stopPropagation();
    }
  };
  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function(orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function(event) {
        var ret,
            target = this,
            related = event.relatedTarget,
            handleObj = event.handleObj;
        if (!related || (related !== target && !jQuery.contains(target, related))) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }
        return ret;
      }
    };
  });
  jQuery.fn.extend({
    on: function(types, selector, data, fn) {
      return on(this, types, selector, data, fn);
    },
    one: function(types, selector, data, fn) {
      return on(this, types, selector, data, fn, 1);
    },
    off: function(types, selector, fn) {
      var handleObj,
          type;
      if (types && types.preventDefault && types.handleObj) {
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }
      if (typeof types === "object") {
        for (type in types) {
          this.off(type, selector, types[type]);
        }
        return this;
      }
      if (selector === false || typeof selector === "function") {
        fn = selector;
        selector = undefined;
      }
      if (fn === false) {
        fn = returnFalse;
      }
      return this.each(function() {
        jQuery.event.remove(this, types, fn, selector);
      });
    }
  });
  var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      rnoInnerhtml = /<script|<style|<link/i,
      rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rscriptTypeMasked = /^true\/(.*)/,
      rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function manipulationTarget(elem, content) {
    return jQuery.nodeName(elem, "table") && jQuery.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
  }
  function disableScript(elem) {
    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
    return elem;
  }
  function restoreScript(elem) {
    var match = rscriptTypeMasked.exec(elem.type);
    if (match) {
      elem.type = match[1];
    } else {
      elem.removeAttribute("type");
    }
    return elem;
  }
  function cloneCopyEvent(src, dest) {
    var i,
        l,
        type,
        pdataOld,
        pdataCur,
        udataOld,
        udataCur,
        events;
    if (dest.nodeType !== 1) {
      return;
    }
    if (dataPriv.hasData(src)) {
      pdataOld = dataPriv.access(src);
      pdataCur = dataPriv.set(dest, pdataOld);
      events = pdataOld.events;
      if (events) {
        delete pdataCur.handle;
        pdataCur.events = {};
        for (type in events) {
          for (i = 0, l = events[type].length; i < l; i++) {
            jQuery.event.add(dest, type, events[type][i]);
          }
        }
      }
    }
    if (dataUser.hasData(src)) {
      udataOld = dataUser.access(src);
      udataCur = jQuery.extend({}, udataOld);
      dataUser.set(dest, udataCur);
    }
  }
  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase();
    if (nodeName === "input" && rcheckableType.test(src.type)) {
      dest.checked = src.checked;
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }
  function domManip(collection, args, callback, ignored) {
    args = concat.apply([], args);
    var fragment,
        first,
        scripts,
        hasScripts,
        node,
        doc,
        i = 0,
        l = collection.length,
        iNoClone = l - 1,
        value = args[0],
        isFunction = jQuery.isFunction(value);
    if (isFunction || (l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value))) {
      return collection.each(function(index) {
        var self = collection.eq(index);
        if (isFunction) {
          args[0] = value.call(this, index, self.html());
        }
        domManip(self, args, callback, ignored);
      });
    }
    if (l) {
      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
      first = fragment.firstChild;
      if (fragment.childNodes.length === 1) {
        fragment = first;
      }
      if (first || ignored) {
        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
        hasScripts = scripts.length;
        for (; i < l; i++) {
          node = fragment;
          if (i !== iNoClone) {
            node = jQuery.clone(node, true, true);
            if (hasScripts) {
              jQuery.merge(scripts, getAll(node, "script"));
            }
          }
          callback.call(collection[i], node, i);
        }
        if (hasScripts) {
          doc = scripts[scripts.length - 1].ownerDocument;
          jQuery.map(scripts, restoreScript);
          for (i = 0; i < hasScripts; i++) {
            node = scripts[i];
            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
              if (node.src) {
                if (jQuery._evalUrl) {
                  jQuery._evalUrl(node.src);
                }
              } else {
                jQuery.globalEval(node.textContent.replace(rcleanScript, ""));
              }
            }
          }
        }
      }
    }
    return collection;
  }
  function remove(elem, selector, keepData) {
    var node,
        nodes = selector ? jQuery.filter(selector, elem) : elem,
        i = 0;
    for (; (node = nodes[i]) != null; i++) {
      if (!keepData && node.nodeType === 1) {
        jQuery.cleanData(getAll(node));
      }
      if (node.parentNode) {
        if (keepData && jQuery.contains(node.ownerDocument, node)) {
          setGlobalEval(getAll(node, "script"));
        }
        node.parentNode.removeChild(node);
      }
    }
    return elem;
  }
  jQuery.extend({
    htmlPrefilter: function(html) {
      return html.replace(rxhtmlTag, "<$1></$2>");
    },
    clone: function(elem, dataAndEvents, deepDataAndEvents) {
      var i,
          l,
          srcElements,
          destElements,
          clone = elem.cloneNode(true),
          inPage = jQuery.contains(elem.ownerDocument, elem);
      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        destElements = getAll(clone);
        srcElements = getAll(elem);
        for (i = 0, l = srcElements.length; i < l; i++) {
          fixInput(srcElements[i], destElements[i]);
        }
      }
      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);
          for (i = 0, l = srcElements.length; i < l; i++) {
            cloneCopyEvent(srcElements[i], destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      }
      destElements = getAll(clone, "script");
      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      }
      return clone;
    },
    cleanData: function(elems) {
      var data,
          elem,
          type,
          special = jQuery.event.special,
          i = 0;
      for (; (elem = elems[i]) !== undefined; i++) {
        if (acceptData(elem)) {
          if ((data = elem[dataPriv.expando])) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type);
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            }
            elem[dataPriv.expando] = undefined;
          }
          if (elem[dataUser.expando]) {
            elem[dataUser.expando] = undefined;
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    domManip: domManip,
    detach: function(selector) {
      return remove(this, selector, true);
    },
    remove: function(selector) {
      return remove(this, selector);
    },
    text: function(value) {
      return access(this, function(value) {
        return value === undefined ? jQuery.text(this) : this.empty().each(function() {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            this.textContent = value;
          }
        });
      }, null, value, arguments.length);
    },
    append: function() {
      return domManip(this, arguments, function(elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function() {
      return domManip(this, arguments, function(elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function() {
      return domManip(this, arguments, function(elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function() {
      return domManip(this, arguments, function(elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    empty: function() {
      var elem,
          i = 0;
      for (; (elem = this[i]) != null; i++) {
        if (elem.nodeType === 1) {
          jQuery.cleanData(getAll(elem, false));
          elem.textContent = "";
        }
      }
      return this;
    },
    clone: function(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function() {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function(value) {
      return access(this, function(value) {
        var elem = this[0] || {},
            i = 0,
            l = this.length;
        if (value === undefined && elem.nodeType === 1) {
          return elem.innerHTML;
        }
        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = jQuery.htmlPrefilter(value);
          try {
            for (; i < l; i++) {
              elem = this[i] || {};
              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }
            elem = 0;
          } catch (e) {}
        }
        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function() {
      var ignored = [];
      return domManip(this, arguments, function(elem) {
        var parent = this.parentNode;
        if (jQuery.inArray(this, ignored) < 0) {
          jQuery.cleanData(getAll(this));
          if (parent) {
            parent.replaceChild(elem, this);
          }
        }
      }, ignored);
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function(name, original) {
    jQuery.fn[name] = function(selector) {
      var elems,
          ret = [],
          insert = jQuery(selector),
          last = insert.length - 1,
          i = 0;
      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems);
        push.apply(ret, elems.get());
      }
      return this.pushStack(ret);
    };
  });
  var iframe,
      elemdisplay = {
        HTML: "block",
        BODY: "block"
      };
  function actualDisplay(name, doc) {
    var elem = jQuery(doc.createElement(name)).appendTo(doc.body),
        display = jQuery.css(elem[0], "display");
    elem.detach();
    return display;
  }
  function defaultDisplay(nodeName) {
    var doc = document,
        display = elemdisplay[nodeName];
    if (!display) {
      display = actualDisplay(nodeName, doc);
      if (display === "none" || !display) {
        iframe = (iframe || jQuery("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement);
        doc = iframe[0].contentDocument;
        doc.write();
        doc.close();
        display = actualDisplay(nodeName, doc);
        iframe.detach();
      }
      elemdisplay[nodeName] = display;
    }
    return display;
  }
  var rmargin = (/^margin/);
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var getStyles = function(elem) {
    var view = elem.ownerDocument.defaultView;
    if (!view || !view.opener) {
      view = window;
    }
    return view.getComputedStyle(elem);
  };
  var swap = function(elem, options, callback, args) {
    var ret,
        name,
        old = {};
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    ret = callback.apply(elem, args || []);
    for (name in options) {
      elem.style[name] = old[name];
    }
    return ret;
  };
  var documentElement = document.documentElement;
  (function() {
    var pixelPositionVal,
        boxSizingReliableVal,
        pixelMarginRightVal,
        reliableMarginLeftVal,
        container = document.createElement("div"),
        div = document.createElement("div");
    if (!div.style) {
      return;
    }
    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";
    container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" + "padding:0;margin-top:1px;position:absolute";
    container.appendChild(div);
    function computeStyleTests() {
      div.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" + "position:relative;display:block;" + "margin:auto;border:1px;padding:1px;" + "top:1%;width:50%";
      div.innerHTML = "";
      documentElement.appendChild(container);
      var divStyle = window.getComputedStyle(div);
      pixelPositionVal = divStyle.top !== "1%";
      reliableMarginLeftVal = divStyle.marginLeft === "2px";
      boxSizingReliableVal = divStyle.width === "4px";
      div.style.marginRight = "50%";
      pixelMarginRightVal = divStyle.marginRight === "4px";
      documentElement.removeChild(container);
    }
    jQuery.extend(support, {
      pixelPosition: function() {
        computeStyleTests();
        return pixelPositionVal;
      },
      boxSizingReliable: function() {
        if (boxSizingReliableVal == null) {
          computeStyleTests();
        }
        return boxSizingReliableVal;
      },
      pixelMarginRight: function() {
        if (boxSizingReliableVal == null) {
          computeStyleTests();
        }
        return pixelMarginRightVal;
      },
      reliableMarginLeft: function() {
        if (boxSizingReliableVal == null) {
          computeStyleTests();
        }
        return reliableMarginLeftVal;
      },
      reliableMarginRight: function() {
        var ret,
            marginDiv = div.appendChild(document.createElement("div"));
        marginDiv.style.cssText = div.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;" + "display:block;margin:0;border:0;padding:0";
        marginDiv.style.marginRight = marginDiv.style.width = "0";
        div.style.width = "1px";
        documentElement.appendChild(container);
        ret = !parseFloat(window.getComputedStyle(marginDiv).marginRight);
        documentElement.removeChild(container);
        div.removeChild(marginDiv);
        return ret;
      }
    });
  })();
  function curCSS(elem, name, computed) {
    var width,
        minWidth,
        maxWidth,
        ret,
        style = elem.style;
    computed = computed || getStyles(elem);
    ret = computed ? computed.getPropertyValue(name) || computed[name] : undefined;
    if ((ret === "" || ret === undefined) && !jQuery.contains(elem.ownerDocument, elem)) {
      ret = jQuery.style(elem, name);
    }
    if (computed) {
      if (!support.pixelMarginRight() && rnumnonpx.test(ret) && rmargin.test(name)) {
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth;
        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width;
        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }
    return ret !== undefined ? ret + "" : ret;
  }
  function addGetHookIf(conditionFn, hookFn) {
    return {get: function() {
        if (conditionFn()) {
          delete this.get;
          return;
        }
        return (this.get = hookFn).apply(this, arguments);
      }};
  }
  var rdisplayswap = /^(none|table(?!-c[ea]).+)/,
      cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
      },
      cssPrefixes = ["Webkit", "O", "Moz", "ms"],
      emptyStyle = document.createElement("div").style;
  function vendorPropName(name) {
    if (name in emptyStyle) {
      return name;
    }
    var capName = name[0].toUpperCase() + name.slice(1),
        i = cssPrefixes.length;
    while (i--) {
      name = cssPrefixes[i] + capName;
      if (name in emptyStyle) {
        return name;
      }
    }
  }
  function setPositiveNumber(elem, value, subtract) {
    var matches = rcssNum.exec(value);
    return matches ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
  }
  function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
    var i = extra === (isBorderBox ? "border" : "content") ? 4 : name === "width" ? 1 : 0,
        val = 0;
    for (; i < 4; i += 2) {
      if (extra === "margin") {
        val += jQuery.css(elem, extra + cssExpand[i], true, styles);
      }
      if (isBorderBox) {
        if (extra === "content") {
          val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        }
        if (extra !== "margin") {
          val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      } else {
        val += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        if (extra !== "padding") {
          val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    }
    return val;
  }
  function getWidthOrHeight(elem, name, extra) {
    var valueIsBorderBox = true,
        val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
        styles = getStyles(elem),
        isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
    if (document.msFullscreenElement && window.top !== window) {
      if (elem.getClientRects().length) {
        val = Math.round(elem.getBoundingClientRect()[name] * 100);
      }
    }
    if (val <= 0 || val == null) {
      val = curCSS(elem, name, styles);
      if (val < 0 || val == null) {
        val = elem.style[name];
      }
      if (rnumnonpx.test(val)) {
        return val;
      }
      valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]);
      val = parseFloat(val) || 0;
    }
    return (val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles)) + "px";
  }
  function showHide(elements, show) {
    var display,
        elem,
        hidden,
        values = [],
        index = 0,
        length = elements.length;
    for (; index < length; index++) {
      elem = elements[index];
      if (!elem.style) {
        continue;
      }
      values[index] = dataPriv.get(elem, "olddisplay");
      display = elem.style.display;
      if (show) {
        if (!values[index] && display === "none") {
          elem.style.display = "";
        }
        if (elem.style.display === "" && isHidden(elem)) {
          values[index] = dataPriv.access(elem, "olddisplay", defaultDisplay(elem.nodeName));
        }
      } else {
        hidden = isHidden(elem);
        if (display !== "none" || !hidden) {
          dataPriv.set(elem, "olddisplay", hidden ? display : jQuery.css(elem, "display"));
        }
      }
    }
    for (index = 0; index < length; index++) {
      elem = elements[index];
      if (!elem.style) {
        continue;
      }
      if (!show || elem.style.display === "none" || elem.style.display === "") {
        elem.style.display = show ? values[index] || "" : "none";
      }
    }
    return elements;
  }
  jQuery.extend({
    cssHooks: {opacity: {get: function(elem, computed) {
          if (computed) {
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }}},
    cssNumber: {
      "animationIterationCount": true,
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },
    cssProps: {"float": "cssFloat"},
    style: function(elem, name, value, extra) {
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      }
      var ret,
          type,
          hooks,
          origName = jQuery.camelCase(name),
          style = elem.style;
      name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
      if (value !== undefined) {
        type = typeof value;
        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
          value = adjustCSS(elem, name, ret);
          type = "number";
        }
        if (value == null || value !== value) {
          return;
        }
        if (type === "number") {
          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
        }
        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        }
        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          style[name] = value;
        }
      } else {
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        }
        return style[name];
      }
    },
    css: function(elem, name, extra, styles) {
      var val,
          num,
          hooks,
          origName = jQuery.camelCase(name);
      name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      }
      if (val === undefined) {
        val = curCSS(elem, name, styles);
      }
      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      }
      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || isFinite(num) ? num || 0 : val;
      }
      return val;
    }
  });
  jQuery.each(["height", "width"], function(i, name) {
    jQuery.cssHooks[name] = {
      get: function(elem, computed, extra) {
        if (computed) {
          return rdisplayswap.test(jQuery.css(elem, "display")) && elem.offsetWidth === 0 ? swap(elem, cssShow, function() {
            return getWidthOrHeight(elem, name, extra);
          }) : getWidthOrHeight(elem, name, extra);
        }
      },
      set: function(elem, value, extra) {
        var matches,
            styles = extra && getStyles(elem),
            subtract = extra && augmentWidthOrHeight(elem, name, extra, jQuery.css(elem, "boxSizing", false, styles) === "border-box", styles);
        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
          elem.style[name] = value;
          value = jQuery.css(elem, name);
        }
        return setPositiveNumber(elem, value, subtract);
      }
    };
  });
  jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
    if (computed) {
      return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {marginLeft: 0}, function() {
        return elem.getBoundingClientRect().left;
      })) + "px";
    }
  });
  jQuery.cssHooks.marginRight = addGetHookIf(support.reliableMarginRight, function(elem, computed) {
    if (computed) {
      return swap(elem, {"display": "inline-block"}, curCSS, [elem, "marginRight"]);
    }
  });
  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function(prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {expand: function(value) {
        var i = 0,
            expanded = {},
            parts = typeof value === "string" ? value.split(" ") : [value];
        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }
        return expanded;
      }};
    if (!rmargin.test(prefix)) {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({
    css: function(name, value) {
      return access(this, function(elem, name, value) {
        var styles,
            len,
            map = {},
            i = 0;
        if (jQuery.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;
          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }
          return map;
        }
        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    },
    show: function() {
      return showHide(this, true);
    },
    hide: function() {
      return showHide(this);
    },
    toggle: function(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }
      return this.each(function() {
        if (isHidden(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });
  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }
  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function(percent) {
      var eased,
          hooks = Tween.propHooks[this.prop];
      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }
      this.now = (this.end - this.start) * eased + this.start;
      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }
      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }
      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {_default: {
      get: function(tween) {
        var result;
        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
          return tween.elem[tween.prop];
        }
        result = jQuery.css(tween.elem, tween.prop, "");
        return !result || result === "auto" ? 0 : result;
      },
      set: function(tween) {
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }};
  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {set: function(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }};
  jQuery.easing = {
    linear: function(p) {
      return p;
    },
    swing: function(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
    _default: "swing"
  };
  jQuery.fx = Tween.prototype.init;
  jQuery.fx.step = {};
  var fxNow,
      timerId,
      rfxtypes = /^(?:toggle|show|hide)$/,
      rrun = /queueHooks$/;
  function createFxNow() {
    window.setTimeout(function() {
      fxNow = undefined;
    });
    return (fxNow = jQuery.now());
  }
  function genFx(type, includeWidth) {
    var which,
        i = 0,
        attrs = {height: type};
    includeWidth = includeWidth ? 1 : 0;
    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }
    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }
    return attrs;
  }
  function createTween(value, prop, animation) {
    var tween,
        collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
        index = 0,
        length = collection.length;
    for (; index < length; index++) {
      if ((tween = collection[index].call(animation, prop, value))) {
        return tween;
      }
    }
  }
  function defaultPrefilter(elem, props, opts) {
    var prop,
        value,
        toggle,
        tween,
        hooks,
        oldfire,
        display,
        checkDisplay,
        anim = this,
        orig = {},
        style = elem.style,
        hidden = elem.nodeType && isHidden(elem),
        dataShow = dataPriv.get(elem, "fxshow");
    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");
      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function() {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;
      anim.always(function() {
        anim.always(function() {
          hooks.unqueued--;
          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    }
    if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
      opts.overflow = [style.overflow, style.overflowX, style.overflowY];
      display = jQuery.css(elem, "display");
      checkDisplay = display === "none" ? dataPriv.get(elem, "olddisplay") || defaultDisplay(elem.nodeName) : display;
      if (checkDisplay === "inline" && jQuery.css(elem, "float") === "none") {
        style.display = "inline-block";
      }
    }
    if (opts.overflow) {
      style.overflow = "hidden";
      anim.always(function() {
        style.overflow = opts.overflow[0];
        style.overflowX = opts.overflow[1];
        style.overflowY = opts.overflow[2];
      });
    }
    for (prop in props) {
      value = props[prop];
      if (rfxtypes.exec(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";
        if (value === (hidden ? "hide" : "show")) {
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true;
          } else {
            continue;
          }
        }
        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
      } else {
        display = undefined;
      }
    }
    if (!jQuery.isEmptyObject(orig)) {
      if (dataShow) {
        if ("hidden" in dataShow) {
          hidden = dataShow.hidden;
        }
      } else {
        dataShow = dataPriv.access(elem, "fxshow", {});
      }
      if (toggle) {
        dataShow.hidden = !hidden;
      }
      if (hidden) {
        jQuery(elem).show();
      } else {
        anim.done(function() {
          jQuery(elem).hide();
        });
      }
      anim.done(function() {
        var prop;
        dataPriv.remove(elem, "fxshow");
        for (prop in orig) {
          jQuery.style(elem, prop, orig[prop]);
        }
      });
      for (prop in orig) {
        tween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
        if (!(prop in dataShow)) {
          dataShow[prop] = tween.start;
          if (hidden) {
            tween.end = tween.start;
            tween.start = prop === "width" || prop === "height" ? 1 : 0;
          }
        }
      }
    } else if ((display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline") {
      style.display = display;
    }
  }
  function propFilter(props, specialEasing) {
    var index,
        name,
        easing,
        value,
        hooks;
    for (index in props) {
      name = jQuery.camelCase(index);
      easing = specialEasing[name];
      value = props[index];
      if (jQuery.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }
      if (index !== name) {
        props[name] = value;
        delete props[index];
      }
      hooks = jQuery.cssHooks[name];
      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name];
        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }
  function Animation(elem, properties, options) {
    var result,
        stopped,
        index = 0,
        length = Animation.prefilters.length,
        deferred = jQuery.Deferred().always(function() {
          delete tick.elem;
        }),
        tick = function() {
          if (stopped) {
            return false;
          }
          var currentTime = fxNow || createFxNow(),
              remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
              temp = remaining / animation.duration || 0,
              percent = 1 - temp,
              index = 0,
              length = animation.tweens.length;
          for (; index < length; index++) {
            animation.tweens[index].run(percent);
          }
          deferred.notifyWith(elem, [animation, percent, remaining]);
          if (percent < 1 && length) {
            return remaining;
          } else {
            deferred.resolveWith(elem, [animation]);
            return false;
          }
        },
        animation = deferred.promise({
          elem: elem,
          props: jQuery.extend({}, properties),
          opts: jQuery.extend(true, {
            specialEasing: {},
            easing: jQuery.easing._default
          }, options),
          originalProperties: properties,
          originalOptions: options,
          startTime: fxNow || createFxNow(),
          duration: options.duration,
          tweens: [],
          createTween: function(prop, end) {
            var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
            animation.tweens.push(tween);
            return tween;
          },
          stop: function(gotoEnd) {
            var index = 0,
                length = gotoEnd ? animation.tweens.length : 0;
            if (stopped) {
              return this;
            }
            stopped = true;
            for (; index < length; index++) {
              animation.tweens[index].run(1);
            }
            if (gotoEnd) {
              deferred.notifyWith(elem, [animation, 1, 0]);
              deferred.resolveWith(elem, [animation, gotoEnd]);
            } else {
              deferred.rejectWith(elem, [animation, gotoEnd]);
            }
            return this;
          }
        }),
        props = animation.props;
    propFilter(props, animation.opts.specialEasing);
    for (; index < length; index++) {
      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
      if (result) {
        if (jQuery.isFunction(result.stop)) {
          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = jQuery.proxy(result.stop, result);
        }
        return result;
      }
    }
    jQuery.map(props, createTween, animation);
    if (jQuery.isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    }
    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    }));
    return animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
  }
  jQuery.Animation = jQuery.extend(Animation, {
    tweeners: {"*": [function(prop, value) {
        var tween = this.createTween(prop, value);
        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
        return tween;
      }]},
    tweener: function(props, callback) {
      if (jQuery.isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.match(rnotwhite);
      }
      var prop,
          index = 0,
          length = props.length;
      for (; index < length; index++) {
        prop = props[index];
        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
        Animation.tweeners[prop].unshift(callback);
      }
    },
    prefilters: [defaultPrefilter],
    prefilter: function(callback, prepend) {
      if (prepend) {
        Animation.prefilters.unshift(callback);
      } else {
        Animation.prefilters.push(callback);
      }
    }
  });
  jQuery.speed = function(speed, easing, fn) {
    var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || jQuery.isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
    };
    opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default;
    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    }
    opt.old = opt.complete;
    opt.complete = function() {
      if (jQuery.isFunction(opt.old)) {
        opt.old.call(this);
      }
      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };
    return opt;
  };
  jQuery.fn.extend({
    fadeTo: function(speed, to, easing, callback) {
      return this.filter(isHidden).css("opacity", 0).show().end().animate({opacity: to}, speed, easing, callback);
    },
    animate: function(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
          optall = jQuery.speed(speed, easing, callback),
          doAnimation = function() {
            var anim = Animation(this, jQuery.extend({}, prop), optall);
            if (empty || dataPriv.get(this, "finish")) {
              anim.stop(true);
            }
          };
      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function(type, clearQueue, gotoEnd) {
      var stopQueue = function(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };
      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if (clearQueue && type !== false) {
        this.queue(type || "fx", []);
      }
      return this.each(function() {
        var dequeue = true,
            index = type != null && type + "queueHooks",
            timers = jQuery.timers,
            data = dataPriv.get(this);
        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }
        for (index = timers.length; index--; ) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        }
        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function(type) {
      if (type !== false) {
        type = type || "fx";
      }
      return this.each(function() {
        var index,
            data = dataPriv.get(this),
            queue = data[type + "queue"],
            hooks = data[type + "queueHooks"],
            timers = jQuery.timers,
            length = queue ? queue.length : 0;
        data.finish = true;
        jQuery.queue(this, type, []);
        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        }
        for (index = timers.length; index--; ) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        }
        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        }
        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function(i, name) {
    var cssFn = jQuery.fn[name];
    jQuery.fn[name] = function(speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  });
  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {opacity: "show"},
    fadeOut: {opacity: "hide"},
    fadeToggle: {opacity: "toggle"}
  }, function(name, props) {
    jQuery.fn[name] = function(speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];
  jQuery.fx.tick = function() {
    var timer,
        i = 0,
        timers = jQuery.timers;
    fxNow = jQuery.now();
    for (; i < timers.length; i++) {
      timer = timers[i];
      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }
    if (!timers.length) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };
  jQuery.fx.timer = function(timer) {
    jQuery.timers.push(timer);
    if (timer()) {
      jQuery.fx.start();
    } else {
      jQuery.timers.pop();
    }
  };
  jQuery.fx.interval = 13;
  jQuery.fx.start = function() {
    if (!timerId) {
      timerId = window.setInterval(jQuery.fx.tick, jQuery.fx.interval);
    }
  };
  jQuery.fx.stop = function() {
    window.clearInterval(timerId);
    timerId = null;
  };
  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  };
  jQuery.fn.delay = function(time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function(next, hooks) {
      var timeout = window.setTimeout(next, time);
      hooks.stop = function() {
        window.clearTimeout(timeout);
      };
    });
  };
  (function() {
    var input = document.createElement("input"),
        select = document.createElement("select"),
        opt = select.appendChild(document.createElement("option"));
    input.type = "checkbox";
    support.checkOn = input.value !== "";
    support.optSelected = opt.selected;
    select.disabled = true;
    support.optDisabled = !opt.disabled;
    input = document.createElement("input");
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  })();
  var boolHook,
      attrHandle = jQuery.expr.attrHandle;
  jQuery.fn.extend({
    attr: function(name, value) {
      return access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function(name) {
      return this.each(function() {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType;
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (typeof elem.getAttribute === "undefined") {
        return jQuery.prop(elem, name, value);
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        name = name.toLowerCase();
        hooks = jQuery.attrHooks[name] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
      }
      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
          return;
        }
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        elem.setAttribute(name, value + "");
        return value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      ret = jQuery.find.attr(elem, name);
      return ret == null ? undefined : ret;
    },
    attrHooks: {type: {set: function(elem, value) {
          if (!support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
            var val = elem.value;
            elem.setAttribute("type", value);
            if (val) {
              elem.value = val;
            }
            return value;
          }
        }}},
    removeAttr: function(elem, value) {
      var name,
          propName,
          i = 0,
          attrNames = value && value.match(rnotwhite);
      if (attrNames && elem.nodeType === 1) {
        while ((name = attrNames[i++])) {
          propName = jQuery.propFix[name] || name;
          if (jQuery.expr.match.bool.test(name)) {
            elem[propName] = false;
          }
          elem.removeAttribute(name);
        }
      }
    }
  });
  boolHook = {set: function(elem, value, name) {
      if (value === false) {
        jQuery.removeAttr(elem, name);
      } else {
        elem.setAttribute(name, name);
      }
      return name;
    }};
  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;
    attrHandle[name] = function(elem, name, isXML) {
      var ret,
          handle;
      if (!isXML) {
        handle = attrHandle[name];
        attrHandle[name] = ret;
        ret = getter(elem, name, isXML) != null ? name.toLowerCase() : null;
        attrHandle[name] = handle;
      }
      return ret;
    };
  });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
      rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function(name, value) {
      return access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function(name) {
      return this.each(function() {
        delete this[jQuery.propFix[name] || name];
      });
    }
  });
  jQuery.extend({
    prop: function(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType;
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }
      if (value !== undefined) {
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        return (elem[name] = value);
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      return elem[name];
    },
    propHooks: {tabIndex: {get: function(elem) {
          var tabindex = jQuery.find.attr(elem, "tabindex");
          return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : -1;
        }}},
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  });
  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function(elem) {
        var parent = elem.parentNode;
        if (parent && parent.parentNode) {
          parent.parentNode.selectedIndex;
        }
        return null;
      },
      set: function(elem) {
        var parent = elem.parentNode;
        if (parent) {
          parent.selectedIndex;
          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }
  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
    jQuery.propFix[this.toLowerCase()] = this;
  });
  var rclass = /[\t\r\n\f]/g;
  function getClass(elem) {
    return elem.getAttribute && elem.getAttribute("class") || "";
  }
  jQuery.fn.extend({
    addClass: function(value) {
      var classes,
          elem,
          cur,
          curValue,
          clazz,
          j,
          finalValue,
          i = 0;
      if (jQuery.isFunction(value)) {
        return this.each(function(j) {
          jQuery(this).addClass(value.call(this, j, getClass(this)));
        });
      }
      if (typeof value === "string" && value) {
        classes = value.match(rnotwhite) || [];
        while ((elem = this[i++])) {
          curValue = getClass(elem);
          cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
          if (cur) {
            j = 0;
            while ((clazz = classes[j++])) {
              if (cur.indexOf(" " + clazz + " ") < 0) {
                cur += clazz + " ";
              }
            }
            finalValue = jQuery.trim(cur);
            if (curValue !== finalValue) {
              elem.setAttribute("class", finalValue);
            }
          }
        }
      }
      return this;
    },
    removeClass: function(value) {
      var classes,
          elem,
          cur,
          curValue,
          clazz,
          j,
          finalValue,
          i = 0;
      if (jQuery.isFunction(value)) {
        return this.each(function(j) {
          jQuery(this).removeClass(value.call(this, j, getClass(this)));
        });
      }
      if (!arguments.length) {
        return this.attr("class", "");
      }
      if (typeof value === "string" && value) {
        classes = value.match(rnotwhite) || [];
        while ((elem = this[i++])) {
          curValue = getClass(elem);
          cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
          if (cur) {
            j = 0;
            while ((clazz = classes[j++])) {
              while (cur.indexOf(" " + clazz + " ") > -1) {
                cur = cur.replace(" " + clazz + " ", " ");
              }
            }
            finalValue = jQuery.trim(cur);
            if (curValue !== finalValue) {
              elem.setAttribute("class", finalValue);
            }
          }
        }
      }
      return this;
    },
    toggleClass: function(value, stateVal) {
      var type = typeof value;
      if (typeof stateVal === "boolean" && type === "string") {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }
      if (jQuery.isFunction(value)) {
        return this.each(function(i) {
          jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
        });
      }
      return this.each(function() {
        var className,
            i,
            self,
            classNames;
        if (type === "string") {
          i = 0;
          self = jQuery(this);
          classNames = value.match(rnotwhite) || [];
          while ((className = classNames[i++])) {
            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          }
        } else if (value === undefined || type === "boolean") {
          className = getClass(this);
          if (className) {
            dataPriv.set(this, "__className__", className);
          }
          if (this.setAttribute) {
            this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
          }
        }
      });
    },
    hasClass: function(selector) {
      var className,
          elem,
          i = 0;
      className = " " + selector + " ";
      while ((elem = this[i++])) {
        if (elem.nodeType === 1 && (" " + getClass(elem) + " ").replace(rclass, " ").indexOf(className) > -1) {
          return true;
        }
      }
      return false;
    }
  });
  var rreturn = /\r/g,
      rspaces = /[\x20\t\r\n\f]+/g;
  jQuery.fn.extend({val: function(value) {
      var hooks,
          ret,
          isFunction,
          elem = this[0];
      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }
          ret = elem.value;
          return typeof ret === "string" ? ret.replace(rreturn, "") : ret == null ? "" : ret;
        }
        return;
      }
      isFunction = jQuery.isFunction(value);
      return this.each(function(i) {
        var val;
        if (this.nodeType !== 1) {
          return;
        }
        if (isFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        }
        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (jQuery.isArray(val)) {
          val = jQuery.map(val, function(value) {
            return value == null ? "" : value + "";
          });
        }
        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }});
  jQuery.extend({valHooks: {
      option: {get: function(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val : jQuery.trim(jQuery.text(elem)).replace(rspaces, " ");
        }},
      select: {
        get: function(elem) {
          var value,
              option,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one" || index < 0,
              values = one ? null : [],
              max = one ? index + 1 : options.length,
              i = index < 0 ? max : one ? index : 0;
          for (; i < max; i++) {
            option = options[i];
            if ((option.selected || i === index) && (support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {
              value = jQuery(option).val();
              if (one) {
                return value;
              }
              values.push(value);
            }
          }
          return values;
        },
        set: function(elem, value) {
          var optionSet,
              option,
              options = elem.options,
              values = jQuery.makeArray(value),
              i = options.length;
          while (i--) {
            option = options[i];
            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
              optionSet = true;
            }
          }
          if (!optionSet) {
            elem.selectedIndex = -1;
          }
          return values;
        }
      }
    }});
  jQuery.each(["radio", "checkbox"], function() {
    jQuery.valHooks[this] = {set: function(elem, value) {
        if (jQuery.isArray(value)) {
          return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
        }
      }};
    if (!support.checkOn) {
      jQuery.valHooks[this].get = function(elem) {
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });
  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
  jQuery.extend(jQuery.event, {
    trigger: function(event, data, elem, onlyHandlers) {
      var i,
          cur,
          tmp,
          bubbleType,
          ontype,
          handle,
          special,
          eventPath = [elem || document],
          type = hasOwn.call(event, "type") ? event.type : event,
          namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = tmp = elem = elem || document;
      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      }
      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }
      if (type.indexOf(".") > -1) {
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf(":") < 0 && "on" + type;
      event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
      event.result = undefined;
      if (!event.target) {
        event.target = elem;
      }
      data = data == null ? [event] : jQuery.makeArray(data, [event]);
      special = jQuery.event.special[type] || {};
      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      }
      if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
        bubbleType = special.delegateType || type;
        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }
        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        }
        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      }
      i = 0;
      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        event.type = i > 1 ? bubbleType : special.bindType || type;
        handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
        if (handle) {
          handle.apply(cur, data);
        }
        handle = ontype && cur[ontype];
        if (handle && handle.apply && acceptData(cur)) {
          event.result = handle.apply(cur, data);
          if (event.result === false) {
            event.preventDefault();
          }
        }
      }
      event.type = type;
      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
          if (ontype && jQuery.isFunction(elem[type]) && !jQuery.isWindow(elem)) {
            tmp = elem[ontype];
            if (tmp) {
              elem[ontype] = null;
            }
            jQuery.event.triggered = type;
            elem[type]();
            jQuery.event.triggered = undefined;
            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }
      return event.result;
    },
    simulate: function(type, elem, event) {
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true
      });
      jQuery.event.trigger(e, null, elem);
      if (e.isDefaultPrevented()) {
        event.preventDefault();
      }
    }
  });
  jQuery.fn.extend({
    trigger: function(type, data) {
      return this.each(function() {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function(type, data) {
      var elem = this[0];
      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  });
  jQuery.each(("blur focus focusin focusout load resize scroll unload click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup error contextmenu").split(" "), function(i, name) {
    jQuery.fn[name] = function(data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  });
  jQuery.fn.extend({hover: function(fnOver, fnOut) {
      return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
    }});
  support.focusin = "onfocusin" in window;
  if (!support.focusin) {
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function(orig, fix) {
      var handler = function(event) {
        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
      };
      jQuery.event.special[fix] = {
        setup: function() {
          var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix);
          if (!attaches) {
            doc.addEventListener(orig, handler, true);
          }
          dataPriv.access(doc, fix, (attaches || 0) + 1);
        },
        teardown: function() {
          var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix) - 1;
          if (!attaches) {
            doc.removeEventListener(orig, handler, true);
            dataPriv.remove(doc, fix);
          } else {
            dataPriv.access(doc, fix, attaches);
          }
        }
      };
    });
  }
  var location = window.location;
  var nonce = jQuery.now();
  var rquery = (/\?/);
  jQuery.parseJSON = function(data) {
    return JSON.parse(data + "");
  };
  jQuery.parseXML = function(data) {
    var xml;
    if (!data || typeof data !== "string") {
      return null;
    }
    try {
      xml = (new window.DOMParser()).parseFromString(data, "text/xml");
    } catch (e) {
      xml = undefined;
    }
    if (!xml || xml.getElementsByTagName("parsererror").length) {
      jQuery.error("Invalid XML: " + data);
    }
    return xml;
  };
  var rhash = /#.*$/,
      rts = /([?&])_=[^&]*/,
      rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
      rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      rnoContent = /^(?:GET|HEAD)$/,
      rprotocol = /^\/\//,
      prefilters = {},
      transports = {},
      allTypes = "*/".concat("*"),
      originAnchor = document.createElement("a");
  originAnchor.href = location.href;
  function addToPrefiltersOrTransports(structure) {
    return function(dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }
      var dataType,
          i = 0,
          dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];
      if (jQuery.isFunction(func)) {
        while ((dataType = dataTypes[i++])) {
          if (dataType[0] === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func);
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  }
  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
        seekingTransport = (structure === transports);
    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }
    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  }
  function ajaxExtend(target, src) {
    var key,
        deep,
        flatOptions = jQuery.ajaxSettings.flatOptions || {};
    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key];
      }
    }
    if (deep) {
      jQuery.extend(true, target, deep);
    }
    return target;
  }
  function ajaxHandleResponses(s, jqXHR, responses) {
    var ct,
        type,
        finalDataType,
        firstDataType,
        contents = s.contents,
        dataTypes = s.dataTypes;
    while (dataTypes[0] === "*") {
      dataTypes.shift();
      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    }
    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    }
    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }
        if (!firstDataType) {
          firstDataType = type;
        }
      }
      finalDataType = finalDataType || firstDataType;
    }
    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }
      return responses[finalDataType];
    }
  }
  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
        current,
        conv,
        tmp,
        prev,
        converters = {},
        dataTypes = s.dataTypes.slice();
    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }
    current = dataTypes.shift();
    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      }
      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }
      prev = current;
      current = dataTypes.shift();
      if (current) {
        if (current === "*") {
          current = prev;
        } else if (prev !== "*" && prev !== current) {
          conv = converters[prev + " " + current] || converters["* " + current];
          if (!conv) {
            for (conv2 in converters) {
              tmp = conv2.split(" ");
              if (tmp[1] === current) {
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                if (conv) {
                  if (conv === true) {
                    conv = converters[conv2];
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }
                  break;
                }
              }
            }
          }
          if (conv !== true) {
            if (conv && s.throws) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }
    return {
      state: "success",
      data: response
    };
  }
  jQuery.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test(location.protocol),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": true,
        "text json": jQuery.parseJSON,
        "text xml": jQuery.parseXML
      },
      flatOptions: {
        url: true,
        context: true
      }
    },
    ajaxSetup: function(target, settings) {
      return settings ? ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    ajax: function(url, options) {
      if (typeof url === "object") {
        options = url;
        url = undefined;
      }
      options = options || {};
      var transport,
          cacheURL,
          responseHeadersString,
          responseHeaders,
          timeoutTimer,
          urlAnchor,
          fireGlobals,
          i,
          s = jQuery.ajaxSetup({}, options),
          callbackContext = s.context || s,
          globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
          deferred = jQuery.Deferred(),
          completeDeferred = jQuery.Callbacks("once memory"),
          statusCode = s.statusCode || {},
          requestHeaders = {},
          requestHeadersNames = {},
          state = 0,
          strAbort = "canceled",
          jqXHR = {
            readyState: 0,
            getResponseHeader: function(key) {
              var match;
              if (state === 2) {
                if (!responseHeaders) {
                  responseHeaders = {};
                  while ((match = rheaders.exec(responseHeadersString))) {
                    responseHeaders[match[1].toLowerCase()] = match[2];
                  }
                }
                match = responseHeaders[key.toLowerCase()];
              }
              return match == null ? null : match;
            },
            getAllResponseHeaders: function() {
              return state === 2 ? responseHeadersString : null;
            },
            setRequestHeader: function(name, value) {
              var lname = name.toLowerCase();
              if (!state) {
                name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
                requestHeaders[name] = value;
              }
              return this;
            },
            overrideMimeType: function(type) {
              if (!state) {
                s.mimeType = type;
              }
              return this;
            },
            statusCode: function(map) {
              var code;
              if (map) {
                if (state < 2) {
                  for (code in map) {
                    statusCode[code] = [statusCode[code], map[code]];
                  }
                } else {
                  jqXHR.always(map[jqXHR.status]);
                }
              }
              return this;
            },
            abort: function(statusText) {
              var finalText = statusText || strAbort;
              if (transport) {
                transport.abort(finalText);
              }
              done(0, finalText);
              return this;
            }
          };
      deferred.promise(jqXHR).complete = completeDeferred.add;
      jqXHR.success = jqXHR.done;
      jqXHR.error = jqXHR.fail;
      s.url = ((url || s.url || location.href) + "").replace(rhash, "").replace(rprotocol, location.protocol + "//");
      s.type = options.method || options.type || s.method || s.type;
      s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [""];
      if (s.crossDomain == null) {
        urlAnchor = document.createElement("a");
        try {
          urlAnchor.href = s.url;
          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
        } catch (e) {
          s.crossDomain = true;
        }
      }
      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      }
      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
      if (state === 2) {
        return jqXHR;
      }
      fireGlobals = jQuery.event && s.global;
      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      }
      s.type = s.type.toUpperCase();
      s.hasContent = !rnoContent.test(s.type);
      cacheURL = s.url;
      if (!s.hasContent) {
        if (s.data) {
          cacheURL = (s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data);
          delete s.data;
        }
        if (s.cache === false) {
          s.url = rts.test(cacheURL) ? cacheURL.replace(rts, "$1_=" + nonce++) : cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++;
        }
      }
      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }
        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      }
      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      }
      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      }
      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
        return jqXHR.abort();
      }
      strAbort = "abort";
      for (i in {
        success: 1,
        error: 1,
        complete: 1
      }) {
        jqXHR[i](s[i]);
      }
      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1;
        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        }
        if (state === 2) {
          return jqXHR;
        }
        if (s.async && s.timeout > 0) {
          timeoutTimer = window.setTimeout(function() {
            jqXHR.abort("timeout");
          }, s.timeout);
        }
        try {
          state = 1;
          transport.send(requestHeaders, done);
        } catch (e) {
          if (state < 2) {
            done(-1, e);
          } else {
            throw e;
          }
        }
      }
      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText;
        if (state === 2) {
          return;
        }
        state = 2;
        if (timeoutTimer) {
          window.clearTimeout(timeoutTimer);
        }
        transport = undefined;
        responseHeadersString = headers || "";
        jqXHR.readyState = status > 0 ? 4 : 0;
        isSuccess = status >= 200 && status < 300 || status === 304;
        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        }
        response = ajaxConvert(s, response, jqXHR, isSuccess);
        if (isSuccess) {
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");
            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }
            modified = jqXHR.getResponseHeader("etag");
            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          }
          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent";
          } else if (status === 304) {
            statusText = "notmodified";
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          error = statusText;
          if (status || !statusText) {
            statusText = "error";
            if (status < 0) {
              status = 0;
            }
          }
        }
        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + "";
        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        }
        jqXHR.statusCode(statusCode);
        statusCode = undefined;
        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        }
        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
          if (!(--jQuery.active)) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }
      return jqXHR;
    },
    getJSON: function(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function(i, method) {
    jQuery[method] = function(url, data, callback, type) {
      if (jQuery.isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      }
      return jQuery.ajax(jQuery.extend({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject(url) && url));
    };
  });
  jQuery._evalUrl = function(url) {
    return jQuery.ajax({
      url: url,
      type: "GET",
      dataType: "script",
      async: false,
      global: false,
      "throws": true
    });
  };
  jQuery.fn.extend({
    wrapAll: function(html) {
      var wrap;
      if (jQuery.isFunction(html)) {
        return this.each(function(i) {
          jQuery(this).wrapAll(html.call(this, i));
        });
      }
      if (this[0]) {
        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }
        wrap.map(function() {
          var elem = this;
          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }
          return elem;
        }).append(this);
      }
      return this;
    },
    wrapInner: function(html) {
      if (jQuery.isFunction(html)) {
        return this.each(function(i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }
      return this.each(function() {
        var self = jQuery(this),
            contents = self.contents();
        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function(html) {
      var isFunction = jQuery.isFunction(html);
      return this.each(function(i) {
        jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function() {
      return this.parent().each(function() {
        if (!jQuery.nodeName(this, "body")) {
          jQuery(this).replaceWith(this.childNodes);
        }
      }).end();
    }
  });
  jQuery.expr.filters.hidden = function(elem) {
    return !jQuery.expr.filters.visible(elem);
  };
  jQuery.expr.filters.visible = function(elem) {
    return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
  };
  var r20 = /%20/g,
      rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (jQuery.isArray(obj)) {
      jQuery.each(obj, function(i, v) {
        if (traditional || rbracket.test(prefix)) {
          add(prefix, v);
        } else {
          buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && jQuery.type(obj) === "object") {
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      add(prefix, obj);
    }
  }
  jQuery.param = function(a, traditional) {
    var prefix,
        s = [],
        add = function(key, value) {
          value = jQuery.isFunction(value) ? value() : (value == null ? "" : value);
          s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
        };
    if (traditional === undefined) {
      traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
    }
    if (jQuery.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
      jQuery.each(a, function() {
        add(this.name, this.value);
      });
    } else {
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }
    return s.join("&").replace(r20, "+");
  };
  jQuery.fn.extend({
    serialize: function() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function() {
      return this.map(function() {
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function() {
        var type = this.type;
        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function(i, elem) {
        var val = jQuery(this).val();
        return val == null ? null : jQuery.isArray(val) ? jQuery.map(val, function(val) {
          return {
            name: elem.name,
            value: val.replace(rCRLF, "\r\n")
          };
        }) : {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  });
  jQuery.ajaxSettings.xhr = function() {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  };
  var xhrSuccessStatus = {
    0: 200,
    1223: 204
  },
      xhrSupported = jQuery.ajaxSettings.xhr();
  support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
  support.ajax = xhrSupported = !!xhrSupported;
  jQuery.ajaxTransport(function(options) {
    var callback,
        errorCallback;
    if (support.cors || xhrSupported && !options.crossDomain) {
      return {
        send: function(headers, complete) {
          var i,
              xhr = options.xhr();
          xhr.open(options.type, options.url, options.async, options.username, options.password);
          if (options.xhrFields) {
            for (i in options.xhrFields) {
              xhr[i] = options.xhrFields[i];
            }
          }
          if (options.mimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(options.mimeType);
          }
          if (!options.crossDomain && !headers["X-Requested-With"]) {
            headers["X-Requested-With"] = "XMLHttpRequest";
          }
          for (i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }
          callback = function(type) {
            return function() {
              if (callback) {
                callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
                if (type === "abort") {
                  xhr.abort();
                } else if (type === "error") {
                  if (typeof xhr.status !== "number") {
                    complete(0, "error");
                  } else {
                    complete(xhr.status, xhr.statusText);
                  }
                } else {
                  complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {binary: xhr.response} : {text: xhr.responseText}, xhr.getAllResponseHeaders());
                }
              }
            };
          };
          xhr.onload = callback();
          errorCallback = xhr.onerror = callback("error");
          if (xhr.onabort !== undefined) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4) {
                window.setTimeout(function() {
                  if (callback) {
                    errorCallback();
                  }
                });
              }
            };
          }
          callback = callback("abort");
          try {
            xhr.send(options.hasContent && options.data || null);
          } catch (e) {
            if (callback) {
              throw e;
            }
          }
        },
        abort: function() {
          if (callback) {
            callback();
          }
        }
      };
    }
  });
  jQuery.ajaxSetup({
    accepts: {script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"},
    contents: {script: /\b(?:java|ecma)script\b/},
    converters: {"text script": function(text) {
        jQuery.globalEval(text);
        return text;
      }}
  });
  jQuery.ajaxPrefilter("script", function(s) {
    if (s.cache === undefined) {
      s.cache = false;
    }
    if (s.crossDomain) {
      s.type = "GET";
    }
  });
  jQuery.ajaxTransport("script", function(s) {
    if (s.crossDomain) {
      var script,
          callback;
      return {
        send: function(_, complete) {
          script = jQuery("<script>").prop({
            charset: s.scriptCharset,
            src: s.url
          }).on("load error", callback = function(evt) {
            script.remove();
            callback = null;
            if (evt) {
              complete(evt.type === "error" ? 404 : 200, evt.type);
            }
          });
          document.head.appendChild(script[0]);
        },
        abort: function() {
          if (callback) {
            callback();
          }
        }
      };
    }
  });
  var oldCallbacks = [],
      rjsonp = /(=)\?(?=&|$)|\?\?/;
  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function() {
      var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce++));
      this[callback] = true;
      return callback;
    }
  });
  jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
    var callbackName,
        overwritten,
        responseContainer,
        jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
    if (jsonProp || s.dataTypes[0] === "jsonp") {
      callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      }
      s.converters["script json"] = function() {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }
        return responseContainer[0];
      };
      s.dataTypes[0] = "json";
      overwritten = window[callbackName];
      window[callbackName] = function() {
        responseContainer = arguments;
      };
      jqXHR.always(function() {
        if (overwritten === undefined) {
          jQuery(window).removeProp(callbackName);
        } else {
          window[callbackName] = overwritten;
        }
        if (s[callbackName]) {
          s.jsonpCallback = originalSettings.jsonpCallback;
          oldCallbacks.push(callbackName);
        }
        if (responseContainer && jQuery.isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }
        responseContainer = overwritten = undefined;
      });
      return "script";
    }
  });
  jQuery.parseHTML = function(data, context, keepScripts) {
    if (!data || typeof data !== "string") {
      return null;
    }
    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }
    context = context || document;
    var parsed = rsingleTag.exec(data),
        scripts = !keepScripts && [];
    if (parsed) {
      return [context.createElement(parsed[1])];
    }
    parsed = buildFragment([data], context, scripts);
    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }
    return jQuery.merge([], parsed.childNodes);
  };
  var _load = jQuery.fn.load;
  jQuery.fn.load = function(url, params, callback) {
    if (typeof url !== "string" && _load) {
      return _load.apply(this, arguments);
    }
    var selector,
        type,
        response,
        self = this,
        off = url.indexOf(" ");
    if (off > -1) {
      selector = jQuery.trim(url.slice(off));
      url = url.slice(0, off);
    }
    if (jQuery.isFunction(params)) {
      callback = params;
      params = undefined;
    } else if (params && typeof params === "object") {
      type = "POST";
    }
    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        type: type || "GET",
        dataType: "html",
        data: params
      }).done(function(responseText) {
        response = arguments;
        self.html(selector ? jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : responseText);
      }).always(callback && function(jqXHR, status) {
        self.each(function() {
          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
        });
      });
    }
    return this;
  };
  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(i, type) {
    jQuery.fn[type] = function(fn) {
      return this.on(type, fn);
    };
  });
  jQuery.expr.filters.animated = function(elem) {
    return jQuery.grep(jQuery.timers, function(fn) {
      return elem === fn.elem;
    }).length;
  };
  function getWindow(elem) {
    return jQuery.isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
  }
  jQuery.offset = {setOffset: function(elem, options, i) {
      var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = jQuery.css(elem, "position"),
          curElem = jQuery(elem),
          props = {};
      if (position === "static") {
        elem.style.position = "relative";
      }
      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }
      if (jQuery.isFunction(options)) {
        options = options.call(elem, i, jQuery.extend({}, curOffset));
      }
      if (options.top != null) {
        props.top = (options.top - curOffset.top) + curTop;
      }
      if (options.left != null) {
        props.left = (options.left - curOffset.left) + curLeft;
      }
      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }};
  jQuery.fn.extend({
    offset: function(options) {
      if (arguments.length) {
        return options === undefined ? this : this.each(function(i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }
      var docElem,
          win,
          elem = this[0],
          box = {
            top: 0,
            left: 0
          },
          doc = elem && elem.ownerDocument;
      if (!doc) {
        return;
      }
      docElem = doc.documentElement;
      if (!jQuery.contains(docElem, elem)) {
        return box;
      }
      box = elem.getBoundingClientRect();
      win = getWindow(doc);
      return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft
      };
    },
    position: function() {
      if (!this[0]) {
        return;
      }
      var offsetParent,
          offset,
          elem = this[0],
          parentOffset = {
            top: 0,
            left: 0
          };
      if (jQuery.css(elem, "position") === "fixed") {
        offset = elem.getBoundingClientRect();
      } else {
        offsetParent = this.offsetParent();
        offset = this.offset();
        if (!jQuery.nodeName(offsetParent[0], "html")) {
          parentOffset = offsetParent.offset();
        }
        parentOffset.top += jQuery.css(offsetParent[0], "borderTopWidth", true);
        parentOffset.left += jQuery.css(offsetParent[0], "borderLeftWidth", true);
      }
      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    offsetParent: function() {
      return this.map(function() {
        var offsetParent = this.offsetParent;
        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || documentElement;
      });
    }
  });
  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function(method, prop) {
    var top = "pageYOffset" === prop;
    jQuery.fn[method] = function(val) {
      return access(this, function(elem, method, val) {
        var win = getWindow(elem);
        if (val === undefined) {
          return win ? win[prop] : elem[method];
        }
        if (win) {
          win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length);
    };
  });
  jQuery.each(["top", "left"], function(i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop);
        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  });
  jQuery.each({
    Height: "height",
    Width: "width"
  }, function(name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function(defaultExtra, funcName) {
      jQuery.fn[funcName] = function(margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
            extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return access(this, function(elem, type, value) {
          var doc;
          if (jQuery.isWindow(elem)) {
            return elem.document.documentElement["client" + name];
          }
          if (elem.nodeType === 9) {
            doc = elem.documentElement;
            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }
          return value === undefined ? jQuery.css(elem, type, extra) : jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable, null);
      };
    });
  });
  jQuery.fn.extend({
    bind: function(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function(selector, types, fn) {
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    },
    size: function() {
      return this.length;
    }
  });
  jQuery.fn.andSelf = jQuery.fn.addBack;
  if (typeof define === "function" && define.amd) {
    define("5c", [], function() {
      return jQuery;
    }) && define("jquery", ["5c"], function(m) {
      return m;
    });
  }
  var _jQuery = window.jQuery,
      _$ = window.$;
  jQuery.noConflict = function(deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }
    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }
    return jQuery;
  };
  if (!noGlobal) {
    window.jQuery = window.$ = jQuery;
  }
  return jQuery;
}));

})();
(function() {
var define = $__System.amdDefine;
define("40", ["5c"], function(main) {
  return main;
});

})();
$__System.registerDynamic("5d", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {})(this);

  return _retrieveGlobal();
});
$__System.registerDynamic("5e", ["40", "5d"], false, function ($__require, $__exports, $__module) {
	var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, "$", null);

	(function ($__global) {
		/* */
		"format global";
		"deps jquery";
		"deps ../css/jquery.dataTables.css!";
		"exports $";
		/*! DataTables 1.10.18
   * ©2008-2018 SpryMedia Ltd - datatables.net/license
   */

		/**
   * @summary     DataTables
   * @description Paginate, search and order HTML tables
   * @version     1.10.18
   * @file        jquery.dataTables.js
   * @author      SpryMedia Ltd
   * @contact     www.datatables.net
   * @copyright   Copyright 2008-2018 SpryMedia Ltd.
   *
   * This source file is free software, available under the following license:
   *   MIT license - http://datatables.net/license
   *
   * This source file is distributed in the hope that it will be useful, but
   * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
   * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
   *
   * For details please refer to: http://www.datatables.net
   */

		/*jslint evil: true, undef: true, browser: true */
		/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/

		(function (factory) {
			"use strict";

			if (typeof define === 'function' && define.amd) {
				// AMD
				define(['jquery'], function ($) {
					return factory($, window, document);
				});
			} else if (typeof exports === 'object') {
				// CommonJS
				module.exports = function (root, $) {
					if (!root) {
						// CommonJS environments without a window global must pass a
						// root. This will give an error otherwise
						root = window;
					}

					if (!$) {
						$ = typeof window !== 'undefined' ? // jQuery's factory checks for a global window
						require('jquery') : require('jquery')(root);
					}

					return factory($, root, root.document);
				};
			} else {
				// Browser
				factory(jQuery, window, document);
			}
		})(function ($, window, document, undefined) {
			"use strict";

			/**
    * DataTables is a plug-in for the jQuery Javascript library. It is a highly
    * flexible tool, based upon the foundations of progressive enhancement,
    * which will add advanced interaction controls to any HTML table. For a
    * full list of features please refer to
    * [DataTables.net](href="http://datatables.net).
    *
    * Note that the `DataTable` object is not a global variable but is aliased
    * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
    * be  accessed.
    *
    *  @class
    *  @param {object} [init={}] Configuration object for DataTables. Options
    *    are defined by {@link DataTable.defaults}
    *  @requires jQuery 1.7+
    *
    *  @example
    *    // Basic initialisation
    *    $(document).ready( function {
    *      $('#example').dataTable();
    *    } );
    *
    *  @example
    *    // Initialisation with configuration options - in this case, disable
    *    // pagination and sorting.
    *    $(document).ready( function {
    *      $('#example').dataTable( {
    *        "paginate": false,
    *        "sort": false
    *      } );
    *    } );
    */

			var DataTable = function (options) {
				/**
     * Perform a jQuery selector action on the table's TR elements (from the tbody) and
     * return the resulting jQuery object.
     *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
     *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
     *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
     *    criterion ("applied") or all TR elements (i.e. no filter).
     *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
     *    Can be either 'current', whereby the current sorting of the table is used, or
     *    'original' whereby the original order the data was read into the table is used.
     *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
     *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
     *    'current' and filter is 'applied', regardless of what they might be given as.
     *  @returns {object} jQuery object, filtered by the given selector.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Highlight every second row
     *      oTable.$('tr:odd').css('backgroundColor', 'blue');
     *    } );
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Filter to rows with 'Webkit' in them, add a background colour and then
     *      // remove the filter, thus highlighting the 'Webkit' rows only.
     *      oTable.fnFilter('Webkit');
     *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
     *      oTable.fnFilter('');
     *    } );
     */
				this.$ = function (sSelector, oOpts) {
					return this.api(true).$(sSelector, oOpts);
				};

				/**
     * Almost identical to $ in operation, but in this case returns the data for the matched
     * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
     * rather than any descendants, so the data can be obtained for the row/cell. If matching
     * rows are found, the data returned is the original data array/object that was used to
     * create the row (or a generated array if from a DOM source).
     *
     * This method is often useful in-combination with $ where both functions are given the
     * same parameters and the array indexes will match identically.
     *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
     *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
     *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
     *    criterion ("applied") or all elements (i.e. no filter).
     *  @param {string} [oOpts.order=current] Order of the data in the processed array.
     *    Can be either 'current', whereby the current sorting of the table is used, or
     *    'original' whereby the original order the data was read into the table is used.
     *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
     *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
     *    'current' and filter is 'applied', regardless of what they might be given as.
     *  @returns {array} Data for the matched elements. If any elements, as a result of the
     *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
     *    entry in the array.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Get the data from the first row in the table
     *      var data = oTable._('tr:first');
     *
     *      // Do something useful with the data
     *      alert( "First cell is: "+data[0] );
     *    } );
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Filter to 'Webkit' and get all data for
     *      oTable.fnFilter('Webkit');
     *      var data = oTable._('tr', {"search": "applied"});
     *
     *      // Do something with the data
     *      alert( data.length+" rows matched the search" );
     *    } );
     */
				this._ = function (sSelector, oOpts) {
					return this.api(true).rows(sSelector, oOpts).data();
				};

				/**
     * Create a DataTables Api instance, with the currently selected tables for
     * the Api's context.
     * @param {boolean} [traditional=false] Set the API instance's context to be
     *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
     *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
     *   or if all tables captured in the jQuery object should be used.
     * @return {DataTables.Api}
     */
				this.api = function (traditional) {
					return traditional ? new _Api(_fnSettingsFromNode(this[_ext.iApiIndex])) : new _Api(this);
				};

				/**
     * Add a single new row or multiple rows of data to the table. Please note
     * that this is suitable for client-side processing only - if you are using
     * server-side processing (i.e. "bServerSide": true), then to add data, you
     * must add it to the data source, i.e. the server-side, through an Ajax call.
     *  @param {array|object} data The data to be added to the table. This can be:
     *    <ul>
     *      <li>1D array of data - add a single row with the data provided</li>
     *      <li>2D array of arrays - add multiple rows in a single call</li>
     *      <li>object - data object when using <i>mData</i></li>
     *      <li>array of objects - multiple data objects when using <i>mData</i></li>
     *    </ul>
     *  @param {bool} [redraw=true] redraw the table or not
     *  @returns {array} An array of integers, representing the list of indexes in
     *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
     *    the table.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    // Global var for counter
     *    var giCount = 2;
     *
     *    $(document).ready(function() {
     *      $('#example').dataTable();
     *    } );
     *
     *    function fnClickAddRow() {
     *      $('#example').dataTable().fnAddData( [
     *        giCount+".1",
     *        giCount+".2",
     *        giCount+".3",
     *        giCount+".4" ]
     *      );
     *
     *      giCount++;
     *    }
     */
				this.fnAddData = function (data, redraw) {
					var api = this.api(true);

					/* Check if we want to add multiple rows or not */
					var rows = $.isArray(data) && ($.isArray(data[0]) || $.isPlainObject(data[0])) ? api.rows.add(data) : api.row.add(data);

					if (redraw === undefined || redraw) {
						api.draw();
					}

					return rows.flatten().toArray();
				};

				/**
     * This function will make DataTables recalculate the column sizes, based on the data
     * contained in the table and the sizes applied to the columns (in the DOM, CSS or
     * through the sWidth parameter). This can be useful when the width of the table's
     * parent element changes (for example a window resize).
     *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable( {
     *        "sScrollY": "200px",
     *        "bPaginate": false
     *      } );
     *
     *      $(window).on('resize', function () {
     *        oTable.fnAdjustColumnSizing();
     *      } );
     *    } );
     */
				this.fnAdjustColumnSizing = function (bRedraw) {
					var api = this.api(true).columns.adjust();
					var settings = api.settings()[0];
					var scroll = settings.oScroll;

					if (bRedraw === undefined || bRedraw) {
						api.draw(false);
					} else if (scroll.sX !== "" || scroll.sY !== "") {
						/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
						_fnScrollDraw(settings);
					}
				};

				/**
     * Quickly and simply clear a table
     *  @param {bool} [bRedraw=true] redraw the table or not
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
     *      oTable.fnClearTable();
     *    } );
     */
				this.fnClearTable = function (bRedraw) {
					var api = this.api(true).clear();

					if (bRedraw === undefined || bRedraw) {
						api.draw();
					}
				};

				/**
     * The exact opposite of 'opening' a row, this function will close any rows which
     * are currently 'open'.
     *  @param {node} nTr the table row to 'close'
     *  @returns {int} 0 on success, or 1 if failed (can't find the row)
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable;
     *
     *      // 'open' an information row when a row is clicked on
     *      $('#example tbody tr').click( function () {
     *        if ( oTable.fnIsOpen(this) ) {
     *          oTable.fnClose( this );
     *        } else {
     *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
     *        }
     *      } );
     *
     *      oTable = $('#example').dataTable();
     *    } );
     */
				this.fnClose = function (nTr) {
					this.api(true).row(nTr).child.hide();
				};

				/**
     * Remove a row for the table
     *  @param {mixed} target The index of the row from aoData to be deleted, or
     *    the TR element you want to delete
     *  @param {function|null} [callBack] Callback function
     *  @param {bool} [redraw=true] Redraw the table or not
     *  @returns {array} The row that was deleted
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Immediately remove the first row
     *      oTable.fnDeleteRow( 0 );
     *    } );
     */
				this.fnDeleteRow = function (target, callback, redraw) {
					var api = this.api(true);
					var rows = api.rows(target);
					var settings = rows.settings()[0];
					var data = settings.aoData[rows[0][0]];

					rows.remove();

					if (callback) {
						callback.call(this, settings, data);
					}

					if (redraw === undefined || redraw) {
						api.draw();
					}

					return data;
				};

				/**
     * Restore the table to it's original state in the DOM by removing all of DataTables
     * enhancements, alterations to the DOM structure of the table and event listeners.
     *  @param {boolean} [remove=false] Completely remove the table from the DOM
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
     *      var oTable = $('#example').dataTable();
     *      oTable.fnDestroy();
     *    } );
     */
				this.fnDestroy = function (remove) {
					this.api(true).destroy(remove);
				};

				/**
     * Redraw the table
     *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
     *      oTable.fnDraw();
     *    } );
     */
				this.fnDraw = function (complete) {
					// Note that this isn't an exact match to the old call to _fnDraw - it takes
					// into account the new data, but can hold position.
					this.api(true).draw(complete);
				};

				/**
     * Filter the input based on data
     *  @param {string} sInput String to filter the table on
     *  @param {int|null} [iColumn] Column to limit filtering to
     *  @param {bool} [bRegex=false] Treat as regular expression or not
     *  @param {bool} [bSmart=true] Perform smart filtering or not
     *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
     *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Sometime later - filter...
     *      oTable.fnFilter( 'test string' );
     *    } );
     */
				this.fnFilter = function (sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive) {
					var api = this.api(true);

					if (iColumn === null || iColumn === undefined) {
						api.search(sInput, bRegex, bSmart, bCaseInsensitive);
					} else {
						api.column(iColumn).search(sInput, bRegex, bSmart, bCaseInsensitive);
					}

					api.draw();
				};

				/**
     * Get the data for the whole table, an individual row or an individual cell based on the
     * provided parameters.
     *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
     *    a TR node then the data source for the whole row will be returned. If given as a
     *    TD/TH cell node then iCol will be automatically calculated and the data for the
     *    cell returned. If given as an integer, then this is treated as the aoData internal
     *    data index for the row (see fnGetPosition) and the data for that row used.
     *  @param {int} [col] Optional column index that you want the data of.
     *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
     *    returned. If mRow is defined, just data for that row, and is iCol is
     *    defined, only data for the designated cell is returned.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    // Row data
     *    $(document).ready(function() {
     *      oTable = $('#example').dataTable();
     *
     *      oTable.$('tr').click( function () {
     *        var data = oTable.fnGetData( this );
     *        // ... do something with the array / object of data for the row
     *      } );
     *    } );
     *
     *  @example
     *    // Individual cell data
     *    $(document).ready(function() {
     *      oTable = $('#example').dataTable();
     *
     *      oTable.$('td').click( function () {
     *        var sData = oTable.fnGetData( this );
     *        alert( 'The cell clicked on had the value of '+sData );
     *      } );
     *    } );
     */
				this.fnGetData = function (src, col) {
					var api = this.api(true);

					if (src !== undefined) {
						var type = src.nodeName ? src.nodeName.toLowerCase() : '';

						return col !== undefined || type == 'td' || type == 'th' ? api.cell(src, col).data() : api.row(src).data() || null;
					}

					return api.data().toArray();
				};

				/**
     * Get an array of the TR nodes that are used in the table's body. Note that you will
     * typically want to use the '$' API method in preference to this as it is more
     * flexible.
     *  @param {int} [iRow] Optional row index for the TR element you want
     *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
     *    in the table's body, or iRow is defined, just the TR element requested.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Get the nodes from the table
     *      var nNodes = oTable.fnGetNodes( );
     *    } );
     */
				this.fnGetNodes = function (iRow) {
					var api = this.api(true);

					return iRow !== undefined ? api.row(iRow).node() : api.rows().nodes().flatten().toArray();
				};

				/**
     * Get the array indexes of a particular cell from it's DOM element
     * and column index including hidden columns
     *  @param {node} node this can either be a TR, TD or TH in the table's body
     *  @returns {int} If nNode is given as a TR, then a single index is returned, or
     *    if given as a cell, an array of [row index, column index (visible),
     *    column index (all)] is given.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      $('#example tbody td').click( function () {
     *        // Get the position of the current data from the node
     *        var aPos = oTable.fnGetPosition( this );
     *
     *        // Get the data array for this row
     *        var aData = oTable.fnGetData( aPos[0] );
     *
     *        // Update the data array and return the value
     *        aData[ aPos[1] ] = 'clicked';
     *        this.innerHTML = 'clicked';
     *      } );
     *
     *      // Init DataTables
     *      oTable = $('#example').dataTable();
     *    } );
     */
				this.fnGetPosition = function (node) {
					var api = this.api(true);
					var nodeName = node.nodeName.toUpperCase();

					if (nodeName == 'TR') {
						return api.row(node).index();
					} else if (nodeName == 'TD' || nodeName == 'TH') {
						var cell = api.cell(node).index();

						return [cell.row, cell.columnVisible, cell.column];
					}
					return null;
				};

				/**
     * Check to see if a row is 'open' or not.
     *  @param {node} nTr the table row to check
     *  @returns {boolean} true if the row is currently open, false otherwise
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable;
     *
     *      // 'open' an information row when a row is clicked on
     *      $('#example tbody tr').click( function () {
     *        if ( oTable.fnIsOpen(this) ) {
     *          oTable.fnClose( this );
     *        } else {
     *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
     *        }
     *      } );
     *
     *      oTable = $('#example').dataTable();
     *    } );
     */
				this.fnIsOpen = function (nTr) {
					return this.api(true).row(nTr).child.isShown();
				};

				/**
     * This function will place a new row directly after a row which is currently
     * on display on the page, with the HTML contents that is passed into the
     * function. This can be used, for example, to ask for confirmation that a
     * particular record should be deleted.
     *  @param {node} nTr The table row to 'open'
     *  @param {string|node|jQuery} mHtml The HTML to put into the row
     *  @param {string} sClass Class to give the new TD cell
     *  @returns {node} The row opened. Note that if the table row passed in as the
     *    first parameter, is not found in the table, this method will silently
     *    return.
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable;
     *
     *      // 'open' an information row when a row is clicked on
     *      $('#example tbody tr').click( function () {
     *        if ( oTable.fnIsOpen(this) ) {
     *          oTable.fnClose( this );
     *        } else {
     *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
     *        }
     *      } );
     *
     *      oTable = $('#example').dataTable();
     *    } );
     */
				this.fnOpen = function (nTr, mHtml, sClass) {
					return this.api(true).row(nTr).child(mHtml, sClass).show().child()[0];
				};

				/**
     * Change the pagination - provides the internal logic for pagination in a simple API
     * function. With this function you can have a DataTables table go to the next,
     * previous, first or last pages.
     *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
     *    or page number to jump to (integer), note that page 0 is the first page.
     *  @param {bool} [bRedraw=true] Redraw the table or not
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *      oTable.fnPageChange( 'next' );
     *    } );
     */
				this.fnPageChange = function (mAction, bRedraw) {
					var api = this.api(true).page(mAction);

					if (bRedraw === undefined || bRedraw) {
						api.draw(false);
					}
				};

				/**
     * Show a particular column
     *  @param {int} iCol The column whose display should be changed
     *  @param {bool} bShow Show (true) or hide (false) the column
     *  @param {bool} [bRedraw=true] Redraw the table or not
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Hide the second column after initialisation
     *      oTable.fnSetColumnVis( 1, false );
     *    } );
     */
				this.fnSetColumnVis = function (iCol, bShow, bRedraw) {
					var api = this.api(true).column(iCol).visible(bShow);

					if (bRedraw === undefined || bRedraw) {
						api.columns.adjust().draw();
					}
				};

				/**
     * Get the settings for a particular table for external manipulation
     *  @returns {object} DataTables settings object. See
     *    {@link DataTable.models.oSettings}
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *      var oSettings = oTable.fnSettings();
     *
     *      // Show an example parameter from the settings
     *      alert( oSettings._iDisplayStart );
     *    } );
     */
				this.fnSettings = function () {
					return _fnSettingsFromNode(this[_ext.iApiIndex]);
				};

				/**
     * Sort the table by a particular column
     *  @param {int} iCol the data index to sort on. Note that this will not match the
     *    'display index' if you have hidden data entries
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Sort immediately with columns 0 and 1
     *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
     *    } );
     */
				this.fnSort = function (aaSort) {
					this.api(true).order(aaSort).draw();
				};

				/**
     * Attach a sort listener to an element for a given column
     *  @param {node} nNode the element to attach the sort listener to
     *  @param {int} iColumn the column that a click on this node will sort on
     *  @param {function} [fnCallback] callback function when sort is run
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *
     *      // Sort on column 1, when 'sorter' is clicked on
     *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
     *    } );
     */
				this.fnSortListener = function (nNode, iColumn, fnCallback) {
					this.api(true).order.listener(nNode, iColumn, fnCallback);
				};

				/**
     * Update a table cell or row - this method will accept either a single value to
     * update the cell with, an array of values with one element for each column or
     * an object in the same format as the original data source. The function is
     * self-referencing in order to make the multi column updates easier.
     *  @param {object|array|string} mData Data to update the cell/row with
     *  @param {node|int} mRow TR element you want to update or the aoData index
     *  @param {int} [iColumn] The column to update, give as null or undefined to
     *    update a whole row.
     *  @param {bool} [bRedraw=true] Redraw the table or not
     *  @param {bool} [bAction=true] Perform pre-draw actions or not
     *  @returns {int} 0 on success, 1 on error
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
     *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
     *    } );
     */
				this.fnUpdate = function (mData, mRow, iColumn, bRedraw, bAction) {
					var api = this.api(true);

					if (iColumn === undefined || iColumn === null) {
						api.row(mRow).data(mData);
					} else {
						api.cell(mRow, iColumn).data(mData);
					}

					if (bAction === undefined || bAction) {
						api.columns.adjust();
					}

					if (bRedraw === undefined || bRedraw) {
						api.draw();
					}
					return 0;
				};

				/**
     * Provide a common method for plug-ins to check the version of DataTables being used, in order
     * to ensure compatibility.
     *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
     *    formats "X" and "X.Y" are also acceptable.
     *  @returns {boolean} true if this version of DataTables is greater or equal to the required
     *    version, or false if this version of DataTales is not suitable
     *  @method
     *  @dtopt API
     *  @deprecated Since v1.10
     *
     *  @example
     *    $(document).ready(function() {
     *      var oTable = $('#example').dataTable();
     *      alert( oTable.fnVersionCheck( '1.9.0' ) );
     *    } );
     */
				this.fnVersionCheck = _ext.fnVersionCheck;

				var _that = this;
				var emptyInit = options === undefined;
				var len = this.length;

				if (emptyInit) {
					options = {};
				}

				this.oApi = this.internal = _ext.internal;

				// Extend with old style plug-in API methods
				for (var fn in DataTable.ext.internal) {
					if (fn) {
						this[fn] = _fnExternApiFunc(fn);
					}
				}

				this.each(function () {
					// For each initialisation we want to give it a clean initialisation
					// object that can be bashed around
					var o = {};
					var oInit = len > 1 ? // optimisation for single table case
					_fnExtend(o, options, true) : options;

					/*global oInit,_that,emptyInit*/
					var i = 0,
					    iLen,
					    j,
					    jLen,
					    k,
					    kLen;
					var sId = this.getAttribute('id');
					var bInitHandedOff = false;
					var defaults = DataTable.defaults;
					var $this = $(this);

					/* Sanity check */
					if (this.nodeName.toLowerCase() != 'table') {
						_fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
						return;
					}

					/* Backwards compatibility for the defaults */
					_fnCompatOpts(defaults);
					_fnCompatCols(defaults.column);

					/* Convert the camel-case defaults to Hungarian */
					_fnCamelToHungarian(defaults, defaults, true);
					_fnCamelToHungarian(defaults.column, defaults.column, true);

					/* Setting up the initialisation object */
					_fnCamelToHungarian(defaults, $.extend(oInit, $this.data()));

					/* Check to see if we are re-initialising a table */
					var allSettings = DataTable.settings;
					for (i = 0, iLen = allSettings.length; i < iLen; i++) {
						var s = allSettings[i];

						/* Base check on table node */
						if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
							var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
							var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;

							if (emptyInit || bRetrieve) {
								return s.oInstance;
							} else if (bDestroy) {
								s.oInstance.fnDestroy();
								break;
							} else {
								_fnLog(s, 0, 'Cannot reinitialise DataTable', 3);
								return;
							}
						}

						/* If the element we are initialising has the same ID as a table which was previously
       * initialised, but the table nodes don't match (from before) then we destroy the old
       * instance by simply deleting it. This is under the assumption that the table has been
       * destroyed by other methods. Anyone using non-id selectors will need to do this manually
       */
						if (s.sTableId == this.id) {
							allSettings.splice(i, 1);
							break;
						}
					}

					/* Ensure the table has an ID - required for accessibility */
					if (sId === null || sId === "") {
						sId = "DataTables_Table_" + DataTable.ext._unique++;
						this.id = sId;
					}

					/* Create the settings object for this table and set some of the default parameters */
					var oSettings = $.extend(true, {}, DataTable.models.oSettings, {
						"sDestroyWidth": $this[0].style.width,
						"sInstance": sId,
						"sTableId": sId
					});
					oSettings.nTable = this;
					oSettings.oApi = _that.internal;
					oSettings.oInit = oInit;

					allSettings.push(oSettings);

					// Need to add the instance after the instance after the settings object has been added
					// to the settings array, so we can self reference the table instance if more than one
					oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();

					// Backwards compatibility, before we apply all the defaults
					_fnCompatOpts(oInit);
					_fnLanguageCompat(oInit.oLanguage);

					// If the length menu is given, but the init display length is not, use the length menu
					if (oInit.aLengthMenu && !oInit.iDisplayLength) {
						oInit.iDisplayLength = $.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
					}

					// Apply the defaults and init options to make a single init object will all
					// options defined from defaults and instance options.
					oInit = _fnExtend($.extend(true, {}, defaults), oInit);

					// Map the initialisation options onto the settings object
					_fnMap(oSettings.oFeatures, oInit, ["bPaginate", "bLengthChange", "bFilter", "bSort", "bSortMulti", "bInfo", "bProcessing", "bAutoWidth", "bSortClasses", "bServerSide", "bDeferRender"]);
					_fnMap(oSettings, oInit, ["asStripeClasses", "ajax", "fnServerData", "fnFormatNumber", "sServerMethod", "aaSorting", "aaSortingFixed", "aLengthMenu", "sPaginationType", "sAjaxSource", "sAjaxDataProp", "iStateDuration", "sDom", "bSortCellsTop", "iTabIndex", "fnStateLoadCallback", "fnStateSaveCallback", "renderer", "searchDelay", "rowId", ["iCookieDuration", "iStateDuration"], // backwards compat
					["oSearch", "oPreviousSearch"], ["aoSearchCols", "aoPreSearchCols"], ["iDisplayLength", "_iDisplayLength"]]);
					_fnMap(oSettings.oScroll, oInit, [["sScrollX", "sX"], ["sScrollXInner", "sXInner"], ["sScrollY", "sY"], ["bScrollCollapse", "bCollapse"]]);
					_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");

					/* Callback functions which are array driven */
					_fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback, 'user');
					_fnCallbackReg(oSettings, 'aoServerParams', oInit.fnServerParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded, 'user');
					_fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback, 'user');
					_fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow, 'user');
					_fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback, 'user');
					_fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback, 'user');
					_fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete, 'user');
					_fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback, 'user');

					oSettings.rowIdFn = _fnGetObjectDataFn(oInit.rowId);

					/* Browser support detection */
					_fnBrowserDetect(oSettings);

					var oClasses = oSettings.oClasses;

					$.extend(oClasses, DataTable.ext.classes, oInit.oClasses);
					$this.addClass(oClasses.sTable);

					if (oSettings.iInitDisplayStart === undefined) {
						/* Display start point, taking into account the save saving */
						oSettings.iInitDisplayStart = oInit.iDisplayStart;
						oSettings._iDisplayStart = oInit.iDisplayStart;
					}

					if (oInit.iDeferLoading !== null) {
						oSettings.bDeferLoading = true;
						var tmp = $.isArray(oInit.iDeferLoading);
						oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
						oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
					}

					/* Language definitions */
					var oLanguage = oSettings.oLanguage;
					$.extend(true, oLanguage, oInit.oLanguage);

					if (oLanguage.sUrl) {
						/* Get the language definitions from a file - because this Ajax call makes the language
       * get async to the remainder of this function we use bInitHandedOff to indicate that
       * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
       */
						$.ajax({
							dataType: 'json',
							url: oLanguage.sUrl,
							success: function (json) {
								_fnLanguageCompat(json);
								_fnCamelToHungarian(defaults.oLanguage, json);
								$.extend(true, oLanguage, json);
								_fnInitialise(oSettings);
							},
							error: function () {
								// Error occurred loading language file, continue on as best we can
								_fnInitialise(oSettings);
							}
						});
						bInitHandedOff = true;
					}

					/*
      * Stripes
      */
					if (oInit.asStripeClasses === null) {
						oSettings.asStripeClasses = [oClasses.sStripeOdd, oClasses.sStripeEven];
					}

					/* Remove row stripe classes if they are already on the table row */
					var stripeClasses = oSettings.asStripeClasses;
					var rowOne = $this.children('tbody').find('tr').eq(0);
					if ($.inArray(true, $.map(stripeClasses, function (el, i) {
						return rowOne.hasClass(el);
					})) !== -1) {
						$('tbody tr', this).removeClass(stripeClasses.join(' '));
						oSettings.asDestroyStripes = stripeClasses.slice();
					}

					/*
      * Columns
      * See if we should load columns automatically or use defined ones
      */
					var anThs = [];
					var aoColumnsInit;
					var nThead = this.getElementsByTagName('thead');
					if (nThead.length !== 0) {
						_fnDetectHeader(oSettings.aoHeader, nThead[0]);
						anThs = _fnGetUniqueThs(oSettings);
					}

					/* If not given a column array, generate one with nulls */
					if (oInit.aoColumns === null) {
						aoColumnsInit = [];
						for (i = 0, iLen = anThs.length; i < iLen; i++) {
							aoColumnsInit.push(null);
						}
					} else {
						aoColumnsInit = oInit.aoColumns;
					}

					/* Add the columns */
					for (i = 0, iLen = aoColumnsInit.length; i < iLen; i++) {
						_fnAddColumn(oSettings, anThs ? anThs[i] : null);
					}

					/* Apply the column definitions */
					_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
						_fnColumnOptions(oSettings, iCol, oDef);
					});

					/* HTML5 attribute detection - build an mData object automatically if the
      * attributes are found
      */
					if (rowOne.length) {
						var a = function (cell, name) {
							return cell.getAttribute('data-' + name) !== null ? name : null;
						};

						$(rowOne[0]).children('th, td').each(function (i, cell) {
							var col = oSettings.aoColumns[i];

							if (col.mData === i) {
								var sort = a(cell, 'sort') || a(cell, 'order');
								var filter = a(cell, 'filter') || a(cell, 'search');

								if (sort !== null || filter !== null) {
									col.mData = {
										_: i + '.display',
										sort: sort !== null ? i + '.@data-' + sort : undefined,
										type: sort !== null ? i + '.@data-' + sort : undefined,
										filter: filter !== null ? i + '.@data-' + filter : undefined
									};

									_fnColumnOptions(oSettings, i);
								}
							}
						});
					}

					var features = oSettings.oFeatures;
					var loadedInit = function () {
						/*
       * Sorting
       * @todo For modularisation (1.11) this needs to do into a sort start up handler
       */

						// If aaSorting is not defined, then we use the first indicator in asSorting
						// in case that has been altered, so the default sort reflects that option
						if (oInit.aaSorting === undefined) {
							var sorting = oSettings.aaSorting;
							for (i = 0, iLen = sorting.length; i < iLen; i++) {
								sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
							}
						}

						/* Do a first pass on the sorting classes (allows any size changes to be taken into
       * account, and also will apply sorting disabled classes if disabled
       */
						_fnSortingClasses(oSettings);

						if (features.bSort) {
							_fnCallbackReg(oSettings, 'aoDrawCallback', function () {
								if (oSettings.bSorted) {
									var aSort = _fnSortFlatten(oSettings);
									var sortedColumns = {};

									$.each(aSort, function (i, val) {
										sortedColumns[val.src] = val.dir;
									});

									_fnCallbackFire(oSettings, null, 'order', [oSettings, aSort, sortedColumns]);
									_fnSortAria(oSettings);
								}
							});
						}

						_fnCallbackReg(oSettings, 'aoDrawCallback', function () {
							if (oSettings.bSorted || _fnDataSource(oSettings) === 'ssp' || features.bDeferRender) {
								_fnSortingClasses(oSettings);
							}
						}, 'sc');

						/*
       * Final init
       * Cache the header, body and footer as required, creating them if needed
       */

						// Work around for Webkit bug 83867 - store the caption-side before removing from doc
						var captions = $this.children('caption').each(function () {
							this._captionSide = $(this).css('caption-side');
						});

						var thead = $this.children('thead');
						if (thead.length === 0) {
							thead = $('<thead/>').appendTo($this);
						}
						oSettings.nTHead = thead[0];

						var tbody = $this.children('tbody');
						if (tbody.length === 0) {
							tbody = $('<tbody/>').appendTo($this);
						}
						oSettings.nTBody = tbody[0];

						var tfoot = $this.children('tfoot');
						if (tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "")) {
							// If we are a scrolling table, and no footer has been given, then we need to create
							// a tfoot element for the caption element to be appended to
							tfoot = $('<tfoot/>').appendTo($this);
						}

						if (tfoot.length === 0 || tfoot.children().length === 0) {
							$this.addClass(oClasses.sNoFooter);
						} else if (tfoot.length > 0) {
							oSettings.nTFoot = tfoot[0];
							_fnDetectHeader(oSettings.aoFooter, oSettings.nTFoot);
						}

						/* Check if there is data passing into the constructor */
						if (oInit.aaData) {
							for (i = 0; i < oInit.aaData.length; i++) {
								_fnAddData(oSettings, oInit.aaData[i]);
							}
						} else if (oSettings.bDeferLoading || _fnDataSource(oSettings) == 'dom') {
							/* Grab the data from the page - only do this when deferred loading or no Ajax
        * source since there is no point in reading the DOM data if we are then going
        * to replace it with Ajax data
        */
							_fnAddTr(oSettings, $(oSettings.nTBody).children('tr'));
						}

						/* Copy the data index array */
						oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();

						/* Initialisation complete - table can be drawn */
						oSettings.bInitialised = true;

						/* Check if we need to initialise the table (it might not have been handed off to the
       * language processor)
       */
						if (bInitHandedOff === false) {
							_fnInitialise(oSettings);
						}
					};

					/* Must be done after everything which can be overridden by the state saving! */
					if (oInit.bStateSave) {
						features.bStateSave = true;
						_fnCallbackReg(oSettings, 'aoDrawCallback', _fnSaveState, 'state_save');
						_fnLoadState(oSettings, oInit, loadedInit);
					} else {
						loadedInit();
					}
				});
				_that = null;
				return this;
			};

			/*
    * It is useful to have variables which are scoped locally so only the
    * DataTables functions can access them and they don't leak into global space.
    * At the same time these functions are often useful over multiple files in the
    * core and API, so we list, or at least document, all variables which are used
    * by DataTables as private variables here. This also ensures that there is no
    * clashing of variable names and that they can easily referenced for reuse.
    */

			// Defined else where
			//  _selector_run
			//  _selector_opts
			//  _selector_first
			//  _selector_row_indexes

			var _ext; // DataTable.ext
			var _Api; // DataTable.Api
			var _api_register; // DataTable.Api.register
			var _api_registerPlural; // DataTable.Api.registerPlural

			var _re_dic = {};
			var _re_new_lines = /[\r\n]/g;
			var _re_html = /<.*?>/g;

			// This is not strict ISO8601 - Date.parse() is quite lax, although
			// implementations differ between browsers.
			var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;

			// Escape regular expression special characters
			var _re_escape_regex = new RegExp('(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-'].join('|\\') + ')', 'g');

			// http://en.wikipedia.org/wiki/Foreign_exchange_market
			// - \u20BD - Russian ruble.
			// - \u20a9 - South Korean Won
			// - \u20BA - Turkish Lira
			// - \u20B9 - Indian Rupee
			// - R - Brazil (R$) and South Africa
			// - fr - Swiss Franc
			// - kr - Swedish krona, Norwegian krone and Danish krone
			// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
			// - Ƀ - Bitcoin
			// - Ξ - Ethereum
			//   standards as thousands separators.
			var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;

			var _empty = function (d) {
				return !d || d === true || d === '-' ? true : false;
			};

			var _intVal = function (s) {
				var integer = parseInt(s, 10);
				return !isNaN(integer) && isFinite(s) ? integer : null;
			};

			// Convert from a formatted number with characters other than `.` as the
			// decimal place, to a Javascript number
			var _numToDecimal = function (num, decimalPoint) {
				// Cache created regular expressions for speed as this function is called often
				if (!_re_dic[decimalPoint]) {
					_re_dic[decimalPoint] = new RegExp(_fnEscapeRegex(decimalPoint), 'g');
				}
				return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace(_re_dic[decimalPoint], '.') : num;
			};

			var _isNumber = function (d, decimalPoint, formatted) {
				var strType = typeof d === 'string';

				// If empty return immediately so there must be a number if it is a
				// formatted string (this stops the string "k", or "kr", etc being detected
				// as a formatted number for currency
				if (_empty(d)) {
					return true;
				}

				if (decimalPoint && strType) {
					d = _numToDecimal(d, decimalPoint);
				}

				if (formatted && strType) {
					d = d.replace(_re_formatted_numeric, '');
				}

				return !isNaN(parseFloat(d)) && isFinite(d);
			};

			// A string without HTML in it can be considered to be HTML still
			var _isHtml = function (d) {
				return _empty(d) || typeof d === 'string';
			};

			var _htmlNumeric = function (d, decimalPoint, formatted) {
				if (_empty(d)) {
					return true;
				}

				var html = _isHtml(d);
				return !html ? null : _isNumber(_stripHtml(d), decimalPoint, formatted) ? true : null;
			};

			var _pluck = function (a, prop, prop2) {
				var out = [];
				var i = 0,
				    ien = a.length;

				// Could have the test in the loop for slightly smaller code, but speed
				// is essential here
				if (prop2 !== undefined) {
					for (; i < ien; i++) {
						if (a[i] && a[i][prop]) {
							out.push(a[i][prop][prop2]);
						}
					}
				} else {
					for (; i < ien; i++) {
						if (a[i]) {
							out.push(a[i][prop]);
						}
					}
				}

				return out;
			};

			// Basically the same as _pluck, but rather than looping over `a` we use `order`
			// as the indexes to pick from `a`
			var _pluck_order = function (a, order, prop, prop2) {
				var out = [];
				var i = 0,
				    ien = order.length;

				// Could have the test in the loop for slightly smaller code, but speed
				// is essential here
				if (prop2 !== undefined) {
					for (; i < ien; i++) {
						if (a[order[i]][prop]) {
							out.push(a[order[i]][prop][prop2]);
						}
					}
				} else {
					for (; i < ien; i++) {
						out.push(a[order[i]][prop]);
					}
				}

				return out;
			};

			var _range = function (len, start) {
				var out = [];
				var end;

				if (start === undefined) {
					start = 0;
					end = len;
				} else {
					end = start;
					start = len;
				}

				for (var i = start; i < end; i++) {
					out.push(i);
				}

				return out;
			};

			var _removeEmpty = function (a) {
				var out = [];

				for (var i = 0, ien = a.length; i < ien; i++) {
					if (a[i]) {
						// careful - will remove all falsy values!
						out.push(a[i]);
					}
				}

				return out;
			};

			var _stripHtml = function (d) {
				return d.replace(_re_html, '');
			};

			/**
    * Determine if all values in the array are unique. This means we can short
    * cut the _unique method at the cost of a single loop. A sorted array is used
    * to easily check the values.
    *
    * @param  {array} src Source array
    * @return {boolean} true if all unique, false otherwise
    * @ignore
    */
			var _areAllUnique = function (src) {
				if (src.length < 2) {
					return true;
				}

				var sorted = src.slice().sort();
				var last = sorted[0];

				for (var i = 1, ien = sorted.length; i < ien; i++) {
					if (sorted[i] === last) {
						return false;
					}

					last = sorted[i];
				}

				return true;
			};

			/**
    * Find the unique elements in a source array.
    *
    * @param  {array} src Source array
    * @return {array} Array of unique items
    * @ignore
    */
			var _unique = function (src) {
				if (_areAllUnique(src)) {
					return src.slice();
				}

				// A faster unique method is to use object keys to identify used values,
				// but this doesn't work with arrays or objects, which we must also
				// consider. See jsperf.com/compare-array-unique-versions/4 for more
				// information.
				var out = [],
				    val,
				    i,
				    ien = src.length,
				    j,
				    k = 0;

				again: for (i = 0; i < ien; i++) {
					val = src[i];

					for (j = 0; j < k; j++) {
						if (out[j] === val) {
							continue again;
						}
					}

					out.push(val);
					k++;
				}

				return out;
			};

			/**
    * DataTables utility methods
    * 
    * This namespace provides helper methods that DataTables uses internally to
    * create a DataTable, but which are not exclusively used only for DataTables.
    * These methods can be used by extension authors to save the duplication of
    * code.
    *
    *  @namespace
    */
			DataTable.util = {
				/**
     * Throttle the calls to a function. Arguments and context are maintained
     * for the throttled function.
     *
     * @param {function} fn Function to be called
     * @param {integer} freq Call frequency in mS
     * @return {function} Wrapped function
     */
				throttle: function (fn, freq) {
					var frequency = freq !== undefined ? freq : 200,
					    last,
					    timer;

					return function () {
						var that = this,
						    now = +new Date(),
						    args = arguments;

						if (last && now < last + frequency) {
							clearTimeout(timer);

							timer = setTimeout(function () {
								last = undefined;
								fn.apply(that, args);
							}, frequency);
						} else {
							last = now;
							fn.apply(that, args);
						}
					};
				},

				/**
     * Escape a string such that it can be used in a regular expression
     *
     *  @param {string} val string to escape
     *  @returns {string} escaped string
     */
				escapeRegex: function (val) {
					return val.replace(_re_escape_regex, '\\$1');
				}
			};

			/**
    * Create a mapping object that allows camel case parameters to be looked up
    * for their Hungarian counterparts. The mapping is stored in a private
    * parameter called `_hungarianMap` which can be accessed on the source object.
    *  @param {object} o
    *  @memberof DataTable#oApi
    */
			function _fnHungarianMap(o) {
				var hungarian = 'a aa ai ao as b fn i m o s ',
				    match,
				    newKey,
				    map = {};

				$.each(o, function (key, val) {
					match = key.match(/^([^A-Z]+?)([A-Z])/);

					if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
						newKey = key.replace(match[0], match[2].toLowerCase());
						map[newKey] = key;

						if (match[1] === 'o') {
							_fnHungarianMap(o[key]);
						}
					}
				});

				o._hungarianMap = map;
			}

			/**
    * Convert from camel case parameters to Hungarian, based on a Hungarian map
    * created by _fnHungarianMap.
    *  @param {object} src The model object which holds all parameters that can be
    *    mapped.
    *  @param {object} user The object to convert from camel case to Hungarian.
    *  @param {boolean} force When set to `true`, properties which already have a
    *    Hungarian value in the `user` object will be overwritten. Otherwise they
    *    won't be.
    *  @memberof DataTable#oApi
    */
			function _fnCamelToHungarian(src, user, force) {
				if (!src._hungarianMap) {
					_fnHungarianMap(src);
				}

				var hungarianKey;

				$.each(user, function (key, val) {
					hungarianKey = src._hungarianMap[key];

					if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
						// For objects, we need to buzz down into the object to copy parameters
						if (hungarianKey.charAt(0) === 'o') {
							// Copy the camelCase options over to the hungarian
							if (!user[hungarianKey]) {
								user[hungarianKey] = {};
							}
							$.extend(true, user[hungarianKey], user[key]);

							_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
						} else {
							user[hungarianKey] = user[key];
						}
					}
				});
			}

			/**
    * Language compatibility - when certain options are given, and others aren't, we
    * need to duplicate the values over, in order to provide backwards compatibility
    * with older language files.
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnLanguageCompat(lang) {
				// Note the use of the Hungarian notation for the parameters in this method as
				// this is called after the mapping of camelCase to Hungarian
				var defaults = DataTable.defaults.oLanguage;

				// Default mapping
				var defaultDecimal = defaults.sDecimal;
				if (defaultDecimal) {
					_addNumericSort(defaultDecimal);
				}

				if (lang) {
					var zeroRecords = lang.sZeroRecords;

					// Backwards compatibility - if there is no sEmptyTable given, then use the same as
					// sZeroRecords - assuming that is given.
					if (!lang.sEmptyTable && zeroRecords && defaults.sEmptyTable === "No data available in table") {
						_fnMap(lang, lang, 'sZeroRecords', 'sEmptyTable');
					}

					// Likewise with loading records
					if (!lang.sLoadingRecords && zeroRecords && defaults.sLoadingRecords === "Loading...") {
						_fnMap(lang, lang, 'sZeroRecords', 'sLoadingRecords');
					}

					// Old parameter name of the thousands separator mapped onto the new
					if (lang.sInfoThousands) {
						lang.sThousands = lang.sInfoThousands;
					}

					var decimal = lang.sDecimal;
					if (decimal && defaultDecimal !== decimal) {
						_addNumericSort(decimal);
					}
				}
			}

			/**
    * Map one parameter onto another
    *  @param {object} o Object to map
    *  @param {*} knew The new parameter name
    *  @param {*} old The old parameter name
    */
			var _fnCompatMap = function (o, knew, old) {
				if (o[knew] !== undefined) {
					o[old] = o[knew];
				}
			};

			/**
    * Provide backwards compatibility for the main DT options. Note that the new
    * options are mapped onto the old parameters, so this is an external interface
    * change only.
    *  @param {object} init Object to map
    */
			function _fnCompatOpts(init) {
				_fnCompatMap(init, 'ordering', 'bSort');
				_fnCompatMap(init, 'orderMulti', 'bSortMulti');
				_fnCompatMap(init, 'orderClasses', 'bSortClasses');
				_fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
				_fnCompatMap(init, 'order', 'aaSorting');
				_fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
				_fnCompatMap(init, 'paging', 'bPaginate');
				_fnCompatMap(init, 'pagingType', 'sPaginationType');
				_fnCompatMap(init, 'pageLength', 'iDisplayLength');
				_fnCompatMap(init, 'searching', 'bFilter');

				// Boolean initialisation of x-scrolling
				if (typeof init.sScrollX === 'boolean') {
					init.sScrollX = init.sScrollX ? '100%' : '';
				}
				if (typeof init.scrollX === 'boolean') {
					init.scrollX = init.scrollX ? '100%' : '';
				}

				// Column search objects are in an array, so it needs to be converted
				// element by element
				var searchCols = init.aoSearchCols;

				if (searchCols) {
					for (var i = 0, ien = searchCols.length; i < ien; i++) {
						if (searchCols[i]) {
							_fnCamelToHungarian(DataTable.models.oSearch, searchCols[i]);
						}
					}
				}
			}

			/**
    * Provide backwards compatibility for column options. Note that the new options
    * are mapped onto the old parameters, so this is an external interface change
    * only.
    *  @param {object} init Object to map
    */
			function _fnCompatCols(init) {
				_fnCompatMap(init, 'orderable', 'bSortable');
				_fnCompatMap(init, 'orderData', 'aDataSort');
				_fnCompatMap(init, 'orderSequence', 'asSorting');
				_fnCompatMap(init, 'orderDataType', 'sortDataType');

				// orderData can be given as an integer
				var dataSort = init.aDataSort;
				if (typeof dataSort === 'number' && !$.isArray(dataSort)) {
					init.aDataSort = [dataSort];
				}
			}

			/**
    * Browser feature detection for capabilities, quirks
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnBrowserDetect(settings) {
				// We don't need to do this every time DataTables is constructed, the values
				// calculated are specific to the browser and OS configuration which we
				// don't expect to change between initialisations
				if (!DataTable.__browser) {
					var browser = {};
					DataTable.__browser = browser;

					// Scrolling feature / quirks detection
					var n = $('<div/>').css({
						position: 'fixed',
						top: 0,
						left: $(window).scrollLeft() * -1, // allow for scrolling
						height: 1,
						width: 1,
						overflow: 'hidden'
					}).append($('<div/>').css({
						position: 'absolute',
						top: 1,
						left: 1,
						width: 100,
						overflow: 'scroll'
					}).append($('<div/>').css({
						width: '100%',
						height: 10
					}))).appendTo('body');

					var outer = n.children();
					var inner = outer.children();

					// Numbers below, in order, are:
					// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
					//
					// IE6 XP:                           100 100 100  83
					// IE7 Vista:                        100 100 100  83
					// IE 8+ Windows:                     83  83 100  83
					// Evergreen Windows:                 83  83 100  83
					// Evergreen Mac with scrollbars:     85  85 100  85
					// Evergreen Mac without scrollbars: 100 100 100 100

					// Get scrollbar width
					browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;

					// IE6/7 will oversize a width 100% element inside a scrolling element, to
					// include the width of the scrollbar, while other browsers ensure the inner
					// element is contained without forcing scrolling
					browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;

					// In rtl text layout, some browsers (most, but not all) will place the
					// scrollbar on the left, rather than the right.
					browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;

					// IE8- don't provide height and width for getBoundingClientRect
					browser.bBounding = n[0].getBoundingClientRect().width ? true : false;

					n.remove();
				}

				$.extend(settings.oBrowser, DataTable.__browser);
				settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
			}

			/**
    * Array.prototype reduce[Right] method, used for browsers which don't support
    * JS 1.6. Done this way to reduce code size, since we iterate either way
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnReduce(that, fn, init, start, end, inc) {
				var i = start,
				    value,
				    isSet = false;

				if (init !== undefined) {
					value = init;
					isSet = true;
				}

				while (i !== end) {
					if (!that.hasOwnProperty(i)) {
						continue;
					}

					value = isSet ? fn(value, that[i], i, that) : that[i];

					isSet = true;
					i += inc;
				}

				return value;
			}

			/**
    * Add a column to the list used for the table with default values
    *  @param {object} oSettings dataTables settings object
    *  @param {node} nTh The th element for this column
    *  @memberof DataTable#oApi
    */
			function _fnAddColumn(oSettings, nTh) {
				// Add column to aoColumns array
				var oDefaults = DataTable.defaults.column;
				var iCol = oSettings.aoColumns.length;
				var oCol = $.extend({}, DataTable.models.oColumn, oDefaults, {
					"nTh": nTh ? nTh : document.createElement('th'),
					"sTitle": oDefaults.sTitle ? oDefaults.sTitle : nTh ? nTh.innerHTML : '',
					"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
					"mData": oDefaults.mData ? oDefaults.mData : iCol,
					idx: iCol
				});
				oSettings.aoColumns.push(oCol);

				// Add search object for column specific search. Note that the `searchCols[ iCol ]`
				// passed into extend can be undefined. This allows the user to give a default
				// with only some of the parameters defined, and also not give a default
				var searchCols = oSettings.aoPreSearchCols;
				searchCols[iCol] = $.extend({}, DataTable.models.oSearch, searchCols[iCol]);

				// Use the default column options function to initialise classes etc
				_fnColumnOptions(oSettings, iCol, $(nTh).data());
			}

			/**
    * Apply options for a column
    *  @param {object} oSettings dataTables settings object
    *  @param {int} iCol column index to consider
    *  @param {object} oOptions object with sType, bVisible and bSearchable etc
    *  @memberof DataTable#oApi
    */
			function _fnColumnOptions(oSettings, iCol, oOptions) {
				var oCol = oSettings.aoColumns[iCol];
				var oClasses = oSettings.oClasses;
				var th = $(oCol.nTh);

				// Try to get width information from the DOM. We can't get it from CSS
				// as we'd need to parse the CSS stylesheet. `width` option can override
				if (!oCol.sWidthOrig) {
					// Width attribute
					oCol.sWidthOrig = th.attr('width') || null;

					// Style attribute
					var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
					if (t) {
						oCol.sWidthOrig = t[1];
					}
				}

				/* User specified column options */
				if (oOptions !== undefined && oOptions !== null) {
					// Backwards compatibility
					_fnCompatCols(oOptions);

					// Map camel case parameters to their Hungarian counterparts
					_fnCamelToHungarian(DataTable.defaults.column, oOptions);

					/* Backwards compatibility for mDataProp */
					if (oOptions.mDataProp !== undefined && !oOptions.mData) {
						oOptions.mData = oOptions.mDataProp;
					}

					if (oOptions.sType) {
						oCol._sManualType = oOptions.sType;
					}

					// `class` is a reserved word in Javascript, so we need to provide
					// the ability to use a valid name for the camel case input
					if (oOptions.className && !oOptions.sClass) {
						oOptions.sClass = oOptions.className;
					}
					if (oOptions.sClass) {
						th.addClass(oOptions.sClass);
					}

					$.extend(oCol, oOptions);
					_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");

					/* iDataSort to be applied (backwards compatibility), but aDataSort will take
      * priority if defined
      */
					if (oOptions.iDataSort !== undefined) {
						oCol.aDataSort = [oOptions.iDataSort];
					}
					_fnMap(oCol, oOptions, "aDataSort");
				}

				/* Cache the data get and set functions for speed */
				var mDataSrc = oCol.mData;
				var mData = _fnGetObjectDataFn(mDataSrc);
				var mRender = oCol.mRender ? _fnGetObjectDataFn(oCol.mRender) : null;

				var attrTest = function (src) {
					return typeof src === 'string' && src.indexOf('@') !== -1;
				};
				oCol._bAttrSrc = $.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
				oCol._setter = null;

				oCol.fnGetData = function (rowData, type, meta) {
					var innerData = mData(rowData, type, undefined, meta);

					return mRender && type ? mRender(innerData, type, rowData, meta) : innerData;
				};
				oCol.fnSetData = function (rowData, val, meta) {
					return _fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
				};

				// Indicate if DataTables should read DOM data as an object or array
				// Used in _fnGetRowElements
				if (typeof mDataSrc !== 'number') {
					oSettings._rowReadObject = true;
				}

				/* Feature sorting overrides column specific when off */
				if (!oSettings.oFeatures.bSort) {
					oCol.bSortable = false;
					th.addClass(oClasses.sSortableNone); // Have to add class here as order event isn't called
				}

				/* Check that the class assignment is correct for sorting */
				var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
				var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
				if (!oCol.bSortable || !bAsc && !bDesc) {
					oCol.sSortingClass = oClasses.sSortableNone;
					oCol.sSortingClassJUI = "";
				} else if (bAsc && !bDesc) {
					oCol.sSortingClass = oClasses.sSortableAsc;
					oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
				} else if (!bAsc && bDesc) {
					oCol.sSortingClass = oClasses.sSortableDesc;
					oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
				} else {
					oCol.sSortingClass = oClasses.sSortable;
					oCol.sSortingClassJUI = oClasses.sSortJUI;
				}
			}

			/**
    * Adjust the table column widths for new data. Note: you would probably want to
    * do a redraw after calling this function!
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnAdjustColumnSizing(settings) {
				/* Not interested in doing column width calculation if auto-width is disabled */
				if (settings.oFeatures.bAutoWidth !== false) {
					var columns = settings.aoColumns;

					_fnCalculateColumnWidths(settings);
					for (var i = 0, iLen = columns.length; i < iLen; i++) {
						columns[i].nTh.style.width = columns[i].sWidth;
					}
				}

				var scroll = settings.oScroll;
				if (scroll.sY !== '' || scroll.sX !== '') {
					_fnScrollDraw(settings);
				}

				_fnCallbackFire(settings, null, 'column-sizing', [settings]);
			}

			/**
    * Covert the index of a visible column to the index in the data array (take account
    * of hidden columns)
    *  @param {object} oSettings dataTables settings object
    *  @param {int} iMatch Visible column index to lookup
    *  @returns {int} i the data index
    *  @memberof DataTable#oApi
    */
			function _fnVisibleToColumnIndex(oSettings, iMatch) {
				var aiVis = _fnGetColumns(oSettings, 'bVisible');

				return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
			}

			/**
    * Covert the index of an index in the data array and convert it to the visible
    *   column index (take account of hidden columns)
    *  @param {int} iMatch Column index to lookup
    *  @param {object} oSettings dataTables settings object
    *  @returns {int} i the data index
    *  @memberof DataTable#oApi
    */
			function _fnColumnIndexToVisible(oSettings, iMatch) {
				var aiVis = _fnGetColumns(oSettings, 'bVisible');
				var iPos = $.inArray(iMatch, aiVis);

				return iPos !== -1 ? iPos : null;
			}

			/**
    * Get the number of visible columns
    *  @param {object} oSettings dataTables settings object
    *  @returns {int} i the number of visible columns
    *  @memberof DataTable#oApi
    */
			function _fnVisbleColumns(oSettings) {
				var vis = 0;

				// No reduce in IE8, use a loop for now
				$.each(oSettings.aoColumns, function (i, col) {
					if (col.bVisible && $(col.nTh).css('display') !== 'none') {
						vis++;
					}
				});

				return vis;
			}

			/**
    * Get an array of column indexes that match a given property
    *  @param {object} oSettings dataTables settings object
    *  @param {string} sParam Parameter in aoColumns to look for - typically
    *    bVisible or bSearchable
    *  @returns {array} Array of indexes with matched properties
    *  @memberof DataTable#oApi
    */
			function _fnGetColumns(oSettings, sParam) {
				var a = [];

				$.map(oSettings.aoColumns, function (val, i) {
					if (val[sParam]) {
						a.push(i);
					}
				});

				return a;
			}

			/**
    * Calculate the 'type' of a column
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnColumnTypes(settings) {
				var columns = settings.aoColumns;
				var data = settings.aoData;
				var types = DataTable.ext.type.detect;
				var i, ien, j, jen, k, ken;
				var col, cell, detectedType, cache;

				// For each column, spin over the 
				for (i = 0, ien = columns.length; i < ien; i++) {
					col = columns[i];
					cache = [];

					if (!col.sType && col._sManualType) {
						col.sType = col._sManualType;
					} else if (!col.sType) {
						for (j = 0, jen = types.length; j < jen; j++) {
							for (k = 0, ken = data.length; k < ken; k++) {
								// Use a cache array so we only need to get the type data
								// from the formatter once (when using multiple detectors)
								if (cache[k] === undefined) {
									cache[k] = _fnGetCellData(settings, k, i, 'type');
								}

								detectedType = types[j](cache[k], settings);

								// If null, then this type can't apply to this column, so
								// rather than testing all cells, break out. There is an
								// exception for the last type which is `html`. We need to
								// scan all rows since it is possible to mix string and HTML
								// types
								if (!detectedType && j !== types.length - 1) {
									break;
								}

								// Only a single match is needed for html type since it is
								// bottom of the pile and very similar to string
								if (detectedType === 'html') {
									break;
								}
							}

							// Type is valid for all data points in the column - use this
							// type
							if (detectedType) {
								col.sType = detectedType;
								break;
							}
						}

						// Fall back - if no type was detected, always use string
						if (!col.sType) {
							col.sType = 'string';
						}
					}
				}
			}

			/**
    * Take the column definitions and static columns arrays and calculate how
    * they relate to column indexes. The callback function will then apply the
    * definition found for a column to a suitable configuration object.
    *  @param {object} oSettings dataTables settings object
    *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
    *  @param {array} aoCols The aoColumns array that defines columns individually
    *  @param {function} fn Callback function - takes two parameters, the calculated
    *    column index and the definition for that column.
    *  @memberof DataTable#oApi
    */
			function _fnApplyColumnDefs(oSettings, aoColDefs, aoCols, fn) {
				var i, iLen, j, jLen, k, kLen, def;
				var columns = oSettings.aoColumns;

				// Column definitions with aTargets
				if (aoColDefs) {
					/* Loop over the definitions array - loop in reverse so first instance has priority */
					for (i = aoColDefs.length - 1; i >= 0; i--) {
						def = aoColDefs[i];

						/* Each definition can target multiple columns, as it is an array */
						var aTargets = def.targets !== undefined ? def.targets : def.aTargets;

						if (!$.isArray(aTargets)) {
							aTargets = [aTargets];
						}

						for (j = 0, jLen = aTargets.length; j < jLen; j++) {
							if (typeof aTargets[j] === 'number' && aTargets[j] >= 0) {
								/* Add columns that we don't yet know about */
								while (columns.length <= aTargets[j]) {
									_fnAddColumn(oSettings);
								}

								/* Integer, basic index */
								fn(aTargets[j], def);
							} else if (typeof aTargets[j] === 'number' && aTargets[j] < 0) {
								/* Negative integer, right to left column counting */
								fn(columns.length + aTargets[j], def);
							} else if (typeof aTargets[j] === 'string') {
								/* Class name matching on TH element */
								for (k = 0, kLen = columns.length; k < kLen; k++) {
									if (aTargets[j] == "_all" || $(columns[k].nTh).hasClass(aTargets[j])) {
										fn(k, def);
									}
								}
							}
						}
					}
				}

				// Statically defined columns array
				if (aoCols) {
					for (i = 0, iLen = aoCols.length; i < iLen; i++) {
						fn(i, aoCols[i]);
					}
				}
			}

			/**
    * Add a data array to the table, creating DOM node etc. This is the parallel to
    * _fnGatherData, but for adding rows from a Javascript source, rather than a
    * DOM source.
    *  @param {object} oSettings dataTables settings object
    *  @param {array} aData data array to be added
    *  @param {node} [nTr] TR element to add to the table - optional. If not given,
    *    DataTables will create a row automatically
    *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
    *    if nTr is.
    *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
    *  @memberof DataTable#oApi
    */
			function _fnAddData(oSettings, aDataIn, nTr, anTds) {
				/* Create the object for storing information about this new row */
				var iRow = oSettings.aoData.length;
				var oData = $.extend(true, {}, DataTable.models.oRow, {
					src: nTr ? 'dom' : 'data',
					idx: iRow
				});

				oData._aData = aDataIn;
				oSettings.aoData.push(oData);

				/* Create the cells */
				var nTd, sThisType;
				var columns = oSettings.aoColumns;

				// Invalidate the column types as the new data needs to be revalidated
				for (var i = 0, iLen = columns.length; i < iLen; i++) {
					columns[i].sType = null;
				}

				/* Add to the display array */
				oSettings.aiDisplayMaster.push(iRow);

				var id = oSettings.rowIdFn(aDataIn);
				if (id !== undefined) {
					oSettings.aIds[id] = oData;
				}

				/* Create the DOM information, or register it if already present */
				if (nTr || !oSettings.oFeatures.bDeferRender) {
					_fnCreateTr(oSettings, iRow, nTr, anTds);
				}

				return iRow;
			}

			/**
    * Add one or more TR elements to the table. Generally we'd expect to
    * use this for reading data from a DOM sourced table, but it could be
    * used for an TR element. Note that if a TR is given, it is used (i.e.
    * it is not cloned).
    *  @param {object} settings dataTables settings object
    *  @param {array|node|jQuery} trs The TR element(s) to add to the table
    *  @returns {array} Array of indexes for the added rows
    *  @memberof DataTable#oApi
    */
			function _fnAddTr(settings, trs) {
				var row;

				// Allow an individual node to be passed in
				if (!(trs instanceof $)) {
					trs = $(trs);
				}

				return trs.map(function (i, el) {
					row = _fnGetRowElements(settings, el);
					return _fnAddData(settings, row.data, el, row.cells);
				});
			}

			/**
    * Take a TR element and convert it to an index in aoData
    *  @param {object} oSettings dataTables settings object
    *  @param {node} n the TR element to find
    *  @returns {int} index if the node is found, null if not
    *  @memberof DataTable#oApi
    */
			function _fnNodeToDataIndex(oSettings, n) {
				return n._DT_RowIndex !== undefined ? n._DT_RowIndex : null;
			}

			/**
    * Take a TD element and convert it into a column data index (not the visible index)
    *  @param {object} oSettings dataTables settings object
    *  @param {int} iRow The row number the TD/TH can be found in
    *  @param {node} n The TD/TH element to find
    *  @returns {int} index if the node is found, -1 if not
    *  @memberof DataTable#oApi
    */
			function _fnNodeToColumnIndex(oSettings, iRow, n) {
				return $.inArray(n, oSettings.aoData[iRow].anCells);
			}

			/**
    * Get the data for a given cell from the internal cache, taking into account data mapping
    *  @param {object} settings dataTables settings object
    *  @param {int} rowIdx aoData row id
    *  @param {int} colIdx Column index
    *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
    *  @returns {*} Cell data
    *  @memberof DataTable#oApi
    */
			function _fnGetCellData(settings, rowIdx, colIdx, type) {
				var draw = settings.iDraw;
				var col = settings.aoColumns[colIdx];
				var rowData = settings.aoData[rowIdx]._aData;
				var defaultContent = col.sDefaultContent;
				var cellData = col.fnGetData(rowData, type, {
					settings: settings,
					row: rowIdx,
					col: colIdx
				});

				if (cellData === undefined) {
					if (settings.iDrawError != draw && defaultContent === null) {
						_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
						settings.iDrawError = draw;
					}
					return defaultContent;
				}

				// When the data source is null and a specific data type is requested (i.e.
				// not the original data), we can use default column data
				if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) {
					cellData = defaultContent;
				} else if (typeof cellData === 'function') {
					// If the data source is a function, then we run it and use the return,
					// executing in the scope of the data object (for instances)
					return cellData.call(rowData);
				}

				if (cellData === null && type == 'display') {
					return '';
				}
				return cellData;
			}

			/**
    * Set the value for a specific cell, into the internal data cache
    *  @param {object} settings dataTables settings object
    *  @param {int} rowIdx aoData row id
    *  @param {int} colIdx Column index
    *  @param {*} val Value to set
    *  @memberof DataTable#oApi
    */
			function _fnSetCellData(settings, rowIdx, colIdx, val) {
				var col = settings.aoColumns[colIdx];
				var rowData = settings.aoData[rowIdx]._aData;

				col.fnSetData(rowData, val, {
					settings: settings,
					row: rowIdx,
					col: colIdx
				});
			}

			// Private variable that is used to match action syntax in the data property object
			var __reArray = /\[.*?\]$/;
			var __reFn = /\(\)$/;

			/**
    * Split string on periods, taking into account escaped periods
    * @param  {string} str String to split
    * @return {array} Split string
    */
			function _fnSplitObjNotation(str) {
				return $.map(str.match(/(\\.|[^\.])+/g) || [''], function (s) {
					return s.replace(/\\\./g, '.');
				});
			}

			/**
    * Return a function that can be used to get data from a source object, taking
    * into account the ability to use nested objects as a source
    *  @param {string|int|function} mSource The data source for the object
    *  @returns {function} Data get function
    *  @memberof DataTable#oApi
    */
			function _fnGetObjectDataFn(mSource) {
				if ($.isPlainObject(mSource)) {
					/* Build an object of get functions, and wrap them in a single call */
					var o = {};
					$.each(mSource, function (key, val) {
						if (val) {
							o[key] = _fnGetObjectDataFn(val);
						}
					});

					return function (data, type, row, meta) {
						var t = o[type] || o._;
						return t !== undefined ? t(data, type, row, meta) : data;
					};
				} else if (mSource === null) {
					/* Give an empty string for rendering / sorting etc */
					return function (data) {
						// type, row and meta also passed, but not used
						return data;
					};
				} else if (typeof mSource === 'function') {
					return function (data, type, row, meta) {
						return mSource(data, type, row, meta);
					};
				} else if (typeof mSource === 'string' && (mSource.indexOf('.') !== -1 || mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1)) {
					/* If there is a . in the source string then the data source is in a
      * nested object so we loop over the data for each level to get the next
      * level down. On each loop we test for undefined, and if found immediately
      * return. This allows entire objects to be missing and sDefaultContent to
      * be used if defined, rather than throwing an error
      */
					var fetchData = function (data, type, src) {
						var arrayNotation, funcNotation, out, innerSrc;

						if (src !== "") {
							var a = _fnSplitObjNotation(src);

							for (var i = 0, iLen = a.length; i < iLen; i++) {
								// Check if we are dealing with special notation
								arrayNotation = a[i].match(__reArray);
								funcNotation = a[i].match(__reFn);

								if (arrayNotation) {
									// Array notation
									a[i] = a[i].replace(__reArray, '');

									// Condition allows simply [] to be passed in
									if (a[i] !== "") {
										data = data[a[i]];
									}
									out = [];

									// Get the remainder of the nested object to get
									a.splice(0, i + 1);
									innerSrc = a.join('.');

									// Traverse each entry in the array getting the properties requested
									if ($.isArray(data)) {
										for (var j = 0, jLen = data.length; j < jLen; j++) {
											out.push(fetchData(data[j], type, innerSrc));
										}
									}

									// If a string is given in between the array notation indicators, that
									// is used to join the strings together, otherwise an array is returned
									var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
									data = join === "" ? out : out.join(join);

									// The inner call to fetchData has already traversed through the remainder
									// of the source requested, so we exit from the loop
									break;
								} else if (funcNotation) {
									// Function call
									a[i] = a[i].replace(__reFn, '');
									data = data[a[i]]();
									continue;
								}

								if (data === null || data[a[i]] === undefined) {
									return undefined;
								}
								data = data[a[i]];
							}
						}

						return data;
					};

					return function (data, type) {
						// row and meta also passed, but not used
						return fetchData(data, type, mSource);
					};
				} else {
					/* Array or flat object mapping */
					return function (data, type) {
						// row and meta also passed, but not used
						return data[mSource];
					};
				}
			}

			/**
    * Return a function that can be used to set data from a source object, taking
    * into account the ability to use nested objects as a source
    *  @param {string|int|function} mSource The data source for the object
    *  @returns {function} Data set function
    *  @memberof DataTable#oApi
    */
			function _fnSetObjectDataFn(mSource) {
				if ($.isPlainObject(mSource)) {
					/* Unlike get, only the underscore (global) option is used for for
      * setting data since we don't know the type here. This is why an object
      * option is not documented for `mData` (which is read/write), but it is
      * for `mRender` which is read only.
      */
					return _fnSetObjectDataFn(mSource._);
				} else if (mSource === null) {
					/* Nothing to do when the data source is null */
					return function () {};
				} else if (typeof mSource === 'function') {
					return function (data, val, meta) {
						mSource(data, 'set', val, meta);
					};
				} else if (typeof mSource === 'string' && (mSource.indexOf('.') !== -1 || mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1)) {
					/* Like the get, we need to get data from a nested object */
					var setData = function (data, val, src) {
						var a = _fnSplitObjNotation(src),
						    b;
						var aLast = a[a.length - 1];
						var arrayNotation, funcNotation, o, innerSrc;

						for (var i = 0, iLen = a.length - 1; i < iLen; i++) {
							// Check if we are dealing with an array notation request
							arrayNotation = a[i].match(__reArray);
							funcNotation = a[i].match(__reFn);

							if (arrayNotation) {
								a[i] = a[i].replace(__reArray, '');
								data[a[i]] = [];

								// Get the remainder of the nested object to set so we can recurse
								b = a.slice();
								b.splice(0, i + 1);
								innerSrc = b.join('.');

								// Traverse each entry in the array setting the properties requested
								if ($.isArray(val)) {
									for (var j = 0, jLen = val.length; j < jLen; j++) {
										o = {};
										setData(o, val[j], innerSrc);
										data[a[i]].push(o);
									}
								} else {
									// We've been asked to save data to an array, but it
									// isn't array data to be saved. Best that can be done
									// is to just save the value.
									data[a[i]] = val;
								}

								// The inner call to setData has already traversed through the remainder
								// of the source and has set the data, thus we can exit here
								return;
							} else if (funcNotation) {
								// Function call
								a[i] = a[i].replace(__reFn, '');
								data = data[a[i]](val);
							}

							// If the nested object doesn't currently exist - since we are
							// trying to set the value - create it
							if (data[a[i]] === null || data[a[i]] === undefined) {
								data[a[i]] = {};
							}
							data = data[a[i]];
						}

						// Last item in the input - i.e, the actual set
						if (aLast.match(__reFn)) {
							// Function call
							data = data[aLast.replace(__reFn, '')](val);
						} else {
							// If array notation is used, we just want to strip it and use the property name
							// and assign the value. If it isn't used, then we get the result we want anyway
							data[aLast.replace(__reArray, '')] = val;
						}
					};

					return function (data, val) {
						// meta is also passed in, but not used
						return setData(data, val, mSource);
					};
				} else {
					/* Array or flat object mapping */
					return function (data, val) {
						// meta is also passed in, but not used
						data[mSource] = val;
					};
				}
			}

			/**
    * Return an array with the full table data
    *  @param {object} oSettings dataTables settings object
    *  @returns array {array} aData Master data array
    *  @memberof DataTable#oApi
    */
			function _fnGetDataMaster(settings) {
				return _pluck(settings.aoData, '_aData');
			}

			/**
    * Nuke the table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnClearTable(settings) {
				settings.aoData.length = 0;
				settings.aiDisplayMaster.length = 0;
				settings.aiDisplay.length = 0;
				settings.aIds = {};
			}

			/**
   * Take an array of integers (index array) and remove a target integer (value - not
   * the key!)
   *  @param {array} a Index array to target
   *  @param {int} iTarget value to find
   *  @memberof DataTable#oApi
   */
			function _fnDeleteIndex(a, iTarget, splice) {
				var iTargetIndex = -1;

				for (var i = 0, iLen = a.length; i < iLen; i++) {
					if (a[i] == iTarget) {
						iTargetIndex = i;
					} else if (a[i] > iTarget) {
						a[i]--;
					}
				}

				if (iTargetIndex != -1 && splice === undefined) {
					a.splice(iTargetIndex, 1);
				}
			}

			/**
    * Mark cached data as invalid such that a re-read of the data will occur when
    * the cached data is next requested. Also update from the data source object.
    *
    * @param {object} settings DataTables settings object
    * @param {int}    rowIdx   Row index to invalidate
    * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
    *     or 'data'
    * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
    *     row will be invalidated
    * @memberof DataTable#oApi
    *
    * @todo For the modularisation of v1.11 this will need to become a callback, so
    *   the sort and filter methods can subscribe to it. That will required
    *   initialisation options for sorting, which is why it is not already baked in
    */
			function _fnInvalidate(settings, rowIdx, src, colIdx) {
				var row = settings.aoData[rowIdx];
				var i, ien;
				var cellWrite = function (cell, col) {
					// This is very frustrating, but in IE if you just write directly
					// to innerHTML, and elements that are overwritten are GC'ed,
					// even if there is a reference to them elsewhere
					while (cell.childNodes.length) {
						cell.removeChild(cell.firstChild);
					}

					cell.innerHTML = _fnGetCellData(settings, rowIdx, col, 'display');
				};

				// Are we reading last data from DOM or the data object?
				if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') {
					// Read the data from the DOM
					row._aData = _fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
				} else {
					// Reading from data object, update the DOM
					var cells = row.anCells;

					if (cells) {
						if (colIdx !== undefined) {
							cellWrite(cells[colIdx], colIdx);
						} else {
							for (i = 0, ien = cells.length; i < ien; i++) {
								cellWrite(cells[i], i);
							}
						}
					}
				}

				// For both row and cell invalidation, the cached data for sorting and
				// filtering is nulled out
				row._aSortData = null;
				row._aFilterData = null;

				// Invalidate the type for a specific column (if given) or all columns since
				// the data might have changed
				var cols = settings.aoColumns;
				if (colIdx !== undefined) {
					cols[colIdx].sType = null;
				} else {
					for (i = 0, ien = cols.length; i < ien; i++) {
						cols[i].sType = null;
					}

					// Update DataTables special `DT_*` attributes for the row
					_fnRowAttributes(settings, row);
				}
			}

			/**
    * Build a data source object from an HTML row, reading the contents of the
    * cells that are in the row.
    *
    * @param {object} settings DataTables settings object
    * @param {node|object} TR element from which to read data or existing row
    *   object from which to re-read the data from the cells
    * @param {int} [colIdx] Optional column index
    * @param {array|object} [d] Data source object. If `colIdx` is given then this
    *   parameter should also be given and will be used to write the data into.
    *   Only the column in question will be written
    * @returns {object} Object with two parameters: `data` the data read, in
    *   document order, and `cells` and array of nodes (they can be useful to the
    *   caller, so rather than needing a second traversal to get them, just return
    *   them from here).
    * @memberof DataTable#oApi
    */
			function _fnGetRowElements(settings, row, colIdx, d) {
				var tds = [],
				    td = row.firstChild,
				    name,
				    col,
				    o,
				    i = 0,
				    contents,
				    columns = settings.aoColumns,
				    objectRead = settings._rowReadObject;

				// Allow the data object to be passed in, or construct
				d = d !== undefined ? d : objectRead ? {} : [];

				var attr = function (str, td) {
					if (typeof str === 'string') {
						var idx = str.indexOf('@');

						if (idx !== -1) {
							var attr = str.substring(idx + 1);
							var setter = _fnSetObjectDataFn(str);
							setter(d, td.getAttribute(attr));
						}
					}
				};

				// Read data from a cell and store into the data object
				var cellProcess = function (cell) {
					if (colIdx === undefined || colIdx === i) {
						col = columns[i];
						contents = $.trim(cell.innerHTML);

						if (col && col._bAttrSrc) {
							var setter = _fnSetObjectDataFn(col.mData._);
							setter(d, contents);

							attr(col.mData.sort, cell);
							attr(col.mData.type, cell);
							attr(col.mData.filter, cell);
						} else {
							// Depending on the `data` option for the columns the data can
							// be read to either an object or an array.
							if (objectRead) {
								if (!col._setter) {
									// Cache the setter function
									col._setter = _fnSetObjectDataFn(col.mData);
								}
								col._setter(d, contents);
							} else {
								d[i] = contents;
							}
						}
					}

					i++;
				};

				if (td) {
					// `tr` element was passed in
					while (td) {
						name = td.nodeName.toUpperCase();

						if (name == "TD" || name == "TH") {
							cellProcess(td);
							tds.push(td);
						}

						td = td.nextSibling;
					}
				} else {
					// Existing row object passed in
					tds = row.anCells;

					for (var j = 0, jen = tds.length; j < jen; j++) {
						cellProcess(tds[j]);
					}
				}

				// Read the ID from the DOM if present
				var rowNode = row.firstChild ? row : row.nTr;

				if (rowNode) {
					var id = rowNode.getAttribute('id');

					if (id) {
						_fnSetObjectDataFn(settings.rowId)(d, id);
					}
				}

				return {
					data: d,
					cells: tds
				};
			}
			/**
    * Create a new TR element (and it's TD children) for a row
    *  @param {object} oSettings dataTables settings object
    *  @param {int} iRow Row to consider
    *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
    *    DataTables will create a row automatically
    *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
    *    if nTr is.
    *  @memberof DataTable#oApi
    */
			function _fnCreateTr(oSettings, iRow, nTrIn, anTds) {
				var row = oSettings.aoData[iRow],
				    rowData = row._aData,
				    cells = [],
				    nTr,
				    nTd,
				    oCol,
				    i,
				    iLen;

				if (row.nTr === null) {
					nTr = nTrIn || document.createElement('tr');

					row.nTr = nTr;
					row.anCells = cells;

					/* Use a private property on the node to allow reserve mapping from the node
      * to the aoData array for fast look up
      */
					nTr._DT_RowIndex = iRow;

					/* Special parameters can be given by the data source to be used on the row */
					_fnRowAttributes(oSettings, row);

					/* Process each column */
					for (i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++) {
						oCol = oSettings.aoColumns[i];

						nTd = nTrIn ? anTds[i] : document.createElement(oCol.sCellType);
						nTd._DT_CellIndex = {
							row: iRow,
							column: i
						};

						cells.push(nTd);

						// Need to create the HTML if new, or if a rendering function is defined
						if ((!nTrIn || oCol.mRender || oCol.mData !== i) && (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i + '.display')) {
							nTd.innerHTML = _fnGetCellData(oSettings, iRow, i, 'display');
						}

						/* Add user defined class */
						if (oCol.sClass) {
							nTd.className += ' ' + oCol.sClass;
						}

						// Visibility - add or remove as required
						if (oCol.bVisible && !nTrIn) {
							nTr.appendChild(nTd);
						} else if (!oCol.bVisible && nTrIn) {
							nTd.parentNode.removeChild(nTd);
						}

						if (oCol.fnCreatedCell) {
							oCol.fnCreatedCell.call(oSettings.oInstance, nTd, _fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
						}
					}

					_fnCallbackFire(oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells]);
				}

				// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
				// and deployed
				row.nTr.setAttribute('role', 'row');
			}

			/**
    * Add attributes to a row based on the special `DT_*` parameters in a data
    * source object.
    *  @param {object} settings DataTables settings object
    *  @param {object} DataTables row object for the row to be modified
    *  @memberof DataTable#oApi
    */
			function _fnRowAttributes(settings, row) {
				var tr = row.nTr;
				var data = row._aData;

				if (tr) {
					var id = settings.rowIdFn(data);

					if (id) {
						tr.id = id;
					}

					if (data.DT_RowClass) {
						// Remove any classes added by DT_RowClass before
						var a = data.DT_RowClass.split(' ');
						row.__rowc = row.__rowc ? _unique(row.__rowc.concat(a)) : a;

						$(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
					}

					if (data.DT_RowAttr) {
						$(tr).attr(data.DT_RowAttr);
					}

					if (data.DT_RowData) {
						$(tr).data(data.DT_RowData);
					}
				}
			}

			/**
    * Create the HTML header for the table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnBuildHead(oSettings) {
				var i, ien, cell, row, column;
				var thead = oSettings.nTHead;
				var tfoot = oSettings.nTFoot;
				var createHeader = $('th, td', thead).length === 0;
				var classes = oSettings.oClasses;
				var columns = oSettings.aoColumns;

				if (createHeader) {
					row = $('<tr/>').appendTo(thead);
				}

				for (i = 0, ien = columns.length; i < ien; i++) {
					column = columns[i];
					cell = $(column.nTh).addClass(column.sClass);

					if (createHeader) {
						cell.appendTo(row);
					}

					// 1.11 move into sorting
					if (oSettings.oFeatures.bSort) {
						cell.addClass(column.sSortingClass);

						if (column.bSortable !== false) {
							cell.attr('tabindex', oSettings.iTabIndex).attr('aria-controls', oSettings.sTableId);

							_fnSortAttachListener(oSettings, column.nTh, i);
						}
					}

					if (column.sTitle != cell[0].innerHTML) {
						cell.html(column.sTitle);
					}

					_fnRenderer(oSettings, 'header')(oSettings, cell, column, classes);
				}

				if (createHeader) {
					_fnDetectHeader(oSettings.aoHeader, thead);
				}

				/* ARIA role for the rows */
				$(thead).find('>tr').attr('role', 'row');

				/* Deal with the footer - add classes if required */
				$(thead).find('>tr>th, >tr>td').addClass(classes.sHeaderTH);
				$(tfoot).find('>tr>th, >tr>td').addClass(classes.sFooterTH);

				// Cache the footer cells. Note that we only take the cells from the first
				// row in the footer. If there is more than one row the user wants to
				// interact with, they need to use the table().foot() method. Note also this
				// allows cells to be used for multiple columns using colspan
				if (tfoot !== null) {
					var cells = oSettings.aoFooter[0];

					for (i = 0, ien = cells.length; i < ien; i++) {
						column = columns[i];
						column.nTf = cells[i].cell;

						if (column.sClass) {
							$(column.nTf).addClass(column.sClass);
						}
					}
				}
			}

			/**
    * Draw the header (or footer) element based on the column visibility states. The
    * methodology here is to use the layout array from _fnDetectHeader, modified for
    * the instantaneous column visibility, to construct the new layout. The grid is
    * traversed over cell at a time in a rows x columns grid fashion, although each
    * cell insert can cover multiple elements in the grid - which is tracks using the
    * aApplied array. Cell inserts in the grid will only occur where there isn't
    * already a cell in that position.
    *  @param {object} oSettings dataTables settings object
    *  @param array {objects} aoSource Layout array from _fnDetectHeader
    *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
    *  @memberof DataTable#oApi
    */
			function _fnDrawHead(oSettings, aoSource, bIncludeHidden) {
				var i, iLen, j, jLen, k, kLen, n, nLocalTr;
				var aoLocal = [];
				var aApplied = [];
				var iColumns = oSettings.aoColumns.length;
				var iRowspan, iColspan;

				if (!aoSource) {
					return;
				}

				if (bIncludeHidden === undefined) {
					bIncludeHidden = false;
				}

				/* Make a copy of the master layout array, but without the visible columns in it */
				for (i = 0, iLen = aoSource.length; i < iLen; i++) {
					aoLocal[i] = aoSource[i].slice();
					aoLocal[i].nTr = aoSource[i].nTr;

					/* Remove any columns which are currently hidden */
					for (j = iColumns - 1; j >= 0; j--) {
						if (!oSettings.aoColumns[j].bVisible && !bIncludeHidden) {
							aoLocal[i].splice(j, 1);
						}
					}

					/* Prep the applied array - it needs an element for each row */
					aApplied.push([]);
				}

				for (i = 0, iLen = aoLocal.length; i < iLen; i++) {
					nLocalTr = aoLocal[i].nTr;

					/* All cells are going to be replaced, so empty out the row */
					if (nLocalTr) {
						while (n = nLocalTr.firstChild) {
							nLocalTr.removeChild(n);
						}
					}

					for (j = 0, jLen = aoLocal[i].length; j < jLen; j++) {
						iRowspan = 1;
						iColspan = 1;

						/* Check to see if there is already a cell (row/colspan) covering our target
       * insert point. If there is, then there is nothing to do.
       */
						if (aApplied[i][j] === undefined) {
							nLocalTr.appendChild(aoLocal[i][j].cell);
							aApplied[i][j] = 1;

							/* Expand the cell to cover as many rows as needed */
							while (aoLocal[i + iRowspan] !== undefined && aoLocal[i][j].cell == aoLocal[i + iRowspan][j].cell) {
								aApplied[i + iRowspan][j] = 1;
								iRowspan++;
							}

							/* Expand the cell to cover as many columns as needed */
							while (aoLocal[i][j + iColspan] !== undefined && aoLocal[i][j].cell == aoLocal[i][j + iColspan].cell) {
								/* Must update the applied array over the rows for the columns */
								for (k = 0; k < iRowspan; k++) {
									aApplied[i + k][j + iColspan] = 1;
								}
								iColspan++;
							}

							/* Do the actual expansion in the DOM */
							$(aoLocal[i][j].cell).attr('rowspan', iRowspan).attr('colspan', iColspan);
						}
					}
				}
			}

			/**
    * Insert the required TR nodes into the table for display
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnDraw(oSettings) {
				/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
				var aPreDraw = _fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings]);
				if ($.inArray(false, aPreDraw) !== -1) {
					_fnProcessingDisplay(oSettings, false);
					return;
				}

				var i, iLen, n;
				var anRows = [];
				var iRowCount = 0;
				var asStripeClasses = oSettings.asStripeClasses;
				var iStripes = asStripeClasses.length;
				var iOpenRows = oSettings.aoOpenRows.length;
				var oLang = oSettings.oLanguage;
				var iInitDisplayStart = oSettings.iInitDisplayStart;
				var bServerSide = _fnDataSource(oSettings) == 'ssp';
				var aiDisplay = oSettings.aiDisplay;

				oSettings.bDrawing = true;

				/* Check and see if we have an initial draw position from state saving */
				if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
					oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;

					oSettings.iInitDisplayStart = -1;
				}

				var iDisplayStart = oSettings._iDisplayStart;
				var iDisplayEnd = oSettings.fnDisplayEnd();

				/* Server-side processing draw intercept */
				if (oSettings.bDeferLoading) {
					oSettings.bDeferLoading = false;
					oSettings.iDraw++;
					_fnProcessingDisplay(oSettings, false);
				} else if (!bServerSide) {
					oSettings.iDraw++;
				} else if (!oSettings.bDestroying && !_fnAjaxUpdate(oSettings)) {
					return;
				}

				if (aiDisplay.length !== 0) {
					var iStart = bServerSide ? 0 : iDisplayStart;
					var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;

					for (var j = iStart; j < iEnd; j++) {
						var iDataIndex = aiDisplay[j];
						var aoData = oSettings.aoData[iDataIndex];
						if (aoData.nTr === null) {
							_fnCreateTr(oSettings, iDataIndex);
						}

						var nRow = aoData.nTr;

						/* Remove the old striping classes and then add the new one */
						if (iStripes !== 0) {
							var sStripe = asStripeClasses[iRowCount % iStripes];
							if (aoData._sRowStripe != sStripe) {
								$(nRow).removeClass(aoData._sRowStripe).addClass(sStripe);
								aoData._sRowStripe = sStripe;
							}
						}

						// Row callback functions - might want to manipulate the row
						// iRowCount and j are not currently documented. Are they at all
						// useful?
						_fnCallbackFire(oSettings, 'aoRowCallback', null, [nRow, aoData._aData, iRowCount, j, iDataIndex]);

						anRows.push(nRow);
						iRowCount++;
					}
				} else {
					/* Table is empty - create a row with an empty message in it */
					var sZero = oLang.sZeroRecords;
					if (oSettings.iDraw == 1 && _fnDataSource(oSettings) == 'ajax') {
						sZero = oLang.sLoadingRecords;
					} else if (oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0) {
						sZero = oLang.sEmptyTable;
					}

					anRows[0] = $('<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' }).append($('<td />', {
						'valign': 'top',
						'colSpan': _fnVisbleColumns(oSettings),
						'class': oSettings.oClasses.sRowEmpty
					}).html(sZero))[0];
				}

				/* Header and footer callbacks */
				_fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [$(oSettings.nTHead).children('tr')[0], _fnGetDataMaster(oSettings), iDisplayStart, iDisplayEnd, aiDisplay]);

				_fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [$(oSettings.nTFoot).children('tr')[0], _fnGetDataMaster(oSettings), iDisplayStart, iDisplayEnd, aiDisplay]);

				var body = $(oSettings.nTBody);

				body.children().detach();
				body.append($(anRows));

				/* Call all required callback functions for the end of a draw */
				_fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [oSettings]);

				/* Draw is complete, sorting and filtering must be as well */
				oSettings.bSorted = false;
				oSettings.bFiltered = false;
				oSettings.bDrawing = false;
			}

			/**
    * Redraw the table - taking account of the various features which are enabled
    *  @param {object} oSettings dataTables settings object
    *  @param {boolean} [holdPosition] Keep the current paging position. By default
    *    the paging is reset to the first page
    *  @memberof DataTable#oApi
    */
			function _fnReDraw(settings, holdPosition) {
				var features = settings.oFeatures,
				    sort = features.bSort,
				    filter = features.bFilter;

				if (sort) {
					_fnSort(settings);
				}

				if (filter) {
					_fnFilterComplete(settings, settings.oPreviousSearch);
				} else {
					// No filtering, so we want to just use the display master
					settings.aiDisplay = settings.aiDisplayMaster.slice();
				}

				if (holdPosition !== true) {
					settings._iDisplayStart = 0;
				}

				// Let any modules know about the draw hold position state (used by
				// scrolling internally)
				settings._drawHold = holdPosition;

				_fnDraw(settings);

				settings._drawHold = false;
			}

			/**
    * Add the options to the page HTML for the table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnAddOptionsHtml(oSettings) {
				var classes = oSettings.oClasses;
				var table = $(oSettings.nTable);
				var holding = $('<div/>').insertBefore(table); // Holding element for speed
				var features = oSettings.oFeatures;

				// All DataTables are wrapped in a div
				var insert = $('<div/>', {
					id: oSettings.sTableId + '_wrapper',
					'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' ' + classes.sNoFooter)
				});

				oSettings.nHolding = holding[0];
				oSettings.nTableWrapper = insert[0];
				oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;

				/* Loop over the user set positioning and place the elements as needed */
				var aDom = oSettings.sDom.split('');
				var featureNode, cOption, nNewNode, cNext, sAttr, j;
				for (var i = 0; i < aDom.length; i++) {
					featureNode = null;
					cOption = aDom[i];

					if (cOption == '<') {
						/* New container div */
						nNewNode = $('<div/>')[0];

						/* Check to see if we should append an id and/or a class name to the container */
						cNext = aDom[i + 1];
						if (cNext == "'" || cNext == '"') {
							sAttr = "";
							j = 2;
							while (aDom[i + j] != cNext) {
								sAttr += aDom[i + j];
								j++;
							}

							/* Replace jQuery UI constants @todo depreciated */
							if (sAttr == "H") {
								sAttr = classes.sJUIHeader;
							} else if (sAttr == "F") {
								sAttr = classes.sJUIFooter;
							}

							/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
        * breaks the string into parts and applies them as needed
        */
							if (sAttr.indexOf('.') != -1) {
								var aSplit = sAttr.split('.');
								nNewNode.id = aSplit[0].substr(1, aSplit[0].length - 1);
								nNewNode.className = aSplit[1];
							} else if (sAttr.charAt(0) == "#") {
								nNewNode.id = sAttr.substr(1, sAttr.length - 1);
							} else {
								nNewNode.className = sAttr;
							}

							i += j; /* Move along the position array */
						}

						insert.append(nNewNode);
						insert = $(nNewNode);
					} else if (cOption == '>') {
						/* End container div */
						insert = insert.parent();
					}
					// @todo Move options into their own plugins?
					else if (cOption == 'l' && features.bPaginate && features.bLengthChange) {
							/* Length */
							featureNode = _fnFeatureHtmlLength(oSettings);
						} else if (cOption == 'f' && features.bFilter) {
							/* Filter */
							featureNode = _fnFeatureHtmlFilter(oSettings);
						} else if (cOption == 'r' && features.bProcessing) {
							/* pRocessing */
							featureNode = _fnFeatureHtmlProcessing(oSettings);
						} else if (cOption == 't') {
							/* Table */
							featureNode = _fnFeatureHtmlTable(oSettings);
						} else if (cOption == 'i' && features.bInfo) {
							/* Info */
							featureNode = _fnFeatureHtmlInfo(oSettings);
						} else if (cOption == 'p' && features.bPaginate) {
							/* Pagination */
							featureNode = _fnFeatureHtmlPaginate(oSettings);
						} else if (DataTable.ext.feature.length !== 0) {
							/* Plug-in features */
							var aoFeatures = DataTable.ext.feature;
							for (var k = 0, kLen = aoFeatures.length; k < kLen; k++) {
								if (cOption == aoFeatures[k].cFeature) {
									featureNode = aoFeatures[k].fnInit(oSettings);
									break;
								}
							}
						}

					/* Add to the 2D features array */
					if (featureNode) {
						var aanFeatures = oSettings.aanFeatures;

						if (!aanFeatures[cOption]) {
							aanFeatures[cOption] = [];
						}

						aanFeatures[cOption].push(featureNode);
						insert.append(featureNode);
					}
				}

				/* Built our DOM structure - replace the holding div with what we want */
				holding.replaceWith(insert);
				oSettings.nHolding = null;
			}

			/**
    * Use the DOM source to create up an array of header cells. The idea here is to
    * create a layout grid (array) of rows x columns, which contains a reference
    * to the cell that that point in the grid (regardless of col/rowspan), such that
    * any column / row could be removed and the new grid constructed
    *  @param array {object} aLayout Array to store the calculated layout in
    *  @param {node} nThead The header/footer element for the table
    *  @memberof DataTable#oApi
    */
			function _fnDetectHeader(aLayout, nThead) {
				var nTrs = $(nThead).children('tr');
				var nTr, nCell;
				var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
				var bUnique;
				var fnShiftCol = function (a, i, j) {
					var k = a[i];
					while (k[j]) {
						j++;
					}
					return j;
				};

				aLayout.splice(0, aLayout.length);

				/* We know how many rows there are in the layout - so prep it */
				for (i = 0, iLen = nTrs.length; i < iLen; i++) {
					aLayout.push([]);
				}

				/* Calculate a layout array */
				for (i = 0, iLen = nTrs.length; i < iLen; i++) {
					nTr = nTrs[i];
					iColumn = 0;

					/* For every cell in the row... */
					nCell = nTr.firstChild;
					while (nCell) {
						if (nCell.nodeName.toUpperCase() == "TD" || nCell.nodeName.toUpperCase() == "TH") {
							/* Get the col and rowspan attributes from the DOM and sanitise them */
							iColspan = nCell.getAttribute('colspan') * 1;
							iRowspan = nCell.getAttribute('rowspan') * 1;
							iColspan = !iColspan || iColspan === 0 || iColspan === 1 ? 1 : iColspan;
							iRowspan = !iRowspan || iRowspan === 0 || iRowspan === 1 ? 1 : iRowspan;

							/* There might be colspan cells already in this row, so shift our target
        * accordingly
        */
							iColShifted = fnShiftCol(aLayout, i, iColumn);

							/* Cache calculation for unique columns */
							bUnique = iColspan === 1 ? true : false;

							/* If there is col / rowspan, copy the information into the layout grid */
							for (l = 0; l < iColspan; l++) {
								for (k = 0; k < iRowspan; k++) {
									aLayout[i + k][iColShifted + l] = {
										"cell": nCell,
										"unique": bUnique
									};
									aLayout[i + k].nTr = nTr;
								}
							}
						}
						nCell = nCell.nextSibling;
					}
				}
			}

			/**
    * Get an array of unique th elements, one for each column
    *  @param {object} oSettings dataTables settings object
    *  @param {node} nHeader automatically detect the layout from this node - optional
    *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
    *  @returns array {node} aReturn list of unique th's
    *  @memberof DataTable#oApi
    */
			function _fnGetUniqueThs(oSettings, nHeader, aLayout) {
				var aReturn = [];
				if (!aLayout) {
					aLayout = oSettings.aoHeader;
					if (nHeader) {
						aLayout = [];
						_fnDetectHeader(aLayout, nHeader);
					}
				}

				for (var i = 0, iLen = aLayout.length; i < iLen; i++) {
					for (var j = 0, jLen = aLayout[i].length; j < jLen; j++) {
						if (aLayout[i][j].unique && (!aReturn[j] || !oSettings.bSortCellsTop)) {
							aReturn[j] = aLayout[i][j].cell;
						}
					}
				}

				return aReturn;
			}

			/**
    * Create an Ajax call based on the table's settings, taking into account that
    * parameters can have multiple forms, and backwards compatibility.
    *
    * @param {object} oSettings dataTables settings object
    * @param {array} data Data to send to the server, required by
    *     DataTables - may be augmented by developer callbacks
    * @param {function} fn Callback function to run when data is obtained
    */
			function _fnBuildAjax(oSettings, data, fn) {
				// Compatibility with 1.9-, allow fnServerData and event to manipulate
				_fnCallbackFire(oSettings, 'aoServerParams', 'serverParams', [data]);

				// Convert to object based for 1.10+ if using the old array scheme which can
				// come from server-side processing or serverParams
				if (data && $.isArray(data)) {
					var tmp = {};
					var rbracket = /(.*?)\[\]$/;

					$.each(data, function (key, val) {
						var match = val.name.match(rbracket);

						if (match) {
							// Support for arrays
							var name = match[0];

							if (!tmp[name]) {
								tmp[name] = [];
							}
							tmp[name].push(val.value);
						} else {
							tmp[val.name] = val.value;
						}
					});
					data = tmp;
				}

				var ajaxData;
				var ajax = oSettings.ajax;
				var instance = oSettings.oInstance;
				var callback = function (json) {
					_fnCallbackFire(oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR]);
					fn(json);
				};

				if ($.isPlainObject(ajax) && ajax.data) {
					ajaxData = ajax.data;

					var newData = typeof ajaxData === 'function' ? ajaxData(data, oSettings) : // fn can manipulate data or return
					ajaxData; // an object object or array to merge

					// If the function returned something, use that alone
					data = typeof ajaxData === 'function' && newData ? newData : $.extend(true, data, newData);

					// Remove the data property as we've resolved it already and don't want
					// jQuery to do it again (it is restored at the end of the function)
					delete ajax.data;
				}

				var baseAjax = {
					"data": data,
					"success": function (json) {
						var error = json.error || json.sError;
						if (error) {
							_fnLog(oSettings, 0, error);
						}

						oSettings.json = json;
						callback(json);
					},
					"dataType": "json",
					"cache": false,
					"type": oSettings.sServerMethod,
					"error": function (xhr, error, thrown) {
						var ret = _fnCallbackFire(oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR]);

						if ($.inArray(true, ret) === -1) {
							if (error == "parsererror") {
								_fnLog(oSettings, 0, 'Invalid JSON response', 1);
							} else if (xhr.readyState === 4) {
								_fnLog(oSettings, 0, 'Ajax error', 7);
							}
						}

						_fnProcessingDisplay(oSettings, false);
					}
				};

				// Store the data submitted for the API
				oSettings.oAjaxData = data;

				// Allow plug-ins and external processes to modify the data
				_fnCallbackFire(oSettings, null, 'preXhr', [oSettings, data]);

				if (oSettings.fnServerData) {
					// DataTables 1.9- compatibility
					oSettings.fnServerData.call(instance, oSettings.sAjaxSource, $.map(data, function (val, key) {
						// Need to convert back to 1.9 trad format
						return { name: key, value: val };
					}), callback, oSettings);
				} else if (oSettings.sAjaxSource || typeof ajax === 'string') {
					// DataTables 1.9- compatibility
					oSettings.jqXHR = $.ajax($.extend(baseAjax, {
						url: ajax || oSettings.sAjaxSource
					}));
				} else if (typeof ajax === 'function') {
					// Is a function - let the caller define what needs to be done
					oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
				} else {
					// Object to extend the base settings
					oSettings.jqXHR = $.ajax($.extend(baseAjax, ajax));

					// Restore for next time around
					ajax.data = ajaxData;
				}
			}

			/**
    * Update the table using an Ajax call
    *  @param {object} settings dataTables settings object
    *  @returns {boolean} Block the table drawing or not
    *  @memberof DataTable#oApi
    */
			function _fnAjaxUpdate(settings) {
				if (settings.bAjaxDataGet) {
					settings.iDraw++;
					_fnProcessingDisplay(settings, true);

					_fnBuildAjax(settings, _fnAjaxParameters(settings), function (json) {
						_fnAjaxUpdateDraw(settings, json);
					});

					return false;
				}
				return true;
			}

			/**
    * Build up the parameters in an object needed for a server-side processing
    * request. Note that this is basically done twice, is different ways - a modern
    * method which is used by default in DataTables 1.10 which uses objects and
    * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
    * the sAjaxSource option is used in the initialisation, or the legacyAjax
    * option is set.
    *  @param {object} oSettings dataTables settings object
    *  @returns {bool} block the table drawing or not
    *  @memberof DataTable#oApi
    */
			function _fnAjaxParameters(settings) {
				var columns = settings.aoColumns,
				    columnCount = columns.length,
				    features = settings.oFeatures,
				    preSearch = settings.oPreviousSearch,
				    preColSearch = settings.aoPreSearchCols,
				    i,
				    data = [],
				    dataProp,
				    column,
				    columnSearch,
				    sort = _fnSortFlatten(settings),
				    displayStart = settings._iDisplayStart,
				    displayLength = features.bPaginate !== false ? settings._iDisplayLength : -1;

				var param = function (name, value) {
					data.push({ 'name': name, 'value': value });
				};

				// DataTables 1.9- compatible method
				param('sEcho', settings.iDraw);
				param('iColumns', columnCount);
				param('sColumns', _pluck(columns, 'sName').join(','));
				param('iDisplayStart', displayStart);
				param('iDisplayLength', displayLength);

				// DataTables 1.10+ method
				var d = {
					draw: settings.iDraw,
					columns: [],
					order: [],
					start: displayStart,
					length: displayLength,
					search: {
						value: preSearch.sSearch,
						regex: preSearch.bRegex
					}
				};

				for (i = 0; i < columnCount; i++) {
					column = columns[i];
					columnSearch = preColSearch[i];
					dataProp = typeof column.mData == "function" ? 'function' : column.mData;

					d.columns.push({
						data: dataProp,
						name: column.sName,
						searchable: column.bSearchable,
						orderable: column.bSortable,
						search: {
							value: columnSearch.sSearch,
							regex: columnSearch.bRegex
						}
					});

					param("mDataProp_" + i, dataProp);

					if (features.bFilter) {
						param('sSearch_' + i, columnSearch.sSearch);
						param('bRegex_' + i, columnSearch.bRegex);
						param('bSearchable_' + i, column.bSearchable);
					}

					if (features.bSort) {
						param('bSortable_' + i, column.bSortable);
					}
				}

				if (features.bFilter) {
					param('sSearch', preSearch.sSearch);
					param('bRegex', preSearch.bRegex);
				}

				if (features.bSort) {
					$.each(sort, function (i, val) {
						d.order.push({ column: val.col, dir: val.dir });

						param('iSortCol_' + i, val.col);
						param('sSortDir_' + i, val.dir);
					});

					param('iSortingCols', sort.length);
				}

				// If the legacy.ajax parameter is null, then we automatically decide which
				// form to use, based on sAjaxSource
				var legacy = DataTable.ext.legacy.ajax;
				if (legacy === null) {
					return settings.sAjaxSource ? data : d;
				}

				// Otherwise, if legacy has been specified then we use that to decide on the
				// form
				return legacy ? data : d;
			}

			/**
    * Data the data from the server (nuking the old) and redraw the table
    *  @param {object} oSettings dataTables settings object
    *  @param {object} json json data return from the server.
    *  @param {string} json.sEcho Tracking flag for DataTables to match requests
    *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
    *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
    *  @param {array} json.aaData The data to display on this page
    *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
    *  @memberof DataTable#oApi
    */
			function _fnAjaxUpdateDraw(settings, json) {
				// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
				// Support both
				var compat = function (old, modern) {
					return json[old] !== undefined ? json[old] : json[modern];
				};

				var data = _fnAjaxDataSrc(settings, json);
				var draw = compat('sEcho', 'draw');
				var recordsTotal = compat('iTotalRecords', 'recordsTotal');
				var recordsFiltered = compat('iTotalDisplayRecords', 'recordsFiltered');

				if (draw) {
					// Protect against out of sequence returns
					if (draw * 1 < settings.iDraw) {
						return;
					}
					settings.iDraw = draw * 1;
				}

				_fnClearTable(settings);
				settings._iRecordsTotal = parseInt(recordsTotal, 10);
				settings._iRecordsDisplay = parseInt(recordsFiltered, 10);

				for (var i = 0, ien = data.length; i < ien; i++) {
					_fnAddData(settings, data[i]);
				}
				settings.aiDisplay = settings.aiDisplayMaster.slice();

				settings.bAjaxDataGet = false;
				_fnDraw(settings);

				if (!settings._bInitComplete) {
					_fnInitComplete(settings, json);
				}

				settings.bAjaxDataGet = true;
				_fnProcessingDisplay(settings, false);
			}

			/**
    * Get the data from the JSON data source to use for drawing a table. Using
    * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
    * source object, or from a processing function.
    *  @param {object} oSettings dataTables settings object
    *  @param  {object} json Data source object / array from the server
    *  @return {array} Array of data to use
    */
			function _fnAjaxDataSrc(oSettings, json) {
				var dataSrc = $.isPlainObject(oSettings.ajax) && oSettings.ajax.dataSrc !== undefined ? oSettings.ajax.dataSrc : oSettings.sAjaxDataProp; // Compatibility with 1.9-.

				// Compatibility with 1.9-. In order to read from aaData, check if the
				// default has been changed, if not, check for aaData
				if (dataSrc === 'data') {
					return json.aaData || json[dataSrc];
				}

				return dataSrc !== "" ? _fnGetObjectDataFn(dataSrc)(json) : json;
			}

			/**
    * Generate the node required for filtering text
    *  @returns {node} Filter control element
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlFilter(settings) {
				var classes = settings.oClasses;
				var tableId = settings.sTableId;
				var language = settings.oLanguage;
				var previousSearch = settings.oPreviousSearch;
				var features = settings.aanFeatures;
				var input = '<input type="search" class="' + classes.sFilterInput + '"/>';

				var str = language.sSearch;
				str = str.match(/_INPUT_/) ? str.replace('_INPUT_', input) : str + input;

				var filter = $('<div/>', {
					'id': !features.f ? tableId + '_filter' : null,
					'class': classes.sFilter
				}).append($('<label/>').append(str));

				var searchFn = function () {
					/* Update all other filter input elements for the new display */
					var n = features.f;
					var val = !this.value ? "" : this.value; // mental IE8 fix :-(

					/* Now do the filter */
					if (val != previousSearch.sSearch) {
						_fnFilterComplete(settings, {
							"sSearch": val,
							"bRegex": previousSearch.bRegex,
							"bSmart": previousSearch.bSmart,
							"bCaseInsensitive": previousSearch.bCaseInsensitive
						});

						// Need to redraw, without resorting
						settings._iDisplayStart = 0;
						_fnDraw(settings);
					}
				};

				var searchDelay = settings.searchDelay !== null ? settings.searchDelay : _fnDataSource(settings) === 'ssp' ? 400 : 0;

				var jqFilter = $('input', filter).val(previousSearch.sSearch).attr('placeholder', language.sSearchPlaceholder).on('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? _fnThrottle(searchFn, searchDelay) : searchFn).on('keypress.DT', function (e) {
					/* Prevent form submission */
					if (e.keyCode == 13) {
						return false;
					}
				}).attr('aria-controls', tableId);

				// Update the input elements whenever the table is filtered
				$(settings.nTable).on('search.dt.DT', function (ev, s) {
					if (settings === s) {
						// IE9 throws an 'unknown error' if document.activeElement is used
						// inside an iframe or frame...
						try {
							if (jqFilter[0] !== document.activeElement) {
								jqFilter.val(previousSearch.sSearch);
							}
						} catch (e) {}
					}
				});

				return filter[0];
			}

			/**
    * Filter the table using both the global filter and column based filtering
    *  @param {object} oSettings dataTables settings object
    *  @param {object} oSearch search information
    *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
    *  @memberof DataTable#oApi
    */
			function _fnFilterComplete(oSettings, oInput, iForce) {
				var oPrevSearch = oSettings.oPreviousSearch;
				var aoPrevSearch = oSettings.aoPreSearchCols;
				var fnSaveFilter = function (oFilter) {
					/* Save the filtering values */
					oPrevSearch.sSearch = oFilter.sSearch;
					oPrevSearch.bRegex = oFilter.bRegex;
					oPrevSearch.bSmart = oFilter.bSmart;
					oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
				};
				var fnRegex = function (o) {
					// Backwards compatibility with the bEscapeRegex option
					return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
				};

				// Resolve any column types that are unknown due to addition or invalidation
				// @todo As per sort - can this be moved into an event handler?
				_fnColumnTypes(oSettings);

				/* In server-side processing all filtering is done by the server, so no point hanging around here */
				if (_fnDataSource(oSettings) != 'ssp') {
					/* Global filter */
					_fnFilter(oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive);
					fnSaveFilter(oInput);

					/* Now do the individual column filter */
					for (var i = 0; i < aoPrevSearch.length; i++) {
						_fnFilterColumn(oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]), aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive);
					}

					/* Custom filtering */
					_fnFilterCustom(oSettings);
				} else {
					fnSaveFilter(oInput);
				}

				/* Tell the draw function we have been filtering */
				oSettings.bFiltered = true;
				_fnCallbackFire(oSettings, null, 'search', [oSettings]);
			}

			/**
    * Apply custom filtering functions
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnFilterCustom(settings) {
				var filters = DataTable.ext.search;
				var displayRows = settings.aiDisplay;
				var row, rowIdx;

				for (var i = 0, ien = filters.length; i < ien; i++) {
					var rows = [];

					// Loop over each row and see if it should be included
					for (var j = 0, jen = displayRows.length; j < jen; j++) {
						rowIdx = displayRows[j];
						row = settings.aoData[rowIdx];

						if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) {
							rows.push(rowIdx);
						}
					}

					// So the array reference doesn't break set the results into the
					// existing array
					displayRows.length = 0;
					$.merge(displayRows, rows);
				}
			}

			/**
    * Filter the table on a per-column basis
    *  @param {object} oSettings dataTables settings object
    *  @param {string} sInput string to filter on
    *  @param {int} iColumn column to filter
    *  @param {bool} bRegex treat search string as a regular expression or not
    *  @param {bool} bSmart use smart filtering or not
    *  @param {bool} bCaseInsensitive Do case insenstive matching or not
    *  @memberof DataTable#oApi
    */
			function _fnFilterColumn(settings, searchStr, colIdx, regex, smart, caseInsensitive) {
				if (searchStr === '') {
					return;
				}

				var data;
				var out = [];
				var display = settings.aiDisplay;
				var rpSearch = _fnFilterCreateSearch(searchStr, regex, smart, caseInsensitive);

				for (var i = 0; i < display.length; i++) {
					data = settings.aoData[display[i]]._aFilterData[colIdx];

					if (rpSearch.test(data)) {
						out.push(display[i]);
					}
				}

				settings.aiDisplay = out;
			}

			/**
    * Filter the data table based on user input and draw the table
    *  @param {object} settings dataTables settings object
    *  @param {string} input string to filter on
    *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
    *  @param {bool} regex treat as a regular expression or not
    *  @param {bool} smart perform smart filtering or not
    *  @param {bool} caseInsensitive Do case insenstive matching or not
    *  @memberof DataTable#oApi
    */
			function _fnFilter(settings, input, force, regex, smart, caseInsensitive) {
				var rpSearch = _fnFilterCreateSearch(input, regex, smart, caseInsensitive);
				var prevSearch = settings.oPreviousSearch.sSearch;
				var displayMaster = settings.aiDisplayMaster;
				var display, invalidated, i;
				var filtered = [];

				// Need to take account of custom filtering functions - always filter
				if (DataTable.ext.search.length !== 0) {
					force = true;
				}

				// Check if any of the rows were invalidated
				invalidated = _fnFilterData(settings);

				// If the input is blank - we just want the full data set
				if (input.length <= 0) {
					settings.aiDisplay = displayMaster.slice();
				} else {
					// New search - start from the master array
					if (invalidated || force || prevSearch.length > input.length || input.indexOf(prevSearch) !== 0 || settings.bSorted // On resort, the display master needs to be
					// re-filtered since indexes will have changed
					) {
							settings.aiDisplay = displayMaster.slice();
						}

					// Search the display array
					display = settings.aiDisplay;

					for (i = 0; i < display.length; i++) {
						if (rpSearch.test(settings.aoData[display[i]]._sFilterRow)) {
							filtered.push(display[i]);
						}
					}

					settings.aiDisplay = filtered;
				}
			}

			/**
    * Build a regular expression object suitable for searching a table
    *  @param {string} sSearch string to search for
    *  @param {bool} bRegex treat as a regular expression or not
    *  @param {bool} bSmart perform smart filtering or not
    *  @param {bool} bCaseInsensitive Do case insensitive matching or not
    *  @returns {RegExp} constructed object
    *  @memberof DataTable#oApi
    */
			function _fnFilterCreateSearch(search, regex, smart, caseInsensitive) {
				search = regex ? search : _fnEscapeRegex(search);

				if (smart) {
					/* For smart filtering we want to allow the search to work regardless of
      * word order. We also want double quoted text to be preserved, so word
      * order is important - a la google. So this is what we want to
      * generate:
      * 
      * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
      */
					var a = $.map(search.match(/"[^"]+"|[^ ]+/g) || [''], function (word) {
						if (word.charAt(0) === '"') {
							var m = word.match(/^"(.*)"$/);
							word = m ? m[1] : word;
						}

						return word.replace('"', '');
					});

					search = '^(?=.*?' + a.join(')(?=.*?') + ').*$';
				}

				return new RegExp(search, caseInsensitive ? 'i' : '');
			}

			/**
    * Escape a string such that it can be used in a regular expression
    *  @param {string} sVal string to escape
    *  @returns {string} escaped string
    *  @memberof DataTable#oApi
    */
			var _fnEscapeRegex = DataTable.util.escapeRegex;

			var __filter_div = $('<div>')[0];
			var __filter_div_textContent = __filter_div.textContent !== undefined;

			// Update the filtering data for each row if needed (by invalidation or first run)
			function _fnFilterData(settings) {
				var columns = settings.aoColumns;
				var column;
				var i, j, ien, jen, filterData, cellData, row;
				var fomatters = DataTable.ext.type.search;
				var wasInvalidated = false;

				for (i = 0, ien = settings.aoData.length; i < ien; i++) {
					row = settings.aoData[i];

					if (!row._aFilterData) {
						filterData = [];

						for (j = 0, jen = columns.length; j < jen; j++) {
							column = columns[j];

							if (column.bSearchable) {
								cellData = _fnGetCellData(settings, i, j, 'filter');

								if (fomatters[column.sType]) {
									cellData = fomatters[column.sType](cellData);
								}

								// Search in DataTables 1.10 is string based. In 1.11 this
								// should be altered to also allow strict type checking.
								if (cellData === null) {
									cellData = '';
								}

								if (typeof cellData !== 'string' && cellData.toString) {
									cellData = cellData.toString();
								}
							} else {
								cellData = '';
							}

							// If it looks like there is an HTML entity in the string,
							// attempt to decode it so sorting works as expected. Note that
							// we could use a single line of jQuery to do this, but the DOM
							// method used here is much faster http://jsperf.com/html-decode
							if (cellData.indexOf && cellData.indexOf('&') !== -1) {
								__filter_div.innerHTML = cellData;
								cellData = __filter_div_textContent ? __filter_div.textContent : __filter_div.innerText;
							}

							if (cellData.replace) {
								cellData = cellData.replace(/[\r\n]/g, '');
							}

							filterData.push(cellData);
						}

						row._aFilterData = filterData;
						row._sFilterRow = filterData.join('  ');
						wasInvalidated = true;
					}
				}

				return wasInvalidated;
			}

			/**
    * Convert from the internal Hungarian notation to camelCase for external
    * interaction
    *  @param {object} obj Object to convert
    *  @returns {object} Inverted object
    *  @memberof DataTable#oApi
    */
			function _fnSearchToCamel(obj) {
				return {
					search: obj.sSearch,
					smart: obj.bSmart,
					regex: obj.bRegex,
					caseInsensitive: obj.bCaseInsensitive
				};
			}

			/**
    * Convert from camelCase notation to the internal Hungarian. We could use the
    * Hungarian convert function here, but this is cleaner
    *  @param {object} obj Object to convert
    *  @returns {object} Inverted object
    *  @memberof DataTable#oApi
    */
			function _fnSearchToHung(obj) {
				return {
					sSearch: obj.search,
					bSmart: obj.smart,
					bRegex: obj.regex,
					bCaseInsensitive: obj.caseInsensitive
				};
			}

			/**
    * Generate the node required for the info display
    *  @param {object} oSettings dataTables settings object
    *  @returns {node} Information element
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlInfo(settings) {
				var tid = settings.sTableId,
				    nodes = settings.aanFeatures.i,
				    n = $('<div/>', {
					'class': settings.oClasses.sInfo,
					'id': !nodes ? tid + '_info' : null
				});

				if (!nodes) {
					// Update display on each draw
					settings.aoDrawCallback.push({
						"fn": _fnUpdateInfo,
						"sName": "information"
					});

					n.attr('role', 'status').attr('aria-live', 'polite');

					// Table is described by our info div
					$(settings.nTable).attr('aria-describedby', tid + '_info');
				}

				return n[0];
			}

			/**
    * Update the information elements in the display
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnUpdateInfo(settings) {
				/* Show information about the table */
				var nodes = settings.aanFeatures.i;
				if (nodes.length === 0) {
					return;
				}

				var lang = settings.oLanguage,
				    start = settings._iDisplayStart + 1,
				    end = settings.fnDisplayEnd(),
				    max = settings.fnRecordsTotal(),
				    total = settings.fnRecordsDisplay(),
				    out = total ? lang.sInfo : lang.sInfoEmpty;

				if (total !== max) {
					/* Record set after filtering */
					out += ' ' + lang.sInfoFiltered;
				}

				// Convert the macros
				out += lang.sInfoPostFix;
				out = _fnInfoMacros(settings, out);

				var callback = lang.fnInfoCallback;
				if (callback !== null) {
					out = callback.call(settings.oInstance, settings, start, end, max, total, out);
				}

				$(nodes).html(out);
			}

			function _fnInfoMacros(settings, str) {
				// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
				// internally
				var formatter = settings.fnFormatNumber,
				    start = settings._iDisplayStart + 1,
				    len = settings._iDisplayLength,
				    vis = settings.fnRecordsDisplay(),
				    all = len === -1;

				return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, settings.fnRecordsTotal())).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len)));
			}

			/**
    * Draw the table for the first time, adding all required features
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnInitialise(settings) {
				var i,
				    iLen,
				    iAjaxStart = settings.iInitDisplayStart;
				var columns = settings.aoColumns,
				    column;
				var features = settings.oFeatures;
				var deferLoading = settings.bDeferLoading; // value modified by the draw

				/* Ensure that the table data is fully initialised */
				if (!settings.bInitialised) {
					setTimeout(function () {
						_fnInitialise(settings);
					}, 200);
					return;
				}

				/* Show the display HTML options */
				_fnAddOptionsHtml(settings);

				/* Build and draw the header / footer for the table */
				_fnBuildHead(settings);
				_fnDrawHead(settings, settings.aoHeader);
				_fnDrawHead(settings, settings.aoFooter);

				/* Okay to show that something is going on now */
				_fnProcessingDisplay(settings, true);

				/* Calculate sizes for columns */
				if (features.bAutoWidth) {
					_fnCalculateColumnWidths(settings);
				}

				for (i = 0, iLen = columns.length; i < iLen; i++) {
					column = columns[i];

					if (column.sWidth) {
						column.nTh.style.width = _fnStringToCss(column.sWidth);
					}
				}

				_fnCallbackFire(settings, null, 'preInit', [settings]);

				// If there is default sorting required - let's do it. The sort function
				// will do the drawing for us. Otherwise we draw the table regardless of the
				// Ajax source - this allows the table to look initialised for Ajax sourcing
				// data (show 'loading' message possibly)
				_fnReDraw(settings);

				// Server-side processing init complete is done by _fnAjaxUpdateDraw
				var dataSrc = _fnDataSource(settings);
				if (dataSrc != 'ssp' || deferLoading) {
					// if there is an ajax source load the data
					if (dataSrc == 'ajax') {
						_fnBuildAjax(settings, [], function (json) {
							var aData = _fnAjaxDataSrc(settings, json);

							// Got the data - add it to the table
							for (i = 0; i < aData.length; i++) {
								_fnAddData(settings, aData[i]);
							}

							// Reset the init display for cookie saving. We've already done
							// a filter, and therefore cleared it before. So we need to make
							// it appear 'fresh'
							settings.iInitDisplayStart = iAjaxStart;

							_fnReDraw(settings);

							_fnProcessingDisplay(settings, false);
							_fnInitComplete(settings, json);
						}, settings);
					} else {
						_fnProcessingDisplay(settings, false);
						_fnInitComplete(settings);
					}
				}
			}

			/**
    * Draw the table for the first time, adding all required features
    *  @param {object} oSettings dataTables settings object
    *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
    *    with client-side processing (optional)
    *  @memberof DataTable#oApi
    */
			function _fnInitComplete(settings, json) {
				settings._bInitComplete = true;

				// When data was added after the initialisation (data or Ajax) we need to
				// calculate the column sizing
				if (json || settings.oInit.aaData) {
					_fnAdjustColumnSizing(settings);
				}

				_fnCallbackFire(settings, null, 'plugin-init', [settings, json]);
				_fnCallbackFire(settings, 'aoInitComplete', 'init', [settings, json]);
			}

			function _fnLengthChange(settings, val) {
				var len = parseInt(val, 10);
				settings._iDisplayLength = len;

				_fnLengthOverflow(settings);

				// Fire length change event
				_fnCallbackFire(settings, null, 'length', [settings, len]);
			}

			/**
    * Generate the node required for user display length changing
    *  @param {object} settings dataTables settings object
    *  @returns {node} Display length feature node
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlLength(settings) {
				var classes = settings.oClasses,
				    tableId = settings.sTableId,
				    menu = settings.aLengthMenu,
				    d2 = $.isArray(menu[0]),
				    lengths = d2 ? menu[0] : menu,
				    language = d2 ? menu[1] : menu;

				var select = $('<select/>', {
					'name': tableId + '_length',
					'aria-controls': tableId,
					'class': classes.sLengthSelect
				});

				for (var i = 0, ien = lengths.length; i < ien; i++) {
					select[0][i] = new Option(typeof language[i] === 'number' ? settings.fnFormatNumber(language[i]) : language[i], lengths[i]);
				}

				var div = $('<div><label/></div>').addClass(classes.sLength);
				if (!settings.aanFeatures.l) {
					div[0].id = tableId + '_length';
				}

				div.children().append(settings.oLanguage.sLengthMenu.replace('_MENU_', select[0].outerHTML));

				// Can't use `select` variable as user might provide their own and the
				// reference is broken by the use of outerHTML
				$('select', div).val(settings._iDisplayLength).on('change.DT', function (e) {
					_fnLengthChange(settings, $(this).val());
					_fnDraw(settings);
				});

				// Update node value whenever anything changes the table's length
				$(settings.nTable).on('length.dt.DT', function (e, s, len) {
					if (settings === s) {
						$('select', div).val(len);
					}
				});

				return div[0];
			}

			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    * Note that most of the paging logic is done in
    * DataTable.ext.pager
    */

			/**
    * Generate the node required for default pagination
    *  @param {object} oSettings dataTables settings object
    *  @returns {node} Pagination feature node
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlPaginate(settings) {
				var type = settings.sPaginationType,
				    plugin = DataTable.ext.pager[type],
				    modern = typeof plugin === 'function',
				    redraw = function (settings) {
					_fnDraw(settings);
				},
				    node = $('<div/>').addClass(settings.oClasses.sPaging + type)[0],
				    features = settings.aanFeatures;

				if (!modern) {
					plugin.fnInit(settings, node, redraw);
				}

				/* Add a draw callback for the pagination on first instance, to update the paging display */
				if (!features.p) {
					node.id = settings.sTableId + '_paginate';

					settings.aoDrawCallback.push({
						"fn": function (settings) {
							if (modern) {
								var start = settings._iDisplayStart,
								    len = settings._iDisplayLength,
								    visRecords = settings.fnRecordsDisplay(),
								    all = len === -1,
								    page = all ? 0 : Math.ceil(start / len),
								    pages = all ? 1 : Math.ceil(visRecords / len),
								    buttons = plugin(page, pages),
								    i,
								    ien;

								for (i = 0, ien = features.p.length; i < ien; i++) {
									_fnRenderer(settings, 'pageButton')(settings, features.p[i], i, buttons, page, pages);
								}
							} else {
								plugin.fnUpdate(settings, redraw);
							}
						},
						"sName": "pagination"
					});
				}

				return node;
			}

			/**
    * Alter the display settings to change the page
    *  @param {object} settings DataTables settings object
    *  @param {string|int} action Paging action to take: "first", "previous",
    *    "next" or "last" or page number to jump to (integer)
    *  @param [bool] redraw Automatically draw the update or not
    *  @returns {bool} true page has changed, false - no change
    *  @memberof DataTable#oApi
    */
			function _fnPageChange(settings, action, redraw) {
				var start = settings._iDisplayStart,
				    len = settings._iDisplayLength,
				    records = settings.fnRecordsDisplay();

				if (records === 0 || len === -1) {
					start = 0;
				} else if (typeof action === "number") {
					start = action * len;

					if (start > records) {
						start = 0;
					}
				} else if (action == "first") {
					start = 0;
				} else if (action == "previous") {
					start = len >= 0 ? start - len : 0;

					if (start < 0) {
						start = 0;
					}
				} else if (action == "next") {
					if (start + len < records) {
						start += len;
					}
				} else if (action == "last") {
					start = Math.floor((records - 1) / len) * len;
				} else {
					_fnLog(settings, 0, "Unknown paging action: " + action, 5);
				}

				var changed = settings._iDisplayStart !== start;
				settings._iDisplayStart = start;

				if (changed) {
					_fnCallbackFire(settings, null, 'page', [settings]);

					if (redraw) {
						_fnDraw(settings);
					}
				}

				return changed;
			}

			/**
    * Generate the node required for the processing node
    *  @param {object} settings dataTables settings object
    *  @returns {node} Processing element
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlProcessing(settings) {
				return $('<div/>', {
					'id': !settings.aanFeatures.r ? settings.sTableId + '_processing' : null,
					'class': settings.oClasses.sProcessing
				}).html(settings.oLanguage.sProcessing).insertBefore(settings.nTable)[0];
			}

			/**
    * Display or hide the processing indicator
    *  @param {object} settings dataTables settings object
    *  @param {bool} show Show the processing indicator (true) or not (false)
    *  @memberof DataTable#oApi
    */
			function _fnProcessingDisplay(settings, show) {
				if (settings.oFeatures.bProcessing) {
					$(settings.aanFeatures.r).css('display', show ? 'block' : 'none');
				}

				_fnCallbackFire(settings, null, 'processing', [settings, show]);
			}

			/**
    * Add any control elements for the table - specifically scrolling
    *  @param {object} settings dataTables settings object
    *  @returns {node} Node to add to the DOM
    *  @memberof DataTable#oApi
    */
			function _fnFeatureHtmlTable(settings) {
				var table = $(settings.nTable);

				// Add the ARIA grid role to the table
				table.attr('role', 'grid');

				// Scrolling from here on in
				var scroll = settings.oScroll;

				if (scroll.sX === '' && scroll.sY === '') {
					return settings.nTable;
				}

				var scrollX = scroll.sX;
				var scrollY = scroll.sY;
				var classes = settings.oClasses;
				var caption = table.children('caption');
				var captionSide = caption.length ? caption[0]._captionSide : null;
				var headerClone = $(table[0].cloneNode(false));
				var footerClone = $(table[0].cloneNode(false));
				var footer = table.children('tfoot');
				var _div = '<div/>';
				var size = function (s) {
					return !s ? null : _fnStringToCss(s);
				};

				if (!footer.length) {
					footer = null;
				}

				/*
     * The HTML structure that we want to generate in this function is:
     *  div - scroller
     *    div - scroll head
     *      div - scroll head inner
     *        table - scroll head table
     *          thead - thead
     *    div - scroll body
     *      table - table (master table)
     *        thead - thead clone for sizing
     *        tbody - tbody
     *    div - scroll foot
     *      div - scroll foot inner
     *        table - scroll foot table
     *          tfoot - tfoot
     */
				var scroller = $(_div, { 'class': classes.sScrollWrapper }).append($(_div, { 'class': classes.sScrollHead }).css({
					overflow: 'hidden',
					position: 'relative',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				}).append($(_div, { 'class': classes.sScrollHeadInner }).css({
					'box-sizing': 'content-box',
					width: scroll.sXInner || '100%'
				}).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($(_div, { 'class': classes.sScrollBody }).css({
					position: 'relative',
					overflow: 'auto',
					width: size(scrollX)
				}).append(table));

				if (footer) {
					scroller.append($(_div, { 'class': classes.sScrollFoot }).css({
						overflow: 'hidden',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					}).append($(_div, { 'class': classes.sScrollFootInner }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
				}

				var children = scroller.children();
				var scrollHead = children[0];
				var scrollBody = children[1];
				var scrollFoot = footer ? children[2] : null;

				// When the body is scrolled, then we also want to scroll the headers
				if (scrollX) {
					$(scrollBody).on('scroll.DT', function (e) {
						var scrollLeft = this.scrollLeft;

						scrollHead.scrollLeft = scrollLeft;

						if (footer) {
							scrollFoot.scrollLeft = scrollLeft;
						}
					});
				}

				$(scrollBody).css(scrollY && scroll.bCollapse ? 'max-height' : 'height', scrollY);

				settings.nScrollHead = scrollHead;
				settings.nScrollBody = scrollBody;
				settings.nScrollFoot = scrollFoot;

				// On redraw - align columns
				settings.aoDrawCallback.push({
					"fn": _fnScrollDraw,
					"sName": "scrolling"
				});

				return scroller[0];
			}

			/**
    * Update the header, footer and body tables for resizing - i.e. column
    * alignment.
    *
    * Welcome to the most horrible function DataTables. The process that this
    * function follows is basically:
    *   1. Re-create the table inside the scrolling div
    *   2. Take live measurements from the DOM
    *   3. Apply the measurements to align the columns
    *   4. Clean up
    *
    *  @param {object} settings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnScrollDraw(settings) {
				// Given that this is such a monster function, a lot of variables are use
				// to try and keep the minimised size as small as possible
				var scroll = settings.oScroll,
				    scrollX = scroll.sX,
				    scrollXInner = scroll.sXInner,
				    scrollY = scroll.sY,
				    barWidth = scroll.iBarWidth,
				    divHeader = $(settings.nScrollHead),
				    divHeaderStyle = divHeader[0].style,
				    divHeaderInner = divHeader.children('div'),
				    divHeaderInnerStyle = divHeaderInner[0].style,
				    divHeaderTable = divHeaderInner.children('table'),
				    divBodyEl = settings.nScrollBody,
				    divBody = $(divBodyEl),
				    divBodyStyle = divBodyEl.style,
				    divFooter = $(settings.nScrollFoot),
				    divFooterInner = divFooter.children('div'),
				    divFooterTable = divFooterInner.children('table'),
				    header = $(settings.nTHead),
				    table = $(settings.nTable),
				    tableEl = table[0],
				    tableStyle = tableEl.style,
				    footer = settings.nTFoot ? $(settings.nTFoot) : null,
				    browser = settings.oBrowser,
				    ie67 = browser.bScrollOversize,
				    dtHeaderCells = _pluck(settings.aoColumns, 'nTh'),
				    headerTrgEls,
				    footerTrgEls,
				    headerSrcEls,
				    footerSrcEls,
				    headerCopy,
				    footerCopy,
				    headerWidths = [],
				    footerWidths = [],
				    headerContent = [],
				    footerContent = [],
				    idx,
				    correction,
				    sanityWidth,
				    zeroOut = function (nSizer) {
					var style = nSizer.style;
					style.paddingTop = "0";
					style.paddingBottom = "0";
					style.borderTopWidth = "0";
					style.borderBottomWidth = "0";
					style.height = 0;
				};

				// If the scrollbar visibility has changed from the last draw, we need to
				// adjust the column sizes as the table width will have changed to account
				// for the scrollbar
				var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;

				if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
					settings.scrollBarVis = scrollBarVis;
					_fnAdjustColumnSizing(settings);
					return; // adjust column sizing will call this function again
				} else {
					settings.scrollBarVis = scrollBarVis;
				}

				/*
     * 1. Re-create the table inside the scrolling div
     */

				// Remove the old minimised thead and tfoot elements in the inner table
				table.children('thead, tfoot').remove();

				if (footer) {
					footerCopy = footer.clone().prependTo(table);
					footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
					footerSrcEls = footerCopy.find('tr');
				}

				// Clone the current header and footer elements and then place it into the inner table
				headerCopy = header.clone().prependTo(table);
				headerTrgEls = header.find('tr'); // original header is in its own table
				headerSrcEls = headerCopy.find('tr');
				headerCopy.find('th, td').removeAttr('tabindex');

				/*
     * 2. Take live measurements from the DOM - do not alter the DOM itself!
     */

				// Remove old sizing and apply the calculated column widths
				// Get the unique column headers in the newly created (cloned) header. We want to apply the
				// calculated sizes to this header
				if (!scrollX) {
					divBodyStyle.width = '100%';
					divHeader[0].style.width = '100%';
				}

				$.each(_fnGetUniqueThs(settings, headerCopy), function (i, el) {
					idx = _fnVisibleToColumnIndex(settings, i);
					el.style.width = settings.aoColumns[idx].sWidth;
				});

				if (footer) {
					_fnApplyToChildren(function (n) {
						n.style.width = "";
					}, footerSrcEls);
				}

				// Size the table as a whole
				sanityWidth = table.outerWidth();
				if (scrollX === "") {
					// No x scrolling
					tableStyle.width = "100%";

					// IE7 will make the width of the table when 100% include the scrollbar
					// - which is shouldn't. When there is a scrollbar we need to take this
					// into account.
					if (ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")) {
						tableStyle.width = _fnStringToCss(table.outerWidth() - barWidth);
					}

					// Recalculate the sanity width
					sanityWidth = table.outerWidth();
				} else if (scrollXInner !== "") {
					// legacy x scroll inner has been given - use it
					tableStyle.width = _fnStringToCss(scrollXInner);

					// Recalculate the sanity width
					sanityWidth = table.outerWidth();
				}

				// Hidden header should have zero height, so remove padding and borders. Then
				// set the width based on the real headers

				// Apply all styles in one pass
				_fnApplyToChildren(zeroOut, headerSrcEls);

				// Read all widths in next pass
				_fnApplyToChildren(function (nSizer) {
					headerContent.push(nSizer.innerHTML);
					headerWidths.push(_fnStringToCss($(nSizer).css('width')));
				}, headerSrcEls);

				// Apply all widths in final pass
				_fnApplyToChildren(function (nToSize, i) {
					// Only apply widths to the DataTables detected header cells - this
					// prevents complex headers from having contradictory sizes applied
					if ($.inArray(nToSize, dtHeaderCells) !== -1) {
						nToSize.style.width = headerWidths[i];
					}
				}, headerTrgEls);

				$(headerSrcEls).height(0);

				/* Same again with the footer if we have one */
				if (footer) {
					_fnApplyToChildren(zeroOut, footerSrcEls);

					_fnApplyToChildren(function (nSizer) {
						footerContent.push(nSizer.innerHTML);
						footerWidths.push(_fnStringToCss($(nSizer).css('width')));
					}, footerSrcEls);

					_fnApplyToChildren(function (nToSize, i) {
						nToSize.style.width = footerWidths[i];
					}, footerTrgEls);

					$(footerSrcEls).height(0);
				}

				/*
     * 3. Apply the measurements
     */

				// "Hide" the header and footer that we used for the sizing. We need to keep
				// the content of the cell so that the width applied to the header and body
				// both match, but we want to hide it completely. We want to also fix their
				// width to what they currently are
				_fnApplyToChildren(function (nSizer, i) {
					nSizer.innerHTML = '<div class="dataTables_sizing">' + headerContent[i] + '</div>';
					nSizer.childNodes[0].style.height = "0";
					nSizer.childNodes[0].style.overflow = "hidden";
					nSizer.style.width = headerWidths[i];
				}, headerSrcEls);

				if (footer) {
					_fnApplyToChildren(function (nSizer, i) {
						nSizer.innerHTML = '<div class="dataTables_sizing">' + footerContent[i] + '</div>';
						nSizer.childNodes[0].style.height = "0";
						nSizer.childNodes[0].style.overflow = "hidden";
						nSizer.style.width = footerWidths[i];
					}, footerSrcEls);
				}

				// Sanity check that the table is of a sensible width. If not then we are going to get
				// misalignment - try to prevent this by not allowing the table to shrink below its min width
				if (table.outerWidth() < sanityWidth) {
					// The min width depends upon if we have a vertical scrollbar visible or not */
					correction = divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll" ? sanityWidth + barWidth : sanityWidth;

					// IE6/7 are a law unto themselves...
					if (ie67 && (divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")) {
						tableStyle.width = _fnStringToCss(correction - barWidth);
					}

					// And give the user a warning that we've stopped the table getting too small
					if (scrollX === "" || scrollXInner !== "") {
						_fnLog(settings, 1, 'Possible column misalignment', 6);
					}
				} else {
					correction = '100%';
				}

				// Apply to the container elements
				divBodyStyle.width = _fnStringToCss(correction);
				divHeaderStyle.width = _fnStringToCss(correction);

				if (footer) {
					settings.nScrollFoot.style.width = _fnStringToCss(correction);
				}

				/*
     * 4. Clean up
     */
				if (!scrollY) {
					/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
      * the scrollbar height from the visible display, rather than adding it on. We need to
      * set the height in order to sort this. Don't want to do it in any other browsers.
      */
					if (ie67) {
						divBodyStyle.height = _fnStringToCss(tableEl.offsetHeight + barWidth);
					}
				}

				/* Finally set the width's of the header and footer tables */
				var iOuterWidth = table.outerWidth();
				divHeaderTable[0].style.width = _fnStringToCss(iOuterWidth);
				divHeaderInnerStyle.width = _fnStringToCss(iOuterWidth);

				// Figure out if there are scrollbar present - if so then we need a the header and footer to
				// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
				var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
				var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
				divHeaderInnerStyle[padding] = bScrolling ? barWidth + "px" : "0px";

				if (footer) {
					divFooterTable[0].style.width = _fnStringToCss(iOuterWidth);
					divFooterInner[0].style.width = _fnStringToCss(iOuterWidth);
					divFooterInner[0].style[padding] = bScrolling ? barWidth + "px" : "0px";
				}

				// Correct DOM ordering for colgroup - comes before the thead
				table.children('colgroup').insertBefore(table.children('thead'));

				/* Adjust the position of the header in case we loose the y-scrollbar */
				divBody.scroll();

				// If sorting or filtering has occurred, jump the scrolling back to the top
				// only if we aren't holding the position
				if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) {
					divBodyEl.scrollTop = 0;
				}
			}

			/**
    * Apply a given function to the display child nodes of an element array (typically
    * TD children of TR rows
    *  @param {function} fn Method to apply to the objects
    *  @param array {nodes} an1 List of elements to look through for display children
    *  @param array {nodes} an2 Another list (identical structure to the first) - optional
    *  @memberof DataTable#oApi
    */
			function _fnApplyToChildren(fn, an1, an2) {
				var index = 0,
				    i = 0,
				    iLen = an1.length;
				var nNode1, nNode2;

				while (i < iLen) {
					nNode1 = an1[i].firstChild;
					nNode2 = an2 ? an2[i].firstChild : null;

					while (nNode1) {
						if (nNode1.nodeType === 1) {
							if (an2) {
								fn(nNode1, nNode2, index);
							} else {
								fn(nNode1, index);
							}

							index++;
						}

						nNode1 = nNode1.nextSibling;
						nNode2 = an2 ? nNode2.nextSibling : null;
					}

					i++;
				}
			}

			var __re_html_remove = /<.*?>/g;

			/**
    * Calculate the width of columns for the table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnCalculateColumnWidths(oSettings) {
				var table = oSettings.nTable,
				    columns = oSettings.aoColumns,
				    scroll = oSettings.oScroll,
				    scrollY = scroll.sY,
				    scrollX = scroll.sX,
				    scrollXInner = scroll.sXInner,
				    columnCount = columns.length,
				    visibleColumns = _fnGetColumns(oSettings, 'bVisible'),
				    headerCells = $('th', oSettings.nTHead),
				    tableWidthAttr = table.getAttribute('width'),
				    // from DOM element
				tableContainer = table.parentNode,
				    userInputs = false,
				    i,
				    column,
				    columnIdx,
				    width,
				    outerWidth,
				    browser = oSettings.oBrowser,
				    ie67 = browser.bScrollOversize;

				var styleWidth = table.style.width;
				if (styleWidth && styleWidth.indexOf('%') !== -1) {
					tableWidthAttr = styleWidth;
				}

				/* Convert any user input sizes into pixel sizes */
				for (i = 0; i < visibleColumns.length; i++) {
					column = columns[visibleColumns[i]];

					if (column.sWidth !== null) {
						column.sWidth = _fnConvertToWidth(column.sWidthOrig, tableContainer);

						userInputs = true;
					}
				}

				/* If the number of columns in the DOM equals the number that we have to
     * process in DataTables, then we can use the offsets that are created by
     * the web- browser. No custom sizes can be set in order for this to happen,
     * nor scrolling used
     */
				if (ie67 || !userInputs && !scrollX && !scrollY && columnCount == _fnVisbleColumns(oSettings) && columnCount == headerCells.length) {
					for (i = 0; i < columnCount; i++) {
						var colIdx = _fnVisibleToColumnIndex(oSettings, i);

						if (colIdx !== null) {
							columns[colIdx].sWidth = _fnStringToCss(headerCells.eq(i).width());
						}
					}
				} else {
					// Otherwise construct a single row, worst case, table with the widest
					// node in the data, assign any user defined widths, then insert it into
					// the DOM and allow the browser to do all the hard work of calculating
					// table widths
					var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
					.css('visibility', 'hidden').removeAttr('id');

					// Clean up the table body
					tmpTable.find('tbody tr').remove();
					var tr = $('<tr/>').appendTo(tmpTable.find('tbody'));

					// Clone the table header and footer - we can't use the header / footer
					// from the cloned table, since if scrolling is active, the table's
					// real header and footer are contained in different table tags
					tmpTable.find('thead, tfoot').remove();
					tmpTable.append($(oSettings.nTHead).clone()).append($(oSettings.nTFoot).clone());

					// Remove any assigned widths from the footer (from scrolling)
					tmpTable.find('tfoot th, tfoot td').css('width', '');

					// Apply custom sizing to the cloned header
					headerCells = _fnGetUniqueThs(oSettings, tmpTable.find('thead')[0]);

					for (i = 0; i < visibleColumns.length; i++) {
						column = columns[visibleColumns[i]];

						headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ? _fnStringToCss(column.sWidthOrig) : '';

						// For scrollX we need to force the column width otherwise the
						// browser will collapse it. If this width is smaller than the
						// width the column requires, then it will have no effect
						if (column.sWidthOrig && scrollX) {
							$(headerCells[i]).append($('<div/>').css({
								width: column.sWidthOrig,
								margin: 0,
								padding: 0,
								border: 0,
								height: 1
							}));
						}
					}

					// Find the widest cell for each column and put it into the table
					if (oSettings.aoData.length) {
						for (i = 0; i < visibleColumns.length; i++) {
							columnIdx = visibleColumns[i];
							column = columns[columnIdx];

							$(_fnGetWidestNode(oSettings, columnIdx)).clone(false).append(column.sContentPadding).appendTo(tr);
						}
					}

					// Tidy the temporary table - remove name attributes so there aren't
					// duplicated in the dom (radio elements for example)
					$('[name]', tmpTable).removeAttr('name');

					// Table has been built, attach to the document so we can work with it.
					// A holding element is used, positioned at the top of the container
					// with minimal height, so it has no effect on if the container scrolls
					// or not. Otherwise it might trigger scrolling when it actually isn't
					// needed
					var holder = $('<div/>').css(scrollX || scrollY ? {
						position: 'absolute',
						top: 0,
						left: 0,
						height: 1,
						right: 0,
						overflow: 'hidden'
					} : {}).append(tmpTable).appendTo(tableContainer);

					// When scrolling (X or Y) we want to set the width of the table as 
					// appropriate. However, when not scrolling leave the table width as it
					// is. This results in slightly different, but I think correct behaviour
					if (scrollX && scrollXInner) {
						tmpTable.width(scrollXInner);
					} else if (scrollX) {
						tmpTable.css('width', 'auto');
						tmpTable.removeAttr('width');

						// If there is no width attribute or style, then allow the table to
						// collapse
						if (tmpTable.width() < tableContainer.clientWidth && tableWidthAttr) {
							tmpTable.width(tableContainer.clientWidth);
						}
					} else if (scrollY) {
						tmpTable.width(tableContainer.clientWidth);
					} else if (tableWidthAttr) {
						tmpTable.width(tableWidthAttr);
					}

					// Get the width of each column in the constructed table - we need to
					// know the inner width (so it can be assigned to the other table's
					// cells) and the outer width so we can calculate the full width of the
					// table. This is safe since DataTables requires a unique cell for each
					// column, but if ever a header can span multiple columns, this will
					// need to be modified.
					var total = 0;
					for (i = 0; i < visibleColumns.length; i++) {
						var cell = $(headerCells[i]);
						var border = cell.outerWidth() - cell.width();

						// Use getBounding... where possible (not IE8-) because it can give
						// sub-pixel accuracy, which we then want to round up!
						var bounding = browser.bBounding ? Math.ceil(headerCells[i].getBoundingClientRect().width) : cell.outerWidth();

						// Total is tracked to remove any sub-pixel errors as the outerWidth
						// of the table might not equal the total given here (IE!).
						total += bounding;

						// Width for each column to use
						columns[visibleColumns[i]].sWidth = _fnStringToCss(bounding - border);
					}

					table.style.width = _fnStringToCss(total);

					// Finished with the table - ditch it
					holder.remove();
				}

				// If there is a width attr, we want to attach an event listener which
				// allows the table sizing to automatically adjust when the window is
				// resized. Use the width attr rather than CSS, since we can't know if the
				// CSS is a relative value or absolute - DOM read is always px.
				if (tableWidthAttr) {
					table.style.width = _fnStringToCss(tableWidthAttr);
				}

				if ((tableWidthAttr || scrollX) && !oSettings._reszEvt) {
					var bindResize = function () {
						$(window).on('resize.DT-' + oSettings.sInstance, _fnThrottle(function () {
							_fnAdjustColumnSizing(oSettings);
						}));
					};

					// IE6/7 will crash if we bind a resize event handler on page load.
					// To be removed in 1.11 which drops IE6/7 support
					if (ie67) {
						setTimeout(bindResize, 1000);
					} else {
						bindResize();
					}

					oSettings._reszEvt = true;
				}
			}

			/**
    * Throttle the calls to a function. Arguments and context are maintained for
    * the throttled function
    *  @param {function} fn Function to be called
    *  @param {int} [freq=200] call frequency in mS
    *  @returns {function} wrapped function
    *  @memberof DataTable#oApi
    */
			var _fnThrottle = DataTable.util.throttle;

			/**
    * Convert a CSS unit width to pixels (e.g. 2em)
    *  @param {string} width width to be converted
    *  @param {node} parent parent to get the with for (required for relative widths) - optional
    *  @returns {int} width in pixels
    *  @memberof DataTable#oApi
    */
			function _fnConvertToWidth(width, parent) {
				if (!width) {
					return 0;
				}

				var n = $('<div/>').css('width', _fnStringToCss(width)).appendTo(parent || document.body);

				var val = n[0].offsetWidth;
				n.remove();

				return val;
			}

			/**
    * Get the widest node
    *  @param {object} settings dataTables settings object
    *  @param {int} colIdx column of interest
    *  @returns {node} widest table node
    *  @memberof DataTable#oApi
    */
			function _fnGetWidestNode(settings, colIdx) {
				var idx = _fnGetMaxLenString(settings, colIdx);
				if (idx < 0) {
					return null;
				}

				var data = settings.aoData[idx];
				return !data.nTr ? // Might not have been created when deferred rendering
				$('<td/>').html(_fnGetCellData(settings, idx, colIdx, 'display'))[0] : data.anCells[colIdx];
			}

			/**
    * Get the maximum strlen for each data column
    *  @param {object} settings dataTables settings object
    *  @param {int} colIdx column of interest
    *  @returns {string} max string length for each column
    *  @memberof DataTable#oApi
    */
			function _fnGetMaxLenString(settings, colIdx) {
				var s,
				    max = -1,
				    maxIdx = -1;

				for (var i = 0, ien = settings.aoData.length; i < ien; i++) {
					s = _fnGetCellData(settings, i, colIdx, 'display') + '';
					s = s.replace(__re_html_remove, '');
					s = s.replace(/&nbsp;/g, ' ');

					if (s.length > max) {
						max = s.length;
						maxIdx = i;
					}
				}

				return maxIdx;
			}

			/**
    * Append a CSS unit (only if required) to a string
    *  @param {string} value to css-ify
    *  @returns {string} value with css unit
    *  @memberof DataTable#oApi
    */
			function _fnStringToCss(s) {
				if (s === null) {
					return '0px';
				}

				if (typeof s == 'number') {
					return s < 0 ? '0px' : s + 'px';
				}

				// Check it has a unit character already
				return s.match(/\d$/) ? s + 'px' : s;
			}

			function _fnSortFlatten(settings) {
				var i,
				    iLen,
				    k,
				    kLen,
				    aSort = [],
				    aiOrig = [],
				    aoColumns = settings.aoColumns,
				    aDataSort,
				    iCol,
				    sType,
				    srcCol,
				    fixed = settings.aaSortingFixed,
				    fixedObj = $.isPlainObject(fixed),
				    nestedSort = [],
				    add = function (a) {
					if (a.length && !$.isArray(a[0])) {
						// 1D array
						nestedSort.push(a);
					} else {
						// 2D array
						$.merge(nestedSort, a);
					}
				};

				// Build the sort array, with pre-fix and post-fix options if they have been
				// specified
				if ($.isArray(fixed)) {
					add(fixed);
				}

				if (fixedObj && fixed.pre) {
					add(fixed.pre);
				}

				add(settings.aaSorting);

				if (fixedObj && fixed.post) {
					add(fixed.post);
				}

				for (i = 0; i < nestedSort.length; i++) {
					srcCol = nestedSort[i][0];
					aDataSort = aoColumns[srcCol].aDataSort;

					for (k = 0, kLen = aDataSort.length; k < kLen; k++) {
						iCol = aDataSort[k];
						sType = aoColumns[iCol].sType || 'string';

						if (nestedSort[i]._idx === undefined) {
							nestedSort[i]._idx = $.inArray(nestedSort[i][1], aoColumns[iCol].asSorting);
						}

						aSort.push({
							src: srcCol,
							col: iCol,
							dir: nestedSort[i][1],
							index: nestedSort[i]._idx,
							type: sType,
							formatter: DataTable.ext.type.order[sType + "-pre"]
						});
					}
				}

				return aSort;
			}

			/**
    * Change the order of the table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    *  @todo This really needs split up!
    */
			function _fnSort(oSettings) {
				var i,
				    ien,
				    iLen,
				    j,
				    jLen,
				    k,
				    kLen,
				    sDataType,
				    nTh,
				    aiOrig = [],
				    oExtSort = DataTable.ext.type.order,
				    aoData = oSettings.aoData,
				    aoColumns = oSettings.aoColumns,
				    aDataSort,
				    data,
				    iCol,
				    sType,
				    oSort,
				    formatters = 0,
				    sortCol,
				    displayMaster = oSettings.aiDisplayMaster,
				    aSort;

				// Resolve any column types that are unknown due to addition or invalidation
				// @todo Can this be moved into a 'data-ready' handler which is called when
				//   data is going to be used in the table?
				_fnColumnTypes(oSettings);

				aSort = _fnSortFlatten(oSettings);

				for (i = 0, ien = aSort.length; i < ien; i++) {
					sortCol = aSort[i];

					// Track if we can use the fast sort algorithm
					if (sortCol.formatter) {
						formatters++;
					}

					// Load the data needed for the sort, for each cell
					_fnSortData(oSettings, sortCol.col);
				}

				/* No sorting required if server-side or no sorting array */
				if (_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
					// Create a value - key array of the current row positions such that we can use their
					// current position during the sort, if values match, in order to perform stable sorting
					for (i = 0, iLen = displayMaster.length; i < iLen; i++) {
						aiOrig[displayMaster[i]] = i;
					}

					/* Do the sort - here we want multi-column sorting based on a given data source (column)
      * and sorting function (from oSort) in a certain direction. It's reasonably complex to
      * follow on it's own, but this is what we want (example two column sorting):
      *  fnLocalSorting = function(a,b){
      *    var iTest;
      *    iTest = oSort['string-asc']('data11', 'data12');
      *      if (iTest !== 0)
      *        return iTest;
      *    iTest = oSort['numeric-desc']('data21', 'data22');
      *    if (iTest !== 0)
      *      return iTest;
      *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
      *  }
      * Basically we have a test for each sorting column, if the data in that column is equal,
      * test the next column. If all columns match, then we use a numeric sort on the row
      * positions in the original data array to provide a stable sort.
      *
      * Note - I know it seems excessive to have two sorting methods, but the first is around
      * 15% faster, so the second is only maintained for backwards compatibility with sorting
      * methods which do not have a pre-sort formatting function.
      */
					if (formatters === aSort.length) {
						// All sort types have formatting functions
						displayMaster.sort(function (a, b) {
							var x,
							    y,
							    k,
							    test,
							    sort,
							    len = aSort.length,
							    dataA = aoData[a]._aSortData,
							    dataB = aoData[b]._aSortData;

							for (k = 0; k < len; k++) {
								sort = aSort[k];

								x = dataA[sort.col];
								y = dataB[sort.col];

								test = x < y ? -1 : x > y ? 1 : 0;
								if (test !== 0) {
									return sort.dir === 'asc' ? test : -test;
								}
							}

							x = aiOrig[a];
							y = aiOrig[b];
							return x < y ? -1 : x > y ? 1 : 0;
						});
					} else {
						// Depreciated - remove in 1.11 (providing a plug-in option)
						// Not all sort types have formatting methods, so we have to call their sorting
						// methods.
						displayMaster.sort(function (a, b) {
							var x,
							    y,
							    k,
							    l,
							    test,
							    sort,
							    fn,
							    len = aSort.length,
							    dataA = aoData[a]._aSortData,
							    dataB = aoData[b]._aSortData;

							for (k = 0; k < len; k++) {
								sort = aSort[k];

								x = dataA[sort.col];
								y = dataB[sort.col];

								fn = oExtSort[sort.type + "-" + sort.dir] || oExtSort["string-" + sort.dir];
								test = fn(x, y);
								if (test !== 0) {
									return test;
								}
							}

							x = aiOrig[a];
							y = aiOrig[b];
							return x < y ? -1 : x > y ? 1 : 0;
						});
					}
				}

				/* Tell the draw function that we have sorted the data */
				oSettings.bSorted = true;
			}

			function _fnSortAria(settings) {
				var label;
				var nextSort;
				var columns = settings.aoColumns;
				var aSort = _fnSortFlatten(settings);
				var oAria = settings.oLanguage.oAria;

				// ARIA attributes - need to loop all columns, to update all (removing old
				// attributes as needed)
				for (var i = 0, iLen = columns.length; i < iLen; i++) {
					var col = columns[i];
					var asSorting = col.asSorting;
					var sTitle = col.sTitle.replace(/<.*?>/g, "");
					var th = col.nTh;

					// IE7 is throwing an error when setting these properties with jQuery's
					// attr() and removeAttr() methods...
					th.removeAttribute('aria-sort');

					/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
					if (col.bSortable) {
						if (aSort.length > 0 && aSort[0].col == i) {
							th.setAttribute('aria-sort', aSort[0].dir == "asc" ? "ascending" : "descending");
							nextSort = asSorting[aSort[0].index + 1] || asSorting[0];
						} else {
							nextSort = asSorting[0];
						}

						label = sTitle + (nextSort === "asc" ? oAria.sSortAscending : oAria.sSortDescending);
					} else {
						label = sTitle;
					}

					th.setAttribute('aria-label', label);
				}
			}

			/**
    * Function to run on user sort request
    *  @param {object} settings dataTables settings object
    *  @param {node} attachTo node to attach the handler to
    *  @param {int} colIdx column sorting index
    *  @param {boolean} [append=false] Append the requested sort to the existing
    *    sort if true (i.e. multi-column sort)
    *  @param {function} [callback] callback function
    *  @memberof DataTable#oApi
    */
			function _fnSortListener(settings, colIdx, append, callback) {
				var col = settings.aoColumns[colIdx];
				var sorting = settings.aaSorting;
				var asSorting = col.asSorting;
				var nextSortIdx;
				var next = function (a, overflow) {
					var idx = a._idx;
					if (idx === undefined) {
						idx = $.inArray(a[1], asSorting);
					}

					return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
				};

				// Convert to 2D array if needed
				if (typeof sorting[0] === 'number') {
					sorting = settings.aaSorting = [sorting];
				}

				// If appending the sort then we are multi-column sorting
				if (append && settings.oFeatures.bSortMulti) {
					// Are we already doing some kind of sort on this column?
					var sortIdx = $.inArray(colIdx, _pluck(sorting, '0'));

					if (sortIdx !== -1) {
						// Yes, modify the sort
						nextSortIdx = next(sorting[sortIdx], true);

						if (nextSortIdx === null && sorting.length === 1) {
							nextSortIdx = 0; // can't remove sorting completely
						}

						if (nextSortIdx === null) {
							sorting.splice(sortIdx, 1);
						} else {
							sorting[sortIdx][1] = asSorting[nextSortIdx];
							sorting[sortIdx]._idx = nextSortIdx;
						}
					} else {
						// No sort on this column yet
						sorting.push([colIdx, asSorting[0], 0]);
						sorting[sorting.length - 1]._idx = 0;
					}
				} else if (sorting.length && sorting[0][0] == colIdx) {
					// Single column - already sorting on this column, modify the sort
					nextSortIdx = next(sorting[0]);

					sorting.length = 1;
					sorting[0][1] = asSorting[nextSortIdx];
					sorting[0]._idx = nextSortIdx;
				} else {
					// Single column - sort only on this column
					sorting.length = 0;
					sorting.push([colIdx, asSorting[0]]);
					sorting[0]._idx = 0;
				}

				// Run the sort by calling a full redraw
				_fnReDraw(settings);

				// callback used for async user interaction
				if (typeof callback == 'function') {
					callback(settings);
				}
			}

			/**
    * Attach a sort handler (click) to a node
    *  @param {object} settings dataTables settings object
    *  @param {node} attachTo node to attach the handler to
    *  @param {int} colIdx column sorting index
    *  @param {function} [callback] callback function
    *  @memberof DataTable#oApi
    */
			function _fnSortAttachListener(settings, attachTo, colIdx, callback) {
				var col = settings.aoColumns[colIdx];

				_fnBindAction(attachTo, {}, function (e) {
					/* If the column is not sortable - don't to anything */
					if (col.bSortable === false) {
						return;
					}

					// If processing is enabled use a timeout to allow the processing
					// display to be shown - otherwise to it synchronously
					if (settings.oFeatures.bProcessing) {
						_fnProcessingDisplay(settings, true);

						setTimeout(function () {
							_fnSortListener(settings, colIdx, e.shiftKey, callback);

							// In server-side processing, the draw callback will remove the
							// processing display
							if (_fnDataSource(settings) !== 'ssp') {
								_fnProcessingDisplay(settings, false);
							}
						}, 0);
					} else {
						_fnSortListener(settings, colIdx, e.shiftKey, callback);
					}
				});
			}

			/**
    * Set the sorting classes on table's body, Note: it is safe to call this function
    * when bSort and bSortClasses are false
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnSortingClasses(settings) {
				var oldSort = settings.aLastSort;
				var sortClass = settings.oClasses.sSortColumn;
				var sort = _fnSortFlatten(settings);
				var features = settings.oFeatures;
				var i, ien, colIdx;

				if (features.bSort && features.bSortClasses) {
					// Remove old sorting classes
					for (i = 0, ien = oldSort.length; i < ien; i++) {
						colIdx = oldSort[i].src;

						// Remove column sorting
						$(_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
					}

					// Add new column sorting
					for (i = 0, ien = sort.length; i < ien; i++) {
						colIdx = sort[i].src;

						$(_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
					}
				}

				settings.aLastSort = sort;
			}

			// Get the data to sort a column, be it from cache, fresh (populating the
			// cache), or from a sort formatter
			function _fnSortData(settings, idx) {
				// Custom sorting function - provided by the sort data type
				var column = settings.aoColumns[idx];
				var customSort = DataTable.ext.order[column.sSortDataType];
				var customData;

				if (customSort) {
					customData = customSort.call(settings.oInstance, settings, idx, _fnColumnIndexToVisible(settings, idx));
				}

				// Use / populate cache
				var row, cellData;
				var formatter = DataTable.ext.type.order[column.sType + "-pre"];

				for (var i = 0, ien = settings.aoData.length; i < ien; i++) {
					row = settings.aoData[i];

					if (!row._aSortData) {
						row._aSortData = [];
					}

					if (!row._aSortData[idx] || customSort) {
						cellData = customSort ? customData[i] : // If there was a custom sort function, use data from there
						_fnGetCellData(settings, i, idx, 'sort');

						row._aSortData[idx] = formatter ? formatter(cellData) : cellData;
					}
				}
			}

			/**
    * Save the state of a table
    *  @param {object} oSettings dataTables settings object
    *  @memberof DataTable#oApi
    */
			function _fnSaveState(settings) {
				if (!settings.oFeatures.bStateSave || settings.bDestroying) {
					return;
				}

				/* Store the interesting variables */
				var state = {
					time: +new Date(),
					start: settings._iDisplayStart,
					length: settings._iDisplayLength,
					order: $.extend(true, [], settings.aaSorting),
					search: _fnSearchToCamel(settings.oPreviousSearch),
					columns: $.map(settings.aoColumns, function (col, i) {
						return {
							visible: col.bVisible,
							search: _fnSearchToCamel(settings.aoPreSearchCols[i])
						};
					})
				};

				_fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [settings, state]);

				settings.oSavedState = state;
				settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
			}

			/**
    * Attempt to load a saved table state
    *  @param {object} oSettings dataTables settings object
    *  @param {object} oInit DataTables init object so we can override settings
    *  @param {function} callback Callback to execute when the state has been loaded
    *  @memberof DataTable#oApi
    */
			function _fnLoadState(settings, oInit, callback) {
				var i, ien;
				var columns = settings.aoColumns;
				var loaded = function (s) {
					if (!s || !s.time) {
						callback();
						return;
					}

					// Allow custom and plug-in manipulation functions to alter the saved data set and
					// cancelling of loading by returning false
					var abStateLoad = _fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s]);
					if ($.inArray(false, abStateLoad) !== -1) {
						callback();
						return;
					}

					// Reject old data
					var duration = settings.iStateDuration;
					if (duration > 0 && s.time < +new Date() - duration * 1000) {
						callback();
						return;
					}

					// Number of columns have changed - all bets are off, no restore of settings
					if (s.columns && columns.length !== s.columns.length) {
						callback();
						return;
					}

					// Store the saved state so it might be accessed at any time
					settings.oLoadedState = $.extend(true, {}, s);

					// Restore key features - todo - for 1.11 this needs to be done by
					// subscribed events
					if (s.start !== undefined) {
						settings._iDisplayStart = s.start;
						settings.iInitDisplayStart = s.start;
					}
					if (s.length !== undefined) {
						settings._iDisplayLength = s.length;
					}

					// Order
					if (s.order !== undefined) {
						settings.aaSorting = [];
						$.each(s.order, function (i, col) {
							settings.aaSorting.push(col[0] >= columns.length ? [0, col[1]] : col);
						});
					}

					// Search
					if (s.search !== undefined) {
						$.extend(settings.oPreviousSearch, _fnSearchToHung(s.search));
					}

					// Columns
					//
					if (s.columns) {
						for (i = 0, ien = s.columns.length; i < ien; i++) {
							var col = s.columns[i];

							// Visibility
							if (col.visible !== undefined) {
								columns[i].bVisible = col.visible;
							}

							// Search
							if (col.search !== undefined) {
								$.extend(settings.aoPreSearchCols[i], _fnSearchToHung(col.search));
							}
						}
					}

					_fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [settings, s]);
					callback();
				};

				if (!settings.oFeatures.bStateSave) {
					callback();
					return;
				}

				var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);

				if (state !== undefined) {
					loaded(state);
				}
				// otherwise, wait for the loaded callback to be executed
			}

			/**
    * Return the settings object for a particular table
    *  @param {node} table table we are using as a dataTable
    *  @returns {object} Settings object - or null if not found
    *  @memberof DataTable#oApi
    */
			function _fnSettingsFromNode(table) {
				var settings = DataTable.settings;
				var idx = $.inArray(table, _pluck(settings, 'nTable'));

				return idx !== -1 ? settings[idx] : null;
			}

			/**
    * Log an error message
    *  @param {object} settings dataTables settings object
    *  @param {int} level log error messages, or display them to the user
    *  @param {string} msg error message
    *  @param {int} tn Technical note id to get more information about the error.
    *  @memberof DataTable#oApi
    */
			function _fnLog(settings, level, msg, tn) {
				msg = 'DataTables warning: ' + (settings ? 'table id=' + settings.sTableId + ' - ' : '') + msg;

				if (tn) {
					msg += '. For more information about this error, please see ' + 'http://datatables.net/tn/' + tn;
				}

				if (!level) {
					// Backwards compatibility pre 1.10
					var ext = DataTable.ext;
					var type = ext.sErrMode || ext.errMode;

					if (settings) {
						_fnCallbackFire(settings, null, 'error', [settings, tn, msg]);
					}

					if (type == 'alert') {
						alert(msg);
					} else if (type == 'throw') {
						throw new Error(msg);
					} else if (typeof type == 'function') {
						type(settings, tn, msg);
					}
				} else if (window.console && console.log) {
					console.log(msg);
				}
			}

			/**
    * See if a property is defined on one object, if so assign it to the other object
    *  @param {object} ret target object
    *  @param {object} src source object
    *  @param {string} name property
    *  @param {string} [mappedName] name to map too - optional, name used if not given
    *  @memberof DataTable#oApi
    */
			function _fnMap(ret, src, name, mappedName) {
				if ($.isArray(name)) {
					$.each(name, function (i, val) {
						if ($.isArray(val)) {
							_fnMap(ret, src, val[0], val[1]);
						} else {
							_fnMap(ret, src, val);
						}
					});

					return;
				}

				if (mappedName === undefined) {
					mappedName = name;
				}

				if (src[name] !== undefined) {
					ret[mappedName] = src[name];
				}
			}

			/**
    * Extend objects - very similar to jQuery.extend, but deep copy objects, and
    * shallow copy arrays. The reason we need to do this, is that we don't want to
    * deep copy array init values (such as aaSorting) since the dev wouldn't be
    * able to override them, but we do want to deep copy arrays.
    *  @param {object} out Object to extend
    *  @param {object} extender Object from which the properties will be applied to
    *      out
    *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
    *      independent copy with the exception of the `data` or `aaData` parameters
    *      if they are present. This is so you can pass in a collection to
    *      DataTables and have that used as your data source without breaking the
    *      references
    *  @returns {object} out Reference, just for convenience - out === the return.
    *  @memberof DataTable#oApi
    *  @todo This doesn't take account of arrays inside the deep copied objects.
    */
			function _fnExtend(out, extender, breakRefs) {
				var val;

				for (var prop in extender) {
					if (extender.hasOwnProperty(prop)) {
						val = extender[prop];

						if ($.isPlainObject(val)) {
							if (!$.isPlainObject(out[prop])) {
								out[prop] = {};
							}
							$.extend(true, out[prop], val);
						} else if (breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val)) {
							out[prop] = val.slice();
						} else {
							out[prop] = val;
						}
					}
				}

				return out;
			}

			/**
    * Bind an event handers to allow a click or return key to activate the callback.
    * This is good for accessibility since a return on the keyboard will have the
    * same effect as a click, if the element has focus.
    *  @param {element} n Element to bind the action to
    *  @param {object} oData Data object to pass to the triggered function
    *  @param {function} fn Callback function for when the event is triggered
    *  @memberof DataTable#oApi
    */
			function _fnBindAction(n, oData, fn) {
				$(n).on('click.DT', oData, function (e) {
					$(n).blur(); // Remove focus outline for mouse users
					fn(e);
				}).on('keypress.DT', oData, function (e) {
					if (e.which === 13) {
						e.preventDefault();
						fn(e);
					}
				}).on('selectstart.DT', function () {
					/* Take the brutal approach to cancelling text selection */
					return false;
				});
			}

			/**
    * Register a callback function. Easily allows a callback function to be added to
    * an array store of callback functions that can then all be called together.
    *  @param {object} oSettings dataTables settings object
    *  @param {string} sStore Name of the array storage for the callbacks in oSettings
    *  @param {function} fn Function to be called back
    *  @param {string} sName Identifying name for the callback (i.e. a label)
    *  @memberof DataTable#oApi
    */
			function _fnCallbackReg(oSettings, sStore, fn, sName) {
				if (fn) {
					oSettings[sStore].push({
						"fn": fn,
						"sName": sName
					});
				}
			}

			/**
    * Fire callback functions and trigger events. Note that the loop over the
    * callback array store is done backwards! Further note that you do not want to
    * fire off triggers in time sensitive applications (for example cell creation)
    * as its slow.
    *  @param {object} settings dataTables settings object
    *  @param {string} callbackArr Name of the array storage for the callbacks in
    *      oSettings
    *  @param {string} eventName Name of the jQuery custom event to trigger. If
    *      null no trigger is fired
    *  @param {array} args Array of arguments to pass to the callback function /
    *      trigger
    *  @memberof DataTable#oApi
    */
			function _fnCallbackFire(settings, callbackArr, eventName, args) {
				var ret = [];

				if (callbackArr) {
					ret = $.map(settings[callbackArr].slice().reverse(), function (val, i) {
						return val.fn.apply(settings.oInstance, args);
					});
				}

				if (eventName !== null) {
					var e = $.Event(eventName + '.dt');

					$(settings.nTable).trigger(e, args);

					ret.push(e.result);
				}

				return ret;
			}

			function _fnLengthOverflow(settings) {
				var start = settings._iDisplayStart,
				    end = settings.fnDisplayEnd(),
				    len = settings._iDisplayLength;

				/* If we have space to show extra rows (backing up from the end point - then do so */
				if (start >= end) {
					start = end - len;
				}

				// Keep the start record on the current page
				start -= start % len;

				if (len === -1 || start < 0) {
					start = 0;
				}

				settings._iDisplayStart = start;
			}

			function _fnRenderer(settings, type) {
				var renderer = settings.renderer;
				var host = DataTable.ext.renderer[type];

				if ($.isPlainObject(renderer) && renderer[type]) {
					// Specific renderer for this type. If available use it, otherwise use
					// the default.
					return host[renderer[type]] || host._;
				} else if (typeof renderer === 'string') {
					// Common renderer - if there is one available for this type use it,
					// otherwise use the default
					return host[renderer] || host._;
				}

				// Use the default
				return host._;
			}

			/**
    * Detect the data source being used for the table. Used to simplify the code
    * a little (ajax) and to make it compress a little smaller.
    *
    *  @param {object} settings dataTables settings object
    *  @returns {string} Data source
    *  @memberof DataTable#oApi
    */
			function _fnDataSource(settings) {
				if (settings.oFeatures.bServerSide) {
					return 'ssp';
				} else if (settings.ajax || settings.sAjaxSource) {
					return 'ajax';
				}
				return 'dom';
			}

			/**
    * Computed structure of the DataTables API, defined by the options passed to
    * `DataTable.Api.register()` when building the API.
    *
    * The structure is built in order to speed creation and extension of the Api
    * objects since the extensions are effectively pre-parsed.
    *
    * The array is an array of objects with the following structure, where this
    * base array represents the Api prototype base:
    *
    *     [
    *       {
    *         name:      'data'                -- string   - Property name
    *         val:       function () {},       -- function - Api method (or undefined if just an object
    *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
    *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
    *       },
    *       {
    *         name:     'row'
    *         val:       {},
    *         methodExt: [ ... ],
    *         propExt:   [
    *           {
    *             name:      'data'
    *             val:       function () {},
    *             methodExt: [ ... ],
    *             propExt:   [ ... ]
    *           },
    *           ...
    *         ]
    *       }
    *     ]
    *
    * @type {Array}
    * @ignore
    */
			var __apiStruct = [];

			/**
    * `Array.prototype` reference.
    *
    * @type object
    * @ignore
    */
			var __arrayProto = Array.prototype;

			/**
    * Abstraction for `context` parameter of the `Api` constructor to allow it to
    * take several different forms for ease of use.
    *
    * Each of the input parameter types will be converted to a DataTables settings
    * object where possible.
    *
    * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
    *   of:
    *
    *   * `string` - jQuery selector. Any DataTables' matching the given selector
    *     with be found and used.
    *   * `node` - `TABLE` node which has already been formed into a DataTable.
    *   * `jQuery` - A jQuery object of `TABLE` nodes.
    *   * `object` - DataTables settings object
    *   * `DataTables.Api` - API instance
    * @return {array|null} Matching DataTables settings objects. `null` or
    *   `undefined` is returned if no matching DataTable is found.
    * @ignore
    */
			var _toSettings = function (mixed) {
				var idx, jq;
				var settings = DataTable.settings;
				var tables = $.map(settings, function (el, i) {
					return el.nTable;
				});

				if (!mixed) {
					return [];
				} else if (mixed.nTable && mixed.oApi) {
					// DataTables settings object
					return [mixed];
				} else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
					// Table node
					idx = $.inArray(mixed, tables);
					return idx !== -1 ? [settings[idx]] : null;
				} else if (mixed && typeof mixed.settings === 'function') {
					return mixed.settings().toArray();
				} else if (typeof mixed === 'string') {
					// jQuery selector
					jq = $(mixed);
				} else if (mixed instanceof $) {
					// jQuery object (also DataTables instance)
					jq = mixed;
				}

				if (jq) {
					return jq.map(function (i) {
						idx = $.inArray(this, tables);
						return idx !== -1 ? settings[idx] : null;
					}).toArray();
				}
			};

			/**
    * DataTables API class - used to control and interface with  one or more
    * DataTables enhanced tables.
    *
    * The API class is heavily based on jQuery, presenting a chainable interface
    * that you can use to interact with tables. Each instance of the API class has
    * a "context" - i.e. the tables that it will operate on. This could be a single
    * table, all tables on a page or a sub-set thereof.
    *
    * Additionally the API is designed to allow you to easily work with the data in
    * the tables, retrieving and manipulating it as required. This is done by
    * presenting the API class as an array like interface. The contents of the
    * array depend upon the actions requested by each method (for example
    * `rows().nodes()` will return an array of nodes, while `rows().data()` will
    * return an array of objects or arrays depending upon your table's
    * configuration). The API object has a number of array like methods (`push`,
    * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
    * `unique` etc) to assist your working with the data held in a table.
    *
    * Most methods (those which return an Api instance) are chainable, which means
    * the return from a method call also has all of the methods available that the
    * top level object had. For example, these two calls are equivalent:
    *
    *     // Not chained
    *     api.row.add( {...} );
    *     api.draw();
    *
    *     // Chained
    *     api.row.add( {...} ).draw();
    *
    * @class DataTable.Api
    * @param {array|object|string|jQuery} context DataTable identifier. This is
    *   used to define which DataTables enhanced tables this API will operate on.
    *   Can be one of:
    *
    *   * `string` - jQuery selector. Any DataTables' matching the given selector
    *     with be found and used.
    *   * `node` - `TABLE` node which has already been formed into a DataTable.
    *   * `jQuery` - A jQuery object of `TABLE` nodes.
    *   * `object` - DataTables settings object
    * @param {array} [data] Data to initialise the Api instance with.
    *
    * @example
    *   // Direct initialisation during DataTables construction
    *   var api = $('#example').DataTable();
    *
    * @example
    *   // Initialisation using a DataTables jQuery object
    *   var api = $('#example').dataTable().api();
    *
    * @example
    *   // Initialisation as a constructor
    *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
    */
			_Api = function (context, data) {
				if (!(this instanceof _Api)) {
					return new _Api(context, data);
				}

				var settings = [];
				var ctxSettings = function (o) {
					var a = _toSettings(o);
					if (a) {
						settings = settings.concat(a);
					}
				};

				if ($.isArray(context)) {
					for (var i = 0, ien = context.length; i < ien; i++) {
						ctxSettings(context[i]);
					}
				} else {
					ctxSettings(context);
				}

				// Remove duplicates
				this.context = _unique(settings);

				// Initial data
				if (data) {
					$.merge(this, data);
				}

				// selector
				this.selector = {
					rows: null,
					cols: null,
					opts: null
				};

				_Api.extend(this, this, __apiStruct);
			};

			DataTable.Api = _Api;

			// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
			// isPlainObject.
			$.extend(_Api.prototype, {
				any: function () {
					return this.count() !== 0;
				},

				concat: __arrayProto.concat,

				context: [], // array of table settings objects


				count: function () {
					return this.flatten().length;
				},

				each: function (fn) {
					for (var i = 0, ien = this.length; i < ien; i++) {
						fn.call(this, this[i], i, this);
					}

					return this;
				},

				eq: function (idx) {
					var ctx = this.context;

					return ctx.length > idx ? new _Api(ctx[idx], this[idx]) : null;
				},

				filter: function (fn) {
					var a = [];

					if (__arrayProto.filter) {
						a = __arrayProto.filter.call(this, fn, this);
					} else {
						// Compatibility for browsers without EMCA-252-5 (JS 1.6)
						for (var i = 0, ien = this.length; i < ien; i++) {
							if (fn.call(this, this[i], i, this)) {
								a.push(this[i]);
							}
						}
					}

					return new _Api(this.context, a);
				},

				flatten: function () {
					var a = [];
					return new _Api(this.context, a.concat.apply(a, this.toArray()));
				},

				join: __arrayProto.join,

				indexOf: __arrayProto.indexOf || function (obj, start) {
					for (var i = start || 0, ien = this.length; i < ien; i++) {
						if (this[i] === obj) {
							return i;
						}
					}
					return -1;
				},

				iterator: function (flatten, type, fn, alwaysNew) {
					var a = [],
					    ret,
					    i,
					    ien,
					    j,
					    jen,
					    context = this.context,
					    rows,
					    items,
					    item,
					    selector = this.selector;

					// Argument shifting
					if (typeof flatten === 'string') {
						alwaysNew = fn;
						fn = type;
						type = flatten;
						flatten = false;
					}

					for (i = 0, ien = context.length; i < ien; i++) {
						var apiInst = new _Api(context[i]);

						if (type === 'table') {
							ret = fn.call(apiInst, context[i], i);

							if (ret !== undefined) {
								a.push(ret);
							}
						} else if (type === 'columns' || type === 'rows') {
							// this has same length as context - one entry for each table
							ret = fn.call(apiInst, context[i], this[i], i);

							if (ret !== undefined) {
								a.push(ret);
							}
						} else if (type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
							// columns and rows share the same structure.
							// 'this' is an array of column indexes for each context
							items = this[i];

							if (type === 'column-rows') {
								rows = _selector_row_indexes(context[i], selector.opts);
							}

							for (j = 0, jen = items.length; j < jen; j++) {
								item = items[j];

								if (type === 'cell') {
									ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
								} else {
									ret = fn.call(apiInst, context[i], item, i, j, rows);
								}

								if (ret !== undefined) {
									a.push(ret);
								}
							}
						}
					}

					if (a.length || alwaysNew) {
						var api = new _Api(context, flatten ? a.concat.apply([], a) : a);
						var apiSelector = api.selector;
						apiSelector.rows = selector.rows;
						apiSelector.cols = selector.cols;
						apiSelector.opts = selector.opts;
						return api;
					}
					return this;
				},

				lastIndexOf: __arrayProto.lastIndexOf || function (obj, start) {
					// Bit cheeky...
					return this.indexOf.apply(this.toArray.reverse(), arguments);
				},

				length: 0,

				map: function (fn) {
					var a = [];

					if (__arrayProto.map) {
						a = __arrayProto.map.call(this, fn, this);
					} else {
						// Compatibility for browsers without EMCA-252-5 (JS 1.6)
						for (var i = 0, ien = this.length; i < ien; i++) {
							a.push(fn.call(this, this[i], i));
						}
					}

					return new _Api(this.context, a);
				},

				pluck: function (prop) {
					return this.map(function (el) {
						return el[prop];
					});
				},

				pop: __arrayProto.pop,

				push: __arrayProto.push,

				// Does not return an API instance
				reduce: __arrayProto.reduce || function (fn, init) {
					return _fnReduce(this, fn, init, 0, this.length, 1);
				},

				reduceRight: __arrayProto.reduceRight || function (fn, init) {
					return _fnReduce(this, fn, init, this.length - 1, -1, -1);
				},

				reverse: __arrayProto.reverse,

				// Object with rows, columns and opts
				selector: null,

				shift: __arrayProto.shift,

				slice: function () {
					return new _Api(this.context, this);
				},

				sort: __arrayProto.sort, // ? name - order?


				splice: __arrayProto.splice,

				toArray: function () {
					return __arrayProto.slice.call(this);
				},

				to$: function () {
					return $(this);
				},

				toJQuery: function () {
					return $(this);
				},

				unique: function () {
					return new _Api(this.context, _unique(this));
				},

				unshift: __arrayProto.unshift
			});

			_Api.extend = function (scope, obj, ext) {
				// Only extend API instances and static properties of the API
				if (!ext.length || !obj || !(obj instanceof _Api) && !obj.__dt_wrapper) {
					return;
				}

				var i,
				    ien,
				    j,
				    jen,
				    struct,
				    inner,
				    methodScoping = function (scope, fn, struc) {
					return function () {
						var ret = fn.apply(scope, arguments);

						// Method extension
						_Api.extend(ret, ret, struc.methodExt);
						return ret;
					};
				};

				for (i = 0, ien = ext.length; i < ien; i++) {
					struct = ext[i];

					// Value
					obj[struct.name] = typeof struct.val === 'function' ? methodScoping(scope, struct.val, struct) : $.isPlainObject(struct.val) ? {} : struct.val;

					obj[struct.name].__dt_wrapper = true;

					// Property extension
					_Api.extend(scope, obj[struct.name], struct.propExt);
				}
			};

			// @todo - Is there need for an augment function?
			// _Api.augment = function ( inst, name )
			// {
			// 	// Find src object in the structure from the name
			// 	var parts = name.split('.');

			// 	_Api.extend( inst, obj );
			// };


			//     [
			//       {
			//         name:      'data'                -- string   - Property name
			//         val:       function () {},       -- function - Api method (or undefined if just an object
			//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
			//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
			//       },
			//       {
			//         name:     'row'
			//         val:       {},
			//         methodExt: [ ... ],
			//         propExt:   [
			//           {
			//             name:      'data'
			//             val:       function () {},
			//             methodExt: [ ... ],
			//             propExt:   [ ... ]
			//           },
			//           ...
			//         ]
			//       }
			//     ]

			_Api.register = _api_register = function (name, val) {
				if ($.isArray(name)) {
					for (var j = 0, jen = name.length; j < jen; j++) {
						_Api.register(name[j], val);
					}
					return;
				}

				var i,
				    ien,
				    heir = name.split('.'),
				    struct = __apiStruct,
				    key,
				    method;

				var find = function (src, name) {
					for (var i = 0, ien = src.length; i < ien; i++) {
						if (src[i].name === name) {
							return src[i];
						}
					}
					return null;
				};

				for (i = 0, ien = heir.length; i < ien; i++) {
					method = heir[i].indexOf('()') !== -1;
					key = method ? heir[i].replace('()', '') : heir[i];

					var src = find(struct, key);
					if (!src) {
						src = {
							name: key,
							val: {},
							methodExt: [],
							propExt: []
						};
						struct.push(src);
					}

					if (i === ien - 1) {
						src.val = val;
					} else {
						struct = method ? src.methodExt : src.propExt;
					}
				}
			};

			_Api.registerPlural = _api_registerPlural = function (pluralName, singularName, val) {
				_Api.register(pluralName, val);

				_Api.register(singularName, function () {
					var ret = val.apply(this, arguments);

					if (ret === this) {
						// Returned item is the API instance that was passed in, return it
						return this;
					} else if (ret instanceof _Api) {
						// New API instance returned, want the value from the first item
						// in the returned array for the singular result.
						return ret.length ? $.isArray(ret[0]) ? new _Api(ret.context, ret[0]) : // Array results are 'enhanced'
						ret[0] : undefined;
					}

					// Non-API return - just fire it back
					return ret;
				});
			};

			/**
    * Selector for HTML tables. Apply the given selector to the give array of
    * DataTables settings objects.
    *
    * @param {string|integer} [selector] jQuery selector string or integer
    * @param  {array} Array of DataTables settings objects to be filtered
    * @return {array}
    * @ignore
    */
			var __table_selector = function (selector, a) {
				// Integer is used to pick out a table by index
				if (typeof selector === 'number') {
					return [a[selector]];
				}

				// Perform a jQuery selector on the table nodes
				var nodes = $.map(a, function (el, i) {
					return el.nTable;
				});

				return $(nodes).filter(selector).map(function (i) {
					// Need to translate back from the table node to the settings
					var idx = $.inArray(this, nodes);
					return a[idx];
				}).toArray();
			};

			/**
    * Context selector for the API's context (i.e. the tables the API instance
    * refers to.
    *
    * @name    DataTable.Api#tables
    * @param {string|integer} [selector] Selector to pick which tables the iterator
    *   should operate on. If not given, all tables in the current context are
    *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
    *   select multiple tables or as an integer to select a single table.
    * @returns {DataTable.Api} Returns a new API instance if a selector is given.
    */
			_api_register('tables()', function (selector) {
				// A new instance is created if there was a selector specified
				return selector ? new _Api(__table_selector(selector, this.context)) : this;
			});

			_api_register('table()', function (selector) {
				var tables = this.tables(selector);
				var ctx = tables.context;

				// Truncate to the first matched table
				return ctx.length ? new _Api(ctx[0]) : tables;
			});

			_api_registerPlural('tables().nodes()', 'table().node()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTable;
				}, 1);
			});

			_api_registerPlural('tables().body()', 'table().body()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTBody;
				}, 1);
			});

			_api_registerPlural('tables().header()', 'table().header()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTHead;
				}, 1);
			});

			_api_registerPlural('tables().footer()', 'table().footer()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTFoot;
				}, 1);
			});

			_api_registerPlural('tables().containers()', 'table().container()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTableWrapper;
				}, 1);
			});

			/**
    * Redraw the tables in the current context.
    */
			_api_register('draw()', function (paging) {
				return this.iterator('table', function (settings) {
					if (paging === 'page') {
						_fnDraw(settings);
					} else {
						if (typeof paging === 'string') {
							paging = paging === 'full-hold' ? false : true;
						}

						_fnReDraw(settings, paging === false);
					}
				});
			});

			/**
    * Get the current page index.
    *
    * @return {integer} Current page index (zero based)
    */ /**
       * Set the current page.
       *
       * Note that if you attempt to show a page which does not exist, DataTables will
       * not throw an error, but rather reset the paging.
       *
       * @param {integer|string} action The paging action to take. This can be one of:
       *  * `integer` - The page index to jump to
       *  * `string` - An action to take:
       *    * `first` - Jump to first page.
       *    * `next` - Jump to the next page
       *    * `previous` - Jump to previous page
       *    * `last` - Jump to the last page.
       * @returns {DataTables.Api} this
       */
			_api_register('page()', function (action) {
				if (action === undefined) {
					return this.page.info().page; // not an expensive call
				}

				// else, have an action to take on all tables
				return this.iterator('table', function (settings) {
					_fnPageChange(settings, action);
				});
			});

			/**
    * Paging information for the first table in the current context.
    *
    * If you require paging information for another table, use the `table()` method
    * with a suitable selector.
    *
    * @return {object} Object with the following properties set:
    *  * `page` - Current page index (zero based - i.e. the first page is `0`)
    *  * `pages` - Total number of pages
    *  * `start` - Display index for the first record shown on the current page
    *  * `end` - Display index for the last record shown on the current page
    *  * `length` - Display length (number of records). Note that generally `start
    *    + length = end`, but this is not always true, for example if there are
    *    only 2 records to show on the final page, with a length of 10.
    *  * `recordsTotal` - Full data set length
    *  * `recordsDisplay` - Data set length once the current filtering criterion
    *    are applied.
    */
			_api_register('page.info()', function (action) {
				if (this.context.length === 0) {
					return undefined;
				}

				var settings = this.context[0],
				    start = settings._iDisplayStart,
				    len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
				    visRecords = settings.fnRecordsDisplay(),
				    all = len === -1;

				return {
					"page": all ? 0 : Math.floor(start / len),
					"pages": all ? 1 : Math.ceil(visRecords / len),
					"start": start,
					"end": settings.fnDisplayEnd(),
					"length": len,
					"recordsTotal": settings.fnRecordsTotal(),
					"recordsDisplay": visRecords,
					"serverSide": _fnDataSource(settings) === 'ssp'
				};
			});

			/**
    * Get the current page length.
    *
    * @return {integer} Current page length. Note `-1` indicates that all records
    *   are to be shown.
    */ /**
       * Set the current page length.
       *
       * @param {integer} Page length to set. Use `-1` to show all records.
       * @returns {DataTables.Api} this
       */
			_api_register('page.len()', function (len) {
				// Note that we can't call this function 'length()' because `length`
				// is a Javascript property of functions which defines how many arguments
				// the function expects.
				if (len === undefined) {
					return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
				}

				// else, set the page length
				return this.iterator('table', function (settings) {
					_fnLengthChange(settings, len);
				});
			});

			var __reload = function (settings, holdPosition, callback) {
				// Use the draw event to trigger a callback
				if (callback) {
					var api = new _Api(settings);

					api.one('draw', function () {
						callback(api.ajax.json());
					});
				}

				if (_fnDataSource(settings) == 'ssp') {
					_fnReDraw(settings, holdPosition);
				} else {
					_fnProcessingDisplay(settings, true);

					// Cancel an existing request
					var xhr = settings.jqXHR;
					if (xhr && xhr.readyState !== 4) {
						xhr.abort();
					}

					// Trigger xhr
					_fnBuildAjax(settings, [], function (json) {
						_fnClearTable(settings);

						var data = _fnAjaxDataSrc(settings, json);
						for (var i = 0, ien = data.length; i < ien; i++) {
							_fnAddData(settings, data[i]);
						}

						_fnReDraw(settings, holdPosition);
						_fnProcessingDisplay(settings, false);
					});
				}
			};

			/**
    * Get the JSON response from the last Ajax request that DataTables made to the
    * server. Note that this returns the JSON from the first table in the current
    * context.
    *
    * @return {object} JSON received from the server.
    */
			_api_register('ajax.json()', function () {
				var ctx = this.context;

				if (ctx.length > 0) {
					return ctx[0].json;
				}

				// else return undefined;
			});

			/**
    * Get the data submitted in the last Ajax request
    */
			_api_register('ajax.params()', function () {
				var ctx = this.context;

				if (ctx.length > 0) {
					return ctx[0].oAjaxData;
				}

				// else return undefined;
			});

			/**
    * Reload tables from the Ajax data source. Note that this function will
    * automatically re-draw the table when the remote data has been loaded.
    *
    * @param {boolean} [reset=true] Reset (default) or hold the current paging
    *   position. A full re-sort and re-filter is performed when this method is
    *   called, which is why the pagination reset is the default action.
    * @returns {DataTables.Api} this
    */
			_api_register('ajax.reload()', function (callback, resetPaging) {
				return this.iterator('table', function (settings) {
					__reload(settings, resetPaging === false, callback);
				});
			});

			/**
    * Get the current Ajax URL. Note that this returns the URL from the first
    * table in the current context.
    *
    * @return {string} Current Ajax source URL
    */ /**
       * Set the Ajax URL. Note that this will set the URL for all tables in the
       * current context.
       *
       * @param {string} url URL to set.
       * @returns {DataTables.Api} this
       */
			_api_register('ajax.url()', function (url) {
				var ctx = this.context;

				if (url === undefined) {
					// get
					if (ctx.length === 0) {
						return undefined;
					}
					ctx = ctx[0];

					return ctx.ajax ? $.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax : ctx.sAjaxSource;
				}

				// set
				return this.iterator('table', function (settings) {
					if ($.isPlainObject(settings.ajax)) {
						settings.ajax.url = url;
					} else {
						settings.ajax = url;
					}
					// No need to consider sAjaxSource here since DataTables gives priority
					// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
					// value of `sAjaxSource` redundant.
				});
			});

			/**
    * Load data from the newly set Ajax URL. Note that this method is only
    * available when `ajax.url()` is used to set a URL. Additionally, this method
    * has the same effect as calling `ajax.reload()` but is provided for
    * convenience when setting a new URL. Like `ajax.reload()` it will
    * automatically redraw the table once the remote data has been loaded.
    *
    * @returns {DataTables.Api} this
    */
			_api_register('ajax.url().load()', function (callback, resetPaging) {
				// Same as a reload, but makes sense to present it for easy access after a
				// url change
				return this.iterator('table', function (ctx) {
					__reload(ctx, resetPaging === false, callback);
				});
			});

			var _selector_run = function (type, selector, selectFn, settings, opts) {
				var out = [],
				    res,
				    a,
				    i,
				    ien,
				    j,
				    jen,
				    selectorType = typeof selector;

				// Can't just check for isArray here, as an API or jQuery instance might be
				// given with their array like look
				if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) {
					selector = [selector];
				}

				for (i = 0, ien = selector.length; i < ien; i++) {
					// Only split on simple strings - complex expressions will be jQuery selectors
					a = selector[i] && selector[i].split && !selector[i].match(/[\[\(:]/) ? selector[i].split(',') : [selector[i]];

					for (j = 0, jen = a.length; j < jen; j++) {
						res = selectFn(typeof a[j] === 'string' ? $.trim(a[j]) : a[j]);

						if (res && res.length) {
							out = out.concat(res);
						}
					}
				}

				// selector extensions
				var ext = _ext.selector[type];
				if (ext.length) {
					for (i = 0, ien = ext.length; i < ien; i++) {
						out = ext[i](settings, opts, out);
					}
				}

				return _unique(out);
			};

			var _selector_opts = function (opts) {
				if (!opts) {
					opts = {};
				}

				// Backwards compatibility for 1.9- which used the terminology filter rather
				// than search
				if (opts.filter && opts.search === undefined) {
					opts.search = opts.filter;
				}

				return $.extend({
					search: 'none',
					order: 'current',
					page: 'all'
				}, opts);
			};

			var _selector_first = function (inst) {
				// Reduce the API instance to the first item found
				for (var i = 0, ien = inst.length; i < ien; i++) {
					if (inst[i].length > 0) {
						// Assign the first element to the first item in the instance
						// and truncate the instance and context
						inst[0] = inst[i];
						inst[0].length = 1;
						inst.length = 1;
						inst.context = [inst.context[i]];

						return inst;
					}
				}

				// Not found - return an empty instance
				inst.length = 0;
				return inst;
			};

			var _selector_row_indexes = function (settings, opts) {
				var i,
				    ien,
				    tmp,
				    a = [],
				    displayFiltered = settings.aiDisplay,
				    displayMaster = settings.aiDisplayMaster;

				var search = opts.search,
				    // none, applied, removed
				order = opts.order,
				    // applied, current, index (original - compatibility with 1.9)
				page = opts.page; // all, current

				if (_fnDataSource(settings) == 'ssp') {
					// In server-side processing mode, most options are irrelevant since
					// rows not shown don't exist and the index order is the applied order
					// Removed is a special case - for consistency just return an empty
					// array
					return search === 'removed' ? [] : _range(0, displayMaster.length);
				} else if (page == 'current') {
					// Current page implies that order=current and fitler=applied, since it is
					// fairly senseless otherwise, regardless of what order and search actually
					// are
					for (i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++) {
						a.push(displayFiltered[i]);
					}
				} else if (order == 'current' || order == 'applied') {
					if (search == 'none') {
						a = displayMaster.slice();
					} else if (search == 'applied') {
						a = displayFiltered.slice();
					} else if (search == 'removed') {
						// O(n+m) solution by creating a hash map
						var displayFilteredMap = {};

						for (var i = 0, ien = displayFiltered.length; i < ien; i++) {
							displayFilteredMap[displayFiltered[i]] = null;
						}

						a = $.map(displayMaster, function (el) {
							return !displayFilteredMap.hasOwnProperty(el) ? el : null;
						});
					}
				} else if (order == 'index' || order == 'original') {
					for (i = 0, ien = settings.aoData.length; i < ien; i++) {
						if (search == 'none') {
							a.push(i);
						} else {
							// applied | removed
							tmp = $.inArray(i, displayFiltered);

							if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') {
								a.push(i);
							}
						}
					}
				}

				return a;
			};

			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    * Rows
    *
    * {}          - no selector - use all available rows
    * {integer}   - row aoData index
    * {node}      - TR node
    * {string}    - jQuery selector to apply to the TR elements
    * {array}     - jQuery array of nodes, or simply an array of TR nodes
    *
    */
			var __row_selector = function (settings, selector, opts) {
				var rows;
				var run = function (sel) {
					var selInt = _intVal(sel);
					var i, ien;
					var aoData = settings.aoData;

					// Short cut - selector is a number and no options provided (default is
					// all records, so no need to check if the index is in there, since it
					// must be - dev error if the index doesn't exist).
					if (selInt !== null && !opts) {
						return [selInt];
					}

					if (!rows) {
						rows = _selector_row_indexes(settings, opts);
					}

					if (selInt !== null && $.inArray(selInt, rows) !== -1) {
						// Selector - integer
						return [selInt];
					} else if (sel === null || sel === undefined || sel === '') {
						// Selector - none
						return rows;
					}

					// Selector - function
					if (typeof sel === 'function') {
						return $.map(rows, function (idx) {
							var row = aoData[idx];
							return sel(idx, row._aData, row.nTr) ? idx : null;
						});
					}

					// Selector - node
					if (sel.nodeName) {
						var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
						var cellIdx = sel._DT_CellIndex;

						if (rowIdx !== undefined) {
							// Make sure that the row is actually still present in the table
							return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [rowIdx] : [];
						} else if (cellIdx) {
							return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel ? [cellIdx.row] : [];
						} else {
							var host = $(sel).closest('*[data-dt-row]');
							return host.length ? [host.data('dt-row')] : [];
						}
					}

					// ID selector. Want to always be able to select rows by id, regardless
					// of if the tr element has been created or not, so can't rely upon
					// jQuery here - hence a custom implementation. This does not match
					// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
					// but to select it using a CSS selector engine (like Sizzle or
					// querySelect) it would need to need to be escaped for some characters.
					// DataTables simplifies this for row selectors since you can select
					// only a row. A # indicates an id any anything that follows is the id -
					// unescaped.
					if (typeof sel === 'string' && sel.charAt(0) === '#') {
						// get row index from id
						var rowObj = settings.aIds[sel.replace(/^#/, '')];
						if (rowObj !== undefined) {
							return [rowObj.idx];
						}

						// need to fall through to jQuery in case there is DOM id that
						// matches
					}

					// Get nodes in the order from the `rows` array with null values removed
					var nodes = _removeEmpty(_pluck_order(settings.aoData, rows, 'nTr'));

					// Selector - jQuery selector string, array of nodes or jQuery object/
					// As jQuery's .filter() allows jQuery objects to be passed in filter,
					// it also allows arrays, so this will cope with all three options
					return $(nodes).filter(sel).map(function () {
						return this._DT_RowIndex;
					}).toArray();
				};

				return _selector_run('row', selector, run, settings, opts);
			};

			_api_register('rows()', function (selector, opts) {
				// argument shifting
				if (selector === undefined) {
					selector = '';
				} else if ($.isPlainObject(selector)) {
					opts = selector;
					selector = '';
				}

				opts = _selector_opts(opts);

				var inst = this.iterator('table', function (settings) {
					return __row_selector(settings, selector, opts);
				}, 1);

				// Want argument shifting here and in __row_selector?
				inst.selector.rows = selector;
				inst.selector.opts = opts;

				return inst;
			});

			_api_register('rows().nodes()', function () {
				return this.iterator('row', function (settings, row) {
					return settings.aoData[row].nTr || undefined;
				}, 1);
			});

			_api_register('rows().data()', function () {
				return this.iterator(true, 'rows', function (settings, rows) {
					return _pluck_order(settings.aoData, rows, '_aData');
				}, 1);
			});

			_api_registerPlural('rows().cache()', 'row().cache()', function (type) {
				return this.iterator('row', function (settings, row) {
					var r = settings.aoData[row];
					return type === 'search' ? r._aFilterData : r._aSortData;
				}, 1);
			});

			_api_registerPlural('rows().invalidate()', 'row().invalidate()', function (src) {
				return this.iterator('row', function (settings, row) {
					_fnInvalidate(settings, row, src);
				});
			});

			_api_registerPlural('rows().indexes()', 'row().index()', function () {
				return this.iterator('row', function (settings, row) {
					return row;
				}, 1);
			});

			_api_registerPlural('rows().ids()', 'row().id()', function (hash) {
				var a = [];
				var context = this.context;

				// `iterator` will drop undefined values, but in this case we want them
				for (var i = 0, ien = context.length; i < ien; i++) {
					for (var j = 0, jen = this[i].length; j < jen; j++) {
						var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
						a.push((hash === true ? '#' : '') + id);
					}
				}

				return new _Api(context, a);
			});

			_api_registerPlural('rows().remove()', 'row().remove()', function () {
				var that = this;

				this.iterator('row', function (settings, row, thatIdx) {
					var data = settings.aoData;
					var rowData = data[row];
					var i, ien, j, jen;
					var loopRow, loopCells;

					data.splice(row, 1);

					// Update the cached indexes
					for (i = 0, ien = data.length; i < ien; i++) {
						loopRow = data[i];
						loopCells = loopRow.anCells;

						// Rows
						if (loopRow.nTr !== null) {
							loopRow.nTr._DT_RowIndex = i;
						}

						// Cells
						if (loopCells !== null) {
							for (j = 0, jen = loopCells.length; j < jen; j++) {
								loopCells[j]._DT_CellIndex.row = i;
							}
						}
					}

					// Delete from the display arrays
					_fnDeleteIndex(settings.aiDisplayMaster, row);
					_fnDeleteIndex(settings.aiDisplay, row);
					_fnDeleteIndex(that[thatIdx], row, false); // maintain local indexes

					// For server-side processing tables - subtract the deleted row from the count
					if (settings._iRecordsDisplay > 0) {
						settings._iRecordsDisplay--;
					}

					// Check for an 'overflow' they case for displaying the table
					_fnLengthOverflow(settings);

					// Remove the row's ID reference if there is one
					var id = settings.rowIdFn(rowData._aData);
					if (id !== undefined) {
						delete settings.aIds[id];
					}
				});

				this.iterator('table', function (settings) {
					for (var i = 0, ien = settings.aoData.length; i < ien; i++) {
						settings.aoData[i].idx = i;
					}
				});

				return this;
			});

			_api_register('rows.add()', function (rows) {
				var newRows = this.iterator('table', function (settings) {
					var row, i, ien;
					var out = [];

					for (i = 0, ien = rows.length; i < ien; i++) {
						row = rows[i];

						if (row.nodeName && row.nodeName.toUpperCase() === 'TR') {
							out.push(_fnAddTr(settings, row)[0]);
						} else {
							out.push(_fnAddData(settings, row));
						}
					}

					return out;
				}, 1);

				// Return an Api.rows() extended instance, so rows().nodes() etc can be used
				var modRows = this.rows(-1);
				modRows.pop();
				$.merge(modRows, newRows);

				return modRows;
			});

			/**
    *
    */
			_api_register('row()', function (selector, opts) {
				return _selector_first(this.rows(selector, opts));
			});

			_api_register('row().data()', function (data) {
				var ctx = this.context;

				if (data === undefined) {
					// Get
					return ctx.length && this.length ? ctx[0].aoData[this[0]]._aData : undefined;
				}

				// Set
				var row = ctx[0].aoData[this[0]];
				row._aData = data;

				// If the DOM has an id, and the data source is an array
				if ($.isArray(data) && row.nTr.id) {
					_fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
				}

				// Automatically invalidate
				_fnInvalidate(ctx[0], this[0], 'data');

				return this;
			});

			_api_register('row().node()', function () {
				var ctx = this.context;

				return ctx.length && this.length ? ctx[0].aoData[this[0]].nTr || null : null;
			});

			_api_register('row.add()', function (row) {
				// Allow a jQuery object to be passed in - only a single row is added from
				// it though - the first element in the set
				if (row instanceof $ && row.length) {
					row = row[0];
				}

				var rows = this.iterator('table', function (settings) {
					if (row.nodeName && row.nodeName.toUpperCase() === 'TR') {
						return _fnAddTr(settings, row)[0];
					}
					return _fnAddData(settings, row);
				});

				// Return an Api.rows() extended instance, with the newly added row selected
				return this.row(rows[0]);
			});

			var __details_add = function (ctx, row, data, klass) {
				// Convert to array of TR elements
				var rows = [];
				var addRow = function (r, k) {
					// Recursion to allow for arrays of jQuery objects
					if ($.isArray(r) || r instanceof $) {
						for (var i = 0, ien = r.length; i < ien; i++) {
							addRow(r[i], k);
						}
						return;
					}

					// If we get a TR element, then just add it directly - up to the dev
					// to add the correct number of columns etc
					if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
						rows.push(r);
					} else {
						// Otherwise create a row with a wrapper
						var created = $('<tr><td/></tr>').addClass(k);
						$('td', created).addClass(k).html(r)[0].colSpan = _fnVisbleColumns(ctx);

						rows.push(created[0]);
					}
				};

				addRow(data, klass);

				if (row._details) {
					row._details.detach();
				}

				row._details = $(rows);

				// If the children were already shown, that state should be retained
				if (row._detailsShow) {
					row._details.insertAfter(row.nTr);
				}
			};

			var __details_remove = function (api, idx) {
				var ctx = api.context;

				if (ctx.length) {
					var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];

					if (row && row._details) {
						row._details.remove();

						row._detailsShow = undefined;
						row._details = undefined;
					}
				}
			};

			var __details_display = function (api, show) {
				var ctx = api.context;

				if (ctx.length && api.length) {
					var row = ctx[0].aoData[api[0]];

					if (row._details) {
						row._detailsShow = show;

						if (show) {
							row._details.insertAfter(row.nTr);
						} else {
							row._details.detach();
						}

						__details_events(ctx[0]);
					}
				}
			};

			var __details_events = function (settings) {
				var api = new _Api(settings);
				var namespace = '.dt.DT_details';
				var drawEvent = 'draw' + namespace;
				var colvisEvent = 'column-visibility' + namespace;
				var destroyEvent = 'destroy' + namespace;
				var data = settings.aoData;

				api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);

				if (_pluck(data, '_details').length > 0) {
					// On each draw, insert the required elements into the document
					api.on(drawEvent, function (e, ctx) {
						if (settings !== ctx) {
							return;
						}

						api.rows({ page: 'current' }).eq(0).each(function (idx) {
							// Internal data grab
							var row = data[idx];

							if (row._detailsShow) {
								row._details.insertAfter(row.nTr);
							}
						});
					});

					// Column visibility change - update the colspan
					api.on(colvisEvent, function (e, ctx, idx, vis) {
						if (settings !== ctx) {
							return;
						}

						// Update the colspan for the details rows (note, only if it already has
						// a colspan)
						var row,
						    visible = _fnVisbleColumns(ctx);

						for (var i = 0, ien = data.length; i < ien; i++) {
							row = data[i];

							if (row._details) {
								row._details.children('td[colspan]').attr('colspan', visible);
							}
						}
					});

					// Table destroyed - nuke any child rows
					api.on(destroyEvent, function (e, ctx) {
						if (settings !== ctx) {
							return;
						}

						for (var i = 0, ien = data.length; i < ien; i++) {
							if (data[i]._details) {
								__details_remove(api, i);
							}
						}
					});
				}
			};

			// Strings for the method names to help minification
			var _emp = '';
			var _child_obj = _emp + 'row().child';
			var _child_mth = _child_obj + '()';

			// data can be:
			//  tr
			//  string
			//  jQuery or array of any of the above
			_api_register(_child_mth, function (data, klass) {
				var ctx = this.context;

				if (data === undefined) {
					// get
					return ctx.length && this.length ? ctx[0].aoData[this[0]]._details : undefined;
				} else if (data === true) {
					// show
					this.child.show();
				} else if (data === false) {
					// remove
					__details_remove(this);
				} else if (ctx.length && this.length) {
					// set
					__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
				}

				return this;
			});

			_api_register([_child_obj + '.show()', _child_mth + '.show()' // only when `child()` was called with parameters (without
			], function (show) {
				// it returns an object and this method is not executed)
				__details_display(this, true);
				return this;
			});

			_api_register([_child_obj + '.hide()', _child_mth + '.hide()' // only when `child()` was called with parameters (without
			], function () {
				// it returns an object and this method is not executed)
				__details_display(this, false);
				return this;
			});

			_api_register([_child_obj + '.remove()', _child_mth + '.remove()' // only when `child()` was called with parameters (without
			], function () {
				// it returns an object and this method is not executed)
				__details_remove(this);
				return this;
			});

			_api_register(_child_obj + '.isShown()', function () {
				var ctx = this.context;

				if (ctx.length && this.length) {
					// _detailsShown as false or undefined will fall through to return false
					return ctx[0].aoData[this[0]]._detailsShow || false;
				}
				return false;
			});

			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    * Columns
    *
    * {integer}           - column index (>=0 count from left, <0 count from right)
    * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
    * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
    * "{string}:name"     - column name
    * "{string}"          - jQuery selector on column header nodes
    *
    */

			// can be an array of these items, comma separated list, or an array of comma
			// separated lists

			var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;

			// r1 and r2 are redundant - but it means that the parameters match for the
			// iterator callback in columns().data()
			var __columnData = function (settings, column, r1, r2, rows) {
				var a = [];
				for (var row = 0, ien = rows.length; row < ien; row++) {
					a.push(_fnGetCellData(settings, rows[row], column));
				}
				return a;
			};

			var __column_selector = function (settings, selector, opts) {
				var columns = settings.aoColumns,
				    names = _pluck(columns, 'sName'),
				    nodes = _pluck(columns, 'nTh');

				var run = function (s) {
					var selInt = _intVal(s);

					// Selector - all
					if (s === '') {
						return _range(columns.length);
					}

					// Selector - index
					if (selInt !== null) {
						return [selInt >= 0 ? selInt : // Count from left
						columns.length + selInt // Count from right (+ because its a negative value)
						];
					}

					// Selector = function
					if (typeof s === 'function') {
						var rows = _selector_row_indexes(settings, opts);

						return $.map(columns, function (col, idx) {
							return s(idx, __columnData(settings, idx, 0, 0, rows), nodes[idx]) ? idx : null;
						});
					}

					// jQuery or string selector
					var match = typeof s === 'string' ? s.match(__re_column_selector) : '';

					if (match) {
						switch (match[2]) {
							case 'visIdx':
							case 'visible':
								var idx = parseInt(match[1], 10);
								// Visible index given, convert to column index
								if (idx < 0) {
									// Counting from the right
									var visColumns = $.map(columns, function (col, i) {
										return col.bVisible ? i : null;
									});
									return [visColumns[visColumns.length + idx]];
								}
								// Counting from the left
								return [_fnVisibleToColumnIndex(settings, idx)];

							case 'name':
								// match by name. `names` is column index complete and in order
								return $.map(names, function (name, i) {
									return name === match[1] ? i : null;
								});

							default:
								return [];
						}
					}

					// Cell in the table body
					if (s.nodeName && s._DT_CellIndex) {
						return [s._DT_CellIndex.column];
					}

					// jQuery selector on the TH elements for the columns
					var jqResult = $(nodes).filter(s).map(function () {
						return $.inArray(this, nodes); // `nodes` is column index complete and in order
					}).toArray();

					if (jqResult.length || !s.nodeName) {
						return jqResult;
					}

					// Otherwise a node which might have a `dt-column` data attribute, or be
					// a child or such an element
					var host = $(s).closest('*[data-dt-column]');
					return host.length ? [host.data('dt-column')] : [];
				};

				return _selector_run('column', selector, run, settings, opts);
			};

			var __setColumnVis = function (settings, column, vis) {
				var cols = settings.aoColumns,
				    col = cols[column],
				    data = settings.aoData,
				    row,
				    cells,
				    i,
				    ien,
				    tr;

				// Get
				if (vis === undefined) {
					return col.bVisible;
				}

				// Set
				// No change
				if (col.bVisible === vis) {
					return;
				}

				if (vis) {
					// Insert column
					// Need to decide if we should use appendChild or insertBefore
					var insertBefore = $.inArray(true, _pluck(cols, 'bVisible'), column + 1);

					for (i = 0, ien = data.length; i < ien; i++) {
						tr = data[i].nTr;
						cells = data[i].anCells;

						if (tr) {
							// insertBefore can act like appendChild if 2nd arg is null
							tr.insertBefore(cells[column], cells[insertBefore] || null);
						}
					}
				} else {
					// Remove column
					$(_pluck(settings.aoData, 'anCells', column)).detach();
				}

				// Common actions
				col.bVisible = vis;
				_fnDrawHead(settings, settings.aoHeader);
				_fnDrawHead(settings, settings.aoFooter);

				// Update colspan for no records display. Child rows and extensions will use their own
				// listeners to do this - only need to update the empty table item here
				if (!settings.aiDisplay.length) {
					$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
				}

				_fnSaveState(settings);
			};

			_api_register('columns()', function (selector, opts) {
				// argument shifting
				if (selector === undefined) {
					selector = '';
				} else if ($.isPlainObject(selector)) {
					opts = selector;
					selector = '';
				}

				opts = _selector_opts(opts);

				var inst = this.iterator('table', function (settings) {
					return __column_selector(settings, selector, opts);
				}, 1);

				// Want argument shifting here and in _row_selector?
				inst.selector.cols = selector;
				inst.selector.opts = opts;

				return inst;
			});

			_api_registerPlural('columns().header()', 'column().header()', function (selector, opts) {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].nTh;
				}, 1);
			});

			_api_registerPlural('columns().footer()', 'column().footer()', function (selector, opts) {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].nTf;
				}, 1);
			});

			_api_registerPlural('columns().data()', 'column().data()', function () {
				return this.iterator('column-rows', __columnData, 1);
			});

			_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function () {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].mData;
				}, 1);
			});

			_api_registerPlural('columns().cache()', 'column().cache()', function (type) {
				return this.iterator('column-rows', function (settings, column, i, j, rows) {
					return _pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
				}, 1);
			});

			_api_registerPlural('columns().nodes()', 'column().nodes()', function () {
				return this.iterator('column-rows', function (settings, column, i, j, rows) {
					return _pluck_order(settings.aoData, rows, 'anCells', column);
				}, 1);
			});

			_api_registerPlural('columns().visible()', 'column().visible()', function (vis, calc) {
				var ret = this.iterator('column', function (settings, column) {
					if (vis === undefined) {
						return settings.aoColumns[column].bVisible;
					} // else
					__setColumnVis(settings, column, vis);
				});

				// Group the column visibility changes
				if (vis !== undefined) {
					// Second loop once the first is done for events
					this.iterator('column', function (settings, column) {
						_fnCallbackFire(settings, null, 'column-visibility', [settings, column, vis, calc]);
					});

					if (calc === undefined || calc) {
						this.columns.adjust();
					}
				}

				return ret;
			});

			_api_registerPlural('columns().indexes()', 'column().index()', function (type) {
				return this.iterator('column', function (settings, column) {
					return type === 'visible' ? _fnColumnIndexToVisible(settings, column) : column;
				}, 1);
			});

			_api_register('columns.adjust()', function () {
				return this.iterator('table', function (settings) {
					_fnAdjustColumnSizing(settings);
				}, 1);
			});

			_api_register('column.index()', function (type, idx) {
				if (this.context.length !== 0) {
					var ctx = this.context[0];

					if (type === 'fromVisible' || type === 'toData') {
						return _fnVisibleToColumnIndex(ctx, idx);
					} else if (type === 'fromData' || type === 'toVisible') {
						return _fnColumnIndexToVisible(ctx, idx);
					}
				}
			});

			_api_register('column()', function (selector, opts) {
				return _selector_first(this.columns(selector, opts));
			});

			var __cell_selector = function (settings, selector, opts) {
				var data = settings.aoData;
				var rows = _selector_row_indexes(settings, opts);
				var cells = _removeEmpty(_pluck_order(data, rows, 'anCells'));
				var allCells = $([].concat.apply([], cells));
				var row;
				var columns = settings.aoColumns.length;
				var a, i, ien, j, o, host;

				var run = function (s) {
					var fnSelector = typeof s === 'function';

					if (s === null || s === undefined || fnSelector) {
						// All cells and function selectors
						a = [];

						for (i = 0, ien = rows.length; i < ien; i++) {
							row = rows[i];

							for (j = 0; j < columns; j++) {
								o = {
									row: row,
									column: j
								};

								if (fnSelector) {
									// Selector - function
									host = data[row];

									if (s(o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) {
										a.push(o);
									}
								} else {
									// Selector - all
									a.push(o);
								}
							}
						}

						return a;
					}

					// Selector - index
					if ($.isPlainObject(s)) {
						// Valid cell index and its in the array of selectable rows
						return s.column !== undefined && s.row !== undefined && $.inArray(s.row, rows) !== -1 ? [s] : [];
					}

					// Selector - jQuery filtered cells
					var jqResult = allCells.filter(s).map(function (i, el) {
						return { // use a new object, in case someone changes the values
							row: el._DT_CellIndex.row,
							column: el._DT_CellIndex.column
						};
					}).toArray();

					if (jqResult.length || !s.nodeName) {
						return jqResult;
					}

					// Otherwise the selector is a node, and there is one last option - the
					// element might be a child of an element which has dt-row and dt-column
					// data attributes
					host = $(s).closest('*[data-dt-row]');
					return host.length ? [{
						row: host.data('dt-row'),
						column: host.data('dt-column')
					}] : [];
				};

				return _selector_run('cell', selector, run, settings, opts);
			};

			_api_register('cells()', function (rowSelector, columnSelector, opts) {
				// Argument shifting
				if ($.isPlainObject(rowSelector)) {
					// Indexes
					if (rowSelector.row === undefined) {
						// Selector options in first parameter
						opts = rowSelector;
						rowSelector = null;
					} else {
						// Cell index objects in first parameter
						opts = columnSelector;
						columnSelector = null;
					}
				}
				if ($.isPlainObject(columnSelector)) {
					opts = columnSelector;
					columnSelector = null;
				}

				// Cell selector
				if (columnSelector === null || columnSelector === undefined) {
					return this.iterator('table', function (settings) {
						return __cell_selector(settings, rowSelector, _selector_opts(opts));
					});
				}

				// Row + column selector
				var columns = this.columns(columnSelector);
				var rows = this.rows(rowSelector);
				var a, i, ien, j, jen;

				this.iterator('table', function (settings, idx) {
					a = [];

					for (i = 0, ien = rows[idx].length; i < ien; i++) {
						for (j = 0, jen = columns[idx].length; j < jen; j++) {
							a.push({
								row: rows[idx][i],
								column: columns[idx][j]
							});
						}
					}
				}, 1);

				// Now pass through the cell selector for options
				var cells = this.cells(a, opts);

				$.extend(cells.selector, {
					cols: columnSelector,
					rows: rowSelector,
					opts: opts
				});

				return cells;
			});

			_api_registerPlural('cells().nodes()', 'cell().node()', function () {
				return this.iterator('cell', function (settings, row, column) {
					var data = settings.aoData[row];

					return data && data.anCells ? data.anCells[column] : undefined;
				}, 1);
			});

			_api_register('cells().data()', function () {
				return this.iterator('cell', function (settings, row, column) {
					return _fnGetCellData(settings, row, column);
				}, 1);
			});

			_api_registerPlural('cells().cache()', 'cell().cache()', function (type) {
				type = type === 'search' ? '_aFilterData' : '_aSortData';

				return this.iterator('cell', function (settings, row, column) {
					return settings.aoData[row][type][column];
				}, 1);
			});

			_api_registerPlural('cells().render()', 'cell().render()', function (type) {
				return this.iterator('cell', function (settings, row, column) {
					return _fnGetCellData(settings, row, column, type);
				}, 1);
			});

			_api_registerPlural('cells().indexes()', 'cell().index()', function () {
				return this.iterator('cell', function (settings, row, column) {
					return {
						row: row,
						column: column,
						columnVisible: _fnColumnIndexToVisible(settings, column)
					};
				}, 1);
			});

			_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function (src) {
				return this.iterator('cell', function (settings, row, column) {
					_fnInvalidate(settings, row, src, column);
				});
			});

			_api_register('cell()', function (rowSelector, columnSelector, opts) {
				return _selector_first(this.cells(rowSelector, columnSelector, opts));
			});

			_api_register('cell().data()', function (data) {
				var ctx = this.context;
				var cell = this[0];

				if (data === undefined) {
					// Get
					return ctx.length && cell.length ? _fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
				}

				// Set
				_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
				_fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);

				return this;
			});

			/**
    * Get current ordering (sorting) that has been applied to the table.
    *
    * @returns {array} 2D array containing the sorting information for the first
    *   table in the current context. Each element in the parent array represents
    *   a column being sorted upon (i.e. multi-sorting with two columns would have
    *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
    *   the column index that the sorting condition applies to, the second is the
    *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
    *   index of the sorting order from the `column.sorting` initialisation array.
    */ /**
       * Set the ordering for the table.
       *
       * @param {integer} order Column index to sort upon.
       * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
       * @returns {DataTables.Api} this
       */ /**
          * Set the ordering for the table.
          *
          * @param {array} order 1D array of sorting information to be applied.
          * @param {array} [...] Optional additional sorting conditions
          * @returns {DataTables.Api} this
          */ /**
             * Set the ordering for the table.
             *
             * @param {array} order 2D array of sorting information to be applied.
             * @returns {DataTables.Api} this
             */
			_api_register('order()', function (order, dir) {
				var ctx = this.context;

				if (order === undefined) {
					// get
					return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
				}

				// set
				if (typeof order === 'number') {
					// Simple column / direction passed in
					order = [[order, dir]];
				} else if (order.length && !$.isArray(order[0])) {
					// Arguments passed in (list of 1D arrays)
					order = Array.prototype.slice.call(arguments);
				}
				// otherwise a 2D array was passed in

				return this.iterator('table', function (settings) {
					settings.aaSorting = order.slice();
				});
			});

			/**
    * Attach a sort listener to an element for a given column
    *
    * @param {node|jQuery|string} node Identifier for the element(s) to attach the
    *   listener to. This can take the form of a single DOM node, a jQuery
    *   collection of nodes or a jQuery selector which will identify the node(s).
    * @param {integer} column the column that a click on this node will sort on
    * @param {function} [callback] callback function when sort is run
    * @returns {DataTables.Api} this
    */
			_api_register('order.listener()', function (node, column, callback) {
				return this.iterator('table', function (settings) {
					_fnSortAttachListener(settings, node, column, callback);
				});
			});

			_api_register('order.fixed()', function (set) {
				if (!set) {
					var ctx = this.context;
					var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;

					return $.isArray(fixed) ? { pre: fixed } : fixed;
				}

				return this.iterator('table', function (settings) {
					settings.aaSortingFixed = $.extend(true, {}, set);
				});
			});

			// Order by the selected column(s)
			_api_register(['columns().order()', 'column().order()'], function (dir) {
				var that = this;

				return this.iterator('table', function (settings, i) {
					var sort = [];

					$.each(that[i], function (j, col) {
						sort.push([col, dir]);
					});

					settings.aaSorting = sort;
				});
			});

			_api_register('search()', function (input, regex, smart, caseInsen) {
				var ctx = this.context;

				if (input === undefined) {
					// get
					return ctx.length !== 0 ? ctx[0].oPreviousSearch.sSearch : undefined;
				}

				// set
				return this.iterator('table', function (settings) {
					if (!settings.oFeatures.bFilter) {
						return;
					}

					_fnFilterComplete(settings, $.extend({}, settings.oPreviousSearch, {
						"sSearch": input + "",
						"bRegex": regex === null ? false : regex,
						"bSmart": smart === null ? true : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					}), 1);
				});
			});

			_api_registerPlural('columns().search()', 'column().search()', function (input, regex, smart, caseInsen) {
				return this.iterator('column', function (settings, column) {
					var preSearch = settings.aoPreSearchCols;

					if (input === undefined) {
						// get
						return preSearch[column].sSearch;
					}

					// set
					if (!settings.oFeatures.bFilter) {
						return;
					}

					$.extend(preSearch[column], {
						"sSearch": input + "",
						"bRegex": regex === null ? false : regex,
						"bSmart": smart === null ? true : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					});

					_fnFilterComplete(settings, settings.oPreviousSearch, 1);
				});
			});

			/*
    * State API methods
    */

			_api_register('state()', function () {
				return this.context.length ? this.context[0].oSavedState : null;
			});

			_api_register('state.clear()', function () {
				return this.iterator('table', function (settings) {
					// Save an empty object
					settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
				});
			});

			_api_register('state.loaded()', function () {
				return this.context.length ? this.context[0].oLoadedState : null;
			});

			_api_register('state.save()', function () {
				return this.iterator('table', function (settings) {
					_fnSaveState(settings);
				});
			});

			/**
    * Provide a common method for plug-ins to check the version of DataTables being
    * used, in order to ensure compatibility.
    *
    *  @param {string} version Version string to check for, in the format "X.Y.Z".
    *    Note that the formats "X" and "X.Y" are also acceptable.
    *  @returns {boolean} true if this version of DataTables is greater or equal to
    *    the required version, or false if this version of DataTales is not
    *    suitable
    *  @static
    *  @dtopt API-Static
    *
    *  @example
    *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
    */
			DataTable.versionCheck = DataTable.fnVersionCheck = function (version) {
				var aThis = DataTable.version.split('.');
				var aThat = version.split('.');
				var iThis, iThat;

				for (var i = 0, iLen = aThat.length; i < iLen; i++) {
					iThis = parseInt(aThis[i], 10) || 0;
					iThat = parseInt(aThat[i], 10) || 0;

					// Parts are the same, keep comparing
					if (iThis === iThat) {
						continue;
					}

					// Parts are different, return immediately
					return iThis > iThat;
				}

				return true;
			};

			/**
    * Check if a `<table>` node is a DataTable table already or not.
    *
    *  @param {node|jquery|string} table Table node, jQuery object or jQuery
    *      selector for the table to test. Note that if more than more than one
    *      table is passed on, only the first will be checked
    *  @returns {boolean} true the table given is a DataTable, or false otherwise
    *  @static
    *  @dtopt API-Static
    *
    *  @example
    *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
    *      $('#example').dataTable();
    *    }
    */
			DataTable.isDataTable = DataTable.fnIsDataTable = function (table) {
				var t = $(table).get(0);
				var is = false;

				if (table instanceof DataTable.Api) {
					return true;
				}

				$.each(DataTable.settings, function (i, o) {
					var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
					var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;

					if (o.nTable === t || head === t || foot === t) {
						is = true;
					}
				});

				return is;
			};

			/**
    * Get all DataTable tables that have been initialised - optionally you can
    * select to get only currently visible tables.
    *
    *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
    *    or visible tables only.
    *  @returns {array} Array of `table` nodes (not DataTable instances) which are
    *    DataTables
    *  @static
    *  @dtopt API-Static
    *
    *  @example
    *    $.each( $.fn.dataTable.tables(true), function () {
    *      $(table).DataTable().columns.adjust();
    *    } );
    */
			DataTable.tables = DataTable.fnTables = function (visible) {
				var api = false;

				if ($.isPlainObject(visible)) {
					api = visible.api;
					visible = visible.visible;
				}

				var a = $.map(DataTable.settings, function (o) {
					if (!visible || visible && $(o.nTable).is(':visible')) {
						return o.nTable;
					}
				});

				return api ? new _Api(a) : a;
			};

			/**
    * Convert from camel case parameters to Hungarian notation. This is made public
    * for the extensions to provide the same ability as DataTables core to accept
    * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
    * parameters.
    *
    *  @param {object} src The model object which holds all parameters that can be
    *    mapped.
    *  @param {object} user The object to convert from camel case to Hungarian.
    *  @param {boolean} force When set to `true`, properties which already have a
    *    Hungarian value in the `user` object will be overwritten. Otherwise they
    *    won't be.
    */
			DataTable.camelToHungarian = _fnCamelToHungarian;

			/**
    *
    */
			_api_register('$()', function (selector, opts) {
				var rows = this.rows(opts).nodes(),
				    // Get all rows
				jqRows = $(rows);

				return $([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
			});

			// jQuery functions to operate on the tables
			$.each(['on', 'one', 'off'], function (i, key) {
				_api_register(key + '()', function () /* event, handler */{
					var args = Array.prototype.slice.call(arguments);

					// Add the `dt` namespace automatically if it isn't already present
					args[0] = $.map(args[0].split(/\s/), function (e) {
						return !e.match(/\.dt\b/) ? e + '.dt' : e;
					}).join(' ');

					var inst = $(this.tables().nodes());
					inst[key].apply(inst, args);
					return this;
				});
			});

			_api_register('clear()', function () {
				return this.iterator('table', function (settings) {
					_fnClearTable(settings);
				});
			});

			_api_register('settings()', function () {
				return new _Api(this.context, this.context);
			});

			_api_register('init()', function () {
				var ctx = this.context;
				return ctx.length ? ctx[0].oInit : null;
			});

			_api_register('data()', function () {
				return this.iterator('table', function (settings) {
					return _pluck(settings.aoData, '_aData');
				}).flatten();
			});

			_api_register('destroy()', function (remove) {
				remove = remove || false;

				return this.iterator('table', function (settings) {
					var orig = settings.nTableWrapper.parentNode;
					var classes = settings.oClasses;
					var table = settings.nTable;
					var tbody = settings.nTBody;
					var thead = settings.nTHead;
					var tfoot = settings.nTFoot;
					var jqTable = $(table);
					var jqTbody = $(tbody);
					var jqWrapper = $(settings.nTableWrapper);
					var rows = $.map(settings.aoData, function (r) {
						return r.nTr;
					});
					var i, ien;

					// Flag to note that the table is currently being destroyed - no action
					// should be taken
					settings.bDestroying = true;

					// Fire off the destroy callbacks for plug-ins etc
					_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [settings]);

					// If not being removed from the document, make all columns visible
					if (!remove) {
						new _Api(settings).columns().visible(true);
					}

					// Blitz all `DT` namespaced events (these are internal events, the
					// lowercase, `dt` events are user subscribed and they are responsible
					// for removing them
					jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
					$(window).off('.DT-' + settings.sInstance);

					// When scrolling we had to break the table up - restore it
					if (table != thead.parentNode) {
						jqTable.children('thead').detach();
						jqTable.append(thead);
					}

					if (tfoot && table != tfoot.parentNode) {
						jqTable.children('tfoot').detach();
						jqTable.append(tfoot);
					}

					settings.aaSorting = [];
					settings.aaSortingFixed = [];
					_fnSortingClasses(settings);

					$(rows).removeClass(settings.asStripeClasses.join(' '));

					$('th, td', thead).removeClass(classes.sSortable + ' ' + classes.sSortableAsc + ' ' + classes.sSortableDesc + ' ' + classes.sSortableNone);

					// Add the TR elements back into the table in their original order
					jqTbody.children().detach();
					jqTbody.append(rows);

					// Remove the DataTables generated nodes, events and classes
					var removedMethod = remove ? 'remove' : 'detach';
					jqTable[removedMethod]();
					jqWrapper[removedMethod]();

					// If we need to reattach the table to the document
					if (!remove && orig) {
						// insertBefore acts like appendChild if !arg[1]
						orig.insertBefore(table, settings.nTableReinsertBefore);

						// Restore the width of the original table - was read from the style property,
						// so we can restore directly to that
						jqTable.css('width', settings.sDestroyWidth).removeClass(classes.sTable);

						// If the were originally stripe classes - then we add them back here.
						// Note this is not fool proof (for example if not all rows had stripe
						// classes - but it's a good effort without getting carried away
						ien = settings.asDestroyStripes.length;

						if (ien) {
							jqTbody.children().each(function (i) {
								$(this).addClass(settings.asDestroyStripes[i % ien]);
							});
						}
					}

					/* Remove the settings object from the settings array */
					var idx = $.inArray(settings, DataTable.settings);
					if (idx !== -1) {
						DataTable.settings.splice(idx, 1);
					}
				});
			});

			// Add the `every()` method for rows, columns and cells in a compact form
			$.each(['column', 'row', 'cell'], function (i, type) {
				_api_register(type + 's().every()', function (fn) {
					var opts = this.selector.opts;
					var api = this;

					return this.iterator(type, function (settings, arg1, arg2, arg3, arg4) {
						// Rows and columns:
						//  arg1 - index
						//  arg2 - table counter
						//  arg3 - loop counter
						//  arg4 - undefined
						// Cells:
						//  arg1 - row index
						//  arg2 - column index
						//  arg3 - table counter
						//  arg4 - loop counter
						fn.call(api[type](arg1, type === 'cell' ? arg2 : opts, type === 'cell' ? opts : undefined), arg1, arg2, arg3, arg4);
					});
				});
			});

			// i18n method for extensions to be able to use the language object from the
			// DataTable
			_api_register('i18n()', function (token, def, plural) {
				var ctx = this.context[0];
				var resolved = _fnGetObjectDataFn(token)(ctx.oLanguage);

				if (resolved === undefined) {
					resolved = def;
				}

				if (plural !== undefined && $.isPlainObject(resolved)) {
					resolved = resolved[plural] !== undefined ? resolved[plural] : resolved._;
				}

				return resolved.replace('%d', plural); // nb: plural might be undefined,
			});

			/**
    * Version string for plug-ins to check compatibility. Allowed format is
    * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
    * only for non-release builds. See http://semver.org/ for more information.
    *  @member
    *  @type string
    *  @default Version number
    */
			DataTable.version = "1.10.18";

			/**
    * Private data store, containing all of the settings objects that are
    * created for the tables on a given page.
    *
    * Note that the `DataTable.settings` object is aliased to
    * `jQuery.fn.dataTableExt` through which it may be accessed and
    * manipulated, or `jQuery.fn.dataTable.settings`.
    *  @member
    *  @type array
    *  @default []
    *  @private
    */
			DataTable.settings = [];

			/**
    * Object models container, for the various models that DataTables has
    * available to it. These models define the objects that are used to hold
    * the active state and configuration of the table.
    *  @namespace
    */
			DataTable.models = {};

			/**
    * Template object for the way in which DataTables holds information about
    * search information for the global filter and individual column filters.
    *  @namespace
    */
			DataTable.models.oSearch = {
				/**
     * Flag to indicate if the filtering should be case insensitive or not
     *  @type boolean
     *  @default true
     */
				"bCaseInsensitive": true,

				/**
     * Applied search term
     *  @type string
     *  @default <i>Empty string</i>
     */
				"sSearch": "",

				/**
     * Flag to indicate if the search term should be interpreted as a
     * regular expression (true) or not (false) and therefore and special
     * regex characters escaped.
     *  @type boolean
     *  @default false
     */
				"bRegex": false,

				/**
     * Flag to indicate if DataTables is to use its smart filtering or not.
     *  @type boolean
     *  @default true
     */
				"bSmart": true
			};

			/**
    * Template object for the way in which DataTables holds information about
    * each individual row. This is the object format used for the settings
    * aoData array.
    *  @namespace
    */
			DataTable.models.oRow = {
				/**
     * TR element for the row
     *  @type node
     *  @default null
     */
				"nTr": null,

				/**
     * Array of TD elements for each row. This is null until the row has been
     * created.
     *  @type array nodes
     *  @default []
     */
				"anCells": null,

				/**
     * Data object from the original data source for the row. This is either
     * an array if using the traditional form of DataTables, or an object if
     * using mData options. The exact type will depend on the passed in
     * data from the data source, or will be an array if using DOM a data
     * source.
     *  @type array|object
     *  @default []
     */
				"_aData": [],

				/**
     * Sorting data cache - this array is ostensibly the same length as the
     * number of columns (although each index is generated only as it is
     * needed), and holds the data that is used for sorting each column in the
     * row. We do this cache generation at the start of the sort in order that
     * the formatting of the sort data need be done only once for each cell
     * per sort. This array should not be read from or written to by anything
     * other than the master sorting methods.
     *  @type array
     *  @default null
     *  @private
     */
				"_aSortData": null,

				/**
     * Per cell filtering data cache. As per the sort data cache, used to
     * increase the performance of the filtering in DataTables
     *  @type array
     *  @default null
     *  @private
     */
				"_aFilterData": null,

				/**
     * Filtering data cache. This is the same as the cell filtering cache, but
     * in this case a string rather than an array. This is easily computed with
     * a join on `_aFilterData`, but is provided as a cache so the join isn't
     * needed on every search (memory traded for performance)
     *  @type array
     *  @default null
     *  @private
     */
				"_sFilterRow": null,

				/**
     * Cache of the class name that DataTables has applied to the row, so we
     * can quickly look at this variable rather than needing to do a DOM check
     * on className for the nTr property.
     *  @type string
     *  @default <i>Empty string</i>
     *  @private
     */
				"_sRowStripe": "",

				/**
     * Denote if the original data source was from the DOM, or the data source
     * object. This is used for invalidating data, so DataTables can
     * automatically read data from the original source, unless uninstructed
     * otherwise.
     *  @type string
     *  @default null
     *  @private
     */
				"src": null,

				/**
     * Index in the aoData array. This saves an indexOf lookup when we have the
     * object, but want to know the index
     *  @type integer
     *  @default -1
     *  @private
     */
				"idx": -1
			};

			/**
    * Template object for the column information object in DataTables. This object
    * is held in the settings aoColumns array and contains all the information that
    * DataTables needs about each individual column.
    *
    * Note that this object is related to {@link DataTable.defaults.column}
    * but this one is the internal data store for DataTables's cache of columns.
    * It should NOT be manipulated outside of DataTables. Any configuration should
    * be done through the initialisation options.
    *  @namespace
    */
			DataTable.models.oColumn = {
				/**
     * Column index. This could be worked out on-the-fly with $.inArray, but it
     * is faster to just hold it as a variable
     *  @type integer
     *  @default null
     */
				"idx": null,

				/**
     * A list of the columns that sorting should occur on when this column
     * is sorted. That this property is an array allows multi-column sorting
     * to be defined for a column (for example first name / last name columns
     * would benefit from this). The values are integers pointing to the
     * columns to be sorted on (typically it will be a single integer pointing
     * at itself, but that doesn't need to be the case).
     *  @type array
     */
				"aDataSort": null,

				/**
     * Define the sorting directions that are applied to the column, in sequence
     * as the column is repeatedly sorted upon - i.e. the first value is used
     * as the sorting direction when the column if first sorted (clicked on).
     * Sort it again (click again) and it will move on to the next index.
     * Repeat until loop.
     *  @type array
     */
				"asSorting": null,

				/**
     * Flag to indicate if the column is searchable, and thus should be included
     * in the filtering or not.
     *  @type boolean
     */
				"bSearchable": null,

				/**
     * Flag to indicate if the column is sortable or not.
     *  @type boolean
     */
				"bSortable": null,

				/**
     * Flag to indicate if the column is currently visible in the table or not
     *  @type boolean
     */
				"bVisible": null,

				/**
     * Store for manual type assignment using the `column.type` option. This
     * is held in store so we can manipulate the column's `sType` property.
     *  @type string
     *  @default null
     *  @private
     */
				"_sManualType": null,

				/**
     * Flag to indicate if HTML5 data attributes should be used as the data
     * source for filtering or sorting. True is either are.
     *  @type boolean
     *  @default false
     *  @private
     */
				"_bAttrSrc": false,

				/**
     * Developer definable function that is called whenever a cell is created (Ajax source,
     * etc) or processed for input (DOM source). This can be used as a compliment to mRender
     * allowing you to modify the DOM element (add background colour for example) when the
     * element is available.
     *  @type function
     *  @param {element} nTd The TD node that has been created
     *  @param {*} sData The Data for the cell
     *  @param {array|object} oData The data for the whole row
     *  @param {int} iRow The row index for the aoData data store
     *  @default null
     */
				"fnCreatedCell": null,

				/**
     * Function to get data from a cell in a column. You should <b>never</b>
     * access data directly through _aData internally in DataTables - always use
     * the method attached to this property. It allows mData to function as
     * required. This function is automatically assigned by the column
     * initialisation method
     *  @type function
     *  @param {array|object} oData The data array/object for the array
     *    (i.e. aoData[]._aData)
     *  @param {string} sSpecific The specific data type you want to get -
     *    'display', 'type' 'filter' 'sort'
     *  @returns {*} The data for the cell from the given row's data
     *  @default null
     */
				"fnGetData": null,

				/**
     * Function to set data for a cell in the column. You should <b>never</b>
     * set the data directly to _aData internally in DataTables - always use
     * this method. It allows mData to function as required. This function
     * is automatically assigned by the column initialisation method
     *  @type function
     *  @param {array|object} oData The data array/object for the array
     *    (i.e. aoData[]._aData)
     *  @param {*} sValue Value to set
     *  @default null
     */
				"fnSetData": null,

				/**
     * Property to read the value for the cells in the column from the data
     * source array / object. If null, then the default content is used, if a
     * function is given then the return from the function is used.
     *  @type function|int|string|null
     *  @default null
     */
				"mData": null,

				/**
     * Partner property to mData which is used (only when defined) to get
     * the data - i.e. it is basically the same as mData, but without the
     * 'set' option, and also the data fed to it is the result from mData.
     * This is the rendering method to match the data method of mData.
     *  @type function|int|string|null
     *  @default null
     */
				"mRender": null,

				/**
     * Unique header TH/TD element for this column - this is what the sorting
     * listener is attached to (if sorting is enabled.)
     *  @type node
     *  @default null
     */
				"nTh": null,

				/**
     * Unique footer TH/TD element for this column (if there is one). Not used
     * in DataTables as such, but can be used for plug-ins to reference the
     * footer for each column.
     *  @type node
     *  @default null
     */
				"nTf": null,

				/**
     * The class to apply to all TD elements in the table's TBODY for the column
     *  @type string
     *  @default null
     */
				"sClass": null,

				/**
     * When DataTables calculates the column widths to assign to each column,
     * it finds the longest string in each column and then constructs a
     * temporary table and reads the widths from that. The problem with this
     * is that "mmm" is much wider then "iiii", but the latter is a longer
     * string - thus the calculation can go wrong (doing it properly and putting
     * it into an DOM object and measuring that is horribly(!) slow). Thus as
     * a "work around" we provide this option. It will append its value to the
     * text that is found to be the longest string for the column - i.e. padding.
     *  @type string
     */
				"sContentPadding": null,

				/**
     * Allows a default value to be given for a column's data, and will be used
     * whenever a null data source is encountered (this can be because mData
     * is set to null, or because the data source itself is null).
     *  @type string
     *  @default null
     */
				"sDefaultContent": null,

				/**
     * Name for the column, allowing reference to the column by name as well as
     * by index (needs a lookup to work by name).
     *  @type string
     */
				"sName": null,

				/**
     * Custom sorting data type - defines which of the available plug-ins in
     * afnSortData the custom sorting will use - if any is defined.
     *  @type string
     *  @default std
     */
				"sSortDataType": 'std',

				/**
     * Class to be applied to the header element when sorting on this column
     *  @type string
     *  @default null
     */
				"sSortingClass": null,

				/**
     * Class to be applied to the header element when sorting on this column -
     * when jQuery UI theming is used.
     *  @type string
     *  @default null
     */
				"sSortingClassJUI": null,

				/**
     * Title of the column - what is seen in the TH element (nTh).
     *  @type string
     */
				"sTitle": null,

				/**
     * Column sorting and filtering type
     *  @type string
     *  @default null
     */
				"sType": null,

				/**
     * Width of the column
     *  @type string
     *  @default null
     */
				"sWidth": null,

				/**
     * Width of the column when it was first "encountered"
     *  @type string
     *  @default null
     */
				"sWidthOrig": null
			};

			/*
    * Developer note: The properties of the object below are given in Hungarian
    * notation, that was used as the interface for DataTables prior to v1.10, however
    * from v1.10 onwards the primary interface is camel case. In order to avoid
    * breaking backwards compatibility utterly with this change, the Hungarian
    * version is still, internally the primary interface, but is is not documented
    * - hence the @name tags in each doc comment. This allows a Javascript function
    * to create a map from Hungarian notation to camel case (going the other direction
    * would require each property to be listed, which would at around 3K to the size
    * of DataTables, while this method is about a 0.5K hit.
    *
    * Ultimately this does pave the way for Hungarian notation to be dropped
    * completely, but that is a massive amount of work and will break current
    * installs (therefore is on-hold until v2).
    */

			/**
    * Initialisation options that can be given to DataTables at initialisation
    * time.
    *  @namespace
    */
			DataTable.defaults = {
				/**
     * An array of data to use for the table, passed in at initialisation which
     * will be used in preference to any data which is already in the DOM. This is
     * particularly useful for constructing tables purely in Javascript, for
     * example with a custom Ajax call.
     *  @type array
     *  @default null
     *
     *  @dtopt Option
     *  @name DataTable.defaults.data
     *
     *  @example
     *    // Using a 2D array data source
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "data": [
     *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
     *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
     *        ],
     *        "columns": [
     *          { "title": "Engine" },
     *          { "title": "Browser" },
     *          { "title": "Platform" },
     *          { "title": "Version" },
     *          { "title": "Grade" }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using an array of objects as a data source (`data`)
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "data": [
     *          {
     *            "engine":   "Trident",
     *            "browser":  "Internet Explorer 4.0",
     *            "platform": "Win 95+",
     *            "version":  4,
     *            "grade":    "X"
     *          },
     *          {
     *            "engine":   "Trident",
     *            "browser":  "Internet Explorer 5.0",
     *            "platform": "Win 95+",
     *            "version":  5,
     *            "grade":    "C"
     *          }
     *        ],
     *        "columns": [
     *          { "title": "Engine",   "data": "engine" },
     *          { "title": "Browser",  "data": "browser" },
     *          { "title": "Platform", "data": "platform" },
     *          { "title": "Version",  "data": "version" },
     *          { "title": "Grade",    "data": "grade" }
     *        ]
     *      } );
     *    } );
     */
				"aaData": null,

				/**
     * If ordering is enabled, then DataTables will perform a first pass sort on
     * initialisation. You can define which column(s) the sort is performed
     * upon, and the sorting direction, with this variable. The `sorting` array
     * should contain an array for each column to be sorted initially containing
     * the column's index and a direction string ('asc' or 'desc').
     *  @type array
     *  @default [[0,'asc']]
     *
     *  @dtopt Option
     *  @name DataTable.defaults.order
     *
     *  @example
     *    // Sort by 3rd column first, and then 4th column
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "order": [[2,'asc'], [3,'desc']]
     *      } );
     *    } );
     *
     *    // No initial sorting
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "order": []
     *      } );
     *    } );
     */
				"aaSorting": [[0, 'asc']],

				/**
     * This parameter is basically identical to the `sorting` parameter, but
     * cannot be overridden by user interaction with the table. What this means
     * is that you could have a column (visible or hidden) which the sorting
     * will always be forced on first - any sorting after that (from the user)
     * will then be performed as required. This can be useful for grouping rows
     * together.
     *  @type array
     *  @default null
     *
     *  @dtopt Option
     *  @name DataTable.defaults.orderFixed
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "orderFixed": [[0,'asc']]
     *      } );
     *    } )
     */
				"aaSortingFixed": [],

				/**
     * DataTables can be instructed to load data to display in the table from a
     * Ajax source. This option defines how that Ajax call is made and where to.
     *
     * The `ajax` property has three different modes of operation, depending on
     * how it is defined. These are:
     *
     * * `string` - Set the URL from where the data should be loaded from.
     * * `object` - Define properties for `jQuery.ajax`.
     * * `function` - Custom data get function
     *
     * `string`
     * --------
     *
     * As a string, the `ajax` property simply defines the URL from which
     * DataTables will load data.
     *
     * `object`
     * --------
     *
     * As an object, the parameters in the object are passed to
     * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
     * of the Ajax request. DataTables has a number of default parameters which
     * you can override using this option. Please refer to the jQuery
     * documentation for a full description of the options available, although
     * the following parameters provide additional options in DataTables or
     * require special consideration:
     *
     * * `data` - As with jQuery, `data` can be provided as an object, but it
     *   can also be used as a function to manipulate the data DataTables sends
     *   to the server. The function takes a single parameter, an object of
     *   parameters with the values that DataTables has readied for sending. An
     *   object may be returned which will be merged into the DataTables
     *   defaults, or you can add the items to the object that was passed in and
     *   not return anything from the function. This supersedes `fnServerParams`
     *   from DataTables 1.9-.
     *
     * * `dataSrc` - By default DataTables will look for the property `data` (or
     *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
     *   from an Ajax source or for server-side processing - this parameter
     *   allows that property to be changed. You can use Javascript dotted
     *   object notation to get a data source for multiple levels of nesting, or
     *   it my be used as a function. As a function it takes a single parameter,
     *   the JSON returned from the server, which can be manipulated as
     *   required, with the returned value being that used by DataTables as the
     *   data source for the table. This supersedes `sAjaxDataProp` from
     *   DataTables 1.9-.
     *
     * * `success` - Should not be overridden it is used internally in
     *   DataTables. To manipulate / transform the data returned by the server
     *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
     *
     * `function`
     * ----------
     *
     * As a function, making the Ajax call is left up to yourself allowing
     * complete control of the Ajax request. Indeed, if desired, a method other
     * than Ajax could be used to obtain the required data, such as Web storage
     * or an AIR database.
     *
     * The function is given four parameters and no return is required. The
     * parameters are:
     *
     * 1. _object_ - Data to send to the server
     * 2. _function_ - Callback function that must be executed when the required
     *    data has been obtained. That data should be passed into the callback
     *    as the only parameter
     * 3. _object_ - DataTables settings object for the table
     *
     * Note that this supersedes `fnServerData` from DataTables 1.9-.
     *
     *  @type string|object|function
     *  @default null
     *
     *  @dtopt Option
     *  @name DataTable.defaults.ajax
     *  @since 1.10.0
     *
     * @example
     *   // Get JSON data from a file via Ajax.
     *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
     *   $('#example').dataTable( {
     *     "ajax": "data.json"
     *   } );
     *
     * @example
     *   // Get JSON data from a file via Ajax, using `dataSrc` to change
     *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
     *   $('#example').dataTable( {
     *     "ajax": {
     *       "url": "data.json",
     *       "dataSrc": "tableData"
     *     }
     *   } );
     *
     * @example
     *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
     *   // from a plain array rather than an array in an object
     *   $('#example').dataTable( {
     *     "ajax": {
     *       "url": "data.json",
     *       "dataSrc": ""
     *     }
     *   } );
     *
     * @example
     *   // Manipulate the data returned from the server - add a link to data
     *   // (note this can, should, be done using `render` for the column - this
     *   // is just a simple example of how the data can be manipulated).
     *   $('#example').dataTable( {
     *     "ajax": {
     *       "url": "data.json",
     *       "dataSrc": function ( json ) {
     *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
     *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
     *         }
     *         return json;
     *       }
     *     }
     *   } );
     *
     * @example
     *   // Add data to the request
     *   $('#example').dataTable( {
     *     "ajax": {
     *       "url": "data.json",
     *       "data": function ( d ) {
     *         return {
     *           "extra_search": $('#extra').val()
     *         };
     *       }
     *     }
     *   } );
     *
     * @example
     *   // Send request as POST
     *   $('#example').dataTable( {
     *     "ajax": {
     *       "url": "data.json",
     *       "type": "POST"
     *     }
     *   } );
     *
     * @example
     *   // Get the data from localStorage (could interface with a form for
     *   // adding, editing and removing rows).
     *   $('#example').dataTable( {
     *     "ajax": function (data, callback, settings) {
     *       callback(
     *         JSON.parse( localStorage.getItem('dataTablesData') )
     *       );
     *     }
     *   } );
     */
				"ajax": null,

				/**
     * This parameter allows you to readily specify the entries in the length drop
     * down menu that DataTables shows when pagination is enabled. It can be
     * either a 1D array of options which will be used for both the displayed
     * option and the value, or a 2D array which will use the array in the first
     * position as the value, and the array in the second position as the
     * displayed options (useful for language strings such as 'All').
     *
     * Note that the `pageLength` property will be automatically set to the
     * first value given in this array, unless `pageLength` is also provided.
     *  @type array
     *  @default [ 10, 25, 50, 100 ]
     *
     *  @dtopt Option
     *  @name DataTable.defaults.lengthMenu
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
     *      } );
     *    } );
     */
				"aLengthMenu": [10, 25, 50, 100],

				/**
     * The `columns` option in the initialisation parameter allows you to define
     * details about the way individual columns behave. For a full list of
     * column options that can be set, please see
     * {@link DataTable.defaults.column}. Note that if you use `columns` to
     * define your columns, you must have an entry in the array for every single
     * column that you have in your table (these can be null if you don't which
     * to specify any options).
     *  @member
     *
     *  @name DataTable.defaults.column
     */
				"aoColumns": null,

				/**
     * Very similar to `columns`, `columnDefs` allows you to target a specific
     * column, multiple columns, or all columns, using the `targets` property of
     * each object in the array. This allows great flexibility when creating
     * tables, as the `columnDefs` arrays can be of any length, targeting the
     * columns you specifically want. `columnDefs` may use any of the column
     * options available: {@link DataTable.defaults.column}, but it _must_
     * have `targets` defined in each object in the array. Values in the `targets`
     * array may be:
     *   <ul>
     *     <li>a string - class name will be matched on the TH for the column</li>
     *     <li>0 or a positive integer - column index counting from the left</li>
     *     <li>a negative integer - column index counting from the right</li>
     *     <li>the string "_all" - all columns (i.e. assign a default)</li>
     *   </ul>
     *  @member
     *
     *  @name DataTable.defaults.columnDefs
     */
				"aoColumnDefs": null,

				/**
     * Basically the same as `search`, this parameter defines the individual column
     * filtering state at initialisation time. The array must be of the same size
     * as the number of columns, and each element be an object with the parameters
     * `search` and `escapeRegex` (the latter is optional). 'null' is also
     * accepted and the default will be used.
     *  @type array
     *  @default []
     *
     *  @dtopt Option
     *  @name DataTable.defaults.searchCols
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "searchCols": [
     *          null,
     *          { "search": "My filter" },
     *          null,
     *          { "search": "^[0-9]", "escapeRegex": false }
     *        ]
     *      } );
     *    } )
     */
				"aoSearchCols": [],

				/**
     * An array of CSS classes that should be applied to displayed rows. This
     * array may be of any length, and DataTables will apply each class
     * sequentially, looping when required.
     *  @type array
     *  @default null <i>Will take the values determined by the `oClasses.stripe*`
     *    options</i>
     *
     *  @dtopt Option
     *  @name DataTable.defaults.stripeClasses
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
     *      } );
     *    } )
     */
				"asStripeClasses": null,

				/**
     * Enable or disable automatic column width calculation. This can be disabled
     * as an optimisation (it takes some time to calculate the widths) if the
     * tables widths are passed in using `columns`.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.autoWidth
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "autoWidth": false
     *      } );
     *    } );
     */
				"bAutoWidth": true,

				/**
     * Deferred rendering can provide DataTables with a huge speed boost when you
     * are using an Ajax or JS data source for the table. This option, when set to
     * true, will cause DataTables to defer the creation of the table elements for
     * each row until they are needed for a draw - saving a significant amount of
     * time.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Features
     *  @name DataTable.defaults.deferRender
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "ajax": "sources/arrays.txt",
     *        "deferRender": true
     *      } );
     *    } );
     */
				"bDeferRender": false,

				/**
     * Replace a DataTable which matches the given selector and replace it with
     * one which has the properties of the new initialisation object passed. If no
     * table matches the selector, then the new DataTable will be constructed as
     * per normal.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Options
     *  @name DataTable.defaults.destroy
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "srollY": "200px",
     *        "paginate": false
     *      } );
     *
     *      // Some time later....
     *      $('#example').dataTable( {
     *        "filter": false,
     *        "destroy": true
     *      } );
     *    } );
     */
				"bDestroy": false,

				/**
     * Enable or disable filtering of data. Filtering in DataTables is "smart" in
     * that it allows the end user to input multiple words (space separated) and
     * will match a row containing those words, even if not in the order that was
     * specified (this allow matching across multiple columns). Note that if you
     * wish to use filtering in DataTables this must remain 'true' - to remove the
     * default filtering input box and retain filtering abilities, please use
     * {@link DataTable.defaults.dom}.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.searching
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "searching": false
     *      } );
     *    } );
     */
				"bFilter": true,

				/**
     * Enable or disable the table information display. This shows information
     * about the data that is currently visible on the page, including information
     * about filtered data if that action is being performed.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.info
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "info": false
     *      } );
     *    } );
     */
				"bInfo": true,

				/**
     * Allows the end user to select the size of a formatted page from a select
     * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.lengthChange
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "lengthChange": false
     *      } );
     *    } );
     */
				"bLengthChange": true,

				/**
     * Enable or disable pagination.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.paging
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "paging": false
     *      } );
     *    } );
     */
				"bPaginate": true,

				/**
     * Enable or disable the display of a 'processing' indicator when the table is
     * being processed (e.g. a sort). This is particularly useful for tables with
     * large amounts of data where it can take a noticeable amount of time to sort
     * the entries.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Features
     *  @name DataTable.defaults.processing
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "processing": true
     *      } );
     *    } );
     */
				"bProcessing": false,

				/**
     * Retrieve the DataTables object for the given selector. Note that if the
     * table has already been initialised, this parameter will cause DataTables
     * to simply return the object that has already been set up - it will not take
     * account of any changes you might have made to the initialisation object
     * passed to DataTables (setting this parameter to true is an acknowledgement
     * that you understand this). `destroy` can be used to reinitialise a table if
     * you need.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Options
     *  @name DataTable.defaults.retrieve
     *
     *  @example
     *    $(document).ready( function() {
     *      initTable();
     *      tableActions();
     *    } );
     *
     *    function initTable ()
     *    {
     *      return $('#example').dataTable( {
     *        "scrollY": "200px",
     *        "paginate": false,
     *        "retrieve": true
     *      } );
     *    }
     *
     *    function tableActions ()
     *    {
     *      var table = initTable();
     *      // perform API operations with oTable
     *    }
     */
				"bRetrieve": false,

				/**
     * When vertical (y) scrolling is enabled, DataTables will force the height of
     * the table's viewport to the given height at all times (useful for layout).
     * However, this can look odd when filtering data down to a small data set,
     * and the footer is left "floating" further down. This parameter (when
     * enabled) will cause DataTables to collapse the table's viewport down when
     * the result set will fit within the given Y height.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Options
     *  @name DataTable.defaults.scrollCollapse
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "scrollY": "200",
     *        "scrollCollapse": true
     *      } );
     *    } );
     */
				"bScrollCollapse": false,

				/**
     * Configure DataTables to use server-side processing. Note that the
     * `ajax` parameter must also be given in order to give DataTables a
     * source to obtain the required data for each draw.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Features
     *  @dtopt Server-side
     *  @name DataTable.defaults.serverSide
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "serverSide": true,
     *        "ajax": "xhr.php"
     *      } );
     *    } );
     */
				"bServerSide": false,

				/**
     * Enable or disable sorting of columns. Sorting of individual columns can be
     * disabled by the `sortable` option for each column.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.ordering
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "ordering": false
     *      } );
     *    } );
     */
				"bSort": true,

				/**
     * Enable or display DataTables' ability to sort multiple columns at the
     * same time (activated by shift-click by the user).
     *  @type boolean
     *  @default true
     *
     *  @dtopt Options
     *  @name DataTable.defaults.orderMulti
     *
     *  @example
     *    // Disable multiple column sorting ability
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "orderMulti": false
     *      } );
     *    } );
     */
				"bSortMulti": true,

				/**
     * Allows control over whether DataTables should use the top (true) unique
     * cell that is found for a single column, or the bottom (false - default).
     * This is useful when using complex headers.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Options
     *  @name DataTable.defaults.orderCellsTop
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "orderCellsTop": true
     *      } );
     *    } );
     */
				"bSortCellsTop": false,

				/**
     * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
     * `sorting\_3` to the columns which are currently being sorted on. This is
     * presented as a feature switch as it can increase processing time (while
     * classes are removed and added) so for large data sets you might want to
     * turn this off.
     *  @type boolean
     *  @default true
     *
     *  @dtopt Features
     *  @name DataTable.defaults.orderClasses
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "orderClasses": false
     *      } );
     *    } );
     */
				"bSortClasses": true,

				/**
     * Enable or disable state saving. When enabled HTML5 `localStorage` will be
     * used to save table display information such as pagination information,
     * display length, filtering and sorting. As such when the end user reloads
     * the page the display display will match what thy had previously set up.
     *
     * Due to the use of `localStorage` the default state saving is not supported
     * in IE6 or 7. If state saving is required in those browsers, use
     * `stateSaveCallback` to provide a storage solution such as cookies.
     *  @type boolean
     *  @default false
     *
     *  @dtopt Features
     *  @name DataTable.defaults.stateSave
     *
     *  @example
     *    $(document).ready( function () {
     *      $('#example').dataTable( {
     *        "stateSave": true
     *      } );
     *    } );
     */
				"bStateSave": false,

				/**
     * This function is called when a TR element is created (and all TD child
     * elements have been inserted), or registered if using a DOM source, allowing
     * manipulation of the TR element (adding classes etc).
     *  @type function
     *  @param {node} row "TR" element for the current row
     *  @param {array} data Raw data array for this row
     *  @param {int} dataIndex The index of this row in the internal aoData array
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.createdRow
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "createdRow": function( row, data, dataIndex ) {
     *          // Bold the grade for all 'A' grade browsers
     *          if ( data[4] == "A" )
     *          {
     *            $('td:eq(4)', row).html( '<b>A</b>' );
     *          }
     *        }
     *      } );
     *    } );
     */
				"fnCreatedRow": null,

				/**
     * This function is called on every 'draw' event, and allows you to
     * dynamically modify any aspect you want about the created DOM.
     *  @type function
     *  @param {object} settings DataTables settings object
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.drawCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "drawCallback": function( settings ) {
     *          alert( 'DataTables has redrawn the table' );
     *        }
     *      } );
     *    } );
     */
				"fnDrawCallback": null,

				/**
     * Identical to fnHeaderCallback() but for the table footer this function
     * allows you to modify the table footer on every 'draw' event.
     *  @type function
     *  @param {node} foot "TR" element for the footer
     *  @param {array} data Full table data (as derived from the original HTML)
     *  @param {int} start Index for the current display starting point in the
     *    display array
     *  @param {int} end Index for the current display ending point in the
     *    display array
     *  @param {array int} display Index array to translate the visual position
     *    to the full data array
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.footerCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "footerCallback": function( tfoot, data, start, end, display ) {
     *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
     *        }
     *      } );
     *    } )
     */
				"fnFooterCallback": null,

				/**
     * When rendering large numbers in the information element for the table
     * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
     * to have a comma separator for the 'thousands' units (e.g. 1 million is
     * rendered as "1,000,000") to help readability for the end user. This
     * function will override the default method DataTables uses.
     *  @type function
     *  @member
     *  @param {int} toFormat number to be formatted
     *  @returns {string} formatted string for DataTables to show the number
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.formatNumber
     *
     *  @example
     *    // Format a number using a single quote for the separator (note that
     *    // this can also be done with the language.thousands option)
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "formatNumber": function ( toFormat ) {
     *          return toFormat.toString().replace(
     *            /\B(?=(\d{3})+(?!\d))/g, "'"
     *          );
     *        };
     *      } );
     *    } );
     */
				"fnFormatNumber": function (toFormat) {
					return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
				},

				/**
     * This function is called on every 'draw' event, and allows you to
     * dynamically modify the header row. This can be used to calculate and
     * display useful information about the table.
     *  @type function
     *  @param {node} head "TR" element for the header
     *  @param {array} data Full table data (as derived from the original HTML)
     *  @param {int} start Index for the current display starting point in the
     *    display array
     *  @param {int} end Index for the current display ending point in the
     *    display array
     *  @param {array int} display Index array to translate the visual position
     *    to the full data array
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.headerCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "fheaderCallback": function( head, data, start, end, display ) {
     *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
     *        }
     *      } );
     *    } )
     */
				"fnHeaderCallback": null,

				/**
     * The information element can be used to convey information about the current
     * state of the table. Although the internationalisation options presented by
     * DataTables are quite capable of dealing with most customisations, there may
     * be times where you wish to customise the string further. This callback
     * allows you to do exactly that.
     *  @type function
     *  @param {object} oSettings DataTables settings object
     *  @param {int} start Starting position in data for the draw
     *  @param {int} end End position in data for the draw
     *  @param {int} max Total number of rows in the table (regardless of
     *    filtering)
     *  @param {int} total Total number of rows in the data set, after filtering
     *  @param {string} pre The string that DataTables has formatted using it's
     *    own rules
     *  @returns {string} The string to be displayed in the information element.
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.infoCallback
     *
     *  @example
     *    $('#example').dataTable( {
     *      "infoCallback": function( settings, start, end, max, total, pre ) {
     *        return start +" to "+ end;
     *      }
     *    } );
     */
				"fnInfoCallback": null,

				/**
     * Called when the table has been initialised. Normally DataTables will
     * initialise sequentially and there will be no need for this function,
     * however, this does not hold true when using external language information
     * since that is obtained using an async XHR call.
     *  @type function
     *  @param {object} settings DataTables settings object
     *  @param {object} json The JSON object request from the server - only
     *    present if client-side Ajax sourced data is used
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.initComplete
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "initComplete": function(settings, json) {
     *          alert( 'DataTables has finished its initialisation.' );
     *        }
     *      } );
     *    } )
     */
				"fnInitComplete": null,

				/**
     * Called at the very start of each table draw and can be used to cancel the
     * draw by returning false, any other return (including undefined) results in
     * the full draw occurring).
     *  @type function
     *  @param {object} settings DataTables settings object
     *  @returns {boolean} False will cancel the draw, anything else (including no
     *    return) will allow it to complete.
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.preDrawCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "preDrawCallback": function( settings ) {
     *          if ( $('#test').val() == 1 ) {
     *            return false;
     *          }
     *        }
     *      } );
     *    } );
     */
				"fnPreDrawCallback": null,

				/**
     * This function allows you to 'post process' each row after it have been
     * generated for each table draw, but before it is rendered on screen. This
     * function might be used for setting the row class name etc.
     *  @type function
     *  @param {node} row "TR" element for the current row
     *  @param {array} data Raw data array for this row
     *  @param {int} displayIndex The display index for the current table draw
     *  @param {int} displayIndexFull The index of the data in the full list of
     *    rows (after filtering)
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.rowCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
     *          // Bold the grade for all 'A' grade browsers
     *          if ( data[4] == "A" ) {
     *            $('td:eq(4)', row).html( '<b>A</b>' );
     *          }
     *        }
     *      } );
     *    } );
     */
				"fnRowCallback": null,

				/**
     * __Deprecated__ The functionality provided by this parameter has now been
     * superseded by that provided through `ajax`, which should be used instead.
     *
     * This parameter allows you to override the default function which obtains
     * the data from the server so something more suitable for your application.
     * For example you could use POST data, or pull information from a Gears or
     * AIR database.
     *  @type function
     *  @member
     *  @param {string} source HTTP source to obtain the data from (`ajax`)
     *  @param {array} data A key/value pair object containing the data to send
     *    to the server
     *  @param {function} callback to be called on completion of the data get
     *    process that will draw the data on the page.
     *  @param {object} settings DataTables settings object
     *
     *  @dtopt Callbacks
     *  @dtopt Server-side
     *  @name DataTable.defaults.serverData
     *
     *  @deprecated 1.10. Please use `ajax` for this functionality now.
     */
				"fnServerData": null,

				/**
     * __Deprecated__ The functionality provided by this parameter has now been
     * superseded by that provided through `ajax`, which should be used instead.
     *
     *  It is often useful to send extra data to the server when making an Ajax
     * request - for example custom filtering information, and this callback
     * function makes it trivial to send extra information to the server. The
     * passed in parameter is the data set that has been constructed by
     * DataTables, and you can add to this or modify it as you require.
     *  @type function
     *  @param {array} data Data array (array of objects which are name/value
     *    pairs) that has been constructed by DataTables and will be sent to the
     *    server. In the case of Ajax sourced data with server-side processing
     *    this will be an empty array, for server-side processing there will be a
     *    significant number of parameters!
     *  @returns {undefined} Ensure that you modify the data array passed in,
     *    as this is passed by reference.
     *
     *  @dtopt Callbacks
     *  @dtopt Server-side
     *  @name DataTable.defaults.serverParams
     *
     *  @deprecated 1.10. Please use `ajax` for this functionality now.
     */
				"fnServerParams": null,

				/**
     * Load the table state. With this function you can define from where, and how, the
     * state of a table is loaded. By default DataTables will load from `localStorage`
     * but you might wish to use a server-side database or cookies.
     *  @type function
     *  @member
     *  @param {object} settings DataTables settings object
     *  @param {object} callback Callback that can be executed when done. It
     *    should be passed the loaded state object.
     *  @return {object} The DataTables state object to be loaded
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.stateLoadCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateLoadCallback": function (settings, callback) {
     *          $.ajax( {
     *            "url": "/state_load",
     *            "dataType": "json",
     *            "success": function (json) {
     *              callback( json );
     *            }
     *          } );
     *        }
     *      } );
     *    } );
     */
				"fnStateLoadCallback": function (settings) {
					try {
						return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
					} catch (e) {}
				},

				/**
     * Callback which allows modification of the saved state prior to loading that state.
     * This callback is called when the table is loading state from the stored data, but
     * prior to the settings object being modified by the saved state. Note that for
     * plug-in authors, you should use the `stateLoadParams` event to load parameters for
     * a plug-in.
     *  @type function
     *  @param {object} settings DataTables settings object
     *  @param {object} data The state object that is to be loaded
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.stateLoadParams
     *
     *  @example
     *    // Remove a saved filter, so filtering is never loaded
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateLoadParams": function (settings, data) {
     *          data.oSearch.sSearch = "";
     *        }
     *      } );
     *    } );
     *
     *  @example
     *    // Disallow state loading by returning false
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateLoadParams": function (settings, data) {
     *          return false;
     *        }
     *      } );
     *    } );
     */
				"fnStateLoadParams": null,

				/**
     * Callback that is called when the state has been loaded from the state saving method
     * and the DataTables settings object has been modified as a result of the loaded state.
     *  @type function
     *  @param {object} settings DataTables settings object
     *  @param {object} data The state object that was loaded
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.stateLoaded
     *
     *  @example
     *    // Show an alert with the filtering value that was saved
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateLoaded": function (settings, data) {
     *          alert( 'Saved filter was: '+data.oSearch.sSearch );
     *        }
     *      } );
     *    } );
     */
				"fnStateLoaded": null,

				/**
     * Save the table state. This function allows you to define where and how the state
     * information for the table is stored By default DataTables will use `localStorage`
     * but you might wish to use a server-side database or cookies.
     *  @type function
     *  @member
     *  @param {object} settings DataTables settings object
     *  @param {object} data The state object to be saved
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.stateSaveCallback
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateSaveCallback": function (settings, data) {
     *          // Send an Ajax request to the server with the state object
     *          $.ajax( {
     *            "url": "/state_save",
     *            "data": data,
     *            "dataType": "json",
     *            "method": "POST"
     *            "success": function () {}
     *          } );
     *        }
     *      } );
     *    } );
     */
				"fnStateSaveCallback": function (settings, data) {
					try {
						(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
					} catch (e) {}
				},

				/**
     * Callback which allows modification of the state to be saved. Called when the table
     * has changed state a new state save is required. This method allows modification of
     * the state saving object prior to actually doing the save, including addition or
     * other state properties or modification. Note that for plug-in authors, you should
     * use the `stateSaveParams` event to save parameters for a plug-in.
     *  @type function
     *  @param {object} settings DataTables settings object
     *  @param {object} data The state object to be saved
     *
     *  @dtopt Callbacks
     *  @name DataTable.defaults.stateSaveParams
     *
     *  @example
     *    // Remove a saved filter, so filtering is never saved
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateSave": true,
     *        "stateSaveParams": function (settings, data) {
     *          data.oSearch.sSearch = "";
     *        }
     *      } );
     *    } );
     */
				"fnStateSaveParams": null,

				/**
     * Duration for which the saved state information is considered valid. After this period
     * has elapsed the state will be returned to the default.
     * Value is given in seconds.
     *  @type int
     *  @default 7200 <i>(2 hours)</i>
     *
     *  @dtopt Options
     *  @name DataTable.defaults.stateDuration
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "stateDuration": 60*60*24; // 1 day
     *      } );
     *    } )
     */
				"iStateDuration": 7200,

				/**
     * When enabled DataTables will not make a request to the server for the first
     * page draw - rather it will use the data already on the page (no sorting etc
     * will be applied to it), thus saving on an XHR at load time. `deferLoading`
     * is used to indicate that deferred loading is required, but it is also used
     * to tell DataTables how many records there are in the full table (allowing
     * the information element and pagination to be displayed correctly). In the case
     * where a filtering is applied to the table on initial load, this can be
     * indicated by giving the parameter as an array, where the first element is
     * the number of records available after filtering and the second element is the
     * number of records without filtering (allowing the table information element
     * to be shown correctly).
     *  @type int | array
     *  @default null
     *
     *  @dtopt Options
     *  @name DataTable.defaults.deferLoading
     *
     *  @example
     *    // 57 records available in the table, no filtering applied
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "serverSide": true,
     *        "ajax": "scripts/server_processing.php",
     *        "deferLoading": 57
     *      } );
     *    } );
     *
     *  @example
     *    // 57 records after filtering, 100 without filtering (an initial filter applied)
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "serverSide": true,
     *        "ajax": "scripts/server_processing.php",
     *        "deferLoading": [ 57, 100 ],
     *        "search": {
     *          "search": "my_filter"
     *        }
     *      } );
     *    } );
     */
				"iDeferLoading": null,

				/**
     * Number of rows to display on a single page when using pagination. If
     * feature enabled (`lengthChange`) then the end user will be able to override
     * this to a custom setting using a pop-up menu.
     *  @type int
     *  @default 10
     *
     *  @dtopt Options
     *  @name DataTable.defaults.pageLength
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "pageLength": 50
     *      } );
     *    } )
     */
				"iDisplayLength": 10,

				/**
     * Define the starting point for data display when using DataTables with
     * pagination. Note that this parameter is the number of records, rather than
     * the page number, so if you have 10 records per page and want to start on
     * the third page, it should be "20".
     *  @type int
     *  @default 0
     *
     *  @dtopt Options
     *  @name DataTable.defaults.displayStart
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "displayStart": 20
     *      } );
     *    } )
     */
				"iDisplayStart": 0,

				/**
     * By default DataTables allows keyboard navigation of the table (sorting, paging,
     * and filtering) by adding a `tabindex` attribute to the required elements. This
     * allows you to tab through the controls and press the enter key to activate them.
     * The tabindex is default 0, meaning that the tab follows the flow of the document.
     * You can overrule this using this parameter if you wish. Use a value of -1 to
     * disable built-in keyboard navigation.
     *  @type int
     *  @default 0
     *
     *  @dtopt Options
     *  @name DataTable.defaults.tabIndex
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "tabIndex": 1
     *      } );
     *    } );
     */
				"iTabIndex": 0,

				/**
     * Classes that DataTables assigns to the various components and features
     * that it adds to the HTML table. This allows classes to be configured
     * during initialisation in addition to through the static
     * {@link DataTable.ext.oStdClasses} object).
     *  @namespace
     *  @name DataTable.defaults.classes
     */
				"oClasses": {},

				/**
     * All strings that DataTables uses in the user interface that it creates
     * are defined in this object, allowing you to modified them individually or
     * completely replace them all as required.
     *  @namespace
     *  @name DataTable.defaults.language
     */
				"oLanguage": {
					/**
      * Strings that are used for WAI-ARIA labels and controls only (these are not
      * actually visible on the page, but will be read by screenreaders, and thus
      * must be internationalised as well).
      *  @namespace
      *  @name DataTable.defaults.language.aria
      */
					"oAria": {
						/**
       * ARIA label that is added to the table headers when the column may be
       * sorted ascending by activing the column (click or return when focused).
       * Note that the column header is prefixed to this string.
       *  @type string
       *  @default : activate to sort column ascending
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.aria.sortAscending
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "aria": {
       *            "sortAscending": " - click/return to sort ascending"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sSortAscending": ": activate to sort column ascending",

						/**
       * ARIA label that is added to the table headers when the column may be
       * sorted descending by activing the column (click or return when focused).
       * Note that the column header is prefixed to this string.
       *  @type string
       *  @default : activate to sort column ascending
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.aria.sortDescending
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "aria": {
       *            "sortDescending": " - click/return to sort descending"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sSortDescending": ": activate to sort column descending"
					},

					/**
      * Pagination string used by DataTables for the built-in pagination
      * control types.
      *  @namespace
      *  @name DataTable.defaults.language.paginate
      */
					"oPaginate": {
						/**
       * Text to use when using the 'full_numbers' type of pagination for the
       * button to take the user to the first page.
       *  @type string
       *  @default First
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.paginate.first
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "paginate": {
       *            "first": "First page"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sFirst": "First",

						/**
       * Text to use when using the 'full_numbers' type of pagination for the
       * button to take the user to the last page.
       *  @type string
       *  @default Last
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.paginate.last
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "paginate": {
       *            "last": "Last page"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sLast": "Last",

						/**
       * Text to use for the 'next' pagination button (to take the user to the
       * next page).
       *  @type string
       *  @default Next
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.paginate.next
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "paginate": {
       *            "next": "Next page"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sNext": "Next",

						/**
       * Text to use for the 'previous' pagination button (to take the user to
       * the previous page).
       *  @type string
       *  @default Previous
       *
       *  @dtopt Language
       *  @name DataTable.defaults.language.paginate.previous
       *
       *  @example
       *    $(document).ready( function() {
       *      $('#example').dataTable( {
       *        "language": {
       *          "paginate": {
       *            "previous": "Previous page"
       *          }
       *        }
       *      } );
       *    } );
       */
						"sPrevious": "Previous"
					},

					/**
      * This string is shown in preference to `zeroRecords` when the table is
      * empty of data (regardless of filtering). Note that this is an optional
      * parameter - if it is not given, the value of `zeroRecords` will be used
      * instead (either the default or given value).
      *  @type string
      *  @default No data available in table
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.emptyTable
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "emptyTable": "No data available in table"
      *        }
      *      } );
      *    } );
      */
					"sEmptyTable": "No data available in table",

					/**
      * This string gives information to the end user about the information
      * that is current on display on the page. The following tokens can be
      * used in the string and will be dynamically replaced as the table
      * display updates. This tokens can be placed anywhere in the string, or
      * removed as needed by the language requires:
      *
      * * `\_START\_` - Display index of the first record on the current page
      * * `\_END\_` - Display index of the last record on the current page
      * * `\_TOTAL\_` - Number of records in the table after filtering
      * * `\_MAX\_` - Number of records in the table without filtering
      * * `\_PAGE\_` - Current page number
      * * `\_PAGES\_` - Total number of pages of data in the table
      *
      *  @type string
      *  @default Showing _START_ to _END_ of _TOTAL_ entries
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.info
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "info": "Showing page _PAGE_ of _PAGES_"
      *        }
      *      } );
      *    } );
      */
					"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",

					/**
      * Display information string for when the table is empty. Typically the
      * format of this string should match `info`.
      *  @type string
      *  @default Showing 0 to 0 of 0 entries
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.infoEmpty
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "infoEmpty": "No entries to show"
      *        }
      *      } );
      *    } );
      */
					"sInfoEmpty": "Showing 0 to 0 of 0 entries",

					/**
      * When a user filters the information in a table, this string is appended
      * to the information (`info`) to give an idea of how strong the filtering
      * is. The variable _MAX_ is dynamically updated.
      *  @type string
      *  @default (filtered from _MAX_ total entries)
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.infoFiltered
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "infoFiltered": " - filtering from _MAX_ records"
      *        }
      *      } );
      *    } );
      */
					"sInfoFiltered": "(filtered from _MAX_ total entries)",

					/**
      * If can be useful to append extra information to the info string at times,
      * and this variable does exactly that. This information will be appended to
      * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
      * being used) at all times.
      *  @type string
      *  @default <i>Empty string</i>
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.infoPostFix
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "infoPostFix": "All records shown are derived from real information."
      *        }
      *      } );
      *    } );
      */
					"sInfoPostFix": "",

					/**
      * This decimal place operator is a little different from the other
      * language options since DataTables doesn't output floating point
      * numbers, so it won't ever use this for display of a number. Rather,
      * what this parameter does is modify the sort methods of the table so
      * that numbers which are in a format which has a character other than
      * a period (`.`) as a decimal place will be sorted numerically.
      *
      * Note that numbers with different decimal places cannot be shown in
      * the same table and still be sortable, the table must be consistent.
      * However, multiple different tables on the page can use different
      * decimal place characters.
      *  @type string
      *  @default 
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.decimal
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "decimal": ","
      *          "thousands": "."
      *        }
      *      } );
      *    } );
      */
					"sDecimal": "",

					/**
      * DataTables has a build in number formatter (`formatNumber`) which is
      * used to format large numbers that are used in the table information.
      * By default a comma is used, but this can be trivially changed to any
      * character you wish with this parameter.
      *  @type string
      *  @default ,
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.thousands
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "thousands": "'"
      *        }
      *      } );
      *    } );
      */
					"sThousands": ",",

					/**
      * Detail the action that will be taken when the drop down menu for the
      * pagination length option is changed. The '_MENU_' variable is replaced
      * with a default select list of 10, 25, 50 and 100, and can be replaced
      * with a custom select box if required.
      *  @type string
      *  @default Show _MENU_ entries
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.lengthMenu
      *
      *  @example
      *    // Language change only
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "lengthMenu": "Display _MENU_ records"
      *        }
      *      } );
      *    } );
      *
      *  @example
      *    // Language and options change
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "lengthMenu": 'Display <select>'+
      *            '<option value="10">10</option>'+
      *            '<option value="20">20</option>'+
      *            '<option value="30">30</option>'+
      *            '<option value="40">40</option>'+
      *            '<option value="50">50</option>'+
      *            '<option value="-1">All</option>'+
      *            '</select> records'
      *        }
      *      } );
      *    } );
      */
					"sLengthMenu": "Show _MENU_ entries",

					/**
      * When using Ajax sourced data and during the first draw when DataTables is
      * gathering the data, this message is shown in an empty row in the table to
      * indicate to the end user the the data is being loaded. Note that this
      * parameter is not used when loading data by server-side processing, just
      * Ajax sourced data with client-side processing.
      *  @type string
      *  @default Loading...
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.loadingRecords
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "loadingRecords": "Please wait - loading..."
      *        }
      *      } );
      *    } );
      */
					"sLoadingRecords": "Loading...",

					/**
      * Text which is displayed when the table is processing a user action
      * (usually a sort command or similar).
      *  @type string
      *  @default Processing...
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.processing
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "processing": "DataTables is currently busy"
      *        }
      *      } );
      *    } );
      */
					"sProcessing": "Processing...",

					/**
      * Details the actions that will be taken when the user types into the
      * filtering input text box. The variable "_INPUT_", if used in the string,
      * is replaced with the HTML text box for the filtering input allowing
      * control over where it appears in the string. If "_INPUT_" is not given
      * then the input box is appended to the string automatically.
      *  @type string
      *  @default Search:
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.search
      *
      *  @example
      *    // Input text box will be appended at the end automatically
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "search": "Filter records:"
      *        }
      *      } );
      *    } );
      *
      *  @example
      *    // Specify where the filter should appear
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "search": "Apply filter _INPUT_ to table"
      *        }
      *      } );
      *    } );
      */
					"sSearch": "Search:",

					/**
      * Assign a `placeholder` attribute to the search `input` element
      *  @type string
      *  @default 
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.searchPlaceholder
      */
					"sSearchPlaceholder": "",

					/**
      * All of the language information can be stored in a file on the
      * server-side, which DataTables will look up if this parameter is passed.
      * It must store the URL of the language file, which is in a JSON format,
      * and the object has the same properties as the oLanguage object in the
      * initialiser object (i.e. the above parameters). Please refer to one of
      * the example language files to see how this works in action.
      *  @type string
      *  @default <i>Empty string - i.e. disabled</i>
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.url
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
      *        }
      *      } );
      *    } );
      */
					"sUrl": "",

					/**
      * Text shown inside the table records when the is no information to be
      * displayed after filtering. `emptyTable` is shown when there is simply no
      * information in the table at all (regardless of filtering).
      *  @type string
      *  @default No matching records found
      *
      *  @dtopt Language
      *  @name DataTable.defaults.language.zeroRecords
      *
      *  @example
      *    $(document).ready( function() {
      *      $('#example').dataTable( {
      *        "language": {
      *          "zeroRecords": "No records to display"
      *        }
      *      } );
      *    } );
      */
					"sZeroRecords": "No matching records found"
				},

				/**
     * This parameter allows you to have define the global filtering state at
     * initialisation time. As an object the `search` parameter must be
     * defined, but all other parameters are optional. When `regex` is true,
     * the search string will be treated as a regular expression, when false
     * (default) it will be treated as a straight string. When `smart`
     * DataTables will use it's smart filtering methods (to word match at
     * any point in the data), when false this will not be done.
     *  @namespace
     *  @extends DataTable.models.oSearch
     *
     *  @dtopt Options
     *  @name DataTable.defaults.search
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "search": {"search": "Initial search"}
     *      } );
     *    } )
     */
				"oSearch": $.extend({}, DataTable.models.oSearch),

				/**
     * __Deprecated__ The functionality provided by this parameter has now been
     * superseded by that provided through `ajax`, which should be used instead.
     *
     * By default DataTables will look for the property `data` (or `aaData` for
     * compatibility with DataTables 1.9-) when obtaining data from an Ajax
     * source or for server-side processing - this parameter allows that
     * property to be changed. You can use Javascript dotted object notation to
     * get a data source for multiple levels of nesting.
     *  @type string
     *  @default data
     *
     *  @dtopt Options
     *  @dtopt Server-side
     *  @name DataTable.defaults.ajaxDataProp
     *
     *  @deprecated 1.10. Please use `ajax` for this functionality now.
     */
				"sAjaxDataProp": "data",

				/**
     * __Deprecated__ The functionality provided by this parameter has now been
     * superseded by that provided through `ajax`, which should be used instead.
     *
     * You can instruct DataTables to load data from an external
     * source using this parameter (use aData if you want to pass data in you
     * already have). Simply provide a url a JSON object can be obtained from.
     *  @type string
     *  @default null
     *
     *  @dtopt Options
     *  @dtopt Server-side
     *  @name DataTable.defaults.ajaxSource
     *
     *  @deprecated 1.10. Please use `ajax` for this functionality now.
     */
				"sAjaxSource": null,

				/**
     * This initialisation variable allows you to specify exactly where in the
     * DOM you want DataTables to inject the various controls it adds to the page
     * (for example you might want the pagination controls at the top of the
     * table). DIV elements (with or without a custom class) can also be added to
     * aid styling. The follow syntax is used:
     *   <ul>
     *     <li>The following options are allowed:
     *       <ul>
     *         <li>'l' - Length changing</li>
     *         <li>'f' - Filtering input</li>
     *         <li>'t' - The table!</li>
     *         <li>'i' - Information</li>
     *         <li>'p' - Pagination</li>
     *         <li>'r' - pRocessing</li>
     *       </ul>
     *     </li>
     *     <li>The following constants are allowed:
     *       <ul>
     *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
     *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
     *       </ul>
     *     </li>
     *     <li>The following syntax is expected:
     *       <ul>
     *         <li>'&lt;' and '&gt;' - div elements</li>
     *         <li>'&lt;"class" and '&gt;' - div with a class</li>
     *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
     *       </ul>
     *     </li>
     *     <li>Examples:
     *       <ul>
     *         <li>'&lt;"wrapper"flipt&gt;'</li>
     *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
     *       </ul>
     *     </li>
     *   </ul>
     *  @type string
     *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
     *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
     *
     *  @dtopt Options
     *  @name DataTable.defaults.dom
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
     *      } );
     *    } );
     */
				"sDom": "lfrtip",

				/**
     * Search delay option. This will throttle full table searches that use the
     * DataTables provided search input element (it does not effect calls to
     * `dt-api search()`, providing a delay before the search is made.
     *  @type integer
     *  @default 0
     *
     *  @dtopt Options
     *  @name DataTable.defaults.searchDelay
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "searchDelay": 200
     *      } );
     *    } )
     */
				"searchDelay": null,

				/**
     * DataTables features six different built-in options for the buttons to
     * display for pagination control:
     *
     * * `numbers` - Page number buttons only
     * * `simple` - 'Previous' and 'Next' buttons only
     * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
     * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
     * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
     * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
     *  
     * Further methods can be added using {@link DataTable.ext.oPagination}.
     *  @type string
     *  @default simple_numbers
     *
     *  @dtopt Options
     *  @name DataTable.defaults.pagingType
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "pagingType": "full_numbers"
     *      } );
     *    } )
     */
				"sPaginationType": "simple_numbers",

				/**
     * Enable horizontal scrolling. When a table is too wide to fit into a
     * certain layout, or you have a large number of columns in the table, you
     * can enable x-scrolling to show the table in a viewport, which can be
     * scrolled. This property can be `true` which will allow the table to
     * scroll horizontally when needed, or any CSS unit, or a number (in which
     * case it will be treated as a pixel measurement). Setting as simply `true`
     * is recommended.
     *  @type boolean|string
     *  @default <i>blank string - i.e. disabled</i>
     *
     *  @dtopt Features
     *  @name DataTable.defaults.scrollX
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "scrollX": true,
     *        "scrollCollapse": true
     *      } );
     *    } );
     */
				"sScrollX": "",

				/**
     * This property can be used to force a DataTable to use more width than it
     * might otherwise do when x-scrolling is enabled. For example if you have a
     * table which requires to be well spaced, this parameter is useful for
     * "over-sizing" the table, and thus forcing scrolling. This property can by
     * any CSS unit, or a number (in which case it will be treated as a pixel
     * measurement).
     *  @type string
     *  @default <i>blank string - i.e. disabled</i>
     *
     *  @dtopt Options
     *  @name DataTable.defaults.scrollXInner
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "scrollX": "100%",
     *        "scrollXInner": "110%"
     *      } );
     *    } );
     */
				"sScrollXInner": "",

				/**
     * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
     * to the given height, and enable scrolling for any data which overflows the
     * current viewport. This can be used as an alternative to paging to display
     * a lot of data in a small area (although paging and scrolling can both be
     * enabled at the same time). This property can be any CSS unit, or a number
     * (in which case it will be treated as a pixel measurement).
     *  @type string
     *  @default <i>blank string - i.e. disabled</i>
     *
     *  @dtopt Features
     *  @name DataTable.defaults.scrollY
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "scrollY": "200px",
     *        "paginate": false
     *      } );
     *    } );
     */
				"sScrollY": "",

				/**
     * __Deprecated__ The functionality provided by this parameter has now been
     * superseded by that provided through `ajax`, which should be used instead.
     *
     * Set the HTTP method that is used to make the Ajax call for server-side
     * processing or Ajax sourced data.
     *  @type string
     *  @default GET
     *
     *  @dtopt Options
     *  @dtopt Server-side
     *  @name DataTable.defaults.serverMethod
     *
     *  @deprecated 1.10. Please use `ajax` for this functionality now.
     */
				"sServerMethod": "GET",

				/**
     * DataTables makes use of renderers when displaying HTML elements for
     * a table. These renderers can be added or modified by plug-ins to
     * generate suitable mark-up for a site. For example the Bootstrap
     * integration plug-in for DataTables uses a paging button renderer to
     * display pagination buttons in the mark-up required by Bootstrap.
     *
     * For further information about the renderers available see
     * DataTable.ext.renderer
     *  @type string|object
     *  @default null
     *
     *  @name DataTable.defaults.renderer
     *
     */
				"renderer": null,

				/**
     * Set the data property name that DataTables should use to get a row's id
     * to set as the `id` property in the node.
     *  @type string
     *  @default DT_RowId
     *
     *  @name DataTable.defaults.rowId
     */
				"rowId": "DT_RowId"
			};

			_fnHungarianMap(DataTable.defaults);

			/*
    * Developer note - See note in model.defaults.js about the use of Hungarian
    * notation and camel case.
    */

			/**
    * Column options that can be given to DataTables at initialisation time.
    *  @namespace
    */
			DataTable.defaults.column = {
				/**
     * Define which column(s) an order will occur on for this column. This
     * allows a column's ordering to take multiple columns into account when
     * doing a sort or use the data from a different column. For example first
     * name / last name columns make sense to do a multi-column sort over the
     * two columns.
     *  @type array|int
     *  @default null <i>Takes the value of the column index automatically</i>
     *
     *  @name DataTable.defaults.column.orderData
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
     *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
     *          { "orderData": 2, "targets": [ 2 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "orderData": [ 0, 1 ] },
     *          { "orderData": [ 1, 0 ] },
     *          { "orderData": 2 },
     *          null,
     *          null
     *        ]
     *      } );
     *    } );
     */
				"aDataSort": null,
				"iDataSort": -1,

				/**
     * You can control the default ordering direction, and even alter the
     * behaviour of the sort handler (i.e. only allow ascending ordering etc)
     * using this parameter.
     *  @type array
     *  @default [ 'asc', 'desc' ]
     *
     *  @name DataTable.defaults.column.orderSequence
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
     *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
     *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          null,
     *          { "orderSequence": [ "asc" ] },
     *          { "orderSequence": [ "desc", "asc", "asc" ] },
     *          { "orderSequence": [ "desc" ] },
     *          null
     *        ]
     *      } );
     *    } );
     */
				"asSorting": ['asc', 'desc'],

				/**
     * Enable or disable filtering on the data in this column.
     *  @type boolean
     *  @default true
     *
     *  @name DataTable.defaults.column.searchable
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "searchable": false, "targets": [ 0 ] }
     *        ] } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "searchable": false },
     *          null,
     *          null,
     *          null,
     *          null
     *        ] } );
     *    } );
     */
				"bSearchable": true,

				/**
     * Enable or disable ordering on this column.
     *  @type boolean
     *  @default true
     *
     *  @name DataTable.defaults.column.orderable
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "orderable": false, "targets": [ 0 ] }
     *        ] } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "orderable": false },
     *          null,
     *          null,
     *          null,
     *          null
     *        ] } );
     *    } );
     */
				"bSortable": true,

				/**
     * Enable or disable the display of this column.
     *  @type boolean
     *  @default true
     *
     *  @name DataTable.defaults.column.visible
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "visible": false, "targets": [ 0 ] }
     *        ] } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "visible": false },
     *          null,
     *          null,
     *          null,
     *          null
     *        ] } );
     *    } );
     */
				"bVisible": true,

				/**
     * Developer definable function that is called whenever a cell is created (Ajax source,
     * etc) or processed for input (DOM source). This can be used as a compliment to mRender
     * allowing you to modify the DOM element (add background colour for example) when the
     * element is available.
     *  @type function
     *  @param {element} td The TD node that has been created
     *  @param {*} cellData The Data for the cell
     *  @param {array|object} rowData The data for the whole row
     *  @param {int} row The row index for the aoData data store
     *  @param {int} col The column index for aoColumns
     *
     *  @name DataTable.defaults.column.createdCell
     *  @dtopt Columns
     *
     *  @example
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [3],
     *          "createdCell": function (td, cellData, rowData, row, col) {
     *            if ( cellData == "1.7" ) {
     *              $(td).css('color', 'blue')
     *            }
     *          }
     *        } ]
     *      });
     *    } );
     */
				"fnCreatedCell": null,

				/**
     * This parameter has been replaced by `data` in DataTables to ensure naming
     * consistency. `dataProp` can still be used, as there is backwards
     * compatibility in DataTables for this option, but it is strongly
     * recommended that you use `data` in preference to `dataProp`.
     *  @name DataTable.defaults.column.dataProp
     */

				/**
     * This property can be used to read data from any data source property,
     * including deeply nested objects / properties. `data` can be given in a
     * number of different ways which effect its behaviour:
     *
     * * `integer` - treated as an array index for the data source. This is the
     *   default that DataTables uses (incrementally increased for each column).
     * * `string` - read an object property from the data source. There are
     *   three 'special' options that can be used in the string to alter how
     *   DataTables reads the data from the source object:
     *    * `.` - Dotted Javascript notation. Just as you use a `.` in
     *      Javascript to read from nested objects, so to can the options
     *      specified in `data`. For example: `browser.version` or
     *      `browser.name`. If your object parameter name contains a period, use
     *      `\\` to escape it - i.e. `first\\.name`.
     *    * `[]` - Array notation. DataTables can automatically combine data
     *      from and array source, joining the data with the characters provided
     *      between the two brackets. For example: `name[, ]` would provide a
     *      comma-space separated list from the source array. If no characters
     *      are provided between the brackets, the original array source is
     *      returned.
     *    * `()` - Function notation. Adding `()` to the end of a parameter will
     *      execute a function of the name given. For example: `browser()` for a
     *      simple function on the data source, `browser.version()` for a
     *      function in a nested property or even `browser().version` to get an
     *      object property if the function called returns an object. Note that
     *      function notation is recommended for use in `render` rather than
     *      `data` as it is much simpler to use as a renderer.
     * * `null` - use the original data source for the row rather than plucking
     *   data directly from it. This action has effects on two other
     *   initialisation options:
     *    * `defaultContent` - When null is given as the `data` option and
     *      `defaultContent` is specified for the column, the value defined by
     *      `defaultContent` will be used for the cell.
     *    * `render` - When null is used for the `data` option and the `render`
     *      option is specified for the column, the whole data source for the
     *      row is used for the renderer.
     * * `function` - the function given will be executed whenever DataTables
     *   needs to set or get the data for a cell in the column. The function
     *   takes three parameters:
     *    * Parameters:
     *      * `{array|object}` The data source for the row
     *      * `{string}` The type call data requested - this will be 'set' when
     *        setting data or 'filter', 'display', 'type', 'sort' or undefined
     *        when gathering data. Note that when `undefined` is given for the
     *        type DataTables expects to get the raw data for the object back<
     *      * `{*}` Data to set when the second parameter is 'set'.
     *    * Return:
     *      * The return value from the function is not required when 'set' is
     *        the type of call, but otherwise the return is what will be used
     *        for the data requested.
     *
     * Note that `data` is a getter and setter option. If you just require
     * formatting of data for output, you will likely want to use `render` which
     * is simply a getter and thus simpler to use.
     *
     * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
     * name change reflects the flexibility of this property and is consistent
     * with the naming of mRender. If 'mDataProp' is given, then it will still
     * be used by DataTables, as it automatically maps the old name to the new
     * if required.
     *
     *  @type string|int|function|null
     *  @default null <i>Use automatically calculated column index</i>
     *
     *  @name DataTable.defaults.column.data
     *  @dtopt Columns
     *
     *  @example
     *    // Read table data from objects
     *    // JSON structure for each row:
     *    //   {
     *    //      "engine": {value},
     *    //      "browser": {value},
     *    //      "platform": {value},
     *    //      "version": {value},
     *    //      "grade": {value}
     *    //   }
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "ajaxSource": "sources/objects.txt",
     *        "columns": [
     *          { "data": "engine" },
     *          { "data": "browser" },
     *          { "data": "platform" },
     *          { "data": "version" },
     *          { "data": "grade" }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Read information from deeply nested objects
     *    // JSON structure for each row:
     *    //   {
     *    //      "engine": {value},
     *    //      "browser": {value},
     *    //      "platform": {
     *    //         "inner": {value}
     *    //      },
     *    //      "details": [
     *    //         {value}, {value}
     *    //      ]
     *    //   }
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "ajaxSource": "sources/deep.txt",
     *        "columns": [
     *          { "data": "engine" },
     *          { "data": "browser" },
     *          { "data": "platform.inner" },
     *          { "data": "details.0" },
     *          { "data": "details.1" }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `data` as a function to provide different information for
     *    // sorting, filtering and display. In this case, currency (price)
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": function ( source, type, val ) {
     *            if (type === 'set') {
     *              source.price = val;
     *              // Store the computed dislay and filter values for efficiency
     *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
     *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
     *              return;
     *            }
     *            else if (type === 'display') {
     *              return source.price_display;
     *            }
     *            else if (type === 'filter') {
     *              return source.price_filter;
     *            }
     *            // 'sort', 'type' and undefined all just use the integer
     *            return source.price;
     *          }
     *        } ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using default content
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": null,
     *          "defaultContent": "Click to edit"
     *        } ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using array notation - outputting a list from an array
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": "name[, ]"
     *        } ]
     *      } );
     *    } );
     *
     */
				"mData": null,

				/**
     * This property is the rendering partner to `data` and it is suggested that
     * when you want to manipulate data for display (including filtering,
     * sorting etc) without altering the underlying data for the table, use this
     * property. `render` can be considered to be the the read only companion to
     * `data` which is read / write (then as such more complex). Like `data`
     * this option can be given in a number of different ways to effect its
     * behaviour:
     *
     * * `integer` - treated as an array index for the data source. This is the
     *   default that DataTables uses (incrementally increased for each column).
     * * `string` - read an object property from the data source. There are
     *   three 'special' options that can be used in the string to alter how
     *   DataTables reads the data from the source object:
     *    * `.` - Dotted Javascript notation. Just as you use a `.` in
     *      Javascript to read from nested objects, so to can the options
     *      specified in `data`. For example: `browser.version` or
     *      `browser.name`. If your object parameter name contains a period, use
     *      `\\` to escape it - i.e. `first\\.name`.
     *    * `[]` - Array notation. DataTables can automatically combine data
     *      from and array source, joining the data with the characters provided
     *      between the two brackets. For example: `name[, ]` would provide a
     *      comma-space separated list from the source array. If no characters
     *      are provided between the brackets, the original array source is
     *      returned.
     *    * `()` - Function notation. Adding `()` to the end of a parameter will
     *      execute a function of the name given. For example: `browser()` for a
     *      simple function on the data source, `browser.version()` for a
     *      function in a nested property or even `browser().version` to get an
     *      object property if the function called returns an object.
     * * `object` - use different data for the different data types requested by
     *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
     *   of the object is the data type the property refers to and the value can
     *   defined using an integer, string or function using the same rules as
     *   `render` normally does. Note that an `_` option _must_ be specified.
     *   This is the default value to use if you haven't specified a value for
     *   the data type requested by DataTables.
     * * `function` - the function given will be executed whenever DataTables
     *   needs to set or get the data for a cell in the column. The function
     *   takes three parameters:
     *    * Parameters:
     *      * {array|object} The data source for the row (based on `data`)
     *      * {string} The type call data requested - this will be 'filter',
     *        'display', 'type' or 'sort'.
     *      * {array|object} The full data source for the row (not based on
     *        `data`)
     *    * Return:
     *      * The return value from the function is what will be used for the
     *        data requested.
     *
     *  @type string|int|function|object|null
     *  @default null Use the data source value.
     *
     *  @name DataTable.defaults.column.render
     *  @dtopt Columns
     *
     *  @example
     *    // Create a comma separated list from an array of objects
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "ajaxSource": "sources/deep.txt",
     *        "columns": [
     *          { "data": "engine" },
     *          { "data": "browser" },
     *          {
     *            "data": "platform",
     *            "render": "[, ].name"
     *          }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Execute a function to obtain data
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": null, // Use the full data source object for the renderer's source
     *          "render": "browserName()"
     *        } ]
     *      } );
     *    } );
     *
     *  @example
     *    // As an object, extracting different data for the different types
     *    // This would be used with a data source such as:
     *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
     *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
     *    // (which has both forms) is used for filtering for if a user inputs either format, while
     *    // the formatted phone number is the one that is shown in the table.
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": null, // Use the full data source object for the renderer's source
     *          "render": {
     *            "_": "phone",
     *            "filter": "phone_filter",
     *            "display": "phone_display"
     *          }
     *        } ]
     *      } );
     *    } );
     *
     *  @example
     *    // Use as a function to create a link from the data source
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "data": "download_link",
     *          "render": function ( data, type, full ) {
     *            return '<a href="'+data+'">Download</a>';
     *          }
     *        } ]
     *      } );
     *    } );
     */
				"mRender": null,

				/**
     * Change the cell type created for the column - either TD cells or TH cells. This
     * can be useful as TH cells have semantic meaning in the table body, allowing them
     * to act as a header for a row (you may wish to add scope='row' to the TH elements).
     *  @type string
     *  @default td
     *
     *  @name DataTable.defaults.column.cellType
     *  @dtopt Columns
     *
     *  @example
     *    // Make the first column use TH cells
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [ {
     *          "targets": [ 0 ],
     *          "cellType": "th"
     *        } ]
     *      } );
     *    } );
     */
				"sCellType": "td",

				/**
     * Class to give to each cell in this column.
     *  @type string
     *  @default <i>Empty string</i>
     *
     *  @name DataTable.defaults.column.class
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "class": "my_class", "targets": [ 0 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "class": "my_class" },
     *          null,
     *          null,
     *          null,
     *          null
     *        ]
     *      } );
     *    } );
     */
				"sClass": "",

				/**
     * When DataTables calculates the column widths to assign to each column,
     * it finds the longest string in each column and then constructs a
     * temporary table and reads the widths from that. The problem with this
     * is that "mmm" is much wider then "iiii", but the latter is a longer
     * string - thus the calculation can go wrong (doing it properly and putting
     * it into an DOM object and measuring that is horribly(!) slow). Thus as
     * a "work around" we provide this option. It will append its value to the
     * text that is found to be the longest string for the column - i.e. padding.
     * Generally you shouldn't need this!
     *  @type string
     *  @default <i>Empty string<i>
     *
     *  @name DataTable.defaults.column.contentPadding
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          null,
     *          null,
     *          null,
     *          {
     *            "contentPadding": "mmm"
     *          }
     *        ]
     *      } );
     *    } );
     */
				"sContentPadding": "",

				/**
     * Allows a default value to be given for a column's data, and will be used
     * whenever a null data source is encountered (this can be because `data`
     * is set to null, or because the data source itself is null).
     *  @type string
     *  @default null
     *
     *  @name DataTable.defaults.column.defaultContent
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          {
     *            "data": null,
     *            "defaultContent": "Edit",
     *            "targets": [ -1 ]
     *          }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          null,
     *          null,
     *          null,
     *          {
     *            "data": null,
     *            "defaultContent": "Edit"
     *          }
     *        ]
     *      } );
     *    } );
     */
				"sDefaultContent": null,

				/**
     * This parameter is only used in DataTables' server-side processing. It can
     * be exceptionally useful to know what columns are being displayed on the
     * client side, and to map these to database fields. When defined, the names
     * also allow DataTables to reorder information from the server if it comes
     * back in an unexpected order (i.e. if you switch your columns around on the
     * client-side, your server-side code does not also need updating).
     *  @type string
     *  @default <i>Empty string</i>
     *
     *  @name DataTable.defaults.column.name
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "name": "engine", "targets": [ 0 ] },
     *          { "name": "browser", "targets": [ 1 ] },
     *          { "name": "platform", "targets": [ 2 ] },
     *          { "name": "version", "targets": [ 3 ] },
     *          { "name": "grade", "targets": [ 4 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "name": "engine" },
     *          { "name": "browser" },
     *          { "name": "platform" },
     *          { "name": "version" },
     *          { "name": "grade" }
     *        ]
     *      } );
     *    } );
     */
				"sName": "",

				/**
     * Defines a data source type for the ordering which can be used to read
     * real-time information from the table (updating the internally cached
     * version) prior to ordering. This allows ordering to occur on user
     * editable elements such as form inputs.
     *  @type string
     *  @default std
     *
     *  @name DataTable.defaults.column.orderDataType
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
     *          { "type": "numeric", "targets": [ 3 ] },
     *          { "orderDataType": "dom-select", "targets": [ 4 ] },
     *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          null,
     *          null,
     *          { "orderDataType": "dom-text" },
     *          { "orderDataType": "dom-text", "type": "numeric" },
     *          { "orderDataType": "dom-select" },
     *          { "orderDataType": "dom-checkbox" }
     *        ]
     *      } );
     *    } );
     */
				"sSortDataType": "std",

				/**
     * The title of this column.
     *  @type string
     *  @default null <i>Derived from the 'TH' value for this column in the
     *    original HTML table.</i>
     *
     *  @name DataTable.defaults.column.title
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "title": "My column title", "targets": [ 0 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "title": "My column title" },
     *          null,
     *          null,
     *          null,
     *          null
     *        ]
     *      } );
     *    } );
     */
				"sTitle": null,

				/**
     * The type allows you to specify how the data for this column will be
     * ordered. Four types (string, numeric, date and html (which will strip
     * HTML tags before ordering)) are currently available. Note that only date
     * formats understood by Javascript's Date() object will be accepted as type
     * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
     * 'numeric', 'date' or 'html' (by default). Further types can be adding
     * through plug-ins.
     *  @type string
     *  @default null <i>Auto-detected from raw data</i>
     *
     *  @name DataTable.defaults.column.type
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "type": "html", "targets": [ 0 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "type": "html" },
     *          null,
     *          null,
     *          null,
     *          null
     *        ]
     *      } );
     *    } );
     */
				"sType": null,

				/**
     * Defining the width of the column, this parameter may take any CSS value
     * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
     * been given a specific width through this interface ensuring that the table
     * remains readable.
     *  @type string
     *  @default null <i>Automatic</i>
     *
     *  @name DataTable.defaults.column.width
     *  @dtopt Columns
     *
     *  @example
     *    // Using `columnDefs`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columnDefs": [
     *          { "width": "20%", "targets": [ 0 ] }
     *        ]
     *      } );
     *    } );
     *
     *  @example
     *    // Using `columns`
     *    $(document).ready( function() {
     *      $('#example').dataTable( {
     *        "columns": [
     *          { "width": "20%" },
     *          null,
     *          null,
     *          null,
     *          null
     *        ]
     *      } );
     *    } );
     */
				"sWidth": null
			};

			_fnHungarianMap(DataTable.defaults.column);

			/**
    * DataTables settings object - this holds all the information needed for a
    * given table, including configuration, data and current application of the
    * table options. DataTables does not have a single instance for each DataTable
    * with the settings attached to that instance, but rather instances of the
    * DataTable "class" are created on-the-fly as needed (typically by a
    * $().dataTable() call) and the settings object is then applied to that
    * instance.
    *
    * Note that this object is related to {@link DataTable.defaults} but this
    * one is the internal data store for DataTables's cache of columns. It should
    * NOT be manipulated outside of DataTables. Any configuration should be done
    * through the initialisation options.
    *  @namespace
    *  @todo Really should attach the settings object to individual instances so we
    *    don't need to create new instances on each $().dataTable() call (if the
    *    table already exists). It would also save passing oSettings around and
    *    into every single function. However, this is a very significant
    *    architecture change for DataTables and will almost certainly break
    *    backwards compatibility with older installations. This is something that
    *    will be done in 2.0.
    */
			DataTable.models.oSettings = {
				/**
     * Primary features of DataTables and their enablement state.
     *  @namespace
     */
				"oFeatures": {

					/**
      * Flag to say if DataTables should automatically try to calculate the
      * optimum table and columns widths (true) or not (false).
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bAutoWidth": null,

					/**
      * Delay the creation of TR and TD elements until they are actually
      * needed by a driven page draw. This can give a significant speed
      * increase for Ajax source and Javascript source data, but makes no
      * difference at all fro DOM and server-side processing tables.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bDeferRender": null,

					/**
      * Enable filtering on the table or not. Note that if this is disabled
      * then there is no filtering at all on the table, including fnFilter.
      * To just remove the filtering input use sDom and remove the 'f' option.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bFilter": null,

					/**
      * Table information element (the 'Showing x of y records' div) enable
      * flag.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bInfo": null,

					/**
      * Present a user control allowing the end user to change the page size
      * when pagination is enabled.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bLengthChange": null,

					/**
      * Pagination enabled or not. Note that if this is disabled then length
      * changing must also be disabled.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bPaginate": null,

					/**
      * Processing indicator enable flag whenever DataTables is enacting a
      * user request - typically an Ajax request for server-side processing.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bProcessing": null,

					/**
      * Server-side processing enabled flag - when enabled DataTables will
      * get all data from the server for every draw - there is no filtering,
      * sorting or paging done on the client-side.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bServerSide": null,

					/**
      * Sorting enablement flag.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bSort": null,

					/**
      * Multi-column sorting
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bSortMulti": null,

					/**
      * Apply a class to the columns which are being sorted to provide a
      * visual highlight or not. This can slow things down when enabled since
      * there is a lot of DOM interaction.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bSortClasses": null,

					/**
      * State saving enablement flag.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bStateSave": null
				},

				/**
     * Scrolling settings for a table.
     *  @namespace
     */
				"oScroll": {
					/**
      * When the table is shorter in height than sScrollY, collapse the
      * table container down to the height of the table (when true).
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type boolean
      */
					"bCollapse": null,

					/**
      * Width of the scrollbar for the web-browser's platform. Calculated
      * during table initialisation.
      *  @type int
      *  @default 0
      */
					"iBarWidth": 0,

					/**
      * Viewport width for horizontal scrolling. Horizontal scrolling is
      * disabled if an empty string.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type string
      */
					"sX": null,

					/**
      * Width to expand the table to when using x-scrolling. Typically you
      * should not need to use this.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type string
      *  @deprecated
      */
					"sXInner": null,

					/**
      * Viewport height for vertical scrolling. Vertical scrolling is disabled
      * if an empty string.
      * Note that this parameter will be set by the initialisation routine. To
      * set a default use {@link DataTable.defaults}.
      *  @type string
      */
					"sY": null
				},

				/**
     * Language information for the table.
     *  @namespace
     *  @extends DataTable.defaults.oLanguage
     */
				"oLanguage": {
					/**
      * Information callback function. See
      * {@link DataTable.defaults.fnInfoCallback}
      *  @type function
      *  @default null
      */
					"fnInfoCallback": null
				},

				/**
     * Browser support parameters
     *  @namespace
     */
				"oBrowser": {
					/**
      * Indicate if the browser incorrectly calculates width:100% inside a
      * scrolling element (IE6/7)
      *  @type boolean
      *  @default false
      */
					"bScrollOversize": false,

					/**
      * Determine if the vertical scrollbar is on the right or left of the
      * scrolling container - needed for rtl language layout, although not
      * all browsers move the scrollbar (Safari).
      *  @type boolean
      *  @default false
      */
					"bScrollbarLeft": false,

					/**
      * Flag for if `getBoundingClientRect` is fully supported or not
      *  @type boolean
      *  @default false
      */
					"bBounding": false,

					/**
      * Browser scrollbar width
      *  @type integer
      *  @default 0
      */
					"barWidth": 0
				},

				"ajax": null,

				/**
     * Array referencing the nodes which are used for the features. The
     * parameters of this object match what is allowed by sDom - i.e.
     *   <ul>
     *     <li>'l' - Length changing</li>
     *     <li>'f' - Filtering input</li>
     *     <li>'t' - The table!</li>
     *     <li>'i' - Information</li>
     *     <li>'p' - Pagination</li>
     *     <li>'r' - pRocessing</li>
     *   </ul>
     *  @type array
     *  @default []
     */
				"aanFeatures": [],

				/**
     * Store data information - see {@link DataTable.models.oRow} for detailed
     * information.
     *  @type array
     *  @default []
     */
				"aoData": [],

				/**
     * Array of indexes which are in the current display (after filtering etc)
     *  @type array
     *  @default []
     */
				"aiDisplay": [],

				/**
     * Array of indexes for display - no filtering
     *  @type array
     *  @default []
     */
				"aiDisplayMaster": [],

				/**
     * Map of row ids to data indexes
     *  @type object
     *  @default {}
     */
				"aIds": {},

				/**
     * Store information about each column that is in use
     *  @type array
     *  @default []
     */
				"aoColumns": [],

				/**
     * Store information about the table's header
     *  @type array
     *  @default []
     */
				"aoHeader": [],

				/**
     * Store information about the table's footer
     *  @type array
     *  @default []
     */
				"aoFooter": [],

				/**
     * Store the applied global search information in case we want to force a
     * research or compare the old search to a new one.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @namespace
     *  @extends DataTable.models.oSearch
     */
				"oPreviousSearch": {},

				/**
     * Store the applied search for each column - see
     * {@link DataTable.models.oSearch} for the format that is used for the
     * filtering information for each column.
     *  @type array
     *  @default []
     */
				"aoPreSearchCols": [],

				/**
     * Sorting that is applied to the table. Note that the inner arrays are
     * used in the following manner:
     * <ul>
     *   <li>Index 0 - column number</li>
     *   <li>Index 1 - current sorting direction</li>
     * </ul>
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type array
     *  @todo These inner arrays should really be objects
     */
				"aaSorting": null,

				/**
     * Sorting that is always applied to the table (i.e. prefixed in front of
     * aaSorting).
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type array
     *  @default []
     */
				"aaSortingFixed": [],

				/**
     * Classes to use for the striping of a table.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type array
     *  @default []
     */
				"asStripeClasses": null,

				/**
     * If restoring a table - we should restore its striping classes as well
     *  @type array
     *  @default []
     */
				"asDestroyStripes": [],

				/**
     * If restoring a table - we should restore its width
     *  @type int
     *  @default 0
     */
				"sDestroyWidth": 0,

				/**
     * Callback functions array for every time a row is inserted (i.e. on a draw).
     *  @type array
     *  @default []
     */
				"aoRowCallback": [],

				/**
     * Callback functions for the header on each draw.
     *  @type array
     *  @default []
     */
				"aoHeaderCallback": [],

				/**
     * Callback function for the footer on each draw.
     *  @type array
     *  @default []
     */
				"aoFooterCallback": [],

				/**
     * Array of callback functions for draw callback functions
     *  @type array
     *  @default []
     */
				"aoDrawCallback": [],

				/**
     * Array of callback functions for row created function
     *  @type array
     *  @default []
     */
				"aoRowCreatedCallback": [],

				/**
     * Callback functions for just before the table is redrawn. A return of
     * false will be used to cancel the draw.
     *  @type array
     *  @default []
     */
				"aoPreDrawCallback": [],

				/**
     * Callback functions for when the table has been initialised.
     *  @type array
     *  @default []
     */
				"aoInitComplete": [],

				/**
     * Callbacks for modifying the settings to be stored for state saving, prior to
     * saving state.
     *  @type array
     *  @default []
     */
				"aoStateSaveParams": [],

				/**
     * Callbacks for modifying the settings that have been stored for state saving
     * prior to using the stored values to restore the state.
     *  @type array
     *  @default []
     */
				"aoStateLoadParams": [],

				/**
     * Callbacks for operating on the settings object once the saved state has been
     * loaded
     *  @type array
     *  @default []
     */
				"aoStateLoaded": [],

				/**
     * Cache the table ID for quick access
     *  @type string
     *  @default <i>Empty string</i>
     */
				"sTableId": "",

				/**
     * The TABLE node for the main table
     *  @type node
     *  @default null
     */
				"nTable": null,

				/**
     * Permanent ref to the thead element
     *  @type node
     *  @default null
     */
				"nTHead": null,

				/**
     * Permanent ref to the tfoot element - if it exists
     *  @type node
     *  @default null
     */
				"nTFoot": null,

				/**
     * Permanent ref to the tbody element
     *  @type node
     *  @default null
     */
				"nTBody": null,

				/**
     * Cache the wrapper node (contains all DataTables controlled elements)
     *  @type node
     *  @default null
     */
				"nTableWrapper": null,

				/**
     * Indicate if when using server-side processing the loading of data
     * should be deferred until the second draw.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type boolean
     *  @default false
     */
				"bDeferLoading": false,

				/**
     * Indicate if all required information has been read in
     *  @type boolean
     *  @default false
     */
				"bInitialised": false,

				/**
     * Information about open rows. Each object in the array has the parameters
     * 'nTr' and 'nParent'
     *  @type array
     *  @default []
     */
				"aoOpenRows": [],

				/**
     * Dictate the positioning of DataTables' control elements - see
     * {@link DataTable.model.oInit.sDom}.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type string
     *  @default null
     */
				"sDom": null,

				/**
     * Search delay (in mS)
     *  @type integer
     *  @default null
     */
				"searchDelay": null,

				/**
     * Which type of pagination should be used.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type string
     *  @default two_button
     */
				"sPaginationType": "two_button",

				/**
     * The state duration (for `stateSave`) in seconds.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type int
     *  @default 0
     */
				"iStateDuration": 0,

				/**
     * Array of callback functions for state saving. Each array element is an
     * object with the following parameters:
     *   <ul>
     *     <li>function:fn - function to call. Takes two parameters, oSettings
     *       and the JSON string to save that has been thus far created. Returns
     *       a JSON string to be inserted into a json object
     *       (i.e. '"param": [ 0, 1, 2]')</li>
     *     <li>string:sName - name of callback</li>
     *   </ul>
     *  @type array
     *  @default []
     */
				"aoStateSave": [],

				/**
     * Array of callback functions for state loading. Each array element is an
     * object with the following parameters:
     *   <ul>
     *     <li>function:fn - function to call. Takes two parameters, oSettings
     *       and the object stored. May return false to cancel state loading</li>
     *     <li>string:sName - name of callback</li>
     *   </ul>
     *  @type array
     *  @default []
     */
				"aoStateLoad": [],

				/**
     * State that was saved. Useful for back reference
     *  @type object
     *  @default null
     */
				"oSavedState": null,

				/**
     * State that was loaded. Useful for back reference
     *  @type object
     *  @default null
     */
				"oLoadedState": null,

				/**
     * Source url for AJAX data for the table.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type string
     *  @default null
     */
				"sAjaxSource": null,

				/**
     * Property from a given object from which to read the table data from. This
     * can be an empty string (when not server-side processing), in which case
     * it is  assumed an an array is given directly.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type string
     */
				"sAjaxDataProp": null,

				/**
     * Note if draw should be blocked while getting data
     *  @type boolean
     *  @default true
     */
				"bAjaxDataGet": true,

				/**
     * The last jQuery XHR object that was used for server-side data gathering.
     * This can be used for working with the XHR information in one of the
     * callbacks
     *  @type object
     *  @default null
     */
				"jqXHR": null,

				/**
     * JSON returned from the server in the last Ajax request
     *  @type object
     *  @default undefined
     */
				"json": undefined,

				/**
     * Data submitted as part of the last Ajax request
     *  @type object
     *  @default undefined
     */
				"oAjaxData": undefined,

				/**
     * Function to get the server-side data.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type function
     */
				"fnServerData": null,

				/**
     * Functions which are called prior to sending an Ajax request so extra
     * parameters can easily be sent to the server
     *  @type array
     *  @default []
     */
				"aoServerParams": [],

				/**
     * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
     * required).
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type string
     */
				"sServerMethod": null,

				/**
     * Format numbers for display.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type function
     */
				"fnFormatNumber": null,

				/**
     * List of options that can be used for the user selectable length menu.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type array
     *  @default []
     */
				"aLengthMenu": null,

				/**
     * Counter for the draws that the table does. Also used as a tracker for
     * server-side processing
     *  @type int
     *  @default 0
     */
				"iDraw": 0,

				/**
     * Indicate if a redraw is being done - useful for Ajax
     *  @type boolean
     *  @default false
     */
				"bDrawing": false,

				/**
     * Draw index (iDraw) of the last error when parsing the returned data
     *  @type int
     *  @default -1
     */
				"iDrawError": -1,

				/**
     * Paging display length
     *  @type int
     *  @default 10
     */
				"_iDisplayLength": 10,

				/**
     * Paging start point - aiDisplay index
     *  @type int
     *  @default 0
     */
				"_iDisplayStart": 0,

				/**
     * Server-side processing - number of records in the result set
     * (i.e. before filtering), Use fnRecordsTotal rather than
     * this property to get the value of the number of records, regardless of
     * the server-side processing setting.
     *  @type int
     *  @default 0
     *  @private
     */
				"_iRecordsTotal": 0,

				/**
     * Server-side processing - number of records in the current display set
     * (i.e. after filtering). Use fnRecordsDisplay rather than
     * this property to get the value of the number of records, regardless of
     * the server-side processing setting.
     *  @type boolean
     *  @default 0
     *  @private
     */
				"_iRecordsDisplay": 0,

				/**
     * The classes to use for the table
     *  @type object
     *  @default {}
     */
				"oClasses": {},

				/**
     * Flag attached to the settings object so you can check in the draw
     * callback if filtering has been done in the draw. Deprecated in favour of
     * events.
     *  @type boolean
     *  @default false
     *  @deprecated
     */
				"bFiltered": false,

				/**
     * Flag attached to the settings object so you can check in the draw
     * callback if sorting has been done in the draw. Deprecated in favour of
     * events.
     *  @type boolean
     *  @default false
     *  @deprecated
     */
				"bSorted": false,

				/**
     * Indicate that if multiple rows are in the header and there is more than
     * one unique cell per column, if the top one (true) or bottom one (false)
     * should be used for sorting / title by DataTables.
     * Note that this parameter will be set by the initialisation routine. To
     * set a default use {@link DataTable.defaults}.
     *  @type boolean
     */
				"bSortCellsTop": null,

				/**
     * Initialisation object that is used for the table
     *  @type object
     *  @default null
     */
				"oInit": null,

				/**
     * Destroy callback functions - for plug-ins to attach themselves to the
     * destroy so they can clean up markup and events.
     *  @type array
     *  @default []
     */
				"aoDestroyCallback": [],

				/**
     * Get the number of records in the current record set, before filtering
     *  @type function
     */
				"fnRecordsTotal": function () {
					return _fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
				},

				/**
     * Get the number of records in the current record set, after filtering
     *  @type function
     */
				"fnRecordsDisplay": function () {
					return _fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
				},

				/**
     * Get the display end point - aiDisplay index
     *  @type function
     */
				"fnDisplayEnd": function () {
					var len = this._iDisplayLength,
					    start = this._iDisplayStart,
					    calc = start + len,
					    records = this.aiDisplay.length,
					    features = this.oFeatures,
					    paginate = features.bPaginate;

					if (features.bServerSide) {
						return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
					} else {
						return !paginate || calc > records || len === -1 ? records : calc;
					}
				},

				/**
     * The DataTables object for this table
     *  @type object
     *  @default null
     */
				"oInstance": null,

				/**
     * Unique identifier for each instance of the DataTables object. If there
     * is an ID on the table node, then it takes that value, otherwise an
     * incrementing internal counter is used.
     *  @type string
     *  @default null
     */
				"sInstance": null,

				/**
     * tabindex attribute value that is added to DataTables control elements, allowing
     * keyboard navigation of the table and its controls.
     */
				"iTabIndex": 0,

				/**
     * DIV container for the footer scrolling table if scrolling
     */
				"nScrollHead": null,

				/**
     * DIV container for the footer scrolling table if scrolling
     */
				"nScrollFoot": null,

				/**
     * Last applied sort
     *  @type array
     *  @default []
     */
				"aLastSort": [],

				/**
     * Stored plug-in instances
     *  @type object
     *  @default {}
     */
				"oPlugins": {},

				/**
     * Function used to get a row's id from the row's data
     *  @type function
     *  @default null
     */
				"rowIdFn": null,

				/**
     * Data location where to store a row's id
     *  @type string
     *  @default null
     */
				"rowId": null
			};

			/**
    * Extension object for DataTables that is used to provide all extension
    * options.
    *
    * Note that the `DataTable.ext` object is available through
    * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
    * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
    *  @namespace
    *  @extends DataTable.models.ext
    */

			/**
    * DataTables extensions
    * 
    * This namespace acts as a collection area for plug-ins that can be used to
    * extend DataTables capabilities. Indeed many of the build in methods
    * use this method to provide their own capabilities (sorting methods for
    * example).
    *
    * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
    * reasons
    *
    *  @namespace
    */
			DataTable.ext = _ext = {
				/**
     * Buttons. For use with the Buttons extension for DataTables. This is
     * defined here so other extensions can define buttons regardless of load
     * order. It is _not_ used by DataTables core.
     *
     *  @type object
     *  @default {}
     */
				buttons: {},

				/**
     * Element class names
     *
     *  @type object
     *  @default {}
     */
				classes: {},

				/**
     * DataTables build type (expanded by the download builder)
     *
     *  @type string
     */
				builder: "-source-",

				/**
     * Error reporting.
     * 
     * How should DataTables report an error. Can take the value 'alert',
     * 'throw', 'none' or a function.
     *
     *  @type string|function
     *  @default alert
     */
				errMode: "alert",

				/**
     * Feature plug-ins.
     * 
     * This is an array of objects which describe the feature plug-ins that are
     * available to DataTables. These feature plug-ins are then available for
     * use through the `dom` initialisation option.
     * 
     * Each feature plug-in is described by an object which must have the
     * following properties:
     * 
     * * `fnInit` - function that is used to initialise the plug-in,
     * * `cFeature` - a character so the feature can be enabled by the `dom`
     *   instillation option. This is case sensitive.
     *
     * The `fnInit` function has the following input parameters:
     *
     * 1. `{object}` DataTables settings object: see
     *    {@link DataTable.models.oSettings}
     *
     * And the following return is expected:
     * 
     * * {node|null} The element which contains your feature. Note that the
     *   return may also be void if your plug-in does not require to inject any
     *   DOM elements into DataTables control (`dom`) - for example this might
     *   be useful when developing a plug-in which allows table control via
     *   keyboard entry
     *
     *  @type array
     *
     *  @example
     *    $.fn.dataTable.ext.features.push( {
     *      "fnInit": function( oSettings ) {
     *        return new TableTools( { "oDTSettings": oSettings } );
     *      },
     *      "cFeature": "T"
     *    } );
     */
				feature: [],

				/**
     * Row searching.
     * 
     * This method of searching is complimentary to the default type based
     * searching, and a lot more comprehensive as it allows you complete control
     * over the searching logic. Each element in this array is a function
     * (parameters described below) that is called for every row in the table,
     * and your logic decides if it should be included in the searching data set
     * or not.
     *
     * Searching functions have the following input parameters:
     *
     * 1. `{object}` DataTables settings object: see
     *    {@link DataTable.models.oSettings}
     * 2. `{array|object}` Data for the row to be processed (same as the
     *    original format that was passed in as the data source, or an array
     *    from a DOM data source
     * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
     *    can be useful to retrieve the `TR` element if you need DOM interaction.
     *
     * And the following return is expected:
     *
     * * {boolean} Include the row in the searched result set (true) or not
     *   (false)
     *
     * Note that as with the main search ability in DataTables, technically this
     * is "filtering", since it is subtractive. However, for consistency in
     * naming we call it searching here.
     *
     *  @type array
     *  @default []
     *
     *  @example
     *    // The following example shows custom search being applied to the
     *    // fourth column (i.e. the data[3] index) based on two input values
     *    // from the end-user, matching the data in a certain range.
     *    $.fn.dataTable.ext.search.push(
     *      function( settings, data, dataIndex ) {
     *        var min = document.getElementById('min').value * 1;
     *        var max = document.getElementById('max').value * 1;
     *        var version = data[3] == "-" ? 0 : data[3]*1;
     *
     *        if ( min == "" && max == "" ) {
     *          return true;
     *        }
     *        else if ( min == "" && version < max ) {
     *          return true;
     *        }
     *        else if ( min < version && "" == max ) {
     *          return true;
     *        }
     *        else if ( min < version && version < max ) {
     *          return true;
     *        }
     *        return false;
     *      }
     *    );
     */
				search: [],

				/**
     * Selector extensions
     *
     * The `selector` option can be used to extend the options available for the
     * selector modifier options (`selector-modifier` object data type) that
     * each of the three built in selector types offer (row, column and cell +
     * their plural counterparts). For example the Select extension uses this
     * mechanism to provide an option to select only rows, columns and cells
     * that have been marked as selected by the end user (`{selected: true}`),
     * which can be used in conjunction with the existing built in selector
     * options.
     *
     * Each property is an array to which functions can be pushed. The functions
     * take three attributes:
     *
     * * Settings object for the host table
     * * Options object (`selector-modifier` object type)
     * * Array of selected item indexes
     *
     * The return is an array of the resulting item indexes after the custom
     * selector has been applied.
     *
     *  @type object
     */
				selector: {
					cell: [],
					column: [],
					row: []
				},

				/**
     * Internal functions, exposed for used in plug-ins.
     * 
     * Please note that you should not need to use the internal methods for
     * anything other than a plug-in (and even then, try to avoid if possible).
     * The internal function may change between releases.
     *
     *  @type object
     *  @default {}
     */
				internal: {},

				/**
     * Legacy configuration options. Enable and disable legacy options that
     * are available in DataTables.
     *
     *  @type object
     */
				legacy: {
					/**
      * Enable / disable DataTables 1.9 compatible server-side processing
      * requests
      *
      *  @type boolean
      *  @default null
      */
					ajax: null
				},

				/**
     * Pagination plug-in methods.
     * 
     * Each entry in this object is a function and defines which buttons should
     * be shown by the pagination rendering method that is used for the table:
     * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
     * buttons are displayed in the document, while the functions here tell it
     * what buttons to display. This is done by returning an array of button
     * descriptions (what each button will do).
     *
     * Pagination types (the four built in options and any additional plug-in
     * options defined here) can be used through the `paginationType`
     * initialisation parameter.
     *
     * The functions defined take two parameters:
     *
     * 1. `{int} page` The current page index
     * 2. `{int} pages` The number of pages in the table
     *
     * Each function is expected to return an array where each element of the
     * array can be one of:
     *
     * * `first` - Jump to first page when activated
     * * `last` - Jump to last page when activated
     * * `previous` - Show previous page when activated
     * * `next` - Show next page when activated
     * * `{int}` - Show page of the index given
     * * `{array}` - A nested array containing the above elements to add a
     *   containing 'DIV' element (might be useful for styling).
     *
     * Note that DataTables v1.9- used this object slightly differently whereby
     * an object with two functions would be defined for each plug-in. That
     * ability is still supported by DataTables 1.10+ to provide backwards
     * compatibility, but this option of use is now decremented and no longer
     * documented in DataTables 1.10+.
     *
     *  @type object
     *  @default {}
     *
     *  @example
     *    // Show previous, next and current page buttons only
     *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
     *      return [ 'previous', page, 'next' ];
     *    };
     */
				pager: {},

				renderer: {
					pageButton: {},
					header: {}
				},

				/**
     * Ordering plug-ins - custom data source
     * 
     * The extension options for ordering of data available here is complimentary
     * to the default type based ordering that DataTables typically uses. It
     * allows much greater control over the the data that is being used to
     * order a column, but is necessarily therefore more complex.
     * 
     * This type of ordering is useful if you want to do ordering based on data
     * live from the DOM (for example the contents of an 'input' element) rather
     * than just the static string that DataTables knows of.
     * 
     * The way these plug-ins work is that you create an array of the values you
     * wish to be ordering for the column in question and then return that
     * array. The data in the array much be in the index order of the rows in
     * the table (not the currently ordering order!). Which order data gathering
     * function is run here depends on the `dt-init columns.orderDataType`
     * parameter that is used for the column (if any).
     *
     * The functions defined take two parameters:
     *
     * 1. `{object}` DataTables settings object: see
     *    {@link DataTable.models.oSettings}
     * 2. `{int}` Target column index
     *
     * Each function is expected to return an array:
     *
     * * `{array}` Data for the column to be ordering upon
     *
     *  @type array
     *
     *  @example
     *    // Ordering using `input` node values
     *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
     *    {
     *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
     *        return $('input', td).val();
     *      } );
     *    }
     */
				order: {},

				/**
     * Type based plug-ins.
     *
     * Each column in DataTables has a type assigned to it, either by automatic
     * detection or by direct assignment using the `type` option for the column.
     * The type of a column will effect how it is ordering and search (plug-ins
     * can also make use of the column type if required).
     *
     * @namespace
     */
				type: {
					/**
      * Type detection functions.
      *
      * The functions defined in this object are used to automatically detect
      * a column's type, making initialisation of DataTables super easy, even
      * when complex data is in the table.
      *
      * The functions defined take two parameters:
      *
         *  1. `{*}` Data from the column cell to be analysed
         *  2. `{settings}` DataTables settings object. This can be used to
         *     perform context specific type detection - for example detection
         *     based on language settings such as using a comma for a decimal
         *     place. Generally speaking the options from the settings will not
         *     be required
      *
      * Each function is expected to return:
      *
      * * `{string|null}` Data type detected, or null if unknown (and thus
      *   pass it on to the other type detection functions.
      *
      *  @type array
      *
      *  @example
      *    // Currency type detection plug-in:
      *    $.fn.dataTable.ext.type.detect.push(
      *      function ( data, settings ) {
      *        // Check the numeric part
      *        if ( ! data.substring(1).match(/[0-9]/) ) {
      *          return null;
      *        }
      *
      *        // Check prefixed by currency
      *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
      *          return 'currency';
      *        }
      *        return null;
      *      }
      *    );
      */
					detect: [],

					/**
      * Type based search formatting.
      *
      * The type based searching functions can be used to pre-format the
      * data to be search on. For example, it can be used to strip HTML
      * tags or to de-format telephone numbers for numeric only searching.
      *
      * Note that is a search is not defined for a column of a given type,
      * no search formatting will be performed.
      * 
      * Pre-processing of searching data plug-ins - When you assign the sType
      * for a column (or have it automatically detected for you by DataTables
      * or a type detection plug-in), you will typically be using this for
      * custom sorting, but it can also be used to provide custom searching
      * by allowing you to pre-processing the data and returning the data in
      * the format that should be searched upon. This is done by adding
      * functions this object with a parameter name which matches the sType
      * for that target column. This is the corollary of <i>afnSortData</i>
      * for searching data.
      *
      * The functions defined take a single parameter:
      *
         *  1. `{*}` Data from the column cell to be prepared for searching
      *
      * Each function is expected to return:
      *
      * * `{string|null}` Formatted string that will be used for the searching.
      *
      *  @type object
      *  @default {}
      *
      *  @example
      *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
      *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
      *    }
      */
					search: {},

					/**
      * Type based ordering.
      *
      * The column type tells DataTables what ordering to apply to the table
      * when a column is sorted upon. The order for each type that is defined,
      * is defined by the functions available in this object.
      *
      * Each ordering option can be described by three properties added to
      * this object:
      *
      * * `{type}-pre` - Pre-formatting function
      * * `{type}-asc` - Ascending order function
      * * `{type}-desc` - Descending order function
      *
      * All three can be used together, only `{type}-pre` or only
      * `{type}-asc` and `{type}-desc` together. It is generally recommended
      * that only `{type}-pre` is used, as this provides the optimal
      * implementation in terms of speed, although the others are provided
      * for compatibility with existing Javascript sort functions.
      *
      * `{type}-pre`: Functions defined take a single parameter:
      *
         *  1. `{*}` Data from the column cell to be prepared for ordering
      *
      * And return:
      *
      * * `{*}` Data to be sorted upon
      *
      * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
      * functions, taking two parameters:
      *
         *  1. `{*}` Data to compare to the second parameter
         *  2. `{*}` Data to compare to the first parameter
      *
      * And returning:
      *
      * * `{*}` Ordering match: <0 if first parameter should be sorted lower
      *   than the second parameter, ===0 if the two parameters are equal and
      *   >0 if the first parameter should be sorted height than the second
      *   parameter.
      * 
      *  @type object
      *  @default {}
      *
      *  @example
      *    // Numeric ordering of formatted numbers with a pre-formatter
      *    $.extend( $.fn.dataTable.ext.type.order, {
      *      "string-pre": function(x) {
      *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
      *        return parseFloat( a );
      *      }
      *    } );
      *
      *  @example
      *    // Case-sensitive string ordering, with no pre-formatting method
      *    $.extend( $.fn.dataTable.ext.order, {
      *      "string-case-asc": function(x,y) {
      *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      *      },
      *      "string-case-desc": function(x,y) {
      *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
      *      }
      *    } );
      */
					order: {}
				},

				/**
     * Unique DataTables instance counter
     *
     * @type int
     * @private
     */
				_unique: 0,

				//
				// Depreciated
				// The following properties are retained for backwards compatiblity only.
				// The should not be used in new projects and will be removed in a future
				// version
				//

				/**
     * Version check function.
     *  @type function
     *  @depreciated Since 1.10
     */
				fnVersionCheck: DataTable.fnVersionCheck,

				/**
     * Index for what 'this' index API functions should use
     *  @type int
     *  @deprecated Since v1.10
     */
				iApiIndex: 0,

				/**
     * jQuery UI class container
     *  @type object
     *  @deprecated Since v1.10
     */
				oJUIClasses: {},

				/**
     * Software version
     *  @type string
     *  @deprecated Since v1.10
     */
				sVersion: DataTable.version
			};

			//
			// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
			//
			$.extend(_ext, {
				afnFiltering: _ext.search,
				aTypes: _ext.type.detect,
				ofnSearch: _ext.type.search,
				oSort: _ext.type.order,
				afnSortData: _ext.order,
				aoFeatures: _ext.feature,
				oApi: _ext.internal,
				oStdClasses: _ext.classes,
				oPagination: _ext.pager
			});

			$.extend(DataTable.ext.classes, {
				"sTable": "dataTable",
				"sNoFooter": "no-footer",

				/* Paging buttons */
				"sPageButton": "paginate_button",
				"sPageButtonActive": "current",
				"sPageButtonDisabled": "disabled",

				/* Striping classes */
				"sStripeOdd": "odd",
				"sStripeEven": "even",

				/* Empty row */
				"sRowEmpty": "dataTables_empty",

				/* Features */
				"sWrapper": "dataTables_wrapper",
				"sFilter": "dataTables_filter",
				"sInfo": "dataTables_info",
				"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
				"sLength": "dataTables_length",
				"sProcessing": "dataTables_processing",

				/* Sorting */
				"sSortAsc": "sorting_asc",
				"sSortDesc": "sorting_desc",
				"sSortable": "sorting", /* Sortable in both directions */
				"sSortableAsc": "sorting_asc_disabled",
				"sSortableDesc": "sorting_desc_disabled",
				"sSortableNone": "sorting_disabled",
				"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */

				/* Filtering */
				"sFilterInput": "",

				/* Page length */
				"sLengthSelect": "",

				/* Scrolling */
				"sScrollWrapper": "dataTables_scroll",
				"sScrollHead": "dataTables_scrollHead",
				"sScrollHeadInner": "dataTables_scrollHeadInner",
				"sScrollBody": "dataTables_scrollBody",
				"sScrollFoot": "dataTables_scrollFoot",
				"sScrollFootInner": "dataTables_scrollFootInner",

				/* Misc */
				"sHeaderTH": "",
				"sFooterTH": "",

				// Deprecated
				"sSortJUIAsc": "",
				"sSortJUIDesc": "",
				"sSortJUI": "",
				"sSortJUIAscAllowed": "",
				"sSortJUIDescAllowed": "",
				"sSortJUIWrapper": "",
				"sSortIcon": "",
				"sJUIHeader": "",
				"sJUIFooter": ""
			});

			var extPagination = DataTable.ext.pager;

			function _numbers(page, pages) {
				var numbers = [],
				    buttons = extPagination.numbers_length,
				    half = Math.floor(buttons / 2),
				    i = 1;

				if (pages <= buttons) {
					numbers = _range(0, pages);
				} else if (page <= half) {
					numbers = _range(0, buttons - 2);
					numbers.push('ellipsis');
					numbers.push(pages - 1);
				} else if (page >= pages - 1 - half) {
					numbers = _range(pages - (buttons - 2), pages);
					numbers.splice(0, 0, 'ellipsis'); // no unshift in ie6
					numbers.splice(0, 0, 0);
				} else {
					numbers = _range(page - half + 2, page + half - 1);
					numbers.push('ellipsis');
					numbers.push(pages - 1);
					numbers.splice(0, 0, 'ellipsis');
					numbers.splice(0, 0, 0);
				}

				numbers.DT_el = 'span';
				return numbers;
			}

			$.extend(extPagination, {
				simple: function (page, pages) {
					return ['previous', 'next'];
				},

				full: function (page, pages) {
					return ['first', 'previous', 'next', 'last'];
				},

				numbers: function (page, pages) {
					return [_numbers(page, pages)];
				},

				simple_numbers: function (page, pages) {
					return ['previous', _numbers(page, pages), 'next'];
				},

				full_numbers: function (page, pages) {
					return ['first', 'previous', _numbers(page, pages), 'next', 'last'];
				},

				first_last_numbers: function (page, pages) {
					return ['first', _numbers(page, pages), 'last'];
				},

				// For testing and plug-ins to use
				_numbers: _numbers,

				// Number of number buttons (including ellipsis) to show. _Must be odd!_
				numbers_length: 7
			});

			$.extend(true, DataTable.ext.renderer, {
				pageButton: {
					_: function (settings, host, idx, buttons, page, pages) {
						var classes = settings.oClasses;
						var lang = settings.oLanguage.oPaginate;
						var aria = settings.oLanguage.oAria.paginate || {};
						var btnDisplay,
						    btnClass,
						    counter = 0;

						var attach = function (container, buttons) {
							var i, ien, node, button;
							var clickHandler = function (e) {
								_fnPageChange(settings, e.data.action, true);
							};

							for (i = 0, ien = buttons.length; i < ien; i++) {
								button = buttons[i];

								if ($.isArray(button)) {
									var inner = $('<' + (button.DT_el || 'div') + '/>').appendTo(container);
									attach(inner, button);
								} else {
									btnDisplay = null;
									btnClass = '';

									switch (button) {
										case 'ellipsis':
											container.append('<span class="ellipsis">&#x2026;</span>');
											break;

										case 'first':
											btnDisplay = lang.sFirst;
											btnClass = button + (page > 0 ? '' : ' ' + classes.sPageButtonDisabled);
											break;

										case 'previous':
											btnDisplay = lang.sPrevious;
											btnClass = button + (page > 0 ? '' : ' ' + classes.sPageButtonDisabled);
											break;

										case 'next':
											btnDisplay = lang.sNext;
											btnClass = button + (page < pages - 1 ? '' : ' ' + classes.sPageButtonDisabled);
											break;

										case 'last':
											btnDisplay = lang.sLast;
											btnClass = button + (page < pages - 1 ? '' : ' ' + classes.sPageButtonDisabled);
											break;

										default:
											btnDisplay = button + 1;
											btnClass = page === button ? classes.sPageButtonActive : '';
											break;
									}

									if (btnDisplay !== null) {
										node = $('<a>', {
											'class': classes.sPageButton + ' ' + btnClass,
											'aria-controls': settings.sTableId,
											'aria-label': aria[button],
											'data-dt-idx': counter,
											'tabindex': settings.iTabIndex,
											'id': idx === 0 && typeof button === 'string' ? settings.sTableId + '_' + button : null
										}).html(btnDisplay).appendTo(container);

										_fnBindAction(node, { action: button }, clickHandler);

										counter++;
									}
								}
							}
						};

						// IE9 throws an 'unknown error' if document.activeElement is used
						// inside an iframe or frame. Try / catch the error. Not good for
						// accessibility, but neither are frames.
						var activeEl;

						try {
							// Because this approach is destroying and recreating the paging
							// elements, focus is lost on the select button which is bad for
							// accessibility. So we want to restore focus once the draw has
							// completed
							activeEl = $(host).find(document.activeElement).data('dt-idx');
						} catch (e) {}

						attach($(host).empty(), buttons);

						if (activeEl !== undefined) {
							$(host).find('[data-dt-idx=' + activeEl + ']').focus();
						}
					}
				}
			});

			// Built in type detection. See model.ext.aTypes for information about
			// what is required from this methods.
			$.extend(DataTable.ext.type.detect, [
			// Plain numbers - first since V8 detects some plain numbers as dates
			// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber(d, decimal) ? 'num' + decimal : null;
			},

			// Dates (only those recognised by the browser's Date.parse)
			function (d, settings) {
				// V8 tries _very_ hard to make a string passed into `Date.parse()`
				// valid, so we need to use a regex to restrict date formats. Use a
				// plug-in for anything other than ISO8601 style strings
				if (d && !(d instanceof Date) && !_re_date.test(d)) {
					return null;
				}
				var parsed = Date.parse(d);
				return parsed !== null && !isNaN(parsed) || _empty(d) ? 'date' : null;
			},

			// Formatted numbers
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber(d, decimal, true) ? 'num-fmt' + decimal : null;
			},

			// HTML numeric
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric(d, decimal) ? 'html-num' + decimal : null;
			},

			// HTML numeric, formatted
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric(d, decimal, true) ? 'html-num-fmt' + decimal : null;
			},

			// HTML (this is strict checking - there must be html)
			function (d, settings) {
				return _empty(d) || typeof d === 'string' && d.indexOf('<') !== -1 ? 'html' : null;
			}]);

			// Filter formatting functions. See model.ext.ofnSearch for information about
			// what is required from these methods.
			// 
			// Note that additional search methods are added for the html numbers and
			// html formatted numbers by `_addNumericSort()` when we know what the decimal
			// place is


			$.extend(DataTable.ext.type.search, {
				html: function (data) {
					return _empty(data) ? data : typeof data === 'string' ? data.replace(_re_new_lines, " ").replace(_re_html, "") : '';
				},

				string: function (data) {
					return _empty(data) ? data : typeof data === 'string' ? data.replace(_re_new_lines, " ") : data;
				}
			});

			var __numericReplace = function (d, decimalPlace, re1, re2) {
				if (d !== 0 && (!d || d === '-')) {
					return -Infinity;
				}

				// If a decimal place other than `.` is used, it needs to be given to the
				// function so we can detect it and replace with a `.` which is the only
				// decimal place Javascript recognises - it is not locale aware.
				if (decimalPlace) {
					d = _numToDecimal(d, decimalPlace);
				}

				if (d.replace) {
					if (re1) {
						d = d.replace(re1, '');
					}

					if (re2) {
						d = d.replace(re2, '');
					}
				}

				return d * 1;
			};

			// Add the numeric 'deformatting' functions for sorting and search. This is done
			// in a function to provide an easy ability for the language options to add
			// additional methods if a non-period decimal place is used.
			function _addNumericSort(decimalPlace) {
				$.each({
					// Plain numbers
					"num": function (d) {
						return __numericReplace(d, decimalPlace);
					},

					// Formatted numbers
					"num-fmt": function (d) {
						return __numericReplace(d, decimalPlace, _re_formatted_numeric);
					},

					// HTML numeric
					"html-num": function (d) {
						return __numericReplace(d, decimalPlace, _re_html);
					},

					// HTML numeric, formatted
					"html-num-fmt": function (d) {
						return __numericReplace(d, decimalPlace, _re_html, _re_formatted_numeric);
					}
				}, function (key, fn) {
					// Add the ordering method
					_ext.type.order[key + decimalPlace + '-pre'] = fn;

					// For HTML types add a search formatter that will strip the HTML
					if (key.match(/^html\-/)) {
						_ext.type.search[key + decimalPlace] = _ext.type.search.html;
					}
				});
			}

			// Default sort methods
			$.extend(_ext.type.order, {
				// Dates
				"date-pre": function (d) {
					var ts = Date.parse(d);
					return isNaN(ts) ? -Infinity : ts;
				},

				// html
				"html-pre": function (a) {
					return _empty(a) ? '' : a.replace ? a.replace(/<.*?>/g, "").toLowerCase() : a + '';
				},

				// string
				"string-pre": function (a) {
					// This is a little complex, but faster than always calling toString,
					// http://jsperf.com/tostring-v-check
					return _empty(a) ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
				},

				// string-asc and -desc are retained only for compatibility with the old
				// sort methods
				"string-asc": function (x, y) {
					return x < y ? -1 : x > y ? 1 : 0;
				},

				"string-desc": function (x, y) {
					return x < y ? 1 : x > y ? -1 : 0;
				}
			});

			// Numeric sorting types - order doesn't matter here
			_addNumericSort('');

			$.extend(true, DataTable.ext.renderer, {
				header: {
					_: function (settings, cell, column, classes) {
						// No additional mark-up required
						// Attach a sort listener to update on sort - note that using the
						// `DT` namespace will allow the event to be removed automatically
						// on destroy, while the `dt` namespaced event is the one we are
						// listening for
						$(settings.nTable).on('order.dt.DT', function (e, ctx, sorting, columns) {
							if (settings !== ctx) {
								// need to check this this is the host
								return; // table, not a nested one
							}

							var colIdx = column.idx;

							cell.removeClass(column.sSortingClass + ' ' + classes.sSortAsc + ' ' + classes.sSortDesc).addClass(columns[colIdx] == 'asc' ? classes.sSortAsc : columns[colIdx] == 'desc' ? classes.sSortDesc : column.sSortingClass);
						});
					},

					jqueryui: function (settings, cell, column, classes) {
						$('<div/>').addClass(classes.sSortJUIWrapper).append(cell.contents()).append($('<span/>').addClass(classes.sSortIcon + ' ' + column.sSortingClassJUI)).appendTo(cell);

						// Attach a sort listener to update on sort
						$(settings.nTable).on('order.dt.DT', function (e, ctx, sorting, columns) {
							if (settings !== ctx) {
								return;
							}

							var colIdx = column.idx;

							cell.removeClass(classes.sSortAsc + " " + classes.sSortDesc).addClass(columns[colIdx] == 'asc' ? classes.sSortAsc : columns[colIdx] == 'desc' ? classes.sSortDesc : column.sSortingClass);

							cell.find('span.' + classes.sSortIcon).removeClass(classes.sSortJUIAsc + " " + classes.sSortJUIDesc + " " + classes.sSortJUI + " " + classes.sSortJUIAscAllowed + " " + classes.sSortJUIDescAllowed).addClass(columns[colIdx] == 'asc' ? classes.sSortJUIAsc : columns[colIdx] == 'desc' ? classes.sSortJUIDesc : column.sSortingClassJUI);
						});
					}
				}
			});

			/*
    * Public helper functions. These aren't used internally by DataTables, or
    * called by any of the options passed into DataTables, but they can be used
    * externally by developers working with DataTables. They are helper functions
    * to make working with DataTables a little bit easier.
    */

			var __htmlEscapeEntities = function (d) {
				return typeof d === 'string' ? d.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : d;
			};

			/**
    * Helpers for `columns.render`.
    *
    * The options defined here can be used with the `columns.render` initialisation
    * option to provide a display renderer. The following functions are defined:
    *
    * * `number` - Will format numeric data (defined by `columns.data`) for
    *   display, retaining the original unformatted data for sorting and filtering.
    *   It takes 5 parameters:
    *   * `string` - Thousands grouping separator
    *   * `string` - Decimal point indicator
    *   * `integer` - Number of decimal points to show
    *   * `string` (optional) - Prefix.
    *   * `string` (optional) - Postfix (/suffix).
    * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
    *   parameters.
    *
    * @example
    *   // Column definition using the number renderer
    *   {
    *     data: "salary",
    *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
    *   }
    *
    * @namespace
    */
			DataTable.render = {
				number: function (thousands, decimal, precision, prefix, postfix) {
					return {
						display: function (d) {
							if (typeof d !== 'number' && typeof d !== 'string') {
								return d;
							}

							var negative = d < 0 ? '-' : '';
							var flo = parseFloat(d);

							// If NaN then there isn't much formatting that we can do - just
							// return immediately, escaping any HTML (this was supposed to
							// be a number after all)
							if (isNaN(flo)) {
								return __htmlEscapeEntities(d);
							}

							flo = flo.toFixed(precision);
							d = Math.abs(flo);

							var intPart = parseInt(d, 10);
							var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';

							return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || '');
						}
					};
				},

				text: function () {
					return {
						display: __htmlEscapeEntities
					};
				}
			};

			/*
    * This is really a good bit rubbish this method of exposing the internal methods
    * publicly... - To be fixed in 2.0 using methods on the prototype
    */

			/**
    * Create a wrapper function for exporting an internal functions to an external API.
    *  @param {string} fn API function name
    *  @returns {function} wrapped function
    *  @memberof DataTable#internal
    */
			function _fnExternApiFunc(fn) {
				return function () {
					var args = [_fnSettingsFromNode(this[DataTable.ext.iApiIndex])].concat(Array.prototype.slice.call(arguments));
					return DataTable.ext.internal[fn].apply(this, args);
				};
			}

			/**
    * Reference to internal functions for use by plug-in developers. Note that
    * these methods are references to internal functions and are considered to be
    * private. If you use these methods, be aware that they are liable to change
    * between versions.
    *  @namespace
    */
			$.extend(DataTable.ext.internal, {
				_fnExternApiFunc: _fnExternApiFunc,
				_fnBuildAjax: _fnBuildAjax,
				_fnAjaxUpdate: _fnAjaxUpdate,
				_fnAjaxParameters: _fnAjaxParameters,
				_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
				_fnAjaxDataSrc: _fnAjaxDataSrc,
				_fnAddColumn: _fnAddColumn,
				_fnColumnOptions: _fnColumnOptions,
				_fnAdjustColumnSizing: _fnAdjustColumnSizing,
				_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
				_fnColumnIndexToVisible: _fnColumnIndexToVisible,
				_fnVisbleColumns: _fnVisbleColumns,
				_fnGetColumns: _fnGetColumns,
				_fnColumnTypes: _fnColumnTypes,
				_fnApplyColumnDefs: _fnApplyColumnDefs,
				_fnHungarianMap: _fnHungarianMap,
				_fnCamelToHungarian: _fnCamelToHungarian,
				_fnLanguageCompat: _fnLanguageCompat,
				_fnBrowserDetect: _fnBrowserDetect,
				_fnAddData: _fnAddData,
				_fnAddTr: _fnAddTr,
				_fnNodeToDataIndex: _fnNodeToDataIndex,
				_fnNodeToColumnIndex: _fnNodeToColumnIndex,
				_fnGetCellData: _fnGetCellData,
				_fnSetCellData: _fnSetCellData,
				_fnSplitObjNotation: _fnSplitObjNotation,
				_fnGetObjectDataFn: _fnGetObjectDataFn,
				_fnSetObjectDataFn: _fnSetObjectDataFn,
				_fnGetDataMaster: _fnGetDataMaster,
				_fnClearTable: _fnClearTable,
				_fnDeleteIndex: _fnDeleteIndex,
				_fnInvalidate: _fnInvalidate,
				_fnGetRowElements: _fnGetRowElements,
				_fnCreateTr: _fnCreateTr,
				_fnBuildHead: _fnBuildHead,
				_fnDrawHead: _fnDrawHead,
				_fnDraw: _fnDraw,
				_fnReDraw: _fnReDraw,
				_fnAddOptionsHtml: _fnAddOptionsHtml,
				_fnDetectHeader: _fnDetectHeader,
				_fnGetUniqueThs: _fnGetUniqueThs,
				_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
				_fnFilterComplete: _fnFilterComplete,
				_fnFilterCustom: _fnFilterCustom,
				_fnFilterColumn: _fnFilterColumn,
				_fnFilter: _fnFilter,
				_fnFilterCreateSearch: _fnFilterCreateSearch,
				_fnEscapeRegex: _fnEscapeRegex,
				_fnFilterData: _fnFilterData,
				_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
				_fnUpdateInfo: _fnUpdateInfo,
				_fnInfoMacros: _fnInfoMacros,
				_fnInitialise: _fnInitialise,
				_fnInitComplete: _fnInitComplete,
				_fnLengthChange: _fnLengthChange,
				_fnFeatureHtmlLength: _fnFeatureHtmlLength,
				_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
				_fnPageChange: _fnPageChange,
				_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
				_fnProcessingDisplay: _fnProcessingDisplay,
				_fnFeatureHtmlTable: _fnFeatureHtmlTable,
				_fnScrollDraw: _fnScrollDraw,
				_fnApplyToChildren: _fnApplyToChildren,
				_fnCalculateColumnWidths: _fnCalculateColumnWidths,
				_fnThrottle: _fnThrottle,
				_fnConvertToWidth: _fnConvertToWidth,
				_fnGetWidestNode: _fnGetWidestNode,
				_fnGetMaxLenString: _fnGetMaxLenString,
				_fnStringToCss: _fnStringToCss,
				_fnSortFlatten: _fnSortFlatten,
				_fnSort: _fnSort,
				_fnSortAria: _fnSortAria,
				_fnSortListener: _fnSortListener,
				_fnSortAttachListener: _fnSortAttachListener,
				_fnSortingClasses: _fnSortingClasses,
				_fnSortData: _fnSortData,
				_fnSaveState: _fnSaveState,
				_fnLoadState: _fnLoadState,
				_fnSettingsFromNode: _fnSettingsFromNode,
				_fnLog: _fnLog,
				_fnMap: _fnMap,
				_fnBindAction: _fnBindAction,
				_fnCallbackReg: _fnCallbackReg,
				_fnCallbackFire: _fnCallbackFire,
				_fnLengthOverflow: _fnLengthOverflow,
				_fnRenderer: _fnRenderer,
				_fnDataSource: _fnDataSource,
				_fnRowAttributes: _fnRowAttributes,
				_fnExtend: _fnExtend,
				_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
				// in 1.10, so this dead-end function is
				// added to prevent errors
			});

			// jQuery access
			$.fn.dataTable = DataTable;

			// Provide access to the host jQuery object (circular reference)
			DataTable.$ = $;

			// Legacy aliases
			$.fn.dataTableSettings = DataTable.settings;
			$.fn.dataTableExt = DataTable.ext;

			// With a capital `D` we return a DataTables API instance rather than a
			// jQuery object
			$.fn.DataTable = function (opts) {
				return $(this).dataTable(opts).api();
			};

			// All properties that are available to $.fn.dataTable should also be
			// available on $.fn.DataTable
			$.each(DataTable, function (prop, val) {
				$.fn.DataTable[prop] = val;
			});

			// Information about events fired by DataTables - for documentation.
			/**
    * Draw event, fired whenever the table is redrawn on the page, at the same
    * point as fnDrawCallback. This may be useful for binding events or
    * performing calculations when the table is altered at all.
    *  @name DataTable#draw.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * Search event, fired when the searching applied to the table (using the
    * built-in global search, or column filters) is altered.
    *  @name DataTable#search.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * Page change event, fired when the paging of the table is altered.
    *  @name DataTable#page.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * Order event, fired when the ordering applied to the table is altered.
    *  @name DataTable#order.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * DataTables initialisation complete event, fired when the table is fully
    * drawn, including Ajax data loaded, if Ajax data is required.
    *  @name DataTable#init.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} oSettings DataTables settings object
    *  @param {object} json The JSON object request from the server - only
    *    present if client-side Ajax sourced data is used</li></ol>
    */

			/**
    * State save event, fired when the table has changed state a new state save
    * is required. This event allows modification of the state saving object
    * prior to actually doing the save, including addition or other state
    * properties (for plug-ins) or modification of a DataTables core property.
    *  @name DataTable#stateSaveParams.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} oSettings DataTables settings object
    *  @param {object} json The state information to be saved
    */

			/**
    * State load event, fired when the table is loading state from the stored
    * data, but prior to the settings object being modified by the saved state
    * - allowing modification of the saved state is required or loading of
    * state for a plug-in.
    *  @name DataTable#stateLoadParams.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} oSettings DataTables settings object
    *  @param {object} json The saved state information
    */

			/**
    * State loaded event, fired when state has been loaded from stored data and
    * the settings object has been modified by the loaded data.
    *  @name DataTable#stateLoaded.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} oSettings DataTables settings object
    *  @param {object} json The saved state information
    */

			/**
    * Processing event, fired when DataTables is doing some kind of processing
    * (be it, order, searcg or anything else). It can be used to indicate to
    * the end user that there is something happening, or that something has
    * finished.
    *  @name DataTable#processing.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} oSettings DataTables settings object
    *  @param {boolean} bShow Flag for if DataTables is doing processing or not
    */

			/**
    * Ajax (XHR) event, fired whenever an Ajax request is completed from a
    * request to made to the server for new data. This event is called before
    * DataTables processed the returned data, so it can also be used to pre-
    * process the data returned from the server, if needed.
    *
    * Note that this trigger is called in `fnServerData`, if you override
    * `fnServerData` and which to use this event, you need to trigger it in you
    * success function.
    *  @name DataTable#xhr.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    *  @param {object} json JSON returned from the server
    *
    *  @example
    *     // Use a custom property returned from the server in another DOM element
    *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
    *       $('#status').html( json.status );
    *     } );
    *
    *  @example
    *     // Pre-process the data returned from the server
    *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
    *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
    *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
    *       }
    *       // Note no return - manipulate the data directly in the JSON object.
    *     } );
    */

			/**
    * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
    * or passing the bDestroy:true parameter in the initialisation object. This
    * can be used to remove bound events, added DOM nodes, etc.
    *  @name DataTable#destroy.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * Page length change event, fired when number of records to show on each
    * page (the length) is changed.
    *  @name DataTable#length.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    *  @param {integer} len New length
    */

			/**
    * Column sizing has changed.
    *  @name DataTable#column-sizing.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    */

			/**
    * Column visibility has changed.
    *  @name DataTable#column-visibility.dt
    *  @event
    *  @param {event} e jQuery event object
    *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
    *  @param {int} column Column index
    *  @param {bool} vis `false` if column now hidden, or `true` if visible
    */

			return $.fn.dataTable;
		});
	})(this);

	return _retrieveGlobal();
});
$__System.registerDynamic("5f", ["5e"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("5e");
});
$__System.register('60', ['61'], function (_export) {
    var _Set;

    function Messages($rootScope, localStorageService, $q, $translate, Sites, Orgs, LcFn, moment) {

        /* Publics */
        this.getSessionNotifications = getSessionNotifications;
        this.getFilteredObjectNotifications = getFilteredObjectNotifications;
        this.pushNewMessage = pushNewMessage;
        this.getSiteNotifications = getSiteNotifications;
        this.getOrgNotifications = getOrgNotifications;
        this.popUp = popUp;
        this.errorToast = errorToast;

        var sessionNotifications = {};

        var defaultAjaxMessageCount = 200;
        var defaultMaxMessageCount = 2000; //Over 2000 will slow UI

        function addSessionNotification(id, data) {
            if (!sessionNotifications[id]) {
                sessionNotifications[id] = new _Set();
            }

            sessionNotifications[id] = _.unionWith(data, sessionNotifications[id], function (arrVal, othVal) {
                return arrVal.timestamp === othVal.timestamp;
            });
        }

        function getSessionNotifications(id, optionalCount) {
            return _.take(sessionNotifications[id], optionalCount || defaultMaxMessageCount);
        }

        function getFilteredObjectNotifications(siteId, defaultCount, defaultOffset, filterType, filterIdSets) {
            return Sites.getNotifications(siteId, defaultCount, defaultOffset, filterType, filterIdSets).then(function (notifications) {
                return translateOurMessages(notifications).then(function (messages) {
                    return messages;
                });
            });
        }

        function pushNewMessage(message) {
            var messages = [transformSocketMessage(message)];

            return translateOurMessages(messages).then(function (messages) {
                addSessionNotification(message.site_id, messages);

                $rootScope.$broadcast('notifications:new-message', messages);
            });
        }

        function getSiteNotifications(id, count) {
            var messageCount = count || defaultAjaxMessageCount;

            return Sites.getNotifications(id, messageCount).then(function (notifications) {
                return translateOurMessages(notifications).then(function (messages) {
                    addSessionNotification(id, messages);
                    return getSessionNotifications(id);
                });
            });
        }

        function getOrgNotifications(uuid, count) {
            var ajaxMessageCount = count || defaultAjaxMessageCount;

            return Orgs.getNotifications(uuid, ajaxMessageCount).then(function (result) {
                return translateOurMessages(result.data).then(function (messages) {
                    addSessionNotification(uuid, messages);
                    return getSessionNotifications(uuid, count);
                });
            });
        }

        //@todo - translate all popup errors
        function popUp(content, extra, group, external) {
            function findErrorMsg(content) {
                var errorMsg;
                if (content.data) {
                    errorMsg = content.data.detail ? content.data.detail : content.data.error;
                } else {
                    errorMsg = content.statusText;
                }
                return errorMsg;
            }

            var message = {};

            if (angular.isUndefined(external)) {
                if (angular.isObject(content)) {
                    //ERROR MESSAGE
                    if (angular.isDefined(content.config)) {
                        //Http Error
                        message = {
                            type: 'error',
                            title: content.status,
                            body: findErrorMsg(content),
                            extra: content.config.url
                        };
                    } else {
                        //Error from kK backend
                        message = {
                            type: 'error',
                            title: 'Error',
                            body: content.error_msg
                        };
                    }

                    message.email = {
                        recipient: 'ted@tedbot.com',
                        subject: encodeURI('LightCloud Bug Report'),
                        body: encodeURI('Error Code: ' + message.title + '\n Message: ' + message.body + '\n Endpoint: ' + message.url + '\n User: ' + (localStorageService.get('lcUser') ? localStorageService.get('lcUser').username : 'none'))
                    };
                } else {
                    message = { body: content };
                }

                if (angular.isDefined(extra)) {
                    message.extra = extra;
                }
            } else {
                //Pass it through as is ? will it always be a socket message? will there ever be a rainbow?
                message = content;
                message.body = content.msg_string;
                message.extra = content.username;
                message.chat = true;
            }

            var date = new Date();
            message.time = date.getHours() + ':' + date.getMinutes();

            //
            //
            // @refactor @rootscope
            //
            //

            $rootScope.$broadcast('notifications:showMessageModal', message);
        }

        function errorToast(message) {
            var dismissable = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

            $rootScope.$broadcast('notification:error', message, dismissable);
        }

        //@todo merge all message translation to one class - currently shared between this, sockets and cs activity view
        function transformSocketMessage(message) {

            var tMsg = {
                changed_by_user_id: null,
                site_id: message.site_id,
                event_id: '0',
                subject_type: 'unknown',
                event_data: message.msg_info || null,
                timestamp: new Date()
            };

            if (message.msg_type === 9) {
                tMsg.subject_alias = 'Gateway';
                tMsg.subject_id = message.gateway_device_id;
                tMsg.subject_type = 'Gateway';
                tMsg.event_id = 901; //Temp until support from bruce

                if (angular.isDefined(message.setup_mode)) {
                    // Setup mode
                    tMsg.event_data = message.setup_mode;
                }
                if (message.ecio) {
                    //Cell Site status
                    tMsg.event_data = 'signal quality: ' + message.ecio + ', signal strength: ' + message.rssi;
                    tMsg.event_id = 902; //Temp until support from bruce
                }
                //Bruce list
            } else if (message.msg_type === 11) {
                    var backendDeviceObj = message.nodes_info[0];
                    var gatewayDeviceObj = message.nodes[0];
                    var state = gatewayDeviceObj.node_state;

                    tMsg.initiator_type = gatewayDeviceObj.initiator_type;
                    tMsg.initiator_id = gatewayDeviceObj.initiator_id;
                    tMsg.lcp_type = gatewayDeviceObj.lcp_type;

                    if ($rootScope.currentSite && $rootScope.currentSite.zones) {
                        var zone = _.find($rootScope.currentSite.zones, ['node', backendDeviceObj.id]);

                        //Could it be daylight?
                        if (angular.isDefined(state.CUR_LIGHT_LEVEL)) {
                            tMsg.subject_alias = backendDeviceObj.id_string;
                            tMsg.subject_id = backendDeviceObj.id;
                            tMsg.subject_type = 'Daylight'; //One-off - best to bring the socket msg in line then remove this
                            //
                            //    Jason - Daylight harvestors need transform of 2.7, all other sensors 10.7
                            //
                            tMsg.event_data = tMsg.lcp_type === 2 ? LcFn.luxToFoot(state.CUR_LIGHT_LEVEL) : LcFn.luxClosedToFoot(state.CUR_LIGHT_LEVEL);
                            tMsg.event_id = 903;
                        } else if (zone) {
                            //Only process messages with corresponding zones
                            tMsg.subject_alias = zone.id_string;
                            tMsg.subject_id = zone.id;
                            tMsg.subject_type = 'Zone';

                            //Temp zone state messages
                            tMsg.event_id = 905;
                            tMsg.event_data = (state.LIGHTS_ON ? 'On' : 'Off') + ' - ' + state.DIM_LEVEL + '%';
                        }
                    }

                    // Node state is bad :(
                    if (!gatewayDeviceObj.node_health) {
                        tMsg.event_id = 18;
                        tMsg.event_data = '';
                    }
                } else if (message.msg_type === 22) {
                    //Dupey
                    if ($rootScope.currentSite && $rootScope.currentSite.devices) {
                        var device = _.find($rootScope.currentSite.devices, ['uuid', message.device_uuid]);

                        if (device) {
                            tMsg.subject_alias = device.settings.id_string;
                            tMsg.subject_id = device.id;
                            tMsg.subject_type = 'Device';
                            tMsg.event_data = device.settings.description + ' ' + message.step + '; ' + message.status + '; Version: ' + message.version; //Translation needed for status + steps
                            tMsg.event_id = 35;
                        } else if (message.gateway_device_id) {
                            tMsg.subject_alias = message.gateway_device_id;
                            tMsg.subject_type = 'Gateway';
                            tMsg.event_data = message.details + ', Version: ' + message.gw_upgrade_version + ', ' + message.step + '; ' + message.status; //Translation needed for status + steps
                            tMsg.event_id = 34;
                        }
                    }
                } else if (message.msg_type === 23) {
                    //Dupey
                    if ($rootScope.currentSite && $rootScope.currentSite.zones) {
                        var zone = _.find($rootScope.currentSite.zones, ['id', message.zone_id]);

                        if (zone) {
                            tMsg.subject_alias = zone.id_string;
                            tMsg.subject_id = zone.id;
                            tMsg.subject_type = 'Zone';
                            tMsg.event_data = message.power ? message.power : '0';
                            tMsg.event_id = 904;
                        }
                    }
                }

            return tMsg;
        }

        function isJsonString(str) {
            if (str !== null) {
                if (str.toString().indexOf('{"') > -1) {
                    try {
                        var json = JSON.parse(str);
                    } catch (e) {
                        return false;
                    }
                    return json;
                }
            }
            return false;
        }

        function buildTranslatedSentence(msg) {
            var subjectIdNeeded = [21, 22, 901, 902];
            var linkingNeeded = [5, 905]; //34

            var data = msg.event_data;
            var dataObj = isJsonString(data);

            if (dataObj) {
                if (dataObj.user) {
                    msg.initiator_type = 'user';
                    msg.initiator_id = dataObj.user;
                    data = dataObj.dim_level + '%';
                }
                if (dataObj.status) {
                    data = 'version ' + (dataObj.gw_upgrade_version || dataObj.firmware_uuid) + '; ' + dataObj.step + ' ' + dataObj.status;
                }
            }

            var sentence = {
                alias: subjectIdNeeded.indexOf(msg.event_id) > -1 ? msg.subject_alias + ' ' + msg.subject_id : msg.subject_alias, //Gateway's have no subject alias - use ID instead
                data: data,
                event: msg.event,
                initiator_type: msg.initiator_type,
                initiator_id: msg.initiator_id || null,
                linking: '',
                site_id: msg.site_id,
                subject_type: msg.subject_type,
                subject_id: msg.subject_id,
                timestamp: msg.timestamp + 'x' + hashCode(msg.event), //Some events appear to happen instantaneously, so we append random to avoid ng-repeat dupes error
                unixTimestamp: moment(msg.timestamp).unix()
            };

            //Some sentences need 'to' inserted to make sense
            if (linkingNeeded.indexOf(msg.event_id) > -1) {
                sentence.linking = 'to';
            }

            return sentence;
        }

        function hashCode(string) {
            var hash = 0,
                i,
                chr;
            if (string.length === 0) return hash;
            for (i = 0; i < string.length; i++) {
                chr = string.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash + window.performance.timing.navigationStart + window.performance.now();
        };

        //One by one was taking 1600ms - bug in angular-translate? - send all at once and re-map
        function translateOurMessages(messages) {
            var translateBatch = [];

            _.each(messages, function (message) {
                translateBatch.push('notificationSubjects.' + message.subject_type);
                translateBatch.push('notificationEvents.' + message.event_id);
                translateBatch.push('common.' + message.initiator_type || 'unknown');
            });

            return $q(function (resolve, reject) {
                $translate(_.uniq(translateBatch)).then(function (translation) {

                    var translatedMessages = _.map(messages, function (message) {
                        message.subject_type = translation['notificationSubjects.' + message.subject_type];
                        message.event = translation['notificationEvents.' + message.event_id];
                        message.initiator_type = message.initiator_type ? translation['common.' + message.initiator_type || 'unknown'] : null;

                        var translatedMessage = buildTranslatedSentence(message);

                        return translatedMessage;
                    });

                    resolve(translatedMessages);
                });
            });
        }
    }

    return {
        setters: [function (_2) {
            _Set = _2['default'];
        }],
        execute: function () {
            'use strict';

            Messages.$inject = ['$rootScope', 'localStorageService', '$q', '$translate', 'Sites', 'Orgs', 'LcFn', 'moment'];
            _export('default', Messages);
        }
    };
});

$__System.register('62', ['12', '13'], function (_export) {
    var _createClass, _classCallCheck, NotificationsMessageModalDirective;

    return {
        setters: [function (_) {
            _createClass = _['default'];
        }, function (_2) {
            _classCallCheck = _2['default'];
        }],
        execute: function () {
            'use strict';

            NotificationsMessageModalDirective = (function () {
                function NotificationsMessageModalDirective() {
                    _classCallCheck(this, NotificationsMessageModalDirective);

                    this.restrict = 'E';
                    this.replace = true;
                    this.template = '\n            <section class="bottom-notice ajax-messages" ng-class="{error: sessionMessages[0].type == \'error\', warning: sessionMessages[0].type == \'warning\'}">\n                <button class="btn right" ng-click="tSN.dismissUGws = true;" class="" translate="common.dismiss">Dismiss</button>\n                <button class="btn right" ng-click="tSN.getFreshSites()" ng-disabled="tSN.pending" class="">Refresh</button>\n\n                <div class="messages">\n                    <div class="message" ng-repeat="message in sessionMessages">\n                        <span class="msg-content">{{message.title}} {{message.body}}</span>\n                    </div>\n                </div>\n            </section>\n        ';
                }

                _createClass(NotificationsMessageModalDirective, [{
                    key: 'controller',
                    value: function controller($scope, $timeout) {
                        $scope.dependencies = {
                            $timeout: $timeout
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, elm) {

                        var element = angular.element(elm);

                        scope.sessionMessages = [];

                        scope.$on('notifications:showMessageModal', function (msgScope, newMessage) {

                            scope.sessionMessages = scope.sessionMessages.slice(0, 4);

                            scope.sessionMessages.unshift(newMessage);

                            console.log(scope.sessionMessages);

                            //Timer to close unless over it
                            var closeModal = scope.dependencies.$timeout(function () {
                                element.fadeOut('slow').removeClass('timeout-10 timeout-5');
                            }, 10000);
                            element.addClass('timeout-10');

                            //Close button
                            element.on('click touchstart', '.close', function () {
                                element.fadeOut('fast');
                                scope.dependencies.$timeout.cancel(closeModal);
                                element.removeClass('timeout-10 timeout-5');
                            });

                            element.on('mouseenter', function () {
                                scope.dependencies.$timeout.cancel(closeModal);
                                element.removeClass('timeout-10 timeout-5');
                            });

                            element.on('mouseleave', function () {
                                closeModal = scope.dependencies.$timeout(function () {
                                    element.fadeOut('slow').removeClass('timeout-10 timeout-5');
                                }, 5000);
                                element.addClass('timeout-5');
                            });

                            if (!element.is(':visible')) {
                                element.fadeIn(300);
                            }
                        });

                        scope.$on('domEvent:closeOthers', function (e, originatorEl) {
                            if (element.has(originatorEl).length > 0 || originatorEl[0] === element[0]) {
                                return;
                            } else {
                                element.fadeOut(300);
                            }
                        });
                    }
                }]);

                return NotificationsMessageModalDirective;
            })();

            _export('default', NotificationsMessageModalDirective);
        }
    };
});

$__System.register('63', ['12', '13'], function (_export) {
    var _createClass, _classCallCheck, NotificationsToastDirective;

    return {
        setters: [function (_) {
            _createClass = _['default'];
        }, function (_2) {
            _classCallCheck = _2['default'];
        }],
        execute: function () {
            'use strict';

            NotificationsToastDirective = (function () {
                function NotificationsToastDirective() {
                    _classCallCheck(this, NotificationsToastDirective);

                    this.restrict = 'E';
                    this.replace = true;
                    this.template = '\n            <div class="toast" ng-if="$root.envionmentSpoof">\n                <p class="toast-message">Connected to backend: {{$root.backEndUrl}}</p>\n            </div>\n        ';
                }

                _createClass(NotificationsToastDirective, [{
                    key: 'controller',
                    value: function controller($scope, $timeout) {
                        $scope.dependencies = {
                            $timeout: $timeout
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, elm) {}
                }]);

                return NotificationsToastDirective;
            })();

            _export('default', NotificationsToastDirective);
        }
    };
});

$__System.register('64', [], function (_export) {
    'use strict';

    var notificationsLogListComponent;
    return {
        setters: [],
        execute: function () {
            notificationsLogListComponent = {
                template: '\n        <h2 class="overview-heading white" ng-if="::nLL.heading">\n            <span>{{::nLL.heading}}</span>\n        </h2>\n        <p class="loading-spinner-label relative" ng-show="nLL.pending" translate="common.loadingEllipsis" translate="common.loadingEllipsis">Loading...</p>\n        <table ng-if="nLL.messages && nLL.messages.length > 0" datatable data-datatable-props="nLL.datatableProps" data-datatable-api="nLL.datatableApi" class="notifications-log-list-table">\n            <thead>\n                <tr>\n                    <th>Site ID</th>\n                    <th>Message</th>\n                    <th>Subject Type</th>\n                    <th>Timestamp</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr class="result" ng-repeat="msg in nLL.messages track by msg.timestamp">\n                    <td>\n                        {{::msg.site_id}}\n                    </td>\n                    <td>\n                        <div class="message-icon device-icon lc-{{::msg.subject_type}}"></div>\n                        <p class="messageBody">\n                            <strong>{{::msg.alias}}</strong>\n                            <span>{{::msg.event}} {{::msg.linking}}</span>\n                            <strong class="message-content ">{{::msg.data}}</strong>\n                            <span ng-if="::msg.initiator_type">\n                                <span translate="by"></span>\n                                <strong>{{::msg.initiator_type}} {{::msg.initiator_id}}</strong>\n                            </span>\n                        </p>\n                    </td>\n                    <td>\n                        {{::msg.subject_type}}\n                    </td>\n                    <td data-sort="{{::msg.unixTimestamp}}">\n                        {{::nLL.humanTime(msg.unixTimestamp)}}\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n\n        <div class="activity last-log" ng-if="nLL.limitReached || nLL.messages.length === 0">\n            <span translate="common.endOfLog">End of log</span>\n        </div>\n        <!-- @todo add a get more button / group by timing -->\n    ',
                bindings: {
                    filterText: '<',
                    filterCategory: '<',
                    heading: '@',
                    limitReached: '<',
                    messages: '<',
                    pending: '<'
                },
                controllerAs: 'nLL',
                controller: function controller($scope, moment) {

                    var nLL = this;

                    nLL.humanTime = function (timestamp) {
                        return moment.unix(timestamp).format('MM/DD/YYYY, h:mm:ss A');
                    };

                    nLL.datatableApi = {};
                    nLL.datatableProps = {
                        dom: 't<ip>',
                        pageLength: 50,
                        order: [[3, 'desc']],
                        columnDefs: [{
                            targets: [2],
                            visible: false
                        }]
                    };

                    $scope.$watch('nLL.filterText', function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            nLL.datatableApi.search(newValue).draw();
                        }
                    });

                    $scope.$watch('nLL.filterCategory', function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            nLL.datatableApi.columns(2).search(newValue).draw();
                        }
                    });
                }
            };

            _export('default', notificationsLogListComponent);
        }
    };
});

$__System.register('65', [], function (_export) {
    'use strict';

    var notificationsBottomNoticeListComponent;
    return {
        setters: [],
        execute: function () {
            notificationsBottomNoticeListComponent = {
                template: '\n        <span class="msg-content">\n            <span ng-repeat="(key,gateway) in nBNL.list">\n                <span ng-if="!gateway.id_string"><span translate="devices.gatewayMAC"></span>: {{gateway.mac_addr | cleanMac | lastFourMac}}</span>\n                <span ng-if="gateway.id_string">{{gateway.id_string}}</span>\n                <span>{{:: key === nBNL.list.length -1 || nBNL.list.length === 1 ? \'\':\',\'}}</span>\n            </span>\n            <span><span>{{nBNL.list.length > 1 ? \'are\':\'is\'}}</span> {{::nBNL.message}}</span>\n        </span>\n    ',
                bindings: {
                    list: '<',
                    message: '@'
                },
                controllerAs: 'nBNL',
                controller: function controller() {

                    var nBNL = this;
                }
            };

            _export('default', notificationsBottomNoticeListComponent);
        }
    };
});

$__System.register('66', [], function (_export) {
    'use strict';

    var notificationsBottomSiteNoticesComponent;
    return {
        setters: [],
        execute: function () {
            notificationsBottomSiteNoticesComponent = {
                template: '\n        <!-- Undo -->\n        <undo-popup></undo-popup>\n\n        <!-- Panic -->\n        <section class="bottom-notice panic-mode" ng-if="tSN.site.is_panic_mode">\n            <button class="btn right" ng-if="::tSN.isOrgAdmin(tSN.user,tSN.site.org)" ng-click="tSN.editSite()" translate="common.goSite" class="" translate="customerService.gotoThisSite">Goto Site</button>\n            <span class="msg-content">\n                <span translate="common.emergencyActive">EMERGENCY MODE IS ACTIVE!!!</span>\n            </span>\n        </section>\n\n        <!-- No Gateways -->\n        <section class="bottom-notice gateway-failure" ng-if="!tSN.site.is_blue && !tSN.site.gateways.length && !tSN.dismissNGws">\n            <button class="btn right" ng-click="tSN.dismissNGws = true;" class="" translate="common.dismiss">Dismiss</button>\n            <span class="msg-content">This site has <strong>no gateways</strong></span>\n        </section>\n\n        <!-- Gateways Unavailable -->\n        <section class="bottom-notice gateway-failure" ng-if="tSN.gwsUnavailable.length && !tSN.dismissUGws">\n            <button class="btn right" ng-click="tSN.dismissUGws = true;" class="" translate="common.dismiss">Dismiss</button>\n            <button class="btn right" ng-click="tSN.getFreshSites()" ng-disabled="tSN.pending" class="">Refresh</button>\n\n            <notifications-bottom-notice-list list="tSN.gwsUnavailable" message="currently unavailable"></notifications-bottom-notice-list>\n        </section>\n\n        <!-- Gateways Setup -->\n        <section class="bottom-notice setup-mode-container" ng-if="tSN.gwsInSetupMode.length && !tSN.dismissSetupMode">\n            <button class="btn right" ng-click="tSN.dismissSetupMode = true;" class="" translate="common.dismiss">Dismiss</button>\n            <button class="btn right" ng-if="::tSN.isOrgAdmin(tSN.user,tSN.site.org)" ui-sref="Devices({siteId:tSN.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'devices\'})" translate="" class="">Goto Devices</button>\n\n            <notifications-bottom-notice-list list="tSN.gwsInSetupMode" message="in Add Device mode"></notifications-bottom-notice-list>\n        </section>\n        \n        <!-- General Error Msg -->\n        <section class="bottom-notice gateway-failure" ng-if="tSN.error && !tSN.dismissError">\n            <button class="btn right" ng-if="tSN.errorIsDismissable" ng-click="tSN.dismissError = true;" class="" translate="common.dismiss">Dismiss</button>\n            <span class="msg-content">{{tSN.errorMsg}}</span>\n        </section> \n\n        <!-- Classic UI Notice -->\n        <section class="bottom-notice classic-message" ng-if="!tSN.hideClassicNotice && !tSN.dismissClassic">\n            <button class="btn right" ng-click="tSN.setClassicFlag()" class="" translate="common.dismiss">Dismiss</button>\n            <span class="msg-content" translate="common.latestInterface">You are using the latest version of the Lightcloud interface. To switch back to the classic version, use the link under the top right menu.</span>\n        </section>\n    ',
                bindings: {
                    gateways: '<',
                    site: '<',
                    user: '<',
                    onUpdateMaster: '&'
                },
                controllerAs: 'tSN',
                controller: function controller(LcFn, Local, _, $rootScope, $timeout) {

                    var tSN = this;

                    tSN.$onInit = function () {
                        updateGateways();
                        checkClassicFlag();
                    };

                    tSN.$onChanges = function (changes) {
                        if (changes) {
                            updateGateways();
                        }
                    };

                    //Available to all children inc CS
                    tSN.getFreshSites = function () {
                        tSN.pending = true;
                        tSN.onUpdateMaster().then(function () {
                            tSN.pending = false;
                        });
                    };

                    tSN.editSite = function () {
                        if (tSN.site) {
                            $rootScope.$broadcast('cs-bar:siteInfo', tSN.site);
                        }
                    };

                    tSN.setClassicFlag = function () {
                        tSN.dismissClassic = true;
                        Local.set('hideClassicNotice', true);
                    };

                    tSN.isOrgAdmin = LcFn.isOrgAdmin;

                    $rootScope.$on('notification:error', function (event, msg) {
                        var dismissable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

                        tSN.error = true;
                        tSN.errorMsg = msg;
                        tSN.errorIsDismissable = dismissable;

                        if (!dismissable) {
                            $timeout(function () {
                                tSN.error = false;
                            }, 3000);
                        }
                    });

                    function updateGateways() {
                        tSN.gwsInSetupMode = _.filter(tSN.site.gateways, 'setup_mode');

                        tSN.gwsUnavailable = _.filter(tSN.site.gateways, function (gateway) {
                            return gateway.gateway_health === 0 || gateway.gateway_health === 2 || gateway.gateway_health === 3;
                        });
                    }

                    function checkClassicFlag() {
                        tSN.hideClassicNotice = Local.get('hideClassicNotice');
                    }
                }
            };

            _export('default', notificationsBottomSiteNoticesComponent);
        }
    };
});

$__System.register('67', ['3', '40', '60', '62', '63', '64', '65', '66', '5f'], function (_export) {
	'use strict';

	var angular, $, MessagesService, NotificationsMessageModalDirective, NotificationsToastDirective, notificationsLogListComponent, notificationsBottomNoticeListComponent, notificationsBottomSiteNoticesComponent, dataTable, notificationsModule;
	return {
		setters: [function (_) {
			angular = _['default'];
		}, function (_2) {
			$ = _2['default'];
		}, function (_3) {
			MessagesService = _3['default'];
		}, function (_4) {
			NotificationsMessageModalDirective = _4['default'];
		}, function (_5) {
			NotificationsToastDirective = _5['default'];
		}, function (_6) {
			notificationsLogListComponent = _6['default'];
		}, function (_7) {
			notificationsBottomNoticeListComponent = _7['default'];
		}, function (_8) {
			notificationsBottomSiteNoticesComponent = _8['default'];
		}, function (_f) {
			dataTable = _f['default'];
		}],
		execute: function () {
			notificationsModule = angular.module('notifications', []).service('Messages', MessagesService).directive('notificationsMessageModal', function () {
				return new NotificationsMessageModalDirective();
			}).directive('toast', function () {
				return new NotificationsToastDirective();
			}).directive('datatable', function ($timeout) {
				return {
					scope: {
						datatableProps: '=',
						datatableApi: '='
					},
					link: function link($scope, element) {
						// Trigger when number of children changes, including by directives like ng-repeat
						$scope.$watch(function () {
							return element.children().length;
						}, function () {
							// Wait for templates to render
							$scope.$evalAsync(function () {
								$timeout(function () {
									$scope.datatableApi = $(element).DataTable($scope.datatableProps);
								}, 500);
							});
						});
					}
				};
			})
			//
			.component('notificationsLogList', notificationsLogListComponent).component('notificationsBottomNoticeList', notificationsBottomNoticeListComponent).component('notificationsBottomSiteNotices', notificationsBottomSiteNoticesComponent);

			_export('default', notificationsModule);
		}
	};
});

$__System.register('59', [], function (_export) {
	'use strict';

	function overviewScenesModalCtrl($scope, $timeout, pending, Scenes, Modals, scenes, close, siteId) {

		$scope.scenes = scenes;
		$scope.activate = activate;
		$scope.close = close;
		$scope.siteId = siteId;
		//$scope.save		= save;
		$scope.pending = pending;

		$scope.modalPending = false;
		$scope.sceneApplied = false;

		var slowClose = null;

		$scope.$on('$destroy', function () {
			$timeout.cancel(slowClose);
		});

		function activate(scene) {
			if (!$scope.modalPending && !$scope.sceneApplied) {
				$scope.modalPending = true;
				scene.pending = true;

				Modals.openLoad('Applying Scene');

				Scenes.activate(scene.id).success(function () {
					finish(scene);
				}).error(function () {
					$scope.modalPending = false;
					scene.pending = false;
					Modals.closeLoad('Scene Apply Fail');
				});
			}
		}

		function finish(scene) {
			Modals.closeLoad('Scene Applied', true);
			$scope.modalPending = false;
			scene.pending = false;
			scene.applied = true;
			$scope.sceneApplied = true;
			slowClose = $timeout(closeClear, 1000);
			function closeClear() {
				close(scene);
				scene.applied = false;
				$scope.sceneApplied = false;
			}
		}

		$scope.selectedScene = false;

		$scope.selectScene = function (scene) {
			$scope.scene.selected = !$scope.scene.selected;
		};
	}

	return {
		setters: [],
		execute: function () {
			overviewScenesModalCtrl.$inject = ['$scope', '$timeout', 'pending', 'Scenes', 'Modals', 'scenes', 'close', 'siteId'];
			_export('default', overviewScenesModalCtrl);
		}
	};
});

$__System.registerDynamic("68", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading cog\">\n    <a class=\"cog\" ui-sref=\"Scenes({siteId:oS.siteId, userSelectedFilter: null, leftMenuSpecialContext: 'scenes'})\"><span class=\"SEdit\" translate=\"common.edit\">Edit</span><i class=\"cog\"></i></a>\n    <span translate=\"common.scenes\">scenes</span>\n</h2>\n<div class=\"overview-modal-launch main-button\" ng-click=\"oS.selectScene()\">\n    <h1 class=\"name\" translate>{{oS.selectedScene ? oS.selectedScene.name : 'scenes.selectScene'}}</h1>\n    <i class=\"fa fa-bars menu\"></i>\n    <h4 class=\"byline\"><span class=\"grey\" translate>{{ oS.selectedScene ? 'scenes.demand' : oS.relevantScenes.length + ' Scenes'}}</span> {{oS.selectedScene ? oS.selectedScene.demand+'W' : '' }}</h4>\n</div>";
});
$__System.register('69', ['68'], function (_export) {
    'use strict';

    var overviewScenesTemplate, overviewScenesComponent;
    return {
        setters: [function (_2) {
            overviewScenesTemplate = _2['default'];
        }],
        execute: function () {
            overviewScenesComponent = {
                template: overviewScenesTemplate,
                bindings: {
                    scenes: '<',
                    siteId: '<',
                    zones: '<'
                },
                controllerAs: 'oS',
                controller: function controller(LcFn, Modals, _) {

                    var oS = this;

                    oS.$onChanges = function () {
                        oS.relevantScenes = filterRelevantScenes(oS.scenes, oS.zones);
                    };

                    oS.selectScene = function () {

                        oS.pendingSelect = true;

                        Modals.showModal({
                            name: 'overviewScenes',
                            controllerAs: 'overviewScenesModal',
                            inputs: {
                                pending: oS.pendingSelect,
                                scenes: oS.relevantScenes,
                                siteId: oS.siteId
                            }
                        }).then(function (result) {
                            if (result) {
                                oS.selectedScene = result;
                            }
                        });
                    };

                    //
                    // Show scenes containing a zone in selection..
                    // OR an area scene matching a zone in selection
                    //
                    function filterRelevantScenes(scenes, zones) {
                        return _.filter(scenes, function (scene) {
                            //
                            // Remove Smart Shift scenes per jason
                            //
                            return !LcFn.isSmartShiftType(scene) && _.find(scene.actions, function (action) {
                                return action.systemType === 'zone' && _.find(zones, { id: action.systemId }) || action.systemType === 'area' && _.find(zones, { area: action.systemId });
                            });
                        });
                    }
                }
            };

            _export('default', overviewScenesComponent);
        }
    };
});

$__System.register('6a', [], function (_export) {
    'use strict';

    var overviewBaseComponent;
    return {
        setters: [],
        execute: function () {
            overviewBaseComponent = {
                template: '\n        <div class="gutters-20">\n            <section class="overview-left">\n                <overview-zones class="overview-zones-container" item-collection="oBC.itemCollection" site-id="oBC.sessionData.id" is-admin="::oBC.isAdmin"></overview-zones>\n                <group-dimming class="overview-zones-container" item-collection="oBC.itemCollection" groups="oBC.sessionData.groups" zones="oBC.sessionData.zones" site-id="oBC.sessionData.id"></group-dimming>\n            </section>\n            <section class="overview-right">\n                <overview-scenes class="overview-scenes-container" ng-if="!oBC.sessionData.is_blue" scenes="oBC.sessionData.scenes" site-id="oBC.sessionData.id" zones="oBC.itemCollection.group" ></overview-scenes>\n                <overview-energy class="overview-energy-container" item-collection="oBC.itemCollection" site-id="oBC.sessionData.id"></overview-energy>\n            </section>\n        </div>\n    ',
                bindings: {
                    itemCollection: '<',
                    masterSessionData: '<',
                    sessionData: '<',
                    user: '<',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'oBC',
                controller: function controller(LcFn) {
                    var oBC = this;

                    oBC.isAdmin = LcFn.isOrgAdmin(oBC.user, oBC.sessionData.org);

                    oBC.$onInit = function () {
                        oBC.onSelectionUpdate({ selection: oBC.itemCollection });
                    };

                    oBC.$onChanges = function (changes) {
                        //console.warn('change in overviewBase',changes)
                    };
                }
            };

            _export('default', overviewBaseComponent);
        }
    };
});

$__System.registerDynamic("6b", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading\" ng-show=\"gDC.groups.length\">\n    <a class=\"cog\" ng-click=\"gDC.editMode=!gDC.editMode\"><span class=\"SEdit\" translate=\"common.edit\">Edit</span><i class=\"cog\"></i></a>\n    <span translate=\"zones.groupControl\">Group Control</span>\n</h2>\n<div class=\"overview-zones-list-wrapper\">\n    <div class=\"overview-zones-list\">\n        <div class=\"group-dimming-container\"  ng-class=\"{edit: gDC.editMode}\" ng-repeat=\"group in gDC.groups\">\n            <div class=\"delete\">\n                <button class=\"btn-select remove\" ng-click=\"gDC.delete(group)\"></button>\n            </div>\n            <div class=\"summary\">\n                <div class=\"left\">\n                    <div class=\"title\">{{group.id_string}}</div>\n                    <div class=\"zone-summary\">{{group.zones.length ? group.zones.length : '0'}} zones</div>\n                </div>\n                <div class=\"right\">\n                    <button class=\"btn-push\" ng-class=\"{on: group.state, loading:group.ajaxPending}\" ng-disabled=\"!group.zones\" ng-click=\"gDC.updateGroup(group,'button')\"></button>\n                </div>\n            </div>\n            <div class=\"control\" ng-if=\"group.zones\">\n                <div class=\"group\">\n                    <div class=\"main\">\n                        <i ng-class=\"{expand: expand}\" ng-click=\"expand = !expand\"></i>\n                        <slider ng-class=\"{unsync: !group.sameLevel}\" floor=\"1\" ceiling=\"{{::group.trimLevel}}\" step=\"1\" precision=\"1\" dim=\"true\" level=\"group.dim_level\" ng-model=\"group.dim_level\" ng-model-high=\"100\" enabled=\"group.dim_level\" update=\"true\" aux-function=\"gDC.updateGroup(group,'slider')\" ng-if=\"group.dim_level\"></slider>\n                        <span class=\"mix\" ng-if=\"group.dim_level\">{{group.sameLevel ? group.dim_level? group.dim_level + \"%\" : \"N/A\" : \"MIXED\"}}</span>\n                        <span class=\"no-dimming\" ng-if=\"!group.dim_level\">Not dimmable</span>\n                    </div>\n                    <div class=\"items\" ng-repeat=\"zone in group.zones\" ng-show=\"expand\">\n                        <div>\n                            <span class=\"title\">{{zone.id_string}}</span>\n                            <span class=\"indicator\" ng-class=\"{on: zone.zone_state}\"></span>\n                        </div>\n                        <div  ng-if=\"::zone.is_dimmable\">\n                            <slider floor=\"1\" ceiling=\"{{::zone.trim_high}}\" step=\"1\" precision=\"1\" dim=\"true\" level=\"zone.reported_dim_level\" ng-model=\"zone.reported_dim_level\" ng-model-high=\"100\" enabled=\"::!zone.controlledBySensor\" update=\"false\"></slider>\n                            <span class=\"percent\">{{zone.reported_dim_level}}%</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";
});
$__System.register('6c', ['6b'], function (_export) {
    'use strict';

    var groupDimmingTemplate, groupDimmingComponent;
    return {
        setters: [function (_b) {
            groupDimmingTemplate = _b['default'];
        }],
        execute: function () {
            groupDimmingComponent = {
                template: groupDimmingTemplate,
                bindings: {
                    itemCollection: '<',
                    groups: '<',
                    zones: '<'
                },
                controllerAs: 'gDC',
                controller: function controller($scope, $q, Areas, Modals, _, $timeout) {

                    var gDC = this;

                    gDC.$onInit = function () {
                        gDC.groups = updateGroups(); // Use gDC.itemCollection.group for filtered view

                        // - Could show only relevant groups
                        gDC.filteredGroups = filterSelectedGroups(gDC.allGroups);

                        gDC.socketListener = $scope.$on('event:socket:zoneState', updateOnMessage);

                        gDC.socketListener2 = $scope.$on('event:socket:groupState', updateGroupState);
                    };

                    gDC.$onChanges = function (changes) {
                        //console.log('Group Change!',changes);
                    };

                    gDC.$onDestroy = function () {
                        gDC.socketListener();
                        gDC.socketListener2();
                    };

                    function updateGroupState(event, message) {
                        var groupId = message.event_id;
                        var targetGroup = _.find(gDC.groups, { id: groupId });
                        var socketUpdate = true;
                        if (targetGroup && message) {
                            targetGroup.state = Boolean(message.lights_on);
                            targetGroup.dim_level = message.dim_level;
                        }
                        applyUpdate(targetGroup, socketUpdate);
                    }

                    function applyUpdate(group, socketUpdate) {
                        //console.log(group, socketUpdate);
                        if (group.zones && group.zones.length > 0) {
                            group.zones.forEach(function (zone) {
                                zone.zone_state = group.state;
                                if (zone.reported_dim_level) {
                                    zone.reported_dim_level = group.dim_level;
                                }
                            });
                            group.sameLevel = true;
                            group.ajaxPending = false;

                            $timeout(function () {
                                $scope.$apply();
                            });
                        }
                    }

                    function updateOnMessage(event, message) {
                        if (message.action === 'response') {
                            //
                            // Match by node id
                            //
                            var match = _.find(gDC.zones, { node: message.node_id });

                            if (match) {
                                console.log('Socket Zone Update: ' + match.id_string, message.zone_state, message.reported_dim_level);

                                match.ajaxPending = false;
                                match.reported_dim_level = message.reported_dim_level;
                                match.zone_state = message.zone_state;
                                match.zone_health = message.zone_health;
                            }
                        }
                    }

                    function updateGroups(optMessage) {
                        //console.error('updating',optMessage)
                        return prepareGroups(gDC.groups, gDC.zones);
                    }

                    function prepareGroups(groups, selectedZones) {
                        _.each(selectedZones, function (zone) {
                            _.each(zone.groups, function (groupId) {

                                var match = _.find(groups, { id: groupId });

                                if (match) {
                                    match.zones = match.zones ? _.union(match.zones, [zone]) : [zone];
                                }
                            });
                        });

                        return _.map(groups, function (group) {
                            return processZones(group);
                        });
                    }

                    function processZones(group) {

                        //console.error('Group Change!',group);

                        var dimLevel = 0,
                            state = true,
                            firstDim = true,
                            sameLevel = true,
                            trimLevel = 100;

                        _.each(group.zones, function (zone) {
                            state = state && zone.zone_state;
                            if (sameLevel && zone.is_dimmable) {
                                if (firstDim) {
                                    dimLevel = zone.reported_dim_level;
                                    firstDim = false;
                                } else {
                                    if (dimLevel !== zone.reported_dim_level) {
                                        sameLevel = false;
                                        dimLevel = 100;
                                    }
                                }
                                if (zone.trim_high && zone.trim_high < trimLevel) {
                                    trimLevel = zone.trim_high;
                                }
                            }
                        });

                        group.dim_level = dimLevel;
                        group.state = state;
                        group.sameLevel = sameLevel;
                        group.trimLevel = trimLevel;

                        return group;
                    }

                    function filterSelectedGroups(groups) {
                        return _.filter(groups, 'zones');
                    }

                    gDC.updateGroup = function (group, trigger) {
                        group.ajaxPending = true;

                        if (trigger === 'button') {
                            group.state = !group.state;
                        } else {
                            group.state = true;
                        }

                        Areas.groupControlOperate(group).then(function () {
                            var socketUpdate = false;
                            applyUpdate(group, socketUpdate);
                        })['catch'](function (err) {
                            console.log(err);
                            group.sameLevel = false;
                            group.ajaxPending = false;
                        });
                    };

                    gDC['delete'] = function (group) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure to delete this group?').then(function () {
                            group.ajaxPending = true;
                            Areas.delGroupControl(group).then(function () {
                                _.remove(gDC.groups, function (item) {
                                    return item.id === group.id;
                                });
                            });
                        });
                    };
                }
            };

            _export('default', groupDimmingComponent);
        }
    };
});

$__System.register('6d', [], function (_export) {
    'use strict';

    var overviewZonesComponent;
    return {
        setters: [],
        execute: function () {
            overviewZonesComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="zones.zones">Zones</span>\n        </h2>\n        <div class="overview-zones-list-wrapper">\n            <div class="overview-zones-list">\n                <overview-zone-control ng-repeat="zone in oZ.zones | orderBy: \'id_string\'" zone="zone"></overview-zone-control>\n\n                <p class="loading-spinner-label" ng-hide="oZ.zones !== undefined" translate="common.loadingEllipsis">Loading...</p>\n                <a ng-if="::oZ.zones.length == 0 && oZ.isAdmin" ui-sref="Devices({siteId:oZ.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'devices\'})" translate="zones.addAZone">Add a Zone</a>\n                <span ng-if="::oZ.zones.length == 0 && !oZ.isAdmin" translate="zones.noZone">No Zones</span>\n            </div>\n        </div>\n    ',
                bindings: {
                    itemCollection: '<',
                    siteId: '<',
                    isAdmin: '<'
                },
                controllerAs: 'oZ',
                controller: function controller($rootScope, $scope, $timeout, _) {

                    var oZ = this;

                    oZ.$onInit = function () {
                        oZ.zones = _.filter(oZ.itemCollection.group, 'visible_in_control');

                        oZ.socketListener = $scope.$on('event:socket:zoneState', updateZones);
                    };

                    oZ.$onDestroy = function () {
                        oZ.socketListener();

                        _.each(oZ.zones, function (zone) {
                            $timeout.cancel(zone.socketPending);
                        });
                    };

                    function updateZones(event, message) {
                        if (message.action === 'request') {
                            (function () {
                                //
                                // Match by zone id
                                //
                                var match = _.find(oZ.zones, ['id', message.id]);

                                if (match) {
                                    //
                                    // Mark as busy
                                    //
                                    match.socketPending = $timeout(function () {
                                        match.socketPending = false;
                                    }, 10000);

                                    $timeout(function () {
                                        $scope.$apply();
                                    });
                                }
                            })();
                        } else if (message.action === 'response') {
                            //
                            // Match by node id
                            //
                            var match = _.find(oZ.zones, { node: message.node_id });

                            if (match) {
                                console.log('Socket Zone Update: ' + match.id_string, message.zone_state, message.reported_dim_level);

                                $timeout.cancel(match.socketPending);

                                match.socketPending = false;
                                match.reported_cct = message.reported_cct;
                                match.reported_dim_level = message.reported_dim_level;
                                match.zone_state = message.zone_state;
                                match.zone_health = message.zone_health;
                            }
                        }

                        //
                        // Replace this shit with bindings to parent
                        //

                        $rootScope.$broadcast('event:updateEnergy');
                    }
                }
            };

            _export('default', overviewZonesComponent);
        }
    };
});

$__System.register('6e', [], function (_export) {
    'use strict';

    var overviewZonesControlComponent;

    function overviewZoneControlCtrl() {
        var oZC = this;

        oZC.updateZone = function (zone) {
            zone.zone_state = !zone.zone_state;
            zone.toggle().then(function () {
                zone.zone_state = !zone.zone_state; //????
            });
        };

        oZC.updateColorTemp = function (zone) {
            zone.updateColorTemp(zone.color_temp);
        };
    }

    return {
        setters: [],
        execute: function () {
            overviewZonesControlComponent = {
                template: '\n        <div class="overview-zone" ng-class="{\n                \'color-temp\' : oZC.zone.is_tunable, \n                \'has-slider\' : oZC.zone.is_dimmable, \n                \'on\' : oZC.zone.zone_state,\n                \'trimmed\' : oZC.zone.trim_high < 100, \n                \'trim-maxed\' : oZC.zone.trim_high === oZC.zone.reported_dim_level && oZC.zone.trim_high < 100, \n                \'disabled\' : oZC.zone.controlledBySensor, \n                \'color-temp-expanded\' : oZC.zone.color_temp_expanded && !oZC.zone.rgb_mode, \n                \'rgb-expanded\' : oZC.zone.rgb_mode && oZC.zone.is_tunable,\n                \'rgb-wheel-expanded\' : oZC.zone.rgb_mode && oZC.zone.showColorWheel\n            }" \n            title="{{::oZC.zone.controlledBySensor ? \'Controlled by Sensor \'+ oZC.zone.node : \'\'}}">\n\n            <button class="btn-push" ng-bind="oZC.zone.zone_state" ng-class="{on:oZC.zone.zone_state,loading:oZC.zone.ajaxPending,working:zone.socketPending,error:oZC.zone.ajaxError,disabled: oZC.zone.controlledBySensor}" ng-click="oZC.updateZone(oZC.zone)" ng-disabled="oZC.zone.ajaxPending || oZC.zone.ajaxError || oZC.zone.controlledBySensor"></button>\n\n            <div class="icon-cluster">\n                <energy-icon full-power="oZC.zone.full_power_reading" power-reporting="oZC.zone.power_reporting" smart-shift="oZC.zone.smart_shift" watts="oZC.zone.watts"></energy-icon>\n            </div>\n\n            <span class="zone-name">\n                {{::oZC.zone.id_string}}\n            </span>\n\n            <div ng-if="::oZC.zone.is_dimmable" class="slider-wrapper">\n                <slider \n                    floor="1" \n                    ceiling="{{oZC.zone.trim_high ? oZC.zone.trim_high : 100}}" \n                    step="1" \n                    precision="1" \n                    dim="true" \n                    level="oZC.zone.reported_dim_level" \n                    ng-model="oZC.zone.reported_dim_level" \n                    ng-model-high="100" \n                    enabled="::!oZC.zone.controlledBySensor" \n                    update="true"\n                ></slider>\n            </div>\n\n            <div ng-if="oZC.zone.is_tunable && !oZC.zone.rgb_mode && oZC.zone.color_temp_expanded" class="slider-wrapper color-temp">\n                <slider \n                    floor="{{oZC.zone.min_cct}}" \n                    ceiling="{{oZC.zone.max_cct}}" \n                    step="100" \n                    precision="1" \n                    dim="true" \n                    level="oZC.zone.reported_cct" \n                    ng-model="oZC.zone.reported_cct" \n                    ng-model-high="oZC.zone.max_cct" \n                    enabled="true" \n                    update="false" \n                    aux-function="oZC.updateColorTemp(oZC.zone);"\n                ></slider>\n            </div>\n\n\n            <overview-zone-rgb-control zone="oZC.zone"></overview-zone-rgb-control>\n\n        </div>\n    ',
                bindings: {
                    zone: '<'
                },
                controllerAs: 'oZC',
                controller: overviewZoneControlCtrl
            };

            overviewZoneControlCtrl.$inject = [];
            _export('default', overviewZonesControlComponent);
        }
    };
});

$__System.register('6f', ['70'], function (_export) {
    var _Object$keys, overviewZoneRGBControlComponent;

    function overviewZoneRGBControlCtrl($scope, $timeout) {
        // Store debounce timers per zone
        var rgbUpdateTimers = {};

        var rgbC = this;

        rgbC.$onInit = function () {
            if (rgbC.zone.is_tunable) {
                // Initialize RGB mode state if not set (default to CCT mode)
                if (rgbC.zone.rgb_mode === undefined) {
                    rgbC.zone.rgb_mode = false;
                }
                // Initialize hue value if not set
                if (rgbC.zone.reported_hue === undefined) {
                    rgbC.zone.reported_hue = 0;
                }
                // Initialize color wheel display state
                if (rgbC.zone.showColorWheel === undefined) {
                    rgbC.zone.showColorWheel = false;
                }
                // Ensure CCT slider is expanded when in CCT mode (not RGB mode)
                if (!rgbC.zone.rgb_mode && rgbC.zone.color_temp_expanded === undefined) {
                    rgbC.zone.color_temp_expanded = true;
                }

                // Initialize color wheel if in RGB mode and wheel is shown
                if (rgbC.zone.rgb_mode && rgbC.zone.showColorWheel) {
                    $timeout(function () {
                        rgbC.initColorWheel(rgbC.zone);
                    }, 0);
                }
            }
        };

        rgbC.cleanupColorWheel = function (zone) {
            if (zone.showColorWheel) {
                zone.showColorWheel = false;
                // Clean up event listeners
                var canvasId = 'color-wheel-canvas-' + zone.id;
                var canvas = document.getElementById(canvasId);
                if (canvas && canvas._mouseDownHandler) {
                    canvas.removeEventListener('mousedown', canvas._mouseDownHandler);
                    canvas.removeEventListener('mousemove', canvas._mouseMoveHandler);
                    canvas.removeEventListener('mouseup', canvas._mouseUpHandler);
                    canvas.removeEventListener('mouseleave', canvas._mouseUpHandler);
                }
                // Cancel any pending debounce timer for this zone
                var zoneId = zone.id;
                if (rgbUpdateTimers[zoneId]) {
                    $timeout.cancel(rgbUpdateTimers[zoneId]);
                    delete rgbUpdateTimers[zoneId];
                }
            }
        };

        rgbC.setColorMode = function (zone, rgbMode) {
            // Don't do anything if already in the requested mode
            if (zone.rgb_mode === rgbMode) return;

            // Clean up color wheel if showing
            rgbC.cleanupColorWheel(zone);

            // Set the mode
            zone.rgb_mode = rgbMode;
            if (zone.rgb_mode) {
                // Switch to RGB mode - hide CCT slider, RGB slider will show automatically
                zone.color_temp_expanded = false;
            } else {
                // Switch to CCT mode - show CCT slider
                zone.color_temp_expanded = true;
            }
        };

        rgbC.toggleColorMode = function (zone) {
            // Legacy method for backwards compatibility - just toggle
            rgbC.setColorMode(zone, !zone.rgb_mode);
        };

        rgbC.updateRGB = function (zone, immediate) {
            if (zone.updateRGB) {
                if (immediate) {
                    // Slider update — always recalculate RGB from the current hue
                    var rgb = rgbC.hslToRgb((zone.reported_hue || 0) / 360, 1, 0.5);
                    zone.rgb_red = rgb[0];
                    zone.rgb_green = rgb[1];
                    zone.rgb_blue = rgb[2];
                } else if (zone.rgb_red === undefined || zone.rgb_green === undefined || zone.rgb_blue === undefined) {
                    // Color wheel path without RGB set yet — fall back to hue
                    var rgb = rgbC.hslToRgb((zone.reported_hue || 0) / 360, 1, 0.5);
                    zone.rgb_red = rgb[0];
                    zone.rgb_green = rgb[1];
                    zone.rgb_blue = rgb[2];
                }

                // If immediate is true (e.g., from slider), update without debounce
                if (immediate) {
                    zone.updateRGB();
                } else {
                    (function () {
                        // Debounce for color wheel updates
                        var zoneId = zone.id;
                        if (rgbUpdateTimers[zoneId]) {
                            $timeout.cancel(rgbUpdateTimers[zoneId]);
                        }
                        rgbUpdateTimers[zoneId] = $timeout(function () {
                            zone.updateRGB();
                            delete rgbUpdateTimers[zoneId];
                        }, 300);
                    })();
                }
            } else {
                // Fallback if updateRGB method doesn't exist on zone
                console.warn('updateRGB method not available on zone');
            }
        };

        rgbC.toggleColorWheel = function (zone) {
            if (zone.showColorWheel) {
                // Hide wheel - clean up
                rgbC.cleanupColorWheel(zone);
            } else {
                // Show wheel - initialize
                zone.showColorWheel = true;
                // Wait for DOM to update before initializing
                $timeout(function () {
                    rgbC.initColorWheel(zone);
                }, 50);
            }
        };

        rgbC.getColorPreview = function (zone) {
            // Use stored RGB values if available, otherwise calculate from hue with stored saturation/lightness
            if (zone.rgb_red !== undefined && zone.rgb_green !== undefined && zone.rgb_blue !== undefined) {
                return 'rgb(' + zone.rgb_red + ',' + zone.rgb_green + ',' + zone.rgb_blue + ')';
            } else {
                // Fallback: use stored saturation/lightness or defaults
                var hue = zone.reported_hue || 0;
                var sat = zone._saturation !== undefined ? zone._saturation : 1.0;
                var light = zone._lightness !== undefined ? zone._lightness : 0.5;
                var rgb = rgbC.hslToRgb(hue / 360, sat, light);
                return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
            }
        };

        rgbC.initColorWheel = function (zone) {
            var canvasId = 'color-wheel-canvas-' + zone.id;
            var canvas = document.getElementById(canvasId);
            if (!canvas) return;

            var ctx = canvas.getContext('2d');
            var centerX = canvas.width / 2;
            var centerY = canvas.height / 2;
            var radius = 90;

            // Store references on canvas for event handlers
            canvas._zone = zone;
            canvas._ctx = ctx;
            canvas._centerX = centerX;
            canvas._centerY = centerY;
            canvas._radius = radius;
            canvas._controller = rgbC;

            // Draw color wheel
            rgbC.drawColorWheel(canvas, ctx, centerX, centerY, radius);
            // Initialize indicator position at edge based on hue, or use stored position
            var initHue = zone.reported_hue || 0;
            var initAngle = initHue / 360 * 2 * Math.PI - Math.PI;
            var initIndicatorX = zone._indicatorX !== undefined ? zone._indicatorX : centerX + Math.cos(initAngle) * (radius - 3);
            var initIndicatorY = zone._indicatorY !== undefined ? zone._indicatorY : centerY + Math.sin(initAngle) * (radius - 3);
            // Use stored saturation/lightness if available, otherwise default to full color
            var initSaturation = zone._saturation !== undefined ? zone._saturation : 1.0;
            var initLightness = zone._lightness !== undefined ? zone._lightness : 0.5;
            rgbC.updateSelectionFromHue(canvas, ctx, centerX, centerY, radius, initHue, initIndicatorX, initIndicatorY, initSaturation, initLightness);

            // Create bound event handlers
            var mouseDownHandler = function mouseDownHandler(e) {
                rgbC.onColorWheelMouseDown(e, canvas);
            };
            var mouseMoveHandler = function mouseMoveHandler(e) {
                rgbC.onColorWheelMouseMove(e, canvas);
            };
            var mouseUpHandler = function mouseUpHandler(e) {
                rgbC.onColorWheelMouseUp(e);
            };

            // Store handlers for cleanup
            canvas._mouseDownHandler = mouseDownHandler;
            canvas._mouseMoveHandler = mouseMoveHandler;
            canvas._mouseUpHandler = mouseUpHandler;

            // Add event listeners
            canvas.addEventListener('mousedown', mouseDownHandler);
            canvas.addEventListener('mousemove', mouseMoveHandler);
            canvas.addEventListener('mouseup', mouseUpHandler);
            canvas.addEventListener('mouseleave', mouseUpHandler);
        };

        rgbC.drawColorWheel = function (canvas, ctx, centerX, centerY, radius) {
            var imageData = ctx.createImageData(canvas.width, canvas.height);
            var data = imageData.data;

            for (var y = 0; y < canvas.height; y++) {
                for (var x = 0; x < canvas.width; x++) {
                    var dx = x - centerX;
                    var dy = y - centerY;
                    var distance = Math.sqrt(dx * dx + dy * dy);
                    var angle = Math.atan2(dy, dx);

                    var index = (y * canvas.width + x) * 4;

                    if (distance <= radius) {
                        // Convert angle to hue (0-360)
                        var hue = (angle + Math.PI) / (2 * Math.PI) * 360;
                        if (hue < 0) hue += 360;

                        // Calculate normalized distance (0 = center, 1 = edge)
                        var normalizedDistance = distance / radius;
                        var inverseDistance = 1 - normalizedDistance; // 0 at edge, 1 at center

                        // Saturation: decreases from edge to center
                        // Edge = 1.0 (full color), Center = 0 (white)
                        // Use power curve so saturation drops more dramatically near center
                        var saturation = normalizedDistance; // Linear for now

                        // Lightness: increases from edge to center
                        // Edge = 0.5 (medium brightness), Center = 1.0 (white/bright)
                        // Use quadratic curve to make it lighter more dramatically as you approach center
                        var lightness = 0.5 + inverseDistance * inverseDistance * 0.5; // Quadratic curve

                        // Convert HSL to RGB
                        var rgb = rgbC.hslToRgb(hue / 360, saturation, lightness);

                        data[index] = rgb[0]; // R
                        data[index + 1] = rgb[1]; // G
                        data[index + 2] = rgb[2]; // B
                        data[index + 3] = 255; // A
                    } else {
                            data[index] = 255; // R
                            data[index + 1] = 255; // G
                            data[index + 2] = 255; // B
                            data[index + 3] = 0; // A (transparent)
                        }
                }
            }

            ctx.putImageData(imageData, 0, 0);
        };

        rgbC.hslToRgb = function (h, s, l) {
            var r = undefined,
                g = undefined,
                b = undefined;
            if (s === 0) {
                r = g = b = l;
            } else {
                var hue2rgb = function hue2rgb(p, q, t) {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
        };

        rgbC.getMousePos = function (e, canvas) {
            var rect = canvas.getBoundingClientRect();
            return {
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            };
        };

        rgbC.updateSelectionFromPosition = function (canvas, ctx, centerX, centerY, radius, x, y, zone) {
            var dx = x - centerX;
            var dy = y - centerY;
            var distance = Math.sqrt(dx * dx + dy * dy);

            // Allow clicking anywhere within the circle
            if (distance <= radius) {
                var angle = Math.atan2(dy, dx);
                var hue = (angle + Math.PI) / (2 * Math.PI) * 360;
                if (hue < 0) hue += 360;

                // Calculate normalized distance (0 = center, 1 = edge)
                var normalizedDistance = distance / radius;
                var inverseDistance = 1 - normalizedDistance; // 0 at edge, 1 at center

                // Saturation: decreases from edge to center
                // Edge = 1.0 (full color), Center = 0 (white)
                // Linear decrease ensures smooth transition
                var saturation = normalizedDistance;

                // Lightness: increases from edge to center
                // Edge = 0.5 (medium brightness), Center = 1.0 (white/bright)
                // Use quadratic curve to make it lighter more dramatically as you approach center
                var lightness = 0.5 + inverseDistance * inverseDistance * 0.5; // Quadratic curve

                zone.reported_hue = Math.round(hue);

                // Store saturation and lightness so we can use them for indicator/preview
                zone._saturation = saturation;
                zone._lightness = lightness;

                // Calculate RGB values from HSL
                // When saturation is 0, hue doesn't matter and lightness determines white/gray/black
                // When saturation > 0, hue determines color and lightness makes it lighter/darker
                var rgb = rgbC.hslToRgb(hue / 360, saturation, lightness);
                zone.rgb_red = rgb[0];
                zone.rgb_green = rgb[1];
                zone.rgb_blue = rgb[2];

                // Store the click position for the indicator
                zone._indicatorX = x;
                zone._indicatorY = y;

                // Update visual immediately with the actual saturation and lightness
                rgbC.updateSelectionFromHue(canvas, ctx, centerX, centerY, radius, zone.reported_hue, zone._indicatorX, zone._indicatorY, saturation, lightness);
                $scope.$apply();

                // Debounce the API call (300ms delay)
                // Call updateRGB with false to use debounce timer
                rgbC.updateRGB(zone, false);
            }
        };

        rgbC.updateSelectionFromHue = function (canvas, ctx, centerX, centerY, radius, hue, indicatorX, indicatorY, saturation, lightness) {
            // Redraw wheel
            rgbC.drawColorWheel(canvas, ctx, centerX, centerY, radius);

            // Use provided indicator position, or calculate from angle at edge
            var x = undefined,
                y = undefined;
            if (indicatorX !== undefined && indicatorY !== undefined) {
                // Ensure indicator is within circle bounds
                var dx = indicatorX - centerX;
                var dy = indicatorY - centerY;
                var distance = Math.sqrt(dx * dx + dy * dy);
                if (distance > radius) {
                    // Clamp to edge if outside
                    var angle = Math.atan2(dy, dx);
                    x = centerX + Math.cos(angle) * (radius - 3);
                    y = centerY + Math.sin(angle) * (radius - 3);
                } else {
                    x = indicatorX;
                    y = indicatorY;
                }
            } else {
                // Fallback: position at edge based on angle
                var angle = hue / 360 * 2 * Math.PI - Math.PI;
                var indicatorRadius = radius - 3;
                x = centerX + Math.cos(angle) * indicatorRadius;
                y = centerY + Math.sin(angle) * indicatorRadius;
            }

            // Draw selection circle with border
            ctx.strokeStyle = '#000';
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.arc(x, y, 7, 0, Math.PI * 2);
            ctx.stroke();

            ctx.strokeStyle = '#fff';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(x, y, 7, 0, Math.PI * 2);
            ctx.stroke();

            // Fill with the actual selected color (use provided saturation and lightness, or default)
            var sat = saturation !== undefined ? saturation : 1.0;
            var light = lightness !== undefined ? lightness : 0.5;
            var rgb = rgbC.hslToRgb(hue / 360, sat, light);
            ctx.fillStyle = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
            ctx.beginPath();
            ctx.arc(x, y, 5, 0, Math.PI * 2);
            ctx.fill();
        };

        // Mouse event handlers for color wheel
        rgbC.colorWheelMouseDown = {};

        rgbC.onColorWheelMouseDown = function (e, canvas) {
            if (!canvas) canvas = e.target;
            var zoneId = canvas._zone.id;
            rgbC.colorWheelMouseDown[zoneId] = true;
            var pos = rgbC.getMousePos(e, canvas);
            rgbC.updateSelectionFromPosition(canvas, canvas._ctx, canvas._centerX, canvas._centerY, canvas._radius, pos.x, pos.y, canvas._zone);
        };

        rgbC.onColorWheelMouseMove = function (e, canvas) {
            if (!canvas) canvas = e.target;
            var zoneId = canvas._zone.id;
            if (rgbC.colorWheelMouseDown[zoneId]) {
                var pos = rgbC.getMousePos(e, canvas);
                rgbC.updateSelectionFromPosition(canvas, canvas._ctx, canvas._centerX, canvas._centerY, canvas._radius, pos.x, pos.y, canvas._zone);
            }
        };

        rgbC.onColorWheelMouseUp = function (e) {
            // Clear all mouse down states when mouse is released
            _Object$keys(rgbC.colorWheelMouseDown).forEach(function (key) {
                rgbC.colorWheelMouseDown[key] = false;
            });
        };
    }

    return {
        setters: [function (_) {
            _Object$keys = _['default'];
        }],
        execute: function () {
            'use strict';

            overviewZoneRGBControlComponent = {
                template: '\n        <div class="color-mode-tabs" ng-if="rgbC.zone.is_tunable && rgbC.zone.is_rgb">\n            <button class="color-mode-tab" ng-class="{active: !rgbC.zone.rgb_mode}" ng-click="rgbC.setColorMode(rgbC.zone, false)" title="CCT Mode">\n                <span class="cct-icon"></span>\n                <span>{{rgbC.zone.reported_cct}}K</span>\n            </button>\n            <button class="color-mode-tab" ng-class="{active: rgbC.zone.rgb_mode}" ng-click="rgbC.setColorMode(rgbC.zone, true)" title="RGB Mode">\n                RGB\n            </button>\n        </div>\n        <div ng-if="rgbC.zone.is_tunable && rgbC.zone.rgb_mode && !rgbC.zone.showColorWheel" class="slider-wrapper rgb">\n            <slider \n                floor="0" \n                ceiling="360" \n                step="1" \n                precision="0" \n                dim="true" \n                level="rgbC.zone.reported_hue || 0" \n                ng-model="rgbC.zone.reported_hue" \n                ng-model-high="360" \n                enabled="true" \n                update="false" \n                aux-function="rgbC.updateRGB(rgbC.zone, true);"\n            ></slider>\n            <button class="color-wheel-btn" ng-click="rgbC.toggleColorWheel(rgbC.zone)" title="Show Color Wheel">\n                <span class="chevron-icon">›</span>\n            </button>\n        </div>\n        <div ng-if="rgbC.zone.is_tunable && rgbC.zone.rgb_mode && rgbC.zone.showColorWheel" class="slider-wrapper rgb rgb-wheel-wrapper">\n            <canvas id="color-wheel-canvas-{{rgbC.zone.id}}" width="200" height="200" class="color-wheel-canvas"></canvas>\n            <div class="color-preview-small" ng-style="{\'background-color\': rgbC.getColorPreview(rgbC.zone)}"></div>\n            <button class="color-wheel-close-btn" ng-click="rgbC.toggleColorWheel(rgbC.zone)" title="Show Slider">×</button>\n        </div>\n    ',
                bindings: {
                    zone: '<'
                },
                controllerAs: 'rgbC',
                controller: overviewZoneRGBControlCtrl
            };

            overviewZoneRGBControlCtrl.$inject = ['$scope', '$timeout'];
            _export('default', overviewZoneRGBControlComponent);
        }
    };
});

$__System.registerDynamic("71", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading\">\n    <span translate=\"energy.currentDemand\">Current Demand</span>\n</h2>\n<div class=\"demand\">\n    <h1 class=\"energy\">\n        <div class=\"energy-spin\" ng-repeat=\"int in oE.visibleEnergyDemand\">\n            <span class=\"digit-{{int.val}}\" ng-class=\"{'beginAnimate': oE.energyAnimate}\">0 1 2 3 4 5 6 7 8 9</span>\n        </div>\n        <span class=\"watts\">Watts</span>\n    </h1>\n    <div class=\"help \"id=\"power\">\n        <div class=\"arrow\"></div>\n        <!-- <i class=\"bolt\"></i> --><h1 translate=\"energy.currentDemand\">Current Demand</h1>\n\n        <ul>\n            <li><i class=\"zone-watts ready\"></i><span translate=\"energy.calculateWith\">Calculated with actual power usage data.</span></li>\n            <li><i class=\"zone-watts collecting\"></i><span translate=\"energy.powerMonitoring\">Power monitoring enabled but no data yet.</span></li>\n            <li><i class=\"zone-watts\"></i><span translate=\"energy.selfReport\">Self-reported power usage.</span></li>\n        </ul>\n\n        <p ng-if=\"oE.hiddenZones.length\">{{oE.hiddenZones.length}} {{'energy.hiddenZonesUsing' | translate}} {{oE.hiddenEnergyDemand}} {{'devices.watts' | translate}}</p>\n        <!--<a href=\"/learn-more\" target=\"_blank\" translate=\"energy.learnMore\">Learn More</a>-->\n    </div>\n\n    <div class=\"help\" id=\"not-reporting\">\n        <div class=\"arrow\"></div>\n        <!-- <i class=\"exclamation-circle\"></i> --><h1 translate=\"energy.warning\">Warning</h1>\n        <h2>{{oE.visibleZonesNotReporting.length}} Device{{oE.visibleZonesNotReporting.length == 1 ? ' is' : 's are'}} not power reporting</h2>\n        <p translate=\"energy.weNotice\">We noticed you have Zones that aren't reporting any demand. Either enable Power Monitoring or self-report using the Watts field.</p>\n    </div>\n    <i class=\"bolt\" help data-help-div=\"power\"></i>\n    <i ng-if=\"oE.visibleZonesNotReporting.length > 0\" class=\"exclamation-circle\" help data-help-div=\"not-reporting\"></i>\n\n    <div class=\"help\" id=\"smart-shifting\">\n        <div class=\"arrow\"></div>\n        <!-- <i class=\"zone-smart-shifting\"></i> --><h1 translate=\"energy.smartShift\">Smart Shift</h1>\n        <h2>{{oE.zonesSmartShifting.length}} Device{{oE.zonesSmartShifting.length == 1 ? ' is' : 's are'}} smart shifting</h2>\n        <p translate=\"energy.smartShiftExplanation\">Some of your zones are part of a Smart Shift schedule and will automatically adjust their color temperature.</p>\n    </div>\n    <i ng-if=\"oE.zonesSmartShifting.length > 0\" class=\"zone-smart-shifting\" help data-help-div=\"smart-shifting\"></i>    \n</div>\n\n<h2 class=\"overview-heading cog\">\n    <a class=\"cog\" ui-sref=\"Energy({siteId:oE.siteId, userSelectedFilter: null, leftMenuSpecialContext: 'overview'})\"><span id=\"energy-view-all\" translate=\"common.viewAll\">VIEW ALL</span></a>\n    <span translate=\"energy.energyUsage\">ENERGY USAGE</span>\n</h2>\n<div class=\"overview-energy-graph\">\n    <div ng-if=\"oE.energyOverviewChartTotal > 0\">\n        <energy-double-chart-directive chart-data-old=\"oE.energyOverviewChartOld\" chart-data-new=\"oE.energyOverviewChartNew\" chart-height=200 chart-top=6 id=\"DChart2\">\n    </div>\n    <p ng-if=\"oE.energyOverviewChartTotal <= 0\" translate=\"energy.currentNoReport\">Currently there is no energy report for this week</p>\n</div>";
});
$__System.register('72', ['71'], function (_export) {
    'use strict';

    var overviewEnergyTemplate, overviewEnergyComponent;
    return {
        setters: [function (_2) {
            overviewEnergyTemplate = _2['default'];
        }],
        execute: function () {
            overviewEnergyComponent = {
                template: overviewEnergyTemplate,
                bindings: {
                    itemCollection: '<',
                    siteId: '<'
                },
                controllerAs: 'oE',
                controller: function controller($scope, $q, Energy, moment, _) {

                    var oE = this;

                    var days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

                    $scope.$on('event:startEnergyAnimation', startEnergyAnimation);
                    $scope.$on('event:updateEnergy', getDemand);

                    oE.$onInit = function () {
                        if (oE.itemCollection.group.length) {
                            // var devicesInNoZoneMode = _.filter(oE.siteData.devices, function(device){
                            //     return device.settings["device_mode"] == "trigger" || device.settings["device_mode"] == "repeater";
                            // })

                            // oE.visibleZones = _.filter(oE.itemCollection, function(zone){
                            //     return !_.find(devicesInNoZoneMode, function(device){ return device.id == zone.node });
                            // })

                            /*
                                See notes in zoneFactory re hidden zones
                             */
                            oE.visibleZones = _.filter(oE.itemCollection.group, { hidden: false });
                            oE.hiddenZones = _.filter(oE.itemCollection.group, { hidden: true });

                            oE.visibleZonesSmartShifting = _.filter(oE.visibleZones, 'smart_shift');

                            getDemand();

                            if (oE.visibleZones.length) {
                                getEnergy(oE.visibleZones);
                            }
                        }
                    };

                    function startEnergyAnimation() {
                        oE.energyAnimate = true;
                    }

                    function getDemand() {
                        var visibleDemand = Energy.getDemand(oE.visibleZones);
                        var hiddenDemand = Energy.getDemand(oE.hiddenZones);

                        // Ensure we have a valid number before processing
                        var demandValue = parseFloat(visibleDemand.currentDemand) || 0;
                        oE.visibleEnergyDemand = splitMapEnergy(Math.round(demandValue));

                        oE.hiddenEnergyDemand = hiddenDemand.currentDemand;

                        oE.visibleZonesNotReporting = visibleDemand.notReporting;

                        oE.energyAnimate = false;
                    }

                    function splitMapEnergy(energy) {
                        var split = _.map(energy.toString(10).split(''), function (val, key) {
                            //Avoid dupes in repeater
                            return { 'key': key, 'val': val };
                        });
                        return split;
                    }

                    function getDay(k, week) {
                        return week[k] ? Math.round(week[k][3] * 1000) / 1000 : 0;
                    }

                    function usageMap(day, k, period) {
                        return { 'month': day, 'usage': getDay(k, period) };
                    }

                    function getEnergy(collection) {
                        var nearestMinute = moment().utc().startOf('minute').unix(); //Cut multiple ajax for slightly different reqs

                        var energyPromises = [Energy.getBySeconds('day', moment().utc().startOf('week').unix(), nearestMinute, collection, false), Energy.getBySeconds('day', moment().utc().startOf('week').subtract(7, 'days').unix(), moment().utc().startOf('week').add(1, 'seconds').unix(), collection, false)];

                        $q.all(energyPromises).then(function (result) {

                            oE.weekAsDays = result[0].combined;
                            oE.lastWeekAsDays = result[1].combined;

                            oE.energyOverviewChartNew = _.map(days, function (day, k) {
                                return usageMap(day, k, oE.weekAsDays);
                            });
                            oE.energyOverviewChartOld = _.map(days, function (day, k) {
                                return usageMap(day, k, oE.lastWeekAsDays);
                            });

                            oE.energyOverviewChartTotal = oE.energyOverviewChartNew.map(function (b) {
                                return b.usage;
                            }).reduce(function (p, c) {
                                return p + c;
                            });
                        });
                    }
                }
            };

            _export('default', overviewEnergyComponent);
        }
    };
});

$__System.register('73', [], function (_export) {
  'use strict';

  var overviewStates;
  return {
    setters: [],
    execute: function () {
      overviewStates = {
        parent: 'site',
        name: 'Overview',
        url: '/overview/{userSelectedFilter}',
        resolve: {
          sessionData: function sessionData(Session) {
            return Session.getSiteData(false);
          },
          itemCollection: function itemCollection(sessionData, StructureService) {
            return StructureService.itemCollection(sessionData, 'zones');
          }
        },

        component: 'overviewBase',

        params: {
          allowDragDrop: true,
          extraSections: ['groups', 'scenes']
        },
        title: 'Overview'
      };

      _export('overviewStates', overviewStates);
    }
  };
});

$__System.register('74', ['3', '59', '69', '72', '73', '6a', '6c', '6d', '6e', '6f'], function (_export) {
    'use strict';

    //import overviewSchedulesComponent from './overviewSchedulesComponent';
    //import overviewSchedulesModalComponent from './overviewSchedulesModalComponent';
    var angular, overviewScenesModalCtrl, overviewScenesComponent, overviewEnergyComponent, overviewStates, overviewBaseComponent, groupDimmingComponent, overviewZonesComponent, overviewZoneControlComponent, overviewZoneRGBControlComponent, overviewModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            overviewScenesModalCtrl = _2['default'];
        }, function (_3) {
            overviewScenesComponent = _3['default'];
        }, function (_4) {
            overviewEnergyComponent = _4['default'];
        }, function (_5) {
            overviewStates = _5.overviewStates;
        }, function (_a) {
            overviewBaseComponent = _a['default'];
        }, function (_c) {
            groupDimmingComponent = _c['default'];
        }, function (_d) {
            overviewZonesComponent = _d['default'];
        }, function (_e) {
            overviewZoneControlComponent = _e['default'];
        }, function (_f) {
            overviewZoneRGBControlComponent = _f['default'];
        }],
        execute: function () {
            overviewModule = angular.module('overview', []).controller('overviewScenesModal', overviewScenesModalCtrl).component('overviewBase', overviewBaseComponent).component('overviewScenes', overviewScenesComponent)
            //.component('overviewSchedules', overviewSchedulesComponent)
            //.component('overviewSchedulesModal', overviewSchedulesModalComponent)
            .component('overviewZones', overviewZonesComponent).component('overviewZoneControl', overviewZoneControlComponent).component('overviewZoneRgbControl', overviewZoneRGBControlComponent).component('overviewEnergy', overviewEnergyComponent).component('groupDimming', groupDimmingComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(overviewStates);
            }]);

            _export('default', overviewModule);
        }
    };
});

$__System.register('75', [], function (_export) {
    'use strict';

    function Regtest($http, _) {

        this.getGatewayRecord = function (macAddress) {
            return $http({
                method: 'GET',
                data: macAddress,
                url: 'gateway/?mac_addr=' + macAddress
            }).then(function (response) {
                return response.status;
            })['catch'](function (error) {
                return error.status;
            });
        };
    }return {
        setters: [],
        execute: function () {
            Regtest.$inject = ['$http'];;

            _export('default', Regtest);
        }
    };
});

$__System.registerDynamic("76", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"content-wrapper\">\n  <div class=\"heading-container\">\n    <div class=\"image-and-text\">\n    <i class=\"lightcloud-logo\"></i>\n    <div class=\"heading-text\"><span>Lightcloud Gateway</span><br /><span>Backend Registration Tester</span></div>\n    </div>\n  </div>\n\n  <div class=\"input-container\">\n    <div id=\"device-id-label\">EUI64 (Device ID)</div>\n    <div class=\"input-fields\">\n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[0]\" ng-change=\"rB.isRegistered(0)\" ng-paste=\"rB.handlePaste($event, 0)\" id=\"input0\" disabled> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[1]\" ng-change=\"rB.isRegistered(1)\" ng-paste=\"rB.handlePaste($event, 0)\" id=\"input1\" disabled> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[2]\" ng-change=\"rB.isRegistered(2)\" ng-paste=\"rB.handlePaste($event, 0)\" id=\"input2\" disabled> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[3]\" ng-change=\"rB.isRegistered(3)\" ng-paste=\"rB.handlePaste($event, 0)\" id=\"input3\" disabled> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[4]\" ng-change=\"rB.isRegistered(4)\" ng-paste=\"rB.handlePaste($event, 4)\" id=\"input4\"> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[5]\" ng-change=\"rB.isRegistered(5)\" ng-paste=\"rB.handlePaste($event, 4)\" id=\"input5\"> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[6]\" ng-change=\"rB.isRegistered(6)\" ng-paste=\"rB.handlePaste($event, 4)\" id=\"input6\"> \n    <input type=\"text\" maxlength=\"2\" ng-model=\"rB.inputs[7]\" ng-change=\"rB.isRegistered(7)\" ng-paste=\"rB.handlePaste($event, 4)\" id=\"input7\"><br>\n    </div>\n    <button id=\"clearButton\" ng-click=\"rB.clearInputs()\">Clear</button>\n  </div>\n\n  <div class=\"device-status-container\">\n    <div ng-show=\"rB.registered === true\" class=\"device-status\">\n      <div class=\"check\"></div>\n      <p class=\"registered-status registered\">Registered</p>\n    </div>\n    <div ng-show=\"rB.registered === false\" class=\"device-status\">\n      <div class=\"multiply\"></div>\n      <p class=\"registered-status unregistered\">Not Registered</p>\n    </div>\n  </div>\n</div>\n";
});
$__System.register('77', ['76'], function (_export) {
  'use strict';

  var regtestBaseTemplate, regtestBaseComponent;
  return {
    setters: [function (_2) {
      regtestBaseTemplate = _2['default'];
    }],
    execute: function () {
      regtestBaseComponent = {
        template: regtestBaseTemplate,
        bindings: {},
        controllerAs: 'rB',
        controller: function controller(Regtest, _, Local, LcFn) {
          var rB = this;
          rB.$onInit = function () {};
          rB.inputs = ['00', '13', 'A2', '00', '', '', '', ''];
          rB.userInput = '';
          rB.clearButtonClicked = false;
          rB.allInputsFilled = false;
          rB.registered;

          rB.handlePaste = function (event, index) {
            // function to handle an easy copy paste
            // Prevent the default paste behavior
            event.preventDefault();

            // Get the pasted text from the clipboard
            var clipboardData = (event.originalEvent || event).clipboardData;
            var pastedText = clipboardData.getData('text');

            // Remove any non-alphanumeric characters from the pasted text
            var sanitizedText = pastedText.replace(/[^0-9A-Fa-f]/g, '');

            // Split the sanitized text into pairs of characters
            var pairs = [];
            for (var i = 0; i < sanitizedText.length; i += 2) {
              pairs.push(sanitizedText.slice(i, i + 2));
            }

            // Update the input fields with the pairs
            for (var i = 0; i < pairs.length && index < rB.inputs.length; i++, index++) {
              rB.inputs[index] = pairs[i];
            }

            // Trigger the input's ng-change function
            rB.isRegistered(index - 1);
          };

          rB.isRegistered = function (index) {
            // Funtion to handle user input
            // Focus through all the inputs
            if (rB.inputs[index].length === 2) {
              if (index !== rB.inputs.length - 1) {
                index++;
                document.getElementById('input' + index).focus();
              }

              // Check if the inputs are not empty or partially filled
              rB.allInputsFilled = rB.inputs.every(function (input) {
                return input !== '' && input.length === 2;
              });

              // Join the inputs list with colons and make the call
              if (rB.allInputsFilled) {
                var macAddress = rB.inputs.join(':');
                macAddress = '[' + macAddress + ']!';
                Regtest.getGatewayRecord(macAddress).then(function (response) {
                  // Backend call to check for a record
                  if (response === 200) {
                    rB.registered = true;
                  } else {
                    rB.registered = false;
                  }
                });
              }
            }
          };

          rB.clearInputs = function () {
            // Clear button function
            rB.inputs = ['00', '13', 'A2', '00', '', '', '', ''];
            document.getElementById('input0').focus();
            rB.clearButtonClicked = true;
            rB.registered = undefined;
          };
        }
      };

      _export('default', regtestBaseComponent);
    }
  };
});

$__System.register('78', [], function (_export) {
    'use strict';

    var regtestStates;
    return {
        setters: [],
        execute: function () {
            regtestStates = [{
                url: '/regtest',
                name: 'Regtest',
                component: 'regtestBase',
                title: 'Regtest',
                resolve: {
                    url: function url($rootScope, $state) {
                        if ($rootScope.staff) {
                            return true;
                        } else {
                            $state.go('Error');
                        }
                    }
                }
            }];

            _export('default', regtestStates);
        }
    };
});

$__System.register('79', ['3', '75', '77', '78'], function (_export) {
    'use strict';

    var angular, RegtestService, regtestBaseComponent, regtestStates, regtestModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            RegtestService = _2['default'];
        }, function (_3) {
            regtestBaseComponent = _3['default'];
        }, function (_4) {
            regtestStates = _4['default'];
        }],
        execute: function () {
            regtestModule = angular.module('regtest', []).service('Regtest', RegtestService).component('regtestBase', regtestBaseComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                regtestStates.forEach(function (state) {
                    return $stateRegistry.register(state);
                });
            }]);

            _export('default', regtestModule);
        }
    };
});

$__System.register('7a', [], function (_export) {
	'use strict';

	function RecurrenceSchedules($http, moment, Track, RecurrenceTransforms, LcFn, LcCache, _) {

		this.schedulesResponseMapping = schedulesResponseMapping;
		this.copiedSchedule = null;

		this.getSchedule = function (id) {
			return $http({
				url: 'schedule/' + id + '/',
				transformResponse: $http.defaults.transformResponse.concat([schedulesResponseMapping])
			});
		};

		this.getSchedulesForArea = function (id) {
			return $http({
				url: 'area/' + id + '/schedules/',
				transformResponse: $http.defaults.transformResponse.concat([schedulesResponseMapping])
			});
		};

		this.getSchedulesForSite = function (id) {
			return $http({
				//return $http.get({
				url: 'site/' + id + '/schedules/'
			}).then(function (response) {
				return response.data.schedules.map(schedulesResponseMapping);
			});
		};

		this.create = function (schedule) {
			return $http({
				url: 'schedule/',
				method: 'POST',
				data: schedule,
				transformRequest: scheduleRequestMapping,
				transformResponse: $http.defaults.transformResponse.concat([schedulesResponseMapping])
			}).success(function (result) {
				LcCache.updateSessionSiteSectionChild('schedules', [result]);
				Track.event('Schedule: Created', 'Schedule ' + schedule.id_string);
			});
		};

		this.update = function (schedule) {
			return $http({
				url: 'schedule/' + schedule.id + '/',
				method: 'PUT',
				data: schedule,
				transformRequest: scheduleRequestMapping,
				transformResponse: $http.defaults.transformResponse.concat([schedulesResponseMapping])
			}).success(function (result) {
				LcCache.updateSessionSiteSectionChild('schedules', [result]);
			});
		};

		this.del = function (schedule) {
			return $http({
				url: 'schedule/' + schedule.id + '/',
				method: 'DELETE'
			}).success(function () {
				LcCache.removeSessionSiteSectionChild('schedules', [schedule]);
				Track.event('Schedule: Deleted', 'Schedule ' + schedule.id_string);
			});
		};

		this.toggleEnabled = function (id) {
			var currentSchedules = LcCache.getSessionSiteSectionData('schedules');

			var targetSchedule = _.find(currentSchedules, { id: id });

			targetSchedule.enabled = !targetSchedule.enabled;

			return $http({
				url: 'schedule/' + id + '/',
				method: 'PUT',
				data: targetSchedule,
				transformRequest: scheduleRequestMapping,
				transformResponse: $http.defaults.transformResponse.concat([schedulesResponseMapping])
			}).success(function (result) {
				LcCache.updateSessionSiteSectionChild('schedules', [result]);
			});
		};

		this.legacyGetNextEvent = function (schedule, currentSite) {
			var nextEvent = {};

			if (schedule.events) {
				var offset = currentSite ? currentSite.locality.gmt_offset : '0';
				var today = moment().isoWeekday() - 1; //our backend monday is 0 indexed
				var now = moment().utcOffset(offset).unix();

				//Flatten days grouped by toMatrix
				var flatEvents = _.flatten(schedule.events);

				//Sort days 0-6
				var sortedEvents = _.sortBy(flatEvents, 'recurrencePeriodOptions', function (day) {
					return day[0];
				});

				nextEvent = _.find(sortedEvents, function (scheduleEvent) {
					if (scheduleEvent.recurrencePeriodOptions) {
						if (scheduleEvent.recurrencePeriodOptions[0] === today) {
							//Event is today
							if (scheduleEvent.sunPosition) {
								return moment(currentSite.locality['next_' + scheduleEvent.sunPosition], 'HH:mm:ss').unix() > now;
							} else {
								return moment(scheduleEvent.time, 'HH:mm').unix() > now;
							}
						}
					}
				});

				if (typeof nextEvent === 'undefined') {
					nextEvent = _.find(sortedEvents, function (scheduleEvent) {
						if (scheduleEvent.recurrencePeriodOptions) {
							return scheduleEvent.recurrencePeriodOptions[0] > today;
						}
					});
				}

				if (typeof nextEvent === 'undefined') {
					nextEvent = sortedEvents[0];
				}
			} else {
				nextEvent = { humanDescription: 'No Events' };
			}

			return nextEvent;
		};

		var blankRecurrence = {
			humanSentence: 'Select Time',
			startTime: {
				hour: '9',
				minute: '30',
				amPm: 'AM',
				date: null,
				sunPosition: false,
				offsetCharge: false
			},
			count: null,
			freq: null,
			interval: null,
			mode: null //Nothing for now
		};

		var Event = function Event(blank, lastItem) {
			this.blank = blank;
			this.recurrence = lastItem ? lastItem.recurrence : blankRecurrence;
			this.startTimeTouched = false;
		};

		this.blankSchedule = function (optName, optEvents, optType) {
			this.name = optName ? optName : 'Blank Schedule';
			this.type = optType ? optType : 'default';
			this.events = optEvents ? optEvents : [new Event(true)];
		};

		this.event = Event;

		function schedulesResponseMapping(schedule) {
			//Single schedule call for new single view
			//@todo seperate transforms ? - see singleScheduleCtrl promise
			//

			// if the response is an array (a validation error), return it as is
			// to prevent it from being processed as a schedule object
			if (Array.isArray(schedule)) {
				return schedule;
			}

			var events = [];

			if (schedule.events) {
				schedule.events.forEach(function (event, key) {
					events.push({
						object_type: event.object_type,
						object_id: event.object_id,
						dates: event.dates, //Ignored for now
						dim_level: event.dim_level, //Only relevant for zone content type
						recurrence: RecurrenceTransforms.parseRRulesFromBackend(event), //One rule per event at this point
						state: event.state ? true : false //Get rid of 1,0
					});
				});
			}

			return {
				id: schedule.id,
				name: schedule.id_string,
				enabled: schedule.enabled,
				behavior: schedule.behavior,
				events: events,
				//next 		: getNextEvent(events),
				areaId: schedule.areaId || null,
				siteId: schedule.site,
				type: LcFn.isSmartShiftType(schedule) ? 'smart' : 'default' //Temp for smart shift
			};
		}

		function scheduleRequestMapping(schedule) {
			var events = [];
			//
			// LcCache req here
			//
			var siteData = LcCache.getSessionSiteData();

			var gatewayGMToffset = siteData.locality.gmt_offset;

			schedule.events.forEach(function (event) {
				events.push({
					object_type: event.object_type,
					object_id: event.object_id,
					dates: [], //event.dates, ignored for now
					dim_level: event.dim_level, //Only relevant for zone content type
					rules: RecurrenceTransforms.parseRRulesToBackend(event.recurrence, gatewayGMToffset), //One rule per event at this point
					state: event.state ? 1 : 0 //1,0 for DM
				});
			});

			var data = {
				site: siteData.id,
				id_string: schedule.name,
				enabled: schedule.enabled,
				area_id: schedule.areaId,
				events: events
			};

			return angular.toJson(data);
		}
	}

	return {
		setters: [],
		execute: function () {
			RecurrenceSchedules.$inject = ['$http', 'moment', 'Track', 'RecurrenceTransforms', 'LcFn', 'LcCache', '_'];
			_export('default', RecurrenceSchedules);
		}
	};
});

$__System.register('7b', ['13', '7c'], function (_export) {
	var _classCallCheck, RRule, RecurrenceMapping;

	return {
		setters: [function (_2) {
			_classCallCheck = _2['default'];
		}, function (_c) {
			RRule = _c['default'];
		}],
		execute: function () {
			'use strict';

			RecurrenceMapping = function RecurrenceMapping(_, moment) {
				_classCallCheck(this, RecurrenceMapping);

				this.parseRRulesFromBackend = parseRRulesFromBackend;
				this.parseRRulesToBackend = parseRRulesToBackend;
				this.getHumanSentence = getHumanSentence;

				var paramMap = {
					byminute: { int: 0 },
					byhour: { int: 1 },
					bysun: { int: 2, 0: 'sunset', 1: 'sunrise' },
					byweekday: { int: 3 },
					bymonthday: { int: 4 },
					bymonth: { int: 5 }
				};

				function getHumanSentence(recurrence) {
					function trimRRuleText(recurrenceText) {
						return recurrenceText.split(' at')[0];
					}

					//Our time - outside of RRule for now
					var humanTime = timeDateParsers.parseMachineTime(recurrence.startTime);

					//'Once' is a special case - flag is if the count is set to 1
					var oneTime = recurrence.startTime.date ? 'on ' + moment(recurrence.startTime.date).format("dddd, MMMM Do YYYY") : '';
					var recurrenceText = _.get(recurrence, 'rrule.options.count') ? 'once ' + oneTime : recurrence.rrule.toText(); //@todo @tranlsate 'once'

					recurrenceText = trimRRuleText(recurrenceText);

					//End time if listed
					return humanTime + ' ' + recurrenceText || '';
				}

				function parseRRulesFromBackend(event) {

					// ---- Some differences between DM rRules and rrules.js ----
					//
					//	- No concept of sun position
					//  - bydom doesn't exist
					//  - yearly = 4?
					//	- bymonthday is bydom, byweekday is byday
					//
					// ----------------------------------------------------------

					var ruleFromlegacy = {
						freq: 2,
						interval: 1,
						params: mapFromBackedHelpers.getFakeParams(event)
					};

					var firstRule = ruleFromlegacy;

					if (event && event.rules && event.rules[0]) firstRule = event.rules[0];

					var rule = {};

					if (firstRule && firstRule.params) {

						//ISO weekday puts Sunday as 7
						_.each(firstRule.params, function (paramObj) {
							if (paramObj.param == 3) {
								//@todo @crust - Remove when ready
								//if(LcFn.ltVersion($rootScope.currentSite.gateways[0].gateway_version, '1.2.0')){
								paramObj.value++;
								//}

								if (paramObj.value == 7) {
									paramObj.value = 0;
								}
							}
						});

						var params = mapFromBackedHelpers.mapOurNames(firstRule.params);

						var rruleParams = _.pickBy({
							dtstart: timeDateParsers.parseTimeForRRule(firstRule.dtstart),
							until: firstRule.dtend ? moment(firstRule.dtend).toDate() : null,
							freq: firstRule.freq || '0', //Pickby ignores 0
							count: firstRule.count || false,
							interval: firstRule.interval || false,
							byweekday: params.byweekday ? params.byweekday : false,
							bymonth: params.bymonth ? params.bymonth : false,
							bymonthday: params.bymonthday ? params.bymonthday : false,
							byhour: params.byhour ? Math.abs(parseInt(params.byhour[0])) : false,
							byminute: params.byminute ? Math.abs(parseInt(params.byminute[0])) : false
						});

						rule.rrule = new RRule(rruleParams);

						//Add our own stuff
						rule.startTime = mapFromBackedHelpers.buildStartTime(rule, params);
						rule.dtend = firstRule.dtend;
						rule.humanSentence = getHumanSentence(rule);
						rule.interval = firstRule.interval;
						rule.freq = firstRule.freq;
						rule.eventId = firstRule.event;
					}

					return rule;
				}

				function parseRRulesToBackend(rule, gatewayGMToffset) {

					//RRule will remove these objects for us
					rule.rrule.origOptions.byminute = rule.rrule.origOptions.byminute ? rule.rrule.origOptions.byminute : 0;
					rule.rrule.origOptions.byhour = rule.rrule.origOptions.byhour ? rule.rrule.origOptions.byhour : 0;

					var params = [];

					// -- Sun Specific
					if (rule.startTime.sunPosition) {
						//Push the bysun param
						params.push({
							param: 2,
							value: rule.startTime.sunPosition == 'sunset' ? 0 : 1
						});

						//Set negative values
						if (rule.startTime.offsetCharge == 'before') {
							if (rule.rrule.origOptions.byhour > 0) rule.rrule.origOptions.byhour = 0 - rule.rrule.origOptions.byhour;
							if (rule.rrule.origOptions.byminute > 0) rule.rrule.origOptions.byminute = 0 - rule.rrule.origOptions.byminute;
						}
					} else {
						//Only convert to 24 hour for non sun events- (this caps sun event offset at 12 hours 59 mins)
						rule.rrule.origOptions.byhour = timeDateParsers.americanHoursToStandard(rule.startTime);
					}

					// --- Bit better
					_.each(rule.rrule.origOptions, function (paramSet, key) {
						if (paramMap[key]) {
							if (paramSet.constructor === Array) {
								//all except min and hour are arrays
								_.each(paramSet, function (value) {
									//ISO weekday puts Sunday as 7
									if (paramMap[key].int == 3) {
										if (value == 0) {
											value = 7; //We are now ISO Compliant
										}

										//@todo @crust - Remove when ready
										//if(LcFn.ltVersion($rootScope.currentSite.gateways[0].gateway_version, '1.2.0')){
										value--;
										//}
									}

									params.push({
										param: paramMap[key].int,
										value: value
									});
								});
							} else {
								params.push({
									param: paramMap[key].int,
									value: paramSet
								});
							}
						}
					});

					var cleanRule = {
						freq: rule.freq || 0,
						interval: rule.interval || 1,
						count: rule.count || rule.rrule.origOptions.count,
						dtstart: timeDateParsers.parseOurRuleDateToBackend(rule, 'startTime', gatewayGMToffset),
						dtend: rule.dtend,
						params: params
					};

					return [cleanRule];
				}

				var timeDateParsers = {

					americanHoursToStandard: function americanHoursToStandard(startTime) {
						return parseInt(moment(startTime.hour + startTime.amPm, 'hh A').hours());
					},

					parseOurRuleDateToBackend: function parseOurRuleDateToBackend(rule, time, gatewayGMToffset) {
						var date = null;
						var time = rule[time];

						if (time) {
							if (time.date) {
								var startDate = moment(time.date).format('MM-DD-YYYY');
								date = moment(startDate + ' ' + time.hour + ':' + time.minute + ' ' + time.amPm, 'MM-DD-YYYY hh:mm A').utcOffset(gatewayGMToffset).format();
							}
						}

						return date;
					},

					parseTimeForRRule: function parseTimeForRRule(dtstart) {
						if (dtstart) {
							dtstart = moment(dtstart).toDate();
						}

						return dtstart;
					},

					parseMachineTime: function parseMachineTime(time) {
						var humanTime = '',
						    hour = time.hour || 0,
						    min = time.minute || 0;

						if (time.sunPosition) {
							//Before / after and more than 0 hours / mins
							if (time.offsetCharge && (hour !== 0 || min !== 0)) {
								if (hour !== 0) {
									humanTime = hour > 1 ? hour + ' hours ' : hour + ' hour '; //Add hours
								}
								if (hour !== 0 && min !== 0) {
									humanTime = humanTime + ' and ';
								}
								if (min !== 0) {
									humanTime = min > 1 ? humanTime + min + ' minutes ' : humanTime + min + ' minute ';
								}
								humanTime = humanTime + time.offsetCharge + ' ' + time.sunPosition;
							} else {
								humanTime = time.sunPosition;
							}
						} else {
							//Only for times
							if (min < 10) {
								min = '0' + min;
							}

							//Time only
							humanTime = hour + ':' + min + time.amPm;
						}
						return humanTime;
					}
				};

				var mapFromBackedHelpers = {

					setCharge: function setCharge(params) {
						var charge = false;

						if (params.byhour || params.byminute) {
							charge = params.byminute && params.byminute[0] > 0 || params.byhour && params.byhour[0] > 0 ? 'after' : 'before';
						}

						return charge;
					},

					buildStartTime: function buildStartTime(rule, params) {
						var hour = rule.rrule.origOptions.byhour ? rule.rrule.origOptions.byhour : '00';
						var minute = rule.rrule.origOptions.byminute ? rule.rrule.origOptions.byminute : '00';

						var momentObj = moment().hour(hour).minutes(minute);

						var ourStart = {
							hour: params.bysun ? parseInt(momentObj.format('hh') == 12 ? 0 : momentObj.format('hh')) : momentObj.format('hh'), //For sun events - 12 to 0?
							minute: parseInt(momentObj.format('mm')),
							amPm: momentObj.format('A'),
							date: rule.rrule.origOptions.dtstart ? moment(rule.rrule.origOptions.dtstart).toDate() : null,
							sunPosition: params.bysun ? paramMap.bysun[params.bysun] : false,
							offsetCharge: mapFromBackedHelpers.setCharge(params)
						};

						return ourStart;
					},

					mapOurNames: function mapOurNames(params) {
						var ourParams = {};

						params.forEach(function (paramObj, key) {
							var paramName = _.findKey(paramMap, ['int', paramObj.param]);
							ourParams[paramName] ? ourParams[paramName].push(paramObj.value) : ourParams[paramName] = [paramObj.value];
						});

						return ourParams;
					},

					getFakeParams: function getFakeParams(event) {
						var params = [];

						if (event.days_of_week) {
							var days = JSON.parse(event.days_of_week);

							//Cover for old wonky schedules with multiple days listed
							var uniqDays = _.uniq(days);

							_.each(uniqDays, function (day) {
								params.push({
									param: 3,
									value: day
								});
							});

							var offsetAndTimeField = event.time;

							//Offset BS - why is this crammed into one field?
							if (offsetAndTimeField.indexOf('sunset') > -1 || offsetAndTimeField.indexOf('sunrise') > -1) {
								var sunPosition = offsetAndTimeField.split(/[+-]/)[0];

								//Set bysun param
								params.push({
									param: 2,
									value: sunPosition == 'sunset' ? 0 : 1
								});

								if (offsetAndTimeField.length > 7) {
									var offsetCharge = offsetAndTimeField.split(/([+-])/)[1];

									var offset = offsetAndTimeField.split(/[+-]/)[1];

									var eventTime = moment(offset, 'HH:mm');

									if (eventTime.minutes() > 0 || eventTime.hours() > 0) {
										params.push({
											param: 0,
											value: offsetCharge == '-' ? 0 - eventTime.minutes() : eventTime.minutes()
										}, {
											param: 1,
											value: offsetCharge == '-' ? 0 - eventTime.hours() : eventTime.hours()
										});
									}
								}
							} else {
								var eventTime = moment(event.time, 'HH:mm');

								params.push({
									param: 0,
									value: eventTime.minutes()
								}, {
									param: 1,
									value: eventTime.hours()
								});
							}
						}

						return params;
					}
				};
			};

			_export('default', RecurrenceMapping);
		}
	};
});

$__System.registerDynamic('7d', [], true, function ($__require, exports, module) {
  /* */
  "format cjs";
  /*!
   * rrule.js - Library for working with recurrence rules for calendar dates.
   * https://github.com/jakubroztocil/rrule
   *
   * Copyright 2010, Jakub Roztocil and Lars Schoning
   * Licenced under the BSD licence.
   * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
   *
   */

  /**
   *
   * Implementation of RRule.fromText() and RRule::toText().
   *
   *
   * On the client side, this file needs to be included
   * when those functions are used.
   *
   */
  /* global module, define */

  var global = this || self,
      GLOBAL = global;
  ;(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
      module.exports = factory();
    } else if (typeof undefined === 'function' && define.amd) {
      define([], factory);
    } else {
      root._getRRuleNLP = factory();
    }
  })(typeof window === 'object' ? window : this, function () {
    // =============================================================================
    // Helper functions
    // =============================================================================

    /**
     * Return true if a value is in an array
     */
    var contains = function (arr, val) {
      return arr.indexOf(val) !== -1;
    };

    return function (RRule) {
      // =============================================================================
      // ToText
      // =============================================================================

      /**
       *
       * @param {RRule} rrule
       * Optional:
       * @param {Function} gettext function
       * @param {Object} language definition
       * @constructor
       */
      var ToText = function (rrule, gettext, language) {
        this.text = '';
        this.language = language || ENGLISH;
        this.gettext = gettext || function (id) {
          return id;
        };

        this.rrule = rrule;
        this.freq = rrule.options.freq;
        this.options = rrule.options;
        this.origOptions = rrule.origOptions;

        if (this.origOptions.bymonthday) {
          var bymonthday = [].concat(this.options.bymonthday);
          var bynmonthday = [].concat(this.options.bynmonthday);

          bymonthday.sort();
          bynmonthday.sort();
          bynmonthday.reverse();
          // 1, 2, 3, .., -5, -4, -3, ..
          this.bymonthday = bymonthday.concat(bynmonthday);
          if (!this.bymonthday.length) this.bymonthday = null;
        }

        if (this.origOptions.byweekday) {
          var byweekday = !(this.origOptions.byweekday instanceof Array) ? [this.origOptions.byweekday] : this.origOptions.byweekday;
          var days = String(byweekday);

          this.byweekday = {
            allWeeks: byweekday.filter(function (weekday) {
              return !weekday.n;
            }),
            someWeeks: byweekday.filter(function (weekday) {
              return Boolean(weekday.n);
            }),
            isWeekdays: days.indexOf('MO') !== -1 && days.indexOf('TU') !== -1 && days.indexOf('WE') !== -1 && days.indexOf('TH') !== -1 && days.indexOf('FR') !== -1 && days.indexOf('SA') === -1 && days.indexOf('SU') === -1
          };

          var sortWeekDays = function (a, b) {
            return a.weekday - b.weekday;
          };

          this.byweekday.allWeeks.sort(sortWeekDays);
          this.byweekday.someWeeks.sort(sortWeekDays);

          if (!this.byweekday.allWeeks.length) this.byweekday.allWeeks = null;
          if (!this.byweekday.someWeeks.length) this.byweekday.someWeeks = null;
        } else {
          this.byweekday = null;
        }
      };

      var common = ['count', 'until', 'interval', 'byweekday', 'bymonthday', 'bymonth'];
      ToText.IMPLEMENTED = [];
      ToText.IMPLEMENTED[RRule.HOURLY] = common;
      ToText.IMPLEMENTED[RRule.MINUTELY] = common;
      ToText.IMPLEMENTED[RRule.DAILY] = ['byhour'].concat(common);
      ToText.IMPLEMENTED[RRule.WEEKLY] = common;
      ToText.IMPLEMENTED[RRule.MONTHLY] = common;
      ToText.IMPLEMENTED[RRule.YEARLY] = ['byweekno', 'byyearday'].concat(common);

      /**
       * Test whether the rrule can be fully converted to text.
       * @param {RRule} rrule
       * @return {Boolean}
       */
      ToText.isFullyConvertible = function (rrule) {
        var canConvert = true;

        if (!(rrule.options.freq in ToText.IMPLEMENTED)) return false;
        if (rrule.origOptions.until && rrule.origOptions.count) return false;

        for (var key in rrule.origOptions) {
          if (contains(['dtstart', 'wkst', 'freq'], key)) return true;
          if (!contains(ToText.IMPLEMENTED[rrule.options.freq], key)) return false;
        }

        return canConvert;
      };

      ToText.prototype = {
        constructor: ToText,

        isFullyConvertible: function () {
          return ToText.isFullyConvertible(this.rrule);
        },

        /**
         * Perform the conversion. Only some of the frequencies are supported.
         * If some of the rrule's options aren't supported, they'll
         * be omitted from the output an "(~ approximate)" will be appended.
         * @return {*}
         */
        toString: function () {
          var gettext = this.gettext;

          if (!(this.options.freq in ToText.IMPLEMENTED)) {
            return gettext('RRule error: Unable to fully convert this rrule to text');
          }

          this.text = [gettext('every')];
          this[RRule.FREQUENCIES[this.options.freq]]();

          if (this.options.until) {
            this.add(gettext('until'));
            var until = this.options.until;
            this.add(this.language.monthNames[until.getMonth()]).add(until.getDate() + ',').add(until.getFullYear());
          } else if (this.options.count) {
            this.add(gettext('for')).add(this.options.count).add(this.plural(this.options.count) ? gettext('times') : gettext('time'));
          }

          if (!this.isFullyConvertible()) this.add(gettext('(~ approximate)'));

          return this.text.join('');
        },

        HOURLY: function () {
          var gettext = this.gettext;

          if (this.options.interval !== 1) this.add(this.options.interval);

          this.add(this.plural(this.options.interval) ? gettext('hours') : gettext('hour'));
        },

        MINUTELY: function () {
          var gettext = this.gettext;

          if (this.options.interval !== 1) this.add(this.options.interval);

          this.add(this.plural(this.options.interval) ? gettext('minutes') : gettext('minutes'));
        },

        DAILY: function () {
          var gettext = this.gettext;

          if (this.options.interval !== 1) this.add(this.options.interval);

          if (this.byweekday && this.byweekday.isWeekdays) {
            this.add(this.plural(this.options.interval) ? gettext('weekdays') : gettext('weekday'));
          } else {
            this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
          }

          if (this.origOptions.bymonth) {
            this.add(gettext('in'));
            this._bymonth();
          }

          if (this.bymonthday) {
            this._bymonthday();
          } else if (this.byweekday) {
            this._byweekday();
          } else if (this.origOptions.byhour) {
            this._byhour();
          }
        },

        WEEKLY: function () {
          var gettext = this.gettext;

          if (this.options.interval !== 1) {
            this.add(this.options.interval).add(this.plural(this.options.interval) ? gettext('weeks') : gettext('week'));
          }

          if (this.byweekday && this.byweekday.isWeekdays) {
            if (this.options.interval === 1) {
              this.add(this.plural(this.options.interval) ? gettext('weekdays') : gettext('weekday'));
            } else {
              this.add(gettext('on')).add(gettext('weekdays'));
            }
          } else {
            if (this.options.interval === 1) this.add(gettext('week'));

            if (this.origOptions.bymonth) {
              this.add(gettext('in'));
              this._bymonth();
            }

            if (this.bymonthday) {
              this._bymonthday();
            } else if (this.byweekday) {
              this._byweekday();
            }
          }
        },

        MONTHLY: function () {
          var gettext = this.gettext;

          if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
              this.add(this.options.interval).add(gettext('months'));
              if (this.plural(this.options.interval)) this.add(gettext('in'));
            } else {
              // this.add(gettext('MONTH'))
            }
            this._bymonth();
          } else {
            if (this.options.interval !== 1) this.add(this.options.interval);
            this.add(this.plural(this.options.interval) ? gettext('months') : gettext('month'));
          }
          if (this.bymonthday) {
            this._bymonthday();
          } else if (this.byweekday && this.byweekday.isWeekdays) {
            this.add(gettext('on')).add(gettext('weekdays'));
          } else if (this.byweekday) {
            this._byweekday();
          }
        },

        YEARLY: function () {
          var gettext = this.gettext;

          if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
              this.add(this.options.interval);
              this.add(gettext('years'));
            } else {
              // this.add(gettext('YEAR'))
            }
            this._bymonth();
          } else {
            if (this.options.interval !== 1) this.add(this.options.interval);
            this.add(this.plural(this.options.interval) ? gettext('years') : gettext('year'));
          }

          if (this.bymonthday) {
            this._bymonthday();
          } else if (this.byweekday) {
            this._byweekday();
          }

          if (this.options.byyearday) {
            this.add(gettext('on the')).add(this.list(this.options.byyearday, this.nth, gettext('and'))).add(gettext('day'));
          }

          if (this.options.byweekno) {
            this.add(gettext('in')).add(this.plural(this.options.byweekno.length) ? gettext('weeks') : gettext('week')).add(this.list(this.options.byweekno, null, gettext('and')));
          }
        },

        _bymonthday: function () {
          var gettext = this.gettext;
          if (this.byweekday && this.byweekday.allWeeks) {
            this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext('or'))).add(gettext('the')).add(this.list(this.bymonthday, this.nth, gettext('or')));
          } else {
            this.add(gettext('on the')).add(this.list(this.bymonthday, this.nth, gettext('and')));
          }
          // this.add(gettext('DAY'))
        },

        _byweekday: function () {
          var gettext = this.gettext;
          if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) {
            this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext));
          }

          if (this.byweekday.someWeeks) {
            if (this.byweekday.allWeeks) this.add(gettext('and'));

            this.add(gettext('on the')).add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext('and')));
          }
        },

        _byhour: function () {
          var gettext = this.gettext;

          this.add(gettext('at')).add(this.list(this.origOptions.byhour, null, gettext('and')));
        },

        _bymonth: function () {
          this.add(this.list(this.options.bymonth, this.monthtext, this.gettext('and')));
        },

        nth: function (n) {
          var nth, npos;
          var gettext = this.gettext;

          if (n === -1) return gettext('last');

          npos = Math.abs(n);
          switch (npos) {
            case 1:
            case 21:
            case 31:
              nth = npos + gettext('st');
              break;
            case 2:
            case 22:
              nth = npos + gettext('nd');
              break;
            case 3:
            case 23:
              nth = npos + gettext('rd');
              break;
            default:
              nth = npos + gettext('th');
          }

          return n < 0 ? nth + ' ' + gettext('last') : nth;
        },

        monthtext: function (m) {
          return this.language.monthNames[m - 1];
        },

        weekdaytext: function (wday) {
          var weekday = typeof wday === 'number' ? wday : wday.getJsWeekday();
          return (wday.n ? this.nth(wday.n) + ' ' : '') + this.language.dayNames[weekday];
        },

        plural: function (n) {
          return n % 100 !== 1;
        },

        add: function (s) {
          this.text.push(' ');
          this.text.push(s);
          return this;
        },

        list: function (arr, callback, finalDelim, delim) {
          if (!(arr instanceof Array)) {
            arr = [arr];
          }
          var delimJoin = function (array, delimiter, finalDelimiter) {
            var list = '';

            for (var i = 0; i < array.length; i++) {
              if (i !== 0) {
                if (i === array.length - 1) {
                  list += ' ' + finalDelimiter + ' ';
                } else {
                  list += delimiter + ' ';
                }
              }
              list += array[i];
            }
            return list;
          };

          delim = delim || ',';
          callback = callback || function (o) {
            return o;
          };
          var self = this;
          var realCallback = function (arg) {
            return callback.call(self, arg);
          };

          if (finalDelim) {
            return delimJoin(arr.map(realCallback), delim, finalDelim);
          } else {
            return arr.map(realCallback).join(delim + ' ');
          }
        }

        // =============================================================================
        // fromText
        // =============================================================================
        /**
         * Will be able to convert some of the below described rules from
         * text format to a rule object.
         *
         *
         * RULES
         *
         * Every ([n])
         *       day(s)
         *     | [weekday], ..., (and) [weekday]
         *     | weekday(s)
         *     | week(s)
         *     | month(s)
         *     | [month], ..., (and) [month]
         *     | year(s)
         *
         *
         * Plus 0, 1, or multiple of these:
         *
         * on [weekday], ..., (or) [weekday] the [monthday], [monthday], ... (or) [monthday]
         *
         * on [weekday], ..., (and) [weekday]
         *
         * on the [monthday], [monthday], ... (and) [monthday] (day of the month)
         *
         * on the [nth-weekday], ..., (and) [nth-weekday] (of the month/year)
         *
         *
         * Plus 0 or 1 of these:
         *
         * for [n] time(s)
         *
         * until [date]
         *
         * Plus (.)
         *
         *
         * Definitely no supported for parsing:
         *
         * (for year):
         *     in week(s) [n], ..., (and) [n]
         *
         *     on the [yearday], ..., (and) [n] day of the year
         *     on day [yearday], ..., (and) [n]
         *
         *
         * NON-TERMINALS
         *
         * [n]: 1, 2 ..., one, two, three ..
         * [month]: January, February, March, April, May, ... December
         * [weekday]: Monday, ... Sunday
         * [nth-weekday]: first [weekday], 2nd [weekday], ... last [weekday], ...
         * [monthday]: first, 1., 2., 1st, 2nd, second, ... 31st, last day, 2nd last day, ..
         * [date]:
         *     [month] (0-31(,) ([year])),
         *     (the) 0-31.(1-12.([year])),
         *     (the) 0-31/(1-12/([year])),
         *     [weekday]
         *
         * [year]: 0000, 0001, ... 01, 02, ..
         *
         * Definitely not supported for parsing:
         *
         * [yearday]: first, 1., 2., 1st, 2nd, second, ... 366th, last day, 2nd last day, ..
         *
         * @param {String} text
         * @return {Object, Boolean} the rule, or null.
         */
      };var fromText = function (text, language) {
        return new RRule(parseText(text, language));
      };

      var parseText = function (text, language) {
        var options = {};
        var ttr = new Parser((language || ENGLISH).tokens);

        if (!ttr.start(text)) return null;

        S();
        return options;

        function S() {
          // every [n]
          var n;

          ttr.expect('every');
          if (n = ttr.accept('number')) options.interval = parseInt(n[0], 10);
          if (ttr.isDone()) throw new Error('Unexpected end');

          switch (ttr.symbol) {
            case 'day(s)':
              options.freq = RRule.DAILY;
              if (ttr.nextSymbol()) {
                AT();
                F();
              }
              break;

            // FIXME Note: every 2 weekdays != every two weeks on weekdays.
            // DAILY on weekdays is not a valid rule
            case 'weekday(s)':
              options.freq = RRule.WEEKLY;
              options.byweekday = [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR];
              ttr.nextSymbol();
              F();
              break;

            case 'week(s)':
              options.freq = RRule.WEEKLY;
              if (ttr.nextSymbol()) {
                ON();
                F();
              }
              break;

            case 'hour(s)':
              options.freq = RRule.HOURLY;
              if (ttr.nextSymbol()) {
                ON();
                F();
              }
              break;

            case 'minute(s)':
              options.freq = RRule.MINUTELY;
              if (ttr.nextSymbol()) {
                ON();
                F();
              }
              break;

            case 'month(s)':
              options.freq = RRule.MONTHLY;
              if (ttr.nextSymbol()) {
                ON();
                F();
              }
              break;

            case 'year(s)':
              options.freq = RRule.YEARLY;
              if (ttr.nextSymbol()) {
                ON();
                F();
              }
              break;

            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
              options.freq = RRule.WEEKLY;
              options.byweekday = [RRule[ttr.symbol.substr(0, 2).toUpperCase()]];

              if (!ttr.nextSymbol()) return;

              // TODO check for duplicates
              while (ttr.accept('comma')) {
                if (ttr.isDone()) throw new Error('Unexpected end');

                var wkd;
                if (!(wkd = decodeWKD())) {
                  throw new Error('Unexpected symbol ' + ttr.symbol + ', expected weekday');
                }

                options.byweekday.push(RRule[wkd]);
                ttr.nextSymbol();
              }
              MDAYs();
              F();
              break;

            case 'january':
            case 'february':
            case 'march':
            case 'april':
            case 'may':
            case 'june':
            case 'july':
            case 'august':
            case 'september':
            case 'october':
            case 'november':
            case 'december':
              options.freq = RRule.YEARLY;
              options.bymonth = [decodeM()];

              if (!ttr.nextSymbol()) return;

              // TODO check for duplicates
              while (ttr.accept('comma')) {
                if (ttr.isDone()) throw new Error('Unexpected end');

                var m;
                if (!(m = decodeM())) {
                  throw new Error('Unexpected symbol ' + ttr.symbol + ', expected month');
                }

                options.bymonth.push(m);
                ttr.nextSymbol();
              }

              ON();
              F();
              break;

            default:
              throw new Error('Unknown symbol');

          }
        }

        function ON() {
          var on = ttr.accept('on');
          var the = ttr.accept('the');
          if (!(on || the)) return;

          do {
            var nth, wkd, m;

            // nth <weekday> | <weekday>
            if (nth = decodeNTH()) {
              // ttr.nextSymbol()

              if (wkd = decodeWKD()) {
                ttr.nextSymbol();
                if (!options.byweekday) options.byweekday = [];
                options.byweekday.push(RRule[wkd].nth(nth));
              } else {
                if (!options.bymonthday) options.bymonthday = [];
                options.bymonthday.push(nth);
                ttr.accept('day(s)');
              }
              // <weekday>
            } else if (wkd = decodeWKD()) {
              ttr.nextSymbol();
              if (!options.byweekday) options.byweekday = [];
              options.byweekday.push(RRule[wkd]);
            } else if (ttr.symbol === 'weekday(s)') {
              ttr.nextSymbol();
              if (!options.byweekday) options.byweekday = [];
              options.byweekday.push(RRule.MO);
              options.byweekday.push(RRule.TU);
              options.byweekday.push(RRule.WE);
              options.byweekday.push(RRule.TH);
              options.byweekday.push(RRule.FR);
            } else if (ttr.symbol === 'week(s)') {
              ttr.nextSymbol();
              var n;
              if (!(n = ttr.accept('number'))) {
                throw new Error('Unexpected symbol ' + ttr.symbol + ', expected week number');
              }
              options.byweekno = [n[0]];
              while (ttr.accept('comma')) {
                if (!(n = ttr.accept('number'))) {
                  throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
                }
                options.byweekno.push(n[0]);
              }
            } else if (m = decodeM()) {
              ttr.nextSymbol();
              if (!options.bymonth) options.bymonth = [];
              options.bymonth.push(m);
            } else {
              return;
            }
          } while (ttr.accept('comma') || ttr.accept('the') || ttr.accept('on'));
        }

        function AT() {
          var at = ttr.accept('at');
          if (!at) return;

          do {
            var n;
            if (!(n = ttr.accept('number'))) {
              throw new Error('Unexpected symbol ' + ttr.symbol + ', expected hour');
            }
            options.byhour = [n[0]];
            while (ttr.accept('comma')) {
              if (!(n = ttr.accept('number'))) {
                throw new Error('Unexpected symbol ' + ttr.symbol + '; expected hour');
              }
              options.byhour.push(n[0]);
            }
          } while (ttr.accept('comma') || ttr.accept('at'));
        }

        function decodeM() {
          switch (ttr.symbol) {
            case 'january':
              return 1;
            case 'february':
              return 2;
            case 'march':
              return 3;
            case 'april':
              return 4;
            case 'may':
              return 5;
            case 'june':
              return 6;
            case 'july':
              return 7;
            case 'august':
              return 8;
            case 'september':
              return 9;
            case 'october':
              return 10;
            case 'november':
              return 11;
            case 'december':
              return 12;
            default:
              return false;
          }
        }

        function decodeWKD() {
          switch (ttr.symbol) {
            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
              return ttr.symbol.substr(0, 2).toUpperCase();
            default:
              return false;
          }
        }

        function decodeNTH() {
          switch (ttr.symbol) {
            case 'last':
              ttr.nextSymbol();
              return -1;
            case 'first':
              ttr.nextSymbol();
              return 1;
            case 'second':
              ttr.nextSymbol();
              return ttr.accept('last') ? -2 : 2;
            case 'third':
              ttr.nextSymbol();
              return ttr.accept('last') ? -3 : 3;
            case 'nth':
              var v = parseInt(ttr.value[1], 10);
              if (v < -366 || v > 366) throw new Error('Nth out of range: ' + v);

              ttr.nextSymbol();
              return ttr.accept('last') ? -v : v;

            default:
              return false;
          }
        }

        function MDAYs() {
          ttr.accept('on');
          ttr.accept('the');

          var nth;
          if (!(nth = decodeNTH())) return;

          options.bymonthday = [nth];
          ttr.nextSymbol();

          while (ttr.accept('comma')) {
            if (!(nth = decodeNTH())) {
              throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
            }

            options.bymonthday.push(nth);
            ttr.nextSymbol();
          }
        }

        function F() {
          if (ttr.symbol === 'until') {
            var date = Date.parse(ttr.text);

            if (!date) throw new Error('Cannot parse until date:' + ttr.text);
            options.until = new Date(date);
          } else if (ttr.accept('for')) {
            options.count = ttr.value[0];
            ttr.expect('number');
            // ttr.expect('times')
          }
        }
      };

      // =============================================================================
      // Parser
      // =============================================================================

      var Parser = function (rules) {
        this.rules = rules;
      };

      Parser.prototype.start = function (text) {
        this.text = text;
        this.done = false;
        return this.nextSymbol();
      };

      Parser.prototype.isDone = function () {
        return this.done && this.symbol == null;
      };

      Parser.prototype.nextSymbol = function () {
        var best, bestSymbol;
        var p = this;

        this.symbol = null;
        this.value = null;
        do {
          if (this.done) return false;

          var match, rule;
          best = null;
          for (var name in this.rules) {
            rule = this.rules[name];
            if (match = rule.exec(p.text)) {
              if (best == null || match[0].length > best[0].length) {
                best = match;
                bestSymbol = name;
              }
            }
          }

          if (best != null) {
            this.text = this.text.substr(best[0].length);

            if (this.text === '') this.done = true;
          }

          if (best == null) {
            this.done = true;
            this.symbol = null;
            this.value = null;
            return;
          }
        } while (bestSymbol === 'SKIP');

        this.symbol = bestSymbol;
        this.value = best;
        return true;
      };

      Parser.prototype.accept = function (name) {
        if (this.symbol === name) {
          if (this.value) {
            var v = this.value;
            this.nextSymbol();
            return v;
          }

          this.nextSymbol();
          return true;
        }

        return false;
      };

      Parser.prototype.expect = function (name) {
        if (this.accept(name)) return true;

        throw new Error('expected ' + name + ' but found ' + this.symbol);
      };

      // =============================================================================
      // i18n
      // =============================================================================

      var ENGLISH = {
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        tokens: {
          'SKIP': /^[ \r\n\t]+|^\.$/,
          'number': /^[1-9][0-9]*/,
          'numberAsText': /^(one|two|three)/i,
          'every': /^every/i,
          'day(s)': /^days?/i,
          'weekday(s)': /^weekdays?/i,
          'week(s)': /^weeks?/i,
          'hour(s)': /^hours?/i,
          'minute(s)': /^minutes?/i,
          'month(s)': /^months?/i,
          'year(s)': /^years?/i,
          'on': /^(on|in)/i,
          'at': /^(at)/i,
          'the': /^the/i,
          'first': /^first/i,
          'second': /^second/i,
          'third': /^third/i,
          'nth': /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
          'last': /^last/i,
          'for': /^for/i,
          'time(s)': /^times?/i,
          'until': /^(un)?til/i,
          'monday': /^mo(n(day)?)?/i,
          'tuesday': /^tu(e(s(day)?)?)?/i,
          'wednesday': /^we(d(n(esday)?)?)?/i,
          'thursday': /^th(u(r(sday)?)?)?/i,
          'friday': /^fr(i(day)?)?/i,
          'saturday': /^sa(t(urday)?)?/i,
          'sunday': /^su(n(day)?)?/i,
          'january': /^jan(uary)?/i,
          'february': /^feb(ruary)?/i,
          'march': /^mar(ch)?/i,
          'april': /^apr(il)?/i,
          'may': /^may/i,
          'june': /^june?/i,
          'july': /^july?/i,
          'august': /^aug(ust)?/i,
          'september': /^sep(t(ember)?)?/i,
          'october': /^oct(ober)?/i,
          'november': /^nov(ember)?/i,
          'december': /^dec(ember)?/i,
          'comma': /^(,\s*|(and|or)\s*)+/i
        }

        // =============================================================================
        // Export
        // =============================================================================

      };return {
        fromText: fromText,
        parseText: parseText,
        isFullyConvertible: ToText.isFullyConvertible,
        toText: function (rrule, gettext, language) {
          return new ToText(rrule, gettext, language).toString();
        }
      };
    };
  }); // eslint-disable-line 
});
$__System.registerDynamic('7e', ['7d'], true, function ($__require, exports, module) {
  /* */
  "format cjs";

  var global = this || self,
      GLOBAL = global;
  ;
  (function (root, factory) {
    if (typeof module === 'object' && module.exports) {
      module.exports = factory();
    } else if (typeof undefined === 'function' && define.amd) {
      define([], factory);
    } else {
      root.RRule = factory(root);
      root.RRuleSet = root.RRule.RRuleSet;
      root.rrulestr = root.RRule.rrulestr;
    }
  })(typeof window === 'object' ? window : this, function (root) {
    var dateutil = {
      MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      ONE_DAY: 1000 * 60 * 60 * 24,
      MAXYEAR: 9999,
      ORDINAL_BASE: new Date(1900, 0, 1),
      PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],
      getYearDay: function (date) {
        var dateNoTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        return Math.ceil((dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1;
      },
      isLeapYear: function (year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      },
      tzOffset: function (date) {
        return date.getTimezoneOffset() * 60 * 1000;
      },
      daysBetween: function (date1, date2) {
        var date1ms = date1.getTime() - dateutil.tzOffset(date1);
        var date2ms = date2.getTime() - dateutil.tzOffset(date2);
        var differencems = date1ms - date2ms;
        return Math.round(differencems / dateutil.ONE_DAY);
      },
      toOrdinal: function (date) {
        if (date < dateutil.ORDINAL_BASE) {
          throw new Error('dates lower than ' + dateutil.ORDINAL_BASE + ' are not supported');
        }
        return dateutil.daysBetween(date, dateutil.ORDINAL_BASE);
      },
      fromOrdinal: function (ordinal) {
        var millisecsFromBase = ordinal * dateutil.ONE_DAY;
        return new Date(dateutil.ORDINAL_BASE.getTime() - dateutil.tzOffset(dateutil.ORDINAL_BASE) + millisecsFromBase + dateutil.tzOffset(new Date(millisecsFromBase)));
      },
      monthRange: function (year, month) {
        var date = new Date(year, month, 1);
        return [dateutil.getWeekday(date), dateutil.getMonthDays(date)];
      },
      getMonthDays: function (date) {
        var month = date.getMonth();
        return month === 1 && dateutil.isLeapYear(date.getFullYear()) ? 29 : dateutil.MONTH_DAYS[month];
      },
      getWeekday: function (date) {
        return dateutil.PY_WEEKDAYS[date.getDay()];
      },
      combine: function (date, time) {
        time = time || date;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
      },
      clone: function (date) {
        var dolly = new Date(date.getTime());
        return dolly;
      },
      cloneDates: function (dates) {
        var clones = [];
        for (var i = 0; i < dates.length; i++) {
          clones.push(dateutil.clone(dates[i]));
        }
        return clones;
      },
      sort: function (dates) {
        dates.sort(function (a, b) {
          return a.getTime() - b.getTime();
        });
      },
      timeToUntilString: function (time) {
        var comp;
        var date = new Date(time);
        var comps = [date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), 'T', date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 'Z'];
        for (var i = 0; i < comps.length; i++) {
          comp = comps[i];
          if (!/[TZ]/.test(comp) && comp < 10) comps[i] = '0' + String(comp);
        }
        return comps.join('');
      },
      untilStringToDate: function (until) {
        var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
        var bits = re.exec(until);
        if (!bits) throw new Error('Invalid UNTIL value: ' + until);
        return new Date(Date.UTC(bits[1], bits[2] - 1, bits[3], bits[5] || 0, bits[6] || 0, bits[7] || 0));
      }
    };
    dateutil.Time = function (hour, minute, second, millisecond) {
      this.hour = hour;
      this.minute = minute;
      this.second = second;
      this.millisecond = millisecond || 0;
    };
    dateutil.Time.prototype = {
      constructor: dateutil.Time,
      getHours: function () {
        return this.hour;
      },
      getMinutes: function () {
        return this.minute;
      },
      getSeconds: function () {
        return this.second;
      },
      getMilliseconds: function () {
        return this.millisecond;
      },
      getTime: function () {
        return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1000 + this.millisecond;
      }
    };
    var range = function (start, end) {
      if (arguments.length === 1) {
        end = start;
        start = 0;
      }
      var rang = [];
      for (var i = start; i < end; i++) rang.push(i);
      return rang;
    };
    var repeat = function (value, times) {
      var i = 0;
      var array = [];
      if (value instanceof Array) {
        for (; i < times; i++) array[i] = [].concat(value);
      } else {
        for (; i < times; i++) array[i] = value;
      }
      return array;
    };
    var split = function (str, sep, num) {
      var splits = str.split(sep);
      return num ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits;
    };
    var pymod = function (a, b) {
      var r = a % b;
      return r * b < 0 ? r + b : r;
    };
    var divmod = function (a, b) {
      return {
        div: Math.floor(a / b),
        mod: pymod(a, b)
      };
    };
    var plb = function (obj) {
      return obj instanceof Array && obj.length === 0 ? false : Boolean(obj);
    };
    var contains = function (arr, val) {
      return arr.indexOf(val) !== -1;
    };
    var M365MASK = [].concat(repeat(1, 31), repeat(2, 28), repeat(3, 31), repeat(4, 30), repeat(5, 31), repeat(6, 30), repeat(7, 31), repeat(8, 31), repeat(9, 30), repeat(10, 31), repeat(11, 30), repeat(12, 31), repeat(1, 7));
    var M366MASK = [].concat(repeat(1, 31), repeat(2, 29), repeat(3, 31), repeat(4, 30), repeat(5, 31), repeat(6, 30), repeat(7, 31), repeat(8, 31), repeat(9, 30), repeat(10, 31), repeat(11, 30), repeat(12, 31), repeat(1, 7));
    var M28 = range(1, 29);
    var M29 = range(1, 30);
    var M30 = range(1, 31);
    var M31 = range(1, 32);
    var MDAY366MASK = [].concat(M31, M29, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
    var MDAY365MASK = [].concat(M31, M28, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
    M28 = range(-28, 0);
    M29 = range(-29, 0);
    M30 = range(-30, 0);
    M31 = range(-31, 0);
    var NMDAY366MASK = [].concat(M31, M29, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
    var NMDAY365MASK = [].concat(M31, M28, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
    var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
    var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
    var WDAYMASK = function () {
      for (var wdaymask = [], i = 0; i < 55; i++) wdaymask = wdaymask.concat(range(7));
      return wdaymask;
    }();
    var WDAYS = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    var Weekday = function (weekday, n) {
      if (n === 0) throw new Error("Can't create weekday with n == 0");
      this.weekday = weekday;
      this.n = n;
    };
    Weekday.prototype = {
      constructor: Weekday,
      nth: function (n) {
        return this.n === n ? this : new Weekday(this.weekday, n);
      },
      equals: function (other) {
        return this.weekday === other.weekday && this.n === other.n;
      },
      toString: function () {
        var s = WDAYS[this.weekday];
        if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s;
        return s;
      },
      getJsWeekday: function () {
        return this.weekday === 6 ? 0 : this.weekday + 1;
      }
    };
    var RRule = function (options, noCache) {
      options = options || {};
      this._string = null;
      this._cache = noCache ? null : {
        all: false,
        before: [],
        after: [],
        between: []
      };
      this.origOptions = {};
      this.options = {};
      var invalid = [];
      var keys = Object.keys(options);
      var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS);
      keys.forEach(function (key) {
        this.origOptions[key] = options[key];
        this.options[key] = options[key];
        if (!contains(defaultKeys, key)) invalid.push(key);
      }, this);
      if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '));
      if (!RRule.FREQUENCIES[options.freq] && options.byeaster === null) {
        throw new Error('Invalid frequency: ' + String(options.freq));
      }
      defaultKeys.forEach(function (key) {
        if (!contains(keys, key)) this.options[key] = RRule.DEFAULT_OPTIONS[key];
      }, this);
      var opts = this.options;
      if (opts.byeaster !== null) opts.freq = RRule.YEARLY;
      if (!opts.dtstart) opts.dtstart = new Date(new Date().setMilliseconds(0));
      var millisecondModulo = opts.dtstart.getTime() % 1000;
      if (opts.wkst === null) {
        opts.wkst = RRule.MO.weekday;
      } else if (typeof opts.wkst === 'number') {} else {
        opts.wkst = opts.wkst.weekday;
      }
      if (opts.bysetpos !== null) {
        if (typeof opts.bysetpos === 'number') opts.bysetpos = [opts.bysetpos];
        for (var i = 0; i < opts.bysetpos.length; i++) {
          var v = opts.bysetpos[i];
          if (v === 0 || !(v >= -366 && v <= 366)) {
            throw new Error('bysetpos must be between 1 and 366,' + ' or between -366 and -1');
          }
        }
      }
      if (!(plb(opts.byweekno) || plb(opts.byyearday) || plb(opts.bymonthday) || opts.byweekday !== null || opts.byeaster !== null)) {
        switch (opts.freq) {
          case RRule.YEARLY:
            if (!opts.bymonth) opts.bymonth = opts.dtstart.getMonth() + 1;
            opts.bymonthday = opts.dtstart.getDate();
            break;
          case RRule.MONTHLY:
            opts.bymonthday = opts.dtstart.getDate();
            break;
          case RRule.WEEKLY:
            opts.byweekday = dateutil.getWeekday(opts.dtstart);
            break;
        }
      }
      if (opts.bymonth !== null && !(opts.bymonth instanceof Array)) {
        opts.bymonth = [opts.bymonth];
      }
      if (opts.byyearday !== null && !(opts.byyearday instanceof Array)) {
        opts.byyearday = [opts.byyearday];
      }
      if (opts.bymonthday === null) {
        opts.bymonthday = [];
        opts.bynmonthday = [];
      } else if (opts.bymonthday instanceof Array) {
        var bymonthday = [];
        var bynmonthday = [];
        for (i = 0; i < opts.bymonthday.length; i++) {
          v = opts.bymonthday[i];
          if (v > 0) {
            bymonthday.push(v);
          } else if (v < 0) {
            bynmonthday.push(v);
          }
        }
        opts.bymonthday = bymonthday;
        opts.bynmonthday = bynmonthday;
      } else {
        if (opts.bymonthday < 0) {
          opts.bynmonthday = [opts.bymonthday];
          opts.bymonthday = [];
        } else {
          opts.bynmonthday = [];
          opts.bymonthday = [opts.bymonthday];
        }
      }
      if (opts.byweekno !== null && !(opts.byweekno instanceof Array)) {
        opts.byweekno = [opts.byweekno];
      }
      if (opts.byweekday === null) {
        opts.bynweekday = null;
      } else if (typeof opts.byweekday === 'number') {
        opts.byweekday = [opts.byweekday];
        opts.bynweekday = null;
      } else if (opts.byweekday instanceof Weekday) {
        if (!opts.byweekday.n || opts.freq > RRule.MONTHLY) {
          opts.byweekday = [opts.byweekday.weekday];
          opts.bynweekday = null;
        } else {
          opts.bynweekday = [[opts.byweekday.weekday, opts.byweekday.n]];
          opts.byweekday = null;
        }
      } else {
        var byweekday = [];
        var bynweekday = [];
        for (i = 0; i < opts.byweekday.length; i++) {
          var wday = opts.byweekday[i];
          if (typeof wday === 'number') {
            byweekday.push(wday);
          } else if (!wday.n || opts.freq > RRule.MONTHLY) {
            byweekday.push(wday.weekday);
          } else {
            bynweekday.push([wday.weekday, wday.n]);
          }
        }
        opts.byweekday = plb(byweekday) ? byweekday : null;
        opts.bynweekday = plb(bynweekday) ? bynweekday : null;
      }
      if (opts.byhour === null) {
        opts.byhour = opts.freq < RRule.HOURLY ? [opts.dtstart.getHours()] : null;
      } else if (typeof opts.byhour === 'number') {
        opts.byhour = [opts.byhour];
      }
      if (opts.byminute === null) {
        opts.byminute = opts.freq < RRule.MINUTELY ? [opts.dtstart.getMinutes()] : null;
      } else if (typeof opts.byminute === 'number') {
        opts.byminute = [opts.byminute];
      }
      if (opts.bysecond === null) {
        opts.bysecond = opts.freq < RRule.SECONDLY ? [opts.dtstart.getSeconds()] : null;
      } else if (typeof opts.bysecond === 'number') {
        opts.bysecond = [opts.bysecond];
      }
      if (opts.freq >= RRule.HOURLY) {
        this.timeset = null;
      } else {
        this.timeset = [];
        for (i = 0; i < opts.byhour.length; i++) {
          var hour = opts.byhour[i];
          for (var j = 0; j < opts.byminute.length; j++) {
            var minute = opts.byminute[j];
            for (var k = 0; k < opts.bysecond.length; k++) {
              var second = opts.bysecond[k];
              this.timeset.push(new dateutil.Time(hour, minute, second, millisecondModulo));
            }
          }
        }
        dateutil.sort(this.timeset);
      }
    };
    RRule.FREQUENCIES = ['YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY', 'HOURLY', 'MINUTELY', 'SECONDLY'];
    RRule.YEARLY = 0;
    RRule.MONTHLY = 1;
    RRule.WEEKLY = 2;
    RRule.DAILY = 3;
    RRule.HOURLY = 4;
    RRule.MINUTELY = 5;
    RRule.SECONDLY = 6;
    RRule.MO = new Weekday(0);
    RRule.TU = new Weekday(1);
    RRule.WE = new Weekday(2);
    RRule.TH = new Weekday(3);
    RRule.FR = new Weekday(4);
    RRule.SA = new Weekday(5);
    RRule.SU = new Weekday(6);
    RRule.DEFAULT_OPTIONS = {
      freq: null,
      dtstart: null,
      interval: 1,
      wkst: RRule.MO,
      count: null,
      until: null,
      bysetpos: null,
      bymonth: null,
      bymonthday: null,
      bynmonthday: null,
      byyearday: null,
      byweekno: null,
      byweekday: null,
      bynweekday: null,
      byhour: null,
      byminute: null,
      bysecond: null,
      byeaster: null
    };
    RRule.parseText = function (text, language) {
      return getnlp().parseText(text, language);
    };
    RRule.fromText = function (text, language) {
      return getnlp().fromText(text, language);
    };
    RRule.optionsToString = function (options) {
      var key, value, strValues;
      var pairs = [];
      var keys = Object.keys(options);
      var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS);
      for (var i = 0; i < keys.length; i++) {
        if (!contains(defaultKeys, keys[i])) continue;
        key = keys[i].toUpperCase();
        value = options[keys[i]];
        strValues = [];
        if (value === null || value instanceof Array && !value.length) continue;
        switch (key) {
          case 'FREQ':
            value = RRule.FREQUENCIES[options.freq];
            break;
          case 'WKST':
            if (!(value instanceof Weekday)) {
              value = new Weekday(value);
            }
            break;
          case 'BYWEEKDAY':
            key = 'BYDAY';
            if (!(value instanceof Array)) value = [value];
            for (var wday, j = 0; j < value.length; j++) {
              wday = value[j];
              if (wday instanceof Weekday) {} else if (wday instanceof Array) {
                wday = new Weekday(wday[0], wday[1]);
              } else {
                wday = new Weekday(wday);
              }
              strValues[j] = wday.toString();
            }
            value = strValues;
            break;
          case 'DTSTART':
          case 'UNTIL':
            value = dateutil.timeToUntilString(value);
            break;
          default:
            if (value instanceof Array) {
              for (j = 0; j < value.length; j++) strValues[j] = String(value[j]);
              value = strValues;
            } else {
              value = String(value);
            }
        }
        pairs.push([key, value]);
      }
      var strings = [];
      for (i = 0; i < pairs.length; i++) {
        var attr = pairs[i];
        strings.push(attr[0] + '=' + attr[1].toString());
      }
      return strings.join(';');
    };
    RRule.prototype = {
      constructor: RRule,
      all: function (iterator) {
        if (iterator) {
          return this._iter(new CallbackIterResult('all', {}, iterator));
        } else {
          var result = this._cacheGet('all');
          if (result === false) {
            result = this._iter(new IterResult('all', {}));
            this._cacheAdd('all', result);
          }
          return result;
        }
      },
      between: function (after, before, inc, iterator) {
        var args = {
          before: before,
          after: after,
          inc: inc
        };
        if (iterator) {
          return this._iter(new CallbackIterResult('between', args, iterator));
        }
        var result = this._cacheGet('between', args);
        if (result === false) {
          result = this._iter(new IterResult('between', args));
          this._cacheAdd('between', result, args);
        }
        return result;
      },
      before: function (dt, inc) {
        var args = {
          dt: dt,
          inc: inc
        };
        var result = this._cacheGet('before', args);
        if (result === false) {
          result = this._iter(new IterResult('before', args));
          this._cacheAdd('before', result, args);
        }
        return result;
      },
      after: function (dt, inc) {
        var args = {
          dt: dt,
          inc: inc
        };
        var result = this._cacheGet('after', args);
        if (result === false) {
          result = this._iter(new IterResult('after', args));
          this._cacheAdd('after', result, args);
        }
        return result;
      },
      count: function () {
        return this.all().length;
      },
      toString: function () {
        return RRule.optionsToString(this.origOptions);
      },
      toText: function (gettext, language) {
        return getnlp().toText(this, gettext, language);
      },
      isFullyConvertibleToText: function () {
        return getnlp().isFullyConvertible(this);
      },
      _cacheAdd: function (what, value, args) {
        if (!this._cache) return;
        if (value) {
          value = value instanceof Date ? dateutil.clone(value) : dateutil.cloneDates(value);
        }
        if (what === 'all') {
          this._cache.all = value;
        } else {
          args._value = value;
          this._cache[what].push(args);
        }
      },
      _cacheGet: function (what, args) {
        if (!this._cache) return false;
        var cached = false;
        var argsKeys = args ? Object.keys(args) : [];
        var findCacheDiff = function (item) {
          for (var key, i = 0; i < argsKeys.length; i++) {
            key = argsKeys[i];
            if (String(args[key]) !== String(item[key])) return true;
          }
          return false;
        };
        if (what === 'all') {
          cached = this._cache.all;
        } else {
          for (var item, i = 0; i < this._cache[what].length; i++) {
            item = this._cache[what][i];
            if (argsKeys.length && findCacheDiff(item)) continue;
            cached = item._value;
            break;
          }
        }
        if (!cached && this._cache.all) {
          var iterResult = new IterResult(what, args);
          for (i = 0; i < this._cache.all.length; i++) {
            if (!iterResult.accept(this._cache.all[i])) break;
          }
          cached = iterResult.getValue();
          this._cacheAdd(what, cached, args);
        }
        return cached instanceof Array ? dateutil.cloneDates(cached) : cached instanceof Date ? dateutil.clone(cached) : cached;
      },
      clone: function () {
        return new RRule(this.origOptions);
      },
      _iter: function (iterResult) {
        var dtstart = this.options.dtstart;
        var dtstartMillisecondModulo = this.options.dtstart % 1000;
        var year = dtstart.getFullYear();
        var month = dtstart.getMonth() + 1;
        var day = dtstart.getDate();
        var hour = dtstart.getHours();
        var minute = dtstart.getMinutes();
        var second = dtstart.getSeconds();
        var weekday = dateutil.getWeekday(dtstart);
        var freq = this.options.freq;
        var interval = this.options.interval;
        var wkst = this.options.wkst;
        var until = this.options.until;
        var bymonth = this.options.bymonth;
        var byweekno = this.options.byweekno;
        var byyearday = this.options.byyearday;
        var byweekday = this.options.byweekday;
        var byeaster = this.options.byeaster;
        var bymonthday = this.options.bymonthday;
        var bynmonthday = this.options.bynmonthday;
        var bysetpos = this.options.bysetpos;
        var byhour = this.options.byhour;
        var byminute = this.options.byminute;
        var bysecond = this.options.bysecond;
        var ii = new Iterinfo(this);
        ii.rebuild(year, month);
        var getdayset = {};
        getdayset[RRule.YEARLY] = ii.ydayset;
        getdayset[RRule.MONTHLY] = ii.mdayset;
        getdayset[RRule.WEEKLY] = ii.wdayset;
        getdayset[RRule.DAILY] = ii.ddayset;
        getdayset[RRule.HOURLY] = ii.ddayset;
        getdayset[RRule.MINUTELY] = ii.ddayset;
        getdayset[RRule.SECONDLY] = ii.ddayset;
        getdayset = getdayset[freq];
        var timeset;
        if (freq < RRule.HOURLY) {
          timeset = this.timeset;
        } else {
          var gettimeset = {};
          gettimeset[RRule.HOURLY] = ii.htimeset;
          gettimeset[RRule.MINUTELY] = ii.mtimeset;
          gettimeset[RRule.SECONDLY] = ii.stimeset;
          gettimeset = gettimeset[freq];
          if (freq >= RRule.HOURLY && plb(byhour) && !contains(byhour, hour) || freq >= RRule.MINUTELY && plb(byminute) && !contains(byminute, minute) || freq >= RRule.SECONDLY && plb(bysecond) && !contains(bysecond, second)) {
            timeset = [];
          } else {
            timeset = gettimeset.call(ii, hour, minute, second, dtstartMillisecondModulo);
          }
        }
        var total = 0;
        var count = this.options.count;
        var i, j, k, dm, div, mod, tmp, pos, dayset, start, end, fixday, filtered;
        while (true) {
          tmp = getdayset.call(ii, year, month, day);
          dayset = tmp[0];
          start = tmp[1];
          end = tmp[2];
          filtered = false;
          for (j = start; j < end; j++) {
            i = dayset[j];
            filtered = plb(bymonth) && !contains(bymonth, ii.mmask[i]) || plb(byweekno) && !ii.wnomask[i] || plb(byweekday) && !contains(byweekday, ii.wdaymask[i]) || plb(ii.nwdaymask) && !ii.nwdaymask[i] || byeaster !== null && !contains(ii.eastermask, i) || (plb(bymonthday) || plb(bynmonthday)) && !contains(bymonthday, ii.mdaymask[i]) && !contains(bynmonthday, ii.nmdaymask[i]) || plb(byyearday) && (i < ii.yearlen && !contains(byyearday, i + 1) && !contains(byyearday, -ii.yearlen + i) || i >= ii.yearlen && !contains(byyearday, i + 1 - ii.yearlen) && !contains(byyearday, -ii.nextyearlen + i - ii.yearlen));
            if (filtered) dayset[i] = null;
          }
          if (plb(bysetpos) && plb(timeset)) {
            var daypos, timepos;
            var poslist = [];
            for (i, j = 0; j < bysetpos.length; j++) {
              pos = bysetpos[j];
              if (pos < 0) {
                daypos = Math.floor(pos / timeset.length);
                timepos = pymod(pos, timeset.length);
              } else {
                daypos = Math.floor((pos - 1) / timeset.length);
                timepos = pymod(pos - 1, timeset.length);
              }
              try {
                tmp = [];
                for (k = start; k < end; k++) {
                  var val = dayset[k];
                  if (val === null) continue;
                  tmp.push(val);
                }
                if (daypos < 0) {
                  i = tmp.slice(daypos)[0];
                } else {
                  i = tmp[daypos];
                }
                var time = timeset[timepos];
                var date = dateutil.fromOrdinal(ii.yearordinal + i);
                var res = dateutil.combine(date, time);
                if (!contains(poslist, res)) poslist.push(res);
              } catch (e) {}
            }
            dateutil.sort(poslist);
            for (j = 0; j < poslist.length; j++) {
              res = poslist[j];
              if (until && res > until) {
                this._len = total;
                return iterResult.getValue();
              } else if (res >= dtstart) {
                ++total;
                if (!iterResult.accept(res)) return iterResult.getValue();
                if (count) {
                  --count;
                  if (!count) {
                    this._len = total;
                    return iterResult.getValue();
                  }
                }
              }
            }
          } else {
            for (j = start; j < end; j++) {
              i = dayset[j];
              if (i !== null) {
                date = dateutil.fromOrdinal(ii.yearordinal + i);
                for (k = 0; k < timeset.length; k++) {
                  time = timeset[k];
                  res = dateutil.combine(date, time);
                  if (until && res > until) {
                    this._len = total;
                    return iterResult.getValue();
                  } else if (res >= dtstart) {
                    ++total;
                    if (!iterResult.accept(res)) return iterResult.getValue();
                    if (count) {
                      --count;
                      if (!count) {
                        this._len = total;
                        return iterResult.getValue();
                      }
                    }
                  }
                }
              }
            }
          }
          fixday = false;
          if (freq === RRule.YEARLY) {
            year += interval;
            if (year > dateutil.MAXYEAR) {
              this._len = total;
              return iterResult.getValue();
            }
            ii.rebuild(year, month);
          } else if (freq === RRule.MONTHLY) {
            month += interval;
            if (month > 12) {
              div = Math.floor(month / 12);
              mod = pymod(month, 12);
              month = mod;
              year += div;
              if (month === 0) {
                month = 12;
                --year;
              }
              if (year > dateutil.MAXYEAR) {
                this._len = total;
                return iterResult.getValue();
              }
            }
            ii.rebuild(year, month);
          } else if (freq === RRule.WEEKLY) {
            if (wkst > weekday) {
              day += -(weekday + 1 + (6 - wkst)) + interval * 7;
            } else {
              day += -(weekday - wkst) + interval * 7;
            }
            weekday = wkst;
            fixday = true;
          } else if (freq === RRule.DAILY) {
            day += interval;
            fixday = true;
          } else if (freq === RRule.HOURLY) {
            if (filtered) {
              hour += Math.floor((23 - hour) / interval) * interval;
            }
            while (true) {
              hour += interval;
              dm = divmod(hour, 24);
              div = dm.div;
              mod = dm.mod;
              if (div) {
                hour = mod;
                day += div;
                fixday = true;
              }
              if (!plb(byhour) || contains(byhour, hour)) break;
            }
            timeset = gettimeset.call(ii, hour, minute, second);
          } else if (freq === RRule.MINUTELY) {
            if (filtered) {
              minute += Math.floor((1439 - (hour * 60 + minute)) / interval) * interval;
            }
            while (true) {
              minute += interval;
              dm = divmod(minute, 60);
              div = dm.div;
              mod = dm.mod;
              if (div) {
                minute = mod;
                hour += div;
                dm = divmod(hour, 24);
                div = dm.div;
                mod = dm.mod;
                if (div) {
                  hour = mod;
                  day += div;
                  fixday = true;
                  filtered = false;
                }
              }
              if ((!plb(byhour) || contains(byhour, hour)) && (!plb(byminute) || contains(byminute, minute))) {
                break;
              }
            }
            timeset = gettimeset.call(ii, hour, minute, second);
          } else if (freq === RRule.SECONDLY) {
            if (filtered) {
              second += Math.floor((86399 - (hour * 3600 + minute * 60 + second)) / interval) * interval;
            }
            while (true) {
              second += interval;
              dm = divmod(second, 60);
              div = dm.div;
              mod = dm.mod;
              if (div) {
                second = mod;
                minute += div;
                dm = divmod(minute, 60);
                div = dm.div;
                mod = dm.mod;
                if (div) {
                  minute = mod;
                  hour += div;
                  dm = divmod(hour, 24);
                  div = dm.div;
                  mod = dm.mod;
                  if (div) {
                    hour = mod;
                    day += div;
                    fixday = true;
                  }
                }
              }
              if ((!plb(byhour) || contains(byhour, hour)) && (!plb(byminute) || contains(byminute, minute)) && (!plb(bysecond) || contains(bysecond, second))) {
                break;
              }
            }
            timeset = gettimeset.call(ii, hour, minute, second);
          }
          if (fixday && day > 28) {
            var daysinmonth = dateutil.monthRange(year, month - 1)[1];
            if (day > daysinmonth) {
              while (day > daysinmonth) {
                day -= daysinmonth;
                ++month;
                if (month === 13) {
                  month = 1;
                  ++year;
                  if (year > dateutil.MAXYEAR) {
                    this._len = total;
                    return iterResult.getValue();
                  }
                }
                daysinmonth = dateutil.monthRange(year, month - 1)[1];
              }
              ii.rebuild(year, month);
            }
          }
        }
      }
    };
    RRule.parseString = function (rfcString) {
      rfcString = rfcString.replace(/^\s+|\s+$/, '');
      if (!rfcString.length) return null;
      var i, j, key, value, attr;
      var attrs = rfcString.split(';');
      var options = {};
      for (i = 0; i < attrs.length; i++) {
        attr = attrs[i].split('=');
        key = attr[0];
        value = attr[1];
        switch (key) {
          case 'FREQ':
            options.freq = RRule[value];
            break;
          case 'WKST':
            options.wkst = RRule[value];
            break;
          case 'COUNT':
          case 'INTERVAL':
          case 'BYSETPOS':
          case 'BYMONTH':
          case 'BYMONTHDAY':
          case 'BYYEARDAY':
          case 'BYWEEKNO':
          case 'BYHOUR':
          case 'BYMINUTE':
          case 'BYSECOND':
            if (value.indexOf(',') !== -1) {
              value = value.split(',');
              for (j = 0; j < value.length; j++) {
                if (/^[+-]?\d+$/.test(value[j])) value[j] = Number(value[j]);
              }
            } else if (/^[+-]?\d+$/.test(value)) {
              value = Number(value);
            }
            key = key.toLowerCase();
            options[key] = value;
            break;
          case 'BYDAY':
            var n, wday, day;
            var days = value.split(',');
            options.byweekday = [];
            for (j = 0; j < days.length; j++) {
              day = days[j];
              if (day.length === 2) {
                wday = RRule[day];
                options.byweekday.push(wday);
              } else {
                day = day.match(/^([+-]?\d)([A-Z]{2})$/);
                n = Number(day[1]);
                wday = day[2];
                wday = RRule[wday].weekday;
                options.byweekday.push(new Weekday(wday, n));
              }
            }
            break;
          case 'DTSTART':
            options.dtstart = dateutil.untilStringToDate(value);
            break;
          case 'UNTIL':
            options.until = dateutil.untilStringToDate(value);
            break;
          case 'BYEASTER':
            options.byeaster = Number(value);
            break;
          default:
            throw new Error("Unknown RRULE property '" + key + "'");
        }
      }
      return options;
    };
    RRule.fromString = function (string) {
      return new RRule(RRule.parseString(string));
    };
    var Iterinfo = function (rrule) {
      this.rrule = rrule;
      this.lastyear = null;
      this.lastmonth = null;
      this.yearlen = null;
      this.nextyearlen = null;
      this.yearordinal = null;
      this.yearweekday = null;
      this.mmask = null;
      this.mrange = null;
      this.mdaymask = null;
      this.nmdaymask = null;
      this.wdaymask = null;
      this.wnomask = null;
      this.nwdaymask = null;
      this.eastermask = null;
    };
    Iterinfo.prototype.easter = function (y, offset) {
      offset = offset || 0;
      var a = y % 19;
      var b = Math.floor(y / 100);
      var c = y % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = Math.floor(19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = (h + l - 7 * m + 114) % 31 + 1;
      var date = Date.UTC(y, month - 1, day + offset);
      var yearStart = Date.UTC(y, 0, 1);
      return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))];
    };
    Iterinfo.prototype.rebuild = function (year, month) {
      var rr = this.rrule;
      if (year !== this.lastyear) {
        this.yearlen = dateutil.isLeapYear(year) ? 366 : 365;
        this.nextyearlen = dateutil.isLeapYear(year + 1) ? 366 : 365;
        var firstyday = new Date(year, 0, 1);
        this.yearordinal = dateutil.toOrdinal(firstyday);
        this.yearweekday = dateutil.getWeekday(firstyday);
        var wday = dateutil.getWeekday(new Date(year, 0, 1));
        if (this.yearlen === 365) {
          this.mmask = [].concat(M365MASK);
          this.mdaymask = [].concat(MDAY365MASK);
          this.nmdaymask = [].concat(NMDAY365MASK);
          this.wdaymask = WDAYMASK.slice(wday);
          this.mrange = [].concat(M365RANGE);
        } else {
          this.mmask = [].concat(M366MASK);
          this.mdaymask = [].concat(MDAY366MASK);
          this.nmdaymask = [].concat(NMDAY366MASK);
          this.wdaymask = WDAYMASK.slice(wday);
          this.mrange = [].concat(M366RANGE);
        }
        if (!plb(rr.options.byweekno)) {
          this.wnomask = null;
        } else {
          this.wnomask = repeat(0, this.yearlen + 7);
          var no1wkst, firstwkst, wyearlen;
          no1wkst = firstwkst = pymod(7 - this.yearweekday + rr.options.wkst, 7);
          if (no1wkst >= 4) {
            no1wkst = 0;
            wyearlen = this.yearlen + pymod(this.yearweekday - rr.options.wkst, 7);
          } else {
            wyearlen = this.yearlen - no1wkst;
          }
          var div = Math.floor(wyearlen / 7);
          var mod = pymod(wyearlen, 7);
          var numweeks = Math.floor(div + mod / 4);
          for (var n, i, j = 0; j < rr.options.byweekno.length; j++) {
            n = rr.options.byweekno[j];
            if (n < 0) {
              n += numweeks + 1;
            }
            if (!(n > 0 && n <= numweeks)) {
              continue;
            }
            if (n > 1) {
              i = no1wkst + (n - 1) * 7;
              if (no1wkst !== firstwkst) {
                i -= 7 - firstwkst;
              }
            } else {
              i = no1wkst;
            }
            for (var k = 0; k < 7; k++) {
              this.wnomask[i] = 1;
              i++;
              if (this.wdaymask[i] === rr.options.wkst) break;
            }
          }
          if (contains(rr.options.byweekno, 1)) {
            i = no1wkst + numweeks * 7;
            if (no1wkst !== firstwkst) i -= 7 - firstwkst;
            if (i < this.yearlen) {
              for (j = 0; j < 7; j++) {
                this.wnomask[i] = 1;
                i += 1;
                if (this.wdaymask[i] === rr.options.wkst) break;
              }
            }
          }
          if (no1wkst) {
            var lnumweeks;
            if (!contains(rr.options.byweekno, -1)) {
              var lyearweekday = dateutil.getWeekday(new Date(year - 1, 0, 1));
              var lno1wkst = pymod(7 - lyearweekday + rr.options.wkst, 7);
              var lyearlen = dateutil.isLeapYear(year - 1) ? 366 : 365;
              if (lno1wkst >= 4) {
                lno1wkst = 0;
                lnumweeks = Math.floor(52 + pymod(lyearlen + pymod(lyearweekday - rr.options.wkst, 7), 7) / 4);
              } else {
                lnumweeks = Math.floor(52 + pymod(this.yearlen - no1wkst, 7) / 4);
              }
            } else {
              lnumweeks = -1;
            }
            if (contains(rr.options.byweekno, lnumweeks)) {
              for (i = 0; i < no1wkst; i++) this.wnomask[i] = 1;
            }
          }
        }
      }
      if (plb(rr.options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
        var ranges = [];
        if (rr.options.freq === RRule.YEARLY) {
          if (plb(rr.options.bymonth)) {
            for (j = 0; j < rr.options.bymonth.length; j++) {
              month = rr.options.bymonth[j];
              ranges.push(this.mrange.slice(month - 1, month + 1));
            }
          } else {
            ranges = [[0, this.yearlen]];
          }
        } else if (rr.options.freq === RRule.MONTHLY) {
          ranges = [this.mrange.slice(month - 1, month + 1)];
        }
        if (plb(ranges)) {
          this.nwdaymask = repeat(0, this.yearlen);
          for (j = 0; j < ranges.length; j++) {
            var rang = ranges[j];
            var first = rang[0];
            var last = rang[1];
            last -= 1;
            for (k = 0; k < rr.options.bynweekday.length; k++) {
              wday = rr.options.bynweekday[k][0];
              n = rr.options.bynweekday[k][1];
              if (n < 0) {
                i = last + (n + 1) * 7;
                i -= pymod(this.wdaymask[i] - wday, 7);
              } else {
                i = first + (n - 1) * 7;
                i += pymod(7 - this.wdaymask[i] + wday, 7);
              }
              if (first <= i && i <= last) this.nwdaymask[i] = 1;
            }
          }
        }
        this.lastyear = year;
        this.lastmonth = month;
      }
      if (rr.options.byeaster !== null) {
        this.eastermask = this.easter(year, rr.options.byeaster);
      }
    };
    Iterinfo.prototype.ydayset = function (year, month, day) {
      return [range(this.yearlen), 0, this.yearlen];
    };
    Iterinfo.prototype.mdayset = function (year, month, day) {
      var set = repeat(null, this.yearlen);
      var start = this.mrange[month - 1];
      var end = this.mrange[month];
      for (var i = start; i < end; i++) set[i] = i;
      return [set, start, end];
    };
    Iterinfo.prototype.wdayset = function (year, month, day) {
      var set = repeat(null, this.yearlen + 7);
      var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal;
      var start = i;
      for (var j = 0; j < 7; j++) {
        set[i] = i;
        ++i;
        if (this.wdaymask[i] === this.rrule.options.wkst) break;
      }
      return [set, start, i];
    };
    Iterinfo.prototype.ddayset = function (year, month, day) {
      var set = repeat(null, this.yearlen);
      var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal;
      set[i] = i;
      return [set, i, i + 1];
    };
    Iterinfo.prototype.htimeset = function (hour, minute, second, millisecond) {
      var set = [];
      var rr = this.rrule;
      for (var i = 0; i < rr.options.byminute.length; i++) {
        minute = rr.options.byminute[i];
        for (var j = 0; j < rr.options.bysecond.length; j++) {
          second = rr.options.bysecond[j];
          set.push(new dateutil.Time(hour, minute, second, millisecond));
        }
      }
      dateutil.sort(set);
      return set;
    };
    Iterinfo.prototype.mtimeset = function (hour, minute, second, millisecond) {
      var set = [];
      var rr = this.rrule;
      for (var j = 0; j < rr.options.bysecond.length; j++) {
        second = rr.options.bysecond[j];
        set.push(new dateutil.Time(hour, minute, second, millisecond));
      }
      dateutil.sort(set);
      return set;
    };
    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
      return [new dateutil.Time(hour, minute, second, millisecond)];
    };
    var IterResult = function (method, args) {
      this.init(method, args);
    };
    IterResult.prototype = {
      constructor: IterResult,
      init: function (method, args) {
        this.method = method;
        this.args = args;
        this.minDate = null;
        this.maxDate = null;
        this._result = [];
        if (method === 'between') {
          this.maxDate = args.inc ? args.before : new Date(args.before.getTime() - 1);
          this.minDate = args.inc ? args.after : new Date(args.after.getTime() + 1);
        } else if (method === 'before') {
          this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1);
        } else if (method === 'after') {
          this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1);
        }
      },
      accept: function (date) {
        var tooEarly = this.minDate && date < this.minDate;
        var tooLate = this.maxDate && date > this.maxDate;
        if (this.method === 'between') {
          if (tooEarly) return true;
          if (tooLate) return false;
        } else if (this.method === 'before') {
          if (tooLate) return false;
        } else if (this.method === 'after') {
          if (tooEarly) return true;
          this.add(date);
          return false;
        }
        return this.add(date);
      },
      add: function (date) {
        this._result.push(date);
        return true;
      },
      getValue: function () {
        var res = this._result;
        switch (this.method) {
          case 'all':
          case 'between':
            return res;
          case 'before':
          case 'after':
            return res.length ? res[res.length - 1] : null;
        }
      },
      clone: function () {
        return new IterResult(this.method, this.args);
      }
    };
    var CallbackIterResult = function (method, args, iterator) {
      var allowedMethods = ['all', 'between'];
      if (!contains(allowedMethods, method)) {
        throw new Error('Invalid method "' + method + '". Only all and between works with iterator.');
      }
      this.add = function (date) {
        if (iterator(date, this._result.length)) {
          this._result.push(date);
          return true;
        }
        return false;
      };
      this.init(method, args);
    };
    CallbackIterResult.prototype = IterResult.prototype;
    var RRuleSet = function (noCache) {
      this._cache = noCache ? null : {
        all: false,
        before: [],
        after: [],
        between: []
      };
      this._rrule = [];
      this._rdate = [];
      this._exrule = [];
      this._exdate = [];
    };
    RRuleSet.prototype = {
      constructor: RRuleSet,
      rrule: function (rrule) {
        if (!(rrule instanceof RRule)) {
          throw new TypeError(String(rrule) + ' is not RRule instance');
        }
        if (!contains(this._rrule.map(String), String(rrule))) {
          this._rrule.push(rrule);
        }
      },
      rdate: function (date) {
        if (!(date instanceof Date)) {
          throw new TypeError(String(date) + ' is not Date instance');
        }
        if (!contains(this._rdate.map(Number), Number(date))) {
          this._rdate.push(date);
          dateutil.sort(this._rdate);
        }
      },
      exrule: function (rrule) {
        if (!(rrule instanceof RRule)) {
          throw new TypeError(String(rrule) + ' is not RRule instance');
        }
        if (!contains(this._exrule.map(String), String(rrule))) {
          this._exrule.push(rrule);
        }
      },
      exdate: function (date) {
        if (!(date instanceof Date)) {
          throw new TypeError(String(date) + ' is not Date instance');
        }
        if (!contains(this._exdate.map(Number), Number(date))) {
          this._exdate.push(date);
          dateutil.sort(this._exdate);
        }
      },
      valueOf: function () {
        var result = [];
        if (this._rrule.length) {
          this._rrule.forEach(function (rrule) {
            result.push('RRULE:' + rrule);
          });
        }
        if (this._rdate.length) {
          result.push('RDATE:' + this._rdate.map(function (rdate) {
            return dateutil.timeToUntilString(rdate);
          }).join(','));
        }
        if (this._exrule.length) {
          this._exrule.forEach(function (exrule) {
            result.push('EXRULE:' + exrule);
          });
        }
        if (this._exdate.length) {
          result.push('EXDATE:' + this._exdate.map(function (exdate) {
            return dateutil.timeToUntilString(exdate);
          }).join(','));
        }
        return result;
      },
      toString: function () {
        return JSON.stringify(this.valueOf());
      },
      _iter: function (iterResult) {
        var _exdateHash = {};
        var _exrule = this._exrule;
        var _accept = iterResult.accept;
        function evalExdate(after, before) {
          _exrule.forEach(function (rrule) {
            rrule.between(after, before, true).forEach(function (date) {
              _exdateHash[Number(date)] = true;
            });
          });
        }
        this._exdate.forEach(function (date) {
          _exdateHash[Number(date)] = true;
        });
        iterResult.accept = function (date) {
          var dt = Number(date);
          if (!_exdateHash[dt]) {
            evalExdate(new Date(dt - 1), new Date(dt + 1));
            if (!_exdateHash[dt]) {
              _exdateHash[dt] = true;
              return _accept.call(this, date);
            }
          }
          return true;
        };
        if (iterResult.method === 'between') {
          evalExdate(iterResult.args.after, iterResult.args.before);
          iterResult.accept = function (date) {
            var dt = Number(date);
            if (!_exdateHash[dt]) {
              _exdateHash[dt] = true;
              return _accept.call(this, date);
            }
            return true;
          };
        }
        for (var i = 0; i < this._rdate.length; i++) {
          if (!iterResult.accept(new Date(this._rdate[i]))) break;
        }
        this._rrule.forEach(function (rrule) {
          rrule._iter(iterResult);
        });
        var res = iterResult._result;
        dateutil.sort(res);
        switch (iterResult.method) {
          case 'all':
          case 'between':
            return res;
          case 'before':
            return res.length && res[res.length - 1] || null;
          case 'after':
            return res.length && res[0] || null;
          default:
            return null;
        }
      },
      clone: function () {
        var rrs = new RRuleSet(!!this._cache);
        var i;
        for (i = 0; i < this._rrule.length; i++) {
          rrs.rrule(this._rrule[i].clone());
        }
        for (i = 0; i < this._rdate.length; i++) {
          rrs.rdate(new Date(this._rdate[i]));
        }
        for (i = 0; i < this._exrule.length; i++) {
          rrs.exrule(this._exrule[i].clone());
        }
        for (i = 0; i < this._exdate.length; i++) {
          rrs.exdate(new Date(this._exdate[i]));
        }
        return rrs;
      }
    };
    var RRuleSetMethods = ['all', 'between', 'before', 'after', 'count', '_cacheAdd', '_cacheGet'];
    RRuleSetMethods.forEach(function (method) {
      RRuleSet.prototype[method] = RRule.prototype[method];
    });
    var RRuleStr = function () {};
    RRuleStr.DEFAULT_OPTIONS = {
      dtstart: null,
      cache: false,
      unfold: false,
      forceset: false,
      compatible: false,
      ignoretz: false,
      tzinfos: null
    };
    RRuleStr._freq_map = {
      'YEARLY': RRule.YEARLY,
      'MONTHLY': RRule.MONTHLY,
      'WEEKLY': RRule.WEEKLY,
      'DAILY': RRule.DAILY,
      'HOURLY': RRule.HOURLY,
      'MINUTELY': RRule.MINUTELY,
      'SECONDLY': RRule.SECONDLY
    };
    RRuleStr._weekday_map = {
      'MO': 0,
      'TU': 1,
      'WE': 2,
      'TH': 3,
      'FR': 4,
      'SA': 5,
      'SU': 6
    };
    RRuleStr.prototype = {
      constructor: RRuleStr,
      _handle_int: function (rrkwargs, name, value, options) {
        rrkwargs[name.toLowerCase()] = parseInt(value, 10);
      },
      _handle_int_list: function (rrkwargs, name, value, options) {
        rrkwargs[name.toLowerCase()] = value.split(',').map(function (x) {
          return parseInt(x, 10);
        });
      },
      _handle_FREQ: function (rrkwargs, name, value, options) {
        rrkwargs['freq'] = RRuleStr._freq_map[value];
      },
      _handle_UNTIL: function (rrkwargs, name, value, options) {
        try {
          rrkwargs['until'] = dateutil.untilStringToDate(value);
        } catch (error) {
          throw new Error('invalid until date');
        }
      },
      _handle_WKST: function (rrkwargs, name, value, options) {
        rrkwargs['wkst'] = RRuleStr._weekday_map[value];
      },
      _handle_BYWEEKDAY: function (rrkwargs, name, value, options) {
        var splt, i, j, n, w, wday;
        var l = [];
        var wdays = value.split(',');
        for (i = 0; i < wdays.length; i++) {
          wday = wdays[i];
          if (wday.indexOf('(') > -1) {
            splt = wday.split('(');
            w = splt[0];
            n = parseInt(splt.slice(1, -1), 10);
          } else {
            for (j = 0; j < wday.length; j++) {
              if ('+-0123456789'.indexOf(wday[j]) === -1) break;
            }
            n = wday.slice(0, j) || null;
            w = wday.slice(j);
            if (n) n = parseInt(n, 10);
          }
          var weekday = new Weekday(RRuleStr._weekday_map[w], n);
          l.push(weekday);
        }
        rrkwargs['byweekday'] = l;
      },
      _parseRfcRRule: function (line, options) {
        options = options || {};
        options.dtstart = options.dtstart || null;
        options.cache = options.cache || false;
        options.ignoretz = options.ignoretz || false;
        options.tzinfos = options.tzinfos || null;
        var name, value, parts;
        if (line.indexOf(':') !== -1) {
          parts = line.split(':');
          name = parts[0];
          value = parts[1];
          if (name !== 'RRULE') throw new Error('unknown parameter name');
        } else {
          value = line;
        }
        var i;
        var rrkwargs = {};
        var pairs = value.split(';');
        for (i = 0; i < pairs.length; i++) {
          parts = pairs[i].split('=');
          name = parts[0].toUpperCase();
          value = parts[1].toUpperCase();
          try {
            this['_handle_' + name](rrkwargs, name, value, {
              ignoretz: options.ignoretz,
              tzinfos: options.tzinfos
            });
          } catch (error) {
            throw new Error("unknown parameter '" + name + "':" + value);
          }
        }
        rrkwargs.dtstart = rrkwargs.dtstart || options.dtstart;
        return new RRule(rrkwargs, !options.cache);
      },
      _parseRfc: function (s, options) {
        if (options.compatible) {
          options.forceset = true;
          options.unfold = true;
        }
        s = s && s.toUpperCase().trim();
        if (!s) throw new Error('Invalid empty string');
        var i = 0;
        var line, lines;
        if (options.unfold) {
          lines = s.split('\n');
          while (i < lines.length) {
            line = lines[i] = lines[i].replace(/\s+$/g, '');
            if (!line) {
              lines.splice(i, 1);
            } else if (i > 0 && line[0] === ' ') {
              lines[i - 1] += line.slice(1);
              lines.splice(i, 1);
            } else {
              i += 1;
            }
          }
        } else {
          lines = s.split(/\s/);
        }
        var rrulevals = [];
        var rdatevals = [];
        var exrulevals = [];
        var exdatevals = [];
        var name, value, parts, parms, parm, dtstart, rset, j, k, datestrs, datestr;
        if (!options.forceset && lines.length === 1 && (s.indexOf(':') === -1 || s.indexOf('RRULE:') === 0)) {
          return this._parseRfcRRule(lines[0], {
            cache: options.cache,
            dtstart: options.dtstart,
            ignoretz: options.ignoretz,
            tzinfos: options.tzinfos
          });
        } else {
          for (i = 0; i < lines.length; i++) {
            line = lines[i];
            if (!line) continue;
            if (line.indexOf(':') === -1) {
              name = 'RRULE';
              value = line;
            } else {
              parts = split(line, ':', 1);
              name = parts[0];
              value = parts[1];
            }
            parms = name.split(';');
            if (!parms) throw new Error('empty property name');
            name = parms[0];
            parms = parms.slice(1);
            if (name === 'RRULE') {
              for (j = 0; j < parms.length; j++) {
                parm = parms[j];
                throw new Error('unsupported RRULE parm: ' + parm);
              }
              rrulevals.push(value);
            } else if (name === 'RDATE') {
              for (j = 0; j < parms.length; j++) {
                parm = parms[j];
                if (parm !== 'VALUE=DATE-TIME' && parm !== 'VALUE=DATE') {
                  throw new Error('unsupported RDATE parm: ' + parm);
                }
              }
              rdatevals.push(value);
            } else if (name === 'EXRULE') {
              for (j = 0; j < parms.length; j++) {
                parm = parms[j];
                throw new Error('unsupported EXRULE parm: ' + parm);
              }
              exrulevals.push(value);
            } else if (name === 'EXDATE') {
              for (j = 0; j < parms.length; j++) {
                parm = parms[j];
                if (parm !== 'VALUE=DATE-TIME' && parm !== 'VALUE=DATE') {
                  throw new Error('unsupported RDATE parm: ' + parm);
                }
              }
              exdatevals.push(value);
            } else if (name === 'DTSTART') {
              dtstart = dateutil.untilStringToDate(value);
            } else {
              throw new Error('unsupported property: ' + name);
            }
          }
          if (options.forceset || rrulevals.length > 1 || rdatevals.length || exrulevals.length || exdatevals.length) {
            rset = new RRuleSet(!options.cache);
            for (j = 0; j < rrulevals.length; j++) {
              rset.rrule(this._parseRfcRRule(rrulevals[j], {
                dtstart: options.dtstart || dtstart,
                ignoretz: options.ignoretz,
                tzinfos: options.tzinfos
              }));
            }
            for (j = 0; j < rdatevals.length; j++) {
              datestrs = rdatevals[j].split(',');
              for (k = 0; k < datestrs.length; k++) {
                datestr = datestrs[k];
                rset.rdate(dateutil.untilStringToDate(datestr));
              }
            }
            for (j = 0; j < exrulevals.length; j++) {
              rset.exrule(this._parseRfcRRule(exrulevals[j], {
                dtstart: options.dtstart || dtstart,
                ignoretz: options.ignoretz,
                tzinfos: options.tzinfos
              }));
            }
            for (j = 0; j < exdatevals.length; j++) {
              datestrs = exdatevals[j].split(',');
              for (k = 0; k < datestrs.length; k++) {
                datestr = datestrs[k];
                rset.exdate(dateutil.untilStringToDate(datestr));
              }
            }
            if (options.campatiable && options.dtstart) rset.rdate(dtstart);
            return rset;
          } else {
            return this._parseRfcRRule(rrulevals[0], {
              dtstart: options.dtstart || dtstart,
              cache: options.cache,
              ignoretz: options.ignoretz,
              tzinfos: options.tzinfos
            });
          }
        }
      },
      parse: function (s, options) {
        options = options || {};
        var invalid = [];
        var keys = Object.keys(options);
        var defaultKeys = Object.keys(RRuleStr.DEFAULT_OPTIONS);
        keys.forEach(function (key) {
          if (!contains(defaultKeys, key)) invalid.push(key);
        }, this);
        if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '));
        defaultKeys.forEach(function (key) {
          if (!contains(keys, key)) options[key] = RRuleStr.DEFAULT_OPTIONS[key];
        });
        return this._parseRfc(s, options);
      }
    };
    RRuleStr.prototype._handle_DTSTART = function (rrkwargs, name, value, options) {
      rrkwargs[name.toLowerCase()] = dateutil.untilStringToDate(value);
    };
    RRuleStr.prototype._handle_BYDAY = RRuleStr.prototype._handle_BYWEEKDAY;
    RRuleStr.prototype._handle_INTERVAL = RRuleStr.prototype._handle_int;
    RRuleStr.prototype._handle_COUNT = RRuleStr.prototype._handle_int;
    ;
    ['_handle_BYSETPOS', '_handle_BYMONTH', '_handle_BYMONTHDAY', '_handle_BYYEARDAY', '_handle_BYEASTER', '_handle_BYWEEKNO', '_handle_BYHOUR', '_handle_BYMINUTE', '_handle_BYSECOND'].forEach(function (method) {
      RRuleStr.prototype[method] = RRuleStr.prototype._handle_int_list;
    });
    var rruleStr = new RRuleStr();
    var rrulestr = function () {
      return rruleStr.parse.apply(rruleStr, arguments);
    };
    RRule.RRule = RRule;
    RRule.RRuleSet = RRuleSet;
    RRule.rrulestr = rrulestr;
    return RRule;
    function getnlp() {
      if (!getnlp._nlp) {
        if (root && root._getRRuleNLP) {
          getnlp._nlp = root._getRRuleNLP(RRule);
        } else if (typeof $__require === 'function') {
          getnlp._nlp = $__require('7d')(RRule);
        } else {
          throw new Error('You need to include rrule/nlp.js for fromText/toText to work.');
        }
      }
      return getnlp._nlp;
    }
  });
});
$__System.registerDynamic("7c", ["7e"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("7e");
});
$__System.registerDynamic("7f", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div>\n\t<div class=\"recur-section-container\">\n\t\t<section class=\"recur-section main times\">\n\t\t\t<h2 ng-click=\"rSCC.showEndTime = !rSCC.showEndTime\" ng-class=\"{'greyed': rSCC.showEndTime}\">Time</h2>\n\t\t\t<h2 ng-click=\"rSCC.showEndTime = !rSCC.showEndTime\" ng-class=\"{'greyed': !rSCC.showEndTime}\">Range</h2>\n\n\t\t\t<div class=\"inner\">\n\t\t\t\t<div class=\"event-time\" ng-show=\"!rSCC.showEndTime\">\n\t\t\t\t\t<time-clicker time=\"rSCC.recurrenceConfig.startTime\" on-change=\"rSCC.onTimeChange()\" ng-class=\"{'semi':!rSCC.recurrenceConfig.startTime.sunPosition}\"></time-clicker>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"event-time\" ng-show=\"rSCC.showEndTime\">\n\t\t\t\t\t<div class=\"block date-range\">\n\t\t\t\t\t\t<span ng-hide=\"rSCC.recurrenceConfig.startTime.date || rSCC.isEditingStartDate\" ng-click=\"rSCC.editStartDate(rSCC.recurrenceConfig)\">Starting Today</span>\n\n\t\t\t\t\t\t<span ng-show=\"rSCC.recurrenceConfig.startTime.date || rSCC.isEditingStartDate\">\n\t\t\t\t\t\t\t<!-- ng-click=\"rSCC.update()\" <input date-time ng-readonly=\"true\" ng-model=\"rSCC.recurrenceConfig.startTime.date\" format=\"ddd MMM Do YYYY\" min-date=\"rSCC.minStartDate\" max-date=\"rSCC.maxStartDate\" view=\"date\" min-view=\"date\" id=\"pickerStartDate\">-->\n\t\t\t\t\t\t\t<input type=\"date\" placeholder=\"yyyy-mm-dd\" ng-model=\"rSCC.recurrenceConfig.startTime.date\" value=\"\"\n\t\t\t\t\t\t\t\t   ng-focus=\"rSCC.isEditingStartDate = true\" ng-blur=\"rSCC.isEditingStartDate = false\"\n\t\t\t\t\t\t\t\t   min=\"{{::rSCC.getDateOnly(rSCC.minStartDate)}}\" max=\"\">\n\t\t\t\t\t\t\t<button class=\"\" ng-click=\"rSCC.clearStartDate(rSCC.recurrenceConfig)\">Clear</button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"block date-range\" ng-if=\"!rSCC.recurrenceConfig.automationSchedule\">\n\t\t\t\t\t\t<span ng-hide=\"rSCC.recurrenceConfig.dtend || rSCC.isEditingEndDate\" ng-click=\"rSCC.editEndDate(rSCC.recurrenceConfig)\">Finishing Never</span>\n\n\t\t\t\t\t\t<span ng-show=\"rSCC.recurrenceConfig.dtend || rSCC.isEditingEndDate\" >\n\t\t\t\t\t\t\t<!-- ng-click=\"rSCC.update()\" <input date-time ng-readonly=\"true\" ng-model=\"rSCC.recurrenceConfig.dtend\" format=\"ddd MMM Do YYYY\" min-date=\"rSCC.minEndDate\"  view=\"date\" min-view=\"date\" id=\"pickerEndDate\"> -->\n\n\t\t\t\t\t\t\t<input type=\"date\" placeholder=\"yyyy-mm-dd\" ng-model=\"rSCC.recurrenceConfig.dtend\" value=\"\"\n\t\t\t\t\t\t\t\t\tng-focus=\"rSCC.isEditingEndDate = true\" ng-blur=\"rSCC.isEditingEndDate = false\"\n\t\t\t\t\t\t\t\t\tmin=\"{{rSCC.getDateOnly(rSCC.recurrenceConfig.startTime.date)}}\" max=\"\">\n\t\t\t\t\t\t\t<button class=\"\" ng-click=\"rSCC.clearEndDate(rSCC.recurrenceConfig)\">Clear</button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<!-- @Yuchao - what is this below?\n\t\t\t\t\t\t<span style=\"display: block\" ng-bind=\"root.minEndDate\"></span>\n\t\t\t\t\t\t-->\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class=\"recur-section main recurrence-select\">\n\t\t    <h2 ng-repeat=\"item in rSCC.recurrenceConfigControls.periods\" ng-click=\"rSCC.selectPeriod(item, rSCC.recurrenceConfig, rSCC.recurrenceConfigControls)\" ng-class=\"{'greyed': !item.selected}\">{{item.name}}</h2>\n\t\t\n\t\t\t<div class=\"inner\">\n\t\t\t\t<div class=\"recurrences\">\t\n\t\t\t\t\t<!-- Daily -->\n\t\t\t\t\t<div ng-show=\"rSCC.recurrenceConfigControls.periods.daily.selected\">\n\t\t\t\t\t\t<p>Event will repeat every day</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Weekly -->\n\t\t\t        <div ng-show=\"rSCC.recurrenceConfigControls.periods.weekly.selected\">\n\t                    <div class=\"day-picker contrast-buttons weekly\">\n\t                      <div ng-repeat=\"(key,day) in rSCC.recurrenceConfigControls.weekdays\" ng-class=\"{selected: day.selected}\" ng-click=\"rSCC.toggleSelection(day);\">\n\t                        <span>{{::key.substring(0,3)}}</span>\n\t                      </div>\n\t                    </div>\n\t                    <div class=\"interval\">\n\t                        <h2>interval (optional)</h2>\n\t                        <input type=\"number\" placeholder=\"E.g. 2 for every 2 weeks\" class=\"interval\" value=\"1\" min=\"1\" name=\"interval\" ng-model=\"rSCC.recurrenceConfig.interval\" ng-change=\"rSCC.update()\">\n\t                    </div>\n\t\t\t        </div>\n\n\t\t\t        <!-- Monthly -->\n\t\t\t        <div ng-show=\"rSCC.recurrenceConfigControls.periods.monthly.selected\">\n\n\t                    <div class=\"block\">\n\t                        <div class=\"day-picker contrast-buttons grid monthdays\">\n\t                          <div ng-repeat=\"(key,day) in rSCC.recurrenceConfigControls.monthdays\" ng-class=\"{selected: day.selected}\" ng-click=\"rSCC.toggleSelection(day)\">\n\t                            <span>{{::day.position}}</span>\n\t                          </div>\n\t                        </div>\n\t                        <div class=\"interval\">\n\t                            <h2>interval (optional)</h2>\n\t                            <input type=\"number\" placeholder=\"Every N months (num)\" class=\"interval\" value=\"1\" min=\"1\" name=\"interval\" ng-model=\"rSCC.recurrenceConfig.interval\" ng-change=\"rSCC.update()\">\n\t                        </div>\n\t                    </div>\n\t\t\t       \t</div>\n\n\t\t\t        <!-- Yearly -->\n\t\t\t        <div ng-show=\"rSCC.recurrenceConfigControls.periods.yearly.selected\">\n\t                    <div class=\"block\">\n\t                        <div class=\"day-picker contrast-buttons grid month\">\n\t                          <div ng-repeat=\"(key,month) in rSCC.recurrenceConfigControls.months\" ng-class=\"{selected: month.selected}\" ng-click=\"rSCC.toggleSelection(month)\">\n\t                            <span>{{::key.substring(0,3)}}</span>\n\t                          </div>\n\t                        </div>\n\t                        <div class=\"day-picker contrast-buttons grid monthdays\">\n\t                          <div ng-repeat=\"(key,day) in rSCC.recurrenceConfigControls.monthdays\" ng-class=\"{selected: day.selected}\" ng-click=\"rSCC.toggleSelection(day)\">\n\t                            <span>{{::day.position}}</span>\n\t                          </div>\n\t                        </div>\n\t                        <div class=\"interval\">\n\t                            <h2>interval (optional)</h2>\n\t                            <input type=\"number\" placeholder=\"Every N years (num)\" class=\"interval\" value=\"1\" min=\"1\" name=\"interval\" ng-model=\"rSCC.recurrenceConfig.interval\" ng-change=\"rSCC.update()\">\n\t                        </div>\n\t                    </div>\n\t\t\t       \t</div>\n\n\t \t\t        <!-- Once -->\n\t\t\t        <div ng-show=\"rSCC.recurrenceConfigControls.periods.once.selected\">\n\t                    One-time event\n\t                    <!-- This won't show a popup on desktop safari / ie but will save us from including angular-datepicker lib --> \n\t                    <input type=\"date\" placeholder=\"yyyy-mm-dd\" ng-model=\"rSCC.recurrenceConfig.startTime.date\" value=\"\" min=\"{{::rSCC.getDateOnly(rSCC.minStartDate)}}\" max=\"\">\n\t\t\t       \t</div>\n\t\t\t    </div>\n\t\t    </div>\n\t\t</section>\n\n\t\t<!--\n\t\t<section class=\"recur-section summary\">\n          \t<h2>Summary</h2>\n\t\t\t<div class=\"inner\">\n\t\t\t\t<!--ng-repeat=\"period in rSCC.recurrenceConfigPeriods\"--\n\t\t\t\t<div class=\"event-item\">\n\t\t\t\t  \t<p>\n\t\t\t\t  \t\t<span class=\"rSCC.recurrenceConfig-write\" ng-hide=\"writing\">{{rSCC.recurrenceConfig.humanSentence}}</span>\n<!-- \t\t\t\t  \t\t<input class=\"rSCC.recurrenceConfig-write\" ng-model=\"rSCC.recurrenceConfig.writeRule\" ng-change=\"testWriteRule(rSCC.recurrenceConfig)\" ng-show=\"writing\" />\n\t\t\t\t  \t\t<button class=\"btn blue right\" ng-hide=\"writing\" ng-click=\"rSCC.startWrite()\">Write Your Rule</button>\n\t\t\t\t  \t\t<button class=\"btn blue right\" ng-show=\"writing\" ng-click=\"rSCC.endWrite(rSCC.recurrenceConfig)\">Finished</button> --\n\t\t\t\t  \t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\t-->\n\t</div>\n\t<!--\n\t<footer>\n\t\t<button class=\"btn blue right save\" ng-click=\"rSCC.save()\" translate=\"common.done\">Done</button>\n\t\t<button class=\"btn black cancel\" ng-click=\"rSCC.close()\" translate=\"common.cancel\">Cancel</button>\n\t\t<span class=\"error\" ng-if=\"rSCC.modalError\" translate=\"schedules.pleaseSelectDate\">Please select rSCC.recurrenceConfig date detail</span>\n\t</footer>\n-->\n</div>\n\n";
});
$__System.register('80', ['7c', '7f'], function (_export) {
  'use strict';

  var RRule, recur_schedules_configuration_tmpl, recurSchedulesConfigurationComponent;
  return {
    setters: [function (_c) {
      RRule = _c['default'];
    }, function (_f) {
      recur_schedules_configuration_tmpl = _f['default'];
    }],
    execute: function () {
      recurSchedulesConfigurationComponent = {
        template: recur_schedules_configuration_tmpl,
        bindings: {
          recurrence: '<',
          onUpdate: '&'
        },
        controllerAs: 'rSCC',
        controller: function controller($scope, moment, RecurrenceTransforms) {

          var rSCC = this;

          rSCC.$onInit = function () {

            rSCC.recurrenceConfig = angular.copy(rSCC.recurrence);

            if (!rSCC.recurrenceConfigControls) {
              rSCC.recurrenceConfigControls = buildConfigControls(rSCC.recurrenceConfig);
            }

            setCalenderMinMax();

            rSCC.update = function () {
              rSCC.onUpdate({ recurrence: buildRRule(rSCC.recurrenceConfig, rSCC.recurrenceConfigControls) });
            };

            setRecurrenceDefaults(rSCC.recurrenceConfig);
          };

          rSCC.onTimeChange = function () {
            rSCC.recurrenceConfig.startTimeTouched = true;
            rSCC.update();
          };

          rSCC.$onChanges = function () {
            //
          };

          function setCalenderMinMax() {
            rSCC.minEndDate = moment();
            rSCC.maxEndDate = moment().add(101, 'years');
            rSCC.minStartDate = moment();
            rSCC.maxStartDate = moment().add(100, 'years');

            rSCC.yearStart = moment().startOf('year').format('YYYY-MM-DD');
            rSCC.yearEnd = moment().endOf('year').format('YYYY-MM-DD');
          }

          function setRecurrenceDefaults(recurrence) {

            // guarentees start/end dates are Date objects prior to handling defaults if not so already
            if (recurrence.startTime.date && !(recurrence.startTime.date instanceof Date)) {
              recurrence.startTime.date = new Date(recurrence.startTime.date);
            }

            if (recurrence.dtend && !(recurrence.dtend instanceof Date)) {
              recurrence.dtend = new Date(recurrence.dtend);
            }

            //Set 0's to 12s
            if (!recurrence.startTime.sunPosition && recurrence.startTime.hour === 0) {
              recurrence.startTime.hour = 12;
            }

            if (recurrence.startTime.date) {
              rSCC.minEndDate = moment(recurrence.startTime.date);
              $scope.$broadcast('pickerUpdate', 'pickerEndDate', {
                minDate: rSCC.minEndDate
              });
            }
            if (recurrence.dtend) {
              rSCC.maxStartDate = recurrence.dtend;
              $scope.$broadcast('pickerUpdate', 'pickerStartDate', {
                maxDate: rSCC.maxStartDate
              });
            }

            if (rSCC.sendUpdateSignal) {
              $scope.$broadcast('pickerUpdate', 'pickerEndDate', {
                minDate: rSCC.minEndDate
              });
              $scope.$broadcast('pickerUpdate', 'pickerStartDate', {
                maxDate: rSCC.maxStartDate
              });
              rSCC.sendUpdateSignal = false;
            }
          }

          rSCC.toggleSelection = function (item) {
            item.selected = !item.selected;
            rSCC.update();
          };

          rSCC.editStartDate = function (recurrence) {
            if (!recurrence.startTime.date) {
              recurrence.startTime.date = new Date();
              //recurrence.startTime.date = moment();
            }
            rSCC.update();
          };

          rSCC.editEndDate = function (recurrence) {
            if (!recurrence.dtend) {
              recurrence.dtend = recurrence.startTime.date || new Date();
            }
            rSCC.update();
          };

          rSCC.clearStartDate = function (recurrence) {
            recurrence.startTime.date = null;
            rSCC.minStartDate = moment();
            rSCC.minEndDate = moment();
            rSCC.sendUpdateSignal = true;
            rSCC.update();
          };

          rSCC.clearEndDate = function (recurrence) {
            recurrence.dtend = null;
            rSCC.maxStartDate = null;
            rSCC.sendUpdateSignal = true;
            rSCC.update();
          };

          rSCC.getToday = function () {
            return moment();
          };

          rSCC.getDateOnly = function (date) {
            return moment(date).format('YYYY-MM-DD');
          };

          rSCC.testWriteRule = function (recurrence) {
            //
            _.debounce(function () {
              recurrence.rrule = new RRule.fromText(recurrence.writeRule);

              if (recurrence.rrule) {
                recurrence.humanRRule = recurrence.rrule.toText();
                rSCC.writeError = false;
              } else {
                rSCC.writeError = true;
              }
            }, 200);
          };

          rSCC.selectPeriod = function (item, recurrence, controls) {
            //clear time stamps for summary
            controls.weekdays = returnWeekdays();
            controls.months = returnMonths();
            controls.monthdays = returnMonthdays();
            recurrence.interval = null;

            var set = controls.periods;

            set = _.mapValues(set, function (item) {
              item.selected = false;
              return item;
            });

            //item.selected = !state;
            item.selected = true;

            rSCC.update();

            return set;
          };

          rSCC.startWrite = function () {
            rSCC.writing = true;
          };

          rSCC.endWrite = function (recurrence) {
            rSCC.writing = false;
            recurrence.rrule = new RRule.fromText(recurrence.writeRule);
          };

          function buildConfigControls(recurrence) {
            var recurrenceConfigControls = {};

            recurrenceConfigControls.periods = {
              daily: { name: 'daily', rrule: 'RRule.DAILY', rrule_freq: 3 },
              weekly: { name: 'weekly', rrule: 'RRule.WEEKLY', rrule_freq: 2 },
              monthly: { name: 'monthly', rrule: 'RRule.MONTHLY', rrule_freq: 1 },
              yearly: { name: 'yearly', rrule: 'RRule.YEARLY', rrule_freq: '0' }, //for _pickBy
              once: { name: 'once', rrule: false, rrule_freq: 'X' }
            };

            recurrenceConfigControls.weekdays = returnWeekdays();

            recurrenceConfigControls.months = returnMonths();

            recurrenceConfigControls.monthdays = returnMonthdays();

            if (recurrence.rrule) {
              //Select our stuff

              //Once marked based on count
              if (recurrence.rrule.options.count || recurrence.count) {
                recurrenceConfigControls.periods.once.selected = true;
              } else {
                _.each(recurrenceConfigControls.periods, function (period) {
                  if (period.rrule_freq == recurrence.rrule.origOptions.freq) {
                    period.selected = true;
                  }
                });
              }

              _.each(recurrenceConfigControls.weekdays, function (day) {
                if (recurrence.rrule.origOptions.byweekday) {
                  if (recurrence.rrule.origOptions.byweekday.indexOf(day.position) > -1) {
                    day.selected = true;
                  }
                }
              });

              _.each(recurrenceConfigControls.monthdays, function (monthday) {
                if (recurrence.rrule.origOptions.bymonthday) {
                  if (recurrence.rrule.origOptions.bymonthday.indexOf(monthday.position) > -1) {
                    monthday.selected = true;
                  }
                }
              });

              _.each(recurrenceConfigControls.months, function (month) {
                if (recurrence.rrule.origOptions.bymonth) {
                  if (recurrence.rrule.origOptions.bymonth.indexOf(month.position) > -1) {
                    month.selected = true;
                  }
                }
              });
            }

            //If no period selected - set daily as a default
            if (!_.find(recurrenceConfigControls.periods, 'selected')) {
              recurrenceConfigControls.periods.daily.selected = true;
            }

            return recurrenceConfigControls;
          }

          // Clear out recurrence when down to 0 events
          function buildRRule(recurrence, controls) {

            if (recurrence.startTime.sunPosition) {
              //Make sure frequency isnt set to hourly?
              //Will this ever happen? Will there ever be a rainbow?
            }

            var rruleParams = _.pickBy({
              dtstart: recurrence.startTime.date ? moment(recurrence.startTime.date).toDate() : null,
              until: recurrence.dtend ? moment(recurrence.dtend).toDate() : null,
              freq: _.filter(controls.periods, 'selected')[0].rrule_freq,
              count: recurrence.count || false,
              interval: recurrence.interval || false,
              byweekday: _.filter(controls.weekdays, 'selected').length ? _.map(_.filter(controls.weekdays, 'selected'), function (item) {
                return item.position;
              }) : false,
              bymonth: _.filter(controls.months, 'selected').length ? _.map(_.filter(controls.months, 'selected'), function (item) {
                return item.position;
              }) : false,
              bymonthday: _.filter(controls.monthdays, 'selected').length ? _.map(_.filter(controls.monthdays, 'selected'), function (item) {
                return item.position;
              }) : false,
              byhour: parseInt(recurrence.startTime.hour) || false,
              byminute: parseInt(recurrence.startTime.minute) || false,
              bysecond: '00' //For RRule.js
            });

            //'Once' is a special case - set RRule freq to yearly and count to 1
            if (rruleParams.freq === 'X') {
              recurrence.once = true;
              rruleParams.freq = '0';
              rruleParams.count = 1;
              recurrence.count = 1;
            } else {
              delete rruleParams.count; //Set count back to false for all other frequencies
              delete recurrence.count;
            }

            recurrence.rrule = new RRule(rruleParams);

            recurrence.freq = rruleParams.freq; //RRule object doesn't store this?
            recurrence.humanSentence = RecurrenceTransforms.getHumanSentence(recurrence);

            return recurrence;
          }

          function returnWeekdays() {
            return {
              monday: { position: 1, rrule: 'RRule.MO' },
              tuesday: { position: 2, rrule: 'RRule.TU' },
              wednesday: { position: 3, rrule: 'RRule.WE' },
              thursday: { position: 4, rrule: 'RRule.TH' },
              friday: { position: 5, rrule: 'RRule.FR' },
              saturday: { position: 6, rrule: 'RRule.SA' },
              sunday: { position: 0, rrule: 'RRule.SU' }
            };
          }

          function returnMonths() {
            return {
              jan: { position: 1 },
              feb: { position: 2 },
              mar: { position: 3 },
              apr: { position: 4 },
              may: { position: 5 },
              jun: { position: 6 },
              jul: { position: 7 },
              aug: { position: 8 },
              sep: { position: 9 },
              oct: { position: 10 },
              nov: { position: 11 },
              dec: { position: 12 }
            };
          }

          function returnMonthdays() {
            return _.times(31, function (i) {
              return { position: i + 1 };
            });
          }
        }
      };

      _export('default', recurSchedulesConfigurationComponent);
    }
  };
});

$__System.register('81', [], function (_export) {
  'use strict';

  var recurSchedulesConfigurationParentComponent;
  return {
    setters: [],
    execute: function () {
      recurSchedulesConfigurationParentComponent = {
        template: '\n    <div class="recurrence-period event-item" ng-class="{\'error\': rB.error && !rSCPC.recurrence.rrule}">\n      <button class="btn black edit right" ng-disabled="rB.disabled" ng-click="rSCPC.editing = !rSCPC.editing;" ng-if="!rSCPC.editing" translate="common.edit">Edit</button>\n      <button class="btn blue right" ng-disabled="rB.disabled" ng-click="rSCPC.editing = !rSCPC.editing;" ng-if="rSCPC.editing" translate="common.done">Done</button>\n      <h1 ng-bind="rSCPC.humanSentence"></h1>\n    </div>\n    <div class="recurrence-period event-item configuration" ng-if="rSCPC.editing">\n      <recur-schedules-configuration recurrence="rSCPC.recurrence" on-update="rSCPC.updateRecurrence(recurrence);"></recur-schedules-configuration>\n    </div>  \n  ',
        bindings: {
          recurrence: '<',
          onRecurrenceUpdate: '&'
        },
        controllerAs: 'rSCPC',
        controller: function controller() {

          var rSCPC = this;

          rSCPC.$onInit = function () {
            rSCPC.updateRecurrence(rSCPC.recurrence);
          };

          rSCPC.$onChanges = function (change) {
            //console.log(change)
            if (change.recurrence.currentValue) {
              rSCPC.updateRecurrence(change.recurrence.currentValue);
            }
          };

          rSCPC.updateRecurrence = function (recurrence) {
            rSCPC.humanSentence = recurrence.humanSentence;
            rSCPC.onRecurrenceUpdate({ recurrence: recurrence });
          };
        }
      };

      _export('default', recurSchedulesConfigurationParentComponent);
    }
  };
});

$__System.register('82', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, TimeClickerDirective;

  return {
    setters: [function (_) {
      _createClass = _['default'];
    }, function (_2) {
      _classCallCheck = _2['default'];
    }],
    execute: function () {
      'use strict';

      TimeClickerDirective = (function () {
        function TimeClickerDirective() {
          _classCallCheck(this, TimeClickerDirective);

          this.restrict = 'E';
          this.replace = true;
          this.scope = {
            //
            // @todo
            //
            // Convert to one-way bind here
            //
            time: '=',
            onChange: '&'
          };
          this.template = '        \n      <div class="time-clicker">\n        <div class="contrast-buttons">\n          <div ng-click="time.sunPosition = false" ng-class="{selected: !time.sunPosition}">\n            <span>Time</span>\n          </div>\n          <div ng-click="time.sunPosition = \'sunrise\'" ng-class="{selected: time.sunPosition == \'sunrise\'}">\n            <span>Sunrise</span>\n          </div>\n          <div ng-click="time.sunPosition = \'sunset\'" ng-class="{selected: time.sunPosition == \'sunset\'}">\n            <span>Sunset</span>\n          </div>\n        </div>\n        <div class="time-edit">\n          <div class="col hours">\n            <div>\n              <button class="btn btn-time-arrow up" ng-click="increase(localTime.hour,12)"></button>\n            </div>\n            <div>\n              <input ng-minlength="0" ng-maxlength="12" max="12" min="0" step="1" type="number" ng-model="localTime.hour" placeholder="00"/>\n            </div>\n            <div>\n              <span class="caps">Hours</span>\n            </div>\n            <div>\n              <button class="btn btn-time-arrow down" ng-click="decrease(localTime.hour,12)"></button>\n            </div>\n          </div>\n          <div class="col mins">\n            <div>\n              <button class="btn btn-time-arrow up" ng-click="increase(localTime.minute,59)"></button>\n            </div>\n            <div>\n              <input ng-minlength="0" ng-maxlength="59" max="59" min="0" step="1" type="number" ng-model="localTime.minute" placeholder="00" />\n            </div>\n            <div>\n              <span class="caps">Mins</span>\n            </div>\n            <div>\n              <button class="btn btn-time-arrow down" ng-click="decrease(localTime.minute,59)"></button>\n            </div>\n          </div>\n        </div>\n        <div class="contrast-buttons vertical" ng-if="time.sunPosition">\n          <div ng-click="time.offsetCharge = \'before\'" ng-class="{selected: time.offsetCharge == \'before\'}">\n            <span>Before</span>\n          </div>\n          <!--<div ng-click="time.offsetCharge = false" ng-class="{selected: !time.offsetCharge}">\n            <span>At</span>\n          </div>-->\n          <div ng-click="time.offsetCharge = \'after\'" ng-class="{selected: time.offsetCharge == \'after\'}">\n            <span>After</span>\n          </div>\n        </div>\n        <div class="contrast-buttons vertical" ng-if="!time.sunPosition">\n          <div ng-click="time.amPm = \'AM\'" ng-class="{selected: time.amPm == \'AM\'}">\n            <span>Am</span>\n          </div>\n          <div ng-click="time.amPm = \'PM\'" ng-class="{selected: time.amPm == \'PM\'}">\n            <span>Pm</span>\n          </div>\n        </div>\n      </div>\n      ';
        }

        _createClass(TimeClickerDirective, [{
          key: 'controller',
          value: function controller() {}
        }, {
          key: 'link',
          value: function link(scope, element, attr) {

            scope.$watch('time', function (time) {
              if (time) {
                time.hour = parseInt(time.hour);
                time.minute = parseInt(time.minute);

                scope.localTime = time;

                if (time.hour == 12 && time.sunPosition) {
                  time.hour = 0; //12 to 24 hour clock BS
                }
                scope.onChange();
              }
            }, true);

            scope.increase = function (val, max) {
              if (max == 12) {
                scope.localTime.hour = maxReset(val, max, true);
              } else {
                scope.localTime.minute = maxReset(val, max, true);
              }
            };

            scope.decrease = function (val, max) {
              if (max == 12) {
                scope.localTime.hour = maxReset(val, max, false);
              } else {
                scope.localTime.minute = maxReset(val, max, false);
              }
            };

            function maxReset(val, max, inc) {
              if (inc) {
                return val ? val == max ? 0 : val + 1 : 1;
              } else {
                return val ? val == 0 ? max : val - 1 : max;
              }
            }
          }
        }]);

        return TimeClickerDirective;
      })();

      _export('TimeClickerDirective', TimeClickerDirective);
    }
  };
});

$__System.registerDynamic("83", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"sub-header\">\n    <button class=\"btn m1pc blue save right recur\" ng-click=\"rBO.save(rBO.schedule)\" ng-disabled=\"rBO.ajaxPending || rBO.disabled || !rBO.schedule.events.length\" translate>{{rBO.ajaxPending ? 'common.saving':'common.save'}}</button>\n    <button class=\"btn m1pc orange delete right recur\" ng-click=\"rBO.promptDel(rBO.schedule)\" ng-disabled=\"rBO.ajaxPending || !rBO.schedule.id\" translate>{{rBO.ajaxPending ? 'common.deleting' : 'common.delete'}}</button>\n    <button class=\"btn m1pc right recur\"  ng-if=\"rBO.schedule.id\" ng-click=\"rBO.rename(rBO.schedule)\" ng-disabled=\"rBO.ajaxPending || rBO.disabled\" translate>{{rBO.ajaxPending ? 'common.renaming' : 'common.rename'}}</button>\n\n    <button ng-if=\"rBO.smartShiftSupported && (!rBO.schedule.events.length || (rBO.schedule.events.length === 1 && rBO.schedule.events[0].blank))\" class=\"btn m1pc right recur\" ng-click=\"rBO.onToggleScheduleType({type: 'smart'})\" ng-disabled=\"rBO.ajaxPending || rBO.disabled\" translate=\"schedules.switchToSmartShift\">Switch to Smart Shift</button>\n\n    <!-- Disable for now --\n    <button class=\"btn m1pc right recur\" ng-if=\"rBO.isSuperUser && rBO.copiedSchedule && !rBO.schedule.id\" ng-click=\"rBO.pasteSchedule()\" ng-disabled=\"rBO.ajaxPending || rBO.disabled\" translate=\"common.paste\">Paste</button>\n    <button class=\"btn m1pc right recur\" ng-if=\"rBO.isSuperUser\" ng-click=\"rBO.copySchedule(rBO.schedule)\" ng-disabled=\"rBO.ajaxPending || rBO.disabled\" translate=\"common.copy\">Copy</button>\n    -->\n    \n    <h3 translate=\"schedules.scheduleName\">Schedule Name</h3>\n    <div class=\"lc-input\">\n        <input placeholder=\"Enter Schedule Name\" class=\"\" type=\"text\" ng-disabled=\"rBO.disabled || rBO.schedule.id\" ng-model=\"rBO.schedule.name\" />\n    </div>\n\n    <button class=\"btn m1pc right \" ng-if=\"!rBO.schedule.id && rBO.schedule.events.length > 0\" ng-click=\"rBO.clearEvents()\">Clear</button>\n    <h3 translate=\"schedules.scheduledEvents\">Scheduled Events</h3>\n</section>\n\n<div>\n    <section class=\"light-gray\" ng-repeat=\"(key, event) in rBO.schedule.events | orderBy:'event.recurrence.eventId'\">\n        <div class=\"event-group\">\n\n            <recur-schedules-configuration-parent ng-if=\"event.recurrence\" recurrence=\"event.recurrence\" on-recurrence-update=\"rBO.updateRecurrence(rBO.schedule.events,key,recurrence)\"></recur-schedules-configuration-parent>             \n            <ul class=\"schedule-events\">\n                <!-- <li ng-repeat=\"(key, action) in event.actions\"> -->\n                <li>\n                    <div class=\"event\">\n                        <button class=\"btn-select remove recur\" ng-disabled=\"rBO.disabled || rBO.automationSchedule\" ng-click=\"rBO.removeEvent($index,rBO.schedule.events)\"></button>\n                        \n                        <div class=\"event-item\" ng-class=\"{'zone-special': event.object_type == 'zone', 'zone-slider': event.dimmable, 'error': rBO.error && event.blank}\">\n\n                            <div class=\"event-item-container\" ng-if=\"event.object_type == 'zone'\" ng-class=\"{'zone-special': event.object_type == 'zone'}\">\n                                <div class=\"overview-zone event-zone\" ng-class=\"{'has-slider' : event.dimmable, 'on' : event.state, 'trimmed' : event.trim_high < 100, 'trim-maxed' : event.trim_high === event.dim_level && event.trim_high < 100, 'selected' : !event.excluded}\">\n                                    <div class=\"zone-control\">\n                                        <button class=\"btn-push\" ng-disabled=\"rBO.disabled\" ng-bind=\"event.state\" ng-class=\"{on:event.state}\" ng-click=\"event.state = !event.state\"></button>\n\n                                        <span class=\"zone-name\">\n                                            {{event.description == undefined ? 'Loading...' : event.description}}\n                                        </span>\n                                        \n                                        <div ng-if=\"event.dimmable\" class=\"slider-wrapper\">\n                                            <slider floor=\"1\" ceiling=\"{{event.trim_high ? event.trim_high : 100}}\" step=\"1\" precision=\"1\" dim=\"true\" level=\"event.dim_level\" ng-model=\"event.dim_level\" ng-model-high=\"100\" enabled=\"!rBO.disabled\" update=\"\"></slider>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"event-item-container\" ng-if=\"event.object_type !== 'zone'\">\n                                <h1 class=\"capitalise\" ng-if=\"event.blank\" translate=\"schedules.selectEvent\">Select Event</h1>\n                                <h1 class=\"capitalise\">{{event.description ? (event.object_type==='behavior2' ? 'Automation' : event.object_type) + ' ' + event.description : event.name ? (event.object_type==='behavior2' ? 'Automation' : event.object_type) + ' ' + event.name : (event.object_type==='behavior2' ? 'Automation' : event.object_type) + ' ' + event.object_id}}</h1>\n                            </div>\n\n                            <button class=\"btn black edit right\" ng-disabled=\"rBO.disabled || rBO.automationSchedule\" ng-click=\"rBO.selectKeyOption(event, key)\" translate=\"common.edit\">Edit</button>\n                        </div>\n\n                        <div class=\"set\" translate=\"common.set\">set</div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </section>\n</div>\n\n<section class=\"add\">\n    <div class=\"event-item\">\n        <button class=\"btn blue right\" ng-disabled=\"rBO.disabled || rBO.automationSchedule\" ng-click=\"rBO.addEvent();\" translate=\"common.add\">Add</button>\n        <h1 translate=\"schedules.addEvent\">Add Event</h1>\n    </div>      \n</section>";
});
$__System.register('84', ['83'], function (_export) {
    'use strict';

    var recurBodyTemplate, recurBodyComponent;
    return {
        setters: [function (_2) {
            recurBodyTemplate = _2['default'];
        }],
        execute: function () {
            recurBodyComponent = {
                template: recurBodyTemplate,
                bindings: {
                    areas: '<',
                    automations: '<',
                    isSuperUser: '<',
                    scenes: '<',
                    schedule: '<',
                    zones: '<',
                    allSchedules: '<',
                    //
                    // Out
                    //
                    onCrud: '&',
                    onToggleScheduleType: '&'
                },
                controllerAs: 'rBO',
                controller: function controller($scope, $q, RecurrenceSchedules, Modals, Messages, _) {

                    var rBO = this;

                    rBO.$onInit = function () {
                        // right now, we don't need this schedule automation check
                        // may though a better way to handle the schedule automation later
                        // if(behaviorScheduleCheck(rBO.schedule.events)){
                        //     rBO.automationSchedule = true;
                        //
                        rBO.copiedSchedule = RecurrenceSchedules.copiedSchedule;

                        //
                        // Only allow SS schedules for sites with CCT devices
                        //
                        rBO.smartShiftSupported = checkCCTDevices(rBO.zones);
                    };

                    rBO.removeEvent = function (index, events) {
                        events.splice(index, 1);
                    };

                    rBO.clearEvents = function () {
                        rBO.schedule.events = [];
                        rBO.schedule.name = null;
                    };

                    rBO.selectKeyOption = function (selectedEvent, key) {
                        //
                        //
                        // @todo remove single select modal and replace with multi and single limit
                        //
                        //

                        var event = selectedEvent ? selectedEvent : new RecurrenceSchedules.event(true, selectedEvent);

                        var originalEventRecurrence = event.recurrence;

                        var allZones = _.map(rBO.areas, function (area) {
                            area.zones = _.filter(rBO.zones, function (zone) {
                                return zone.area === area.id;
                            });
                            return area;
                        });

                        allZones.push({
                            id_string: 'No Area',
                            zones: _.filter(rBO.zones, function (zone) {
                                return !zone.area;
                            })
                        });
                        //core problem is here, all items treat each modal element insides a whole together

                        var allItems = [{
                            type: 'zones',
                            areas: allZones,
                            selected: _.filter(rBO.zones, function (zone) {
                                return event.object_type === 'zone' && event.object_id === zone.id;
                            })
                        }, {
                            type: 'scenes',
                            areas: [{ name: 'Site Wide', scenes: rBO.scenes }],
                            selected: _.filter(rBO.scenes, function (scene) {
                                return event.object_type === 'scene' && event.object_id === scene.id;
                            })
                        }, {
                            type: 'automations',
                            areas: [{ automations: rBO.automations }],
                            selected: _.filter(rBO.automations, function (automation) {
                                //don't know why here automation change from behavior_id to id
                                return event.object_type === 'behavior2' && event.object_id === automation.id;
                            })
                        }];

                        Modals.showMulti(allItems, 'Schedule Events', 'schedules', 1).then(function (selection) {
                            // why use map
                            if (selection && selection.length > 0) {
                                var selectedEvents = _.map(selection, function (item) {
                                    //no more behavior_id

                                    var itemId = item.object_id || item.id || item.behavior_id;
                                    var itemType = item.zone_msg ? 'zone' : item.criteria ? 'behavior2' : 'scene';
                                    // let existingEvent = _.find(rBO.schedule.events, event => {
                                    //     return event.object_type === itemType && event.object_id === itemId;
                                    // });

                                    var newEvent = {
                                        recurrence: originalEventRecurrence,
                                        object_type: itemType,
                                        description: item.description || item.name,
                                        dimmable: item.is_dimmable ? item.is_dimmable : false,
                                        dim_level: 50, //Nothing supplied - default to 50
                                        object_id: itemId,
                                        state: item.zone_state === 'on' ? 1 : 0
                                    };

                                    return newEvent; //existingEvent ? existingEvent : newEvent;
                                });
                                rBO.schedule.events[key] = angular.copy(selectedEvents[0]);
                            }
                        });
                    };

                    rBO.addEvent = function () {
                        rBO.schedule.events.push(new RecurrenceSchedules.event(true));
                    };

                    rBO.save = function (schedule) {
                        if (schedule.name === 'Blank Schedule') {
                            promptModal('Schedule Name', schedule);
                        } else {
                            saveSchedule(schedule);
                        }
                    };

                    rBO.copySchedule = function (schedule) {
                        RecurrenceSchedules.copiedSchedule = new RecurrenceSchedules.blankSchedule('Copy of ' + schedule.name, _.map(schedule.events, function (event) {
                            return {
                                dates: event.dates,
                                recurrence: event.recurrence
                            };
                        }));

                        rBO.copiedSchedule = RecurrenceSchedules.copiedSchedule;
                    };

                    rBO.pasteSchedule = function () {
                        rBO.schedule = RecurrenceSchedules.copiedSchedule;
                    };

                    rBO.rename = function (schedule) {
                        promptModal('Rename', schedule);
                    };

                    rBO.promptDel = function (schedule) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete this schedule?').then(function () {
                            //@todo yuchau translations
                            delSchedule(schedule);
                        });
                    };

                    rBO.updateRecurrence = function (scheduleEvents, eventIndex, recurrence) {
                        //console.log('Update from parent');
                        //console.log(recurrence);
                        scheduleEvents[eventIndex].recurrence = recurrence;
                    };

                    function checkCCTDevices(zones) {
                        return _.find(zones, 'is_tunable') ? true : false;
                    }

                    function behaviorScheduleCheck(events) {
                        return _.find(events, { object_type: 'behavior2' });
                    }

                    function checkDuplicateName(scheduleName, currentScheduleId) {
                        if (!rBO.allSchedules || !Array.isArray(rBO.allSchedules)) {
                            return false;
                        }

                        return rBO.allSchedules.some(function (schedule) {
                            return schedule.name === scheduleName && (currentScheduleId === undefined || schedule.id !== currentScheduleId);
                        });
                    }

                    function checkMissing(schedule) {
                        return schedule.events.map(function (event) {
                            var missing = {};

                            if (event.blank) missing.event = true;
                            if (!event.recurrence.startTimeTouched && !event.recurrence.eventId) missing.startTime = true;
                            if (missing.event && missing.startTime) missing.both = true;
                            //if (event.blank && (!event.recurrence.startTimeTouched && !event.recurrence.id)) missing.both = true; // Check if both event and startTime are missing

                            return missing;
                        });
                    }

                    function promptModal(title, schedule) {
                        rBO.cleanSchedule = angular.copy(schedule);

                        Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: schedule,
                                cleanObject: rBO.cleanSchedule,
                                title: title,
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                if (checkMissing(schedule)) {
                                    saveSchedule(schedule);
                                }
                            } else {
                                schedule.name = rBO.cleanSchedule.name;
                            }
                        });
                    }

                    function saveSchedule(schedule) {
                        rBO.ajaxPending = true;
                        Modals.openLoad('Saving Schedule');
                        //This is to prevent the dom updating with a an unmatrixed schedule
                        var deep = _.cloneDeep(schedule);

                        // Check for duplicate schedule name first
                        if (checkDuplicateName(schedule.name, schedule.id)) {
                            rBO.ajaxPending = false;
                            Modals.closeLoad('Schedule Save Failed - Name Already Exists');
                            return;
                        }

                        // validation checks (independent from backend response)
                        var missing = checkMissing(schedule);
                        var handleMissing = function handleMissing(type, message) {
                            Modals.closeLoad('Schedule Incomplete: ' + message);
                            rBO.ajaxPending = false;
                            return;
                        };

                        var missingField = missing[0];
                        if (missingField.both) return handleMissing('both', 'Missing Time and Event');
                        if (missingField.startTime) return handleMissing('startTime', 'Missing Time');
                        if (missingField.event) return handleMissing('event', 'Missing Event');

                        if (schedule.id) {
                            RecurrenceSchedules.update(deep).success(function (response) {
                                finish(response, 'Schedule Saved');
                            }).error(function (data) {
                                rBO.ajaxPending = false;

                                if (Array.isArray(data)) {
                                    var err_message = data[0].toLowerCase();
                                    if (err_message.includes("no start date")) {
                                        Modals.closeLoad('Save Failed: No Start Date');
                                    } else {
                                        Modals.closeLoad('Save Failed');
                                    }
                                }
                            });
                        } else {
                            RecurrenceSchedules.create(deep).success(function (response) {
                                finish(response, 'Schedule Saved');
                                rBO.onCrud({ destinationId: response.id });
                            }).error(function (data) {
                                rBO.ajaxPending = false;

                                if (Array.isArray(data)) {
                                    var err_message = data[0].toLowerCase();
                                    if (err_message.includes("no start date")) {
                                        Modals.closeLoad('Save Failed: Add Start Date');
                                    } else {
                                        Modals.closeLoad('Save Failed');
                                    }
                                }
                            });
                        }
                    }

                    function delSchedule(schedule) {
                        Modals.openLoad('Deleting Schedule');
                        RecurrenceSchedules.del(schedule).success(function (data) {
                            Modals.closeLoad('Schedule Deleted', true);
                            rBO.onCrud({ destinationId: null });
                        }).error(function () {
                            rBO.ajaxPending = false;
                            Modals.closeLoad('Delete Failed');
                        });
                    }

                    function finish(response, message) {
                        rBO.ajaxPending = false;
                        Modals.closeLoad(message, true);
                    }
                }
            };

            _export('default', recurBodyComponent);
        }
    };
});

$__System.register('85', ['80', '81', '82', '84', '7a', '7b'], function (_export) {
    'use strict';

    var recurSchedulesConfigurationComponent, recurSchedulesConfigurationParentComponent, TimeClickerDirective, recurBodyComponent, RecurrenceService, RecurrenceTransformsService, recurModule;
    return {
        setters: [function (_) {
            recurSchedulesConfigurationComponent = _['default'];
        }, function (_2) {
            recurSchedulesConfigurationParentComponent = _2['default'];
        }, function (_3) {
            TimeClickerDirective = _3.TimeClickerDirective;
        }, function (_4) {
            recurBodyComponent = _4['default'];
        }, function (_a) {
            RecurrenceService = _a['default'];
        }, function (_b) {
            RecurrenceTransformsService = _b['default'];
        }],
        execute: function () {
            recurModule = angular.module('schedules-recurrence', []).service('RecurrenceSchedules', RecurrenceService).service('RecurrenceTransforms', RecurrenceTransformsService).component('recurSchedulesConfiguration', recurSchedulesConfigurationComponent).component('recurSchedulesConfigurationParent', recurSchedulesConfigurationParentComponent).component('recurBody', recurBodyComponent).directive('timeClicker', function () {
                return new TimeClickerDirective();
            });

            _export('default', recurModule);
        }
    };
});

$__System.register('86', [], function (_export) {
    'use strict';

    function SmartShiftSchedules($http, $q, moment, LcFn, Track, Scenes, RecurrenceSchedules, scenesTransform, _) {

        var blankRecurrence = {
            humanSentence: 'Select Time',
            startTime: {
                hour: '9',
                minute: '30',
                amPm: 'AM',
                date: null,
                sunPosition: false,
                offsetCharge: false
            },
            count: null,
            freq: null,
            interval: null,
            mode: null //Nothing for now
        };

        var Event = function Event(blank, lastItem) {
            this.blank = blank;
            this.recurrence = lastItem ? lastItem.recurrence : blankRecurrence;
        };

        this.blankSchedule = function () {
            this.type = 'smart';
            this.name = 'Blank Smart Schedule', this.events = [new Event(true)];
            this.zones = null;
        };

        this.nearestCCTShade = function (targetCCT) {
            // credit http://planetpixelemporium.com/ !
            var orderedCCTHex = [{
                name: 'Candle',
                cct: 1900,
                rgb: '255, 147, 41'
            }, {
                name: '40W Tungsten',
                cct: 2600,
                rgb: '255, 197, 143'
            }, {
                name: '100W Tungsten',
                cct: 2850,
                rgb: '255, 214, 170'
            }, {
                name: 'Halogen',
                cct: 3200,
                rgb: '255, 241, 224'
            }, {
                name: 'Carbon Arc',
                cct: 5200,
                rgb: '255, 250, 244'
            }, {
                name: 'High Noon Sun',
                cct: 5400,
                rgb: '255, 255, 251'
            }, {
                name: 'Direct Sunlight',
                cct: 6000,
                rgb: '255, 255, 255'
            }, {
                name: 'Overcast Sky',
                cct: 7000,
                rgb: '201, 226, 255'
            }, {
                name: 'Clear Blue Sky',
                cct: 20000,
                rgb: '64, 156, 255'
            }];

            //
            // Davis wants to use existing colors not the real deal...
            //

            var rabCCT = [{
                name: 'Red',
                cct: 2700,
                rgb: '242,124,33'
            }, {
                name: 'Yellow',
                cct: 4300,
                rgb: '242,235,43'
            }, {
                name: 'White',
                cct: 5400,
                rgb: '255,255,255'
            }, {
                name: 'Blue',
                cct: 6500,
                rgb: '16,178,237'
            }];

            return orderedCCTHex.reduce(function (best, current) {
                return current.cct >= targetCCT && (!best || current.cct < best.cct) ? current : best;
            }, undefined);
        };

        this.parseFromBackend = function (schedule, scenes) {
            //
            //
            // @todo CCT and DIM only flags need to be set
            //
            //
            function timeFromRRules(recurrence) {
                return moment(recurrence.startTime.hour + ':' + recurrence.startTime.minute + ' ' + recurrence.startTime.amPm, 'hh:mm A').format('HH:mm');
            }

            //
            // Deal with dumb double scene actions for zones
            //
            function pickFlattenMergeZoneAction(actions) {
                var firstPair = _.sortBy(actions, 'systemId');
                var newAction1 = angular.copy(firstPair[0]),
                    newAction2 = angular.copy(firstPair[1]);
                return _.merge(newAction1, newAction2);
            }

            function matchEventToSceneAction(eventObjId, scenes) {
                var matchingScene = _.find(scenes, { id: eventObjId });

                return pickFlattenMergeZoneAction(matchingScene.actions);
            }

            //
            //
            // Assumes event and scene response order are the same
            //
            //
            return {
                cctOnly: false,
                dimOnly: false,
                graph: _.filter(_.map(schedule.events, function (event, k) {

                    var thisSceneAction = matchEventToSceneAction(event.object_id, scenes);

                    return {
                        time: timeFromRRules(event.recurrence),
                        cct: thisSceneAction.cct,
                        dimLevel: thisSceneAction.dimLevel,
                        cct_transition_time: thisSceneAction.cct_transition_time || 0
                    };
                }), function (event) {
                    //
                    // @todo - remove this hack
                    //
                    // Remove fade events
                    //
                    return event.cct_transition_time === 0;
                }),
                name: schedule.name
            };
        };

        this.checkDeleteExistingScenes = function (scheduleName, allScenes) {
            //
            // Dirty - need backend to provide ID
            //

            var existingScenes = _.filter(allScenes, function (scene) {
                return (scene.name || scene.id_string).indexOf(scheduleName) > -1;
            });

            return existingScenes.length ? $q.all(_.map(existingScenes, function (scene) {
                return Scenes.del(scene);
            })) : $q.resolve();
        };

        this.tempBuildScenesSaveSchedule = function (schedule, smartScheduleGraphData, allScenes, allZones, siteId) {
            //
            // Build Scenes, remove related for now (update in future)
            //
            return this.checkDeleteExistingScenes(schedule.name, allScenes).then(function () {
                return buildSmartScenes(schedule, smartScheduleGraphData, allZones, siteId).then(function (createdScenes) {
                    return schedule.id ? RecurrenceSchedules.update(buildSmartSchedule(schedule, smartScheduleGraphData, createdScenes)) : RecurrenceSchedules.create(buildSmartSchedule(schedule, smartScheduleGraphData, createdScenes));
                });
            });
        };

        function buildDummyRecurrence(time) {
            var pointMoment = moment(time, 'HH:mm');

            return {
                freq: 3,
                humanSentence: '',
                interval: null,
                mode: null,
                rrule: {
                    origOptions: { freq: 3, byhour: pointMoment.format('HH'), byminute: pointMoment.format('mm'), bysecond: '00' }
                },
                startTime: {
                    amPm: pointMoment.format('a'),
                    date: null,
                    hour: pointMoment.format('HH'),
                    minute: pointMoment.format('mm'),
                    offsetCharge: false,
                    sunPosition: false
                }
            };
        }

        function addTransitionPoints(schedulePoints) {

            var lastPoint = null;

            _.each(schedulePoints, function (point) {
                if (!lastPoint) {
                    //
                    // Add 3 hour transition for first change
                    //
                    lastPoint = {
                        cct: point.cct,
                        dimLevel: point.dimLevel,
                        time: moment(point.time, 'HH:mm').subtract(3, 'hours').format('HH:mm'),
                        cct_transition_time: 180
                    };
                }

                // Get transition duration
                var transitionDuration = moment(point.time, 'HH:mm').diff(moment(lastPoint.time, 'HH:mm'), 'minutes');

                lastPoint = {
                    cct: point.cct,
                    dimLevel: point.dimLevel,
                    time: moment(point.time, 'HH:mm'),
                    cct_transition_time: transitionDuration
                };

                schedulePoints.push(lastPoint);
            });

            // Re-sort?

            return schedulePoints;
        }

        this.getIncludedZones = function (schedule, scenes, zones) {
            //
            // Will return null for all zones
            //
            var firstScheduleEvent = schedule.events[1];
            var firstMatchingScene = _.find(scenes, { id: firstScheduleEvent.object_id });

            var scheduleZoneIds = _.uniq(_.map(firstMatchingScene.actions, 'systemId')).sort();
            var allZoneIds = _.map(_.filter(zones, 'is_tunable'), 'id').sort();

            return JSON.stringify(scheduleZoneIds) === JSON.stringify(allZoneIds) ? null : _.filter(zones, function (zone) {
                return scheduleZoneIds.indexOf(zone.id) > -1;
            });
        };

        function buildSmartScenes(schedule, smartScheduleGraphData, allZones, siteId) {
            //
            //    Temporary ridiculous Hack to account for CCT transitions
            //
            //    Add another CCT-only scene to initiate transition / fade
            //    Please do this in BE in future
            //   
            var scheduleData = schedule.dimOnly ? smartScheduleGraphData : addTransitionPoints(smartScheduleGraphData);
            //
            //
            //
            return $q.all(_.map(scheduleData, function (point, k) {

                var newScene = {
                    actionZones: _.map(schedule.zones && schedule.zones.length ? schedule.zones : allZones, function (zone) {
                        if (!schedule.cctOnly) {
                            zone.reported_dim_level = point.dimLevel;
                            //
                            // NOTE: All 'Smart' schedules only affect dim and cct, no state
                            // 
                            zone.zone_state = null;
                        }
                        if (!schedule.dimOnly) {
                            zone.cct = point.cct;
                            zone.cct_transition_time = point.cct_transition_time;
                        }
                        return zone;
                    }),
                    name: (LcFn.isSmartShiftType(schedule) ? schedule.name : '[SHIFT] ' + schedule.name) + '[' + k + ']',
                    site: siteId
                };

                //scene, showColor, showDim, showState
                return Scenes.create(scenesTransform.mapSceneToBackend(newScene, !schedule.dimOnly, !schedule.cctOnly, false));
            }));
        }

        function buildSmartSchedule(schedule, smartScheduleGraphData, scenes) {
            return {
                events: _.map(smartScheduleGraphData, function (point, k) {
                    return {
                        object_id: scenes[k].id,
                        object_type: 'scene',
                        recurrence: buildDummyRecurrence(point.time)
                    };
                }),
                id: schedule.id || null,
                name: LcFn.isSmartShiftType(schedule) ? schedule.name : '[SHIFT] ' + schedule.name, //Temp
                type: 'smart'
            };
        }
    }

    return {
        setters: [],
        execute: function () {
            SmartShiftSchedules.$inject = ['$http', '$q', 'moment', 'LcFn', 'Track', 'Scenes', 'RecurrenceSchedules', 'scenesTransform', '_'];
            _export('default', SmartShiftSchedules);
        }
    };
});

$__System.registerDynamic("87", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"sub-header\">\n    <button class=\"btn m1pc blue save right recur\" ng-click=\"sSB.save(sSB.schedule,sSB.smartScheduleGraphData)\" ng-disabled=\"sSB.ajaxPending || sSB.disabled || !sSB.schedule.events.length\" translate>{{sSB.ajaxPending ? 'common.saving':'common.save'}}</button>\n    <button class=\"btn m1pc orange delete right recur\" ng-click=\"sSB.promptDel(sSB.schedule)\" ng-disabled=\"sSB.ajaxPending || !sSB.schedule.id\" translate>{{sSB.ajaxPending ? 'common.deleting' : 'common.delete'}}</button>\n    <button class=\"btn m1pc right recur\" ng-if=\"sSB.schedule.id\" ng-click=\"sSB.rename(sSB.schedule,sSB.smartScheduleGraphData)\" ng-disabled=\"sSB.ajaxPending || sSB.disabled\" translate>{{sSB.ajaxPending ? 'common.renaming' : 'common.rename'}}</button>\n    <button class=\"btn m1pc right recur\" ng-if=\"!sSB.schedule.id\" ng-click=\"sSB.onToggleScheduleType({type: 'default'})\" ng-disabled=\"sSB.ajaxPending || sSB.disabled\" translate=\"schedules.switchToDefaultSchedule\">Switch to Default Schedule</button>\n    <h3 translate=\"schedules.scheduleName\">Schedule Name</h3>\n    <div class=\"lc-input\">\n        <input placeholder=\"Enter Schedule Name\" class=\"\" type=\"text\" ng-disabled=\"sSB.disabled || sSB.schedule.id\" ng-model=\"sSB.schedule.name\" />\n    </div>\n    <h3 translate=\"schedules.scheduledEvents\">Scheduled Events</h3>\n</section>\n\n<section class=\"main-body no-padding light-gray\">\n    <div class=\"main-body smart-shift-header\">\n        <div class=\"left\" ng-if=\"!sSB.schedule.id\">\n            <span class=\"smallcaps\">Preset</span>\n\n            <div class=\"lc-select button\">\n                <select ng-model=\"sSB.selectedPreset\" ng-options=\"preset as preset.name for preset in sSB.presets\" class=\"no-user-styles\" ng-click=\"sSB.warnSetGraph($event,sSB.selectedPreset)\" ng-change=\"sSB.setGraph(sSB.selectedPreset)\"></select>\n            </div>\n        </div>\n\n        <div class=\"right\">\n            <button class=\"btn-select blue\" ng-class=\"{selected:!sSB.schedule.dimOnly}\" ng-click=\"sSB.toggleHideCCT()\"></button>\n            <span class=\"smallcaps\">Color Temperature (CCT)</span>\n\n            <button class=\"btn-select blue\" ng-class=\"{selected:!sSB.schedule.cctOnly}\" ng-click=\"sSB.toggleHideDimLevel()\"></button>\n            <span class=\"smallcaps\">Dim Level</span>\n        </div>\n    </div>\n</section>\n\n<section class=\"main-body no-padding light-gray\">\n    <smart-shift-chart\n        id=\"smart-shift-main\" \n        cct-only-mode=\"sSB.schedule.cctOnly\"\n        dim-only-mode=\"sSB.schedule.dimOnly\"\n        max-graph-points=\"sSB.maxGraphPoints\"\n        smart-schedule-graph-data=\"sSB.smartScheduleGraphData\"\n        sun-positions=\"sSB.sunPositions\"\n        ng-class=\"{'hide-cct': sSB.schedule.dimOnly, 'hide-dim-level': sSB.schedule.cctOnly, 'block-new-points': sSB.graphLength === sSB.maxGraphPoints}\"\n        on-pop-menu=\"sSB.onPopMenu(data,x,y,position,index)\"\n        on-update=\"sSB.updateGraph(graphData)\"\n    ></smart-shift-chart>\n</section>\n\n<section class=\"main-body\">\n\n    <h2 class=\"overview-heading\">\n        <span translate=\"zones.zones\">Zones</span>\n    </h2>\n\n    <div class=\"all-zones-toggle\">\n        <button class=\"btn btn-select-toggle\" ng-class=\"{selected: sSB.schedule.zones === null}\" ng-click=\"sSB.toggleAllZonesSelected()\"></button>\n        <span class=\"smallcaps\">All SmartShift Zones</span>\n    </div>\n</section>\n\n<section class=\"main-body no-padding light-gray\" ng-if=\"sSB.schedule.zones !== null\"> \n    <section class=\"smart-schedule-zone\" ng-repeat=\"(key, zone) in sSB.schedule.zones\"> <!-- | orderBy:'event.recurrence.eventId' -->\n        <div class=\"event-group\">\n            <ul class=\"schedule-events\">\n                <li>\n                    <div class=\"event\">\n                        <button class=\"btn-select remove recur\" ng-click=\"sSB.removeEvent($index,sSB.schedule.zones)\"></button>\n                        \n                        <div class=\"event-item\">\n\n                            <div class=\"event-item-container zone-special\">\n                                <div class=\"overview-zone event-zone\">\n                                    <div class=\"zone-control\">\n                                        <!--<button class=\"btn-push\" ng-disabled=\"sSB.disabled\" ng-bind=\"event.state\" ng-class=\"{on:event.state}\" ng-click=\"event.state = !event.state\"></button>-->\n\n                                        <span class=\"zone-name\">\n                                            {{zone.id_string}}\n                                        </span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </section>\n</section>\n\n\n<section class=\"main-body\">\n    <div class=\"white-pill-item no-icon short\" ng-if=\"sSB.schedule.zones !== null\">\n        <button class=\"btn black btn-white-plus large\" ng-click=\"sSB.selectObject(sSB.schedule.zones);\"></button>\n        <h1 class=\"name\" translate=\"demand.addZone\">Add Zone</h1>\n    </div>\n</section>";
});
$__System.register('88', ['87'], function (_export) {
    'use strict';

    var smartShiftBodyTemplate, smartShiftBodyComponent;
    return {
        setters: [function (_2) {
            smartShiftBodyTemplate = _2['default'];
        }],
        execute: function () {
            smartShiftBodyComponent = {
                template: smartShiftBodyTemplate,
                bindings: {
                    areas: '<',
                    automations: '<',
                    scenes: '<',
                    schedule: '<',
                    siteId: '<',
                    sunPositions: '<',
                    zones: '<',
                    //
                    // Out
                    //
                    onCrud: '&',
                    onToggleScheduleType: '&'
                },
                controllerAs: 'sSB',
                controller: function controller($timeout, $scope, moment, RecurrenceSchedules, Scenes, SmartShiftSchedules, smartShiftPresets, Modals, _) {

                    var sSB = this;
                    var cachedGraph = null;

                    sSB.$onInit = function () {
                        //
                        sSB.maxGraphPoints = 12;

                        sSB.presets = parsePresets(smartShiftPresets, sSB.sunPositions);

                        // Start with master
                        sSB.allZonesSelected = true;

                        // If no data - select a preset
                        if (!sSB.schedule.id) {
                            //
                            sSB.selectedPreset = sSB.presets[0];
                            sSB.setGraph(sSB.selectedPreset);
                        } else {
                            //
                            // First time prepare
                            //
                            prepareView(sSB.schedule, sSB.scenes, sSB.zones);
                        }
                    };

                    sSB.$onChanges = function (changes) {
                        //console.log('changes in ssbod', changes);
                    };

                    sSB.$onDestroy = function (changes) {
                        //console.log('destroy in ssbod', changes);
                    };

                    sSB.toggleHideCCT = function () {
                        sSB.schedule.dimOnly = !sSB.schedule.dimOnly;

                        if (sSB.schedule.dimOnly) {
                            sSB.schedule.cctOnly = false;
                        }
                    };

                    sSB.toggleHideDimLevel = function () {
                        sSB.schedule.cctOnly = !sSB.schedule.cctOnly;

                        if (sSB.schedule.cctOnly) {
                            sSB.schedule.dimOnly = false;

                            //
                            // Cache old graph before flattening dim for an undo state
                            //
                            cachedGraph = angular.copy(sSB.selectedPreset.graph);
                            sSB.smartScheduleGraphData = flattenDimLevel(sSB.selectedPreset.graph);
                        } else if (cachedGraph) {
                            //
                            // User changed their mind
                            //
                            sSB.smartScheduleGraphData = cachedGraph;
                            cachedGraph = null;
                        }
                    };

                    sSB.toggleAllZonesSelected = function () {
                        sSB.schedule.zones = sSB.schedule.zones === null ? [] : null;
                    };

                    sSB.warnSetGraph = function ($event, preset) {
                        console.log($event, preset);
                        $event.preventDefault();
                        $event.stopPropagation();
                    };

                    sSB.setGraph = function (preset) {
                        //
                        cachedGraph = null;
                        sSB.smartScheduleGraphData = preset.graph;
                        sSB.schedule.cctOnly = preset.cctOnly;
                        sSB.schedule.dimOnly = preset.dimOnly;
                        sSB.graphLength = preset.graph.length;
                    };

                    sSB.onPopMenu = function (data, x, y, position, index) {
                        //console.log(data,x,y,position,index);
                    };

                    sSB.updateGraph = function (graphData) {
                        sSB.smartScheduleGraphData = mapGraphPoint(graphData);

                        //
                        // Switch to custom on any change
                        //
                        setPresetCustom(sSB.presets, graphData);
                        sSB.graphLength = graphData.length;
                    };

                    sSB.selectObject = function () {
                        //let temp = true; // zone.is_tunable

                        var allZonesAreas = _.map(sSB.areas, function (area) {
                            area.zones = _.filter(sSB.zones, function (zone) {
                                return zone.area === area.id && zone.is_tunable;
                            });
                            return area;
                        });

                        allZonesAreas.push({
                            id_string: 'No Area',
                            zones: _.filter(sSB.zones, function (zone) {
                                return !zone.area && zone.is_tunable;
                            })
                        });

                        var allItems = [{
                            type: 'zones',
                            areas: allZonesAreas,
                            selected: _.filter(sSB.zones, function (zone) {
                                return _.find(sSB.schedule.zones, { 'id': zone.id });
                            })
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Zones', 'site-scenes').then(function (items) {
                            _.each(items, function (zone) {
                                zone.areaName = _.find(sSB.areas, ['id', zone.area]) ? _.find(sSB.areas, ['id', zone.area]).name : '';
                            });

                            sSB.schedule.zones = items;
                        });
                    };

                    sSB.save = function (schedule, smartScheduleGraphData) {
                        if (schedule.name === 'Blank Smart Schedule') {
                            promptModal('Schedule Name', schedule, smartScheduleGraphData);
                        } else {
                            saveSchedule(schedule, smartScheduleGraphData);
                        }
                    };

                    sSB.rename = function (schedule, smartScheduleGraphData) {
                        promptModal('Rename', schedule, smartScheduleGraphData);
                    };

                    sSB.promptDel = function (schedule) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete this schedule?').then(function () {
                            //@todo yuchau translations
                            delSchedule(schedule);
                        });
                    };

                    sSB.removeEvent = function (index, events) {
                        events.splice(index, 1);
                    };

                    function prepareView(schedule, scenes, zones) {
                        var preppedSchedule = SmartShiftSchedules.parseFromBackend(schedule, scenes);

                        sSB.schedule.zones = SmartShiftSchedules.getIncludedZones(schedule, scenes, zones);

                        sSB.setGraph(preppedSchedule);
                    }

                    function getUpdatedScenes(siteId) {
                        //
                        // Do we have master cache update
                        //
                        return Scenes.getForSite(siteId);
                    }

                    function saveSchedule(schedule, smartScheduleGraphData) {
                        Modals.openLoad('Saving Schedule');

                        // pre-validation check
                        if (schedule.name.length === 0) {
                            Modals.closeLoad('Schedule Save Failed: Enter Schedule Name');
                            return;
                        }

                        getUpdatedScenes(sSB.siteId).then(function (scenes) {
                            SmartShiftSchedules.tempBuildScenesSaveSchedule(schedule, smartScheduleGraphData, scenes, _.filter(sSB.zones, 'is_tunable'), sSB.siteId).then(function (response) {
                                Modals.closeLoad('Schedule Saved', true);
                                sSB.onCrud({ destinationId: response.data.id });

                                sSB.smartScheduleGraphData = smartScheduleGraphData;
                            })['catch'](function (e) {
                                console.log(e);
                                Modals.closeLoad('Schedule Save Failed');
                            });
                        });
                    }

                    function promptModal(title, schedule, smartScheduleGraphData) {
                        sSB.cleanSchedule = angular.copy(schedule);

                        Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: schedule,
                                cleanObject: sSB.cleanSchedule,
                                title: title,
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                saveSchedule(schedule, smartScheduleGraphData);
                            } else {
                                schedule.name = sSB.cleanSchedule.name;
                            }
                        });
                    }

                    function delSchedule(schedule) {
                        Modals.openLoad('Deleting Schedule');

                        getUpdatedScenes(sSB.siteId).then(function (scenes) {
                            SmartShiftSchedules.checkDeleteExistingScenes(schedule.name, scenes).then(function () {
                                RecurrenceSchedules.del(schedule).success(function () {
                                    Modals.closeLoad('Schedule Deleted', true);
                                    sSB.onCrud({ destinationId: null });
                                }).error(function () {
                                    Modals.closeLoad('Delete Failed');
                                });
                            });
                        });
                    }

                    function parsePresets(presets, sunPositions) {
                        function parseSunEvent(time) {
                            if (typeof time === 'string') {
                                if (time.indexOf('sun') > -1) {
                                    var sunTimeMoment = time.indexOf('rise') > -1 ? moment(sunPositions[0], 'HH:mm:ss') : moment(sunPositions[1], 'HH:mm:ss');

                                    if (time.indexOf('-') > -1) {
                                        sunTimeMoment.subtract(time.split('-')[1], 'hour');
                                    }

                                    if (time.indexOf('+') > -1) {
                                        sunTimeMoment.add(time.split('+')[1], 'hour');
                                    }

                                    time = sunTimeMoment.format('HH:mm');
                                }
                            }

                            return time;
                        }

                        return _.map(presets, function (preset) {
                            preset.graph = _.map(preset.graph, function (point) {
                                point.time = parseSunEvent(point.time);
                                return point;
                            });

                            return preset;
                        });
                    }

                    function flattenDimLevel(graphData) {
                        //
                        //
                        // Set dimLevel to 100 for visuals - save without this
                        //
                        //

                        return _.map(graphData, function (point) {
                            return {
                                time: point.time,
                                dimLevel: 100,
                                cct: point.cct
                            };
                        });
                    }

                    function checkCustom(presets) {
                        return _.findIndex(presets, { name: 'Custom' });
                    }

                    function mapGraphPoint(graphData) {
                        return _.map(graphData, function (point) {
                            return {
                                time: moment(point.x).hour(),
                                dimLevel: point.y,
                                cct: point.cct
                            };
                        });
                    }

                    function setPresetCustom(presets, graphData) {
                        var custom = {
                            name: 'Custom',
                            graph: mapGraphPoint(graphData)
                        };

                        if (checkCustom(presets) > -1) {
                            presets[checkCustom(presets)] = custom;
                        } else {
                            presets.push(custom);
                        }

                        sSB.selectedPreset = custom;

                        $timeout(function () {
                            $scope.$apply();
                        });
                    }
                }
            };

            _export('default', smartShiftBodyComponent);
        }
    };
});

$__System.register('89', ['1d'], function (_export) {
    'use strict';

    var d3, smartShiftChartComponent;
    return {
        setters: [function (_d) {
            d3 = _d['default'];
        }],
        execute: function () {
            smartShiftChartComponent = {
                bindings: {
                    cctOnlyMode: '<',
                    dimOnlyMode: '<',
                    maxGraphPoints: '<',
                    smartScheduleGraphData: '<',
                    sunPositions: '<',
                    //
                    // Out
                    //
                    onPopMenu: '&',
                    onUpdate: '&'
                },
                controllerAs: 'sSC',
                controller: function controller($element, $attrs, $window, $compile, $scope, $q, moment, SmartShiftSchedules, smartShiftChartSvg, _) {
                    var sSC = this;

                    //
                    // Use defer/resole as a crutch for d3/svg/angular wiring - refactor possibly
                    //
                    var openPopupPromise = $q.defer();

                    sSC.$onInit = function () {
                        //
                        sSC.windowWatcher = d3.select($window).on('resize.' + $attrs.id, debounceResize);
                    };

                    sSC.$onChanges = function (changes) {
                        console.log(changes);
                        if (changes.smartScheduleGraphData && changes.smartScheduleGraphData.currentValue && changes.smartScheduleGraphData.currentValue.length) {
                            closePopups();

                            smartShiftChartSvg($element, changes.smartScheduleGraphData.currentValue, sSC.maxGraphPoints, sSC.sunPositions, sSC.cctOnlyMode, SmartShiftSchedules.nearestCCTShade, popMenu, sSC.onUpdate);
                        }
                    };

                    sSC.$onDestroy = function () {
                        //console.log('destroy in ssCC');
                        removeWatch();
                    };

                    sSC.done = function (optionalUpdateData) {
                        closePopups(optionalUpdateData);
                        sSC.onUpdate(optionalUpdateData);
                    };

                    sSC.remove = function (index) {
                        console.log('Remove', index);
                        openPopupPromise.resolve();
                        closePopups();
                    };

                    function closePopups(optionalUpdateData) {
                        angular.element($element).children('.pop-menu').remove();
                        sSC.pop = null;
                        openPopupPromise.reject();
                        openPopupPromise = $q.defer();

                        if (optionalUpdateData) {
                            updateGraphData(optionalUpdateData);
                        }
                    };

                    function updateGraphData(optionalUpdateData) {
                        // Can't bind d3 datapoints to angular explicitly, scope kills perf
                        // Work out a cleaner way to do this?
                        optionalUpdateData.graphData[optionalUpdateData.index].y = optionalUpdateData.y;
                        optionalUpdateData.graphData[optionalUpdateData.index].cct = optionalUpdateData.cct;

                        // Call update func scoped to drawGraph
                        optionalUpdateData.updateFunc();
                    }

                    var popMenu = function popMenu(dataPoint, position, index, graphData, updateFunc) {
                        closePopups();

                        sSC.pop = {
                            cct: dataPoint.cct,
                            y: dataPoint.y,
                            x: moment(dataPoint.x).format('hh:mm a'),
                            index: index,
                            graphData: graphData,
                            updateFunc: updateFunc
                        };

                        var template = '\n                <div class="pop-menu" style="left: ' + position.x + 'px; top: ' + position.y + 'px;">\n                    <div class="row" ng-if="!sSC.dimOnlyMode">\n                        <input type="number" class="pop-input" ng-model="sSC.pop.cct"  name="cct" placeholder="CCT" min="2700" ng-min="2700" max="6500" ng-max="6500" />\n                        <span>K</span>\n                    </div>\n\n                    <div class="row" ng-if="!sSC.cctOnlyMode">\n                        <input type="number" class="pop-input" ng-model="sSC.pop.y" name="dimLevel" placeholder="Dim" min="0" ng-min="0" max="100" ng-max="100" />\n                        <span>%</span>\n                    </div>\n\n                    <div class="row">\n                        <input type="text" class="pop-input" ng-model="sSC.pop.x" name="time" placeholder="HH:MM" disabled="disabled" ng-disabled="true" />\n                    </div>\n\n                    <button class="pop-close" ng-click="sSC.done(sSC.pop)">Done</button>\n                    ' + (graphData.length > 2 ? '<button class="pop-remove" ng-click="sSC.remove(' + index + ')">Remove</button>' : '') + ' \n                </div>\n            ';

                        $element.prepend($compile(template)($scope));

                        // angular.element($element).children('.pop-menu').on('click', function(e){
                        //    
                        //     Remove / close on click away?
                        //   
                        //     console.log('angular', e);
                        // });

                        return openPopupPromise.promise;
                    };

                    var debounceResize = _.debounce(resize, 200);

                    function resize() {
                        smartShiftChartSvg($element, sSC.smartScheduleGraphData, sSC.maxGraphPoints, sSC.sunPositions, sSC.cctOnlyMode, SmartShiftSchedules.nearestCCTShade, popMenu, sSC.onUpdate);
                    }

                    function removeWatch() {
                        d3.select($window).on('resize.' + $attrs.id, null);
                    }
                }
            };

            _export('default', smartShiftChartComponent);
        }
    };
});

$__System.register('8a', [], function (_export) {
    'use strict';

    var smartShiftPresets;
    return {
        setters: [],
        execute: function () {
            smartShiftPresets = [{
                name: 'Well - Default using equator sunrise sunset and average levels',
                graph: [{
                    time: '00:00',
                    dimLevel: 25,
                    cct: 2700
                }, {
                    time: '05:00',
                    dimLevel: 100,
                    cct: 6000
                }, {
                    time: '12:00',
                    dimLevel: 85,
                    cct: 5700
                }, {
                    time: '15:00',
                    dimLevel: 85,
                    cct: 5000
                }, {
                    time: '18:00',
                    dimLevel: 35,
                    cct: 3000
                }, {
                    time: '21:00',
                    dimLevel: 25,
                    cct: 2700
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Nature - Uses local sunrise sunset instead of time',
                graph: [{
                    time: '00:00',
                    dimLevel: 30,
                    cct: 2700
                }, {
                    time: 'sunrise',
                    dimLevel: 100,
                    cct: 6000
                }, {
                    time: '12:00',
                    dimLevel: 85,
                    cct: 5000
                }, {
                    time: '14:00',
                    dimLevel: 85,
                    cct: 4000
                }, {
                    time: 'sunset-1',
                    dimLevel: 50,
                    cct: 3000
                }, {
                    time: 'sunset',
                    dimLevel: 30,
                    cct: 2700
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Work - Increased levels throughout day; non-sleep inducing',
                graph: [{
                    time: '00:00',
                    dimLevel: 40,
                    cct: 4000
                }, {
                    time: '05:00',
                    dimLevel: 100,
                    cct: 6000
                }, {
                    time: '12:00',
                    dimLevel: 100,
                    cct: 5700
                }, {
                    time: '15:00',
                    dimLevel: 80,
                    cct: 4500
                }, {
                    time: '18:00',
                    dimLevel: 40,
                    cct: 2700
                }, {
                    time: '21:00',
                    dimLevel: 40,
                    cct: 4000
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Learn - Slightly lower levels targeted at education',
                graph: [{
                    time: '00:00',
                    dimLevel: 40,
                    cct: 4000
                }, {
                    time: '07:00',
                    dimLevel: 100,
                    cct: 6000
                }, {
                    time: '12:00',
                    dimLevel: 80,
                    cct: 5700
                }, {
                    time: '15:00',
                    dimLevel: 60,
                    cct: 4500
                }, {
                    time: '18:00',
                    dimLevel: 40,
                    cct: 2700
                }, {
                    time: '21:00',
                    dimLevel: 40,
                    cct: 4000
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Calm - Decreased levels throughout the day',
                graph: [{
                    time: '00:00',
                    dimLevel: 25,
                    cct: 2700
                }, {
                    time: '07:00',
                    dimLevel: 100,
                    cct: 4500
                }, {
                    time: '11:00',
                    dimLevel: 50,
                    cct: 3500
                }, {
                    time: '15:00',
                    dimLevel: 25,
                    cct: 2700
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Cool - Maintain cooler temperatures throughout the day',
                graph: [{
                    time: '00:00',
                    dimLevel: 40,
                    cct: 4000
                }, {
                    time: '05:00',
                    dimLevel: 100,
                    cct: 5700
                }, {
                    time: '15:00',
                    dimLevel: 60,
                    cct: 5000
                }, {
                    time: '21:00',
                    dimLevel: 40,
                    cct: 4000
                }],
                cctOnly: false,
                dimOnly: false
            }, {
                name: 'Warm - Maintain warmer temperatures throughout the day',
                graph: [{
                    time: '00:00',
                    dimLevel: 30,
                    cct: 2700
                }, {
                    time: '07:00',
                    dimLevel: 100,
                    cct: 3000
                }, {
                    time: '12:00',
                    dimLevel: 85,
                    cct: 3000
                }, {
                    time: '15:00',
                    dimLevel: 65,
                    cct: 2700
                }, {
                    time: '18:00',
                    dimLevel: 30,
                    cct: 2700
                }],
                cctOnly: false,
                dimOnly: false
            }];

            _export('default', smartShiftPresets);
        }
    };
});

(function() {
var define = $__System.amdDefine;
"format amd";
;
(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define("8b", [], factory) : global.moment = factory();
}(this, function() {
  'use strict';
  var hookCallback;
  function utils_hooks__hooks() {
    return hookCallback.apply(null, arguments);
  }
  function setHookCallback(callback) {
    hookCallback = callback;
  }
  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }
  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }
  function map(arr, fn) {
    var res = [],
        i;
    for (i = 0; i < arr.length; ++i) {
      res.push(fn(arr[i], i));
    }
    return res;
  }
  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }
  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }
    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }
    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }
    return a;
  }
  function create_utc__createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }
  function defaultParsingFlags() {
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      meridiem: null
    };
  }
  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }
    return m._pf;
  }
  var some;
  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function(fun) {
      var t = Object(this);
      var len = t.length >>> 0;
      for (var i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }
      return false;
    };
  }
  function valid__isValid(m) {
    if (m._isValid == null) {
      var flags = getParsingFlags(m);
      var parsedParts = some.call(flags.parsedDateParts, function(i) {
        return i != null;
      });
      m._isValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || (flags.meridiem && parsedParts));
      if (m._strict) {
        m._isValid = m._isValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }
    }
    return m._isValid;
  }
  function valid__createInvalid(flags) {
    var m = create_utc__createUTC(NaN);
    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }
    return m;
  }
  function isUndefined(input) {
    return input === void 0;
  }
  var momentProperties = utils_hooks__hooks.momentProperties = [];
  function copyConfig(to, from) {
    var i,
        prop,
        val;
    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
      to._i = from._i;
    }
    if (!isUndefined(from._f)) {
      to._f = from._f;
    }
    if (!isUndefined(from._l)) {
      to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }
    if (momentProperties.length > 0) {
      for (i in momentProperties) {
        prop = momentProperties[i];
        val = from[prop];
        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }
    return to;
  }
  var updateInProgress = false;
  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (updateInProgress === false) {
      updateInProgress = true;
      utils_hooks__hooks.updateOffset(this);
      updateInProgress = false;
    }
  }
  function isMoment(obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
  }
  function absFloor(number) {
    if (number < 0) {
      return Math.ceil(number);
    } else {
      return Math.floor(number);
    }
  }
  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }
    return value;
  }
  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
      if ((dontConvert && array1[i] !== array2[i]) || (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
        diffs++;
      }
    }
    return diffs + lengthDiff;
  }
  function warn(msg) {
    if (utils_hooks__hooks.suppressDeprecationWarnings === false && (typeof console !== 'undefined') && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }
  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function() {
      if (utils_hooks__hooks.deprecationHandler != null) {
        utils_hooks__hooks.deprecationHandler(null, msg);
      }
      if (firstTime) {
        warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
        firstTime = false;
      }
      return fn.apply(this, arguments);
    }, fn);
  }
  var deprecations = {};
  function deprecateSimple(name, msg) {
    if (utils_hooks__hooks.deprecationHandler != null) {
      utils_hooks__hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }
  utils_hooks__hooks.suppressDeprecationWarnings = false;
  utils_hooks__hooks.deprecationHandler = null;
  function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }
  function isObject(input) {
    return Object.prototype.toString.call(input) === '[object Object]';
  }
  function locale_set__set(config) {
    var prop,
        i;
    for (i in config) {
      prop = config[i];
      if (isFunction(prop)) {
        this[i] = prop;
      } else {
        this['_' + i] = prop;
      }
    }
    this._config = config;
    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
  }
  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;
    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }
    return res;
  }
  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }
  var keys;
  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function(obj) {
      var i,
          res = [];
      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }
      return res;
    };
  }
  var locales = {};
  var globalLocale;
  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  }
  function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;
    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;
      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));
        if (locale) {
          return locale;
        }
        if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
          break;
        }
        j--;
      }
      i++;
    }
    return null;
  }
  function loadLocale(name) {
    var oldLocale = null;
    if (!locales[name] && (typeof module !== 'undefined') && module && module.exports) {
      try {
        oldLocale = globalLocale._abbr;
        require('./locale/' + name);
        locale_locales__getSetGlobalLocale(oldLocale);
      } catch (e) {}
    }
    return locales[name];
  }
  function locale_locales__getSetGlobalLocale(key, values) {
    var data;
    if (key) {
      if (isUndefined(values)) {
        data = locale_locales__getLocale(key);
      } else {
        data = defineLocale(key, values);
      }
      if (data) {
        globalLocale = data;
      }
    }
    return globalLocale._abbr;
  }
  function defineLocale(name, config) {
    if (config !== null) {
      config.abbr = name;
      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale');
        config = mergeConfigs(locales[name]._config, config);
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          config = mergeConfigs(locales[config.parentLocale]._config, config);
        } else {
          deprecateSimple('parentLocaleUndefined', 'specified parentLocale is not defined yet');
        }
      }
      locales[name] = new Locale(config);
      locale_locales__getSetGlobalLocale(name);
      return locales[name];
    } else {
      delete locales[name];
      return null;
    }
  }
  function updateLocale(name, config) {
    if (config != null) {
      var locale;
      if (locales[name] != null) {
        config = mergeConfigs(locales[name]._config, config);
      }
      locale = new Locale(config);
      locale.parentLocale = locales[name];
      locales[name] = locale;
      locale_locales__getSetGlobalLocale(name);
    } else {
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }
    return locales[name];
  }
  function locale_locales__getLocale(key) {
    var locale;
    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }
    if (!key) {
      return globalLocale;
    }
    if (!isArray(key)) {
      locale = loadLocale(key);
      if (locale) {
        return locale;
      }
      key = [key];
    }
    return chooseLocale(key);
  }
  function locale_locales__listLocales() {
    return keys(locales);
  }
  var aliases = {};
  function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
  }
  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }
  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;
    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }
    return normalizedInput;
  }
  function makeGetSet(unit, keepTime) {
    return function(value) {
      if (value != null) {
        get_set__set(this, unit, value);
        utils_hooks__hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get_set__get(this, unit);
      }
    };
  }
  function get_set__get(mom, unit) {
    return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
  }
  function get_set__set(mom, unit, value) {
    if (mom.isValid()) {
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
  }
  function getSet(units, value) {
    var unit;
    if (typeof units === 'object') {
      for (unit in units) {
        this.set(unit, units[unit]);
      }
    } else {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units](value);
      }
    }
    return this;
  }
  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }
  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
  var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
  var formatFunctions = {};
  var formatTokenFunctions = {};
  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
      func = function() {
        return this[callback]();
      };
    }
    if (token) {
      formatTokenFunctions[token] = func;
    }
    if (padded) {
      formatTokenFunctions[padded[0]] = function() {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }
    if (ordinal) {
      formatTokenFunctions[ordinal] = function() {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }
  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
  }
  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;
    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }
    return function(mom) {
      var output = '',
          i;
      for (i = 0; i < length; i++) {
        output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
      }
      return output;
    };
  }
  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }
    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
  }
  function expandFormat(format, locale) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }
    return format;
  }
  var match1 = /\d/;
  var match2 = /\d\d/;
  var match3 = /\d{3}/;
  var match4 = /\d{4}/;
  var match6 = /[+-]?\d{6}/;
  var match1to2 = /\d\d?/;
  var match3to4 = /\d\d\d\d?/;
  var match5to6 = /\d\d\d\d\d\d?/;
  var match1to3 = /\d{1,3}/;
  var match1to4 = /\d{1,4}/;
  var match1to6 = /[+-]?\d{1,6}/;
  var matchUnsigned = /\d+/;
  var matchSigned = /[+-]?\d+/;
  var matchOffset = /Z|[+-]\d\d:?\d\d/gi;
  var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi;
  var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/;
  var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
  var regexes = {};
  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
      return (isStrict && strictRegex) ? strictRegex : regex;
    };
  }
  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }
    return regexes[token](config._strict, config._locale);
  }
  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }
  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
  var tokens = {};
  function addParseToken(token, callback) {
    var i,
        func = callback;
    if (typeof token === 'string') {
      token = [token];
    }
    if (typeof callback === 'number') {
      func = function(input, array) {
        array[callback] = toInt(input);
      };
    }
    for (i = 0; i < token.length; i++) {
      tokens[token[i]] = func;
    }
  }
  function addWeekParseToken(token, callback) {
    addParseToken(token, function(input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }
  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }
  var YEAR = 0;
  var MONTH = 1;
  var DATE = 2;
  var HOUR = 3;
  var MINUTE = 4;
  var SECOND = 5;
  var MILLISECOND = 6;
  var WEEK = 7;
  var WEEKDAY = 8;
  var indexOf;
  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function(o) {
      var i;
      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }
      return -1;
    };
  }
  function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  }
  addFormatToken('M', ['MM', 2], 'Mo', function() {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function(format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function(format) {
    return this.localeData().months(this, format);
  });
  addUnitAlias('month', 'M');
  addRegexToken('M', match1to2);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function(isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function(isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function(input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function(input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  });
  var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
  function localeMonths(m, format) {
    return isArray(this._months) ? this._months[m.month()] : this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }
  var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
  function localeMonthsShort(m, format) {
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }
  function units_month__handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
      for (i = 0; i < 12; ++i) {
        mom = create_utc__createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeMonthsParse(monthName, format, strict) {
    var i,
        mom,
        regex;
    if (this._monthsParseExact) {
      return units_month__handleStrictParse.call(this, monthName, format, strict);
    }
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    }
    for (i = 0; i < 12; i++) {
      mom = create_utc__createUTC([2000, i]);
      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }
      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  }
  function setMonth(mom, value) {
    var dayOfMonth;
    if (!mom.isValid()) {
      return mom;
    }
    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value);
        if (typeof value !== 'number') {
          return mom;
        }
      }
    }
    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
  }
  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      utils_hooks__hooks.updateOffset(this, true);
      return this;
    } else {
      return get_set__get(this, 'Month');
    }
  }
  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }
  var defaultMonthsShortRegex = matchWord;
  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }
  var defaultMonthsRegex = matchWord;
  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }
  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
    for (i = 0; i < 12; i++) {
      mom = create_utc__createUTC([2000, i]);
      shortPieces.push(this.monthsShort(mom, ''));
      longPieces.push(this.months(mom, ''));
      mixedPieces.push(this.months(mom, ''));
      mixedPieces.push(this.monthsShort(mom, ''));
    }
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }
    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  }
  function checkOverflow(m) {
    var overflow;
    var a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }
      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }
      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }
      getParsingFlags(m).overflow = overflow;
    }
    return m;
  }
  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
  var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
  var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
  var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];
  var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
  var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
  function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;
    if (match) {
      getParsingFlags(config).iso = true;
      for (i = 0, l = isoDates.length; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }
      if (dateFormat == null) {
        config._isValid = false;
        return;
      }
      if (match[3]) {
        for (i = 0, l = isoTimes.length; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }
        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }
      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }
      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }
      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }
  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }
    configFromISO(config);
    if (config._isValid === false) {
      delete config._isValid;
      utils_hooks__hooks.createFromInputFallback(config);
    }
  }
  utils_hooks__hooks.createFromInputFallback = deprecate('moment construction falls back to js Date. This is ' + 'discouraged and will be removed in upcoming major ' + 'release. Please refer to ' + 'https://github.com/moment/moment/issues/1407 for more info.', function(config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  });
  function createDate(y, m, d, h, M, s, ms) {
    var date = new Date(y, m, d, h, M, s, ms);
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
    return date;
  }
  function createUTCDate(y) {
    var date = new Date(Date.UTC.apply(null, arguments));
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
    return date;
  }
  addFormatToken('Y', 0, 0, function() {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function() {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
  addUnitAlias('year', 'y');
  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function(input, array) {
    array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function(input, array) {
    array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function(input, array) {
    array[YEAR] = parseInt(input, 10);
  });
  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }
  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }
  utils_hooks__hooks.parseTwoDigitYear = function(input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  };
  var getSetYear = makeGetSet('FullYear', true);
  function getIsLeapYear() {
    return isLeapYear(this.year());
  }
  function firstWeekOffset(year, dow, doy) {
    var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  }
  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }
    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }
  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }
    return {
      week: resWeek,
      year: resYear
    };
  }
  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  }
  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }
    if (b != null) {
      return b;
    }
    return c;
  }
  function currentDateArray(config) {
    var nowValue = new Date(utils_hooks__hooks.now());
    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  }
  function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        yearToUse;
    if (config._d) {
      return;
    }
    currentDate = currentDateArray(config);
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    }
    if (config._dayOfYear) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
      if (config._dayOfYear > daysInYear(yearToUse)) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }
      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    }
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    }
    for (; i < 7; i++) {
      config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }
    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }
    if (config._nextDay) {
      config._a[HOUR] = 24;
    }
  }
  function dayOfYearFromWeekInfo(config) {
    var w,
        weekYear,
        week,
        weekday,
        dow,
        doy,
        temp,
        weekdayOverflow;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4;
      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);
      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
      week = defaults(w.w, 1);
      if (w.d != null) {
        weekday = w.d;
        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        weekday = w.e + dow;
        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        weekday = dow;
      }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  }
  utils_hooks__hooks.ISO_8601 = function() {};
  function configFromStringAndFormat(config) {
    if (config._f === utils_hooks__hooks.ISO_8601) {
      configFromISO(config);
      return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;
    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));
        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }
        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      }
      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }
        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    }
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    }
    if (getParsingFlags(config).bigHour === true && config._a[HOUR] <= 12 && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
    configFromArray(config);
    checkOverflow(config);
  }
  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;
    if (meridiem == null) {
      return hour;
    }
    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      isPm = locale.isPM(meridiem);
      if (isPm && hour < 12) {
        hour += 12;
      }
      if (!isPm && hour === 12) {
        hour = 0;
      }
      return hour;
    } else {
      return hour;
    }
  }
  function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore;
    if (config._f.length === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }
    for (i = 0; i < config._f.length; i++) {
      currentScore = 0;
      tempConfig = copyConfig({}, config);
      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }
      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);
      if (!valid__isValid(tempConfig)) {
        continue;
      }
      currentScore += getParsingFlags(tempConfig).charsLeftOver;
      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;
      if (scoreToBeat == null || currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
    extend(config, bestMoment || tempConfig);
  }
  function configFromObject(config) {
    if (config._d) {
      return;
    }
    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function(obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }
  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
      res.add(1, 'd');
      res._nextDay = undefined;
    }
    return res;
  }
  function prepareConfig(config) {
    var input = config._i,
        format = config._f;
    config._locale = config._locale || locale_locales__getLocale(config._l);
    if (input === null || (format === undefined && input === '')) {
      return valid__createInvalid({nullInput: true});
    }
    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }
    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else if (isDate(input)) {
      config._d = input;
    } else {
      configFromInput(config);
    }
    if (!valid__isValid(config)) {
      config._d = null;
    }
    return config;
  }
  function configFromInput(config) {
    var input = config._i;
    if (input === undefined) {
      config._d = new Date(utils_hooks__hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function(obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (typeof(input) === 'object') {
      configFromObject(config);
    } else if (typeof(input) === 'number') {
      config._d = new Date(input);
    } else {
      utils_hooks__hooks.createFromInputFallback(config);
    }
  }
  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};
    if (typeof(locale) === 'boolean') {
      strict = locale;
      locale = undefined;
    }
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }
  function local__createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }
  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548', function() {
    var other = local__createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return valid__createInvalid();
    }
  });
  var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548', function() {
    var other = local__createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return valid__createInvalid();
    }
  });
  function pickBy(fn, moments) {
    var res,
        i;
    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }
    if (!moments.length) {
      return local__createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }
    return res;
  }
  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }
  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }
  var now = function() {
    return Date.now ? Date.now() : +(new Date());
  };
  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
    this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
    this._days = +days + weeks * 7;
    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = locale_locales__getLocale();
    this._bubble();
  }
  function isDuration(obj) {
    return obj instanceof Duration;
  }
  function offset(token, separator) {
    addFormatToken(token, 0, 0, function() {
      var offset = this.utcOffset();
      var sign = '+';
      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }
      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
  }
  offset('Z', ':');
  offset('ZZ', '');
  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function(input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  });
  var chunkOffset = /([\+\-]|\d\d)/gi;
  function offsetFromString(matcher, string) {
    var matches = ((string || '').match(matcher) || []);
    var chunk = matches[matches.length - 1] || [];
    var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);
    return parts[0] === '+' ? minutes : -minutes;
  }
  function cloneWithOffset(input, model) {
    var res,
        diff;
    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
      res._d.setTime(res._d.valueOf() + diff);
      utils_hooks__hooks.updateOffset(res, false);
      return res;
    } else {
      return local__createLocal(input).local();
    }
  }
  function getDateOffset(m) {
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
  }
  utils_hooks__hooks.updateOffset = function() {};
  function getSetOffset(input, keepLocalTime) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);
      } else if (Math.abs(input) < 16) {
        input = input * 60;
      }
      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }
      this._offset = input;
      this._isUTC = true;
      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }
      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          utils_hooks__hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }
      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }
  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }
      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }
  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }
  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;
      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }
    return this;
  }
  function setOffsetToParsedOffset() {
    if (this._tzm) {
      this.utcOffset(this._tzm);
    } else if (typeof this._i === 'string') {
      this.utcOffset(offsetFromString(matchOffset, this._i));
    }
    return this;
  }
  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }
    input = input ? local__createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }
  function isDaylightSavingTime() {
    return (this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset());
  }
  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }
    var c = {};
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
      var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }
    return this._isDSTShifted;
  }
  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }
  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }
  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  }
  var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
  var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
  function create__createDuration(input, key) {
    var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (typeof input === 'number') {
      duration = {};
      if (key) {
        duration[key] = input;
      } else {
        duration.milliseconds = input;
      }
    } else if (!!(match = aspNetRegex.exec(input))) {
      sign = (match[1] === '-') ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(match[MILLISECOND]) * sign
      };
    } else if (!!(match = isoRegex.exec(input))) {
      sign = (match[1] === '-') ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }
    return ret;
  }
  create__createDuration.fn = Duration.prototype;
  function parseIso(inp, sign) {
    var res = inp && parseFloat(inp.replace(',', '.'));
    return (isNaN(res) ? 0 : res) * sign;
  }
  function positiveMomentsDifference(base, other) {
    var res = {
      milliseconds: 0,
      months: 0
    };
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }
    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
    return res;
  }
  function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }
    return res;
  }
  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  }
  function createAdder(direction, name) {
    return function(val, period) {
      var dur,
          tmp;
      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
        tmp = val;
        val = period;
        period = tmp;
      }
      val = typeof val === 'string' ? +val : val;
      dur = create__createDuration(val, period);
      add_subtract__addSubtract(this, dur, direction);
      return this;
    };
  }
  function add_subtract__addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
    if (!mom.isValid()) {
      return;
    }
    updateOffset = updateOffset == null ? true : updateOffset;
    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
      get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
    }
    if (months) {
      setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
      utils_hooks__hooks.updateOffset(mom, days || months);
    }
  }
  var add_subtract__add = createAdder(1, 'add');
  var add_subtract__subtract = createAdder(-1, 'subtract');
  function moment_calendar__calendar(time, formats) {
    var now = time || local__createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        diff = this.diff(sod, 'days', true),
        format = diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
  }
  function clone() {
    return new Moment(this);
  }
  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }
  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }
  function isBetween(from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) && (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
  }
  function isSame(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }
  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }
  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }
  function diff(input, units, asFloat) {
    var that,
        zoneDelta,
        delta,
        output;
    if (!this.isValid()) {
      return NaN;
    }
    that = cloneWithOffset(input, this);
    if (!that.isValid()) {
      return NaN;
    }
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    if (units === 'year' || units === 'month' || units === 'quarter') {
      output = monthDiff(this, that);
      if (units === 'quarter') {
        output = output / 3;
      } else if (units === 'year') {
        output = output / 12;
      }
    } else {
      delta = this - that;
      output = units === 'second' ? delta / 1e3 : units === 'minute' ? delta / 6e4 : units === 'hour' ? delta / 36e5 : units === 'day' ? (delta - zoneDelta) / 864e5 : units === 'week' ? (delta - zoneDelta) / 6048e5 : delta;
    }
    return asFloat ? output : absFloor(output);
  }
  function monthDiff(a, b) {
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
      adjust = (b - anchor) / (anchor2 - anchor);
    }
    return -(wholeMonthDiff + adjust) || 0;
  }
  utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }
  function moment_format__toISOString() {
    var m = this.clone().utc();
    if (0 < m.year() && m.year() <= 9999) {
      if (isFunction(Date.prototype.toISOString)) {
        return this.toDate().toISOString();
      } else {
        return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
      }
    } else {
      return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
  }
  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }
  function from(time, withoutSuffix) {
    if (this.isValid() && ((isMoment(time) && time.isValid()) || local__createLocal(time).isValid())) {
      return create__createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function fromNow(withoutSuffix) {
    return this.from(local__createLocal(), withoutSuffix);
  }
  function to(time, withoutSuffix) {
    if (this.isValid() && ((isMoment(time) && time.isValid()) || local__createLocal(time).isValid())) {
      return create__createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function toNow(withoutSuffix) {
    return this.to(local__createLocal(), withoutSuffix);
  }
  function locale(key) {
    var newLocaleData;
    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = locale_locales__getLocale(key);
      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }
      return this;
    }
  }
  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });
  function localeData() {
    return this._locale;
  }
  function startOf(units) {
    units = normalizeUnits(units);
    switch (units) {
      case 'year':
        this.month(0);
      case 'quarter':
      case 'month':
        this.date(1);
      case 'week':
      case 'isoWeek':
      case 'day':
      case 'date':
        this.hours(0);
      case 'hour':
        this.minutes(0);
      case 'minute':
        this.seconds(0);
      case 'second':
        this.milliseconds(0);
    }
    if (units === 'week') {
      this.weekday(0);
    }
    if (units === 'isoWeek') {
      this.isoWeekday(1);
    }
    if (units === 'quarter') {
      this.month(Math.floor(this.month() / 3) * 3);
    }
    return this;
  }
  function endOf(units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
      return this;
    }
    if (units === 'date') {
      units = 'day';
    }
    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
  }
  function to_type__valueOf() {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
  }
  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }
  function toDate() {
    return this._offset ? new Date(this.valueOf()) : this._d;
  }
  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }
  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }
  function toJSON() {
    return this.isValid() ? this.toISOString() : null;
  }
  function moment_valid__isValid() {
    return valid__isValid(this);
  }
  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }
  function invalidAt() {
    return getParsingFlags(this).overflow;
  }
  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }
  addFormatToken(0, ['gg', 2], 0, function() {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function() {
    return this.isoWeekYear() % 100;
  });
  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }
  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear');
  addUnitAlias('weekYear', 'gg');
  addUnitAlias('isoWeekYear', 'GG');
  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function(input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function(input, week, config, token) {
    week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
  });
  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }
  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }
  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }
  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);
      if (week > weeksTarget) {
        week = weeksTarget;
      }
      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }
  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  }
  addFormatToken('Q', 0, 'Qo', 'quarter');
  addUnitAlias('quarter', 'Q');
  addRegexToken('Q', match1);
  addParseToken('Q', function(input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  });
  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  }
  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
  addUnitAlias('week', 'w');
  addUnitAlias('isoWeek', 'W');
  addRegexToken('w', match1to2);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function(input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  });
  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }
  var defaultLocaleWeek = {
    dow: 0,
    doy: 6
  };
  function localeFirstDayOfWeek() {
    return this._week.dow;
  }
  function localeFirstDayOfYear() {
    return this._week.doy;
  }
  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }
  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  }
  addFormatToken('D', ['DD', 2], 'Do', 'date');
  addUnitAlias('date', 'D');
  addRegexToken('D', match1to2);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function(isStrict, locale) {
    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function(input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
  });
  var getSetDayOfMonth = makeGetSet('Date', true);
  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function(format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function(format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function(format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday');
  addUnitAlias('day', 'd');
  addUnitAlias('weekday', 'e');
  addUnitAlias('isoWeekday', 'E');
  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('dd', function(isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function(isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function(isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function(input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function(input, week, config, token) {
    week[token] = toInt(input);
  });
  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }
    if (!isNaN(input)) {
      return parseInt(input, 10);
    }
    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
      return input;
    }
    return null;
  }
  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
  function localeWeekdays(m, format) {
    return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
  }
  var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
  function localeWeekdaysShort(m) {
    return this._weekdaysShort[m.day()];
  }
  var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
  function localeWeekdaysMin(m) {
    return this._weekdaysMin[m.day()];
  }
  function day_of_week__handleStrictParse(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];
      for (i = 0; i < 7; ++i) {
        mom = create_utc__createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeWeekdaysParse(weekdayName, format, strict) {
    var i,
        mom,
        regex;
    if (this._weekdaysParseExact) {
      return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
    }
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }
    for (i = 0; i < 7; i++) {
      mom = create_utc__createUTC([2000, 1]).day(i);
      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
      }
      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  }
  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }
  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }
  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
  }
  var defaultWeekdaysRegex = matchWord;
  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }
  var defaultWeekdaysShortRegex = matchWord;
  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }
  var defaultWeekdaysMinRegex = matchWord;
  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }
  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
    for (i = 0; i < 7; i++) {
      mom = create_utc__createUTC([2000, 1]).day(i);
      minp = this.weekdaysMin(mom, '');
      shortp = this.weekdaysShort(mom, '');
      longp = this.weekdays(mom, '');
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    }
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  }
  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
  addUnitAlias('dayOfYear', 'DDD');
  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function(input, array, config) {
    config._dayOfYear = toInt(input);
  });
  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
  }
  function hFormat() {
    return this.hours() % 12 || 12;
  }
  function kFormat() {
    return this.hours() || 24;
  }
  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function() {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function() {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function() {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function() {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function() {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }
  meridiem('a', true);
  meridiem('A', false);
  addUnitAlias('hour', 'h');
  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }
  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2);
  addRegexToken('h', match1to2);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['a', 'A'], function(input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function(input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function(input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function(input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  });
  function localeIsPM(input) {
    return ((input + '').toLowerCase().charAt(0) === 'p');
  }
  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  }
  var getSetHour = makeGetSet('Hours', true);
  addFormatToken('m', ['mm', 2], 0, 'minute');
  addUnitAlias('minute', 'm');
  addRegexToken('m', match1to2);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE);
  var getSetMinute = makeGetSet('Minutes', false);
  addFormatToken('s', ['ss', 2], 0, 'second');
  addUnitAlias('second', 's');
  addRegexToken('s', match1to2);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND);
  var getSetSecond = makeGetSet('Seconds', false);
  addFormatToken('S', 0, 0, function() {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function() {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function() {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function() {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function() {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function() {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function() {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function() {
    return this.millisecond() * 1000000;
  });
  addUnitAlias('millisecond', 'ms');
  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token;
  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }
  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }
  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  }
  var getSetMillisecond = makeGetSet('Milliseconds', false);
  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName');
  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }
  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }
  var momentPrototype__proto = Moment.prototype;
  momentPrototype__proto.add = add_subtract__add;
  momentPrototype__proto.calendar = moment_calendar__calendar;
  momentPrototype__proto.clone = clone;
  momentPrototype__proto.diff = diff;
  momentPrototype__proto.endOf = endOf;
  momentPrototype__proto.format = format;
  momentPrototype__proto.from = from;
  momentPrototype__proto.fromNow = fromNow;
  momentPrototype__proto.to = to;
  momentPrototype__proto.toNow = toNow;
  momentPrototype__proto.get = getSet;
  momentPrototype__proto.invalidAt = invalidAt;
  momentPrototype__proto.isAfter = isAfter;
  momentPrototype__proto.isBefore = isBefore;
  momentPrototype__proto.isBetween = isBetween;
  momentPrototype__proto.isSame = isSame;
  momentPrototype__proto.isSameOrAfter = isSameOrAfter;
  momentPrototype__proto.isSameOrBefore = isSameOrBefore;
  momentPrototype__proto.isValid = moment_valid__isValid;
  momentPrototype__proto.lang = lang;
  momentPrototype__proto.locale = locale;
  momentPrototype__proto.localeData = localeData;
  momentPrototype__proto.max = prototypeMax;
  momentPrototype__proto.min = prototypeMin;
  momentPrototype__proto.parsingFlags = parsingFlags;
  momentPrototype__proto.set = getSet;
  momentPrototype__proto.startOf = startOf;
  momentPrototype__proto.subtract = add_subtract__subtract;
  momentPrototype__proto.toArray = toArray;
  momentPrototype__proto.toObject = toObject;
  momentPrototype__proto.toDate = toDate;
  momentPrototype__proto.toISOString = moment_format__toISOString;
  momentPrototype__proto.toJSON = toJSON;
  momentPrototype__proto.toString = toString;
  momentPrototype__proto.unix = unix;
  momentPrototype__proto.valueOf = to_type__valueOf;
  momentPrototype__proto.creationData = creationData;
  momentPrototype__proto.year = getSetYear;
  momentPrototype__proto.isLeapYear = getIsLeapYear;
  momentPrototype__proto.weekYear = getSetWeekYear;
  momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
  momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
  momentPrototype__proto.month = getSetMonth;
  momentPrototype__proto.daysInMonth = getDaysInMonth;
  momentPrototype__proto.week = momentPrototype__proto.weeks = getSetWeek;
  momentPrototype__proto.isoWeek = momentPrototype__proto.isoWeeks = getSetISOWeek;
  momentPrototype__proto.weeksInYear = getWeeksInYear;
  momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
  momentPrototype__proto.date = getSetDayOfMonth;
  momentPrototype__proto.day = momentPrototype__proto.days = getSetDayOfWeek;
  momentPrototype__proto.weekday = getSetLocaleDayOfWeek;
  momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
  momentPrototype__proto.dayOfYear = getSetDayOfYear;
  momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
  momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
  momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
  momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
  momentPrototype__proto.utcOffset = getSetOffset;
  momentPrototype__proto.utc = setOffsetToUTC;
  momentPrototype__proto.local = setOffsetToLocal;
  momentPrototype__proto.parseZone = setOffsetToParsedOffset;
  momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
  momentPrototype__proto.isDST = isDaylightSavingTime;
  momentPrototype__proto.isDSTShifted = isDaylightSavingTimeShifted;
  momentPrototype__proto.isLocal = isLocal;
  momentPrototype__proto.isUtcOffset = isUtcOffset;
  momentPrototype__proto.isUtc = isUtc;
  momentPrototype__proto.isUTC = isUtc;
  momentPrototype__proto.zoneAbbr = getZoneAbbr;
  momentPrototype__proto.zoneName = getZoneName;
  momentPrototype__proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  momentPrototype__proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  momentPrototype__proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
  var momentPrototype = momentPrototype__proto;
  function moment__createUnix(input) {
    return local__createLocal(input * 1000);
  }
  function moment__createInZone() {
    return local__createLocal.apply(null, arguments).parseZone();
  }
  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };
  function locale_calendar__calendar(key, mom, now) {
    var output = this._calendar[key];
    return isFunction(output) ? output.call(mom, now) : output;
  }
  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };
  function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
    if (format || !formatUpper) {
      return format;
    }
    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function(val) {
      return val.slice(1);
    });
    return this._longDateFormat[key];
  }
  var defaultInvalidDate = 'Invalid date';
  function invalidDate() {
    return this._invalidDate;
  }
  var defaultOrdinal = '%d';
  var defaultOrdinalParse = /\d{1,2}/;
  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }
  function preParsePostFormat(string) {
    return string;
  }
  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };
  function relative__relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }
  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }
  var prototype__proto = Locale.prototype;
  prototype__proto._calendar = defaultCalendar;
  prototype__proto.calendar = locale_calendar__calendar;
  prototype__proto._longDateFormat = defaultLongDateFormat;
  prototype__proto.longDateFormat = longDateFormat;
  prototype__proto._invalidDate = defaultInvalidDate;
  prototype__proto.invalidDate = invalidDate;
  prototype__proto._ordinal = defaultOrdinal;
  prototype__proto.ordinal = ordinal;
  prototype__proto._ordinalParse = defaultOrdinalParse;
  prototype__proto.preparse = preParsePostFormat;
  prototype__proto.postformat = preParsePostFormat;
  prototype__proto._relativeTime = defaultRelativeTime;
  prototype__proto.relativeTime = relative__relativeTime;
  prototype__proto.pastFuture = pastFuture;
  prototype__proto.set = locale_set__set;
  prototype__proto.months = localeMonths;
  prototype__proto._months = defaultLocaleMonths;
  prototype__proto.monthsShort = localeMonthsShort;
  prototype__proto._monthsShort = defaultLocaleMonthsShort;
  prototype__proto.monthsParse = localeMonthsParse;
  prototype__proto._monthsRegex = defaultMonthsRegex;
  prototype__proto.monthsRegex = monthsRegex;
  prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
  prototype__proto.monthsShortRegex = monthsShortRegex;
  prototype__proto.week = localeWeek;
  prototype__proto._week = defaultLocaleWeek;
  prototype__proto.firstDayOfYear = localeFirstDayOfYear;
  prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
  prototype__proto.weekdays = localeWeekdays;
  prototype__proto._weekdays = defaultLocaleWeekdays;
  prototype__proto.weekdaysMin = localeWeekdaysMin;
  prototype__proto._weekdaysMin = defaultLocaleWeekdaysMin;
  prototype__proto.weekdaysShort = localeWeekdaysShort;
  prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
  prototype__proto.weekdaysParse = localeWeekdaysParse;
  prototype__proto._weekdaysRegex = defaultWeekdaysRegex;
  prototype__proto.weekdaysRegex = weekdaysRegex;
  prototype__proto._weekdaysShortRegex = defaultWeekdaysShortRegex;
  prototype__proto.weekdaysShortRegex = weekdaysShortRegex;
  prototype__proto._weekdaysMinRegex = defaultWeekdaysMinRegex;
  prototype__proto.weekdaysMinRegex = weekdaysMinRegex;
  prototype__proto.isPM = localeIsPM;
  prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
  prototype__proto.meridiem = localeMeridiem;
  function lists__get(format, index, field, setter) {
    var locale = locale_locales__getLocale();
    var utc = create_utc__createUTC().set(setter, index);
    return locale[field](utc, format);
  }
  function listMonthsImpl(format, index, field) {
    if (typeof format === 'number') {
      index = format;
      format = undefined;
    }
    format = format || '';
    if (index != null) {
      return lists__get(format, index, field, 'month');
    }
    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
      out[i] = lists__get(format, i, field, 'month');
    }
    return out;
  }
  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (typeof format === 'number') {
        index = format;
        format = undefined;
      }
      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;
      if (typeof format === 'number') {
        index = format;
        format = undefined;
      }
      format = format || '';
    }
    var locale = locale_locales__getLocale(),
        shift = localeSorted ? locale._week.dow : 0;
    if (index != null) {
      return lists__get(format, (index + shift) % 7, field, 'day');
    }
    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
      out[i] = lists__get(format, (i + shift) % 7, field, 'day');
    }
    return out;
  }
  function lists__listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }
  function lists__listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }
  function lists__listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }
  function lists__listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }
  function lists__listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }
  locale_locales__getSetGlobalLocale('en', {
    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function(number) {
      var b = number % 10,
          output = (toInt(number % 100 / 10) === 1) ? 'th' : (b === 1) ? 'st' : (b === 2) ? 'nd' : (b === 3) ? 'rd' : 'th';
      return number + output;
    }
  });
  utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
  utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
  var mathAbs = Math.abs;
  function duration_abs__abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }
  function duration_add_subtract__addSubtract(duration, input, value, direction) {
    var other = create__createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  }
  function duration_add_subtract__add(input, value) {
    return duration_add_subtract__addSubtract(this, input, value, 1);
  }
  function duration_add_subtract__subtract(input, value) {
    return duration_add_subtract__addSubtract(this, input, value, -1);
  }
  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }
  function bubble() {
    var milliseconds = this._milliseconds;
    var days = this._days;
    var months = this._months;
    var data = this._data;
    var seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) || (milliseconds <= 0 && days <= 0 && months <= 0))) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    }
    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24);
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));
    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }
  function daysToMonths(days) {
    return days * 4800 / 146097;
  }
  function monthsToDays(months) {
    return months * 146097 / 4800;
  }
  function as(units) {
    var days;
    var months;
    var milliseconds = this._milliseconds;
    units = normalizeUnits(units);
    if (units === 'month' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);
      return units === 'month' ? months : months / 12;
    } else {
      days = this._days + Math.round(monthsToDays(this._months));
      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;
        case 'day':
          return days + milliseconds / 864e5;
        case 'hour':
          return days * 24 + milliseconds / 36e5;
        case 'minute':
          return days * 1440 + milliseconds / 6e4;
        case 'second':
          return days * 86400 + milliseconds / 1000;
        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;
        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  }
  function duration_as__valueOf() {
    return (this._milliseconds + this._days * 864e5 + (this._months % 12) * 2592e6 + toInt(this._months / 12) * 31536e6);
  }
  function makeAs(alias) {
    return function() {
      return this.as(alias);
    };
  }
  var asMilliseconds = makeAs('ms');
  var asSeconds = makeAs('s');
  var asMinutes = makeAs('m');
  var asHours = makeAs('h');
  var asDays = makeAs('d');
  var asWeeks = makeAs('w');
  var asMonths = makeAs('M');
  var asYears = makeAs('y');
  function duration_get__get(units) {
    units = normalizeUnits(units);
    return this[units + 's']();
  }
  function makeGetter(name) {
    return function() {
      return this._data[name];
    };
  }
  var milliseconds = makeGetter('milliseconds');
  var seconds = makeGetter('seconds');
  var minutes = makeGetter('minutes');
  var hours = makeGetter('hours');
  var days = makeGetter('days');
  var months = makeGetter('months');
  var years = makeGetter('years');
  function weeks() {
    return absFloor(this.days() / 7);
  }
  var round = Math.round;
  var thresholds = {
    s: 45,
    m: 45,
    h: 22,
    d: 26,
    M: 11
  };
  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }
  function duration_humanize__relativeTime(posNegDuration, withoutSuffix, locale) {
    var duration = create__createDuration(posNegDuration).abs();
    var seconds = round(duration.as('s'));
    var minutes = round(duration.as('m'));
    var hours = round(duration.as('h'));
    var days = round(duration.as('d'));
    var months = round(duration.as('M'));
    var years = round(duration.as('y'));
    var a = seconds < thresholds.s && ['s', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  }
  function duration_humanize__getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }
    if (limit === undefined) {
      return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    return true;
  }
  function humanize(withSuffix) {
    var locale = this.localeData();
    var output = duration_humanize__relativeTime(this, !withSuffix, locale);
    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }
    return locale.postformat(output);
  }
  var iso_string__abs = Math.abs;
  function iso_string__toISOString() {
    var seconds = iso_string__abs(this._milliseconds) / 1000;
    var days = iso_string__abs(this._days);
    var months = iso_string__abs(this._months);
    var minutes,
        hours,
        years;
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;
    years = absFloor(months / 12);
    months %= 12;
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();
    if (!total) {
      return 'P0D';
    }
    return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + ((h || m || s) ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
  }
  var duration_prototype__proto = Duration.prototype;
  duration_prototype__proto.abs = duration_abs__abs;
  duration_prototype__proto.add = duration_add_subtract__add;
  duration_prototype__proto.subtract = duration_add_subtract__subtract;
  duration_prototype__proto.as = as;
  duration_prototype__proto.asMilliseconds = asMilliseconds;
  duration_prototype__proto.asSeconds = asSeconds;
  duration_prototype__proto.asMinutes = asMinutes;
  duration_prototype__proto.asHours = asHours;
  duration_prototype__proto.asDays = asDays;
  duration_prototype__proto.asWeeks = asWeeks;
  duration_prototype__proto.asMonths = asMonths;
  duration_prototype__proto.asYears = asYears;
  duration_prototype__proto.valueOf = duration_as__valueOf;
  duration_prototype__proto._bubble = bubble;
  duration_prototype__proto.get = duration_get__get;
  duration_prototype__proto.milliseconds = milliseconds;
  duration_prototype__proto.seconds = seconds;
  duration_prototype__proto.minutes = minutes;
  duration_prototype__proto.hours = hours;
  duration_prototype__proto.days = days;
  duration_prototype__proto.weeks = weeks;
  duration_prototype__proto.months = months;
  duration_prototype__proto.years = years;
  duration_prototype__proto.humanize = humanize;
  duration_prototype__proto.toISOString = iso_string__toISOString;
  duration_prototype__proto.toString = iso_string__toISOString;
  duration_prototype__proto.toJSON = iso_string__toISOString;
  duration_prototype__proto.locale = locale;
  duration_prototype__proto.localeData = localeData;
  duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
  duration_prototype__proto.lang = lang;
  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf');
  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function(input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
  });
  addParseToken('x', function(input, array, config) {
    config._d = new Date(toInt(input));
  });
  utils_hooks__hooks.version = '2.13.0';
  setHookCallback(local__createLocal);
  utils_hooks__hooks.fn = momentPrototype;
  utils_hooks__hooks.min = min;
  utils_hooks__hooks.max = max;
  utils_hooks__hooks.now = now;
  utils_hooks__hooks.utc = create_utc__createUTC;
  utils_hooks__hooks.unix = moment__createUnix;
  utils_hooks__hooks.months = lists__listMonths;
  utils_hooks__hooks.isDate = isDate;
  utils_hooks__hooks.locale = locale_locales__getSetGlobalLocale;
  utils_hooks__hooks.invalid = valid__createInvalid;
  utils_hooks__hooks.duration = create__createDuration;
  utils_hooks__hooks.isMoment = isMoment;
  utils_hooks__hooks.weekdays = lists__listWeekdays;
  utils_hooks__hooks.parseZone = moment__createInZone;
  utils_hooks__hooks.localeData = locale_locales__getLocale;
  utils_hooks__hooks.isDuration = isDuration;
  utils_hooks__hooks.monthsShort = lists__listMonthsShort;
  utils_hooks__hooks.weekdaysMin = lists__listWeekdaysMin;
  utils_hooks__hooks.defineLocale = defineLocale;
  utils_hooks__hooks.updateLocale = updateLocale;
  utils_hooks__hooks.locales = locale_locales__listLocales;
  utils_hooks__hooks.weekdaysShort = lists__listWeekdaysShort;
  utils_hooks__hooks.normalizeUnits = normalizeUnits;
  utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
  utils_hooks__hooks.prototype = momentPrototype;
  var _moment = utils_hooks__hooks;
  return _moment;
}));

})();
(function() {
var define = $__System.amdDefine;
define("10", ["8b"], function(main) {
  return main;
});

})();
$__System.register('8c', ['10'], function (_export) {
  'use strict';

  var moment, smartShiftChartSvgValue;
  return {
    setters: [function (_2) {
      moment = _2['default'];
    }],
    execute: function () {
      smartShiftChartSvgValue = function smartShiftChartSvgValue($element, chartData, maxGraphPoints, sunPositions, cctOnlyMode, nearestCCTShadeFunc, popMenu, onUpdate) {

        function sortByTime(data) {
          function firstTime(a, b) {
            return moment(a.time, 'HH:mm').unix() - moment(b.time, 'HH:mm').unix();
          }

          return data.sort(firstTime);
        }

        function mapGradients(data) {
          return _.map(data, function (point) {
            return {
              offset: moment(point.x).hour() / 24 * 100 + '%', //@todo - Allow minutes
              // - Some points missing CCT?
              color: 'rgb(' + nearestCCTShadeFunc(point.cct || 2700).rgb + ')'
            };
          });
        }

        d3.selectAll('svg').remove();

        var data = _.map(sortByTime(chartData), function (point) {
          return {
            x: moment(point.time, 'HH:mm'),
            y: point.dimLevel,
            cct: point.cct
          };
        });

        //setting structure for D3 chart
        var width = $element[0].parentElement.clientWidth * 0.90,
            height = width * 0.475,
            margin = {
          top: 25,
          right: 25, //width * 0.025,
          bottom: 60,
          left: 60
        };

        var xScale = d3.time.scale().domain([moment().hour(0), moment().hour(23)]).range([0, width]).nice();

        var yScale = d3.scale.linear().range([height, 0]).domain([0, 100]).nice();

        var sunTicks = _.map(sunPositions, function (sun, k) {
          return {
            position: k === 0 ? 'Sunrise' : 'Sunset', //@todo translation
            time: moment(sun, 'HH:mm:ss').toDate()
          };
        });

        var xAxis = d3.svg.axis().scale(xScale).orient('bottom').tickFormat(d3.time.format('%I %p')),
            /*.ticks(12)*/
        xAxisSun = d3.svg.axis().scale(xScale).orient('bottom').tickFormat(function (d, i, v) {
          return sunTicks[i].position + ' ' + moment(sunTicks[i].time).format('h:mm a');
        }).tickValues(sunTicks.map(function (sunPos) {
          return sunPos.time;
        })).tickSize(-height, 0, 0),
            yAxis = d3.svg.axis().scale(yScale).orient('left').ticks(6).tickFormat(function (d) {
          return d + '%';
        });

        var area = d3.svg.area().interpolate('linear').x(function (d) {
          return xScale(d.x);
        }).y0(height).y1(function (d) {
          return yScale(d.y);
        });

        var plotLine = d3.svg.line().interpolate('linear').x(function (d) {
          return xScale(d.x);
        }).y(function (d) {
          return yScale(d.y);
        });

        var svg = d3.select($element[0]).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);

        svg.append('g').attr('class', 'x axis ').attr('id', 'axis--x').attr('transform', 'translate(' + margin.left + ',' + (height + margin.top) + ')').call(xAxis);

        svg.append('g').attr('class', 'x axis ').attr('id', 'axis--x-sun').attr('transform', 'translate(' + margin.left + ',' + (height + margin.top + 30) + ')').call(xAxisSun);

        svg.append('g').attr('class', 'y axis').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('id', 'axis--y').call(yAxis);

        //
        // Colors
        //
        svg.append('linearGradient').attr('id', 'cct-gradient').attr('gradientUnits', 'userSpaceOnUse').attr('y1', 0).attr('x1', xScale(moment().hour(0))).attr('y2', 0).attr('x2', xScale(moment().hour(23))).selectAll('stop').data(mapGradients(data)).enter().append('stop').attr('offset', function (d) {
          return d.offset;
        }).attr('stop-color', function (d) {
          return d.color;
        });

        svg.append('g').attr('id', 'shade-area').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').append('path').datum(data).attr('class', 'area').attr('d', area);

        var throttledAdd = _.throttle(addPoint, 1000, { leading: true });

        function clickedAdd(d, i) {
          if (d3.event.defaultPrevented) return; // dragged
          var clickArea = d3.select(this).node();
          //
          // Cover for double clicks, should probably stop items adding too close together too
          //
          throttledAdd(clickArea, cctOnlyMode);
        }

        //
        // d3 Bug with click firing 'drag' without movement
        //
        var realDragEvent = false;

        var drag = d3.behavior.drag()
        //.clickDistance(10)
        .on('dragstart', dragstarted).on('drag', dragged).on('dragend', dragended);

        function dragged(d, i) {
          realDragEvent = true;

          var yPos = validate(d3.event.y, 0, height); //  d3.event.x > 0 ? d3.event.x : 0;

          d.x = moment(xScale.invert(getValidXPos(d3.event.x, i))).seconds(0);
          d.y = Math.round(yScale.invert(yPos));

          d3.select(this).attr('cx', xScale(d.x)).attr('cy', yScale(d.y));
        }

        function dragstarted(d) {
          //console.log('drag start',d)
        }

        function dragended(d, i) {
          //
          // Only update after done?
          //
          var s = d3.select(this);

          var clickArea = d3.select('.click-zone').node();

          update();

          showMenu(s, d, clickArea, i, data);
        }

        function getValidXPos(eventX, i) {
          //
          //
          // Block movement under existing points here...
          //
          //
          var minPos = i === 0 ? 0 : xScale(data[i - 1].x);
          var maxPos = i === data.length - 1 ? width : xScale(data[i + 1].x);

          return validate(eventX, minPos, maxPos);
        }

        function validate(x, a, b) {
          if (x < a) x = a;
          if (x > b) x = b;
          return x;
        }

        var clickZone = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').append('g').append('rect').attr('class', 'click-zone').attr('width', width).attr('height', height).style('opacity', 0).on('click', clickedAdd);

        var line = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        var dot = svg.append('g').attr('id', 'scatter').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        // Add line plot
        line.append('g').attr('id', 'line-1').attr('clip-path', 'url(#clip)').append('path').data([data]).attr('class', 'pointlines').attr('d', plotLine).style('fill', 'none').style('stroke', 'lightgray');

        function clickedDot(dataPoint, i) {
          if (d3.event.defaultPrevented) return; // dragged

          var s = d3.select(this);

          var clickArea = d3.select('.click-zone').node();

          //removeGraphItem(s,i);
          showMenu(s, dataPoint, clickArea, i, data);
        }

        dot.append('g').attr('id', 'scatter-1').attr('clip-path', 'url(#clip)').selectAll('.dot').data(data).enter().append('circle').attr('class', 'dot').attr('r', 10).attr('cx', function (d) {
          return xScale(d.x);
        }).attr('cy', function (d) {
          return yScale(d.y);
        }).attr('stroke', 'white').attr('stroke-width', '2px').style('fill', function (d) {
          return 'rgba(255,232,2,' + d.y / 100 + ')';
        }).call(drag).on('click', clickedDot);

        function showMenu(s, dataPoint, clickArea, i, graphData) {
          var d3Pos = d3.mouse(clickArea);

          var position = {
            x: getValidXPos(d3Pos[0], i),
            y: validate(d3Pos[1], 0, height)
          };

          popMenu(dataPoint, position, i, graphData, update).then(function () {
            removeGraphItem(s, i);
          });
        }

        function addPoint(clickArea, cctOnlyMode) {
          if (data.length < maxGraphPoints) {
            var pos = d3.mouse(clickArea);
            var xPos = Math.round(xScale.invert(pos[0]));

            //
            // When in CCT only mode - dont add points mid graph
            //
            var yPos = Math.round(cctOnlyMode ? 100 : yScale.invert(pos[1]));

            data.push({ x: xPos, y: yPos, cct: null });
            data.sort(function (a, b) {
              return a.x - b.x;
            });
            onUpdate({ graphData: data });
            update();
          }
        }

        function removeGraphItem(sel, index) {
          data.splice(index, 1);
          update();
          onUpdate({ graphData: data });
        }

        function update() {
          // Update line
          d3.select('#line-1').select('path').data([data]).transition().duration(100).attr('d', plotLine);

          // Remove old line data
          d3.select('#line-1').select('path').data([data]).exit().remove();

          //Remove old area & data  
          d3.select('#shade-area').select('path').datum(data).transition().duration(100).attr('d', area);

          d3.select('#shade-area').select('path').data([data]).exit().remove();

          //Update all circles
          d3.select('#scatter-1').selectAll('circle').data(data).transition().duration(100).attr('cx', function (d) {
            return xScale(d.x);
          }).attr('cy', function (d) {
            return yScale(d.y);
          }).style('fill', function (d) {
            return 'rgba(255,232,2,' + d.y / 100 + ')';
          });

          //Enter new circles
          d3.select('#scatter-1').selectAll('.dot').data(data).enter().append('circle').attr('class', 'dot').attr('cx', function (d) {
            return xScale(d.x);
          }).attr('cy', function (d) {
            return yScale(d.y);
          }).attr('r', 10).attr('stroke', 'white').attr('stroke-width', '2px').style('fill', function (d) {
            return 'rgba(255,232,2,' + d.y / 100 + ')';
          }).call(drag).on('click', clickedDot);

          // Remove old
          d3.selectAll('circle').data(data).exit().remove();

          //Remove old area & data  
          d3.select('#cct-gradient').remove();

          //
          // Colors
          //
          var gradient = svg.append('linearGradient').attr('id', 'cct-gradient').attr('gradientUnits', 'userSpaceOnUse').attr('y1', 0).attr('x1', xScale(moment().hour(0))).attr('y2', 0).attr('x2', xScale(moment().hour(23)));

          var stops = gradient.selectAll('stop').data(mapGradients(data)).enter().append('stop').attr('offset', function (d) {
            return d.offset;
          }).attr('stop-color', function (d) {
            return d.color;
          });

          stops.transition().attr('stop-color', function (d) {
            return d.color;
          }).duration(100);
        }
      };

      _export('default', smartShiftChartSvgValue);
    }
  };
});

$__System.register('8d', ['86', '88', '89', '8a', '8c'], function (_export) {
   'use strict';

   var smartShiftService, smartShiftBodyComponent, smartShiftChartComponent, smartShiftPresetsValue, smartShiftChartSvgValue, smartShiftModule;
   return {
      setters: [function (_) {
         smartShiftService = _['default'];
      }, function (_2) {
         smartShiftBodyComponent = _2['default'];
      }, function (_3) {
         smartShiftChartComponent = _3['default'];
      }, function (_a) {
         smartShiftPresetsValue = _a['default'];
      }, function (_c) {
         smartShiftChartSvgValue = _c['default'];
      }],
      execute: function () {
         smartShiftModule = angular.module('schedules-smart-shift', []).service('SmartShiftSchedules', smartShiftService).component('smartShiftChart', smartShiftChartComponent).component('smartShiftBody', smartShiftBodyComponent).value('smartShiftPresets', smartShiftPresetsValue).value('smartShiftChartSvg', smartShiftChartSvgValue);

         _export('default', smartShiftModule);
      }
   };
});

$__System.registerDynamic("8e", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"recur-schedules full-width\">\n    <!-- \n    \t/schedules/ View option A (Base) - Nothing selected - Welcome / Add new schedule control \n    -->\n    <div ng-if=\"!sB.itemCollection.filtered\">\n        <div class=\"welcome-screen\" ng-if=\"!sB.blankSchedule\">\n            <h1 translate=\"schedules.schedules\">Schedules</h1>\n            <!-- @todoyu Translations -->\n            <h2 translate=\"schedules.byline\">Configure schedules for zones, scenes, and automations.</h2>\n            <div class=\"setup-mode\" translate=\"schedules.selectAnExistingSchedule\">To begin, select an existing schedule from the list on the left, or create a new one by clicking the plus (+) button.</div>\n        </div>\n\n        <recur-body \n            ng-if=\"sB.blankSchedule.type === 'default'\" \n            areas=\"sB.sessionData.areas\" \n            automations=\"sB.sessionData.automations\"\n            is-super-user=\"sB.isSuperUser\"\n            scenes=\"sB.sessionData.scenes\" \n            schedule=\"sB.blankSchedule\" \n            all-schedules=\"sB.sessionData.schedules\"\n            zones=\"sB.sessionData.zones\" \n            on-crud=\"sB.navigate(destinationId)\"\n            on-toggle-schedule-type=\"sB.toggleScheduleType(type);\"\n        ></recur-body>\n        \n        <smart-shift-body \n            ng-if=\"sB.blankSchedule.type === 'smart'\" \n            areas=\"sB.sessionData.areas\" \n            automations=\"sB.sessionData.automations\"\n            is-super-user=\"sB.isSuperUser\"\n            scenes=\"sB.sessionData.scenes\"\n            schedule=\"sB.blankSchedule\"\n            site-id=\"sB.sessionData.id\"\n            sun-positions=\"[sB.sessionData.locality.next_sunrise, sB.sessionData.locality.next_sunset]\"\n            zones=\"sB.sessionData.zones\" \n            on-crud=\"sB.navigate(destinationId)\"\n            on-toggle-schedule-type=\"sB.toggleScheduleType(type);\"\n        ></smart-shift-body>\n    </div>\n    <!-- \n    \t/schedules/selection~123 View option B - Single schedule control \n    -->\n    <recur-body \n        ng-if=\"sB.selectedSchedule.type === 'default'\" \n        areas=\"sB.sessionData.areas\" \n        automations=\"sB.sessionData.automations\"\n        is-super-user=\"sB.isSuperUser\"\n        scenes=\"sB.sessionData.scenes\" \n        schedule=\"sB.selectedSchedule\" \n        all-schedules=\"sB.sessionData.schedules\"\n        zones=\"sB.sessionData.zones\" \n        on-crud=\"sB.navigate(destinationId)\"\n        on-toggle-schedule-type=\"sB.toggleScheduleType(type);\"\n    ></recur-body>\n\n    <smart-shift-body \n        ng-if=\"sB.selectedSchedule.type === 'smart'\" \n        areas=\"sB.sessionData.areas\" \n        automations=\"sB.sessionData.automations\"\n        is-super-user=\"sB.isSuperUser\"\n        scenes=\"sB.sessionData.scenes\" \n        schedule=\"sB.selectedSchedule\"\n        site-id=\"sB.sessionData.id\"\n        sun-positions=\"[sB.sessionData.locality.next_sunrise, sB.sessionData.locality.next_sunset]\"\n        zones=\"sB.sessionData.zones\"\n        on-crud=\"sB.navigate(destinationId)\"\n        on-toggle-schedule-type=\"sB.toggleScheduleType(type);\"\n    ></smart-shift-body>\n\n    <!-- \n    \t/schedules/selection~123+124 View option C - Group selection options \n    -->\n    <div ng-if=\"sB.groupSelection\">\n        <section class=\"main-left\">\n            <h2 class=\"overview-heading\">\n                <span>Group Actions</span>\n            </h2>\n\n            <div class=\"left\">\n                <button class=\"btn orange delete\" ng-click=\"sB.deleteGroup(sB.groupSelection)\">Delete Group</button>\n            </div>\n        </section>\n\n        <section class=\"main-right\">\n            <!-- this wont work for now -->\n            <schedules-energy-demand-box selection-demand=\"sB.groupSelection.demand\" demand-change=\"sB.groupSelection.demandDifference\" max-demand=\"sB.groupSelection.maxDemand\"></schedules-energy-demand-box>\n        </section>\n    </div>\n    <!-- \n    \t/schedules/ View option D - Disabled because of old gateway version \n    -->\n\t<section class=\"bottom-notice show\" ng-show=\"sB.disabled\">\n\t\t<span><p translate=\"schedules.toEditThisScheduleUpdate\">To edit this schedule, please upgrade your gateway software. Call Lightcloud support on 1(844) LIGHTCLOUD.</p></span>\n\t</section>\n</div>";
});
$__System.register('8f', ['8e'], function (_export) {
    'use strict';

    var schedulesBaseTemplate, schedulesBaseComponent;
    return {
        setters: [function (_e) {
            schedulesBaseTemplate = _e['default'];
        }],
        execute: function () {
            schedulesBaseComponent = {
                template: schedulesBaseTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    user: '<',
                    onClearToBase: '&',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'sB',
                controller: function controller($scope, $q, $state, RecurrenceSchedules, SmartShiftSchedules, Modals, Messages, LcFn, _) {

                    var sB = this;

                    sB.$onInit = function () {
                        sB.onSelectionUpdate({ selection: sB.itemCollection });

                        if (gatewaySupported(sB.sessionData.gateways[0], '1.1.0') || sB.sessionData.is_blue) {
                            prepareViewContext();
                        } else {
                            disableSchedules();
                        }

                        sB.isSuperUser = sB.user.is_superuser;
                    };

                    sB.navigate = function (destinationId) {
                        //go to that schedule after creation
                        var filter = destinationId ? ['selection~' + destinationId] : null;

                        if (filter) {
                            $state.go('Schedules', { siteId: sB.sessionData.id, userSelectedFilter: filter });
                        } else {
                            sB.onClearToBase();
                        }
                    };

                    sB.deleteGroup = function (group) {
                        //
                        // @temp - add scene check here for smart s?
                        //
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + group.length + '</strong> Schedules?').then(function () {

                            Modals.openLoad('Deleting Schedules');

                            var schedulesToDelete = [];

                            _.each(group, function (schedule) {
                                schedulesToDelete.push(RecurrenceSchedules.del(schedule));
                            });

                            $q.all(schedulesToDelete).then(function () {
                                Modals.closeLoad('Schedules Deleted', true);
                                sB.navigate();
                            });
                        });
                    };

                    sB.toggleScheduleType = function (type) {
                        sB.blankSchedule = type === 'smart' ? new SmartShiftSchedules.blankSchedule() : new RecurrenceSchedules.blankSchedule();
                    };

                    function prepareViewContext() {
                        //Base View if filtered false
                        if (sB.itemCollection.filtered) {
                            if (sB.itemCollection.group.length > 1) {
                                sB.groupSelection = sB.itemCollection.group;
                            } else {
                                sB.selectedSchedule = prepareCurrentSchedule(sB.itemCollection.group[0], sB.sessionData.zones, sB.sessionData.scenes, sB.sessionData.automations);
                            }
                        }

                        if (sB.itemCollection['new']) {
                            sB.blankSchedule = new RecurrenceSchedules.blankSchedule();
                        }
                    }

                    function gatewaySupported(gateway, minVersion) {
                        return gateway && !LcFn.ltVersion(gateway.gateway_version, minVersion);
                    }

                    function disableSchedules() {
                        Messages.popUp('Gateway software upgrade required for new schedules');
                        sB.disabled = true;
                    }

                    function prepareCurrentSchedule(schedule, zones, scenes, automations) {
                        var buckets = {
                            zone: zones,
                            scene: scenes,
                            behavior2: automations
                        };

                        schedule.events.forEach(function (event) {
                            var objectMatch = _.filter(buckets[event.object_type], ['id', event.object_id])[0];
                            if (objectMatch) {
                                event.description = objectMatch.id_string || objectMatch.name;
                                event.dimmable = objectMatch.is_dimmable ? objectMatch.is_dimmable : false;
                                event.trim_high = objectMatch.trim_high ? objectMatch.trim_high.trim_high : false;
                            }
                        });
                        return schedule;
                    }
                }

            };

            _export('default', schedulesBaseComponent);
        }
    };
});

$__System.register('90', [], function (_export) {
  'use strict';

  var schedulesStates;
  return {
    setters: [],
    execute: function () {
      schedulesStates = {
        parent: 'site',
        name: 'Schedules',
        url: '/schedules/{userSelectedFilter}',
        resolve: {
          sessionData: function sessionData(Session) {
            return Session.getSiteData(false);
          },
          itemCollection: function itemCollection(sessionData, StructureService) {
            return StructureService.itemCollection(sessionData, 'schedules');
          }
        },

        component: 'schedulesBase',

        params: {
          allowNew: true,
          'new': false,
          leftMenuSpecialContext: 'schedules',
          //
          // - This will prevent route change
          //
          // userSelectedFilter: {
          //   value: null,
          //   dynamic: true
          // },
          extraSections: ['automations', 'schedules', 'scenes']
        },

        title: 'Schedules'
      };

      _export('schedulesStates', schedulesStates);
    }
  };
});

$__System.register('91', ['3', '85', '90', '8d', '8f'], function (_export) {
    'use strict';

    var angular, schedulesStates, schedulesBaseComponent, schedulesModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {}, function (_3) {
            schedulesStates = _3.schedulesStates;
        }, function (_d) {}, function (_f) {
            schedulesBaseComponent = _f['default'];
        }],
        execute: function () {
            schedulesModule = angular.module('schedules', ['schedules-recurrence', 'schedules-smart-shift']).component('schedulesBase', schedulesBaseComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(schedulesStates);
            }]);

            _export('default', schedulesModule);
        }
    };
});

$__System.register('92', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, ScenesService;

  return {
    setters: [function (_2) {
      _createClass = _2['default'];
    }, function (_3) {
      _classCallCheck = _3['default'];
    }],
    execute: function () {
      'use strict';

      ScenesService = (function () {
        function ScenesService($http, Energy, Track, LcCache, LcFn, _) {
          _classCallCheck(this, ScenesService);

          this.$http = $http;
          this.Energy = Energy;
          this.Track = Track;
          this.LcCache = LcCache;
          this.LcFn = this.LcFn;

          this.scenesResponseMapping = function (scene) {
            function combineCctActions(actions) {
              return _.flatten(_.map(_.groupBy(actions, 'systemId'), function (actionPair) {
                //
                // This is dumb, why not have two fields?
                //
                function parseStateAction(action) {
                  return {
                    id_state: action.id,
                    dimmable: action.dimmable,
                    dimLevel: action.dimLevel,
                    fade_time: action.fade_time,
                    lightsOn: action.lightsOn
                  };
                }

                function parseCctAction(action) {
                  return {
                    id_cct: action.id,
                    cct: action.cct,
                    cct_transition_time: (action.fade_time || 0) / 60
                  };
                }

                function parseAction(action) {
                  return action.cct ? parseCctAction(action) : parseStateAction(action);
                }

                function globActions(action, optionals) {
                  _.each(optionals, function (optAction) {
                    _.assign(action, parseAction(optAction));
                  });

                  return action;
                }

                //
                // Shared stuff
                //
                function Action(action) {
                  return {
                    systemId: action.systemId,
                    systemName: action.systemIdString,
                    systemType: action.systemType
                  };
                }

                return globActions(new Action(actionPair[0]), actionPair);
              }));
            }

            return {
              id: scene.id,
              name: scene.id_string || 'Blank Scene',
              actions: combineCctActions(scene.actions), //scene.actions.map(sceneActionMapping),
              area: scene.area,
              demand_response: scene.demand_response,
              site: scene.site
            };
          };

          this.sceneUpdateRequestMapping = function (scene) {
            function splitCombinedActions(actions) {
              return _.reduce(actions, function (result, action, key) {
                var defaultAction = {
                  systemId: action.systemId,
                  systemName: action.systemIdString,
                  systemType: action.systemType
                };

                if (angular.isDefined(action.lightsOn) || action.dimLevel) {
                  var stateAction = {
                    lightsOn: action.lightsOn,
                    dimLevel: action.dimLevel,
                    dimmable: action.dimmable,
                    //
                    //  Backend will give 'duplicate actions in a scene' error if no fade_time is supplied,
                    //  even if zone doesn't dim so fade is n/a
                    //
                    fade_time: parseInt(action.fade_time) || LcFn.defaultSceneFadeTime
                  };

                  // Allow updates without BE ID
                  if (action.id_state) {
                    defaultAction.id = stateAction.id_state;
                  }

                  result.push(_.merge({}, defaultAction, stateAction));
                }

                if (action.cct) {
                  //
                  // Add another action derp
                  //
                  var colorAction = {
                    id: action.id_cct,
                    cct: action.cct,
                    fade_time: (action.cct_transition_time || 0) * 60
                  };

                  result.push(_.merge({}, defaultAction, colorAction));
                }

                return result;
              }, []);
            }

            var sendScene = {
              id_string: scene.id_string ? scene.id_string : scene.name ? scene.name : 'Blank Scene',
              area_id: scene.area,
              site: scene.site,
              demand_response: scene.demand_response,
              actions: splitCombinedActions(scene.actions)
            };

            if (scene.id) {
              sendScene.id = scene.id;
            }

            return sendScene;
          };
        }

        _createClass(ScenesService, [{
          key: 'get',
          value: function get(sceneId) {
            var _this = this;

            return this.$http({
              url: 'scene/' + sceneId + '/'
            }).then(function (response) {
              return _this.scenesResponseMapping(response.data);
            });
          }
        }, {
          key: 'getForArea',
          value: function getForArea(areaId) {
            var _this2 = this;

            return this.$http({
              url: 'area/' + areaId + '/scenes/'
            }). //transformResponse : this.$http.defaults.transformResponse.concat([this.scenesResponseMapping(areaId)])
            then(function (response) {
              return response.data.scenes.map(_this2.scenesResponseMapping);
            });
          }
        }, {
          key: 'getForSite',
          value: function getForSite(siteId) {
            var _this3 = this;

            return this.$http({
              //return this.$http.get({
              url: 'site/' + siteId + '/scenes/'
            }).then(function (response) {
              return response.data.scenes.map(_this3.scenesResponseMapping);
            });
          }
        }, {
          key: 'create',
          value: function create(scene) {
            var _this4 = this;

            return this.$http({
              url: 'scene/',
              method: 'POST',
              data: this.sceneUpdateRequestMapping(scene)
            }).then(function (response) {
              _this4.LcCache.updateSessionSiteSectionChild('scenes', [_this4.scenesResponseMapping(response.data)]);
              _this4.Track.event('Scene: Created', 'Scene ' + scene.name);

              return _this4.scenesResponseMapping(response.data);
            });
          }
        }, {
          key: 'del',
          value: function del(scene) {
            var _this5 = this;

            return this.$http({
              url: 'scene/' + scene.id + '/',
              method: 'DELETE'
            }).success(function () {
              _this5.LcCache.removeSessionSiteSectionChild('scenes', [scene]);
              _this5.Track.event('Scene: Deleted', 'Scene ' + scene.name);
            });
          }
        }, {
          key: 'update',
          value: function update(scene) {
            var _this6 = this;

            return this.$http({
              url: 'scene/' + scene.id + '/',
              method: 'PUT',
              data: this.sceneUpdateRequestMapping(scene)
            }).then(function () {
              _this6.LcCache.updateSessionSiteSectionChild('scenes', [scene]);
            });
          }
        }, {
          key: 'activate',
          value: function activate(sceneId) {
            var _this7 = this;

            return this.$http({
              url: 'scene/' + sceneId + '/command/',
              method: 'POST',
              data: {
                'command': 'activate'
              }
            }).success(function () {
              _this7.Track.event('Scene: Activated', 'Scene ' + sceneId);
            });
          }
        }, {
          key: 'mapZonesEnergy',
          value: function mapZonesEnergy(zoneSet, sceneSet) {
            var maxDemand = 999999;

            //Use max from all zones for all scenes
            maxDemand = this.Energy.getDemand(zoneSet).maxDemand;

            sceneSet.forEach(function (scene) {
              scene.zones = [];

              //Scene has no knowledge of its dimmability - check against zone props
              scene.actions.forEach(function (action) {
                if (action.systemType === 'zone') {
                  //The end of systemType = zone? where did it go?
                  var matchingZone = angular.copy(_.filter(zoneSet, function (zone) {
                    return zone.id === action.systemId;
                  })[0]);
                  //@todo if the zone has been removed?

                  if (matchingZone) {
                    //Dimmability
                    action.dimmable = matchingZone.is_dimmable;
                    action.trim_high = matchingZone.trim_high;

                    //Energy Demand Madness
                    //The zone's current state to be ignored - set as scene will set
                    matchingZone.zone_state = action.lightsOn;
                    matchingZone.reported_dim_level = action.dimLevel;

                    //IF we know the Energy Load currently, but the scene will set to different dim level - we should use watts...
                    if (matchingZone.reported_dim_level !== action.dimLevel) {
                      matchingZone.full_power_reading = null;
                      //Does a reported energy load at X dimLevel give us the right figure to calculate demand ?
                      //Should we always ignore watts if given reported energy usage?
                    }

                    //@todo - same scene with same zones ?
                    scene.zones.push(matchingZone);
                  }
                }
              });

              scene.demand = this.Energy.getDemand(scene.zones).currentDemand;
              scene.maxDemand = maxDemand;
            });

            return sceneSet;
          }
        }]);

        return ScenesService;
      })();

      _export('default', ScenesService);
    }
  };
});

$__System.registerDynamic("93", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"scenes gutters-20\">\n    <!-- \n        /scenes/ View option A (Base) - Nothing selected - Welcome / Add new scene control\n    -->\n    <div ng-if=\"!sB.itemCollection.filtered\">\n        <div class=\"welcome-screen\" ng-if=\"!sB.blankScene\">\n            <h1 translate=\"demand.siteScenes\">Scenes</h1>\n            <!-- @todoyu Translations -->\n            <h2 translate=\"demand.creatPreSet\">Create pre-set collections of actions across multiple zones</h2>\n            <div class=\"setup-mode\" translate=\"common.selectAnExisting\">Select exisiting from left or create one with the plus button</div>\n        </div>\n\n\n        <scene-body ng-if=\"sB.blankScene\" areas=\"sB.sessionData.areas\" is-admin=\"sB.isOrgAdmin\" is-super-user=\"sB.isSuperUser\" scene=\"sB.blankScene\" zones=\"sB.zones\" on-crud=\"sB.navigate(destinationId)\" scene-names=\"sB.sceneNames\" edit-mode=\"sB.editMode\"></scene-body>\n\n        <section class=\"main-left\" ng-if=\"sB.isOrgAdmin && sB.siteHasOrgScenes\">\n            <h2 class=\"overview-heading\">\n                <span>Organization Level Scenes</span>\n            </h2>\n\n            <div class=\"left\">\n                <button class=\"btn blue\" ui-sref=\"MultiSite({orgUuid:sB.sessionData.org.uuid})\">View All Organization Level Scenes</button>\n            </div>\n        </section>\n    </div>\n    <!-- \n        /scenes/ View option B - Single scene control\n    -->\n    <scene-body ng-if=\"sB.selectedScene\" areas=\"sB.sessionData.areas\" is-admin=\"sB.isOrgAdmin\" is-super-user=\"sB.isSuperUser\" scene=\"sB.selectedScene\" zones=\"sB.zones\" on-crud=\"sB.navigate(destinationId)\" scene-names=\"sB.sceneNames\" edit-mode=\"sB.editMode\"></scene-body>\n    <!-- \n        /scenes/ View option C - group selection options\n    -->\n    <div ng-if=\"sB.groupSelection\">\n        <section class=\"main-left\">\n            <h2 class=\"overview-heading\">\n                <span>Group Actions</span>\n            </h2>\n\n            <div class=\"left\">\n                <button class=\"btn orange delete\" ng-click=\"sB.deleteGroup(sB.groupSelection)\">Delete Group</button>\n            </div>\n        </section>\n\n        <section class=\"main-right\" ng-if=\"sB.groupSelection.demand\">\n            <!-- this wont work for now -->\n            <scenes-energy-demand-box selection-demand=\"sB.groupSelection.demand\" demand-change=\"sB.groupSelection.demandDifference\" max-demand=\"sB.groupSelection.maxDemand\"></scenes-energy-demand-box>\n        </section>\n    </div>\n</div>";
});
$__System.register('94', ['93'], function (_export) {
    'use strict';

    var scenesBaseTemplate, scenesBaseComponent;
    return {
        setters: [function (_2) {
            scenesBaseTemplate = _2['default'];
        }],
        execute: function () {
            scenesBaseComponent = {
                template: scenesBaseTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    user: '<',
                    onClearToBase: '&',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'sB',
                controller: function controller(LcFn, $state, $scope, $q, Modals, Scenes, scenesTransform, _, $location) {

                    var sB = this;

                    sB.$onInit = function () {

                        sB.isOrgAdmin = LcFn.isOrgAdmin(sB.user, sB.sessionData.org);
                        sB.isSuperUser = sB.user.is_superuser;

                        sB.siteHasOrgScenes = _.find(sB.sessionData.scenes, function (scene) {
                            return (scene.name || '').indexOf('[Master]') > -1;
                        });

                        sB.onSelectionUpdate({ selection: sB.itemCollection });

                        sB.zones = angular.copy(sB.sessionData.zones);

                        sB.sceneNames = _.map(sB.sessionData.scenes, 'name');

                        sB.editMode = $location.search().edit === 'true';

                        // Watch for URL changes to update editMode
                        $scope.$watch(function () {
                            return $location.search().edit;
                        }, function (newEditParam) {
                            // Only update editMode from URL if we're not creating a new scene
                            if (!sB.itemCollection || !sB.itemCollection['new']) {
                                sB.editMode = newEditParam === 'true';
                            }
                        });

                        prepareViewContext(sB.zones);
                    };

                    sB.$onChanges = function (changes) {
                        //
                    };

                    sB.navigate = function (destinationId) {
                        //go to that scene after creation
                        var filter = destinationId ? ['selection~' + destinationId] : null;

                        if (filter) {
                            $state.go('Scenes', { siteId: sB.sessionData.id, userSelectedFilter: filter });
                        } else {
                            sB.onClearToBase();
                        }
                    };

                    sB.deleteGroup = function (group) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + group.length + '</strong> scenes?').then(function () {

                            Modals.openLoad('Deleting Scenes');

                            var scenesToDelete = [];

                            _.each(group, function (scene) {
                                scenesToDelete.push(Scenes.del(scene));
                            });

                            $q.all(scenesToDelete).then(function () {
                                Modals.closeLoad('Scenes Deleted', true);
                                sB.navigate();
                            }, function () {
                                //Failures handled here
                            });
                        });
                    };

                    function prepareViewContext(zones) {
                        //Base View if filtered false
                        if (sB.itemCollection.filtered) {
                            if (sB.itemCollection.group.length > 1) {
                                sB.groupSelection = sB.itemCollection.group;
                            } else {
                                sB.selectedScene = prepareScene(sB.itemCollection.group[0], zones);
                            }
                        }

                        if (sB.itemCollection['new']) {
                            //
                            // Avoid keeping exisitingActionIds from old scenes
                            //
                            sB.zones = angular.copy(zones);

                            sB.blankScene = new scenesTransform.NewScene(sB.sessionData.id);

                            sB.editMode = true;
                        }
                    }

                    function prepareScene(scene) {
                        //if it's area default scene, need to show whole zone list
                        if (scene.actions && scene.actions[0] && scene.actions[0].systemType === 'area') {
                            var zones = _.filter(sB.zones, ['area', scene.actions[0].systemId]);
                            if (zones) {
                                zones.forEach(function (zone) {
                                    scenesTransform.zoneActionMapping(zone, scene.actions[0], sB.sessionData.areas, LcFn.defaultCct);
                                });
                            }
                            scene.actionZones = zones;
                            //add a mark,then disable edit
                            scene.isDefaultScene = true;
                        } else {
                            scene.actionZones = _.map(scene.actions, function (action) {
                                var zone = _.find(sB.zones, ['id', action.systemId]);

                                if (!zone) {
                                    //
                                    // Check if Zone was deleted - BE should catch these in most cases but apparently not all
                                    //
                                    zone = {
                                        disabled: true,
                                        id: action.systemId,
                                        id_string: 'DELETED - ' + action.systemName
                                    };
                                }

                                scenesTransform.zoneActionMapping(zone, action, sB.sessionData.areas, LcFn.defaultCct);

                                return zone;
                            });
                        }

                        //Filter out zones that didnt match anything- ie they've been deleted
                        scene.actionZones = _.filter(scene.actionZones); //???

                        return scene;
                    }
                }
            };

            _export('default', scenesBaseComponent);
        }
    };
});

$__System.registerDynamic("95", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"main-left\">\n    <h2 class=\"overview-heading\">\n        <span translate=\"scenes.actions\">Actions</span>\n    </h2>\n\n    <div class=\"left\">\n        <button class=\"btn edit blue\" ng-if=\"sBO.scene.id && !sBO.isEditMode\" ng-disabled=\"sBO.scene.isDefaultScene\" ng-click=\"sBO.toggleEdit(sBO.scene)\" translate=\"common.edit\">Edit</button>\n        <button class=\"btn rename\" ng-if=\"sBO.scene.id\" ng-click=\"sBO.rename(sBO.scene)\" ng-disabled=\"sBO.ajaxPending || sBO.scene.isDefaultScene\" translate=\"common.rename\">Rename</button>\n        <button class=\"btn orange delete\" ng-if=\"sBO.scene.id\" ng-disabled=\"sBO.isSmartShift\" ng-click=\"sBO.deleteDemand(sBO.scene)\" translate=\"common.delete\">Delete</button>\n        <!-- <button class=\"btn blue save\" ng-if=\"sBO.isSuperUser\" ng-click=\"sBO.scene.liveMode = !sBO.scene.liveMode\" ng-disabled=\"sBO.ajaxPending || !sBO.scene.editMode || sBO.scene.masterMode\" translate>{{sBO.scene.liveMode ? 'demand.disableLiveMode' : 'demand.enableLiveMode'}}</button> -->\n    </div>\n\n    <div class=\"left full\">\n        <div class=\"demand-toggle\" ng-class=\"{selected:sBO.scene.demand_response}\">\n            <button class=\"btn btn-select-toggle\" ng-disabled=\"!sBO.isEditMode\" ng-class=\"{selected:sBO.scene.demand_response}\" ng-click=\"sBO.scene.demand_response = !sBO.scene.demand_response\"></button>\n            <span class=\"\" translate=\"demand.demandResponse\">Demand Response</span>\n        </div>\n    </div>\n</section>\n\n<section class=\"main-right\" ng-if=\"sBO.scene.demand\">\n    <scenes-energy-demand-box selection-demand=\"sBO.scene.demand\" demand-change=\"sBO.scene.demandDifference\" max-demand=\"sBO.maxDemand\"></scenes-energy-demand-box>\n</section>\n\n<section class=\"main-body\">\n    <h2 ng-if=\"!sBO.isEditMode\" class=\"overview-heading\">\n        <span translate=\"zones.zones\">Zones</span>\n    </h2>\n\n    <h2 ng-if=\"sBO.isEditMode\" class=\"overview-heading cog\">\n        <!-- <button class=\"btn green right m1pc\" ng-click=\"sBO.selectObject(sBO.scene.actionZones);\" ng-if=\"sBO.isEditMode\" ng-disabled=\"sBO.ajaxPending\" translate=\"common.add\">Add</button> -->\n        <a class=\"cog\" ng-hide=\"sBO.scene.masterMode || sBO.scene.actionZones.length === 0\" ng-click=\"sBO.toggleMaster(sBO.scene)\"><span class=\"SEdit\" translate=\"common.editAll\">Edit All</span><i class=\"cog\"></i></a>\n        <a class=\"cog done\" ng-if=\"sBO.scene.masterMode\" ng-click=\"sBO.scene.masterMode = false\"><span class=\"SEdit\" translate=\"common.doneEditAll\">Done Edit All</span><i class=\"cog\"></i></a>\n        <a class=\"\" ng-if=\"sBO.scene.masterMode\" ng-click=\"sBO.revertAll(sBO.scene)\"><span class=\"SEdit\" translate=\"common.cancel\">Cancel</span></a>\n\n        <span translate=\"zones.zones\">Zones</span>\n\n        <span class=\"mode-toggles\" ng-if=\"sBO.isEditMode && sBO.is_tunable;\">\n            <a class=\"mode-toggle color-tuning\" ng-class=\"{inactive: !sBO.showColor}\" ng-click=\"sBO.toggleShowColor();\"><span class=\"SEdit\" translate=\"\">Color Tuning</span></a>\n            <a class=\"mode-toggle\" ng-class=\"{inactive: !sBO.showState}\" ng-click=\"sBO.toggleShowState();\"><span class=\"SEdit\" translate=\"\">Zone State</span></a>\n            <a class=\"mode-toggle\" ng-class=\"{inactive: !sBO.showDim}\" ng-click=\"sBO.toggleShowDim();\"><span class=\"SEdit\" translate=\"\">Zone Dim</span></a>\n        </span>        \n    </h2>\n\n    <div class=\"overview-zones-list-wrapper\">\n        <div class=\"overview-zones-list scenes\" ng-class=\"{liveMode: sBO.scene.liveMode, dullMode: !sBO.scene.liveMode, editMode: sBO.isEditMode}\">\n            \n            <scene-zone-control \n                ng-if=\"sBO.scene.masterMode\"  \n                edit-mode=\"true\"\n                is-admin=\"sBO.isAdmin\"\n                live-mode=\"false\" \n                master-mode=\"false\"\n                show-color=\"sBO.showColor\" \n                show-state=\"sBO.showState\" \n                show-dim=\"sBO.showDim\" \n                title=\"{{'zones.setAllZones' | translate}}\" \n                zone=\"sBO.master\" \n                on-change=\"sBO.propUpdate(sBO.master,propKey,propVal);\" \n                on-remove=\"sBO.removeItem();\"\n            ></scene-zone-control>\n\n            <form name=\"zonesSetting\">\n\n                <scene-zone-control \n                    ng-repeat=\"zone in sBO.scene.actionZones | orderBy:['areaName', 'id_string']\" \n                    edit-mode=\"sBO.isEditMode\"\n                    is-admin=\"sBO.isAdmin\" \n                    live-mode=\"sBO.scene.liveMode\" \n                    master-mode=\"sBo.scene.masterMode\" \n                    show-color=\"sBO.showColor\" \n                    show-state=\"sBO.showState\" \n                    show-dim=\"sBO.showDim\" \n                    title=\"{{zone.id_string}}\" \n                    zone=\"zone\" \n                    on-change=\"sBO.propUpdate(zone,propKey,propVal);\" \n                    on-remove=\"sBO.removeItem(zone);\"\n                ></scene-zone-control>\n\n            </form>\n\n            <div class=\"white-pill-item no-icon short\" ng-if=\"sBO.isEditMode\">\n                <button class=\"btn black btn-white-plus large\" ng-click=\"sBO.selectObject(sBO.scene.actionZones);\"></button>\n                <h1 class=\"name\" translate=\"demand.addZone\">Add Zone</h1>\n            </div>\n\n            <span ng-if=\"sBO.scene.actionZones.length < 1 && !sBO.isEditMode\">No Zones</span>\n\n        </div>\n        <div class=\"buttons\">\n            <!-- <button class=\"btn blue right m1pc\" ng-click=\"sBO.savesiteScenes()\"  ng-disabled=\"sBO.ajaxPending\">Done</button> -->\n            <button class=\"btn blue save right\" ng-if=\"sBO.isEditMode\" ng-click=\"sBO.save(sBO.scene)\" ng-disabled=\"sBO.ajaxPending || sBO.scene.actionZones.length == 0 || zonesSetting.$invalid\" translate>{{sBO.ajaxPending? 'common.saving' : 'common.save'}}</button>\n        </div>\n    </div>\n</section>";
});
$__System.register('96', ['95'], function (_export) {
    'use strict';

    var sceneBodyTemplate, sceneBodyComponent;
    return {
        setters: [function (_2) {
            sceneBodyTemplate = _2['default'];
        }],
        execute: function () {
            sceneBodyComponent = {
                template: sceneBodyTemplate,
                bindings: {
                    areas: '<',
                    isAdmin: '<',
                    isSuperUser: '<',
                    scene: '<',
                    zones: '<',
                    onCrud: '&',
                    sceneNames: '<',
                    editMode: '<'
                },
                controllerAs: 'sBO',
                controller: function controller($rootScope, $scope, $q, $state, $stateParams, $location, Scenes, scenesTransform, Energy, Modals, LcFn, $timeout, _) {
                    // @refactor - used to broadcast 'animatebars' which was a hack

                    var sBO = this;

                    sBO.$onInit = function () {
                        sBO.showState = sBO.scene.actions ? _.find(sBO.scene.actions, function (action) {
                            return angular.isDefined(action.lightsOn);
                        }) ? true : false : true;

                        sBO.showDim = sBO.scene.actions ? _.find(sBO.scene.actions, function (action) {
                            return action.dimLevel;
                        }) ? true : false : true;

                        sBO.showColor = _.find(sBO.scene.actionZones, 'cct') ? true : false;
                        sBO.is_tunable = _.find(sBO.scene.actionZones, 'is_tunable') ? true : false;

                        //
                        // Set SS Flag to block delete
                        //
                        sBO.isSmartShift = LcFn.isSmartShiftType(sBO.scene);

                        sBO.isEditMode = sBO.editMode;
                    };

                    sBO.$onChanges = function (changes) {
                        if (changes.editMode) {
                            sBO.isEditMode = changes.editMode.currentValue;
                        }
                    };

                    sBO.$onDestroy = function () {
                        if (sBO.masterWatch) {
                            sBO.masterWatch();
                        }
                    };

                    sBO.toggleEdit = function (scene) {
                        sBO.isEditMode = !sBO.isEditMode;
                        scene.masterMode = false;
                        $timeout(function () {
                            $rootScope.$broadcast('animateBars');
                        });
                    };

                    sBO.rename = function (scene) {
                        promptModal('Rename', scene);
                    };

                    sBO.save = function (scene) {
                        if (scene.id) {
                            saveScene(scene);
                        } else {
                            promptModal(scene.demand ? 'Demand Name' : 'Scene Name', scene);
                        }
                    };

                    sBO.deleteDemand = function (scene) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete this scene?').then(function () {
                            Modals.openLoad('Deleting Scenes');

                            return Scenes.del(scene).success(function (result) {
                                Modals.closeLoad('Scenes Deleted', true);

                                sBO.onCrud({ destinationId: null });
                            }).error(function (error) {
                                Modals.closeLoad('Scenes Delete Failed');
                            });
                        });
                    };

                    sBO.removeItem = function (item) {
                        return sBO.scene.actionZones.splice(sBO.scene.actionZones.indexOf(item), 1);
                    };

                    sBO.selectObject = function () {
                        function flagZones(zones) {
                            return zones.map(function (zone) {
                                //
                                // No flag for now...
                                //
                                return zone;
                            });
                        }

                        var flaggedZones = flagZones(sBO.zones);

                        var areas = _.map(sBO.areas, function (area) {
                            area.zones = _.filter(flaggedZones, { area: area.id });
                            return area;
                        });

                        // - Add unassigned zones to their own category
                        var noAreaZones = _.filter(flaggedZones, { area: null });

                        if (noAreaZones.length) {
                            areas.push({
                                name: 'No Area',
                                zones: noAreaZones
                            });
                        }

                        var allItems = [{
                            type: 'zones',
                            areas: areas,
                            selected: _.filter(flaggedZones, function (zone) {
                                return _.find(sBO.scene.actionZones, { 'id': zone.id });
                            })
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Zones', 'site-scenes').then(function (items) {
                            _.each(items, function (zone) {
                                // Add area name
                                zone.areaName = _.find(sBO.areas, ['id', zone.area]) ? _.find(sBO.areas, ['id', zone.area]).name : 'Unassigned';
                                // Set default fade time for dimmable zones
                                if (zone.is_dimmable) {
                                    // May have set to 0
                                    if (angular.isUndefined(zone.fade_time)) {
                                        zone.fade_time = LcFn.defaultSceneFadeTime;
                                    }
                                }
                            });

                            sBO.is_tunable = _.find(items, 'is_tunable') ? true : false;
                            sBO.scene.actionZones = items;
                        });
                    };

                    sBO.propUpdate = function (target, propKey, propVal) {
                        //
                        //
                        // Master CCT / Fade time updates
                        //
                        //
                        target[propKey] = propVal;

                        if (target.name === 'master') {
                            _.each(sBO.scene.actionZones, function (zone) {
                                zone[propKey] = propVal;
                            });
                        }
                    };

                    sBO.toggleMaster = function (scene) {

                        scene.masterMode = !scene.masterMode;

                        sBO.cachedZones = angular.copy(scene.actionZones);

                        sBO.master = {
                            name: 'master',
                            cct: LcFn.defaultCct.reported,
                            cct_transition_time: LcFn.defaultCct.transition,
                            fade_time: LcFn.defaultSceneFadeTime,
                            is_dimmable: _.find(scene.actionZones, 'is_dimmable') ? true : false,
                            is_tunable: sBO.is_tunable,
                            min_cct: getDefaultCct(scene.actionZones, 'min'),
                            max_cct: getDefaultCct(scene.actionZones, 'max'),
                            reported_dim_level: 1,
                            zone_state: false
                        };

                        sBO.masterWatch = $scope.$watch('sBO.master', function (masterNew, masterOld) {
                            $rootScope.$broadcast('animateBars'); // Puke

                            _.each(sBO.scene.actionZones, function (zone) {
                                if (zone.is_dimmable) {
                                    if (masterNew.reported_dim_level <= zone.trim_high) {
                                        zone.reported_dim_level = masterNew.reported_dim_level;
                                    }
                                }
                                //
                                if (zone.is_tunable) {
                                    //
                                    //
                                    //
                                    // No / Mixed defaults for min max cct, need to address this
                                    //
                                    //
                                    //
                                    if (masterNew.cct <= zone.max_cct && masterNew.cct >= zone.min_cct) {
                                        zone.cct = masterNew.cct;
                                    }
                                }

                                zone.zone_state = masterNew.zone_state;
                                zone.fade_time = masterNew.fade_time;
                            });
                        }, true);
                    };

                    sBO.toggleShowColor = function () {
                        $rootScope.$broadcast('animateBars');
                        sBO.showColor = !sBO.showColor;

                        //
                        // Don't leave an empty bar
                        //
                        if (!sBO.showState && !sBO.showDim) {
                            sBO.showState = true;
                        }
                    };

                    sBO.toggleShowState = function () {
                        $rootScope.$broadcast('animateBars');
                        sBO.showState = !sBO.showState;

                        //
                        // Don't leave an empty bar
                        //
                        if (!sBO.showState && !sBO.showDim) {
                            sBO.showColor = true;
                        }
                    };

                    sBO.toggleShowDim = function () {
                        $rootScope.$broadcast('animateBars');
                        sBO.showDim = !sBO.showDim;

                        //
                        // Don't leave an empty bar
                        //
                        if (!sBO.showDim && !sBO.showState) {
                            sBO.showState = true;
                        }
                    };

                    sBO.revertAll = function (scene) {
                        sBO.masterWatch();
                        scene.actionZones = sBO.cachedZones;
                        scene.masterMode = !scene.masterMode;
                        return scene;
                    };

                    //
                    //
                    // @todo - move this crap to the new demand box component
                    //
                    //

                    // function //watchScene(scope,scenes){
                    //     $scope.$watch("selectedScene.actionZones", _.debounce(function (newActionZones,oldActionZones) {
                    //         $scope.$apply(function(){ //For the debounce
                    //             if(newActionZones){

                    //                 calculateDemand();

                    //                 if(sBO.scene.oldDemand !== sBO.scene.demand){
                    //                     sBO.scene.demandDifference = sBO.scene.oldDemand - sBO.scene.demand;
                    //                 }
                    //             }
                    //         });
                    //     }, 1000),true);
                    // }

                    // var store = _.once(storeDemand);

                    // function calculateDemand(){
                    //     var demand = Energy.getDemand(sBO.scene.actionZones);

                    //     sBO.maxDemand = demand.maxDemand;
                    //     sBO.scene.demand = demand.currentDemand;

                    //     store();
                    // }

                    // function storeDemand(){
                    //     sBO.scene.oldDemand = angular.copy(sBO.scene.demand);
                    // }

                    function getDefaultCct(zones, limit) {
                        var propName = limit + '_cct';
                        var match = _.maxBy(zones, propName);
                        return match[propName] ? match[propName] : LcFn.defaultCct[limit];
                    }

                    function promptModal(title, scene) {
                        Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: scene,
                                cleanObject: sBO.cleanScene,
                                title: title,
                                action: 'Save',
                                existingNames: sBO.sceneNames
                            }
                        }).then(function (result) {
                            if (result) {
                                saveScene(scene);
                            }
                        });
                    }

                    function saveScene(scene) {
                        function finish(scene) {
                            scene.masterMode = false;
                            scene.editMode = false;

                            $timeout(function () {
                                $rootScope.$broadcast('animateBars');
                            });

                            Modals.closeLoad('Scenes Saved', true);

                            // Remove ?edit from the URL after save
                            $location.search('edit', null);
                        }

                        Modals.openLoad('Saving Scenes');

                        return scene.id === undefined ? Scenes.create(scenesTransform.mapSceneToBackend(scene, sBO.showColor, sBO.showDim, sBO.showState)).then(function (savedScene) {
                            finish(scene);
                            sBO.onCrud({ destinationId: savedScene.id });
                        })['catch'](function () {
                            //400 Returned with ugly error msg - assuming its a scene name collision
                            Modals.closeLoad('Scenes Save Failed - Name Already Exists');
                        }) : Scenes.update(scenesTransform.mapSceneToBackend(scene, sBO.showColor, sBO.showDim, sBO.showState)).then(function (response) {
                            $rootScope.$broadcast('event:cache-update:renameItem', scene);
                            finish(scene);
                        })['catch'](function () {
                            Modals.closeLoad('Scenes Update Failed');
                        });
                    }
                }
            };

            _export('default', sceneBodyComponent);
        }
    };
});

$__System.register('97', [], function (_export) {
    'use strict';

    var sceneZoneControlComponent;
    return {
        setters: [],
        execute: function () {
            sceneZoneControlComponent = {
                template: '\n        <div class="overview-zone" \n            ng-class="{\n                \'color-temp-enabled\' : sZC.showColor && sZC.zone.is_tunable,\n                \'disabled\'           : sZC.zone.disabled,\n                \'hasAdvanced\'        : sZC.editMode && sZC.isAdmin && (sZC.zone.is_dimmable || sZC.zone.is_tunable), \n                \'has-slider\'         : (sZC.showState || sZC.showDim) && sZC.zone.is_dimmable,\n                \'hide-dim\'           : !sZC.showDim,\n                \'hide-state\'         : !sZC.showState,\n                \'on\'                 : sZC.zone.zone_state,               \n                \'selected\'           : !sZC.masterMode,\n                \'showAdvanced\'       : sZC.showAdvanced,\n                \'trimmed\'            : sZC.zone.trim_high < 100, \n                \'trim-maxed\'         : sZC.zone.trim_high === sZC.zone.reported_dim_level && sZC.zone.trim_high < 100\n            }">\n\n            <button class="btn-select remove demands" ng-if="sZC.zone.name !== \'master\'" ng-click="sZC.zone.selected = false; sZC.onRemove({zone:sZC.zone});"></button>\n\n            <div class="zone-control">\n                <button ng-if="sZC.showState" class="btn-push" ng-bind="sZC.zone.zone_state" ng-class="{on:sZC.zone.zone_state}" ng-click="sZC.toggleZone(sZC.zone,sZC.liveMode)" ng-disabled="sZC.zone.disabled || sZC.masterMode || !sZC.editMode"></button>\n\n                <span class="zone-name">{{sZC.title}}</span>\n\n                <span ng-if="sZC.zone.areaName" class="zone-description" ng-class="{\'without-slider\': !sZC.zone.is_dimmable}">Area: {{sZC.zone.areaName}}</span>\n\n                <div ng-if="sZC.showDim && sZC.zone.is_dimmable" class="slider-wrapper">\n                    <slider \n                        floor="1" \n                        ceiling="{{sZC.zone.trim_high ? sZC.zone.trim_high : 100}}" \n                        step="1" \n                        precision="1" \n                        dim="true" \n                        level="sZC.zone.reported_dim_level" \n                        ng-model="sZC.zone.reported_dim_level" \n                        ng-model-low="1" \n                        ng-model-high="100" \n                        enabled="!sZC.masterMode && sZC.editMode" \n                        update="sZC.liveMode"\n                    ></slider>\n                </div>\n            </div>\n\n            <div class="color-temp-drop" ng-if="sZC.showColor && sZC.zone.is_tunable">\n                <div class="slider-wrapper color-temp">\n                    <!-- <span class="subtitle">Temperature</span> -->\n                    <slider \n                        floor="{{::sZC.zone.min_cct}}" \n                        ceiling="{{::sZC.zone.max_cct}}" \n                        step="100" \n                        precision="1" \n                        dim="true" \n                        level="sZC.zone.cct" \n                        ng-model="sZC.zone.cct"\n                        ng-model-high="sZC.zone.max_cct" \n                        enabled="!sZC.masterMode && sZC.editMode" \n                        update="false" \n                        aux-function=""\n                    ></slider>\n                    <span class="unit">{{sZC.zone.cct ? sZC.zone.cct + \' K\' : \'\'}}</span>\n                </div>\n            </div>\n\n            <div class="advanced" ng-if="sZC.editMode && sZC.isAdmin && ((sZC.zone.is_dimmable && sZC.showDim && sZC.showState) || (sZC.zone.is_tunable && sZC.showColor))">\n                <div class="toggle" ng-click="sZC.toggleAdvanced()">\n                    <span>Advanced <i>{{sZC.showAdvanced ? \'&#9650;\' : \'&#9660;\'}}</i></span>\n                </div>\n                <ng-form name="details">\n                    <div class="settings">\n                        <scene-zone-control-setting \n                            ng-if="sZC.showDim && sZC.zone.is_dimmable" \n                            time="sZC.zone.fade_time" \n                            max="120" \n                            name="fadeTime" \n                            unit="secs" \n                            on-update="sZC.onChange({propKey: \'fade_time\', propVal: propVal});"\n                        ></scene-zone-control-setting>\n                        <scene-zone-control-setting \n                            ng-if="sZC.showColor && sZC.zone.is_tunable" \n                            time="sZC.zone.cct_transition_time" \n                            max="360" \n                            name="cct_transition_time" \n                            unit="mins" \n                            on-update="sZC.onChange({propKey: \'cct_transition_time\', propVal: propVal});"\n                        ></scene-zone-control-setting>\n                    </div>\n                </ng-form>\n            </div>\n\n        </div>\n    ',
                bindings: {
                    editMode: '<',
                    dim: '<',
                    isAdmin: '<',
                    liveMode: '<',
                    masterMode: '<',
                    showColor: '<',
                    showDim: '<',
                    showState: '<',
                    title: '@',
                    zone: '<',
                    onRemove: '&',
                    onChange: '&'
                },
                controllerAs: 'sZC',
                controller: function controller($timeout, $rootScope) {

                    var sZC = this;

                    sZC.$onInit = function () {
                        //
                        //
                        //
                        sZC.showAdvanced = sZC.zone.fade_time && sZC.zone.fade_time !== 4 || sZC.zone.cct_transition_time && sZC.zone.cct_transition_time > 0 || false;
                    };

                    sZC.$onChanges = function (changes) {
                        //
                        //
                        //
                    };

                    sZC.toggleAdvanced = function () {
                        sZC.showAdvanced = !sZC.showAdvanced;
                        $timeout(function () {
                            $rootScope.$broadcast('animateBars');
                        });
                    };

                    sZC.toggleZone = function (zone, liveMode) {
                        zone.zone_state = !zone.zone_state;

                        if (liveMode) {
                            zone.toggle().then(function (result) {
                                zone.zone_state = !zone.zone_state;
                            });
                        }
                    };
                }
            };

            _export('default', sceneZoneControlComponent);
        }
    };
});

$__System.register('98', [], function (_export) {
    'use strict';

    var sceneZoneControlSettingComponent;
    return {
        setters: [],
        execute: function () {
            sceneZoneControlSettingComponent = {
                template: '\n        <div class="setting">\n            <h3>{{\'scenes.\'+sZCS.name | translate}}</h3>\n            <input string-to-number type="number" placeholder="0" ng-model="sZCS.time" ng-change="sZCS.onUpdate({propVal:sZCS.time})" ng-min="0" ng-max="sZCS.max" ng-required="false" name="sZCS.name"/>\n            <span>{{zonesSetting[sZCS.name].$error}}</span>\n            <span class="max" ng-class="{error:details[sZCS.name].$invalid}">{{\'common.max\' | translate}}: {{sZCS.max}} {{\'common.\'+[sZCS.unit] | translate}}</span>\n        </div>\n    ',
                bindings: {
                    time: '<',
                    max: '@',
                    name: '@',
                    unit: '@',
                    onUpdate: '&'
                },
                controllerAs: 'sZCS'
            };

            _export('default', sceneZoneControlSettingComponent);
        }
    };
});

$__System.register('99', [], function (_export) {
    'use strict';

    var scenesEnergyDemandBoxComponent;
    return {
        setters: [],
        execute: function () {
            scenesEnergyDemandBoxComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="demand.energyDemand">Energy Demand</span>\n        </h2>\n        <span>{{sEDB.selectionDemand}}W of {{sEDB.maxDemand}}W</span>\n\n        <span class="savings" ng-if="sEDB.demandDifference" ng-class="{\'saved\': sEDB.demandDifference >= 0, \'extra\': sEDB.demandDifference < 0}">{{sEDB.demandDifference}} Watts {{sEDB.demandDifference > 0 ? \'Saved\':\'\'}}</span>\n\n    ',
                bindings: {
                    selectionDemand: '<',
                    demandChange: '<',
                    maxDemand: '<'
                },
                controllerAs: 'sEDB',
                controller: function controller() {

                    var sEDB = this;

                    sEDB.$onInit = function () {};
                }
            };

            _export('default', scenesEnergyDemandBoxComponent);
        }
    };
});

$__System.registerDynamic("9a", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<header class=\"main-header\">\t\n\t<a class=\"btn-left-arrow\" ui-sref=\"area.overview({siteId:currentSite.id,areaId:currentArea.id})\"></a>\n\t<a class=\"btn-plus right\" ui-sref=\"site-scenes({siteId:currentSite.id, newScene: true})\"></a>\n\t<h1 ng-bind=\"currentArea.name\"></h1>\n</header>\n\n<div class=\"overview-wrapper\">\n\t<div class=\"overview-container lc-pill-list scenes\">\n\t\t<div class=\"lc-pill\" ng-repeat=\"scene in scenes\" ng-click=\"gotoScene(scene)\">\n\t\t\t<i ng-if=\"scene.actions[0].systemType !== 'area'\" class=\"lc-svg chevron\">\n\t\t\t</i>\n\t\t\t<span class=\"pill-left\">\n\t\t\t\t<h1>{{scene.name}}</h1>\n\t\t\t</span>\n\t\t\t<span class=\"pill-center\">\n\t\t\t\t<span class=\"gray\" translate=\"scenes.demand\">Demand: </span>\n\t\t\t\t<span ng-if=\"!scene.placeholder\">{{scene.demand}}W of {{maxDemand}}W</span>\n\t\t\t\t<span ng-if=\"scene.placeholder\">{{scene.placeholder == 'on' ? maxDemand : 0}}W of {{maxDemand}}W</span>\n\t\t\t</span>\n\n\t\t\t<button class=\"btn black apply\" ng-click=\"apply(scene); $event.stopPropagation();\" translate=\"common.apply\">Apply</button>\n\t\t</div>\n\t</div>\n</div>";
});
$__System.register('9b', ['9a'], function (_export) {
    'use strict';

    var areaScenesListTemplate, areaScenesListComponent;
    return {
        setters: [function (_a) {
            areaScenesListTemplate = _a['default'];
        }],
        execute: function () {
            areaScenesListComponent = {
                template: areaScenesListTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    areaId: '@'
                },
                controllerAs: 'aS',
                controller: function controller(Scenes, Energy, Modals) {

                    var aS = this;

                    aS.$onInit = function () {
                        var areaZones = _.filter(aS.sessionData.zones, ['area', aS.areaId]);

                        aS.maxDemand = Number(Energy.getDemand(areaZones).maxDemand);

                        aS.scenes = Scenes.mapZonesEnergy(areaZones, aS.itemCollection);
                    };

                    aS.gotoScene = function (scene) {
                        if (scene.actions[0] && scene.actions[0].systemType == 'area') {
                            //Area wide scene - no access
                        } else {
                                $state.go('area.scenes.scene', { sceneId: scene.id });
                            }
                    };

                    aS.apply = function (scene) {
                        Modals.openLoad('Applying Scene');

                        Scenes.activate(scene.id).success(function (response) {
                            Modals.closeLoad('Scene Applied', true);
                        }).error(function () {
                            Modals.closeLoad('Scene Apply Failed');
                            getScenes();
                        });
                    };
                }
            };

            _export('default', areaScenesListComponent);
        }
    };
});

$__System.register('9c', ['11'], function (_export) {
    'use strict';

    var _, scenesTransform;

    return {
        setters: [function (_2) {
            _ = _2['default'];
        }],
        execute: function () {
            scenesTransform = {

                NewScene: function NewScene(siteId) {
                    this.site = siteId;
                    this.name = null;
                    this.actionZones = [];
                    this.editMode = true;
                },

                areaSceneCheck: function areaSceneCheck(scene) {
                    //If all Zones match the same area - we want to designate this scene an 'area scene'
                    //need to consider more cases for site wide scene
                    var sceneArea = scene.actionZones[0].area;

                    return _.every(scene.actionZones, ['area', sceneArea]) ? sceneArea : null;
                },

                mapActionZonesToScene: function mapActionZonesToScene(zones, showColor, showDim, showState) {
                    return _.map(zones, function (zone) {
                        var sharedAction = {
                            systemId: zone.id,
                            systemIdString: zone.id_string,
                            systemType: 'zone',
                            id: zone.existingActionId || null
                        };

                        if (showColor) {
                            _.extend(sharedAction, {
                                cct: zone.cct,
                                cct_transition_time: zone.cct_transition_time
                            });
                        }

                        if (showDim) {
                            _.extend(sharedAction, {
                                dimLevel: zone.reported_dim_level,
                                fade_time: zone.fade_time
                            });
                        }

                        if (showState) {
                            _.extend(sharedAction, {
                                lightsOn: zone.zone_state
                            });
                        }

                        return sharedAction;
                    });
                },

                mapSceneToBackend: function mapSceneToBackend(scene, showColor, showDim, showState) {
                    return {
                        actions: this.mapActionZonesToScene(scene.actionZones, showColor, showDim, showState),
                        area: this.areaSceneCheck(scene),
                        demand_response: scene.demand_response,
                        id: scene.id,
                        id_string: scene.name,
                        site: scene.site
                    };
                },

                zoneActionMapping: function zoneActionMapping(zone, action, areas, defaultCct) {

                    zone.existingActionId = action.id_state || action.id_cct;
                    zone.zone_state = action.lightsOn;
                    zone.reported_dim_level = action.dimLevel ? action.dimLevel : zone.reported_dim_level;
                    zone.fade_time = action.fade_time;

                    //
                    // CCT Extras - note - can't use "|| defaultCct.reported" here as we use cct===null to show/hide bar in non-cct scenes
                    //
                    zone.cct = action.cct;
                    zone.cct_transition_time = action.cct_transition_time || defaultCct.transition;

                    zone.min_cct = zone.min_cct || defaultCct.min;
                    zone.max_cct = zone.max_cct || defaultCct.max;

                    if (zone.area) {
                        var match = _.find(areas, ['id', zone.area]);
                        zone.areaName = match ? match.name : ''; //Some zones reference deleted areas;
                    }

                    return zone;
                }

            };

            _export('default', scenesTransform);
        }
    };
});

$__System.register('9d', [], function (_export) {
  'use strict';

  var scenesTitle, scenesParams, scenesStatesResolve, scenesStates;
  return {
    setters: [],
    execute: function () {
      scenesTitle = 'Scenes';
      scenesParams = {
        leftMenuSpecialContext: 'scenes',
        //
        // - This will prevent route change
        //
        // userSelectedFilter: {
        //   value: null,
        //   dynamic: true
        // },
        //
        'new': false,
        allowNew: true,
        extraSections: ['scenes']
      };
      scenesStatesResolve = {
        sessionData: function sessionData(Session) {
          console.log('Initial Session Data in Scenes Service');
          return Session.getSiteData(false);
        },
        itemCollection: function itemCollection(sessionData, StructureService, $stateParams) {
          return StructureService.itemCollection(sessionData, 'scenes', $stateParams);
        }
      };
      scenesStates = [{
        parent: 'site',
        name: "Scenes",
        url: '/scenes/{userSelectedFilter}?edit',
        resolve: scenesStatesResolve,

        component: 'scenesBase',

        params: scenesParams,

        title: scenesTitle
      }, {
        //
        // Cover legacy routes
        //
        parent: 'site',
        name: "SiteScenes",
        url: '/scenes/{userSelectedFilter}',
        resolve: scenesStatesResolve,

        component: 'scenesBase',

        params: scenesParams,

        title: scenesTitle
      }, {
        parent: 'site',
        name: "AreaScenes",
        url: '/overview/{userSelectedFilter}/scenes',
        resolve: {
          itemCollection: function itemCollection($stateParams, $state$, $transition$, initialSessionData, initialSelectedIds, StructureService, Scenes) {
            //
            // Use the zone collection to then return scenes associated with said zones..
            //
            var relevantZones = StructureService.itemCollection($transition$, initialSessionData, 'zones');

            _.each(relevantZones, function (zone) {
              //Show relevant zones
            });

            return relevantZones;
          }
        },

        component: 'areaScenes',

        params: scenesParams,

        title: scenesTitle
      }];

      _export('default', scenesStates);
    }
  };
});

$__System.register('9e', ['3', '92', '94', '96', '97', '98', '99', '9b', '9c', '9d'], function (_export) {
    //, legacySceneStates

    'use strict';

    var angular, ScenesService, scenesBaseComponent, sceneBodyComponent, sceneZoneControlComponent, sceneZoneControlSettingComponent, scenesEnergyDemandBoxComponent, areaScenesComponent, scenesTransformValue, scenesStates, scenesModule;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_3) {
            ScenesService = _3['default'];
        }, function (_4) {
            scenesBaseComponent = _4['default'];
        }, function (_5) {
            sceneBodyComponent = _5['default'];
        }, function (_6) {
            sceneZoneControlComponent = _6['default'];
        }, function (_7) {
            sceneZoneControlSettingComponent = _7['default'];
        }, function (_8) {
            scenesEnergyDemandBoxComponent = _8['default'];
        }, function (_b) {
            areaScenesComponent = _b['default'];
        }, function (_c) {
            scenesTransformValue = _c['default'];
        }, function (_d) {
            scenesStates = _d['default'];
        }],
        execute: function () {
            scenesModule = angular.module('scenes', []).service('Scenes', ScenesService).component('scenesBase', scenesBaseComponent).component('scenesEnergyDemandBox', scenesEnergyDemandBoxComponent).component('sceneBody', sceneBodyComponent).component('sceneZoneControl', sceneZoneControlComponent).component('sceneZoneControlSetting', sceneZoneControlSettingComponent).component('areaScenes', areaScenesComponent).value('scenesTransform', scenesTransformValue).config(['$stateRegistryProvider', function ($stateRegistry) {
                _.each(scenesStates, function (state) {
                    $stateRegistry.register(state);
                });
            }]);

            _export('default', scenesModule);
        }
    };
});

$__System.register('9f', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, ShowsService;

  return {
    setters: [function (_2) {
      _createClass = _2['default'];
    }, function (_3) {
      _classCallCheck = _3['default'];
    }],
    execute: function () {
      /*
      
          Basic interface for concept of 'Ligthshows' -  see /wiki/spaces/LC/pages/2581364737
      
          'Show' is really a 'show group' - which in this implementation is just a list of lcshow devices...
      
          A 'program' is a preconfigured light animation which is triggered for a duration against a show group with controlShowGroup()
      
          Assumption is to roll this into /scenes/
      
       */
      'use strict';

      ShowsService = (function () {
        function ShowsService($http, Energy, Track, LcCache, LcFn, _) {
          _classCallCheck(this, ShowsService);

          this.$http = $http;
          this.Energy = Energy;
          this.Track = Track;
          this.LcCache = LcCache;
          this.LcFn = this.LcFn;

          this.NewShowGroup = function (siteId, gatewayId) {
            this.site = siteId;
            this.gateway = gatewayId;
            this.name = null;
            this.program = null;
            //
            // Default duration 60 ?
            //
            this.duration = 60;
            this.nodes = [];
            this['new'] = true;
          };

          this.showGroupResponseMapping = function (show) {
            return show;
          };

          this.showGroupUpdateRequestMapping = function (showGroup) {
            return {
              id: showGroup.id,
              duration: parseInt(showGroup.duration),
              gateway: showGroup.gateway,
              name: showGroup.name,
              nodes: _.map(showGroup.devices, 'id'),
              site: showGroup.site,
              program: showGroup.program
            };
          };
        }

        _createClass(ShowsService, [{
          key: 'getShowGroup',
          value: function getShowGroup(groupId) {
            var _this = this;

            return this.$http({
              url: 'lightshow/group/' + groupId + '/'
            }).then(function (response) {
              return _this.showGroupResponseMapping(response.data);
            });
          }
        }, {
          key: 'getShowGroupsBySite',
          value: function getShowGroupsBySite(siteId) {
            var _this2 = this;

            return this.$http({
              url: 'lightshow/site/' + siteId + '/group/'
            }).then(function (response) {
              return _this2.showGroupResponseMapping(response.data);
            });
          }
        }, {
          key: 'getAllPrograms',
          value: function getAllPrograms() {
            return this.$http({
              url: 'lightshow/program/'
            }).then(function (response) {
              return response.data;
            })['catch'](function (error) {
              return error;
            });
          }
        }, {
          key: 'getProgram',
          value: function getProgram(programId) {
            return this.$http({
              url: 'lightshow/program/' + programId + '/'
            }).then(function (response) {
              return response.data;
            });
          }
        }, {
          key: 'createShowGroup',
          value: function createShowGroup(show) {
            var _this3 = this;

            //
            // Tony CRUD wants side id in path
            //
            return this.$http({
              url: 'lightshow/site/' + show.site + '/group/',
              method: 'POST',
              data: this.showGroupUpdateRequestMapping(show)
            }).then(function (response) {
              _this3.LcCache.updateSessionSiteSectionChild('shows', [_this3.showGroupResponseMapping(response.data)]);
              _this3.Track.event('Show: Created', 'Show ' + show.name);

              return _this3.showGroupResponseMapping(response.data);
            });
          }
        }, {
          key: 'delShowGroup',
          value: function delShowGroup(show) {
            var _this4 = this;

            return this.$http({
              url: 'lightshow/group/' + show.id + '/',
              method: 'DELETE'
            }).success(function () {
              _this4.LcCache.removeSessionSiteSectionChild('shows', [show]);
              _this4.Track.event('Show: Deleted', 'Show ' + show.name);
            });
          }
        }, {
          key: 'updateShowGroup',
          value: function updateShowGroup(show) {
            var _this5 = this;

            return this.$http({
              url: 'lightshow/group/' + show.id + '/',
              method: 'PUT',
              data: this.showGroupUpdateRequestMapping(show)
            }).then(function () {
              _this5.LcCache.updateSessionSiteSectionChild('shows', [show]);
            });
          }
        }, {
          key: 'controlShowGroup',
          value: function controlShowGroup(groupId, programId, startStop, duration) {
            var _this6 = this;

            return this.$http({
              url: 'lightshow/command/',
              method: 'POST',
              data: {
                'group': groupId,
                'begin_show': startStop,
                'program_id': parseInt(programId),
                'duration': parseInt(duration)
              }
            }).success(function () {
              _this6.Track.event('Show: Activated', 'Show Group Id: ' + groupId);
            });
          }
        }]);

        return ShowsService;
      })();

      _export('default', ShowsService);
    }
  };
});

$__System.registerDynamic("a0", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"shows\">\n    <!-- \n        /shows/ View option A (Base) - Nothing selected - Welcome\n    -->\n\n    <div ng-if=\"!sHB.itemCollection.filtered\">\n        <div class=\"welcome-screen\" ng-if=\"!sHB.blankShowGroup\">\n            <h1 translate=\"common.shows\">Shows</h1>\n            <h2 translate=\"shows.selectDevice\">Select an LcShow Device to view and activate shows</h2>\n            <div class=\"setup-mode\" translate=\"shows.askRABConfigure\">Ask your RAB Customer Service representative to configure your exisiting shows</div>\n        </div>\n\n        <show-body \n            ng-if=\"sHB.blankShowGroup && sHB.isOrgAdmin\" \n            areas=\"sHB.sessionData.areas\"\n            devices=\"sHB.devices\" \n            is-admin=\"sHB.isOrgAdmin\"\n            is-super-user=\"sHB.isSuperUser\"   \n            programs=\"sHB.programs\" \n            show-group=\"sHB.blankShowGroup\"\n            on-crud=\"sHB.navigate(destinationId)\"\n        ></show-body>\n\n        <!-- Only allow super users to add new / edit existing shows -->\n        <div class=\"welcome-screen\" ng-if=\"sHB.blankShowGroup && !sHB.isOrgAdmin\">\n            <h1 translate=\"common.shows\">Shows</h1>\n            <div class=\"setup-mode\" translate=\"shows.askRABaddNew\">Please ask your organization's administrator to add new shows</div>\n        </div>\n    </div>\n\n    <!-- \n        /shows/ View option B - Single LcShow device selected control\n    -->\n    <show-body \n        ng-if=\"sHB.selectedShowGroup\" \n        areas=\"sHB.sessionData.areas\"\n        devices=\"sHB.devices\" \n        is-admin=\"sHB.isOrgAdmin\" \n        is-super-user=\"sHB.isSuperUser\"   \n        programs=\"sHB.programs\" \n        show-group=\"sHB.selectedShowGroup\" \n        on-crud=\"sHB.navigate(destinationId)\"\n    ></show-body>\n\n    <!-- \n        /shows/ View option C - group selection options\n    -->\n    <div ng-if=\"sHB.groupSelection\">\n        <section class=\"main-left\">\n            <h2 class=\"overview-heading\">\n                <span>Group Actions</span>\n            </h2>\n\n            <div class=\"left\">\n                <button class=\"btn orange delete\" ng-click=\"sHB.deleteGroup(sHB.groupSelection)\">Delete Group</button>\n            </div>\n        </section>\n\n        <show-body \n            ng-if=\"sHB.selectedShowGroup\" \n            areas=\"sHB.sessionData.areas\"\n            devices=\"sHB.devices\" \n            is-admin=\"sHB.isOrgAdmin\" \n            is-super-user=\"sHB.isSuperUser\"  \n            programs=\"sHB.programs\" \n            show-group=\"sHB.selectedShowGroup\"\n            on-crud=\"sHB.navigate(destinationId)\"\n        ></show-body>\n\n    </div>\n</div>";
});
$__System.register('a1', ['a0'], function (_export) {
    'use strict';

    var showsBaseTemplate, showsBaseComponent;
    return {
        setters: [function (_a0) {
            showsBaseTemplate = _a0['default'];
        }],
        execute: function () {
            showsBaseComponent = {
                template: showsBaseTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    user: '<',
                    onClearToBase: '&',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'sHB',
                controller: function controller(LcFn, $state, $scope, $q, Modals, Shows, _) {

                    var sHB = this;

                    sHB.$onInit = function () {
                        sHB.isOrgAdmin = LcFn.isOrgAdmin(sHB.user, sHB.sessionData.org);
                        sHB.isSuperUser = sHB.user.is_superuser;

                        sHB.devices = angular.copy(sHB.sessionData.devices);
                        sHB.programs = angular.copy(sHB.sessionData.programs);

                        sHB.onSelectionUpdate({ selection: sHB.itemCollection });

                        prepareViewContext(sHB.devices);
                    };

                    sHB.$onChanges = function (changes) {
                        //
                    };

                    sHB.navigate = function (destinationId) {
                        //go to that show after creation
                        var filter = destinationId ? ['selection~' + destinationId] : null;

                        if (filter) {
                            $state.go('Shows', { siteId: sHB.sessionData.id, userSelectedFilter: filter });
                        } else {
                            sHB.onClearToBase();
                        }
                    };

                    sHB.deleteGroup = function (group) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + group.length + '</strong> shows?').then(function () {

                            Modals.openLoad('Deleting Shows');

                            var showsToDelete = [];

                            _.each(group, function (show) {
                                showsToDelete.push(Shows.del(show));
                            });

                            $q.all(showsToDelete).then(function () {
                                Modals.closeLoad('Shows Deleted', true);
                                sHB.navigate();
                            }, function () {
                                //Failures handled here
                            });
                        });
                    };

                    function prepareViewContext(devices) {
                        //Base View if filtered false
                        if (sHB.itemCollection.filtered) {
                            if (sHB.itemCollection.group.length > 1) {
                                sHB.groupSelection = sHB.itemCollection.group;
                            } else {
                                sHB.selectedShowGroup = prepareShow(sHB.itemCollection.group[0], devices);
                            }
                        }

                        if (sHB.itemCollection['new']) {
                            sHB.blankShowGroup = new Shows.NewShowGroup(sHB.sessionData.id, getGatewayID(sHB.sessionData.gateways));
                        }
                    }

                    function getGatewayID(gateways) {
                        //
                        // Not sure how we are supposed to handle multi gateway selection for LcShow or why the gateway ID is needed
                        // Use first gateway ID for now
                        //
                        return gateways[0] ? gateways[0].id : null;
                    }

                    function prepareShow(show, devices) {
                        //
                        // No validation on BE for deleted devices, need to handle that here - will just filter them out for now
                        //
                        show.devices = _.filter(_.map(show.nodes, function (nodeId) {
                            return _.find(devices, { id: nodeId });
                        }), 'id');

                        return show;
                    }
                }
            };

            _export('default', showsBaseComponent);
        }
    };
});

$__System.registerDynamic("a2", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"recur-schedules\">\n    <section class=\"main-left\" ng-if=\"sBO.isAdmin\">\n        <h2 class=\"overview-heading\">\n            <span translate=\"common.actions\">Actions</span>\n        </h2>\n\n        <div class=\"left\">\n            <button class=\"btn edit blue\" ng-if=\"sBO.showGroup.id && !sBO.editMode\" ng-click=\"sBO.toggleEdit(sBO.showGroup)\" translate=\"common.edit\">Edit</button>\n            <button class=\"btn rename\" ng-if=\"sBO.showGroup.id\" ng-click=\"sBO.rename(sBO.showGroup)\" ng-disabled=\"sBO.ajaxPending || sBO.showGroup.isDefaultShow\" translate=\"common.rename\">Rename</button>\n            <button class=\"btn orange delete\" ng-if=\"sBO.showGroup.id\" ng-click=\"sBO.deleteShowGroup(sBO.showGroup)\" translate=\"common.delete\">Delete</button>\n            <button class=\"btn blue save\" ng-if=\"sBO.editMode\" ng-click=\"sBO.save(sBO.showGroup)\" ng-disabled=\"sBO.ajaxPending || sBO.showGroup.devices.length == 0\" translate>{{sBO.ajaxPending? 'common.saving' : 'common.save'}}</button>\n        </div>\n\n    </section>\n\n\n    <section class=\"main-body\">\n        <h2 class=\"overview-heading\">\n            <span translate=\"shows.controlShow\">Control Show</span>\n        </h2>\n\n        <show-group-control-box programs=\"sBO.programs\" is-admin=\"sBO.isAdmin\" show-group-duration=\"sBO.showGroup.duration\" show-group-id=\"sBO.showGroup.id\" show-group-program-id=\"sBO.showGroup.program\" on-change=\"sBO.propUpdate(sBO.showGroup,propKey,propVal);\"></show-group-control-box>\n    </section>\n\n    <section class=\"main-body\">\n        <h2 class=\"overview-heading drop\" ng-class=\"{dropped: sBO.drop}\" ng-click=\"sBO.drop = !sBO.drop;\">\n            <span translate=\"common.devices\">Devices</span> \n        </h2>\n    </section>\n\n    <section class=\"main-body no-padding light-gray\" ng-if=\"sBO.drop\"> \n        <section class=\"smart-schedule-zone\" ng-repeat=\"device in sBO.showGroup.devices\">\n            <div class=\"event-group\">\n                <ul class=\"schedule-events\">\n                    <li>\n                        <div class=\"event\">\n                            <button class=\"btn-select remove recur\" ng-if=\"sBO.editMode\" ng-click=\"sBO.removeItem(device);\"></button>\n                            \n                            <div class=\"event-item\">\n                                <div class=\"event-item-container zone-special\">\n                                    <div class=\"overview-zone event-zone\">\n                                        <div class=\"zone-control\">\n                                            <span class=\"zone-name\">\n                                                {{::device.settings.id_string}}\n                                            </span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </section>\n\n        <span ng-if=\"sBO.showGroup.devices.length < 1 && !sBO.editMode\">No Zones</span>\n    </section>\n\n    <section class=\"main-body\" ng-if=\"sBO.drop\">\n        <div class=\"white-pill-item no-icon short\" ng-if=\"sBO.editMode\">\n            <button class=\"btn black btn-white-plus large\" ng-click=\"sBO.selectObject(sBO.showGroup.devices);\"></button>\n            <h1 class=\"name\" translate=\"shows.addDevice\">Add Device</h1>\n        </div>\n    </section>\n</div>";
});
$__System.register('a3', ['a2'], function (_export) {
    'use strict';

    var showBodyTemplate, showBodyComponent;
    return {
        setters: [function (_a2) {
            showBodyTemplate = _a2['default'];
        }],
        execute: function () {
            showBodyComponent = {
                template: showBodyTemplate,
                bindings: {
                    areas: '<',
                    devices: '<',
                    isAdmin: '<',
                    isSuperUser: '<',
                    programs: '<',
                    showGroup: '<',
                    onCrud: '&'
                },
                controllerAs: 'sBO',
                controller: function controller($rootScope, $scope, $q, Shows, Modals, LcFn, $timeout, _) {
                    // @refactor - used to broadcast 'animatebars' which was a hack
                    var sBO = this;

                    sBO.$onInit = function () {
                        //
                        // Default to edit mode for now - makes interaction with the show control more intuitive - now for admin only
                        //
                        if (sBO.isAdmin) {
                            sBO.editMode = true;
                        }

                        //
                        if (sBO.showGroup['new']) {
                            sBO.editMode = true;
                            sBO.drop = true;
                        }
                    };

                    sBO.$onDestroy = function () {
                        //
                    };

                    sBO.toggleEdit = function (show) {
                        sBO.editMode = !sBO.editMode;
                    };

                    sBO.rename = function (show) {
                        promptModal('Rename', show);
                    };

                    sBO.save = function (show) {
                        if (show.id) {
                            saveShow(show);
                        } else {
                            promptModal(show.demand ? 'Demand Name' : 'Show Name', show);
                        }
                    };

                    sBO.deleteShowGroup = function (show) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete this show?').then(function () {
                            Modals.openLoad('Deleting Show');

                            return Shows.delShowGroup(show).success(function (result) {
                                Modals.closeLoad('Show Deleted', true);

                                sBO.onCrud({ destinationId: null });
                            }).error(function (error) {
                                Modals.closeLoad('Show Delete Failed');
                            });
                        });
                    };

                    sBO.removeItem = function (item) {
                        return sBO.showGroup.devices.splice(sBO.showGroup.devices.indexOf(item), 1);
                    };

                    sBO.selectObject = function () {
                        function filterDevices(devices) {
                            return devices.filter(function (device) {
                                return device.device_type.lcp_type === "57";
                            });
                        }

                        var lcShowDevices = filterDevices(sBO.devices);

                        var areas = _.map(sBO.areas, function (area) {
                            area.zones = _.filter(lcShowDevices, { area: area.id });
                            return area;
                        });

                        // - Add unassigned zones to their own category
                        var noAreaDevices = _.filter(lcShowDevices, { area: null });

                        if (noAreaDevices.length) {
                            areas.push({
                                name: 'No Area',
                                zones: noAreaDevices
                            });
                        }

                        var allItems = [{
                            type: 'zones',
                            areas: areas,
                            selected: _.filter(lcShowDevices, function (device) {
                                return _.find(sBO.showGroup.devices, { 'id': device.id });
                            })
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Devices', 'site-shows').then(function (items) {
                            sBO.showGroup.devices = items;
                        });
                    };

                    sBO.propUpdate = function (target, propKey, propVal) {
                        //
                        target[propKey] = propVal;
                    };

                    function promptModal(title, show) {
                        Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: show,
                                cleanObject: sBO.cleanShow,
                                title: title,
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                saveShow(show);
                            }
                        });
                    }

                    function saveShow(show) {
                        function finish(show) {
                            show.editMode = false;

                            $timeout(function () {
                                $rootScope.$broadcast('animateBars');
                            });

                            Modals.closeLoad('Show Saved', true);
                        }

                        Modals.openLoad('Saving Show');

                        return show.id === undefined ? Shows.createShowGroup(show).then(function (savedShow) {
                            finish(show);
                            sBO.onCrud({ destinationId: savedShow.id });
                        })['catch'](function () {
                            //400 Returned with ugly error msg - assuming its a show name collision
                            Modals.closeLoad('Show Save Failed - Name Already Exists');
                        }) : Shows.updateShowGroup(show).then(function (response) {
                            $rootScope.$broadcast('event:cache-update:renameItem', show);
                            finish(show);
                        })['catch'](function () {
                            Modals.closeLoad('Show Update Failed');
                        });
                    }
                }
            };

            _export('default', showBodyComponent);
        }
    };
});

$__System.register('a4', [], function (_export) {
    'use strict';

    var showGroupControlBoxComponent;
    return {
        setters: [],
        execute: function () {
            showGroupControlBoxComponent = {
                template: '\n        <div class="white-pill-item control-show">\n\n            <button class="btn btn-play right" ng-click="sGCB.toggleShow(sGCB.showGroupId, sGCB.selectedProgram.id, true, sGCB.showGroupDuration);" ng-disabled="sGCB.ajaxPending">Begin Show</button>\n\n            <div class="program-name left">\n              <div class="lc-select">\n                  <select\n                      ng-disabled="!sGCB.isAdmin"\n                      ng-model="sGCB.selectedProgram" \n                      ng-change="sGCB.setSelectedProgram(sGCB.selectedProgram)"\n                      ng-options="program as program.name for program in sGCB.programs"\n                      class="no-user-styles"\n                  ></select>\n              </div>\n            </div>\n\n            <div class="program-timeout">\n              <div class="device-details-group quarter">\n                  <input \n                    class="num-input-temp" \n                    string-to-number="" \n                    type="number" \n                    ng-min="1" \n                    ng-max="65535" \n                    min="1" \n                    max="65535" \n                    placeholder="60"\n                    ng-disabled="!sGCB.isAdmin"\n                    ng-model="sGCB.showGroupDuration" \n                    ng-change="sGCB.onChange({propKey: \'duration\', propVal: sGCB.showGroupDuration})"\n                  ><span>seconds</span>\n              </div>\n            </div>\n\n        </div>\n    ',
                bindings: {
                    isAdmin: '<',
                    programs: '<',
                    showGroupDuration: '<',
                    showGroupId: '<',
                    showGroupProgramId: '<',
                    onChange: '&',
                    onToggle: '&'
                },
                controllerAs: 'sGCB',
                controller: function controller(Shows) {
                    var sGCB = this;

                    sGCB.$onInit = function () {
                        //
                    };

                    sGCB.$onDestroy = function () {
                        //
                    };

                    sGCB.$onChanges = function (changes) {
                        //
                        if (changes && changes.showGroupProgramId && changes.programs) {
                            prepareProgramList(changes.programs.currentValue, changes.showGroupProgramId.currentValue);
                        }
                    };

                    sGCB.toggleShow = function (showGroupId, showGroupProgramId, begin, showGroupDuration) {
                        sGCB.ajaxPending = true;

                        Shows.controlShowGroup(showGroupId, showGroupProgramId, begin, showGroupDuration)['finally'](function () {
                            sGCB.ajaxPending = false;
                        });
                    };

                    sGCB.setSelectedProgram = function (program) {
                        //
                        sGCB.selectedProgram = program;
                        sGCB.onChange({ propKey: 'program', propVal: program.id });
                    };

                    function prepareProgramList(programs, showGroupProgramId) {
                        if (showGroupProgramId) {
                            sGCB.setSelectedProgram(_.find(programs, { id: showGroupProgramId }));
                        } else {
                            //
                            // Use first returned as default, ideally we will remember the last used?
                            //
                            sGCB.setSelectedProgram(programs[0]);
                        }
                    }
                }
            };

            _export('default', showGroupControlBoxComponent);
        }
    };
});

$__System.register('a5', [], function (_export) {
  'use strict';

  var showsTitle, showsParams, showsStatesResolve, showsStates;
  return {
    setters: [],
    execute: function () {
      showsTitle = 'Shows';
      showsParams = {
        leftMenuSpecialContext: 'shows',
        //
        // - This will prevent route change
        //
        // userSelectedFilter: {
        //   value: null,
        //   dynamic: true
        // },
        //
        'new': false,
        allowNew: true,
        extraSections: ['programs', 'shows']
      };
      showsStatesResolve = {
        sessionData: function sessionData(Session) {
          console.log('Initial Session Data in Shows Service');
          return Session.getSiteData(false);
        },
        itemCollection: function itemCollection(sessionData, StructureService, $stateParams) {
          return StructureService.itemCollection(sessionData, 'shows', $stateParams);
        }
      };
      showsStates = [{
        parent: 'site',
        name: 'Shows',
        url: '/shows/{userSelectedFilter}',
        resolve: showsStatesResolve,

        component: 'showsBase',

        params: showsParams,

        title: showsTitle
      }];

      _export('default', showsStates);
    }
  };
});

$__System.register('a6', ['3', '9f', 'a1', 'a3', 'a4', 'a5'], function (_export) {
    //, legacyShowStates

    'use strict';

    var angular, ShowsService, showsBaseComponent, showBodyComponent, showGroupControlBoxComponent, showsStates, showsModule;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_f) {
            ShowsService = _f['default'];
        }, function (_a1) {
            showsBaseComponent = _a1['default'];
        }, function (_a3) {
            showBodyComponent = _a3['default'];
        }, function (_a4) {
            showGroupControlBoxComponent = _a4['default'];
        }, function (_a5) {
            showsStates = _a5['default'];
        }],
        execute: function () {
            showsModule = angular.module('shows', []).service('Shows', ShowsService).component('showsBase', showsBaseComponent).component('showBody', showBodyComponent).component('showGroupControlBox', showGroupControlBoxComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                _.each(showsStates, function (state) {
                    $stateRegistry.register(state);
                });
            }]);

            _export('default', showsModule);
        }
    };
});

$__System.register('a7', [], function (_export) {
    'use strict';

    function Search($http, _) {

        this.fullText = function (query) {
            return $http({
                url: 'audit/query_full_text_index/',
                method: 'POST',
                data: { user_search_text: query }
            }).then(function (result) {
                //
                // Angular will loose our order/ranking without this mapping (alphabetical)
                //
                return _.map(result.data, function (group, groupName) {
                    return {
                        name: groupName,
                        group: group
                    };
                });
            });
        };
    }

    return {
        setters: [],
        execute: function () {
            Search.$inject = ['$http', '_'];
            _export('default', Search);
        }
    };
});

$__System.register('a8', ['3', 'a7'], function (_export) {
    'use strict';

    var angular, searchService, searchModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_a7) {
            searchService = _a7['default'];
        }],
        execute: function () {
            searchModule = angular.module('search', []).service('Search', searchService);

            _export('default', searchModule);
        }
    };
});

$__System.registerDynamic('a9', [], true, function ($__require, exports, module) {
  /* */
  "format cjs";

  var global = this || self,
      GLOBAL = global;
  var isDefined = angular.isDefined,
      isUndefined = angular.isUndefined,
      isNumber = angular.isNumber,
      isObject = angular.isObject,
      isArray = angular.isArray,
      extend = angular.extend,
      toJson = angular.toJson;

  angular.module('LocalStorageModule', []).provider('localStorageService', function () {
    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
    // With provider you can use config as this:
    // myApp.config(function (localStorageServiceProvider) {
    //    localStorageServiceProvider.prefix = 'yourAppName';
    // });
    this.prefix = 'ls';

    // You could change web storage type localstorage or sessionStorage
    this.storageType = 'localStorage';

    // Cookie options (usually in case of fallback)
    // expiry = Number of days before cookies expire // 0 = Does not expire
    // path = The web path the cookie represents
    this.cookie = {
      expiry: 30,
      path: '/'
    };

    // Send signals for each of the following actions?
    this.notify = {
      setItem: true,
      removeItem: false
    };

    // Setter for the prefix
    this.setPrefix = function (prefix) {
      this.prefix = prefix;
      return this;
    };

    // Setter for the storageType
    this.setStorageType = function (storageType) {
      this.storageType = storageType;
      return this;
    };

    // Setter for cookie config
    this.setStorageCookie = function (exp, path) {
      this.cookie.expiry = exp;
      this.cookie.path = path;
      return this;
    };

    // Setter for cookie domain
    this.setStorageCookieDomain = function (domain) {
      this.cookie.domain = domain;
      return this;
    };

    // Setter for notification config
    // itemSet & itemRemove should be booleans
    this.setNotify = function (itemSet, itemRemove) {
      this.notify = {
        setItem: itemSet,
        removeItem: itemRemove
      };
      return this;
    };

    this.$get = ['$rootScope', '$window', '$document', '$parse', function ($rootScope, $window, $document, $parse) {
      var self = this;
      var prefix = self.prefix;
      var cookie = self.cookie;
      var notify = self.notify;
      var storageType = self.storageType;
      var webStorage;

      // When Angular's $document is not available
      if (!$document) {
        $document = document;
      } else if ($document[0]) {
        $document = $document[0];
      }

      // If there is a prefix set in the config lets use that with an appended period for readability
      if (prefix.substr(-1) !== '.') {
        prefix = !!prefix ? prefix + '.' : '';
      }
      var deriveQualifiedKey = function (key) {
        return prefix + key;
      };
      // Checks the browser to see if local storage is supported
      var browserSupportsLocalStorage = function () {
        try {
          var supported = storageType in $window && $window[storageType] !== null;

          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
          // is available, but trying to call .setItem throws an exception.
          //
          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
          // that exceeded the quota."
          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
          if (supported) {
            webStorage = $window[storageType];
            webStorage.setItem(key, '');
            webStorage.removeItem(key);
          }

          return supported;
        } catch (e) {
          storageType = 'cookie';
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return false;
        }
      }();

      // Directly adds a value to local storage
      // If local storage is not available in the browser use cookies
      // Example use: localStorageService.add('library','angular');
      var addToLocalStorage = function (key, value) {
        // Let's convert undefined values to null to get the value consistent
        if (isUndefined(value)) {
          value = null;
        } else {
          value = toJson(value);
        }

        // If this browser does not support local storage use cookies
        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }

          if (notify.setItem) {
            $rootScope.$broadcast('LocalStorageModule.notification.setitem', { key: key, newvalue: value, storageType: 'cookie' });
          }
          return addToCookies(key, value);
        }

        try {
          if (webStorage) {
            webStorage.setItem(deriveQualifiedKey(key), value);
          }
          if (notify.setItem) {
            $rootScope.$broadcast('LocalStorageModule.notification.setitem', { key: key, newvalue: value, storageType: self.storageType });
          }
        } catch (e) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return addToCookies(key, value);
        }
        return true;
      };

      // Directly get a value from local storage
      // Example use: localStorageService.get('library'); // returns 'angular'
      var getFromLocalStorage = function (key) {

        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }

          return getFromCookies(key);
        }

        var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
        // angular.toJson will convert null to 'null', so a proper conversion is needed
        // FIXME not a perfect solution, since a valid 'null' string can't be stored
        if (!item || item === 'null') {
          return null;
        }

        try {
          return JSON.parse(item);
        } catch (e) {
          return item;
        }
      };

      // Remove an item from local storage
      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
      var removeFromLocalStorage = function () {
        var i, key;
        for (i = 0; i < arguments.length; i++) {
          key = arguments[i];
          if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            }

            if (notify.removeItem) {
              $rootScope.$broadcast('LocalStorageModule.notification.removeitem', { key: key, storageType: 'cookie' });
            }
            removeFromCookies(key);
          } else {
            try {
              webStorage.removeItem(deriveQualifiedKey(key));
              if (notify.removeItem) {
                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
                  key: key,
                  storageType: self.storageType
                });
              }
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
              removeFromCookies(key);
            }
          }
        }
      };

      // Return array of keys for local storage
      // Example use: var keys = localStorageService.keys()
      var getKeysForLocalStorage = function () {

        if (!browserSupportsLocalStorage) {
          $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          return false;
        }

        var prefixLength = prefix.length;
        var keys = [];
        for (var key in webStorage) {
          // Only return keys that are for this app
          if (key.substr(0, prefixLength) === prefix) {
            try {
              keys.push(key.substr(prefixLength));
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
              return [];
            }
          }
        }
        return keys;
      };

      // Remove all data for this app from local storage
      // Also optionally takes a regular expression string and removes the matching key-value pairs
      // Example use: localStorageService.clearAll();
      // Should be used mostly for development purposes
      var clearAllFromLocalStorage = function (regularExpression) {

        // Setting both regular expressions independently
        // Empty strings result in catchall RegExp
        var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
        var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();

        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }
          return clearAllFromCookies();
        }

        var prefixLength = prefix.length;

        for (var key in webStorage) {
          // Only remove items that are for this app and match the regular expression
          if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
            try {
              removeFromLocalStorage(key.substr(prefixLength));
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
              return clearAllFromCookies();
            }
          }
        }
        return true;
      };

      // Checks the browser to see if cookies are supported
      var browserSupportsCookies = function () {
        try {
          return $window.navigator.cookieEnabled || "cookie" in $document && ($document.cookie.length > 0 || ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1);
        } catch (e) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return false;
        }
      }();

      // Directly adds a value to cookies
      // Typically used as a fallback is local storage is not available in the browser
      // Example use: localStorageService.cookie.add('library','angular');
      var addToCookies = function (key, value, daysToExpiry) {

        if (isUndefined(value)) {
          return false;
        } else if (isArray(value) || isObject(value)) {
          value = toJson(value);
        }

        if (!browserSupportsCookies) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
          return false;
        }

        try {
          var expiry = '',
              expiryDate = new Date(),
              cookieDomain = '';

          if (value === null) {
            // Mark that the cookie has expired one day ago
            expiryDate.setTime(expiryDate.getTime() + -1 * 24 * 60 * 60 * 1000);
            expiry = "; expires=" + expiryDate.toGMTString();
            value = '';
          } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
            expiryDate.setTime(expiryDate.getTime() + daysToExpiry * 24 * 60 * 60 * 1000);
            expiry = "; expires=" + expiryDate.toGMTString();
          } else if (cookie.expiry !== 0) {
            expiryDate.setTime(expiryDate.getTime() + cookie.expiry * 24 * 60 * 60 * 1000);
            expiry = "; expires=" + expiryDate.toGMTString();
          }
          if (!!key) {
            var cookiePath = "; path=" + cookie.path;
            if (cookie.domain) {
              cookieDomain = "; domain=" + cookie.domain;
            }
            $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
          }
        } catch (e) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return false;
        }
        return true;
      };

      // Directly get a value from a cookie
      // Example use: localStorageService.cookie.get('library'); // returns 'angular'
      var getFromCookies = function (key) {
        if (!browserSupportsCookies) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
          return false;
        }

        var cookies = $document.cookie && $document.cookie.split(';') || [];
        for (var i = 0; i < cookies.length; i++) {
          var thisCookie = cookies[i];
          while (thisCookie.charAt(0) === ' ') {
            thisCookie = thisCookie.substring(1, thisCookie.length);
          }
          if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
            var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
            try {
              return JSON.parse(storedValues);
            } catch (e) {
              return storedValues;
            }
          }
        }
        return null;
      };

      var removeFromCookies = function (key) {
        addToCookies(key, null);
      };

      var clearAllFromCookies = function () {
        var thisCookie = null,
            thisKey = null;
        var prefixLength = prefix.length;
        var cookies = $document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          thisCookie = cookies[i];

          while (thisCookie.charAt(0) === ' ') {
            thisCookie = thisCookie.substring(1, thisCookie.length);
          }

          var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
          removeFromCookies(key);
        }
      };

      var getStorageType = function () {
        return storageType;
      };

      // Add a listener on scope variable to save its changes to local storage
      // Return a function which when called cancels binding
      var bindToScope = function (scope, key, def, lsKey) {
        lsKey = lsKey || key;
        var value = getFromLocalStorage(lsKey);

        if (value === null && isDefined(def)) {
          value = def;
        } else if (isObject(value) && isObject(def)) {
          value = extend(value, def);
        }

        $parse(key).assign(scope, value);

        return scope.$watch(key, function (newVal) {
          addToLocalStorage(lsKey, newVal);
        }, isObject(scope[key]));
      };

      // Return localStorageService.length
      // ignore keys that not owned
      var lengthOfLocalStorage = function () {
        var count = 0;
        var storage = $window[storageType];
        for (var i = 0; i < storage.length; i++) {
          if (storage.key(i).indexOf(prefix) === 0) {
            count++;
          }
        }
        return count;
      };

      return {
        isSupported: browserSupportsLocalStorage,
        getStorageType: getStorageType,
        set: addToLocalStorage,
        add: addToLocalStorage, //DEPRECATED
        get: getFromLocalStorage,
        keys: getKeysForLocalStorage,
        remove: removeFromLocalStorage,
        clearAll: clearAllFromLocalStorage,
        bind: bindToScope,
        deriveKey: deriveQualifiedKey,
        length: lengthOfLocalStorage,
        cookie: {
          isSupported: browserSupportsCookies,
          set: addToCookies,
          add: addToCookies, //DEPRECATED
          get: getFromCookies,
          remove: removeFromCookies,
          clearAll: clearAllFromCookies
        }
      };
    }];
  });
});
$__System.registerDynamic('aa', ['a9'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('a9');
  module.exports = 'LocalStorageModule';
});
$__System.registerDynamic("ab", ["aa"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("aa");
});
$__System.register('ac', [], function (_export) {
	'use strict';

	function Session($rootScope, $window, $state, $q, moment, Local, /*Idle,*/LcCache, Modals, LcFn, SessionAdapter, _) {

		/*
  	Publics
   */

		this.getUrlParamsUserSelection = getUrlParamsUserSelection;

		this.setIdletime = setIdletime;
		this.goLastUrl = goLastUrl;

		this.getSiteData = getSiteData;
		this.getSitesList = getSitesList;

		this.lastNetworkUpdate = null;

		var prepareOrg = function prepareOrg(site) {
			//Now we set currentOrg for CS bar
			$rootScope.currentOrg = site.org;
		};

		/*
  	Fetches and caches site data, per session, per site.
   */

		function getUrlParamsUserSelection() {
			var cachedParams = LcCache.getUrlParams();

			var selection = { ids: [], groups: [], 'new': cachedParams['new'], allowNew: cachedParams.allowNew };
			var urlText = cachedParams.userSelectedFilter;

			if (urlText) {
				if (!isNaN(parseFloat(urlText))) {
					//
					// To maintain backward compatibility, single Id selections are preferenced
					//
					selection.ids = urlText;
				} else {
					if (urlText.indexOf('~') > -1) {
						var ids = urlText.split('selection~')[1].split(',')[0];
						var groups = urlText.split('groups~')[1] ? urlText.split('groups~')[1].split(',')[0] : null;

						if (ids) {
							selection.ids = _.map(ids.split('-'), function (id) {
								return parseInt(id);
							});
						}

						if (groups) {
							selection.groups = _.map(groups.split('-'));
						}
					}
				}
			}

			return selection;
		}

		function setIdletime(time) {
			//Idle.setIdle(time);
		}

		function goLastUrl() {
			var last = null;
			var user = Local.get('lcUser');

			if (Local.get('urlHistory')) {
				//History API 2
				var allHistory = Local.get('urlHistory');

				if (allHistory[Local.get('lcUser').username]) {
					last = allHistory[Local.get('lcUser').username];
				}
			} else if (Local.get('lastUrl')) {
				//Legacy
				last = Local.get('lastUrl');
			}

			if (last && last.url && !$rootScope.error && !(LcFn.nonSiteCallRoutes.indexOf(last.url) > -1)) {
				return $window.location.assign('#' + last.url); //BS Bug - see http://stackoverflow.com/questions/11784656/angularjs-location-not-changing-the-path
			} else {
					console.info('Cache Service: No last url - push us on');

					if (user.org) {
						checkLocalSiteList(user.org.uuid).then(function (list) {
							if (list[0]) {
								$state.go('Overview', { siteId: list[0].id, userSelectedFilter: null, leftMenuSpecialContext: 'default' });
							} else {
								$state.go('Home');
							}
						});
					} else {
						$state.go('Home');
					}
				}
		}

		/**
   * @public
   * @description Get session / site data
   * @param {Boolean} Site - We can call this from settings view for non-site related data
   * @param {Boolen} forceNetwork - force fresh call to server
   * @param {Array} extraSections - we call site/devices/zones/areas by default but nothing else,
   *                                can request scenes / schedules for any views needed
   * @return {Promise} siteData object
   */

		function getSiteData(forceNetwork, extraSections) {
			//
			// Here we can check a local store or cache flag to determine next move
			// a) Goto cache
			// b) Goto network
			//
			// For dev we can get fresh each time
			//

			console.log('Session getsitedata', forceNetwork, extraSections);

			return $q(function (resolve, reject) {
				//
				// Most Views require sitedata with some extras
				//  - Default: Site,Devices,Zones,Areas
				//	- Extras: Scenes,Schedules,Automations

				var targetId = parseInt(LcCache.getUrlParams().siteId);
				//here has issue that if jump from device to control,
				//left nav list won't refresh

				console.log('Socket disconnected: ', LcCache.socketConnectionBroken);

				if (!LcCache.getSessionSiteData() || forceNetwork || isNetworkStale()) {

					Modals.openLoad('Getting Site Data');

					networkSiteData(targetId, forceNetwork, extraSections).then(function (result) {

						console.log('Fresh from Session');
						//console.log(result)
						LcCache.setSessionSiteData(result);
						//
						// @remove
						//
						// When we've finally removed all $scope/$rootScope.currentSite we can axe this
						//
						tempCurrentScope(result);

						resolve(result);

						Modals.closeLoad('Site Data Loaded', true);
					})['catch'](function (error) {
						Modals.closeLoad('Error reaching server', false);

						reject(error);
					});
				} else {
					resolve(LcCache.getSessionSiteData());
				}
			});
		}

		function isNetworkStale() {
			//
			// Broken socket connection was causing a pointless double request,
			// unless last response from BE is stale - dont goto network again
			//
			// @todo - deal with long-term socket failures
			//
			return LcCache.socketConnectionBroken && moment().diff(Session.lastNetworkUpdate, 'seconds') > 5;
		}

		function tempCurrentScope(site) {
			$rootScope.currentSite = site;
		}

		// function updateSection(){ //+ Optional section arguments
		// 	var updateSections = arguments;
		// 	var updateSectionsReq = [];

		// 	_.each(updateSections, function(argument, key){
		// 		updateSectionsReq.push(SessionAdapter.fetchers[argument](LcCache.getSessionSiteData().id));
		// 	});

		// 	return $q.all(updateSectionsReq)
		//         .then(function(results){
		//         	_.each(results, (result,key) =>{
		//         		setSessionSiteSectionData(updateSections,result);
		//         	})
		//   		}, function(reason){
		//             // :(
		//         }
		//     );
		// }

		function networkSiteData(newId, forceNetwork, extraSections) {

			Session.lastNetworkUpdate = moment();

			var requests = [SessionAdapter.fetchers.site(newId, true), // Force cache bust for site req - setup_mode isn't getting invalided on backend
			SessionAdapter.fetchers.devices(newId), SessionAdapter.fetchers.zones(newId), SessionAdapter.fetchers.areas(newId)];

			//
			// If any extra sections requested - push to $q here
			//
			_.each(extraSections, function (section) {
				requests.push(SessionAdapter.fetchers[section](newId));
			});

			return $q.all(requests).then(function (result) {
				//
				// Default site data sections
				//

				var site = result[0][0];
				var devices = result[1];
				var zones = result[2];
				var areas = result[3];

				site.devices = SessionAdapter.renderers.devices(devices);
				site.zones = SessionAdapter.renderers.zones(zones, site.devices); //SessionAdapter.renderers.zones(zones,devices); //Devices sent for zoneDevice
				site.areas = SessionAdapter.renderers.areas(areas, site.zones); //zones sent for 'areaZones' - with func bindings

				//
				// Optional Extra sections
				//

				_.each(extraSections, function (section, key) {
					site[section] = SessionAdapter.renderers[section](result[key + 4]);
				});

				//
				// Resolve Site object soon as we can
				//
				if (site && site.id) {
					//
					// CS bar func, to remove eventually
					//
					prepareOrg(site);
				}

				return site;
			})['catch'](function (error) {
				if (error.status === 403) {
					//
					console.log('No auth - can we get this far?');
				} else if (error.status === 404) {
					// Missing Site
				} else {
						console.log('Site data retrieval error - no forced logout here');
						//Local.clearAll();
						//$state.go('login');

						//
						// - Close outstanding error modals (turn to promise chain eventually)
						//
						Modals.closeLoad('Error reaching server', false);
					}

				throw {
					text: error.statusText,
					status: error.status
				};
			});
		}

		function checkCacheBust(orgUuid, cacheBust, searchTerm) {
			return cacheBust ? ajaxOrgSites(orgUuid, true, searchTerm) : checkLocalSiteList(orgUuid, cacheBust, searchTerm);
		}

		function checkLocalSiteList(orgUuid, cacheBust, searchTerm) {
			return LcCache.getSessionSitesList(orgUuid) ? $q.resolve(LcCache.getSessionSitesList(orgUuid)) : ajaxOrgSites(orgUuid, cacheBust, searchTerm);
		}

		function ajaxOrgSites(orgUuid, cacheBust, searchTerm) {
			return SessionAdapter.fetchers.site(null, cacheBust, orgUuid, searchTerm);
		}

		// function checkWorkerOffload(cacheBust){
		// 	return indexedDbSupported() ? workerOffloadedSitesList(cacheBust) : SessionAdapter.fetchers.site(null,cacheBust);
		// }

		// function workerOffloadedSitesList(cacheBust){
		// 	var start = $window.performance.now(); console.info('TIMING: Indexing site list');

		// 	return Indexer.build(cacheBust).then(list => {
		// 		var end = $window.performance.now(), time = end - start; console.info('TIMING: Sites list indexed in: ', time/1000);
		// 		return list;//Return trimmed list (name,id);
		// 	}).catch(error =>{
		// 		console.log(error);
		// 		return SessionAdapter.fetchers.site(null,true); //WW fail - backup to AJAX
		// 	});
		// }

		//// ---------------------------------------------------
		//// @def Session.getSitesList()
		////
		//// Promises Sites list in correct order (current site at top)
		//// Only goes to server if forceNetwork is true
		////
		//// For super users (and browsers supporting indexedDB), we offload sites call to webworker (can be v slow)
		////
		//// ----------------------------------------------------

		function getSitesList(currentSiteId, orgUuid, cacheBust, searchTerm) {
			//All optional
			return checkCacheBust(orgUuid, cacheBust, searchTerm).then(function (list) {
				//
				//
				// @refactor - @rootscope remove
				//
				//
				//$rootScope.sites = orderSites(currentSiteId,list);

				var orderedList = LcFn.bringToFront(list, 'id', currentSiteId);

				LcCache.setSessionSitesList(orgUuid, orderedList);

				//$rootScope.$broadcast('event:updateSites',orgUuid);

				return orderedList;
			});
		}
	}

	return {
		setters: [],
		execute: function () {
			Session.$inject = ['$rootScope', '$window', '$state', '$q', 'moment', 'Local', /*'Idle',*/'LcCache', 'Modals', 'LcFn', 'SessionAdapter', '_'];
			_export('default', Session);
		}
	};
});

$__System.register('ad', ['13'], function (_export) {
	var _classCallCheck, SessionAdapter;

	return {
		setters: [function (_2) {
			_classCallCheck = _2['default'];
		}],
		execute: function () {
			'use strict';

			SessionAdapter = function SessionAdapter($window, $q, Sites, Orgs, Areas, Zones, Zone, Devices, Device, Scenes, Shows, RecurrenceSchedules, Automations, Settings, Users, Messages, _) {
				_classCallCheck(this, SessionAdapter);

				this.fetchers = {
					site: function site(id, cacheBust, filterUuid, searchTerm) {
						var start = $window.performance.now();console.info('TIMING: Fetching site ' + (id || 'list')); //Timing Start
						return Sites.get(id, cacheBust, searchTerm).then(function (response) {

							var end = $window.performance.now(),
							    time = end - start;console.info('TIMING: Site ' + (id || 'list') + ' fetched in: ', time / 1000); //Timing End

							var list = filterUuid ? _.filter(response, { org_uuid: filterUuid }) : response;

							return list;
						});
					},
					//
					//
					// We cant use this as anything but super user... ask DM
					//
					//
					orgSites: function orgSites(uuid, cacheBust) {
						console.time('TIMING: Fetching sites list'); //Timing Start
						return Orgs.getSites(uuid).then(function (list) {
							console.timeEnd('TIMING: Fetching sites list');
							return list;
						});
					},
					areas: function areas(id) {
						return Areas.get(id);
					},
					automations: function automations(id) {
						return Automations.get(id);
					},
					devices: function devices(id) {
						return Devices.get(id);
					},
					groups: function groups(id) {
						return Areas.getGroupControl(id);
					},
					notes: function notes() {
						return Settings.getNotes();
					},
					notifications: function notifications(id) {
						return Messages.getSiteNotifications(id);
					},
					programs: function programs(id) {
						return Shows.getAllPrograms(id);
					},
					scenes: function scenes(id) {
						return Scenes.getForSite(id);
					},
					schedules: function schedules(id) {
						return RecurrenceSchedules.getSchedulesForSite(id);
					},
					shows: function shows(id) {
						return Shows.getShowGroupsBySite(id);
					},
					users: function users() {
						return Users.getAll();
					},
					updateStatus: function updateStatus(id) {
						return Devices.getAllUpdateInfo(id);
					},
					zones: function zones(id) {
						return Zones.getForSite(id);
					}
				};

				this.renderers = {
					areas: function areas(_areas, zones) {
						return _areas;

						//
						// We cant use area.zones in this service because it breaks our caching model, too nested. Add per component as needed.
						//
						// return areas.map(function(area){
						// 	area.zones = zones.filter(function(zone){ return zone.area === area.id }); //Area zones - used some places
						// 	return area;
						// });
					},
					automations: function automations(_automations) {
						//
						// Nothing to do here for now
						//	    	
						return _automations;
					},
					devices: function devices(_devices) {
						return _.map(_devices, function (deviceProps) {
							return new Device(deviceProps, false);
						});
					},
					groups: function groups(_groups) {
						return _groups;
					},
					programs: function programs(_programs) {
						return _programs;
					},
					notes: function notes(_notes) {
						return _notes;
					},
					notifications: function notifications(_notifications) {
						return _notifications;
					},
					scenes: function scenes(_scenes) {
						//
						// Nothing to do here for now
						//
						return _scenes;
					},
					schedules: function schedules(_schedules) {
						//
						// Nothing to do here for now
						//
						return _schedules;
					},
					shows: function shows(_shows) {
						//
						// Nothing to do here for now
						//
						return _shows;
					},
					updateStatus: function updateStatus(info) {
						return info;
					},
					users: function users(_users) {
						return _users;
					},
					zones: function zones(_zones, devices) {
						return _zones.map(function (zoneProps) {
							return new Zone(zoneProps, devices);
						});
					}
				};

				this.socketRenderers = function (type, obj) {
					var renderers = {
						scenes: function scenes(obj) {
							return Scenes.scenesResponseMapping(obj);
						},
						schedules: function schedules(obj) {
							return RecurrenceSchedules.schedulesResponseMapping(obj);
						}
					};

					//
					// Socket message objects need a transform - should use same transform here for all services
					//
					return renderers[type] ? renderers[type](obj) : obj;
				};
			};

			SessionAdapter.$inject = ['$window', '$q', 'Sites', 'Orgs', 'Areas', 'Zones', 'Zone', 'Devices', 'Device', 'Scenes', 'Shows', 'RecurrenceSchedules', 'Automations', 'Settings', 'Users', 'Messages', '_'];

			_export('default', SessionAdapter);
		}
	};
});

$__System.register('ae', [], function (_export) {
	'use strict';

	function Local(localStorageService, $rootScope) {

		this.get = localStorageService.get;
		this.set = localStorageService.set;

		this.clearLS = function () {
			localStorageService.remove('apiKey');
			localStorageService.remove('currentSite');
			localStorageService.remove('lcUser');

			//Remove legacy currentUser objects - we can get rid of this in subsequent releases
			localStorageService.remove('currentUser');
			localStorageService.remove('currentUser.email');
			localStorageService.remove('currentUser.is_superuser');
			localStorageService.remove('currentUser.is_staff');
			localStorageService.remove('currentUser.org_admin');
			localStorageService.remove('currentUser.first_name');
			localStorageService.remove('currentUser.last_name');

			//No longer caching sites list here
			localStorageService.remove('sites');
		};

		this.clearRS = function () {
			console.log('clear rs');
			delete $rootScope.sites;
			delete $rootScope.currentSite;
			delete $rootScope.areas;
			delete $rootScope.currentArea;
			delete $rootScope.showDetailsArea;

			//User flags
			delete $rootScope['super'];
			delete $rootScope.staff;
			delete $rootScope.admin;
		};

		this.clearAll = function () {
			this.clearLS();
			this.clearRS();
		};
	}

	return {
		setters: [],
		execute: function () {
			Local.$inject = ['localStorageService', '$rootScope'];
			_export('default', Local);
		}
	};
});

$__System.register('af', [], function (_export) {
	'use strict';

	function LcCache($rootScope, $timeout, Local, moment, _) {

		var sessionData = {};

		var sessionSitesList = {};

		var csData = {};

		this.socketConnectionBroken = false;

		this.setCurrentOrg = function (org) {
			sessionData.currentOrg = angular.copy(org);
		};

		this.getCurrentOrg = function () {
			//
			// RAB User orgUuid is null...
			// Old routes wont have Org Uuid in address bar
			//

			return sessionData.currentOrg || Local.get('lcUser').org;
		};

		this.setUrlParams = function (params) {
			sessionData.UrlParams = angular.copy(params);
		};

		this.getUrlParams = function () {
			return sessionData.UrlParams;
		};

		this.setSessionSiteSectionData = function (section, data) {
			sessionData.siteData[section] = angular.copy(data);
		};

		this.getSessionSiteSectionData = function (section) {
			return sessionData.siteData[section];
		};

		this.updateSessionSite = function (site) {
			//
			// Keep session data per site in future - for now just match it in case
			//
			var siteData = getSessionSiteData();

			var updatedSiteData = _.merge(siteData, site);

			setSessionSiteData(updatedSiteData);
		};

		this.updateSessionSiteSetupMode = function (siteId, setupMode) {
			//
			// Keep session data per site in future - for now just match it in case
			//
			var siteData = getSessionSiteData();

			if (siteData.id === siteId) {
				siteData.setupMode = setupMode;

				setSessionSiteData(siteData);
			}
		};

		this.updateSessionSiteZombie = function (siteId, gatewayId) {
			//
			// Keep session data per site in future - for now just match it in case
			//
			var siteData = getSessionSiteData();

			if (siteData.id === siteId) {
				var matchingGatewayIndex = _.findIndex(siteData.gateways, { device_id: gatewayId });

				if (matchingGatewayIndex > -1) {
					siteData.gateways[matchingGatewayIndex].gateway_health = 1;

					setSessionSiteData(siteData);
				}
			}
		};

		this.updateSessionSiteSectionChild = function (section, items, isSocketMsg) {
			//
			// Update called from all AJAX and incoming Socket messages
			//
			// -Throttle / Queue to prevent multiple cache updates to same client
			//  ie when User A saves, updates cache on ajax response, then tries to update again on socket confirm
			//

			//console.log('Checking ignore flag',section,items);
			// - Heisenbug - console.log(checkIgnoreCacheUpdate(section,items[0]));

			if (!checkIgnoreCacheUpdate(section, items[0])) {
				(function () {
					var siteData = getSessionSiteData() || {};

					var newItems = [];

					_.each(items, function (item) {

						var existingIndex = _.findIndex(siteData[section], ['id', item.id]);

						//Render Items?
						if (existingIndex > -1) {
							siteData[section].splice(existingIndex, 1, item);
						} else {
							if (siteData[section]) {
								siteData[section].push(item);
							} else {
								siteData[section] = [item];
							}

							newItems.push(item);
						}

						//
						// Mark each item as a socket message or not
						// This will help us decide whether to navigate to new item
						//
						if (isSocketMsg) {
							item.isSocketMsg = true;
						}

						//
						// Mark section so no navigation for subsection items (automations and device updates within Devices view)
						//
						item.section = section;

						// if(existingIndex === -1){
						// 	//
						// 	//
						// 	// New areas shouldn't count as a new 'item'
						// 	// Areas have (currently unused) 'position' key
						// 	//
						// 	//
						// 	if(!angular.isDefined(item.position)){
						// 		newItems.push(item);
						// 	}				
						// }
						//
					});

					setSessionSiteData(siteData);

					queueBroadcastChanges(items, newItems);
				})();
			}
		};

		this.removeSessionSiteSectionChild = function (section, items) {
			console.log('Remove Called', section, items);

			if (!checkIgnoreCacheUpdate(section, items[0])) {
				(function () {
					var siteData = getSessionSiteData();

					_.each(items, function (item) {
						var existingIndex = _.findIndex(siteData[section], ['id', item.id]);

						if (existingIndex > -1) {
							siteData[section].splice(existingIndex, 1);
						}
					});

					queueBroadcastChanges(items);

					setSessionSiteData(siteData);
				})();
			}
		};

		this.getCSGlobalSitesList = getCSGlobalSitesList;
		this.setCSGlobalSitesList = setCSGlobalSitesList;

		this.getSessionSitesList = getSessionSitesList;
		this.setSessionSitesList = setSessionSitesList;

		this.getSessionSiteData = getSessionSiteData;
		this.setSessionSiteData = setSessionSiteData;

		function getCSGlobalSitesList() {
			return csData.globalSitesList;
		}

		function setCSGlobalSitesList(data) {
			csData.globalSitesList = angular.copy(data);
		}

		function getSessionSitesList(orgUuid) {
			return sessionSitesList[orgUuid];
		}

		function setSessionSitesList(orgUuid, data) {
			sessionSitesList[orgUuid] = angular.copy(data);
		}

		function getSessionSiteData() {
			return sessionData.siteData;
		}

		function setSessionSiteData(data) {
			sessionData.siteData = angular.copy(data);
		}

		function checkRecentUpdate(now, reqTime) {
			//
			// 5 Seconds for socket message roundtrip
			//
			return now.diff(reqTime, 'seconds') < 5;
		}

		//
		// Cache update req queue
		//
		var cacheUpdateReqs = [];

		function checkIgnoreCacheUpdate(section, item) {
			var ignoreFlag = false;

			var matchingReq = _.find(cacheUpdateReqs, function (req) {
				return req.section === section && req.itemId === item.id;
			});

			if (matchingReq) {
				ignoreFlag = checkRecentUpdate(moment(), matchingReq.time);
			}

			//
			// Clean out old reqs
			//
			cacheUpdateReqs = _.filter(cacheUpdateReqs, function (req) {
				return checkRecentUpdate(moment(), req.time);
			});

			cacheUpdateReqs.push({
				section: section,
				itemId: item.id,
				time: moment()
			});

			return ignoreFlag;
		}

		//
		// App broadcast queue
		//
		//
		// Prevent layout thrashing / digest cycles on multi edit / group updates
		//
		var BroadcastQueue = function BroadcastQueue() {
			this.items = [];
			this.newItems = [];
		};

		var broadcastQueue = new BroadcastQueue();
		var broadcastTimers = {};

		function queueBroadcastChanges(items, newItems) {
			console.log('Queuing Broadcast changes', items, newItems);
			//
			// Push items to relevent queues
			//
			broadcastQueue.items = _.union(broadcastQueue.items, items);
			broadcastQueue.newItems = _.union(broadcastQueue, newItems);

			//
			// Add timer
			//
			var rand = Math.random() * 10;
			//broadcastTimers[rand] = $timeout(function(){broadcastChanges(rand);},1000);

			//
			// -- Call this every time for now
			//
			broadcastChanges(rand);
		}

		function broadcastChanges(rand) {
			console.log('Broadcast called');
			console.log(broadcastQueue);

			//
			// Update app in batches
			//

			// if(broadcastQueue.items.length || broadcastQueue.newItems.length){
			// 	$rootScope.$broadcast('event:cache-update:sessionData',broadcastQueue.items,broadcastQueue.newItems);

			// 	//
			// 	// Clean queue after update
			// 	//
			// 	broadcastQueue = new BroadcastQueue();
			// }

			$rootScope.$broadcast('event:cache-update:sessionData', broadcastQueue.items, broadcastQueue.newItems);

			broadcastQueue = new BroadcastQueue();

			//
			// Clean this timer for angular GC
			//

			// - Temp remove this
			// - $timeout.cancel(broadcastTimers[rand]);
			//
			//delete broadcastTimers[rand];
		}
	}

	return {
		setters: [],
		execute: function () {
			LcCache.$inject = ['$rootScope', '$timeout', 'Local', 'moment', '_'];
			_export('default', LcCache);
		}
	};
});

$__System.register('b0', ['3', 'ab', 'ac', 'ad', 'ae', 'af'], function (_export) {
    'use strict';

    var angular, localStorageService, sessionService, sessionAdapterService, localService, lcCacheService, sessionModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_ab) {
            localStorageService = _ab['default'];
        }, function (_ac) {
            sessionService = _ac['default'];
        }, function (_ad) {
            sessionAdapterService = _ad['default'];
        }, function (_ae) {
            localService = _ae['default'];
        }, function (_af) {
            lcCacheService = _af['default'];
        }],
        execute: function () {
            sessionModule = angular.module('session', ['LocalStorageModule']).service('Session', sessionService).service('SessionAdapter', sessionAdapterService).service('Local', localService).service('LcCache', lcCacheService);

            _export('default', sessionModule);
        }
    };
});

$__System.register('b1', ['12', '13'], function (_export) {
	var _createClass, _classCallCheck, SettingsService;

	return {
		setters: [function (_) {
			_createClass = _['default'];
		}, function (_2) {
			_classCallCheck = _2['default'];
		}],
		execute: function () {
			'use strict';

			SettingsService = (function () {
				function SettingsService($http, Track, moment, $sce) {
					_classCallCheck(this, SettingsService);

					this.$http = $http;
					this.Track = Track;
					this.moment = moment;
					this.$sce = $sce;

					this.notesResponseMapping = function (rawNote) {
						var note = {
							release_number: rawNote.release_number,
							text: $sce.trustAsHtml(rawNote.text),
							timestamp: moment(rawNote.timestamp).format('LL'),
							title: rawNote.title
						};

						return note;
					};
				}

				_createClass(SettingsService, [{
					key: 'getNotes',
					value: function getNotes() {
						var _this = this;

						return this.$http({
							url: 'legal/get_release_notes/'
						}).then(function (response) {
							return response.data.map(_this.notesResponseMapping);
						});
					}
				}]);

				return SettingsService;
			})();

			_export('default', SettingsService);
		}
	};
});

$__System.register('b2', [], function (_export) {
    'use strict';

    //
    //
    // Route isn't under masterParent - so replicates some lightweight functionality
    //
    //
    var settingsMasterParentComponent;
    return {
        setters: [],
        execute: function () {
            settingsMasterParentComponent = {
                template: '\n        <section class="selection-container selection settings-section" ng-class="{scroll:$root.scroll}">\n            <left-nav-header on-menu-toggle="sMP.onMenuToggle();" menu-open="sMP.menuOpen" site-id="sMP.siteId;"></left-nav-header>\n            <settings-menu org="sMP.initialSessionData.org" user="sMP.user"></settings-menu>\n        </section><!--\n\n     --><section class="details-container settings-section">\n            <div class="master-right-container">\n                <header class="main-header">\n                    <h1 ng-bind="sMP.selection.title"></h1>\n                    <button class="btn clear-selection right" ng-if="sMP.selection.filtered" ng-click="sMP.clearToBase();">Clear Selection</button>\n                </header>\n\n                <div class="overview-wrapper">\n                    <div class="overview-container">\n                        <ui-view on-selection-update="sMP.selectionUpdate(selection)"></ui-view>\n                    </div>\n                </div>\n            </div>\n        </section>\n    ',
                bindings: {
                    //
                    // Bindings inherited from $state and lcAuthApp
                    //
                    initialSessionSitesListPromise: '<',
                    initialSessionData: '<',
                    menuOpen: '<',
                    itemCollection: '<',
                    user: '<',
                    onSessionDataChange: '&',
                    onMenuToggle: '&',
                    onClearToBase: '&'
                },
                controllerAs: 'sMP',
                controller: function controller() {

                    var sMP = this;

                    sMP.$onInit = function () {
                        //
                        sMP.initialSessionSitesListPromise.promise.then(function (list) {
                            sMP.sitesList = list;
                        });

                        sMP.onSessionDataChange({ data: sMP.initialSessionData });
                    };

                    sMP.selectionUpdate = function (selection) {
                        sMP.selection = selection;
                    };

                    sMP.clearToBase = function (createNew) {
                        console.log('Clear command from masterRight - will triger ui-route change');
                        sMP.onClearToBase({ createNew: createNew });
                    };
                }
            };

            _export('default', settingsMasterParentComponent);
        }
    };
});

$__System.register('b3', [], function (_export) {
    'use strict';

    var settingsMenuComponent;
    return {
        setters: [],
        execute: function () {
            settingsMenuComponent = {
                template: '\n\n        <div class="selection-list-wrapper settings">\n            <ul class="selection-list settings-options">\n                <li class="selection-list-item" ng-if="sM.isOrgAdmin(sM.user,sM.org)">\n                    <a ui-sref="notifications" class="selection-list-item-contents">\n                        <h1 class="name" translate="settings.faultNotifications">Fault Notifications</h1>\n                        <span class="description" translate="settings.viewManageFaultNotificationEmail">View &amp; Manage Fault Notification Emails</span>\n                    </a>\n                </li>\n\n                <!--\n                <li class="selection-list-item">\n                    <a ui-sref="releaseNotes" class="selection-list-item-contents">\n                        <h1 class="name" translate="settings.releaseNotes">Release Notes</h1>\n                        <span class="description" translate="settings.viewSoftwareRelease">View Software Release Notes</span>\n                    </a>\n                </li>\n                -->\n\n                <!--<li class="selection-list-item">-->\n                    <!--<phone-code user="sM.user"></phone-code>-->\n                <!--</li>-->\n\n                <!--<li class="lang-selection">-->\n                    <!--<span translate="common.language" class="ng-scope">language:</span>-->\n                    <!--<a ng-click="sM.changeLanguage(\'zh\')" ng-class="{selected: zhSelected}">中文</a>-->\n                    <!--<span>|</span>-->\n                    <!--<a ng-click="sM.changeLanguage(\'en\')" ng-class="{selected: enSelected}">EN</a>-->\n                    <!--<span>|</span>-->\n                    <!--<a ng-click="sM.changeLanguage(\'es\')" ng-class="{selected: esSelected}">Español</a>-->\n                <!--</li>-->\n\n            </ul>\n        </div>\n    ',
                bindings: {
                    org: '<',
                    user: '<'
                },
                controllerAs: 'sM',
                controller: function controller($translate, LcFn) {

                    var sM = this;

                    sM.$onInit = function () {
                        //
                    };

                    sM.changeLanguage = function (langKey) {
                        $translate.use(langKey);
                    };

                    sM.isOrgAdmin = LcFn.isOrgAdmin;
                }
            };

            _export('default', settingsMenuComponent);
        }
    };
});

$__System.registerDynamic("b4", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"main-body\">\n    <h2 class=\"overview-heading\">\n        <span translate=\"settings.releaseNotes\">Release Notes</span>\n    </h2>\n           \n    <div class=\"notes-container\" ng-repeat=\"note in sRN.notes\" ng-class=\"{'details': showDetail}\" ng-click=\"showDetail = !showDetail\">\n    \t\t\n        <div class=\"lc-pill\">\n            \n            <span class=\"pill-right\">\n                <div class=\"title\" translate=\"settings.version\">Version: </div>\n                <div>{{note.release_number}}</div>\n            </span>\n    <!--                 <span class=\"pill-left\">\n                <div class=\"title\" translate=\"settings.title\">Title: </div>\n                <div>{{note.title}}</div>\n            </span> -->\n            <span class=\"pill-left\">\n                <div class=\"title\" translate=\"settings.releaseDate\">Release Date: </div>\n                <div>{{note.timestamp}}</div>\n            </span>\n\n        </div>\n\n    \t<div ng-bind-html=\"note.text\" ng-show=\"showDetail\" class=\"note-content\">\n        </div>\n    </div>\n</section>";
});
$__System.register('b5', ['b4'], function (_export) {
    'use strict';

    var settingsReleaseNotesTmpl, settingsReleaseNotesComponent;
    return {
        setters: [function (_b4) {
            settingsReleaseNotesTmpl = _b4['default'];
        }],
        execute: function () {
            settingsReleaseNotesComponent = {
                template: settingsReleaseNotesTmpl,
                bindings: {
                    notes: '<'
                },
                controllerAs: 'sRN',
                controller: function controller() {
                    var sRN = this;
                    //
                    // Dumb
                    //
                }
            };

            _export('default', settingsReleaseNotesComponent);
        }
    };
});

$__System.registerDynamic("b6", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"main-body\">\n    <h2 class=\"overview-heading\">\n        <span translate=\"fault.subscribedUserEmails\">Subscribed Users & Emails</span>\n    </h2>\n           \n\t<p class=\"loading-spinner-label\" ng-if=\"sN.ajaxLoading\" translate=\"common.loadingEllipsis\" translate=\"common.loadingEllipsis\">Loading...</p>\n\n    <p ng-show=\"sN.siteSubscribers.length == 0\">No Subscriptions</p>\n\n    <div class=\"notes-container\"  ng-class=\"{'details': site.showDetail}\" ng-repeat=\"site in sN.siteSubscribers\">           \n        <div class=\"lc-pill\" ng-click=\"sN.toggleSite(site)\">\n            <span class=\"pill-right\">\n                <div class=\"title\" translate=\"fault.subscribers\"># Subscribers: </div>\n                <div>{{site.count}}</div>\n            </span>\n\n            <span class=\"pill-left\">\n                <div class=\"title\" translate=\"customerService.siteName\">Site Name: </div>\n                <div>{{site.name}}</div>\n            </span>\n        </div>\n\n        <div class=\"subscribers-container\" ng-show=\"site.showDetail\" ng-repeat=\"subscriber in site.subscribers\">\n            <div class=\"lc-pill\">\n                \n                <span class=\"pill-right\">\n                    <button class=\"btn delete orange\" ng-click=\"sN.delete(subscriber)\" translate=\"common.delete\">Delete</button>\n                </span>\n\n                <span class=\"pill-left\">\n                    <div class=\"title\" translate=\"fault.emailAddress\">Email Address: </div>\n                    <div>{{subscriber.email || subscriber.email_address}}</div>\n                </span>\n\n                <span class=\"pill-center\">\n                    <div class=\"title\" translate>{{fault.userName}}</div>\n                    <div>{{subscriber.first_name}} {{subscriber.last_name}}</div>\n                </span>\n\n            </div>                \n        </div>\n\t</div>\n\t\n    <div class=\"notification\">\n\n        <h2 class=\"overview-heading\">\n            <span translate=\"fault.addByUser\">Add by User</span>\n        </h2>\n\n        <div class=\"search-input-wrapper\">\n            <i class=\"fa fa-search\"></i>\n            <input class=\"search\" type=\"search\" ng-model=\"sN.addUserSearch\" placeholder=\"{{'settings.searchForUsers' | translate }}\"/>\n        </div>\n\n        <div class=\"lc-pill user-list users title\">\n            \n            <span class=\"pill-right\">\n                <h3 class=\"title\" translate=\"fault.select\">Select</h3>\n            </span>\n\n            <span class=\"pill-left\">\n                <h3 class=\"title\" translate=\"fault.user\">User</h3>\n            </span>\n\n            <span class=\"pill-center\">\n                <h3 class=\"title\" translate=\"fault.email\">Email</h3>\n            </span>\n\n        </div>\n\n        <div class=\"user-list-wrapper-scroll-container\">\n        <div class=\"user-list-wrapper\">\n            <div ng-repeat=\"user in sN.users | filter: sN.addUserSearch\">\n                <div class=\"lc-pill user-list users\">\n                    <span class=\"pill-right\">\n                        <button class=\"btn-check-select view\" ng-class=\"{all: user.selected}\"   ng-click=\"sN.selectUser(user)\"></button>\n                    </span>\n\n                    <span class=\"pill-left\">\n                        <h3 class=\"title\">{{user.first_name}} {{user.last_name}}</h3>\n                    </span>\n\n                    <span class=\"pill-center\">\n                        <h3 class=\"title\">{{user.email}}</h3>\n                    </span>\n                </div>\n\n                <div class=\"site-list\" ng-show=\"user.selected\" ng-repeat=\"site in user.sites\">\n                    <div class=\"lc-pill user-list\">\n                        <span class=\"pill-right\">\n                            <button class=\"btn-check-select view\" ng-class=\"{all: site.selectSite}\"   ng-click=\"site.selectSite = !site.selectSite; sN.siteAction()\"></button>\n                        </span>\n\n                        <span class=\"pill-left\">\n                            <h3 class=\"title\" translate=\"fault.siteName\">Site Name:</h3>\n                        </span>\n\n                        <span class=\"pill-center\">\n                            <h3 class=\"title\">{{site.id_string}}</h3>\n                        </span>\n                    </div>                        \n                </div>\n\n            </div>                    \n        </div>\n        </div>\n        <h2 class=\"overview-heading\">\n            <span translate=\"fault.addByEmail\">Add by Email</span>\n        </h2>\n\n        <div class=\"lc-pill email\">\n            <span class=\"pill-left\">\n                <form name=\"sub\">\n                    <div class=\"title\" translate=\"fault.inputEmail\">Input Email: </div>\n                    <input type=\"email\" name=\"input\" ng-model=\"sN.emailAddress\" placeholder=\"e.g: xxxx@rabweb.com\" ng-pattern=\"/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/\">\n                    <span class=\"error\" ng-show=\"sub.input.$invalid\">Please input valid Email Address.</span>\n                </form>\n            </span>\n        </div>\n\n\n        <div class=\"buttons\">\n            <button class=\"btn save blue right\" ng-disabled=\"(!sN.selectedUsers || sN.selectedUsers.length == 0) && !sN.emailAddress\" ng-click=\"sN.selectSites()\">Select Sites</button>\n        </div>\n\n    </div>\n</section>";
});
$__System.register('b7', ['b6'], function (_export) {
    'use strict';

    var settingsNotificationTmpl, settingsNotificationComponent;
    return {
        setters: [function (_b6) {
            settingsNotificationTmpl = _b6['default'];
        }],
        execute: function () {
            settingsNotificationComponent = {
                template: settingsNotificationTmpl,
                bindings: {
                    notificationSessionData: '<',
                    itemCollection: '<'
                },
                controllerAs: 'sN',
                controller: function controller($q, Users, Modals) {

                    var sN = this;

                    sN.$onInit = function () {
                        //
                        // Better (angular) way to do this
                        //
                        $('.overview-container').scrollTop(0);

                        sN.ajaxLoading = true;

                        $q.all([sN.notificationSessionData.sitesPromise.promise, sN.notificationSessionData.usersPromise.promise]).then(function (result) {

                            sN.sites = result[0];
                            sN.users = result[1];

                            sN.selectedUsers = [];

                            sN.ajaxLoading = false;

                            subscriberInfo();
                        });
                    };

                    sN.toggleSite = function (site) {
                        site.showDetail = !site.showDetail;

                        return site;
                    };

                    sN.selectUser = function (user) {
                        user.selected = !user.selected;

                        if (user.selected) {
                            sN.selectedUsers.push(user);
                        } else {
                            sN.selectedUsers.splice(sN.selectedUsers.indexOf(user), 1);
                        }
                    };

                    sN.selectSites = function () {
                        var allItems = [{
                            type: 'notifications',
                            areas: [{ notifications: sN.sites }],
                            selected: [] //@todo
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Sites', 'site-select').then(function (sites) {

                            addRecords(sites, sN.selectedUsers);
                        });
                    };

                    function subscriberInfo() {
                        sN.allSubscribers = [];

                        Users.getEmailSubscribers().success(function (data) {

                            sN.allSubscribers = _.map(data, function (subscriber) {
                                if (!subscriber.email_address) {
                                    var match = _.find(sN.users, ['id', subscriber.user_id]);
                                    subscriber.email_address = match ? match.email : '';
                                }
                                return subscriber;
                            });

                            //Group all subscribers into sites, find matching site for each
                            // - Cover for subscribers to deleted sites
                            sN.siteSubscribers = _.filter(_.map(_.groupBy(sN.allSubscribers, 'site_id'), function (group, key) {
                                var site = _.find(sN.sites, function (site) {
                                    return site.id == key;
                                });

                                if (site) {
                                    return {
                                        name: site.id_string || null,
                                        id: site.id || null,
                                        subscribers: group,
                                        count: group.length
                                    };
                                }
                            }));
                        }).error(function (data) {
                            console.log("get subscribers error");
                        });
                    }

                    function addRecords(sites, users) {
                        Modals.openLoad('Adding Subscriber(s)');

                        var req = [];

                        _.each(users, function (user) {
                            _.each(sites, function (site) {
                                req.push({ user_id: user.id, site_id: site.id });
                            });
                        });

                        if (sN.emailAddress) {
                            _.each(sites, function (site) {
                                req.push({ email_address: sN.emailAddress, site_id: site.id });
                            });
                        }

                        Users.addSubscribers(req).success(function (data) {
                            Modals.closeLoad('Successful', true);
                            finish();
                        }).error(function (err, status) {
                            if (status == 400) {
                                Modals.closeLoad('Email already exists in the system');
                            } else {
                                Modals.closeLoad('Failed');
                            }
                        });
                    }

                    function finish() {
                        //de-select all users
                        sN.users = _.map(sN.users, function (user) {
                            user.selected = false;
                            return user;
                        });
                        sN.selectedUsers = [];
                        sN.emailAddress = null;

                        subscriberInfo();
                    }

                    sN['delete'] = function (subscriber) {
                        Modals.openLoad('Deleting Subscriber');

                        Users.deleteSubscriber(subscriber.notificationId || subscriber.id).success(function (data) {
                            Modals.closeLoad('Successful', true);
                            subscriberInfo();
                        }).error(function (data) {
                            Modals.closeLoad('Deleting Failed');
                        });
                    };
                }
            };

            _export('default', settingsNotificationComponent);
        }
    };
});

$__System.registerDynamic("b8", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"main-body\">\n    <h2 class=\"overview-heading\">\n        <span>Organization Level Scenes</span>\n    </h2>\n\n    <div class=\"overview-zones-list scenes multi-site\">\n        <div class=\"overview-zone\" ng-repeat=\"masterScene in sMS.masterScenes | orderBy:['id_string']\">\n            <div class=\"zone-control\">\n                <span class=\"zone-name\">{{masterScene.id_string}}</span>\n\n                <div class=\"toggler on\" ng-if=\"masterScene.scenes.length\"> \n                    <span>Activate</span>\n                    <button class=\"btn-push momentary\" ng-disabled=\"masterScene.applying\" ng-class=\"{disabled: masterScene.applying, activated: masterScene.activated}\" ng-click=\"sMS.scenesToggle(masterScene, masterScene)\"></button>\n                </div>\n            </div>\n        </div>\n\n        <p class=\"loading-spinner-label\" ng-hide=\"sMS.masterScenes !== undefined\" translate=\"common.loadingEllipsis\">Loading...</p>\n    </div>\n\n    <h2 class=\"overview-heading\">\n        <span>Site Toggle Scenes</span>\n    </h2>\n\n    <div class=\"overview-zones-list scenes multi-site\">\n        <div class=\"overview-zone\" ng-repeat=\"site in sMS.siteTogglers | orderBy:['id_string']\">\n            <div class=\"zone-control\">\n                <span class=\"zone-name\">{{site.id_string}}</span>\n\n    \t\t\t<div class=\"toggler off\" ng-if=\"site.offScene.scenes.length\">\n    \t\t\t\t<span>Off</span>\n    \t\t\t\t<button class=\"btn-push momentary\" ng-disabled=\"site.applying\" ng-class=\"{disabled: site.applying, activated: site.offScene.activated}\" ng-click=\"sMS.scenesToggle(site, site.offScene)\"></button>\n    \t\t\t</div>\n                <div class=\"toggler on\" ng-if=\"site.onScene.scenes.length\"> \n                    <span>On</span>\n    \t\t\t\t<button class=\"btn-push momentary\" ng-disabled=\"site.applying\" ng-class=\"{disabled: site.applying, activated: site.onScene.activated}\" ng-click=\"sMS.scenesToggle(site, site.onScene)\"></button>\n    \t\t\t</div>\n            </div>\n        </div>\n\n        <p class=\"loading-spinner-label\" ng-hide=\"sMS.siteTogglers !== undefined\" translate=\"common.loadingEllipsis\">Loading...</p>\n    </div>\n</section>";
});
$__System.register('b9', ['b8'], function (_export) {
    'use strict';

    var settingsOrgScenesTemplate, settingsOrgScenesComponent;
    return {
        setters: [function (_b8) {
            settingsOrgScenesTemplate = _b8['default'];
        }],
        execute: function () {
            settingsOrgScenesComponent = {
                template: settingsOrgScenesTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    orgUuid: '<',
                    onSelectionUpdate: '&?'
                },
                controllerAs: 'sMS',
                controller: function controller($rootScope, $timeout, $q, localStorageService, SessionAdapter, Scenes, Orgs) {

                    var sMS = this;

                    var sceneTimeouts = [];

                    //
                    // Match with master scene names -puke
                    //
                    var masterTitle = '[Master]';
                    var onTitle = '[On]';
                    var offTitle = '[Off]';

                    sMS.$onInit = function () {
                        _.each(sceneTimeouts, function (sceneTimeout) {
                            $timeout.cancel(sceneTimeout);
                        });

                        init(sMS.orgUuid);
                    };

                    function init(uuid) {
                        getOrgSites(uuid).then(function (sites) {
                            return getSitesScenes(sites);
                        }).then(function (result) {
                            sMS.masterScenes = result[0];
                            sMS.siteTogglers = result[1];
                        });
                    }

                    sMS.scenesToggle = function (group, toggle) {
                        group.applying = true;

                        //Open
                        $rootScope.$broadcast('event:openLoadingModal', 'Activating');

                        toggleSceneGroup(toggle.scenes)['finally'](function () {
                            // One or more could fail - ideally we would have one command here...
                            // - Let's say its passed for now...
                            $rootScope.$broadcast('event:closeLoadingModal', 'Complete', true);
                            group.applying = false;
                            toggle.activated = true;

                            var sceneTimeout = $timeout(function () {
                                toggle.activated = false;
                            }, 5000);

                            sceneTimeouts.push(sceneTimeout);
                        });
                    };

                    function getUser() {
                        return localStorageService.get('lcUser') || {};
                    }

                    function getOrgSites(uuid) {
                        return Orgs.getSites(uuid);
                    }

                    function getSitesScenes(sites) {
                        var sceneReqs = [];

                        _.each(sites, function (site) {
                            sceneReqs.push(Scenes.getForSite(site.id));
                        });

                        return $q.all(sceneReqs).then(function (sceneRepsonses) {

                            var otherMasters = {};
                            var siteTogglers = [];

                            var SceneStub = function SceneStub(scene) {
                                this.id = scene.id;
                                this.name = scene.name;
                            };

                            //
                            // Nice chance to use reduce here instead of each
                            //
                            _.each(sceneRepsonses, function (scenes, k) {

                                //Per site
                                var onScenes = [];
                                var offScenes = [];

                                _.each(scenes, function (scene) {
                                    if (scene.name.indexOf(masterTitle) > -1) {
                                        if (scene.name.indexOf(onTitle) > -1) {
                                            onScenes.push(new SceneStub(scene));
                                        } else if (scene.name.indexOf(offTitle) > -1) {
                                            offScenes.push(new SceneStub(scene));
                                        } else {
                                            var thisMasterTitle = scene.name.split('[Master][')[1] ? scene.name.split('[Master][')[1].split(']')[0] : '';

                                            if (otherMasters[thisMasterTitle]) {
                                                otherMasters[thisMasterTitle].push(new SceneStub(scene));
                                            } else {
                                                otherMasters[thisMasterTitle] = [new SceneStub(scene)];
                                            }
                                        }
                                    }
                                });

                                siteTogglers.push({
                                    id_string: sites[k].id_string,
                                    onScene: {
                                        scenes: onScenes,
                                        activated: false
                                    },
                                    offScene: {
                                        scenes: offScenes,
                                        activated: false
                                    }
                                });
                            });

                            var masters = _.map(otherMasters, function (group, k) {
                                return {
                                    id_string: k,
                                    scenes: group
                                };
                            });

                            return [masters, siteTogglers];
                        });
                    }

                    function toggleSceneGroup(scenes) {

                        var sceneReqs = _.map(scenes, function (scene) {
                            return Scenes.activate(scene.id);
                        });

                        // _.each(scenes, function(scene,k){
                        //     var delay = 500;
                        //     //
                        //     // Hack #8 - Put an artificial delay between requests (500ms)
                        //     //
                        //     var delayedPromise = $timeout(k*delay).then(function(){ return Scenes.activate(scene.id);});
                        //     sceneReqs.push(delayedPromise);
                        // });

                        return $q.all(sceneReqs);
                    }
                }
            };

            _export('default', settingsOrgScenesComponent);
        }
    };
});

$__System.register('ba', [], function (_export) {
  'use strict';

  // -------------------
  //
  // /settings/ base for all component routing outside of site context
  //
  // -------------------

  var settingsStates;
  return {
    setters: [],
    execute: function () {
      settingsStates = [{
        //
        // Not a child of site
        //
        name: 'Settings',
        url: '/settings',
        resolve: {
          org: function org($transition$, LcCache, Local, Sites, Orgs, _) {
            //
            //
            // Settings view context decided here
            //
            //

            // - New user has no org sometimes :(
            function fetchOrgFromSites() {
              return Sites.get().then(function (sites) {
                return sites[0] ? sites[0].org : {};
              });
            }

            function getOrgObjectForUser() {
              var user = Local.get('lcUser');

              var firstOrgPerm = _.find(user.permissions, function (perm) {
                return perm.permission === 'org_admin' || perm.permission === 'org_user';
              });

              //
              // User could be RAB Super user - no perms explicitly set
              // give them Org #1 (per DM req)
              //
              if (!firstOrgPerm && user.is_superuser) {
                firstOrgPerm = { object_id: 1 };
              }

              return firstOrgPerm ? Orgs.get(firstOrgPerm.object_id).then(function (org) {
                return org;
              }) : fetchOrgFromSites(); //Try sites API if no explicit perms
            }

            return LcCache.getCurrentOrg() ? LcCache.getCurrentOrg() : getOrgObjectForUser();
          },
          //Resolve site data
          initialSessionData: /*@ngInject*/function initialSessionData(org, $stateParams, $state$, $transition$, $q, Session, Orgs, LcCache) {

            var mockSiteData = { org: org };

            LcCache.setSessionSiteData(mockSiteData);

            console.log('Master Structure state change here...');

            LcCache.setCurrentOrg(org);

            return mockSiteData;
          },
          initialSessionSitesListPromise: function initialSessionSitesListPromise(org, Session, $q) {
            var sitesListDeferred = $q.defer();

            Session.getSitesList(null, org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            });

            return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
          },
          initialSelectedIds: function initialSelectedIds($stateParams, Session) {
            return Session.getUrlParamsUserSelection();
          },
          viewNavContext: function viewNavContext($transition$) {
            var to = $transition$.to();
            //
            // Some views will require different arrangements than default listed below
            //
            // - 'default' ('grouped-zones' view)
            // - 'devices'
            // - 'scenes'
            // 
            //   
            return to.params.leftMenuSpecialContext ? to.params.leftMenuSpecialContext : 'default';
          }
        },

        component: 'settingsMasterBase',

        params: {
          siteId: null,

          userSelectedFilter: {
            value: null,
            dynamic: true
          },

          leftMenuSpecialContext: 'settings'

        },
        title: 'Settings'
      }, {
        //
        // Multi-site scenes (org-level scenes)
        //
        parent: 'Settings',
        name: 'MultiSite',
        url: '/multi-site/{orgUuid}',
        resolve: {

          orgUuid: function orgUuid($transition$, LcCache, Orgs) {
            return $transition$.params('to').orgUuid;
          }

        },

        params: {},

        component: 'settingsMultiSite',

        title: 'Multi Site'
      }, {
        //
        // Cover legacy routes
        //
        parent: 'Settings',
        name: 'notifications',
        url: '/notification',
        resolve: {

          // - This view is taking 40/50 seconds to resolve, have to pass promise instead of list to show spinner

          notificationSessionData: function notificationSessionData($q, org, Orgs, initialSessionSitesListPromise) {

            var usersListDeferred = $q.defer(),
                sitesListDeferred = $q.defer();

            Orgs.getUsers(org.uuid).then(function (list) {
              usersListDeferred.resolve(list);
            });

            Orgs.getSites(org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            });

            return { sitesPromise: sitesListDeferred, usersPromise: usersListDeferred };
          }

          // notificationSessionData: function($q,Sites,Users){
          //   return $q.all([Sites.get(),Users.getAll()]).then(result => {
          //     return {sites: result[0], users: result[1]};
          //   });

          // }
        },

        params: {},

        component: 'settingsNotifications',

        title: 'Notifications'
      }, {
        //
        // Cover legacy routes
        //
        parent: 'Settings',
        name: 'releaseNotes',
        url: '/releaseNote',
        resolve: {
          notes: function notes(Messages, Settings) {
            return Settings.getNotes().then(function (data) {
              return data;
            })['catch'](function (error) {
              var message = {
                type: 'error',
                title: 'Error',
                body: 'Load Software Release Notes Failed'
              };

              Messages.popUp(message);
            });
          }
        },

        params: {},

        component: 'settingsReleaseNotes',

        title: 'Release Notes'
      }];

      _export('settingsStates', settingsStates);
    }
  };
});

$__System.register('bb', ['3', 'b1', 'b2', 'b3', 'b5', 'b7', 'b9', 'ba'], function (_export) {
    'use strict';

    var angular, SettingsService, settingsMasterParentComponent, settingsMenuComponent, settingsReleaseNotesComponent, settingsNotificationsComponent, settingsOrgScenesComponent, settingsStates, settingsModule;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_b1) {
            SettingsService = _b1['default'];
        }, function (_b2) {
            settingsMasterParentComponent = _b2['default'];
        }, function (_b3) {
            settingsMenuComponent = _b3['default'];
        }, function (_b5) {
            settingsReleaseNotesComponent = _b5['default'];
        }, function (_b7) {
            settingsNotificationsComponent = _b7['default'];
        }, function (_b9) {
            settingsOrgScenesComponent = _b9['default'];
        }, function (_ba) {
            settingsStates = _ba.settingsStates;
        }],
        execute: function () {
            settingsModule = angular.module('settings', []).service('Settings', SettingsService).component('settingsMasterBase', settingsMasterParentComponent).component('settingsMenu', settingsMenuComponent).component('settingsReleaseNotes', settingsReleaseNotesComponent).component('settingsNotifications', settingsNotificationsComponent).component('settingsMultiSite', settingsOrgScenesComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                _.each(settingsStates, function (state) {
                    $stateRegistry.register(state);
                });
            }]);

            _export('default', settingsModule);
        }
    };
});

$__System.register('bc', ['14'], function (_export) {
	var _defineProperty;

	function Sites($http, Local) {

		this.newSite = newSite;

		this.get = function (optionalId, cacheBust, searchTerm, loadAllSites) {
			var cached = angular.isDefined(cacheBust) ? false : true;
			var isSuperUser = Local.get('lcUser').is_superuser;
			var st = searchTerm || Local.get('lcUser').org.name;
			var endpoint = 'site/';

			if (optionalId) {
				endpoint += optionalId + '/';
			} else if (st && isSuperUser && !loadAllSites) {
				endpoint += 'search/?searchTerm=' + encodeURIComponent(st);
			}

			return $http({
				url: endpoint,
				cache: cached,
				transformResponse: $http.defaults.transformResponse.concat([sitesResponseMapping])
			}).then(function (response) {
				return Array.isArray(response.data) ? response.data : [response.data];
			})['catch'](function (error) {
				throw error;
			});
		};

		this.create = function (site) {
			return $http({
				method: 'POST',
				url: 'site/',
				data: sitesRequestMapping(site),
				transformResponse: $http.defaults.transformResponse.concat([sitesResponseMapping])
			}, function () {
				//OH noes
			}).then(function (response) {
				return response.data[0]; // Why wrapped in array?
			});
		};

		this.update = function (site) {
			return $http({
				method: 'PUT',
				url: 'site/' + site.id + '/',
				data: sitesRequestMapping(site)
			}, //transformResponse : $http.defaults.transformResponse.concat([sitesResponseMapping])
			function () {
				//OH noes
			}).then(function (response) {
				//swap out this site in the sites list / indexedDB
				//updateSitesList(sitesRequestMapping(site));
				return response.data;
			});
		};

		this['delete'] = function (site) {
			return $http({
				method: 'DELETE',
				url: 'site/' + site.id + '/'
			}, function () {
				//Error
			}).then(function () {});
		};

		this.toggleDiscovery = function (siteId, gatewayId, discoveryMode) {
			return $http({
				method: 'POST',
				url: 'site/' + siteId + '/command/',
				data: {
					setupMode: discoveryMode,
					gatewayId: gatewayId
				}
			});
		};

		this.indicate = function (site) {
			return $http({
				method: 'POST',
				url: 'site/' + site.id + '/command/',
				data: {
					'indicate': 3
				}
			});
		};

		this.deviceTable = function (siteId) {
			var httpParams = {
				url: 'site/' + siteId + '/create_device_table/',
				responseType: 'blob'
			};

			return $http(httpParams).then(function (response) {
				return response.data;
			});
		};

		this.siteData = function (siteId) {
			return $http({
				method: 'GET',
				url: 'site/' + siteId + '/site_data_export/',
				responseType: 'blob'
			}).then(function (response) {
				return response.data;
			});
		};

		this.setPowerLossMode = function (siteId, period) {
			return $http({
				method: 'POST',
				url: 'site/' + siteId + '/command/',
				data: {
					set_heartbeat: {
						enable: true,
						period: period, // Off by sending 0, on by anything else     
						timeout: 2
					}
				}
			});
		};

		this.setPowerMonitor = function (siteId, period) {
			return $http({
				method: 'POST',
				url: 'site/' + siteId + '/command/',
				data: {
					set_power_monitor: period
				}
			});
		};

		this.gatewayRestartReboot = function (siteId, gatewayId, command) {
			return $http({
				method: 'POST',
				url: 'site/' + siteId + '/command/',
				data: _defineProperty({
					gatewayId: gatewayId
				}, command, {})
			});
		};

		//gateway_app_restart / gateway_app_reboot
		this.getTimezone = function (siteId) {
			return $http({
				method: 'GET',
				url: 'site/' + siteId + '/offset/'
			});
		};

		this.getNotifications = function (siteId, count, offset, filterTypes, filterIdSets) {
			//
			//
			// Change to new style multi-select/filter
			//
			//
			var params = {
				max: count,
				offset: offset
			};

			_.each(filterTypes, function (name, k) {
				_.merge(params, _defineProperty({}, name, filterIdSets[k].toString().replace(/,/g, '-')));
			});

			return $http({
				url: 'site/' + siteId + '/system_notifications/',
				params: params
			}).then(function (result) {
				return result.data;
			});
		};

		this.getBuildingTypeInfo = function () {
			return $http({
				url: 'site/building_types/'
			}).then(function (result) {
				return result.data;
			});
		};

		function newSite(site) {
			var gatewayHealthCodes = {
				0: 'POWER_LOSS',
				1: 'POWER_ON',
				2: 'UNREACHABLE',
				3: 'UNKNOWN'
			};

			var setupMode = site.gateways && site.gateways[0] ? site.gateways[0].setup_mode : false; //Will have to change for true multiple gateways

			return {
				id: site.id,
				id_string: site.id_string,
				address: {
					address1: site.address1,
					address2: site.address2,
					city: site.city,
					state: site.state,
					postal_code: site.postal_code,
					country_code: site.country_code
				},
				//
				// - What is this site deviceId for? @todo remove?
				//
				deviceId: site.device_id,
				health: gatewayHealthCodes[site.gateway_health],
				setupMode: setupMode,
				gateways: site.gateways,
				org: site.org,
				org_uuid: site.org ? site.org.uuid : null, //Simple org filtering in menu list
				org_name: site.org ? site.org.name : null,
				uuid: site.uuid,
				is_blue: site.is_blue,

				//hide emergency mode for moment
				// is_panic_mode: site.is_panic_mode,
				locality: {
					timezone: site.timezone,
					gmt_offset: site.gmt_offset,
					friendly_tz_name: site.friendly_tz_name,
					three_letter_tz_code: site.three_letter_tz_code,
					lat: site.lat,
					lng: site.lng,
					next_sunrise: site.next_sunrise,
					next_sunset: site.next_sunset,
					latest_dst_update: site.latest_dst_update
				},
				electrician: {
					electrician_name: site.electrician_name,
					electrician_company: site.electrician_company,
					electrician_phone_no: site.electrician_phone_no,
					electrician_pin: site.electrician_pin
				},
				support_15_min_power: site.support_15_min_power,
				building_type: site.building_type
			};
		}

		function sitesRequestMapping(site) {
			return {
				id_string: site.id_string,
				address1: site.address.address1,
				address2: site.address.address2,
				city: site.address.city,
				state: site.address.state,
				postal_code: site.address.postal_code,
				country_code: site.address.country_code,
				electrician_name: site.electrician.electrician_name,
				electrician_company: site.electrician.electrician_company,
				electrician_phone_no: site.electrician.electrician_phone_no,
				electrician_pin: site.electrician.electrician_pin,
				org_uuid: site.org_uuid,
				gateways: site.gateways,
				building_type: site.building_type

				//hide emergency mode for moment
				// is_panic_mode		: site.is_panic_mode
			};
		}

		function sitesResponseMapping(data) {
			var sites = [];

			//Single request response is object not array
			if (!data || !data.site) {
				data = { site: [data] };
			}

			if (data.site[0]) {
				data.site.forEach(function (site) {
					sites.push(newSite(site));
				});
			}

			return sites;
		}
	}

	return {
		setters: [function (_2) {
			_defineProperty = _2['default'];
		}],
		execute: function () {
			'use strict';

			Sites.$inject = ['$http', 'Local'];
			_export('default', Sites);
		}
	};
});

$__System.register('bd', [], function (_export) {
    'use strict';

    //
    //
    // Route isn't under masterParent - so replicates some lightweight functionality
    //
    //
    var noSitesMasterComponent;
    return {
        setters: [],
        execute: function () {
            noSitesMasterComponent = {
                template: '\n        <section class="">\n            <div class="welcome-screen">\n                <h1>Welcome</h1>\n                <h2>Let\'s get your first Lightcloud site online</h2>\n                <div class="setup-mode">To setup your gateway, call Lightcloud support on 1(844) LIGHTCLOUD</div>\n            </div>\n        </section>\n    ',
                bindings: {
                    //
                    // Bindings inherited from $state and lcAuthApp
                    //
                    initialSessionSitesListPromise: '<',
                    initialSessionData: '<',
                    menuOpen: '<',
                    itemCollection: '<',
                    user: '<',
                    onSessionDataChange: '&',
                    onClearToBase: '&'
                },
                controllerAs: 'nS',
                controller: function controller() {

                    var nS = this;

                    nS.$onInit = function () {
                        //
                        nS.initialSessionSitesListPromise.promise.then(function (list) {
                            nS.sitesList = list;
                        });

                        nS.onSessionDataChange({ data: nS.initialSessionData });
                    };

                    nS.selectionUpdate = function (selection) {
                        nS.selection = selection;
                    };

                    nS.clearToBase = function (createNew) {
                        console.log('Clear command from masterRight - will triger ui-route change');
                        nS.onClearToBase({ createNew: createNew });
                    };
                }
            };

            _export('default', noSitesMasterComponent);
        }
    };
});

$__System.register('be', [], function (_export) {
	'use strict';

	var sitesStates;
	return {
		setters: [],
		execute: function () {
			sitesStates = [{
				name: 'no-sites',
				url: '/no-sites',
				resolve: {
					org: function org($stateParams, $transition$, LcCache) {
						//
						// - Allow the no-sites state to be passed an org object (from search results)
						//
						if ($stateParams.orgObject) {
							LcCache.setCurrentOrg($stateParams.orgObject);
						}

						//
						//
						// Settings view context decided here
						//
						//
						return LcCache.getCurrentOrg();
					},
					//Resolve site data
					initialSessionData: function initialSessionData(org, $stateParams, $state$, $transition$, $q, Session, Orgs, LcCache) {

						var mockSiteData = { org: org };

						LcCache.setSessionSiteData(mockSiteData);

						console.log('Master Structure state change here...');

						LcCache.setCurrentOrg(org);

						return mockSiteData;
					},
					initialSessionSitesListPromise: function initialSessionSitesListPromise(initialSessionData, Session, $q) {
						var sitesListDeferred = $q.defer();

						Session.getSitesList(initialSessionData.id, initialSessionData.org.uuid).then(function (list) {
							sitesListDeferred.resolve(list);
						});

						return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
					},
					initialSelectedIds: function initialSelectedIds($stateParams, Session) {
						return Session.getUrlParamsUserSelection();
					},
					viewNavContext: function viewNavContext($transition$) {
						var to = $transition$.to();
						//
						// Some views will require different arrangements than default listed below
						//
						// - 'default' ('grouped-zones' view)
						// - 'devices'
						// - 'scenes'
						// 
						//   
						return to.params.leftMenuSpecialContext ? to.params.leftMenuSpecialContext : 'default';
					}
				},

				component: 'noSites',

				params: {
					orgObject: null
				},

				title: 'No-Sites'
			}];

			_export('sitesStates', sitesStates);
		}
	};
});

$__System.register('bf', ['3', 'bc', 'bd', 'be'], function (_export) {
    'use strict';

    var angular, SitesService, noSitesComponent, sitesStates, sitesModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_bc) {
            SitesService = _bc['default'];
        }, function (_bd) {
            noSitesComponent = _bd['default'];
        }, function (_be) {
            sitesStates = _be.sitesStates;
        }],
        execute: function () {
            sitesModule = angular.module('sites', []).service('Sites', SitesService).component('noSites', noSitesComponent).config(['$stateRegistryProvider', function ($stateRegistry) {
                sitesStates.forEach(function (state) {
                    return $stateRegistry.register(state);
                });
            }]);

            _export('default', sitesModule);
        }
    };
});

$__System.registerDynamic('c0', ['c1', 'c2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Module dependencies.
   */

  var parseuri = $__require('c1');
  var debug = $__require('c2')('socket.io-client:url');

  /**
   * Module exports.
   */

  module.exports = url;

  /**
   * URL parser.
   *
   * @param {String} url
   * @param {Object} An object meant to mimic window.location.
   *                 Defaults to window.location.
   * @api public
   */

  function url(uri, loc) {
    var obj = uri;

    // default to window.location
    loc = loc || typeof location !== 'undefined' && location;
    if (null == uri) uri = loc.protocol + '//' + loc.host;

    // relative path support
    if ('string' === typeof uri) {
      if ('/' === uri.charAt(0)) {
        if ('/' === uri.charAt(1)) {
          uri = loc.protocol + uri;
        } else {
          uri = loc.host + uri;
        }
      }

      if (!/^(https?|wss?):\/\//.test(uri)) {
        debug('protocol-less url %s', uri);
        if ('undefined' !== typeof loc) {
          uri = loc.protocol + '//' + uri;
        } else {
          uri = 'https://' + uri;
        }
      }

      // parse
      debug('parse %s', uri);
      obj = parseuri(uri);
    }

    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
      if (/^(http|ws)$/.test(obj.protocol)) {
        obj.port = '80';
      } else if (/^(http|ws)s$/.test(obj.protocol)) {
        obj.port = '443';
      }
    }

    obj.path = obj.path || '/';

    var ipv6 = obj.host.indexOf(':') !== -1;
    var host = ipv6 ? '[' + obj.host + ']' : obj.host;

    // define unique id
    obj.id = obj.protocol + '://' + host + ':' + obj.port;
    // define href
    obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : ':' + obj.port);

    return obj;
  }
});
$__System.registerDynamic('c3', ['c4', 'c5', 'c6', 'c7', 'c2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var XMLHttpRequest = $__require('c4');
  var Polling = $__require('c5');
  var Emitter = $__require('c6');
  var inherit = $__require('c7');
  var debug = $__require('c2')('engine.io-client:polling-xhr');
  module.exports = XHR;
  module.exports.Request = Request;
  function empty() {}
  function XHR(opts) {
    Polling.call(this, opts);
    this.requestTimeout = opts.requestTimeout;
    this.extraHeaders = opts.extraHeaders;
    if (typeof location !== 'undefined') {
      var isSSL = 'https:' === location.protocol;
      var port = location.port;
      if (!port) {
        port = isSSL ? 443 : 80;
      }
      this.xd = typeof location !== 'undefined' && opts.hostname !== location.hostname || port !== opts.port;
      this.xs = opts.secure !== isSSL;
    }
  }
  inherit(XHR, Polling);
  XHR.prototype.supportsBinary = true;
  XHR.prototype.request = function (opts) {
    opts = opts || {};
    opts.uri = this.uri();
    opts.xd = this.xd;
    opts.xs = this.xs;
    opts.agent = this.agent || false;
    opts.supportsBinary = this.supportsBinary;
    opts.enablesXDR = this.enablesXDR;
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    opts.requestTimeout = this.requestTimeout;
    opts.extraHeaders = this.extraHeaders;
    return new Request(opts);
  };
  XHR.prototype.doWrite = function (data, fn) {
    var isBinary = typeof data !== 'string' && data !== undefined;
    var req = this.request({
      method: 'POST',
      data: data,
      isBinary: isBinary
    });
    var self = this;
    req.on('success', fn);
    req.on('error', function (err) {
      self.onError('xhr post error', err);
    });
    this.sendXhr = req;
  };
  XHR.prototype.doPoll = function () {
    debug('xhr poll');
    var req = this.request();
    var self = this;
    req.on('data', function (data) {
      self.onData(data);
    });
    req.on('error', function (err) {
      self.onError('xhr poll error', err);
    });
    this.pollXhr = req;
  };
  function Request(opts) {
    this.method = opts.method || 'GET';
    this.uri = opts.uri;
    this.xd = !!opts.xd;
    this.xs = !!opts.xs;
    this.async = false !== opts.async;
    this.data = undefined !== opts.data ? opts.data : null;
    this.agent = opts.agent;
    this.isBinary = opts.isBinary;
    this.supportsBinary = opts.supportsBinary;
    this.enablesXDR = opts.enablesXDR;
    this.requestTimeout = opts.requestTimeout;
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    this.extraHeaders = opts.extraHeaders;
    this.create();
  }
  Emitter(Request.prototype);
  Request.prototype.create = function () {
    var opts = {
      agent: this.agent,
      xdomain: this.xd,
      xscheme: this.xs,
      enablesXDR: this.enablesXDR
    };
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    var xhr = this.xhr = new XMLHttpRequest(opts);
    var self = this;
    try {
      debug('xhr open %s: %s', this.method, this.uri);
      xhr.open(this.method, this.uri, this.async);
      try {
        if (this.extraHeaders) {
          xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
          for (var i in this.extraHeaders) {
            if (this.extraHeaders.hasOwnProperty(i)) {
              xhr.setRequestHeader(i, this.extraHeaders[i]);
            }
          }
        }
      } catch (e) {}
      if ('POST' === this.method) {
        try {
          if (this.isBinary) {
            xhr.setRequestHeader('Content-type', 'application/octet-stream');
          } else {
            xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
          }
        } catch (e) {}
      }
      try {
        xhr.setRequestHeader('Accept', '*/*');
      } catch (e) {}
      if ('withCredentials' in xhr) {
        xhr.withCredentials = true;
      }
      if (this.requestTimeout) {
        xhr.timeout = this.requestTimeout;
      }
      if (this.hasXDR()) {
        xhr.onload = function () {
          self.onLoad();
        };
        xhr.onerror = function () {
          self.onError(xhr.responseText);
        };
      } else {
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 2) {
            try {
              var contentType = xhr.getResponseHeader('Content-Type');
              if (self.supportsBinary && contentType === 'application/octet-stream') {
                xhr.responseType = 'arraybuffer';
              }
            } catch (e) {}
          }
          if (4 !== xhr.readyState) return;
          if (200 === xhr.status || 1223 === xhr.status) {
            self.onLoad();
          } else {
            setTimeout(function () {
              self.onError(xhr.status);
            }, 0);
          }
        };
      }
      debug('xhr data %s', this.data);
      xhr.send(this.data);
    } catch (e) {
      setTimeout(function () {
        self.onError(e);
      }, 0);
      return;
    }
    if (typeof document !== 'undefined') {
      this.index = Request.requestsCount++;
      Request.requests[this.index] = this;
    }
  };
  Request.prototype.onSuccess = function () {
    this.emit('success');
    this.cleanup();
  };
  Request.prototype.onData = function (data) {
    this.emit('data', data);
    this.onSuccess();
  };
  Request.prototype.onError = function (err) {
    this.emit('error', err);
    this.cleanup(true);
  };
  Request.prototype.cleanup = function (fromError) {
    if ('undefined' === typeof this.xhr || null === this.xhr) {
      return;
    }
    if (this.hasXDR()) {
      this.xhr.onload = this.xhr.onerror = empty;
    } else {
      this.xhr.onreadystatechange = empty;
    }
    if (fromError) {
      try {
        this.xhr.abort();
      } catch (e) {}
    }
    if (typeof document !== 'undefined') {
      delete Request.requests[this.index];
    }
    this.xhr = null;
  };
  Request.prototype.onLoad = function () {
    var data;
    try {
      var contentType;
      try {
        contentType = this.xhr.getResponseHeader('Content-Type');
      } catch (e) {}
      if (contentType === 'application/octet-stream') {
        data = this.xhr.response || this.xhr.responseText;
      } else {
        data = this.xhr.responseText;
      }
    } catch (e) {
      this.onError(e);
    }
    if (null != data) {
      this.onData(data);
    }
  };
  Request.prototype.hasXDR = function () {
    return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
  };
  Request.prototype.abort = function () {
    this.cleanup();
  };
  Request.requestsCount = 0;
  Request.requests = {};
  if (typeof document !== 'undefined') {
    if (typeof attachEvent === 'function') {
      attachEvent('onunload', unloadHandler);
    } else if (typeof addEventListener === 'function') {
      var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
      addEventListener(terminationEvent, unloadHandler, false);
    }
  }
  function unloadHandler() {
    for (var i in Request.requests) {
      if (Request.requests.hasOwnProperty(i)) {
        Request.requests[i].abort();
      }
    }
  }
});
$__System.registerDynamic('c8', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Module exports.
   *
   * Logic borrowed from Modernizr:
   *
   *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
   */

  try {
    module.exports = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
  } catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
    module.exports = false;
  }
});
$__System.registerDynamic("c9", ["c8"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("c8");
});
$__System.registerDynamic('c4', ['c9'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // browser shim for xmlhttprequest module

  var hasCORS = $__require('c9');

  module.exports = function (opts) {
    var xdomain = opts.xdomain;

    // scheme must be same when usign XDomainRequest
    // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
    var xscheme = opts.xscheme;

    // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
    // https://github.com/Automattic/engine.io-client/pull/217
    var enablesXDR = opts.enablesXDR;

    // XMLHttpRequest can be disabled on IE
    try {
      if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
        return new XMLHttpRequest();
      }
    } catch (e) {}

    // Use XDomainRequest for IE8 if enablesXDR is true
    // because loading bar keeps flashing when using jsonp-polling
    // https://github.com/yujiosaka/socke.io-ie8-loading-example
    try {
      if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
        return new XDomainRequest();
      }
    } catch (e) {}

    if (!xdomain) {
      try {
        return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
      } catch (e) {}
    }
  };
});
$__System.registerDynamic('c5', ['ca', 'cc', 'cd', 'c7', 'cb', 'c2', 'c4'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var Transport = $__require('ca');
  var parseqs = $__require('cc');
  var parser = $__require('cd');
  var inherit = $__require('c7');
  var yeast = $__require('cb');
  var debug = $__require('c2')('engine.io-client:polling');
  module.exports = Polling;
  var hasXHR2 = function () {
    var XMLHttpRequest = $__require('c4');
    var xhr = new XMLHttpRequest({ xdomain: false });
    return null != xhr.responseType;
  }();
  function Polling(opts) {
    var forceBase64 = opts && opts.forceBase64;
    if (!hasXHR2 || forceBase64) {
      this.supportsBinary = false;
    }
    Transport.call(this, opts);
  }
  inherit(Polling, Transport);
  Polling.prototype.name = 'polling';
  Polling.prototype.doOpen = function () {
    this.poll();
  };
  Polling.prototype.pause = function (onPause) {
    var self = this;
    this.readyState = 'pausing';
    function pause() {
      debug('paused');
      self.readyState = 'paused';
      onPause();
    }
    if (this.polling || !this.writable) {
      var total = 0;
      if (this.polling) {
        debug('we are currently polling - waiting to pause');
        total++;
        this.once('pollComplete', function () {
          debug('pre-pause polling complete');
          --total || pause();
        });
      }
      if (!this.writable) {
        debug('we are currently writing - waiting to pause');
        total++;
        this.once('drain', function () {
          debug('pre-pause writing complete');
          --total || pause();
        });
      }
    } else {
      pause();
    }
  };
  Polling.prototype.poll = function () {
    debug('polling');
    this.polling = true;
    this.doPoll();
    this.emit('poll');
  };
  Polling.prototype.onData = function (data) {
    var self = this;
    debug('polling got data %s', data);
    var callback = function (packet, index, total) {
      if ('opening' === self.readyState) {
        self.onOpen();
      }
      if ('close' === packet.type) {
        self.onClose();
        return false;
      }
      self.onPacket(packet);
    };
    parser.decodePayload(data, this.socket.binaryType, callback);
    if ('closed' !== this.readyState) {
      this.polling = false;
      this.emit('pollComplete');
      if ('open' === this.readyState) {
        this.poll();
      } else {
        debug('ignoring poll - transport state "%s"', this.readyState);
      }
    }
  };
  Polling.prototype.doClose = function () {
    var self = this;
    function close() {
      debug('writing close packet');
      self.write([{ type: 'close' }]);
    }
    if ('open' === this.readyState) {
      debug('transport open - closing');
      close();
    } else {
      debug('transport not open - deferring close');
      this.once('open', close);
    }
  };
  Polling.prototype.write = function (packets) {
    var self = this;
    this.writable = false;
    var callbackfn = function () {
      self.writable = true;
      self.emit('drain');
    };
    parser.encodePayload(packets, this.supportsBinary, function (data) {
      self.doWrite(data, callbackfn);
    });
  };
  Polling.prototype.uri = function () {
    var query = this.query || {};
    var schema = this.secure ? 'https' : 'http';
    var port = '';
    if (false !== this.timestampRequests) {
      query[this.timestampParam] = yeast();
    }
    if (!this.supportsBinary && !query.sid) {
      query.b64 = 1;
    }
    query = parseqs.encode(query);
    if (this.port && ('https' === schema && Number(this.port) !== 443 || 'http' === schema && Number(this.port) !== 80)) {
      port = ':' + this.port;
    }
    if (query.length) {
      query = '?' + query;
    }
    var ipv6 = this.hostname.indexOf(':') !== -1;
    return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
  };
});
$__System.registerDynamic('ce', ['c5', 'c7'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var Polling = $__require('c5');
  var inherit = $__require('c7');
  module.exports = JSONPPolling;
  var rNewline = /\n/g;
  var rEscapedNewline = /\\n/g;
  var callbacks;
  function empty() {}
  function glob() {
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
  }
  function JSONPPolling(opts) {
    Polling.call(this, opts);
    this.query = this.query || {};
    if (!callbacks) {
      var global = glob();
      callbacks = global.___eio = global.___eio || [];
    }
    this.index = callbacks.length;
    var self = this;
    callbacks.push(function (msg) {
      self.onData(msg);
    });
    this.query.j = this.index;
    if (typeof addEventListener === 'function') {
      addEventListener('beforeunload', function () {
        if (self.script) self.script.onerror = empty;
      }, false);
    }
  }
  inherit(JSONPPolling, Polling);
  JSONPPolling.prototype.supportsBinary = false;
  JSONPPolling.prototype.doClose = function () {
    if (this.script) {
      this.script.parentNode.removeChild(this.script);
      this.script = null;
    }
    if (this.form) {
      this.form.parentNode.removeChild(this.form);
      this.form = null;
      this.iframe = null;
    }
    Polling.prototype.doClose.call(this);
  };
  JSONPPolling.prototype.doPoll = function () {
    var self = this;
    var script = document.createElement('script');
    if (this.script) {
      this.script.parentNode.removeChild(this.script);
      this.script = null;
    }
    script.async = true;
    script.src = this.uri();
    script.onerror = function (e) {
      self.onError('jsonp poll error', e);
    };
    var insertAt = document.getElementsByTagName('script')[0];
    if (insertAt) {
      insertAt.parentNode.insertBefore(script, insertAt);
    } else {
      (document.head || document.body).appendChild(script);
    }
    this.script = script;
    var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
    if (isUAgecko) {
      setTimeout(function () {
        var iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        document.body.removeChild(iframe);
      }, 100);
    }
  };
  JSONPPolling.prototype.doWrite = function (data, fn) {
    var self = this;
    if (!this.form) {
      var form = document.createElement('form');
      var area = document.createElement('textarea');
      var id = this.iframeId = 'eio_iframe_' + this.index;
      var iframe;
      form.className = 'socketio';
      form.style.position = 'absolute';
      form.style.top = '-1000px';
      form.style.left = '-1000px';
      form.target = id;
      form.method = 'POST';
      form.setAttribute('accept-charset', 'utf-8');
      area.name = 'd';
      form.appendChild(area);
      document.body.appendChild(form);
      this.form = form;
      this.area = area;
    }
    this.form.action = this.uri();
    function complete() {
      initIframe();
      fn();
    }
    function initIframe() {
      if (self.iframe) {
        try {
          self.form.removeChild(self.iframe);
        } catch (e) {
          self.onError('jsonp polling iframe removal error', e);
        }
      }
      try {
        var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
        iframe = document.createElement(html);
      } catch (e) {
        iframe = document.createElement('iframe');
        iframe.name = self.iframeId;
        iframe.src = 'javascript:0';
      }
      iframe.id = self.iframeId;
      self.form.appendChild(iframe);
      self.iframe = iframe;
    }
    initIframe();
    data = data.replace(rEscapedNewline, '\\\n');
    this.area.value = data.replace(rNewline, '\\n');
    try {
      this.form.submit();
    } catch (e) {}
    if (this.iframe.attachEvent) {
      this.iframe.onreadystatechange = function () {
        if (self.iframe.readyState === 'complete') {
          complete();
        }
      };
    } else {
      this.iframe.onload = complete;
    }
  };
});
$__System.registerDynamic("cf", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */

  module.exports = function (a, b) {
    var fn = function () {};
    fn.prototype = b.prototype;
    a.prototype = new fn();
    a.prototype.constructor = a;
  };
});
$__System.registerDynamic("c7", ["cf"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("cf");
});
$__System.registerDynamic('d0', [], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''),
      length = 64,
      map = {},
      seed = 0,
      i = 0,
      prev;

  /**
   * Return a string representing the specified number.
   *
   * @param {Number} num The number to convert.
   * @returns {String} The string representation of the number.
   * @api public
   */
  function encode(num) {
    var encoded = '';

    do {
      encoded = alphabet[num % length] + encoded;
      num = Math.floor(num / length);
    } while (num > 0);

    return encoded;
  }

  /**
   * Return the integer value specified by the given string.
   *
   * @param {String} str The string to convert.
   * @returns {Number} The integer value represented by the string.
   * @api public
   */
  function decode(str) {
    var decoded = 0;

    for (i = 0; i < str.length; i++) {
      decoded = decoded * length + map[str.charAt(i)];
    }

    return decoded;
  }

  /**
   * Yeast: A tiny growing id generator.
   *
   * @returns {String} A unique id.
   * @api public
   */
  function yeast() {
    var now = encode(+new Date());

    if (now !== prev) return seed = 0, prev = now;
    return now + '.' + encode(seed++);
  }

  //
  // Map each character to its index.
  //
  for (; i < length; i++) map[alphabet[i]] = i;

  //
  // Expose the `yeast`, `encode` and `decode` functions.
  //
  yeast.encode = encode;
  yeast.decode = decode;
  module.exports = yeast;
});
$__System.registerDynamic("cb", ["d0"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("d0");
});
$__System.registerDynamic('d1', ['ca', 'cd', 'cc', 'c7', 'cb', 'c2', '@empty', 'd2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (Buffer) {
    var Transport = $__require('ca');
    var parser = $__require('cd');
    var parseqs = $__require('cc');
    var inherit = $__require('c7');
    var yeast = $__require('cb');
    var debug = $__require('c2')('engine.io-client:websocket');
    var BrowserWebSocket, NodeWebSocket;
    if (typeof WebSocket !== 'undefined') {
      BrowserWebSocket = WebSocket;
    } else if (typeof self !== 'undefined') {
      BrowserWebSocket = self.WebSocket || self.MozWebSocket;
    } else {
      try {
        NodeWebSocket = $__require('@empty');
      } catch (e) {}
    }
    var WebSocketImpl = BrowserWebSocket || NodeWebSocket;
    module.exports = WS;
    function WS(opts) {
      var forceBase64 = opts && opts.forceBase64;
      if (forceBase64) {
        this.supportsBinary = false;
      }
      this.perMessageDeflate = opts.perMessageDeflate;
      this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
      this.protocols = opts.protocols;
      if (!this.usingBrowserWebSocket) {
        WebSocketImpl = NodeWebSocket;
      }
      Transport.call(this, opts);
    }
    inherit(WS, Transport);
    WS.prototype.name = 'websocket';
    WS.prototype.supportsBinary = true;
    WS.prototype.doOpen = function () {
      if (!this.check()) {
        return;
      }
      var uri = this.uri();
      var protocols = this.protocols;
      var opts = {
        agent: this.agent,
        perMessageDeflate: this.perMessageDeflate
      };
      opts.pfx = this.pfx;
      opts.key = this.key;
      opts.passphrase = this.passphrase;
      opts.cert = this.cert;
      opts.ca = this.ca;
      opts.ciphers = this.ciphers;
      opts.rejectUnauthorized = this.rejectUnauthorized;
      if (this.extraHeaders) {
        opts.headers = this.extraHeaders;
      }
      if (this.localAddress) {
        opts.localAddress = this.localAddress;
      }
      try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? protocols ? new WebSocketImpl(uri, protocols) : new WebSocketImpl(uri) : new WebSocketImpl(uri, protocols, opts);
      } catch (err) {
        return this.emit('error', err);
      }
      if (this.ws.binaryType === undefined) {
        this.supportsBinary = false;
      }
      if (this.ws.supports && this.ws.supports.binary) {
        this.supportsBinary = true;
        this.ws.binaryType = 'nodebuffer';
      } else {
        this.ws.binaryType = 'arraybuffer';
      }
      this.addEventListeners();
    };
    WS.prototype.addEventListeners = function () {
      var self = this;
      this.ws.onopen = function () {
        self.onOpen();
      };
      this.ws.onclose = function () {
        self.onClose();
      };
      this.ws.onmessage = function (ev) {
        self.onData(ev.data);
      };
      this.ws.onerror = function (e) {
        self.onError('websocket error', e);
      };
    };
    WS.prototype.write = function (packets) {
      var self = this;
      this.writable = false;
      var total = packets.length;
      for (var i = 0, l = total; i < l; i++) {
        (function (packet) {
          parser.encodePacket(packet, self.supportsBinary, function (data) {
            if (!self.usingBrowserWebSocket) {
              var opts = {};
              if (packet.options) {
                opts.compress = packet.options.compress;
              }
              if (self.perMessageDeflate) {
                var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
                if (len < self.perMessageDeflate.threshold) {
                  opts.compress = false;
                }
              }
            }
            try {
              if (self.usingBrowserWebSocket) {
                self.ws.send(data);
              } else {
                self.ws.send(data, opts);
              }
            } catch (e) {
              debug('websocket closed before onclose event');
            }
            --total || done();
          });
        })(packets[i]);
      }
      function done() {
        self.emit('flush');
        setTimeout(function () {
          self.writable = true;
          self.emit('drain');
        }, 0);
      }
    };
    WS.prototype.onClose = function () {
      Transport.prototype.onClose.call(this);
    };
    WS.prototype.doClose = function () {
      if (typeof this.ws !== 'undefined') {
        this.ws.close();
      }
    };
    WS.prototype.uri = function () {
      var query = this.query || {};
      var schema = this.secure ? 'wss' : 'ws';
      var port = '';
      if (this.port && ('wss' === schema && Number(this.port) !== 443 || 'ws' === schema && Number(this.port) !== 80)) {
        port = ':' + this.port;
      }
      if (this.timestampRequests) {
        query[this.timestampParam] = yeast();
      }
      if (!this.supportsBinary) {
        query.b64 = 1;
      }
      query = parseqs.encode(query);
      if (query.length) {
        query = '?' + query;
      }
      var ipv6 = this.hostname.indexOf(':') !== -1;
      return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
    };
    WS.prototype.check = function () {
      return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
    };
  })($__require('d2').Buffer);
});
$__System.registerDynamic('d3', ['c4', 'c3', 'ce', 'd1'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var XMLHttpRequest = $__require('c4');
  var XHR = $__require('c3');
  var JSONP = $__require('ce');
  var websocket = $__require('d1');
  exports.polling = polling;
  exports.websocket = websocket;
  function polling(opts) {
    var xhr;
    var xd = false;
    var xs = false;
    var jsonp = false !== opts.jsonp;
    if (typeof location !== 'undefined') {
      var isSSL = 'https:' === location.protocol;
      var port = location.port;
      if (!port) {
        port = isSSL ? 443 : 80;
      }
      xd = opts.hostname !== location.hostname || port !== opts.port;
      xs = opts.secure !== isSSL;
    }
    opts.xdomain = xd;
    opts.xscheme = xs;
    xhr = new XMLHttpRequest(opts);
    if ('open' in xhr && !opts.forceJSONP) {
      return new XHR(opts);
    } else {
      if (!jsonp) throw new Error('JSONP disabled');
      return new JSONP(opts);
    }
  }
});
$__System.registerDynamic('d4', [], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /**
     * Parses an URI
     *
     * @author Steven Levithan <stevenlevithan.com> (MIT license)
     * @api private
     */

    var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

    var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];

    module.exports = function parseuri(str) {
        var src = str,
            b = str.indexOf('['),
            e = str.indexOf(']');

        if (b != -1 && e != -1) {
            str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
        }

        var m = re.exec(str || ''),
            uri = {},
            i = 14;

        while (i--) {
            uri[parts[i]] = m[i] || '';
        }

        if (b != -1 && e != -1) {
            uri.source = src;
            uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
            uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
            uri.ipv6uri = true;
        }

        return uri;
    };
});
$__System.registerDynamic("c1", ["d4"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("d4");
});
$__System.registerDynamic('ca', ['cd', 'c6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * Module dependencies.
   */

  var parser = $__require('cd');
  var Emitter = $__require('c6');

  /**
   * Module exports.
   */

  module.exports = Transport;

  /**
   * Transport abstract constructor.
   *
   * @param {Object} options.
   * @api private
   */

  function Transport(opts) {
    this.path = opts.path;
    this.hostname = opts.hostname;
    this.port = opts.port;
    this.secure = opts.secure;
    this.query = opts.query;
    this.timestampParam = opts.timestampParam;
    this.timestampRequests = opts.timestampRequests;
    this.readyState = '';
    this.agent = opts.agent || false;
    this.socket = opts.socket;
    this.enablesXDR = opts.enablesXDR;

    // SSL options for Node.js client
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    this.forceNode = opts.forceNode;

    // results of ReactNative environment detection
    this.isReactNative = opts.isReactNative;

    // other options for Node.js client
    this.extraHeaders = opts.extraHeaders;
    this.localAddress = opts.localAddress;
  }

  /**
   * Mix in `Emitter`.
   */

  Emitter(Transport.prototype);

  /**
   * Emits an error.
   *
   * @param {String} str
   * @return {Transport} for chaining
   * @api public
   */

  Transport.prototype.onError = function (msg, desc) {
    var err = new Error(msg);
    err.type = 'TransportError';
    err.description = desc;
    this.emit('error', err);
    return this;
  };

  /**
   * Opens the transport.
   *
   * @api public
   */

  Transport.prototype.open = function () {
    if ('closed' === this.readyState || '' === this.readyState) {
      this.readyState = 'opening';
      this.doOpen();
    }

    return this;
  };

  /**
   * Closes the transport.
   *
   * @api private
   */

  Transport.prototype.close = function () {
    if ('opening' === this.readyState || 'open' === this.readyState) {
      this.doClose();
      this.onClose();
    }

    return this;
  };

  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   * @api private
   */

  Transport.prototype.send = function (packets) {
    if ('open' === this.readyState) {
      this.write(packets);
    } else {
      throw new Error('Transport not open');
    }
  };

  /**
   * Called upon open
   *
   * @api private
   */

  Transport.prototype.onOpen = function () {
    this.readyState = 'open';
    this.writable = true;
    this.emit('open');
  };

  /**
   * Called with data.
   *
   * @param {String} data
   * @api private
   */

  Transport.prototype.onData = function (data) {
    var packet = parser.decodePacket(data, this.socket.binaryType);
    this.onPacket(packet);
  };

  /**
   * Called with a decoded packet.
   */

  Transport.prototype.onPacket = function (packet) {
    this.emit('packet', packet);
  };

  /**
   * Called upon close.
   *
   * @api private
   */

  Transport.prototype.onClose = function () {
    this.readyState = 'closed';
    this.emit('close');
  };
});
$__System.registerDynamic('d5', ['d3', 'c6', 'c2', 'd6', 'cd', 'c1', 'cc', 'ca'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var transports = $__require('d3');
  var Emitter = $__require('c6');
  var debug = $__require('c2')('engine.io-client:socket');
  var index = $__require('d6');
  var parser = $__require('cd');
  var parseuri = $__require('c1');
  var parseqs = $__require('cc');
  module.exports = Socket;
  function Socket(uri, opts) {
    if (!(this instanceof Socket)) return new Socket(uri, opts);
    opts = opts || {};
    if (uri && 'object' === typeof uri) {
      opts = uri;
      uri = null;
    }
    if (uri) {
      uri = parseuri(uri);
      opts.hostname = uri.host;
      opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
      opts.port = uri.port;
      if (uri.query) opts.query = uri.query;
    } else if (opts.host) {
      opts.hostname = parseuri(opts.host).host;
    }
    this.secure = null != opts.secure ? opts.secure : typeof location !== 'undefined' && 'https:' === location.protocol;
    if (opts.hostname && !opts.port) {
      opts.port = this.secure ? '443' : '80';
    }
    this.agent = opts.agent || false;
    this.hostname = opts.hostname || (typeof location !== 'undefined' ? location.hostname : 'localhost');
    this.port = opts.port || (typeof location !== 'undefined' && location.port ? location.port : this.secure ? 443 : 80);
    this.query = opts.query || {};
    if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
    this.upgrade = false !== opts.upgrade;
    this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
    this.forceJSONP = !!opts.forceJSONP;
    this.jsonp = false !== opts.jsonp;
    this.forceBase64 = !!opts.forceBase64;
    this.enablesXDR = !!opts.enablesXDR;
    this.timestampParam = opts.timestampParam || 't';
    this.timestampRequests = opts.timestampRequests;
    this.transports = opts.transports || ['polling', 'websocket'];
    this.transportOptions = opts.transportOptions || {};
    this.readyState = '';
    this.writeBuffer = [];
    this.prevBufferLen = 0;
    this.policyPort = opts.policyPort || 843;
    this.rememberUpgrade = opts.rememberUpgrade || false;
    this.binaryType = null;
    this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
    this.perMessageDeflate = false !== opts.perMessageDeflate ? opts.perMessageDeflate || {} : false;
    if (true === this.perMessageDeflate) this.perMessageDeflate = {};
    if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
      this.perMessageDeflate.threshold = 1024;
    }
    this.pfx = opts.pfx || null;
    this.key = opts.key || null;
    this.passphrase = opts.passphrase || null;
    this.cert = opts.cert || null;
    this.ca = opts.ca || null;
    this.ciphers = opts.ciphers || null;
    this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
    this.forceNode = !!opts.forceNode;
    this.isReactNative = typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative';
    if (typeof self === 'undefined' || this.isReactNative) {
      if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
        this.extraHeaders = opts.extraHeaders;
      }
      if (opts.localAddress) {
        this.localAddress = opts.localAddress;
      }
    }
    this.id = null;
    this.upgrades = null;
    this.pingInterval = null;
    this.pingTimeout = null;
    this.pingIntervalTimer = null;
    this.pingTimeoutTimer = null;
    this.open();
  }
  Socket.priorWebsocketSuccess = false;
  Emitter(Socket.prototype);
  Socket.protocol = parser.protocol;
  Socket.Socket = Socket;
  Socket.Transport = $__require('ca');
  Socket.transports = $__require('d3');
  Socket.parser = $__require('cd');
  Socket.prototype.createTransport = function (name) {
    debug('creating transport "%s"', name);
    var query = clone(this.query);
    query.EIO = parser.protocol;
    query.transport = name;
    var options = this.transportOptions[name] || {};
    if (this.id) query.sid = this.id;
    var transport = new transports[name]({
      query: query,
      socket: this,
      agent: options.agent || this.agent,
      hostname: options.hostname || this.hostname,
      port: options.port || this.port,
      secure: options.secure || this.secure,
      path: options.path || this.path,
      forceJSONP: options.forceJSONP || this.forceJSONP,
      jsonp: options.jsonp || this.jsonp,
      forceBase64: options.forceBase64 || this.forceBase64,
      enablesXDR: options.enablesXDR || this.enablesXDR,
      timestampRequests: options.timestampRequests || this.timestampRequests,
      timestampParam: options.timestampParam || this.timestampParam,
      policyPort: options.policyPort || this.policyPort,
      pfx: options.pfx || this.pfx,
      key: options.key || this.key,
      passphrase: options.passphrase || this.passphrase,
      cert: options.cert || this.cert,
      ca: options.ca || this.ca,
      ciphers: options.ciphers || this.ciphers,
      rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
      perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
      extraHeaders: options.extraHeaders || this.extraHeaders,
      forceNode: options.forceNode || this.forceNode,
      localAddress: options.localAddress || this.localAddress,
      requestTimeout: options.requestTimeout || this.requestTimeout,
      protocols: options.protocols || void 0,
      isReactNative: this.isReactNative
    });
    return transport;
  };
  function clone(obj) {
    var o = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        o[i] = obj[i];
      }
    }
    return o;
  }
  Socket.prototype.open = function () {
    var transport;
    if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
      transport = 'websocket';
    } else if (0 === this.transports.length) {
      var self = this;
      setTimeout(function () {
        self.emit('error', 'No transports available');
      }, 0);
      return;
    } else {
      transport = this.transports[0];
    }
    this.readyState = 'opening';
    try {
      transport = this.createTransport(transport);
    } catch (e) {
      this.transports.shift();
      this.open();
      return;
    }
    transport.open();
    this.setTransport(transport);
  };
  Socket.prototype.setTransport = function (transport) {
    debug('setting transport %s', transport.name);
    var self = this;
    if (this.transport) {
      debug('clearing existing transport %s', this.transport.name);
      this.transport.removeAllListeners();
    }
    this.transport = transport;
    transport.on('drain', function () {
      self.onDrain();
    }).on('packet', function (packet) {
      self.onPacket(packet);
    }).on('error', function (e) {
      self.onError(e);
    }).on('close', function () {
      self.onClose('transport close');
    });
  };
  Socket.prototype.probe = function (name) {
    debug('probing transport "%s"', name);
    var transport = this.createTransport(name, { probe: 1 });
    var failed = false;
    var self = this;
    Socket.priorWebsocketSuccess = false;
    function onTransportOpen() {
      if (self.onlyBinaryUpgrades) {
        var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
        failed = failed || upgradeLosesBinary;
      }
      if (failed) return;
      debug('probe transport "%s" opened', name);
      transport.send([{
        type: 'ping',
        data: 'probe'
      }]);
      transport.once('packet', function (msg) {
        if (failed) return;
        if ('pong' === msg.type && 'probe' === msg.data) {
          debug('probe transport "%s" pong', name);
          self.upgrading = true;
          self.emit('upgrading', transport);
          if (!transport) return;
          Socket.priorWebsocketSuccess = 'websocket' === transport.name;
          debug('pausing current transport "%s"', self.transport.name);
          self.transport.pause(function () {
            if (failed) return;
            if ('closed' === self.readyState) return;
            debug('changing transport and sending upgrade packet');
            cleanup();
            self.setTransport(transport);
            transport.send([{ type: 'upgrade' }]);
            self.emit('upgrade', transport);
            transport = null;
            self.upgrading = false;
            self.flush();
          });
        } else {
          debug('probe transport "%s" failed', name);
          var err = new Error('probe error');
          err.transport = transport.name;
          self.emit('upgradeError', err);
        }
      });
    }
    function freezeTransport() {
      if (failed) return;
      failed = true;
      cleanup();
      transport.close();
      transport = null;
    }
    function onerror(err) {
      var error = new Error('probe error: ' + err);
      error.transport = transport.name;
      freezeTransport();
      debug('probe transport "%s" failed because of error: %s', name, err);
      self.emit('upgradeError', error);
    }
    function onTransportClose() {
      onerror('transport closed');
    }
    function onclose() {
      onerror('socket closed');
    }
    function onupgrade(to) {
      if (transport && to.name !== transport.name) {
        debug('"%s" works - aborting "%s"', to.name, transport.name);
        freezeTransport();
      }
    }
    function cleanup() {
      transport.removeListener('open', onTransportOpen);
      transport.removeListener('error', onerror);
      transport.removeListener('close', onTransportClose);
      self.removeListener('close', onclose);
      self.removeListener('upgrading', onupgrade);
    }
    transport.once('open', onTransportOpen);
    transport.once('error', onerror);
    transport.once('close', onTransportClose);
    this.once('close', onclose);
    this.once('upgrading', onupgrade);
    transport.open();
  };
  Socket.prototype.onOpen = function () {
    debug('socket open');
    this.readyState = 'open';
    Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
    this.emit('open');
    this.flush();
    if ('open' === this.readyState && this.upgrade && this.transport.pause) {
      debug('starting upgrade probes');
      for (var i = 0, l = this.upgrades.length; i < l; i++) {
        this.probe(this.upgrades[i]);
      }
    }
  };
  Socket.prototype.onPacket = function (packet) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
      debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
      this.emit('packet', packet);
      this.emit('heartbeat');
      switch (packet.type) {
        case 'open':
          this.onHandshake(JSON.parse(packet.data));
          break;
        case 'pong':
          this.setPing();
          this.emit('pong');
          break;
        case 'error':
          var err = new Error('server error');
          err.code = packet.data;
          this.onError(err);
          break;
        case 'message':
          this.emit('data', packet.data);
          this.emit('message', packet.data);
          break;
      }
    } else {
      debug('packet received with socket readyState "%s"', this.readyState);
    }
  };
  Socket.prototype.onHandshake = function (data) {
    this.emit('handshake', data);
    this.id = data.sid;
    this.transport.query.sid = data.sid;
    this.upgrades = this.filterUpgrades(data.upgrades);
    this.pingInterval = data.pingInterval;
    this.pingTimeout = data.pingTimeout;
    this.onOpen();
    if ('closed' === this.readyState) return;
    this.setPing();
    this.removeListener('heartbeat', this.onHeartbeat);
    this.on('heartbeat', this.onHeartbeat);
  };
  Socket.prototype.onHeartbeat = function (timeout) {
    clearTimeout(this.pingTimeoutTimer);
    var self = this;
    self.pingTimeoutTimer = setTimeout(function () {
      if ('closed' === self.readyState) return;
      self.onClose('ping timeout');
    }, timeout || self.pingInterval + self.pingTimeout);
  };
  Socket.prototype.setPing = function () {
    var self = this;
    clearTimeout(self.pingIntervalTimer);
    self.pingIntervalTimer = setTimeout(function () {
      debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
      self.ping();
      self.onHeartbeat(self.pingTimeout);
    }, self.pingInterval);
  };
  Socket.prototype.ping = function () {
    var self = this;
    this.sendPacket('ping', function () {
      self.emit('ping');
    });
  };
  Socket.prototype.onDrain = function () {
    this.writeBuffer.splice(0, this.prevBufferLen);
    this.prevBufferLen = 0;
    if (0 === this.writeBuffer.length) {
      this.emit('drain');
    } else {
      this.flush();
    }
  };
  Socket.prototype.flush = function () {
    if ('closed' !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      debug('flushing %d packets in socket', this.writeBuffer.length);
      this.transport.send(this.writeBuffer);
      this.prevBufferLen = this.writeBuffer.length;
      this.emit('flush');
    }
  };
  Socket.prototype.write = Socket.prototype.send = function (msg, options, fn) {
    this.sendPacket('message', msg, options, fn);
    return this;
  };
  Socket.prototype.sendPacket = function (type, data, options, fn) {
    if ('function' === typeof data) {
      fn = data;
      data = undefined;
    }
    if ('function' === typeof options) {
      fn = options;
      options = null;
    }
    if ('closing' === this.readyState || 'closed' === this.readyState) {
      return;
    }
    options = options || {};
    options.compress = false !== options.compress;
    var packet = {
      type: type,
      data: data,
      options: options
    };
    this.emit('packetCreate', packet);
    this.writeBuffer.push(packet);
    if (fn) this.once('flush', fn);
    this.flush();
  };
  Socket.prototype.close = function () {
    if ('opening' === this.readyState || 'open' === this.readyState) {
      this.readyState = 'closing';
      var self = this;
      if (this.writeBuffer.length) {
        this.once('drain', function () {
          if (this.upgrading) {
            waitForUpgrade();
          } else {
            close();
          }
        });
      } else if (this.upgrading) {
        waitForUpgrade();
      } else {
        close();
      }
    }
    function close() {
      self.onClose('forced close');
      debug('socket closing - telling transport to close');
      self.transport.close();
    }
    function cleanupAndClose() {
      self.removeListener('upgrade', cleanupAndClose);
      self.removeListener('upgradeError', cleanupAndClose);
      close();
    }
    function waitForUpgrade() {
      self.once('upgrade', cleanupAndClose);
      self.once('upgradeError', cleanupAndClose);
    }
    return this;
  };
  Socket.prototype.onError = function (err) {
    debug('socket error %j', err);
    Socket.priorWebsocketSuccess = false;
    this.emit('error', err);
    this.onClose('transport error', err);
  };
  Socket.prototype.onClose = function (reason, desc) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
      debug('socket close with reason: "%s"', reason);
      var self = this;
      clearTimeout(this.pingIntervalTimer);
      clearTimeout(this.pingTimeoutTimer);
      this.transport.removeAllListeners('close');
      this.transport.close();
      this.transport.removeAllListeners();
      this.readyState = 'closed';
      this.id = null;
      this.emit('close', reason, desc);
      self.writeBuffer = [];
      self.prevBufferLen = 0;
    }
  };
  Socket.prototype.filterUpgrades = function (upgrades) {
    var filteredUpgrades = [];
    for (var i = 0, j = upgrades.length; i < j; i++) {
      if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
    }
    return filteredUpgrades;
  };
});
$__System.registerDynamic("d7", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Gets the keys for an object.
   *
   * @return {Array} keys
   * @api private
   */

  module.exports = Object.keys || function keys(obj) {
    var arr = [];
    var has = Object.prototype.hasOwnProperty;

    for (var i in obj) {
      if (has.call(obj, i)) {
        arr.push(i);
      }
    }
    return arr;
  };
});
$__System.registerDynamic("d8", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * An abstraction for slicing an arraybuffer even when
   * ArrayBuffer.prototype.slice is not supported
   *
   * @api public
   */

  module.exports = function (arraybuffer, start, end) {
    var bytes = arraybuffer.byteLength;
    start = start || 0;
    end = end || bytes;

    if (arraybuffer.slice) {
      return arraybuffer.slice(start, end);
    }

    if (start < 0) {
      start += bytes;
    }
    if (end < 0) {
      end += bytes;
    }
    if (end > bytes) {
      end = bytes;
    }

    if (start >= bytes || start >= end || bytes === 0) {
      return new ArrayBuffer(0);
    }

    var abv = new Uint8Array(arraybuffer);
    var result = new Uint8Array(end - start);
    for (var i = start, ii = 0; i < end; i++, ii++) {
      result[ii] = abv[i];
    }
    return result.buffer;
  };
});
$__System.registerDynamic("d9", ["d8"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("d8");
});
$__System.registerDynamic('da', [], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    module.exports = after;

    function after(count, callback, err_cb) {
        var bail = false;
        err_cb = err_cb || noop;
        proxy.count = count;

        return count === 0 ? callback() : proxy;

        function proxy(err, result) {
            if (proxy.count <= 0) {
                throw new Error('after called too many times');
            }
            --proxy.count;

            // after first error, rest are passed to err_cb
            if (err) {
                bail = true;
                callback(err);
                // future error callbacks will go to error handler
                callback = err_cb;
            } else if (proxy.count === 0 && !bail) {
                callback(null, result);
            }
        }
    }

    function noop() {}
});
$__System.registerDynamic("db", ["da"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("da");
});
$__System.registerDynamic('dc', [], true, function ($__require, exports, module) {
	var global = this || self,
	    GLOBAL = global;
	/*! https://mths.be/utf8js v2.1.2 by @mathias */

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() + ' is not a scalar value');
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
	}

	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) {
			// 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) {
			// 2-byte sequence
			symbol = stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
		} else if ((codePoint & 0xFFFF0000) == 0) {
			// 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
			symbol += createByte(codePoint, 6);
		} else if ((codePoint & 0xFFE00000) == 0) {
			// 4-byte sequence
			symbol = stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode(codePoint & 0x3F | 0x80);
		return symbol;
	}

	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = (byte1 & 0x1F) << 6 | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	module.exports = {
		version: '2.1.2',
		encode: utf8encode,
		decode: utf8decode
	};
});
$__System.registerDynamic("dd", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */
  (function () {
    "use strict";

    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

    // Use a lookup table to find the index.
    var lookup = new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
      lookup[chars.charCodeAt(i)] = i;
    }

    exports.encode = function (arraybuffer) {
      var bytes = new Uint8Array(arraybuffer),
          i,
          len = bytes.length,
          base64 = "";

      for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
      }

      if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + "=";
      } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + "==";
      }

      return base64;
    };

    exports.decode = function (base64) {
      var bufferLength = base64.length * 0.75,
          len = base64.length,
          i,
          p = 0,
          encoded1,
          encoded2,
          encoded3,
          encoded4;

      if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") {
          bufferLength--;
        }
      }

      var arraybuffer = new ArrayBuffer(bufferLength),
          bytes = new Uint8Array(arraybuffer);

      for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];

        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
      }

      return arraybuffer;
    };
  })();
});
$__System.registerDynamic("de", ["dd"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("dd");
});
$__System.registerDynamic('df', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * Create a blob builder even when vendor prefixes exist
   */

  var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : false;

  /**
   * Check if Blob constructor is supported
   */

  var blobSupported = function () {
    try {
      var a = new Blob(['hi']);
      return a.size === 2;
    } catch (e) {
      return false;
    }
  }();

  /**
   * Check if Blob constructor supports ArrayBufferViews
   * Fails in Safari 6, so we need to map to ArrayBuffers there.
   */

  var blobSupportsArrayBufferView = blobSupported && function () {
    try {
      var b = new Blob([new Uint8Array([1, 2])]);
      return b.size === 2;
    } catch (e) {
      return false;
    }
  }();

  /**
   * Check if BlobBuilder is supported
   */

  var blobBuilderSupported = BlobBuilder && BlobBuilder.prototype.append && BlobBuilder.prototype.getBlob;

  /**
   * Helper function that maps ArrayBufferViews to ArrayBuffers
   * Used by BlobBuilder constructor and old browsers that didn't
   * support it in the Blob constructor.
   */

  function mapArrayBufferViews(ary) {
    return ary.map(function (chunk) {
      if (chunk.buffer instanceof ArrayBuffer) {
        var buf = chunk.buffer;

        // if this is a subarray, make a copy so we only
        // include the subarray region from the underlying buffer
        if (chunk.byteLength !== buf.byteLength) {
          var copy = new Uint8Array(chunk.byteLength);
          copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
          buf = copy.buffer;
        }

        return buf;
      }

      return chunk;
    });
  }

  function BlobBuilderConstructor(ary, options) {
    options = options || {};

    var bb = new BlobBuilder();
    mapArrayBufferViews(ary).forEach(function (part) {
      bb.append(part);
    });

    return options.type ? bb.getBlob(options.type) : bb.getBlob();
  };

  function BlobConstructor(ary, options) {
    return new Blob(mapArrayBufferViews(ary), options || {});
  };

  if (typeof Blob !== 'undefined') {
    BlobBuilderConstructor.prototype = Blob.prototype;
    BlobConstructor.prototype = Blob.prototype;
  }

  module.exports = function () {
    if (blobSupported) {
      return blobSupportsArrayBufferView ? Blob : BlobConstructor;
    } else if (blobBuilderSupported) {
      return BlobBuilderConstructor;
    } else {
      return undefined;
    }
  }();
});
$__System.registerDynamic("e0", ["df"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("df");
});
$__System.registerDynamic('e1', ['d7', 'e2', 'd9', 'db', 'dc', 'de', 'e0'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var keys = $__require('d7');
  var hasBinary = $__require('e2');
  var sliceBuffer = $__require('d9');
  var after = $__require('db');
  var utf8 = $__require('dc');
  var base64encoder;
  if (typeof ArrayBuffer !== 'undefined') {
    base64encoder = $__require('de');
  }
  var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
  var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
  var dontSendBlobs = isAndroid || isPhantomJS;
  exports.protocol = 3;
  var packets = exports.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  };
  var packetslist = keys(packets);
  var err = {
    type: 'error',
    data: 'parser error'
  };
  var Blob = $__require('e0');
  exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
    if (typeof supportsBinary === 'function') {
      callback = supportsBinary;
      supportsBinary = false;
    }
    if (typeof utf8encode === 'function') {
      callback = utf8encode;
      utf8encode = null;
    }
    var data = packet.data === undefined ? undefined : packet.data.buffer || packet.data;
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
      return encodeArrayBuffer(packet, supportsBinary, callback);
    } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
      return encodeBlob(packet, supportsBinary, callback);
    }
    if (data && data.base64) {
      return encodeBase64Object(packet, callback);
    }
    var encoded = packets[packet.type];
    if (undefined !== packet.data) {
      encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
    }
    return callback('' + encoded);
  };
  function encodeBase64Object(packet, callback) {
    var message = 'b' + exports.packets[packet.type] + packet.data.data;
    return callback(message);
  }
  function encodeArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var data = packet.data;
    var contentArray = new Uint8Array(data);
    var resultBuffer = new Uint8Array(1 + data.byteLength);
    resultBuffer[0] = packets[packet.type];
    for (var i = 0; i < contentArray.length; i++) {
      resultBuffer[i + 1] = contentArray[i];
    }
    return callback(resultBuffer.buffer);
  }
  function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var fr = new FileReader();
    fr.onload = function () {
      exports.encodePacket({
        type: packet.type,
        data: fr.result
      }, supportsBinary, true, callback);
    };
    return fr.readAsArrayBuffer(packet.data);
  }
  function encodeBlob(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    if (dontSendBlobs) {
      return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
    }
    var length = new Uint8Array(1);
    length[0] = packets[packet.type];
    var blob = new Blob([length.buffer, packet.data]);
    return callback(blob);
  }
  exports.encodeBase64Packet = function (packet, callback) {
    var message = 'b' + exports.packets[packet.type];
    if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
      var fr = new FileReader();
      fr.onload = function () {
        var b64 = fr.result.split(',')[1];
        callback(message + b64);
      };
      return fr.readAsDataURL(packet.data);
    }
    var b64data;
    try {
      b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
    } catch (e) {
      var typed = new Uint8Array(packet.data);
      var basic = new Array(typed.length);
      for (var i = 0; i < typed.length; i++) {
        basic[i] = typed[i];
      }
      b64data = String.fromCharCode.apply(null, basic);
    }
    message += btoa(b64data);
    return callback(message);
  };
  exports.decodePacket = function (data, binaryType, utf8decode) {
    if (data === undefined) {
      return err;
    }
    if (typeof data === 'string') {
      if (data.charAt(0) === 'b') {
        return exports.decodeBase64Packet(data.substr(1), binaryType);
      }
      if (utf8decode) {
        data = tryDecode(data);
        if (data === false) {
          return err;
        }
      }
      var type = data.charAt(0);
      if (Number(type) != type || !packetslist[type]) {
        return err;
      }
      if (data.length > 1) {
        return {
          type: packetslist[type],
          data: data.substring(1)
        };
      } else {
        return { type: packetslist[type] };
      }
    }
    var asArray = new Uint8Array(data);
    var type = asArray[0];
    var rest = sliceBuffer(data, 1);
    if (Blob && binaryType === 'blob') {
      rest = new Blob([rest]);
    }
    return {
      type: packetslist[type],
      data: rest
    };
  };
  function tryDecode(data) {
    try {
      data = utf8.decode(data, { strict: false });
    } catch (e) {
      return false;
    }
    return data;
  }
  exports.decodeBase64Packet = function (msg, binaryType) {
    var type = packetslist[msg.charAt(0)];
    if (!base64encoder) {
      return {
        type: type,
        data: {
          base64: true,
          data: msg.substr(1)
        }
      };
    }
    var data = base64encoder.decode(msg.substr(1));
    if (binaryType === 'blob' && Blob) {
      data = new Blob([data]);
    }
    return {
      type: type,
      data: data
    };
  };
  exports.encodePayload = function (packets, supportsBinary, callback) {
    if (typeof supportsBinary === 'function') {
      callback = supportsBinary;
      supportsBinary = null;
    }
    var isBinary = hasBinary(packets);
    if (supportsBinary && isBinary) {
      if (Blob && !dontSendBlobs) {
        return exports.encodePayloadAsBlob(packets, callback);
      }
      return exports.encodePayloadAsArrayBuffer(packets, callback);
    }
    if (!packets.length) {
      return callback('0:');
    }
    function setLengthHeader(message) {
      return message.length + ':' + message;
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function (message) {
        doneCallback(null, setLengthHeader(message));
      });
    }
    map(packets, encodeOne, function (err, results) {
      return callback(results.join(''));
    });
  };
  function map(ary, each, done) {
    var result = new Array(ary.length);
    var next = after(ary.length, done);
    var eachWithIndex = function (i, el, cb) {
      each(el, function (error, msg) {
        result[i] = msg;
        cb(error, result);
      });
    };
    for (var i = 0; i < ary.length; i++) {
      eachWithIndex(i, ary[i], next);
    }
  }
  exports.decodePayload = function (data, binaryType, callback) {
    if (typeof data !== 'string') {
      return exports.decodePayloadAsBinary(data, binaryType, callback);
    }
    if (typeof binaryType === 'function') {
      callback = binaryType;
      binaryType = null;
    }
    var packet;
    if (data === '') {
      return callback(err, 0, 1);
    }
    var length = '',
        n,
        msg;
    for (var i = 0, l = data.length; i < l; i++) {
      var chr = data.charAt(i);
      if (chr !== ':') {
        length += chr;
        continue;
      }
      if (length === '' || length != (n = Number(length))) {
        return callback(err, 0, 1);
      }
      msg = data.substr(i + 1, n);
      if (length != msg.length) {
        return callback(err, 0, 1);
      }
      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, false);
        if (err.type === packet.type && err.data === packet.data) {
          return callback(err, 0, 1);
        }
        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }
      i += n;
      length = '';
    }
    if (length !== '') {
      return callback(err, 0, 1);
    }
  };
  exports.encodePayloadAsArrayBuffer = function (packets, callback) {
    if (!packets.length) {
      return callback(new ArrayBuffer(0));
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function (data) {
        return doneCallback(null, data);
      });
    }
    map(packets, encodeOne, function (err, encodedPackets) {
      var totalLength = encodedPackets.reduce(function (acc, p) {
        var len;
        if (typeof p === 'string') {
          len = p.length;
        } else {
          len = p.byteLength;
        }
        return acc + len.toString().length + len + 2;
      }, 0);
      var resultArray = new Uint8Array(totalLength);
      var bufferIndex = 0;
      encodedPackets.forEach(function (p) {
        var isString = typeof p === 'string';
        var ab = p;
        if (isString) {
          var view = new Uint8Array(p.length);
          for (var i = 0; i < p.length; i++) {
            view[i] = p.charCodeAt(i);
          }
          ab = view.buffer;
        }
        if (isString) {
          resultArray[bufferIndex++] = 0;
        } else {
          resultArray[bufferIndex++] = 1;
        }
        var lenStr = ab.byteLength.toString();
        for (var i = 0; i < lenStr.length; i++) {
          resultArray[bufferIndex++] = parseInt(lenStr[i]);
        }
        resultArray[bufferIndex++] = 255;
        var view = new Uint8Array(ab);
        for (var i = 0; i < view.length; i++) {
          resultArray[bufferIndex++] = view[i];
        }
      });
      return callback(resultArray.buffer);
    });
  };
  exports.encodePayloadAsBlob = function (packets, callback) {
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function (encoded) {
        var binaryIdentifier = new Uint8Array(1);
        binaryIdentifier[0] = 1;
        if (typeof encoded === 'string') {
          var view = new Uint8Array(encoded.length);
          for (var i = 0; i < encoded.length; i++) {
            view[i] = encoded.charCodeAt(i);
          }
          encoded = view.buffer;
          binaryIdentifier[0] = 0;
        }
        var len = encoded instanceof ArrayBuffer ? encoded.byteLength : encoded.size;
        var lenStr = len.toString();
        var lengthAry = new Uint8Array(lenStr.length + 1);
        for (var i = 0; i < lenStr.length; i++) {
          lengthAry[i] = parseInt(lenStr[i]);
        }
        lengthAry[lenStr.length] = 255;
        if (Blob) {
          var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
          doneCallback(null, blob);
        }
      });
    }
    map(packets, encodeOne, function (err, results) {
      return callback(new Blob(results));
    });
  };
  exports.decodePayloadAsBinary = function (data, binaryType, callback) {
    if (typeof binaryType === 'function') {
      callback = binaryType;
      binaryType = null;
    }
    var bufferTail = data;
    var buffers = [];
    while (bufferTail.byteLength > 0) {
      var tailArray = new Uint8Array(bufferTail);
      var isString = tailArray[0] === 0;
      var msgLength = '';
      for (var i = 1;; i++) {
        if (tailArray[i] === 255) break;
        if (msgLength.length > 310) {
          return callback(err, 0, 1);
        }
        msgLength += tailArray[i];
      }
      bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
      msgLength = parseInt(msgLength);
      var msg = sliceBuffer(bufferTail, 0, msgLength);
      if (isString) {
        try {
          msg = String.fromCharCode.apply(null, new Uint8Array(msg));
        } catch (e) {
          var typed = new Uint8Array(msg);
          msg = '';
          for (var i = 0; i < typed.length; i++) {
            msg += String.fromCharCode(typed[i]);
          }
        }
      }
      buffers.push(msg);
      bufferTail = sliceBuffer(bufferTail, msgLength);
    }
    var total = buffers.length;
    buffers.forEach(function (buffer, i) {
      callback(exports.decodePacket(buffer, binaryType, true), i, total);
    });
  };
});
$__System.registerDynamic("cd", ["e1"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("e1");
});
$__System.registerDynamic('e3', ['d5', 'cd'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = $__require('d5');
  module.exports.parser = $__require('cd');
});
$__System.registerDynamic("e4", ["e3"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("e3");
});
$__System.registerDynamic("e5", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */

  var indexOf = [].indexOf;

  module.exports = function (arr, obj) {
    if (indexOf) return arr.indexOf(obj);
    for (var i = 0; i < arr.length; ++i) {
      if (arr[i] === obj) return i;
    }
    return -1;
  };
});
$__System.registerDynamic("d6", ["e5"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("e5");
});
$__System.registerDynamic("e6", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Expose `Backoff`.
   */

  module.exports = Backoff;

  /**
   * Initialize backoff timer with `opts`.
   *
   * - `min` initial timeout in milliseconds [100]
   * - `max` max timeout [10000]
   * - `jitter` [0]
   * - `factor` [2]
   *
   * @param {Object} opts
   * @api public
   */

  function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
  }

  /**
   * Return the backoff duration.
   *
   * @return {Number}
   * @api public
   */

  Backoff.prototype.duration = function () {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var rand = Math.random();
      var deviation = Math.floor(rand * this.jitter * ms);
      ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
  };

  /**
   * Reset the number of attempts.
   *
   * @api public
   */

  Backoff.prototype.reset = function () {
    this.attempts = 0;
  };

  /**
   * Set the minimum duration
   *
   * @api public
   */

  Backoff.prototype.setMin = function (min) {
    this.ms = min;
  };

  /**
   * Set the maximum duration
   *
   * @api public
   */

  Backoff.prototype.setMax = function (max) {
    this.max = max;
  };

  /**
   * Set the jitter
   *
   * @api public
   */

  Backoff.prototype.setJitter = function (jitter) {
    this.jitter = jitter;
  };
});
$__System.registerDynamic("e7", ["e6"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("e6");
});
$__System.registerDynamic('e8', ['e4', 'e9', 'c6', 'ec', 'ea', 'eb', 'c2', 'd6', 'e7'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var eio = $__require('e4');
  var Socket = $__require('e9');
  var Emitter = $__require('c6');
  var parser = $__require('ec');
  var on = $__require('ea');
  var bind = $__require('eb');
  var debug = $__require('c2')('socket.io-client:manager');
  var indexOf = $__require('d6');
  var Backoff = $__require('e7');
  var has = Object.prototype.hasOwnProperty;
  module.exports = Manager;
  function Manager(uri, opts) {
    if (!(this instanceof Manager)) return new Manager(uri, opts);
    if (uri && 'object' === typeof uri) {
      opts = uri;
      uri = undefined;
    }
    opts = opts || {};
    opts.path = opts.path || '/socket.io';
    this.nsps = {};
    this.subs = [];
    this.opts = opts;
    this.reconnection(opts.reconnection !== false);
    this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
    this.reconnectionDelay(opts.reconnectionDelay || 1000);
    this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
    this.randomizationFactor(opts.randomizationFactor || 0.5);
    this.backoff = new Backoff({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    });
    this.timeout(null == opts.timeout ? 20000 : opts.timeout);
    this.readyState = 'closed';
    this.uri = uri;
    this.connecting = [];
    this.lastPing = null;
    this.encoding = false;
    this.packetBuffer = [];
    var _parser = opts.parser || parser;
    this.encoder = new _parser.Encoder();
    this.decoder = new _parser.Decoder();
    this.autoConnect = opts.autoConnect !== false;
    if (this.autoConnect) this.open();
  }
  Manager.prototype.emitAll = function () {
    this.emit.apply(this, arguments);
    for (var nsp in this.nsps) {
      if (has.call(this.nsps, nsp)) {
        this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
      }
    }
  };
  Manager.prototype.updateSocketIds = function () {
    for (var nsp in this.nsps) {
      if (has.call(this.nsps, nsp)) {
        this.nsps[nsp].id = this.generateId(nsp);
      }
    }
  };
  Manager.prototype.generateId = function (nsp) {
    return (nsp === '/' ? '' : nsp + '#') + this.engine.id;
  };
  Emitter(Manager.prototype);
  Manager.prototype.reconnection = function (v) {
    if (!arguments.length) return this._reconnection;
    this._reconnection = !!v;
    return this;
  };
  Manager.prototype.reconnectionAttempts = function (v) {
    if (!arguments.length) return this._reconnectionAttempts;
    this._reconnectionAttempts = v;
    return this;
  };
  Manager.prototype.reconnectionDelay = function (v) {
    if (!arguments.length) return this._reconnectionDelay;
    this._reconnectionDelay = v;
    this.backoff && this.backoff.setMin(v);
    return this;
  };
  Manager.prototype.randomizationFactor = function (v) {
    if (!arguments.length) return this._randomizationFactor;
    this._randomizationFactor = v;
    this.backoff && this.backoff.setJitter(v);
    return this;
  };
  Manager.prototype.reconnectionDelayMax = function (v) {
    if (!arguments.length) return this._reconnectionDelayMax;
    this._reconnectionDelayMax = v;
    this.backoff && this.backoff.setMax(v);
    return this;
  };
  Manager.prototype.timeout = function (v) {
    if (!arguments.length) return this._timeout;
    this._timeout = v;
    return this;
  };
  Manager.prototype.maybeReconnectOnOpen = function () {
    if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
      this.reconnect();
    }
  };
  Manager.prototype.open = Manager.prototype.connect = function (fn, opts) {
    debug('readyState %s', this.readyState);
    if (~this.readyState.indexOf('open')) return this;
    debug('opening %s', this.uri);
    this.engine = eio(this.uri, this.opts);
    var socket = this.engine;
    var self = this;
    this.readyState = 'opening';
    this.skipReconnect = false;
    var openSub = on(socket, 'open', function () {
      self.onopen();
      fn && fn();
    });
    var errorSub = on(socket, 'error', function (data) {
      debug('connect_error');
      self.cleanup();
      self.readyState = 'closed';
      self.emitAll('connect_error', data);
      if (fn) {
        var err = new Error('Connection error');
        err.data = data;
        fn(err);
      } else {
        self.maybeReconnectOnOpen();
      }
    });
    if (false !== this._timeout) {
      var timeout = this._timeout;
      debug('connect attempt will timeout after %d', timeout);
      var timer = setTimeout(function () {
        debug('connect attempt timed out after %d', timeout);
        openSub.destroy();
        socket.close();
        socket.emit('error', 'timeout');
        self.emitAll('connect_timeout', timeout);
      }, timeout);
      this.subs.push({ destroy: function () {
          clearTimeout(timer);
        } });
    }
    this.subs.push(openSub);
    this.subs.push(errorSub);
    return this;
  };
  Manager.prototype.onopen = function () {
    debug('open');
    this.cleanup();
    this.readyState = 'open';
    this.emit('open');
    var socket = this.engine;
    this.subs.push(on(socket, 'data', bind(this, 'ondata')));
    this.subs.push(on(socket, 'ping', bind(this, 'onping')));
    this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
    this.subs.push(on(socket, 'error', bind(this, 'onerror')));
    this.subs.push(on(socket, 'close', bind(this, 'onclose')));
    this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
  };
  Manager.prototype.onping = function () {
    this.lastPing = new Date();
    this.emitAll('ping');
  };
  Manager.prototype.onpong = function () {
    this.emitAll('pong', new Date() - this.lastPing);
  };
  Manager.prototype.ondata = function (data) {
    this.decoder.add(data);
  };
  Manager.prototype.ondecoded = function (packet) {
    this.emit('packet', packet);
  };
  Manager.prototype.onerror = function (err) {
    debug('error', err);
    this.emitAll('error', err);
  };
  Manager.prototype.socket = function (nsp, opts) {
    var socket = this.nsps[nsp];
    if (!socket) {
      socket = new Socket(this, nsp, opts);
      this.nsps[nsp] = socket;
      var self = this;
      socket.on('connecting', onConnecting);
      socket.on('connect', function () {
        socket.id = self.generateId(nsp);
      });
      if (this.autoConnect) {
        onConnecting();
      }
    }
    function onConnecting() {
      if (!~indexOf(self.connecting, socket)) {
        self.connecting.push(socket);
      }
    }
    return socket;
  };
  Manager.prototype.destroy = function (socket) {
    var index = indexOf(this.connecting, socket);
    if (~index) this.connecting.splice(index, 1);
    if (this.connecting.length) return;
    this.close();
  };
  Manager.prototype.packet = function (packet) {
    debug('writing packet %j', packet);
    var self = this;
    if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
    if (!self.encoding) {
      self.encoding = true;
      this.encoder.encode(packet, function (encodedPackets) {
        for (var i = 0; i < encodedPackets.length; i++) {
          self.engine.write(encodedPackets[i], packet.options);
        }
        self.encoding = false;
        self.processPacketQueue();
      });
    } else {
      self.packetBuffer.push(packet);
    }
  };
  Manager.prototype.processPacketQueue = function () {
    if (this.packetBuffer.length > 0 && !this.encoding) {
      var pack = this.packetBuffer.shift();
      this.packet(pack);
    }
  };
  Manager.prototype.cleanup = function () {
    debug('cleanup');
    var subsLength = this.subs.length;
    for (var i = 0; i < subsLength; i++) {
      var sub = this.subs.shift();
      sub.destroy();
    }
    this.packetBuffer = [];
    this.encoding = false;
    this.lastPing = null;
    this.decoder.destroy();
  };
  Manager.prototype.close = Manager.prototype.disconnect = function () {
    debug('disconnect');
    this.skipReconnect = true;
    this.reconnecting = false;
    if ('opening' === this.readyState) {
      this.cleanup();
    }
    this.backoff.reset();
    this.readyState = 'closed';
    if (this.engine) this.engine.close();
  };
  Manager.prototype.onclose = function (reason) {
    debug('onclose');
    this.cleanup();
    this.backoff.reset();
    this.readyState = 'closed';
    this.emit('close', reason);
    if (this._reconnection && !this.skipReconnect) {
      this.reconnect();
    }
  };
  Manager.prototype.reconnect = function () {
    if (this.reconnecting || this.skipReconnect) return this;
    var self = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) {
      debug('reconnect failed');
      this.backoff.reset();
      this.emitAll('reconnect_failed');
      this.reconnecting = false;
    } else {
      var delay = this.backoff.duration();
      debug('will wait %dms before reconnect attempt', delay);
      this.reconnecting = true;
      var timer = setTimeout(function () {
        if (self.skipReconnect) return;
        debug('attempting reconnect');
        self.emitAll('reconnect_attempt', self.backoff.attempts);
        self.emitAll('reconnecting', self.backoff.attempts);
        if (self.skipReconnect) return;
        self.open(function (err) {
          if (err) {
            debug('reconnect attempt error');
            self.reconnecting = false;
            self.reconnect();
            self.emitAll('reconnect_error', err.data);
          } else {
            debug('reconnect success');
            self.onreconnect();
          }
        });
      }, delay);
      this.subs.push({ destroy: function () {
          clearTimeout(timer);
        } });
    }
  };
  Manager.prototype.onreconnect = function () {
    var attempt = this.backoff.attempts;
    this.reconnecting = false;
    this.backoff.reset();
    this.updateSocketIds();
    this.emitAll('reconnect', attempt);
  };
});
$__System.registerDynamic('ed', ['ef', 'ee', 'd2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (Buffer) {
    var isArray = $__require('ef');
    var isBuf = $__require('ee');
    var toString = Object.prototype.toString;
    var withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
    var withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';
    exports.deconstructPacket = function (packet) {
      var buffers = [];
      var packetData = packet.data;
      var pack = packet;
      pack.data = _deconstructPacket(packetData, buffers);
      pack.attachments = buffers.length;
      return {
        packet: pack,
        buffers: buffers
      };
    };
    function _deconstructPacket(data, buffers) {
      if (!data) return data;
      if (isBuf(data)) {
        var placeholder = {
          _placeholder: true,
          num: buffers.length
        };
        buffers.push(data);
        return placeholder;
      } else if (isArray(data)) {
        var newData = new Array(data.length);
        for (var i = 0; i < data.length; i++) {
          newData[i] = _deconstructPacket(data[i], buffers);
        }
        return newData;
      } else if (typeof data === 'object' && !(data instanceof Date)) {
        var newData = {};
        for (var key in data) {
          newData[key] = _deconstructPacket(data[key], buffers);
        }
        return newData;
      }
      return data;
    }
    exports.reconstructPacket = function (packet, buffers) {
      packet.data = _reconstructPacket(packet.data, buffers);
      packet.attachments = undefined;
      return packet;
    };
    function _reconstructPacket(data, buffers) {
      if (!data) return data;
      if (data && data._placeholder) {
        return buffers[data.num];
      } else if (isArray(data)) {
        for (var i = 0; i < data.length; i++) {
          data[i] = _reconstructPacket(data[i], buffers);
        }
      } else if (typeof data === 'object') {
        for (var key in data) {
          data[key] = _reconstructPacket(data[key], buffers);
        }
      }
      return data;
    }
    exports.removeBlobs = function (data, callback) {
      function _removeBlobs(obj, curKey, containingObject) {
        if (!obj) return obj;
        if (withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File) {
          pendingBlobs++;
          var fileReader = new FileReader();
          fileReader.onload = function () {
            if (containingObject) {
              containingObject[curKey] = this.result;
            } else {
              bloblessData = this.result;
            }
            if (! --pendingBlobs) {
              callback(bloblessData);
            }
          };
          fileReader.readAsArrayBuffer(obj);
        } else if (isArray(obj)) {
          for (var i = 0; i < obj.length; i++) {
            _removeBlobs(obj[i], i, obj);
          }
        } else if (typeof obj === 'object' && !isBuf(obj)) {
          for (var key in obj) {
            _removeBlobs(obj[key], key, obj);
          }
        }
      }
      var pendingBlobs = 0;
      var bloblessData = data;
      _removeBlobs(bloblessData);
      if (!pendingBlobs) {
        callback(bloblessData);
      }
    };
  })($__require('d2').Buffer);
});
$__System.registerDynamic('ee', ['d2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (Buffer) {
    module.exports = isBuf;
    var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
    var withNativeArrayBuffer = typeof ArrayBuffer === 'function';
    var isView = function (obj) {
      return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
    };
    function isBuf(obj) {
      return withNativeBuffer && Buffer.isBuffer(obj) || withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj));
    }
  })($__require('d2').Buffer);
});
$__System.registerDynamic('f0', ['c2', 'c6', 'ed', 'ef', 'ee', 'd2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (Buffer) {
    var debug = $__require('c2')('socket.io-parser');
    var Emitter = $__require('c6');
    var binary = $__require('ed');
    var isArray = $__require('ef');
    var isBuf = $__require('ee');
    exports.protocol = 4;
    exports.types = ['CONNECT', 'DISCONNECT', 'EVENT', 'ACK', 'ERROR', 'BINARY_EVENT', 'BINARY_ACK'];
    exports.CONNECT = 0;
    exports.DISCONNECT = 1;
    exports.EVENT = 2;
    exports.ACK = 3;
    exports.ERROR = 4;
    exports.BINARY_EVENT = 5;
    exports.BINARY_ACK = 6;
    exports.Encoder = Encoder;
    exports.Decoder = Decoder;
    function Encoder() {}
    var ERROR_PACKET = exports.ERROR + '"encode error"';
    Encoder.prototype.encode = function (obj, callback) {
      debug('encoding packet %j', obj);
      if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
        encodeAsBinary(obj, callback);
      } else {
        var encoding = encodeAsString(obj);
        callback([encoding]);
      }
    };
    function encodeAsString(obj) {
      var str = '' + obj.type;
      if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
        str += obj.attachments + '-';
      }
      if (obj.nsp && '/' !== obj.nsp) {
        str += obj.nsp + ',';
      }
      if (null != obj.id) {
        str += obj.id;
      }
      if (null != obj.data) {
        var payload = tryStringify(obj.data);
        if (payload !== false) {
          str += payload;
        } else {
          return ERROR_PACKET;
        }
      }
      debug('encoded %j as %s', obj, str);
      return str;
    }
    function tryStringify(str) {
      try {
        return JSON.stringify(str);
      } catch (e) {
        return false;
      }
    }
    function encodeAsBinary(obj, callback) {
      function writeEncoding(bloblessData) {
        var deconstruction = binary.deconstructPacket(bloblessData);
        var pack = encodeAsString(deconstruction.packet);
        var buffers = deconstruction.buffers;
        buffers.unshift(pack);
        callback(buffers);
      }
      binary.removeBlobs(obj, writeEncoding);
    }
    function Decoder() {
      this.reconstructor = null;
    }
    Emitter(Decoder.prototype);
    Decoder.prototype.add = function (obj) {
      var packet;
      if (typeof obj === 'string') {
        packet = decodeString(obj);
        if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) {
          this.reconstructor = new BinaryReconstructor(packet);
          if (this.reconstructor.reconPack.attachments === 0) {
            this.emit('decoded', packet);
          }
        } else {
          this.emit('decoded', packet);
        }
      } else if (isBuf(obj) || obj.base64) {
        if (!this.reconstructor) {
          throw new Error('got binary data when not reconstructing a packet');
        } else {
          packet = this.reconstructor.takeBinaryData(obj);
          if (packet) {
            this.reconstructor = null;
            this.emit('decoded', packet);
          }
        }
      } else {
        throw new Error('Unknown type: ' + obj);
      }
    };
    function decodeString(str) {
      var i = 0;
      var p = { type: Number(str.charAt(0)) };
      if (null == exports.types[p.type]) {
        return error('unknown packet type ' + p.type);
      }
      if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
        var buf = '';
        while (str.charAt(++i) !== '-') {
          buf += str.charAt(i);
          if (i == str.length) break;
        }
        if (buf != Number(buf) || str.charAt(i) !== '-') {
          throw new Error('Illegal attachments');
        }
        p.attachments = Number(buf);
      }
      if ('/' === str.charAt(i + 1)) {
        p.nsp = '';
        while (++i) {
          var c = str.charAt(i);
          if (',' === c) break;
          p.nsp += c;
          if (i === str.length) break;
        }
      } else {
        p.nsp = '/';
      }
      var next = str.charAt(i + 1);
      if ('' !== next && Number(next) == next) {
        p.id = '';
        while (++i) {
          var c = str.charAt(i);
          if (null == c || Number(c) != c) {
            --i;
            break;
          }
          p.id += str.charAt(i);
          if (i === str.length) break;
        }
        p.id = Number(p.id);
      }
      if (str.charAt(++i)) {
        var payload = tryParse(str.substr(i));
        var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
        if (isPayloadValid) {
          p.data = payload;
        } else {
          return error('invalid payload');
        }
      }
      debug('decoded %s as %j', str, p);
      return p;
    }
    function tryParse(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return false;
      }
    }
    Decoder.prototype.destroy = function () {
      if (this.reconstructor) {
        this.reconstructor.finishedReconstruction();
      }
    };
    function BinaryReconstructor(packet) {
      this.reconPack = packet;
      this.buffers = [];
    }
    BinaryReconstructor.prototype.takeBinaryData = function (binData) {
      this.buffers.push(binData);
      if (this.buffers.length === this.reconPack.attachments) {
        var packet = binary.reconstructPacket(this.reconPack, this.buffers);
        this.finishedReconstruction();
        return packet;
      }
      return null;
    };
    BinaryReconstructor.prototype.finishedReconstruction = function () {
      this.reconPack = null;
      this.buffers = [];
    };
    function error(msg) {
      return {
        type: exports.ERROR,
        data: 'parser error: ' + msg
      };
    }
  })($__require('d2').Buffer);
});
$__System.registerDynamic("ec", ["f0"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f0");
});
$__System.registerDynamic('f1', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Expose `Emitter`.
   */

  if (typeof module !== 'undefined') {
    module.exports = Emitter;
  }

  /**
   * Initialize a new `Emitter`.
   *
   * @api public
   */

  function Emitter(obj) {
    if (obj) return mixin(obj);
  };

  /**
   * Mixin the emitter properties.
   *
   * @param {Object} obj
   * @return {Object}
   * @api private
   */

  function mixin(obj) {
    for (var key in Emitter.prototype) {
      obj[key] = Emitter.prototype[key];
    }
    return obj;
  }

  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.once = function (event, fn) {
    function on() {
      this.off(event, on);
      fn.apply(this, arguments);
    }

    on.fn = fn;
    this.on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};

    // all
    if (0 == arguments.length) {
      this._callbacks = {};
      return this;
    }

    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;

    // remove all handlers
    if (1 == arguments.length) {
      delete this._callbacks['$' + event];
      return this;
    }

    // remove specific handler
    var cb;
    for (var i = 0; i < callbacks.length; i++) {
      cb = callbacks[i];
      if (cb === fn || cb.fn === fn) {
        callbacks.splice(i, 1);
        break;
      }
    }
    return this;
  };

  /**
   * Emit `event` with the given args.
   *
   * @param {String} event
   * @param {Mixed} ...
   * @return {Emitter}
   */

  Emitter.prototype.emit = function (event) {
    this._callbacks = this._callbacks || {};
    var args = [].slice.call(arguments, 1),
        callbacks = this._callbacks['$' + event];

    if (callbacks) {
      callbacks = callbacks.slice(0);
      for (var i = 0, len = callbacks.length; i < len; ++i) {
        callbacks[i].apply(this, args);
      }
    }

    return this;
  };

  /**
   * Return array of callbacks for `event`.
   *
   * @param {String} event
   * @return {Array}
   * @api public
   */

  Emitter.prototype.listeners = function (event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
  };

  /**
   * Check if this emitter has `event` handlers.
   *
   * @param {String} event
   * @return {Boolean}
   * @api public
   */

  Emitter.prototype.hasListeners = function (event) {
    return !!this.listeners(event).length;
  };
});
$__System.registerDynamic("c6", ["f1"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f1");
});
$__System.registerDynamic("f2", [], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    module.exports = toArray;

    function toArray(list, index) {
        var array = [];

        index = index || 0;

        for (var i = index || 0; i < list.length; i++) {
            array[i - index] = list[i];
        }

        return array;
    }
});
$__System.registerDynamic("f3", ["f2"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f2");
});
$__System.registerDynamic("ea", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * Module exports.
   */

  module.exports = on;

  /**
   * Helper for subscriptions.
   *
   * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
   * @param {String} event name
   * @param {Function} callback
   * @api public
   */

  function on(obj, ev, fn) {
    obj.on(ev, fn);
    return {
      destroy: function () {
        obj.removeListener(ev, fn);
      }
    };
  }
});
$__System.registerDynamic('f4', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * Slice reference.
   */

  var slice = [].slice;

  /**
   * Bind `obj` to `fn`.
   *
   * @param {Object} obj
   * @param {Function|String} fn or string
   * @return {Function}
   * @api public
   */

  module.exports = function (obj, fn) {
    if ('string' == typeof fn) fn = obj[fn];
    if ('function' != typeof fn) throw new Error('bind() requires a function');
    var args = slice.call(arguments, 2);
    return function () {
      return fn.apply(obj, args.concat(slice.call(arguments)));
    };
  };
});
$__System.registerDynamic("eb", ["f4"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f4");
});
$__System.registerDynamic('f5', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * Helpers.
   */

  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var y = d * 365.25;

  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  module.exports = function (val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) {
      return parse(val);
    } else if (type === 'number' && isNaN(val) === false) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
  };

  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */

  function parse(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;
      case 'days':
      case 'day':
      case 'd':
        return n * d;
      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;
      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;
      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;
      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;
      default:
        return undefined;
    }
  }

  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtShort(ms) {
    if (ms >= d) {
      return Math.round(ms / d) + 'd';
    }
    if (ms >= h) {
      return Math.round(ms / h) + 'h';
    }
    if (ms >= m) {
      return Math.round(ms / m) + 'm';
    }
    if (ms >= s) {
      return Math.round(ms / s) + 's';
    }
    return ms + 'ms';
  }

  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtLong(ms) {
    return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
  }

  /**
   * Pluralization helper.
   */

  function plural(ms, n, name) {
    if (ms < n) {
      return;
    }
    if (ms < n * 1.5) {
      return Math.floor(ms / n) + ' ' + name;
    }
    return Math.ceil(ms / n) + ' ' + name + 's';
  }
});
$__System.registerDynamic("f6", ["f5"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f5");
});
$__System.registerDynamic('f7', ['f6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;

  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = $__require('f6');

  /**
   * Active `debug` instances.
   */
  exports.instances = [];

  /**
   * The currently active debug mode names, and names to skip.
   */

  exports.names = [];
  exports.skips = [];

  /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */

  exports.formatters = {};

  /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */

  function selectColor(namespace) {
    var hash = 0,
        i;

    for (i in namespace) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return exports.colors[Math.abs(hash) % exports.colors.length];
  }

  /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */

  function createDebug(namespace) {

    var prevTime;

    function debug() {
      // disabled?
      if (!debug.enabled) return;

      var self = debug;

      // set `diff` timestamp
      var curr = +new Date();
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;

      // turn the `arguments` into a proper Array
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      args[0] = exports.coerce(args[0]);

      if ('string' !== typeof args[0]) {
        // anything else let's inspect with %O
        args.unshift('%O');
      }

      // apply any `formatters` transformations
      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // if we encounter an escaped % then don't increase the array index
        if (match === '%%') return match;
        index++;
        var formatter = exports.formatters[format];
        if ('function' === typeof formatter) {
          var val = args[index];
          match = formatter.call(self, val);

          // now we need to remove `args[index]` since it's inlined in the `format`
          args.splice(index, 1);
          index--;
        }
        return match;
      });

      // apply env-specific formatting (colors, etc.)
      exports.formatArgs.call(self, args);

      var logFn = debug.log || exports.log || console.log.bind(console);
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;

    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) {
      exports.init(debug);
    }

    exports.instances.push(debug);

    return debug;
  }

  function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
      exports.instances.splice(index, 1);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */

  function enable(namespaces) {
    exports.save(namespaces);

    exports.names = [];
    exports.skips = [];

    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) continue; // ignore empty strings
      namespaces = split[i].replace(/\*/g, '.*?');
      if (namespaces[0] === '-') {
        exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        exports.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < exports.instances.length; i++) {
      var instance = exports.instances[i];
      instance.enabled = exports.enabled(instance.namespace);
    }
  }

  /**
   * Disable debug output.
   *
   * @api public
   */

  function disable() {
    exports.enable('');
  }

  /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */

  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }
    var i, len;
    for (i = 0, len = exports.skips.length; i < len; i++) {
      if (exports.skips[i].test(name)) {
        return false;
      }
    }
    for (i = 0, len = exports.names.length; i < len; i++) {
      if (exports.names[i].test(name)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */

  function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
  }
});
$__System.registerDynamic('f8', ['f7', 'f9'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    exports = module.exports = $__require('f7');
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
    exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
    function useColors() {
      if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
        return true;
      }
      if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }
      return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    exports.formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
      }
    };
    function formatArgs(args) {
      var useColors = this.useColors;
      args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
      if (!useColors) return;
      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit');
      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function (match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) {
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }
    function log() {
      return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function save(namespaces) {
      try {
        if (null == namespaces) {
          exports.storage.removeItem('debug');
        } else {
          exports.storage.debug = namespaces;
        }
      } catch (e) {}
    }
    function load() {
      var r;
      try {
        r = exports.storage.debug;
      } catch (e) {}
      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }
      return r;
    }
    exports.enable(load());
    function localstorage() {
      try {
        return window.localStorage;
      } catch (e) {}
    }
  })($__require('f9'));
});
$__System.registerDynamic("c2", ["f8"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("f8");
});
$__System.registerDynamic('fa', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /**
   * Compiles a querystring
   * Returns string representation of the object
   *
   * @param {Object}
   * @api private
   */

  exports.encode = function (obj) {
    var str = '';

    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
      }
    }

    return str;
  };

  /**
   * Parses a simple querystring into an object
   *
   * @param {String} qs
   * @api private
   */

  exports.decode = function (qs) {
    var qry = {};
    var pairs = qs.split('&');
    for (var i = 0, l = pairs.length; i < l; i++) {
      var pair = pairs[i].split('=');
      qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
  };
});
$__System.registerDynamic("cc", ["fa"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("fa");
});
$__System.registerDynamic('fb', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toString = {}.toString;

  module.exports = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };
});
$__System.registerDynamic("ef", ["fb"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("fb");
});
$__System.registerDynamic('fc', [], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  exports.byteLength = byteLength;
  exports.toByteArray = toByteArray;
  exports.fromByteArray = fromByteArray;

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  // Support decoding URL-safe base64 strings, as Node.js does.
  // See: https://en.wikipedia.org/wiki/Base64#URL_applications
  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;

  function getLens(b64) {
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4');
    }

    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;

    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;

    return [validLen, placeHoldersLen];
  }

  // base64 is 4/3 + up to two characters of the original data
  function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }

  function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }

  function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];

    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

    var curByte = 0;

    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

    for (var i = 0; i < len; i += 4) {
      tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
      arr[curByte++] = tmp >> 16 & 0xFF;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }

    if (placeHoldersLen === 2) {
      tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
      arr[curByte++] = tmp & 0xFF;
    }

    if (placeHoldersLen === 1) {
      tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }

    return arr;
  }

  function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
  }

  function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
      output.push(tripletToBase64(tmp));
    }
    return output.join('');
  }

  function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3

    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    }

    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1];
      parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }

    return parts.join('');
  }
});
$__System.registerDynamic("fd", ["fc"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("fc");
});
$__System.registerDynamic("fe", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  exports.read = function (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];

    i += d;

    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  };

  exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = e << mLen | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  };
});
$__System.registerDynamic("ff", ["fe"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("fe");
});
$__System.registerDynamic('100', ['fd', 'ff'], true, function ($__require, exports, module) {
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */
  /* eslint-disable no-proto */

  'use strict';

  var global = this || self,
      GLOBAL = global;
  var base64 = $__require('fd');
  var ieee754 = $__require('ff');

  exports.Buffer = Buffer;
  exports.SlowBuffer = SlowBuffer;
  exports.INSPECT_MAX_BYTES = 50;

  var K_MAX_LENGTH = 0x7fffffff;
  exports.kMaxLength = K_MAX_LENGTH;

  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */
  Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

  if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
  }

  function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
      var arr = new Uint8Array(1);
      arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () {
          return 42;
        } };
      return arr.foo() === 42;
    } catch (e) {
      return false;
    }
  }

  Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function () {
      if (!Buffer.isBuffer(this)) return undefined;
      return this.buffer;
    }
  });

  Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function () {
      if (!Buffer.isBuffer(this)) return undefined;
      return this.byteOffset;
    }
  });

  function createBuffer(length) {
    if (length > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length + '" is invalid for option "size"');
    }
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    buf.__proto__ = Buffer.prototype;
    return buf;
  }

  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */

  function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new TypeError('The "string" argument must be of type string. Received type number');
      }
      return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
  }

  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    });
  }

  Buffer.poolSize = 8192; // not used by this implementation

  function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') {
      return fromString(value, encodingOrOffset);
    }

    if (ArrayBuffer.isView(value)) {
      return fromArrayLike(value);
    }

    if (value == null) {
      throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
    }

    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }

    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    }

    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
      return Buffer.from(valueOf, encodingOrOffset, length);
    }

    var b = fromObject(value);
    if (b) return b;

    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
      return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    }

    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
  }

  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/
  Buffer.from = function (value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
  };

  // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
  // https://github.com/feross/buffer/pull/148
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;

  function assertSize(size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }

  function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }

  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/
  Buffer.alloc = function (size, fill, encoding) {
    return alloc(size, fill, encoding);
  };

  function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }

  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */
  Buffer.allocUnsafe = function (size) {
    return allocUnsafe(size);
  };
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */
  Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(size);
  };

  function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }

    if (!Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }

    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);

    var actual = buf.write(string, encoding);

    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      buf = buf.slice(0, actual);
    }

    return buf;
  }

  function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for (var i = 0; i < length; i += 1) {
      buf[i] = array[i] & 255;
    }
    return buf;
  }

  function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }

    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }

    var buf;
    if (byteOffset === undefined && length === undefined) {
      buf = new Uint8Array(array);
    } else if (length === undefined) {
      buf = new Uint8Array(array, byteOffset);
    } else {
      buf = new Uint8Array(array, byteOffset, length);
    }

    // Return an augmented `Uint8Array` instance
    buf.__proto__ = Buffer.prototype;
    return buf;
  }

  function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
      var len = checked(obj.length) | 0;
      var buf = createBuffer(len);

      if (buf.length === 0) {
        return buf;
      }

      obj.copy(buf, 0, 0, len);
      return buf;
    }

    if (obj.length !== undefined) {
      if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }

    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }

  function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
    }
    return length | 0;
  }

  function SlowBuffer(length) {
    if (+length != length) {
      // eslint-disable-line eqeqeq
      length = 0;
    }
    return Buffer.alloc(+length);
  }

  Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
  };

  Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }

    if (a === b) return 0;

    var x = a.length;
    var y = b.length;

    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }

    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  };

  Buffer.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true;
      default:
        return false;
    }
  };

  Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }

    if (list.length === 0) {
      return Buffer.alloc(0);
    }

    var i;
    if (length === undefined) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }

    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (isInstance(buf, Uint8Array)) {
        buf = Buffer.from(buf);
      }
      if (!Buffer.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      buf.copy(buffer, pos);
      pos += buf.length;
    }
    return buffer;
  };

  function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== 'string') {
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
    }

    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;

    // Use a for loop to avoid recursion
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len;
        case 'utf8':
        case 'utf-8':
          return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2;
        case 'hex':
          return len >>> 1;
        case 'base64':
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
          }
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer.byteLength = byteLength;

  function slowToString(encoding, start, end) {
    var loweredCase = false;

    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.

    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
      start = 0;
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
      return '';
    }

    if (end === undefined || end > this.length) {
      end = this.length;
    }

    if (end <= 0) {
      return '';
    }

    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;

    if (end <= start) {
      return '';
    }

    if (!encoding) encoding = 'utf8';

    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end);

        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end);

        case 'ascii':
          return asciiSlice(this, start, end);

        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end);

        case 'base64':
          return base64Slice(this, start, end);

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end);

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  }

  // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
  // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
  // reliably in a browserify context because there could be multiple different
  // copies of the 'buffer' package in use. This method works even for Buffer
  // instances that were created from another copy of the `buffer` package.
  // See: https://github.com/feross/buffer/issues/154
  Buffer.prototype._isBuffer = true;

  function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }

  Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits');
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this;
  };

  Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits');
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this;
  };

  Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits');
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this;
  };

  Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };

  Buffer.prototype.toLocaleString = Buffer.prototype.toString;

  Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
  };

  Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
  };

  Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer.from(target, target.offset, target.byteLength);
    }
    if (!Buffer.isBuffer(target)) {
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
    }

    if (start === undefined) {
      start = 0;
    }
    if (end === undefined) {
      end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
      thisStart = 0;
    }
    if (thisEnd === undefined) {
      thisEnd = this.length;
    }

    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index');
    }

    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }

    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;

    if (this === target) return 0;

    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);

    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);

    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
      }
    }

    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  };

  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf
  function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;

    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset; // Coerce to Number.
    if (numberIsNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : buffer.length - 1;
    }

    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
      if (dir) return -1;else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;else return -1;
    }

    // Normalize val
    if (typeof val === 'string') {
      val = Buffer.from(val, encoding);
    }

    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
      val = val & 0xFF; // Search for a byte value [0-255]
      if (typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }

    throw new TypeError('val must be string, number or Buffer');
  }

  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;

    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();
      if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }

    function read(buf, i) {
      if (indexSize === 1) {
        return buf[i];
      } else {
        return buf.readUInt16BE(i * indexSize);
      }
    }

    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found) return i;
      }
    }

    return -1;
  }

  Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };

  Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };

  Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };

  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }

    var strLen = string.length;

    if (length > strLen / 2) {
      length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (numberIsNaN(parsed)) return i;
      buf[offset + i] = parsed;
    }
    return i;
  }

  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }

  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }

  function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
  }

  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }

  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }

  Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0;
      // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0;
      // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset >>> 0;
      if (isFinite(length)) {
        length = length >>> 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      }
    } else {
      throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }

    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;

    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds');
    }

    if (!encoding) encoding = 'utf8';

    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length);

        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length);

        case 'ascii':
          return asciiWrite(this, string, offset, length);

        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length);

        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length);

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length);

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };

  Buffer.prototype.toJSON = function toJSON() {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };

  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start, end));
    }
  }

  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];

    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;

        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }
        }
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }

      res.push(codePoint);
      i += bytesPerSequence;
    }

    return decodeCodePointsArray(res);
  }

  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety
  var MAX_ARGUMENTS_LENGTH = 0x1000;

  function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
    }

    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }

  function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret;
  }

  function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret;
  }

  function hexSlice(buf, start, end) {
    var len = buf.length;

    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;

    var out = '';
    for (var i = start; i < end; ++i) {
      out += toHex(buf[i]);
    }
    return out;
  }

  function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
  }

  Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;

    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }

    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }

    if (end < start) end = start;

    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype;
    return newBuf;
  };

  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */
  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
  }

  Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    return val;
  };

  Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }

    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }

    return val;
  };

  Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
  };

  Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };

  Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };

  Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
  };

  Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);

    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };

  Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val;
  };

  Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val;
  };

  Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
  };

  Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };

  Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };

  Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);

    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };

  Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);

    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };

  Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
  };

  Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
  };

  Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
  };

  Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
  };

  function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
  }

  Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
  };

  Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };

  Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
  };

  Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
  };

  Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
  };

  Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
  };

  Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };

  Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
  };

  Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
  };

  Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
  };

  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
  }

  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    }
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }

  Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };

  Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };

  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
    }
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }

  Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };

  Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };

  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
  Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;

    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;

    // Fatal error conditions
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds');
    }
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');

    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }

    var len = end - start;

    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
      // Use built-in when available, missing from IE11
      this.copyWithin(targetStart, start, end);
    } else if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (var i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    }

    return len;
  };

  // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])
  Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string');
      }
      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding);
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0);
        if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
          // Fast path: If `val` fits into a single byte, use that numeric value.
          val = code;
        }
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    }

    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index');
    }

    if (end <= start) {
      return this;
    }

    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;

    if (!val) val = 0;

    var i;
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
      var len = bytes.length;
      if (len === 0) {
        throw new TypeError('The value "' + val + '" is invalid for argument "value"');
      }
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }

    return this;
  };

  // HELPER FUNCTIONS
  // ================

  var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

  function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
      str = str + '=';
    }
    return str;
  }

  function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
  }

  function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];

    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);

      // is surrogate component
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          }

          // valid lead
          leadSurrogate = codePoint;

          continue;
        }

        // 2 leads in a row
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue;
        }

        // valid surrogate pair
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }

      leadSurrogate = null;

      // encode utf8
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break;
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break;
        bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break;
        bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break;
        bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else {
        throw new Error('Invalid code point');
      }
    }

    return bytes;
  }

  function asciiToBytes(str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray;
  }

  function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break;

      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }

    return byteArray;
  }

  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }

  function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if (i + offset >= dst.length || i >= src.length) break;
      dst[i + offset] = src[i];
    }
    return i;
  }

  // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
  // the `instanceof` check but they should be treated as of that type.
  // See: https://github.com/feross/buffer/issues/166
  function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
  }
  function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj; // eslint-disable-line no-self-compare
  }
});
$__System.registerDynamic("101", ["100"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("100");
});
$__System.registerDynamic('102', ['101'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = $__System._nodeRequire ? $__System._nodeRequire('buffer') : $__require('101');
});
$__System.registerDynamic("d2", ["102"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("102");
});
$__System.registerDynamic('103', ['ef', 'd2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (Buffer) {
    var isArray = $__require('ef');
    var toString = Object.prototype.toString;
    var withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
    var withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';
    module.exports = hasBinary;
    function hasBinary(obj) {
      if (!obj || typeof obj !== 'object') {
        return false;
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (hasBinary(obj[i])) {
            return true;
          }
        }
        return false;
      }
      if (typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj) || typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File) {
        return true;
      }
      if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
        return hasBinary(obj.toJSON(), true);
      }
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
          return true;
        }
      }
      return false;
    }
  })($__require('d2').Buffer);
});
$__System.registerDynamic("e2", ["103"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("103");
});
$__System.registerDynamic('e9', ['ec', 'c6', 'f3', 'ea', 'eb', 'c2', 'cc', 'e2'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var parser = $__require('ec');
  var Emitter = $__require('c6');
  var toArray = $__require('f3');
  var on = $__require('ea');
  var bind = $__require('eb');
  var debug = $__require('c2')('socket.io-client:socket');
  var parseqs = $__require('cc');
  var hasBin = $__require('e2');
  module.exports = exports = Socket;
  var events = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
  };
  var emit = Emitter.prototype.emit;
  function Socket(io, nsp, opts) {
    this.io = io;
    this.nsp = nsp;
    this.json = this;
    this.ids = 0;
    this.acks = {};
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this.connected = false;
    this.disconnected = true;
    this.flags = {};
    if (opts && opts.query) {
      this.query = opts.query;
    }
    if (this.io.autoConnect) this.open();
  }
  Emitter(Socket.prototype);
  Socket.prototype.subEvents = function () {
    if (this.subs) return;
    var io = this.io;
    this.subs = [on(io, 'open', bind(this, 'onopen')), on(io, 'packet', bind(this, 'onpacket')), on(io, 'close', bind(this, 'onclose'))];
  };
  Socket.prototype.open = Socket.prototype.connect = function () {
    if (this.connected) return this;
    this.subEvents();
    this.io.open();
    if ('open' === this.io.readyState) this.onopen();
    this.emit('connecting');
    return this;
  };
  Socket.prototype.send = function () {
    var args = toArray(arguments);
    args.unshift('message');
    this.emit.apply(this, args);
    return this;
  };
  Socket.prototype.emit = function (ev) {
    if (events.hasOwnProperty(ev)) {
      emit.apply(this, arguments);
      return this;
    }
    var args = toArray(arguments);
    var packet = {
      type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
      data: args
    };
    packet.options = {};
    packet.options.compress = !this.flags || false !== this.flags.compress;
    if ('function' === typeof args[args.length - 1]) {
      debug('emitting packet with ack id %d', this.ids);
      this.acks[this.ids] = args.pop();
      packet.id = this.ids++;
    }
    if (this.connected) {
      this.packet(packet);
    } else {
      this.sendBuffer.push(packet);
    }
    this.flags = {};
    return this;
  };
  Socket.prototype.packet = function (packet) {
    packet.nsp = this.nsp;
    this.io.packet(packet);
  };
  Socket.prototype.onopen = function () {
    debug('transport is open - connecting');
    if ('/' !== this.nsp) {
      if (this.query) {
        var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
        debug('sending connect packet with query %s', query);
        this.packet({
          type: parser.CONNECT,
          query: query
        });
      } else {
        this.packet({ type: parser.CONNECT });
      }
    }
  };
  Socket.prototype.onclose = function (reason) {
    debug('close (%s)', reason);
    this.connected = false;
    this.disconnected = true;
    delete this.id;
    this.emit('disconnect', reason);
  };
  Socket.prototype.onpacket = function (packet) {
    var sameNamespace = packet.nsp === this.nsp;
    var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';
    if (!sameNamespace && !rootNamespaceError) return;
    switch (packet.type) {
      case parser.CONNECT:
        this.onconnect();
        break;
      case parser.EVENT:
        this.onevent(packet);
        break;
      case parser.BINARY_EVENT:
        this.onevent(packet);
        break;
      case parser.ACK:
        this.onack(packet);
        break;
      case parser.BINARY_ACK:
        this.onack(packet);
        break;
      case parser.DISCONNECT:
        this.ondisconnect();
        break;
      case parser.ERROR:
        this.emit('error', packet.data);
        break;
    }
  };
  Socket.prototype.onevent = function (packet) {
    var args = packet.data || [];
    debug('emitting event %j', args);
    if (null != packet.id) {
      debug('attaching ack callback to event');
      args.push(this.ack(packet.id));
    }
    if (this.connected) {
      emit.apply(this, args);
    } else {
      this.receiveBuffer.push(args);
    }
  };
  Socket.prototype.ack = function (id) {
    var self = this;
    var sent = false;
    return function () {
      if (sent) return;
      sent = true;
      var args = toArray(arguments);
      debug('sending ack %j', args);
      self.packet({
        type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
        id: id,
        data: args
      });
    };
  };
  Socket.prototype.onack = function (packet) {
    var ack = this.acks[packet.id];
    if ('function' === typeof ack) {
      debug('calling ack %s with %j', packet.id, packet.data);
      ack.apply(this, packet.data);
      delete this.acks[packet.id];
    } else {
      debug('bad ack %s', packet.id);
    }
  };
  Socket.prototype.onconnect = function () {
    this.connected = true;
    this.disconnected = false;
    this.emit('connect');
    this.emitBuffered();
  };
  Socket.prototype.emitBuffered = function () {
    var i;
    for (i = 0; i < this.receiveBuffer.length; i++) {
      emit.apply(this, this.receiveBuffer[i]);
    }
    this.receiveBuffer = [];
    for (i = 0; i < this.sendBuffer.length; i++) {
      this.packet(this.sendBuffer[i]);
    }
    this.sendBuffer = [];
  };
  Socket.prototype.ondisconnect = function () {
    debug('server disconnect (%s)', this.nsp);
    this.destroy();
    this.onclose('io server disconnect');
  };
  Socket.prototype.destroy = function () {
    if (this.subs) {
      for (var i = 0; i < this.subs.length; i++) {
        this.subs[i].destroy();
      }
      this.subs = null;
    }
    this.io.destroy(this);
  };
  Socket.prototype.close = Socket.prototype.disconnect = function () {
    if (this.connected) {
      debug('performing disconnect (%s)', this.nsp);
      this.packet({ type: parser.DISCONNECT });
    }
    this.destroy();
    if (this.connected) {
      this.onclose('io client disconnect');
    }
    return this;
  };
  Socket.prototype.compress = function (compress) {
    this.flags.compress = compress;
    return this;
  };
  Socket.prototype.binary = function (binary) {
    this.flags.binary = binary;
    return this;
  };
});
$__System.registerDynamic('104', ['c0', 'ec', 'e8', 'c2', 'e9'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var url = $__require('c0');
  var parser = $__require('ec');
  var Manager = $__require('e8');
  var debug = $__require('c2')('socket.io-client');
  module.exports = exports = lookup;
  var cache = exports.managers = {};
  function lookup(uri, opts) {
    if (typeof uri === 'object') {
      opts = uri;
      uri = undefined;
    }
    opts = opts || {};
    var parsed = url(uri);
    var source = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache[id] && path in cache[id].nsps;
    var newConnection = opts.forceNew || opts['force new connection'] || false === opts.multiplex || sameNamespace;
    var io;
    if (newConnection) {
      debug('ignoring socket cache for %s', source);
      io = Manager(source, opts);
    } else {
      if (!cache[id]) {
        debug('new io instance for %s', source);
        cache[id] = Manager(source, opts);
      }
      io = cache[id];
    }
    if (parsed.query && !opts.query) {
      opts.query = parsed.query;
    }
    return io.socket(parsed.path, opts);
  }
  exports.protocol = parser.protocol;
  exports.connect = lookup;
  exports.Manager = $__require('e8');
  exports.Socket = $__require('e9');
});
$__System.registerDynamic("105", ["104"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("104");
});
$__System.register('106', ['13', '105'], function (_export) {
    var _classCallCheck, io, socketOpen, SocketsService;

    return {
        setters: [function (_2) {
            _classCallCheck = _2['default'];
        }, function (_3) {
            io = _3['default'];
        }],
        execute: function () {
            'use strict';

            socketOpen = null;

            SocketsService = function SocketsService($q, $rootScope, $location, $window, Local, Messages, Session, SessionAdapter, LcCache, Track, _) {
                _classCallCheck(this, SocketsService);

                //
                // Only process some socket messages
                //
                var messagesToProcess = {
                    log: [9, 11, 22, 23],
                    crud: [6, 9, 12, 101],
                    notice: [13, 55],
                    zoneState: [11, 102]
                    // Zombie is type 10
                };

                var namespace = '';
                var socket;
                var breakInConnection = false;

                //specify API address here
                var protocol = $location.protocol();
                var host = $location.host();
                var port = $location.port() || '';
                var url = '';

                if (port === 3000 || port === 9000 || port === 8080 || port === 8081) {
                    url = $rootScope.backEndUrl.slice(0, -1) + '/' + namespace; //url = $rootScope.backEndUrl.slice(0, -1) + ':5000/' + namespace; for Control
                } else {
                        url = protocol + '://' + host + '/' + namespace;
                    }

                this.disconnect = disconnect;
                this.sendShout = sendShout;
                this.joinRoom = joinRoom;

                socketOpen = false;

                //Temp for WS debugging
                $window.lcSetRoom = setRoom;

                function joinRoom(oldRoomId, newRoomId) {
                    var promise = createConnection();

                    promise.then(function (greeting) {
                        //Join room on ready
                        setRoom(oldRoomId, newRoomId);
                    }, function (reason) {
                        console.warn('--- SOCKET: Failed: ' + reason);
                    }, function (update) {
                        console.warn('--- SOCKET: Got notification: ' + update);
                    });
                }

                function createConnection() {
                    var deferred = $q.defer();

                    if (!socket) {
                        console.info('--- SOCKET: new connection');
                        socket = io(url, {
                            'reconnect': true,
                            'reconectionDelay': 9000,
                            'reconnectionAttempts': 10,
                            'forceNew': false,
                            'transports': ['websocket', 'flashsocket', 'htmlfile', 'xhr-polling', 'jsonp-polling']
                        });

                        socket.on('connect', function () {
                            console.info('--- SOCKET: Socket "connect" event fired');
                            socket.emit('auth', { username: Local.get('lcUser') ? Local.get('lcUser').username : null, apiKey: Local.get('apiKey') });

                            //Bit of an Anti-pattern but we have to wait for 'ready' AFTER auth
                            socket.on('ready', function () {
                                console.info('--- SOCKET: Socket "ready" event fired');
                                deferred.resolve(true);

                                LcCache.socketConnectionBroken = false;

                                if (breakInConnection) {
                                    setRoom(false, socket.currentRoom, true);
                                    breakInConnection = false;
                                }
                            });

                            //Dont need to wait on these bindings
                            bindEvents();
                        });
                    } else {
                        console.info('--- SOCKET: existing connection');
                        deferred.resolve(true);
                    }
                    return deferred.promise;
                }

                function setRoom(oldRoomId, newRoomId, forceRoom) {
                    //We have a connection
                    if (oldRoomId) {
                        console.info('--- SOCKET: Leaving Room: ' + oldRoomId);
                        socket.emit('leave', { room: oldRoomId });
                    }
                    if (newRoomId && newRoomId !== socket.currentRoom || forceRoom) {
                        //We have a new room to join
                        console.info('--- SOCKET: Joining Room: ' + newRoomId);
                        socket.emit('join', { room: newRoomId });
                        socket.currentRoom = newRoomId;
                    }
                    return newRoomId;
                }

                function sendShout(message) {
                    console.info('SOCKETS: Socket.shout called');
                    socket.emit('shout', message);
                }

                function disconnect() {
                    //We can't properly close the WS
                    if (socket) {
                        console.info('--- SOCKET: Leaving room: ' + socket.currentRoom);
                        socket.emit('leave', { room: socket.currentRoom });

                        socketOpen = true;

                        socket.io.autoConnect = false; //MUST SET OR ELSE RECONNECTS
                        unbindEvents();
                        socket.disconnect();
                        socket = null;
                    }
                }

                function connectionBreak(room) {
                    if (socket) {
                        console.warn('SOCKETS: Connection is broken :( ');

                        //@todo - Put in fresh backend call here...
                        LcCache.socketConnectionBroken = true;
                        breakInConnection = true;
                        unbindEvents();
                    }
                }

                function bindEvents() {
                    console.info('--- SOCKET: Binding');

                    delete socket.$events;

                    if (!socket.$events) {
                        //don't bind events again if they already exist, allows us to call connect() multiple times

                        socket.on('disconnect', function () {
                            console.warn('--- SOCKET: Socket "disconnect" event fired');

                            Track.event('Socket: Disconnect', 'Disconnect ' + ($rootScope.currentSite ? $rootScope.currentSite.id : ' no current site'));

                            if (!socketOpen) {
                                socketOpen = false;
                                connectionBreak(socket.currentRoom);
                            }
                        });

                        socket.on('refresh', function (msg) {
                            $window.location.reload(false);
                        });

                        socket.on('shout', function (msg) {
                            Messages.popUp(msg, null, null, true);
                            Messages.pushNewMessage(msg);
                        });

                        socket.on('gateway_events', function (rawMessage) {
                            var message = rawMessage.data;

                            function pCheck(type, category) {
                                return messagesToProcess[category].indexOf(type) > -1;
                            }

                            if (message) {
                                //
                                // Single point of Socket message consumption in app
                                //

                                //
                                // Any message with dezombified flag set
                                //
                                if (angular.isDefined(message.dezombified)) {
                                    //
                                    // Only ever set to true
                                    //
                                    LcCache.updateSessionSiteZombie(message.site_id, message.gateway_device_id);

                                    appBroadcaster('dezombified', message.site_id, message.gateway_device_id);
                                }

                                //
                                // Messages pertaining to object changes / CRUD
                                //
                                if (pCheck(message.msg_type, 'crud')) {
                                    //
                                    // Only interact with cache for some events
                                    //
                                    if (message.object) {
                                        var objectType = message.object_type + 's';

                                        console.log('Trying to update cache with socket msg');
                                        console.log(message);

                                        var renderedObject = SessionAdapter.socketRenderers(objectType, message.object);

                                        if (message.action === 'DELETE') {
                                            LcCache.removeSessionSiteSectionChild(objectType, [renderedObject]);
                                        } else {
                                            LcCache.updateSessionSiteSectionChild(objectType, [renderedObject], true);
                                        }
                                    }

                                    // New node has its own structure...
                                    if (message.msg_type === 12) {
                                        var objectType = 'devices';

                                        console.log('New node!');
                                        console.log(message);

                                        //
                                        //
                                        // @Todo - Include site updates here?
                                        //
                                        //
                                        LcCache.updateSessionSiteSectionChild(objectType, [message.nodes_info[0]], true);
                                    }

                                    if (message.msg_type === 9 && angular.isDefined(message.setup_mode)) {
                                        //
                                        // Setup mode change message
                                        //
                                        LcCache.updateSessionSiteSetupMode(message.site_id, message.setup_mode);

                                        appBroadcaster('setupMode', { site_id: message.site_id, setup_mode: message.setup_mode, gateway_device_id: message.gateway_device_id }, message.timestamp);
                                    }
                                }

                                // Push message to any log watchers
                                //
                                //  - Home component
                                //  - Org activity modal
                                //  - Device activity section
                                //
                                if (pCheck(message.msg_type, 'log')) {
                                    //
                                    // Only log some messages
                                    //
                                    Messages.pushNewMessage(message);
                                }

                                //
                                // Notices
                                //
                                if (pCheck(message.msg_type, 'notice')) {
                                    // Send indicate + targetId
                                    if (message.msg_type === 55) {
                                        appBroadcaster('deviceStatus', message.nodes);
                                    } else {
                                        appBroadcaster('indicate', message.nodes_info[0].id, message.timestamp);
                                    }
                                }

                                // we only get state info here - plus refreshing the zone list on every state update isn't as performant
                                //
                                if (pCheck(message.msg_type, 'zoneState')) {

                                    if (message.action) {
                                        //
                                        // 'CMD' messages look a little different to CRUD
                                        //
                                        // These messages aren't technically object updates, they are requests to update - use to mark pending
                                        if (message.action === 'CMD') {
                                            //
                                            // CCT missing from this update req message
                                            //
                                            appBroadcaster('zoneState', _.extend(message.object, { action: 'request' }));
                                        }
                                    } else {
                                        //
                                        // True state update from GW
                                        //
                                        appBroadcaster('zoneState', parseZoneState(message));
                                    }
                                }

                                if (message.msg_type == 19 && message.process == 'zone calibration') {
                                    appBroadcaster('calibrationStatus', false, message.timestamp);
                                }

                                if (message.msg_type == 16) {
                                    appBroadcaster('groupState', message, message.timestamp);
                                }

                                //
                                // Log as text to prevent memory usage (no GC for console logs in Chrome)
                                //
                                console.info('--- SOCKET: Gateway Event Socket Incoming', JSON.stringify(message, undefined, 2));
                            }
                        });

                        socket.on('join_events', function (msg) {
                            console.info('--- SOCKET: Socket Join Events', msg.data);
                        });
                    }
                }

                function parseZoneState(msgData) {
                    var thisNode = msgData.nodes_info[0];
                    var thisNodeState = msgData.nodes[0].node_state;

                    return {
                        action: 'response',
                        node_id: thisNode.id,
                        reported_cct: thisNodeState.cct,
                        reported_dim_level: thisNodeState.DIM_LEVEL,
                        zone_health: thisNode.node_health,
                        zone_state: thisNodeState.LIGHTS_ON
                    };
                }

                function appBroadcaster(eventCategory, data, timestamp) {
                    // console.log('broadcasting',JSON.stringify(data, undefined, 2));
                    $rootScope.$broadcast('event:socket:' + eventCategory, data, timestamp);
                }

                function unbindEvents() {
                    socket.removeListener('ready');
                    socket.removeListener('disconnect');
                    socket.removeListener('shout');
                    socket.removeListener('gateway_events');
                    socket.removeListener('join_events');
                }
            };

            _export('default', SocketsService);
        }
    };
});

$__System.register('107', ['3', '106'], function (_export) {
    'use strict';

    var angular, SocketsService, socketsModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            SocketsService = _2['default'];
        }],
        execute: function () {
            socketsModule = angular.module('sockets', []).service('Sockets', SocketsService);

            _export('default', socketsModule);
        }
    };
});

$__System.registerDynamic("108", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<left-nav-list-search item-count=\"nL.totalItemCount\" item-type=\"\" on-search-term=\"nL.search(query)\"></left-nav-list-search>\n<left-nav-list-filter \n    on-filter-selection-change=\"nL.updateFilterByKeyValues(filters)\" \n    on-clear-selection=\"nL.onChildMultiSelectChange(mode)\" \n    selection-count=\"nL.navLevelSelectionCache.level2.size\" \n    available-filters=\"nL.filterOptions\" \n    multi-select=\"nL.multiSelectMode\"\n    filtered-group-list=\"nL.filteredGroupList\"\n    site-id=\"nL.siteId\"\n    on-enable-multi-select=\"nL.onChildMultiSelectChange(mode)\"\n></left-nav-list-filter>\n<left-nav-list-multi-select \n    ng-if=\"nL.multiSelectMode\"\n    multi-select-mode=\"nL.multiSelectMode\" \n    item-selected=\"nL.navLevelSelectionCache.level2.size > 0\"\n    on-multi-select-change=\"nL.onChildMultiSelectChange(mode)\"\n    on-select-action=\"nL.onSelectAction(action)\"\n></left-nav-list-multi-select>\n\n<div class=\"left-nav-mobile-container\" ng-if=\"nL.showMobileSection\">\n    <div class=\"left-nav-list-group-item-contents\" ng-click=\"nL.onUpdateSelectionCache({action: 'mobileShowAllZones'})\">\n        <h1 class=\"name\">Show Overview</h1>\n    </div>\n</div>\n\n<div class=\"left-nav-mobile-container\" ng-if=\"nL.multiSelectMode && nL.itemSelected\">\n    <div class=\"left-nav-list-group-item-contents\" ng-click=\"nL.onUpdateSelectionCache({action: 'mobileMultiSelection'})\">\n        <h1 class=\"name\" >Finish Selection</h1>\n    </div>\n</div>\n\n<div class=\"left-nav-group-list-wrapper\" lc-context-menu scenes=\"nL.scenes\" sites=\"nL.sites\" on-context-click=\"nL.contextMenuAction(action,itemType,id,parentId)\">\n    <ul class=\"left-nav-group-list\">\n        <li \n            class=\"left-nav-list-group-special-dropzone special-drop-target-hidden new-group\"\n            lc-droppable-item\n            lc-droppable-target-id=\"\"\n            lc-droppable-special=\"newGroup\"\n        ><span>Create New Area</span></li>\n        <left-nav-list-group \n            ng-repeat=\"group in nL.filteredGroupList | filter : nL.groupFilter(nL.searchTerm)\"\n            allow-drag-drop=\"nL.allowDragDrop\"\n            expanded=\"group.expanded\"\n            group-index=\"$index\"\n            group=\"group\"\n            search-term=\"nL.searchTerm\"\n            multi-select-mode=\"nL.multiSelectMode\"\n            on-group-select=\"nL.handleSelection(nL.groupList, group, clickEvent)\" \n            on-group-item-select=\"nL.handleSelection(group.children, item, clickEvent)\"\n            on-expanded=\"nL.handleExpanded(status, groupIndex)\"\n        ></left-nav-list-group>\n        <li \n            class=\"left-nav-list-group-special-dropzone special-drop-target-hidden de-group\"\n            lc-droppable-item\n            lc-droppable-target-id=\"\"\n            lc-droppable-special=\"deGroup\"\n        ><span>Remove From Area</span></li>\n        <li \n            class=\"left-nav-list-group-special-hoverzone special-drop-target-hidden scroll-down\"\n            lc-droppable-item\n            lc-droppable-target-id=\"\"\n            lc-droppable-special=\"down\"\n        >Jump to Bottom</li>\n    </ul>\n</div>\n";
});
$__System.register('109', ['20', '61', '70', '108'], function (_export) {
    var _toConsumableArray, _Set, _Object$keys, leftNavListTmpl, leftNavListComponent;

    return {
        setters: [function (_2) {
            _toConsumableArray = _2['default'];
        }, function (_4) {
            _Set = _4['default'];
        }, function (_3) {
            _Object$keys = _3['default'];
        }, function (_5) {
            leftNavListTmpl = _5['default'];
        }],
        execute: function () {
            'use strict';

            leftNavListComponent = {
                template: leftNavListTmpl,
                bindings: {
                    activeFilters: '<',
                    allowDragDrop: '<',
                    areas: '<',
                    devices: '<',
                    groupList: '<',
                    filterOptions: '<',
                    navLevelSelectionCache: '<',
                    siteId: '<',
                    updateStatus: '<',
                    zones: '<',
                    scenes: '<',
                    automations: '<',
                    leftMenuSpecialContext: '<',
                    multiSelectStatus: '<',
                    sites: '<',
                    //
                    // - Out -
                    //
                    onClearGotoBaseView: '&',
                    onClearSelectionCache: '&',
                    onFilterUpdate: '&',
                    onUpdateSelectionCache: '&',
                    onMultiSelectChange: '&'
                },
                controllerAs: 'nL',
                controller: function controller($rootScope, $scope, $filter, $q, $timeout, $location, $window, $state, Modals, Zones, Areas, Messages, Programmer, ContextualMenusActions, _, Undo, LcFn) {
                    /**
                     * [nL description]
                     * @type {component}
                     * @requires [component:masterLeft]
                     * 
                     *  Component should support N tree depth (have limited it to 3 for now)    
                     *  Ideally it won't get noticably slower at this depth.     
                     *   
                     */
                    var nL = this;

                    /**
                     * @private
                     * @description init - Get groupList from
                     */
                    nL.$onInit = function () {
                        setFilteredGroupList(nL.groupList);
                        checkMultiSelectMode();
                        checkCurrentLocation();
                        nL.groupExpandStatusHolder = [];
                    };

                    nL.$destroy = function () {
                        //
                    };

                    nL.$onChanges = function (changes) {
                        //Item selection while filters are active
                        if (changes.activeFilters && changes.activeFilters.currentValue) {
                            setFilteredGroupList($filter('nLFilterGroups')(nL.groupList, changes.activeFilters.currentValue));
                        } else if (changes.groupList) {
                            if (nL.activeFilters) {
                                setFilteredGroupList($filter('nLFilterGroups')(nL.groupList, nL.activeFilters));
                            } else {
                                setFilteredGroupList(nL.groupList);
                            }
                        }
                        if (changes.multiSelectStatus) {
                            nL.multiSelectMode = changes.multiSelectStatus.currentValue;
                            if (!nL.multiSelectMode) {
                                nL.itemSelected = false;
                            }
                        }
                    };

                    $scope.$on('event:socket:indicate', function (event, indicationTargetNodeId, timestamp) {
                        console.log('Node Indicating', indicationTargetNodeId);

                        var matchingGroupIndex = _.findIndex(nL.filteredGroupList, function (group) {
                            return _.find(group.children, { id: indicationTargetNodeId });
                        });

                        if (matchingGroupIndex > -1) {
                            var group = nL.filteredGroupList[matchingGroupIndex];
                            var child = _.find(group.children, { id: indicationTargetNodeId });

                            // Group
                            //group.expanded = true; //Expand group

                            //Bring to top (temporarily breaks alphabetical order for highlighting)
                            nL.filteredGroupList.splice(matchingGroupIndex, 1);
                            nL.filteredGroupList.unshift(group); //.splice(matchingGroupIndex,1);

                            //Flag child with indication timestamp (will trigger $onChanges with subsequent hits)
                            child.indicate = timestamp;

                            //Trigger Child components
                            $scope.$apply();
                        } else {
                            console.log('No matching node?');
                        }
                    });

                    $scope.$on('event:socket:deviceStatus', function (event, updateInfo) {
                        if (nL.updateStatus && nL.updateStatus) {
                            _Object$keys(updateInfo).forEach(function (key) {
                                nL.updateStatus.nodes[key] = updateInfo[key];
                            });
                            $timeout(function () {
                                setFilteredGroupList(nL.groupList);
                            });
                        }
                    });

                    nL.lastSelection = {};

                    nL.clearToBase = function () {
                        //resetAllSelections();
                        //resetLocalSelections();
                        nL.onClearGotoBaseView();
                    };

                    /**
                     * @param  {string} search query
                     * @return {[type]}
                     */
                    nL.search = function (query) {
                        nL.searchTerm = query;
                    };

                    /*
                    nL.filterMode = { // @todo In future - track user-expanded groups while searching
                        active     : false,
                        expanded   : [],
                        query: null
                    };
                    */

                    nL.groupFilter = function (searchTerm) {
                        return function (thisGroup, id, list) {
                            var matches = $filter('filter')([thisGroup], searchTerm).length;

                            return matches;
                        };
                    };

                    nL.updateFilterByKeyValues = function (filters) {
                        nL.onFilterUpdate({ filters: filters }); // - Avoid $digest loop filtering by triggering here instead
                    };

                    nL.contextMenuAction = function (action, itemType, id, parentId) {
                        //console.log(action,itemType,id,parentId,contextActionIds);
                        var scopedActions = {
                            assign: function assign(itemType, contextActionIds, parentId) {
                                return createGroupAndMove(nL.siteId, itemType, contextActionIds, parentId);
                            },
                            createGroup: function createGroup(itemType, contextActionIds, parentId) {
                                return createGroupControl(nL.siteId, itemType, contextActionIds, parentId);
                            },
                            edit: function edit(itemType, contextActionIds) {
                                if (itemType === 'zone') {
                                    // Zone edit is in device view - get node id from zone obj
                                    contextActionIds = _.filter(_.map(contextActionIds, function (id) {
                                        return _.find(nL.zones, { id: id }) ? _.find(nL.zones, { id: id }).node : null;
                                    }));

                                    itemType = 'device';
                                } else if (itemType === 'scene') {
                                    contextActionIds = id;
                                };
                                return $state.go(itemType.charAt(0).toUpperCase() + itemType.slice(1) + 's', { siteId: nL.siteId, userSelectedFilter: 'selection~' + contextActionIds.toString().replace(/,/g, '-'), leftMenuSpecialContext: itemType + 's', edit: true });
                            },
                            quickAdd: function quickAdd(itemType, contextActionIds, parentId, siteId, areas, zones) {
                                // - Add unassigned zones to their own category
                                var allItems = [{
                                    type: 'zones',
                                    areas: [{
                                        name: 'No Area',
                                        zones: _.filter(zones, { area: null })
                                    }],
                                    selected: []
                                }];

                                //               allItems, title, class
                                return Modals.showMulti(allItems, 'Zones', 'site-scenes').then(function (items) {
                                    promptReorganize('zone', _.map(items, 'id'), id, 'X');
                                });
                            },
                            toggle: function toggle(itemType, contextActionIds) {
                                var selectedGroup = _.find(nL.groupList, { id: contextActionIds[0] });

                                nL.handleSelection(nL.groupList, selectedGroup, {});

                                return $q.defer().promise;
                            },
                            unassign: function unassign(itemType, contextActionIds, parentId) {
                                return promptReorganize(itemType, contextActionIds, null, parentId);
                            }
                        };

                        //
                        // Right-click on unselected is default action, but if group is selected we perform group actions instead
                        // Area only for now
                        //
                        var selectionIds = [].concat(_toConsumableArray(nL.navLevelSelectionCache[itemType === 'group' ? 'level1' : 'level2']));

                        var contextActionIds = selectionIds.length ? selectionIds : [id];

                        return scopedActions[action] ? scopedActions[action](itemType, contextActionIds, parentId, nL.siteId, nL.areas, nL.zones) : ContextualMenusActions[action](itemType, contextActionIds, parentId, nL.siteId, nL.areas, nL.automations, nL.leftMenuSpecialContext).then(function () {
                            // Callback?
                        });
                    };

                    /**
                     * @public - @param {Object} selectedParent 
                     * @param {Object} selectedItem
                     * @param {Object} clickEvent
                     */
                    nL.handleSelection = function (selectedParent, selectedItem, clickEvent) {
                        //
                        // Check outstanding changes before we transition
                        //
                        Undo.checkOutstanding().then(function () {
                            handleSelection(selectedParent, selectedItem, clickEvent);
                        });
                    };

                    function handleSelection(selectedParent, selectedItem, clickEvent) {
                        //
                        // 'Ctrl' key sometimes passed as 'metaKey' (ie win usb keyboard on mac)
                        //
                        var ctrlKey = clickEvent.ctrlKey || clickEvent.metaKey;
                        //
                        //  If ctrl & shift selected - ctrl wins out
                        //           
                        if (ctrlKey || nL.multiSelectMode) {
                            selectItem(selectedItem);
                            nL.itemSelected = true;
                        } else if (clickEvent.shiftKey) {
                            selectRange(selectedParent, selectedItem, nL.lastSelection);
                            nL.itemSelected = true;
                        } else {
                            resetAllSelections();
                            nL.itemSelected = false;
                            //
                            // Cover for a selection of a selected group
                            //
                            selectedItem.selected = false;

                            selectItem(selectedItem);
                        }

                        if (selectedItem.type === 'scene') {
                            $state.go('Scenes', {
                                siteId: nL.siteId,
                                userSelectedFilter: 'selection~' + selectedItem.id,
                                leftMenuSpecialContext: 'scenes'
                            });
                        }

                        nL.lastSelection = selectedItem;

                        nL.onUpdateSelectionCache({ cache: nL.navLevelSelectionCache });
                    }

                    /**
                     * @private
                     * @description Check if a group is a special group that should be kept at the end
                     * @param {Object} group - The group to check
                     * @return {Boolean} - True if the group is special
                     */
                    function isSpecialGroup(group) {
                        // Special groups have ids 'X', 'Y', 'Z' or specific titles
                        var specialIds = ['X', 'Y', 'Z'];
                        var specialTitles = ['Unassigned', 'Demand Response', 'Site Wide', 'Admins', 'Regular', 'Automation', 'Smart Shift', 'All Show Groups'];

                        return specialIds.indexOf(group.id) !== -1 || specialTitles.indexOf(group.title) !== -1;
                    }

                    /**
                     * @private
                     * @description Get sort value for an item (description with fallback to title)
                     * @param {Object} item - Item to get sort value for
                     * @return {String} - Sort value (description or title)
                     */
                    function getSortValue(item) {
                        return item.description && item.description.trim() || item.title || '';
                    }

                    /**
                     * @private
                     * @description Sort groups alphabetically, keeping special groups at the end
                     * @param {Array} groups - Array of groups to sort
                     * @return {Array} - Sorted array with special groups at the end
                     */
                    function sortGroups(groups) {
                        // Separate regular and special groups
                        var regularGroups = [];
                        var specialGroups = [];

                        groups.forEach(function (group) {
                            if (isSpecialGroup(group)) {
                                specialGroups.push(group);
                            } else {
                                regularGroups.push(group);
                            }
                        });

                        // Sort regular groups alphabetically by description (fallback to title)
                        var sortedRegular = _.orderBy(regularGroups, [getSortValue], ['asc']);

                        // Sort special groups alphabetically by description (fallback to title)
                        var sortedSpecial = _.orderBy(specialGroups, [getSortValue], ['asc']);

                        // Return regular groups first, then special groups
                        return [].concat(_toConsumableArray(sortedRegular), _toConsumableArray(sortedSpecial));
                    }

                    /**
                     * @private
                     * @description Sort children within a group alphabetically
                     * @param {Object} group - Group with children to sort
                     * @return {Object} - Group with sorted children
                     */
                    function sortGroupChildren(group) {
                        if (group.children && group.children.length > 0) {
                            // Sort by description (fallback to title)
                            group.children = _.orderBy(group.children, [getSortValue], ['asc']);
                        }
                        return group;
                    }

                    function setFilteredGroupList(list) {
                        if (!list || !Array.isArray(list)) {
                            nL.filteredGroupList = [];
                            nL.totalItemCount = 0;
                            return;
                        }
                        if (nL.updateStatus) {
                            _.forEach(list, function (section) {
                                if (section.children && section.children.length > 0) {
                                    section.children.forEach(function (child) {
                                        var status = nL.updateStatus.nodes[child.id];
                                        if (status) {
                                            child.status = status;
                                        }
                                    });
                                }
                            });
                        }

                        // Sort children within each group alphabetically
                        var listWithSortedChildren = list.map(function (group) {
                            return sortGroupChildren(angular.copy(group));
                        });

                        // Sort groups alphabetically (special groups at end)
                        var sortedList = sortGroups(listWithSortedChildren);

                        nL.filteredGroupList = angular.copy(updateGroupExpandStatus(sortedList));
                        //
                        // Count all items
                        //
                        nL.totalItemCount = _.flatten(_.map(list, function (list) {
                            return list.children;
                        })).length;
                    }

                    /**
                     * @constructor
                     * @description - Keep selection cache seperate to view should make some stuff a lot faster
                     */
                    var SelectionCache = function SelectionCache() {
                        //
                        //  Use new ES6 Set - lets us push() / add() without duplicates
                        //  3 levels is my arbitrary choice for now...
                        //
                        this.level1 = new _Set();
                        this.level2 = new _Set();
                        this.level3 = new _Set();
                    };

                    /**
                     * @public
                     * @description - Clear selection
                     */
                    function resetAllSelections() {
                        resetLocalSelections();
                        nL.onClearSelectionCache();
                    }

                    function resetLocalSelections() {
                        clearLeftNavCache();
                        nL.groupList = clearSelection(nL.groupList);
                    }

                    /**
                     * @private
                     * @param  {obj} group
                     * @return {obj} group with all deselected
                     */
                    function clearSelection(group) {
                        return _.map(group, function (item) {
                            item.selected = false;
                            item.children = clearSelection(item.children);
                            return item;
                        });
                    }

                    /**
                     * @private
                     * @description Recursive func to select all items in tree
                     * @param  {Obj} selectedItem - folder / item clicked by user
                     * @param  {Boolen} forceState - override state toggle
                     * @return {Obj} selectedItem
                     */
                    function selectItem(selectedItem, forceState) {
                        selectedItem.selected = angular.isDefined(forceState) ? forceState : !selectedItem.selected;

                        updateNavLevelSelectionCache(selectedItem.level, selectedItem.id, selectedItem.selected);

                        if (selectedItem.children.length > 0) {
                            selectedItem.children = _.map(selectedItem.children, function (item) {
                                return selectItem(item, selectedItem.selected);
                            });
                        }
                        checkMultiSelectMode();
                        return selectedItem;
                    }

                    /**
                     * @private
                     * @param {Object} groupList - parent list of groups 
                     * @param {Object} selectedItem
                     * @param {Object} lastSelection - previously clicked item
                     */
                    function selectRange(groupList, selectedItem, lastSelection) {
                        //
                        // If last selection is within group, select this range
                        // Could try and be smarter - if last selection was in parent range, select between these groups
                        //
                        var selectionIndex = selectedItem.index;
                        var lastSelectionIndex = lastSelection.index;

                        if (lastSelection.level === selectedItem.level) {
                            if (lastSelectionIndex > -1 && lastSelectionIndex !== selectionIndex) {
                                //
                                // Probably a cleaner way to do this but for 10's of items we can live with it
                                //
                                _.each(groupList, function (group, key) {
                                    if (key > lastSelectionIndex && key <= selectionIndex || key < lastSelectionIndex && key >= selectionIndex) {
                                        selectItem(group, true);
                                    }
                                });
                            }
                        }
                    }

                    function updateNavLevelSelectionCache(cache, id, add) {
                        if (!nL.navLevelSelectionCache) {
                            nL.navLevelSelectionCache = new SelectionCache();
                        }

                        if (add) {
                            nL.navLevelSelectionCache[cache].add(id);
                        } else {
                            nL.navLevelSelectionCache[cache]['delete'](id);
                        }
                    }

                    function clearLeftNavCache() {
                        nL.navLevelSelectionCache = new SelectionCache();
                    }

                    /**
                     * Drag & Drop
                     *
                     * OFfload this to a directive and refactor - should only watch these events in once place ideally
                     * 
                     */

                    $scope.$on('LC-DRAG-START', function (scope, event) {
                        //console.log('drag start')
                    });

                    $scope.$on('LC-DRAG-END', function (scope, event) {
                        //console.log('drag end')
                    });

                    $scope.$on('LC-DRAG-DROP', function (scope, data, special) {
                        var dragTypeAndIds = data.split(',');

                        var itemType = dragTypeAndIds[0];

                        var sourceItemId = parseInt(dragTypeAndIds[1]);
                        var sourceParentId = isNaN(dragTypeAndIds[2]) ? dragTypeAndIds[2] : parseInt(dragTypeAndIds[2]);
                        var destinationId = isNaN(dragTypeAndIds[3]) ? dragTypeAndIds[3] : parseInt(dragTypeAndIds[3]);

                        if (sourceParentId !== destinationId) {
                            //
                            // Functionally we should pass the other ids here but the parent cache knows of all selections,
                            // we can use this to move multiple items from different groups - just feed it the destination
                            //
                            var selectionIds = [].concat(_toConsumableArray(nL.navLevelSelectionCache.level2));

                            //
                            // Drag event can happen with NO selection
                            // Drag can also happen on unselected item
                            //
                            selectionIds = selectionIds.indexOf(sourceItemId) === -1 || selectionIds.length < 1 ? [sourceItemId] : selectionIds;

                            if (special) {
                                if (special === 'deGroup') {
                                    //
                                    // Clear selected item parents
                                    //
                                    promptReorganize(itemType, selectionIds, null, sourceParentId);
                                } else if (special === 'newGroup') {
                                    //
                                    // Create new group with selections
                                    //
                                    //
                                    createGroupAndMove(nL.siteId, itemType, selectionIds, sourceParentId);
                                }
                            } else {
                                promptReorganize(itemType, filterReorganizeItems(nL.groupList, destinationId, selectionIds), destinationId, sourceParentId);
                            }
                        }
                    });

                    function createGroupAndMove(siteId, itemType, selectionIds, sourceParentId) {
                        return promptAreaCreation(siteId).then(function (newArea) {
                            return createGroup(newArea);
                        }).then(function (area) {
                            return promptReorganize(itemType, selectionIds, area.id, sourceParentId);
                        });
                    }

                    function createGroupControl(siteId, itemType, selectionIds, sourceParentId) {
                        //todo how to deal with created groups, need to consider
                        var dummyGroup = { site_id: siteId };

                        return Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: dummyGroup,
                                cleanObject: {},
                                title: 'Name Group',
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                dummyGroup.id_string = dummyGroup.name;
                                return dummyGroup;
                            } else {
                                throw 'Cancel';
                            }
                        }).then(function (newGroup) {
                            Modals.openLoad('Creating Control Group...');
                            return Areas.createGroupControl(newGroup).then(function (result) {

                                var zonesIds = itemType === 'zone' ? selectionIds : _.map(_.map(selectionIds, function (id) {
                                    return _.find(nL.zones, { node: id });
                                }), 'id');

                                return Areas.assignGroupControlNodes(result.id, zonesIds, nL.zones).then(function (result) {
                                    Modals.closeLoad('Success', true);
                                })['catch'](function (err) {
                                    console.log(err);
                                    Modals.closeLoad('Failed to assign zones to control group');
                                });
                            })['catch'](function (err) {
                                console.log(err);
                                Modals.closeLoad('Failed to create control group');
                                throw 'Error';
                            });
                        });
                    }

                    function filterReorganizeItems(groupList, targetGroupId, selectionIds) {
                        //
                        // Any drag between areas may indicate a wish to combine zones from
                        // that area with zones from outside (in multi select mode), so we can't just check for zone
                        // area - on every drop we need to see if all zones match target drop area
                        //
                        var targetGroup = _.find(groupList, { id: targetGroupId });

                        var idsNotInTarget = _.filter(selectionIds, function (id) {
                            return !_.find(targetGroup.children, ['id', id]);
                        });

                        return idsNotInTarget;
                    }

                    function promptAreaCreation(siteId) {
                        var dummyArea = { site_id: siteId };

                        return Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: dummyArea,
                                cleanObject: {},
                                title: 'Name Area',
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                //Can we finally get rid of 'name'?
                                dummyArea.id_string = dummyArea.name;

                                return dummyArea;
                            } else {
                                // Let's refactor Modal service soon
                                throw 'Cancel';
                            }
                        });
                    }

                    function createGroup(newArea) {
                        Modals.openLoad('Updating');

                        return Areas.create(newArea).then(function (area) {
                            Modals.closeLoad('Success', true);
                            return area;
                        })['catch'](function (err) {
                            Modals.closeLoad(err.data[0] || '');
                        });
                    }

                    var getMatchingDevice = function getMatchingDevice(deviceId, devices) {
                        return _.find(devices, ['id', deviceId]);
                    };

                    var getMatchingZone = function getMatchingZone(deviceId, zones) {
                        return _.find(zones, ['node', deviceId]);
                    };

                    //
                    // @todo - Bunch of out of scope refs here eg nL.zones
                    //
                    var reorganizor = {
                        device: function device(selectionIds, targetGroupId, sourceParentId) {
                            //
                            // Build promise queue
                            //
                            var movementReqs = [];

                            //
                            // Now sort device moves into two groups, devices with zones will trigger a zone move only
                            //
                            var splitIDsByIsControllerType = _.partition(selectionIds, function (deviceId) {
                                var matchingDevice = getMatchingDevice(deviceId, nL.devices);

                                // Move zones for controller devices OR zonable devices (devices that have associated zones)
                                return matchingDevice && (matchingDevice.isControllerType || matchingDevice.device_type.zonable);
                            });

                            //
                            // Don't match for zoneMatch & device.area or we get duplicates
                            //

                            var controllerTypeDeviceIDs = splitIDsByIsControllerType[0]; // Controller Type or Zonable - use zone call for this
                            var nonControllerTypeDeviceIDs = splitIDsByIsControllerType[1]; // Device type - use old school device move

                            if (controllerTypeDeviceIDs.length) {
                                //
                                // Use corresponding zoneIds for the zone movement
                                //
                                var zoneIDs = controllerTypeDeviceIDs.map(function (id) {
                                    return getMatchingZone(id, nL.zones).id;
                                });

                                movementReqs.push(this.zone(zoneIDs, targetGroupId));
                            }

                            //
                            // If target is null - unassign
                            //
                            if (nonControllerTypeDeviceIDs.length) {
                                //need to handle single unassign node to unassign and group of unassigned nodes to unassign
                                if (!targetGroupId) {
                                    //only unassign those nodes which has area id
                                    //or do nothing
                                    var assignedIds = nonControllerTypeDeviceIDs.filter(function (id) {
                                        var selectDevice = nL.devices.find(function (device) {
                                            return device.id === id;
                                        });
                                        //in order to handle possible error cases
                                        return selectDevice && selectDevice.area;
                                    });
                                    if (assignedIds && assignedIds.length > 0) {
                                        movementReqs.push(Areas.unassignNodes(sourceParentId, nonControllerTypeDeviceIDs, nL.devices));
                                    }
                                } else {
                                    movementReqs.push(Areas.assignNodes(targetGroupId, nonControllerTypeDeviceIDs, nL.devices));
                                }
                            }

                            return $q.all(movementReqs);
                        },
                        scene: function scene() {
                            //No scene actions
                            return $q.resolve();
                        },
                        zone: function zone(selectionIds, targetGroupId) {

                            var zones = _.map(selectionIds, function (id) {
                                return _.find(nL.zones, { id: id });
                            });

                            return Zones.updateGroup(zones, 'area', targetGroupId, nL.devices);
                        }
                    };

                    function promptReorganize(itemType, selectionIds, targetGroupId, sourceParentId) {
                        //
                        // No prompt for now
                        //
                        Modals.openLoad('Updating');

                        return reorganizor[itemType](selectionIds, targetGroupId, sourceParentId).then(function () {
                            Modals.closeLoad('Success', true);
                        })['catch'](function (error) {
                            console.log(error);
                            Messages.popUp('Failed');
                        });
                    }

                    /**
                     * End Drag Drop section
                     */

                    nL.resetAllSelections = resetAllSelections;

                    nL.onChildMultiSelectChange = function (mode) {
                        nL.multiSelectMode = mode;
                        if (!nL.multiSelectMode) {
                            resetAllSelections();
                            nL.clearToBase();
                        }
                        nL.onMultiSelectChange({ mode: mode });
                    };

                    function checkMultiSelectMode() {
                        if (nL.navLevelSelectionCache.level2.size > 1 || nL.multiSelectMode) {
                            nL.multiSelectMode = true;
                        } else {
                            nL.multiSelectMode = false;
                        }
                    }

                    nL.onSelectAction = function (action) {
                        if (LcFn.mobileCheck()) {
                            nL.onUpdateSelectionCache({ action: 'mobileMultiSelection' });
                            setTimeout(function () {
                                nL.contextMenuAction(action, 'device', null, null);
                            }, 1500);
                        } else {
                            nL.contextMenuAction(action, 'device', null, null);
                        }
                    };

                    function checkCurrentLocation() {
                        var location = $location.path().toString();
                        // if(location.includes('overview') || location.includes('energy') || location.includes('recurrence')){
                        //     nL.showMobileSection = true;
                        // }else{
                        //     nL.showMobileSection = false;
                        // }
                        nL.showMobileSection = true;
                    }

                    function updateGroupExpandStatus(list) {
                        _.forEach(nL.groupExpandStatusHolder, function (group) {
                            var temp = _.filter(list, ['index', group.groupIndex]);
                            if (temp[0]) {
                                temp[0].expanded = group.status;
                            }
                        });
                        return list;
                    }

                    nL.handleExpanded = function (status, groupIndex) {
                        if (_.find(nL.groupExpandStatusHolder, ['groupIndex', groupIndex])) {
                            _.find(nL.groupExpandStatusHolder, ['groupIndex', groupIndex]).status = status;
                        } else {
                            nL.groupExpandStatusHolder.push({ groupIndex: groupIndex, status: status });
                        }
                    };
                }
            };

            _export('default', leftNavListComponent);
        }
    };
});

$__System.register('10a', [], function (_export) {
    'use strict';

    var leftNavListGroupComponent;
    return {
        setters: [],
        execute: function () {
            leftNavListGroupComponent = {
                template: '\n            <li \n                lc-droppable-item\n                lc-droppable-target-id="{{::nLG.group.id}}"\n                lc-droppable-special="{{::nLG.group.id === \'X\' ? \'deGroup\': null}}"\n                class="left-nav-group-item-list" \n                ng-class="{selected: nLG.group.selected}"\n            >\n                <h2 class="overview-heading">\n                    <button class="left-nav-group-drop" ng-class="{dropped: nLG.group.expanded}" ng-click="nLG.onExpandOp()"><i class="drop"></i></button>\n                    <div class="left-nav-group-title-contents" ng-click="nLG.selectOrDrop($event)"><!-- ng-click="nLG.selectGroup($event);" -->\n                        <!-- wait for Loz to finish this feature-->\n                        <!--<span class="left-nav-group-title" click-to-rename on-update="nLG.renameItem()" value="nLG.group.title"></span>-->\n                        <span class="left-nav-group-title" >{{nLG.group.title}}</span>\n                        <span class="left-nav-group-count right">{{nLG.group.children.length}}</span>\n                        <span class="left-nav-group-count right" ng-if="nLG.indicateCount > 0">{{nLG.indicateCount}} Indicated</span>\n                    </div>\n                </h2>\n                                \n                <ul ng-if="nLG.group.expanded">\n                    <left-nav-list-group-item ng-repeat="item in nLG.group.children | filter : nLG.searchTerm" allow-drag-drop="{{::nLG.allowDragDrop}}" child-index="$index" indicate="item.indicate" item="item" on-select="nLG.onItemSelect(item, clickEvent)"></left-nav-list-group-item>\n                </ul>\n            </li>\n    ',
                bindings: {
                    allowDragDrop: '<',
                    expanded: '<',
                    groupIndex: '<',
                    group: '<',
                    multiSelectMode: '<',
                    searchTerm: '<',
                    onGroupItemSelect: '&?',
                    onGroupSelect: '&?',
                    onItemDrop: '&?',
                    onExpanded: '&?'
                },
                controllerAs: 'nLG',
                controller: function controller(_, LcFn) {

                    var nLG = this;

                    nLG.$onInit = function () {
                        //openGroups()
                    };

                    nLG.$onChanges = function (changes) {
                        openGroups();

                        //selectGroups();
                        countIndicating();
                    };

                    // nLG.selectGroup = function($event){
                    //     nLG.group.selected = !nLG.group.selected;
                    // };

                    nLG.selectOrDrop = function ($event) {
                        if (LcFn.mobileCheck() && !LcFn.multiSelectMode) {
                            nLG.selectGroup($event);
                        } else {
                            nLG.onExpandOp();
                        }
                    };

                    nLG.selectGroup = function ($event) {
                        //
                        // Select all group children
                        //
                        nLG.onGroupSelect({ group: nLG.group, item: null, clickEvent: $event });
                    };

                    nLG.onItemSelect = function (item, clickEvent) {
                        nLG.onGroupItemSelect({ group: nLG.group, item: item, clickEvent: clickEvent });
                    };

                    nLG.renameItem = function (value) {
                        console.log(value);
                    };
                    //@todo - On changes count group's selected items and toggle group selection

                    function openGroups() {
                        if (_.find(nLG.group.children, 'selected')) {
                            nLG.group.expanded = true;
                        }
                    }

                    // function selectGroups(){
                    //     if(_.find(nLG.group.children, 'selected')){
                    //         nLG.group.selected = true;
                    //     }
                    // }

                    function countIndicating() {
                        nLG.indicateCount = _.filter(nLG.group.children, 'indicate').length;
                    }

                    nLG.onExpandOp = function () {
                        nLG.group.expanded = !nLG.group.expanded;
                        if (!nLG.multiSelectMode) {
                            nLG.onExpanded({ status: nLG.group.expanded, groupIndex: nLG.group.index });
                        }
                    };
                }
            };

            _export('default', leftNavListGroupComponent);
        }
    };
});

$__System.register('10b', [], function (_export) {
    'use strict';

    var leftNavGroupChildComponent;
    return {
        setters: [],
        execute: function () {
            leftNavGroupChildComponent = {
                template: function template($element, $attrs) {
                    //use el and attrs
                    return '\n            <li \n                lc-draggable-item\n                lc-draggable-allow-drag-drop="::nLGI.allowDragDrop"\n                lc-draggable-drag-item-type="{{::nLGI.item.type}}"\n                lc-draggable-drag-id="{{::nLGI.item.id}}"\n                lc-draggable-parent-id="{{::nLGI.item.parent}}"\n                lc-draggable-item-type="{{::nLGI.item.type}}"\n                class="left-nav-list-group-item" \n                ng-class="{\'selected\': nLGI.item.selected, \'highlighted\': nLGI.itemIndicating, \'marked\': nLGI.item.active && nLGI.item.type === \'user\'}" \n                \n            >\n                <div class="left-nav-list-group-item-child-action" ng-if="::nLGI.hasAction(nLGI.item.type);">\n                    <button class="btn-action {{::nLGI.item.type}}" ng-class="{active: nLGI.item.active, pending: nLGI.pending, activated: nLGI.activated};" ng-click="nLGI.action(nLGI.item.type,nLGI.item.id);"></button>\n                </div>\n\n                <div ng-if="::!nLGI.item.node_details" ng-click="nLGI.onSelect({item: nLGI.item, clickEvent: $event})" class="left-nav-list-group-item-contents">\n                    <h1 class="name">{{::nLGI.item.title}}</h1>\n                </div>\n\n                <div ng-if="::nLGI.item.node_details" ng-click="nLGI.onSelect({item: nLGI.item, clickEvent: $event})" class="left-nav-list-group-item-contents has-child">\n                    <div class="device-icon lc-{{::nLGI.item.node_details.class}}"></div>\n\n                    <h1 ng-if="::!nLGI.item.nested_children.length" class="name single">{{::nLGI.item.description}}</h1>\n                                      \n                    <div ng-if="::nLGI.item.nested_children.length" class="left-nav-list-group-item-contents-zoned">\n                        <h1 class="name" ng-repeat="child in nLGI.item.nested_children">{{::child.id_string}}</h1>\n                        <h2 class="last-four"> - {{::nLGI.getLastFour(nLGI.item.title)}}</h2>\n                        <!-- Alt style <h2 class="name nested" >{{::nLGI.item.title}}</h2> -->\n                    </div>\n\n                    <left-nav-list-device-update update-status="nLGI.item.status"></left-nav-list-device-update>\n                </div>\n            </li>\n        ';
                    /* @todo may want multiple zones in left view e.g Touch, dimmer */
                },
                bindings: {
                    allowDragDrop: '@',
                    childIndex: '<',
                    indicate: '<',
                    item: '<',
                    onSelect: '&?'
                },
                controllerAs: 'nLGI',
                controller: function controller($timeout, $scope, Scenes, Shows, RecurrenceSchedules, Modals) {
                    var nLGI = this;

                    var itemTimeout = null;

                    nLGI.$onChanges = function (changes) {
                        //
                        // Gotta be a better way :(
                        //
                        if (changes && changes.indicate && changes.indicate.currentValue) {
                            //
                            // If already indicating, cancel outstanding timeout and reset flag
                            //
                            if (nLGI.itemIndicating) {
                                $timeout.cancel(itemTimeout);
                                nLGI.itemIndicating = false;

                                $timeout(function () {
                                    nLGI.itemIndicating = true;
                                });
                            } else {
                                nLGI.itemIndicating = true;
                            }

                            //
                            // Set 30 second wait to reset indicate flag
                            //
                            itemTimeout = $timeout(function () {
                                nLGI.itemIndicating = false;
                                $scope.$apply();
                            }, 30000);
                        }

                        //catch device status change
                        if (changes.item) {
                            //update device status
                            nLGI.item = changes.item.currentValue;
                        }
                    };

                    nLGI.$onDestroy = function () {
                        $timeout.cancel(itemTimeout);
                    };

                    var buttonActions = {
                        scene: function scene(id) {
                            return Scenes.activate(id).then(function () {
                                nLGI.activated = true;

                                $timeout(function () {
                                    nLGI.activated = false;
                                }, 5000);
                            });
                        },
                        schedule: function schedule(id) {
                            return RecurrenceSchedules.toggleEnabled(id).then(function () {
                                nLGI.item.active = !nLGI.item.active;
                            });
                        },
                        shows: function shows(id) {
                            return Shows.getShowGroup(id).then(function (showGroup) {
                                //
                                //
                                // Can't activate with ID alone per this model, have to get program and duration too
                                //
                                //
                                return Shows.controlShowGroup(id, showGroup.program, true, showGroup.duration).then(function () {
                                    nLGI.activated = true;

                                    $timeout(function () {
                                        nLGI.activated = false;
                                    }, 5000);
                                });
                            });
                        }
                    };

                    nLGI.hasAction = function (type) {
                        return angular.isDefined(buttonActions[type]);
                    };

                    nLGI.action = function (action, id) {
                        nLGI.pending = true;

                        Modals.openLoad('Working');

                        return buttonActions[action](id).then(function () {
                            Modals.closeLoad('Complete', true);

                            nLGI.pending = false;
                        })['catch'](function (error) {
                            Modals.closeLoad(error.data.detail ? error.data.detail : 'Failure');
                        });
                    };

                    nLGI.getLastFour = function (title) {
                        var n = title.split(" ");
                        return n[n.length - 1];
                    };
                }
            };

            _export('default', leftNavGroupChildComponent);
        }
    };
});

$__System.register('10c', [], function (_export) {
    'use strict';

    var leftNavListSearchComponent;
    return {
        setters: [],
        execute: function () {
            leftNavListSearchComponent = {
                template: '\n        <div class="search-input-wrapper">\n            <i class="fa fa-search"></i>\n            <input class="search" type="search" ng-model="nLS.query" ng-change="nLS.searchTerm(nLS.query);" placeholder="Search {{nLS.placeholder}}">\n        </div>\n    ',
                bindings: {
                    itemCount: '<',
                    itemType: '<',
                    onSearchTerm: '&?'
                },
                controllerAs: 'nLS',
                controller: function controller() {
                    var nLS = this;

                    nLS.$onInit = function () {
                        nLS.query = '';
                    };

                    nLS.$onChanges = function (changes) {
                        //
                        // Can replace 'items' with a type in future?
                        //
                        if (changes.itemCount && angular.isDefined(changes.itemCount.currentValue)) {
                            nLS.placeholder = nLS.itemCount + ' ' + (nLS.itemType ? nLS.itemType : 'items') + '...';
                        }
                    };

                    nLS.searchTerm = function (query) {
                        //Debounce etc here
                        nLS.onSearchTerm({ query: query });
                    };
                }
            };

            _export('default', leftNavListSearchComponent);
        }
    };
});

$__System.register('10d', ['14'], function (_export) {
    var _defineProperty, leftNavListFilterComponent;

    return {
        setters: [function (_2) {
            _defineProperty = _2['default'];
        }],
        execute: function () {
            'use strict';

            leftNavListFilterComponent = {
                template: function template($element, $attrs) {
                    //use el and attrs
                    return '\n            <header class="left-nav-list-filter-header">\n                <span class="left-nav-list-filter-viewing-summary" ng-if="nLF.activeFilters.length < 1">{{:: \'common.viewing\' | translate }} {{nLF.filterGroup}}</span>\n\n                <a class="left-nav-list-filter-header-toggle right" ng-click="nLF.toggleShowAvailableFilterGroups()">{{ nLF.showAvailableFilterGroups ? \'Done\' : \'...Add a filter\' }}</a>\n                \n                <a class="left-nav-list-filter-header-toggle right" ng-if="!nLF.multiSelect" ng-click="nLF.onEnableMultiSelect({mode: true})">Multi Select</a>  \n                \n                <a class="left-nav-list-filter-header-toggle right" ng-if="nLF.selectionCount > 0" ng-click="nLF.onClearSelection({mode:false})">Deselect</a>\n\n                <left-nav-list-filter-option filter-options="nLF.availableFilters" on-active-filters-change="nLF.filterSelectionChange(filters)" ng-if="nLF.showAvailableFilterGroups" filtered-group-list="nLF.filteredGroupList" site-id="nLF.siteId"></left-nav-list-filter-option>\n            </header>\n        ';
                },
                bindings: {
                    //
                    // In
                    //
                    title: '<',
                    availableFilters: '<',
                    list: '<',
                    selectionCount: '<',
                    multiSelect: '<',
                    filteredGroupList: '<',
                    siteId: '<',
                    //
                    // Out
                    //
                    onFilterSelectionChange: '&',
                    onClearSelection: '&',
                    onEnableMultiSelect: '&'
                },
                //
                // Shake it all about
                //
                controllerAs: 'nLF',
                controller: function controller() {

                    var nLF = this;

                    nLF.$onInit = function () {
                        //
                    };

                    nLF.$onChanges = function (changes) {};

                    nLF.filterSelectionChange = function (filters) {
                        var activeFilters = _.map(filters, function (item) {
                            return _defineProperty({}, item.title, item.selectedValue);
                        });

                        nLF.onFilterSelectionChange({ filters: activeFilters });

                        nLF.activeFilters = activeFilters;
                    };

                    //Nothing selected to begin with - but we could add filters to $location
                    nLF.activeFilters = [];

                    nLF.filterGroup = 'All';

                    nLF.toggleShowAvailableFilterGroups = function () {
                        nLF.showAvailableFilterGroups = !nLF.showAvailableFilterGroups;

                        if (!nLF.showAvailableFilterGroups) {
                            nLF.filterSelectionChange(null);
                        }
                    };

                    nLF.prettyName = function (name) {
                        return name.replace(/_/g, ' ');
                    };
                }
            };

            _export('default', leftNavListFilterComponent);
        }
    };
});

$__System.registerDynamic('10e', ['10f'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $ = $__require('10f');
  module.exports = function (it) {
    var keys = $.getKeys(it),
        getSymbols = $.getSymbols;
    if (getSymbols) {
      var symbols = getSymbols(it),
          isEnum = $.isEnum,
          i = 0,
          key;
      while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) keys.push(key);
    }
    return keys;
  };
});
$__System.registerDynamic('110', ['111', '112', '10e', '113', '114'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toObject = $__require('111'),
      IObject = $__require('112'),
      enumKeys = $__require('10e'),
      has = $__require('113');
  module.exports = $__require('114')(function () {
    var a = Object.assign,
        A = {},
        B = {},
        S = Symbol(),
        K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
  }) ? function assign(target, source) {
    var T = toObject(target),
        l = arguments.length,
        i = 1;
    while (l > i) {
      var S = IObject(arguments[i++]),
          keys = enumKeys(S),
          length = keys.length,
          j = 0,
          key;
      while (length > j) if (has(S, key = keys[j++])) T[key] = S[key];
    }
    return T;
  } : Object.assign;
});
$__System.registerDynamic('115', ['116', '110'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $def = $__require('116');
  $def($def.S + $def.F, 'Object', { assign: $__require('110') });
});
$__System.registerDynamic('117', ['115', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('115');
  module.exports = $__require('118').Object.assign;
});
$__System.registerDynamic("21", ["117"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("117"), __esModule: true };
});
$__System.registerDynamic("119", ["21"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var _Object$assign = $__require("21")["default"];
  exports["default"] = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  exports.__esModule = true;
});
$__System.register('11a', ['14', '20', '119'], function (_export) {
    var _defineProperty, _toConsumableArray, _extends, leftNavListFilterComponent;

    return {
        setters: [function (_3) {
            _defineProperty = _3['default'];
        }, function (_4) {
            _toConsumableArray = _4['default'];
        }, function (_2) {
            _extends = _2['default'];
        }],
        execute: function () {
            'use strict';

            leftNavListFilterComponent = {
                template: '\n        <ul>\n            <li class="left-nav-list-filter-group-list" ng-repeat="activeFilter in nLFO.activeFilters track by $index">\n                <button ng-click="nLFO.removeActiveFilter(activeFilter.title,$index)" class="left-nav-list-filter-group-remove-button">X</button>\n                <span class="capitalise bold" translate="#.{{activeFilter.title}}"></span>:\n                <span translate="{{ (activeFilter.title === \'reported_dim_level\' || activeFilter.title === \'full_power_reading\' || activeFilter.title === \'trim_high\') ? activeFilter.selectedValue : \'#.\' + activeFilter.selectedValue }}"></span>\n                </li>\n            <li class="left-nav-list-filter-group-add">\n                <select \n                    ng-model="nLFO.mainCatalog" \n                    class="no-user-styles"\n                    ng-change="nLFO.chooseMainCatalog()"\n                >\n                    <option value="" selected disabled>Select Catalog</option>\n                    <option \n                            ng-repeat="optionObj in nLFO.currentFilterOptions"\n                            translate="#.{{optionObj.title}}"\n                            value={{optionObj}}\n                    ></option>\n                </select>\n                <span> </span>  \n                <select \n                    ng-if="nLFO.results" \n                    ng-model="nLFO.subCatalog"\n                    class="no-user-styles"\n                    ng-change="nLFO.chooseSubCatalog()"\n                >\n                    <option value="" selected disabled>Select Value</option>\n                    <option \n                            ng-repeat="optionObj in nLFO.results"\n                            translate="{{ (nLFO.categoryVal === \'reported_dim_level\' || nLFO.categoryVal === \'full_power_reading\' || nLFO.categoryVal === \'trim_high\') ? optionObj.value : \'#.\' + optionObj.value }}"\n                            value={{optionObj}}\n                    >\n                    </option>\n                </select>\n                <a class="left-nav-list-filter-header-toggle right" ng-click="nLFO.exportFilteredDevices(nLFO.siteId,nLFO.activeFilters, nLFO.filteredGroupList)"  ng-if="nLFO.isDevicesView" >Export...</a>\n            </li>\n        </ul>\n    ',
                bindings: {
                    filterOptions: '<',
                    filteredGroupList: '<',
                    siteId: '<',
                    isDevicesView: '<',
                    onActiveFiltersChange: '&'
                },
                controllerAs: 'nLFO',
                controller: function controller(FilteredDevicesExport, $location, Modals, Messages, _) {
                    var nLFO = this;

                    nLFO.activeFilters = [];
                    nLFO.categoryVal = '';
                    nLFO.$onInit = function () {
                        nLFO.allfilterOptions = _.map(nLFO.filterOptions, function (values, key) {
                            return {
                                title: key,
                                values: [].concat(_toConsumableArray(values))
                            };
                        });

                        nLFO.currentFilterOptions = angular.copy(nLFO.allfilterOptions);
                    };

                    nLFO.chooseMainCatalog = function () {
                        nLFO.newFilter = JSON.parse(nLFO.mainCatalog);
                        nLFO.results = [];
                        nLFO.categoryVal = nLFO.newFilter.title;
                        _.forEach(nLFO.newFilter.values, function (value) {
                            nLFO.results.push({ value: value });
                        });
                    };

                    nLFO.chooseSubCatalog = function () {
                        var temp = JSON.parse(nLFO.subCatalog);
                        if (!nLFO.newFilter) {
                            nLFO.newFilter = JSON.parse(nLFO.mainCatalog);
                        }
                        nLFO.newFilter.selectedValue = temp.value;
                        addActiveFilter(nLFO.newFilter);
                    };

                    function addActiveFilter(filter) {
                        // Don't allow multiple filter of same type
                        nLFO.currentFilterOptions = _.filter(nLFO.currentFilterOptions, function (mappedFilter) {
                            return filter.title !== mappedFilter.title;
                        });
                        nLFO.subCatalog = [];

                        nLFO.activeFilters.push(filter);
                        nLFO.newFilter = null;
                        nLFO.onActiveFiltersChange({ filters: nLFO.activeFilters });
                    }

                    nLFO.removeActiveFilter = function (activeFilterTitle, index) {
                        // Doesn't add filter group back to list if already present (prevents dupllicates when deleting)
                        if (!nLFO.currentFilterOptions.find(function (option) {
                            return option.title === activeFilterTitle;
                        })) {
                            nLFO.currentFilterOptions.push(angular.copy(_.find(nLFO.allfilterOptions, ['title', activeFilterTitle])));
                        }

                        nLFO.activeFilters.splice(index, 1);
                        nLFO.onActiveFiltersChange({ filters: nLFO.activeFilters });
                    };

                    nLFO.exportFilteredDevices = function (siteId, activeFilters) {
                        var activeFiltersObj = activeFilters.reduce(function (filter, cur) {
                            return _extends({}, filter, _defineProperty({}, cur.title, cur.selectedValue));
                        }, {});
                        var groupTitles = [];
                        var childrenList = [];
                        var alertMsg = "";
                        for (var i = 0; i < nLFO.filteredGroupList.length; i++) {
                            groupTitles.push(nLFO.filteredGroupList[i].title);
                            childrenList.push(nLFO.filteredGroupList[i].children);
                        };

                        var filteredGroupsObj = groupTitles.reduce(function (obj, title, index) {
                            obj[title] = childrenList[index].map(function (item) {
                                return item.id;
                            });
                            return obj;
                        }, {});

                        var ajaxArg = [siteId, activeFiltersObj, filteredGroupsObj];

                        FilteredDevicesExport.filteredDevicesText.apply(FilteredDevicesExport, ajaxArg).then(function (response) {
                            alertMsg = "Generating filtered devices text file...";
                            Modals.openLoad(alertMsg, true);

                            var file = new Blob([response], { type: 'text/plain' });
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.download = 'filtered_devices.txt';
                            a.click();
                        })['catch'](function (error) {
                            if (error.status !== 200) {
                                alertMsg = 'Something went wrong please try again: ' + error.statusText;
                                Messages.errorToast(alertMsg, true);
                            } else {
                                Messages.errorToast('Something went wrong please try again later', true);
                            }
                        })['finally'](function () {
                            Modals.closeLoad(alertMsg, true);
                        });
                    };

                    nLFO.isDevicesView = $location.path().toString().includes('devices');
                }

            };

            _export('default', leftNavListFilterComponent);
        }
    };
});

$__System.register('11b', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, leftNavListDraggableItemDirective;

  return {
    setters: [function (_) {
      _createClass = _['default'];
    }, function (_2) {
      _classCallCheck = _2['default'];
    }],
    execute: function () {
      'use strict';

      leftNavListDraggableItemDirective = (function () {
        function leftNavListDraggableItemDirective() {
          _classCallCheck(this, leftNavListDraggableItemDirective);

          this.restrict = 'A';
          this.scope = {
            lcDraggableAllowDragDrop: '<',
            lcDraggableDragItemType: '@',
            lcDraggableDragId: '@',
            lcDraggableParentId: '@'
          };
        }

        _createClass(leftNavListDraggableItemDirective, [{
          key: 'controller',
          value: function controller($window, $rootScope, $scope) {
            //Hoist injected services to $scope for use in linking function
            $scope.dependencies = {
              $window: $window,
              $rootScope: $rootScope
            };
          }
        }, {
          key: 'link',
          value: function link(scope, elm, attrs) {

            if (scope.lcDraggableAllowDragDrop) {
              (function () {
                angular.element(elm).attr('draggable', 'true');

                var dragIds = [scope.lcDraggableDragItemType, scope.lcDraggableDragId, scope.lcDraggableParentId].toString();

                //
                //  Can't bind to dragstart without long-running op triggering wacky
                //  side effects, see SO#28408720
                //
                var dragBind = function dragBind() {
                  elm.bind('drag', function ($event) {
                    scope.$emit('LC-DRAG', dragIds);
                    elm.unbind('drag');
                  });
                };

                dragBind();

                elm.bind('dragstart', function ($event) {
                  $event.originalEvent.dataTransfer.setData('text/plain', dragIds);

                  console.log('drag start in draggable');

                  scope.$emit('LC-DRAG-START', dragIds);
                  //scope.onDragStart({$event: $event});
                });

                elm.bind('dragend', function ($event) {
                  scope.$emit('LC-DRAG-END', dragIds);

                  console.log('drag end in draggable');

                  //
                  // Re-bind drag event
                  //
                  dragBind();
                });
              })();
            }
          }
        }]);

        return leftNavListDraggableItemDirective;
      })();

      _export('default', leftNavListDraggableItemDirective);
    }
  };
});

$__System.register('11c', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, leftNavListDroppableItemDirective;

  return {
    setters: [function (_) {
      _createClass = _['default'];
    }, function (_2) {
      _classCallCheck = _2['default'];
    }],
    execute: function () {
      'use strict';

      leftNavListDroppableItemDirective = (function () {
        function leftNavListDroppableItemDirective() {
          _classCallCheck(this, leftNavListDroppableItemDirective);

          this.restrict = 'A';
          this.scope = {
            lcDroppableSpecial: '@?',
            lcDroppableTargetId: '@'
          };
        }

        _createClass(leftNavListDroppableItemDirective, [{
          key: 'controller',
          value: function controller($window, $rootScope, $scope, $timeout) {
            //Hoist injected services to $scope for use in linking function
            $scope.dependencies = {
              $window: $window,
              $rootScope: $rootScope,
              $timeout: $timeout
            };
          }
        }, {
          key: 'link',
          value: function link(scope, elm, attrs) {

            var dragId = scope.dragId;

            angular.element(elm).attr('id', dragId);

            elm.bind('dragover', function (e) {

              if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
              }

              if (e.stopPropagation) {
                e.stopPropagation();
              }

              e.originalEvent.dataTransfer.dropEffect = 'move';
              return false;
            });

            elm.bind('dragenter', function (e) {
              if (scope.lcDroppableSpecial === 'down') {
                angular.element('.de-group')[0].scrollIntoView({ behavior: "smooth" });
              }

              angular.element(e.currentTarget).addClass('on-drag-hover');
            });

            elm.bind('dragleave', function (e) {
              angular.element(e.currentTarget).removeClass('on-drag-hover'); // this / e.target is previous target element.
            });

            elm.bind('drop', function (e) {
              if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
              }

              if (e.stopPropogation) {
                e.stopPropogation(); // Necessary. Allows us to drop.
              }

              angular.element(e.currentTarget).removeClass('on-drag-hover');

              var data = e.originalEvent.dataTransfer.getData('text') + ',' + scope.lcDroppableTargetId;

              //
              // data here is the item type, destination id and item ids.
              //
              scope.$emit('LC-DRAG-DROP', data, scope.lcDroppableSpecial);
            });

            //
            // Handle top and bottom special drop target areas
            // Only attach rootScope listeners in this case
            //
            if (scope.lcDroppableSpecial) {

              //
              // Have to use drag event as opposed to dragstart (see directive for why)
              //
              scope.dependencies.$rootScope.$on('LC-DRAG', function (event) {
                //event.preventDefault()
                //event.stopPropagation();
                console.log('dragwatcher inner called');

                if (elm.hasClass('special-drop-target-hidden')) {
                  elm.removeClass('special-drop-target-hidden');

                  console.log('dragwatcher inner called');

                  //dragStartWatcher();
                }
              });

              scope.dependencies.$rootScope.$on('LC-DRAG-END', function () {
                console.log('end drag - start watcher again');
                elm.addClass('special-drop-target-hidden');
                //dragStartWatcher();
              });
            }
          }
        }]);

        return leftNavListDroppableItemDirective;
      })();

      _export('default', leftNavListDroppableItemDirective);
    }
  };
});

$__System.register('11d', ['11', '12', '13'], function (_export) {
  var _, _createClass, _classCallCheck, leftNavListContextMenuDirective;

  return {
    setters: [function (_4) {
      _ = _4['default'];
    }, function (_2) {
      _createClass = _2['default'];
    }, function (_3) {
      _classCallCheck = _3['default'];
    }],
    execute: function () {
      'use strict';

      leftNavListContextMenuDirective = (function () {
        function leftNavListContextMenuDirective() {
          _classCallCheck(this, leftNavListContextMenuDirective);

          this.restrict = 'A';
          this.scope = {
            onContextClick: '&',
            scenes: '<',
            sites: '<'
          };
        }

        _createClass(leftNavListContextMenuDirective, [{
          key: 'controller',
          value: function controller($window, $rootScope, $scope, $compile, $translate) {
            //Hoist injected services to $scope for use in linking function
            $scope.dependencies = {
              $window: $window,
              $rootScope: $rootScope,
              $compile: $compile,
              $translate: $translate
            };
          }
        }, {
          key: 'link',
          value: function link(scope, elm, attrs) {
            //
          }
        }, {
          key: 'compile',
          value: function compile(elm, attrs) {

            return {
              post: function post(scope, element, attrs, ctrls) {

                //
                // Submenus in future
                //
                var groupOptions = [{
                  name: 'quickAdd',
                  submenu: null,
                  condition: function condition(type, targetParentId, targetId, scope) {
                    return !(scope.sites && scope.sites.is_blue);
                  }
                }, {
                  name: 'toggle',
                  submenu: null
                }, {
                  name: 'rename',
                  submenu: null,
                  condition: function condition(type, targetParentId, targetId, scope) {
                    return !(scope.sites && scope.sites.is_blue);
                  }
                }, {
                  name: 'auto',
                  submenu: null,
                  condition: function condition(type, targetParentId) {
                    // - Disabled for now
                    return false;
                  }
                }, {
                  name: 'delete',
                  submenu: null,
                  filter: ['group', 'zone', 'device'],
                  condition: function condition(type, targetParentId, targetId, scope) {
                    return !(scope.sites && scope.sites.is_blue);
                  }
                }];

                var itemOptions = [{
                  name: 'edit',
                  submenu: null,
                  condition: function condition(type, targetParentType, targetId) {
                    if (type === 'scene') {
                      var scene = scope.scenes.find(function (scene) {
                        return scene.id == targetId;
                      });

                      // unique scene properties that define a 'defaultScene'
                      var isDefault = scene && scene.actions && scene.actions[0] && scene.actions[0].systemType === 'area';
                      return scene && !isDefault;
                    }
                    return true;
                  }
                }, {
                  name: 'assign',
                  submenu: null,
                  filter: ['zone', 'device']
                }, {
                  name: 'unassign',
                  submenu: null,
                  filter: ['zone', 'device'],
                  condition: function condition(type, targetParentId) {
                    return targetParentId !== 'X';
                  }
                }, {
                  name: 'createGroup',
                  submenu: null,
                  filter: ['zone']
                }, {
                  name: 'update',
                  submenu: null,
                  filter: ['device']
                }
                /*
                    Add a quick delete option in future:   {name: 'delete', submenu: null}
                */
                ];

                // Disabled for dev
                elm.on('contextmenu', function ($event) {
                  var ctrlKey = $event.ctrlKey || $event.metaKey;
                  //
                  // Let ctrl key disable right click, easier for dev
                  //
                  if (!ctrlKey) {
                    $event.originalEvent.preventDefault();

                    resetMenus();

                    //
                    // - Close if right click within menu
                    //
                    if (!$event.target.closest('.left-nav-list-context-menu')) {
                      chooseMenu($event);
                    }
                  }
                });

                scope.menuAction = function (action, type, id, parentId) {
                  // - Allow passing 'X' for unassigned
                  id = isNaN(id) ? id : parseInt(id);

                  scope.onContextClick({ action: action, itemType: type, id: id, parentId: parentId });
                };

                function getMenuList(targetId, targetItemType, targetParentId) {
                  if (scope.sites && scope.sites.is_blue && targetItemType !== 'group') {
                    return [];
                  }
                  var optionSet = targetItemType === 'group' ? groupOptions : itemOptions;

                  //Unassign & New Groups only offer toggle option
                  return isNaN(parseInt(targetId)) ? ['toggle'] : _.map(_.filter(optionSet, function (option) {
                    return (option.filter ? option.filter.indexOf(targetItemType) > -1 : true) && (option.condition ? option.condition(targetItemType, targetParentId, targetId, scope) : true);
                  }), function (option) {
                    return option.name;
                  });
                }

                function resetMenus() {
                  elm.find('.left-nav-list-context-menu').remove();
                  elm.off('mousewheel');
                  angular.element(scope.dependencies.$window).off('click');
                }

                function chooseMenu($event) {
                  var target = $event.target.closest('.left-nav-list-group-item') || $event.target.closest('.left-nav-group-item-list');
                  var targetItemType = angular.element(target).attr('lc-draggable-item-type') || 'group';

                  var targetId = targetItemType === 'group' ? angular.element(target).attr('lc-droppable-target-id') : angular.element(target).attr('lc-draggable-drag-id');

                  var targetParentId = angular.element(target).attr('lc-draggable-parent-id') || null;

                  var contextOptions = getMenuList(targetId, targetItemType, targetParentId);

                  // Only show menu if there are options to choose from
                  if (!contextOptions || !contextOptions.length) {
                    return;
                  }

                  var translatedOptionsPromise = scope.dependencies.$translate(_.map(contextOptions, function (option) {
                    return 'menu.' + option;
                  }));

                  translatedOptionsPromise.then(function (translatedOptions) {
                    var menuContent = _.map(translatedOptions, function (translated, k) {
                      return '<li class="' + k.split('.')[1] + '" ng-click="menuAction(\'' + k.split('.')[1] + '\',\'' + targetItemType + '\',\'' + targetId + '\',' + targetParentId + ')">' + translated + '</li>';
                    }).join('');

                    openMenu($event, wrapMenu($event, menuContent));
                  });
                }

                function wrapMenu($event, content) {
                  var menuWidth = 140;

                  var leftPostion = $event.currentTarget.offsetWidth - $event.clientX > menuWidth ? $event.clientX : $event.currentTarget.offsetWidth - menuWidth;
                  var verticalPosition = $event.currentTarget.offsetHeight - $event.clientY > menuWidth ? 'top: ' + $event.clientY + 'px;' : 'bottom: ' + ($event.currentTarget.offsetHeight - $event.clientY) + 'px;';

                  return '<ul class=\'left-nav-list-context-menu\' style=\'left:' + leftPostion + 'px; ' + verticalPosition + '\'>' + content + '</ul>';
                }

                function openMenu($event, template) {
                  elm.append(scope.dependencies.$compile(template)(scope));
                  //
                  // Block Wheel while menu open a-la normal context menus
                  // - Use native element for passive listener flag - {passive: true} ?
                  //
                  elm.on('mousewheel', function ($event) {
                    $event.originalEvent.preventDefault();
                  });

                  angular.element(scope.dependencies.$window).on('click', function () {
                    resetMenus();
                  });
                }
              }
            };
          }
        }]);

        return leftNavListContextMenuDirective;
      })();

      _export('default', leftNavListContextMenuDirective);
    }
  };
});

$__System.register('11e', [], function (_export) {
    'use strict';

    return {
        setters: [],
        execute: function () {
            _export('default', function (_) {

                return function (items, filterKeyValuePairs) {

                    function filterPairs(item) {
                        return _.filter(item.children, function (child) {
                            return _.some(filterKeyValuePairs, function (setting) {
                                return _.find(child.filterables, setting) ? true : false;
                            });
                        });
                    }

                    function mainFilter(items) {
                        var filtered = [];

                        //console.time('navFilterLoop');
                        _.each(items, function (item) {
                            var groupClone = angular.copy(item);

                            groupClone.children = filterPairs(item);

                            if (groupClone.children.length) {
                                filtered.push(groupClone);
                            }
                        });
                        //console.timeEnd('navFilterLoop');

                        return filtered;
                    }

                    //
                    // Preserve empty areas on filter
                    //
                    return filterKeyValuePairs.length ? mainFilter(items) : items;
                };
            });
        }
    };
});

$__System.registerDynamic("14", ["11f"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var _Object$defineProperty = $__require("11f")["default"];
  exports["default"] = function (obj, key, value) {
    if (key in obj) {
      _Object$defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  };
  exports.__esModule = true;
});
$__System.register('120', ['11', '12', '13', '14', '61'], function (_export) {
    var _, _createClass, _classCallCheck, _defineProperty, _Set, ContextualMenusHelper;

    return {
        setters: [function (_6) {
            _ = _6['default'];
        }, function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }, function (_4) {
            _defineProperty = _4['default'];
        }, function (_5) {
            _Set = _5['default'];
        }],
        execute: function () {
            'use strict';

            ContextualMenusHelper = (function () {
                function ContextualMenusHelper(LcFn) {
                    _classCallCheck(this, ContextualMenusHelper);

                    //
                    // Not really using this pattern here
                    //
                    this.LcFn = LcFn;
                }

                _createClass(ContextualMenusHelper, [{
                    key: 'getMenu',
                    value: function getMenu(context, data, cache, currentUser) {
                        //
                        // Lazy
                        //
                        var LcFn = this.LcFn;

                        //
                        //  These lists should probably come from backend
                        //
                        var allowedFilterOptions = function allowedFilterOptions(siteData, type) {
                            var filterOptions = {
                                automations: { filterOptions: ['enabled'] },
                                devices: {
                                    filterOptions: ['automations_enabled', 'automations_supported', 'className', 'daylighting_enabled', 'daylighting_supported', 'description', 'gateway', 'id_string', 'last_firmware_version', 'mac_addr', 'node_health'],
                                    transforms: {
                                        gateway: function gateway(val) {

                                            var match = _.find(siteData.gateways, { id: val });

                                            return match ? match.id_string || val : val;
                                        }
                                    }
                                },
                                // devices: [
                                //     'automations_enabled',
                                //     'automations_supported',
                                //     'daylighting_enabled',
                                //     'daylighting_supported',
                                //     {'device_type' : [
                                //         'hardware_version',
                                //         'lcp_type',
                                //         'make',
                                //         'model',
                                //         'submodel',
                                //         'uuid',
                                //         'zonable'
                                //     ]},
                                //     'last_firmware_version',
                                //     'node_health',
                                //     {'settings':[
                                //         'actuator_state',
                                //         'als_local_enable',
                                //         'als_report_enable',
                                //         'als_sensitivity',
                                //         'blink_duration',
                                //         'blink_number',
                                //         'blink_time_pre_unoccupied',
                                //         'default_actuator_state',
                                //         'description',
                                //         'device_mode',
                                //         'dim_level',
                                //         'dimmer_off_slope_time',
                                //         'dimming_curve_type',
                                //         'heartbeat_enable',
                                //         'id_string',
                                //         'max_dimmer_level',
                                //         'mic_enable',
                                //         'mic_pir_timeout',
                                //         'mic_sensitivity',
                                //         'min_dimmer_level',
                                //         'occupancy_led_enable',
                                //         'off_to_unoccupied_timeout',
                                //         'pir_sensitivity',
                                //         'power_report',
                                //         'power_report_frequency',
                                //         'ramp_down_time',
                                //         'soft_dim_enable',
                                //         'temp_sensor_report_enable',
                                //         'time_to_off',
                                //         'turn_off_time_delay',
                                //         'vacancies_mode_return_time'
                                //     ]}
                                // ],
                                scenes: { filterOptions: ['demand_response'] },
                                schedule: { filterOptions: ['enabled'] },
                                shows: { filterOptions: ['gateway', 'site', 'program'] },
                                users: { filterOptions: ['is_active', 'is_staff', 'is_superuser'] },
                                zone: {
                                    filterOptions: ['controller_health_flagged', 'emergency_mode', 'fault_recipients_alerted', 'fixture_health_detection', 'full_power_reading',
                                    // 'indicating',
                                    'is_dimmable', 'power_draws_by_decile_as_dictionary', 'power_reporting', 'reported_dim_level', 'trim_high',
                                    // 'trim_low',
                                    'zone_health',
                                    // 'zone_msg',
                                    'zone_state'],
                                    transforms: {
                                        power_draws_by_decile_as_dictionary: function power_draws_by_decile_as_dictionary(val) {
                                            return _.isEmpty(val) ? false : true;
                                        }
                                    }
                                }
                            };

                            return filterOptions[type];
                        };

                        function buildItemFilter(item, filters, allowedOptions) {
                            var filterables = [];

                            _.map(item, function (value, key) {
                                if (allowedOptions.filterOptions && allowedOptions.filterOptions.indexOf(key) > -1) {
                                    if (!filters[key]) {
                                        filters[key] = new _Set();
                                    }

                                    // - Now allow custom transforms (for translations and others)
                                    if (allowedOptions.transforms && allowedOptions.transforms[key]) {
                                        filters[key].add(allowedOptions.transforms[key](value));
                                        filterables.push(_defineProperty({}, key, allowedOptions.transforms[key](value)));
                                    } else {
                                        filters[key].add(value);
                                        filterables.push(_defineProperty({}, key, value));
                                    }
                                }
                            });

                            return filterables;
                        }

                        function buildNodeShell(device) {
                            return {
                                id: device.id,
                                'class': device.className
                            };
                        }

                        function buildNodeNestedChildrenShell(deviceZones) {
                            return _.map(deviceZones, function (zone) {
                                return {
                                    id_string: zone.id_string,
                                    description: zone.description
                                };
                            });
                        }

                        function setActiveFlag(child) {
                            var active = child.active;

                            //Schedules
                            if (child.events) {
                                active = child.enabled;
                            }

                            //Zones
                            if (child.zone_msg) {
                                active = child.zone_state;
                            }

                            return active;
                        }

                        function defaultGroupGenerator(area, parentKey, childGroup, childType, filterOptions, cache, filters, childGeneratorFn, mapGroup) {
                            // If we do this func recursively will have to generate these levels ourselves
                            var level = 'level1';

                            // remove zones that have load mode disabled
                            if (childType == 'zone') {
                                for (var i = 0; i < childGroup.length; i++) {
                                    if (!childGroup[i].visible_in_control) {
                                        childGroup.splice(i, 1);
                                    }
                                }
                            }

                            return {
                                index: parentKey,
                                id: area.id,
                                parent: null, //Root object
                                level: level,
                                //
                                // uuid        : area.uuid,
                                //
                                title: LcFn.getName(area),
                                description: area.description || LcFn.getName(area),
                                selected: cache[level].has(area.id),
                                expanded: false,
                                children: _.map(childGroup, function (child, key) {
                                    return childGeneratorFn(area.id, child, childType, key, filterOptions, cache, filters, mapGroup);
                                })
                            };
                        }

                        function defaultChildGenerator(parentId, child, childType, key, filterOptions, cache, filters, mapGroup) {
                            var level = 'level2';

                            return {
                                index: key,
                                id: child.id,
                                type: childType,
                                parent: parentId,
                                level: level,
                                //
                                //  @dm - Zone ID's are primary keys across all sites at the moment
                                //        'no plans' to change this for forseable future...
                                //        We can swap to UUID when needed but will need to map UUIDs to IDs for URL fragment nav
                                //
                                //  uuid        : zone.uuid,
                                //
                                title: LcFn.getName(child),
                                description: child.description || LcFn.getName(child),
                                selected: cache[level].has(child.id),
                                active: setActiveFlag(child),
                                children: [],
                                count: 0,
                                //
                                // Push filterable options out here - not sure if this is the best way to do it
                                //
                                filterables: buildItemFilter(child, filters, filterOptions)
                            };
                        }

                        var renderers = {
                            overview: function overview(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                var defaultChildType = 'zone';

                                var areas = siteData.areas.map(function (area) {
                                    area.zones = siteData.zones.filter(function (zone) {
                                        return zone.area === area.id;
                                    }); //Area zones - used some places
                                    return area;
                                });

                                var list = _.map(areas, function (area, key) {
                                    return defaultGroupGenerator(area, key, area.zones, defaultChildType, allowedFilterOptions(siteData, 'zone'), cache, filters, defaultChildGenerator);
                                });

                                //
                                // @replace
                                //
                                // Temp place for unassigned zones - should handle these better
                                //
                                var unassigned = _.filter(siteData.zones, ['area', null]);

                                if (unassigned.length) {
                                    var unassignedArea = {
                                        id: 'X',
                                        name: 'Unassigned',
                                        description: 'Unassigned Zones'
                                    };

                                    list.push(defaultGroupGenerator(unassignedArea, 'X', unassigned, defaultChildType, allowedFilterOptions(siteData, 'zone'), cache, filters, defaultChildGenerator));
                                }

                                return [list, filters];
                            },
                            automations: function automations(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                //
                                // Admin users at the top for now
                                //

                                var partitioned = _.groupBy(siteData.automations, 'criteria[0].attribute');

                                var counter = -1;

                                var list = _.map(partitioned, function (group, key, set) {
                                    counter++;

                                    var automationTypeGroup = {
                                        id: counter + 1,
                                        name: key,
                                        description: key
                                    };

                                    return defaultGroupGenerator(automationTypeGroup, 'X', group, 'automation', allowedFilterOptions(siteData, 'automations'), cache, filters, defaultChildGenerator);
                                });

                                return [list, filters];
                            },
                            devices: function devices(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                var getMatchingDevice = function getMatchingDevice(deviceId, devices) {
                                    return _.find(devices, ['id', deviceId]);
                                };

                                var getMatchingZone = function getMatchingZone(deviceId, zones) {
                                    return _.find(zones, ['node', deviceId]);
                                };

                                var devicesChildDeviceGenerator = function devicesChildDeviceGenerator(parentId, child, childType, key, filterOptions, cache, filters, devices) {
                                    var level = 'level2';

                                    //
                                    // Can be passed a zone or device - bit confusing
                                    //
                                    var matchingDevice = child.constructor.name === 'Zone' ? getMatchingDevice(child.node, devices) : child;

                                    var deviceZones = _.filter(siteData.zones, { node: child.id });

                                    return {
                                        index: key,
                                        id: matchingDevice.id,
                                        type: childType,
                                        parent: parentId,
                                        level: level,
                                        //
                                        // Node Shell
                                        //
                                        node_details: buildNodeShell(matchingDevice),
                                        //
                                        // Use settings.description for matchingDevice items
                                        //
                                        title: matchingDevice.settings.id_string,
                                        description: matchingDevice.settings.description,
                                        selected: cache[level].has(matchingDevice.id),
                                        active: setActiveFlag(child),
                                        children: [],
                                        //
                                        // List Zones nested inside device object in this view
                                        //
                                        nested_children: child.constructor.name === 'Device' ? buildNodeNestedChildrenShell(deviceZones) : null,
                                        count: 0,
                                        //
                                        // Push filterable options out here - not sure if this is the best way to do it
                                        //
                                        filterables: buildItemFilter(matchingDevice, filters, filterOptions)
                                    };
                                };

                                var areas = siteData.areas.map(function (area) {
                                    area.devices = siteData.devices.filter(function (device) {
                                        /*
                                            By default, use the area tied to the device's associated zone, if one exists
                                            This will render device.area on the device useless apart from Dimmers / Touch etc
                                            Probably smarter on the BE
                                         */
                                        return LcFn.getDeviceArea(area.id, device.id, device.area, siteData.zones);
                                    });
                                    // - Area zones - almost redundant now because of the above list, only difference is it will exclude dimmers etc
                                    area.zones = siteData.zones.filter(function (zone) {
                                        return zone.area === area.id;
                                    });

                                    return area;
                                });

                                var list = _.map(areas, function (area, key) {
                                    return defaultGroupGenerator(area, key, area.devices, 'device', allowedFilterOptions(siteData, 'devices'), cache, filters, devicesChildDeviceGenerator, siteData.devices);
                                });

                                //
                                // @replace
                                //
                                // Temp place for unassigned zones - should handle these better
                                //
                                var unassigned = _.filter(siteData.devices, function (device) {
                                    // - Don't match for zoneMatch & device.area or we get duplicates
                                    return LcFn.getDeviceUnassigned(device.id, device.area, siteData.zones);
                                });

                                // let zonelessDevices = _.filter(siteData.devices, device => {
                                //     return device.deviceZones.length === 0;
                                // });

                                if (unassigned.length) {
                                    var unassignedArea = {
                                        id: 'X',
                                        name: 'Unassigned',
                                        description: 'Unassigned Zones',
                                        zones: unassigned //_.union(unassigned,zonelessDevices)
                                    };

                                    list.push(defaultGroupGenerator(unassignedArea, 'X', unassignedArea.zones, 'device', allowedFilterOptions(siteData, 'devices'), cache, filters, devicesChildDeviceGenerator, siteData.devices));
                                }

                                return [list, filters];
                            },
                            scenes: function scenes(siteData, cache, currentUser) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                //
                                // Demand response and site-wide scenes listed seperately
                                //
                                var splitBySmartShift = _.partition(siteData.scenes, function (scene) {
                                    return LcFn.isSmartShiftType(scene);
                                }),
                                    smartShiftScenes = splitBySmartShift[0],
                                    splitByDemand = _.partition(splitBySmartShift[1], 'demand_response'),
                                    demandScenes = splitByDemand[0],
                                    areaScenes = _.groupBy(splitByDemand[1], 'area'),
                                    siteWideScenes = areaScenes[null];

                                var list = _.map(siteData.areas, function (area, key) {
                                    return defaultGroupGenerator(area, key, areaScenes[area.id], 'scene', allowedFilterOptions(siteData, 'scenes'), cache, filters, defaultChildGenerator);
                                });

                                if (demandScenes.length) {
                                    var demandResponse = {
                                        id: 'X',
                                        name: 'Demand Response',
                                        description: 'Demand Response Scenes'
                                    };

                                    list.push(defaultGroupGenerator(demandResponse, 'X', demandScenes, 'scene', allowedFilterOptions(siteData, 'scenes'), cache, filters, defaultChildGenerator));
                                }

                                if (siteWideScenes && siteWideScenes.length) {
                                    var siteWideArea = {
                                        id: 'Y',
                                        name: 'Site Wide',
                                        description: 'Site Wide Scenes'
                                    };

                                    list.push(defaultGroupGenerator(siteWideArea, 'Y', siteWideScenes, 'scene', allowedFilterOptions(siteData, 'scenes'), cache, filters, defaultChildGenerator));
                                }

                                //
                                // Only show smart shift for super users
                                //
                                if (currentUser.is_superuser) {
                                    if (smartShiftScenes && smartShiftScenes.length) {
                                        var smartShiftArea = {
                                            id: 'Z',
                                            name: 'Smart Shift',
                                            description: 'Smart Shift Scenes'
                                        };

                                        list.push(defaultGroupGenerator(smartShiftArea, 'Y', smartShiftScenes, 'scene', allowedFilterOptions(siteData, 'scenes'), cache, filters, defaultChildGenerator));
                                    }
                                }

                                return [list, filters];
                            },
                            schedules: function schedules(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                //
                                // automationSchedules site-wide schedules listed seperately
                                //
                                var partitioned = _.partition(siteData.schedules, ['events[0].object_type', 'behavior2']); //OR - ? _.partition(siteData.schedules, 'behavior');

                                var automationSchedules = partitioned[0];
                                var siteWideSchedules = partitioned[1];

                                var list = [];

                                if (siteWideSchedules.length) {
                                    var siteWideScheduleArea = {
                                        id: 'X',
                                        name: 'Site Wide',
                                        description: 'Site Wide Schedules'
                                    };

                                    list.push(defaultGroupGenerator(siteWideScheduleArea, 'X', siteWideSchedules, 'schedule', allowedFilterOptions(siteData, 'schedule'), cache, filters, defaultChildGenerator));
                                }

                                if (automationSchedules.length) {
                                    var automationSchedulesGroup = {
                                        id: 'Y',
                                        name: 'Automation',
                                        description: 'Automation Schedules'
                                    };

                                    list.push(defaultGroupGenerator(automationSchedulesGroup, 'Y', automationSchedules, 'schedule', allowedFilterOptions(siteData, 'schedule'), cache, filters, defaultChildGenerator));
                                }

                                return [list, filters];
                            },
                            shows: function shows(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                var allShows = {
                                    id: 'X',
                                    name: 'All Show Groups',
                                    description: 'All Show Groups'
                                };

                                var list = [defaultGroupGenerator(allShows, 'X', siteData.shows, 'shows', allowedFilterOptions(siteData, 'shows'), cache, filters, defaultChildGenerator)];

                                return [list, filters];
                            },
                            users: function users(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                //
                                // Admin & Staff users at the top for now
                                //
                                var partitioned = _.partition(siteData.users, function (user) {
                                    return user.org_admin || user.is_staff ? true : user.permissions ? _.find(user.permissions, function (permission) {
                                        return permission.permission === 'org_admin';
                                    }) : false;
                                });

                                var adminUsers = partitioned[0];
                                var regularUsers = partitioned[1];

                                var list = [];

                                if (adminUsers.length) {
                                    var adminArea = {
                                        id: 'X',
                                        name: 'Admins',
                                        description: 'Admin Users'
                                    };

                                    list.push(defaultGroupGenerator(adminArea, 'X', adminUsers, 'user', allowedFilterOptions(siteData, 'users'), cache, filters, defaultChildGenerator));
                                }

                                if (regularUsers.length) {
                                    var regularArea = {
                                        id: 'Y',
                                        name: 'Regular',
                                        description: 'Regular Users'
                                    };

                                    list.push(defaultGroupGenerator(regularArea, 'Y', regularUsers, 'user', allowedFilterOptions(siteData, 'users'), cache, filters, defaultChildGenerator));
                                }

                                return [list, filters];
                            },
                            "default": function _default(siteData, cache) {
                                //
                                // All filter actions scoped here
                                //
                                var filters = {};

                                var defaultChildType = 'zone';

                                var areas = siteData.areas.map(function (area) {
                                    area.zones = siteData.zones.filter(function (zone) {
                                        return zone.area === area.id;
                                    }); //Area zones - used some places
                                    return area;
                                });

                                var list = _.map(areas, function (area, key) {
                                    return defaultGroupGenerator(area, key, area.zones, defaultChildType, allowedFilterOptions(siteData, 'zone'), cache, filters, defaultChildGenerator);
                                });

                                //
                                // @replace
                                //
                                // Temp place for unassigned zones - should handle these better
                                //
                                var unassigned = _.filter(siteData.zones, ['area', null]);

                                if (unassigned.length) {
                                    var unassignedArea = {
                                        id: 'X',
                                        name: 'Unassigned',
                                        description: 'Unassigned Zones'
                                    };

                                    list.push(defaultGroupGenerator(unassignedArea, 'X', unassigned, defaultChildType, allowedFilterOptions(siteData, 'zone'), cache, filters, defaultChildGenerator));
                                }

                                return [list, filters];
                            }
                        };

                        return renderers[context] ? renderers[context](data, cache, currentUser) : renderers['default'](data, cache, currentUser);
                    }
                }]);

                return ContextualMenusHelper;
            })();

            _export('default', ContextualMenusHelper);
        }
    };
});

$__System.register('121', ['12', '13', '70'], function (_export) {
    var _createClass, _classCallCheck, _Object$keys, ContextualMenusActions;

    return {
        setters: [function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }, function (_4) {
            _Object$keys = _4['default'];
        }],
        execute: function () {
            'use strict';

            ContextualMenusActions = (function () {
                function ContextualMenusActions($rootScope, Areas, Automations, Modals, Programmer, $q, $state, _) {
                    _classCallCheck(this, ContextualMenusActions);

                    //
                    // Not really using this pattern here
                    //
                    //
                    this.$scope = $rootScope;
                    this.Areas = Areas;
                    this.Automations = Automations;
                    this.Modals = Modals;
                    this.Programmer = Programmer;
                    this.$q = $q;
                    this.$state = $state;
                    this._ = _;
                }

                _createClass(ContextualMenusActions, [{
                    key: 'assign',
                    value: function assign(itemType, ids, parentId, siteId) {
                        //
                        // Moved to leftNavList for brevity
                        //
                    }
                }, {
                    key: 'auto',
                    value: function auto(itemType, ids, parentId, siteId) {
                        var _this = this;

                        this.Modals.openLoad('Programming');

                        var reqs = this._.map(ids, function (id) {
                            return _this.Programmer.area(id, siteId);
                        });

                        return this.$q.all(reqs).then(function () {
                            _this.Modals.closeLoad('Complete', true);
                        })['catch'](function (error) {
                            _this.Modals.closeLoad('Failure');
                        });
                    }
                }, {
                    key: 'delete',
                    value: function _delete(itemType, ids, parentId, siteId, areas, automations, leftMenuSpecialContext) {
                        var _this2 = this;

                        if (leftMenuSpecialContext === 'automations' && itemType === 'group') {
                            return this.Modals.confirm(this.$scope, 'Cancel', 'Delete', 'Are you sure about deleting these Automations?').then(function () {
                                _this2.Modals.openLoad('Deleting Automation Groups');

                                // Group automations by their criteria attribute to match the left nav structure
                                var groupedAutomations = _this2._.groupBy(automations, 'criteria[0].attribute');

                                var allAutomationsToDelete = [];
                                _this2._.each(ids, function (groupId) {

                                    var groupKeys = _Object$keys(groupedAutomations);
                                    var groupKey = groupKeys[groupId - 1];

                                    if (groupKey) {
                                        var automationsInGroup = groupedAutomations[groupKey];

                                        allAutomationsToDelete = allAutomationsToDelete.concat(automationsInGroup);
                                    } else {
                                        console.error('Group not found for ID:', groupId);
                                    }
                                });

                                var reqs = _this2._.map(allAutomationsToDelete, function (automation) {
                                    return _this2.Automations['delete'](automation);
                                });

                                return _this2.$q.all(reqs).then(function () {
                                    _this2.Modals.closeLoad('Automation Groups Deleted', true);
                                })['catch'](function (err) {
                                    console.log(err);
                                    _this2.Modals.closeLoad('Failed', false);
                                });
                            })['catch'](function (err) {
                                console.log(err);
                                _this2.$q.resolve();
                            });
                        } else {
                            // Handle area deletion
                            return this.Modals.confirm(this.$scope, 'Cancel', 'Delete', 'Are you sure about deleting this Area?').then(function () {
                                _this2.Modals.openLoad('Deleting Area');

                                var reqs = _this2._.map(ids, function (id) {
                                    var matchingArea = _this2._.find(areas, { id: id });
                                    return _this2.Areas.del(matchingArea);
                                });

                                return _this2.$q.all(reqs).then(function () {
                                    _this2.Modals.closeLoad('Success', true);
                                })['catch'](function (err) {
                                    console.log(err);
                                    _this2.Modals.closeLoad('Failed', false);
                                });
                            })['catch'](function (err) {
                                console.log(err);
                                _this2.$q.resolve();
                            });
                        }
                    }

                    // createMulti(){
                    //     let blankInput = {};

                    //     return this.Modals.showModal({
                    //             name: 'rename',
                    //             inputs:{
                    //                 selectedObject : blankInput,
                    //                 cleanObject: {},
                    //                 title: 'Name Multi-Zone',
                    //                 action: 'Save'
                    //             }
                    //     }).then(result => {
                    //         if(result){
                    //             let newName = blankInput.name; //Rename modal returns name

                    //             //this.Modals.openLoad('Updating');

                    //             return this.$q.defer().promise;

                    //             // return this.$q.all(reqs).then(() => {
                    //             //     this.Modals.closeLoad('Success',true);
                    //             // });
                    //         }
                    //     });
                    // }

                }, {
                    key: 'edit',
                    value: function edit() {
                        return this.$q.defer().promise;
                    }
                }, {
                    key: 'rename',
                    value: function rename(itemType, ids, parentId, siteId, areas) {
                        var _this3 = this;

                        //
                        // Area only for now
                        //
                        // Give them all same name with increment?
                        //
                        var firstMatchingArea = this._.find(areas, { id: ids[0] });

                        return this.Modals.showModal({
                            name: 'rename',
                            inputs: {
                                selectedObject: firstMatchingArea,
                                cleanObject: {},
                                title: 'Name Area',
                                action: 'Save'
                            }
                        }).then(function (result) {
                            if (result) {
                                var _ret = (function () {

                                    var newName = firstMatchingArea.name; //Rename modal returns name

                                    _this3.Modals.openLoad('Updating');

                                    var reqs = _this3._.map(ids, function (id) {
                                        var areaUpdateObj = {
                                            id: id,
                                            id_string: newName,
                                            site_id: siteId
                                        };

                                        return _this3.Areas.update(areaUpdateObj);
                                    });

                                    return {
                                        v: _this3.$q.all(reqs).then(function () {
                                            _this3.Modals.closeLoad('Success', true);
                                        })
                                    };
                                })();

                                if (typeof _ret === 'object') return _ret.v;
                            }
                        });
                    }
                }, {
                    key: 'unassign',
                    value: function unassign() {
                        //
                        // Moved to leftNavList for brevity
                        //
                    }
                }, {
                    key: 'update',
                    value: function update(itemType, ids, parentId, siteId, areas, zones) {
                        return this.$state.go('Updates', { userSelectedFilter: ['selection' + this._.map(ids, function (id) {
                                return '-' + id;
                            }).join('').toString()] });
                    }
                }]);

                return ContextualMenusActions;
            })();

            _export('default', ContextualMenusActions);
        }
    };
});

$__System.register('122', [], function (_export) {
    'use strict';

    function FilteredDevicesExport($http, _) {
        this.filteredDevicesText = function (siteId, filters, filteredDevices) {
            var data = {
                filters: filters, filteredDevices: filteredDevices
            };
            return $http({
                method: 'POST',
                url: 'site/' + siteId + '/filtered_devices_list/',
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(data),
                responseType: 'blob'
            }).then(function (response) {
                return response.data;
            });
        };
    }return {
        setters: [],
        execute: function () {
            FilteredDevicesExport.$inject = ['$http', '_'];;

            _export('default', FilteredDevicesExport);
        }
    };
});

$__System.register('123', [], function (_export) {
    /**
     * Created by yuchao on 3/16/18.
     */
    'use strict';

    var leftNavListDeviceUpdateComponent;
    return {
        setters: [],
        execute: function () {
            leftNavListDeviceUpdateComponent = {
                template: '\n        <span ng-if="lNLDUC.updateStatus !== \'NOT-UP-TO-DATE\'" ng-class="{ready: lNLDUC.updateStatus === \'NOT-UP-TO-DATE\', queued: lNLDUC.updateStatus === \'QUEUED\', installing: lNLDUC.updateStatus === \'INSTALLING\', failed: lNLDUC.updateStatus === \'FAILED\'}">{{lNLDUC.updateSteps[lNLDUC.updateStatus]}}</span>\n    ',
                bindings: {
                    updateStatus: '<'
                },
                controllerAs: 'lNLDUC',
                controller: function controller() {

                    var lNLDUC = this;

                    lNLDUC.updateSteps = {
                        'NOT-UP-TO-DATE': 'Update Ready',
                        'QUEUED': 'Queued',
                        'INSTALLING': 'Installing',
                        'UP-TO-DATE': '',
                        'FAILED': 'Update Failed',
                        'ERROR': 'Error',
                        'PREPARING': 'Preparing'
                    };

                    lNLDUC.$onInit = function () {
                        //console.log(lNLDUC.updateStatus);
                    };

                    lNLDUC.$onChanges = function (changes) {
                        if (changes.updateStatus) {
                            lNLDUC.updateStatus = changes.updateStatus.currentValue;
                        }
                    };
                }
            };

            _export('default', leftNavListDeviceUpdateComponent);
        }
    };
});

$__System.register('124', [], function (_export) {
    'use strict';

    var leftNavListMultiSelectComponent;
    return {
        setters: [],
        execute: function () {
            leftNavListMultiSelectComponent = {
                template: function template($element, $attrs) {
                    //use el and attrs
                    return '\n            <header class="left-nav-list-filter-header left-nav-list-multi-select">\n                <span class="" ng-click="nLMS.onClick()">Multi Select Mode</span>\n                <button class="btn btn-select-toggle" ng-class="{selected: nLMS.multiSelectMode}" ng-click="nLMS.onClick()"></button>\n                \n                \n                <select ng-if="nLMS.multiSelectMode && nLMS.devicesSection && nLMS.itemSelected" ng-model="nLMS.item" ng-change="nLMS.onSelectChange(nLMS.item)">\n                  <option value="" disabled selected>choose an action</option>\n                  <option value="edit">edit</option>\n                  <option value="assign">create new area</option>\n                  <option value="unassign">unassign</option>\n                  <option value="update">update</option>\n                  <option value="createGroup">create group</option>\n                </select>\n            </header>\n        ';
                },
                bindings: {
                    //
                    // In
                    //
                    multiSelectMode: '<',
                    itemSelected: '<',
                    //
                    // Out
                    //
                    onMultiSelectChange: '&',
                    onSelectAction: '&'
                    //
                    // Shake it all about
                    //
                },
                controllerAs: 'nLMS',
                controller: function controller($location) {

                    var nLMS = this;

                    nLMS.$onInit = function () {
                        checkCurrentLocation();
                    };

                    nLMS.$onChanges = function (changes) {};

                    nLMS.onClick = function () {
                        nLMS.multiSelectMode = !nLMS.multiSelectMode;
                        nLMS.onMultiSelectChange({ mode: nLMS.multiSelectMode });
                    };

                    nLMS.onSelectChange = function (item) {
                        nLMS.onSelectAction({ action: item });
                        nLMS.item = null;
                    };

                    function checkCurrentLocation() {
                        var location = $location.path().toString();
                        if (location.includes('devices')) {
                            nLMS.devicesSection = true;
                        } else {
                            nLMS.devicesSection = false;
                        }
                    }
                }
            };

            _export('default', leftNavListMultiSelectComponent);
        }
    };
});

$__System.register('125', ['109', '120', '121', '122', '123', '124', '10a', '10b', '10c', '10d', '11a', '11b', '11c', '11d', '11e'], function (_export) {
    'use strict';

    var leftNavListComponent, leftNavListContextualMenusHelper, leftNavListContextualMenusActions, leftNavListExportService, leftNavListDeviceUpdateComponent, leftNavListMultiSelectComponent, leftNavListGroupComponent, leftNavListGroupChildComponent, leftNavListSearchComponent, leftNavListFilterComponent, leftNavListFilterOptionComponent, LeftNavListDraggableItemDirective, LeftNavListDroppableItemDirective, LeftNavListContextMenuDirective, leftNavListFilterGroupFilter;
    return {
        setters: [function (_) {
            leftNavListComponent = _['default'];
        }, function (_2) {
            leftNavListContextualMenusHelper = _2['default'];
        }, function (_3) {
            leftNavListContextualMenusActions = _3['default'];
        }, function (_4) {
            leftNavListExportService = _4['default'];
        }, function (_5) {
            leftNavListDeviceUpdateComponent = _5['default'];
        }, function (_6) {
            leftNavListMultiSelectComponent = _6['default'];
        }, function (_a) {
            leftNavListGroupComponent = _a['default'];
        }, function (_b) {
            leftNavListGroupChildComponent = _b['default'];
        }, function (_c) {
            leftNavListSearchComponent = _c['default'];
        }, function (_d) {
            leftNavListFilterComponent = _d['default'];
        }, function (_a2) {
            leftNavListFilterOptionComponent = _a2['default'];
        }, function (_b2) {
            LeftNavListDraggableItemDirective = _b2['default'];
        }, function (_c2) {
            LeftNavListDroppableItemDirective = _c2['default'];
        }, function (_d2) {
            LeftNavListContextMenuDirective = _d2['default'];
        }, function (_e) {
            leftNavListFilterGroupFilter = _e['default'];
        }],
        execute: function () {

            angular.module('left-nav-list', []).component('leftNavList', leftNavListComponent).component('leftNavListGroup', leftNavListGroupComponent).component('leftNavListGroupItem', leftNavListGroupChildComponent).component('leftNavListSearch', leftNavListSearchComponent).component('leftNavListFilter', leftNavListFilterComponent).component('leftNavListFilterOption', leftNavListFilterOptionComponent).component('leftNavListMultiSelect', leftNavListMultiSelectComponent).component('leftNavListDeviceUpdate', leftNavListDeviceUpdateComponent).service('ContextualMenusHelper', leftNavListContextualMenusHelper).service('ContextualMenusActions', leftNavListContextualMenusActions).service('FilteredDevicesExport', leftNavListExportService).directive('lcDraggableItem', function () {
                return new LeftNavListDraggableItemDirective();
            }).directive('lcDroppableItem', function () {
                return new LeftNavListDroppableItemDirective();
            }).directive('lcContextMenu', function () {
                return new LeftNavListContextMenuDirective();
            }).filter('nLFilterGroups', leftNavListFilterGroupFilter);
        }
    };
});

$__System.register('126', [], function (_export) {
    'use strict';

    var omniBoxComponent;
    return {
        setters: [],
        execute: function () {
            omniBoxComponent = {
                template: '\n      <div class="search-cluster">\n        <div class="current-org">\n            <button class="omni-drop-down-menu" ng-click="oBC.toggleDrop(true);"></button>\n            <span class="org-name" ng-if="!oBC.site.id && oBC.org">Org: {{oBC.org.name}}</span>\n            <omni-box-input \n                class="{{oBC.site.id_string ? \'site-selected\' : \'org-selected\'}}"\n                selection="oBC.site.id_string" \n                enable-full-text-select="oBC.enableFullTextSelect"\n                on-browse="oBC.onBrowse(direction);" \n                on-enter="oBC.select(item,category);" \n                on-results="oBC.showResults(results);"\n                on-local-search="oBC.localFilter(filter)" \n                top-match="oBC.topMatch"\n            ></omni-box-input>\n            <button class="omni-drop-down-arrow" ng-class="{\'open\': oBC.dropBoxOpen}" ng-click="oBC.toggleDrop(true);"></button>\n        </div>\n\n        <omni-box-dropdown \n            ng-if="oBC.dropBoxOpen"\n            direction="oBC.browseDirection" \n            is-super-user="oBC.isSuperUser"\n            local-filter-content="oBC.localFilterContent" \n            results="oBC.results" \n            on-focus-parent="oBC.focusBox($event)" \n            on-escape="oBC.toggleDrop(true)" \n            on-select="oBC.select(item,category);"\n        ></omni-box-dropdown>\n      </div>\n    ',
                bindings: {
                    isSuperUser: '<',
                    org: '<',
                    site: '<',
                    onToggleDrop: '&?'
                },
                controllerAs: 'oBC',
                controller: function controller($state, $scope, $window, $timeout, Orgs, _) {
                    //
                    //
                    //
                    var oBC = this;

                    var selectionHandlers = {
                        gateway: function gateway(object) {
                            //
                            // - Nothing for now
                            //
                            console.log('Browse to gateway', object);
                        },
                        org: function org(object) {
                            function getOrgSites(uuid) {
                                return Orgs.getSites(uuid);
                            }

                            function navigateToOrgSite(sites) {
                                if (sites.length) {
                                    $state.go('Overview', { siteId: sites[0].id, userSelectedFilter: null, leftMenuSpecialContext: 'overview' });
                                } else {
                                    $state.go('no-sites', { orgObject: object });
                                }
                            }

                            getOrgSites(object.uuid).then(function (sites) {
                                navigateToOrgSite(sites);
                            });
                        },
                        site: function site(object, currentState) {
                            //
                            //
                            // When transitioning sites, retain current context if possible
                            // If using omnibox from Home / Notification / Users Release note view, browsing to new site will catch in loop
                            // We can fix this by adding org_uuid to every object in the left nav... better handled with BE Search in future
                            //
                            var orgLevelViews = ['Home', 'Users', 'MultiSite', 'notifications', 'releaseNotes'];

                            //
                            //
                            //Blue sites only allow control view, so navigation from devices on a non-blue will trip this logic
                            var targetStateName = oBC.site.is_blue ? 'Overview' : orgLevelViews.indexOf(currentState.name) > -1 ? 'Overview' : currentState.name;

                            $state.go(targetStateName, { siteId: object.id, userSelectedFilter: null, leftMenuSpecialContext: currentState.params.leftMenuSpecialContext || 'default' });
                        },
                        user: function user(object) {
                            //
                            // Permissions are listed by ID - we need uuid for the user view ( could change this down the line )
                            //
                            var userOrgId = _.find(object.permissions, function (perm) {
                                return perm.permission === 'org_admin' || perm.permission === 'org_user';
                            });

                            // Super users and homeless users have no explicity perms, use rab org for now
                            userOrgId = userOrgId || 1;

                            if (userOrgId) {
                                Orgs.get(userOrgId).then(function (org) {
                                    //
                                    //
                                    //  REMOVE
                                    //
                                    //
                                    var orgUuid = org.uuid || '49edc3f0-4abb-41cf-b43a-07eee0b82079'; //REMOVE THIS when DM merges multi org
                                    //
                                    //
                                    //
                                    //
                                    //

                                    $state.go('Users', { orgUuid: orgUuid, userSelectedFilter: [object.id], leftMenuSpecialContext: 'users' });
                                });
                            } else {
                                $state.go('Users', { orgUuid: null, userSelectedFilter: [object.id], leftMenuSpecialContext: 'users' });
                            }
                        }
                    };

                    oBC.$onDestroy = function () {
                        removeWindowClickWatch();
                    };

                    oBC.focusBox = function (event) {
                        console.log(event);
                    };

                    oBC.onBrowse = function (direction) {
                        openDrop();

                        oBC.browseDirection = { direction: direction };
                    };

                    oBC.select = function (item, category) {

                        // - hide drop
                        oBC.dropBoxOpen = false;
                        selectionHandlers[category](item, $state.current);
                    };

                    //use local filter for the moment, will be replaced by elastic search

                    oBC.localFilter = function (filter) {
                        oBC.localFilterContent = filter;
                        if (!oBC.dropBoxOpen) {
                            oBC.toggleDrop();
                        }
                    };

                    oBC.showResults = function (results) {
                        setResults(results);

                        openDrop();
                    };

                    oBC.toggleDrop = function (dontTriggerSearch) {
                        return $timeout(function () {
                            return oBC.dropBoxOpen ? closeDrop() : openDrop(dontTriggerSearch ? _.get(oBC, 'site.org.uuid') : false);
                        });
                    };

                    function setWindowClickWatch() {
                        angular.element($window).on('click', function (event) {
                            $timeout(function () {
                                if (!event.target.closest('omni-box')) {
                                    closeDrop();
                                    var selectionHolder = angular.copy(oBC.site.id_string);
                                    oBC.site.id_string = "";
                                    oBC.enableFullTextSelect = true;
                                    $scope.$apply();
                                    oBC.site.id_string = selectionHolder;
                                    oBC.enableFullTextSelect = false;
                                    $scope.$apply();

                                    if (!event.target.closest('top-menu-bar-right-section')) {
                                        removeWindowClickWatch();
                                    }
                                }
                            });
                        });
                    }

                    function openDrop(filter) {
                        oBC.dropBoxOpen = true;
                        setWindowClickWatch();
                        oBC.localFilter(filter ? filter : $scope.$$childHead.selection);
                    }

                    function closeDrop() {
                        oBC.dropBoxOpen = false;
                    }

                    function removeWindowClickWatch() {
                        angular.element($window).off('click');
                    }

                    function setResults(results) {
                        oBC.results = results;
                    }
                }
            };

            _export('default', omniBoxComponent);
        }
    };
});

$__System.register('127', [], function (_export) {
    'use strict';

    var omniBoxDropListComponent;
    return {
        setters: [],
        execute: function () {
            omniBoxDropListComponent = {
                template: '\n        <div class="omni-drop-sites-list">\n            <h2 class="overview-heading" ng-class="{\'joinMode\': oBDL.listTitle === \'Join Mode\'}" ng-click="oBDL.dropped = !oBDL.dropped;" >\n              <span>{{::oBDL.listTitle}}</span>\n              <button class="omni-drop-down-arrow" ng-class="{\'open\': oBDL.dropped}"></button>\n            </h2>\n            <ul class="results" ng-class="{\'dropped\': oBDL.dropped}" ng-if="oBDL.dropped">\n                <li class="item search-result" ng-class="{focused: item.selected}" ng-repeat="item in oBDL.list | orderBy: \'id_string\'" data-uuid="{{::item.uuid}}" ng-keydown="$event.keyCode === 13 && oBDL.onSelect({item: item, category: item.category});" ng-click="oBDL.onSelect({item: item, category: item.category});" tabindex="0" index="{{$index}}">\n                    <span class="listTitle">{{::item.id_string}}</span>\n\n                    <!--<span class="description" ng-if="::oBDL.list.length === 1" class="parent">{{::oBDL.listTitle}}</span>-->\n\n                    <span ng-if="::!oBDL.showSiteInfo" class="parent">{{::item.category}}</span>\n\n                    <span ng-if="::oBDL.showSiteInfo && (((item.gateways_count === 0  && !item.is_blue)|| item.gateways_count > 1) || item.gateways_setup_count > 0 || item.gateways_unavailable_count > 0)" class="parent">\n                        <i ng-if="::(item.gateways_count === 0 || item.gateways_count > 1) \n                                        && item.gateways_setup_count < 2 \n                                        && item.gateways_unavailable_count < 2" \n                            class="gateways-list-icon gateways" title="Gateways: {{::item.gateways_count}}">{{::item.gateways_count}}</i>\n                        <i ng-if="::item.gateways_setup_count > 0" class="gateways-list-icon setup-mode" title="Gateways in setup mode: {{::item.gateways_setup_count}}">{{::item.gateways_setup_count}}</i>\n                        <i ng-if="::item.gateways_unavailable_count > 0" class="gateways-list-icon unhealthy" title="Gateways unavailable: {{::item.gateways_unavailable_count}}">{{::item.gateways_unavailable_count}}</i>\n                    </span>\n                </li>              \n            </ul>\n        </div>\n    ',
                bindings: {
                    index: '<',
                    list: '<',
                    listTitle: '<',
                    listFilter: '<',
                    showSiteInfo: '<',
                    onSelect: '&?'
                },
                controllerAs: 'oBDL',
                controller: function controller() {
                    //
                    //
                    //
                    var oBDL = this;

                    oBDL.$onInit = function () {
                        // - //
                        if (oBDL.listTitle !== 'Join Mode' && (oBDL.index === 0 || oBDL.listFilter)) {
                            oBDL.dropped = true;
                        }
                    };
                }
            };

            _export('default', omniBoxDropListComponent);
        }
    };
});

$__System.register('128', ['12', '13'], function (_export) {
    var _createClass, _classCallCheck, OmniBoxInputDirective;

    return {
        setters: [function (_) {
            _createClass = _['default'];
        }, function (_2) {
            _classCallCheck = _2['default'];
        }],
        execute: function () {
            'use strict';

            OmniBoxInputDirective = (function () {
                function OmniBoxInputDirective() {
                    _classCallCheck(this, OmniBoxInputDirective);

                    this.restrict = 'E';
                    this.scope = {
                        selection: '<',
                        enableFullTextSelect: '<',
                        topMatch: '<',
                        onBrowse: '&',
                        onEscape: '&',
                        onEnter: '&',
                        onResults: '&',
                        onType: '&',
                        onLocalSearch: '&'
                    };
                    this.template = '\n        <input type="text" placeholder="Search a Site" class="omni-search-input" ng-model="selection" value="selection" ng-click="onClicked($event)"/>\n        <!--<span class="result-suggestion" ng-if="suggestion">{{suggestion}}</span>-->\n      ';
                }

                _createClass(OmniBoxInputDirective, [{
                    key: 'controller',
                    value: function controller($scope, $timeout, HttpPendingRequestsService, Search, focus, LcFn) {
                        $scope.dependencies = {
                            $timeout: $timeout,
                            HttpPendingRequestsService: HttpPendingRequestsService,
                            Search: Search,
                            focus: focus,
                            LcFn: LcFn
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, elm, attrs, ngModel) {

                        var searchBox = elm[0].children[0];

                        var searchTerm = null;

                        var timer = undefined;

                        var waitTime = 500;

                        //
                        // @todo
                        //
                        // - Cancel outstanding reqs as you type (or debounce)
                        // - Handle case sensitivitiy
                        //
                        //

                        function showSuggestion(string) {
                            scope.selection = string;
                            selectInputRange(searchBox, scope.selectionStart, string.length);
                        }

                        function selectInputRange(elm, selectionStart, selectionEnd) {
                            scope.dependencies.$timeout(function () {
                                elm.focus();
                                elm.setSelectionRange(selectionStart, selectionEnd);
                            });
                        }

                        function getNameFromResult(object) {
                            return scope.dependencies.LcFn.getName(object);
                        }

                        function checkResultVsInput(resultString) {
                            //
                            // Whitespace issues
                            //
                            var contractedString = resultString.replace(/ /g, '');
                            var contractedSelection = searchTerm.replace(/ /g, '');

                            //
                            // Check the result matches current input
                            //
                            return contractedString.split(contractedSelection).length > 1;
                        }

                        function toLowerCase(string) {
                            return string ? string.toLowerCase() : string;
                        }

                        function search(selection) {
                            //
                            //  - @todo cancel outstanding searches as you type
                            //
                            scope.dependencies.Search.fullText(selection).then(function (results) {
                                if (results.length) {
                                    setCurrentResults(results);

                                    //
                                    // Some items match search but have no name or Id field - what to do?
                                    //
                                    var resultString = getNameFromResult(getTopMatch(results));

                                    if (resultString) {

                                        if (checkResultVsInput(resultString)) {

                                            showSuggestion(resultString);
                                        } else {
                                            //
                                            // Push this suggestion to top of the drop box?
                                            //
                                            console.log(resultString);
                                        }
                                    }
                                } else {
                                    //
                                    //No matches
                                    // - @todo - prevent additional searches here until backspace?
                                    console.log('No matches');
                                }
                            });
                        }

                        function setCurrentResults(results) {
                            scope.results = results;
                            scope.onResults({ results: results });
                        }

                        function getTopMatchGroup(results) {
                            return { category: results[0].name, object: results[0].group[0] };
                        }

                        function getTopMatch(results) {
                            return results[0].group[0];
                        }

                        function localSearch(filter) {
                            scope.onLocalSearch({ filter: filter });
                            scope.$apply();
                        }

                        //scope.changed = function(){
                        //  localSearch(scope.selection);
                        //};

                        // comment this out for the moment, use local search ng-change
                        // when search api works, then restructure all of this

                        // delay local search until waitTime ms elapses since user last typed
                        elm.bind('keyup', function (e) {
                            // Clear timer
                            clearTimeout(timer);

                            // Wait for waitTime ms and then process the request
                            timer = setTimeout(function () {
                                localSearch(scope.selection);
                            }, waitTime);
                        });

                        //Bindings
                        elm.bind('keydown', function (e) {
                            var ignoredKeys = [16, 17, 18, 33, 34, 35, 36, 37, 39, 91, 93, 124];

                            if (ignoredKeys.indexOf(e.keyCode) > -1) {
                                //Moved to keydown

                            } else if (e.keyCode === 8 || e.keyCode === 46) {
                                    //Backspace
                                } else if (e.keyCode === 13) {
                                        //Enter

                                        // if(scope.results){
                                        //     scope.onEnter({result: getTopMatchGroup(scope.results)});
                                        // }
                                    } else if (e.keyCode === 27) {
                                            //Escape
                                            scope.onEscape();
                                            //scope.$apply();
                                        } else if (e.keyCode === 38) {
                                                //Up
                                                scope.onBrowse({ direction: 'up' });
                                                scope.$apply();
                                            } else if (e.keyCode === 40) {
                                                //Down
                                                scope.onBrowse({ direction: 'down' });
                                                scope.$apply();
                                            } else {
                                                //Too early to use scope.selection
                                                // searchTerm = e.target.value + e.key;
                                                // search(searchTerm);
                                            }
                        });

                        elm.bind('keyup', function (e) {
                            var ignoredKeys = [8, 13, 16, 17, 18, 27, 33, 34, 35, 36, 37, 38, 39, 40, 91, 93, 124];

                            if (ignoredKeys.indexOf(e.keyCode) > -1) {
                                //Moved to keydown
                            } else {
                                    if (scope.selection) {
                                        scope.selectionStart = e.target.selectionStart;
                                    }
                                }
                        });

                        // - Interfering with click watcher for menu drop in omni-box parent

                        // elm.on('mousedown', $event => {
                        //     // - Drop the quickmenu, select the text
                        //     scope.onBrowse();
                        // });

                        // scope.update = function(selection){
                        //   scope.onType({selection: selection});
                        // };

                        scope.focusField = function () {
                            // get element ID here ?
                            scope.dependencies.focus('#csSearch');
                        };

                        scope.onClicked = function ($event) {
                            if (scope.selection && !scope.enableFullTextSelect) {
                                $event.target.select();
                                scope.enableFullTextSelect = true;
                            }
                        };
                    }
                }]);

                return OmniBoxInputDirective;
            })();

            _export('OmniBoxInputDirective', OmniBoxInputDirective);
        }
    };
});

$__System.register('129', ['11', '12', '13'], function (_export) {
    var _, _createClass, _classCallCheck, OmniBoxDropdownDirective;

    return {
        setters: [function (_4) {
            _ = _4['default'];
        }, function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }],
        execute: function () {
            'use strict';

            OmniBoxDropdownDirective = (function () {
                function OmniBoxDropdownDirective() {
                    _classCallCheck(this, OmniBoxDropdownDirective);

                    this.restrict = 'E';
                    this.scope = {
                        direction: '<',
                        isSuperUser: '<',
                        results: '<',
                        localFilterContent: '<',
                        onEscape: '&',
                        onFocusParent: '&',
                        onSelect: '&'
                    };
                    this.template = '\n            <omni-box-drop-list \n                ng-if="results" \n                index="0" \n                list="oBD.flattenResults(results)" \n                list-title="\'Search Results\'" \n                on-select="onSelect({item: item, category: category})"\n            ></omni-box-drop-list>\n\n            <omni-box-drop-list \n                ng-if="!results && (!localFilterContent || localFilterContent.length < 1)" \n                ng-repeat="group in oBD.groupedSitesList" \n                index="$index" \n                list="group.sites" \n                list-title="group.name" \n                show-site-info="true" \n                on-select="onSelect({item: item, category: category})"\n            ></omni-box-drop-list>\n            \n            <omni-box-drop-list \n                ng-if="!results && (localFilterContent && localFilterContent.length > 0)" \n                ng-repeat="group in oBD.rawResults | filter: (isSuperUser ? \'\' : localFilterContent) "\n                index="$index" \n                list="group.sites" \n                list-title="group.name" \n                list-filter="localFilterContent"\n                show-site-info="true" \n                on-select="onSelect({item: item, category: category})"\n            ></omni-box-drop-list>\n\n            <omni-box-drop-list \n                ng-if="isSuperUser && (oBD.joiners.sites.length > 0)" \n                ng-repeat="group in oBD.joiners | filter: localFilterContent" \n                index="$index" \n                list="group.sites" \n                list-title="\'Join Mode\'" \n                list-filter="localFilterContent"\n                show-site-info="true" \n                on-select="onSelect({item: item, category: category})"\n            ></omni-box-drop-list>\n\n            <div class="pagination" ng-if="oBD.totalItems > oBD.entryLimit  && (!results && (!localFilterContent || localFilterContent.length < 1))">\n                <button class="btn btn-less" ng-disabled="oBD.currentPage === 1" ng-click="oBD.currentPage=oBD.currentPage-1; oBD.paginate(oBD.currentPage)"></button>\n                <span>{{oBD.currentPage}}/{{oBD.noOfPages}}</span>\n                <button class="btn btn-greater" ng-disabled="oBD.currentPage === oBD.noOfPages" ng-click="oBD.currentPage=oBD.currentPage+1; oBD.paginate(oBD.currentPage)"></button>\n            </div>\n\n            <p class="loading-spinner-label relative" ng-if="oBD.pending" translate="common.loadingEllipsis">Loading...</p>\n            <p style="color:#fff;text-align:center;" ng-if="!oBD.pending && !oBD.groupedSitesList && !oBD.results">No site found.</p>\n        '; // - Sites list could be seperate component
                }

                _createClass(OmniBoxDropdownDirective, [{
                    key: 'controller',
                    value: function controller($scope, focus, LcFn, Session, Orgs) {
                        $scope.dependencies = {
                            focus: focus,
                            LcFn: LcFn,
                            Session: Session,
                            Orgs: Orgs
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, elm, attrs, ngModel) {
                        var index = 0;

                        var allResults = [];
                        // - Keep our component style
                        scope.oBD = {
                            entryLimit: 10,
                            rawResults: []
                        };

                        init();

                        function init() {
                            scope.oBD.selectedResult = null;
                            scope.oBD.resultListElements = elm.find('.search-result');
                            // showSites(scope.localFilterContent);
                        }

                        scope.$watch('direction', function (directionChange) {
                            if (directionChange) {
                                if (directionChange.direction === 'up') {
                                    // - Go to last result

                                } else if (directionChange.direction === 'down') {
                                        // - Go to first result
                                        focusItem(index);
                                    }
                            }
                        });

                        scope.$watch('localFilterContent', function (filterChange) {
                            if (filterChange) {
                                index = 0;
                                showSites(filterChange);
                            }
                        });

                        elm.bind('keydown', function (e) {

                            if (e.keyCode === 13) {
                                //Handled by ng-keydown now
                            } else if (e.keyCode === 27) {
                                    //Escape
                                    scope.onEscape();
                                } else if (e.keyCode === 38) {
                                    //Up
                                    if (index === 0) {
                                        focusParent();
                                    } else {
                                        index--;
                                        focusItem(index, e);
                                    }
                                } else if (e.keyCode === 40) {
                                    //Down
                                    if (index === scope.oBD.resultListElements.length - 1) {
                                        focusParent();
                                    } else {
                                        index++;
                                        focusItem(index, e);
                                    }
                                }
                        });

                        function addCategory(list, cat) {
                            return _.map(list, function (item) {
                                item.category = cat;
                                return item;
                            });
                        }

                        function sortByName(list) {
                            return _.orderBy(list, ['name'], ['asc']);
                        }

                        function groupByOrg(list) {
                            return _.map(_.groupBy(list, 'orgName'), function (val, k) {
                                return {
                                    name: k,
                                    sites: val
                                };
                            });
                        }

                        function chunkSitesList(list, count) {
                            return _.chunk(list, count);
                        }

                        function mapTrimSites(site) {
                            return {
                                id_string: site.id_string,
                                id: site.id,
                                orgName: site.org.name,
                                category: 'site',
                                gateways_count: site.gateways.length,
                                gateways_unavailable_count: _.filter(site.gateways, function (gateway) {
                                    return gateway.gateway_health !== 1;
                                }).length,
                                gateways_setup_count: _.filter(site.gateways, 'setup_mode').length,
                                is_blue: site.is_blue
                            };
                        }

                        function mapJoiners(sites) {
                            return [{
                                name: 'Join Mode',
                                sites: sites
                            }];
                        }

                        function setup(trimmedOrgSites) {
                            scope.oBD.totalItems = trimmedOrgSites.length;
                            scope.oBD.rawResults = sortByName(groupByOrg(addCategory(trimmedOrgSites, 'site')));
                            scope.oBD.joiners = mapJoiners(_.filter(trimmedOrgSites, 'gateways_setup_count'));

                            allResults = chunkSitesList(scope.oBD.rawResults, scope.oBD.entryLimit);

                            scope.oBD.currentPage = 1;

                            scope.oBD.noOfPages = allResults.length;

                            return allResults[0];
                        }

                        scope.oBD.paginate = function (page) {
                            scope.oBD.groupedSitesList = allResults[page - 1]; //currentPage not 0-indexed
                        };

                        function isUUID(uuid) {
                            return (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(uuid)
                            );
                        }

                        function showSites(searchTerm) {
                            scope.oBD.pending = true;
                            var promise;

                            // if uuid then use it to get all org sites
                            if (isUUID(searchTerm)) {
                                promise = scope.dependencies.Orgs.getSites(searchTerm);
                            } else {
                                promise = scope.dependencies.Session.getSitesList(null, null, true, searchTerm);
                            }

                            promise.then(function (sites) {
                                //
                                // Dont bind whole list to scope
                                //
                                //sitesList = addCategory(sites,'site');

                                // make sure search term corresponding to the site list
                                // is the current search term inputted by user
                                if (sites && (scope.localFilterContent === searchTerm || isUUID(searchTerm))) {
                                    scope.oBD.groupedSitesList = setup(sites.map(mapTrimSites));
                                    scope.localFilterContent = '';
                                } else {
                                    scope.oBD.groupedSitesList = [];
                                }
                            })['finally'](function () {
                                scope.oBD.pending = false;
                            });
                        }

                        function focusParent() {
                            var parentInput = angular.element(elm[0].previousElementSibling).find('.omni-search-input');

                            parentInput.focus();
                            parentInput[0].setSelectionRange(0, parentInput.val().length);

                            //reset index
                            index = 0;
                        }

                        function focusItem(index, e) {
                            if (e) {
                                e.preventDefault();
                            }

                            scope.oBD.resultListElements = elm.find('.search-result');
                            scope.oBD.selectedResult = scope.oBD.resultListElements[index];

                            if (scope.oBD.selectedResult) {
                                scope.oBD.selectedResult.focus({ preventScroll: true });
                            }
                        }

                        scope.oBD.flattenResults = function (results) {
                            var flatResults = [];

                            _.each(results, function (resultGroup) {
                                _.each(resultGroup.group, function (item) {
                                    item.category = resultGroup.name.slice(0, -1);
                                    flatResults.push(item);
                                });
                            });

                            return flatResults;
                        };

                        scope.oBD.enterSelectResult = function (selectedResult) {
                            var item = scope.oBD.flattenResults(scope.oBD.results)[angular.element(selectedResult).attr('index')] || scope.oBD.results[angular.element(selectedResult).attr('index')];
                            scope.oBD.onSelect({ item: item, category: item.category });
                            //
                            // - Send focus to the search bar at this point?
                        };
                    }
                }]);

                return OmniBoxDropdownDirective;
            })();

            _export('OmniBoxDropdownDirective', OmniBoxDropdownDirective);
        }
    };
});

$__System.register('12a', [], function (_export) {
    'use strict';

    var topMenuBarComponent;
    return {
        setters: [],
        execute: function () {
            topMenuBarComponent = {
                template: '\n        <div class="top-menu-bar" ng-class="{\'lc-show-visible\': tMBC.lcShowVisible(tMBC.site)}">\n\n            <omni-box is-super-user="tMBC.isSuperUser" org="tMBC.org" site="tMBC.site"></omni-box>\n           \n            <div class="menu-tabs left-cluster">\n                <!--\n                <a ui-sref="Home({siteId:tMBC.site.id, orgId:tMBC.org.id})" ui-sref-active="{\'active\': \'Home.**\'}" class="top-menu-link menu-home">\n                    <span translate="common.home">Home</span>\n                </a>\n                -->\n                <a ng-disabled="!tMBC.site.id" ui-sref="Overview({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'default\'})" ui-sref-active="{\'active\': \'Overview.**\'}" class="top-menu-link menu-control">\n                    <span translate="common.control">Control</span>\n                </a>\n                <a ng-if="!tMBC.site.is_blue" ng-disabled="!tMBC.site.id" ui-sref="Energy({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'energy\'})" ui-sref-active="{\'active\': \'Energy.**\'}" class="top-menu-link menu-energy">\n                    <span translate="common.energy">Energy</span>\n                </a>\n                <a ng-if="!tMBC.site.is_blue" ng-disabled="!tMBC.site.id" ui-sref="Scenes({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'scenes\'})" ui-sref-active="{\'active\': \'Scenes.**\'}" class="top-menu-link menu-scenes">\n                    <span translate="common.scenes">Scenes</span>\n                </a>\n                <a ng-if="!tMBC.site.is_blue" ng-disabled="!tMBC.site.id" ui-sref="Schedules({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'schedules\'})" ui-sref-active="{\'active\': \'Schedules.**\'}" class="top-menu-link menu-schedules">\n                    <span translate="common.schedules">Schedules</span>\n                </a>\n                <a ng-if="tMBC.lcShowVisible(tMBC.site) && !tMBC.site.is_blue" ng-disabled="!tMBC.site.id" ui-sref="Shows({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'shows\'})" ui-sref-active="{\'active\': \'Shows.**\'}" class="top-menu-link menu-shows">\n                    <span translate="common.shows">Shows</span>\n                </a>       \n                <a ng-if="!tMBC.site.is_blue" ng-disabled="!tMBC.site.id" ui-sref="Devices({siteId:tMBC.site.id, userSelectedFilter: null, leftMenuSpecialContext: \'devices\'})" ui-sref-active="{\'active\': \'Devices.**\',\'active-child\': \'Updates.**\',\'active-child-child\': \'Automations.**\'}" class="top-menu-link menu-devices" ng-if="::tMBC.isOrgAdmin(tMBC.user,tMBC.org)">\n                    <span translate="common.devices">Devices</span>\n                </a>\n            </div>\n\n            <div class="right-cluster">\n                <top-menu-bar-right-section org="tMBC.org" site="tMBC.site" user="tMBC.user"></top-menu-bar-right-section>\n            </div>\n        </div>\n    ',
                bindings: {
                    org: '<',
                    site: '<',
                    user: '<'
                },
                controllerAs: 'tMBC',
                controller: function controller(LcFn, _) {

                    var tMBC = this;

                    tMBC.$onInit = function () {
                        //console.log(init);
                    };

                    tMBC.$onChanges = function (changes) {
                        //console.log(changes);
                    };

                    tMBC.lcShowVisible = function (site) {
                        //
                        // @todo - Temp - only show this tab on relevant sites
                        //
                        return site ? _.find(site.devices, function (device) {
                            return device.device_type.lcp_type === '57';
                        }) ? true : false : false;
                    };

                    tMBC.isOrgAdmin = LcFn.isOrgAdmin;
                    tMBC.isSuperUser = tMBC.user && tMBC.user.is_superuser;
                }
            };

            _export('default', topMenuBarComponent);
        }
    };
});

$__System.register('12b', [], function (_export) {
    'use strict';

    var topMenuBarRightSectionComponent;
    return {
        setters: [],
        execute: function () {
            topMenuBarRightSectionComponent = {
                template: '\n        <div>\n            <button class="omni-drop-down-arrow face-right" \n                    ng-class="{\'open\': tMBR.dropped}" \n                    ng-click="tMBR.toggleDrop()"\n            ></button>\n\n            <div class="user-name"  ng-click="tMBR.toggleDrop()">\n                <span>{{::tMBR.user.first_name ? tMBR.user.first_name : \'Lightcloud\'}} {{::tMBR.user.last_name ? tMBR.user.last_name : \'User\'}}</span>\n            </div>\n        \n            <div class="org-name"  ng-click="tMBR.toggleDrop()">\n                <span>{{tMBR.org.name}}</span>\n            </div>\n\n            <i class="top-bar-logo"  ng-click="tMBR.toggleDrop()"></i>\n\n            <top-menu-bar-right-section-drop \n                org="tMBR.org" \n                site="tMBR.site" \n                user="tMBR.user" \n                ng-if="tMBR.dropped"\n                on-collapse="tMBR.dropped=!tMBR.dropped"\n            ></top-menu-bar-right-section-drop>\n        </div>\n    ',
                bindings: {
                    org: '<',
                    site: '<',
                    user: '<'
                },
                controllerAs: 'tMBR',
                controller: function controller($window, $timeout) {

                    var tMBR = this;

                    tMBR.$onInit = function () {};

                    tMBR.$onChanges = function () {};

                    tMBR.$onDestroy = function () {
                        removeWindowClickWatch();
                    };

                    tMBR.toggleDrop = function () {
                        return $timeout(function () {
                            return tMBR.dropped ? closeDrop() : openDrop();
                        });
                    };

                    function setWindowClickWatch() {
                        angular.element($window).on('click', function (event) {
                            $timeout(function () {
                                if (!event.target.closest('top-menu-bar-right-section')) {
                                    closeDrop();
                                    if (!event.target.closest('omni-box')) {
                                        removeWindowClickWatch();
                                    }
                                }
                            });
                        });
                    }

                    function openDrop() {
                        tMBR.dropped = true;
                        setWindowClickWatch();
                    }

                    function closeDrop() {
                        tMBR.dropped = false;
                    }

                    function removeWindowClickWatch() {
                        angular.element($window).off('click');
                    }
                }
            };

            _export('default', topMenuBarRightSectionComponent);
        }
    };
});

$__System.register('12c', [], function (_export) {
    'use strict';

    var topMenuBarRightSectionDropComponent;
    return {
        setters: [],
        execute: function () {
            topMenuBarRightSectionDropComponent = {
                template: '\n        <div class="top-menu-drop">\n            <div class="top-menu-section" ng-click="tMD.onCollapse()">\n                <!--<h3 translate="">Site</h3>-->\n                \n                <ul>\n                    <li><button ng-click="tMD.popModal(\'csOrgSiteInfo\', {selectedOrg: tMD.org, site: tMD.site, isSuperUser: tMD.user.is_superuser, isOrgAdmin: tMD.isOrgAdmin(tMD.user,tMD.org)})" class="top-menu-drop-link"><span translate="">Site Info</span></button></li>\n                    <li><button ui-sref="notifications" class="top-menu-drop-link"><span translate="settings.faultNotifications">Notification Management</span></button></li>\n                    <li><button ui-sref="releaseNotes" class="top-menu-drop-link"><span translate="settings.releaseNotes">Release Notes</span></button></li>\n\n                </ul>\n            </div>\n\n            <div class="top-menu-section borders" ng-click="tMD.onCollapse()">\n                <!--<h3 translate="">Organization</h3>-->\n\n                <ul>\n                    <li ng-if="tMD.isOrgAdmin(tMD.user,tMD.org);"><button ng-click="tMD.popModal(\'csOrgEdit\',{selectedOrg: tMD.org});" class="top-menu-drop-link"><span translate="">Edit Org</span></button></li>\n                    <li><button ng-click="tMD.popModal(\'csOrgActivity\',{selectedOrg: tMD.org});" class="top-menu-drop-link"><span translate="">Activity</span></button></li>\n                    <li><button ui-sref="Users({orgUuid: tMD.org.uuid, userSelectedFilter: null})" class="top-menu-drop-link"><span translate="">User Management</span></button></li>\n                    <li><button ui-sref="Home({siteId: tMD.site.id, orgId: tMD.org.id, orgObject: tMD.org})" class="top-menu-drop-link"><span translate="">Org Home</span></button></li>\n                </ul>\n            </div>\n\n\n\n\n            <div class="top-menu-section" ng-if="tMD.user.is_staff"  ng-click="tMD.onCollapse()">\n                <!--<h3 translate="">CS</h3>-->\n                \n                <ul>\n                    <li><button ng-click="tMD.popModal(\'csOrgEdit\', {selectedOrg: null});" class="top-menu-drop-link"><span translate="">Create Org</span></button></li>\n                    <!-- Hidden Jason 9/24 --\n                    <li><button ng-click="tMD.popModal(\'csSalesforceCase\', {selectedOrg: tMD.org});" class="top-menu-drop-link"><span translate="">Salesforce Case</span></button></li>\n                    -->\n                    <li><button ng-click="tMD.popModal(\'csOrgGateways\', {selectedOrg: tMD.org, isSuperUser: tMD.user.is_superuser});" class="top-menu-drop-link"><span translate="">Unassigned Gateways</span></button></li>\n                </ul>\n            </div>\n\n            <div class="top-menu-section borders">\n                <!--<h3 translate="">CS</h3>-->\n                \n                <ul>\n                    <li><button ng-click="tMD.generatePhoneCode()" class="top-menu-drop-link"><span translate="">generate phone code</span></button></li>\n                    <li><button ng-if="tMD.phoneCode" class="top-menu-drop-link"><span translate="">{{tMD.phoneCode}}</span></button></li>\n                   \n                </ul>\n            </div>\n            \n            <div class="top-menu-section">\n                <!--<h3 translate="">CS</h3>-->\n                \n                <ul>\n                    <li>\n                        <button class="top-menu-drop-link">\n                            <span ng-click="tMD.changeLanguage(\'zh\')">中文 </span> |\n                            <span ng-click="tMD.changeLanguage(\'en\')"> EN </span> |\n                            <span ng-click="tMD.changeLanguage(\'es\')"> Español</span>\n                        </button>\n                    </li>\n                   \n                </ul>\n            </div>\n           \n            <!--<div class="top-menu-section borders">\n                <ul>\n                    <li>\n                        <button class="top-menu-drop-link">\n                            <span ng-click="tMD.transitionLegacy()" translate="menu.switchToLegacy">Switch to Legacy UI</span>\n                        </button>\n                    </li>\n                   \n                </ul>\n            </div>-->\n\n            <div class="top-menu-section footer"  ng-click="tMD.onCollapse()">\n                <div class="rab-logo-container">\n                    <i class="rab-logo white" ng-class="{\'rab-logo-ca\': tMD.domainTld === \'ca\'}"></i>\n                </div>\n\n                <button ng-click="tMD.logout()" class="btn top-menu-drop-link-logout"><span translate="login.logout">Logout</span></button>\n\n                <div ng-if="::tMD.user.is_superuser" class="version">Version: {{tMD.releaseVersion}}</div>\n            </div>\n        </div>\n    ',
                bindings: {
                    org: '<',
                    site: '<',
                    user: '<',
                    onCollapse: '&'
                },
                controllerAs: 'tMD',
                controller: function controller($state, $document, Modals, LcFn, Login, _, Users, Local, $translate) {

                    var tMD = this;

                    tMD.$onInit = function () {};

                    tMD.$onChanges = function () {};

                    //
                    // @todo - Change these popup funcs to stateful modals
                    //
                    tMD.popModal = function (name, inputs) {
                        Modals.showModal({
                            name: name,
                            inputs: inputs
                        }).then(function (route) {
                            if (route) {
                                $state.go(route.path, route.params);
                            }
                        });
                    };

                    tMD.logout = function () {
                        return Login.logout();
                    };

                    function getVersion(doc) {
                        var versionElm = angular.element(doc).find('#lightcloud-app');

                        return versionElm.data('lc-version-release');
                    }

                    tMD.releaseVersion = getVersion($document);

                    tMD.domainTld = LcFn.getDomainTld();

                    tMD.isOrgAdmin = LcFn.isOrgAdmin;

                    tMD.generatePhoneCode = function () {
                        var userId = angular.fromJson(Local.get('lcUser')).id; //Context dependent

                        Users.getPhoneCode(userId).success(function (response) {
                            tMD.phoneCode = response.token;
                        });
                    };

                    tMD.changeLanguage = function (langKey) {
                        $translate.use(langKey);
                    };

                    tMD.transitionLegacy = function () {
                        //
                        //    URL Mapping
                        //
                        //    Energy, Schedules (Recurrence), Devices same mapping
                        //
                        //    commissioning/site/123     : site/123/devices
                        //    site/123                   : site/123/overview/
                        //    site/123/scenes            : site/ID/site-scenes
                        //   
                        //    Anything not listed will direct to '/settings' in old app
                        //   

                        var origin = window.location.origin;
                        var hash = window.location.hash;

                        if (hash.indexOf('/overview/') > -1) {
                            hash = hash.replace('/overview/', '');
                        } else if (hash.indexOf('/scenes/') > -1) {
                            hash = hash.replace('/scenes/', '/site-scenes/');
                        }

                        //
                        // Remove selection for now
                        //
                        var destination = origin + '/legacy/' + hash.split('selection')[0];

                        window.location.href = destination;
                    };
                }
            };

            _export('default', topMenuBarRightSectionDropComponent);
        }
    };
});

$__System.register('12d', ['126', '127', '128', '129', '12a', '12b', '12c'], function (_export) {
	'use strict';

	var omniBoxComponent, omniBoxDropListComponent, OmniBoxInputDirective, OmniBoxDropdownDirective, topMenuBarComponent, topMenuBarRightSectionComponent, topMenuBarRightSectionDropComponent;
	return {
		setters: [function (_) {
			omniBoxComponent = _['default'];
		}, function (_2) {
			omniBoxDropListComponent = _2['default'];
		}, function (_3) {
			OmniBoxInputDirective = _3.OmniBoxInputDirective;
		}, function (_4) {
			OmniBoxDropdownDirective = _4.OmniBoxDropdownDirective;
		}, function (_a) {
			topMenuBarComponent = _a['default'];
		}, function (_b) {
			topMenuBarRightSectionComponent = _b['default'];
		}, function (_c) {
			topMenuBarRightSectionDropComponent = _c['default'];
		}],
		execute: function () {

			angular.module('top-menu', []).component('omniBox', omniBoxComponent).component('omniBoxDropList', omniBoxDropListComponent).directive('omniBoxInput', function () {
				return new OmniBoxInputDirective();
			}).directive('omniBoxDropdown', function () {
				return new OmniBoxDropdownDirective();
			}).component('topMenuBar', topMenuBarComponent).component('topMenuBarRightSection', topMenuBarRightSectionComponent).component('topMenuBarRightSectionDrop', topMenuBarRightSectionDropComponent);
		}
	};
});

$__System.register('12e', [], function (_export) {
    'use strict';

    var lcAppComponent;
    return {
        setters: [],
        execute: function () {
            lcAppComponent = {
                template: '\n        <lc-no-auth ng-if="lcApp.isLogin()"></lc-no-auth>\n\n        <lc-auth-app ng-if="!lcApp.isLogin()"></lc-auth-app>\n\n        <toast></toast>\n    ',
                controllerAs: 'lcApp',
                controller: function controller($state, LcFn) {
                    //
                    var lcApp = this;

                    lcApp.isLogin = function () {
                        return LcFn.nonAuthStates.indexOf($state.$current.name) > -1;
                    };
                }
            };

            _export('default', lcAppComponent);
        }
    };
});

$__System.register("12f", [], function (_export) {
    "use strict";

    var lcNoAuthComponent;
    return {
        setters: [],
        execute: function () {
            lcNoAuthComponent = {
                template: "\n        <ui-view></ui-view>\n    ",
                controller: function controller($state) {
                    //
                    var lcNoAuth = this;

                    lcNoAuth.$state = $state;
                }
            };

            _export("default", lcNoAuthComponent);
        }
    };
});

$__System.register('130', [], function (_export) {
    'use strict';

    var lcSiteAppComponent;
    return {
        setters: [],
        execute: function () {
            lcSiteAppComponent = {
                template: '\n        <!--<cs-bar org="lSAC.selectedOrg"></cs-bar>-->\n\n        <top-menu-bar org="lSAC.selectedOrg" site="lSAC.selectedSite" user="lSAC.user"></top-menu-bar><!--\n\n        --><div \n            class="main-container" \n            menu-click-handler menu-open="lSAC.menuOpen" \n            on-menu-toggle="lSAC.menuToggle()" \n            ng-class="{\'menu-open\':lSAC.menuOpen, \'selection-active\': lSAC.selectionActive}"\n            >\n            \n            <!-- Master View nested here -->\n            <ui-view \n                on-menu-toggle="lSAC.menuToggle()" \n                on-session-data-change="lSAC.sessionDataChange(data)" \n                on-selection-update="lSAC.setSelection(selection)" \n                menu-open="lSAC.menuOpen" \n                user="lSAC.user"></ui-view>\n\n            <!--<notifications-popover></notifications-popover>-->\n\n            <!-- AJAX \n            <notifications-message-modal session-messages="lSAC.sessionMsgs"></notifications-message-modal>\n            -->\n\n            <section class="global-messages">\n                <section class="bottom-notice ajax-messages" >\n                    <button class="btn right" ng-click="lSAC.dismissMsgs = true;" class="" translate="common.dismiss">Dismiss</button>\n\n                    <span ng-repeat="msg in lSAC.sessionMsgs">{{::msg.body}}</span>\n                </section>     \n            </div>\n\n            <div class="overlay grey-cover modal-overlay screen-block">\n                <confirmation-modal></confirmation-modal>\n            </div>\n\n            <loading-modal></loading-modal>\n        </div>\n    ',
                controllerAs: 'lSAC',
                controller: function controller($scope, $timeout, $state, Local) {
                    //
                    var lSAC = this;

                    $scope.$on('notifications:showMessageModal', function (msgScope, newMessage) {
                        lSAC.sessionMsgs = lSAC.sessionMsgs && Array.isArray(lSAC.sessionMsgs) ? lSAC.sessionMsgs.unshift(newMessage) : [newMessage];
                    });

                    lSAC.$onInit = function () {
                        //
                        //lSAC.$state = $state;
                        lSAC.user = Local.get('lcUser');
                    };

                    lSAC.$onChanges = function (changes) {
                        //
                    };

                    lSAC.menuToggle = function () {
                        lSAC.menuOpen = !lSAC.menuOpen;
                    };

                    lSAC.sessionDataChange = function (data) {
                        //
                        // does this make sense
                        //
                        lSAC.selectedSite = data;
                        lSAC.selectedOrg = data.org;
                    };

                    lSAC.setSelection = function (selection) {
                        //
                        // Structure.itemCollection
                        //
                        // allowNew
                        // filtered
                        // group
                        // new
                        // title
                        //
                        // This is confusing because Session.getUrlParamsUserSelection() returns slightly different obj - merge these / remove one
                        //
                        //
                        lSAC.selectionActive = (selection.filtered || selection['new'] || selection.mobile) && !selection.notFinishSelection;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    };
                }
            };

            _export('default', lcSiteAppComponent);
        }
    };
});

$__System.registerDynamic('131', ['132', '133', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var anObject = $__require('132'),
      get = $__require('133');
  module.exports = $__require('118').getIterator = function (it) {
    var iterFn = get(it);
    if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
    return anObject(iterFn.call(it));
  };
});
$__System.registerDynamic('134', ['135', '136', '131'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('135');
  $__require('136');
  module.exports = $__require('131');
});
$__System.registerDynamic("137", ["134"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("134"), __esModule: true };
});
$__System.register('138', ['20', '61', '137'], function (_export) {
    var _toConsumableArray, _Set, _getIterator, leftNavComponent;

    return {
        setters: [function (_2) {
            _toConsumableArray = _2['default'];
        }, function (_4) {
            _Set = _4['default'];
        }, function (_3) {
            _getIterator = _3['default'];
        }],
        execute: function () {
            'use strict';

            leftNavComponent = {
                template: '\n\t    <notifications-bottom-site-notices ng-if="mP.sessionData.id" gateways="mP.sessionData.gateways" site="mP.sessionData" user="mP.user" on-update-master="mP.updateMasterSessionDataFromNetwork()"></notifications-bottom-site-notices><!--\n\n     --><!--<master-hamburger-menu selected-site="mP.sessionData;" sites-list="mP.sitesList" user="mP.user"></master-hamburger-menu>--><!--\n\n     --><section class="selection-container" ng-class="{\'scroll\':$root.scroll}"><master-left\n                active-filters="mP.activeFilters"\n                allow-drag-drop="mP.allowDragDrop"\n                areas="mP.sessionData.areas"\n                devices="mP.sessionData.devices"\n                gateways="mP.sessionData.gateways"\n                group-list="mP.groupList"\n                filter-options="mP.filterOptions"\n                menu-open="mP.menuOpen"\n                on-clear-to-base="mP.clearGotoBaseView(createNew)"\n                on-clear-selection-cache="mP.clearSelectionCache()"\n                on-menu-toggle="mP.onMenuToggle();"\n                on-nav-filter-update="mP.onFilterUpdate(filters)"\n                on-nav-update-selection-cache="mP.updateSelectionCache(cache)"\n                on-multi-select-change="mP.onMultiSelectChange(mode)"\n                selection-cache="mP.selectionCache"\n                site-id="mP.sessionData.id"\n                update-status="mP.sessionData.updateStatus"\n                user="mP.user"\n                zones="mP.sessionData.zones"\n                scenes="mP.sessionData.scenes"\n                automations="mP.sessionData.automations"\n                left-menu-special-context="mP.leftMenuSpecialContext"\n                multi-select-status="mP.multiSelectStatus"\n                sites="mP.sessionData"\n            ></master-left>\n        </section><!--\n\n     --><section class="details-container"><master-right\n                cache-titles="mP.selectionTitleCache"\n                gateways="mP.sessionData.gateways"\n                user="mP.user"\n                on-clear-to-base="mP.clearGotoBaseView(createNew)"\n                on-selection-update="mP.selectionUpdate(selection)"\n            ></master-right>\n        </section>\n    ', // Remove inline-block whitespace with comments
                //replace: true,
                bindings: {
                    initialSessionData: '<', //siteData in state resolve
                    initialSelectedIds: '<',
                    initialSessionSitesListPromise: '<', //Don't hold resolve for sites list - takes too long
                    menuOpen: '<',
                    sessionData: '<',
                    user: '<',
                    viewNavContext: '@',
                    leftMenuSpecialContext: '<',
                    //
                    // Out
                    //
                    onSessionDataChange: '&',
                    onSiteChange: '&',
                    onMenuToggle: '&',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'mP',
                controller: function controller($timeout, $scope, $state, $q, $window, Session, ContextualMenusHelper, LcFn, LcCache, _) {
                    //
                    // 	Component only instantiated on siteData promise resolve
                    // 	- we have access to siteData here
                    //
                    var mP = this;

                    mP.$onInit = function () {
                        mP.allowDragDrop = LcCache.getUrlParams().allowDragDrop;
                        mP.leftMenuSpecialContext = $state.params.leftMenuSpecialContext;
                        mP.sitesList = [];

                        mP.onSessionDataChange({ data: mP.initialSessionData });

                        mP.sessionData = angular.copy(mP.initialSessionData);

                        // mP.sessionData.gateways = {
                        //     last_update : null,
                        //     list        : mP.sessionData.gateways
                        // };

                        setLocalSelection(mP.initialSelectedIds);

                        setupSelection(mP.selection.ids, mP.sessionData);

                        console.log(mP.sessionData);
                        mP.initialSessionSitesListPromise.promise.then(function (list) {
                            mP.sitesList = list;
                            setDetailTitles();
                        });
                    };

                    mP.$onChanges = function (changes) {
                        //console.log('%c master p ', 'background: red; color: white');
                        //console.warn(changes);
                    };

                    mP.selectionUpdate = function (selection) {
                        //
                        // Use sessionparams instead of selection here?
                        //
                        setLocalSelection(Session.getUrlParamsUserSelection());

                        mP.onSelectionUpdate({ selection: selection });

                        setupSelection(mP.selection.ids);
                    };

                    // Master socket message watchers here
                    $scope.$on('event:socket:dezombified', function (event, siteId, gatewayId) {
                        console.log('Gateway dezombified', gatewayId);

                        if (siteId === mP.sessionData.id) {
                            var gwList = mP.sessionData.gateways;
                            var gwMatch = _.findIndex(gwList, { device_id: gatewayId });

                            if (gwMatch > -1) {
                                gwList[gwMatch].gateway_health = 1;
                                mP.sessionData.gateways = angular.copy(gwList);
                            }
                        }
                    });

                    $scope.$on('event:socket:setupMode', function (event, message, timestamp) {
                        console.log('Setup mode change', message);

                        if (message.site_id === mP.sessionData.id) {
                            var gwList = mP.sessionData.gateways;
                            var gwMatch = _.findIndex(gwList, { device_id: message.gateway_device_id });

                            if (gwMatch > -1) {
                                gwList[gwMatch].setup_mode = message.setup_mode;
                                mP.sessionData.gateways = angular.copy(gwList);
                            }
                        }
                    });

                    $scope.$on('event:panicMode', function (event, message) {
                        mP.sessionData.is_panic_mode = message;
                    });

                    $scope.$on('event:cache-update:sessionData', function (event, items, newItems) {
                        console.log('Update Event in MasterParent', items, newItems);
                        //
                        // For new items we push to new group at top of list
                        //

                        mP.sessionData = angular.copy(LcCache.getSessionSiteData());

                        if (newItems && newItems.length) {
                            //
                            _.each(newItems, function (item) {

                                if (item.constructor.name === 'Area') {
                                    pushNewGroup(item); //Do we even need to do this?
                                } else if (item.constructor.name === 'Site') {
                                        //Think of something good...
                                    } else {
                                            pushNewChild(item);
                                        }
                            });

                            if (newItems[0].section === $state.params.leftMenuSpecialContext) {
                                //
                                // Only navigate / refresh left list for matching item section                  
                                //                                                           
                                // - New area creation -?
                                setupSelection([newItems[0].id], mP.sessionData);
                            }
                        } else {
                            //
                            // List user stories here for left nav update
                            //
                            // 1 - Single or multi edit of device / zone property
                            //
                            // 2 - add any new item to the list?
                            //
                            // 3 - Drag and drop

                            // //
                            // // Navigate to first id ?
                            // //
                            var navigateId = items[0] ? items[0].id : null;

                            //
                            // Only navigate on item creation - maybe do this somewhere else?
                            //
                            //in order to solve losing track or item/items and zones settings,
                            //use last local selection,solved both problems
                            setLocalSelection(Session.getUrlParamsUserSelection());
                            setupSelection(mP.selection.ids, mP.sessionData);
                            setDetailTitles();
                        }
                    });

                    $scope.$on('event:cache-update:renameItem', function (event, item) {
                        console.log('Master Parent Rename Item', item);
                        renameItem(item);
                        setDetailTitles();
                    });

                    var NewItem = function NewItem(item) {
                        this.children = [];
                        this.count = 0;
                        this.description = LcFn.getName(item);
                        this.filterables = []; //Could use other items here
                        this.id = item.id;
                        this.index = 0;
                        this.level = 'level2';
                        this.parent = 'N';
                        this.selected = false;
                        this.title = LcFn.getName(item);
                    };

                    var NewGroup = function NewGroup(item) {
                        this.children = [new NewItem(item)];
                        this.description = 'New';
                        this.id = 'N';
                        this.index = 'N';
                        this.level = 'level1';
                        this.parent = null;
                        this.selected = false;
                        this.title = 'New';
                    };

                    function pushNewGroup(item) {
                        var updatedGroupList = getGroupList();
                        setGroupList(updatedGroupList);
                    }

                    function pushNewChild(item) {
                        var updatedGroupList = getGroupList();

                        var newGroupIndex = _.findIndex(updatedGroupList, { index: 'N' });

                        if (newGroupIndex > -1) {
                            updatedGroupList[newGroupIndex].children.unshift(new NewItem(item));
                        } else {
                            updatedGroupList.unshift(new NewGroup(item));
                        }

                        setGroupList(updatedGroupList);
                    }

                    // This is used to propagate item name changes to the parent component title
                    // to prevent re-display of stale cache.
                    function renameItem(item) {
                        var updatedGroupList = getGroupList();
                        // look through each group for the item with matching `id`
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = _getIterator(updatedGroupList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var groupItem = _step.value;

                                var updatedItem = _.find(groupItem.children, function (childItem) {
                                    return childItem.id === item.id;
                                });

                                // if no match, continue
                                if (!updatedItem) continue;

                                // we found the item! time to rename it.
                                updatedItem.name = item.name;
                                updatedItem.title = item.name;
                                updatedItem.description = item.name;
                                break;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator['return']) {
                                    _iterator['return']();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    function updateMasterSessionDataFromNetwork() {
                        return Session.getSiteData(true).then(function (data) {
                            mP.sessionData = data;
                            return data;
                        });
                    }

                    function getGroupList() {
                        return mP.groupList;
                    }

                    function setGroupList(list) {
                        $timeout(function () {

                            mP.groupList = list;
                        });
                    }

                    /**
                     * @constructor
                     * @description - Keep selection cache seperate to view should make some stuff a lot faster
                     */
                    var SelectionCache = function SelectionCache() {
                        //
                        //  Use new ES6 Set - lets us push() / add() without duplicates
                        //  3 levels is my arbitrary choice for now...
                        //
                        this.level1 = new _Set();
                        this.level2 = new _Set();
                        this.level3 = new _Set();
                    };

                    function setupSelection(selectionIds, sessionData) {
                        mP.selectionCache = new SelectionCache();

                        setSelectedIds(selectionIds);

                        tempCacheSelectedIds(selectionIds);

                        setListFilterBindings(sessionData, mP.user);
                    }

                    function tempCacheSelectedIds(ids) {
                        //
                        // @todo split ID's into levels - for now just use level2 (zone, device etc)
                        //
                        //
                        _.each(ids, function (id) {
                            mP.selectionCache.level2.add(id);
                        });
                    }

                    function updateSelectionCache(data) {
                        var cache = data.cache;
                        var action = data.action;
                        mP.selectionCache = cache;
                        //for mobile show all zones button

                        //
                        //
                        // @yuchau - use LcFn.mobileCheck here -
                        //           also we can get into a bad state on mobile with multiple transitions, need to rethink this
                        //
                        //
                        if (mP.multiSelectStatus && $window.innerWidth <= 479) {
                            if (action === 'mobileMultiSelection') {
                                mP.multiSelectStatus = false;
                                tempStateUpdate(mP.cacheHolder);
                            } else {
                                deepCopyCache(cache);
                                tempStateUpdate(cache);
                            }
                        } else {
                            if (action === 'mobileShowAllZones') {
                                mP.onSelectionUpdate({ selection: { mobile: true } });
                            } else {
                                //
                                // Is this temp still?
                                //
                                deepCopyCache(cache);
                                tempStateUpdate(cache);
                            }
                        }

                        setDetailTitles();
                    }

                    mP.onMultiSelectChange = function (mode) {
                        mP.multiSelectStatus = mode;
                    };

                    function deepCopyCache(cache) {
                        mP.cacheHolder = {
                            level1: new _Set(cache.level1),
                            level2: new _Set(cache.level2),
                            level3: new _Set(cache.level3)
                        };
                    }

                    function tempStateUpdate(cache) {
                        var ids = [].concat(_toConsumableArray(cache.level2));
                        var idsString = 'selection~' + ids.toString().replace(/,/g, '-');

                        gotoNewState(idsString, false, ids);
                    }

                    function gotoNewState(selectionString, createNew, ids) {
                        //
                        // Fire this now to transition faster - will get tagged again on final resolve
                        //
                        if (mP.multiSelectStatus && $window.innerWidth <= 479) {
                            mP.onSelectionUpdate({ selection: { filtered: ids ? ids.length : false, notFinishSelection: true } });
                        } else {
                            mP.onSelectionUpdate({ selection: { filtered: ids ? ids.length : false, 'new': createNew } });
                            $state.go('.', { userSelectedFilter: selectionString, 'new': createNew }).then(function (transition) {
                                //
                                // Session params saved by now
                                //
                                setLocalSelection(Session.getUrlParamsUserSelection());
                            });
                        }
                    }

                    function setLocalSelection(selection) {
                        mP.selection = selection;
                    }

                    function clearGotoBaseView(createNew) {
                        // Clear selection
                        clearSelectionCache();
                        // Goto Base

                        gotoNewState([], createNew);
                        // Republish bindings for leftNav etc
                        setListFilterBindings(null, mP.user);
                        mP.multiSelectStatus = false;
                    }

                    /**
                     * @public
                     * @return {Obj}
                     */
                    function getSelectionCache() {
                        return mP.selectionCache;
                    }

                    /**
                     * @public
                     */
                    function clearSelectionCache() {
                        console.log('Clearing selection cache');
                        mP.selectionCache = new SelectionCache();
                        mP.selectionTitleCache = null;
                    }

                    /**
                     * @public
                     * @desc    Get site data from parent controller
                     *          map data to smaller objects for nav list
                     *          Also arranges filters (saves re-mapping later)
                     *
                     *          Ideally the mapping is recursive (til depth of 5 or whatever)
                     *          but we need similar looking parent objects for this
                     *          eg areas.zones vs parentArea.childAreas
                     *
                     * @returns {Array} Formatted nav list and any allowed filters
                     */
                    //function getNavListAndFilters(){
                    // return getSiteData().then(siteData => {
                    //     return siteData ? ContextualMenusHelper[mP.viewNavContext](siteData,getSelectionCache()) : [];
                    // })

                    //ContextualMenusHelper[mP.viewNavContext](siteData,getSelectionCache());
                    //}

                    function setListFilterBindings(sessionData, user) {
                        var selectionCache = getSelectionCache();
                        var menuData = ContextualMenusHelper.getMenu(mP.viewNavContext, sessionData || mP.sessionData, selectionCache, user);
                        setGroupList(menuData[0]);
                        mP.filterOptions = menuData[1];
                    }

                    /**
                     * @public
                     * @return {Obj}
                     */
                    function setSelectedIds(ids) {
                        mP.selectedIds = ids;
                    }

                    /**
                     * @public
                     * @return {Obj}
                     */
                    function getSelectedIds() {
                        return mP.selectedIds;
                    }

                    //filter cache items' names with cache ids
                    function setDetailTitles() {
                        if (mP.groupList && mP.groupList.length > 0 && mP.selectionCache && mP.selectionCache.level2) {
                            mP.selectionTitleCache = [];
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                var _loop = function () {
                                    var cacheId = _step2.value;
                                    _iteratorNormalCompletion3 = true;
                                    _didIteratorError3 = false;
                                    _iteratorError3 = undefined;

                                    try {
                                        for (_iterator3 = _getIterator(mP.groupList); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                            var groupItem = _step3.value;

                                            var cacheTitle = _.find(groupItem.children, function (childItem) {
                                                return childItem.id === cacheId;
                                            });
                                            if (cacheTitle) {
                                                mP.selectionTitleCache.push(cacheTitle.title);
                                                break;
                                            }
                                        }

                                        //for main container header, 8 titles are maximum, use 10 in case they use super giant screen
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                                                _iterator3['return']();
                                            }
                                        } finally {
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }

                                    if (mP.selectionTitleCache.length > 9) {
                                        return 'break';
                                    }
                                };

                                for (var _iterator2 = _getIterator(mP.selectionCache.level2), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var _iteratorNormalCompletion3;

                                    var _didIteratorError3;

                                    var _iteratorError3;

                                    var _iterator3, _step3;

                                    var _ret = _loop();

                                    if (_ret === 'break') break;
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                                        _iterator2['return']();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }

                    // Temp
                    //
                    mP.onFilterUpdate = function (filters) {
                        mP.activeFilters = filters;
                    };

                    //
                    // Cache API
                    //
                    mP.updateSelectionCache = updateSelectionCache;
                    mP.getSelectionCache = getSelectionCache;
                    mP.clearSelectionCache = clearSelectionCache;

                    //
                    // Site Data & selections
                    //
                    mP.updateMasterSessionDataFromNetwork = updateMasterSessionDataFromNetwork;
                    mP.getSelectedIds = getSelectedIds;

                    // Router
                    mP.clearGotoBaseView = clearGotoBaseView;
                }
            };

            _export('default', leftNavComponent);
        }
    };
});

$__System.register('139', [], function (_export) {
    'use strict';

    var masterLeftComponent;
    return {
        setters: [],
        execute: function () {
            masterLeftComponent = {
                template: '<section ng-if="mL.isDevicesView"><!--\n         --><devices-sub-section-menu site-id="mL.siteId"></devices-sub-section-menu><!--\n         --><devices-setup-mode-section ng-if="mL.isOrgAdmin && mL.siteId && mL.gateways.length" gateways="mL.gateways" site-id="mL.siteId"></devices-setup-mode-section><!--\n     --></section><!--\n     --><left-nav-list\n            active-filters="mL.activeFilters"\n            allow-drag-drop="mL.allowDragDrop"\n            areas="mL.areas"\n            devices="mL.devices"\n            group-list="mL.groupList"\n            filter-options="mL.filterOptions"\n            nav-level-selection-cache="mL.selectionCache"\n            site-id="mL.siteId"\n            on-clear-goto-base-view="mL.clearToBase()"\n            on-clear-selection-cache="mL.onClearSelectionCache()"\n            on-filter-update="mL.onFilterUpdate(filters)"\n            on-update-selection-cache="mL.onUpdateSelectionCache({cache:cache,action:action})"\n            on-multi-select-change="mL.onMultiSelectChange({mode:mode})"\n            update-status="mL.updateStatus"\n            zones="mL.zones"\n            scenes="mL.scenes"\n            automations="mL.automations"\n            left-menu-special-context="mL.leftMenuSpecialContext"\n            multi-select-status="mL.multiSelectStatus"\n            sites="mL.sites"\n        ></left-nav-list>\n    ',
                bindings: {
                    allowDragDrop: '<',
                    activeFilters: '<',
                    areas: '<',
                    devices: '<',
                    gateways: '<',
                    groupList: '<',
                    filterOptions: '<',
                    filteredGroupList: '<',
                    menuOpen: '<',
                    selectionCache: '<',

                    siteId: '<',
                    updateStatus: '<',
                    user: '<',
                    zones: '<',
                    scenes: '<',
                    automations: '<',
                    leftMenuSpecialContext: '<',
                    multiSelectStatus: '<',
                    sites: '<',
                    //
                    // Out
                    //
                    onMenuToggle: '&',
                    onClearToBase: '&',
                    onClearSelectionCache: '&',
                    onNavFilterUpdate: '&',
                    onNavUpdateSelectionCache: '&',
                    onMultiSelectChange: '&'
                },
                controllerAs: 'mL',
                controller: function controller($location, LcFn) {

                    var mL = this;

                    mL.$onChanges = function (changes) {
                        //console.log('%c master left ', 'background: blue; color: white');
                        //console.warn(changes);
                    };

                    mL.isOrgAdmin = LcFn.isOrgAdmin(mL.user);

                    mL.clearToBase = function (createNew) {
                        //console.log('Clear command from masterLeft - will triger ui-route change');
                        mL.onClearToBase({ createNew: createNew });
                    };

                    mL.onFilterUpdate = function (filters) {
                        mL.onNavFilterUpdate({ filters: filters });
                    };

                    mL.onUpdateSelectionCache = function (cache) {
                        mL.onNavUpdateSelectionCache({ cache: cache });
                    };

                    mL.isDevicesView = checkDevicesView($location);

                    function checkDevicesView(location) {
                        return location.path().toString().includes('devices');
                    }
                }
            };

            _export('default', masterLeftComponent);
        }
    };
});

$__System.register('13a', [], function (_export) {
    'use strict';

    var masterRightComponent;
    return {
        setters: [],
        execute: function () {
            masterRightComponent = {
                template: '\n        <div class="master-right-container">\n            <header class="main-header">\n                <button class="btn-left-arrow" ng-if="mR.selection.filtered || mR.isMobile" ng-click="mR.clearToBase();"></button>\n                <h1 ng-bind="mR.selection.title" ng-if="!mR.cacheTitles"></h1>\n                <h1 ng-if="mR.cacheTitles" class="multi-select-titles">\n                    <span ng-repeat="title in mR.cacheTitles">{{title}}</span>\n                </h1>\n                <button class="btn clear-selection right" ng-if="mR.selection.allowNew" ng-click="mR.clearToBase(true);">+ New</button>\n                <button class="btn clear-selection right clear-btn" ng-if="mR.selection.filtered" ng-click="mR.clearToBase();">Clear Selection</button>\n            </header>\n\n            <div class="overview-wrapper">\n                <div class="overview-container">\n                    <ui-view gateways="mR.gateways" on-clear-to-base="mR.onClearToBase(createNew)" on-selection-update="mR.selectionUpdate(selection)" user="mR.user"></ui-view>\n                </div>\n            </div>\n        </div>\n    ',
                bindings: {
                    cacheTitles: '<',
                    gateways: '<',
                    user: '<',
                    onClearToBase: '&',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'mR',
                controller: function controller(LcFn) {

                    var mR = this;

                    //
                    //  Child states have to publish their item collections as this resolve is below master state and won't be updated
                    //
                    mR.$onChanges = function (changes) {
                        //console.log('%c master right ', 'background: #222; color: #bada55');
                        // console.log(changes)
                    };

                    mR.isMobile = LcFn.mobileCheck();

                    mR.selectionUpdate = function (selection) {
                        mR.selection = selection;
                        //mR.title = selection.title;
                        //mR.selectionSize = selection.group ? selection.group.length : 0;
                        mR.onSelectionUpdate({ selection: selection });
                    };

                    mR.clearToBase = function (createNew) {
                        console.log('Clear command from masterRight - will triger ui-route change');
                        mR.onClearToBase({ createNew: createNew });
                    };
                }
            };

            _export('default', masterRightComponent);
        }
    };
});

$__System.register('13b', ['12', '13'], function (_export) {
    var _createClass, _classCallCheck, StructureService;

    return {
        setters: [function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }],
        execute: function () {
            'use strict';

            StructureService = (function () {
                function StructureService(Session, LcFn) {
                    _classCallCheck(this, StructureService);

                    this.Session = Session;
                    this.LcFn = LcFn;
                }

                _createClass(StructureService, [{
                    key: 'itemCollection',
                    value: function itemCollection(sessionData, context, $stateParams) {
                        //
                        //  Let users enter + delimited obj id's (and maybe area id_strings?) into adress bar to filter
                        //  their usage data
                        //
                        var siteName = sessionData ? sessionData.id_string : '';

                        return sessionData ? this.getSelection($stateParams, sessionData[context], siteName, context) : { group: [], title: '', filtered: false };
                    }
                }, {
                    key: 'getContextualDefaultSelection',
                    value: function getContextualDefaultSelection(contextualSiteData, context) {
                        var defaultSelection = contextualSiteData;

                        if (context === 'scenes' || context === 'schedules') {
                            defaultSelection = [];
                        }

                        return defaultSelection;
                    }
                }, {
                    key: 'getSelection',
                    value: function getSelection($stateParams, contextualSiteData, siteName, context) {
                        //
                        // Ideally on a dynamic update we would re-resolve the selectedIds
                        // ui-router parent resolves are 'retained' - so no update will happen
                        // see https://github.com/angular-ui/ui-router/issues/2520 / 2424 / 3210 /
                        //
                        // Use ids here for now - but getUrlParamsUserSelection() supports passing areas too
                        //
                        var urlParams = this.Session.getUrlParamsUserSelection();

                        //
                        // Why use this instead of $stateParams ?
                        //

                        var newItem = urlParams['new'];
                        var allowNew = urlParams.allowNew;
                        var selectedIds = urlParams.ids;

                        var matchingItemCollection = [];

                        if (selectedIds && selectedIds.length) {
                            matchingItemCollection = _.filter(contextualSiteData, function (obj) {
                                return selectedIds.indexOf(obj.id) > -1; // || userSelection.indexOf(obj.id_string) > -1;
                            });
                        }

                        //
                        // If nothing is selected - return everything for base view ?
                        //
                        var group = matchingItemCollection.length ? matchingItemCollection : contextualSiteData;

                        var filtered = matchingItemCollection.length > 0;

                        //
                        // Set title to site unless specific title or group selected
                        //
                        var title = siteName;

                        // If resolving from an error state - no collection/group
                        if (group) {
                            if (group.length === 1) {
                                // One item - grab name
                                title = this.LcFn.getName(group[0]);
                            } else if (group.length > 1 && filtered) {
                                //Multi items
                                title = this.collectionTitle(group, context);
                            }
                        }

                        return { group: group, title: title, filtered: filtered, 'new': newItem, allowNew: allowNew };
                    }
                }, {
                    key: 'collectionTitle',
                    value: function collectionTitle(collection, context) {
                        return context.charAt(0).toUpperCase() + context.slice(1) + ' selected: ' + _.map(collection, function (obj) {
                            return obj.id;
                        }).toString();
                    }
                }]);

                return StructureService;
            })();

            _export('default', StructureService);
        }
    };
});

$__System.register('13c', [], function (_export) {
  'use strict';

  // -------------------
  //
  // /site/ base for all component routing
  //
  // -------------------

  var structureStates;
  return {
    setters: [],
    execute: function () {
      structureStates = {
        abstract: true,
        name: 'site',
        url: '/site/{siteId:[0-9]{1,24}}',
        resolve: {
          //Resolve site data
          initialSessionData: function initialSessionData($stateParams, $state$, $transition$, $q, $rootScope, Session, LcCache) {

            var to = $transition$.to();
            var toParams = $transition$.params('to');
            var fromState = $transition$.from();
            var fromParams = $transition$.params('from');
            var extraSections = to.params.extraSections || null;

            console.log('Initial Session Data in Structure Service');

            //
            //
            // Set up master view session data and extra sections required
            //
            //
            return Session.getSiteData(true, extraSections).then(function (data) {
              //
              // Kick off site list process for menu
              // Is a promise but we won't hold the resolve on it, can swap to eager resolves ?
              //
              if (data.org) {
                console.log('Master Structure state change here...');

                LcCache.setCurrentOrg(data.org);
              }

              return data;
            })['catch'](function (error) {
              console.log(error);
              throw error;
            });
          },
          initialSessionSitesListPromise: function initialSessionSitesListPromise(initialSessionData, Session, $q) {
            var sitesListDeferred = $q.defer();

            Session.getSitesList(initialSessionData.id, initialSessionData.org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            });

            return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
          },
          initialSelectedIds: function initialSelectedIds($stateParams, Session) {
            return Session.getUrlParamsUserSelection();
          },
          viewNavContext: function viewNavContext($stateParams) {
            //
            // Some views will require different arrangements than default listed below
            //
            // - 'default' ('grouped-zones' view)
            // - 'devices'
            // - 'scenes'
            //
            return $stateParams.leftMenuSpecialContext ? $stateParams.leftMenuSpecialContext : 'default';
          }
        },

        component: 'masterParent',

        params: {
          section: {
            value: null,
            dynamic: true
          },

          siteId: null,

          userSelectedFilter: {
            value: null,
            dynamic: true
          },

          leftMenuSpecialContext: 'default'

        },
        title: 'Master'
      };

      _export('structureStates', structureStates);
    }
  };
});

$__System.register('13d', ['3', '125', '130', '138', '139', '12d', '12e', '12f', '13a', '13b', '13c'], function (_export) {

    //import leftNavHeaderComponent from './left-nav-header/leftNavHeaderComponent';

    'use strict';

    var angular, lcAuthAppComponent, masterParentComponent, masterLeftComponent, lcAppComponent, lcNoAuthComponent, masterRightComponent, StructureService, structureStates, structureModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {}, function (_3) {
            lcAuthAppComponent = _3['default'];
        }, function (_4) {
            masterParentComponent = _4['default'];
        }, function (_5) {
            masterLeftComponent = _5['default'];
        }, function (_d) {}, function (_e) {
            lcAppComponent = _e['default'];
        }, function (_f) {
            lcNoAuthComponent = _f['default'];
        }, function (_a) {
            masterRightComponent = _a['default'];
        }, function (_b) {
            StructureService = _b['default'];
        }, function (_c) {
            structureStates = _c.structureStates;
        }],
        execute: function () {
            structureModule = angular.module('structure', ['left-nav-list', 'top-menu']).component('lcApp', lcAppComponent).component('lcNoAuth', lcNoAuthComponent).component('lcAuthApp', lcAuthAppComponent).component('masterParent', masterParentComponent).component('masterLeft', masterLeftComponent).component('masterRight', masterRightComponent)

            //.component('leftNavHeader', leftNavHeaderComponent)

            .service('StructureService', StructureService).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(structureStates);
            }]);

            _export('default', structureModule);
        }
    };
});

$__System.register('13e', [], function (_export) {
        'use strict';

        function Track($window, $location, $rootScope) {

                //AdBlock etc kills Google Analytics
                var ga = function ga() {
                        if ($window.ga) {
                                $window.ga.apply(arguments);
                        } else {
                                console.log('Event blocked by client (probably AdBlock)', arguments);
                        }
                };

                this.register = function () {
                        if ($location.host().indexOf('control') > -1) {
                                ga('create', 'UA-60313476-4', 'auto'); //Live
                        } else if ($location.host().indexOf('stag') > -1) {
                                        ga('create', 'UA-60313476-3', 'auto'); //Stage - 'stag' covers stage and staging
                                } else {
                                                ga('create', 'UA-60313476-2', 'auto'); //Dev
                                        }
                };

                this.event = function (category, action, label, value, fieldsObj) {
                        var gaLabel = label ? label : $rootScope.currentSite ? $rootScope.currentSite.id_string : 'No Label';

                        ga('send', 'event', category, action, gaLabel, value, fieldsObj);
                };
        }

        return {
                setters: [],
                execute: function () {
                        Track.$inject = ['$window', '$location', '$rootScope'];
                        _export('default', Track);
                }
        };
});

$__System.register('13f', ['3', '13e'], function (_export) {
    'use strict';

    var angular, trackService, trackModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_e) {
            trackService = _e['default'];
        }],
        execute: function () {
            trackModule = angular.module('track', []).service('Track', trackService);

            _export('default', trackModule);
        }
    };
});

$__System.register('140', [], function (_export) {
    /*
    
    Take any promise to save something with the backend and offer an undo option
    
    Requires group of change promises, and group of matching original objects 
    
    */

    'use strict';

    function Undo($rootScope, _, $q, Modals) {

        var actionQueue = [];
        var undoQueue = [];

        this.queueActions = function (ajClass, ajAction, updateObjects, originalObjects, deferred) {
            /*
                Example updateObjects:
                
                {
                    ajax: [{
                        ajClass      : Devices,
                        ajAction     : 'update'
                        ajObject     : {id: 1, id_string: 'New Name'...}
                        originalObj  : {id: 1, id_string: 'Exisiting Name'...}
                    }],
                    controlDeferred: deferred
                }
                 If multi-editing, the ajax array will be all device updates, but only one deferred
                for the control gray-out
             */
            function getExisitingReq(exisitingQueue, newUpdateGroup) {
                //
                // While we wait for batch from BE, combine device edits if same device is in queue
                //
                return _.find(exisitingQueue, function (group) {
                    return _.isEqual(_.map(group.ajax, function (item) {
                        return item.ajObject.uuid;
                    }), _.map(newUpdateGroup, 'uuid'));
                });
            }

            function mapAjax(ajClass, ajAction, updateObjects, originalObjects) {
                return _.map(updateObjects, function (updateObject, index) {
                    return {
                        ajClass: ajClass,
                        ajAction: ajAction,
                        ajObject: angular.copy(updateObject),
                        originalObj: originalObjects[index] ? angular.copy(originalObjects[index]) : null
                    };
                });
            }
            //
            //
            // We can remove below if statement when we have batch update
            //
            //

            var matchingReqGroup = getExisitingReq(getActionQueue(), updateObjects);

            if (matchingReqGroup) {
                matchingReqGroup.ajax = mapAjax(ajClass, ajAction, updateObjects, originalObjects);
                matchingReqGroup.controlDeferredGroup.push(deferred);
            } else {
                var promiseGroup = [{
                    ajax: mapAjax(ajClass, ajAction, updateObjects, originalObjects),
                    controlDeferredGroup: [deferred]
                }];

                setActionQueue(getActionQueue().concat(promiseGroup));
            }

            console.log('Actions queued', getActionQueue());

            //
            // Was returning a promise here but it's a sync action
            //
            $rootScope.$broadcast('undo:showConfirm');
        };

        this.clearActionQueue = function (outcome) {
            clearActionQueue(outcome);
        };

        this.runQueue = function () {

            var promiseQueue = mapPromiseQueueParent(getActionQueue(), 'ajax-success');

            undoQueue = buildUndoActions(getActionQueue());

            return $q.all(promiseQueue).then(function () {
                // Dont use clearActionQueue, we want to keep the promises
                getActionQueue().length = 0;

                // - Crud complete
                //   Decide if we can offer an undo
                return undoQueue.length;
            })['catch'](function () {
                //console.log(error);
            });
        };

        this.undoLast = function () {
            var _this = this;

            console.log('Undo queue is:', undoQueue);

            var promiseQueue = mapPromiseQueueParent(undoQueue, 'ajax-undo-success');

            return $q.all(promiseQueue).then(function () {
                //
                console.log('Undo actions');
                _this.clearUndoQueue();
            });
        };

        this.clearUndoQueue = function () {
            clearUndoQueue();
        };

        this.checkOutstanding = function () {
            return getActionQueue().length ? promptSave() : $q.resolve();
        };

        function setActionQueue(queue) {
            actionQueue = queue;
        }

        function getActionQueue() {
            return actionQueue;
        }

        function clearUndoQueue() {
            clearQueue(undoQueue, 'resolve');
        }

        function clearActionQueue(outcome) {
            clearQueue(getActionQueue(), outcome);
            setActionQueue([]);
        }

        function promptSave() {
            //
            // Use old modal for now
            //
            return Modals.confirm($rootScope, 'Go Back', 'Leave without saving', 'You have outstanding changes, do you want to leave them?').then(function (result) {
                // We really want to leave!
                clearActionQueue('reject');
                clearUndoQueue();

                return true;
            })['catch'](function () {
                return false;
            });
        }

        function clearQueue(queue, outcome) {
            // - Clear
            _.each(queue, function (item) {
                deferredGroupAction(item.controlDeferredGroup, outcome);
            });

            queue.length = 0;
        }

        function deferredGroupAction(group, action, optMessage) {
            _.each(group, function (deferred) {
                deferred[action](optMessage);
            });
        }

        function mapPromiseQueueParent(queue, notifyMessage) {
            //
            //
            // @todo combine group reqs to same device / zone while we wait for batch endpoint
            //
            //
            return _.map(queue, function (item) {
                // Notify control item(s)
                deferredGroupAction(item.controlDeferredGroup, 'notify', 'ajax-start');

                return $q.all(mapPromiseQueueChild(item.ajax)).then(function () {
                    // Don't resolve here, leave that for the undo action
                    deferredGroupAction(item.controlDeferredGroup, 'notify', notifyMessage);
                })['catch'](function (error) {
                    deferredGroupAction(item.controlDeferredGroup, 'reject', error);
                });
            });
        }

        function mapPromiseQueueChild(queue) {
            return _.map(queue, function (queuedAction) {
                return queuedAction.ajClass[queuedAction.ajAction](queuedAction.ajObject);
            });
        }

        function checkForOriginals(queue) {
            return _.every(queue, function (item) {
                return _.every(item.ajax, 'originalObj');
            });
        }

        function buildUndoActions(actionQueue) {
            var undoQueue = [];
            //
            // - Only offer undo for now if all actions in group can be reversed
            //
            if (checkForOriginals(actionQueue)) {

                undoQueue = _.map(actionQueue, function (queuedAction) {
                    return {
                        ajax: _.map(queuedAction.ajax, function (ajaxObj) {
                            //
                            // - Have to name our ajax funcs in the services for this to work
                            //let actionName = queuedAction.ajClass.name;

                            var inverseAction = 'update';
                            //
                            // Update reverted with same action
                            //
                            // - Delete = Create, Create = Delete...
                            //
                            if (ajaxObj.ajAction === 'create') {
                                inverseAction = 'delete';
                            } else if (ajaxObj.ajAction === 'delete') {
                                inverseAction = 'create';
                            }

                            return {
                                ajClass: ajaxObj.ajClass,
                                ajAction: inverseAction,
                                ajObject: angular.copy(ajaxObj.originalObj),
                                originalObj: angular.copy(ajaxObj.ajObject)
                            };
                        }),
                        controlDeferredGroup: queuedAction.controlDeferredGroup
                    };
                });
            }

            return undoQueue;
        }
    }

    return {
        setters: [],
        execute: function () {
            Undo.$inject = ['$rootScope', '_', '$q', 'Modals'];
            _export('default', Undo);
        }
    };
});

$__System.register('141', [], function (_export) {
    'use strict';

    var undoPupupComponent;
    return {
        setters: [],
        execute: function () {
            undoPupupComponent = {
                template: '\n        <section class="bottom-notice undo" ng-if="uP.show">\n                        \n            <!-- Offer a Redo option coming soon to a lightcloud near you\n            <button class="btn right" ng-click="uP.redo()" ng-if="uP.offerRedo" ng-disabled="uP.pending" class="">Redo Changes</button>\n            -->\n\n            <section ng-if="uP.undoSuccess">\n                <button class="btn right" ng-click="uP.dismissUndoSuccess()" class="" translate="common.dismiss">Dismiss</button>\n\n                <span class="msg-content">\n                    <span translate="">Changes reverted.</span>\n                </span>\n            </section>\n\n            <section ng-if="uP.saveSuccess">\n                <button class="btn right" ng-click="uP.dismissUndo()" class="" translate="common.dismiss">Dismiss</button>\n                <button class="btn right" ng-click="uP.undo()" ng-disabled="uP.pending" ng-if="uP.offerUndo" class="">Undo Changes</button>\n\n                <span class="msg-content">\n                    <span translate="">All changes saved.</span>\n                </span>\n            </section>\n\n            <section ng-if="uP.offerSave">\n                <button class="btn right" ng-click="uP.cancel();" class="" translate="common.cancel">Cancel</button>\n                <button class="btn right" ng-click="uP.save()" ng-disabled="uP.pending" class="">Save Changes</button>\n\n                <span class="msg-content">\n                    <span translate="">Do you want to save changes?</span>\n                </span>\n            </section>\n        </section>\n    ',
                controllerAs: 'uP',
                controller: function controller($state, $rootScope, $timeout, Undo) {
                    //
                    var uP = this;

                    var confirmListener = $rootScope.$on('undo:showConfirm', function (scope) {
                        console.log('undo event broadcast');
                        uP.saveSuccess = false;
                        uP.offerUndo = false;
                        uP.undoSuccess = false;
                        uP.offerSave = true;

                        $timeout(function () {
                            uP.show = true;
                        });
                        /* Could use a promise chain for all of this, but while its a serial queue theres no point */
                    });

                    uP.$onInit = function () {
                        reset();
                    };

                    uP.$onDestroy = function () {
                        confirmListener();
                    };

                    uP.save = function () {
                        uP.pending = true;
                        Undo.runQueue().then(function (undoAvailable) {
                            uP.saveSuccess = true;

                            if (undoAvailable) {
                                uP.offerUndo = true;
                            }

                            uP.undoSuccess = false;
                            uP.offerSave = false;
                            uP.pending = false;
                        });
                    };

                    uP.undo = function () {
                        uP.pending = true;
                        Undo.undoLast().then(function () {
                            //
                            //
                            //
                            uP.saveSuccess = false;
                            uP.undoSuccess = true;
                            uP.offerUndo = false;
                            uP.pending = false;
                        });
                    };

                    uP.dismissUndo = function () {
                        Undo.clearUndoQueue();
                        reset();
                    };

                    uP.dismissUndoSuccess = function () {
                        reset();
                    };

                    uP.cancel = function () {
                        Undo.clearActionQueue('reject');
                        reset();
                    };

                    function reset() {
                        uP.saveSuccess = false;
                        uP.undoSuccess = false;
                        uP.offerUndo = false;
                        uP.offerSave = false;
                        uP.show = false;
                    }
                }
            };

            _export('default', undoPupupComponent);
        }
    };
});

$__System.register('142', ['3', '140', '141'], function (_export) {
    'use strict';

    var angular, undoService, undoPopupComponent, undoModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            undoService = _2['default'];
        }, function (_3) {
            undoPopupComponent = _3['default'];
        }],
        execute: function () {
            undoModule = angular.module('undo', []).component('undoPopup', undoPopupComponent).service('Undo', undoService);

            _export('default', undoModule);
        }
    };
});

$__System.registerDynamic("143", ["144", "145", "146", "147"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("144"));
  __export($__require("145"));
  __export($__require("146"));
  __export($__require("147"));
});
$__System.registerDynamic("148", ["149", "14a"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("149"));
  __export($__require("14a"));
});
$__System.registerDynamic("14b", ["14c", "14d", "14e", "14f", "150", "151", "152"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("14c"));
  __export($__require("14d"));
  __export($__require("14e"));
  __export($__require("14f"));
  __export($__require("150"));
  __export($__require("151"));
  __export($__require("152"));
});
$__System.registerDynamic("153", ["154", "155", "156", "157", "158", "159", "15a", "15b"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("154"));
  __export($__require("155"));
  __export($__require("156"));
  __export($__require("157"));
  __export($__require("158"));
  __export($__require("159"));
  __export($__require("15a"));
  __export($__require("15b"));
});
$__System.registerDynamic("15c", ["15d", "15e", "15f", "160", "161"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("15d"));
  __export($__require("15e"));
  __export($__require("15f"));
  __export($__require("160"));
  __export($__require("161"));
});
$__System.registerDynamic("162", ["163"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("163"));
});
$__System.registerDynamic("145", ["164", "165", "166", "167", "147"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var hof_1 = $__require("166");
  var coreservices_1 = $__require("167");
  var paramType_1 = $__require("147");
  var ParamTypes = function () {
    function ParamTypes() {
      this.enqueue = true;
      this.typeQueue = [];
      this.defaultTypes = common_1.pick(ParamTypes.prototype, ['hash', 'string', 'query', 'path', 'int', 'bool', 'date', 'json', 'any']);
      var makeType = function (definition, name) {
        return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
      };
      this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
    }
    ParamTypes.prototype.dispose = function () {
      this.types = {};
    };
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
      if (!predicates_1.isDefined(definition)) return this.types[name];
      if (this.types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
      this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
      if (definitionFn) {
        this.typeQueue.push({
          name: name,
          def: definitionFn
        });
        if (!this.enqueue) this._flushTypeQueue();
      }
      return this;
    };
    ParamTypes.prototype._flushTypeQueue = function () {
      while (this.typeQueue.length) {
        var type = this.typeQueue.shift();
        if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
        common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
      }
    };
    return ParamTypes;
  }();
  exports.ParamTypes = ParamTypes;
  function initDefaultTypes() {
    var makeDefaultType = function (def) {
      var valToString = function (val) {
        return val != null ? val.toString() : val;
      };
      var defaultTypeBase = {
        encode: valToString,
        decode: valToString,
        is: hof_1.is(String),
        pattern: /.*/,
        equals: function (a, b) {
          return a == b;
        }
      };
      return common_1.extend({}, defaultTypeBase, def);
    };
    common_1.extend(ParamTypes.prototype, {
      string: makeDefaultType({}),
      path: makeDefaultType({ pattern: /[^/]*/ }),
      query: makeDefaultType({}),
      hash: makeDefaultType({ inherit: false }),
      int: makeDefaultType({
        decode: function (val) {
          return parseInt(val, 10);
        },
        is: function (val) {
          return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
        },
        pattern: /-?\d+/
      }),
      bool: makeDefaultType({
        encode: function (val) {
          return val && 1 || 0;
        },
        decode: function (val) {
          return parseInt(val, 10) !== 0;
        },
        is: hof_1.is(Boolean),
        pattern: /0|1/
      }),
      date: makeDefaultType({
        encode: function (val) {
          return !this.is(val) ? undefined : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
        },
        decode: function (val) {
          if (this.is(val)) return val;
          var match = this.capture.exec(val);
          return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
        },
        is: function (val) {
          return val instanceof Date && !isNaN(val.valueOf());
        },
        equals: function (l, r) {
          return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) {
            return acc && l[fn]() === r[fn]();
          }, true);
        },
        pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
        capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
      }),
      json: makeDefaultType({
        encode: common_1.toJson,
        decode: common_1.fromJson,
        is: hof_1.is(Object),
        equals: common_1.equals,
        pattern: /[^/]*/
      }),
      any: makeDefaultType({
        encode: common_1.identity,
        decode: common_1.identity,
        is: function () {
          return true;
        },
        equals: common_1.equals
      })
    });
  }
  initDefaultTypes();
});
$__System.registerDynamic("15e", ["164", "165", "15d", "144", "145"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var urlMatcher_1 = $__require("15d");
  var param_1 = $__require("144");
  var paramTypes_1 = $__require("145");
  var UrlMatcherFactory = function () {
    function UrlMatcherFactory() {
      var _this = this;
      this.paramTypes = new paramTypes_1.ParamTypes();
      this._isCaseInsensitive = false;
      this._isStrictMode = true;
      this._defaultSquashPolicy = false;
      this.paramFactory = {
        fromConfig: function (id, type, config) {
          return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
        },
        fromPath: function (id, type, config) {
          return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
        },
        fromSearch: function (id, type, config) {
          return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
        }
      };
      this._getConfig = function (config) {
        return common_1.extend({
          strict: _this._isStrictMode,
          caseInsensitive: _this._isCaseInsensitive
        }, config);
      };
      common_1.extend(this, {
        UrlMatcher: urlMatcher_1.UrlMatcher,
        Param: param_1.Param
      });
    }
    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
      return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
    };
    UrlMatcherFactory.prototype.strictMode = function (value) {
      return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
    };
    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
      if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
      return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
    };
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
      return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
    };
    UrlMatcherFactory.prototype.isMatcher = function (object) {
      if (!predicates_1.isObject(object)) return false;
      var result = true;
      common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
        if (predicates_1.isFunction(val)) result = result && predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]);
      });
      return result;
    };
    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
      var type = this.paramTypes.type(name, definition, definitionFn);
      return !predicates_1.isDefined(definition) ? type : this;
    };
    UrlMatcherFactory.prototype.$get = function () {
      this.paramTypes.enqueue = false;
      this.paramTypes._flushTypeQueue();
      return this;
    };
    UrlMatcherFactory.prototype.dispose = function () {
      this.paramTypes.dispose();
    };
    return UrlMatcherFactory;
  }();
  exports.UrlMatcherFactory = UrlMatcherFactory;
});
$__System.registerDynamic("15d", ["164", "166", "165", "144", "168", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var common_1 = $__require("164");
    var hof_1 = $__require("166");
    var predicates_1 = $__require("165");
    var param_1 = $__require("144");
    var strings_1 = $__require("168");
    function quoteRegExp(str, param) {
      var surroundPattern = ['', ''],
          result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
      if (!param) return result;
      switch (param.squash) {
        case false:
          surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
          break;
        case true:
          result = result.replace(/\/$/, '');
          surroundPattern = ['(?:\/(', ')|\/)?'];
          break;
        default:
          surroundPattern = ["(" + param.squash + "|", ')?'];
          break;
      }
      return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
    }
    var memoizeTo = function (obj, _prop, fn) {
      return obj[_prop] = obj[_prop] || fn();
    };
    var splitOnSlash = strings_1.splitOnDelim('/');
    var UrlMatcher = function () {
      function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        this.config = config;
        this._cache = { path: [this] };
        this._children = [];
        this._params = [];
        this._segments = [];
        this._compiled = [];
        this.pattern = pattern;
        this.config = common_1.defaults(this.config, {
          params: {},
          strict: true,
          caseInsensitive: false,
          paramMap: common_1.identity
        });
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
        var patterns = [];
        var last = 0,
            matchArray;
        var checkParamErrors = function (id) {
          if (!UrlMatcher.nameValidator.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
          if (common_1.find(_this._params, hof_1.propEq('id', id))) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        var matchDetails = function (m, isSearch) {
          var id = m[2] || m[3];
          var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
          var makeRegexpType = function (str) {
            return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), { pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined) });
          };
          return {
            id: id,
            regexp: regexp,
            cfg: _this.config.params[id],
            segment: pattern.substring(last, m.index),
            type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
          };
        };
        var p, segment;
        while (matchArray = placeholder.exec(pattern)) {
          p = matchDetails(matchArray, false);
          if (p.segment.indexOf('?') >= 0) break;
          checkParamErrors(p.id);
          this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
          this._segments.push(p.segment);
          patterns.push([p.segment, common_1.tail(this._params)]);
          last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        var i = segment.indexOf('?');
        if (i >= 0) {
          var search = segment.substring(i);
          segment = segment.substring(0, i);
          if (search.length > 0) {
            last = 0;
            while (matchArray = searchPlaceholder.exec(search)) {
              p = matchDetails(matchArray, true);
              checkParamErrors(p.id);
              this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
              last = placeholder.lastIndex;
            }
          }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function (_pattern) {
          return quoteRegExp.apply(null, _pattern);
        }).concat(quoteRegExp(segment));
      }
      UrlMatcher.encodeDashes = function (str) {
        return encodeURIComponent(str).replace(/-/g, function (c) {
          return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase();
        });
      };
      UrlMatcher.pathSegmentsAndParams = function (matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function (p) {
          return p.location === param_1.DefType.PATH;
        });
        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined)).reduce(common_1.unnestR, []).filter(function (x) {
          return x !== '' && predicates_1.isDefined(x);
        });
      };
      UrlMatcher.queryParams = function (matcher) {
        return matcher._params.filter(function (p) {
          return p.location === param_1.DefType.SEARCH;
        });
      };
      UrlMatcher.compare = function (a, b) {
        var segments = function (matcher) {
          return matcher._cache.segments = matcher._cache.segments || matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []).reduce(strings_1.joinNeighborsR, []).map(function (x) {
            return predicates_1.isString(x) ? splitOnSlash(x) : x;
          }).reduce(common_1.unnestR, []);
        };
        var weights = function (matcher) {
          return matcher._cache.weights = matcher._cache.weights || segments(matcher).map(function (segment) {
            if (segment === '/') return 1;
            if (predicates_1.isString(segment)) return 2;
            if (segment instanceof param_1.Param) return 3;
          });
        };
        var padArrays = function (l, r, padVal) {
          var len = Math.max(l.length, r.length);
          while (l.length < len) l.push(padVal);
          while (r.length < len) r.push(padVal);
        };
        var weightsA = weights(a),
            weightsB = weights(b);
        padArrays(weightsA, weightsB, 0);
        var _pairs = common_1.arrayTuples(weightsA, weightsB);
        var cmp, i;
        for (i = 0; i < _pairs.length; i++) {
          cmp = _pairs[i][0] - _pairs[i][1];
          if (cmp !== 0) return cmp;
        }
        return 0;
      };
      UrlMatcher.prototype.append = function (url) {
        this._children.push(url);
        url._cache = {
          path: this._cache.path.concat(url),
          parent: this,
          pattern: null
        };
        return url;
      };
      UrlMatcher.prototype.isRoot = function () {
        return this._cache.path[0] === this;
      };
      UrlMatcher.prototype.toString = function () {
        return this.pattern;
      };
      UrlMatcher.prototype.exec = function (path, search, hash, options) {
        var _this = this;
        if (search === void 0) {
          search = {};
        }
        if (options === void 0) {
          options = {};
        }
        var match = memoizeTo(this._cache, 'pattern', function () {
          return new RegExp(['^', common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''), _this.config.strict === false ? '\/?' : '', '$'].join(''), _this.config.caseInsensitive ? 'i' : undefined);
        }).exec(path);
        if (!match) return null;
        var allParams = this.parameters(),
            pathParams = allParams.filter(function (param) {
          return !param.isSearch();
        }),
            searchParams = allParams.filter(function (param) {
          return param.isSearch();
        }),
            nPathSegments = this._cache.path.map(function (urlm) {
          return urlm._segments.length - 1;
        }).reduce(function (a, x) {
          return a + x;
        }),
            values = {};
        if (nPathSegments !== match.length - 1) throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(paramVal) {
          var reverseString = function (str) {
            return str.split('').reverse().join('');
          };
          var unquoteDashes = function (str) {
            return str.replace(/\\-/g, '-');
          };
          var split = reverseString(paramVal).split(/-(?!\\)/);
          var allReversed = common_1.map(split, reverseString);
          return common_1.map(allReversed, unquoteDashes).reverse();
        }
        for (var i = 0; i < nPathSegments; i++) {
          var param = pathParams[i];
          var value = match[i + 1];
          for (var j = 0; j < param.replace.length; j++) {
            if (param.replace[j].from === value) value = param.replace[j].to;
          }
          if (value && param.array === true) value = decodePathArray(value);
          if (predicates_1.isDefined(value)) value = param.type.decode(value);
          values[param.id] = param.value(value);
        }
        searchParams.forEach(function (param) {
          var value = search[param.id];
          for (var j = 0; j < param.replace.length; j++) {
            if (param.replace[j].from === value) value = param.replace[j].to;
          }
          if (predicates_1.isDefined(value)) value = param.type.decode(value);
          values[param.id] = param.value(value);
        });
        if (hash) values['#'] = hash;
        return values;
      };
      UrlMatcher.prototype.parameters = function (opts) {
        if (opts === void 0) {
          opts = {};
        }
        if (opts.inherit === false) return this._params;
        return common_1.unnest(this._cache.path.map(function (matcher) {
          return matcher._params;
        }));
      };
      UrlMatcher.prototype.parameter = function (id, opts) {
        var _this = this;
        if (opts === void 0) {
          opts = {};
        }
        var findParam = function () {
          for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
            var param = _a[_i];
            if (param.id === id) return param;
          }
        };
        var parent = this._cache.parent;
        return findParam() || opts.inherit !== false && parent && parent.parameter(id, opts) || null;
      };
      UrlMatcher.prototype.validates = function (params) {
        var validParamVal = function (param, val) {
          return !param || param.validates(val);
        };
        params = params || {};
        var paramSchema = this.parameters().filter(function (paramDef) {
          return params.hasOwnProperty(paramDef.id);
        });
        return paramSchema.map(function (paramDef) {
          return validParamVal(paramDef, params[paramDef.id]);
        }).reduce(common_1.allTrueR, true);
      };
      UrlMatcher.prototype.format = function (values) {
        if (values === void 0) {
          values = {};
        }
        var urlMatchers = this._cache.path;
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []).map(function (x) {
          return predicates_1.isString(x) ? x : getDetails(x);
        });
        var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(common_1.unnestR, []).map(getDetails);
        var isInvalid = function (param) {
          return param.isValid === false;
        };
        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
          return null;
        }
        function getDetails(param) {
          var value = param.value(values[param.id]);
          var isValid = param.validates(value);
          var isDefaultValue = param.isDefaultValue(value);
          var squash = isDefaultValue ? param.squash : false;
          var encoded = param.type.encode(value);
          return {
            param: param,
            value: value,
            isValid: isValid,
            isDefaultValue: isDefaultValue,
            squash: squash,
            encoded: encoded
          };
        }
        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
          if (predicates_1.isString(x)) return acc + x;
          var squash = x.squash,
              encoded = x.encoded,
              param = x.param;
          if (squash === true) return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
          if (predicates_1.isString(squash)) return acc + squash;
          if (squash !== false) return acc;
          if (encoded == null) return acc;
          if (predicates_1.isArray(encoded)) return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
          if (param.raw) return acc + encoded;
          return acc + encodeURIComponent(encoded);
        }, '');
        var queryString = queryParams.map(function (paramDetails) {
          var param = paramDetails.param,
              squash = paramDetails.squash,
              encoded = paramDetails.encoded,
              isDefaultValue = paramDetails.isDefaultValue;
          if (encoded == null || isDefaultValue && squash !== false) return;
          if (!predicates_1.isArray(encoded)) encoded = [encoded];
          if (encoded.length === 0) return;
          if (!param.raw) encoded = common_1.map(encoded, encodeURIComponent);
          return encoded.map(function (val) {
            return param.id + "=" + val;
          });
        }).filter(common_1.identity).reduce(common_1.unnestR, []).join('&');
        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
      };
      UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
      return UrlMatcher;
    }();
    exports.UrlMatcher = UrlMatcher;
  })($__require("f9"));
});
$__System.registerDynamic("160", ["15d", "165", "164", "166"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var urlMatcher_1 = $__require("15d");
  var predicates_1 = $__require("165");
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var UrlRuleFactory = function () {
    function UrlRuleFactory(router) {
      this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
      return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
      var _this = this;
      var makeRule = hof_1.pattern([[predicates_1.isString, function (_what) {
        return makeRule(_this.compile(_what));
      }], [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) {
        return _this.fromUrlMatcher(_what, handler);
      }], [predicates_1.isState, function (_what) {
        return _this.fromState(_what, _this.router);
      }], [hof_1.is(RegExp), function (_what) {
        return _this.fromRegExp(_what, handler);
      }], [predicates_1.isFunction, function (_what) {
        return new BaseUrlRule(_what, handler);
      }]]);
      var rule = makeRule(what);
      if (!rule) throw new Error("invalid 'what' in when()");
      return rule;
    };
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
      var _handler = handler;
      if (predicates_1.isString(handler)) handler = this.router.urlMatcherFactory.compile(handler);
      if (hof_1.is(urlMatcher_1.UrlMatcher)(handler)) _handler = function (match) {
        return handler.format(match);
      };
      function matchUrlParamters(url) {
        var params = urlMatcher.exec(url.path, url.search, url.hash);
        return urlMatcher.validates(params) && params;
      }
      function matchPriority(params) {
        var optional = urlMatcher.parameters().filter(function (param) {
          return param.isOptional;
        });
        if (!optional.length) return 0.000001;
        var matched = optional.filter(function (param) {
          return params[param.id];
        });
        return matched.length / optional.length;
      }
      var details = {
        urlMatcher: urlMatcher,
        matchPriority: matchPriority,
        type: 'URLMATCHER'
      };
      return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
    };
    UrlRuleFactory.prototype.fromState = function (state, router) {
      var handler = function (match) {
        var $state = router.stateService;
        var globals = router.globals;
        if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
          $state.transitionTo(state, match, {
            inherit: true,
            source: 'url'
          });
        }
      };
      var details = {
        state: state,
        type: 'STATE'
      };
      return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
    };
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
      if (regexp.global || regexp.sticky) throw new Error('Rule RegExp must not be global or sticky');
      var redirectUrlTo = function (match) {
        return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
          return match[what === '$' ? 0 : Number(what)];
        });
      };
      var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
      var matchParamsFromRegexp = function (url) {
        return regexp.exec(url.path);
      };
      var details = {
        regexp: regexp,
        type: 'REGEXP'
      };
      return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
    };
    UrlRuleFactory.isUrlRule = function (obj) {
      return obj && ['type', 'match', 'handler'].every(function (key) {
        return predicates_1.isDefined(obj[key]);
      });
    };
    return UrlRuleFactory;
  }();
  exports.UrlRuleFactory = UrlRuleFactory;
  var BaseUrlRule = function () {
    function BaseUrlRule(match, handler) {
      var _this = this;
      this.match = match;
      this.type = 'RAW';
      this.matchPriority = function (match) {
        return 0 - _this.$id;
      };
      this.handler = handler || common_1.identity;
    }
    return BaseUrlRule;
  }();
  exports.BaseUrlRule = BaseUrlRule;
});
$__System.registerDynamic("15f", ["164", "165", "15d", "166", "160", "152", "169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var urlMatcher_1 = $__require("15d");
  var hof_1 = $__require("166");
  var urlRule_1 = $__require("160");
  var targetState_1 = $__require("152");
  var common_2 = $__require("169");
  function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/') return url;
    if (isHtml5) return common_2.stripLastPathElement(baseHref) + url;
    if (absolute) return baseHref.slice(1) + url;
    return url;
  }
  var prioritySort = function (a, b) {
    return (b.priority || 0) - (a.priority || 0);
  };
  var typeSort = function (a, b) {
    var weights = {
      'STATE': 4,
      'URLMATCHER': 4,
      'REGEXP': 3,
      'RAW': 2,
      'OTHER': 1
    };
    return (weights[a.type] || 0) - (weights[b.type] || 0);
  };
  var urlMatcherSort = function (a, b) {
    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
  };
  var idSort = function (a, b) {
    var useMatchPriority = {
      STATE: true,
      URLMATCHER: true
    };
    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
  };
  var defaultRuleSortFn;
  defaultRuleSortFn = function (a, b) {
    var cmp = prioritySort(a, b);
    if (cmp !== 0) return cmp;
    cmp = typeSort(a, b);
    if (cmp !== 0) return cmp;
    cmp = urlMatcherSort(a, b);
    if (cmp !== 0) return cmp;
    return idSort(a, b);
  };
  var UrlRouter = function () {
    function UrlRouter(router) {
      this._sortFn = defaultRuleSortFn;
      this._rules = [];
      this.interceptDeferred = false;
      this._id = 0;
      this._sorted = false;
      this._router = router;
      this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
      common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
    }
    UrlRouter.prototype.dispose = function () {
      this.listen(false);
      this._rules = [];
      delete this._otherwiseFn;
    };
    UrlRouter.prototype.sort = function (compareFn) {
      this._rules = this.stableSort(this._rules, this._sortFn = compareFn || this._sortFn);
      this._sorted = true;
    };
    UrlRouter.prototype.ensureSorted = function () {
      this._sorted || this.sort();
    };
    UrlRouter.prototype.stableSort = function (arr, compareFn) {
      var arrOfWrapper = arr.map(function (elem, idx) {
        return {
          elem: elem,
          idx: idx
        };
      });
      arrOfWrapper.sort(function (wrapperA, wrapperB) {
        var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
        return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
      });
      return arrOfWrapper.map(function (wrapper) {
        return wrapper.elem;
      });
    };
    UrlRouter.prototype.match = function (url) {
      var _this = this;
      this.ensureSorted();
      url = common_1.extend({
        path: '',
        search: {},
        hash: ''
      }, url);
      var rules = this.rules();
      if (this._otherwiseFn) rules.push(this._otherwiseFn);
      var checkRule = function (rule) {
        var match = rule.match(url, _this._router);
        return match && {
          match: match,
          rule: rule,
          weight: rule.matchPriority(match)
        };
      };
      var best;
      for (var i = 0; i < rules.length; i++) {
        if (best && this._sortFn(rules[i], best.rule) !== 0) break;
        var current = checkRule(rules[i]);
        best = !best || current && current.weight > best.weight ? current : best;
      }
      return best;
    };
    UrlRouter.prototype.sync = function (evt) {
      if (evt && evt.defaultPrevented) return;
      var router = this._router,
          $url = router.urlService,
          $state = router.stateService;
      var url = {
        path: $url.path(),
        search: $url.search(),
        hash: $url.hash()
      };
      var best = this.match(url);
      var applyResult = hof_1.pattern([[predicates_1.isString, function (newurl) {
        return $url.url(newurl, true);
      }], [targetState_1.TargetState.isDef, function (def) {
        return $state.go(def.state, def.params, def.options);
      }], [hof_1.is(targetState_1.TargetState), function (target) {
        return $state.go(target.state(), target.params(), target.options());
      }]]);
      applyResult(best && best.rule.handler(best.match, url, router));
    };
    UrlRouter.prototype.listen = function (enabled) {
      var _this = this;
      if (enabled === false) {
        this._stopFn && this._stopFn();
        delete this._stopFn;
      } else {
        return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) {
          return _this.sync(evt);
        });
      }
    };
    UrlRouter.prototype.update = function (read) {
      var $url = this._router.locationService;
      if (read) {
        this.location = $url.url();
        return;
      }
      if ($url.url() === this.location) return;
      $url.url(this.location, true);
    };
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
      var replace = options && !!options.replace;
      this._router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
      var url = urlMatcher.format(params);
      if (url == null) return null;
      options = options || { absolute: false };
      var cfg = this._router.urlService.config;
      var isHtml5 = cfg.html5Mode();
      if (!isHtml5 && url !== null) {
        url = '#' + cfg.hashPrefix() + url;
      }
      url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
      if (!options.absolute || !url) {
        return url;
      }
      var slash = !isHtml5 && url ? '/' : '';
      var cfgPort = cfg.port();
      var port = cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort;
      return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    UrlRouter.prototype.rule = function (rule) {
      var _this = this;
      if (!urlRule_1.UrlRuleFactory.isUrlRule(rule)) throw new Error('invalid rule');
      rule.$id = this._id++;
      rule.priority = rule.priority || 0;
      this._rules.push(rule);
      this._sorted = false;
      return function () {
        return _this.removeRule(rule);
      };
    };
    UrlRouter.prototype.removeRule = function (rule) {
      common_1.removeFrom(this._rules, rule);
    };
    UrlRouter.prototype.rules = function () {
      this.ensureSorted();
      return this._rules.slice();
    };
    UrlRouter.prototype.otherwise = function (handler) {
      var handlerFn = getHandlerFn(handler);
      this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
      this._sorted = false;
    };
    UrlRouter.prototype.initial = function (handler) {
      var handlerFn = getHandlerFn(handler);
      var matchFn = function (urlParts, router) {
        return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
      };
      this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
    };
    UrlRouter.prototype.when = function (matcher, handler, options) {
      var rule = this.urlRuleFactory.create(matcher, handler);
      if (predicates_1.isDefined(options && options.priority)) rule.priority = options.priority;
      this.rule(rule);
      return rule;
    };
    UrlRouter.prototype.deferIntercept = function (defer) {
      if (defer === undefined) defer = true;
      this.interceptDeferred = defer;
    };
    return UrlRouter;
  }();
  exports.UrlRouter = UrlRouter;
  function getHandlerFn(handler) {
    if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
      throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
    }
    return predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
  }
});
$__System.registerDynamic("163", ["164", "166", "165", "16a"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var predicates_1 = $__require("165");
  var trace_1 = $__require("16a");
  var ViewService = function () {
    function ViewService() {
      var _this = this;
      this._uiViews = [];
      this._viewConfigs = [];
      this._viewConfigFactories = {};
      this._listeners = [];
      this._pluginapi = {
        _rootViewContext: this._rootViewContext.bind(this),
        _viewConfigFactory: this._viewConfigFactory.bind(this),
        _registeredUIViews: function () {
          return _this._uiViews;
        },
        _activeViewConfigs: function () {
          return _this._viewConfigs;
        },
        _onSync: function (listener) {
          _this._listeners.push(listener);
          return function () {
            return common_1.removeFrom(_this._listeners, listener);
          };
        }
      };
    }
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
      if (rawViewName === void 0) {
        rawViewName = '';
      }
      var viewAtContext = rawViewName.split('@');
      var uiViewName = viewAtContext[0] || '$default';
      var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^';
      var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
      if (relativeViewNameSugar) {
        uiViewContextAnchor = relativeViewNameSugar[1];
        uiViewName = relativeViewNameSugar[2];
      }
      if (uiViewName.charAt(0) === '!') {
        uiViewName = uiViewName.substr(1);
        uiViewContextAnchor = '';
      }
      var relativeMatch = /^(\^(?:\.\^)*)$/;
      if (relativeMatch.exec(uiViewContextAnchor)) {
        var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) {
          return anchor.parent;
        }, context);
        uiViewContextAnchor = anchorState.name;
      } else if (uiViewContextAnchor === '.') {
        uiViewContextAnchor = context.name;
      }
      return {
        uiViewName: uiViewName,
        uiViewContextAnchor: uiViewContextAnchor
      };
    };
    ViewService.prototype._rootViewContext = function (context) {
      return this._rootContext = context || this._rootContext;
    };
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
      this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
      var cfgFactory = this._viewConfigFactories[decl.$type];
      if (!cfgFactory) throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
      var cfgs = cfgFactory(path, decl);
      return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
    };
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
      trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
      common_1.removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
      trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
      this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
      var _this = this;
      var uiViewsByFqn = this._uiViews.map(function (uiv) {
        return [uiv.fqn, uiv];
      }).reduce(common_1.applyPairs, {});
      function uiViewDepth(uiView) {
        var stateDepth = function (context) {
          return context && context.parent ? stateDepth(context.parent) + 1 : 1;
        };
        return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
      }
      function viewConfigDepth(config) {
        var context = config.viewDecl.$context,
            count = 0;
        while (++count && context.parent) context = context.parent;
        return count;
      }
      var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) {
        return posNeg * (depthFn(left) - depthFn(right));
      });
      var matchingConfigPair = function (uiView) {
        var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
        if (matchingConfigs.length > 1) {
          matchingConfigs.sort(depthCompare(viewConfigDepth, -1));
        }
        return {
          uiView: uiView,
          viewConfig: matchingConfigs[0]
        };
      };
      var configureUIView = function (tuple) {
        if (_this._uiViews.indexOf(tuple.uiView) !== -1) tuple.uiView.configUpdated(tuple.viewConfig);
      };
      var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
      var matchedViewConfigs = uiViewTuples.map(function (tuple) {
        return tuple.viewConfig;
      });
      var unmatchedConfigTuples = this._viewConfigs.filter(function (config) {
        return !common_1.inArray(matchedViewConfigs, config);
      }).map(function (viewConfig) {
        return {
          uiView: undefined,
          viewConfig: viewConfig
        };
      });
      uiViewTuples.forEach(configureUIView);
      var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
      this._listeners.forEach(function (cb) {
        return cb(allTuples);
      });
      trace_1.trace.traceViewSync(allTuples);
    };
    ViewService.prototype.registerUIView = function (uiView) {
      trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
      var uiViews = this._uiViews;
      var fqnAndTypeMatches = function (uiv) {
        return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type;
      };
      if (uiViews.filter(fqnAndTypeMatches).length) trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
      uiViews.push(uiView);
      this.sync();
      return function () {
        var idx = uiViews.indexOf(uiView);
        if (idx === -1) {
          trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
          return;
        }
        trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
        common_1.removeFrom(uiViews)(uiView);
      };
    };
    ViewService.prototype.available = function () {
      return this._uiViews.map(hof_1.prop('fqn'));
    };
    ViewService.prototype.active = function () {
      return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
    };
    ViewService.matches = function (uiViewsByFqn, uiView) {
      return function (viewConfig) {
        if (uiView.$type !== viewConfig.viewDecl.$type) return false;
        var vc = viewConfig.viewDecl;
        var vcSegments = vc.$uiViewName.split('.');
        var uivSegments = uiView.fqn.split('.');
        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length))) return false;
        var negOffset = 1 - vcSegments.length || undefined;
        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
      };
    };
    return ViewService;
  }();
  exports.ViewService = ViewService;
});
$__System.registerDynamic("14e", ["165", "164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var common_1 = $__require("164");
  var StateMatcher = function () {
    function StateMatcher(_states) {
      this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
      stateName = stateName || '';
      return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
      if (matchGlob === void 0) {
        matchGlob = true;
      }
      if (!stateOrName && stateOrName !== '') return undefined;
      var isStr = predicates_1.isString(stateOrName);
      var name = isStr ? stateOrName : stateOrName.name;
      if (this.isRelative(name)) name = this.resolvePath(name, base);
      var state = this._states[name];
      if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) {
        return state;
      } else if (isStr && matchGlob) {
        var _states = common_1.values(this._states);
        var matches = _states.filter(function (_state) {
          return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name);
        });
        if (matches.length > 1) {
          console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) {
            return match.name;
          }));
        }
        return matches[0];
      }
      return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
      if (!base) throw new Error("No reference point given for path '" + name + "'");
      var baseState = this.find(base);
      var splitName = name.split('.');
      var pathLength = splitName.length;
      var i = 0,
          current = baseState;
      for (; i < pathLength; i++) {
        if (splitName[i] === '' && i === 0) {
          current = baseState;
          continue;
        }
        if (splitName[i] === '^') {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      var relName = splitName.slice(i).join('.');
      return current.name + (current.name && relName ? '.' : '') + relName;
    };
    return StateMatcher;
  }();
  exports.StateMatcher = StateMatcher;
});
$__System.registerDynamic("14c", ["164", "165", "168", "166", "16b", "167"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var strings_1 = $__require("168");
  var hof_1 = $__require("166");
  var resolvable_1 = $__require("16b");
  var coreservices_1 = $__require("167");
  var parseUrl = function (url) {
    if (!predicates_1.isString(url)) return false;
    var root = url.charAt(0) === '^';
    return {
      val: root ? url.substring(1) : url,
      root: root
    };
  };
  function nameBuilder(state) {
    return state.name;
  }
  function selfBuilder(state) {
    state.self.$$state = function () {
      return state;
    };
    return state.self;
  }
  function dataBuilder(state) {
    if (state.parent && state.parent.data) {
      state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
    }
    return state.data;
  }
  var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
    return function urlBuilder(state) {
      var stateDec = state;
      if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
        stateDec.url += '{remainder:any}';
      }
      var parsed = parseUrl(stateDec.url),
          parent = state.parent;
      var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
        params: state.params || {},
        paramMap: function (paramConfig, isSearch) {
          if (stateDec.reloadOnSearch === false && isSearch) paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
          return paramConfig;
        }
      });
      if (!url) return null;
      if (!$urlMatcherFactoryProvider.isMatcher(url)) throw new Error("Invalid url '" + url + "' in state '" + state + "'");
      return parsed && parsed.root ? url : (parent && parent.navigable || root()).url.append(url);
    };
  };
  var getNavigableBuilder = function (isRoot) {
    return function navigableBuilder(state) {
      return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
    };
  };
  var getParamsBuilder = function (paramFactory) {
    return function paramsBuilder(state) {
      var makeConfigParam = function (config, id) {
        return paramFactory.fromConfig(id, null, config);
      };
      var urlParams = state.url && state.url.parameters({ inherit: false }) || [];
      var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
      return urlParams.concat(nonUrlParams).map(function (p) {
        return [p.id, p];
      }).reduce(common_1.applyPairs, {});
    };
  };
  function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : [state];
  }
  function includesBuilder(state) {
    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
  }
  function resolvablesBuilder(state) {
    var objects2Tuples = function (resolveObj, resolvePolicies) {
      return Object.keys(resolveObj || {}).map(function (token) {
        return {
          token: token,
          val: resolveObj[token],
          deps: undefined,
          policy: resolvePolicies[token]
        };
      });
    };
    var annotate = function (fn) {
      var $injector = coreservices_1.services.$injector;
      return fn['$inject'] || $injector && $injector.annotate(fn, $injector.strictDi) || 'deferred';
    };
    var isResolveLiteral = function (obj) {
      return !!(obj.token && obj.resolveFn);
    };
    var isLikeNg2Provider = function (obj) {
      return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
    };
    var isTupleFromObj = function (obj) {
      return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
    };
    var getToken = function (p) {
      return p.provide || p.token;
    };
    var literal2Resolvable = hof_1.pattern([[hof_1.prop('resolveFn'), function (p) {
      return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy);
    }], [hof_1.prop('useFactory'), function (p) {
      return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy);
    }], [hof_1.prop('useClass'), function (p) {
      return new resolvable_1.Resolvable(getToken(p), function () {
        return new p.useClass();
      }, [], p.policy);
    }], [hof_1.prop('useValue'), function (p) {
      return new resolvable_1.Resolvable(getToken(p), function () {
        return p.useValue;
      }, [], p.policy, p.useValue);
    }], [hof_1.prop('useExisting'), function (p) {
      return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy);
    }]]);
    var tuple2Resolvable = hof_1.pattern([[hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) {
      return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy);
    }], [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) {
      return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy);
    }], [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) {
      return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy);
    }]]);
    var item2Resolvable = hof_1.pattern([[hof_1.is(resolvable_1.Resolvable), function (r) {
      return r;
    }], [isResolveLiteral, literal2Resolvable], [isLikeNg2Provider, literal2Resolvable], [isTupleFromObj, tuple2Resolvable], [hof_1.val(true), function (obj) {
      throw new Error('Invalid resolve value: ' + strings_1.stringify(obj));
    }]]);
    var decl = state.resolve;
    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
  }
  exports.resolvablesBuilder = resolvablesBuilder;
  var StateBuilder = function () {
    function StateBuilder(matcher, urlMatcherFactory) {
      this.matcher = matcher;
      var self = this;
      var root = function () {
        return matcher.find('');
      };
      var isRoot = function (state) {
        return state.name === '';
      };
      function parentBuilder(state) {
        if (isRoot(state)) return null;
        return matcher.find(self.parentName(state)) || root();
      }
      this.builders = {
        name: [nameBuilder],
        self: [selfBuilder],
        parent: [parentBuilder],
        data: [dataBuilder],
        url: [getUrlBuilder(urlMatcherFactory, root)],
        navigable: [getNavigableBuilder(isRoot)],
        params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
        views: [],
        path: [pathBuilder],
        includes: [includesBuilder],
        resolvables: [resolvablesBuilder]
      };
    }
    StateBuilder.prototype.builder = function (name, fn) {
      var builders = this.builders;
      var array = builders[name] || [];
      if (predicates_1.isString(name) && !predicates_1.isDefined(fn)) return array.length > 1 ? array : array[0];
      if (!predicates_1.isString(name) || !predicates_1.isFunction(fn)) return;
      builders[name] = array;
      builders[name].push(fn);
      return function () {
        return builders[name].splice(builders[name].indexOf(fn, 1)) && null;
      };
    };
    StateBuilder.prototype.build = function (state) {
      var _a = this,
          matcher = _a.matcher,
          builders = _a.builders;
      var parent = this.parentName(state);
      if (parent && !matcher.find(parent, undefined, false)) {
        return null;
      }
      for (var key in builders) {
        if (!builders.hasOwnProperty(key)) continue;
        var chain = builders[key].reduce(function (parentFn, step) {
          return function (_state) {
            return step(_state, parentFn);
          };
        }, common_1.noop);
        state[key] = chain(state);
      }
      return state;
    };
    StateBuilder.prototype.parentName = function (state) {
      var name = state.name || '';
      var segments = name.split('.');
      var lastSegment = segments.pop();
      if (lastSegment === '**') segments.pop();
      if (segments.length) {
        if (state.parent) {
          throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
        }
        return segments.join('.');
      }
      if (!state.parent) return '';
      return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
      var name = state.name;
      if (name.indexOf('.') !== -1 || !state.parent) return name;
      var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
      return parentName ? parentName + '.' + name : name;
    };
    return StateBuilder;
  }();
  exports.StateBuilder = StateBuilder;
});
$__System.registerDynamic("14f", ["164", "165", "14d", "166"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var stateObject_1 = $__require("14d");
  var hof_1 = $__require("166");
  var StateQueueManager = function () {
    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
      this.$registry = $registry;
      this.$urlRouter = $urlRouter;
      this.states = states;
      this.builder = builder;
      this.listeners = listeners;
      this.queue = [];
      this.matcher = $registry.matcher;
    }
    StateQueueManager.prototype.dispose = function () {
      this.queue = [];
    };
    StateQueueManager.prototype.register = function (stateDecl) {
      var queue = this.queue;
      var state = stateObject_1.StateObject.create(stateDecl);
      var name = state.name;
      if (!predicates_1.isString(name)) throw new Error('State must have a valid name');
      if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(hof_1.prop('name')), name)) throw new Error("State '" + name + "' is already defined");
      queue.push(state);
      this.flush();
      return state;
    };
    StateQueueManager.prototype.flush = function () {
      var _this = this;
      var _a = this,
          queue = _a.queue,
          states = _a.states,
          builder = _a.builder;
      var registered = [],
          orphans = [],
          previousQueueLength = {};
      var getState = function (name) {
        return _this.states.hasOwnProperty(name) && _this.states[name];
      };
      while (queue.length > 0) {
        var state = queue.shift();
        var name_1 = state.name;
        var result = builder.build(state);
        var orphanIdx = orphans.indexOf(state);
        if (result) {
          var existingState = getState(name_1);
          if (existingState && existingState.name === name_1) {
            throw new Error("State '" + name_1 + "' is already defined");
          }
          var existingFutureState = getState(name_1 + '.**');
          if (existingFutureState) {
            this.$registry.deregister(existingFutureState);
          }
          states[name_1] = state;
          this.attachRoute(state);
          if (orphanIdx >= 0) orphans.splice(orphanIdx, 1);
          registered.push(state);
          continue;
        }
        var prev = previousQueueLength[name_1];
        previousQueueLength[name_1] = queue.length;
        if (orphanIdx >= 0 && prev === queue.length) {
          queue.push(state);
          return states;
        } else if (orphanIdx < 0) {
          orphans.push(state);
        }
        queue.push(state);
      }
      if (registered.length) {
        this.listeners.forEach(function (listener) {
          return listener('registered', registered.map(function (s) {
            return s.self;
          }));
        });
      }
      return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
      if (state.abstract || !state.url) return;
      this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
    };
    return StateQueueManager;
  }();
  exports.StateQueueManager = StateQueueManager;
});
$__System.registerDynamic("150", ["14e", "14c", "14f", "164", "166"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var stateMatcher_1 = $__require("14e");
  var stateBuilder_1 = $__require("14c");
  var stateQueueManager_1 = $__require("14f");
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var StateRegistry = function () {
    function StateRegistry(_router) {
      this._router = _router;
      this.states = {};
      this.listeners = [];
      this.matcher = new stateMatcher_1.StateMatcher(this.states);
      this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
      this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
      this._registerRoot();
    }
    StateRegistry.prototype._registerRoot = function () {
      var rootStateDef = {
        name: '',
        url: '^',
        views: null,
        params: { '#': {
            value: null,
            type: 'hash',
            dynamic: true
          } },
        abstract: true
      };
      var _root = this._root = this.stateQueue.register(rootStateDef);
      _root.navigable = null;
    };
    StateRegistry.prototype.dispose = function () {
      var _this = this;
      this.stateQueue.dispose();
      this.listeners = [];
      this.get().forEach(function (state) {
        return _this.get(state) && _this.deregister(state);
      });
    };
    StateRegistry.prototype.onStatesChanged = function (listener) {
      this.listeners.push(listener);
      return function deregisterListener() {
        common_1.removeFrom(this.listeners)(listener);
      }.bind(this);
    };
    StateRegistry.prototype.root = function () {
      return this._root;
    };
    StateRegistry.prototype.register = function (stateDefinition) {
      return this.stateQueue.register(stateDefinition);
    };
    StateRegistry.prototype._deregisterTree = function (state) {
      var _this = this;
      var all = this.get().map(function (s) {
        return s.$$state();
      });
      var getChildren = function (states) {
        var _children = all.filter(function (s) {
          return states.indexOf(s.parent) !== -1;
        });
        return _children.length === 0 ? _children : _children.concat(getChildren(_children));
      };
      var children = getChildren([state]);
      var deregistered = [state].concat(children).reverse();
      deregistered.forEach(function (_state) {
        var $ur = _this._router.urlRouter;
        $ur.rules().filter(hof_1.propEq('state', _state)).forEach($ur.removeRule.bind($ur));
        delete _this.states[_state.name];
      });
      return deregistered;
    };
    StateRegistry.prototype.deregister = function (stateOrName) {
      var _state = this.get(stateOrName);
      if (!_state) throw new Error("Can't deregister state; not found: " + stateOrName);
      var deregisteredStates = this._deregisterTree(_state.$$state());
      this.listeners.forEach(function (listener) {
        return listener('deregistered', deregisteredStates.map(function (s) {
          return s.self;
        }));
      });
      return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
      var _this = this;
      if (arguments.length === 0) return Object.keys(this.states).map(function (name) {
        return _this.states[name].self;
      });
      var found = this.matcher.find(stateOrName, base);
      return found && found.self || null;
    };
    StateRegistry.prototype.decorator = function (name, func) {
      return this.builder.builder(name, func);
    };
    return StateRegistry;
  }();
  exports.StateRegistry = StateRegistry;
});
$__System.registerDynamic("16c", ["16d", "16b", "16e"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("16d"));
  __export($__require("16b"));
  __export($__require("16e"));
});
$__System.registerDynamic("16f", ["158", "170", "16c", "169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var transition_1 = $__require("158");
  var router_1 = $__require("170");
  var resolve_1 = $__require("16c");
  var common_1 = $__require("169");
  function addCoreResolvables(trans) {
    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
    trans.entering().forEach(function (state) {
      trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
    });
  }
  exports.registerAddCoreResolvables = function (transitionService) {
    return transitionService.onCreate({}, addCoreResolvables);
  };
  var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
  var isTransition = common_1.inArray(TRANSITION_TOKENS);
  exports.treeChangesCleanup = function (trans) {
    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
    var replaceTransitionWithNull = function (r) {
      return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
    };
    nodes.forEach(function (node) {
      node.resolvables = node.resolvables.map(replaceTransitionWithNull);
    });
  };
});
$__System.registerDynamic("171", ["165", "167", "152"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var coreservices_1 = $__require("167");
  var targetState_1 = $__require("152");
  var redirectToHook = function (trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect) return;
    var $state = trans.router.stateService;
    function handleResult(result) {
      if (!result) return;
      if (result instanceof targetState_1.TargetState) return result;
      if (predicates_1.isString(result)) return $state.target(result, trans.params(), trans.options());
      if (result['state'] || result['params']) return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (predicates_1.isFunction(redirect)) {
      return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
  };
  exports.registerRedirectToHook = function (transitionService) {
    return transitionService.onStart({ to: function (state) {
        return !!state.redirectTo;
      } }, redirectToHook);
  };
});
$__System.registerDynamic("172", [], true, function ($__require, exports, module) {
    /* */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * A factory which creates an onEnter, onExit or onRetain transition hook function
     *
     * The returned function invokes the (for instance) state.onEnter hook when the
     * state is being entered.
     *
     * @hidden
     */
    function makeEnterExitRetainHook(hookName) {
        return function (transition, state) {
            var _state = state.$$state();
            var hookFn = _state[hookName];
            return hookFn(transition, state);
        };
    }
    /**
     * The [[TransitionStateHookFn]] for onExit
     *
     * When the state is being exited, the state's .onExit function is invoked.
     *
     * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
     *
     * See: [[IHookRegistry.onExit]]
     */
    var onExitHook = makeEnterExitRetainHook('onExit');
    exports.registerOnExitHook = function (transitionService) {
        return transitionService.onExit({ exiting: function (state) {
                return !!state.onExit;
            } }, onExitHook);
    };
    /**
     * The [[TransitionStateHookFn]] for onRetain
     *
     * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
     *
     * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
     *
     * See: [[IHookRegistry.onRetain]]
     */
    var onRetainHook = makeEnterExitRetainHook('onRetain');
    exports.registerOnRetainHook = function (transitionService) {
        return transitionService.onRetain({ retained: function (state) {
                return !!state.onRetain;
            } }, onRetainHook);
    };
    /**
     * The [[TransitionStateHookFn]] for onEnter
     *
     * When the state is being entered, the state's .onEnter function is invoked.
     *
     * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
     *
     * See: [[IHookRegistry.onEnter]]
     */
    var onEnterHook = makeEnterExitRetainHook('onEnter');
    exports.registerOnEnterHook = function (transitionService) {
        return transitionService.onEnter({ entering: function (state) {
                return !!state.onEnter;
            } }, onEnterHook);
    };
    
});
$__System.registerDynamic("173", ["164", "16e", "166"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var resolveContext_1 = $__require("16e");
  var hof_1 = $__require("166");
  exports.RESOLVE_HOOK_PRIORITY = 1000;
  var eagerResolvePath = function (trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
  };
  exports.registerEagerResolvePath = function (transitionService) {
    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
  };
  var lazyResolveState = function (trans, state) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
  };
  exports.registerLazyResolveState = function (transitionService) {
    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
  };
  var resolveRemaining = function (trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
  };
  exports.registerResolveRemaining = function (transitionService) {
    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
  };
});
$__System.registerDynamic("174", ["164", "167"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var coreservices_1 = $__require("167");
  var loadEnteringViews = function (transition) {
    var $q = coreservices_1.services.$q;
    var enteringViews = transition.views('entering');
    if (!enteringViews.length) return;
    return $q.all(enteringViews.map(function (view) {
      return $q.when(view.load());
    })).then(common_1.noop);
  };
  exports.registerLoadEnteringViews = function (transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
  };
  var activateViews = function (transition) {
    var enteringViews = transition.views('entering');
    var exitingViews = transition.views('exiting');
    if (!enteringViews.length && !exitingViews.length) return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) {
      return $view.deactivateViewConfig(vc);
    });
    enteringViews.forEach(function (vc) {
      return $view.activateViewConfig(vc);
    });
    $view.sync();
  };
  exports.registerActivateViews = function (transitionService) {
    return transitionService.onSuccess({}, activateViews);
  };
});
$__System.registerDynamic("175", ["164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var updateGlobalState = function (trans) {
    var globals = trans.router.globals;
    var transitionSuccessful = function () {
      globals.successfulTransitions.enqueue(trans);
      globals.$current = trans.$to();
      globals.current = globals.$current.self;
      common_1.copy(trans.params(), globals.params);
    };
    var clearCurrentTransition = function () {
      if (globals.transition === trans) globals.transition = null;
    };
    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
  };
  exports.registerUpdateGlobalState = function (transitionService) {
    return transitionService.onCreate({}, updateGlobalState);
  };
});
$__System.registerDynamic("176", [], true, function ($__require, exports, module) {
    /* */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * A [[TransitionHookFn]] which updates the URL after a successful transition
     *
     * Registered using `transitionService.onSuccess({}, updateUrl);`
     */
    var updateUrl = function (transition) {
        var options = transition.options();
        var $state = transition.router.stateService;
        var $urlRouter = transition.router.urlRouter;
        // Dont update the url in these situations:
        // The transition was triggered by a URL sync (options.source === 'url')
        // The user doesn't want the url to update (options.location === false)
        // The destination state, and all parents have no navigable url
        if (options.source !== 'url' && options.location && $state.$current.navigable) {
            var urlOptions = { replace: options.location === 'replace' };
            $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
        }
        $urlRouter.update(true);
    };
    exports.registerUpdateUrl = function (transitionService) {
        return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
    };
    
});
$__System.registerDynamic("15a", ["159"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var transitionHook_1 = $__require("159");
  var TransitionEventType = function () {
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
      if (reverseSort === void 0) {
        reverseSort = false;
      }
      if (getResultHandler === void 0) {
        getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT;
      }
      if (getErrorHandler === void 0) {
        getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR;
      }
      if (synchronous === void 0) {
        synchronous = false;
      }
      this.name = name;
      this.hookPhase = hookPhase;
      this.hookOrder = hookOrder;
      this.criteriaMatchPath = criteriaMatchPath;
      this.reverseSort = reverseSort;
      this.getResultHandler = getResultHandler;
      this.getErrorHandler = getErrorHandler;
      this.synchronous = synchronous;
    }
    return TransitionEventType;
  }();
  exports.TransitionEventType = TransitionEventType;
});
$__System.registerDynamic("177", ["16a", "157", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var trace_1 = $__require("16a");
    var rejectFactory_1 = $__require("157");
    function ignoredHook(trans) {
      var ignoredReason = trans._ignoredReason();
      if (!ignoredReason) return;
      trace_1.trace.traceTransitionIgnored(trans);
      var pending = trans.router.globals.transition;
      if (ignoredReason === 'SameAsCurrent' && pending) {
        pending.abort();
      }
      return rejectFactory_1.Rejection.ignored().toPromise();
    }
    exports.registerIgnoredTransitionHook = function (transitionService) {
      return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
    };
  })($__require("f9"));
});
$__System.registerDynamic("178", [], true, function ($__require, exports, module) {
    /* */
    "use strict";
    /** @module hooks */ /** */

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * A [[TransitionHookFn]] that rejects the Transition if it is invalid
     *
     * This hook is invoked at the end of the onBefore phase.
     * If the transition is invalid (for example, param values do not validate)
     * then the transition is rejected.
     */
    function invalidTransitionHook(trans) {
        if (!trans.valid()) {
            throw new Error(trans.error());
        }
    }
    exports.registerInvalidTransitionHook = function (transitionService) {
        return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
    };
    
});
$__System.registerDynamic("15b", ["154", "158", "156", "16f", "171", "172", "173", "174", "175", "176", "179", "15a", "159", "165", "164", "166", "177", "178"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var interface_1 = $__require("154");
  var transition_1 = $__require("158");
  var hookRegistry_1 = $__require("156");
  var coreResolvables_1 = $__require("16f");
  var redirectTo_1 = $__require("171");
  var onEnterExitRetain_1 = $__require("172");
  var resolve_1 = $__require("173");
  var views_1 = $__require("174");
  var updateGlobals_1 = $__require("175");
  var url_1 = $__require("176");
  var lazyLoad_1 = $__require("179");
  var transitionEventType_1 = $__require("15a");
  var transitionHook_1 = $__require("159");
  var predicates_1 = $__require("165");
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var ignoredTransition_1 = $__require("177");
  var invalidTransition_1 = $__require("178");
  exports.defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    custom: {},
    current: function () {
      return null;
    },
    source: 'unknown'
  };
  var TransitionService = function () {
    function TransitionService(_router) {
      this._transitionCount = 0;
      this._eventTypes = [];
      this._registeredHooks = {};
      this._criteriaPaths = {};
      this._router = _router;
      this.$view = _router.viewService;
      this._deregisterHookFns = {};
      this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), ['_definePathType', '_defineEvent', '_getPathTypes', '_getEvents', 'getHooks']);
      this._defineCorePaths();
      this._defineCoreEvents();
      this._registerCoreTransitionHooks();
      _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
    }
    TransitionService.prototype.onCreate = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onBefore = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onStart = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onExit = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onRetain = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onEnter = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onFinish = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.onError = function (criteria, callback, options) {
      return;
    };
    TransitionService.prototype.dispose = function (router) {
      common_1.values(this._registeredHooks).forEach(function (hooksArray) {
        return hooksArray.forEach(function (hook) {
          hook._deregistered = true;
          common_1.removeFrom(hooksArray, hook);
        });
      });
    };
    TransitionService.prototype.create = function (fromPath, targetState) {
      return new transition_1.Transition(fromPath, targetState, this._router);
    };
    TransitionService.prototype._defineCoreEvents = function () {
      var Phase = interface_1.TransitionHookPhase;
      var TH = transitionHook_1.TransitionHook;
      var paths = this._criteriaPaths;
      var NORMAL_SORT = false,
          REVERSE_SORT = true;
      var SYNCHRONOUS = true;
      this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
      this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
      this._defineEvent('onStart', Phase.RUN, 0, paths.to);
      this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
      this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
      this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
      this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
      this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
      this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
    };
    TransitionService.prototype._defineCorePaths = function () {
      var STATE = interface_1.TransitionHookScope.STATE,
          TRANSITION = interface_1.TransitionHookScope.TRANSITION;
      this._definePathType('to', TRANSITION);
      this._definePathType('from', TRANSITION);
      this._definePathType('exiting', STATE);
      this._definePathType('retained', STATE);
      this._definePathType('entering', STATE);
    };
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
      if (reverseSort === void 0) {
        reverseSort = false;
      }
      if (getResultHandler === void 0) {
        getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT;
      }
      if (getErrorHandler === void 0) {
        getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR;
      }
      if (synchronous === void 0) {
        synchronous = false;
      }
      var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
      this._eventTypes.push(eventType);
      hookRegistry_1.makeEvent(this, this, eventType);
    };
    TransitionService.prototype._getEvents = function (phase) {
      var transitionHookTypes = predicates_1.isDefined(phase) ? this._eventTypes.filter(function (type) {
        return type.hookPhase === phase;
      }) : this._eventTypes.slice();
      return transitionHookTypes.sort(function (l, r) {
        var cmpByPhase = l.hookPhase - r.hookPhase;
        return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
      });
    };
    TransitionService.prototype._definePathType = function (name, hookScope) {
      this._criteriaPaths[name] = {
        name: name,
        scope: hookScope
      };
    };
    TransitionService.prototype._getPathTypes = function () {
      return this._criteriaPaths;
    };
    TransitionService.prototype.getHooks = function (hookName) {
      return this._registeredHooks[hookName];
    };
    TransitionService.prototype._registerCoreTransitionHooks = function () {
      var fns = this._deregisterHookFns;
      fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
      fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
      fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
      fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
      fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
      fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
      fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
      fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
      fns.lazyResolve = resolve_1.registerLazyResolveState(this);
      fns.resolveAll = resolve_1.registerResolveRemaining(this);
      fns.loadViews = views_1.registerLoadEnteringViews(this);
      fns.activateViews = views_1.registerActivateViews(this);
      fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
      fns.updateUrl = url_1.registerUpdateUrl(this);
      fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
    };
    return TransitionService;
  }();
  exports.TransitionService = TransitionService;
});
$__System.registerDynamic("179", ["167", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var coreservices_1 = $__require("167");
    var lazyLoadHook = function (transition) {
      var router = transition.router;
      function retryTransition() {
        if (transition.originalTransition().options().source !== 'url') {
          var orig = transition.targetState();
          return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        if (rule && rule.type === 'STATE') {
          var state = rule.state;
          var params = result.match;
          return router.stateService.target(state, params, transition.options());
        }
        router.urlService.sync();
      }
      var promises = transition.entering().filter(function (state) {
        return !!state.$$state().lazyLoad;
      }).map(function (state) {
        return lazyLoadState(transition, state);
      });
      return coreservices_1.services.$q.all(promises).then(retryTransition);
    };
    exports.registerLazyLoadHook = function (transitionService) {
      return transitionService.onBefore({ entering: function (state) {
          return !!state.lazyLoad;
        } }, lazyLoadHook);
    };
    function lazyLoadState(transition, state) {
      var lazyLoadFn = state.$$state().lazyLoad;
      var promise = lazyLoadFn['_promise'];
      if (!promise) {
        var success = function (result) {
          delete state.lazyLoad;
          delete state.$$state().lazyLoad;
          delete lazyLoadFn['_promise'];
          return result;
        };
        var error = function (err) {
          delete lazyLoadFn['_promise'];
          return coreservices_1.services.$q.reject(err);
        };
        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q.when(lazyLoadFn(transition, state)).then(updateStateRegistry).then(success, error);
      }
      function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) {
          result.states.forEach(function (_state) {
            return transition.router.stateRegistry.register(_state);
          });
        }
        return result;
      }
      return promise;
    }
    exports.lazyLoadState = lazyLoadState;
  })($__require("f9"));
});
$__System.registerDynamic("151", ["164", "165", "17a", "167", "14a", "149", "15b", "157", "152", "144", "17b", "16e", "179", "166"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var queue_1 = $__require("17a");
  var coreservices_1 = $__require("167");
  var pathUtils_1 = $__require("14a");
  var pathNode_1 = $__require("149");
  var transitionService_1 = $__require("15b");
  var rejectFactory_1 = $__require("157");
  var targetState_1 = $__require("152");
  var param_1 = $__require("144");
  var glob_1 = $__require("17b");
  var resolveContext_1 = $__require("16e");
  var lazyLoad_1 = $__require("179");
  var hof_1 = $__require("166");
  var StateService = function () {
    function StateService(router) {
      this.router = router;
      this.invalidCallbacks = [];
      this._defaultErrorHandler = function $defaultErrorHandler($error$) {
        if ($error$ instanceof Error && $error$.stack) {
          console.error($error$);
          console.error($error$.stack);
        } else if ($error$ instanceof rejectFactory_1.Rejection) {
          console.error($error$.toString());
          if ($error$.detail && $error$.detail.stack) console.error($error$.detail.stack);
        } else {
          console.error($error$);
        }
      };
      var getters = ['current', '$current', 'params', 'transition'];
      var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
      common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
      get: function () {
        return this.router.globals.transition;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
      get: function () {
        return this.router.globals.params;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
      get: function () {
        return this.router.globals.current;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
      get: function () {
        return this.router.globals.$current;
      },
      enumerable: true,
      configurable: true
    });
    StateService.prototype.dispose = function () {
      this.defaultErrorHandler(common_1.noop);
      this.invalidCallbacks = [];
    };
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
      var _this = this;
      var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
      var globals = this.router.globals;
      var latestThing = function () {
        return globals.transitionHistory.peekTail();
      };
      var latest = latestThing();
      var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
      var injector = new resolveContext_1.ResolveContext(fromPath).injector();
      var checkForRedirect = function (result) {
        if (!(result instanceof targetState_1.TargetState)) {
          return;
        }
        var target = result;
        target = _this.target(target.identifier(), target.params(), target.options());
        if (!target.valid()) {
          return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
        }
        if (latestThing() !== latest) {
          return rejectFactory_1.Rejection.superseded().toPromise();
        }
        return _this.transitionTo(target.identifier(), target.params(), target.options());
      };
      function invokeNextCallback() {
        var nextCallback = callbackQueue.dequeue();
        if (nextCallback === undefined) return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
        var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
        return callbackResult.then(checkForRedirect).then(function (result) {
          return result || invokeNextCallback();
        });
      }
      return invokeNextCallback();
    };
    StateService.prototype.onInvalid = function (callback) {
      this.invalidCallbacks.push(callback);
      return function deregisterListener() {
        common_1.removeFrom(this.invalidCallbacks)(callback);
      }.bind(this);
    };
    StateService.prototype.reload = function (reloadState) {
      return this.transitionTo(this.current, this.params, {
        reload: predicates_1.isDefined(reloadState) ? reloadState : true,
        inherit: false,
        notify: false
      });
    };
    StateService.prototype.go = function (to, params, options) {
      var defautGoOpts = {
        relative: this.$current,
        inherit: true
      };
      var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
      return this.transitionTo(to, params, transOpts);
    };
    StateService.prototype.target = function (identifier, params, options) {
      if (options === void 0) {
        options = {};
      }
      if (predicates_1.isObject(options.reload) && !options.reload.name) throw new Error('Invalid reload state object');
      var reg = this.router.stateRegistry;
      options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
      if (options.reload && !options.reloadState) throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
      return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
    };
    StateService.prototype.getCurrentPath = function () {
      var _this = this;
      var globals = this.router.globals;
      var latestSuccess = globals.successfulTransitions.peekTail();
      var rootPath = function () {
        return [new pathNode_1.PathNode(_this.router.stateRegistry.root())];
      };
      return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    StateService.prototype.transitionTo = function (to, toParams, options) {
      var _this = this;
      if (toParams === void 0) {
        toParams = {};
      }
      if (options === void 0) {
        options = {};
      }
      var router = this.router;
      var globals = router.globals;
      options = common_1.defaults(options, transitionService_1.defaultTransOpts);
      var getCurrent = function () {
        return globals.transition;
      };
      options = common_1.extend(options, { current: getCurrent });
      var ref = this.target(to, toParams, options);
      var currentPath = this.getCurrentPath();
      if (!ref.exists()) return this._handleInvalidTargetState(currentPath, ref);
      if (!ref.valid()) return common_1.silentRejection(ref.error());
      var rejectedTransitionHandler = function (trans) {
        return function (error) {
          if (error instanceof rejectFactory_1.Rejection) {
            var isLatest = router.globals.lastStartedTransitionId === trans.$id;
            if (error.type === rejectFactory_1.RejectType.IGNORED) {
              isLatest && router.urlRouter.update();
              return coreservices_1.services.$q.when(globals.current);
            }
            var detail = error.detail;
            if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
              var redirect = trans.redirect(detail);
              return redirect.run().catch(rejectedTransitionHandler(redirect));
            }
            if (error.type === rejectFactory_1.RejectType.ABORTED) {
              isLatest && router.urlRouter.update();
              return coreservices_1.services.$q.reject(error);
            }
          }
          var errorHandler = _this.defaultErrorHandler();
          errorHandler(error);
          return coreservices_1.services.$q.reject(error);
        };
      };
      var transition = this.router.transitionService.create(currentPath, ref);
      var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
      common_1.silenceUncaughtInPromise(transitionToPromise);
      return common_1.extend(transitionToPromise, { transition: transition });
    };
    StateService.prototype.is = function (stateOrName, params, options) {
      options = common_1.defaults(options, { relative: this.$current });
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
      if (!predicates_1.isDefined(state)) return undefined;
      if (this.$current !== state) return false;
      if (!params) return true;
      var schema = state.parameters({
        inherit: true,
        matchingKeys: params
      });
      return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    StateService.prototype.includes = function (stateOrName, params, options) {
      options = common_1.defaults(options, { relative: this.$current });
      var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
      if (glob) {
        if (!glob.matches(this.$current.name)) return false;
        stateOrName = this.$current.name;
      }
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative),
          include = this.$current.includes;
      if (!predicates_1.isDefined(state)) return undefined;
      if (!predicates_1.isDefined(include[state.name])) return false;
      if (!params) return true;
      var schema = state.parameters({
        inherit: true,
        matchingKeys: params
      });
      return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    StateService.prototype.href = function (stateOrName, params, options) {
      var defaultHrefOpts = {
        lossy: true,
        inherit: true,
        absolute: false,
        relative: this.$current
      };
      options = common_1.defaults(options, defaultHrefOpts);
      params = params || {};
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
      if (!predicates_1.isDefined(state)) return null;
      if (options.inherit) params = this.params.$inherit(params, this.$current, state);
      var nav = state && options.lossy ? state.navigable : state;
      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
    };
    StateService.prototype.defaultErrorHandler = function (handler) {
      return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
      var reg = this.router.stateRegistry;
      if (arguments.length === 0) return reg.get();
      return reg.get(stateOrName, base || this.$current);
    };
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
      var state = this.get(stateOrName);
      if (!state || !state.lazyLoad) throw new Error('Can not lazy load ' + stateOrName);
      var currentPath = this.getCurrentPath();
      var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
      transition = transition || this.router.transitionService.create(currentPath, target);
      return lazyLoad_1.lazyLoadState(transition, state);
    };
    return StateService;
  }();
  exports.StateService = StateService;
});
$__System.registerDynamic("146", ["164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var StateParams = function () {
    function StateParams(params) {
      if (params === void 0) {
        params = {};
      }
      common_1.extend(this, params);
    }
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
      var parentParams;
      var parents = common_1.ancestors($current, $to),
          inherited = {},
          inheritList = [];
      for (var i in parents) {
        if (!parents[i] || !parents[i].params) continue;
        parentParams = Object.keys(parents[i].params);
        if (!parentParams.length) continue;
        for (var j in parentParams) {
          if (inheritList.indexOf(parentParams[j]) >= 0) continue;
          inheritList.push(parentParams[j]);
          inherited[parentParams[j]] = this[parentParams[j]];
        }
      }
      return common_1.extend({}, inherited, newParams);
    };
    return StateParams;
  }();
  exports.StateParams = StateParams;
});
$__System.registerDynamic("17c", ["146", "17a"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var stateParams_1 = $__require("146");
  var queue_1 = $__require("17a");
  var UIRouterGlobals = function () {
    function UIRouterGlobals() {
      this.params = new stateParams_1.StateParams();
      this.lastStartedTransitionId = -1;
      this.transitionHistory = new queue_1.Queue([], 1);
      this.successfulTransitions = new queue_1.Queue([], 1);
    }
    UIRouterGlobals.prototype.dispose = function () {
      this.transitionHistory.clear();
      this.successfulTransitions.clear();
      this.transition = null;
    };
    return UIRouterGlobals;
  }();
  exports.UIRouterGlobals = UIRouterGlobals;
});
$__System.registerDynamic("161", ["167", "164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var coreservices_1 = $__require("167");
  var common_1 = $__require("164");
  var makeStub = function (keys) {
    return keys.reduce(function (acc, key) {
      return acc[key] = coreservices_1.notImplemented(key), acc;
    }, { dispose: common_1.noop });
  };
  var locationServicesFns = ['url', 'path', 'search', 'hash', 'onChange'];
  var locationConfigFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
  var umfFns = ['type', 'caseInsensitive', 'strictMode', 'defaultSquashPolicy'];
  var rulesFns = ['sort', 'when', 'initial', 'otherwise', 'rules', 'rule', 'removeRule'];
  var syncFns = ['deferIntercept', 'listen', 'sync', 'match'];
  var UrlService = function () {
    function UrlService(router, lateBind) {
      if (lateBind === void 0) {
        lateBind = true;
      }
      this.router = router;
      this.rules = {};
      this.config = {};
      var locationServices = function () {
        return router.locationService;
      };
      common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
      var locationConfig = function () {
        return router.locationConfig;
      };
      common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
      var umf = function () {
        return router.urlMatcherFactory;
      };
      common_1.createProxyFunctions(umf, this.config, umf, umfFns);
      var urlRouter = function () {
        return router.urlRouter;
      };
      common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
      common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
    }
    UrlService.prototype.url = function (newurl, replace, state) {
      return;
    };
    UrlService.prototype.path = function () {
      return;
    };
    UrlService.prototype.search = function () {
      return;
    };
    UrlService.prototype.hash = function () {
      return;
    };
    UrlService.prototype.onChange = function (callback) {
      return;
    };
    UrlService.prototype.parts = function () {
      return {
        path: this.path(),
        search: this.search(),
        hash: this.hash()
      };
    };
    UrlService.prototype.dispose = function () {};
    UrlService.prototype.sync = function (evt) {
      return;
    };
    UrlService.prototype.listen = function (enabled) {
      return;
    };
    UrlService.prototype.deferIntercept = function (defer) {
      return;
    };
    UrlService.prototype.match = function (urlParts) {
      return;
    };
    UrlService.locationServiceStub = makeStub(locationServicesFns);
    UrlService.locationConfigStub = makeStub(locationConfigFns);
    return UrlService;
  }();
  exports.UrlService = UrlService;
});
$__System.registerDynamic("170", ["15e", "15f", "15b", "163", "150", "151", "17c", "164", "165", "161", "16a"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var urlMatcherFactory_1 = $__require("15e");
  var urlRouter_1 = $__require("15f");
  var transitionService_1 = $__require("15b");
  var view_1 = $__require("163");
  var stateRegistry_1 = $__require("150");
  var stateService_1 = $__require("151");
  var globals_1 = $__require("17c");
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var urlService_1 = $__require("161");
  var trace_1 = $__require("16a");
  var _routerInstance = 0;
  var UIRouter = function () {
    function UIRouter(locationService, locationConfig) {
      if (locationService === void 0) {
        locationService = urlService_1.UrlService.locationServiceStub;
      }
      if (locationConfig === void 0) {
        locationConfig = urlService_1.UrlService.locationConfigStub;
      }
      this.locationService = locationService;
      this.locationConfig = locationConfig;
      this.$id = _routerInstance++;
      this._disposed = false;
      this._disposables = [];
      this.trace = trace_1.trace;
      this.viewService = new view_1.ViewService();
      this.globals = new globals_1.UIRouterGlobals();
      this.transitionService = new transitionService_1.TransitionService(this);
      this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
      this.urlRouter = new urlRouter_1.UrlRouter(this);
      this.stateRegistry = new stateRegistry_1.StateRegistry(this);
      this.stateService = new stateService_1.StateService(this);
      this.urlService = new urlService_1.UrlService(this);
      this._plugins = {};
      this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
      this.globals.$current = this.stateRegistry.root();
      this.globals.current = this.globals.$current.self;
      this.disposable(this.globals);
      this.disposable(this.stateService);
      this.disposable(this.stateRegistry);
      this.disposable(this.transitionService);
      this.disposable(this.urlRouter);
      this.disposable(locationService);
      this.disposable(locationConfig);
    }
    UIRouter.prototype.disposable = function (disposable) {
      this._disposables.push(disposable);
    };
    UIRouter.prototype.dispose = function (disposable) {
      var _this = this;
      if (disposable && predicates_1.isFunction(disposable.dispose)) {
        disposable.dispose(this);
        return undefined;
      }
      this._disposed = true;
      this._disposables.slice().forEach(function (d) {
        try {
          typeof d.dispose === 'function' && d.dispose(_this);
          common_1.removeFrom(_this._disposables, d);
        } catch (ignored) {}
      });
    };
    UIRouter.prototype.plugin = function (plugin, options) {
      if (options === void 0) {
        options = {};
      }
      var pluginInstance = new plugin(this, options);
      if (!pluginInstance.name) throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
      this._disposables.push(pluginInstance);
      return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
      return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
    };
    return UIRouter;
  }();
  exports.UIRouter = UIRouter;
});
$__System.registerDynamic("17d", ["165"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var BrowserLocationConfig = function () {
    function BrowserLocationConfig(router, _isHtml5) {
      if (_isHtml5 === void 0) {
        _isHtml5 = false;
      }
      this._isHtml5 = _isHtml5;
      this._baseHref = undefined;
      this._hashPrefix = '';
    }
    BrowserLocationConfig.prototype.port = function () {
      if (location.port) {
        return Number(location.port);
      }
      return this.protocol() === 'https' ? 443 : 80;
    };
    BrowserLocationConfig.prototype.protocol = function () {
      return location.protocol.replace(/:/g, '');
    };
    BrowserLocationConfig.prototype.host = function () {
      return location.hostname;
    };
    BrowserLocationConfig.prototype.html5Mode = function () {
      return this._isHtml5;
    };
    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
      return predicates_1.isDefined(newprefix) ? this._hashPrefix = newprefix : this._hashPrefix;
    };
    BrowserLocationConfig.prototype.baseHref = function (href) {
      return predicates_1.isDefined(href) ? this._baseHref = href : predicates_1.isDefined(this._baseHref) ? this._baseHref : this.applyDocumentBaseHref();
    };
    BrowserLocationConfig.prototype.applyDocumentBaseHref = function () {
      var baseTag = document.getElementsByTagName('base')[0];
      return this._baseHref = baseTag ? baseTag.href.substr(location.origin.length) : location.pathname || '/';
    };
    BrowserLocationConfig.prototype.dispose = function () {};
    return BrowserLocationConfig;
  }();
  exports.BrowserLocationConfig = BrowserLocationConfig;
});
$__System.registerDynamic("17e", ["169", "17f"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("169");
  var baseLocationService_1 = $__require("17f");
  var HashLocationService = function (_super) {
    __extends(HashLocationService, _super);
    function HashLocationService(router) {
      var _this = _super.call(this, router, false) || this;
      common_1.root.addEventListener('hashchange', _this._listener, false);
      return _this;
    }
    HashLocationService.prototype._get = function () {
      return common_1.trimHashVal(this._location.hash);
    };
    HashLocationService.prototype._set = function (state, title, url, replace) {
      this._location.hash = url;
    };
    HashLocationService.prototype.dispose = function (router) {
      _super.prototype.dispose.call(this, router);
      common_1.root.removeEventListener('hashchange', this._listener);
    };
    return HashLocationService;
  }(baseLocationService_1.BaseLocationServices);
  exports.HashLocationService = HashLocationService;
});
$__System.registerDynamic("180", ["17f", "169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  Object.defineProperty(exports, "__esModule", { value: true });
  var baseLocationService_1 = $__require("17f");
  var common_1 = $__require("169");
  var PushStateLocationService = function (_super) {
    __extends(PushStateLocationService, _super);
    function PushStateLocationService(router) {
      var _this = _super.call(this, router, true) || this;
      _this._config = router.urlService.config;
      common_1.root.addEventListener('popstate', _this._listener, false);
      return _this;
    }
    PushStateLocationService.prototype._getBasePrefix = function () {
      return common_1.stripLastPathElement(this._config.baseHref());
    };
    PushStateLocationService.prototype._get = function () {
      var _a = this._location,
          pathname = _a.pathname,
          hash = _a.hash,
          search = _a.search;
      search = common_1.splitQuery(search)[1];
      hash = common_1.splitHash(hash)[1];
      var basePrefix = this._getBasePrefix();
      var exactBaseHrefMatch = pathname === this._config.baseHref();
      var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
      pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
      return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
    };
    PushStateLocationService.prototype._set = function (state, title, url, replace) {
      var basePrefix = this._getBasePrefix();
      var slash = url && url[0] !== '/' ? '/' : '';
      var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
      if (replace) {
        this._history.replaceState(state, title, fullUrl);
      } else {
        this._history.pushState(state, title, fullUrl);
      }
    };
    PushStateLocationService.prototype.dispose = function (router) {
      _super.prototype.dispose.call(this, router);
      common_1.root.removeEventListener('popstate', this._listener);
    };
    return PushStateLocationService;
  }(baseLocationService_1.BaseLocationServices);
  exports.PushStateLocationService = PushStateLocationService;
});
$__System.registerDynamic("181", ["169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("169");
  exports.keyValsToObjectR = function (accum, _a) {
    var key = _a[0],
        val = _a[1];
    if (!accum.hasOwnProperty(key)) {
      accum[key] = val;
    } else if (common_1.isArray(accum[key])) {
      accum[key].push(val);
    } else {
      accum[key] = [accum[key], val];
    }
    return accum;
  };
  exports.getParams = function (queryString) {
    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
  };
  function parseUrl(url) {
    var orEmptyString = function (x) {
      return x || '';
    };
    var _a = common_1.splitHash(url).map(orEmptyString),
        beforehash = _a[0],
        hash = _a[1];
    var _b = common_1.splitQuery(beforehash).map(orEmptyString),
        path = _b[0],
        search = _b[1];
    return {
      path: path,
      search: search,
      hash: hash,
      url: url
    };
  }
  exports.parseUrl = parseUrl;
  exports.buildUrl = function (loc) {
    var path = loc.path();
    var searchObject = loc.search();
    var hash = loc.hash();
    var search = Object.keys(searchObject).map(function (key) {
      var param = searchObject[key];
      var vals = common_1.isArray(param) ? param : [param];
      return vals.map(function (val) {
        return key + '=' + val;
      });
    }).reduce(common_1.unnestR, []).join('&');
    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
  };
  function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
    return function (uiRouter) {
      var service = uiRouter.locationService = new serviceClass(uiRouter);
      var configuration = uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5);
      function dispose(router) {
        router.dispose(service);
        router.dispose(configuration);
      }
      return {
        name: name,
        service: service,
        configuration: configuration,
        dispose: dispose
      };
    };
  }
  exports.locationPluginFactory = locationPluginFactory;
});
$__System.registerDynamic("17f", ["169", "181"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("169");
  var utils_1 = $__require("181");
  var BaseLocationServices = function () {
    function BaseLocationServices(router, fireAfterUpdate) {
      var _this = this;
      this.fireAfterUpdate = fireAfterUpdate;
      this._listeners = [];
      this._listener = function (evt) {
        return _this._listeners.forEach(function (cb) {
          return cb(evt);
        });
      };
      this.hash = function () {
        return utils_1.parseUrl(_this._get()).hash;
      };
      this.path = function () {
        return utils_1.parseUrl(_this._get()).path;
      };
      this.search = function () {
        return utils_1.getParams(utils_1.parseUrl(_this._get()).search);
      };
      this._location = common_1.root.location;
      this._history = common_1.root.history;
    }
    BaseLocationServices.prototype.url = function (url, replace) {
      if (replace === void 0) {
        replace = true;
      }
      if (common_1.isDefined(url) && url !== this._get()) {
        this._set(null, null, url, replace);
        if (this.fireAfterUpdate) {
          this._listeners.forEach(function (cb) {
            return cb({ url: url });
          });
        }
      }
      return utils_1.buildUrl(this);
    };
    BaseLocationServices.prototype.onChange = function (cb) {
      var _this = this;
      this._listeners.push(cb);
      return function () {
        return common_1.removeFrom(_this._listeners, cb);
      };
    };
    BaseLocationServices.prototype.dispose = function (router) {
      common_1.deregAll(this._listeners);
    };
    return BaseLocationServices;
  }();
  exports.BaseLocationServices = BaseLocationServices;
});
$__System.registerDynamic("182", ["17f"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  Object.defineProperty(exports, "__esModule", { value: true });
  var baseLocationService_1 = $__require("17f");
  var MemoryLocationService = function (_super) {
    __extends(MemoryLocationService, _super);
    function MemoryLocationService(router) {
      return _super.call(this, router, true) || this;
    }
    MemoryLocationService.prototype._get = function () {
      return this._url;
    };
    MemoryLocationService.prototype._set = function (state, title, url, replace) {
      this._url = url;
    };
    return MemoryLocationService;
  }(baseLocationService_1.BaseLocationServices);
  exports.MemoryLocationService = MemoryLocationService;
});
$__System.registerDynamic("183", ["165", "164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var common_1 = $__require("164");
  var MemoryLocationConfig = function () {
    function MemoryLocationConfig() {
      var _this = this;
      this.dispose = common_1.noop;
      this._baseHref = '';
      this._port = 80;
      this._protocol = 'http';
      this._host = 'localhost';
      this._hashPrefix = '';
      this.port = function () {
        return _this._port;
      };
      this.protocol = function () {
        return _this._protocol;
      };
      this.host = function () {
        return _this._host;
      };
      this.baseHref = function () {
        return _this._baseHref;
      };
      this.html5Mode = function () {
        return false;
      };
      this.hashPrefix = function (newval) {
        return predicates_1.isDefined(newval) ? _this._hashPrefix = newval : _this._hashPrefix;
      };
    }
    return MemoryLocationConfig;
  }();
  exports.MemoryLocationConfig = MemoryLocationConfig;
});
$__System.registerDynamic("184", ["169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var index_1 = $__require("169");
  var globals = {};
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  var ARGUMENT_NAMES = /([^\s,]+)/g;
  exports.$injector = {
    get: function (name) {
      return globals[name];
    },
    has: function (name) {
      return exports.$injector.get(name) != null;
    },
    invoke: function (fn, context, locals) {
      var all = index_1.extend({}, globals, locals || {});
      var params = exports.$injector.annotate(fn);
      var ensureExist = index_1.assertPredicate(function (key) {
        return all.hasOwnProperty(key);
      }, function (key) {
        return "DI can't find injectable: '" + key + "'";
      });
      var args = params.filter(ensureExist).map(function (x) {
        return all[x];
      });
      if (index_1.isFunction(fn)) return fn.apply(context, args);else return fn.slice(-1)[0].apply(context, args);
    },
    annotate: function (fn) {
      if (!index_1.isInjectable(fn)) throw new Error("Not an injectable function: " + fn);
      if (fn && fn.$inject) return fn.$inject;
      if (index_1.isArray(fn)) return fn.slice(0, -1);
      var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
      var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
      return result || [];
    }
  };
});
$__System.registerDynamic("17a", ["164"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var Queue = function () {
    function Queue(_items, _limit) {
      if (_items === void 0) {
        _items = [];
      }
      if (_limit === void 0) {
        _limit = null;
      }
      this._items = _items;
      this._limit = _limit;
      this._evictListeners = [];
      this.onEvict = common_1.pushTo(this._evictListeners);
    }
    Queue.prototype.enqueue = function (item) {
      var items = this._items;
      items.push(item);
      if (this._limit && items.length > this._limit) this.evict();
      return item;
    };
    Queue.prototype.evict = function () {
      var item = this._items.shift();
      this._evictListeners.forEach(function (fn) {
        return fn(item);
      });
      return item;
    };
    Queue.prototype.dequeue = function () {
      if (this.size()) return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
      var current = this._items;
      this._items = [];
      return current;
    };
    Queue.prototype.size = function () {
      return this._items.length;
    };
    Queue.prototype.remove = function (item) {
      var idx = this._items.indexOf(item);
      return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
      return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
      if (this.size()) return this._items[0];
    };
    return Queue;
  }();
  exports.Queue = Queue;
});
$__System.registerDynamic("156", ["169", "154"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("169");
  var interface_1 = $__require("154");
  function matchState(state, criterion) {
    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
      var globStrings = toMatch;
      for (var i = 0; i < globStrings.length; i++) {
        var glob = new common_1.Glob(globStrings[i]);
        if (glob && glob.matches(_state.name) || !glob && globStrings[i] === _state.name) {
          return true;
        }
      }
      return false;
    }
    var matchFn = common_1.isFunction(toMatch) ? toMatch : matchGlobs;
    return !!matchFn(state);
  }
  exports.matchState = matchState;
  var RegisteredHook = function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
      if (options === void 0) {
        options = {};
      }
      this.tranSvc = tranSvc;
      this.eventType = eventType;
      this.callback = callback;
      this.matchCriteria = matchCriteria;
      this.removeHookFromRegistry = removeHookFromRegistry;
      this.invokeCount = 0;
      this._deregistered = false;
      this.priority = options.priority || 0;
      this.bind = options.bind || null;
      this.invokeLimit = options.invokeLimit;
    }
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
      if (criterion === true) return nodes;
      var matching = nodes.filter(function (node) {
        return matchState(node.state, criterion);
      });
      return matching.length ? matching : null;
    };
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
      return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () {
        return true;
      });
    };
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
      var _this = this;
      var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
      var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
      return paths.reduce(function (mn, pathtype) {
        var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
        var path = treeChanges[pathtype.name] || [];
        var nodes = isStateHook ? path : [common_1.tail(path)];
        mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
        return mn;
      }, {});
    };
    RegisteredHook.prototype.matches = function (treeChanges) {
      var matches = this._getMatchingNodes(treeChanges);
      var allMatched = common_1.values(matches).every(common_1.identity);
      return allMatched ? matches : null;
    };
    RegisteredHook.prototype.deregister = function () {
      this.removeHookFromRegistry(this);
      this._deregistered = true;
    };
    return RegisteredHook;
  }();
  exports.RegisteredHook = RegisteredHook;
  function makeEvent(registry, transitionService, eventType) {
    var _registeredHooks = registry._registeredHooks = registry._registeredHooks || {};
    var hooks = _registeredHooks[eventType.name] = [];
    var removeHookFn = common_1.removeFrom(hooks);
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
      if (options === void 0) {
        options = {};
      }
      var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
      hooks.push(registeredHook);
      return registeredHook.deregister.bind(registeredHook);
    }
    return hookRegistrationFn;
  }
  exports.makeEvent = makeEvent;
});
$__System.registerDynamic("154", [], true, function ($__require, exports, module) {
    /* */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    var TransitionHookPhase;
    (function (TransitionHookPhase) {
        TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
        TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
        TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
        TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
        TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
    })(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
    var TransitionHookScope;
    (function (TransitionHookScope) {
        TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
        TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
    })(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
    
});
$__System.registerDynamic('157', ['164', '168', '166'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require('164');
  var strings_1 = $__require('168');
  var hof_1 = $__require('166');
  var RejectType;
  (function (RejectType) {
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
  })(RejectType = exports.RejectType || (exports.RejectType = {}));
  var id = 0;
  var Rejection = function () {
    function Rejection(type, message, detail) {
      this.$id = id++;
      this.type = type;
      this.message = message;
      this.detail = detail;
    }
    Rejection.isRejectionPromise = function (obj) {
      return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
    };
    Rejection.superseded = function (detail, options) {
      var message = 'The transition has been superseded by a different transition';
      var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
      if (options && options.redirected) {
        rejection.redirected = true;
      }
      return rejection;
    };
    Rejection.redirected = function (detail) {
      return Rejection.superseded(detail, { redirected: true });
    };
    Rejection.invalid = function (detail) {
      var message = 'This transition is invalid';
      return new Rejection(RejectType.INVALID, message, detail);
    };
    Rejection.ignored = function (detail) {
      var message = 'The transition was ignored';
      return new Rejection(RejectType.IGNORED, message, detail);
    };
    Rejection.aborted = function (detail) {
      var message = 'The transition has been aborted';
      return new Rejection(RejectType.ABORTED, message, detail);
    };
    Rejection.errored = function (detail) {
      var message = 'The transition errored';
      return new Rejection(RejectType.ERROR, message, detail);
    };
    Rejection.normalize = function (detail) {
      return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
    };
    Rejection.prototype.toString = function () {
      var detailString = function (d) {
        return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
      };
      var detail = detailString(this.detail);
      var _a = this,
          $id = _a.$id,
          type = _a.type,
          message = _a.message;
      return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
      return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
    };
    return Rejection;
  }();
  exports.Rejection = Rejection;
});
$__System.registerDynamic("159", ["154", "164", "168", "165", "166", "16a", "167", "157", "152", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var interface_1 = $__require("154");
    var common_1 = $__require("164");
    var strings_1 = $__require("168");
    var predicates_1 = $__require("165");
    var hof_1 = $__require("166");
    var trace_1 = $__require("16a");
    var coreservices_1 = $__require("167");
    var rejectFactory_1 = $__require("157");
    var targetState_1 = $__require("152");
    var defaultOptions = {
      current: common_1.noop,
      transition: null,
      traceData: {},
      bind: null
    };
    var TransitionHook = function () {
      function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.isSuperseded = function () {
          return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive();
        };
        this.options = common_1.defaults(options, defaultOptions);
        this.type = registeredHook.eventType;
      }
      TransitionHook.chain = function (hooks, waitFor) {
        var createHookChainR = function (prev, nextHook) {
          return prev.then(function () {
            return nextHook.invokeHook();
          });
        };
        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
      };
      TransitionHook.invokeHooks = function (hooks, doneCallback) {
        for (var idx = 0; idx < hooks.length; idx++) {
          var hookResult = hooks[idx].invokeHook();
          if (predicates_1.isPromise(hookResult)) {
            var remainingHooks = hooks.slice(idx + 1);
            return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
          }
        }
        return doneCallback();
      };
      TransitionHook.runAllHooks = function (hooks) {
        hooks.forEach(function (hook) {
          return hook.invokeHook();
        });
      };
      TransitionHook.prototype.logError = function (err) {
        this.transition.router.stateService.defaultErrorHandler()(err);
      };
      TransitionHook.prototype.invokeHook = function () {
        var _this = this;
        var hook = this.registeredHook;
        if (hook._deregistered) return;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent) return notCurrent;
        var options = this.options;
        trace_1.trace.traceHookInvocation(this, this.transition, options);
        var invokeCallback = function () {
          return hook.callback.call(options.bind, _this.transition, _this.stateContext);
        };
        var normalizeErr = function (err) {
          return rejectFactory_1.Rejection.normalize(err).toPromise();
        };
        var handleError = function (err) {
          return hook.eventType.getErrorHandler(_this)(err);
        };
        var handleResult = function (result) {
          return hook.eventType.getResultHandler(_this)(result);
        };
        try {
          var result = invokeCallback();
          if (!this.type.synchronous && predicates_1.isPromise(result)) {
            return result.catch(normalizeErr).then(handleResult, handleError);
          } else {
            return handleResult(result);
          }
        } catch (err) {
          return handleError(rejectFactory_1.Rejection.normalize(err));
        } finally {
          if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
            hook.deregister();
          }
        }
      };
      TransitionHook.prototype.handleHookResult = function (result) {
        var _this = this;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent) return notCurrent;
        if (predicates_1.isPromise(result)) {
          return result.then(function (val) {
            return _this.handleHookResult(val);
          });
        }
        trace_1.trace.traceHookResult(result, this.transition, this.options);
        if (result === false) {
          return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
        }
        var isTargetState = hof_1.is(targetState_1.TargetState);
        if (isTargetState(result)) {
          return rejectFactory_1.Rejection.redirected(result).toPromise();
        }
      };
      TransitionHook.prototype.getNotCurrentRejection = function () {
        var router = this.transition.router;
        if (router._disposed) {
          return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
        }
        if (this.transition._aborted) {
          return rejectFactory_1.Rejection.aborted().toPromise();
        }
        if (this.isSuperseded()) {
          return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
        }
      };
      TransitionHook.prototype.toString = function () {
        var _a = this,
            options = _a.options,
            registeredHook = _a.registeredHook;
        var event = hof_1.parse('traceData.hookType')(options) || 'internal',
            context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown',
            name = strings_1.fnToString(registeredHook.callback);
        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
      };
      TransitionHook.HANDLE_RESULT = function (hook) {
        return function (result) {
          return hook.handleHookResult(result);
        };
      };
      TransitionHook.LOG_REJECTED_RESULT = function (hook) {
        return function (result) {
          predicates_1.isPromise(result) && result.catch(function (err) {
            return hook.logError(rejectFactory_1.Rejection.normalize(err));
          });
          return undefined;
        };
      };
      TransitionHook.LOG_ERROR = function (hook) {
        return function (error) {
          return hook.logError(error);
        };
      };
      TransitionHook.REJECT_ERROR = function (hook) {
        return function (error) {
          return common_1.silentRejection(error);
        };
      };
      TransitionHook.THROW_ERROR = function (hook) {
        return function (error) {
          throw error;
        };
      };
      return TransitionHook;
    }();
    exports.TransitionHook = TransitionHook;
  })($__require("f9"));
});
$__System.registerDynamic("155", ["164", "165", "154", "159"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var interface_1 = $__require("154");
  var transitionHook_1 = $__require("159");
  var HookBuilder = function () {
    function HookBuilder(transition) {
      this.transition = transition;
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
      var _this = this;
      var $transitions = this.transition.router.transitionService;
      return $transitions._pluginapi._getEvents(phase).map(function (type) {
        return _this.buildHooks(type);
      }).reduce(common_1.unnestR, []).filter(common_1.identity);
    };
    HookBuilder.prototype.buildHooks = function (hookType) {
      var transition = this.transition;
      var treeChanges = transition.treeChanges();
      var matchingHooks = this.getMatchingHooks(hookType, treeChanges);
      if (!matchingHooks) return [];
      var baseHookOptions = {
        transition: transition,
        current: transition.options().current
      };
      var makeTransitionHooks = function (hook) {
        var matches = hook.matches(treeChanges);
        var matchingNodes = matches[hookType.criteriaMatchPath.name];
        return matchingNodes.map(function (node) {
          var _options = common_1.extend({
            bind: hook.bind,
            traceData: {
              hookType: hookType.name,
              context: node
            }
          }, baseHookOptions);
          var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
          var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
          return {
            hook: hook,
            node: node,
            transitionHook: transitionHook
          };
        });
      };
      return matchingHooks.map(makeTransitionHooks).reduce(common_1.unnestR, []).sort(tupleSort(hookType.reverseSort)).map(function (tuple) {
        return tuple.transitionHook;
      });
    };
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
      var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
      var $transitions = this.transition.router.transitionService;
      var registries = isCreate ? [$transitions] : [this.transition, $transitions];
      return registries.map(function (reg) {
        return reg.getHooks(hookType.name);
      }).filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)).reduce(common_1.unnestR, []).filter(function (hook) {
        return hook.matches(treeChanges);
      });
    };
    return HookBuilder;
  }();
  exports.HookBuilder = HookBuilder;
  function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) {
      reverseDepthSort = false;
    }
    return function nodeDepthThenPriority(l, r) {
      var factor = reverseDepthSort ? -1 : 1;
      var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
      return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
  }
});
$__System.registerDynamic("16d", [], true, function ($__require, exports, module) {
    /* */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    /** @internalapi */
    exports.resolvePolicies = {
        when: {
            LAZY: 'LAZY',
            EAGER: 'EAGER'
        },
        async: {
            WAIT: 'WAIT',
            NOWAIT: 'NOWAIT',
            RXWAIT: 'RXWAIT'
        }
    };
    
});
$__System.registerDynamic("152", ["165", "168", "169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var strings_1 = $__require("168");
  var common_1 = $__require("169");
  var TargetState = function () {
    function TargetState(_stateRegistry, _identifier, _params, _options) {
      this._stateRegistry = _stateRegistry;
      this._identifier = _identifier;
      this._identifier = _identifier;
      this._params = common_1.extend({}, _params || {});
      this._options = common_1.extend({}, _options || {});
      this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
    }
    TargetState.prototype.name = function () {
      return this._definition && this._definition.name || this._identifier;
    };
    TargetState.prototype.identifier = function () {
      return this._identifier;
    };
    TargetState.prototype.params = function () {
      return this._params;
    };
    TargetState.prototype.$state = function () {
      return this._definition;
    };
    TargetState.prototype.state = function () {
      return this._definition && this._definition.self;
    };
    TargetState.prototype.options = function () {
      return this._options;
    };
    TargetState.prototype.exists = function () {
      return !!(this._definition && this._definition.self);
    };
    TargetState.prototype.valid = function () {
      return !this.error();
    };
    TargetState.prototype.error = function () {
      var base = this.options().relative;
      if (!this._definition && !!base) {
        var stateName = base.name ? base.name : base;
        return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
      }
      if (!this._definition) return "No such state '" + this.name() + "'";
      if (!this._definition.self) return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
      return "'" + this.name() + "'" + strings_1.stringify(this.params());
    };
    TargetState.prototype.withState = function (state) {
      return new TargetState(this._stateRegistry, state, this._params, this._options);
    };
    TargetState.prototype.withParams = function (params, replace) {
      if (replace === void 0) {
        replace = false;
      }
      var newParams = replace ? params : common_1.extend({}, this._params, params);
      return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
    };
    TargetState.prototype.withOptions = function (options, replace) {
      if (replace === void 0) {
        replace = false;
      }
      var newOpts = replace ? options : common_1.extend({}, this._options, options);
      return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
    };
    TargetState.isDef = function (obj) {
      return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
    };
    return TargetState;
  }();
  exports.TargetState = TargetState;
});
$__System.registerDynamic("147", ["164", "165"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var predicates_1 = $__require("165");
  var ParamType = function () {
    function ParamType(def) {
      this.pattern = /.*/;
      this.inherit = true;
      common_1.extend(this, def);
    }
    ParamType.prototype.is = function (val, key) {
      return true;
    };
    ParamType.prototype.encode = function (val, key) {
      return val;
    };
    ParamType.prototype.decode = function (val, key) {
      return val;
    };
    ParamType.prototype.equals = function (a, b) {
      return a == b;
    };
    ParamType.prototype.$subPattern = function () {
      var sub = this.pattern.toString();
      return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
      return "{ParamType:" + this.name + "}";
    };
    ParamType.prototype.$normalize = function (val) {
      return this.is(val) ? val : this.decode(val);
    };
    ParamType.prototype.$asArray = function (mode, isSearch) {
      if (!mode) return this;
      if (mode === 'auto' && !isSearch) throw new Error("'auto' array mode is for query parameters only");
      return new ArrayType(this, mode);
    };
    return ParamType;
  }();
  exports.ParamType = ParamType;
  function ArrayType(type, mode) {
    var _this = this;
    function arrayWrap(val) {
      return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
    }
    function arrayUnwrap(val) {
      switch (val.length) {
        case 0:
          return undefined;
        case 1:
          return mode === 'auto' ? val[0] : val;
        default:
          return val;
      }
    }
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (predicates_1.isArray(val) && val.length === 0) return val;
        var arr = arrayWrap(val);
        var result = common_1.map(arr, callback);
        return allTruthyMode === true ? common_1.filter(result, function (x) {
          return !x;
        }).length === 0 : arrayUnwrap(result);
      };
    }
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1),
            right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
      var paramTypeFn = type[name].bind(type);
      var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
      _this[name] = wrapperFn(paramTypeFn);
    });
    common_1.extend(this, {
      dynamic: type.dynamic,
      name: type.name,
      pattern: type.pattern,
      inherit: type.inherit,
      is: arrayHandler(type.is.bind(type), true),
      $arrayMode: mode
    });
  }
});
$__System.registerDynamic("144", ["164", "166", "165", "167", "147"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var predicates_1 = $__require("165");
  var coreservices_1 = $__require("167");
  var paramType_1 = $__require("147");
  var hasOwn = Object.prototype.hasOwnProperty;
  var isShorthand = function (cfg) {
    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
  };
  var DefType;
  (function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
  })(DefType = exports.DefType || (exports.DefType = {}));
  function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) && { value: cfg } || cfg;
    getStaticDefaultValue['__cacheable'] = true;
    function getStaticDefaultValue() {
      return cfg.value;
    }
    return common_1.extend(cfg, { $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue });
  }
  function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string') throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type)) return paramTypes.type(cfg.type);
    if (urlType) return urlType;
    if (!cfg.type) {
      var type = location === DefType.CONFIG ? 'any' : location === DefType.PATH ? 'path' : location === DefType.SEARCH ? 'query' : 'string';
      return paramTypes.type(type);
    }
    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
  }
  function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false) return false;
    if (!predicates_1.isDefined(squash) || squash == null) return defaultPolicy;
    if (squash === true || predicates_1.isString(squash)) return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
  }
  function getReplace(config, arrayMode, isOptional, squash) {
    var defaultPolicy = [{
      from: '',
      to: isOptional || arrayMode ? undefined : ''
    }, {
      from: null,
      to: isOptional || arrayMode ? undefined : ''
    }];
    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
    if (predicates_1.isString(squash)) replace.push({
      from: squash,
      to: undefined
    });
    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
    return common_1.filter(defaultPolicy, function (item) {
      return configuredKeys.indexOf(item.from) === -1;
    }).concat(replace);
  }
  var Param = function () {
    function Param(id, type, config, location, urlMatcherFactory) {
      config = unwrapShorthand(config);
      type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
      var arrayMode = getArrayMode();
      type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
      var isOptional = config.value !== undefined || location === DefType.SEARCH;
      var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
      var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
      var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
      var replace = getReplace(config, arrayMode, isOptional, squash);
      var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
      function getArrayMode() {
        var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
        var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
        return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
      }
      common_1.extend(this, {
        id: id,
        type: type,
        location: location,
        isOptional: isOptional,
        dynamic: dynamic,
        raw: raw,
        squash: squash,
        replace: replace,
        inherit: inherit,
        array: arrayMode,
        config: config
      });
    }
    Param.values = function (params, values) {
      if (values === void 0) {
        values = {};
      }
      var paramValues = {};
      for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
        var param = params_1[_i];
        paramValues[param.id] = param.value(values[param.id]);
      }
      return paramValues;
    };
    Param.changed = function (params, values1, values2) {
      if (values1 === void 0) {
        values1 = {};
      }
      if (values2 === void 0) {
        values2 = {};
      }
      return params.filter(function (param) {
        return !param.type.equals(values1[param.id], values2[param.id]);
      });
    };
    Param.equals = function (params, values1, values2) {
      if (values1 === void 0) {
        values1 = {};
      }
      if (values2 === void 0) {
        values2 = {};
      }
      return Param.changed(params, values1, values2).length === 0;
    };
    Param.validates = function (params, values) {
      if (values === void 0) {
        values = {};
      }
      return params.map(function (param) {
        return param.validates(values[param.id]);
      }).reduce(common_1.allTrueR, true);
    };
    Param.prototype.isDefaultValue = function (value) {
      return this.isOptional && this.type.equals(this.value(), value);
    };
    Param.prototype.value = function (value) {
      var _this = this;
      var getDefaultValue = function () {
        if (_this._defaultValueCache) return _this._defaultValueCache.defaultValue;
        if (!coreservices_1.services.$injector) throw new Error('Injectable functions cannot be called at configuration time');
        var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
        if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
        if (_this.config.$$fn['__cacheable']) {
          _this._defaultValueCache = { defaultValue: defaultValue };
        }
        return defaultValue;
      };
      var replaceSpecialValues = function (val) {
        for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
          var tuple = _a[_i];
          if (tuple.from === val) return tuple.to;
        }
        return val;
      };
      value = replaceSpecialValues(value);
      return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
      return this.location === DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
      if ((predicates_1.isUndefined(value) || value === null) && this.isOptional) return true;
      var normalized = this.type.$normalize(value);
      if (!this.type.is(normalized)) return false;
      var encoded = this.type.encode(normalized);
      return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
      return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    return Param;
  }();
  exports.Param = Param;
});
$__System.registerDynamic("149", ["164", "166", "144"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var param_1 = $__require("144");
  var PathNode = function () {
    function PathNode(stateOrNode) {
      if (stateOrNode instanceof PathNode) {
        var node = stateOrNode;
        this.state = node.state;
        this.paramSchema = node.paramSchema.slice();
        this.paramValues = common_1.extend({}, node.paramValues);
        this.resolvables = node.resolvables.slice();
        this.views = node.views && node.views.slice();
      } else {
        var state = stateOrNode;
        this.state = state;
        this.paramSchema = state.parameters({ inherit: false });
        this.paramValues = {};
        this.resolvables = state.resolvables.map(function (res) {
          return res.clone();
        });
      }
    }
    PathNode.prototype.clone = function () {
      return new PathNode(this);
    };
    PathNode.prototype.applyRawParams = function (params) {
      var getParamVal = function (paramDef) {
        return [paramDef.id, paramDef.value(params[paramDef.id])];
      };
      this.paramValues = this.paramSchema.reduce(function (memo, pDef) {
        return common_1.applyPairs(memo, getParamVal(pDef));
      }, {});
      return this;
    };
    PathNode.prototype.parameter = function (name) {
      return common_1.find(this.paramSchema, hof_1.propEq('id', name));
    };
    PathNode.prototype.equals = function (node, paramsFn) {
      var diff = this.diff(node, paramsFn);
      return diff && diff.length === 0;
    };
    PathNode.prototype.diff = function (node, paramsFn) {
      if (this.state !== node.state) return false;
      var params = paramsFn ? paramsFn(this) : this.paramSchema;
      return param_1.Param.changed(params, this.paramValues, node.paramValues);
    };
    PathNode.clone = function (node) {
      return node.clone();
    };
    return PathNode;
  }();
  exports.PathNode = PathNode;
});
$__System.registerDynamic("14a", ["164", "166", "152", "149"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var targetState_1 = $__require("152");
  var pathNode_1 = $__require("149");
  var PathUtils = function () {
    function PathUtils() {}
    PathUtils.makeTargetState = function (registry, path) {
      var state = common_1.tail(path).state;
      return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
    };
    PathUtils.buildPath = function (targetState) {
      var toParams = targetState.params();
      return targetState.$state().path.map(function (state) {
        return new pathNode_1.PathNode(state).applyRawParams(toParams);
      });
    };
    PathUtils.buildToPath = function (fromPath, targetState) {
      var toPath = PathUtils.buildPath(targetState);
      if (targetState.options().inherit) {
        return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
      }
      return toPath;
    };
    PathUtils.applyViewConfigs = function ($view, path, states) {
      path.filter(function (node) {
        return common_1.inArray(states, node.state);
      }).forEach(function (node) {
        var viewDecls = common_1.values(node.state.views || {});
        var subPath = PathUtils.subPath(path, function (n) {
          return n === node;
        });
        var viewConfigs = viewDecls.map(function (view) {
          return $view.createViewConfig(subPath, view);
        });
        node.views = viewConfigs.reduce(common_1.unnestR, []);
      });
    };
    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
      if (toKeys === void 0) {
        toKeys = [];
      }
      function nodeParamVals(path, state) {
        var node = common_1.find(path, hof_1.propEq('state', state));
        return common_1.extend({}, node && node.paramValues);
      }
      var noInherit = fromPath.map(function (node) {
        return node.paramSchema;
      }).reduce(common_1.unnestR, []).filter(function (param) {
        return !param.inherit;
      }).map(hof_1.prop('id'));
      function makeInheritedParamsNode(toNode) {
        var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
        var incomingParamVals = common_1.pick(toParamVals, toKeys);
        toParamVals = common_1.omit(toParamVals, toKeys);
        var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
        var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
        return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
      }
      return toPath.map(makeInheritedParamsNode);
    };
    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
      var max = Math.min(fromPath.length, toPath.length);
      var keep = 0;
      var nodesMatch = function (node1, node2) {
        return node1.equals(node2, PathUtils.nonDynamicParams);
      };
      while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
        keep++;
      }
      function applyToParams(retainedNode, idx) {
        var cloned = retainedNode.clone();
        cloned.paramValues = toPath[idx].paramValues;
        return cloned;
      }
      var from, retained, exiting, entering, to;
      from = fromPath;
      retained = from.slice(0, keep);
      exiting = from.slice(keep);
      var retainedWithToParams = retained.map(applyToParams);
      entering = toPath.slice(keep);
      to = retainedWithToParams.concat(entering);
      return {
        from: from,
        to: to,
        retained: retained,
        retainedWithToParams: retainedWithToParams,
        exiting: exiting,
        entering: entering
      };
    };
    PathUtils.matching = function (pathA, pathB, paramsFn) {
      var done = false;
      var tuples = common_1.arrayTuples(pathA, pathB);
      return tuples.reduce(function (matching, _a) {
        var nodeA = _a[0],
            nodeB = _a[1];
        done = done || !nodeA.equals(nodeB, paramsFn);
        return done ? matching : matching.concat(nodeA);
      }, []);
    };
    PathUtils.equals = function (pathA, pathB, paramsFn) {
      return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
    };
    PathUtils.subPath = function (path, predicate) {
      var node = common_1.find(path, predicate);
      var elementIdx = path.indexOf(node);
      return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    PathUtils.nonDynamicParams = function (node) {
      return node.state.parameters({ inherit: false }).filter(function (param) {
        return !param.dynamic;
      });
    };
    PathUtils.paramValues = function (path) {
      return path.reduce(function (acc, node) {
        return common_1.extend(acc, node.paramValues);
      }, {});
    };
    return PathUtils;
  }();
  exports.PathUtils = PathUtils;
});
$__System.registerDynamic("16e", ["164", "166", "16a", "167", "16d", "16b", "14a", "168", "169", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var common_1 = $__require("164");
    var hof_1 = $__require("166");
    var trace_1 = $__require("16a");
    var coreservices_1 = $__require("167");
    var interface_1 = $__require("16d");
    var resolvable_1 = $__require("16b");
    var pathUtils_1 = $__require("14a");
    var strings_1 = $__require("168");
    var common_2 = $__require("169");
    var whens = interface_1.resolvePolicies.when;
    var ALL_WHENS = [whens.EAGER, whens.LAZY];
    var EAGER_WHENS = [whens.EAGER];
    exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
    var ResolveContext = function () {
      function ResolveContext(_path) {
        this._path = _path;
      }
      ResolveContext.prototype.getTokens = function () {
        return this._path.reduce(function (acc, node) {
          return acc.concat(node.resolvables.map(function (r) {
            return r.token;
          }));
        }, []).reduce(common_1.uniqR, []);
      };
      ResolveContext.prototype.getResolvable = function (token) {
        var matching = this._path.map(function (node) {
          return node.resolvables;
        }).reduce(common_1.unnestR, []).filter(function (r) {
          return r.token === token;
        });
        return common_1.tail(matching);
      };
      ResolveContext.prototype.getPolicy = function (resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
      };
      ResolveContext.prototype.subContext = function (state) {
        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) {
          return node.state === state;
        }));
      };
      ResolveContext.prototype.addResolvables = function (newResolvables, state) {
        var node = common_1.find(this._path, hof_1.propEq('state', state));
        var keys = newResolvables.map(function (r) {
          return r.token;
        });
        node.resolvables = node.resolvables.filter(function (r) {
          return keys.indexOf(r.token) === -1;
        }).concat(newResolvables);
      };
      ResolveContext.prototype.resolvePath = function (when, trans) {
        var _this = this;
        if (when === void 0) {
          when = 'LAZY';
        }
        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
        trace_1.trace.traceResolvePath(this._path, when, trans);
        var matchesPolicy = function (acceptedVals, whenOrAsync) {
          return function (resolvable) {
            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
          };
        };
        var promises = this._path.reduce(function (acc, node) {
          var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
          var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
          var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
          var subContext = _this.subContext(node.state);
          var getResult = function (r) {
            return r.get(subContext, trans).then(function (value) {
              return {
                token: r.token,
                value: value
              };
            });
          };
          nowait.forEach(getResult);
          return acc.concat(wait.map(getResult));
        }, []);
        return coreservices_1.services.$q.all(promises);
      };
      ResolveContext.prototype.injector = function () {
        return this._injector || (this._injector = new UIInjectorImpl(this));
      };
      ResolveContext.prototype.findNode = function (resolvable) {
        return common_1.find(this._path, function (node) {
          return common_1.inArray(node.resolvables, resolvable);
        });
      };
      ResolveContext.prototype.getDependencies = function (resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) {
          return x === node;
        }) || this._path;
        var availableResolvables = subPath.reduce(function (acc, _node) {
          return acc.concat(_node.resolvables);
        }, []).filter(function (res) {
          return res !== resolvable;
        });
        var getDependency = function (token) {
          var matching = availableResolvables.filter(function (r) {
            return r.token === token;
          });
          if (matching.length) return common_1.tail(matching);
          var fromInjector = _this.injector().getNative(token);
          if (common_2.isUndefined(fromInjector)) {
            throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
          }
          return new resolvable_1.Resolvable(token, function () {
            return fromInjector;
          }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
      };
      return ResolveContext;
    }();
    exports.ResolveContext = ResolveContext;
    var UIInjectorImpl = function () {
      function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
      }
      UIInjectorImpl.prototype.get = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
          if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
            return resolvable.get(this.context);
          }
          if (!resolvable.resolved) {
            throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
          }
          return resolvable.data;
        }
        return this.getNative(token);
      };
      UIInjectorImpl.prototype.getAsync = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) return resolvable.get(this.context);
        return coreservices_1.services.$q.when(this.native.get(token));
      };
      UIInjectorImpl.prototype.getNative = function (token) {
        return this.native && this.native.get(token);
      };
      return UIInjectorImpl;
    }();
  })($__require("f9"));
});
$__System.registerDynamic("158", ["16a", "167", "168", "164", "165", "166", "154", "159", "156", "155", "14a", "144", "16b", "16e", "f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var trace_1 = $__require("16a");
    var coreservices_1 = $__require("167");
    var strings_1 = $__require("168");
    var common_1 = $__require("164");
    var predicates_1 = $__require("165");
    var hof_1 = $__require("166");
    var interface_1 = $__require("154");
    var transitionHook_1 = $__require("159");
    var hookRegistry_1 = $__require("156");
    var hookBuilder_1 = $__require("155");
    var pathUtils_1 = $__require("14a");
    var param_1 = $__require("144");
    var resolvable_1 = $__require("16b");
    var resolveContext_1 = $__require("16e");
    var stateSelf = hof_1.prop('self');
    var Transition = function () {
      function Transition(fromPath, targetState, router) {
        var _this = this;
        this._deferred = coreservices_1.services.$q.defer();
        this.promise = this._deferred.promise;
        this._registeredHooks = {};
        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
        this.isActive = function () {
          return _this.router.globals.transition === _this;
        };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) {
          throw new Error(targetState.error());
        }
        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () {
          return null;
        });
        this.applyViewConfigs(router);
      }
      Transition.prototype.onBefore = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onStart = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onExit = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onRetain = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onEnter = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onFinish = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onSuccess = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.onError = function (criteria, callback, options) {
        return;
      };
      Transition.prototype.createTransitionHookRegFns = function () {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents().filter(function (type) {
          return type.hookPhase !== interface_1.TransitionHookPhase.CREATE;
        }).forEach(function (type) {
          return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type);
        });
      };
      Transition.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
      };
      Transition.prototype.applyViewConfigs = function (router) {
        var enteringStates = this._treeChanges.entering.map(function (node) {
          return node.state;
        });
        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
      };
      Transition.prototype.$from = function () {
        return common_1.tail(this._treeChanges.from).state;
      };
      Transition.prototype.$to = function () {
        return common_1.tail(this._treeChanges.to).state;
      };
      Transition.prototype.from = function () {
        return this.$from().self;
      };
      Transition.prototype.to = function () {
        return this.$to().self;
      };
      Transition.prototype.targetState = function () {
        return this._targetState;
      };
      Transition.prototype.is = function (compare) {
        if (compare instanceof Transition) {
          return this.is({
            to: compare.$to().name,
            from: compare.$from().name
          });
        }
        return !(compare.to && !hookRegistry_1.matchState(this.$to(), compare.to) || compare.from && !hookRegistry_1.matchState(this.$from(), compare.from));
      };
      Transition.prototype.params = function (pathname) {
        if (pathname === void 0) {
          pathname = 'to';
        }
        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
      };
      Transition.prototype.injector = function (state, pathName) {
        if (pathName === void 0) {
          pathName = 'to';
        }
        var path = this._treeChanges[pathName];
        if (state) path = pathUtils_1.PathUtils.subPath(path, function (node) {
          return node.state === state || node.state.name === state;
        });
        return new resolveContext_1.ResolveContext(path).injector();
      };
      Transition.prototype.getResolveTokens = function (pathname) {
        if (pathname === void 0) {
          pathname = 'to';
        }
        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
      };
      Transition.prototype.addResolvable = function (resolvable, state) {
        if (state === void 0) {
          state = '';
        }
        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
        var stateName = typeof state === 'string' ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = common_1.find(topath, function (node) {
          return node.state.name === stateName;
        });
        var resolveContext = new resolveContext_1.ResolveContext(topath);
        resolveContext.addResolvables([resolvable], targetNode.state);
      };
      Transition.prototype.redirectedFrom = function () {
        return this._options.redirectedFrom || null;
      };
      Transition.prototype.originalTransition = function () {
        var rf = this.redirectedFrom();
        return rf && rf.originalTransition() || this;
      };
      Transition.prototype.options = function () {
        return this._options;
      };
      Transition.prototype.entering = function () {
        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
      };
      Transition.prototype.exiting = function () {
        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
      };
      Transition.prototype.retained = function () {
        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
      };
      Transition.prototype.views = function (pathname, state) {
        if (pathname === void 0) {
          pathname = 'entering';
        }
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter(hof_1.propEq('state', state));
        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
      };
      Transition.prototype.treeChanges = function (pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
      };
      Transition.prototype.redirect = function (targetState) {
        var redirects = 1,
            trans = this;
        while ((trans = trans.redirectedFrom()) != null) {
          if (++redirects > 20) throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = {
          redirectedFrom: this,
          source: 'redirect'
        };
        if (this.options().source === 'url' && targetState.options().location !== false) {
          redirectOpts.location = 'replace';
        }
        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
        targetState = targetState.withOptions(newOptions, true);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        var nodeIsReloading = function (reloadState) {
          return function (node) {
            return reloadState && node.state.includes[reloadState.name];
          };
        };
        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
        matchingEnteringNodes.forEach(function (node, idx) {
          node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
      };
      Transition.prototype._changedParams = function () {
        var tc = this._treeChanges;
        if (this._options.reload) return undefined;
        if (tc.exiting.length || tc.entering.length) return undefined;
        if (tc.to.length !== tc.from.length) return undefined;
        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from).map(function (tuple) {
          return tuple[0].state !== tuple[1].state;
        }).reduce(common_1.anyTrueR, false);
        if (pathsDiffer) return undefined;
        var nodeSchemas = tc.to.map(function (node) {
          return node.paramSchema;
        });
        var _a = [tc.to, tc.from].map(function (path) {
          return path.map(function (x) {
            return x.paramValues;
          });
        }),
            toValues = _a[0],
            fromValues = _a[1];
        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
        return tuples.map(function (_a) {
          var schema = _a[0],
              toVals = _a[1],
              fromVals = _a[2];
          return param_1.Param.changed(schema, toVals, fromVals);
        }).reduce(common_1.unnestR, []);
      };
      Transition.prototype.dynamic = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function (x) {
          return x.dynamic;
        }).reduce(common_1.anyTrueR, false);
      };
      Transition.prototype.ignored = function () {
        return !!this._ignoredReason();
      };
      Transition.prototype._ignoredReason = function () {
        var pending = this.router.globals.transition;
        var reloadState = this._options.reloadState;
        var same = function (pathA, pathB) {
          if (pathA.length !== pathB.length) return false;
          var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
          return pathA.length === matching.filter(function (node) {
            return !reloadState || !node.state.includes[reloadState.name];
          }).length;
        };
        var newTC = this.treeChanges();
        var pendTC = pending && pending.treeChanges();
        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting)) return 'SameAsPending';
        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to)) return 'SameAsCurrent';
      };
      Transition.prototype.run = function () {
        var _this = this;
        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
        var getHooksFor = function (phase) {
          return _this._hookBuilder.buildHooksForPhase(phase);
        };
        var transitionSuccess = function () {
          trace_1.trace.traceSuccess(_this.$to(), _this);
          _this.success = true;
          _this._deferred.resolve(_this.to());
          runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
        };
        var transitionError = function (reason) {
          trace_1.trace.traceError(reason, _this);
          _this.success = false;
          _this._deferred.reject(reason);
          _this._error = reason;
          runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
        };
        var runTransition = function () {
          var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
          var done = function () {
            return coreservices_1.services.$q.when(undefined);
          };
          return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
        };
        var startTransition = function () {
          var globals = _this.router.globals;
          globals.lastStartedTransitionId = _this.$id;
          globals.transition = _this;
          globals.transitionHistory.enqueue(_this);
          trace_1.trace.traceTransitionStart(_this);
          return coreservices_1.services.$q.when(undefined);
        };
        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition).then(runTransition).then(transitionSuccess, transitionError);
        return this.promise;
      };
      Transition.prototype.valid = function () {
        return !this.error() || this.success !== undefined;
      };
      Transition.prototype.abort = function () {
        if (predicates_1.isUndefined(this.success)) {
          this._aborted = true;
        }
      };
      Transition.prototype.error = function () {
        var state = this.$to();
        if (state.self.abstract) return "Cannot transition to abstract state '" + state.name + "'";
        var paramDefs = state.parameters(),
            values = this.params();
        var invalidParams = paramDefs.filter(function (param) {
          return !param.validates(values[param.id]);
        });
        if (invalidParams.length) {
          return "Param values not valid for state '" + state.name + "'. Invalid params: [ " + invalidParams.map(function (param) {
            return param.id;
          }).join(', ') + " ]";
        }
        if (this.success === false) return this._error;
      };
      Transition.prototype.toString = function () {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function (params) {
          return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
        };
        var id = this.$id,
            from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName,
            fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))),
            toValid = this.valid() ? '' : '(X) ',
            to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName,
            toParams = strings_1.stringify(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
      };
      Transition.diToken = Transition;
      return Transition;
    }();
    exports.Transition = Transition;
  })($__require("f9"));
});
$__System.registerDynamic("164", ["165", "166", "167"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var hof_1 = $__require("166");
  var coreservices_1 = $__require("167");
  exports.root = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this;
  var angular = exports.root.angular || {};
  exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
  exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
  exports.forEach = angular.forEach || _forEach;
  exports.extend = Object.assign || _extend;
  exports.equals = angular.equals || _equals;
  function identity(x) {
    return x;
  }
  exports.identity = identity;
  function noop() {}
  exports.noop = noop;
  function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) {
      latebind = false;
    }
    var bindFunction = function (fnName) {
      return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function (fnName) {
      return function lateRebindFunction() {
        target[fnName] = bindFunction(fnName);
        return target[fnName].apply(null, arguments);
      };
    };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
      acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
      return acc;
    }, target);
  }
  exports.createProxyFunctions = createProxyFunctions;
  exports.inherit = function (parent, extra) {
    return exports.extend(Object.create(parent), extra);
  };
  exports.inArray = hof_1.curry(_inArray);
  function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
  }
  exports._inArray = _inArray;
  exports.removeFrom = hof_1.curry(_removeFrom);
  function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0) array.splice(idx, 1);
    return array;
  }
  exports._removeFrom = _removeFrom;
  exports.pushTo = hof_1.curry(_pushTo);
  function _pushTo(arr, val) {
    return arr.push(val), val;
  }
  exports._pushTo = _pushTo;
  exports.deregAll = function (functions) {
    return functions.slice().forEach(function (fn) {
      typeof fn === 'function' && fn();
      exports.removeFrom(functions, fn);
    });
  };
  function defaults(opts) {
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      defaultsList[_i - 1] = arguments[_i];
    }
    var _defaultsList = defaultsList.concat({}).reverse();
    var defaultVals = exports.extend.apply(null, _defaultsList);
    return exports.extend({}, defaultVals, pick(opts || {}, Object.keys(defaultVals)));
  }
  exports.defaults = defaults;
  exports.mergeR = function (memo, item) {
    return exports.extend(memo, item);
  };
  function ancestors(first, second) {
    var path = [];
    for (var n in first.path) {
      if (first.path[n] !== second.path[n]) break;
      path.push(first.path[n]);
    }
    return path;
  }
  exports.ancestors = ancestors;
  function pick(obj, propNames) {
    var objCopy = {};
    for (var _prop in obj) {
      if (propNames.indexOf(_prop) !== -1) {
        objCopy[_prop] = obj[_prop];
      }
    }
    return objCopy;
  }
  exports.pick = pick;
  function omit(obj, propNames) {
    return Object.keys(obj).filter(hof_1.not(exports.inArray(propNames))).reduce(function (acc, key) {
      return acc[key] = obj[key], acc;
    }, {});
  }
  exports.omit = omit;
  function pluck(collection, propName) {
    return map(collection, hof_1.prop(propName));
  }
  exports.pluck = pluck;
  function filter(collection, callback) {
    var arr = predicates_1.isArray(collection),
        result = arr ? [] : {};
    var accept = arr ? function (x) {
      return result.push(x);
    } : function (x, key) {
      return result[key] = x;
    };
    exports.forEach(collection, function (item, i) {
      if (callback(item, i)) accept(item, i);
    });
    return result;
  }
  exports.filter = filter;
  function find(collection, callback) {
    var result;
    exports.forEach(collection, function (item, i) {
      if (result) return;
      if (callback(item, i)) result = item;
    });
    return result;
  }
  exports.find = find;
  exports.mapObj = map;
  function map(collection, callback, target) {
    target = target || (predicates_1.isArray(collection) ? [] : {});
    exports.forEach(collection, function (item, i) {
      return target[i] = callback(item, i);
    });
    return target;
  }
  exports.map = map;
  exports.values = function (obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
  exports.allTrueR = function (memo, elem) {
    return memo && elem;
  };
  exports.anyTrueR = function (memo, elem) {
    return memo || elem;
  };
  exports.unnestR = function (memo, elem) {
    return memo.concat(elem);
  };
  exports.flattenR = function (memo, elem) {
    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
  };
  function pushR(arr, obj) {
    arr.push(obj);
    return arr;
  }
  exports.pushR = pushR;
  exports.uniqR = function (acc, token) {
    return exports.inArray(acc, token) ? acc : pushR(acc, token);
  };
  exports.unnest = function (arr) {
    return arr.reduce(exports.unnestR, []);
  };
  exports.flatten = function (arr) {
    return arr.reduce(exports.flattenR, []);
  };
  exports.assertPredicate = assertFn;
  exports.assertMap = assertFn;
  function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) {
      errMsg = 'assert failure';
    }
    return function (obj) {
      var result = predicateOrMap(obj);
      if (!result) {
        throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
      }
      return result;
    };
  }
  exports.assertFn = assertFn;
  exports.pairs = function (obj) {
    return Object.keys(obj).map(function (key) {
      return [key, obj[key]];
    });
  };
  function arrayTuples() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 0) return [];
    var maxArrayLen = args.reduce(function (min, arr) {
      return Math.min(arr.length, min);
    }, 9007199254740991);
    var result = [];
    var _loop_1 = function (i) {
      switch (args.length) {
        case 1:
          result.push([args[0][i]]);
          break;
        case 2:
          result.push([args[0][i], args[1][i]]);
          break;
        case 3:
          result.push([args[0][i], args[1][i], args[2][i]]);
          break;
        case 4:
          result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
          break;
        default:
          result.push(args.map(function (array) {
            return array[i];
          }));
          break;
      }
    };
    for (var i = 0; i < maxArrayLen; i++) {
      _loop_1(i);
    }
    return result;
  }
  exports.arrayTuples = arrayTuples;
  function applyPairs(memo, keyValTuple) {
    var key, value;
    if (predicates_1.isArray(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
    if (!predicates_1.isString(key)) throw new Error('invalid parameters to applyPairs');
    memo[key] = value;
    return memo;
  }
  exports.applyPairs = applyPairs;
  function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
  }
  exports.tail = tail;
  function copy(src, dest) {
    if (dest) Object.keys(dest).forEach(function (key) {
      return delete dest[key];
    });
    if (!dest) dest = {};
    return exports.extend(dest, src);
  }
  exports.copy = copy;
  function _forEach(obj, cb, _this) {
    if (predicates_1.isArray(obj)) return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) {
      return cb(obj[key], key);
    });
  }
  function _extend(toObj) {
    for (var i = 1; i < arguments.length; i++) {
      var obj = arguments[i];
      if (!obj) continue;
      var keys = Object.keys(obj);
      for (var j = 0; j < keys.length; j++) {
        toObj[keys[j]] = obj[keys[j]];
      }
    }
    return toObj;
  }
  exports._extend = _extend;
  function _equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    if (o1 !== o1 && o2 !== o2) return true;
    var t1 = typeof o1,
        t2 = typeof o2;
    if (t1 !== t2 || t1 !== 'object') return false;
    var tup = [o1, o2];
    if (hof_1.all(predicates_1.isArray)(tup)) return _arraysEq(o1, o2);
    if (hof_1.all(predicates_1.isDate)(tup)) return o1.getTime() === o2.getTime();
    if (hof_1.all(predicates_1.isRegExp)(tup)) return o1.toString() === o2.toString();
    if (hof_1.all(predicates_1.isFunction)(tup)) return true;
    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
    if (predicates.map(hof_1.any).reduce(function (b, fn) {
      return b || !!fn(tup);
    }, false)) return false;
    var keys = {};
    for (var key in o1) {
      if (!_equals(o1[key], o2[key])) return false;
      keys[key] = true;
    }
    for (var key in o2) {
      if (!keys[key]) return false;
    }
    return true;
  }
  function _arraysEq(a1, a2) {
    if (a1.length !== a2.length) return false;
    return arrayTuples(a1, a2).reduce(function (b, t) {
      return b && _equals(t[0], t[1]);
    }, true);
  }
  exports.silenceUncaughtInPromise = function (promise) {
    return promise.catch(function (e) {
      return 0;
    }) && promise;
  };
  exports.silentRejection = function (error) {
    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
  };
});
$__System.registerDynamic("166", [], true, function ($__require, exports, module) {
    /* */
    "use strict";
    /**
     * Higher order functions
     *
     * These utility functions are exported, but are subject to change without notice.
     *
     * @module common_hof
     */ /** */

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
     *
     * Given a function with N parameters, returns a new function that supports partial application.
     * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
     * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
     * accept more parameters until all N parameters have been supplied.
     *
     *
     * This contrived example uses a partially applied function as an predicate, which returns true
     * if an object is found in both arrays.
     * @example
     * ```
     * // returns true if an object is in both of the two arrays
     * function inBoth(array1, array2, object) {
     *   return array1.indexOf(object) !== -1 &&
     *          array2.indexOf(object) !== 1;
     * }
     * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
     * let foos = [obj1, obj3]
     * let bars = [obj3, obj4, obj5]
     *
     * // A curried "copy" of inBoth
     * let curriedInBoth = curry(inBoth);
     * // Partially apply both the array1 and array2
     * let inFoosAndBars = curriedInBoth(foos, bars);
     *
     * // Supply the final argument; since all arguments are
     * // supplied, the original inBoth function is then called.
     * let obj1InBoth = inFoosAndBars(obj1); // false
     *
     * // Use the inFoosAndBars as a predicate.
     * // Filter, on each iteration, supplies the final argument
     * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
     * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
     *
     * ```
     *
     * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
     *
     * @param fn
     * @returns {*|function(): (*|any)}
     */
    function curry(fn) {
        var initial_args = [].slice.apply(arguments, [1]);
        var func_args_length = fn.length;
        function curried(args) {
            if (args.length >= func_args_length) return fn.apply(null, args);
            return function () {
                return curried(args.concat([].slice.apply(arguments)));
            };
        }
        return curried(initial_args);
    }
    exports.curry = curry;
    /**
     * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
     * given: f(x), g(x), h(x)
     * let composed = compose(f,g,h)
     * then, composed is: f(g(h(x)))
     */
    function compose() {
        var args = arguments;
        var start = args.length - 1;
        return function () {
            var i = start,
                result = args[start].apply(this, arguments);
            while (i--) result = args[i].call(this, result);
            return result;
        };
    }
    exports.compose = compose;
    /**
     * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
     * given: f(x), g(x), h(x)
     * let piped = pipe(f,g,h);
     * then, piped is: h(g(f(x)))
     */
    function pipe() {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            funcs[_i] = arguments[_i];
        }
        return compose.apply(null, [].slice.call(arguments).reverse());
    }
    exports.pipe = pipe;
    /**
     * Given a property name, returns a function that returns that property from an object
     * let obj = { foo: 1, name: "blarg" };
     * let getName = prop("name");
     * getName(obj) === "blarg"
     */
    exports.prop = function (name) {
        return function (obj) {
            return obj && obj[name];
        };
    };
    /**
     * Given a property name and a value, returns a function that returns a boolean based on whether
     * the passed object has a property that matches the value
     * let obj = { foo: 1, name: "blarg" };
     * let getName = propEq("name", "blarg");
     * getName(obj) === true
     */
    exports.propEq = curry(function (name, _val, obj) {
        return obj && obj[name] === _val;
    });
    /**
     * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
     * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
     * let getName = prop("nestedObj.name");
     * getName(obj) === "blarg"
     * let propNotFound = prop("this.property.doesnt.exist");
     * propNotFound(obj) === undefined
     */
    exports.parse = function (name) {
        return pipe.apply(null, name.split('.').map(exports.prop));
    };
    /**
     * Given a function that returns a truthy or falsey value, returns a
     * function that returns the opposite (falsey or truthy) value given the same inputs
     */
    exports.not = function (fn) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return !fn.apply(null, args);
        };
    };
    /**
     * Given two functions that return truthy or falsey values, returns a function that returns truthy
     * if both functions return truthy for the given arguments
     */
    function and(fn1, fn2) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return fn1.apply(null, args) && fn2.apply(null, args);
        };
    }
    exports.and = and;
    /**
     * Given two functions that return truthy or falsey values, returns a function that returns truthy
     * if at least one of the functions returns truthy for the given arguments
     */
    function or(fn1, fn2) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return fn1.apply(null, args) || fn2.apply(null, args);
        };
    }
    exports.or = or;
    /**
     * Check if all the elements of an array match a predicate function
     *
     * @param fn1 a predicate function `fn1`
     * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
     */
    exports.all = function (fn1) {
        return function (arr) {
            return arr.reduce(function (b, x) {
                return b && !!fn1(x);
            }, true);
        };
    };
    // tslint:disable-next-line:variable-name
    exports.any = function (fn1) {
        return function (arr) {
            return arr.reduce(function (b, x) {
                return b || !!fn1(x);
            }, false);
        };
    };
    /** Given a class, returns a Predicate function that returns true if the object is of that class */
    exports.is = function (ctor) {
        return function (obj) {
            return obj != null && obj.constructor === ctor || obj instanceof ctor;
        };
    };
    /** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
    exports.eq = function (value) {
        return function (other) {
            return value === other;
        };
    };
    /** Given a value, returns a function which returns the value */
    exports.val = function (v) {
        return function () {
            return v;
        };
    };
    function invoke(fnName, args) {
        return function (obj) {
            return obj[fnName].apply(obj, args);
        };
    }
    exports.invoke = invoke;
    /**
     * Sorta like Pattern Matching (a functional programming conditional construct)
     *
     * See http://c2.com/cgi/wiki?PatternMatching
     *
     * This is a conditional construct which allows a series of predicates and output functions
     * to be checked and then applied.  Each predicate receives the input.  If the predicate
     * returns truthy, then its matching output function (mapping function) is provided with
     * the input and, then the result is returned.
     *
     * Each combination (2-tuple) of predicate + output function should be placed in an array
     * of size 2: [ predicate, mapFn ]
     *
     * These 2-tuples should be put in an outer array.
     *
     * @example
     * ```
     *
     * // Here's a 2-tuple where the first element is the isString predicate
     * // and the second element is a function that returns a description of the input
     * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
     *
     * // Second tuple: predicate "isNumber", mapfn returns a description
     * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
     *
     * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
     *
     * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
     *
     * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
     *
     * console.log(descriptionOf(undefined)); // 'notdefined'
     * console.log(descriptionOf(55)); // '(55) That's a number!'
     * console.log(descriptionOf("foo")); // 'Here's your string foo'
     * ```
     *
     * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
     * with a Predicate and a mapping/output function
     * @returns {function(any): *}
     */
    function pattern(struct) {
        return function (x) {
            for (var i = 0; i < struct.length; i++) {
                if (struct[i][0](x)) return struct[i][1](x);
            }
        };
    }
    exports.pattern = pattern;
    
});
$__System.registerDynamic("17b", ["f9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  (function (process) {
    "use strict";

    Object.defineProperty(exports, "__esModule", { value: true });
    var Glob = function () {
      function Glob(text) {
        this.text = text;
        this.glob = text.split('.');
        var regexpString = this.text.split('.').map(function (seg) {
          if (seg === '**') return '(?:|(?:\\.[^.]*)*)';
          if (seg === '*') return '\\.[^.]*';
          return '\\.' + seg;
        }).join('');
        this.regexp = new RegExp('^' + regexpString + '$');
      }
      Glob.is = function (text) {
        return !!/[!,*]+/.exec(text);
      };
      Glob.fromString = function (text) {
        return Glob.is(text) ? new Glob(text) : null;
      };
      Glob.prototype.matches = function (name) {
        return this.regexp.test('.' + name);
      };
      return Glob;
    }();
    exports.Glob = Glob;
  })($__require("f9"));
});
$__System.registerDynamic("14d", ["164", "166", "17b", "165"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var glob_1 = $__require("17b");
  var predicates_1 = $__require("165");
  var StateObject = function () {
    function StateObject(config) {
      return StateObject.create(config || {});
    }
    StateObject.create = function (stateDecl) {
      stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
      var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
      stateDecl.$$state = function () {
        return state;
      };
      state.self = stateDecl;
      state.__stateObjectCache = { nameGlob: glob_1.Glob.fromString(state.name) };
      return state;
    };
    StateObject.prototype.is = function (ref) {
      return this === ref || this.self === ref || this.fqn() === ref;
    };
    StateObject.prototype.fqn = function () {
      if (!this.parent || !(this.parent instanceof this.constructor)) return this.name;
      var name = this.parent.fqn();
      return name ? name + '.' + this.name : this.name;
    };
    StateObject.prototype.root = function () {
      return this.parent && this.parent.root() || this;
    };
    StateObject.prototype.parameters = function (opts) {
      opts = common_1.defaults(opts, {
        inherit: true,
        matchingKeys: null
      });
      var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
      return inherited.concat(common_1.values(this.params)).filter(function (param) {
        return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id);
      });
    };
    StateObject.prototype.parameter = function (id, opts) {
      if (opts === void 0) {
        opts = {};
      }
      return this.url && this.url.parameter(id, opts) || common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) || opts.inherit && this.parent && this.parent.parameter(id);
    };
    StateObject.prototype.toString = function () {
      return this.fqn();
    };
    StateObject.isStateClass = function (stateDecl) {
      return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
    };
    StateObject.isState = function (obj) {
      return predicates_1.isObject(obj['__stateObjectCache']);
    };
    return StateObject;
  }();
  exports.StateObject = StateObject;
});
$__System.registerDynamic("165", ["166", "14d"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var hof_1 = $__require("166");
  var stateObject_1 = $__require("14d");
  var toStr = Object.prototype.toString;
  var tis = function (t) {
    return function (x) {
      return typeof x === t;
    };
  };
  exports.isUndefined = tis('undefined');
  exports.isDefined = hof_1.not(exports.isUndefined);
  exports.isNull = function (o) {
    return o === null;
  };
  exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
  exports.isFunction = tis('function');
  exports.isNumber = tis('number');
  exports.isString = tis('string');
  exports.isObject = function (x) {
    return x !== null && typeof x === 'object';
  };
  exports.isArray = Array.isArray;
  exports.isDate = function (x) {
    return toStr.call(x) === '[object Date]';
  };
  exports.isRegExp = function (x) {
    return toStr.call(x) === '[object RegExp]';
  };
  exports.isState = stateObject_1.StateObject.isState;
  function isInjectable(val) {
    if (exports.isArray(val) && val.length) {
      var head = val.slice(0, -1),
          tail = val.slice(-1);
      return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
    }
    return exports.isFunction(val);
  }
  exports.isInjectable = isInjectable;
  exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
});
$__System.registerDynamic("16b", ["164", "167", "16a", "168", "165"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var common_1 = $__require("164");
  var coreservices_1 = $__require("167");
  var trace_1 = $__require("16a");
  var strings_1 = $__require("168");
  var predicates_1 = $__require("165");
  var predicates_2 = $__require("165");
  exports.defaultResolvePolicy = {
    when: 'LAZY',
    async: 'WAIT'
  };
  var Resolvable = function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
      this.resolved = false;
      this.promise = undefined;
      if (arg1 instanceof Resolvable) {
        common_1.extend(this, arg1);
      } else if (predicates_1.isFunction(resolveFn)) {
        if (predicates_2.isNullOrUndefined(arg1)) throw new Error('new Resolvable(): token argument is required');
        if (!predicates_1.isFunction(resolveFn)) throw new Error('new Resolvable(): resolveFn argument must be a function');
        this.token = arg1;
        this.policy = policy;
        this.resolveFn = resolveFn;
        this.deps = deps || [];
        this.data = data;
        this.resolved = data !== undefined;
        this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
      } else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
        var literal = arg1;
        return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
      }
    }
    Resolvable.prototype.getPolicy = function (state) {
      var thisPolicy = this.policy || {};
      var statePolicy = state && state.resolvePolicy || {};
      return {
        when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
        async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async
      };
    };
    Resolvable.prototype.resolve = function (resolveContext, trans) {
      var _this = this;
      var $q = coreservices_1.services.$q;
      var getResolvableDependencies = function () {
        return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) {
          return resolvable.get(resolveContext, trans);
        }));
      };
      var invokeResolveFn = function (resolvedDeps) {
        return _this.resolveFn.apply(null, resolvedDeps);
      };
      var waitForRx = function (observable$) {
        var cached = observable$.cache(1);
        return cached.take(1).toPromise().then(function () {
          return cached;
        });
      };
      var node = resolveContext.findNode(this);
      var state = node && node.state;
      var maybeWaitForRx = this.getPolicy(state).async === 'RXWAIT' ? waitForRx : common_1.identity;
      var applyResolvedValue = function (resolvedValue) {
        _this.data = resolvedValue;
        _this.resolved = true;
        _this.resolveFn = null;
        trace_1.trace.traceResolvableResolved(_this, trans);
        return _this.data;
      };
      return this.promise = $q.when().then(getResolvableDependencies).then(invokeResolveFn).then(maybeWaitForRx).then(applyResolvedValue);
    };
    Resolvable.prototype.get = function (resolveContext, trans) {
      return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
      return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
      return new Resolvable(this);
    };
    Resolvable.fromData = function (token, data) {
      return new Resolvable(token, function () {
        return data;
      }, null, null, data);
    };
    return Resolvable;
  }();
  exports.Resolvable = Resolvable;
});
$__System.registerDynamic("168", ["165", "157", "164", "166", "158", "16b"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var predicates_1 = $__require("165");
  var rejectFactory_1 = $__require("157");
  var common_1 = $__require("164");
  var hof_1 = $__require("166");
  var transition_1 = $__require("158");
  var resolvable_1 = $__require("16b");
  function maxLength(max, str) {
    if (str.length <= max) return str;
    return str.substr(0, max - 3) + '...';
  }
  exports.maxLength = maxLength;
  function padString(length, str) {
    while (str.length < length) str += ' ';
    return str;
  }
  exports.padString = padString;
  function kebobString(camelCase) {
    return camelCase.replace(/^([A-Z])/, function ($1) {
      return $1.toLowerCase();
    }).replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  }
  exports.kebobString = kebobString;
  function _toJson(obj) {
    return JSON.stringify(obj);
  }
  function _fromJson(json) {
    return predicates_1.isString(json) ? JSON.parse(json) : json;
  }
  function promiseToString(p) {
    return "Promise(" + JSON.stringify(p) + ")";
  }
  function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || '';
    if (fnName && toStr.match(/function \(/)) {
      return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
  }
  exports.functionToString = functionToString;
  function fnToString(fn) {
    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || 'undefined';
  }
  exports.fnToString = fnToString;
  var stringifyPatternFn = null;
  var stringifyPattern = function (value) {
    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([[hof_1.not(predicates_1.isDefined), hof_1.val('undefined')], [predicates_1.isNull, hof_1.val('null')], [predicates_1.isPromise, hof_1.val('[Promise]')], [isRejection, function (x) {
      return x._transitionRejection.toString();
    }], [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke('toString')], [hof_1.is(transition_1.Transition), hof_1.invoke('toString')], [hof_1.is(resolvable_1.Resolvable), hof_1.invoke('toString')], [predicates_1.isInjectable, functionToString], [hof_1.val(true), common_1.identity]]);
    return stringifyPatternFn(value);
  };
  function stringify(o) {
    var seen = [];
    function format(value) {
      if (predicates_1.isObject(value)) {
        if (seen.indexOf(value) !== -1) return '[circular ref]';
        seen.push(value);
      }
      return stringifyPattern(value);
    }
    return JSON.stringify(o, function (key, value) {
      return format(value);
    }).replace(/\\"/g, '"');
  }
  exports.stringify = stringify;
  exports.beforeAfterSubstr = function (char) {
    return function (str) {
      if (!str) return ['', ''];
      var idx = str.indexOf(char);
      if (idx === -1) return [str, ''];
      return [str.substr(0, idx), str.substr(idx + 1)];
    };
  };
  exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
  exports.stripLastPathElement = function (str) {
    return str.replace(/\/[^/]*$/, '');
  };
  exports.splitHash = exports.beforeAfterSubstr('#');
  exports.splitQuery = exports.beforeAfterSubstr('?');
  exports.splitEqual = exports.beforeAfterSubstr('=');
  exports.trimHashVal = function (str) {
    return str ? str.replace(/^#/, '') : '';
  };
  function splitOnDelim(delim) {
    var re = new RegExp('(' + delim + ')', 'g');
    return function (str) {
      return str.split(re).filter(common_1.identity);
    };
  }
  exports.splitOnDelim = splitOnDelim;
  function joinNeighborsR(acc, x) {
    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x)) return acc.slice(0, -1).concat(common_1.tail(acc) + x);
    return common_1.pushR(acc, x);
  }
  exports.joinNeighborsR = joinNeighborsR;
});
$__System.registerDynamic("16a", ["166", "165", "168"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var hof_1 = $__require("166");
  var predicates_1 = $__require("165");
  var strings_1 = $__require("168");
  function uiViewString(uiview) {
    if (!uiview) return 'ui-view (defunct)';
    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
  }
  var viewConfigString = function (viewConfig) {
    var view = viewConfig.viewDecl;
    var state = view.$context.name || '(root)';
    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
  };
  function normalizedCat(input) {
    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
  }
  var consoleLog = Function.prototype.bind.call(console.log, console);
  var consoletable = predicates_1.isFunction(console.table) ? console.table.bind(console) : consoleLog.bind(console);
  var Category;
  (function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
  })(Category = exports.Category || (exports.Category = {}));
  var _tid = hof_1.parse('$id');
  var _rid = hof_1.parse('router.$id');
  var transLbl = function (trans) {
    return "Transition #" + _tid(trans) + "-" + _rid(trans);
  };
  var Trace = function () {
    function Trace() {
      this._enabled = {};
      this.approximateDigests = 0;
    }
    Trace.prototype._set = function (enabled, categories) {
      var _this = this;
      if (!categories.length) {
        categories = Object.keys(Category).map(function (k) {
          return parseInt(k, 10);
        }).filter(function (k) {
          return !isNaN(k);
        }).map(function (key) {
          return Category[key];
        });
      }
      categories.map(normalizedCat).forEach(function (category) {
        return _this._enabled[category] = enabled;
      });
    };
    Trace.prototype.enable = function () {
      var categories = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        categories[_i] = arguments[_i];
      }
      this._set(true, categories);
    };
    Trace.prototype.disable = function () {
      var categories = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        categories[_i] = arguments[_i];
      }
      this._set(false, categories);
    };
    Trace.prototype.enabled = function (category) {
      return !!this._enabled[normalizedCat(category)];
    };
    Trace.prototype.traceTransitionStart = function (trans) {
      if (!this.enabled(Category.TRANSITION)) return;
      console.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
    };
    Trace.prototype.traceTransitionIgnored = function (trans) {
      if (!this.enabled(Category.TRANSITION)) return;
      console.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
    };
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
      if (!this.enabled(Category.HOOK)) return;
      var event = hof_1.parse('traceData.hookType')(options) || 'internal',
          context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown',
          name = strings_1.functionToString(step.registeredHook.callback);
      console.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
    };
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
      if (!this.enabled(Category.HOOK)) return;
      console.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
    };
    Trace.prototype.traceResolvePath = function (path, when, trans) {
      if (!this.enabled(Category.RESOLVE)) return;
      console.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
    };
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
      if (!this.enabled(Category.RESOLVE)) return;
      console.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
    };
    Trace.prototype.traceError = function (reason, trans) {
      if (!this.enabled(Category.TRANSITION)) return;
      console.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
    };
    Trace.prototype.traceSuccess = function (finalState, trans) {
      if (!this.enabled(Category.TRANSITION)) return;
      console.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
    };
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
      if (extra === void 0) {
        extra = '';
      }
      if (!this.enabled(Category.UIVIEW)) return;
      console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
      if (!this.enabled(Category.UIVIEW)) return;
      this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
    };
    Trace.prototype.traceUIViewFill = function (viewData, html) {
      if (!this.enabled(Category.UIVIEW)) return;
      this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
    };
    Trace.prototype.traceViewSync = function (pairs) {
      if (!this.enabled(Category.VIEWCONFIG)) return;
      var uivheader = 'uiview component fqn';
      var cfgheader = 'view config state (view name)';
      var mapping = pairs.map(function (_a) {
        var uiView = _a.uiView,
            viewConfig = _a.viewConfig;
        var uiv = uiView && uiView.fqn;
        var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
        return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
        var _b;
      }).sort(function (a, b) {
        return (a[uivheader] || '').localeCompare(b[uivheader] || '');
      });
      consoletable(mapping);
    };
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
      if (!this.enabled(Category.VIEWCONFIG)) return;
      console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
      if (!this.enabled(Category.VIEWCONFIG)) return;
      console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
  }();
  exports.Trace = Trace;
  var trace = new Trace();
  exports.trace = trace;
});
$__System.registerDynamic("169", ["164", "167", "17b", "166", "165", "17a", "168", "16a"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("164"));
  __export($__require("167"));
  __export($__require("17b"));
  __export($__require("166"));
  __export($__require("165"));
  __export($__require("17a"));
  __export($__require("168"));
  __export($__require("16a"));
});
$__System.registerDynamic("185", ["169"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var index_1 = $__require("169");
  exports.$q = {
    when: function (val) {
      return new Promise(function (resolve, reject) {
        return resolve(val);
      });
    },
    reject: function (val) {
      return new Promise(function (resolve, reject) {
        reject(val);
      });
    },
    defer: function () {
      var deferred = {};
      deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      return deferred;
    },
    all: function (promises) {
      if (index_1.isArray(promises)) {
        return Promise.all(promises);
      }
      if (index_1.isObject(promises)) {
        var chain = Object.keys(promises).map(function (key) {
          return promises[key].then(function (val) {
            return {
              key: key,
              val: val
            };
          });
        });
        return exports.$q.all(chain).then(function (values) {
          return values.reduce(function (acc, tuple) {
            acc[tuple.key] = tuple.val;
            return acc;
          }, {});
        });
      }
    }
  };
});
$__System.registerDynamic("167", [], true, function ($__require, exports, module) {
    /* */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.notImplemented = function (fnname) {
        return function () {
            throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
        };
    };
    var services = {
        $q: undefined,
        $injector: undefined
    };
    exports.services = services;
    
});
$__System.registerDynamic("186", ["17d", "17e", "181", "180", "182", "183", "184", "185", "167"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  var browserLocationConfig_1 = $__require("17d");
  var hashLocationService_1 = $__require("17e");
  var utils_1 = $__require("181");
  var pushStateLocationService_1 = $__require("180");
  var memoryLocationService_1 = $__require("182");
  var memoryLocationConfig_1 = $__require("183");
  var injector_1 = $__require("184");
  var q_1 = $__require("185");
  var coreservices_1 = $__require("167");
  function servicesPlugin(router) {
    coreservices_1.services.$injector = injector_1.$injector;
    coreservices_1.services.$q = q_1.$q;
    return {
      name: 'vanilla.services',
      $q: q_1.$q,
      $injector: injector_1.$injector,
      dispose: function () {
        return null;
      }
    };
  }
  exports.servicesPlugin = servicesPlugin;
  exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
  exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
  exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
});
$__System.registerDynamic("187", ["185", "184", "17f", "17e", "182", "180", "183", "17d", "181", "186"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("185"));
  __export($__require("184"));
  __export($__require("17f"));
  __export($__require("17e"));
  __export($__require("182"));
  __export($__require("180"));
  __export($__require("183"));
  __export($__require("17d"));
  __export($__require("181"));
  __export($__require("186"));
});
$__System.registerDynamic("188", ["187"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("187"));
});
$__System.registerDynamic("189", [], true, function ($__require, exports, module) {
  /* */
  "use strict";
  /**
   * # Core classes and interfaces
   *
   * The classes and interfaces that are core to ui-router and do not belong
   * to a more specific subsystem (such as resolve).
   *
   * @coreapi
   * @preferred
   * @module core
   */ /** for typedoc */

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  /** @internalapi */
  var UIRouterPluginBase = /** @class */function () {
    function UIRouterPluginBase() {}
    UIRouterPluginBase.prototype.dispose = function (router) {};
    return UIRouterPluginBase;
  }();
  exports.UIRouterPluginBase = UIRouterPluginBase;
  
});
$__System.registerDynamic("18a", ["169", "143", "148", "16c", "14b", "153", "15c", "162", "17c", "170", "188", "189"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  Object.defineProperty(exports, "__esModule", { value: true });
  __export($__require("169"));
  __export($__require("143"));
  __export($__require("148"));
  __export($__require("16c"));
  __export($__require("14b"));
  __export($__require("153"));
  __export($__require("15c"));
  __export($__require("162"));
  __export($__require("17c"));
  __export($__require("170"));
  __export($__require("188"));
  __export($__require("189"));
});
$__System.registerDynamic("18b", ["18a"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("18a");
});
$__System.registerDynamic('18c', ['3', '18b', 'f9'], true, function ($__require, exports, module) {
  /* */
  "format cjs";

  var global = this || self,
      GLOBAL = global;
  (function (process) {
    (function (global, factory) {
      typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, $__require('3'), $__require('18b')) : typeof undefined === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) : factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']);
    })(this, function (exports, ng_from_import, core) {
      'use strict';

      var ng_from_global = angular;
      var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
      function getNg1ViewConfigFactory() {
        var templateFactory = null;
        return function (path, view) {
          templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
          return [new Ng1ViewConfig(path, view, templateFactory)];
        };
      }
      var hasAnyKey = function (keys, obj) {
        return keys.reduce(function (acc, key) {
          return acc || core.isDefined(obj[key]);
        }, false);
      };
      function ng1ViewsBuilder(state) {
        if (!state.parent) return {};
        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'],
            ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'],
            compKeys = ['component', 'bindings', 'componentProvider'],
            nonCompKeys = tplKeys.concat(ctrlKeys),
            allViewKeys = compKeys.concat(nonCompKeys);
        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
          throw new Error("State '" + state.name + "' has a 'views' object. " + "It cannot also have \"view properties\" at the state level.  " + "Move the following properties into a view (in the 'views' object): " + (" " + allViewKeys.filter(function (key) {
            return core.isDefined(state[key]);
          }).join(', ')));
        }
        var views = {},
            viewsObject = state.views || { '$default': core.pick(state, allViewKeys) };
        core.forEach(viewsObject, function (config, name) {
          name = name || '$default';
          if (core.isString(config)) config = { component: config };
          config = core.extend({}, config);
          if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
            throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
          }
          config.resolveAs = config.resolveAs || '$resolve';
          config.$type = 'ng1';
          config.$context = state;
          config.$name = name;
          var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
          config.$uiViewName = normalized.uiViewName;
          config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
          views[name] = config;
        });
        return views;
      }
      var id = 0;
      var Ng1ViewConfig = function () {
        function Ng1ViewConfig(path, viewDecl, factory) {
          var _this = this;
          this.path = path;
          this.viewDecl = viewDecl;
          this.factory = factory;
          this.$id = id++;
          this.loaded = false;
          this.getTemplate = function (uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
          };
        }
        Ng1ViewConfig.prototype.load = function () {
          var _this = this;
          var $q = core.services.$q;
          var context = new core.ResolveContext(this.path);
          var params = this.path.reduce(function (acc, node) {
            return core.extend(acc, node.paramValues);
          }, {});
          var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
          };
          return $q.all(promises).then(function (results) {
            core.trace.traceViewServiceEvent('Loaded', _this);
            _this.controller = results.controller;
            core.extend(_this, results.template);
            return _this;
          });
        };
        Ng1ViewConfig.prototype.getController = function (context) {
          var provider = this.viewDecl.controllerProvider;
          if (!core.isInjectable(provider)) return this.viewDecl.controller;
          var deps = core.services.$injector.annotate(provider);
          var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
          var resolvable = new core.Resolvable('', providerFn, deps);
          return resolvable.get(context);
        };
        return Ng1ViewConfig;
      }();
      var TemplateFactory = function () {
        function TemplateFactory() {
          var _this = this;
          this._useHttp = ng.version.minor < 3;
          this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
            _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
            _this.$http = $http;
            _this.$templateCache = $templateCache;
            return _this;
          }];
        }
        TemplateFactory.prototype.useHttpService = function (value) {
          this._useHttp = value;
        };
        TemplateFactory.prototype.fromConfig = function (config, params, context) {
          var defaultTemplate = '<ui-view></ui-view>';
          var asTemplate = function (result) {
            return core.services.$q.when(result).then(function (str) {
              return { template: str };
            });
          };
          var asComponent = function (result) {
            return core.services.$q.when(result).then(function (str) {
              return { component: str };
            });
          };
          return core.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) : core.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) : core.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) : core.isDefined(config.component) ? asComponent(config.component) : core.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) : asTemplate(defaultTemplate);
        };
        TemplateFactory.prototype.fromString = function (template, params) {
          return core.isFunction(template) ? template(params) : template;
        };
        TemplateFactory.prototype.fromUrl = function (url, params) {
          if (core.isFunction(url)) url = url(params);
          if (url == null) return null;
          if (this._useHttp) {
            return this.$http.get(url, {
              cache: this.$templateCache,
              headers: { Accept: 'text/html' }
            }).then(function (response) {
              return response.data;
            });
          }
          return this.$templateRequest(url);
        };
        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
          var deps = core.services.$injector.annotate(provider);
          var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
          var resolvable = new core.Resolvable('', providerFn, deps);
          return resolvable.get(context);
        };
        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
          var deps = core.services.$injector.annotate(provider);
          var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
          var resolvable = new core.Resolvable('', providerFn, deps);
          return resolvable.get(context);
        };
        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
          bindings = bindings || {};
          var prefix = ng.version.minor >= 3 ? '::' : '';
          var kebob = function (camelCase) {
            var kebobed = core.kebobString(camelCase);
            return (/^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed
            );
          };
          var attributeTpl = function (input) {
            var name = input.name,
                type = input.type;
            var attrName = kebob(name);
            if (uiView.attr(attrName) && !bindings[name]) return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            if (type === '@') return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            if (type === '&') {
              var res = context.getResolvable(resolveName);
              var fn = res && res.data;
              var args = fn && core.services.$injector.annotate(fn) || [];
              var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
              return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
            }
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
          };
          var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
          var kebobName = kebob(component);
          return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
        };
        return TemplateFactory;
      }();
      function getComponentBindings(name) {
        var cmpDefs = core.services.$injector.get(name + 'Directive');
        if (!cmpDefs || !cmpDefs.length) throw new Error("Unable to find component named '" + name + "'");
        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
      }
      var getBindings = function (def) {
        if (core.isObject(def.bindToController)) return scopeBindings(def.bindToController);
        return scopeBindings(def.scope);
      };
      var scopeBindings = function (bindingsObj) {
        return Object.keys(bindingsObj || {}).map(function (key) {
          return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])];
        }).filter(function (tuple) {
          return core.isDefined(tuple) && core.isArray(tuple[1]);
        }).map(function (tuple) {
          return {
            name: tuple[1][2] || tuple[0],
            type: tuple[1][1]
          };
        });
      };
      var StateProvider = function () {
        function StateProvider(stateRegistry, stateService) {
          this.stateRegistry = stateRegistry;
          this.stateService = stateService;
          core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
        }
        StateProvider.prototype.decorator = function (name, func) {
          return this.stateRegistry.decorator(name, func) || this;
        };
        StateProvider.prototype.state = function (name, definition) {
          if (core.isObject(name)) {
            definition = name;
          } else {
            definition.name = name;
          }
          this.stateRegistry.register(definition);
          return this;
        };
        StateProvider.prototype.onInvalid = function (callback) {
          return this.stateService.onInvalid(callback);
        };
        return StateProvider;
      }();
      var getStateHookBuilder = function (hookName) {
        return function stateHookBuilder(stateObject, parentFn) {
          var hook = stateObject[hookName];
          var pathname = hookName === 'onExit' ? 'from' : 'to';
          function decoratedNg1Hook(trans, state) {
            var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
            var subContext = resolveContext.subContext(state.$$state());
            var locals = core.extend(getLocals(subContext), {
              $state$: state,
              $transition$: trans
            });
            return core.services.$injector.invoke(hook, this, locals);
          }
          return hook ? decoratedNg1Hook : undefined;
        };
      };
      var Ng1LocationServices = function () {
        function Ng1LocationServices($locationProvider) {
          this._urlListeners = [];
          this.$locationProvider = $locationProvider;
          var _lp = core.val($locationProvider);
          core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
        }
        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
          var pathType = router.urlMatcherFactory.type('path');
          pathType.encode = function (x) {
            return x != null ? x.toString().replace(/(~|\/)/g, function (m) {
              return {
                '~': '~~',
                '/': '~2F'
              }[m];
            }) : x;
          };
          pathType.decode = function (x) {
            return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) {
              return {
                '~~': '~',
                '~2F': '/'
              }[m];
            }) : x;
          };
        };
        Ng1LocationServices.prototype.dispose = function () {};
        Ng1LocationServices.prototype.onChange = function (callback) {
          var _this = this;
          this._urlListeners.push(callback);
          return function () {
            return core.removeFrom(_this._urlListeners)(callback);
          };
        };
        Ng1LocationServices.prototype.html5Mode = function () {
          var html5Mode = this.$locationProvider.html5Mode();
          html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
          return html5Mode && this.$sniffer.history;
        };
        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
          if (replace === void 0) {
            replace = false;
          }
          if (core.isDefined(newUrl)) this.$location.url(newUrl);
          if (replace) this.$location.replace();
          if (state) this.$location.state(state);
          return this.$location.url();
        };
        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
          var _this = this;
          this.$location = $location;
          this.$sniffer = $sniffer;
          $rootScope.$on('$locationChangeSuccess', function (evt) {
            return _this._urlListeners.forEach(function (fn) {
              return fn(evt);
            });
          });
          var _loc = core.val($location);
          var _browser = core.val($browser);
          core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
          core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
          core.createProxyFunctions(_browser, this, _browser, ['baseHref']);
        };
        return Ng1LocationServices;
      }();
      var UrlRouterProvider = function () {
        function UrlRouterProvider(router) {
          this._router = router;
          this._urlRouter = router.urlRouter;
        }
        UrlRouterProvider.injectableHandler = function (router, handler) {
          return function (match) {
            return core.services.$injector.invoke(handler, null, {
              $match: match,
              $stateParams: router.globals.params
            });
          };
        };
        UrlRouterProvider.prototype.$get = function () {
          var urlRouter = this._urlRouter;
          urlRouter.update(true);
          if (!urlRouter.interceptDeferred) urlRouter.listen();
          return urlRouter;
        };
        UrlRouterProvider.prototype.rule = function (ruleFn) {
          var _this = this;
          if (!core.isFunction(ruleFn)) throw new Error("'rule' must be a function");
          var match = function () {
            return ruleFn(core.services.$injector, _this._router.locationService);
          };
          var rule = new core.BaseUrlRule(match, core.identity);
          this._urlRouter.rule(rule);
          return this;
        };
        UrlRouterProvider.prototype.otherwise = function (rule) {
          var _this = this;
          var urlRouter = this._urlRouter;
          if (core.isString(rule)) {
            urlRouter.otherwise(rule);
          } else if (core.isFunction(rule)) {
            urlRouter.otherwise(function () {
              return rule(core.services.$injector, _this._router.locationService);
            });
          } else {
            throw new Error("'rule' must be a string or function");
          }
          return this;
        };
        UrlRouterProvider.prototype.when = function (what, handler) {
          if (core.isArray(handler) || core.isFunction(handler)) {
            handler = UrlRouterProvider.injectableHandler(this._router, handler);
          }
          this._urlRouter.when(what, handler);
          return this;
        };
        UrlRouterProvider.prototype.deferIntercept = function (defer) {
          this._urlRouter.deferIntercept(defer);
        };
        return UrlRouterProvider;
      }();
      ng.module('ui.router.angular1', []);
      var mod_init = ng.module('ui.router.init', []);
      var mod_util = ng.module('ui.router.util', ['ng', 'ui.router.init']);
      var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
      var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
      var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
      var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
      var router = null;
      $uiRouterProvider.$inject = ['$locationProvider'];
      function $uiRouterProvider($locationProvider) {
        router = this.router = new core.UIRouter();
        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
        router.stateRegistry.decorator('views', ng1ViewsBuilder);
        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
        var ng1LocationService = router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider);
        Ng1LocationServices.monkeyPatchPathParameterType(router);
        router['router'] = router;
        router['$get'] = $get;
        $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
        function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
          ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
          delete router['router'];
          delete router['$get'];
          return router;
        }
        return router;
      }
      var getProviderFor = function (serviceName) {
        return ['$uiRouterProvider', function ($urp) {
          var service = $urp.router[serviceName];
          service['$get'] = function () {
            return service;
          };
          return service;
        }];
      };
      runBlock.$inject = ['$injector', '$q', '$uiRouter'];
      function runBlock($injector, $q, $uiRouter) {
        core.services.$injector = $injector;
        core.services.$q = $q;
        $uiRouter.stateRegistry.get().map(function (x) {
          return x.$$state().resolvables;
        }).reduce(core.unnestR, []).filter(function (x) {
          return x.deps === 'deferred';
        }).forEach(function (resolvable) {
          return resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi);
        });
      }
      var getUrlRouterProvider = function (uiRouter) {
        return uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter);
      };
      var getStateProvider = function () {
        return core.extend(router.stateProvider, { $get: function () {
            return router.stateService;
          } });
      };
      watchDigests.$inject = ['$rootScope'];
      function watchDigests($rootScope) {
        $rootScope.$watch(function () {
          core.trace.approximateDigests++;
        });
      }
      mod_init.provider('$uiRouter', $uiRouterProvider);
      mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
      mod_util.provider('$urlService', getProviderFor('urlService'));
      mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () {
        return router.urlMatcherFactory;
      }]);
      mod_util.provider('$templateFactory', function () {
        return new TemplateFactory();
      });
      mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
      mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
      mod_state.provider('$transitions', getProviderFor('transitionService'));
      mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
      mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) {
        return $uiRouter.globals.params;
      }]);
      mod_main.factory('$view', function () {
        return router.viewService;
      });
      mod_main.service('$trace', function () {
        return core.trace;
      });
      mod_main.run(watchDigests);
      mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) {}]);
      mod_state.run(['$state', function ($state) {}]);
      mod_rtr.run(['$urlRouter', function ($urlRouter) {}]);
      mod_init.run(runBlock);
      var getLocals = function (ctx) {
        var tokens = ctx.getTokens().filter(core.isString);
        var tuples = tokens.map(function (key) {
          var resolvable = ctx.getResolvable(key);
          var waitPolicy = ctx.getPolicy(resolvable).async;
          return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
        });
        return tuples.reduce(core.applyPairs, {});
      };
      function parseStateRef(ref) {
        var parsed;
        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
        if (paramsOnly) ref = '(' + paramsOnly[1] + ')';
        parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
        if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
        return {
          state: parsed[1] || null,
          paramExpr: parsed[3] || null
        };
      }
      function stateContext(el) {
        var $uiView = el.parent().inheritedData('$uiView');
        var path = core.parse('$cfg.path')($uiView);
        return path ? core.tail(path).state.name : undefined;
      }
      function processedDef($state, $element, def) {
        var uiState = def.uiState || $state.current.name;
        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
        return {
          uiState: uiState,
          uiStateParams: def.uiStateParams,
          uiStateOpts: uiStateOpts,
          href: href
        };
      }
      function getTypeInfo(el) {
        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
        var isForm = el[0].nodeName === 'FORM';
        return {
          attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
          isAnchor: el.prop('tagName').toUpperCase() === 'A',
          clickable: !isForm
        };
      }
      function clickHook(el, $state, $timeout, type, getDef) {
        return function (e) {
          var button = e.which || e.button,
              target = getDef();
          if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            var transition_1 = $timeout(function () {
              $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function () {
              if (ignorePreventDefaultCount_1-- <= 0) $timeout.cancel(transition_1);
            };
          }
        };
      }
      function defaultOpts(el, $state) {
        return {
          relative: stateContext(el) || $state.$current,
          inherit: true,
          source: 'sref'
        };
      }
      function bindEvents(element, scope, hookFn, uiStateOpts) {
        var events;
        if (uiStateOpts) {
          events = uiStateOpts.events;
        }
        if (!core.isArray(events)) {
          events = ['click'];
        }
        var on = element.on ? 'on' : 'bind';
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
          var event_1 = events_1[_i];
          element[on](event_1, hookFn);
        }
        scope.$on('$destroy', function () {
          var off = element.off ? 'off' : 'unbind';
          for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
            var event_2 = events_2[_i];
            element[off](event_2, hookFn);
          }
        });
      }
      var uiSrefDirective;
      uiSrefDirective = ['$uiRouter', '$timeout', function $StateRefDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
          restrict: 'A',
          require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
          link: function (scope, element, attrs, uiSrefActive) {
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var unlinkInfoFn = null;
            var hookFn;
            var rawDef = {};
            var getDef = function () {
              return processedDef($state, element, rawDef);
            };
            var ref = parseStateRef(attrs.uiSref);
            rawDef.uiState = ref.state;
            rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
            function update() {
              var def = getDef();
              if (unlinkInfoFn) unlinkInfoFn();
              if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
              if (def.href != null) attrs.$set(type.attr, def.href);
            }
            if (ref.paramExpr) {
              scope.$watch(ref.paramExpr, function (val) {
                rawDef.uiStateParams = core.extend({}, val);
                update();
              }, true);
              rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
            }
            update();
            scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
            scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
            if (!type.clickable) return;
            hookFn = clickHook(element, $state, $timeout, type, getDef);
            bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
          }
        };
      }];
      var uiStateDirective;
      uiStateDirective = ['$uiRouter', '$timeout', function $StateRefDynamicDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
          restrict: 'A',
          require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
          link: function (scope, element, attrs, uiSrefActive) {
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var unlinkInfoFn = null;
            var hookFn;
            var rawDef = {};
            var getDef = function () {
              return processedDef($state, element, rawDef);
            };
            var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
            var watchDeregFns = inputAttrs.reduce(function (acc, attr) {
              return acc[attr] = core.noop, acc;
            }, {});
            function update() {
              var def = getDef();
              if (unlinkInfoFn) unlinkInfoFn();
              if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
              if (def.href != null) attrs.$set(type.attr, def.href);
            }
            inputAttrs.forEach(function (field) {
              rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
              attrs.$observe(field, function (expr) {
                watchDeregFns[field]();
                watchDeregFns[field] = scope.$watch(expr, function (newval) {
                  rawDef[field] = newval;
                  update();
                }, true);
              });
            });
            update();
            scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
            scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
            if (!type.clickable) return;
            hookFn = clickHook(element, $state, $timeout, type, getDef);
            bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
          }
        };
      }];
      var uiSrefActiveDirective;
      uiSrefActiveDirective = ['$state', '$stateParams', '$interpolate', '$uiRouter', function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
        return {
          restrict: 'A',
          controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            var states = [];
            var activeEqClass;
            var uiSrefActive;
            activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
            try {
              uiSrefActive = $scope.$eval($attrs.uiSrefActive);
            } catch (e) {}
            uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
            setStatesFromDefinitionObject(uiSrefActive);
            this.$$addStateInfo = function (newState, newParams) {
              if (core.isObject(uiSrefActive) && states.length > 0) {
                return;
              }
              var deregister = addState(newState, newParams, uiSrefActive);
              update();
              return deregister;
            };
            function updateAfterTransition(trans) {
              trans.promise.then(update, core.noop);
            }
            $scope.$on('$destroy', setupEventListeners());
            if ($uiRouter.globals.transition) {
              updateAfterTransition($uiRouter.globals.transition);
            }
            function setupEventListeners() {
              var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
              var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
              var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
              return function cleanUp() {
                deregisterStatesChangedListener();
                deregisterOnStartListener();
                deregisterStateChangeSuccessListener();
              };
            }
            function handleStatesChanged() {
              setStatesFromDefinitionObject(uiSrefActive);
            }
            function setStatesFromDefinitionObject(statesDefinition) {
              if (core.isObject(statesDefinition)) {
                states = [];
                core.forEach(statesDefinition, function (stateOrName, activeClass) {
                  var addStateForClass = function (stateOrName, activeClass) {
                    var ref = parseStateRef(stateOrName);
                    addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                  };
                  if (core.isString(stateOrName)) {
                    addStateForClass(stateOrName, activeClass);
                  } else if (core.isArray(stateOrName)) {
                    core.forEach(stateOrName, function (stateOrName) {
                      addStateForClass(stateOrName, activeClass);
                    });
                  }
                });
              }
            }
            function addState(stateName, stateParams, activeClass) {
              var state = $state.get(stateName, stateContext($element));
              var stateInfo = {
                state: state || { name: stateName },
                params: stateParams,
                activeClass: activeClass
              };
              states.push(stateInfo);
              return function removeState() {
                core.removeFrom(states)(stateInfo);
              };
            }
            function update() {
              var splitClasses = function (str) {
                return str.split(/\s/).filter(core.identity);
              };
              var getClasses = function (stateList) {
                return stateList.map(function (x) {
                  return x.activeClass;
                }).map(splitClasses).reduce(core.unnestR, []);
              };
              var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
              var fuzzyClasses = getClasses(states.filter(function (x) {
                return $state.includes(x.state.name, x.params);
              }));
              var exactlyMatchesAny = !!states.filter(function (x) {
                return $state.is(x.state.name, x.params);
              }).length;
              var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
              var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
              var removeClasses = allClasses.filter(function (cls) {
                return !core.inArray(addClasses, cls);
              });
              $scope.$evalAsync(function () {
                addClasses.forEach(function (className) {
                  return $element.addClass(className);
                });
                removeClasses.forEach(function (className) {
                  return $element.removeClass(className);
                });
              });
            }
            update();
          }]
        };
      }];
      ng.module('ui.router.state').directive('uiSref', uiSrefDirective).directive('uiSrefActive', uiSrefActiveDirective).directive('uiSrefActiveEq', uiSrefActiveDirective).directive('uiState', uiStateDirective);
      $IsStateFilter.$inject = ['$state'];
      function $IsStateFilter($state) {
        var isFilter = function (state, params, options) {
          return $state.is(state, params, options);
        };
        isFilter.$stateful = true;
        return isFilter;
      }
      $IncludedByStateFilter.$inject = ['$state'];
      function $IncludedByStateFilter($state) {
        var includesFilter = function (state, params, options) {
          return $state.includes(state, params, options);
        };
        includesFilter.$stateful = true;
        return includesFilter;
      }
      ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
      var uiView;
      uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q', function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer(attrs, scope) {
          return {
            enter: function (element, target, cb) {
              if (ng.version.minor > 2) {
                $animate.enter(element, null, target).then(cb);
              } else {
                $animate.enter(element, null, target, cb);
              }
            },
            leave: function (element, cb) {
              if (ng.version.minor > 2) {
                $animate.leave(element).then(cb);
              } else {
                $animate.leave(element, cb);
              }
            }
          };
        }
        function configsEqual(config1, config2) {
          return config1 === config2;
        }
        var rootData = {
          $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
          $uiView: {}
        };
        var directive = {
          count: 0,
          restrict: 'ECA',
          terminal: true,
          priority: 400,
          transclude: 'element',
          compile: function (tElement, tAttrs, $transclude) {
            return function (scope, $element, attrs) {
              var onloadExp = attrs['onload'] || '',
                  autoScrollExp = attrs['autoscroll'],
                  renderer = getRenderer(attrs, scope),
                  inherited = $element.inheritedData('$uiView') || rootData,
                  name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
              var previousEl, currentEl, currentScope, viewConfig, unregister;
              var activeUIView = {
                $type: 'ng1',
                id: directive.count++,
                name: name,
                fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
                config: null,
                configUpdated: configUpdatedCallback,
                get creationContext() {
                  var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
                  var fromParentTag = core.parse('$uiView.creationContext')(inherited);
                  return fromParentTagConfig || fromParentTag;
                }
              };
              core.trace.traceUIViewEvent('Linking', activeUIView);
              function configUpdatedCallback(config) {
                if (config && !(config instanceof Ng1ViewConfig)) return;
                if (configsEqual(viewConfig, config)) return;
                core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                viewConfig = config;
                updateView(config);
              }
              $element.data('$uiView', { $uiView: activeUIView });
              updateView();
              unregister = $view.registerUIView(activeUIView);
              scope.$on('$destroy', function () {
                core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
                unregister();
              });
              function cleanupLastView() {
                if (previousEl) {
                  core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
                  previousEl.remove();
                  previousEl = null;
                }
                if (currentScope) {
                  core.trace.traceUIViewEvent('Destroying scope', activeUIView);
                  currentScope.$destroy();
                  currentScope = null;
                }
                if (currentEl) {
                  var _viewData_1 = currentEl.data('$uiViewAnim');
                  core.trace.traceUIViewEvent('Animate out', _viewData_1);
                  renderer.leave(currentEl, function () {
                    _viewData_1.$$animLeave.resolve();
                    previousEl = null;
                  });
                  previousEl = currentEl;
                  currentEl = null;
                }
              }
              function updateView(config) {
                var newScope = scope.$new();
                var animEnter = $q.defer(),
                    animLeave = $q.defer();
                var $uiViewData = {
                  $cfg: config,
                  $uiView: activeUIView
                };
                var $uiViewAnim = {
                  $animEnter: animEnter.promise,
                  $animLeave: animLeave.promise,
                  $$animLeave: animLeave
                };
                newScope.$emit('$viewContentLoading', name);
                var cloned = $transclude(newScope, function (clone) {
                  clone.data('$uiViewAnim', $uiViewAnim);
                  clone.data('$uiView', $uiViewData);
                  renderer.enter(clone, $element, function onUIViewEnter() {
                    animEnter.resolve();
                    if (currentScope) currentScope.$emit('$viewContentAnimationEnded');
                    if (core.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                      $uiViewScroll(clone);
                    }
                  });
                  cleanupLastView();
                });
                currentEl = cloned;
                currentScope = newScope;
                currentScope.$emit('$viewContentLoaded', config || viewConfig);
                currentScope.$eval(onloadExp);
              }
            };
          }
        };
        return directive;
      }];
      $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q', '$timeout'];
      function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q, $timeout) {
        var getControllerAs = core.parse('viewDecl.controllerAs');
        var getResolveAs = core.parse('viewDecl.resolveAs');
        return {
          restrict: 'ECA',
          priority: -400,
          compile: function (tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function (scope, $element) {
              var data = $element.data('$uiView');
              if (!data) {
                $element.html(initial);
                $compile($element.contents())(scope);
                return;
              }
              var cfg = data.$cfg || {
                viewDecl: {},
                getTemplate: core.noop
              };
              var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
              $element.html(cfg.getTemplate($element, resolveCtx) || initial);
              core.trace.traceUIViewFill(data.$uiView, $element.html());
              var link = $compile($element.contents());
              var controller = cfg.controller;
              var controllerAs = getControllerAs(cfg);
              var resolveAs = getResolveAs(cfg);
              var locals = resolveCtx && getLocals(resolveCtx);
              scope[resolveAs] = locals;
              if (controller) {
                var controllerInstance = $controller(controller, core.extend({}, locals, {
                  $scope: scope,
                  $element: $element
                }));
                if (controllerAs) {
                  scope[controllerAs] = controllerInstance;
                  scope[controllerAs][resolveAs] = locals;
                }
                $element.data('$ngControllerController', controllerInstance);
                $element.children().data('$ngControllerController', controllerInstance);
                registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
              }
              if (core.isString(cfg.viewDecl.component)) {
                var cmp_1 = cfg.viewDecl.component;
                var kebobName = core.kebobString(cmp_1);
                var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
                var getComponentController = function () {
                  var directiveEl = [].slice.call($element[0].children).filter(function (el) {
                    return el && el.tagName && tagRegexp_1.exec(el.tagName);
                  });
                  return directiveEl && ng.element(directiveEl).data("$" + cmp_1 + "Controller");
                };
                var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                  if (!ctrlInstance) return;
                  registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
                  deregisterWatch_1();
                });
              }
              link(scope);
            };
          }
        };
      }
      var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
      var _uiCanExitId = 0;
      function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
        if (core.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) {
          controllerInstance.$onInit();
        }
        var viewState = core.tail(cfg.path).state.self;
        var hookOptions = { bind: controllerInstance };
        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
          var resolveContext = new core.ResolveContext(cfg.path);
          var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
          var paramsUpdated = function ($transition$) {
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1) return;
            var toParams = $transition$.params('to');
            var fromParams = $transition$.params('from');
            var toSchema = $transition$.treeChanges().to.map(function (node) {
              return node.paramSchema;
            }).reduce(core.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function (node) {
              return node.paramSchema;
            }).reduce(core.unnestR, []);
            var changedToParams = toSchema.filter(function (param) {
              var idx = fromSchema.indexOf(param);
              return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            if (changedToParams.length) {
              var changedKeys_1 = changedToParams.map(function (x) {
                return x.id;
              });
              var newValues = core.filter(toParams, function (val, key) {
                return changedKeys_1.indexOf(key) !== -1;
              });
              controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
          };
          $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
        }
        if (core.isFunction(controllerInstance.uiCanExit)) {
          var id_1 = _uiCanExitId++;
          var cacheProp_1 = '_uiCanExitIds';
          var prevTruthyAnswer_1 = function (trans) {
            return !!trans && (trans[cacheProp_1] && trans[cacheProp_1][id_1] === true || prevTruthyAnswer_1(trans.redirectedFrom()));
          };
          var wrappedHook = function (trans) {
            var promise;
            var ids = trans[cacheProp_1] = trans[cacheProp_1] || {};
            if (!prevTruthyAnswer_1(trans)) {
              promise = $q.when(controllerInstance.uiCanExit(trans));
              promise.then(function (val) {
                return ids[id_1] = val !== false;
              });
            }
            return promise;
          };
          var criteria = { exiting: viewState.name };
          $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
        }
      }
      ng.module('ui.router.state').directive('uiView', uiView);
      ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
      function $ViewScrollProvider() {
        var useAnchorScroll = false;
        this.useAnchorScroll = function () {
          useAnchorScroll = true;
        };
        this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
          if (useAnchorScroll) {
            return $anchorScroll;
          }
          return function ($element) {
            return $timeout(function () {
              $element[0].scrollIntoView();
            }, 0, false);
          };
        }];
      }
      ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
      var index = 'ui.router';
      Object.keys(core).forEach(function (key) {
        exports[key] = core[key];
      });
      exports.core = core;
      exports.default = index;
      exports.watchDigests = watchDigests;
      exports.getLocals = getLocals;
      exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
      exports.ng1ViewsBuilder = ng1ViewsBuilder;
      exports.Ng1ViewConfig = Ng1ViewConfig;
      exports.StateProvider = StateProvider;
      exports.UrlRouterProvider = UrlRouterProvider;
      Object.defineProperty(exports, '__esModule', { value: true });
    });
  })($__require('f9'));
});
$__System.registerDynamic("18d", ["18c"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("18c");
});
$__System.register('18e', ['12', '13'], function (_export) {
	var _createClass, _classCallCheck, UsersService;

	return {
		setters: [function (_2) {
			_createClass = _2['default'];
		}, function (_3) {
			_classCallCheck = _3['default'];
		}],
		execute: function () {
			'use strict';

			UsersService = (function () {
				function UsersService($http, LcCache, Track, _) {
					_classCallCheck(this, UsersService);

					this.$http = $http;
					this.LcCache = LcCache;
					this.Track = Track;

					this.userTransform = function (data) {
						return angular.toJson({
							'first_name': data.first_name,
							'last_name': data.last_name,
							'email': data.email,
							'username': data.email,
							'password': data.verify,
							'org_uuid': data.org_uuid,
							'permissions': data.permissions,
							'user_security_question': data.user_security_question || '',
							'user_security_answer': data.user_security_answer || '',
							'user_security_pin_code': data.user_security_pin_code || '',
							'user_phone_no': data.user_phone_no || '',
							'uuid': data.uuid,
							'password_logged_in_user': data.password_logged_in_user || '',
							'authy_cell_no': data.authy_cell_no || '',
							'authy_country_code': data.authy_country_code || 1,
							'authy_opted_in': data.authy_opted_in || false,
							'touch_passcode': data.touch_passcode,
							'touch_passcode_enable': data.touch_passcode_enable,
							'org_admin': data.org_admin
						});
					};

					this.parseUserData = function (data, filterOrgId) {
						return _.filter(data, function (user) {
							return user.username !== 'AnonymousUser' && (filterOrgId ? matchOrg(user.permissions, filterOrgId) : true);
						});
					};

					function matchOrg(perms, filterOrgId) {
						return _.find(perms, function (perm) {
							return (perm.permission === 'org_user' || perm.permission === 'org_user') && perm.object_id === filterOrgId;
						});
					}
				}

				_createClass(UsersService, [{
					key: 'getAll',
					value: function getAll(filterOrgId) {
						var _this = this;

						return this.$http({
							url: 'user/'
						}).then(function (response) {
							return _this.parseUserData(response.data, filterOrgId);
						});
					}
				}, {
					key: 'get',
					value: function get(id) {
						return this.$http({
							url: 'user/' + id + '/'
						}).then(function (response) {
							return response.data;
						});
					}
				}, {
					key: 'getStatus',
					value: function getStatus() {
						return this.$http({
							url: 'authn/get_status/'
						});
					}
				}, {
					key: 'create',
					value: function create(user) {
						var _this2 = this;

						return this.$http({
							method: 'POST',
							url: 'user/',
							data: user,
							transformRequest: this.userTransform
						}).success(function (result) {
							// this.LcCache.updateSessionSiteSectionChild('users',[result]);
							//move this to editUserInfoEditComponent, because need to handle new created user cases
							_this2.Track.event('User: Created', 'User ' + user.username);
						});
					}
				}, {
					key: 'update',
					value: function update(user) {
						var _this3 = this;

						return this.$http({
							method: 'PUT',
							url: 'user/' + user.id + '/',
							data: user,
							transformRequest: this.userTransform
						}).success(function () {
							_this3.LcCache.updateSessionSiteSectionChild('users', [user]);
							_this3.Track.event('User: Created', 'User ' + user.username);
						});
					}
				}, {
					key: 'del',
					value: function del(user) {
						var _this4 = this;

						return this.$http({
							method: 'DELETE',
							url: 'user/' + user.id + '/'
						}).success(function () {
							_this4.LcCache.removeSessionSiteSectionChild('users', [user]);
							_this4.Track.event('User: Deleted', 'User ' + user.name);
						});
					}
				}, {
					key: 'getPhoneCode',
					value: function getPhoneCode(id) {
						return this.$http({
							url: 'user/' + id + '/phone_code/'
						});
					}
				}, {
					key: 'getEmailSubscribers',
					value: function getEmailSubscribers() {
						return this.$http({
							url: 'fixture_health_email/'
						});
					}
				}, {
					key: 'addSubscribers',
					value: function addSubscribers(subscribers) {
						return this.$http({
							method: 'POST',
							url: 'fixture_health_email/',
							data: subscribers //[{user_id, site_id}]
						});
					}
				}, {
					key: 'deleteSubscriber',
					value: function deleteSubscriber(id) {
						return this.$http({
							method: 'DELETE',
							url: 'fixture_health_email/' + id + '/'
						});
					}
				}, {
					key: 'getSingle',
					value: function getSingle(id) {
						return this.$http({
							url: 'user/' + id + '/'
						});
					}
				}, {
					key: 'resendEmail',
					value: function resendEmail(userId) {
						return this.$http({
							method: 'POST',
							url: 'audit/send_welcome_email/',
							data: { 'user_id': userId }
						});
					}
				}, {
					key: 'requestAuthyPhoneVerification',
					value: function requestAuthyPhoneVerification(cellNo, countryCode) {
						return this.$http({
							method: 'PUT',
							url: 'audit/request_phone_verification/',
							data: {
								'authy_cell_no': cellNo,
								'authy_country_code': countryCode
							}
						});
					}
				}, {
					key: 'authyPhoneValidation',
					value: function authyPhoneValidation(cellNo, validationCode, countryCode) {
						return this.$http({
							method: 'PUT',
							url: 'audit/check_phone_verification/',
							data: {
								'authy_cell_no': cellNo,
								'validation_code': validationCode,
								'authy_country_code': countryCode
							}
						});
					}
				}]);

				return UsersService;
			})();

			_export('default', UsersService);
		}
	};
});

$__System.registerDynamic("18f", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"users gutters-20\">\n    <!-- \n        /users View option A (Base) - Nothing selected - Welcome / Add new scene user\n    -->\n    <div ng-if=\"!uB.itemCollection.filtered\">\n        <div class=\"welcome-screen\" ng-if=\"!uB.blankUser\">\n            <h1 translate=\"customerService.users\">Users</h1>\n            <!-- @todoyu Translations -->\n            <h2 translate=\"settings.permissionsUserManagement\">Permissions & User Management</h2>\n            <div class=\"setup-mode\" translate=\"common.selectAnExisting\">Select exisiting from left or create one with the plus button</div>\n        </div>\n\n        <users-user-info-edit\n            ng-if=\"uB.blankUser\"\n            current-session-user=\"uB.user\"\n            context-user=\"uB.blankUser\"\n            context-user-is-org-admin=\"uB.contextUserIsOrgAdmin\"\n            org=\"uB.org\"\n            on-user-naviagtion=\"uB.navigate(userId,newUser);\"\n            on-user-update=\"uB.userUpdate(user)\"\n            on-user-org-admin-update=\"uB.userOrgAdminUpdate(orgAdmin)\"\n        ></users-user-info-edit>\n    </div>\n    <!-- \n        /users View option B - Single user control\n    -->\n    <section ng-if=\"uB.contextUser\">\n        <users-user-info-edit\n            current-session-user=\"uB.user\"\n            context-user=\"uB.contextUser\"\n            context-user-is-org-admin=\"uB.contextUserIsOrgAdmin\"\n            org=\"uB.org\"\n            on-user-naviagtion=\"uB.navigate(userId,newUser);\"\n            on-user-update=\"uB.userUpdate(user)\"\n            on-user-org-admin-update=\"uB.userOrgAdminUpdate(orgAdmin)\"\n        ></users-user-info-edit>\n\n        <permissions-base\n            current-session-user-write-access=\"uB.currentSessionUserWriteAccess\"\n            context-user=\"uB.contextUser\"\n            context-user-is-org-admin=\"uB.contextUserIsOrgAdmin\"            \n            sites=\"uB.sites\"\n            org=\"uB.org\"\n        ></permissions-base>\n\n        <permissions-multi-org\n            context-user=\"uB.contextUser\"\n            org=\"uB.org\"\n            ng-if=\"uB.user.is_superuser && !uB.contextUser.org\"\n            on-user-update=\"uB.userUpdate(user)\"\n        ></permissions-multi-org>\n    </section>\n    <!-- \n        /users View option C - group selection options\n    -->\n    <div ng-if=\"uB.groupSelection\">\n        <section class=\"main-left\">\n            <h2 class=\"overview-heading\">\n                <span>Group Actions</span>\n            </h2>\n\n            <div class=\"left\">\n                <button class=\"btn orange delete\" ng-click=\"uB.deleteGroup(uB.groupSelection)\">Delete Group</button>\n            </div>\n        </section>\n    </div>\n</div>";
});
$__System.register('190', ['18f'], function (_export) {
    'use strict';

    var usersBaseTemplate, usersBaseComponent;
    return {
        setters: [function (_f) {
            usersBaseTemplate = _f['default'];
        }],
        execute: function () {
            usersBaseComponent = {
                template: usersBaseTemplate,
                bindings: {
                    user: '<',
                    itemCollection: '<',
                    org: '<',
                    sessionData: '<',
                    sites: '<',
                    onSelectionUpdate: '&'
                },
                controllerAs: 'uB',
                controller: function controller($scope, $q, $state, SessionAdapter, Modals, Users, LcFn) {

                    var uB = this;

                    uB.$onInit = function () {

                        SessionAdapter.fetchers.orgSites(uB.org.uuid).then(function (sites) {
                            uB.sites = sites;
                        });

                        //
                        // uB.user too confusing, use currentSession & contextUser
                        //
                        //
                        uB.currentSessionUser = uB.user;

                        //
                        // Can current user edit their / others perms?
                        //
                        uB.currentSessionUserWriteAccess = LcFn.isOrgAdmin(uB.currentSessionUser, uB.org);

                        //
                        // Show 'user has full perms' is org admin / super
                        //
                        if (uB.contextUser) {
                            uB.contextUserIsOrgAdmin = LcFn.isOrgAdmin(uB.contextUser, uB.org);
                        }

                        uB.onSelectionUpdate({ selection: uB.itemCollection });

                        prepareViewContext();
                    };

                    uB.$onChanges = function () {
                        //
                    };

                    uB.navigate = function (userId, newUser) {
                        //go to that user after creation
                        var filter = userId ? ['selection~' + userId] : null;
                        $state.go('Users', { siteId: uB.sessionData.id, userSelectedFilter: filter });
                    };

                    uB.deleteGroup = function (group) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + group.length + '</strong> users?').then(function () {

                            Modals.openLoad('Deleting users');

                            var usersToDelete = group.map(function (user) {
                                return Users.del(user);
                            });

                            $q.all(usersToDelete).then(function () {
                                Modals.closeLoad('users Deleted', true);
                                uB.navigate();
                            }, function () {
                                //Failures handled here
                            });
                        });
                    };

                    uB.userUpdate = function () {
                        prepareViewContext();
                    };

                    uB.userOrgAdminUpdate = function (orgAdmin) {
                        uB.contextUserIsOrgAdmin = orgAdmin;
                    };

                    var NewUser = function NewUser(siteId) {
                        //
                        // What does a dummy user look like? (no joke intended)
                        //
                        this.org_admin = false;
                    };

                    function prepareViewContext() {
                        //Base View if filtered false
                        if (uB.itemCollection.filtered) {
                            if (uB.itemCollection.group.length > 1) {
                                uB.groupSelection = uB.itemCollection.group;
                            } else {
                                uB.contextUser = uB.itemCollection.group[0];
                            }
                        }

                        if (uB.itemCollection['new']) {
                            uB.blankUser = new NewUser(uB.sessionData.id);
                        }
                    }
                }
            };

            _export('default', usersBaseComponent);
        }
    };
});

$__System.registerDynamic("191", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"user-modal zone-details\">\n\n    <form name=\"userForm\" novalidate>\n        <div>\n            <div class=\"input-field half\">\n                <label translate=\"settings.firstName\">First Name</label>\n                <input type=\"text\" placeholder=\"First Name\" name=\"firstName\" ng-model=\"uUIE.contextUser.first_name\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"true\" ng-pattern=\"/^[\\p{L}\\p{M}][\\p{L}\\p{M}\\p{Zs},.'-]+$/u\"  ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                <p ng-show=\"uUIE.submitted && userForm.firstName.$invalid\" class=\"error-msg\">{{'settings.errorMsg' | translate}}First Name</p>\n            </div>\n            <div class=\"input-field half\">\n                <label translate=\"settings.lastName\">Last Name</label>\n                <input type=\"text\" placeholder=\"Last Name\" name=\"lastName\" ng-model=\"uUIE.contextUser.last_name\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"true\" ng-pattern=\"/^[\\p{L}\\p{M}][\\p{L}\\p{M}\\p{Zs},.'-]+$/u\"  ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                <p ng-show=\"uUIE.submitted && userForm.lastName.$invalid\" class=\"error-msg\">{{'settings.errorMsg' | translate}}Last Name</p>\n            </div>\n        </div>\n        <div>\n            <div class=\"input-field half\">\n                <label translate=\"settings.email\">E-Mail</label>\n                <input type=\"email\" placeholder=\"{{'settings.email' | translate}}\" name=\"email\" ng-model=\"uUIE.contextUser.email\" ng-required=\"true\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                <p ng-show=\"uUIE.submitted && userForm.email.$invalid\" class=\"error-msg\">{{'settings.errorMsg' | translate}}E-Mail</p>\n            </div>\n            <div class=\"input-field half\">\n                <label translate=\"settings.phoneNumber\">Phone Number</label>\n                <input type=\"tel\" ng-pattern=\"/^([0-9]( |-)?)?(\\(?[0-9]{3}\\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/\"  autocomplete=\"tel\" placeholder=\"{{'settings.phoneNumber' | translate }}\" name=\"phone\" ng-model=\"uUIE.contextUser.user_phone_no\" ng-minlength=\"10\" ng-maxlength=\"20\" ng-required=\"false\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                <p ng-show=\"uUIE.submitted && userForm.phone.$invalid\" class=\"error-msg\">{{'settings.errorMsg' | translate}}Phone Number</p>\n            </div>\n        </div>\n\n        <div ng-show=\"uUIE.ToChangePass || (!uUIE.contextUser.id && !uUIE.tempPass)\">\n            <div>\n                <div class=\"input-field half\">\n                    <label translate=\"login.password\">Password</label>\n                    <input type=\"password\" autocomplete=\"new-password\" placeholder=\"{{'login.password' | translate }}\" name=\"password\" ng-model=\"uUIE.contextUser.password\" ng-minlength=\"8\" ng-maxlength=\"254\" ng-required=\"!uUIE.contextUser.id\" match=\"uUIE.contextUser.verify\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                    <p ng-show=\"uUIE.submitted && userForm.password.$invalid\" class=\"error-msg\">{{'login.passwordMatching' | translate}}{{'login.passwordError' | translate}}</p>\n                </div>\n\n                <div class=\"input-field half\">\n                    <label translate=\"login.reenterPassword\">Re-Enter Password</label>\n                    <input type=\"password\" autocomplete=\"new-password\" placeholder=\"{{'login.reenterPassword' | translate }}\" name=\"verify\" ng-model=\"uUIE.contextUser.verify\" ng-minlength=\"8\" ng-maxlength=\"254\" ng-pattern=\"regex\" ng-required=\"!uUIE.contextUser.id\" match=\"uUIE.contextUser.password\" ng-change=\"uUIE.watchChange()\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n                    <p ng-show=\"uUIE.submitted && userForm.verify.$invalid\" class=\"error-msg\">{{'login.passwordMatching' | translate}}{{'login.passwordError' | translate}}</p>\n                </div>\n            </div>\n            <button type=\"button\" class=\"btn blue\" ng-click=\"uUIE.setTempPass(); $event.stopPropagation();\" ng-disabled=\"uUIE.pending\" ng-hide=\"uUIE.ToChangePass\" translate=\"settings.useGeneratedPassword\">Use Generated Password</button>\n            <button type=\"button\" class=\"btn blue\" ng-click=\"uUIE.ToChangePass = !uUIE.ToChangePass\" ng-disabled=\"uUIE.pending\" ng-hide=\"!uUIE.contextUser.id\">{{'settings.useCurrentPassword' | translate}}</button>\n        </div>\n\n        <div ng-show=\"uUIE.tempPass\" class=\"temp-pass\">\n            <p>{{'settings.temporaryPassword' | translate}}<span class=\"bold\">{{uUIE.tempPass}}</span>{{'settings.created' | translate}}</p>\n            <button type=\"button\" class=\"btn blue\" ng-click=\"uUIE.setPass(); $event.stopPropagation();\" ng-disabled=\"uUIE.pending\" translate=\"settings.chooseOwnPassword\">Choose Own Password</button>\n        </div>\n\n        <div class=\"temp-pass\">\n            <button type=\"button\" class=\"btn blue\" ng-click=\"uUIE.ToChangePass = !uUIE.ToChangePass\" ng-disabled=\"uUIE.pending\" ng-hide=\"uUIE.ToChangePass || !uUIE.contextUser.id\">{{'settings.changePassword' | translate}}</button>\n        </div>\n\n        <div>\n            <div class=\"half inline-block\">\n                <div class=\"input-field full\">\n                    <label class=\"auth-info\" translate=\"login.twoFactorAuth\">Two Factor Authentication</label>\n\n                    <div class=\"help\" id=\"authInfo\">\n                        <div class=\"arrow\"></div>\n\n                        <p>Two-factor authentication is an extra layer of security for your Lightcloud login that ensures that you're the only person who can access your account, even if someone knows your password. Enter your mobile phone number here and you will be texted a passcode when you login.\n                        </p>\n\n                    </div>\n                </div>\n\n                <i \n                    class=\"auth-info\" \n                    help \n                    data-help-div=\"authInfo\"\n                    id=\"authInfoIcon\"\n                ></i>\n\n                <div class=\"full auth-info\">\n\n                    <div class=\"auth-container\">\n                        <button class=\"btn btn-select-toggle\" type=\"button\" ng-class=\"{selected:uUIE.contextUser.authy_opted_in}\" ng-click=\"uUIE.TFAOpt(uUIE.contextUser)\"></button>\n                        <span translate>{{uUIE.contextUser.authy_opted_in? 'common.on' : 'common.off'}}</span>\n                        <span ng-show=\"uUIE.contextUser.authy_opted_in\">{{lastFour}}</span>\n                    </div>\n\n                </div>\n            </div>\n\n\n            <div class=\"half inline-block\" ng-if=\"uUIE.currentSessionUser.is_superuser || uUIE.currentSessionUserIsOrgAdmin || uUIE.contextUserIsOrgAdmin\">\n                <div class=\"input-field half\">\n                    <label class=\"auth-info\" translate=\"\">Account Administrator</label>\n                </div>\n\n                <div class=\"full auth-info\">\n                    <!-- for old user system-->\n                    <div class=\"auth-container\" ng-if=\"uUIE.contextUser.org\">\n                        <button class=\"btn btn-select-toggle\" type=\"button\" ng-class=\"{selected:uUIE.contextUser.org_admin}\" ng-click=\"uUIE.updateUserOrgAdmin()\" ng-disabled=\"uUIE.currentSessionUser.id === uUIE.contextUser.id\"></button>\n                        <span translate>{{uuUIE.contextUserIsOrgAdmin ? 'devices.enabled' : ''}}</span>\n                        <span></span>\n                    </div>\n                    <!-- for newer one-->\n                    <div class=\"auth-container\" ng-if=\"!uUIE.contextUser.org\">\n                        <button class=\"btn btn-select-toggle\" type=\"button\" ng-class=\"{selected:uUIE.contextUserIsOrgAdmin}\" ng-click=\"uUIE.updateNewUserOrgAdmin()\" ng-disabled=\"uUIE.currentSessionUser.id === uUIE.contextUser.id\"></button>\n                        <span translate>{{uuUIE.contextUserIsOrgAdmin ? 'devices.enabled' : ''}}</span>\n                        <span></span>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n        <div>\n            <div class=\"half inline-block\">\n                <div class=\"input-field half\">\n                    <label class=\"auth-info\" translate=\"\">Touch PIN Enabled</label>\n\n                    <div class=\"help\" id=\"touchInfo\">\n                        <div class=\"arrow\"></div>\n\n                        <p>Enable PIN code access for the Lightcloud Touch. On save, we will generate a PIN code for this user.</p>\n                    </div>\n                </div>\n\n                <!-- @yuchao - why is this posistion so badly -->\n                <!-- <i class=\"auth-info\" help data-help-div=\"touchInfo\" id=\"touchInfoIcon\"></i> -->\n\n                <div class=\"full auth-info\">\n                    <div class=\"auth-container\">\n                        <button class=\"btn btn-select-toggle\" type=\"button\" ng-class=\"{selected:uUIE.contextUser.touch_passcode_enable}\" ng-click=\" uUIE.contextUser.touch_passcode_enable = !uUIE.contextUser.touch_passcode_enable\"></button>\n                        <span translate>{{uUIE.contextUser.touch_passcode_enable ? 'devices.enabled' : ''}}</span>\n                        <span></span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"input-field half\" ng-if=\"uUIE.contextUser.touch_passcode_enable\">\n                <label class=\"auth-info\" translate=\"\">Touch PIN</label>\n                <input type=\"text\" placeholder=\"PIN Generated on Save\" ng-if=\"!uUIE.contextUser.touch_passcode\" ng-readonly=\"true\" />\n                <input type=\"text\" placeholder=\"PIN Generated on Save\" ng-if=\"uUIE.contextUser.touch_passcode\" name=\"touch_passcode\" ng-model=\"uUIE.contextUser.touch_passcode\" ng-readonly=\"true\"/>\n            </div>\n        </div>\n\n        <div>\n            <div class=\"input-field full\" ng-show=\"uUIE.contextUser.id\">\n                <label translate=\"settings.securityQuestion\">Security Question</label>\n                <input type=\"text\" placeholder=\"{{'settings.securityQuestion' | translate}}\" name=\"securityQuestion\" ng-model=\"uUIE.contextUser.user_security_question\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"false\" ng-change=\"uUIE.watchChange()\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n            </div>\n        </div>\n        <div>\n            <div class=\"input-field full\" ng-show=\"uUIE.contextUser.id\">\n                <label translate=\"settings.answer\">Answer</label>\n                <input type=\"text\" placeholder=\"{{'settings.answer' | translate}}\" name=\"securityAnswer\" ng-model=\"uUIE.contextUser.user_security_answer\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"false\" ng-change=\"uUIE.watchChange()\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\" focused/>\n            </div>\n        </div>\n        <div>\n            <div class=\"input-field full\" ng-show=\"uUIE.contextUser.id\">\n                <label translate=\"settings.securityPin\">Security Pin</label>\n                <input type=\"password\" placeholder=\"{{'settings.securityPin' | translate}}\" name=\"securityPin\" ng-model=\"uUIE.contextUser.user_security_pin_code\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"false\" focused ng-if=\"!uUIE.contextUser.id\" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\"/>\n                <input type=\"text\" placeholder=\"{{'settings.securityPin' | translate}}\" name=\"securityPin\" ng-model=\"uUIE.contextUser.user_security_pin_code\" ng-minlength=\"1\" ng-maxlength=\"254\" ng-required=\"false\" focused ng-if=\"uUIE.contextUser.id \" ng-model-options=\"{ debounce: 1000 }\" ng-keyup=\"uUIE.formEnter($event)\"/>\n            </div>\n        </div>\n        <div  class=\"half-buttons\">\n            <button type=\"button\" class=\"btn delete half\" ng-if=\"uUIE.contextUser.id && !uUIE.contextUser.delConfirm && (uUIE.contextUser.id !== uUIE.currentselectedUser.id)\" ng-click=\"uUIE.contextUser.delConfirm = true;\" translate=\"settings.deleteUser\">Delete User</button>\n            <button type=\"button\" ng-show=\"uUIE.contextUser.delConfirm\" class=\"btn orange delete half\" ng-click=\"uUIE.deleteUser(uUIE.contextUser)\" translate=\"common.confirmDelete\" translate=\"common.confirmDelete\">Confirm Delete</button>\n\n            <button ng-click=\"uUIE.update(uUIE.contextUser, userForm);blockEnter()\" class=\"btn blue save\"  ng-if=\"!uUIE.selecting\" ng-disabled=\"uUIE.pending || !userForm.$valid\" translate>{{uUIE.pending ? 'common.working' : 'common.save'}}</button>\n            <button ng-show=\"!uUIE.contextUser.id\" ng-click=\"uUIE.resetForm(userForm)\" type=\"button\" class=\"btn delete\" translate> Reset </button>\n        </div>\n\n        <div ng-if=\"uUIE.currentSessionUserIsOrgAdmin\"  ng-show=\"uUIE.contextUser.id\"  class=\"half-buttons\">\n            <button class=\"btn blue save\" ng-click=\"uUIE.resendEmail()\">Resend Welcome Email</button>\n        </div>\n\n        <div  ng-show=\"uUIE.contextUser.id\"  class=\"half-buttons\">\n            <phone-code user=\"uUIE.contextUser\"></phone-code>\n        </div>\n\n    </form>\n    <div class=\"error user-modal\" ng-show=\"uUIE.error\">{{ uUIE.userUpdateErrorMsg }}</div>\n\n</section>\n";
});
$__System.register('192', ['191'], function (_export) {
    'use strict';

    var usersUserInfoEditTemplate, usersUserInfoEdit;
    return {
        setters: [function (_2) {
            usersUserInfoEditTemplate = _2['default'];
        }],
        execute: function () {
            usersUserInfoEdit = {
                template: usersUserInfoEditTemplate,
                bindings: {
                    currentSessionUser: '<',
                    contextUser: '<',
                    contextUserIsOrgAdmin: '<',
                    org: '<',
                    onUserUpdate: '&',
                    onUserNaviagtion: '&',
                    onUserOrgAdminUpdate: '&'
                },
                controllerAs: 'uUIE',
                controller: function controller($timeout, $window, LcCache, Users, Modals, Permissions, LcFn, _) {

                    var uUIE = this;

                    uUIE.$onInit = function () {

                        uUIE.currentSessionUserIsOrgAdmin = LcFn.isOrgAdmin(uUIE.currentSessionUser, uUIE.org);
                        uUIE.contextUserIsOrgAdmin = LcFn.isOrgAdmin(uUIE.contextUser, uUIE.org);

                        maskPhoneCode();
                        uUIE.originalInfo = angular.copy(uUIE.contextUser);
                        uUIE.regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z` ~ ! @ # $ % ^ * ( ) _ _ + + .  - - - = { } | \[ \] & \ : " ; ' < > ? , . /]{8,}$/;
                        uUIE.setPassCodeEnabledValue();
                    };

                    uUIE.setPassCodeEnabledValue = function () {
                        uUIE.contextUser.touch_passcode_enable = !!uUIE.contextUser.touch_passcode;
                    };

                    uUIE.updateUserOrgAdmin = function () {
                        uUIE.contextUser.org_admin = !uUIE.contextUser.org_admin;
                    };

                    uUIE.updateNewUserOrgAdmin = function () {
                        uUIE.contextUserIsOrgAdmin = !uUIE.contextUserIsOrgAdmin;
                        uUIE.contextUser.org_admin = uUIE.contextUserIsOrgAdmin;
                        uUIE.org_admin_changed = !uUIE.org_admin_changed;
                    };

                    uUIE.resetForm = function (userForm) {
                        uUIE.ToChangePass = false;
                        uUIE.tempPass = '';

                        if (uUIE.contextUser.org_admin) {
                            uUIE.updateNewUserOrgAdmin();
                        }

                        uUIE.contextUser = {
                            email: '',
                            user_phone_no: '',
                            password: '',
                            verify: '',
                            authy_opted_in: false
                        };
                    };

                    uUIE.selectUser = function (user) {
                        user.selected = !user.selected;
                    };

                    uUIE.deleteUser = function (user) {
                        Modals.openLoad('Deleting User');
                        uUIE.pending = true;
                        Users.del(user).success(function (user) {
                            uUIE.pending = false;
                            Modals.closeLoad('User Deleted', true);
                            uUIE.onUserUpdate({ user: user });
                            uUIE.onUserNaviagtion({ userId: null, newUser: true });
                        }).error(function () {
                            uUIE.pending = false;
                            uUIE.error = true;
                            Modals.closeLoad('Deletion Failed');
                        });
                    };

                    uUIE.update = update;
                    uUIE.setTempPass = setTempPass;

                    uUIE.resendEmail = function () {

                        Modals.openLoad('Resending Welcome Email');

                        Users.resendEmail(uUIE.contextUser.id).success(function () {

                            Modals.closeLoad('Resending Welcome Email is Successful', true);
                        }).error(function () {
                            Modals.closeLoad('Resending Welcome Email Failed');
                        });
                    };

                    uUIE.TFAOpt = function (user) {
                        if (uUIE.contextUser.authy_opted_in) {
                            uUIE.contextUser.authy_opted_in = false;
                            uUIE.contextUser.authy_cell_no = null;
                            uUIE.tfaChanged = true;
                        } else {
                            uUIE.contextUser.authy_cell_no = null;
                            tFAEdite(user);
                        }
                    };

                    //for key event: save user
                    uUIE.formEnter = function (event) {
                        if (event.keyCode === 13) {
                            uUIE.update(uUIE.contextUser, uUIE.userForm);
                        }
                    };

                    uUIE.setPass = function () {
                        uUIE.tempPass = null;
                        uUIE.contextUser.password = '';
                        uUIE.contextUser.verify = '';
                    };

                    uUIE.watchChange = function () {
                        uUIE.showCurrentPassword = true;
                    };

                    uUIE.toggleOrgAdmin = function (user, org) {
                        uUIE.pending = true;

                        return (uUIE.contextUserIsOrgAdmin ? grantOrgAdmin(user, org) : revokeOrgAdmin(user, org)).then(function () {
                            uUIE.pending = false;

                            uUIE.contextUser.org_admin = uUIE.contextUserIsOrgAdmin;
                            uUIE.onUserUpdate({ user: uUIE.contextUser });
                            uUIE.onUserOrgAdminUpdate({ orgAdmin: uUIE.contextUserIsOrgAdmin });
                        })['catch'](function () {
                            //new user in old system will send a failure request
                            if (uUIE.contextUser.id && !uUIE.contextUser.org) {
                                uUIE.contextUserIsOrgAdmin = !uUIE.contextUserIsOrgAdmin;
                                uUIE.contextUser.org_admin = uUIE.contextUserIsOrgAdmin;
                            }
                            uUIE.pending = false;
                        });
                    };

                    function grantOrgAdmin(user, org) {
                        return Permissions.setUser(user.id, 'org', org.id, 'org_admin');
                    }

                    function revokeOrgAdmin(user, org) {
                        return Permissions.revokeUser(user.id, 'org', org.id, 'org_admin');
                    }

                    function ajaxUser(user, loggedInPass) {
                        //
                        // BE Wants pass of logged in user
                        //
                        user.password_logged_in_user = loggedInPass;

                        Modals.openLoad('Updating User');

                        user.org_uuid = user.org_uuid || uUIE.org.uuid; //Give user the current org ID - do we need to do this?

                        return user.id ? Users.update(user) : Users.create(user);
                    }

                    function update(user, optionalForm) {
                        uUIE.pending = true;
                        uUIE.submitted = true; //-What is this for?
                        uUIE.error = false;

                        return confirmAdminPassword().then(function (password) {
                            return password ? ajaxUser(user, password) : null;
                        }).then(function (result) {
                            Modals.closeLoad('Complete', true);

                            if (result) {
                                if (uUIE.contextUser.org) {
                                    uUIE.contextUserIsOrgAdmin = uUIE.contextUser.org_admin;
                                }
                                //handle new system org admin setting for new User

                                if (uUIE.org_admin_changed) {
                                    if (!uUIE.contextUser.id) {
                                        uUIE.contextUser = result.data;

                                        LcCache.updateSessionSiteSectionChild('users', [uUIE.contextUser]);
                                    }
                                    uUIE.toggleOrgAdmin(uUIE.contextUser, uUIE.org).then(function () {

                                        uUIE.org_admin_changed = false;
                                        uUIE.onUserNaviagtion({ userId: result.data.id, newUser: true });
                                    })['catch'](function (err) {
                                        console.log(err);

                                        uUIE.onUserNaviagtion({ userId: result.data.id, newUser: false });
                                        uUIE.org_admin_changed = false;
                                    });
                                } else {
                                    uUIE.onUserUpdate({ user: result.data });
                                    uUIE.onUserOrgAdminUpdate({ orgAdmin: uUIE.contextUserIsOrgAdmin });
                                    uUIE.onUserNaviagtion({ userId: result.data.id, newUser: false });
                                    uUIE.contextUser = result.data;
                                    LcCache.updateSessionSiteSectionChild('users', [uUIE.contextUser]);
                                }

                                uUIE.setPassCodeEnabledValue();
                            } else {
                                return result;
                            }
                        })['catch'](function (errorResponse) {
                            var errorMsg = parseErrorMessage(errorResponse.data);
                            uUIE.userUpdateErrorMsg = errorMsg;
                            uUIE.error = true;

                            Modals.closeLoad(_.startCase(errorMsg));

                            return errorMsg;
                        })['finally'](function () {
                            uUIE.pending = false;
                            uUIE.submitted = false;
                        });
                    }

                    function parseErrorMessage(data) {
                        var message = '';

                        if (data.username) {
                            if (data.username[0]) {
                                message = data.username[0];
                            }
                        } else if (data.error) {
                            message = 'Current Password Wrong';
                        } else if (_.map(data)[0]) {
                            message = _.map(data)[0];
                        } else if (data.details) {
                            message = data.details;
                        }

                        if (!message || message.length < 1) {
                            message = 'Failed';
                        }

                        return message;
                    }

                    function confirmAdminPassword() {
                        uUIE.contextUser.current_password = null;

                        $timeout(function () {
                            //
                            //
                            // @refactor Can we get rid of jquery here ?
                            //
                            //
                            $("input[name='current_password']").focus();
                        });

                        return Modals.showModal({
                            name: 'userConfirmPassword',
                            inputs: {
                                user: uUIE.contextUser,
                                users: [],
                                selecting: uUIE.selecting,
                                userForm: uUIE.userForm
                            }
                        });
                    }

                    //Psuedo-random TEMP password - JS Password generation is a bad idea...
                    var passGen = {
                        _pattern: /[a-zA-Z0-9_\-\+\.]/,

                        _getRandomByte: function _getRandomByte() {
                            // http://caniuse.com/#feat=getrandomvalues
                            var result = null;
                            if ($window.crypto && $window.crypto.getRandomValues) {
                                result = new Uint8Array(1);
                                $window.crypto.getRandomValues(result);
                                return result[0];
                            } else if ($window.msCrypto && $window.msCrypto.getRandomValues) {
                                result = new Uint8Array(1);
                                $window.msCrypto.getRandomValues(result);
                                return result[0];
                            } else {
                                return Math.floor(Math.random() * 256);
                            }
                        },

                        generate: function generate(length) {
                            return Array.apply(null, { 'length': length }).map(function () {
                                var result;
                                while (true) {
                                    result = String.fromCharCode(this._getRandomByte());
                                    if (this._pattern.test(result)) {
                                        return result;
                                    }
                                }
                            }, this).join('');
                        }
                    };

                    function setTempPass() {
                        uUIE.tempPass = passGen.generate(16);
                        uUIE.contextUser.password = uUIE.tempPass;
                        uUIE.contextUser.verify = uUIE.tempPass;
                    }

                    function tFAEdite(user) {
                        Modals.showModal({
                            name: 'twoFactorAuth',
                            inputs: {
                                user: user
                            }
                        }).then(function (result) {
                            if (result) {
                                if (result.validateSuccess) {
                                    uUIE.contextUser.authy_opted_in = true;
                                    uUIE.contextUser.authy_cell_no = result.authy_cell_no;
                                    uUIE.tfaChanged = true;
                                    maskPhoneCode();
                                }
                            }
                        });
                    }

                    function maskPhoneCode() {
                        if (uUIE.contextUser.authy_opted_in) {
                            uUIE.lastFour = ' ***-***-' + uUIE.contextUser.authy_cell_no.substr(uUIE.contextUser.authy_cell_no.length - 4);
                        } else {
                            uUIE.lastFour = '';
                        }
                    }
                }
            };

            _export('default', usersUserInfoEdit);
        }
    };
});

$__System.register('193', [], function (_export) {
  'use strict';

  var usersStates;
  return {
    setters: [],
    execute: function () {
      usersStates = [{
        abstract: true,
        name: 'users-abstract',
        url: '/users/{orgUuid}',
        resolve: {
          org: function org($transition$, LcCache, Orgs) {
            //
            //
            // Settings view context decided here
            //
            //
            var destinationOrgUuid = $transition$.params('to').orgUuid;

            var currentOrg = LcCache.getCurrentOrg();

            return currentOrg && currentOrg.uuid === destinationOrgUuid ? LcCache.getCurrentOrg() : Orgs.getByUuid(destinationOrgUuid).then(function (org) {
              return org;
            });
          },
          //Resolve site data
          initialSessionData: function initialSessionData(org, $transition$, $q, Session, Orgs, LcCache, Modals, Local, LcFn) {

            //let toParams = $transition$.params('to');

            Modals.openLoad('Getting User Data');

            return $q.all([Orgs.getUsers(org.uuid), Session.getSitesList(null, org.uuid)]).then(function (result) {

              var mockSiteData = { org: org, users: LcFn.bringToFront(result[0], 'uuid', Local.get('lcUser').uuid, true), sites: result[1] };

              LcCache.setSessionSiteData(mockSiteData);

              console.log('Master Structure state change here...');

              LcCache.setCurrentOrg(org);

              Modals.closeLoad('Complete', true);

              return mockSiteData;
            })['catch'](function (error) {
              Modals.closeLoad('Failed');
              console.log('Failed to fetch users - probably dud orgUuid ', error);
            });
          },
          initialSessionSitesListPromise: function initialSessionSitesListPromise(initialSessionData, Session, $q) {
            var sitesListDeferred = $q.defer();

            Session.getSitesList(initialSessionData.id, initialSessionData.org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            });

            return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
          },
          initialSelectedIds: function initialSelectedIds($stateParams, Session) {
            return Session.getUrlParamsUserSelection();
          },
          viewNavContext: function viewNavContext($transition$) {
            var to = $transition$.to();
            //
            // Some views will require different arrangements than default listed below
            //
            // - 'default' ('grouped-zones' view)
            // - 'devices'
            // - 'scenes'
            // 
            //   
            return to.params.leftMenuSpecialContext ? to.params.leftMenuSpecialContext : 'default';
          }
        },

        component: 'masterParent',

        params: {
          allowNew: true,
          'new': false,
          orgUuid: null,

          leftMenuSpecialContext: 'users',
          //
          // - This will prevent route change
          //
          userSelectedFilter: {
            value: null,
            dynamic: true
          }
        },

        //extraSections: ['users']
        title: 'Users'
      }, {
        parent: 'users-abstract',
        name: 'Users',
        url: '/{userSelectedFilter}',
        resolve: {
          sessionData: function sessionData(initialSessionData) {
            return initialSessionData;
          },
          itemCollection: function itemCollection(sessionData, StructureService) {
            return StructureService.itemCollection(sessionData, 'users');
          }
        },

        component: 'usersBase',

        params: {
          allowNew: true,
          'new': false,
          leftMenuSpecialContext: 'users'
        },

        //
        // - This will prevent route change
        //
        // userSelectedFilter: {
        //   value: null,
        //   dynamic: true
        // },
        //extraSections: ['users']
        title: 'Users'
      }];

      _export('usersStates', usersStates);
    }
  };
});

$__System.register('194', ['3', '190', '192', '193', '18d', '18e'], function (_export) {

	//import usersMasterParentComponent from './usersMasterParentComponent';
	'use strict';

	var angular, usersBaseComponent, usersUserInfoEditComponent, usersStates, UsersService, usersModule;
	return {
		setters: [function (_) {
			angular = _['default'];
		}, function (_2) {
			usersBaseComponent = _2['default'];
		}, function (_3) {
			usersUserInfoEditComponent = _3['default'];
		}, function (_4) {
			usersStates = _4.usersStates;
		}, function (_d) {}, function (_e) {
			UsersService = _e['default'];
		}],
		execute: function () {
			usersModule = angular.module('users', ['ui.router'])

			//.component('usersMasterParent',usersMasterParentComponent)
			.component('usersBase', usersBaseComponent).component('usersUserInfoEdit', usersUserInfoEditComponent).service('Users', UsersService)
			// .controller('userModalCtrl', require('./userModalCtrl.js'))
			// .controller('userInfoEditCtrl', require('userInfoEditCtrl'))
			// .controller('userConfirmPasswordCtrl', require('userConfirmPasswordCtrl'))

			.config(function ($stateRegistryProvider) {
				usersStates.forEach(function (state) {
					$stateRegistryProvider.register(state);
				});
			});

			_export('default', usersModule);
		}
	};
});

$__System.register('195', [], function (_export) {
	'use strict';

	function Zones($http, $q, Zone, _) {

		var defaultTransforms = $http.defaults.transformResponse;

		function responseTransform(response) {
			var zones = [];

			if (response) {
				if (response.zones) {
					//no longer need this, now the hidden flag will be used to lock zones
					//zones = _.reject(response['zones'], 'hidden');
					zones = _.map(response['zones']);
				}
			}

			return zones;
		}

		this.getForSite = function (currentSiteId) {
			return $http({
				//return $http.get({
				cache: false, //Explicitly block Zone state caching here (will override any global cache settings in .run)
				url: 'site/' + currentSiteId + '/zones/',
				transformResponse: defaultTransforms.concat([responseTransform])
			}).then(function (result) {
				// $http returns result.data, but WW service its result.zones...
				//
				//
				return result.data.zones ? result.data.zones : result.data;
			});
		};

		this.calibration = function (zoneId) {
			return $http({
				url: 'zone/' + zoneId + '/calibrate/'
			}).success(function (result) {
				return true;
			}).error(function (result) {
				return false;
			});
		};

		this.clearCalibration = function (zoneId) {
			return $http({
				url: 'zone/' + zoneId + '/clear_calibration/',
				method: 'POST'
			});
		};

		this.dependencies = function (zoneId) {
			return $http({
				url: 'zone/' + zoneId + '/dependencies/'
			}).then(function (response) {
				return response.data;
			});
		};

		this.update = function update(zone) {
			/* Accepts proto zone and calls .update - for use with undo service */
			return zone.update();
		};

		this.zoneStateChanges = function (zoneId, start, end) {
			return $http({
				method: 'POST',
				url: 'zone/' + zoneId + '/zone_state_change_details/',
				data: {
					start_seconds: start,
					end_seconds: end
				}
			});
		};

		this.fixtureHealthDetection = function (zoneId, idString, value) {
			return $http({
				method: 'PUT',
				url: 'zone/' + zoneId + '/',
				data: {
					id_string: idString,
					fixture_health_detection: value
				}
			});
		};

		this.updateGroup = function (zones, key, value, devices) {
			var updateZoneGroup = [];

			_.each(zones, function (zone) {
				if (zone.constructor.name !== 'Zone') {
					zone = new Zone(zone, devices);
				}

				zone[key] = value;
				updateZoneGroup.push(zone.update());
			});

			return $q.all(updateZoneGroup);
		};

		this.clearFaultNotification = function (zoneId) {
			return $http({
				method: 'POST',
				url: 'zone/' + zoneId + '/clear_fixture_fault/'
			});
		};
	}

	return {
		setters: [],
		execute: function () {
			Zones.$inject = ['$http', '$q', 'Zone', '_'];
			_export('default', Zones);
		}
	};
});

$__System.register('196', [], function (_export) {
    'use strict';

    function ZoneFactory($rootScope, $http, $q, Track, LcCache, LcFn) {

        /*
         **	Class
         */

        function Zone(zoneProps, devices) {

            for (var prop in zoneProps) {
                this[prop] = zoneProps[prop];
            }

            this.ajaxPending = false;
            this.ajaxError = false;
            this.ajaxResult = '';
            this.indicating = false;

            //Cover for 1 / 0 vs true false from backend
            if (this.zone_state === 1) {
                this.zone_state = true;
            } else if (this.zone_state === 0) {
                this.zone_state = false;
            }

            var zone = this;

            //CCT Default cover
            this.min_cct = this.min_cct || LcFn.defaultCct.min;
            this.max_cct = this.max_cct || LcFn.defaultCct.max;

            //LC-1128 -- Zone tied to Device here - might not be best place for it
            var zoneDevice = _.filter(devices, function (device) {
                return device.id === zone.node;
            })[0];

            if (zoneDevice) {
                var settings = zoneDevice.settings || angular.fromJson(zoneDevice.device_specific_json); //Dealing with pre=formed devices so use device_specific here instead of settings

                if (zoneDevice.isActuator) {
                    this.power_reporting = settings.power_report === '0' || !settings.power_report ? false : true;
                }

                /*
                    HIDDEN ZONES
                     Hide zones for devices in the wrong mode - note DM is also doing this on the BE for some situations...
                     Any controller-like device without the mode explicitly set to controller will also be hidden here
                    
                    This flag is pertinant for:
                         - Energy Overview 'Current Demand'
                        - Control Overview (& 'Current Demand')
                        - others 
                 */

                var hiddenZoneModes = ['advance_trigger', 'advance_trigger_no_actuator', 'repeater', 'trigger'];

                if (hiddenZoneModes.indexOf(settings.device_mode) > -1) {
                    this.hidden = true;
                }

                if (zoneDevice.isSensor && settings.device_mode === 'occupancy') {
                    this.controlledBySensor = true;
                }

                this.deviceClassName = zoneDevice.device_type.model.toLowerCase().replace(/ /g, '-'); //@todo clean this up
                this.deviceMacAddress = zoneDevice.mac_addr;
                this.gatewayId = zoneDevice.gateway;

                // Set RGB support based on device capability
                this.is_rgb = zoneDevice.isRGB === true ? true : false;
            }
        }

        /*
         **	Methods
         */

        Zone.prototype.toggle = toggle;
        Zone.prototype.dim = dim;
        Zone.prototype.updateColorTemp = updateColorTemp;
        Zone.prototype.updateRGB = updateRGB;
        Zone.prototype.update = update;
        Zone.prototype.del = del;

        function parseResponse(result) {
            if (result && result.data && result.data.command_responses && result.data.command_responses.response.status_code === 200) {
                return false;
            } else {
                return true;
            }
        }

        function toggle() {

            $rootScope.$broadcast('event:startEnergyAnimation');

            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            return $http({
                method: 'POST',
                url: !self.is_blue ? 'zone/' + self.id + '/command/' : 'blue/' + self.blue_endpoint_id + '/toggle_device/',
                data: {
                    'lightsOn': self.zone_state,
                    'zone_id': self.id
                    //'dimLevel' : self.reported_dim_level - Per DM, not required any more
                }
            }).then(function (result) {
                LcCache.updateSessionSiteSectionChild('zones', [self]);

                Track.event('Zone: Toggle', 'Zone ' + self.id_string + ' turned ' + self.zone_state);

                $rootScope.$broadcast('event:updateEnergy');

                self.ajaxError = parseResponse(result);

                if (!self.ajaxError) {
                    self.zone_state = !self.zone_state;
                }

                self.ajaxPending = false;
                self.ajaxResult = result;
            })['catch'](function (result) {
                $rootScope.$broadcast('event:updateEnergy');
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        function dim(reported_dim_level) {

            $rootScope.$broadcast('event:startEnergyAnimation');

            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            return $http({
                method: 'POST',
                url: !self.is_blue ? 'zone/' + self.id + '/command/' : 'blue/' + self.blue_endpoint_id + '/set_brightness/',
                data: {
                    'lightsOn': true,
                    'dimLevel': reported_dim_level,
                    'zone_id': self.id
                }
            }).then(function (result) {
                LcCache.updateSessionSiteSectionChild('zones', [self]);

                Track.event('Zone: Dim', 'Zone ' + self.id_string + ' dimmed to ' + reported_dim_level);

                $rootScope.$broadcast('event:updateEnergy');

                self.ajaxError = parseResponse(result);

                if (!self.ajaxError) {
                    self.reported_dim_level = reported_dim_level;
                }

                self.ajaxPending = false;
                self.ajaxResult = result;
            })['catch'](function (result) {
                $rootScope.$broadcast('event:updateEnergy');
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        function updateColorTemp() {

            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            return $http({
                method: 'POST',
                url: !self.is_blue ? 'zone/' + self.id + '/command/' : 'blue/' + self.blue_endpoint_id + '/set_color_temperature/',
                data: {
                    //
                    // Per J,L,B - only set cct
                    //
                    //'lightsOn' : self.zone_state,
                    //'dimLevel' : self.reported_dim_level,            
                    'cct': self.reported_cct,
                    'zone_id': self.id
                }
            }).then(function (result) {
                LcCache.updateSessionSiteSectionChild('zones', [self]);

                Track.event('Zone: Color Temp', 'Zone ' + self.id_string + ' color temp changed to  ' + self.cct);

                self.ajaxError = parseResponse(result);

                self.ajaxPending = false;
                self.ajaxResult = result;
            })['catch'](function (result) {
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        function updateRGB() {

            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            //
            // Per API guidance:
            //  - use the same base URL, but call set_color
            //  - payload requires zone_id and a color key
            //  - color can be hex, an RGB list, or an RGB dictionary
            //  - here we send a dictionary with r/g/b components
            //

            if (self.rgb_red === undefined || self.rgb_green === undefined || self.rgb_blue === undefined) {
                self.ajaxPending = false;
                return $q.resolve();
            }

            var colorPayload = {
                r: self.rgb_red,
                g: self.rgb_green,
                b: self.rgb_blue
            };

            var requestData = {
                zone_id: self.id,
                color: colorPayload
            };

            return $http({
                method: 'POST',
                url: !self.is_blue ? 'zone/' + self.id + '/set_color/' : 'blue/' + self.blue_endpoint_id + '/set_color/',
                data: requestData
            }).then(function (result) {
                LcCache.updateSessionSiteSectionChild('zones', [self]);

                var eventData = 'color set to (' + colorPayload.r + ',' + colorPayload.g + ',' + colorPayload.b + ')';

                Track.event('Zone: RGB', 'Zone ' + self.id_string + ' ' + eventData);

                //No fake command response for RGB
                self.ajaxError = result.status !== 200;

                self.ajaxPending = false;
                self.ajaxResult = result;
            })['catch'](function (result) {
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        function update() {
            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            return $http({
                method: 'PUT',
                url: 'zone/' + self.id + '/',
                data: {
                    'area': self.area,
                    'baseline_wattage': self.baseline_wattage,
                    'controller_health_flagged': self.controller_health_flagged,
                    'date_last_fixture_config': self.date_last_fixture_config,
                    'description': self.description,
                    'fault_recipients_alerted': self.fault_recipients_alerted,
                    'fixture_health_detection': self.fixture_health_detection,
                    'emergency_mode': self.emergency_mode,
                    'groups': self.groups,
                    'id_string': self.id_string,
                    'is_dimmable': self.is_dimmable,
                    'is_tunable': self.is_tunable,
                    'manual_override_length': self.manual_override_length,
                    'manual_override_restore_state': self.manual_override_restore_state,
                    'min_cct': self.min_cct,
                    'max_cct': self.max_cct,
                    // - 'Think we're gonna hold off on that for now' - Jeremy
                    // 'min_cct_trim'                  : self.min_cct_trim,
                    // 'max_cct_trim'                  : self.max_cct_trim,
                    'panel': self.panel,
                    'trim_high': self.trim_high,
                    'trim_low': self.trim_low,
                    'user_group': self.user_group,
                    'visible_in_control': self.visible_in_control,
                    'watts': self.watts === '' ? 0 : self.watts }
            }). //For Jason
            then(function (result) {
                LcCache.updateSessionSiteSectionChild('zones', [self], false, true);

                self.ajaxPending = false;
                self.ajaxError = parseResponse(result);
                self.ajaxResult = result;
            })['catch'](function (result) {
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        function del() {
            var self = this;

            self.ajaxPending = true;
            self.ajaxError = false;

            return $http({
                method: 'PUT',
                url: 'zone/' + self.id + '/',
                data: {
                    'area': null,
                    'id_string': self.id_string,
                    'description': self.description
                }
            }).then(function (result) {
                LcCache.removeSessionSiteSectionChild('zones', [self]);

                self.ajaxPending = false;
                self.ajaxError = parseResponse(result);
                self.ajaxResult = result;
            })['catch'](function (result) {
                self.ajaxPending = false;
                self.ajaxError = true;
                self.ajaxResult = result;
            });
        }

        return Zone;
    }

    return {
        setters: [],
        execute: function () {
            ZoneFactory.$inject = ['$rootScope', '$http', '$q', 'Track', 'LcCache', 'LcFn'];
            _export('default', ZoneFactory);
        }
    };
});

$__System.register("197", ["12", "13"], function (_export) {
  var _createClass, _classCallCheck, angularize, pixelize, hide, show, offset, halfWidth, offsetLeft, width, gap, contain, roundStep, events, ZoneSliderDirective;

  return {
    setters: [function (_2) {
      _createClass = _2["default"];
    }, function (_3) {
      _classCallCheck = _3["default"];
    }],
    execute: function () {
      'use strict';

      angularize = function angularize(element) {
        return angular.element(element);
      };

      pixelize = function pixelize(position) {
        return "" + position + "px";
      };

      hide = function hide(element) {
        return element.css({
          opacity: 0
        });
      };

      show = function show(element) {
        return element.css({
          opacity: 1
        });
      };

      offset = function offset(element, position) {
        return element.css({
          left: position
        });
      };

      halfWidth = function halfWidth(element) {
        return element[0].offsetWidth / 2;
      };

      offsetLeft = function offsetLeft(element) {
        return element[0].offsetLeft;
      };

      width = function width(element) {
        return element[0].offsetWidth;
      };

      gap = function gap(element1, element2) {
        return offsetLeft(element2) - offsetLeft(element1) - width(element1);
      };

      contain = function contain(value) {
        if (isNaN(value)) {
          return value;
        }
        return Math.min(Math.max(0, value), 100);
      };

      roundStep = function roundStep(value, precision, step, floor) {
        var decimals, remainder, roundedValue, steppedValue;
        if (floor == null) {
          floor = 0;
        }
        if (step == null) {
          step = 1 / Math.pow(10, precision);
        }
        remainder = (value - floor) % step;
        steppedValue = remainder > step / 2 ? value + step - remainder : value - remainder;
        decimals = Math.pow(10, precision);
        roundedValue = steppedValue * decimals / decimals;
        return parseFloat(roundedValue.toFixed(precision));
      };

      events = {
        mouse: {
          start: 'mousedown',
          move: 'mousemove',
          end: 'mouseup'
        },
        touch: {
          start: 'touchstart',
          move: 'touchmove',
          end: 'touchend'
        }
      };

      ZoneSliderDirective = (function () {
        function ZoneSliderDirective() {
          _classCallCheck(this, ZoneSliderDirective);

          this.restrict = 'E';
          this.scope = {
            enabled: '=',
            update: '=',
            editMode: '=',
            floor: '@',
            ceiling: '@',
            values: '=?',
            step: '@',
            highlight: '@',
            precision: '@',
            buffer: '@',
            dragstop: '@',
            ngModel: '=?',
            ngModelLow: '=?',
            ngModelHigh: '=?',
            dim: '=',
            level: '=',
            auxFunction: '&?'
          };
          this.template = "\n      <div class=\"bar\" style=\"width:{{ceiling > 100 ? 100 : ceiling}}%;\">\n        <div class=\"selection\"></div>\n      </div>\n                     \n      <div class=\"handle low\"></div>\n      <div class=\"handle high\"></div>\n\n      <div class=\"bubble limit low\">{{floor}}</div>\n      <div class=\"bubble limit high\">{{ceiling}}</div>\n\n      <div class=\"pop-up\">\n        <span class=\"zone-max\">Max</span>\n        <span class=\"value\">{{local.ngModel || 0 }}</span>\n      </div>\n\n      <div class=\"handle high\"></div>\n      <div class=\"bubble value high\">{{local.ngModelHigh}}</div>\n      \n      <div class=\"bar-fill\" style=\"width:{{ceiling > 100 ? ((local.ngModel / ceiling) * 100) : (local.ngModel || 0 )}}%;\"></div>\n    ";
        }

        _createClass(ZoneSliderDirective, [{
          key: "controller",
          value: function controller($scope, $timeout) {
            //Hoist injected services to $scope for use in linking function
            $scope.dependencies = {
              $timeout: $timeout
            };
          }
        }, {
          key: "compile",
          value: function compile(scope, element, attributes) {
            var high, low, range, watchables;
            range = attributes.ngModel == null && attributes.ngModelLow != null && attributes.ngModelHigh != null;
            low = range ? 'ngModelLow' : 'ngModel';
            high = 'ngModelHigh';

            watchables = ['floor', 'ceiling', 'values', low];
            if (range) {
              watchables.push(high);
            }

            return {
              post: function post(scope, element, attributes) {

                //Alternative to animateBars - bit slow
                // var parentWidth = $(element).parent().width();
                // scope.$parent.$watch(
                //     function (scopeDigest) {
                //       if($(element).parent().width() !== parentWidth){
                //         updateDOM();
                //       }
                //    },
                //    function () {}, //listener
                //    true //deep watch
                // );

                var bar, barWidth, bound, ceilBub, dimensions, e, flrBub, handleHalfWidth, highBub, lowBub, maxOffset, maxPtr, maxValue, minOffset, minPtr, minValue, ngDocument, offsetRange, selection, updateDOM, upper, valueRange, w, _i, _j, _len, _len1, _ref, _ref1, enabled;

                _ref = (function () {
                  var _i, _len, _ref, _results;
                  _ref = element.children();
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    e = _ref[_i];
                    _results.push(angularize(e));
                  }
                  return _results;
                })(), bar = _ref[0], minPtr = _ref[1], maxPtr = _ref[2], flrBub = _ref[3], ceilBub = _ref[4], lowBub = _ref[5], highBub = _ref[6];
                selection = angularize(bar.children()[0]);
                if (!range) {
                  _ref1 = [maxPtr, highBub];
                  for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                    upper = _ref1[_i];
                    upper.remove();
                  }
                  if (!attributes.highlight) {
                    selection.remove();
                  }
                }

                scope.local = {};
                scope.local[low] = scope[low];
                scope.local[high] = scope[high];
                bound = false;
                ngDocument = angularize(document);
                handleHalfWidth = barWidth = minOffset = maxOffset = minValue = maxValue = valueRange = offsetRange = void 0;
                dimensions = function () {
                  var value, _j, _len1, _ref2;
                  if (scope.step == null) {
                    scope.step = 1;
                  }
                  if (scope.floor == null) {
                    scope.floor = 0;
                  }
                  if (scope.precision == null) {
                    scope.precision = 0;
                  }
                  if (!range) {
                    scope.ngModelLow = scope.ngModel;
                  }
                  if ((_ref2 = scope.values) != null ? _ref2.length : void 0) {
                    if (scope.ceiling == null) {
                      scope.ceiling = scope.values.length - 1;
                    }
                  }
                  scope.local[low] = scope[low];
                  scope.local[high] = scope[high];
                  for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
                    value = watchables[_j];
                    if (typeof value === 'number') {
                      scope[value] = roundStep(parseFloat(scope[value]), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                    }
                  }
                  handleHalfWidth = halfWidth(minPtr);
                  barWidth = width(bar);
                  minOffset = 0;
                  maxOffset = barWidth - width(minPtr);
                  minValue = parseFloat(scope.floor);
                  maxValue = parseFloat(scope.ceiling);
                  valueRange = maxValue - minValue;
                  return offsetRange = maxOffset - minOffset;
                };
                updateDOM = function () {
                  var bind, percentOffset, percentValue, pixelsToOffset, setBindings, setPointers;
                  dimensions();
                  percentOffset = function (offset) {
                    return contain((offset - minOffset) / offsetRange * 100);
                  };
                  percentValue = function (value) {
                    return contain((value - minValue) / valueRange * 100);
                  };
                  pixelsToOffset = function (percent) {
                    return pixelize(percent * offsetRange / 100);
                  };
                  setPointers = function () {
                    var newHighValue, newLowValue;
                    offset(ceilBub, pixelize(barWidth - width(ceilBub)));
                    newLowValue = percentValue(scope.local[low]);
                    offset(minPtr, pixelsToOffset(newLowValue));
                    offset(lowBub, pixelize(offsetLeft(minPtr) - halfWidth(lowBub) + handleHalfWidth));
                    offset(selection, pixelize(offsetLeft(minPtr) + handleHalfWidth));
                    switch (true) {
                      case range:
                        newHighValue = percentValue(scope.local[high]);
                        offset(maxPtr, pixelsToOffset(newHighValue));
                        offset(highBub, pixelize(offsetLeft(maxPtr) - halfWidth(highBub) + handleHalfWidth));
                        return selection.css({
                          width: pixelsToOffset(newHighValue - newLowValue)
                        });
                      case attributes.highlight === 'right':
                        return selection.css({
                          width: pixelsToOffset(110 - newLowValue)
                        });
                      case attributes.highlight === 'left':
                        selection.css({
                          width: pixelsToOffset(newLowValue) + 100
                        });
                        return offset(selection, 0);
                    }
                  };
                  bind = function (handle, bubble, ref, events) {
                    // comment it out, too annoying
                    // console.log('Possibly expensive bindings set for slider')
                    //console.log('Setting setBindings',handle, bubble, ref, events)
                    var currentRef, onEnd, onMove, onStart;
                    currentRef = ref;
                    onEnd = function () {
                      bubble.removeClass('active');
                      handle.removeClass('active');
                      ngDocument.off(events.move);
                      ngDocument.off(events.end);
                      if (scope.dragstop) {
                        scope[high] = scope.local[high];
                        scope[low] = scope.local[low];
                      }
                      //scope.level = 100;

                      if (scope.$parent.oZC && scope.$parent.oZC.zone && scope.update) {
                        var dimThrottled = _.throttle(scope.$parent.oZC.zone.dim, 1000);
                        dimThrottled.call(scope.$parent.oZC.zone, scope.level);
                        scope.$parent.oZC.zone.zone_state = scope.level > 0 ? 'on' : null;
                      }

                      if (scope.auxFunction) {
                        scope.auxFunction();
                      }

                      scope.$apply();

                      currentRef = ref;
                      return scope.$apply();
                    };
                    onMove = function (event) {
                      var eventX, newOffset, newPercent, newValue, _ref2, _ref3, _ref4, _ref5;
                      eventX = event.clientX || ((_ref2 = event.touches) != null ? (_ref3 = _ref2[0]) != null ? _ref3.clientX : void 0 : void 0) || ((_ref4 = event.originalEvent) != null ? (_ref5 = _ref4.changedTouches) != null ? _ref5[0].clientX : void 0 : void 0) || 0;
                      newOffset = eventX - element[0].getBoundingClientRect().left - handleHalfWidth;
                      newOffset = Math.max(Math.min(newOffset, maxOffset), minOffset);
                      newPercent = percentOffset(newOffset);
                      newValue = minValue + valueRange * newPercent / 100.0;
                      if (range) {
                        switch (currentRef) {
                          case low:
                            if (newValue > scope.local[high]) {
                              currentRef = high;
                              minPtr.removeClass('active');
                              lowBub.removeClass('active');
                              maxPtr.addClass('active');
                              highBub.addClass('active');
                              setPointers();
                            } else if (scope.buffer > 0) {
                              newValue = Math.min(newValue, scope.local[high] - scope.buffer);
                            }
                            break;
                          case high:
                            if (newValue < scope.local[low]) {
                              currentRef = low;
                              maxPtr.removeClass('active');
                              highBub.removeClass('active');
                              minPtr.addClass('active');
                              lowBub.addClass('active');
                              setPointers();
                            } else if (scope.buffer > 0) {
                              newValue = Math.max(newValue, parseInt(scope.local[low]) + parseInt(scope.buffer));
                            }
                        }
                      }
                      newValue = roundStep(newValue, parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                      scope.local[currentRef] = newValue;
                      if (!scope.dragstop) {
                        scope[currentRef] = newValue;
                      }
                      setPointers();
                      return scope.$apply();
                    };
                    onStart = function (event) {
                      if (scope.enabled) {
                        dimensions();
                        bubble.addClass('active');
                        handle.addClass('active');
                        setPointers();
                        event.stopPropagation();
                        //event.preventDefault();
                        ngDocument.on(events.move, onMove);
                        return ngDocument.on(events.end, onEnd);
                      } else {
                        return null;
                      }
                    };
                    //
                    // Marking event handler as 'passive' to make the page more responsive.
                    // See https://www.chromestatus.com/feature/5745543795965952
                    //
                    // return handle.on(events.start, onStart);
                    //
                    return handle[0].addEventListener(events.start, onStart, { passive: true });
                  };
                  setBindings = function () {
                    var method, _j, _len1, _ref2;
                    _ref2 = ['touch', 'mouse'];
                    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                      method = _ref2[_j];
                      bind(minPtr, lowBub, low, events[method]);
                      bind(maxPtr, highBub, high, events[method]);
                    }
                    return bound = true;
                  };
                  if (!bound) {
                    setBindings();
                  }
                  return setPointers();
                };
                scope.dependencies.$timeout(updateDOM, 500);
                for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
                  w = watchables[_j];
                  scope.$watch(w, updateDOM, true);
                }
                scope.$on('animateBars', updateDOM);
                return window.addEventListener('resize', updateDOM);
              }
            };
          }
        }]);

        return ZoneSliderDirective;
      })();

      _export("default", ZoneSliderDirective);
    }
  };
});

$__System.register('198', ['3', '195', '196', '197'], function (_export) {
    'use strict';

    var angular, zonesService, zoneFactory, ZoneSliderDirective, zonesModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            zonesService = _2['default'];
        }, function (_3) {
            zoneFactory = _3['default'];
        }, function (_4) {
            ZoneSliderDirective = _4['default'];
        }],
        execute: function () {
            zonesModule = angular.module('zones', []).service('Zones', zonesService).factory('Zone', zoneFactory).directive('slider', function () {
                return new ZoneSliderDirective();
            });

            _export('default', zonesModule);
        }
    };
});

$__System.register('199', ['3', '5', '7', '9', '15', '19', '28', '34', '67', '74', '79', '91', '107', '142', '194', '198', '2c', '3c', '3f', '5b', '9e', 'a6', 'a8', 'b0', 'bb', 'bf', '13d', '13f'], function (_export) {
	'use strict';

	//- REMOVE
	var angular, Ajax, Areas, Automations, Common, Devices, Energy, Home, Notifications, Overview, Regtest, Schedules, Sockets, Undo, Users, Zones, Error, Login, ModalsLegacy, ModalsNew, Scenes, Shows, Search, Session, Settings, Sites, Structure, Track, baseModule;
	return {
		setters: [function (_) {
			angular = _['default'];
		}, function (_2) {
			Ajax = _2['default'];
		}, function (_3) {
			Areas = _3['default'];
		}, function (_4) {
			Automations = _4['default'];
		}, function (_5) {
			Common = _5['default'];
		}, function (_6) {
			Devices = _6['default'];
		}, function (_7) {
			Energy = _7['default'];
		}, function (_8) {
			Home = _8['default'];
		}, function (_9) {
			Notifications = _9['default'];
		}, function (_10) {
			Overview = _10['default'];
		}, function (_11) {
			Regtest = _11['default'];
		}, function (_12) {
			Schedules = _12['default'];
		}, function (_13) {
			Sockets = _13['default'];
		}, function (_14) {
			Undo = _14['default'];
		}, function (_15) {
			Users = _15['default'];
		}, function (_16) {
			Zones = _16['default'];
		}, function (_c) {
			Error = _c['default'];
		}, function (_c2) {
			Login = _c2['default'];
		}, function (_f) {
			ModalsLegacy = _f['default'];
		}, function (_b) {
			ModalsNew = _b['default'];
		}, function (_e) {
			Scenes = _e['default'];
		}, function (_a6) {
			Shows = _a6['default'];
		}, function (_a8) {
			Search = _a8['default'];
		}, function (_b0) {
			Session = _b0['default'];
		}, function (_bb) {
			Settings = _bb['default'];
		}, function (_bf) {
			Sites = _bf['default'];
		}, function (_d) {
			Structure = _d['default'];
		}, function (_f2) {
			Track = _f2['default'];
		}],
		execute: function () {
			baseModule = angular.module('app.base', [Ajax.name, Areas.name, Automations.name, Common.name, Devices.name, Energy.name, Error.name, Home.name, Login.name, ModalsLegacy.name, ModalsNew.name, Notifications.name, Overview.name, Regtest.name, Scenes.name, Shows.name, Schedules.name, Search.name, Session.name, Settings.name, Sites.name, Sockets.name, Structure.name, Track.name, Undo.name, Users.name, Zones.name]);

			_export('default', baseModule);
		}
	};
});

$__System.register('19a', [], function (_export) {
    'use strict';

    var devicesSectionInfoComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionInfoComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="devices.info">Info</span>\n        </h2>\n        <div class="main-button device-info {{dSIC.allUnhealthy(dSIC.devices) ? \'unhealthy\' : \'healthy\'}}">\n            <div class="main-button-device {{device.node_health ? \'healthy\' : \'unhealthy\'}}" ng-repeat="device in dSIC.devices">\n                <div class="device-info-middle-button-holder">\n                    <button class="btn green right" ng-if="!device.deviceZones || (device.deviceZones && device.deviceZones.length === 0)" ng-click="dSIC.indicate(device)" ng-disabled="device.ajaxPending" translate="common.indicate">Indicate</button>\n                </div>\n\n                <div class="device-icon lc-{{device.className}}"></div>\n                \n                <h2 class="mac device-mac-description">{{device.mac_addr | cleanMac }}</h2>\n                \n                <h3 class="grey">\n                    <span ng-if="device.settings.device_mode">{{device.settings.device_mode | translate}}</span>\n                    <span class="firmware-version">v:{{device.last_firmware_version}}</span>\n                    <span ng-if="dSIC.isSuperUser"> - ID:{{::device.id}} GW: {{::device.gateway}}</span>\n                </h3>\n            </div>\n        </div>\n    ',
                bindings: {
                    devices: '<',
                    isSuperUser: '<'
                },
                controllerAs: 'dSIC',
                controller: function controller(_, $timeout, $q) {

                    var dSIC = this;

                    dSIC.$onInit = function () {};

                    dSIC.allUnhealthy = function (group) {
                        return _.every(group, { 'node_health': 0 });
                    };

                    dSIC.indicate = function (device) {
                        device.indicate();
                    };
                }
            };

            _export('default', devicesSectionInfoComponent);
        }
    };
});

$__System.register('19b', [], function (_export) {
    'use strict';

    var devicesSectionProductInfoComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionProductInfoComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="">Product Info</span>\n        </h2>\n        <div class="main-button product-info" >\n            <ul>\n                <!--<li><h3>Family</h3><span>RAILP</span></li>-->\n                <li><h3>Name</h3><span>{{::dSPIC.catalogInfo.product_name}}</span></li>\n                <li><h3>Wattage</h3><span>{{::dSPIC.catalogInfo.product_watts}}W</span></li>\n                <!--<li><h3>Color Temp</h3><span>4000K Neutral</span></li>-->\n                <!--<li><h3>Driver</h3><span>120-277V, 0-10V Dim/D10</span></li>-->\n                <li><h3>Datasheet</h3><span><a href="{{::dSPIC.catalogInfo.info_url}}" target="_blank">Link to datasheet</a></span></li>\n            </ul>\n        </div>\n    ',
                bindings: {
                    catalogInfo: '<'
                },
                controllerAs: 'dSPIC',
                controller: function controller() {

                    var dSPIC = this;

                    dSPIC.$onInit = function () {};
                }
            };

            _export('default', devicesSectionProductInfoComponent);
        }
    };
});

$__System.register('19c', [], function (_export) {
    'use strict';

    var devicesSectionProductImageComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionProductImageComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="">Product Image</span>\n        </h2>\n        <div class="main-button product-image">\n            <img ng-src="{{::dSPImC.imageUrl}}" />\n        </div>\n    ',
                bindings: {
                    imageUrl: '<'
                },
                controllerAs: 'dSPImC',
                controller: function controller() {

                    var dSPImC = this;

                    dSPImC.$onInit = function () {};
                }
            };

            _export('default', devicesSectionProductImageComponent);
        }
    };
});

$__System.register('19d', [], function (_export) {
    'use strict';

    var devicesSectionActivityComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionActivityComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dSAC.drop}" ng-click="dSAC.toggleDrop();">\n            <span translate="">Activity Log</span>\n        </h2>\n\n        <section class="devices-section-inner full main-body" ng-if="dSAC.drop;">\n            <div class="device-acitvity-log">\n\n                <notifications-log-list heading="" pending="" messages="dSAC.recentActivity" filter-text="" filter-category="" limit-reached="dSAC.limitReached"></notifications-log-list>\n\n                <div class="pager">\n                    <button class="loadMore" ng-disabled="dSAC.startCount === 100" ng-click="dSAC.loadLess();" translate="devices.previousSet">Previous Set</button>\n                    <button class="loadMore right" ng-disabled="dSAC.limitReached" ng-click="dSAC.loadMore();">\n                        <span ng-if="dSAC.limitReached" translate="common.endOfLog">End of Log</span>\n                        <span ng-if="!dSAC.limitReached" translate="common.next">Next</span>\n                    </button>\n                </div>\n            </div>\n        </section>\n    ',
                bindings: {
                    filterItems: '<',
                    logTypes: '<',
                    siteId: '<',
                    timeZoneOffset: '@',
                    onLatestStatus: '&'
                },
                controllerAs: 'dSAC',
                controller: function controller($rootScope, Messages, Modals, moment, _) {

                    var dSAC = this;

                    var pageBreak = 1,
                        defaultCount = 100;

                    var getEntries = function getEntries(siteId, count, offset) {
                        var filterIdSets = [_.map(dSAC.filterItems, function (item) {
                            return item.id;
                        })];

                        return Messages.getFilteredObjectNotifications(siteId, count, offset, dSAC.logTypes, filterIdSets).then(function (notifications) {
                            dSAC.limitReached = count !== notifications.length;

                            dSAC.recentActivity = _.union(dSAC.recentActivity, notifications);

                            dSAC.onLatestStatus(dSAC.recentActivity[0]);
                        });
                    };

                    dSAC.startOffset = 0;
                    dSAC.startCount = defaultCount;
                    dSAC.limitReached = false;

                    //
                    // Watch for socket messages to update log without polling the system_notification endpoint
                    //
                    dSAC.$onInit = function () {
                        dSAC.socketListener = $rootScope.$on('notifications:new-message', pushDeviceMessage);
                    };

                    dSAC.$onDestroy = function () {
                        dSAC.socketListener();
                    };

                    dSAC.toggleDrop = function () {
                        dSAC.drop = !dSAC.drop;

                        if (dSAC.drop) {
                            getEntries(dSAC.siteId, dSAC.startCount, dSAC.startOffset);
                        }
                    };

                    dSAC.loadMore = function () {
                        dSAC.startOffset = dSAC.startCount * pageBreak;
                        pageBreak = pageBreak + 1;
                        dSAC.startCount = dSAC.startCount * pageBreak;
                        getEntries(dSAC.siteId, dSAC.startCount, dSAC.startOffset);
                    };

                    dSAC.loadLess = function () {
                        dSAC.startCount = dSAC.startCount / pageBreak;
                        pageBreak = pageBreak - 1;
                        dSAC.startOffset = dSAC.startCount / pageBreak;
                        getEntries(dSAC.siteId, dSAC.startCount, dSAC.startOffset);
                    };

                    function pushDeviceMessage(message) {
                        dSAC.recentActivity = _.union(dSAC.recentActivity, [message]);
                    }
                }
            };

            _export('default', devicesSectionActivityComponent);
        }
    };
});

$__System.register('19e', [], function (_export) {
    'use strict';

    var devicesSectionUpdateStatusComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionUpdateStatusComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dSUS.drop}" ng-click="dSUS.drop = !dSUS.drop;">\n            <span translate="">Device Update Status</span>\n        </h2>\n\n        <section class="" ng-if="dSUS.drop;">\n            <devices-update-status-bar-list class="main-body" devices="dSUS.devices" update-status="dSUS.updateStatus"></devices-update-status-bar-list>\n        </section>\n    ',
                bindings: {
                    devices: '<',
                    updateStatus: '<'
                },
                controllerAs: 'dSUS',
                controller: function controller($scope) {

                    var dSUS = this;

                    $scope.$on('event:socket:deviceStatus', function (event, updateInfo) {

                        // Update here ?

                    });

                    dSUS.$onInit = function () {

                        console.log(dSUS.updateStatus);
                    };

                    dSUS.$onChanges = function (changes) {
                        console.log(changes);
                    };
                }
            };

            _export('default', devicesSectionUpdateStatusComponent);
        }
    };
});

$__System.register('19f', [], function (_export) {
    'use strict';

    var devicesSectionUpdateVersionComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionUpdateVersionComponent = {
                template: '\n        <h2 class="overview-heading">\n            <span translate="">Version Information</span>\n        </h2>\n        <section class="main-button"> <!-- {{dSUV.devices.length > 1 ? \'devices-section-inner main-body\':\'main-button\'}} -->\n            <devices-update-version-boxes devices="dSUV.devices"></devices-update-version-boxes>\n\n            <div class="device-info-middle-button-holder" ng-if="dSUV.isOrgAdmin">\n                <button class="btn blue check" ng-disabled="dSUV.device.ajaxPending || dSUV.device.nextFirmwareUuid === 0 || dSUV.device.nextFirmwareUuid == \'in progress\'" ng-if="!dSUV.device.nextFirmwareUuid" ng-click="dSUV.device.checkUpdate()" ng-bind="dSUV.device.nextFirmwareUuid === 0 ? \'You are up to date\' : \'Check for Firmware Update\'"></button>\n                <button class="btn blue check" ng-disabled="dSUV.device.ajaxPending || dSUV.device.ajaxError || dSUV.device.nextFirmwareUuid == \'in progress\'" ng-if="dSUV.device.nextFirmwareUuid" ng-click="dSUV.device.upgrade()" ng-bind="dSUV.device.nextFirmwareUuid == \'in progress\' ? \'Update in progress\' : \'Update Firmware\'"></button>\n                <span ng-if="dSUV.device.ajaxError">Ajax Error</span>\n                \n                <!-- If the update status isnt FAILED then display the update status -->\n                <div ng-if="dSUV.updateStatus && dSUV.updateStatus[0] !== \'FAILED\'" class="update-status">\n                    <span>Status: <span>{{dSUV.updateStatus}}</span></span>\n                </div>\n            </div>\n\n        </section>\n    ',
                bindings: {
                    device: '<',
                    devices: '<',
                    isOrgAdmin: '<',
                    updateStatus: '<'
                },
                controllerAs: 'dSUV',
                controller: function controller($scope) {

                    var dSUV = this;

                    var socketMsgWatcher = $scope.$on('event:socket:deviceStatus', updateStatus);

                    /*
                        Can't do this unitl we have a way to clear faulty / stale upgrade statuses - locking FE for some sites
                     *
                    // Call API to get firmware upgrade status when navigating to a device
                    dSUV.$onInit = function(){
                        if(dSUV.device && dSUV.device.getFirmwareUpgradeStatus){
                            dSUV.device.getFirmwareUpgradeStatus(); 
                        }
                    };
                    */

                    dSUV.$onDestroy = function () {
                        socketMsgWatcher();
                    };

                    function updateStatus(event, updateMessageObj) {
                        if (dSUV.device && updateMessageObj && updateMessageObj[dSUV.device.id] === 'UP-TO-DATE') {
                            if (dSUV.device.nextFirmwareUuid === 'in progress') {
                                dSUV.device.nextFirmwareUuid = 0;
                            }
                        }
                        dSUV.updateStatus = _.map(updateMessageObj, function (val, key) {
                            return val;
                        });
                    }
                }
            };

            _export('default', devicesSectionUpdateVersionComponent);
        }
    };
});

$__System.registerDynamic("1a0", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "\n    <section class=\"main-body no-padding\">\n    <!-- @refactor - lets turn the control-select element into a component -->\n        <div class=\"control-select\" ng-class=\"{editMode: dSC.editMode}\" ng-show=\"dSC.device.device_type.model === 'Touch' || (dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode !== 'scene') || (dSC.device.device_type.model === 'Phase Cut Dimmer' && dSC.device.settings.device_mode !== 'scene')\">\n            <h2 class=\"overview-heading cog\">\n                <a class=\"cog\" ng-click=\"dSC.editMode = !dSC.editMode\"><span>Edit</span><i class=\"cog\"></i></a>\n                <span>Control Zones</span>\n\n                <div class=\"help\" id=\"multizoneTrim\">\n                    <div class=\"arrow\"></div>\n                    <p ng-if=\"::dSC.device.device_type.model === 'Touch'\">Zones added here will appear on your Touch device.</p>\n                    <p ng-if=\"::dSC.device.device_type.model !== 'Touch'\">The Dimmer will control these Zones.</p>\n                </div>\n                \n                <i \n                    help \n                    data-help-div=\"multizoneTrim\" \n                    id=\"multizoneTrimIcon\"\n                ></i>\n            </h2>\n            \t\n            <div ng-hide=\"dSC.ajaxPending\">\n                <div class=\"white-pill-item no-icon short\" ng-show=\"dSC.selectedZones.length < 1\">\n                    <button class=\"btn black btn-white-plus large\" ng-click=\"dSC.selectObjectZones(dSC.selectedZones); dSC.editMode = true;\" ng-disabled=\"dSC.ajaxPending\"></button>\n                    <h1 class=\"name\">Add Zone</h1>\n                </div>\n\n                <div>\n                    <div class=\"white-pill-item no-icon\" ng-repeat=\"(key, zone) in dSC.selectedZones track by $index\">\n                        <button class=\"btn-select remove\" ng-click=\"dSC.removeItem($index,dSC.selectedZones)\"></button>\n                        <!-- <div class=\"device-icon\">Z</div> -->\n                        <h1 class=\"name\">{{zone.id_string}} <span class=\"smallcaps\" ng-if=\"dSC.device.deviceZones[0].id === zone.id\">Local Zone</span></h1>\n                        <span class=\"details\">{{(zone.area ? 'Area: ' + zone.areaName : '')}} </span>\n\n                        <div class=\"trim-help\" ng-hide=\"dSC.zoneTrimSame\">\n                            <span class=\"smallcaps\">Max Trim: {{zone.trim_high}}</span>\n                            <div class=\"trim-progress\">\n                                <progress value=\"{{zone.trim_high}}\" max=\"100\"></progress>\n                            </div>\n                        </div>\n\n                        <button class=\"btn btn-time-arrow up\" ng-if=\"dSC.editMode\" ng-disabled=\"$index === 0\" ng-click=\"dSC.position('up',dSC.selectedZones,zone,$index)\"></button>\n                        <button class=\"btn btn-time-arrow down\" ng-if=\"dSC.editMode\" ng-disabled=\"$index === (dSC.selectedZones.length-1)\" ng-click=\"dSC.position('down',dSC.selectedZones,zone,$index)\"></button>\n                    </div>\n                </div>\n\n                <div class=\"buttons\" ng-show=\"dSC.editMode\">\n                    <p class=\"button-area-message\" ng-if=\"dSC.selectedZones.length > 1 && dSC.groupMinTrim && !dSC.zoneTrimSame && dSC.device.device_type.model != 'Touch'\">All zones will be limited by the lowest max trim: <strong>{{dSC.groupMinTrim}}</strong>.</p>\n                    <button class=\"btn blue right m1pc\" ng-click=\"dSC.saveControl()\" ng-disabled=\"dSC.ajaxPending\" ng-hide=\"dSC.device.device_type.model==='Touch'\">Save</button>\n                    <!--for newer dimmer which can select multi-zones-->\n                    <button class=\"btn green right m1pc\" ng-click=\"dSC.selectObjectZones(dSC.selectedZones);\"\n                        ng-hide=\"dSC.device.device_type.model ==='Touch' ||  dSC.device.device_type.model === 'Dimmer' && ((dSC.selectedZones.length >= 1 && (!dSC.firmwareSupported('1.24'))) || (dSC.selectedZones.length >= 15 && (dSC.firmwareSupported('1.24'))))\"\n                        ng-disabled=\"dSC.ajaxPending\">Add Zone</button>\n                </div>\n            </div>\n            <p class=\"loading-spinner-label relative\" ng-show=\"dSC.ajaxPending\" translate=\"common.loadingEllipsis\" translate=\"common.loadingEllipsis\">Loading...</p>\n        </div>\n\n    </section>\n\n    <section class=\"main-body no-padding\">\n        <div class=\"control-select\" ng-class=\"{editMode: dSC.editMode}\" ng-show=\"dSC.device.device_type.model === 'Touch' || (dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene') || (dSC.device.device_type.model === 'Phase Cut Dimmer' && dSC.device.settings.device_mode === 'scene')\">\n            <h2 class=\"overview-heading cog\">\n                <a class=\"cog\" ng-click=\"dSC.editMode = !dSC.editMode\"><span>Edit</span><i class=\"cog\"></i></a>\n                <span>Control Scenes</span>\n            </h2>\n\n            <div ng-hide=\"dSC.ajaxPending\">\n                <div class=\"scene-holder\" ng-class=\"{'short': dSC.device.device_type.model == 'Dimmer' && dSC.device.settings.device_mode == 'scene'}\">\n                    <div class=\"scene-drop\" ng-if=\"dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene' && dSC.selectedScenes.length\">\n                        <div>Top</div>\n                        <div>Bottom</div>\n                        <div ng-if=\"dSC.selectedScenes.length && dSC.doubleEditMode\">Top Double Click</div>\n                        <div ng-if=\"dSC.selectedScenes.length && dSC.doubleEditMode\">Bottom Double Click</div>    \n                    </div>  \n                \n                    <div class=\"white-pill-item no-icon\" ng-repeat=\"(key, scene) in dSC.selectedScenes\">\n                        <button class=\"btn-select remove\" ng-click=\"dSC.removeItem($index,dSC.selectedScenes)\"></button>\n                        <!-- <div class=\"device-icon\">S</div> -->\n                        <h1 class=\"name\">{{scene.description ? scene.description : scene.name}}</h1>\n                        <span class=\"details\">ID: {{scene.id}}</span>\n\n                        <button class=\"btn btn-time-arrow up\" ng-if=\"dSC.editMode\" ng-disabled=\"$index === 0\" ng-click=\"dSC.position('up',dSC.selectedScenes,scene,$index)\"></button>\n                        <button class=\"btn btn-time-arrow down\" ng-if=\"dSC.editMode\" ng-disabled=\"$index === (dSC.selectedScenes.length-1)\" ng-click=\"dSC.position('down',dSC.selectedScenes,scene,$index)\"></button>\n                    </div>\n                </div>\n\n                <div class=\"dimmer-buttons\" ng-if=\"dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene' && dSC.selectedScenes.length\">\n                    <div><span>Top</span></div>\n                    <div><span>Bottom</span></div>\n                    <div ng-if=\"dSC.selectedScenes.length > 2 || dSC.doubleEditMode\" class=\"double-click\"><span>Top</span><p>Double</p></div>\n                    <div ng-if=\"dSC.selectedScenes.length > 2 || dSC.doubleEditMode\" class=\"double-click\"><span>Bottom</span><p>Double</p></div>\n                </div>\n\n                <div class=\"white-pill-item no-icon short\" ng-if=\"dSC.selectedScenes < 1\">\n                    <button class=\"btn black btn-white-plus large\" ng-click=\"dSC.editMode = true; dSC.selectObjectScenes(dSC.selectedScenes, 'scene', dSC.doubleEditMode);\" ng-disabled=\"dSC.ajaxPending\"></button>\n                    <h1 class=\"name\">Add Scene</h1>\n                </div>\n\n                <div class=\"buttons\" ng-show=\"dSC.editMode\">\n                    <button class=\"btn blue right m1pc\" ng-click=\"dSC.saveControl()\" ng-disabled=\"dSC.ajaxPending\">Save</button>\n                    \n                    <!-- @todo fix Toggler! -->\n\n                    <button class=\"btn blue right m1pc\" ng-if=\"dSC.editMode && (dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene')\" ng-click=\"dSC.toggleDoubleClickMode()\">{{dSC.doubleEditMode ? 'Disable Double Press' : 'Enable Double Press'}}</button>\n\n                    <button class=\"btn green right m1pc\" ng-click=\"dSC.selectObjectScenes(dSC.selectedScenes, 'scene', dSC.doubleEditMode);\" ng-hide=\"dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene' && (dSC.doubleEditMode ? dSC.selectedScenes.length === 4 : dSC.selectedScenes.length === 2)\" ng-disabled=\"dSC.ajaxPending\">Add Scene</button>\n                    <button class=\"btn green right m1pc\" ng-click=\"dSC.selectObjectZones(dSC.selectedZones);\" ng-hide=\"dSC.device.device_type.model === 'Dimmer'\" ng-disabled=\"dSC.ajaxPending\">Add Zone</button>\n                </div>\n            </div>\n            <p class=\"loading-spinner-label relative\" ng-show=\"dSC.ajaxPending\" translate=\"common.loadingEllipsis\" translate=\"common.loadingEllipsis\">Loading...</p>\n        </div>\n    </section>\n";
});
$__System.register('1a1', ['1a0'], function (_export) {
				'use strict';

				var devicesSectionControlComponentTmpl, devicesSectionControlComponent;
				return {
								setters: [function (_a0) {
												devicesSectionControlComponentTmpl = _a0['default'];
								}],
								execute: function () {
												devicesSectionControlComponent = {
																template: devicesSectionControlComponentTmpl,
																bindings: {
																				device: '<',
																				siteId: '<',
																				zones: '<',
																				areas: '<',
																				scenes: '<',
																				onControlUpdate: '&'
																},
																controllerAs: 'dSC',
																controller: function controller($scope, $q, Devices, Scenes, Modals, LcFn, _) {

																				var dSC = this;

																				var insaneDumbDimmerMappings = [1, 0, 3, 2];

																				dSC.selectedZones = [];
																				dSC.selectedScenes = [];

																				dSC.$onInit = function () {
																								getControlConfigs(dSC.siteId, dSC.zones, dSC.scenes, dSC.device);
																				};

																				dSC.firmwareSupported = function (minVersion) {
																								return !LcFn.ltVersion(dSC.device.last_firmware_version, minVersion);
																				};

																				dSC.selectObjectZones = function () {
																								//var max = dSC.device.device_type.model === 'Dimmer' ? 1 : false;
																								var max = false;

																								var deviceZoneId = dSC.device.deviceZones[0] ? dSC.device.deviceZones[0].id : null;

																								var flaggedZones = flagZones(dSC.zones, dSC.device.gateway, deviceZoneId);

																								if (dSC.device.device_type.model === 'Dimmer') {
																												if (dSC.firmwareSupported('1.24')) {
																																max = 15;
																												} else {
																																max = 1;
																												}
																								}

																								var areas = _.map(dSC.areas, function (area) {
																												area.zones = _.filter(flaggedZones, { area: area.id });
																												return area;
																								});

																								// - Add unassigned zones to their own category
																								var noAreaZones = _.filter(flaggedZones, { area: null });

																								if (noAreaZones.length) {
																												areas.push({
																																name: 'No Area',
																																zones: noAreaZones
																												});
																								}

																								var allItems = [{
																												type: 'zones',
																												areas: areas,
																												selected: dSC.selectedZones
																								}];

																								//               allItems, title, class, max
																								Modals.showMulti(allItems, 'Select Zones', 'control', max).then(function (items) {
																												dSC.selectedZones = items;
																												setGroupMinimumTrim(items);
																												dSC.zoneTrimSame = getZoneTrims(dSC.selectedZones);
																								});
																				};

																				dSC.selectObjectScenes = function (scenes, type, doubleModeFlag) {
																								var sceneGroups = _.groupBy(dSC.scenes, 'area');

																								dSC.areaScenes = _.map(dSC.areas, function (_area) {
																												var area = _.cloneDeep(_area);
																												area.scenes = sceneGroups[area.id];
																												return area;
																								});

																								dSC.areaScenes.push({
																												name: 'Site-Wide Scenes',
																												scenes: _.map(_.filter(dSC.scenes, { area: null }), function (_scene) {
																																var scene = _.cloneDeep(_scene);
																																scene.area = 999;
																																return scene;
																												})
																								});

																								//Dimmer mode only 2 scenes
																								var max = dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene' ? doubleModeFlag ? 4 : 2 : false;

																								var allItems = [{
																												type: 'scenes',
																												areas: dSC.areaScenes,
																												selected: dSC.selectedScenes
																								}];

																								//               allItems, title, class
																								Modals.showMulti(allItems, 'Scenes', 'control', max).then(function (items) {
																												dSC.selectedScenes = items;
																								});
																				};

																				dSC.position = function (direction, group, element, index) {
																								var targetIndex = direction === 'down' ? index + 1 : index - 1;

																								group.splice(targetIndex, 0, group.splice(index, 1)[0]);
																				};

																				dSC.toggleDoubleClickMode = function () {
																								dSC.doubleEditMode = !dSC.doubleEditMode;

																								if (!dSC.doubleEditMode) {
																												dSC.selectedScenes = _.take(dSC.selectedScenes, 2);
																								}
																				};

																				dSC.saveControl = function () {
																								var sceneArray = _.map(angular.copy(dSC.selectedScenes), function (value, k) {
																												return { id: value.id, position: k };
																								});

																								//Temp - wipe out config details on change of mode
																								if (dSC.device.device_type.model === 'Dimmer') {
																												if (dSC.device.settings.device_mode === 'scene') {
																																//Reverse for the derps
																																_.each(sceneArray, function (mapping, k) {
																																				mapping.position = insaneDumbDimmerMappings[k];
																																});

																																dSC.selectedZones = [];
																												} else {
																																dSC.selectedScenes = [];
																												}
																								}

																								var controlObject = {
																												name: 'Control for device ' + dSC.device.id,
																												node: dSC.device.id,
																												zones: _.map(dSC.selectedZones, function (value, k) {
																																return { id: value.id, position: k };
																												}),
																												scenes: sceneArray
																								};

																								Modals.openLoad('Saving Configuration');

																								if (dSC.controlConfig) {
																												Devices.setControlConfig(dSC.controlConfig.id, controlObject).then(function () {
																																dSC.editMode = false;
																																Modals.closeLoad('Configuration Saved', true);
																												}, function () {
																																Modals.closeLoad('Configuration Save Failure');
																												});
																								} else {
																												Devices.createControlConfig(controlObject).then(function () {
																																dSC.editMode = false;
																																Modals.closeLoad('Configuration Saved', true);
																												}, function () {
																																Modals.closeLoad('Configuration Save Failure');
																												});
																								}
																				};

																				dSC.removeItem = function (index, group) {
																								group.splice(index, 1);
																				};

																				function flagZones(zones, deviceGatewayId, deviceZoneId) {
																								return zones.map(function (zone) {
																												// - Gateway Mismatch
																												if (zone.gatewayId !== deviceGatewayId) {
																																zone.block_selection_gateway = true;
																												}

																												// - PC Dimmer Zone
																												if (zone.id === deviceZoneId) {
																																zone.is_local_zone = true;
																												}

																												return zone;
																								});
																				}

																				function getControlConfigs(siteId, allZones, allScenes, device) {
																								dSC.ajaxPending = true;

																								Devices.getControlConfigs(siteId).then(function (response) {
																												dSC.controlConfig = _.filter(response.data, { 'node': dSC.device.id })[0];
																												if (dSC.controlConfig) {
																																mapZonesAndScenes(dSC.controlConfig, allZones, allScenes, device);
																												}
																												dSC.ajaxPending = false;
																								});
																				}

																				function mapZonesAndScenes(controlConfig, allZones, allScenes, device) {
																								dSC.selectedZones = mapZones(controlConfig.zones, allZones);

																								setGroupMinimumTrim(dSC.selectedZones);

																								dSC.zoneTrimSame = getZoneTrims(dSC.selectedZones);

																								dSC.selectedScenes = reOrderScenes(mapScenes(controlConfig.scenes, allScenes), device, insaneDumbDimmerMappings);

																								//Set initial double click edit flag
																								if (device.device_type.model === 'Dimmer' && device.settings.device_mode === 'scene' && controlConfig.scenes.length > 2) {
																												dSC.doubleEditMode = true;
																								}
																				}

																				function reOrderScenes(scenes, device, mappings) {
																								var orderedScenes = [];

																								if (dSC.device.device_type.model === 'Dimmer' && dSC.device.settings.device_mode === 'scene') {

																												orderedScenes = _.filter(_.map(insaneDumbDimmerMappings, function (val, k) {
																																return _.find(scenes, { position: val });
																												}));;
																								}

																								return orderedScenes.length ? orderedScenes : scenes;
																				}

																				function mapZones(zonesObject, allZones) {
																								return _.map(zonesObject, function (zone) {
																												var match = _.find(allZones, { 'id': zone.id });

																												if (match && match.area) {
																																match.areaName = _.find(dSC.areas, ['id', match.area]).id_string;
																												}

																												return match;
																								});
																				}

																				function mapScenes(scenesObject, allScenes) {
																								return _.map(scenesObject, function (controlScene) {

																												var matchingScene = _.find(allScenes, { id: controlScene.id });

																												return {
																																id: matchingScene ? matchingScene.id : null,
																																object_id: matchingScene ? matchingScene.id : null,
																																description: matchingScene ? matchingScene.name : 'Scene Not Found',
																																object_type: 'scene',
																																position: controlScene.position
																												};
																								});
																				}

																				function getZoneTrims(group) {
																								//Returns true if all zones trim is 100
																								return _.every(group, function (zone) {
																												return zone && zone.trim_high === 100;
																								});
																				}

																				function setGroupMinimumTrim(list) {
																								dSC.groupMinTrim = list ? _.sortBy(list, ['trim_high'], 'asc')[0] ? _.sortBy(list, ['trim_high'], 'asc')[0].trim_high : null : null;
																				}
																}
												};

												_export('default', devicesSectionControlComponent);
								}
				};
});

$__System.registerDynamic("1a2", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"main-body no-padding\" ng-if=\"dSCM.device.controlBtnSets.length > 1\">\n\n    <h2 class=\"overview-heading\">\n        <span translate=\"\">Select Faceplate</span>\n    </h2>\n\n    <div \n        class=\"dimmer-faceplate selector\" \n        ng-repeat=\"faceplate in dSCM.faceplates\" \n        ng-class=\"{'selected': faceplate.selected}\"\n        ng-click=\"dSCM.selectFaceplate(dSCM.faceplates, faceplate.buttonCount)\"\n    >\n        <div class=\"dimmer-faceplate-inner {{::dSCM.device.className}} buttons-count-{{::faceplate.buttonCount}}\">\n            <ul>\n                <li class=\"dimmer-button\" ng-repeat=\"button in faceplate.buttonPositions\">\n                    <h3>{{::$index +1}}</h3>\n                </li>\n            </ul>\n        </div>\n    </div>\n</section>\n\n<section class=\"main-body no-padding\">\n\n    <h2 class=\"overview-heading\">\n        <span translate=\"\">Button Config</span>\n    </h2>\n\n    <div class=\"dimmer-faceplate\">\n        <div class=\"dimmer-faceplate-inner {{::dSCM.device.className}} buttons-count-{{dSCM.selectedButtonCount}}\">\n            <ul>\n                <li class=\"dimmer-button ripple \" ng-class=\"{active: button.button_id===dSCM.selectedButtonIndex}\" ng-repeat=\"button in dSCM.controlConfig.buttons\" ng-click=\"dSCM.selectedButtonIndex=button.button_id\"> <!-- hasContent:button.actions.length>0 -->\n                    <h3>{{::$index +1}}</h3>\n                    <span ng-class=\"{hide: !button.actions || button.actions.length < 1 || button.button_id===dSCM.selectedButtonIndex}\"><strong>{{dSCM.countActionObjects(button.actions)}}</strong> actions</span>\n                    <span ng-class=\"{'disabled': button.button_id===dSCM.selectedButtonIndex}\"></span>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n    <div class=\"button-action-list-holder devices-section-inner {{::dSCM.device.className}}\">\n        <nav class=\"button-criteria-tabs\">\n            <button \n                class=\"button-criteria-tab\" \n                ng-class=\"{'active': dSCM.selectedCriteria === 'single_press'}\" \n                ng-click=\"dSCM.selectCriteria('single_press')\"\n            >Single Press</button>\n\n            <!-- No hold actions for now --\n            <button \n                class=\"button-criteria-tab\" \n                ng-class=\"{'active': dSCM.selectedCriteria === 'hold'}\" \n                ng-click=\"dSCM.selectCriteria('hold')\"\n            >Hold</button>\n        -->\n\n            <button \n                class=\"button-criteria-tab\" \n                ng-class=\"{'active': dSCM.selectedCriteria === 'double_press'}\" \n                ng-click=\"dSCM.selectCriteria('double_press')\"\n            >Double Press</button>\n        </nav>\n\n        <control-button-action-list\n            class=\"dimmer-configs buttons-count-{{dSCM.selectedButtonCount}}\"\n            action-list=\"dSCM.controlConfig.buttons[dSCM.selectedButtonIndex].actions\"\n            button-index=\"dSCM.selectedButtonIndex\"\n            criteria=\"dSCM.selectedCriteria\"\n            on-update=\"dSCM.onListUpdate(objectId,objectType,buttonIndex,list)\"\n            on-selection-prompt=\"dSCM.selectKeyOption(buttonIndex,list,criteria,dSCM.controlConfig.buttons[dSCM.selectedButtonIndex])\"\n        ></control-button-action-list>\n\n    </div>\n    <!--\n    <control-button-action-list\n        class=\"devices-section-inner dimmer-configs buttons-count-{{dSCM.selectedButtonCount}}\"\n        action-list=\"dSCM.controlConfig.buttons[dSCM.selectedButtonIndex].actions\"\n        button-index=\"dSCM.selectedButtonIndex\"\n        criteria=\"hold\"\n        on-update=\"dSCM.onListUpdate(objectId,objectType,buttonIndex,list)\"\n        on-selection-prompt=\"dSCM.selectKeyOption(buttonIndex,list,criteria,dSCM.controlConfig.buttons[dSCM.selectedButtonIndex])\"\n    ></control-button-action-list>\n\n    <control-button-action-list\n        class=\"devices-section-inner dimmer-configs buttons-count-{{dSCM.selectedButtonCount}}\"\n        action-list=\"dSCM.controlConfig.buttons[dSCM.selectedButtonIndex].actions\"\n        button-index=\"dSCM.selectedButtonIndex\"\n        criteria=\"double_press\"\n        on-update=\"dSCM.onListUpdate(objectId,objectType,buttonIndex,list)\"\n        on-selection-prompt=\"dSCM.selectKeyOption(buttonIndex,list,criteria,dSCM.controlConfig.buttons[dSCM.selectedButtonIndex])\"\n    ></control-button-action-list>\n-->\n\n    <section class=\"dimmer-adtional-container\">\n\n        <div class=\"devices-section-inner control-button-quick-actions left full\">\n            <!--\n            <ul>\n                <li>Control Own Zone</li>\n                <li>Clear Config</li>\n            </ul>\n            --\n\n            <p class=\"button-area-message\" ng-if=\"cBAL.list.length > 1 && cBAL.groupMinTrim && !cBAL.zoneTrimSame && cBAL.device.device_type.model != 'Touch'\">All zones will be limited by the lowest max trim: <strong>{{cBAL.groupMinTrim}}</strong>.</p>-->\n\n            <button class=\"btn blue right m1pc\" ng-click=\"dSCM.saveControl()\"  ng-disabled=\"dSCM.ajaxPending\">Save</button>\n            <!--for newer dimmer which can select multi-zones--\n            <button class=\"btn green right m1pc\" ng-click=\"cBAL.selectObjectZones(cBAL.list);\" ng-hide=\"cBAL.device.device_type.model === 'Dimmer' && ((cBAL.list.length >= 1 && (!cBAL.firmwareSupported('1.24'))) || (cBAL.list.length >= 15 && (cBAL.firmwareSupported('1.24'))))\" ng-disabled=\"cBAL.ajaxPending\">Add</button>-->\n        </div>\n\n    </section>\n\n</section>";
});
$__System.register('1a3', ['1a2'], function (_export) {
				'use strict';

				var devicesSectionControlMultiComponentTmpl, devicesSectionControlMultiComponent;
				return {
								setters: [function (_a2) {
												devicesSectionControlMultiComponentTmpl = _a2['default'];
								}],
								execute: function () {
												devicesSectionControlMultiComponent = {
																template: devicesSectionControlMultiComponentTmpl,
																bindings: {
																				device: '<',
																				siteId: '<',
																				zones: '<',
																				areas: '<',
																				automations: '<',
																				scenes: '<',
																				onControlUpdate: '&'
																},
																controllerAs: 'dSCM',
																controller: function controller($scope, $timeout, $q, Devices, Scenes, Modals, LcFn, _) {

																				var dSCM = this;

																				dSCM.selectedZones = [];
																				dSCM.selectedScenes = [];

																				//
																				// Where does the inverse come from? Better way to do this?
																				//
																				var faceplates = [{
																								buttonCount: 2,
																								buttonPositions: [{ position: 0, inverse: 1 }, { position: 1, inverse: 0 } // Or 7?
																								]
																				}, {
																								buttonCount: 3,
																								buttonPositions: [{ position: 0, inverse: 1 }, { position: 1, inverse: 0 }, { position: 2, inverse: null }]
																				}, {
																								buttonCount: 4,
																								buttonPositions: [{ position: 0, inverse: 1 }, { position: 1, inverse: 0 }, { position: 2, inverse: 3 }, { position: 3, inverse: 2 }]
																				}, {
																								// 5 = Remote
																								buttonCount: 5,
																								buttonPositions: [{ position: 0, inverse: 2 }, { position: 1, inverse: null }, { position: 2, inverse: 0 }, { position: 3, inverse: null }, { position: 4, inverse: null }]
																				}, {
																								buttonCount: 8,
																								buttonPositions: [{ position: 0, inverse: 2 }, { position: 1, inverse: 3 }, { position: 2, inverse: 0 }, { position: 3, inverse: 1 }, { position: 4, inverse: 6 }, { position: 5, inverse: 7 }, { position: 6, inverse: 4 }, { position: 7, inverse: 5 }]
																				}];

																				dSCM.$onInit = function () {
																								//
																								// Init defaults
																								//
																								dSCM.selectedButtonIndex = 0;
																								dSCM.selectedCriteria = 'single_press';

																								dSCM.faceplates = _.filter(faceplates, function (faceplate) {
																												return dSCM.device.controlBtnSets.indexOf(faceplate.buttonCount) > -1;
																								});

																								//
																								//	Take first faceplate as default (will usually be 2)
																								//
																								dSCM.selectedButtonCount = dSCM.faceplates[0] ? dSCM.faceplates[0].buttonCount : 2;

																								dSCM.selectFaceplate(dSCM.faceplates, dSCM.selectedButtonCount);
																				};

																				dSCM.$onChanges = function (changes) {
																								//console.log(changes)
																				};

																				dSCM.onControlUpdate = function (change) {
																								//console.log(change);
																				};

																				dSCM.firmwareSupported = function (minVersion) {
																								return !LcFn.ltVersion(dSCM.device.last_firmware_version, minVersion);
																				};

																				dSCM.selectCriteria = function (criteria) {
																								//console.log(criteria);

																								dSCM.selectedCriteria = criteria;
																				};

																				dSCM.selectKeyOption = function (position, list, criteria, button) {
																								//console.log(position, list, criteria, button)
																								var selectedZones = [];

																								var deviceZoneId = dSCM.device.deviceZones[0] ? dSCM.device.deviceZones[0].id : null;

																								var flaggedZones = flagZones(dSCM.zones, dSCM.device.gateway, deviceZoneId);

																								var areas = _.map(dSCM.areas, function (area) {
																												area.zones = _.filter(flaggedZones, { area: area.id }).map(function (zone) {
																																if (_.find(list, function (action) {
																																				return (action.object_type === 'zone' || action.lcType === 'zone') && action.id === zone.id;
																																})) {
																																				selectedZones.push(zone);
																																}
																																return zone;
																												});

																												return area;
																								});

																								// - Add unassigned zones to their own category
																								var noAreaZones = _.filter(flaggedZones, { area: null }).map(function (zone) {
																												if (_.find(list, function (action) {
																																return (action.object_type === 'zone' || action.lcType === 'zone') && action.id === zone.id;
																												})) {
																																selectedZones.push(zone);
																												}
																												return zone;
																								});

																								if (noAreaZones.length) {
																												areas.push({
																																name: 'No Area',
																																zones: noAreaZones
																												});
																								}

																								var allItems = [{
																												type: 'scenes',
																												areas: [{ name: 'Site Wide', scenes: dSCM.scenes }],
																												selected: _.filter(dSCM.scenes, function (scene) {
																																return _.find(list, function (action) {
																																				return (action.object_type === 'scene' || action.lcType === 'scene') && action.id === scene.id;
																																});
																												})
																								}];

																								//
																								// Only allow Scene and automation selection
																								//
																								if (criteria === 'single_press') {
																												allItems.unshift({
																																type: 'zones',
																																areas: areas,
																																selected: selectedZones
																												});
																								}

																								//
																								// Remove automations for now
																								//
																								/*
                        	{
                                type    : 'automations',
                                areas   : [{automations:dSCM.automations}],
                                selected: _.filter(dSCM.automations, automation => {
                                    return _.find(list, action=>{
                                        return (action.object_type === 'closed_loop_dim' || action.lcType === 'behavior2') && action.id === automation.behavior_id;
                                    });
                                })
                            }
                         */

																								return Modals.showMulti(allItems, 'Select Action', 'class').then(function (selection) {
																												return updateFromSelection(selection, button, criteria);
																								});
																				};

																				dSCM.onListUpdate = function (objectId, objectType, buttonIndex, list) {
																								if (dSCM.controlConfig) {
																												//
																												// Automatically remove inverse ID zone action
																												//
																												var inverseButtonActions = getInverseActions(dSCM.selectedButtonCount, objectType, dSCM.controlConfig.buttons, getInverseId(buttonIndex));

																												if (inverseButtonActions) {
																																//
																																// Limit one type of action per button for now
																																//
																																var inverseButtonAction = _.find(inverseButtonActions, { object_type: 'zone' });

																																if (inverseButtonAction) {

																																				LcFn.removeFromLists([objectId], [inverseButtonAction.objects]);
																																}
																												}
																								}
																				};

																				// function getAutoActionObjectType(item){
																				//     return item.object_type === 'gateway' ? automationsDefaults.actions.emergency(item) : item.behavior_id ? automationsDefaults.actions.automation(item) : item.zone_msg ? automationsDefaults.actions.zone(item) : automationsDefaults.actions.scene(item);
																				// }

																				dSCM.countActionObjects = function (actions) {
																								return _.flatten(_.map(actions, function (action) {
																												return action.objects;
																								})).length;
																				};

																				dSCM.saveControl = function () {

																								var controlObject = {
																												name: 'Control for device ' + dSCM.device.id,
																												node: dSCM.device.id,
																												buttons: mapButtonsForSave(dSCM.controlConfig.buttons)
																								};

																								Modals.openLoad('Saving Configuration');

																								(dSCM.controlConfig.id ? Devices.setControlConfig(dSCM.controlConfig.id, controlObject) : Devices.createControlConfig(controlObject)).then(function () {
																												dSCM.editMode = false;
																												Modals.closeLoad('Configuration Saved', true);
																								}, function () {
																												Modals.closeLoad('Configuration Save Failure');
																								});
																				};

																				dSCM.removeItem = function (index, group) {
																								group.splice(index, 1);
																				};

																				dSCM.selectFaceplate = function (faceplates, buttonCount) {
																								_.each(faceplates, function (faceplate) {
																												faceplate.selected = faceplate.buttonCount === buttonCount;
																								});

																								updateButtonTemplate(buttonCount);
																				};

																				function updateButtonTemplate(buttonCount) {
																								dSCM.selectedButtonCount = buttonCount;

																								getControlConfigs(dSCM.siteId, dSCM.zones, dSCM.scenes, dSCM.areas, dSCM.device, dSCM.selectedButtonCount).then(function (mappedConfig) {
																												dSCM.controlConfig = mappedConfig;
																								});
																				}

																				function updateActionSet(buttonActions, lcType, selectionGroup, action, criteria) {
																								var existingActionType = _.find(buttonActions, function (action) {
																												return action.object_type === lcType && action.criteria === criteria;
																								});

																								if (existingActionType) {
																												existingActionType.objects = selectionGroup;
																								} else {
																												buttonActions.push({
																																criteria: criteria,
																																object_type: lcType,
																																object_action: action, //@todo Automation support
																																objects: selectionGroup
																												});
																								}
																				}

																				function getDefaultAction(lcType, button, criteria) {
																								//
																								// Default to activate for scene or automation
																								//
																								var defaultAction = 'activate';

																								if (lcType === 'zone') {
																												if (criteria === 'hold') {
																																defaultAction = button.button_id < button.inverse_id ? 'dim_up' : 'dim_down';
																												} else if (criteria === 'single_press') {
																																defaultAction = button.button_id < button.inverse_id ? 'switch_on' : 'switch_off';
																												}
																								}

																								return defaultAction;
																				}

																				function getInverseActions(selectedButtonCount, lcType, buttons, buttonInverseId) {
																								var inverse = _.find(buttons, { button_id: buttonInverseId });

																								// per Jason - hide multiple button UI for now - we only allow a single button config that applies to all

																								return selectedButtonCount === 2 /*|| selectedButtonCount === 5*/ && lcType === 'zone' ? inverse ? inverse.actions : null : null;
																				}

																				function updateFromSelection(selection, button, criteria) {
																								var selectionByType = _.groupBy(selection, 'lcType');

																								_.each(selectionByType, function (selectionGroup, lcType) {
																												//
																												// Assumes no duplicate 'object_actions' for the same zone/scene
																												//
																												// Based on criteria - set default and inverse
																												var defaultAction = getDefaultAction(lcType, button, criteria);

																												updateActionSet(button.actions, lcType, selectionGroup, defaultAction, criteria);

																												//
																												// Inverse magic... add an inverse of selected zone action
																												//
																												var matchingInverseActions = getInverseActions(dSCM.selectedButtonCount, lcType, dSCM.controlConfig.buttons, button.inverse_id);

																												if (matchingInverseActions) {
																																var defaultInverseAction = criteria === 'hold' ? 'dim_down' : 'switch_off';

																																updateActionSet(matchingInverseActions, lcType, selectionGroup, defaultInverseAction, criteria);
																																//
																																// Automatically add dim_up & dim_down to zones for single_press criteria
																																//
																																/* -- Removed for now - device is inferring hold actions (not per spec) 
                                if(criteria === 'single_press'){
                                updateFromSelection(selection,button,'hold');
                                }
                                */
																												}
																								});

																								return button.actions;
																				}

																				function flagZones(zones, deviceGatewayId, deviceZoneId) {
																								return zones.map(function (zone) {
																												// - Gateway Mismatch
																												if (zone.gatewayId !== deviceGatewayId) {
																																zone.block_selection_gateway = true;
																												}

																												// - PC Dimmer Zone
																												if (zone.id === deviceZoneId) {
																																zone.is_local_zone = true;
																												}

																												return zone;
																								});
																				}

																				var DefaultConfigObj = function DefaultConfigObj(device) {
																								this.name = device.settings.id_string;
																								this.node = device.id;
																								this.buttons = [{}, {}];
																				};

																				function getControlConfigs(siteId, allZones, allScenes, allAreas, device, buttonCount) {
																								dSCM.ajaxPending = true;

																								return Devices.getMultiControlConfigs(siteId, device.id).then(function (config) {
																												//
																												// Cover for no matching control config - returning null for now
																												//
																												var configObj = config || new DefaultConfigObj(device);

																												dSCM.ajaxPending = false;
																												return {
																																id: configObj.id,
																																buttons: mapZonesAndScenes(configObj.buttons, allZones, allScenes, allAreas, buttonCount) //Take first?
																												};
																								});
																				}

																				function mapZonesAndScenes(buttons, allZones, allScenes, allAreas, buttonCount) {
																								//
																								// Better to merge button and faceplate array here to allow change of faceplate?
																								//
																								return _.map(new Array(buttonCount), function (button, key) {
																												var buttonMatch = _.find(buttons, { button_id: checkPhaseCutSwapButtonIndex(dSCM.device, dSCM.selectedButtonCount, key) });

																												return {
																																button_id: key,
																																inverse_id: getInverseId(key),
																																actions: buttonMatch ? _.map(buttonMatch.actions, function (action) {
																																				return actionMap(action, allZones, allScenes, allAreas);
																																}) : []
																												};
																								});
																				}

																				function getInverseId(buttonId) {
																								var matchInverse = null;

																								var selected = _.find(dSCM.faceplates, 'selected');

																								if (selected) {
																												var selectedPositions = selected.buttonPositions;

																												var match = _.find(selectedPositions, { position: buttonId });

																												if (match) {
																																matchInverse = match.inverse;
																												}
																								}

																								return matchInverse;
																				}

																				function actionMap(action, allZones, allScenes, allAreas) {
																								var converters = {
																												zone: function zone(action, allZones, allScenes, allAreas) {
																																return _.map(action.object_ids, function (id) {
																																				var matchingZone = _.find(allZones, { 'id': id });

																																				if (matchingZone && matchingZone.area) {
																																								matchingZone.areaName = LcFn.getName(_.find(allAreas, ['id', matchingZone.area]));
																																				}

																																				return {
																																								id: matchingZone ? matchingZone.id : null,
																																								id_string: matchingZone ? LcFn.getName(matchingZone) : 'Zone ' + id + ' Not Found',
																																								object_type: 'zone'
																																				};
																																});
																												},
																												scene: function scene(action, allZones, allScenes) {
																																return _.map(action.object_ids, function (id) {
																																				var matchingScene = _.find(allScenes, { id: id });

																																				return {
																																								id: matchingScene ? matchingScene.id : null,
																																								id_string: matchingScene ? LcFn.getName(matchingScene) : 'Scene Not Found',
																																								object_type: 'scene'
																																				};
																																});
																												}
																								};

																								return {
																												criteria: action.criteria,
																												object_type: action.object_type,
																												object_action: action.object_action,
																												objects: converters[action.object_type](action, allZones, allScenes, allAreas)
																								};
																				}

																				function mapButtonsForSave(buttons) {
																								function mapActionForSave(action) {
																												return {
																																criteria: action.criteria,
																																object_action: action.object_action,
																																object_ids: action.objects.map(function (object) {
																																				return object.id;
																																}),
																																object_type: action.object_type
																												};
																								}

																								return _.map(buttons, function (button) {
																												return {
																																actions: _.filter(button.actions.map(mapActionForSave), function (action) {
																																				return action.object_ids.length;
																																}),
																																button_id: checkPhaseCutSwapButtonIndex(dSCM.device, dSCM.selectedButtonCount, button.button_id),
																																inverse_id: checkPhaseCutSwapButtonIndex(dSCM.device, dSCM.selectedButtonCount, button.inverse_id)
																												};
																								});
																				}

																				function checkPhaseCutSwapButtonIndex(device, buttonCount, id) {
																								//
																								// PC with 2 button faceplate wants button ids 1 & 6...
																								// Swapping to these indexes for UI is messy
																								// Hoping we can do this somewhere other than FE in future
																								//
																								return device.device_type.model === 'Phase Cut Dimmer' && buttonCount === 2 ? id === 0 ? 1 : id === 1 ? 6 : id : id;
																				}
																}
												};

												_export('default', devicesSectionControlMultiComponent);
								}
				};
});

$__System.register('1a4', [], function (_export) {
    'use strict';

    var controlButtonActionListComponent;
    return {
        setters: [],
        execute: function () {
            controlButtonActionListComponent = {
                template: '\n        <h1>Button {{cBAL.buttonIndex + 1}}</h1>\n\n        <!-- Switches the display based on if there are actions to present -->\n        <div ng-switch="cBAL.hasActions()">\n\n            <!-- Display No actions -->\n            <div ng-switch-when="false" class="dimmer-action-container">\n                <div class="white-pill-item no-icon short"\n                    ng-click="cBAL.promptSelection({buttonIndex: cBAL.buttonIndex, list: [], criteria: cBAL.criteria});">\n                    <button class="btn black btn-white-plus"></button>\n                    <h1 class="name">No Action</h1>\n                </div>\n            </div>\n\n            <!-- Has actions so display them -->\n            <div ng-switch-when="true">\n                <div ng-repeat="(key, action) in cBAL.list track by $index">\n                    <div class="dimmer-action-container" ng-repeat="(key, item) in action.objects track by $index">\n                        <button class="btn-select remove"\n                                ng-click="cBAL.removeItem(item.id,item.object_type,cBAL.buttonIndex,action.objects)">\n                        </button>\n                        <div class="white-pill-item no-icon {{(item.id === null ? \'disabled\' : \'\')}}">\n                            <h1 class="name">{{item.id_string || item.name}}</h1>\n                            \n                            <div class="trim-help" ng-if="::!cBAL.zoneTrimSame">\n                                <span class="smallcaps">Max Trim: {{item.trim_high}}</span>\n                                <div class="trim-progress">\n                                    <progress value="{{item.trim_high}}" max="100"></progress>\n                                </div>\n                            </div>\n\n                            <div class="dimmer-button-zone-toggle" ng-if="action.object_type === \'zone\'">\n                                <div class="contrast-buttons">\n                                    <div ng-repeat="zoneAction in cBAL.zoneActions" ng-class="{selected: zoneAction.action === action.object_action}" ng-click="cBAL.selectZoneAction(action,zoneAction.action)">{{zoneAction.label}}</div> \n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <button class="btn green right"\n                            ng-click="cBAL.promptSelection({buttonIndex: cBAL.buttonIndex, list: action.objects, criteria: cBAL.criteria})">\n                        Add\n                    </button>\n                </div>\n            </div>\n        </div>\n    ',
                bindings: {
                    actionList: '<',
                    buttonIndex: '<',
                    criteria: '<',
                    onSelectionPrompt: '&',
                    onUpdate: '&'
                },
                controllerAs: 'cBAL',
                controller: function controller(_, LcFn) {

                    var cBAL = this;

                    cBAL.$onInit = function () {};

                    cBAL.$onChanges = function (changes) {
                        updateCBAL(cBAL.actionList, cBAL.criteria, cBAL.buttonIndex);
                    };

                    function updateCBAL(actionList, criteria, buttonIndex) {
                        var filtered = _.filter(actionList, { criteria: criteria });

                        // This removes actions with no objects that we don't want in the list
                        filtered = filtered.filter(function (a) {
                            return Array.isArray(a.objects) && a.objects.length > 0;
                        });

                        // Update the list with new reference
                        cBAL.list = filtered;

                        // Update with a fresh shallow copy of the list to parent
                        cBAL.onUpdate({ objectId: null, objectType: null, buttonIndex: buttonIndex, list: filtered.slice() });
                    }

                    // This is a helper so that we know if there are actual actions to display
                    cBAL.hasActions = function () {
                        // false if no real actions to display
                        if (!cBAL.list || !cBAL.list.length) return false;

                        // true only if at least one action has non-empty objects
                        return cBAL.list.some(function (a) {
                            return Array.isArray(a.objects) && a.objects.length > 0;
                        });
                    };

                    cBAL.zoneActions = [{
                        label: 'On',
                        action: 'switch_on'
                    }, {
                        label: 'Off',
                        action: 'switch_off'
                    }, {
                        label: 'Dim +',
                        action: 'dim_up'
                    }, {
                        label: 'Dim -',
                        action: 'dim_down'
                    }];

                    cBAL.promptSelection = function (args) {
                        cBAL.onSelectionPrompt(args).then(function (list) {
                            updateCBAL(list, cBAL.criteria, cBAL.buttonIndex);
                        });
                    };

                    cBAL.toggleZone = function (action) {
                        action.object_action = action.object_action === 'switch_on' ? 'switch_off' : 'switch_on';
                    };

                    cBAL.selectZoneAction = function (item, action) {
                        item.object_action = action;
                    };

                    cBAL.removeItem = function (objectId, objectType, buttonIndex, list) {
                        LcFn.removeFromLists([objectId], [list]);
                        cBAL.onUpdate({ objectId: objectId, objectType: objectType, buttonIndex: buttonIndex, list: list });
                    };

                    cBAL.zoneTrimSame = function (group) {
                        return _.every(group, function (zone) {
                            return zone && zone.trim_high === 100;
                        });
                    };
                }
            };

            _export('default', controlButtonActionListComponent);
        }
    };
});

$__System.register('1a5', [], function (_export) {
    'use strict';

    var devicesSectionGroupActionsComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionGroupActionsComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dSMAC.drop}" ng-click="dSMAC.drop = !dSMAC.drop;">\n            <span translate="devices.masterDevicesControls">{{::dSMAC.title}}</span>\n        </h2>\n\n        <section class="" ng-if="dSMAC.drop;">\n\n            <div class="upgrade-info left m1pc" > <!-- ng-if="$root.staff" -->\n               <!-- Device Table -->\n               <button class="btn blue" ng-click="dSMAC.getDeviceTable(dSMAC.siteId)" translate="devices.downloadDeviceTable">Generate Device Table</button>\n\n                <a href="{{dSMAC.downloadLink}}" download="{{dSMAC.downloadLinkName}}" ng-if="dSMAC.downloadLink" target="_blank">Export Device Table...</a>\n\n                <button class="btn blue" ui-sref="Automations({siteId:dSMAC.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'automations\'})">Master Automations</button>\n               \n               <!-- Site data -->\n                <button class="btn blue" ng-click="dSMAC.getSiteData(dSMAC.siteId)">Generate Site Data</button>\n                \n                <a href="{{dSMAC.siteDataDownloadLink}}" download="{{dSMAC.downloadLinkName}}" ng-if="dSMAC.siteDataDownloadLink" target="_blank">Export Site Data...</a>\n\n\n                <!-- Calibration -->\n                <button class="btn blue" ng-if="!dSMAC.selectedDevices" ng-click="dSMAC.startCalibration(dSMAC.allDevices)">Calibrate All</button>\n                <button class="btn blue" ng-if="dSMAC.selectedDevices" ng-click="dSMAC.startCalibration(dSMAC.selectedDevices)">Calibrate Selected</button>\n\n                <!-- Indicate -->\n                <button class="btn blue" ng-if="dSMAC.selectedDevices" ng-click="dSMAC.indicateDevices(dSMAC.selectedDevices)">Indicate Devices</button>\n                <!--<button class="btn blue" ng-if="!dSMAC.selectedDevices" ng-click="dSMAC.indicateDevices(dSMAC.allDevices)">Indicate Site</button>-->\n\n                <button class="btn orange" ng-if="dSMAC.selectedDevices" ng-click="dSMAC.deleteDevices(dSMAC.selectedDevices)" ng-if="dSMAC.isSuperUser">Delete Devices</button>\n            </div>  \n\n                <!--\n               <devices-section-update ng-if="dSMAC.selectedDevices" update-set="dSMAC.selectedDevices" devices="dSMAC.allDevices"></devices-section-update>\n               -->\n\n               <!-- Old Update -->\n               <devices-update-legacy ng-if="dSMAC.selectedDevices" devices="dSMAC.allDevices" update-set="dSMAC.selectedDevices"></devices-update-legacy>\n\n\n            <!-- Old Update ALL -->\n            <section class="main-body" ng-if="!dSMAC.selectedDevices">\n                <!--\n                <h2 class="overview-heading">\n                    <span translate="devices.updateAllDevices">Update All Devices</span>\n                </h2>\n                -->\n                <devices-update-legacy devices="dSMAC.allDevices" update-set="dSMAC.allDevices"></devices-update-legacy>\n            </section>\n\n        </section>\n    ',
                bindings: {
                    allDevices: '<',
                    isSuperUser: '<',
                    selectedDevices: '<',
                    siteId: '<',
                    site: '<',
                    title: '@',
                    zones: '<'
                },
                controllerAs: 'dSMAC',
                controller: function controller($window, $rootScope, $scope, $q, $sce, Devices, Modals, Zones, Sites, Messages, _) {
                    // @refactor $rootScope for mobile check - move this away

                    var dSMAC = this;

                    dSMAC.$onInit = function () {
                        //
                    };

                    dSMAC.$onChanges = function (changes) {
                        //
                    };

                    dSMAC.deleteDevices = function (devices) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + devices.length + '</strong> devices?').then(function () {

                            Modals.openLoad('Deleting Devices');

                            var devicesToDelete = [];

                            _.each(devices, function (device) {
                                devicesToDelete.push(device['delete']());
                            });

                            $q.all(devicesToDelete).then(function () {
                                Modals.closeLoad('Devices Deleted', true);
                                //updateDevices($scope, $scope.selectedDevices);
                            }, function () {
                                //Failures handled here
                            });
                        });
                    };

                    dSMAC.getDeviceTable = function (siteId) {
                        var alertMsg = 'Generating Device Table, please wait...';
                        Messages.errorToast(alertMsg); // using error toast to display a message that the request has been made, it dissappears automatically.
                        Sites.deviceTable(siteId).then(function (response) {
                            dSMAC.downloadLink = generateDownload(response);
                            dSMAC.downloadLinkName = dSMAC.site.id_string + '-device_table.csv';
                        })['catch'](function (error) {
                            if (error.status !== 200) {
                                alertMsg = 'Something went wrong please try again: ' + error.statusText;
                                console.error('failed to get device table', error);
                                Messages.errorToast(alertMsg, true);
                            } else {
                                Messages.errorToast('Something went wrong please try again later', true);
                                console.error('failed to get device table', error);
                            }
                        });
                    };

                    dSMAC.getSiteData = function (siteId) {
                        var alertMsg = 'Generating Site Data, please wait...';
                        Messages.errorToast(alertMsg);
                        Sites.siteData(siteId).then(function (response) {
                            dSMAC.siteDataDownloadLink = generateDownload(response);
                            dSMAC.downloadLinkName = dSMAC.site.id_string + '-site-data.txt';
                        })['catch'](function (error) {
                            if (error.status !== 200) {
                                alertMsg = 'Something went wrong please try again: ' + error.statusText;
                                console.error('failed to get site data', error);
                                Messages.errorToast(alertMsg, true);
                            } else {
                                Messages.errorToast('Something went wrong please try again later', true);
                                console.error('failed to get site data', error);
                            }
                        });
                    };

                    dSMAC.startCalibration = function (devices) {
                        Modals.confirm($scope, 'Cancel', 'Continue', 'Calibrate ' + devices.length + ' devices with zones? (this will take place in background)').then(function () {
                            Modals.openLoad('Initiating Calibration');

                            var zonesToCalibrate = [];

                            _.each(devices, function (device) {
                                //
                                device.deviceZones = _.filter(dSMAC.zones, { node: device.id });

                                _.each(device.deviceZones, function (zone) {
                                    zonesToCalibrate.push(Zones.calibration(zone.id));
                                });
                            });

                            $q.all(zonesToCalibrate).then(function () {
                                Modals.closeLoad('Calibration initiated', true);
                            }, function () {
                                Modals.closeLoad('Calibration initiation failed');
                                //Failures handled here
                            });
                        });
                    };

                    dSMAC.indicateDevices = function (devices) {
                        _.each(devices, function (device) {
                            Devices.indicate(device.id);
                        });
                    };

                    function generateDownload(response) {
                        return $sce.trustAsResourceUrl(URL.createObjectURL(response));
                    }
                }
            };

            _export('default', devicesSectionGroupActionsComponent);
        }
    };
});

$__System.registerDynamic('1a6', ['1a7'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var isObject = $__require('1a7'),
      floor = Math.floor;
  module.exports = function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };
});
$__System.registerDynamic('1a8', ['116', '1a6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $def = $__require('116');
  $def($def.S, 'Number', { isInteger: $__require('1a6') });
});
$__System.registerDynamic('1a9', ['1a8', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('1a8');
  module.exports = $__require('118').Number.isInteger;
});
$__System.registerDynamic("1aa", ["1a9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("1a9"), __esModule: true };
});
$__System.registerDynamic("1ab", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading drop\" ng-class=\"{dropped: dSS.drop}\" ng-click=\"dSS.drop = !dSS.drop;\">\n    <span>Device Settings</span>\n</h2>\n\n<section class=\"devices-section-inner full main-body\" ng-if=\"dSS.drop;\">\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"deviceId\"\n            value=\"dSS.device.mac_addr\"\n            template=\"textInput\"\n            disabled=\"true\"\n            cleanMac\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\" \n            setting-name=\"zoneName\" \n            value=\"dSS.device.deviceZones[0].id_string\" \n            template=\"textInput\" \n            disabled=\"true\"\n            ng-if=\"dSS.device.isControllerType\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\" \n            value=\"dSS.settings.description\" \n            template=\"textInput\" \n            placeholder=\"Breaker Box e.g.\" \n            size=\"half\"\n            ng-if=\"!dSS.groupMode\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            is-super-user=\"dSS.isSuperUser\"\n            pending=\"dSS.ajaxPending\"\n            firmware=\"dSS.device.last_firmware_version\"\n            setting-name=\"deviceMode\" \n            value=\"dSS.settings.device_mode\" \n            template=\"buttonSelect\" \n            size=\"full\" \n            button-options=\"dSS.device.modes\"\n            ng-if=\"dSS.device.isControllerType && (dSS.device.modes.length > 0)\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\" \n            setting-name=\"soft_dim_enable\" \n            value=\"dSS.settings.soft_dim_enable\" \n            template=\"toggleA\"\n            ng-if=\"dSS.device.isDimmable\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"powerMonitoring\"\n            value=\"dSS.settings.power_report\"\n            template=\"toggleA\"\n            verb-true=\"On\"\n            verb-false=\"Off\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.device.monitorsPower !== undefined ? dSS.device.monitorsPower : (dSS.device.isControllerType && !(dSS.settings.device_mode === 'advance_trigger' || dSS.settings.device_mode === 'advance_trigger_no_actuator')) || dSS.device.isSensor\"\n        ></device-setting>\n\n        <!-- zone offline notification  \n\n            @temp - jason 7/22 Hide unless enabled until feature works correctly\n            \n        -->\n        <device-setting\n            ng-if=\"dSS.device.offline_notification_enabled && dSS.device.device_type.model !== 'Daylight Harvester'\"\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"offlineNotification\"\n            value=\"dSS.device.offline_notification_enabled\"\n            template=\"toggleA\"\n            verb-true=\"On\"\n            verb-false=\"Off\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            ng-if=\"dSS.device.offline_notification_enabled\"\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"offlineNotificationThreshold\"\n            value=\"dSS.device.offline_notification_threshold\"\n            template=\"numInput\"\n            max=\"100\"\n            min=\"0\"\n            unit=\"mins\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.device.offline_notification_enabled\"\n        ></device-setting>\n        <!-- end of zone offline notification-->\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"faultNotificationThreshold\"\n            value=\"dSS.settings.fixture_fault_alert_threshold\"\n            template=\"slider\"\n            max=\"100\"\n            min=\"0\"\n            unit=\"%\"\n            size=\"full\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.settings.power_report\"\n            help=\"The alert threshold is the percentage drop from calibrated power level that will trigger a fault. E.g: if you set it to 10%, a drop of 10% or more will trigger a fault\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"powerUpState\"\n            value=\"dSS.settings.power_on_mode\"\n            template=\"buttonSelect\" \n            size=\"full\"\n            button-options=\"[\n                {name: 'last'},\n                {name: 'last_on'},\n                {\n                    name: 'custom',\n                    conditions : {\n                        zoneDimmable: true\n                    }\n                },\n                {name: 'off'}\n            ]\"\n            zones=\"dSS.device.deviceZones\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"((dSS.device.isSensor && dSS.firmwareSupported(dSS.device.last_firmware_version, '1.33.5')) || dSS.device.isControllerType) && dSS.device.device_type.model !== 'Dimmer Bridge'\"\n            help=\"When this device powers up, it will: 1) enter the last state it was in when it powered down (on or off), 2) turn ON, at the last level it was at when it powered down, 3) turn ON at the specified level or 4) turn OFF\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            pending=\"dSS.ajaxPending\"\n            setting-name=\"powerUpOnLevel\"\n            value=\"dSS.settings.power_on_level\"\n            min=\"dSS.device.deviceZones[0].trim_low ? dSS.device.deviceZones[0].trim_low  : 1\"\n            max=\"dSS.device.deviceZones[0].trim_high\"\n            template=\"slider\"\n            size=\"full\"\n            unit=\"%\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.settings.power_on_mode === 'custom'\"\n        ></device-setting>\n\n        <!-- Twistlock gets ALS but isn't a 'sensor'-->\n        <device-setting\n            group=\"dSS.groupMode\" \n            setting-name=\"alsControlState\" \n            value=\"dSS.settings.als_control_state\" \n            template=\"toggleA\"\n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.device.device_type.model === 'Twistlock'\"\n        ></device-setting>\n\n        <div class=\"\" ng-if=\"dSS.device.isSensor\">\n            <!-- Hidden per linda\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"testMode\" \n                value=\"dSS.settings.test_mode\" \n                template=\"toggleA\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n            -->\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"indicatorLED\"\n                value=\"dSS.settings.occupancy_led_enable\"\n                template=\"toggleA\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"offToUnoccupied\"\n                value=\"dSS.settings.off_to_unoccupied_timeout\"\n                template=\"toggleA\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"dSS.firmwareSupported(dSS.device.last_firmware_version, '1.35')\"\n                help=\"When the zone is switched off via a Dimmer, trigger a vacancy event so the zone turns back on immediately upon re-entry to the space.\"\n                id=\"off-to-unoccupied\"\n                size=\"half\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                is-super-user=\"dSS.isSuperUser\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"deviceMode\" \n                value=\"dSS.settings.device_mode\" \n                template=\"buttonSelect\" \n                size=\"full\"\n                button-options=\"dSS.device.modes\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <!--\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"pirSensitivity\" \n                value=\"dSS.settings.pir_sensitivity\"\n                template=\"slider\" \n                size=\"full\" \n                unit=\"%\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n            -->\n\n            <!-- Use buttonSelect template instead of range slider -->\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"pirSensitivity\" \n                value=\"dSS.settings.pir_sensitivity\"\n                template=\"buttonSelect\" \n                size=\"half\" \n                button-options=\"[\n                    {name: 'low',    value: 1},\n                    {name: 'med',    value: 50},\n                    {name: 'high',   value: 100}\n                ]\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"timeout\"\n                value=\"dSS.settings.turn_off_time_delay\"\n                size=\"full\"\n                max=\"30\"\n                unit=\"mins\"\n                is-super-user=\"dSS.isSuperUser\"\n                template=\"sliderWithCustomizedValue\"\n                threshold=\"30\"\n                customizedmax=\"240\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <!--\n                LCFRONTEND-233 - This setting was max_dimmer_level, now changed to occupied_dimmer_level\n            -->\n            <div ng-if=\"!dSS.firmwareSupported(dSS.device.last_firmware_version, '1.36.16')\">\n                <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\" \n                    setting-name=\"whenOccupied\" \n                    value=\"dSS.settings.occupied_dimmer_level\" \n                    template=\"sliderToggle\" \n                    size=\"full\" \n                    unit=\"%\" \n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"dSS.settings.device_mode === 'occupancy'\"\n                ></device-setting>\n            </div>\n\n            <!-- New Occupied light on settings -->\n            <div ng-if=\"dSS.firmwareSupported(dSS.device.last_firmware_version, '1.36.16')&& dSS.settings.device_mode === 'occupancy'\" class=\"occupied-zone\" ng-class=\"{extended: dSS.settings.occupied_zone_on_type === 0}\">\n                <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\"\n                    setting-name=\"whenOccupied\"\n                    value=\"dSS.settings.occupied_zone_on_type\"\n                    template=\"buttonSelectForNum\"\n                    size=\"full\"\n                    button-options=\"[\n                        {name: 'custom'},\n                        {name: 'last_on'}\n                    ]\"\n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"dSS.settings.device_mode === 'occupancy'\"\n                ></device-setting>\n\n                <!--\n                    LCFRONTEND-233 - This setting was max_dimmer_level, now changed to occupied_dimmer_level\n                -->\n                <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\"\n                    setting-name=\"whenOccupiedZoneLevel\"\n                    value=\"dSS.settings.occupied_dimmer_level\"\n                    min=\"dSS.device.deviceZones[0].trim_low || 1\"\n                    max=\"dSS.device.deviceZones[0].trim_high || 100\"\n                    template=\"slider\"\n                    size=\"full\"\n                    unit=\"%\"\n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"dSS.settings.occupied_zone_on_type === 0\"\n                ></device-setting>\n            </div>\n            <!-- End Occupied light on settings -->\n\n            <!--\n                LCFRONTEND-233 - This setting was min_dimmer_level, now changed to unoccupied_dimmer_level\n            -->\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"whenUnoccupied\" \n                value=\"dSS.settings.unoccupied_dimmer_level\" \n                last-saved-unoccupied-dimmer-level=\"dSS.settings.last_saved_unoccupied_dimmer_level\"\n                template=\"sliderToggle\"\n                size=\"full\" \n                unit=\"%\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"dSS.settings.device_mode === 'occupancy'\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"reentryTimeout\" \n                value=\"dSS.settings.vacancies_mode_return_time\" \n                template=\"sliderToggle\" \n                size=\"full\" \n                min=\"1\" \n                max=\"30\" \n                unit=\"secs\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"dSS.settings.device_mode === 'vacancy'\"\n            ></device-setting>\n\n            <!-- Blink settings disabled in group mode - they set a bunch of nutty defaults -->\n            <!-- <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"blinkBeforeUnoccupied\"\n                value=\"dSS.settings.blink_number\"\n                template=\"wrappedToggle\"\n                size=\"full\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"!dSS.groupMode && (dSS.settings.device_mode !== 'no_actuator' || dSS.firmwareSupported(dSS.device.last_firmware_version, '1.33'))\"\n                settings=\"dSS.settings\"\n            ></device-setting> -->\n        </div>\n\n        <!-- LcSense settings here until we swap to YAML -->\n        <div ng-if=\"dSS.device.isLcSense && dSS.device.has_sense\">\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                value=\"dSS.settings.motion_timeout\"\n                template=\"sliderToggle\"\n                max=\"360\"\n                min=\"1\"\n                unit=\"mins\"\n                size=\"full\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                value=\"dSS.settings.sensor_sensitivity\"\n                template=\"buttonSelect\" \n                size=\"half\"\n                button-options=\"[\n                    {name: 'low'},\n                    {name: 'med'},\n                    {name: 'high'}\n                ]\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"indicatorLED\"\n                value=\"dSS.settings.occupancy_led_enable\"\n                template=\"toggleA\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n            \n        </div>\n\n\n        <!-- 3/20 \n            Jason - Daylight harvestors need transform of 2.7, all other sensors 10.7\n        -->\n        <div ng-if=\"dSS.device.isSensor || (dSS.device.isLcSense && dSS.device.has_sense)\">\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"daylightAverageSinceLastValue\" \n                value=\"dSS.device.daylight_average_since_last_value\" \n                template=\"textInput\" \n                disabled=\"true\" \n                size=\"third\" \n                transform=\"dSS.device.device_type.model === 'Daylight Harvester' ? 'luxToFoot' : 'luxClosedToFoot'\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"daylightAverageValue\"\n                value=\"dSS.device.daylight_average_value\" \n                template=\"textInput\" \n                disabled=\"true\" \n                size=\"third\" \n                transform=\"dSS.device.device_type.model === 'Daylight Harvester' ? 'luxToFoot' : 'luxClosedToFoot'\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"daylightvalue\" \n                value=\"dSS.device.daylight_value\" \n                template=\"textInput\" \n                disabled=\"true\" \n                size=\"third\" \n                transform=\"dSS.device.device_type.model === 'Daylight Harvester' ? 'luxToFoot' : 'luxClosedToFoot'\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n        </div>\n\n        <device-setting\n            group=\"dSS.groupMode\"\n            is-super-user=\"dSS.isSuperUser\"\n            pending=\"dSS.ajaxPending\" \n            setting-name=\"deviceMode\" \n            value=\"dSS.settings.device_mode\" \n            template=\"buttonSelect\" \n            size=\"full\" \n            button-options=\"dSS.device.modes\" \n            on-update=\"dSS.update(setting,value,deferred)\"\n            ng-if=\"dSS.device.device_type.model === 'Dimmer'\"\n        ></device-setting>\n\n        <div ng-if=\"dSS.device.device_type.model === 'Touch'\">\n\n            <!-- Using strings instead of ints! Wahoo -->\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                value=\"dSS.settings.passcode_mode\"\n                template=\"buttonSelect\" \n                size=\"half\"\n                button-options=\"[\n                    {name: 'disabled'},\n                    {name: 'single'},\n                    {name: 'multiple'}\n                ]\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                help=\"Choose 'Single' for one master passcode. Choose 'Multiple' mode to assign individual codes per user. To set up these codes, go to the user view and enable this setting on each applicable user.\"\n                ng-if=\"dSS.firmwareSupported(dSS.device.last_firmware_version, '1.2')\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"passcodeEnabled\" \n                value=\"dSS.settings.passcode_enable\" \n                template=\"toggleA\" \n                verb-true=\"devices.passcodeEnabled\" \n                verb-false=\"devices.disabled\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"!dSS.firmwareSupported(dSS.device.last_firmware_version, '1.2')\"\n            ></device-setting>\n\n<!--             <div class=\"device-details-group half\" ng-if=\"!dSS.groupMode && dSS.settings.passcode_mode === '1'\">\n                <h3 translate=\"devices.passcode\">Passcode</h3>\n                <input type=\"text\"  ng-minlength=\"4\" ng-maxlength=\"8\"  ng-pattern=\"/^[0-9]{4,8}$/\" ng-model=\"dSS.settings.passcode\" placeholder=\"Pin\" ng-change=\"dSS.debounceUpdate('passcode',dSS.settings.passcode)\" />\n            </div> -->\n\n            <!-- Passcode has to be text input to allow 0000 as pin code -->\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                value=\"dSS.settings.passcode\" \n                template=\"textInput\" \n                placeholder=\"1234\" \n                size=\"half\"\n                min=\"0\" \n                max=\"99999999\"\n                validate=\"/^[0-9]{4,8}$/\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n                ng-if=\"!dSS.groupMode && (dSS.firmwareSupported(dSS.device.last_firmware_version, '1.2') && dSS.settings.passcode_mode === 'single') || (!dSS.firmwareSupported(dSS.device.last_firmware_version, '1.2') && dSS.settings.passcode_enable)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"mainTitle\" \n                value=\"dSS.settings.title\" \n                template=\"textInput\" \n                size=\"half\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"subTitle\" \n                value=\"dSS.settings.subtitle\" \n                template=\"textInput\" \n                size=\"half\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"screenBrightness\" \n                value=\"dSS.settings.screen_brightness\" \n                template=\"range\"\n                button-options=\"[\n                    {value: 0},\n                    {value: 10},\n                    {value: 20},\n                    {value: 30},\n                    {value: 40},\n                    {value: 50},\n                    {value: 60},\n                    {value: 70},\n                    {value: 80},\n                    {value: 90},\n                    {value: 100}\n                ]\"\n                min=\"0\"\n                max=\"100\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\" \n                setting-name=\"screenLockTimeout\" \n                value=\"dSS.settings.screen_lock_timeout\" \n                template=\"select\"\n                button-options=\"[\n                    {name: '30 Seconds',    value: 00},\n                    {name: '1 min',         value: 01},\n                    {name: '2 min',         value: 02},\n                    {name: '5 min',         value: 05},\n                    {name: '10 min',        value: 10},\n                    {name: '30 min',        value: 30},\n                    {name: 'Never Sleep',   value: 255}\n                ]\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            ></device-setting>\n\n        </div>\n\n        <!--advanced trigger mode-->\n        <div class=\"left full\" ng-if=\"dSS.settings.device_mode === 'advance_trigger' || dSS.settings.device_mode === 'advance_trigger_no_actuator'\">\n            <device-setting\n                group=\"dSS.groupMode\"\n                pending=\"dSS.ajaxPending\"\n                setting-name=\"timeout\"\n                value=\"dSS.settings.turn_off_time_delay\"\n                size=\"full\"\n                max=\"30\"\n                unit=\"mins\"\n                is-super-user=\"dSS.isSuperUser\"\n                template=\"sliderWithCustomizedValue\"\n                threshold=\"30\"\n                customizedmax=\"240\"\n                on-update=\"dSS.update(setting,value,deferred)\"\n            >\n            </device-setting>\n\n            <div class=\"device-details-group full sensitivity\">\n\n                <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\" \n                    setting-name=\"whenOccupied\" \n                    value=\"dSS.settings.occupied_dimmer_level\" \n                    template=\"sliderToggle\" \n                    size=\"full\" \n                    unit=\"%\"\n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"dSS.settings.device_mode === 'advance_trigger'\"\n                ></device-setting>\n\n                <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\" \n                    setting-name=\"whenUnoccupied\" \n                    value=\"dSS.settings.unoccupied_dimmer_level\" \n                    template=\"sliderToggle\" \n                    size=\"full\" \n                    unit=\"%\"\n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"dSS.settings.device_mode === 'advance_trigger'\"\n                ></device-setting>\n\n                <!-- Blink settings disabled in group mode - they set a bunch of nutty defaults -->\n                <!-- <device-setting\n                    group=\"dSS.groupMode\"\n                    pending=\"dSS.ajaxPending\"\n                    disabled=\"dSS.groupMode\"\n                    setting-name=\"blinkBeforeUnoccupied\"\n                    value=\"dSS.settings.blink_number\"\n                    template=\"wrappedToggle\"\n                    size=\"full\"\n                    on-update=\"dSS.update(setting,value,deferred)\"\n                    ng-if=\"!dSS.groupMode && (!(dSS.settings.device_mode === 'advance_trigger_no_actuator') || dSS.firmwareSupported(dSS.device.last_firmware_version, '1.29'))\"\n                    settings=\"dSS.settings\"\n                ></device-setting> -->\n            </div>\n\n        </div>\n\n    <!--end of advanced trigger mode-->\n</section>";
});
$__System.register('1ac', ['1aa', '1ab'], function (_export) {
    var _Number$isInteger, devicesSectionSettingsComponentTmpl, devicesSectionSettingsComponent;

    return {
        setters: [function (_aa) {
            _Number$isInteger = _aa['default'];
        }, function (_ab) {
            devicesSectionSettingsComponentTmpl = _ab['default'];
        }],
        execute: function () {
            'use strict';

            devicesSectionSettingsComponent = {
                template: devicesSectionSettingsComponentTmpl,
                bindings: {
                    ajaxPending: '<',
                    device: '<',
                    isSuperUser: '<',
                    settings: '<',
                    groupMode: '<',
                    onSettingChange: '&?'
                },
                controllerAs: 'dSS',
                controller: function controller(LcFn, $q, _) {
                    var dSS = this;

                    dSS.$onInit = function () {
                        dSS.settings.last_saved_unoccupied_dimmer_level = dSS.settings.unoccupied_dimmer_level || 100;

                        var timeout = parseInt(dSS.settings.screen_lock_timeout, 10);
                        if (_Number$isInteger(timeout) && timeout >= 0) {
                            dSS.settings.screen_lock_timeout = timeout.toString();
                        } else {
                            dSS.settings.screen_lock_timeout = '255'; // 255 is the default value for screen lock timeout
                        }
                        //
                        // Start with this field dropped
                        //
                        dSS.drop = true;

                        /*
                            Front-end defaults from hell
                         */

                        //special treatment for power monitoring frequency, need to remove when we get power monitoring back to position
                        if ((dSS.device.isSensor || dSS.device.isControllerType) && !dSS.settings.power_report_frequency) {
                            dSS.settings.power_report_frequency = LcFn.defaults.powerReportFrequency;
                        }
                        //special treatment for power monitoring frequency
                        if (dSS.settings.hasOwnProperty('power_report_frequency') && !dSS.settings.power_report_frequency) {
                            dSS.settings.power_report_frequency = LcFn.defaults.powerReportFrequency;
                        }
                        //special treatment for when occupied - still needed for occupied_dimmer_level?
                        // if (dSS.settings.hasOwnProperty('max_dimmer_level') && !dSS.settings.max_dimmer_level) {
                        //     dSS.settings.max_dimmer_level = 100;
                        // }
                        //special treatment for timeout
                        if (dSS.settings.hasOwnProperty('turn_off_time_delay') && !dSS.settings.turn_off_time_delay) {
                            dSS.settings.turn_off_time_delay = LcFn.defaults.turnOffTimeDelay;
                        }
                    };

                    dSS.debounceUpdate = _.debounce(update, 500);

                    dSS.update = update;

                    dSS.firmwareSupported = function (deviceLastVersion, minVersion) {
                        return !LcFn.ltVersion(deviceLastVersion, minVersion);
                    };

                    function update(setting, value, deferred) {
                        dSS.onSettingChange({ device: dSS.device, settingChange: { setting: setting, value: value }, deferred: deferred });
                    }
                }
            };

            _export('default', devicesSectionSettingsComponent);
        }
    };
});

$__System.registerDynamic("1ad", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading drop\" ng-class=\"{dropped: dSSA.drop}\" ng-click=\"dSSA.drop = !dSSA.drop;\">\n    <span>Advanced Device Settings</span>\n</h2>\n\n<section class=\"devices-section-inner full main-body\" ng-if=\"dSSA.drop;\">\n\n    <div class=\"device-details-group half\"\n        ng-if=\"!dSSA.displayCalibration && !dSSA.device.isLcSense && !dSSA.device.isSensor && !dSSA.device.isControllerType\"\n    ><h3>No Advanced Settings For This Device</h3></div>\n\n    <div class=\"device-details-group half calibration\" ng-if=\"dSSA.displayCalibration\">\n        <h3><span translate=\"devices.calibrateEnergy\">calibrate energy</span></h3>\n        <button class=\"btn blue check\" translate=\"devices.startCalibration\" ng-click=\"dSSA.calibrate(dSSA.device.deviceZones[0].id)\" ng-disabled=\"dSSA.device.calibrationDisabled\">{{ dSSA.calibrateTitle}}</button>\n        <button class=\"btn blue check\" translate=\"devices.clearCalibration\" ng-click=\"dSSA.clearCalibrate(dSSA.device.deviceZones[0].id)\" ng-disabled=\"dSSA.device.clearCalibrationDisabled\">{{ dSSA.clearCalibrateTitle}}</button>\n        <span class=\"gray calibrate-energy\" ng-if=\"dSSA.calibrateResult\">{{ dSSA.calibrateProcess}}</span>\n        <h3 class=\"calibrate-energy-subtitle\"><span translate=\"devices.fullPowerReading\">full power reading</span></h3>\n        <span class=\"gray\" ng-if=\"dSSA.device.deviceZones[0]\">{{dSSA.device.deviceZones[0].full_power_reading ? dSSA.device.deviceZones[0].full_power_reading : dSSA.device.deviceZones[0].power_draws_by_decile_as_dictionary[100]}}</span>\n        <h3 class=\"calibrate-energy-subtitle\"><span translate=\"devices.powerDrawsByDecile\">power draws by decile</span></h3>\n        <span class=\"gray\" ng-if=\"dSSA.device.deviceZones[0] && dSSA.device.deviceZones[0].power_draws_by_decile_as_dictionary\">\n            <p>\n                <span ng-repeat=\"(key,value) in dSSA.device.deviceZones[0].power_draws_by_decile_as_dictionary\">\n                    {{key}}: {{value}};\n                </span>\n            </p>\n        </span>\n    </div>\n\n    <device-setting\n        group=\"dSSA.groupMode\"\n        value=\"dSSA.device.has_sense\" \n        setting-name=\"hasSensorToggle\"\n        template=\"toggleA\"\n        on-update=\"dSSA.update(setting,value,deferred)\"\n        settings=\"dSSA.settings\"\n        ng-if=\"dSSA.device.isLcSense\"\n    ></device-setting>\n    <!-- \n        LcSense controller-like devices need als when 'has_sense' is enabled \n    -->\n    <device-setting\n        group=\"dSSA.groupMode\" \n        setting-name=\"alsReport\" \n        value=\"dSSA.settings.als_report_enable\" \n        template=\"toggleA\"\n        on-update=\"dSSA.update(setting,value,deferred)\"\n        ng-if=\"(dSSA.device.isLcSense && dSSA.device.has_sense) || dSSA.device.device_type.model === 'Twistlock'\"\n    ></device-setting>\n    \n    <div ng-if=\"dSSA.device.isSensor || dSSA.device.isControllerType\">\n\n        <!-- Hidden Jason 9/24 \n        <device-setting\n            group=\"dSSA.groupMode\" \n            setting-name=\"dimmingCurve\" \n            value=\"dSSA.settings.dimming_curve_type\" \n            template=\"buttonSelect\" \n            size=\"full\" \n            button-options=\"[{name:'linear'},{name: 'square'},{name:'square_root'}]\"\n            ng-if=\"dSSA.device.isDimmable\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n        ></device-setting>\n        -->\n\n        <device-setting\n            group=\"dSSA.groupMode\"\n            setting-name=\"powerReportInterval\"\n            value=\"dSSA.settings.power_report_frequency\"\n            template=\"numInput\"\n            max=\"1440\"\n            unit=\"mins\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSSA.groupMode\"\n            value=\"dSSA.settings.heartbeat_timeout\" \n            setting-name=\"lostSignalEnable\"\n            template=\"toggleA\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n            settings=\"dSSA.settings\"\n            ng-if=\"dSSA.showLostSignalState\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSSA.groupMode\"\n            parent-id=\"dSSA.device.id\"\n            setting-name=\"lostSignal\" \n            value=\"dSSA.settings.heartbeat_missed_state\" \n            template=\"buttonSelect\" \n            size=\"full\"\n            button-options=\"[\n                {   \n                    name        : 'last',\n                    value       : 0\n                },\n                {\n                    name        : 'last_on',\n                    value       : 1\n                },\n                {\n                    name        : 'custom',\n                    conditions  : {\n                        zoneDimmable: true\n                    },\n                    value       : 2\n                },\n                {\n                    name        : 'off',\n                    value       : 3\n                },\n                {\n                    name        : 'ALSTrigger',\n                    conditions  : {\n                        supportedDeviceTypes: [\n                            {\n                                lcp_type: 21,\n                                name    : 'Twistlock'\n                            }\n                        ]\n                    },\n                    value       : 4\n                }\n            ]\"\n            lcp-type=\"dSSA.device.device_type.lcp_type\"\n            zones=\"dSSA.device.deviceZones\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n            ng-if=\"dSSA.settings.heartbeat_timeout\"\n            help=\"When gateway signal is lost, device will: 1) enter the last state it was in when it lost signal (on or off), 2) turn ON, at the last level it was at when it lost signal, 3) turn ON at the specified level or 4) turn OFF\"            \n        ></device-setting>\n\n        <device-setting\n            group=\"dSSA.groupMode\"\n            pending=\"dSSA.ajaxPending\" \n            setting-name=\"lostSignalDimLevel\" \n            value=\"dSSA.settings.heartbeat_missed_light_level\"\n            template=\"slider\" \n            size=\"full\" \n            unit=\"%\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n            ng-show=\"dSSA.settings.heartbeat_missed_state === 2\"\n        ></device-setting>\n\n        <!--\n\n        <device-setting\n            group=\"dSSA.groupMode\"\n            parent-id=\"dSSA.device.id\"\n            setting-name=\"powerUpState\" \n            value=\"dSSA.settings.default_actuator_state\" \n            template=\"toggleB\" \n            verb-true=\"Lights On\" \n            verb-false=\"Lights Off\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n        ></device-setting>\n\n        -->\n    </div>\n\n    <div ng-show=\"dSSA.device.isSensor\">\n\n        <device-setting\n            group=\"dSSA.groupMode\" \n            setting-name=\"alsReport\" \n            value=\"dSSA.settings.als_report_enable\" \n            template=\"toggleA\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n            ng-if=\"!dSSA.device.isLcSense && !dSSA.device.has_sense && dSSA.device.device_type.model !== 'Twistlock'\"\n        ></device-setting>\n \n        <device-setting\n            group=\"dSSA.groupMode\" \n            setting-name=\"ambientLightSensorSensitivity\" \n            value=\"dSSA.settings.als_sensitivity\" \n            template=\"range\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <device-setting\n            group=\"dSSA.groupMode\" \n            setting-name=\"temperatureSensor\" \n            value=\"dSSA.settings.temp_sensor_report_enable\" \n            template=\"toggleA\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n        ></device-setting>\n\n        <!--duplicate of new microphone sensor settings-->\n        <device-setting\n            group=\"dSSA.groupMode\"\n            setting-name=\"micEnable\"\n            value=\"dSSA.settings.mic_enable\"\n            template=\"toggleA\"\n            on-update=\"dSSA.update(setting,value,deferred)\"\n            ng-show=\"dSSA.firmwareSupported(dSSA.device.last_firmware_version,'1.35')\"\n        ></device-setting>\n        <device-setting\n            group=\"dSSA.groupMode\" \n            labels=\"sliderLabels\"\n            setting-name=\"microphoneSensor\"\n            switch=\"dSSA.settings.mic_enable\"\n            template=\"numInput\"\n            unit=\"\"\n            validate=\"/^[0-9]*$/\"\n            value=\"dSSA.settings.mic_sensitivity\"\n            ng-init=\"!dSSA.settings.mic_sensitivity ? dSSA.settings.mic_sensitivity = 3500 : false\"\n            ng-if=\"dSSA.firmwareSupported(dSSA.device.last_firmware_version,'1.35') && dSSA.settings.mic_enable\"\n            max=\"65535\"\n            min=\"0\"       \n            on-update=\"dSSA.update(setting,value,deferred)\" \n        ></device-setting>\n    <!--<device-setting\n        group=\"dSSA.groupMode\"\n            setting-name=\"microphoneSensor\"\n            value=\"micSensitivityMappingSlider\"\n            template=\"sliderToggleWithScale\"\n            switch=\"dSSA.settings.mic_enable\"\n            size=\"full\"\n            labels=\"sliderLabels\"\n            func=\"mapSlider\"\n            unit=\"ft\"\n            ng-show=\"dSSA.firmwareSupported('1.35')\"\n    ></device-setting>-->\n    </div>\n\n</section>\n";
});
$__System.register('1ae', ['1ad'], function (_export) {
  'use strict';

  var devicesSectionSettingsAdvancedComponentTmpl, devicesSectionSettingsAdvancedComponent;
  return {
    setters: [function (_ad) {
      devicesSectionSettingsAdvancedComponentTmpl = _ad['default'];
    }],
    execute: function () {
      devicesSectionSettingsAdvancedComponent = {
        template: devicesSectionSettingsAdvancedComponentTmpl,
        bindings: {
          device: '<',
          groupMode: '<',
          isSuperUser: '<',
          settings: '<',
          showLostSignalState: '<',
          onFirmwareStatus: '&?',
          onSettingChange: '&?'
        },
        controllerAs: 'dSSA',
        controller: function controller(Zones, LcFn, $scope, $timeout, Modals) {

          var dSSA = this;

          dSSA.$onInit = function () {
            dSSA.displayCalibration = dSSA.device.isActuator && !dSSA.groupMode && dSSA.device.deviceZones.length;
            dSSA.calibrateTitle = 'Start Calibration';
            dSSA.clearCalibrateTitle = 'Clear Calibration';
            dSSA.calibrateProcess = '';
            dSSA.calibrateResult = null;

            dSSA.calibrationStatusSocketListener = $scope.$on('event:socket:calibrationStatus', function (event, calibrationDisabled, timestamp) {
              dSSA.device.calibrationDisabled = calibrationDisabled;
              $timeout(function () {
                $scope.$apply();
              });
            });
          };

          dSSA.$onDestroy = function () {
            dSSA.calibrationStatusSocketListener();
          };

          dSSA.calibrate = function (zoneId) {
            dSSA.device.calibrationDisabled = true;

            dSSA.calibrateTitle = 'In Process...';

            Zones.calibration(zoneId).then(function (result) {

              dSSA.calibrateResult = result.data.info;

              dSSA.calibrateTitle = 'Start Calibration';

              dSSA.calibrateProcess = dSSA.calibrateResult ? 'calibration started' : 'calibration failed';
            });
          };

          dSSA.clearCalibrate = function (zoneId) {
            Modals.openLoad('Clear calibration is in progress.');
            dSSA.device.clearCalibrationDisabled = true;
            dSSA.clearCalibrateTitle = 'In Process...';
            Zones.clearCalibration(zoneId).then(function (result) {
              if (result.status == 204) {
                dSSA.device.deviceZones[0].full_power_reading = null;
                dSSA.device.deviceZones[0].power_draws_by_decile_as_dictionary = {};
                Modals.closeLoad('Cleared calibration successfully!', true);
              } else {
                Modals.closeLoad('Failed to clear calibration.');
              }
            })['catch'](function () {
              Modals.closeLoad('Failed to clear calibration.');
            })['finally'](function () {
              dSSA.device.clearCalibrationDisabled = false;
              dSSA.clearCalibrateTitle = 'Clear Calibration';
            });
          };

          dSSA.update = function (setting, value, deferred) {
            dSSA.onSettingChange({ device: dSSA.device, settingChange: { setting: setting, value: value }, deferred: deferred });
          };

          dSSA.upgrade = function () {
            dSSA.device.upgrade().then(function (device) {
              dSSA.device = device;
              dSSA.onFirmwareStatus({ device: device });
            });
          };

          dSSA.firmwareSupported = function (deviceLastVersion, minVersion) {
            return !LcFn.ltVersion(deviceLastVersion, minVersion);
          };
        }
      };

      _export('default', devicesSectionSettingsAdvancedComponent);
    }
  };
});

$__System.register('1af', [], function (_export) {
    'use strict';

    var devicesSectionZonesComponent;
    return {
        setters: [],
        execute: function () {
            devicesSectionZonesComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dSZ.drop}" ng-click="dSZ.drop = !dSZ.drop;">\n            <span translate="zones.zones">Zones</span>\n        </h2>\n\n        <div class="white-pill-item animated" ng-if="dSZ.drop;">\n\n            <i \n                ng-click="dSZ.dismissAlert(dSZ.zones[0])"\n                ng-if="dSZ.zones.length === 1 && dSZ.zones[0].controller_health_flagged && dSZ.device.settings.power_report"\n                class="help-icon"\n                id="fault-notification-icon" \n                help \n                data-help-div="fault-detected"\n            ></i>\n\n            <div class="help" id="fault-detected">\n                <div class="arrow"></div>\n                <p translate="zones.faultDescription">There is a fault detected in this Zone. If you want to dismiss this alert, click here.</p>\n            </div>\n\n            <h1 class="name">\n                <span ng-repeat="zone in dSZ.zones">\n                    {{::zone.id_string}}<span class="greyed" ng-if="::dSZ.isSuperUser"> - ID:{{::zone.id}}</span>\n                    <span ng-if="dSZ.zones.length > 1 && $index !== dSZ.zones.length -1">, </span>\n                </span>\n            </h1>\n              \n            <button class="btn black edit" ng-click="dSZ.zones[0].showZoneSettings = !dSZ.zones[0].showZoneSettings" translate="common.edit">Edit</button>\n\n            <button class="btn green indicate" ng-class="{indicating: dSZ.groupIndicating}" ng-disabled="dSZ.zones[0].ajaxPending || dSZ.groupIndicating" ng-click="dSZ.indicate(dSZ.zones)" translate="common.indicate">Indicate</button>\n            <h3 class="grey" ng-if="dSZ.zones[0].visible_in_control">{{dSZ.zones[0].areaName ? \'Area: \' + dSZ.zones[0].areaName : \'\'}}</h3>\n            <h3 class="grey disabled" ng-if="!dSZ.zones[0].visible_in_control">Manually Disabled</h3>\n\n            <devices-section-zone-settings \n                device="dSZ.device"\n                group-mode="dSZ.zones.length > 1"\n                is-super-user="dSZ.isSuperUser"\n                zone="dSZ.zones[0]" \n                ng-if="dSZ.zones[0].showZoneSettings" \n                on-setting-change="dSZ.onSettingChange({zones:dSZ.zones[0],settingChange:settingChange,deferred:deferred})"\n            ></devices-section-zone-settings>\n\n        </div>\n    ',
                bindings: {
                    device: '<',
                    isSuperUser: '<',
                    zones: '<',
                    onSettingChange: '&'
                },
                controllerAs: 'dSZ',
                controller: function controller($rootScope, Modals, Zone, Zones, $timeout, $q, Devices, _) {

                    var dSZ = this;

                    dSZ.$onInit = function () {
                        //
                        // Drop by default for now
                        //
                        dSZ.drop = true;
                    };

                    // dSZ.$onChanges = function(changes){
                    //     //
                    //     console.log('dSZ Changes');
                    //     console.log(changes);
                    // };

                    dSZ.$onDestroy = function () {
                        if (dSZ.blockIndicate) {
                            $timeout.cancel(dSZ.blockIndicate);
                        }
                    };

                    dSZ.dismissAlert = function (zone) {
                        Modals.confirm($rootScope, 'Cancel', 'Dismiss', 'Are you sure about dismissing this alert?').then(function () {
                            Modals.openLoad('Deleting');
                            Zones.clearFaultNotification(zone.id).then(function () {
                                Modals.closeLoad('Success', true);
                                zone.controller_health_flagged = false;
                            })['catch'](function (err) {
                                console.log(err);
                                Modals.closeLoad('Failed', false);
                            });
                        });
                    };

                    dSZ.indicate = function (zones) {
                        dSZ.groupIndicating = true;

                        var groupIndication = _.map(zones, function (zone) {
                            return Devices.indicate(zone.node);
                        });

                        $q.all(groupIndication).then(function () {
                            dSZ.blockIndicate = $timeout(function () {
                                dSZ.groupIndicating = false;
                            }, 30000);
                        });
                    };
                }
            };

            _export('default', devicesSectionZonesComponent);
        }
    };
});

$__System.registerDynamic("1b0", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"devices-section-inner zones main-body\" ng-class=\"{disabled: !dSZS.zone.visible_in_control}\">\n    \n    <device-setting\n        class=\"always-enabled\"\n        group=\"dSZS.groupMode\"\n        value=\"dSZS.zone.visible_in_control\"\n        template=\"toggleA\"\n        verb-true=\"Enabled\"\n        verb-false=\"Disabled\"\n        size=\"full\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n    ></device-setting>\n    \n    <device-setting\n        group=\"dSZS.groupMode\" \n        value=\"dSZS.zone.id_string\" \n        template=\"textInput\" \n        placeholder=\"{{zones.zoneName | translate}}\" \n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"!dSZS.groupMode\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\" \n        value=\"dSZS.zone.watts\" \n        template=\"strictPositiveNumInput\" \n        placeholder=\"0\" \n        min=\"0\"\n        max=\"Number.MAX_VALUE\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\" \n        value=\"dSZS.zone.panel\" \n        template=\"textInput\" \n        placeholder=\"e.g. LP-16\" \n        on-update=\"dSZS.update(setting,value,deferred)\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\" \n        value=\"dSZS.zone.baseline_wattage\" \n        template=\"strictPositiveNumInput\" \n        placeholder=\"0\" \n        min=\"0\"\n        max=\"Number.MAX_VALUE\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.isSuperUser\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\" \n        setting-name=\"dimming\" \n        value=\"dSZS.zone.is_dimmable\" \n        template=\"toggleA\" \n        verb-true=\"On\"\n        verb-false=\"Off\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.device.isDimmable\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\"\n        value=\"dSZS.zone.fixture_health_detection\"\n        setting-name=\"faultDetection\"\n        template=\"toggleA\"\n        verb-true=\"On\"\n        verb-false=\"Off\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.device.settings.power_report\"\n    ></device-setting>\n\n    <!-- Removed per Linda \t\n\t<device-setting\n        group=\"dSZS.groupMode\"\n        value=\"dSZS.zone.emergency_mode\"\n        setting-name=\"emergencyMode\"\n        template=\"toggleA\" \n        verb-true=\"On\"\n        verb-false=\"Off\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n    ></device-setting>\n    -->\n    \n    <device-setting\n        group=\"dSZS.groupMode\"\n        setting-name=\"actionBtn\"\n        action-title=\"reset\"\n        template=\"actionBtn\"\n        action-name=\"dSZS.resetFaultData()\"\n        help=\"Reset the power data\"\n        ng-if=\"dSZS.zone.fixture_health_detection && !dSZS.groupMode\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\"\n        setting-name=\"maxTrimLevel\"\n        value=\"dSZS.zone.trim_high\"\n        min=\"1\"\n        max=\"100\"\n        template=\"slider\"\n        size=\"full\"\n        unit=\"%\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.zone.is_dimmable\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\"\n        value=\"dSZS.zone.manual_override_length\"\n        min=\"0\"\n        max=\"270\"\n        placeholder=\"0 to 270\"\n        setting-name=\"manualOverride\"\n        template=\"toggleTextInput\"\n        size=\"half\"\n        verb-true=\"On\"\n        verb-false=\"Off\"\n        unit=\"mins\"\n        help=\"Allows control of this zone to be overridden by a Dimmer, by the web or mobile apps, etc. Set how long this zone can be overridden.\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.firmwareSupported('1.5.0.30')\"\n    ></device-setting>\n\n    <device-setting\n        group=\"dSZS.groupMode\"\n        value=\"dSZS.zone.manual_override_restore_state\"\n        template=\"buttonSelect\"              \n        button-options=\"[\n            {name: 'return',    value: 0},\n            {name: 'remain',    value: 1}\n        ]\"\n        help=\"What the zone does at the end of the override period, either revert to normally scheduled behavior, or remain in the same state.\"\n        on-update=\"dSZS.update(setting,value,deferred)\"\n        ng-if=\"dSZS.firmwareSupported('1.5.0.30') && dSZS.zone.manual_override_length !== 0\"\n    ></device-setting>\n\n</section>";
});
$__System.register('1b1', ['1b0'], function (_export) {
    'use strict';

    var devicesSectionZoneSettingsComponentTmpl, devicesSectionZoneSettingsComponent;
    return {
        setters: [function (_b0) {
            devicesSectionZoneSettingsComponentTmpl = _b0['default'];
        }],
        execute: function () {
            devicesSectionZoneSettingsComponent = {
                template: devicesSectionZoneSettingsComponentTmpl,
                bindings: {
                    device: '<',
                    groupMode: '<',
                    isSuperUser: '<',
                    zone: '<',
                    onSettingChange: '&?'
                },
                controllerAs: 'dSZS',
                controller: function controller(Zones, LcFn, Modals, $q) {
                    var dSZS = this;

                    dSZS.$onInit = function () {
                        //
                    };

                    // dSZS.$onChanges = function(changes){
                    //     //
                    //     console.log('dSZSC Changes');
                    //     console.log(changes);
                    // };

                    dSZS.update = function (setting, value, deferred) {
                        //
                        // Added to accomodate yuchao's ng-change hack
                        //
                        console.log(setting);
                        if (setting) {
                            dSZS.onSettingChange({ zone: dSZS.zone, settingChange: { setting: setting, value: value }, deferred: deferred });
                        }
                    };

                    dSZS.firmwareSupported = function (deviceLastVersion, minVersion) {
                        return !LcFn.ltVersion(deviceLastVersion, minVersion);
                    };

                    dSZS.resetFaultData = function () {
                        Modals.openLoad('Resetting  fault data...');
                        Zones.clearFaultNotification(dSZS.zone.id).success(function () {
                            Modals.closeLoad('Resetting fault data successful', true);
                        }).error(function (err) {
                            console.log(err);
                            Modals.closeLoad('Resetting fault data failed', false);
                        });
                    };
                }
            };

            _export('default', devicesSectionZoneSettingsComponent);
        }
    };
});

$__System.register('1b2', ['19a', '19b', '19c', '19d', '19e', '19f', '1a1', '1a3', '1a4', '1a5', '1ac', '1ae', '1af', '1b1'], function (_export) {

    /* Overview Sections */
    'use strict';var devicesSectionInfoComponent, devicesSectionProductInfoComponent, devicesSectionProductImageComponent, devicesSectionActivityComponent, devicesSectionUpdateStatusComponent, devicesSectionUpdateVersionComponent, devicesSectionControlComponent, devicesSectionControlMultiComponent, controlButtonActionListComponent, devicesSectionGroupActionsComponent, devicesSectionSettingsComponent, devicesSectionSettingsAdvancedComponent, devicesSectionZonesComponent, devicesSectionZoneSettingsComponent;
    return {
        setters: [function (_a) {
            devicesSectionInfoComponent = _a['default'];
        }, function (_b) {
            devicesSectionProductInfoComponent = _b['default'];
        }, function (_c) {
            devicesSectionProductImageComponent = _c['default'];
        }, function (_d) {
            devicesSectionActivityComponent = _d['default'];
        }, function (_e) {
            devicesSectionUpdateStatusComponent = _e['default'];
        }, function (_f) {
            devicesSectionUpdateVersionComponent = _f['default'];
        }, function (_a1) {
            devicesSectionControlComponent = _a1['default'];
        }, function (_a3) {
            devicesSectionControlMultiComponent = _a3['default'];
        }, function (_a4) {
            controlButtonActionListComponent = _a4['default'];
        }, function (_a5) {
            devicesSectionGroupActionsComponent = _a5['default'];
        }, function (_ac) {
            devicesSectionSettingsComponent = _ac['default'];
        }, function (_ae) {
            devicesSectionSettingsAdvancedComponent = _ae['default'];
        }, function (_af) {
            devicesSectionZonesComponent = _af['default'];
        }, function (_b1) {
            devicesSectionZoneSettingsComponent = _b1['default'];
        }],
        execute: function () {

            angular.module('admin-devices-sections', [])

            /* Base Devices View Sections*/
            .component('devicesSectionInfo', devicesSectionInfoComponent).component('devicesSectionProductInfo', devicesSectionProductInfoComponent).component('devicesSectionProductImage', devicesSectionProductImageComponent).component('devicesSectionActivity', devicesSectionActivityComponent).component('devicesSectionUpdateStatus', devicesSectionUpdateStatusComponent).component('devicesSectionUpdateVersion', devicesSectionUpdateVersionComponent).component('devicesSectionControl', devicesSectionControlComponent).component('devicesSectionControlMulti', devicesSectionControlMultiComponent).component('controlButtonActionList', controlButtonActionListComponent).component('devicesSectionGroupActions', devicesSectionGroupActionsComponent).component('devicesSectionSettings', devicesSectionSettingsComponent).component('devicesSectionSettingsAdvanced', devicesSectionSettingsAdvancedComponent).component('devicesSectionZones', devicesSectionZonesComponent).component('devicesSectionZoneSettings', devicesSectionZoneSettingsComponent);
        }
    };
});

$__System.register('1b3', [], function (_export) {
    'use strict';

    var masterUpdatesBaseComponent;
    return {
        setters: [],
        execute: function () {
            masterUpdatesBaseComponent = {
                template: '\n        <div class="devices-wrapper gutters">\n            \n            <devices-update-summary class="main-body" update-status="mUB.sessionData.updateStatus"></devices-update-summary>\n\n            <devices-update-status-bar-list class="main-body" devices="mUB.sessionData.devices" update-status="mUB.sessionData.updateStatus"></devices-update-status-bar-list>\n\n            <devices-update-version-summary class="main-body" devices="mUB.sessionData.devices"></devices-update-version-summary>\n\n<!--            <devices-update-legacy class="main-body" update-set="mUB.groupSelection" devices="mUB.sessionData.devices"></devices-update-legacy> -->\n\n            <master-updates-global-view class="main-body" ng-if="mUB.user.is_superuser"></master-updates-global-view>\n\n        </div>\n    ',
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    onSelectionUpdate: '&?',
                    user: '<'
                },
                controllerAs: 'mUB',
                controller: function controller() {

                    var mUB = this;

                    mUB.$onInit = function () {
                        mUB.onSelectionUpdate({ selection: mUB.itemCollection });

                        prepareViewContext(mUB.itemCollection);
                    };

                    mUB.$onChanges = function (changes) {
                        console.log('automations base changes');
                        console.log(changes);
                    };

                    // mUB.navigate = function(destinationId){
                    //     //go to that automation after creation
                    //     let filter = destinationId ? ['selection~'+destinationId] : null;
                    //     $state.go('automations',{siteId:mUB.sessionData.id, userSelectedFilter: filter});
                    // };

                    function prepareViewContext(itemCollection) {
                        //Base View if filtered false
                        if (itemCollection.filtered) {
                            // No different single selection
                            mUB.groupSelection = itemCollection.group;
                        }

                        if (itemCollection['new']) {
                            mUB.blankAutomationSet = [];
                        }
                    }
                }
            };

            _export('default', masterUpdatesBaseComponent);
        }
    };
});

$__System.register('1b4', [], function (_export) {
    'use strict';

    var masterUpdatesGlobalViewComponent;
    return {
        setters: [],
        execute: function () {
            masterUpdatesGlobalViewComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: mUGV.drop}" ng-click="mUGV.drop = !mUGV.drop;">\n            <span translate="updates.globalFirmwareVersionSummary">Global Firmware Version Summary</span>\n        </h2>\n\n        <section class="main-body" ng-if="mUGV.drop;">\n\n            <button translate="updates.retrieveGlobal" class="btn" ng-if="!mUGV.globalUpdates" ng-disabled="mUGV.ajaxPending" ng-click="mUGV.getGlobal();">Retrieve Global Update Status (can take a while)</button>\n\n            <devices-update-version-boxes ng-if="mUGV.globalUpdates" versions="mUGV.globalUpdates"></devices-update-version-boxes>\n\n        </section>\n    ',
                bindings: {
                    //
                },
                controllerAs: 'mUGV',
                controller: function controller(Devices) {

                    var mUGV = this;

                    mUGV.$onInit = function () {
                        //
                    };

                    mUGV.getGlobal = function () {
                        getGlobalUpdates().then(function (response) {
                            mUGV.globalUpdates = parseGlobal(response);
                        });
                    };

                    function getGlobalUpdates() {
                        mUGV.ajaxPending = true;

                        return Devices.getGlobalUpdateInfo().then(function (result) {
                            mUGV.ajaxPending = false;

                            return result;
                        });
                    }

                    function parseGlobal(data) {
                        return data;
                    }
                }
            };

            _export('default', masterUpdatesGlobalViewComponent);
        }
    };
});

$__System.register('1b5', [], function (_export) {
    'use strict';

    var devicesUpdateSummaryComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateSummaryComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dUSB.drop}" ng-click="dUSB.drop = !dUSB.drop;">\n            <span translate="">Site Devices Firmware Version Summary</span>\n        </h2>\n\n        <section class="" ng-if="dUSB.drop;">\n\n            <section class="quarter">\n                <h2 class="overview-heading">\n                    <span translate="updates.upToDate">Up to date</span>\n                </h2>\n                <h1>{{dUSB.parsedUpdateStatus[\'UP-TO-DATE\'] ? dUSB.parsedUpdateStatus[\'UP-TO-DATE\'].length : \'0\'}}</h1>\n            </section>\n\n            <section class="quarter">\n                <h2 class="overview-heading">\n                    <span translate="updates.upgradeAvailable">Update available</span>\n                </h2>\n                <h1>{{dUSB.parsedUpdateStatus[\'NOT-UP-TO-DATE\'] ? dUSB.parsedUpdateStatus[\'NOT-UP-TO-DATE\'].length : \'0\'}}</h1>\n                <button class="updates-button" ng-if="dUSB.parsedUpdateStatus[\'NOT-UP-TO-DATE\'].length > 0">Update All</button>\n            </section>\n\n            <section class="quarter">\n                <h2 class="overview-heading">\n                    <span translate="updates.inProgress">In progress</span>\n                </h2>\n                <h1>{{dUSB.parsedUpdateStatus[\'IN-PROGRESS\'] ? dUSB.parsedUpdateStatus[\'IN-PROGRESS\'].length : \'0\'}}</h1>\n            </section>\n\n            <section class="quarter">\n                <h2 class="overview-heading">\n                    <span translate="updates.failed">Failed</span>\n                </h2>\n                <h1>{{dUSB.parsedUpdateStatus[\'FAILED\'] ? dUSB.parsedUpdateStatus[\'FAILED\'].length : \'0\'}}</h1>\n                <button class="updates-button" ng-if="dUSB.parsedUpdateStatus[\'FAILED\'].length > 0">Retry</button>\n            </section>\n        </section>\n    ',
                bindings: {
                    updateStatus: '<'
                },
                controllerAs: 'dUSB',
                controller: function controller(_) {

                    var dUSB = this;

                    dUSB.$onInit = function () {
                        dUSB.parsedUpdateStatus = parseStatusSummary(dUSB.updateStatus);
                    };

                    dUSB.$onChanges = function (changes) {};

                    function parseStatusSummary(statusCollection) {
                        return _.map(statusCollection.nodes, function (val, key) {
                            return { node: key, status: val };
                        }).reduce(function (r, a) {
                            r[a.status] = r[a.status] || [];
                            r[a.status].push(parseInt(a.node));
                            return r;
                        }, {});
                    }
                }
            };

            _export('default', devicesUpdateSummaryComponent);
        }
    };
});

$__System.register('1b6', [], function (_export) {
    'use strict';

    var devicesUpdateVersionSummaryComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateVersionSummaryComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dUVS.drop}" ng-click="dUVS.drop = !dUVS.drop;">\n            <span translate="updates.deviceFirmwareVersionSummary">Site Devices Firmware Version Summary</span>\n        </h2>\n\n        <section class="" ng-if="dUVS.drop;">\n            <devices-update-version-boxes devices="dUVS.devices"></devices-update-version-boxes>\n        </section>\n    ',
                bindings: {
                    devices: '<'
                },
                controllerAs: 'dUVS'
            };

            _export('default', devicesUpdateVersionSummaryComponent);
        }
    };
});

$__System.register('1b7', [], function (_export) {
    'use strict';

    var devicesUpdateVersionBoxesComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateVersionBoxesComponent = {
                template: '\n        <div class="upgrade-summary-box" ng-repeat="(model, versions) in dUVB.versions">\n            <div class="device-icon lc-{{model}}"></div>\n\n            <!--\n            <h1 class="name nested">\n                <b>{{::model.replace(\'-\',\' \')}}</b>\n            </h1>\n            -->\n            \n            <div class="upgrade-summary-version-group">\n                <em ng-repeat="(version, ids) in versions">\n                    <b style="background-color: {{::dUVB.getCSSHex(version)}}">{{version}}</b> {{ids.length || ids}} {{::model.replace(\'-\',\' \')}}{{ids.length > 1 ? \'s\':\'\'}}\n                </em>\n            </div>\n        </div>\n    ',
                bindings: {
                    devices: '<'
                },
                controllerAs: 'dUVB',
                controller: function controller(_) {

                    var dUVB = this;

                    dUVB.$onInit = function () {
                        dUVB.versions = parseDeviceVersions(dUVB.devices);
                    };

                    dUVB.$onChanges = function (changes) {};

                    dUVB.getCSSHex = function (version) {
                        //
                        // Keep color scheme within #40s for maroon/purple shades
                        //
                        var hex = ('#40' + version.replace(/\./g, '') + '000').substring(0, 7);

                        return hex;
                    };

                    function parseDeviceVersions(devices) {
                        return _.reduce(devices, function (result, device, key) {
                            ((result[device.className] || (result[device.className] = {}))[device.last_firmware_version] = result[device.className][device.last_firmware_version] || []).push(device.id);
                            return result;
                        }, {});
                    }
                }
            };

            _export('default', devicesUpdateVersionBoxesComponent);
        }
    };
});

$__System.register('1b8', [], function (_export) {
    'use strict';

    var devicesUpdateLegacyComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateLegacyComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dSUC.drop}" ng-click="dSUC.drop = !dSUC.drop;">\n            <span translate="devices.legacyUpdate">Legacy Update</span>\n        </h2>\n\n        <section ng-if="dSUC.drop;">\n            <button class="btn" ng-click="dSUC.updateMultiple()" ng-disabled="!dSUC.updateSet" translate="devices.updateMultipleDevices">Update Multiple Devices</button>\n \n            <div ng-show="dSUC.log.length > 0">\n                <div class="estimate" ng-show="dSUC.upgrading">\n                    <h3 ng-bind="dSUC.estimate.humanTime ? \'Finishing \'+dSUC.estimate.humanTime : \'Estimating time remaining\'"></h3>\n                    <progress value="{{dSUC.estimate.finished_update_count}}" max="{{dSUC.estimate.total_device_count}}"></progress>\n                </div>\n                <div class="upgrade-log" scroll-bottom="log">\n                    <p ng-repeat="line in dSUC.log">\n                        <span class="gray caps">{{line.time}}</span>: <span class="{{line.class}}">{{line.entry}}</span>\n                    </p>\n                </div>\n            </div>\n        </section>\n    ',
                bindings: {
                    devices: '<',
                    updateSet: '<'
                },
                controllerAs: 'dSUC',
                controller: function controller($rootScope, $scope, $q, $timeout, $interval, moment, Modals, _) {
                    // @refactor - rootscope for socket message watcher - do we need?

                    var dSUC = this;

                    var remainingInterval = undefined;

                    var socketListener = $rootScope.$on('notifications:new-message', pushDeviceMessage);

                    dSUC.$onInit = function () {
                        //
                        dSUC.drop = true;
                    };

                    dSUC.$onDestroy = function () {
                        socketListener();
                        $timeout.cancel(remainingInterval);
                    };

                    dSUC.log = [];

                    dSUC.estimate = {
                        total_device_count: 0,
                        finished_update_count: 0,
                        start_time: null,
                        first_install_seconds: 0,
                        first_device_uuid: null,
                        finish_time: null,
                        humanTime: null
                    };

                    dSUC.upgradeAll = function () {
                        runUpdate(dSUC.devices);
                    };

                    dSUC.updateMultiple = function () {
                        runUpdate(dSUC.updateSet);
                    };

                    function runUpdate(devices) {
                        var devicesToCheck = [],
                            devicesToUpdate = [];

                        Modals.openLoad('Checking Update status for ' + devices.length + ' devices');

                        dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'Checking Update status for ' + devices.length + ' devices', 'class': 'strong' });

                        devices.forEach(function (device) {
                            dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'Checking upgrade for ' + device.settings.description });
                            devicesToCheck.push(device.checkUpdate().then(function (result) {
                                if (device.nextFirmwareUuid !== 0) {
                                    dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'Update for ' + device.settings.description + ' available', 'class': 'green' });
                                } else {
                                    dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': device.settings.description + ' is up to date' });
                                }
                                return device;
                            }));
                        });

                        $q.all(devicesToCheck).then(function (result) {

                            dSUC.devicesDueUpdate = _.filter(result, function (device) {
                                return device.nextFirmwareUuid !== 0;
                            });

                            if (dSUC.devicesDueUpdate.length === 0) {
                                Modals.closeLoad('Up to date', true);
                                dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'All devices up to date - upgrade finished', 'class': 'strong' });
                            } else {
                                Modals.closeLoad('Finished', true);

                                // Builds scrollable HTML list of all the devices that need an update
                                // Maps each device to a new div element
                                // Container is styled so that if the list is long it becomes scrollable
                                var deviceListHtml = '\n                        <div style="\n                            max-height: 200px;\n                            overflow-y: auto;\n                            text-align: left;\n                            border: 1px solid #ccc;\n                            padding: 8px;\n                            margin-top: 8px;\n                        ">\n                            ' + dSUC.devicesDueUpdate.map(function (d) {
                                    return '<div>' + d.settings.description + '</div>';
                                }).join('') + '\n                        </div>\n                        ';

                                // Builds the full confirmation message including the scrollable list of device names
                                var confirmMsg = '<div>\n                            <p>Are you sure you want to upgrade ' + dSUC.devicesDueUpdate.length + ' devices?</p>\n                            ' + deviceListHtml + '</div>';

                                // Shows the confirmation modal using the existing modals.confirm in modalsService.js
                                Modals.confirm($scope, 'Cancel', 'Update', confirmMsg).then(function () {
                                    dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'Updates found for ' + dSUC.devicesDueUpdate.length + ' devices', 'class': 'green' });
                                    dSUC.upgrading = true;

                                    dSUC.estimate.total_device_count = dSUC.devicesDueUpdate.length;
                                    dSUC.estimate.first_device_uuid = dSUC.devicesDueUpdate[0].uuid;
                                    dSUC.estimate.start_time = moment();

                                    dSUC.devicesDueUpdate.forEach(function (device) {
                                        dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'Upgrading ' + device.settings.description + ' with firmware uuid ' + device.nextFirmwareUuid });
                                        devicesToUpdate.push(device.upgrade().then(function (result) {
                                            dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': device.settings.description + ' upgrade queued', 'class': 'strong' });
                                            return device;
                                        }, function (error) {
                                            dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': device.settings.description + ' upgrade failure', 'class': 'red' });
                                        }));
                                    });

                                    Modals.openLoad('Update Devices');

                                    $q.all(devicesToUpdate).then(function (result) {
                                        dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': dSUC.devicesDueUpdate.length + ' device updates initiated', 'class': 'strong' });
                                        Modals.closeLoad('Updates Initiated', true);
                                    }, function () {
                                        dSUC.log.push({ 'time': moment().format('HH:mm:ss'), 'entry': 'One or more devices failed to upgrade', 'class': 'red' });
                                        Modals.closeLoad('Update Failed');
                                    });
                                });
                            }
                        });
                    }

                    function pushDeviceMessage(event, data) {
                        if (data && data.step) {
                            //It's a chillamessage
                            if (_.filter(dSUC.devices, { 'uuid': data.device_uuid })[0]) {
                                //Device is in our site

                                dSUC.log.push({
                                    'time': moment().format('HH:mm:ss'),
                                    'entry': _.filter(dSUC.devices, { 'uuid': data.device_uuid })[0].settings.id_string + ': ' + data.step + ' ' + data.status + ' ' + data.details,
                                    'class': data.status === 'PASSED' ? 'green' : data.status === 'FAILED' ? 'red' : ''
                                });

                                if (data.step === 'INSTALLING' && data.status === 'PASSED') {
                                    //Estimate from first device time
                                    if (dSUC.estimate.finished_update_count === 0) {
                                        dSUC.estimate.finished_update_count++;
                                        dSUC.estimate.first_install_seconds = moment().diff(dSUC.estimate.start_time, 'seconds');

                                        dSUC.estimate.finish_time = moment().add(dSUC.estimate.first_install_seconds * dSUC.estimate.total_device_count - dSUC.estimate.first_install_seconds, 'seconds');

                                        remainingInterval = $interval(function () {
                                            dSUC.estimate.humanTime = moment().to(dSUC.estimate.finish_time);
                                        }, 1000);
                                    } else {
                                        dSUC.estimate.finished_update_count++;
                                    }
                                }

                                if (data.status === 'FAILED') {
                                    //Give Up on an estimate
                                    $timeout.cancel(remainingInterval);
                                    dSUC.estimate.humanTime = null;
                                }
                            }
                        }
                    }
                }
            };

            _export('default', devicesUpdateLegacyComponent);
        }
    };
});

$__System.register('1b9', [], function (_export) {
    'use strict';

    var devicesUpdateStatusBarComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateStatusBarComponent = {
                template: '\n        <div class="device-update-overview">\n\n            <!--\n            <input\n                class="devices-update-checkbox" \n                type="checkbox"\n                ng-model="dSUPC.selected"\n                name="device-{{::dSUPC.device.id}}"\n                ng-true-value="\'dSUPC.selected\'"\n                ng-false-value="\'!dSUPC.selected\'"\n                ng-change="dSUPC.toggle(dSUPC.selected)">\n                -->\n            <div class="top">\n                <div class="device-icon lc-{{::dSUPC.device.className}}"></div>\n                <h3>{{::dSUPC.device.id}} - {{::dSUPC.device.settings.id_string}}</h3>\n                <button class="btn check blue" ng-disabled="dSUPC.updateStatus !== \'NOT-UP-TO-DATE\' && !dSUPC.pending" ng-click="dSUPC.update(dSUPC.device)">Update</button>\n            </div>\n            \n            <div class="bottom">\n                <progress value="{{dSUPC.progressValue}}" max="100"></progress>\n                <h4>{{dSUPC.parsedStatus}}</h4>\n            </div>\n\n             <!--  ng-bind="dSUPC.nextFirmwareUuid == \'in progress\' ? \'Update in progress\' : \'Update Firmware\'" -->\n\n        </div>\n    ',
                bindings: {
                    device: '<',
                    updateStatus: '<'
                },
                controllerAs: 'dSUPC',
                controller: function controller() {

                    var dSUPC = this;

                    dSUPC.$onInit = function () {
                        dSUPC.progressValue = getProgressValue(dSUPC.updateStatus);
                        dSUPC.parsedStatus = parseStatus(dSUPC.updateStatus);
                    };

                    dSUPC.$onChanges = function (changes) {
                        //
                    };

                    function parseStatus(status) {
                        return status ? status.replace(/-/g, ' ') : '';
                    }

                    dSUPC.update = function (device) {
                        dSUPC.pending = true;

                        //
                        // Old update paradigm is to check first per device
                        //
                        device.checkUpdate().then(function (result) {
                            device.upgrade().then(function (result) {
                                //
                                dSUPC.pending = false;
                            });
                        });
                    };

                    function getProgressValue(status) {
                        var updateSteps = {
                            'NOT-UP-TO-DATE': 0,
                            'QUEUED': 33,
                            'INSTALLING': 67,
                            'UP-TO-DATE': 100,
                            'FAILED': 0
                        };

                        return updateSteps[status];
                    }
                }
            };

            _export('default', devicesUpdateStatusBarComponent);
        }
    };
});

$__System.register('1ba', [], function (_export) {
    'use strict';

    var devicesUpdateStatusBarListComponent;
    return {
        setters: [],
        execute: function () {
            devicesUpdateStatusBarListComponent = {
                template: '\n        <h2 class="overview-heading drop" ng-class="{dropped: dUSBL.drop}" ng-click="dUSBL.drop = !dUSBL.drop;">\n            <span>Device Update Status List</span>\n        </h2>\n\n        <section class="devices-section-inner main-body" ng-if="dUSBL.drop;">\n            <form>\n                <devices-update-status-bar \n                    ng-repeat="item in dUSBL.updateStatusByDevice"\n                    device="::item.device"\n                    update-status="::item.status" \n                ></devices-update-status-bar>\n            </form>\n        </section>\n    ',
                bindings: {
                    devices: '<',
                    updateStatus: '<'
                },
                controllerAs: 'dUSBL',
                controller: function controller(_) {

                    var dUSBL = this;

                    dUSBL.$onInit = function () {
                        // Dropped for dev
                        dUSBL.drop = true;

                        dUSBL.groupedDevicesByStatus = groupDevicesByStatus(dUSBL.updateStatus.nodes, dUSBL.devices);

                        dUSBL.updateStatusByDevice = parseDevicesAndStatus(dUSBL.updateStatus, dUSBL.devices);
                    };

                    dUSBL.$onChanges = function (changes) {
                        //
                    };

                    function groupDevicesByStatus(statuses, devices) {
                        return _.reduce(statuses, function (result, status, nodeId) {
                            (result[status] || (result[status] = [])).push(_.find(devices, { id: parseInt(nodeId) }));
                            return result;
                        }, {});
                    }

                    function parseDevicesAndStatus(statuses, devices) {
                        //
                        // firmware_update endpoint is returning nodeId's that dont belong to this site...
                        //
                        return _.filter(_.map(statuses.nodes, function (status, nodeId) {
                            return {
                                device: _.find(devices, { id: parseInt(nodeId) }),
                                status: status
                            };
                        }), 'device');
                    }
                }
            };

            _export('default', devicesUpdateStatusBarListComponent);
        }
    };
});

$__System.register('1bb', ['1b3', '1b4', '1b5', '1b6', '1b7', '1b8', '1b9', '1ba'], function (_export) {
  'use strict';

  var masterUpdatesBaseComponent, masterUpdatesGlobalViewComponent, devicesUpdateSummaryComponent, devicesUpdateVersionSummaryComponent, devicesUpdateVersionBoxesComponent, devicesUpdateLegacyComponent, devicesUpdateStatusBarComponent, devicesUpdateStatusBarListComponent;
  return {
    setters: [function (_b3) {
      masterUpdatesBaseComponent = _b3['default'];
    }, function (_b4) {
      masterUpdatesGlobalViewComponent = _b4['default'];
    }, function (_b5) {
      devicesUpdateSummaryComponent = _b5['default'];
    }, function (_b6) {
      devicesUpdateVersionSummaryComponent = _b6['default'];
    }, function (_b7) {
      devicesUpdateVersionBoxesComponent = _b7['default'];
    }, function (_b8) {
      devicesUpdateLegacyComponent = _b8['default'];
    }, function (_b9) {
      devicesUpdateStatusBarComponent = _b9['default'];
    }, function (_ba) {
      devicesUpdateStatusBarListComponent = _ba['default'];
    }],
    execute: function () {

      angular.module('admin-devices-updates', []).component('masterUpdatesBase', masterUpdatesBaseComponent).component('masterUpdatesGlobalView', masterUpdatesGlobalViewComponent).component('devicesUpdateSummary', devicesUpdateSummaryComponent).component('devicesUpdateVersionSummary', devicesUpdateVersionSummaryComponent).component('devicesUpdateVersionBoxes', devicesUpdateVersionBoxesComponent).component('devicesUpdateLegacy', devicesUpdateLegacyComponent).component('devicesUpdateStatusBar', devicesUpdateStatusBarComponent).component('devicesUpdateStatusBarList', devicesUpdateStatusBarListComponent);
    }
  };
});

$__System.registerDynamic("1bc", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"automations gutters-20\">\n    <!-- \n        /automations/ View option A (Base) - Nothing selected - Welcome / Add new automation control\n    -->\n    <div ng-if=\"!mAB.itemCollection.filtered\">\n        <div class=\"welcome-screen\" ng-if=\"!mAB.blankAutomationSet\">\n            <h1>Automations</h1>\n            <!-- @todoyu Translations -->\n            <h2>Create an automation</h2>\n            <div class=\"setup-mode\">Select existing from left or create one with the plus button</div>\n        </div>\n\n\t    <!-- \n\t        /automations/ View option A(1) Add New Selector\n\t    -->\n        <section  ng-if=\"mAB.blankAutomationSet\">\n\t\t\t<h2 class=\"overview-heading\">\n\t\t\t    <span>Automations Type</span>\n\t\t\t</h2>\n\n\t\t\t<div class=\"white-pill-item no-icon short\"> \n\t\t\t    <h1 class=\"name\">\n\t\t\t    \t<span>Add</span>\n\t\t\t\t\t<div class=\"lc-select-sentence\">\n\t\t\t\t\t\t<select ng-model=\"mAB.automationType\" ng-selected=\"mAB.automationType\">\n\t\t\t\t\t\t\t<option value=\"\">Select Device Type</option>\n\t\t\t\t\t\t\t<option ng-repeat=\"automationType in mAB.availableAutomationTypes\" value=\"{{automationType}}\">{{automationType}}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<span>Automation</span>\n\t\t\t    </h1>\n\t\t\t\t<button class=\"btn green indicate\" ng-click=\"mAB.addAutomation(mAB.automationType)\" ng-disabled=\"!mAB.automationType\">Add</button>\n\t\t\t</div>\n\n\t\t\t<devices-section-automations\n\t\t\t\tng-if=\"mAB.blankAutomationSet[0]\"\n\t\t\t\tdrop=\"true\"\n\t\t\t\tclass=\"main-body\"\n\t\t\t\tall-automations=\"mAB.sessionData.automations\"\n\t\t\t\tareas=\"mAB.sessionData.areas\"\n\t\t\t\tdevice-automations=\"mAB.blankAutomationSet\" \n\t\t\t\tdevice=\"mAB.masterDevice\"\n\t\t\t\tdevices=\"mAB.sessionData.devices\"\n\t\t\t\tscenes=\"mAB.sessionData.scenes\"\n\t\t\t\tschedules=\"mAB.sessionData.schedules\"\n\t\t\t\tzones=\"mAB.sessionData.zones\"\n\t\t\t\tsite-id=\"mAB.sessionData.id\"\n\t\t\t\ton-automations-update=\"mAB.updateDeviceAutomations(automations)\"\n\t\t\t></devices-section-automations>\n        </section>\n\n    </div>\n    <!-- \n        /automations/ View option B - One or More Automations selected\n    -->\n    <div ng-if=\"mAB.groupSelection\">\n\t    <!-- \n\t        /automations/ View option B(1) - More than one Automations selected\n\t    -->\n\t    <div ng-if=\"mAB.groupSelection.length > 1\">\n\t        <section class=\"main-left\">\n\t            <h2 class=\"overview-heading\">\n\t                <span>Group Actions</span>\n\t            </h2>\n\n\t            <div class=\"left\">\n\t                <button class=\"btn orange delete\" ng-click=\"mAB.deleteGroup(mAB.groupSelection)\">Delete Group</button>\n\t            </div>\n\t        </section>\n\n\t        <section class=\"main-right\">\n\t            <!-- this wont work for now -->\n\t            <scenes-energy-demand-box selection-demand=\"mAB.groupSelection.demand\" demand-change=\"mAB.groupSelection.demandDifference\" max-demand=\"mAB.groupSelection.maxDemand\"></scenes-energy-demand-box>\n\t        </section>\n\t    </div>\n\n\t    <devices-section-automations\n\t    \tdrop=\"true\"\n\t\t\tclass=\"main-body\" \n\t\t\tareas=\"mAB.sessionData.areas\"\n\t\t\tall-automations=\"mAB.sessionData.automations\"\n\t\t\tdevice-automations=\"mAB.groupSelection\" \n\t\t\tdevice=\"mAB.masterDevice\"\n\t\t\tdevices=\"mAB.sessionData.devices\"\n\t\t\tscenes=\"mAB.sessionData.scenes\"\n\t\t\tschedules=\"mAB.sessionData.schedules\"\n\t\t\tzones=\"mAB.sessionData.zones\"\n\t\t\tsite-id=\"mAB.sessionData.id\"\n\t\t\ton-automations-update=\"mAB.updateDeviceAutomations(automations)\"\n\t\t></devices-section-automations>\t\t\n    </div>\n</div>";
});
$__System.register('1bd', ['1bc'], function (_export) {
    'use strict';

    var masterAutomationsBaseTemplate, masterAutomationsBaseComponent;
    return {
        setters: [function (_bc) {
            masterAutomationsBaseTemplate = _bc['default'];
        }],
        execute: function () {
            masterAutomationsBaseComponent = {
                template: masterAutomationsBaseTemplate,
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    onSelectionUpdate: '&?'
                },
                controllerAs: 'mAB',
                controller: function controller($scope, $state, $q, $timeout, automationsFuncs, automationsDefaults, Automations, Modals, LcFn, _) {

                    var mAB = this;

                    var MasterDevice = function MasterDevice() {
                        //For child component
                        this.master = true;
                        this.automations_supported = true;
                        this.automations_enabled = true;
                        //For schedules
                        this.settings = {
                            id_string: 'Group Automation'
                        };
                    };

                    mAB.$onInit = function () {
                        mAB.onSelectionUpdate({ selection: mAB.itemCollection });

                        prepareViewContext();

                        mAB.masterDevice = new MasterDevice();

                        var currentGatewayVersion = mAB.sessionData.gateways[0].gateway_version; //No multiGw

                        mAB.availableAutomationTypes = getAvailableAutomationTypes(automationsDefaults.Criteria, currentGatewayVersion);
                    };

                    mAB.$onChanges = function (changes) {
                        console.log('automations base changes');
                    };

                    mAB.navigate = function (destinationId) {
                        //go to that automation after creation
                        var filter = destinationId ? ['selection~' + destinationId] : null;
                        $state.go('Automations', { siteId: mAB.sessionData.id, userSelectedFilter: filter });
                    };

                    mAB.deleteGroup = function (group) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete <strong>' + group.length + '</strong> automations?').then(function () {

                            Modals.openLoad('Deleting Automations');

                            var automationsToDelete = [];

                            _.each(group, function (automation) {
                                automationsToDelete.push(Automations['delete'](automation));
                            });

                            $q.all(automationsToDelete).then(function () {
                                Modals.closeLoad('Automations Deleted', true);
                                mAB.navigate();
                            }, function () {
                                //Failures handled here
                                Modals.closeLoad('Automations Deleting Failed', false);
                            });
                        });
                    };

                    mAB.addAutomation = function (deviceModel) {
                        mAB.blankAutomationSet = automationsFuncs.addAutomation(mAB.blankAutomationSet ? mAB.blankAutomationSet : [], null, deviceModel, mAB.sessionData.id);
                    };
                    // we should use this or not
                    // mAB.updateDeviceAutomations = function (automations) {
                    //
                    // };

                    function prepareViewContext() {
                        //Base View if filtered false
                        if (mAB.itemCollection.filtered) {
                            // No different single selection
                            mAB.groupSelection = mAB.itemCollection.group;
                        }

                        if (mAB.itemCollection['new']) {
                            mAB.blankAutomationSet = [];
                        }
                    }

                    function getAvailableAutomationTypes(criteria, currentGatewayVersion) {
                        var supportTests = {
                            'Daylighting': function Daylighting(currentGatewayVersion) {
                                return !LcFn.ltVersion(currentGatewayVersion, '1.4');
                            }
                        };

                        return _.filter(_.map(criteria, function (criterion, criterionName) {
                            return criterionName;
                        }), function (criterion) {
                            return supportTests[criterion] ? supportTests[criterion](currentGatewayVersion) : true;
                        });
                    }

                    // //In master view, if linked from device, filter by that device's model
                    // if($state.params.masterDeviceId){
                    //     $scope.$parent.$parent.category = _.find($scope.currentSite.devices, ['id', $state.params.masterDeviceId]).device_type.model;

                    //     $scope.deviceModel = $scope.$parent.$parent.category;

                    //     automations = _.filter(automations, function(automation){
                    //         var deviceId = ((automation.criteria[0] || []).device_id || null);
                    //         var match = _.find($scope.currentSite.devices, ['id', deviceId]);
                    //         return match && match.device_type.model == $scope.$parent.$parent.category;
                    //     })
                    // }
                }
            };

            _export('default', masterAutomationsBaseComponent);
        }
    };
});

$__System.register('1be', ['1bd'], function (_export) {
    'use strict';

    /* Master Auto */
    var masterAutomationsBaseComponent;
    return {
        setters: [function (_bd) {
            masterAutomationsBaseComponent = _bd['default'];
        }],
        execute: function () {

            angular.module('admin-devices-automations', []).component('masterAutomationsBase', masterAutomationsBaseComponent);
        }
    };
});

$__System.registerDynamic("1bf", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading drop\" ng-class=\"{dropped: dSAC.drop}\" ng-click=\"dSAC.drop = !dSAC.drop;\">\n    <span translate=\"automation.automations\">Automations</span>\n</h2>\n\n<span ng-if=\"dSAC.drop && !dSAC.device.automations_enabled\">Choose a trigger mode to set automations</span>\n\n<div ng-if=\"dSAC.drop && dSAC.device.automations_enabled\">\n\t<div class=\"automation\" ng-repeat=\"(key, automation) in dSAC.formattedAutomations\" ng-class=\"{'selectMode': dSAC.selectMode}\" ng-if=\"dSAC.device.device_type.model != 'Daylight Harvester'\">\n\t\t<button class=\"btn-select\" ng-class=\"{selected:automation.selected}\" ng-click=\"dSAC.toggleSelectAutomation(automation)\"></button>\n\t\t\t\n\t\t<div class=\"event-box\">\n\t\t\t<div class=\"inner\">\n\t\t\t\t<automation-condition-loop automation=\"automation\" areas=\"dSAC.areas\" zones=\"dSAC.zones\" ng-if=\"automation.criteria[0].attribute === 'closed_loop_dim'\"></automation-condition-loop>\n\n\t\t\t\t<automation-condition-trigger automation=\"automation\" ng-if=\"automation.criteria[0].attribute === 'trigger'\"></automation-condition-trigger>\n\n\t\t\t\t<automation-condition-dimmer automation=\"automation\" ng-if=\"automation.criteria[0].attribute === 'button'\"></automation-condition-dimmer>\n\n\t\t\t\t<automation-condition-occupancy automation=\"automation\" ng-if=\"automation.criteria[0].attribute === 'occupancy'\"></automation-condition-occupancy>\n\n\t\t\t\t<!-- Same action selection except for closed-loop -->\n\t\t\t\t<automation-actions \n\t\t\t\t\tareas=\"dSAC.areas\" \n\t\t\t\t\tall-automations=\"dSAC.allAutomations\"\n\t\t\t\t\tautomation=\"automation\" \n\t\t\t\t\tcurrent-gateway-id=\"dSAC.gatewayId\" \n\t\t\t\t\tcurrent-gateway-version=\"dSAC.gatewayVersion\" \n\t\t\t\t\tscenes=\"dSAC.scenes\" \n\t\t\t\t\tsite-id=\"dSAC.siteId\" \n\t\t\t\t\tzones=\"dSAC.zones\"\n\t\t\t\t\tng-if=\"automation.criteria[0].attribute !== 'closed_loop_dim'\"\n\t\t\t\t></automation-actions>\n\n\t\t\t\t<span class=\"action-description\" ng-hide=\"automation.actions.length || automation.editing\">No Events</span>\n\t\t\t</div> \n\n            <!-- Automation Schedules -->\n            <automation-schedule automation-id=\"automation.id\" schedules=\"dSAC.schedules\" site-id=\"dSAC.siteId\" device=\"dSAC.device\" editing=\"automation.editing\" clearing=\"automation.clearing\" on-start-edit=\"dSAC.editAutomation(automation);\" on-update-schedule=\"dSAC.updateAutomationSchedule(schedule,automation)\" on-clear-schedule=\"dSAC.clearSchedule(schedule, scheduleHolder, automation)\"></automation-schedule>\n\n\t        <div class=\"automation-footer\">\n\t            <div class=\"attached-devices timing\"><!-- ng-if=\"automation.criteria.length > 1\" -->\n\t                <span>Devices: </span>\n\t                <!-- <a ui-sref=\"devices.device({siteId:currentSite.id,deviceId:criteria.device_id})\"\" ng-repeat=\"criteria in automation.criteria\">{{$index > 0 ? ',':''}}{{criteria.device_id}}</a> -->\n\t                <a href=\"\" ng-click=\"dSAC.editAutomation(automation);dSAC.browseDevices(automation);\">{{automation.criteria.length>0 ? automation.criteria[0].device_id? automation.criteria.length : 0 : 0}}</a>\n\t                <a href=\"\" ng-click=\"dSAC.browseDevices(automation)\" ng-show=\"automation.editing\">+</a>\n\t            </div>\n\n\t            <div class=\"timing\">\n\t                <button class=\"btn m1pc cancel\" ng-show=\"automation.editing && automation.id\" ng-click=\"automation.confirmDelete = false; automation.editing = false; automation.clearing = true\" translate=\"common.cancel\">Cancel</button>\n\t                <button class=\"btn m1pc edit black\" ng-hide=\"automation.editing\" ng-click=\"dSAC.editAutomation(automation);automation.clearing = false\" translate=\"common.edit\">Edit</button>\n\t                <!-- <div class=\"error\" ng-show=\"automation.ajaxError\">{{automation.ajaxError}}</div> -->\n\t                <button class=\"btn m1pc orange delete\" ng-show=\"automation.editing && !automation.confirmDelete\" ng-click=\"automation.confirmDelete = !automation.confirmDelete\" translate=\"common.delete\">Delete</button>\n\t                <button class=\"btn m1pc orange delete\" ng-show=\"automation.confirmDelete\" ng-click=\"dSAC.deleteAutomation(automations, automation, $index)\">Confirm Delete</button>\n\n\t                <button class=\"btn m1pc blue save\" ng-disabled=\"automation.actions.length === 0 || !automation.actions[0].object_type || !automation.criteria[0].device_id || dSAC.ajaxPending\" ng-show=\"automation.editing && !automation.confirmDelete\" ng-click=\"dSAC.saveAutomation(automation)\" translate=\"common.save\">Save</button>\n\n\n\t                <button class=\"btn blue m1pc\" ng-show=\"$state.params.masterDeviceId && !automation.editing\" ng-click=\"dSAC.selectAutomationForDevice(automation)\">Select</button>\n\t            </div>\n\t        </div>\n\n\t\t\t<span class=\"behavior-id greyed\" ng-if=\"dSAC.isSuperUser && automation.id\">ID:{{::automation.id}}</span>\n\t\t</div>\n\t</div>\n\n\t<!-- daylighting automation-->\n\t<div ng-if=\"dSAC.device.device_type.model === 'Daylight Harvester' || dSAC.device.device_type.model === 'Twistlock'\">\n\n\t\t<automation-condition-daylight \n\t\t\tall-automations=\"dSAC.formattedAutomations\" \n\t\t\tautomation-group=\"dSAC.automationGroup\" \n\t\t\tareas=\"dSAC.areas\"\n\t\t\tdevice=\"dSAC.device\" \n\t\t\tscenes=\"dSAC.scenes\" \n\t\t\tcurrent-gateway-id=\"dSAC.gatewayId\" \n\t\t\tcurrent-gateway-version=\"dSAC.gatewayVersion\"\n\t\t\tis-super-user=\"dSAC.isSuperUser\"\n\t\t\tschedules=\"dSAC.schedules\" \n\t\t\tsite-id=\"dSAC.siteId\" \n\t\t\tzones=\"dSAC.zones\"\n\t\t\ton-start-edit=\"\"\n\t\t\ton-update-schedule=\"\"\n\t\t></automation-condition-daylight>\n\n\t\t<div class=\"white-pill-item no-icon short third\">\n\t\t\t<h1 class=\"name\">Add Daylighting Automation</h1>\n\t\t\t<button class=\"btn green indicate\" ng-click=\"dSAC.addDaylightingAutomation()\" ng-disabled=\"\">Add</button>\n\t\t</div>\n\t\t<div class=\"white-pill-item no-icon short third\">\n\t\t\t<h1 class=\"name\">Browse All Daylighting Automations</h1>\n\t\t\t<button class=\"btn green indicate\"  ui-sref=\"Automations({siteId: dSAC.siteId, userSelectedFilter: null, leftMenuSpecialContext: 'automations', automationType: 'Daylight Harvester'})\">Browse</button>\n\t\t</div>\n\t</div>\n\t<!-- end for daylighting automation-->\n\n\t<!-- emergency mode automation-->\n<!-- \t<div ng-if=\"dSAC.device.device_type.model === 'Dimmer'\">\n\t\t<div class=\"white-pill-item no-icon short third\">\n\t\t\t<h1 class=\"name\">Add Emergency Mode Automation</h1>\n\t\t\t<button class=\"btn green indicate\" ng-click=\"dSAC.addEmergencyAutomation()\" ng-disabled=\"\">Add</button>\n\t\t</div>\n\t</div> -->\n\t<!-- end for daylighting emergency mode-->\n\n\t<automation-add\n\t\tng-if=\"dSAC.device.id && dSAC.device.device_type.model != 'Daylight Harvester'\"\n        automations=\"dSAC.formattedAutomations\"\n        device-id=\"dSAC.device.id\"\n        device-model=\"dSAC.device.device_type.model\"\n        daylighting-supported=\"dSAC.device.daylighting_supported\"\n        daylighting-enabled=\"dSAC.device.daylighting_enabled \"\n        gateway-support=\"dSAC.gatewayFirmwareSupported('1.4')\"\n        pending=\"dSAC.ajaxPending\"\n        site-id=\"dSAC.siteId\"\n        on-add-automation=\"dSAC.addAutomation(model)\"\n    ></automation-add>\n</div>";
});
$__System.register('1c0', ['1bf'], function (_export) {
    'use strict';

    var devicesSectionAutomationsComponentTmpl, devicesSectionAutomationsComponent;
    return {
        setters: [function (_bf) {
            devicesSectionAutomationsComponentTmpl = _bf['default'];
        }],
        execute: function () {
            devicesSectionAutomationsComponent = {
                template: devicesSectionAutomationsComponentTmpl,
                bindings: {
                    allAutomations: '<',
                    areas: '<',
                    device: '<',
                    deviceAutomations: '<',
                    devices: '<',
                    drop: '<',
                    gatewayId: '<',
                    gatewayVersion: '<',
                    isSuperUser: '<',
                    scenes: '<',
                    schedules: '<',
                    siteId: '<',
                    zones: '<',
                    clearSchedule: '&',
                    onAutomationsUpdate: '&'
                },
                controllerAs: 'dSAC',
                controller: function controller($scope, $q, $timeout, RecurrenceSchedules, Automations, automationsFuncs, automationsDefaults, devicesDefinitionsValue, Modals, LcFn, moment, _) {

                    var dSAC = this;

                    //
                    //
                    // @todo - loads of refactoring here - a bunch of nutty promise chains
                    //
                    //
                    dSAC.$onInit = function () {

                        dSAC.formattedAutomations = automationsFuncs.viewMapping(dSAC.deviceAutomations, dSAC.areas, dSAC.zones, dSAC.scenes, dSAC.schedules);
                        //if it's daylight harvester, generator automation groups

                        if (dSAC.device && dSAC.device.device_type && (dSAC.device.device_type.model === 'Daylight Harvester' || dSAC.device.device_type.model === 'Twistlock')) {
                            dSAC.automationGroup = {};
                            groupGenerator(dSAC.deviceAutomations);
                        }
                    };

                    dSAC.$onChanges = function (changes) {
                        if (changes.device && changes.device.currentValue) {
                            // Use this component in automations master view
                            if (changes.device.currentValue.master) {
                                dSAC.device = changes.device.currentValue;
                            } else {
                                //
                                // Set automations_enabled feature settings
                                //
                                dSAC.device = angular.copy(devicesDefinitionsValue.featureSettings(changes.device.currentValue));
                            }
                        }
                        if (changes.schedules) {
                            dSAC.schedules = changes.schedules.currentValue;
                        }
                    };

                    dSAC.updateAutomationSchedule = function (schedule, automation) {
                        automation.schedule = schedule;
                    };

                    dSAC.editAutomation = editAutomation;
                    dSAC.saveAutomation = saveAutomation;
                    dSAC.deleteAutomation = deleteAutomation;

                    dSAC.getAutomationEvent = function (automation, eventState) {
                        var events = ((automation || {}).schedule || {}).events || {};
                        return _.find(events, eventState);
                    };

                    dSAC.addAutomation = function (model) {
                        var deviceModel = model || dSAC.device.device_type.model;
                        dSAC.formattedAutomations = automationsFuncs.addAutomation(dSAC.formattedAutomations, dSAC.device.id, deviceModel, dSAC.siteId);
                    };

                    dSAC.addDaylightingAutomation = function () {
                        dSAC.automationGroup[moment().toString()] = [];
                    };

                    dSAC.gatewayFirmwareSupported = function (minVersion, currentGatewayVersion) {
                        return !LcFn.ltVersion(currentGatewayVersion, minVersion);
                    };

                    dSAC.browseDevices = function (automation) {
                        var criteriaId = automation.criteria[0] ? automation.criteria[0].device_id : null;
                        var matchingDevice = _.find(dSAC.devices, { id: criteriaId });
                        var model = automation.model ? automation.model : matchingDevice ? matchingDevice.device_type.model : 'Controller';

                        function checkDeviceAvailable(device, model) {
                            var deviceAvailable = false;

                            if (automationsDefaults.compatibleAutomationModels.sensors.indexOf(model) > -1) {
                                deviceAvailable = device.isSensor || device.isLcSense;
                            } else if (model === 'Daylighting') {
                                //
                                // Is daylighting_enabled used anywhere?
                                //
                                deviceAvailable = device.daylighting_enabled;
                            } else {
                                deviceAvailable = device.device_type.model === model;
                            }

                            return deviceAvailable;
                        }

                        var availableDevices = _.filter(dSAC.devices, function (device) {
                            return checkDeviceAvailable(device, model);
                        });

                        var allDeviceAreas = _.map(dSAC.areas, function (area) {
                            area.devices = _.filter(availableDevices, function (device) {
                                //
                                // Match to zone area so we line up with the new left list
                                //
                                return LcFn.getDeviceArea(area.id, device.id, device.area, dSAC.zones);
                            });

                            return area;
                        });

                        allDeviceAreas.push({
                            id_string: 'No Area',
                            devices: _.map(_.filter(availableDevices, function (device) {
                                //
                                // Match to zone area so we line up with the new left list
                                //
                                return LcFn.getDeviceUnassigned(device.id, device.area, dSAC.zones);
                            }), function (device) {
                                device.area = 0; //Required by multiSelect - could rewrite to get rid of this req
                                return device;
                            })
                        });

                        var selected = [];

                        _.each(automation.criteria, function (criteria) {
                            var match = _.find(dSAC.devices, ['id', criteria.device_id]);

                            if (match) {
                                selected.push(match);
                            }
                        });

                        var allItems = [{
                            type: 'devices',
                            areas: allDeviceAreas,
                            selected: selected
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Devices', 'devices').then(function (items) {
                            var defaultCriteria = automation.criteria[0];
                            var newCriterias = [];

                            _.each(items, function (device) {
                                var criteria = angular.copy(defaultCriteria);
                                criteria.device_id = device.id;

                                newCriterias.push(criteria);
                            });

                            automation.criteria = newCriterias;

                            if (automation.criteria.length === 0) {
                                //They unticked all
                                defaultCriteria.device_id = null;
                                automation.criteria[0] = defaultCriteria;
                            }
                        });
                    };

                    function editAutomation(automation) {
                        automation.editing = true;
                        dSAC.ajaxError = null;
                        var animate = $timeout(function () {
                            $scope.$broadcast('animateBars');
                            $timeout.cancel(animate);
                        });
                    }

                    function checkEndAutomation(automation) {
                        return automation.schedule && dSAC.getAutomationEvent(automation, { state: true }) && !dSAC.getAutomationEvent(automation, { state: false }) ? Modals.confirm($scope, 'Cancel', 'Continue', 'No end set to automation, continue anyway?') : $q.resolve();
                    }

                    function saveAutomation(automation) {
                        automation.confirmDelete = false;

                        //for checking empty actions
                        automation.actions = _.filter(automation.actions, 'object_id');

                        return checkEndAutomation(automation).then(function (result) {
                            return mapAndSave(automation);
                        }).then(function (result) {
                            dSAC.onAutomationsUpdate({ automations: dSAC.deviceAutomations });
                        });
                    }

                    function automationAjax(automationToSend) {
                        return automationToSend.id ? Automations.update(automationToSend) : Automations.create(automationToSend);
                    }

                    function mapAndSave(automation) {
                        Modals.openLoad('Saving');

                        return automationAjax(automation).then(function (result) {
                            $scope.$broadcast('animateBars');
                            automation.editing = false;
                            //LC 755
                            automation.id = result.data.body.behavior.behavior_id;
                            //delte schedule
                            if (!automation.schedule && automation.scheduleHolder) {
                                return deleteOnlySchedule(automation);
                            } else if (!automation.schedule) {
                                return "Saved";
                            } else {
                                return scheduleMeld(automation);
                            }
                        })['catch'](function (error) {
                            Modals.closeLoad(error);
                            automation.ajaxError = error;
                        }).then(function (result) {
                            if (result) {
                                Modals.closeLoad('Saved', true);
                            }
                            automation.editing = false;
                        })['finally'](function (result) {
                            dSAC.ajaxPending = false;
                        });
                    }

                    function scheduleMeld(automation) {
                        //create or update schedule here
                        var match = _.find(dSAC.schedules, function (schedule) {
                            return _.find(schedule.events, function (event) {
                                return event.object_type === 'behavior2' && event.object_id === automation.id;
                            });
                        });

                        return match ? updateSchedule(automation, match) : createSchedule(automation);
                    }

                    function updateSchedule(automation, schedule) {
                        //Keep existing schedule name / id - update events
                        schedule.events = automation.schedule.events;

                        return RecurrenceSchedules.update(schedule).success(function (result) {
                            automation.schedule = angular.copy(schedule);
                            return 'Schedule Updated';
                        });
                    }

                    function createSchedule(automation) {
                        var automationName = dSAC.device ? dSAC.device.settings.id_string : 'Group Automation';

                        //Add Id's from behavior
                        automation.schedule.name = automationName + automation.id;

                        _.each(automation.schedule.events, function (scheduleEvent) {
                            scheduleEvent.object_id = automation.id;
                        });

                        return RecurrenceSchedules.create(automation.schedule).success(function (result) {
                            automation.schedule.id = result.id; //So we can delete without reload
                            return 'Schedule Created';
                        });
                    }

                    function deleteOnlySchedule(automation) {
                        return RecurrenceSchedules.del(automation.scheduleHolder).success(function (result) {
                            return 'Schedule Deleted';
                        }).error(function (err) {
                            console.log(err);
                        });
                    }

                    function checkLocalAuto(automation) {
                        return automation.id ? ajaxDeleteAutomation(automation) : $q.resolve();
                    }

                    function deleteAutomation(automations, automation, index) {
                        automation.editing = false;

                        return checkLocalAuto(automation).then(function (result) {
                            return automation.schedule && automation.schedule.id ? deleteSchedule(automation) : $q.resolve();
                        }).then(function (result) {
                            dSAC.deviceAutomations.splice(index, 1);
                            dSAC.onAutomationsUpdate({ automations: dSAC.deviceAutomations });
                        });
                    }

                    function ajaxDeleteAutomation(automation) {
                        dSAC.ajaxPending = true;
                        Modals.openLoad('Deleting Automation');

                        return Automations['delete'](automation).then(function () {
                            Modals.closeLoad('Automation Deleted', true);
                            dSAC.ajaxPending = false;
                        });
                    }

                    function deleteSchedule(automation) {
                        Modals.openLoad('Deleting Schedule');
                        return RecurrenceSchedules.del(automation.schedule).success(function () {
                            Modals.closeLoad('Schedule Deleted', true);
                        });
                    }

                    dSAC.clearSchedule = function (schedule, scheduleHolder, automation) {
                        automation.schedule = schedule;
                        automation.scheduleHolder = scheduleHolder;
                    };

                    function groupGenerator(automations) {
                        if (automations === null || automations.length < 1) {
                            dSAC.automationGroup[moment().toString()] = [];
                        } else {
                            automations.forEach(function (automation) {
                                //handle existing automation, generate a group id for them
                                if (!automation.group_id) {
                                    //two randoms, reduce the possibility to overlap
                                    automation.group_id = moment().subtract(Math.floor(Math.random() * 1000), 'seconds').subtract(Math.floor(Math.random() * 100), 'hours').toString();
                                }
                                if (!dSAC.automationGroup[automation.group_id]) {
                                    dSAC.automationGroup[automation.group_id] = [automation];
                                } else {
                                    dSAC.automationGroup[automation.group_id].push(automation);
                                }
                            });
                        }
                    }
                }
            };

            _export('default', devicesSectionAutomationsComponent);
        }
    };
});

$__System.registerDynamic("1c1", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"action automation-action\" ng-repeat=\"action in aAC.automation.actions\" ng-class=\"{'editing': aAC.automation.editing}\">\n    <!-- Default state / not editing -->\n    <span class=\"action-description\" ng-hide=\"aAC.automation.editing\">\n        <span ng-if=\"action.seconds || action.minutes\">\n            <span class=\"gray\">after</span>\n            <span ng-if=\"action.minutes > 0\">{{action.minutes}} {{action.minutes == 1 ? 'minute' :'minutes'}}</span>\n            <span ng-if=\"action.seconds > 0\">{{action.seconds}} {{action.seconds == 1 ? 'second' : 'seconds'}}</span>\n        </span>\n        <span class=\"gray\">set</span>\n        <span class=\"target-name bold capitalise\">\n            <span ng-hide=\"action.description\">Loading Action...</span>\n             {{action.description}}\n        </span>\n        <span  ng-if=\"action.object_type == 'zone'\" class=\"gray\">to</span>\n\n        <span ng-if=\"action.object_type == 'zone'\">\n            <span class=\"action-value bold\">{{action.action_parameter}}</span>\n            <span ng-if=\"action.dimmable && action.dim_level\"> at {{action.dim_level}}%</span>\n        </span>\n    </span>\n\n    <div class=\"action-editable\" ng-show=\"aAC.automation.editing\" ng-class=\"{dimHeight: action.dimmable, long: aAC.automation.actions.length < 2}\">\n        <div class=\"event-item time\">\n            <!-- Timeout / Delay -->\n            <button class=\"btn black edit right\" ng-hide=\"action.editTimeout\" ng-click=\"action.editTimeout = true;\">Edit</button>\n            <button class=\"btn black edit right\" ng-show=\"action.editTimeout\" ng-click=\"aAC.clearTimeout(action)\">Clear</button>\n\n            <span ng-hide=\"action.editTimeout || action.minutes || action.seconds\">Immediately</span>\n            <span ng-show=\"action.editTimeout || action.minutes || action.seconds\" class=\"left-container\">\n                <span class=\"text\">after</span>\n                <input type=\"number\" class=\"minutes\" ng-class=\"{'empty': !action.minutes}\" ng-model=\"action.minutes\"  name=\"minutes\" placeholder=\"mins\" min=\"0\" ng-min=\"0\" />\n                <span ng-show=\"action.minutes\" class=\"text\">{{action.minutes == 1 ? 'min' : 'mins'}}</span>\n                <input type=\"number\" ng-class=\"{'empty': !action.seconds}\" ng-model=\"action.seconds\" name=\"seconds\" placeholder=\"secs\" min=\"0\" ng-min=\"0\" max=\"59\" ng-max=\"59\" />\n                <span ng-show=\"action.seconds\" class=\"text\">{{action.seconds == 1 ? 'sec' : 'secs'}}</span>\n            </span>\n        </div>\n\n        <span class=\"join\">set</span>\n        \n        <div class=\"event-item\">\n            <button class=\"btn black edit right\" ng-click=\"aAC.selectKeyOption(action, aAC.automation)\">Edit</button>\n            <!-- Scene or Nothing selected yet -->\n            <span ng-if=\"!action.object_id\" class=\"selected\">Select</span>\n            <span ng-if=\"action.object_type !== 'zone' && action.description && action.object_type !== 'behavior2'\" class=\"selected\">{{action.description}}</span>\n\n            <!-- Zone -->\n            <div class=\"event-item-container zone-special\" ng-if=\"action.object_type == 'zone'\">\n                <div class=\"overview-zone event-zone\" ng-class=\"{'has-slider' : action.dimmable, 'on' : action.action_parameter == 'on', 'trimmed' : action.trim_high < 100, 'trim-maxed' : action.trim_high === action.dim_level && action.trim_high < 100, 'selected' : !action.excluded}\">\n                    <div class=\"zone-control\">\n                        <button class=\"btn-push\" ng-class=\"{'on' : action.action_parameter == 'on'}\" ng-click=\"action.action_parameter == 'on' ? action.action_parameter = 'off' : action.action_parameter = 'on'\">1</button>\n                        <span class=\"zone-name\">\n                            {{action.description}}\n                        </span>\n\n                        <div ng-if=\"aAC.gatewayFirmwareSupported('1.4',aAC.currentGatewayVersion) &&  action.dimmable\" class=\"slider-wrapper with-toggle\">\n                            <button class=\"btn btn-select-toggle\" ng-class=\"{selected:action.dim_level > 0}\" ng-click=\"aAC.toggleDim(action);\"></button>\n                            <span class=\"set-dim\" ng-show=\"!action.dim_level > 0\">Set Dim Level</span>\n                            <slider floor=\"1\" ceiling=\"{{action.trim_high ? action.trim_high : 100}}\" step=\"1\" precision=\"1\" dim=\"true\" level=\"action.dim_level\" ng-model=\"action.dim_level\" ng-model-high=\"100\" enabled=\"action.dim_level > 0\" disabled=\"!action.dim_level > 0\" ng-class=\"{disabled: !action.dim_level > 0}\" ng-show=\"action.dim_level > 0\"></slider>\n                        </div>\n\n                        <div ng-if=\"!aAC.gatewayFirmwareSupported('1.4',aAC.currentGatewayVersion) && action.dimmable\" class=\"slider-wrapper\">\n                            <slider floor=\"1\" ceiling=\"{{action.trim_high ? action.trim_high : 100}}\" step=\"1\" precision=\"1\" dim=\"true\" level=\"action.dim_level\" ng-model=\"action.dim_level\" ng-model-high=\"100\" enabled=\"true\"></slider>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- daylighting automation-->\n            <div class=\"event-item-container zone-special\" ng-if=\"action.object_type == 'behavior2'\">\n                <div class=\"overview-zone event-zone\" ng-class=\"{'has-slider' : action.dimmable, 'on' : action.action_parameter == 'on', 'trimmed' : action.trim_high < 100, 'trim-maxed' : action.trim_high === action.dim_level && action.trim_high < 100, 'selected' : !action.excluded}\">\n                    <div class=\"zone-control\">\n                        <button class=\"btn-push\" ng-class=\"{'on' : action.action_parameter == 'on'}\" ng-click=\"action.action_parameter == 'on' ? action.action_parameter = 'off' : action.action_parameter = 'on'\">1</button>\n                        <span class=\"zone-name\">\n                            {{action.description}}\n                        </span>\n\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <button class=\"btn-minus\" ng-show=\"aAC.automation.actions.length > 1\" ng-click=\"aAC.removeAction(aAC.automation,action)\"></button>\n    </div>\n</div>\n<div class=\"add-action\" ng-show=\"aAC.automation.editing\" ng-click=\"aAC.addAction(aAC.automation)\">\n    <button class=\"btn-plus\"></button>\n    <span translate=\"automation.addAction\">Add Action</span>\n</div>";
});
$__System.register('1c2', ['1c1'], function (_export) {
    'use strict';

    var automation_actions_component_tmpl, automationActionsComponent;
    return {
        setters: [function (_c1) {
            automation_actions_component_tmpl = _c1['default'];
        }],
        execute: function () {
            automationActionsComponent = {
                template: automation_actions_component_tmpl,
                bindings: {
                    areas: '<',
                    allAutomations: '<',
                    automation: '<',
                    currentGatewayId: '<',
                    currentGatewayVersion: '<',
                    scenes: '<',
                    siteId: '<',
                    zones: '<'
                },
                controllerAs: 'aAC',
                controller: function controller($scope, $q, automationsDefaults, LcFn, Modals, _) {

                    var aAC = this;

                    aAC.removeAction = function (automation, action) {
                        var actionIndex = automation.actions.indexOf(action);
                        automation.actions.splice(actionIndex, 1);
                    };

                    aAC.addAction = function (automation) {
                        automation.actions.push({
                            action_parameter: 'on'
                        });
                    };

                    aAC.clearTimeout = function (action) {
                        action.editTimeout = false;

                        delete action.minutes;
                        delete action.seconds;

                        return action;
                    };

                    aAC.toggleDim = function (action) {
                        if (angular.isDefined(action.dim_level)) {
                            delete action.dim_level;
                        } else {
                            action.dim_level = 1;
                        }

                        return action;
                    };

                    aAC.selectKeyOption = function (action, automation) {
                        var actionMinutes = action.minutes;
                        var actionSeconds = action.seconds;

                        var selectedZones = [];
                        var allZones = angular.copy(aAC.areas).map(function (area) {
                            area.zones = aAC.zones.filter(function (zone) {
                                return zone.area === area.id;
                            }).map(function (zone) {
                                if (_.find(automation.actions, function (action) {
                                    return action.object_type === 'zone' && action.object_id === zone.id;
                                })) {
                                    selectedZones.push(zone);
                                }

                                return zone;
                            });
                            return area;
                        });

                        allZones.push({
                            id_string: 'No Area',
                            zones: _.filter(aAC.zones, function (zone) {
                                return !zone.area;
                            }).map(function (zone) {
                                if (_.find(automation.actions, function (action) {
                                    return action.object_type === 'zone' && action.object_id === zone.id;
                                })) {
                                    selectedZones.push(zone);
                                }

                                return zone;
                            })
                        });

                        var allDaylightAutomations = [];

                        allDaylightAutomations = aAC.allAutomations.filter(function (automation) {
                            return automation.criteria[0].attribute === 'closed_loop_dim';
                        });

                        var allItems = [{
                            type: 'zones',
                            areas: allZones,
                            selected: selectedZones
                        }, {
                            type: 'scenes',
                            areas: [{ name: 'Site Wide', scenes: aAC.scenes }],
                            selected: _.filter(aAC.scenes, function (scene) {
                                return _.find(automation.actions, function (action) {
                                    return action.object_type === 'scene' && action.object_id === scene.id;
                                });
                            })
                        }, {
                            type: 'automations',
                            areas: [{ automations: allDaylightAutomations }],
                            selected: _.filter(allDaylightAutomations, function (automation) {
                                return _.find(automation.actions, function (action) {
                                    return action.object_id === automation.id;
                                });
                            })
                        }];

                        //
                        // If gateway supports it - add option for Emergency Mode here
                        //
                        if (aAC.gatewayFirmwareSupported('1.6.1', aAC.currentGatewayVersion)) {
                            //
                            // Limit to dimmer selection (for now)
                            //
                            if (_.find(automation.criteria, function (criteria) {
                                return criteria.attribute === 'button';
                            })) {
                                (function () {

                                    //
                                    // Build dummy actions for emergency mode on/off
                                    //
                                    var emergencyModeActions = [automationsDefaults.actions.emergency({ object_action: true, object_id: aAC.currentGatewayId, id: 0 }), automationsDefaults.actions.emergency({ object_action: false, object_id: aAC.currentGatewayId, id: 1 })];

                                    var selected = [];

                                    //
                                    // - Push corresponding dummy action to selected set
                                    //
                                    _.each(automation.actions, function (action) {
                                        if (action.object_type === 'gateway' && action.object_id === aAC.currentGatewayId) {
                                            // - Thanks DM / Django
                                            if (action.object_action === 'True' || action.object_action === true) {
                                                selected.push(emergencyModeActions[0]);
                                            } else {
                                                selected.push(emergencyModeActions[1]);
                                            }
                                        }
                                    });

                                    allItems.push({
                                        type: 'emergency',
                                        areas: [{ emergency: emergencyModeActions }],
                                        selected: selected
                                    });
                                })();
                            }
                        }

                        Modals.showMulti(allItems, 'Select Zones', 'class').then(function (selection) {
                            automation.actions = _.map(selection, function (item) {
                                if (item.criteria && item.criteria[0].attribute === 'closed_loop_dim') {
                                    item.name = 'Daylighting: ' + item.name + '--' + item.id;
                                    automation.name = item.name;
                                }
                                var action = getAutoActionObjectType(item);

                                return _.merge(action, {
                                    object_id: item.id || item.object_id || item.behavior_id,
                                    id_string: item.id_string || item.name,
                                    minutes: actionMinutes,
                                    seconds: actionSeconds
                                });
                            });
                        });
                    };

                    aAC.gatewayFirmwareSupported = function (minVersion, currentGatewayVersion) {
                        return !LcFn.ltVersion(currentGatewayVersion, minVersion);
                    };

                    function getAutoActionObjectType(item) {
                        return item.object_type === 'gateway' ? automationsDefaults.actions.emergency(item) : item.criteria ? item.criteria[0].attribute === 'closed_loop_dim' ? automationsDefaults.actions.daylightingAutomation(item) : automationsDefaults.actions.automation(item) : item.zone_msg ? automationsDefaults.actions.zone(item) : automationsDefaults.actions.scene(item);
                    }
                }
            };

            _export('default', automationActionsComponent);
        }
    };
});

$__System.register('1c3', [], function (_export) {
    'use strict';

    var automationAddComponent;
    return {
        setters: [],
        execute: function () {
            automationAddComponent = {
                template: '\n        <div class="white-pill-item no-icon short third">\n            <h1 class="name">Add Automation</h1>\n            <button class="btn green indicate" ng-click="aAC.onAddAutomation({model: aAC.deviceModel})" ng-disabled="aAC.ajaxPending || !aAC.automations">Add</button>\n        </div>\n        <div class="white-pill-item no-icon short third" ng-class="{disabled: !aAC.daylightingEnabled}" ng-if="aAC.daylightingSupported && aAC.gatewaySupport" title="{{aAC.daylightingEnabled ? \'Add Daylighting\' : \'Change device mode to add daylighting\' }}">\n            <h1 class="name">Add Daylighting</h1>\n            <button class="btn green indicate" ng-click="aAC.onAddAutomation({model: \'Daylighting\'})" ng-disabled="aAC.ajaxPending || !aAC.automations || !aAC.daylightingEnabled">Add</button>\n        </div>\n        <div class="white-pill-item no-icon short third">\n            <h1 class="name">Browse All {{aAC.deviceModel}} Automations</h1>\n            <button class="btn green indicate"  ui-sref="Automations({siteId: aAC.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'automations\', automationType: aAC.deviceModel})">Browse</button>\n        </div>\n    ',
                bindings: {
                    automations: '<',
                    deviceId: '<',
                    deviceModel: '<',
                    daylightingSupported: '<',
                    daylightingEnabled: '<',
                    gatewaySupport: '<',
                    pending: '<',
                    siteId: '<',
                    onAddAutomation: '&'
                },
                controllerAs: 'aAC',
                controller: function controller() {

                    var aAC = this;

                    aAC.$onInit = function () {
                        //
                    };

                    aAC.$onChanges = function (changes) {
                        //
                    };
                }
            };

            _export('default', automationAddComponent);
        }
    };
});

$__System.register('1c4', [], function (_export) {
    'use strict';

    var automationScheduleComponent;
    return {
        setters: [],
        execute: function () {
            automationScheduleComponent = {
                template: '\n        <div class="automation-option-group">\n            <div class="select-modal-selector key timing" ng-class="{active: aSC.dropStart}" ng-click="aSC.selectStartEvent()">\n                <span class="selected">{{aSC.startEvent ? \'Enabled at: \'+aSC.startEvent.recurrence.humanSentence : \'Schedule Start\'}}</span>\n            </div>\n            <div class="select-modal-selector key timing" ng-class="{active: aSC.dropEnd}" ng-click="aSC.selectEndEvent(aSC.schedule)">\n                <span class="selected">{{aSC.endEvent ? \'Disabled at: \'+aSC.endEvent.recurrence.humanSentence : \'Schedule Finish\'}}</span>\n            </div>\n            <button class="btn"  ng-click="aSC.clearSchedule()" translate="common.clear" ng-show="aSC.editing && aSC.startEvent">Clear</button>\n        </div>\n        <recur-schedules-configuration ng-if="aSC.dropStart" recurrence="aSC.startEvent.recurrence" on-update="aSC.updateRecurrence(recurrence,aSC.startEvent);"></recur-schedules-configuration>\n        <recur-schedules-configuration ng-if="aSC.dropEnd" recurrence="aSC.endEvent.recurrence" on-update="aSC.updateRecurrence(recurrence,aSC.endEvent);"></recur-schedules-configuration>\n    ',
                bindings: {
                    automationId: '<',
                    clearing: '<',
                    editing: '<',
                    schedules: '<',
                    siteId: '<',
                    device: '<',
                    onClearSchedule: '&',
                    onStartEdit: '&',
                    onUpdateSchedule: '&'
                },
                controllerAs: 'aSC',
                controller: function controller($scope, $timeout, $q, Modals, automationsFuncs) {
                    //
                    //
                    // Have this component find it's own associated schedules
                    //
                    //

                    var aSC = this;

                    aSC.$onInit = function () {
                        aSC.schedule = findSchedule(aSC.schedules, aSC.automationId);

                        getEvents();
                    };

                    aSC.$onChanges = function (changes) {
                        if (changes.clearing) {
                            aSC.clearing = changes.clearing.currentValue;
                            if (aSC.clearing && aSC.scheduleHolder && aSC.automationId) {
                                //restore the old schedule
                                aSC.schedule = angular.copy(aSC.scheduleHolder);
                                getEvents();
                                aSC.scheduleHolder = null;
                            }
                        }
                        if (changes.editing) {
                            aSC.editing = changes.editing.currentValue;
                            if (!aSC.editing) {
                                aSC.dropEnd = false;
                                aSC.dropStart = false;
                            }
                        }
                    };

                    aSC.updateRecurrence = function (recurrence, position) {
                        position.recurrence = recurrence;

                        if (aSC.startEvent) {
                            aSC.schedule.events[0] = aSC.startEvent;
                        }

                        if (aSC.endEvent) {
                            aSC.schedule.events[1] = aSC.endEvent;
                        }

                        aSC.onUpdateSchedule({ schedule: aSC.schedule });
                    };

                    aSC.selectStartEvent = function () {
                        aSC.onStartEdit();

                        if (!aSC.schedule) {
                            aSC.schedule = buildStart();
                            getEvents();
                        }

                        aSC.dropEnd = false;
                        aSC.dropStart = true;
                    };

                    aSC.selectEndEvent = function () {
                        aSC.onStartEdit();

                        if (!aSC.schedule) {
                            aSC.schedule = buildStart();
                            getEvents();
                        }

                        if (!aSC.endEvent) {
                            aSC.endEvent = angular.copy(aSC.startEvent);
                            aSC.endEvent.description = aSC.device ? 'Automation ' + aSC.device.settings.id_string + ' disabled' : 'Group Automation disabled';
                            aSC.endEvent.state = false;
                        }

                        aSC.dropEnd = true;
                        aSC.dropStart = false;
                    };

                    aSC.clearSchedule = function () {
                        if (aSC.schedule && aSC.schedule.id) {
                            aSC.scheduleHolder = angular.copy(aSC.schedule);
                        }
                        aSC.schedule = null;
                        getEvents();
                        aSC.onClearSchedule({ scheduleHolder: aSC.scheduleHolder, schedule: aSC.schedule });
                    };

                    function buildStart() {
                        return automationsFuncs.buildStart(aSC.device ? aSC.device : { settings: { id_string: 'Group Automation' } }, aSC.automationId, aSC.siteId);
                    }

                    function findSchedule(schedules, automationId) {
                        return _.find(schedules, ['events[0].object_id', automationId]);
                    }

                    function getEvents() {
                        aSC.startEvent = getScheduleEvent(aSC.schedule, { state: true });
                        aSC.endEvent = getScheduleEvent(aSC.schedule, { state: false });
                    }

                    function getScheduleEvent(schedule, eventState) {
                        var events = schedule ? schedule.events : {};
                        return _.find(events, eventState);
                    }
                }
            };

            _export('default', automationScheduleComponent);
        }
    };
});

$__System.registerDynamic('1c5', ['116', '118', '114'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (KEY, exec) {
    var $def = $__require('116'),
        fn = ($__require('118').Object || {})[KEY] || Object[KEY],
        exp = {};
    exp[KEY] = exec(fn);
    $def($def.S + $def.F * $__require('114')(function () {
      fn(1);
    }), 'Object', exp);
  };
});
$__System.registerDynamic('1c6', ['111', '1c5'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toObject = $__require('111');
  $__require('1c5')('keys', function ($keys) {
    return function keys(it) {
      return $keys(toObject(it));
    };
  });
});
$__System.registerDynamic('1c7', ['1c6', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('1c6');
  module.exports = $__require('118').Object.keys;
});
$__System.registerDynamic("70", ["1c7"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("1c7"), __esModule: true };
});
$__System.registerDynamic("1c8", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<!--******************automation template for daylight harvester*****************-->\n\n<div class=\"daylight-automation-group\" ng-repeat=\"(key,automations) in aCDLC.automationGroup\" ng-init=\"tabIndex=0\">\n\n    <automation-daylighting-timeline automations=\"automations\" current-index=\"aCDLC.currentTabIndexes[key]\" current-device=\"aCDLC.device\" on-click-change=\"aCDLC.notifyTab()\" site-id=\"aCDLC.siteId\"></automation-daylighting-timeline>\n\n    <!--for tab in this automation sections-->\n    <div class=\"tab-container\">\n        <div class=\"tab-frame\" ng-repeat=\"(key, automation) in automations\" ng-click=\"$parent.tabIndex=key;aCDLC.notifyHighlightChange(key,$parent.key)\" ng-class=\"{tabSelected: key==$parent.tabIndex}\">\n            <span class=\"tab-title\" ng-class=\"{red: (automation.actions.length===0||!automation.actions[0].object_type||!automation.criteria[0].device_id)}\">{{key+1}}</span>\n            <button class=\"remove\" ng-click=\"aCDLC.deleteThisRange(automations, automation, $index, $parent.key)\"></button>\n        </div>\n        <span class=\"hint\" ng-show=\"addActionHint(automations)\">Please add action for each range</span>\n    </div>\n    <!--end tab in this automation sections-->\n\n\n    <div class=\"automation daylight\" ng-repeat=\"(key, automation) in automations\" ng-class=\"{'selectMode': selectMode, tabSelected: key==tabInex}\" ng-hide=\"currentDevice && !currentDevice.automations_enabled || key != tabIndex\">\n        <button class=\"btn-select\" ng-class=\"{selected:automation.selected}\" ng-click=\"toggleSelectAutomation(automation)\"></button>\n\n\n        <div class=\"event-box\">\n\n            <!-- temp -->\n            <!--<h1 ng-if=\"currentDevice.device_type.model === 'Daylight Harvester'\" class=\"daylight-harvestor-specific\">{{key+1}}</h1>-->\n\n\n            <!-- 'Normal' automations -->\n            <div class=\"inner\" ng-if=\"automation.criteria[0].attribute !== 'closed_loop_dim'\">\n\n                <!-- DAYLIGHT -->\n                <div class=\"condition daylight\" ng-if=\"automation.criteria[0].attribute == 'dim_level'\">\n                    <!--<span class=\"light-level\">{{automation.criteria[0]}}</span>-->\n                    <span class=\"light-level\" ng-if=\"automation.criteria.length==2 && automation.criteria[0].threshold && automation.criteria[1].threshold\">when the light level is between </span>\n                    <span class=\"light-level\" ng-if=\"(automation.criteria.length==1 && automation.criteria[0].operator==='<')||(automation.criteria.length==2 && automation.criteria[0].threshold==null)\">when the light level is less than </span>\n                    <span class=\"light-level\" ng-if=\"(automation.criteria.length==1 && automation.criteria[0].operator==='>=')||(automation.criteria.length==2 && automation.criteria[1].threshold==null)\">when the light level is greater than </span>\n                    <span >\n\t\t\t\t\t\t<!--<span ng-hide=\"automation.editing\" ng-click=\"automation.editing = !automation.editing\" ng-bind=\"automation.criteria[0].operator === '>=' ? 'greater than or equal to' : automation.criteria[0].operator === '<' ? 'less than' : 'no operator set'\"></span>-->\n                        <!-- \t\t\t\t\t\t<div class=\"lc-select-sentence\">\n                                                    <select class=\"automation-picker\" ng-model=\"automation.criteria[0].operator\" ng-show=\"automation.editing\">\n                                                        <option value=\">=\" ng-selected=\"automation.criteria[0].operator === '>='\" translate=\"devices.greaterThan\">Greater than or equal to</option>\n                                                        <option value=\"<\" ng-selected=\"automation.criteria[0].operator === '<'\" translate=\"devices.lessThan\">Less than</option>\n                                                    </select>\n                                                </div> -->\n\n                        <!--<span ng-hide=\"automation.editing\" ng-click=\"automation.editing = !automation.editing\" ng-bind=\"automation.criteria[0].threshold\"></span>-->\n                        <!--<input type=\"text\" class=\"threshold light-level-threshold\" ng-show=\"automation.editing\" ng-model=\"automation.criteria[0].threshold\" />-->\n\t\t\t\t\t\t<span class=\"blue\" ng-bind=\"automation.criteria[0].threshold\"></span>\n\t\t\t\t\t\t<span ng-if=\"automation.criteria[0].threshold && automation.criteria[1].threshold\">and</span>\n\t\t\t\t\t\t<span class=\"blue\" ng-bind=\"automation.criteria[1].threshold\"></span>\n                        <!--<span ng-hide=\"automation.editing\" ng-click=\"automation.editing = !automation.editing\" ng-bind=\"automation.criteria[1].threshold\"></span>-->\n                        <!--<input type=\"text\" class=\"threshold light-level-threshold\" ng-show=\"automation.editing\" ng-model=\"automation.criteria[1].threshold\" />-->\n\t\t\t\t\t\t<span class=\"foot-candle\" translate=\"devices.footCandles\">foot candles</span>\n\t\t\t\t\t</span>\n                </div>\n\n                <automation-actions\n                    areas=\"aCDLC.areas\"\n                    all-automations=\"aCDLC.allAutomations\"\n                    automation=\"automation\"\n                    current-gateway-version=\"aCDLC.gatewayVersion\"\n                    scenes=\"aCDLC.scenes\"\n                    site-id=\"aCDLC.siteId\"\n                    zones=\"aCDLC.zones\"\n                    ng-if=\"automation.criteria[0].attribute !== 'closed_loop_dim'\"\n                ></automation-actions>\n            </div>\n\n            <span class=\"behavior-id greyed\" ng-if=\"aCDLC.isSuperUser && automation.behavior_id\">ID:{{::automation.behavior_id}}</span>\n        </div>\n    </div>\n\n    <!-- Automation Schedules -->\n    <automation-schedule ng-show=\"automations[0]\" automation-id=\"automations[0].id\" schedules=\"aCDLC.schedules\" site-id=\"aCDLC.siteId\" device=\"aCDLC.device\" editing=\"automations[0].editing\" clearing=\"automations[0].clearing\" on-start-edit=\"aCDLC.editAutomation(automations[0]);\" on-update-schedule=\"aCDLC.updateAutomationSchedule(schedule,automations[0])\" on-clear-schedule=\"aCDLC.clearSchedule(schedule, scheduleHolder, automations[0])\"></automation-schedule>\n\n    <div ng-show=\"automations[0]\" class=\"automation-footer\">\n\n        <div class=\"timing\">\n            <button class=\"btn m1pc cancel\" ng-show=\"automations[0].editing && automations[0].id\" ng-click=\"automations[0].confirmDelete = false; automations[0].editing = false; automations[0].clearing = true\" translate=\"common.cancel\">Cancel</button>\n            <button class=\"btn m1pc edit black\" ng-hide=\"automations[0].editing\" ng-click=\"aCDLC.editAutomation(automations[0]);automations[0].clearing = false\" translate=\"common.edit\">Edit</button>\n            <!-- <div class=\"error\" ng-show=\"automation.ajaxError\">{{automation.ajaxError}}</div> -->\n            <button class=\"btn m1pc orange delete\" ng-show=\"automations[0].editing && !automations[0].confirmDelete\" ng-click=\"automations[0].confirmDelete = !automations[0].confirmDelete\" translate=\"common.delete\">Delete</button>\n            <button class=\"btn m1pc orange delete\" ng-show=\"automations[0].confirmDelete\" ng-click=\"aCDLC.deleteDaylightAutomation(automations,key, $index)\">Confirm Delete</button>\n\n            <button class=\"btn m1pc blue save\" ng-disabled=\"automations[0].actions.length === 0 || !automations[0].actions[0].object_type || !automations[0].criteria[0].device_id || aCDLC.ajaxPending\" ng-show=\"automations[0].editing && !automations[0].confirmDelete\" ng-click=\"aCDLC.saveAutomation(automations, key)\" translate=\"common.save\">Save</button>\n\n\n            <button class=\"btn blue m1pc\" ng-show=\"$state.params.masterDeviceId && !automations[0].editing\" ng-click=\"aCDLC.selectAutomationForDevice(automations[0])\">Select</button>\n        </div>\n    </div>\n\n    <span class=\"behavior-id greyed\" ng-if=\"aCDLC.isSuperUser && automations[0].id\">ID:{{::automations[0].id}}</span>\n\n</div>\n\n\n<!-- ******************end automation template for daylight harvester*********************-->";
});
$__System.register('1c9', ['70', '1c8'], function (_export) {
    var _Object$keys, automationDaylightTmpl, automationConditionDaylightComponent;

    return {
        setters: [function (_2) {
            _Object$keys = _2['default'];
        }, function (_c8) {
            automationDaylightTmpl = _c8['default'];
        }],
        execute: function () {
            'use strict';

            automationConditionDaylightComponent = {
                template: automationDaylightTmpl,
                bindings: {
                    allAutomations: '<',
                    automationGroup: '<',
                    areas: '<',
                    device: '<',
                    currentGatewayId: '<',
                    currentGatewayVersion: '<',
                    isSuperUser: '<',
                    schedules: '<',
                    siteId: '<',
                    scenes: '<',
                    zones: '<',
                    onStartEdit: '&?',
                    onUpdateSchedule: '&?'
                },
                controllerAs: 'aCDLC',
                controller: function controller($scope, $q, Automations, automationsFuncs, automationsDefaults, Modals, RecurrenceSchedules, moment, $timeout) {
                    /*
                    
                        @yuchau - gotta refactor this at some point, saveAutomation func especially.
                                  I've removed $scope.currentDevice ref for now
                      */

                    var aCDLC = this;

                    aCDLC.$onInit = function () {
                        aCDLC.currentTabIndexes = {};
                        if (aCDLC.automationGroup) {
                            _Object$keys(aCDLC.automationGroup).forEach(function (key) {
                                aCDLC.currentTabIndexes[key] = 0;
                            });
                        }
                    };

                    aCDLC.$onChanges = function (changes) {
                        if (changes.schedules) {
                            aCDLC.schedules = changes.schedules.currentValue;
                        }
                    };

                    aCDLC.editAutomation = editAutomation;

                    aCDLC.updateAutomationSchedule = function (schedule, automations) {
                        // automation.schedule = schedule;
                        //need to handle : pass no matter what changes to all automation groups

                    };

                    aCDLC.notifyHighlightChange = function (index, parentKey) {
                        aCDLC.currentTabIndexes[parentKey] = index;
                    };

                    function editAutomation(automation) {
                        automation.editing = true;
                        aCDLC.ajaxError = null;
                        var animate = $timeout(function () {
                            $scope.$broadcast('animateBars');
                            $timeout.cancel(animate);
                        });
                    };

                    aCDLC.updateAutomationSchedule = function (schedule, automation) {
                        automation.schedule = schedule;
                    };

                    aCDLC.clearSchedule = function (schedule, scheduleHolder, automation) {
                        automation.schedule = schedule;
                        automation.scheduleHolder = scheduleHolder;
                    };

                    aCDLC.getAutomationEvent = function (automation, eventState) {
                        var events = ((automation || {}).schedule || {}).events || {};
                        return _.find(events, eventState);
                    };

                    aCDLC.saveAutomation = function (automations, key) {

                        for (var i = 0; i < automations.length; i++) {
                            //set group id
                            automations[i].group_id = key;
                            //set same schedule @todo when delete first element, give schedule to second, also automation edit
                            if (i >= 1) {
                                //should use same recurrence, leave others free, because other params have object id bind to behavior

                                //because in deleteThisRange method, the order of automation can be maintained, so new automation can only show up at tail
                                //case 1: first automation has schedule(no matter it has ID or not), but the rest are new or not
                                //case 2: all the automation exits before
                                automations[i].schedule = automations[0].schedule;
                                if (automations[0].schedule && automations[0].schedule.events) {
                                    //the events are existing
                                    if (automations[i].schedule && automations[i].schedule.events) {
                                        // 4 possible situations:
                                        if (automations[i].schedule.events.length === 1 && automations[0].schedule.events.length === 1) {
                                            automations[i].schedule.events[0].recurrence = automations[0].schedule.events[0].recurrence;
                                        } else if (automations[i].schedule.events.length === 2 && automations[0].schedule.events.length === 2) {
                                            automations[0].schedule.events.forEach(function (event) {
                                                _.find(automations[i].schedule.events, ['state', event.state]).recurrence = event.recurrence;
                                            });
                                        } else if (automations[i].schedule.events.length === 1 && automations[0].schedule.events.length === 2) {
                                            automations[i].schedule.events.push(angular.copy(automations[i].schedule.events[0]));
                                            automations[i].schedule.events[1].description = aCDLC.device ? 'Automation ' + aCDLC.device.settings.id_string + ' disabled' : 'Group Automation disabled';
                                            automations[i].schedule.events[1].state = false;

                                            automations[0].schedule.events.forEach(function (event) {
                                                _.find(automations[i].schedule.events, ['state', event.state]).recurrence = event.recurrence;
                                            });
                                        } else if (automations[i].schedule.events.length === 2 && automations[0].schedule.events.length === 1) {
                                            _.remove(automations[i].schedule.events, ['state', false]);
                                            automations[i].schedule.events[0].recurrence = automations[0].schedule.events[0].recurrence;
                                        }
                                    } else {
                                        //the events are new and need to be created
                                        //sub-cases
                                        //init schedule
                                        automations[i].schedule = automationsFuncs.buildStart(aCDLC.device ? aCDLC.device : { settings: { id_string: 'Group Automation' } }, automations[i], $scope.currentSite.siteId);
                                        //sub-case 1: only have start
                                        if (automations[0].schedule.events.length === 1) {
                                            automations[i].schedule.events[0].recurrence = automations[0].schedule.events[0].recurrence;
                                        } else {
                                            //sub-case 2: have both start and end
                                            automations[i].schedule.events.push(angular.copy(automations[i].schedule.events[0]));
                                            automations[i].schedule.events[1].description = aCDLC.device ? 'Automation ' + aCDLC.device.settings.id_string + ' disabled' : 'Group Automation disabled';
                                            automations[i].schedule.events[1].state = false;
                                            //make sure, start match start, end match end
                                            automations[0].schedule.events.forEach(function (event) {
                                                if (event.state) {
                                                    automations[i].schedule.events[0].recurrence = event.recurrence;
                                                } else {
                                                    automations[i].schedule.events[1].recurrence = event.recurrence;
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                            //create one schedule targeting behavior is enough
                            //set action
                            var actionList = [];
                            automations[i].actions.forEach(function (action) {
                                if (action.object_id) {
                                    actionList.push(action);
                                }
                            });
                            automations[i].actions = actionList;
                        }

                        if (automations[0].schedule && aCDLC.getAutomationEvent(automations[0], { state: true }) && !aCDLC.getAutomationEvent(automations[0], { state: false })) {
                            Modals.confirm($scope, 'Cancel', 'Continue', 'No end set to automation, continue anyway?').then(function () {
                                runMapAndSave(automations);
                            });
                        } else {
                            runMapAndSave(automations);
                        }
                    };

                    function automationAjax(automationToSend) {
                        return automationToSend.id ? Automations.update(automationToSend) : Automations.create(automationToSend);
                    }

                    function runMapAndSave(automationGroup) {
                        automationGroup.forEach(function (automation) {
                            return $q(function (resolve, reject) {
                                mapAndSave(automation).then(function () {
                                    resolve();
                                    automationGroup[0].editing = false;
                                });
                            });
                        });
                    }

                    function mapAndSave(automation) {
                        Modals.openLoad('Saving');

                        return automationAjax(automation).then(function (result) {
                            $scope.$broadcast('animateBars');

                            //LC 755
                            automation.id = result.data.body.behavior.behavior_id;
                            //delte schedule
                            if (!automation.schedule && automation.scheduleHolder) {
                                return deleteOnlySchedule(automation);
                            } else if (!automation.schedule) {
                                return "Saved";
                            } else {
                                return scheduleMeld(automation);
                            }
                            // return automation.schedule ? scheduleMeld(automation) : null;
                        })['catch'](function (error) {
                            Modals.closeLoad(error);
                            automation.ajaxError = error;
                        }).then(function (result) {
                            if (result) {
                                Modals.closeLoad('Saved', true);
                            }
                        })['finally'](function (result) {
                            dSAC.ajaxPending = false;
                            Modals.closeLoad('Saved', true);
                        });
                    }

                    function scheduleMeld(automation) {
                        //This will take a while
                        Modals.openLoad('Configuring Automation Schedules');

                        //create or update schedule here
                        var match = _.find(aCDLC.schedules, function (schedule) {
                            return _.find(schedule.events, function (event) {
                                return event.object_type === 'behavior2' && event.object_id === automation.id;
                            });
                        });
                        return match ? updateSchedule(automation, match) : createSchedule(automation);
                    }

                    function updateSchedule(automation, schedule) {
                        //Keep existing schedule name / id - update events
                        schedule.events = automation.schedule.events;

                        return RecurrenceSchedules.update(schedule).success(function (result) {
                            automation.schedule = angular.copy(schedule);
                            return 'Schedule Updated';
                        });
                    }

                    function createSchedule(automation) {
                        var automationName = aCDLC.device ? aCDLC.device.settings.id_string : 'Group Automation';

                        //Add Id's from behavior
                        automation.schedule.name = automationName + automation.id;

                        _.each(automation.schedule.events, function (scheduleEvent) {
                            scheduleEvent.object_id = automation.id;
                        });

                        return RecurrenceSchedules.create(automation.schedule).success(function (result) {
                            automation.schedule.id = result.id; //So we can delete without reload
                            return 'Schedule Created';
                        });
                    }

                    function deleteOnlySchedule(automation) {
                        return RecurrenceSchedules.del(automation.scheduleHolder).success(function (result) {
                            return 'Schedule Deleted';
                        }).error(function (err) {
                            console.log(err);
                        });
                    }

                    //@todo need to distinguish the delete with other devices' automaitons
                    aCDLC.deleteDaylightAutomation = function (automationGroup, key, index) {
                        //$rootScope.$broadcast('event:openLoadingModal','Deleting Automation(s)');
                        Modals.openLoad('Deleting Automation(s)');
                        aCDLC.ajaxPending = true;

                        var promises = [];
                        var schedulesToDelete = [];
                        automationGroup.forEach(function (automation) {
                            if (automation.id) {
                                promises.push(Automations['delete'](automation));
                                schedulesToDelete.push(angular.copy(automation));
                            }
                        });
                        $q.all(promises).then(function (result) {
                            //$rootScope.$broadcast('event:closeLoadingModal','Automation Deleted', true);
                            Modals.closeLoad('Automation Deleted', true);
                            //delete all the schedules
                            //in case that automation and schedule is just created without refresh the page
                            schedulesToDelete.forEach(function (automation) {
                                if (automation.scheduleHolder && automation.scheduleHolder.length > 0) {
                                    var idHolder = _.find(automation.scheduleHolder, ['behavior', automation.id]);
                                    if (idHolder && automation.schedule) {
                                        automation.schedule.id = angular.copy(idHolder.id);
                                    }
                                }
                                var automationToDelete = angular.copy(automation);
                                checkDeleteSchedule(automationToDelete);
                            });

                            aCDLC.ajaxPending = false;
                            delete aCDLC.automationGroup[key];

                            //in order to handle this no reason UI white issue, take this tricky way. @yuchao
                            if (index == 0) {
                                aCDLC.automationGroup['delety'] = [];
                                $timeout(function () {
                                    delete aCDLC.automationGroup['delety'];
                                });
                            }
                        }), function () {
                            aCDLC.ajaxPending = false;
                            //$rootScope.$broadcast('event:closeLoadingModal','Delete Automation Failed');
                        };
                    };
                    aCDLC.deleteThisRange = function (automations, automation, index, key) {
                        if (!automation.id) {
                            automations.splice(index, 1);
                            var data = { 'index': index, 'key': key };
                            $scope.$broadcast("deleteTab", data);
                        } else {
                            aCDLC.editing = false;
                            aCDLC.ajaxPending = true;
                            //$rootScope.$broadcast('event:openLoadingModal','Deleting Automation');
                            Modals.openLoad('Deleting Automation');
                            Automations['delete'](automation).then(function () {
                                //$rootScope.$broadcast('event:closeLoadingModal','Automation Deleted', true);
                                Modals.closeLoad('Automation Deleted', true);
                                checkDeleteSchedule(automation);

                                automations.splice(index, 1);
                                var data = { 'index': index, 'key': key };
                                $scope.$broadcast("deleteTab", data);
                                aCDLC.ajaxPending = false;
                            });
                        }
                    };

                    function checkDeleteSchedule(automation) {
                        //two cases: one: user doesn't clear automation, click delete directly
                        //           two: user clear automation first, then click delete

                        //chech whether user click clear automation before, if so, transfer it

                        if (automation.scheduleHolder) {
                            automation.schedule = angular.copy(automation.scheduleHolder);
                            automation.scheduleHolder = null;
                        }
                        if (automation.schedule && automation.schedule.id) {
                            //$rootScope.$broadcast('event:openLoadingModal','Deleting Schedule');
                            Modals.openLoad('Deleting Deleting Schedule');

                            RecurrenceSchedules.del(automation.schedule).success(function () {
                                //$rootScope.$broadcast('event:closeLoadingModal','Schedule Deleted', true);
                                Modals.closeLoad('Schedule Deleted', true);
                            });
                        }
                    }
                }
            };

            _export('default', automationConditionDaylightComponent);
        }
    };
});

$__System.register('1ca', [], function (_export) {
    'use strict';

    var automationConditionDimmerComponent;
    return {
        setters: [],
        execute: function () {
            automationConditionDimmerComponent = {
                template: '\n        <!-- DIMMER -->\n        <div class="condition dimmer" ng-if="aCDC.automation.criteria[0].attribute == \'button\'">\n            <span class="light-level">when the </span>\n            <span class="blue">\n                <span ng-hide="aCDC.automation.editing" ng-click="aCDC.automation.editing = !aCDC.automation.editing" ng-bind="aCDC.automation.criteria[0].operator"></span>\n                <div class="lc-select-sentence">\n                    <select class="automation-picker" ng-model="aCDC.automation.criteria[0].operator" ng-show="aCDC.automation.editing">\n                        <option value="top" ng-selected="aCDC.automation.criteria[0].operator === \'top\'">top</option>\n                        <option value="bottom" ng-selected="aCDC.automation.criteria[0].operator === \'bottom\'">bottom</option>\n                    </select>\n                </div>\n            </span>\n            <span>button is pressed</span>\n        </div>\n    ',
                bindings: {
                    automation: '<'
                },
                controllerAs: 'aCDC' // <- lolz
            };

            _export('default', automationConditionDimmerComponent);
        }
    };
});

$__System.register('1cb', [], function (_export) {
    'use strict';

    var automationConditionLoopComponent;
    return {
        setters: [],
        execute: function () {
            automationConditionLoopComponent = {
                template: '\n        <div class="inner">            <div class="condition occupancy" >                <span>maintain daylight level of</span><!-- @todo @yuchau translate -->                <span class="blue">                    <span ng-click="aDLC.aDLC.automation.editing = !aDLC.automation.editing" ng-bind="aDLC.automation.criteria[0].threshold"></span>                </span>                <span>footcandles</span>            </div>            <div class="event-item closed-loop" ng-if="aDLC.automation.editing">                <div class="" ng-if="aDLC.automation.editing">                    <div class="slider-wrapper">                        <slider floor="1" ceiling="100" step="1" precision="1" dim="true" level="aDLC.automation.criteria[0].threshold" ng-model="aDLC.automation.criteria[0].threshold" ng-model-high="100" enabled="true"></slider>                    </div>                </div>            </div>            <div class="action automation-action">                <!-- Default state / not editing -->                <span class="action-description">                    <p class="loop-zones">                        <span class="gray" ng-show="aDLC.automation.actions.length">using</span>                        <span ng-click="aDLC.selectObject(aDLC.automation)" ng-repeat="(key, action) in aDLC.automation.actions" class="target-name bold capitalise clickable">                            <span ng-hide="action.description">Selecting Action...</span>                             {{action.description}}                             <span ng-if="(aDLC.automation.actions.length > 1) && (key !== aDLC.automation.actions.length -1)">,</span>                        </span>                    </p>                </span>            </div>            <div class="add-action" ng-show="aDLC.automation.editing" ng-click="aDLC.selectObject(aDLC.automation)">                <button class="btn-plus"></button>                <span class="ng-scope" translate="demand.addZone">Add Zone</span>            </div>            <div class="">                <div class="condition">                    <span></span>                </div>            </div>        </div>\n    ',
                bindings: {
                    automation: '<',
                    areas: '<',
                    zones: '<'
                },
                controllerAs: 'aDLC',
                controller: function controller(Modals, $q, automationsDefaults, _) {

                    var aDLC = this;

                    aDLC.selectObject = function (automation) {
                        function flagZones(zones) {
                            return zones.map(function (zone) {
                                // - Gateway Mismatch
                                if (!zone.is_dimmable) {
                                    zone.block_selection_dimming = true;
                                }

                                return zone;
                            });
                        }

                        var flaggedZones = flagZones(aDLC.zones);

                        var areas = _.map(aDLC.areas, function (area) {
                            area.zones = _.filter(flaggedZones, { area: area.id });
                            return area;
                        });

                        // - Add unassigned zones to their own category
                        var noAreaZones = _.filter(flaggedZones, { area: null });

                        if (noAreaZones.length) {
                            areas.push({
                                name: 'No Area',
                                zones: noAreaZones
                            });
                        }

                        var allItems = [{
                            type: 'zones',
                            areas: areas,
                            selected: _.filter(flaggedZones, function (zone) {
                                return _.find(automation.actions, function (action) {
                                    return action.object_type === 'zone' && action.object_id === zone.id;
                                });
                            })
                        }];

                        //               allItems, title, class
                        Modals.showMulti(allItems, 'Zones', 'zones').then(function (items) {
                            automation.actions = _.map(items, function (zone) {
                                return _.merge(automationsDefaults.actions.zone(zone), {
                                    object_id: zone.id,
                                    id_string: zone.id_string
                                });
                            });
                        });
                    };
                }
            };

            _export('default', automationConditionLoopComponent);
        }
    };
});

$__System.register('1cc', [], function (_export) {
    'use strict';

    var automationConditionOccupancyComponent;
    return {
        setters: [],
        execute: function () {
            automationConditionOccupancyComponent = {
                template: '\n        <!-- OCCUPANCY -->\n        <div class="condition occupancy" ng-if="aCOC.automation.criteria[0].attribute == \'occupancy\'">\n            <span translate="automation.whenSensorIndicate">when sensor indicates</span>\n            <span class="blue">\n                <span ng-hide="aCOC.automation.editing" ng-click="aCOC.automation.editing = !aCOC.automation.editing" ng-bind="aCOC.automation.criteria[0].threshold"></span>\n                <div class="lc-select-sentence">\n                    <select ng-model="aCOC.automation.criteria[0].threshold" ng-show="aCOC.automation.editing">\n                        <option value="occupancy" ng-selected="aCOC.automation.criteria[0].threshold == \'occupancy\'" translate="devices.occupancy">occupancy</option>\n                        <option value="vacancy" ng-selected="aCOC.automation.criteria[0].threshold == \'vacancy\'" translate="devices.vacancy">vacancy</option>\n                    </select>\n                </div>\n            </span>\n        </div>\n    ',
                bindings: {
                    automation: '<'
                },
                controllerAs: 'aCOC'
            };

            _export('default', automationConditionOccupancyComponent);
        }
    };
});

$__System.register('1cd', [], function (_export) {
    'use strict';

    var automationConditionTriggerComponent;
    return {
        setters: [],
        execute: function () {
            automationConditionTriggerComponent = {
                template: '\n        <!-- TRIGGER -->\n        <div class="condition trigger" ng-if="aCTC.automation.criteria[0].attribute == \'trigger\'">\n            <span translate="automation.whenTriggerIs">when the trigger is</span>\n            <span class="blue">\n                <span ng-hide="aCTC.automation.editing" ng-click="aCTC.automation.editing = !aCTC.automation.editing" ng-bind="aCTC.automation.criteria[0].threshold"></span>\n                <div class="lc-select-sentence">\n                    <select ng-model="aCTC.automation.criteria[0].threshold" ng-show="aCTC.automation.editing">\n                        <option value="trigger" ng-selected="aCTC.automation.criteria[0].threshold == \'trigger\'" translate="devices.trigger">trigger</option>\n                        <option value="timeout" ng-selected="aCTC.automation.criteria[0].threshold == \'timeout\'" translate="devices.timeout">timeout</option>\n                    </select>\n                </div>\n            </span>\n        </div>\n    ',
                bindings: {
                    automation: '<'
                },
                controllerAs: 'aCTC'
            };

            _export('default', automationConditionTriggerComponent);
        }
    };
});

$__System.register('1ce', [], function (_export) {
    /**
     * Created by yuchao on 3/5/18.
     */
    'use strict';
    var automationDaylightingTimelineComponent;
    return {
        setters: [],
        execute: function () {
            automationDaylightingTimelineComponent = {
                template: '<div class="automation">\n                    <div class="event-box">\n                        <div class="inner auto-timeline">\n                            <brushbox ng-if="aDTC.brushes" initial-brushes="aDTC.brushes" on-brush-update="aDTC.update(brushes)" current-index="aDTC.currentIndex" on-click-change="aDTC.updateTab"></brushbox>\n                        </div>\n                    </div>\n                </div>',
                bindings: {
                    automations: '<',
                    currentIndex: '<',
                    currentDevice: '<',
                    siteId: '<',
                    onClickChange: '&?'
                },
                controllerAs: 'aDTC',
                controller: function controller($scope, automationsFuncs, LcFn) {
                    var aDTC = this;

                    aDTC.$onInit = function () {
                        aDTC.brushes = getBrushes(aDTC.automations);
                    };

                    aDTC.$onChanges = function (changes) {
                        if (changes.automations) {
                            aDTC.brushes = getBrushes(changes.automations.currentValue);
                        }
                        if (changes.currentIndex) {
                            aDTC.currentIndex = changes.currentIndex.currentValue;
                        }
                    };

                    function getThreshold(criteria) {
                        return criteria ? parseInt(criteria.threshold) : 0;
                    }

                    function getBrushes(automations) {
                        return _.map(automations, function (automation, k) {
                            return {
                                id: k,
                                extent: [getThreshold(automation.criteria[0]), getThreshold(automation.criteria[1])]
                            };
                        });
                    }

                    aDTC.update = function (brushes) {
                        var i = 0;
                        _.each(brushes, function (brush, k) {
                            //
                            if (!aDTC.automations[brush.id]) {
                                aDTC.automations = automationsFuncs.addAutomation(aDTC.automations, aDTC.currentDevice.id, aDTC.currentDevice.device_type.model, aDTC.siteId, aDTC.currentDevice.idstring);
                            }

                            if (aDTC.automations[i].criteria) {
                                //check boundary
                                if (brush.extent[0] == 0) {
                                    aDTC.automations[i].criteria[0].threshold = null;
                                } else {
                                    aDTC.automations[i].criteria[0].threshold = brush.extent[0];
                                }
                                //set the maxium value for daylighting
                                if (brush.extent[1] == LcFn.defaults.daylightingMax) {
                                    aDTC.automations[i].criteria[1].threshold = null;
                                } else {
                                    aDTC.automations[i].criteria[1].threshold = brush.extent[1];
                                }
                            }
                            i++;

                            $scope.$apply();
                        });
                    };
                }
            };

            _export('default', automationDaylightingTimelineComponent);
        }
    };
});

$__System.register('1cf', ['12', '13'], function (_export) {
    var _createClass, _classCallCheck, BrushboxDirective;

    return {
        setters: [function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }],
        execute: function () {
            /**
             * Created by yuchao on 3/5/18.
             */
            'use strict';

            BrushboxDirective = (function () {
                function BrushboxDirective() {
                    _classCallCheck(this, BrushboxDirective);

                    this.restrict = 'E';
                    this.scope = {
                        currentIndex: '<',
                        initialBrushes: '<',
                        onBrushUpdate: '&?'
                    };
                }

                _createClass(BrushboxDirective, [{
                    key: 'controller',
                    value: function controller($scope, $rootScope, $timeout, LcFn) {
                        //Hoist injected services to $scope for use in linking function
                        $scope.dependencies = {
                            $rootScope: $rootScope,
                            $timeout: $timeout,
                            LcFn: LcFn
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, element, attrs) {
                        var widthWatcher = scope.$watch(function () {
                            var parentWidth = element.parent()[0].getBoundingClientRect().width;
                            if (parentWidth) {
                                // console.log(parentWidth);
                                drawGraph(parentWidth);
                                widthWatcher();
                            }
                        });

                        var paddingFactor = 20;

                        function drawGraph(width) {
                            var graph = {};

                            var parentWidth = width - width / paddingFactor;

                            graph.padding = parentWidth / paddingFactor / 2;
                            graph.margin = {
                                top: graph.padding,
                                right: 0, //graph.padding,
                                bottom: graph.padding,
                                left: 0 //graph.padding
                            }, graph.width = parentWidth - graph.margin.left - graph.margin.right, graph.height = parentWidth / 5 - graph.margin.top - graph.margin.bottom,
                            //here is the max for footcandle graph
                            graph.rangeTop = scope.dependencies.LcFn.defaults.daylightingMax;

                            graph.x = d3.scale.linear().domain([0, graph.rangeTop]).range([0, graph.width]);

                            graph.svg = d3.select(element[0]).append("svg").attr("width", graph.width + graph.margin.left + graph.margin.right).attr("height", graph.height + graph.margin.top + graph.margin.bottom).attr('viewBox', '0 0 ' + (graph.width + graph.margin.left + graph.margin.right) + ' ' + (graph.height + graph.margin.top + graph.margin.bottom)).attr('preserveAspectRatio', 'xMidYMid meet').append("g").attr("transform", "translate(" + graph.margin.left + "," + graph.margin.top + ")");

                            graph.svg.append("rect").attr("class", "grid-background").attr("width", graph.width).attr("height", graph.height).attr("fill", "url(#svgGradient)");

                            graph.svg.append("g").attr("class", "x grid").attr("transform", "translate(0," + graph.height + ")").call(d3.svg.axis().scale(graph.x).orient("bottom")
                            //.ticks(d3.time.hours, 12)
                            .tickSize(-graph.height).tickFormat("")).selectAll(".tick").classed("minor", function (d) {
                                return d;
                            });

                            graph.svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + graph.height + ")").call(d3.svg.axis().scale(graph.x).orient("bottom")
                            //.ticks(d3.time.days)
                            .tickPadding(0)).selectAll("text").attr("x", 6).style("text-anchor", null);

                            var defs = graph.svg.append("defs");

                            var gradient = defs.append("linearGradient").attr("id", "svgGradient").attr("x1", "0%").attr("x2", "100%");

                            gradient.append("stop").attr('class', 'start').attr("offset", "0%").attr("stop-color", "gray").attr("stop-opacity", 1);

                            gradient.append("stop").attr('class', 'end').attr("offset", "100%").attr("stop-color", "silver").attr("stop-opacity", 1);

                            //keep track of existing brushes
                            var brushes = [];

                            //brushes container
                            graph.gBrushes = graph.svg.append('g').attr("class", "brushes").attr("stroke", "white");

                            if (scope.initialBrushes.length) {
                                scope.initialBrushes.forEach(function (initialBrush, key) {
                                    newBrush(key);

                                    brushes[key].brush.extent.start = brushes[key].brush.extent();
                                    brushes[key].brush.extent.start[0] = scope.initialBrushes[key].extent[0];
                                    brushes[key].brush.extent.start[1] = scope.initialBrushes[key].extent[1];

                                    update();

                                    if (brushes[key].brush.extent && brushes[key].brush.extent.start) {
                                        var leftBorder = clc(brushes[key].brush.extent.start[0]);
                                        var borderWidth = clc(brushes[key].brush.extent.start[1] - brushes[key].brush.extent.start[0]);
                                        var brushGraph = d3.select(element[0]).select(".brush-" + key);

                                        brushGraph.append("text").attr("x", function (d) {
                                            return labelPostition(brushes[key].brush.extent.start[0], graph.width);
                                        }).attr("y", graph.margin.top / 4 + 5).attr("dy", ".35em").text(key + 1);
                                    }
                                });
                            } else {
                                //Draw a help message
                                graph.svg.append('text').attr('id', 'help-text').attr('x', width / 2).attr('y', graph.height / 2).style('text-anchor', 'middle').style('fill', 'white').text(function (d, i) {
                                    return 'Click and drag here to create automation'; //chartVars[i].legend;
                                });
                            }

                            function clc(value) {
                                return graph.width / graph.rangeTop * value;
                            }

                            function labelPostition(extent, graphWidth) {
                                return extent * (graphWidth / graph.rangeTop) + 5;
                            }

                            //return an array that contains the closest brush edge to the left and right
                            function getBrushesAround(brush, brushes) {
                                var edge = [];
                                //console.log("call getBrushesAround");
                                if (brush.extent.start === undefined) brush.extent.start = brush.extent();

                                brushes.forEach(function (otherBrush) {
                                    var otherBrush_extent = otherBrush.extent();

                                    if (otherBrush !== brush) {

                                        if (brush.extent.start !== undefined && otherBrush_extent[1] <= brush.extent.start[0]) {

                                            if (edge[0] !== undefined && otherBrush_extent[1] > edge[0] || edge[0] === undefined) edge[0] = otherBrush_extent[1];
                                        } else if (brush.extent.start !== undefined && otherBrush_extent[0] > brush.extent.start[0]) {

                                            if (edge[1] !== undefined && otherBrush_extent[0] < edge[1] || edge[1] === undefined) edge[1] = otherBrush_extent[0];
                                        }
                                    }
                                });
                                //console.log(edge);
                                return edge;
                            }

                            //new brush handler
                            function newBrush(initialBrushIndex) {
                                // Clear help message
                                if (brushes.length) {
                                    d3.select('#help-text').remove();
                                }

                                //I need to create brush here
                                var brush = d3.svg.brush().x(graph.x).on("brushstart", brushstart(self)).on("brush", brushing) //Make sure don't pass surrounding brushes
                                .on("brushend", brushend); //Keep track of what brushes is surrounding

                                //need to write extent into graph svg
                                if (initialBrushIndex != null) {

                                    var initExtent = [scope.initialBrushes[initialBrushIndex].extent[0], scope.initialBrushes[initialBrushIndex].extent[1]];
                                    d3.select().call(brush.extent(initExtent));
                                }
                                brushes.push({ id: brushes.length, brush: brush });

                                function brushstart(brush) {
                                    // console.log("call brush begiiiing");
                                    if (d3.event) {
                                        if (d3.event.sourceEvent) {
                                            brush.mouseStart = d3.event.sourceEvent.x;
                                        }
                                    }
                                };

                                function brushing() {
                                    var extent0 = brush.extent(),
                                        extent1 = [Math.round(extent0[0]), Math.round(extent0[1])];

                                    var width = extent1[1] - extent1[0];

                                    //Make sure no collision

                                    //find out what surrounds this brush
                                    var edge = getBrushesAround(brush, brushes.map(function (d) {
                                        return d.brush;
                                    }));

                                    //if the current block gets brushingik  beyond the surrounding block, limit it so it does not go past

                                    //@todo here need more work
                                    if (edge[1] !== undefined && extent1[1] > edge[1]) {
                                        extent1[1] = edge[1];
                                        //if we are moving, not only do we stop it from going past, but also keep the brush the same size
                                        if (d3.event.mode === "move") {
                                            extent1 = [edge[1] - width, edge[1]];
                                        }
                                    } else if (edge[0] !== undefined && extent1[0] < edge[0]) {
                                        extent1[0] = edge[0];
                                        if (d3.event.mode === "move") {
                                            extent1 = [edge[0], edge[0] + width];
                                        }
                                    }

                                    d3.select(this).call(brush.extent(extent1)).select('text').attr("x", function (d) {
                                        return labelPostition(d.brush.extent()[0], graph.width);
                                    });
                                }

                                function brushend() {
                                    //add a new brush as needed

                                    var lastBrushExtent = brushes[brushes.length - 1].brush.extent();

                                    if (lastBrushExtent[0] != lastBrushExtent[1]) {
                                        newBrush();
                                    } else {

                                        for (var i = 0; i < brushes.length - 1; i++) {
                                            if (_.isEqual(brushes[i].brush.extent.start, d3.event.target.extent.start)) {
                                                // scope.$emit('updateDaylightIndex', i);
                                                scope.$parent.$parent.$parent.tabIndex = i;
                                            }
                                        }
                                    }

                                    //keep track of current loc for comparison later
                                    brush.extent.start = brush.extent();

                                    if (lastBrushExtent[0] != lastBrushExtent[1]) {
                                        var label = d3.select(this).select('text')[0][0];

                                        if (!label) {
                                            d3.select(this).append("text").attr("x", function (d) {
                                                return labelPostition(d.brush.extent()[0], graph.width);
                                            }).attr("y", graph.margin.top / 4 + 5).attr("dy", ".35em").text(function (d) {
                                                return brushes.length - 1;
                                            });
                                        }
                                    }

                                    update();
                                }
                            }

                            function update() {
                                var brushesExport = _.map(graph.gBrushes.selectAll('.brush').data(), function (brushObj) {

                                    return {
                                        id: brushObj.id,
                                        extent: brushObj.brush.extent()
                                    };
                                });

                                var rawBrushesExport = _.filter(brushesExport, function (brush) {
                                    return brush.extent[1] !== 0 && brush.extent[0] != brush.extent[1];
                                });

                                if (cleanBrush()) {
                                    rawBrushesExport.splice(0, 1);
                                }

                                for (var i = 0; i < brushes.length - 1; i++) {
                                    brushes[i].id = i;
                                }
                                var gBrush = graph.gBrushes.selectAll('.brush').data(brushes, function (d) {
                                    return d.id;
                                });

                                gBrush.enter().insert("g", '.brush').attr('class', 'brush').each(function (brushWrapper) {
                                    //call the brush
                                    brushWrapper.brush(d3.select(this));
                                });

                                gBrush.each(function (brushWrapper, i) {
                                    d3.select(this).attr('class', 'brush brush-' + i).selectAll('.background').style('pointer-events', function () {
                                        var brush = brushWrapper.brush;

                                        return i === brushes.length - 1 && brush !== undefined && brush.extent()[0] === brush.extent()[1] ? 'all' : 'none';
                                    });
                                });

                                gBrush.selectAll('rect').attr("height", graph.height);

                                gBrush.exit().remove();

                                // in order to avoid that digesting issue by adding a delay
                                scope.dependencies.$timeout(function () {
                                    publishBrushes(_.orderBy(rawBrushesExport, ['id']));
                                }, 100);

                                //highlight current one
                                highlightBrush(scope.$parent.$parent.$parent.tabIndex, brushes.length);
                            }

                            function cleanBrush() {

                                var tempBrushes = angular.copy(brushes);
                                // console.log(tempBrushes);
                                if (tempBrushes.length < 3) {
                                    return false;
                                } else {
                                    var brushLength = tempBrushes.length;
                                    for (var i = 0; i < brushLength - 1; i++) {

                                        if (tempBrushes[i].brush.extent.start[0] > tempBrushes[i].brush.extent.start[1]) {

                                            var xx = tempBrushes[i][0];
                                            tempBrushes[i].brush.extent.start[0] = tempBrushes[i].brush.extent.start[1];
                                            tempBrushes[i].brush.extent.start[1] = xx;
                                        }
                                    }

                                    if (!tempBrushes[brushLength - 2].brush.extent.start[1]) {
                                        brushes.splice(-2, 1);

                                        return true;
                                    }

                                    for (var i = 0; i < brushLength - 2; i++) {

                                        if ((tempBrushes[brushLength - 2].brush.extent.start[0] - tempBrushes[i].brush.extent.start[0]) * (tempBrushes[brushLength - 2].brush.extent.start[1] - tempBrushes[i].brush.extent.start[1]) <= 0) {
                                            brushes.splice(-2, 1);

                                            return true;
                                        }
                                    }
                                    return false;
                                }
                            }

                            function publishBrushes(brushes) {
                                scope.onBrushUpdate({ brushes: brushes });
                            }

                            newBrush();
                            update();

                            scope.$on("deleteTab", function (event, data) {

                                if (scope.$parent.$parent.$parent.key != data.key) return;

                                brushes.splice(data.index, 1);

                                //remove the brush
                                d3.select(element[0]).select(".brush-" + data.index).remove();
                                //change brush id and brush class id
                                for (var i = data.index; i < brushes.length - 1; i++) {
                                    d3.select(element[0]).select(".brush-" + (i + 1)).select("text").text(function (d) {
                                        return i + 1;
                                    });
                                }
                                for (var i = data.index; i < brushes.length; i++) {
                                    d3.select(element[0]).select(".brush-" + (i + 1)).attr('class', 'brush brush-' + i);
                                    brushes[i].id = i;
                                }
                            });

                            scope.$watch('currentIndex', function (nV, oV) {
                                if (!angular.equals(nV, oV)) {
                                    //highlight here
                                    highlightBrush(nV, brushes.length);
                                }
                            });
                        }

                        function highlightBrush(index, numberOfBrushes) {
                            for (var i = 0; i < numberOfBrushes; i++) {
                                if (i == index) {
                                    d3.select(element[0]).select(".brush-" + i).select(".extent").style("fill", "dodgerblue");
                                } else {
                                    d3.select(element[0]).select(".brush-" + i).select(".extent").style("fill", "white");
                                }
                            }
                        }

                        function removeExisting() {
                            d3.select(element[0]).selectAll('svg').remove();
                        }

                        function getBoxWidth() {
                            var width = element.parent()[0].getBoundingClientRect().width;
                            return width - width / paddingFactor;
                        }

                        function resize() {
                            d3.select(element[0]).selectAll('svg').attr("width", getBoxWidth()).attr("height", getBoxWidth() / 5);
                        }

                        function removeWatch() {
                            d3.select(window).on('resize', null);
                        }

                        scope.$on('$destroy', removeWatch);
                        scope.windowWatcher = d3.select(window).on('resize', resize);
                    }
                }]);

                return BrushboxDirective;
            })();

            _export('BrushboxDirective', BrushboxDirective);
        }
    };
});

$__System.register('1d0', [], function (_export) {
    'use strict';

    function automationsHelper(moment, automationsDefaults, LcFn, _) {

        // ------------------------
        //
        //      viewMapping     :   Converts Lux to Foot candles, seconds to minutes, gets zone and scene info, combines split actions
        //      addAutomation   :   Sets some defaults for different device types
        //      buildStart      :   Defaults for recurrence rule - now kept in automationsDefaults
        //
        // ------------------------

        automationsHelper.viewMapping = function (automations, siteAreas, siteZones, siteScenes, siteSchedules) {
            automations.forEach(function (automation) {
                //Add Schedule
                if (siteSchedules) {
                    automation.schedule = _.find(siteSchedules, ['behavior', automation.id]);
                }

                //Lux toFT
                // if(automation.criteria[0]){
                //     if(automation.criteria[0].attribute == 'dim_level' || automation.criteria[0].attribute == 'closed_loop_dim'){
                //         automation.criteria[0].threshold = LcFn.luxToFoot(automation.criteria[0].threshold); //((automation.criteria[0].threshold*4) * 0.092903).toFixed(2);
                //     }
                // }

                //PER BEHAVIOR
                if (!automation.mapped) {
                    _.each(automation.criteria, function (criteria) {
                        if (criteria.attribute === 'dim_level') {
                            criteria.threshold = LcFn.luxToFoot(criteria.threshold); //((automation.criteria[0].threshold*4) * 0.092903).toFixed(2);
                        } else if (criteria.attribute === '' + 'closed_loop_dim') {
                                criteria.threshold = LcFn.luxClosedToFoot(criteria.threshold);
                            }
                    });
                    //Group pairs of actions based on their shared ID AND Timeout
                    var actionSets = _.groupBy(automation.actions, function (action) {
                        return action.object_id + '#' + action.timeout;
                    });

                    var combinedActionsArray = [];

                    //Get the two actions from each pair
                    _.each(actionSets, function (actionPair) {
                        //Let's have a predefined order?
                        var combinedAction = {};
                        actionPair.forEach(function (action) {
                            //Map Zone Description and Dimmability - keep this
                            var match = {};

                            if (action.object_type === 'zone') {
                                match = _.find(siteZones, ['id', action.object_id]);

                                if (match) {
                                    combinedAction.dimmable = match.is_dimmable;
                                    combinedAction.description = match.id_string;

                                    //Trim high - needed here?
                                    if (match.trim_high) {
                                        combinedAction.trim_high = match.trim_high;
                                    }
                                } else {
                                    combinedAction.description = 'Zone Not Found';
                                }

                                combinedAction.object_id = action.object_id;
                                combinedAction.object_type = action.object_type;

                                if (action.object_action === 'dim_level') {
                                    combinedAction.dim_level = parseInt(action.action_parameter);
                                } else {
                                    combinedAction.object_action = 'lights_on';
                                    combinedAction.action_parameter = action.action_parameter;
                                }
                            } else if (action.object_type === 'scene') {
                                combinedAction = action;

                                match = _.find(siteScenes, ['id', combinedAction.object_id]);

                                combinedAction.description = match ? match.name : 'Scene Not Found';
                            } else if (action.object_type === 'area') {
                                combinedAction = action;

                                match = _.find(siteAreas, { 'id': combinedAction.object_id });

                                combinedAction.description = match ? match.description + ' ' + combinedAction.object_action.replace('_', ' ') : 'Area Not Found';
                            } else if (action.object_type === 'behavior2') {
                                combinedAction = action;
                                //will handle correct target in automationsCtrl.js
                                combinedAction.description = automation.name + ' ' + (action.action_parameter === 'on' ? 'Enabled' : 'Disabled');
                            } else if (action.object_type === 'gateway') {
                                combinedAction = action;
                                combinedAction.description = action.object_action === 'True' || action.object_action === true ? 'Emergency Mode On' : 'Emergency Mode Off';
                            }

                            var zeroTime = moment().startOf('year'),
                                actionTimeout = zeroTime.clone().add(action.timeout, 'seconds'),
                                totalMinutes = actionTimeout.diff(zeroTime, 'minutes');

                            if (totalMinutes) {
                                combinedAction.minutes = totalMinutes;
                            }
                            if (actionTimeout.seconds()) {
                                combinedAction.seconds = actionTimeout.seconds();
                            }
                        });

                        combinedActionsArray.push(combinedAction);
                    });
                    automation.actions = combinedActionsArray;

                    automation.mapped = true;
                }
            });

            return automations;
        };

        automationsHelper.addAutomation = function (automations, deviceId, deviceModel, siteId, deviceIdString) {
            var newCriteria = automationsDefaults.Criteria[deviceModel] || automationsDefaults.Criteria.Controller;
            newCriteria.device_id = deviceId;

            //for daylight harvester, need to push another boundary
            if (newCriteria.attribute === 'dim_level') {
                var secondCriteria = angular.copy(newCriteria);
                secondCriteria.operator = '<';
                secondCriteria.threshold = 50;
                automations.push(angular.copy(automationsDefaults.automation(deviceModel, [newCriteria, secondCriteria], deviceId, siteId, deviceIdString)));
            } else {
                automations.push(angular.copy(automationsDefaults.automation(deviceModel, [newCriteria], deviceId, siteId, deviceIdString)));
            }

            return automations;
        };

        automationsHelper.buildStart = function (device, automationId, siteId) {
            return automationsDefaults.schedule(device, automationId, siteId);
        };

        return automationsHelper;
    }

    return {
        setters: [],
        execute: function () {
            _export('default', automationsHelper);
        }
    };
});

$__System.register('1d1', [], function (_export) {
    'use strict';

    var automationsDefaults;
    return {
        setters: [],
        execute: function () {
            automationsDefaults = {
                actions: {
                    automation: function automation(item) {
                        return {
                            description: item.name + ' ' + (item.action_parameter === 'on' ? 'Enabled' : 'Disabled'),
                            object_type: 'behavior2',
                            object_action: 'lights_on',
                            action_parameter: item.action_parameter
                        };
                    },
                    daylightingAutomation: function daylightingAutomation(item) {
                        return {
                            description: item.name,
                            object_type: 'behavior2',
                            object_action: 'lights_on',
                            action_parameter: 'on'
                        };
                    },
                    emergency: function emergency(item) {
                        return {
                            description: 'Emergency Mode ' + (item.object_action === 'True' || item.object_action === true ? 'On' : 'Off'),
                            object_type: 'gateway',
                            object_id: item.object_id,
                            id: item.id, //For selection
                            object_action: item.object_action,
                            action_parameter: 'emergency_mode'
                        };
                    },
                    scene: function scene(item) {
                        return {
                            description: item.name,
                            object_type: 'scene',
                            object_action: 'activate',
                            action_parameter: ''
                        };
                    },
                    zone: function zone(item) {
                        return {
                            description: item.id_string,
                            object_type: 'zone',
                            object_action: 'lights_on',
                            action_parameter: 'on', //Default to on?
                            dimmable: item.is_dimmable,
                            //Trim
                            trim_high: item.trim_high
                        };
                    }
                },
                automation: function automation(deviceModel, newCriteria, deviceId, siteId, deviceIdString) {
                    return {
                        actions: [],
                        model: deviceModel,
                        criteria: newCriteria,
                        blank: true,
                        enabled: true,
                        editing: true,
                        name: deviceId ? deviceIdString ? deviceIdString : deviceModel + ' ' + deviceId : 'Shared ' + deviceModel + ' Behavior',
                        site_id: parseInt(siteId),
                        time_ranges: []
                    };
                },
                automationSelfAction: function automationSelfAction(selection, item) {
                    selection.object_type = 'behavior2';
                    selection.object_action = 'lights_on';
                    selection.description = item.name + ' ' + (item.action_parameter === 'on' ? 'Enabled' : 'Disabled');
                    selection.action_parameter = item.action_parameter;

                    return selection;
                },
                compatibleAutomationModels: {
                    //
                    // Add Daylighting support here...
                    //
                    sensors: ['Controller Mini', 'Ceiling Sensor', 'Ceiling Sensor V2', 'DimmerSense', 'Driver Plus', 'High Bay Sensor', 'High Bay Sensor V2', 'LCLC3GEN2', 'Smart Driver'] //,'Tunable Lamp']
                },
                Criteria: {
                    'Ceiling Sensor': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'Ceiling Sensor V2': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'Controller': {
                        attribute: 'trigger',
                        operator: '',
                        threshold: 'trigger'
                    },
                    'Controller Mini': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'Daylighting': {
                        attribute: 'closed_loop_dim',
                        operator: '',
                        threshold: 50 // Footcandles (pre-conversion to LUX)?
                    },
                    'Daylight Harvester': {
                        attribute: 'dim_level',
                        operator: '>=',
                        threshold: 30
                    },
                    'Dimmer': {
                        attribute: 'button',
                        operator: 'top',
                        threshold: 30
                    },
                    'Dimmer Bridge': {
                        attribute: 'button',
                        operator: 'top',
                        threshold: 30
                    },
                    'Dimmer V2': {
                        attribute: 'button',
                        operator: 'top',
                        threshold: 30
                    },
                    'DimmerSense': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'Driver Plus': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'High Bay Sensor': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'High Bay Sensor V2': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'LCLC3GEN2': {
                        attribute: 'occupancy',
                        operator: '',
                        threshold: 'occupancy'
                    },
                    'Twistlock': {
                        attribute: 'dim_level',
                        operator: '>=',
                        threshold: 30
                    } /*                  
                      'Tunable Lamp': {
                         attribute   : 'occupancy',
                         operator    : '',
                         threshold   : 'occupancy'
                      }*/
                },
                schedule: function schedule(device, automationId, siteId) {
                    return {
                        name: device.settings.id_string + ' automation ' + automationId,
                        enabled: true,
                        sideId: siteId,
                        events: [{
                            object_id: automationId,
                            object_type: 'behavior2',
                            description: 'Automation for Device ' + device.settings.id_string + ' enabled',
                            state: true,
                            recurrence: {
                                humanSentence: 'Select Time',
                                startTime: {
                                    hour: '9',
                                    minute: '30',
                                    amPm: 'AM',
                                    date: null,
                                    sunPosition: false,
                                    offsetCharge: false
                                },
                                count: null,
                                freq: null,
                                interval: null,
                                mode: null //Nothing for now
                            }
                        }]
                    };
                },
                cleanRecurrence: {
                    humanSentence: 'Select Time',
                    startTime: {
                        hour: '9',
                        minute: '30',
                        amPm: 'AM',
                        date: null,
                        sunPosition: false,
                        offsetCharge: false
                    },
                    count: null,
                    freq: null,
                    interval: null,
                    mode: null //Nothing for now
                }
            };

            _export('default', automationsDefaults);
        }
    };
});

$__System.register('1d2', ['1c0', '1c2', '1c3', '1c4', '1c9', '1ca', '1cb', '1cc', '1cd', '1ce', '1cf', '1d0', '1d1'], function (_export) {
   'use strict';

   /* Conditions */
   var devicesSectionAutomationsComponent, automationActionsComponent, automationAddComponent, automationScheduleComponent, automationConditionDaylightComponent, automationConditionDimmerComponent, automationConditionLoopComponent, automationConditionOccupancyComponent, automationConditionTriggerComponent, automationDaylightingTimelineComponent, BrushboxDirective, automationsHelperFactory, automationsDefaultsValue;
   return {
      setters: [function (_c0) {
         devicesSectionAutomationsComponent = _c0['default'];
      }, function (_c2) {
         automationActionsComponent = _c2['default'];
      }, function (_c3) {
         automationAddComponent = _c3['default'];
      }, function (_c4) {
         automationScheduleComponent = _c4['default'];
      }, function (_c9) {
         automationConditionDaylightComponent = _c9['default'];
      }, function (_ca) {
         automationConditionDimmerComponent = _ca['default'];
      }, function (_cb) {
         automationConditionLoopComponent = _cb['default'];
      }, function (_cc) {
         automationConditionOccupancyComponent = _cc['default'];
      }, function (_cd) {
         automationConditionTriggerComponent = _cd['default'];
      }, function (_ce) {
         automationDaylightingTimelineComponent = _ce['default'];
      }, function (_cf) {
         BrushboxDirective = _cf.BrushboxDirective;
      }, function (_d0) {
         automationsHelperFactory = _d0['default'];
      }, function (_d1) {
         automationsDefaultsValue = _d1['default'];
      }],
      execute: function () {

         angular.module('admin-automations', []).component('devicesSectionAutomations', devicesSectionAutomationsComponent).component('automationActions', automationActionsComponent).component('automationAdd', automationAddComponent).component('automationSchedule', automationScheduleComponent).component('automationConditionDaylight', automationConditionDaylightComponent).component('automationConditionDimmer', automationConditionDimmerComponent).component('automationConditionLoop', automationConditionLoopComponent).component('automationConditionOccupancy', automationConditionOccupancyComponent).component('automationConditionTrigger', automationConditionTriggerComponent).component('automationDaylightingTimeline', automationDaylightingTimelineComponent)
         //.controller('masterAutomationsCtrl',require('./masterAutomationsCtrl.js'))
         //.directive.apply(null,require('./automationLoopDirective.js'))
         //

         .directive('brushbox', function () {
            return new BrushboxDirective();
         }).factory('automationsFuncs', automationsHelperFactory).value('automationsDefaults', automationsDefaultsValue);
      }
   };
});

$__System.registerDynamic("1d3", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "\n<section class=\"main-body\">\n\t<ui-view></ui-view>\n</section>\n\n<section class=\"main-body\">\n\t<div class=\"devices-wrapper gutters\">\n\n\t\t<!-- \n\t\t\t/devices/ \n\n\t\t\tView option A (Base)\n\n\t\t\tNothing selected - master controls only\n\t\t-->\n\n\t\t<div ng-if=\"!dC.itemCollection.filtered\">\n\t\t\t<devices-section-group-actions\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tis-super-user=\"dC.user.is_superuser\" \n\t\t\t\tsite-id=\"dC.sessionData.id\"\n\t\t\t\tsite=\"dC.sessionData\" \t\t\t\n\t\t\t\tselected-devices=\"dC.groupSelection\"\n\t\t\t\ttitle=\"Master Devices Controls\"\n\t\t\t\tall-devices=\"dC.sessionData.devices\" \n\t\t\t\tzones=\"dC.sessionData.zones\"\n\t\t\t></devices-section-group-actions>\n\n\t\t\t<devices-section-activity \n\t\t\t\tclass=\"main-body\" \n\t\t\t\tfilter-items=\"[dC.sessionData]\"\n\t\t\t\tlog-types=\"['site']\"\n\t            site-id=\"dC.sessionData.id\"\n\t\t\t\ttime-zone-offset=\"dC.sessionData.locality.gmt_offset\"\n\t\t\t\ton-latest-status=\"dC.setLatestStatus(status)\"\n\t\t\t></devices-section-activity>\n\n\t\t</div>\n\n\t\t<!-- \n\t\t\t/devices/selection~123\n\n\t\t\tView option B \n\n\t\t\tSingle device selected - dC.currentDevice\n\t\t-->\n\n\t\t<div ng-if=\"dC.currentDevice\">\n\t\t\t<devices-section-product-image\n\t\t\t\tclass=\"main-left\" \n\t\t\t\timage-url=\"dC.currentDevice.fixture_catalog_info.image_url\"\n\t\t\t\tng-if=\"dC.currentDevice.fixture_catalog_info\"\n\t\t\t></devices-section-product-image>\n\n\t\t\t<devices-section-product-info\n\t\t\t\tclass=\"main-right\" \n\t\t\t\tcatalog-info=\"dC.currentDevice.fixture_catalog_info\"\n\t\t\t\tng-if=\"dC.currentDevice.fixture_catalog_info\"\n\t\t\t></devices-section-product-info>\n\n\t\t\t<devices-section-zones\n\t\t\t\tng-if=\"dC.currentDevice.deviceZones.length\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.currentDevice\" \n\t\t\t\tdevices=\"dC.sessionData.devices\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tzones=\"dC.currentDevice.deviceZones\"\n\t\t\t\ton-setting-change=\"dC.updateZoneSettings(dC.currentDevice.deviceZones,settingChange,deferred)\"\n\t\t\t></devices-section-zones>\n\n\t\t\t<devices-section-info\n\t\t\t\tclass=\"main-left\" \n\t\t\t\tdevices=\"[dC.currentDevice]\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t></devices-section-info>\n\n\t\t\t<devices-section-update-version\n\t\t\t\tclass=\"main-right\" \n\t\t\t\tdevice=\"dC.currentDevice\"\n\t\t\t\tdevices=\"[dC.currentDevice]\"\n\t\t\t\tis-org-admin=\"dC.isOrgAdmin\"\n\t\t\t></devices-section-update-version>\n\n\t\t\t<!-- Old control ui - touches and old dimmers -->\n\t\t\t<devices-section-control\n\t\t\t\tng-if=\"dC.currentDevice.control && dC.currentDevice.controlLegacy\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.currentDevice\" \n\t\t\t\tsite-id=\"dC.sessionData.id\"\n\t\t\t\tscenes=\"dC.sessionData.scenes\"\n\t\t\t\tzones=\"dC.sessionData.zones\" \n\t\t\t\tareas=\"dC.sessionData.areas\" \n\t\t\t></devices-section-control>\n\n\t\t\t<!-- New control ui, PC / keypad -->\n\t\t\t<devices-section-control-multi\n\t\t\t\tng-if=\"dC.currentDevice.control && !dC.currentDevice.controlLegacy\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.currentDevice\" \n\t\t\t\tsite-id=\"dC.sessionData.id\"\n\t\t\t\tscenes=\"dC.sessionData.scenes\"\n\t\t\t\tzones=\"dC.sessionData.zones\" \n\t\t\t\tareas=\"dC.sessionData.areas\"\n\t\t\t\tautomations=\"dC.automations\"\n\t\t\t></devices-section-control-multi>\n\n\t\t\t<devices-section-settings \n\t\t\t\tclass=\"main-body\"\n\t\t\t\tajax-pending=\"dC.ajaxPending\"\n\t\t\t\tdevice=\"dC.currentDevice\" \n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tsettings=\"dC.currentDevice.settings\"\n\t\t\t\ton-setting-change=\"dC.updateDeviceSections(device,settingChange,deferred)\"\n\t\t\t></devices-section-settings>\n\n\t\t\t<devices-section-settings-advanced\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.currentDevice\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tsettings=\"dC.currentDevice.settings\"\n\t\t\t\tshow-lost-signal-state=\"dC.showLostSignalState\"\n\t\t\t\ton-firmware-status=\"dC.updateFirmwareStatus(device)\"\n\t\t\t\ton-setting-change=\"dC.updateDeviceSections(device,settingChange,deferred)\"\n\t\t\t></devices-section-settings-advanced>\n\n\t\t\t<devices-section-activity \n\t\t\t\tclass=\"main-body\" \n\t\t\t\tfilter-items=\"[dC.currentDevice]\"\n\t\t\t\tlog-types=\"['node']\"\n\t            site-id=\"dC.sessionData.id\"\n\t\t\t\ttime-zone-offset=\"dC.sessionData.locality.gmt_offset\"\n\t\t\t\ton-latest-status=\"dC.setLatestStatus(status)\"\n\t\t\t></devices-section-activity>\n\n\t\t\t<devices-section-automations \n\t\t\t\tng-if=\"dC.currentDevice.automations_supported\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tareas=\"dC.sessionData.areas\"\n\t\t\t\tall-automations=\"dC.allAutomations\"\n\t\t\t\tdevice-automations=\"dC.deviceAutomations\"\n\t\t\t\tdevice=\"dC.currentDevice\"\n\t\t\t\tdevices=\"dC.sessionData.devices\"\n\t\t\t\tdrop=\"dC.deviceAutomations.length\"\n\t\t\t\tgateway-id=\"dC.sessionData.gateways[0].id\"\n\t\t\t\tgateway-version=\"dC.sessionData.gateways[0].gateway_version\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tscenes=\"dC.sessionData.scenes\"\n\t\t\t\tschedules=\"dC.schedules\"\n\t\t\t\tsite-id=\"dC.sessionData.id\"\n\t\t\t\tzones=\"dC.sessionData.zones\"\n\t\t\t\ton-automations-update=\"dC.updateDeviceAutomations(automations)\"\n\t\t\t></devices-section-automations>\t\t\n\n\t\t\t<section class=\"main-body\">\n\t\t\t\t<h2 class=\"overview-heading\">\n\t                <span translate=\"common.location\">Location</span>\n\t            </h2>\n\t\t\t\t<span ng-bind=\"dC.currentDevice.settings.description\"></span>\n\t\t\t\t<span ng-bind=\"dC.currentDevice.settings.device_mode\"></span>\n\t\t\t\t<button class=\"btn orange right\" ng-if=\"dC.isOrgAdmin\" ng-click=\"dC.promptDelNode(dC.currentDevice)\" ng-disabled=\"ajaxPending || dC.currentDevice.nextFirmwareUuid === 'in progress'\" translate=\"devices.deleteDevice\">Delete Device</button>\n\t\t\t</section>\n\t\t</div>\n\n\t\t<!-- \n\t\t\t/devices/selection~123+124+125\n\n\t\t\tView option C \n\n\t\t\tMultiple devices ***OF SAME TYPE*** selected - dC.groupSelection\n\t\t-->\n\n\t\t<div ng-if=\"dC.groupSelection && dC.groupSelectionSameFlag\">\n\t\t\t<devices-section-zones\n\t\t\t\tng-if=\"dC.groupSelection[0].deviceZones.length\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.groupSelection[0]\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tzones=\"dC.groupSelectionZones\"\n\t\t\t\ton-setting-change=\"dC.updateZoneSettings(dC.groupSelectionZones,settingChange,deferred)\"\n\t\t\t></devices-section-zones>\n\n\t\t\t<devices-section-info\n\t\t\t\tclass=\"main-left\" \n\t\t\t\tdevices=\"dC.groupSelection\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t></devices-section-info>\n\n\t\t\t<devices-section-update-version\n\t\t\t\tclass=\"main-right\" \n\t\t\t\tdevices=\"dC.groupSelection\"\n\t\t\t></devices-section-update-version>\n\n\t\t\t<devices-update-status-bar-list class=\"main-body\" devices=\"dC.groupSelection\" update-status=\"dC.sessionData.updateStatus\"></devices-update-status-bar-list>\n\n\t\t\t<devices-section-settings \n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.groupSelection[0]\" \n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tsettings=\"dC.groupSelection[0].settings\"\n\t\t\t\tgroup-mode=\"true\"\n\t\t\t\ton-setting-change=\"dC.updateGroupDevices(dC.groupSelection,settingChange,deferred)\"\n\t\t\t></devices-section-settings>\n\n\t\t\t<devices-section-settings-advanced\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.groupSelection[0]\" \n\t\t\t\tgroup-mode=\"true\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tsettings=\"dC.groupSelection[0].settings\"\n\t\t\t\tshow-lost-signal-state=\"dC.showLostSignalState\"\n\t\t\t\ton-firmware-status=\"dC.updateFirmwareStatus(device)\"\n\t\t\t\ton-setting-change=\"dC.updateGroupDevices(dC.groupSelection,settingChange,deferred)\"\n\t\t\t></devices-section-settings-advanced>\n\n\t\t\t<devices-section-activity \n\t\t\t\tclass=\"main-body\" \n\t\t\t\tfilter-items=\"dC.groupSelection\"\n\t\t\t\tlog-types=\"['node']\"\n\t            site-id=\"dC.sessionData.id\"\n\t\t\t\ttime-zone-offset=\"dC.sessionData.locality.gmt_offset\"\n\t\t\t\ton-latest-status=\"dC.setLatestStatus(status)\"\n\t\t\t></devices-section-activity>\n\n\t\t\t<devices-section-group-actions\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tclass=\"main-body\"\n\t\t\t\tsite-id=\"dC.sessionData.id\" \n\t\t\t\tsite=\"dC.sessionData\"\n\t\t\t\tselected-devices=\"dC.groupSelection\"\n\t\t\t\ttitle=\"Group Selection Controls\"\n\t\t\t\tall-devices=\"dC.sessionData.devices\" \n\t\t\t\tzones=\"dC.sessionData.zones\"\n\t\t\t></devices-section-group-actions>\n\t\t</div>\t\n\n\t\t<!-- \n\t\t\t/devices/selection~123+124+125\n\n\t\t\tView option D \n\n\t\t\tMultiple devices ***OF DIFFERENT TYPES*** selected - dC.groupSelection\n\t\t-->\n\n\t\t<div ng-if=\"dC.groupSelection && !dC.groupSelectionSameFlag\">\n\n\t\t\t<devices-section-zones\n\t\t\t\tng-if=\"dC.groupSelection[0].deviceZones.length\"\n\t\t\t\tclass=\"main-body\" \n\t\t\t\tdevice=\"dC.groupSelection[0]\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t\tzones=\"dC.groupSelectionZones\"\n\t\t\t\ton-setting-change=\"dC.updateZoneSettings(dC.groupSelectionZones,settingChange,deferred)\"\n\t\t\t></devices-section-zones>\n\n\t\t\t<devices-section-info\n\t\t\t\tclass=\"main-left\" \n\t\t\t\tdevices=\"dC.groupSelection\"\n\t\t\t\tis-super-user=\"dC.user.is_superuser\"\n\t\t\t></devices-section-info>\n\n\t\t\t<devices-section-update-version\n\t\t\t\tclass=\"main-right\" \n\t\t\t\tdevices=\"dC.groupSelection\"\n\t\t\t></devices-section-update-version>\n\n\t\t\t<devices-update-status-bar-list class=\"main-body\" devices=\"dC.groupSelection\" update-status=\"dC.sessionData.updateStatus\"></devices-update-status-bar-list>\n\n\t\t\t<devices-section-activity \n\t\t\t\tclass=\"main-body\" \n\t\t\t\tfilter-items=\"dC.groupSelection\"\n\t\t\t\tlog-types=\"['node']\"\n\t            site-id=\"dC.sessionData.id\"\n\t\t\t\ttime-zone-offset=\"dC.sessionData.locality.gmt_offset\"\n\t\t\t\ton-latest-status=\"dC.setLatestStatus(status)\"\n\t\t\t></devices-section-activity>\n\n\t\t\t<secton class=\"main-body\">\n\t\t\t\t<h2 class=\"overview-heading\">\n\t\t\t\t    <span translate=\"devices.groupSameMessage\">Please Select Matching Device Types To Edit Settings</span>\n\t\t\t\t</h2>\n\t\t\t</secton>\n\t\n\t\t\t<secton class=\"main-body\">\t\t\n\t\t\t\t<devices-section-group-actions\n\t\t\t\t\tis-super-user=\"dC.user.is_superuser\" \n\t\t\t\t\tsite-id=\"dC.sessionData.id\" \n\t\t\t\t\tsite=\"dC.sessionData\"\n\t\t\t\t\tselected-devices=\"dC.groupSelection\"\n\t\t\t\t\ttitle=\"Group Selection Controls\"\n\t\t\t\t\tall-devices=\"dC.sessionData.devices\" \n\t\t\t\t\tzones=\"dC.sessionData.zones\"\n\t\t\t\t></devices-section-group-actions>\n\t\t\t</secton>\n\t\t</div>\n\t</div>\n</section>\n\t<!-- \n\t\t/devices/ \n\n\t\tView option E\n\n\t\tNo devices in system - show welcome screen\n\t-->\n\n<div class=\"welcome-screen\" ng-if=\"welcomeScreen\">\n\t<h1>Welcome</h1>\n\t<h2>Let's get your Lightcloud devices online</h2>\n\t<div class=\"setup-mode\">Toggle 'Add Devices Mode' on the left</div>\n</div>";
});
$__System.register('1d4', ['1d3'], function (_export) {
    'use strict';

    var devicesBaseTemplate, devicesBaseComponent;
    return {
        setters: [function (_d3) {
            devicesBaseTemplate = _d3['default'];
        }],
        execute: function () {
            devicesBaseComponent = {
                template: devicesBaseTemplate,
                bindings: {
                    gateways: '<',
                    itemCollection: '<',
                    sessionData: '<',
                    user: '<',
                    onSelectionUpdate: '&?'
                },
                controllerAs: 'dC',
                controller: function controller($state, $rootScope, $scope, $timeout, $q, LcFn, Devices, Device, devicesDefinitionsValue, Modals, Zones, Messages, LcCache, _, moment, Undo) {
                    //
                    //  Component only instanciated on itemCollection promise resolve
                    //  - we have access to itemCollection here
                    //
                    var dC = this;

                    dC.$onInit = function () {
                        // Filter unrelated schedules
                        dC.schedules = _.filter(dC.sessionData.schedules, ['events[0].object_type', 'behavior2']);

                        dC.onSelectionUpdate({ selection: dC.itemCollection });
                        //
                        // Single or group selection
                        //
                        prepareViewContext();

                        dC.showLostSignalState = checkHeartbeatEnabled(dC.sessionData.gateways);
                    };

                    dC.$onChanges = function (changes) {
                        //
                        if (changes.sessionData && changes.sessionData.currentValue && changes.sessionData.currentValue.automations) {
                            dC.allAutomations = angular.copy(dC.sessionData.automations);
                        }

                        if (changes.gateways && changes.gateways.currentValue) {
                            dC.showLostSignalState = checkHeartbeatEnabled(changes.gateways.currentValue);
                        }
                    };

                    dC.$onDestroy = function () {
                        if (dC.blockIndicate) {
                            $timeout.cancel(dC.blockIndicate);
                        }
                    };

                    dC.isOrgAdmin = LcFn.isOrgAdmin(dC.user, dC.sessionData.org);

                    dC.updateDeviceSections = function (device, settingChange, deferred) {
                        console.log('Device setting update', settingChange);
                        setCurrentDevice(devicesDefinitionsValue.featureSettings(device));

                        settingDevicesUpdate('device', [dC.currentDevice], settingChange, deferred, dC.sessionData.devices);
                    };

                    dC.updateFirmwareStatus = function (device) {
                        setCurrentDevice(device);
                    };

                    dC.updateGroupDevices = function (devices, settingChange, deferred) {
                        settingDevicesUpdate('device', devices, settingChange, deferred, dC.sessionData.devices);
                    };

                    dC.updateZoneSettings = function (zones, settingChange, deferred) {
                        console.log('Zone setting update', settingChange, deferred);
                        settingZonesUpdate('zone', zones, settingChange, deferred, dC.sessionData.devices, dC.sessionData.zones);
                    };

                    dC.updateDeviceAutomations = function (automations) {
                        //
                        //  @todo
                        //
                        //  Master sessionData update service here
                        // 
                        //  Go through sessionData and update with new response from BE - saves additional roundtrip
                        //
                        dC.sessionData.automations = angular.copy(automations);
                    };

                    dC.promptDelNode = function (node) {
                        checkDeviceZoneDependencies(node).then(function () {
                            deleteNode(node);
                        })['catch'](function () {
                            //
                        });
                    };

                    dC.startAllCalibration = function () {
                        Modals.confirm($scope, 'Cancel', 'Continue', 'Calibrate ' + dC.sessionData.zones.length + ' devices with zones? (this will take place in background)').then(function () {
                            Modals.openLoad('Initiating Calibration');
                            dC.calibrationPending = true;

                            //No need to $q
                            _.each(dC.sessionData.zones, function (zone) {
                                Zones.calibration(zone.id);
                            });

                            Modals.closeLoad('Calibration initiated', true);
                        });
                    };

                    dC.toggleMasterAutomationsView = function () {
                        dC.masterAutomationsView = !dC.masterAutomationsView;
                    };

                    dC.partyMode = function () {
                        _.each($scope.currentSite.devices, function (device) {
                            Devices.indicate(device.id);
                        });
                    };

                    function prepareViewContext() {
                        //Base View if filtered false
                        if (dC.itemCollection.filtered) {
                            if (dC.itemCollection.group.length > 1) {
                                dC.groupSelection = _.map(dC.itemCollection.group, function (device) {
                                    device.deviceZones = _.filter(dC.sessionData.zones, { node: device.id });
                                    device.updateStatus = dC.sessionData.updateStatus.nodes[device.id] || null;
                                    return device;
                                });

                                dC.groupSelectionSameFlag = _.every(dC.groupSelection, ['device_type.lcp_type', dC.groupSelection[0].device_type.lcp_type]);

                                dC.groupSelectionZones = _.flatMap(dC.groupSelection, function (device) {
                                    return device.deviceZones;
                                });
                            } else {
                                setCurrentDevice(dC.itemCollection.group[0]);
                                dC.deviceAutomations = _.filter(dC.sessionData.automations, function (automation) {
                                    return _.find(automation.criteria, ['device_id', dC.currentDevice.id]);
                                });
                            }
                        }

                        dC.allAutomations = angular.copy(dC.sessionData.automations);
                    }

                    function setCurrentDevice(device) {
                        //
                        // $onChanges won't be triggered by a deep object property change so
                        // call angular.copy.
                        //
                        var deviceCopy = angular.copy(device);

                        //
                        // Don't rely on stable socket connection here
                        //
                        if (dC.sessionData.zones) {
                            deviceCopy.deviceZones = _.filter(dC.sessionData.zones, { node: deviceCopy.id });
                        }

                        if (dC.sessionData.updateStatus && dC.sessionData.updateStatus.nodes) {
                            deviceCopy.updateStatus = dC.sessionData.updateStatus.nodes[device.id] || null;
                        }

                        dC.currentDevice = deviceCopy;
                    }

                    function mapDeviceUpdateGroup(group, key, value, zones) {
                        return _.map(group, function (device) {
                            if (device.constructor.name !== 'Device') {
                                device = new Device(device, zones);
                            }

                            //
                            // Difference to zones service is the settings obj
                            //
                            device.settings[key] = value;
                            return device;
                        });
                    }

                    function mapZonesUpdateGroup(zones, key, value) {
                        return _.map(zones, function (zone) {
                            zone[key] = value;
                            return zone;
                        });
                    }

                    function mapOriginals(group, cachedGroup) {
                        return _.map(group, function (device) {
                            return _.find(cachedGroup, { id: device.id });
                        });
                    }

                    function checkDeviceZoneDependencies(node) {
                        function promptDependencies(set) {
                            return Modals.showDeps('Cancel', 'Continue', node.settings.id_string + ' dependencies', set);
                        }

                        return node.deviceZones && node.deviceZones[0] ? Zones.dependencies(node.deviceZones[0].id).then(function (deps) {
                            return _.find(deps, function (dep) {
                                return dep.length;
                            }) ? promptDependencies(deps) : null;
                        }) : $q.resolve();
                    }

                    function settingDevicesUpdate(type, group, settingUpdate, deferred, cachedDevices) {
                        var updateDevicesGroup = mapDeviceUpdateGroup(group, settingUpdate.setting, settingUpdate.value, dC.sessionData.zones);

                        Undo.queueActions(Devices, 'update', updateDevicesGroup, mapOriginals(group, cachedDevices), deferred);
                    }

                    function settingZonesUpdate(type, group, settingUpdate, deferred, cachedZones) {
                        //
                        //
                        //
                        var updateZonesGroup = mapZonesUpdateGroup(group, settingUpdate.setting, settingUpdate.value);

                        Undo.queueActions(Zones, 'update', updateZonesGroup, mapOriginals(group, cachedZones), deferred);
                    }

                    function deleteNode(node) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'Are you sure you want to delete ' + node.settings.id_string + '?').then(function () {
                            dC.ajaxPending = true;

                            Modals.openLoad('Deleting Device');

                            node['delete']().then(function () {
                                Modals.closeLoad('Node Deleted', true);
                                $rootScope.$broadcast('event:removeDevice', node);
                                _.remove(dC.sessionData.devices, { id: node.id });
                                _.remove(dC.itemCollection.group, { id: node.id });
                                $state.go('devices', { deviceId: $rootScope.currentSite.devices[0].id });
                            }, function () {
                                Modals.closeLoad('Node Delete Failed');
                            });
                        });
                    }

                    function checkHeartbeatEnabled(gateways) {
                        return _.find(gateways, 'heartbeat_period') ? true : false;
                    };
                }
            };

            _export('default', devicesBaseComponent);
        }
    };
});

$__System.register('1d5', [], function (_export) {
    'use strict';

    var quickAddBaseComponent;
    return {
        setters: [],
        execute: function () {
            quickAddBaseComponent = {
                template: '\n        <div class="wizard-container step-content">\n            <div class="wizard-form">\n                <div class="search-box search-input-wrapper">\n                    <i class="fa fa-search"></i>\n                    <input class="search" placeholder="Search for zones" ng-model="qaB.zoneSearch" />\n                </div>\n                <div ng-show="qaB.zoneSearch" class="">\n                     <div class="sites-list-wrapper">\n                        <ul class="sites-list">\n                            <li class="site-item" id="zoneId-{{::zone.id}}" ng-class="{\'selected\': zone.selected}" ng-click="zone.selected = true; qaB.selectedzone = zone;" ng-repeat="zone in qaB.sessionData.zones | filter:qaB.zoneSearch">\n                                <h1 ng-bind="::zone.id_string">Default Site Name</h1>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n    ',
                bindings: {
                    sessionData: '<',
                    itemCollection: '<',
                    onSelectionUpdate: '&?'
                },
                controllerAs: 'qaB',
                controller: function controller() {

                    var qaB = this;

                    qaB.$onInit = function () {
                        qaB.onSelectionUpdate({ selection: qaB.itemCollection });
                    };

                    qaB.$onChanges = function (changes) {};
                }
            };

            _export('default', quickAddBaseComponent);
        }
    };
});

$__System.register('1d6', [], function (_export) {
    'use strict';

    var devicesSetupModeToggleComponent;
    return {
        setters: [],
        execute: function () {
            devicesSetupModeToggleComponent = {
                template: '\n        <button class="btn btn-select-toggle" ng-class="{selected:dSMT.setupMode, pending: dSMT.setupLoading}" ng-click="dSMT.toggleDiscovery(dSMT.siteId,dSMT.gatewayId,dSMT.setupMode)"></button>\n    ',
                bindings: {
                    setupMode: '<',
                    gatewayId: '<',
                    siteId: '<',
                    //
                    //
                    //
                    onToggle: '&'
                },
                controllerAs: 'dSMT',
                controller: function controller(Sites, $timeout) {

                    var dSMT = this;

                    var waitForSetupMode = null;

                    dSMT.$onChanges = function (changes) {
                        if (changes.setupMode) {
                            dSMT.setupMode = changes.setupMode.currentValue;
                            finishToggle();
                        }
                    };

                    dSMT.toggleDiscovery = function (siteId, gatewayId, state) {
                        dSMT.setupLoading = true;

                        state = !state;

                        Sites.toggleDiscovery(siteId, gatewayId, state).success(function () {
                            // Nothing for now
                            // We will now wait for a socket message to confirm setup mode has been entered.
                            //
                            // - Note -
                            //
                            // IF one or more devices on gw won't go into setup mode, gw will reply with
                            // 'Failed enabling setup mode on devices' first, then success - can take 1-2mins
                            //
                            waitForSetupMode = $timeout(function () {
                                finishToggle(siteId);
                            }, 30000);
                        }).error(function () {
                            dSMT.setupLoading = false;
                        });
                    };

                    function finishToggle() {
                        dSMT.setupLoading = false;

                        $timeout.cancel(waitForSetupMode);
                    }
                }
            };

            _export('default', devicesSetupModeToggleComponent);
        }
    };
});

$__System.register('1d7', [], function (_export) {
    'use strict';

    var devicesSetupModeSectionComponent;
    return {
        setters: [],
        execute: function () {
            devicesSetupModeSectionComponent = {
                template: '\n        <section class="selection-list discovery">\n            <h2 translate="devices.addDevicesMode">Add Devices Mode</h2>\n            \n            <!-- One gateway (default, majority) -->\n            <devices-setup-mode-toggle ng-if="dSMS.gateways.length === 1" gateway-id="dSMS.gateways[0].id" setup-mode="dSMS.gateways[0].setup_mode" site-id="dSMS.siteId;"></devices-setup-mode-toggle>\n\n            <!-- Multi gateway -->\n            <button class="btn-dropdown white" ng-if="dSMS.gateways.length > 1" ng-click="dSMS.dropped = !dSMS.dropped;" ng-class="{dropped: dSMS.dropped}"></button>\n\n            <ul class="multi-gateway-toggles" ng-if="dSMS.dropped">\n                <li ng-repeat="gateway in dSMS.gateways">\n                    <span ng-if="!gateway.id_string"><span translate="devices.gatewayMAC"></span>: {{gateway.mac_addr | cleanMac | lastFourMac}}</span>\n                    <span ng-if="gateway.id_string">{{gateway.id_string}}</span>\n                    <span class="unavailable" ng-if="gateway.gateway_health === 0 || gateway.gateway_health === 2 || gateway.gateway_health === 3" translate="common.unavailable">Unavailable</span>\n                    <devices-setup-mode-toggle gateway-id="gateway.id" setup-mode="gateway.setup_mode" site-id="dSMS.siteId;"></devices-setup-mode-toggle>\n                </li>\n            </ul>\n        </section>\n    ',
                bindings: {
                    gateways: '<',
                    siteId: '<'
                },
                controllerAs: 'dSMS',
                controller: function controller() {

                    var dSMS = this;

                    dSMS.$onChanges = function (changes) {
                        //console.log(changes);

                        // if(changes.gateways){
                        //     dSMS.setupMode = changes.setupMode.currentValue;
                        //     finishToggle();
                        // }
                    };
                }
            };

            _export('default', devicesSetupModeSectionComponent);
        }
    };
});

$__System.register('1d8', [], function (_export) {
    'use strict';

    var devicesSubSectionMenuComponent;
    return {
        setters: [],
        execute: function () {
            devicesSubSectionMenuComponent = {
                template: '<section class="top-menu-bar">\n            <a ui-sref="Devices({siteId:dSSM.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'devices\'})" ui-sref-active="{\'active\': \'Devices.**\'}" class="top-menu-link" translate="common.devices">Devices</a>\n            <a ui-sref="Automations({siteId:dSSM.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'automations\'})" ui-sref-active="{\'active\': \'Automations.**\'}" class="top-menu-link" translate="common.automations">Automations</a>\n            <!-- Hide until ready - Jason 10/20\n                <a ui-sref="Updates({siteId:dSSM.siteId, userSelectedFilter: null, leftMenuSpecialContext: \'devices\'})" ui-sref-active="{\'active\': \'Updates.**\'}" class="top-menu-link" translate="common.updates">Updates</a>\n            -->\n        </section>\n    ',
                bindings: {
                    siteId: '<'
                },
                controllerAs: 'dSSM',
                controller: function controller() {

                    var dSSM = this;

                    dSSM.$onChanges = function (changes) {
                        //
                    };
                }
            };

            _export('default', devicesSubSectionMenuComponent);
        }
    };
});

$__System.registerDynamic('1d9', [], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;

    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
    }
    (function () {
        try {
            if (typeof setTimeout === 'function') {
                cachedSetTimeout = setTimeout;
            } else {
                cachedSetTimeout = defaultSetTimout;
            }
        } catch (e) {
            cachedSetTimeout = defaultSetTimout;
        }
        try {
            if (typeof clearTimeout === 'function') {
                cachedClearTimeout = clearTimeout;
            } else {
                cachedClearTimeout = defaultClearTimeout;
            }
        } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
        }
    })();
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e) {
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }

    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }

    process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};

    function noop() {}

    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;

    process.listeners = function (name) {
        return [];
    };

    process.binding = function (name) {
        throw new Error('process.binding is not supported');
    };

    process.cwd = function () {
        return '/';
    };
    process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
        return 0;
    };
});
$__System.registerDynamic("1da", ["1d9"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("1d9");
});
$__System.registerDynamic('1db', ['1da'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__System._nodeRequire ? process : $__require('1da');
});
$__System.registerDynamic("f9", ["1db"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("1db");
});
$__System.registerDynamic('1dc', ['f9'], true, function ($__require, exports, module) {
  /* */
  "format cjs";

  var global = this || self,
      GLOBAL = global;
  (function (process) {
    ;
    (function () {
      var undefined;
      var VERSION = '4.0.0';
      var BIND_FLAG = 1,
          BIND_KEY_FLAG = 2,
          CURRY_BOUND_FLAG = 4,
          CURRY_FLAG = 8,
          CURRY_RIGHT_FLAG = 16,
          PARTIAL_FLAG = 32,
          PARTIAL_RIGHT_FLAG = 64,
          ARY_FLAG = 128,
          REARG_FLAG = 256,
          FLIP_FLAG = 512;
      var UNORDERED_COMPARE_FLAG = 1,
          PARTIAL_COMPARE_FLAG = 2;
      var DEFAULT_TRUNC_LENGTH = 30,
          DEFAULT_TRUNC_OMISSION = '...';
      var HOT_COUNT = 150,
          HOT_SPAN = 16;
      var LARGE_ARRAY_SIZE = 200;
      var LAZY_FILTER_FLAG = 1,
          LAZY_MAP_FLAG = 2,
          LAZY_WHILE_FLAG = 3;
      var FUNC_ERROR_TEXT = 'Expected a function';
      var HASH_UNDEFINED = '__lodash_hash_undefined__';
      var INFINITY = 1 / 0,
          MAX_SAFE_INTEGER = 9007199254740991,
          MAX_INTEGER = 1.7976931348623157e+308,
          NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295,
          MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
          HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var PLACEHOLDER = '__lodash_placeholder__';
      var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          objectTag = '[object Object]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]',
          weakMapTag = '[object WeakMap]';
      var arrayBufferTag = '[object ArrayBuffer]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';
      var reEmptyStringLeading = /\b__p \+= '';/g,
          reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
          reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
          reUnescapedHtml = /[&<>"'`]/g,
          reHasEscapedHtml = RegExp(reEscapedHtml.source),
          reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g,
          reEvaluate = /<%([\s\S]+?)%>/g,
          reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          reIsPlainProp = /^\w*$/,
          rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
          reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrim = /^\s+|\s+$/g,
          reTrimStart = /^\s+/,
          reTrimEnd = /\s+$/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reHasHexPrefix = /^0x/i;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = '\\ud800-\\udfff',
          rsComboRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
          rsDingbatRange = '\\u2700-\\u27bf',
          rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
          rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
          rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
          rsQuoteRange = '\\u2018\\u2019\\u201c\\u201d',
          rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
          rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
          rsVarRange = '\\ufe0e\\ufe0f',
          rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;
      var rsAstral = '[' + rsAstralRange + ']',
          rsBreak = '[' + rsBreakRange + ']',
          rsCombo = '[' + rsComboRange + ']',
          rsDigits = '\\d+',
          rsDingbat = '[' + rsDingbatRange + ']',
          rsLower = '[' + rsLowerRange + ']',
          rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
          rsModifier = '(?:\\ud83c[\\udffb-\\udfff])',
          rsNonAstral = '[^' + rsAstralRange + ']',
          rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
          rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
          rsUpper = '[' + rsUpperRange + ']',
          rsZWJ = '\\u200d';
      var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
          rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
          reOptMod = rsModifier + '?',
          rsOptVar = '[' + rsVarRange + ']?',
          rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
          rsSeq = rsOptVar + reOptMod + rsOptJoin,
          rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
          rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
      var reComboMark = RegExp(rsCombo, 'g');
      var reComplexSymbol = RegExp(rsSymbol + rsSeq, 'g');
      var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
      var reBasicWord = /[a-zA-Z0-9]+/g;
      var reComplexWord = RegExp([rsUpper + '?' + rsLower + '+(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsUpperMisc + '+(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')', rsUpper + '?' + rsLowerMisc + '+', rsDigits + '(?:' + rsLowerMisc + '+)?', rsEmoji].join('|'), 'g');
      var reHasComplexWord = /[a-z][A-Z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = ['Array', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcC': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xeC': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss'
      };
      var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#96;'
      };
      var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&#96;': '`'
      };
      var objectTypes = {
        'function': true,
        'object': true
      };
      var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
      };
      var freeParseFloat = parseFloat,
          freeParseInt = parseInt;
      var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType ? exports : null;
      var freeModule = objectTypes[typeof module] && module && !module.nodeType ? module : null;
      var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
      var freeSelf = checkGlobal(objectTypes[typeof self] && self);
      var freeWindow = checkGlobal(objectTypes[typeof window] && window);
      var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
      var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
      var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
      function addMapEntry(map, pair) {
        map.set(pair[0], pair[1]);
        return map;
      }
      function addSetEntry(set, value) {
        set.add(value);
        return set;
      }
      function apply(func, thisArg, args) {
        var length = args ? args.length : 0;
        switch (length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayConcat(array, other) {
        var index = -1,
            length = array.length,
            othIndex = -1,
            othLength = other.length,
            result = Array(length + othLength);
        while (++index < length) {
          result[index] = array[index];
        }
        while (++othIndex < othLength) {
          result[index++] = other[othIndex];
        }
        return result;
      }
      function arrayEach(array, iteratee) {
        var index = -1,
            length = array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1,
            length = array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1,
            length = array.length,
            resIndex = -1,
            result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[++resIndex] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        return !!array.length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1,
            length = array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1,
            length = array.length,
            result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1,
            length = values.length,
            offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initFromArray) {
        var index = -1,
            length = array.length;
        if (initFromArray && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
        var length = array.length;
        if (initFromArray && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1,
            length = array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
            length = array.length;
        while (++index < length) {
          var value = array[index],
              current = iteratee(value);
          if (current != null && (computed === undefined ? current === current : comparator(current, computed))) {
            var computed = current,
                result = value;
          }
        }
        return result;
      }
      function baseFind(collection, predicate, eachFunc, retKey) {
        var result;
        eachFunc(collection, function (value, key, collection) {
          if (predicate(value, key, collection)) {
            result = retKey ? key : value;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromRight) {
        var length = array.length,
            index = fromRight ? length : -1;
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        if (value !== value) {
          return indexOfNaN(array, fromIndex);
        }
        var index = fromIndex - 1,
            length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
        eachFunc(collection, function (value, index, collection) {
          accumulator = initFromCollection ? (initFromCollection = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result,
            index = -1,
            length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined) {
            result = result === undefined ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1,
            result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function (key) {
          return [key, object[key]];
        });
      }
      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1,
            length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }
      function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsNull = value === null,
              valIsUndef = value === undefined,
              valIsReflexive = value === value;
          var othIsNull = other === null,
              othIsUndef = other === undefined,
              othIsReflexive = other === other;
          if (value > other && !othIsNull || !valIsReflexive || valIsNull && !othIsUndef && othIsReflexive || valIsUndef && othIsReflexive) {
            return 1;
          }
          if (value < other && !valIsNull || !othIsReflexive || othIsNull && !valIsUndef && valIsReflexive || othIsUndef && valIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index = -1,
            objCriteria = object.criteria,
            othCriteria = other.criteria,
            length = objCriteria.length,
            ordersLength = orders.length;
        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function deburrLetter(letter) {
        return deburredLetters[letter];
      }
      function escapeHtmlChar(chr) {
        return htmlEscapes[chr];
      }
      function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
      }
      function indexOfNaN(array, fromIndex, fromRight) {
        var length = array.length,
            index = fromIndex + (fromRight ? 0 : -1);
        while (fromRight ? index-- : ++index < length) {
          var other = array[index];
          if (other !== other) {
            return index;
          }
        }
        return -1;
      }
      function isHostObject(value) {
        var result = false;
        if (value != null && typeof value.toString != 'function') {
          try {
            result = !!(value + '');
          } catch (e) {}
        }
        return result;
      }
      function isIndex(value, length) {
        value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return value > -1 && value % 1 == 0 && value < length;
      }
      function iteratorToArray(iterator) {
        var data,
            result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1,
            result = Array(map.size);
        map.forEach(function (value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function replaceHolders(array, placeholder) {
        var index = -1,
            length = array.length,
            resIndex = -1,
            result = [];
        while (++index < length) {
          if (array[index] === placeholder) {
            array[index] = PLACEHOLDER;
            result[++resIndex] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1,
            result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = value;
        });
        return result;
      }
      function stringSize(string) {
        if (!(string && reHasComplexSymbol.test(string))) {
          return string.length;
        }
        var result = reComplexSymbol.lastIndex = 0;
        while (reComplexSymbol.test(string)) {
          result++;
        }
        return result;
      }
      function stringToArray(string) {
        return string.match(reComplexSymbol);
      }
      function unescapeHtmlChar(chr) {
        return htmlUnescapes[chr];
      }
      function runInContext(context) {
        context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
        var Date = context.Date,
            Error = context.Error,
            Math = context.Math,
            RegExp = context.RegExp,
            TypeError = context.TypeError;
        var arrayProto = context.Array.prototype,
            objectProto = context.Object.prototype;
        var funcToString = context.Function.prototype.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var objectCtorString = funcToString.call(Object);
        var objectToString = objectProto.toString;
        var oldDash = root._;
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        var _Symbol = context.Symbol,
            Reflect = context.Reflect,
            Uint8Array = context.Uint8Array,
            clearTimeout = context.clearTimeout,
            enumerate = Reflect ? Reflect.enumerate : undefined,
            getPrototypeOf = Object.getPrototypeOf,
            getOwnPropertySymbols = Object.getOwnPropertySymbols,
            iteratorSymbol = typeof (iteratorSymbol = _Symbol && _Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
            propertyIsEnumerable = objectProto.propertyIsEnumerable,
            setTimeout = context.setTimeout,
            splice = arrayProto.splice;
        var nativeCeil = Math.ceil,
            nativeFloor = Math.floor,
            nativeIsFinite = context.isFinite,
            nativeJoin = arrayProto.join,
            nativeKeys = Object.keys,
            nativeMax = Math.max,
            nativeMin = Math.min,
            nativeParseInt = context.parseInt,
            nativeRandom = Math.random,
            nativeReverse = arrayProto.reverse;
        var Map = getNative(context, 'Map'),
            Set = getNative(context, 'Set'),
            WeakMap = getNative(context, 'WeakMap'),
            nativeCreate = getNative(Object, 'create');
        var metaMap = WeakMap && new WeakMap();
        var mapCtorString = Map ? funcToString.call(Map) : '',
            setCtorString = Set ? funcToString.call(Set) : '';
        var symbolProto = _Symbol ? _Symbol.prototype : undefined,
            symbolValueOf = _Symbol ? symbolProto.valueOf : undefined,
            symbolToString = _Symbol ? symbolProto.toString : undefined;
        var realNames = {};
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, '__wrapped__')) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        function baseLodash() {}
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined;
        }
        lodash.templateSettings = {
          'escape': reEscape,
          'evaluate': reEvaluate,
          'interpolate': reInterpolate,
          'variable': '',
          'imports': { '_': lodash }
        };
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result = new LazyWrapper(this.__wrapped__);
          result.__actions__ = copyArray(this.__actions__);
          result.__dir__ = this.__dir__;
          result.__filtered__ = this.__filtered__;
          result.__iteratees__ = copyArray(this.__iteratees__);
          result.__takeCount__ = this.__takeCount__;
          result.__views__ = copyArray(this.__views__);
          return result;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result = new LazyWrapper(this);
            result.__dir__ = -1;
            result.__filtered__ = true;
          } else {
            result = this.clone();
            result.__dir__ *= -1;
          }
          return result;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(),
              dir = this.__dir__,
              isArr = isArray(array),
              isRight = dir < 0,
              arrLength = isArr ? array.length : 0,
              view = getView(0, arrLength, this.__views__),
              start = view.start,
              end = view.end,
              length = end - start,
              index = isRight ? end : start - 1,
              iteratees = this.__iteratees__,
              iterLength = iteratees.length,
              resIndex = 0,
              takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || arrLength < LARGE_ARRAY_SIZE || arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result = [];
          outer: while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1,
                value = array[index];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex],
                  iteratee = data.iteratee,
                  type = data.type,
                  computed = iteratee(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result[resIndex++] = value;
          }
          return result;
        }
        function Hash() {}
        function hashDelete(hash, key) {
          return hashHas(hash, key) && delete hash[key];
        }
        function hashGet(hash, key) {
          if (nativeCreate) {
            var result = hash[key];
            return result === HASH_UNDEFINED ? undefined : result;
          }
          return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
        }
        function hashHas(hash, key) {
          return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
        }
        function hashSet(hash, key, value) {
          hash[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        }
        function MapCache(values) {
          var index = -1,
              length = values ? values.length : 0;
          this.clear();
          while (++index < length) {
            var entry = values[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapClear() {
          this.__data__ = {
            'hash': new Hash(),
            'map': Map ? new Map() : [],
            'string': new Hash()
          };
        }
        function mapDelete(key) {
          var data = this.__data__;
          if (isKeyable(key)) {
            return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
          }
          return Map ? data.map['delete'](key) : assocDelete(data.map, key);
        }
        function mapGet(key) {
          var data = this.__data__;
          if (isKeyable(key)) {
            return hashGet(typeof key == 'string' ? data.string : data.hash, key);
          }
          return Map ? data.map.get(key) : assocGet(data.map, key);
        }
        function mapHas(key) {
          var data = this.__data__;
          if (isKeyable(key)) {
            return hashHas(typeof key == 'string' ? data.string : data.hash, key);
          }
          return Map ? data.map.has(key) : assocHas(data.map, key);
        }
        function mapSet(key, value) {
          var data = this.__data__;
          if (isKeyable(key)) {
            hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
          } else if (Map) {
            data.map.set(key, value);
          } else {
            assocSet(data.map, key, value);
          }
          return this;
        }
        function SetCache(values) {
          var index = -1,
              length = values ? values.length : 0;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.push(values[index]);
          }
        }
        function cacheHas(cache, value) {
          var map = cache.__data__;
          if (isKeyable(value)) {
            var data = map.__data__,
                hash = typeof value == 'string' ? data.string : data.hash;
            return hash[value] === HASH_UNDEFINED;
          }
          return map.has(value);
        }
        function cachePush(value) {
          var map = this.__data__;
          if (isKeyable(value)) {
            var data = map.__data__,
                hash = typeof value == 'string' ? data.string : data.hash;
            hash[value] = HASH_UNDEFINED;
          } else {
            map.set(value, HASH_UNDEFINED);
          }
        }
        function Stack(values) {
          var index = -1,
              length = values ? values.length : 0;
          this.clear();
          while (++index < length) {
            var entry = values[index];
            this.set(entry[0], entry[1]);
          }
        }
        function stackClear() {
          this.__data__ = {
            'array': [],
            'map': null
          };
        }
        function stackDelete(key) {
          var data = this.__data__,
              array = data.array;
          return array ? assocDelete(array, key) : data.map['delete'](key);
        }
        function stackGet(key) {
          var data = this.__data__,
              array = data.array;
          return array ? assocGet(array, key) : data.map.get(key);
        }
        function stackHas(key) {
          var data = this.__data__,
              array = data.array;
          return array ? assocHas(array, key) : data.map.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__,
              array = data.array;
          if (array) {
            if (array.length < LARGE_ARRAY_SIZE - 1) {
              assocSet(array, key, value);
            } else {
              data.array = null;
              data.map = new MapCache(array);
            }
          }
          var map = data.map;
          if (map) {
            map.set(key, value);
          }
          return this;
        }
        function assocDelete(array, key) {
          var index = assocIndexOf(array, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = array.length - 1;
          if (index == lastIndex) {
            array.pop();
          } else {
            splice.call(array, index, 1);
          }
          return true;
        }
        function assocGet(array, key) {
          var index = assocIndexOf(array, key);
          return index < 0 ? undefined : array[index][1];
        }
        function assocHas(array, key) {
          return assocIndexOf(array, key) > -1;
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function assocSet(array, key, value) {
          var index = assocIndexOf(array, key);
          if (index < 0) {
            array.push([key, value]);
          } else {
            array[index][1] = value;
          }
        }
        function assignInDefaults(objValue, srcValue, key, object) {
          if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined && !eq(object[key], value) || typeof key == 'number' && value === undefined && !(key in object)) {
            object[key] = value;
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!eq(objValue, value) || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key) || value === undefined && !(key in object)) {
            object[key] = value;
          }
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAt(object, paths) {
          var index = -1,
              isNil = object == null,
              length = paths.length,
              result = Array(length);
          while (++index < length) {
            result[index] = isNil ? undefined : get(object, paths[index]);
          }
          return result;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, isDeep, customizer, key, object, stack) {
          var result;
          if (customizer) {
            result = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result !== undefined) {
            return result;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result);
            }
          } else {
            var tag = getTag(value),
                isFunc = tag == funcTag || tag == genTag;
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              if (isHostObject(value)) {
                return object ? value : {};
              }
              result = initCloneObject(isFunc ? {} : value);
              if (!isDeep) {
                return copySymbols(value, baseAssign(result, value));
              }
            } else {
              return cloneableTags[tag] ? initCloneByTag(value, tag, isDeep) : object ? value : {};
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result);
          (isArr ? arrayEach : baseForOwn)(value, function (subValue, key) {
            assignValue(result, key, baseClone(subValue, isDeep, customizer, key, value, stack));
          });
          return isArr ? result : copySymbols(value, result);
        }
        function baseConforms(source) {
          var props = keys(source),
              length = props.length;
          return function (object) {
            if (object == null) {
              return !length;
            }
            var index = length;
            while (index--) {
              var key = props[index],
                  predicate = source[key],
                  value = object[key];
              if (value === undefined && !(key in Object(object)) || !predicate(value)) {
                return false;
              }
            }
            return true;
          };
        }
        var baseCreate = function () {
          function object() {}
          return function (prototype) {
            if (isObject(prototype)) {
              object.prototype = prototype;
              var result = new object();
              object.prototype = undefined;
            }
            return result || {};
          };
        }();
        function baseDelay(func, wait, args) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return setTimeout(function () {
            func.apply(undefined, args);
          }, wait);
        }
        function baseDifference(array, values, iteratee, comparator) {
          var index = -1,
              includes = arrayIncludes,
              isCommon = true,
              length = array.length,
              result = [],
              valuesLength = values.length;
          if (!length) {
            return result;
          }
          if (iteratee) {
            values = arrayMap(values, baseUnary(iteratee));
          }
          if (comparator) {
            includes = arrayIncludesWith;
            isCommon = false;
          } else if (values.length >= LARGE_ARRAY_SIZE) {
            includes = cacheHas;
            isCommon = false;
            values = new SetCache(values);
          }
          outer: while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result.push(value);
            } else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }
          return result;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result = true;
          baseEach(collection, function (value, index, collection) {
            result = !!predicate(value, index, collection);
            return result;
          });
          return result;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result = [];
          baseEach(collection, function (value, index, collection) {
            if (predicate(value, index, collection)) {
              result.push(value);
            }
          });
          return result;
        }
        function baseFlatten(array, isDeep, isStrict, result) {
          result || (result = []);
          var index = -1,
              length = array.length;
          while (++index < length) {
            var value = array[index];
            if (isArrayLikeObject(value) && (isStrict || isArray(value) || isArguments(value))) {
              if (isDeep) {
                baseFlatten(value, isDeep, isStrict, result);
              } else {
                arrayPush(result, value);
              }
            } else if (!isStrict) {
              result[result.length] = value;
            }
          }
          return result;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForIn(object, iteratee) {
          return object == null ? object : baseFor(object, iteratee, keysIn);
        }
        function baseForOwn(object, iteratee) {
          return object && baseFor(object, iteratee, keys);
        }
        function baseForOwnRight(object, iteratee) {
          return object && baseForRight(object, iteratee, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function (key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = isKey(path, object) ? [path + ''] : baseToPath(path);
          var index = 0,
              length = path.length;
          while (object != null && index < length) {
            object = object[path[index++]];
          }
          return index && index == length ? object : undefined;
        }
        function baseHas(object, key) {
          return hasOwnProperty.call(object, key) || typeof object == 'object' && key in object && getPrototypeOf(object) === null;
        }
        function baseHasIn(object, key) {
          return key in Object(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee, comparator) {
          var includes = comparator ? arrayIncludesWith : arrayIncludes,
              othLength = arrays.length,
              othIndex = othLength,
              caches = Array(othLength),
              result = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee) {
              array = arrayMap(array, baseUnary(iteratee));
            }
            caches[othIndex] = !comparator && (iteratee || array.length >= 120) ? new SetCache(othIndex && array) : undefined;
          }
          array = arrays[0];
          var index = -1,
              length = array.length,
              seen = caches[0];
          outer: while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;
            if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
              var othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }
        function baseInvoke(object, path, args) {
          if (!isKey(path, object)) {
            path = baseToPath(path);
            object = parent(object, path);
            path = last(path);
          }
          var func = object == null ? object : object[path];
          return func == null ? undefined : apply(func, object, args);
        }
        function baseIsEqual(value, other, customizer, bitmask, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
        }
        function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
          var objIsArr = isArray(object),
              othIsArr = isArray(other),
              objTag = arrayTag,
              othTag = arrayTag;
          if (!objIsArr) {
            objTag = getTag(object);
            if (objTag == argsTag) {
              objTag = objectTag;
            } else if (objTag != objectTag) {
              objIsArr = isTypedArray(object);
            }
          }
          if (!othIsArr) {
            othTag = getTag(other);
            if (othTag == argsTag) {
              othTag = objectTag;
            } else if (othTag != objectTag) {
              othIsArr = isTypedArray(other);
            }
          }
          var objIsObj = objTag == objectTag && !isHostObject(object),
              othIsObj = othTag == objectTag && !isHostObject(other),
              isSameTag = objTag == othTag;
          if (isSameTag && !(objIsArr || objIsObj)) {
            return equalByTag(object, other, objTag, equalFunc, customizer, bitmask);
          }
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
          if (!isPartial) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
            if (objIsWrapped || othIsWrapped) {
              return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, bitmask, stack);
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length,
              length = index,
              noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0],
                objValue = object[key],
                srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack(),
                  result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;
              if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIteratee(value) {
          var type = typeof value;
          if (type == 'function') {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (type == 'object') {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          return nativeKeys(Object(object));
        }
        function baseKeysIn(object) {
          object = object == null ? object : Object(object);
          var result = [];
          for (var key in object) {
            result.push(key);
          }
          return result;
        }
        if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
          baseKeysIn = function (object) {
            return iteratorToArray(enumerate(object));
          };
        }
        function baseMap(collection, iteratee) {
          var index = -1,
              result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value, key, collection) {
            result[++index] = iteratee(value, key, collection);
          });
          return result;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            var key = matchData[0][0],
                value = matchData[0][1];
            return function (object) {
              if (object == null) {
                return false;
              }
              return object[key] === value && (value !== undefined || key in Object(object));
            };
          }
          return function (object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          return function (object) {
            var objValue = get(object, path);
            return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
          };
        }
        function baseMerge(object, source, customizer, stack) {
          if (object === source) {
            return;
          }
          var props = isArray(source) || isTypedArray(source) ? undefined : keysIn(source);
          arrayEach(props || source, function (srcValue, key) {
            if (props) {
              key = srcValue;
              srcValue = source[key];
            }
            if (isObject(srcValue)) {
              stack || (stack = new Stack());
              baseMergeDeep(object, source, key, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(object[key], srcValue, key + '', object, source, stack) : undefined;
              if (newValue === undefined) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          });
        }
        function baseMergeDeep(object, source, key, mergeFunc, customizer, stack) {
          var objValue = object[key],
              srcValue = source[key],
              stacked = stack.get(srcValue) || stack.get(objValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined,
              isCommon = newValue === undefined;
          if (isCommon) {
            newValue = srcValue;
            if (isArray(srcValue) || isTypedArray(srcValue)) {
              newValue = isArray(objValue) ? objValue : isArrayLikeObject(objValue) ? copyArray(objValue) : baseClone(srcValue);
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = isArguments(objValue) ? toPlainObject(objValue) : isObject(objValue) ? objValue : baseClone(srcValue);
            } else {
              isCommon = isFunction(srcValue);
            }
          }
          stack.set(srcValue, newValue);
          if (isCommon) {
            mergeFunc(newValue, srcValue, customizer, stack);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseOrderBy(collection, iteratees, orders) {
          var index = -1,
              toIteratee = getIteratee();
          iteratees = arrayMap(iteratees.length ? iteratees : Array(1), function (iteratee) {
            return toIteratee(iteratee);
          });
          var result = baseMap(collection, function (value, key, collection) {
            var criteria = arrayMap(iteratees, function (iteratee) {
              return iteratee(value);
            });
            return {
              'criteria': criteria,
              'index': ++index,
              'value': value
            };
          });
          return baseSortBy(result, function (object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, props) {
          object = Object(object);
          return arrayReduce(props, function (result, key) {
            if (key in object) {
              result[key] = object[key];
            }
            return result;
          }, {});
        }
        function basePickBy(object, predicate) {
          var result = {};
          baseForIn(object, function (value, key) {
            if (predicate(value)) {
              result[key] = value;
            }
          });
          return result;
        }
        function baseProperty(key) {
          return function (object) {
            return object == null ? undefined : object[key];
          };
        }
        function basePropertyDeep(path) {
          return function (object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values) {
          return basePullAllBy(array, values);
        }
        function basePullAllBy(array, values, iteratee) {
          var index = -1,
              length = values.length,
              seen = array;
          if (iteratee) {
            seen = arrayMap(array, function (value) {
              return iteratee(value);
            });
          }
          while (++index < length) {
            var fromIndex = 0,
                value = values[index],
                computed = iteratee ? iteratee(value) : value;
            while ((fromIndex = baseIndexOf(seen, computed, fromIndex)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0,
              lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (lastIndex == length || index != previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else if (!isKey(index, array)) {
                var path = baseToPath(index),
                    object = parent(array, path);
                if (object != null) {
                  delete object[last(path)];
                }
              } else {
                delete array[index];
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1,
              length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
              result = Array(length);
          while (length--) {
            result[fromRight ? length : ++index] = start;
            start += step;
          }
          return result;
        }
        function baseSet(object, path, value, customizer) {
          path = isKey(path, object) ? [path + ''] : baseToPath(path);
          var index = -1,
              length = path.length,
              lastIndex = length - 1,
              nested = object;
          while (nested != null && ++index < length) {
            var key = path[index];
            if (isObject(nested)) {
              var newValue = value;
              if (index != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined;
                if (newValue === undefined) {
                  newValue = objValue == null ? isIndex(path[index + 1]) ? [] : {} : objValue;
                }
              }
              assignValue(nested, key, newValue);
            }
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function (func, data) {
          metaMap.set(func, data);
          return func;
        };
        function baseSlice(array, start, end) {
          var index = -1,
              length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result = Array(length);
          while (++index < length) {
            result[index] = array[index + start];
          }
          return result;
        }
        function baseSome(collection, predicate) {
          var result;
          baseEach(collection, function (value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
          });
          return !!result;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0,
              high = array ? array.length : low;
          if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1,
                  computed = array[mid];
              if ((retHighest ? computed <= value : computed < value) && computed !== null) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee, retHighest) {
          value = iteratee(value);
          var low = 0,
              high = array ? array.length : 0,
              valIsNaN = value !== value,
              valIsNull = value === null,
              valIsUndef = value === undefined;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2),
                computed = iteratee(array[mid]),
                isDef = computed !== undefined,
                isReflexive = computed === computed;
            if (valIsNaN) {
              var setLow = isReflexive || retHighest;
            } else if (valIsNull) {
              setLow = isReflexive && isDef && (retHighest || computed != null);
            } else if (valIsUndef) {
              setLow = isReflexive && (retHighest || isDef);
            } else if (computed == null) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array) {
          return baseSortedUniqBy(array);
        }
        function baseSortedUniqBy(array, iteratee) {
          var index = 0,
              length = array.length,
              value = array[0],
              computed = iteratee ? iteratee(value) : value,
              seen = computed,
              resIndex = 0,
              result = [value];
          while (++index < length) {
            value = array[index], computed = iteratee ? iteratee(value) : value;
            if (!eq(computed, seen)) {
              seen = computed;
              result[++resIndex] = value;
            }
          }
          return result;
        }
        function baseToPath(value) {
          return isArray(value) ? value : stringToPath(value);
        }
        function baseUniq(array, iteratee, comparator) {
          var index = -1,
              includes = arrayIncludes,
              length = array.length,
              isCommon = true,
              result = [],
              seen = result;
          if (comparator) {
            isCommon = false;
            includes = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set = iteratee ? null : createSet(array);
            if (set) {
              return setToArray(set);
            }
            isCommon = false;
            includes = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee ? [] : result;
          }
          outer: while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee) {
                seen.push(computed);
              }
              result.push(value);
            } else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }
        function baseUnset(object, path) {
          path = isKey(path, object) ? [path + ''] : baseToPath(path);
          object = parent(object, path);
          var key = last(path);
          return object != null && has(object, key) ? delete object[key] : true;
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length,
              index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result = value;
          if (result instanceof LazyWrapper) {
            result = result.value();
          }
          return arrayReduce(actions, function (result, action) {
            return action.func.apply(action.thisArg, arrayPush([result], action.args));
          }, result);
        }
        function baseXor(arrays, iteratee, comparator) {
          var index = -1,
              length = arrays.length;
          while (++index < length) {
            var result = result ? arrayPush(baseDifference(result, arrays[index], iteratee, comparator), baseDifference(arrays[index], result, iteratee, comparator)) : arrays[index];
          }
          return result && result.length ? baseUniq(result, iteratee, comparator) : [];
        }
        function cloneBuffer(buffer) {
          var Ctor = buffer.constructor,
              result = new Ctor(buffer.byteLength),
              view = new Uint8Array(result);
          view.set(new Uint8Array(buffer));
          return result;
        }
        function cloneMap(map) {
          var Ctor = map.constructor;
          return arrayReduce(mapToArray(map), addMapEntry, new Ctor());
        }
        function cloneRegExp(regexp) {
          var Ctor = regexp.constructor,
              result = new Ctor(regexp.source, reFlags.exec(regexp));
          result.lastIndex = regexp.lastIndex;
          return result;
        }
        function cloneSet(set) {
          var Ctor = set.constructor;
          return arrayReduce(setToArray(set), addSetEntry, new Ctor());
        }
        function cloneSymbol(symbol) {
          return _Symbol ? Object(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = typedArray.buffer,
              Ctor = typedArray.constructor;
          return new Ctor(isDeep ? cloneBuffer(buffer) : buffer, typedArray.byteOffset, typedArray.length);
        }
        function composeArgs(args, partials, holders) {
          var holdersLength = holders.length,
              argsIndex = -1,
              argsLength = nativeMax(args.length - holdersLength, 0),
              leftIndex = -1,
              leftLength = partials.length,
              result = Array(leftLength + argsLength);
          while (++leftIndex < leftLength) {
            result[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
          while (argsLength--) {
            result[leftIndex++] = args[argsIndex++];
          }
          return result;
        }
        function composeArgsRight(args, partials, holders) {
          var holdersIndex = -1,
              holdersLength = holders.length,
              argsIndex = -1,
              argsLength = nativeMax(args.length - holdersLength, 0),
              rightIndex = -1,
              rightLength = partials.length,
              result = Array(argsLength + rightLength);
          while (++argsIndex < argsLength) {
            result[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
          return result;
        }
        function copyArray(source, array) {
          var index = -1,
              length = source.length;
          array || (array = Array(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object) {
          return copyObjectWith(source, props, object);
        }
        function copyObjectWith(source, props, object, customizer) {
          object || (object = {});
          var index = -1,
              length = props.length;
          while (++index < length) {
            var key = props[index],
                newValue = customizer ? customizer(object[key], source[key], key, object, source) : source[key];
            assignValue(object, key, newValue);
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function createAggregator(setter, initializer) {
          return function (collection, iteratee) {
            var result = initializer ? initializer() : {};
            iteratee = getIteratee(iteratee);
            if (isArray(collection)) {
              var index = -1,
                  length = collection.length;
              while (++index < length) {
                var value = collection[index];
                setter(result, value, iteratee(value), collection);
              }
            } else {
              baseEach(collection, function (value, key, collection) {
                setter(result, value, iteratee(value), collection);
              });
            }
            return result;
          };
        }
        function createAssigner(assigner) {
          return rest(function (object, sources) {
            var index = -1,
                length = sources.length,
                customizer = length > 1 ? sources[length - 1] : undefined,
                guard = length > 2 ? sources[2] : undefined;
            customizer = typeof customizer == 'function' ? (length--, customizer) : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }
            object = Object(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function (collection, iteratee) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee);
            }
            var length = collection.length,
                index = fromRight ? length : -1,
                iterable = Object(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
                iterable = Object(object),
                props = keysFunc(object),
                length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBaseWrapper(func, bitmask, thisArg) {
          var isBind = bitmask & BIND_FLAG,
              Ctor = createCtorWrapper(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function (string) {
            string = toString(string);
            var strSymbols = reHasComplexSymbol.test(string) ? stringToArray(string) : undefined,
                chr = strSymbols ? strSymbols[0] : string.charAt(0),
                trailing = strSymbols ? strSymbols.slice(1).join('') : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function (string) {
            return arrayReduce(words(deburr(string)), callback, '');
          };
        }
        function createCtorWrapper(Ctor) {
          return function () {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype),
                result = Ctor.apply(thisBinding, args);
            return isObject(result) ? result : thisBinding;
          };
        }
        function createCurryWrapper(func, bitmask, arity) {
          var Ctor = createCtorWrapper(func);
          function wrapper() {
            var length = arguments.length,
                index = length,
                args = Array(length),
                fn = this && this !== root && this instanceof wrapper ? Ctor : func,
                placeholder = wrapper.placeholder;
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            return length < arity ? createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, undefined, args, holders, undefined, undefined, arity - length) : apply(fn, this, args);
          }
          return wrapper;
        }
        function createFlow(fromRight) {
          return rest(function (funcs) {
            funcs = baseFlatten(funcs);
            var length = funcs.length,
                index = length,
                prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func),
                  data = funcName == 'wrapper' ? getData(func) : undefined;
              if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function () {
              var args = arguments,
                  value = args[0];
              if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
                return wrapper.plant(value).value();
              }
              var index = 0,
                  result = length ? funcs[index].apply(this, args) : value;
              while (++index < length) {
                result = funcs[index].call(this, result);
              }
              return result;
            };
          });
        }
        function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
          var isAry = bitmask & ARY_FLAG,
              isBind = bitmask & BIND_FLAG,
              isBindKey = bitmask & BIND_KEY_FLAG,
              isCurry = bitmask & CURRY_FLAG,
              isCurryRight = bitmask & CURRY_RIGHT_FLAG,
              isFlip = bitmask & FLIP_FLAG,
              Ctor = isBindKey ? undefined : createCtorWrapper(func);
          function wrapper() {
            var length = arguments.length,
                index = length,
                args = Array(length);
            while (index--) {
              args[index] = arguments[index];
            }
            if (partials) {
              args = composeArgs(args, partials, holders);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight);
            }
            if (isCurry || isCurryRight) {
              var placeholder = wrapper.placeholder,
                  argsHolders = replaceHolders(args, placeholder);
              length -= argsHolders.length;
              if (length < arity) {
                return createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, thisArg, args, argsHolders, argPos, ary, arity - length);
              }
            }
            var thisBinding = isBind ? thisArg : this,
                fn = isBindKey ? thisBinding[func] : func;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && args.length > 1) {
              args.reverse();
            }
            if (isAry && ary < args.length) {
              args.length = ary;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtorWrapper(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createOver(arrayFunc) {
          return rest(function (iteratees) {
            iteratees = arrayMap(baseFlatten(iteratees), getIteratee());
            return rest(function (args) {
              var thisArg = this;
              return arrayFunc(iteratees, function (iteratee) {
                return apply(iteratee, thisArg, args);
              });
            });
          });
        }
        function createPadding(string, length, chars) {
          length = toInteger(length);
          var strLength = stringSize(string);
          if (!length || strLength >= length) {
            return '';
          }
          var padLength = length - strLength;
          chars = chars === undefined ? ' ' : chars + '';
          var result = repeat(chars, nativeCeil(padLength / stringSize(chars)));
          return reHasComplexSymbol.test(chars) ? stringToArray(result).slice(0, padLength).join('') : result.slice(0, padLength);
        }
        function createPartialWrapper(func, bitmask, thisArg, partials) {
          var isBind = bitmask & BIND_FLAG,
              Ctor = createCtorWrapper(func);
          function wrapper() {
            var argsIndex = -1,
                argsLength = arguments.length,
                leftIndex = -1,
                leftLength = partials.length,
                args = Array(leftLength + argsLength),
                fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function (start, end, step) {
            if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
              end = step = undefined;
            }
            start = toNumber(start);
            start = start === start ? start : 0;
            if (end === undefined) {
              end = start;
              start = 0;
            } else {
              end = toNumber(end) || 0;
            }
            step = step === undefined ? start < end ? 1 : -1 : toNumber(step) || 0;
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
          var isCurry = bitmask & CURRY_FLAG,
              newArgPos = argPos ? copyArray(argPos) : undefined,
              newsHolders = isCurry ? holders : undefined,
              newHoldersRight = isCurry ? undefined : holders,
              newPartials = isCurry ? partials : undefined,
              newPartialsRight = isCurry ? undefined : partials;
          bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
          if (!(bitmask & CURRY_BOUND_FLAG)) {
            bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
          }
          var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, arity],
              result = wrapFunc.apply(undefined, newData);
          if (isLaziable(func)) {
            setData(result, newData);
          }
          result.placeholder = placeholder;
          return result;
        }
        function createRound(methodName) {
          var func = Math[methodName];
          return function (number, precision) {
            number = toNumber(number);
            precision = toInteger(precision);
            if (precision) {
              var pair = (toString(number) + 'e').split('e'),
                  value = func(pair[0] + 'e' + (+pair[1] + precision));
              pair = (toString(value) + 'e').split('e');
              return +(pair[0] + 'e' + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function (values) {
          return new Set(values);
        };
        function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
          var isBindKey = bitmask & BIND_KEY_FLAG;
          if (!isBindKey && typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
          }
          ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
          arity = arity === undefined ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials,
                holdersRight = holders;
            partials = holders = undefined;
          }
          var data = isBindKey ? undefined : getData(func),
              newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] == null ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
            bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == BIND_FLAG) {
            var result = createBaseWrapper(func, bitmask, thisArg);
          } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
            result = createCurryWrapper(func, bitmask, arity);
          } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
            result = createPartialWrapper(func, bitmask, thisArg, partials);
          } else {
            result = createHybridWrapper.apply(undefined, newData);
          }
          var setter = data ? baseSetData : setData;
          return setter(result, newData);
        }
        function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
          var index = -1,
              isPartial = bitmask & PARTIAL_COMPARE_FLAG,
              isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
              arrLength = array.length,
              othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var stacked = stack.get(array);
          if (stacked) {
            return stacked == other;
          }
          var result = true;
          stack.set(array, other);
          while (++index < arrLength) {
            var arrValue = array[index],
                othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined) {
              if (compared) {
                continue;
              }
              result = false;
              break;
            }
            if (isUnordered) {
              if (!arraySome(other, function (othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
              })) {
                result = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              result = false;
              break;
            }
          }
          stack['delete'](array);
          return result;
        }
        function equalByTag(object, other, tag, equalFunc, customizer, bitmask) {
          switch (tag) {
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
              return +object == +other;
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case numberTag:
              return object != +object ? other != +other : object == +other;
            case regexpTag:
            case stringTag:
              return object == other + '';
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
              convert || (convert = setToArray);
              return (isPartial || object.size == other.size) && equalFunc(convert(object), convert(other), customizer, bitmask | UNORDERED_COMPARE_FLAG);
            case symbolTag:
              return !!_Symbol && symbolValueOf.call(object) == symbolValueOf.call(other);
          }
          return false;
        }
        function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
              isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
              objProps = keys(object),
              objLength = objProps.length,
              othProps = keys(other),
              othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : baseHas(other, key)) || !(isUnordered || key == othProps[index])) {
              return false;
            }
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          var result = true;
          stack.set(object, other);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key],
                othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
              result = false;
              break;
            }
            skipCtor || (skipCtor = key == 'constructor');
          }
          if (result && !skipCtor) {
            var objCtor = object.constructor,
                othCtor = other.constructor;
            if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
              result = false;
            }
          }
          stack['delete'](object);
          return result;
        }
        var getData = !metaMap ? noop : function (func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result = func.name + '',
              array = realNames[result],
              length = array ? array.length : 0;
          while (length--) {
            var data = array[length],
                otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result;
        }
        function getIteratee() {
          var result = lodash.iteratee || iteratee;
          result = result === iteratee ? baseIteratee : result;
          return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        var getLength = baseProperty('length');
        function getMatchData(object) {
          var result = toPairs(object),
              length = result.length;
          while (length--) {
            result[length][2] = isStrictComparable(result[length][1]);
          }
          return result;
        }
        function getNative(object, key) {
          var value = object == null ? undefined : object[key];
          return isNative(value) ? value : undefined;
        }
        var getSymbols = getOwnPropertySymbols || function () {
          return [];
        };
        function getTag(value) {
          return objectToString.call(value);
        }
        if (Map && getTag(new Map()) != mapTag || Set && getTag(new Set()) != setTag) {
          getTag = function (value) {
            var result = objectToString.call(value),
                Ctor = result == objectTag ? value.constructor : null,
                ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
            if (ctorString) {
              if (ctorString == mapCtorString) {
                return mapTag;
              }
              if (ctorString == setCtorString) {
                return setTag;
              }
            }
            return result;
          };
        }
        function getView(start, end, transforms) {
          var index = -1,
              length = transforms.length;
          while (++index < length) {
            var data = transforms[index],
                size = data.size;
            switch (data.type) {
              case 'drop':
                start += size;
                break;
              case 'dropRight':
                end -= size;
                break;
              case 'take':
                end = nativeMin(end, start + size);
                break;
              case 'takeRight':
                start = nativeMax(start, end - size);
                break;
            }
          }
          return {
            'start': start,
            'end': end
          };
        }
        function hasPath(object, path, hasFunc) {
          if (object == null) {
            return false;
          }
          var result = hasFunc(object, path);
          if (!result && !isKey(path)) {
            path = baseToPath(path);
            object = parent(object, path);
            if (object != null) {
              path = last(path);
              result = hasFunc(object, path);
            }
          }
          return result || isLength(object && object.length) && isIndex(path, object.length) && (isArray(object) || isString(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length,
              result = array.constructor(length);
          if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
            result.index = array.index;
            result.input = array.input;
          }
          return result;
        }
        function initCloneObject(object) {
          var Ctor = object.constructor;
          return baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return cloneMap(object);
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return cloneSet(object);
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function indexKeys(object) {
          var length = object ? object.length : undefined;
          return isLength(length) && (isArray(object) || isString(object) || isArguments(object)) ? baseTimes(length, String) : null;
        }
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (typeof value == 'number') {
            return true;
          }
          return !isArray(value) && (reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object));
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == 'number' || type == 'boolean' || type == 'string' && value !== '__proto__' || value == null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func),
              other = lodash[funcName];
          if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isPrototype(value) {
          var Ctor = value && value.constructor,
              proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function mergeData(data, source) {
          var bitmask = data[1],
              srcBitmask = source[1],
              newBitmask = bitmask | srcBitmask,
              isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
          var isCombo = srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG || srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8] || srcBitmask == (ARY_FLAG | REARG_FLAG) && source[7].length <= source[8] && bitmask == CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
          }
          value = source[7];
          if (value) {
            data[7] = copyArray(value);
          }
          if (srcBitmask & ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function mergeDefaults(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, mergeDefaults, stack);
          }
          return objValue === undefined ? baseClone(srcValue) : objValue;
        }
        function parent(object, path) {
          return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length,
              length = nativeMin(indexes.length, arrLength),
              oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
          }
          return array;
        }
        var setData = function () {
          var count = 0,
              lastCalled = 0;
          return function (key, value) {
            var stamp = now(),
                remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return key;
              }
            } else {
              count = 0;
            }
            return baseSetData(key, value);
          };
        }();
        function stringToPath(string) {
          var result = [];
          toString(string).replace(rePropName, function (match, number, quote, string) {
            result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
          });
          return result;
        }
        function toArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function toFunction(value) {
          return typeof value == 'function' ? value : identity;
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result.__actions__ = copyArray(wrapper.__actions__);
          result.__index__ = wrapper.__index__;
          result.__values__ = wrapper.__values__;
          return result;
        }
        function chunk(array, size) {
          size = nativeMax(toInteger(size), 0);
          var length = array ? array.length : 0;
          if (!length || size < 1) {
            return [];
          }
          var index = 0,
              resIndex = -1,
              result = Array(nativeCeil(length / size));
          while (index < length) {
            result[++resIndex] = baseSlice(array, index, index += size);
          }
          return result;
        }
        function compact(array) {
          var index = -1,
              length = array ? array.length : 0,
              resIndex = -1,
              result = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result[++resIndex] = value;
            }
          }
          return result;
        }
        var concat = rest(function (array, values) {
          values = baseFlatten(values);
          return arrayConcat(isArray(array) ? array : [Object(array)], values);
        });
        var difference = rest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, false, true)) : [];
        });
        var differenceBy = rest(function (array, values) {
          var iteratee = last(values);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, false, true), getIteratee(iteratee)) : [];
        });
        var differenceWith = rest(function (array, values) {
          var comparator = last(values);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, false, true), undefined, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array ? array.length : 0;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array ? array.length : 0;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array ? array.length : 0;
          if (!length) {
            return [];
          }
          if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate) {
          return array && array.length ? baseFindIndex(array, getIteratee(predicate, 3)) : -1;
        }
        function findLastIndex(array, predicate) {
          return array && array.length ? baseFindIndex(array, getIteratee(predicate, 3), true) : -1;
        }
        function flatMap(array, iteratee) {
          var length = array ? array.length : 0;
          return length ? baseFlatten(arrayMap(array, getIteratee(iteratee, 3))) : [];
        }
        function flatten(array) {
          var length = array ? array.length : 0;
          return length ? baseFlatten(array) : [];
        }
        function flattenDeep(array) {
          var length = array ? array.length : 0;
          return length ? baseFlatten(array, true) : [];
        }
        function fromPairs(pairs) {
          var index = -1,
              length = pairs ? pairs.length : 0,
              result = {};
          while (++index < length) {
            var pair = pairs[index];
            baseSet(result, pair[0], pair[1]);
          }
          return result;
        }
        function head(array) {
          return array ? array[0] : undefined;
        }
        function indexOf(array, value, fromIndex) {
          var length = array ? array.length : 0;
          if (!length) {
            return -1;
          }
          fromIndex = toInteger(fromIndex);
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return baseIndexOf(array, value, fromIndex);
        }
        function initial(array) {
          return dropRight(array, 1);
        }
        var intersection = rest(function (arrays) {
          var mapped = arrayMap(arrays, toArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = rest(function (arrays) {
          var iteratee = last(arrays),
              mapped = arrayMap(arrays, toArrayLikeObject);
          if (iteratee === last(mapped)) {
            iteratee = undefined;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee)) : [];
        });
        var intersectionWith = rest(function (arrays) {
          var comparator = last(arrays),
              mapped = arrayMap(arrays, toArrayLikeObject);
          if (comparator === last(mapped)) {
            comparator = undefined;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        function join(array, separator) {
          return array ? nativeJoin.call(array, separator) : '';
        }
        function last(array) {
          var length = array ? array.length : 0;
          return length ? array[length - 1] : undefined;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array ? array.length : 0;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined) {
            index = toInteger(fromIndex);
            index = (index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1)) + 1;
          }
          if (value !== value) {
            return indexOfNaN(array, index, true);
          }
          while (index--) {
            if (array[index] === value) {
              return index;
            }
          }
          return -1;
        }
        var pull = rest(pullAll);
        function pullAll(array, values) {
          return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        function pullAllBy(array, values, iteratee) {
          return array && array.length && values && values.length ? basePullAllBy(array, values, getIteratee(iteratee)) : array;
        }
        var pullAt = rest(function (array, indexes) {
          indexes = arrayMap(baseFlatten(indexes), String);
          var result = baseAt(array, indexes);
          basePullAt(array, indexes.sort(compareAscending));
          return result;
        });
        function remove(array, predicate) {
          var result = [];
          if (!(array && array.length)) {
            return result;
          }
          var index = -1,
              indexes = [],
              length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result;
        }
        function reverse(array) {
          return array ? nativeReverse.call(array) : array;
        }
        function slice(array, start, end) {
          var length = array ? array.length : 0;
          if (!length) {
            return [];
          }
          if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee));
        }
        function sortedIndexOf(array, value) {
          var length = array ? array.length : 0;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array ? array.length : 0;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee) {
          return array && array.length ? baseSortedUniqBy(array, getIteratee(iteratee)) : [];
        }
        function tail(array) {
          return drop(array, 1);
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array ? array.length : 0;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = rest(function (arrays) {
          return baseUniq(baseFlatten(arrays, false, true));
        });
        var unionBy = rest(function (arrays) {
          var iteratee = last(arrays);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return baseUniq(baseFlatten(arrays, false, true), getIteratee(iteratee));
        });
        var unionWith = rest(function (arrays) {
          var comparator = last(arrays);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined;
          }
          return baseUniq(baseFlatten(arrays, false, true), undefined, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee)) : [];
        }
        function uniqWith(array, comparator) {
          return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function (group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function (index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee) {
          if (!(array && array.length)) {
            return [];
          }
          var result = unzip(array);
          if (iteratee == null) {
            return result;
          }
          return arrayMap(result, function (group) {
            return apply(iteratee, undefined, group);
          });
        }
        var without = rest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        var xor = rest(function (arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = rest(function (arrays) {
          var iteratee = last(arrays);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
        });
        var xorWith = rest(function (arrays) {
          var comparator = last(arrays);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        var zip = rest(unzip);
        function zipObject(props, values) {
          var index = -1,
              length = props ? props.length : 0,
              valsLength = values ? values.length : 0,
              result = {};
          while (++index < length) {
            baseSet(result, props[index], index < valsLength ? values[index] : undefined);
          }
          return result;
        }
        var zipWith = rest(function (arrays) {
          var length = arrays.length,
              iteratee = length > 1 ? arrays[length - 1] : undefined;
          iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
          return unzipWith(arrays, iteratee);
        });
        function chain(value) {
          var result = lodash(value);
          result.__chain__ = true;
          return result;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = rest(function (paths) {
          paths = baseFlatten(paths);
          var length = paths.length,
              start = length ? paths[0] : 0,
              value = this.__wrapped__,
              interceptor = function (object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            'func': thru,
            'args': [interceptor],
            'thisArg': undefined
          });
          return new LodashWrapper(value, this.__chain__).thru(function (array) {
            if (length && !array.length) {
              array.push(undefined);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperFlatMap(iteratee) {
          return this.map(iteratee).flatten();
        }
        function wrapperNext() {
          if (this.__values__ === undefined) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length,
              value = done ? undefined : this.__values__[this.__index__++];
          return {
            'done': done,
            'value': value
          };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result,
              parent = this;
          while (parent instanceof baseLodash) {
            var clone = wrapperClone(parent);
            clone.__index__ = 0;
            clone.__values__ = undefined;
            if (result) {
              previous.__wrapped__ = clone;
            } else {
              result = clone;
            }
            var previous = clone;
            parent = parent.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              'func': thru,
              'args': [reverse],
              'thisArg': undefined
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function (result, value, key) {
          hasOwnProperty.call(result, key) ? ++result[key] : result[key] = 1;
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        function find(collection, predicate) {
          predicate = getIteratee(predicate, 3);
          if (isArray(collection)) {
            var index = baseFindIndex(collection, predicate);
            return index > -1 ? collection[index] : undefined;
          }
          return baseFind(collection, predicate, baseEach);
        }
        function findLast(collection, predicate) {
          predicate = getIteratee(predicate, 3);
          if (isArray(collection)) {
            var index = baseFindIndex(collection, predicate, true);
            return index > -1 ? collection[index] : undefined;
          }
          return baseFind(collection, predicate, baseEachRight);
        }
        function forEach(collection, iteratee) {
          return typeof iteratee == 'function' && isArray(collection) ? arrayEach(collection, iteratee) : baseEach(collection, toFunction(iteratee));
        }
        function forEachRight(collection, iteratee) {
          return typeof iteratee == 'function' && isArray(collection) ? arrayEachRight(collection, iteratee) : baseEachRight(collection, toFunction(iteratee));
        }
        var groupBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            result[key].push(value);
          } else {
            result[key] = [value];
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = rest(function (collection, path, args) {
          var index = -1,
              isFunc = typeof path == 'function',
              isProp = isKey(path),
              result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value) {
            var func = isFunc ? path : isProp && value != null ? value[path] : undefined;
            result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
          });
          return result;
        });
        var keyBy = createAggregator(function (result, value, key) {
          result[key] = value;
        });
        function map(collection, iteratee) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function (result, value, key) {
          result[key ? 0 : 1].push(value);
        }, function () {
          return [[], []];
        });
        function reduce(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce,
              initFromCollection = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initFromCollection, baseEach);
        }
        function reduceRight(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce,
              initFromCollection = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initFromCollection, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          predicate = getIteratee(predicate, 3);
          return func(collection, function (value, index, collection) {
            return !predicate(value, index, collection);
          });
        }
        function sample(collection) {
          var array = isArrayLike(collection) ? collection : values(collection),
              length = array.length;
          return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
        }
        function sampleSize(collection, n) {
          var index = -1,
              result = toArray(collection),
              length = result.length,
              lastIndex = length - 1;
          n = baseClamp(toInteger(n), 0, length);
          while (++index < n) {
            var rand = baseRandom(index, lastIndex),
                value = result[rand];
            result[rand] = result[index];
            result[index] = value;
          }
          result.length = n;
          return result;
        }
        function shuffle(collection) {
          return sampleSize(collection, MAX_ARRAY_LENGTH);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            var result = collection.length;
            return result && isString(collection) ? stringSize(collection) : result;
          }
          return keys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = rest(function (collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees.length = 1;
          }
          return baseOrderBy(collection, baseFlatten(iteratees), []);
        });
        var now = Date.now;
        function after(n, func) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function () {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined : n;
          n = func && n == null ? func.length : n;
          return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        function before(n, func) {
          var result;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function () {
            if (--n > 0) {
              result = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined;
            }
            return result;
          };
        }
        var bind = rest(function (func, thisArg, partials) {
          var bitmask = BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, bind.placeholder);
            bitmask |= PARTIAL_FLAG;
          }
          return createWrapper(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = rest(function (object, key, partials) {
          var bitmask = BIND_FLAG | BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, bindKey.placeholder);
            bitmask |= PARTIAL_FLAG;
          }
          return createWrapper(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined : arity;
          var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
          result.placeholder = curry.placeholder;
          return result;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined : arity;
          var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
          result.placeholder = curryRight.placeholder;
          return result;
        }
        function debounce(func, wait, options) {
          var args,
              maxTimeoutId,
              result,
              stamp,
              thisArg,
              timeoutId,
              trailingCall,
              lastCalled = 0,
              leading = false,
              maxWait = false,
              trailing = true;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }
          function cancel() {
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
            if (maxTimeoutId) {
              clearTimeout(maxTimeoutId);
            }
            lastCalled = 0;
            args = maxTimeoutId = thisArg = timeoutId = trailingCall = undefined;
          }
          function complete(isCalled, id) {
            if (id) {
              clearTimeout(id);
            }
            maxTimeoutId = timeoutId = trailingCall = undefined;
            if (isCalled) {
              lastCalled = now();
              result = func.apply(thisArg, args);
              if (!timeoutId && !maxTimeoutId) {
                args = thisArg = undefined;
              }
            }
          }
          function delayed() {
            var remaining = wait - (now() - stamp);
            if (remaining <= 0 || remaining > wait) {
              complete(trailingCall, maxTimeoutId);
            } else {
              timeoutId = setTimeout(delayed, remaining);
            }
          }
          function flush() {
            if (timeoutId && trailingCall || maxTimeoutId && trailing) {
              result = func.apply(thisArg, args);
            }
            cancel();
            return result;
          }
          function maxDelayed() {
            complete(trailing, timeoutId);
          }
          function debounced() {
            args = arguments;
            stamp = now();
            thisArg = this;
            trailingCall = trailing && (timeoutId || !leading);
            if (maxWait === false) {
              var leadingCall = leading && !timeoutId;
            } else {
              if (!maxTimeoutId && !leading) {
                lastCalled = stamp;
              }
              var remaining = maxWait - (stamp - lastCalled),
                  isCalled = remaining <= 0 || remaining > maxWait;
              if (isCalled) {
                if (maxTimeoutId) {
                  maxTimeoutId = clearTimeout(maxTimeoutId);
                }
                lastCalled = stamp;
                result = func.apply(thisArg, args);
              } else if (!maxTimeoutId) {
                maxTimeoutId = setTimeout(maxDelayed, remaining);
              }
            }
            if (isCalled && timeoutId) {
              timeoutId = clearTimeout(timeoutId);
            } else if (!timeoutId && wait !== maxWait) {
              timeoutId = setTimeout(delayed, wait);
            }
            if (leadingCall) {
              isCalled = true;
              result = func.apply(thisArg, args);
            }
            if (isCalled && !timeoutId && !maxTimeoutId) {
              args = thisArg = undefined;
            }
            return result;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = rest(function (func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = rest(function (func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrapper(func, FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != 'function' || resolver && typeof resolver != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var memoized = function () {
            var args = arguments,
                key = resolver ? resolver.apply(this, args) : args[0],
                cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result);
            return result;
          };
          memoized.cache = new memoize.Cache();
          return memoized;
        }
        function negate(predicate) {
          if (typeof predicate != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return function () {
            return !predicate.apply(this, arguments);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = rest(function (func, transforms) {
          transforms = arrayMap(baseFlatten(transforms), getIteratee());
          var funcsLength = transforms.length;
          return rest(function (args) {
            var index = -1,
                length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = rest(function (func, partials) {
          var holders = replaceHolders(partials, partial.placeholder);
          return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
        });
        var partialRight = rest(function (func, partials) {
          var holders = replaceHolders(partials, partialRight.placeholder);
          return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        var rearg = rest(function (func, indexes) {
          return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
        });
        function rest(func, start) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          start = nativeMax(start === undefined ? func.length - 1 : toInteger(start), 0);
          return function () {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            switch (start) {
              case 0:
                return func.call(this, array);
              case 1:
                return func.call(this, args[0], array);
              case 2:
                return func.call(this, args[0], args[1], array);
            }
            var otherArgs = Array(start + 1);
            index = -1;
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = array;
            return apply(func, this, otherArgs);
          };
        }
        function spread(func) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return function (array) {
            return apply(func, this, array);
          };
        }
        function throttle(func, wait, options) {
          var leading = true,
              trailing = true;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          wrapper = wrapper == null ? identity : wrapper;
          return partial(wrapper, value);
        }
        function clone(value) {
          return baseClone(value);
        }
        function cloneWith(value, customizer) {
          return baseClone(value, false, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, true);
        }
        function cloneDeepWith(value, customizer) {
          return baseClone(value, true, customizer);
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        function gt(value, other) {
          return value > other;
        }
        function gte(value, other) {
          return value >= other;
        }
        function isArguments(value) {
          return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
        }
        var isArray = Array.isArray;
        function isArrayLike(value) {
          return value != null && !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && objectToString.call(value) == boolTag;
        }
        function isDate(value) {
          return isObjectLike(value) && objectToString.call(value) == dateTag;
        }
        function isElement(value) {
          return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
        }
        function isEmpty(value) {
          return !isObjectLike(value) || isFunction(value.splice) ? !size(value) : !keys(value).length;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          var result = customizer ? customizer(value, other) : undefined;
          return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
        }
        function isError(value) {
          return isObjectLike(value) && typeof value.message == 'string' && objectToString.call(value) == errorTag;
        }
        function isFinite(value) {
          return typeof value == 'number' && nativeIsFinite(value);
        }
        function isFunction(value) {
          var tag = isObject(value) ? objectToString.call(value) : '';
          return tag == funcTag || tag == genTag;
        }
        function isInteger(value) {
          return typeof value == 'number' && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return !!value && (type == 'object' || type == 'function');
        }
        function isObjectLike(value) {
          return !!value && typeof value == 'object';
        }
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (value == null) {
            return false;
          }
          if (isFunction(value)) {
            return reIsNative.test(funcToString.call(value));
          }
          return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == 'number' || isObjectLike(value) && objectToString.call(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
            return false;
          }
          var proto = objectProto;
          if (typeof value.constructor == 'function') {
            proto = getPrototypeOf(value);
          }
          if (proto === null) {
            return true;
          }
          var Ctor = proto.constructor;
          return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        function isRegExp(value) {
          return isObject(value) && objectToString.call(value) == regexpTag;
        }
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        function isString(value) {
          return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        function isTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
        }
        function isUndefined(value) {
          return value === undefined;
        }
        function lt(value, other) {
          return value < other;
        }
        function lte(value, other) {
          return value <= other;
        }
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (iteratorSymbol && value[iteratorSymbol]) {
            return iteratorToArray(value[iteratorSymbol]());
          }
          var tag = getTag(value),
              func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toInteger(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          var remainder = value % 1;
          return value === value ? remainder ? value - remainder : value : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (isObject(value)) {
            var other = isFunction(value.valueOf) ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }
          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }
          value = value.replace(reTrim, '');
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
        }
        function toString(value) {
          if (typeof value == 'string') {
            return value;
          }
          if (value == null) {
            return '';
          }
          if (isSymbol(value)) {
            return _Symbol ? symbolToString.call(value) : '';
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        var assign = createAssigner(function (object, source) {
          copyObject(source, keys(source), object);
        });
        var assignIn = createAssigner(function (object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function (object, source, customizer) {
          copyObjectWith(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function (object, source, customizer) {
          copyObjectWith(source, keys(source), object, customizer);
        });
        var at = rest(function (object, paths) {
          return baseAt(object, baseFlatten(paths));
        });
        function create(prototype, properties) {
          var result = baseCreate(prototype);
          return properties ? baseAssign(result, properties) : result;
        }
        var defaults = rest(function (args) {
          args.push(undefined, assignInDefaults);
          return apply(assignInWith, undefined, args);
        });
        var defaultsDeep = rest(function (args) {
          args.push(undefined, mergeDefaults);
          return apply(mergeWith, undefined, args);
        });
        function findKey(object, predicate) {
          return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
        }
        function findLastKey(object, predicate) {
          return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
        }
        function forIn(object, iteratee) {
          return object == null ? object : baseFor(object, toFunction(iteratee), keysIn);
        }
        function forInRight(object, iteratee) {
          return object == null ? object : baseForRight(object, toFunction(iteratee), keysIn);
        }
        function forOwn(object, iteratee) {
          return object && baseForOwn(object, toFunction(iteratee));
        }
        function forOwnRight(object, iteratee) {
          return object && baseForOwnRight(object, toFunction(iteratee));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result = object == null ? undefined : baseGet(object, path);
          return result === undefined ? defaultValue : result;
        }
        function has(object, path) {
          return hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return hasPath(object, path, baseHasIn);
        }
        function invert(object, multiVal, guard) {
          return arrayReduce(keys(object), function (result, key) {
            var value = object[key];
            if (multiVal && !guard) {
              if (hasOwnProperty.call(result, value)) {
                result[value].push(key);
              } else {
                result[value] = [key];
              }
            } else {
              result[value] = key;
            }
            return result;
          }, {});
        }
        var invoke = rest(baseInvoke);
        function keys(object) {
          var isProto = isPrototype(object);
          if (!(isProto || isArrayLike(object))) {
            return baseKeys(object);
          }
          var indexes = indexKeys(object),
              skipIndexes = !!indexes,
              result = indexes || [],
              length = result.length;
          for (var key in object) {
            if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
              result.push(key);
            }
          }
          return result;
        }
        function keysIn(object) {
          var index = -1,
              isProto = isPrototype(object),
              props = baseKeysIn(object),
              propsLength = props.length,
              indexes = indexKeys(object),
              skipIndexes = !!indexes,
              result = indexes || [],
              length = result.length;
          while (++index < propsLength) {
            var key = props[index];
            if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
              result.push(key);
            }
          }
          return result;
        }
        function mapKeys(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            result[iteratee(value, key, object)] = value;
          });
          return result;
        }
        function mapValues(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            result[key] = iteratee(value, key, object);
          });
          return result;
        }
        var merge = createAssigner(function (object, source) {
          baseMerge(object, source);
        });
        var mergeWith = createAssigner(function (object, source, customizer) {
          baseMerge(object, source, customizer);
        });
        var omit = rest(function (object, props) {
          if (object == null) {
            return {};
          }
          props = arrayMap(baseFlatten(props), String);
          return basePick(object, baseDifference(keysIn(object), props));
        });
        function omitBy(object, predicate) {
          predicate = getIteratee(predicate);
          return basePickBy(object, function (value) {
            return !predicate(value);
          });
        }
        var pick = rest(function (object, props) {
          return object == null ? {} : basePick(object, baseFlatten(props));
        });
        function pickBy(object, predicate) {
          return object == null ? {} : basePickBy(object, getIteratee(predicate));
        }
        function result(object, path, defaultValue) {
          if (!isKey(path, object)) {
            path = baseToPath(path);
            var result = get(object, path);
            object = parent(object, path);
          } else {
            result = object == null ? undefined : object[path];
          }
          if (result === undefined) {
            result = defaultValue;
          }
          return isFunction(result) ? result.call(object) : result;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        function toPairs(object) {
          return baseToPairs(object, keys(object));
        }
        function toPairsIn(object) {
          return baseToPairs(object, keysIn(object));
        }
        function transform(object, iteratee, accumulator) {
          var isArr = isArray(object) || isTypedArray(object);
          iteratee = getIteratee(iteratee, 4);
          if (accumulator == null) {
            if (isArr || isObject(object)) {
              var Ctor = object.constructor;
              if (isArr) {
                accumulator = isArray(object) ? new Ctor() : [];
              } else {
                accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
              }
            } else {
              accumulator = {};
            }
          }
          (isArr ? arrayEach : baseForOwn)(object, function (value, index, object) {
            return iteratee(accumulator, value, index, object);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function values(object) {
          return object ? baseValues(object, keys(object)) : [];
        }
        function valuesIn(object) {
          return object == null ? baseValues(object, keysIn(object)) : [];
        }
        function clamp(number, lower, upper) {
          if (upper === undefined) {
            upper = lower;
            lower = undefined;
          }
          if (upper !== undefined) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toNumber(start) || 0;
          if (end === undefined) {
            end = start;
            start = 0;
          } else {
            end = toNumber(end) || 0;
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined;
          }
          if (floating === undefined) {
            if (typeof upper == 'boolean') {
              floating = upper;
              upper = undefined;
            } else if (typeof lower == 'boolean') {
              floating = lower;
              lower = undefined;
            }
          }
          if (lower === undefined && upper === undefined) {
            lower = 0;
            upper = 1;
          } else {
            lower = toNumber(lower) || 0;
            if (upper === undefined) {
              upper = lower;
              lower = 0;
            } else {
              upper = toNumber(upper) || 0;
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function (result, word, index) {
          word = word.toLowerCase();
          return result + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = typeof target == 'string' ? target : target + '';
          var length = string.length;
          position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
          position -= target.length;
          return position >= 0 && string.indexOf(target, position) == position;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        var kebabCase = createCompounder(function (result, word, index) {
          return result + (index ? '-' : '') + word.toLowerCase();
        });
        var lowerCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst('toLowerCase');
        var upperFirst = createCaseFirst('toUpperCase');
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = stringSize(string);
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2,
              leftLength = nativeFloor(mid),
              rightLength = nativeCeil(mid);
          return createPadding('', leftLength, chars) + string + createPadding('', rightLength, chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          return string + createPadding(string, length, chars);
        }
        function padStart(string, length, chars) {
          string = toString(string);
          return createPadding(string, length, chars) + string;
        }
        function parseInt(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          string = toString(string).replace(reTrim, '');
          return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
        }
        function repeat(string, n) {
          string = toString(string);
          n = toInteger(n);
          var result = '';
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result;
          }
          do {
            if (n % 2) {
              result += string;
            }
            n = nativeFloor(n / 2);
            string += string;
          } while (n);
          return result;
        }
        function replace() {
          var args = arguments,
              string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function (result, word, index) {
          return result + (index ? '_' : '') + word.toLowerCase();
        });
        function split(string, separator, limit) {
          return toString(string).split(separator, limit);
        }
        var startCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + capitalize(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = baseClamp(toInteger(position), 0, string.length);
          return string.lastIndexOf(target, position) == position;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, assignInDefaults);
          var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
              importsKeys = keys(imports),
              importsValues = baseValues(imports, importsKeys);
          var isEscaping,
              isEvaluating,
              index = 0,
              interpolate = options.interpolate || reNoMatch,
              source = "__p += '";
          var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
          var sourceURL = '//# sourceURL=' + ('sourceURL' in options ? options.sourceURL : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
          string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = options.variable;
          if (!variable) {
            source = 'with (obj) {\n' + source + '\n}\n';
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
          source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
          var result = attempt(function () {
            return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
          });
          result.source = source;
          if (isError(result)) {
            throw result;
          }
          return result;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (!string) {
            return string;
          }
          if (guard || chars === undefined) {
            return string.replace(reTrim, '');
          }
          chars = chars + '';
          if (!chars) {
            return string;
          }
          var strSymbols = stringToArray(string),
              chrSymbols = stringToArray(chars);
          return strSymbols.slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1).join('');
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (!string) {
            return string;
          }
          if (guard || chars === undefined) {
            return string.replace(reTrimEnd, '');
          }
          chars = chars + '';
          if (!chars) {
            return string;
          }
          var strSymbols = stringToArray(string);
          return strSymbols.slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1).join('');
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (!string) {
            return string;
          }
          if (guard || chars === undefined) {
            return string.replace(reTrimStart, '');
          }
          chars = chars + '';
          if (!chars) {
            return string;
          }
          var strSymbols = stringToArray(string);
          return strSymbols.slice(charsStartIndex(strSymbols, stringToArray(chars))).join('');
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH,
              omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = 'separator' in options ? options.separator : separator;
            length = 'length' in options ? toInteger(options.length) : length;
            omission = 'omission' in options ? toString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (reHasComplexSymbol.test(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result = strSymbols ? strSymbols.slice(0, end).join('') : string.slice(0, end);
          if (separator === undefined) {
            return result + omission;
          }
          if (strSymbols) {
            end += result.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match,
                  substring = result;
              if (!separator.global) {
                separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result = result.slice(0, newEnd === undefined ? end : newEnd);
            }
          } else if (string.indexOf(separator, end) != end) {
            var index = result.lastIndexOf(separator);
            if (index > -1) {
              result = result.slice(0, index);
            }
          }
          return result + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toUpperCase();
        });
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined : pattern;
          if (pattern === undefined) {
            pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
          }
          return string.match(pattern) || [];
        }
        var attempt = rest(function (func, args) {
          try {
            return apply(func, undefined, args);
          } catch (e) {
            return isError(e) ? e : new Error(e);
          }
        });
        var bindAll = rest(function (object, methodNames) {
          arrayEach(baseFlatten(methodNames), function (key) {
            object[key] = bind(object[key], object);
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs ? pairs.length : 0,
              toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function (pair) {
            if (typeof pair[1] != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return rest(function (args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, true));
        }
        function constant(value) {
          return function () {
            return value;
          };
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return isObjectLike(func) && !isArray(func) ? matches(func) : baseIteratee(func);
        }
        function matches(source) {
          return baseMatches(baseClone(source, true));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, true));
        }
        var method = rest(function (path, args) {
          return function (object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = rest(function (object, args) {
          return function (path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source),
              methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain = isObject(options) && 'chain' in options ? options.chain : true,
              isFunc = isFunction(object);
          arrayEach(methodNames, function (methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function () {
                var chainAll = this.__chain__;
                if (chain || chainAll) {
                  var result = object(this.__wrapped__),
                      actions = result.__actions__ = copyArray(this.__actions__);
                  actions.push({
                    'func': func,
                    'args': arguments,
                    'thisArg': object
                  });
                  result.__chain__ = chainAll;
                  return result;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          root._ = oldDash;
          return this;
        }
        function noop() {}
        function nthArg(n) {
          n = toInteger(n);
          return function () {
            return arguments[n];
          };
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function (path) {
            return object == null ? undefined : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function times(n, iteratee) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH,
              length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee = toFunction(iteratee);
          n -= MAX_ARRAY_LENGTH;
          var result = baseTimes(length, iteratee);
          while (++index < n) {
            iteratee(index);
          }
          return result;
        }
        function toPath(value) {
          return isArray(value) ? arrayMap(value, String) : stringToPath(value);
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        function add(augend, addend) {
          var result;
          if (augend !== undefined) {
            result = augend;
          }
          if (addend !== undefined) {
            result = result === undefined ? addend : result + addend;
          }
          return result;
        }
        var ceil = createRound('ceil');
        var floor = createRound('floor');
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, gt) : undefined;
        }
        function maxBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee), gt) : undefined;
        }
        function mean(array) {
          return sum(array) / (array ? array.length : 0);
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, lt) : undefined;
        }
        function minBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee), lt) : undefined;
        }
        var round = createRound('round');
        function subtract(minuend, subtrahend) {
          var result;
          if (minuend !== undefined) {
            result = minuend;
          }
          if (subtrahend !== undefined) {
            result = result === undefined ? subtrahend : result - subtrahend;
          }
          return result;
        }
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : undefined;
        }
        function sumBy(array, iteratee) {
          return array && array.length ? baseSum(array, getIteratee(iteratee)) : undefined;
        }
        lodash.prototype = baseLodash.prototype;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
        MapCache.prototype.clear = mapClear;
        MapCache.prototype['delete'] = mapDelete;
        MapCache.prototype.get = mapGet;
        MapCache.prototype.has = mapHas;
        MapCache.prototype.set = mapSet;
        SetCache.prototype.push = cachePush;
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        memoize.Cache = MapCache;
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipWith = zipWith;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.deburr = deburr;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.first = head;
        mixin(lodash, function () {
          var source = {};
          baseForOwn(lodash, function (func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { 'chain': false });
        lodash.VERSION = VERSION;
        arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(['drop', 'take'], function (methodName, index) {
          LazyWrapper.prototype[methodName] = function (n) {
            var filtered = this.__filtered__;
            if (filtered && !index) {
              return new LazyWrapper(this);
            }
            n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
            var result = this.clone();
            if (filtered) {
              result.__takeCount__ = nativeMin(n, result.__takeCount__);
            } else {
              result.__views__.push({
                'size': nativeMin(n, MAX_ARRAY_LENGTH),
                'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
              });
            }
            return result;
          };
          LazyWrapper.prototype[methodName + 'Right'] = function (n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
          var type = index + 1,
              isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function (iteratee) {
            var result = this.clone();
            result.__iteratees__.push({
              'iteratee': getIteratee(iteratee, 3),
              'type': type
            });
            result.__filtered__ = result.__filtered__ || isFilter;
            return result;
          };
        });
        arrayEach(['head', 'last'], function (methodName, index) {
          var takeName = 'take' + (index ? 'Right' : '');
          LazyWrapper.prototype[methodName] = function () {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(['initial', 'tail'], function (methodName, index) {
          var dropName = 'drop' + (index ? '' : 'Right');
          LazyWrapper.prototype[methodName] = function () {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function () {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function (predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function (predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = rest(function (path, args) {
          if (typeof path == 'function') {
            return new LazyWrapper(this);
          }
          return this.map(function (value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function (predicate) {
          predicate = getIteratee(predicate, 3);
          return this.filter(function (value) {
            return !predicate(value);
          });
        };
        LazyWrapper.prototype.slice = function (start, end) {
          start = toInteger(start);
          var result = this;
          if (result.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result);
          }
          if (start < 0) {
            result = result.takeRight(-start);
          } else if (start) {
            result = result.drop(start);
          }
          if (end !== undefined) {
            end = toInteger(end);
            result = end < 0 ? result.dropRight(-end) : result.take(end - start);
          }
          return result;
        };
        LazyWrapper.prototype.takeRightWhile = function (predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function () {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
              isTaker = /^(?:head|last)$/.test(methodName),
              lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
              retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function () {
            var value = this.__wrapped__,
                args = isTaker ? [1] : arguments,
                isLazy = value instanceof LazyWrapper,
                iteratee = args[0],
                useLazy = isLazy || isArray(value);
            var interceptor = function (value) {
              var result = lodashFunc.apply(lodash, arrayPush([value], args));
              return isTaker && chainAll ? result[0] : result;
            };
            if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__,
                isHybrid = !!this.__actions__.length,
                isUnwrapped = retUnwrapped && !chainAll,
                onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result = func.apply(value, args);
              result.__actions__.push({
                'func': thru,
                'args': [interceptor],
                'thisArg': undefined
              });
              return new LodashWrapper(result, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
          };
        });
        arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
          var func = arrayProto[methodName],
              chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
              retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function () {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              return func.apply(this.value(), args);
            }
            return this[chainName](function (value) {
              return func.apply(value, args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + '',
                names = realNames[key] || (realNames[key] = []);
            names.push({
              'name': methodName,
              'func': lodashFunc
            });
          }
        });
        realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
          'name': 'wrapper',
          'func': undefined
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.flatMap = wrapperFlatMap;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        if (iteratorSymbol) {
          lodash.prototype[iteratorSymbol] = wrapperToIterator;
        }
        return lodash;
      }
      var _ = runInContext();
      (freeWindow || freeSelf || {})._ = _;
      if (typeof undefined == 'function' && typeof define.amd == 'object' && define.amd) {
        define(function () {
          return _;
        });
      } else if (freeExports && freeModule) {
        if (moduleExports) {
          (freeModule.exports = _)._ = _;
        }
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(this);
  })($__require('f9'));
});
$__System.registerDynamic('1dd', ['1dc'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = $__require('1dc');
});
$__System.registerDynamic("11", ["1dd"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("1dd");
});
$__System.register('1de', ['11', '12', '13'], function (_export) {
    var _, _createClass, _classCallCheck, DeviceSettingDirective;

    return {
        setters: [function (_4) {
            _ = _4['default'];
        }, function (_2) {
            _createClass = _2['default'];
        }, function (_3) {
            _classCallCheck = _3['default'];
        }],
        execute: function () {
            'use strict';

            DeviceSettingDirective = (function () {
                function DeviceSettingDirective() {
                    _classCallCheck(this, DeviceSettingDirective);

                    this.restrict = 'E';
                    this.scope = {
                        //
                        // @todo One-way bindings for all
                        //
                        actionName: '&?',
                        actionTitle: '@',
                        ajaxPending: '<',
                        buttonOptions: '=',
                        customizedmax: '=',
                        disabled: '@',
                        firmware: '<',
                        func: '=',
                        group: '<',
                        help: '@',
                        isSuperUser: '<',
                        labels: '=',
                        lcpType: '<',
                        level: '=',
                        max: '=',
                        min: '=',
                        parentId: '&',
                        placeholder: '@',
                        selected: '&',
                        settingName: '@',
                        size: '@',
                        settings: '=',
                        'switch': '=',
                        template: '@',
                        transform: '=',
                        threshold: '=',
                        unit: '@',
                        value: '=',
                        validate: '@',
                        zones: '=',
                        lastSavedUnoccupiedDimmerLevel: '=',
                        //
                        // - Out
                        //
                        onUpdate: '&?'
                    };
                    this.replace = true;
                    this.template = function (tElement, tAttrs) {

                        var defaults = {
                            disabled: tAttrs.disabled || '',
                            inputMsg: !isNaN(tAttrs.max) ? '<span class="max"> ' + tAttrs.unit + ' (Max: ' + tAttrs.max + ')</span>' : '',
                            isSuperUser: tAttrs.isSuperUser || false,
                            placeholder: tAttrs.placeholder || 0,
                            settingName: tAttrs.settingName ? tAttrs.settingName : getSettingName(tAttrs.value),
                            size: tAttrs.size || 'quarter',
                            verbTrue: tAttrs.verbTrue || 'On',
                            verbFalse: tAttrs.verbFalse || 'Off'
                        };

                        function looseJsonParse(obj) {
                            return Function('"use strict";return (' + obj + ')')();
                        }

                        function getStep(options, min, max) {
                            var defaultStep = max || 100;
                            var stepValue = defaultStep;

                            // Can only count plaintext array (not angular obj)
                            if (options.indexOf('[') > -1) {
                                try {
                                    var optionArray = looseJsonParse(tAttrs.buttonOptions);

                                    stepValue = Math.round(defaultStep / (optionArray.length - 1));
                                } catch (e) {}
                            }

                            return stepValue;
                        }

                        //
                        // No need for settingName - just grab from the key
                        //
                        function getSettingName(value) {
                            return value.split('.')[2];
                        }

                        //Set these here to allow interpolation in the template
                        tAttrs.min = angular.isDefined(tAttrs.min) ? tAttrs.min : '1';
                        tAttrs.max = angular.isDefined(tAttrs.max) ? tAttrs.max : '100';

                        var helpBox = function helpBox(helpText) {
                            var helpBoxHtml = '<i class="info" help data-help-div="' + defaults.settingName + '" id="' + defaults.settingName + 'Icon"></i>\n                    <div class="tooltipContainer">\n                        <div class="help" id="' + defaults.settingName + '">\n                            <div class="arrow"></div>\n                            <p>' + helpText + '</p>\n                        </div>\n                    </div>';
                            return helpBoxHtml;
                        };

                        var makeTemplate = function makeTemplate(controls, template) {

                            var parents = {
                                base: '<div class="device-details-group {{classes}}">\n                            <h3><span title="{{::\'devices.' + defaults.settingName + '\' | translate }}" translate>devices.' + defaults.settingName + '</span>' + (tAttrs.help ? helpBox(tAttrs.help) : '') + '</h3>\n                            ' + controls[template].control + '\n                        </div>',
                                slider: '<div class="device-details-group sensitivity {{classes}}">\n                            <div class="overview-zone ' + controls[template].slideClasses + '">\n                                <div class="slider-wrapper">\n                                ' + controls[template].control + '\n                                </div>\n                            </div>\n                        </div>',
                                noTitle: '<div class="device-details-group {{classes}} no-title">                           \n                            ' + controls[template].control + '\n                        </div>'
                            };

                            return controls[template].type ? parents[controls[template].type] : controls[template].control;
                        };

                        var controls = {
                            toggleA: {
                                type: 'base',
                                control: '<button class="btn btn-select-toggle" ng-class="{selected: value, loading:ajaxPending}" ng-click="toggle()"></button>\n                    <span class="caps" translate>{{value ? "' + defaults.verbTrue + '" : "' + defaults.verbFalse + '"}}</span>'
                            },
                            toggleB: {
                                type: 'base',
                                control: '<button class="btn-push" ng-bind="value" ng-class="{on:value, loading:ajaxPending}" ng-click="toggle()"></button>\n                    <span class="caps" translate>{{value ? "' + defaults.verbTrue + '" : "' + defaults.verbFalse + '"}}</span>'
                            },
                            toggleGeneralEnable: {
                                type: 'noTitle',
                                control: '<button class="btn btn-select-toggle general-enable" ng-class="{selected: value, loading:ajaxPending}" ng-click="toggle()"></button>\n                    <span class="caps" translate>{{value ? "' + defaults.verbTrue + '" : "' + defaults.verbFalse + '"}}</span>'
                            },
                            toggleTextInput: {
                                type: 'base',
                                control: '<button class="btn-select-toggle" ng-class="{selected: value > 0}" ng-click="toggle()"></button>\n                    <span class="caps" translate>{{value ? "' + defaults.verbTrue + '" : "' + defaults.verbFalse + '"}}</span>\n                    <div class="toggle-text-input" ng-show="value > 0 || value == undefined">\n                        <input class="num-input-temp"  string-to-number type="number" ng-pattern="' + tAttrs.validate + '" ng-min="min" ng-max="max" min="min" max="max" placeholder="' + defaults.placeholder + '"  ng-model="value" ng-change="update()" ng-disabled="' + defaults.disabled + '" />\n                        ' + defaults.inputMsg + '\n                    </div>'
                            },
                            actionBtn: {
                                type: 'base',
                                control: '<button class="btn btn-action" ng-click="actionName()" translate="devices.{{actionTitle}}">{{actionTitle}}</button>'
                            },
                            numInput: {
                                type: 'base',
                                control: '<input class="num-input-temp"  string-to-number type="number" ng-pattern="' + tAttrs.validate + '" ng-min="min" ng-max="max" min="min" max="max" placeholder="' + defaults.placeholder + '"  ng-model="value" ng-change="update()" ng-disabled="' + defaults.disabled + '" /><span>{{unit}}</span>\n                   ' + defaults.inputMsg
                            },
                            strictPositiveNumInput: {
                                type: 'base',
                                control: '<input class="num-input-temp" string-to-number type="number" ng-pattern="' + tAttrs.validate + '" ng-min="min" ng-max="max" min="min" max="max" placeholder="' + defaults.placeholder + '" ng-model="value" ng-change="enforcePositive()" ng-keydown="numericInputHandler($event)" ng-disabled="' + defaults.disabled + '"/><span>{{unit}}</span>\n                    ' + defaults.inputMsg
                            },
                            textInput: {
                                type: 'base',
                                control: '<input type="text" ng-pattern="' + tAttrs.validate + '" placeholder="' + defaults.placeholder + '"  ng-model="value" ng-change="update()" ng-disabled="' + defaults.disabled + '" />\n                   ' + defaults.inputMsg
                            },
                            buttonSelect: {
                                type: 'base',
                                control: '<div class="contrast-buttons">\n                        <div ng-repeat="(key, option) in options track by $index" ng-click="select(option)" ng-class="{selected: (value === option.name || value === option.value), loading:ajaxPending}">\n                            <span translate="devices.{{option.name}}"></span>\n                        </div>\n                    </div>'
                            },
                            range: {
                                type: 'base',
                                control: '<div class="slider-container">\n                            <div class="slider-highlight" ng-style="{ width: highlightPercent + \'%\' }"></div>\n                            <input type="range" ng-model="value" list="' + defaults.settingName + '" step="' + (tAttrs.buttonOptions ? getStep(tAttrs.buttonOptions, tAttrs.min, tAttrs.max) : null) + '">\n                        </div>\n                        <label >{{value}}</label>\n                        <datalist ng-class="{labels: tAttrs.showLabels}" id="' + defaults.settingName + '">\n                            <option ng-repeat="option in options" value="{{option.value}}" label="{{option.value}}"></option>\n                        </datalist>'
                            },
                            buttonSelectForNum: {
                                type: 'base',
                                control: '<div class="contrast-buttons">\n                          <div ng-repeat="(key, option) in options track by $index" ng-click="select({\'value\': $index})" ng-class="{selected: value == $index, loading:ajaxPending}">\n                              <span translate="devices.{{option.name}}"></span>\n                          </div>\n                      </div>'
                            },
                            select: {
                                type: 'base',
                                control: '<select ng-model="value">\n                        <option ng-repeat="option in options" value="{{option.value}}">{{option.name}}</option>\n                    </select>'
                            },
                            slider: {
                                type: 'slider',
                                slideClasses: 'has-slider blue-bar',
                                control: '<h4><span class="caps" translate>devices.' + defaults.settingName + '</span>' + (tAttrs.help ? helpBox(tAttrs.help) : '') + '</h4>\n                    <slider floor="{{min}}" ceiling="{{max}}" step="1" precision="1" dim="true" level="value" ng-model="value" ng-model-high="max" enabled="true"></slider>\n                    <div class="max-trim">\n                        <span class="max">{{value ? value : 0}}</span>\n                        <span class="caps">' + tAttrs.unit + '</span>\n                    </div>'
                            },
                            sliderToggle: {
                                type: 'slider',
                                slideClasses: 'has-slider has-btn blue-bar',
                                control: '<h4><span class="caps" translate>devices.' + defaults.settingName + '</span>' + (tAttrs.help ? helpBox(tAttrs.help) : '') + '</h4>\n                    <!-- Use a max value here ? eg: value = (max ? max : 100) -->\n                    <button class="btn-push" ng-class="{on: value > 0}" ng-click="toggleUnoccupiedDimmerLevel()"></button>\n                    <slider\n                        floor="{{min}}"\n                        ceiling="{{max}}"\n                        step="1"\n                        precision="1"\n                        dim="true"\n                        level="value"\n                        ng-model="value"\n                        ng-model-high="max"\n                        enabled="true"\n                    ></slider>\n                    <div class="max-trim">\n                        <span ng-if="value > 0">\n                            <span class="max">{{value}}</span>\n                            <span class="caps">' + tAttrs.unit + '</span>\n                        </span>\n                        <span ng-if="value === 0">\n                            <span class="caps">' + defaults.verbFalse + '</span>\n                        </span>\n                    </div>'
                            },
                            sliderToggleWithScale: {
                                control: '<div class="device-details-group sensitivity {{classes}}" ng-class="{extend: switch}">\n                        <div class="overview-zone ' + this.slideClasses + '">\n                            <div class="slider-wrapper">\n                                <h4><span class="caps" translate>devices.' + defaults.settingName + '</span>' + (tAttrs.help ? helpBox(tAttrs.help) : '') + '</h4>\n                                <button class="btn-push" ng-class="{on: switch}" ng-click="switch = !switch"></button>\n                                <span class="text" ng-if="!switch">Disabled</span>\n                                <div class="container" ng-if="switch">\n                                    <div class="scale-container">\n                                        <span class="scale"  ng-repeat="label in labels">{{label}}</span>\n                                    </div>\n                                    <slider floor="0" ceiling="100" step="1" precision="1" dim="true" level="value" ng-model="$parent.value" ng-model-high="100" enabled="true"></slider>\n                                </div>\n                                <div class="max-trim" ng-show="switch">\n                                    <span class="max">{{func()}}</span>\n                                    <span class="caps">' + tAttrs.unit + '</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>'
                            },
                            sliderWithCustomizedValue: {
                                control: '<div class="device-details-group sensitivity {{classes}}" ng-class="{customized: ' + defaults.isSuperUser + ' || value > threshold}">\n                        <div class="overview-zone has-slider blue-bar" ng-class="{extended: showCustomizedBar}">\n                            <div class="slider-wrapper">\n                                <h4><span class="caps" translate>devices.' + defaults.settingName + '</span>' + (tAttrs.help ? helpBox(tAttrs.help) : '') + '</h4>\n                                <slider floor="{{min}}" ceiling="{{max}}" step="1" precision="1" dim="true" level="sliderValue" ng-model="sliderValue" ng-model-high="max" enabled="!showCustomizedBar && !customized"></slider>\n                                <div class="max-trim">\n                                    <span class="max">{{value ? value : 0}}</span>\n                                    <span class="caps">' + tAttrs.unit + '</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="customized-container" ng-class="{extended: showCustomizedBar}">\n                            <div class="label">\n                                <span ng-click="customizedBarClick()" ng-class="{customized: customized}">Customize</span>\n                            </div>\n                            <div class="customized-content" ng-class="{error:$parent.err}">\n                                <form name="customizeValue" autofocus>\n                                    <input type="text" ng-keydown="CustomizedformEnter($event)" ng-model="value" placeholder="' + defaults.placeholder + '" ng-change="customizedValueChange()">\n                                    <span>' + tAttrs.unit + '</span>\n                                    <span class="error-msg">The max value is {{customizedmax}}</span>\n                                </form>\n                            </div>\n                        </div>\n                    </div>'
                            },
                            wrappedToggle: {
                                type: 'slider',
                                slideClasses: 'has-slider has-btn blue-bar blink',
                                control: '<h3 translate>devices.' + defaults.settingName + '</h3>\n                    <button class="btn btn-select-toggle" ng-class="{selected: value, loading:ajaxPending}" ng-click="toggle()"></button>'
                            }
                        };

                        return makeTemplate(controls, tAttrs.template);
                    };
                }

                _createClass(DeviceSettingDirective, [{
                    key: 'controller',
                    value: function controller($scope, $rootScope, $timeout, $q, Sites, LcFn) {
                        //Hoist injected services to $scope for use in linking function
                        $scope.dependencies = {
                            $rootScope: $rootScope,
                            $timeout: $timeout,
                            $q: $q,
                            Sites: Sites,
                            LcFn: LcFn
                        };
                    }
                }, {
                    key: 'link',
                    value: function link(scope, element, attrs) {
                        scope.highlightPercent = 100;
                        // ---------------------------------
                        // - Shit tied to specific settings
                        // - FE 'Defaults' - bad idea
                        // - Shift this to DeviceSettingDirective as a half measure

                        var cachedValue = scope.value; // - We need this for the undo / cancel service
                        var undoFlag = false;

                        var debouncedSettingUpdate = _.debounce(update, 1000);

                        var helperFuncs = {
                            daylightAverageSinceLastValue: function daylightAverageSinceLastValue() {},
                            hasSensorToggle: function hasSensorToggle() {
                                //
                                // 7/31/20 Jason needs these as they don't come from the device and will cause problems if not set...
                                //
                                scope.value = !scope.value;

                                if (scope.value) {
                                    //
                                    // Parent to other child scope BS
                                    //
                                    scope.dependencies.$timeout(function () {
                                        scope.settings.motion_timeout = scope.dependencies.LcFn.defaults.sensor.motion_timeout;
                                        scope.settings.occupancy_led_enable = scope.dependencies.LcFn.defaults.sensor.occupancy_led_enable;
                                        scope.settings.sensor_sensitivity = scope.dependencies.LcFn.defaults.sensor.sensor_sensitivity;
                                        scope.$apply();
                                    });
                                } else {
                                    scope.settings.motion_timeout = 0;
                                    scope.settings.occupancy_led_enable = false;
                                }
                            },
                            lostSignalEnable: function lostSignalEnable() {
                                //
                                // 5/3/22 Jason asking for heartbeat timeouts
                                //
                                if (!scope.value) {
                                    //
                                    // Parent to other child scope BS
                                    //
                                    scope.value = scope.dependencies.LcFn.defaults.heartbeat.heartbeat_timeout;

                                    scope.dependencies.$timeout(function () {
                                        scope.settings.heartbeat_missed_light_level = scope.dependencies.LcFn.defaults.heartbeat.heartbeat_missed_light_level;
                                        scope.settings.heartbeat_missed_state = scope.dependencies.LcFn.defaults.heartbeat.heartbeat_missed_state;
                                        scope.$apply();
                                    });
                                } else {
                                    scope.value = 0;
                                }
                            },
                            offToUnoccupied: function offToUnoccupied() {
                                //for now set the default value
                                //may change UI to slider or let user input the value
                                if (scope.value !== scope.dependencies.LcFn.defaults.offToUnoccupied) {
                                    scope.value = scope.dependencies.LcFn.defaults.offToUnoccupied;
                                } else {
                                    scope.value = 0;
                                }
                            },
                            blinkBeforeUnoccupied: function blinkBeforeUnoccupied() {
                                //Requires scope.settings
                                if (scope.value === 0) {
                                    scope.value = scope.dependencies.LcFn.defaults.blink.blink_value;
                                    //Other settings
                                    scope.settings.blink_duration = scope.dependencies.LcFn.defaults.blink.blink_duration;
                                    scope.settings.ramp_down_time = scope.dependencies.LcFn.defaults.blink.ramp_down_time;
                                    scope.settings.time_to_off = scope.dependencies.LcFn.defaults.blink.time_to_off;
                                } else {
                                    scope.value = 0;
                                    //Other settings
                                    scope.settings.blink_time_pre_unoccupied = 0;
                                    scope.settings.blink_duration = 0;
                                    scope.settings.ramp_down_time = 0;
                                    scope.settings.time_to_off = 0;
                                }
                            },
                            manualOverride: function manualOverride() {
                                scope.value = !scope.value ? scope.dependencies.LcFn.defaults.zoneManualOverrideDefault : 0;
                            }
                        };

                        scope.$watch('value', function (oldVal, newVal) {
                            //
                            // This replaces triggerUpdate until the slider directive is re-written
                            //
                            if (oldVal !== newVal) {
                                //
                                // Check undo flag so as not to trigger a UI update if just reverting
                                //

                                updateIfNotUndo();
                            }
                        });

                        scope.triggerUpdate = function () {
                            //Noop - temp
                            return angular.noop;
                        };

                        //Set width of element if supplied, half, third, quarter is default
                        scope.classes = attrs.size ? attrs.size : 'quarter';

                        //Set disabled class
                        if (scope.disabled) {
                            scope.classes = scope.classes + ' disabled';
                        }

                        if (scope.group) {
                            //Anything disabled in group mode should be blanked out to avoid confusion
                            if (scope.disabled) {
                                //scope.value = 'N/A';
                            } else {
                                    //Ghost class fades the element out until click
                                    scope.classes = scope.classes + ' ghost';

                                    angular.element(element).click(function (event) {
                                        event.stopPropagation();

                                        if (scope.classes.indexOf('ghost') > -1) {
                                            //scope.triggerUpdate();
                                            updateIfNotUndo();
                                        }

                                        // //This will clear the ghost class (could use toggleClass)
                                        scope.classes = attrs.size ? attrs.size : 'quarter';
                                        scope.$apply();
                                    });
                                }
                        }

                        scope.round = function (val) {
                            return Math.round(val);
                        };

                        scope.toggle = function () {
                            if (helperFuncs[scope.settingName]) {
                                helperFuncs[scope.settingName]();
                            } else {
                                scope.value = !scope.value;
                            }
                            scope.triggerUpdate();
                        };

                        scope.select = function (option) {
                            if (angular.isDefined(option.value)) {
                                scope.value = option.value;
                            } else {
                                scope.value = option.name;
                            }

                            scope.triggerUpdate();
                        };

                        //Fix array passed as string
                        //scope.options = _.filter(_.map(scope.$eval(attrs.buttonOptions), function(setting){

                        scope.options = _.filter(scope.buttonOptions, function (setting) {
                            if (setting.conditions) {
                                //We cant interpolate nested conditions in the template, have to keep these here
                                var conditionTests = {
                                    minFirmware: function minFirmware(value) {
                                        return !scope.dependencies.LcFn.ltVersion(scope.firmware, value);
                                    },
                                    'super': function _super(value) {
                                        return scope.isSuperUser === value;
                                    },
                                    supportedDeviceTypes: function supportedDeviceTypes(value) {
                                        return _.find(value, function (value) {
                                            return parseInt(value.lcp_type) === parseInt(scope.lcpType);
                                        });
                                    },
                                    zoneDimmable: function zoneDimmable(value) {
                                        return scope.zones[0] ? scope.zones[0].is_dimmable : false;
                                    }
                                };

                                return _.every(setting.conditions, function (value, condition) {
                                    return conditionTests[condition](value);
                                }) ? setting : null;
                            } else {
                                return setting;
                            }
                        });

                        function updateIfNotUndo() {
                            if (!undoFlag) {
                                debouncedSettingUpdate();
                            } else {
                                undoFlag = false;
                            }
                        }

                        function update() {
                            if (typeof scope.value !== 'undefined') {

                                var deferred = scope.dependencies.$q.defer();
                                var promise = deferred.promise;

                                // - Zone id string field bug - deep one...
                                if (scope.onUpdate) {
                                    scope.onUpdate({ setting: getSettingName(attrs.value), value: scope.value, deferred: deferred });
                                }

                                promise.then(function () {
                                    //
                                    // Success = save persisted, undo ignored
                                    //
                                    clearPendingBlock();
                                }, function () {
                                    //
                                    // Fail = User clicks cancel / dismiss
                                    //
                                    undoFlag = true;
                                    scope.value = cachedValue;
                                }, function (update) {
                                    //
                                    // - While undo is still an option, use nofity instead of resolve
                                    //   Block further changes to this control until reciept from BE
                                    //  
                                    if (update === 'ajax-start') {
                                        blockWhilePending();
                                    } else if (update === 'ajax-success') {
                                        updateLastSavedUnoccupiedDimmerLevel();
                                        console.log('finished inital update, lets resolve this promise later');
                                        clearPendingBlock();
                                    } else if (update === 'ajax-undo-success') {
                                        console.log('finished an undo action successfully');
                                        undoFlag = true;
                                        scope.value = cachedValue;
                                        updateLastSavedUnoccupiedDimmerLevel();
                                        clearPendingBlock();
                                    }
                                })['finally'](function () {
                                    console.log('Closing the book');
                                });
                            }
                        }

                        function updateLastSavedUnoccupiedDimmerLevel() {
                            if (scope.value > 0 && attrs.hasOwnProperty('lastSavedUnoccupiedDimmerLevel') && scope.settingName == 'whenUnoccupied') {
                                scope.onUpdate({ setting: getSettingName(attrs.lastSavedUnoccupiedDimmerLevel), value: scope.value, deferred: scope.dependencies.$q.defer() });
                            }
                        }

                        scope.valueStore;
                        scope.toggleUnoccupiedDimmerLevel = function () {
                            if (isNaN(scope.valueStore)) {
                                scope.valueStore = scope.value;
                            }
                            if (scope.value == 0) {
                                scope.value = scope.valueStore;
                            } else {
                                scope.valueStore = scope.value;
                                scope.value = 0;
                            }
                        };

                        function blockWhilePending() {
                            scope.dependencies.$timeout(function () {
                                scope.ajaxPending = true;
                                angular.element(element).toggleClass('ghost');

                                angular.element(element).click(function (event) {
                                    event.stopPropagation();
                                });

                                scope.$apply();
                            });
                        }

                        function clearPendingBlock() {
                            scope.ajaxPending = false;

                            angular.element(element).removeClass('ghost');
                            angular.element(element).off('click');
                        }

                        function getSettingName(value) {
                            return value.split('.')[2];
                        }

                        //Device setting sanitization
                        if (attrs.template === 'textInput') {
                            if (scope.value === false) {
                                scope.value = 0;
                            }
                        }

                        //Fix 1 / 0 BE toggle (every boolean setting should use true false - avoid confusion with 0 value settings that don't disable function (ie timeouts))
                        if (attrs.template === 'toggleA' || attrs.template === 'toggleB') {
                            scope.value = scope.value ? true : false;
                        }

                        //
                        // @todo remove these in favor of in / out in deviceFactory
                        //
                        var transforms = {
                            luxToFoot: function luxToFoot(value) {
                                return scope.dependencies.LcFn.luxToFoot(value);
                            },
                            //
                            //
                            // Jason 3/20 Sensors (apart from daylight harvestor) need this transform
                            //
                            //
                            luxClosedToFoot: function luxClosedToFoot(value) {
                                return scope.dependencies.LcFn.luxClosedToFoot(value);
                            }
                        };

                        if (scope.transform) {
                            if (transforms[scope.transform]) {
                                scope.value = transforms[scope.transform](scope.value);
                            }
                        }

                        //******** Yuchau *********//
                        //
                        // @todo @yuchau - These bigger custom inputs should be seperated into own directives/components - they aren't reusable
                        //                  sliderWithCustomizedValue and powerUpState at least
                        //

                        //---- Still left to refactor ----//

                        //for slider with customized bar
                        scope.customizedBarClick = function () {

                            if (scope.showCustomizedBar) {
                                if (scope.value <= scope.threshold) {
                                    scope.showCustomizedBar = false;
                                }
                            } else {
                                scope.showCustomizedBar = true;
                            }
                        };

                        scope.CustomizedformEnter = function (event) {

                            if (event.keyCode === 46 || event.keyCode === 8) {
                                return;
                            }
                            if (event.keyCode === 13) {
                                if (scope.value <= scope.threshold) {
                                    scope.customized = false;
                                    scope.showCustomizedBar = false;
                                }
                            }
                            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                                event.preventDefault();
                            }
                        };

                        scope.customizedValueChange = function () {
                            if (scope.value > scope.customizedmax) {
                                scope.$parent.err = true;
                            } else {
                                scope.$parent.err = false;
                            }
                            if (scope.value > scope.threshold) {
                                scope.sliderValue = 0;
                                scope.customized = true;
                                scope.showCustomizedBar = true;
                            } else {
                                scope.sliderValue = scope.value;
                                scope.customized = false;
                                scope.showCustomizedBar = true;
                            }
                        };

                        scope.numericInputHandler = function (event) {
                            // allows navigation keys - (backspace, tab, left/right, enter, delete)
                            if ([8, 13, 37, 39, 46].includes(event.keyCode)) return;

                            // prevents any non-numeric keys
                            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                                event.preventDefault();
                            }

                            // prevents infinite zeros/leading zeros
                            if (event.keyCode === 48) {
                                var currentValue = scope.value || '';
                                if (currentValue === '0') {
                                    event.preventDefault();
                                    return;
                                }
                            }
                        };

                        scope.enforcePositive = function () {

                            // invalid input
                            if (scope.value !== '' || scope.value !== null || scope.value !== undefined) {
                                var num = Math.abs(Number(scope.value));

                                if (!isNaN(num) && num >= 0) {
                                    scope.value = num;
                                } else {
                                    scope.value = null;
                                }
                            }
                        };

                        scope.$watch('sliderValue', function (newV, oldV) {
                            if (newV) {
                                if (newV !== 0) {
                                    scope.value = newV;
                                }
                            }
                        });

                        if (scope.template === 'sliderWithCustomizedValue') {
                            scope.dependencies.$timeout(function () {
                                scope.$broadcast('animateBars');
                                scope.sliderValue = scope.value;
                                if (scope.value > scope.threshold) {
                                    scope.sliderValue = 0;
                                    scope.customized = true;
                                    scope.showCustomizedBar = true;
                                }
                            }, 50);
                        }

                        // if(scope.settingName === "offToUnoccupied"){
                        //     scope.dependencies.$timeout(function () {
                        //         helperFuncs["offToUnoccupied"]();
                        //     })
                        // }

                        //---- Still left to refactor ----//
                    }
                }]);

                return DeviceSettingDirective;
            })();

            _export('DeviceSettingDirective', DeviceSettingDirective);
        }
    };
});

$__System.register('1df', [], function (_export) {
    'use strict';

    var devicesStates;
    return {
        setters: [],
        execute: function () {
            devicesStates = [{
                parent: 'site',
                name: 'Devices',
                url: '/devices/{userSelectedFilter}',
                resolve: {
                    sessionData: function sessionData(Session) {
                        return Session.getSiteData(false);
                    }, // - No need to ask for extraSections - this is triggered by the master state change
                    itemCollection: function itemCollection(sessionData, StructureService) {
                        return StructureService.itemCollection(sessionData, 'devices');
                    }
                },

                component: 'devicesBase',

                params: {
                    allowDragDrop: true,
                    leftMenuSpecialContext: 'devices',
                    //
                    // All extra sections required for devices view - maybe nest a sub view here to avoid this extra calls
                    //
                    extraSections: ['automations', 'scenes', 'schedules', 'updateStatus']
                },
                title: 'Devices'
            }, /* {
                 parent: 'site',
                 name: 'Quick-Add',
                 url: '/quick-add/{areaId}',
                 resolve: {
                     sessionData: (Session) => { return Session.getSiteData(false); }, // - No need to ask for extraSections - this is triggered by the master state change
                     itemCollection: function(sessionData, StructureService) {
                         return StructureService.itemCollection(sessionData, 'zones');
                     }
                 },
                  component: 'quickAddBase',
                  params: {
                     new: false,
                     allowNew: false,
                     leftMenuSpecialContext: 'devices',
                     //
                     // All extra sections required for devices view - maybe nest a sub view here to avoid this extra calls
                     //
                     //extraSections: ['automations','scenes','schedules']
                 },
                 title: 'Quick-Add'
               },*/{
                parent: 'Devices',
                name: 'Automations',
                url: 'automations/{userSelectedFilter}',
                resolve: {
                    sessionData: function sessionData(Session) {
                        return Session.getSiteData(false);
                    }, // - No need to ask for extraSections - this is triggered by the master state change
                    itemCollection: function itemCollection(sessionData, StructureService) {
                        return StructureService.itemCollection(sessionData, 'automations');
                    }
                },

                component: 'masterAutomationsBase',

                params: {
                    'new': false,
                    allowNew: true,
                    automationType: null,
                    leftMenuSpecialContext: 'automations',
                    //
                    // All extra sections required for devices view - maybe nest a sub view here to avoid this extra calls
                    //
                    extraSections: ['automations', 'scenes', 'schedules']
                },
                title: 'Automations'
            }, {
                parent: 'Devices',
                name: 'Updates',
                url: 'updates',
                resolve: {
                    sessionData: function sessionData(Session) {
                        return Session.getSiteData(false);
                    }, // - No need to ask for extraSections - this is triggered by the master state change
                    itemCollection: function itemCollection(sessionData, StructureService) {
                        return StructureService.itemCollection(sessionData, 'devices');
                    }
                },

                component: 'masterUpdatesBase',

                params: {
                    'new': false,
                    allowNew: false,
                    leftMenuSpecialContext: 'devices',
                    extraSections: ['updateStatus'] //would put globalUpdates here but too slow
                },
                title: 'Updates'
            }];

            _export('devicesStates', devicesStates);
        }
    };
});

$__System.register('1e0', ['3', '1b2', '1bb', '1be', '1d2', '1d4', '1d5', '1d6', '1d7', '1d8', '1de', '1df'], function (_export) {

    /* Directives */

    /*Quick Add*/
    'use strict';

    /* States */

    /* Other Components */
    var angular, devicesBaseComponent, quickAddBaseComponent, devicesSetupModeToggleComponent, devicesSetupModeSectionComponent, devicesSubSectionMenuComponent, DeviceSettingDirective, devicesStates, adminDevicesModule;
    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_b2) {}, function (_bb) {}, function (_be) {}, function (_d2) {}, function (_d4) {
            devicesBaseComponent = _d4['default'];
        }, function (_d5) {
            quickAddBaseComponent = _d5['default'];
        }, function (_d6) {
            devicesSetupModeToggleComponent = _d6['default'];
        }, function (_d7) {
            devicesSetupModeSectionComponent = _d7['default'];
        }, function (_d8) {
            devicesSubSectionMenuComponent = _d8['default'];
        }, function (_de) {
            DeviceSettingDirective = _de.DeviceSettingDirective;
        }, function (_df) {
            devicesStates = _df.devicesStates;
        }],
        execute: function () {
            adminDevicesModule = angular.module('admin-devices', ['admin-devices-sections', 'admin-devices-updates', 'admin-devices-automations', 'admin-automations'])

            /* Base Devices View */
            .component('devicesBase', devicesBaseComponent)

            /*Quick Add*/
            .component('quickAddBase', quickAddBaseComponent).component('devicesSetupModeToggle', devicesSetupModeToggleComponent).component('devicesSetupModeSection', devicesSetupModeSectionComponent).component('devicesSubSectionMenu', devicesSubSectionMenuComponent).directive('deviceSetting', function () {
                return new DeviceSettingDirective();
            }).config(['$stateRegistryProvider', function ($stateRegistry) {
                _.each(devicesStates, function (state) {
                    $stateRegistry.register(state);
                });
            }]);

            _export('default', adminDevicesModule);
        }
    };
});

$__System.register('1e1', [], function (_export) {
	'use strict';

	function Permissions($http) {

		this.getUser = function (userId, objectName, objectId) {
			return $http({
				method: 'POST',
				url: objectName + '/' + objectId + '/permissions/',
				data: {
					'user': parseInt(userId)
				}
			});
		};

		this.setUser = function (userId, objectName, objectId, permName) {
			return $http({
				method: 'POST',
				url: objectName + '/' + objectId + '/permissions/grant/',
				data: {
					'user': parseInt(userId),
					'permission': permName
				}
			});
		};

		this.revokeUser = function (userId, objectName, objectId, permName) {
			return $http({
				method: 'POST',
				url: objectName + '/' + objectId + '/permissions/revoke/',
				data: {
					'user': parseInt(userId),
					'permission': permName
				}
			});
		};

		this.fetchPermissions = function (userId) {
			return $http({
				method: 'GET',
				url: 'user/' + userId + '/permissions'
			}).then(function (data) {
				data.data.permissions.forEach(function (permission) {
					permission.object_id = parseInt(permission.object_id);
				});

				return data.data;
			});
		};
	}

	return {
		setters: [],
		execute: function () {
			Permissions.$inject = ['$http'];
			_export('default', Permissions);
		}
	};
});

$__System.registerDynamic("1e2", [], true, function ($__require, exports, module) {
  /* */
  "format cjs";

  var global = this || self,
      GLOBAL = global;
});
$__System.registerDynamic("1e3", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function () {/* empty */};
});
$__System.registerDynamic('112', ['1e4'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var cof = $__require('1e4');
  module.exports = 0 in Object('z') ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
});
$__System.registerDynamic('1e5', ['112', '1e6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var IObject = $__require('112'),
      defined = $__require('1e6');
  module.exports = function (it) {
    return IObject(defined(it));
  };
});
$__System.registerDynamic('1e7', ['1e3', '1e8', '1e9', '1e5', '1ea'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var setUnscope = $__require('1e3'),
      step = $__require('1e8'),
      Iterators = $__require('1e9'),
      toIObject = $__require('1e5');
  $__require('1ea')(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated);
    this._i = 0;
    this._k = kind;
  }, function () {
    var O = this._t,
        kind = this._k,
        index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }
    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values');
  Iterators.Arguments = Iterators.Array;
  setUnscope('keys');
  setUnscope('values');
  setUnscope('entries');
});
$__System.registerDynamic('135', ['1e7', '1e9'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('1e7');
  var Iterators = $__require('1e9');
  Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
});
$__System.registerDynamic('1eb', ['10f', '1ec', '1ed'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('10f'),
      SPECIES = $__require('1ec')('species');
  module.exports = function (C) {
    if ($__require('1ed') && !(SPECIES in C)) $.setDesc(C, SPECIES, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  };
});
$__System.registerDynamic("1e8", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (done, value) {
    return { value: value, done: !!done };
  };
});
$__System.registerDynamic('1ee', ['10f', '1ef', '1f0', '1eb', '1f1', '1e6', '1f2', '1e8', '1f3', '113', '1a7', '1ed', '1f4', '1ea', '118'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('10f'),
      hide = $__require('1ef'),
      ctx = $__require('1f0'),
      species = $__require('1eb'),
      strictNew = $__require('1f1'),
      defined = $__require('1e6'),
      forOf = $__require('1f2'),
      step = $__require('1e8'),
      ID = $__require('1f3')('id'),
      $has = $__require('113'),
      isObject = $__require('1a7'),
      isExtensible = Object.isExtensible || isObject,
      SUPPORT_DESC = $__require('1ed'),
      SIZE = SUPPORT_DESC ? '_s' : 'size',
      id = 0;
  var fastKey = function (it, create) {
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$has(it, ID)) {
      if (!isExtensible(it)) return 'F';
      if (!create) return 'E';
      hide(it, ID, ++id);
    }
    return 'O' + it[ID];
  };
  var getEntry = function (that, key) {
    var index = fastKey(key),
        entry;
    if (index !== 'F') return that._i[index];
    for (entry = that._f; entry; entry = entry.n) {
      if (entry.k == key) return entry;
    }
  };
  module.exports = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        strictNew(that, C, NAME);
        that._i = $.create(null);
        that._f = undefined;
        that._l = undefined;
        that[SIZE] = 0;
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
      });
      $__require('1f4')(C.prototype, {
        clear: function clear() {
          for (var that = this, data = that._i, entry = that._f; entry; entry = entry.n) {
            entry.r = true;
            if (entry.p) entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }
          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        'delete': function (key) {
          var that = this,
              entry = getEntry(that, key);
          if (entry) {
            var next = entry.n,
                prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if (prev) prev.n = next;
            if (next) next.p = prev;
            if (that._f == entry) that._f = next;
            if (that._l == entry) that._l = prev;
            that[SIZE]--;
          }
          return !!entry;
        },
        forEach: function forEach(callbackfn) {
          var f = ctx(callbackfn, arguments[1], 3),
              entry;
          while (entry = entry ? entry.n : this._f) {
            f(entry.v, entry.k, this);
            while (entry && entry.r) entry = entry.p;
          }
        },
        has: function has(key) {
          return !!getEntry(this, key);
        }
      });
      if (SUPPORT_DESC) $.setDesc(C.prototype, 'size', { get: function () {
          return defined(this[SIZE]);
        } });
      return C;
    },
    def: function (that, key, value) {
      var entry = getEntry(that, key),
          prev,
          index;
      if (entry) {
        entry.v = value;
      } else {
        that._l = entry = {
          i: index = fastKey(key, true),
          k: key,
          v: value,
          p: prev = that._l,
          n: undefined,
          r: false
        };
        if (!that._f) that._f = entry;
        if (prev) prev.n = entry;
        that[SIZE]++;
        if (index !== 'F') that._i[index] = entry;
      }
      return that;
    },
    getEntry: getEntry,
    setStrong: function (C, NAME, IS_MAP) {
      $__require('1ea')(C, NAME, function (iterated, kind) {
        this._t = iterated;
        this._k = kind;
        this._l = undefined;
      }, function () {
        var that = this,
            kind = that._k,
            entry = that._l;
        while (entry && entry.r) entry = entry.p;
        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
          that._t = undefined;
          return step(1);
        }
        if (kind == 'keys') return step(0, entry.k);
        if (kind == 'values') return step(0, entry.v);
        return step(0, [entry.k, entry.v]);
      }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
      species(C);
      species($__require('118')[NAME]);
    }
  };
});
$__System.registerDynamic("1f1", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (it, Constructor, name) {
    if (!(it instanceof Constructor)) throw TypeError(name + ": use the 'new' operator!");
    return it;
  };
});
$__System.registerDynamic('1f4', ['1f5'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $redef = $__require('1f5');
  module.exports = function (target, src) {
    for (var key in src) $redef(target, key, src[key]);
    return target;
  };
});
$__System.registerDynamic('1f6', ['10f', '116', '1ef', '1f2', '1f1', '1f7', '1ed', '114', '1f4', '1f8'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('10f'),
      $def = $__require('116'),
      hide = $__require('1ef'),
      forOf = $__require('1f2'),
      strictNew = $__require('1f1');
  module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $__require('1f7')[NAME],
        C = Base,
        ADDER = IS_MAP ? 'set' : 'add',
        proto = C && C.prototype,
        O = {};
    if (!$__require('1ed') || typeof C != 'function' || !(IS_WEAK || proto.forEach && !$__require('114')(function () {
      new C().entries().next();
    }))) {
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      $__require('1f4')(C.prototype, methods);
    } else {
      C = wrapper(function (target, iterable) {
        strictNew(target, C, NAME);
        target._c = new Base();
        if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
      });
      $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','), function (KEY) {
        var chain = KEY == 'add' || KEY == 'set';
        if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
          var result = this._c[KEY](a === 0 ? 0 : a, b);
          return chain ? this : result;
        });
      });
      if ('size' in proto) $.setDesc(C.prototype, 'size', { get: function () {
          return this._c.size;
        } });
    }
    $__require('1f8')(C, NAME);
    O[NAME] = C;
    $def($def.G + $def.W + $def.F, O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
  };
});
$__System.registerDynamic('1f9', ['1ee', '1f6'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var strong = $__require('1ee');
  $__require('1f6')('Set', function (get) {
    return function Set() {
      return get(this, arguments[0]);
    };
  }, { add: function add(value) {
      return strong.def(this, value = value === 0 ? 0 : value, value);
    } }, strong);
});
$__System.registerDynamic('1f2', ['1f0', '1fa', '1fb', '132', '1fc', '133'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var ctx = $__require('1f0'),
      call = $__require('1fa'),
      isArrayIter = $__require('1fb'),
      anObject = $__require('132'),
      toLength = $__require('1fc'),
      getIterFn = $__require('133');
  module.exports = function (iterable, entries, fn, that) {
    var iterFn = getIterFn(iterable),
        f = ctx(fn, that, entries ? 2 : 1),
        index = 0,
        length,
        step,
        iterator;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
      entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      call(iterator, f, step.value, entries);
    }
  };
});
$__System.registerDynamic('1fd', ['1f2', '1fe'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var forOf = $__require('1f2'),
      classof = $__require('1fe');
  module.exports = function (NAME) {
    return function toJSON() {
      if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
      var arr = [];
      forOf(this, false, arr.push, arr);
      return arr;
    };
  };
});
$__System.registerDynamic('1ff', ['116', '1fd'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $def = $__require('116');
  $def($def.P, 'Set', { toJSON: $__require('1fd')('Set') });
});
$__System.registerDynamic('200', ['1e2', '136', '135', '1f9', '1ff', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('1e2');
  $__require('136');
  $__require('135');
  $__require('1f9');
  $__require('1ff');
  module.exports = $__require('118').Set;
});
$__System.registerDynamic("61", ["200"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("200"), __esModule: true };
});
$__System.registerDynamic("201", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"new-permissions\">\n    <h2 class=\"overview-heading drop\" ng-class=\"{dropped: pBC.drop}\" ng-click=\"pBC.toggleShowPerms();\">\n        <span translate=\"settings.permissionsUserManagement\">Site Permissions</span>\n    </h2>\n\n    <div class=\"permissions-wrapper\" ng-if=\"pBC.sites && pBC.sites.length>0 && pBC.drop && !(pBC.contextUser.is_staff || pBC.contextUser.is_superuser || pBC.contextUserIsOrgAdmin)\">\n        <div class=\"header\">\n            <div class=\"left\">Name</div>\n            <div class=\"middle\">View</div>\n            <div class=\"right\">Edit</div>\n        </div>\n\n        <div class=\"site-level\">\n            <div class=\"row\" ng-repeat=\"site in pBC.sites\">\n                <permissions-cell\n                    item-permissions=\"site.permissions\"\n                    is-zone-level=\"false\"\n                    level=\"'areas'\"\n                    ng-class=\"{expandable: site.areas.length > 0 && site.ani}\"\n                    ng-click=\"pBC.getZones(site);$event.stopPropagation();\"\n                    ng-disabled=\"!site.areas || site.areas.length == 0\"\n                    ng-mouseover=\"site.ani=true\"\n                    ng-mouseleave=\"site.ani=false\"\n                    num-of-all=\"site.areas.length\"\n                    num-of-edit=\"site.numOfEdit\"\n                    num-of-view=\"site.numOfView\"\n                    pending=\"site.pending\"\n                    permission-title=\"{{::site.id_string}}\"\n                    read-only=\"!pBC.currentSessionUserWriteAccess\"\n                    on-handle-permission=\"pBC.handlePermission(site,operate,type,'site')\"             \n                ></permissions-cell>\n                <div class=\"child-wrapper\" ng-class=\"{active: site.showAreas}\" ng-if=\"site.areas.length > 0\">\n                    <div class=\"expand-sheet\" ng-class=\"{active: site.ani}\" ng-if=\"!site.showAreas\">\n                        <i></i>\n                    </div>\n                    <div class=\"area-level\" ng-if=\"site.showAreas\">\n                        <div class=\"close-sheet\" ng-if=\"site.showAreas\" ng-click=\"site.showAreas = false\">\n                            <i></i>\n                        </div>\n                        <div class=\"list-wrapper\">\n                            <div class=\"row\" ng-repeat=\"area in site.areas\">\n                                <permissions-cell\n                                    item-permissions=\"area.permissions\"\n                                    is-zone-level=\"false\"\n                                    level=\"'zones'\"\n                                    ng-class=\"{expandable: area.zones.length > 0 && area.ani}\"\n                                    ng-click=\"pBC.showZones(area);$event.stopPropagation()\"\n                                    ng-disabled=\"!area.zones || area.zones.length == 0\"\n                                    ng-mouseover=\"area.ani=true\"\n                                    ng-mouseleave=\"area.ani=false\"\n                                    num-of-all=\"area.zones.length\"\n                                    num-of-edit=\"area.numOfEdit\"\n                                    num-of-view=\"area.numOfView\"\n                                    pending=\"area.pending\"\n                                    permission-title=\"{{::area.id_string}}\"\n                                    read-only=\"!pBC.currentSessionUserWriteAccess\"\n                                    on-handle-permission=\"pBC.handlePermission(area,operate,type,'area')\"\n                                ></permissions-cell>\n                                <div class=\"child-wrapper\" ng-class=\"{active: area.showZones}\" ng-if=\"area.zones.length > 0\">\n                                    <div class=\"expand-sheet\" ng-class=\"{active: area.ani}\" ng-if=\"!area.showZones\">\n                                        <i></i>\n                                    </div>\n                                    <div class=\"area-level\" ng-if=\"area.showZones\">\n                                        <div class=\"close-sheet\" ng-if=\"area.showZones\" ng-click=\"area.showZones = false\">\n                                            <i></i>\n                                        </div>\n                                        <div class=\"list-wrapper\">\n                                            <div class=\"row\" ng-repeat=\"zone in area.zones\">\n                                                <permissions-cell\n                                                    item-permissions=\"zone.permissions\"\n                                                    is-zone-level = true\n                                                    level=\"' '\"\n                                                    ng-mouseover=\"zone.ani=true\"\n                                                    ng-mouseleave=\"zone.ani=false\"\n                                                    num-of-edit=\"zone.edit\"\n                                                    num-of-view=\"zone.view\"\n                                                    pending=\"zone.pending\"\n                                                    permission-title=\"{{::zone.id_string}}\"\n                                                    read-only=\"!pBC.currentSessionUserWriteAccess\"\n                                                    on-handle-permission=\"pBC.handlePermission(zone,operate,type,'zone')\"\n                                                ></permissions-cell>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"permissions-wrapper\" ng-if=\"!pBC.sites || pBC.sites.length ===0\">\n        <p>This Org has no sites.</p>\n    </div>\n\n    <div class=\"permissions-wrapper\" ng-if=\"pBC.drop && (pBC.contextUser.is_staff || pBC.contextUser.is_superuser || pBC.contextUserIsOrgAdmin)\">\n        <p>This user has full permissions.</p>\n    </div>\n\n</div>";
});
$__System.register('202', ['61', '201'], function (_export) {
    var _Set, permissionsBaseComponentTmpl, permissionsBaseComponent;

    return {
        setters: [function (_2) {
            _Set = _2['default'];
        }, function (_3) {
            permissionsBaseComponentTmpl = _3['default'];
        }],
        execute: function () {
            'use strict';

            permissionsBaseComponent = {

                template: permissionsBaseComponentTmpl,
                bindings: {
                    currentSessionUserWriteAccess: '<',
                    contextUser: '<',
                    contextUserIsOrgAdmin: '<',
                    org: '<',
                    sites: '<'
                },
                controllerAs: 'pBC',
                controller: function controller(LcFn, Areas, Zones, Permissions, Modals, _) {

                    var pBC = this;

                    var firstFetch = true;

                    var permissions = {
                        site: [],
                        area: [],
                        zone: [],
                        org: []
                    };

                    pBC.toggleShowPerms = function () {
                        pBC.drop = !pBC.drop;

                        if (!(pBC.contextUser.is_staff || pBC.contextUser.is_superuser || pBC.contextUserIsOrgAdmin)) {
                            if (firstFetch) {
                                //getPermissions(pBC.contextUser.id, 'site', pBC.sites);
                                firstFetch = false;

                                Modals.openLoad('Fetching Permissions...');
                                Permissions.fetchPermissions(pBC.contextUser.id).then(function (data) {
                                    if (data && data.permissions) {
                                        permissionsAdd(data.permissions);
                                    }

                                    mapSites();
                                    pBC.sites.forEach(function (site) {
                                        fetchAreas(site);
                                    });
                                    Modals.closeLoad('', true);
                                })['catch'](function (err) {
                                    console.log(err);
                                    Modals.closeLoad('Fetching Permissions Failed');
                                });
                            }
                        }
                    };

                    function permissionsAdd(permissionsSet) {
                        permissionsSet.forEach(function (permission) {
                            if (permissions[permission.object_type]) {
                                permissions[permission.object_type].push(permission);
                            } else {
                                permissions[permission.object_type] = [permission];
                            }
                        });
                    }

                    function permissionsDel(permissionsSet) {
                        permissionsSet.forEach(function (permission) {
                            _.remove(permissions[permission.object_type], function (perm) {
                                return perm.object_id === permission.object_id && perm.permission === permission.permission;
                            });
                        });
                    }

                    function mapSites() {
                        pBC.sites.forEach(function (site) {
                            site.permissions = _.filter(permissions.site, ['object_id', site.id]);
                        });
                    }

                    function fetchAreas(site) {
                        Areas.get(site.id).then(function (areas) {
                            site.areas = areas;
                            mapAreas(site);
                        })['catch'](function (err) {
                            console.log(err);
                        });
                    }

                    function mapAreas(site) {
                        var viewC = 0;
                        var editC = 0;
                        site.areas.forEach(function (area) {
                            area.permissions = _.filter(permissions.area, ['object_id', area.id]);
                            if (area.permissions) {
                                (function () {
                                    var hashset = new _Set();
                                    area.permissions.forEach(function (permission) {

                                        if (permission.permission === 'view_area') {
                                            if (!hashset.has('view_area')) {
                                                viewC += 1;
                                                hashset.add('view_area');
                                            }
                                        } else {
                                            if (!hashset.has('edit_area')) {
                                                hashset.add('edit_area');
                                                editC += 1;
                                            }
                                        }
                                    });
                                })();
                            }
                        });

                        site.numOfView = viewC;
                        site.numOfEdit = editC;
                    }

                    function mapZones(area) {
                        if (area.zones && area.zones.length >= 1) {
                            var viewC = 0;
                            var editC = 0;
                            area.zones.forEach(function (zone) {
                                zone.permissions = _.filter(permissions.zone, ['object_id', zone.id]);
                                zone.view = 0;
                                zone.edit = 0;
                                if (zone.permissions) {
                                    (function () {
                                        var hashset = new _Set();
                                        zone.permissions.forEach(function (permission) {
                                            if (permission.permission === 'view_zone') {
                                                if (!hashset.has('view_zone')) {
                                                    hashset.add('view_zone');
                                                    viewC += 1;
                                                    zone.view = 1;
                                                }
                                            } else {
                                                if (!hashset.has('edit_zone')) {
                                                    hashset.add('edit_zone');
                                                    editC += 1;
                                                    zone.edit = 1;
                                                }
                                            }
                                        });
                                    })();
                                }
                            });
                            area.numOfView = viewC;
                            area.numOfEdit = editC;
                        }
                    }

                    pBC.getZones = function (site) {
                        site.showAreas = !site.showAreas;
                        if (site.zones) {} else {
                            Zones.getForSite(site.id).then(function (zones) {
                                site.zones = zones;
                                site.areas.forEach(function (area) {
                                    area.zones = _.filter(site.zones, function (zone) {
                                        return zone.area === area.id;
                                    });
                                    mapZones(area);
                                });
                            });
                        }
                    };

                    pBC.showZones = function (area) {
                        area.showZones = !area.showZones;
                    };

                    pBC.handlePermission = function (object, operate, type, level) {

                        object.pending = true;
                        var levelType = type + '_' + level;
                        if (operate === 'grant') {
                            Permissions.setUser(pBC.contextUser.id, level, object.id, levelType).then(function (data) {
                                //console.log(data);
                                permissionsAdd(data.data);
                                if (level === 'site') {
                                    mapSites();
                                    mapAreas(object);
                                    if (object.zones) {
                                        object.areas.forEach(function (area) {
                                            mapZones(area);
                                        });
                                    }
                                } else if (level === 'area') {
                                    var site = _.find(pBC.sites, ['id', object.siteId]);
                                    mapAreas(site);
                                    site.areas.forEach(function (area) {
                                        mapZones(area);
                                    });
                                } else {

                                    var site = _.find(pBC.sites, ['id', object.site]);

                                    mapAreas(site);
                                    site.areas.forEach(function (area) {
                                        mapZones(area);
                                    });
                                }

                                object.pending = false;
                            })['catch'](function (err) {
                                console.log(err);
                            });
                        } else {
                            Permissions.revokeUser(pBC.contextUser.id, level, object.id, levelType).then(function (data) {

                                permissionsDel(data.data);
                                if (level === 'site') {
                                    mapSites();
                                    mapAreas(object);
                                    if (object.zones) {
                                        object.areas.forEach(function (area) {
                                            mapZones(area);
                                        });
                                    }
                                } else if (level === 'area') {
                                    var site = _.find(pBC.sites, ['id', object.siteId]);
                                    mapAreas(site);
                                    site.areas.forEach(function (area) {
                                        mapZones(area);
                                    });
                                } else {
                                    var site = _.find(pBC.sites, ['id', object.site]);
                                    mapAreas(site);
                                    site.areas.forEach(function (area) {
                                        mapZones(area);
                                    });
                                }

                                object.pending = false;
                            })['catch'](function (err) {
                                console.log(err);
                            });
                        }
                    };
                }
            };

            _export('default', permissionsBaseComponent);
        }
    };
});

$__System.registerDynamic("203", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading drop\" ng-class=\"{dropped: pSC.drop}\" ng-click=\"pSC.toggleShowPerms();\">\n    <span translate=\"settings.permissionsUserManagement\">Site Permissions</span>\n</h2>\n\n<section class=\"\" ng-if=\"pSC.drop;\">\n\n\t<header class=\"permissions-list-header\">\n\t\t<span class=\"caps right edit\" translate=\"common.edit\">edit</span>\n\t\t<span class=\"caps right view\" translate=\"common.view\">view</span>\n\t</header>\n\n\t<div class=\"permissions-sites-list-wrapper\">\n\t\t<ul class=\"permissions-sites-list\">\n\t\t\t<li class=\"permissions-sites-site\" ng-class=\"{show:pSC.show}\" ng-repeat=\"site in pSC.sites\">\n\t\t\t\t\n\t\t\t\t<div class=\"lc-pill\">\n\t\t\t\t\t<span class=\"pill-right\">\n\t\t\t\t\t\t<button class=\"btn-check-select view\" \tng-disabled=\"site.showAreas\" ng-class=\"{all:site.perms.indexOf('view_site') != -1, pending: site.pending, greyed: site.showAreas}\"\t ng-click=\"pSC.setPermissions(site,'site','view_site')\"></button>\n\t\t\t\t\t\t<button class=\"btn-check-select edit\" \tng-disabled=\"site.showAreas\" ng-class=\"{all:site.perms.indexOf('edit_site') != -1, pending: site.pending, greyed: site.showAreas}\"    ng-click=\"pSC.setPermissions(site,'site','edit_site')\"></button>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"pill-left\">\n\t\t\t\t\t\t<h1>{{::site.id_string}}</h1>\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<span class=\"pill-center\">\n\t\t\t\t\t\t<button class=\"btn\" ng-click=\"pSC.getAreas(site)\" ng-disabled=\"site.pending\" ng-bind=\"site.showAreas ? 'Hide Areas':'Show Areas'\"></button>\n\t\t\t\t\t</span>\n\t\t\t\t\t\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"site-areas\" ng-show=\"site.showAreas\">\n\t\t\t\t\t<h2 class=\"overview-heading\">\n\t\t\t\t\t   <span translate=\"settings.areaPermissions\">Area Permissions</span>\n\t\t\t\t\t</h2>\n\t\t\t\t\t<p ng-show=\"site.areas.length == 0\" translate=\"settings.noAreas\">No Areas</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"site-areas\" ng-show=\"site.showAreas\" ng-repeat=\"area in site.areas\">\n\t\t\t\t\t<div class=\"lc-pill\">\n\t\t\t\t\t\t<span class=\"pill-right\">\n\t\t\t\t\t\t\t<button class=\"btn-check-select view\" \tng-disabled=\"area.showZones\" ng-class=\"{all:area.perms.indexOf('view_area') != -1, pending: area.pending, greyed: area.showZones}\"\t ng-click=\"pSC.setPermissions(area,'area','view_area')\"></button>\n\t\t\t\t\t\t\t<button class=\"btn-check-select edit\" \tng-disabled=\"area.showZones\" ng-class=\"{all:area.perms.indexOf('edit_area') != -1, pending: area.pending, greyed: area.showZones}\"    ng-click=\"pSC.setPermissions(area,'area','edit_area')\"></button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class=\"pill-left\">\n\t\t\t\t\t\t\t<h1 ng-bind=\"area.id_string\"></h1>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class=\"pill-center\">\n\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"pSC.getZones(site, area)\" translate>{{area.showZones ? 'settings.hideZones':'settings.showZones'}}</button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"area-zones\" ng-show=\"area.showZones\">\n\t\t\t\t\t\t<h2 class=\"overview-heading\">\n\t\t\t\t\t\t   <span translate=\"settings.zonePermissions\">Zone Permissions</span>\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<p ng-show=\"area.zones.length == 0\" translate=\"settings.noZones\">No Zones</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"area-zones\" ng-show=\"area.showZones\" ng-repeat=\"zone in area.zones\">\n\t\t\t\t\t\t<div class=\"lc-pill\">\n\t\t\t\t\t\t\t<span class=\"pill-right\">\n\t\t\t\t\t\t\t\t<button class=\"btn-check-select view\" \t ng-class=\"{all:zone.perms.indexOf('view_zone') != -1, pending: zone.pending}\"\t ng-click=\"pSC.setPermissions(zone,'zone','view_zone')\"></button>\n\t\t\t\t\t\t\t\t<button class=\"btn-check-select edit\" \t ng-class=\"{all:zone.perms.indexOf('edit_zone') != -1, pending: zone.pending}\"    ng-click=\"pSC.setPermissions(zone,'zone','edit_zone')\"></button>\n\t\t\t\t\t\t\t</span>\t\n\t\t\t\t\t\t\t<span class=\"pill-left\">\n\t\t\t\t\t\t\t\t<h1>{{::zone.id_string}}</h1>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"pill-center\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t\n</section>";
});
$__System.register('204', ['203'], function (_export) {
	'use strict';

	var permissionsSectionComponentTmpl, permissionsSectionComponent;
	return {
		setters: [function (_2) {
			permissionsSectionComponentTmpl = _2['default'];
		}],
		execute: function () {
			permissionsSectionComponent = {
				template: permissionsSectionComponentTmpl,
				bindings: {
					sites: '<',
					user: '<'
				},
				controllerAs: 'pSC',
				controller: function controller(Areas, Zones, Permissions) {

					var pSC = this;

					var firstFetch = true;

					pSC.$onInit = function () {
						//getPermissions(pSC.user.id, 'site', pSC.sites);
					};

					pSC.$onChanges = function (changes) {};

					pSC.toggleShowPerms = function () {
						pSC.drop = !pSC.drop;

						if (firstFetch) {
							getPermissions(pSC.user.id, 'site', pSC.sites);
							firstFetch = false;
						}
					};

					pSC.getAreas = function (site) {
						if (site.showAreas) {
							site.showAreas = false;
						} else {
							site.pending = true;
							Areas.get(site.id).then(function (areas) {
								site.areas = areas;
								site.showAreas = true;
								getPermissions(pSC.user.id, 'area', site.areas);
								site.pending = false;
							});
						}
					};

					pSC.getZones = function (site, area) {
						if (area.showZones) {
							area.showZones = false;
						} else {
							if (!site.zones) {
								Zones.getForSite(site.id).then(function (zones) {
									site.zones = zones;
									finish(area, site);
								});
							} else {
								finish(area, site);
							}
						}
					};

					pSC.showPermissionList = function () {
						pSC.showPermissions = !pSC.showPermissions;
					};

					pSC.setPermissions = function (object, objectName, perm) {
						object.pending = true;
						if (object.perms && object.perms.indexOf(perm) !== -1) {
							Permissions.revokeUser(pSC.user.id, objectName, object.id, perm).then(function () {
								object.perms.splice(object.perms.indexOf(perm), 1);
								object.pending = false;
							});
						} else {
							Permissions.setUser(pSC.user.id, objectName, object.id, perm).then(function () {
								object.perms.push(perm);

								//Toggle View permission if granting edit - backend should have cascaded for us - [ch2939]
								if (perm.indexOf('edit_') > -1 && object.perms.indexOf('view_' + objectName) === -1) {
									object.perms.push('view_' + objectName);
								}

								object.pending = false;
							});
						}
					};

					function getPermissions(userId, objectName, collection) {
						collection.forEach(function (object) {
							object.pending = true;

							Permissions.getUser(userId, objectName, object.id).success(function (perms) {
								object.perms = perms;
								object.pending = false;
							});
						});
					}

					function finish(area, site) {
						area.zones = _.filter(site.zones, function (zone) {
							return zone.area === area.id;
						});
						area.showZones = true;
						getPermissions(pSC.user.id, 'zone', area.zones);
					}
				}
			};

			_export('default', permissionsSectionComponent);
		}
	};
});

$__System.registerDynamic("205", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<h2 class=\"overview-heading drop\" ng-class=\"{dropped: pMO.drop}\" ng-click=\"pMO.toggleShowPerms();\">\n    <span translate=\"\">Multi Org User Management</span>\n</h2>\n\n<section class=\"\" ng-if=\"pMO.drop;\">\n\n\t<div class=\"permissions-sites-list-wrapper multi-org-user-perms\">\n\t\t<ul>\n\t\t\t<li ng-repeat=\"orgPerm in pMO.orgPermsList\">\n\t\t\t\t<div class=\"lc-pill\">\n\t\t\t\t\t<span class=\"pill-right\">\n\t\t\t\t\t\t<button ng-class=\"::{'admin': orgPerm.permission_name === 'org_admin'}\" class=\"btn red\" ng-click=\"pMO.removePerm(pMO.contextUser,orgPerm.id,orgPerm.permission_name)\"><span>{{::orgPerm.permission_name === 'org_admin' ? 'Revoke Admin':'Revoke User'}}</span></button>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"pill-left\">\n\t\t\t\t\t\t<h1>{{::orgPerm.name}} - {{::orgPerm.permission_name === 'org_admin' ? 'Admin':'User'}}</h1>\n\t\t\t\t\t</span>\t\t\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ul>\n\n        <div class=\"lc-pill\">\n\n                <div class=\"search-box search-input-wrapper\">\n                    <i class=\"fa fa-search\"></i>\n                    <input class=\"search\" placeholder=\"Search for Org\" ng-model=\"pMO.orgSearch\" />\n                </div>\n\n        </div>\n\n    </div>\n\n</section>\n\n<div ng-show=\"pMO.orgSearch\">\n\n    <h2 class=\"overview-heading\">\n        <span translate=\"\">Results</span>\n    </h2>\n\n    <section class=\"\">\n\n\t\t<ul>\n\t\t\t<li id=\"orgId-{{::org.id}}\" ng-class=\"{'selected': org.selected}\" ng-repeat=\"org in pMO.orgList | filter:pMO.orgSearch\">\n\t\t\t\t<div class=\"lc-pill\">\n\t\t\t\t\t<span class=\"pill-left\">\n\t\t\t\t\t\t<h1 ng-bind=\"::org.name\">Default Org Name</h1>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"pill-right\">\n\t\t\t\t\t\t<button class=\"btn\" ng-click=\"pMO.grantPerm(pMO.contextUser,org,'org_admin');\">Grant Admin</button>\n\t\t\t\t\t\t<button class=\"btn\" ng-click=\"pMO.grantPerm(pMO.contextUser,org,'org_user');\">Grant User</button>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ul>\n\n\t</section>\n\n</div>";
});
$__System.register('206', ['205'], function (_export) {
    'use strict';

    var permissionsMultiOrgTmpl, permissionsMultiOrgComponent;
    return {
        setters: [function (_2) {
            permissionsMultiOrgTmpl = _2['default'];
        }],
        execute: function () {
            permissionsMultiOrgComponent = {
                template: permissionsMultiOrgTmpl,
                bindings: {
                    org: '<',
                    contextUser: '<',
                    onUserUpdate: '&'
                },
                controllerAs: 'pMO',
                controller: function controller(_, Orgs, Permissions, LcFn, $q, Users) {

                    var pMO = this;

                    pMO.$onInit = function () {};

                    pMO.$onChanges = function (changes) {
                        //
                    };

                    pMO.toggleShowPerms = function () {
                        pMO.drop = !pMO.drop;

                        if (pMO.drop) {
                            prepareView(pMO.contextUser);
                        }
                    };

                    pMO.removePerm = function (user, permissionId, permissionName) {
                        Permissions.revokeUser(user.id, 'org', permissionId, permissionName).then(function () {
                            LcFn.removeFromLists([permissionId], [pMO.orgPermsList]);
                            pMO.onUserUpdate(pMO.contextUser);
                        });
                    };

                    pMO.grantPerm = function (user, org, permissionName) {
                        Permissions.setUser(user.id, 'org', org.id, permissionName).then(function () {
                            //
                            pMO.orgPermsList.push({ name: org.name, id: org.id, permission_name: permissionName });
                            pMO.onUserUpdate(pMO.contextUser);
                        });
                    };

                    function prepareView(user) {
                        pMO.ajaxPending = true;

                        $q.all([getOrgs(), getUser(user.id)]).then(function (responses) {
                            pMO.orgList = responses[0];
                            pMO.contextUser = responses[1];
                            pMO.orgPermsList = mapOrgPerms(filterOrgPerms(pMO.contextUser.permissions), pMO.orgList);
                        })['finally'](function () {
                            pMO.ajaxPending = false;
                        });
                    }

                    function getUser(id) {
                        return Users.get(id);
                    }

                    function getOrgs() {
                        return Orgs.getAll();
                    }

                    function mapOrgPerms(perms, orgs) {
                        return _.map(perms, function (perm) {
                            var orgMatch = _.find(orgs, ['id', perm.object_id]);

                            return {
                                name: orgMatch.name,
                                id: orgMatch.id,
                                permission_name: perm.permission
                            };
                        });
                    }

                    function filterOrgPerms(permissions) {
                        return _.filter(permissions, function (perm) {
                            return perm.permission === 'org_admin' || perm.permission === 'org_user';
                        });
                    }
                }
            };

            _export('default', permissionsMultiOrgComponent);
        }
    };
});

$__System.register('207', [], function (_export) {
    'use strict';
    var permissionCellComponent;
    return {
        setters: [],
        execute: function () {
            permissionCellComponent = {
                template: '\n        <div class="cell">\n            <div class="title">{{::pCC.permissionTitle}}</div>\n            <div class="view ">\n                <permissions-operation\n                    is-zone-level="pCC.isZoneLevel"\n                    level="pCC.level"\n                    num-of-granted="pCC.numOfView"\n                    num-of-all="pCC.numOfAll"\n                    pending="pCC.pending"\n                    read-only="pCC.readOnly"\n                    single-grant="pCC.grantCheck(\'view\')"\n                    on-operate="pCC.operate(operate,\'view\')"\n                ></permissions-operation>\n            </div>\n            <div class="edit">\n                <permissions-operation\n                    is-zone-level="pCC.isZoneLevel"\n                    level="pCC.level"\n                    num-of-granted="pCC.numOfEdit"\n                    num-of-all="pCC.numOfAll"\n                    pending="pCC.pending"\n                    read-only="pCC.readOnly"\n                    single-grant="pCC.grantCheck(\'edit\')"\n                    on-operate="pCC.operate(operate,\'edit\')"\n                ></permissions-operation>\n            </div>\n        </div>\n    ',
                bindings: {
                    itemPermissions: '<',
                    isZoneLevel: '<',
                    level: '<',
                    numOfAll: '<',
                    numOfEdit: '<',
                    numOfView: '<',
                    pending: '<',
                    permissionTitle: '@',
                    readOnly: '<',
                    onHandlePermission: '&?'
                },
                controllerAs: 'pCC',
                controller: function controller(_) {
                    var pCC = this;

                    pCC.grantCheck = function (type) {
                        if (pCC.itemPermissions) {
                            return _.find(pCC.itemPermissions, function (permission) {
                                return permission.permission.includes(type);
                            });
                        }
                    };

                    pCC.operate = function (operate, type) {
                        pCC.onHandlePermission({ operate: operate, type: type });
                    };
                }

            };

            _export('default', permissionCellComponent);
        }
    };
});

$__System.register('208', [], function (_export) {
    'use strict';
    var permissionOperationComponent;
    return {
        setters: [],
        execute: function () {
            permissionOperationComponent = {
                template: '\n        <div class="operation">\n            <div class="count" ng-class="{writeable: !pOC.readOnly, granted: (pOC.numOfAll && pOC.numOfGranted === pOC.numOfAll) || (!pOC.numOfAll && pOC.singleGrant)}" ng-if="!pOC.isZoneLevel" >\n                <span \n                    class="description" \n                    ng-class="{revoke: (pOC.numOfAll && pOC.numOfGranted === pOC.numOfAll), pending: pOC.pending}"\n                >\n                    {{pOC.numOfAll ? pOC.numOfGranted + \' \'+ (pOC.numOfGranted > -1 ? \'of\' : \'\') + \' \' +pOC.numOfAll+ \' \' +pOC.level : \'No \'+ pOC.level}}\n                </span>\n                <span \n                    class="button" \n                    ng-click="pOC.operating(\'count\');$event.stopPropagation();" \n                    ng-class="{revoke: (pOC.numOfAll && pOC.numOfGranted === pOC.numOfAll), pending: pOC.pending}" \n                    ng-disabled="pOC.pending"\n                >\n                    {{pOC.numOfAll ? pOC.numOfGranted === pOC.numOfAll ? \'Revoke All\' : \'Grant All\': pOC.singleGrant ? \'Revoke\': \'Grant\' }}\n                </span>\n            </div>\n            <div class="operate" ng-class="{writeable: !pOC.readOnly, granted: pOC.numOfGranted > 0}" ng-if="pOC.isZoneLevel">\n                <span \n                    class="description" \n                    ng-class="{pending:pOC.pending}"\n                >\n                    {{pOC.numOfGranted > 0 ? \'Granted\' : \'No Perm\'}}\n                </span>\n                <span \n                    class="button" \n                    ng-click="pOC.operating(\'operate\');$event.stopPropagation();" \n                    ng-class="{pending:pOC.pending}" ng-disabled="pOC.pending || pOC.readOnly"\n                >\n                    {{pOC.numOfGranted > 0 ? \'Revoke\' : \'Grant\'}}\n                </span>\n            </div>\n        </div>\n    ',
                bindings: {
                    isZoneLevel: '<',
                    level: '<',
                    numOfGranted: '<',
                    numOfAll: '<',
                    pending: '<',
                    readOnly: '<',
                    singleGrant: '<',
                    onOperate: '&?'
                },
                controllerAs: 'pOC',
                controller: function controller() {
                    var pOC = this;

                    pOC.operating = function (type) {
                        if (!pOC.readOnly) {
                            if (type === 'operate') {
                                if (pOC.numOfGranted > 0) {
                                    pOC.onOperate({ operate: 'revoke' });
                                } else {
                                    pOC.onOperate({ operate: 'grant' });
                                }
                            } else {
                                if (pOC.numOfAll && pOC.numOfGranted === pOC.numOfAll || !pOC.numOfAll && pOC.singleGrant) {
                                    pOC.onOperate({ operate: 'revoke' });
                                } else {
                                    pOC.onOperate({ operate: 'grant' });
                                }
                            }
                        }
                    };
                }

            };

            _export('default', permissionOperationComponent);
        }
    };
});

$__System.register('209', ['3', '202', '204', '206', '207', '208', '1e1'], function (_export) {
    'use strict';

    var angular, permissionBaseComponent, permissionsSectionComponent, permissionsMultiOrgComponent, permissionsCellComponent, permissionsOperationComponent, permissionsService, permissionsModule;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            permissionBaseComponent = _2['default'];
        }, function (_3) {
            permissionsSectionComponent = _3['default'];
        }, function (_4) {
            permissionsMultiOrgComponent = _4['default'];
        }, function (_5) {
            permissionsCellComponent = _5['default'];
        }, function (_6) {
            permissionsOperationComponent = _6['default'];
        }, function (_e1) {
            permissionsService = _e1['default'];
        }],
        execute: function () {
            permissionsModule = angular.module('permissions', []).service('Permissions', permissionsService).component('permissionsBase', permissionBaseComponent).component('permissionsSection', permissionsSectionComponent).component('permissionsMultiOrg', permissionsMultiOrgComponent).component('permissionsCell', permissionsCellComponent).component('permissionsOperation', permissionsOperationComponent);

            _export('default', permissionsModule);
        }
    };
});

$__System.register('20a', ['3', '209', '1e0'], function (_export) {
	'use strict';

	var angular, Permissions, AdminDevices, adminModule;
	return {
		setters: [function (_) {
			angular = _['default'];
		}, function (_2) {
			Permissions = _2['default'];
		}, function (_e0) {
			AdminDevices = _e0['default'];
		}],
		execute: function () {
			adminModule = angular.module('app.admin', [AdminDevices.name, Permissions.name]);

			_export('default', adminModule);
		}
	};
});

$__System.registerDynamic("20b", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, "angular", null);

  (function ($__global) {
    /* */
    "format global";
    "exports angular";
    /**
     * @license AngularJS v1.5.8
     * (c) 2010-2016 Google, Inc. http://angularjs.org
     * License: MIT
     */

    (function (window) {
      'use strict';

      /**
       * @description
       *
       * This object provides a utility for producing rich Error messages within
       * Angular. It can be called as follows:
       *
       * var exampleMinErr = minErr('example');
       * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
       *
       * The above creates an instance of minErr in the example namespace. The
       * resulting error will have a namespaced error code of example.one.  The
       * resulting error will replace {0} with the value of foo, and {1} with the
       * value of bar. The object is not restricted in the number of arguments it can
       * take.
       *
       * If fewer arguments are specified than necessary for interpolation, the extra
       * interpolation markers will be preserved in the final string.
       *
       * Since data will be parsed statically during a build step, some restrictions
       * are applied with respect to how minErr instances are created and called.
       * Instances should have names of the form namespaceMinErr for a minErr created
       * using minErr('namespace') . Error codes, namespaces and template strings
       * should all be static strings, not variables or general expressions.
       *
       * @param {string} module The namespace to use for the new minErr instance.
       * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
       *   error from returned function, for cases when a particular type of error is useful.
       * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
       */

      function minErr(module, ErrorConstructor) {
        ErrorConstructor = ErrorConstructor || Error;
        return function () {
          var SKIP_INDEXES = 2;

          var templateArgs = arguments,
              code = templateArgs[0],
              message = '[' + (module ? module + ':' : '') + code + '] ',
              template = templateArgs[1],
              paramPrefix,
              i;

          message += template.replace(/\{\d+\}/g, function (match) {
            var index = +match.slice(1, -1),
                shiftedIndex = index + SKIP_INDEXES;

            if (shiftedIndex < templateArgs.length) {
              return toDebugString(templateArgs[shiftedIndex]);
            }

            return match;
          });

          message += '\nhttp://errors.angularjs.org/1.5.8/' + (module ? module + '/' : '') + code;

          for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
            message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' + encodeURIComponent(toDebugString(templateArgs[i]));
          }

          return new ErrorConstructor(message);
        };
      }

      /* We need to tell jshint what variables are being exported */
      /* global angular: true,
        msie: true,
        jqLite: true,
        jQuery: true,
        slice: true,
        splice: true,
        push: true,
        toString: true,
        ngMinErr: true,
        angularModule: true,
        uid: true,
        REGEX_STRING_REGEXP: true,
        VALIDITY_STATE_PROPERTY: true,
      
        lowercase: true,
        uppercase: true,
        manualLowercase: true,
        manualUppercase: true,
        nodeName_: true,
        isArrayLike: true,
        forEach: true,
        forEachSorted: true,
        reverseParams: true,
        nextUid: true,
        setHashKey: true,
        extend: true,
        toInt: true,
        inherit: true,
        merge: true,
        noop: true,
        identity: true,
        valueFn: true,
        isUndefined: true,
        isDefined: true,
        isObject: true,
        isBlankObject: true,
        isString: true,
        isNumber: true,
        isDate: true,
        isArray: true,
        isFunction: true,
        isRegExp: true,
        isWindow: true,
        isScope: true,
        isFile: true,
        isFormData: true,
        isBlob: true,
        isBoolean: true,
        isPromiseLike: true,
        trim: true,
        escapeForRegexp: true,
        isElement: true,
        makeMap: true,
        includes: true,
        arrayRemove: true,
        copy: true,
        equals: true,
        csp: true,
        jq: true,
        concat: true,
        sliceArgs: true,
        bind: true,
        toJsonReplacer: true,
        toJson: true,
        fromJson: true,
        convertTimezoneToLocal: true,
        timezoneToOffset: true,
        startingTag: true,
        tryDecodeURIComponent: true,
        parseKeyValue: true,
        toKeyValue: true,
        encodeUriSegment: true,
        encodeUriQuery: true,
        angularInit: true,
        bootstrap: true,
        getTestability: true,
        snake_case: true,
        bindJQuery: true,
        assertArg: true,
        assertArgFn: true,
        assertNotHasOwnProperty: true,
        getter: true,
        getBlockNodes: true,
        hasOwnProperty: true,
        createMap: true,
      
        NODE_TYPE_ELEMENT: true,
        NODE_TYPE_ATTRIBUTE: true,
        NODE_TYPE_TEXT: true,
        NODE_TYPE_COMMENT: true,
        NODE_TYPE_DOCUMENT: true,
        NODE_TYPE_DOCUMENT_FRAGMENT: true,
      */

      ////////////////////////////////////

      /**
       * @ngdoc module
       * @name ng
       * @module ng
       * @installation
       * @description
       *
       * # ng (core module)
       * The ng module is loaded by default when an AngularJS application is started. The module itself
       * contains the essential components for an AngularJS application to function. The table below
       * lists a high level breakdown of each of the services/factories, filters, directives and testing
       * components available within this core module.
       *
       * <div doc-module-components="ng"></div>
       */

      var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

      // The name of a form control's ValidityState property.
      // This is used so that it's possible for internal tests to create mock ValidityStates.
      var VALIDITY_STATE_PROPERTY = 'validity';

      var hasOwnProperty = Object.prototype.hasOwnProperty;

      var lowercase = function (string) {
        return isString(string) ? string.toLowerCase() : string;
      };
      var uppercase = function (string) {
        return isString(string) ? string.toUpperCase() : string;
      };

      var manualLowercase = function (s) {
        /* jshint bitwise: false */
        return isString(s) ? s.replace(/[A-Z]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) | 32);
        }) : s;
      };
      var manualUppercase = function (s) {
        /* jshint bitwise: false */
        return isString(s) ? s.replace(/[a-z]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) & ~32);
        }) : s;
      };

      // String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
      // locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
      // with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
      if ('i' !== 'I'.toLowerCase()) {
        lowercase = manualLowercase;
        uppercase = manualUppercase;
      }

      var msie,
          // holds major version number for IE, or NaN if UA is not IE.
      jqLite,
          // delay binding since jQuery could be loaded after us.
      jQuery,
          // delay binding
      slice = [].slice,
          splice = [].splice,
          push = [].push,
          toString = Object.prototype.toString,
          getPrototypeOf = Object.getPrototypeOf,
          ngMinErr = minErr('ng'),


      /** @name angular */
      angular = window.angular || (window.angular = {}),
          angularModule,
          uid = 0;

      /**
       * documentMode is an IE-only property
       * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
       */
      msie = window.document.documentMode;

      /**
       * @private
       * @param {*} obj
       * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
       *                   String ...)
       */
      function isArrayLike(obj) {

        // `null`, `undefined` and `window` are not array-like
        if (obj == null || isWindow(obj)) return false;

        // arrays, strings and jQuery/jqLite objects are array like
        // * jqLite is either the jQuery or jqLite constructor function
        // * we have to check the existence of jqLite first as this method is called
        //   via the forEach method when constructing the jqLite object in the first place
        if (isArray(obj) || isString(obj) || jqLite && obj instanceof jqLite) return true;

        // Support: iOS 8.2 (not reproducible in simulator)
        // "length" in obj used to prevent JIT error (gh-11508)
        var length = "length" in Object(obj) && obj.length;

        // NodeList objects (with `item` method) and
        // other objects with suitable length characteristics are array-like
        return isNumber(length) && (length >= 0 && (length - 1 in obj || obj instanceof Array) || typeof obj.item == 'function');
      }

      /**
       * @ngdoc function
       * @name angular.forEach
       * @module ng
       * @kind function
       *
       * @description
       * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
       * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
       * is the value of an object property or an array element, `key` is the object property key or
       * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
       *
       * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
       * using the `hasOwnProperty` method.
       *
       * Unlike ES262's
       * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
       * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
       * return the value provided.
       *
         ```js
           var values = {name: 'misko', gender: 'male'};
           var log = [];
           angular.forEach(values, function(value, key) {
             this.push(key + ': ' + value);
           }, log);
           expect(log).toEqual(['name: misko', 'gender: male']);
         ```
       *
       * @param {Object|Array} obj Object to iterate over.
       * @param {Function} iterator Iterator function.
       * @param {Object=} context Object to become context (`this`) for the iterator function.
       * @returns {Object|Array} Reference to `obj`.
       */

      function forEach(obj, iterator, context) {
        var key, length;
        if (obj) {
          if (isFunction(obj)) {
            for (key in obj) {
              // Need to check if hasOwnProperty exists,
              // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
              if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (isArray(obj) || isArrayLike(obj)) {
            var isPrimitive = typeof obj !== 'object';
            for (key = 0, length = obj.length; key < length; key++) {
              if (isPrimitive || key in obj) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (obj.forEach && obj.forEach !== forEach) {
            obj.forEach(iterator, context, obj);
          } else if (isBlankObject(obj)) {
            // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for (key in obj) {
              iterator.call(context, obj[key], key, obj);
            }
          } else if (typeof obj.hasOwnProperty === 'function') {
            // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
            for (key in obj) {
              if (obj.hasOwnProperty(key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else {
            // Slow path for objects which do not have a method `hasOwnProperty`
            for (key in obj) {
              if (hasOwnProperty.call(obj, key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          }
        }
        return obj;
      }

      function forEachSorted(obj, iterator, context) {
        var keys = Object.keys(obj).sort();
        for (var i = 0; i < keys.length; i++) {
          iterator.call(context, obj[keys[i]], keys[i]);
        }
        return keys;
      }

      /**
       * when using forEach the params are value, key, but it is often useful to have key, value.
       * @param {function(string, *)} iteratorFn
       * @returns {function(*, string)}
       */
      function reverseParams(iteratorFn) {
        return function (value, key) {
          iteratorFn(key, value);
        };
      }

      /**
       * A consistent way of creating unique IDs in angular.
       *
       * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
       * we hit number precision issues in JavaScript.
       *
       * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
       *
       * @returns {number} an unique alpha-numeric string
       */
      function nextUid() {
        return ++uid;
      }

      /**
       * Set or clear the hashkey for an object.
       * @param obj object
       * @param h the hashkey (!truthy to delete the hashkey)
       */
      function setHashKey(obj, h) {
        if (h) {
          obj.$$hashKey = h;
        } else {
          delete obj.$$hashKey;
        }
      }

      function baseExtend(dst, objs, deep) {
        var h = dst.$$hashKey;

        for (var i = 0, ii = objs.length; i < ii; ++i) {
          var obj = objs[i];
          if (!isObject(obj) && !isFunction(obj)) continue;
          var keys = Object.keys(obj);
          for (var j = 0, jj = keys.length; j < jj; j++) {
            var key = keys[j];
            var src = obj[key];

            if (deep && isObject(src)) {
              if (isDate(src)) {
                dst[key] = new Date(src.valueOf());
              } else if (isRegExp(src)) {
                dst[key] = new RegExp(src);
              } else if (src.nodeName) {
                dst[key] = src.cloneNode(true);
              } else if (isElement(src)) {
                dst[key] = src.clone();
              } else {
                if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
                baseExtend(dst[key], [src], true);
              }
            } else {
              dst[key] = src;
            }
          }
        }

        setHashKey(dst, h);
        return dst;
      }

      /**
       * @ngdoc function
       * @name angular.extend
       * @module ng
       * @kind function
       *
       * @description
       * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
       * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
       * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
       *
       * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
       * {@link angular.merge} for this.
       *
       * @param {Object} dst Destination object.
       * @param {...Object} src Source object(s).
       * @returns {Object} Reference to `dst`.
       */
      function extend(dst) {
        return baseExtend(dst, slice.call(arguments, 1), false);
      }

      /**
      * @ngdoc function
      * @name angular.merge
      * @module ng
      * @kind function
      *
      * @description
      * Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
      * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
      * by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
      *
      * Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
      * objects, performing a deep copy.
      *
      * @param {Object} dst Destination object.
      * @param {...Object} src Source object(s).
      * @returns {Object} Reference to `dst`.
      */
      function merge(dst) {
        return baseExtend(dst, slice.call(arguments, 1), true);
      }

      function toInt(str) {
        return parseInt(str, 10);
      }

      function inherit(parent, extra) {
        return extend(Object.create(parent), extra);
      }

      /**
       * @ngdoc function
       * @name angular.noop
       * @module ng
       * @kind function
       *
       * @description
       * A function that performs no operations. This function can be useful when writing code in the
       * functional style.
         ```js
           function foo(callback) {
             var result = calculateResult();
             (callback || angular.noop)(result);
           }
         ```
       */
      function noop() {}
      noop.$inject = [];

      /**
       * @ngdoc function
       * @name angular.identity
       * @module ng
       * @kind function
       *
       * @description
       * A function that returns its first argument. This function is useful when writing code in the
       * functional style.
       *
         ```js
         function transformer(transformationFn, value) {
           return (transformationFn || angular.identity)(value);
         };
      
         // E.g.
         function getResult(fn, input) {
           return (fn || angular.identity)(input);
         };
      
         getResult(function(n) { return n * 2; }, 21);   // returns 42
         getResult(null, 21);                            // returns 21
         getResult(undefined, 21);                       // returns 21
         ```
       *
       * @param {*} value to be returned.
       * @returns {*} the value passed in.
       */
      function identity($) {
        return $;
      }
      identity.$inject = [];

      function valueFn(value) {
        return function valueRef() {
          return value;
        };
      }

      function hasCustomToString(obj) {
        return isFunction(obj.toString) && obj.toString !== toString;
      }

      /**
       * @ngdoc function
       * @name angular.isUndefined
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is undefined.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is undefined.
       */
      function isUndefined(value) {
        return typeof value === 'undefined';
      }

      /**
       * @ngdoc function
       * @name angular.isDefined
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is defined.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is defined.
       */
      function isDefined(value) {
        return typeof value !== 'undefined';
      }

      /**
       * @ngdoc function
       * @name angular.isObject
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
       * considered to be objects. Note that JavaScript arrays are objects.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is an `Object` but not `null`.
       */
      function isObject(value) {
        // http://jsperf.com/isobject4
        return value !== null && typeof value === 'object';
      }

      /**
       * Determine if a value is an object with a null prototype
       *
       * @returns {boolean} True if `value` is an `Object` with a null prototype
       */
      function isBlankObject(value) {
        return value !== null && typeof value === 'object' && !getPrototypeOf(value);
      }

      /**
       * @ngdoc function
       * @name angular.isString
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is a `String`.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a `String`.
       */
      function isString(value) {
        return typeof value === 'string';
      }

      /**
       * @ngdoc function
       * @name angular.isNumber
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is a `Number`.
       *
       * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
       *
       * If you wish to exclude these then you can use the native
       * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
       * method.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a `Number`.
       */
      function isNumber(value) {
        return typeof value === 'number';
      }

      /**
       * @ngdoc function
       * @name angular.isDate
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a value is a date.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a `Date`.
       */
      function isDate(value) {
        return toString.call(value) === '[object Date]';
      }

      /**
       * @ngdoc function
       * @name angular.isArray
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is an `Array`.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is an `Array`.
       */
      var isArray = Array.isArray;

      /**
       * @ngdoc function
       * @name angular.isFunction
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is a `Function`.
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a `Function`.
       */
      function isFunction(value) {
        return typeof value === 'function';
      }

      /**
       * Determines if a value is a regular expression object.
       *
       * @private
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a `RegExp`.
       */
      function isRegExp(value) {
        return toString.call(value) === '[object RegExp]';
      }

      /**
       * Checks if `obj` is a window object.
       *
       * @private
       * @param {*} obj Object to check
       * @returns {boolean} True if `obj` is a window obj.
       */
      function isWindow(obj) {
        return obj && obj.window === obj;
      }

      function isScope(obj) {
        return obj && obj.$evalAsync && obj.$watch;
      }

      function isFile(obj) {
        return toString.call(obj) === '[object File]';
      }

      function isFormData(obj) {
        return toString.call(obj) === '[object FormData]';
      }

      function isBlob(obj) {
        return toString.call(obj) === '[object Blob]';
      }

      function isBoolean(value) {
        return typeof value === 'boolean';
      }

      function isPromiseLike(obj) {
        return obj && isFunction(obj.then);
      }

      var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
      function isTypedArray(value) {
        return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
      }

      function isArrayBuffer(obj) {
        return toString.call(obj) === '[object ArrayBuffer]';
      }

      var trim = function (value) {
        return isString(value) ? value.trim() : value;
      };

      // Copied from:
      // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
      // Prereq: s is a string.
      var escapeForRegexp = function (s) {
        return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').replace(/\x08/g, '\\x08');
      };

      /**
       * @ngdoc function
       * @name angular.isElement
       * @module ng
       * @kind function
       *
       * @description
       * Determines if a reference is a DOM element (or wrapped jQuery element).
       *
       * @param {*} value Reference to check.
       * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
       */
      function isElement(node) {
        return !!(node && (node.nodeName // We are a direct element.
        || node.prop && node.attr && node.find)); // We have an on and find method part of jQuery API.
      }

      /**
       * @param str 'key1,key2,...'
       * @returns {object} in the form of {key1:true, key2:true, ...}
       */
      function makeMap(str) {
        var obj = {},
            items = str.split(','),
            i;
        for (i = 0; i < items.length; i++) {
          obj[items[i]] = true;
        }
        return obj;
      }

      function nodeName_(element) {
        return lowercase(element.nodeName || element[0] && element[0].nodeName);
      }

      function includes(array, obj) {
        return Array.prototype.indexOf.call(array, obj) != -1;
      }

      function arrayRemove(array, value) {
        var index = array.indexOf(value);
        if (index >= 0) {
          array.splice(index, 1);
        }
        return index;
      }

      /**
       * @ngdoc function
       * @name angular.copy
       * @module ng
       * @kind function
       *
       * @description
       * Creates a deep copy of `source`, which should be an object or an array.
       *
       * * If no destination is supplied, a copy of the object or array is created.
       * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
       *   are deleted and then all elements/properties from the source are copied to it.
       * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
       * * If `source` is identical to `destination` an exception will be thrown.
       *
       * <br />
       * <div class="alert alert-warning">
       *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
       *   and on `destination`) will be ignored.
       * </div>
       *
       * @param {*} source The source that will be used to make a copy.
       *                   Can be any type, including primitives, `null`, and `undefined`.
       * @param {(Object|Array)=} destination Destination into which the source is copied. If
       *     provided, must be of the same type as `source`.
       * @returns {*} The copy or updated `destination`, if `destination` was specified.
       *
       * @example
        <example module="copyExample">
          <file name="index.html">
            <div ng-controller="ExampleController">
              <form novalidate class="simple-form">
                <label>Name: <input type="text" ng-model="user.name" /></label><br />
                <label>Age:  <input type="number" ng-model="user.age" /></label><br />
                Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                        <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
                <button ng-click="reset()">RESET</button>
                <button ng-click="update(user)">SAVE</button>
              </form>
              <pre>form = {{user | json}}</pre>
              <pre>master = {{master | json}}</pre>
            </div>
          </file>
          <file name="script.js">
            // Module: copyExample
            angular.
              module('copyExample', []).
              controller('ExampleController', ['$scope', function($scope) {
                $scope.master = {};
      
                $scope.reset = function() {
                  // Example with 1 argument
                  $scope.user = angular.copy($scope.master);
                };
      
                $scope.update = function(user) {
                  // Example with 2 arguments
                  angular.copy(user, $scope.master);
                };
      
                $scope.reset();
              }]);
          </file>
        </example>
       */
      function copy(source, destination) {
        var stackSource = [];
        var stackDest = [];

        if (destination) {
          if (isTypedArray(destination) || isArrayBuffer(destination)) {
            throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
          }
          if (source === destination) {
            throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
          }

          // Empty the destination object
          if (isArray(destination)) {
            destination.length = 0;
          } else {
            forEach(destination, function (value, key) {
              if (key !== '$$hashKey') {
                delete destination[key];
              }
            });
          }

          stackSource.push(source);
          stackDest.push(destination);
          return copyRecurse(source, destination);
        }

        return copyElement(source);

        function copyRecurse(source, destination) {
          var h = destination.$$hashKey;
          var key;
          if (isArray(source)) {
            for (var i = 0, ii = source.length; i < ii; i++) {
              destination.push(copyElement(source[i]));
            }
          } else if (isBlankObject(source)) {
            // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for (key in source) {
              destination[key] = copyElement(source[key]);
            }
          } else if (source && typeof source.hasOwnProperty === 'function') {
            // Slow path, which must rely on hasOwnProperty
            for (key in source) {
              if (source.hasOwnProperty(key)) {
                destination[key] = copyElement(source[key]);
              }
            }
          } else {
            // Slowest path --- hasOwnProperty can't be called as a method
            for (key in source) {
              if (hasOwnProperty.call(source, key)) {
                destination[key] = copyElement(source[key]);
              }
            }
          }
          setHashKey(destination, h);
          return destination;
        }

        function copyElement(source) {
          // Simple values
          if (!isObject(source)) {
            return source;
          }

          // Already copied values
          var index = stackSource.indexOf(source);
          if (index !== -1) {
            return stackDest[index];
          }

          if (isWindow(source) || isScope(source)) {
            throw ngMinErr('cpws', "Can't copy! Making copies of Window or Scope instances is not supported.");
          }

          var needsRecurse = false;
          var destination = copyType(source);

          if (destination === undefined) {
            destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
            needsRecurse = true;
          }

          stackSource.push(source);
          stackDest.push(destination);

          return needsRecurse ? copyRecurse(source, destination) : destination;
        }

        function copyType(source) {
          switch (toString.call(source)) {
            case '[object Int8Array]':
            case '[object Int16Array]':
            case '[object Int32Array]':
            case '[object Float32Array]':
            case '[object Float64Array]':
            case '[object Uint8Array]':
            case '[object Uint8ClampedArray]':
            case '[object Uint16Array]':
            case '[object Uint32Array]':
              return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

            case '[object ArrayBuffer]':
              //Support: IE10
              if (!source.slice) {
                var copied = new ArrayBuffer(source.byteLength);
                new Uint8Array(copied).set(new Uint8Array(source));
                return copied;
              }
              return source.slice(0);

            case '[object Boolean]':
            case '[object Number]':
            case '[object String]':
            case '[object Date]':
              return new source.constructor(source.valueOf());

            case '[object RegExp]':
              var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
              re.lastIndex = source.lastIndex;
              return re;

            case '[object Blob]':
              return new source.constructor([source], { type: source.type });
          }

          if (isFunction(source.cloneNode)) {
            return source.cloneNode(true);
          }
        }
      }

      /**
       * @ngdoc function
       * @name angular.equals
       * @module ng
       * @kind function
       *
       * @description
       * Determines if two objects or two values are equivalent. Supports value types, regular
       * expressions, arrays and objects.
       *
       * Two objects or values are considered equivalent if at least one of the following is true:
       *
       * * Both objects or values pass `===` comparison.
       * * Both objects or values are of the same type and all of their properties are equal by
       *   comparing them with `angular.equals`.
       * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
       * * Both values represent the same regular expression (In JavaScript,
       *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
       *   representation matches).
       *
       * During a property comparison, properties of `function` type and properties with names
       * that begin with `$` are ignored.
       *
       * Scope and DOMWindow objects are being compared only by identify (`===`).
       *
       * @param {*} o1 Object or value to compare.
       * @param {*} o2 Object or value to compare.
       * @returns {boolean} True if arguments are equal.
       *
       * @example
         <example module="equalsExample" name="equalsExample">
           <file name="index.html">
            <div ng-controller="ExampleController">
              <form novalidate>
                <h3>User 1</h3>
                Name: <input type="text" ng-model="user1.name">
                Age: <input type="number" ng-model="user1.age">
      
                <h3>User 2</h3>
                Name: <input type="text" ng-model="user2.name">
                Age: <input type="number" ng-model="user2.age">
      
                <div>
                  <br/>
                  <input type="button" value="Compare" ng-click="compare()">
                </div>
                User 1: <pre>{{user1 | json}}</pre>
                User 2: <pre>{{user2 | json}}</pre>
                Equal: <pre>{{result}}</pre>
              </form>
            </div>
          </file>
          <file name="script.js">
              angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
                $scope.user1 = {};
                $scope.user2 = {};
                $scope.result;
                $scope.compare = function() {
                  $scope.result = angular.equals($scope.user1, $scope.user2);
                };
              }]);
          </file>
        </example>
       */
      function equals(o1, o2) {
        if (o1 === o2) return true;
        if (o1 === null || o2 === null) return false;
        if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
        var t1 = typeof o1,
            t2 = typeof o2,
            length,
            key,
            keySet;
        if (t1 == t2 && t1 == 'object') {
          if (isArray(o1)) {
            if (!isArray(o2)) return false;
            if ((length = o1.length) == o2.length) {
              for (key = 0; key < length; key++) {
                if (!equals(o1[key], o2[key])) return false;
              }
              return true;
            }
          } else if (isDate(o1)) {
            if (!isDate(o2)) return false;
            return equals(o1.getTime(), o2.getTime());
          } else if (isRegExp(o1)) {
            if (!isRegExp(o2)) return false;
            return o1.toString() == o2.toString();
          } else {
            if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
            keySet = createMap();
            for (key in o1) {
              if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
              if (!equals(o1[key], o2[key])) return false;
              keySet[key] = true;
            }
            for (key in o2) {
              if (!(key in keySet) && key.charAt(0) !== '$' && isDefined(o2[key]) && !isFunction(o2[key])) return false;
            }
            return true;
          }
        }
        return false;
      }

      var csp = function () {
        if (!isDefined(csp.rules)) {

          var ngCspElement = window.document.querySelector('[ng-csp]') || window.document.querySelector('[data-ng-csp]');

          if (ngCspElement) {
            var ngCspAttribute = ngCspElement.getAttribute('ng-csp') || ngCspElement.getAttribute('data-ng-csp');
            csp.rules = {
              noUnsafeEval: !ngCspAttribute || ngCspAttribute.indexOf('no-unsafe-eval') !== -1,
              noInlineStyle: !ngCspAttribute || ngCspAttribute.indexOf('no-inline-style') !== -1
            };
          } else {
            csp.rules = {
              noUnsafeEval: noUnsafeEval(),
              noInlineStyle: false
            };
          }
        }

        return csp.rules;

        function noUnsafeEval() {
          try {
            /* jshint -W031, -W054 */
            new Function('');
            /* jshint +W031, +W054 */
            return false;
          } catch (e) {
            return true;
          }
        }
      };

      /**
       * @ngdoc directive
       * @module ng
       * @name ngJq
       *
       * @element ANY
       * @param {string=} ngJq the name of the library available under `window`
       * to be used for angular.element
       * @description
       * Use this directive to force the angular.element library.  This should be
       * used to force either jqLite by leaving ng-jq blank or setting the name of
       * the jquery variable under window (eg. jQuery).
       *
       * Since angular looks for this directive when it is loaded (doesn't wait for the
       * DOMContentLoaded event), it must be placed on an element that comes before the script
       * which loads angular. Also, only the first instance of `ng-jq` will be used and all
       * others ignored.
       *
       * @example
       * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
       ```html
       <!doctype html>
       <html ng-app ng-jq>
       ...
       ...
       </html>
       ```
       * @example
       * This example shows how to use a jQuery based library of a different name.
       * The library name must be available at the top most 'window'.
       ```html
       <!doctype html>
       <html ng-app ng-jq="jQueryLib">
       ...
       ...
       </html>
       ```
       */
      var jq = function () {
        if (isDefined(jq.name_)) return jq.name_;
        var el;
        var i,
            ii = ngAttrPrefixes.length,
            prefix,
            name;
        for (i = 0; i < ii; ++i) {
          prefix = ngAttrPrefixes[i];
          if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
            name = el.getAttribute(prefix + 'jq');
            break;
          }
        }

        return jq.name_ = name;
      };

      function concat(array1, array2, index) {
        return array1.concat(slice.call(array2, index));
      }

      function sliceArgs(args, startIndex) {
        return slice.call(args, startIndex || 0);
      }

      /* jshint -W101 */
      /**
       * @ngdoc function
       * @name angular.bind
       * @module ng
       * @kind function
       *
       * @description
       * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
       * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
       * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
       * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
       *
       * @param {Object} self Context which `fn` should be evaluated in.
       * @param {function()} fn Function to be bound.
       * @param {...*} args Optional arguments to be prebound to the `fn` function call.
       * @returns {function()} Function that wraps the `fn` with all the specified bindings.
       */
      /* jshint +W101 */
      function bind(self, fn) {
        var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
        if (isFunction(fn) && !(fn instanceof RegExp)) {
          return curryArgs.length ? function () {
            return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
          } : function () {
            return arguments.length ? fn.apply(self, arguments) : fn.call(self);
          };
        } else {
          // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
          return fn;
        }
      }

      function toJsonReplacer(key, value) {
        var val = value;

        if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
          val = undefined;
        } else if (isWindow(value)) {
          val = '$WINDOW';
        } else if (value && window.document === value) {
          val = '$DOCUMENT';
        } else if (isScope(value)) {
          val = '$SCOPE';
        }

        return val;
      }

      /**
       * @ngdoc function
       * @name angular.toJson
       * @module ng
       * @kind function
       *
       * @description
       * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
       * stripped since angular uses this notation internally.
       *
       * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
       * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
       *    If set to an integer, the JSON output will contain that many spaces per indentation.
       * @returns {string|undefined} JSON-ified string representing `obj`.
       * @knownIssue
       *
       * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
       * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
       * `Date.prototype.toJSON` method as follows:
       *
       * ```
       * var _DatetoJSON = Date.prototype.toJSON;
       * Date.prototype.toJSON = function() {
       *   try {
       *     return _DatetoJSON.call(this);
       *   } catch(e) {
       *     if (e instanceof RangeError) {
       *       return null;
       *     }
       *     throw e;
       *   }
       * };
       * ```
       *
       * See https://github.com/angular/angular.js/pull/14221 for more information.
       */
      function toJson(obj, pretty) {
        if (isUndefined(obj)) return undefined;
        if (!isNumber(pretty)) {
          pretty = pretty ? 2 : null;
        }
        return JSON.stringify(obj, toJsonReplacer, pretty);
      }

      /**
       * @ngdoc function
       * @name angular.fromJson
       * @module ng
       * @kind function
       *
       * @description
       * Deserializes a JSON string.
       *
       * @param {string} json JSON string to deserialize.
       * @returns {Object|Array|string|number} Deserialized JSON string.
       */
      function fromJson(json) {
        return isString(json) ? JSON.parse(json) : json;
      }

      var ALL_COLONS = /:/g;
      function timezoneToOffset(timezone, fallback) {
        // IE/Edge do not "understand" colon (`:`) in timezone
        timezone = timezone.replace(ALL_COLONS, '');
        var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
        return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
      }

      function addDateMinutes(date, minutes) {
        date = new Date(date.getTime());
        date.setMinutes(date.getMinutes() + minutes);
        return date;
      }

      function convertTimezoneToLocal(date, timezone, reverse) {
        reverse = reverse ? -1 : 1;
        var dateTimezoneOffset = date.getTimezoneOffset();
        var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
      }

      /**
       * @returns {string} Returns the string representation of the element.
       */
      function startingTag(element) {
        element = jqLite(element).clone();
        try {
          // turns out IE does not let you set .html() on elements which
          // are not allowed to have children. So we just ignore it.
          element.empty();
        } catch (e) {}
        var elemHtml = jqLite('<div>').append(element).html();
        try {
          return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/, function (match, nodeName) {
            return '<' + lowercase(nodeName);
          });
        } catch (e) {
          return lowercase(elemHtml);
        }
      }

      /////////////////////////////////////////////////

      /**
       * Tries to decode the URI component without throwing an exception.
       *
       * @private
       * @param str value potential URI component to check.
       * @returns {boolean} True if `value` can be decoded
       * with the decodeURIComponent function.
       */
      function tryDecodeURIComponent(value) {
        try {
          return decodeURIComponent(value);
        } catch (e) {
          // Ignore any invalid uri component.
        }
      }

      /**
       * Parses an escaped url query string into key-value pairs.
       * @returns {Object.<string,boolean|Array>}
       */
      function parseKeyValue( /**string*/keyValue) {
        var obj = {};
        forEach((keyValue || "").split('&'), function (keyValue) {
          var splitPoint, key, val;
          if (keyValue) {
            key = keyValue = keyValue.replace(/\+/g, '%20');
            splitPoint = keyValue.indexOf('=');
            if (splitPoint !== -1) {
              key = keyValue.substring(0, splitPoint);
              val = keyValue.substring(splitPoint + 1);
            }
            key = tryDecodeURIComponent(key);
            if (isDefined(key)) {
              val = isDefined(val) ? tryDecodeURIComponent(val) : true;
              if (!hasOwnProperty.call(obj, key)) {
                obj[key] = val;
              } else if (isArray(obj[key])) {
                obj[key].push(val);
              } else {
                obj[key] = [obj[key], val];
              }
            }
          }
        });
        return obj;
      }

      function toKeyValue(obj) {
        var parts = [];
        forEach(obj, function (value, key) {
          if (isArray(value)) {
            forEach(value, function (arrayValue) {
              parts.push(encodeUriQuery(key, true) + (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
            });
          } else {
            parts.push(encodeUriQuery(key, true) + (value === true ? '' : '=' + encodeUriQuery(value, true)));
          }
        });
        return parts.length ? parts.join('&') : '';
      }

      /**
       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
       * segments:
       *    segment       = *pchar
       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
       *    pct-encoded   = "%" HEXDIG HEXDIG
       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
       *                     / "*" / "+" / "," / ";" / "="
       */
      function encodeUriSegment(val) {
        return encodeUriQuery(val, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
      }

      /**
       * This method is intended for encoding *key* or *value* parts of query component. We need a custom
       * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
       * encoded per http://tools.ietf.org/html/rfc3986:
       *    query       = *( pchar / "/" / "?" )
       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
       *    pct-encoded   = "%" HEXDIG HEXDIG
       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
       *                     / "*" / "+" / "," / ";" / "="
       */
      function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
      }

      var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

      function getNgAttribute(element, ngAttr) {
        var attr,
            i,
            ii = ngAttrPrefixes.length;
        for (i = 0; i < ii; ++i) {
          attr = ngAttrPrefixes[i] + ngAttr;
          if (isString(attr = element.getAttribute(attr))) {
            return attr;
          }
        }
        return null;
      }

      /**
       * @ngdoc directive
       * @name ngApp
       * @module ng
       *
       * @element ANY
       * @param {angular.Module} ngApp an optional application
       *   {@link angular.module module} name to load.
       * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
       *   created in "strict-di" mode. This means that the application will fail to invoke functions which
       *   do not use explicit function annotation (and are thus unsuitable for minification), as described
       *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
       *   tracking down the root of these bugs.
       *
       * @description
       *
       * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
       * designates the **root element** of the application and is typically placed near the root element
       * of the page - e.g. on the `<body>` or `<html>` tags.
       *
       * There are a few things to keep in mind when using `ngApp`:
       * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
       *   found in the document will be used to define the root element to auto-bootstrap as an
       *   application. To run multiple applications in an HTML document you must manually bootstrap them using
       *   {@link angular.bootstrap} instead.
       * - AngularJS applications cannot be nested within each other.
       * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
       *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
       *   {@link ngRoute.ngView `ngView`}.
       *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
       *   causing animations to stop working and making the injector inaccessible from outside the app.
       *
       * You can specify an **AngularJS module** to be used as the root module for the application.  This
       * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
       * should contain the application code needed or have dependencies on other modules that will
       * contain the code. See {@link angular.module} for more information.
       *
       * In the example below if the `ngApp` directive were not placed on the `html` element then the
       * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
       * would not be resolved to `3`.
       *
       * `ngApp` is the easiest, and most common way to bootstrap an application.
       *
       <example module="ngAppDemo">
         <file name="index.html">
         <div ng-controller="ngAppDemoController">
           I can add: {{a}} + {{b}} =  {{ a+b }}
         </div>
         </file>
         <file name="script.js">
         angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
           $scope.a = 1;
           $scope.b = 2;
         });
         </file>
       </example>
       *
       * Using `ngStrictDi`, you would see something like this:
       *
       <example ng-app-included="true">
         <file name="index.html">
         <div ng-app="ngAppStrictDemo" ng-strict-di>
             <div ng-controller="GoodController1">
                 I can add: {{a}} + {{b}} =  {{ a+b }}
      
                 <p>This renders because the controller does not fail to
                    instantiate, by using explicit annotation style (see
                    script.js for details)
                 </p>
             </div>
      
             <div ng-controller="GoodController2">
                 Name: <input ng-model="name"><br />
                 Hello, {{name}}!
      
                 <p>This renders because the controller does not fail to
                    instantiate, by using explicit annotation style
                    (see script.js for details)
                 </p>
             </div>
      
             <div ng-controller="BadController">
                 I can add: {{a}} + {{b}} =  {{ a+b }}
      
                 <p>The controller could not be instantiated, due to relying
                    on automatic function annotations (which are disabled in
                    strict mode). As such, the content of this section is not
                    interpolated, and there should be an error in your web console.
                 </p>
             </div>
         </div>
         </file>
         <file name="script.js">
         angular.module('ngAppStrictDemo', [])
           // BadController will fail to instantiate, due to relying on automatic function annotation,
           // rather than an explicit annotation
           .controller('BadController', function($scope) {
             $scope.a = 1;
             $scope.b = 2;
           })
           // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
           // due to using explicit annotations using the array style and $inject property, respectively.
           .controller('GoodController1', ['$scope', function($scope) {
             $scope.a = 1;
             $scope.b = 2;
           }])
           .controller('GoodController2', GoodController2);
           function GoodController2($scope) {
             $scope.name = "World";
           }
           GoodController2.$inject = ['$scope'];
         </file>
         <file name="style.css">
         div[ng-controller] {
             margin-bottom: 1em;
             -webkit-border-radius: 4px;
             border-radius: 4px;
             border: 1px solid;
             padding: .5em;
         }
         div[ng-controller^=Good] {
             border-color: #d6e9c6;
             background-color: #dff0d8;
             color: #3c763d;
         }
         div[ng-controller^=Bad] {
             border-color: #ebccd1;
             background-color: #f2dede;
             color: #a94442;
             margin-bottom: 0;
         }
         </file>
       </example>
       */
      function angularInit(element, bootstrap) {
        var appElement,
            module,
            config = {};

        // The element `element` has priority over any other element.
        forEach(ngAttrPrefixes, function (prefix) {
          var name = prefix + 'app';

          if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
            appElement = element;
            module = element.getAttribute(name);
          }
        });
        forEach(ngAttrPrefixes, function (prefix) {
          var name = prefix + 'app';
          var candidate;

          if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
            appElement = candidate;
            module = candidate.getAttribute(name);
          }
        });
        if (appElement) {
          config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
          bootstrap(appElement, module ? [module] : [], config);
        }
      }

      /**
       * @ngdoc function
       * @name angular.bootstrap
       * @module ng
       * @description
       * Use this function to manually start up angular application.
       *
       * For more information, see the {@link guide/bootstrap Bootstrap guide}.
       *
       * Angular will detect if it has been loaded into the browser more than once and only allow the
       * first loaded script to be bootstrapped and will report a warning to the browser console for
       * each of the subsequent scripts. This prevents strange results in applications, where otherwise
       * multiple instances of Angular try to work on the DOM.
       *
       * <div class="alert alert-warning">
       * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
       * They must use {@link ng.directive:ngApp ngApp}.
       * </div>
       *
       * <div class="alert alert-warning">
       * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
       * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
       * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
       * causing animations to stop working and making the injector inaccessible from outside the app.
       * </div>
       *
       * ```html
       * <!doctype html>
       * <html>
       * <body>
       * <div ng-controller="WelcomeController">
       *   {{greeting}}
       * </div>
       *
       * <script src="angular.js"></script>
       * <script>
       *   var app = angular.module('demo', [])
       *   .controller('WelcomeController', function($scope) {
       *       $scope.greeting = 'Welcome!';
       *   });
       *   angular.bootstrap(document, ['demo']);
       * </script>
       * </body>
       * </html>
       * ```
       *
       * @param {DOMElement} element DOM element which is the root of angular application.
       * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
       *     Each item in the array should be the name of a predefined module or a (DI annotated)
       *     function that will be invoked by the injector as a `config` block.
       *     See: {@link angular.module modules}
       * @param {Object=} config an object for defining configuration options for the application. The
       *     following keys are supported:
       *
       * * `strictDi` - disable automatic function annotation for the application. This is meant to
       *   assist in finding bugs which break minified code. Defaults to `false`.
       *
       * @returns {auto.$injector} Returns the newly created injector for this app.
       */
      function bootstrap(element, modules, config) {
        if (!isObject(config)) config = {};
        var defaultConfig = {
          strictDi: false
        };
        config = extend(defaultConfig, config);
        var doBootstrap = function () {
          element = jqLite(element);

          if (element.injector()) {
            var tag = element[0] === window.document ? 'document' : startingTag(element);
            // Encode angle brackets to prevent input from being sanitized to empty string #8683.
            throw ngMinErr('btstrpd', "App already bootstrapped with this element '{0}'", tag.replace(/</, '&lt;').replace(/>/, '&gt;'));
          }

          modules = modules || [];
          modules.unshift(['$provide', function ($provide) {
            $provide.value('$rootElement', element);
          }]);

          if (config.debugInfoEnabled) {
            // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
            modules.push(['$compileProvider', function ($compileProvider) {
              $compileProvider.debugInfoEnabled(true);
            }]);
          }

          modules.unshift('ng');
          var injector = createInjector(modules, config.strictDi);
          injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector', function bootstrapApply(scope, element, compile, injector) {
            scope.$apply(function () {
              element.data('$injector', injector);
              compile(element)(scope);
            });
          }]);
          return injector;
        };

        var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
        var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

        if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
          config.debugInfoEnabled = true;
          window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
        }

        if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
          return doBootstrap();
        }

        window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
        angular.resumeBootstrap = function (extraModules) {
          forEach(extraModules, function (module) {
            modules.push(module);
          });
          return doBootstrap();
        };

        if (isFunction(angular.resumeDeferredBootstrap)) {
          angular.resumeDeferredBootstrap();
        }
      }

      /**
       * @ngdoc function
       * @name angular.reloadWithDebugInfo
       * @module ng
       * @description
       * Use this function to reload the current application with debug information turned on.
       * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
       *
       * See {@link ng.$compileProvider#debugInfoEnabled} for more.
       */
      function reloadWithDebugInfo() {
        window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
        window.location.reload();
      }

      /**
       * @name angular.getTestability
       * @module ng
       * @description
       * Get the testability service for the instance of Angular on the given
       * element.
       * @param {DOMElement} element DOM element which is the root of angular application.
       */
      function getTestability(rootElement) {
        var injector = angular.element(rootElement).injector();
        if (!injector) {
          throw ngMinErr('test', 'no injector found for element argument to getTestability');
        }
        return injector.get('$$testability');
      }

      var SNAKE_CASE_REGEXP = /[A-Z]/g;
      function snake_case(name, separator) {
        separator = separator || '_';
        return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      var bindJQueryFired = false;
      function bindJQuery() {
        var originalCleanData;

        if (bindJQueryFired) {
          return;
        }

        // bind to jQuery if present;
        var jqName = jq();
        jQuery = isUndefined(jqName) ? window.jQuery : // use jQuery (if present)
        !jqName ? undefined : // use jqLite
        window[jqName]; // use jQuery specified by `ngJq`

        // Use jQuery if it exists with proper functionality, otherwise default to us.
        // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
        // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
        // versions. It will not work for sure with jQuery <1.7, though.
        if (jQuery && jQuery.fn.on) {
          jqLite = jQuery;
          extend(jQuery.fn, {
            scope: JQLitePrototype.scope,
            isolateScope: JQLitePrototype.isolateScope,
            controller: JQLitePrototype.controller,
            injector: JQLitePrototype.injector,
            inheritedData: JQLitePrototype.inheritedData
          });

          // All nodes removed from the DOM via various jQuery APIs like .remove()
          // are passed through jQuery.cleanData. Monkey-patch this method to fire
          // the $destroy event on all removed nodes.
          originalCleanData = jQuery.cleanData;
          jQuery.cleanData = function (elems) {
            var events;
            for (var i = 0, elem; (elem = elems[i]) != null; i++) {
              events = jQuery._data(elem, "events");
              if (events && events.$destroy) {
                jQuery(elem).triggerHandler('$destroy');
              }
            }
            originalCleanData(elems);
          };
        } else {
          jqLite = JQLite;
        }

        angular.element = jqLite;

        // Prevent double-proxying.
        bindJQueryFired = true;
      }

      /**
       * throw error if the argument is falsy.
       */
      function assertArg(arg, name, reason) {
        if (!arg) {
          throw ngMinErr('areq', "Argument '{0}' is {1}", name || '?', reason || "required");
        }
        return arg;
      }

      function assertArgFn(arg, name, acceptArrayAnnotation) {
        if (acceptArrayAnnotation && isArray(arg)) {
          arg = arg[arg.length - 1];
        }

        assertArg(isFunction(arg), name, 'not a function, got ' + (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
        return arg;
      }

      /**
       * throw error if the name given is hasOwnProperty
       * @param  {String} name    the name to test
       * @param  {String} context the context in which the name is used, such as module or directive
       */
      function assertNotHasOwnProperty(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
        }
      }

      /**
       * Return the value accessible from the object by path. Any undefined traversals are ignored
       * @param {Object} obj starting object
       * @param {String} path path to traverse
       * @param {boolean} [bindFnToScope=true]
       * @returns {Object} value as accessible by path
       */
      //TODO(misko): this function needs to be removed
      function getter(obj, path, bindFnToScope) {
        if (!path) return obj;
        var keys = path.split('.');
        var key;
        var lastInstance = obj;
        var len = keys.length;

        for (var i = 0; i < len; i++) {
          key = keys[i];
          if (obj) {
            obj = (lastInstance = obj)[key];
          }
        }
        if (!bindFnToScope && isFunction(obj)) {
          return bind(lastInstance, obj);
        }
        return obj;
      }

      /**
       * Return the DOM siblings between the first and last node in the given array.
       * @param {Array} array like object
       * @returns {Array} the inputted object or a jqLite collection containing the nodes
       */
      function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;

        for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
          if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) {
              blockNodes = jqLite(slice.call(nodes, 0, i));
            }
            blockNodes.push(node);
          }
        }

        return blockNodes || nodes;
      }

      /**
       * Creates a new object without a prototype. This object is useful for lookup without having to
       * guard against prototypically inherited properties via hasOwnProperty.
       *
       * Related micro-benchmarks:
       * - http://jsperf.com/object-create2
       * - http://jsperf.com/proto-map-lookup/2
       * - http://jsperf.com/for-in-vs-object-keys2
       *
       * @returns {Object}
       */
      function createMap() {
        return Object.create(null);
      }

      var NODE_TYPE_ELEMENT = 1;
      var NODE_TYPE_ATTRIBUTE = 2;
      var NODE_TYPE_TEXT = 3;
      var NODE_TYPE_COMMENT = 8;
      var NODE_TYPE_DOCUMENT = 9;
      var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

      /**
       * @ngdoc type
       * @name angular.Module
       * @module ng
       * @description
       *
       * Interface for configuring angular {@link angular.module modules}.
       */

      function setupModuleLoader(window) {

        var $injectorMinErr = minErr('$injector');
        var ngMinErr = minErr('ng');

        function ensure(obj, name, factory) {
          return obj[name] || (obj[name] = factory());
        }

        var angular = ensure(window, 'angular', Object);

        // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
        angular.$$minErr = angular.$$minErr || minErr;

        return ensure(angular, 'module', function () {
          /** @type {Object.<string, angular.Module>} */
          var modules = {};

          /**
           * @ngdoc function
           * @name angular.module
           * @module ng
           * @description
           *
           * The `angular.module` is a global place for creating, registering and retrieving Angular
           * modules.
           * All modules (angular core or 3rd party) that should be available to an application must be
           * registered using this mechanism.
           *
           * Passing one argument retrieves an existing {@link angular.Module},
           * whereas passing more than one argument creates a new {@link angular.Module}
           *
           *
           * # Module
           *
           * A module is a collection of services, directives, controllers, filters, and configuration information.
           * `angular.module` is used to configure the {@link auto.$injector $injector}.
           *
           * ```js
           * // Create a new module
           * var myModule = angular.module('myModule', []);
           *
           * // register a new service
           * myModule.value('appName', 'MyCoolApp');
           *
           * // configure existing services inside initialization blocks.
           * myModule.config(['$locationProvider', function($locationProvider) {
           *   // Configure existing providers
           *   $locationProvider.hashPrefix('!');
           * }]);
           * ```
           *
           * Then you can create an injector and load your modules like this:
           *
           * ```js
           * var injector = angular.injector(['ng', 'myModule'])
           * ```
           *
           * However it's more likely that you'll just use
           * {@link ng.directive:ngApp ngApp} or
           * {@link angular.bootstrap} to simplify this process for you.
           *
           * @param {!string} name The name of the module to create or retrieve.
           * @param {!Array.<string>=} requires If specified then new module is being created. If
           *        unspecified then the module is being retrieved for further configuration.
           * @param {Function=} configFn Optional configuration function for the module. Same as
           *        {@link angular.Module#config Module#config()}.
           * @returns {angular.Module} new module with the {@link angular.Module} api.
           */
          return function module(name, requires, configFn) {
            var assertNotHasOwnProperty = function (name, context) {
              if (name === 'hasOwnProperty') {
                throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
              }
            };

            assertNotHasOwnProperty(name, 'module');
            if (requires && modules.hasOwnProperty(name)) {
              modules[name] = null;
            }
            return ensure(modules, name, function () {
              if (!requires) {
                throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " + "the module name or forgot to load it. If registering a module ensure that you " + "specify the dependencies as the second argument.", name);
              }

              /** @type {!Array.<Array.<*>>} */
              var invokeQueue = [];

              /** @type {!Array.<Function>} */
              var configBlocks = [];

              /** @type {!Array.<Function>} */
              var runBlocks = [];

              var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

              /** @type {angular.Module} */
              var moduleInstance = {
                // Private state
                _invokeQueue: invokeQueue,
                _configBlocks: configBlocks,
                _runBlocks: runBlocks,

                /**
                 * @ngdoc property
                 * @name angular.Module#requires
                 * @module ng
                 *
                 * @description
                 * Holds the list of modules which the injector will load before the current module is
                 * loaded.
                 */
                requires: requires,

                /**
                 * @ngdoc property
                 * @name angular.Module#name
                 * @module ng
                 *
                 * @description
                 * Name of the module.
                 */
                name: name,

                /**
                 * @ngdoc method
                 * @name angular.Module#provider
                 * @module ng
                 * @param {string} name service name
                 * @param {Function} providerType Construction function for creating new instance of the
                 *                                service.
                 * @description
                 * See {@link auto.$provide#provider $provide.provider()}.
                 */
                provider: invokeLaterAndSetModuleName('$provide', 'provider'),

                /**
                 * @ngdoc method
                 * @name angular.Module#factory
                 * @module ng
                 * @param {string} name service name
                 * @param {Function} providerFunction Function for creating new instance of the service.
                 * @description
                 * See {@link auto.$provide#factory $provide.factory()}.
                 */
                factory: invokeLaterAndSetModuleName('$provide', 'factory'),

                /**
                 * @ngdoc method
                 * @name angular.Module#service
                 * @module ng
                 * @param {string} name service name
                 * @param {Function} constructor A constructor function that will be instantiated.
                 * @description
                 * See {@link auto.$provide#service $provide.service()}.
                 */
                service: invokeLaterAndSetModuleName('$provide', 'service'),

                /**
                 * @ngdoc method
                 * @name angular.Module#value
                 * @module ng
                 * @param {string} name service name
                 * @param {*} object Service instance object.
                 * @description
                 * See {@link auto.$provide#value $provide.value()}.
                 */
                value: invokeLater('$provide', 'value'),

                /**
                 * @ngdoc method
                 * @name angular.Module#constant
                 * @module ng
                 * @param {string} name constant name
                 * @param {*} object Constant value.
                 * @description
                 * Because the constants are fixed, they get applied before other provide methods.
                 * See {@link auto.$provide#constant $provide.constant()}.
                 */
                constant: invokeLater('$provide', 'constant', 'unshift'),

                /**
                * @ngdoc method
                * @name angular.Module#decorator
                * @module ng
                * @param {string} name The name of the service to decorate.
                * @param {Function} decorFn This function will be invoked when the service needs to be
                *                           instantiated and should return the decorated service instance.
                * @description
                * See {@link auto.$provide#decorator $provide.decorator()}.
                */
                decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),

                /**
                 * @ngdoc method
                 * @name angular.Module#animation
                 * @module ng
                 * @param {string} name animation name
                 * @param {Function} animationFactory Factory function for creating new instance of an
                 *                                    animation.
                 * @description
                 *
                 * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
                 *
                 *
                 * Defines an animation hook that can be later used with
                 * {@link $animate $animate} service and directives that use this service.
                 *
                 * ```js
                 * module.animation('.animation-name', function($inject1, $inject2) {
                 *   return {
                 *     eventName : function(element, done) {
                 *       //code to run the animation
                 *       //once complete, then run done()
                 *       return function cancellationFunction(element) {
                 *         //code to cancel the animation
                 *       }
                 *     }
                 *   }
                 * })
                 * ```
                 *
                 * See {@link ng.$animateProvider#register $animateProvider.register()} and
                 * {@link ngAnimate ngAnimate module} for more information.
                 */
                animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

                /**
                 * @ngdoc method
                 * @name angular.Module#filter
                 * @module ng
                 * @param {string} name Filter name - this must be a valid angular expression identifier
                 * @param {Function} filterFactory Factory function for creating new instance of filter.
                 * @description
                 * See {@link ng.$filterProvider#register $filterProvider.register()}.
                 *
                 * <div class="alert alert-warning">
                 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
                 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
                 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
                 * (`myapp_subsection_filterx`).
                 * </div>
                 */
                filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

                /**
                 * @ngdoc method
                 * @name angular.Module#controller
                 * @module ng
                 * @param {string|Object} name Controller name, or an object map of controllers where the
                 *    keys are the names and the values are the constructors.
                 * @param {Function} constructor Controller constructor function.
                 * @description
                 * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
                 */
                controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

                /**
                 * @ngdoc method
                 * @name angular.Module#directive
                 * @module ng
                 * @param {string|Object} name Directive name, or an object map of directives where the
                 *    keys are the names and the values are the factories.
                 * @param {Function} directiveFactory Factory function for creating new instance of
                 * directives.
                 * @description
                 * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
                 */
                directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

                /**
                 * @ngdoc method
                 * @name angular.Module#component
                 * @module ng
                 * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
                 * @param {Object} options Component definition object (a simplified
                 *    {@link ng.$compile#directive-definition-object directive definition object})
                 *
                 * @description
                 * See {@link ng.$compileProvider#component $compileProvider.component()}.
                 */
                component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

                /**
                 * @ngdoc method
                 * @name angular.Module#config
                 * @module ng
                 * @param {Function} configFn Execute this function on module load. Useful for service
                 *    configuration.
                 * @description
                 * Use this method to register work which needs to be performed on module loading.
                 * For more about how to configure services, see
                 * {@link providers#provider-recipe Provider Recipe}.
                 */
                config: config,

                /**
                 * @ngdoc method
                 * @name angular.Module#run
                 * @module ng
                 * @param {Function} initializationFn Execute this function after injector creation.
                 *    Useful for application initialization.
                 * @description
                 * Use this method to register work which should be performed when the injector is done
                 * loading all modules.
                 */
                run: function (block) {
                  runBlocks.push(block);
                  return this;
                }
              };

              if (configFn) {
                config(configFn);
              }

              return moduleInstance;

              /**
               * @param {string} provider
               * @param {string} method
               * @param {String=} insertMethod
               * @returns {angular.Module}
               */
              function invokeLater(provider, method, insertMethod, queue) {
                if (!queue) queue = invokeQueue;
                return function () {
                  queue[insertMethod || 'push']([provider, method, arguments]);
                  return moduleInstance;
                };
              }

              /**
               * @param {string} provider
               * @param {string} method
               * @returns {angular.Module}
               */
              function invokeLaterAndSetModuleName(provider, method) {
                return function (recipeName, factoryFunction) {
                  if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
                  invokeQueue.push([provider, method, arguments]);
                  return moduleInstance;
                };
              }
            });
          };
        });
      }

      /* global shallowCopy: true */

      /**
       * Creates a shallow copy of an object, an array or a primitive.
       *
       * Assumes that there are no proto properties for objects.
       */
      function shallowCopy(src, dst) {
        if (isArray(src)) {
          dst = dst || [];

          for (var i = 0, ii = src.length; i < ii; i++) {
            dst[i] = src[i];
          }
        } else if (isObject(src)) {
          dst = dst || {};

          for (var key in src) {
            if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
              dst[key] = src[key];
            }
          }
        }

        return dst || src;
      }

      /* global toDebugString: true */

      function serializeObject(obj) {
        var seen = [];

        return JSON.stringify(obj, function (key, val) {
          val = toJsonReplacer(key, val);
          if (isObject(val)) {

            if (seen.indexOf(val) >= 0) return '...';

            seen.push(val);
          }
          return val;
        });
      }

      function toDebugString(obj) {
        if (typeof obj === 'function') {
          return obj.toString().replace(/ \{[\s\S]*$/, '');
        } else if (isUndefined(obj)) {
          return 'undefined';
        } else if (typeof obj !== 'string') {
          return serializeObject(obj);
        }
        return obj;
      }

      /* global angularModule: true,
        version: true,
      
        $CompileProvider,
      
        htmlAnchorDirective,
        inputDirective,
        inputDirective,
        formDirective,
        scriptDirective,
        selectDirective,
        styleDirective,
        optionDirective,
        ngBindDirective,
        ngBindHtmlDirective,
        ngBindTemplateDirective,
        ngClassDirective,
        ngClassEvenDirective,
        ngClassOddDirective,
        ngCloakDirective,
        ngControllerDirective,
        ngFormDirective,
        ngHideDirective,
        ngIfDirective,
        ngIncludeDirective,
        ngIncludeFillContentDirective,
        ngInitDirective,
        ngNonBindableDirective,
        ngPluralizeDirective,
        ngRepeatDirective,
        ngShowDirective,
        ngStyleDirective,
        ngSwitchDirective,
        ngSwitchWhenDirective,
        ngSwitchDefaultDirective,
        ngOptionsDirective,
        ngTranscludeDirective,
        ngModelDirective,
        ngListDirective,
        ngChangeDirective,
        patternDirective,
        patternDirective,
        requiredDirective,
        requiredDirective,
        minlengthDirective,
        minlengthDirective,
        maxlengthDirective,
        maxlengthDirective,
        ngValueDirective,
        ngModelOptionsDirective,
        ngAttributeAliasDirectives,
        ngEventDirectives,
      
        $AnchorScrollProvider,
        $AnimateProvider,
        $CoreAnimateCssProvider,
        $$CoreAnimateJsProvider,
        $$CoreAnimateQueueProvider,
        $$AnimateRunnerFactoryProvider,
        $$AnimateAsyncRunFactoryProvider,
        $BrowserProvider,
        $CacheFactoryProvider,
        $ControllerProvider,
        $DateProvider,
        $DocumentProvider,
        $ExceptionHandlerProvider,
        $FilterProvider,
        $$ForceReflowProvider,
        $InterpolateProvider,
        $IntervalProvider,
        $$HashMapProvider,
        $HttpProvider,
        $HttpParamSerializerProvider,
        $HttpParamSerializerJQLikeProvider,
        $HttpBackendProvider,
        $xhrFactoryProvider,
        $jsonpCallbacksProvider,
        $LocationProvider,
        $LogProvider,
        $ParseProvider,
        $RootScopeProvider,
        $QProvider,
        $$QProvider,
        $$SanitizeUriProvider,
        $SceProvider,
        $SceDelegateProvider,
        $SnifferProvider,
        $TemplateCacheProvider,
        $TemplateRequestProvider,
        $$TestabilityProvider,
        $TimeoutProvider,
        $$RAFProvider,
        $WindowProvider,
        $$jqLiteProvider,
        $$CookieReaderProvider
      */

      /**
       * @ngdoc object
       * @name angular.version
       * @module ng
       * @description
       * An object that contains information about the current AngularJS version.
       *
       * This object has the following properties:
       *
       * - `full` – `{string}` – Full version string, such as "0.9.18".
       * - `major` – `{number}` – Major version number, such as "0".
       * - `minor` – `{number}` – Minor version number, such as "9".
       * - `dot` – `{number}` – Dot version number, such as "18".
       * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
       */
      var version = {
        full: '1.5.8', // all of these placeholder strings will be replaced by grunt's
        major: 1, // package task
        minor: 5,
        dot: 8,
        codeName: 'arbitrary-fallbacks'
      };

      function publishExternalAPI(angular) {
        extend(angular, {
          'bootstrap': bootstrap,
          'copy': copy,
          'extend': extend,
          'merge': merge,
          'equals': equals,
          'element': jqLite,
          'forEach': forEach,
          'injector': createInjector,
          'noop': noop,
          'bind': bind,
          'toJson': toJson,
          'fromJson': fromJson,
          'identity': identity,
          'isUndefined': isUndefined,
          'isDefined': isDefined,
          'isString': isString,
          'isFunction': isFunction,
          'isObject': isObject,
          'isNumber': isNumber,
          'isElement': isElement,
          'isArray': isArray,
          'version': version,
          'isDate': isDate,
          'lowercase': lowercase,
          'uppercase': uppercase,
          'callbacks': { $$counter: 0 },
          'getTestability': getTestability,
          '$$minErr': minErr,
          '$$csp': csp,
          'reloadWithDebugInfo': reloadWithDebugInfo
        });

        angularModule = setupModuleLoader(window);

        angularModule('ng', ['ngLocale'], ['$provide', function ngModule($provide) {
          // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
          $provide.provider({
            $$sanitizeUri: $$SanitizeUriProvider
          });
          $provide.provider('$compile', $CompileProvider).directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            style: styleDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
          }).directive({
            ngInclude: ngIncludeFillContentDirective
          }).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
          $provide.provider({
            $anchorScroll: $AnchorScrollProvider,
            $animate: $AnimateProvider,
            $animateCss: $CoreAnimateCssProvider,
            $$animateJs: $$CoreAnimateJsProvider,
            $$animateQueue: $$CoreAnimateQueueProvider,
            $$AnimateRunner: $$AnimateRunnerFactoryProvider,
            $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
            $browser: $BrowserProvider,
            $cacheFactory: $CacheFactoryProvider,
            $controller: $ControllerProvider,
            $document: $DocumentProvider,
            $exceptionHandler: $ExceptionHandlerProvider,
            $filter: $FilterProvider,
            $$forceReflow: $$ForceReflowProvider,
            $interpolate: $InterpolateProvider,
            $interval: $IntervalProvider,
            $http: $HttpProvider,
            $httpParamSerializer: $HttpParamSerializerProvider,
            $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
            $httpBackend: $HttpBackendProvider,
            $xhrFactory: $xhrFactoryProvider,
            $jsonpCallbacks: $jsonpCallbacksProvider,
            $location: $LocationProvider,
            $log: $LogProvider,
            $parse: $ParseProvider,
            $rootScope: $RootScopeProvider,
            $q: $QProvider,
            $$q: $$QProvider,
            $sce: $SceProvider,
            $sceDelegate: $SceDelegateProvider,
            $sniffer: $SnifferProvider,
            $templateCache: $TemplateCacheProvider,
            $templateRequest: $TemplateRequestProvider,
            $$testability: $$TestabilityProvider,
            $timeout: $TimeoutProvider,
            $window: $WindowProvider,
            $$rAF: $$RAFProvider,
            $$jqLite: $$jqLiteProvider,
            $$HashMap: $$HashMapProvider,
            $$cookieReader: $$CookieReaderProvider
          });
        }]);
      }

      /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
       *     Any commits to this file should be reviewed with security in mind.  *
       *   Changes to this file can potentially create security vulnerabilities. *
       *          An approval from 2 Core members with history of modifying      *
       *                         this file is required.                          *
       *                                                                         *
       *  Does the change somehow allow for arbitrary javascript to be executed? *
       *    Or allows for someone to change the prototype of built-in objects?   *
       *     Or gives undesired access to variables likes document or window?    *
       * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

      /* global JQLitePrototype: true,
        addEventListenerFn: true,
        removeEventListenerFn: true,
        BOOLEAN_ATTR: true,
        ALIASED_ATTR: true,
      */

      //////////////////////////////////
      //JQLite
      //////////////////////////////////

      /**
       * @ngdoc function
       * @name angular.element
       * @module ng
       * @kind function
       *
       * @description
       * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
       *
       * If jQuery is available, `angular.element` is an alias for the
       * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
       * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
       *
       * jqLite is a tiny, API-compatible subset of jQuery that allows
       * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
       * commonly needed functionality with the goal of having a very small footprint.
       *
       * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
       * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
       * specific version of jQuery if multiple versions exist on the page.
       *
       * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
       * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
       *
       * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
       * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
       * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
       *
       * ## Angular's jqLite
       * jqLite provides only the following jQuery methods:
       *
       * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
       * - [`after()`](http://api.jquery.com/after/)
       * - [`append()`](http://api.jquery.com/append/)
       * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
       * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
       * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
       * - [`clone()`](http://api.jquery.com/clone/)
       * - [`contents()`](http://api.jquery.com/contents/)
       * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
       *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
       * - [`data()`](http://api.jquery.com/data/)
       * - [`detach()`](http://api.jquery.com/detach/)
       * - [`empty()`](http://api.jquery.com/empty/)
       * - [`eq()`](http://api.jquery.com/eq/)
       * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
       * - [`hasClass()`](http://api.jquery.com/hasClass/)
       * - [`html()`](http://api.jquery.com/html/)
       * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
       * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
       * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
       * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
       * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
       * - [`prepend()`](http://api.jquery.com/prepend/)
       * - [`prop()`](http://api.jquery.com/prop/)
       * - [`ready()`](http://api.jquery.com/ready/)
       * - [`remove()`](http://api.jquery.com/remove/)
       * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
       * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
       * - [`removeData()`](http://api.jquery.com/removeData/)
       * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
       * - [`text()`](http://api.jquery.com/text/)
       * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
       * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
       * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
       * - [`val()`](http://api.jquery.com/val/)
       * - [`wrap()`](http://api.jquery.com/wrap/)
       *
       * ## jQuery/jqLite Extras
       * Angular also provides the following additional methods and events to both jQuery and jqLite:
       *
       * ### Events
       * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
       *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
       *    element before it is removed.
       *
       * ### Methods
       * - `controller(name)` - retrieves the controller of the current element or its parent. By default
       *   retrieves controller associated with the `ngController` directive. If `name` is provided as
       *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
       *   `'ngModel'`).
       * - `injector()` - retrieves the injector of the current element or its parent.
       * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
       *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
       *   be enabled.
       * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
       *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
       *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
       *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
       * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
       *   parent element is reached.
       *
       * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
       * https://github.com/angular/angular.js/issues/14251 for more information.
       *
       * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
       * @returns {Object} jQuery object.
       */

      JQLite.expando = 'ng339';

      var jqCache = JQLite.cache = {},
          jqId = 1,
          addEventListenerFn = function (element, type, fn) {
        element.addEventListener(type, fn, false);
      },
          removeEventListenerFn = function (element, type, fn) {
        element.removeEventListener(type, fn, false);
      };

      /*
       * !!! This is an undocumented "private" function !!!
       */
      JQLite._data = function (node) {
        //jQuery always returns an object on cache miss
        return this.cache[node[this.expando]] || {};
      };

      function jqNextId() {
        return ++jqId;
      }

      var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
      var MOZ_HACK_REGEXP = /^moz([A-Z])/;
      var MOUSE_EVENT_MAP = { mouseleave: "mouseout", mouseenter: "mouseover" };
      var jqLiteMinErr = minErr('jqLite');

      /**
       * Converts snake_case to camelCase.
       * Also there is special case for Moz prefix starting with upper case letter.
       * @param name Name to normalize
       */
      function camelCase(name) {
        return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        }).replace(MOZ_HACK_REGEXP, 'Moz$1');
      }

      var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
      var HTML_REGEXP = /<|&#?\w+;/;
      var TAG_NAME_REGEXP = /<([\w:-]+)/;
      var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

      var wrapMap = {
        'option': [1, '<select multiple="multiple">', '</select>'],

        'thead': [1, '<table>', '</table>'],
        'col': [2, '<table><colgroup>', '</colgroup></table>'],
        'tr': [2, '<table><tbody>', '</tbody></table>'],
        'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        '_default': [0, "", ""]
      };

      wrapMap.optgroup = wrapMap.option;
      wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
      wrapMap.th = wrapMap.td;

      function jqLiteIsTextNode(html) {
        return !HTML_REGEXP.test(html);
      }

      function jqLiteAcceptsData(node) {
        // The window object can accept data but has no nodeType
        // Otherwise we are only interested in elements (1) and documents (9)
        var nodeType = node.nodeType;
        return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
      }

      function jqLiteHasData(node) {
        for (var key in jqCache[node.ng339]) {
          return true;
        }
        return false;
      }

      function jqLiteCleanData(nodes) {
        for (var i = 0, ii = nodes.length; i < ii; i++) {
          jqLiteRemoveData(nodes[i]);
        }
      }

      function jqLiteBuildFragment(html, context) {
        var tmp,
            tag,
            wrap,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i;

        if (jqLiteIsTextNode(html)) {
          // Convert non-html into a text node
          nodes.push(context.createTextNode(html));
        } else {
          // Convert html into DOM nodes
          tmp = fragment.appendChild(context.createElement("div"));
          tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];

          // Descend through wrappers to the right content
          i = wrap[0];
          while (i--) {
            tmp = tmp.lastChild;
          }

          nodes = concat(nodes, tmp.childNodes);

          tmp = fragment.firstChild;
          tmp.textContent = "";
        }

        // Remove wrapper from fragment
        fragment.textContent = "";
        fragment.innerHTML = ""; // Clear inner HTML
        forEach(nodes, function (node) {
          fragment.appendChild(node);
        });

        return fragment;
      }

      function jqLiteParseHTML(html, context) {
        context = context || window.document;
        var parsed;

        if (parsed = SINGLE_TAG_REGEXP.exec(html)) {
          return [context.createElement(parsed[1])];
        }

        if (parsed = jqLiteBuildFragment(html, context)) {
          return parsed.childNodes;
        }

        return [];
      }

      function jqLiteWrapNode(node, wrapper) {
        var parent = node.parentNode;

        if (parent) {
          parent.replaceChild(wrapper, node);
        }

        wrapper.appendChild(node);
      }

      // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
      var jqLiteContains = window.Node.prototype.contains || function (arg) {
        // jshint bitwise: false
        return !!(this.compareDocumentPosition(arg) & 16);
        // jshint bitwise: true
      };

      /////////////////////////////////////////////
      function JQLite(element) {
        if (element instanceof JQLite) {
          return element;
        }

        var argIsString;

        if (isString(element)) {
          element = trim(element);
          argIsString = true;
        }
        if (!(this instanceof JQLite)) {
          if (argIsString && element.charAt(0) != '<') {
            throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
          }
          return new JQLite(element);
        }

        if (argIsString) {
          jqLiteAddNodes(this, jqLiteParseHTML(element));
        } else {
          jqLiteAddNodes(this, element);
        }
      }

      function jqLiteClone(element) {
        return element.cloneNode(true);
      }

      function jqLiteDealoc(element, onlyDescendants) {
        if (!onlyDescendants) jqLiteRemoveData(element);

        if (element.querySelectorAll) {
          var descendants = element.querySelectorAll('*');
          for (var i = 0, l = descendants.length; i < l; i++) {
            jqLiteRemoveData(descendants[i]);
          }
        }
      }

      function jqLiteOff(element, type, fn, unsupported) {
        if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

        var expandoStore = jqLiteExpandoStore(element);
        var events = expandoStore && expandoStore.events;
        var handle = expandoStore && expandoStore.handle;

        if (!handle) return; //no listeners registered

        if (!type) {
          for (type in events) {
            if (type !== '$destroy') {
              removeEventListenerFn(element, type, handle);
            }
            delete events[type];
          }
        } else {

          var removeHandler = function (type) {
            var listenerFns = events[type];
            if (isDefined(fn)) {
              arrayRemove(listenerFns || [], fn);
            }
            if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
              removeEventListenerFn(element, type, handle);
              delete events[type];
            }
          };

          forEach(type.split(' '), function (type) {
            removeHandler(type);
            if (MOUSE_EVENT_MAP[type]) {
              removeHandler(MOUSE_EVENT_MAP[type]);
            }
          });
        }
      }

      function jqLiteRemoveData(element, name) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];

        if (expandoStore) {
          if (name) {
            delete expandoStore.data[name];
            return;
          }

          if (expandoStore.handle) {
            if (expandoStore.events.$destroy) {
              expandoStore.handle({}, '$destroy');
            }
            jqLiteOff(element);
          }
          delete jqCache[expandoId];
          element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
        }
      }

      function jqLiteExpandoStore(element, createIfNecessary) {
        var expandoId = element.ng339,
            expandoStore = expandoId && jqCache[expandoId];

        if (createIfNecessary && !expandoStore) {
          element.ng339 = expandoId = jqNextId();
          expandoStore = jqCache[expandoId] = { events: {}, data: {}, handle: undefined };
        }

        return expandoStore;
      }

      function jqLiteData(element, key, value) {
        if (jqLiteAcceptsData(element)) {

          var isSimpleSetter = isDefined(value);
          var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
          var massGetter = !key;
          var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
          var data = expandoStore && expandoStore.data;

          if (isSimpleSetter) {
            // data('key', value)
            data[key] = value;
          } else {
            if (massGetter) {
              // data()
              return data;
            } else {
              if (isSimpleGetter) {
                // data('key')
                // don't force creation of expandoStore if it doesn't exist yet
                return data && data[key];
              } else {
                // mass-setter: data({key1: val1, key2: val2})
                extend(data, key);
              }
            }
          }
        }
      }

      function jqLiteHasClass(element, selector) {
        if (!element.getAttribute) return false;
        return (" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").indexOf(" " + selector + " ") > -1;
      }

      function jqLiteRemoveClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
          forEach(cssClasses.split(' '), function (cssClass) {
            element.setAttribute('class', trim((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").replace(" " + trim(cssClass) + " ", " ")));
          });
        }
      }

      function jqLiteAddClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
          var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, " ");

          forEach(cssClasses.split(' '), function (cssClass) {
            cssClass = trim(cssClass);
            if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
              existingClasses += cssClass + ' ';
            }
          });

          element.setAttribute('class', trim(existingClasses));
        }
      }

      function jqLiteAddNodes(root, elements) {
        // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

        if (elements) {

          // if a Node (the most common case)
          if (elements.nodeType) {
            root[root.length++] = elements;
          } else {
            var length = elements.length;

            // if an Array or NodeList and not a Window
            if (typeof length === 'number' && elements.window !== elements) {
              if (length) {
                for (var i = 0; i < length; i++) {
                  root[root.length++] = elements[i];
                }
              }
            } else {
              root[root.length++] = elements;
            }
          }
        }
      }

      function jqLiteController(element, name) {
        return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
      }

      function jqLiteInheritedData(element, name, value) {
        // if element is the document object work with the html element instead
        // this makes $(document).scope() possible
        if (element.nodeType == NODE_TYPE_DOCUMENT) {
          element = element.documentElement;
        }
        var names = isArray(name) ? name : [name];

        while (element) {
          for (var i = 0, ii = names.length; i < ii; i++) {
            if (isDefined(value = jqLite.data(element, names[i]))) return value;
          }

          // If dealing with a document fragment node with a host element, and no parent, use the host
          // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
          // to lookup parent controllers.
          element = element.parentNode || element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host;
        }
      }

      function jqLiteEmpty(element) {
        jqLiteDealoc(element, true);
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
      }

      function jqLiteRemove(element, keepData) {
        if (!keepData) jqLiteDealoc(element);
        var parent = element.parentNode;
        if (parent) parent.removeChild(element);
      }

      function jqLiteDocumentLoaded(action, win) {
        win = win || window;
        if (win.document.readyState === 'complete') {
          // Force the action to be run async for consistent behavior
          // from the action's point of view
          // i.e. it will definitely not be in a $apply
          win.setTimeout(action);
        } else {
          // No need to unbind this handler as load is only ever called once
          jqLite(win).on('load', action);
        }
      }

      //////////////////////////////////////////
      // Functions which are declared directly.
      //////////////////////////////////////////
      var JQLitePrototype = JQLite.prototype = {
        ready: function (fn) {
          var fired = false;

          function trigger() {
            if (fired) return;
            fired = true;
            fn();
          }

          // check if document is already loaded
          if (window.document.readyState === 'complete') {
            window.setTimeout(trigger);
          } else {
            this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
            // we can not use jqLite since we are not done loading and jQuery could be loaded later.
            // jshint -W064
            JQLite(window).on('load', trigger); // fallback to window.onload for others
            // jshint +W064
          }
        },
        toString: function () {
          var value = [];
          forEach(this, function (e) {
            value.push('' + e);
          });
          return '[' + value.join(', ') + ']';
        },

        eq: function (index) {
          return index >= 0 ? jqLite(this[index]) : jqLite(this[this.length + index]);
        },

        length: 0,
        push: push,
        sort: [].sort,
        splice: [].splice
      };

      //////////////////////////////////////////
      // Functions iterating getter/setters.
      // these functions return self on setter and
      // value on get.
      //////////////////////////////////////////
      var BOOLEAN_ATTR = {};
      forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function (value) {
        BOOLEAN_ATTR[lowercase(value)] = value;
      });
      var BOOLEAN_ELEMENTS = {};
      forEach('input,select,option,textarea,button,form,details'.split(','), function (value) {
        BOOLEAN_ELEMENTS[value] = true;
      });
      var ALIASED_ATTR = {
        'ngMinlength': 'minlength',
        'ngMaxlength': 'maxlength',
        'ngMin': 'min',
        'ngMax': 'max',
        'ngPattern': 'pattern'
      };

      function getBooleanAttrName(element, name) {
        // check dom last since we will most likely fail on name
        var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

        // booleanAttr is here twice to minimize DOM access
        return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
      }

      function getAliasedAttrName(name) {
        return ALIASED_ATTR[name];
      }

      forEach({
        data: jqLiteData,
        removeData: jqLiteRemoveData,
        hasData: jqLiteHasData,
        cleanData: jqLiteCleanData
      }, function (fn, name) {
        JQLite[name] = fn;
      });

      forEach({
        data: jqLiteData,
        inheritedData: jqLiteInheritedData,

        scope: function (element) {
          // Can't use jqLiteData here directly so we stay compatible with jQuery!
          return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
        },

        isolateScope: function (element) {
          // Can't use jqLiteData here directly so we stay compatible with jQuery!
          return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
        },

        controller: jqLiteController,

        injector: function (element) {
          return jqLiteInheritedData(element, '$injector');
        },

        removeAttr: function (element, name) {
          element.removeAttribute(name);
        },

        hasClass: jqLiteHasClass,

        css: function (element, name, value) {
          name = camelCase(name);

          if (isDefined(value)) {
            element.style[name] = value;
          } else {
            return element.style[name];
          }
        },

        attr: function (element, name, value) {
          var nodeType = element.nodeType;
          if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
            return;
          }
          var lowercasedName = lowercase(name);
          if (BOOLEAN_ATTR[lowercasedName]) {
            if (isDefined(value)) {
              if (!!value) {
                element[name] = true;
                element.setAttribute(name, lowercasedName);
              } else {
                element[name] = false;
                element.removeAttribute(lowercasedName);
              }
            } else {
              return element[name] || (element.attributes.getNamedItem(name) || noop).specified ? lowercasedName : undefined;
            }
          } else if (isDefined(value)) {
            element.setAttribute(name, value);
          } else if (element.getAttribute) {
            // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
            // some elements (e.g. Document) don't have get attribute, so return undefined
            var ret = element.getAttribute(name, 2);
            // normalize non-existing attributes to undefined (as jQuery)
            return ret === null ? undefined : ret;
          }
        },

        prop: function (element, name, value) {
          if (isDefined(value)) {
            element[name] = value;
          } else {
            return element[name];
          }
        },

        text: function () {
          getText.$dv = '';
          return getText;

          function getText(element, value) {
            if (isUndefined(value)) {
              var nodeType = element.nodeType;
              return nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT ? element.textContent : '';
            }
            element.textContent = value;
          }
        }(),

        val: function (element, value) {
          if (isUndefined(value)) {
            if (element.multiple && nodeName_(element) === 'select') {
              var result = [];
              forEach(element.options, function (option) {
                if (option.selected) {
                  result.push(option.value || option.text);
                }
              });
              return result.length === 0 ? null : result;
            }
            return element.value;
          }
          element.value = value;
        },

        html: function (element, value) {
          if (isUndefined(value)) {
            return element.innerHTML;
          }
          jqLiteDealoc(element, true);
          element.innerHTML = value;
        },

        empty: jqLiteEmpty
      }, function (fn, name) {
        /**
         * Properties: writes return selection, reads return first value
         */
        JQLite.prototype[name] = function (arg1, arg2) {
          var i, key;
          var nodeCount = this.length;

          // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
          // in a way that survives minification.
          // jqLiteEmpty takes no arguments but is a setter.
          if (fn !== jqLiteEmpty && isUndefined(fn.length == 2 && fn !== jqLiteHasClass && fn !== jqLiteController ? arg1 : arg2)) {
            if (isObject(arg1)) {

              // we are a write, but the object properties are the key/values
              for (i = 0; i < nodeCount; i++) {
                if (fn === jqLiteData) {
                  // data() takes the whole object in jQuery
                  fn(this[i], arg1);
                } else {
                  for (key in arg1) {
                    fn(this[i], key, arg1[key]);
                  }
                }
              }
              // return self for chaining
              return this;
            } else {
              // we are a read, so read the first child.
              // TODO: do we still need this?
              var value = fn.$dv;
              // Only if we have $dv do we iterate over all, otherwise it is just the first element.
              var jj = isUndefined(value) ? Math.min(nodeCount, 1) : nodeCount;
              for (var j = 0; j < jj; j++) {
                var nodeValue = fn(this[j], arg1, arg2);
                value = value ? value + nodeValue : nodeValue;
              }
              return value;
            }
          } else {
            // we are a write, so apply to all children
            for (i = 0; i < nodeCount; i++) {
              fn(this[i], arg1, arg2);
            }
            // return self for chaining
            return this;
          }
        };
      });

      function createEventHandler(element, events) {
        var eventHandler = function (event, type) {
          // jQuery specific api
          event.isDefaultPrevented = function () {
            return event.defaultPrevented;
          };

          var eventFns = events[type || event.type];
          var eventFnsLength = eventFns ? eventFns.length : 0;

          if (!eventFnsLength) return;

          if (isUndefined(event.immediatePropagationStopped)) {
            var originalStopImmediatePropagation = event.stopImmediatePropagation;
            event.stopImmediatePropagation = function () {
              event.immediatePropagationStopped = true;

              if (event.stopPropagation) {
                event.stopPropagation();
              }

              if (originalStopImmediatePropagation) {
                originalStopImmediatePropagation.call(event);
              }
            };
          }

          event.isImmediatePropagationStopped = function () {
            return event.immediatePropagationStopped === true;
          };

          // Some events have special handlers that wrap the real handler
          var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

          // Copy event handlers in case event handlers array is modified during execution.
          if (eventFnsLength > 1) {
            eventFns = shallowCopy(eventFns);
          }

          for (var i = 0; i < eventFnsLength; i++) {
            if (!event.isImmediatePropagationStopped()) {
              handlerWrapper(element, event, eventFns[i]);
            }
          }
        };

        // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
        //       events on `element`
        eventHandler.elem = element;
        return eventHandler;
      }

      function defaultHandlerWrapper(element, event, handler) {
        handler.call(element, event);
      }

      function specialMouseHandlerWrapper(target, event, handler) {
        // Refer to jQuery's implementation of mouseenter & mouseleave
        // Read about mouseenter and mouseleave:
        // http://www.quirksmode.org/js/events_mouse.html#link8
        var related = event.relatedTarget;
        // For mousenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if (!related || related !== target && !jqLiteContains.call(target, related)) {
          handler.call(target, event);
        }
      }

      //////////////////////////////////////////
      // Functions iterating traversal.
      // These functions chain results into a single
      // selector.
      //////////////////////////////////////////
      forEach({
        removeData: jqLiteRemoveData,

        on: function jqLiteOn(element, type, fn, unsupported) {
          if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

          // Do not add event handlers to non-elements because they will not be cleaned up.
          if (!jqLiteAcceptsData(element)) {
            return;
          }

          var expandoStore = jqLiteExpandoStore(element, true);
          var events = expandoStore.events;
          var handle = expandoStore.handle;

          if (!handle) {
            handle = expandoStore.handle = createEventHandler(element, events);
          }

          // http://jsperf.com/string-indexof-vs-split
          var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
          var i = types.length;

          var addHandler = function (type, specialHandlerWrapper, noEventListener) {
            var eventFns = events[type];

            if (!eventFns) {
              eventFns = events[type] = [];
              eventFns.specialHandlerWrapper = specialHandlerWrapper;
              if (type !== '$destroy' && !noEventListener) {
                addEventListenerFn(element, type, handle);
              }
            }

            eventFns.push(fn);
          };

          while (i--) {
            type = types[i];
            if (MOUSE_EVENT_MAP[type]) {
              addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
              addHandler(type, undefined, true);
            } else {
              addHandler(type);
            }
          }
        },

        off: jqLiteOff,

        one: function (element, type, fn) {
          element = jqLite(element);

          //add the listener twice so that when it is called
          //you can remove the original function and still be
          //able to call element.off(ev, fn) normally
          element.on(type, function onFn() {
            element.off(type, fn);
            element.off(type, onFn);
          });
          element.on(type, fn);
        },

        replaceWith: function (element, replaceNode) {
          var index,
              parent = element.parentNode;
          jqLiteDealoc(element);
          forEach(new JQLite(replaceNode), function (node) {
            if (index) {
              parent.insertBefore(node, index.nextSibling);
            } else {
              parent.replaceChild(node, element);
            }
            index = node;
          });
        },

        children: function (element) {
          var children = [];
          forEach(element.childNodes, function (element) {
            if (element.nodeType === NODE_TYPE_ELEMENT) {
              children.push(element);
            }
          });
          return children;
        },

        contents: function (element) {
          return element.contentDocument || element.childNodes || [];
        },

        append: function (element, node) {
          var nodeType = element.nodeType;
          if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

          node = new JQLite(node);

          for (var i = 0, ii = node.length; i < ii; i++) {
            var child = node[i];
            element.appendChild(child);
          }
        },

        prepend: function (element, node) {
          if (element.nodeType === NODE_TYPE_ELEMENT) {
            var index = element.firstChild;
            forEach(new JQLite(node), function (child) {
              element.insertBefore(child, index);
            });
          }
        },

        wrap: function (element, wrapNode) {
          jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
        },

        remove: jqLiteRemove,

        detach: function (element) {
          jqLiteRemove(element, true);
        },

        after: function (element, newElement) {
          var index = element,
              parent = element.parentNode;
          newElement = new JQLite(newElement);

          for (var i = 0, ii = newElement.length; i < ii; i++) {
            var node = newElement[i];
            parent.insertBefore(node, index.nextSibling);
            index = node;
          }
        },

        addClass: jqLiteAddClass,
        removeClass: jqLiteRemoveClass,

        toggleClass: function (element, selector, condition) {
          if (selector) {
            forEach(selector.split(' '), function (className) {
              var classCondition = condition;
              if (isUndefined(classCondition)) {
                classCondition = !jqLiteHasClass(element, className);
              }
              (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
            });
          }
        },

        parent: function (element) {
          var parent = element.parentNode;
          return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
        },

        next: function (element) {
          return element.nextElementSibling;
        },

        find: function (element, selector) {
          if (element.getElementsByTagName) {
            return element.getElementsByTagName(selector);
          } else {
            return [];
          }
        },

        clone: jqLiteClone,

        triggerHandler: function (element, event, extraParameters) {

          var dummyEvent, eventFnsCopy, handlerArgs;
          var eventName = event.type || event;
          var expandoStore = jqLiteExpandoStore(element);
          var events = expandoStore && expandoStore.events;
          var eventFns = events && events[eventName];

          if (eventFns) {
            // Create a dummy event to pass to the handlers
            dummyEvent = {
              preventDefault: function () {
                this.defaultPrevented = true;
              },
              isDefaultPrevented: function () {
                return this.defaultPrevented === true;
              },
              stopImmediatePropagation: function () {
                this.immediatePropagationStopped = true;
              },
              isImmediatePropagationStopped: function () {
                return this.immediatePropagationStopped === true;
              },
              stopPropagation: noop,
              type: eventName,
              target: element
            };

            // If a custom event was provided then extend our dummy event with it
            if (event.type) {
              dummyEvent = extend(dummyEvent, event);
            }

            // Copy event handlers in case event handlers array is modified during execution.
            eventFnsCopy = shallowCopy(eventFns);
            handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

            forEach(eventFnsCopy, function (fn) {
              if (!dummyEvent.isImmediatePropagationStopped()) {
                fn.apply(element, handlerArgs);
              }
            });
          }
        }
      }, function (fn, name) {
        /**
         * chaining functions
         */
        JQLite.prototype[name] = function (arg1, arg2, arg3) {
          var value;

          for (var i = 0, ii = this.length; i < ii; i++) {
            if (isUndefined(value)) {
              value = fn(this[i], arg1, arg2, arg3);
              if (isDefined(value)) {
                // any function which returns a value needs to be wrapped
                value = jqLite(value);
              }
            } else {
              jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
            }
          }
          return isDefined(value) ? value : this;
        };

        // bind legacy bind/unbind to on/off
        JQLite.prototype.bind = JQLite.prototype.on;
        JQLite.prototype.unbind = JQLite.prototype.off;
      });

      // Provider for private $$jqLite service
      function $$jqLiteProvider() {
        this.$get = function $$jqLite() {
          return extend(JQLite, {
            hasClass: function (node, classes) {
              if (node.attr) node = node[0];
              return jqLiteHasClass(node, classes);
            },
            addClass: function (node, classes) {
              if (node.attr) node = node[0];
              return jqLiteAddClass(node, classes);
            },
            removeClass: function (node, classes) {
              if (node.attr) node = node[0];
              return jqLiteRemoveClass(node, classes);
            }
          });
        };
      }

      /**
       * Computes a hash of an 'obj'.
       * Hash of a:
       *  string is string
       *  number is number as string
       *  object is either result of calling $$hashKey function on the object or uniquely generated id,
       *         that is also assigned to the $$hashKey property of the object.
       *
       * @param obj
       * @returns {string} hash string such that the same input will have the same hash string.
       *         The resulting string key is in 'type:hashKey' format.
       */
      function hashKey(obj, nextUidFn) {
        var key = obj && obj.$$hashKey;

        if (key) {
          if (typeof key === 'function') {
            key = obj.$$hashKey();
          }
          return key;
        }

        var objType = typeof obj;
        if (objType == 'function' || objType == 'object' && obj !== null) {
          key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
        } else {
          key = objType + ':' + obj;
        }

        return key;
      }

      /**
       * HashMap which can use objects as keys
       */
      function HashMap(array, isolatedUid) {
        if (isolatedUid) {
          var uid = 0;
          this.nextUid = function () {
            return ++uid;
          };
        }
        forEach(array, this.put, this);
      }
      HashMap.prototype = {
        /**
         * Store key value pair
         * @param key key to store can be any type
         * @param value value to store can be any type
         */
        put: function (key, value) {
          this[hashKey(key, this.nextUid)] = value;
        },

        /**
         * @param key
         * @returns {Object} the value for the key
         */
        get: function (key) {
          return this[hashKey(key, this.nextUid)];
        },

        /**
         * Remove the key/value pair
         * @param key
         */
        remove: function (key) {
          var value = this[key = hashKey(key, this.nextUid)];
          delete this[key];
          return value;
        }
      };

      var $$HashMapProvider = [function () {
        this.$get = [function () {
          return HashMap;
        }];
      }];

      /**
       * @ngdoc function
       * @module ng
       * @name angular.injector
       * @kind function
       *
       * @description
       * Creates an injector object that can be used for retrieving services as well as for
       * dependency injection (see {@link guide/di dependency injection}).
       *
       * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
       *     {@link angular.module}. The `ng` module must be explicitly added.
       * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
       *     disallows argument name annotation inference.
       * @returns {injector} Injector object. See {@link auto.$injector $injector}.
       *
       * @example
       * Typical usage
       * ```js
       *   // create an injector
       *   var $injector = angular.injector(['ng']);
       *
       *   // use the injector to kick off your application
       *   // use the type inference to auto inject arguments, or use implicit injection
       *   $injector.invoke(function($rootScope, $compile, $document) {
       *     $compile($document)($rootScope);
       *     $rootScope.$digest();
       *   });
       * ```
       *
       * Sometimes you want to get access to the injector of a currently running Angular app
       * from outside Angular. Perhaps, you want to inject and compile some markup after the
       * application has been bootstrapped. You can do this using the extra `injector()` added
       * to JQuery/jqLite elements. See {@link angular.element}.
       *
       * *This is fairly rare but could be the case if a third party library is injecting the
       * markup.*
       *
       * In the following example a new block of HTML containing a `ng-controller`
       * directive is added to the end of the document body by JQuery. We then compile and link
       * it into the current AngularJS scope.
       *
       * ```js
       * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
       * $(document.body).append($div);
       *
       * angular.element(document).injector().invoke(function($compile) {
       *   var scope = angular.element($div).scope();
       *   $compile($div)(scope);
       * });
       * ```
       */

      /**
       * @ngdoc module
       * @name auto
       * @installation
       * @description
       *
       * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
       */

      var ARROW_ARG = /^([^\(]+?)=>/;
      var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
      var FN_ARG_SPLIT = /,/;
      var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
      var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
      var $injectorMinErr = minErr('$injector');

      function stringifyFn(fn) {
        // Support: Chrome 50-51 only
        // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
        // (See https://github.com/angular/angular.js/issues/14487.)
        // TODO (gkalpak): Remove workaround when Chrome v52 is released
        return Function.prototype.toString.call(fn) + ' ';
      }

      function extractArgs(fn) {
        var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
            args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
        return args;
      }

      function anonFn(fn) {
        // For anonymous functions, showing at the very least the function signature can help in
        // debugging.
        var args = extractArgs(fn);
        if (args) {
          return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
        }
        return 'fn';
      }

      function annotate(fn, strictDi, name) {
        var $inject, argDecl, last;

        if (typeof fn === 'function') {
          if (!($inject = fn.$inject)) {
            $inject = [];
            if (fn.length) {
              if (strictDi) {
                if (!isString(name) || !name) {
                  name = fn.name || anonFn(fn);
                }
                throw $injectorMinErr('strictdi', '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
              }
              argDecl = extractArgs(fn);
              forEach(argDecl[1].split(FN_ARG_SPLIT), function (arg) {
                arg.replace(FN_ARG, function (all, underscore, name) {
                  $inject.push(name);
                });
              });
            }
            fn.$inject = $inject;
          }
        } else if (isArray(fn)) {
          last = fn.length - 1;
          assertArgFn(fn[last], 'fn');
          $inject = fn.slice(0, last);
        } else {
          assertArgFn(fn, 'fn', true);
        }
        return $inject;
      }

      ///////////////////////////////////////

      /**
       * @ngdoc service
       * @name $injector
       *
       * @description
       *
       * `$injector` is used to retrieve object instances as defined by
       * {@link auto.$provide provider}, instantiate types, invoke methods,
       * and load modules.
       *
       * The following always holds true:
       *
       * ```js
       *   var $injector = angular.injector();
       *   expect($injector.get('$injector')).toBe($injector);
       *   expect($injector.invoke(function($injector) {
       *     return $injector;
       *   })).toBe($injector);
       * ```
       *
       * # Injection Function Annotation
       *
       * JavaScript does not have annotations, and annotations are needed for dependency injection. The
       * following are all valid ways of annotating function with injection arguments and are equivalent.
       *
       * ```js
       *   // inferred (only works if code not minified/obfuscated)
       *   $injector.invoke(function(serviceA){});
       *
       *   // annotated
       *   function explicit(serviceA) {};
       *   explicit.$inject = ['serviceA'];
       *   $injector.invoke(explicit);
       *
       *   // inline
       *   $injector.invoke(['serviceA', function(serviceA){}]);
       * ```
       *
       * ## Inference
       *
       * In JavaScript calling `toString()` on a function returns the function definition. The definition
       * can then be parsed and the function arguments can be extracted. This method of discovering
       * annotations is disallowed when the injector is in strict mode.
       * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
       * argument names.
       *
       * ## `$inject` Annotation
       * By adding an `$inject` property onto a function the injection parameters can be specified.
       *
       * ## Inline
       * As an array of injection names, where the last item in the array is the function to call.
       */

      /**
       * @ngdoc method
       * @name $injector#get
       *
       * @description
       * Return an instance of the service.
       *
       * @param {string} name The name of the instance to retrieve.
       * @param {string=} caller An optional string to provide the origin of the function call for error messages.
       * @return {*} The instance.
       */

      /**
       * @ngdoc method
       * @name $injector#invoke
       *
       * @description
       * Invoke the method and supply the method arguments from the `$injector`.
       *
       * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
       *   injected according to the {@link guide/di $inject Annotation} rules.
       * @param {Object=} self The `this` for the invoked method.
       * @param {Object=} locals Optional object. If preset then any argument names are read from this
       *                         object first, before the `$injector` is consulted.
       * @returns {*} the value returned by the invoked `fn` function.
       */

      /**
       * @ngdoc method
       * @name $injector#has
       *
       * @description
       * Allows the user to query if the particular service exists.
       *
       * @param {string} name Name of the service to query.
       * @returns {boolean} `true` if injector has given service.
       */

      /**
       * @ngdoc method
       * @name $injector#instantiate
       * @description
       * Create a new instance of JS type. The method takes a constructor function, invokes the new
       * operator, and supplies all of the arguments to the constructor function as specified by the
       * constructor annotation.
       *
       * @param {Function} Type Annotated constructor function.
       * @param {Object=} locals Optional object. If preset then any argument names are read from this
       * object first, before the `$injector` is consulted.
       * @returns {Object} new instance of `Type`.
       */

      /**
       * @ngdoc method
       * @name $injector#annotate
       *
       * @description
       * Returns an array of service names which the function is requesting for injection. This API is
       * used by the injector to determine which services need to be injected into the function when the
       * function is invoked. There are three ways in which the function can be annotated with the needed
       * dependencies.
       *
       * # Argument names
       *
       * The simplest form is to extract the dependencies from the arguments of the function. This is done
       * by converting the function into a string using `toString()` method and extracting the argument
       * names.
       * ```js
       *   // Given
       *   function MyController($scope, $route) {
       *     // ...
       *   }
       *
       *   // Then
       *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
       * ```
       *
       * You can disallow this method by using strict injection mode.
       *
       * This method does not work with code minification / obfuscation. For this reason the following
       * annotation strategies are supported.
       *
       * # The `$inject` property
       *
       * If a function has an `$inject` property and its value is an array of strings, then the strings
       * represent names of services to be injected into the function.
       * ```js
       *   // Given
       *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
       *     // ...
       *   }
       *   // Define function dependencies
       *   MyController['$inject'] = ['$scope', '$route'];
       *
       *   // Then
       *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
       * ```
       *
       * # The array notation
       *
       * It is often desirable to inline Injected functions and that's when setting the `$inject` property
       * is very inconvenient. In these situations using the array notation to specify the dependencies in
       * a way that survives minification is a better choice:
       *
       * ```js
       *   // We wish to write this (not minification / obfuscation safe)
       *   injector.invoke(function($compile, $rootScope) {
       *     // ...
       *   });
       *
       *   // We are forced to write break inlining
       *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
       *     // ...
       *   };
       *   tmpFn.$inject = ['$compile', '$rootScope'];
       *   injector.invoke(tmpFn);
       *
       *   // To better support inline function the inline annotation is supported
       *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
       *     // ...
       *   }]);
       *
       *   // Therefore
       *   expect(injector.annotate(
       *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
       *    ).toEqual(['$compile', '$rootScope']);
       * ```
       *
       * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
       * be retrieved as described above.
       *
       * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
       *
       * @returns {Array.<string>} The names of the services which the function requires.
       */

      /**
       * @ngdoc service
       * @name $provide
       *
       * @description
       *
       * The {@link auto.$provide $provide} service has a number of methods for registering components
       * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
       * {@link angular.Module}.
       *
       * An Angular **service** is a singleton object created by a **service factory**.  These **service
       * factories** are functions which, in turn, are created by a **service provider**.
       * The **service providers** are constructor functions. When instantiated they must contain a
       * property called `$get`, which holds the **service factory** function.
       *
       * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
       * correct **service provider**, instantiating it and then calling its `$get` **service factory**
       * function to get the instance of the **service**.
       *
       * Often services have no configuration options and there is no need to add methods to the service
       * provider.  The provider will be no more than a constructor function with a `$get` property. For
       * these cases the {@link auto.$provide $provide} service has additional helper methods to register
       * services without specifying a provider.
       *
       * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
       *     {@link auto.$injector $injector}
       * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
       *     providers and services.
       * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
       *     services, not providers.
       * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
       *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
       *     given factory function.
       * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
       *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
       *      a new object using the given constructor function.
       * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
       *      will be able to modify or replace the implementation of another service.
       *
       * See the individual methods for more information and examples.
       */

      /**
       * @ngdoc method
       * @name $provide#provider
       * @description
       *
       * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
       * are constructor functions, whose instances are responsible for "providing" a factory for a
       * service.
       *
       * Service provider names start with the name of the service they provide followed by `Provider`.
       * For example, the {@link ng.$log $log} service has a provider called
       * {@link ng.$logProvider $logProvider}.
       *
       * Service provider objects can have additional methods which allow configuration of the provider
       * and its service. Importantly, you can configure what kind of service is created by the `$get`
       * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
       * method {@link ng.$logProvider#debugEnabled debugEnabled}
       * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
       * console or not.
       *
       * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                              'Provider'` key.
       * @param {(Object|function())} provider If the provider is:
       *
       *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
       *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
       *   - `Constructor`: a new instance of the provider will be created using
       *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
       *
       * @returns {Object} registered provider instance
      
       * @example
       *
       * The following example shows how to create a simple event tracking service and register it using
       * {@link auto.$provide#provider $provide.provider()}.
       *
       * ```js
       *  // Define the eventTracker provider
       *  function EventTrackerProvider() {
       *    var trackingUrl = '/track';
       *
       *    // A provider method for configuring where the tracked events should been saved
       *    this.setTrackingUrl = function(url) {
       *      trackingUrl = url;
       *    };
       *
       *    // The service factory function
       *    this.$get = ['$http', function($http) {
       *      var trackedEvents = {};
       *      return {
       *        // Call this to track an event
       *        event: function(event) {
       *          var count = trackedEvents[event] || 0;
       *          count += 1;
       *          trackedEvents[event] = count;
       *          return count;
       *        },
       *        // Call this to save the tracked events to the trackingUrl
       *        save: function() {
       *          $http.post(trackingUrl, trackedEvents);
       *        }
       *      };
       *    }];
       *  }
       *
       *  describe('eventTracker', function() {
       *    var postSpy;
       *
       *    beforeEach(module(function($provide) {
       *      // Register the eventTracker provider
       *      $provide.provider('eventTracker', EventTrackerProvider);
       *    }));
       *
       *    beforeEach(module(function(eventTrackerProvider) {
       *      // Configure eventTracker provider
       *      eventTrackerProvider.setTrackingUrl('/custom-track');
       *    }));
       *
       *    it('tracks events', inject(function(eventTracker) {
       *      expect(eventTracker.event('login')).toEqual(1);
       *      expect(eventTracker.event('login')).toEqual(2);
       *    }));
       *
       *    it('saves to the tracking url', inject(function(eventTracker, $http) {
       *      postSpy = spyOn($http, 'post');
       *      eventTracker.event('login');
       *      eventTracker.save();
       *      expect(postSpy).toHaveBeenCalled();
       *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
       *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
       *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
       *    }));
       *  });
       * ```
       */

      /**
       * @ngdoc method
       * @name $provide#factory
       * @description
       *
       * Register a **service factory**, which will be called to return the service instance.
       * This is short for registering a service where its provider consists of only a `$get` property,
       * which is the given service factory function.
       * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
       * configure your service in a provider.
       *
       * @param {string} name The name of the instance.
       * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
       *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
       * @returns {Object} registered provider instance
       *
       * @example
       * Here is an example of registering a service
       * ```js
       *   $provide.factory('ping', ['$http', function($http) {
       *     return function ping() {
       *       return $http.send('/ping');
       *     };
       *   }]);
       * ```
       * You would then inject and use this service like this:
       * ```js
       *   someModule.controller('Ctrl', ['ping', function(ping) {
       *     ping();
       *   }]);
       * ```
       */

      /**
       * @ngdoc method
       * @name $provide#service
       * @description
       *
       * Register a **service constructor**, which will be invoked with `new` to create the service
       * instance.
       * This is short for registering a service where its provider's `$get` property is a factory
       * function that returns an instance instantiated by the injector from the service constructor
       * function.
       *
       * Internally it looks a bit like this:
       *
       * ```
       * {
       *   $get: function() {
       *     return $injector.instantiate(constructor);
       *   }
       * }
       * ```
       *
       *
       * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
       * as a type/class.
       *
       * @param {string} name The name of the instance.
       * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
       *     that will be instantiated.
       * @returns {Object} registered provider instance
       *
       * @example
       * Here is an example of registering a service using
       * {@link auto.$provide#service $provide.service(class)}.
       * ```js
       *   var Ping = function($http) {
       *     this.$http = $http;
       *   };
       *
       *   Ping.$inject = ['$http'];
       *
       *   Ping.prototype.send = function() {
       *     return this.$http.get('/ping');
       *   };
       *   $provide.service('ping', Ping);
       * ```
       * You would then inject and use this service like this:
       * ```js
       *   someModule.controller('Ctrl', ['ping', function(ping) {
       *     ping.send();
       *   }]);
       * ```
       */

      /**
       * @ngdoc method
       * @name $provide#value
       * @description
       *
       * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
       * number, an array, an object or a function. This is short for registering a service where its
       * provider's `$get` property is a factory function that takes no arguments and returns the **value
       * service**. That also means it is not possible to inject other services into a value service.
       *
       * Value services are similar to constant services, except that they cannot be injected into a
       * module configuration function (see {@link angular.Module#config}) but they can be overridden by
       * an Angular {@link auto.$provide#decorator decorator}.
       *
       * @param {string} name The name of the instance.
       * @param {*} value The value.
       * @returns {Object} registered provider instance
       *
       * @example
       * Here are some examples of creating value services.
       * ```js
       *   $provide.value('ADMIN_USER', 'admin');
       *
       *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
       *
       *   $provide.value('halfOf', function(value) {
       *     return value / 2;
       *   });
       * ```
       */

      /**
       * @ngdoc method
       * @name $provide#constant
       * @description
       *
       * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
       * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
       * possible to inject other services into a constant.
       *
       * But unlike {@link auto.$provide#value value}, a constant can be
       * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
       * be overridden by an Angular {@link auto.$provide#decorator decorator}.
       *
       * @param {string} name The name of the constant.
       * @param {*} value The constant value.
       * @returns {Object} registered instance
       *
       * @example
       * Here a some examples of creating constants:
       * ```js
       *   $provide.constant('SHARD_HEIGHT', 306);
       *
       *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
       *
       *   $provide.constant('double', function(value) {
       *     return value * 2;
       *   });
       * ```
       */

      /**
       * @ngdoc method
       * @name $provide#decorator
       * @description
       *
       * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
       * intercepts the creation of a service, allowing it to override or modify the behavior of the
       * service. The return value of the decorator function may be the original service, or a new service
       * that replaces (or wraps and delegates to) the original service.
       *
       * You can find out more about using decorators in the {@link guide/decorators} guide.
       *
       * @param {string} name The name of the service to decorate.
       * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
       *    provided and should return the decorated service instance. The function is called using
       *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
       *    Local injection arguments:
       *
       *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
       *      decorated or delegated to.
       *
       * @example
       * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
       * calls to {@link ng.$log#error $log.warn()}.
       * ```js
       *   $provide.decorator('$log', ['$delegate', function($delegate) {
       *     $delegate.warn = $delegate.error;
       *     return $delegate;
       *   }]);
       * ```
       */

      function createInjector(modulesToLoad, strictDi) {
        strictDi = strictDi === true;
        var INSTANTIATING = {},
            providerSuffix = 'Provider',
            path = [],
            loadedModules = new HashMap([], true),
            providerCache = {
          $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
        },
            providerInjector = providerCache.$injector = createInternalInjector(providerCache, function (serviceName, caller) {
          if (angular.isString(caller)) {
            path.push(caller);
          }
          throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
        }),
            instanceCache = {},
            protoInstanceInjector = createInternalInjector(instanceCache, function (serviceName, caller) {
          var provider = providerInjector.get(serviceName + providerSuffix, caller);
          return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
        }),
            instanceInjector = protoInstanceInjector;

        providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
        var runBlocks = loadModules(modulesToLoad);
        instanceInjector = protoInstanceInjector.get('$injector');
        instanceInjector.strictDi = strictDi;
        forEach(runBlocks, function (fn) {
          if (fn) instanceInjector.invoke(fn);
        });

        return instanceInjector;

        ////////////////////////////////////
        // $provider
        ////////////////////////////////////

        function supportObject(delegate) {
          return function (key, value) {
            if (isObject(key)) {
              forEach(key, reverseParams(delegate));
            } else {
              return delegate(key, value);
            }
          };
        }

        function provider(name, provider_) {
          assertNotHasOwnProperty(name, 'service');
          if (isFunction(provider_) || isArray(provider_)) {
            provider_ = providerInjector.instantiate(provider_);
          }
          if (!provider_.$get) {
            throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
          }
          return providerCache[name + providerSuffix] = provider_;
        }

        function enforceReturnValue(name, factory) {
          return function enforcedReturnValue() {
            var result = instanceInjector.invoke(factory, this);
            if (isUndefined(result)) {
              throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
            }
            return result;
          };
        }

        function factory(name, factoryFn, enforce) {
          return provider(name, {
            $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
          });
        }

        function service(name, constructor) {
          return factory(name, ['$injector', function ($injector) {
            return $injector.instantiate(constructor);
          }]);
        }

        function value(name, val) {
          return factory(name, valueFn(val), false);
        }

        function constant(name, value) {
          assertNotHasOwnProperty(name, 'constant');
          providerCache[name] = value;
          instanceCache[name] = value;
        }

        function decorator(serviceName, decorFn) {
          var origProvider = providerInjector.get(serviceName + providerSuffix),
              orig$get = origProvider.$get;

          origProvider.$get = function () {
            var origInstance = instanceInjector.invoke(orig$get, origProvider);
            return instanceInjector.invoke(decorFn, null, { $delegate: origInstance });
          };
        }

        ////////////////////////////////////
        // Module Loading
        ////////////////////////////////////
        function loadModules(modulesToLoad) {
          assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
          var runBlocks = [],
              moduleFn;
          forEach(modulesToLoad, function (module) {
            if (loadedModules.get(module)) return;
            loadedModules.put(module, true);

            function runInvokeQueue(queue) {
              var i, ii;
              for (i = 0, ii = queue.length; i < ii; i++) {
                var invokeArgs = queue[i],
                    provider = providerInjector.get(invokeArgs[0]);

                provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
              }
            }

            try {
              if (isString(module)) {
                moduleFn = angularModule(module);
                runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
                runInvokeQueue(moduleFn._invokeQueue);
                runInvokeQueue(moduleFn._configBlocks);
              } else if (isFunction(module)) {
                runBlocks.push(providerInjector.invoke(module));
              } else if (isArray(module)) {
                runBlocks.push(providerInjector.invoke(module));
              } else {
                assertArgFn(module, 'module');
              }
            } catch (e) {
              if (isArray(module)) {
                module = module[module.length - 1];
              }
              if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
                // Safari & FF's stack traces don't contain error.message content
                // unlike those of Chrome and IE
                // So if stack doesn't contain message, we create a new string that contains both.
                // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
                /* jshint -W022 */
                e = e.message + '\n' + e.stack;
              }
              throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}", module, e.stack || e.message || e);
            }
          });
          return runBlocks;
        }

        ////////////////////////////////////
        // internal Injector
        ////////////////////////////////////

        function createInternalInjector(cache, factory) {

          function getService(serviceName, caller) {
            if (cache.hasOwnProperty(serviceName)) {
              if (cache[serviceName] === INSTANTIATING) {
                throw $injectorMinErr('cdep', 'Circular dependency found: {0}', serviceName + ' <- ' + path.join(' <- '));
              }
              return cache[serviceName];
            } else {
              try {
                path.unshift(serviceName);
                cache[serviceName] = INSTANTIATING;
                return cache[serviceName] = factory(serviceName, caller);
              } catch (err) {
                if (cache[serviceName] === INSTANTIATING) {
                  delete cache[serviceName];
                }
                throw err;
              } finally {
                path.shift();
              }
            }
          }

          function injectionArgs(fn, locals, serviceName) {
            var args = [],
                $inject = createInjector.$$annotate(fn, strictDi, serviceName);

            for (var i = 0, length = $inject.length; i < length; i++) {
              var key = $inject[i];
              if (typeof key !== 'string') {
                throw $injectorMinErr('itkn', 'Incorrect injection token! Expected service name as string, got {0}', key);
              }
              args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
            }
            return args;
          }

          function isClass(func) {
            // IE 9-11 do not support classes and IE9 leaks with the code below.
            if (msie <= 11) {
              return false;
            }
            // Support: Edge 12-13 only
            // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
            return typeof func === 'function' && /^(?:class\b|constructor\()/.test(stringifyFn(func));
          }

          function invoke(fn, self, locals, serviceName) {
            if (typeof locals === 'string') {
              serviceName = locals;
              locals = null;
            }

            var args = injectionArgs(fn, locals, serviceName);
            if (isArray(fn)) {
              fn = fn[fn.length - 1];
            }

            if (!isClass(fn)) {
              // http://jsperf.com/angularjs-invoke-apply-vs-switch
              // #5388
              return fn.apply(self, args);
            } else {
              args.unshift(null);
              return new (Function.prototype.bind.apply(fn, args))();
            }
          }

          function instantiate(Type, locals, serviceName) {
            // Check if Type is annotated and use just the given function at n-1 as parameter
            // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
            var ctor = isArray(Type) ? Type[Type.length - 1] : Type;
            var args = injectionArgs(Type, locals, serviceName);
            // Empty object at position 0 is ignored for invocation with `new`, but required.
            args.unshift(null);
            return new (Function.prototype.bind.apply(ctor, args))();
          }

          return {
            invoke: invoke,
            instantiate: instantiate,
            get: getService,
            annotate: createInjector.$$annotate,
            has: function (name) {
              return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
            }
          };
        }
      }

      createInjector.$$annotate = annotate;

      /**
       * @ngdoc provider
       * @name $anchorScrollProvider
       *
       * @description
       * Use `$anchorScrollProvider` to disable automatic scrolling whenever
       * {@link ng.$location#hash $location.hash()} changes.
       */
      function $AnchorScrollProvider() {

        var autoScrollingEnabled = true;

        /**
         * @ngdoc method
         * @name $anchorScrollProvider#disableAutoScrolling
         *
         * @description
         * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
         * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
         * Use this method to disable automatic scrolling.
         *
         * If automatic scrolling is disabled, one must explicitly call
         * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
         * current hash.
         */
        this.disableAutoScrolling = function () {
          autoScrollingEnabled = false;
        };

        /**
         * @ngdoc service
         * @name $anchorScroll
         * @kind function
         * @requires $window
         * @requires $location
         * @requires $rootScope
         *
         * @description
         * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
         * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
         * in the
         * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
         *
         * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
         * match any anchor whenever it changes. This can be disabled by calling
         * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
         *
         * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
         * vertical scroll-offset (either fixed or dynamic).
         *
         * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
         *                       {@link ng.$location#hash $location.hash()} will be used.
         *
         * @property {(number|function|jqLite)} yOffset
         * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
         * positioned elements at the top of the page, such as navbars, headers etc.
         *
         * `yOffset` can be specified in various ways:
         * - **number**: A fixed number of pixels to be used as offset.<br /><br />
         * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
         *   a number representing the offset (in pixels).<br /><br />
         * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
         *   the top of the page to the element's bottom will be used as offset.<br />
         *   **Note**: The element will be taken into account only as long as its `position` is set to
         *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
         *   their height and/or positioning according to the viewport's size.
         *
         * <br />
         * <div class="alert alert-warning">
         * In order for `yOffset` to work properly, scrolling should take place on the document's root and
         * not some child element.
         * </div>
         *
         * @example
           <example module="anchorScrollExample">
             <file name="index.html">
               <div id="scrollArea" ng-controller="ScrollController">
                 <a ng-click="gotoBottom()">Go to bottom</a>
                 <a id="bottom"></a> You're at the bottom!
               </div>
             </file>
             <file name="script.js">
               angular.module('anchorScrollExample', [])
                 .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
                   function ($scope, $location, $anchorScroll) {
                     $scope.gotoBottom = function() {
                       // set the location.hash to the id of
                       // the element you wish to scroll to.
                       $location.hash('bottom');
                        // call $anchorScroll()
                       $anchorScroll();
                     };
                   }]);
             </file>
             <file name="style.css">
               #scrollArea {
                 height: 280px;
                 overflow: auto;
               }
                #bottom {
                 display: block;
                 margin-top: 2000px;
               }
             </file>
           </example>
         *
         * <hr />
         * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
         * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
         *
         * @example
           <example module="anchorScrollOffsetExample">
             <file name="index.html">
               <div class="fixed-header" ng-controller="headerCtrl">
                 <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
                   Go to anchor {{x}}
                 </a>
               </div>
               <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
                 Anchor {{x}} of 5
               </div>
             </file>
             <file name="script.js">
               angular.module('anchorScrollOffsetExample', [])
                 .run(['$anchorScroll', function($anchorScroll) {
                   $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
                 }])
                 .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
                   function ($anchorScroll, $location, $scope) {
                     $scope.gotoAnchor = function(x) {
                       var newHash = 'anchor' + x;
                       if ($location.hash() !== newHash) {
                         // set the $location.hash to `newHash` and
                         // $anchorScroll will automatically scroll to it
                         $location.hash('anchor' + x);
                       } else {
                         // call $anchorScroll() explicitly,
                         // since $location.hash hasn't changed
                         $anchorScroll();
                       }
                     };
                   }
                 ]);
             </file>
             <file name="style.css">
               body {
                 padding-top: 50px;
               }
                .anchor {
                 border: 2px dashed DarkOrchid;
                 padding: 10px 10px 200px 10px;
               }
                .fixed-header {
                 background-color: rgba(0, 0, 0, 0.2);
                 height: 50px;
                 position: fixed;
                 top: 0; left: 0; right: 0;
               }
                .fixed-header > a {
                 display: inline-block;
                 margin: 5px 15px;
               }
             </file>
           </example>
         */
        this.$get = ['$window', '$location', '$rootScope', function ($window, $location, $rootScope) {
          var document = $window.document;

          // Helper function to get first anchor from a NodeList
          // (using `Array#some()` instead of `angular#forEach()` since it's more performant
          //  and working in all supported browsers.)
          function getFirstAnchor(list) {
            var result = null;
            Array.prototype.some.call(list, function (element) {
              if (nodeName_(element) === 'a') {
                result = element;
                return true;
              }
            });
            return result;
          }

          function getYOffset() {

            var offset = scroll.yOffset;

            if (isFunction(offset)) {
              offset = offset();
            } else if (isElement(offset)) {
              var elem = offset[0];
              var style = $window.getComputedStyle(elem);
              if (style.position !== 'fixed') {
                offset = 0;
              } else {
                offset = elem.getBoundingClientRect().bottom;
              }
            } else if (!isNumber(offset)) {
              offset = 0;
            }

            return offset;
          }

          function scrollTo(elem) {
            if (elem) {
              elem.scrollIntoView();

              var offset = getYOffset();

              if (offset) {
                // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
                // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
                // top of the viewport.
                //
                // IF the number of pixels from the top of `elem` to the end of the page's content is less
                // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
                // way down the page.
                //
                // This is often the case for elements near the bottom of the page.
                //
                // In such cases we do not need to scroll the whole `offset` up, just the difference between
                // the top of the element and the offset, which is enough to align the top of `elem` at the
                // desired position.
                var elemTop = elem.getBoundingClientRect().top;
                $window.scrollBy(0, elemTop - offset);
              }
            } else {
              $window.scrollTo(0, 0);
            }
          }

          function scroll(hash) {
            hash = isString(hash) ? hash : $location.hash();
            var elm;

            // empty hash, scroll to the top of the page
            if (!hash) scrollTo(null);

            // element with given id
            else if (elm = document.getElementById(hash)) scrollTo(elm);

              // first anchor with given name :-D
              else if (elm = getFirstAnchor(document.getElementsByName(hash))) scrollTo(elm);

                // no element and hash == 'top', scroll to the top of the page
                else if (hash === 'top') scrollTo(null);
          }

          // does not scroll when user clicks on anchor link that is currently on
          // (no url change, no $location.hash() change), browser native does scroll
          if (autoScrollingEnabled) {
            $rootScope.$watch(function autoScrollWatch() {
              return $location.hash();
            }, function autoScrollWatchAction(newVal, oldVal) {
              // skip the initial scroll if $location.hash is empty
              if (newVal === oldVal && newVal === '') return;

              jqLiteDocumentLoaded(function () {
                $rootScope.$evalAsync(scroll);
              });
            });
          }

          return scroll;
        }];
      }

      var $animateMinErr = minErr('$animate');
      var ELEMENT_NODE = 1;
      var NG_ANIMATE_CLASSNAME = 'ng-animate';

      function mergeClasses(a, b) {
        if (!a && !b) return '';
        if (!a) return b;
        if (!b) return a;
        if (isArray(a)) a = a.join(' ');
        if (isArray(b)) b = b.join(' ');
        return a + ' ' + b;
      }

      function extractElementNode(element) {
        for (var i = 0; i < element.length; i++) {
          var elm = element[i];
          if (elm.nodeType === ELEMENT_NODE) {
            return elm;
          }
        }
      }

      function splitClasses(classes) {
        if (isString(classes)) {
          classes = classes.split(' ');
        }

        // Use createMap() to prevent class assumptions involving property names in
        // Object.prototype
        var obj = createMap();
        forEach(classes, function (klass) {
          // sometimes the split leaves empty string values
          // incase extra spaces were applied to the options
          if (klass.length) {
            obj[klass] = true;
          }
        });
        return obj;
      }

      // if any other type of options value besides an Object value is
      // passed into the $animate.method() animation then this helper code
      // will be run which will ignore it. While this patch is not the
      // greatest solution to this, a lot of existing plugins depend on
      // $animate to either call the callback (< 1.2) or return a promise
      // that can be changed. This helper function ensures that the options
      // are wiped clean incase a callback function is provided.
      function prepareAnimateOptions(options) {
        return isObject(options) ? options : {};
      }

      var $$CoreAnimateJsProvider = function () {
        this.$get = noop;
      };

      // this is prefixed with Core since it conflicts with
      // the animateQueueProvider defined in ngAnimate/animateQueue.js
      var $$CoreAnimateQueueProvider = function () {
        var postDigestQueue = new HashMap();
        var postDigestElements = [];

        this.$get = ['$$AnimateRunner', '$rootScope', function ($$AnimateRunner, $rootScope) {
          return {
            enabled: noop,
            on: noop,
            off: noop,
            pin: noop,

            push: function (element, event, options, domOperation) {
              domOperation && domOperation();

              options = options || {};
              options.from && element.css(options.from);
              options.to && element.css(options.to);

              if (options.addClass || options.removeClass) {
                addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
              }

              var runner = new $$AnimateRunner(); // jshint ignore:line

              // since there are no animations to run the runner needs to be
              // notified that the animation call is complete.
              runner.complete();
              return runner;
            }
          };

          function updateData(data, classes, value) {
            var changed = false;
            if (classes) {
              classes = isString(classes) ? classes.split(' ') : isArray(classes) ? classes : [];
              forEach(classes, function (className) {
                if (className) {
                  changed = true;
                  data[className] = value;
                }
              });
            }
            return changed;
          }

          function handleCSSClassChanges() {
            forEach(postDigestElements, function (element) {
              var data = postDigestQueue.get(element);
              if (data) {
                var existing = splitClasses(element.attr('class'));
                var toAdd = '';
                var toRemove = '';
                forEach(data, function (status, className) {
                  var hasClass = !!existing[className];
                  if (status !== hasClass) {
                    if (status) {
                      toAdd += (toAdd.length ? ' ' : '') + className;
                    } else {
                      toRemove += (toRemove.length ? ' ' : '') + className;
                    }
                  }
                });

                forEach(element, function (elm) {
                  toAdd && jqLiteAddClass(elm, toAdd);
                  toRemove && jqLiteRemoveClass(elm, toRemove);
                });
                postDigestQueue.remove(element);
              }
            });
            postDigestElements.length = 0;
          }

          function addRemoveClassesPostDigest(element, add, remove) {
            var data = postDigestQueue.get(element) || {};

            var classesAdded = updateData(data, add, true);
            var classesRemoved = updateData(data, remove, false);

            if (classesAdded || classesRemoved) {

              postDigestQueue.put(element, data);
              postDigestElements.push(element);

              if (postDigestElements.length === 1) {
                $rootScope.$$postDigest(handleCSSClassChanges);
              }
            }
          }
        }];
      };

      /**
       * @ngdoc provider
       * @name $animateProvider
       *
       * @description
       * Default implementation of $animate that doesn't perform any animations, instead just
       * synchronously performs DOM updates and resolves the returned runner promise.
       *
       * In order to enable animations the `ngAnimate` module has to be loaded.
       *
       * To see the functional implementation check out `src/ngAnimate/animate.js`.
       */
      var $AnimateProvider = ['$provide', function ($provide) {
        var provider = this;

        this.$$registeredAnimations = Object.create(null);

        /**
        * @ngdoc method
        * @name $animateProvider#register
        *
        * @description
        * Registers a new injectable animation factory function. The factory function produces the
        * animation object which contains callback functions for each event that is expected to be
        * animated.
        *
        *   * `eventFn`: `function(element, ... , doneFunction, options)`
        *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
        *   on the type of animation additional arguments will be injected into the animation function. The
        *   list below explains the function signatures for the different animation methods:
        *
        *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
        *   - addClass: function(element, addedClasses, doneFunction, options)
        *   - removeClass: function(element, removedClasses, doneFunction, options)
        *   - enter, leave, move: function(element, doneFunction, options)
        *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
        *
        *   Make sure to trigger the `doneFunction` once the animation is fully complete.
        *
        * ```js
        *   return {
        *     //enter, leave, move signature
        *     eventFn : function(element, done, options) {
        *       //code to run the animation
        *       //once complete, then run done()
        *       return function endFunction(wasCancelled) {
        *         //code to cancel the animation
        *       }
        *     }
        *   }
        * ```
        *
        * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
        * @param {Function} factory The factory function that will be executed to return the animation
        *                           object.
        */
        this.register = function (name, factory) {
          if (name && name.charAt(0) !== '.') {
            throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
          }

          var key = name + '-animation';
          provider.$$registeredAnimations[name.substr(1)] = key;
          $provide.factory(key, factory);
        };

        /**
         * @ngdoc method
         * @name $animateProvider#classNameFilter
         *
         * @description
         * Sets and/or returns the CSS class regular expression that is checked when performing
         * an animation. Upon bootstrap the classNameFilter value is not set at all and will
         * therefore enable $animate to attempt to perform an animation on any element that is triggered.
         * When setting the `classNameFilter` value, animations will only be performed on elements
         * that successfully match the filter expression. This in turn can boost performance
         * for low-powered devices as well as applications containing a lot of structural operations.
         * @param {RegExp=} expression The className expression which will be checked against all animations
         * @return {RegExp} The current CSS className expression value. If null then there is no expression value
         */
        this.classNameFilter = function (expression) {
          if (arguments.length === 1) {
            this.$$classNameFilter = expression instanceof RegExp ? expression : null;
            if (this.$$classNameFilter) {
              var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
              if (reservedRegex.test(this.$$classNameFilter.toString())) {
                throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
              }
            }
          }
          return this.$$classNameFilter;
        };

        this.$get = ['$$animateQueue', function ($$animateQueue) {
          function domInsert(element, parentElement, afterElement) {
            // if for some reason the previous element was removed
            // from the dom sometime before this code runs then let's
            // just stick to using the parent element as the anchor
            if (afterElement) {
              var afterNode = extractElementNode(afterElement);
              if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
                afterElement = null;
              }
            }
            afterElement ? afterElement.after(element) : parentElement.prepend(element);
          }

          /**
           * @ngdoc service
           * @name $animate
           * @description The $animate service exposes a series of DOM utility methods that provide support
           * for animation hooks. The default behavior is the application of DOM operations, however,
           * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
           * to ensure that animation runs with the triggered DOM operation.
           *
           * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
           * included and only when it is active then the animation hooks that `$animate` triggers will be
           * functional. Once active then all structural `ng-` directives will trigger animations as they perform
           * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
           * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
           *
           * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
           *
           * To learn more about enabling animation support, click here to visit the
           * {@link ngAnimate ngAnimate module page}.
           */
          return {
            // we don't call it directly since non-existant arguments may
            // be interpreted as null within the sub enabled function

            /**
             *
             * @ngdoc method
             * @name $animate#on
             * @kind function
             * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
             *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
             *    is fired with the following params:
             *
             * ```js
             * $animate.on('enter', container,
             *    function callback(element, phase) {
             *      // cool we detected an enter animation within the container
             *    }
             * );
             * ```
             *
             * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
             * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
             *     as well as among its children
             * @param {Function} callback the callback function that will be fired when the listener is triggered
             *
             * The arguments present in the callback function are:
             * * `element` - The captured DOM element that the animation was fired on.
             * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
             */
            on: $$animateQueue.on,

            /**
             *
             * @ngdoc method
             * @name $animate#off
             * @kind function
             * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
             * can be used in three different ways depending on the arguments:
             *
             * ```js
             * // remove all the animation event listeners listening for `enter`
             * $animate.off('enter');
             *
             * // remove listeners for all animation events from the container element
             * $animate.off(container);
             *
             * // remove all the animation event listeners listening for `enter` on the given element and its children
             * $animate.off('enter', container);
             *
             * // remove the event listener function provided by `callback` that is set
             * // to listen for `enter` on the given `container` as well as its children
             * $animate.off('enter', container, callback);
             * ```
             *
             * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
             * addClass, removeClass, etc...), or the container element. If it is the element, all other
             * arguments are ignored.
             * @param {DOMElement=} container the container element the event listener was placed on
             * @param {Function=} callback the callback function that was registered as the listener
             */
            off: $$animateQueue.off,

            /**
             * @ngdoc method
             * @name $animate#pin
             * @kind function
             * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
             *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
             *    element despite being outside the realm of the application or within another application. Say for example if the application
             *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
             *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
             *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
             *
             *    Note that this feature is only active when the `ngAnimate` module is used.
             *
             * @param {DOMElement} element the external element that will be pinned
             * @param {DOMElement} parentElement the host parent element that will be associated with the external element
             */
            pin: $$animateQueue.pin,

            /**
             *
             * @ngdoc method
             * @name $animate#enabled
             * @kind function
             * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
             * function can be called in four ways:
             *
             * ```js
             * // returns true or false
             * $animate.enabled();
             *
             * // changes the enabled state for all animations
             * $animate.enabled(false);
             * $animate.enabled(true);
             *
             * // returns true or false if animations are enabled for an element
             * $animate.enabled(element);
             *
             * // changes the enabled state for an element and its children
             * $animate.enabled(element, true);
             * $animate.enabled(element, false);
             * ```
             *
             * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
             * @param {boolean=} enabled whether or not the animations will be enabled for the element
             *
             * @return {boolean} whether or not animations are enabled
             */
            enabled: $$animateQueue.enabled,

            /**
             * @ngdoc method
             * @name $animate#cancel
             * @kind function
             * @description Cancels the provided animation.
             *
             * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
             */
            cancel: function (runner) {
              runner.end && runner.end();
            },

            /**
             *
             * @ngdoc method
             * @name $animate#enter
             * @kind function
             * @description Inserts the element into the DOM either after the `after` element (if provided) or
             *   as the first child within the `parent` element and then triggers an animation.
             *   A promise is returned that will be resolved during the next digest once the animation
             *   has completed.
             *
             * @param {DOMElement} element the element which will be inserted into the DOM
             * @param {DOMElement} parent the parent element which will append the element as
             *   a child (so long as the after element is not present)
             * @param {DOMElement=} after the sibling element after which the element will be appended
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            enter: function (element, parent, after, options) {
              parent = parent && jqLite(parent);
              after = after && jqLite(after);
              parent = parent || after.parent();
              domInsert(element, parent, after);
              return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
            },

            /**
             *
             * @ngdoc method
             * @name $animate#move
             * @kind function
             * @description Inserts (moves) the element into its new position in the DOM either after
             *   the `after` element (if provided) or as the first child within the `parent` element
             *   and then triggers an animation. A promise is returned that will be resolved
             *   during the next digest once the animation has completed.
             *
             * @param {DOMElement} element the element which will be moved into the new DOM position
             * @param {DOMElement} parent the parent element which will append the element as
             *   a child (so long as the after element is not present)
             * @param {DOMElement=} after the sibling element after which the element will be appended
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            move: function (element, parent, after, options) {
              parent = parent && jqLite(parent);
              after = after && jqLite(after);
              parent = parent || after.parent();
              domInsert(element, parent, after);
              return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
            },

            /**
             * @ngdoc method
             * @name $animate#leave
             * @kind function
             * @description Triggers an animation and then removes the element from the DOM.
             * When the function is called a promise is returned that will be resolved during the next
             * digest once the animation has completed.
             *
             * @param {DOMElement} element the element which will be removed from the DOM
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            leave: function (element, options) {
              return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function () {
                element.remove();
              });
            },

            /**
             * @ngdoc method
             * @name $animate#addClass
             * @kind function
             *
             * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
             *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
             *   animation if element already contains the CSS class or if the class is removed at a later step.
             *   Note that class-based animations are treated differently compared to structural animations
             *   (like enter, move and leave) since the CSS classes may be added/removed at different points
             *   depending if CSS or JavaScript animations are used.
             *
             * @param {DOMElement} element the element which the CSS classes will be applied to
             * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            addClass: function (element, className, options) {
              options = prepareAnimateOptions(options);
              options.addClass = mergeClasses(options.addclass, className);
              return $$animateQueue.push(element, 'addClass', options);
            },

            /**
             * @ngdoc method
             * @name $animate#removeClass
             * @kind function
             *
             * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
             *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
             *   animation if element does not contain the CSS class or if the class is added at a later step.
             *   Note that class-based animations are treated differently compared to structural animations
             *   (like enter, move and leave) since the CSS classes may be added/removed at different points
             *   depending if CSS or JavaScript animations are used.
             *
             * @param {DOMElement} element the element which the CSS classes will be applied to
             * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            removeClass: function (element, className, options) {
              options = prepareAnimateOptions(options);
              options.removeClass = mergeClasses(options.removeClass, className);
              return $$animateQueue.push(element, 'removeClass', options);
            },

            /**
             * @ngdoc method
             * @name $animate#setClass
             * @kind function
             *
             * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
             *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
             *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
             *    passed. Note that class-based animations are treated differently compared to structural animations
             *    (like enter, move and leave) since the CSS classes may be added/removed at different points
             *    depending if CSS or JavaScript animations are used.
             *
             * @param {DOMElement} element the element which the CSS classes will be applied to
             * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
             * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            setClass: function (element, add, remove, options) {
              options = prepareAnimateOptions(options);
              options.addClass = mergeClasses(options.addClass, add);
              options.removeClass = mergeClasses(options.removeClass, remove);
              return $$animateQueue.push(element, 'setClass', options);
            },

            /**
             * @ngdoc method
             * @name $animate#animate
             * @kind function
             *
             * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
             * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
             * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
             * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
             * style in `to`, the style in `from` is applied immediately, and no animation is run.
             * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
             * method (or as part of the `options` parameter):
             *
             * ```js
             * ngModule.animation('.my-inline-animation', function() {
             *   return {
             *     animate : function(element, from, to, done, options) {
             *       //animation
             *       done();
             *     }
             *   }
             * });
             * ```
             *
             * @param {DOMElement} element the element which the CSS styles will be applied to
             * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
             * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
             * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
             *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
             *    (Note that if no animation is detected then this value will not be applied to the element.)
             * @param {object=} options an optional collection of options/styles that will be applied to the element.
             *   The object can have the following properties:
             *
             *   - **addClass** - `{string}` - space-separated CSS classes to add to element
             *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
             *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
             *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
             *
             * @return {Promise} the animation callback promise
             */
            animate: function (element, from, to, className, options) {
              options = prepareAnimateOptions(options);
              options.from = options.from ? extend(options.from, from) : from;
              options.to = options.to ? extend(options.to, to) : to;

              className = className || 'ng-inline-animate';
              options.tempClasses = mergeClasses(options.tempClasses, className);
              return $$animateQueue.push(element, 'animate', options);
            }
          };
        }];
      }];

      var $$AnimateAsyncRunFactoryProvider = function () {
        this.$get = ['$$rAF', function ($$rAF) {
          var waitQueue = [];

          function waitForTick(fn) {
            waitQueue.push(fn);
            if (waitQueue.length > 1) return;
            $$rAF(function () {
              for (var i = 0; i < waitQueue.length; i++) {
                waitQueue[i]();
              }
              waitQueue = [];
            });
          }

          return function () {
            var passed = false;
            waitForTick(function () {
              passed = true;
            });
            return function (callback) {
              passed ? callback() : waitForTick(callback);
            };
          };
        }];
      };

      var $$AnimateRunnerFactoryProvider = function () {
        this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout', function ($q, $sniffer, $$animateAsyncRun, $document, $timeout) {

          var INITIAL_STATE = 0;
          var DONE_PENDING_STATE = 1;
          var DONE_COMPLETE_STATE = 2;

          AnimateRunner.chain = function (chain, callback) {
            var index = 0;

            next();
            function next() {
              if (index === chain.length) {
                callback(true);
                return;
              }

              chain[index](function (response) {
                if (response === false) {
                  callback(false);
                  return;
                }
                index++;
                next();
              });
            }
          };

          AnimateRunner.all = function (runners, callback) {
            var count = 0;
            var status = true;
            forEach(runners, function (runner) {
              runner.done(onProgress);
            });

            function onProgress(response) {
              status = status && response;
              if (++count === runners.length) {
                callback(status);
              }
            }
          };

          function AnimateRunner(host) {
            this.setHost(host);

            var rafTick = $$animateAsyncRun();
            var timeoutTick = function (fn) {
              $timeout(fn, 0, false);
            };

            this._doneCallbacks = [];
            this._tick = function (fn) {
              var doc = $document[0];

              // the document may not be ready or attached
              // to the module for some internal tests
              if (doc && doc.hidden) {
                timeoutTick(fn);
              } else {
                rafTick(fn);
              }
            };
            this._state = 0;
          }

          AnimateRunner.prototype = {
            setHost: function (host) {
              this.host = host || {};
            },

            done: function (fn) {
              if (this._state === DONE_COMPLETE_STATE) {
                fn();
              } else {
                this._doneCallbacks.push(fn);
              }
            },

            progress: noop,

            getPromise: function () {
              if (!this.promise) {
                var self = this;
                this.promise = $q(function (resolve, reject) {
                  self.done(function (status) {
                    status === false ? reject() : resolve();
                  });
                });
              }
              return this.promise;
            },

            then: function (resolveHandler, rejectHandler) {
              return this.getPromise().then(resolveHandler, rejectHandler);
            },

            'catch': function (handler) {
              return this.getPromise()['catch'](handler);
            },

            'finally': function (handler) {
              return this.getPromise()['finally'](handler);
            },

            pause: function () {
              if (this.host.pause) {
                this.host.pause();
              }
            },

            resume: function () {
              if (this.host.resume) {
                this.host.resume();
              }
            },

            end: function () {
              if (this.host.end) {
                this.host.end();
              }
              this._resolve(true);
            },

            cancel: function () {
              if (this.host.cancel) {
                this.host.cancel();
              }
              this._resolve(false);
            },

            complete: function (response) {
              var self = this;
              if (self._state === INITIAL_STATE) {
                self._state = DONE_PENDING_STATE;
                self._tick(function () {
                  self._resolve(response);
                });
              }
            },

            _resolve: function (response) {
              if (this._state !== DONE_COMPLETE_STATE) {
                forEach(this._doneCallbacks, function (fn) {
                  fn(response);
                });
                this._doneCallbacks.length = 0;
                this._state = DONE_COMPLETE_STATE;
              }
            }
          };

          return AnimateRunner;
        }];
      };

      /**
       * @ngdoc service
       * @name $animateCss
       * @kind object
       *
       * @description
       * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
       * then the `$animateCss` service will actually perform animations.
       *
       * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
       */
      var $CoreAnimateCssProvider = function () {
        this.$get = ['$$rAF', '$q', '$$AnimateRunner', function ($$rAF, $q, $$AnimateRunner) {

          return function (element, initialOptions) {
            // all of the animation functions should create
            // a copy of the options data, however, if a
            // parent service has already created a copy then
            // we should stick to using that
            var options = initialOptions || {};
            if (!options.$$prepared) {
              options = copy(options);
            }

            // there is no point in applying the styles since
            // there is no animation that goes on at all in
            // this version of $animateCss.
            if (options.cleanupStyles) {
              options.from = options.to = null;
            }

            if (options.from) {
              element.css(options.from);
              options.from = null;
            }

            /* jshint newcap: false */
            var closed,
                runner = new $$AnimateRunner();
            return {
              start: run,
              end: run
            };

            function run() {
              $$rAF(function () {
                applyAnimationContents();
                if (!closed) {
                  runner.complete();
                }
                closed = true;
              });
              return runner;
            }

            function applyAnimationContents() {
              if (options.addClass) {
                element.addClass(options.addClass);
                options.addClass = null;
              }
              if (options.removeClass) {
                element.removeClass(options.removeClass);
                options.removeClass = null;
              }
              if (options.to) {
                element.css(options.to);
                options.to = null;
              }
            }
          };
        }];
      };

      /* global stripHash: true */

      /**
       * ! This is a private undocumented service !
       *
       * @name $browser
       * @requires $log
       * @description
       * This object has two goals:
       *
       * - hide all the global state in the browser caused by the window object
       * - abstract away all the browser specific features and inconsistencies
       *
       * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
       * service, which can be used for convenient testing of the application without the interaction with
       * the real browser apis.
       */
      /**
       * @param {object} window The global window object.
       * @param {object} document jQuery wrapped document.
       * @param {object} $log window.console or an object with the same interface.
       * @param {object} $sniffer $sniffer service
       */
      function Browser(window, document, $log, $sniffer) {
        var self = this,
            location = window.location,
            history = window.history,
            setTimeout = window.setTimeout,
            clearTimeout = window.clearTimeout,
            pendingDeferIds = {};

        self.isMock = false;

        var outstandingRequestCount = 0;
        var outstandingRequestCallbacks = [];

        // TODO(vojta): remove this temporary api
        self.$$completeOutstandingRequest = completeOutstandingRequest;
        self.$$incOutstandingRequestCount = function () {
          outstandingRequestCount++;
        };

        /**
         * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
         * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
         */
        function completeOutstandingRequest(fn) {
          try {
            fn.apply(null, sliceArgs(arguments, 1));
          } finally {
            outstandingRequestCount--;
            if (outstandingRequestCount === 0) {
              while (outstandingRequestCallbacks.length) {
                try {
                  outstandingRequestCallbacks.pop()();
                } catch (e) {
                  $log.error(e);
                }
              }
            }
          }
        }

        function getHash(url) {
          var index = url.indexOf('#');
          return index === -1 ? '' : url.substr(index);
        }

        /**
         * @private
         * Note: this method is used only by scenario runner
         * TODO(vojta): prefix this method with $$ ?
         * @param {function()} callback Function that will be called when no outstanding request
         */
        self.notifyWhenNoOutstandingRequests = function (callback) {
          if (outstandingRequestCount === 0) {
            callback();
          } else {
            outstandingRequestCallbacks.push(callback);
          }
        };

        //////////////////////////////////////////////////////////////
        // URL API
        //////////////////////////////////////////////////////////////

        var cachedState,
            lastHistoryState,
            lastBrowserUrl = location.href,
            baseElement = document.find('base'),
            pendingLocation = null,
            getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
          try {
            return history.state;
          } catch (e) {
            // MSIE can reportedly throw when there is no state (UNCONFIRMED).
          }
        };

        cacheState();
        lastHistoryState = cachedState;

        /**
         * @name $browser#url
         *
         * @description
         * GETTER:
         * Without any argument, this method just returns current value of location.href.
         *
         * SETTER:
         * With at least one argument, this method sets url to new value.
         * If html5 history api supported, pushState/replaceState is used, otherwise
         * location.href/location.replace is used.
         * Returns its own instance to allow chaining
         *
         * NOTE: this api is intended for use only by the $location service. Please use the
         * {@link ng.$location $location service} to change url.
         *
         * @param {string} url New url (when used as setter)
         * @param {boolean=} replace Should new url replace current history record?
         * @param {object=} state object to use with pushState/replaceState
         */
        self.url = function (url, replace, state) {
          // In modern browsers `history.state` is `null` by default; treating it separately
          // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
          // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
          if (isUndefined(state)) {
            state = null;
          }

          // Android Browser BFCache causes location, history reference to become stale.
          if (location !== window.location) location = window.location;
          if (history !== window.history) history = window.history;

          // setter
          if (url) {
            var sameState = lastHistoryState === state;

            // Don't change anything if previous and current URLs and states match. This also prevents
            // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
            // See https://github.com/angular/angular.js/commit/ffb2701
            if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
              return self;
            }
            var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
            lastBrowserUrl = url;
            lastHistoryState = state;
            // Don't use history API if only the hash changed
            // due to a bug in IE10/IE11 which leads
            // to not firing a `hashchange` nor `popstate` event
            // in some cases (see #9143).
            if ($sniffer.history && (!sameBase || !sameState)) {
              history[replace ? 'replaceState' : 'pushState'](state, '', url);
              cacheState();
              // Do the assignment again so that those two variables are referentially identical.
              lastHistoryState = cachedState;
            } else {
              if (!sameBase) {
                pendingLocation = url;
              }
              if (replace) {
                location.replace(url);
              } else if (!sameBase) {
                location.href = url;
              } else {
                location.hash = getHash(url);
              }
              if (location.href !== url) {
                pendingLocation = url;
              }
            }
            if (pendingLocation) {
              pendingLocation = url;
            }
            return self;
            // getter
          } else {
            // - pendingLocation is needed as browsers don't allow to read out
            //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
            //   https://openradar.appspot.com/22186109).
            // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
            return pendingLocation || location.href.replace(/%27/g, "'");
          }
        };

        /**
         * @name $browser#state
         *
         * @description
         * This method is a getter.
         *
         * Return history.state or null if history.state is undefined.
         *
         * @returns {object} state
         */
        self.state = function () {
          return cachedState;
        };

        var urlChangeListeners = [],
            urlChangeInit = false;

        function cacheStateAndFireUrlChange() {
          pendingLocation = null;
          cacheState();
          fireUrlChange();
        }

        // This variable should be used *only* inside the cacheState function.
        var lastCachedState = null;
        function cacheState() {
          // This should be the only place in $browser where `history.state` is read.
          cachedState = getCurrentState();
          cachedState = isUndefined(cachedState) ? null : cachedState;

          // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
          if (equals(cachedState, lastCachedState)) {
            cachedState = lastCachedState;
          }
          lastCachedState = cachedState;
        }

        function fireUrlChange() {
          if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
            return;
          }

          lastBrowserUrl = self.url();
          lastHistoryState = cachedState;
          forEach(urlChangeListeners, function (listener) {
            listener(self.url(), cachedState);
          });
        }

        /**
         * @name $browser#onUrlChange
         *
         * @description
         * Register callback function that will be called, when url changes.
         *
         * It's only called when the url is changed from outside of angular:
         * - user types different url into address bar
         * - user clicks on history (forward/back) button
         * - user clicks on a link
         *
         * It's not called when url is changed by $browser.url() method
         *
         * The listener gets called with new url as parameter.
         *
         * NOTE: this api is intended for use only by the $location service. Please use the
         * {@link ng.$location $location service} to monitor url changes in angular apps.
         *
         * @param {function(string)} listener Listener function to be called when url changes.
         * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
         */
        self.onUrlChange = function (callback) {
          // TODO(vojta): refactor to use node's syntax for events
          if (!urlChangeInit) {
            // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
            // don't fire popstate when user change the address bar and don't fire hashchange when url
            // changed by push/replaceState

            // html5 history api - popstate event
            if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
            // hashchange event
            jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

            urlChangeInit = true;
          }

          urlChangeListeners.push(callback);
          return callback;
        };

        /**
         * @private
         * Remove popstate and hashchange handler from window.
         *
         * NOTE: this api is intended for use only by $rootScope.
         */
        self.$$applicationDestroyed = function () {
          jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
        };

        /**
         * Checks whether the url has changed outside of Angular.
         * Needs to be exported to be able to check for changes that have been done in sync,
         * as hashchange/popstate events fire in async.
         */
        self.$$checkUrlChange = fireUrlChange;

        //////////////////////////////////////////////////////////////
        // Misc API
        //////////////////////////////////////////////////////////////

        /**
         * @name $browser#baseHref
         *
         * @description
         * Returns current <base href>
         * (always relative - without domain)
         *
         * @returns {string} The current base href
         */
        self.baseHref = function () {
          var href = baseElement.attr('href');
          return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
        };

        /**
         * @name $browser#defer
         * @param {function()} fn A function, who's execution should be deferred.
         * @param {number=} [delay=0] of milliseconds to defer the function execution.
         * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
         *
         * @description
         * Executes a fn asynchronously via `setTimeout(fn, delay)`.
         *
         * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
         * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
         * via `$browser.defer.flush()`.
         *
         */
        self.defer = function (fn, delay) {
          var timeoutId;
          outstandingRequestCount++;
          timeoutId = setTimeout(function () {
            delete pendingDeferIds[timeoutId];
            completeOutstandingRequest(fn);
          }, delay || 0);
          pendingDeferIds[timeoutId] = true;
          return timeoutId;
        };

        /**
         * @name $browser#defer.cancel
         *
         * @description
         * Cancels a deferred task identified with `deferId`.
         *
         * @param {*} deferId Token returned by the `$browser.defer` function.
         * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
         *                    canceled.
         */
        self.defer.cancel = function (deferId) {
          if (pendingDeferIds[deferId]) {
            delete pendingDeferIds[deferId];
            clearTimeout(deferId);
            completeOutstandingRequest(noop);
            return true;
          }
          return false;
        };
      }

      function $BrowserProvider() {
        this.$get = ['$window', '$log', '$sniffer', '$document', function ($window, $log, $sniffer, $document) {
          return new Browser($window, $document, $log, $sniffer);
        }];
      }

      /**
       * @ngdoc service
       * @name $cacheFactory
       *
       * @description
       * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
       * them.
       *
       * ```js
       *
       *  var cache = $cacheFactory('cacheId');
       *  expect($cacheFactory.get('cacheId')).toBe(cache);
       *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
       *
       *  cache.put("key", "value");
       *  cache.put("another key", "another value");
       *
       *  // We've specified no options on creation
       *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
       *
       * ```
       *
       *
       * @param {string} cacheId Name or id of the newly created cache.
       * @param {object=} options Options object that specifies the cache behavior. Properties:
       *
       *   - `{number=}` `capacity` — turns the cache into LRU cache.
       *
       * @returns {object} Newly created cache object with the following set of methods:
       *
       * - `{object}` `info()` — Returns id, size, and options of cache.
       * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
       *   it.
       * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
       * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
       * - `{void}` `removeAll()` — Removes all cached values.
       * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
       *
       * @example
         <example module="cacheExampleApp">
           <file name="index.html">
             <div ng-controller="CacheController">
               <input ng-model="newCacheKey" placeholder="Key">
               <input ng-model="newCacheValue" placeholder="Value">
               <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
      
               <p ng-if="keys.length">Cached Values</p>
               <div ng-repeat="key in keys">
                 <span ng-bind="key"></span>
                 <span>: </span>
                 <b ng-bind="cache.get(key)"></b>
               </div>
      
               <p>Cache Info</p>
               <div ng-repeat="(key, value) in cache.info()">
                 <span ng-bind="key"></span>
                 <span>: </span>
                 <b ng-bind="value"></b>
               </div>
             </div>
           </file>
           <file name="script.js">
             angular.module('cacheExampleApp', []).
               controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
                 $scope.keys = [];
                 $scope.cache = $cacheFactory('cacheId');
                 $scope.put = function(key, value) {
                   if (angular.isUndefined($scope.cache.get(key))) {
                     $scope.keys.push(key);
                   }
                   $scope.cache.put(key, angular.isUndefined(value) ? null : value);
                 };
               }]);
           </file>
           <file name="style.css">
             p {
               margin: 10px 0 3px;
             }
           </file>
         </example>
       */
      function $CacheFactoryProvider() {

        this.$get = function () {
          var caches = {};

          function cacheFactory(cacheId, options) {
            if (cacheId in caches) {
              throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
            }

            var size = 0,
                stats = extend({}, options, { id: cacheId }),
                data = createMap(),
                capacity = options && options.capacity || Number.MAX_VALUE,
                lruHash = createMap(),
                freshEnd = null,
                staleEnd = null;

            /**
             * @ngdoc type
             * @name $cacheFactory.Cache
             *
             * @description
             * A cache object used to store and retrieve data, primarily used by
             * {@link $http $http} and the {@link ng.directive:script script} directive to cache
             * templates and other data.
             *
             * ```js
             *  angular.module('superCache')
             *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
             *      return $cacheFactory('super-cache');
             *    }]);
             * ```
             *
             * Example test:
             *
             * ```js
             *  it('should behave like a cache', inject(function(superCache) {
             *    superCache.put('key', 'value');
             *    superCache.put('another key', 'another value');
             *
             *    expect(superCache.info()).toEqual({
             *      id: 'super-cache',
             *      size: 2
             *    });
             *
             *    superCache.remove('another key');
             *    expect(superCache.get('another key')).toBeUndefined();
             *
             *    superCache.removeAll();
             *    expect(superCache.info()).toEqual({
             *      id: 'super-cache',
             *      size: 0
             *    });
             *  }));
             * ```
             */
            return caches[cacheId] = {

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#put
               * @kind function
               *
               * @description
               * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
               * retrieved later, and incrementing the size of the cache if the key was not already
               * present in the cache. If behaving like an LRU cache, it will also remove stale
               * entries from the set.
               *
               * It will not insert undefined values into the cache.
               *
               * @param {string} key the key under which the cached data is stored.
               * @param {*} value the value to store alongside the key. If it is undefined, the key
               *    will not be stored.
               * @returns {*} the value stored.
               */
              put: function (key, value) {
                if (isUndefined(value)) return;
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key] || (lruHash[key] = { key: key });

                  refresh(lruEntry);
                }

                if (!(key in data)) size++;
                data[key] = value;

                if (size > capacity) {
                  this.remove(staleEnd.key);
                }

                return value;
              },

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#get
               * @kind function
               *
               * @description
               * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
               *
               * @param {string} key the key of the data to be retrieved
               * @returns {*} the value stored.
               */
              get: function (key) {
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key];

                  if (!lruEntry) return;

                  refresh(lruEntry);
                }

                return data[key];
              },

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#remove
               * @kind function
               *
               * @description
               * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
               *
               * @param {string} key the key of the entry to be removed
               */
              remove: function (key) {
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key];

                  if (!lruEntry) return;

                  if (lruEntry == freshEnd) freshEnd = lruEntry.p;
                  if (lruEntry == staleEnd) staleEnd = lruEntry.n;
                  link(lruEntry.n, lruEntry.p);

                  delete lruHash[key];
                }

                if (!(key in data)) return;

                delete data[key];
                size--;
              },

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#removeAll
               * @kind function
               *
               * @description
               * Clears the cache object of any entries.
               */
              removeAll: function () {
                data = createMap();
                size = 0;
                lruHash = createMap();
                freshEnd = staleEnd = null;
              },

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#destroy
               * @kind function
               *
               * @description
               * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
               * removing it from the {@link $cacheFactory $cacheFactory} set.
               */
              destroy: function () {
                data = null;
                stats = null;
                lruHash = null;
                delete caches[cacheId];
              },

              /**
               * @ngdoc method
               * @name $cacheFactory.Cache#info
               * @kind function
               *
               * @description
               * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
               *
               * @returns {object} an object with the following properties:
               *   <ul>
               *     <li>**id**: the id of the cache instance</li>
               *     <li>**size**: the number of entries kept in the cache instance</li>
               *     <li>**...**: any additional properties from the options object when creating the
               *       cache.</li>
               *   </ul>
               */
              info: function () {
                return extend({}, stats, { size: size });
              }
            };

            /**
             * makes the `entry` the freshEnd of the LRU linked list
             */
            function refresh(entry) {
              if (entry != freshEnd) {
                if (!staleEnd) {
                  staleEnd = entry;
                } else if (staleEnd == entry) {
                  staleEnd = entry.n;
                }

                link(entry.n, entry.p);
                link(entry, freshEnd);
                freshEnd = entry;
                freshEnd.n = null;
              }
            }

            /**
             * bidirectionally links two entries of the LRU linked list
             */
            function link(nextEntry, prevEntry) {
              if (nextEntry != prevEntry) {
                if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
                if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
              }
            }
          }

          /**
           * @ngdoc method
           * @name $cacheFactory#info
           *
           * @description
           * Get information about all the caches that have been created
           *
           * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
           */
          cacheFactory.info = function () {
            var info = {};
            forEach(caches, function (cache, cacheId) {
              info[cacheId] = cache.info();
            });
            return info;
          };

          /**
           * @ngdoc method
           * @name $cacheFactory#get
           *
           * @description
           * Get access to a cache object by the `cacheId` used when it was created.
           *
           * @param {string} cacheId Name or id of a cache to access.
           * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
           */
          cacheFactory.get = function (cacheId) {
            return caches[cacheId];
          };

          return cacheFactory;
        };
      }

      /**
       * @ngdoc service
       * @name $templateCache
       *
       * @description
       * The first time a template is used, it is loaded in the template cache for quick retrieval. You
       * can load templates directly into the cache in a `script` tag, or by consuming the
       * `$templateCache` service directly.
       *
       * Adding via the `script` tag:
       *
       * ```html
       *   <script type="text/ng-template" id="templateId.html">
       *     <p>This is the content of the template</p>
       *   </script>
       * ```
       *
       * **Note:** the `script` tag containing the template does not need to be included in the `head` of
       * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
       * element with ng-app attribute), otherwise the template will be ignored.
       *
       * Adding via the `$templateCache` service:
       *
       * ```js
       * var myApp = angular.module('myApp', []);
       * myApp.run(function($templateCache) {
       *   $templateCache.put('templateId.html', 'This is the content of the template');
       * });
       * ```
       *
       * To retrieve the template later, simply use it in your HTML:
       * ```html
       * <div ng-include=" 'templateId.html' "></div>
       * ```
       *
       * or get it via Javascript:
       * ```js
       * $templateCache.get('templateId.html')
       * ```
       *
       * See {@link ng.$cacheFactory $cacheFactory}.
       *
       */
      function $TemplateCacheProvider() {
        this.$get = ['$cacheFactory', function ($cacheFactory) {
          return $cacheFactory('templates');
        }];
      }

      /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
       *     Any commits to this file should be reviewed with security in mind.  *
       *   Changes to this file can potentially create security vulnerabilities. *
       *          An approval from 2 Core members with history of modifying      *
       *                         this file is required.                          *
       *                                                                         *
       *  Does the change somehow allow for arbitrary javascript to be executed? *
       *    Or allows for someone to change the prototype of built-in objects?   *
       *     Or gives undesired access to variables likes document or window?    *
       * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

      /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
       *
       * DOM-related variables:
       *
       * - "node" - DOM Node
       * - "element" - DOM Element or Node
       * - "$node" or "$element" - jqLite-wrapped node or element
       *
       *
       * Compiler related stuff:
       *
       * - "linkFn" - linking fn of a single directive
       * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
       * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
       * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
       */

      /**
       * @ngdoc service
       * @name $compile
       * @kind function
       *
       * @description
       * Compiles an HTML string or DOM into a template and produces a template function, which
       * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
       *
       * The compilation is a process of walking the DOM tree and matching DOM elements to
       * {@link ng.$compileProvider#directive directives}.
       *
       * <div class="alert alert-warning">
       * **Note:** This document is an in-depth reference of all directive options.
       * For a gentle introduction to directives with examples of common use cases,
       * see the {@link guide/directive directive guide}.
       * </div>
       *
       * ## Comprehensive Directive API
       *
       * There are many different options for a directive.
       *
       * The difference resides in the return value of the factory function.
       * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
       * that defines the directive properties, or just the `postLink` function (all other properties will have
       * the default values).
       *
       * <div class="alert alert-success">
       * **Best Practice:** It's recommended to use the "directive definition object" form.
       * </div>
       *
       * Here's an example directive declared with a Directive Definition Object:
       *
       * ```js
       *   var myModule = angular.module(...);
       *
       *   myModule.directive('directiveName', function factory(injectables) {
       *     var directiveDefinitionObject = {
       *       priority: 0,
       *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
       *       // or
       *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
       *       transclude: false,
       *       restrict: 'A',
       *       templateNamespace: 'html',
       *       scope: false,
       *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
       *       controllerAs: 'stringIdentifier',
       *       bindToController: false,
       *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
       *       compile: function compile(tElement, tAttrs, transclude) {
       *         return {
       *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
       *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
       *         }
       *         // or
       *         // return function postLink( ... ) { ... }
       *       },
       *       // or
       *       // link: {
       *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
       *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
       *       // }
       *       // or
       *       // link: function postLink( ... ) { ... }
       *     };
       *     return directiveDefinitionObject;
       *   });
       * ```
       *
       * <div class="alert alert-warning">
       * **Note:** Any unspecified options will use the default value. You can see the default values below.
       * </div>
       *
       * Therefore the above can be simplified as:
       *
       * ```js
       *   var myModule = angular.module(...);
       *
       *   myModule.directive('directiveName', function factory(injectables) {
       *     var directiveDefinitionObject = {
       *       link: function postLink(scope, iElement, iAttrs) { ... }
       *     };
       *     return directiveDefinitionObject;
       *     // or
       *     // return function postLink(scope, iElement, iAttrs) { ... }
       *   });
       * ```
       *
       * ### Life-cycle hooks
       * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
       * directive:
       * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
       *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
       *   this element). This is a good place to put initialization code for your controller.
       * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
       *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
       *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
       *   component such as cloning the bound value to prevent accidental mutation of the outer value.
       * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
       *   changes. Any actions that you wish to take in response to the changes that you detect must be
       *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
       *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
       *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
       *   if detecting changes, you must store the previous value(s) for comparison to the current values.
       * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
       *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
       *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
       *   components will have their `$onDestroy()` hook called before child components.
       * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
       *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
       *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
       *   they are waiting for their template to load asynchronously and their own compilation and linking has been
       *   suspended until that occurs.
       *
       * #### Comparison with Angular 2 life-cycle hooks
       * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
       * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
       *
       * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
       * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
       *   In Angular 2 you can only define hooks on the prototype of the Component class.
       * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
       *   `ngDoCheck` in Angular 2
       * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
       *   propagated throughout the application.
       *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
       *   error or do nothing depending upon the state of `enableProdMode()`.
       *
       * #### Life-cycle hook examples
       *
       * This example shows how you can check for mutations to a Date object even though the identity of the object
       * has not changed.
       *
       * <example name="doCheckDateExample" module="do-check-module">
       *   <file name="app.js">
       *     angular.module('do-check-module', [])
       *       .component('app', {
       *         template:
       *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
       *           'Date: {{ $ctrl.date }}' +
       *           '<test date="$ctrl.date"></test>',
       *         controller: function() {
       *           this.date = new Date();
       *           this.month = this.date.getMonth();
       *           this.updateDate = function() {
       *             this.date.setMonth(this.month);
       *           };
       *         }
       *       })
       *       .component('test', {
       *         bindings: { date: '<' },
       *         template:
       *           '<pre>{{ $ctrl.log | json }}</pre>',
       *         controller: function() {
       *           var previousValue;
       *           this.log = [];
       *           this.$doCheck = function() {
       *             var currentValue = this.date && this.date.valueOf();
       *             if (previousValue !== currentValue) {
       *               this.log.push('doCheck: date mutated: ' + this.date);
       *               previousValue = currentValue;
       *             }
       *           };
       *         }
       *       });
       *   </file>
       *   <file name="index.html">
       *     <app></app>
       *   </file>
       * </example>
       *
       * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
       * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
       * arrays or objects can have a negative impact on your application performance)
       *
       * <example name="doCheckArrayExample" module="do-check-module">
       *   <file name="index.html">
       *     <div ng-init="items = []">
       *       <button ng-click="items.push(items.length)">Add Item</button>
       *       <button ng-click="items = []">Reset Items</button>
       *       <pre>{{ items }}</pre>
       *       <test items="items"></test>
       *     </div>
       *   </file>
       *   <file name="app.js">
       *      angular.module('do-check-module', [])
       *        .component('test', {
       *          bindings: { items: '<' },
       *          template:
       *            '<pre>{{ $ctrl.log | json }}</pre>',
       *          controller: function() {
       *            this.log = [];
       *
       *            this.$doCheck = function() {
       *              if (this.items_ref !== this.items) {
       *                this.log.push('doCheck: items changed');
       *                this.items_ref = this.items;
       *              }
       *              if (!angular.equals(this.items_clone, this.items)) {
       *                this.log.push('doCheck: items mutated');
       *                this.items_clone = angular.copy(this.items);
       *              }
       *            };
       *          }
       *        });
       *   </file>
       * </example>
       *
       *
       * ### Directive Definition Object
       *
       * The directive definition object provides instructions to the {@link ng.$compile
       * compiler}. The attributes are:
       *
       * #### `multiElement`
       * When this property is set to true, the HTML compiler will collect DOM nodes between
       * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
       * together as the directive elements. It is recommended that this feature be used on directives
       * which are not strictly behavioral (such as {@link ngClick}), and which
       * do not manipulate or replace child nodes (such as {@link ngInclude}).
       *
       * #### `priority`
       * When there are multiple directives defined on a single DOM element, sometimes it
       * is necessary to specify the order in which the directives are applied. The `priority` is used
       * to sort the directives before their `compile` functions get called. Priority is defined as a
       * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
       * are also run in priority order, but post-link functions are run in reverse order. The order
       * of directives with the same priority is undefined. The default priority is `0`.
       *
       * #### `terminal`
       * If set to true then the current `priority` will be the last set of directives
       * which will execute (any directives at the current priority will still execute
       * as the order of execution on same `priority` is undefined). Note that expressions
       * and other directives used in the directive's template will also be excluded from execution.
       *
       * #### `scope`
       * The scope property can be `true`, an object or a falsy value:
       *
       * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
       *
       * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
       * the directive's element. If multiple directives on the same element request a new scope,
       * only one new scope is created. The new scope rule does not apply for the root of the template
       * since the root of the template always gets a new scope.
       *
       * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
       * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
       * scope. This is useful when creating reusable components, which should not accidentally read or modify
       * data in the parent scope.
       *
       * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
       * directive's element. These local properties are useful for aliasing values for templates. The keys in
       * the object hash map to the name of the property on the isolate scope; the values define how the property
       * is bound to the parent scope, via matching attributes on the directive's element:
       *
       * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
       *   always a string since DOM attributes are strings. If no `attr` name is specified then the
       *   attribute name is assumed to be the same as the local name. Given `<my-component
       *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
       *   the directive's scope property `localName` will reflect the interpolated value of `hello
       *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
       *   scope. The `name` is read from the parent scope (not the directive's scope).
       *
       * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
       *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
       *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
       *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
       *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
       *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
       *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
       *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
       *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
       *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
       *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
       *   method is used for tracking changes, and the equality check is based on object identity.
       *   However, if an object literal or an array literal is passed as the binding expression, the
       *   equality check is done by value (using the {@link angular.equals} function). It's also possible
       *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
       *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
       *
        * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
       *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
       *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
       *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
       *
       *   For example, given `<my-component my-attr="parentModel">` and directive definition of
       *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
       *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
       *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
       *   two caveats:
       *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
       *     sets the same value. That means if your bound value is an object, changes to its properties
       *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
       *     2. one-way binding watches changes to the **identity** of the parent value. That means the
       *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
       *     to the value has changed. In most cases, this should not be of concern, but can be important
       *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
       *     If you now change a property of the object in your parent scope, the change will not be
       *     propagated to the isolated scope, because the identity of the object on the parent scope
       *     has not changed. Instead you must assign a new object.
       *
       *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
       *   back to the parent. However, it does not make this completely impossible.
       *
       * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
       *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
       *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
       *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
       *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
       *   via an expression to the parent scope. This can be done by passing a map of local variable names
       *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
       *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
       *
       * In general it's possible to apply more than one directive to one element, but there might be limitations
       * depending on the type of scope required by the directives. The following points will help explain these limitations.
       * For simplicity only two directives are taken into account, but it is also applicable for several directives:
       *
       * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
       * * **child scope** + **no scope** =>  Both directives will share one single child scope
       * * **child scope** + **child scope** =>  Both directives will share one single child scope
       * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
       * its parent's scope
       * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
       * be applied to the same element.
       * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
       * cannot be applied to the same element.
       *
       *
       * #### `bindToController`
       * This property is used to bind scope properties directly to the controller. It can be either
       * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
       * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
       * definition: `controller: 'myCtrl as myAlias'`.
       *
       * When an isolate scope is used for a directive (see above), `bindToController: true` will
       * allow a component to have its properties bound to the controller, rather than to scope.
       *
       * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
       * properties. You can access these bindings once they have been initialized by providing a controller method called
       * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
       * initialized.
       *
       * <div class="alert alert-warning">
       * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
       * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
       * code that relies upon bindings inside a `$onInit` method on the controller, instead.
       * </div>
       *
       * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
       * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
       * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
       * scope (useful for component directives).
       *
       * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
       *
       *
       * #### `controller`
       * Controller constructor function. The controller is instantiated before the
       * pre-linking phase and can be accessed by other directives (see
       * `require` attribute). This allows the directives to communicate with each other and augment
       * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
       *
       * * `$scope` - Current scope associated with the element
       * * `$element` - Current element
       * * `$attrs` - Current attributes object for the element
       * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
       *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
       *    * `scope`: (optional) override the scope.
       *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
       *    * `futureParentElement` (optional):
       *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
       *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
       *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
       *          and when the `cloneLinkinFn` is passed,
       *          as those elements need to created and cloned in a special way when they are defined outside their
       *          usual containers (e.g. like `<svg>`).
       *        * See also the `directive.templateNamespace` property.
       *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
       *      then the default translusion is provided.
       *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
       *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
       *
       * #### `require`
       * Require another directive and inject its controller as the fourth argument to the linking function. The
       * `require` property can be a string, an array or an object:
       * * a **string** containing the name of the directive to pass to the linking function
       * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
       * linking function will be an array of controllers in the same order as the names in the `require` property
       * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
       * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
       * controllers.
       *
       * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
       * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
       * have been constructed but before `$onInit` is called.
       * If the name of the required controller is the same as the local name (the key), the name can be
       * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
       * See the {@link $compileProvider#component} helper for an example of how this can be used.
       * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
       * raised (unless no link function is specified and the required controllers are not being bound to the directive
       * controller, in which case error checking is skipped). The name can be prefixed with:
       *
       * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
       * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
       * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
       * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
       * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
       *   `null` to the `link` fn if not found.
       * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
       *   `null` to the `link` fn if not found.
       *
       *
       * #### `controllerAs`
       * Identifier name for a reference to the controller in the directive's scope.
       * This allows the controller to be referenced from the directive template. This is especially
       * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
       * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
       * `controllerAs` reference might overwrite a property that already exists on the parent scope.
       *
       *
       * #### `restrict`
       * String of subset of `EACM` which restricts the directive to a specific directive
       * declaration style. If omitted, the defaults (elements and attributes) are used.
       *
       * * `E` - Element name (default): `<my-directive></my-directive>`
       * * `A` - Attribute (default): `<div my-directive="exp"></div>`
       * * `C` - Class: `<div class="my-directive: exp;"></div>`
       * * `M` - Comment: `<!-- directive: my-directive exp -->`
       *
       *
       * #### `templateNamespace`
       * String representing the document type used by the markup in the template.
       * AngularJS needs this information as those elements need to be created and cloned
       * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
       *
       * * `html` - All root nodes in the template are HTML. Root nodes may also be
       *   top-level elements such as `<svg>` or `<math>`.
       * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
       * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
       *
       * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
       *
       * #### `template`
       * HTML markup that may:
       * * Replace the contents of the directive's element (default).
       * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
       * * Wrap the contents of the directive's element (if `transclude` is true).
       *
       * Value may be:
       *
       * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
       * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
       *   function api below) and returns a string value.
       *
       *
       * #### `templateUrl`
       * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
       *
       * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
       * for later when the template has been resolved.  In the meantime it will continue to compile and link
       * sibling and parent elements as though this element had not contained any directives.
       *
       * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
       * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
       * case when only one deeply nested directive has `templateUrl`.
       *
       * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
       *
       * You can specify `templateUrl` as a string representing the URL or as a function which takes two
       * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
       * a string value representing the url.  In either case, the template URL is passed through {@link
       * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
       *
       *
       * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
       * specify what the template should replace. Defaults to `false`.
       *
       * * `true` - the template will replace the directive's element.
       * * `false` - the template will replace the contents of the directive's element.
       *
       * The replacement process migrates all of the attributes / classes from the old element to the new
       * one. See the {@link guide/directive#template-expanding-directive
       * Directives Guide} for an example.
       *
       * There are very few scenarios where element replacement is required for the application function,
       * the main one being reusable custom components that are used within SVG contexts
       * (because SVG doesn't work with custom elements in the DOM tree).
       *
       * #### `transclude`
       * Extract the contents of the element where the directive appears and make it available to the directive.
       * The contents are compiled and provided to the directive as a **transclusion function**. See the
       * {@link $compile#transclusion Transclusion} section below.
       *
       *
       * #### `compile`
       *
       * ```js
       *   function compile(tElement, tAttrs, transclude) { ... }
       * ```
       *
       * The compile function deals with transforming the template DOM. Since most directives do not do
       * template transformation, it is not used often. The compile function takes the following arguments:
       *
       *   * `tElement` - template element - The element where the directive has been declared. It is
       *     safe to do template transformation on the element and child elements only.
       *
       *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
       *     between all directive compile functions.
       *
       *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
       *
       * <div class="alert alert-warning">
       * **Note:** The template instance and the link instance may be different objects if the template has
       * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
       * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
       * should be done in a linking function rather than in a compile function.
       * </div>
      
       * <div class="alert alert-warning">
       * **Note:** The compile function cannot handle directives that recursively use themselves in their
       * own templates or compile functions. Compiling these directives results in an infinite loop and
       * stack overflow errors.
       *
       * This can be avoided by manually using $compile in the postLink function to imperatively compile
       * a directive's template instead of relying on automatic template compilation via `template` or
       * `templateUrl` declaration or manual compilation inside the compile function.
       * </div>
       *
       * <div class="alert alert-danger">
       * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
       *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
       *   to the link function instead.
       * </div>
      
       * A compile function can have a return value which can be either a function or an object.
       *
       * * returning a (post-link) function - is equivalent to registering the linking function via the
       *   `link` property of the config object when the compile function is empty.
       *
       * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
       *   control when a linking function should be called during the linking phase. See info about
       *   pre-linking and post-linking functions below.
       *
       *
       * #### `link`
       * This property is used only if the `compile` property is not defined.
       *
       * ```js
       *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
       * ```
       *
       * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
       * executed after the template has been cloned. This is where most of the directive logic will be
       * put.
       *
       *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
       *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
       *
       *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
       *     manipulate the children of the element only in `postLink` function since the children have
       *     already been linked.
       *
       *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
       *     between all directive linking functions.
       *
       *   * `controller` - the directive's required controller instance(s) - Instances are shared
       *     among all directives, which allows the directives to use the controllers as a communication
       *     channel. The exact value depends on the directive's `require` property:
       *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
       *       * `string`: the controller instance
       *       * `array`: array of controller instances
       *
       *     If a required controller cannot be found, and it is optional, the instance is `null`,
       *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
       *
       *     Note that you can also require the directive's own controller - it will be made available like
       *     any other controller.
       *
       *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
       *     This is the same as the `$transclude` parameter of directive controllers,
       *     see {@link ng.$compile#-controller- the controller section for details}.
       *     `function([scope], cloneLinkingFn, futureParentElement)`.
       *
       * #### Pre-linking function
       *
       * Executed before the child elements are linked. Not safe to do DOM transformation since the
       * compiler linking function will fail to locate the correct elements for linking.
       *
       * #### Post-linking function
       *
       * Executed after the child elements are linked.
       *
       * Note that child elements that contain `templateUrl` directives will not have been compiled
       * and linked since they are waiting for their template to load asynchronously and their own
       * compilation and linking has been suspended until that occurs.
       *
       * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
       * for their async templates to be resolved.
       *
       *
       * ### Transclusion
       *
       * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
       * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
       * scope from where they were taken.
       *
       * Transclusion is used (often with {@link ngTransclude}) to insert the
       * original contents of a directive's element into a specified place in the template of the directive.
       * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
       * content has access to the properties on the scope from which it was taken, even if the directive
       * has isolated scope.
       * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
       *
       * This makes it possible for the widget to have private state for its template, while the transcluded
       * content has access to its originating scope.
       *
       * <div class="alert alert-warning">
       * **Note:** When testing an element transclude directive you must not place the directive at the root of the
       * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
       * Testing Transclusion Directives}.
       * </div>
       *
       * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
       * directive's element, the entire element or multiple parts of the element contents:
       *
       * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
       * * `'element'` - transclude the whole of the directive's element including any directives on this
       *   element that defined at a lower priority than this directive. When used, the `template`
       *   property is ignored.
       * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
       *
       * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
       *
       * This object is a map where the keys are the name of the slot to fill and the value is an element selector
       * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
       * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * If the element selector is prefixed with a `?` then that slot is optional.
       *
       * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
       * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
       *
       * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
       * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
       * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
       * injectable into the directive's controller.
       *
       *
       * #### Transclusion Functions
       *
       * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
       * function** to the directive's `link` function and `controller`. This transclusion function is a special
       * **linking function** that will return the compiled contents linked to a new transclusion scope.
       *
       * <div class="alert alert-info">
       * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
       * ngTransclude will deal with it for us.
       * </div>
       *
       * If you want to manually control the insertion and removal of the transcluded content in your directive
       * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
       * object that contains the compiled DOM, which is linked to the correct transclusion scope.
       *
       * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
       * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
       * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
       *
       * <div class="alert alert-info">
       * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
       * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
       * </div>
       *
       * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
       * attach function**:
       *
       * ```js
       * var transcludedContent, transclusionScope;
       *
       * $transclude(function(clone, scope) {
       *   element.append(clone);
       *   transcludedContent = clone;
       *   transclusionScope = scope;
       * });
       * ```
       *
       * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
       * associated transclusion scope:
       *
       * ```js
       * transcludedContent.remove();
       * transclusionScope.$destroy();
       * ```
       *
       * <div class="alert alert-info">
       * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
       * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
       * then you are also responsible for calling `$destroy` on the transclusion scope.
       * </div>
       *
       * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
       * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
       * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
       *
       *
       * #### Transclusion Scopes
       *
       * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
       * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
       * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
       * was taken.
       *
       * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
       * like this:
       *
       * ```html
       * <div ng-app>
       *   <div isolate>
       *     <div transclusion>
       *     </div>
       *   </div>
       * </div>
       * ```
       *
       * The `$parent` scope hierarchy will look like this:
       *
         ```
         - $rootScope
           - isolate
             - transclusion
         ```
       *
       * but the scopes will inherit prototypically from different scopes to their `$parent`.
       *
         ```
         - $rootScope
           - transclusion
         - isolate
         ```
       *
       *
       * ### Attributes
       *
       * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
       * `link()` or `compile()` functions. It has a variety of uses.
       *
       * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
       *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
       *   to the attributes.
       *
       * * *Directive inter-communication:* All directives share the same instance of the attributes
       *   object which allows the directives to use the attributes object as inter directive
       *   communication.
       *
       * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
       *   allowing other directives to read the interpolated value.
       *
       * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
       *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
       *   the only way to easily get the actual value because during the linking phase the interpolation
       *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
       *
       * ```js
       * function linkingFn(scope, elm, attrs, ctrl) {
       *   // get the attribute value
       *   console.log(attrs.ngModel);
       *
       *   // change the attribute
       *   attrs.$set('ngModel', 'new value');
       *
       *   // observe changes to interpolated attribute
       *   attrs.$observe('ngModel', function(value) {
       *     console.log('ngModel has changed value to ' + value);
       *   });
       * }
       * ```
       *
       * ## Example
       *
       * <div class="alert alert-warning">
       * **Note**: Typically directives are registered with `module.directive`. The example below is
       * to illustrate how `$compile` works.
       * </div>
       *
       <example module="compileExample">
         <file name="index.html">
          <script>
            angular.module('compileExample', [], function($compileProvider) {
              // configure new 'compile' directive by passing a directive
              // factory function. The factory function injects the '$compile'
              $compileProvider.directive('compile', function($compile) {
                // directive factory creates a link function
                return function(scope, element, attrs) {
                  scope.$watch(
                    function(scope) {
                       // watch the 'compile' expression for changes
                      return scope.$eval(attrs.compile);
                    },
                    function(value) {
                      // when the 'compile' expression changes
                      // assign it into the current DOM
                      element.html(value);
      
                      // compile the new DOM and link it to the current
                      // scope.
                      // NOTE: we only compile .childNodes so that
                      // we don't get into infinite loop compiling ourselves
                      $compile(element.contents())(scope);
                    }
                  );
                };
              });
            })
            .controller('GreeterController', ['$scope', function($scope) {
              $scope.name = 'Angular';
              $scope.html = 'Hello {{name}}';
            }]);
          </script>
          <div ng-controller="GreeterController">
            <input ng-model="name"> <br/>
            <textarea ng-model="html"></textarea> <br/>
            <div compile="html"></div>
          </div>
         </file>
         <file name="protractor.js" type="protractor">
           it('should auto compile', function() {
             var textarea = $('textarea');
             var output = $('div[compile]');
             // The initial state reads 'Hello Angular'.
             expect(output.getText()).toBe('Hello Angular');
             textarea.clear();
             textarea.sendKeys('{{name}}!');
             expect(output.getText()).toBe('Angular!');
           });
         </file>
       </example>
      
       *
       *
       * @param {string|DOMElement} element Element or HTML string to compile into a template function.
       * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
       *
       * <div class="alert alert-danger">
       * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
       *   e.g. will not use the right outer scope. Please pass the transclude function as a
       *   `parentBoundTranscludeFn` to the link function instead.
       * </div>
       *
       * @param {number} maxPriority only apply directives lower than given priority (Only effects the
       *                 root element(s), not their children)
       * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
       * (a DOM element/tree) to a scope. Where:
       *
       *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
       *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
       *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
       *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
       *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
       *
       *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
       *      * `scope` - is the current scope with which the linking function is working with.
       *
       *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
       *  keys may be used to control linking behavior:
       *
       *      * `parentBoundTranscludeFn` - the transclude function made available to
       *        directives; if given, it will be passed through to the link functions of
       *        directives found in `element` during compilation.
       *      * `transcludeControllers` - an object hash with keys that map controller names
       *        to a hash with the key `instance`, which maps to the controller instance;
       *        if given, it will make the controllers available to directives on the compileNode:
       *        ```
       *        {
       *          parent: {
       *            instance: parentControllerInstance
       *          }
       *        }
       *        ```
       *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
       *        the cloned elements; only needed for transcludes that are allowed to contain non html
       *        elements (e.g. SVG elements). See also the directive.controller property.
       *
       * Calling the linking function returns the element of the template. It is either the original
       * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
       *
       * After linking the view is not updated until after a call to $digest which typically is done by
       * Angular automatically.
       *
       * If you need access to the bound view, there are two ways to do it:
       *
       * - If you are not asking the linking function to clone the template, create the DOM element(s)
       *   before you send them to the compiler and keep this reference around.
       *   ```js
       *     var element = $compile('<p>{{total}}</p>')(scope);
       *   ```
       *
       * - if on the other hand, you need the element to be cloned, the view reference from the original
       *   example would not point to the clone, but rather to the original template that was cloned. In
       *   this case, you can access the clone via the cloneAttachFn:
       *   ```js
       *     var templateElement = angular.element('<p>{{total}}</p>'),
       *         scope = ....;
       *
       *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
       *       //attach the clone to DOM document at the right place
       *     });
       *
       *     //now we have reference to the cloned DOM via `clonedElement`
       *   ```
       *
       *
       * For information on how the compiler works, see the
       * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
       */

      var $compileMinErr = minErr('$compile');

      function UNINITIALIZED_VALUE() {}
      var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

      /**
       * @ngdoc provider
       * @name $compileProvider
       *
       * @description
       */
      $CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
      function $CompileProvider($provide, $$sanitizeUriProvider) {
        var hasDirectives = {},
            Suffix = 'Directive',
            COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
            CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
            ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
            REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

        // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
        // The assumption is that future DOM event attribute names will begin with
        // 'on' and be composed of only English letters.
        var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
        var bindingCache = createMap();

        function parseIsolateBindings(scope, directiveName, isController) {
          var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;

          var bindings = createMap();

          forEach(scope, function (definition, scopeName) {
            if (definition in bindingCache) {
              bindings[scopeName] = bindingCache[definition];
              return;
            }
            var match = definition.match(LOCAL_REGEXP);

            if (!match) {
              throw $compileMinErr('iscp', "Invalid {3} for directive '{0}'." + " Definition: {... {1}: '{2}' ...}", directiveName, scopeName, definition, isController ? "controller bindings definition" : "isolate scope definition");
            }

            bindings[scopeName] = {
              mode: match[1][0],
              collection: match[2] === '*',
              optional: match[3] === '?',
              attrName: match[4] || scopeName
            };
            if (match[4]) {
              bindingCache[definition] = bindings[scopeName];
            }
          });

          return bindings;
        }

        function parseDirectiveBindings(directive, directiveName) {
          var bindings = {
            isolateScope: null,
            bindToController: null
          };
          if (isObject(directive.scope)) {
            if (directive.bindToController === true) {
              bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
              bindings.isolateScope = {};
            } else {
              bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
            }
          }
          if (isObject(directive.bindToController)) {
            bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
          }
          if (isObject(bindings.bindToController)) {
            var controller = directive.controller;
            var controllerAs = directive.controllerAs;
            if (!controller) {
              // There is no controller, there may or may not be a controllerAs property
              throw $compileMinErr('noctrl', "Cannot bind to controller without directive '{0}'s controller.", directiveName);
            } else if (!identifierForController(controller, controllerAs)) {
              // There is a controller, but no identifier or controllerAs property
              throw $compileMinErr('noident', "Cannot bind to controller without identifier for directive '{0}'.", directiveName);
            }
          }
          return bindings;
        }

        function assertValidDirectiveName(name) {
          var letter = name.charAt(0);
          if (!letter || letter !== lowercase(letter)) {
            throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
          }
          if (name !== name.trim()) {
            throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces", name);
          }
        }

        function getDirectiveRequire(directive) {
          var require = directive.require || directive.controller && directive.name;

          if (!isArray(require) && isObject(require)) {
            forEach(require, function (value, key) {
              var match = value.match(REQUIRE_PREFIX_REGEXP);
              var name = value.substring(match[0].length);
              if (!name) require[key] = match[0] + key;
            });
          }

          return require;
        }

        /**
         * @ngdoc method
         * @name $compileProvider#directive
         * @kind function
         *
         * @description
         * Register a new directive with the compiler.
         *
         * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
         *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
         *    names and the values are the factories.
         * @param {Function|Array} directiveFactory An injectable directive factory function. See the
         *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
         * @returns {ng.$compileProvider} Self for chaining.
         */
        this.directive = function registerDirective(name, directiveFactory) {
          assertNotHasOwnProperty(name, 'directive');
          if (isString(name)) {
            assertValidDirectiveName(name);
            assertArg(directiveFactory, 'directiveFactory');
            if (!hasDirectives.hasOwnProperty(name)) {
              hasDirectives[name] = [];
              $provide.factory(name + Suffix, ['$injector', '$exceptionHandler', function ($injector, $exceptionHandler) {
                var directives = [];
                forEach(hasDirectives[name], function (directiveFactory, index) {
                  try {
                    var directive = $injector.invoke(directiveFactory);
                    if (isFunction(directive)) {
                      directive = { compile: valueFn(directive) };
                    } else if (!directive.compile && directive.link) {
                      directive.compile = valueFn(directive.link);
                    }
                    directive.priority = directive.priority || 0;
                    directive.index = index;
                    directive.name = directive.name || name;
                    directive.require = getDirectiveRequire(directive);
                    directive.restrict = directive.restrict || 'EA';
                    directive.$$moduleName = directiveFactory.$$moduleName;
                    directives.push(directive);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                });
                return directives;
              }]);
            }
            hasDirectives[name].push(directiveFactory);
          } else {
            forEach(name, reverseParams(registerDirective));
          }
          return this;
        };

        /**
         * @ngdoc method
         * @name $compileProvider#component
         * @module ng
         * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
         * @param {Object} options Component definition object (a simplified
         *    {@link ng.$compile#directive-definition-object directive definition object}),
         *    with the following properties (all optional):
         *
         *    - `controller` – `{(string|function()=}` – controller constructor function that should be
         *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
         *      registered controller} if passed as a string. An empty `noop` function by default.
         *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
         *      If present, the controller will be published to scope under the `controllerAs` name.
         *      If not present, this will default to be `$ctrl`.
         *    - `template` – `{string=|function()=}` – html template as a string or a function that
         *      returns an html template as a string which should be used as the contents of this component.
         *      Empty string by default.
         *
         *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
         *      the following locals:
         *
         *      - `$element` - Current element
         *      - `$attrs` - Current attributes object for the element
         *
         *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
         *      template that should be used  as the contents of this component.
         *
         *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
         *      the following locals:
         *
         *      - `$element` - Current element
         *      - `$attrs` - Current attributes object for the element
         *
         *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
         *      Component properties are always bound to the component controller and not to the scope.
         *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
         *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
         *      Disabled by default.
         *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
         *      this component's controller. The object keys specify the property names under which the required
         *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
         *    - `$...` – additional properties to attach to the directive factory function and the controller
         *      constructor function. (This is used by the component router to annotate)
         *
         * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
         * @description
         * Register a **component definition** with the compiler. This is a shorthand for registering a special
         * type of directive, which represents a self-contained UI component in your application. Such components
         * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
         *
         * Component definitions are very simple and do not require as much configuration as defining general
         * directives. Component definitions usually consist only of a template and a controller backing it.
         *
         * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
         * `bindToController`. They always have **isolate scope** and are restricted to elements.
         *
         * Here are a few examples of how you would usually define components:
         *
         * ```js
         *   var myMod = angular.module(...);
         *   myMod.component('myComp', {
         *     template: '<div>My name is {{$ctrl.name}}</div>',
         *     controller: function() {
         *       this.name = 'shahar';
         *     }
         *   });
         *
         *   myMod.component('myComp', {
         *     template: '<div>My name is {{$ctrl.name}}</div>',
         *     bindings: {name: '@'}
         *   });
         *
         *   myMod.component('myComp', {
         *     templateUrl: 'views/my-comp.html',
         *     controller: 'MyCtrl',
         *     controllerAs: 'ctrl',
         *     bindings: {name: '@'}
         *   });
         *
         * ```
         * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
         *
         * <br />
         * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
         */
        this.component = function registerComponent(name, options) {
          var controller = options.controller || function () {};

          function factory($injector) {
            function makeInjectable(fn) {
              if (isFunction(fn) || isArray(fn)) {
                return function (tElement, tAttrs) {
                  return $injector.invoke(fn, this, { $element: tElement, $attrs: tAttrs });
                };
              } else {
                return fn;
              }
            }

            var template = !options.template && !options.templateUrl ? '' : options.template;
            var ddo = {
              controller: controller,
              controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
              template: makeInjectable(template),
              templateUrl: makeInjectable(options.templateUrl),
              transclude: options.transclude,
              scope: {},
              bindToController: options.bindings || {},
              restrict: 'E',
              require: options.require
            };

            // Copy annotations (starting with $) over to the DDO
            forEach(options, function (val, key) {
              if (key.charAt(0) === '$') ddo[key] = val;
            });

            return ddo;
          }

          // TODO(pete) remove the following `forEach` before we release 1.6.0
          // The component-router@0.2.0 looks for the annotations on the controller constructor
          // Nothing in Angular looks for annotations on the factory function but we can't remove
          // it from 1.5.x yet.

          // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
          // These could be used by libraries such as the new component router
          forEach(options, function (val, key) {
            if (key.charAt(0) === '$') {
              factory[key] = val;
              // Don't try to copy over annotations to named controller
              if (isFunction(controller)) controller[key] = val;
            }
          });

          factory.$inject = ['$injector'];

          return this.directive(name, factory);
        };

        /**
         * @ngdoc method
         * @name $compileProvider#aHrefSanitizationWhitelist
         * @kind function
         *
         * @description
         * Retrieves or overrides the default regular expression that is used for whitelisting of safe
         * urls during a[href] sanitization.
         *
         * The sanitization is a security measure aimed at preventing XSS attacks via html links.
         *
         * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
         * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
         * regular expression. If a match is found, the original url is written into the dom. Otherwise,
         * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
         *
         * @param {RegExp=} regexp New regexp to whitelist urls with.
         * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
         *    chaining otherwise.
         */
        this.aHrefSanitizationWhitelist = function (regexp) {
          if (isDefined(regexp)) {
            $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
            return this;
          } else {
            return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
          }
        };

        /**
         * @ngdoc method
         * @name $compileProvider#imgSrcSanitizationWhitelist
         * @kind function
         *
         * @description
         * Retrieves or overrides the default regular expression that is used for whitelisting of safe
         * urls during img[src] sanitization.
         *
         * The sanitization is a security measure aimed at prevent XSS attacks via html links.
         *
         * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
         * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
         * regular expression. If a match is found, the original url is written into the dom. Otherwise,
         * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
         *
         * @param {RegExp=} regexp New regexp to whitelist urls with.
         * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
         *    chaining otherwise.
         */
        this.imgSrcSanitizationWhitelist = function (regexp) {
          if (isDefined(regexp)) {
            $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
            return this;
          } else {
            return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
          }
        };

        /**
         * @ngdoc method
         * @name  $compileProvider#debugInfoEnabled
         *
         * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
         * current debugInfoEnabled state
         * @returns {*} current value if used as getter or itself (chaining) if used as setter
         *
         * @kind function
         *
         * @description
         * Call this method to enable/disable various debug runtime information in the compiler such as adding
         * binding information and a reference to the current scope on to DOM elements.
         * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
         * * `ng-binding` CSS class
         * * `$binding` data property containing an array of the binding expressions
         *
         * You may want to disable this in production for a significant performance boost. See
         * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
         *
         * The default value is true.
         */
        var debugInfoEnabled = true;
        this.debugInfoEnabled = function (enabled) {
          if (isDefined(enabled)) {
            debugInfoEnabled = enabled;
            return this;
          }
          return debugInfoEnabled;
        };

        var TTL = 10;
        /**
         * @ngdoc method
         * @name $compileProvider#onChangesTtl
         * @description
         *
         * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
         * assuming that the model is unstable.
         *
         * The current default is 10 iterations.
         *
         * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
         * in several iterations of calls to these hooks. However if an application needs more than the default 10
         * iterations to stabilize then you should investigate what is causing the model to continuously change during
         * the `$onChanges` hook execution.
         *
         * Increasing the TTL could have performance implications, so you should not change it without proper justification.
         *
         * @param {number} limit The number of `$onChanges` hook iterations.
         * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
         */
        this.onChangesTtl = function (value) {
          if (arguments.length) {
            TTL = value;
            return this;
          }
          return TTL;
        };

        this.$get = ['$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse', '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri', function ($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate, $$sanitizeUri) {

          var SIMPLE_ATTR_NAME = /^\w/;
          var specialAttrHolder = window.document.createElement('div');

          var onChangesTtl = TTL;
          // The onChanges hooks should all be run together in a single digest
          // When changes occur, the call to trigger their hooks will be added to this queue
          var onChangesQueue;

          // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
          function flushOnChangesQueue() {
            try {
              if (! --onChangesTtl) {
                // We have hit the TTL limit so reset everything
                onChangesQueue = undefined;
                throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
              }
              // We must run this hook in an apply since the $$postDigest runs outside apply
              $rootScope.$apply(function () {
                var errors = [];
                for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
                  try {
                    onChangesQueue[i]();
                  } catch (e) {
                    errors.push(e);
                  }
                }
                // Reset the queue to trigger a new schedule next time there is a change
                onChangesQueue = undefined;
                if (errors.length) {
                  throw errors;
                }
              });
            } finally {
              onChangesTtl++;
            }
          }

          function Attributes(element, attributesToCopy) {
            if (attributesToCopy) {
              var keys = Object.keys(attributesToCopy);
              var i, l, key;

              for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                this[key] = attributesToCopy[key];
              }
            } else {
              this.$attr = {};
            }

            this.$$element = element;
          }

          Attributes.prototype = {
            /**
             * @ngdoc method
             * @name $compile.directive.Attributes#$normalize
             * @kind function
             *
             * @description
             * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
             * `data-`) to its normalized, camelCase form.
             *
             * Also there is special case for Moz prefix starting with upper case letter.
             *
             * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
             *
             * @param {string} name Name to normalize
             */
            $normalize: directiveNormalize,

            /**
             * @ngdoc method
             * @name $compile.directive.Attributes#$addClass
             * @kind function
             *
             * @description
             * Adds the CSS class value specified by the classVal parameter to the element. If animations
             * are enabled then an animation will be triggered for the class addition.
             *
             * @param {string} classVal The className value that will be added to the element
             */
            $addClass: function (classVal) {
              if (classVal && classVal.length > 0) {
                $animate.addClass(this.$$element, classVal);
              }
            },

            /**
             * @ngdoc method
             * @name $compile.directive.Attributes#$removeClass
             * @kind function
             *
             * @description
             * Removes the CSS class value specified by the classVal parameter from the element. If
             * animations are enabled then an animation will be triggered for the class removal.
             *
             * @param {string} classVal The className value that will be removed from the element
             */
            $removeClass: function (classVal) {
              if (classVal && classVal.length > 0) {
                $animate.removeClass(this.$$element, classVal);
              }
            },

            /**
             * @ngdoc method
             * @name $compile.directive.Attributes#$updateClass
             * @kind function
             *
             * @description
             * Adds and removes the appropriate CSS class values to the element based on the difference
             * between the new and old CSS class values (specified as newClasses and oldClasses).
             *
             * @param {string} newClasses The current CSS className value
             * @param {string} oldClasses The former CSS className value
             */
            $updateClass: function (newClasses, oldClasses) {
              var toAdd = tokenDifference(newClasses, oldClasses);
              if (toAdd && toAdd.length) {
                $animate.addClass(this.$$element, toAdd);
              }

              var toRemove = tokenDifference(oldClasses, newClasses);
              if (toRemove && toRemove.length) {
                $animate.removeClass(this.$$element, toRemove);
              }
            },

            /**
             * Set a normalized attribute on the element in a way such that all directives
             * can share the attribute. This function properly handles boolean attributes.
             * @param {string} key Normalized key. (ie ngAttribute)
             * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
             * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
             *     Defaults to true.
             * @param {string=} attrName Optional none normalized name. Defaults to key.
             */
            $set: function (key, value, writeAttr, attrName) {
              // TODO: decide whether or not to throw an error if "class"
              //is set through this function since it may cause $updateClass to
              //become unstable.

              var node = this.$$element[0],
                  booleanKey = getBooleanAttrName(node, key),
                  aliasedKey = getAliasedAttrName(key),
                  observer = key,
                  nodeName;

              if (booleanKey) {
                this.$$element.prop(key, value);
                attrName = booleanKey;
              } else if (aliasedKey) {
                this[aliasedKey] = value;
                observer = aliasedKey;
              }

              this[key] = value;

              // translate normalized key to actual key
              if (attrName) {
                this.$attr[key] = attrName;
              } else {
                attrName = this.$attr[key];
                if (!attrName) {
                  this.$attr[key] = attrName = snake_case(key, '-');
                }
              }

              nodeName = nodeName_(this.$$element);

              if (nodeName === 'a' && (key === 'href' || key === 'xlinkHref') || nodeName === 'img' && key === 'src') {
                // sanitize a[href] and img[src] values
                this[key] = value = $$sanitizeUri(value, key === 'src');
              } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
                // sanitize img[srcset] values
                var result = "";

                // first check if there are spaces because it's not the same pattern
                var trimmedSrcset = trim(value);
                //                (   999x   ,|   999w   ,|   ,|,   )
                var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
                var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

                // split srcset into tuple of uri and descriptor except for the last item
                var rawUris = trimmedSrcset.split(pattern);

                // for each tuples
                var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
                for (var i = 0; i < nbrUrisWith2parts; i++) {
                  var innerIdx = i * 2;
                  // sanitize the uri
                  result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
                  // add the descriptor
                  result += " " + trim(rawUris[innerIdx + 1]);
                }

                // split the last item into uri and descriptor
                var lastTuple = trim(rawUris[i * 2]).split(/\s/);

                // sanitize the last uri
                result += $$sanitizeUri(trim(lastTuple[0]), true);

                // and add the last descriptor if any
                if (lastTuple.length === 2) {
                  result += " " + trim(lastTuple[1]);
                }
                this[key] = value = result;
              }

              if (writeAttr !== false) {
                if (value === null || isUndefined(value)) {
                  this.$$element.removeAttr(attrName);
                } else {
                  if (SIMPLE_ATTR_NAME.test(attrName)) {
                    this.$$element.attr(attrName, value);
                  } else {
                    setSpecialAttr(this.$$element[0], attrName, value);
                  }
                }
              }

              // fire observers
              var $$observers = this.$$observers;
              $$observers && forEach($$observers[observer], function (fn) {
                try {
                  fn(value);
                } catch (e) {
                  $exceptionHandler(e);
                }
              });
            },

            /**
             * @ngdoc method
             * @name $compile.directive.Attributes#$observe
             * @kind function
             *
             * @description
             * Observes an interpolated attribute.
             *
             * The observer function will be invoked once during the next `$digest` following
             * compilation. The observer is then invoked whenever the interpolated value
             * changes.
             *
             * @param {string} key Normalized key. (ie ngAttribute) .
             * @param {function(interpolatedValue)} fn Function that will be called whenever
                      the interpolated value of the attribute changes.
             *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
             *        guide} for more info.
             * @returns {function()} Returns a deregistration function for this observer.
             */
            $observe: function (key, fn) {
              var attrs = this,
                  $$observers = attrs.$$observers || (attrs.$$observers = createMap()),
                  listeners = $$observers[key] || ($$observers[key] = []);

              listeners.push(fn);
              $rootScope.$evalAsync(function () {
                if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
                  // no one registered attribute interpolation function, so lets call it manually
                  fn(attrs[key]);
                }
              });

              return function () {
                arrayRemove(listeners, fn);
              };
            }
          };

          function setSpecialAttr(element, attrName, value) {
            // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
            // so we have to jump through some hoops to get such an attribute
            // https://github.com/angular/angular.js/pull/13318
            specialAttrHolder.innerHTML = "<span " + attrName + ">";
            var attributes = specialAttrHolder.firstChild.attributes;
            var attribute = attributes[0];
            // We have to remove the attribute from its container element before we can add it to the destination element
            attributes.removeNamedItem(attribute.name);
            attribute.value = value;
            element.attributes.setNamedItem(attribute);
          }

          function safeAddClass($element, className) {
            try {
              $element.addClass(className);
            } catch (e) {
              // ignore, since it means that we are trying to set class on
              // SVG element, where class name is read-only.
            }
          }

          var startSymbol = $interpolate.startSymbol(),
              endSymbol = $interpolate.endSymbol(),
              denormalizeTemplate = startSymbol == '{{' && endSymbol == '}}' ? identity : function denormalizeTemplate(template) {
            return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
          },
              NG_ATTR_BINDING = /^ngAttr[A-Z]/;
          var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

          compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
            var bindings = $element.data('$binding') || [];

            if (isArray(binding)) {
              bindings = bindings.concat(binding);
            } else {
              bindings.push(binding);
            }

            $element.data('$binding', bindings);
          } : noop;

          compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
            safeAddClass($element, 'ng-binding');
          } : noop;

          compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
            var dataName = isolated ? noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope' : '$scope';
            $element.data(dataName, scope);
          } : noop;

          compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
            safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
          } : noop;

          compile.$$createComment = function (directiveName, comment) {
            var content = '';
            if (debugInfoEnabled) {
              content = ' ' + (directiveName || '') + ': ';
              if (comment) content += comment + ' ';
            }
            return window.document.createComment(content);
          };

          return compile;

          //================================

          function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
            if (!($compileNodes instanceof jqLite)) {
              // jquery always rewraps, whereas we need to preserve the original selector so that we can
              // modify it.
              $compileNodes = jqLite($compileNodes);
            }

            var NOT_EMPTY = /\S+/;

            // We can not compile top level text elements since text nodes can be merged and we will
            // not be able to attach scope data to them, so we will wrap them in <span>
            for (var i = 0, len = $compileNodes.length; i < len; i++) {
              var domNode = $compileNodes[i];

              if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
                  jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
                }
            }

            var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
            compile.$$addScopeClass($compileNodes);
            var namespace = null;
            return function publicLinkFn(scope, cloneConnectFn, options) {
              assertArg(scope, 'scope');

              if (previousCompileContext && previousCompileContext.needsNewScope) {
                // A parent directive did a replace and a directive on this element asked
                // for transclusion, which caused us to lose a layer of element on which
                // we could hold the new transclusion scope, so we will create it manually
                // here.
                scope = scope.$parent.$new();
              }

              options = options || {};
              var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
                  transcludeControllers = options.transcludeControllers,
                  futureParentElement = options.futureParentElement;

              // When `parentBoundTranscludeFn` is passed, it is a
              // `controllersBoundTransclude` function (it was previously passed
              // as `transclude` to directive.link) so we must unwrap it to get
              // its `boundTranscludeFn`
              if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
                parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
              }

              if (!namespace) {
                namespace = detectNamespaceForChildElements(futureParentElement);
              }
              var $linkNode;
              if (namespace !== 'html') {
                // When using a directive with replace:true and templateUrl the $compileNodes
                // (or a child element inside of them)
                // might change, so we need to recreate the namespace adapted compileNodes
                // for call to the link function.
                // Note: This will already clone the nodes...
                $linkNode = jqLite(wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html()));
              } else if (cloneConnectFn) {
                // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
                // and sometimes changes the structure of the DOM.
                $linkNode = JQLitePrototype.clone.call($compileNodes);
              } else {
                $linkNode = $compileNodes;
              }

              if (transcludeControllers) {
                for (var controllerName in transcludeControllers) {
                  $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
                }
              }

              compile.$$addScopeInfo($linkNode, scope);

              if (cloneConnectFn) cloneConnectFn($linkNode, scope);
              if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
              return $linkNode;
            };
          }

          function detectNamespaceForChildElements(parentElement) {
            // TODO: Make this detect MathML as well...
            var node = parentElement && parentElement[0];
            if (!node) {
              return 'html';
            } else {
              return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
            }
          }

          /**
           * Compile function matches each node in nodeList against the directives. Once all directives
           * for a particular node are collected their compile functions are executed. The compile
           * functions return values - the linking functions - are combined into a composite linking
           * function, which is the a linking function for the node.
           *
           * @param {NodeList} nodeList an array of nodes or NodeList to compile
           * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
           *        scope argument is auto-generated to the new child of the transcluded parent scope.
           * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
           *        the rootElement must be set the jqLite collection of the compile root. This is
           *        needed so that the jqLite collection items can be replaced with widgets.
           * @param {number=} maxPriority Max directive priority.
           * @returns {Function} A composite linking function of all of the matched directives or null.
           */
          function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
            var linkFns = [],
                attrs,
                directives,
                nodeLinkFn,
                childNodes,
                childLinkFn,
                linkFnFound,
                nodeLinkFnFound;

            for (var i = 0; i < nodeList.length; i++) {
              attrs = new Attributes();

              // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
              directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);

              nodeLinkFn = directives.length ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;

              if (nodeLinkFn && nodeLinkFn.scope) {
                compile.$$addScopeClass(attrs.$$element);
              }

              childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length ? null : compileNodes(childNodes, nodeLinkFn ? (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude : transcludeFn);

              if (nodeLinkFn || childLinkFn) {
                linkFns.push(i, nodeLinkFn, childLinkFn);
                linkFnFound = true;
                nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
              }

              //use the previous context only for the first element in the virtual group
              previousCompileContext = null;
            }

            // return a linking function if we have found anything, null otherwise
            return linkFnFound ? compositeLinkFn : null;

            function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
              var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
              var stableNodeList;

              if (nodeLinkFnFound) {
                // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
                // offsets don't get screwed up
                var nodeListLength = nodeList.length;
                stableNodeList = new Array(nodeListLength);

                // create a sparse array by only copying the elements which have a linkFn
                for (i = 0; i < linkFns.length; i += 3) {
                  idx = linkFns[i];
                  stableNodeList[idx] = nodeList[idx];
                }
              } else {
                stableNodeList = nodeList;
              }

              for (i = 0, ii = linkFns.length; i < ii;) {
                node = stableNodeList[linkFns[i++]];
                nodeLinkFn = linkFns[i++];
                childLinkFn = linkFns[i++];

                if (nodeLinkFn) {
                  if (nodeLinkFn.scope) {
                    childScope = scope.$new();
                    compile.$$addScopeInfo(jqLite(node), childScope);
                  } else {
                    childScope = scope;
                  }

                  if (nodeLinkFn.transcludeOnThisElement) {
                    childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
                  } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
                    childBoundTranscludeFn = parentBoundTranscludeFn;
                  } else if (!parentBoundTranscludeFn && transcludeFn) {
                    childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
                  } else {
                    childBoundTranscludeFn = null;
                  }

                  nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
                } else if (childLinkFn) {
                  childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
                }
              }
            }
          }

          function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
            function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

              if (!transcludedScope) {
                transcludedScope = scope.$new(false, containingScope);
                transcludedScope.$$transcluded = true;
              }

              return transcludeFn(transcludedScope, cloneFn, {
                parentBoundTranscludeFn: previousBoundTranscludeFn,
                transcludeControllers: controllers,
                futureParentElement: futureParentElement
              });
            }

            // We need  to attach the transclusion slots onto the `boundTranscludeFn`
            // so that they are available inside the `controllersBoundTransclude` function
            var boundSlots = boundTranscludeFn.$$slots = createMap();
            for (var slotName in transcludeFn.$$slots) {
              if (transcludeFn.$$slots[slotName]) {
                boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
              } else {
                boundSlots[slotName] = null;
              }
            }

            return boundTranscludeFn;
          }

          /**
           * Looks for directives on the given node and adds them to the directive collection which is
           * sorted.
           *
           * @param node Node to search.
           * @param directives An array to which the directives are added to. This array is sorted before
           *        the function returns.
           * @param attrs The shared attrs object which is used to populate the normalized attributes.
           * @param {number=} maxPriority Max directive priority.
           */
          function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
            var nodeType = node.nodeType,
                attrsMap = attrs.$attr,
                match,
                className;

            switch (nodeType) {
              case NODE_TYPE_ELEMENT:
                /* Element */
                // use the node name: <directive>
                addDirective(directives, directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);

                // iterate over the attributes
                for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes, j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
                  var attrStartName = false;
                  var attrEndName = false;

                  attr = nAttrs[j];
                  name = attr.name;
                  value = trim(attr.value);

                  // support ngAttr attribute binding
                  ngAttrName = directiveNormalize(name);
                  if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
                    name = name.replace(PREFIX_REGEXP, '').substr(8).replace(/_(.)/g, function (match, letter) {
                      return letter.toUpperCase();
                    });
                  }

                  var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
                  if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
                    attrStartName = name;
                    attrEndName = name.substr(0, name.length - 5) + 'end';
                    name = name.substr(0, name.length - 6);
                  }

                  nName = directiveNormalize(name.toLowerCase());
                  attrsMap[nName] = name;
                  if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                    attrs[nName] = value;
                    if (getBooleanAttrName(node, nName)) {
                      attrs[nName] = true; // presence means true
                    }
                  }
                  addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                  addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName, attrEndName);
                }

                // use class as directive
                className = node.className;
                if (isObject(className)) {
                  // Maybe SVGAnimatedString
                  className = className.animVal;
                }
                if (isString(className) && className !== '') {
                  while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
                    nName = directiveNormalize(match[2]);
                    if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                      attrs[nName] = trim(match[3]);
                    }
                    className = className.substr(match.index + match[0].length);
                  }
                }
                break;
              case NODE_TYPE_TEXT:
                /* Text Node */
                if (msie === 11) {
                  // Workaround for #11781
                  while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
                    node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
                    node.parentNode.removeChild(node.nextSibling);
                  }
                }
                addTextInterpolateDirective(directives, node.nodeValue);
                break;
              case NODE_TYPE_COMMENT:
                /* Comment */
                collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
                break;
            }

            directives.sort(byPriority);
            return directives;
          }

          function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
            // function created because of performance, try/catch disables
            // the optimization of the whole function #14848
            try {
              var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
              if (match) {
                var nName = directiveNormalize(match[1]);
                if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
                  attrs[nName] = trim(match[2]);
                }
              }
            } catch (e) {
              // turns out that under some circumstances IE9 throws errors when one attempts to read
              // comment's node value.
              // Just ignore it and continue. (Can't seem to reproduce in test case.)
            }
          }

          /**
           * Given a node with an directive-start it collects all of the siblings until it finds
           * directive-end.
           * @param node
           * @param attrStart
           * @param attrEnd
           * @returns {*}
           */
          function groupScan(node, attrStart, attrEnd) {
            var nodes = [];
            var depth = 0;
            if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
              do {
                if (!node) {
                  throw $compileMinErr('uterdir', "Unterminated attribute, found '{0}' but no matching '{1}' found.", attrStart, attrEnd);
                }
                if (node.nodeType == NODE_TYPE_ELEMENT) {
                  if (node.hasAttribute(attrStart)) depth++;
                  if (node.hasAttribute(attrEnd)) depth--;
                }
                nodes.push(node);
                node = node.nextSibling;
              } while (depth > 0);
            } else {
              nodes.push(node);
            }

            return jqLite(nodes);
          }

          /**
           * Wrapper for linking function which converts normal linking function into a grouped
           * linking function.
           * @param linkFn
           * @param attrStart
           * @param attrEnd
           * @returns {Function}
           */
          function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
            return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
              element = groupScan(element[0], attrStart, attrEnd);
              return linkFn(scope, element, attrs, controllers, transcludeFn);
            };
          }

          /**
           * A function generator that is used to support both eager and lazy compilation
           * linking function.
           * @param eager
           * @param $compileNodes
           * @param transcludeFn
           * @param maxPriority
           * @param ignoreDirective
           * @param previousCompileContext
           * @returns {Function}
           */
          function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
            var compiled;

            if (eager) {
              return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
            }
            return function lazyCompilation() {
              if (!compiled) {
                compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

                // Null out all of these references in order to make them eligible for garbage collection
                // since this is a potentially long lived closure
                $compileNodes = transcludeFn = previousCompileContext = null;
              }
              return compiled.apply(this, arguments);
            };
          }

          /**
           * Once the directives have been collected, their compile functions are executed. This method
           * is responsible for inlining directive templates as well as terminating the application
           * of the directives if the terminal directive has been reached.
           *
           * @param {Array} directives Array of collected directives to execute their compile function.
           *        this needs to be pre-sorted by priority order.
           * @param {Node} compileNode The raw DOM node to apply the compile functions to
           * @param {Object} templateAttrs The shared attribute function
           * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
           *                                                  scope argument is auto-generated to the new
           *                                                  child of the transcluded parent scope.
           * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
           *                              argument has the root jqLite array so that we can replace nodes
           *                              on it.
           * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
           *                                           compiling the transclusion.
           * @param {Array.<Function>} preLinkFns
           * @param {Array.<Function>} postLinkFns
           * @param {Object} previousCompileContext Context used for previous compilation of the current
           *                                        node
           * @returns {Function} linkFn
           */
          function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
            previousCompileContext = previousCompileContext || {};

            var terminalPriority = -Number.MAX_VALUE,
                newScopeDirective = previousCompileContext.newScopeDirective,
                controllerDirectives = previousCompileContext.controllerDirectives,
                newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
                templateDirective = previousCompileContext.templateDirective,
                nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
                hasTranscludeDirective = false,
                hasTemplate = false,
                hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
                $compileNode = templateAttrs.$$element = jqLite(compileNode),
                directive,
                directiveName,
                $template,
                replaceDirective = originalReplaceDirective,
                childTranscludeFn = transcludeFn,
                linkFn,
                didScanForMultipleTransclusion = false,
                mightHaveMultipleTransclusionError = false,
                directiveValue;

            // executes all directives on the current element
            for (var i = 0, ii = directives.length; i < ii; i++) {
              directive = directives[i];
              var attrStart = directive.$$start;
              var attrEnd = directive.$$end;

              // collect multiblock sections
              if (attrStart) {
                $compileNode = groupScan(compileNode, attrStart, attrEnd);
              }
              $template = undefined;

              if (terminalPriority > directive.priority) {
                break; // prevent further processing of directives
              }

              if (directiveValue = directive.scope) {

                // skip the check for directives with async templates, we'll check the derived sync
                // directive when the template arrives
                if (!directive.templateUrl) {
                  if (isObject(directiveValue)) {
                    // This directive is trying to add an isolated scope.
                    // Check that there is no scope of any kind already
                    assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                    newIsolateScopeDirective = directive;
                  } else {
                    // This directive is trying to add a child scope.
                    // Check that there is no isolated scope already
                    assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive, $compileNode);
                  }
                }

                newScopeDirective = newScopeDirective || directive;
              }

              directiveName = directive.name;

              // If we encounter a condition that can result in transclusion on the directive,
              // then scan ahead in the remaining directives for others that may cause a multiple
              // transclusion error to be thrown during the compilation process.  If a matching directive
              // is found, then we know that when we encounter a transcluded directive, we need to eagerly
              // compile the `transclude` function rather than doing it lazily in order to throw
              // exceptions at the correct time
              if (!didScanForMultipleTransclusion && (directive.replace && (directive.templateUrl || directive.template) || directive.transclude && !directive.$$tlb)) {
                var candidateDirective;

                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
                  if (candidateDirective.transclude && !candidateDirective.$$tlb || candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template)) {
                    mightHaveMultipleTransclusionError = true;
                    break;
                  }
                }

                didScanForMultipleTransclusion = true;
              }

              if (!directive.templateUrl && directive.controller) {
                directiveValue = directive.controller;
                controllerDirectives = controllerDirectives || createMap();
                assertNoDuplicate("'" + directiveName + "' controller", controllerDirectives[directiveName], directive, $compileNode);
                controllerDirectives[directiveName] = directive;
              }

              if (directiveValue = directive.transclude) {
                hasTranscludeDirective = true;

                // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
                // This option should only be used by directives that know how to safely handle element transclusion,
                // where the transcluded nodes are added or replaced after linking.
                if (!directive.$$tlb) {
                  assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
                  nonTlbTranscludeDirective = directive;
                }

                if (directiveValue == 'element') {
                  hasElementTranscludeDirective = true;
                  terminalPriority = directive.priority;
                  $template = $compileNode;
                  $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
                  compileNode = $compileNode[0];
                  replaceWith(jqCollection, sliceArgs($template), compileNode);

                  // Support: Chrome < 50
                  // https://github.com/angular/angular.js/issues/14041

                  // In the versions of V8 prior to Chrome 50, the document fragment that is created
                  // in the `replaceWith` function is improperly garbage collected despite still
                  // being referenced by the `parentNode` property of all of the child nodes.  By adding
                  // a reference to the fragment via a different property, we can avoid that incorrect
                  // behavior.
                  // TODO: remove this line after Chrome 50 has been released
                  $template[0].$$parentNode = $template[0].parentNode;

                  childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {
                    // Don't pass in:
                    // - controllerDirectives - otherwise we'll create duplicates controllers
                    // - newIsolateScopeDirective or templateDirective - combining templates with
                    //   element transclusion doesn't make sense.
                    //
                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                    // on the same element more than once.
                    nonTlbTranscludeDirective: nonTlbTranscludeDirective
                  });
                } else {

                  var slots = createMap();

                  $template = jqLite(jqLiteClone(compileNode)).contents();

                  if (isObject(directiveValue)) {

                    // We have transclusion slots,
                    // collect them up, compile them and store their transclusion functions
                    $template = [];

                    var slotMap = createMap();
                    var filledSlots = createMap();

                    // Parse the element selectors
                    forEach(directiveValue, function (elementSelector, slotName) {
                      // If an element selector starts with a ? then it is optional
                      var optional = elementSelector.charAt(0) === '?';
                      elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                      slotMap[elementSelector] = slotName;

                      // We explicitly assign `null` since this implies that a slot was defined but not filled.
                      // Later when calling boundTransclusion functions with a slot name we only error if the
                      // slot is `undefined`
                      slots[slotName] = null;

                      // filledSlots contains `true` for all slots that are either optional or have been
                      // filled. This is used to check that we have not missed any required slots
                      filledSlots[slotName] = optional;
                    });

                    // Add the matching elements into their slot
                    forEach($compileNode.contents(), function (node) {
                      var slotName = slotMap[directiveNormalize(nodeName_(node))];
                      if (slotName) {
                        filledSlots[slotName] = true;
                        slots[slotName] = slots[slotName] || [];
                        slots[slotName].push(node);
                      } else {
                        $template.push(node);
                      }
                    });

                    // Check for required slots that were not filled
                    forEach(filledSlots, function (filled, slotName) {
                      if (!filled) {
                        throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                      }
                    });

                    for (var slotName in slots) {
                      if (slots[slotName]) {
                        // Only define a transclusion function if the slot was filled
                        slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                      }
                    }
                  }

                  $compileNode.empty(); // clear contents
                  childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope });
                  childTranscludeFn.$$slots = slots;
                }
              }

              if (directive.template) {
                hasTemplate = true;
                assertNoDuplicate('template', templateDirective, directive, $compileNode);
                templateDirective = directive;

                directiveValue = isFunction(directive.template) ? directive.template($compileNode, templateAttrs) : directive.template;

                directiveValue = denormalizeTemplate(directiveValue);

                if (directive.replace) {
                  replaceDirective = directive;
                  if (jqLiteIsTextNode(directiveValue)) {
                    $template = [];
                  } else {
                    $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
                  }
                  compileNode = $template[0];

                  if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                    throw $compileMinErr('tplrt', "Template for directive '{0}' must have exactly one root element. {1}", directiveName, '');
                  }

                  replaceWith(jqCollection, $compileNode, compileNode);

                  var newTemplateAttrs = { $attr: {} };

                  // combine directives from the original node and from the template:
                  // - take the array of directives for this element
                  // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
                  // - collect directives from the template and sort them by priority
                  // - combine directives as: processed + template + unprocessed
                  var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
                  var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

                  if (newIsolateScopeDirective || newScopeDirective) {
                    // The original directive caused the current element to be replaced but this element
                    // also needs to have a new scope, so we need to tell the template directives
                    // that they would need to get their scope from further up, if they require transclusion
                    markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
                  }
                  directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
                  mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

                  ii = directives.length;
                } else {
                  $compileNode.html(directiveValue);
                }
              }

              if (directive.templateUrl) {
                hasTemplate = true;
                assertNoDuplicate('template', templateDirective, directive, $compileNode);
                templateDirective = directive;

                if (directive.replace) {
                  replaceDirective = directive;
                }

                /* jshint -W021 */
                nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
                /* jshint +W021 */
                templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                  controllerDirectives: controllerDirectives,
                  newScopeDirective: newScopeDirective !== directive && newScopeDirective,
                  newIsolateScopeDirective: newIsolateScopeDirective,
                  templateDirective: templateDirective,
                  nonTlbTranscludeDirective: nonTlbTranscludeDirective
                });
                ii = directives.length;
              } else if (directive.compile) {
                try {
                  linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
                  var context = directive.$$originalDirective || directive;
                  if (isFunction(linkFn)) {
                    addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
                  } else if (linkFn) {
                    addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
                  }
                } catch (e) {
                  $exceptionHandler(e, startingTag($compileNode));
                }
              }

              if (directive.terminal) {
                nodeLinkFn.terminal = true;
                terminalPriority = Math.max(terminalPriority, directive.priority);
              }
            }

            nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
            nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
            nodeLinkFn.templateOnThisElement = hasTemplate;
            nodeLinkFn.transclude = childTranscludeFn;

            previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

            // might be normal or delayed nodeLinkFn depending on if templateUrl is present
            return nodeLinkFn;

            ////////////////////

            function addLinkFns(pre, post, attrStart, attrEnd) {
              if (pre) {
                if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
                pre.require = directive.require;
                pre.directiveName = directiveName;
                if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                  pre = cloneAndAnnotateFn(pre, { isolateScope: true });
                }
                preLinkFns.push(pre);
              }
              if (post) {
                if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
                post.require = directive.require;
                post.directiveName = directiveName;
                if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                  post = cloneAndAnnotateFn(post, { isolateScope: true });
                }
                postLinkFns.push(post);
              }
            }

            function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
              var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element, attrs, scopeBindingInfo;

              if (compileNode === linkNode) {
                attrs = templateAttrs;
                $element = templateAttrs.$$element;
              } else {
                $element = jqLite(linkNode);
                attrs = new Attributes($element, templateAttrs);
              }

              controllerScope = scope;
              if (newIsolateScopeDirective) {
                isolateScope = scope.$new(true);
              } else if (newScopeDirective) {
                controllerScope = scope.$parent;
              }

              if (boundTranscludeFn) {
                // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
                // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
                transcludeFn = controllersBoundTransclude;
                transcludeFn.$$boundTransclude = boundTranscludeFn;
                // expose the slots on the `$transclude` function
                transcludeFn.isSlotFilled = function (slotName) {
                  return !!boundTranscludeFn.$$slots[slotName];
                };
              }

              if (controllerDirectives) {
                elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
              }

              if (newIsolateScopeDirective) {
                // Initialize isolate scope bindings for new isolate scope directive.
                compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
                compile.$$addScopeClass($element, true);
                isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
                scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
                if (scopeBindingInfo.removeWatches) {
                  isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
                }
              }

              // Initialize bindToController bindings
              for (var name in elementControllers) {
                var controllerDirective = controllerDirectives[name];
                var controller = elementControllers[name];
                var bindings = controllerDirective.$$bindings.bindToController;

                if (controller.identifier && bindings) {
                  controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                } else {
                  controller.bindingInfo = {};
                }

                var controllerResult = controller();
                if (controllerResult !== controller.instance) {
                  // If the controller constructor has a return value, overwrite the instance
                  // from setupControllers
                  controller.instance = controllerResult;
                  $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
                  controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
                  controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                }
              }

              // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
              forEach(controllerDirectives, function (controllerDirective, name) {
                var require = controllerDirective.require;
                if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
                  extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
                }
              });

              // Handle the init and destroy lifecycle hooks on all controllers that have them
              forEach(elementControllers, function (controller) {
                var controllerInstance = controller.instance;
                if (isFunction(controllerInstance.$onChanges)) {
                  try {
                    controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (isFunction(controllerInstance.$onInit)) {
                  try {
                    controllerInstance.$onInit();
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (isFunction(controllerInstance.$doCheck)) {
                  controllerScope.$watch(function () {
                    controllerInstance.$doCheck();
                  });
                  controllerInstance.$doCheck();
                }
                if (isFunction(controllerInstance.$onDestroy)) {
                  controllerScope.$on('$destroy', function callOnDestroyHook() {
                    controllerInstance.$onDestroy();
                  });
                }
              });

              // PRELINKING
              for (i = 0, ii = preLinkFns.length; i < ii; i++) {
                linkFn = preLinkFns[i];
                invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
              }

              // RECURSION
              // We only pass the isolate scope, if the isolate directive has a template,
              // otherwise the child elements do not belong to the isolate directive.
              var scopeToChild = scope;
              if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
                scopeToChild = isolateScope;
              }
              childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);

              // POSTLINKING
              for (i = postLinkFns.length - 1; i >= 0; i--) {
                linkFn = postLinkFns[i];
                invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
              }

              // Trigger $postLink lifecycle hooks
              forEach(elementControllers, function (controller) {
                var controllerInstance = controller.instance;
                if (isFunction(controllerInstance.$postLink)) {
                  controllerInstance.$postLink();
                }
              });

              // This is the function that is injected as `$transclude`.
              // Note: all arguments are optional!
              function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
                var transcludeControllers;
                // No scope passed in:
                if (!isScope(scope)) {
                  slotName = futureParentElement;
                  futureParentElement = cloneAttachFn;
                  cloneAttachFn = scope;
                  scope = undefined;
                }

                if (hasElementTranscludeDirective) {
                  transcludeControllers = elementControllers;
                }
                if (!futureParentElement) {
                  futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
                }
                if (slotName) {
                  // slotTranscludeFn can be one of three things:
                  //  * a transclude function - a filled slot
                  //  * `null` - an optional slot that was not filled
                  //  * `undefined` - a slot that was not declared (i.e. invalid)
                  var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
                  if (slotTranscludeFn) {
                    return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                  } else if (isUndefined(slotTranscludeFn)) {
                    throw $compileMinErr('noslot', 'No parent directive that requires a transclusion with slot name "{0}". ' + 'Element: {1}', slotName, startingTag($element));
                  }
                } else {
                  return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                }
              }
            }
          }

          function getControllers(directiveName, require, $element, elementControllers) {
            var value;

            if (isString(require)) {
              var match = require.match(REQUIRE_PREFIX_REGEXP);
              var name = require.substring(match[0].length);
              var inheritType = match[1] || match[3];
              var optional = match[2] === '?';

              //If only parents then start at the parent element
              if (inheritType === '^^') {
                $element = $element.parent();
                //Otherwise attempt getting the controller from elementControllers in case
                //the element is transcluded (and has no data) and to avoid .data if possible
              } else {
                value = elementControllers && elementControllers[name];
                value = value && value.instance;
              }

              if (!value) {
                var dataName = '$' + name + 'Controller';
                value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
              }

              if (!value && !optional) {
                throw $compileMinErr('ctreq', "Controller '{0}', required by directive '{1}', can't be found!", name, directiveName);
              }
            } else if (isArray(require)) {
              value = [];
              for (var i = 0, ii = require.length; i < ii; i++) {
                value[i] = getControllers(directiveName, require[i], $element, elementControllers);
              }
            } else if (isObject(require)) {
              value = {};
              forEach(require, function (controller, property) {
                value[property] = getControllers(directiveName, controller, $element, elementControllers);
              });
            }

            return value || null;
          }

          function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
            var elementControllers = createMap();
            for (var controllerKey in controllerDirectives) {
              var directive = controllerDirectives[controllerKey];
              var locals = {
                $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
                $element: $element,
                $attrs: attrs,
                $transclude: transcludeFn
              };

              var controller = directive.controller;
              if (controller == '@') {
                controller = attrs[directive.name];
              }

              var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

              // For directives with element transclusion the element is a comment.
              // In this case .data will not attach any data.
              // Instead, we save the controllers for the element in a local hash and attach to .data
              // later, once we have the actual element.
              elementControllers[directive.name] = controllerInstance;
              $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
            }
            return elementControllers;
          }

          // Depending upon the context in which a directive finds itself it might need to have a new isolated
          // or child scope created. For instance:
          // * if the directive has been pulled into a template because another directive with a higher priority
          // asked for element transclusion
          // * if the directive itself asks for transclusion but it is at the root of a template and the original
          // element was replaced. See https://github.com/angular/angular.js/issues/12936
          function markDirectiveScope(directives, isolateScope, newScope) {
            for (var j = 0, jj = directives.length; j < jj; j++) {
              directives[j] = inherit(directives[j], { $$isolateScope: isolateScope, $$newScope: newScope });
            }
          }

          /**
           * looks up the directive and decorates it with exception handling and proper parameters. We
           * call this the boundDirective.
           *
           * @param {string} name name of the directive to look up.
           * @param {string} location The directive must be found in specific format.
           *   String containing any of theses characters:
           *
           *   * `E`: element name
           *   * `A': attribute
           *   * `C`: class
           *   * `M`: comment
           * @returns {boolean} true if directive was added.
           */
          function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
            if (name === ignoreDirective) return null;
            var match = null;
            if (hasDirectives.hasOwnProperty(name)) {
              for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
                try {
                  directive = directives[i];
                  if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) != -1) {
                    if (startAttrName) {
                      directive = inherit(directive, { $$start: startAttrName, $$end: endAttrName });
                    }
                    if (!directive.$$bindings) {
                      var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                      if (isObject(bindings.isolateScope)) {
                        directive.$$isolateBindings = bindings.isolateScope;
                      }
                    }
                    tDirectives.push(directive);
                    match = directive;
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }
            return match;
          }

          /**
           * looks up the directive and returns true if it is a multi-element directive,
           * and therefore requires DOM nodes between -start and -end markers to be grouped
           * together.
           *
           * @param {string} name name of the directive to look up.
           * @returns true if directive was registered as multi-element.
           */
          function directiveIsMultiElement(name) {
            if (hasDirectives.hasOwnProperty(name)) {
              for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
                directive = directives[i];
                if (directive.multiElement) {
                  return true;
                }
              }
            }
            return false;
          }

          /**
           * When the element is replaced with HTML template then the new attributes
           * on the template need to be merged with the existing attributes in the DOM.
           * The desired effect is to have both of the attributes present.
           *
           * @param {object} dst destination attributes (original DOM)
           * @param {object} src source attributes (from the directive template)
           */
          function mergeTemplateAttributes(dst, src) {
            var srcAttr = src.$attr,
                dstAttr = dst.$attr,
                $element = dst.$$element;

            // reapply the old attributes to the new element
            forEach(dst, function (value, key) {
              if (key.charAt(0) != '$') {
                if (src[key] && src[key] !== value) {
                  value += (key === 'style' ? ';' : ' ') + src[key];
                }
                dst.$set(key, value, true, srcAttr[key]);
              }
            });

            // copy the new attributes on the old attrs object
            forEach(src, function (value, key) {
              // Check if we already set this attribute in the loop above.
              // `dst` will never contain hasOwnProperty as DOM parser won't let it.
              // You will get an "InvalidCharacterError: DOM Exception 5" error if you
              // have an attribute like "has-own-property" or "data-has-own-property", etc.
              if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
                dst[key] = value;

                if (key !== 'class' && key !== 'style') {
                  dstAttr[key] = srcAttr[key];
                }
              }
            });
          }

          function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
            var linkQueue = [],
                afterTemplateNodeLinkFn,
                afterTemplateChildLinkFn,
                beforeTemplateCompileNode = $compileNode[0],
                origAsyncDirective = directives.shift(),
                derivedSyncDirective = inherit(origAsyncDirective, {
              templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
            }),
                templateUrl = isFunction(origAsyncDirective.templateUrl) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl,
                templateNamespace = origAsyncDirective.templateNamespace;

            $compileNode.empty();

            $templateRequest(templateUrl).then(function (content) {
              var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

              content = denormalizeTemplate(content);

              if (origAsyncDirective.replace) {
                if (jqLiteIsTextNode(content)) {
                  $template = [];
                } else {
                  $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
                }
                compileNode = $template[0];

                if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                  throw $compileMinErr('tplrt', "Template for directive '{0}' must have exactly one root element. {1}", origAsyncDirective.name, templateUrl);
                }

                tempTemplateAttrs = { $attr: {} };
                replaceWith($rootElement, $compileNode, compileNode);
                var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

                if (isObject(origAsyncDirective.scope)) {
                  // the original directive that caused the template to be loaded async required
                  // an isolate scope
                  markDirectiveScope(templateDirectives, true);
                }
                directives = templateDirectives.concat(directives);
                mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
              } else {
                compileNode = beforeTemplateCompileNode;
                $compileNode.html(content);
              }

              directives.unshift(derivedSyncDirective);

              afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
              forEach($rootElement, function (node, i) {
                if (node == compileNode) {
                  $rootElement[i] = $compileNode[0];
                }
              });
              afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

              while (linkQueue.length) {
                var scope = linkQueue.shift(),
                    beforeTemplateLinkNode = linkQueue.shift(),
                    linkRootElement = linkQueue.shift(),
                    boundTranscludeFn = linkQueue.shift(),
                    linkNode = $compileNode[0];

                if (scope.$$destroyed) continue;

                if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
                  var oldClasses = beforeTemplateLinkNode.className;

                  if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) {
                    // it was cloned therefore we have to clone as well.
                    linkNode = jqLiteClone(compileNode);
                  }
                  replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

                  // Copy in CSS classes from original node
                  safeAddClass(jqLite(linkNode), oldClasses);
                }
                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                } else {
                  childBoundTranscludeFn = boundTranscludeFn;
                }
                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
              }
              linkQueue = null;
            });

            return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
              var childBoundTranscludeFn = boundTranscludeFn;
              if (scope.$$destroyed) return;
              if (linkQueue) {
                linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
              } else {
                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                }
                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
              }
            };
          }

          /**
           * Sorting function for bound directives.
           */
          function byPriority(a, b) {
            var diff = b.priority - a.priority;
            if (diff !== 0) return diff;
            if (a.name !== b.name) return a.name < b.name ? -1 : 1;
            return a.index - b.index;
          }

          function assertNoDuplicate(what, previousDirective, directive, element) {

            function wrapModuleNameIfDefined(moduleName) {
              return moduleName ? ' (module: ' + moduleName + ')' : '';
            }

            if (previousDirective) {
              throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}', previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
            }
          }

          function addTextInterpolateDirective(directives, text) {
            var interpolateFn = $interpolate(text, true);
            if (interpolateFn) {
              directives.push({
                priority: 0,
                compile: function textInterpolateCompileFn(templateNode) {
                  var templateNodeParent = templateNode.parent(),
                      hasCompileParent = !!templateNodeParent.length;

                  // When transcluding a template that has bindings in the root
                  // we don't have a parent and thus need to add the class during linking fn.
                  if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

                  return function textInterpolateLinkFn(scope, node) {
                    var parent = node.parent();
                    if (!hasCompileParent) compile.$$addBindingClass(parent);
                    compile.$$addBindingInfo(parent, interpolateFn.expressions);
                    scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                      node[0].nodeValue = value;
                    });
                  };
                }
              });
            }
          }

          function wrapTemplate(type, template) {
            type = lowercase(type || 'html');
            switch (type) {
              case 'svg':
              case 'math':
                var wrapper = window.document.createElement('div');
                wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
                return wrapper.childNodes[0].childNodes;
              default:
                return template;
            }
          }

          function getTrustedContext(node, attrNormalizedName) {
            if (attrNormalizedName == "srcdoc") {
              return $sce.HTML;
            }
            var tag = nodeName_(node);
            // maction[xlink:href] can source SVG.  It's not limited to <maction>.
            if (attrNormalizedName == "xlinkHref" || tag == "form" && attrNormalizedName == "action" || tag != "img" && (attrNormalizedName == "src" || attrNormalizedName == "ngSrc")) {
              return $sce.RESOURCE_URL;
            }
          }

          function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
            var trustedContext = getTrustedContext(node, name);
            allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;

            var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);

            // no interpolation found -> ignore
            if (!interpolateFn) return;

            if (name === "multiple" && nodeName_(node) === "select") {
              throw $compileMinErr("selmulti", "Binding to the 'multiple' attribute is not supported. Element: {0}", startingTag(node));
            }

            directives.push({
              priority: 100,
              compile: function () {
                return {
                  pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                    var $$observers = attr.$$observers || (attr.$$observers = createMap());

                    if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
                      throw $compileMinErr('nodomevents', "Interpolations for HTML DOM event attributes are disallowed.  Please use the " + "ng- versions (such as ng-click instead of onclick) instead.");
                    }

                    // If the attribute has changed since last $interpolate()ed
                    var newValue = attr[name];
                    if (newValue !== value) {
                      // we need to interpolate again since the attribute value has been updated
                      // (e.g. by another directive's compile function)
                      // ensure unset/empty values make interpolateFn falsy
                      interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                      value = newValue;
                    }

                    // if attribute was updated so that there is no interpolation going on we don't want to
                    // register any observers
                    if (!interpolateFn) return;

                    // initialize attr object so that it's ready in case we need the value for isolate
                    // scope initialization, otherwise the value would not be available from isolate
                    // directive's linking fn during linking phase
                    attr[name] = interpolateFn(scope);

                    ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                    (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                      //special case for class attribute addition + removal
                      //so that class changes can tap into the animation
                      //hooks provided by the $animate service. Be sure to
                      //skip animations when the first digest occurs (when
                      //both the new and the old values are the same) since
                      //the CSS classes are the non-interpolated values
                      if (name === 'class' && newValue != oldValue) {
                        attr.$updateClass(newValue, oldValue);
                      } else {
                        attr.$set(name, newValue);
                      }
                    });
                  }
                };
              }
            });
          }

          /**
           * This is a special jqLite.replaceWith, which can replace items which
           * have no parents, provided that the containing jqLite collection is provided.
           *
           * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
           *                               in the root of the tree.
           * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
           *                                  the shell, but replace its DOM node reference.
           * @param {Node} newNode The new DOM node.
           */
          function replaceWith($rootElement, elementsToRemove, newNode) {
            var firstElementToRemove = elementsToRemove[0],
                removeCount = elementsToRemove.length,
                parent = firstElementToRemove.parentNode,
                i,
                ii;

            if ($rootElement) {
              for (i = 0, ii = $rootElement.length; i < ii; i++) {
                if ($rootElement[i] == firstElementToRemove) {
                  $rootElement[i++] = newNode;
                  for (var j = i, j2 = j + removeCount - 1, jj = $rootElement.length; j < jj; j++, j2++) {
                    if (j2 < jj) {
                      $rootElement[j] = $rootElement[j2];
                    } else {
                      delete $rootElement[j];
                    }
                  }
                  $rootElement.length -= removeCount - 1;

                  // If the replaced element is also the jQuery .context then replace it
                  // .context is a deprecated jQuery api, so we should set it only when jQuery set it
                  // http://api.jquery.com/context/
                  if ($rootElement.context === firstElementToRemove) {
                    $rootElement.context = newNode;
                  }
                  break;
                }
              }
            }

            if (parent) {
              parent.replaceChild(newNode, firstElementToRemove);
            }

            // Append all the `elementsToRemove` to a fragment. This will...
            // - remove them from the DOM
            // - allow them to still be traversed with .nextSibling
            // - allow a single fragment.qSA to fetch all elements being removed
            var fragment = window.document.createDocumentFragment();
            for (i = 0; i < removeCount; i++) {
              fragment.appendChild(elementsToRemove[i]);
            }

            if (jqLite.hasData(firstElementToRemove)) {
              // Copy over user data (that includes Angular's $scope etc.). Don't copy private
              // data here because there's no public interface in jQuery to do that and copying over
              // event listeners (which is the main use of private data) wouldn't work anyway.
              jqLite.data(newNode, jqLite.data(firstElementToRemove));

              // Remove $destroy event listeners from `firstElementToRemove`
              jqLite(firstElementToRemove).off('$destroy');
            }

            // Cleanup any data/listeners on the elements and children.
            // This includes invoking the $destroy event on any elements with listeners.
            jqLite.cleanData(fragment.querySelectorAll('*'));

            // Update the jqLite collection to only contain the `newNode`
            for (i = 1; i < removeCount; i++) {
              delete elementsToRemove[i];
            }
            elementsToRemove[0] = newNode;
            elementsToRemove.length = 1;
          }

          function cloneAndAnnotateFn(fn, annotation) {
            return extend(function () {
              return fn.apply(null, arguments);
            }, fn, annotation);
          }

          function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
            try {
              linkFn(scope, $element, attrs, controllers, transcludeFn);
            } catch (e) {
              $exceptionHandler(e, startingTag($element));
            }
          }

          // Set up $watches for isolate scope and controller bindings. This process
          // only occurs for isolate scopes and new scopes with controllerAs.
          function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
            var removeWatchCollection = [];
            var initialChanges = {};
            var changes;
            forEach(bindings, function initializeBinding(definition, scopeName) {
              var attrName = definition.attrName,
                  optional = definition.optional,
                  mode = definition.mode,
                  // @, =, <, or &
              lastValue,
                  parentGet,
                  parentSet,
                  compare,
                  removeWatch;

              switch (mode) {

                case '@':
                  if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                    destination[scopeName] = attrs[attrName] = void 0;
                  }
                  attrs.$observe(attrName, function (value) {
                    if (isString(value) || isBoolean(value)) {
                      var oldValue = destination[scopeName];
                      recordChanges(scopeName, value, oldValue);
                      destination[scopeName] = value;
                    }
                  });
                  attrs.$$observers[attrName].$$scope = scope;
                  lastValue = attrs[attrName];
                  if (isString(lastValue)) {
                    // If the attribute has been provided then we trigger an interpolation to ensure
                    // the value is there for use in the link fn
                    destination[scopeName] = $interpolate(lastValue)(scope);
                  } else if (isBoolean(lastValue)) {
                    // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
                    // the value to boolean rather than a string, so we special case this situation
                    destination[scopeName] = lastValue;
                  }
                  initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                  break;

                case '=':
                  if (!hasOwnProperty.call(attrs, attrName)) {
                    if (optional) break;
                    attrs[attrName] = void 0;
                  }
                  if (optional && !attrs[attrName]) break;

                  parentGet = $parse(attrs[attrName]);
                  if (parentGet.literal) {
                    compare = equals;
                  } else {
                    compare = function simpleCompare(a, b) {
                      return a === b || a !== a && b !== b;
                    };
                  }
                  parentSet = parentGet.assign || function () {
                    // reset the change, or we will throw this exception on every $digest
                    lastValue = destination[scopeName] = parentGet(scope);
                    throw $compileMinErr('nonassign', "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!", attrs[attrName], attrName, directive.name);
                  };
                  lastValue = destination[scopeName] = parentGet(scope);
                  var parentValueWatch = function parentValueWatch(parentValue) {
                    if (!compare(parentValue, destination[scopeName])) {
                      // we are out of sync and need to copy
                      if (!compare(parentValue, lastValue)) {
                        // parent changed and it has precedence
                        destination[scopeName] = parentValue;
                      } else {
                        // if the parent can be assigned then do so
                        parentSet(scope, parentValue = destination[scopeName]);
                      }
                    }
                    return lastValue = parentValue;
                  };
                  parentValueWatch.$stateful = true;
                  if (definition.collection) {
                    removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                  } else {
                    removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                  }
                  removeWatchCollection.push(removeWatch);
                  break;

                case '<':
                  if (!hasOwnProperty.call(attrs, attrName)) {
                    if (optional) break;
                    attrs[attrName] = void 0;
                  }
                  if (optional && !attrs[attrName]) break;

                  parentGet = $parse(attrs[attrName]);

                  var initialValue = destination[scopeName] = parentGet(scope);
                  initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

                  removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
                    if (oldValue === newValue) {
                      if (oldValue === initialValue) return;
                      oldValue = initialValue;
                    }
                    recordChanges(scopeName, newValue, oldValue);
                    destination[scopeName] = newValue;
                  }, parentGet.literal);

                  removeWatchCollection.push(removeWatch);
                  break;

                case '&':
                  // Don't assign Object.prototype method to scope
                  parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

                  // Don't assign noop to destination if expression is not valid
                  if (parentGet === noop && optional) break;

                  destination[scopeName] = function (locals) {
                    return parentGet(scope, locals);
                  };
                  break;
              }
            });

            function recordChanges(key, currentValue, previousValue) {
              if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
                // If we have not already scheduled the top level onChangesQueue handler then do so now
                if (!onChangesQueue) {
                  scope.$$postDigest(flushOnChangesQueue);
                  onChangesQueue = [];
                }
                // If we have not already queued a trigger of onChanges for this controller then do so now
                if (!changes) {
                  changes = {};
                  onChangesQueue.push(triggerOnChangesHook);
                }
                // If the has been a change on this property already then we need to reuse the previous value
                if (changes[key]) {
                  previousValue = changes[key].previousValue;
                }
                // Store this change
                changes[key] = new SimpleChange(previousValue, currentValue);
              }
            }

            function triggerOnChangesHook() {
              destination.$onChanges(changes);
              // Now clear the changes so that we schedule onChanges when more changes arrive
              changes = undefined;
            }

            return {
              initialChanges: initialChanges,
              removeWatches: removeWatchCollection.length && function removeWatches() {
                for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
                  removeWatchCollection[i]();
                }
              }
            };
          }
        }];
      }

      function SimpleChange(previous, current) {
        this.previousValue = previous;
        this.currentValue = current;
      }
      SimpleChange.prototype.isFirstChange = function () {
        return this.previousValue === _UNINITIALIZED_VALUE;
      };

      var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
      /**
       * Converts all accepted directives format into proper directive name.
       * @param name Name to normalize
       */
      function directiveNormalize(name) {
        return camelCase(name.replace(PREFIX_REGEXP, ''));
      }

      /**
       * @ngdoc type
       * @name $compile.directive.Attributes
       *
       * @description
       * A shared object between directive compile / linking functions which contains normalized DOM
       * element attributes. The values reflect current binding state `{{ }}`. The normalization is
       * needed since all of these are treated as equivalent in Angular:
       *
       * ```
       *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
       * ```
       */

      /**
       * @ngdoc property
       * @name $compile.directive.Attributes#$attr
       *
       * @description
       * A map of DOM element attribute names to the normalized name. This is
       * needed to do reverse lookup from normalized name back to actual name.
       */

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$set
       * @kind function
       *
       * @description
       * Set DOM element attribute value.
       *
       *
       * @param {string} name Normalized element attribute name of the property to modify. The name is
       *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
       *          property to the original name.
       * @param {string} value Value to set the attribute to. The value can be an interpolated string.
       */

      /**
       * Closure compiler type information
       */

      function nodesetLinkingFn(
      /* angular.Scope */scope,
      /* NodeList */nodeList,
      /* Element */rootElement,
      /* function(Function) */boundTranscludeFn) {}

      function directiveLinkingFn(
      /* nodesetLinkingFn */nodesetLinkingFn,
      /* angular.Scope */scope,
      /* Node */node,
      /* Element */rootElement,
      /* function(Function) */boundTranscludeFn) {}

      function tokenDifference(str1, str2) {
        var values = '',
            tokens1 = str1.split(/\s+/),
            tokens2 = str2.split(/\s+/);

        outer: for (var i = 0; i < tokens1.length; i++) {
          var token = tokens1[i];
          for (var j = 0; j < tokens2.length; j++) {
            if (token == tokens2[j]) continue outer;
          }
          values += (values.length > 0 ? ' ' : '') + token;
        }
        return values;
      }

      function removeComments(jqNodes) {
        jqNodes = jqLite(jqNodes);
        var i = jqNodes.length;

        if (i <= 1) {
          return jqNodes;
        }

        while (i--) {
          var node = jqNodes[i];
          if (node.nodeType === NODE_TYPE_COMMENT) {
            splice.call(jqNodes, i, 1);
          }
        }
        return jqNodes;
      }

      var $controllerMinErr = minErr('$controller');

      var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
      function identifierForController(controller, ident) {
        if (ident && isString(ident)) return ident;
        if (isString(controller)) {
          var match = CNTRL_REG.exec(controller);
          if (match) return match[3];
        }
      }

      /**
       * @ngdoc provider
       * @name $controllerProvider
       * @description
       * The {@link ng.$controller $controller service} is used by Angular to create new
       * controllers.
       *
       * This provider allows controller registration via the
       * {@link ng.$controllerProvider#register register} method.
       */
      function $ControllerProvider() {
        var controllers = {},
            globals = false;

        /**
         * @ngdoc method
         * @name $controllerProvider#has
         * @param {string} name Controller name to check.
         */
        this.has = function (name) {
          return controllers.hasOwnProperty(name);
        };

        /**
         * @ngdoc method
         * @name $controllerProvider#register
         * @param {string|Object} name Controller name, or an object map of controllers where the keys are
         *    the names and the values are the constructors.
         * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
         *    annotations in the array notation).
         */
        this.register = function (name, constructor) {
          assertNotHasOwnProperty(name, 'controller');
          if (isObject(name)) {
            extend(controllers, name);
          } else {
            controllers[name] = constructor;
          }
        };

        /**
         * @ngdoc method
         * @name $controllerProvider#allowGlobals
         * @description If called, allows `$controller` to find controller constructors on `window`
         */
        this.allowGlobals = function () {
          globals = true;
        };

        this.$get = ['$injector', '$window', function ($injector, $window) {

          /**
           * @ngdoc service
           * @name $controller
           * @requires $injector
           *
           * @param {Function|string} constructor If called with a function then it's considered to be the
           *    controller constructor function. Otherwise it's considered to be a string which is used
           *    to retrieve the controller constructor using the following steps:
           *
           *    * check if a controller with given name is registered via `$controllerProvider`
           *    * check if evaluating the string on the current scope returns a constructor
           *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
           *      `window` object (not recommended)
           *
           *    The string can use the `controller as property` syntax, where the controller instance is published
           *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
           *    to work correctly.
           *
           * @param {Object} locals Injection locals for Controller.
           * @return {Object} Instance of given controller.
           *
           * @description
           * `$controller` service is responsible for instantiating controllers.
           *
           * It's just a simple call to {@link auto.$injector $injector}, but extracted into
           * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
           */
          return function $controller(expression, locals, later, ident) {
            // PRIVATE API:
            //   param `later` --- indicates that the controller's constructor is invoked at a later time.
            //                     If true, $controller will allocate the object with the correct
            //                     prototype chain, but will not invoke the controller until a returned
            //                     callback is invoked.
            //   param `ident` --- An optional label which overrides the label parsed from the controller
            //                     expression, if any.
            var instance, match, constructor, identifier;
            later = later === true;
            if (ident && isString(ident)) {
              identifier = ident;
            }

            if (isString(expression)) {
              match = expression.match(CNTRL_REG);
              if (!match) {
                throw $controllerMinErr('ctrlfmt', "Badly formed controller string '{0}'. " + "Must match `__name__ as __id__` or `__name__`.", expression);
              }
              constructor = match[1], identifier = identifier || match[3];
              expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true) || (globals ? getter($window, constructor, true) : undefined);

              assertArgFn(expression, constructor, true);
            }

            if (later) {
              // Instantiate controller later:
              // This machinery is used to create an instance of the object before calling the
              // controller's constructor itself.
              //
              // This allows properties to be added to the controller before the constructor is
              // invoked. Primarily, this is used for isolate scope bindings in $compile.
              //
              // This feature is not intended for use by applications, and is thus not documented
              // publicly.
              // Object creation: http://jsperf.com/create-constructor/2
              var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
              instance = Object.create(controllerPrototype || null);

              if (identifier) {
                addIdentifier(locals, identifier, instance, constructor || expression.name);
              }

              var instantiate;
              return instantiate = extend(function $controllerInit() {
                var result = $injector.invoke(expression, instance, locals, constructor);
                if (result !== instance && (isObject(result) || isFunction(result))) {
                  instance = result;
                  if (identifier) {
                    // If result changed, re-assign controllerAs value to scope.
                    addIdentifier(locals, identifier, instance, constructor || expression.name);
                  }
                }
                return instance;
              }, {
                instance: instance,
                identifier: identifier
              });
            }

            instance = $injector.instantiate(expression, locals, constructor);

            if (identifier) {
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }

            return instance;
          };

          function addIdentifier(locals, identifier, instance, name) {
            if (!(locals && isObject(locals.$scope))) {
              throw minErr('$controller')('noscp', "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.", name, identifier);
            }

            locals.$scope[identifier] = instance;
          }
        }];
      }

      /**
       * @ngdoc service
       * @name $document
       * @requires $window
       *
       * @description
       * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
       *
       * @example
         <example module="documentExample">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <p>$document title: <b ng-bind="title"></b></p>
               <p>window.document title: <b ng-bind="windowTitle"></b></p>
             </div>
           </file>
           <file name="script.js">
             angular.module('documentExample', [])
               .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
                 $scope.title = $document[0].title;
                 $scope.windowTitle = angular.element(window.document)[0].title;
               }]);
           </file>
         </example>
       */
      function $DocumentProvider() {
        this.$get = ['$window', function (window) {
          return jqLite(window.document);
        }];
      }

      /**
       * @ngdoc service
       * @name $exceptionHandler
       * @requires ng.$log
       *
       * @description
       * Any uncaught exception in angular expressions is delegated to this service.
       * The default implementation simply delegates to `$log.error` which logs it into
       * the browser console.
       *
       * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
       * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
       *
       * ## Example:
       *
       * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
       * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
       * of `$log.error()`.
       *
       * ```js
       *   angular.
       *     module('exceptionOverwrite', []).
       *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
       *       return function myExceptionHandler(exception, cause) {
       *         logErrorsToBackend(exception, cause);
       *         $log.warn(exception, cause);
       *       };
       *     }]);
       * ```
       *
       * <hr />
       * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
       * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
       * (unless executed during a digest).
       *
       * If you wish, you can manually delegate exceptions, e.g.
       * `try { ... } catch(e) { $exceptionHandler(e); }`
       *
       * @param {Error} exception Exception associated with the error.
       * @param {string=} cause Optional information about the context in which
       *       the error was thrown.
       *
       */
      function $ExceptionHandlerProvider() {
        this.$get = ['$log', function ($log) {
          return function (exception, cause) {
            $log.error.apply($log, arguments);
          };
        }];
      }

      var $$ForceReflowProvider = function () {
        this.$get = ['$document', function ($document) {
          return function (domNode) {
            //the line below will force the browser to perform a repaint so
            //that all the animated elements within the animation frame will
            //be properly updated and drawn on screen. This is required to
            //ensure that the preparation animation is properly flushed so that
            //the active state picks up from there. DO NOT REMOVE THIS LINE.
            //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
            //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
            //WILL TAKE YEARS AWAY FROM YOUR LIFE.
            if (domNode) {
              if (!domNode.nodeType && domNode instanceof jqLite) {
                domNode = domNode[0];
              }
            } else {
              domNode = $document[0].body;
            }
            return domNode.offsetWidth + 1;
          };
        }];
      };

      var APPLICATION_JSON = 'application/json';
      var CONTENT_TYPE_APPLICATION_JSON = { 'Content-Type': APPLICATION_JSON + ';charset=utf-8' };
      var JSON_START = /^\[|^\{(?!\{)/;
      var JSON_ENDS = {
        '[': /]$/,
        '{': /}$/
      };
      var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
      var $httpMinErr = minErr('$http');
      var $httpMinErrLegacyFn = function (method) {
        return function () {
          throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
        };
      };

      function serializeValue(v) {
        if (isObject(v)) {
          return isDate(v) ? v.toISOString() : toJson(v);
        }
        return v;
      }

      function $HttpParamSerializerProvider() {
        /**
         * @ngdoc service
         * @name $httpParamSerializer
         * @description
         *
         * Default {@link $http `$http`} params serializer that converts objects to strings
         * according to the following rules:
         *
         * * `{'foo': 'bar'}` results in `foo=bar`
         * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
         * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
         * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
         *
         * Note that serializer will sort the request parameters alphabetically.
         * */

        this.$get = function () {
          return function ngParamSerializer(params) {
            if (!params) return '';
            var parts = [];
            forEachSorted(params, function (value, key) {
              if (value === null || isUndefined(value)) return;
              if (isArray(value)) {
                forEach(value, function (v) {
                  parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(v)));
                });
              } else {
                parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
              }
            });

            return parts.join('&');
          };
        };
      }

      function $HttpParamSerializerJQLikeProvider() {
        /**
         * @ngdoc service
         * @name $httpParamSerializerJQLike
         * @description
         *
         * Alternative {@link $http `$http`} params serializer that follows
         * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
         * The serializer will also sort the params alphabetically.
         *
         * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
         *
         * ```js
         * $http({
         *   url: myUrl,
         *   method: 'GET',
         *   params: myParams,
         *   paramSerializer: '$httpParamSerializerJQLike'
         * });
         * ```
         *
         * It is also possible to set it as the default `paramSerializer` in the
         * {@link $httpProvider#defaults `$httpProvider`}.
         *
         * Additionally, you can inject the serializer and use it explicitly, for example to serialize
         * form data for submission:
         *
         * ```js
         * .controller(function($http, $httpParamSerializerJQLike) {
         *   //...
         *
         *   $http({
         *     url: myUrl,
         *     method: 'POST',
         *     data: $httpParamSerializerJQLike(myData),
         *     headers: {
         *       'Content-Type': 'application/x-www-form-urlencoded'
         *     }
         *   });
         *
         * });
         * ```
         *
         * */
        this.$get = function () {
          return function jQueryLikeParamSerializer(params) {
            if (!params) return '';
            var parts = [];
            serialize(params, '', true);
            return parts.join('&');

            function serialize(toSerialize, prefix, topLevel) {
              if (toSerialize === null || isUndefined(toSerialize)) return;
              if (isArray(toSerialize)) {
                forEach(toSerialize, function (value, index) {
                  serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
                });
              } else if (isObject(toSerialize) && !isDate(toSerialize)) {
                forEachSorted(toSerialize, function (value, key) {
                  serialize(value, prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'));
                });
              } else {
                parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
              }
            }
          };
        };
      }

      function defaultHttpResponseTransform(data, headers) {
        if (isString(data)) {
          // Strip json vulnerability protection prefix and trim whitespace
          var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

          if (tempData) {
            var contentType = headers('Content-Type');
            if (contentType && contentType.indexOf(APPLICATION_JSON) === 0 || isJsonLike(tempData)) {
              data = fromJson(tempData);
            }
          }
        }

        return data;
      }

      function isJsonLike(str) {
        var jsonStart = str.match(JSON_START);
        return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
      }

      /**
       * Parse headers into key value object
       *
       * @param {string} headers Raw headers as a string
       * @returns {Object} Parsed headers as key value object
       */
      function parseHeaders(headers) {
        var parsed = createMap(),
            i;

        function fillInParsed(key, val) {
          if (key) {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
          }
        }

        if (isString(headers)) {
          forEach(headers.split('\n'), function (line) {
            i = line.indexOf(':');
            fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
          });
        } else if (isObject(headers)) {
          forEach(headers, function (headerVal, headerKey) {
            fillInParsed(lowercase(headerKey), trim(headerVal));
          });
        }

        return parsed;
      }

      /**
       * Returns a function that provides access to parsed headers.
       *
       * Headers are lazy parsed when first requested.
       * @see parseHeaders
       *
       * @param {(string|Object)} headers Headers to provide access to.
       * @returns {function(string=)} Returns a getter function which if called with:
       *
       *   - if called with single an argument returns a single header value or null
       *   - if called with no arguments returns an object containing all headers.
       */
      function headersGetter(headers) {
        var headersObj;

        return function (name) {
          if (!headersObj) headersObj = parseHeaders(headers);

          if (name) {
            var value = headersObj[lowercase(name)];
            if (value === void 0) {
              value = null;
            }
            return value;
          }

          return headersObj;
        };
      }

      /**
       * Chain all given functions
       *
       * This function is used for both request and response transforming
       *
       * @param {*} data Data to transform.
       * @param {function(string=)} headers HTTP headers getter fn.
       * @param {number} status HTTP status code of the response.
       * @param {(Function|Array.<Function>)} fns Function or an array of functions.
       * @returns {*} Transformed data.
       */
      function transformData(data, headers, status, fns) {
        if (isFunction(fns)) {
          return fns(data, headers, status);
        }

        forEach(fns, function (fn) {
          data = fn(data, headers, status);
        });

        return data;
      }

      function isSuccess(status) {
        return 200 <= status && status < 300;
      }

      /**
       * @ngdoc provider
       * @name $httpProvider
       * @description
       * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
       * */
      function $HttpProvider() {
        /**
         * @ngdoc property
         * @name $httpProvider#defaults
         * @description
         *
         * Object containing default values for all {@link ng.$http $http} requests.
         *
         * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
         * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
         * by default. See {@link $http#caching $http Caching} for more information.
         *
         * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
         * Defaults value is `'XSRF-TOKEN'`.
         *
         * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
         * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
         *
         * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
         * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
         * setting default headers.
         *     - **`defaults.headers.common`**
         *     - **`defaults.headers.post`**
         *     - **`defaults.headers.put`**
         *     - **`defaults.headers.patch`**
         *
         *
         * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
         *  used to the prepare string representation of request parameters (specified as an object).
         *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
         *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
         *
         **/
        var defaults = this.defaults = {
          // transform incoming response data
          transformResponse: [defaultHttpResponseTransform],

          // transform outgoing request data
          transformRequest: [function (d) {
            return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
          }],

          // default headers
          headers: {
            common: {
              'Accept': 'application/json, text/plain, */*'
            },
            post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
            put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
            patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
          },

          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',

          paramSerializer: '$httpParamSerializer'
        };

        var useApplyAsync = false;
        /**
         * @ngdoc method
         * @name $httpProvider#useApplyAsync
         * @description
         *
         * Configure $http service to combine processing of multiple http responses received at around
         * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
         * significant performance improvement for bigger applications that make many HTTP requests
         * concurrently (common during application bootstrap).
         *
         * Defaults to false. If no value is specified, returns the current configured value.
         *
         * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
         *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
         *    to load and share the same digest cycle.
         *
         * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
         *    otherwise, returns the current configured value.
         **/
        this.useApplyAsync = function (value) {
          if (isDefined(value)) {
            useApplyAsync = !!value;
            return this;
          }
          return useApplyAsync;
        };

        var useLegacyPromise = true;
        /**
         * @ngdoc method
         * @name $httpProvider#useLegacyPromiseExtensions
         * @description
         *
         * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
         * This should be used to make sure that applications work without these methods.
         *
         * Defaults to true. If no value is specified, returns the current configured value.
         *
         * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
         *
         * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
         *    otherwise, returns the current configured value.
         **/
        this.useLegacyPromiseExtensions = function (value) {
          if (isDefined(value)) {
            useLegacyPromise = !!value;
            return this;
          }
          return useLegacyPromise;
        };

        /**
         * @ngdoc property
         * @name $httpProvider#interceptors
         * @description
         *
         * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
         * pre-processing of request or postprocessing of responses.
         *
         * These service factories are ordered by request, i.e. they are applied in the same order as the
         * array, on request, but reverse order, on response.
         *
         * {@link ng.$http#interceptors Interceptors detailed info}
         **/
        var interceptorFactories = this.interceptors = [];

        this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', function ($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {

          var defaultCache = $cacheFactory('$http');

          /**
           * Make sure that default param serializer is exposed as a function
           */
          defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

          /**
           * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
           * The reversal is needed so that we can build up the interception chain around the
           * server request.
           */
          var reversedInterceptors = [];

          forEach(interceptorFactories, function (interceptorFactory) {
            reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
          });

          /**
           * @ngdoc service
           * @kind function
           * @name $http
           * @requires ng.$httpBackend
           * @requires $cacheFactory
           * @requires $rootScope
           * @requires $q
           * @requires $injector
           *
           * @description
           * The `$http` service is a core Angular service that facilitates communication with the remote
           * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
           * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
           *
           * For unit testing applications that use `$http` service, see
           * {@link ngMock.$httpBackend $httpBackend mock}.
           *
           * For a higher level of abstraction, please check out the {@link ngResource.$resource
           * $resource} service.
           *
           * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
           * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
           * it is important to familiarize yourself with these APIs and the guarantees they provide.
           *
           *
           * ## General usage
           * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
           * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
           *
           * ```js
           *   // Simple GET request example:
           *   $http({
           *     method: 'GET',
           *     url: '/someUrl'
           *   }).then(function successCallback(response) {
           *       // this callback will be called asynchronously
           *       // when the response is available
           *     }, function errorCallback(response) {
           *       // called asynchronously if an error occurs
           *       // or server returns response with an error status.
           *     });
           * ```
           *
           * The response object has these properties:
           *
           *   - **data** – `{string|Object}` – The response body transformed with the transform
           *     functions.
           *   - **status** – `{number}` – HTTP status code of the response.
           *   - **headers** – `{function([headerName])}` – Header getter function.
           *   - **config** – `{Object}` – The configuration object that was used to generate the request.
           *   - **statusText** – `{string}` – HTTP status text of the response.
           *
           * A response status code between 200 and 299 is considered a success status and will result in
           * the success callback being called. Any response status code outside of that range is
           * considered an error status and will result in the error callback being called.
           * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
           * aborted, e.g. using a `config.timeout`.
           * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
           * that the outcome (success or error) will be determined by the final response status code.
           *
           *
           * ## Shortcut methods
           *
           * Shortcut methods are also available. All shortcut methods require passing in the URL, and
           * request data must be passed in for POST/PUT requests. An optional config can be passed as the
           * last argument.
           *
           * ```js
           *   $http.get('/someUrl', config).then(successCallback, errorCallback);
           *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
           * ```
           *
           * Complete list of shortcut methods:
           *
           * - {@link ng.$http#get $http.get}
           * - {@link ng.$http#head $http.head}
           * - {@link ng.$http#post $http.post}
           * - {@link ng.$http#put $http.put}
           * - {@link ng.$http#delete $http.delete}
           * - {@link ng.$http#jsonp $http.jsonp}
           * - {@link ng.$http#patch $http.patch}
           *
           *
           * ## Writing Unit Tests that use $http
           * When unit testing (using {@link ngMock ngMock}), it is necessary to call
           * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
           * request using trained responses.
           *
           * ```
           * $httpBackend.expectGET(...);
           * $http.get(...);
           * $httpBackend.flush();
           * ```
           *
           * ## Deprecation Notice
           * <div class="alert alert-danger">
           *   The `$http` legacy promise methods `success` and `error` have been deprecated.
           *   Use the standard `then` method instead.
           *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
           *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
           * </div>
           *
           * ## Setting HTTP Headers
           *
           * The $http service will automatically add certain HTTP headers to all requests. These defaults
           * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
           * object, which currently contains this default configuration:
           *
           * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
           *   - `Accept: application/json, text/plain, * / *`
           * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
           *   - `Content-Type: application/json`
           * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
           *   - `Content-Type: application/json`
           *
           * To add or overwrite these defaults, simply add or remove a property from these configuration
           * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
           * with the lowercased HTTP method name as the key, e.g.
           * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
           *
           * The defaults can also be set at runtime via the `$http.defaults` object in the same
           * fashion. For example:
           *
           * ```
           * module.run(function($http) {
           *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
           * });
           * ```
           *
           * In addition, you can supply a `headers` property in the config object passed when
           * calling `$http(config)`, which overrides the defaults without changing them globally.
           *
           * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
           * Use the `headers` property, setting the desired header to `undefined`. For example:
           *
           * ```js
           * var req = {
           *  method: 'POST',
           *  url: 'http://example.com',
           *  headers: {
           *    'Content-Type': undefined
           *  },
           *  data: { test: 'test' }
           * }
           *
           * $http(req).then(function(){...}, function(){...});
           * ```
           *
           * ## Transforming Requests and Responses
           *
           * Both requests and responses can be transformed using transformation functions: `transformRequest`
           * and `transformResponse`. These properties can be a single function that returns
           * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
           * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
           *
           * <div class="alert alert-warning">
           * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
           * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
           * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
           * function will be reflected on the scope and in any templates where the object is data-bound.
           * To prevent this, transform functions should have no side-effects.
           * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
           * </div>
           *
           * ### Default Transformations
           *
           * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
           * `defaults.transformResponse` properties. If a request does not provide its own transformations
           * then these will be applied.
           *
           * You can augment or replace the default transformations by modifying these properties by adding to or
           * replacing the array.
           *
           * Angular provides the following default transformations:
           *
           * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
           *
           * - If the `data` property of the request configuration object contains an object, serialize it
           *   into JSON format.
           *
           * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
           *
           *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
           *  - If JSON response is detected, deserialize it using a JSON parser.
           *
           *
           * ### Overriding the Default Transformations Per Request
           *
           * If you wish to override the request/response transformations only for a single request then provide
           * `transformRequest` and/or `transformResponse` properties on the configuration object passed
           * into `$http`.
           *
           * Note that if you provide these properties on the config object the default transformations will be
           * overwritten. If you wish to augment the default transformations then you must include them in your
           * local transformation array.
           *
           * The following code demonstrates adding a new response transformation to be run after the default response
           * transformations have been run.
           *
           * ```js
           * function appendTransform(defaults, transform) {
           *
           *   // We can't guarantee that the default transformation is an array
           *   defaults = angular.isArray(defaults) ? defaults : [defaults];
           *
           *   // Append the new transformation to the defaults
           *   return defaults.concat(transform);
           * }
           *
           * $http({
           *   url: '...',
           *   method: 'GET',
           *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
           *     return doTransform(value);
           *   })
           * });
           * ```
           *
           *
           * ## Caching
           *
           * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
           * set the config.cache value or the default cache value to TRUE or to a cache object (created
           * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
           * precedence over the default cache value.
           *
           * In order to:
           *   * cache all responses - set the default cache value to TRUE or to a cache object
           *   * cache a specific response - set config.cache value to TRUE or to a cache object
           *
           * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
           * then the default `$cacheFactory("$http")` object is used.
           *
           * The default cache value can be set by updating the
           * {@link ng.$http#defaults `$http.defaults.cache`} property or the
           * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
           *
           * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
           * the relevant cache object. The next time the same request is made, the response is returned
           * from the cache without sending a request to the server.
           *
           * Take note that:
           *
           *   * Only GET and JSONP requests are cached.
           *   * The cache key is the request URL including search parameters; headers are not considered.
           *   * Cached responses are returned asynchronously, in the same way as responses from the server.
           *   * If multiple identical requests are made using the same cache, which is not yet populated,
           *     one request will be made to the server and remaining requests will return the same response.
           *   * A cache-control header on the response does not affect if or how responses are cached.
           *
           *
           * ## Interceptors
           *
           * Before you start creating interceptors, be sure to understand the
           * {@link ng.$q $q and deferred/promise APIs}.
           *
           * For purposes of global error handling, authentication, or any kind of synchronous or
           * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
           * able to intercept requests before they are handed to the server and
           * responses before they are handed over to the application code that
           * initiated these requests. The interceptors leverage the {@link ng.$q
           * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
           *
           * The interceptors are service factories that are registered with the `$httpProvider` by
           * adding them to the `$httpProvider.interceptors` array. The factory is called and
           * injected with dependencies (if specified) and returns the interceptor.
           *
           * There are two kinds of interceptors (and two kinds of rejection interceptors):
           *
           *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
           *     modify the `config` object or create a new one. The function needs to return the `config`
           *     object directly, or a promise containing the `config` or a new `config` object.
           *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
           *     resolved with a rejection.
           *   * `response`: interceptors get called with http `response` object. The function is free to
           *     modify the `response` object or create a new one. The function needs to return the `response`
           *     object directly, or as a promise containing the `response` or a new `response` object.
           *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
           *     resolved with a rejection.
           *
           *
           * ```js
           *   // register the interceptor as a service
           *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
           *     return {
           *       // optional method
           *       'request': function(config) {
           *         // do something on success
           *         return config;
           *       },
           *
           *       // optional method
           *      'requestError': function(rejection) {
           *         // do something on error
           *         if (canRecover(rejection)) {
           *           return responseOrNewPromise
           *         }
           *         return $q.reject(rejection);
           *       },
           *
           *
           *
           *       // optional method
           *       'response': function(response) {
           *         // do something on success
           *         return response;
           *       },
           *
           *       // optional method
           *      'responseError': function(rejection) {
           *         // do something on error
           *         if (canRecover(rejection)) {
           *           return responseOrNewPromise
           *         }
           *         return $q.reject(rejection);
           *       }
           *     };
           *   });
           *
           *   $httpProvider.interceptors.push('myHttpInterceptor');
           *
           *
           *   // alternatively, register the interceptor via an anonymous factory
           *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
           *     return {
           *      'request': function(config) {
           *          // same as above
           *       },
           *
           *       'response': function(response) {
           *          // same as above
           *       }
           *     };
           *   });
           * ```
           *
           * ## Security Considerations
           *
           * When designing web applications, consider security threats from:
           *
           * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
           * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
           *
           * Both server and the client must cooperate in order to eliminate these threats. Angular comes
           * pre-configured with strategies that address these issues, but for this to work backend server
           * cooperation is required.
           *
           * ### JSON Vulnerability Protection
           *
           * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
           * allows third party website to turn your JSON resource URL into
           * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
           * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
           * Angular will automatically strip the prefix before processing it as JSON.
           *
           * For example if your server needs to return:
           * ```js
           * ['one','two']
           * ```
           *
           * which is vulnerable to attack, your server can return:
           * ```js
           * )]}',
           * ['one','two']
           * ```
           *
           * Angular will strip the prefix, before processing the JSON.
           *
           *
           * ### Cross Site Request Forgery (XSRF) Protection
           *
           * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
           * which the attacker can trick an authenticated user into unknowingly executing actions on your
           * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
           * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
           * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
           * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
           * The header will not be set for cross-domain requests.
           *
           * To take advantage of this, your server needs to set a token in a JavaScript readable session
           * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
           * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
           * that only JavaScript running on your domain could have sent the request. The token must be
           * unique for each user and must be verifiable by the server (to prevent the JavaScript from
           * making up its own tokens). We recommend that the token is a digest of your site's
           * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
           * for added security.
           *
           * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
           * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
           * or the per-request config object.
           *
           * In order to prevent collisions in environments where multiple Angular apps share the
           * same domain or subdomain, we recommend that each application uses unique cookie name.
           *
           * @param {object} config Object describing the request to be made and how it should be
           *    processed. The object has following properties:
           *
           *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
           *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
           *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
           *      with the `paramSerializer` and appended as GET parameters.
           *    - **data** – `{string|Object}` – Data to be sent as the request message data.
           *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
           *      HTTP headers to send to the server. If the return value of a function is null, the
           *      header will not be sent. Functions accept a config object as an argument.
           *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
           *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
           *      The handler will be called in the context of a `$apply` block.
           *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
           *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
           *      The handler will be called in the context of a `$apply` block.
           *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
           *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
           *    - **transformRequest** –
           *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
           *      transform function or an array of such functions. The transform function takes the http
           *      request body and headers and returns its transformed (typically serialized) version.
           *      See {@link ng.$http#overriding-the-default-transformations-per-request
           *      Overriding the Default Transformations}
           *    - **transformResponse** –
           *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
           *      transform function or an array of such functions. The transform function takes the http
           *      response body, headers and status and returns its transformed (typically deserialized) version.
           *      See {@link ng.$http#overriding-the-default-transformations-per-request
           *      Overriding the Default Transformations}
           *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
           *      prepare the string representation of request parameters (specified as an object).
           *      If specified as string, it is interpreted as function registered with the
           *      {@link $injector $injector}, which means you can create your own serializer
           *      by registering it as a {@link auto.$provide#service service}.
           *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
           *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
           *    - **cache** – `{boolean|Object}` – A boolean value or object created with
           *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
           *      See {@link $http#caching $http Caching} for more information.
           *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
           *      that should abort the request when resolved.
           *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
           *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
           *      for more information.
           *    - **responseType** - `{string}` - see
           *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
           *
           * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
           *                        when the request succeeds or fails.
           *
           *
           * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
           *   requests. This is primarily meant to be used for debugging purposes.
           *
           *
           * @example
          <example module="httpExample">
          <file name="index.html">
          <div ng-controller="FetchController">
          <select ng-model="method" aria-label="Request method">
            <option>GET</option>
            <option>JSONP</option>
          </select>
          <input type="text" ng-model="url" size="80" aria-label="URL" />
          <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
          <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
          <button id="samplejsonpbtn"
            ng-click="updateModel('JSONP',
                          'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
            Sample JSONP
          </button>
          <button id="invalidjsonpbtn"
            ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
              Invalid JSONP
            </button>
          <pre>http status code: {{status}}</pre>
          <pre>http response data: {{data}}</pre>
          </div>
          </file>
          <file name="script.js">
          angular.module('httpExample', [])
          .controller('FetchController', ['$scope', '$http', '$templateCache',
            function($scope, $http, $templateCache) {
              $scope.method = 'GET';
              $scope.url = 'http-hello.html';
               $scope.fetch = function() {
                $scope.code = null;
                $scope.response = null;
                 $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
                  then(function(response) {
                    $scope.status = response.status;
                    $scope.data = response.data;
                  }, function(response) {
                    $scope.data = response.data || "Request failed";
                    $scope.status = response.status;
                });
              };
               $scope.updateModel = function(method, url) {
                $scope.method = method;
                $scope.url = url;
              };
            }]);
          </file>
          <file name="http-hello.html">
          Hello, $http!
          </file>
          <file name="protractor.js" type="protractor">
          var status = element(by.binding('status'));
          var data = element(by.binding('data'));
          var fetchBtn = element(by.id('fetchbtn'));
          var sampleGetBtn = element(by.id('samplegetbtn'));
          var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
          var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
          it('should make an xhr GET request', function() {
          sampleGetBtn.click();
          fetchBtn.click();
          expect(status.getText()).toMatch('200');
          expect(data.getText()).toMatch(/Hello, \$http!/);
          });
          // Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
          // it('should make a JSONP request to angularjs.org', function() {
          //   sampleJsonpBtn.click();
          //   fetchBtn.click();
          //   expect(status.getText()).toMatch('200');
          //   expect(data.getText()).toMatch(/Super Hero!/);
          // });
          it('should make JSONP request to invalid URL and invoke the error handler',
            function() {
          invalidJsonpBtn.click();
          fetchBtn.click();
          expect(status.getText()).toMatch('0');
          expect(data.getText()).toMatch('Request failed');
          });
          </file>
          </example>
           */
          function $http(requestConfig) {

            if (!isObject(requestConfig)) {
              throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
            }

            if (!isString(requestConfig.url)) {
              throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
            }

            var config = extend({
              method: 'get',
              transformRequest: defaults.transformRequest,
              transformResponse: defaults.transformResponse,
              paramSerializer: defaults.paramSerializer
            }, requestConfig);

            config.headers = mergeHeaders(requestConfig);
            config.method = uppercase(config.method);
            config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;

            var requestInterceptors = [];
            var responseInterceptors = [];
            var promise = $q.when(config);

            // apply interceptors
            forEach(reversedInterceptors, function (interceptor) {
              if (interceptor.request || interceptor.requestError) {
                requestInterceptors.unshift(interceptor.request, interceptor.requestError);
              }
              if (interceptor.response || interceptor.responseError) {
                responseInterceptors.push(interceptor.response, interceptor.responseError);
              }
            });

            promise = chainInterceptors(promise, requestInterceptors);
            promise = promise.then(serverRequest);
            promise = chainInterceptors(promise, responseInterceptors);

            if (useLegacyPromise) {
              promise.success = function (fn) {
                assertArgFn(fn, 'fn');

                promise.then(function (response) {
                  fn(response.data, response.status, response.headers, config);
                });
                return promise;
              };

              promise.error = function (fn) {
                assertArgFn(fn, 'fn');

                promise.then(null, function (response) {
                  fn(response.data, response.status, response.headers, config);
                });
                return promise;
              };
            } else {
              promise.success = $httpMinErrLegacyFn('success');
              promise.error = $httpMinErrLegacyFn('error');
            }

            return promise;

            function chainInterceptors(promise, interceptors) {
              for (var i = 0, ii = interceptors.length; i < ii;) {
                var thenFn = interceptors[i++];
                var rejectFn = interceptors[i++];

                promise = promise.then(thenFn, rejectFn);
              }

              interceptors.length = 0;

              return promise;
            }

            function executeHeaderFns(headers, config) {
              var headerContent,
                  processedHeaders = {};

              forEach(headers, function (headerFn, header) {
                if (isFunction(headerFn)) {
                  headerContent = headerFn(config);
                  if (headerContent != null) {
                    processedHeaders[header] = headerContent;
                  }
                } else {
                  processedHeaders[header] = headerFn;
                }
              });

              return processedHeaders;
            }

            function mergeHeaders(config) {
              var defHeaders = defaults.headers,
                  reqHeaders = extend({}, config.headers),
                  defHeaderName,
                  lowercaseDefHeaderName,
                  reqHeaderName;

              defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

              // using for-in instead of forEach to avoid unnecessary iteration after header has been found
              defaultHeadersIteration: for (defHeaderName in defHeaders) {
                lowercaseDefHeaderName = lowercase(defHeaderName);

                for (reqHeaderName in reqHeaders) {
                  if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
                    continue defaultHeadersIteration;
                  }
                }

                reqHeaders[defHeaderName] = defHeaders[defHeaderName];
              }

              // execute if header value is a function for merged headers
              return executeHeaderFns(reqHeaders, shallowCopy(config));
            }

            function serverRequest(config) {
              var headers = config.headers;
              var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

              // strip content-type if data is undefined
              if (isUndefined(reqData)) {
                forEach(headers, function (value, header) {
                  if (lowercase(header) === 'content-type') {
                    delete headers[header];
                  }
                });
              }

              if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
                config.withCredentials = defaults.withCredentials;
              }

              // send request
              return sendReq(config, reqData).then(transformResponse, transformResponse);
            }

            function transformResponse(response) {
              // make a copy since the response must be cacheable
              var resp = extend({}, response);
              resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
              return isSuccess(response.status) ? resp : $q.reject(resp);
            }
          }

          $http.pendingRequests = [];

          /**
           * @ngdoc method
           * @name $http#get
           *
           * @description
           * Shortcut method to perform `GET` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */

          /**
           * @ngdoc method
           * @name $http#delete
           *
           * @description
           * Shortcut method to perform `DELETE` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */

          /**
           * @ngdoc method
           * @name $http#head
           *
           * @description
           * Shortcut method to perform `HEAD` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */

          /**
           * @ngdoc method
           * @name $http#jsonp
           *
           * @description
           * Shortcut method to perform `JSONP` request.
           * If you would like to customise where and how the callbacks are stored then try overriding
           * or decorating the {@link $jsonpCallbacks} service.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request.
           *                     The name of the callback should be the string `JSON_CALLBACK`.
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */
          createShortMethods('get', 'delete', 'head', 'jsonp');

          /**
           * @ngdoc method
           * @name $http#post
           *
           * @description
           * Shortcut method to perform `POST` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {*} data Request content
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */

          /**
           * @ngdoc method
           * @name $http#put
           *
           * @description
           * Shortcut method to perform `PUT` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {*} data Request content
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */

          /**
           * @ngdoc method
           * @name $http#patch
           *
           * @description
           * Shortcut method to perform `PATCH` request.
           *
           * @param {string} url Relative or absolute URL specifying the destination of the request
           * @param {*} data Request content
           * @param {Object=} config Optional configuration object
           * @returns {HttpPromise} Future object
           */
          createShortMethodsWithData('post', 'put', 'patch');

          /**
           * @ngdoc property
           * @name $http#defaults
           *
           * @description
           * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
           * default headers, withCredentials as well as request and response transformations.
           *
           * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
           */
          $http.defaults = defaults;

          return $http;

          function createShortMethods(names) {
            forEach(arguments, function (name) {
              $http[name] = function (url, config) {
                return $http(extend({}, config || {}, {
                  method: name,
                  url: url
                }));
              };
            });
          }

          function createShortMethodsWithData(name) {
            forEach(arguments, function (name) {
              $http[name] = function (url, data, config) {
                return $http(extend({}, config || {}, {
                  method: name,
                  url: url,
                  data: data
                }));
              };
            });
          }

          /**
           * Makes the request.
           *
           * !!! ACCESSES CLOSURE VARS:
           * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
           */
          function sendReq(config, reqData) {
            var deferred = $q.defer(),
                promise = deferred.promise,
                cache,
                cachedResp,
                reqHeaders = config.headers,
                url = buildUrl(config.url, config.paramSerializer(config.params));

            $http.pendingRequests.push(config);
            promise.then(removePendingReq, removePendingReq);

            if ((config.cache || defaults.cache) && config.cache !== false && (config.method === 'GET' || config.method === 'JSONP')) {
              cache = isObject(config.cache) ? config.cache : isObject(defaults.cache) ? defaults.cache : defaultCache;
            }

            if (cache) {
              cachedResp = cache.get(url);
              if (isDefined(cachedResp)) {
                if (isPromiseLike(cachedResp)) {
                  // cached request has already been sent, but there is no response yet
                  cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
                } else {
                  // serving from cache
                  if (isArray(cachedResp)) {
                    resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
                  } else {
                    resolvePromise(cachedResp, 200, {}, 'OK');
                  }
                }
              } else {
                // put the promise for the non-transformed response into cache as a placeholder
                cache.put(url, promise);
              }
            }

            // if we won't have the response in cache, set the xsrf headers and
            // send the request to the backend
            if (isUndefined(cachedResp)) {
              var xsrfValue = urlIsSameOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
              if (xsrfValue) {
                reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
              }

              $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
            }

            return promise;

            function createApplyHandlers(eventHandlers) {
              if (eventHandlers) {
                var applyHandlers = {};
                forEach(eventHandlers, function (eventHandler, key) {
                  applyHandlers[key] = function (event) {
                    if (useApplyAsync) {
                      $rootScope.$applyAsync(callEventHandler);
                    } else if ($rootScope.$$phase) {
                      callEventHandler();
                    } else {
                      $rootScope.$apply(callEventHandler);
                    }

                    function callEventHandler() {
                      eventHandler(event);
                    }
                  };
                });
                return applyHandlers;
              }
            }

            /**
             * Callback registered to $httpBackend():
             *  - caches the response if desired
             *  - resolves the raw $http promise
             *  - calls $apply
             */
            function done(status, response, headersString, statusText) {
              if (cache) {
                if (isSuccess(status)) {
                  cache.put(url, [status, response, parseHeaders(headersString), statusText]);
                } else {
                  // remove promise from the cache
                  cache.remove(url);
                }
              }

              function resolveHttpPromise() {
                resolvePromise(response, status, headersString, statusText);
              }

              if (useApplyAsync) {
                $rootScope.$applyAsync(resolveHttpPromise);
              } else {
                resolveHttpPromise();
                if (!$rootScope.$$phase) $rootScope.$apply();
              }
            }

            /**
             * Resolves the raw $http promise.
             */
            function resolvePromise(response, status, headers, statusText) {
              //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
              status = status >= -1 ? status : 0;

              (isSuccess(status) ? deferred.resolve : deferred.reject)({
                data: response,
                status: status,
                headers: headersGetter(headers),
                config: config,
                statusText: statusText
              });
            }

            function resolvePromiseWithResult(result) {
              resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
            }

            function removePendingReq() {
              var idx = $http.pendingRequests.indexOf(config);
              if (idx !== -1) $http.pendingRequests.splice(idx, 1);
            }
          }

          function buildUrl(url, serializedParams) {
            if (serializedParams.length > 0) {
              url += (url.indexOf('?') == -1 ? '?' : '&') + serializedParams;
            }
            return url;
          }
        }];
      }

      /**
       * @ngdoc service
       * @name $xhrFactory
       *
       * @description
       * Factory function used to create XMLHttpRequest objects.
       *
       * Replace or decorate this service to create your own custom XMLHttpRequest objects.
       *
       * ```
       * angular.module('myApp', [])
       * .factory('$xhrFactory', function() {
       *   return function createXhr(method, url) {
       *     return new window.XMLHttpRequest({mozSystem: true});
       *   };
       * });
       * ```
       *
       * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
       * @param {string} url URL of the request.
       */
      function $xhrFactoryProvider() {
        this.$get = function () {
          return function createXhr() {
            return new window.XMLHttpRequest();
          };
        };
      }

      /**
       * @ngdoc service
       * @name $httpBackend
       * @requires $jsonpCallbacks
       * @requires $document
       * @requires $xhrFactory
       *
       * @description
       * HTTP backend used by the {@link ng.$http service} that delegates to
       * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
       *
       * You should never need to use this service directly, instead use the higher-level abstractions:
       * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
       *
       * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
       * $httpBackend} which can be trained with responses.
       */
      function $HttpBackendProvider() {
        this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function ($browser, $jsonpCallbacks, $document, $xhrFactory) {
          return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
        }];
      }

      function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
        // TODO(vojta): fix the signature
        return function (method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
          $browser.$$incOutstandingRequestCount();
          url = url || $browser.url();

          if (lowercase(method) === 'jsonp') {
            var callbackPath = callbacks.createCallback(url);
            var jsonpDone = jsonpReq(url, callbackPath, function (status, text) {
              // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
              var response = status === 200 && callbacks.getResponse(callbackPath);
              completeRequest(callback, status, response, "", text);
              callbacks.removeCallback(callbackPath);
            });
          } else {

            var xhr = createXhr(method, url);

            xhr.open(method, url, true);
            forEach(headers, function (value, key) {
              if (isDefined(value)) {
                xhr.setRequestHeader(key, value);
              }
            });

            xhr.onload = function requestLoaded() {
              var statusText = xhr.statusText || '';

              // responseText is the old-school way of retrieving response (supported by IE9)
              // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
              var response = 'response' in xhr ? xhr.response : xhr.responseText;

              // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
              var status = xhr.status === 1223 ? 204 : xhr.status;

              // fix status code when it is 0 (0 status is undocumented).
              // Occurs when accessing file resources or on Android 4.1 stock browser
              // while retrieving files from application cache.
              if (status === 0) {
                status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
              }

              completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText);
            };

            var requestError = function () {
              // The response is always empty
              // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
              completeRequest(callback, -1, null, null, '');
            };

            xhr.onerror = requestError;
            xhr.onabort = requestError;

            forEach(eventHandlers, function (value, key) {
              xhr.addEventListener(key, value);
            });

            forEach(uploadEventHandlers, function (value, key) {
              xhr.upload.addEventListener(key, value);
            });

            if (withCredentials) {
              xhr.withCredentials = true;
            }

            if (responseType) {
              try {
                xhr.responseType = responseType;
              } catch (e) {
                // WebKit added support for the json responseType value on 09/03/2013
                // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
                // known to throw when setting the value "json" as the response type. Other older
                // browsers implementing the responseType
                //
                // The json response type can be ignored if not supported, because JSON payloads are
                // parsed on the client-side regardless.
                if (responseType !== 'json') {
                  throw e;
                }
              }
            }

            xhr.send(isUndefined(post) ? null : post);
          }

          if (timeout > 0) {
            var timeoutId = $browserDefer(timeoutRequest, timeout);
          } else if (isPromiseLike(timeout)) {
            timeout.then(timeoutRequest);
          }

          function timeoutRequest() {
            jsonpDone && jsonpDone();
            xhr && xhr.abort();
          }

          function completeRequest(callback, status, response, headersString, statusText) {
            // cancel timeout and subsequent timeout promise resolution
            if (isDefined(timeoutId)) {
              $browserDefer.cancel(timeoutId);
            }
            jsonpDone = xhr = null;

            callback(status, response, headersString, statusText);
            $browser.$$completeOutstandingRequest(noop);
          }
        };

        function jsonpReq(url, callbackPath, done) {
          url = url.replace('JSON_CALLBACK', callbackPath);
          // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
          // - fetches local scripts via XHR and evals them
          // - adds and immediately removes script elements from the document
          var script = rawDocument.createElement('script'),
              callback = null;
          script.type = "text/javascript";
          script.src = url;
          script.async = true;

          callback = function (event) {
            removeEventListenerFn(script, "load", callback);
            removeEventListenerFn(script, "error", callback);
            rawDocument.body.removeChild(script);
            script = null;
            var status = -1;
            var text = "unknown";

            if (event) {
              if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
                event = { type: "error" };
              }
              text = event.type;
              status = event.type === "error" ? 404 : 200;
            }

            if (done) {
              done(status, text);
            }
          };

          addEventListenerFn(script, "load", callback);
          addEventListenerFn(script, "error", callback);
          rawDocument.body.appendChild(script);
          return callback;
        }
      }

      var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
      $interpolateMinErr.throwNoconcat = function (text) {
        throw $interpolateMinErr('noconcat', "Error while interpolating: {0}\nStrict Contextual Escaping disallows " + "interpolations that concatenate multiple expressions when a trusted value is " + "required.  See http://docs.angularjs.org/api/ng.$sce", text);
      };

      $interpolateMinErr.interr = function (text, err) {
        return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
      };

      /**
       * @ngdoc provider
       * @name $interpolateProvider
       *
       * @description
       *
       * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
       *
       * <div class="alert alert-danger">
       * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
       * template within a Python Jinja template (or any other template language). Mixing templating
       * languages is **very dangerous**. The embedding template language will not safely escape Angular
       * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
       * security bugs!
       * </div>
       *
       * @example
      <example name="custom-interpolation-markup" module="customInterpolationApp">
      <file name="index.html">
      <script>
        var customInterpolationApp = angular.module('customInterpolationApp', []);
      
        customInterpolationApp.config(function($interpolateProvider) {
          $interpolateProvider.startSymbol('//');
          $interpolateProvider.endSymbol('//');
        });
      
      
        customInterpolationApp.controller('DemoController', function() {
            this.label = "This binding is brought you by // interpolation symbols.";
        });
      </script>
      <div ng-controller="DemoController as demo">
          //demo.label//
      </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should interpolate binding with custom symbols', function() {
          expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
        });
      </file>
      </example>
       */
      function $InterpolateProvider() {
        var startSymbol = '{{';
        var endSymbol = '}}';

        /**
         * @ngdoc method
         * @name $interpolateProvider#startSymbol
         * @description
         * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
         *
         * @param {string=} value new value to set the starting symbol to.
         * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
         */
        this.startSymbol = function (value) {
          if (value) {
            startSymbol = value;
            return this;
          } else {
            return startSymbol;
          }
        };

        /**
         * @ngdoc method
         * @name $interpolateProvider#endSymbol
         * @description
         * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
         *
         * @param {string=} value new value to set the ending symbol to.
         * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
         */
        this.endSymbol = function (value) {
          if (value) {
            endSymbol = value;
            return this;
          } else {
            return endSymbol;
          }
        };

        this.$get = ['$parse', '$exceptionHandler', '$sce', function ($parse, $exceptionHandler, $sce) {
          var startSymbolLength = startSymbol.length,
              endSymbolLength = endSymbol.length,
              escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
              escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

          function escape(ch) {
            return '\\\\\\' + ch;
          }

          function unescapeText(text) {
            return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
          }

          function stringify(value) {
            if (value == null) {
              // null || undefined
              return '';
            }
            switch (typeof value) {
              case 'string':
                break;
              case 'number':
                value = '' + value;
                break;
              default:
                value = toJson(value);
            }

            return value;
          }

          //TODO: this is the same as the constantWatchDelegate in parse.js
          function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
            var unwatch;
            return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
              unwatch();
              return constantInterp(scope);
            }, listener, objectEquality);
          }

          /**
           * @ngdoc service
           * @name $interpolate
           * @kind function
           *
           * @requires $parse
           * @requires $sce
           *
           * @description
           *
           * Compiles a string with markup into an interpolation function. This service is used by the
           * HTML {@link ng.$compile $compile} service for data binding. See
           * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
           * interpolation markup.
           *
           *
           * ```js
           *   var $interpolate = ...; // injected
           *   var exp = $interpolate('Hello {{name | uppercase}}!');
           *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
           * ```
           *
           * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
           * `true`, the interpolation function will return `undefined` unless all embedded expressions
           * evaluate to a value other than `undefined`.
           *
           * ```js
           *   var $interpolate = ...; // injected
           *   var context = {greeting: 'Hello', name: undefined };
           *
           *   // default "forgiving" mode
           *   var exp = $interpolate('{{greeting}} {{name}}!');
           *   expect(exp(context)).toEqual('Hello !');
           *
           *   // "allOrNothing" mode
           *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
           *   expect(exp(context)).toBeUndefined();
           *   context.name = 'Angular';
           *   expect(exp(context)).toEqual('Hello Angular!');
           * ```
           *
           * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
           *
           * #### Escaped Interpolation
           * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
           * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
           * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
           * or binding.
           *
           * This enables web-servers to prevent script injection attacks and defacing attacks, to some
           * degree, while also enabling code examples to work without relying on the
           * {@link ng.directive:ngNonBindable ngNonBindable} directive.
           *
           * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
           * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
           * interpolation start/end markers with their escaped counterparts.**
           *
           * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
           * output when the $interpolate service processes the text. So, for HTML elements interpolated
           * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
           * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
           * this is typically useful only when user-data is used in rendering a template from the server, or
           * when otherwise untrusted data is used by a directive.
           *
           * <example>
           *  <file name="index.html">
           *    <div ng-init="username='A user'">
           *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
           *        </p>
           *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
           *        application, but fails to accomplish their task, because the server has correctly
           *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
           *        characters.</p>
           *      <p>Instead, the result of the attempted script injection is visible, and can be removed
           *        from the database by an administrator.</p>
           *    </div>
           *  </file>
           * </example>
           *
           * @knownIssue
           * It is currently not possible for an interpolated expression to contain the interpolation end
           * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
           * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
           *
           * @knownIssue
           * All directives and components must use the standard `{{` `}}` interpolation symbols
           * in their templates. If you change the application interpolation symbols the {@link $compile}
           * service will attempt to denormalize the standard symbols to the custom symbols.
           * The denormalization process is not clever enough to know not to replace instances of the standard
           * symbols where they would not normally be treated as interpolation symbols. For example in the following
           * code snippet the closing braces of the literal object will get incorrectly denormalized:
           *
           * ```
           * <div data-context='{"context":{"id":3,"type":"page"}}">
           * ```
           *
           * The workaround is to ensure that such instances are separated by whitespace:
           * ```
           * <div data-context='{"context":{"id":3,"type":"page"} }">
           * ```
           *
           * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
           *
           * @param {string} text The text with markup to interpolate.
           * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
           *    embedded expression in order to return an interpolation function. Strings with no
           *    embedded expression will return null for the interpolation function.
           * @param {string=} trustedContext when provided, the returned function passes the interpolated
           *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
           *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
           *    provides Strict Contextual Escaping for details.
           * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
           *    unless all embedded expressions evaluate to a value other than `undefined`.
           * @returns {function(context)} an interpolation function which is used to compute the
           *    interpolated string. The function has these parameters:
           *
           * - `context`: evaluation context for all expressions embedded in the interpolated text
           */
          function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
            // Provide a quick exit and simplified result function for text with no interpolation
            if (!text.length || text.indexOf(startSymbol) === -1) {
              var constantInterp;
              if (!mustHaveExpression) {
                var unescapedText = unescapeText(text);
                constantInterp = valueFn(unescapedText);
                constantInterp.exp = text;
                constantInterp.expressions = [];
                constantInterp.$$watchDelegate = constantWatchDelegate;
              }
              return constantInterp;
            }

            allOrNothing = !!allOrNothing;
            var startIndex,
                endIndex,
                index = 0,
                expressions = [],
                parseFns = [],
                textLength = text.length,
                exp,
                concat = [],
                expressionPositions = [];

            while (index < textLength) {
              if ((startIndex = text.indexOf(startSymbol, index)) != -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1) {
                if (index !== startIndex) {
                  concat.push(unescapeText(text.substring(index, startIndex)));
                }
                exp = text.substring(startIndex + startSymbolLength, endIndex);
                expressions.push(exp);
                parseFns.push($parse(exp, parseStringifyInterceptor));
                index = endIndex + endSymbolLength;
                expressionPositions.push(concat.length);
                concat.push('');
              } else {
                // we did not find an interpolation, so we have to add the remainder to the separators array
                if (index !== textLength) {
                  concat.push(unescapeText(text.substring(index)));
                }
                break;
              }
            }

            // Concatenating expressions makes it hard to reason about whether some combination of
            // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
            // single expression be used for iframe[src], object[src], etc., we ensure that the value
            // that's used is assigned or constructed by some JS code somewhere that is more testable or
            // make it obvious that you bound the value to some user controlled value.  This helps reduce
            // the load when auditing for XSS issues.
            if (trustedContext && concat.length > 1) {
              $interpolateMinErr.throwNoconcat(text);
            }

            if (!mustHaveExpression || expressions.length) {
              var compute = function (values) {
                for (var i = 0, ii = expressions.length; i < ii; i++) {
                  if (allOrNothing && isUndefined(values[i])) return;
                  concat[expressionPositions[i]] = values[i];
                }
                return concat.join('');
              };

              var getValue = function (value) {
                return trustedContext ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
              };

              return extend(function interpolationFn(context) {
                var i = 0;
                var ii = expressions.length;
                var values = new Array(ii);

                try {
                  for (; i < ii; i++) {
                    values[i] = parseFns[i](context);
                  }

                  return compute(values);
                } catch (err) {
                  $exceptionHandler($interpolateMinErr.interr(text, err));
                }
              }, {
                // all of these properties are undocumented for now
                exp: text, //just for compatibility with regular watchers created via $watch
                expressions: expressions,
                $$watchDelegate: function (scope, listener) {
                  var lastValue;
                  return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
                    var currValue = compute(values);
                    if (isFunction(listener)) {
                      listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                    }
                    lastValue = currValue;
                  });
                }
              });
            }

            function parseStringifyInterceptor(value) {
              try {
                value = getValue(value);
                return allOrNothing && !isDefined(value) ? value : stringify(value);
              } catch (err) {
                $exceptionHandler($interpolateMinErr.interr(text, err));
              }
            }
          }

          /**
           * @ngdoc method
           * @name $interpolate#startSymbol
           * @description
           * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
           *
           * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
           * the symbol.
           *
           * @returns {string} start symbol.
           */
          $interpolate.startSymbol = function () {
            return startSymbol;
          };

          /**
           * @ngdoc method
           * @name $interpolate#endSymbol
           * @description
           * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
           *
           * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
           * the symbol.
           *
           * @returns {string} end symbol.
           */
          $interpolate.endSymbol = function () {
            return endSymbol;
          };

          return $interpolate;
        }];
      }

      function $IntervalProvider() {
        this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser', function ($rootScope, $window, $q, $$q, $browser) {
          var intervals = {};

          /**
           * @ngdoc service
           * @name $interval
           *
           * @description
           * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
           * milliseconds.
           *
           * The return value of registering an interval function is a promise. This promise will be
           * notified upon each tick of the interval, and will be resolved after `count` iterations, or
           * run indefinitely if `count` is not defined. The value of the notification will be the
           * number of iterations that have run.
           * To cancel an interval, call `$interval.cancel(promise)`.
           *
           * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
           * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
           * time.
           *
           * <div class="alert alert-warning">
           * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
           * with them.  In particular they are not automatically destroyed when a controller's scope or a
           * directive's element are destroyed.
           * You should take this into consideration and make sure to always cancel the interval at the
           * appropriate moment.  See the example below for more details on how and when to do this.
           * </div>
           *
           * @param {function()} fn A function that should be called repeatedly.
           * @param {number} delay Number of milliseconds between each function call.
           * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
           *   indefinitely.
           * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
           *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
           * @param {...*=} Pass additional parameters to the executed function.
           * @returns {promise} A promise which will be notified on each iteration.
           *
           * @example
           * <example module="intervalExample">
           * <file name="index.html">
           *   <script>
           *     angular.module('intervalExample', [])
           *       .controller('ExampleController', ['$scope', '$interval',
           *         function($scope, $interval) {
           *           $scope.format = 'M/d/yy h:mm:ss a';
           *           $scope.blood_1 = 100;
           *           $scope.blood_2 = 120;
           *
           *           var stop;
           *           $scope.fight = function() {
           *             // Don't start a new fight if we are already fighting
           *             if ( angular.isDefined(stop) ) return;
           *
           *             stop = $interval(function() {
           *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
           *                 $scope.blood_1 = $scope.blood_1 - 3;
           *                 $scope.blood_2 = $scope.blood_2 - 4;
           *               } else {
           *                 $scope.stopFight();
           *               }
           *             }, 100);
           *           };
           *
           *           $scope.stopFight = function() {
           *             if (angular.isDefined(stop)) {
           *               $interval.cancel(stop);
           *               stop = undefined;
           *             }
           *           };
           *
           *           $scope.resetFight = function() {
           *             $scope.blood_1 = 100;
           *             $scope.blood_2 = 120;
           *           };
           *
           *           $scope.$on('$destroy', function() {
           *             // Make sure that the interval is destroyed too
           *             $scope.stopFight();
           *           });
           *         }])
           *       // Register the 'myCurrentTime' directive factory method.
           *       // We inject $interval and dateFilter service since the factory method is DI.
           *       .directive('myCurrentTime', ['$interval', 'dateFilter',
           *         function($interval, dateFilter) {
           *           // return the directive link function. (compile function not needed)
           *           return function(scope, element, attrs) {
           *             var format,  // date format
           *                 stopTime; // so that we can cancel the time updates
           *
           *             // used to update the UI
           *             function updateTime() {
           *               element.text(dateFilter(new Date(), format));
           *             }
           *
           *             // watch the expression, and update the UI on change.
           *             scope.$watch(attrs.myCurrentTime, function(value) {
           *               format = value;
           *               updateTime();
           *             });
           *
           *             stopTime = $interval(updateTime, 1000);
           *
           *             // listen on DOM destroy (removal) event, and cancel the next UI update
           *             // to prevent updating time after the DOM element was removed.
           *             element.on('$destroy', function() {
           *               $interval.cancel(stopTime);
           *             });
           *           }
           *         }]);
           *   </script>
           *
           *   <div>
           *     <div ng-controller="ExampleController">
           *       <label>Date format: <input ng-model="format"></label> <hr/>
           *       Current time is: <span my-current-time="format"></span>
           *       <hr/>
           *       Blood 1 : <font color='red'>{{blood_1}}</font>
           *       Blood 2 : <font color='red'>{{blood_2}}</font>
           *       <button type="button" data-ng-click="fight()">Fight</button>
           *       <button type="button" data-ng-click="stopFight()">StopFight</button>
           *       <button type="button" data-ng-click="resetFight()">resetFight</button>
           *     </div>
           *   </div>
           *
           * </file>
           * </example>
           */
          function interval(fn, delay, count, invokeApply) {
            var hasParams = arguments.length > 4,
                args = hasParams ? sliceArgs(arguments, 4) : [],
                setInterval = $window.setInterval,
                clearInterval = $window.clearInterval,
                iteration = 0,
                skipApply = isDefined(invokeApply) && !invokeApply,
                deferred = (skipApply ? $$q : $q).defer(),
                promise = deferred.promise;

            count = isDefined(count) ? count : 0;

            promise.$$intervalId = setInterval(function tick() {
              if (skipApply) {
                $browser.defer(callback);
              } else {
                $rootScope.$evalAsync(callback);
              }
              deferred.notify(iteration++);

              if (count > 0 && iteration >= count) {
                deferred.resolve(iteration);
                clearInterval(promise.$$intervalId);
                delete intervals[promise.$$intervalId];
              }

              if (!skipApply) $rootScope.$apply();
            }, delay);

            intervals[promise.$$intervalId] = deferred;

            return promise;

            function callback() {
              if (!hasParams) {
                fn(iteration);
              } else {
                fn.apply(null, args);
              }
            }
          }

          /**
           * @ngdoc method
           * @name $interval#cancel
           *
           * @description
           * Cancels a task associated with the `promise`.
           *
           * @param {Promise=} promise returned by the `$interval` function.
           * @returns {boolean} Returns `true` if the task was successfully canceled.
           */
          interval.cancel = function (promise) {
            if (promise && promise.$$intervalId in intervals) {
              intervals[promise.$$intervalId].reject('canceled');
              $window.clearInterval(promise.$$intervalId);
              delete intervals[promise.$$intervalId];
              return true;
            }
            return false;
          };

          return interval;
        }];
      }

      /**
       * @ngdoc service
       * @name $jsonpCallbacks
       * @requires $window
       * @description
       * This service handles the lifecycle of callbacks to handle JSONP requests.
       * Override this service if you wish to customise where the callbacks are stored and
       * how they vary compared to the requested url.
       */
      var $jsonpCallbacksProvider = function () {
        this.$get = ['$window', function ($window) {
          var callbacks = $window.angular.callbacks;
          var callbackMap = {};

          function createCallback(callbackId) {
            var callback = function (data) {
              callback.data = data;
              callback.called = true;
            };
            callback.id = callbackId;
            return callback;
          }

          return {
            /**
             * @ngdoc method
             * @name $jsonpCallbacks#createCallback
             * @param {string} url the url of the JSONP request
             * @returns {string} the callback path to send to the server as part of the JSONP request
             * @description
             * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
             * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
             */
            createCallback: function (url) {
              var callbackId = '_' + (callbacks.$$counter++).toString(36);
              var callbackPath = 'angular.callbacks.' + callbackId;
              var callback = createCallback(callbackId);
              callbackMap[callbackPath] = callbacks[callbackId] = callback;
              return callbackPath;
            },
            /**
             * @ngdoc method
             * @name $jsonpCallbacks#wasCalled
             * @param {string} callbackPath the path to the callback that was sent in the JSONP request
             * @returns {boolean} whether the callback has been called, as a result of the JSONP response
             * @description
             * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
             * callback that was passed in the request.
             */
            wasCalled: function (callbackPath) {
              return callbackMap[callbackPath].called;
            },
            /**
             * @ngdoc method
             * @name $jsonpCallbacks#getResponse
             * @param {string} callbackPath the path to the callback that was sent in the JSONP request
             * @returns {*} the data received from the response via the registered callback
             * @description
             * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
             * in the JSONP response.
             */
            getResponse: function (callbackPath) {
              return callbackMap[callbackPath].data;
            },
            /**
             * @ngdoc method
             * @name $jsonpCallbacks#removeCallback
             * @param {string} callbackPath the path to the callback that was sent in the JSONP request
             * @description
             * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
             * completed or timed-out.
             */
            removeCallback: function (callbackPath) {
              var callback = callbackMap[callbackPath];
              delete callbacks[callback.id];
              delete callbackMap[callbackPath];
            }
          };
        }];
      };

      /**
       * @ngdoc service
       * @name $locale
       *
       * @description
       * $locale service provides localization rules for various Angular components. As of right now the
       * only public api is:
       *
       * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
       */

      var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
          DEFAULT_PORTS = { 'http': 80, 'https': 443, 'ftp': 21 };
      var $locationMinErr = minErr('$location');

      /**
       * Encode path using encodeUriSegment, ignoring forward slashes
       *
       * @param {string} path Path to encode
       * @returns {string}
       */
      function encodePath(path) {
        var segments = path.split('/'),
            i = segments.length;

        while (i--) {
          segments[i] = encodeUriSegment(segments[i]);
        }

        return segments.join('/');
      }

      function parseAbsoluteUrl(absoluteUrl, locationObj) {
        var parsedUrl = urlResolve(absoluteUrl);

        locationObj.$$protocol = parsedUrl.protocol;
        locationObj.$$host = parsedUrl.hostname;
        locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
      }

      function parseAppUrl(relativeUrl, locationObj) {
        var prefixed = relativeUrl.charAt(0) !== '/';
        if (prefixed) {
          relativeUrl = '/' + relativeUrl;
        }
        var match = urlResolve(relativeUrl);
        locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname);
        locationObj.$$search = parseKeyValue(match.search);
        locationObj.$$hash = decodeURIComponent(match.hash);

        // make sure path starts with '/';
        if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
          locationObj.$$path = '/' + locationObj.$$path;
        }
      }

      function startsWith(haystack, needle) {
        return haystack.lastIndexOf(needle, 0) === 0;
      }

      /**
       *
       * @param {string} base
       * @param {string} url
       * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
       *                   the expected string.
       */
      function stripBaseUrl(base, url) {
        if (startsWith(url, base)) {
          return url.substr(base.length);
        }
      }

      function stripHash(url) {
        var index = url.indexOf('#');
        return index == -1 ? url : url.substr(0, index);
      }

      function trimEmptyHash(url) {
        return url.replace(/(#.+)|#$/, '$1');
      }

      function stripFile(url) {
        return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
      }

      /* return the server only (scheme://host:port) */
      function serverBase(url) {
        return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
      }

      /**
       * LocationHtml5Url represents an url
       * This object is exposed as $location service when HTML5 mode is enabled and supported
       *
       * @constructor
       * @param {string} appBase application base URL
       * @param {string} appBaseNoFile application base URL stripped of any filename
       * @param {string} basePrefix url path prefix
       */
      function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
        this.$$html5 = true;
        basePrefix = basePrefix || '';
        parseAbsoluteUrl(appBase, this);

        /**
         * Parse given html5 (regular) url string into properties
         * @param {string} url HTML5 url
         * @private
         */
        this.$$parse = function (url) {
          var pathUrl = stripBaseUrl(appBaseNoFile, url);
          if (!isString(pathUrl)) {
            throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
          }

          parseAppUrl(pathUrl, this);

          if (!this.$$path) {
            this.$$path = '/';
          }

          this.$$compose();
        };

        /**
         * Compose url and update `absUrl` property
         * @private
         */
        this.$$compose = function () {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
        };

        this.$$parseLinkUrl = function (url, relHref) {
          if (relHref && relHref[0] === '#') {
            // special case for links to hash fragments:
            // keep the old url and only replace the hash fragment
            this.hash(relHref.slice(1));
            return true;
          }
          var appUrl, prevAppUrl;
          var rewrittenUrl;

          if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
            prevAppUrl = appUrl;
            if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
              rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
            } else {
              rewrittenUrl = appBase + prevAppUrl;
            }
          } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
            rewrittenUrl = appBaseNoFile + appUrl;
          } else if (appBaseNoFile == url + '/') {
            rewrittenUrl = appBaseNoFile;
          }
          if (rewrittenUrl) {
            this.$$parse(rewrittenUrl);
          }
          return !!rewrittenUrl;
        };
      }

      /**
       * LocationHashbangUrl represents url
       * This object is exposed as $location service when developer doesn't opt into html5 mode.
       * It also serves as the base class for html5 mode fallback on legacy browsers.
       *
       * @constructor
       * @param {string} appBase application base URL
       * @param {string} appBaseNoFile application base URL stripped of any filename
       * @param {string} hashPrefix hashbang prefix
       */
      function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

        parseAbsoluteUrl(appBase, this);

        /**
         * Parse given hashbang url into properties
         * @param {string} url Hashbang url
         * @private
         */
        this.$$parse = function (url) {
          var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
          var withoutHashUrl;

          if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

            // The rest of the url starts with a hash so we have
            // got either a hashbang path or a plain hash fragment
            withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
            if (isUndefined(withoutHashUrl)) {
              // There was no hashbang prefix so we just have a hash fragment
              withoutHashUrl = withoutBaseUrl;
            }
          } else {
            // There was no hashbang path nor hash fragment:
            // If we are in HTML5 mode we use what is left as the path;
            // Otherwise we ignore what is left
            if (this.$$html5) {
              withoutHashUrl = withoutBaseUrl;
            } else {
              withoutHashUrl = '';
              if (isUndefined(withoutBaseUrl)) {
                appBase = url;
                this.replace();
              }
            }
          }

          parseAppUrl(withoutHashUrl, this);

          this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

          this.$$compose();

          /*
           * In Windows, on an anchor node on documents loaded from
           * the filesystem, the browser will return a pathname
           * prefixed with the drive name ('/C:/path') when a
           * pathname without a drive is set:
           *  * a.setAttribute('href', '/foo')
           *   * a.pathname === '/C:/foo' //true
           *
           * Inside of Angular, we're always using pathnames that
           * do not include drive names for routing.
           */
          function removeWindowsDriveName(path, url, base) {
            /*
            Matches paths for file protocol on windows,
            such as /C:/foo/bar, and captures only /foo/bar.
            */
            var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

            var firstPathSegmentMatch;

            //Get the relative path from the input URL.
            if (startsWith(url, base)) {
              url = url.replace(base, '');
            }

            // The input URL intentionally contains a first path segment that ends with a colon.
            if (windowsFilePathExp.exec(url)) {
              return path;
            }

            firstPathSegmentMatch = windowsFilePathExp.exec(path);
            return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
          }
        };

        /**
         * Compose hashbang url and update `absUrl` property
         * @private
         */
        this.$$compose = function () {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
        };

        this.$$parseLinkUrl = function (url, relHref) {
          if (stripHash(appBase) == stripHash(url)) {
            this.$$parse(url);
            return true;
          }
          return false;
        };
      }

      /**
       * LocationHashbangUrl represents url
       * This object is exposed as $location service when html5 history api is enabled but the browser
       * does not support it.
       *
       * @constructor
       * @param {string} appBase application base URL
       * @param {string} appBaseNoFile application base URL stripped of any filename
       * @param {string} hashPrefix hashbang prefix
       */
      function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
        this.$$html5 = true;
        LocationHashbangUrl.apply(this, arguments);

        this.$$parseLinkUrl = function (url, relHref) {
          if (relHref && relHref[0] === '#') {
            // special case for links to hash fragments:
            // keep the old url and only replace the hash fragment
            this.hash(relHref.slice(1));
            return true;
          }

          var rewrittenUrl;
          var appUrl;

          if (appBase == stripHash(url)) {
            rewrittenUrl = url;
          } else if (appUrl = stripBaseUrl(appBaseNoFile, url)) {
            rewrittenUrl = appBase + hashPrefix + appUrl;
          } else if (appBaseNoFile === url + '/') {
            rewrittenUrl = appBaseNoFile;
          }
          if (rewrittenUrl) {
            this.$$parse(rewrittenUrl);
          }
          return !!rewrittenUrl;
        };

        this.$$compose = function () {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
          this.$$absUrl = appBase + hashPrefix + this.$$url;
        };
      }

      var locationPrototype = {

        /**
         * Ensure absolute url is initialized.
         * @private
         */
        $$absUrl: '',

        /**
         * Are we in html5 mode?
         * @private
         */
        $$html5: false,

        /**
         * Has any change been replacing?
         * @private
         */
        $$replace: false,

        /**
         * @ngdoc method
         * @name $location#absUrl
         *
         * @description
         * This method is getter only.
         *
         * Return full url representation with all segments encoded according to rules specified in
         * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var absUrl = $location.absUrl();
         * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
         * ```
         *
         * @return {string} full url
         */
        absUrl: locationGetter('$$absUrl'),

        /**
         * @ngdoc method
         * @name $location#url
         *
         * @description
         * This method is getter / setter.
         *
         * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
         *
         * Change path, search and hash, when called with parameter and return `$location`.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var url = $location.url();
         * // => "/some/path?foo=bar&baz=xoxo"
         * ```
         *
         * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
         * @return {string} url
         */
        url: function (url) {
          if (isUndefined(url)) {
            return this.$$url;
          }

          var match = PATH_MATCH.exec(url);
          if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
          if (match[2] || match[1] || url === '') this.search(match[3] || '');
          this.hash(match[5] || '');

          return this;
        },

        /**
         * @ngdoc method
         * @name $location#protocol
         *
         * @description
         * This method is getter only.
         *
         * Return protocol of current url.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var protocol = $location.protocol();
         * // => "http"
         * ```
         *
         * @return {string} protocol of current url
         */
        protocol: locationGetter('$$protocol'),

        /**
         * @ngdoc method
         * @name $location#host
         *
         * @description
         * This method is getter only.
         *
         * Return host of current url.
         *
         * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var host = $location.host();
         * // => "example.com"
         *
         * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
         * host = $location.host();
         * // => "example.com"
         * host = location.host;
         * // => "example.com:8080"
         * ```
         *
         * @return {string} host of current url.
         */
        host: locationGetter('$$host'),

        /**
         * @ngdoc method
         * @name $location#port
         *
         * @description
         * This method is getter only.
         *
         * Return port of current url.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var port = $location.port();
         * // => 80
         * ```
         *
         * @return {Number} port
         */
        port: locationGetter('$$port'),

        /**
         * @ngdoc method
         * @name $location#path
         *
         * @description
         * This method is getter / setter.
         *
         * Return path of current url when called without any parameter.
         *
         * Change path when called with parameter and return `$location`.
         *
         * Note: Path should always begin with forward slash (/), this method will add the forward slash
         * if it is missing.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var path = $location.path();
         * // => "/some/path"
         * ```
         *
         * @param {(string|number)=} path New path
         * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
         */
        path: locationGetterSetter('$$path', function (path) {
          path = path !== null ? path.toString() : '';
          return path.charAt(0) == '/' ? path : '/' + path;
        }),

        /**
         * @ngdoc method
         * @name $location#search
         *
         * @description
         * This method is getter / setter.
         *
         * Return search part (as object) of current url when called without any parameter.
         *
         * Change search part when called with parameter and return `$location`.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
         * var searchObject = $location.search();
         * // => {foo: 'bar', baz: 'xoxo'}
         *
         * // set foo to 'yipee'
         * $location.search('foo', 'yipee');
         * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
         * ```
         *
         * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
         * hash object.
         *
         * When called with a single argument the method acts as a setter, setting the `search` component
         * of `$location` to the specified value.
         *
         * If the argument is a hash object containing an array of values, these values will be encoded
         * as duplicate search parameters in the url.
         *
         * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
         * will override only a single search property.
         *
         * If `paramValue` is an array, it will override the property of the `search` component of
         * `$location` specified via the first argument.
         *
         * If `paramValue` is `null`, the property specified via the first argument will be deleted.
         *
         * If `paramValue` is `true`, the property specified via the first argument will be added with no
         * value nor trailing equal sign.
         *
         * @return {Object} If called with no arguments returns the parsed `search` object. If called with
         * one or more arguments returns `$location` object itself.
         */
        search: function (search, paramValue) {
          switch (arguments.length) {
            case 0:
              return this.$$search;
            case 1:
              if (isString(search) || isNumber(search)) {
                search = search.toString();
                this.$$search = parseKeyValue(search);
              } else if (isObject(search)) {
                search = copy(search, {});
                // remove object undefined or null properties
                forEach(search, function (value, key) {
                  if (value == null) delete search[key];
                });

                this.$$search = search;
              } else {
                throw $locationMinErr('isrcharg', 'The first argument of the `$location#search()` call must be a string or an object.');
              }
              break;
            default:
              if (isUndefined(paramValue) || paramValue === null) {
                delete this.$$search[search];
              } else {
                this.$$search[search] = paramValue;
              }
          }

          this.$$compose();
          return this;
        },

        /**
         * @ngdoc method
         * @name $location#hash
         *
         * @description
         * This method is getter / setter.
         *
         * Returns the hash fragment when called without any parameters.
         *
         * Changes the hash fragment when called with a parameter and returns `$location`.
         *
         *
         * ```js
         * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
         * var hash = $location.hash();
         * // => "hashValue"
         * ```
         *
         * @param {(string|number)=} hash New hash fragment
         * @return {string} hash
         */
        hash: locationGetterSetter('$$hash', function (hash) {
          return hash !== null ? hash.toString() : '';
        }),

        /**
         * @ngdoc method
         * @name $location#replace
         *
         * @description
         * If called, all changes to $location during the current `$digest` will replace the current history
         * record, instead of adding a new one.
         */
        replace: function () {
          this.$$replace = true;
          return this;
        }
      };

      forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function (Location) {
        Location.prototype = Object.create(locationPrototype);

        /**
         * @ngdoc method
         * @name $location#state
         *
         * @description
         * This method is getter / setter.
         *
         * Return the history state object when called without any parameter.
         *
         * Change the history state object when called with one parameter and return `$location`.
         * The state object is later passed to `pushState` or `replaceState`.
         *
         * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
         * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
         * older browsers (like IE9 or Android < 4.0), don't use this method.
         *
         * @param {object=} state State object for pushState or replaceState
         * @return {object} state
         */
        Location.prototype.state = function (state) {
          if (!arguments.length) {
            return this.$$state;
          }

          if (Location !== LocationHtml5Url || !this.$$html5) {
            throw $locationMinErr('nostate', 'History API state support is available only ' + 'in HTML5 mode and only in browsers supporting HTML5 History API');
          }
          // The user might modify `stateObject` after invoking `$location.state(stateObject)`
          // but we're changing the $$state reference to $browser.state() during the $digest
          // so the modification window is narrow.
          this.$$state = isUndefined(state) ? null : state;

          return this;
        };
      });

      function locationGetter(property) {
        return function () {
          return this[property];
        };
      }

      function locationGetterSetter(property, preprocess) {
        return function (value) {
          if (isUndefined(value)) {
            return this[property];
          }

          this[property] = preprocess(value);
          this.$$compose();

          return this;
        };
      }

      /**
       * @ngdoc service
       * @name $location
       *
       * @requires $rootElement
       *
       * @description
       * The $location service parses the URL in the browser address bar (based on the
       * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
       * available to your application. Changes to the URL in the address bar are reflected into
       * $location service and changes to $location are reflected into the browser address bar.
       *
       * **The $location service:**
       *
       * - Exposes the current URL in the browser address bar, so you can
       *   - Watch and observe the URL.
       *   - Change the URL.
       * - Synchronizes the URL with the browser when the user
       *   - Changes the address bar.
       *   - Clicks the back or forward button (or clicks a History link).
       *   - Clicks on a link.
       * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
       *
       * For more information see {@link guide/$location Developer Guide: Using $location}
       */

      /**
       * @ngdoc provider
       * @name $locationProvider
       * @description
       * Use the `$locationProvider` to configure how the application deep linking paths are stored.
       */
      function $LocationProvider() {
        var hashPrefix = '',
            html5Mode = {
          enabled: false,
          requireBase: true,
          rewriteLinks: true
        };

        /**
         * @ngdoc method
         * @name $locationProvider#hashPrefix
         * @description
         * @param {string=} prefix Prefix for hash part (containing path and search)
         * @returns {*} current value if used as getter or itself (chaining) if used as setter
         */
        this.hashPrefix = function (prefix) {
          if (isDefined(prefix)) {
            hashPrefix = prefix;
            return this;
          } else {
            return hashPrefix;
          }
        };

        /**
         * @ngdoc method
         * @name $locationProvider#html5Mode
         * @description
         * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
         *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
         *   properties:
         *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
         *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
         *     support `pushState`.
         *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
         *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
         *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
         *     See the {@link guide/$location $location guide for more information}
         *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
         *     enables/disables url rewriting for relative links.
         *
         * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
         */
        this.html5Mode = function (mode) {
          if (isBoolean(mode)) {
            html5Mode.enabled = mode;
            return this;
          } else if (isObject(mode)) {

            if (isBoolean(mode.enabled)) {
              html5Mode.enabled = mode.enabled;
            }

            if (isBoolean(mode.requireBase)) {
              html5Mode.requireBase = mode.requireBase;
            }

            if (isBoolean(mode.rewriteLinks)) {
              html5Mode.rewriteLinks = mode.rewriteLinks;
            }

            return this;
          } else {
            return html5Mode;
          }
        };

        /**
         * @ngdoc event
         * @name $location#$locationChangeStart
         * @eventType broadcast on root scope
         * @description
         * Broadcasted before a URL will change.
         *
         * This change can be prevented by calling
         * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
         * details about event object. Upon successful change
         * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
         *
         * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
         * the browser supports the HTML5 History API.
         *
         * @param {Object} angularEvent Synthetic event object.
         * @param {string} newUrl New URL
         * @param {string=} oldUrl URL that was before it was changed.
         * @param {string=} newState New history state object
         * @param {string=} oldState History state object that was before it was changed.
         */

        /**
         * @ngdoc event
         * @name $location#$locationChangeSuccess
         * @eventType broadcast on root scope
         * @description
         * Broadcasted after a URL was changed.
         *
         * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
         * the browser supports the HTML5 History API.
         *
         * @param {Object} angularEvent Synthetic event object.
         * @param {string} newUrl New URL
         * @param {string=} oldUrl URL that was before it was changed.
         * @param {string=} newState New history state object
         * @param {string=} oldState History state object that was before it was changed.
         */

        this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window', function ($rootScope, $browser, $sniffer, $rootElement, $window) {
          var $location,
              LocationMode,
              baseHref = $browser.baseHref(),
              // if base[href] is undefined, it defaults to ''
          initialUrl = $browser.url(),
              appBase;

          if (html5Mode.enabled) {
            if (!baseHref && html5Mode.requireBase) {
              throw $locationMinErr('nobase', "$location in HTML5 mode requires a <base> tag to be present!");
            }
            appBase = serverBase(initialUrl) + (baseHref || '/');
            LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
          } else {
            appBase = stripHash(initialUrl);
            LocationMode = LocationHashbangUrl;
          }
          var appBaseNoFile = stripFile(appBase);

          $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
          $location.$$parseLinkUrl(initialUrl, initialUrl);

          $location.$$state = $browser.state();

          var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

          function setBrowserUrlWithFallback(url, replace, state) {
            var oldUrl = $location.url();
            var oldState = $location.$$state;
            try {
              $browser.url(url, replace, state);

              // Make sure $location.state() returns referentially identical (not just deeply equal)
              // state object; this makes possible quick checking if the state changed in the digest
              // loop. Checking deep equality would be too expensive.
              $location.$$state = $browser.state();
            } catch (e) {
              // Restore old values if pushState fails
              $location.url(oldUrl);
              $location.$$state = oldState;

              throw e;
            }
          }

          $rootElement.on('click', function (event) {
            // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
            // currently we open nice url link and redirect then

            if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;

            var elm = jqLite(event.target);

            // traverse the DOM up to find first A tag
            while (nodeName_(elm[0]) !== 'a') {
              // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
              if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
            }

            var absHref = elm.prop('href');
            // get the actual href attribute - see
            // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
            var relHref = elm.attr('href') || elm.attr('xlink:href');

            if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
              // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
              // an animation.
              absHref = urlResolve(absHref.animVal).href;
            }

            // Ignore when url is started with javascript: or mailto:
            if (IGNORE_URI_REGEXP.test(absHref)) return;

            if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
              if ($location.$$parseLinkUrl(absHref, relHref)) {
                // We do a preventDefault for all urls that are part of the angular application,
                // in html5mode and also without, so that we are able to abort navigation without
                // getting double entries in the location history.
                event.preventDefault();
                // update location manually
                if ($location.absUrl() != $browser.url()) {
                  $rootScope.$apply();
                  // hack to work around FF6 bug 684208 when scenario runner clicks on links
                  $window.angular['ff-684208-preventDefault'] = true;
                }
              }
            }
          });

          // rewrite hashbang url <> html5 url
          if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
            $browser.url($location.absUrl(), true);
          }

          var initializing = true;

          // update $location when $browser url changes
          $browser.onUrlChange(function (newUrl, newState) {

            if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
              // If we are navigating outside of the app then force a reload
              $window.location.href = newUrl;
              return;
            }

            $rootScope.$evalAsync(function () {
              var oldUrl = $location.absUrl();
              var oldState = $location.$$state;
              var defaultPrevented;
              newUrl = trimEmptyHash(newUrl);
              $location.$$parse(newUrl);
              $location.$$state = newState;

              defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, newState, oldState).defaultPrevented;

              // if the location was changed by a `$locationChangeStart` handler then stop
              // processing this location change
              if ($location.absUrl() !== newUrl) return;

              if (defaultPrevented) {
                $location.$$parse(oldUrl);
                $location.$$state = oldState;
                setBrowserUrlWithFallback(oldUrl, false, oldState);
              } else {
                initializing = false;
                afterLocationChange(oldUrl, oldState);
              }
            });
            if (!$rootScope.$$phase) $rootScope.$digest();
          });

          // update browser
          $rootScope.$watch(function $locationWatch() {
            var oldUrl = trimEmptyHash($browser.url());
            var newUrl = trimEmptyHash($location.absUrl());
            var oldState = $browser.state();
            var currentReplace = $location.$$replace;
            var urlOrStateChanged = oldUrl !== newUrl || $location.$$html5 && $sniffer.history && oldState !== $location.$$state;

            if (initializing || urlOrStateChanged) {
              initializing = false;

              $rootScope.$evalAsync(function () {
                var newUrl = $location.absUrl();
                var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;

                // if the location was changed by a `$locationChangeStart` handler then stop
                // processing this location change
                if ($location.absUrl() !== newUrl) return;

                if (defaultPrevented) {
                  $location.$$parse(oldUrl);
                  $location.$$state = oldState;
                } else {
                  if (urlOrStateChanged) {
                    setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                  }
                  afterLocationChange(oldUrl, oldState);
                }
              });
            }

            $location.$$replace = false;

            // we don't need to return anything because $evalAsync will make the digest loop dirty when
            // there is a change
          });

          return $location;

          function afterLocationChange(oldUrl, oldState) {
            $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl, $location.$$state, oldState);
          }
        }];
      }

      /**
       * @ngdoc service
       * @name $log
       * @requires $window
       *
       * @description
       * Simple service for logging. Default implementation safely writes the message
       * into the browser's console (if present).
       *
       * The main purpose of this service is to simplify debugging and troubleshooting.
       *
       * The default is to log `debug` messages. You can use
       * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
       *
       * @example
         <example module="logExample">
           <file name="script.js">
             angular.module('logExample', [])
               .controller('LogController', ['$scope', '$log', function($scope, $log) {
                 $scope.$log = $log;
                 $scope.message = 'Hello World!';
               }]);
           </file>
           <file name="index.html">
             <div ng-controller="LogController">
               <p>Reload this page with open console, enter text and hit the log button...</p>
               <label>Message:
               <input type="text" ng-model="message" /></label>
               <button ng-click="$log.log(message)">log</button>
               <button ng-click="$log.warn(message)">warn</button>
               <button ng-click="$log.info(message)">info</button>
               <button ng-click="$log.error(message)">error</button>
               <button ng-click="$log.debug(message)">debug</button>
             </div>
           </file>
         </example>
       */

      /**
       * @ngdoc provider
       * @name $logProvider
       * @description
       * Use the `$logProvider` to configure how the application logs messages
       */
      function $LogProvider() {
        var debug = true,
            self = this;

        /**
         * @ngdoc method
         * @name $logProvider#debugEnabled
         * @description
         * @param {boolean=} flag enable or disable debug level messages
         * @returns {*} current value if used as getter or itself (chaining) if used as setter
         */
        this.debugEnabled = function (flag) {
          if (isDefined(flag)) {
            debug = flag;
            return this;
          } else {
            return debug;
          }
        };

        this.$get = ['$window', function ($window) {
          return {
            /**
             * @ngdoc method
             * @name $log#log
             *
             * @description
             * Write a log message
             */
            log: consoleLog('log'),

            /**
             * @ngdoc method
             * @name $log#info
             *
             * @description
             * Write an information message
             */
            info: consoleLog('info'),

            /**
             * @ngdoc method
             * @name $log#warn
             *
             * @description
             * Write a warning message
             */
            warn: consoleLog('warn'),

            /**
             * @ngdoc method
             * @name $log#error
             *
             * @description
             * Write an error message
             */
            error: consoleLog('error'),

            /**
             * @ngdoc method
             * @name $log#debug
             *
             * @description
             * Write a debug message
             */
            debug: function () {
              var fn = consoleLog('debug');

              return function () {
                if (debug) {
                  fn.apply(self, arguments);
                }
              };
            }()
          };

          function formatError(arg) {
            if (arg instanceof Error) {
              if (arg.stack) {
                arg = arg.message && arg.stack.indexOf(arg.message) === -1 ? 'Error: ' + arg.message + '\n' + arg.stack : arg.stack;
              } else if (arg.sourceURL) {
                arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
              }
            }
            return arg;
          }

          function consoleLog(type) {
            var console = $window.console || {},
                logFn = console[type] || console.log || noop,
                hasApply = false;

            // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
            // The reason behind this is that console.log has type "object" in IE8...
            try {
              hasApply = !!logFn.apply;
            } catch (e) {}

            if (hasApply) {
              return function () {
                var args = [];
                forEach(arguments, function (arg) {
                  args.push(formatError(arg));
                });
                return logFn.apply(console, args);
              };
            }

            // we are IE which either doesn't have window.console => this is noop and we do nothing,
            // or we are IE where console.log doesn't have apply so we log at least first 2 args
            return function (arg1, arg2) {
              logFn(arg1, arg2 == null ? '' : arg2);
            };
          }
        }];
      }

      /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
       *     Any commits to this file should be reviewed with security in mind.  *
       *   Changes to this file can potentially create security vulnerabilities. *
       *          An approval from 2 Core members with history of modifying      *
       *                         this file is required.                          *
       *                                                                         *
       *  Does the change somehow allow for arbitrary javascript to be executed? *
       *    Or allows for someone to change the prototype of built-in objects?   *
       *     Or gives undesired access to variables likes document or window?    *
       * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

      var $parseMinErr = minErr('$parse');

      // Sandboxing Angular Expressions
      // ------------------------------
      // Angular expressions are generally considered safe because these expressions only have direct
      // access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
      // obtaining a reference to native JS functions such as the Function constructor.
      //
      // As an example, consider the following Angular expression:
      //
      //   {}.toString.constructor('alert("evil JS code")')
      //
      // This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
      // against the expression language, but not to prevent exploits that were enabled by exposing
      // sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
      // practice and therefore we are not even trying to protect against interaction with an object
      // explicitly exposed in this way.
      //
      // In general, it is not possible to access a Window object from an angular expression unless a
      // window or some DOM object that has a reference to window is published onto a Scope.
      // Similarly we prevent invocations of function known to be dangerous, as well as assignments to
      // native objects.
      //
      // See https://docs.angularjs.org/guide/security


      function ensureSafeMemberName(name, fullExpression) {
        if (name === "__defineGetter__" || name === "__defineSetter__" || name === "__lookupGetter__" || name === "__lookupSetter__" || name === "__proto__") {
          throw $parseMinErr('isecfld', 'Attempting to access a disallowed field in Angular expressions! ' + 'Expression: {0}', fullExpression);
        }
        return name;
      }

      function getStringValue(name) {
        // Property names must be strings. This means that non-string objects cannot be used
        // as keys in an object. Any non-string object, including a number, is typecasted
        // into a string via the toString method.
        // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
        //
        // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
        // to a string. It's not always possible. If `name` is an object and its `toString` method is
        // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
        //
        // TypeError: Cannot convert object to primitive value
        //
        // For performance reasons, we don't catch this error here and allow it to propagate up the call
        // stack. Note that you'll get the same error in JavaScript if you try to access a property using
        // such a 'broken' object as a key.
        return name + '';
      }

      function ensureSafeObject(obj, fullExpression) {
        // nifty check if obj is Function that is fast and works across iframes and other contexts
        if (obj) {
          if (obj.constructor === obj) {
            throw $parseMinErr('isecfn', 'Referencing Function in Angular expressions is disallowed! Expression: {0}', fullExpression);
          } else if ( // isWindow(obj)
          obj.window === obj) {
            throw $parseMinErr('isecwindow', 'Referencing the Window in Angular expressions is disallowed! Expression: {0}', fullExpression);
          } else if ( // isElement(obj)
          obj.children && (obj.nodeName || obj.prop && obj.attr && obj.find)) {
            throw $parseMinErr('isecdom', 'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}', fullExpression);
          } else if ( // block Object so that we can't get hold of dangerous Object.* methods
          obj === Object) {
            throw $parseMinErr('isecobj', 'Referencing Object in Angular expressions is disallowed! Expression: {0}', fullExpression);
          }
        }
        return obj;
      }

      var CALL = Function.prototype.call;
      var APPLY = Function.prototype.apply;
      var BIND = Function.prototype.bind;

      function ensureSafeFunction(obj, fullExpression) {
        if (obj) {
          if (obj.constructor === obj) {
            throw $parseMinErr('isecfn', 'Referencing Function in Angular expressions is disallowed! Expression: {0}', fullExpression);
          } else if (obj === CALL || obj === APPLY || obj === BIND) {
            throw $parseMinErr('isecff', 'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}', fullExpression);
          }
        }
      }

      function ensureSafeAssignContext(obj, fullExpression) {
        if (obj) {
          if (obj === 0 .constructor || obj === false.constructor || obj === ''.constructor || obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
            throw $parseMinErr('isecaf', 'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
          }
        }
      }

      var OPERATORS = createMap();
      forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function (operator) {
        OPERATORS[operator] = true;
      });
      var ESCAPE = { "n": "\n", "f": "\f", "r": "\r", "t": "\t", "v": "\v", "'": "'", '"': '"' };

      /////////////////////////////////////////


      /**
       * @constructor
       */
      var Lexer = function (options) {
        this.options = options;
      };

      Lexer.prototype = {
        constructor: Lexer,

        lex: function (text) {
          this.text = text;
          this.index = 0;
          this.tokens = [];

          while (this.index < this.text.length) {
            var ch = this.text.charAt(this.index);
            if (ch === '"' || ch === "'") {
              this.readString(ch);
            } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
              this.readNumber();
            } else if (this.isIdentifierStart(this.peekMultichar())) {
              this.readIdent();
            } else if (this.is(ch, '(){}[].,;:?')) {
              this.tokens.push({ index: this.index, text: ch });
              this.index++;
            } else if (this.isWhitespace(ch)) {
              this.index++;
            } else {
              var ch2 = ch + this.peek();
              var ch3 = ch2 + this.peek(2);
              var op1 = OPERATORS[ch];
              var op2 = OPERATORS[ch2];
              var op3 = OPERATORS[ch3];
              if (op1 || op2 || op3) {
                var token = op3 ? ch3 : op2 ? ch2 : ch;
                this.tokens.push({ index: this.index, text: token, operator: true });
                this.index += token.length;
              } else {
                this.throwError('Unexpected next character ', this.index, this.index + 1);
              }
            }
          }
          return this.tokens;
        },

        is: function (ch, chars) {
          return chars.indexOf(ch) !== -1;
        },

        peek: function (i) {
          var num = i || 1;
          return this.index + num < this.text.length ? this.text.charAt(this.index + num) : false;
        },

        isNumber: function (ch) {
          return '0' <= ch && ch <= '9' && typeof ch === "string";
        },

        isWhitespace: function (ch) {
          // IE treats non-breaking space as \u00A0
          return ch === ' ' || ch === '\r' || ch === '\t' || ch === '\n' || ch === '\v' || ch === '\u00A0';
        },

        isIdentifierStart: function (ch) {
          return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
        },

        isValidIdentifierStart: function (ch) {
          return 'a' <= ch && ch <= 'z' || 'A' <= ch && ch <= 'Z' || '_' === ch || ch === '$';
        },

        isIdentifierContinue: function (ch) {
          return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
        },

        isValidIdentifierContinue: function (ch, cp) {
          return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
        },

        codePointAt: function (ch) {
          if (ch.length === 1) return ch.charCodeAt(0);
          /*jshint bitwise: false*/
          return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
          /*jshint bitwise: true*/
        },

        peekMultichar: function () {
          var ch = this.text.charAt(this.index);
          var peek = this.peek();
          if (!peek) {
            return ch;
          }
          var cp1 = ch.charCodeAt(0);
          var cp2 = peek.charCodeAt(0);
          if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
            return ch + peek;
          }
          return ch;
        },

        isExpOperator: function (ch) {
          return ch === '-' || ch === '+' || this.isNumber(ch);
        },

        throwError: function (error, start, end) {
          end = end || this.index;
          var colStr = isDefined(start) ? 's ' + start + '-' + this.index + ' [' + this.text.substring(start, end) + ']' : ' ' + end;
          throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].', error, colStr, this.text);
        },

        readNumber: function () {
          var number = '';
          var start = this.index;
          while (this.index < this.text.length) {
            var ch = lowercase(this.text.charAt(this.index));
            if (ch == '.' || this.isNumber(ch)) {
              number += ch;
            } else {
              var peekCh = this.peek();
              if (ch == 'e' && this.isExpOperator(peekCh)) {
                number += ch;
              } else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) == 'e') {
                number += ch;
              } else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) == 'e') {
                this.throwError('Invalid exponent');
              } else {
                break;
              }
            }
            this.index++;
          }
          this.tokens.push({
            index: start,
            text: number,
            constant: true,
            value: Number(number)
          });
        },

        readIdent: function () {
          var start = this.index;
          this.index += this.peekMultichar().length;
          while (this.index < this.text.length) {
            var ch = this.peekMultichar();
            if (!this.isIdentifierContinue(ch)) {
              break;
            }
            this.index += ch.length;
          }
          this.tokens.push({
            index: start,
            text: this.text.slice(start, this.index),
            identifier: true
          });
        },

        readString: function (quote) {
          var start = this.index;
          this.index++;
          var string = '';
          var rawString = quote;
          var escape = false;
          while (this.index < this.text.length) {
            var ch = this.text.charAt(this.index);
            rawString += ch;
            if (escape) {
              if (ch === 'u') {
                var hex = this.text.substring(this.index + 1, this.index + 5);
                if (!hex.match(/[\da-f]{4}/i)) {
                  this.throwError('Invalid unicode escape [\\u' + hex + ']');
                }
                this.index += 4;
                string += String.fromCharCode(parseInt(hex, 16));
              } else {
                var rep = ESCAPE[ch];
                string = string + (rep || ch);
              }
              escape = false;
            } else if (ch === '\\') {
              escape = true;
            } else if (ch === quote) {
              this.index++;
              this.tokens.push({
                index: start,
                text: rawString,
                constant: true,
                value: string
              });
              return;
            } else {
              string += ch;
            }
            this.index++;
          }
          this.throwError('Unterminated quote', start);
        }
      };

      var AST = function (lexer, options) {
        this.lexer = lexer;
        this.options = options;
      };

      AST.Program = 'Program';
      AST.ExpressionStatement = 'ExpressionStatement';
      AST.AssignmentExpression = 'AssignmentExpression';
      AST.ConditionalExpression = 'ConditionalExpression';
      AST.LogicalExpression = 'LogicalExpression';
      AST.BinaryExpression = 'BinaryExpression';
      AST.UnaryExpression = 'UnaryExpression';
      AST.CallExpression = 'CallExpression';
      AST.MemberExpression = 'MemberExpression';
      AST.Identifier = 'Identifier';
      AST.Literal = 'Literal';
      AST.ArrayExpression = 'ArrayExpression';
      AST.Property = 'Property';
      AST.ObjectExpression = 'ObjectExpression';
      AST.ThisExpression = 'ThisExpression';
      AST.LocalsExpression = 'LocalsExpression';

      // Internal use only
      AST.NGValueParameter = 'NGValueParameter';

      AST.prototype = {
        ast: function (text) {
          this.text = text;
          this.tokens = this.lexer.lex(text);

          var value = this.program();

          if (this.tokens.length !== 0) {
            this.throwError('is an unexpected token', this.tokens[0]);
          }

          return value;
        },

        program: function () {
          var body = [];
          while (true) {
            if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']')) body.push(this.expressionStatement());
            if (!this.expect(';')) {
              return { type: AST.Program, body: body };
            }
          }
        },

        expressionStatement: function () {
          return { type: AST.ExpressionStatement, expression: this.filterChain() };
        },

        filterChain: function () {
          var left = this.expression();
          var token;
          while (token = this.expect('|')) {
            left = this.filter(left);
          }
          return left;
        },

        expression: function () {
          return this.assignment();
        },

        assignment: function () {
          var result = this.ternary();
          if (this.expect('=')) {
            result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '=' };
          }
          return result;
        },

        ternary: function () {
          var test = this.logicalOR();
          var alternate;
          var consequent;
          if (this.expect('?')) {
            alternate = this.expression();
            if (this.consume(':')) {
              consequent = this.expression();
              return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent };
            }
          }
          return test;
        },

        logicalOR: function () {
          var left = this.logicalAND();
          while (this.expect('||')) {
            left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
          }
          return left;
        },

        logicalAND: function () {
          var left = this.equality();
          while (this.expect('&&')) {
            left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality() };
          }
          return left;
        },

        equality: function () {
          var left = this.relational();
          var token;
          while (token = this.expect('==', '!=', '===', '!==')) {
            left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
          }
          return left;
        },

        relational: function () {
          var left = this.additive();
          var token;
          while (token = this.expect('<', '>', '<=', '>=')) {
            left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
          }
          return left;
        },

        additive: function () {
          var left = this.multiplicative();
          var token;
          while (token = this.expect('+', '-')) {
            left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
          }
          return left;
        },

        multiplicative: function () {
          var left = this.unary();
          var token;
          while (token = this.expect('*', '/', '%')) {
            left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
          }
          return left;
        },

        unary: function () {
          var token;
          if (token = this.expect('+', '-', '!')) {
            return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
          } else {
            return this.primary();
          }
        },

        primary: function () {
          var primary;
          if (this.expect('(')) {
            primary = this.filterChain();
            this.consume(')');
          } else if (this.expect('[')) {
            primary = this.arrayDeclaration();
          } else if (this.expect('{')) {
            primary = this.object();
          } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
            primary = copy(this.selfReferential[this.consume().text]);
          } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
            primary = { type: AST.Literal, value: this.options.literals[this.consume().text] };
          } else if (this.peek().identifier) {
            primary = this.identifier();
          } else if (this.peek().constant) {
            primary = this.constant();
          } else {
            this.throwError('not a primary expression', this.peek());
          }

          var next;
          while (next = this.expect('(', '[', '.')) {
            if (next.text === '(') {
              primary = { type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
              this.consume(')');
            } else if (next.text === '[') {
              primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
              this.consume(']');
            } else if (next.text === '.') {
              primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
            } else {
              this.throwError('IMPOSSIBLE');
            }
          }
          return primary;
        },

        filter: function (baseExpression) {
          var args = [baseExpression];
          var result = { type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true };

          while (this.expect(':')) {
            args.push(this.expression());
          }

          return result;
        },

        parseArguments: function () {
          var args = [];
          if (this.peekToken().text !== ')') {
            do {
              args.push(this.filterChain());
            } while (this.expect(','));
          }
          return args;
        },

        identifier: function () {
          var token = this.consume();
          if (!token.identifier) {
            this.throwError('is not a valid identifier', token);
          }
          return { type: AST.Identifier, name: token.text };
        },

        constant: function () {
          // TODO check that it is a constant
          return { type: AST.Literal, value: this.consume().value };
        },

        arrayDeclaration: function () {
          var elements = [];
          if (this.peekToken().text !== ']') {
            do {
              if (this.peek(']')) {
                // Support trailing commas per ES5.1.
                break;
              }
              elements.push(this.expression());
            } while (this.expect(','));
          }
          this.consume(']');

          return { type: AST.ArrayExpression, elements: elements };
        },

        object: function () {
          var properties = [],
              property;
          if (this.peekToken().text !== '}') {
            do {
              if (this.peek('}')) {
                // Support trailing commas per ES5.1.
                break;
              }
              property = { type: AST.Property, kind: 'init' };
              if (this.peek().constant) {
                property.key = this.constant();
                property.computed = false;
                this.consume(':');
                property.value = this.expression();
              } else if (this.peek().identifier) {
                property.key = this.identifier();
                property.computed = false;
                if (this.peek(':')) {
                  this.consume(':');
                  property.value = this.expression();
                } else {
                  property.value = property.key;
                }
              } else if (this.peek('[')) {
                this.consume('[');
                property.key = this.expression();
                this.consume(']');
                property.computed = true;
                this.consume(':');
                property.value = this.expression();
              } else {
                this.throwError("invalid key", this.peek());
              }
              properties.push(property);
            } while (this.expect(','));
          }
          this.consume('}');

          return { type: AST.ObjectExpression, properties: properties };
        },

        throwError: function (msg, token) {
          throw $parseMinErr('syntax', 'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].', token.text, msg, token.index + 1, this.text, this.text.substring(token.index));
        },

        consume: function (e1) {
          if (this.tokens.length === 0) {
            throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
          }

          var token = this.expect(e1);
          if (!token) {
            this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
          }
          return token;
        },

        peekToken: function () {
          if (this.tokens.length === 0) {
            throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
          }
          return this.tokens[0];
        },

        peek: function (e1, e2, e3, e4) {
          return this.peekAhead(0, e1, e2, e3, e4);
        },

        peekAhead: function (i, e1, e2, e3, e4) {
          if (this.tokens.length > i) {
            var token = this.tokens[i];
            var t = token.text;
            if (t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4) {
              return token;
            }
          }
          return false;
        },

        expect: function (e1, e2, e3, e4) {
          var token = this.peek(e1, e2, e3, e4);
          if (token) {
            this.tokens.shift();
            return token;
          }
          return false;
        },

        selfReferential: {
          'this': { type: AST.ThisExpression },
          '$locals': { type: AST.LocalsExpression }
        }
      };

      function ifDefined(v, d) {
        return typeof v !== 'undefined' ? v : d;
      }

      function plusFn(l, r) {
        if (typeof l === 'undefined') return r;
        if (typeof r === 'undefined') return l;
        return l + r;
      }

      function isStateless($filter, filterName) {
        var fn = $filter(filterName);
        return !fn.$stateful;
      }

      function findConstantAndWatchExpressions(ast, $filter) {
        var allConstants;
        var argsToWatch;
        switch (ast.type) {
          case AST.Program:
            allConstants = true;
            forEach(ast.body, function (expr) {
              findConstantAndWatchExpressions(expr.expression, $filter);
              allConstants = allConstants && expr.expression.constant;
            });
            ast.constant = allConstants;
            break;
          case AST.Literal:
            ast.constant = true;
            ast.toWatch = [];
            break;
          case AST.UnaryExpression:
            findConstantAndWatchExpressions(ast.argument, $filter);
            ast.constant = ast.argument.constant;
            ast.toWatch = ast.argument.toWatch;
            break;
          case AST.BinaryExpression:
            findConstantAndWatchExpressions(ast.left, $filter);
            findConstantAndWatchExpressions(ast.right, $filter);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
            break;
          case AST.LogicalExpression:
            findConstantAndWatchExpressions(ast.left, $filter);
            findConstantAndWatchExpressions(ast.right, $filter);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = ast.constant ? [] : [ast];
            break;
          case AST.ConditionalExpression:
            findConstantAndWatchExpressions(ast.test, $filter);
            findConstantAndWatchExpressions(ast.alternate, $filter);
            findConstantAndWatchExpressions(ast.consequent, $filter);
            ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
            ast.toWatch = ast.constant ? [] : [ast];
            break;
          case AST.Identifier:
            ast.constant = false;
            ast.toWatch = [ast];
            break;
          case AST.MemberExpression:
            findConstantAndWatchExpressions(ast.object, $filter);
            if (ast.computed) {
              findConstantAndWatchExpressions(ast.property, $filter);
            }
            ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
            ast.toWatch = [ast];
            break;
          case AST.CallExpression:
            allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
            argsToWatch = [];
            forEach(ast.arguments, function (expr) {
              findConstantAndWatchExpressions(expr, $filter);
              allConstants = allConstants && expr.constant;
              if (!expr.constant) {
                argsToWatch.push.apply(argsToWatch, expr.toWatch);
              }
            });
            ast.constant = allConstants;
            ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
            break;
          case AST.AssignmentExpression:
            findConstantAndWatchExpressions(ast.left, $filter);
            findConstantAndWatchExpressions(ast.right, $filter);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = [ast];
            break;
          case AST.ArrayExpression:
            allConstants = true;
            argsToWatch = [];
            forEach(ast.elements, function (expr) {
              findConstantAndWatchExpressions(expr, $filter);
              allConstants = allConstants && expr.constant;
              if (!expr.constant) {
                argsToWatch.push.apply(argsToWatch, expr.toWatch);
              }
            });
            ast.constant = allConstants;
            ast.toWatch = argsToWatch;
            break;
          case AST.ObjectExpression:
            allConstants = true;
            argsToWatch = [];
            forEach(ast.properties, function (property) {
              findConstantAndWatchExpressions(property.value, $filter);
              allConstants = allConstants && property.value.constant && !property.computed;
              if (!property.value.constant) {
                argsToWatch.push.apply(argsToWatch, property.value.toWatch);
              }
            });
            ast.constant = allConstants;
            ast.toWatch = argsToWatch;
            break;
          case AST.ThisExpression:
            ast.constant = false;
            ast.toWatch = [];
            break;
          case AST.LocalsExpression:
            ast.constant = false;
            ast.toWatch = [];
            break;
        }
      }

      function getInputs(body) {
        if (body.length != 1) return;
        var lastExpression = body[0].expression;
        var candidate = lastExpression.toWatch;
        if (candidate.length !== 1) return candidate;
        return candidate[0] !== lastExpression ? candidate : undefined;
      }

      function isAssignable(ast) {
        return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
      }

      function assignableAST(ast) {
        if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
          return { type: AST.AssignmentExpression, left: ast.body[0].expression, right: { type: AST.NGValueParameter }, operator: '=' };
        }
      }

      function isLiteral(ast) {
        return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
      }

      function isConstant(ast) {
        return ast.constant;
      }

      function ASTCompiler(astBuilder, $filter) {
        this.astBuilder = astBuilder;
        this.$filter = $filter;
      }

      ASTCompiler.prototype = {
        compile: function (expression, expensiveChecks) {
          var self = this;
          var ast = this.astBuilder.ast(expression);
          this.state = {
            nextId: 0,
            filters: {},
            expensiveChecks: expensiveChecks,
            fn: { vars: [], body: [], own: {} },
            assign: { vars: [], body: [], own: {} },
            inputs: []
          };
          findConstantAndWatchExpressions(ast, self.$filter);
          var extra = '';
          var assignable;
          this.stage = 'assign';
          if (assignable = assignableAST(ast)) {
            this.state.computing = 'assign';
            var result = this.nextId();
            this.recurse(assignable, result);
            this.return_(result);
            extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
          }
          var toWatch = getInputs(ast.body);
          self.stage = 'inputs';
          forEach(toWatch, function (watch, key) {
            var fnKey = 'fn' + key;
            self.state[fnKey] = { vars: [], body: [], own: {} };
            self.state.computing = fnKey;
            var intoId = self.nextId();
            self.recurse(watch, intoId);
            self.return_(intoId);
            self.state.inputs.push(fnKey);
            watch.watchId = key;
          });
          this.state.computing = 'fn';
          this.stage = 'main';
          this.recurse(ast);
          var fnString =
          // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
          // This is a workaround for this until we do a better job at only removing the prefix only when we should.
          '"' + this.USE + ' ' + this.STRICT + '";\n' + this.filterPrefix() + 'var fn=' + this.generateFunction('fn', 's,l,a,i') + extra + this.watchFns() + 'return fn;';

          /* jshint -W054 */
          var fn = new Function('$filter', 'ensureSafeMemberName', 'ensureSafeObject', 'ensureSafeFunction', 'getStringValue', 'ensureSafeAssignContext', 'ifDefined', 'plus', 'text', fnString)(this.$filter, ensureSafeMemberName, ensureSafeObject, ensureSafeFunction, getStringValue, ensureSafeAssignContext, ifDefined, plusFn, expression);
          /* jshint +W054 */
          this.state = this.stage = undefined;
          fn.literal = isLiteral(ast);
          fn.constant = isConstant(ast);
          return fn;
        },

        USE: 'use',

        STRICT: 'strict',

        watchFns: function () {
          var result = [];
          var fns = this.state.inputs;
          var self = this;
          forEach(fns, function (name) {
            result.push('var ' + name + '=' + self.generateFunction(name, 's'));
          });
          if (fns.length) {
            result.push('fn.inputs=[' + fns.join(',') + '];');
          }
          return result.join('');
        },

        generateFunction: function (name, params) {
          return 'function(' + params + '){' + this.varsPrefix(name) + this.body(name) + '};';
        },

        filterPrefix: function () {
          var parts = [];
          var self = this;
          forEach(this.state.filters, function (id, filter) {
            parts.push(id + '=$filter(' + self.escape(filter) + ')');
          });
          if (parts.length) return 'var ' + parts.join(',') + ';';
          return '';
        },

        varsPrefix: function (section) {
          return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
        },

        body: function (section) {
          return this.state[section].body.join('');
        },

        recurse: function (ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
          var left,
              right,
              self = this,
              args,
              expression,
              computed;
          recursionFn = recursionFn || noop;
          if (!skipWatchIdCheck && isDefined(ast.watchId)) {
            intoId = intoId || this.nextId();
            this.if_('i', this.lazyAssign(intoId, this.computedMember('i', ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
            return;
          }
          switch (ast.type) {
            case AST.Program:
              forEach(ast.body, function (expression, pos) {
                self.recurse(expression.expression, undefined, undefined, function (expr) {
                  right = expr;
                });
                if (pos !== ast.body.length - 1) {
                  self.current().body.push(right, ';');
                } else {
                  self.return_(right);
                }
              });
              break;
            case AST.Literal:
              expression = this.escape(ast.value);
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.UnaryExpression:
              this.recurse(ast.argument, undefined, undefined, function (expr) {
                right = expr;
              });
              expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.BinaryExpression:
              this.recurse(ast.left, undefined, undefined, function (expr) {
                left = expr;
              });
              this.recurse(ast.right, undefined, undefined, function (expr) {
                right = expr;
              });
              if (ast.operator === '+') {
                expression = this.plus(left, right);
              } else if (ast.operator === '-') {
                expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
              } else {
                expression = '(' + left + ')' + ast.operator + '(' + right + ')';
              }
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.LogicalExpression:
              intoId = intoId || this.nextId();
              self.recurse(ast.left, intoId);
              self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
              recursionFn(intoId);
              break;
            case AST.ConditionalExpression:
              intoId = intoId || this.nextId();
              self.recurse(ast.test, intoId);
              self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
              recursionFn(intoId);
              break;
            case AST.Identifier:
              intoId = intoId || this.nextId();
              if (nameId) {
                nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
                nameId.computed = false;
                nameId.name = ast.name;
              }
              ensureSafeMemberName(ast.name);
              self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)), function () {
                self.if_(self.stage === 'inputs' || 's', function () {
                  if (create && create !== 1) {
                    self.if_(self.not(self.nonComputedMember('s', ast.name)), self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
                  }
                  self.assign(intoId, self.nonComputedMember('s', ast.name));
                });
              }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name)));
              if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
                self.addEnsureSafeObject(intoId);
              }
              recursionFn(intoId);
              break;
            case AST.MemberExpression:
              left = nameId && (nameId.context = this.nextId()) || this.nextId();
              intoId = intoId || this.nextId();
              self.recurse(ast.object, left, undefined, function () {
                self.if_(self.notNull(left), function () {
                  if (create && create !== 1) {
                    self.addEnsureSafeAssignContext(left);
                  }
                  if (ast.computed) {
                    right = self.nextId();
                    self.recurse(ast.property, right);
                    self.getStringValue(right);
                    self.addEnsureSafeMemberName(right);
                    if (create && create !== 1) {
                      self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
                    }
                    expression = self.ensureSafeObject(self.computedMember(left, right));
                    self.assign(intoId, expression);
                    if (nameId) {
                      nameId.computed = true;
                      nameId.name = right;
                    }
                  } else {
                    ensureSafeMemberName(ast.property.name);
                    if (create && create !== 1) {
                      self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
                    }
                    expression = self.nonComputedMember(left, ast.property.name);
                    if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
                      expression = self.ensureSafeObject(expression);
                    }
                    self.assign(intoId, expression);
                    if (nameId) {
                      nameId.computed = false;
                      nameId.name = ast.property.name;
                    }
                  }
                }, function () {
                  self.assign(intoId, 'undefined');
                });
                recursionFn(intoId);
              }, !!create);
              break;
            case AST.CallExpression:
              intoId = intoId || this.nextId();
              if (ast.filter) {
                right = self.filter(ast.callee.name);
                args = [];
                forEach(ast.arguments, function (expr) {
                  var argument = self.nextId();
                  self.recurse(expr, argument);
                  args.push(argument);
                });
                expression = right + '(' + args.join(',') + ')';
                self.assign(intoId, expression);
                recursionFn(intoId);
              } else {
                right = self.nextId();
                left = {};
                args = [];
                self.recurse(ast.callee, right, left, function () {
                  self.if_(self.notNull(right), function () {
                    self.addEnsureSafeFunction(right);
                    forEach(ast.arguments, function (expr) {
                      self.recurse(expr, self.nextId(), undefined, function (argument) {
                        args.push(self.ensureSafeObject(argument));
                      });
                    });
                    if (left.name) {
                      if (!self.state.expensiveChecks) {
                        self.addEnsureSafeObject(left.context);
                      }
                      expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
                    } else {
                      expression = right + '(' + args.join(',') + ')';
                    }
                    expression = self.ensureSafeObject(expression);
                    self.assign(intoId, expression);
                  }, function () {
                    self.assign(intoId, 'undefined');
                  });
                  recursionFn(intoId);
                });
              }
              break;
            case AST.AssignmentExpression:
              right = this.nextId();
              left = {};
              if (!isAssignable(ast.left)) {
                throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
              }
              this.recurse(ast.left, undefined, left, function () {
                self.if_(self.notNull(left.context), function () {
                  self.recurse(ast.right, right);
                  self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
                  self.addEnsureSafeAssignContext(left.context);
                  expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
                  self.assign(intoId, expression);
                  recursionFn(intoId || expression);
                });
              }, 1);
              break;
            case AST.ArrayExpression:
              args = [];
              forEach(ast.elements, function (expr) {
                self.recurse(expr, self.nextId(), undefined, function (argument) {
                  args.push(argument);
                });
              });
              expression = '[' + args.join(',') + ']';
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.ObjectExpression:
              args = [];
              computed = false;
              forEach(ast.properties, function (property) {
                if (property.computed) {
                  computed = true;
                }
              });
              if (computed) {
                intoId = intoId || this.nextId();
                this.assign(intoId, '{}');
                forEach(ast.properties, function (property) {
                  if (property.computed) {
                    left = self.nextId();
                    self.recurse(property.key, left);
                  } else {
                    left = property.key.type === AST.Identifier ? property.key.name : '' + property.key.value;
                  }
                  right = self.nextId();
                  self.recurse(property.value, right);
                  self.assign(self.member(intoId, left, property.computed), right);
                });
              } else {
                forEach(ast.properties, function (property) {
                  self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function (expr) {
                    args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : '' + property.key.value) + ':' + expr);
                  });
                });
                expression = '{' + args.join(',') + '}';
                this.assign(intoId, expression);
              }
              recursionFn(intoId || expression);
              break;
            case AST.ThisExpression:
              this.assign(intoId, 's');
              recursionFn('s');
              break;
            case AST.LocalsExpression:
              this.assign(intoId, 'l');
              recursionFn('l');
              break;
            case AST.NGValueParameter:
              this.assign(intoId, 'v');
              recursionFn('v');
              break;
          }
        },

        getHasOwnProperty: function (element, property) {
          var key = element + '.' + property;
          var own = this.current().own;
          if (!own.hasOwnProperty(key)) {
            own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
          }
          return own[key];
        },

        assign: function (id, value) {
          if (!id) return;
          this.current().body.push(id, '=', value, ';');
          return id;
        },

        filter: function (filterName) {
          if (!this.state.filters.hasOwnProperty(filterName)) {
            this.state.filters[filterName] = this.nextId(true);
          }
          return this.state.filters[filterName];
        },

        ifDefined: function (id, defaultValue) {
          return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
        },

        plus: function (left, right) {
          return 'plus(' + left + ',' + right + ')';
        },

        return_: function (id) {
          this.current().body.push('return ', id, ';');
        },

        if_: function (test, alternate, consequent) {
          if (test === true) {
            alternate();
          } else {
            var body = this.current().body;
            body.push('if(', test, '){');
            alternate();
            body.push('}');
            if (consequent) {
              body.push('else{');
              consequent();
              body.push('}');
            }
          }
        },

        not: function (expression) {
          return '!(' + expression + ')';
        },

        notNull: function (expression) {
          return expression + '!=null';
        },

        nonComputedMember: function (left, right) {
          var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
          var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
          if (SAFE_IDENTIFIER.test(right)) {
            return left + '.' + right;
          } else {
            return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
          }
        },

        computedMember: function (left, right) {
          return left + '[' + right + ']';
        },

        member: function (left, right, computed) {
          if (computed) return this.computedMember(left, right);
          return this.nonComputedMember(left, right);
        },

        addEnsureSafeObject: function (item) {
          this.current().body.push(this.ensureSafeObject(item), ';');
        },

        addEnsureSafeMemberName: function (item) {
          this.current().body.push(this.ensureSafeMemberName(item), ';');
        },

        addEnsureSafeFunction: function (item) {
          this.current().body.push(this.ensureSafeFunction(item), ';');
        },

        addEnsureSafeAssignContext: function (item) {
          this.current().body.push(this.ensureSafeAssignContext(item), ';');
        },

        ensureSafeObject: function (item) {
          return 'ensureSafeObject(' + item + ',text)';
        },

        ensureSafeMemberName: function (item) {
          return 'ensureSafeMemberName(' + item + ',text)';
        },

        ensureSafeFunction: function (item) {
          return 'ensureSafeFunction(' + item + ',text)';
        },

        getStringValue: function (item) {
          this.assign(item, 'getStringValue(' + item + ')');
        },

        ensureSafeAssignContext: function (item) {
          return 'ensureSafeAssignContext(' + item + ',text)';
        },

        lazyRecurse: function (ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
          var self = this;
          return function () {
            self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
          };
        },

        lazyAssign: function (id, value) {
          var self = this;
          return function () {
            self.assign(id, value);
          };
        },

        stringEscapeRegex: /[^ a-zA-Z0-9]/g,

        stringEscapeFn: function (c) {
          return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
        },

        escape: function (value) {
          if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
          if (isNumber(value)) return value.toString();
          if (value === true) return 'true';
          if (value === false) return 'false';
          if (value === null) return 'null';
          if (typeof value === 'undefined') return 'undefined';

          throw $parseMinErr('esc', 'IMPOSSIBLE');
        },

        nextId: function (skip, init) {
          var id = 'v' + this.state.nextId++;
          if (!skip) {
            this.current().vars.push(id + (init ? '=' + init : ''));
          }
          return id;
        },

        current: function () {
          return this.state[this.state.computing];
        }
      };

      function ASTInterpreter(astBuilder, $filter) {
        this.astBuilder = astBuilder;
        this.$filter = $filter;
      }

      ASTInterpreter.prototype = {
        compile: function (expression, expensiveChecks) {
          var self = this;
          var ast = this.astBuilder.ast(expression);
          this.expression = expression;
          this.expensiveChecks = expensiveChecks;
          findConstantAndWatchExpressions(ast, self.$filter);
          var assignable;
          var assign;
          if (assignable = assignableAST(ast)) {
            assign = this.recurse(assignable);
          }
          var toWatch = getInputs(ast.body);
          var inputs;
          if (toWatch) {
            inputs = [];
            forEach(toWatch, function (watch, key) {
              var input = self.recurse(watch);
              watch.input = input;
              inputs.push(input);
              watch.watchId = key;
            });
          }
          var expressions = [];
          forEach(ast.body, function (expression) {
            expressions.push(self.recurse(expression.expression));
          });
          var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function (scope, locals) {
            var lastValue;
            forEach(expressions, function (exp) {
              lastValue = exp(scope, locals);
            });
            return lastValue;
          };
          if (assign) {
            fn.assign = function (scope, value, locals) {
              return assign(scope, locals, value);
            };
          }
          if (inputs) {
            fn.inputs = inputs;
          }
          fn.literal = isLiteral(ast);
          fn.constant = isConstant(ast);
          return fn;
        },

        recurse: function (ast, context, create) {
          var left,
              right,
              self = this,
              args,
              expression;
          if (ast.input) {
            return this.inputs(ast.input, ast.watchId);
          }
          switch (ast.type) {
            case AST.Literal:
              return this.value(ast.value, context);
            case AST.UnaryExpression:
              right = this.recurse(ast.argument);
              return this['unary' + ast.operator](right, context);
            case AST.BinaryExpression:
              left = this.recurse(ast.left);
              right = this.recurse(ast.right);
              return this['binary' + ast.operator](left, right, context);
            case AST.LogicalExpression:
              left = this.recurse(ast.left);
              right = this.recurse(ast.right);
              return this['binary' + ast.operator](left, right, context);
            case AST.ConditionalExpression:
              return this['ternary?:'](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
            case AST.Identifier:
              ensureSafeMemberName(ast.name, self.expression);
              return self.identifier(ast.name, self.expensiveChecks || isPossiblyDangerousMemberName(ast.name), context, create, self.expression);
            case AST.MemberExpression:
              left = this.recurse(ast.object, false, !!create);
              if (!ast.computed) {
                ensureSafeMemberName(ast.property.name, self.expression);
                right = ast.property.name;
              }
              if (ast.computed) right = this.recurse(ast.property);
              return ast.computed ? this.computedMember(left, right, context, create, self.expression) : this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
            case AST.CallExpression:
              args = [];
              forEach(ast.arguments, function (expr) {
                args.push(self.recurse(expr));
              });
              if (ast.filter) right = this.$filter(ast.callee.name);
              if (!ast.filter) right = this.recurse(ast.callee, true);
              return ast.filter ? function (scope, locals, assign, inputs) {
                var values = [];
                for (var i = 0; i < args.length; ++i) {
                  values.push(args[i](scope, locals, assign, inputs));
                }
                var value = right.apply(undefined, values, inputs);
                return context ? { context: undefined, name: undefined, value: value } : value;
              } : function (scope, locals, assign, inputs) {
                var rhs = right(scope, locals, assign, inputs);
                var value;
                if (rhs.value != null) {
                  ensureSafeObject(rhs.context, self.expression);
                  ensureSafeFunction(rhs.value, self.expression);
                  var values = [];
                  for (var i = 0; i < args.length; ++i) {
                    values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
                  }
                  value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
                }
                return context ? { value: value } : value;
              };
            case AST.AssignmentExpression:
              left = this.recurse(ast.left, true, 1);
              right = this.recurse(ast.right);
              return function (scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                ensureSafeObject(lhs.value, self.expression);
                ensureSafeAssignContext(lhs.context);
                lhs.context[lhs.name] = rhs;
                return context ? { value: rhs } : rhs;
              };
            case AST.ArrayExpression:
              args = [];
              forEach(ast.elements, function (expr) {
                args.push(self.recurse(expr));
              });
              return function (scope, locals, assign, inputs) {
                var value = [];
                for (var i = 0; i < args.length; ++i) {
                  value.push(args[i](scope, locals, assign, inputs));
                }
                return context ? { value: value } : value;
              };
            case AST.ObjectExpression:
              args = [];
              forEach(ast.properties, function (property) {
                if (property.computed) {
                  args.push({ key: self.recurse(property.key),
                    computed: true,
                    value: self.recurse(property.value)
                  });
                } else {
                  args.push({ key: property.key.type === AST.Identifier ? property.key.name : '' + property.key.value,
                    computed: false,
                    value: self.recurse(property.value)
                  });
                }
              });
              return function (scope, locals, assign, inputs) {
                var value = {};
                for (var i = 0; i < args.length; ++i) {
                  if (args[i].computed) {
                    value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
                  } else {
                    value[args[i].key] = args[i].value(scope, locals, assign, inputs);
                  }
                }
                return context ? { value: value } : value;
              };
            case AST.ThisExpression:
              return function (scope) {
                return context ? { value: scope } : scope;
              };
            case AST.LocalsExpression:
              return function (scope, locals) {
                return context ? { value: locals } : locals;
              };
            case AST.NGValueParameter:
              return function (scope, locals, assign) {
                return context ? { value: assign } : assign;
              };
          }
        },

        'unary+': function (argument, context) {
          return function (scope, locals, assign, inputs) {
            var arg = argument(scope, locals, assign, inputs);
            if (isDefined(arg)) {
              arg = +arg;
            } else {
              arg = 0;
            }
            return context ? { value: arg } : arg;
          };
        },
        'unary-': function (argument, context) {
          return function (scope, locals, assign, inputs) {
            var arg = argument(scope, locals, assign, inputs);
            if (isDefined(arg)) {
              arg = -arg;
            } else {
              arg = 0;
            }
            return context ? { value: arg } : arg;
          };
        },
        'unary!': function (argument, context) {
          return function (scope, locals, assign, inputs) {
            var arg = !argument(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary+': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            var arg = plusFn(lhs, rhs);
            return context ? { value: arg } : arg;
          };
        },
        'binary-': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
            return context ? { value: arg } : arg;
          };
        },
        'binary*': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary/': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary%': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary===': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary!==': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary==': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary!=': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary<': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary>': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary<=': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary>=': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary&&': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'binary||': function (left, right, context) {
          return function (scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        'ternary?:': function (test, alternate, consequent, context) {
          return function (scope, locals, assign, inputs) {
            var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
            return context ? { value: arg } : arg;
          };
        },
        value: function (value, context) {
          return function () {
            return context ? { context: undefined, name: undefined, value: value } : value;
          };
        },
        identifier: function (name, expensiveChecks, context, create, expression) {
          return function (scope, locals, assign, inputs) {
            var base = locals && name in locals ? locals : scope;
            if (create && create !== 1 && base && !base[name]) {
              base[name] = {};
            }
            var value = base ? base[name] : undefined;
            if (expensiveChecks) {
              ensureSafeObject(value, expression);
            }
            if (context) {
              return { context: base, name: name, value: value };
            } else {
              return value;
            }
          };
        },
        computedMember: function (left, right, context, create, expression) {
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs;
            var value;
            if (lhs != null) {
              rhs = right(scope, locals, assign, inputs);
              rhs = getStringValue(rhs);
              ensureSafeMemberName(rhs, expression);
              if (create && create !== 1) {
                ensureSafeAssignContext(lhs);
                if (lhs && !lhs[rhs]) {
                  lhs[rhs] = {};
                }
              }
              value = lhs[rhs];
              ensureSafeObject(value, expression);
            }
            if (context) {
              return { context: lhs, name: rhs, value: value };
            } else {
              return value;
            }
          };
        },
        nonComputedMember: function (left, right, expensiveChecks, context, create, expression) {
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            if (create && create !== 1) {
              ensureSafeAssignContext(lhs);
              if (lhs && !lhs[right]) {
                lhs[right] = {};
              }
            }
            var value = lhs != null ? lhs[right] : undefined;
            if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
              ensureSafeObject(value, expression);
            }
            if (context) {
              return { context: lhs, name: right, value: value };
            } else {
              return value;
            }
          };
        },
        inputs: function (input, watchId) {
          return function (scope, value, locals, inputs) {
            if (inputs) return inputs[watchId];
            return input(scope, value, locals);
          };
        }
      };

      /**
       * @constructor
       */
      var Parser = function (lexer, $filter, options) {
        this.lexer = lexer;
        this.$filter = $filter;
        this.options = options;
        this.ast = new AST(lexer, options);
        this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) : new ASTCompiler(this.ast, $filter);
      };

      Parser.prototype = {
        constructor: Parser,

        parse: function (text) {
          return this.astCompiler.compile(text, this.options.expensiveChecks);
        }
      };

      function isPossiblyDangerousMemberName(name) {
        return name == 'constructor';
      }

      var objectValueOf = Object.prototype.valueOf;

      function getValueOf(value) {
        return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
      }

      ///////////////////////////////////

      /**
       * @ngdoc service
       * @name $parse
       * @kind function
       *
       * @description
       *
       * Converts Angular {@link guide/expression expression} into a function.
       *
       * ```js
       *   var getter = $parse('user.name');
       *   var setter = getter.assign;
       *   var context = {user:{name:'angular'}};
       *   var locals = {user:{name:'local'}};
       *
       *   expect(getter(context)).toEqual('angular');
       *   setter(context, 'newValue');
       *   expect(context.user.name).toEqual('newValue');
       *   expect(getter(context, locals)).toEqual('local');
       * ```
       *
       *
       * @param {string} expression String expression to compile.
       * @returns {function(context, locals)} a function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
       *      are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
       *      `context`.
       *
       *    The returned function also has the following properties:
       *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
       *        literal.
       *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
       *        constant literals.
       *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
       *        set to a function to change its value on the given context.
       *
       */

      /**
       * @ngdoc provider
       * @name $parseProvider
       *
       * @description
       * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
       *  service.
       */
      function $ParseProvider() {
        var cacheDefault = createMap();
        var cacheExpensive = createMap();
        var literals = {
          'true': true,
          'false': false,
          'null': null,
          'undefined': undefined
        };
        var identStart, identContinue;

        /**
         * @ngdoc method
         * @name $parseProvider#addLiteral
         * @description
         *
         * Configure $parse service to add literal values that will be present as literal at expressions.
         *
         * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
         * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
         *
         **/
        this.addLiteral = function (literalName, literalValue) {
          literals[literalName] = literalValue;
        };

        /**
         * @ngdoc method
         * @name $parseProvider#setIdentifierFns
         * @description
         *
         * Allows defining the set of characters that are allowed in Angular expressions. The function
         * `identifierStart` will get called to know if a given character is a valid character to be the
         * first character for an identifier. The function `identifierContinue` will get called to know if
         * a given character is a valid character to be a follow-up identifier character. The functions
         * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
         * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
         * mind that the `string` parameter can be two characters long depending on the character
         * representation. It is expected for the function to return `true` or `false`, whether that
         * character is allowed or not.
         *
         * Since this function will be called extensivelly, keep the implementation of these functions fast,
         * as the performance of these functions have a direct impact on the expressions parsing speed.
         *
         * @param {function=} identifierStart The function that will decide whether the given character is
         *   a valid identifier start character.
         * @param {function=} identifierContinue The function that will decide whether the given character is
         *   a valid identifier continue character.
         */
        this.setIdentifierFns = function (identifierStart, identifierContinue) {
          identStart = identifierStart;
          identContinue = identifierContinue;
          return this;
        };

        this.$get = ['$filter', function ($filter) {
          var noUnsafeEval = csp().noUnsafeEval;
          var $parseOptions = {
            csp: noUnsafeEval,
            expensiveChecks: false,
            literals: copy(literals),
            isIdentifierStart: isFunction(identStart) && identStart,
            isIdentifierContinue: isFunction(identContinue) && identContinue
          },
              $parseOptionsExpensive = {
            csp: noUnsafeEval,
            expensiveChecks: true,
            literals: copy(literals),
            isIdentifierStart: isFunction(identStart) && identStart,
            isIdentifierContinue: isFunction(identContinue) && identContinue
          };
          var runningChecksEnabled = false;

          $parse.$$runningExpensiveChecks = function () {
            return runningChecksEnabled;
          };

          return $parse;

          function $parse(exp, interceptorFn, expensiveChecks) {
            var parsedExpression, oneTime, cacheKey;

            expensiveChecks = expensiveChecks || runningChecksEnabled;

            switch (typeof exp) {
              case 'string':
                exp = exp.trim();
                cacheKey = exp;

                var cache = expensiveChecks ? cacheExpensive : cacheDefault;
                parsedExpression = cache[cacheKey];

                if (!parsedExpression) {
                  if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
                    oneTime = true;
                    exp = exp.substring(2);
                  }
                  var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
                  var lexer = new Lexer(parseOptions);
                  var parser = new Parser(lexer, $filter, parseOptions);
                  parsedExpression = parser.parse(exp);
                  if (parsedExpression.constant) {
                    parsedExpression.$$watchDelegate = constantWatchDelegate;
                  } else if (oneTime) {
                    parsedExpression.$$watchDelegate = parsedExpression.literal ? oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
                  } else if (parsedExpression.inputs) {
                    parsedExpression.$$watchDelegate = inputsWatchDelegate;
                  }
                  if (expensiveChecks) {
                    parsedExpression = expensiveChecksInterceptor(parsedExpression);
                  }
                  cache[cacheKey] = parsedExpression;
                }
                return addInterceptor(parsedExpression, interceptorFn);

              case 'function':
                return addInterceptor(exp, interceptorFn);

              default:
                return addInterceptor(noop, interceptorFn);
            }
          }

          function expensiveChecksInterceptor(fn) {
            if (!fn) return fn;
            expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
            expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
            expensiveCheckFn.constant = fn.constant;
            expensiveCheckFn.literal = fn.literal;
            for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
              fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
            }
            expensiveCheckFn.inputs = fn.inputs;

            return expensiveCheckFn;

            function expensiveCheckFn(scope, locals, assign, inputs) {
              var expensiveCheckOldValue = runningChecksEnabled;
              runningChecksEnabled = true;
              try {
                return fn(scope, locals, assign, inputs);
              } finally {
                runningChecksEnabled = expensiveCheckOldValue;
              }
            }
          }

          function expressionInputDirtyCheck(newValue, oldValueOfValue) {

            if (newValue == null || oldValueOfValue == null) {
              // null/undefined
              return newValue === oldValueOfValue;
            }

            if (typeof newValue === 'object') {

              // attempt to convert the value to a primitive type
              // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
              //             be cheaply dirty-checked
              newValue = getValueOf(newValue);

              if (typeof newValue === 'object') {
                // objects/arrays are not supported - deep-watching them would be too expensive
                return false;
              }

              // fall-through to the primitive equality check
            }

            //Primitive or NaN
            return newValue === oldValueOfValue || newValue !== newValue && oldValueOfValue !== oldValueOfValue;
          }

          function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
            var inputExpressions = parsedExpression.inputs;
            var lastResult;

            if (inputExpressions.length === 1) {
              var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
              inputExpressions = inputExpressions[0];
              return scope.$watch(function expressionInputWatch(scope) {
                var newInputValue = inputExpressions(scope);
                if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
                  lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
                  oldInputValueOf = newInputValue && getValueOf(newInputValue);
                }
                return lastResult;
              }, listener, objectEquality, prettyPrintExpression);
            }

            var oldInputValueOfValues = [];
            var oldInputValues = [];
            for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
              oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
              oldInputValues[i] = null;
            }

            return scope.$watch(function expressionInputsWatch(scope) {
              var changed = false;

              for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
                var newInputValue = inputExpressions[i](scope);
                if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
                  oldInputValues[i] = newInputValue;
                  oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
                }
              }

              if (changed) {
                lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
              }

              return lastResult;
            }, listener, objectEquality, prettyPrintExpression);
          }

          function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
            var unwatch, lastValue;
            return unwatch = scope.$watch(function oneTimeWatch(scope) {
              return parsedExpression(scope);
            }, function oneTimeListener(value, old, scope) {
              lastValue = value;
              if (isFunction(listener)) {
                listener.apply(this, arguments);
              }
              if (isDefined(value)) {
                scope.$$postDigest(function () {
                  if (isDefined(lastValue)) {
                    unwatch();
                  }
                });
              }
            }, objectEquality);
          }

          function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
            var unwatch, lastValue;
            return unwatch = scope.$watch(function oneTimeWatch(scope) {
              return parsedExpression(scope);
            }, function oneTimeListener(value, old, scope) {
              lastValue = value;
              if (isFunction(listener)) {
                listener.call(this, value, old, scope);
              }
              if (isAllDefined(value)) {
                scope.$$postDigest(function () {
                  if (isAllDefined(lastValue)) unwatch();
                });
              }
            }, objectEquality);

            function isAllDefined(value) {
              var allDefined = true;
              forEach(value, function (val) {
                if (!isDefined(val)) allDefined = false;
              });
              return allDefined;
            }
          }

          function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
            var unwatch;
            return unwatch = scope.$watch(function constantWatch(scope) {
              unwatch();
              return parsedExpression(scope);
            }, listener, objectEquality);
          }

          function addInterceptor(parsedExpression, interceptorFn) {
            if (!interceptorFn) return parsedExpression;
            var watchDelegate = parsedExpression.$$watchDelegate;
            var useInputs = false;

            var regularWatch = watchDelegate !== oneTimeLiteralWatchDelegate && watchDelegate !== oneTimeWatchDelegate;

            var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
              var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
              return interceptorFn(value, scope, locals);
            } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
              var value = parsedExpression(scope, locals, assign, inputs);
              var result = interceptorFn(value, scope, locals);
              // we only return the interceptor's result if the
              // initial value is defined (for bind-once)
              return isDefined(value) ? result : value;
            };

            // Propagate $$watchDelegates other then inputsWatchDelegate
            if (parsedExpression.$$watchDelegate && parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
              fn.$$watchDelegate = parsedExpression.$$watchDelegate;
            } else if (!interceptorFn.$stateful) {
              // If there is an interceptor, but no watchDelegate then treat the interceptor like
              // we treat filters - it is assumed to be a pure function unless flagged with $stateful
              fn.$$watchDelegate = inputsWatchDelegate;
              useInputs = !parsedExpression.inputs;
              fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
            }

            return fn;
          }
        }];
      }

      /**
       * @ngdoc service
       * @name $q
       * @requires $rootScope
       *
       * @description
       * A service that helps you run functions asynchronously, and use their return values (or exceptions)
       * when they are done processing.
       *
       * This is an implementation of promises/deferred objects inspired by
       * [Kris Kowal's Q](https://github.com/kriskowal/q).
       *
       * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
       * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
       *
       * # $q constructor
       *
       * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
       * function as the first argument. This is similar to the native Promise implementation from ES6,
       * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
       *
       * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
       * available yet.
       *
       * It can be used like so:
       *
       * ```js
       *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
       *   // are available in the current lexical scope (they could have been injected or passed in).
       *
       *   function asyncGreet(name) {
       *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
       *     return $q(function(resolve, reject) {
       *       setTimeout(function() {
       *         if (okToGreet(name)) {
       *           resolve('Hello, ' + name + '!');
       *         } else {
       *           reject('Greeting ' + name + ' is not allowed.');
       *         }
       *       }, 1000);
       *     });
       *   }
       *
       *   var promise = asyncGreet('Robin Hood');
       *   promise.then(function(greeting) {
       *     alert('Success: ' + greeting);
       *   }, function(reason) {
       *     alert('Failed: ' + reason);
       *   });
       * ```
       *
       * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
       *
       * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
       *
       * However, the more traditional CommonJS-style usage is still available, and documented below.
       *
       * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
       * interface for interacting with an object that represents the result of an action that is
       * performed asynchronously, and may or may not be finished at any given point in time.
       *
       * From the perspective of dealing with error handling, deferred and promise APIs are to
       * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
       *
       * ```js
       *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
       *   // are available in the current lexical scope (they could have been injected or passed in).
       *
       *   function asyncGreet(name) {
       *     var deferred = $q.defer();
       *
       *     setTimeout(function() {
       *       deferred.notify('About to greet ' + name + '.');
       *
       *       if (okToGreet(name)) {
       *         deferred.resolve('Hello, ' + name + '!');
       *       } else {
       *         deferred.reject('Greeting ' + name + ' is not allowed.');
       *       }
       *     }, 1000);
       *
       *     return deferred.promise;
       *   }
       *
       *   var promise = asyncGreet('Robin Hood');
       *   promise.then(function(greeting) {
       *     alert('Success: ' + greeting);
       *   }, function(reason) {
       *     alert('Failed: ' + reason);
       *   }, function(update) {
       *     alert('Got notification: ' + update);
       *   });
       * ```
       *
       * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
       * comes in the way of guarantees that promise and deferred APIs make, see
       * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
       *
       * Additionally the promise api allows for composition that is very hard to do with the
       * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
       * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
       * section on serial or parallel joining of promises.
       *
       * # The Deferred API
       *
       * A new instance of deferred is constructed by calling `$q.defer()`.
       *
       * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
       * that can be used for signaling the successful or unsuccessful completion, as well as the status
       * of the task.
       *
       * **Methods**
       *
       * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
       *   constructed via `$q.reject`, the promise will be rejected instead.
       * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
       *   resolving it with a rejection constructed via `$q.reject`.
       * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
       *   multiple times before the promise is either resolved or rejected.
       *
       * **Properties**
       *
       * - promise – `{Promise}` – promise object associated with this deferred.
       *
       *
       * # The Promise API
       *
       * A new promise instance is created when a deferred instance is created and can be retrieved by
       * calling `deferred.promise`.
       *
       * The purpose of the promise object is to allow for interested parties to get access to the result
       * of the deferred task when it completes.
       *
       * **Methods**
       *
       * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
       *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
       *   as soon as the result is available. The callbacks are called with a single argument: the result
       *   or rejection reason. Additionally, the notify callback may be called zero or more times to
       *   provide a progress indication, before the promise is resolved or rejected.
       *
       *   This method *returns a new promise* which is resolved or rejected via the return value of the
       *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
       *   with the value which is resolved in that promise using
       *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
       *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
       *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
       *   arguments are optional.
       *
       * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
       *
       * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
       *   but to do so without modifying the final value. This is useful to release resources or do some
       *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
       *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
       *   more information.
       *
       * # Chaining promises
       *
       * Because calling the `then` method of a promise returns a new derived promise, it is easily
       * possible to create a chain of promises:
       *
       * ```js
       *   promiseB = promiseA.then(function(result) {
       *     return result + 1;
       *   });
       *
       *   // promiseB will be resolved immediately after promiseA is resolved and its value
       *   // will be the result of promiseA incremented by 1
       * ```
       *
       * It is possible to create chains of any length and since a promise can be resolved with another
       * promise (which will defer its resolution further), it is possible to pause/defer resolution of
       * the promises at any point in the chain. This makes it possible to implement powerful APIs like
       * $http's response interceptors.
       *
       *
       * # Differences between Kris Kowal's Q and $q
       *
       *  There are two main differences:
       *
       * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
       *   mechanism in angular, which means faster propagation of resolution or rejection into your
       *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
       * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
       *   all the important functionality needed for common async tasks.
       *
       * # Testing
       *
       *  ```js
       *    it('should simulate promise', inject(function($q, $rootScope) {
       *      var deferred = $q.defer();
       *      var promise = deferred.promise;
       *      var resolvedValue;
       *
       *      promise.then(function(value) { resolvedValue = value; });
       *      expect(resolvedValue).toBeUndefined();
       *
       *      // Simulate resolving of promise
       *      deferred.resolve(123);
       *      // Note that the 'then' function does not get called synchronously.
       *      // This is because we want the promise API to always be async, whether or not
       *      // it got called synchronously or asynchronously.
       *      expect(resolvedValue).toBeUndefined();
       *
       *      // Propagate promise resolution to 'then' functions using $apply().
       *      $rootScope.$apply();
       *      expect(resolvedValue).toEqual(123);
       *    }));
       *  ```
       *
       * @param {function(function, function)} resolver Function which is responsible for resolving or
       *   rejecting the newly created promise. The first parameter is a function which resolves the
       *   promise, the second parameter is a function which rejects the promise.
       *
       * @returns {Promise} The newly created promise.
       */
      function $QProvider() {

        this.$get = ['$rootScope', '$exceptionHandler', function ($rootScope, $exceptionHandler) {
          return qFactory(function (callback) {
            $rootScope.$evalAsync(callback);
          }, $exceptionHandler);
        }];
      }

      function $$QProvider() {
        this.$get = ['$browser', '$exceptionHandler', function ($browser, $exceptionHandler) {
          return qFactory(function (callback) {
            $browser.defer(callback);
          }, $exceptionHandler);
        }];
      }

      /**
       * Constructs a promise manager.
       *
       * @param {function(function)} nextTick Function for executing functions in the next turn.
       * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
       *     debugging purposes.
       * @returns {object} Promise manager.
       */
      function qFactory(nextTick, exceptionHandler) {
        var $qMinErr = minErr('$q', TypeError);

        /**
         * @ngdoc method
         * @name ng.$q#defer
         * @kind function
         *
         * @description
         * Creates a `Deferred` object which represents a task which will finish in the future.
         *
         * @returns {Deferred} Returns a new instance of deferred.
         */
        var defer = function () {
          var d = new Deferred();
          //Necessary to support unbound execution :/
          d.resolve = simpleBind(d, d.resolve);
          d.reject = simpleBind(d, d.reject);
          d.notify = simpleBind(d, d.notify);
          return d;
        };

        function Promise() {
          this.$$state = { status: 0 };
        }

        extend(Promise.prototype, {
          then: function (onFulfilled, onRejected, progressBack) {
            if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
              return this;
            }
            var result = new Deferred();

            this.$$state.pending = this.$$state.pending || [];
            this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
            if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

            return result.promise;
          },

          "catch": function (callback) {
            return this.then(null, callback);
          },

          "finally": function (callback, progressBack) {
            return this.then(function (value) {
              return handleCallback(value, true, callback);
            }, function (error) {
              return handleCallback(error, false, callback);
            }, progressBack);
          }
        });

        //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
        function simpleBind(context, fn) {
          return function (value) {
            fn.call(context, value);
          };
        }

        function processQueue(state) {
          var fn, deferred, pending;

          pending = state.pending;
          state.processScheduled = false;
          state.pending = undefined;
          for (var i = 0, ii = pending.length; i < ii; ++i) {
            deferred = pending[i][0];
            fn = pending[i][state.status];
            try {
              if (isFunction(fn)) {
                deferred.resolve(fn(state.value));
              } else if (state.status === 1) {
                deferred.resolve(state.value);
              } else {
                deferred.reject(state.value);
              }
            } catch (e) {
              deferred.reject(e);
              exceptionHandler(e);
            }
          }
        }

        function scheduleProcessQueue(state) {
          if (state.processScheduled || !state.pending) return;
          state.processScheduled = true;
          nextTick(function () {
            processQueue(state);
          });
        }

        function Deferred() {
          this.promise = new Promise();
        }

        extend(Deferred.prototype, {
          resolve: function (val) {
            if (this.promise.$$state.status) return;
            if (val === this.promise) {
              this.$$reject($qMinErr('qcycle', "Expected promise to be resolved with value other than itself '{0}'", val));
            } else {
              this.$$resolve(val);
            }
          },

          $$resolve: function (val) {
            var then;
            var that = this;
            var done = false;
            try {
              if (isObject(val) || isFunction(val)) then = val && val.then;
              if (isFunction(then)) {
                this.promise.$$state.status = -1;
                then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
              } else {
                this.promise.$$state.value = val;
                this.promise.$$state.status = 1;
                scheduleProcessQueue(this.promise.$$state);
              }
            } catch (e) {
              rejectPromise(e);
              exceptionHandler(e);
            }

            function resolvePromise(val) {
              if (done) return;
              done = true;
              that.$$resolve(val);
            }
            function rejectPromise(val) {
              if (done) return;
              done = true;
              that.$$reject(val);
            }
          },

          reject: function (reason) {
            if (this.promise.$$state.status) return;
            this.$$reject(reason);
          },

          $$reject: function (reason) {
            this.promise.$$state.value = reason;
            this.promise.$$state.status = 2;
            scheduleProcessQueue(this.promise.$$state);
          },

          notify: function (progress) {
            var callbacks = this.promise.$$state.pending;

            if (this.promise.$$state.status <= 0 && callbacks && callbacks.length) {
              nextTick(function () {
                var callback, result;
                for (var i = 0, ii = callbacks.length; i < ii; i++) {
                  result = callbacks[i][0];
                  callback = callbacks[i][3];
                  try {
                    result.notify(isFunction(callback) ? callback(progress) : progress);
                  } catch (e) {
                    exceptionHandler(e);
                  }
                }
              });
            }
          }
        });

        /**
         * @ngdoc method
         * @name $q#reject
         * @kind function
         *
         * @description
         * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
         * used to forward rejection in a chain of promises. If you are dealing with the last promise in
         * a promise chain, you don't need to worry about it.
         *
         * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
         * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
         * a promise error callback and you want to forward the error to the promise derived from the
         * current promise, you have to "rethrow" the error by returning a rejection constructed via
         * `reject`.
         *
         * ```js
         *   promiseB = promiseA.then(function(result) {
         *     // success: do something and resolve promiseB
         *     //          with the old or a new result
         *     return result;
         *   }, function(reason) {
         *     // error: handle the error if possible and
         *     //        resolve promiseB with newPromiseOrValue,
         *     //        otherwise forward the rejection to promiseB
         *     if (canHandle(reason)) {
         *      // handle the error and recover
         *      return newPromiseOrValue;
         *     }
         *     return $q.reject(reason);
         *   });
         * ```
         *
         * @param {*} reason Constant, message, exception or an object representing the rejection reason.
         * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
         */
        var reject = function (reason) {
          var result = new Deferred();
          result.reject(reason);
          return result.promise;
        };

        var makePromise = function makePromise(value, resolved) {
          var result = new Deferred();
          if (resolved) {
            result.resolve(value);
          } else {
            result.reject(value);
          }
          return result.promise;
        };

        var handleCallback = function handleCallback(value, isResolved, callback) {
          var callbackOutput = null;
          try {
            if (isFunction(callback)) callbackOutput = callback();
          } catch (e) {
            return makePromise(e, false);
          }
          if (isPromiseLike(callbackOutput)) {
            return callbackOutput.then(function () {
              return makePromise(value, isResolved);
            }, function (error) {
              return makePromise(error, false);
            });
          } else {
            return makePromise(value, isResolved);
          }
        };

        /**
         * @ngdoc method
         * @name $q#when
         * @kind function
         *
         * @description
         * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
         * This is useful when you are dealing with an object that might or might not be a promise, or if
         * the promise comes from a source that can't be trusted.
         *
         * @param {*} value Value or a promise
         * @param {Function=} successCallback
         * @param {Function=} errorCallback
         * @param {Function=} progressCallback
         * @returns {Promise} Returns a promise of the passed value or promise
         */

        var when = function (value, callback, errback, progressBack) {
          var result = new Deferred();
          result.resolve(value);
          return result.promise.then(callback, errback, progressBack);
        };

        /**
         * @ngdoc method
         * @name $q#resolve
         * @kind function
         *
         * @description
         * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
         *
         * @param {*} value Value or a promise
         * @param {Function=} successCallback
         * @param {Function=} errorCallback
         * @param {Function=} progressCallback
         * @returns {Promise} Returns a promise of the passed value or promise
         */
        var resolve = when;

        /**
         * @ngdoc method
         * @name $q#all
         * @kind function
         *
         * @description
         * Combines multiple promises into a single promise that is resolved when all of the input
         * promises are resolved.
         *
         * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
         * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
         *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
         *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
         *   with the same rejection value.
         */

        function all(promises) {
          var deferred = new Deferred(),
              counter = 0,
              results = isArray(promises) ? [] : {};

          forEach(promises, function (promise, key) {
            counter++;
            when(promise).then(function (value) {
              if (results.hasOwnProperty(key)) return;
              results[key] = value;
              if (! --counter) deferred.resolve(results);
            }, function (reason) {
              if (results.hasOwnProperty(key)) return;
              deferred.reject(reason);
            });
          });

          if (counter === 0) {
            deferred.resolve(results);
          }

          return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name $q#race
         * @kind function
         *
         * @description
         * Returns a promise that resolves or rejects as soon as one of those promises
         * resolves or rejects, with the value or reason from that promise.
         *
         * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
         * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
         * resolves or rejects, with the value or reason from that promise.
         */

        function race(promises) {
          var deferred = defer();

          forEach(promises, function (promise) {
            when(promise).then(deferred.resolve, deferred.reject);
          });

          return deferred.promise;
        }

        var $Q = function Q(resolver) {
          if (!isFunction(resolver)) {
            throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
          }

          var deferred = new Deferred();

          function resolveFn(value) {
            deferred.resolve(value);
          }

          function rejectFn(reason) {
            deferred.reject(reason);
          }

          resolver(resolveFn, rejectFn);

          return deferred.promise;
        };

        // Let's make the instanceof operator work for promises, so that
        // `new $q(fn) instanceof $q` would evaluate to true.
        $Q.prototype = Promise.prototype;

        $Q.defer = defer;
        $Q.reject = reject;
        $Q.when = when;
        $Q.resolve = resolve;
        $Q.all = all;
        $Q.race = race;

        return $Q;
      }

      function $$RAFProvider() {
        //rAF
        this.$get = ['$window', '$timeout', function ($window, $timeout) {
          var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;

          var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;

          var rafSupported = !!requestAnimationFrame;
          var raf = rafSupported ? function (fn) {
            var id = requestAnimationFrame(fn);
            return function () {
              cancelAnimationFrame(id);
            };
          } : function (fn) {
            var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
            return function () {
              $timeout.cancel(timer);
            };
          };

          raf.supported = rafSupported;

          return raf;
        }];
      }

      /**
       * DESIGN NOTES
       *
       * The design decisions behind the scope are heavily favored for speed and memory consumption.
       *
       * The typical use of scope is to watch the expressions, which most of the time return the same
       * value as last time so we optimize the operation.
       *
       * Closures construction is expensive in terms of speed as well as memory:
       *   - No closures, instead use prototypical inheritance for API
       *   - Internal state needs to be stored on scope directly, which means that private state is
       *     exposed as $$____ properties
       *
       * Loop operations are optimized by using while(count--) { ... }
       *   - This means that in order to keep the same order of execution as addition we have to add
       *     items to the array at the beginning (unshift) instead of at the end (push)
       *
       * Child scopes are created and removed often
       *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
       *
       * There are fewer watches than observers. This is why you don't want the observer to be implemented
       * in the same way as watch. Watch requires return of the initialization function which is expensive
       * to construct.
       */

      /**
       * @ngdoc provider
       * @name $rootScopeProvider
       * @description
       *
       * Provider for the $rootScope service.
       */

      /**
       * @ngdoc method
       * @name $rootScopeProvider#digestTtl
       * @description
       *
       * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
       * assuming that the model is unstable.
       *
       * The current default is 10 iterations.
       *
       * In complex applications it's possible that the dependencies between `$watch`s will result in
       * several digest iterations. However if an application needs more than the default 10 digest
       * iterations for its model to stabilize then you should investigate what is causing the model to
       * continuously change during the digest.
       *
       * Increasing the TTL could have performance implications, so you should not change it without
       * proper justification.
       *
       * @param {number} limit The number of digest iterations.
       */

      /**
       * @ngdoc service
       * @name $rootScope
       * @description
       *
       * Every application has a single root {@link ng.$rootScope.Scope scope}.
       * All other scopes are descendant scopes of the root scope. Scopes provide separation
       * between the model and the view, via a mechanism for watching the model for changes.
       * They also provide event emission/broadcast and subscription facility. See the
       * {@link guide/scope developer guide on scopes}.
       */
      function $RootScopeProvider() {
        var TTL = 10;
        var $rootScopeMinErr = minErr('$rootScope');
        var lastDirtyWatch = null;
        var applyAsyncId = null;

        this.digestTtl = function (value) {
          if (arguments.length) {
            TTL = value;
          }
          return TTL;
        };

        function createChildScopeClass(parent) {
          function ChildScope() {
            this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
            this.$$listeners = {};
            this.$$listenerCount = {};
            this.$$watchersCount = 0;
            this.$id = nextUid();
            this.$$ChildScope = null;
          }
          ChildScope.prototype = parent;
          return ChildScope;
        }

        this.$get = ['$exceptionHandler', '$parse', '$browser', function ($exceptionHandler, $parse, $browser) {

          function destroyChildScope($event) {
            $event.currentScope.$$destroyed = true;
          }

          function cleanUpScope($scope) {

            if (msie === 9) {
              // There is a memory leak in IE9 if all child scopes are not disconnected
              // completely when a scope is destroyed. So this code will recurse up through
              // all this scopes children
              //
              // See issue https://github.com/angular/angular.js/issues/10706
              $scope.$$childHead && cleanUpScope($scope.$$childHead);
              $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
            }

            // The code below works around IE9 and V8's memory leaks
            //
            // See:
            // - https://code.google.com/p/v8/issues/detail?id=2073#c26
            // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
            // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

            $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
          }

          /**
           * @ngdoc type
           * @name $rootScope.Scope
           *
           * @description
           * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
           * {@link auto.$injector $injector}. Child scopes are created using the
           * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
           * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
           * an in-depth introduction and usage examples.
           *
           *
           * # Inheritance
           * A scope can inherit from a parent scope, as in this example:
           * ```js
               var parent = $rootScope;
               var child = parent.$new();
                parent.salutation = "Hello";
               expect(child.salutation).toEqual('Hello');
                child.salutation = "Welcome";
               expect(child.salutation).toEqual('Welcome');
               expect(parent.salutation).toEqual('Hello');
           * ```
           *
           * When interacting with `Scope` in tests, additional helper methods are available on the
           * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
           * details.
           *
           *
           * @param {Object.<string, function()>=} providers Map of service factory which need to be
           *                                       provided for the current scope. Defaults to {@link ng}.
           * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
           *                              append/override services provided by `providers`. This is handy
           *                              when unit-testing and having the need to override a default
           *                              service.
           * @returns {Object} Newly created scope.
           *
           */
          function Scope() {
            this.$id = nextUid();
            this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
            this.$root = this;
            this.$$destroyed = false;
            this.$$listeners = {};
            this.$$listenerCount = {};
            this.$$watchersCount = 0;
            this.$$isolateBindings = null;
          }

          /**
           * @ngdoc property
           * @name $rootScope.Scope#$id
           *
           * @description
           * Unique scope ID (monotonically increasing) useful for debugging.
           */

          /**
           * @ngdoc property
           * @name $rootScope.Scope#$parent
           *
           * @description
           * Reference to the parent scope.
           */

          /**
           * @ngdoc property
           * @name $rootScope.Scope#$root
           *
           * @description
           * Reference to the root scope.
           */

          Scope.prototype = {
            constructor: Scope,
            /**
             * @ngdoc method
             * @name $rootScope.Scope#$new
             * @kind function
             *
             * @description
             * Creates a new child {@link ng.$rootScope.Scope scope}.
             *
             * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
             * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
             *
             * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
             * desired for the scope and its child scopes to be permanently detached from the parent and
             * thus stop participating in model change detection and listener notification by invoking.
             *
             * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
             *         parent scope. The scope is isolated, as it can not see parent scope properties.
             *         When creating widgets, it is useful for the widget to not accidentally read parent
             *         state.
             *
             * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
             *                              of the newly created scope. Defaults to `this` scope if not provided.
             *                              This is used when creating a transclude scope to correctly place it
             *                              in the scope hierarchy while maintaining the correct prototypical
             *                              inheritance.
             *
             * @returns {Object} The newly created child scope.
             *
             */
            $new: function (isolate, parent) {
              var child;

              parent = parent || this;

              if (isolate) {
                child = new Scope();
                child.$root = this.$root;
              } else {
                // Only create a child scope class if somebody asks for one,
                // but cache it to allow the VM to optimize lookups.
                if (!this.$$ChildScope) {
                  this.$$ChildScope = createChildScopeClass(this);
                }
                child = new this.$$ChildScope();
              }
              child.$parent = parent;
              child.$$prevSibling = parent.$$childTail;
              if (parent.$$childHead) {
                parent.$$childTail.$$nextSibling = child;
                parent.$$childTail = child;
              } else {
                parent.$$childHead = parent.$$childTail = child;
              }

              // When the new scope is not isolated or we inherit from `this`, and
              // the parent scope is destroyed, the property `$$destroyed` is inherited
              // prototypically. In all other cases, this property needs to be set
              // when the parent scope is destroyed.
              // The listener needs to be added after the parent is set
              if (isolate || parent != this) child.$on('$destroy', destroyChildScope);

              return child;
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$watch
             * @kind function
             *
             * @description
             * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
             *
             * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
             *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
             *   its value when executed multiple times with the same input because it may be executed multiple
             *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
             *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
             * - The `listener` is called only when the value from the current `watchExpression` and the
             *   previous call to `watchExpression` are not equal (with the exception of the initial run,
             *   see below). Inequality is determined according to reference inequality,
             *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
             *    via the `!==` Javascript operator, unless `objectEquality == true`
             *   (see next point)
             * - When `objectEquality == true`, inequality of the `watchExpression` is determined
             *   according to the {@link angular.equals} function. To save the value of the object for
             *   later comparison, the {@link angular.copy} function is used. This therefore means that
             *   watching complex objects will have adverse memory and performance implications.
             * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
             *   This is achieved by rerunning the watchers until no changes are detected. The rerun
             *   iteration limit is 10 to prevent an infinite loop deadlock.
             *
             *
             * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
             * you can register a `watchExpression` function with no `listener`. (Be prepared for
             * multiple calls to your `watchExpression` because it will execute multiple times in a
             * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
             *
             * After a watcher is registered with the scope, the `listener` fn is called asynchronously
             * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
             * watcher. In rare cases, this is undesirable because the listener is called when the result
             * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
             * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
             * listener was called due to initialization.
             *
             *
             *
             * # Example
             * ```js
                 // let's assume that scope was dependency injected as the $rootScope
                 var scope = $rootScope;
                 scope.name = 'misko';
                 scope.counter = 0;
                  expect(scope.counter).toEqual(0);
                 scope.$watch('name', function(newValue, oldValue) {
                   scope.counter = scope.counter + 1;
                 });
                 expect(scope.counter).toEqual(0);
                  scope.$digest();
                 // the listener is always called during the first $digest loop after it was registered
                 expect(scope.counter).toEqual(1);
                  scope.$digest();
                 // but now it will not be called unless the value changes
                 expect(scope.counter).toEqual(1);
                  scope.name = 'adam';
                 scope.$digest();
                 expect(scope.counter).toEqual(2);
                    // Using a function as a watchExpression
                 var food;
                 scope.foodCounter = 0;
                 expect(scope.foodCounter).toEqual(0);
                 scope.$watch(
                   // This function returns the value being watched. It is called for each turn of the $digest loop
                   function() { return food; },
                   // This is the change listener, called when the value returned from the above function changes
                   function(newValue, oldValue) {
                     if ( newValue !== oldValue ) {
                       // Only increment the counter if the value changed
                       scope.foodCounter = scope.foodCounter + 1;
                     }
                   }
                 );
                 // No digest has been run so the counter will be zero
                 expect(scope.foodCounter).toEqual(0);
                  // Run the digest but since food has not changed count will still be zero
                 scope.$digest();
                 expect(scope.foodCounter).toEqual(0);
                  // Update food and run digest.  Now the counter will increment
                 food = 'cheeseburger';
                 scope.$digest();
                 expect(scope.foodCounter).toEqual(1);
              * ```
             *
             *
             *
             * @param {(function()|string)} watchExpression Expression that is evaluated on each
             *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
             *    a call to the `listener`.
             *
             *    - `string`: Evaluated as {@link guide/expression expression}
             *    - `function(scope)`: called with current `scope` as a parameter.
             * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
             *    of `watchExpression` changes.
             *
             *    - `newVal` contains the current value of the `watchExpression`
             *    - `oldVal` contains the previous value of the `watchExpression`
             *    - `scope` refers to the current scope
             * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
             *     comparing for reference equality.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            $watch: function (watchExp, listener, objectEquality, prettyPrintExpression) {
              var get = $parse(watchExp);

              if (get.$$watchDelegate) {
                return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
              }
              var scope = this,
                  array = scope.$$watchers,
                  watcher = {
                fn: listener,
                last: initWatchVal,
                get: get,
                exp: prettyPrintExpression || watchExp,
                eq: !!objectEquality
              };

              lastDirtyWatch = null;

              if (!isFunction(listener)) {
                watcher.fn = noop;
              }

              if (!array) {
                array = scope.$$watchers = [];
              }
              // we use unshift since we use a while loop in $digest for speed.
              // the while loop reads in reverse order.
              array.unshift(watcher);
              incrementWatchersCount(this, 1);

              return function deregisterWatch() {
                if (arrayRemove(array, watcher) >= 0) {
                  incrementWatchersCount(scope, -1);
                }
                lastDirtyWatch = null;
              };
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$watchGroup
             * @kind function
             *
             * @description
             * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
             * If any one expression in the collection changes the `listener` is executed.
             *
             * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
             *   call to $digest() to see if any items changes.
             * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
             *
             * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
             * watched using {@link ng.$rootScope.Scope#$watch $watch()}
             *
             * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
             *    expression in `watchExpressions` changes
             *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
             *    those of `watchExpression`
             *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
             *    those of `watchExpression`
             *    The `scope` refers to the current scope.
             * @returns {function()} Returns a de-registration function for all listeners.
             */
            $watchGroup: function (watchExpressions, listener) {
              var oldValues = new Array(watchExpressions.length);
              var newValues = new Array(watchExpressions.length);
              var deregisterFns = [];
              var self = this;
              var changeReactionScheduled = false;
              var firstRun = true;

              if (!watchExpressions.length) {
                // No expressions means we call the listener ASAP
                var shouldCall = true;
                self.$evalAsync(function () {
                  if (shouldCall) listener(newValues, newValues, self);
                });
                return function deregisterWatchGroup() {
                  shouldCall = false;
                };
              }

              if (watchExpressions.length === 1) {
                // Special case size of one
                return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
                  newValues[0] = value;
                  oldValues[0] = oldValue;
                  listener(newValues, value === oldValue ? newValues : oldValues, scope);
                });
              }

              forEach(watchExpressions, function (expr, i) {
                var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
                  newValues[i] = value;
                  oldValues[i] = oldValue;
                  if (!changeReactionScheduled) {
                    changeReactionScheduled = true;
                    self.$evalAsync(watchGroupAction);
                  }
                });
                deregisterFns.push(unwatchFn);
              });

              function watchGroupAction() {
                changeReactionScheduled = false;

                if (firstRun) {
                  firstRun = false;
                  listener(newValues, newValues, self);
                } else {
                  listener(newValues, oldValues, self);
                }
              }

              return function deregisterWatchGroup() {
                while (deregisterFns.length) {
                  deregisterFns.shift()();
                }
              };
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$watchCollection
             * @kind function
             *
             * @description
             * Shallow watches the properties of an object and fires whenever any of the properties change
             * (for arrays, this implies watching the array items; for object maps, this implies watching
             * the properties). If a change is detected, the `listener` callback is fired.
             *
             * - The `obj` collection is observed via standard $watch operation and is examined on every
             *   call to $digest() to see if any items have been added, removed, or moved.
             * - The `listener` is called whenever anything within the `obj` has changed. Examples include
             *   adding, removing, and moving items belonging to an object or array.
             *
             *
             * # Example
             * ```js
                $scope.names = ['igor', 'matias', 'misko', 'james'];
                $scope.dataCount = 4;
                 $scope.$watchCollection('names', function(newNames, oldNames) {
                  $scope.dataCount = newNames.length;
                });
                 expect($scope.dataCount).toEqual(4);
                $scope.$digest();
                 //still at 4 ... no changes
                expect($scope.dataCount).toEqual(4);
                 $scope.names.pop();
                $scope.$digest();
                 //now there's been a change
                expect($scope.dataCount).toEqual(3);
             * ```
             *
             *
             * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
             *    expression value should evaluate to an object or an array which is observed on each
             *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
             *    collection will trigger a call to the `listener`.
             *
             * @param {function(newCollection, oldCollection, scope)} listener a callback function called
             *    when a change is detected.
             *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
             *    - The `oldCollection` object is a copy of the former collection data.
             *      Due to performance considerations, the`oldCollection` value is computed only if the
             *      `listener` function declares two or more arguments.
             *    - The `scope` argument refers to the current scope.
             *
             * @returns {function()} Returns a de-registration function for this listener. When the
             *    de-registration function is executed, the internal watch operation is terminated.
             */
            $watchCollection: function (obj, listener) {
              $watchCollectionInterceptor.$stateful = true;

              var self = this;
              // the current value, updated on each dirty-check run
              var newValue;
              // a shallow copy of the newValue from the last dirty-check run,
              // updated to match newValue during dirty-check run
              var oldValue;
              // a shallow copy of the newValue from when the last change happened
              var veryOldValue;
              // only track veryOldValue if the listener is asking for it
              var trackVeryOldValue = listener.length > 1;
              var changeDetected = 0;
              var changeDetector = $parse(obj, $watchCollectionInterceptor);
              var internalArray = [];
              var internalObject = {};
              var initRun = true;
              var oldLength = 0;

              function $watchCollectionInterceptor(_value) {
                newValue = _value;
                var newLength, key, bothNaN, newItem, oldItem;

                // If the new value is undefined, then return undefined as the watch may be a one-time watch
                if (isUndefined(newValue)) return;

                if (!isObject(newValue)) {
                  // if primitive
                  if (oldValue !== newValue) {
                    oldValue = newValue;
                    changeDetected++;
                  }
                } else if (isArrayLike(newValue)) {
                  if (oldValue !== internalArray) {
                    // we are transitioning from something which was not an array into array.
                    oldValue = internalArray;
                    oldLength = oldValue.length = 0;
                    changeDetected++;
                  }

                  newLength = newValue.length;

                  if (oldLength !== newLength) {
                    // if lengths do not match we need to trigger change notification
                    changeDetected++;
                    oldValue.length = oldLength = newLength;
                  }
                  // copy the items to oldValue and look for changes.
                  for (var i = 0; i < newLength; i++) {
                    oldItem = oldValue[i];
                    newItem = newValue[i];

                    bothNaN = oldItem !== oldItem && newItem !== newItem;
                    if (!bothNaN && oldItem !== newItem) {
                      changeDetected++;
                      oldValue[i] = newItem;
                    }
                  }
                } else {
                  if (oldValue !== internalObject) {
                    // we are transitioning from something which was not an object into object.
                    oldValue = internalObject = {};
                    oldLength = 0;
                    changeDetected++;
                  }
                  // copy the items to oldValue and look for changes.
                  newLength = 0;
                  for (key in newValue) {
                    if (hasOwnProperty.call(newValue, key)) {
                      newLength++;
                      newItem = newValue[key];
                      oldItem = oldValue[key];

                      if (key in oldValue) {
                        bothNaN = oldItem !== oldItem && newItem !== newItem;
                        if (!bothNaN && oldItem !== newItem) {
                          changeDetected++;
                          oldValue[key] = newItem;
                        }
                      } else {
                        oldLength++;
                        oldValue[key] = newItem;
                        changeDetected++;
                      }
                    }
                  }
                  if (oldLength > newLength) {
                    // we used to have more keys, need to find them and destroy them.
                    changeDetected++;
                    for (key in oldValue) {
                      if (!hasOwnProperty.call(newValue, key)) {
                        oldLength--;
                        delete oldValue[key];
                      }
                    }
                  }
                }
                return changeDetected;
              }

              function $watchCollectionAction() {
                if (initRun) {
                  initRun = false;
                  listener(newValue, newValue, self);
                } else {
                  listener(newValue, veryOldValue, self);
                }

                // make a copy for the next time a collection is changed
                if (trackVeryOldValue) {
                  if (!isObject(newValue)) {
                    //primitive
                    veryOldValue = newValue;
                  } else if (isArrayLike(newValue)) {
                    veryOldValue = new Array(newValue.length);
                    for (var i = 0; i < newValue.length; i++) {
                      veryOldValue[i] = newValue[i];
                    }
                  } else {
                    // if object
                    veryOldValue = {};
                    for (var key in newValue) {
                      if (hasOwnProperty.call(newValue, key)) {
                        veryOldValue[key] = newValue[key];
                      }
                    }
                  }
                }
              }

              return this.$watch(changeDetector, $watchCollectionAction);
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$digest
             * @kind function
             *
             * @description
             * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
             * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
             * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
             * until no more listeners are firing. This means that it is possible to get into an infinite
             * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
             * iterations exceeds 10.
             *
             * Usually, you don't call `$digest()` directly in
             * {@link ng.directive:ngController controllers} or in
             * {@link ng.$compileProvider#directive directives}.
             * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
             * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
             *
             * If you want to be notified whenever `$digest()` is called,
             * you can register a `watchExpression` function with
             * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
             *
             * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
             *
             * # Example
             * ```js
                 var scope = ...;
                 scope.name = 'misko';
                 scope.counter = 0;
                  expect(scope.counter).toEqual(0);
                 scope.$watch('name', function(newValue, oldValue) {
                   scope.counter = scope.counter + 1;
                 });
                 expect(scope.counter).toEqual(0);
                  scope.$digest();
                 // the listener is always called during the first $digest loop after it was registered
                 expect(scope.counter).toEqual(1);
                  scope.$digest();
                 // but now it will not be called unless the value changes
                 expect(scope.counter).toEqual(1);
                  scope.name = 'adam';
                 scope.$digest();
                 expect(scope.counter).toEqual(2);
             * ```
             *
             */
            $digest: function () {
              var watch,
                  value,
                  last,
                  fn,
                  get,
                  watchers,
                  length,
                  dirty,
                  ttl = TTL,
                  next,
                  current,
                  target = this,
                  watchLog = [],
                  logIdx,
                  asyncTask;

              beginPhase('$digest');
              // Check for changes to browser url that happened in sync before the call to $digest
              $browser.$$checkUrlChange();

              if (this === $rootScope && applyAsyncId !== null) {
                // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
                // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
                $browser.defer.cancel(applyAsyncId);
                flushApplyAsync();
              }

              lastDirtyWatch = null;

              do {
                // "while dirty" loop
                dirty = false;
                current = target;

                // It's safe for asyncQueuePosition to be a local variable here because this loop can't
                // be reentered recursively. Calling $digest from a function passed to $applyAsync would
                // lead to a '$digest already in progress' error.
                for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
                  try {
                    asyncTask = asyncQueue[asyncQueuePosition];
                    asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                  lastDirtyWatch = null;
                }
                asyncQueue.length = 0;

                traverseScopesLoop: do {
                  // "traverse the scopes" loop
                  if (watchers = current.$$watchers) {
                    // process our watches
                    length = watchers.length;
                    while (length--) {
                      try {
                        watch = watchers[length];
                        // Most common watches are on primitives, in which case we can short
                        // circuit it with === operator, only when === fails do we use .equals
                        if (watch) {
                          get = watch.get;
                          if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : typeof value === 'number' && typeof last === 'number' && isNaN(value) && isNaN(last))) {
                            dirty = true;
                            lastDirtyWatch = watch;
                            watch.last = watch.eq ? copy(value, null) : value;
                            fn = watch.fn;
                            fn(value, last === initWatchVal ? value : last, current);
                            if (ttl < 5) {
                              logIdx = 4 - ttl;
                              if (!watchLog[logIdx]) watchLog[logIdx] = [];
                              watchLog[logIdx].push({
                                msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                                newVal: value,
                                oldVal: last
                              });
                            }
                          } else if (watch === lastDirtyWatch) {
                            // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                            // have already been tested.
                            dirty = false;
                            break traverseScopesLoop;
                          }
                        }
                      } catch (e) {
                        $exceptionHandler(e);
                      }
                    }
                  }

                  // Insanity Warning: scope depth-first traversal
                  // yes, this code is a bit crazy, but it works and we have tests to prove it!
                  // this piece should be kept in sync with the traversal in $broadcast
                  if (!(next = current.$$watchersCount && current.$$childHead || current !== target && current.$$nextSibling)) {
                    while (current !== target && !(next = current.$$nextSibling)) {
                      current = current.$parent;
                    }
                  }
                } while (current = next);

                // `break traverseScopesLoop;` takes us to here

                if ((dirty || asyncQueue.length) && !ttl--) {
                  clearPhase();
                  throw $rootScopeMinErr('infdig', '{0} $digest() iterations reached. Aborting!\n' + 'Watchers fired in the last 5 iterations: {1}', TTL, watchLog);
                }
              } while (dirty || asyncQueue.length);

              clearPhase();

              // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
              while (postDigestQueuePosition < postDigestQueue.length) {
                try {
                  postDigestQueue[postDigestQueuePosition++]();
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              postDigestQueue.length = postDigestQueuePosition = 0;
            },

            /**
             * @ngdoc event
             * @name $rootScope.Scope#$destroy
             * @eventType broadcast on scope being destroyed
             *
             * @description
             * Broadcasted when a scope and its children are being destroyed.
             *
             * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
             * clean up DOM bindings before an element is removed from the DOM.
             */

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$destroy
             * @kind function
             *
             * @description
             * Removes the current scope (and all of its children) from the parent scope. Removal implies
             * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
             * propagate to the current scope and its children. Removal also implies that the current
             * scope is eligible for garbage collection.
             *
             * The `$destroy()` is usually used by directives such as
             * {@link ng.directive:ngRepeat ngRepeat} for managing the
             * unrolling of the loop.
             *
             * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
             * Application code can register a `$destroy` event handler that will give it a chance to
             * perform any necessary cleanup.
             *
             * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
             * clean up DOM bindings before an element is removed from the DOM.
             */
            $destroy: function () {
              // We can't destroy a scope that has been already destroyed.
              if (this.$$destroyed) return;
              var parent = this.$parent;

              this.$broadcast('$destroy');
              this.$$destroyed = true;

              if (this === $rootScope) {
                //Remove handlers attached to window when $rootScope is removed
                $browser.$$applicationDestroyed();
              }

              incrementWatchersCount(this, -this.$$watchersCount);
              for (var eventName in this.$$listenerCount) {
                decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
              }

              // sever all the references to parent scopes (after this cleanup, the current scope should
              // not be retained by any of our references and should be eligible for garbage collection)
              if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
              if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
              if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
              if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

              // Disable listeners, watchers and apply/digest methods
              this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
              this.$on = this.$watch = this.$watchGroup = function () {
                return noop;
              };
              this.$$listeners = {};

              // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
              this.$$nextSibling = null;
              cleanUpScope(this);
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$eval
             * @kind function
             *
             * @description
             * Executes the `expression` on the current scope and returns the result. Any exceptions in
             * the expression are propagated (uncaught). This is useful when evaluating Angular
             * expressions.
             *
             * # Example
             * ```js
                 var scope = ng.$rootScope.Scope();
                 scope.a = 1;
                 scope.b = 2;
                  expect(scope.$eval('a+b')).toEqual(3);
                 expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
             * ```
             *
             * @param {(string|function())=} expression An angular expression to be executed.
             *
             *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
             *    - `function(scope)`: execute the function with the current `scope` parameter.
             *
             * @param {(object)=} locals Local variables object, useful for overriding values in scope.
             * @returns {*} The result of evaluating the expression.
             */
            $eval: function (expr, locals) {
              return $parse(expr)(this, locals);
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$evalAsync
             * @kind function
             *
             * @description
             * Executes the expression on the current scope at a later point in time.
             *
             * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
             * that:
             *
             *   - it will execute after the function that scheduled the evaluation (preferably before DOM
             *     rendering).
             *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
             *     `expression` execution.
             *
             * Any exceptions from the execution of the expression are forwarded to the
             * {@link ng.$exceptionHandler $exceptionHandler} service.
             *
             * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
             * will be scheduled. However, it is encouraged to always call code that changes the model
             * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
             *
             * @param {(string|function())=} expression An angular expression to be executed.
             *
             *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
             *    - `function(scope)`: execute the function with the current `scope` parameter.
             *
             * @param {(object)=} locals Local variables object, useful for overriding values in scope.
             */
            $evalAsync: function (expr, locals) {
              // if we are outside of an $digest loop and this is the first time we are scheduling async
              // task also schedule async auto-flush
              if (!$rootScope.$$phase && !asyncQueue.length) {
                $browser.defer(function () {
                  if (asyncQueue.length) {
                    $rootScope.$digest();
                  }
                });
              }

              asyncQueue.push({ scope: this, expression: $parse(expr), locals: locals });
            },

            $$postDigest: function (fn) {
              postDigestQueue.push(fn);
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$apply
             * @kind function
             *
             * @description
             * `$apply()` is used to execute an expression in angular from outside of the angular
             * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
             * Because we are calling into the angular framework we need to perform proper scope life
             * cycle of {@link ng.$exceptionHandler exception handling},
             * {@link ng.$rootScope.Scope#$digest executing watches}.
             *
             * ## Life cycle
             *
             * # Pseudo-Code of `$apply()`
             * ```js
                 function $apply(expr) {
                   try {
                     return $eval(expr);
                   } catch (e) {
                     $exceptionHandler(e);
                   } finally {
                     $root.$digest();
                   }
                 }
             * ```
             *
             *
             * Scope's `$apply()` method transitions through the following stages:
             *
             * 1. The {@link guide/expression expression} is executed using the
             *    {@link ng.$rootScope.Scope#$eval $eval()} method.
             * 2. Any exceptions from the execution of the expression are forwarded to the
             *    {@link ng.$exceptionHandler $exceptionHandler} service.
             * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
             *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
             *
             *
             * @param {(string|function())=} exp An angular expression to be executed.
             *
             *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
             *    - `function(scope)`: execute the function with current `scope` parameter.
             *
             * @returns {*} The result of evaluating the expression.
             */
            $apply: function (expr) {
              try {
                beginPhase('$apply');
                try {
                  return this.$eval(expr);
                } finally {
                  clearPhase();
                }
              } catch (e) {
                $exceptionHandler(e);
              } finally {
                try {
                  $rootScope.$digest();
                } catch (e) {
                  $exceptionHandler(e);
                  throw e;
                }
              }
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$applyAsync
             * @kind function
             *
             * @description
             * Schedule the invocation of $apply to occur at a later time. The actual time difference
             * varies across browsers, but is typically around ~10 milliseconds.
             *
             * This can be used to queue up multiple expressions which need to be evaluated in the same
             * digest.
             *
             * @param {(string|function())=} exp An angular expression to be executed.
             *
             *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
             *    - `function(scope)`: execute the function with current `scope` parameter.
             */
            $applyAsync: function (expr) {
              var scope = this;
              expr && applyAsyncQueue.push($applyAsyncExpression);
              expr = $parse(expr);
              scheduleApplyAsync();

              function $applyAsyncExpression() {
                scope.$eval(expr);
              }
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$on
             * @kind function
             *
             * @description
             * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
             * discussion of event life cycle.
             *
             * The event listener function format is: `function(event, args...)`. The `event` object
             * passed into the listener has the following attributes:
             *
             *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
             *     `$broadcast`-ed.
             *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
             *     event propagates through the scope hierarchy, this property is set to null.
             *   - `name` - `{string}`: name of the event.
             *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
             *     further event propagation (available only for events that were `$emit`-ed).
             *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
             *     to true.
             *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
             *
             * @param {string} name Event name to listen on.
             * @param {function(event, ...args)} listener Function to call when the event is emitted.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            $on: function (name, listener) {
              var namedListeners = this.$$listeners[name];
              if (!namedListeners) {
                this.$$listeners[name] = namedListeners = [];
              }
              namedListeners.push(listener);

              var current = this;
              do {
                if (!current.$$listenerCount[name]) {
                  current.$$listenerCount[name] = 0;
                }
                current.$$listenerCount[name]++;
              } while (current = current.$parent);

              var self = this;
              return function () {
                var indexOfListener = namedListeners.indexOf(listener);
                if (indexOfListener !== -1) {
                  namedListeners[indexOfListener] = null;
                  decrementListenerCount(self, 1, name);
                }
              };
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$emit
             * @kind function
             *
             * @description
             * Dispatches an event `name` upwards through the scope hierarchy notifying the
             * registered {@link ng.$rootScope.Scope#$on} listeners.
             *
             * The event life cycle starts at the scope on which `$emit` was called. All
             * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
             * notified. Afterwards, the event traverses upwards toward the root scope and calls all
             * registered listeners along the way. The event will stop propagating if one of the listeners
             * cancels it.
             *
             * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
             * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
             *
             * @param {string} name Event name to emit.
             * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
             * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
             */
            $emit: function (name, args) {
              var empty = [],
                  namedListeners,
                  scope = this,
                  stopPropagation = false,
                  event = {
                name: name,
                targetScope: scope,
                stopPropagation: function () {
                  stopPropagation = true;
                },
                preventDefault: function () {
                  event.defaultPrevented = true;
                },
                defaultPrevented: false
              },
                  listenerArgs = concat([event], arguments, 1),
                  i,
                  length;

              do {
                namedListeners = scope.$$listeners[name] || empty;
                event.currentScope = scope;
                for (i = 0, length = namedListeners.length; i < length; i++) {

                  // if listeners were deregistered, defragment the array
                  if (!namedListeners[i]) {
                    namedListeners.splice(i, 1);
                    i--;
                    length--;
                    continue;
                  }
                  try {
                    //allow all listeners attached to the current scope to run
                    namedListeners[i].apply(null, listenerArgs);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                //if any listener on the current scope stops propagation, prevent bubbling
                if (stopPropagation) {
                  event.currentScope = null;
                  return event;
                }
                //traverse upwards
                scope = scope.$parent;
              } while (scope);

              event.currentScope = null;

              return event;
            },

            /**
             * @ngdoc method
             * @name $rootScope.Scope#$broadcast
             * @kind function
             *
             * @description
             * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
             * registered {@link ng.$rootScope.Scope#$on} listeners.
             *
             * The event life cycle starts at the scope on which `$broadcast` was called. All
             * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
             * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
             * scope and calls all registered listeners along the way. The event cannot be canceled.
             *
             * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
             * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
             *
             * @param {string} name Event name to broadcast.
             * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
             * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
             */
            $broadcast: function (name, args) {
              var target = this,
                  current = target,
                  next = target,
                  event = {
                name: name,
                targetScope: target,
                preventDefault: function () {
                  event.defaultPrevented = true;
                },
                defaultPrevented: false
              };

              if (!target.$$listenerCount[name]) return event;

              var listenerArgs = concat([event], arguments, 1),
                  listeners,
                  i,
                  length;

              //down while you can, then up and next sibling or up and next sibling until back at root
              while (current = next) {
                event.currentScope = current;
                listeners = current.$$listeners[name] || [];
                for (i = 0, length = listeners.length; i < length; i++) {
                  // if listeners were deregistered, defragment the array
                  if (!listeners[i]) {
                    listeners.splice(i, 1);
                    i--;
                    length--;
                    continue;
                  }

                  try {
                    listeners[i].apply(null, listenerArgs);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }

                // Insanity Warning: scope depth-first traversal
                // yes, this code is a bit crazy, but it works and we have tests to prove it!
                // this piece should be kept in sync with the traversal in $digest
                // (though it differs due to having the extra check for $$listenerCount)
                if (!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)) {
                  while (current !== target && !(next = current.$$nextSibling)) {
                    current = current.$parent;
                  }
                }
              }

              event.currentScope = null;
              return event;
            }
          };

          var $rootScope = new Scope();

          //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
          var asyncQueue = $rootScope.$$asyncQueue = [];
          var postDigestQueue = $rootScope.$$postDigestQueue = [];
          var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

          var postDigestQueuePosition = 0;

          return $rootScope;

          function beginPhase(phase) {
            if ($rootScope.$$phase) {
              throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
            }

            $rootScope.$$phase = phase;
          }

          function clearPhase() {
            $rootScope.$$phase = null;
          }

          function incrementWatchersCount(current, count) {
            do {
              current.$$watchersCount += count;
            } while (current = current.$parent);
          }

          function decrementListenerCount(current, count, name) {
            do {
              current.$$listenerCount[name] -= count;

              if (current.$$listenerCount[name] === 0) {
                delete current.$$listenerCount[name];
              }
            } while (current = current.$parent);
          }

          /**
           * function used as an initial value for watchers.
           * because it's unique we can easily tell it apart from other values
           */
          function initWatchVal() {}

          function flushApplyAsync() {
            while (applyAsyncQueue.length) {
              try {
                applyAsyncQueue.shift()();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            applyAsyncId = null;
          }

          function scheduleApplyAsync() {
            if (applyAsyncId === null) {
              applyAsyncId = $browser.defer(function () {
                $rootScope.$apply(flushApplyAsync);
              });
            }
          }
        }];
      }

      /**
       * @ngdoc service
       * @name $rootElement
       *
       * @description
       * The root element of Angular application. This is either the element where {@link
       * ng.directive:ngApp ngApp} was declared or the element passed into
       * {@link angular.bootstrap}. The element represents the root element of application. It is also the
       * location where the application's {@link auto.$injector $injector} service gets
       * published, and can be retrieved using `$rootElement.injector()`.
       */

      // the implementation is in angular.bootstrap

      /**
       * @description
       * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
       */
      function $$SanitizeUriProvider() {
        var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
            imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

        /**
         * @description
         * Retrieves or overrides the default regular expression that is used for whitelisting of safe
         * urls during a[href] sanitization.
         *
         * The sanitization is a security measure aimed at prevent XSS attacks via html links.
         *
         * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
         * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
         * regular expression. If a match is found, the original url is written into the dom. Otherwise,
         * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
         *
         * @param {RegExp=} regexp New regexp to whitelist urls with.
         * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
         *    chaining otherwise.
         */
        this.aHrefSanitizationWhitelist = function (regexp) {
          if (isDefined(regexp)) {
            aHrefSanitizationWhitelist = regexp;
            return this;
          }
          return aHrefSanitizationWhitelist;
        };

        /**
         * @description
         * Retrieves or overrides the default regular expression that is used for whitelisting of safe
         * urls during img[src] sanitization.
         *
         * The sanitization is a security measure aimed at prevent XSS attacks via html links.
         *
         * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
         * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
         * regular expression. If a match is found, the original url is written into the dom. Otherwise,
         * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
         *
         * @param {RegExp=} regexp New regexp to whitelist urls with.
         * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
         *    chaining otherwise.
         */
        this.imgSrcSanitizationWhitelist = function (regexp) {
          if (isDefined(regexp)) {
            imgSrcSanitizationWhitelist = regexp;
            return this;
          }
          return imgSrcSanitizationWhitelist;
        };

        this.$get = function () {
          return function sanitizeUri(uri, isImage) {
            var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
            var normalizedVal;
            normalizedVal = urlResolve(uri).href;
            if (normalizedVal !== '' && !normalizedVal.match(regex)) {
              return 'unsafe:' + normalizedVal;
            }
            return uri;
          };
        };
      }

      /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
       *     Any commits to this file should be reviewed with security in mind.  *
       *   Changes to this file can potentially create security vulnerabilities. *
       *          An approval from 2 Core members with history of modifying      *
       *                         this file is required.                          *
       *                                                                         *
       *  Does the change somehow allow for arbitrary javascript to be executed? *
       *    Or allows for someone to change the prototype of built-in objects?   *
       *     Or gives undesired access to variables likes document or window?    *
       * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

      var $sceMinErr = minErr('$sce');

      var SCE_CONTEXTS = {
        HTML: 'html',
        CSS: 'css',
        URL: 'url',
        // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
        // url.  (e.g. ng-include, script src, templateUrl)
        RESOURCE_URL: 'resourceUrl',
        JS: 'js'
      };

      // Helper functions follow.

      function adjustMatcher(matcher) {
        if (matcher === 'self') {
          return matcher;
        } else if (isString(matcher)) {
          // Strings match exactly except for 2 wildcards - '*' and '**'.
          // '*' matches any character except those from the set ':/.?&'.
          // '**' matches any character (like .* in a RegExp).
          // More than 2 *'s raises an error as it's ill defined.
          if (matcher.indexOf('***') > -1) {
            throw $sceMinErr('iwcard', 'Illegal sequence *** in string matcher.  String: {0}', matcher);
          }
          matcher = escapeForRegexp(matcher).replace('\\*\\*', '.*').replace('\\*', '[^:/.?&;]*');
          return new RegExp('^' + matcher + '$');
        } else if (isRegExp(matcher)) {
          // The only other type of matcher allowed is a Regexp.
          // Match entire URL / disallow partial matches.
          // Flags are reset (i.e. no global, ignoreCase or multiline)
          return new RegExp('^' + matcher.source + '$');
        } else {
          throw $sceMinErr('imatcher', 'Matchers may only be "self", string patterns or RegExp objects');
        }
      }

      function adjustMatchers(matchers) {
        var adjustedMatchers = [];
        if (isDefined(matchers)) {
          forEach(matchers, function (matcher) {
            adjustedMatchers.push(adjustMatcher(matcher));
          });
        }
        return adjustedMatchers;
      }

      /**
       * @ngdoc service
       * @name $sceDelegate
       * @kind function
       *
       * @description
       *
       * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
       * Contextual Escaping (SCE)} services to AngularJS.
       *
       * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
       * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
       * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
       * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
       * work because `$sce` delegates to `$sceDelegate` for these operations.
       *
       * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
       *
       * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
       * can override it completely to change the behavior of `$sce`, the common case would
       * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
       * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
       * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
       * $sceDelegateProvider.resourceUrlWhitelist} and {@link
       * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
       */

      /**
       * @ngdoc provider
       * @name $sceDelegateProvider
       * @description
       *
       * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
       * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
       * that the URLs used for sourcing Angular templates are safe.  Refer {@link
       * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
       * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
       *
       * For the general details about this service in Angular, read the main page for {@link ng.$sce
       * Strict Contextual Escaping (SCE)}.
       *
       * **Example**:  Consider the following case. <a name="example"></a>
       *
       * - your app is hosted at url `http://myapp.example.com/`
       * - but some of your templates are hosted on other domains you control such as
       *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
       * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
       *
       * Here is what a secure configuration for this scenario might look like:
       *
       * ```
       *  angular.module('myApp', []).config(function($sceDelegateProvider) {
       *    $sceDelegateProvider.resourceUrlWhitelist([
       *      // Allow same origin resource loads.
       *      'self',
       *      // Allow loading from our assets domain.  Notice the difference between * and **.
       *      'http://srv*.assets.example.com/**'
       *    ]);
       *
       *    // The blacklist overrides the whitelist so the open redirect here is blocked.
       *    $sceDelegateProvider.resourceUrlBlacklist([
       *      'http://myapp.example.com/clickThru**'
       *    ]);
       *  });
       * ```
       */

      function $SceDelegateProvider() {
        this.SCE_CONTEXTS = SCE_CONTEXTS;

        // Resource URLs can also be trusted by policy.
        var resourceUrlWhitelist = ['self'],
            resourceUrlBlacklist = [];

        /**
         * @ngdoc method
         * @name $sceDelegateProvider#resourceUrlWhitelist
         * @kind function
         *
         * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
         *    provided.  This must be an array or null.  A snapshot of this array is used so further
         *    changes to the array are ignored.
         *
         *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
         *    allowed in this array.
         *
         *    <div class="alert alert-warning">
         *    **Note:** an empty whitelist array will block all URLs!
         *    </div>
         *
         * @return {Array} the currently set whitelist array.
         *
         * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
         * same origin resource requests.
         *
         * @description
         * Sets/Gets the whitelist of trusted resource URLs.
         */
        this.resourceUrlWhitelist = function (value) {
          if (arguments.length) {
            resourceUrlWhitelist = adjustMatchers(value);
          }
          return resourceUrlWhitelist;
        };

        /**
         * @ngdoc method
         * @name $sceDelegateProvider#resourceUrlBlacklist
         * @kind function
         *
         * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
         *    provided.  This must be an array or null.  A snapshot of this array is used so further
         *    changes to the array are ignored.
         *
         *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
         *    allowed in this array.
         *
         *    The typical usage for the blacklist is to **block
         *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
         *    these would otherwise be trusted but actually return content from the redirected domain.
         *
         *    Finally, **the blacklist overrides the whitelist** and has the final say.
         *
         * @return {Array} the currently set blacklist array.
         *
         * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
         * is no blacklist.)
         *
         * @description
         * Sets/Gets the blacklist of trusted resource URLs.
         */

        this.resourceUrlBlacklist = function (value) {
          if (arguments.length) {
            resourceUrlBlacklist = adjustMatchers(value);
          }
          return resourceUrlBlacklist;
        };

        this.$get = ['$injector', function ($injector) {

          var htmlSanitizer = function htmlSanitizer(html) {
            throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
          };

          if ($injector.has('$sanitize')) {
            htmlSanitizer = $injector.get('$sanitize');
          }

          function matchUrl(matcher, parsedUrl) {
            if (matcher === 'self') {
              return urlIsSameOrigin(parsedUrl);
            } else {
              // definitely a regex.  See adjustMatchers()
              return !!matcher.exec(parsedUrl.href);
            }
          }

          function isResourceUrlAllowedByPolicy(url) {
            var parsedUrl = urlResolve(url.toString());
            var i,
                n,
                allowed = false;
            // Ensure that at least one item from the whitelist allows this url.
            for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
              if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
                allowed = true;
                break;
              }
            }
            if (allowed) {
              // Ensure that no item from the blacklist blocked this url.
              for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
                if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
                  allowed = false;
                  break;
                }
              }
            }
            return allowed;
          }

          function generateHolderType(Base) {
            var holderType = function TrustedValueHolderType(trustedValue) {
              this.$$unwrapTrustedValue = function () {
                return trustedValue;
              };
            };
            if (Base) {
              holderType.prototype = new Base();
            }
            holderType.prototype.valueOf = function sceValueOf() {
              return this.$$unwrapTrustedValue();
            };
            holderType.prototype.toString = function sceToString() {
              return this.$$unwrapTrustedValue().toString();
            };
            return holderType;
          }

          var trustedValueHolderBase = generateHolderType(),
              byType = {};

          byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

          /**
           * @ngdoc method
           * @name $sceDelegate#trustAs
           *
           * @description
           * Returns an object that is trusted by angular for use in specified strict
           * contextual escaping contexts (such as ng-bind-html, ng-include, any src
           * attribute interpolation, any dom event binding attribute interpolation
           * such as for onclick,  etc.) that uses the provided value.
           * See {@link ng.$sce $sce} for enabling strict contextual escaping.
           *
           * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
           *   resourceUrl, html, js and css.
           * @param {*} value The value that that should be considered trusted/safe.
           * @returns {*} A value that can be used to stand in for the provided `value` in places
           * where Angular expects a $sce.trustAs() return value.
           */
          function trustAs(type, trustedValue) {
            var Constructor = byType.hasOwnProperty(type) ? byType[type] : null;
            if (!Constructor) {
              throw $sceMinErr('icontext', 'Attempted to trust a value in invalid context. Context: {0}; Value: {1}', type, trustedValue);
            }
            if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
              return trustedValue;
            }
            // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
            // mutable objects, we ensure here that the value passed in is actually a string.
            if (typeof trustedValue !== 'string') {
              throw $sceMinErr('itype', 'Attempted to trust a non-string value in a content requiring a string: Context: {0}', type);
            }
            return new Constructor(trustedValue);
          }

          /**
           * @ngdoc method
           * @name $sceDelegate#valueOf
           *
           * @description
           * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
           * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
           * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
           *
           * If the passed parameter is not a value that had been returned by {@link
           * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
           *
           * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
           *      call or anything else.
           * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
           *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
           *     `value` unchanged.
           */
          function valueOf(maybeTrusted) {
            if (maybeTrusted instanceof trustedValueHolderBase) {
              return maybeTrusted.$$unwrapTrustedValue();
            } else {
              return maybeTrusted;
            }
          }

          /**
           * @ngdoc method
           * @name $sceDelegate#getTrusted
           *
           * @description
           * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
           * returns the originally supplied value if the queried context type is a supertype of the
           * created type.  If this condition isn't satisfied, throws an exception.
           *
           * <div class="alert alert-danger">
           * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
           * (XSS) vulnerability in your application.
           * </div>
           *
           * @param {string} type The kind of context in which this value is to be used.
           * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
           *     `$sceDelegate.trustAs`} call.
           * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
           *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
           */
          function getTrusted(type, maybeTrusted) {
            if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
              return maybeTrusted;
            }
            var constructor = byType.hasOwnProperty(type) ? byType[type] : null;
            if (constructor && maybeTrusted instanceof constructor) {
              return maybeTrusted.$$unwrapTrustedValue();
            }
            // If we get here, then we may only take one of two actions.
            // 1. sanitize the value for the requested type, or
            // 2. throw an exception.
            if (type === SCE_CONTEXTS.RESOURCE_URL) {
              if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
                return maybeTrusted;
              } else {
                throw $sceMinErr('insecurl', 'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}', maybeTrusted.toString());
              }
            } else if (type === SCE_CONTEXTS.HTML) {
              return htmlSanitizer(maybeTrusted);
            }
            throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
          }

          return { trustAs: trustAs,
            getTrusted: getTrusted,
            valueOf: valueOf };
        }];
      }

      /**
       * @ngdoc provider
       * @name $sceProvider
       * @description
       *
       * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
       * -   enable/disable Strict Contextual Escaping (SCE) in a module
       * -   override the default implementation with a custom delegate
       *
       * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
       */

      /* jshint maxlen: false*/

      /**
       * @ngdoc service
       * @name $sce
       * @kind function
       *
       * @description
       *
       * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
       *
       * # Strict Contextual Escaping
       *
       * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
       * contexts to result in a value that is marked as safe to use for that context.  One example of
       * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
       * to these contexts as privileged or SCE contexts.
       *
       * As of version 1.2, Angular ships with SCE enabled by default.
       *
       * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
       * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
       * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
       * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
       * to the top of your HTML document.
       *
       * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
       * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
       *
       * Here's an example of a binding in a privileged context:
       *
       * ```
       * <input ng-model="userHtml" aria-label="User input">
       * <div ng-bind-html="userHtml"></div>
       * ```
       *
       * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
       * disabled, this application allows the user to render arbitrary HTML into the DIV.
       * In a more realistic example, one may be rendering user comments, blog articles, etc. via
       * bindings.  (HTML is just one example of a context where rendering user controlled input creates
       * security vulnerabilities.)
       *
       * For the case of HTML, you might use a library, either on the client side, or on the server side,
       * to sanitize unsafe HTML before binding to the value and rendering it in the document.
       *
       * How would you ensure that every place that used these types of bindings was bound to a value that
       * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
       * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
       * properties/fields and forgot to update the binding to the sanitized value?
       *
       * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
       * determine that something explicitly says it's safe to use a value for binding in that
       * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
       * for those values that you can easily tell are safe - because they were received from your server,
       * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
       * allowing only the files in a specific directory to do this.  Ensuring that the internal API
       * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
       *
       * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
       * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
       * obtain values that will be accepted by SCE / privileged contexts.
       *
       *
       * ## How does it work?
       *
       * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
       * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
       * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
       * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
       *
       * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
       * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
       * simplified):
       *
       * ```
       * var ngBindHtmlDirective = ['$sce', function($sce) {
       *   return function(scope, element, attr) {
       *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
       *       element.html(value || '');
       *     });
       *   };
       * }];
       * ```
       *
       * ## Impact on loading templates
       *
       * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
       * `templateUrl`'s specified by {@link guide/directive directives}.
       *
       * By default, Angular only loads templates from the same domain and protocol as the application
       * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
       * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
       * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
       * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
       *
       * *Please note*:
       * The browser's
       * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
       * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
       * policy apply in addition to this and may further restrict whether the template is successfully
       * loaded.  This means that without the right CORS policy, loading templates from a different domain
       * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
       * browsers.
       *
       * ## This feels like too much overhead
       *
       * It's important to remember that SCE only applies to interpolation expressions.
       *
       * If your expressions are constant literals, they're automatically trusted and you don't need to
       * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
       * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
       *
       * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
       * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
       *
       * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
       * templates in `ng-include` from your application's domain without having to even know about SCE.
       * It blocks loading templates from other domains or loading templates over http from an https
       * served document.  You can change these by setting your own custom {@link
       * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
       * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
       *
       * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
       * application that's secure and can be audited to verify that with much more ease than bolting
       * security onto an application later.
       *
       * <a name="contexts"></a>
       * ## What trusted context types are supported?
       *
       * | Context             | Notes          |
       * |---------------------|----------------|
       * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
       * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
       * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
       * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
       * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
       *
       * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
       *
       *  Each element in these arrays must be one of the following:
       *
       *  - **'self'**
       *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
       *      domain** as the application document using the **same protocol**.
       *  - **String** (except the special value `'self'`)
       *    - The string is matched against the full *normalized / absolute URL* of the resource
       *      being tested (substring matches are not good enough.)
       *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
       *      match themselves.
       *    - `*`: matches zero or more occurrences of any character other than one of the following 6
       *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
       *      in a whitelist.
       *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
       *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
       *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
       *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
       *      http://foo.example.com/templates/**).
       *  - **RegExp** (*see caveat below*)
       *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
       *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
       *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
       *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
       *      small number of cases.  A `.` character in the regex used when matching the scheme or a
       *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
       *      is highly recommended to use the string patterns and only fall back to regular expressions
       *      as a last resort.
       *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
       *      matched against the **entire** *normalized / absolute URL* of the resource being tested
       *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
       *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
       *    - If you are generating your JavaScript from some other templating engine (not
       *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
       *      remember to escape your regular expression (and be aware that you might need more than
       *      one level of escaping depending on your templating engine and the way you interpolated
       *      the value.)  Do make use of your platform's escaping mechanism as it might be good
       *      enough before coding your own.  E.g. Ruby has
       *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
       *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
       *      Javascript lacks a similar built in function for escaping.  Take a look at Google
       *      Closure library's [goog.string.regExpEscape(s)](
       *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
       *
       * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
       *
       * ## Show me an example using SCE.
       *
       * <example module="mySceApp" deps="angular-sanitize.js">
       * <file name="index.html">
       *   <div ng-controller="AppController as myCtrl">
       *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
       *     <b>User comments</b><br>
       *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
       *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
       *     exploit.
       *     <div class="well">
       *       <div ng-repeat="userComment in myCtrl.userComments">
       *         <b>{{userComment.name}}</b>:
       *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
       *         <br>
       *       </div>
       *     </div>
       *   </div>
       * </file>
       *
       * <file name="script.js">
       *   angular.module('mySceApp', ['ngSanitize'])
       *     .controller('AppController', ['$http', '$templateCache', '$sce',
       *       function($http, $templateCache, $sce) {
       *         var self = this;
       *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
       *           self.userComments = userComments;
       *         });
       *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
       *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
       *             'sanitization.&quot;">Hover over this text.</span>');
       *       }]);
       * </file>
       *
       * <file name="test_data.json">
       * [
       *   { "name": "Alice",
       *     "htmlComment":
       *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
       *   },
       *   { "name": "Bob",
       *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
       *   }
       * ]
       * </file>
       *
       * <file name="protractor.js" type="protractor">
       *   describe('SCE doc demo', function() {
       *     it('should sanitize untrusted values', function() {
       *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
       *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
       *     });
       *
       *     it('should NOT sanitize explicitly trusted values', function() {
       *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
       *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
       *           'sanitization.&quot;">Hover over this text.</span>');
       *     });
       *   });
       * </file>
       * </example>
       *
       *
       *
       * ## Can I disable SCE completely?
       *
       * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
       * for little coding overhead.  It will be much harder to take an SCE disabled application and
       * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
       * for cases where you have a lot of existing code that was written before SCE was introduced and
       * you're migrating them a module at a time.
       *
       * That said, here's how you can completely disable SCE:
       *
       * ```
       * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
       *   // Completely disable SCE.  For demonstration purposes only!
       *   // Do not use in new projects.
       *   $sceProvider.enabled(false);
       * });
       * ```
       *
       */
      /* jshint maxlen: 100 */

      function $SceProvider() {
        var enabled = true;

        /**
         * @ngdoc method
         * @name $sceProvider#enabled
         * @kind function
         *
         * @param {boolean=} value If provided, then enables/disables SCE.
         * @return {boolean} true if SCE is enabled, false otherwise.
         *
         * @description
         * Enables/disables SCE and returns the current value.
         */
        this.enabled = function (value) {
          if (arguments.length) {
            enabled = !!value;
          }
          return enabled;
        };

        /* Design notes on the default implementation for SCE.
         *
         * The API contract for the SCE delegate
         * -------------------------------------
         * The SCE delegate object must provide the following 3 methods:
         *
         * - trustAs(contextEnum, value)
         *     This method is used to tell the SCE service that the provided value is OK to use in the
         *     contexts specified by contextEnum.  It must return an object that will be accepted by
         *     getTrusted() for a compatible contextEnum and return this value.
         *
         * - valueOf(value)
         *     For values that were not produced by trustAs(), return them as is.  For values that were
         *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
         *     trustAs is wrapping the given values into some type, this operation unwraps it when given
         *     such a value.
         *
         * - getTrusted(contextEnum, value)
         *     This function should return the a value that is safe to use in the context specified by
         *     contextEnum or throw and exception otherwise.
         *
         * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
         * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
         * instance, an implementation could maintain a registry of all trusted objects by context.  In
         * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
         * return the same object passed in if it was found in the registry under a compatible context or
         * throw an exception otherwise.  An implementation might only wrap values some of the time based
         * on some criteria.  getTrusted() might return a value and not throw an exception for special
         * constants or objects even if not wrapped.  All such implementations fulfill this contract.
         *
         *
         * A note on the inheritance model for SCE contexts
         * ------------------------------------------------
         * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
         * is purely an implementation details.
         *
         * The contract is simply this:
         *
         *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
         *     will also succeed.
         *
         * Inheritance happens to capture this in a natural way.  In some future, we
         * may not use inheritance anymore.  That is OK because no code outside of
         * sce.js and sceSpecs.js would need to be aware of this detail.
         */

        this.$get = ['$parse', '$sceDelegate', function ($parse, $sceDelegate) {
          // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
          // the "expression(javascript expression)" syntax which is insecure.
          if (enabled && msie < 8) {
            throw $sceMinErr('iequirks', 'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' + 'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' + 'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
          }

          var sce = shallowCopy(SCE_CONTEXTS);

          /**
           * @ngdoc method
           * @name $sce#isEnabled
           * @kind function
           *
           * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
           * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
           *
           * @description
           * Returns a boolean indicating if SCE is enabled.
           */
          sce.isEnabled = function () {
            return enabled;
          };
          sce.trustAs = $sceDelegate.trustAs;
          sce.getTrusted = $sceDelegate.getTrusted;
          sce.valueOf = $sceDelegate.valueOf;

          if (!enabled) {
            sce.trustAs = sce.getTrusted = function (type, value) {
              return value;
            };
            sce.valueOf = identity;
          }

          /**
           * @ngdoc method
           * @name $sce#parseAs
           *
           * @description
           * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
           * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
           * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
           * *result*)}
           *
           * @param {string} type The kind of SCE context in which this result will be used.
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */
          sce.parseAs = function sceParseAs(type, expr) {
            var parsed = $parse(expr);
            if (parsed.literal && parsed.constant) {
              return parsed;
            } else {
              return $parse(expr, function (value) {
                return sce.getTrusted(type, value);
              });
            }
          };

          /**
           * @ngdoc method
           * @name $sce#trustAs
           *
           * @description
           * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
           * returns an object that is trusted by angular for use in specified strict contextual
           * escaping contexts (such as ng-bind-html, ng-include, any src attribute
           * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
           * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
           * escaping.
           *
           * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
           *   resourceUrl, html, js and css.
           * @param {*} value The value that that should be considered trusted/safe.
           * @returns {*} A value that can be used to stand in for the provided `value` in places
           * where Angular expects a $sce.trustAs() return value.
           */

          /**
           * @ngdoc method
           * @name $sce#trustAsHtml
           *
           * @description
           * Shorthand method.  `$sce.trustAsHtml(value)` →
           *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
           *
           * @param {*} value The value to trustAs.
           * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
           *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
           *     only accept expressions that are either literal constants or are the
           *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
           */

          /**
           * @ngdoc method
           * @name $sce#trustAsUrl
           *
           * @description
           * Shorthand method.  `$sce.trustAsUrl(value)` →
           *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
           *
           * @param {*} value The value to trustAs.
           * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
           *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
           *     only accept expressions that are either literal constants or are the
           *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
           */

          /**
           * @ngdoc method
           * @name $sce#trustAsResourceUrl
           *
           * @description
           * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
           *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
           *
           * @param {*} value The value to trustAs.
           * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
           *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
           *     only accept expressions that are either literal constants or are the return
           *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
           */

          /**
           * @ngdoc method
           * @name $sce#trustAsJs
           *
           * @description
           * Shorthand method.  `$sce.trustAsJs(value)` →
           *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
           *
           * @param {*} value The value to trustAs.
           * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
           *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
           *     only accept expressions that are either literal constants or are the
           *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
           */

          /**
           * @ngdoc method
           * @name $sce#getTrusted
           *
           * @description
           * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
           * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
           * originally supplied value if the queried context type is a supertype of the created type.
           * If this condition isn't satisfied, throws an exception.
           *
           * @param {string} type The kind of context in which this value is to be used.
           * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
           *                         call.
           * @returns {*} The value the was originally provided to
           *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
           *              Otherwise, throws an exception.
           */

          /**
           * @ngdoc method
           * @name $sce#getTrustedHtml
           *
           * @description
           * Shorthand method.  `$sce.getTrustedHtml(value)` →
           *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
           *
           * @param {*} value The value to pass to `$sce.getTrusted`.
           * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
           */

          /**
           * @ngdoc method
           * @name $sce#getTrustedCss
           *
           * @description
           * Shorthand method.  `$sce.getTrustedCss(value)` →
           *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
           *
           * @param {*} value The value to pass to `$sce.getTrusted`.
           * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
           */

          /**
           * @ngdoc method
           * @name $sce#getTrustedUrl
           *
           * @description
           * Shorthand method.  `$sce.getTrustedUrl(value)` →
           *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
           *
           * @param {*} value The value to pass to `$sce.getTrusted`.
           * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
           */

          /**
           * @ngdoc method
           * @name $sce#getTrustedResourceUrl
           *
           * @description
           * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
           *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
           *
           * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
           * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
           */

          /**
           * @ngdoc method
           * @name $sce#getTrustedJs
           *
           * @description
           * Shorthand method.  `$sce.getTrustedJs(value)` →
           *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
           *
           * @param {*} value The value to pass to `$sce.getTrusted`.
           * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
           */

          /**
           * @ngdoc method
           * @name $sce#parseAsHtml
           *
           * @description
           * Shorthand method.  `$sce.parseAsHtml(expression string)` →
           *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
           *
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */

          /**
           * @ngdoc method
           * @name $sce#parseAsCss
           *
           * @description
           * Shorthand method.  `$sce.parseAsCss(value)` →
           *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
           *
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */

          /**
           * @ngdoc method
           * @name $sce#parseAsUrl
           *
           * @description
           * Shorthand method.  `$sce.parseAsUrl(value)` →
           *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
           *
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */

          /**
           * @ngdoc method
           * @name $sce#parseAsResourceUrl
           *
           * @description
           * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
           *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
           *
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */

          /**
           * @ngdoc method
           * @name $sce#parseAsJs
           *
           * @description
           * Shorthand method.  `$sce.parseAsJs(value)` →
           *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
           *
           * @param {string} expression String expression to compile.
           * @returns {function(context, locals)} a function which represents the compiled expression:
           *
           *    * `context` – `{object}` – an object against which any expressions embedded in the strings
           *      are evaluated against (typically a scope object).
           *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
           *      `context`.
           */

          // Shorthand delegations.
          var parse = sce.parseAs,
              getTrusted = sce.getTrusted,
              trustAs = sce.trustAs;

          forEach(SCE_CONTEXTS, function (enumValue, name) {
            var lName = lowercase(name);
            sce[camelCase("parse_as_" + lName)] = function (expr) {
              return parse(enumValue, expr);
            };
            sce[camelCase("get_trusted_" + lName)] = function (value) {
              return getTrusted(enumValue, value);
            };
            sce[camelCase("trust_as_" + lName)] = function (value) {
              return trustAs(enumValue, value);
            };
          });

          return sce;
        }];
      }

      /**
       * !!! This is an undocumented "private" service !!!
       *
       * @name $sniffer
       * @requires $window
       * @requires $document
       *
       * @property {boolean} history Does the browser support html5 history api ?
       * @property {boolean} transitions Does the browser support CSS transition events ?
       * @property {boolean} animations Does the browser support CSS animation events ?
       *
       * @description
       * This is very simple implementation of testing browser's features.
       */
      function $SnifferProvider() {
        this.$get = ['$window', '$document', function ($window, $document) {
          var eventSupport = {},

          // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
          // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
          isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
              hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
              android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
              boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
              document = $document[0] || {},
              vendorPrefix,
              vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
              bodyStyle = document.body && document.body.style,
              transitions = false,
              animations = false,
              match;

          if (bodyStyle) {
            for (var prop in bodyStyle) {
              if (match = vendorRegex.exec(prop)) {
                vendorPrefix = match[0];
                vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
                break;
              }
            }

            if (!vendorPrefix) {
              vendorPrefix = 'WebkitOpacity' in bodyStyle && 'webkit';
            }

            transitions = !!('transition' in bodyStyle || vendorPrefix + 'Transition' in bodyStyle);
            animations = !!('animation' in bodyStyle || vendorPrefix + 'Animation' in bodyStyle);

            if (android && (!transitions || !animations)) {
              transitions = isString(bodyStyle.webkitTransition);
              animations = isString(bodyStyle.webkitAnimation);
            }
          }

          return {
            // Android has history.pushState, but it does not update location correctly
            // so let's not use the history API at all.
            // http://code.google.com/p/android/issues/detail?id=17471
            // https://github.com/angular/angular.js/issues/904

            // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
            // so let's not use the history API also
            // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
            // jshint -W018
            history: !!(hasHistoryPushState && !(android < 4) && !boxee),
            // jshint +W018
            hasEvent: function (event) {
              // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
              // it. In particular the event is not fired when backspace or delete key are pressed or
              // when cut operation is performed.
              // IE10+ implements 'input' event but it erroneously fires under various situations,
              // e.g. when placeholder changes, or a form is focused.
              if (event === 'input' && msie <= 11) return false;

              if (isUndefined(eventSupport[event])) {
                var divElm = document.createElement('div');
                eventSupport[event] = 'on' + event in divElm;
              }

              return eventSupport[event];
            },
            csp: csp(),
            vendorPrefix: vendorPrefix,
            transitions: transitions,
            animations: animations,
            android: android
          };
        }];
      }

      var $templateRequestMinErr = minErr('$compile');

      /**
       * @ngdoc provider
       * @name $templateRequestProvider
       * @description
       * Used to configure the options passed to the {@link $http} service when making a template request.
       *
       * For example, it can be used for specifying the "Accept" header that is sent to the server, when
       * requesting a template.
       */
      function $TemplateRequestProvider() {

        var httpOptions;

        /**
         * @ngdoc method
         * @name $templateRequestProvider#httpOptions
         * @description
         * The options to be passed to the {@link $http} service when making the request.
         * You can use this to override options such as the "Accept" header for template requests.
         *
         * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
         * options if not overridden here.
         *
         * @param {string=} value new value for the {@link $http} options.
         * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
         */
        this.httpOptions = function (val) {
          if (val) {
            httpOptions = val;
            return this;
          }
          return httpOptions;
        };

        /**
         * @ngdoc service
         * @name $templateRequest
         *
         * @description
         * The `$templateRequest` service runs security checks then downloads the provided template using
         * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
         * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
         * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
         * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
         * when `tpl` is of type string and `$templateCache` has the matching entry.
         *
         * If you want to pass custom options to the `$http` service, such as setting the Accept header you
         * can configure this via {@link $templateRequestProvider#httpOptions}.
         *
         * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
         * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
         *
         * @return {Promise} a promise for the HTTP response data of the given URL.
         *
         * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
         */
        this.$get = ['$templateCache', '$http', '$q', '$sce', function ($templateCache, $http, $q, $sce) {

          function handleRequestFn(tpl, ignoreRequestError) {
            handleRequestFn.totalPendingRequests++;

            // We consider the template cache holds only trusted templates, so
            // there's no need to go through whitelisting again for keys that already
            // are included in there. This also makes Angular accept any script
            // directive, no matter its name. However, we still need to unwrap trusted
            // types.
            if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
              tpl = $sce.getTrustedResourceUrl(tpl);
            }

            var transformResponse = $http.defaults && $http.defaults.transformResponse;

            if (isArray(transformResponse)) {
              transformResponse = transformResponse.filter(function (transformer) {
                return transformer !== defaultHttpResponseTransform;
              });
            } else if (transformResponse === defaultHttpResponseTransform) {
              transformResponse = null;
            }

            return $http.get(tpl, extend({
              cache: $templateCache,
              transformResponse: transformResponse
            }, httpOptions))['finally'](function () {
              handleRequestFn.totalPendingRequests--;
            }).then(function (response) {
              $templateCache.put(tpl, response.data);
              return response.data;
            }, handleError);

            function handleError(resp) {
              if (!ignoreRequestError) {
                throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})', tpl, resp.status, resp.statusText);
              }
              return $q.reject(resp);
            }
          }

          handleRequestFn.totalPendingRequests = 0;

          return handleRequestFn;
        }];
      }

      function $$TestabilityProvider() {
        this.$get = ['$rootScope', '$browser', '$location', function ($rootScope, $browser, $location) {

          /**
           * @name $testability
           *
           * @description
           * The private $$testability service provides a collection of methods for use when debugging
           * or by automated test and debugging tools.
           */
          var testability = {};

          /**
           * @name $$testability#findBindings
           *
           * @description
           * Returns an array of elements that are bound (via ng-bind or {{}})
           * to expressions matching the input.
           *
           * @param {Element} element The element root to search from.
           * @param {string} expression The binding expression to match.
           * @param {boolean} opt_exactMatch If true, only returns exact matches
           *     for the expression. Filters and whitespace are ignored.
           */
          testability.findBindings = function (element, expression, opt_exactMatch) {
            var bindings = element.getElementsByClassName('ng-binding');
            var matches = [];
            forEach(bindings, function (binding) {
              var dataBinding = angular.element(binding).data('$binding');
              if (dataBinding) {
                forEach(dataBinding, function (bindingName) {
                  if (opt_exactMatch) {
                    var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
                    if (matcher.test(bindingName)) {
                      matches.push(binding);
                    }
                  } else {
                    if (bindingName.indexOf(expression) != -1) {
                      matches.push(binding);
                    }
                  }
                });
              }
            });
            return matches;
          };

          /**
           * @name $$testability#findModels
           *
           * @description
           * Returns an array of elements that are two-way found via ng-model to
           * expressions matching the input.
           *
           * @param {Element} element The element root to search from.
           * @param {string} expression The model expression to match.
           * @param {boolean} opt_exactMatch If true, only returns exact matches
           *     for the expression.
           */
          testability.findModels = function (element, expression, opt_exactMatch) {
            var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
            for (var p = 0; p < prefixes.length; ++p) {
              var attributeEquals = opt_exactMatch ? '=' : '*=';
              var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
              var elements = element.querySelectorAll(selector);
              if (elements.length) {
                return elements;
              }
            }
          };

          /**
           * @name $$testability#getLocation
           *
           * @description
           * Shortcut for getting the location in a browser agnostic way. Returns
           *     the path, search, and hash. (e.g. /path?a=b#hash)
           */
          testability.getLocation = function () {
            return $location.url();
          };

          /**
           * @name $$testability#setLocation
           *
           * @description
           * Shortcut for navigating to a location without doing a full page reload.
           *
           * @param {string} url The location url (path, search and hash,
           *     e.g. /path?a=b#hash) to go to.
           */
          testability.setLocation = function (url) {
            if (url !== $location.url()) {
              $location.url(url);
              $rootScope.$digest();
            }
          };

          /**
           * @name $$testability#whenStable
           *
           * @description
           * Calls the callback when $timeout and $http requests are completed.
           *
           * @param {function} callback
           */
          testability.whenStable = function (callback) {
            $browser.notifyWhenNoOutstandingRequests(callback);
          };

          return testability;
        }];
      }

      function $TimeoutProvider() {
        this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler', function ($rootScope, $browser, $q, $$q, $exceptionHandler) {

          var deferreds = {};

          /**
           * @ngdoc service
           * @name $timeout
           *
           * @description
           * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
           * block and delegates any exceptions to
           * {@link ng.$exceptionHandler $exceptionHandler} service.
           *
           * The return value of calling `$timeout` is a promise, which will be resolved when
           * the delay has passed and the timeout function, if provided, is executed.
           *
           * To cancel a timeout request, call `$timeout.cancel(promise)`.
           *
           * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
           * synchronously flush the queue of deferred functions.
           *
           * If you only want a promise that will be resolved after some specified delay
           * then you can call `$timeout` without the `fn` function.
           *
           * @param {function()=} fn A function, whose execution should be delayed.
           * @param {number=} [delay=0] Delay in milliseconds.
           * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
           *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
           * @param {...*=} Pass additional parameters to the executed function.
           * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
           *   will be resolved with the return value of the `fn` function.
           *
           */
          function timeout(fn, delay, invokeApply) {
            if (!isFunction(fn)) {
              invokeApply = delay;
              delay = fn;
              fn = noop;
            }

            var args = sliceArgs(arguments, 3),
                skipApply = isDefined(invokeApply) && !invokeApply,
                deferred = (skipApply ? $$q : $q).defer(),
                promise = deferred.promise,
                timeoutId;

            timeoutId = $browser.defer(function () {
              try {
                deferred.resolve(fn.apply(null, args));
              } catch (e) {
                deferred.reject(e);
                $exceptionHandler(e);
              } finally {
                delete deferreds[promise.$$timeoutId];
              }

              if (!skipApply) $rootScope.$apply();
            }, delay);

            promise.$$timeoutId = timeoutId;
            deferreds[timeoutId] = deferred;

            return promise;
          }

          /**
           * @ngdoc method
           * @name $timeout#cancel
           *
           * @description
           * Cancels a task associated with the `promise`. As a result of this, the promise will be
           * resolved with a rejection.
           *
           * @param {Promise=} promise Promise returned by the `$timeout` function.
           * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
           *   canceled.
           */
          timeout.cancel = function (promise) {
            if (promise && promise.$$timeoutId in deferreds) {
              deferreds[promise.$$timeoutId].reject('canceled');
              delete deferreds[promise.$$timeoutId];
              return $browser.defer.cancel(promise.$$timeoutId);
            }
            return false;
          };

          return timeout;
        }];
      }

      // NOTE:  The usage of window and document instead of $window and $document here is
      // deliberate.  This service depends on the specific behavior of anchor nodes created by the
      // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
      // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
      // doesn't know about mocked locations and resolves URLs to the real document - which is
      // exactly the behavior needed here.  There is little value is mocking these out for this
      // service.
      var urlParsingNode = window.document.createElement("a");
      var originUrl = urlResolve(window.location.href);

      /**
       *
       * Implementation Notes for non-IE browsers
       * ----------------------------------------
       * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
       * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
       * URL will be resolved into an absolute URL in the context of the application document.
       * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
       * properties are all populated to reflect the normalized URL.  This approach has wide
       * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
       * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
       *
       * Implementation Notes for IE
       * ---------------------------
       * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
       * browsers.  However, the parsed components will not be set if the URL assigned did not specify
       * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
       * work around that by performing the parsing in a 2nd step by taking a previously normalized
       * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
       * properties such as protocol, hostname, port, etc.
       *
       * References:
       *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
       *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
       *   http://url.spec.whatwg.org/#urlutils
       *   https://github.com/angular/angular.js/pull/2902
       *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
       *
       * @kind function
       * @param {string} url The URL to be parsed.
       * @description Normalizes and parses a URL.
       * @returns {object} Returns the normalized URL as a dictionary.
       *
       *   | member name   | Description    |
       *   |---------------|----------------|
       *   | href          | A normalized version of the provided URL if it was not an absolute URL |
       *   | protocol      | The protocol including the trailing colon                              |
       *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
       *   | search        | The search params, minus the question mark                             |
       *   | hash          | The hash string, minus the hash symbol
       *   | hostname      | The hostname
       *   | port          | The port, without ":"
       *   | pathname      | The pathname, beginning with "/"
       *
       */
      function urlResolve(url) {
        var href = url;

        if (msie) {
          // Normalize before parse.  Refer Implementation Notes on why this is
          // done in two steps on IE.
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
      }

      /**
       * Parse a request URL and determine whether this is a same-origin request as the application document.
       *
       * @param {string|object} requestUrl The url of the request as a string that will be resolved
       * or a parsed URL object.
       * @returns {boolean} Whether the request is for the same origin as the application document.
       */
      function urlIsSameOrigin(requestUrl) {
        var parsed = isString(requestUrl) ? urlResolve(requestUrl) : requestUrl;
        return parsed.protocol === originUrl.protocol && parsed.host === originUrl.host;
      }

      /**
       * @ngdoc service
       * @name $window
       *
       * @description
       * A reference to the browser's `window` object. While `window`
       * is globally available in JavaScript, it causes testability problems, because
       * it is a global variable. In angular we always refer to it through the
       * `$window` service, so it may be overridden, removed or mocked for testing.
       *
       * Expressions, like the one defined for the `ngClick` directive in the example
       * below, are evaluated with respect to the current scope.  Therefore, there is
       * no risk of inadvertently coding in a dependency on a global value in such an
       * expression.
       *
       * @example
         <example module="windowExample">
           <file name="index.html">
             <script>
               angular.module('windowExample', [])
                 .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
                   $scope.greeting = 'Hello, World!';
                   $scope.doGreeting = function(greeting) {
                     $window.alert(greeting);
                   };
                 }]);
             </script>
             <div ng-controller="ExampleController">
               <input type="text" ng-model="greeting" aria-label="greeting" />
               <button ng-click="doGreeting(greeting)">ALERT</button>
             </div>
           </file>
           <file name="protractor.js" type="protractor">
            it('should display the greeting in the input box', function() {
             element(by.model('greeting')).sendKeys('Hello, E2E Tests');
             // If we click the button it will block the test runner
             // element(':button').click();
            });
           </file>
         </example>
       */
      function $WindowProvider() {
        this.$get = valueFn(window);
      }

      /**
       * @name $$cookieReader
       * @requires $document
       *
       * @description
       * This is a private service for reading cookies used by $http and ngCookies
       *
       * @return {Object} a key/value map of the current cookies
       */
      function $$CookieReader($document) {
        var rawDocument = $document[0] || {};
        var lastCookies = {};
        var lastCookieString = '';

        function safeDecodeURIComponent(str) {
          try {
            return decodeURIComponent(str);
          } catch (e) {
            return str;
          }
        }

        return function () {
          var cookieArray, cookie, i, index, name;
          var currentCookieString = rawDocument.cookie || '';

          if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};

            for (i = 0; i < cookieArray.length; i++) {
              cookie = cookieArray[i];
              index = cookie.indexOf('=');
              if (index > 0) {
                //ignore nameless cookies
                name = safeDecodeURIComponent(cookie.substring(0, index));
                // the first value that is seen for a cookie is the most
                // specific one.  values for the same cookie name that
                // follow are for less specific paths.
                if (isUndefined(lastCookies[name])) {
                  lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
                }
              }
            }
          }
          return lastCookies;
        };
      }

      $$CookieReader.$inject = ['$document'];

      function $$CookieReaderProvider() {
        this.$get = $$CookieReader;
      }

      /* global currencyFilter: true,
       dateFilter: true,
       filterFilter: true,
       jsonFilter: true,
       limitToFilter: true,
       lowercaseFilter: true,
       numberFilter: true,
       orderByFilter: true,
       uppercaseFilter: true,
       */

      /**
       * @ngdoc provider
       * @name $filterProvider
       * @description
       *
       * Filters are just functions which transform input to an output. However filters need to be
       * Dependency Injected. To achieve this a filter definition consists of a factory function which is
       * annotated with dependencies and is responsible for creating a filter function.
       *
       * <div class="alert alert-warning">
       * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
       * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
       * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
       * (`myapp_subsection_filterx`).
       * </div>
       *
       * ```js
       *   // Filter registration
       *   function MyModule($provide, $filterProvider) {
       *     // create a service to demonstrate injection (not always needed)
       *     $provide.value('greet', function(name){
       *       return 'Hello ' + name + '!';
       *     });
       *
       *     // register a filter factory which uses the
       *     // greet service to demonstrate DI.
       *     $filterProvider.register('greet', function(greet){
       *       // return the filter function which uses the greet service
       *       // to generate salutation
       *       return function(text) {
       *         // filters need to be forgiving so check input validity
       *         return text && greet(text) || text;
       *       };
       *     });
       *   }
       * ```
       *
       * The filter function is registered with the `$injector` under the filter name suffix with
       * `Filter`.
       *
       * ```js
       *   it('should be the same instance', inject(
       *     function($filterProvider) {
       *       $filterProvider.register('reverse', function(){
       *         return ...;
       *       });
       *     },
       *     function($filter, reverseFilter) {
       *       expect($filter('reverse')).toBe(reverseFilter);
       *     });
       * ```
       *
       *
       * For more information about how angular filters work, and how to create your own filters, see
       * {@link guide/filter Filters} in the Angular Developer Guide.
       */

      /**
       * @ngdoc service
       * @name $filter
       * @kind function
       * @description
       * Filters are used for formatting data displayed to the user.
       *
       * The general syntax in templates is as follows:
       *
       *         {{ expression [| filter_name[:parameter_value] ... ] }}
       *
       * @param {String} name Name of the filter function to retrieve
       * @return {Function} the filter function
       * @example
         <example name="$filter" module="filterExample">
           <file name="index.html">
             <div ng-controller="MainCtrl">
              <h3>{{ originalText }}</h3>
              <h3>{{ filteredText }}</h3>
             </div>
           </file>
      
           <file name="script.js">
            angular.module('filterExample', [])
            .controller('MainCtrl', function($scope, $filter) {
              $scope.originalText = 'hello';
              $scope.filteredText = $filter('uppercase')($scope.originalText);
            });
           </file>
         </example>
        */
      $FilterProvider.$inject = ['$provide'];
      function $FilterProvider($provide) {
        var suffix = 'Filter';

        /**
         * @ngdoc method
         * @name $filterProvider#register
         * @param {string|Object} name Name of the filter function, or an object map of filters where
         *    the keys are the filter names and the values are the filter factories.
         *
         *    <div class="alert alert-warning">
         *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
         *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
         *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
         *    (`myapp_subsection_filterx`).
         *    </div>
          * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
         * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
         *    of the registered filter instances.
         */
        function register(name, factory) {
          if (isObject(name)) {
            var filters = {};
            forEach(name, function (filter, key) {
              filters[key] = register(key, filter);
            });
            return filters;
          } else {
            return $provide.factory(name + suffix, factory);
          }
        }
        this.register = register;

        this.$get = ['$injector', function ($injector) {
          return function (name) {
            return $injector.get(name + suffix);
          };
        }];

        ////////////////////////////////////////

        /* global
          currencyFilter: false,
          dateFilter: false,
          filterFilter: false,
          jsonFilter: false,
          limitToFilter: false,
          lowercaseFilter: false,
          numberFilter: false,
          orderByFilter: false,
          uppercaseFilter: false,
        */

        register('currency', currencyFilter);
        register('date', dateFilter);
        register('filter', filterFilter);
        register('json', jsonFilter);
        register('limitTo', limitToFilter);
        register('lowercase', lowercaseFilter);
        register('number', numberFilter);
        register('orderBy', orderByFilter);
        register('uppercase', uppercaseFilter);
      }

      /**
       * @ngdoc filter
       * @name filter
       * @kind function
       *
       * @description
       * Selects a subset of items from `array` and returns it as a new array.
       *
       * @param {Array} array The source array.
       * @param {string|Object|function()} expression The predicate to be used for selecting items from
       *   `array`.
       *
       *   Can be one of:
       *
       *   - `string`: The string is used for matching against the contents of the `array`. All strings or
       *     objects with string properties in `array` that match this string will be returned. This also
       *     applies to nested object properties.
       *     The predicate can be negated by prefixing the string with `!`.
       *
       *   - `Object`: A pattern object can be used to filter specific properties on objects contained
       *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
       *     which have property `name` containing "M" and property `phone` containing "1". A special
       *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
       *     against any property of the object or its nested object properties. That's equivalent to the
       *     simple substring match with a `string` as described above. The special property name can be
       *     overwritten, using the `anyPropertyKey` parameter.
       *     The predicate can be negated by prefixing the string with `!`.
       *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
       *     not containing "M".
       *
       *     Note that a named property will match properties on the same level only, while the special
       *     `$` property will match properties on the same level or deeper. E.g. an array item like
       *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
       *     **will** be matched by `{$: 'John'}`.
       *
       *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
       *     The function is called for each element of the array, with the element, its index, and
       *     the entire array itself as arguments.
       *
       *     The final result is an array of those elements that the predicate returned true for.
       *
       * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
       *     determining if the expected value (from the filter expression) and actual value (from
       *     the object in the array) should be considered a match.
       *
       *   Can be one of:
       *
       *   - `function(actual, expected)`:
       *     The function will be given the object value and the predicate value to compare and
       *     should return true if both values should be considered equal.
       *
       *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
       *     This is essentially strict comparison of expected and actual.
       *
       *   - `false|undefined`: A short hand for a function which will look for a substring match in case
       *     insensitive way.
       *
       *     Primitive values are converted to strings. Objects are not compared against primitives,
       *     unless they have a custom `toString` method (e.g. `Date` objects).
       *
       * @param {string=} anyPropertyKey The special property name that matches against any property.
       *     By default `$`.
       *
       * @example
         <example>
           <file name="index.html">
             <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                      {name:'Mary', phone:'800-BIG-MARY'},
                                      {name:'Mike', phone:'555-4321'},
                                      {name:'Adam', phone:'555-5678'},
                                      {name:'Julie', phone:'555-8765'},
                                      {name:'Juliette', phone:'555-5678'}]"></div>
      
             <label>Search: <input ng-model="searchText"></label>
             <table id="searchTextResults">
               <tr><th>Name</th><th>Phone</th></tr>
               <tr ng-repeat="friend in friends | filter:searchText">
                 <td>{{friend.name}}</td>
                 <td>{{friend.phone}}</td>
               </tr>
             </table>
             <hr>
             <label>Any: <input ng-model="search.$"></label> <br>
             <label>Name only <input ng-model="search.name"></label><br>
             <label>Phone only <input ng-model="search.phone"></label><br>
             <label>Equality <input type="checkbox" ng-model="strict"></label><br>
             <table id="searchObjResults">
               <tr><th>Name</th><th>Phone</th></tr>
               <tr ng-repeat="friendObj in friends | filter:search:strict">
                 <td>{{friendObj.name}}</td>
                 <td>{{friendObj.phone}}</td>
               </tr>
             </table>
           </file>
           <file name="protractor.js" type="protractor">
             var expectFriendNames = function(expectedNames, key) {
               element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
                 arr.forEach(function(wd, i) {
                   expect(wd.getText()).toMatch(expectedNames[i]);
                 });
               });
             };
      
             it('should search across all fields when filtering with a string', function() {
               var searchText = element(by.model('searchText'));
               searchText.clear();
               searchText.sendKeys('m');
               expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
      
               searchText.clear();
               searchText.sendKeys('76');
               expectFriendNames(['John', 'Julie'], 'friend');
             });
      
             it('should search in specific fields when filtering with a predicate object', function() {
               var searchAny = element(by.model('search.$'));
               searchAny.clear();
               searchAny.sendKeys('i');
               expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
             });
             it('should use a equal comparison when comparator is true', function() {
               var searchName = element(by.model('search.name'));
               var strict = element(by.model('strict'));
               searchName.clear();
               searchName.sendKeys('Julie');
               strict.click();
               expectFriendNames(['Julie'], 'friendObj');
             });
           </file>
         </example>
       */

      function filterFilter() {
        return function (array, expression, comparator, anyPropertyKey) {
          if (!isArrayLike(array)) {
            if (array == null) {
              return array;
            } else {
              throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
            }
          }

          anyPropertyKey = anyPropertyKey || '$';
          var expressionType = getTypeForFilter(expression);
          var predicateFn;
          var matchAgainstAnyProp;

          switch (expressionType) {
            case 'function':
              predicateFn = expression;
              break;
            case 'boolean':
            case 'null':
            case 'number':
            case 'string':
              matchAgainstAnyProp = true;
            //jshint -W086
            case 'object':
              //jshint +W086
              predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
              break;
            default:
              return array;
          }

          return Array.prototype.filter.call(array, predicateFn);
        };
      }

      // Helper functions for `filterFilter`
      function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
        var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
        var predicateFn;

        if (comparator === true) {
          comparator = equals;
        } else if (!isFunction(comparator)) {
          comparator = function (actual, expected) {
            if (isUndefined(actual)) {
              // No substring matching against `undefined`
              return false;
            }
            if (actual === null || expected === null) {
              // No substring matching against `null`; only match against `null`
              return actual === expected;
            }
            if (isObject(expected) || isObject(actual) && !hasCustomToString(actual)) {
              // Should not compare primitives against objects, unless they have custom `toString` method
              return false;
            }

            actual = lowercase('' + actual);
            expected = lowercase('' + expected);
            return actual.indexOf(expected) !== -1;
          };
        }

        predicateFn = function (item) {
          if (shouldMatchPrimitives && !isObject(item)) {
            return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
          }
          return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        };

        return predicateFn;
      }

      function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
        var actualType = getTypeForFilter(actual);
        var expectedType = getTypeForFilter(expected);

        if (expectedType === 'string' && expected.charAt(0) === '!') {
          return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
        } else if (isArray(actual)) {
          // In case `actual` is an array, consider it a match
          // if ANY of it's items matches `expected`
          return actual.some(function (item) {
            return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
          });
        }

        switch (actualType) {
          case 'object':
            var key;
            if (matchAgainstAnyProp) {
              for (key in actual) {
                if (key.charAt(0) !== '$' && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
                  return true;
                }
              }
              return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
            } else if (expectedType === 'object') {
              for (key in expected) {
                var expectedVal = expected[key];
                if (isFunction(expectedVal) || isUndefined(expectedVal)) {
                  continue;
                }

                var matchAnyProperty = key === anyPropertyKey;
                var actualVal = matchAnyProperty ? actual : actual[key];
                if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
                  return false;
                }
              }
              return true;
            } else {
              return comparator(actual, expected);
            }
            break;
          case 'function':
            return false;
          default:
            return comparator(actual, expected);
        }
      }

      // Used for easily differentiating between `null` and actual `object`
      function getTypeForFilter(val) {
        return val === null ? 'null' : typeof val;
      }

      var MAX_DIGITS = 22;
      var DECIMAL_SEP = '.';
      var ZERO_CHAR = '0';

      /**
       * @ngdoc filter
       * @name currency
       * @kind function
       *
       * @description
       * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
       * symbol for current locale is used.
       *
       * @param {number} amount Input to filter.
       * @param {string=} symbol Currency symbol or identifier to be displayed.
       * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
       * @returns {string} Formatted number.
       *
       *
       * @example
         <example module="currencyExample">
           <file name="index.html">
             <script>
               angular.module('currencyExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.amount = 1234.56;
                 }]);
             </script>
             <div ng-controller="ExampleController">
               <input type="number" ng-model="amount" aria-label="amount"> <br>
               default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
               custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
               no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
             </div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should init with 1234.56', function() {
               expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
               expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
               expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
             });
             it('should update', function() {
               if (browser.params.browser == 'safari') {
                 // Safari does not understand the minus key. See
                 // https://github.com/angular/protractor/issues/481
                 return;
               }
               element(by.model('amount')).clear();
               element(by.model('amount')).sendKeys('-1234');
               expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
               expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
               expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
             });
           </file>
         </example>
       */
      currencyFilter.$inject = ['$locale'];
      function currencyFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function (amount, currencySymbol, fractionSize) {
          if (isUndefined(currencySymbol)) {
            currencySymbol = formats.CURRENCY_SYM;
          }

          if (isUndefined(fractionSize)) {
            fractionSize = formats.PATTERNS[1].maxFrac;
          }

          // if null or undefined pass it through
          return amount == null ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(/\u00A4/g, currencySymbol);
        };
      }

      /**
       * @ngdoc filter
       * @name number
       * @kind function
       *
       * @description
       * Formats a number as text.
       *
       * If the input is null or undefined, it will just be returned.
       * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
       * If the input is not a number an empty string is returned.
       *
       *
       * @param {number|string} number Number to format.
       * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
       * If this is not provided then the fraction size is computed from the current locale's number
       * formatting pattern. In the case of the default locale, it will be 3.
       * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
       *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
       *                   include "," group separators after each third digit).
       *
       * @example
         <example module="numberFilterExample">
           <file name="index.html">
             <script>
               angular.module('numberFilterExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.val = 1234.56789;
                 }]);
             </script>
             <div ng-controller="ExampleController">
               <label>Enter number: <input ng-model='val'></label><br>
               Default formatting: <span id='number-default'>{{val | number}}</span><br>
               No fractions: <span>{{val | number:0}}</span><br>
               Negative number: <span>{{-val | number:4}}</span>
             </div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should format numbers', function() {
               expect(element(by.id('number-default')).getText()).toBe('1,234.568');
               expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
               expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
             });
      
             it('should update', function() {
               element(by.model('val')).clear();
               element(by.model('val')).sendKeys('3374.333');
               expect(element(by.id('number-default')).getText()).toBe('3,374.333');
               expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
               expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
            });
           </file>
         </example>
       */
      numberFilter.$inject = ['$locale'];
      function numberFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function (number, fractionSize) {

          // if null or undefined pass it through
          return number == null ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
        };
      }

      /**
       * Parse a number (as a string) into three components that can be used
       * for formatting the number.
       *
       * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
       *
       * @param  {string} numStr The number to parse
       * @return {object} An object describing this number, containing the following keys:
       *  - d : an array of digits containing leading zeros as necessary
       *  - i : the number of the digits in `d` that are to the left of the decimal point
       *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
       *
       */
      function parse(numStr) {
        var exponent = 0,
            digits,
            numberOfIntegerDigits;
        var i, j, zeros;

        // Decimal point?
        if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
          numStr = numStr.replace(DECIMAL_SEP, '');
        }

        // Exponential form?
        if ((i = numStr.search(/e/i)) > 0) {
          // Work out the exponent.
          if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
          numberOfIntegerDigits += +numStr.slice(i + 1);
          numStr = numStr.substring(0, i);
        } else if (numberOfIntegerDigits < 0) {
          // There was no decimal point or exponent so it is an integer.
          numberOfIntegerDigits = numStr.length;
        }

        // Count the number of leading zeros.
        for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}

        if (i == (zeros = numStr.length)) {
          // The digits are all zero.
          digits = [0];
          numberOfIntegerDigits = 1;
        } else {
          // Count the number of trailing zeros
          zeros--;
          while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;

          // Trailing zeros are insignificant so ignore them
          numberOfIntegerDigits -= i;
          digits = [];
          // Convert string to array of digits without leading/trailing zeros.
          for (j = 0; i <= zeros; i++, j++) {
            digits[j] = +numStr.charAt(i);
          }
        }

        // If the number overflows the maximum allowed digits then use an exponent.
        if (numberOfIntegerDigits > MAX_DIGITS) {
          digits = digits.splice(0, MAX_DIGITS - 1);
          exponent = numberOfIntegerDigits - 1;
          numberOfIntegerDigits = 1;
        }

        return { d: digits, e: exponent, i: numberOfIntegerDigits };
      }

      /**
       * Round the parsed number to the specified number of decimal places
       * This function changed the parsedNumber in-place
       */
      function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
        var digits = parsedNumber.d;
        var fractionLen = digits.length - parsedNumber.i;

        // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
        fractionSize = isUndefined(fractionSize) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

        // The index of the digit to where rounding is to occur
        var roundAt = fractionSize + parsedNumber.i;
        var digit = digits[roundAt];

        if (roundAt > 0) {
          // Drop fractional digits beyond `roundAt`
          digits.splice(Math.max(parsedNumber.i, roundAt));

          // Set non-fractional digits beyond `roundAt` to 0
          for (var j = roundAt; j < digits.length; j++) {
            digits[j] = 0;
          }
        } else {
          // We rounded to zero so reset the parsedNumber
          fractionLen = Math.max(0, fractionLen);
          parsedNumber.i = 1;
          digits.length = Math.max(1, roundAt = fractionSize + 1);
          digits[0] = 0;
          for (var i = 1; i < roundAt; i++) digits[i] = 0;
        }

        if (digit >= 5) {
          if (roundAt - 1 < 0) {
            for (var k = 0; k > roundAt; k--) {
              digits.unshift(0);
              parsedNumber.i++;
            }
            digits.unshift(1);
            parsedNumber.i++;
          } else {
            digits[roundAt - 1]++;
          }
        }

        // Pad out with zeros to get the required fraction length
        for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);

        // Do any carrying, e.g. a digit was rounded up to 10
        var carry = digits.reduceRight(function (carry, d, i, digits) {
          d = d + carry;
          digits[i] = d % 10;
          return Math.floor(d / 10);
        }, 0);
        if (carry) {
          digits.unshift(carry);
          parsedNumber.i++;
        }
      }

      /**
       * Format a number into a string
       * @param  {number} number       The number to format
       * @param  {{
       *           minFrac, // the minimum number of digits required in the fraction part of the number
       *           maxFrac, // the maximum number of digits required in the fraction part of the number
       *           gSize,   // number of digits in each group of separated digits
       *           lgSize,  // number of digits in the last group of digits before the decimal separator
       *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
       *           posPre,  // the string to go in front of a positive number
       *           negSuf,  // the string to go after a negative number (e.g. `)`)
       *           posSuf   // the string to go after a positive number
       *         }} pattern
       * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
       * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
       * @param  {[type]} fractionSize The size of the fractional part of the number
       * @return {string}              The number formatted as a string
       */
      function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

        if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

        var isInfinity = !isFinite(number);
        var isZero = false;
        var numStr = Math.abs(number) + '',
            formattedText = '',
            parsedNumber;

        if (isInfinity) {
          formattedText = '\u221e';
        } else {
          parsedNumber = parse(numStr);

          roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

          var digits = parsedNumber.d;
          var integerLen = parsedNumber.i;
          var exponent = parsedNumber.e;
          var decimals = [];
          isZero = digits.reduce(function (isZero, d) {
            return isZero && !d;
          }, true);

          // pad zeros for small numbers
          while (integerLen < 0) {
            digits.unshift(0);
            integerLen++;
          }

          // extract decimals digits
          if (integerLen > 0) {
            decimals = digits.splice(integerLen, digits.length);
          } else {
            decimals = digits;
            digits = [0];
          }

          // format the integer digits with grouping separators
          var groups = [];
          if (digits.length >= pattern.lgSize) {
            groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
          }
          while (digits.length > pattern.gSize) {
            groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
          }
          if (digits.length) {
            groups.unshift(digits.join(''));
          }
          formattedText = groups.join(groupSep);

          // append the decimal digits
          if (decimals.length) {
            formattedText += decimalSep + decimals.join('');
          }

          if (exponent) {
            formattedText += 'e+' + exponent;
          }
        }
        if (number < 0 && !isZero) {
          return pattern.negPre + formattedText + pattern.negSuf;
        } else {
          return pattern.posPre + formattedText + pattern.posSuf;
        }
      }

      function padNumber(num, digits, trim, negWrap) {
        var neg = '';
        if (num < 0 || negWrap && num <= 0) {
          if (negWrap) {
            num = -num + 1;
          } else {
            num = -num;
            neg = '-';
          }
        }
        num = '' + num;
        while (num.length < digits) num = ZERO_CHAR + num;
        if (trim) {
          num = num.substr(num.length - digits);
        }
        return neg + num;
      }

      function dateGetter(name, size, offset, trim, negWrap) {
        offset = offset || 0;
        return function (date) {
          var value = date['get' + name]();
          if (offset > 0 || value > -offset) {
            value += offset;
          }
          if (value === 0 && offset == -12) value = 12;
          return padNumber(value, size, trim, negWrap);
        };
      }

      function dateStrGetter(name, shortForm, standAlone) {
        return function (date, formats) {
          var value = date['get' + name]();
          var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
          var get = uppercase(propPrefix + name);

          return formats[get][value];
        };
      }

      function timeZoneGetter(date, formats, offset) {
        var zone = -1 * offset;
        var paddedZone = zone >= 0 ? "+" : "";

        paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);

        return paddedZone;
      }

      function getFirstThursdayOfYear(year) {
        // 0 = index of January
        var dayOfWeekOnFirst = new Date(year, 0, 1).getDay();
        // 4 = index of Thursday (+1 to account for 1st = 5)
        // 11 = index of *next* Thursday (+1 account for 1st = 12)
        return new Date(year, 0, (dayOfWeekOnFirst <= 4 ? 5 : 12) - dayOfWeekOnFirst);
      }

      function getThursdayThisWeek(datetime) {
        return new Date(datetime.getFullYear(), datetime.getMonth(),
        // 4 = index of Thursday
        datetime.getDate() + (4 - datetime.getDay()));
      }

      function weekGetter(size) {
        return function (date) {
          var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
              thisThurs = getThursdayThisWeek(date);

          var diff = +thisThurs - +firstThurs,
              result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

          return padNumber(result, size);
        };
      }

      function ampmGetter(date, formats) {
        return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
      }

      function eraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
      }

      function longEraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
      }

      var DATE_FORMATS = {
        yyyy: dateGetter('FullYear', 4, 0, false, true),
        yy: dateGetter('FullYear', 2, 0, true, true),
        y: dateGetter('FullYear', 1, 0, false, true),
        MMMM: dateStrGetter('Month'),
        MMM: dateStrGetter('Month', true),
        MM: dateGetter('Month', 2, 1),
        M: dateGetter('Month', 1, 1),
        LLLL: dateStrGetter('Month', false, true),
        dd: dateGetter('Date', 2),
        d: dateGetter('Date', 1),
        HH: dateGetter('Hours', 2),
        H: dateGetter('Hours', 1),
        hh: dateGetter('Hours', 2, -12),
        h: dateGetter('Hours', 1, -12),
        mm: dateGetter('Minutes', 2),
        m: dateGetter('Minutes', 1),
        ss: dateGetter('Seconds', 2),
        s: dateGetter('Seconds', 1),
        // while ISO 8601 requires fractions to be prefixed with `.` or `,`
        // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
        sss: dateGetter('Milliseconds', 3),
        EEEE: dateStrGetter('Day'),
        EEE: dateStrGetter('Day', true),
        a: ampmGetter,
        Z: timeZoneGetter,
        ww: weekGetter(2),
        w: weekGetter(1),
        G: eraGetter,
        GG: eraGetter,
        GGG: eraGetter,
        GGGG: longEraGetter
      };

      var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
          NUMBER_STRING = /^\-?\d+$/;

      /**
       * @ngdoc filter
       * @name date
       * @kind function
       *
       * @description
       *   Formats `date` to a string based on the requested `format`.
       *
       *   `format` string can be composed of the following elements:
       *
       *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
       *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
       *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
       *   * `'MMMM'`: Month in year (January-December)
       *   * `'MMM'`: Month in year (Jan-Dec)
       *   * `'MM'`: Month in year, padded (01-12)
       *   * `'M'`: Month in year (1-12)
       *   * `'LLLL'`: Stand-alone month in year (January-December)
       *   * `'dd'`: Day in month, padded (01-31)
       *   * `'d'`: Day in month (1-31)
       *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
       *   * `'EEE'`: Day in Week, (Sun-Sat)
       *   * `'HH'`: Hour in day, padded (00-23)
       *   * `'H'`: Hour in day (0-23)
       *   * `'hh'`: Hour in AM/PM, padded (01-12)
       *   * `'h'`: Hour in AM/PM, (1-12)
       *   * `'mm'`: Minute in hour, padded (00-59)
       *   * `'m'`: Minute in hour (0-59)
       *   * `'ss'`: Second in minute, padded (00-59)
       *   * `'s'`: Second in minute (0-59)
       *   * `'sss'`: Millisecond in second, padded (000-999)
       *   * `'a'`: AM/PM marker
       *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
       *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
       *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
       *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
       *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
       *
       *   `format` string can also be one of the following predefined
       *   {@link guide/i18n localizable formats}:
       *
       *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
       *     (e.g. Sep 3, 2010 12:05:08 PM)
       *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
       *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
       *     (e.g. Friday, September 3, 2010)
       *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
       *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
       *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
       *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
       *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
       *
       *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
       *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
       *   (e.g. `"h 'o''clock'"`).
       *
       * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
       *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
       *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
       *    specified in the string input, the time is considered to be in the local timezone.
       * @param {string=} format Formatting rules (see Description). If not specified,
       *    `mediumDate` is used.
       * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
       *    continental US time zone abbreviations, but for general use, use a time zone offset, for
       *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
       *    If not specified, the timezone of the browser will be used.
       * @returns {string} Formatted string or the input if input is not recognized as date/millis.
       *
       * @example
         <example>
           <file name="index.html">
             <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
                 <span>{{1288323623006 | date:'medium'}}</span><br>
             <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
                <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
             <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
                <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
             <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
                <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
           </file>
           <file name="protractor.js" type="protractor">
             it('should format date', function() {
               expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
                  toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
               expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
                  toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
               expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
                  toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
               expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
                  toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
             });
           </file>
         </example>
       */
      dateFilter.$inject = ['$locale'];
      function dateFilter($locale) {

        var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
        // 1        2       3         4          5          6          7          8  9     10      11
        function jsonStringToDate(string) {
          var match;
          if (match = string.match(R_ISO8601_STR)) {
            var date = new Date(0),
                tzHour = 0,
                tzMin = 0,
                dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
                timeSetter = match[8] ? date.setUTCHours : date.setHours;

            if (match[9]) {
              tzHour = toInt(match[9] + match[10]);
              tzMin = toInt(match[9] + match[11]);
            }
            dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
            var h = toInt(match[4] || 0) - tzHour;
            var m = toInt(match[5] || 0) - tzMin;
            var s = toInt(match[6] || 0);
            var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
            timeSetter.call(date, h, m, s, ms);
            return date;
          }
          return string;
        }

        return function (date, format, timezone) {
          var text = '',
              parts = [],
              fn,
              match;

          format = format || 'mediumDate';
          format = $locale.DATETIME_FORMATS[format] || format;
          if (isString(date)) {
            date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
          }

          if (isNumber(date)) {
            date = new Date(date);
          }

          if (!isDate(date) || !isFinite(date.getTime())) {
            return date;
          }

          while (format) {
            match = DATE_FORMATS_SPLIT.exec(format);
            if (match) {
              parts = concat(parts, match, 1);
              format = parts.pop();
            } else {
              parts.push(format);
              format = null;
            }
          }

          var dateTimezoneOffset = date.getTimezoneOffset();
          if (timezone) {
            dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
            date = convertTimezoneToLocal(date, timezone, true);
          }
          forEach(parts, function (value) {
            fn = DATE_FORMATS[value];
            text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
          });

          return text;
        };
      }

      /**
       * @ngdoc filter
       * @name json
       * @kind function
       *
       * @description
       *   Allows you to convert a JavaScript object into JSON string.
       *
       *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
       *   the binding is automatically converted to JSON.
       *
       * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
       * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
       * @returns {string} JSON string.
       *
       *
       * @example
         <example>
           <file name="index.html">
             <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
             <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
           </file>
           <file name="protractor.js" type="protractor">
             it('should jsonify filtered objects', function() {
               expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
               expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
             });
           </file>
         </example>
       *
       */
      function jsonFilter() {
        return function (object, spacing) {
          if (isUndefined(spacing)) {
            spacing = 2;
          }
          return toJson(object, spacing);
        };
      }

      /**
       * @ngdoc filter
       * @name lowercase
       * @kind function
       * @description
       * Converts string to lowercase.
       * @see angular.lowercase
       */
      var lowercaseFilter = valueFn(lowercase);

      /**
       * @ngdoc filter
       * @name uppercase
       * @kind function
       * @description
       * Converts string to uppercase.
       * @see angular.uppercase
       */
      var uppercaseFilter = valueFn(uppercase);

      /**
       * @ngdoc filter
       * @name limitTo
       * @kind function
       *
       * @description
       * Creates a new array or string containing only a specified number of elements. The elements are
       * taken from either the beginning or the end of the source array, string or number, as specified by
       * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
       * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
       * it is converted to a string.
       *
       * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
       * @param {string|number} limit - The length of the returned array or string. If the `limit` number
       *     is positive, `limit` number of items from the beginning of the source array/string are copied.
       *     If the number is negative, `limit` number  of items from the end of the source array/string
       *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
       *     the input will be returned unchanged.
       * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
       *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
       * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
       *     less than `limit` elements.
       *
       * @example
         <example module="limitToExample">
           <file name="index.html">
             <script>
               angular.module('limitToExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.numbers = [1,2,3,4,5,6,7,8,9];
                   $scope.letters = "abcdefghi";
                   $scope.longNumber = 2345432342;
                   $scope.numLimit = 3;
                   $scope.letterLimit = 3;
                   $scope.longNumberLimit = 3;
                 }]);
             </script>
             <div ng-controller="ExampleController">
               <label>
                  Limit {{numbers}} to:
                  <input type="number" step="1" ng-model="numLimit">
               </label>
               <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
               <label>
                  Limit {{letters}} to:
                  <input type="number" step="1" ng-model="letterLimit">
               </label>
               <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
               <label>
                  Limit {{longNumber}} to:
                  <input type="number" step="1" ng-model="longNumberLimit">
               </label>
               <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
             </div>
           </file>
           <file name="protractor.js" type="protractor">
             var numLimitInput = element(by.model('numLimit'));
             var letterLimitInput = element(by.model('letterLimit'));
             var longNumberLimitInput = element(by.model('longNumberLimit'));
             var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
             var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
             var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
      
             it('should limit the number array to first three items', function() {
               expect(numLimitInput.getAttribute('value')).toBe('3');
               expect(letterLimitInput.getAttribute('value')).toBe('3');
               expect(longNumberLimitInput.getAttribute('value')).toBe('3');
               expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
               expect(limitedLetters.getText()).toEqual('Output letters: abc');
               expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
             });
      
             // There is a bug in safari and protractor that doesn't like the minus key
             // it('should update the output when -3 is entered', function() {
             //   numLimitInput.clear();
             //   numLimitInput.sendKeys('-3');
             //   letterLimitInput.clear();
             //   letterLimitInput.sendKeys('-3');
             //   longNumberLimitInput.clear();
             //   longNumberLimitInput.sendKeys('-3');
             //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
             //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
             //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
             // });
      
             it('should not exceed the maximum size of input array', function() {
               numLimitInput.clear();
               numLimitInput.sendKeys('100');
               letterLimitInput.clear();
               letterLimitInput.sendKeys('100');
               longNumberLimitInput.clear();
               longNumberLimitInput.sendKeys('100');
               expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
               expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
               expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
             });
           </file>
         </example>
      */
      function limitToFilter() {
        return function (input, limit, begin) {
          if (Math.abs(Number(limit)) === Infinity) {
            limit = Number(limit);
          } else {
            limit = toInt(limit);
          }
          if (isNaN(limit)) return input;

          if (isNumber(input)) input = input.toString();
          if (!isArrayLike(input)) return input;

          begin = !begin || isNaN(begin) ? 0 : toInt(begin);
          begin = begin < 0 ? Math.max(0, input.length + begin) : begin;

          if (limit >= 0) {
            return sliceFn(input, begin, begin + limit);
          } else {
            if (begin === 0) {
              return sliceFn(input, limit, input.length);
            } else {
              return sliceFn(input, Math.max(0, begin + limit), begin);
            }
          }
        };
      }

      function sliceFn(input, begin, end) {
        if (isString(input)) return input.slice(begin, end);

        return slice.call(input, begin, end);
      }

      /**
       * @ngdoc filter
       * @name orderBy
       * @kind function
       *
       * @description
       * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
       * function based on the values computed using the `expression` predicate.
       *
       * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
       * `[{id: 'bar'}, {id: 'foo'}]`.
       *
       * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
       * String, etc).
       *
       * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
       * for the preceeding one. The `expression` is evaluated against each item and the output is used
       * for comparing with other items.
       *
       * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
       * ascending order.
       *
       * The comparison is done using the `comparator` function. If none is specified, a default, built-in
       * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
       * strings alphabetically).
       *
       * ### Under the hood
       *
       * Ordering the specified `collection` happens in two phases:
       *
       * 1. All items are passed through the predicate (or predicates), and the returned values are saved
       *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
       *    through a predicate that extracts the value of the `label` property, would be transformed to:
       *    ```
       *    {
       *      value: 'foo',
       *      type: 'string',
       *      index: ...
       *    }
       *    ```
       * 2. The comparator function is used to sort the items, based on the derived values, types and
       *    indices.
       *
       * If you use a custom comparator, it will be called with pairs of objects of the form
       * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
       * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
       * second, or `1` otherwise.
       *
       * In order to ensure that the sorting will be deterministic across platforms, if none of the
       * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
       * dummy predicate that returns the item's index as `value`.
       * (If you are using a custom comparator, make sure it can handle this predicate as well.)
       *
       * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
       * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
       * it to the comparator. The following rules govern the conversion:
       *
       * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
       *    used instead.<br />
       *    (If the object has a `valueOf()` method that returns another object, then the returned object
       *    will be used in subsequent steps.)
       * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
       *    returns a primitive, its return value will be used instead.<br />
       *    (If the object has a `toString()` method that returns another object, then the returned object
       *    will be used in subsequent steps.)
       * 3. No conversion; the object itself is used.
       *
       * ### The default comparator
       *
       * The default, built-in comparator should be sufficient for most usecases. In short, it compares
       * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
       * using their index in the original collection, and sorts values of different types by type.
       *
       * More specifically, it follows these steps to determine the relative order of items:
       *
       * 1. If the compared values are of different types, compare the types themselves alphabetically.
       * 2. If both values are of type `string`, compare them alphabetically in a case- and
       *    locale-insensitive way.
       * 3. If both values are objects, compare their indices instead.
       * 4. Otherwise, return:
       *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
       *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
       *    -  `1`, otherwise.
       *
       * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
       *           saved as numbers and not strings.
       *
       * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
       * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
       *    predicates) to be used by the comparator to determine the order of elements.
       *
       *    Can be one of:
       *
       *    - `Function`: A getter function. This function will be called with each item as argument and
       *      the return value will be used for sorting.
       *    - `string`: An Angular expression. This expression will be evaluated against each item and the
       *      result will be used for sorting. For example, use `'label'` to sort by a property called
       *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
       *      property.<br />
       *      (The result of a constant expression is interpreted as a property name to be used for
       *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
       *      property called `special name`.)<br />
       *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
       *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
       *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
       *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
       *      relative order of two items, the next predicate is used as a tie-breaker.
       *
       * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
       *
       * @param {boolean=} reverse - If `true`, reverse the sorting order.
       * @param {(Function)=} comparator - The comparator function used to determine the relative order of
       *    value pairs. If omitted, the built-in comparator will be used.
       *
       * @returns {Array} - The sorted array.
       *
       *
       * @example
       * ### Ordering a table with `ngRepeat`
       *
       * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
       * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
       * it defaults to the built-in comparator.
       *
         <example name="orderBy-static" module="orderByExample1">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <table class="friends">
                 <tr>
                   <th>Name</th>
                   <th>Phone Number</th>
                   <th>Age</th>
                 </tr>
                 <tr ng-repeat="friend in friends | orderBy:'-age'">
                   <td>{{friend.name}}</td>
                   <td>{{friend.phone}}</td>
                   <td>{{friend.age}}</td>
                 </tr>
               </table>
             </div>
           </file>
           <file name="script.js">
             angular.module('orderByExample1', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.friends = [
                   {name: 'John',   phone: '555-1212',  age: 10},
                   {name: 'Mary',   phone: '555-9876',  age: 19},
                   {name: 'Mike',   phone: '555-4321',  age: 21},
                   {name: 'Adam',   phone: '555-5678',  age: 35},
                   {name: 'Julie',  phone: '555-8765',  age: 29}
                 ];
               }]);
           </file>
           <file name="style.css">
             .friends {
               border-collapse: collapse;
             }
      
             .friends th {
               border-bottom: 1px solid;
             }
             .friends td, .friends th {
               border-left: 1px solid;
               padding: 5px 10px;
             }
             .friends td:first-child, .friends th:first-child {
               border-left: none;
             }
           </file>
           <file name="protractor.js" type="protractor">
             // Element locators
             var names = element.all(by.repeater('friends').column('friend.name'));
      
             it('should sort friends by age in reverse order', function() {
               expect(names.get(0).getText()).toBe('Adam');
               expect(names.get(1).getText()).toBe('Julie');
               expect(names.get(2).getText()).toBe('Mike');
               expect(names.get(3).getText()).toBe('Mary');
               expect(names.get(4).getText()).toBe('John');
             });
           </file>
         </example>
       * <hr />
       *
       * @example
       * ### Changing parameters dynamically
       *
       * All parameters can be changed dynamically. The next example shows how you can make the columns of
       * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
       *
         <example name="orderBy-dynamic" module="orderByExample2">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
               <hr/>
               <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
               <hr/>
               <table class="friends">
                 <tr>
                   <th>
                     <button ng-click="sortBy('name')">Name</button>
                     <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
                   </th>
                   <th>
                     <button ng-click="sortBy('phone')">Phone Number</button>
                     <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
                   </th>
                   <th>
                     <button ng-click="sortBy('age')">Age</button>
                     <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
                   </th>
                 </tr>
                 <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
                   <td>{{friend.name}}</td>
                   <td>{{friend.phone}}</td>
                   <td>{{friend.age}}</td>
                 </tr>
               </table>
             </div>
           </file>
           <file name="script.js">
             angular.module('orderByExample2', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 var friends = [
                   {name: 'John',   phone: '555-1212',  age: 10},
                   {name: 'Mary',   phone: '555-9876',  age: 19},
                   {name: 'Mike',   phone: '555-4321',  age: 21},
                   {name: 'Adam',   phone: '555-5678',  age: 35},
                   {name: 'Julie',  phone: '555-8765',  age: 29}
                 ];
      
                 $scope.propertyName = 'age';
                 $scope.reverse = true;
                 $scope.friends = friends;
      
                 $scope.sortBy = function(propertyName) {
                   $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
                   $scope.propertyName = propertyName;
                 };
               }]);
           </file>
           <file name="style.css">
             .friends {
               border-collapse: collapse;
             }
      
             .friends th {
               border-bottom: 1px solid;
             }
             .friends td, .friends th {
               border-left: 1px solid;
               padding: 5px 10px;
             }
             .friends td:first-child, .friends th:first-child {
               border-left: none;
             }
      
             .sortorder:after {
               content: '\25b2';   // BLACK UP-POINTING TRIANGLE
             }
             .sortorder.reverse:after {
               content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
             }
           </file>
           <file name="protractor.js" type="protractor">
             // Element locators
             var unsortButton = element(by.partialButtonText('unsorted'));
             var nameHeader = element(by.partialButtonText('Name'));
             var phoneHeader = element(by.partialButtonText('Phone'));
             var ageHeader = element(by.partialButtonText('Age'));
             var firstName = element(by.repeater('friends').column('friend.name').row(0));
             var lastName = element(by.repeater('friends').column('friend.name').row(4));
      
             it('should sort friends by some property, when clicking on the column header', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               phoneHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Mary');
      
               nameHeader.click();
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('Mike');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Adam');
             });
      
             it('should sort friends in reverse order, when clicking on the same column', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Adam');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
             });
      
             it('should restore the original order, when clicking "Set to unsorted"', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               unsortButton.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Julie');
             });
           </file>
         </example>
       * <hr />
       *
       * @example
       * ### Using `orderBy` inside a controller
       *
       * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
       * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
       * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
       *
         <example name="orderBy-call-manually" module="orderByExample3">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
               <hr/>
               <button ng-click="sortBy(null)">Set to unsorted</button>
               <hr/>
               <table class="friends">
                 <tr>
                   <th>
                     <button ng-click="sortBy('name')">Name</button>
                     <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
                   </th>
                   <th>
                     <button ng-click="sortBy('phone')">Phone Number</button>
                     <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
                   </th>
                   <th>
                     <button ng-click="sortBy('age')">Age</button>
                     <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
                   </th>
                 </tr>
                 <tr ng-repeat="friend in friends">
                   <td>{{friend.name}}</td>
                   <td>{{friend.phone}}</td>
                   <td>{{friend.age}}</td>
                 </tr>
               </table>
             </div>
           </file>
           <file name="script.js">
             angular.module('orderByExample3', [])
               .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
                 var friends = [
                   {name: 'John',   phone: '555-1212',  age: 10},
                   {name: 'Mary',   phone: '555-9876',  age: 19},
                   {name: 'Mike',   phone: '555-4321',  age: 21},
                   {name: 'Adam',   phone: '555-5678',  age: 35},
                   {name: 'Julie',  phone: '555-8765',  age: 29}
                 ];
      
                 $scope.propertyName = 'age';
                 $scope.reverse = true;
                 $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
      
                 $scope.sortBy = function(propertyName) {
                   $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                       ? !$scope.reverse : false;
                   $scope.propertyName = propertyName;
                   $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
                 };
               }]);
           </file>
           <file name="style.css">
             .friends {
               border-collapse: collapse;
             }
      
             .friends th {
               border-bottom: 1px solid;
             }
             .friends td, .friends th {
               border-left: 1px solid;
               padding: 5px 10px;
             }
             .friends td:first-child, .friends th:first-child {
               border-left: none;
             }
      
             .sortorder:after {
               content: '\25b2';   // BLACK UP-POINTING TRIANGLE
             }
             .sortorder.reverse:after {
               content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
             }
           </file>
           <file name="protractor.js" type="protractor">
             // Element locators
             var unsortButton = element(by.partialButtonText('unsorted'));
             var nameHeader = element(by.partialButtonText('Name'));
             var phoneHeader = element(by.partialButtonText('Phone'));
             var ageHeader = element(by.partialButtonText('Age'));
             var firstName = element(by.repeater('friends').column('friend.name').row(0));
             var lastName = element(by.repeater('friends').column('friend.name').row(4));
      
             it('should sort friends by some property, when clicking on the column header', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               phoneHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Mary');
      
               nameHeader.click();
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('Mike');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Adam');
             });
      
             it('should sort friends in reverse order, when clicking on the same column', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Adam');
      
               ageHeader.click();
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
             });
      
             it('should restore the original order, when clicking "Set to unsorted"', function() {
               expect(firstName.getText()).toBe('Adam');
               expect(lastName.getText()).toBe('John');
      
               unsortButton.click();
               expect(firstName.getText()).toBe('John');
               expect(lastName.getText()).toBe('Julie');
             });
           </file>
         </example>
       * <hr />
       *
       * @example
       * ### Using a custom comparator
       *
       * If you have very specific requirements about the way items are sorted, you can pass your own
       * comparator function. For example, you might need to compare some strings in a locale-sensitive
       * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
       * argument - passing `false` retains the default sorting order, i.e. ascending.)
       *
         <example name="orderBy-custom-comparator" module="orderByExample4">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <div class="friends-container custom-comparator">
                 <h3>Locale-sensitive Comparator</h3>
                 <table class="friends">
                   <tr>
                     <th>Name</th>
                     <th>Favorite Letter</th>
                   </tr>
                   <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
                     <td>{{friend.name}}</td>
                     <td>{{friend.favoriteLetter}}</td>
                   </tr>
                 </table>
               </div>
               <div class="friends-container default-comparator">
                 <h3>Default Comparator</h3>
                 <table class="friends">
                   <tr>
                     <th>Name</th>
                     <th>Favorite Letter</th>
                   </tr>
                   <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
                     <td>{{friend.name}}</td>
                     <td>{{friend.favoriteLetter}}</td>
                   </tr>
                 </table>
               </div>
             </div>
           </file>
           <file name="script.js">
             angular.module('orderByExample4', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.friends = [
                   {name: 'John',   favoriteLetter: 'Ä'},
                   {name: 'Mary',   favoriteLetter: 'Ü'},
                   {name: 'Mike',   favoriteLetter: 'Ö'},
                   {name: 'Adam',   favoriteLetter: 'H'},
                   {name: 'Julie',  favoriteLetter: 'Z'}
                 ];
      
                 $scope.localeSensitiveComparator = function(v1, v2) {
                   // If we don't get strings, just compare by index
                   if (v1.type !== 'string' || v2.type !== 'string') {
                     return (v1.index < v2.index) ? -1 : 1;
                   }
      
                   // Compare strings alphabetically, taking locale into account
                   return v1.value.localeCompare(v2.value);
                 };
               }]);
           </file>
           <file name="style.css">
             .friends-container {
               display: inline-block;
               margin: 0 30px;
             }
      
             .friends {
               border-collapse: collapse;
             }
      
             .friends th {
               border-bottom: 1px solid;
             }
             .friends td, .friends th {
               border-left: 1px solid;
               padding: 5px 10px;
             }
             .friends td:first-child, .friends th:first-child {
               border-left: none;
             }
           </file>
           <file name="protractor.js" type="protractor">
             // Element locators
             var container = element(by.css('.custom-comparator'));
             var names = container.all(by.repeater('friends').column('friend.name'));
      
             it('should sort friends by favorite letter (in correct alphabetical order)', function() {
               expect(names.get(0).getText()).toBe('John');
               expect(names.get(1).getText()).toBe('Adam');
               expect(names.get(2).getText()).toBe('Mike');
               expect(names.get(3).getText()).toBe('Mary');
               expect(names.get(4).getText()).toBe('Julie');
             });
           </file>
         </example>
       *
       */
      orderByFilter.$inject = ['$parse'];
      function orderByFilter($parse) {
        return function (array, sortPredicate, reverseOrder, compareFn) {

          if (array == null) return array;
          if (!isArrayLike(array)) {
            throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
          }

          if (!isArray(sortPredicate)) {
            sortPredicate = [sortPredicate];
          }
          if (sortPredicate.length === 0) {
            sortPredicate = ['+'];
          }

          var predicates = processPredicates(sortPredicate);

          var descending = reverseOrder ? -1 : 1;

          // Define the `compare()` function. Use a default comparator if none is specified.
          var compare = isFunction(compareFn) ? compareFn : defaultCompare;

          // The next three lines are a version of a Swartzian Transform idiom from Perl
          // (sometimes called the Decorate-Sort-Undecorate idiom)
          // See https://en.wikipedia.org/wiki/Schwartzian_transform
          var compareValues = Array.prototype.map.call(array, getComparisonObject);
          compareValues.sort(doComparison);
          array = compareValues.map(function (item) {
            return item.value;
          });

          return array;

          function getComparisonObject(value, index) {
            // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
            // This will be used to keep the sort stable when none of the input predicates can
            // distinguish between two elements.
            return {
              value: value,
              tieBreaker: { value: index, type: 'number', index: index },
              predicateValues: predicates.map(function (predicate) {
                return getPredicateValue(predicate.get(value), index);
              })
            };
          }

          function doComparison(v1, v2) {
            for (var i = 0, ii = predicates.length; i < ii; i++) {
              var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
              if (result) {
                return result * predicates[i].descending * descending;
              }
            }

            return compare(v1.tieBreaker, v2.tieBreaker) * descending;
          }
        };

        function processPredicates(sortPredicates) {
          return sortPredicates.map(function (predicate) {
            var descending = 1,
                get = identity;

            if (isFunction(predicate)) {
              get = predicate;
            } else if (isString(predicate)) {
              if (predicate.charAt(0) == '+' || predicate.charAt(0) == '-') {
                descending = predicate.charAt(0) == '-' ? -1 : 1;
                predicate = predicate.substring(1);
              }
              if (predicate !== '') {
                get = $parse(predicate);
                if (get.constant) {
                  var key = get();
                  get = function (value) {
                    return value[key];
                  };
                }
              }
            }
            return { get: get, descending: descending };
          });
        }

        function isPrimitive(value) {
          switch (typeof value) {
            case 'number': /* falls through */
            case 'boolean': /* falls through */
            case 'string':
              return true;
            default:
              return false;
          }
        }

        function objectValue(value) {
          // If `valueOf` is a valid function use that
          if (isFunction(value.valueOf)) {
            value = value.valueOf();
            if (isPrimitive(value)) return value;
          }
          // If `toString` is a valid function and not the one from `Object.prototype` use that
          if (hasCustomToString(value)) {
            value = value.toString();
            if (isPrimitive(value)) return value;
          }

          return value;
        }

        function getPredicateValue(value, index) {
          var type = typeof value;
          if (value === null) {
            type = 'string';
            value = 'null';
          } else if (type === 'object') {
            value = objectValue(value);
          }
          return { value: value, type: type, index: index };
        }

        function defaultCompare(v1, v2) {
          var result = 0;
          var type1 = v1.type;
          var type2 = v2.type;

          if (type1 === type2) {
            var value1 = v1.value;
            var value2 = v2.value;

            if (type1 === 'string') {
              // Compare strings case-insensitively
              value1 = value1.toLowerCase();
              value2 = value2.toLowerCase();
            } else if (type1 === 'object') {
              // For basic objects, use the position of the object
              // in the collection instead of the value
              if (isObject(value1)) value1 = v1.index;
              if (isObject(value2)) value2 = v2.index;
            }

            if (value1 !== value2) {
              result = value1 < value2 ? -1 : 1;
            }
          } else {
            result = type1 < type2 ? -1 : 1;
          }

          return result;
        }
      }

      function ngDirective(directive) {
        if (isFunction(directive)) {
          directive = {
            link: directive
          };
        }
        directive.restrict = directive.restrict || 'AC';
        return valueFn(directive);
      }

      /**
       * @ngdoc directive
       * @name a
       * @restrict E
       *
       * @description
       * Modifies the default behavior of the html A tag so that the default action is prevented when
       * the href attribute is empty.
       *
       * This change permits the easy creation of action links with the `ngClick` directive
       * without changing the location or causing page reloads, e.g.:
       * `<a href="" ng-click="list.addItem()">Add Item</a>`
       */
      var htmlAnchorDirective = valueFn({
        restrict: 'E',
        compile: function (element, attr) {
          if (!attr.href && !attr.xlinkHref) {
            return function (scope, element) {
              // If the linked element is not an anchor tag anymore, do nothing
              if (element[0].nodeName.toLowerCase() !== 'a') return;

              // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
              var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ? 'xlink:href' : 'href';
              element.on('click', function (event) {
                // if we have no href url, then don't navigate anywhere.
                if (!element.attr(href)) {
                  event.preventDefault();
                }
              });
            };
          }
        }
      });

      /**
       * @ngdoc directive
       * @name ngHref
       * @restrict A
       * @priority 99
       *
       * @description
       * Using Angular markup like `{{hash}}` in an href attribute will
       * make the link go to the wrong URL if the user clicks it before
       * Angular has a chance to replace the `{{hash}}` markup with its
       * value. Until Angular replaces the markup the link will be broken
       * and will most likely return a 404 error. The `ngHref` directive
       * solves this problem.
       *
       * The wrong way to write it:
       * ```html
       * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
       * ```
       *
       * The correct way to write it:
       * ```html
       * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
       * ```
       *
       * @element A
       * @param {template} ngHref any string which can contain `{{}}` markup.
       *
       * @example
       * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
       * in links and their different behaviors:
          <example>
            <file name="index.html">
              <input ng-model="value" /><br />
              <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
              <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
              <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
              <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
              <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
              <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
            </file>
            <file name="protractor.js" type="protractor">
              it('should execute ng-click but not reload when href without value', function() {
                element(by.id('link-1')).click();
                expect(element(by.model('value')).getAttribute('value')).toEqual('1');
                expect(element(by.id('link-1')).getAttribute('href')).toBe('');
              });
      
              it('should execute ng-click but not reload when href empty string', function() {
                element(by.id('link-2')).click();
                expect(element(by.model('value')).getAttribute('value')).toEqual('2');
                expect(element(by.id('link-2')).getAttribute('href')).toBe('');
              });
      
              it('should execute ng-click and change url when ng-href specified', function() {
                expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
      
                element(by.id('link-3')).click();
      
                // At this point, we navigate away from an Angular page, so we need
                // to use browser.driver to get the base webdriver.
      
                browser.wait(function() {
                  return browser.driver.getCurrentUrl().then(function(url) {
                    return url.match(/\/123$/);
                  });
                }, 5000, 'page should navigate to /123');
              });
      
              it('should execute ng-click but not reload when href empty string and name specified', function() {
                element(by.id('link-4')).click();
                expect(element(by.model('value')).getAttribute('value')).toEqual('4');
                expect(element(by.id('link-4')).getAttribute('href')).toBe('');
              });
      
              it('should execute ng-click but not reload when no href but name specified', function() {
                element(by.id('link-5')).click();
                expect(element(by.model('value')).getAttribute('value')).toEqual('5');
                expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
              });
      
              it('should only change url when only ng-href', function() {
                element(by.model('value')).clear();
                element(by.model('value')).sendKeys('6');
                expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
      
                element(by.id('link-6')).click();
      
                // At this point, we navigate away from an Angular page, so we need
                // to use browser.driver to get the base webdriver.
                browser.wait(function() {
                  return browser.driver.getCurrentUrl().then(function(url) {
                    return url.match(/\/6$/);
                  });
                }, 5000, 'page should navigate to /6');
              });
            </file>
          </example>
       */

      /**
       * @ngdoc directive
       * @name ngSrc
       * @restrict A
       * @priority 99
       *
       * @description
       * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
       * work right: The browser will fetch from the URL with the literal
       * text `{{hash}}` until Angular replaces the expression inside
       * `{{hash}}`. The `ngSrc` directive solves this problem.
       *
       * The buggy way to write it:
       * ```html
       * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
       * ```
       *
       * The correct way to write it:
       * ```html
       * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
       * ```
       *
       * @element IMG
       * @param {template} ngSrc any string which can contain `{{}}` markup.
       */

      /**
       * @ngdoc directive
       * @name ngSrcset
       * @restrict A
       * @priority 99
       *
       * @description
       * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
       * work right: The browser will fetch from the URL with the literal
       * text `{{hash}}` until Angular replaces the expression inside
       * `{{hash}}`. The `ngSrcset` directive solves this problem.
       *
       * The buggy way to write it:
       * ```html
       * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
       * ```
       *
       * The correct way to write it:
       * ```html
       * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
       * ```
       *
       * @element IMG
       * @param {template} ngSrcset any string which can contain `{{}}` markup.
       */

      /**
       * @ngdoc directive
       * @name ngDisabled
       * @restrict A
       * @priority 100
       *
       * @description
       *
       * This directive sets the `disabled` attribute on the element if the
       * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
       *
       * A special directive is necessary because we cannot use interpolation inside the `disabled`
       * attribute. See the {@link guide/interpolation interpolation guide} for more info.
       *
       * @example
          <example>
            <file name="index.html">
              <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
              <button ng-model="button" ng-disabled="checked">Button</button>
            </file>
            <file name="protractor.js" type="protractor">
              it('should toggle button', function() {
                expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
                element(by.model('checked')).click();
                expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
              });
            </file>
          </example>
       *
       * @element INPUT
       * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
       *     then the `disabled` attribute will be set on the element
       */

      /**
       * @ngdoc directive
       * @name ngChecked
       * @restrict A
       * @priority 100
       *
       * @description
       * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
       *
       * Note that this directive should not be used together with {@link ngModel `ngModel`},
       * as this can lead to unexpected behavior.
       *
       * A special directive is necessary because we cannot use interpolation inside the `checked`
       * attribute. See the {@link guide/interpolation interpolation guide} for more info.
       *
       * @example
          <example>
            <file name="index.html">
              <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
              <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
            </file>
            <file name="protractor.js" type="protractor">
              it('should check both checkBoxes', function() {
                expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
                element(by.model('master')).click();
                expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
              });
            </file>
          </example>
       *
       * @element INPUT
       * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
       *     then the `checked` attribute will be set on the element
       */

      /**
       * @ngdoc directive
       * @name ngReadonly
       * @restrict A
       * @priority 100
       *
       * @description
       *
       * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
       * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
       * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
       *
       * A special directive is necessary because we cannot use interpolation inside the `readonly`
       * attribute. See the {@link guide/interpolation interpolation guide} for more info.
       *
       * @example
          <example>
            <file name="index.html">
              <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
              <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
            </file>
            <file name="protractor.js" type="protractor">
              it('should toggle readonly attr', function() {
                expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
                element(by.model('checked')).click();
                expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
              });
            </file>
          </example>
       *
       * @element INPUT
       * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
       *     then special attribute "readonly" will be set on the element
       */

      /**
       * @ngdoc directive
       * @name ngSelected
       * @restrict A
       * @priority 100
       *
       * @description
       *
       * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
       *
       * A special directive is necessary because we cannot use interpolation inside the `selected`
       * attribute. See the {@link guide/interpolation interpolation guide} for more info.
       *
       * <div class="alert alert-warning">
       *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
       *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
       *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
       *   selected options.
       * </div>
       *
       * @example
          <example>
            <file name="index.html">
              <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
              <select aria-label="ngSelected demo">
                <option>Hello!</option>
                <option id="greet" ng-selected="selected">Greetings!</option>
              </select>
            </file>
            <file name="protractor.js" type="protractor">
              it('should select Greetings!', function() {
                expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
                element(by.model('selected')).click();
                expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
              });
            </file>
          </example>
       *
       * @element OPTION
       * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
       *     then special attribute "selected" will be set on the element
       */

      /**
       * @ngdoc directive
       * @name ngOpen
       * @restrict A
       * @priority 100
       *
       * @description
       *
       * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
       *
       * A special directive is necessary because we cannot use interpolation inside the `open`
       * attribute. See the {@link guide/interpolation interpolation guide} for more info.
       *
       * ## A note about browser compatibility
       *
       * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
       * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
       *
       * @example
           <example>
             <file name="index.html">
               <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
               <details id="details" ng-open="open">
                  <summary>Show/Hide me</summary>
               </details>
             </file>
             <file name="protractor.js" type="protractor">
               it('should toggle open', function() {
                 expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
                 element(by.model('open')).click();
                 expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
               });
             </file>
           </example>
       *
       * @element DETAILS
       * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
       *     then special attribute "open" will be set on the element
       */

      var ngAttributeAliasDirectives = {};

      // boolean attrs are evaluated
      forEach(BOOLEAN_ATTR, function (propName, attrName) {
        // binding to multiple is not supported
        if (propName == "multiple") return;

        function defaultLinkFn(scope, element, attr) {
          scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
            attr.$set(attrName, !!value);
          });
        }

        var normalized = directiveNormalize('ng-' + attrName);
        var linkFn = defaultLinkFn;

        if (propName === 'checked') {
          linkFn = function (scope, element, attr) {
            // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
            if (attr.ngModel !== attr[normalized]) {
              defaultLinkFn(scope, element, attr);
            }
          };
        }

        ngAttributeAliasDirectives[normalized] = function () {
          return {
            restrict: 'A',
            priority: 100,
            link: linkFn
          };
        };
      });

      // aliased input attrs are evaluated
      forEach(ALIASED_ATTR, function (htmlAttr, ngAttr) {
        ngAttributeAliasDirectives[ngAttr] = function () {
          return {
            priority: 100,
            link: function (scope, element, attr) {
              //special case ngPattern when a literal regular expression value
              //is used as the expression (this way we don't have to watch anything).
              if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
                var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
                if (match) {
                  attr.$set("ngPattern", new RegExp(match[1], match[2]));
                  return;
                }
              }

              scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
                attr.$set(ngAttr, value);
              });
            }
          };
        };
      });

      // ng-src, ng-srcset, ng-href are interpolated
      forEach(['src', 'srcset', 'href'], function (attrName) {
        var normalized = directiveNormalize('ng-' + attrName);
        ngAttributeAliasDirectives[normalized] = function () {
          return {
            priority: 99, // it needs to run after the attributes are interpolated
            link: function (scope, element, attr) {
              var propName = attrName,
                  name = attrName;

              if (attrName === 'href' && toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
                name = 'xlinkHref';
                attr.$attr[name] = 'xlink:href';
                propName = null;
              }

              attr.$observe(normalized, function (value) {
                if (!value) {
                  if (attrName === 'href') {
                    attr.$set(name, null);
                  }
                  return;
                }

                attr.$set(name, value);

                // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
                // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
                // to set the property as well to achieve the desired effect.
                // we use attr[attrName] value since $set can sanitize the url.
                if (msie && propName) element.prop(propName, attr[name]);
              });
            }
          };
        };
      });

      /* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
       */
      var nullFormCtrl = {
        $addControl: noop,
        $$renameControl: nullFormRenameControl,
        $removeControl: noop,
        $setValidity: noop,
        $setDirty: noop,
        $setPristine: noop,
        $setSubmitted: noop
      },
          SUBMITTED_CLASS = 'ng-submitted';

      function nullFormRenameControl(control, name) {
        control.$name = name;
      }

      /**
       * @ngdoc type
       * @name form.FormController
       *
       * @property {boolean} $pristine True if user has not interacted with the form yet.
       * @property {boolean} $dirty True if user has already interacted with the form.
       * @property {boolean} $valid True if all of the containing forms and controls are valid.
       * @property {boolean} $invalid True if at least one containing control or form is invalid.
       * @property {boolean} $pending True if at least one containing control or form is pending.
       * @property {boolean} $submitted True if user has submitted the form even if its invalid.
       *
       * @property {Object} $error Is an object hash, containing references to controls or
       *  forms with failing validators, where:
       *
       *  - keys are validation tokens (error names),
       *  - values are arrays of controls or forms that have a failing validator for given error name.
       *
       *  Built-in validation tokens:
       *
       *  - `email`
       *  - `max`
       *  - `maxlength`
       *  - `min`
       *  - `minlength`
       *  - `number`
       *  - `pattern`
       *  - `required`
       *  - `url`
       *  - `date`
       *  - `datetimelocal`
       *  - `time`
       *  - `week`
       *  - `month`
       *
       * @description
       * `FormController` keeps track of all its controls and nested forms as well as the state of them,
       * such as being valid/invalid or dirty/pristine.
       *
       * Each {@link ng.directive:form form} directive creates an instance
       * of `FormController`.
       *
       */
      //asks for $scope to fool the BC controller module
      FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
      function FormController(element, attrs, $scope, $animate, $interpolate) {
        var form = this,
            controls = [];

        // init state
        form.$error = {};
        form.$$success = {};
        form.$pending = undefined;
        form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
        form.$dirty = false;
        form.$pristine = true;
        form.$valid = true;
        form.$invalid = false;
        form.$submitted = false;
        form.$$parentForm = nullFormCtrl;

        /**
         * @ngdoc method
         * @name form.FormController#$rollbackViewValue
         *
         * @description
         * Rollback all form controls pending updates to the `$modelValue`.
         *
         * Updates may be pending by a debounced event or because the input is waiting for a some future
         * event defined in `ng-model-options`. This method is typically needed by the reset button of
         * a form that uses `ng-model-options` to pend updates.
         */
        form.$rollbackViewValue = function () {
          forEach(controls, function (control) {
            control.$rollbackViewValue();
          });
        };

        /**
         * @ngdoc method
         * @name form.FormController#$commitViewValue
         *
         * @description
         * Commit all form controls pending updates to the `$modelValue`.
         *
         * Updates may be pending by a debounced event or because the input is waiting for a some future
         * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
         * usually handles calling this in response to input events.
         */
        form.$commitViewValue = function () {
          forEach(controls, function (control) {
            control.$commitViewValue();
          });
        };

        /**
         * @ngdoc method
         * @name form.FormController#$addControl
         * @param {object} control control object, either a {@link form.FormController} or an
         * {@link ngModel.NgModelController}
         *
         * @description
         * Register a control with the form. Input elements using ngModelController do this automatically
         * when they are linked.
         *
         * Note that the current state of the control will not be reflected on the new parent form. This
         * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
         * state.
         *
         * However, if the method is used programmatically, for example by adding dynamically created controls,
         * or controls that have been previously removed without destroying their corresponding DOM element,
         * it's the developers responsibility to make sure the current state propagates to the parent form.
         *
         * For example, if an input control is added that is already `$dirty` and has `$error` properties,
         * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
         */
        form.$addControl = function (control) {
          // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
          // and not added to the scope.  Now we throw an error.
          assertNotHasOwnProperty(control.$name, 'input');
          controls.push(control);

          if (control.$name) {
            form[control.$name] = control;
          }

          control.$$parentForm = form;
        };

        // Private API: rename a form control
        form.$$renameControl = function (control, newName) {
          var oldName = control.$name;

          if (form[oldName] === control) {
            delete form[oldName];
          }
          form[newName] = control;
          control.$name = newName;
        };

        /**
         * @ngdoc method
         * @name form.FormController#$removeControl
         * @param {object} control control object, either a {@link form.FormController} or an
         * {@link ngModel.NgModelController}
         *
         * @description
         * Deregister a control from the form.
         *
         * Input elements using ngModelController do this automatically when they are destroyed.
         *
         * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
         * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
         * different from case to case. For example, removing the only `$dirty` control from a form may or
         * may not mean that the form is still `$dirty`.
         */
        form.$removeControl = function (control) {
          if (control.$name && form[control.$name] === control) {
            delete form[control.$name];
          }
          forEach(form.$pending, function (value, name) {
            form.$setValidity(name, null, control);
          });
          forEach(form.$error, function (value, name) {
            form.$setValidity(name, null, control);
          });
          forEach(form.$$success, function (value, name) {
            form.$setValidity(name, null, control);
          });

          arrayRemove(controls, control);
          control.$$parentForm = nullFormCtrl;
        };

        /**
         * @ngdoc method
         * @name form.FormController#$setValidity
         *
         * @description
         * Sets the validity of a form control.
         *
         * This method will also propagate to parent forms.
         */
        addSetValidityMethod({
          ctrl: this,
          $element: element,
          set: function (object, property, controller) {
            var list = object[property];
            if (!list) {
              object[property] = [controller];
            } else {
              var index = list.indexOf(controller);
              if (index === -1) {
                list.push(controller);
              }
            }
          },
          unset: function (object, property, controller) {
            var list = object[property];
            if (!list) {
              return;
            }
            arrayRemove(list, controller);
            if (list.length === 0) {
              delete object[property];
            }
          },
          $animate: $animate
        });

        /**
         * @ngdoc method
         * @name form.FormController#$setDirty
         *
         * @description
         * Sets the form to a dirty state.
         *
         * This method can be called to add the 'ng-dirty' class and set the form to a dirty
         * state (ng-dirty class). This method will also propagate to parent forms.
         */
        form.$setDirty = function () {
          $animate.removeClass(element, PRISTINE_CLASS);
          $animate.addClass(element, DIRTY_CLASS);
          form.$dirty = true;
          form.$pristine = false;
          form.$$parentForm.$setDirty();
        };

        /**
         * @ngdoc method
         * @name form.FormController#$setPristine
         *
         * @description
         * Sets the form to its pristine state.
         *
         * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
         * state (ng-pristine class). This method will also propagate to all the controls contained
         * in this form.
         *
         * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
         * saving or resetting it.
         */
        form.$setPristine = function () {
          $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
          form.$dirty = false;
          form.$pristine = true;
          form.$submitted = false;
          forEach(controls, function (control) {
            control.$setPristine();
          });
        };

        /**
         * @ngdoc method
         * @name form.FormController#$setUntouched
         *
         * @description
         * Sets the form to its untouched state.
         *
         * This method can be called to remove the 'ng-touched' class and set the form controls to their
         * untouched state (ng-untouched class).
         *
         * Setting a form controls back to their untouched state is often useful when setting the form
         * back to its pristine state.
         */
        form.$setUntouched = function () {
          forEach(controls, function (control) {
            control.$setUntouched();
          });
        };

        /**
         * @ngdoc method
         * @name form.FormController#$setSubmitted
         *
         * @description
         * Sets the form to its submitted state.
         */
        form.$setSubmitted = function () {
          $animate.addClass(element, SUBMITTED_CLASS);
          form.$submitted = true;
          form.$$parentForm.$setSubmitted();
        };
      }

      /**
       * @ngdoc directive
       * @name ngForm
       * @restrict EAC
       *
       * @description
       * Nestable alias of {@link ng.directive:form `form`} directive. HTML
       * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
       * sub-group of controls needs to be determined.
       *
       * Note: the purpose of `ngForm` is to group controls,
       * but not to be a replacement for the `<form>` tag with all of its capabilities
       * (e.g. posting to the server, ...).
       *
       * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
       *                       related scope, under this name.
       *
       */

      /**
      * @ngdoc directive
      * @name form
      * @restrict E
      *
      * @description
      * Directive that instantiates
      * {@link form.FormController FormController}.
      *
      * If the `name` attribute is specified, the form controller is published onto the current scope under
      * this name.
      *
      * # Alias: {@link ng.directive:ngForm `ngForm`}
      *
      * In Angular, forms can be nested. This means that the outer form is valid when all of the child
      * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
      * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
      * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
      * of controls needs to be determined.
      *
      * # CSS classes
      *  - `ng-valid` is set if the form is valid.
      *  - `ng-invalid` is set if the form is invalid.
      *  - `ng-pending` is set if the form is pending.
      *  - `ng-pristine` is set if the form is pristine.
      *  - `ng-dirty` is set if the form is dirty.
      *  - `ng-submitted` is set if the form was submitted.
      *
      * Keep in mind that ngAnimate can detect each of these classes when added and removed.
      *
      *
      * # Submitting a form and preventing the default action
      *
      * Since the role of forms in client-side Angular applications is different than in classical
      * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
      * page reload that sends the data to the server. Instead some javascript logic should be triggered
      * to handle the form submission in an application-specific way.
      *
      * For this reason, Angular prevents the default action (form submission to the server) unless the
      * `<form>` element has an `action` attribute specified.
      *
      * You can use one of the following two ways to specify what javascript method should be called when
      * a form is submitted:
      *
      * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
      * - {@link ng.directive:ngClick ngClick} directive on the first
       *  button or input field of type submit (input[type=submit])
      *
      * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
      * or {@link ng.directive:ngClick ngClick} directives.
      * This is because of the following form submission rules in the HTML specification:
      *
      * - If a form has only one input field then hitting enter in this field triggers form submit
      * (`ngSubmit`)
      * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
      * doesn't trigger submit
      * - if a form has one or more input fields and one or more buttons or input[type=submit] then
      * hitting enter in any of the input fields will trigger the click handler on the *first* button or
      * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
      *
      * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
      * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
      * to have access to the updated model.
      *
      * ## Animation Hooks
      *
      * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
      * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
      * other validations that are performed within the form. Animations in ngForm are similar to how
      * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
      * as JS animations.
      *
      * The following example shows a simple way to utilize CSS transitions to style a form element
      * that has been rendered as invalid after it has been validated:
      *
      * <pre>
      * //be sure to include ngAnimate as a module to hook into more
      * //advanced animations
      * .my-form {
      *   transition:0.5s linear all;
      *   background: white;
      * }
      * .my-form.ng-invalid {
      *   background: red;
      *   color:white;
      * }
      * </pre>
      *
      * @example
         <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
           <file name="index.html">
            <script>
              angular.module('formExample', [])
                .controller('FormController', ['$scope', function($scope) {
                  $scope.userType = 'guest';
                }]);
            </script>
            <style>
             .my-form {
               transition:all linear 0.5s;
               background: transparent;
             }
             .my-form.ng-invalid {
               background: red;
             }
            </style>
            <form name="myForm" ng-controller="FormController" class="my-form">
              userType: <input name="input" ng-model="userType" required>
              <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
              <code>userType = {{userType}}</code><br>
              <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
              <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
              <code>myForm.$valid = {{myForm.$valid}}</code><br>
              <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
             </form>
           </file>
           <file name="protractor.js" type="protractor">
             it('should initialize to model', function() {
               var userType = element(by.binding('userType'));
               var valid = element(by.binding('myForm.input.$valid'));
                expect(userType.getText()).toContain('guest');
               expect(valid.getText()).toContain('true');
             });
              it('should be invalid if empty', function() {
               var userType = element(by.binding('userType'));
               var valid = element(by.binding('myForm.input.$valid'));
               var userInput = element(by.model('userType'));
                userInput.clear();
               userInput.sendKeys('');
                expect(userType.getText()).toEqual('userType =');
               expect(valid.getText()).toContain('false');
             });
           </file>
         </example>
      *
      * @param {string=} name Name of the form. If specified, the form controller will be published into
      *                       related scope, under this name.
      */
      var formDirectiveFactory = function (isNgForm) {
        return ['$timeout', '$parse', function ($timeout, $parse) {
          var formDirective = {
            name: 'form',
            restrict: isNgForm ? 'EAC' : 'E',
            require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
            controller: FormController,
            compile: function ngFormCompile(formElement, attr) {
              // Setup initial state of the control
              formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

              var nameAttr = attr.name ? 'name' : isNgForm && attr.ngForm ? 'ngForm' : false;

              return {
                pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
                  var controller = ctrls[0];

                  // if `action` attr is not present on the form, prevent the default action (submission)
                  if (!('action' in attr)) {
                    // we can't use jq events because if a form is destroyed during submission the default
                    // action is not prevented. see #1238
                    //
                    // IE 9 is not affected because it doesn't fire a submit event and try to do a full
                    // page reload if the form was destroyed by submission of the form via a click handler
                    // on a button in the form. Looks like an IE9 specific bug.
                    var handleFormSubmission = function (event) {
                      scope.$apply(function () {
                        controller.$commitViewValue();
                        controller.$setSubmitted();
                      });

                      event.preventDefault();
                    };

                    addEventListenerFn(formElement[0], 'submit', handleFormSubmission);

                    // unregister the preventDefault listener so that we don't not leak memory but in a
                    // way that will achieve the prevention of the default action.
                    formElement.on('$destroy', function () {
                      $timeout(function () {
                        removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
                      }, 0, false);
                    });
                  }

                  var parentFormCtrl = ctrls[1] || controller.$$parentForm;
                  parentFormCtrl.$addControl(controller);

                  var setter = nameAttr ? getSetter(controller.$name) : noop;

                  if (nameAttr) {
                    setter(scope, controller);
                    attr.$observe(nameAttr, function (newValue) {
                      if (controller.$name === newValue) return;
                      setter(scope, undefined);
                      controller.$$parentForm.$$renameControl(controller, newValue);
                      setter = getSetter(controller.$name);
                      setter(scope, controller);
                    });
                  }
                  formElement.on('$destroy', function () {
                    controller.$$parentForm.$removeControl(controller);
                    setter(scope, undefined);
                    extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
                  });
                }
              };
            }
          };

          return formDirective;

          function getSetter(expression) {
            if (expression === '') {
              //create an assignable expression, so forms with an empty name can be renamed later
              return $parse('this[""]').assign;
            }
            return $parse(expression).assign || noop;
          }
        }];
      };

      var formDirective = formDirectiveFactory();
      var ngFormDirective = formDirectiveFactory(true);

      /* global VALID_CLASS: false,
        INVALID_CLASS: false,
        PRISTINE_CLASS: false,
        DIRTY_CLASS: false,
        UNTOUCHED_CLASS: false,
        TOUCHED_CLASS: false,
        ngModelMinErr: false,
      */

      // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
      var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
      // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
      // Note: We are being more lenient, because browsers are too.
      //   1. Scheme
      //   2. Slashes
      //   3. Username
      //   4. Password
      //   5. Hostname
      //   6. Port
      //   7. Path
      //   8. Query
      //   9. Fragment
      //                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
      var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
      /* jshint maxlen:220 */
      var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
      /* jshint maxlen:200 */
      var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
      var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
      var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
      var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
      var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
      var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

      var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
      var PARTIAL_VALIDATION_TYPES = createMap();
      forEach('date,datetime-local,month,time,week'.split(','), function (type) {
        PARTIAL_VALIDATION_TYPES[type] = true;
      });

      var inputType = {

        /**
         * @ngdoc input
         * @name input[text]
         *
         * @description
         * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
         *
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} required Adds `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
         *    minlength.
         * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
         *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
         *    any length.
         * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
         *    that contains the regular expression body that will be converted to a regular expression
         *    as in the ngPattern directive.
         * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
         *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
         *    If the expression evaluates to a RegExp object, then this is used directly.
         *    If the expression evaluates to a string, then it will be converted to a RegExp
         *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
         *    `new RegExp('^abc$')`.<br />
         *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
         *    start at the index of the last search's match, thus not taking the whole input value into
         *    account.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
         *    This parameter is ignored for input[type=password] controls, which will never trim the
         *    input.
         *
         * @example
            <example name="text-input-directive" module="textInputExample">
              <file name="index.html">
               <script>
                 angular.module('textInputExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.example = {
                       text: 'guest',
                       word: /^\s*\w*\s*$/
                     };
                   }]);
               </script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>Single word:
                   <input type="text" name="input" ng-model="example.text"
                          ng-pattern="example.word" required ng-trim="false">
                 </label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.input.$error.required">
                     Required!</span>
                   <span class="error" ng-show="myForm.input.$error.pattern">
                     Single word only!</span>
                 </div>
                 <code>text = {{example.text}}</code><br/>
                 <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
                 <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
                 <code>myForm.$valid = {{myForm.$valid}}</code><br/>
                 <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
                </form>
              </file>
              <file name="protractor.js" type="protractor">
                var text = element(by.binding('example.text'));
                var valid = element(by.binding('myForm.input.$valid'));
                var input = element(by.model('example.text'));
                 it('should initialize to model', function() {
                  expect(text.getText()).toContain('guest');
                  expect(valid.getText()).toContain('true');
                });
                 it('should be invalid if empty', function() {
                  input.clear();
                  input.sendKeys('');
                   expect(text.getText()).toEqual('text =');
                  expect(valid.getText()).toContain('false');
                });
                 it('should be invalid if multi word', function() {
                  input.clear();
                  input.sendKeys('hello world');
                   expect(valid.getText()).toContain('false');
                });
              </file>
            </example>
         */
        'text': textInputType,

        /**
         * @ngdoc input
         * @name input[date]
         *
         * @description
         * Input with date validation and transformation. In browsers that do not yet support
         * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
         * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
         * modern browsers do not yet support this input type, it is important to provide cues to users on the
         * expected input format via a placeholder or label.
         *
         * The model must always be a Date object, otherwise Angular will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
         *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
         *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
         *   constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
         *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
         *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
         *   constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
         *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
         *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="date-input-directive" module="dateInputExample">
         <file name="index.html">
           <script>
              angular.module('dateInputExample', [])
                .controller('DateController', ['$scope', function($scope) {
                  $scope.example = {
                    value: new Date(2013, 9, 22)
                  };
                }]);
           </script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
              <label for="exampleInput">Pick a date in 2013:</label>
              <input type="date" id="exampleInput" name="input" ng-model="example.value"
                  placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
              <div role="alert">
                <span class="error" ng-show="myForm.input.$error.required">
                    Required!</span>
                <span class="error" ng-show="myForm.input.$error.date">
                    Not a valid date!</span>
               </div>
               <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.value'));
             // currently protractor/webdriver does not support
            // sending keys to all known HTML5 input controls
            // for various browsers (see https://github.com/angular/protractor/issues/562).
            function setInput(val) {
              // set the value of the element and force validation.
              var scr = "var ipt = document.getElementById('exampleInput'); " +
              "ipt.value = '" + val + "';" +
              "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
              browser.executeScript(scr);
            }
             it('should initialize to model', function() {
              expect(value.getText()).toContain('2013-10-22');
              expect(valid.getText()).toContain('myForm.input.$valid = true');
            });
             it('should be invalid if empty', function() {
              setInput('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
             it('should be invalid if over max', function() {
              setInput('2015-01-01');
              expect(value.getText()).toContain('');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
         </file>
         </example>
         */
        'date': createDateInputType('date', DATE_REGEXP, createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']), 'yyyy-MM-dd'),

        /**
         * @ngdoc input
         * @name input[datetime-local]
         *
         * @description
         * Input with datetime validation and transformation. In browsers that do not yet support
         * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
         * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
         *
         * The model must always be a Date object, otherwise Angular will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
         *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
         *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
         *   Note that `min` will also add native HTML5 constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
         *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
         *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
         *   Note that `max` will also add native HTML5 constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
         *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
         *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="datetimelocal-input-directive" module="dateExample">
         <file name="index.html">
           <script>
             angular.module('dateExample', [])
               .controller('DateController', ['$scope', function($scope) {
                 $scope.example = {
                   value: new Date(2010, 11, 28, 14, 57)
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
             <label for="exampleInput">Pick a date between in 2013:</label>
             <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
                 placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
               <span class="error" ng-show="myForm.input.$error.datetimelocal">
                   Not a valid date!</span>
             </div>
             <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
           var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
           var valid = element(by.binding('myForm.input.$valid'));
           var input = element(by.model('example.value'));
            // currently protractor/webdriver does not support
           // sending keys to all known HTML5 input controls
           // for various browsers (https://github.com/angular/protractor/issues/562).
           function setInput(val) {
             // set the value of the element and force validation.
             var scr = "var ipt = document.getElementById('exampleInput'); " +
             "ipt.value = '" + val + "';" +
             "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
             browser.executeScript(scr);
           }
            it('should initialize to model', function() {
             expect(value.getText()).toContain('2010-12-28T14:57:00');
             expect(valid.getText()).toContain('myForm.input.$valid = true');
           });
            it('should be invalid if empty', function() {
             setInput('');
             expect(value.getText()).toEqual('value =');
             expect(valid.getText()).toContain('myForm.input.$valid = false');
           });
            it('should be invalid if over max', function() {
             setInput('2015-01-01T23:59:00');
             expect(value.getText()).toContain('');
             expect(valid.getText()).toContain('myForm.input.$valid = false');
           });
         </file>
         </example>
         */
        'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']), 'yyyy-MM-ddTHH:mm:ss.sss'),

        /**
         * @ngdoc input
         * @name input[time]
         *
         * @description
         * Input with time validation and transformation. In browsers that do not yet support
         * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
         * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
         * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
         *
         * The model must always be a Date object, otherwise Angular will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
         *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
         *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
         *   native HTML5 constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
         *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
         *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
         *   native HTML5 constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
         *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
         *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="time-input-directive" module="timeExample">
         <file name="index.html">
           <script>
            angular.module('timeExample', [])
              .controller('DateController', ['$scope', function($scope) {
                $scope.example = {
                  value: new Date(1970, 0, 1, 14, 57, 0)
                };
              }]);
           </script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
              <label for="exampleInput">Pick a time between 8am and 5pm:</label>
              <input type="time" id="exampleInput" name="input" ng-model="example.value"
                  placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
              <div role="alert">
                <span class="error" ng-show="myForm.input.$error.required">
                    Required!</span>
                <span class="error" ng-show="myForm.input.$error.time">
                    Not a valid date!</span>
              </div>
              <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
              <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
              <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
              <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
              <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value | date: "HH:mm:ss"'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.value'));
             // currently protractor/webdriver does not support
            // sending keys to all known HTML5 input controls
            // for various browsers (https://github.com/angular/protractor/issues/562).
            function setInput(val) {
              // set the value of the element and force validation.
              var scr = "var ipt = document.getElementById('exampleInput'); " +
              "ipt.value = '" + val + "';" +
              "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
              browser.executeScript(scr);
            }
             it('should initialize to model', function() {
              expect(value.getText()).toContain('14:57:00');
              expect(valid.getText()).toContain('myForm.input.$valid = true');
            });
             it('should be invalid if empty', function() {
              setInput('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
             it('should be invalid if over max', function() {
              setInput('23:59:00');
              expect(value.getText()).toContain('');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
         </file>
         </example>
         */
        'time': createDateInputType('time', TIME_REGEXP, createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']), 'HH:mm:ss.sss'),

        /**
         * @ngdoc input
         * @name input[week]
         *
         * @description
         * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
         * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
         * week format (yyyy-W##), for example: `2013-W02`.
         *
         * The model must always be a Date object, otherwise Angular will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
         *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
         *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
         *   native HTML5 constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
         *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
         *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
         *   native HTML5 constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
         *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
         *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="week-input-directive" module="weekExample">
         <file name="index.html">
           <script>
           angular.module('weekExample', [])
             .controller('DateController', ['$scope', function($scope) {
               $scope.example = {
                 value: new Date(2013, 0, 3)
               };
             }]);
           </script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
             <label>Pick a date between in 2013:
               <input id="exampleInput" type="week" name="input" ng-model="example.value"
                      placeholder="YYYY-W##" min="2012-W32"
                      max="2013-W52" required />
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
               <span class="error" ng-show="myForm.input.$error.week">
                   Not a valid date!</span>
             </div>
             <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
           var value = element(by.binding('example.value | date: "yyyy-Www"'));
           var valid = element(by.binding('myForm.input.$valid'));
           var input = element(by.model('example.value'));
            // currently protractor/webdriver does not support
           // sending keys to all known HTML5 input controls
           // for various browsers (https://github.com/angular/protractor/issues/562).
           function setInput(val) {
             // set the value of the element and force validation.
             var scr = "var ipt = document.getElementById('exampleInput'); " +
             "ipt.value = '" + val + "';" +
             "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
             browser.executeScript(scr);
           }
            it('should initialize to model', function() {
             expect(value.getText()).toContain('2013-W01');
             expect(valid.getText()).toContain('myForm.input.$valid = true');
           });
            it('should be invalid if empty', function() {
             setInput('');
             expect(value.getText()).toEqual('value =');
             expect(valid.getText()).toContain('myForm.input.$valid = false');
           });
            it('should be invalid if over max', function() {
             setInput('2015-W01');
             expect(value.getText()).toContain('');
             expect(valid.getText()).toContain('myForm.input.$valid = false');
           });
         </file>
         </example>
         */
        'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

        /**
         * @ngdoc input
         * @name input[month]
         *
         * @description
         * Input with month validation and transformation. In browsers that do not yet support
         * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
         * month format (yyyy-MM), for example: `2009-01`.
         *
         * The model must always be a Date object, otherwise Angular will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         * If the model is not set to the first of the month, the next view to model update will set it
         * to the first of the month.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
         *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
         *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
         *   native HTML5 constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
         *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
         *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
         *   native HTML5 constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
         *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
         *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
          * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="month-input-directive" module="monthExample">
         <file name="index.html">
           <script>
            angular.module('monthExample', [])
              .controller('DateController', ['$scope', function($scope) {
                $scope.example = {
                  value: new Date(2013, 9, 1)
                };
              }]);
           </script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
             <label for="exampleInput">Pick a month in 2013:</label>
             <input id="exampleInput" type="month" name="input" ng-model="example.value"
                placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                  Required!</span>
               <span class="error" ng-show="myForm.input.$error.month">
                  Not a valid month!</span>
             </div>
             <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value | date: "yyyy-MM"'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.value'));
             // currently protractor/webdriver does not support
            // sending keys to all known HTML5 input controls
            // for various browsers (https://github.com/angular/protractor/issues/562).
            function setInput(val) {
              // set the value of the element and force validation.
              var scr = "var ipt = document.getElementById('exampleInput'); " +
              "ipt.value = '" + val + "';" +
              "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
              browser.executeScript(scr);
            }
             it('should initialize to model', function() {
              expect(value.getText()).toContain('2013-10');
              expect(valid.getText()).toContain('myForm.input.$valid = true');
            });
             it('should be invalid if empty', function() {
              setInput('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
             it('should be invalid if over max', function() {
              setInput('2015-01');
              expect(value.getText()).toContain('');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
         </file>
         </example>
         */
        'month': createDateInputType('month', MONTH_REGEXP, createDateParser(MONTH_REGEXP, ['yyyy', 'MM']), 'yyyy-MM'),

        /**
         * @ngdoc input
         * @name input[number]
         *
         * @description
         * Text input with number validation and transformation. Sets the `number` validation
         * error if not a valid number.
         *
         * <div class="alert alert-warning">
         * The model must always be of type `number` otherwise Angular will throw an error.
         * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
         * error docs for more information and an example of how to convert your model if necessary.
         * </div>
         *
         * ## Issues with HTML5 constraint validation
         *
         * In browsers that follow the
         * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
         * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
         * If a non-number is entered in the input, the browser will report the value as an empty string,
         * which means the view / model values in `ngModel` and subsequently the scope value
         * will also be an empty string.
         *
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
         *    minlength.
         * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
         *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
         *    any length.
         * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
         *    that contains the regular expression body that will be converted to a regular expression
         *    as in the ngPattern directive.
         * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
         *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
         *    If the expression evaluates to a RegExp object, then this is used directly.
         *    If the expression evaluates to a string, then it will be converted to a RegExp
         *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
         *    `new RegExp('^abc$')`.<br />
         *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
         *    start at the index of the last search's match, thus not taking the whole input value into
         *    account.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
            <example name="number-input-directive" module="numberExample">
              <file name="index.html">
               <script>
                 angular.module('numberExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.example = {
                       value: 12
                     };
                   }]);
               </script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>Number:
                   <input type="number" name="input" ng-model="example.value"
                          min="0" max="99" required>
                </label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.input.$error.required">
                     Required!</span>
                   <span class="error" ng-show="myForm.input.$error.number">
                     Not valid number!</span>
                 </div>
                 <tt>value = {{example.value}}</tt><br/>
                 <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
                 <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
                 <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
                 <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
                </form>
              </file>
              <file name="protractor.js" type="protractor">
                var value = element(by.binding('example.value'));
                var valid = element(by.binding('myForm.input.$valid'));
                var input = element(by.model('example.value'));
                 it('should initialize to model', function() {
                  expect(value.getText()).toContain('12');
                  expect(valid.getText()).toContain('true');
                });
                 it('should be invalid if empty', function() {
                  input.clear();
                  input.sendKeys('');
                  expect(value.getText()).toEqual('value =');
                  expect(valid.getText()).toContain('false');
                });
                 it('should be invalid if over max', function() {
                  input.clear();
                  input.sendKeys('123');
                  expect(value.getText()).toEqual('value =');
                  expect(valid.getText()).toContain('false');
                });
              </file>
            </example>
         */
        'number': numberInputType,

        /**
         * @ngdoc input
         * @name input[url]
         *
         * @description
         * Text input with URL validation. Sets the `url` validation error key if the content is not a
         * valid URL.
         *
         * <div class="alert alert-warning">
         * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
         * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
         * the built-in validators (see the {@link guide/forms Forms guide})
         * </div>
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
         *    minlength.
         * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
         *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
         *    any length.
         * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
         *    that contains the regular expression body that will be converted to a regular expression
         *    as in the ngPattern directive.
         * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
         *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
         *    If the expression evaluates to a RegExp object, then this is used directly.
         *    If the expression evaluates to a string, then it will be converted to a RegExp
         *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
         *    `new RegExp('^abc$')`.<br />
         *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
         *    start at the index of the last search's match, thus not taking the whole input value into
         *    account.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
            <example name="url-input-directive" module="urlExample">
              <file name="index.html">
               <script>
                 angular.module('urlExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.url = {
                       text: 'http://google.com'
                     };
                   }]);
               </script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>URL:
                   <input type="url" name="input" ng-model="url.text" required>
                 <label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.input.$error.required">
                     Required!</span>
                   <span class="error" ng-show="myForm.input.$error.url">
                     Not valid url!</span>
                 </div>
                 <tt>text = {{url.text}}</tt><br/>
                 <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
                 <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
                 <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
                 <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
                 <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
                </form>
              </file>
              <file name="protractor.js" type="protractor">
                var text = element(by.binding('url.text'));
                var valid = element(by.binding('myForm.input.$valid'));
                var input = element(by.model('url.text'));
                 it('should initialize to model', function() {
                  expect(text.getText()).toContain('http://google.com');
                  expect(valid.getText()).toContain('true');
                });
                 it('should be invalid if empty', function() {
                  input.clear();
                  input.sendKeys('');
                   expect(text.getText()).toEqual('text =');
                  expect(valid.getText()).toContain('false');
                });
                 it('should be invalid if not url', function() {
                  input.clear();
                  input.sendKeys('box');
                   expect(valid.getText()).toContain('false');
                });
              </file>
            </example>
         */
        'url': urlInputType,

        /**
         * @ngdoc input
         * @name input[email]
         *
         * @description
         * Text input with email validation. Sets the `email` validation error key if not a valid email
         * address.
         *
         * <div class="alert alert-warning">
         * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
         * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
         * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
         * </div>
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
         *    minlength.
         * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
         *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
         *    any length.
         * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
         *    that contains the regular expression body that will be converted to a regular expression
         *    as in the ngPattern directive.
         * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
         *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
         *    If the expression evaluates to a RegExp object, then this is used directly.
         *    If the expression evaluates to a string, then it will be converted to a RegExp
         *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
         *    `new RegExp('^abc$')`.<br />
         *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
         *    start at the index of the last search's match, thus not taking the whole input value into
         *    account.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
            <example name="email-input-directive" module="emailExample">
              <file name="index.html">
               <script>
                 angular.module('emailExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.email = {
                       text: 'me@example.com'
                     };
                   }]);
               </script>
                 <form name="myForm" ng-controller="ExampleController">
                   <label>Email:
                     <input type="email" name="input" ng-model="email.text" required>
                   </label>
                   <div role="alert">
                     <span class="error" ng-show="myForm.input.$error.required">
                       Required!</span>
                     <span class="error" ng-show="myForm.input.$error.email">
                       Not valid email!</span>
                   </div>
                   <tt>text = {{email.text}}</tt><br/>
                   <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
                   <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
                   <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
                   <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
                   <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
                 </form>
               </file>
              <file name="protractor.js" type="protractor">
                var text = element(by.binding('email.text'));
                var valid = element(by.binding('myForm.input.$valid'));
                var input = element(by.model('email.text'));
                 it('should initialize to model', function() {
                  expect(text.getText()).toContain('me@example.com');
                  expect(valid.getText()).toContain('true');
                });
                 it('should be invalid if empty', function() {
                  input.clear();
                  input.sendKeys('');
                  expect(text.getText()).toEqual('text =');
                  expect(valid.getText()).toContain('false');
                });
                 it('should be invalid if not email', function() {
                  input.clear();
                  input.sendKeys('xxx');
                   expect(valid.getText()).toContain('false');
                });
              </file>
            </example>
         */
        'email': emailInputType,

        /**
         * @ngdoc input
         * @name input[radio]
         *
         * @description
         * HTML radio button.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string} value The value to which the `ngModel` expression should be set when selected.
         *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
         *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
         *    is selected. Should be used instead of the `value` attribute if you need
         *    a non-string `ngModel` (`boolean`, `array`, ...).
         *
         * @example
            <example name="radio-input-directive" module="radioExample">
              <file name="index.html">
               <script>
                 angular.module('radioExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.color = {
                       name: 'blue'
                     };
                     $scope.specialValue = {
                       "id": "12345",
                       "value": "green"
                     };
                   }]);
               </script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>
                   <input type="radio" ng-model="color.name" value="red">
                   Red
                 </label><br/>
                 <label>
                   <input type="radio" ng-model="color.name" ng-value="specialValue">
                   Green
                 </label><br/>
                 <label>
                   <input type="radio" ng-model="color.name" value="blue">
                   Blue
                 </label><br/>
                 <tt>color = {{color.name | json}}</tt><br/>
                </form>
                Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
              </file>
              <file name="protractor.js" type="protractor">
                it('should change state', function() {
                  var color = element(by.binding('color.name'));
                   expect(color.getText()).toContain('blue');
                   element.all(by.model('color.name')).get(0).click();
                   expect(color.getText()).toContain('red');
                });
              </file>
            </example>
         */
        'radio': radioInputType,

        /**
         * @ngdoc input
         * @name input[checkbox]
         *
         * @description
         * HTML checkbox.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
         * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
            <example name="checkbox-input-directive" module="checkboxExample">
              <file name="index.html">
               <script>
                 angular.module('checkboxExample', [])
                   .controller('ExampleController', ['$scope', function($scope) {
                     $scope.checkboxModel = {
                      value1 : true,
                      value2 : 'YES'
                    };
                   }]);
               </script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>Value1:
                   <input type="checkbox" ng-model="checkboxModel.value1">
                 </label><br/>
                 <label>Value2:
                   <input type="checkbox" ng-model="checkboxModel.value2"
                          ng-true-value="'YES'" ng-false-value="'NO'">
                  </label><br/>
                 <tt>value1 = {{checkboxModel.value1}}</tt><br/>
                 <tt>value2 = {{checkboxModel.value2}}</tt><br/>
                </form>
              </file>
              <file name="protractor.js" type="protractor">
                it('should change state', function() {
                  var value1 = element(by.binding('checkboxModel.value1'));
                  var value2 = element(by.binding('checkboxModel.value2'));
                   expect(value1.getText()).toContain('true');
                  expect(value2.getText()).toContain('YES');
                   element(by.model('checkboxModel.value1')).click();
                  element(by.model('checkboxModel.value2')).click();
                   expect(value1.getText()).toContain('false');
                  expect(value2.getText()).toContain('NO');
                });
              </file>
            </example>
         */
        'checkbox': checkboxInputType,

        'hidden': noop,
        'button': noop,
        'submit': noop,
        'reset': noop,
        'file': noop
      };

      function stringBasedInputType(ctrl) {
        ctrl.$formatters.push(function (value) {
          return ctrl.$isEmpty(value) ? value : value.toString();
        });
      }

      function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
      }

      function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        var type = lowercase(element[0].type);

        // In composition mode, users are still inputing intermediate text buffer,
        // hold the listener until composition is done.
        // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
        if (!$sniffer.android) {
          var composing = false;

          element.on('compositionstart', function () {
            composing = true;
          });

          element.on('compositionend', function () {
            composing = false;
            listener();
          });
        }

        var timeout;

        var listener = function (ev) {
          if (timeout) {
            $browser.defer.cancel(timeout);
            timeout = null;
          }
          if (composing) return;
          var value = element.val(),
              event = ev && ev.type;

          // By default we will trim the value
          // If the attribute ng-trim exists we will avoid trimming
          // If input type is 'password', the value is never trimmed
          if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
            value = trim(value);
          }

          // If a control is suffering from bad input (due to native validators), browsers discard its
          // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
          // control's value is the same empty value twice in a row.
          if (ctrl.$viewValue !== value || value === '' && ctrl.$$hasNativeValidators) {
            ctrl.$setViewValue(value, event);
          }
        };

        // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
        // input event on backspace, delete or cut
        if ($sniffer.hasEvent('input')) {
          element.on('input', listener);
        } else {
          var deferListener = function (ev, input, origValue) {
            if (!timeout) {
              timeout = $browser.defer(function () {
                timeout = null;
                if (!input || input.value !== origValue) {
                  listener(ev);
                }
              });
            }
          };

          element.on('keydown', function (event) {
            var key = event.keyCode;

            // ignore
            //    command            modifiers                   arrows
            if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;

            deferListener(event, this, this.value);
          });

          // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
          if ($sniffer.hasEvent('paste')) {
            element.on('paste cut', deferListener);
          }
        }

        // if user paste into input using mouse on older browser
        // or form autocomplete on newer browser, we need "change" event to catch it
        element.on('change', listener);

        // Some native input types (date-family) have the ability to change validity without
        // firing any input/change events.
        // For these event types, when native validators are present and the browser supports the type,
        // check for validity changes on various DOM events.
        if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
          element.on(PARTIAL_VALIDATION_EVENTS, function (ev) {
            if (!timeout) {
              var validity = this[VALIDITY_STATE_PROPERTY];
              var origBadInput = validity.badInput;
              var origTypeMismatch = validity.typeMismatch;
              timeout = $browser.defer(function () {
                timeout = null;
                if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
                  listener(ev);
                }
              });
            }
          });
        }

        ctrl.$render = function () {
          // Workaround for Firefox validation #12102.
          var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
          if (element.val() !== value) {
            element.val(value);
          }
        };
      }

      function weekParser(isoWeek, existingDate) {
        if (isDate(isoWeek)) {
          return isoWeek;
        }

        if (isString(isoWeek)) {
          WEEK_REGEXP.lastIndex = 0;
          var parts = WEEK_REGEXP.exec(isoWeek);
          if (parts) {
            var year = +parts[1],
                week = +parts[2],
                hours = 0,
                minutes = 0,
                seconds = 0,
                milliseconds = 0,
                firstThurs = getFirstThursdayOfYear(year),
                addDays = (week - 1) * 7;

            if (existingDate) {
              hours = existingDate.getHours();
              minutes = existingDate.getMinutes();
              seconds = existingDate.getSeconds();
              milliseconds = existingDate.getMilliseconds();
            }

            return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
          }
        }

        return NaN;
      }

      function createDateParser(regexp, mapping) {
        return function (iso, date) {
          var parts, map;

          if (isDate(iso)) {
            return iso;
          }

          if (isString(iso)) {
            // When a date is JSON'ified to wraps itself inside of an extra
            // set of double quotes. This makes the date parsing code unable
            // to match the date string and parse it as a date.
            if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
              iso = iso.substring(1, iso.length - 1);
            }
            if (ISO_DATE_REGEXP.test(iso)) {
              return new Date(iso);
            }
            regexp.lastIndex = 0;
            parts = regexp.exec(iso);

            if (parts) {
              parts.shift();
              if (date) {
                map = {
                  yyyy: date.getFullYear(),
                  MM: date.getMonth() + 1,
                  dd: date.getDate(),
                  HH: date.getHours(),
                  mm: date.getMinutes(),
                  ss: date.getSeconds(),
                  sss: date.getMilliseconds() / 1000
                };
              } else {
                map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
              }

              forEach(parts, function (part, index) {
                if (index < mapping.length) {
                  map[mapping[index]] = +part;
                }
              });
              return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
            }
          }

          return NaN;
        };
      }

      function createDateInputType(type, regexp, parseDate, format) {
        return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
          badInputChecker(scope, element, attr, ctrl);
          baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
          var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
          var previousDate;

          ctrl.$$parserName = type;
          ctrl.$parsers.push(function (value) {
            if (ctrl.$isEmpty(value)) return null;
            if (regexp.test(value)) {
              // Note: We cannot read ctrl.$modelValue, as there might be a different
              // parser/formatter in the processing chain so that the model
              // contains some different data format!
              var parsedDate = parseDate(value, previousDate);
              if (timezone) {
                parsedDate = convertTimezoneToLocal(parsedDate, timezone);
              }
              return parsedDate;
            }
            return undefined;
          });

          ctrl.$formatters.push(function (value) {
            if (value && !isDate(value)) {
              throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
            }
            if (isValidDate(value)) {
              previousDate = value;
              if (previousDate && timezone) {
                previousDate = convertTimezoneToLocal(previousDate, timezone, true);
              }
              return $filter('date')(value, format, timezone);
            } else {
              previousDate = null;
              return '';
            }
          });

          if (isDefined(attr.min) || attr.ngMin) {
            var minVal;
            ctrl.$validators.min = function (value) {
              return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
            };
            attr.$observe('min', function (val) {
              minVal = parseObservedDateValue(val);
              ctrl.$validate();
            });
          }

          if (isDefined(attr.max) || attr.ngMax) {
            var maxVal;
            ctrl.$validators.max = function (value) {
              return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
            };
            attr.$observe('max', function (val) {
              maxVal = parseObservedDateValue(val);
              ctrl.$validate();
            });
          }

          function isValidDate(value) {
            // Invalid Date: getTime() returns NaN
            return value && !(value.getTime && value.getTime() !== value.getTime());
          }

          function parseObservedDateValue(val) {
            return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
          }
        };
      }

      function badInputChecker(scope, element, attr, ctrl) {
        var node = element[0];
        var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
        if (nativeValidation) {
          ctrl.$parsers.push(function (value) {
            var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
            return validity.badInput || validity.typeMismatch ? undefined : value;
          });
        }
      }

      function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        badInputChecker(scope, element, attr, ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

        ctrl.$$parserName = 'number';
        ctrl.$parsers.push(function (value) {
          if (ctrl.$isEmpty(value)) return null;
          if (NUMBER_REGEXP.test(value)) return parseFloat(value);
          return undefined;
        });

        ctrl.$formatters.push(function (value) {
          if (!ctrl.$isEmpty(value)) {
            if (!isNumber(value)) {
              throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
            }
            value = value.toString();
          }
          return value;
        });

        if (isDefined(attr.min) || attr.ngMin) {
          var minVal;
          ctrl.$validators.min = function (value) {
            return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
          };

          attr.$observe('min', function (val) {
            if (isDefined(val) && !isNumber(val)) {
              val = parseFloat(val);
            }
            minVal = isNumber(val) && !isNaN(val) ? val : undefined;
            // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
          });
        }

        if (isDefined(attr.max) || attr.ngMax) {
          var maxVal;
          ctrl.$validators.max = function (value) {
            return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
          };

          attr.$observe('max', function (val) {
            if (isDefined(val) && !isNumber(val)) {
              val = parseFloat(val);
            }
            maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
            // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
          });
        }
      }

      function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);

        ctrl.$$parserName = 'url';
        ctrl.$validators.url = function (modelValue, viewValue) {
          var value = modelValue || viewValue;
          return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
        };
      }

      function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);

        ctrl.$$parserName = 'email';
        ctrl.$validators.email = function (modelValue, viewValue) {
          var value = modelValue || viewValue;
          return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
        };
      }

      function radioInputType(scope, element, attr, ctrl) {
        // make the name unique, if not defined
        if (isUndefined(attr.name)) {
          element.attr('name', nextUid());
        }

        var listener = function (ev) {
          if (element[0].checked) {
            ctrl.$setViewValue(attr.value, ev && ev.type);
          }
        };

        element.on('click', listener);

        ctrl.$render = function () {
          var value = attr.value;
          element[0].checked = value == ctrl.$viewValue;
        };

        attr.$observe('value', ctrl.$render);
      }

      function parseConstantExpr($parse, context, name, expression, fallback) {
        var parseFn;
        if (isDefined(expression)) {
          parseFn = $parse(expression);
          if (!parseFn.constant) {
            throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' + '`{1}`.', name, expression);
          }
          return parseFn(context);
        }
        return fallback;
      }

      function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
        var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

        var listener = function (ev) {
          ctrl.$setViewValue(element[0].checked, ev && ev.type);
        };

        element.on('click', listener);

        ctrl.$render = function () {
          element[0].checked = ctrl.$viewValue;
        };

        // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
        // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
        // it to a boolean.
        ctrl.$isEmpty = function (value) {
          return value === false;
        };

        ctrl.$formatters.push(function (value) {
          return equals(value, trueValue);
        });

        ctrl.$parsers.push(function (value) {
          return value ? trueValue : falseValue;
        });
      }

      /**
       * @ngdoc directive
       * @name textarea
       * @restrict E
       *
       * @description
       * HTML textarea element control with angular data-binding. The data-binding and validation
       * properties of this element are exactly the same as those of the
       * {@link ng.directive:input input element}.
       *
       * @param {string} ngModel Assignable angular expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
       *    length.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange Angular expression to be executed when input changes due to user
       *    interaction with the input element.
       * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
       */

      /**
       * @ngdoc directive
       * @name input
       * @restrict E
       *
       * @description
       * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
       * input state control, and validation.
       * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
       *
       * <div class="alert alert-warning">
       * **Note:** Not every feature offered is available for all input types.
       * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
       * </div>
       *
       * @param {string} ngModel Assignable angular expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {boolean=} ngRequired Sets `required` attribute if set to true
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
       *    length.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange Angular expression to be executed when input changes due to user
       *    interaction with the input element.
       * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
       *    This parameter is ignored for input[type=password] controls, which will never trim the
       *    input.
       *
       * @example
          <example name="input-directive" module="inputExample">
            <file name="index.html">
             <script>
                angular.module('inputExample', [])
                  .controller('ExampleController', ['$scope', function($scope) {
                    $scope.user = {name: 'guest', last: 'visitor'};
                  }]);
             </script>
             <div ng-controller="ExampleController">
               <form name="myForm">
                 <label>
                    User name:
                    <input type="text" name="userName" ng-model="user.name" required>
                 </label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.userName.$error.required">
                    Required!</span>
                 </div>
                 <label>
                    Last name:
                    <input type="text" name="lastName" ng-model="user.last"
                    ng-minlength="3" ng-maxlength="10">
                 </label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.lastName.$error.minlength">
                     Too short!</span>
                   <span class="error" ng-show="myForm.lastName.$error.maxlength">
                     Too long!</span>
                 </div>
               </form>
               <hr>
               <tt>user = {{user}}</tt><br/>
               <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
               <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
               <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
               <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
               <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
               <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
             </div>
            </file>
            <file name="protractor.js" type="protractor">
              var user = element(by.exactBinding('user'));
              var userNameValid = element(by.binding('myForm.userName.$valid'));
              var lastNameValid = element(by.binding('myForm.lastName.$valid'));
              var lastNameError = element(by.binding('myForm.lastName.$error'));
              var formValid = element(by.binding('myForm.$valid'));
              var userNameInput = element(by.model('user.name'));
              var userLastInput = element(by.model('user.last'));
      
              it('should initialize to model', function() {
                expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
                expect(userNameValid.getText()).toContain('true');
                expect(formValid.getText()).toContain('true');
              });
      
              it('should be invalid if empty when required', function() {
                userNameInput.clear();
                userNameInput.sendKeys('');
      
                expect(user.getText()).toContain('{"last":"visitor"}');
                expect(userNameValid.getText()).toContain('false');
                expect(formValid.getText()).toContain('false');
              });
      
              it('should be valid if empty when min length is set', function() {
                userLastInput.clear();
                userLastInput.sendKeys('');
      
                expect(user.getText()).toContain('{"name":"guest","last":""}');
                expect(lastNameValid.getText()).toContain('true');
                expect(formValid.getText()).toContain('true');
              });
      
              it('should be invalid if less than required min length', function() {
                userLastInput.clear();
                userLastInput.sendKeys('xx');
      
                expect(user.getText()).toContain('{"name":"guest"}');
                expect(lastNameValid.getText()).toContain('false');
                expect(lastNameError.getText()).toContain('minlength');
                expect(formValid.getText()).toContain('false');
              });
      
              it('should be invalid if longer than max length', function() {
                userLastInput.clear();
                userLastInput.sendKeys('some ridiculously long name');
      
                expect(user.getText()).toContain('{"name":"guest"}');
                expect(lastNameValid.getText()).toContain('false');
                expect(lastNameError.getText()).toContain('maxlength');
                expect(formValid.getText()).toContain('false');
              });
            </file>
          </example>
       */
      var inputDirective = ['$browser', '$sniffer', '$filter', '$parse', function ($browser, $sniffer, $filter, $parse) {
        return {
          restrict: 'E',
          require: ['?ngModel'],
          link: {
            pre: function (scope, element, attr, ctrls) {
              if (ctrls[0]) {
                (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
              }
            }
          }
        };
      }];

      var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
      /**
       * @ngdoc directive
       * @name ngValue
       *
       * @description
       * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
       * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
       * the bound value.
       *
       * `ngValue` is useful when dynamically generating lists of radio buttons using
       * {@link ngRepeat `ngRepeat`}, as shown below.
       *
       * Likewise, `ngValue` can be used to generate `<option>` elements for
       * the {@link select `select`} element. In that case however, only strings are supported
       * for the `value `attribute, so the resulting `ngModel` will always be a string.
       * Support for `select` models with non-string values is available via `ngOptions`.
       *
       * @element input
       * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
       *   of the `input` element
       *
       * @example
          <example name="ngValue-directive" module="valueExample">
            <file name="index.html">
             <script>
                angular.module('valueExample', [])
                  .controller('ExampleController', ['$scope', function($scope) {
                    $scope.names = ['pizza', 'unicorns', 'robots'];
                    $scope.my = { favorite: 'unicorns' };
                  }]);
             </script>
              <form ng-controller="ExampleController">
                <h2>Which is your favorite?</h2>
                  <label ng-repeat="name in names" for="{{name}}">
                    {{name}}
                    <input type="radio"
                           ng-model="my.favorite"
                           ng-value="name"
                           id="{{name}}"
                           name="favorite">
                  </label>
                <div>You chose {{my.favorite}}</div>
              </form>
            </file>
            <file name="protractor.js" type="protractor">
              var favorite = element(by.binding('my.favorite'));
      
              it('should initialize to model', function() {
                expect(favorite.getText()).toContain('unicorns');
              });
              it('should bind the values to the inputs', function() {
                element.all(by.model('my.favorite')).get(0).click();
                expect(favorite.getText()).toContain('pizza');
              });
            </file>
          </example>
       */
      var ngValueDirective = function () {
        return {
          restrict: 'A',
          priority: 100,
          compile: function (tpl, tplAttr) {
            if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
              return function ngValueConstantLink(scope, elm, attr) {
                attr.$set('value', scope.$eval(attr.ngValue));
              };
            } else {
              return function ngValueLink(scope, elm, attr) {
                scope.$watch(attr.ngValue, function valueWatchAction(value) {
                  attr.$set('value', value);
                });
              };
            }
          }
        };
      };

      /**
       * @ngdoc directive
       * @name ngBind
       * @restrict AC
       *
       * @description
       * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
       * with the value of a given expression, and to update the text content when the value of that
       * expression changes.
       *
       * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
       * `{{ expression }}` which is similar but less verbose.
       *
       * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
       * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
       * element attribute, it makes the bindings invisible to the user while the page is loading.
       *
       * An alternative solution to this problem would be using the
       * {@link ng.directive:ngCloak ngCloak} directive.
       *
       *
       * @element ANY
       * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
       *
       * @example
       * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
         <example module="bindExample">
           <file name="index.html">
             <script>
               angular.module('bindExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.name = 'Whirled';
                 }]);
             </script>
             <div ng-controller="ExampleController">
               <label>Enter name: <input type="text" ng-model="name"></label><br>
               Hello <span ng-bind="name"></span>!
             </div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-bind', function() {
               var nameInput = element(by.model('name'));
      
               expect(element(by.binding('name')).getText()).toBe('Whirled');
               nameInput.clear();
               nameInput.sendKeys('world');
               expect(element(by.binding('name')).getText()).toBe('world');
             });
           </file>
         </example>
       */
      var ngBindDirective = ['$compile', function ($compile) {
        return {
          restrict: 'AC',
          compile: function ngBindCompile(templateElement) {
            $compile.$$addBindingClass(templateElement);
            return function ngBindLink(scope, element, attr) {
              $compile.$$addBindingInfo(element, attr.ngBind);
              element = element[0];
              scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
                element.textContent = isUndefined(value) ? '' : value;
              });
            };
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngBindTemplate
       *
       * @description
       * The `ngBindTemplate` directive specifies that the element
       * text content should be replaced with the interpolation of the template
       * in the `ngBindTemplate` attribute.
       * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
       * expressions. This directive is needed since some HTML elements
       * (such as TITLE and OPTION) cannot contain SPAN elements.
       *
       * @element ANY
       * @param {string} ngBindTemplate template of form
       *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
       *
       * @example
       * Try it here: enter text in text box and watch the greeting change.
         <example module="bindExample">
           <file name="index.html">
             <script>
               angular.module('bindExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.salutation = 'Hello';
                   $scope.name = 'World';
                 }]);
             </script>
             <div ng-controller="ExampleController">
              <label>Salutation: <input type="text" ng-model="salutation"></label><br>
              <label>Name: <input type="text" ng-model="name"></label><br>
              <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
             </div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-bind', function() {
               var salutationElem = element(by.binding('salutation'));
               var salutationInput = element(by.model('salutation'));
               var nameInput = element(by.model('name'));
      
               expect(salutationElem.getText()).toBe('Hello World!');
      
               salutationInput.clear();
               salutationInput.sendKeys('Greetings');
               nameInput.clear();
               nameInput.sendKeys('user');
      
               expect(salutationElem.getText()).toBe('Greetings user!');
             });
           </file>
         </example>
       */
      var ngBindTemplateDirective = ['$interpolate', '$compile', function ($interpolate, $compile) {
        return {
          compile: function ngBindTemplateCompile(templateElement) {
            $compile.$$addBindingClass(templateElement);
            return function ngBindTemplateLink(scope, element, attr) {
              var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
              $compile.$$addBindingInfo(element, interpolateFn.expressions);
              element = element[0];
              attr.$observe('ngBindTemplate', function (value) {
                element.textContent = isUndefined(value) ? '' : value;
              });
            };
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngBindHtml
       *
       * @description
       * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
       * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
       * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
       * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
       * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
       *
       * You may also bypass sanitization for values you know are safe. To do so, bind to
       * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
       * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
       *
       * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
       * will have an exception (instead of an exploit.)
       *
       * @element ANY
       * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
       *
       * @example
      
         <example module="bindHtmlExample" deps="angular-sanitize.js">
           <file name="index.html">
             <div ng-controller="ExampleController">
              <p ng-bind-html="myHTML"></p>
             </div>
           </file>
      
           <file name="script.js">
             angular.module('bindHtmlExample', ['ngSanitize'])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.myHTML =
                    'I am an <code>HTML</code>string with ' +
                    '<a href="#">links!</a> and other <em>stuff</em>';
               }]);
           </file>
      
           <file name="protractor.js" type="protractor">
             it('should check ng-bind-html', function() {
               expect(element(by.binding('myHTML')).getText()).toBe(
                   'I am an HTMLstring with links! and other stuff');
             });
           </file>
         </example>
       */
      var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function ($sce, $parse, $compile) {
        return {
          restrict: 'A',
          compile: function ngBindHtmlCompile(tElement, tAttrs) {
            var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
            var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
              // Unwrap the value to compare the actual inner safe value, not the wrapper object.
              return $sce.valueOf(val);
            });
            $compile.$$addBindingClass(tElement);

            return function ngBindHtmlLink(scope, element, attr) {
              $compile.$$addBindingInfo(element, attr.ngBindHtml);

              scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
                // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
                var value = ngBindHtmlGetter(scope);
                element.html($sce.getTrustedHtml(value) || '');
              });
            };
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngChange
       *
       * @description
       * Evaluate the given expression when the user changes the input.
       * The expression is evaluated immediately, unlike the JavaScript onchange event
       * which only triggers at the end of a change (usually, when the user leaves the
       * form element or presses the return key).
       *
       * The `ngChange` expression is only evaluated when a change in the input value causes
       * a new value to be committed to the model.
       *
       * It will not be evaluated:
       * * if the value returned from the `$parsers` transformation pipeline has not changed
       * * if the input has continued to be invalid since the model will stay `null`
       * * if the model is changed programmatically and not by a change to the input value
       *
       *
       * Note, this directive requires `ngModel` to be present.
       *
       * @element input
       * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
       * in input value.
       *
       * @example
       * <example name="ngChange-directive" module="changeExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('changeExample', [])
       *         .controller('ExampleController', ['$scope', function($scope) {
       *           $scope.counter = 0;
       *           $scope.change = function() {
       *             $scope.counter++;
       *           };
       *         }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
       *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
       *       <label for="ng-change-example2">Confirmed</label><br />
       *       <tt>debug = {{confirmed}}</tt><br/>
       *       <tt>counter = {{counter}}</tt><br/>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *     var counter = element(by.binding('counter'));
       *     var debug = element(by.binding('confirmed'));
       *
       *     it('should evaluate the expression if changing from view', function() {
       *       expect(counter.getText()).toContain('0');
       *
       *       element(by.id('ng-change-example1')).click();
       *
       *       expect(counter.getText()).toContain('1');
       *       expect(debug.getText()).toContain('true');
       *     });
       *
       *     it('should not evaluate the expression if changing from model', function() {
       *       element(by.id('ng-change-example2')).click();
      
       *       expect(counter.getText()).toContain('0');
       *       expect(debug.getText()).toContain('true');
       *     });
       *   </file>
       * </example>
       */
      var ngChangeDirective = valueFn({
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ctrl) {
          ctrl.$viewChangeListeners.push(function () {
            scope.$eval(attr.ngChange);
          });
        }
      });

      function classDirective(name, selector) {
        name = 'ngClass' + name;
        return ['$animate', function ($animate) {
          return {
            restrict: 'AC',
            link: function (scope, element, attr) {
              var oldVal;

              scope.$watch(attr[name], ngClassWatchAction, true);

              attr.$observe('class', function (value) {
                ngClassWatchAction(scope.$eval(attr[name]));
              });

              if (name !== 'ngClass') {
                scope.$watch('$index', function ($index, old$index) {
                  // jshint bitwise: false
                  var mod = $index & 1;
                  if (mod !== (old$index & 1)) {
                    var classes = arrayClasses(scope.$eval(attr[name]));
                    mod === selector ? addClasses(classes) : removeClasses(classes);
                  }
                });
              }

              function addClasses(classes) {
                var newClasses = digestClassCounts(classes, 1);
                attr.$addClass(newClasses);
              }

              function removeClasses(classes) {
                var newClasses = digestClassCounts(classes, -1);
                attr.$removeClass(newClasses);
              }

              function digestClassCounts(classes, count) {
                // Use createMap() to prevent class assumptions involving property
                // names in Object.prototype
                var classCounts = element.data('$classCounts') || createMap();
                var classesToUpdate = [];
                forEach(classes, function (className) {
                  if (count > 0 || classCounts[className]) {
                    classCounts[className] = (classCounts[className] || 0) + count;
                    if (classCounts[className] === +(count > 0)) {
                      classesToUpdate.push(className);
                    }
                  }
                });
                element.data('$classCounts', classCounts);
                return classesToUpdate.join(' ');
              }

              function updateClasses(oldClasses, newClasses) {
                var toAdd = arrayDifference(newClasses, oldClasses);
                var toRemove = arrayDifference(oldClasses, newClasses);
                toAdd = digestClassCounts(toAdd, 1);
                toRemove = digestClassCounts(toRemove, -1);
                if (toAdd && toAdd.length) {
                  $animate.addClass(element, toAdd);
                }
                if (toRemove && toRemove.length) {
                  $animate.removeClass(element, toRemove);
                }
              }

              function ngClassWatchAction(newVal) {
                // jshint bitwise: false
                if (selector === true || (scope.$index & 1) === selector) {
                  // jshint bitwise: true
                  var newClasses = arrayClasses(newVal || []);
                  if (!oldVal) {
                    addClasses(newClasses);
                  } else if (!equals(newVal, oldVal)) {
                    var oldClasses = arrayClasses(oldVal);
                    updateClasses(oldClasses, newClasses);
                  }
                }
                if (isArray(newVal)) {
                  oldVal = newVal.map(function (v) {
                    return shallowCopy(v);
                  });
                } else {
                  oldVal = shallowCopy(newVal);
                }
              }
            }
          };

          function arrayDifference(tokens1, tokens2) {
            var values = [];

            outer: for (var i = 0; i < tokens1.length; i++) {
              var token = tokens1[i];
              for (var j = 0; j < tokens2.length; j++) {
                if (token == tokens2[j]) continue outer;
              }
              values.push(token);
            }
            return values;
          }

          function arrayClasses(classVal) {
            var classes = [];
            if (isArray(classVal)) {
              forEach(classVal, function (v) {
                classes = classes.concat(arrayClasses(v));
              });
              return classes;
            } else if (isString(classVal)) {
              return classVal.split(' ');
            } else if (isObject(classVal)) {
              forEach(classVal, function (v, k) {
                if (v) {
                  classes = classes.concat(k.split(' '));
                }
              });
              return classes;
            }
            return classVal;
          }
        }];
      }

      /**
       * @ngdoc directive
       * @name ngClass
       * @restrict AC
       *
       * @description
       * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
       * an expression that represents all classes to be added.
       *
       * The directive operates in three different ways, depending on which of three types the expression
       * evaluates to:
       *
       * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
       * names.
       *
       * 2. If the expression evaluates to an object, then for each key-value pair of the
       * object with a truthy value the corresponding key is used as a class name.
       *
       * 3. If the expression evaluates to an array, each element of the array should either be a string as in
       * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
       * to give you more control over what CSS classes appear. See the code below for an example of this.
       *
       *
       * The directive won't add duplicate classes if a particular class was already set.
       *
       * When the expression changes, the previously added classes are removed and only then are the
       * new classes added.
       *
       * @knownIssue
       * You should not use {@link guide/interpolation interpolation} in the value of the `class`
       * attribute, when using the `ngClass` directive on the same element.
       * See {@link guide/interpolation#known-issues here} for more info.
       *
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
       * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
       *
       * @element ANY
       * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
       *   of the evaluation can be a string representing space delimited class
       *   names, an array, or a map of class names to boolean values. In the case of a map, the
       *   names of the properties whose values are truthy will be added as css classes to the
       *   element.
       *
       * @example Example that demonstrates basic bindings via ngClass directive.
         <example>
           <file name="index.html">
             <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
             <label>
                <input type="checkbox" ng-model="deleted">
                deleted (apply "strike" class)
             </label><br>
             <label>
                <input type="checkbox" ng-model="important">
                important (apply "bold" class)
             </label><br>
             <label>
                <input type="checkbox" ng-model="error">
                error (apply "has-error" class)
             </label>
             <hr>
             <p ng-class="style">Using String Syntax</p>
             <input type="text" ng-model="style"
                    placeholder="Type: bold strike red" aria-label="Type: bold strike red">
             <hr>
             <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
             <input ng-model="style1"
                    placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
             <input ng-model="style2"
                    placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
             <input ng-model="style3"
                    placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
             <hr>
             <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
             <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
             <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
           </file>
           <file name="style.css">
             .strike {
                 text-decoration: line-through;
             }
             .bold {
                 font-weight: bold;
             }
             .red {
                 color: red;
             }
             .has-error {
                 color: red;
                 background-color: yellow;
             }
             .orange {
                 color: orange;
             }
           </file>
           <file name="protractor.js" type="protractor">
             var ps = element.all(by.css('p'));
      
             it('should let you toggle the class', function() {
      
               expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
               expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
      
               element(by.model('important')).click();
               expect(ps.first().getAttribute('class')).toMatch(/bold/);
      
               element(by.model('error')).click();
               expect(ps.first().getAttribute('class')).toMatch(/has-error/);
             });
      
             it('should let you toggle string example', function() {
               expect(ps.get(1).getAttribute('class')).toBe('');
               element(by.model('style')).clear();
               element(by.model('style')).sendKeys('red');
               expect(ps.get(1).getAttribute('class')).toBe('red');
             });
      
             it('array example should have 3 classes', function() {
               expect(ps.get(2).getAttribute('class')).toBe('');
               element(by.model('style1')).sendKeys('bold');
               element(by.model('style2')).sendKeys('strike');
               element(by.model('style3')).sendKeys('red');
               expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
             });
      
             it('array with map example should have 2 classes', function() {
               expect(ps.last().getAttribute('class')).toBe('');
               element(by.model('style4')).sendKeys('bold');
               element(by.model('warning')).click();
               expect(ps.last().getAttribute('class')).toBe('bold orange');
             });
           </file>
         </example>
      
         ## Animations
      
         The example below demonstrates how to perform animations using ngClass.
      
         <example module="ngAnimate" deps="angular-animate.js" animations="true">
           <file name="index.html">
            <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
            <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
            <br>
            <span class="base-class" ng-class="myVar">Sample Text</span>
           </file>
           <file name="style.css">
             .base-class {
               transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
             }
      
             .base-class.my-class {
               color: red;
               font-size:3em;
             }
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-class', function() {
               expect(element(by.css('.base-class')).getAttribute('class')).not.
                 toMatch(/my-class/);
      
               element(by.id('setbtn')).click();
      
               expect(element(by.css('.base-class')).getAttribute('class')).
                 toMatch(/my-class/);
      
               element(by.id('clearbtn')).click();
      
               expect(element(by.css('.base-class')).getAttribute('class')).not.
                 toMatch(/my-class/);
             });
           </file>
         </example>
      
      
         ## ngClass and pre-existing CSS3 Transitions/Animations
         The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
         Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
         any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
         to view the step by step details of {@link $animate#addClass $animate.addClass} and
         {@link $animate#removeClass $animate.removeClass}.
       */
      var ngClassDirective = classDirective('', true);

      /**
       * @ngdoc directive
       * @name ngClassOdd
       * @restrict AC
       *
       * @description
       * The `ngClassOdd` and `ngClassEven` directives work exactly as
       * {@link ng.directive:ngClass ngClass}, except they work in
       * conjunction with `ngRepeat` and take effect only on odd (even) rows.
       *
       * This directive can be applied only within the scope of an
       * {@link ng.directive:ngRepeat ngRepeat}.
       *
       * @element ANY
       * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
       *   of the evaluation can be a string representing space delimited class names or an array.
       *
       * @example
         <example>
           <file name="index.html">
              <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
                <li ng-repeat="name in names">
                 <span ng-class-odd="'odd'" ng-class-even="'even'">
                   {{name}}
                 </span>
                </li>
              </ol>
           </file>
           <file name="style.css">
             .odd {
               color: red;
             }
             .even {
               color: blue;
             }
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-class-odd and ng-class-even', function() {
               expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
                 toMatch(/odd/);
               expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
                 toMatch(/even/);
             });
           </file>
         </example>
       */
      var ngClassOddDirective = classDirective('Odd', 0);

      /**
       * @ngdoc directive
       * @name ngClassEven
       * @restrict AC
       *
       * @description
       * The `ngClassOdd` and `ngClassEven` directives work exactly as
       * {@link ng.directive:ngClass ngClass}, except they work in
       * conjunction with `ngRepeat` and take effect only on odd (even) rows.
       *
       * This directive can be applied only within the scope of an
       * {@link ng.directive:ngRepeat ngRepeat}.
       *
       * @element ANY
       * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
       *   result of the evaluation can be a string representing space delimited class names or an array.
       *
       * @example
         <example>
           <file name="index.html">
              <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
                <li ng-repeat="name in names">
                 <span ng-class-odd="'odd'" ng-class-even="'even'">
                   {{name}} &nbsp; &nbsp; &nbsp;
                 </span>
                </li>
              </ol>
           </file>
           <file name="style.css">
             .odd {
               color: red;
             }
             .even {
               color: blue;
             }
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-class-odd and ng-class-even', function() {
               expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
                 toMatch(/odd/);
               expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
                 toMatch(/even/);
             });
           </file>
         </example>
       */
      var ngClassEvenDirective = classDirective('Even', 1);

      /**
       * @ngdoc directive
       * @name ngCloak
       * @restrict AC
       *
       * @description
       * The `ngCloak` directive is used to prevent the Angular html template from being briefly
       * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
       * directive to avoid the undesirable flicker effect caused by the html template display.
       *
       * The directive can be applied to the `<body>` element, but the preferred usage is to apply
       * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
       * of the browser view.
       *
       * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
       * `angular.min.js`.
       * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
       *
       * ```css
       * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
       *   display: none !important;
       * }
       * ```
       *
       * When this css rule is loaded by the browser, all html elements (including their children) that
       * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
       * during the compilation of the template it deletes the `ngCloak` element attribute, making
       * the compiled element visible.
       *
       * For the best result, the `angular.js` script must be loaded in the head section of the html
       * document; alternatively, the css rule above must be included in the external stylesheet of the
       * application.
       *
       * @element ANY
       *
       * @example
         <example>
           <file name="index.html">
              <div id="template1" ng-cloak>{{ 'hello' }}</div>
              <div id="template2" class="ng-cloak">{{ 'world' }}</div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should remove the template directive and css class', function() {
               expect($('#template1').getAttribute('ng-cloak')).
                 toBeNull();
               expect($('#template2').getAttribute('ng-cloak')).
                 toBeNull();
             });
           </file>
         </example>
       *
       */
      var ngCloakDirective = ngDirective({
        compile: function (element, attr) {
          attr.$set('ngCloak', undefined);
          element.removeClass('ng-cloak');
        }
      });

      /**
       * @ngdoc directive
       * @name ngController
       *
       * @description
       * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
       * supports the principles behind the Model-View-Controller design pattern.
       *
       * MVC components in angular:
       *
       * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
       *   are accessed through bindings.
       * * View — The template (HTML with data bindings) that is rendered into the View.
       * * Controller — The `ngController` directive specifies a Controller class; the class contains business
       *   logic behind the application to decorate the scope with functions and values
       *
       * Note that you can also attach controllers to the DOM by declaring it in a route definition
       * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
       * again using `ng-controller` in the template itself.  This will cause the controller to be attached
       * and executed twice.
       *
       * @element ANY
       * @scope
       * @priority 500
       * @param {expression} ngController Name of a constructor function registered with the current
       * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
       * that on the current scope evaluates to a constructor function.
       *
       * The controller instance can be published into a scope property by specifying
       * `ng-controller="as propertyName"`.
       *
       * If the current `$controllerProvider` is configured to use globals (via
       * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
       * also be the name of a globally accessible constructor function (not recommended).
       *
       * @example
       * Here is a simple form for editing user contact information. Adding, removing, clearing, and
       * greeting are methods declared on the controller (see source tab). These methods can
       * easily be called from the angular markup. Any changes to the data are automatically reflected
       * in the View without the need for a manual update.
       *
       * Two different declaration styles are included below:
       *
       * * one binds methods and properties directly onto the controller using `this`:
       * `ng-controller="SettingsController1 as settings"`
       * * one injects `$scope` into the controller:
       * `ng-controller="SettingsController2"`
       *
       * The second option is more common in the Angular community, and is generally used in boilerplates
       * and in this guide. However, there are advantages to binding properties directly to the controller
       * and avoiding scope.
       *
       * * Using `controller as` makes it obvious which controller you are accessing in the template when
       * multiple controllers apply to an element.
       * * If you are writing your controllers as classes you have easier access to the properties and
       * methods, which will appear on the scope, from inside the controller code.
       * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
       * inheritance masking primitives.
       *
       * This example demonstrates the `controller as` syntax.
       *
       * <example name="ngControllerAs" module="controllerAsExample">
       *   <file name="index.html">
       *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
       *      <label>Name: <input type="text" ng-model="settings.name"/></label>
       *      <button ng-click="settings.greet()">greet</button><br/>
       *      Contact:
       *      <ul>
       *        <li ng-repeat="contact in settings.contacts">
       *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
       *             <option>phone</option>
       *             <option>email</option>
       *          </select>
       *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
       *          <button ng-click="settings.clearContact(contact)">clear</button>
       *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
       *        </li>
       *        <li><button ng-click="settings.addContact()">add</button></li>
       *     </ul>
       *    </div>
       *   </file>
       *   <file name="app.js">
       *    angular.module('controllerAsExample', [])
       *      .controller('SettingsController1', SettingsController1);
       *
       *    function SettingsController1() {
       *      this.name = "John Smith";
       *      this.contacts = [
       *        {type: 'phone', value: '408 555 1212'},
       *        {type: 'email', value: 'john.smith@example.org'} ];
       *    }
       *
       *    SettingsController1.prototype.greet = function() {
       *      alert(this.name);
       *    };
       *
       *    SettingsController1.prototype.addContact = function() {
       *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
       *    };
       *
       *    SettingsController1.prototype.removeContact = function(contactToRemove) {
       *     var index = this.contacts.indexOf(contactToRemove);
       *      this.contacts.splice(index, 1);
       *    };
       *
       *    SettingsController1.prototype.clearContact = function(contact) {
       *      contact.type = 'phone';
       *      contact.value = '';
       *    };
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *     it('should check controller as', function() {
       *       var container = element(by.id('ctrl-as-exmpl'));
       *         expect(container.element(by.model('settings.name'))
       *           .getAttribute('value')).toBe('John Smith');
       *
       *       var firstRepeat =
       *           container.element(by.repeater('contact in settings.contacts').row(0));
       *       var secondRepeat =
       *           container.element(by.repeater('contact in settings.contacts').row(1));
       *
       *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
       *           .toBe('408 555 1212');
       *
       *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
       *           .toBe('john.smith@example.org');
       *
       *       firstRepeat.element(by.buttonText('clear')).click();
       *
       *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
       *           .toBe('');
       *
       *       container.element(by.buttonText('add')).click();
       *
       *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
       *           .element(by.model('contact.value'))
       *           .getAttribute('value'))
       *           .toBe('yourname@example.org');
       *     });
       *   </file>
       * </example>
       *
       * This example demonstrates the "attach to `$scope`" style of controller.
       *
       * <example name="ngController" module="controllerExample">
       *  <file name="index.html">
       *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
       *     <label>Name: <input type="text" ng-model="name"/></label>
       *     <button ng-click="greet()">greet</button><br/>
       *     Contact:
       *     <ul>
       *       <li ng-repeat="contact in contacts">
       *         <select ng-model="contact.type" id="select_{{$index}}">
       *            <option>phone</option>
       *            <option>email</option>
       *         </select>
       *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
       *         <button ng-click="clearContact(contact)">clear</button>
       *         <button ng-click="removeContact(contact)">X</button>
       *       </li>
       *       <li>[ <button ng-click="addContact()">add</button> ]</li>
       *    </ul>
       *   </div>
       *  </file>
       *  <file name="app.js">
       *   angular.module('controllerExample', [])
       *     .controller('SettingsController2', ['$scope', SettingsController2]);
       *
       *   function SettingsController2($scope) {
       *     $scope.name = "John Smith";
       *     $scope.contacts = [
       *       {type:'phone', value:'408 555 1212'},
       *       {type:'email', value:'john.smith@example.org'} ];
       *
       *     $scope.greet = function() {
       *       alert($scope.name);
       *     };
       *
       *     $scope.addContact = function() {
       *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
       *     };
       *
       *     $scope.removeContact = function(contactToRemove) {
       *       var index = $scope.contacts.indexOf(contactToRemove);
       *       $scope.contacts.splice(index, 1);
       *     };
       *
       *     $scope.clearContact = function(contact) {
       *       contact.type = 'phone';
       *       contact.value = '';
       *     };
       *   }
       *  </file>
       *  <file name="protractor.js" type="protractor">
       *    it('should check controller', function() {
       *      var container = element(by.id('ctrl-exmpl'));
       *
       *      expect(container.element(by.model('name'))
       *          .getAttribute('value')).toBe('John Smith');
       *
       *      var firstRepeat =
       *          container.element(by.repeater('contact in contacts').row(0));
       *      var secondRepeat =
       *          container.element(by.repeater('contact in contacts').row(1));
       *
       *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
       *          .toBe('408 555 1212');
       *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
       *          .toBe('john.smith@example.org');
       *
       *      firstRepeat.element(by.buttonText('clear')).click();
       *
       *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
       *          .toBe('');
       *
       *      container.element(by.buttonText('add')).click();
       *
       *      expect(container.element(by.repeater('contact in contacts').row(2))
       *          .element(by.model('contact.value'))
       *          .getAttribute('value'))
       *          .toBe('yourname@example.org');
       *    });
       *  </file>
       *</example>
      
       */
      var ngControllerDirective = [function () {
        return {
          restrict: 'A',
          scope: true,
          controller: '@',
          priority: 500
        };
      }];

      /**
       * @ngdoc directive
       * @name ngCsp
       *
       * @element html
       * @description
       *
       * Angular has some features that can break certain
       * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
       *
       * If you intend to implement these rules then you must tell Angular not to use these features.
       *
       * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
       *
       *
       * The following rules affect Angular:
       *
       * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
       * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
       * increase in the speed of evaluating Angular expressions.
       *
       * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
       * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
       * To make these directives work when a CSP rule is blocking inline styles, you must link to the
       * `angular-csp.css` in your HTML manually.
       *
       * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
       * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
       * however, triggers a CSP error to be logged in the console:
       *
       * ```
       * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
       * script in the following Content Security Policy directive: "default-src 'self'". Note that
       * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
       * ```
       *
       * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
       * directive on an element of the HTML document that appears before the `<script>` tag that loads
       * the `angular.js` file.
       *
       * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
       *
       * You can specify which of the CSP related Angular features should be deactivated by providing
       * a value for the `ng-csp` attribute. The options are as follows:
       *
       * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
       *
       * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
       *
       * You can use these values in the following combinations:
       *
       *
       * * No declaration means that Angular will assume that you can do inline styles, but it will do
       * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
       * of Angular.
       *
       * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
       * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
       * of Angular.
       *
       * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
       * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
       *
       * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
       * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
       *
       * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
       * styles nor use eval, which is the same as an empty: ng-csp.
       * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
       *
       * @example
       * This example shows how to apply the `ngCsp` directive to the `html` tag.
         ```html
           <!doctype html>
           <html ng-app ng-csp>
           ...
           ...
           </html>
         ```
        * @example
            // Note: the suffix `.csp` in the example name triggers
            // csp mode in our http server!
            <example name="example.csp" module="cspExample" ng-csp="true">
              <file name="index.html">
                <div ng-controller="MainController as ctrl">
                  <div>
                    <button ng-click="ctrl.inc()" id="inc">Increment</button>
                    <span id="counter">
                      {{ctrl.counter}}
                    </span>
                  </div>
      
                  <div>
                    <button ng-click="ctrl.evil()" id="evil">Evil</button>
                    <span id="evilError">
                      {{ctrl.evilError}}
                    </span>
                  </div>
                </div>
              </file>
              <file name="script.js">
                 angular.module('cspExample', [])
                   .controller('MainController', function() {
                      this.counter = 0;
                      this.inc = function() {
                        this.counter++;
                      };
                      this.evil = function() {
                        // jshint evil:true
                        try {
                          eval('1+2');
                        } catch (e) {
                          this.evilError = e.message;
                        }
                      };
                    });
              </file>
              <file name="protractor.js" type="protractor">
                var util, webdriver;
      
                var incBtn = element(by.id('inc'));
                var counter = element(by.id('counter'));
                var evilBtn = element(by.id('evil'));
                var evilError = element(by.id('evilError'));
      
                function getAndClearSevereErrors() {
                  return browser.manage().logs().get('browser').then(function(browserLog) {
                    return browserLog.filter(function(logEntry) {
                      return logEntry.level.value > webdriver.logging.Level.WARNING.value;
                    });
                  });
                }
      
                function clearErrors() {
                  getAndClearSevereErrors();
                }
      
                function expectNoErrors() {
                  getAndClearSevereErrors().then(function(filteredLog) {
                    expect(filteredLog.length).toEqual(0);
                    if (filteredLog.length) {
                      console.log('browser console errors: ' + util.inspect(filteredLog));
                    }
                  });
                }
      
                function expectError(regex) {
                  getAndClearSevereErrors().then(function(filteredLog) {
                    var found = false;
                    filteredLog.forEach(function(log) {
                      if (log.message.match(regex)) {
                        found = true;
                      }
                    });
                    if (!found) {
                      throw new Error('expected an error that matches ' + regex);
                    }
                  });
                }
      
                beforeEach(function() {
                  util = require('util');
                  webdriver = require('protractor/node_modules/selenium-webdriver');
                });
      
                // For now, we only test on Chrome,
                // as Safari does not load the page with Protractor's injected scripts,
                // and Firefox webdriver always disables content security policy (#6358)
                if (browser.params.browser !== 'chrome') {
                  return;
                }
      
                it('should not report errors when the page is loaded', function() {
                  // clear errors so we are not dependent on previous tests
                  clearErrors();
                  // Need to reload the page as the page is already loaded when
                  // we come here
                  browser.driver.getCurrentUrl().then(function(url) {
                    browser.get(url);
                  });
                  expectNoErrors();
                });
      
                it('should evaluate expressions', function() {
                  expect(counter.getText()).toEqual('0');
                  incBtn.click();
                  expect(counter.getText()).toEqual('1');
                  expectNoErrors();
                });
      
                it('should throw and report an error when using "eval"', function() {
                  evilBtn.click();
                  expect(evilError.getText()).toMatch(/Content Security Policy/);
                  expectError(/Content Security Policy/);
                });
              </file>
            </example>
        */

      // ngCsp is not implemented as a proper directive any more, because we need it be processed while we
      // bootstrap the system (before $parse is instantiated), for this reason we just have
      // the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc

      /**
       * @ngdoc directive
       * @name ngClick
       *
       * @description
       * The ngClick directive allows you to specify custom behavior when
       * an element is clicked.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
       * click. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-click="count = count + 1" ng-init="count=0">
              Increment
            </button>
            <span>
              count: {{count}}
            </span>
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-click', function() {
               expect(element(by.binding('count')).getText()).toMatch('0');
               element(by.css('button')).click();
               expect(element(by.binding('count')).getText()).toMatch('1');
             });
           </file>
         </example>
       */
      /*
       * A collection of directives that allows creation of custom event handlers that are defined as
       * angular expressions and are compiled and executed within the current scope.
       */
      var ngEventDirectives = {};

      // For events that might fire synchronously during DOM manipulation
      // we need to execute their event handlers asynchronously using $evalAsync,
      // so that they are not executed in an inconsistent state.
      var forceAsyncEvents = {
        'blur': true,
        'focus': true
      };
      forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '), function (eventName) {
        var directiveName = directiveNormalize('ng-' + eventName);
        ngEventDirectives[directiveName] = ['$parse', '$rootScope', function ($parse, $rootScope) {
          return {
            restrict: 'A',
            compile: function ($element, attr) {
              // We expose the powerful $event object on the scope that provides access to the Window,
              // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
              // checks at the cost of speed since event handler expressions are not executed as
              // frequently as regular change detection.
              var fn = $parse(attr[directiveName], /* interceptorFn */null, /* expensiveChecks */true);
              return function ngEventHandler(scope, element) {
                element.on(eventName, function (event) {
                  var callback = function () {
                    fn(scope, { $event: event });
                  };
                  if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                    scope.$evalAsync(callback);
                  } else {
                    scope.$apply(callback);
                  }
                });
              };
            }
          };
        }];
      });

      /**
       * @ngdoc directive
       * @name ngDblclick
       *
       * @description
       * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
       * a dblclick. (The Event object is available as `$event`)
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-dblclick="count = count + 1" ng-init="count=0">
              Increment (on double click)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMousedown
       *
       * @description
       * The ngMousedown directive allows you to specify custom behavior on mousedown event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
       * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mousedown="count = count + 1" ng-init="count=0">
              Increment (on mouse down)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMouseup
       *
       * @description
       * Specify custom behavior on mouseup event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
       * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mouseup="count = count + 1" ng-init="count=0">
              Increment (on mouse up)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMouseover
       *
       * @description
       * Specify custom behavior on mouseover event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
       * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mouseover="count = count + 1" ng-init="count=0">
              Increment (when mouse is over)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMouseenter
       *
       * @description
       * Specify custom behavior on mouseenter event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
       * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mouseenter="count = count + 1" ng-init="count=0">
              Increment (when mouse enters)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMouseleave
       *
       * @description
       * Specify custom behavior on mouseleave event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
       * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mouseleave="count = count + 1" ng-init="count=0">
              Increment (when mouse leaves)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngMousemove
       *
       * @description
       * Specify custom behavior on mousemove event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
       * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <button ng-mousemove="count = count + 1" ng-init="count=0">
              Increment (when mouse moves)
            </button>
            count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngKeydown
       *
       * @description
       * Specify custom behavior on keydown event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
       * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
       *
       * @example
         <example>
           <file name="index.html">
            <input ng-keydown="count = count + 1" ng-init="count=0">
            key down count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngKeyup
       *
       * @description
       * Specify custom behavior on keyup event.
       *
       * @element ANY
       * @priority 0
       * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
       * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
       *
       * @example
         <example>
           <file name="index.html">
             <p>Typing in the input box below updates the key count</p>
             <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
      
             <p>Typing in the input box below updates the keycode</p>
             <input ng-keyup="event=$event">
             <p>event keyCode: {{ event.keyCode }}</p>
             <p>event altKey: {{ event.altKey }}</p>
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngKeypress
       *
       * @description
       * Specify custom behavior on keypress event.
       *
       * @element ANY
       * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
       * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
       * and can be interrogated for keyCode, altKey, etc.)
       *
       * @example
         <example>
           <file name="index.html">
            <input ng-keypress="count = count + 1" ng-init="count=0">
            key press count: {{count}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngSubmit
       *
       * @description
       * Enables binding angular expressions to onsubmit events.
       *
       * Additionally it prevents the default action (which for form means sending the request to the
       * server and reloading the current page), but only if the form does not contain `action`,
       * `data-action`, or `x-action` attributes.
       *
       * <div class="alert alert-warning">
       * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
       * `ngSubmit` handlers together. See the
       * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
       * for a detailed discussion of when `ngSubmit` may be triggered.
       * </div>
       *
       * @element form
       * @priority 0
       * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
       * ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example module="submitExample">
           <file name="index.html">
            <script>
              angular.module('submitExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.list = [];
                  $scope.text = 'hello';
                  $scope.submit = function() {
                    if ($scope.text) {
                      $scope.list.push(this.text);
                      $scope.text = '';
                    }
                  };
                }]);
            </script>
            <form ng-submit="submit()" ng-controller="ExampleController">
              Enter text and hit enter:
              <input type="text" ng-model="text" name="text" />
              <input type="submit" id="submit" value="Submit" />
              <pre>list={{list}}</pre>
            </form>
           </file>
           <file name="protractor.js" type="protractor">
             it('should check ng-submit', function() {
               expect(element(by.binding('list')).getText()).toBe('list=[]');
               element(by.css('#submit')).click();
               expect(element(by.binding('list')).getText()).toContain('hello');
               expect(element(by.model('text')).getAttribute('value')).toBe('');
             });
             it('should ignore empty strings', function() {
               expect(element(by.binding('list')).getText()).toBe('list=[]');
               element(by.css('#submit')).click();
               element(by.css('#submit')).click();
               expect(element(by.binding('list')).getText()).toContain('hello');
              });
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngFocus
       *
       * @description
       * Specify custom behavior on focus event.
       *
       * Note: As the `focus` event is executed synchronously when calling `input.focus()`
       * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
       * during an `$apply` to ensure a consistent state.
       *
       * @element window, input, select, textarea, a
       * @priority 0
       * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
       * focus. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
       * See {@link ng.directive:ngClick ngClick}
       */

      /**
       * @ngdoc directive
       * @name ngBlur
       *
       * @description
       * Specify custom behavior on blur event.
       *
       * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
       * an element has lost focus.
       *
       * Note: As the `blur` event is executed synchronously also during DOM manipulations
       * (e.g. removing a focussed input),
       * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
       * during an `$apply` to ensure a consistent state.
       *
       * @element window, input, select, textarea, a
       * @priority 0
       * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
       * blur. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
       * See {@link ng.directive:ngClick ngClick}
       */

      /**
       * @ngdoc directive
       * @name ngCopy
       *
       * @description
       * Specify custom behavior on copy event.
       *
       * @element window, input, select, textarea, a
       * @priority 0
       * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
       * copy. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
            copied: {{copied}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngCut
       *
       * @description
       * Specify custom behavior on cut event.
       *
       * @element window, input, select, textarea, a
       * @priority 0
       * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
       * cut. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
            cut: {{cut}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngPaste
       *
       * @description
       * Specify custom behavior on paste event.
       *
       * @element window, input, select, textarea, a
       * @priority 0
       * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
       * paste. ({@link guide/expression#-event- Event object is available as `$event`})
       *
       * @example
         <example>
           <file name="index.html">
            <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
            pasted: {{paste}}
           </file>
         </example>
       */

      /**
       * @ngdoc directive
       * @name ngIf
       * @restrict A
       * @multiElement
       *
       * @description
       * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
       * {expression}. If the expression assigned to `ngIf` evaluates to a false
       * value then the element is removed from the DOM, otherwise a clone of the
       * element is reinserted into the DOM.
       *
       * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
       * element in the DOM rather than changing its visibility via the `display` css property.  A common
       * case when this difference is significant is when using css selectors that rely on an element's
       * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
       *
       * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
       * is created when the element is restored.  The scope created within `ngIf` inherits from
       * its parent scope using
       * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
       * An important implication of this is if `ngModel` is used within `ngIf` to bind to
       * a javascript primitive defined in the parent scope. In this case any modifications made to the
       * variable within the child scope will override (hide) the value in the parent scope.
       *
       * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
       * is if an element's class attribute is directly modified after it's compiled, using something like
       * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
       * the added class will be lost because the original compiled state is used to regenerate the element.
       *
       * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
       * and `leave` effects.
       *
       * @animations
       * | Animation                        | Occurs                               |
       * |----------------------------------|-------------------------------------|
       * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
       * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
       *
       * @element ANY
       * @scope
       * @priority 600
       * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
       *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
       *     element is added to the DOM tree.
       *
       * @example
        <example module="ngAnimate" deps="angular-animate.js" animations="true">
          <file name="index.html">
            <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
            Show when checked:
            <span ng-if="checked" class="animate-if">
              This is removed when the checkbox is unchecked.
            </span>
          </file>
          <file name="animations.css">
            .animate-if {
              background:white;
              border:1px solid black;
              padding:10px;
            }
      
            .animate-if.ng-enter, .animate-if.ng-leave {
              transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
            }
      
            .animate-if.ng-enter,
            .animate-if.ng-leave.ng-leave-active {
              opacity:0;
            }
      
            .animate-if.ng-leave,
            .animate-if.ng-enter.ng-enter-active {
              opacity:1;
            }
          </file>
        </example>
       */
      var ngIfDirective = ['$animate', '$compile', function ($animate, $compile) {
        return {
          multiElement: true,
          transclude: 'element',
          priority: 600,
          terminal: true,
          restrict: 'A',
          $$tlb: true,
          link: function ($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;
            $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

              if (value) {
                if (!childScope) {
                  $transclude(function (clone, newScope) {
                    childScope = newScope;
                    clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                    // Note: We only need the first/last node of the cloned nodes.
                    // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                    // by a directive with templateUrl when its template arrives.
                    block = {
                      clone: clone
                    };
                    $animate.enter(clone, $element.parent(), $element);
                  });
                }
              } else {
                if (previousElements) {
                  previousElements.remove();
                  previousElements = null;
                }
                if (childScope) {
                  childScope.$destroy();
                  childScope = null;
                }
                if (block) {
                  previousElements = getBlockNodes(block.clone);
                  $animate.leave(previousElements).then(function () {
                    previousElements = null;
                  });
                  block = null;
                }
              }
            });
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngInclude
       * @restrict ECA
       *
       * @description
       * Fetches, compiles and includes an external HTML fragment.
       *
       * By default, the template URL is restricted to the same domain and protocol as the
       * application document. This is done by calling {@link $sce#getTrustedResourceUrl
       * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
       * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
       * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
       * ng.$sce Strict Contextual Escaping}.
       *
       * In addition, the browser's
       * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
       * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
       * policy may further restrict whether the template is successfully loaded.
       * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
       * access on some browsers.
       *
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
       * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
       *
       * The enter and leave animation occur concurrently.
       *
       * @scope
       * @priority 400
       *
       * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
       *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
       * @param {string=} onload Expression to evaluate when a new partial is loaded.
       *                  <div class="alert alert-warning">
       *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
       *                  a function with the name on the window element, which will usually throw a
       *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
       *                  different form that {@link guide/directive#normalization matches} `onload`.
       *                  </div>
         *
       * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
       *                  $anchorScroll} to scroll the viewport after the content is loaded.
       *
       *                  - If the attribute is not set, disable scrolling.
       *                  - If the attribute is set without value, enable scrolling.
       *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
       *
       * @example
        <example module="includeExample" deps="angular-animate.js" animations="true">
          <file name="index.html">
           <div ng-controller="ExampleController">
             <select ng-model="template" ng-options="t.name for t in templates">
              <option value="">(blank)</option>
             </select>
             url of the template: <code>{{template.url}}</code>
             <hr/>
             <div class="slide-animate-container">
               <div class="slide-animate" ng-include="template.url"></div>
             </div>
           </div>
          </file>
          <file name="script.js">
            angular.module('includeExample', ['ngAnimate'])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.templates =
                  [ { name: 'template1.html', url: 'template1.html'},
                    { name: 'template2.html', url: 'template2.html'} ];
                $scope.template = $scope.templates[0];
              }]);
           </file>
          <file name="template1.html">
            Content of template1.html
          </file>
          <file name="template2.html">
            Content of template2.html
          </file>
          <file name="animations.css">
            .slide-animate-container {
              position:relative;
              background:white;
              border:1px solid black;
              height:40px;
              overflow:hidden;
            }
      
            .slide-animate {
              padding:10px;
            }
      
            .slide-animate.ng-enter, .slide-animate.ng-leave {
              transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      
              position:absolute;
              top:0;
              left:0;
              right:0;
              bottom:0;
              display:block;
              padding:10px;
            }
      
            .slide-animate.ng-enter {
              top:-50px;
            }
            .slide-animate.ng-enter.ng-enter-active {
              top:0;
            }
      
            .slide-animate.ng-leave {
              top:0;
            }
            .slide-animate.ng-leave.ng-leave-active {
              top:50px;
            }
          </file>
          <file name="protractor.js" type="protractor">
            var templateSelect = element(by.model('template'));
            var includeElem = element(by.css('[ng-include]'));
      
            it('should load template1.html', function() {
              expect(includeElem.getText()).toMatch(/Content of template1.html/);
            });
      
            it('should load template2.html', function() {
              if (browser.params.browser == 'firefox') {
                // Firefox can't handle using selects
                // See https://github.com/angular/protractor/issues/480
                return;
              }
              templateSelect.click();
              templateSelect.all(by.css('option')).get(2).click();
              expect(includeElem.getText()).toMatch(/Content of template2.html/);
            });
      
            it('should change to blank', function() {
              if (browser.params.browser == 'firefox') {
                // Firefox can't handle using selects
                return;
              }
              templateSelect.click();
              templateSelect.all(by.css('option')).get(0).click();
              expect(includeElem.isPresent()).toBe(false);
            });
          </file>
        </example>
       */

      /**
       * @ngdoc event
       * @name ngInclude#$includeContentRequested
       * @eventType emit on the scope ngInclude was declared in
       * @description
       * Emitted every time the ngInclude content is requested.
       *
       * @param {Object} angularEvent Synthetic event object.
       * @param {String} src URL of content to load.
       */

      /**
       * @ngdoc event
       * @name ngInclude#$includeContentLoaded
       * @eventType emit on the current ngInclude scope
       * @description
       * Emitted every time the ngInclude content is reloaded.
       *
       * @param {Object} angularEvent Synthetic event object.
       * @param {String} src URL of content to load.
       */

      /**
       * @ngdoc event
       * @name ngInclude#$includeContentError
       * @eventType emit on the scope ngInclude was declared in
       * @description
       * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
       *
       * @param {Object} angularEvent Synthetic event object.
       * @param {String} src URL of content to load.
       */
      var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', function ($templateRequest, $anchorScroll, $animate) {
        return {
          restrict: 'ECA',
          priority: 400,
          terminal: true,
          transclude: 'element',
          controller: angular.noop,
          compile: function (element, attr) {
            var srcExp = attr.ngInclude || attr.src,
                onloadExp = attr.onload || '',
                autoScrollExp = attr.autoscroll;

            return function (scope, $element, $attr, ctrl, $transclude) {
              var changeCounter = 0,
                  currentScope,
                  previousElement,
                  currentElement;

              var cleanupLastIncludeContent = function () {
                if (previousElement) {
                  previousElement.remove();
                  previousElement = null;
                }
                if (currentScope) {
                  currentScope.$destroy();
                  currentScope = null;
                }
                if (currentElement) {
                  $animate.leave(currentElement).then(function () {
                    previousElement = null;
                  });
                  previousElement = currentElement;
                  currentElement = null;
                }
              };

              scope.$watch(srcExp, function ngIncludeWatchAction(src) {
                var afterAnimation = function () {
                  if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                    $anchorScroll();
                  }
                };
                var thisChangeId = ++changeCounter;

                if (src) {
                  //set the 2nd param to true to ignore the template request error so that the inner
                  //contents and scope can be cleaned up.
                  $templateRequest(src, true).then(function (response) {
                    if (scope.$$destroyed) return;

                    if (thisChangeId !== changeCounter) return;
                    var newScope = scope.$new();
                    ctrl.template = response;

                    // Note: This will also link all children of ng-include that were contained in the original
                    // html. If that content contains controllers, ... they could pollute/change the scope.
                    // However, using ng-include on an element with additional content does not make sense...
                    // Note: We can't remove them in the cloneAttchFn of $transclude as that
                    // function is called before linking the content, which would apply child
                    // directives to non existing elements.
                    var clone = $transclude(newScope, function (clone) {
                      cleanupLastIncludeContent();
                      $animate.enter(clone, null, $element).then(afterAnimation);
                    });

                    currentScope = newScope;
                    currentElement = clone;

                    currentScope.$emit('$includeContentLoaded', src);
                    scope.$eval(onloadExp);
                  }, function () {
                    if (scope.$$destroyed) return;

                    if (thisChangeId === changeCounter) {
                      cleanupLastIncludeContent();
                      scope.$emit('$includeContentError', src);
                    }
                  });
                  scope.$emit('$includeContentRequested', src);
                } else {
                  cleanupLastIncludeContent();
                  ctrl.template = null;
                }
              });
            };
          }
        };
      }];

      // This directive is called during the $transclude call of the first `ngInclude` directive.
      // It will replace and compile the content of the element with the loaded template.
      // We need this directive so that the element content is already filled when
      // the link function of another directive on the same element as ngInclude
      // is called.
      var ngIncludeFillContentDirective = ['$compile', function ($compile) {
        return {
          restrict: 'ECA',
          priority: -400,
          require: 'ngInclude',
          link: function (scope, $element, $attr, ctrl) {
            if (toString.call($element[0]).match(/SVG/)) {
              // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
              // support innerHTML, so detect this here and try to generate the contents
              // specially.
              $element.empty();
              $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
                $element.append(clone);
              }, { futureParentElement: $element });
              return;
            }

            $element.html(ctrl.template);
            $compile($element.contents())(scope);
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngInit
       * @restrict AC
       *
       * @description
       * The `ngInit` directive allows you to evaluate an expression in the
       * current scope.
       *
       * <div class="alert alert-danger">
       * This directive can be abused to add unnecessary amounts of logic into your templates.
       * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
       * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
       * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
       * rather than `ngInit` to initialize values on a scope.
       * </div>
       *
       * <div class="alert alert-warning">
       * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
       * sure you have parentheses to ensure correct operator precedence:
       * <pre class="prettyprint">
       * `<div ng-init="test1 = ($index | toString)"></div>`
       * </pre>
       * </div>
       *
       * @priority 450
       *
       * @element ANY
       * @param {expression} ngInit {@link guide/expression Expression} to eval.
       *
       * @example
         <example module="initExample">
           <file name="index.html">
         <script>
           angular.module('initExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.list = [['a', 'b'], ['c', 'd']];
             }]);
         </script>
         <div ng-controller="ExampleController">
           <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
             <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
                <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
             </div>
           </div>
         </div>
           </file>
           <file name="protractor.js" type="protractor">
             it('should alias index positions', function() {
               var elements = element.all(by.css('.example-init'));
               expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
               expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
               expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
               expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
             });
           </file>
         </example>
       */
      var ngInitDirective = ngDirective({
        priority: 450,
        compile: function () {
          return {
            pre: function (scope, element, attrs) {
              scope.$eval(attrs.ngInit);
            }
          };
        }
      });

      /**
       * @ngdoc directive
       * @name ngList
       *
       * @description
       * Text input that converts between a delimited string and an array of strings. The default
       * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
       * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
       *
       * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
       * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
       *   list item is respected. This implies that the user of the directive is responsible for
       *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
       *   tab or newline character.
       * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
       *   when joining the list items back together) and whitespace around each list item is stripped
       *   before it is added to the model.
       *
       * ### Example with Validation
       *
       * <example name="ngList-directive" module="listExample">
       *   <file name="app.js">
       *      angular.module('listExample', [])
       *        .controller('ExampleController', ['$scope', function($scope) {
       *          $scope.names = ['morpheus', 'neo', 'trinity'];
       *        }]);
       *   </file>
       *   <file name="index.html">
       *    <form name="myForm" ng-controller="ExampleController">
       *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
       *      <span role="alert">
       *        <span class="error" ng-show="myForm.namesInput.$error.required">
       *        Required!</span>
       *      </span>
       *      <br>
       *      <tt>names = {{names}}</tt><br/>
       *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
       *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
       *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       *     </form>
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *     var listInput = element(by.model('names'));
       *     var names = element(by.exactBinding('names'));
       *     var valid = element(by.binding('myForm.namesInput.$valid'));
       *     var error = element(by.css('span.error'));
       *
       *     it('should initialize to model', function() {
       *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
       *       expect(valid.getText()).toContain('true');
       *       expect(error.getCssValue('display')).toBe('none');
       *     });
       *
       *     it('should be invalid if empty', function() {
       *       listInput.clear();
       *       listInput.sendKeys('');
       *
       *       expect(names.getText()).toContain('');
       *       expect(valid.getText()).toContain('false');
       *       expect(error.getCssValue('display')).not.toBe('none');
       *     });
       *   </file>
       * </example>
       *
       * ### Example - splitting on newline
       * <example name="ngList-directive-newlines">
       *   <file name="index.html">
       *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
       *    <pre>{{ list | json }}</pre>
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *     it("should split the text by newlines", function() {
       *       var listInput = element(by.model('list'));
       *       var output = element(by.binding('list | json'));
       *       listInput.sendKeys('abc\ndef\nghi');
       *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
       *     });
       *   </file>
       * </example>
       *
       * @element input
       * @param {string=} ngList optional delimiter that should be used to split the value.
       */
      var ngListDirective = function () {
        return {
          restrict: 'A',
          priority: 100,
          require: 'ngModel',
          link: function (scope, element, attr, ctrl) {
            // We want to control whitespace trimming so we use this convoluted approach
            // to access the ngList attribute, which doesn't pre-trim the attribute
            var ngList = element.attr(attr.$attr.ngList) || ', ';
            var trimValues = attr.ngTrim !== 'false';
            var separator = trimValues ? trim(ngList) : ngList;

            var parse = function (viewValue) {
              // If the viewValue is invalid (say required but empty) it will be `undefined`
              if (isUndefined(viewValue)) return;

              var list = [];

              if (viewValue) {
                forEach(viewValue.split(separator), function (value) {
                  if (value) list.push(trimValues ? trim(value) : value);
                });
              }

              return list;
            };

            ctrl.$parsers.push(parse);
            ctrl.$formatters.push(function (value) {
              if (isArray(value)) {
                return value.join(ngList);
              }

              return undefined;
            });

            // Override the standard $isEmpty because an empty array means the input is empty.
            ctrl.$isEmpty = function (value) {
              return !value || !value.length;
            };
          }
        };
      };

      /* global VALID_CLASS: true,
        INVALID_CLASS: true,
        PRISTINE_CLASS: true,
        DIRTY_CLASS: true,
        UNTOUCHED_CLASS: true,
        TOUCHED_CLASS: true,
      */

      var VALID_CLASS = 'ng-valid',
          INVALID_CLASS = 'ng-invalid',
          PRISTINE_CLASS = 'ng-pristine',
          DIRTY_CLASS = 'ng-dirty',
          UNTOUCHED_CLASS = 'ng-untouched',
          TOUCHED_CLASS = 'ng-touched',
          PENDING_CLASS = 'ng-pending',
          EMPTY_CLASS = 'ng-empty',
          NOT_EMPTY_CLASS = 'ng-not-empty';

      var ngModelMinErr = minErr('ngModel');

      /**
       * @ngdoc type
       * @name ngModel.NgModelController
       *
       * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
       * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
       * is set.
       * @property {*} $modelValue The value in the model that the control is bound to.
       * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
             the control reads value from the DOM. The functions are called in array order, each passing
             its return value through to the next. The last return value is forwarded to the
             {@link ngModel.NgModelController#$validators `$validators`} collection.
      
      Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
      `$viewValue`}.
      
      Returning `undefined` from a parser means a parse error occurred. In that case,
      no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
      will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
      is set to `true`. The parse error is stored in `ngModel.$error.parse`.
      
       *
       * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
             the model value changes. The functions are called in reverse array order, each passing the value through to the
             next. The last return value is used as the actual DOM value.
             Used to format / convert values for display in the control.
       * ```js
       * function formatter(value) {
       *   if (value) {
       *     return value.toUpperCase();
       *   }
       * }
       * ngModel.$formatters.push(formatter);
       * ```
       *
       * @property {Object.<string, function>} $validators A collection of validators that are applied
       *      whenever the model value changes. The key value within the object refers to the name of the
       *      validator while the function refers to the validation operation. The validation operation is
       *      provided with the model value as an argument and must return a true or false value depending
       *      on the response of that validation.
       *
       * ```js
       * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
       *   var value = modelValue || viewValue;
       *   return /[0-9]+/.test(value) &&
       *          /[a-z]+/.test(value) &&
       *          /[A-Z]+/.test(value) &&
       *          /\W+/.test(value);
       * };
       * ```
       *
       * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
       *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
       *      is expected to return a promise when it is run during the model validation process. Once the promise
       *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
       *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
       *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
       *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
       *      will only run once all synchronous validators have passed.
       *
       * Please note that if $http is used then it is important that the server returns a success HTTP response code
       * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
       *
       * ```js
       * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
       *   var value = modelValue || viewValue;
       *
       *   // Lookup user by username
       *   return $http.get('/api/users/' + value).
       *      then(function resolved() {
       *        //username exists, this means validation fails
       *        return $q.reject('exists');
       *      }, function rejected() {
       *        //username does not exist, therefore this validation passes
       *        return true;
       *      });
       * };
       * ```
       *
       * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
       *     view value has changed. It is called with no arguments, and its return value is ignored.
       *     This can be used in place of additional $watches against the model value.
       *
       * @property {Object} $error An object hash with all failing validator ids as keys.
       * @property {Object} $pending An object hash with all pending validator ids as keys.
       *
       * @property {boolean} $untouched True if control has not lost focus yet.
       * @property {boolean} $touched True if control has lost focus.
       * @property {boolean} $pristine True if user has not interacted with the control yet.
       * @property {boolean} $dirty True if user has already interacted with the control.
       * @property {boolean} $valid True if there is no error.
       * @property {boolean} $invalid True if at least one error on the control.
       * @property {string} $name The name attribute of the control.
       *
       * @description
       *
       * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
       * The controller contains services for data-binding, validation, CSS updates, and value formatting
       * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
       * listening to DOM events.
       * Such DOM related logic should be provided by other directives which make use of
       * `NgModelController` for data-binding to control elements.
       * Angular provides this DOM logic for most {@link input `input`} elements.
       * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
       * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
       *
       * @example
       * ### Custom Control Example
       * This example shows how to use `NgModelController` with a custom control to achieve
       * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
       * collaborate together to achieve the desired result.
       *
       * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
       * contents be edited in place by the user.
       *
       * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
       * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
       * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
       * that content using the `$sce` service.
       *
       * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
          <file name="style.css">
            [contenteditable] {
              border: 1px solid black;
              background-color: white;
              min-height: 20px;
            }
      
            .ng-invalid {
              border: 1px solid red;
            }
      
          </file>
          <file name="script.js">
            angular.module('customControl', ['ngSanitize']).
              directive('contenteditable', ['$sce', function($sce) {
                return {
                  restrict: 'A', // only activate on element attribute
                  require: '?ngModel', // get a hold of NgModelController
                  link: function(scope, element, attrs, ngModel) {
                    if (!ngModel) return; // do nothing if no ng-model
      
                    // Specify how UI should be updated
                    ngModel.$render = function() {
                      element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                    };
      
                    // Listen for change events to enable binding
                    element.on('blur keyup change', function() {
                      scope.$evalAsync(read);
                    });
                    read(); // initialize
      
                    // Write data to the model
                    function read() {
                      var html = element.html();
                      // When we clear the content editable the browser leaves a <br> behind
                      // If strip-br attribute is provided then we strip this out
                      if ( attrs.stripBr && html == '<br>' ) {
                        html = '';
                      }
                      ngModel.$setViewValue(html);
                    }
                  }
                };
              }]);
          </file>
          <file name="index.html">
            <form name="myForm">
             <div contenteditable
                  name="myWidget" ng-model="userContent"
                  strip-br="true"
                  required>Change me!</div>
              <span ng-show="myForm.myWidget.$error.required">Required!</span>
             <hr>
             <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
          it('should data-bind and become invalid', function() {
            if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
              // SafariDriver can't handle contenteditable
              // and Firefox driver can't clear contenteditables very well
              return;
            }
            var contentEditable = element(by.css('[contenteditable]'));
            var content = 'Change me!';
      
            expect(contentEditable.getText()).toEqual(content);
      
            contentEditable.clear();
            contentEditable.sendKeys(protractor.Key.BACK_SPACE);
            expect(contentEditable.getText()).toEqual('');
            expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
          });
          </file>
       * </example>
       *
       *
       */
      var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate', function ($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
        this.$viewValue = Number.NaN;
        this.$modelValue = Number.NaN;
        this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
        this.$validators = {};
        this.$asyncValidators = {};
        this.$parsers = [];
        this.$formatters = [];
        this.$viewChangeListeners = [];
        this.$untouched = true;
        this.$touched = false;
        this.$pristine = true;
        this.$dirty = false;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {}; // keep invalid keys here
        this.$$success = {}; // keep valid keys here
        this.$pending = undefined; // keep pending keys here
        this.$name = $interpolate($attr.name || '', false)($scope);
        this.$$parentForm = nullFormCtrl;

        var parsedNgModel = $parse($attr.ngModel),
            parsedNgModelAssign = parsedNgModel.assign,
            ngModelGet = parsedNgModel,
            ngModelSet = parsedNgModelAssign,
            pendingDebounce = null,
            parserValid,
            ctrl = this;

        this.$$setOptions = function (options) {
          ctrl.$options = options;
          if (options && options.getterSetter) {
            var invokeModelGetter = $parse($attr.ngModel + '()'),
                invokeModelSetter = $parse($attr.ngModel + '($$$p)');

            ngModelGet = function ($scope) {
              var modelValue = parsedNgModel($scope);
              if (isFunction(modelValue)) {
                modelValue = invokeModelGetter($scope);
              }
              return modelValue;
            };
            ngModelSet = function ($scope, newValue) {
              if (isFunction(parsedNgModel($scope))) {
                invokeModelSetter($scope, { $$$p: newValue });
              } else {
                parsedNgModelAssign($scope, newValue);
              }
            };
          } else if (!parsedNgModel.assign) {
            throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}", $attr.ngModel, startingTag($element));
          }
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$render
         *
         * @description
         * Called when the view needs to be updated. It is expected that the user of the ng-model
         * directive will implement this method.
         *
         * The `$render()` method is invoked in the following situations:
         *
         * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
         *   committed value then `$render()` is called to update the input control.
         * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
         *   the `$viewValue` are different from last time.
         *
         * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
         * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
         * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
         * invoked if you only change a property on the objects.
         */
        this.$render = noop;

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$isEmpty
         *
         * @description
         * This is called when we need to determine if the value of an input is empty.
         *
         * For instance, the required directive does this to work out if the input has data or not.
         *
         * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
         *
         * You can override this for input directives whose concept of being empty is different from the
         * default. The `checkboxInputType` directive does this because in its case a value of `false`
         * implies empty.
         *
         * @param {*} value The value of the input to check for emptiness.
         * @returns {boolean} True if `value` is "empty".
         */
        this.$isEmpty = function (value) {
          return isUndefined(value) || value === '' || value === null || value !== value;
        };

        this.$$updateEmptyClasses = function (value) {
          if (ctrl.$isEmpty(value)) {
            $animate.removeClass($element, NOT_EMPTY_CLASS);
            $animate.addClass($element, EMPTY_CLASS);
          } else {
            $animate.removeClass($element, EMPTY_CLASS);
            $animate.addClass($element, NOT_EMPTY_CLASS);
          }
        };

        var currentValidationRunId = 0;

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setValidity
         *
         * @description
         * Change the validity state, and notify the form.
         *
         * This method can be called within $parsers/$formatters or a custom validation implementation.
         * However, in most cases it should be sufficient to use the `ngModel.$validators` and
         * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
         *
         * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
         *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
         *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
         *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
         *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
         *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
         * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
         *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
         *                          Skipped is used by Angular when validators do not run because of parse errors and
         *                          when `$asyncValidators` do not run because any of the `$validators` failed.
         */
        addSetValidityMethod({
          ctrl: this,
          $element: $element,
          set: function (object, property) {
            object[property] = true;
          },
          unset: function (object, property) {
            delete object[property];
          },
          $animate: $animate
        });

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setPristine
         *
         * @description
         * Sets the control to its pristine state.
         *
         * This method can be called to remove the `ng-dirty` class and set the control to its pristine
         * state (`ng-pristine` class). A model is considered to be pristine when the control
         * has not been changed from when first compiled.
         */
        this.$setPristine = function () {
          ctrl.$dirty = false;
          ctrl.$pristine = true;
          $animate.removeClass($element, DIRTY_CLASS);
          $animate.addClass($element, PRISTINE_CLASS);
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setDirty
         *
         * @description
         * Sets the control to its dirty state.
         *
         * This method can be called to remove the `ng-pristine` class and set the control to its dirty
         * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
         * from when first compiled.
         */
        this.$setDirty = function () {
          ctrl.$dirty = true;
          ctrl.$pristine = false;
          $animate.removeClass($element, PRISTINE_CLASS);
          $animate.addClass($element, DIRTY_CLASS);
          ctrl.$$parentForm.$setDirty();
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setUntouched
         *
         * @description
         * Sets the control to its untouched state.
         *
         * This method can be called to remove the `ng-touched` class and set the control to its
         * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
         * by default, however this function can be used to restore that state if the model has
         * already been touched by the user.
         */
        this.$setUntouched = function () {
          ctrl.$touched = false;
          ctrl.$untouched = true;
          $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setTouched
         *
         * @description
         * Sets the control to its touched state.
         *
         * This method can be called to remove the `ng-untouched` class and set the control to its
         * touched state (`ng-touched` class). A model is considered to be touched when the user has
         * first focused the control element and then shifted focus away from the control (blur event).
         */
        this.$setTouched = function () {
          ctrl.$touched = true;
          ctrl.$untouched = false;
          $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$rollbackViewValue
         *
         * @description
         * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
         * which may be caused by a pending debounced event or because the input is waiting for a some
         * future event.
         *
         * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
         * depend on special events such as blur, you can have a situation where there is a period when
         * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
         *
         * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
         * and reset the input to the last committed view value.
         *
         * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
         * programmatically before these debounced/future events have resolved/occurred, because Angular's
         * dirty checking mechanism is not able to tell whether the model has actually changed or not.
         *
         * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
         * input which may have such events pending. This is important in order to make sure that the
         * input field will be updated with the new model value and any pending operations are cancelled.
         *
         * <example name="ng-model-cancel-update" module="cancel-update-example">
         *   <file name="app.js">
         *     angular.module('cancel-update-example', [])
         *
         *     .controller('CancelUpdateController', ['$scope', function($scope) {
         *       $scope.model = {};
         *
         *       $scope.setEmpty = function(e, value, rollback) {
         *         if (e.keyCode == 27) {
         *           e.preventDefault();
         *           if (rollback) {
         *             $scope.myForm[value].$rollbackViewValue();
         *           }
         *           $scope.model[value] = '';
         *         }
         *       };
         *     }]);
         *   </file>
         *   <file name="index.html">
         *     <div ng-controller="CancelUpdateController">
         *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
         *        empty them. Follow these steps and observe the difference:</p>
         *       <ol>
         *         <li>Type something in the input. You will see that the model is not yet updated</li>
         *         <li>Press the Escape key.
         *           <ol>
         *             <li> In the first example, nothing happens, because the model is already '', and no
         *             update is detected. If you blur the input, the model will be set to the current view.
         *             </li>
         *             <li> In the second example, the pending update is cancelled, and the input is set back
         *             to the last committed view value (''). Blurring the input does nothing.
         *             </li>
         *           </ol>
         *         </li>
         *       </ol>
         *
         *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
         *         <div>
         *        <p id="inputDescription1">Without $rollbackViewValue():</p>
         *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
         *                ng-keydown="setEmpty($event, 'value1')">
         *         value1: "{{ model.value1 }}"
         *         </div>
         *
         *         <div>
         *        <p id="inputDescription2">With $rollbackViewValue():</p>
         *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
         *                ng-keydown="setEmpty($event, 'value2', true)">
         *         value2: "{{ model.value2 }}"
         *         </div>
         *       </form>
         *     </div>
         *   </file>
             <file name="style.css">
                div {
                  display: table-cell;
                }
                div:nth-child(1) {
                  padding-right: 30px;
                }
               </file>
         * </example>
         */
        this.$rollbackViewValue = function () {
          $timeout.cancel(pendingDebounce);
          ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
          ctrl.$render();
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$validate
         *
         * @description
         * Runs each of the registered validators (first synchronous validators and then
         * asynchronous validators).
         * If the validity changes to invalid, the model will be set to `undefined`,
         * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
         * If the validity changes to valid, it will set the model to the last available valid
         * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
         */
        this.$validate = function () {
          // ignore $validate before model is initialized
          if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
            return;
          }

          var viewValue = ctrl.$$lastCommittedViewValue;
          // Note: we use the $$rawModelValue as $modelValue might have been
          // set to undefined during a view -> model update that found validation
          // errors. We can't parse the view here, since that could change
          // the model although neither viewValue nor the model on the scope changed
          var modelValue = ctrl.$$rawModelValue;

          var prevValid = ctrl.$valid;
          var prevModelValue = ctrl.$modelValue;

          var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;

          ctrl.$$runValidators(modelValue, viewValue, function (allValid) {
            // If there was no change in validity, don't update the model
            // This prevents changing an invalid modelValue to undefined
            if (!allowInvalid && prevValid !== allValid) {
              // Note: Don't check ctrl.$valid here, as we could have
              // external validators (e.g. calculated on the server),
              // that just call $setValidity and need the model value
              // to calculate their validity.
              ctrl.$modelValue = allValid ? modelValue : undefined;

              if (ctrl.$modelValue !== prevModelValue) {
                ctrl.$$writeModelToScope();
              }
            }
          });
        };

        this.$$runValidators = function (modelValue, viewValue, doneCallback) {
          currentValidationRunId++;
          var localValidationRunId = currentValidationRunId;

          // check parser error
          if (!processParseErrors()) {
            validationDone(false);
            return;
          }
          if (!processSyncValidators()) {
            validationDone(false);
            return;
          }
          processAsyncValidators();

          function processParseErrors() {
            var errorKey = ctrl.$$parserName || 'parse';
            if (isUndefined(parserValid)) {
              setValidity(errorKey, null);
            } else {
              if (!parserValid) {
                forEach(ctrl.$validators, function (v, name) {
                  setValidity(name, null);
                });
                forEach(ctrl.$asyncValidators, function (v, name) {
                  setValidity(name, null);
                });
              }
              // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
              setValidity(errorKey, parserValid);
              return parserValid;
            }
            return true;
          }

          function processSyncValidators() {
            var syncValidatorsValid = true;
            forEach(ctrl.$validators, function (validator, name) {
              var result = validator(modelValue, viewValue);
              syncValidatorsValid = syncValidatorsValid && result;
              setValidity(name, result);
            });
            if (!syncValidatorsValid) {
              forEach(ctrl.$asyncValidators, function (v, name) {
                setValidity(name, null);
              });
              return false;
            }
            return true;
          }

          function processAsyncValidators() {
            var validatorPromises = [];
            var allValid = true;
            forEach(ctrl.$asyncValidators, function (validator, name) {
              var promise = validator(modelValue, viewValue);
              if (!isPromiseLike(promise)) {
                throw ngModelMinErr('nopromise', "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
              }
              setValidity(name, undefined);
              validatorPromises.push(promise.then(function () {
                setValidity(name, true);
              }, function () {
                allValid = false;
                setValidity(name, false);
              }));
            });
            if (!validatorPromises.length) {
              validationDone(true);
            } else {
              $q.all(validatorPromises).then(function () {
                validationDone(allValid);
              }, noop);
            }
          }

          function setValidity(name, isValid) {
            if (localValidationRunId === currentValidationRunId) {
              ctrl.$setValidity(name, isValid);
            }
          }

          function validationDone(allValid) {
            if (localValidationRunId === currentValidationRunId) {

              doneCallback(allValid);
            }
          }
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$commitViewValue
         *
         * @description
         * Commit a pending update to the `$modelValue`.
         *
         * Updates may be pending by a debounced event or because the input is waiting for a some future
         * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
         * usually handles calling this in response to input events.
         */
        this.$commitViewValue = function () {
          var viewValue = ctrl.$viewValue;

          $timeout.cancel(pendingDebounce);

          // If the view value has not changed then we should just exit, except in the case where there is
          // a native validator on the element. In this case the validation state may have changed even though
          // the viewValue has stayed empty.
          if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
            return;
          }
          ctrl.$$updateEmptyClasses(viewValue);
          ctrl.$$lastCommittedViewValue = viewValue;

          // change to dirty
          if (ctrl.$pristine) {
            this.$setDirty();
          }
          this.$$parseAndValidate();
        };

        this.$$parseAndValidate = function () {
          var viewValue = ctrl.$$lastCommittedViewValue;
          var modelValue = viewValue;
          parserValid = isUndefined(modelValue) ? undefined : true;

          if (parserValid) {
            for (var i = 0; i < ctrl.$parsers.length; i++) {
              modelValue = ctrl.$parsers[i](modelValue);
              if (isUndefined(modelValue)) {
                parserValid = false;
                break;
              }
            }
          }
          if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
            // ctrl.$modelValue has not been touched yet...
            ctrl.$modelValue = ngModelGet($scope);
          }
          var prevModelValue = ctrl.$modelValue;
          var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
          ctrl.$$rawModelValue = modelValue;

          if (allowInvalid) {
            ctrl.$modelValue = modelValue;
            writeToModelIfNeeded();
          }

          // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
          // This can happen if e.g. $setViewValue is called from inside a parser
          ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function (allValid) {
            if (!allowInvalid) {
              // Note: Don't check ctrl.$valid here, as we could have
              // external validators (e.g. calculated on the server),
              // that just call $setValidity and need the model value
              // to calculate their validity.
              ctrl.$modelValue = allValid ? modelValue : undefined;
              writeToModelIfNeeded();
            }
          });

          function writeToModelIfNeeded() {
            if (ctrl.$modelValue !== prevModelValue) {
              ctrl.$$writeModelToScope();
            }
          }
        };

        this.$$writeModelToScope = function () {
          ngModelSet($scope, ctrl.$modelValue);
          forEach(ctrl.$viewChangeListeners, function (listener) {
            try {
              listener();
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        };

        /**
         * @ngdoc method
         * @name ngModel.NgModelController#$setViewValue
         *
         * @description
         * Update the view value.
         *
         * This method should be called when a control wants to change the view value; typically,
         * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
         * directive calls it when the value of the input changes and {@link ng.directive:select select}
         * calls it when an option is selected.
         *
         * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
         * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
         * value sent directly for processing, finally to be applied to `$modelValue` and then the
         * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
         * in the `$viewChangeListeners` list, are called.
         *
         * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
         * and the `default` trigger is not listed, all those actions will remain pending until one of the
         * `updateOn` events is triggered on the DOM element.
         * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
         * directive is used with a custom debounce for this particular event.
         * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
         * is specified, once the timer runs out.
         *
         * When used with standard inputs, the view value will always be a string (which is in some cases
         * parsed into another type, such as a `Date` object for `input[date]`.)
         * However, custom controls might also pass objects to this method. In this case, we should make
         * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
         * perform a deep watch of objects, it only looks for a change of identity. If you only change
         * the property of the object then ngModel will not realize that the object has changed and
         * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
         * not change properties of the copy once it has been passed to `$setViewValue`.
         * Otherwise you may cause the model value on the scope to change incorrectly.
         *
         * <div class="alert alert-info">
         * In any case, the value passed to the method should always reflect the current value
         * of the control. For example, if you are calling `$setViewValue` for an input element,
         * you should pass the input DOM value. Otherwise, the control and the scope model become
         * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
         * the control's DOM value in any way. If we want to change the control's DOM value
         * programmatically, we should update the `ngModel` scope expression. Its new value will be
         * picked up by the model controller, which will run it through the `$formatters`, `$render` it
         * to update the DOM, and finally call `$validate` on it.
         * </div>
         *
         * @param {*} value value from the view.
         * @param {string} trigger Event that triggered the update.
         */
        this.$setViewValue = function (value, trigger) {
          ctrl.$viewValue = value;
          if (!ctrl.$options || ctrl.$options.updateOnDefault) {
            ctrl.$$debounceViewValueCommit(trigger);
          }
        };

        this.$$debounceViewValueCommit = function (trigger) {
          var debounceDelay = 0,
              options = ctrl.$options,
              debounce;

          if (options && isDefined(options.debounce)) {
            debounce = options.debounce;
            if (isNumber(debounce)) {
              debounceDelay = debounce;
            } else if (isNumber(debounce[trigger])) {
              debounceDelay = debounce[trigger];
            } else if (isNumber(debounce['default'])) {
              debounceDelay = debounce['default'];
            }
          }

          $timeout.cancel(pendingDebounce);
          if (debounceDelay) {
            pendingDebounce = $timeout(function () {
              ctrl.$commitViewValue();
            }, debounceDelay);
          } else if ($rootScope.$$phase) {
            ctrl.$commitViewValue();
          } else {
            $scope.$apply(function () {
              ctrl.$commitViewValue();
            });
          }
        };

        // model -> value
        // Note: we cannot use a normal scope.$watch as we want to detect the following:
        // 1. scope value is 'a'
        // 2. user enters 'b'
        // 3. ng-change kicks in and reverts scope value to 'a'
        //    -> scope value did not change since the last digest as
        //       ng-change executes in apply phase
        // 4. view should be changed back to 'a'
        $scope.$watch(function ngModelWatch() {
          var modelValue = ngModelGet($scope);

          // if scope model value and ngModel value are out of sync
          // TODO(perf): why not move this to the action fn?
          if (modelValue !== ctrl.$modelValue && (
          // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
          ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) {
            ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
            parserValid = undefined;

            var formatters = ctrl.$formatters,
                idx = formatters.length;

            var viewValue = modelValue;
            while (idx--) {
              viewValue = formatters[idx](viewValue);
            }
            if (ctrl.$viewValue !== viewValue) {
              ctrl.$$updateEmptyClasses(viewValue);
              ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
              ctrl.$render();

              ctrl.$$runValidators(modelValue, viewValue, noop);
            }
          }

          return modelValue;
        });
      }];

      /**
       * @ngdoc directive
       * @name ngModel
       *
       * @element input
       * @priority 1
       *
       * @description
       * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
       * property on the scope using {@link ngModel.NgModelController NgModelController},
       * which is created and exposed by this directive.
       *
       * `ngModel` is responsible for:
       *
       * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
       *   require.
       * - Providing validation behavior (i.e. required, number, email, url).
       * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
       * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
       *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
       * - Registering the control with its parent {@link ng.directive:form form}.
       *
       * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
       * current scope. If the property doesn't already exist on this scope, it will be created
       * implicitly and added to the scope.
       *
       * For best practices on using `ngModel`, see:
       *
       *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
       *
       * For basic examples, how to use `ngModel`, see:
       *
       *  - {@link ng.directive:input input}
       *    - {@link input[text] text}
       *    - {@link input[checkbox] checkbox}
       *    - {@link input[radio] radio}
       *    - {@link input[number] number}
       *    - {@link input[email] email}
       *    - {@link input[url] url}
       *    - {@link input[date] date}
       *    - {@link input[datetime-local] datetime-local}
       *    - {@link input[time] time}
       *    - {@link input[month] month}
       *    - {@link input[week] week}
       *  - {@link ng.directive:select select}
       *  - {@link ng.directive:textarea textarea}
       *
       * # Complex Models (objects or collections)
       *
       * By default, `ngModel` watches the model by reference, not value. This is important to know when
       * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
       * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
       *
       * The model must be assigned an entirely new object or collection before a re-rendering will occur.
       *
       * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
       * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
       * if the select is given the `multiple` attribute.
       *
       * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
       * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
       * not trigger a re-rendering of the model.
       *
       * # CSS classes
       * The following CSS classes are added and removed on the associated input/select/textarea element
       * depending on the validity of the model.
       *
       *  - `ng-valid`: the model is valid
       *  - `ng-invalid`: the model is invalid
       *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
       *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
       *  - `ng-pristine`: the control hasn't been interacted with yet
       *  - `ng-dirty`: the control has been interacted with
       *  - `ng-touched`: the control has been blurred
       *  - `ng-untouched`: the control hasn't been blurred
       *  - `ng-pending`: any `$asyncValidators` are unfulfilled
       *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
       *     by the {@link ngModel.NgModelController#$isEmpty} method
       *  - `ng-not-empty`: the view contains a non-empty value
       *
       * Keep in mind that ngAnimate can detect each of these classes when added and removed.
       *
       * ## Animation Hooks
       *
       * Animations within models are triggered when any of the associated CSS classes are added and removed
       * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
       * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
       * The animations that are triggered within ngModel are similar to how they work in ngClass and
       * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
       *
       * The following example shows a simple way to utilize CSS transitions to style an input element
       * that has been rendered as invalid after it has been validated:
       *
       * <pre>
       * //be sure to include ngAnimate as a module to hook into more
       * //advanced animations
       * .my-input {
       *   transition:0.5s linear all;
       *   background: white;
       * }
       * .my-input.ng-invalid {
       *   background: red;
       *   color:white;
       * }
       * </pre>
       *
       * @example
       * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
           <file name="index.html">
             <script>
              angular.module('inputExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.val = '1';
                }]);
             </script>
             <style>
               .my-input {
                 transition:all linear 0.5s;
                 background: transparent;
               }
               .my-input.ng-invalid {
                 color:white;
                 background: red;
               }
             </style>
             <p id="inputDescription">
              Update input to see transitions when valid/invalid.
              Integer is a valid value.
             </p>
             <form name="testForm" ng-controller="ExampleController">
               <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                      aria-describedby="inputDescription" />
             </form>
           </file>
       * </example>
       *
       * ## Binding to a getter/setter
       *
       * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
       * function that returns a representation of the model when called with zero arguments, and sets
       * the internal state of a model when called with an argument. It's sometimes useful to use this
       * for models that have an internal representation that's different from what the model exposes
       * to the view.
       *
       * <div class="alert alert-success">
       * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
       * frequently than other parts of your code.
       * </div>
       *
       * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
       * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
       * a `<form>`, which will enable this behavior for all `<input>`s within it. See
       * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
       *
       * The following example shows how to use `ngModel` with a getter/setter:
       *
       * @example
       * <example name="ngModel-getter-setter" module="getterSetterExample">
           <file name="index.html">
             <div ng-controller="ExampleController">
               <form name="userForm">
                 <label>Name:
                   <input type="text" name="userName"
                          ng-model="user.name"
                          ng-model-options="{ getterSetter: true }" />
                 </label>
               </form>
               <pre>user.name = <span ng-bind="user.name()"></span></pre>
             </div>
           </file>
           <file name="app.js">
             angular.module('getterSetterExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 var _name = 'Brian';
                 $scope.user = {
                   name: function(newName) {
                    // Note that newName can be undefined for two reasons:
                    // 1. Because it is called as a getter and thus called with no arguments
                    // 2. Because the property should actually be set to undefined. This happens e.g. if the
                    //    input is invalid
                    return arguments.length ? (_name = newName) : _name;
                   }
                 };
               }]);
           </file>
       * </example>
       */
      var ngModelDirective = ['$rootScope', function ($rootScope) {
        return {
          restrict: 'A',
          require: ['ngModel', '^?form', '^?ngModelOptions'],
          controller: NgModelController,
          // Prelink needs to run before any input directive
          // so that we can set the NgModelOptions in NgModelController
          // before anyone else uses it.
          priority: 1,
          compile: function ngModelCompile(element) {
            // Setup initial state of the control
            element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

            return {
              pre: function ngModelPreLink(scope, element, attr, ctrls) {
                var modelCtrl = ctrls[0],
                    formCtrl = ctrls[1] || modelCtrl.$$parentForm;

                modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);

                // notify others, especially parent forms
                formCtrl.$addControl(modelCtrl);

                attr.$observe('name', function (newValue) {
                  if (modelCtrl.$name !== newValue) {
                    modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
                  }
                });

                scope.$on('$destroy', function () {
                  modelCtrl.$$parentForm.$removeControl(modelCtrl);
                });
              },
              post: function ngModelPostLink(scope, element, attr, ctrls) {
                var modelCtrl = ctrls[0];
                if (modelCtrl.$options && modelCtrl.$options.updateOn) {
                  element.on(modelCtrl.$options.updateOn, function (ev) {
                    modelCtrl.$$debounceViewValueCommit(ev && ev.type);
                  });
                }

                element.on('blur', function () {
                  if (modelCtrl.$touched) return;

                  if ($rootScope.$$phase) {
                    scope.$evalAsync(modelCtrl.$setTouched);
                  } else {
                    scope.$apply(modelCtrl.$setTouched);
                  }
                });
              }
            };
          }
        };
      }];

      var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

      /**
       * @ngdoc directive
       * @name ngModelOptions
       *
       * @description
       * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
       * events that will trigger a model update and/or a debouncing delay so that the actual update only
       * takes place when a timer expires; this timer will be reset after another change takes place.
       *
       * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
       * be different from the value in the actual model. This means that if you update the model you
       * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
       * order to make sure it is synchronized with the model and that any debounced action is canceled.
       *
       * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
       * method is by making sure the input is placed inside a form that has a `name` attribute. This is
       * important because `form` controllers are published to the related scope under the name in their
       * `name` attribute.
       *
       * Any pending changes will take place immediately when an enclosing form is submitted via the
       * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
       * to have access to the updated model.
       *
       * `ngModelOptions` has an effect on the element it's declared on and its descendants.
       *
       * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
       *   - `updateOn`: string specifying which event should the input be bound to. You can set several
       *     events using an space delimited list. There is a special event called `default` that
       *     matches the default events belonging of the control.
       *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
       *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
       *     custom value for each event. For example:
       *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
       *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
       *     not validate correctly instead of the default behavior of setting the model to undefined.
       *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
             `ngModel` as getters/setters.
       *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
       *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
       *     continental US time zone abbreviations, but for general use, use a time zone offset, for
       *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
       *     If not specified, the timezone of the browser will be used.
       *
       * @example
      
        The following example shows how to override immediate updates. Changes on the inputs within the
        form will update the model only when the control loses focus (blur event). If `escape` key is
        pressed while the input field is focused, the value is reset to the value in the current model.
      
        <example name="ngModelOptions-directive-blur" module="optionsExample">
          <file name="index.html">
            <div ng-controller="ExampleController">
              <form name="userForm">
                <label>Name:
                  <input type="text" name="userName"
                         ng-model="user.name"
                         ng-model-options="{ updateOn: 'blur' }"
                         ng-keyup="cancel($event)" />
                </label><br />
                <label>Other data:
                  <input type="text" ng-model="user.data" />
                </label><br />
              </form>
              <pre>user.name = <span ng-bind="user.name"></span></pre>
              <pre>user.data = <span ng-bind="user.data"></span></pre>
            </div>
          </file>
          <file name="app.js">
            angular.module('optionsExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.user = { name: 'John', data: '' };
      
                $scope.cancel = function(e) {
                  if (e.keyCode == 27) {
                    $scope.userForm.userName.$rollbackViewValue();
                  }
                };
              }]);
          </file>
          <file name="protractor.js" type="protractor">
            var model = element(by.binding('user.name'));
            var input = element(by.model('user.name'));
            var other = element(by.model('user.data'));
      
            it('should allow custom events', function() {
              input.sendKeys(' Doe');
              input.click();
              expect(model.getText()).toEqual('John');
              other.click();
              expect(model.getText()).toEqual('John Doe');
            });
      
            it('should $rollbackViewValue when model changes', function() {
              input.sendKeys(' Doe');
              expect(input.getAttribute('value')).toEqual('John Doe');
              input.sendKeys(protractor.Key.ESCAPE);
              expect(input.getAttribute('value')).toEqual('John');
              other.click();
              expect(model.getText()).toEqual('John');
            });
          </file>
        </example>
      
        This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
        If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
      
        <example name="ngModelOptions-directive-debounce" module="optionsExample">
          <file name="index.html">
            <div ng-controller="ExampleController">
              <form name="userForm">
                <label>Name:
                  <input type="text" name="userName"
                         ng-model="user.name"
                         ng-model-options="{ debounce: 1000 }" />
                </label>
                <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
                <br />
              </form>
              <pre>user.name = <span ng-bind="user.name"></span></pre>
            </div>
          </file>
          <file name="app.js">
            angular.module('optionsExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.user = { name: 'Igor' };
              }]);
          </file>
        </example>
      
        This one shows how to bind to getter/setters:
      
        <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
          <file name="index.html">
            <div ng-controller="ExampleController">
              <form name="userForm">
                <label>Name:
                  <input type="text" name="userName"
                         ng-model="user.name"
                         ng-model-options="{ getterSetter: true }" />
                </label>
              </form>
              <pre>user.name = <span ng-bind="user.name()"></span></pre>
            </div>
          </file>
          <file name="app.js">
            angular.module('getterSetterExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                var _name = 'Brian';
                $scope.user = {
                  name: function(newName) {
                    // Note that newName can be undefined for two reasons:
                    // 1. Because it is called as a getter and thus called with no arguments
                    // 2. Because the property should actually be set to undefined. This happens e.g. if the
                    //    input is invalid
                    return arguments.length ? (_name = newName) : _name;
                  }
                };
              }]);
          </file>
        </example>
       */
      var ngModelOptionsDirective = function () {
        return {
          restrict: 'A',
          controller: ['$scope', '$attrs', function ($scope, $attrs) {
            var that = this;
            this.$options = copy($scope.$eval($attrs.ngModelOptions));
            // Allow adding/overriding bound events
            if (isDefined(this.$options.updateOn)) {
              this.$options.updateOnDefault = false;
              // extract "default" pseudo-event from list of events that can trigger a model update
              this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function () {
                that.$options.updateOnDefault = true;
                return ' ';
              }));
            } else {
              this.$options.updateOnDefault = true;
            }
          }]
        };
      };

      // helper methods
      function addSetValidityMethod(context) {
        var ctrl = context.ctrl,
            $element = context.$element,
            classCache = {},
            set = context.set,
            unset = context.unset,
            $animate = context.$animate;

        classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));

        ctrl.$setValidity = setValidity;

        function setValidity(validationErrorKey, state, controller) {
          if (isUndefined(state)) {
            createAndSet('$pending', validationErrorKey, controller);
          } else {
            unsetAndCleanup('$pending', validationErrorKey, controller);
          }
          if (!isBoolean(state)) {
            unset(ctrl.$error, validationErrorKey, controller);
            unset(ctrl.$$success, validationErrorKey, controller);
          } else {
            if (state) {
              unset(ctrl.$error, validationErrorKey, controller);
              set(ctrl.$$success, validationErrorKey, controller);
            } else {
              set(ctrl.$error, validationErrorKey, controller);
              unset(ctrl.$$success, validationErrorKey, controller);
            }
          }
          if (ctrl.$pending) {
            cachedToggleClass(PENDING_CLASS, true);
            ctrl.$valid = ctrl.$invalid = undefined;
            toggleValidationCss('', null);
          } else {
            cachedToggleClass(PENDING_CLASS, false);
            ctrl.$valid = isObjectEmpty(ctrl.$error);
            ctrl.$invalid = !ctrl.$valid;
            toggleValidationCss('', ctrl.$valid);
          }

          // re-read the state as the set/unset methods could have
          // combined state in ctrl.$error[validationError] (used for forms),
          // where setting/unsetting only increments/decrements the value,
          // and does not replace it.
          var combinedState;
          if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
            combinedState = undefined;
          } else if (ctrl.$error[validationErrorKey]) {
            combinedState = false;
          } else if (ctrl.$$success[validationErrorKey]) {
            combinedState = true;
          } else {
            combinedState = null;
          }

          toggleValidationCss(validationErrorKey, combinedState);
          ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
        }

        function createAndSet(name, value, controller) {
          if (!ctrl[name]) {
            ctrl[name] = {};
          }
          set(ctrl[name], value, controller);
        }

        function unsetAndCleanup(name, value, controller) {
          if (ctrl[name]) {
            unset(ctrl[name], value, controller);
          }
          if (isObjectEmpty(ctrl[name])) {
            ctrl[name] = undefined;
          }
        }

        function cachedToggleClass(className, switchValue) {
          if (switchValue && !classCache[className]) {
            $animate.addClass($element, className);
            classCache[className] = true;
          } else if (!switchValue && classCache[className]) {
            $animate.removeClass($element, className);
            classCache[className] = false;
          }
        }

        function toggleValidationCss(validationErrorKey, isValid) {
          validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

          cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
          cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
        }
      }

      function isObjectEmpty(obj) {
        if (obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              return false;
            }
          }
        }
        return true;
      }

      /**
       * @ngdoc directive
       * @name ngNonBindable
       * @restrict AC
       * @priority 1000
       *
       * @description
       * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
       * DOM element. This is useful if the element contains what appears to be Angular directives and
       * bindings but which should be ignored by Angular. This could be the case if you have a site that
       * displays snippets of code, for instance.
       *
       * @element ANY
       *
       * @example
       * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
       * but the one wrapped in `ngNonBindable` is left alone.
       *
       * @example
          <example>
            <file name="index.html">
              <div>Normal: {{1 + 2}}</div>
              <div ng-non-bindable>Ignored: {{1 + 2}}</div>
            </file>
            <file name="protractor.js" type="protractor">
             it('should check ng-non-bindable', function() {
               expect(element(by.binding('1 + 2')).getText()).toContain('3');
               expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
             });
            </file>
          </example>
       */
      var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

      /* global jqLiteRemove */

      var ngOptionsMinErr = minErr('ngOptions');

      /**
       * @ngdoc directive
       * @name ngOptions
       * @restrict A
       *
       * @description
       *
       * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
       * elements for the `<select>` element using the array or object obtained by evaluating the
       * `ngOptions` comprehension expression.
       *
       * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
       * similar result. However, `ngOptions` provides some benefits such as reducing memory and
       * increasing speed by not creating a new scope for each repeated instance, as well as providing
       * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
       * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
       *  to a non-string value. This is because an option element can only be bound to string values at
       * present.
       *
       * When an item in the `<select>` menu is selected, the array element or object property
       * represented by the selected option will be bound to the model identified by the `ngModel`
       * directive.
       *
       * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
       * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
       * option. See example below for demonstration.
       *
       * ## Complex Models (objects or collections)
       *
       * By default, `ngModel` watches the model by reference, not value. This is important to know when
       * binding the select to a model that is an object or a collection.
       *
       * One issue occurs if you want to preselect an option. For example, if you set
       * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
       * because the objects are not identical. So by default, you should always reference the item in your collection
       * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
       *
       * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
       * of the item not by reference, but by the result of the `track by` expression. For example, if your
       * collection items have an id property, you would `track by item.id`.
       *
       * A different issue with objects or collections is that ngModel won't detect if an object property or
       * a collection item changes. For that reason, `ngOptions` additionally watches the model using
       * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
       * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
       * has not changed identity, but only a property on the object or an item in the collection changes.
       *
       * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
       * if the model is an array). This means that changing a property deeper than the first level inside the
       * object/collection will not trigger a re-rendering.
       *
       * ## `select` **`as`**
       *
       * Using `select` **`as`** will bind the result of the `select` expression to the model, but
       * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
       * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
       * is used, the result of that expression will be set as the value of the `option` and `select` elements.
       *
       *
       * ### `select` **`as`** and **`track by`**
       *
       * <div class="alert alert-warning">
       * Be careful when using `select` **`as`** and **`track by`** in the same expression.
       * </div>
       *
       * Given this array of items on the $scope:
       *
       * ```js
       * $scope.items = [{
       *   id: 1,
       *   label: 'aLabel',
       *   subItem: { name: 'aSubItem' }
       * }, {
       *   id: 2,
       *   label: 'bLabel',
       *   subItem: { name: 'bSubItem' }
       * }];
       * ```
       *
       * This will work:
       *
       * ```html
       * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
       * ```
       * ```js
       * $scope.selected = $scope.items[0];
       * ```
       *
       * but this will not work:
       *
       * ```html
       * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
       * ```
       * ```js
       * $scope.selected = $scope.items[0].subItem;
       * ```
       *
       * In both examples, the **`track by`** expression is applied successfully to each `item` in the
       * `items` array. Because the selected option has been set programmatically in the controller, the
       * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
       * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
       * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
       * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
       * is not matched against any `<option>` and the `<select>` appears as having no selected value.
       *
       *
       * @param {string} ngModel Assignable angular expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required The control is considered valid only if value is entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {comprehension_expression=} ngOptions in one of the following forms:
       *
       *   * for array data sources:
       *     * `label` **`for`** `value` **`in`** `array`
       *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
       *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
       *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
       *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
       *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
       *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
       *        (for including a filter with `track by`)
       *   * for object data sources:
       *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
       *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
       *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
       *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
       *     * `select` **`as`** `label` **`group by`** `group`
       *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
       *     * `select` **`as`** `label` **`disable when`** `disable`
       *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
       *
       * Where:
       *
       *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
       *   * `value`: local variable which will refer to each item in the `array` or each property value
       *      of `object` during iteration.
       *   * `key`: local variable which will refer to a property name in `object` during iteration.
       *   * `label`: The result of this expression will be the label for `<option>` element. The
       *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
       *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
       *      element. If not specified, `select` expression will default to `value`.
       *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
       *      DOM element.
       *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
       *      element. Return `true` to disable.
       *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
       *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
       *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
       *      even when the options are recreated (e.g. reloaded from the server).
       *
       * @example
          <example module="selectExample">
            <file name="index.html">
              <script>
              angular.module('selectExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.colors = [
                    {name:'black', shade:'dark'},
                    {name:'white', shade:'light', notAnOption: true},
                    {name:'red', shade:'dark'},
                    {name:'blue', shade:'dark', notAnOption: true},
                    {name:'yellow', shade:'light', notAnOption: false}
                  ];
                  $scope.myColor = $scope.colors[2]; // red
                }]);
              </script>
              <div ng-controller="ExampleController">
                <ul>
                  <li ng-repeat="color in colors">
                    <label>Name: <input ng-model="color.name"></label>
                    <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
                    <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
                  </li>
                  <li>
                    <button ng-click="colors.push({})">add</button>
                  </li>
                </ul>
                <hr/>
                <label>Color (null not allowed):
                  <select ng-model="myColor" ng-options="color.name for color in colors"></select>
                </label><br/>
                <label>Color (null allowed):
                <span  class="nullable">
                  <select ng-model="myColor" ng-options="color.name for color in colors">
                    <option value="">-- choose color --</option>
                  </select>
                </span></label><br/>
      
                <label>Color grouped by shade:
                  <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
                  </select>
                </label><br/>
      
                <label>Color grouped by shade, with some disabled:
                  <select ng-model="myColor"
                        ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
                  </select>
                </label><br/>
      
      
      
                Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
                <br/>
                <hr/>
                Currently selected: {{ {selected_color:myColor} }}
                <div style="border:solid 1px black; height:20px"
                     ng-style="{'background-color':myColor.name}">
                </div>
              </div>
            </file>
            <file name="protractor.js" type="protractor">
               it('should check ng-options', function() {
                 expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
                 element.all(by.model('myColor')).first().click();
                 element.all(by.css('select[ng-model="myColor"] option')).first().click();
                 expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
                 element(by.css('.nullable select[ng-model="myColor"]')).click();
                 element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
                 expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
               });
            </file>
          </example>
       */

      // jshint maxlen: false
      //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
      var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
      // 1: value expression (valueFn)
      // 2: label expression (displayFn)
      // 3: group by expression (groupByFn)
      // 4: disable when expression (disableWhenFn)
      // 5: array item variable name
      // 6: object item key variable name
      // 7: object item value variable name
      // 8: collection expression
      // 9: track by expression
      // jshint maxlen: 100


      var ngOptionsDirective = ['$compile', '$document', '$parse', function ($compile, $document, $parse) {

        function parseOptionsExpression(optionsExp, selectElement, scope) {

          var match = optionsExp.match(NG_OPTIONS_REGEXP);
          if (!match) {
            throw ngOptionsMinErr('iexp', "Expected expression in form of " + "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" + " but got '{0}'. Element: {1}", optionsExp, startingTag(selectElement));
          }

          // Extract the parts from the ngOptions expression

          // The variable name for the value of the item in the collection
          var valueName = match[5] || match[7];
          // The variable name for the key of the item in the collection
          var keyName = match[6];

          // An expression that generates the viewValue for an option if there is a label expression
          var selectAs = / as /.test(match[0]) && match[1];
          // An expression that is used to track the id of each object in the options collection
          var trackBy = match[9];
          // An expression that generates the viewValue for an option if there is no label expression
          var valueFn = $parse(match[2] ? match[1] : valueName);
          var selectAsFn = selectAs && $parse(selectAs);
          var viewValueFn = selectAsFn || valueFn;
          var trackByFn = trackBy && $parse(trackBy);

          // Get the value by which we are going to track the option
          // if we have a trackFn then use that (passing scope and locals)
          // otherwise just hash the given viewValue
          var getTrackByValueFn = trackBy ? function (value, locals) {
            return trackByFn(scope, locals);
          } : function getHashOfValue(value) {
            return hashKey(value);
          };
          var getTrackByValue = function (value, key) {
            return getTrackByValueFn(value, getLocals(value, key));
          };

          var displayFn = $parse(match[2] || match[1]);
          var groupByFn = $parse(match[3] || '');
          var disableWhenFn = $parse(match[4] || '');
          var valuesFn = $parse(match[8]);

          var locals = {};
          var getLocals = keyName ? function (value, key) {
            locals[keyName] = key;
            locals[valueName] = value;
            return locals;
          } : function (value) {
            locals[valueName] = value;
            return locals;
          };

          function Option(selectValue, viewValue, label, group, disabled) {
            this.selectValue = selectValue;
            this.viewValue = viewValue;
            this.label = label;
            this.group = group;
            this.disabled = disabled;
          }

          function getOptionValuesKeys(optionValues) {
            var optionValuesKeys;

            if (!keyName && isArrayLike(optionValues)) {
              optionValuesKeys = optionValues;
            } else {
              // if object, extract keys, in enumeration order, unsorted
              optionValuesKeys = [];
              for (var itemKey in optionValues) {
                if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
                  optionValuesKeys.push(itemKey);
                }
              }
            }
            return optionValuesKeys;
          }

          return {
            trackBy: trackBy,
            getTrackByValue: getTrackByValue,
            getWatchables: $parse(valuesFn, function (optionValues) {
              // Create a collection of things that we would like to watch (watchedArray)
              // so that they can all be watched using a single $watchCollection
              // that only runs the handler once if anything changes
              var watchedArray = [];
              optionValues = optionValues || [];

              var optionValuesKeys = getOptionValuesKeys(optionValues);
              var optionValuesLength = optionValuesKeys.length;
              for (var index = 0; index < optionValuesLength; index++) {
                var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                var value = optionValues[key];

                var locals = getLocals(value, key);
                var selectValue = getTrackByValueFn(value, locals);
                watchedArray.push(selectValue);

                // Only need to watch the displayFn if there is a specific label expression
                if (match[2] || match[1]) {
                  var label = displayFn(scope, locals);
                  watchedArray.push(label);
                }

                // Only need to watch the disableWhenFn if there is a specific disable expression
                if (match[4]) {
                  var disableWhen = disableWhenFn(scope, locals);
                  watchedArray.push(disableWhen);
                }
              }
              return watchedArray;
            }),

            getOptions: function () {

              var optionItems = [];
              var selectValueMap = {};

              // The option values were already computed in the `getWatchables` fn,
              // which must have been called to trigger `getOptions`
              var optionValues = valuesFn(scope) || [];
              var optionValuesKeys = getOptionValuesKeys(optionValues);
              var optionValuesLength = optionValuesKeys.length;

              for (var index = 0; index < optionValuesLength; index++) {
                var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                var value = optionValues[key];
                var locals = getLocals(value, key);
                var viewValue = viewValueFn(scope, locals);
                var selectValue = getTrackByValueFn(viewValue, locals);
                var label = displayFn(scope, locals);
                var group = groupByFn(scope, locals);
                var disabled = disableWhenFn(scope, locals);
                var optionItem = new Option(selectValue, viewValue, label, group, disabled);

                optionItems.push(optionItem);
                selectValueMap[selectValue] = optionItem;
              }

              return {
                items: optionItems,
                selectValueMap: selectValueMap,
                getOptionFromViewValue: function (value) {
                  return selectValueMap[getTrackByValue(value)];
                },
                getViewValueFromOption: function (option) {
                  // If the viewValue could be an object that may be mutated by the application,
                  // we need to make a copy and not return the reference to the value on the option.
                  return trackBy ? angular.copy(option.viewValue) : option.viewValue;
                }
              };
            }
          };
        }

        // we can't just jqLite('<option>') since jqLite is not smart enough
        // to create it in <select> and IE barfs otherwise.
        var optionTemplate = window.document.createElement('option'),
            optGroupTemplate = window.document.createElement('optgroup');

        function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

          var selectCtrl = ctrls[0];
          var ngModelCtrl = ctrls[1];
          var multiple = attr.multiple;

          // The emptyOption allows the application developer to provide their own custom "empty"
          // option when the viewValue does not match any of the option values.
          var emptyOption;
          for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
            if (children[i].value === '') {
              emptyOption = children.eq(i);
              break;
            }
          }

          var providedEmptyOption = !!emptyOption;

          var unknownOption = jqLite(optionTemplate.cloneNode(false));
          unknownOption.val('?');

          var options;
          var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
          // This stores the newly created options before they are appended to the select.
          // Since the contents are removed from the fragment when it is appended,
          // we only need to create it once.
          var listFragment = $document[0].createDocumentFragment();

          var renderEmptyOption = function () {
            if (!providedEmptyOption) {
              selectElement.prepend(emptyOption);
            }
            selectElement.val('');
            emptyOption.prop('selected', true); // needed for IE
            emptyOption.attr('selected', true);
          };

          var removeEmptyOption = function () {
            if (!providedEmptyOption) {
              emptyOption.remove();
            }
          };

          var renderUnknownOption = function () {
            selectElement.prepend(unknownOption);
            selectElement.val('?');
            unknownOption.prop('selected', true); // needed for IE
            unknownOption.attr('selected', true);
          };

          var removeUnknownOption = function () {
            unknownOption.remove();
          };

          // Update the controller methods for multiple selectable options
          if (!multiple) {

            selectCtrl.writeValue = function writeNgOptionsValue(value) {
              var option = options.getOptionFromViewValue(value);

              if (option) {
                // Don't update the option when it is already selected.
                // For example, the browser will select the first option by default. In that case,
                // most properties are set automatically - except the `selected` attribute, which we
                // set always

                if (selectElement[0].value !== option.selectValue) {
                  removeUnknownOption();
                  removeEmptyOption();

                  selectElement[0].value = option.selectValue;
                  option.element.selected = true;
                }

                option.element.setAttribute('selected', 'selected');
              } else {
                if (value === null || providedEmptyOption) {
                  removeUnknownOption();
                  renderEmptyOption();
                } else {
                  removeEmptyOption();
                  renderUnknownOption();
                }
              }
            };

            selectCtrl.readValue = function readNgOptionsValue() {

              var selectedOption = options.selectValueMap[selectElement.val()];

              if (selectedOption && !selectedOption.disabled) {
                removeEmptyOption();
                removeUnknownOption();
                return options.getViewValueFromOption(selectedOption);
              }
              return null;
            };

            // If we are using `track by` then we must watch the tracked value on the model
            // since ngModel only watches for object identity change
            if (ngOptions.trackBy) {
              scope.$watch(function () {
                return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
              }, function () {
                ngModelCtrl.$render();
              });
            }
          } else {

            ngModelCtrl.$isEmpty = function (value) {
              return !value || value.length === 0;
            };

            selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
              options.items.forEach(function (option) {
                option.element.selected = false;
              });

              if (value) {
                value.forEach(function (item) {
                  var option = options.getOptionFromViewValue(item);
                  if (option) option.element.selected = true;
                });
              }
            };

            selectCtrl.readValue = function readNgOptionsMultiple() {
              var selectedValues = selectElement.val() || [],
                  selections = [];

              forEach(selectedValues, function (value) {
                var option = options.selectValueMap[value];
                if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
              });

              return selections;
            };

            // If we are using `track by` then we must watch these tracked values on the model
            // since ngModel only watches for object identity change
            if (ngOptions.trackBy) {

              scope.$watchCollection(function () {
                if (isArray(ngModelCtrl.$viewValue)) {
                  return ngModelCtrl.$viewValue.map(function (value) {
                    return ngOptions.getTrackByValue(value);
                  });
                }
              }, function () {
                ngModelCtrl.$render();
              });
            }
          }

          if (providedEmptyOption) {

            // we need to remove it before calling selectElement.empty() because otherwise IE will
            // remove the label from the element. wtf?
            emptyOption.remove();

            // compile the element since there might be bindings in it
            $compile(emptyOption)(scope);

            // remove the class, which is added automatically because we recompile the element and it
            // becomes the compilation root
            emptyOption.removeClass('ng-scope');
          } else {
            emptyOption = jqLite(optionTemplate.cloneNode(false));
          }

          selectElement.empty();

          // We need to do this here to ensure that the options object is defined
          // when we first hit it in writeNgOptionsValue
          updateOptions();

          // We will re-render the option elements if the option values or labels change
          scope.$watchCollection(ngOptions.getWatchables, updateOptions);

          // ------------------------------------------------------------------ //

          function addOptionElement(option, parent) {
            var optionElement = optionTemplate.cloneNode(false);
            parent.appendChild(optionElement);
            updateOptionElement(option, optionElement);
          }

          function updateOptionElement(option, element) {
            option.element = element;
            element.disabled = option.disabled;
            // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
            // selects in certain circumstances when multiple selects are next to each other and display
            // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
            // See https://github.com/angular/angular.js/issues/11314 for more info.
            // This is unfortunately untestable with unit / e2e tests
            if (option.label !== element.label) {
              element.label = option.label;
              element.textContent = option.label;
            }
            if (option.value !== element.value) element.value = option.selectValue;
          }

          function updateOptions() {
            var previousValue = options && selectCtrl.readValue();

            // We must remove all current options, but cannot simply set innerHTML = null
            // since the providedEmptyOption might have an ngIf on it that inserts comments which we
            // must preserve.
            // Instead, iterate over the current option elements and remove them or their optgroup
            // parents
            if (options) {

              for (var i = options.items.length - 1; i >= 0; i--) {
                var option = options.items[i];
                if (isDefined(option.group)) {
                  jqLiteRemove(option.element.parentNode);
                } else {
                  jqLiteRemove(option.element);
                }
              }
            }

            options = ngOptions.getOptions();

            var groupElementMap = {};

            // Ensure that the empty option is always there if it was explicitly provided
            if (providedEmptyOption) {
              selectElement.prepend(emptyOption);
            }

            options.items.forEach(function addOption(option) {
              var groupElement;

              if (isDefined(option.group)) {

                // This option is to live in a group
                // See if we have already created this group
                groupElement = groupElementMap[option.group];

                if (!groupElement) {

                  groupElement = optGroupTemplate.cloneNode(false);
                  listFragment.appendChild(groupElement);

                  // Update the label on the group element
                  // "null" is special cased because of Safari
                  groupElement.label = option.group === null ? 'null' : option.group;

                  // Store it for use later
                  groupElementMap[option.group] = groupElement;
                }

                addOptionElement(option, groupElement);
              } else {

                // This option is not in a group
                addOptionElement(option, listFragment);
              }
            });

            selectElement[0].appendChild(listFragment);

            ngModelCtrl.$render();

            // Check to see if the value has changed due to the update to the options
            if (!ngModelCtrl.$isEmpty(previousValue)) {
              var nextValue = selectCtrl.readValue();
              var isNotPrimitive = ngOptions.trackBy || multiple;
              if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
                ngModelCtrl.$setViewValue(nextValue);
                ngModelCtrl.$render();
              }
            }
          }
        }

        return {
          restrict: 'A',
          terminal: true,
          require: ['select', 'ngModel'],
          link: {
            pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
              // Deactivate the SelectController.register method to prevent
              // option directives from accidentally registering themselves
              // (and unwanted $destroy handlers etc.)
              ctrls[0].registerOption = noop;
            },
            post: ngOptionsPostLink
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngPluralize
       * @restrict EA
       *
       * @description
       * `ngPluralize` is a directive that displays messages according to en-US localization rules.
       * These rules are bundled with angular.js, but can be overridden
       * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
       * by specifying the mappings between
       * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
       * and the strings to be displayed.
       *
       * # Plural categories and explicit number rules
       * There are two
       * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
       * in Angular's default en-US locale: "one" and "other".
       *
       * While a plural category may match many numbers (for example, in en-US locale, "other" can match
       * any number that is not 1), an explicit number rule can only match one number. For example, the
       * explicit number rule for "3" matches the number 3. There are examples of plural categories
       * and explicit number rules throughout the rest of this documentation.
       *
       * # Configuring ngPluralize
       * You configure ngPluralize by providing 2 attributes: `count` and `when`.
       * You can also provide an optional attribute, `offset`.
       *
       * The value of the `count` attribute can be either a string or an {@link guide/expression
       * Angular expression}; these are evaluated on the current scope for its bound value.
       *
       * The `when` attribute specifies the mappings between plural categories and the actual
       * string to be displayed. The value of the attribute should be a JSON object.
       *
       * The following example shows how to configure ngPluralize:
       *
       * ```html
       * <ng-pluralize count="personCount"
                       when="{'0': 'Nobody is viewing.',
       *                      'one': '1 person is viewing.',
       *                      'other': '{} people are viewing.'}">
       * </ng-pluralize>
       *```
       *
       * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
       * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
       * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
       * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
       * show "a dozen people are viewing".
       *
       * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
       * into pluralized strings. In the previous example, Angular will replace `{}` with
       * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
       * for <span ng-non-bindable>{{numberExpression}}</span>.
       *
       * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
       * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
       *
       * # Configuring ngPluralize with offset
       * The `offset` attribute allows further customization of pluralized text, which can result in
       * a better user experience. For example, instead of the message "4 people are viewing this document",
       * you might display "John, Kate and 2 others are viewing this document".
       * The offset attribute allows you to offset a number by any desired value.
       * Let's take a look at an example:
       *
       * ```html
       * <ng-pluralize count="personCount" offset=2
       *               when="{'0': 'Nobody is viewing.',
       *                      '1': '{{person1}} is viewing.',
       *                      '2': '{{person1}} and {{person2}} are viewing.',
       *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
       *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
       * </ng-pluralize>
       * ```
       *
       * Notice that we are still using two plural categories(one, other), but we added
       * three explicit number rules 0, 1 and 2.
       * When one person, perhaps John, views the document, "John is viewing" will be shown.
       * When three people view the document, no explicit number rule is found, so
       * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
       * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
       * is shown.
       *
       * Note that when you specify offsets, you must provide explicit number rules for
       * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
       * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
       * plural categories "one" and "other".
       *
       * @param {string|expression} count The variable to be bound to.
       * @param {string} when The mapping between plural category to its corresponding strings.
       * @param {number=} offset Offset to deduct from the total number.
       *
       * @example
          <example module="pluralizeExample">
            <file name="index.html">
              <script>
                angular.module('pluralizeExample', [])
                  .controller('ExampleController', ['$scope', function($scope) {
                    $scope.person1 = 'Igor';
                    $scope.person2 = 'Misko';
                    $scope.personCount = 1;
                  }]);
              </script>
              <div ng-controller="ExampleController">
                <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
                <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
                <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
      
                <!--- Example with simple pluralization rules for en locale --->
                Without Offset:
                <ng-pluralize count="personCount"
                              when="{'0': 'Nobody is viewing.',
                                     'one': '1 person is viewing.',
                                     'other': '{} people are viewing.'}">
                </ng-pluralize><br>
      
                <!--- Example with offset --->
                With Offset(2):
                <ng-pluralize count="personCount" offset=2
                              when="{'0': 'Nobody is viewing.',
                                     '1': '{{person1}} is viewing.',
                                     '2': '{{person1}} and {{person2}} are viewing.',
                                     'one': '{{person1}}, {{person2}} and one other person are viewing.',
                                     'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
                </ng-pluralize>
              </div>
            </file>
            <file name="protractor.js" type="protractor">
              it('should show correct pluralized string', function() {
                var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
                var withOffset = element.all(by.css('ng-pluralize')).get(1);
                var countInput = element(by.model('personCount'));
      
                expect(withoutOffset.getText()).toEqual('1 person is viewing.');
                expect(withOffset.getText()).toEqual('Igor is viewing.');
      
                countInput.clear();
                countInput.sendKeys('0');
      
                expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
                expect(withOffset.getText()).toEqual('Nobody is viewing.');
      
                countInput.clear();
                countInput.sendKeys('2');
      
                expect(withoutOffset.getText()).toEqual('2 people are viewing.');
                expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
      
                countInput.clear();
                countInput.sendKeys('3');
      
                expect(withoutOffset.getText()).toEqual('3 people are viewing.');
                expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
      
                countInput.clear();
                countInput.sendKeys('4');
      
                expect(withoutOffset.getText()).toEqual('4 people are viewing.');
                expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
              });
              it('should show data-bound names', function() {
                var withOffset = element.all(by.css('ng-pluralize')).get(1);
                var personCount = element(by.model('personCount'));
                var person1 = element(by.model('person1'));
                var person2 = element(by.model('person2'));
                personCount.clear();
                personCount.sendKeys('4');
                person1.clear();
                person1.sendKeys('Di');
                person2.clear();
                person2.sendKeys('Vojta');
                expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
              });
            </file>
          </example>
       */
      var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function ($locale, $interpolate, $log) {
        var BRACE = /{}/g,
            IS_WHEN = /^when(Minus)?(.+)$/;

        return {
          link: function (scope, element, attr) {
            var numberExp = attr.count,
                whenExp = attr.$attr.when && element.attr(attr.$attr.when),
                // we have {{}} in attrs
            offset = attr.offset || 0,
                whens = scope.$eval(whenExp) || {},
                whensExpFns = {},
                startSymbol = $interpolate.startSymbol(),
                endSymbol = $interpolate.endSymbol(),
                braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
                watchRemover = angular.noop,
                lastCount;

            forEach(attr, function (expression, attributeName) {
              var tmpMatch = IS_WHEN.exec(attributeName);
              if (tmpMatch) {
                var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
                whens[whenKey] = element.attr(attr.$attr[attributeName]);
              }
            });
            forEach(whens, function (expression, key) {
              whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
            });

            scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
              var count = parseFloat(newVal);
              var countIsNaN = isNaN(count);

              if (!countIsNaN && !(count in whens)) {
                // If an explicit number rule such as 1, 2, 3... is defined, just use it.
                // Otherwise, check it against pluralization rules in $locale service.
                count = $locale.pluralCat(count - offset);
              }

              // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
              // In JS `NaN !== NaN`, so we have to explicitly check.
              if (count !== lastCount && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
                watchRemover();
                var whenExpFn = whensExpFns[count];
                if (isUndefined(whenExpFn)) {
                  if (newVal != null) {
                    $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
                  }
                  watchRemover = noop;
                  updateElementText();
                } else {
                  watchRemover = scope.$watch(whenExpFn, updateElementText);
                }
                lastCount = count;
              }
            });

            function updateElementText(newText) {
              element.text(newText || '');
            }
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngRepeat
       * @multiElement
       *
       * @description
       * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
       * instance gets its own scope, where the given loop variable is set to the current collection item,
       * and `$index` is set to the item index or key.
       *
       * Special properties are exposed on the local scope of each template instance, including:
       *
       * | Variable  | Type            | Details                                                                     |
       * |-----------|-----------------|-----------------------------------------------------------------------------|
       * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
       * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
       * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
       * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
       * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
       * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
       *
       * <div class="alert alert-info">
       *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
       *   This may be useful when, for instance, nesting ngRepeats.
       * </div>
       *
       *
       * # Iterating over object properties
       *
       * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
       * syntax:
       *
       * ```js
       * <div ng-repeat="(key, value) in myObj"> ... </div>
       * ```
       *
       * However, there are a limitations compared to array iteration:
       *
       * - The JavaScript specification does not define the order of keys
       *   returned for an object, so Angular relies on the order returned by the browser
       *   when running `for key in myObj`. Browsers generally follow the strategy of providing
       *   keys in the order in which they were defined, although there are exceptions when keys are deleted
       *   and reinstated. See the
       *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
       *
       * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
       *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
       *
       * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
       *   objects, and will throw an error if used with one.
       *
       * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
       * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
       * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
       * or implement a `$watch` on the object yourself.
       *
       *
       * # Tracking and Duplicates
       *
       * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
       * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
       *
       * * When an item is added, a new instance of the template is added to the DOM.
       * * When an item is removed, its template instance is removed from the DOM.
       * * When items are reordered, their respective templates are reordered in the DOM.
       *
       * To minimize creation of DOM elements, `ngRepeat` uses a function
       * to "keep track" of all items in the collection and their corresponding DOM elements.
       * For example, if an item is added to the collection, ngRepeat will know that all other items
       * already have DOM elements, and will not re-render them.
       *
       * The default tracking function (which tracks items by their identity) does not allow
       * duplicate items in arrays. This is because when there are duplicates, it is not possible
       * to maintain a one-to-one mapping between collection items and DOM elements.
       *
       * If you do need to repeat duplicate items, you can substitute the default tracking behavior
       * with your own using the `track by` expression.
       *
       * For example, you may track items by the index of each item in the collection, using the
       * special scope property `$index`:
       * ```html
       *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
       *      {{n}}
       *    </div>
       * ```
       *
       * You may also use arbitrary expressions in `track by`, including references to custom functions
       * on the scope:
       * ```html
       *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
       *      {{n}}
       *    </div>
       * ```
       *
       * <div class="alert alert-success">
       * If you are working with objects that have an identifier property, you should track
       * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
       * will not have to rebuild the DOM elements for items it has already rendered, even if the
       * JavaScript objects in the collection have been substituted for new ones. For large collections,
       * this significantly improves rendering performance. If you don't have a unique identifier,
       * `track by $index` can also provide a performance boost.
       * </div>
       * ```html
       *    <div ng-repeat="model in collection track by model.id">
       *      {{model.name}}
       *    </div>
       * ```
       *
       * When no `track by` expression is provided, it is equivalent to tracking by the built-in
       * `$id` function, which tracks items by their identity:
       * ```html
       *    <div ng-repeat="obj in collection track by $id(obj)">
       *      {{obj.prop}}
       *    </div>
       * ```
       *
       * <div class="alert alert-warning">
       * **Note:** `track by` must always be the last expression:
       * </div>
       * ```
       * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
       *     {{model.name}}
       * </div>
       * ```
       *
       * # Special repeat start and end points
       * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
       * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
       * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
       * up to and including the ending HTML tag where **ng-repeat-end** is placed.
       *
       * The example below makes use of this feature:
       * ```html
       *   <header ng-repeat-start="item in items">
       *     Header {{ item }}
       *   </header>
       *   <div class="body">
       *     Body {{ item }}
       *   </div>
       *   <footer ng-repeat-end>
       *     Footer {{ item }}
       *   </footer>
       * ```
       *
       * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
       * ```html
       *   <header>
       *     Header A
       *   </header>
       *   <div class="body">
       *     Body A
       *   </div>
       *   <footer>
       *     Footer A
       *   </footer>
       *   <header>
       *     Header B
       *   </header>
       *   <div class="body">
       *     Body B
       *   </div>
       *   <footer>
       *     Footer B
       *   </footer>
       * ```
       *
       * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
       * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
       *
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
       * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
       * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
       *
       * See the example below for defining CSS animations with ngRepeat.
       *
       * @element ANY
       * @scope
       * @priority 1000
       * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
       *   formats are currently supported:
       *
       *   * `variable in expression` – where variable is the user defined loop variable and `expression`
       *     is a scope expression giving the collection to enumerate.
       *
       *     For example: `album in artist.albums`.
       *
       *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
       *     and `expression` is the scope expression giving the collection to enumerate.
       *
       *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
       *
       *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
       *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
       *     is specified, ng-repeat associates elements by identity. It is an error to have
       *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
       *     mapped to the same DOM element, which is not possible.)
       *
       *     Note that the tracking expression must come last, after any filters, and the alias expression.
       *
       *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
       *     will be associated by item identity in the array.
       *
       *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
       *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
       *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
       *     element in the same way in the DOM.
       *
       *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
       *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
       *     property is same.
       *
       *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
       *     to items in conjunction with a tracking expression.
       *
       *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
       *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
       *     when a filter is active on the repeater, but the filtered result set is empty.
       *
       *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
       *     the items have been processed through the filter.
       *
       *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
       *     (and not as operator, inside an expression).
       *
       *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
       *
       * @example
       * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
       * results by name. New (entering) and removed (leaving) items are animated.
        <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
          <file name="index.html">
            <div ng-controller="repeatController">
              I have {{friends.length}} friends. They are:
              <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
              <ul class="example-animate-container">
                <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
                  [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
                </li>
                <li class="animate-repeat" ng-if="results.length == 0">
                  <strong>No results found...</strong>
                </li>
              </ul>
            </div>
          </file>
          <file name="script.js">
            angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
              $scope.friends = [
                {name:'John', age:25, gender:'boy'},
                {name:'Jessie', age:30, gender:'girl'},
                {name:'Johanna', age:28, gender:'girl'},
                {name:'Joy', age:15, gender:'girl'},
                {name:'Mary', age:28, gender:'girl'},
                {name:'Peter', age:95, gender:'boy'},
                {name:'Sebastian', age:50, gender:'boy'},
                {name:'Erika', age:27, gender:'girl'},
                {name:'Patrick', age:40, gender:'boy'},
                {name:'Samantha', age:60, gender:'girl'}
              ];
            });
          </file>
          <file name="animations.css">
            .example-animate-container {
              background:white;
              border:1px solid black;
              list-style:none;
              margin:0;
              padding:0 10px;
            }
      
            .animate-repeat {
              line-height:30px;
              list-style:none;
              box-sizing:border-box;
            }
      
            .animate-repeat.ng-move,
            .animate-repeat.ng-enter,
            .animate-repeat.ng-leave {
              transition:all linear 0.5s;
            }
      
            .animate-repeat.ng-leave.ng-leave-active,
            .animate-repeat.ng-move,
            .animate-repeat.ng-enter {
              opacity:0;
              max-height:0;
            }
      
            .animate-repeat.ng-leave,
            .animate-repeat.ng-move.ng-move-active,
            .animate-repeat.ng-enter.ng-enter-active {
              opacity:1;
              max-height:30px;
            }
          </file>
          <file name="protractor.js" type="protractor">
            var friends = element.all(by.repeater('friend in friends'));
      
            it('should render initial data set', function() {
              expect(friends.count()).toBe(10);
              expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
              expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
              expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
              expect(element(by.binding('friends.length')).getText())
                  .toMatch("I have 10 friends. They are:");
            });
      
             it('should update repeater when filter predicate changes', function() {
               expect(friends.count()).toBe(10);
      
               element(by.model('q')).sendKeys('ma');
      
               expect(friends.count()).toBe(2);
               expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
               expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
             });
            </file>
          </example>
       */
      var ngRepeatDirective = ['$parse', '$animate', '$compile', function ($parse, $animate, $compile) {
        var NG_REMOVED = '$$NG_REMOVED';
        var ngRepeatMinErr = minErr('ngRepeat');

        var updateScope = function (scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
          // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
          scope[valueIdentifier] = value;
          if (keyIdentifier) scope[keyIdentifier] = key;
          scope.$index = index;
          scope.$first = index === 0;
          scope.$last = index === arrayLength - 1;
          scope.$middle = !(scope.$first || scope.$last);
          // jshint bitwise: false
          scope.$odd = !(scope.$even = (index & 1) === 0);
          // jshint bitwise: true
        };

        var getBlockStart = function (block) {
          return block.clone[0];
        };

        var getBlockEnd = function (block) {
          return block.clone[block.clone.length - 1];
        };

        return {
          restrict: 'A',
          multiElement: true,
          transclude: 'element',
          priority: 1000,
          terminal: true,
          $$tlb: true,
          compile: function ngRepeatCompile($element, $attr) {
            var expression = $attr.ngRepeat;
            var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            if (!match) {
              throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
            }

            var lhs = match[1];
            var rhs = match[2];
            var aliasAs = match[3];
            var trackByExp = match[4];

            match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);

            if (!match) {
              throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.", lhs);
            }
            var valueIdentifier = match[3] || match[1];
            var keyIdentifier = match[2];

            if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
              throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.", aliasAs);
            }

            var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
            var hashFnLocals = { $id: hashKey };

            if (trackByExp) {
              trackByExpGetter = $parse(trackByExp);
            } else {
              trackByIdArrayFn = function (key, value) {
                return hashKey(value);
              };
              trackByIdObjFn = function (key) {
                return key;
              };
            }

            return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

              if (trackByExpGetter) {
                trackByIdExpFn = function (key, value, index) {
                  // assign key, value, and $index to the locals so that they can be used in hash functions
                  if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
                  hashFnLocals[valueIdentifier] = value;
                  hashFnLocals.$index = index;
                  return trackByExpGetter($scope, hashFnLocals);
                };
              }

              // Store a list of elements from previous run. This is a hash where key is the item from the
              // iterator, and the value is objects with following properties.
              //   - scope: bound scope
              //   - element: previous element.
              //   - index: position
              //
              // We are using no-proto object so that we don't need to guard against inherited props via
              // hasOwnProperty.
              var lastBlockMap = createMap();

              //watch props
              $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
                var index,
                    length,
                    previousNode = $element[0],
                    // node that cloned nodes should be inserted after
                // initialized to the comment node anchor
                nextNode,

                // Same as lastBlockMap but it has the current state. It will become the
                // lastBlockMap on the next iteration.
                nextBlockMap = createMap(),
                    collectionLength,
                    key,
                    value,
                    // key/value of iteration
                trackById,
                    trackByIdFn,
                    collectionKeys,
                    block,
                    // last object information {scope, element, id}
                nextBlockOrder,
                    elementsToRemove;

                if (aliasAs) {
                  $scope[aliasAs] = collection;
                }

                if (isArrayLike(collection)) {
                  collectionKeys = collection;
                  trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
                } else {
                  trackByIdFn = trackByIdExpFn || trackByIdObjFn;
                  // if object, extract keys, in enumeration order, unsorted
                  collectionKeys = [];
                  for (var itemKey in collection) {
                    if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                      collectionKeys.push(itemKey);
                    }
                  }
                }

                collectionLength = collectionKeys.length;
                nextBlockOrder = new Array(collectionLength);

                // locate existing items
                for (index = 0; index < collectionLength; index++) {
                  key = collection === collectionKeys ? index : collectionKeys[index];
                  value = collection[key];
                  trackById = trackByIdFn(key, value, index);
                  if (lastBlockMap[trackById]) {
                    // found previously seen block
                    block = lastBlockMap[trackById];
                    delete lastBlockMap[trackById];
                    nextBlockMap[trackById] = block;
                    nextBlockOrder[index] = block;
                  } else if (nextBlockMap[trackById]) {
                    // if collision detected. restore lastBlockMap and throw an error
                    forEach(nextBlockOrder, function (block) {
                      if (block && block.scope) lastBlockMap[block.id] = block;
                    });
                    throw ngRepeatMinErr('dupes', "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}", expression, trackById, value);
                  } else {
                    // new never before seen block
                    nextBlockOrder[index] = { id: trackById, scope: undefined, clone: undefined };
                    nextBlockMap[trackById] = true;
                  }
                }

                // remove leftover items
                for (var blockKey in lastBlockMap) {
                  block = lastBlockMap[blockKey];
                  elementsToRemove = getBlockNodes(block.clone);
                  $animate.leave(elementsToRemove);
                  if (elementsToRemove[0].parentNode) {
                    // if the element was not removed yet because of pending animation, mark it as deleted
                    // so that we can ignore it later
                    for (index = 0, length = elementsToRemove.length; index < length; index++) {
                      elementsToRemove[index][NG_REMOVED] = true;
                    }
                  }
                  block.scope.$destroy();
                }

                // we are not using forEach for perf reasons (trying to avoid #call)
                for (index = 0; index < collectionLength; index++) {
                  key = collection === collectionKeys ? index : collectionKeys[index];
                  value = collection[key];
                  block = nextBlockOrder[index];

                  if (block.scope) {
                    // if we have already seen this object, then we need to reuse the
                    // associated scope/element

                    nextNode = previousNode;

                    // skip nodes that are already pending removal via leave animation
                    do {
                      nextNode = nextNode.nextSibling;
                    } while (nextNode && nextNode[NG_REMOVED]);

                    if (getBlockStart(block) != nextNode) {
                      // existing item which got moved
                      $animate.move(getBlockNodes(block.clone), null, previousNode);
                    }
                    previousNode = getBlockEnd(block);
                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                  } else {
                    // new item which we don't know about
                    $transclude(function ngRepeatTransclude(clone, scope) {
                      block.scope = scope;
                      // http://jsperf.com/clone-vs-createcomment
                      var endNode = ngRepeatEndComment.cloneNode(false);
                      clone[clone.length++] = endNode;

                      $animate.enter(clone, null, previousNode);
                      previousNode = endNode;
                      // Note: We only need the first/last node of the cloned nodes.
                      // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                      // by a directive with templateUrl when its template arrives.
                      block.clone = clone;
                      nextBlockMap[block.id] = block;
                      updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                    });
                  }
                }
                lastBlockMap = nextBlockMap;
              });
            };
          }
        };
      }];

      var NG_HIDE_CLASS = 'ng-hide';
      var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
      /**
       * @ngdoc directive
       * @name ngShow
       * @multiElement
       *
       * @description
       * The `ngShow` directive shows or hides the given HTML element based on the expression
       * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
       * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
       * in AngularJS and sets the display style to none (using an !important flag).
       * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
       *
       * ```html
       * <!-- when $scope.myValue is truthy (element is visible) -->
       * <div ng-show="myValue"></div>
       *
       * <!-- when $scope.myValue is falsy (element is hidden) -->
       * <div ng-show="myValue" class="ng-hide"></div>
       * ```
       *
       * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
       * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
       * from the element causing the element not to appear hidden.
       *
       * ## Why is !important used?
       *
       * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
       * can be easily overridden by heavier selectors. For example, something as simple
       * as changing the display style on a HTML list item would make hidden elements appear visible.
       * This also becomes a bigger issue when dealing with CSS frameworks.
       *
       * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
       * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
       * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
       *
       * ### Overriding `.ng-hide`
       *
       * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
       * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
       * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
       * with extra animation classes that can be added.
       *
       * ```css
       * .ng-hide:not(.ng-hide-animate) {
       *   /&#42; this is just another form of hiding an element &#42;/
       *   display: block!important;
       *   position: absolute;
       *   top: -9999px;
       *   left: -9999px;
       * }
       * ```
       *
       * By default you don't need to override in CSS anything and the animations will work around the display style.
       *
       * ## A note about animations with `ngShow`
       *
       * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
       * is true and false. This system works like the animation system present with ngClass except that
       * you must also include the !important flag to override the display property
       * so that you can perform an animation when the element is hidden during the time of the animation.
       *
       * ```css
       * //
       * //a working example can be found at the bottom of this page
       * //
       * .my-element.ng-hide-add, .my-element.ng-hide-remove {
       *   /&#42; this is required as of 1.3x to properly
       *      apply all styling in a show/hide animation &#42;/
       *   transition: 0s linear all;
       * }
       *
       * .my-element.ng-hide-add-active,
       * .my-element.ng-hide-remove-active {
       *   /&#42; the transition is defined in the active class &#42;/
       *   transition: 1s linear all;
       * }
       *
       * .my-element.ng-hide-add { ... }
       * .my-element.ng-hide-add.ng-hide-add-active { ... }
       * .my-element.ng-hide-remove { ... }
       * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
       * ```
       *
       * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
       * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
       *
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
       * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
       *
       * @element ANY
       * @param {expression} ngShow If the {@link guide/expression expression} is truthy
       *     then the element is shown or hidden respectively.
       *
       * @example
        <example module="ngAnimate" deps="angular-animate.js" animations="true">
          <file name="index.html">
            Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
            <div>
              Show:
              <div class="check-element animate-show" ng-show="checked">
                <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
              </div>
            </div>
            <div>
              Hide:
              <div class="check-element animate-show" ng-hide="checked">
                <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
              </div>
            </div>
          </file>
          <file name="glyphicons.css">
            @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
          </file>
          <file name="animations.css">
            .animate-show {
              line-height: 20px;
              opacity: 1;
              padding: 10px;
              border: 1px solid black;
              background: white;
            }
      
            .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
              transition: all linear 0.5s;
            }
      
            .animate-show.ng-hide {
              line-height: 0;
              opacity: 0;
              padding: 0 10px;
            }
      
            .check-element {
              padding: 10px;
              border: 1px solid black;
              background: white;
            }
          </file>
          <file name="protractor.js" type="protractor">
            var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
            var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
      
            it('should check ng-show / ng-hide', function() {
              expect(thumbsUp.isDisplayed()).toBeFalsy();
              expect(thumbsDown.isDisplayed()).toBeTruthy();
      
              element(by.model('checked')).click();
      
              expect(thumbsUp.isDisplayed()).toBeTruthy();
              expect(thumbsDown.isDisplayed()).toBeFalsy();
            });
          </file>
        </example>
       */
      var ngShowDirective = ['$animate', function ($animate) {
        return {
          restrict: 'A',
          multiElement: true,
          link: function (scope, element, attr) {
            scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
              // we're adding a temporary, animation-specific class for ng-hide since this way
              // we can control when the element is actually displayed on screen without having
              // to have a global/greedy CSS selector that breaks when other animations are run.
              // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
              $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
                tempClasses: NG_HIDE_IN_PROGRESS_CLASS
              });
            });
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngHide
       * @multiElement
       *
       * @description
       * The `ngHide` directive shows or hides the given HTML element based on the expression
       * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
       * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
       * in AngularJS and sets the display style to none (using an !important flag).
       * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
       *
       * ```html
       * <!-- when $scope.myValue is truthy (element is hidden) -->
       * <div ng-hide="myValue" class="ng-hide"></div>
       *
       * <!-- when $scope.myValue is falsy (element is visible) -->
       * <div ng-hide="myValue"></div>
       * ```
       *
       * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
       * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
       * from the element causing the element not to appear hidden.
       *
       * ## Why is !important used?
       *
       * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
       * can be easily overridden by heavier selectors. For example, something as simple
       * as changing the display style on a HTML list item would make hidden elements appear visible.
       * This also becomes a bigger issue when dealing with CSS frameworks.
       *
       * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
       * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
       * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
       *
       * ### Overriding `.ng-hide`
       *
       * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
       * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
       * class in CSS:
       *
       * ```css
       * .ng-hide {
       *   /&#42; this is just another form of hiding an element &#42;/
       *   display: block!important;
       *   position: absolute;
       *   top: -9999px;
       *   left: -9999px;
       * }
       * ```
       *
       * By default you don't need to override in CSS anything and the animations will work around the display style.
       *
       * ## A note about animations with `ngHide`
       *
       * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
       * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
       * CSS class is added and removed for you instead of your own CSS class.
       *
       * ```css
       * //
       * //a working example can be found at the bottom of this page
       * //
       * .my-element.ng-hide-add, .my-element.ng-hide-remove {
       *   transition: 0.5s linear all;
       * }
       *
       * .my-element.ng-hide-add { ... }
       * .my-element.ng-hide-add.ng-hide-add-active { ... }
       * .my-element.ng-hide-remove { ... }
       * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
       * ```
       *
       * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
       * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
       *
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
       * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
       *
       *
       * @element ANY
       * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
       *     the element is shown or hidden respectively.
       *
       * @example
        <example module="ngAnimate" deps="angular-animate.js" animations="true">
          <file name="index.html">
            Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
            <div>
              Show:
              <div class="check-element animate-hide" ng-show="checked">
                <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
              </div>
            </div>
            <div>
              Hide:
              <div class="check-element animate-hide" ng-hide="checked">
                <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
              </div>
            </div>
          </file>
          <file name="glyphicons.css">
            @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
          </file>
          <file name="animations.css">
            .animate-hide {
              transition: all linear 0.5s;
              line-height: 20px;
              opacity: 1;
              padding: 10px;
              border: 1px solid black;
              background: white;
            }
      
            .animate-hide.ng-hide {
              line-height: 0;
              opacity: 0;
              padding: 0 10px;
            }
      
            .check-element {
              padding: 10px;
              border: 1px solid black;
              background: white;
            }
          </file>
          <file name="protractor.js" type="protractor">
            var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
            var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
      
            it('should check ng-show / ng-hide', function() {
              expect(thumbsUp.isDisplayed()).toBeFalsy();
              expect(thumbsDown.isDisplayed()).toBeTruthy();
      
              element(by.model('checked')).click();
      
              expect(thumbsUp.isDisplayed()).toBeTruthy();
              expect(thumbsDown.isDisplayed()).toBeFalsy();
            });
          </file>
        </example>
       */
      var ngHideDirective = ['$animate', function ($animate) {
        return {
          restrict: 'A',
          multiElement: true,
          link: function (scope, element, attr) {
            scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
              // The comment inside of the ngShowDirective explains why we add and
              // remove a temporary class for the show/hide animation
              $animate[value ? 'addClass' : 'removeClass'](element, NG_HIDE_CLASS, {
                tempClasses: NG_HIDE_IN_PROGRESS_CLASS
              });
            });
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name ngStyle
       * @restrict AC
       *
       * @description
       * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
       *
       * @knownIssue
       * You should not use {@link guide/interpolation interpolation} in the value of the `style`
       * attribute, when using the `ngStyle` directive on the same element.
       * See {@link guide/interpolation#known-issues here} for more info.
       *
       * @element ANY
       * @param {expression} ngStyle
       *
       * {@link guide/expression Expression} which evals to an
       * object whose keys are CSS style names and values are corresponding values for those CSS
       * keys.
       *
       * Since some CSS style names are not valid keys for an object, they must be quoted.
       * See the 'background-color' style in the example below.
       *
       * @example
         <example>
           <file name="index.html">
              <input type="button" value="set color" ng-click="myStyle={color:'red'}">
              <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
              <input type="button" value="clear" ng-click="myStyle={}">
              <br/>
              <span ng-style="myStyle">Sample Text</span>
              <pre>myStyle={{myStyle}}</pre>
           </file>
           <file name="style.css">
             span {
               color: black;
             }
           </file>
           <file name="protractor.js" type="protractor">
             var colorSpan = element(by.css('span'));
      
             it('should check ng-style', function() {
               expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
               element(by.css('input[value=\'set color\']')).click();
               expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
               element(by.css('input[value=clear]')).click();
               expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
             });
           </file>
         </example>
       */
      var ngStyleDirective = ngDirective(function (scope, element, attr) {
        scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
          if (oldStyles && newStyles !== oldStyles) {
            forEach(oldStyles, function (val, style) {
              element.css(style, '');
            });
          }
          if (newStyles) element.css(newStyles);
        }, true);
      });

      /**
       * @ngdoc directive
       * @name ngSwitch
       * @restrict EA
       *
       * @description
       * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
       * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
       * as specified in the template.
       *
       * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
       * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
       * matches the value obtained from the evaluated expression. In other words, you define a container element
       * (where you place the directive), place an expression on the **`on="..."` attribute**
       * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
       * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
       * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
       * attribute is displayed.
       *
       * <div class="alert alert-info">
       * Be aware that the attribute values to match against cannot be expressions. They are interpreted
       * as literal string values to match against.
       * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
       * value of the expression `$scope.someVal`.
       * </div>
      
       * @animations
       * | Animation                        | Occurs                              |
       * |----------------------------------|-------------------------------------|
       * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
       * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
       *
       * @usage
       *
       * ```
       * <ANY ng-switch="expression">
       *   <ANY ng-switch-when="matchValue1">...</ANY>
       *   <ANY ng-switch-when="matchValue2">...</ANY>
       *   <ANY ng-switch-default>...</ANY>
       * </ANY>
       * ```
       *
       *
       * @scope
       * @priority 1200
       * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
       * On child elements add:
       *
       * * `ngSwitchWhen`: the case statement to match against. If match then this
       *   case will be displayed. If the same match appears multiple times, all the
       *   elements will be displayed.
       * * `ngSwitchDefault`: the default case when no other case match. If there
       *   are multiple default cases, all of them will be displayed when no other
       *   case match.
       *
       *
       * @example
        <example module="switchExample" deps="angular-animate.js" animations="true">
          <file name="index.html">
            <div ng-controller="ExampleController">
              <select ng-model="selection" ng-options="item for item in items">
              </select>
              <code>selection={{selection}}</code>
              <hr/>
              <div class="animate-switch-container"
                ng-switch on="selection">
                  <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
                  <div class="animate-switch" ng-switch-when="home">Home Span</div>
                  <div class="animate-switch" ng-switch-default>default</div>
              </div>
            </div>
          </file>
          <file name="script.js">
            angular.module('switchExample', ['ngAnimate'])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.items = ['settings', 'home', 'other'];
                $scope.selection = $scope.items[0];
              }]);
          </file>
          <file name="animations.css">
            .animate-switch-container {
              position:relative;
              background:white;
              border:1px solid black;
              height:40px;
              overflow:hidden;
            }
      
            .animate-switch {
              padding:10px;
            }
      
            .animate-switch.ng-animate {
              transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      
              position:absolute;
              top:0;
              left:0;
              right:0;
              bottom:0;
            }
      
            .animate-switch.ng-leave.ng-leave-active,
            .animate-switch.ng-enter {
              top:-50px;
            }
            .animate-switch.ng-leave,
            .animate-switch.ng-enter.ng-enter-active {
              top:0;
            }
          </file>
          <file name="protractor.js" type="protractor">
            var switchElem = element(by.css('[ng-switch]'));
            var select = element(by.model('selection'));
      
            it('should start in settings', function() {
              expect(switchElem.getText()).toMatch(/Settings Div/);
            });
            it('should change to home', function() {
              select.all(by.css('option')).get(1).click();
              expect(switchElem.getText()).toMatch(/Home Span/);
            });
            it('should select default', function() {
              select.all(by.css('option')).get(2).click();
              expect(switchElem.getText()).toMatch(/default/);
            });
          </file>
        </example>
       */
      var ngSwitchDirective = ['$animate', '$compile', function ($animate, $compile) {
        return {
          require: 'ngSwitch',

          // asks for $scope to fool the BC controller module
          controller: ['$scope', function ngSwitchController() {
            this.cases = {};
          }],
          link: function (scope, element, attr, ngSwitchController) {
            var watchExpr = attr.ngSwitch || attr.on,
                selectedTranscludes = [],
                selectedElements = [],
                previousLeaveAnimations = [],
                selectedScopes = [];

            var spliceFactory = function (array, index) {
              return function () {
                array.splice(index, 1);
              };
            };

            scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
              var i, ii;
              for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
                $animate.cancel(previousLeaveAnimations[i]);
              }
              previousLeaveAnimations.length = 0;

              for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
                var selected = getBlockNodes(selectedElements[i].clone);
                selectedScopes[i].$destroy();
                var promise = previousLeaveAnimations[i] = $animate.leave(selected);
                promise.then(spliceFactory(previousLeaveAnimations, i));
              }

              selectedElements.length = 0;
              selectedScopes.length = 0;

              if (selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?']) {
                forEach(selectedTranscludes, function (selectedTransclude) {
                  selectedTransclude.transclude(function (caseElement, selectedScope) {
                    selectedScopes.push(selectedScope);
                    var anchor = selectedTransclude.element;
                    caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
                    var block = { clone: caseElement };

                    selectedElements.push(block);
                    $animate.enter(caseElement, anchor.parent(), anchor);
                  });
                });
              }
            });
          }
        };
      }];

      var ngSwitchWhenDirective = ngDirective({
        transclude: 'element',
        priority: 1200,
        require: '^ngSwitch',
        multiElement: true,
        link: function (scope, element, attrs, ctrl, $transclude) {
          ctrl.cases['!' + attrs.ngSwitchWhen] = ctrl.cases['!' + attrs.ngSwitchWhen] || [];
          ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
        }
      });

      var ngSwitchDefaultDirective = ngDirective({
        transclude: 'element',
        priority: 1200,
        require: '^ngSwitch',
        multiElement: true,
        link: function (scope, element, attr, ctrl, $transclude) {
          ctrl.cases['?'] = ctrl.cases['?'] || [];
          ctrl.cases['?'].push({ transclude: $transclude, element: element });
        }
      });

      /**
       * @ngdoc directive
       * @name ngTransclude
       * @restrict EAC
       *
       * @description
       * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
       *
       * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
       * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
       *
       * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
       * content of this element will be removed before the transcluded content is inserted.
       * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
       * that no transcluded content is provided.
       *
       * @element ANY
       *
       * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
       *                                               or its value is the same as the name of the attribute then the default slot is used.
       *
       * @example
       * ### Basic transclusion
       * This example demonstrates basic transclusion of content into a component directive.
       * <example name="simpleTranscludeExample" module="transcludeExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('transcludeExample', [])
       *        .directive('pane', function(){
       *           return {
       *             restrict: 'E',
       *             transclude: true,
       *             scope: { title:'@' },
       *             template: '<div style="border: 1px solid black;">' +
       *                         '<div style="background-color: gray">{{title}}</div>' +
       *                         '<ng-transclude></ng-transclude>' +
       *                       '</div>'
       *           };
       *       })
       *       .controller('ExampleController', ['$scope', function($scope) {
       *         $scope.title = 'Lorem Ipsum';
       *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
       *       }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <input ng-model="title" aria-label="title"> <br/>
       *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
       *       <pane title="{{title}}">{{text}}</pane>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *      it('should have transcluded', function() {
       *        var titleElement = element(by.model('title'));
       *        titleElement.clear();
       *        titleElement.sendKeys('TITLE');
       *        var textElement = element(by.model('text'));
       *        textElement.clear();
       *        textElement.sendKeys('TEXT');
       *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
       *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
       *      });
       *   </file>
       * </example>
       *
       * @example
       * ### Transclude fallback content
       * This example shows how to use `NgTransclude` with fallback content, that
       * is displayed if no transcluded content is provided.
       *
       * <example module="transcludeFallbackContentExample">
       * <file name="index.html">
       * <script>
       * angular.module('transcludeFallbackContentExample', [])
       * .directive('myButton', function(){
       *             return {
       *               restrict: 'E',
       *               transclude: true,
       *               scope: true,
       *               template: '<button style="cursor: pointer;">' +
       *                           '<ng-transclude>' +
       *                             '<b style="color: red;">Button1</b>' +
       *                           '</ng-transclude>' +
       *                         '</button>'
       *             };
       *         });
       * </script>
       * <!-- fallback button content -->
       * <my-button id="fallback"></my-button>
       * <!-- modified button content -->
       * <my-button id="modified">
       *   <i style="color: green;">Button2</i>
       * </my-button>
       * </file>
       * <file name="protractor.js" type="protractor">
       * it('should have different transclude element content', function() {
       *          expect(element(by.id('fallback')).getText()).toBe('Button1');
       *          expect(element(by.id('modified')).getText()).toBe('Button2');
       *        });
       * </file>
       * </example>
       *
       * @example
       * ### Multi-slot transclusion
       * This example demonstrates using multi-slot transclusion in a component directive.
       * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
       *   <file name="index.html">
       *    <style>
       *      .title, .footer {
       *        background-color: gray
       *      }
       *    </style>
       *    <div ng-controller="ExampleController">
       *      <input ng-model="title" aria-label="title"> <br/>
       *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
       *      <pane>
       *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
       *        <pane-body><p>{{text}}</p></pane-body>
       *      </pane>
       *    </div>
       *   </file>
       *   <file name="app.js">
       *    angular.module('multiSlotTranscludeExample', [])
       *     .directive('pane', function(){
       *        return {
       *          restrict: 'E',
       *          transclude: {
       *            'title': '?paneTitle',
       *            'body': 'paneBody',
       *            'footer': '?paneFooter'
       *          },
       *          template: '<div style="border: 1px solid black;">' +
       *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
       *                      '<div ng-transclude="body"></div>' +
       *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
       *                    '</div>'
       *        };
       *    })
       *    .controller('ExampleController', ['$scope', function($scope) {
       *      $scope.title = 'Lorem Ipsum';
       *      $scope.link = "https://google.com";
       *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
       *    }]);
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *      it('should have transcluded the title and the body', function() {
       *        var titleElement = element(by.model('title'));
       *        titleElement.clear();
       *        titleElement.sendKeys('TITLE');
       *        var textElement = element(by.model('text'));
       *        textElement.clear();
       *        textElement.sendKeys('TEXT');
       *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
       *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
       *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
       *      });
       *   </file>
       * </example>
       */
      var ngTranscludeMinErr = minErr('ngTransclude');
      var ngTranscludeDirective = ['$compile', function ($compile) {
        return {
          restrict: 'EAC',
          terminal: true,
          compile: function ngTranscludeCompile(tElement) {

            // Remove and cache any original content to act as a fallback
            var fallbackLinkFn = $compile(tElement.contents());
            tElement.empty();

            return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

              if (!$transclude) {
                throw ngTranscludeMinErr('orphan', 'Illegal use of ngTransclude directive in the template! ' + 'No parent directive that requires a transclusion found. ' + 'Element: {0}', startingTag($element));
              }

              // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
              if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
                $attrs.ngTransclude = '';
              }
              var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

              // If the slot is required and no transclusion content is provided then this call will throw an error
              $transclude(ngTranscludeCloneAttachFn, null, slotName);

              // If the slot is optional and no transclusion content is provided then use the fallback content
              if (slotName && !$transclude.isSlotFilled(slotName)) {
                useFallbackContent();
              }

              function ngTranscludeCloneAttachFn(clone, transcludedScope) {
                if (clone.length) {
                  $element.append(clone);
                } else {
                  useFallbackContent();
                  // There is nothing linked against the transcluded scope since no content was available,
                  // so it should be safe to clean up the generated scope.
                  transcludedScope.$destroy();
                }
              }

              function useFallbackContent() {
                // Since this is the fallback content rather than the transcluded content,
                // we link against the scope of this directive rather than the transcluded scope
                fallbackLinkFn($scope, function (clone) {
                  $element.append(clone);
                });
              }
            };
          }
        };
      }];

      /**
       * @ngdoc directive
       * @name script
       * @restrict E
       *
       * @description
       * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
       * template can be used by {@link ng.directive:ngInclude `ngInclude`},
       * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
       * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
       * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
       *
       * @param {string} type Must be set to `'text/ng-template'`.
       * @param {string} id Cache name of the template.
       *
       * @example
        <example>
          <file name="index.html">
            <script type="text/ng-template" id="/tpl.html">
              Content of the template.
            </script>
      
            <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
            <div id="tpl-content" ng-include src="currentTpl"></div>
          </file>
          <file name="protractor.js" type="protractor">
            it('should load template defined inside script tag', function() {
              element(by.css('#tpl-link')).click();
              expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
            });
          </file>
        </example>
       */
      var scriptDirective = ['$templateCache', function ($templateCache) {
        return {
          restrict: 'E',
          terminal: true,
          compile: function (element, attr) {
            if (attr.type == 'text/ng-template') {
              var templateUrl = attr.id,
                  text = element[0].text;

              $templateCache.put(templateUrl, text);
            }
          }
        };
      }];

      var noopNgModelController = { $setViewValue: noop, $render: noop };

      function chromeHack(optionElement) {
        // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
        // Adding an <option selected="selected"> element to a <select required="required"> should
        // automatically select the new element
        if (optionElement[0].hasAttribute('selected')) {
          optionElement[0].selected = true;
        }
      }

      /**
       * @ngdoc type
       * @name  select.SelectController
       * @description
       * The controller for the `<select>` directive. This provides support for reading
       * and writing the selected value(s) of the control and also coordinates dynamically
       * added `<option>` elements, perhaps by an `ngRepeat` directive.
       */
      var SelectController = ['$element', '$scope', function ($element, $scope) {

        var self = this,
            optionsMap = new HashMap();

        // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
        self.ngModelCtrl = noopNgModelController;

        // The "unknown" option is one that is prepended to the list if the viewValue
        // does not match any of the options. When it is rendered the value of the unknown
        // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
        //
        // We can't just jqLite('<option>') since jqLite is not smart enough
        // to create it in <select> and IE barfs otherwise.
        self.unknownOption = jqLite(window.document.createElement('option'));
        self.renderUnknownOption = function (val) {
          var unknownVal = '? ' + hashKey(val) + ' ?';
          self.unknownOption.val(unknownVal);
          $element.prepend(self.unknownOption);
          $element.val(unknownVal);
        };

        $scope.$on('$destroy', function () {
          // disable unknown option so that we don't do work when the whole select is being destroyed
          self.renderUnknownOption = noop;
        });

        self.removeUnknownOption = function () {
          if (self.unknownOption.parent()) self.unknownOption.remove();
        };

        // Read the value of the select control, the implementation of this changes depending
        // upon whether the select can have multiple values and whether ngOptions is at work.
        self.readValue = function readSingleValue() {
          self.removeUnknownOption();
          return $element.val();
        };

        // Write the value to the select control, the implementation of this changes depending
        // upon whether the select can have multiple values and whether ngOptions is at work.
        self.writeValue = function writeSingleValue(value) {
          if (self.hasOption(value)) {
            self.removeUnknownOption();
            $element.val(value);
            if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
          } else {
            if (value == null && self.emptyOption) {
              self.removeUnknownOption();
              $element.val('');
            } else {
              self.renderUnknownOption(value);
            }
          }
        };

        // Tell the select control that an option, with the given value, has been added
        self.addOption = function (value, element) {
          // Skip comment nodes, as they only pollute the `optionsMap`
          if (element[0].nodeType === NODE_TYPE_COMMENT) return;

          assertNotHasOwnProperty(value, '"option value"');
          if (value === '') {
            self.emptyOption = element;
          }
          var count = optionsMap.get(value) || 0;
          optionsMap.put(value, count + 1);
          self.ngModelCtrl.$render();
          chromeHack(element);
        };

        // Tell the select control that an option, with the given value, has been removed
        self.removeOption = function (value) {
          var count = optionsMap.get(value);
          if (count) {
            if (count === 1) {
              optionsMap.remove(value);
              if (value === '') {
                self.emptyOption = undefined;
              }
            } else {
              optionsMap.put(value, count - 1);
            }
          }
        };

        // Check whether the select control has an option matching the given value
        self.hasOption = function (value) {
          return !!optionsMap.get(value);
        };

        self.registerOption = function (optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

          if (interpolateValueFn) {
            // The value attribute is interpolated
            var oldVal;
            optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
              if (isDefined(oldVal)) {
                self.removeOption(oldVal);
              }
              oldVal = newVal;
              self.addOption(newVal, optionElement);
            });
          } else if (interpolateTextFn) {
            // The text content is interpolated
            optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
              optionAttrs.$set('value', newVal);
              if (oldVal !== newVal) {
                self.removeOption(oldVal);
              }
              self.addOption(newVal, optionElement);
            });
          } else {
            // The value attribute is static
            self.addOption(optionAttrs.value, optionElement);
          }

          optionElement.on('$destroy', function () {
            self.removeOption(optionAttrs.value);
            self.ngModelCtrl.$render();
          });
        };
      }];

      /**
       * @ngdoc directive
       * @name select
       * @restrict E
       *
       * @description
       * HTML `SELECT` element with angular data-binding.
       *
       * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
       * between the scope and the `<select>` control (including setting default values).
       * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
       * {@link ngOptions `ngOptions`} directives.
       *
       * When an item in the `<select>` menu is selected, the value of the selected option will be bound
       * to the model identified by the `ngModel` directive. With static or repeated options, this is
       * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
       * If you want dynamic value attributes, you can use interpolation inside the value attribute.
       *
       * <div class="alert alert-warning">
       * Note that the value of a `select` directive used without `ngOptions` is always a string.
       * When the model needs to be bound to a non-string value, you must either explicitly convert it
       * using a directive (see example below) or use `ngOptions` to specify the set of options.
       * This is because an option element can only be bound to string values at present.
       * </div>
       *
       * If the viewValue of `ngModel` does not match any of the options, then the control
       * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
       *
       * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
       * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
       * option. See example below for demonstration.
       *
       * <div class="alert alert-info">
       * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
       * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
       * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
       * comprehension expression, and additionally in reducing memory and increasing speed by not creating
       * a new scope for each repeated instance.
       * </div>
       *
       *
       * @param {string} ngModel Assignable angular expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} multiple Allows multiple options to be selected. The selected values will be
       *     bound to the model as an array.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds required attribute and required validation constraint to
       * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
       * when you want to data-bind to the required attribute.
       * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
       *    interaction with the select element.
       * @param {string=} ngOptions sets the options that the select is populated with and defines what is
       * set on the model on selection. See {@link ngOptions `ngOptions`}.
       *
       * @example
       * ### Simple `select` elements with static options
       *
       * <example name="static-select" module="staticSelect">
       * <file name="index.html">
       * <div ng-controller="ExampleController">
       *   <form name="myForm">
       *     <label for="singleSelect"> Single select: </label><br>
       *     <select name="singleSelect" ng-model="data.singleSelect">
       *       <option value="option-1">Option 1</option>
       *       <option value="option-2">Option 2</option>
       *     </select><br>
       *
       *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
       *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
       *       <option value="">---Please select---</option> <!-- not selected / blank option -->
       *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
       *       <option value="option-2">Option 2</option>
       *     </select><br>
       *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
       *     <tt>singleSelect = {{data.singleSelect}}</tt>
       *
       *     <hr>
       *     <label for="multipleSelect"> Multiple select: </label><br>
       *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
       *       <option value="option-1">Option 1</option>
       *       <option value="option-2">Option 2</option>
       *       <option value="option-3">Option 3</option>
       *     </select><br>
       *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
       *   </form>
       * </div>
       * </file>
       * <file name="app.js">
       *  angular.module('staticSelect', [])
       *    .controller('ExampleController', ['$scope', function($scope) {
       *      $scope.data = {
       *       singleSelect: null,
       *       multipleSelect: [],
       *       option1: 'option-1',
       *      };
       *
       *      $scope.forceUnknownOption = function() {
       *        $scope.data.singleSelect = 'nonsense';
       *      };
       *   }]);
       * </file>
       *</example>
       *
       * ### Using `ngRepeat` to generate `select` options
       * <example name="ngrepeat-select" module="ngrepeatSelect">
       * <file name="index.html">
       * <div ng-controller="ExampleController">
       *   <form name="myForm">
       *     <label for="repeatSelect"> Repeat select: </label>
       *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
       *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
       *     </select>
       *   </form>
       *   <hr>
       *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
       * </div>
       * </file>
       * <file name="app.js">
       *  angular.module('ngrepeatSelect', [])
       *    .controller('ExampleController', ['$scope', function($scope) {
       *      $scope.data = {
       *       repeatSelect: null,
       *       availableOptions: [
       *         {id: '1', name: 'Option A'},
       *         {id: '2', name: 'Option B'},
       *         {id: '3', name: 'Option C'}
       *       ],
       *      };
       *   }]);
       * </file>
       *</example>
       *
       *
       * ### Using `select` with `ngOptions` and setting a default value
       * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
       *
       * <example name="select-with-default-values" module="defaultValueSelect">
       * <file name="index.html">
       * <div ng-controller="ExampleController">
       *   <form name="myForm">
       *     <label for="mySelect">Make a choice:</label>
       *     <select name="mySelect" id="mySelect"
       *       ng-options="option.name for option in data.availableOptions track by option.id"
       *       ng-model="data.selectedOption"></select>
       *   </form>
       *   <hr>
       *   <tt>option = {{data.selectedOption}}</tt><br/>
       * </div>
       * </file>
       * <file name="app.js">
       *  angular.module('defaultValueSelect', [])
       *    .controller('ExampleController', ['$scope', function($scope) {
       *      $scope.data = {
       *       availableOptions: [
       *         {id: '1', name: 'Option A'},
       *         {id: '2', name: 'Option B'},
       *         {id: '3', name: 'Option C'}
       *       ],
       *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
       *       };
       *   }]);
       * </file>
       *</example>
       *
       *
       * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
       *
       * <example name="select-with-non-string-options" module="nonStringSelect">
       *   <file name="index.html">
       *     <select ng-model="model.id" convert-to-number>
       *       <option value="0">Zero</option>
       *       <option value="1">One</option>
       *       <option value="2">Two</option>
       *     </select>
       *     {{ model }}
       *   </file>
       *   <file name="app.js">
       *     angular.module('nonStringSelect', [])
       *       .run(function($rootScope) {
       *         $rootScope.model = { id: 2 };
       *       })
       *       .directive('convertToNumber', function() {
       *         return {
       *           require: 'ngModel',
       *           link: function(scope, element, attrs, ngModel) {
       *             ngModel.$parsers.push(function(val) {
       *               return parseInt(val, 10);
       *             });
       *             ngModel.$formatters.push(function(val) {
       *               return '' + val;
       *             });
       *           }
       *         };
       *       });
       *   </file>
       *   <file name="protractor.js" type="protractor">
       *     it('should initialize to model', function() {
       *       var select = element(by.css('select'));
       *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
       *     });
       *   </file>
       * </example>
       *
       */
      var selectDirective = function () {

        return {
          restrict: 'E',
          require: ['select', '?ngModel'],
          controller: SelectController,
          priority: 1,
          link: {
            pre: selectPreLink,
            post: selectPostLink
          }
        };

        function selectPreLink(scope, element, attr, ctrls) {

          // if ngModel is not defined, we don't need to do anything
          var ngModelCtrl = ctrls[1];
          if (!ngModelCtrl) return;

          var selectCtrl = ctrls[0];

          selectCtrl.ngModelCtrl = ngModelCtrl;

          // When the selected item(s) changes we delegate getting the value of the select control
          // to the `readValue` method, which can be changed if the select can have multiple
          // selected values or if the options are being generated by `ngOptions`
          element.on('change', function () {
            scope.$apply(function () {
              ngModelCtrl.$setViewValue(selectCtrl.readValue());
            });
          });

          // If the select allows multiple values then we need to modify how we read and write
          // values from and to the control; also what it means for the value to be empty and
          // we have to add an extra watch since ngModel doesn't work well with arrays - it
          // doesn't trigger rendering if only an item in the array changes.
          if (attr.multiple) {

            // Read value now needs to check each option to see if it is selected
            selectCtrl.readValue = function readMultipleValue() {
              var array = [];
              forEach(element.find('option'), function (option) {
                if (option.selected) {
                  array.push(option.value);
                }
              });
              return array;
            };

            // Write value now needs to set the selected property of each matching option
            selectCtrl.writeValue = function writeMultipleValue(value) {
              var items = new HashMap(value);
              forEach(element.find('option'), function (option) {
                option.selected = isDefined(items.get(option.value));
              });
            };

            // we have to do it on each watch since ngModel watches reference, but
            // we need to work of an array, so we need to see if anything was inserted/removed
            var lastView,
                lastViewRef = NaN;
            scope.$watch(function selectMultipleWatch() {
              if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
                lastView = shallowCopy(ngModelCtrl.$viewValue);
                ngModelCtrl.$render();
              }
              lastViewRef = ngModelCtrl.$viewValue;
            });

            // If we are a multiple select then value is now a collection
            // so the meaning of $isEmpty changes
            ngModelCtrl.$isEmpty = function (value) {
              return !value || value.length === 0;
            };
          }
        }

        function selectPostLink(scope, element, attrs, ctrls) {
          // if ngModel is not defined, we don't need to do anything
          var ngModelCtrl = ctrls[1];
          if (!ngModelCtrl) return;

          var selectCtrl = ctrls[0];

          // We delegate rendering to the `writeValue` method, which can be changed
          // if the select can have multiple selected values or if the options are being
          // generated by `ngOptions`.
          // This must be done in the postLink fn to prevent $render to be called before
          // all nodes have been linked correctly.
          ngModelCtrl.$render = function () {
            selectCtrl.writeValue(ngModelCtrl.$viewValue);
          };
        }
      };

      // The option directive is purely designed to communicate the existence (or lack of)
      // of dynamically created (and destroyed) option elements to their containing select
      // directive via its controller.
      var optionDirective = ['$interpolate', function ($interpolate) {
        return {
          restrict: 'E',
          priority: 100,
          compile: function (element, attr) {
            if (isDefined(attr.value)) {
              // If the value attribute is defined, check if it contains an interpolation
              var interpolateValueFn = $interpolate(attr.value, true);
            } else {
              // If the value attribute is not defined then we fall back to the
              // text content of the option element, which may be interpolated
              var interpolateTextFn = $interpolate(element.text(), true);
              if (!interpolateTextFn) {
                attr.$set('value', element.text());
              }
            }

            return function (scope, element, attr) {
              // This is an optimization over using ^^ since we don't want to have to search
              // all the way to the root of the DOM for every single option element
              var selectCtrlName = '$selectController',
                  parent = element.parent(),
                  selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName); // in case we are in optgroup

              if (selectCtrl) {
                selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
              }
            };
          }
        };
      }];

      var styleDirective = valueFn({
        restrict: 'E',
        terminal: false
      });

      /**
       * @ngdoc directive
       * @name ngRequired
       * @restrict A
       *
       * @description
       *
       * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
       * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
       * applied to custom controls.
       *
       * The directive sets the `required` attribute on the element if the Angular expression inside
       * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
       * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
       * for more info.
       *
       * The validator will set the `required` error key to true if the `required` attribute is set and
       * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
       * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
       * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
       * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
       *
       * @example
       * <example name="ngRequiredDirective" module="ngRequiredExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('ngRequiredExample', [])
       *         .controller('ExampleController', ['$scope', function($scope) {
       *           $scope.required = true;
       *         }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <form name="form">
       *         <label for="required">Toggle required: </label>
       *         <input type="checkbox" ng-model="required" id="required" />
       *         <br>
       *         <label for="input">This input must be filled if `required` is true: </label>
       *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
       *         <hr>
       *         required error set? = <code>{{form.input.$error.required}}</code><br>
       *         model = <code>{{model}}</code>
       *       </form>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
             var required = element(by.binding('form.input.$error.required'));
             var model = element(by.binding('model'));
             var input = element(by.id('input'));
      
             it('should set the required error', function() {
               expect(required.getText()).toContain('true');
      
               input.sendKeys('123');
               expect(required.getText()).not.toContain('true');
               expect(model.getText()).toContain('123');
             });
       *   </file>
       * </example>
       */
      var requiredDirective = function () {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function (scope, elm, attr, ctrl) {
            if (!ctrl) return;
            attr.required = true; // force truthy in case we are on non input element

            ctrl.$validators.required = function (modelValue, viewValue) {
              return !attr.required || !ctrl.$isEmpty(viewValue);
            };

            attr.$observe('required', function () {
              ctrl.$validate();
            });
          }
        };
      };

      /**
       * @ngdoc directive
       * @name ngPattern
       *
       * @description
       *
       * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
       * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
       *
       * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
       * does not match a RegExp which is obtained by evaluating the Angular expression given in the
       * `ngPattern` attribute value:
       * * If the expression evaluates to a RegExp object, then this is used directly.
       * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
       * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
       *
       * <div class="alert alert-info">
       * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       * start at the index of the last search's match, thus not taking the whole input value into
       * account.
       * </div>
       *
       * <div class="alert alert-info">
       * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
       * differences:
       * <ol>
       *   <li>
       *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
       *     not available.
       *   </li>
       *   <li>
       *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
       *     interpolated.
       *   </li>
       * </ol>
       * </div>
       *
       * @example
       * <example name="ngPatternDirective" module="ngPatternExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('ngPatternExample', [])
       *         .controller('ExampleController', ['$scope', function($scope) {
       *           $scope.regex = '\\d+';
       *         }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <form name="form">
       *         <label for="regex">Set a pattern (regex string): </label>
       *         <input type="text" ng-model="regex" id="regex" />
       *         <br>
       *         <label for="input">This input is restricted by the current pattern: </label>
       *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
       *         <hr>
       *         input valid? = <code>{{form.input.$valid}}</code><br>
       *         model = <code>{{model}}</code>
       *       </form>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
             var model = element(by.binding('model'));
             var input = element(by.id('input'));
      
             it('should validate the input with the default pattern', function() {
               input.sendKeys('aaa');
               expect(model.getText()).not.toContain('aaa');
      
               input.clear().then(function() {
                 input.sendKeys('123');
                 expect(model.getText()).toContain('123');
               });
             });
       *   </file>
       * </example>
       */
      var patternDirective = function () {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function (scope, elm, attr, ctrl) {
            if (!ctrl) return;

            var regexp,
                patternExp = attr.ngPattern || attr.pattern;
            attr.$observe('pattern', function (regex) {
              if (isString(regex) && regex.length > 0) {
                regex = new RegExp('^' + regex + '$');
              }

              if (regex && !regex.test) {
                throw minErr('ngPattern')('noregexp', 'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp, regex, startingTag(elm));
              }

              regexp = regex || undefined;
              ctrl.$validate();
            });

            ctrl.$validators.pattern = function (modelValue, viewValue) {
              // HTML5 pattern constraint validates the input value, so we validate the viewValue
              return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
            };
          }
        };
      };

      /**
       * @ngdoc directive
       * @name ngMaxlength
       *
       * @description
       *
       * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
       * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
       *
       * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
       * is longer than the integer obtained by evaluating the Angular expression given in the
       * `ngMaxlength` attribute value.
       *
       * <div class="alert alert-info">
       * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
       * differences:
       * <ol>
       *   <li>
       *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
       *     validation is not available.
       *   </li>
       *   <li>
       *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
       *     interpolated.
       *   </li>
       * </ol>
       * </div>
       *
       * @example
       * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('ngMaxlengthExample', [])
       *         .controller('ExampleController', ['$scope', function($scope) {
       *           $scope.maxlength = 5;
       *         }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <form name="form">
       *         <label for="maxlength">Set a maxlength: </label>
       *         <input type="number" ng-model="maxlength" id="maxlength" />
       *         <br>
       *         <label for="input">This input is restricted by the current maxlength: </label>
       *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
       *         <hr>
       *         input valid? = <code>{{form.input.$valid}}</code><br>
       *         model = <code>{{model}}</code>
       *       </form>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
             var model = element(by.binding('model'));
             var input = element(by.id('input'));
      
             it('should validate the input with the default maxlength', function() {
               input.sendKeys('abcdef');
               expect(model.getText()).not.toContain('abcdef');
      
               input.clear().then(function() {
                 input.sendKeys('abcde');
                 expect(model.getText()).toContain('abcde');
               });
             });
       *   </file>
       * </example>
       */
      var maxlengthDirective = function () {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function (scope, elm, attr, ctrl) {
            if (!ctrl) return;

            var maxlength = -1;
            attr.$observe('maxlength', function (value) {
              var intVal = toInt(value);
              maxlength = isNaN(intVal) ? -1 : intVal;
              ctrl.$validate();
            });
            ctrl.$validators.maxlength = function (modelValue, viewValue) {
              return maxlength < 0 || ctrl.$isEmpty(viewValue) || viewValue.length <= maxlength;
            };
          }
        };
      };

      /**
       * @ngdoc directive
       * @name ngMinlength
       *
       * @description
       *
       * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
       * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
       *
       * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
       * is shorter than the integer obtained by evaluating the Angular expression given in the
       * `ngMinlength` attribute value.
       *
       * <div class="alert alert-info">
       * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
       * differences:
       * <ol>
       *   <li>
       *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
       *     validation is not available.
       *   </li>
       *   <li>
       *     The `ngMinlength` value must be an expression, while the `minlength` value must be
       *     interpolated.
       *   </li>
       * </ol>
       * </div>
       *
       * @example
       * <example name="ngMinlengthDirective" module="ngMinlengthExample">
       *   <file name="index.html">
       *     <script>
       *       angular.module('ngMinlengthExample', [])
       *         .controller('ExampleController', ['$scope', function($scope) {
       *           $scope.minlength = 3;
       *         }]);
       *     </script>
       *     <div ng-controller="ExampleController">
       *       <form name="form">
       *         <label for="minlength">Set a minlength: </label>
       *         <input type="number" ng-model="minlength" id="minlength" />
       *         <br>
       *         <label for="input">This input is restricted by the current minlength: </label>
       *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
       *         <hr>
       *         input valid? = <code>{{form.input.$valid}}</code><br>
       *         model = <code>{{model}}</code>
       *       </form>
       *     </div>
       *   </file>
       *   <file name="protractor.js" type="protractor">
             var model = element(by.binding('model'));
             var input = element(by.id('input'));
      
             it('should validate the input with the default minlength', function() {
               input.sendKeys('ab');
               expect(model.getText()).not.toContain('ab');
      
               input.sendKeys('abc');
               expect(model.getText()).toContain('abc');
             });
       *   </file>
       * </example>
       */
      var minlengthDirective = function () {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function (scope, elm, attr, ctrl) {
            if (!ctrl) return;

            var minlength = 0;
            attr.$observe('minlength', function (value) {
              minlength = toInt(value) || 0;
              ctrl.$validate();
            });
            ctrl.$validators.minlength = function (modelValue, viewValue) {
              return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
            };
          }
        };
      };

      if (window.angular.bootstrap) {
        //AngularJS is already loaded, so we can return here...
        if (window.console) {
          console.log('WARNING: Tried to load angular more than once.');
        }
        return;
      }

      //try to bind to jquery now so that one can write jqLite(document).ready()
      //but we will rebind on bootstrap again.
      bindJQuery();

      publishExternalAPI(angular);

      angular.module("ngLocale", [], ["$provide", function ($provide) {
        var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
        function getDecimals(n) {
          n = n + '';
          var i = n.indexOf('.');
          return i == -1 ? 0 : n.length - i - 1;
        }

        function getVF(n, opt_precision) {
          var v = opt_precision;

          if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
          }

          var base = Math.pow(10, v);
          var f = (n * base | 0) % base;
          return { v: v, f: f };
        }

        $provide.value("$locale", {
          "DATETIME_FORMATS": {
            "AMPMS": ["AM", "PM"],
            "DAY": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "ERANAMES": ["Before Christ", "Anno Domini"],
            "ERAS": ["BC", "AD"],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "SHORTDAY": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "SHORTMONTH": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            "STANDALONEMONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "WEEKENDRANGE": [5, 6],
            "fullDate": "EEEE, MMMM d, y",
            "longDate": "MMMM d, y",
            "medium": "MMM d, y h:mm:ss a",
            "mediumDate": "MMM d, y",
            "mediumTime": "h:mm:ss a",
            "short": "M/d/yy h:mm a",
            "shortDate": "M/d/yy",
            "shortTime": "h:mm a"
          },
          "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [{
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 3,
              "minFrac": 0,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "",
              "posPre": "",
              "posSuf": ""
            }, {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 2,
              "minFrac": 2,
              "minInt": 1,
              "negPre": "-\u00a4",
              "negSuf": "",
              "posPre": "\u00a4",
              "posSuf": ""
            }]
          },
          "id": "en-us",
          "localeID": "en_US",
          "pluralCat": function (n, opt_precision) {
            var i = n | 0;var vf = getVF(n, opt_precision);if (i == 1 && vf.v == 0) {
              return PLURAL_CATEGORY.ONE;
            }return PLURAL_CATEGORY.OTHER;
          }
        });
      }]);

      jqLite(window.document).ready(function () {
        angularInit(window.document, bootstrap);
      });
    })(window);

    !window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
  })(this);

  return _retrieveGlobal();
});
$__System.registerDynamic("3", ["20b"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("20b");
});
$__System.register('20c', [], function (_export) {
	'use strict';

	function Orgs($rootScope, $http, Sites, _) {

		this.getByUuid = function (orgUuid) {
			return $http({
				method: 'POST',
				url: 'org/get_org/',
				data: { 'uuid': orgUuid }
			}).then(function (result) {
				return result.data;
			});
		};

		this.get = function (orgId) {
			return $http({
				url: 'org/' + orgId + '/'
			}).then(function (result) {
				return result.data;
			})['catch'](function (error) {
				return error;
			});
		};

		this.getAll = function () {
			return $http({
				method: 'GET',
				url: 'org/'
			}).then(function (result) {
				return result.data;
			});
		};

		this['delete'] = function (org) {
			return $http({
				method: 'POST',
				url: 'org/delete_org/',
				data: { 'uuid': org.uuid }
			}, function (error) {
				//
			}).then(function (success) {
				//DB remove could go here
				clearFromRecentOrgs(org);
			});
		};

		this.create = function (org) {
			return $http({
				method: 'POST',
				url: 'org/',
				data: org
			}, function (error) {
				//
			}).then(function (response) {
				return response.data;
			});
		};

		this.update = function (org) {
			return $http({
				method: 'PUT',
				url: 'org/' + org.id + '/',
				data: org
			}, function (error) {
				//
			}).then(function (response) {
				//Update indexed record
				return response.data;
			});
		};

		this.listGateways = function () {
			return $http({
				//return $http.get({
				url: 'gateway/',
				noCancelOnRouteChange: true
			}).then(function (response) {
				return response.data;
			});
		};

		this.refreshSignal = function (gatewayId) {
			return $http({
				method: 'POST',
				url: 'gateway/' + gatewayId + '/request_cell_signal_update/'
			}, function (error) {
				//
			}).then(function (response) {
				//Update indexed record
				return response.data;
			});
		};

		this.updateGateway = function (gateway) {
			return $http({
				method: 'PUT',
				url: 'gateway/' + gateway.id + '/',
				data: gateway
			}, function (error) {
				//
			}).then(function (response) {
				//Update indexed record
				return response.data;
			});
		};

		this.sendIntegratorIP = function (gatewayID, newIP) {
			return $http({
				method: 'POST',
				url: 'gateway/send_bacnet_config/',
				data: {
					gateway_id: gatewayID,
					integrator_ip: newIP
				}
			})['catch'](function (error) {
				return error;
			}).then(function (response) {
				return response.data;
			});
		};

		//get users in org
		this.getUsers = function (uuid) {
			return $http({
				method: 'GET',
				url: 'org/' + uuid + '/users/'
			}).then(function (response) {
				return response.data;
			});
		};

		//get sites in org
		this.getSites = function (uuid) {
			return $http({
				method: 'GET',
				url: 'org/' + uuid + '/sites/',
				transformResponse: $http.defaults.transformResponse.concat([orgSitesMapping])
			}).then(function (response) {
				return response.data;
			});
		};

		/* Deprecated by DM 2/20/20
  this.getDataUsage = function () {
  	return $http({
  		method: 'POST',
  		url: 'gateway/usage_summary/',
  		data: {
  			'download': true
  		}
  	});
  };
  */

		this.getNotifications = function (uuid, count) {
			return $http({
				url: 'org/' + uuid + '/system_notifications/',
				params: { max: count }
			});
		};

		this.submitSalesforceCase = function (form) {
			var defaults = {
				orgid: '00D290000000YEn',
				retURL: 'http://',
				recordType: '012a0000001ZVHZ',
				debug: 1,
				debugEmail: 'jason@rabweb.com'
			};

			return $http({
				method: 'POST',
				withCredentials: false,
				url: 'https://cs19.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
				transformRequest: function transformRequest(obj) {
					var str = [];
					for (var p in obj) {
						str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
					}
					return str.join('&');
				},
				data: _.extend(form, defaults)
			})['catch'](function (error) {
				//Suppress CORS errors for cross domain POST
				return true;
			});
		};

		this.connectLightcloudBlue = function (authData) {
			return $http({
				method: 'POST',
				url: 'blue/authenticate/',
				data: authData
			}).then(function (response) {
				return response;
			})['catch'](function (error) {
				throw error;
			});
		};

		this.logoutLightcloudBlue = function (orgUuid) {
			return $http({
				method: 'POST',
				url: 'blue/logout/',
				data: {
					org: orgUuid
				}
			}).then(function (response) {
				return response;
			})['catch'](function (error) {
				throw error;
			});
		};

		this.getBlueDevices = function (orgUuid) {
			return $http({
				method: 'POST',
				url: 'blue/discover_devices/',
				data: {
					'org': orgUuid
				}
			}).then(function (response) {
				return response;
			})['catch'](function (error) {
				throw error;
			});
		};

		function clearFromRecentOrgs(org) {
			$rootScope.$broadcast('cs-bar:removeFromRecent', org);
		}

		function orgSitesMapping(data) {
			return _.map(data, function (site) {
				return Sites.newSite(site);
			});
		}
	}

	return {
		setters: [],
		execute: function () {
			Orgs.$inject = ['$rootScope', '$http', 'Sites', '_'];
			_export('default', Orgs);
		}
	};
});

$__System.register('20d', [], function (_export) {
	'use strict';

	function globalCtrl($rootScope, $scope, $sce, Devices, Messages, Orgs) {

		init();

		function init() {
			getDefinitions();
			getAllSchedules();
		}

		function getDefinitions() {
			Devices.getDefinitions().success(function (response) {

				$scope.devices = response.body.devices;
				$scope.uuids = _.map($scope.devices, 'uuid');
			});
		}

		function getAllSchedules() {
			Devices.getAllSchedules().success(function (response) {
				$scope.schedules = response;
				$scope.schedules = _.sortBy($scope.schedules, 'model');
			});
		}

		$scope.getDeviceSchedules = function (device) {
			device.schedules = _.filter($scope.schedules, function (schedule) {
				return device.uuid == schedule.device.uuid;
			});
			if (device.schedules.length == 0) {
				device.schedules.push({ device_uuid: device.uuid, blank: true });
			}
		};

		$scope.addDefinition = function () {
			$scope.devices.push({ blank: true });
		};

		$scope.addSchedule = function (device) {
			if (!device.showSchedules) device.showSchedules = true;
			if (angular.isUndefined(device.schedules)) {
				device.schedules = [];
			}
			device.schedules.push({ device_uuid: device.uuid, blank: true });
		};

		$scope.updateDefinition = function (device, devices, index) {
			device.ajaxPending = true;
			if (device.blank) {
				Devices.createDefinition(device).success(function (response) {
					device.ajaxPending = false;
					if (angular.isDefined(response.error)) {
						Messages.popUp(response.error, 'Could not update definition');
					} else {
						devices.splice(index, 1);
						devices.push(response.body.device);
					}
				});
			} else {
				Devices.updateDefinition(device).success(function () {
					device.ajaxPending = false;
				});
			}
		};

		$scope.updateSchedule = function (schedule, schedules, index) {
			schedule.ajaxPending = true;
			if (schedule.blank) {
				Devices.createSchedule(schedule).success(function (response) {
					schedule.ajaxPending = false;
					if (angular.isDefined(response.error)) {
						Messages.popUp(response.error, 'Could not update schedule');
					} else {
						schedules.splice(index, 1);
						schedules.push(response.body.firmware_schedule);
					}
				}).error(function (error) {
					//Messages.popUp(error);
				});
			} else {
					Devices.updateSchedule(schedule).success(function (response) {
						schedule.ajaxPending = false;
					});
				}
		};

		$scope.deleteDefinition = function (device, index) {
			Devices.deleteDefinition(device).success(function () {
				$scope.devices.splice(index, 1);
			});
		};

		$scope.deleteSchedule = function (schedule, schedules, index) {
			Devices.deleteSchedule(schedule).success(function () {
				schedules.splice(index, 1);
			});
		};

		$scope.getDataUsage = function () {

			$scope.pending = true;

			Orgs.getDataUsage().success(function (result) {

				$scope.pending = false;

				if ($rootScope.mobile) {
					var reader = new FileReader();
					var out = new Blob([result], { type: 'text/csv' });
					reader.onload = function (e) {
						var bdata = btoa(reader.result);
						var datauri = 'data:text/csv;base64,' + bdata;
						window.location.href = datauri;
					};
					reader.readAsBinaryString(out);
				} else {
					var file = new Blob([result], { type: 'text/csv' });
					$scope.downloadLink = $sce.trustAsResourceUrl(URL.createObjectURL(file));
					window.open($scope.downloadLink);
				}
			}).error(function () {
				console.log("get report fails");
			});
		};
	}

	return {
		setters: [],
		execute: function () {
			globalCtrl.$inject = ['$rootScope', '$scope', '$sce', 'Devices', 'Messages', 'Orgs'];
			_export('default', globalCtrl);
		}
	};
});

$__System.register('5a', [], function (_export) {
	'use strict';

	function ratesModalCtrl($rootScope, $scope, $q, close, Billing, Devices, moment) {

		$scope.close = close;
		$scope.pending = false;
		$scope.error = false;

		function getRates(orgUuid, month, year) {
			return $q(function (resolve, reject) {
				Billing.getRates(orgUuid, month, year).then(function (response) {
					resolve(response.data.body.rates);
				});
			});
		}

		function getDevices() {
			return $q(function (resolve, reject) {
				Devices.getDefinitions().then(function (response) {
					resolve(response.data.body.devices);
				});
			});
		}

		var promiseRates = getRates($rootScope.currentOrg.uuid, moment().month() + 1, moment().year());
		var promiseDevices = getDevices();

		$q.all([promiseRates, promiseDevices]).then(function (result) {
			$scope.devices = result[1];
			convertRatesToView(result[0]);
		}, function (reason) {
			// :(
		});

		function convertRatesToView(rates) {
			if (rates.length) {
				$scope.rateObject = {
					'as_of_month': rates[0].as_of_month, //Locking all rates to one month - ask jason why
					'humanMonth': moment().month(rates[0].as_of_month - 1).format('MMM'),
					'as_of_year': rates[0].as_of_year,
					'rates': _.each(rates, function (rate) {
						rate.deviceName = _.filter($scope.devices, function (device) {
							return device.uuid == rate.device_type_uuid;
						})[0].model;
					})
				};
			} else {
				//No rates - add some blank ones
				var momentMonth = moment().month() + 1;

				$scope.rateObject = {
					'as_of_month': momentMonth,
					'humanMonth': moment().format('MMM'),
					'as_of_year': moment().year(),
					'rates': []
				};

				_.each($scope.devices, function (device) {
					//One rate per device found
					$scope.rateObject.rates.push({
						deviceName: device.model,
						device_type_uuid: device.uuid,
						monthly_rate: 1,
						as_of_year: $scope.rateObject.as_of_year,
						as_of_month: $scope.rateObject.as_of_month
					});
				});
			}
		}

		$scope.save = function () {
			$scope.pending = true;

			delete $scope.rateObject.humanMonth;
			$scope.rateObject.as_of_month = moment().month() + 1;
			$scope.rateObject.year = moment().year();
			$scope.rateObject.org_uuid = $scope.currentOrg.uuid;

			Billing.setRates($scope.rateObject).then(function (response) {
				if (response.data && response.data.error) {
					//Handle error here or rely on global error box
					$scope.pending = false;
				} else {
					$scope.rateObject.editMode = false;
					$scope.rateObject.humanMonth = moment().month($scope.rateObject.as_of_month - 1).format('MMM');
					$scope.pending = false;
				}
			}, function (error) {
				//Getting 500's for bad characters
				$scope.pending = false;
			});
		};

		//Sending them all at once for now derp 
		/*
  	$scope.addRate = function(){
  	if(angular.isUndefined($scope.rates)){
  		$scope.rates = [];
  	}
  	$scope.rates.push({device_type_uuid: null, month: (moment().month() + 1), monthly_rate: 1, as_of_year: moment().year(), blank: true})
  }
      $scope.save = function(rate){
     	$scope.pending = true;
      	$scope.setRateRequests = [];
      	$scope.newRates = _.filter($scope.rates, function(rate){ return rate.blank });
      	_.each($scope.newRates, function(rate){
  		var rates = {
     			"device_type_uuid" 	: rate.device_type_uuid,
     			"monthly_rate"		: rate.monthly_rate
     		}
  			var ratePromise = setRate($rootScope.currentOrg.uuid,rate.month,rate.as_of_year,rates);
     		$scope.setRateRequests.push(ratePromise);
     	})
       	$q.all($scope.setRateRequests).then(function(response){
     			$scope.pending = false;
  	    	}, function(reason){
              // :(
              $scope.pending = false;
          }
      );
  	
      }
  */

		/* No promise any more
  function setRate(rateObject){
  	return $q(function(resolve, reject) {
   	Billing.setRates(rateObject).then(function(response){
   		if(response.data && response.data.error){
   			//Handle error
   			reject(response.data.error)
   		} else {
   			resolve()
   		}
   	});
   });
  }
  */
	}

	return {
		setters: [],
		execute: function () {
			_export('default', ratesModalCtrl);
		}
	};
});

$__System.registerDynamic("20e", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"cs-bar\" ng-class=\"{active: csBC.active}\" ng-hide=\"csBC.hidden\">\n\n\t<div class=\"search-cluster\">\n\t\t<div class=\"current-org\">\n\t\t\t<omni-box org=\"csBC.currentOrg\"></omni-box>\n\t\t</div>\n\t</div>\n\t\n<!-- \t<div class=\"search-cluster\">\n\t\t<div class=\"current-org\" ng-class=\"{dropped: csBC.drop, loading: !csBC.indexComplete}\" ng-click=\"csBC.toggleDrop()\">\n\t\t\t<span ng-bind=\"csBC.currentOrg ? csBC.currentOrg.name : 'Select Org' \"></span>\n\t\t</div>\n\t\t<cs-bar-search org=\"csBC.currentOrg\" on-toggle-drop=\"csBC.toggleDrop()\" ng-if=\"csBC.drop\"></cs-bar-search>\n\t\t<div class=\"fade\" ng-if=\"csBC.drop\" ng-click=\"csBC.toggleDrop()\"></div>\n\t</div> -->\n\n\t<div class=\"dark-buttons left-cluster\" ng-class=\"{'disabled': !csBC.currentOrg}\">\n\t\t<button class=\"edit\" droptip tip=\"Edit Org\" ng-disabled=\"!csBC.currentOrg\" ng-click=\"csBC.editOrg()\"></button> <!-- ui-sref=\"cs.org.edit({orgId: csBC.currentOrg.uuid})\" -->\n\t\t<button class=\"users\" droptip tip=\"Manage Users\" ui-sref=\"Users({orgUuid: csBC.currentOrg.uuid, userSelectedFilter: null})\" ng-disabled=\"!csBC.currentOrg\"></button>\n\t\t<button class=\"list\" droptip tip=\"Activity Log\" ng-disabled=\"!csBC.currentOrg\" ng-click=\"csBC.activity()\"></button>\n\t\t<button class=\"info\" droptip tip=\"Site Information\" ng-disabled=\"!csBC.currentOrg\" ng-click=\"csBC.siteInfo()\"></button>\n\t</div>\n\t<div class=\"dark-buttons right-cluster\">\n\t\t<button class=\"salesforce\" droptip tip=\"Add Salesforce Case\" ng-click=\"csBC.addSalesforceCase()\">SF</button>\n\t\t<button class=\"gateway count\" droptip tip=\"Unassigned Gateways\" ng-click=\"csBC.unassigned()\"><span class=\"count\">{{csBC.unassignedGatewayCount}}</span></button>\n\t\t<button class=\"add\" droptip tip=\"Create Organization\" ng-click=\"csBC.addOrg()\"></button>\n\t</div>\n</div>";
});
$__System.register('20f', ['20e'], function (_export) {
	'use strict';

	var csBarTmpl, csBarComponent;
	return {
		setters: [function (_e) {
			csBarTmpl = _e['default'];
		}],
		execute: function () {
			csBarComponent = {
				template: csBarTmpl,
				bindings: {
					org: '<'
				},
				//onUpdateGatewayCount: '&'
				controllerAs: 'csBC',
				controller: function controller($window, $scope, $rootScope, $state, $q, Modals, Orgs, LcCache, Local, _) {

					var csBC = this;

					csBC.$onInit = function () {
						//
						// Kick this off on every load?
						// - returns all gateways..
						//
						getGatewayList();

						//
						//
						// CS indexer begins here now - no more event misses
						//
						//
						//startWorker();
					};

					csBC.$onChanges = function (changes) {
						//
						if (changes.org.currentValue) {
							csBC.currentOrg = changes.org.currentValue;
						}
					};

					csBC.toggleDrop = function () {
						if (csBC.indexComplete) {
							csBC.drop = !csBC.drop;
						}
					};

					csBC.siteInfo = siteInfo;
					csBC.sitesListDeferred = $q.defer();

					$scope.$on('cs-bar:updateGatewayList', function (scope, id) {
						getGatewayList();
					});

					$scope.$on('cs-bar:siteInfo', function (scope, site) {
						//@todo open the correct site
						siteInfo(site);
					});

					csBC.editOrg = function () {
						Modals.showModal({
							name: 'csOrgEdit',
							inputs: {
								selectedOrg: csBC.currentOrg
							}
						});
					};

					csBC.activity = function () {
						Modals.showModal({
							name: 'csOrgActivity',
							inputs: {
								selectedOrg: csBC.currentOrg
							}
						});
					};

					csBC.unassigned = function () {
						Modals.showModal({
							name: 'csOrgGateways',
							inputs: {
								selectedOrg: csBC.currentOrg || null,
								gateways: csBC.unassignedGateways,
								sitesDeferred: csBC.sitesListDeferred
							}
						});
					};

					csBC.addSalesforceCase = function () {
						Modals.showModal({
							name: 'csSalesforceCase',
							inputs: {
								selectedOrg: csBC.currentOrg
							}
						});
					};

					csBC.addOrg = function () {
						Modals.showModal({
							name: 'csOrgEdit',
							inputs: {
								selectedOrg: null
							}
						});
					};

					csBC.getFreshSites = function () {
						console.log('Old Site update func - still needed?');
					};

					/* No more indexer for now
     	function startWorker(){
     if(indexedDbSupported()){
     //
     // Don't start worker without some auth - work will bail out if auth is bad anyway
     //
     if(Local.get('apiKey')){
     buildCSIndex();
     }
     }else{
     // Do something if browser doesn't support indexedDB
     csBC.noSupport = true;
     }    		
     }
     function indexedDbSupported(){
     var indexedDB = $window.indexedDB || $window.mozIndexedDB || $window.webkitIndexedDB || $window.msIndexedDB;
     return indexedDB ? true : false;
     }
     	function buildCSIndex(){
     Indexer.build().then(list => {
     LcCache.setCSGlobalSitesList(list);
     csBC.sitesListDeferred.resolve(list);
     csBC.indexComplete = true;
     });
     }
     */

					function getGatewayList() {
						return Orgs.listGateways().then(function (gateways) {
							csBC.unassignedGateways = _.filter(gateways, { site: null });
							csBC.unassignedGatewayCount = csBC.unassignedGateways.length;
						});
					}

					function siteInfo(site) {
						var currentOrg = site && csBC.currentOrg && csBC.currentOrg.uuid === site.org_uuid ? csBC.currentOrg : null;

						Modals.showModal({
							name: 'csOrgSiteInfo',
							inputs: {
								selectedOrg: currentOrg,
								site: site
							}
						}).then(function (route) {
							if (route) {
								$state.go(route.path, route.params);
							}
						});
					}
				}
			};

			_export('default', csBarComponent);
		}
	};
});

$__System.registerDynamic("210", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"search-drop\" cs-bar-search-input-directive toggletron=\"csBSC.toggleDrop();\" >\n\t<header class=\"selection-header selection-header-device\">\n\t\t<i class=\"fa fa-search\"></i>\n\t\t<div class=\"selection-search\">\n\t\t\t<input id=\"csSearch\" class=\"search-input\" type=\"search\" ng-disabled=\"ajaxPending || blocked\" placeholder=\"{{placeholder}}\" ng-class=\"{loading: ajaxPending, disabled: blocked}\" ng-model=\"orgSearch\">\n\t\t</div>\n\t</header>\n    <div class=\"results\">\n\t\t<ul>\n\t\t\t<li ng-repeat=\"group in groupedResults\">\n\t\t\t\t<h2 class=\"overview-heading\">\n\t\t\t\t\t<span>{{group.name}}</span>\n\t\t\t\t</h2>\n\t\t\t\t<h3></h3>\n\t\t\t\t<ul>\n\t\t\t\t\t<li class=\"item search-result\" ng-class=\"{focused: item.selected}\" ng-repeat=\"item in group.results\" data-uuid=\"{{::item.uuid}}\">\n\t\t\t\t\t  \t<div>\n\t\t\t\t\t  \t\t<span class=\"title\">{{::item.email || item.id_string || item.name}}</span>\n\t\t\t\t\t  \t\t<span class=\"description\">{{::item.description}}</span>\n\t\t\t\t\t  \t\t<span class=\"parent\">{{::item.parent}}</span>\n\t\t\t\t\t  \t</div>\n\t\t\t\t\t</li>\n\t\t  \t\t</ul>\n        \t</li>\n        \t<li class=\"reloader\" ng-if=\"showReload\">\n\t\t\t\t<span>No results found</span><a href=\"\" ng-click=\"build()\">Refresh Client Database</a>\n        \t</li>\n      \t</ul>\n    </div>\n</div>\n";
});
$__System.register('211', ['210'], function (_export) {
  'use strict';

  var csBarSearchTmpl, csBarSearchComponent;
  return {
    setters: [function (_) {
      csBarSearchTmpl = _['default'];
    }],
    execute: function () {
      csBarSearchComponent = {
        template: csBarSearchTmpl,
        bindings: {
          org: '<',
          onToggleDrop: '&?'
        },
        controllerAs: 'csBSC',
        controller: function controller() {
          //
          //
          //
          var csBSC = this;
        }
      };

      _export('default', csBarSearchComponent);
    }
  };
});

$__System.registerDynamic('212', ['213', '1e6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toInteger = $__require('213'),
      defined = $__require('1e6');
  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that)),
          i = toInteger(pos),
          l = s.length,
          a,
          b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
});
$__System.registerDynamic("214", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = true;
});
$__System.registerDynamic('1f5', ['1ef'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = $__require('1ef');
});
$__System.registerDynamic('215', ['10f', '1ef', '1ec', '216', '1f8'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('10f'),
      IteratorPrototype = {};
  $__require('1ef')(IteratorPrototype, $__require('1ec')('iterator'), function () {
    return this;
  });
  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = $.create(IteratorPrototype, { next: $__require('216')(1, next) });
    $__require('1f8')(Constructor, NAME + ' Iterator');
  };
});
$__System.registerDynamic("113", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var hasOwnProperty = {}.hasOwnProperty;
  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
});
$__System.registerDynamic("216", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
});
$__System.registerDynamic("114", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
});
$__System.registerDynamic('1ed', ['114'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = !$__require('114')(function () {
    return Object.defineProperty({}, 'a', { get: function () {
        return 7;
      } }).a != 7;
  });
});
$__System.registerDynamic('1ef', ['10f', '216', '1ed'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $ = $__require('10f'),
      createDesc = $__require('216');
  module.exports = $__require('1ed') ? function (object, key, value) {
    return $.setDesc(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
});
$__System.registerDynamic('1f8', ['113', '1ef', '1ec'], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    var has = $__require('113'),
        hide = $__require('1ef'),
        TAG = $__require('1ec')('toStringTag');
    module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) hide(it, TAG, tag);
    };
});
$__System.registerDynamic('1ea', ['214', '116', '1f5', '1ef', '113', '1ec', '1e9', '215', '10f', '1f8'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var LIBRARY = $__require('214'),
      $def = $__require('116'),
      $redef = $__require('1f5'),
      hide = $__require('1ef'),
      has = $__require('113'),
      SYMBOL_ITERATOR = $__require('1ec')('iterator'),
      Iterators = $__require('1e9'),
      BUGGY = !([].keys && 'next' in [].keys()),
      FF_ITERATOR = '@@iterator',
      KEYS = 'keys',
      VALUES = 'values';
  var returnThis = function () {
    return this;
  };
  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE) {
    $__require('215')(Constructor, NAME, next);
    var createMethod = function (kind) {
      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };
        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }
      return function entries() {
        return new Constructor(this, kind);
      };
    };
    var TAG = NAME + ' Iterator',
        proto = Base.prototype,
        _native = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
        _default = _native || createMethod(DEFAULT),
        methods,
        key;
    if (_native) {
      var IteratorPrototype = $__require('10f').getProto(_default.call(new Base()));
      $__require('1f8')(IteratorPrototype, TAG, true);
      if (!LIBRARY && has(proto, FF_ITERATOR)) hide(IteratorPrototype, SYMBOL_ITERATOR, returnThis);
    }
    if (!LIBRARY || FORCE) hide(proto, SYMBOL_ITERATOR, _default);
    Iterators[NAME] = _default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        keys: IS_SET ? _default : createMethod(KEYS),
        values: DEFAULT == VALUES ? _default : createMethod(VALUES),
        entries: DEFAULT != VALUES ? _default : createMethod('entries')
      };
      if (FORCE) for (key in methods) {
        if (!(key in proto)) $redef(proto, key, methods[key]);
      } else $def($def.P + $def.F * BUGGY, NAME, methods);
    }
  };
});
$__System.registerDynamic('136', ['212', '1ea'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $at = $__require('212')(true);
  $__require('1ea')(String, 'String', function (iterated) {
    this._t = String(iterated);
    this._i = 0;
  }, function () {
    var O = this._t,
        index = this._i,
        point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
});
$__System.registerDynamic('217', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };
});
$__System.registerDynamic('1f0', ['217'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var aFunction = $__require('217');
  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };
      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };
      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function () {
      return fn.apply(that, arguments);
    };
  };
});
$__System.registerDynamic('116', ['1f7', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var global = $__require('1f7'),
      core = $__require('118'),
      PROTOTYPE = 'prototype';
  var ctx = function (fn, that) {
    return function () {
      return fn.apply(that, arguments);
    };
  };
  var $def = function (type, name, source) {
    var key,
        own,
        out,
        exp,
        isGlobal = type & $def.G,
        isProto = type & $def.P,
        target = isGlobal ? global : type & $def.S ? global[name] : (global[name] || {})[PROTOTYPE],
        exports = isGlobal ? core : core[name] || (core[name] = {});
    if (isGlobal) source = name;
    for (key in source) {
      own = !(type & $def.F) && target && key in target;
      if (own && key in exports) continue;
      out = own ? target[key] : source[key];
      if (isGlobal && typeof target[key] != 'function') exp = source[key];else if (type & $def.B && own) exp = ctx(out, global);else if (type & $def.W && target[key] == out) !function (C) {
        exp = function (param) {
          return this instanceof C ? new C(param) : C(param);
        };
        exp[PROTOTYPE] = C[PROTOTYPE];
      }(out);else exp = isProto && typeof out == 'function' ? ctx(Function.call, out) : out;
      exports[key] = exp;
      if (isProto) (exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
    }
  };
  $def.F = 1;
  $def.G = 2;
  $def.S = 4;
  $def.P = 8;
  $def.B = 16;
  $def.W = 32;
  module.exports = $def;
});
$__System.registerDynamic("1e6", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
});
$__System.registerDynamic('111', ['1e6'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var defined = $__require('1e6');
  module.exports = function (it) {
    return Object(defined(it));
  };
});
$__System.registerDynamic('1a7', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };
});
$__System.registerDynamic('132', ['1a7'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var isObject = $__require('1a7');
  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };
});
$__System.registerDynamic('1fa', ['132'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var anObject = $__require('132');
  module.exports = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) anObject(ret.call(iterator));
      throw e;
    }
  };
});
$__System.registerDynamic('1fb', ['1e9', '1ec'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var Iterators = $__require('1e9'),
      ITERATOR = $__require('1ec')('iterator');
  module.exports = function (it) {
    return (Iterators.Array || Array.prototype[ITERATOR]) === it;
  };
});
$__System.registerDynamic("213", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // 7.1.4 ToInteger
  var ceil = Math.ceil,
      floor = Math.floor;
  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
});
$__System.registerDynamic('1fc', ['213'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toInteger = $__require('213'),
      min = Math.min;
  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
  };
});
$__System.registerDynamic("1e4", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
});
$__System.registerDynamic('1fe', ['1e4', '1ec'], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    var cof = $__require('1e4'),
        TAG = $__require('1ec')('toStringTag'),
        ARG = cof(function () {
        return arguments;
    }()) == 'Arguments';
    module.exports = function (it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = (O = Object(it))[TAG]) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };
});
$__System.registerDynamic("1e9", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = {};
});
$__System.registerDynamic('133', ['1fe', '1ec', '1e9', '118'], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    var classof = $__require('1fe'),
        ITERATOR = $__require('1ec')('iterator'),
        Iterators = $__require('1e9');
    module.exports = $__require('118').getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };
});
$__System.registerDynamic('218', ['1f7'], true, function ($__require, exports, module) {
    var global = this || self,
        GLOBAL = global;
    /* */
    var global = $__require('1f7'),
        SHARED = '__core-js_shared__',
        store = global[SHARED] || (global[SHARED] = {});
    module.exports = function (key) {
        return store[key] || (store[key] = {});
    };
});
$__System.registerDynamic('1f7', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var UNDEFINED = 'undefined';
  var global = module.exports = typeof window != UNDEFINED && window.Math == Math ? window : typeof self != UNDEFINED && self.Math == Math ? self : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});
$__System.registerDynamic('1f3', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var id = 0,
      px = Math.random();
  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
});
$__System.registerDynamic('1ec', ['218', '1f7', '1f3'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var store = $__require('218')('wks'),
      Symbol = $__require('1f7').Symbol;
  module.exports = function (name) {
    return store[name] || (store[name] = Symbol && Symbol[name] || (Symbol || $__require('1f3'))('Symbol.' + name));
  };
});
$__System.registerDynamic('219', ['1ec'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var SYMBOL_ITERATOR = $__require('1ec')('iterator'),
      SAFE_CLOSING = false;
  try {
    var riter = [7][SYMBOL_ITERATOR]();
    riter['return'] = function () {
      SAFE_CLOSING = true;
    };
    Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {}
  module.exports = function (exec) {
    if (!SAFE_CLOSING) return false;
    var safe = false;
    try {
      var arr = [7],
          iter = arr[SYMBOL_ITERATOR]();
      iter.next = function () {
        safe = true;
      };
      arr[SYMBOL_ITERATOR] = function () {
        return iter;
      };
      exec(arr);
    } catch (e) {}
    return safe;
  };
});
$__System.registerDynamic('21a', ['1f0', '116', '111', '1fa', '1fb', '1fc', '133', '219'], true, function ($__require, exports, module) {
  /* */
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var ctx = $__require('1f0'),
      $def = $__require('116'),
      toObject = $__require('111'),
      call = $__require('1fa'),
      isArrayIter = $__require('1fb'),
      toLength = $__require('1fc'),
      getIterFn = $__require('133');
  $def($def.S + $def.F * !$__require('219')(function (iter) {
    Array.from(iter);
  }), 'Array', { from: function from(arrayLike) {
      var O = toObject(arrayLike),
          C = typeof this == 'function' ? this : Array,
          mapfn = arguments[1],
          mapping = mapfn !== undefined,
          index = 0,
          iterFn = getIterFn(O),
          length,
          result,
          step,
          iterator;
      if (mapping) mapfn = ctx(mapfn, arguments[2], 2);
      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
        }
      } else {
        length = toLength(O.length);
        for (result = new C(length); length > index; index++) {
          result[index] = mapping ? mapfn(O[index], index) : O[index];
        }
      }
      result.length = index;
      return result;
    } });
});
$__System.registerDynamic('118', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var core = module.exports = { version: '1.2.1' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
$__System.registerDynamic('21b', ['136', '21a', '118'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  $__require('136');
  $__require('21a');
  module.exports = $__require('118').Array.from;
});
$__System.registerDynamic("21c", ["21b"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("21b"), __esModule: true };
});
$__System.registerDynamic("20", ["21c"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var _Array$from = $__require("21c")["default"];
  exports["default"] = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
      return arr2;
    } else {
      return _Array$from(arr);
    }
  };
  exports.__esModule = true;
});
$__System.registerDynamic("21d", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<div class=\"gateways\">\n\t<section class=\"wizard\">\n\t\t<div class=\"wizard-step\" ng-class=\"{chosen: gAW.gateway.wizard.step > 1}\">\t\n\t\t\t<div class=\"step-number\"><h1>1</h1></div>\n\t\t\t\n\t\t\t<div class=\"step1 step-content\">\n\t\t\t\t<div class=\"choice first\" ng-class=\"{selected: gAW.gateway.wizard.step == 2}\" ng-click=\"gAW.gateway.wizard.step = gAW.gateway.wizard.step == 2 ? gAW.gateway.wizard.step = 1 : gAW.gateway.wizard.step = 2; gAW.selectedSite = null; gAW.selectedOrg = null; gAW.fetchSites();\">\n\t\t\t\t\t<h1>Assign to Existing Site</h1>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"choice first\" ng-class=\"{selected: gAW.gateway.wizard.step > 2}\" ng-click=\"gAW.gateway.wizard.step = gAW.gateway.wizard.step == 3 ? gAW.gateway.wizard.step = 1 : gAW.gateway.wizard.step = 3; gAW.selectedSite = null; gAW.selectedOrg = null;\">\n\t\t\t\t\t<h1>Assign to New Site</h1>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"wizard-step\" ng-if=\"gAW.gateway.wizard.step > 1\" ng-class=\"{chosen: gAW.gateway.wizard.step > 3 || gAW.selectedSite}\">\t\n\t\t\t<div class=\"step-number\" ><h1>2</h1></div>\n\t\t\t<div class=\"wizard-container step-content\" ng-if=\"gAW.gateway.wizard.step == 2 && !gAW.selectedSite\">\n\t\t\t\t<div class=\"wizard-form\">\n\t\t\t\t\t<div class=\"search-box search-input-wrapper\">\n\t\t\t\t\t\t<i class=\"fa fa-search\"></i>\n\t\t\t\t\t\t<input class=\"search\" placeholder=\"Search for site\" ng-model=\"gAW.siteSearch\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div ng-if=\"gAW.siteSearch\" class=\"\">\n\t\t\t\t\t\t <div class=\"sites-list-wrapper\">\n\t\t\t\t\t\t\t<ul class=\"sites-list\">\n\t\t\t\t\t\t\t\t<li class=\"site-item\" id=\"siteId-{{::site.id}}\" ng-class=\"{'selected': site.selected}\" ng-click=\"site.selected = true; gAW.selectedSite = site;\" ng-repeat=\"site in gAW.sites | filter:gAW.siteSearch\">\n\t\t\t\t\t\t\t\t\t\t<h1 ng-bind=\"::site.id_string\">Default Site Name</h1>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"step2b step-content\" ng-if=\"gAW.gateway.wizard.step > 2\">\n\t\t\t\t<div class=\"choice second\" ng-class=\"{selected: gAW.gateway.wizard.step == 4}\" ng-click=\"gAW.gateway.wizard.step = gAW.gateway.wizard.step == 4 ? gAW.gateway.wizard.step = 3 : gAW.gateway.wizard.step = 4; gAW.selectedSite = null; gAW.fetchOrgs();\">\n\t\t\t\t\t<h1>Existing Org</h1>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"choice second\" ng-class=\"{selected: gAW.gateway.wizard.step > 4}\" ng-click=\"gAW.gateway.wizard.step = gAW.gateway.wizard.step == 5 ? gAW.gateway.wizard.step = 3 : gAW.gateway.wizard.step = 5; gAW.selectedOrg = null; gAW.selectedSite = null;\">\n\t\t\t\t\t<h1>Create Org</h1>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"wizard-step\" ng-if=\"gAW.gateway.wizard.step > 3\" ng-class=\"{chosen: gAW.selectedOrg}\">\t\n\t\t\t<div class=\"step-number\"><h1>3</h1></div>\n\n\t\t\t<div class=\"wizard-container step-content\" ng-if=\"gAW.gateway.wizard.step == 4 && !gAW.selectedOrg\">\n\t\t\t\t<div class=\"wizard-form\">\n\t\t\t\t\t<div class=\"search-box search-input-wrapper\">\n\t\t\t\t\t\t<i class=\"fa fa-search\"></i>\n\t\t\t\t\t\t<input class=\"search\" placeholder=\"Search for Org\" ng-model=\"gAW.orgSearch\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div ng-if=\"gAW.orgSearch\" class=\"\">\n\t\t\t\t\t\t <div class=\"sites-list-wrapper\">\n\t\t\t\t\t\t\t<ul class=\"sites-list\">\n\t\t\t\t\t\t\t\t<li class=\"site-item\" id=\"orgId-{{::org.id}}\" ng-class=\"{'selected': org.selected}\" ng-click=\"gAW.prepSiteSelectOrg(org)\" ng-repeat=\"org in gAW.allOrgs | filter:gAW.orgSearch\">\n\t\t\t\t\t\t\t\t\t\t<h1 ng-bind=\"::org.name\">Default Org Name</h1>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"quick-buttons\">\n\t\t\t\t\t\t<button class=\"btn\" ng-click=\"gAW.selectedOrg = gAW.currentOrg;\">Use <span>Current Org</span></button>\n\t\t\t\t\t\t<button class=\"btn\" ng-click=\"gAW.useRab(gAW.gateway);\">Use <span>RAB</span></button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"wizard-container\" ng-if=\"gAW.gateway.wizard.step == 5 && !gAW.selectedOrg\">\n\t\t\t\t<div class=\"wizard-form\">\n\t\t\t\t\t<div class=\"create-org\">\n\t\t\t\t\t\t<cs-org-edit-form org=\"null\" on-org-delete=\"\" on-org-update=\"gAW.prepSiteSelectOrg(org)\"></cs-org-edit-form>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"wizard-container step-content\" ng-if=\"gAW.selectedOrg\">\n\t\t\t\t<div class=\"choice full selected\">\n\t\t\t\t\t<h1>Organization: {{gAW.selectedOrg.name}}</h1>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=\"wizard-step\" ng-if=\"gAW.selectedOrg\" ng-class=\"{chosen: gAW.selectedSite}\">\t\t\n\t\t\t<div class=\"step-number\"><h1>4</h1></div>\n\t\t\t\n\t\t\t<div class=\"wizard-container step-content\" ng-if=\"!gAW.selectedSite\">\n\t\t\t\t<div class=\"wizard-form\">\n\t\t\t\t\t<cs-site-edit-form site=\"gAW.tempSite\" org-selection-disabled=\"true\" orgs-list=\"gAW.allOrgsKeyedByName\" on-site-delete=\"\" on-site-update=\"gAW.selectSite(site)\"></cs-site-edit-form>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"wizard-step\" ng-if=\"gAW.selectedSite\">\n\t\t\t<div class=\"wizard-container step-content\">\n\t\t\t\t<div class=\"choice full selected\">\n\t\t\t\t\t<h1>Site: {{gAW.selectedSite.id_string}}</h1>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"wizard-container final step-content\">\n\t\t\t\t<button class=\"btn\" ng-click=\"gAW.commission(gAW.gateway)\">Commission Gateway</button>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n</div>";
});
$__System.register('21e', ['20', '21d'], function (_export) {
    var _toConsumableArray, gatewayAssignWizardTemplate, gatewayAssignWizardComponent;

    return {
        setters: [function (_2) {
            _toConsumableArray = _2['default'];
        }, function (_d) {
            gatewayAssignWizardTemplate = _d['default'];
        }],
        execute: function () {
            'use strict';

            gatewayAssignWizardComponent = {
                template: gatewayAssignWizardTemplate,
                bindings: {
                    currentOrg: '<',
                    gateway: '<',
                    gatewayList: '<'
                },
                controllerAs: 'gAW',
                controller: function controller($rootScope, $q, $state, _, Sites, Orgs, Modals) {
                    //
                    var gAW = this;

                    gAW.$onInit = function () {
                        //
                        gAW.orgSearch = [];
                        gAW.siteSearch = [];
                    };

                    gAW.$onChanges = function (changes) {
                        //
                        console.log('Changes in GAW Base');
                        console.log(changes);
                    };

                    gAW.prepSiteSelectOrg = function (org) {
                        gAW.tempSite = Sites.newSite(org);

                        //For the address selector
                        if (!_.find(gAW.allOrgs, ['id', org.id])) {
                            gAW.allOrgs = gAW.allOrgs ? [].concat(_toConsumableArray(gAW.allOrgs), [org]) : [org];
                        }

                        gAW.tempSite.id_string = org.name + ' (Site)';
                        gAW.tempSite.org = org;

                        delete gAW.tempSite.id;
                        delete gAW.tempSite.uuid;

                        gAW.selectedOrg = org;

                        return $q.resolve();
                    };

                    gAW.selectSite = function (site) {
                        gAW.selectedSite = angular.copy(site);

                        return $q.resolve(gAW.selectedSite);
                    };

                    gAW.fetchSites = function () {
                        Sites.get(null, null, null, true).then(function (sites) {
                            gAW.sites = sites;
                        });
                    };

                    gAW.fetchOrgs = function () {
                        Orgs.getAll().then(function (orgs) {
                            gAW.allOrgs = orgs;
                            gAW.allOrgsKeyedByName = _.mapValues(_.keyBy(orgs, 'uuid'), function (org) {
                                return org.name;
                            });
                        });
                    };

                    gAW.useRab = function (gateway) {
                        gAW.selectedOrg = _.find(gAW.allOrgs, ['name', 'RAB']); //Name match for now - different IDs per environments

                        return gateway;
                    };

                    gAW.commission = function (gateway) {
                        /*            
                            --- Outcomes ---
                            
                            1  - Exisiting Site
                            2a - New Site (exisiting org)
                            2b - New Site New Org
                            
                            Can't save site without Org UUID
                        */

                        Modals.openLoad('Commissioning Gateway');

                        checkSiteOrg(gAW.selectedSite, gAW.selectedOrg).then(function (org) {
                            var sitePayload = gAW.selectedSite;

                            sitePayload.org = org;
                            sitePayload.org_uuid = org.uuid;
                            sitePayload.gateways = _.union(sitePayload.gateways, [gateway]); //Unassign-reassign no reload

                            return createUpdateSite(sitePayload);
                        }).then(function (site) {
                            commissionSuccess(gateway);
                            Modals.closeLoad('Commissioning Success', true);
                            $state.go('Overview', { siteId: site.id, userSelectedFilter: null, leftMenuSpecialContext: 'default' });
                        })['catch'](function (error) {
                            console.log(error);
                            Modals.closeLoad('Commissioning Failure');
                        });
                    };

                    function commissionSuccess(gateway) {
                        delete gateway.wizard;

                        gAW.gatewayList.splice(gateway.$index, 1);
                        $rootScope.$broadcast('cs-bar:updateGatewayList');
                    }

                    function createUpdateSite(site) {
                        return site.uuid ? Sites.update(site) : Sites.create(site);
                    }

                    function checkCreateOrg(org) {
                        return org.uuid ? $q.resolve(org) : Orgs.create(org);
                    }

                    function checkSiteOrg(site, org) {
                        return site.org && site.org.uuid ? $q.resolve(site.org) : checkCreateOrg(org);
                    }
                }
            };

            _export('default', gatewayAssignWizardComponent);
        }
    };
});

$__System.registerDynamic("10f", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $Object = Object;
  module.exports = {
    create: $Object.create,
    getProto: $Object.getPrototypeOf,
    isEnum: {}.propertyIsEnumerable,
    getDesc: $Object.getOwnPropertyDescriptor,
    setDesc: $Object.defineProperty,
    setDescs: $Object.defineProperties,
    getKeys: $Object.keys,
    getNames: $Object.getOwnPropertyNames,
    getSymbols: $Object.getOwnPropertySymbols,
    each: [].forEach
  };
});
$__System.registerDynamic('21f', ['10f'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  var $ = $__require('10f');
  module.exports = function defineProperty(it, key, desc) {
    return $.setDesc(it, key, desc);
  };
});
$__System.registerDynamic("11f", ["21f"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /* */
  module.exports = { "default": $__require("21f"), __esModule: true };
});
$__System.registerDynamic("12", ["11f"], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var _Object$defineProperty = $__require("11f")["default"];
  exports["default"] = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  exports.__esModule = true;
});
$__System.registerDynamic("13", [], true, function ($__require, exports, module) {
  /* */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  exports["default"] = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  exports.__esModule = true;
});
$__System.register('220', ['12', '13'], function (_export) {
  var _createClass, _classCallCheck, CsBarSearchInputDirective;

  return {
    setters: [function (_2) {
      _createClass = _2['default'];
    }, function (_3) {
      _classCallCheck = _3['default'];
    }],
    execute: function () {
      'use strict';

      CsBarSearchInputDirective = (function () {
        function CsBarSearchInputDirective() {
          _classCallCheck(this, CsBarSearchInputDirective);

          this.restrict = 'A';
          this.scope = true;
        }

        _createClass(CsBarSearchInputDirective, [{
          key: 'controller',
          value: function controller($window, $rootScope, $scope, $state, $timeout, Orgs, Local, LcCache, focus) {
            //Hoist injected services to $scope for use in linking function
            $scope.dependencies = {
              $window: $window,
              $rootScope: $rootScope,
              $state: $state,
              $timeout: $timeout,
              Orgs: Orgs,
              Local: Local,
              LcCache: LcCache,
              focus: focus
            };
          }
        }, {
          key: 'link',
          value: function link(scope, elm, attrs) {

            //
            //
            // @todo Component / directive split all of this
            //
            // For now we use scope.$parent.csBSC.onToggleDrop();
            //
            // To remove also - $rootScope.backEndUrl

            //Scope vars
            scope.ajaxPending = false;
            scope.selectedIndex = -1;
            scope.bucket = 'customerService';
            scope.placeholder = 'Search System...';

            //Start with recents
            showRecent();

            //jq Dom
            var searchField = $('#csSearch');

            //Bindings
            elm.bind('keydown', function (e) {
              if (e.keyCode === 13) {
                //Enter
                if (scope.selectedItem) {
                  scope.selectResult(scope.selectedItem);
                }
              } else if (e.keyCode === 27) {
                //Escape
                scope.$parent.csBSC.onToggleDrop();
                scope.$apply();
              } else if (e.keyCode === 38) {
                //Up
                if (scope.selectedIndex === -1) {
                  scope.selectedIndex = scope.results.length - 1;
                } else if (scope.selectedIndex === 0) {
                  scope.focusField();
                } else {
                  scope.selectedIndex--;
                }

                syncSelected();
                scope.$apply();
              } else if (e.keyCode === 40) {
                //Down
                if (scope.selectedIndex < scope.results.length - 1) {
                  scope.selectedIndex++;
                } else {
                  scope.focusField();
                }

                syncSelected();
                scope.$apply();
              }
            });

            elm.bind('keyup', function (e) {
              if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
                //Moved to keydown
              } else {
                  if (scope.orgSearch) {
                    scope.search(scope.orgSearch);
                  } else {
                    //Reset to recent on null
                    showRecent();
                  }
                }
            });

            elm.on('mousedown', function ($event) {
              //
              // Cover for ng-click missing initial click after keyboard input
              //
              if ($event.target.closest('.search-result')) {
                var selectedUuid = $($event.target.closest('.search-result')).data('uuid');
                var match = _.find(scope.results, { uuid: selectedUuid });

                scope.selectResult(match);
              }
            });

            //Scope funcs

            scope.$on('omni:search-results', function (event, results) {
              sortGroup(results);
            });

            // scope.build = function(){
            //   scope.ajaxPending = true;

            //   scope.dependencies.Indexer.build().then(function(){
            //     donePending();
            //   });
            // };

            scope.selectResult = function (item) {
              if (item.type.indexOf('orgs') > -1) {

                var orgSite = _.find(scope.dependencies.LcCache.getCSGlobalSitesList(), function (site) {
                  return site.org_uuid === item.uuid;
                });

                if (orgSite) {
                  scope.dependencies.$state.go('Overview', { siteId: orgSite.id, userSelectedFilter: null, leftMenuSpecialContext: 'overview' });
                } else {
                  //Some orgs have no sites :(
                  scope.ajaxPending = true;
                  scope.dependencies.Orgs.getByUuid(item.uuid).then(function (org) {

                    //
                    // Some orgs will count hidden sites, but actually have none (ask DM)
                    //
                    scope.dependencies.$rootScope.currentOrg = org;
                    scope.dependencies.$rootScope.currentSite = null;
                    scope.dependencies.$state.go('no-sites');
                    scope.ajaxPending = false;
                  });
                }
              }

              if (item.type.indexOf('sites') > -1) {
                scope.dependencies.$state.go('Overview', { siteId: item.id, userSelectedFilter: null, leftMenuSpecialContext: 'overview' });
              }

              if (item.type.indexOf('users') > -1) {
                scope.dependencies.$state.go('Users', { orgUuid: item.org_uuid, userSelectedFilter: [item.id], leftMenuSpecialContext: 'users' });
              }

              saveRecent(item);
              scope.$parent.csBSC.onToggleDrop();
            };

            // scope.$parent.csBSC.onToggleDrop = function(){
            //   scope.drop = !scope.drop;
            //   if(scope.drop){
            //     scope.focusField();
            //   }
            // };

            scope.focusField = function () {
              scope.dependencies.focus('#csSearch');

              //Select the text for lazy people (cough cough jason)
              if (!scope.dependencies.$window.getSelection().toString()) {
                // Required for mobile Safari
                searchField[0].setSelectionRange(0, searchField[0].value.length);
              }

              scope.selectedIndex = -1;
              scope.dependencies.$timeout(function () {
                searchField.focus();
              });
            };

            scope.search = function (query) {
              scope.$emit('omni:search', query, scope.bucket);
            };

            function showRecent() {
              if (scope.dependencies.Local.get('csRecentOrgs')) {
                sortGroup(scope.dependencies.Local.get('csRecentOrgs')[scope.dependencies.$rootScope.backEndUrl]);
              }
            }

            function donePending(failure) {
              //scope.dependencies.$timeout.cancel(wwTimeoutCover);
              scope.ajaxPending = false;
              //scope.focusField();
              if (failure) {
                scope.placeholder = 'Client Search Indexing Failed';
                scope.blocked = true;
              } else {
                scope.placeholder = 'Search System...';
              }
            }

            function sortGroup(results) {
              var sort = _.sortBy(results, ['type']);

              scope.results = _.map(sort, function (result) {
                if (result) {
                  result.selectIndex = sort.indexOf(result);
                  return result;
                }
              });

              scope.groupedResults = _.map(_.groupBy(sort, 'type'), function (group, key) {
                return { name: key, results: group };
              });

              // - Adds more confusion?

              // if(scope.groupedResults.length === 0){
              //   scope.showReload = true;
              // } else {
              //   scope.showReload = false;
              // }
            }

            function syncSelected() {
              scope.groupedResults = _.map(scope.groupedResults, function (group) {
                return {
                  name: group.name,
                  results: _.map(group.results, function (item) {
                    if (item.selectIndex === scope.selectedIndex) {
                      item.selected = true;
                      scope.selectedItem = item;
                    } else {
                      item.selected = false;
                    }

                    return item;
                  })
                };
              });
            }

            function removeFromRecent(scope, item) {
              var allRecent = scope.dependencies.Local.get('csRecentOrgs') || {};
              var thisEnvironment = allRecent[scope.dependencies.$rootScope.backEndUrl] || [];

              if (_.find(thisEnvironment, ['uuid', item.uuid])) {
                thisEnvironment.splice(_.findIndex(thisEnvironment, ['uuid', item.uuid]), 1);

                allRecent[scope.dependencies.$rootScope.backEndUrl] = thisEnvironment;

                scope.dependencies.Local.set('csRecentOrgs', allRecent);
                showRecent();

                //searchField
                searchField.val('');
              }
            }

            function saveRecent(item) {
              var allRecent = scope.dependencies.Local.get('csRecentOrgs') || {};
              var thisEnvironment = allRecent[scope.dependencies.$rootScope.backEndUrl] || [];

              item.type = item.type.indexOf('Recent') > -1 ? item.type : 'Recent ' + item.type;
              item.selected = false;

              if (!_.find(thisEnvironment, ['uuid', item.uuid])) {
                thisEnvironment.unshift(item);
              }

              allRecent[scope.dependencies.$rootScope.backEndUrl] = thisEnvironment;

              scope.recent = _.take(thisEnvironment, 5);
              scope.dependencies.Local.set('csRecentOrgs', allRecent);
            }
          }
        }]);

        return CsBarSearchInputDirective;
      })();

      _export('CsBarSearchInputDirective', CsBarSearchInputDirective);
    }
  };
});

$__System.registerDynamic("221", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<form name=\"siteForm\" ng-submit=\"cSEF.save(siteForm.$valid, cSEF.site)\" novalidate>\n\t<section class=\"title main-left\">\n\t\t<h3 translate=\"customerService.siteName\">Site Name</h3>\n\t\t<input ng-model=\"cSEF.site.id_string\" type=\"text\" name=\"id_string\" placeholder=\"{{'customerService.siteName' | translate}}\" required/>\n\t</section>\n\n\t<section class=\"select-org main-right\">\n\t\t<h3 translate=\"customerService.organization\" class=\"no-float\">organization</h3>\n\t\t<!-- use org address button goes here -->\n\t\t<section class=\"main-left\">\n\t\t\t<lc-select ng-class=\"{submitted: cSEF.submitted}\" selection=\"cSEF.selectedOrgUuid\" options-list=\"cSEF.orgsList\" options-name=\"\" options-required=\"true\" disabled=\"cSEF.orgSelectionDisabled\" placeholder=\"{{'customerService.selectAnOrg' | translate }}\"  on-update=\"cSEF.updateOrgUuid(selection)\"></lc-select>\n\t\t</section>\n\n\t\t<section class=\"main-right\">\n\t\t\t<button type=\"button\" class=\"btn blue left\" ng-click=\"cSEF.useOrgAddress()\" translate=\"customerService.useOrgAddress\">Use Org Address</button>\n\t\t</section>\n\t</section>\n\n\t<section class=\"address main-left\">\n\t\t<h3 translate=\"customerService.address\">Address</h3>\n\n\t\t<input ng-model=\"cSEF.site.address.address1\" type=\"text\" name=\"address1\" placeholder=\"{{'customerService.address' | translate}}\" required/>\n\n\t\t<input class=\"\" type=\"text\" placeholder=\"{{'customerService.address2' | translate }}\" ng-model=\"cSEF.site.address.address2\" ng-required=\"false\" />\n\n\t\t<input class=\"\" type=\"text\" placeholder=\"{{'customerService.city' | translate }}\" ng-model=\"cSEF.site.address.city\" ng-required=\"true\" />\n\n\t\t<input class=\"\" type=\"text\" placeholder=\"{{'customerService.zipCode' | translate }}\" ng-model=\"cSEF.site.address.postal_code\" ng-required=\"true\" ng-pattern=\"/^\\d{5}(?:[-\\s]\\d{4})?$/\" />\n\n\t\t<input class=\"\" type=\"text\" name=\"state\" placeholder=\"{{'customerService.stateCode' | translate }}\"\n\t\t\tng-model=\"cSEF.site.address.state\" ng-required=\"true\" ng-pattern=\"/^[a-zA-Z]{2}$/\" />\n\n\t\t<!-- \n\n\t\t<input  ng-if=\"site.address.country_code !== 'US'\" class=\"\" type=\"text\" name=\"state\" placeholder=\"{{'customerService.state' | translate }}\" ng-model=\"cSEF.site.address.state\" ng-required=\"\n\t\ttrue\"  />\n\n\t\tng-pattern=\"/^[a-zA-Z]{2}$/\" \n\n\t\t<lc-select ng-if=\"site.address.country_code === 'US'\" ng-class=\"{submitted: submitted}\" selection=\"site.address.state\" options-name=\"state\" option-required=\"true\" placeholder=\"{{'customerService.state' | translate }}\"></lc-select>\n\n\t\t-->\n\n\t\t<lc-select ng-class=\"{submitted: cSEF.submitted}\" selection=\"cSEF.site.address.country_code\" options-default=\"'US'\" options-name=\"country\" options-required=\"true\" placeholder=\"{{'customerService.country_code' | translate }}\"></lc-select>\n\n\t</section>\n\n\t<section class=\"build-type main-right\" ng-if=\"cSEF.newBuildTypes\">\n\t\t<h3 translate=\"\">Build Type</h3>\n\t\t<div class=\"lc-select\">\n\t\t\t<select size=\"1\" name=\"mainBuildTypeSelect\" ng-model=\"cSEF.site.mainBuildType\" ng-class=\"{error: siteForm.mainBuildTypeSelect.$invalid && siteForm.$submitted}\" required>\n\t\t\t\t<option value=\"\" disabled selected=\"true\">please select primary type</option>\n\t\t\t\t<option ng-repeat=\"(key, value) in cSEF.newBuildTypes\" ng-value=\"key\">{{key}}</option>\n\t\t\t</select>\n\t\t</div>\n\n\t\t<div class=\"lc-select\"  ng-if=\"cSEF.site.mainBuildType\">\n\t\t\t<select size=\"1\" name=\"subBuildTypeSelect\" ng-model=\"cSEF.site.building_type\" ng-class=\"{error: siteForm.subBuildTypeSelect.$invalid && siteForm.$submitted}\" required>\n\t\t\t\t<option value=\"\" disabled selected=\"true\">please select one secondary type</option>\n\t\t\t\t<option ng-repeat=\"option in cSEF.newBuildTypes[cSEF.site.mainBuildType]\" ng-value=\"option.id\" value=\"{{option.id}}\" >{{option.name}}</option>\n\t\t\t</select>\n\t\t</div>\n\t</section>\n\n\t<section class=\"timeout main-right\">\n\t\t<h3 translate=\"customerService.electricianInfo\">Electrician Info</h3>\n\n    \t<input type=\"text\" placeholder=\"{{'customerService.name' | translate }}\" ng-model=\"cSEF.site.electrician.electrician_name\" class=\"info\" ng-required=\"true\" />\n    \t\n    \t<input type=\"text\" placeholder=\"{{'customerService.company' | translate }}\" ng-model=\"cSEF.site.electrician.electrician_company\" class=\"info\" ng-required=\"true\" />\n    \t\n    \t<input type=\"text\" placeholder=\"{{'settings.phoneNumber' | translate }}\" ng-model=\"cSEF.site.electrician.electrician_phone_no\" class=\"info\" ng-required=\"true\" />\n    \t\n    \t<input type=\"text\" placeholder=\"{{'customerService.pincode' | translate }}\" ng-model=\"cSEF.site.electrician.electrician_pin\" class=\"info\" ng-required=\"true\" />\n\n\t\t<p ng-show=\"siteForm.$invalid && siteForm.$submitted\" class=\"error error-msg organization\" translate=\"customerService.allFieldsRequired\">All fields required, No special characters allowed</p>\n\t\t\n\t\t<div class=\"error\" ng-show=\"cSEF.error\" translate=\"customerService.saveFailed\">\n\t\t\tSave failed\n\t\t</div>\n\t\n\t\t<button type=\"button\" class=\"btn orange cancel\" ng-show=\"cSEF.site.uuid\" ng-disabled=\"cSEF.site.gateways.length\" ng-click=\"cSEF.deleteSite(cSEF.site)\" ng-disabled=\"cSEF.pending\" translate=\"common.delete\" title=\"{{cSEF.site.gateways.length ? 'Unassign Gateway before deleting site':'Delete Site'}}\">Delete</button>\n\t\t<button type=\"submit\" class=\"btn blue save\" ng-disabled=\"cSEF.pending\" ng-bind=\"cSEF.pending ? 'Saving' : 'Save'\" ng-click=\"cSEF.submitted=true\"></button>\n\n\t</section>\n\n<!--   <section class=\"main-left\">\n\t\t<h3 translate=\"customerService.installerApp\">Installer Application</h3>\n\t\t<input type=\"file\"></input>\n\t</section> -->\n</form>";
});
$__System.register('222', ['221'], function (_export) {
    'use strict';

    var csSiteEditFormTemplate, csSiteEditFormComponent;
    return {
        setters: [function (_) {
            csSiteEditFormTemplate = _['default'];
        }],
        execute: function () {
            csSiteEditFormComponent = {
                template: csSiteEditFormTemplate,
                bindings: {
                    site: '<',
                    orgsList: '<',
                    orgSelectionDisabled: '<',
                    onSiteDelete: '&',
                    onSiteUpdate: '&'
                },
                controllerAs: 'cSEF',
                controller: function controller($scope, $q, Sites, Modals, Orgs) {

                    var cSEF = this;

                    cSEF.$onInit = function () {
                        // SelectedOrgUuid is org_uuid first, nested org object second
                        cSEF.selectedOrgUuid = cSEF.site.org_uuid ? cSEF.site.org_uuid : cSEF.site.org ? cSEF.site.org.uuid : null;
                        getBuildingTypeInfo();
                    };

                    //Site stuff
                    cSEF.useOrgAddress = function () {
                        var siteOrgUuid = cSEF.site.org ? cSEF.site.org.uuid : null;

                        getSelectedOrg(cSEF.selectedOrgUuid, siteOrgUuid).then(function (org) {
                            cSEF.site.address = {
                                address1: org.address1,
                                address2: org.address2,
                                city: org.city,
                                state: org.state,
                                postal_code: org.postal_code,
                                country_code: org.country_code
                            };
                        });
                    };

                    cSEF.save = function (isValid, site) {
                        cSEF.ajaxPending = true;

                        var sitePayload = angular.copy(site);
                        sitePayload.org_uuid = sitePayload.org.uuid;

                        delete sitePayload.org;

                        cSEF.submitted = true;

                        if (isValid) {
                            checkOrgChange(sitePayload.org_uuid, cSEF.selectedOrgUuid, sitePayload.id).then(function (transitionOptions) {
                                //
                                // Parent AJAX should dictate site save loading animation
                                //
                                Modals.openLoad('Saving Site');
                                cSEF.onSiteUpdate({ site: site, transition: transitionOptions }).then(function () {
                                    Modals.closeLoad('Site successfully saved.', true);
                                })['catch'](function (error) {
                                    var errorMessage;
                                    if (error && error.status === 400) {
                                        errorMessage = 'Site could not be saved. Check form for errors.';
                                    }
                                    Modals.closeLoad(errorMessage || 'Site could not be saved.', false);
                                })['finally'](function () {
                                    cSEF.ajaxPending = false;
                                });
                            });
                        }
                    };

                    cSEF.deleteSite = function (site) {
                        Modals.confirm($scope, 'Cancel', 'Delete', 'This will permanently remove the entire site ' + cSEF.site.id_string + ', are you really sure?').then(function () {
                            Modals.openLoad('Deleting Site');

                            cSEF.onSiteDelete({ site: site }).then(function () {
                                Modals.closeLoad('Site Deleted', true);
                            })['catch'](function () {
                                //@todo No perms? Maybe hide / grey the button instead
                                Modals.closeLoad('Site Deletion Failed');
                            })['finally'](function () {
                                //
                            });
                        });

                        cSEF.delConfirm = false;
                    };

                    cSEF.updateOrgUuid = function (orgUuid) {
                        cSEF.site.org_uuid = orgUuid;
                    };

                    function checkOrgChange(payloadOrgUuid, selectedOrgUuid, targetSiteId) {
                        return payloadOrgUuid === selectedOrgUuid ? $q.resolve(null) : Modals.confirm($scope, 'Cancel', 'Confirm', 'This will move entire site to a new organization, are you really sure?').then(function () {
                            return { target: targetSiteId };
                        });
                    }

                    function getSelectedOrg(selectedOrgUuid, currentSiteOrgUuid) {
                        return selectedOrgUuid === currentSiteOrgUuid ? $q.resolve(cSEF.site.org) : Orgs.getByUuid(selectedOrgUuid);
                    }

                    function getBuildingTypeInfo() {
                        return Sites.getBuildingTypeInfo().then(function (data) {
                            cSEF.newBuildTypes = data.reduce(function (map, item) {
                                if (map[item.category]) {
                                    map[item.category].push({ name: item.name, id: item.id });
                                } else {
                                    map[item.category] = [{ name: item.name, id: item.id }];
                                }
                                return map;
                            }, {});

                            //
                            if (cSEF.site && cSEF.site.building_type) {
                                var match = data.find(function (item) {
                                    return item.id === cSEF.site.building_type;
                                });

                                cSEF.site.mainBuildType = match ? match.category : '';
                            }
                        });
                    }
                }
            };

            _export('default', csSiteEditFormComponent);
        }
    };
});

$__System.register('223', [], function (_export) {
    'use strict';

    var csOrgEditFormComponent;
    return {
        setters: [],
        execute: function () {
            csOrgEditFormComponent = {
                template: '\n        <form name="orgForm" ng-submit="cOEF.saveOrg(cOEF.org, orgForm)" novalidate>\n            <section class="title">\n                <h3 translate="customerService.organizationName">organization name</h3>\n                <input class="zone-name" ng-class="{\'has-error\': orgForm.orgName.$invalid}" type="text" name="orgName" placeholder="{{\'customerService.organizationName\' | translate }}" ng-model="cOEF.org.name" ng-required="true" />\n            </section>\n\n            <section class="description">\n                <h3 translate="customerService.description">description</h3>\n                <input class="" placeholder="{{\'customerService.eg\' | translate}} " ng-model="cOEF.org.description" ng-required="false" />\n            </section>\n\n            <section class="address">\n                <h3 translate="customerService.address">address</h3>\n                \n                <input class="" type="text" placeholder="{{\'customerService.address1\' | translate }}" ng-model="cOEF.org.address1" ng-required="true" />\n\n                <input class="" type="text" placeholder="{{\'customerService.address2\' | translate }}" ng-model="cOEF.org.address2" ng-required="false" />\n\n                <input class="" type="text" placeholder="{{\'customerService.city\' | translate }}" ng-model="cOEF.org.city" ng-required="true" />\n\n                <input class="" type="text" placeholder="{{\'customerService.zipCode\' | translate }}" ng-model="cOEF.org.postal_code" ng-required="true" id="1234" ng-pattern="/^\\d{5}(?:[-\\s]\\d{4})?$/" />\n\n                <input class="" type="text" name="state" placeholder="{{\'customerService.stateCode\' | translate }}" ng-model="cOEF.org.state" ng-required="true" ng-pattern="/^[a-zA-Z]{2}$/" />\n\n                <lc-select ng-class="{submitted: cOEF.submitted}" selection="cOEF.org.country_code" options-default="\'US\'" options-name="country" options-required="true" placeholder="{{\'customerService.country_code\' | translate }}" on-update=""></lc-select>\n\n            </section>\n\n            <section class="timeout">\n                <h3 translate="customerService.organizationTimeout">Organization Timeout</h3>\n\n                <div class="lc-select">\n                    <select ng-model="cOEF.org.session_timeout" ng-required="true" ng-options="timeout.timeout as timeout.length for timeout in cOEF.timeouts" class="no-user-styles">\n                        <option value="" disabled selected>Select Timeout</option>\n                    </select>\n                </div>\n            </section>\n\n            <footer>\n                <p ng-show="orgForm.$invalid && orgForm.$submitted" class="error error-msg organization" translate="customerService.allFieldsRequired">All fields required, No special characters allowed</p>\n                \n                <button type="button" class="btn orange cancel" ng-if="cOEF.org.uuid" ng-click="cOEF.deleteOrg(cOEF.org)" ng-disabled="cOEF.pending" translate="common.delete">Delete</button>\n                <button type="submit" class="btn blue save" ng-disabled="cOEF.pending" ng-bind="cOEF.pending ? \'Saving\' : \'Save\'" ng-click="cOEF.submitted = true"></button>\n            </footer>\n        </form>\n    ',
                bindings: {
                    org: '<',
                    onOrgDelete: '&',
                    onOrgUpdate: '&'
                },
                controllerAs: 'cOEF',
                controller: function controller($rootScope, $scope, $state, $timeout, $q, Orgs, Messages, Modals) {
                    var cOEF = this;

                    cOEF.pending = false;
                    cOEF.error = false;

                    function ajaxError(msg) {
                        Messages.popUp(msg);
                        cOEF.pending = false;
                        cOEF.error = true;
                        console.log('Org save failed');
                    }

                    cOEF.saveOrg = function (org, orgForm) {
                        if (orgForm.$valid) {
                            cOEF.pending = true;
                            cOEF.error = false;

                            org.site_type = 1; //Cover for site type requirement
                            //org.country_code = angular.isObject(cOEF.selectedCountry) ? cOEF.selectedCountry.code : cOEF.selectedCountry;        

                            cOEF.onOrgUpdate({ org: org }).then(function () {
                                //
                            })['catch'](function (error) {
                                //
                                ajaxError(error);
                            })['finally'](function () {
                                cOEF.pending = false;
                            });
                        }
                    };

                    cOEF.deleteOrg = function (org) {
                        console.log('org', org);

                        Modals.confirm($scope, 'Cancel', 'Continue', 'This will permanently remove the entire org, are you really sure?').then(function () {
                            Orgs['delete'](org).then(function () {
                                cOEF.onOrgDelete({ org: cOEF.org });
                            });
                        });

                        cOEF.delConfirm = false;
                    };

                    cOEF.timeouts = [{
                        length: '30 Minutes',
                        timeout: 1800
                    }, {
                        length: '1 Day',
                        timeout: 86400
                    }, {
                        length: '1 Week',
                        timeout: 604800
                    }];

                    this.$onChanges = function (changes) {
                        if (changes.org && changes.org.currentValue) {
                            // set the default timeout if it's not in the list
                            if (!cOEF.timeouts.some(function (timeout) {
                                return timeout.timeout === cOEF.org.session_timeout;
                            })) {
                                cOEF.org.session_timeout = cOEF.timeouts[1].timeout;
                            }
                        }
                    };
                }
            };

            _export('default', csOrgEditFormComponent);
        }
    };
});

$__System.register('224', [], function (_export) {
  'use strict';

  /* @todo -  Find if / why this isnt used */

  var CsGatewayBoxComponent;
  return {
    setters: [],
    execute: function () {
      CsGatewayBoxComponent = {
        template: '\n      <div class="gateway-box">\n        <div class="device-icon lc-gateway">\n          <span class="network caps"  ng-show="csGBD.gateway" ng-class="{\'atnt\': csGBD.gateway.gateway_type === 1, \'verizon\': csGBD.gateway.gateway_type === 2}">\n            {{csGBD.gateway.gateway_type === 0 ? \'Wifi\' : csGBD.gateway.gateway_type === 1 ? \'AT&T\' : csGBD.gateway.gateway_type === 2 ? \'Verizon\' : \'Unknown\'}}\n          </span>\n        </div>\n        <div class="gateway-text">\n          <h1>{{csGBD.gateway.id_string === \'\' ? \'Gateway \'+csGBD.gateway.id : csGBD.gateway.id_string}}</h1>\n          <h2 class="mac">{{csGBD.gateway.mac_addr | cleanMac}}</h2>\n        </div>\n        <div class="gateway-text">\n          <h1>v {{csGBD.gateway.gateway_version}}</h1>\n          <h2 class="mac">\n            <span>{{gateway.ip_address}}</span>\n            <span>Add Devices Mode: <span ng-class="{green: gateway.setup_mode, red: !gateway.setup_mode}">{{gateway.setup_mode ? \'On\':\'Off\'}}</span>\n          </h2>\n        </div>\n      </div>\n    ',
        bindings: {
          gateway: '<'
        },
        controllerAs: 'csGBD',
        controller: function controller() {

          var csGBD = this;

          // csGBD.$onChanges = function(changes){
          //   console.log(changes);
          // };
        }

        // - This was for drag and drop assign, shelved
        // controller($scope, $compile, $rootScope){
        //   $scope.assign = function(){
        //     $('body').append($compile('<cs-gateway-box-directive cs-gateway-box-toast gateway="'+scope.gateway+'"></cs-gateway-box-directive>')($rootScope));
        //   };
        // }
      };

      _export('default', CsGatewayBoxComponent);
    }
  };
});

$__System.registerDynamic("225", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = "<section class=\"gateway-details\">\n    \n    <div class=\"left full\">\n        <div class=\"device-details-group half\">\n            <h3 translate=\"customerService.gatewayName\">Gateway Name</h3>\n            <input class=\"device-zone-input\" type=\"text\" ng-model=\"csGD.gateway.id_string\" ng-change=\"\" />\n        </div>\n        <div class=\"device-details-group half\">\n            <h3>location</h3>\n            <input class=\"device-zone-input\" type=\"text\" ng-model=\"csGD.gateway.description\" ng-change=\"\" />\n        </div>\n        <div class=\"left full\">\n            <button type=\"button\" class=\"btn blue save left\" ng-disabled=\"csGD.pending\" ng-bind=\"csGD.pending ? 'Saving' : 'Save Info'\" ng-click=\"csGD.updateGateway(csGD.gateway)\"></button>\n        </div>\n    </div>\n\n    <div class=\"left full\">\n        <div class=\"device-details-group third\">\n            <h3>Gateway ID</h3>\n            <span>{{::csGD.gateway.id}}</span>\n        </div>\n\n        <div ng-if=\"!(csGD.gateway.is_office_gw || csGD.gateway.is_hub)\" class=\"device-details-group third\">\n            <h3 translate=\"devices.digiFirmware\">Gateway Firmware</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.firmware_version\"></span>\n        </div>\n\n        <div class=\"device-details-group third\">\n            <h3 translate=\"devices.update\">update</h3>\n            <button class=\"btn blue check\" ng-disabled=\"!csGD.gateway.site || csGD.gateway.ajaxPending || csGD.gateway.nextFirmwareUuid === 0 || csGD.gateway.nextFirmwareUuid == 'in progress'\" ng-show=\"!csGD.gateway.nextFirmwareUuid\" ng-click=\"csGD.gateway.checkUpdate()\" ng-bind=\"csGD.gateway.nextFirmwareUuid === 0 ? 'You are up to date' : 'Check for Firmware Update'\"></button>\n            <button class=\"btn blue check\" ng-disabled=\"csGD.gateway.ajaxPending || csGD.gateway.ajaxError || csGD.gateway.nextFirmwareUuid == 'in progress'\" ng-show=\"csGD.gateway.nextFirmwareUuid\" ng-click=\"csGD.gateway.upgrade()\" ng-bind=\"csGD.gateway.nextFirmwareUuid == 'in progress' ? 'Update in progress' : 'Update Firmware'\"></button>\n            <span ng-show=\"csGD.gateway.ajaxError\" ng-bind=\"csGD.gateway.ajaxError\"></span>\n        </div> \n    </div>\n\n    <div class=\"left full\">\n        <div class=\"device-details-group third\" ng-if=\"csGD.gateway.site !== null\">\n            <h3 translate=\"devices.siteCreationDate\">Site Creation Date</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.site_created_date\"></span>\n        </div>\n\n        <div class=\"device-details-group third\">\n            <h3 translate=\"devices.panId\">PAN ID</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.pan_id\"></span>\n        </div>\n\n        <div class=\"device-details-group third\">\n            <h3 translate=\"devices.xbeeFirmwareVersion\">XBee Version</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.xbee_firmware_version || csGD.gateway.xbee_hardware_version\"></span>\n        </div>\n\n        <div class=\"device-details-group third\" ng-show=\"!csGD.gateway.is_hub\">\n            <h3>LTE Bridge Connection</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.lte_bridge_connection ? 'Yes' : 'No'\"></span>\n        </div>\n    </div>\n\n    <div class=\"left full\">\n        <div class=\"device-details-group third\" id=\"signal-strength\" ng-show=\"!csGD.gateway.is_hub\">\n            <h3>Signal Strength</h3>\n            <div class=\"help\" id=\"signalStrength\">\n                <div class=\"arrow\"></div>\n                <p>This indicate the gateway signal strength. Green means Excellent; Yellow means Good; Orange means Fair; Red means Poor; Dark Red means No Signal.</p>\n            </div>\n\n            <i \n                class=\"info override-info\" \n                help \n                data-help-div=\"signalStrength\"\n                id=\"signalStrengthIcon\"\n            ></i>\n\n            <span class=\"gray signal-bar\" ng-class=\"{\n                'excellent': csGD.gateway.last_cell_signal_rssi > -70, \n                'good': csGD.gateway.last_cell_signal_rssi > -85 && csGD.gateway.last_cell_signal_rssi <= -70,\n                'fair': csGD.gateway.last_cell_signal_rssi > -100 && csGD.gateway.last_cell_signal_rssi <= -85, \n                'poor': csGD.gateway.last_cell_signal_rssi > -110 && csGD.gateway.last_cell_signal_rssi <= -100, \n                'none': csGD.gateway.last_cell_signal_rssi === -110\n            }\">{{csGD.gateway.last_cell_signal_rssi}} rssi</span>\n            <span class=\"signal-refresh\" ng-class=\"{'spin': csGD.loading}\" ng-click=\"csGD.refreshSignal(csGD.gateway.id)\"></span>\n        </div>\n\n        <div class=\"device-details-group third\">\n            <h3 translate=\"site.restartGatewayApp\">Restart Gateway App</h3>\n            <button translate=\"site.restartGatewayApp\" type=\"button\" class=\"btn blue\" ng-click=\"csGD.gatewayRestartReboot(csGD.parentSite.id,csGD.gateway.id,'gateway_app_restart')\" ng-disabled=\"csGD.gateway.ajaxPending || !csGD.parentSite.id\">Restart Gateway App</button>\n        </div>\n        <div class=\"device-details-group third\">\n            <h3 translate=\"site.rebootGateway\">Reboot Gateway</h3>\n            <button translate=\"site.rebootGateway\" type=\"button\" class=\"btn blue\" ng-click=\"csGD.gatewayRestartReboot(csGD.parentSite.id,csGD.gateway.id,'gateway_app_reboot')\" ng-disabled=\"csGD.gateway.ajaxPending || !csGD.parentSite.id\">Reboot Gateway</button>\n        </div>\n    </div>\n\n    <div class=\"left full\" ng-if=\"csGD.isSuperUser && !csGD.gateway.is_hub\">\n        <div class=\"device-details-group third\">\n            <h3 translate=\"devices.deviceICCID\">Device iccid</h3>\n            <span ng-bind=\"csGD.gateway.iccid\"></span>\n        </div>\n\n        <div class=\"device-details-group third\" ng-show=\"!csGD.gateway.is_hub\">\n            <h3>IP</h3>\n            <span class=\"gray\" ng-bind=\"csGD.gateway.ip_address\"></span>\n        </div>\n        <!--    \n        <div class=\"device-details-group third\">\n            <h3 translate=\"devices.latLong\">Lat Long</h3>\n            <span class=\"gray\">{{gateway.locality.lat}}, {{gateway.locality.lng}}</span>\n        </div> \n        -->\n        <div class=\"device-details-group third\" ng-show=\"!csGD.gateway.is_hub\">\n            <h3>IMEI / MEID</h3>\n            <span ng-bind=\"csGD.gateway.universal_id\"></span>\n        </div>\n\n        <div class=\"device-details-group half\">\n            <h3>15 Mins Report</h3>\n            <button class=\"btn btn-select-toggle\" ng-disabled=\"!csGD.gateway.site\" ng-class=\"{selected:csGD.parentSite.support_15_min_power > 0}\" ng-click=\"csGD.set15Report(csGD.gateway)\"></button>\n            <span class=\"caps\" translate>{{csGD.parentSite.support_15_min_power > 0 ? 'common.on' : 'common.off'}}</span>\n        </div>\n\n        <div class=\"device-details-group half\">\n            <h3 translate=\"devices.lostSignalMode\">lost signal mode</h3>\n            <button class=\"btn btn-select-toggle\" ng-disabled=\"csGD.gateway.ajaxPending\" ng-class=\"{selected:csGD.heartbeatPeriod > 0}\" ng-click=\"csGD.togglePowerLossMode(csGD.parentSite.id,csGD.heartbeatPeriod)\"></button>\n            <span class=\"caps\" translate>{{csGD.heartbeatPeriod > 0 ? 'common.on' : 'common.off'}}</span>\n        </div>\n\n        <div class=\"left full\">\n            <div class=\"device-details-group half\">\n                <h3>Integrator IP</h3>\n                <input class=\"device-zone-input\" type=\"text\" ng-model=\"csGD.gateway.integrator_ip\" placeholder=\"Update Integrator IP\" /><!-- ng-change=\"sendIntegrator(gateway.integrator_ip)\" -->\n            </div>\n            <div class=\"device-details-group half\">\n                <h3>Integrator Update</h3>\n                <button type=\"button\" class=\"btn blue\" ng-click=\"csGD.sendIntegratorIP(csGD.gateway.id,csGD.gateway.integrator_ip)\">Update IP</button>\n            </div>\n        </div>\n\n        <div class=\"device-details-group half\" ng-if=\"csGD.gateway.site !== null\">\n            <h3 translate=\"\">Unassign Gateway</h3>\n            <button type=\"button\" class=\"btn orange cancel\" ng-click=\"csGD.unassignGateway(csGD.gateway)\">Unassign This Gateway</button> <!-- ng-disabled=\"true\" re-un-dis-abled for multi gw -->\n        </div>\n    </div>\n</section>\n";
});
$__System.register('226', ['225'], function (_export) {
  'use strict';

  var csGatewayDetailsComponentTmpl, csGatewayDetailsComponent;
  return {
    setters: [function (_2) {
      csGatewayDetailsComponentTmpl = _2['default'];
    }],
    execute: function () {
      csGatewayDetailsComponent = {
        template: csGatewayDetailsComponentTmpl,
        bindings: {
          gateway: '<',
          isSuperUser: '<',
          parentSite: '<',
          onUpdate: '&'
        },
        controllerAs: 'csGD',
        controller: function controller($rootScope, $scope, $state, Device, Sites, Modals, Messages, Orgs, LcCache, LcFn, _) {

          var csGD = this;

          var debounceGatewayUpdate = _.debounce(update, 2000);

          csGD.$onInit = function () {
            csGD.gateway = new Device(csGD.gateway, true);
            csGD.heartbeatPeriod = csGD.gateway.heartbeat_period;
          };

          csGD.refreshSignal = function (gatewayId) {
            csGD.loading = true;
            Orgs.refreshSignal(gatewayId).then(function (gateway) {
              if (gateway && gateway.rssi) {
                csGD.gateway.last_cell_signal_rssi = gateway.rssi;
              }
              csGD.loading = false;
            });
          };

          csGD.unassignGateway = function (gateway) {
            //
            //
            //
            Modals.confirm($scope, 'Cancel', 'Unassign', 'Are you sure you want to unassign this gateway?').then(function () {

              function finalize() {
                $rootScope.$broadcast('cs-bar:updateGatewayList');
                csGD.ajaxPending = false;
                //
                // Can't refresh gateways and transition state...
                // $rootScope.$broadcast('event:refreshGateways');
                $state.go('Home');
              }

              Modals.openLoad('Unassigning Gateway');
              var site = angular.copy(csGD.parentSite);

              site.gateways.splice(_.findIndex(site.gateways, { id: gateway.id }), 1);

              csGD.ajaxPending = true;

              Sites.update(site).then(function (site) {
                if (!_.find(site.gateways, ['id', gateway.id])) {
                  Modals.closeLoad('Unassigning Successful', true);
                  finalize();
                } else {
                  //@todo dmitry - BE gives a 200
                  Modals.closeLoad('Unassigning Failure');
                  //Messages.popUp({error_msg: 'Failed to unassign gateway '+gateway.id})
                  csGD.ajaxPending = false;
                }
              });
            });
          };

          csGD.updateGateway = function (gateway) {
            debounceGatewayUpdate(gateway);
          };

          csGD.set15Report = function (gateway) {
            csGD.ajaxPending = true;

            if (csGD.parentSite.support_15_min_power === 15 || csGD.parentSite.support_15_min_power === true) {
              csGD.parentSite.support_15_min_power = 0;
            } else {
              csGD.parentSite.support_15_min_power = 15;
            }

            Modals.openLoad('Setting 15 Minutes Power Monitor');

            Sites.setPowerMonitor(csGD.parentSite.id, csGD.parentSite.support_15_min_power).success(function () {
              csGD.ajaxPending = false;
              Modals.closeLoad('Setting Success', true);
            }).error(function () {
              Modals.closeLoad('Setting 15 Minutes Power Monitor Failed');
            });
          };

          csGD.togglePowerLossMode = function (siteId, period) {
            csGD.ajaxPending = true;

            //
            // Don't allow any custom values, just use default or 0 for off
            //
            if (!period) {
              period = LcFn.defaults.heartbeat.gatewayHeartbeatPeriod;
            } else {
              period = 0;
            }

            Modals.openLoad('Setting Power Loss Value');

            Sites.setPowerLossMode(siteId, period).then(function () {
              Modals.closeLoad('Setting Success', true);
            })['catch'](function () {
              Modals.closeLoad('Setting Power Loss Value Failed');
            })['finally'](function () {
              csGD.ajaxPending = false;

              csGD.heartbeatPeriod = period;
              //
              //  @todo @refactor @BE
              //
              // No gateway socket update message from the backend so we fake it here
              // Should send from site service but no gateway object is returned from BE
              //
              csGD.gateway.heartbeat_period = period;
              LcCache.updateSessionSiteSectionChild('gateways', [csGD.gateway]);
            });
          };

          csGD.sendIntegratorIP = function (gatewayID, newIP) {
            Modals.openLoad('Sending New IP');

            Orgs.sendIntegratorIP(gatewayID, newIP).then(function (result) {
              Modals.closeLoad(result, true);
            })['catch'](function (error) {
              Messages.popUp({ error_msg: error }, 'Save IP Failed');
              Modals.closeLoad(error);
            });
          };

          csGD.gatewayRestartReboot = function (siteId, gatewayID, command) {
            Modals.confirm($scope, 'Cancel', 'Continue', 'Gateway will be unresponsive during this period and scheduled events may not occur, do you wish to continue?').then(function () {
              Modals.openLoad('Sending Command');

              Sites.gatewayRestartReboot(siteId, gatewayID, command).then(function (result) {
                Modals.closeLoad('Success', true);
              })['catch'](function (error) {
                Messages.popUp({ error_msg: error }, 'Command Send Failed');
                Modals.closeLoad(error);
              });
            });
          };

          function update(gateway) {
            Modals.openLoad('Updating Gateway Details');

            Orgs.updateGateway(gateway).then(function (updatedGateway) {
              csGD.onUpdate({ updatedGateway: updatedGateway });

              Modals.closeLoad('Gateway Details successfully updated', true);
            })['catch'](function (error) {
              Modals.closeLoad('Error reaching server', false);
              reject(error);
            });
          }
        }
      };

      _export('default', csGatewayDetailsComponent);
    }
  };
});

$__System.register('227', [], function (_export) {
    //
    //
    // We want site data here but not under masterParent split view
    //
    //

    'use strict';

    //import activityScss from './activity.scss';

    var activityMasterBaseComponent;
    return {
        setters: [],
        execute: function () {
            activityMasterBaseComponent = {
                template: '\n      <notifications-bottom-site-notices ng-if="aMBC.sessionData.id" gateway="aMBC.sessionData.gateways[0]" setup-mode="aMBC.sessionData.setupMode;" site-id="aMBC.sessionData.id"  user="aMBC.user" on-update-master="aMBC.updateMasterSessionDataFromNetwork()"></notifications-bottom-site-notices><!--\n\n     --><section class="selection-container full-page" ng-class="{scroll:$root.scroll}">\n            <activity-base header-title="aMBC.sessionData.id_string" notifications="aMBC.sessionData.notifications" user="aMBC.user" on-clear-to-base="aMBC.clearGotoBaseView(createNew)" on-selection-update="aMBC.onSelectionUpdate(selection)" on-menu-toggle="aMBC.onMenuToggle();"></activity-base>\n        </section>\n    ', // Remove inline-block whitespace with comments
                //replace: true,
                bindings: {
                    initialSessionData: '<', //siteData in state resolve
                    initialSelectedIds: '<',
                    initialSessionSitesListPromise: '<', //Don't hold resolve for sites list - takes too long
                    menuOpen: '<',
                    user: '<',
                    viewNavContext: '@',
                    //
                    // Out
                    //
                    onSessionDataChange: '&',
                    onMenuToggle: '&'
                },
                controllerAs: 'aMBC',
                controller: function controller() {

                    var aMBC = this;

                    aMBC.$onInit = function () {
                        aMBC.onSessionDataChange({ data: aMBC.initialSessionData });

                        aMBC.sessionData = angular.copy(aMBC.initialSessionData);

                        aMBC.initialSessionSitesListPromise.promise.then(function (list) {
                            aMBC.sitesList = list;
                        });
                    };

                    aMBC.$onChanges = function (changes) {
                        //
                        console.log('Change in master parent');
                        console.log(changes);
                    };

                    aMBC.onSelectionUpdate = function (selection) {
                        //
                        // Use sessionparams instead of selection here?
                        //
                    };
                }

            };

            _export('default', activityMasterBaseComponent);
        }
    };
});

$__System.register('228', [], function (_export) {
	'use strict';

	var activityBaseComponent;
	return {
		setters: [],
		execute: function () {
			activityBaseComponent = {
				template: '\n\t\t<header class="main-header">\n\t\t    <button class="btn-menu mainMenu" ng-click="aBC.onMenuToggle();"></button>\n\t\t    <h1>{{::aBC.headerTitle}} Activity</h1>\n\t\t</header>\n\n\t\t<section class="main-body">\n\n\t\t\t<activity-timeline notifications="aBC.notifications"></activity-timeline>\n\n\t\t\t<activity-event-list notifications="aBC.notifications"></activity-event-list>\n\n\t\t</section>\n    ', // Remove inline-block whitespace with comments
				//replace: true,
				bindings: {
					headerTitle: '<',
					notifications: '<',
					user: '<',
					//
					// Out
					//
					onMenuToggle: '&',
					onClearToBase: '&',
					onSelectionUpdate: '&'
				},
				controllerAs: 'aBC',
				controller: function controller() {

					var aBC = this;

					//for sorting the table
					aBC.orderBy = 'name';

					aBC.sortTable = function (orderBy) {
						return orderBy;
					};

					aBC.sort = function (str) {
						if (aBC.orderBy === str) {
							if (aBC.orderBy[0] === '-') {
								aBC.orderBy = aBC.orderBy.substring(1);
							} else {
								aBC.orderBy = '-' + aBC.orderBy;
							}
						} else {
							aBC.orderBy = str;
						}
					};
				}
			};

			_export('default', activityBaseComponent);
		}
	};
});

$__System.registerDynamic("229", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, "d3", null);

  (function ($__global) {
    /* */
    "format global";
    "exports d3";

    !function () {
      var d3 = {
        version: "3.5.17"
      };
      var d3_arraySlice = [].slice,
          d3_array = function (list) {
        return d3_arraySlice.call(list);
      };
      var d3_document = this.document;
      function d3_documentElement(node) {
        return node && (node.ownerDocument || node.document || node).documentElement;
      }
      function d3_window(node) {
        return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
      }
      if (d3_document) {
        try {
          d3_array(d3_document.documentElement.childNodes)[0].nodeType;
        } catch (e) {
          d3_array = function (list) {
            var i = list.length,
                array = new Array(i);
            while (i--) array[i] = list[i];
            return array;
          };
        }
      }
      if (!Date.now) Date.now = function () {
        return +new Date();
      };
      if (d3_document) {
        try {
          d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
        } catch (error) {
          var d3_element_prototype = this.Element.prototype,
              d3_element_setAttribute = d3_element_prototype.setAttribute,
              d3_element_setAttributeNS = d3_element_prototype.setAttributeNS,
              d3_style_prototype = this.CSSStyleDeclaration.prototype,
              d3_style_setProperty = d3_style_prototype.setProperty;
          d3_element_prototype.setAttribute = function (name, value) {
            d3_element_setAttribute.call(this, name, value + "");
          };
          d3_element_prototype.setAttributeNS = function (space, local, value) {
            d3_element_setAttributeNS.call(this, space, local, value + "");
          };
          d3_style_prototype.setProperty = function (name, value, priority) {
            d3_style_setProperty.call(this, name, value + "", priority);
          };
        }
      }
      d3.ascending = d3_ascending;
      function d3_ascending(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
      }
      d3.descending = function (a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
      };
      d3.min = function (array, f) {
        var i = -1,
            n = array.length,
            a,
            b;
        if (arguments.length === 1) {
          while (++i < n) if ((b = array[i]) != null && b >= b) {
            a = b;
            break;
          }
          while (++i < n) if ((b = array[i]) != null && a > b) a = b;
        } else {
          while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
            a = b;
            break;
          }
          while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
        }
        return a;
      };
      d3.max = function (array, f) {
        var i = -1,
            n = array.length,
            a,
            b;
        if (arguments.length === 1) {
          while (++i < n) if ((b = array[i]) != null && b >= b) {
            a = b;
            break;
          }
          while (++i < n) if ((b = array[i]) != null && b > a) a = b;
        } else {
          while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
            a = b;
            break;
          }
          while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
        }
        return a;
      };
      d3.extent = function (array, f) {
        var i = -1,
            n = array.length,
            a,
            b,
            c;
        if (arguments.length === 1) {
          while (++i < n) if ((b = array[i]) != null && b >= b) {
            a = c = b;
            break;
          }
          while (++i < n) if ((b = array[i]) != null) {
            if (a > b) a = b;
            if (c < b) c = b;
          }
        } else {
          while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
            a = c = b;
            break;
          }
          while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
            if (a > b) a = b;
            if (c < b) c = b;
          }
        }
        return [a, c];
      };
      function d3_number(x) {
        return x === null ? NaN : +x;
      }
      function d3_numeric(x) {
        return !isNaN(x);
      }
      d3.sum = function (array, f) {
        var s = 0,
            n = array.length,
            a,
            i = -1;
        if (arguments.length === 1) {
          while (++i < n) if (d3_numeric(a = +array[i])) s += a;
        } else {
          while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
        }
        return s;
      };
      d3.mean = function (array, f) {
        var s = 0,
            n = array.length,
            a,
            i = -1,
            j = n;
        if (arguments.length === 1) {
          while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a;else --j;
        } else {
          while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a;else --j;
        }
        if (j) return s / j;
      };
      d3.quantile = function (values, p) {
        var H = (values.length - 1) * p + 1,
            h = Math.floor(H),
            v = +values[h - 1],
            e = H - h;
        return e ? v + e * (values[h] - v) : v;
      };
      d3.median = function (array, f) {
        var numbers = [],
            n = array.length,
            a,
            i = -1;
        if (arguments.length === 1) {
          while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
        } else {
          while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
        }
        if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
      };
      d3.variance = function (array, f) {
        var n = array.length,
            m = 0,
            a,
            d,
            s = 0,
            i = -1,
            j = 0;
        if (arguments.length === 1) {
          while (++i < n) {
            if (d3_numeric(a = d3_number(array[i]))) {
              d = a - m;
              m += d / ++j;
              s += d * (a - m);
            }
          }
        } else {
          while (++i < n) {
            if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
              d = a - m;
              m += d / ++j;
              s += d * (a - m);
            }
          }
        }
        if (j > 1) return s / (j - 1);
      };
      d3.deviation = function () {
        var v = d3.variance.apply(this, arguments);
        return v ? Math.sqrt(v) : v;
      };
      function d3_bisector(compare) {
        return {
          left: function (a, x, lo, hi) {
            if (arguments.length < 3) lo = 0;
            if (arguments.length < 4) hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
            }
            return lo;
          },
          right: function (a, x, lo, hi) {
            if (arguments.length < 3) lo = 0;
            if (arguments.length < 4) hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
            }
            return lo;
          }
        };
      }
      var d3_bisect = d3_bisector(d3_ascending);
      d3.bisectLeft = d3_bisect.left;
      d3.bisect = d3.bisectRight = d3_bisect.right;
      d3.bisector = function (f) {
        return d3_bisector(f.length === 1 ? function (d, x) {
          return d3_ascending(f(d), x);
        } : f);
      };
      d3.shuffle = function (array, i0, i1) {
        if ((m = arguments.length) < 3) {
          i1 = array.length;
          if (m < 2) i0 = 0;
        }
        var m = i1 - i0,
            t,
            i;
        while (m) {
          i = Math.random() * m-- | 0;
          t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
        }
        return array;
      };
      d3.permute = function (array, indexes) {
        var i = indexes.length,
            permutes = new Array(i);
        while (i--) permutes[i] = array[indexes[i]];
        return permutes;
      };
      d3.pairs = function (array) {
        var i = 0,
            n = array.length - 1,
            p0,
            p1 = array[0],
            pairs = new Array(n < 0 ? 0 : n);
        while (i < n) pairs[i] = [p0 = p1, p1 = array[++i]];
        return pairs;
      };
      d3.transpose = function (matrix) {
        if (!(n = matrix.length)) return [];
        for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m;) {
          for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
            row[j] = matrix[j][i];
          }
        }
        return transpose;
      };
      function d3_transposeLength(d) {
        return d.length;
      }
      d3.zip = function () {
        return d3.transpose(arguments);
      };
      d3.keys = function (map) {
        var keys = [];
        for (var key in map) keys.push(key);
        return keys;
      };
      d3.values = function (map) {
        var values = [];
        for (var key in map) values.push(map[key]);
        return values;
      };
      d3.entries = function (map) {
        var entries = [];
        for (var key in map) entries.push({
          key: key,
          value: map[key]
        });
        return entries;
      };
      d3.merge = function (arrays) {
        var n = arrays.length,
            m,
            i = -1,
            j = 0,
            merged,
            array;
        while (++i < n) j += arrays[i].length;
        merged = new Array(j);
        while (--n >= 0) {
          array = arrays[n];
          m = array.length;
          while (--m >= 0) {
            merged[--j] = array[m];
          }
        }
        return merged;
      };
      var abs = Math.abs;
      d3.range = function (start, stop, step) {
        if (arguments.length < 3) {
          step = 1;
          if (arguments.length < 2) {
            stop = start;
            start = 0;
          }
        }
        if ((stop - start) / step === Infinity) throw new Error("infinite range");
        var range = [],
            k = d3_range_integerScale(abs(step)),
            i = -1,
            j;
        start *= k, stop *= k, step *= k;
        if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k);else while ((j = start + step * ++i) < stop) range.push(j / k);
        return range;
      };
      function d3_range_integerScale(x) {
        var k = 1;
        while (x * k % 1) k *= 10;
        return k;
      }
      function d3_class(ctor, properties) {
        for (var key in properties) {
          Object.defineProperty(ctor.prototype, key, {
            value: properties[key],
            enumerable: false
          });
        }
      }
      d3.map = function (object, f) {
        var map = new d3_Map();
        if (object instanceof d3_Map) {
          object.forEach(function (key, value) {
            map.set(key, value);
          });
        } else if (Array.isArray(object)) {
          var i = -1,
              n = object.length,
              o;
          if (arguments.length === 1) while (++i < n) map.set(i, object[i]);else while (++i < n) map.set(f.call(object, o = object[i], i), o);
        } else {
          for (var key in object) map.set(key, object[key]);
        }
        return map;
      };
      function d3_Map() {
        this._ = Object.create(null);
      }
      var d3_map_proto = "__proto__",
          d3_map_zero = "\x00";
      d3_class(d3_Map, {
        has: d3_map_has,
        get: function (key) {
          return this._[d3_map_escape(key)];
        },
        set: function (key, value) {
          return this._[d3_map_escape(key)] = value;
        },
        remove: d3_map_remove,
        keys: d3_map_keys,
        values: function () {
          var values = [];
          for (var key in this._) values.push(this._[key]);
          return values;
        },
        entries: function () {
          var entries = [];
          for (var key in this._) entries.push({
            key: d3_map_unescape(key),
            value: this._[key]
          });
          return entries;
        },
        size: d3_map_size,
        empty: d3_map_empty,
        forEach: function (f) {
          for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
        }
      });
      function d3_map_escape(key) {
        return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
      }
      function d3_map_unescape(key) {
        return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
      }
      function d3_map_has(key) {
        return d3_map_escape(key) in this._;
      }
      function d3_map_remove(key) {
        return (key = d3_map_escape(key)) in this._ && delete this._[key];
      }
      function d3_map_keys() {
        var keys = [];
        for (var key in this._) keys.push(d3_map_unescape(key));
        return keys;
      }
      function d3_map_size() {
        var size = 0;
        for (var key in this._) ++size;
        return size;
      }
      function d3_map_empty() {
        for (var key in this._) return false;
        return true;
      }
      d3.nest = function () {
        var nest = {},
            keys = [],
            sortKeys = [],
            sortValues,
            rollup;
        function map(mapType, array, depth) {
          if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
          var i = -1,
              n = array.length,
              key = keys[depth++],
              keyValue,
              object,
              setter,
              valuesByKey = new d3_Map(),
              values;
          while (++i < n) {
            if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
              values.push(object);
            } else {
              valuesByKey.set(keyValue, [object]);
            }
          }
          if (mapType) {
            object = mapType();
            setter = function (keyValue, values) {
              object.set(keyValue, map(mapType, values, depth));
            };
          } else {
            object = {};
            setter = function (keyValue, values) {
              object[keyValue] = map(mapType, values, depth);
            };
          }
          valuesByKey.forEach(setter);
          return object;
        }
        function entries(map, depth) {
          if (depth >= keys.length) return map;
          var array = [],
              sortKey = sortKeys[depth++];
          map.forEach(function (key, keyMap) {
            array.push({
              key: key,
              values: entries(keyMap, depth)
            });
          });
          return sortKey ? array.sort(function (a, b) {
            return sortKey(a.key, b.key);
          }) : array;
        }
        nest.map = function (array, mapType) {
          return map(mapType, array, 0);
        };
        nest.entries = function (array) {
          return entries(map(d3.map, array, 0), 0);
        };
        nest.key = function (d) {
          keys.push(d);
          return nest;
        };
        nest.sortKeys = function (order) {
          sortKeys[keys.length - 1] = order;
          return nest;
        };
        nest.sortValues = function (order) {
          sortValues = order;
          return nest;
        };
        nest.rollup = function (f) {
          rollup = f;
          return nest;
        };
        return nest;
      };
      d3.set = function (array) {
        var set = new d3_Set();
        if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
        return set;
      };
      function d3_Set() {
        this._ = Object.create(null);
      }
      d3_class(d3_Set, {
        has: d3_map_has,
        add: function (key) {
          this._[d3_map_escape(key += "")] = true;
          return key;
        },
        remove: d3_map_remove,
        values: d3_map_keys,
        size: d3_map_size,
        empty: d3_map_empty,
        forEach: function (f) {
          for (var key in this._) f.call(this, d3_map_unescape(key));
        }
      });
      d3.behavior = {};
      function d3_identity(d) {
        return d;
      }
      d3.rebind = function (target, source) {
        var i = 1,
            n = arguments.length,
            method;
        while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
        return target;
      };
      function d3_rebind(target, source, method) {
        return function () {
          var value = method.apply(source, arguments);
          return value === source ? target : value;
        };
      }
      function d3_vendorSymbol(object, name) {
        if (name in object) return name;
        name = name.charAt(0).toUpperCase() + name.slice(1);
        for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
          var prefixName = d3_vendorPrefixes[i] + name;
          if (prefixName in object) return prefixName;
        }
      }
      var d3_vendorPrefixes = ["webkit", "ms", "moz", "Moz", "o", "O"];
      function d3_noop() {}
      d3.dispatch = function () {
        var dispatch = new d3_dispatch(),
            i = -1,
            n = arguments.length;
        while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        return dispatch;
      };
      function d3_dispatch() {}
      d3_dispatch.prototype.on = function (type, listener) {
        var i = type.indexOf("."),
            name = "";
        if (i >= 0) {
          name = type.slice(i + 1);
          type = type.slice(0, i);
        }
        if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
        if (arguments.length === 2) {
          if (listener == null) for (type in this) {
            if (this.hasOwnProperty(type)) this[type].on(name, null);
          }
          return this;
        }
      };
      function d3_dispatch_event(dispatch) {
        var listeners = [],
            listenerByName = new d3_Map();
        function event() {
          var z = listeners,
              i = -1,
              n = z.length,
              l;
          while (++i < n) if (l = z[i].on) l.apply(this, arguments);
          return dispatch;
        }
        event.on = function (name, listener) {
          var l = listenerByName.get(name),
              i;
          if (arguments.length < 2) return l && l.on;
          if (l) {
            l.on = null;
            listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
            listenerByName.remove(name);
          }
          if (listener) listeners.push(listenerByName.set(name, {
            on: listener
          }));
          return dispatch;
        };
        return event;
      }
      d3.event = null;
      function d3_eventPreventDefault() {
        d3.event.preventDefault();
      }
      function d3_eventSource() {
        var e = d3.event,
            s;
        while (s = e.sourceEvent) e = s;
        return e;
      }
      function d3_eventDispatch(target) {
        var dispatch = new d3_dispatch(),
            i = 0,
            n = arguments.length;
        while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        dispatch.of = function (thiz, argumentz) {
          return function (e1) {
            try {
              var e0 = e1.sourceEvent = d3.event;
              e1.target = target;
              d3.event = e1;
              dispatch[e1.type].apply(thiz, argumentz);
            } finally {
              d3.event = e0;
            }
          };
        };
        return dispatch;
      }
      d3.requote = function (s) {
        return s.replace(d3_requote_re, "\\$&");
      };
      var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
      var d3_subclass = {}.__proto__ ? function (object, prototype) {
        object.__proto__ = prototype;
      } : function (object, prototype) {
        for (var property in prototype) object[property] = prototype[property];
      };
      function d3_selection(groups) {
        d3_subclass(groups, d3_selectionPrototype);
        return groups;
      }
      var d3_select = function (s, n) {
        return n.querySelector(s);
      },
          d3_selectAll = function (s, n) {
        return n.querySelectorAll(s);
      },
          d3_selectMatches = function (n, s) {
        var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
        d3_selectMatches = function (n, s) {
          return d3_selectMatcher.call(n, s);
        };
        return d3_selectMatches(n, s);
      };
      if (typeof Sizzle === "function") {
        d3_select = function (s, n) {
          return Sizzle(s, n)[0] || null;
        };
        d3_selectAll = Sizzle;
        d3_selectMatches = Sizzle.matchesSelector;
      }
      d3.selection = function () {
        return d3.select(d3_document.documentElement);
      };
      var d3_selectionPrototype = d3.selection.prototype = [];
      d3_selectionPrototype.select = function (selector) {
        var subgroups = [],
            subgroup,
            subnode,
            group,
            node;
        selector = d3_selection_selector(selector);
        for (var j = -1, m = this.length; ++j < m;) {
          subgroups.push(subgroup = []);
          subgroup.parentNode = (group = this[j]).parentNode;
          for (var i = -1, n = group.length; ++i < n;) {
            if (node = group[i]) {
              subgroup.push(subnode = selector.call(node, node.__data__, i, j));
              if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_selector(selector) {
        return typeof selector === "function" ? selector : function () {
          return d3_select(selector, this);
        };
      }
      d3_selectionPrototype.selectAll = function (selector) {
        var subgroups = [],
            subgroup,
            node;
        selector = d3_selection_selectorAll(selector);
        for (var j = -1, m = this.length; ++j < m;) {
          for (var group = this[j], i = -1, n = group.length; ++i < n;) {
            if (node = group[i]) {
              subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
              subgroup.parentNode = node;
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_selectorAll(selector) {
        return typeof selector === "function" ? selector : function () {
          return d3_selectAll(selector, this);
        };
      }
      var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
      var d3_nsPrefix = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: d3_nsXhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
      };
      d3.ns = {
        prefix: d3_nsPrefix,
        qualify: function (name) {
          var i = name.indexOf(":"),
              prefix = name;
          if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
          return d3_nsPrefix.hasOwnProperty(prefix) ? {
            space: d3_nsPrefix[prefix],
            local: name
          } : name;
        }
      };
      d3_selectionPrototype.attr = function (name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string") {
            var node = this.node();
            name = d3.ns.qualify(name);
            return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
          }
          for (value in name) this.each(d3_selection_attr(value, name[value]));
          return this;
        }
        return this.each(d3_selection_attr(name, value));
      };
      function d3_selection_attr(name, value) {
        name = d3.ns.qualify(name);
        function attrNull() {
          this.removeAttribute(name);
        }
        function attrNullNS() {
          this.removeAttributeNS(name.space, name.local);
        }
        function attrConstant() {
          this.setAttribute(name, value);
        }
        function attrConstantNS() {
          this.setAttributeNS(name.space, name.local, value);
        }
        function attrFunction() {
          var x = value.apply(this, arguments);
          if (x == null) this.removeAttribute(name);else this.setAttribute(name, x);
        }
        function attrFunctionNS() {
          var x = value.apply(this, arguments);
          if (x == null) this.removeAttributeNS(name.space, name.local);else this.setAttributeNS(name.space, name.local, x);
        }
        return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
      }
      function d3_collapse(s) {
        return s.trim().replace(/\s+/g, " ");
      }
      d3_selectionPrototype.classed = function (name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string") {
            var node = this.node(),
                n = (name = d3_selection_classes(name)).length,
                i = -1;
            if (value = node.classList) {
              while (++i < n) if (!value.contains(name[i])) return false;
            } else {
              value = node.getAttribute("class");
              while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
            }
            return true;
          }
          for (value in name) this.each(d3_selection_classed(value, name[value]));
          return this;
        }
        return this.each(d3_selection_classed(name, value));
      };
      function d3_selection_classedRe(name) {
        return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
      }
      function d3_selection_classes(name) {
        return (name + "").trim().split(/^|\s+/);
      }
      function d3_selection_classed(name, value) {
        name = d3_selection_classes(name).map(d3_selection_classedName);
        var n = name.length;
        function classedConstant() {
          var i = -1;
          while (++i < n) name[i](this, value);
        }
        function classedFunction() {
          var i = -1,
              x = value.apply(this, arguments);
          while (++i < n) name[i](this, x);
        }
        return typeof value === "function" ? classedFunction : classedConstant;
      }
      function d3_selection_classedName(name) {
        var re = d3_selection_classedRe(name);
        return function (node, value) {
          if (c = node.classList) return value ? c.add(name) : c.remove(name);
          var c = node.getAttribute("class") || "";
          if (value) {
            re.lastIndex = 0;
            if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
          } else {
            node.setAttribute("class", d3_collapse(c.replace(re, " ")));
          }
        };
      }
      d3_selectionPrototype.style = function (name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof name !== "string") {
            if (n < 2) value = "";
            for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
            return this;
          }
          if (n < 2) {
            var node = this.node();
            return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
          }
          priority = "";
        }
        return this.each(d3_selection_style(name, value, priority));
      };
      function d3_selection_style(name, value, priority) {
        function styleNull() {
          this.style.removeProperty(name);
        }
        function styleConstant() {
          this.style.setProperty(name, value, priority);
        }
        function styleFunction() {
          var x = value.apply(this, arguments);
          if (x == null) this.style.removeProperty(name);else this.style.setProperty(name, x, priority);
        }
        return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
      }
      d3_selectionPrototype.property = function (name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string") return this.node()[name];
          for (value in name) this.each(d3_selection_property(value, name[value]));
          return this;
        }
        return this.each(d3_selection_property(name, value));
      };
      function d3_selection_property(name, value) {
        function propertyNull() {
          delete this[name];
        }
        function propertyConstant() {
          this[name] = value;
        }
        function propertyFunction() {
          var x = value.apply(this, arguments);
          if (x == null) delete this[name];else this[name] = x;
        }
        return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
      }
      d3_selectionPrototype.text = function (value) {
        return arguments.length ? this.each(typeof value === "function" ? function () {
          var v = value.apply(this, arguments);
          this.textContent = v == null ? "" : v;
        } : value == null ? function () {
          this.textContent = "";
        } : function () {
          this.textContent = value;
        }) : this.node().textContent;
      };
      d3_selectionPrototype.html = function (value) {
        return arguments.length ? this.each(typeof value === "function" ? function () {
          var v = value.apply(this, arguments);
          this.innerHTML = v == null ? "" : v;
        } : value == null ? function () {
          this.innerHTML = "";
        } : function () {
          this.innerHTML = value;
        }) : this.node().innerHTML;
      };
      d3_selectionPrototype.append = function (name) {
        name = d3_selection_creator(name);
        return this.select(function () {
          return this.appendChild(name.apply(this, arguments));
        });
      };
      function d3_selection_creator(name) {
        function create() {
          var document = this.ownerDocument,
              namespace = this.namespaceURI;
          return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
        }
        function createNS() {
          return this.ownerDocument.createElementNS(name.space, name.local);
        }
        return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
      }
      d3_selectionPrototype.insert = function (name, before) {
        name = d3_selection_creator(name);
        before = d3_selection_selector(before);
        return this.select(function () {
          return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
        });
      };
      d3_selectionPrototype.remove = function () {
        return this.each(d3_selectionRemove);
      };
      function d3_selectionRemove() {
        var parent = this.parentNode;
        if (parent) parent.removeChild(this);
      }
      d3_selectionPrototype.data = function (value, key) {
        var i = -1,
            n = this.length,
            group,
            node;
        if (!arguments.length) {
          value = new Array(n = (group = this[0]).length);
          while (++i < n) {
            if (node = group[i]) {
              value[i] = node.__data__;
            }
          }
          return value;
        }
        function bind(group, groupData) {
          var i,
              n = group.length,
              m = groupData.length,
              n0 = Math.min(n, m),
              updateNodes = new Array(m),
              enterNodes = new Array(m),
              exitNodes = new Array(n),
              node,
              nodeData;
          if (key) {
            var nodeByKeyValue = new d3_Map(),
                keyValues = new Array(n),
                keyValue;
            for (i = -1; ++i < n;) {
              if (node = group[i]) {
                if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
                  exitNodes[i] = node;
                } else {
                  nodeByKeyValue.set(keyValue, node);
                }
                keyValues[i] = keyValue;
              }
            }
            for (i = -1; ++i < m;) {
              if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
                enterNodes[i] = d3_selection_dataNode(nodeData);
              } else if (node !== true) {
                updateNodes[i] = node;
                node.__data__ = nodeData;
              }
              nodeByKeyValue.set(keyValue, true);
            }
            for (i = -1; ++i < n;) {
              if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
                exitNodes[i] = group[i];
              }
            }
          } else {
            for (i = -1; ++i < n0;) {
              node = group[i];
              nodeData = groupData[i];
              if (node) {
                node.__data__ = nodeData;
                updateNodes[i] = node;
              } else {
                enterNodes[i] = d3_selection_dataNode(nodeData);
              }
            }
            for (; i < m; ++i) {
              enterNodes[i] = d3_selection_dataNode(groupData[i]);
            }
            for (; i < n; ++i) {
              exitNodes[i] = group[i];
            }
          }
          enterNodes.update = updateNodes;
          enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
          enter.push(enterNodes);
          update.push(updateNodes);
          exit.push(exitNodes);
        }
        var enter = d3_selection_enter([]),
            update = d3_selection([]),
            exit = d3_selection([]);
        if (typeof value === "function") {
          while (++i < n) {
            bind(group = this[i], value.call(group, group.parentNode.__data__, i));
          }
        } else {
          while (++i < n) {
            bind(group = this[i], value);
          }
        }
        update.enter = function () {
          return enter;
        };
        update.exit = function () {
          return exit;
        };
        return update;
      };
      function d3_selection_dataNode(data) {
        return {
          __data__: data
        };
      }
      d3_selectionPrototype.datum = function (value) {
        return arguments.length ? this.property("__data__", value) : this.property("__data__");
      };
      d3_selectionPrototype.filter = function (filter) {
        var subgroups = [],
            subgroup,
            group,
            node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for (var j = 0, m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          subgroup.parentNode = (group = this[j]).parentNode;
          for (var i = 0, n = group.length; i < n; i++) {
            if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
              subgroup.push(node);
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_filter(selector) {
        return function () {
          return d3_selectMatches(this, selector);
        };
      }
      d3_selectionPrototype.order = function () {
        for (var j = -1, m = this.length; ++j < m;) {
          for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
            if (node = group[i]) {
              if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
              next = node;
            }
          }
        }
        return this;
      };
      d3_selectionPrototype.sort = function (comparator) {
        comparator = d3_selection_sortComparator.apply(this, arguments);
        for (var j = -1, m = this.length; ++j < m;) this[j].sort(comparator);
        return this.order();
      };
      function d3_selection_sortComparator(comparator) {
        if (!arguments.length) comparator = d3_ascending;
        return function (a, b) {
          return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
        };
      }
      d3_selectionPrototype.each = function (callback) {
        return d3_selection_each(this, function (node, i, j) {
          callback.call(node, node.__data__, i, j);
        });
      };
      function d3_selection_each(groups, callback) {
        for (var j = 0, m = groups.length; j < m; j++) {
          for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
            if (node = group[i]) callback(node, i, j);
          }
        }
        return groups;
      }
      d3_selectionPrototype.call = function (callback) {
        var args = d3_array(arguments);
        callback.apply(args[0] = this, args);
        return this;
      };
      d3_selectionPrototype.empty = function () {
        return !this.node();
      };
      d3_selectionPrototype.node = function () {
        for (var j = 0, m = this.length; j < m; j++) {
          for (var group = this[j], i = 0, n = group.length; i < n; i++) {
            var node = group[i];
            if (node) return node;
          }
        }
        return null;
      };
      d3_selectionPrototype.size = function () {
        var n = 0;
        d3_selection_each(this, function () {
          ++n;
        });
        return n;
      };
      function d3_selection_enter(selection) {
        d3_subclass(selection, d3_selection_enterPrototype);
        return selection;
      }
      var d3_selection_enterPrototype = [];
      d3.selection.enter = d3_selection_enter;
      d3.selection.enter.prototype = d3_selection_enterPrototype;
      d3_selection_enterPrototype.append = d3_selectionPrototype.append;
      d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
      d3_selection_enterPrototype.node = d3_selectionPrototype.node;
      d3_selection_enterPrototype.call = d3_selectionPrototype.call;
      d3_selection_enterPrototype.size = d3_selectionPrototype.size;
      d3_selection_enterPrototype.select = function (selector) {
        var subgroups = [],
            subgroup,
            subnode,
            upgroup,
            group,
            node;
        for (var j = -1, m = this.length; ++j < m;) {
          upgroup = (group = this[j]).update;
          subgroups.push(subgroup = []);
          subgroup.parentNode = group.parentNode;
          for (var i = -1, n = group.length; ++i < n;) {
            if (node = group[i]) {
              subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
              subnode.__data__ = node.__data__;
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_selection(subgroups);
      };
      d3_selection_enterPrototype.insert = function (name, before) {
        if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
        return d3_selectionPrototype.insert.call(this, name, before);
      };
      function d3_selection_enterInsertBefore(enter) {
        var i0, j0;
        return function (d, i, j) {
          var group = enter[j].update,
              n = group.length,
              node;
          if (j != j0) j0 = j, i0 = 0;
          if (i >= i0) i0 = i + 1;
          while (!(node = group[i0]) && ++i0 < n);
          return node;
        };
      }
      d3.select = function (node) {
        var group;
        if (typeof node === "string") {
          group = [d3_select(node, d3_document)];
          group.parentNode = d3_document.documentElement;
        } else {
          group = [node];
          group.parentNode = d3_documentElement(node);
        }
        return d3_selection([group]);
      };
      d3.selectAll = function (nodes) {
        var group;
        if (typeof nodes === "string") {
          group = d3_array(d3_selectAll(nodes, d3_document));
          group.parentNode = d3_document.documentElement;
        } else {
          group = d3_array(nodes);
          group.parentNode = null;
        }
        return d3_selection([group]);
      };
      d3_selectionPrototype.on = function (type, listener, capture) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof type !== "string") {
            if (n < 2) listener = false;
            for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
            return this;
          }
          if (n < 2) return (n = this.node()["__on" + type]) && n._;
          capture = false;
        }
        return this.each(d3_selection_on(type, listener, capture));
      };
      function d3_selection_on(type, listener, capture) {
        var name = "__on" + type,
            i = type.indexOf("."),
            wrap = d3_selection_onListener;
        if (i > 0) type = type.slice(0, i);
        var filter = d3_selection_onFilters.get(type);
        if (filter) type = filter, wrap = d3_selection_onFilter;
        function onRemove() {
          var l = this[name];
          if (l) {
            this.removeEventListener(type, l, l.$);
            delete this[name];
          }
        }
        function onAdd() {
          var l = wrap(listener, d3_array(arguments));
          onRemove.call(this);
          this.addEventListener(type, this[name] = l, l.$ = capture);
          l._ = listener;
        }
        function removeAll() {
          var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"),
              match;
          for (var name in this) {
            if (match = name.match(re)) {
              var l = this[name];
              this.removeEventListener(match[1], l, l.$);
              delete this[name];
            }
          }
        }
        return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
      }
      var d3_selection_onFilters = d3.map({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
      });
      if (d3_document) {
        d3_selection_onFilters.forEach(function (k) {
          if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
        });
      }
      function d3_selection_onListener(listener, argumentz) {
        return function (e) {
          var o = d3.event;
          d3.event = e;
          argumentz[0] = this.__data__;
          try {
            listener.apply(this, argumentz);
          } finally {
            d3.event = o;
          }
        };
      }
      function d3_selection_onFilter(listener, argumentz) {
        var l = d3_selection_onListener(listener, argumentz);
        return function (e) {
          var target = this,
              related = e.relatedTarget;
          if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
            l.call(target, e);
          }
        };
      }
      var d3_event_dragSelect,
          d3_event_dragId = 0;
      function d3_event_dragSuppress(node) {
        var name = ".dragsuppress-" + ++d3_event_dragId,
            click = "click" + name,
            w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
        if (d3_event_dragSelect == null) {
          d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
        }
        if (d3_event_dragSelect) {
          var style = d3_documentElement(node).style,
              select = style[d3_event_dragSelect];
          style[d3_event_dragSelect] = "none";
        }
        return function (suppressClick) {
          w.on(name, null);
          if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
          if (suppressClick) {
            var off = function () {
              w.on(click, null);
            };
            w.on(click, function () {
              d3_eventPreventDefault();
              off();
            }, true);
            setTimeout(off, 0);
          }
        };
      }
      d3.mouse = function (container) {
        return d3_mousePoint(container, d3_eventSource());
      };
      var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
      function d3_mousePoint(container, e) {
        if (e.changedTouches) e = e.changedTouches[0];
        var svg = container.ownerSVGElement || container;
        if (svg.createSVGPoint) {
          var point = svg.createSVGPoint();
          if (d3_mouse_bug44083 < 0) {
            var window = d3_window(container);
            if (window.scrollX || window.scrollY) {
              svg = d3.select("body").append("svg").style({
                position: "absolute",
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                border: "none"
              }, "important");
              var ctm = svg[0][0].getScreenCTM();
              d3_mouse_bug44083 = !(ctm.f || ctm.e);
              svg.remove();
            }
          }
          if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY;else point.x = e.clientX, point.y = e.clientY;
          point = point.matrixTransform(container.getScreenCTM().inverse());
          return [point.x, point.y];
        }
        var rect = container.getBoundingClientRect();
        return [e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop];
      }
      d3.touch = function (container, touches, identifier) {
        if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
        if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
          if ((touch = touches[i]).identifier === identifier) {
            return d3_mousePoint(container, touch);
          }
        }
      };
      d3.behavior.drag = function () {
        var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"),
            origin = null,
            mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"),
            touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
        function drag() {
          this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
        }
        function dragstart(id, position, subject, move, end) {
          return function () {
            var that = this,
                target = d3.event.target.correspondingElement || d3.event.target,
                parent = that.parentNode,
                dispatch = event.of(that, arguments),
                dragged = 0,
                dragId = id(),
                dragName = ".drag" + (dragId == null ? "" : "-" + dragId),
                dragOffset,
                dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended),
                dragRestore = d3_event_dragSuppress(target),
                position0 = position(parent, dragId);
            if (origin) {
              dragOffset = origin.apply(that, arguments);
              dragOffset = [dragOffset.x - position0[0], dragOffset.y - position0[1]];
            } else {
              dragOffset = [0, 0];
            }
            dispatch({
              type: "dragstart"
            });
            function moved() {
              var position1 = position(parent, dragId),
                  dx,
                  dy;
              if (!position1) return;
              dx = position1[0] - position0[0];
              dy = position1[1] - position0[1];
              dragged |= dx | dy;
              position0 = position1;
              dispatch({
                type: "drag",
                x: position1[0] + dragOffset[0],
                y: position1[1] + dragOffset[1],
                dx: dx,
                dy: dy
              });
            }
            function ended() {
              if (!position(parent, dragId)) return;
              dragSubject.on(move + dragName, null).on(end + dragName, null);
              dragRestore(dragged);
              dispatch({
                type: "dragend"
              });
            }
          };
        }
        drag.origin = function (x) {
          if (!arguments.length) return origin;
          origin = x;
          return drag;
        };
        return d3.rebind(drag, event, "on");
      };
      function d3_behavior_dragTouchId() {
        return d3.event.changedTouches[0].identifier;
      }
      d3.touches = function (container, touches) {
        if (arguments.length < 2) touches = d3_eventSource().touches;
        return touches ? d3_array(touches).map(function (touch) {
          var point = d3_mousePoint(container, touch);
          point.identifier = touch.identifier;
          return point;
        }) : [];
      };
      var ε = 1e-6,
          ε2 = ε * ε,
          π = Math.PI,
          τ = 2 * π,
          τε = τ - ε,
          halfπ = π / 2,
          d3_radians = π / 180,
          d3_degrees = 180 / π;
      function d3_sgn(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
      }
      function d3_cross2d(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
      }
      function d3_acos(x) {
        return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
      }
      function d3_asin(x) {
        return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
      }
      function d3_sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
      }
      function d3_cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
      }
      function d3_tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
      }
      function d3_haversin(x) {
        return (x = Math.sin(x / 2)) * x;
      }
      var ρ = Math.SQRT2,
          ρ2 = 2,
          ρ4 = 4;
      d3.interpolateZoom = function (p0, p1) {
        var ux0 = p0[0],
            uy0 = p0[1],
            w0 = p0[2],
            ux1 = p1[0],
            uy1 = p1[1],
            w1 = p1[2],
            dx = ux1 - ux0,
            dy = uy1 - uy0,
            d2 = dx * dx + dy * dy,
            i,
            S;
        if (d2 < ε2) {
          S = Math.log(w1 / w0) / ρ;
          i = function (t) {
            return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S)];
          };
        } else {
          var d1 = Math.sqrt(d2),
              b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1),
              b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1),
              r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
              r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
          S = (r1 - r0) / ρ;
          i = function (t) {
            var s = t * S,
                coshr0 = d3_cosh(r0),
                u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
            return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0)];
          };
        }
        i.duration = S * 1e3;
        return i;
      };
      d3.behavior.zoom = function () {
        var view = {
          x: 0,
          y: 0,
          k: 1
        },
            translate0,
            center0,
            center,
            size = [960, 500],
            scaleExtent = d3_behavior_zoomInfinity,
            duration = 250,
            zooming = 0,
            mousedown = "mousedown.zoom",
            mousemove = "mousemove.zoom",
            mouseup = "mouseup.zoom",
            mousewheelTimer,
            touchstart = "touchstart.zoom",
            touchtime,
            event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"),
            x0,
            x1,
            y0,
            y1;
        if (!d3_behavior_zoomWheel) {
          d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function () {
            return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
          }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function () {
            return d3.event.wheelDelta;
          }, "mousewheel") : (d3_behavior_zoomDelta = function () {
            return -d3.event.detail;
          }, "MozMousePixelScroll");
        }
        function zoom(g) {
          g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
        }
        zoom.event = function (g) {
          g.each(function () {
            var dispatch = event.of(this, arguments),
                view1 = view;
            if (d3_transitionInheritId) {
              d3.select(this).transition().each("start.zoom", function () {
                view = this.__chart__ || {
                  x: 0,
                  y: 0,
                  k: 1
                };
                zoomstarted(dispatch);
              }).tween("zoom:zoom", function () {
                var dx = size[0],
                    dy = size[1],
                    cx = center0 ? center0[0] : dx / 2,
                    cy = center0 ? center0[1] : dy / 2,
                    i = d3.interpolateZoom([(cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k], [(cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k]);
                return function (t) {
                  var l = i(t),
                      k = dx / l[2];
                  this.__chart__ = view = {
                    x: cx - l[0] * k,
                    y: cy - l[1] * k,
                    k: k
                  };
                  zoomed(dispatch);
                };
              }).each("interrupt.zoom", function () {
                zoomended(dispatch);
              }).each("end.zoom", function () {
                zoomended(dispatch);
              });
            } else {
              this.__chart__ = view;
              zoomstarted(dispatch);
              zoomed(dispatch);
              zoomended(dispatch);
            }
          });
        };
        zoom.translate = function (_) {
          if (!arguments.length) return [view.x, view.y];
          view = {
            x: +_[0],
            y: +_[1],
            k: view.k
          };
          rescale();
          return zoom;
        };
        zoom.scale = function (_) {
          if (!arguments.length) return view.k;
          view = {
            x: view.x,
            y: view.y,
            k: null
          };
          scaleTo(+_);
          rescale();
          return zoom;
        };
        zoom.scaleExtent = function (_) {
          if (!arguments.length) return scaleExtent;
          scaleExtent = _ == null ? d3_behavior_zoomInfinity : [+_[0], +_[1]];
          return zoom;
        };
        zoom.center = function (_) {
          if (!arguments.length) return center;
          center = _ && [+_[0], +_[1]];
          return zoom;
        };
        zoom.size = function (_) {
          if (!arguments.length) return size;
          size = _ && [+_[0], +_[1]];
          return zoom;
        };
        zoom.duration = function (_) {
          if (!arguments.length) return duration;
          duration = +_;
          return zoom;
        };
        zoom.x = function (z) {
          if (!arguments.length) return x1;
          x1 = z;
          x0 = z.copy();
          view = {
            x: 0,
            y: 0,
            k: 1
          };
          return zoom;
        };
        zoom.y = function (z) {
          if (!arguments.length) return y1;
          y1 = z;
          y0 = z.copy();
          view = {
            x: 0,
            y: 0,
            k: 1
          };
          return zoom;
        };
        function location(p) {
          return [(p[0] - view.x) / view.k, (p[1] - view.y) / view.k];
        }
        function point(l) {
          return [l[0] * view.k + view.x, l[1] * view.k + view.y];
        }
        function scaleTo(s) {
          view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
        }
        function translateTo(p, l) {
          l = point(l);
          view.x += p[0] - l[0];
          view.y += p[1] - l[1];
        }
        function zoomTo(that, p, l, k) {
          that.__chart__ = {
            x: view.x,
            y: view.y,
            k: view.k
          };
          scaleTo(Math.pow(2, k));
          translateTo(center0 = p, l);
          that = d3.select(that);
          if (duration > 0) that = that.transition().duration(duration);
          that.call(zoom.event);
        }
        function rescale() {
          if (x1) x1.domain(x0.range().map(function (x) {
            return (x - view.x) / view.k;
          }).map(x0.invert));
          if (y1) y1.domain(y0.range().map(function (y) {
            return (y - view.y) / view.k;
          }).map(y0.invert));
        }
        function zoomstarted(dispatch) {
          if (!zooming++) dispatch({
            type: "zoomstart"
          });
        }
        function zoomed(dispatch) {
          rescale();
          dispatch({
            type: "zoom",
            scale: view.k,
            translate: [view.x, view.y]
          });
        }
        function zoomended(dispatch) {
          if (! --zooming) dispatch({
            type: "zoomend"
          }), center0 = null;
        }
        function mousedowned() {
          var that = this,
              dispatch = event.of(that, arguments),
              dragged = 0,
              subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended),
              location0 = location(d3.mouse(that)),
              dragRestore = d3_event_dragSuppress(that);
          d3_selection_interrupt.call(that);
          zoomstarted(dispatch);
          function moved() {
            dragged = 1;
            translateTo(d3.mouse(that), location0);
            zoomed(dispatch);
          }
          function ended() {
            subject.on(mousemove, null).on(mouseup, null);
            dragRestore(dragged);
            zoomended(dispatch);
          }
        }
        function touchstarted() {
          var that = this,
              dispatch = event.of(that, arguments),
              locations0 = {},
              distance0 = 0,
              scale0,
              zoomName = ".zoom-" + d3.event.changedTouches[0].identifier,
              touchmove = "touchmove" + zoomName,
              touchend = "touchend" + zoomName,
              targets = [],
              subject = d3.select(that),
              dragRestore = d3_event_dragSuppress(that);
          started();
          zoomstarted(dispatch);
          subject.on(mousedown, null).on(touchstart, started);
          function relocate() {
            var touches = d3.touches(that);
            scale0 = view.k;
            touches.forEach(function (t) {
              if (t.identifier in locations0) locations0[t.identifier] = location(t);
            });
            return touches;
          }
          function started() {
            var target = d3.event.target;
            d3.select(target).on(touchmove, moved).on(touchend, ended);
            targets.push(target);
            var changed = d3.event.changedTouches;
            for (var i = 0, n = changed.length; i < n; ++i) {
              locations0[changed[i].identifier] = null;
            }
            var touches = relocate(),
                now = Date.now();
            if (touches.length === 1) {
              if (now - touchtime < 500) {
                var p = touches[0];
                zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
                d3_eventPreventDefault();
              }
              touchtime = now;
            } else if (touches.length > 1) {
              var p = touches[0],
                  q = touches[1],
                  dx = p[0] - q[0],
                  dy = p[1] - q[1];
              distance0 = dx * dx + dy * dy;
            }
          }
          function moved() {
            var touches = d3.touches(that),
                p0,
                l0,
                p1,
                l1;
            d3_selection_interrupt.call(that);
            for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
              p1 = touches[i];
              if (l1 = locations0[p1.identifier]) {
                if (l0) break;
                p0 = p1, l0 = l1;
              }
            }
            if (l1) {
              var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1,
                  scale1 = distance0 && Math.sqrt(distance1 / distance0);
              p0 = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
              l0 = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
              scaleTo(scale1 * scale0);
            }
            touchtime = null;
            translateTo(p0, l0);
            zoomed(dispatch);
          }
          function ended() {
            if (d3.event.touches.length) {
              var changed = d3.event.changedTouches;
              for (var i = 0, n = changed.length; i < n; ++i) {
                delete locations0[changed[i].identifier];
              }
              for (var identifier in locations0) {
                return void relocate();
              }
            }
            d3.selectAll(targets).on(zoomName, null);
            subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
            dragRestore();
            zoomended(dispatch);
          }
        }
        function mousewheeled() {
          var dispatch = event.of(this, arguments);
          if (mousewheelTimer) clearTimeout(mousewheelTimer);else d3_selection_interrupt.call(this), translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
          mousewheelTimer = setTimeout(function () {
            mousewheelTimer = null;
            zoomended(dispatch);
          }, 50);
          d3_eventPreventDefault();
          scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
          translateTo(center0, translate0);
          zoomed(dispatch);
        }
        function dblclicked() {
          var p = d3.mouse(this),
              k = Math.log(view.k) / Math.LN2;
          zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
        }
        return d3.rebind(zoom, event, "on");
      };
      var d3_behavior_zoomInfinity = [0, Infinity],
          d3_behavior_zoomDelta,
          d3_behavior_zoomWheel;
      d3.color = d3_color;
      function d3_color() {}
      d3_color.prototype.toString = function () {
        return this.rgb() + "";
      };
      d3.hsl = d3_hsl;
      function d3_hsl(h, s, l) {
        return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
      }
      var d3_hslPrototype = d3_hsl.prototype = new d3_color();
      d3_hslPrototype.brighter = function (k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_hsl(this.h, this.s, this.l / k);
      };
      d3_hslPrototype.darker = function (k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_hsl(this.h, this.s, k * this.l);
      };
      d3_hslPrototype.rgb = function () {
        return d3_hsl_rgb(this.h, this.s, this.l);
      };
      function d3_hsl_rgb(h, s, l) {
        var m1, m2;
        h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
        s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
        l = l < 0 ? 0 : l > 1 ? 1 : l;
        m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
        m1 = 2 * l - m2;
        function v(h) {
          if (h > 360) h -= 360;else if (h < 0) h += 360;
          if (h < 60) return m1 + (m2 - m1) * h / 60;
          if (h < 180) return m2;
          if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
          return m1;
        }
        function vv(h) {
          return Math.round(v(h) * 255);
        }
        return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
      }
      d3.hcl = d3_hcl;
      function d3_hcl(h, c, l) {
        return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
      }
      var d3_hclPrototype = d3_hcl.prototype = new d3_color();
      d3_hclPrototype.brighter = function (k) {
        return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
      };
      d3_hclPrototype.darker = function (k) {
        return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
      };
      d3_hclPrototype.rgb = function () {
        return d3_hcl_lab(this.h, this.c, this.l).rgb();
      };
      function d3_hcl_lab(h, c, l) {
        if (isNaN(h)) h = 0;
        if (isNaN(c)) c = 0;
        return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
      }
      d3.lab = d3_lab;
      function d3_lab(l, a, b) {
        return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
      }
      var d3_lab_K = 18;
      var d3_lab_X = .95047,
          d3_lab_Y = 1,
          d3_lab_Z = 1.08883;
      var d3_labPrototype = d3_lab.prototype = new d3_color();
      d3_labPrototype.brighter = function (k) {
        return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
      };
      d3_labPrototype.darker = function (k) {
        return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
      };
      d3_labPrototype.rgb = function () {
        return d3_lab_rgb(this.l, this.a, this.b);
      };
      function d3_lab_rgb(l, a, b) {
        var y = (l + 16) / 116,
            x = y + a / 500,
            z = y - b / 200;
        x = d3_lab_xyz(x) * d3_lab_X;
        y = d3_lab_xyz(y) * d3_lab_Y;
        z = d3_lab_xyz(z) * d3_lab_Z;
        return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
      }
      function d3_lab_hcl(l, a, b) {
        return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
      }
      function d3_lab_xyz(x) {
        return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
      }
      function d3_xyz_lab(x) {
        return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
      }
      function d3_xyz_rgb(r) {
        return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
      }
      d3.rgb = d3_rgb;
      function d3_rgb(r, g, b) {
        return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
      }
      function d3_rgbNumber(value) {
        return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
      }
      function d3_rgbString(value) {
        return d3_rgbNumber(value) + "";
      }
      var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
      d3_rgbPrototype.brighter = function (k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        var r = this.r,
            g = this.g,
            b = this.b,
            i = 30;
        if (!r && !g && !b) return new d3_rgb(i, i, i);
        if (r && r < i) r = i;
        if (g && g < i) g = i;
        if (b && b < i) b = i;
        return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
      };
      d3_rgbPrototype.darker = function (k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_rgb(k * this.r, k * this.g, k * this.b);
      };
      d3_rgbPrototype.hsl = function () {
        return d3_rgb_hsl(this.r, this.g, this.b);
      };
      d3_rgbPrototype.toString = function () {
        return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
      };
      function d3_rgb_hex(v) {
        return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
      }
      function d3_rgb_parse(format, rgb, hsl) {
        var r = 0,
            g = 0,
            b = 0,
            m1,
            m2,
            color;
        m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
        if (m1) {
          m2 = m1[2].split(",");
          switch (m1[1]) {
            case "hsl":
              {
                return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
              }

            case "rgb":
              {
                return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
              }
          }
        }
        if (color = d3_rgb_names.get(format)) {
          return rgb(color.r, color.g, color.b);
        }
        if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
          if (format.length === 4) {
            r = (color & 3840) >> 4;
            r = r >> 4 | r;
            g = color & 240;
            g = g >> 4 | g;
            b = color & 15;
            b = b << 4 | b;
          } else if (format.length === 7) {
            r = (color & 16711680) >> 16;
            g = (color & 65280) >> 8;
            b = color & 255;
          }
        }
        return rgb(r, g, b);
      }
      function d3_rgb_hsl(r, g, b) {
        var min = Math.min(r /= 255, g /= 255, b /= 255),
            max = Math.max(r, g, b),
            d = max - min,
            h,
            s,
            l = (max + min) / 2;
        if (d) {
          s = l < .5 ? d / (max + min) : d / (2 - max - min);
          if (r == max) h = (g - b) / d + (g < b ? 6 : 0);else if (g == max) h = (b - r) / d + 2;else h = (r - g) / d + 4;
          h *= 60;
        } else {
          h = NaN;
          s = l > 0 && l < 1 ? 0 : h;
        }
        return new d3_hsl(h, s, l);
      }
      function d3_rgb_lab(r, g, b) {
        r = d3_rgb_xyz(r);
        g = d3_rgb_xyz(g);
        b = d3_rgb_xyz(b);
        var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X),
            y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y),
            z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
        return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
      }
      function d3_rgb_xyz(r) {
        return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
      }
      function d3_rgb_parseNumber(c) {
        var f = parseFloat(c);
        return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
      }
      var d3_rgb_names = d3.map({
        aliceblue: 15792383,
        antiquewhite: 16444375,
        aqua: 65535,
        aquamarine: 8388564,
        azure: 15794175,
        beige: 16119260,
        bisque: 16770244,
        black: 0,
        blanchedalmond: 16772045,
        blue: 255,
        blueviolet: 9055202,
        brown: 10824234,
        burlywood: 14596231,
        cadetblue: 6266528,
        chartreuse: 8388352,
        chocolate: 13789470,
        coral: 16744272,
        cornflowerblue: 6591981,
        cornsilk: 16775388,
        crimson: 14423100,
        cyan: 65535,
        darkblue: 139,
        darkcyan: 35723,
        darkgoldenrod: 12092939,
        darkgray: 11119017,
        darkgreen: 25600,
        darkgrey: 11119017,
        darkkhaki: 12433259,
        darkmagenta: 9109643,
        darkolivegreen: 5597999,
        darkorange: 16747520,
        darkorchid: 10040012,
        darkred: 9109504,
        darksalmon: 15308410,
        darkseagreen: 9419919,
        darkslateblue: 4734347,
        darkslategray: 3100495,
        darkslategrey: 3100495,
        darkturquoise: 52945,
        darkviolet: 9699539,
        deeppink: 16716947,
        deepskyblue: 49151,
        dimgray: 6908265,
        dimgrey: 6908265,
        dodgerblue: 2003199,
        firebrick: 11674146,
        floralwhite: 16775920,
        forestgreen: 2263842,
        fuchsia: 16711935,
        gainsboro: 14474460,
        ghostwhite: 16316671,
        gold: 16766720,
        goldenrod: 14329120,
        gray: 8421504,
        green: 32768,
        greenyellow: 11403055,
        grey: 8421504,
        honeydew: 15794160,
        hotpink: 16738740,
        indianred: 13458524,
        indigo: 4915330,
        ivory: 16777200,
        khaki: 15787660,
        lavender: 15132410,
        lavenderblush: 16773365,
        lawngreen: 8190976,
        lemonchiffon: 16775885,
        lightblue: 11393254,
        lightcoral: 15761536,
        lightcyan: 14745599,
        lightgoldenrodyellow: 16448210,
        lightgray: 13882323,
        lightgreen: 9498256,
        lightgrey: 13882323,
        lightpink: 16758465,
        lightsalmon: 16752762,
        lightseagreen: 2142890,
        lightskyblue: 8900346,
        lightslategray: 7833753,
        lightslategrey: 7833753,
        lightsteelblue: 11584734,
        lightyellow: 16777184,
        lime: 65280,
        limegreen: 3329330,
        linen: 16445670,
        magenta: 16711935,
        maroon: 8388608,
        mediumaquamarine: 6737322,
        mediumblue: 205,
        mediumorchid: 12211667,
        mediumpurple: 9662683,
        mediumseagreen: 3978097,
        mediumslateblue: 8087790,
        mediumspringgreen: 64154,
        mediumturquoise: 4772300,
        mediumvioletred: 13047173,
        midnightblue: 1644912,
        mintcream: 16121850,
        mistyrose: 16770273,
        moccasin: 16770229,
        navajowhite: 16768685,
        navy: 128,
        oldlace: 16643558,
        olive: 8421376,
        olivedrab: 7048739,
        orange: 16753920,
        orangered: 16729344,
        orchid: 14315734,
        palegoldenrod: 15657130,
        palegreen: 10025880,
        paleturquoise: 11529966,
        palevioletred: 14381203,
        papayawhip: 16773077,
        peachpuff: 16767673,
        peru: 13468991,
        pink: 16761035,
        plum: 14524637,
        powderblue: 11591910,
        purple: 8388736,
        rebeccapurple: 6697881,
        red: 16711680,
        rosybrown: 12357519,
        royalblue: 4286945,
        saddlebrown: 9127187,
        salmon: 16416882,
        sandybrown: 16032864,
        seagreen: 3050327,
        seashell: 16774638,
        sienna: 10506797,
        silver: 12632256,
        skyblue: 8900331,
        slateblue: 6970061,
        slategray: 7372944,
        slategrey: 7372944,
        snow: 16775930,
        springgreen: 65407,
        steelblue: 4620980,
        tan: 13808780,
        teal: 32896,
        thistle: 14204888,
        tomato: 16737095,
        turquoise: 4251856,
        violet: 15631086,
        wheat: 16113331,
        white: 16777215,
        whitesmoke: 16119285,
        yellow: 16776960,
        yellowgreen: 10145074
      });
      d3_rgb_names.forEach(function (key, value) {
        d3_rgb_names.set(key, d3_rgbNumber(value));
      });
      function d3_functor(v) {
        return typeof v === "function" ? v : function () {
          return v;
        };
      }
      d3.functor = d3_functor;
      d3.xhr = d3_xhrType(d3_identity);
      function d3_xhrType(response) {
        return function (url, mimeType, callback) {
          if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, mimeType = null;
          return d3_xhr(url, mimeType, response, callback);
        };
      }
      function d3_xhr(url, mimeType, response, callback) {
        var xhr = {},
            dispatch = d3.dispatch("beforesend", "progress", "load", "error"),
            headers = {},
            request = new XMLHttpRequest(),
            responseType = null;
        if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
        "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function () {
          request.readyState > 3 && respond();
        };
        function respond() {
          var status = request.status,
              result;
          if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
            try {
              result = response.call(xhr, request);
            } catch (e) {
              dispatch.error.call(xhr, e);
              return;
            }
            dispatch.load.call(xhr, result);
          } else {
            dispatch.error.call(xhr, request);
          }
        }
        request.onprogress = function (event) {
          var o = d3.event;
          d3.event = event;
          try {
            dispatch.progress.call(xhr, request);
          } finally {
            d3.event = o;
          }
        };
        xhr.header = function (name, value) {
          name = (name + "").toLowerCase();
          if (arguments.length < 2) return headers[name];
          if (value == null) delete headers[name];else headers[name] = value + "";
          return xhr;
        };
        xhr.mimeType = function (value) {
          if (!arguments.length) return mimeType;
          mimeType = value == null ? null : value + "";
          return xhr;
        };
        xhr.responseType = function (value) {
          if (!arguments.length) return responseType;
          responseType = value;
          return xhr;
        };
        xhr.response = function (value) {
          response = value;
          return xhr;
        };
        ["get", "post"].forEach(function (method) {
          xhr[method] = function () {
            return xhr.send.apply(xhr, [method].concat(d3_array(arguments)));
          };
        });
        xhr.send = function (method, data, callback) {
          if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
          request.open(method, url, true);
          if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
          if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
          if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
          if (responseType != null) request.responseType = responseType;
          if (callback != null) xhr.on("error", callback).on("load", function (request) {
            callback(null, request);
          });
          dispatch.beforesend.call(xhr, request);
          request.send(data == null ? null : data);
          return xhr;
        };
        xhr.abort = function () {
          request.abort();
          return xhr;
        };
        d3.rebind(xhr, dispatch, "on");
        return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
      }
      function d3_xhr_fixCallback(callback) {
        return callback.length === 1 ? function (error, request) {
          callback(error == null ? request : null);
        } : callback;
      }
      function d3_xhrHasResponse(request) {
        var type = request.responseType;
        return type && type !== "text" ? request.response : request.responseText;
      }
      d3.dsv = function (delimiter, mimeType) {
        var reFormat = new RegExp('["' + delimiter + "\n]"),
            delimiterCode = delimiter.charCodeAt(0);
        function dsv(url, row, callback) {
          if (arguments.length < 3) callback = row, row = null;
          var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
          xhr.row = function (_) {
            return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
          };
          return xhr;
        }
        function response(request) {
          return dsv.parse(request.responseText);
        }
        function typedResponse(f) {
          return function (request) {
            return dsv.parse(request.responseText, f);
          };
        }
        dsv.parse = function (text, f) {
          var o;
          return dsv.parseRows(text, function (row, i) {
            if (o) return o(row, i - 1);
            var a = new Function("d", "return {" + row.map(function (name, i) {
              return JSON.stringify(name) + ": d[" + i + "]";
            }).join(",") + "}");
            o = f ? function (row, i) {
              return f(a(row), i);
            } : a;
          });
        };
        dsv.parseRows = function (text, f) {
          var EOL = {},
              EOF = {},
              rows = [],
              N = text.length,
              I = 0,
              n = 0,
              t,
              eol;
          function token() {
            if (I >= N) return EOF;
            if (eol) return eol = false, EOL;
            var j = I;
            if (text.charCodeAt(j) === 34) {
              var i = j;
              while (i++ < N) {
                if (text.charCodeAt(i) === 34) {
                  if (text.charCodeAt(i + 1) !== 34) break;
                  ++i;
                }
              }
              I = i + 2;
              var c = text.charCodeAt(i + 1);
              if (c === 13) {
                eol = true;
                if (text.charCodeAt(i + 2) === 10) ++I;
              } else if (c === 10) {
                eol = true;
              }
              return text.slice(j + 1, i).replace(/""/g, '"');
            }
            while (I < N) {
              var c = text.charCodeAt(I++),
                  k = 1;
              if (c === 10) eol = true;else if (c === 13) {
                eol = true;
                if (text.charCodeAt(I) === 10) ++I, ++k;
              } else if (c !== delimiterCode) continue;
              return text.slice(j, I - k);
            }
            return text.slice(j);
          }
          while ((t = token()) !== EOF) {
            var a = [];
            while (t !== EOL && t !== EOF) {
              a.push(t);
              t = token();
            }
            if (f && (a = f(a, n++)) == null) continue;
            rows.push(a);
          }
          return rows;
        };
        dsv.format = function (rows) {
          if (Array.isArray(rows[0])) return dsv.formatRows(rows);
          var fieldSet = new d3_Set(),
              fields = [];
          rows.forEach(function (row) {
            for (var field in row) {
              if (!fieldSet.has(field)) {
                fields.push(fieldSet.add(field));
              }
            }
          });
          return [fields.map(formatValue).join(delimiter)].concat(rows.map(function (row) {
            return fields.map(function (field) {
              return formatValue(row[field]);
            }).join(delimiter);
          })).join("\n");
        };
        dsv.formatRows = function (rows) {
          return rows.map(formatRow).join("\n");
        };
        function formatRow(row) {
          return row.map(formatValue).join(delimiter);
        }
        function formatValue(text) {
          return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
        }
        return dsv;
      };
      d3.csv = d3.dsv(",", "text/csv");
      d3.tsv = d3.dsv("	", "text/tab-separated-values");
      var d3_timer_queueHead,
          d3_timer_queueTail,
          d3_timer_interval,
          d3_timer_timeout,
          d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function (callback) {
        setTimeout(callback, 17);
      };
      d3.timer = function () {
        d3_timer.apply(this, arguments);
      };
      function d3_timer(callback, delay, then) {
        var n = arguments.length;
        if (n < 2) delay = 0;
        if (n < 3) then = Date.now();
        var time = then + delay,
            timer = {
          c: callback,
          t: time,
          n: null
        };
        if (d3_timer_queueTail) d3_timer_queueTail.n = timer;else d3_timer_queueHead = timer;
        d3_timer_queueTail = timer;
        if (!d3_timer_interval) {
          d3_timer_timeout = clearTimeout(d3_timer_timeout);
          d3_timer_interval = 1;
          d3_timer_frame(d3_timer_step);
        }
        return timer;
      }
      function d3_timer_step() {
        var now = d3_timer_mark(),
            delay = d3_timer_sweep() - now;
        if (delay > 24) {
          if (isFinite(delay)) {
            clearTimeout(d3_timer_timeout);
            d3_timer_timeout = setTimeout(d3_timer_step, delay);
          }
          d3_timer_interval = 0;
        } else {
          d3_timer_interval = 1;
          d3_timer_frame(d3_timer_step);
        }
      }
      d3.timer.flush = function () {
        d3_timer_mark();
        d3_timer_sweep();
      };
      function d3_timer_mark() {
        var now = Date.now(),
            timer = d3_timer_queueHead;
        while (timer) {
          if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
          timer = timer.n;
        }
        return now;
      }
      function d3_timer_sweep() {
        var t0,
            t1 = d3_timer_queueHead,
            time = Infinity;
        while (t1) {
          if (t1.c) {
            if (t1.t < time) time = t1.t;
            t1 = (t0 = t1).n;
          } else {
            t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
          }
        }
        d3_timer_queueTail = t0;
        return time;
      }
      function d3_format_precision(x, p) {
        return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
      }
      d3.round = function (x, n) {
        return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
      };
      var d3_formatPrefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(d3_formatPrefix);
      d3.formatPrefix = function (value, precision) {
        var i = 0;
        if (value = +value) {
          if (value < 0) value *= -1;
          if (precision) value = d3.round(value, d3_format_precision(value, precision));
          i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
          i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
        }
        return d3_formatPrefixes[8 + i / 3];
      };
      function d3_formatPrefix(d, i) {
        var k = Math.pow(10, abs(8 - i) * 3);
        return {
          scale: i > 8 ? function (d) {
            return d / k;
          } : function (d) {
            return d * k;
          },
          symbol: d
        };
      }
      function d3_locale_numberFormat(locale) {
        var locale_decimal = locale.decimal,
            locale_thousands = locale.thousands,
            locale_grouping = locale.grouping,
            locale_currency = locale.currency,
            formatGroup = locale_grouping && locale_thousands ? function (value, width) {
          var i = value.length,
              t = [],
              j = 0,
              g = locale_grouping[0],
              length = 0;
          while (i > 0 && g > 0) {
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = locale_grouping[j = (j + 1) % locale_grouping.length];
          }
          return t.reverse().join(locale_thousands);
        } : d3_identity;
        return function (specifier) {
          var match = d3_format_re.exec(specifier),
              fill = match[1] || " ",
              align = match[2] || ">",
              sign = match[3] || "-",
              symbol = match[4] || "",
              zfill = match[5],
              width = +match[6],
              comma = match[7],
              precision = match[8],
              type = match[9],
              scale = 1,
              prefix = "",
              suffix = "",
              integer = false,
              exponent = true;
          if (precision) precision = +precision.substring(1);
          if (zfill || fill === "0" && align === "=") {
            zfill = fill = "0";
            align = "=";
          }
          switch (type) {
            case "n":
              comma = true;
              type = "g";
              break;

            case "%":
              scale = 100;
              suffix = "%";
              type = "f";
              break;

            case "p":
              scale = 100;
              suffix = "%";
              type = "r";
              break;

            case "b":
            case "o":
            case "x":
            case "X":
              if (symbol === "#") prefix = "0" + type.toLowerCase();

            case "c":
              exponent = false;

            case "d":
              integer = true;
              precision = 0;
              break;

            case "s":
              scale = -1;
              type = "r";
              break;
          }
          if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
          if (type == "r" && !precision) type = "g";
          if (precision != null) {
            if (type == "g") precision = Math.max(1, Math.min(21, precision));else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
          }
          type = d3_format_types.get(type) || d3_format_typeDefault;
          var zcomma = zfill && comma;
          return function (value) {
            var fullSuffix = suffix;
            if (integer && value % 1) return "";
            var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
            if (scale < 0) {
              var unit = d3.formatPrefix(value, precision);
              value = unit.scale(value);
              fullSuffix = unit.symbol + suffix;
            } else {
              value *= scale;
            }
            value = type(value, precision);
            var i = value.lastIndexOf("."),
                before,
                after;
            if (i < 0) {
              var j = exponent ? value.lastIndexOf("e") : -1;
              if (j < 0) before = value, after = "";else before = value.substring(0, j), after = value.substring(j);
            } else {
              before = value.substring(0, i);
              after = locale_decimal + value.substring(i + 1);
            }
            if (!zfill && comma) before = formatGroup(before, Infinity);
            var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length),
                padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
            if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
            negative += prefix;
            value = before + after;
            return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
          };
        };
      }
      var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
      var d3_format_types = d3.map({
        b: function (x) {
          return x.toString(2);
        },
        c: function (x) {
          return String.fromCharCode(x);
        },
        o: function (x) {
          return x.toString(8);
        },
        x: function (x) {
          return x.toString(16);
        },
        X: function (x) {
          return x.toString(16).toUpperCase();
        },
        g: function (x, p) {
          return x.toPrecision(p);
        },
        e: function (x, p) {
          return x.toExponential(p);
        },
        f: function (x, p) {
          return x.toFixed(p);
        },
        r: function (x, p) {
          return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
        }
      });
      function d3_format_typeDefault(x) {
        return x + "";
      }
      var d3_time = d3.time = {},
          d3_date = Date;
      function d3_date_utc() {
        this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
      }
      d3_date_utc.prototype = {
        getDate: function () {
          return this._.getUTCDate();
        },
        getDay: function () {
          return this._.getUTCDay();
        },
        getFullYear: function () {
          return this._.getUTCFullYear();
        },
        getHours: function () {
          return this._.getUTCHours();
        },
        getMilliseconds: function () {
          return this._.getUTCMilliseconds();
        },
        getMinutes: function () {
          return this._.getUTCMinutes();
        },
        getMonth: function () {
          return this._.getUTCMonth();
        },
        getSeconds: function () {
          return this._.getUTCSeconds();
        },
        getTime: function () {
          return this._.getTime();
        },
        getTimezoneOffset: function () {
          return 0;
        },
        valueOf: function () {
          return this._.valueOf();
        },
        setDate: function () {
          d3_time_prototype.setUTCDate.apply(this._, arguments);
        },
        setDay: function () {
          d3_time_prototype.setUTCDay.apply(this._, arguments);
        },
        setFullYear: function () {
          d3_time_prototype.setUTCFullYear.apply(this._, arguments);
        },
        setHours: function () {
          d3_time_prototype.setUTCHours.apply(this._, arguments);
        },
        setMilliseconds: function () {
          d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
        },
        setMinutes: function () {
          d3_time_prototype.setUTCMinutes.apply(this._, arguments);
        },
        setMonth: function () {
          d3_time_prototype.setUTCMonth.apply(this._, arguments);
        },
        setSeconds: function () {
          d3_time_prototype.setUTCSeconds.apply(this._, arguments);
        },
        setTime: function () {
          d3_time_prototype.setTime.apply(this._, arguments);
        }
      };
      var d3_time_prototype = Date.prototype;
      function d3_time_interval(local, step, number) {
        function round(date) {
          var d0 = local(date),
              d1 = offset(d0, 1);
          return date - d0 < d1 - date ? d0 : d1;
        }
        function ceil(date) {
          step(date = local(new d3_date(date - 1)), 1);
          return date;
        }
        function offset(date, k) {
          step(date = new d3_date(+date), k);
          return date;
        }
        function range(t0, t1, dt) {
          var time = ceil(t0),
              times = [];
          if (dt > 1) {
            while (time < t1) {
              if (!(number(time) % dt)) times.push(new Date(+time));
              step(time, 1);
            }
          } else {
            while (time < t1) times.push(new Date(+time)), step(time, 1);
          }
          return times;
        }
        function range_utc(t0, t1, dt) {
          try {
            d3_date = d3_date_utc;
            var utc = new d3_date_utc();
            utc._ = t0;
            return range(utc, t1, dt);
          } finally {
            d3_date = Date;
          }
        }
        local.floor = local;
        local.round = round;
        local.ceil = ceil;
        local.offset = offset;
        local.range = range;
        var utc = local.utc = d3_time_interval_utc(local);
        utc.floor = utc;
        utc.round = d3_time_interval_utc(round);
        utc.ceil = d3_time_interval_utc(ceil);
        utc.offset = d3_time_interval_utc(offset);
        utc.range = range_utc;
        return local;
      }
      function d3_time_interval_utc(method) {
        return function (date, k) {
          try {
            d3_date = d3_date_utc;
            var utc = new d3_date_utc();
            utc._ = date;
            return method(utc, k)._;
          } finally {
            d3_date = Date;
          }
        };
      }
      d3_time.year = d3_time_interval(function (date) {
        date = d3_time.day(date);
        date.setMonth(0, 1);
        return date;
      }, function (date, offset) {
        date.setFullYear(date.getFullYear() + offset);
      }, function (date) {
        return date.getFullYear();
      });
      d3_time.years = d3_time.year.range;
      d3_time.years.utc = d3_time.year.utc.range;
      d3_time.day = d3_time_interval(function (date) {
        var day = new d3_date(2e3, 0);
        day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        return day;
      }, function (date, offset) {
        date.setDate(date.getDate() + offset);
      }, function (date) {
        return date.getDate() - 1;
      });
      d3_time.days = d3_time.day.range;
      d3_time.days.utc = d3_time.day.utc.range;
      d3_time.dayOfYear = function (date) {
        var year = d3_time.year(date);
        return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
      };
      ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function (day, i) {
        i = 7 - i;
        var interval = d3_time[day] = d3_time_interval(function (date) {
          (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
          return date;
        }, function (date, offset) {
          date.setDate(date.getDate() + Math.floor(offset) * 7);
        }, function (date) {
          var day = d3_time.year(date).getDay();
          return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
        });
        d3_time[day + "s"] = interval.range;
        d3_time[day + "s"].utc = interval.utc.range;
        d3_time[day + "OfYear"] = function (date) {
          var day = d3_time.year(date).getDay();
          return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
        };
      });
      d3_time.week = d3_time.sunday;
      d3_time.weeks = d3_time.sunday.range;
      d3_time.weeks.utc = d3_time.sunday.utc.range;
      d3_time.weekOfYear = d3_time.sundayOfYear;
      function d3_locale_timeFormat(locale) {
        var locale_dateTime = locale.dateTime,
            locale_date = locale.date,
            locale_time = locale.time,
            locale_periods = locale.periods,
            locale_days = locale.days,
            locale_shortDays = locale.shortDays,
            locale_months = locale.months,
            locale_shortMonths = locale.shortMonths;
        function d3_time_format(template) {
          var n = template.length;
          function format(date) {
            var string = [],
                i = -1,
                j = 0,
                c,
                p,
                f;
            while (++i < n) {
              if (template.charCodeAt(i) === 37) {
                string.push(template.slice(j, i));
                if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
                if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
                string.push(c);
                j = i + 1;
              }
            }
            string.push(template.slice(j, i));
            return string.join("");
          }
          format.parse = function (string) {
            var d = {
              y: 1900,
              m: 0,
              d: 1,
              H: 0,
              M: 0,
              S: 0,
              L: 0,
              Z: null
            },
                i = d3_time_parse(d, template, string, 0);
            if (i != string.length) return null;
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            var localZ = d.Z != null && d3_date !== d3_date_utc,
                date = new (localZ ? d3_date_utc : d3_date)();
            if ("j" in d) date.setFullYear(d.y, 0, d.j);else if ("W" in d || "U" in d) {
              if (!("w" in d)) d.w = "W" in d ? 1 : 0;
              date.setFullYear(d.y, 0, 1);
              date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
            } else date.setFullYear(d.y, d.m, d.d);
            date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
            return localZ ? date._ : date;
          };
          format.toString = function () {
            return template;
          };
          return format;
        }
        function d3_time_parse(date, template, string, j) {
          var c,
              p,
              t,
              i = 0,
              n = template.length,
              m = string.length;
          while (i < n) {
            if (j >= m) return -1;
            c = template.charCodeAt(i++);
            if (c === 37) {
              t = template.charAt(i++);
              p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
              if (!p || (j = p(date, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) {
              return -1;
            }
          }
          return j;
        }
        d3_time_format.utc = function (template) {
          var local = d3_time_format(template);
          function format(date) {
            try {
              d3_date = d3_date_utc;
              var utc = new d3_date();
              utc._ = date;
              return local(utc);
            } finally {
              d3_date = Date;
            }
          }
          format.parse = function (string) {
            try {
              d3_date = d3_date_utc;
              var date = local.parse(string);
              return date && date._;
            } finally {
              d3_date = Date;
            }
          };
          format.toString = local.toString;
          return format;
        };
        d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
        var d3_time_periodLookup = d3.map(),
            d3_time_dayRe = d3_time_formatRe(locale_days),
            d3_time_dayLookup = d3_time_formatLookup(locale_days),
            d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays),
            d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays),
            d3_time_monthRe = d3_time_formatRe(locale_months),
            d3_time_monthLookup = d3_time_formatLookup(locale_months),
            d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths),
            d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
        locale_periods.forEach(function (p, i) {
          d3_time_periodLookup.set(p.toLowerCase(), i);
        });
        var d3_time_formats = {
          a: function (d) {
            return locale_shortDays[d.getDay()];
          },
          A: function (d) {
            return locale_days[d.getDay()];
          },
          b: function (d) {
            return locale_shortMonths[d.getMonth()];
          },
          B: function (d) {
            return locale_months[d.getMonth()];
          },
          c: d3_time_format(locale_dateTime),
          d: function (d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
          },
          e: function (d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
          },
          H: function (d, p) {
            return d3_time_formatPad(d.getHours(), p, 2);
          },
          I: function (d, p) {
            return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
          },
          j: function (d, p) {
            return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
          },
          L: function (d, p) {
            return d3_time_formatPad(d.getMilliseconds(), p, 3);
          },
          m: function (d, p) {
            return d3_time_formatPad(d.getMonth() + 1, p, 2);
          },
          M: function (d, p) {
            return d3_time_formatPad(d.getMinutes(), p, 2);
          },
          p: function (d) {
            return locale_periods[+(d.getHours() >= 12)];
          },
          S: function (d, p) {
            return d3_time_formatPad(d.getSeconds(), p, 2);
          },
          U: function (d, p) {
            return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
          },
          w: function (d) {
            return d.getDay();
          },
          W: function (d, p) {
            return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
          },
          x: d3_time_format(locale_date),
          X: d3_time_format(locale_time),
          y: function (d, p) {
            return d3_time_formatPad(d.getFullYear() % 100, p, 2);
          },
          Y: function (d, p) {
            return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
          },
          Z: d3_time_zone,
          "%": function () {
            return "%";
          }
        };
        var d3_time_parsers = {
          a: d3_time_parseWeekdayAbbrev,
          A: d3_time_parseWeekday,
          b: d3_time_parseMonthAbbrev,
          B: d3_time_parseMonth,
          c: d3_time_parseLocaleFull,
          d: d3_time_parseDay,
          e: d3_time_parseDay,
          H: d3_time_parseHour24,
          I: d3_time_parseHour24,
          j: d3_time_parseDayOfYear,
          L: d3_time_parseMilliseconds,
          m: d3_time_parseMonthNumber,
          M: d3_time_parseMinutes,
          p: d3_time_parseAmPm,
          S: d3_time_parseSeconds,
          U: d3_time_parseWeekNumberSunday,
          w: d3_time_parseWeekdayNumber,
          W: d3_time_parseWeekNumberMonday,
          x: d3_time_parseLocaleDate,
          X: d3_time_parseLocaleTime,
          y: d3_time_parseYear,
          Y: d3_time_parseFullYear,
          Z: d3_time_parseZone,
          "%": d3_time_parseLiteralPercent
        };
        function d3_time_parseWeekdayAbbrev(date, string, i) {
          d3_time_dayAbbrevRe.lastIndex = 0;
          var n = d3_time_dayAbbrevRe.exec(string.slice(i));
          return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseWeekday(date, string, i) {
          d3_time_dayRe.lastIndex = 0;
          var n = d3_time_dayRe.exec(string.slice(i));
          return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseMonthAbbrev(date, string, i) {
          d3_time_monthAbbrevRe.lastIndex = 0;
          var n = d3_time_monthAbbrevRe.exec(string.slice(i));
          return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseMonth(date, string, i) {
          d3_time_monthRe.lastIndex = 0;
          var n = d3_time_monthRe.exec(string.slice(i));
          return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseLocaleFull(date, string, i) {
          return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
        }
        function d3_time_parseLocaleDate(date, string, i) {
          return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
        }
        function d3_time_parseLocaleTime(date, string, i) {
          return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
        }
        function d3_time_parseAmPm(date, string, i) {
          var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
          return n == null ? -1 : (date.p = n, i);
        }
        return d3_time_format;
      }
      var d3_time_formatPads = {
        "-": "",
        _: " ",
        "0": "0"
      },
          d3_time_numberRe = /^\s*\d+/,
          d3_time_percentRe = /^%/;
      function d3_time_formatPad(value, fill, width) {
        var sign = value < 0 ? "-" : "",
            string = (sign ? -value : value) + "",
            length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
      }
      function d3_time_formatRe(names) {
        return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
      }
      function d3_time_formatLookup(names) {
        var map = new d3_Map(),
            i = -1,
            n = names.length;
        while (++i < n) map.set(names[i].toLowerCase(), i);
        return map;
      }
      function d3_time_parseWeekdayNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 1));
        return n ? (date.w = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseWeekNumberSunday(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i));
        return n ? (date.U = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseWeekNumberMonday(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i));
        return n ? (date.W = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseFullYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 4));
        return n ? (date.y = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
      }
      function d3_time_parseZone(date, string, i) {
        return (/^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, i + 5) : -1
        );
      }
      function d3_time_expandYear(d) {
        return d + (d > 68 ? 1900 : 2e3);
      }
      function d3_time_parseMonthNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
      }
      function d3_time_parseDay(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.d = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseDayOfYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 3));
        return n ? (date.j = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseHour24(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.H = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseMinutes(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.M = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseSeconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.S = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseMilliseconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 3));
        return n ? (date.L = +n[0], i + n[0].length) : -1;
      }
      function d3_time_zone(d) {
        var z = d.getTimezoneOffset(),
            zs = z > 0 ? "-" : "+",
            zh = abs(z) / 60 | 0,
            zm = abs(z) % 60;
        return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
      }
      function d3_time_parseLiteralPercent(date, string, i) {
        d3_time_percentRe.lastIndex = 0;
        var n = d3_time_percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
      }
      function d3_time_formatMulti(formats) {
        var n = formats.length,
            i = -1;
        while (++i < n) formats[i][0] = this(formats[i][0]);
        return function (date) {
          var i = 0,
              f = formats[i];
          while (!f[1](date)) f = formats[++i];
          return f[0](date);
        };
      }
      d3.locale = function (locale) {
        return {
          numberFormat: d3_locale_numberFormat(locale),
          timeFormat: d3_locale_timeFormat(locale)
        };
      };
      var d3_locale_enUS = d3.locale({
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["$", ""],
        dateTime: "%a %b %e %X %Y",
        date: "%m/%d/%Y",
        time: "%H:%M:%S",
        periods: ["AM", "PM"],
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      });
      d3.format = d3_locale_enUS.numberFormat;
      d3.geo = {};
      function d3_adder() {}
      d3_adder.prototype = {
        s: 0,
        t: 0,
        add: function (y) {
          d3_adderSum(y, this.t, d3_adderTemp);
          d3_adderSum(d3_adderTemp.s, this.s, this);
          if (this.s) this.t += d3_adderTemp.t;else this.s = d3_adderTemp.t;
        },
        reset: function () {
          this.s = this.t = 0;
        },
        valueOf: function () {
          return this.s;
        }
      };
      var d3_adderTemp = new d3_adder();
      function d3_adderSum(a, b, o) {
        var x = o.s = a + b,
            bv = x - a,
            av = x - bv;
        o.t = a - av + (b - bv);
      }
      d3.geo.stream = function (object, listener) {
        if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
          d3_geo_streamObjectType[object.type](object, listener);
        } else {
          d3_geo_streamGeometry(object, listener);
        }
      };
      function d3_geo_streamGeometry(geometry, listener) {
        if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
          d3_geo_streamGeometryType[geometry.type](geometry, listener);
        }
      }
      var d3_geo_streamObjectType = {
        Feature: function (feature, listener) {
          d3_geo_streamGeometry(feature.geometry, listener);
        },
        FeatureCollection: function (object, listener) {
          var features = object.features,
              i = -1,
              n = features.length;
          while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
        }
      };
      var d3_geo_streamGeometryType = {
        Sphere: function (object, listener) {
          listener.sphere();
        },
        Point: function (object, listener) {
          object = object.coordinates;
          listener.point(object[0], object[1], object[2]);
        },
        MultiPoint: function (object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
        },
        LineString: function (object, listener) {
          d3_geo_streamLine(object.coordinates, listener, 0);
        },
        MultiLineString: function (object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
        },
        Polygon: function (object, listener) {
          d3_geo_streamPolygon(object.coordinates, listener);
        },
        MultiPolygon: function (object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
        },
        GeometryCollection: function (object, listener) {
          var geometries = object.geometries,
              i = -1,
              n = geometries.length;
          while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
        }
      };
      function d3_geo_streamLine(coordinates, listener, closed) {
        var i = -1,
            n = coordinates.length - closed,
            coordinate;
        listener.lineStart();
        while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
        listener.lineEnd();
      }
      function d3_geo_streamPolygon(coordinates, listener) {
        var i = -1,
            n = coordinates.length;
        listener.polygonStart();
        while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
        listener.polygonEnd();
      }
      d3.geo.area = function (object) {
        d3_geo_areaSum = 0;
        d3.geo.stream(object, d3_geo_area);
        return d3_geo_areaSum;
      };
      var d3_geo_areaSum,
          d3_geo_areaRingSum = new d3_adder();
      var d3_geo_area = {
        sphere: function () {
          d3_geo_areaSum += 4 * π;
        },
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function () {
          d3_geo_areaRingSum.reset();
          d3_geo_area.lineStart = d3_geo_areaRingStart;
        },
        polygonEnd: function () {
          var area = 2 * d3_geo_areaRingSum;
          d3_geo_areaSum += area < 0 ? 4 * π + area : area;
          d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
        }
      };
      function d3_geo_areaRingStart() {
        var λ00, φ00, λ0, cosφ0, sinφ0;
        d3_geo_area.point = function (λ, φ) {
          d3_geo_area.point = nextPoint;
          λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), sinφ0 = Math.sin(φ);
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          φ = φ * d3_radians / 2 + π / 4;
          var dλ = λ - λ0,
              sdλ = dλ >= 0 ? 1 : -1,
              adλ = sdλ * dλ,
              cosφ = Math.cos(φ),
              sinφ = Math.sin(φ),
              k = sinφ0 * sinφ,
              u = cosφ0 * cosφ + k * Math.cos(adλ),
              v = k * sdλ * Math.sin(adλ);
          d3_geo_areaRingSum.add(Math.atan2(v, u));
          λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
        }
        d3_geo_area.lineEnd = function () {
          nextPoint(λ00, φ00);
        };
      }
      function d3_geo_cartesian(spherical) {
        var λ = spherical[0],
            φ = spherical[1],
            cosφ = Math.cos(φ);
        return [cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ)];
      }
      function d3_geo_cartesianDot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
      }
      function d3_geo_cartesianCross(a, b) {
        return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
      }
      function d3_geo_cartesianAdd(a, b) {
        a[0] += b[0];
        a[1] += b[1];
        a[2] += b[2];
      }
      function d3_geo_cartesianScale(vector, k) {
        return [vector[0] * k, vector[1] * k, vector[2] * k];
      }
      function d3_geo_cartesianNormalize(d) {
        var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l;
        d[1] /= l;
        d[2] /= l;
      }
      function d3_geo_spherical(cartesian) {
        return [Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2])];
      }
      function d3_geo_sphericalEqual(a, b) {
        return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
      }
      d3.geo.bounds = function () {
        var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
        var bound = {
          point: point,
          lineStart: lineStart,
          lineEnd: lineEnd,
          polygonStart: function () {
            bound.point = ringPoint;
            bound.lineStart = ringStart;
            bound.lineEnd = ringEnd;
            dλSum = 0;
            d3_geo_area.polygonStart();
          },
          polygonEnd: function () {
            d3_geo_area.polygonEnd();
            bound.point = point;
            bound.lineStart = lineStart;
            bound.lineEnd = lineEnd;
            if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90);else if (dλSum > ε) φ1 = 90;else if (dλSum < -ε) φ0 = -90;
            range[0] = λ0, range[1] = λ1;
          }
        };
        function point(λ, φ) {
          ranges.push(range = [λ0 = λ, λ1 = λ]);
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        function linePoint(λ, φ) {
          var p = d3_geo_cartesian([λ * d3_radians, φ * d3_radians]);
          if (p0) {
            var normal = d3_geo_cartesianCross(p0, p),
                equatorial = [normal[1], -normal[0], 0],
                inflection = d3_geo_cartesianCross(equatorial, normal);
            d3_geo_cartesianNormalize(inflection);
            inflection = d3_geo_spherical(inflection);
            var dλ = λ - λ_,
                s = dλ > 0 ? 1 : -1,
                λi = inflection[0] * d3_degrees * s,
                antimeridian = abs(dλ) > 180;
            if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
              var φi = inflection[1] * d3_degrees;
              if (φi > φ1) φ1 = φi;
            } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
              var φi = -inflection[1] * d3_degrees;
              if (φi < φ0) φ0 = φi;
            } else {
              if (φ < φ0) φ0 = φ;
              if (φ > φ1) φ1 = φ;
            }
            if (antimeridian) {
              if (λ < λ_) {
                if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
              } else {
                if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
              }
            } else {
              if (λ1 >= λ0) {
                if (λ < λ0) λ0 = λ;
                if (λ > λ1) λ1 = λ;
              } else {
                if (λ > λ_) {
                  if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
                } else {
                  if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
                }
              }
            }
          } else {
            point(λ, φ);
          }
          p0 = p, λ_ = λ;
        }
        function lineStart() {
          bound.point = linePoint;
        }
        function lineEnd() {
          range[0] = λ0, range[1] = λ1;
          bound.point = point;
          p0 = null;
        }
        function ringPoint(λ, φ) {
          if (p0) {
            var dλ = λ - λ_;
            dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
          } else λ__ = λ, φ__ = φ;
          d3_geo_area.point(λ, φ);
          linePoint(λ, φ);
        }
        function ringStart() {
          d3_geo_area.lineStart();
        }
        function ringEnd() {
          ringPoint(λ__, φ__);
          d3_geo_area.lineEnd();
          if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
          range[0] = λ0, range[1] = λ1;
          p0 = null;
        }
        function angle(λ0, λ1) {
          return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
        }
        function compareRanges(a, b) {
          return a[0] - b[0];
        }
        function withinRange(x, range) {
          return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
        }
        return function (feature) {
          φ1 = λ1 = -(λ0 = φ0 = Infinity);
          ranges = [];
          d3.geo.stream(feature, bound);
          var n = ranges.length;
          if (n) {
            ranges.sort(compareRanges);
            for (var i = 1, a = ranges[0], b, merged = [a]; i < n; ++i) {
              b = ranges[i];
              if (withinRange(b[0], a) || withinRange(b[1], a)) {
                if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
              } else {
                merged.push(a = b);
              }
            }
            var best = -Infinity,
                dλ;
            for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
              b = merged[i];
              if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
            }
          }
          ranges = range = null;
          return λ0 === Infinity || φ0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[λ0, φ0], [λ1, φ1]];
        };
      }();
      d3.geo.centroid = function (object) {
        d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
        d3.geo.stream(object, d3_geo_centroid);
        var x = d3_geo_centroidX2,
            y = d3_geo_centroidY2,
            z = d3_geo_centroidZ2,
            m = x * x + y * y + z * z;
        if (m < ε2) {
          x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
          if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
          m = x * x + y * y + z * z;
          if (m < ε2) return [NaN, NaN];
        }
        return [Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees];
      };
      var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
      var d3_geo_centroid = {
        sphere: d3_noop,
        point: d3_geo_centroidPoint,
        lineStart: d3_geo_centroidLineStart,
        lineEnd: d3_geo_centroidLineEnd,
        polygonStart: function () {
          d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
        },
        polygonEnd: function () {
          d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
        }
      };
      function d3_geo_centroidPoint(λ, φ) {
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians);
        d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
      }
      function d3_geo_centroidPointXYZ(x, y, z) {
        ++d3_geo_centroidW0;
        d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
        d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
        d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
      }
      function d3_geo_centroidLineStart() {
        var x0, y0, z0;
        d3_geo_centroid.point = function (λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians);
          x0 = cosφ * Math.cos(λ);
          y0 = cosφ * Math.sin(λ);
          z0 = Math.sin(φ);
          d3_geo_centroid.point = nextPoint;
          d3_geo_centroidPointXYZ(x0, y0, z0);
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians),
              x = cosφ * Math.cos(λ),
              y = cosφ * Math.sin(λ),
              z = Math.sin(φ),
              w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
          d3_geo_centroidW1 += w;
          d3_geo_centroidX1 += w * (x0 + (x0 = x));
          d3_geo_centroidY1 += w * (y0 + (y0 = y));
          d3_geo_centroidZ1 += w * (z0 + (z0 = z));
          d3_geo_centroidPointXYZ(x0, y0, z0);
        }
      }
      function d3_geo_centroidLineEnd() {
        d3_geo_centroid.point = d3_geo_centroidPoint;
      }
      function d3_geo_centroidRingStart() {
        var λ00, φ00, x0, y0, z0;
        d3_geo_centroid.point = function (λ, φ) {
          λ00 = λ, φ00 = φ;
          d3_geo_centroid.point = nextPoint;
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians);
          x0 = cosφ * Math.cos(λ);
          y0 = cosφ * Math.sin(λ);
          z0 = Math.sin(φ);
          d3_geo_centroidPointXYZ(x0, y0, z0);
        };
        d3_geo_centroid.lineEnd = function () {
          nextPoint(λ00, φ00);
          d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
          d3_geo_centroid.point = d3_geo_centroidPoint;
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians),
              x = cosφ * Math.cos(λ),
              y = cosφ * Math.sin(λ),
              z = Math.sin(φ),
              cx = y0 * z - z0 * y,
              cy = z0 * x - x0 * z,
              cz = x0 * y - y0 * x,
              m = Math.sqrt(cx * cx + cy * cy + cz * cz),
              u = x0 * x + y0 * y + z0 * z,
              v = m && -d3_acos(u) / m,
              w = Math.atan2(m, u);
          d3_geo_centroidX2 += v * cx;
          d3_geo_centroidY2 += v * cy;
          d3_geo_centroidZ2 += v * cz;
          d3_geo_centroidW1 += w;
          d3_geo_centroidX1 += w * (x0 + (x0 = x));
          d3_geo_centroidY1 += w * (y0 + (y0 = y));
          d3_geo_centroidZ1 += w * (z0 + (z0 = z));
          d3_geo_centroidPointXYZ(x0, y0, z0);
        }
      }
      function d3_geo_compose(a, b) {
        function compose(x, y) {
          return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function (x, y) {
          return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
      }
      function d3_true() {
        return true;
      }
      function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
        var subject = [],
            clip = [];
        segments.forEach(function (segment) {
          if ((n = segment.length - 1) <= 0) return;
          var n,
              p0 = segment[0],
              p1 = segment[n];
          if (d3_geo_sphericalEqual(p0, p1)) {
            listener.lineStart();
            for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
            listener.lineEnd();
            return;
          }
          var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true),
              b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
          a.o = b;
          subject.push(a);
          clip.push(b);
          a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
          b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
          a.o = b;
          subject.push(a);
          clip.push(b);
        });
        clip.sort(compare);
        d3_geo_clipPolygonLinkCircular(subject);
        d3_geo_clipPolygonLinkCircular(clip);
        if (!subject.length) return;
        for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
          clip[i].e = entry = !entry;
        }
        var start = subject[0],
            points,
            point;
        while (1) {
          var current = start,
              isSubject = true;
          while (current.v) if ((current = current.n) === start) return;
          points = current.z;
          listener.lineStart();
          do {
            current.v = current.o.v = true;
            if (current.e) {
              if (isSubject) {
                for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
              } else {
                interpolate(current.x, current.n.x, 1, listener);
              }
              current = current.n;
            } else {
              if (isSubject) {
                points = current.p.z;
                for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
              } else {
                interpolate(current.x, current.p.x, -1, listener);
              }
              current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
          } while (!current.v);
          listener.lineEnd();
        }
      }
      function d3_geo_clipPolygonLinkCircular(array) {
        if (!(n = array.length)) return;
        var n,
            i = 0,
            a = array[0],
            b;
        while (++i < n) {
          a.n = b = array[i];
          b.p = a;
          a = b;
        }
        a.n = b = array[0];
        b.p = a;
      }
      function d3_geo_clipPolygonIntersection(point, points, other, entry) {
        this.x = point;
        this.z = points;
        this.o = other;
        this.e = entry;
        this.v = false;
        this.n = this.p = null;
      }
      function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
        return function (rotate, listener) {
          var line = clipLine(listener),
              rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
          var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function () {
              clip.point = pointRing;
              clip.lineStart = ringStart;
              clip.lineEnd = ringEnd;
              segments = [];
              polygon = [];
            },
            polygonEnd: function () {
              clip.point = point;
              clip.lineStart = lineStart;
              clip.lineEnd = lineEnd;
              segments = d3.merge(segments);
              var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
              if (segments.length) {
                if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
                d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
              } else if (clipStartInside) {
                if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
                listener.lineStart();
                interpolate(null, null, 1, listener);
                listener.lineEnd();
              }
              if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
              segments = polygon = null;
            },
            sphere: function () {
              listener.polygonStart();
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
              listener.polygonEnd();
            }
          };
          function point(λ, φ) {
            var point = rotate(λ, φ);
            if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
          }
          function pointLine(λ, φ) {
            var point = rotate(λ, φ);
            line.point(point[0], point[1]);
          }
          function lineStart() {
            clip.point = pointLine;
            line.lineStart();
          }
          function lineEnd() {
            clip.point = point;
            line.lineEnd();
          }
          var segments;
          var buffer = d3_geo_clipBufferListener(),
              ringListener = clipLine(buffer),
              polygonStarted = false,
              polygon,
              ring;
          function pointRing(λ, φ) {
            ring.push([λ, φ]);
            var point = rotate(λ, φ);
            ringListener.point(point[0], point[1]);
          }
          function ringStart() {
            ringListener.lineStart();
            ring = [];
          }
          function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringListener.lineEnd();
            var clean = ringListener.clean(),
                ringSegments = buffer.buffer(),
                segment,
                n = ringSegments.length;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            if (clean & 1) {
              segment = ringSegments[0];
              var n = segment.length - 1,
                  i = -1,
                  point;
              if (n > 0) {
                if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
                listener.lineStart();
                while (++i < n) listener.point((point = segment[i])[0], point[1]);
                listener.lineEnd();
              }
              return;
            }
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
          }
          return clip;
        };
      }
      function d3_geo_clipSegmentLength1(segment) {
        return segment.length > 1;
      }
      function d3_geo_clipBufferListener() {
        var lines = [],
            line;
        return {
          lineStart: function () {
            lines.push(line = []);
          },
          point: function (λ, φ) {
            line.push([λ, φ]);
          },
          lineEnd: d3_noop,
          buffer: function () {
            var buffer = lines;
            lines = [];
            line = null;
            return buffer;
          },
          rejoin: function () {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
          }
        };
      }
      function d3_geo_clipSort(a, b) {
        return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
      }
      var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [-π, -π / 2]);
      function d3_geo_clipAntimeridianLine(listener) {
        var λ0 = NaN,
            φ0 = NaN,
            sλ0 = NaN,
            clean;
        return {
          lineStart: function () {
            listener.lineStart();
            clean = 1;
          },
          point: function (λ1, φ1) {
            var sλ1 = λ1 > 0 ? π : -π,
                dλ = abs(λ1 - λ0);
            if (abs(dλ - π) < ε) {
              listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
              listener.point(sλ0, φ0);
              listener.lineEnd();
              listener.lineStart();
              listener.point(sλ1, φ0);
              listener.point(λ1, φ0);
              clean = 0;
            } else if (sλ0 !== sλ1 && dλ >= π) {
              if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
              if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
              φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
              listener.point(sλ0, φ0);
              listener.lineEnd();
              listener.lineStart();
              listener.point(sλ1, φ0);
              clean = 0;
            }
            listener.point(λ0 = λ1, φ0 = φ1);
            sλ0 = sλ1;
          },
          lineEnd: function () {
            listener.lineEnd();
            λ0 = φ0 = NaN;
          },
          clean: function () {
            return 2 - clean;
          }
        };
      }
      function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
        var cosφ0,
            cosφ1,
            sinλ0_λ1 = Math.sin(λ0 - λ1);
        return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
      }
      function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
        var φ;
        if (from == null) {
          φ = direction * halfπ;
          listener.point(-π, φ);
          listener.point(0, φ);
          listener.point(π, φ);
          listener.point(π, 0);
          listener.point(π, -φ);
          listener.point(0, -φ);
          listener.point(-π, -φ);
          listener.point(-π, 0);
          listener.point(-π, φ);
        } else if (abs(from[0] - to[0]) > ε) {
          var s = from[0] < to[0] ? π : -π;
          φ = direction * s / 2;
          listener.point(-s, φ);
          listener.point(0, φ);
          listener.point(s, φ);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function d3_geo_pointInPolygon(point, polygon) {
        var meridian = point[0],
            parallel = point[1],
            meridianNormal = [Math.sin(meridian), -Math.cos(meridian), 0],
            polarAngle = 0,
            winding = 0;
        d3_geo_areaRingSum.reset();
        for (var i = 0, n = polygon.length; i < n; ++i) {
          var ring = polygon[i],
              m = ring.length;
          if (!m) continue;
          var point0 = ring[0],
              λ0 = point0[0],
              φ0 = point0[1] / 2 + π / 4,
              sinφ0 = Math.sin(φ0),
              cosφ0 = Math.cos(φ0),
              j = 1;
          while (true) {
            if (j === m) j = 0;
            point = ring[j];
            var λ = point[0],
                φ = point[1] / 2 + π / 4,
                sinφ = Math.sin(φ),
                cosφ = Math.cos(φ),
                dλ = λ - λ0,
                sdλ = dλ >= 0 ? 1 : -1,
                adλ = sdλ * dλ,
                antimeridian = adλ > π,
                k = sinφ0 * sinφ;
            d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
            polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
            if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
              var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
              d3_geo_cartesianNormalize(arc);
              var intersection = d3_geo_cartesianCross(meridianNormal, arc);
              d3_geo_cartesianNormalize(intersection);
              var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
              if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
                winding += antimeridian ^ dλ >= 0 ? 1 : -1;
              }
            }
            if (!j++) break;
            λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
          }
        }
        return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
      }
      function d3_geo_clipCircle(radius) {
        var cr = Math.cos(radius),
            smallRadius = cr > 0,
            notHemisphere = abs(cr) > ε,
            interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
        return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-π, radius - π]);
        function visible(λ, φ) {
          return Math.cos(λ) * Math.cos(φ) > cr;
        }
        function clipLine(listener) {
          var point0, c0, v0, v00, clean;
          return {
            lineStart: function () {
              v00 = v0 = false;
              clean = 1;
            },
            point: function (λ, φ) {
              var point1 = [λ, φ],
                  point2,
                  v = visible(λ, φ),
                  c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
              if (!point0 && (v00 = v0 = v)) listener.lineStart();
              if (v !== v0) {
                point2 = intersect(point0, point1);
                if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
                  point1[0] += ε;
                  point1[1] += ε;
                  v = visible(point1[0], point1[1]);
                }
              }
              if (v !== v0) {
                clean = 0;
                if (v) {
                  listener.lineStart();
                  point2 = intersect(point1, point0);
                  listener.point(point2[0], point2[1]);
                } else {
                  point2 = intersect(point0, point1);
                  listener.point(point2[0], point2[1]);
                  listener.lineEnd();
                }
                point0 = point2;
              } else if (notHemisphere && point0 && smallRadius ^ v) {
                var t;
                if (!(c & c0) && (t = intersect(point1, point0, true))) {
                  clean = 0;
                  if (smallRadius) {
                    listener.lineStart();
                    listener.point(t[0][0], t[0][1]);
                    listener.point(t[1][0], t[1][1]);
                    listener.lineEnd();
                  } else {
                    listener.point(t[1][0], t[1][1]);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(t[0][0], t[0][1]);
                  }
                }
              }
              if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
                listener.point(point1[0], point1[1]);
              }
              point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function () {
              if (v0) listener.lineEnd();
              point0 = null;
            },
            clean: function () {
              return clean | (v00 && v0) << 1;
            }
          };
        }
        function intersect(a, b, two) {
          var pa = d3_geo_cartesian(a),
              pb = d3_geo_cartesian(b);
          var n1 = [1, 0, 0],
              n2 = d3_geo_cartesianCross(pa, pb),
              n2n2 = d3_geo_cartesianDot(n2, n2),
              n1n2 = n2[0],
              determinant = n2n2 - n1n2 * n1n2;
          if (!determinant) return !two && a;
          var c1 = cr * n2n2 / determinant,
              c2 = -cr * n1n2 / determinant,
              n1xn2 = d3_geo_cartesianCross(n1, n2),
              A = d3_geo_cartesianScale(n1, c1),
              B = d3_geo_cartesianScale(n2, c2);
          d3_geo_cartesianAdd(A, B);
          var u = n1xn2,
              w = d3_geo_cartesianDot(A, u),
              uu = d3_geo_cartesianDot(u, u),
              t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
          if (t2 < 0) return;
          var t = Math.sqrt(t2),
              q = d3_geo_cartesianScale(u, (-w - t) / uu);
          d3_geo_cartesianAdd(q, A);
          q = d3_geo_spherical(q);
          if (!two) return q;
          var λ0 = a[0],
              λ1 = b[0],
              φ0 = a[1],
              φ1 = b[1],
              z;
          if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
          var δλ = λ1 - λ0,
              polar = abs(δλ - π) < ε,
              meridian = polar || δλ < ε;
          if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
          if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
            var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
            d3_geo_cartesianAdd(q1, A);
            return [q, d3_geo_spherical(q1)];
          }
        }
        function code(λ, φ) {
          var r = smallRadius ? radius : π - radius,
              code = 0;
          if (λ < -r) code |= 1;else if (λ > r) code |= 2;
          if (φ < -r) code |= 4;else if (φ > r) code |= 8;
          return code;
        }
      }
      function d3_geom_clipLine(x0, y0, x1, y1) {
        return function (line) {
          var a = line.a,
              b = line.b,
              ax = a.x,
              ay = a.y,
              bx = b.x,
              by = b.y,
              t0 = 0,
              t1 = 1,
              dx = bx - ax,
              dy = by - ay,
              r;
          r = x0 - ax;
          if (!dx && r > 0) return;
          r /= dx;
          if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
          } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
          }
          r = x1 - ax;
          if (!dx && r < 0) return;
          r /= dx;
          if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
          } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
          }
          r = y0 - ay;
          if (!dy && r > 0) return;
          r /= dy;
          if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
          } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
          }
          r = y1 - ay;
          if (!dy && r < 0) return;
          r /= dy;
          if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
          } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
          }
          if (t0 > 0) line.a = {
            x: ax + t0 * dx,
            y: ay + t0 * dy
          };
          if (t1 < 1) line.b = {
            x: ax + t1 * dx,
            y: ay + t1 * dy
          };
          return line;
        };
      }
      var d3_geo_clipExtentMAX = 1e9;
      d3.geo.clipExtent = function () {
        var x0,
            y0,
            x1,
            y1,
            stream,
            clip,
            clipExtent = {
          stream: function (output) {
            if (stream) stream.valid = false;
            stream = clip(output);
            stream.valid = true;
            return stream;
          },
          extent: function (_) {
            if (!arguments.length) return [[x0, y0], [x1, y1]];
            clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
            if (stream) stream.valid = false, stream = null;
            return clipExtent;
          }
        };
        return clipExtent.extent([[0, 0], [960, 500]]);
      };
      function d3_geo_clipExtent(x0, y0, x1, y1) {
        return function (listener) {
          var listener_ = listener,
              bufferListener = d3_geo_clipBufferListener(),
              clipLine = d3_geom_clipLine(x0, y0, x1, y1),
              segments,
              polygon,
              ring;
          var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function () {
              listener = bufferListener;
              segments = [];
              polygon = [];
              clean = true;
            },
            polygonEnd: function () {
              listener = listener_;
              segments = d3.merge(segments);
              var clipStartInside = insidePolygon([x0, y1]),
                  inside = clean && clipStartInside,
                  visible = segments.length;
              if (inside || visible) {
                listener.polygonStart();
                if (inside) {
                  listener.lineStart();
                  interpolate(null, null, 1, listener);
                  listener.lineEnd();
                }
                if (visible) {
                  d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
                }
                listener.polygonEnd();
              }
              segments = polygon = ring = null;
            }
          };
          function insidePolygon(p) {
            var wn = 0,
                n = polygon.length,
                y = p[1];
            for (var i = 0; i < n; ++i) {
              for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
                b = v[j];
                if (a[1] <= y) {
                  if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
                } else {
                  if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
                }
                a = b;
              }
            }
            return wn !== 0;
          }
          function interpolate(from, to, direction, listener) {
            var a = 0,
                a1 = 0;
            if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
              do {
                listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
              } while ((a = (a + direction + 4) % 4) !== a1);
            } else {
              listener.point(to[0], to[1]);
            }
          }
          function pointVisible(x, y) {
            return x0 <= x && x <= x1 && y0 <= y && y <= y1;
          }
          function point(x, y) {
            if (pointVisible(x, y)) listener.point(x, y);
          }
          var x__, y__, v__, x_, y_, v_, first, clean;
          function lineStart() {
            clip.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
          }
          function lineEnd() {
            if (segments) {
              linePoint(x__, y__);
              if (v__ && v_) bufferListener.rejoin();
              segments.push(bufferListener.buffer());
            }
            clip.point = point;
            if (v_) listener.lineEnd();
          }
          function linePoint(x, y) {
            x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
            y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
            var v = pointVisible(x, y);
            if (polygon) ring.push([x, y]);
            if (first) {
              x__ = x, y__ = y, v__ = v;
              first = false;
              if (v) {
                listener.lineStart();
                listener.point(x, y);
              }
            } else {
              if (v && v_) listener.point(x, y);else {
                var l = {
                  a: {
                    x: x_,
                    y: y_
                  },
                  b: {
                    x: x,
                    y: y
                  }
                };
                if (clipLine(l)) {
                  if (!v_) {
                    listener.lineStart();
                    listener.point(l.a.x, l.a.y);
                  }
                  listener.point(l.b.x, l.b.y);
                  if (!v) listener.lineEnd();
                  clean = false;
                } else if (v) {
                  listener.lineStart();
                  listener.point(x, y);
                  clean = false;
                }
              }
            }
            x_ = x, y_ = y, v_ = v;
          }
          return clip;
        };
        function corner(p, direction) {
          return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
        }
        function compare(a, b) {
          return comparePoints(a.x, b.x);
        }
        function comparePoints(a, b) {
          var ca = corner(a, 1),
              cb = corner(b, 1);
          return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
        }
      }
      function d3_geo_conic(projectAt) {
        var φ0 = 0,
            φ1 = π / 3,
            m = d3_geo_projectionMutator(projectAt),
            p = m(φ0, φ1);
        p.parallels = function (_) {
          if (!arguments.length) return [φ0 / π * 180, φ1 / π * 180];
          return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
        };
        return p;
      }
      function d3_geo_conicEqualArea(φ0, φ1) {
        var sinφ0 = Math.sin(φ0),
            n = (sinφ0 + Math.sin(φ1)) / 2,
            C = 1 + sinφ0 * (2 * n - sinφ0),
            ρ0 = Math.sqrt(C) / n;
        function forward(λ, φ) {
          var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
          return [ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ)];
        }
        forward.invert = function (x, y) {
          var ρ0_y = ρ0 - y;
          return [Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n))];
        };
        return forward;
      }
      (d3.geo.conicEqualArea = function () {
        return d3_geo_conic(d3_geo_conicEqualArea);
      }).raw = d3_geo_conicEqualArea;
      d3.geo.albers = function () {
        return d3.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
      };
      d3.geo.albersUsa = function () {
        var lower48 = d3.geo.albers();
        var alaska = d3.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]);
        var hawaii = d3.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]);
        var point,
            pointStream = {
          point: function (x, y) {
            point = [x, y];
          }
        },
            lower48Point,
            alaskaPoint,
            hawaiiPoint;
        function albersUsa(coordinates) {
          var x = coordinates[0],
              y = coordinates[1];
          point = null;
          (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
          return point;
        }
        albersUsa.invert = function (coordinates) {
          var k = lower48.scale(),
              t = lower48.translate(),
              x = (coordinates[0] - t[0]) / k,
              y = (coordinates[1] - t[1]) / k;
          return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function (stream) {
          var lower48Stream = lower48.stream(stream),
              alaskaStream = alaska.stream(stream),
              hawaiiStream = hawaii.stream(stream);
          return {
            point: function (x, y) {
              lower48Stream.point(x, y);
              alaskaStream.point(x, y);
              hawaiiStream.point(x, y);
            },
            sphere: function () {
              lower48Stream.sphere();
              alaskaStream.sphere();
              hawaiiStream.sphere();
            },
            lineStart: function () {
              lower48Stream.lineStart();
              alaskaStream.lineStart();
              hawaiiStream.lineStart();
            },
            lineEnd: function () {
              lower48Stream.lineEnd();
              alaskaStream.lineEnd();
              hawaiiStream.lineEnd();
            },
            polygonStart: function () {
              lower48Stream.polygonStart();
              alaskaStream.polygonStart();
              hawaiiStream.polygonStart();
            },
            polygonEnd: function () {
              lower48Stream.polygonEnd();
              alaskaStream.polygonEnd();
              hawaiiStream.polygonEnd();
            }
          };
        };
        albersUsa.precision = function (_) {
          if (!arguments.length) return lower48.precision();
          lower48.precision(_);
          alaska.precision(_);
          hawaii.precision(_);
          return albersUsa;
        };
        albersUsa.scale = function (_) {
          if (!arguments.length) return lower48.scale();
          lower48.scale(_);
          alaska.scale(_ * .35);
          hawaii.scale(_);
          return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function (_) {
          if (!arguments.length) return lower48.translate();
          var k = lower48.scale(),
              x = +_[0],
              y = +_[1];
          lower48Point = lower48.translate(_).clipExtent([[x - .455 * k, y - .238 * k], [x + .455 * k, y + .238 * k]]).stream(pointStream).point;
          alaskaPoint = alaska.translate([x - .307 * k, y + .201 * k]).clipExtent([[x - .425 * k + ε, y + .12 * k + ε], [x - .214 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
          hawaiiPoint = hawaii.translate([x - .205 * k, y + .212 * k]).clipExtent([[x - .214 * k + ε, y + .166 * k + ε], [x - .115 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
          return albersUsa;
        };
        return albersUsa.scale(1070);
      };
      var d3_geo_pathAreaSum,
          d3_geo_pathAreaPolygon,
          d3_geo_pathArea = {
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function () {
          d3_geo_pathAreaPolygon = 0;
          d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
        },
        polygonEnd: function () {
          d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
          d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
        }
      };
      function d3_geo_pathAreaRingStart() {
        var x00, y00, x0, y0;
        d3_geo_pathArea.point = function (x, y) {
          d3_geo_pathArea.point = nextPoint;
          x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
          d3_geo_pathAreaPolygon += y0 * x - x0 * y;
          x0 = x, y0 = y;
        }
        d3_geo_pathArea.lineEnd = function () {
          nextPoint(x00, y00);
        };
      }
      var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
      var d3_geo_pathBounds = {
        point: d3_geo_pathBoundsPoint,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
      };
      function d3_geo_pathBoundsPoint(x, y) {
        if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
        if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
        if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
        if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
      }
      function d3_geo_pathBuffer() {
        var pointCircle = d3_geo_pathBufferCircle(4.5),
            buffer = [];
        var stream = {
          point: point,
          lineStart: function () {
            stream.point = pointLineStart;
          },
          lineEnd: lineEnd,
          polygonStart: function () {
            stream.lineEnd = lineEndPolygon;
          },
          polygonEnd: function () {
            stream.lineEnd = lineEnd;
            stream.point = point;
          },
          pointRadius: function (_) {
            pointCircle = d3_geo_pathBufferCircle(_);
            return stream;
          },
          result: function () {
            if (buffer.length) {
              var result = buffer.join("");
              buffer = [];
              return result;
            }
          }
        };
        function point(x, y) {
          buffer.push("M", x, ",", y, pointCircle);
        }
        function pointLineStart(x, y) {
          buffer.push("M", x, ",", y);
          stream.point = pointLine;
        }
        function pointLine(x, y) {
          buffer.push("L", x, ",", y);
        }
        function lineEnd() {
          stream.point = point;
        }
        function lineEndPolygon() {
          buffer.push("Z");
        }
        return stream;
      }
      function d3_geo_pathBufferCircle(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
      }
      var d3_geo_pathCentroid = {
        point: d3_geo_pathCentroidPoint,
        lineStart: d3_geo_pathCentroidLineStart,
        lineEnd: d3_geo_pathCentroidLineEnd,
        polygonStart: function () {
          d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
        },
        polygonEnd: function () {
          d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
          d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
          d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
        }
      };
      function d3_geo_pathCentroidPoint(x, y) {
        d3_geo_centroidX0 += x;
        d3_geo_centroidY0 += y;
        ++d3_geo_centroidZ0;
      }
      function d3_geo_pathCentroidLineStart() {
        var x0, y0;
        d3_geo_pathCentroid.point = function (x, y) {
          d3_geo_pathCentroid.point = nextPoint;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        };
        function nextPoint(x, y) {
          var dx = x - x0,
              dy = y - y0,
              z = Math.sqrt(dx * dx + dy * dy);
          d3_geo_centroidX1 += z * (x0 + x) / 2;
          d3_geo_centroidY1 += z * (y0 + y) / 2;
          d3_geo_centroidZ1 += z;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        }
      }
      function d3_geo_pathCentroidLineEnd() {
        d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      }
      function d3_geo_pathCentroidRingStart() {
        var x00, y00, x0, y0;
        d3_geo_pathCentroid.point = function (x, y) {
          d3_geo_pathCentroid.point = nextPoint;
          d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
        };
        function nextPoint(x, y) {
          var dx = x - x0,
              dy = y - y0,
              z = Math.sqrt(dx * dx + dy * dy);
          d3_geo_centroidX1 += z * (x0 + x) / 2;
          d3_geo_centroidY1 += z * (y0 + y) / 2;
          d3_geo_centroidZ1 += z;
          z = y0 * x - x0 * y;
          d3_geo_centroidX2 += z * (x0 + x);
          d3_geo_centroidY2 += z * (y0 + y);
          d3_geo_centroidZ2 += z * 3;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        }
        d3_geo_pathCentroid.lineEnd = function () {
          nextPoint(x00, y00);
        };
      }
      function d3_geo_pathContext(context) {
        var pointRadius = 4.5;
        var stream = {
          point: point,
          lineStart: function () {
            stream.point = pointLineStart;
          },
          lineEnd: lineEnd,
          polygonStart: function () {
            stream.lineEnd = lineEndPolygon;
          },
          polygonEnd: function () {
            stream.lineEnd = lineEnd;
            stream.point = point;
          },
          pointRadius: function (_) {
            pointRadius = _;
            return stream;
          },
          result: d3_noop
        };
        function point(x, y) {
          context.moveTo(x + pointRadius, y);
          context.arc(x, y, pointRadius, 0, τ);
        }
        function pointLineStart(x, y) {
          context.moveTo(x, y);
          stream.point = pointLine;
        }
        function pointLine(x, y) {
          context.lineTo(x, y);
        }
        function lineEnd() {
          stream.point = point;
        }
        function lineEndPolygon() {
          context.closePath();
        }
        return stream;
      }
      function d3_geo_resample(project) {
        var δ2 = .5,
            cosMinDistance = Math.cos(30 * d3_radians),
            maxDepth = 16;
        function resample(stream) {
          return (maxDepth ? resampleRecursive : resampleNone)(stream);
        }
        function resampleNone(stream) {
          return d3_geo_transformPoint(stream, function (x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
          });
        }
        function resampleRecursive(stream) {
          var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
          var resample = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function () {
              stream.polygonStart();
              resample.lineStart = ringStart;
            },
            polygonEnd: function () {
              stream.polygonEnd();
              resample.lineStart = lineStart;
            }
          };
          function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
          }
          function lineStart() {
            x0 = NaN;
            resample.point = linePoint;
            stream.lineStart();
          }
          function linePoint(λ, φ) {
            var c = d3_geo_cartesian([λ, φ]),
                p = project(λ, φ);
            resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
          }
          function lineEnd() {
            resample.point = point;
            stream.lineEnd();
          }
          function ringStart() {
            lineStart();
            resample.point = ringPoint;
            resample.lineEnd = ringEnd;
          }
          function ringPoint(λ, φ) {
            linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resample.point = linePoint;
          }
          function ringEnd() {
            resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
            resample.lineEnd = lineEnd;
            lineEnd();
          }
          return resample;
        }
        function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
          var dx = x1 - x0,
              dy = y1 - y0,
              d2 = dx * dx + dy * dy;
          if (d2 > 4 * δ2 && depth--) {
            var a = a0 + a1,
                b = b0 + b1,
                c = c0 + c1,
                m = Math.sqrt(a * a + b * b + c * c),
                φ2 = Math.asin(c /= m),
                λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a),
                p = project(λ2, φ2),
                x2 = p[0],
                y2 = p[1],
                dx2 = x2 - x0,
                dy2 = y2 - y0,
                dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
              resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
              stream.point(x2, y2);
              resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
            }
          }
        }
        resample.precision = function (_) {
          if (!arguments.length) return Math.sqrt(δ2);
          maxDepth = (δ2 = _ * _) > 0 && 16;
          return resample;
        };
        return resample;
      }
      d3.geo.path = function () {
        var pointRadius = 4.5,
            projection,
            context,
            projectStream,
            contextStream,
            cacheStream;
        function path(object) {
          if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
            d3.geo.stream(object, cacheStream);
          }
          return contextStream.result();
        }
        path.area = function (object) {
          d3_geo_pathAreaSum = 0;
          d3.geo.stream(object, projectStream(d3_geo_pathArea));
          return d3_geo_pathAreaSum;
        };
        path.centroid = function (object) {
          d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
          d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
          return d3_geo_centroidZ2 ? [d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2] : d3_geo_centroidZ1 ? [d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1] : d3_geo_centroidZ0 ? [d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0] : [NaN, NaN];
        };
        path.bounds = function (object) {
          d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
          d3.geo.stream(object, projectStream(d3_geo_pathBounds));
          return [[d3_geo_pathBoundsX0, d3_geo_pathBoundsY0], [d3_geo_pathBoundsX1, d3_geo_pathBoundsY1]];
        };
        path.projection = function (_) {
          if (!arguments.length) return projection;
          projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
          return reset();
        };
        path.context = function (_) {
          if (!arguments.length) return context;
          contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
          if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
          return reset();
        };
        path.pointRadius = function (_) {
          if (!arguments.length) return pointRadius;
          pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
          return path;
        };
        function reset() {
          cacheStream = null;
          return path;
        }
        return path.projection(d3.geo.albersUsa()).context(null);
      };
      function d3_geo_pathProjectStream(project) {
        var resample = d3_geo_resample(function (x, y) {
          return project([x * d3_degrees, y * d3_degrees]);
        });
        return function (stream) {
          return d3_geo_projectionRadians(resample(stream));
        };
      }
      d3.geo.transform = function (methods) {
        return {
          stream: function (stream) {
            var transform = new d3_geo_transform(stream);
            for (var k in methods) transform[k] = methods[k];
            return transform;
          }
        };
      };
      function d3_geo_transform(stream) {
        this.stream = stream;
      }
      d3_geo_transform.prototype = {
        point: function (x, y) {
          this.stream.point(x, y);
        },
        sphere: function () {
          this.stream.sphere();
        },
        lineStart: function () {
          this.stream.lineStart();
        },
        lineEnd: function () {
          this.stream.lineEnd();
        },
        polygonStart: function () {
          this.stream.polygonStart();
        },
        polygonEnd: function () {
          this.stream.polygonEnd();
        }
      };
      function d3_geo_transformPoint(stream, point) {
        return {
          point: point,
          sphere: function () {
            stream.sphere();
          },
          lineStart: function () {
            stream.lineStart();
          },
          lineEnd: function () {
            stream.lineEnd();
          },
          polygonStart: function () {
            stream.polygonStart();
          },
          polygonEnd: function () {
            stream.polygonEnd();
          }
        };
      }
      d3.geo.projection = d3_geo_projection;
      d3.geo.projectionMutator = d3_geo_projectionMutator;
      function d3_geo_projection(project) {
        return d3_geo_projectionMutator(function () {
          return project;
        })();
      }
      function d3_geo_projectionMutator(projectAt) {
        var project,
            rotate,
            projectRotate,
            projectResample = d3_geo_resample(function (x, y) {
          x = project(x, y);
          return [x[0] * k + δx, δy - x[1] * k];
        }),
            k = 150,
            x = 480,
            y = 250,
            λ = 0,
            φ = 0,
            δλ = 0,
            δφ = 0,
            δγ = 0,
            δx,
            δy,
            preclip = d3_geo_clipAntimeridian,
            postclip = d3_identity,
            clipAngle = null,
            clipExtent = null,
            stream;
        function projection(point) {
          point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
          return [point[0] * k + δx, δy - point[1] * k];
        }
        function invert(point) {
          point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
          return point && [point[0] * d3_degrees, point[1] * d3_degrees];
        }
        projection.stream = function (output) {
          if (stream) stream.valid = false;
          stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
          stream.valid = true;
          return stream;
        };
        projection.clipAngle = function (_) {
          if (!arguments.length) return clipAngle;
          preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
          return invalidate();
        };
        projection.clipExtent = function (_) {
          if (!arguments.length) return clipExtent;
          clipExtent = _;
          postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
          return invalidate();
        };
        projection.scale = function (_) {
          if (!arguments.length) return k;
          k = +_;
          return reset();
        };
        projection.translate = function (_) {
          if (!arguments.length) return [x, y];
          x = +_[0];
          y = +_[1];
          return reset();
        };
        projection.center = function (_) {
          if (!arguments.length) return [λ * d3_degrees, φ * d3_degrees];
          λ = _[0] % 360 * d3_radians;
          φ = _[1] % 360 * d3_radians;
          return reset();
        };
        projection.rotate = function (_) {
          if (!arguments.length) return [δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees];
          δλ = _[0] % 360 * d3_radians;
          δφ = _[1] % 360 * d3_radians;
          δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
          return reset();
        };
        d3.rebind(projection, projectResample, "precision");
        function reset() {
          projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
          var center = project(λ, φ);
          δx = x - center[0] * k;
          δy = y + center[1] * k;
          return invalidate();
        }
        function invalidate() {
          if (stream) stream.valid = false, stream = null;
          return projection;
        }
        return function () {
          project = projectAt.apply(this, arguments);
          projection.invert = project.invert && invert;
          return reset();
        };
      }
      function d3_geo_projectionRadians(stream) {
        return d3_geo_transformPoint(stream, function (x, y) {
          stream.point(x * d3_radians, y * d3_radians);
        });
      }
      function d3_geo_equirectangular(λ, φ) {
        return [λ, φ];
      }
      (d3.geo.equirectangular = function () {
        return d3_geo_projection(d3_geo_equirectangular);
      }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
      d3.geo.rotation = function (rotate) {
        rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
        function forward(coordinates) {
          coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
          return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        }
        forward.invert = function (coordinates) {
          coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
          return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        };
        return forward;
      };
      function d3_geo_identityRotation(λ, φ) {
        return [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
      }
      d3_geo_identityRotation.invert = d3_geo_equirectangular;
      function d3_geo_rotation(δλ, δφ, δγ) {
        return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
      }
      function d3_geo_forwardRotationλ(δλ) {
        return function (λ, φ) {
          return λ += δλ, [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
        };
      }
      function d3_geo_rotationλ(δλ) {
        var rotation = d3_geo_forwardRotationλ(δλ);
        rotation.invert = d3_geo_forwardRotationλ(-δλ);
        return rotation;
      }
      function d3_geo_rotationφγ(δφ, δγ) {
        var cosδφ = Math.cos(δφ),
            sinδφ = Math.sin(δφ),
            cosδγ = Math.cos(δγ),
            sinδγ = Math.sin(δγ);
        function rotation(λ, φ) {
          var cosφ = Math.cos(φ),
              x = Math.cos(λ) * cosφ,
              y = Math.sin(λ) * cosφ,
              z = Math.sin(φ),
              k = z * cosδφ + x * sinδφ;
          return [Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ)];
        }
        rotation.invert = function (λ, φ) {
          var cosφ = Math.cos(φ),
              x = Math.cos(λ) * cosφ,
              y = Math.sin(λ) * cosφ,
              z = Math.sin(φ),
              k = z * cosδγ - y * sinδγ;
          return [Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ)];
        };
        return rotation;
      }
      d3.geo.circle = function () {
        var origin = [0, 0],
            angle,
            precision = 6,
            interpolate;
        function circle() {
          var center = typeof origin === "function" ? origin.apply(this, arguments) : origin,
              rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert,
              ring = [];
          interpolate(null, null, 1, {
            point: function (x, y) {
              ring.push(x = rotate(x, y));
              x[0] *= d3_degrees, x[1] *= d3_degrees;
            }
          });
          return {
            type: "Polygon",
            coordinates: [ring]
          };
        }
        circle.origin = function (x) {
          if (!arguments.length) return origin;
          origin = x;
          return circle;
        };
        circle.angle = function (x) {
          if (!arguments.length) return angle;
          interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
          return circle;
        };
        circle.precision = function (_) {
          if (!arguments.length) return precision;
          interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
          return circle;
        };
        return circle.angle(90);
      };
      function d3_geo_circleInterpolate(radius, precision) {
        var cr = Math.cos(radius),
            sr = Math.sin(radius);
        return function (from, to, direction, listener) {
          var step = direction * precision;
          if (from != null) {
            from = d3_geo_circleAngle(cr, from);
            to = d3_geo_circleAngle(cr, to);
            if (direction > 0 ? from < to : from > to) from += direction * τ;
          } else {
            from = radius + direction * τ;
            to = radius - .5 * step;
          }
          for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
            listener.point((point = d3_geo_spherical([cr, -sr * Math.cos(t), -sr * Math.sin(t)]))[0], point[1]);
          }
        };
      }
      function d3_geo_circleAngle(cr, point) {
        var a = d3_geo_cartesian(point);
        a[0] -= cr;
        d3_geo_cartesianNormalize(a);
        var angle = d3_acos(-a[1]);
        return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
      }
      d3.geo.distance = function (a, b) {
        var Δλ = (b[0] - a[0]) * d3_radians,
            φ0 = a[1] * d3_radians,
            φ1 = b[1] * d3_radians,
            sinΔλ = Math.sin(Δλ),
            cosΔλ = Math.cos(Δλ),
            sinφ0 = Math.sin(φ0),
            cosφ0 = Math.cos(φ0),
            sinφ1 = Math.sin(φ1),
            cosφ1 = Math.cos(φ1),
            t;
        return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
      };
      d3.geo.graticule = function () {
        var x1,
            x0,
            X1,
            X0,
            y1,
            y0,
            Y1,
            Y0,
            dx = 10,
            dy = dx,
            DX = 90,
            DY = 360,
            x,
            y,
            X,
            Y,
            precision = 2.5;
        function graticule() {
          return {
            type: "MultiLineString",
            coordinates: lines()
          };
        }
        function lines() {
          return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function (x) {
            return abs(x % DX) > ε;
          }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function (y) {
            return abs(y % DY) > ε;
          }).map(y));
        }
        graticule.lines = function () {
          return lines().map(function (coordinates) {
            return {
              type: "LineString",
              coordinates: coordinates
            };
          });
        };
        graticule.outline = function () {
          return {
            type: "Polygon",
            coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
          };
        };
        graticule.extent = function (_) {
          if (!arguments.length) return graticule.minorExtent();
          return graticule.majorExtent(_).minorExtent(_);
        };
        graticule.majorExtent = function (_) {
          if (!arguments.length) return [[X0, Y0], [X1, Y1]];
          X0 = +_[0][0], X1 = +_[1][0];
          Y0 = +_[0][1], Y1 = +_[1][1];
          if (X0 > X1) _ = X0, X0 = X1, X1 = _;
          if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
          return graticule.precision(precision);
        };
        graticule.minorExtent = function (_) {
          if (!arguments.length) return [[x0, y0], [x1, y1]];
          x0 = +_[0][0], x1 = +_[1][0];
          y0 = +_[0][1], y1 = +_[1][1];
          if (x0 > x1) _ = x0, x0 = x1, x1 = _;
          if (y0 > y1) _ = y0, y0 = y1, y1 = _;
          return graticule.precision(precision);
        };
        graticule.step = function (_) {
          if (!arguments.length) return graticule.minorStep();
          return graticule.majorStep(_).minorStep(_);
        };
        graticule.majorStep = function (_) {
          if (!arguments.length) return [DX, DY];
          DX = +_[0], DY = +_[1];
          return graticule;
        };
        graticule.minorStep = function (_) {
          if (!arguments.length) return [dx, dy];
          dx = +_[0], dy = +_[1];
          return graticule;
        };
        graticule.precision = function (_) {
          if (!arguments.length) return precision;
          precision = +_;
          x = d3_geo_graticuleX(y0, y1, 90);
          y = d3_geo_graticuleY(x0, x1, precision);
          X = d3_geo_graticuleX(Y0, Y1, 90);
          Y = d3_geo_graticuleY(X0, X1, precision);
          return graticule;
        };
        return graticule.majorExtent([[-180, -90 + ε], [180, 90 - ε]]).minorExtent([[-180, -80 - ε], [180, 80 + ε]]);
      };
      function d3_geo_graticuleX(y0, y1, dy) {
        var y = d3.range(y0, y1 - ε, dy).concat(y1);
        return function (x) {
          return y.map(function (y) {
            return [x, y];
          });
        };
      }
      function d3_geo_graticuleY(x0, x1, dx) {
        var x = d3.range(x0, x1 - ε, dx).concat(x1);
        return function (y) {
          return x.map(function (x) {
            return [x, y];
          });
        };
      }
      function d3_source(d) {
        return d.source;
      }
      function d3_target(d) {
        return d.target;
      }
      d3.geo.greatArc = function () {
        var source = d3_source,
            source_,
            target = d3_target,
            target_;
        function greatArc() {
          return {
            type: "LineString",
            coordinates: [source_ || source.apply(this, arguments), target_ || target.apply(this, arguments)]
          };
        }
        greatArc.distance = function () {
          return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
        };
        greatArc.source = function (_) {
          if (!arguments.length) return source;
          source = _, source_ = typeof _ === "function" ? null : _;
          return greatArc;
        };
        greatArc.target = function (_) {
          if (!arguments.length) return target;
          target = _, target_ = typeof _ === "function" ? null : _;
          return greatArc;
        };
        greatArc.precision = function () {
          return arguments.length ? greatArc : 0;
        };
        return greatArc;
      };
      d3.geo.interpolate = function (source, target) {
        return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
      };
      function d3_geo_interpolate(x0, y0, x1, y1) {
        var cy0 = Math.cos(y0),
            sy0 = Math.sin(y0),
            cy1 = Math.cos(y1),
            sy1 = Math.sin(y1),
            kx0 = cy0 * Math.cos(x0),
            ky0 = cy0 * Math.sin(x0),
            kx1 = cy1 * Math.cos(x1),
            ky1 = cy1 * Math.sin(x1),
            d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))),
            k = 1 / Math.sin(d);
        var interpolate = d ? function (t) {
          var B = Math.sin(t *= d) * k,
              A = Math.sin(d - t) * k,
              x = A * kx0 + B * kx1,
              y = A * ky0 + B * ky1,
              z = A * sy0 + B * sy1;
          return [Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees];
        } : function () {
          return [x0 * d3_degrees, y0 * d3_degrees];
        };
        interpolate.distance = d;
        return interpolate;
      }
      d3.geo.length = function (object) {
        d3_geo_lengthSum = 0;
        d3.geo.stream(object, d3_geo_length);
        return d3_geo_lengthSum;
      };
      var d3_geo_lengthSum;
      var d3_geo_length = {
        sphere: d3_noop,
        point: d3_noop,
        lineStart: d3_geo_lengthLineStart,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
      };
      function d3_geo_lengthLineStart() {
        var λ0, sinφ0, cosφ0;
        d3_geo_length.point = function (λ, φ) {
          λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
          d3_geo_length.point = nextPoint;
        };
        d3_geo_length.lineEnd = function () {
          d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
        };
        function nextPoint(λ, φ) {
          var sinφ = Math.sin(φ *= d3_radians),
              cosφ = Math.cos(φ),
              t = abs((λ *= d3_radians) - λ0),
              cosΔλ = Math.cos(t);
          d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
          λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
        }
      }
      function d3_geo_azimuthal(scale, angle) {
        function azimuthal(λ, φ) {
          var cosλ = Math.cos(λ),
              cosφ = Math.cos(φ),
              k = scale(cosλ * cosφ);
          return [k * cosφ * Math.sin(λ), k * Math.sin(φ)];
        }
        azimuthal.invert = function (x, y) {
          var ρ = Math.sqrt(x * x + y * y),
              c = angle(ρ),
              sinc = Math.sin(c),
              cosc = Math.cos(c);
          return [Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ)];
        };
        return azimuthal;
      }
      var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function (cosλcosφ) {
        return Math.sqrt(2 / (1 + cosλcosφ));
      }, function (ρ) {
        return 2 * Math.asin(ρ / 2);
      });
      (d3.geo.azimuthalEqualArea = function () {
        return d3_geo_projection(d3_geo_azimuthalEqualArea);
      }).raw = d3_geo_azimuthalEqualArea;
      var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function (cosλcosφ) {
        var c = Math.acos(cosλcosφ);
        return c && c / Math.sin(c);
      }, d3_identity);
      (d3.geo.azimuthalEquidistant = function () {
        return d3_geo_projection(d3_geo_azimuthalEquidistant);
      }).raw = d3_geo_azimuthalEquidistant;
      function d3_geo_conicConformal(φ0, φ1) {
        var cosφ0 = Math.cos(φ0),
            t = function (φ) {
          return Math.tan(π / 4 + φ / 2);
        },
            n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)),
            F = cosφ0 * Math.pow(t(φ0), n) / n;
        if (!n) return d3_geo_mercator;
        function forward(λ, φ) {
          if (F > 0) {
            if (φ < -halfπ + ε) φ = -halfπ + ε;
          } else {
            if (φ > halfπ - ε) φ = halfπ - ε;
          }
          var ρ = F / Math.pow(t(φ), n);
          return [ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ)];
        }
        forward.invert = function (x, y) {
          var ρ0_y = F - y,
              ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
          return [Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ];
        };
        return forward;
      }
      (d3.geo.conicConformal = function () {
        return d3_geo_conic(d3_geo_conicConformal);
      }).raw = d3_geo_conicConformal;
      function d3_geo_conicEquidistant(φ0, φ1) {
        var cosφ0 = Math.cos(φ0),
            n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0),
            G = cosφ0 / n + φ0;
        if (abs(n) < ε) return d3_geo_equirectangular;
        function forward(λ, φ) {
          var ρ = G - φ;
          return [ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ)];
        }
        forward.invert = function (x, y) {
          var ρ0_y = G - y;
          return [Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y)];
        };
        return forward;
      }
      (d3.geo.conicEquidistant = function () {
        return d3_geo_conic(d3_geo_conicEquidistant);
      }).raw = d3_geo_conicEquidistant;
      var d3_geo_gnomonic = d3_geo_azimuthal(function (cosλcosφ) {
        return 1 / cosλcosφ;
      }, Math.atan);
      (d3.geo.gnomonic = function () {
        return d3_geo_projection(d3_geo_gnomonic);
      }).raw = d3_geo_gnomonic;
      function d3_geo_mercator(λ, φ) {
        return [λ, Math.log(Math.tan(π / 4 + φ / 2))];
      }
      d3_geo_mercator.invert = function (x, y) {
        return [x, 2 * Math.atan(Math.exp(y)) - halfπ];
      };
      function d3_geo_mercatorProjection(project) {
        var m = d3_geo_projection(project),
            scale = m.scale,
            translate = m.translate,
            clipExtent = m.clipExtent,
            clipAuto;
        m.scale = function () {
          var v = scale.apply(m, arguments);
          return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.translate = function () {
          var v = translate.apply(m, arguments);
          return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.clipExtent = function (_) {
          var v = clipExtent.apply(m, arguments);
          if (v === m) {
            if (clipAuto = _ == null) {
              var k = π * scale(),
                  t = translate();
              clipExtent([[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]]);
            }
          } else if (clipAuto) {
            v = null;
          }
          return v;
        };
        return m.clipExtent(null);
      }
      (d3.geo.mercator = function () {
        return d3_geo_mercatorProjection(d3_geo_mercator);
      }).raw = d3_geo_mercator;
      var d3_geo_orthographic = d3_geo_azimuthal(function () {
        return 1;
      }, Math.asin);
      (d3.geo.orthographic = function () {
        return d3_geo_projection(d3_geo_orthographic);
      }).raw = d3_geo_orthographic;
      var d3_geo_stereographic = d3_geo_azimuthal(function (cosλcosφ) {
        return 1 / (1 + cosλcosφ);
      }, function (ρ) {
        return 2 * Math.atan(ρ);
      });
      (d3.geo.stereographic = function () {
        return d3_geo_projection(d3_geo_stereographic);
      }).raw = d3_geo_stereographic;
      function d3_geo_transverseMercator(λ, φ) {
        return [Math.log(Math.tan(π / 4 + φ / 2)), -λ];
      }
      d3_geo_transverseMercator.invert = function (x, y) {
        return [-y, 2 * Math.atan(Math.exp(x)) - halfπ];
      };
      (d3.geo.transverseMercator = function () {
        var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator),
            center = projection.center,
            rotate = projection.rotate;
        projection.center = function (_) {
          return _ ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
        };
        projection.rotate = function (_) {
          return _ ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
        };
        return rotate([0, 0, 90]);
      }).raw = d3_geo_transverseMercator;
      d3.geom = {};
      function d3_geom_pointX(d) {
        return d[0];
      }
      function d3_geom_pointY(d) {
        return d[1];
      }
      d3.geom.hull = function (vertices) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY;
        if (arguments.length) return hull(vertices);
        function hull(data) {
          if (data.length < 3) return [];
          var fx = d3_functor(x),
              fy = d3_functor(y),
              i,
              n = data.length,
              points = [],
              flippedPoints = [];
          for (i = 0; i < n; i++) {
            points.push([+fx.call(this, data[i], i), +fy.call(this, data[i], i), i]);
          }
          points.sort(d3_geom_hullOrder);
          for (i = 0; i < n; i++) flippedPoints.push([points[i][0], -points[i][1]]);
          var upper = d3_geom_hullUpper(points),
              lower = d3_geom_hullUpper(flippedPoints);
          var skipLeft = lower[0] === upper[0],
              skipRight = lower[lower.length - 1] === upper[upper.length - 1],
              polygon = [];
          for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
          for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
          return polygon;
        }
        hull.x = function (_) {
          return arguments.length ? (x = _, hull) : x;
        };
        hull.y = function (_) {
          return arguments.length ? (y = _, hull) : y;
        };
        return hull;
      };
      function d3_geom_hullUpper(points) {
        var n = points.length,
            hull = [0, 1],
            hs = 2;
        for (var i = 2; i < n; i++) {
          while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
          hull[hs++] = i;
        }
        return hull.slice(0, hs);
      }
      function d3_geom_hullOrder(a, b) {
        return a[0] - b[0] || a[1] - b[1];
      }
      d3.geom.polygon = function (coordinates) {
        d3_subclass(coordinates, d3_geom_polygonPrototype);
        return coordinates;
      };
      var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
      d3_geom_polygonPrototype.area = function () {
        var i = -1,
            n = this.length,
            a,
            b = this[n - 1],
            area = 0;
        while (++i < n) {
          a = b;
          b = this[i];
          area += a[1] * b[0] - a[0] * b[1];
        }
        return area * .5;
      };
      d3_geom_polygonPrototype.centroid = function (k) {
        var i = -1,
            n = this.length,
            x = 0,
            y = 0,
            a,
            b = this[n - 1],
            c;
        if (!arguments.length) k = -1 / (6 * this.area());
        while (++i < n) {
          a = b;
          b = this[i];
          c = a[0] * b[1] - b[0] * a[1];
          x += (a[0] + b[0]) * c;
          y += (a[1] + b[1]) * c;
        }
        return [x * k, y * k];
      };
      d3_geom_polygonPrototype.clip = function (subject) {
        var input,
            closed = d3_geom_polygonClosed(subject),
            i = -1,
            n = this.length - d3_geom_polygonClosed(this),
            j,
            m,
            a = this[n - 1],
            b,
            c,
            d;
        while (++i < n) {
          input = subject.slice();
          subject.length = 0;
          b = this[i];
          c = input[(m = input.length - closed) - 1];
          j = -1;
          while (++j < m) {
            d = input[j];
            if (d3_geom_polygonInside(d, a, b)) {
              if (!d3_geom_polygonInside(c, a, b)) {
                subject.push(d3_geom_polygonIntersect(c, d, a, b));
              }
              subject.push(d);
            } else if (d3_geom_polygonInside(c, a, b)) {
              subject.push(d3_geom_polygonIntersect(c, d, a, b));
            }
            c = d;
          }
          if (closed) subject.push(subject[0]);
          a = b;
        }
        return subject;
      };
      function d3_geom_polygonInside(p, a, b) {
        return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
      }
      function d3_geom_polygonIntersect(c, d, a, b) {
        var x1 = c[0],
            x3 = a[0],
            x21 = d[0] - x1,
            x43 = b[0] - x3,
            y1 = c[1],
            y3 = a[1],
            y21 = d[1] - y1,
            y43 = b[1] - y3,
            ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
        return [x1 + ua * x21, y1 + ua * y21];
      }
      function d3_geom_polygonClosed(coordinates) {
        var a = coordinates[0],
            b = coordinates[coordinates.length - 1];
        return !(a[0] - b[0] || a[1] - b[1]);
      }
      var d3_geom_voronoiEdges,
          d3_geom_voronoiCells,
          d3_geom_voronoiBeaches,
          d3_geom_voronoiBeachPool = [],
          d3_geom_voronoiFirstCircle,
          d3_geom_voronoiCircles,
          d3_geom_voronoiCirclePool = [];
      function d3_geom_voronoiBeach() {
        d3_geom_voronoiRedBlackNode(this);
        this.edge = this.site = this.circle = null;
      }
      function d3_geom_voronoiCreateBeach(site) {
        var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
        beach.site = site;
        return beach;
      }
      function d3_geom_voronoiDetachBeach(beach) {
        d3_geom_voronoiDetachCircle(beach);
        d3_geom_voronoiBeaches.remove(beach);
        d3_geom_voronoiBeachPool.push(beach);
        d3_geom_voronoiRedBlackNode(beach);
      }
      function d3_geom_voronoiRemoveBeach(beach) {
        var circle = beach.circle,
            x = circle.x,
            y = circle.cy,
            vertex = {
          x: x,
          y: y
        },
            previous = beach.P,
            next = beach.N,
            disappearing = [beach];
        d3_geom_voronoiDetachBeach(beach);
        var lArc = previous;
        while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
          previous = lArc.P;
          disappearing.unshift(lArc);
          d3_geom_voronoiDetachBeach(lArc);
          lArc = previous;
        }
        disappearing.unshift(lArc);
        d3_geom_voronoiDetachCircle(lArc);
        var rArc = next;
        while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
          next = rArc.N;
          disappearing.push(rArc);
          d3_geom_voronoiDetachBeach(rArc);
          rArc = next;
        }
        disappearing.push(rArc);
        d3_geom_voronoiDetachCircle(rArc);
        var nArcs = disappearing.length,
            iArc;
        for (iArc = 1; iArc < nArcs; ++iArc) {
          rArc = disappearing[iArc];
          lArc = disappearing[iArc - 1];
          d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
        }
        lArc = disappearing[0];
        rArc = disappearing[nArcs - 1];
        rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
        d3_geom_voronoiAttachCircle(lArc);
        d3_geom_voronoiAttachCircle(rArc);
      }
      function d3_geom_voronoiAddBeach(site) {
        var x = site.x,
            directrix = site.y,
            lArc,
            rArc,
            dxl,
            dxr,
            node = d3_geom_voronoiBeaches._;
        while (node) {
          dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
          if (dxl > ε) node = node.L;else {
            dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
            if (dxr > ε) {
              if (!node.R) {
                lArc = node;
                break;
              }
              node = node.R;
            } else {
              if (dxl > -ε) {
                lArc = node.P;
                rArc = node;
              } else if (dxr > -ε) {
                lArc = node;
                rArc = node.N;
              } else {
                lArc = rArc = node;
              }
              break;
            }
          }
        }
        var newArc = d3_geom_voronoiCreateBeach(site);
        d3_geom_voronoiBeaches.insert(lArc, newArc);
        if (!lArc && !rArc) return;
        if (lArc === rArc) {
          d3_geom_voronoiDetachCircle(lArc);
          rArc = d3_geom_voronoiCreateBeach(lArc.site);
          d3_geom_voronoiBeaches.insert(newArc, rArc);
          newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
          d3_geom_voronoiAttachCircle(lArc);
          d3_geom_voronoiAttachCircle(rArc);
          return;
        }
        if (!rArc) {
          newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
          return;
        }
        d3_geom_voronoiDetachCircle(lArc);
        d3_geom_voronoiDetachCircle(rArc);
        var lSite = lArc.site,
            ax = lSite.x,
            ay = lSite.y,
            bx = site.x - ax,
            by = site.y - ay,
            rSite = rArc.site,
            cx = rSite.x - ax,
            cy = rSite.y - ay,
            d = 2 * (bx * cy - by * cx),
            hb = bx * bx + by * by,
            hc = cx * cx + cy * cy,
            vertex = {
          x: (cy * hb - by * hc) / d + ax,
          y: (bx * hc - cx * hb) / d + ay
        };
        d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
        newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
        rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
        d3_geom_voronoiAttachCircle(lArc);
        d3_geom_voronoiAttachCircle(rArc);
      }
      function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
        var site = arc.site,
            rfocx = site.x,
            rfocy = site.y,
            pby2 = rfocy - directrix;
        if (!pby2) return rfocx;
        var lArc = arc.P;
        if (!lArc) return -Infinity;
        site = lArc.site;
        var lfocx = site.x,
            lfocy = site.y,
            plby2 = lfocy - directrix;
        if (!plby2) return lfocx;
        var hl = lfocx - rfocx,
            aby2 = 1 / pby2 - 1 / plby2,
            b = hl / plby2;
        if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
        return (rfocx + lfocx) / 2;
      }
      function d3_geom_voronoiRightBreakPoint(arc, directrix) {
        var rArc = arc.N;
        if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
        var site = arc.site;
        return site.y === directrix ? site.x : Infinity;
      }
      function d3_geom_voronoiCell(site) {
        this.site = site;
        this.edges = [];
      }
      d3_geom_voronoiCell.prototype.prepare = function () {
        var halfEdges = this.edges,
            iHalfEdge = halfEdges.length,
            edge;
        while (iHalfEdge--) {
          edge = halfEdges[iHalfEdge].edge;
          if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
        }
        halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
        return halfEdges.length;
      };
      function d3_geom_voronoiCloseCells(extent) {
        var x0 = extent[0][0],
            x1 = extent[1][0],
            y0 = extent[0][1],
            y1 = extent[1][1],
            x2,
            y2,
            x3,
            y3,
            cells = d3_geom_voronoiCells,
            iCell = cells.length,
            cell,
            iHalfEdge,
            halfEdges,
            nHalfEdges,
            start,
            end;
        while (iCell--) {
          cell = cells[iCell];
          if (!cell || !cell.prepare()) continue;
          halfEdges = cell.edges;
          nHalfEdges = halfEdges.length;
          iHalfEdge = 0;
          while (iHalfEdge < nHalfEdges) {
            end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
            start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
            if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
              halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
                x: x0,
                y: abs(x2 - x0) < ε ? y2 : y1
              } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
                x: abs(y2 - y1) < ε ? x2 : x1,
                y: y1
              } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
                x: x1,
                y: abs(x2 - x1) < ε ? y2 : y0
              } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
                x: abs(y2 - y0) < ε ? x2 : x0,
                y: y0
              } : null), cell.site, null));
              ++nHalfEdges;
            }
          }
        }
      }
      function d3_geom_voronoiHalfEdgeOrder(a, b) {
        return b.angle - a.angle;
      }
      function d3_geom_voronoiCircle() {
        d3_geom_voronoiRedBlackNode(this);
        this.x = this.y = this.arc = this.site = this.cy = null;
      }
      function d3_geom_voronoiAttachCircle(arc) {
        var lArc = arc.P,
            rArc = arc.N;
        if (!lArc || !rArc) return;
        var lSite = lArc.site,
            cSite = arc.site,
            rSite = rArc.site;
        if (lSite === rSite) return;
        var bx = cSite.x,
            by = cSite.y,
            ax = lSite.x - bx,
            ay = lSite.y - by,
            cx = rSite.x - bx,
            cy = rSite.y - by;
        var d = 2 * (ax * cy - ay * cx);
        if (d >= -ε2) return;
        var ha = ax * ax + ay * ay,
            hc = cx * cx + cy * cy,
            x = (cy * ha - ay * hc) / d,
            y = (ax * hc - cx * ha) / d,
            cy = y + by;
        var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
        circle.arc = arc;
        circle.site = cSite;
        circle.x = x + bx;
        circle.y = cy + Math.sqrt(x * x + y * y);
        circle.cy = cy;
        arc.circle = circle;
        var before = null,
            node = d3_geom_voronoiCircles._;
        while (node) {
          if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;else {
              before = node.P;
              break;
            }
          } else {
            if (node.R) node = node.R;else {
              before = node;
              break;
            }
          }
        }
        d3_geom_voronoiCircles.insert(before, circle);
        if (!before) d3_geom_voronoiFirstCircle = circle;
      }
      function d3_geom_voronoiDetachCircle(arc) {
        var circle = arc.circle;
        if (circle) {
          if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
          d3_geom_voronoiCircles.remove(circle);
          d3_geom_voronoiCirclePool.push(circle);
          d3_geom_voronoiRedBlackNode(circle);
          arc.circle = null;
        }
      }
      function d3_geom_voronoiClipEdges(extent) {
        var edges = d3_geom_voronoiEdges,
            clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]),
            i = edges.length,
            e;
        while (i--) {
          e = edges[i];
          if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
            e.a = e.b = null;
            edges.splice(i, 1);
          }
        }
      }
      function d3_geom_voronoiConnectEdge(edge, extent) {
        var vb = edge.b;
        if (vb) return true;
        var va = edge.a,
            x0 = extent[0][0],
            x1 = extent[1][0],
            y0 = extent[0][1],
            y1 = extent[1][1],
            lSite = edge.l,
            rSite = edge.r,
            lx = lSite.x,
            ly = lSite.y,
            rx = rSite.x,
            ry = rSite.y,
            fx = (lx + rx) / 2,
            fy = (ly + ry) / 2,
            fm,
            fb;
        if (ry === ly) {
          if (fx < x0 || fx >= x1) return;
          if (lx > rx) {
            if (!va) va = {
              x: fx,
              y: y0
            };else if (va.y >= y1) return;
            vb = {
              x: fx,
              y: y1
            };
          } else {
            if (!va) va = {
              x: fx,
              y: y1
            };else if (va.y < y0) return;
            vb = {
              x: fx,
              y: y0
            };
          }
        } else {
          fm = (lx - rx) / (ry - ly);
          fb = fy - fm * fx;
          if (fm < -1 || fm > 1) {
            if (lx > rx) {
              if (!va) va = {
                x: (y0 - fb) / fm,
                y: y0
              };else if (va.y >= y1) return;
              vb = {
                x: (y1 - fb) / fm,
                y: y1
              };
            } else {
              if (!va) va = {
                x: (y1 - fb) / fm,
                y: y1
              };else if (va.y < y0) return;
              vb = {
                x: (y0 - fb) / fm,
                y: y0
              };
            }
          } else {
            if (ly < ry) {
              if (!va) va = {
                x: x0,
                y: fm * x0 + fb
              };else if (va.x >= x1) return;
              vb = {
                x: x1,
                y: fm * x1 + fb
              };
            } else {
              if (!va) va = {
                x: x1,
                y: fm * x1 + fb
              };else if (va.x < x0) return;
              vb = {
                x: x0,
                y: fm * x0 + fb
              };
            }
          }
        }
        edge.a = va;
        edge.b = vb;
        return true;
      }
      function d3_geom_voronoiEdge(lSite, rSite) {
        this.l = lSite;
        this.r = rSite;
        this.a = this.b = null;
      }
      function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
        var edge = new d3_geom_voronoiEdge(lSite, rSite);
        d3_geom_voronoiEdges.push(edge);
        if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
        if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
        d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
        d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
        return edge;
      }
      function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
        var edge = new d3_geom_voronoiEdge(lSite, null);
        edge.a = va;
        edge.b = vb;
        d3_geom_voronoiEdges.push(edge);
        return edge;
      }
      function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
        if (!edge.a && !edge.b) {
          edge.a = vertex;
          edge.l = lSite;
          edge.r = rSite;
        } else if (edge.l === rSite) {
          edge.b = vertex;
        } else {
          edge.a = vertex;
        }
      }
      function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
        var va = edge.a,
            vb = edge.b;
        this.edge = edge;
        this.site = lSite;
        this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
      }
      d3_geom_voronoiHalfEdge.prototype = {
        start: function () {
          return this.edge.l === this.site ? this.edge.a : this.edge.b;
        },
        end: function () {
          return this.edge.l === this.site ? this.edge.b : this.edge.a;
        }
      };
      function d3_geom_voronoiRedBlackTree() {
        this._ = null;
      }
      function d3_geom_voronoiRedBlackNode(node) {
        node.U = node.C = node.L = node.R = node.P = node.N = null;
      }
      d3_geom_voronoiRedBlackTree.prototype = {
        insert: function (after, node) {
          var parent, grandpa, uncle;
          if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
              after = after.R;
              while (after.L) after = after.L;
              after.L = node;
            } else {
              after.R = node;
            }
            parent = after;
          } else if (this._) {
            after = d3_geom_voronoiRedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
          } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
          }
          node.L = node.R = null;
          node.U = parent;
          node.C = true;
          after = node;
          while (parent && parent.C) {
            grandpa = parent.U;
            if (parent === grandpa.L) {
              uncle = grandpa.R;
              if (uncle && uncle.C) {
                parent.C = uncle.C = false;
                grandpa.C = true;
                after = grandpa;
              } else {
                if (after === parent.R) {
                  d3_geom_voronoiRedBlackRotateLeft(this, parent);
                  after = parent;
                  parent = after.U;
                }
                parent.C = false;
                grandpa.C = true;
                d3_geom_voronoiRedBlackRotateRight(this, grandpa);
              }
            } else {
              uncle = grandpa.L;
              if (uncle && uncle.C) {
                parent.C = uncle.C = false;
                grandpa.C = true;
                after = grandpa;
              } else {
                if (after === parent.L) {
                  d3_geom_voronoiRedBlackRotateRight(this, parent);
                  after = parent;
                  parent = after.U;
                }
                parent.C = false;
                grandpa.C = true;
                d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
              }
            }
            parent = after.U;
          }
          this._.C = false;
        },
        remove: function (node) {
          if (node.N) node.N.P = node.P;
          if (node.P) node.P.N = node.N;
          node.N = node.P = null;
          var parent = node.U,
              sibling,
              left = node.L,
              right = node.R,
              next,
              red;
          if (!left) next = right;else if (!right) next = left;else next = d3_geom_voronoiRedBlackFirst(right);
          if (parent) {
            if (parent.L === node) parent.L = next;else parent.R = next;
          } else {
            this._ = next;
          }
          if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
              parent = next.U;
              next.U = node.U;
              node = next.R;
              parent.L = node;
              next.R = right;
              right.U = next;
            } else {
              next.U = parent;
              parent = next;
              node = next.R;
            }
          } else {
            red = node.C;
            node = next;
          }
          if (node) node.U = parent;
          if (red) return;
          if (node && node.C) {
            node.C = false;
            return;
          }
          do {
            if (node === this._) break;
            if (node === parent.L) {
              sibling = parent.R;
              if (sibling.C) {
                sibling.C = false;
                parent.C = true;
                d3_geom_voronoiRedBlackRotateLeft(this, parent);
                sibling = parent.R;
              }
              if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                if (!sibling.R || !sibling.R.C) {
                  sibling.L.C = false;
                  sibling.C = true;
                  d3_geom_voronoiRedBlackRotateRight(this, sibling);
                  sibling = parent.R;
                }
                sibling.C = parent.C;
                parent.C = sibling.R.C = false;
                d3_geom_voronoiRedBlackRotateLeft(this, parent);
                node = this._;
                break;
              }
            } else {
              sibling = parent.L;
              if (sibling.C) {
                sibling.C = false;
                parent.C = true;
                d3_geom_voronoiRedBlackRotateRight(this, parent);
                sibling = parent.L;
              }
              if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                if (!sibling.L || !sibling.L.C) {
                  sibling.R.C = false;
                  sibling.C = true;
                  d3_geom_voronoiRedBlackRotateLeft(this, sibling);
                  sibling = parent.L;
                }
                sibling.C = parent.C;
                parent.C = sibling.L.C = false;
                d3_geom_voronoiRedBlackRotateRight(this, parent);
                node = this._;
                break;
              }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
          } while (!node.C);
          if (node) node.C = false;
        }
      };
      function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
        var p = node,
            q = node.R,
            parent = p.U;
        if (parent) {
          if (parent.L === p) parent.L = q;else parent.R = q;
        } else {
          tree._ = q;
        }
        q.U = parent;
        p.U = q;
        p.R = q.L;
        if (p.R) p.R.U = p;
        q.L = p;
      }
      function d3_geom_voronoiRedBlackRotateRight(tree, node) {
        var p = node,
            q = node.L,
            parent = p.U;
        if (parent) {
          if (parent.L === p) parent.L = q;else parent.R = q;
        } else {
          tree._ = q;
        }
        q.U = parent;
        p.U = q;
        p.L = q.R;
        if (p.L) p.L.U = p;
        q.R = p;
      }
      function d3_geom_voronoiRedBlackFirst(node) {
        while (node.L) node = node.L;
        return node;
      }
      function d3_geom_voronoi(sites, bbox) {
        var site = sites.sort(d3_geom_voronoiVertexOrder).pop(),
            x0,
            y0,
            circle;
        d3_geom_voronoiEdges = [];
        d3_geom_voronoiCells = new Array(sites.length);
        d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
        d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
        while (true) {
          circle = d3_geom_voronoiFirstCircle;
          if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
            if (site.x !== x0 || site.y !== y0) {
              d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
              d3_geom_voronoiAddBeach(site);
              x0 = site.x, y0 = site.y;
            }
            site = sites.pop();
          } else if (circle) {
            d3_geom_voronoiRemoveBeach(circle.arc);
          } else {
            break;
          }
        }
        if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
        var diagram = {
          cells: d3_geom_voronoiCells,
          edges: d3_geom_voronoiEdges
        };
        d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
        return diagram;
      }
      function d3_geom_voronoiVertexOrder(a, b) {
        return b.y - a.y || b.x - a.x;
      }
      d3.geom.voronoi = function (points) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            fx = x,
            fy = y,
            clipExtent = d3_geom_voronoiClipExtent;
        if (points) return voronoi(points);
        function voronoi(data) {
          var polygons = new Array(data.length),
              x0 = clipExtent[0][0],
              y0 = clipExtent[0][1],
              x1 = clipExtent[1][0],
              y1 = clipExtent[1][1];
          d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function (cell, i) {
            var edges = cell.edges,
                site = cell.site,
                polygon = polygons[i] = edges.length ? edges.map(function (e) {
              var s = e.start();
              return [s.x, s.y];
            }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [[x0, y1], [x1, y1], [x1, y0], [x0, y0]] : [];
            polygon.point = data[i];
          });
          return polygons;
        }
        function sites(data) {
          return data.map(function (d, i) {
            return {
              x: Math.round(fx(d, i) / ε) * ε,
              y: Math.round(fy(d, i) / ε) * ε,
              i: i
            };
          });
        }
        voronoi.links = function (data) {
          return d3_geom_voronoi(sites(data)).edges.filter(function (edge) {
            return edge.l && edge.r;
          }).map(function (edge) {
            return {
              source: data[edge.l.i],
              target: data[edge.r.i]
            };
          });
        };
        voronoi.triangles = function (data) {
          var triangles = [];
          d3_geom_voronoi(sites(data)).cells.forEach(function (cell, i) {
            var site = cell.site,
                edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder),
                j = -1,
                m = edges.length,
                e0,
                s0,
                e1 = edges[m - 1].edge,
                s1 = e1.l === site ? e1.r : e1.l;
            while (++j < m) {
              e0 = e1;
              s0 = s1;
              e1 = edges[j].edge;
              s1 = e1.l === site ? e1.r : e1.l;
              if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
                triangles.push([data[i], data[s0.i], data[s1.i]]);
              }
            }
          });
          return triangles;
        };
        voronoi.x = function (_) {
          return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
        };
        voronoi.y = function (_) {
          return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
        };
        voronoi.clipExtent = function (_) {
          if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
          clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
          return voronoi;
        };
        voronoi.size = function (_) {
          if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
          return voronoi.clipExtent(_ && [[0, 0], _]);
        };
        return voronoi;
      };
      var d3_geom_voronoiClipExtent = [[-1e6, -1e6], [1e6, 1e6]];
      function d3_geom_voronoiTriangleArea(a, b, c) {
        return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
      }
      d3.geom.delaunay = function (vertices) {
        return d3.geom.voronoi().triangles(vertices);
      };
      d3.geom.quadtree = function (points, x1, y1, x2, y2) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            compat;
        if (compat = arguments.length) {
          x = d3_geom_quadtreeCompatX;
          y = d3_geom_quadtreeCompatY;
          if (compat === 3) {
            y2 = y1;
            x2 = x1;
            y1 = x1 = 0;
          }
          return quadtree(points);
        }
        function quadtree(data) {
          var d,
              fx = d3_functor(x),
              fy = d3_functor(y),
              xs,
              ys,
              i,
              n,
              x1_,
              y1_,
              x2_,
              y2_;
          if (x1 != null) {
            x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
          } else {
            x2_ = y2_ = -(x1_ = y1_ = Infinity);
            xs = [], ys = [];
            n = data.length;
            if (compat) for (i = 0; i < n; ++i) {
              d = data[i];
              if (d.x < x1_) x1_ = d.x;
              if (d.y < y1_) y1_ = d.y;
              if (d.x > x2_) x2_ = d.x;
              if (d.y > y2_) y2_ = d.y;
              xs.push(d.x);
              ys.push(d.y);
            } else for (i = 0; i < n; ++i) {
              var x_ = +fx(d = data[i], i),
                  y_ = +fy(d, i);
              if (x_ < x1_) x1_ = x_;
              if (y_ < y1_) y1_ = y_;
              if (x_ > x2_) x2_ = x_;
              if (y_ > y2_) y2_ = y_;
              xs.push(x_);
              ys.push(y_);
            }
          }
          var dx = x2_ - x1_,
              dy = y2_ - y1_;
          if (dx > dy) y2_ = y1_ + dx;else x2_ = x1_ + dy;
          function insert(n, d, x, y, x1, y1, x2, y2) {
            if (isNaN(x) || isNaN(y)) return;
            if (n.leaf) {
              var nx = n.x,
                  ny = n.y;
              if (nx != null) {
                if (abs(nx - x) + abs(ny - y) < .01) {
                  insertChild(n, d, x, y, x1, y1, x2, y2);
                } else {
                  var nPoint = n.point;
                  n.x = n.y = n.point = null;
                  insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
                  insertChild(n, d, x, y, x1, y1, x2, y2);
                }
              } else {
                n.x = x, n.y = y, n.point = d;
              }
            } else {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          }
          function insertChild(n, d, x, y, x1, y1, x2, y2) {
            var xm = (x1 + x2) * .5,
                ym = (y1 + y2) * .5,
                right = x >= xm,
                below = y >= ym,
                i = below << 1 | right;
            n.leaf = false;
            n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
            if (right) x1 = xm;else x2 = xm;
            if (below) y1 = ym;else y2 = ym;
            insert(n, d, x, y, x1, y1, x2, y2);
          }
          var root = d3_geom_quadtreeNode();
          root.add = function (d) {
            insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
          };
          root.visit = function (f) {
            d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
          };
          root.find = function (point) {
            return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
          };
          i = -1;
          if (x1 == null) {
            while (++i < n) {
              insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
            }
            --i;
          } else data.forEach(root.add);
          xs = ys = data = d = null;
          return root;
        }
        quadtree.x = function (_) {
          return arguments.length ? (x = _, quadtree) : x;
        };
        quadtree.y = function (_) {
          return arguments.length ? (y = _, quadtree) : y;
        };
        quadtree.extent = function (_) {
          if (!arguments.length) return x1 == null ? null : [[x1, y1], [x2, y2]];
          if (_ == null) x1 = y1 = x2 = y2 = null;else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], y2 = +_[1][1];
          return quadtree;
        };
        quadtree.size = function (_) {
          if (!arguments.length) return x1 == null ? null : [x2 - x1, y2 - y1];
          if (_ == null) x1 = y1 = x2 = y2 = null;else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
          return quadtree;
        };
        return quadtree;
      };
      function d3_geom_quadtreeCompatX(d) {
        return d.x;
      }
      function d3_geom_quadtreeCompatY(d) {
        return d.y;
      }
      function d3_geom_quadtreeNode() {
        return {
          leaf: true,
          nodes: [],
          point: null,
          x: null,
          y: null
        };
      }
      function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
        if (!f(node, x1, y1, x2, y2)) {
          var sx = (x1 + x2) * .5,
              sy = (y1 + y2) * .5,
              children = node.nodes;
          if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
          if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
          if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
          if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
        }
      }
      function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
        var minDistance2 = Infinity,
            closestPoint;
        (function find(node, x1, y1, x2, y2) {
          if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
          if (point = node.point) {
            var point,
                dx = x - node.x,
                dy = y - node.y,
                distance2 = dx * dx + dy * dy;
            if (distance2 < minDistance2) {
              var distance = Math.sqrt(minDistance2 = distance2);
              x0 = x - distance, y0 = y - distance;
              x3 = x + distance, y3 = y + distance;
              closestPoint = point;
            }
          }
          var children = node.nodes,
              xm = (x1 + x2) * .5,
              ym = (y1 + y2) * .5,
              right = x >= xm,
              below = y >= ym;
          for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
            if (node = children[i & 3]) switch (i & 3) {
              case 0:
                find(node, x1, y1, xm, ym);
                break;

              case 1:
                find(node, xm, y1, x2, ym);
                break;

              case 2:
                find(node, x1, ym, xm, y2);
                break;

              case 3:
                find(node, xm, ym, x2, y2);
                break;
            }
          }
        })(root, x0, y0, x3, y3);
        return closestPoint;
      }
      d3.interpolateRgb = d3_interpolateRgb;
      function d3_interpolateRgb(a, b) {
        a = d3.rgb(a);
        b = d3.rgb(b);
        var ar = a.r,
            ag = a.g,
            ab = a.b,
            br = b.r - ar,
            bg = b.g - ag,
            bb = b.b - ab;
        return function (t) {
          return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
        };
      }
      d3.interpolateObject = d3_interpolateObject;
      function d3_interpolateObject(a, b) {
        var i = {},
            c = {},
            k;
        for (k in a) {
          if (k in b) {
            i[k] = d3_interpolate(a[k], b[k]);
          } else {
            c[k] = a[k];
          }
        }
        for (k in b) {
          if (!(k in a)) {
            c[k] = b[k];
          }
        }
        return function (t) {
          for (k in i) c[k] = i[k](t);
          return c;
        };
      }
      d3.interpolateNumber = d3_interpolateNumber;
      function d3_interpolateNumber(a, b) {
        a = +a, b = +b;
        return function (t) {
          return a * (1 - t) + b * t;
        };
      }
      d3.interpolateString = d3_interpolateString;
      function d3_interpolateString(a, b) {
        var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0,
            am,
            bm,
            bs,
            i = -1,
            s = [],
            q = [];
        a = a + "", b = b + "";
        while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
          if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs;else s[++i] = bs;
          }
          if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm;else s[++i] = bm;
          } else {
            s[++i] = null;
            q.push({
              i: i,
              x: d3_interpolateNumber(am, bm)
            });
          }
          bi = d3_interpolate_numberB.lastIndex;
        }
        if (bi < b.length) {
          bs = b.slice(bi);
          if (s[i]) s[i] += bs;else s[++i] = bs;
        }
        return s.length < 2 ? q[0] ? (b = q[0].x, function (t) {
          return b(t) + "";
        }) : function () {
          return b;
        } : (b = q.length, function (t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
      }
      var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
          d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
      d3.interpolate = d3_interpolate;
      function d3_interpolate(a, b) {
        var i = d3.interpolators.length,
            f;
        while (--i >= 0 && !(f = d3.interpolators[i](a, b)));
        return f;
      }
      d3.interpolators = [function (a, b) {
        var t = typeof b;
        return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
      }];
      d3.interpolateArray = d3_interpolateArray;
      function d3_interpolateArray(a, b) {
        var x = [],
            c = [],
            na = a.length,
            nb = b.length,
            n0 = Math.min(a.length, b.length),
            i;
        for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
        for (; i < na; ++i) c[i] = a[i];
        for (; i < nb; ++i) c[i] = b[i];
        return function (t) {
          for (i = 0; i < n0; ++i) c[i] = x[i](t);
          return c;
        };
      }
      var d3_ease_default = function () {
        return d3_identity;
      };
      var d3_ease = d3.map({
        linear: d3_ease_default,
        poly: d3_ease_poly,
        quad: function () {
          return d3_ease_quad;
        },
        cubic: function () {
          return d3_ease_cubic;
        },
        sin: function () {
          return d3_ease_sin;
        },
        exp: function () {
          return d3_ease_exp;
        },
        circle: function () {
          return d3_ease_circle;
        },
        elastic: d3_ease_elastic,
        back: d3_ease_back,
        bounce: function () {
          return d3_ease_bounce;
        }
      });
      var d3_ease_mode = d3.map({
        "in": d3_identity,
        out: d3_ease_reverse,
        "in-out": d3_ease_reflect,
        "out-in": function (f) {
          return d3_ease_reflect(d3_ease_reverse(f));
        }
      });
      d3.ease = function (name) {
        var i = name.indexOf("-"),
            t = i >= 0 ? name.slice(0, i) : name,
            m = i >= 0 ? name.slice(i + 1) : "in";
        t = d3_ease.get(t) || d3_ease_default;
        m = d3_ease_mode.get(m) || d3_identity;
        return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
      };
      function d3_ease_clamp(f) {
        return function (t) {
          return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
        };
      }
      function d3_ease_reverse(f) {
        return function (t) {
          return 1 - f(1 - t);
        };
      }
      function d3_ease_reflect(f) {
        return function (t) {
          return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
        };
      }
      function d3_ease_quad(t) {
        return t * t;
      }
      function d3_ease_cubic(t) {
        return t * t * t;
      }
      function d3_ease_cubicInOut(t) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        var t2 = t * t,
            t3 = t2 * t;
        return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
      }
      function d3_ease_poly(e) {
        return function (t) {
          return Math.pow(t, e);
        };
      }
      function d3_ease_sin(t) {
        return 1 - Math.cos(t * halfπ);
      }
      function d3_ease_exp(t) {
        return Math.pow(2, 10 * (t - 1));
      }
      function d3_ease_circle(t) {
        return 1 - Math.sqrt(1 - t * t);
      }
      function d3_ease_elastic(a, p) {
        var s;
        if (arguments.length < 2) p = .45;
        if (arguments.length) s = p / τ * Math.asin(1 / a);else a = 1, s = p / 4;
        return function (t) {
          return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
        };
      }
      function d3_ease_back(s) {
        if (!s) s = 1.70158;
        return function (t) {
          return t * t * ((s + 1) * t - s);
        };
      }
      function d3_ease_bounce(t) {
        return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
      }
      d3.interpolateHcl = d3_interpolateHcl;
      function d3_interpolateHcl(a, b) {
        a = d3.hcl(a);
        b = d3.hcl(b);
        var ah = a.h,
            ac = a.c,
            al = a.l,
            bh = b.h - ah,
            bc = b.c - ac,
            bl = b.l - al;
        if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
        if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;else if (bh > 180) bh -= 360;else if (bh < -180) bh += 360;
        return function (t) {
          return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
        };
      }
      d3.interpolateHsl = d3_interpolateHsl;
      function d3_interpolateHsl(a, b) {
        a = d3.hsl(a);
        b = d3.hsl(b);
        var ah = a.h,
            as = a.s,
            al = a.l,
            bh = b.h - ah,
            bs = b.s - as,
            bl = b.l - al;
        if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
        if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;else if (bh > 180) bh -= 360;else if (bh < -180) bh += 360;
        return function (t) {
          return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
        };
      }
      d3.interpolateLab = d3_interpolateLab;
      function d3_interpolateLab(a, b) {
        a = d3.lab(a);
        b = d3.lab(b);
        var al = a.l,
            aa = a.a,
            ab = a.b,
            bl = b.l - al,
            ba = b.a - aa,
            bb = b.b - ab;
        return function (t) {
          return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
        };
      }
      d3.interpolateRound = d3_interpolateRound;
      function d3_interpolateRound(a, b) {
        b -= a;
        return function (t) {
          return Math.round(a + b * t);
        };
      }
      d3.transform = function (string) {
        var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
        return (d3.transform = function (string) {
          if (string != null) {
            g.setAttribute("transform", string);
            var t = g.transform.baseVal.consolidate();
          }
          return new d3_transform(t ? t.matrix : d3_transformIdentity);
        })(string);
      };
      function d3_transform(m) {
        var r0 = [m.a, m.b],
            r1 = [m.c, m.d],
            kx = d3_transformNormalize(r0),
            kz = d3_transformDot(r0, r1),
            ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
        if (r0[0] * r1[1] < r1[0] * r0[1]) {
          r0[0] *= -1;
          r0[1] *= -1;
          kx *= -1;
          kz *= -1;
        }
        this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
        this.translate = [m.e, m.f];
        this.scale = [kx, ky];
        this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
      }
      d3_transform.prototype.toString = function () {
        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
      };
      function d3_transformDot(a, b) {
        return a[0] * b[0] + a[1] * b[1];
      }
      function d3_transformNormalize(a) {
        var k = Math.sqrt(d3_transformDot(a, a));
        if (k) {
          a[0] /= k;
          a[1] /= k;
        }
        return k;
      }
      function d3_transformCombine(a, b, k) {
        a[0] += k * b[0];
        a[1] += k * b[1];
        return a;
      }
      var d3_transformIdentity = {
        a: 1,
        b: 0,
        c: 0,
        d: 1,
        e: 0,
        f: 0
      };
      d3.interpolateTransform = d3_interpolateTransform;
      function d3_interpolateTransformPop(s) {
        return s.length ? s.pop() + "," : "";
      }
      function d3_interpolateTranslate(ta, tb, s, q) {
        if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
          var i = s.push("translate(", null, ",", null, ")");
          q.push({
            i: i - 4,
            x: d3_interpolateNumber(ta[0], tb[0])
          }, {
            i: i - 2,
            x: d3_interpolateNumber(ta[1], tb[1])
          });
        } else if (tb[0] || tb[1]) {
          s.push("translate(" + tb + ")");
        }
      }
      function d3_interpolateRotate(ra, rb, s, q) {
        if (ra !== rb) {
          if (ra - rb > 180) rb += 360;else if (rb - ra > 180) ra += 360;
          q.push({
            i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
            x: d3_interpolateNumber(ra, rb)
          });
        } else if (rb) {
          s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
        }
      }
      function d3_interpolateSkew(wa, wb, s, q) {
        if (wa !== wb) {
          q.push({
            i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
            x: d3_interpolateNumber(wa, wb)
          });
        } else if (wb) {
          s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
        }
      }
      function d3_interpolateScale(ka, kb, s, q) {
        if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
          var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
          q.push({
            i: i - 4,
            x: d3_interpolateNumber(ka[0], kb[0])
          }, {
            i: i - 2,
            x: d3_interpolateNumber(ka[1], kb[1])
          });
        } else if (kb[0] !== 1 || kb[1] !== 1) {
          s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
        }
      }
      function d3_interpolateTransform(a, b) {
        var s = [],
            q = [];
        a = d3.transform(a), b = d3.transform(b);
        d3_interpolateTranslate(a.translate, b.translate, s, q);
        d3_interpolateRotate(a.rotate, b.rotate, s, q);
        d3_interpolateSkew(a.skew, b.skew, s, q);
        d3_interpolateScale(a.scale, b.scale, s, q);
        a = b = null;
        return function (t) {
          var i = -1,
              n = q.length,
              o;
          while (++i < n) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        };
      }
      function d3_uninterpolateNumber(a, b) {
        b = (b -= a = +a) || 1 / b;
        return function (x) {
          return (x - a) / b;
        };
      }
      function d3_uninterpolateClamp(a, b) {
        b = (b -= a = +a) || 1 / b;
        return function (x) {
          return Math.max(0, Math.min(1, (x - a) / b));
        };
      }
      d3.layout = {};
      d3.layout.bundle = function () {
        return function (links) {
          var paths = [],
              i = -1,
              n = links.length;
          while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
          return paths;
        };
      };
      function d3_layout_bundlePath(link) {
        var start = link.source,
            end = link.target,
            lca = d3_layout_bundleLeastCommonAncestor(start, end),
            points = [start];
        while (start !== lca) {
          start = start.parent;
          points.push(start);
        }
        var k = points.length;
        while (end !== lca) {
          points.splice(k, 0, end);
          end = end.parent;
        }
        return points;
      }
      function d3_layout_bundleAncestors(node) {
        var ancestors = [],
            parent = node.parent;
        while (parent != null) {
          ancestors.push(node);
          node = parent;
          parent = parent.parent;
        }
        ancestors.push(node);
        return ancestors;
      }
      function d3_layout_bundleLeastCommonAncestor(a, b) {
        if (a === b) return a;
        var aNodes = d3_layout_bundleAncestors(a),
            bNodes = d3_layout_bundleAncestors(b),
            aNode = aNodes.pop(),
            bNode = bNodes.pop(),
            sharedNode = null;
        while (aNode === bNode) {
          sharedNode = aNode;
          aNode = aNodes.pop();
          bNode = bNodes.pop();
        }
        return sharedNode;
      }
      d3.layout.chord = function () {
        var chord = {},
            chords,
            groups,
            matrix,
            n,
            padding = 0,
            sortGroups,
            sortSubgroups,
            sortChords;
        function relayout() {
          var subgroups = {},
              groupSums = [],
              groupIndex = d3.range(n),
              subgroupIndex = [],
              k,
              x,
              x0,
              i,
              j;
          chords = [];
          groups = [];
          k = 0, i = -1;
          while (++i < n) {
            x = 0, j = -1;
            while (++j < n) {
              x += matrix[i][j];
            }
            groupSums.push(x);
            subgroupIndex.push(d3.range(n));
            k += x;
          }
          if (sortGroups) {
            groupIndex.sort(function (a, b) {
              return sortGroups(groupSums[a], groupSums[b]);
            });
          }
          if (sortSubgroups) {
            subgroupIndex.forEach(function (d, i) {
              d.sort(function (a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
              });
            });
          }
          k = (τ - padding * n) / k;
          x = 0, i = -1;
          while (++i < n) {
            x0 = x, j = -1;
            while (++j < n) {
              var di = groupIndex[i],
                  dj = subgroupIndex[di][j],
                  v = matrix[di][dj],
                  a0 = x,
                  a1 = x += v * k;
              subgroups[di + "-" + dj] = {
                index: di,
                subindex: dj,
                startAngle: a0,
                endAngle: a1,
                value: v
              };
            }
            groups[di] = {
              index: di,
              startAngle: x0,
              endAngle: x,
              value: groupSums[di]
            };
            x += padding;
          }
          i = -1;
          while (++i < n) {
            j = i - 1;
            while (++j < n) {
              var source = subgroups[i + "-" + j],
                  target = subgroups[j + "-" + i];
              if (source.value || target.value) {
                chords.push(source.value < target.value ? {
                  source: target,
                  target: source
                } : {
                  source: source,
                  target: target
                });
              }
            }
          }
          if (sortChords) resort();
        }
        function resort() {
          chords.sort(function (a, b) {
            return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
          });
        }
        chord.matrix = function (x) {
          if (!arguments.length) return matrix;
          n = (matrix = x) && matrix.length;
          chords = groups = null;
          return chord;
        };
        chord.padding = function (x) {
          if (!arguments.length) return padding;
          padding = x;
          chords = groups = null;
          return chord;
        };
        chord.sortGroups = function (x) {
          if (!arguments.length) return sortGroups;
          sortGroups = x;
          chords = groups = null;
          return chord;
        };
        chord.sortSubgroups = function (x) {
          if (!arguments.length) return sortSubgroups;
          sortSubgroups = x;
          chords = null;
          return chord;
        };
        chord.sortChords = function (x) {
          if (!arguments.length) return sortChords;
          sortChords = x;
          if (chords) resort();
          return chord;
        };
        chord.chords = function () {
          if (!chords) relayout();
          return chords;
        };
        chord.groups = function () {
          if (!groups) relayout();
          return groups;
        };
        return chord;
      };
      d3.layout.force = function () {
        var force = {},
            event = d3.dispatch("start", "tick", "end"),
            timer,
            size = [1, 1],
            drag,
            alpha,
            friction = .9,
            linkDistance = d3_layout_forceLinkDistance,
            linkStrength = d3_layout_forceLinkStrength,
            charge = -30,
            chargeDistance2 = d3_layout_forceChargeDistance2,
            gravity = .1,
            theta2 = .64,
            nodes = [],
            links = [],
            distances,
            strengths,
            charges;
        function repulse(node) {
          return function (quad, x1, _, x2) {
            if (quad.point !== node) {
              var dx = quad.cx - node.x,
                  dy = quad.cy - node.y,
                  dw = x2 - x1,
                  dn = dx * dx + dy * dy;
              if (dw * dw / theta2 < dn) {
                if (dn < chargeDistance2) {
                  var k = quad.charge / dn;
                  node.px -= dx * k;
                  node.py -= dy * k;
                }
                return true;
              }
              if (quad.point && dn && dn < chargeDistance2) {
                var k = quad.pointCharge / dn;
                node.px -= dx * k;
                node.py -= dy * k;
              }
            }
            return !quad.charge;
          };
        }
        force.tick = function () {
          if ((alpha *= .99) < .005) {
            timer = null;
            event.end({
              type: "end",
              alpha: alpha = 0
            });
            return true;
          }
          var n = nodes.length,
              m = links.length,
              q,
              i,
              o,
              s,
              t,
              l,
              k,
              x,
              y;
          for (i = 0; i < m; ++i) {
            o = links[i];
            s = o.source;
            t = o.target;
            x = t.x - s.x;
            y = t.y - s.y;
            if (l = x * x + y * y) {
              l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
              x *= l;
              y *= l;
              t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
              t.y -= y * k;
              s.x += x * (k = 1 - k);
              s.y += y * k;
            }
          }
          if (k = alpha * gravity) {
            x = size[0] / 2;
            y = size[1] / 2;
            i = -1;
            if (k) while (++i < n) {
              o = nodes[i];
              o.x += (x - o.x) * k;
              o.y += (y - o.y) * k;
            }
          }
          if (charge) {
            d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
            i = -1;
            while (++i < n) {
              if (!(o = nodes[i]).fixed) {
                q.visit(repulse(o));
              }
            }
          }
          i = -1;
          while (++i < n) {
            o = nodes[i];
            if (o.fixed) {
              o.x = o.px;
              o.y = o.py;
            } else {
              o.x -= (o.px - (o.px = o.x)) * friction;
              o.y -= (o.py - (o.py = o.y)) * friction;
            }
          }
          event.tick({
            type: "tick",
            alpha: alpha
          });
        };
        force.nodes = function (x) {
          if (!arguments.length) return nodes;
          nodes = x;
          return force;
        };
        force.links = function (x) {
          if (!arguments.length) return links;
          links = x;
          return force;
        };
        force.size = function (x) {
          if (!arguments.length) return size;
          size = x;
          return force;
        };
        force.linkDistance = function (x) {
          if (!arguments.length) return linkDistance;
          linkDistance = typeof x === "function" ? x : +x;
          return force;
        };
        force.distance = force.linkDistance;
        force.linkStrength = function (x) {
          if (!arguments.length) return linkStrength;
          linkStrength = typeof x === "function" ? x : +x;
          return force;
        };
        force.friction = function (x) {
          if (!arguments.length) return friction;
          friction = +x;
          return force;
        };
        force.charge = function (x) {
          if (!arguments.length) return charge;
          charge = typeof x === "function" ? x : +x;
          return force;
        };
        force.chargeDistance = function (x) {
          if (!arguments.length) return Math.sqrt(chargeDistance2);
          chargeDistance2 = x * x;
          return force;
        };
        force.gravity = function (x) {
          if (!arguments.length) return gravity;
          gravity = +x;
          return force;
        };
        force.theta = function (x) {
          if (!arguments.length) return Math.sqrt(theta2);
          theta2 = x * x;
          return force;
        };
        force.alpha = function (x) {
          if (!arguments.length) return alpha;
          x = +x;
          if (alpha) {
            if (x > 0) {
              alpha = x;
            } else {
              timer.c = null, timer.t = NaN, timer = null;
              event.end({
                type: "end",
                alpha: alpha = 0
              });
            }
          } else if (x > 0) {
            event.start({
              type: "start",
              alpha: alpha = x
            });
            timer = d3_timer(force.tick);
          }
          return force;
        };
        force.start = function () {
          var i,
              n = nodes.length,
              m = links.length,
              w = size[0],
              h = size[1],
              neighbors,
              o;
          for (i = 0; i < n; ++i) {
            (o = nodes[i]).index = i;
            o.weight = 0;
          }
          for (i = 0; i < m; ++i) {
            o = links[i];
            if (typeof o.source == "number") o.source = nodes[o.source];
            if (typeof o.target == "number") o.target = nodes[o.target];
            ++o.source.weight;
            ++o.target.weight;
          }
          for (i = 0; i < n; ++i) {
            o = nodes[i];
            if (isNaN(o.x)) o.x = position("x", w);
            if (isNaN(o.y)) o.y = position("y", h);
            if (isNaN(o.px)) o.px = o.x;
            if (isNaN(o.py)) o.py = o.y;
          }
          distances = [];
          if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i);else for (i = 0; i < m; ++i) distances[i] = linkDistance;
          strengths = [];
          if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i);else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
          charges = [];
          if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i);else for (i = 0; i < n; ++i) charges[i] = charge;
          function position(dimension, size) {
            if (!neighbors) {
              neighbors = new Array(n);
              for (j = 0; j < n; ++j) {
                neighbors[j] = [];
              }
              for (j = 0; j < m; ++j) {
                var o = links[j];
                neighbors[o.source.index].push(o.target);
                neighbors[o.target.index].push(o.source);
              }
            }
            var candidates = neighbors[i],
                j = -1,
                l = candidates.length,
                x;
            while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
            return Math.random() * size;
          }
          return force.resume();
        };
        force.resume = function () {
          return force.alpha(.1);
        };
        force.stop = function () {
          return force.alpha(0);
        };
        force.drag = function () {
          if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
          if (!arguments.length) return drag;
          this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
        };
        function dragmove(d) {
          d.px = d3.event.x, d.py = d3.event.y;
          force.resume();
        }
        return d3.rebind(force, event, "on");
      };
      function d3_layout_forceDragstart(d) {
        d.fixed |= 2;
      }
      function d3_layout_forceDragend(d) {
        d.fixed &= ~6;
      }
      function d3_layout_forceMouseover(d) {
        d.fixed |= 4;
        d.px = d.x, d.py = d.y;
      }
      function d3_layout_forceMouseout(d) {
        d.fixed &= ~4;
      }
      function d3_layout_forceAccumulate(quad, alpha, charges) {
        var cx = 0,
            cy = 0;
        quad.charge = 0;
        if (!quad.leaf) {
          var nodes = quad.nodes,
              n = nodes.length,
              i = -1,
              c;
          while (++i < n) {
            c = nodes[i];
            if (c == null) continue;
            d3_layout_forceAccumulate(c, alpha, charges);
            quad.charge += c.charge;
            cx += c.charge * c.cx;
            cy += c.charge * c.cy;
          }
        }
        if (quad.point) {
          if (!quad.leaf) {
            quad.point.x += Math.random() - .5;
            quad.point.y += Math.random() - .5;
          }
          var k = alpha * charges[quad.point.index];
          quad.charge += quad.pointCharge = k;
          cx += k * quad.point.x;
          cy += k * quad.point.y;
        }
        quad.cx = cx / quad.charge;
        quad.cy = cy / quad.charge;
      }
      var d3_layout_forceLinkDistance = 20,
          d3_layout_forceLinkStrength = 1,
          d3_layout_forceChargeDistance2 = Infinity;
      d3.layout.hierarchy = function () {
        var sort = d3_layout_hierarchySort,
            children = d3_layout_hierarchyChildren,
            value = d3_layout_hierarchyValue;
        function hierarchy(root) {
          var stack = [root],
              nodes = [],
              node;
          root.depth = 0;
          while ((node = stack.pop()) != null) {
            nodes.push(node);
            if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
              var n, childs, child;
              while (--n >= 0) {
                stack.push(child = childs[n]);
                child.parent = node;
                child.depth = node.depth + 1;
              }
              if (value) node.value = 0;
              node.children = childs;
            } else {
              if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
              delete node.children;
            }
          }
          d3_layout_hierarchyVisitAfter(root, function (node) {
            var childs, parent;
            if (sort && (childs = node.children)) childs.sort(sort);
            if (value && (parent = node.parent)) parent.value += node.value;
          });
          return nodes;
        }
        hierarchy.sort = function (x) {
          if (!arguments.length) return sort;
          sort = x;
          return hierarchy;
        };
        hierarchy.children = function (x) {
          if (!arguments.length) return children;
          children = x;
          return hierarchy;
        };
        hierarchy.value = function (x) {
          if (!arguments.length) return value;
          value = x;
          return hierarchy;
        };
        hierarchy.revalue = function (root) {
          if (value) {
            d3_layout_hierarchyVisitBefore(root, function (node) {
              if (node.children) node.value = 0;
            });
            d3_layout_hierarchyVisitAfter(root, function (node) {
              var parent;
              if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
              if (parent = node.parent) parent.value += node.value;
            });
          }
          return root;
        };
        return hierarchy;
      };
      function d3_layout_hierarchyRebind(object, hierarchy) {
        d3.rebind(object, hierarchy, "sort", "children", "value");
        object.nodes = object;
        object.links = d3_layout_hierarchyLinks;
        return object;
      }
      function d3_layout_hierarchyVisitBefore(node, callback) {
        var nodes = [node];
        while ((node = nodes.pop()) != null) {
          callback(node);
          if ((children = node.children) && (n = children.length)) {
            var n, children;
            while (--n >= 0) nodes.push(children[n]);
          }
        }
      }
      function d3_layout_hierarchyVisitAfter(node, callback) {
        var nodes = [node],
            nodes2 = [];
        while ((node = nodes.pop()) != null) {
          nodes2.push(node);
          if ((children = node.children) && (n = children.length)) {
            var i = -1,
                n,
                children;
            while (++i < n) nodes.push(children[i]);
          }
        }
        while ((node = nodes2.pop()) != null) {
          callback(node);
        }
      }
      function d3_layout_hierarchyChildren(d) {
        return d.children;
      }
      function d3_layout_hierarchyValue(d) {
        return d.value;
      }
      function d3_layout_hierarchySort(a, b) {
        return b.value - a.value;
      }
      function d3_layout_hierarchyLinks(nodes) {
        return d3.merge(nodes.map(function (parent) {
          return (parent.children || []).map(function (child) {
            return {
              source: parent,
              target: child
            };
          });
        }));
      }
      d3.layout.partition = function () {
        var hierarchy = d3.layout.hierarchy(),
            size = [1, 1];
        function position(node, x, dx, dy) {
          var children = node.children;
          node.x = x;
          node.y = node.depth * dy;
          node.dx = dx;
          node.dy = dy;
          if (children && (n = children.length)) {
            var i = -1,
                n,
                c,
                d;
            dx = node.value ? dx / node.value : 0;
            while (++i < n) {
              position(c = children[i], x, d = c.value * dx, dy);
              x += d;
            }
          }
        }
        function depth(node) {
          var children = node.children,
              d = 0;
          if (children && (n = children.length)) {
            var i = -1,
                n;
            while (++i < n) d = Math.max(d, depth(children[i]));
          }
          return 1 + d;
        }
        function partition(d, i) {
          var nodes = hierarchy.call(this, d, i);
          position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
          return nodes;
        }
        partition.size = function (x) {
          if (!arguments.length) return size;
          size = x;
          return partition;
        };
        return d3_layout_hierarchyRebind(partition, hierarchy);
      };
      d3.layout.pie = function () {
        var value = Number,
            sort = d3_layout_pieSortByValue,
            startAngle = 0,
            endAngle = τ,
            padAngle = 0;
        function pie(data) {
          var n = data.length,
              values = data.map(function (d, i) {
            return +value.call(pie, d, i);
          }),
              a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle),
              da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a,
              p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)),
              pa = p * (da < 0 ? -1 : 1),
              sum = d3.sum(values),
              k = sum ? (da - n * pa) / sum : 0,
              index = d3.range(n),
              arcs = [],
              v;
          if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function (i, j) {
            return values[j] - values[i];
          } : function (i, j) {
            return sort(data[i], data[j]);
          });
          index.forEach(function (i) {
            arcs[i] = {
              data: data[i],
              value: v = values[i],
              startAngle: a,
              endAngle: a += v * k + pa,
              padAngle: p
            };
          });
          return arcs;
        }
        pie.value = function (_) {
          if (!arguments.length) return value;
          value = _;
          return pie;
        };
        pie.sort = function (_) {
          if (!arguments.length) return sort;
          sort = _;
          return pie;
        };
        pie.startAngle = function (_) {
          if (!arguments.length) return startAngle;
          startAngle = _;
          return pie;
        };
        pie.endAngle = function (_) {
          if (!arguments.length) return endAngle;
          endAngle = _;
          return pie;
        };
        pie.padAngle = function (_) {
          if (!arguments.length) return padAngle;
          padAngle = _;
          return pie;
        };
        return pie;
      };
      var d3_layout_pieSortByValue = {};
      d3.layout.stack = function () {
        var values = d3_identity,
            order = d3_layout_stackOrderDefault,
            offset = d3_layout_stackOffsetZero,
            out = d3_layout_stackOut,
            x = d3_layout_stackX,
            y = d3_layout_stackY;
        function stack(data, index) {
          if (!(n = data.length)) return data;
          var series = data.map(function (d, i) {
            return values.call(stack, d, i);
          });
          var points = series.map(function (d) {
            return d.map(function (v, i) {
              return [x.call(stack, v, i), y.call(stack, v, i)];
            });
          });
          var orders = order.call(stack, points, index);
          series = d3.permute(series, orders);
          points = d3.permute(points, orders);
          var offsets = offset.call(stack, points, index);
          var m = series[0].length,
              n,
              i,
              j,
              o;
          for (j = 0; j < m; ++j) {
            out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
            for (i = 1; i < n; ++i) {
              out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
            }
          }
          return data;
        }
        stack.values = function (x) {
          if (!arguments.length) return values;
          values = x;
          return stack;
        };
        stack.order = function (x) {
          if (!arguments.length) return order;
          order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
          return stack;
        };
        stack.offset = function (x) {
          if (!arguments.length) return offset;
          offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
          return stack;
        };
        stack.x = function (z) {
          if (!arguments.length) return x;
          x = z;
          return stack;
        };
        stack.y = function (z) {
          if (!arguments.length) return y;
          y = z;
          return stack;
        };
        stack.out = function (z) {
          if (!arguments.length) return out;
          out = z;
          return stack;
        };
        return stack;
      };
      function d3_layout_stackX(d) {
        return d.x;
      }
      function d3_layout_stackY(d) {
        return d.y;
      }
      function d3_layout_stackOut(d, y0, y) {
        d.y0 = y0;
        d.y = y;
      }
      var d3_layout_stackOrders = d3.map({
        "inside-out": function (data) {
          var n = data.length,
              i,
              j,
              max = data.map(d3_layout_stackMaxIndex),
              sums = data.map(d3_layout_stackReduceSum),
              index = d3.range(n).sort(function (a, b) {
            return max[a] - max[b];
          }),
              top = 0,
              bottom = 0,
              tops = [],
              bottoms = [];
          for (i = 0; i < n; ++i) {
            j = index[i];
            if (top < bottom) {
              top += sums[j];
              tops.push(j);
            } else {
              bottom += sums[j];
              bottoms.push(j);
            }
          }
          return bottoms.reverse().concat(tops);
        },
        reverse: function (data) {
          return d3.range(data.length).reverse();
        },
        "default": d3_layout_stackOrderDefault
      });
      var d3_layout_stackOffsets = d3.map({
        silhouette: function (data) {
          var n = data.length,
              m = data[0].length,
              sums = [],
              max = 0,
              i,
              j,
              o,
              y0 = [];
          for (j = 0; j < m; ++j) {
            for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
            if (o > max) max = o;
            sums.push(o);
          }
          for (j = 0; j < m; ++j) {
            y0[j] = (max - sums[j]) / 2;
          }
          return y0;
        },
        wiggle: function (data) {
          var n = data.length,
              x = data[0],
              m = x.length,
              i,
              j,
              k,
              s1,
              s2,
              s3,
              dx,
              o,
              o0,
              y0 = [];
          y0[0] = o = o0 = 0;
          for (j = 1; j < m; ++j) {
            for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
            for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
              for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
                s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
              }
              s2 += s3 * data[i][j][1];
            }
            y0[j] = o -= s1 ? s2 / s1 * dx : 0;
            if (o < o0) o0 = o;
          }
          for (j = 0; j < m; ++j) y0[j] -= o0;
          return y0;
        },
        expand: function (data) {
          var n = data.length,
              m = data[0].length,
              k = 1 / n,
              i,
              j,
              o,
              y0 = [];
          for (j = 0; j < m; ++j) {
            for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
            if (o) for (i = 0; i < n; i++) data[i][j][1] /= o;else for (i = 0; i < n; i++) data[i][j][1] = k;
          }
          for (j = 0; j < m; ++j) y0[j] = 0;
          return y0;
        },
        zero: d3_layout_stackOffsetZero
      });
      function d3_layout_stackOrderDefault(data) {
        return d3.range(data.length);
      }
      function d3_layout_stackOffsetZero(data) {
        var j = -1,
            m = data[0].length,
            y0 = [];
        while (++j < m) y0[j] = 0;
        return y0;
      }
      function d3_layout_stackMaxIndex(array) {
        var i = 1,
            j = 0,
            v = array[0][1],
            k,
            n = array.length;
        for (; i < n; ++i) {
          if ((k = array[i][1]) > v) {
            j = i;
            v = k;
          }
        }
        return j;
      }
      function d3_layout_stackReduceSum(d) {
        return d.reduce(d3_layout_stackSum, 0);
      }
      function d3_layout_stackSum(p, d) {
        return p + d[1];
      }
      d3.layout.histogram = function () {
        var frequency = true,
            valuer = Number,
            ranger = d3_layout_histogramRange,
            binner = d3_layout_histogramBinSturges;
        function histogram(data, i) {
          var bins = [],
              values = data.map(valuer, this),
              range = ranger.call(this, values, i),
              thresholds = binner.call(this, range, values, i),
              bin,
              i = -1,
              n = values.length,
              m = thresholds.length - 1,
              k = frequency ? 1 : 1 / n,
              x;
          while (++i < m) {
            bin = bins[i] = [];
            bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
            bin.y = 0;
          }
          if (m > 0) {
            i = -1;
            while (++i < n) {
              x = values[i];
              if (x >= range[0] && x <= range[1]) {
                bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
                bin.y += k;
                bin.push(data[i]);
              }
            }
          }
          return bins;
        }
        histogram.value = function (x) {
          if (!arguments.length) return valuer;
          valuer = x;
          return histogram;
        };
        histogram.range = function (x) {
          if (!arguments.length) return ranger;
          ranger = d3_functor(x);
          return histogram;
        };
        histogram.bins = function (x) {
          if (!arguments.length) return binner;
          binner = typeof x === "number" ? function (range) {
            return d3_layout_histogramBinFixed(range, x);
          } : d3_functor(x);
          return histogram;
        };
        histogram.frequency = function (x) {
          if (!arguments.length) return frequency;
          frequency = !!x;
          return histogram;
        };
        return histogram;
      };
      function d3_layout_histogramBinSturges(range, values) {
        return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
      }
      function d3_layout_histogramBinFixed(range, n) {
        var x = -1,
            b = +range[0],
            m = (range[1] - b) / n,
            f = [];
        while (++x <= n) f[x] = m * x + b;
        return f;
      }
      function d3_layout_histogramRange(values) {
        return [d3.min(values), d3.max(values)];
      }
      d3.layout.pack = function () {
        var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort),
            padding = 0,
            size = [1, 1],
            radius;
        function pack(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root = nodes[0],
              w = size[0],
              h = size[1],
              r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function () {
            return radius;
          };
          root.x = root.y = 0;
          d3_layout_hierarchyVisitAfter(root, function (d) {
            d.r = +r(d.value);
          });
          d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
          if (padding) {
            var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
            d3_layout_hierarchyVisitAfter(root, function (d) {
              d.r += dr;
            });
            d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
            d3_layout_hierarchyVisitAfter(root, function (d) {
              d.r -= dr;
            });
          }
          d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
          return nodes;
        }
        pack.size = function (_) {
          if (!arguments.length) return size;
          size = _;
          return pack;
        };
        pack.radius = function (_) {
          if (!arguments.length) return radius;
          radius = _ == null || typeof _ === "function" ? _ : +_;
          return pack;
        };
        pack.padding = function (_) {
          if (!arguments.length) return padding;
          padding = +_;
          return pack;
        };
        return d3_layout_hierarchyRebind(pack, hierarchy);
      };
      function d3_layout_packSort(a, b) {
        return a.value - b.value;
      }
      function d3_layout_packInsert(a, b) {
        var c = a._pack_next;
        a._pack_next = b;
        b._pack_prev = a;
        b._pack_next = c;
        c._pack_prev = b;
      }
      function d3_layout_packSplice(a, b) {
        a._pack_next = b;
        b._pack_prev = a;
      }
      function d3_layout_packIntersects(a, b) {
        var dx = b.x - a.x,
            dy = b.y - a.y,
            dr = a.r + b.r;
        return .999 * dr * dr > dx * dx + dy * dy;
      }
      function d3_layout_packSiblings(node) {
        if (!(nodes = node.children) || !(n = nodes.length)) return;
        var nodes,
            xMin = Infinity,
            xMax = -Infinity,
            yMin = Infinity,
            yMax = -Infinity,
            a,
            b,
            c,
            i,
            j,
            k,
            n;
        function bound(node) {
          xMin = Math.min(node.x - node.r, xMin);
          xMax = Math.max(node.x + node.r, xMax);
          yMin = Math.min(node.y - node.r, yMin);
          yMax = Math.max(node.y + node.r, yMax);
        }
        nodes.forEach(d3_layout_packLink);
        a = nodes[0];
        a.x = -a.r;
        a.y = 0;
        bound(a);
        if (n > 1) {
          b = nodes[1];
          b.x = b.r;
          b.y = 0;
          bound(b);
          if (n > 2) {
            c = nodes[2];
            d3_layout_packPlace(a, b, c);
            bound(c);
            d3_layout_packInsert(a, c);
            a._pack_prev = c;
            d3_layout_packInsert(c, b);
            b = a._pack_next;
            for (i = 3; i < n; i++) {
              d3_layout_packPlace(a, b, c = nodes[i]);
              var isect = 0,
                  s1 = 1,
                  s2 = 1;
              for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
                if (d3_layout_packIntersects(j, c)) {
                  isect = 1;
                  break;
                }
              }
              if (isect == 1) {
                for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
                  if (d3_layout_packIntersects(k, c)) {
                    break;
                  }
                }
              }
              if (isect) {
                if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j);else d3_layout_packSplice(a = k, b);
                i--;
              } else {
                d3_layout_packInsert(a, c);
                b = c;
                bound(c);
              }
            }
          }
        }
        var cx = (xMin + xMax) / 2,
            cy = (yMin + yMax) / 2,
            cr = 0;
        for (i = 0; i < n; i++) {
          c = nodes[i];
          c.x -= cx;
          c.y -= cy;
          cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
        }
        node.r = cr;
        nodes.forEach(d3_layout_packUnlink);
      }
      function d3_layout_packLink(node) {
        node._pack_next = node._pack_prev = node;
      }
      function d3_layout_packUnlink(node) {
        delete node._pack_next;
        delete node._pack_prev;
      }
      function d3_layout_packTransform(node, x, y, k) {
        var children = node.children;
        node.x = x += k * node.x;
        node.y = y += k * node.y;
        node.r *= k;
        if (children) {
          var i = -1,
              n = children.length;
          while (++i < n) d3_layout_packTransform(children[i], x, y, k);
        }
      }
      function d3_layout_packPlace(a, b, c) {
        var db = a.r + c.r,
            dx = b.x - a.x,
            dy = b.y - a.y;
        if (db && (dx || dy)) {
          var da = b.r + c.r,
              dc = dx * dx + dy * dy;
          da *= da;
          db *= db;
          var x = .5 + (db - da) / (2 * dc),
              y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
          c.x = a.x + x * dx + y * dy;
          c.y = a.y + x * dy - y * dx;
        } else {
          c.x = a.x + db;
          c.y = a.y;
        }
      }
      d3.layout.tree = function () {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null),
            separation = d3_layout_treeSeparation,
            size = [1, 1],
            nodeSize = null;
        function tree(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root0 = nodes[0],
              root1 = wrapTree(root0);
          d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
          d3_layout_hierarchyVisitBefore(root1, secondWalk);
          if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode);else {
            var left = root0,
                right = root0,
                bottom = root0;
            d3_layout_hierarchyVisitBefore(root0, function (node) {
              if (node.x < left.x) left = node;
              if (node.x > right.x) right = node;
              if (node.depth > bottom.depth) bottom = node;
            });
            var tx = separation(left, right) / 2 - left.x,
                kx = size[0] / (right.x + separation(right, left) / 2 + tx),
                ky = size[1] / (bottom.depth || 1);
            d3_layout_hierarchyVisitBefore(root0, function (node) {
              node.x = (node.x + tx) * kx;
              node.y = node.depth * ky;
            });
          }
          return nodes;
        }
        function wrapTree(root0) {
          var root1 = {
            A: null,
            children: [root0]
          },
              queue = [root1],
              node1;
          while ((node1 = queue.pop()) != null) {
            for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
              queue.push((children[i] = child = {
                _: children[i],
                parent: node1,
                children: (child = children[i].children) && child.slice() || [],
                A: null,
                a: null,
                z: 0,
                m: 0,
                c: 0,
                s: 0,
                t: null,
                i: i
              }).a = child);
            }
          }
          return root1.children[0];
        }
        function firstWalk(v) {
          var children = v.children,
              siblings = v.parent.children,
              w = v.i ? siblings[v.i - 1] : null;
          if (children.length) {
            d3_layout_treeShift(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
              v.z = w.z + separation(v._, w._);
              v.m = v.z - midpoint;
            } else {
              v.z = midpoint;
            }
          } else if (w) {
            v.z = w.z + separation(v._, w._);
          }
          v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        function secondWalk(v) {
          v._.x = v.z + v.parent.m;
          v.m += v.parent.m;
        }
        function apportion(v, w, ancestor) {
          if (w) {
            var vip = v,
                vop = v,
                vim = w,
                vom = vip.parent.children[0],
                sip = vip.m,
                sop = vop.m,
                sim = vim.m,
                som = vom.m,
                shift;
            while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
              vom = d3_layout_treeLeft(vom);
              vop = d3_layout_treeRight(vop);
              vop.a = v;
              shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
              if (shift > 0) {
                d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
                sip += shift;
                sop += shift;
              }
              sim += vim.m;
              sip += vip.m;
              som += vom.m;
              sop += vop.m;
            }
            if (vim && !d3_layout_treeRight(vop)) {
              vop.t = vim;
              vop.m += sim - sop;
            }
            if (vip && !d3_layout_treeLeft(vom)) {
              vom.t = vip;
              vom.m += sip - som;
              ancestor = v;
            }
          }
          return ancestor;
        }
        function sizeNode(node) {
          node.x *= size[0];
          node.y = node.depth * size[1];
        }
        tree.separation = function (x) {
          if (!arguments.length) return separation;
          separation = x;
          return tree;
        };
        tree.size = function (x) {
          if (!arguments.length) return nodeSize ? null : size;
          nodeSize = (size = x) == null ? sizeNode : null;
          return tree;
        };
        tree.nodeSize = function (x) {
          if (!arguments.length) return nodeSize ? size : null;
          nodeSize = (size = x) == null ? null : sizeNode;
          return tree;
        };
        return d3_layout_hierarchyRebind(tree, hierarchy);
      };
      function d3_layout_treeSeparation(a, b) {
        return a.parent == b.parent ? 1 : 2;
      }
      function d3_layout_treeLeft(v) {
        var children = v.children;
        return children.length ? children[0] : v.t;
      }
      function d3_layout_treeRight(v) {
        var children = v.children,
            n;
        return (n = children.length) ? children[n - 1] : v.t;
      }
      function d3_layout_treeMove(wm, wp, shift) {
        var change = shift / (wp.i - wm.i);
        wp.c -= change;
        wp.s += shift;
        wm.c += change;
        wp.z += shift;
        wp.m += shift;
      }
      function d3_layout_treeShift(v) {
        var shift = 0,
            change = 0,
            children = v.children,
            i = children.length,
            w;
        while (--i >= 0) {
          w = children[i];
          w.z += shift;
          w.m += shift;
          shift += w.s + (change += w.c);
        }
      }
      function d3_layout_treeAncestor(vim, v, ancestor) {
        return vim.a.parent === v.parent ? vim.a : ancestor;
      }
      d3.layout.cluster = function () {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null),
            separation = d3_layout_treeSeparation,
            size = [1, 1],
            nodeSize = false;
        function cluster(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root = nodes[0],
              previousNode,
              x = 0;
          d3_layout_hierarchyVisitAfter(root, function (node) {
            var children = node.children;
            if (children && children.length) {
              node.x = d3_layout_clusterX(children);
              node.y = d3_layout_clusterY(children);
            } else {
              node.x = previousNode ? x += separation(node, previousNode) : 0;
              node.y = 0;
              previousNode = node;
            }
          });
          var left = d3_layout_clusterLeft(root),
              right = d3_layout_clusterRight(root),
              x0 = left.x - separation(left, right) / 2,
              x1 = right.x + separation(right, left) / 2;
          d3_layout_hierarchyVisitAfter(root, nodeSize ? function (node) {
            node.x = (node.x - root.x) * size[0];
            node.y = (root.y - node.y) * size[1];
          } : function (node) {
            node.x = (node.x - x0) / (x1 - x0) * size[0];
            node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
          });
          return nodes;
        }
        cluster.separation = function (x) {
          if (!arguments.length) return separation;
          separation = x;
          return cluster;
        };
        cluster.size = function (x) {
          if (!arguments.length) return nodeSize ? null : size;
          nodeSize = (size = x) == null;
          return cluster;
        };
        cluster.nodeSize = function (x) {
          if (!arguments.length) return nodeSize ? size : null;
          nodeSize = (size = x) != null;
          return cluster;
        };
        return d3_layout_hierarchyRebind(cluster, hierarchy);
      };
      function d3_layout_clusterY(children) {
        return 1 + d3.max(children, function (child) {
          return child.y;
        });
      }
      function d3_layout_clusterX(children) {
        return children.reduce(function (x, child) {
          return x + child.x;
        }, 0) / children.length;
      }
      function d3_layout_clusterLeft(node) {
        var children = node.children;
        return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
      }
      function d3_layout_clusterRight(node) {
        var children = node.children,
            n;
        return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
      }
      d3.layout.treemap = function () {
        var hierarchy = d3.layout.hierarchy(),
            round = Math.round,
            size = [1, 1],
            padding = null,
            pad = d3_layout_treemapPadNull,
            sticky = false,
            stickies,
            mode = "squarify",
            ratio = .5 * (1 + Math.sqrt(5));
        function scale(children, k) {
          var i = -1,
              n = children.length,
              child,
              area;
          while (++i < n) {
            area = (child = children[i]).value * (k < 0 ? 0 : k);
            child.area = isNaN(area) || area <= 0 ? 0 : area;
          }
        }
        function squarify(node) {
          var children = node.children;
          if (children && children.length) {
            var rect = pad(node),
                row = [],
                remaining = children.slice(),
                child,
                best = Infinity,
                score,
                u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy),
                n;
            scale(remaining, rect.dx * rect.dy / node.value);
            row.area = 0;
            while ((n = remaining.length) > 0) {
              row.push(child = remaining[n - 1]);
              row.area += child.area;
              if (mode !== "squarify" || (score = worst(row, u)) <= best) {
                remaining.pop();
                best = score;
              } else {
                row.area -= row.pop().area;
                position(row, u, rect, false);
                u = Math.min(rect.dx, rect.dy);
                row.length = row.area = 0;
                best = Infinity;
              }
            }
            if (row.length) {
              position(row, u, rect, true);
              row.length = row.area = 0;
            }
            children.forEach(squarify);
          }
        }
        function stickify(node) {
          var children = node.children;
          if (children && children.length) {
            var rect = pad(node),
                remaining = children.slice(),
                child,
                row = [];
            scale(remaining, rect.dx * rect.dy / node.value);
            row.area = 0;
            while (child = remaining.pop()) {
              row.push(child);
              row.area += child.area;
              if (child.z != null) {
                position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
                row.length = row.area = 0;
              }
            }
            children.forEach(stickify);
          }
        }
        function worst(row, u) {
          var s = row.area,
              r,
              rmax = 0,
              rmin = Infinity,
              i = -1,
              n = row.length;
          while (++i < n) {
            if (!(r = row[i].area)) continue;
            if (r < rmin) rmin = r;
            if (r > rmax) rmax = r;
          }
          s *= s;
          u *= u;
          return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
        }
        function position(row, u, rect, flush) {
          var i = -1,
              n = row.length,
              x = rect.x,
              y = rect.y,
              v = u ? round(row.area / u) : 0,
              o;
          if (u == rect.dx) {
            if (flush || v > rect.dy) v = rect.dy;
            while (++i < n) {
              o = row[i];
              o.x = x;
              o.y = y;
              o.dy = v;
              x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
            }
            o.z = true;
            o.dx += rect.x + rect.dx - x;
            rect.y += v;
            rect.dy -= v;
          } else {
            if (flush || v > rect.dx) v = rect.dx;
            while (++i < n) {
              o = row[i];
              o.x = x;
              o.y = y;
              o.dx = v;
              y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
            }
            o.z = false;
            o.dy += rect.y + rect.dy - y;
            rect.x += v;
            rect.dx -= v;
          }
        }
        function treemap(d) {
          var nodes = stickies || hierarchy(d),
              root = nodes[0];
          root.x = root.y = 0;
          if (root.value) root.dx = size[0], root.dy = size[1];else root.dx = root.dy = 0;
          if (stickies) hierarchy.revalue(root);
          scale([root], root.dx * root.dy / root.value);
          (stickies ? stickify : squarify)(root);
          if (sticky) stickies = nodes;
          return nodes;
        }
        treemap.size = function (x) {
          if (!arguments.length) return size;
          size = x;
          return treemap;
        };
        treemap.padding = function (x) {
          if (!arguments.length) return padding;
          function padFunction(node) {
            var p = x.call(treemap, node, node.depth);
            return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [p, p, p, p] : p);
          }
          function padConstant(node) {
            return d3_layout_treemapPad(node, x);
          }
          var type;
          pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [x, x, x, x], padConstant) : padConstant;
          return treemap;
        };
        treemap.round = function (x) {
          if (!arguments.length) return round != Number;
          round = x ? Math.round : Number;
          return treemap;
        };
        treemap.sticky = function (x) {
          if (!arguments.length) return sticky;
          sticky = x;
          stickies = null;
          return treemap;
        };
        treemap.ratio = function (x) {
          if (!arguments.length) return ratio;
          ratio = x;
          return treemap;
        };
        treemap.mode = function (x) {
          if (!arguments.length) return mode;
          mode = x + "";
          return treemap;
        };
        return d3_layout_hierarchyRebind(treemap, hierarchy);
      };
      function d3_layout_treemapPadNull(node) {
        return {
          x: node.x,
          y: node.y,
          dx: node.dx,
          dy: node.dy
        };
      }
      function d3_layout_treemapPad(node, padding) {
        var x = node.x + padding[3],
            y = node.y + padding[0],
            dx = node.dx - padding[1] - padding[3],
            dy = node.dy - padding[0] - padding[2];
        if (dx < 0) {
          x += dx / 2;
          dx = 0;
        }
        if (dy < 0) {
          y += dy / 2;
          dy = 0;
        }
        return {
          x: x,
          y: y,
          dx: dx,
          dy: dy
        };
      }
      d3.random = {
        normal: function (µ, σ) {
          var n = arguments.length;
          if (n < 2) σ = 1;
          if (n < 1) µ = 0;
          return function () {
            var x, y, r;
            do {
              x = Math.random() * 2 - 1;
              y = Math.random() * 2 - 1;
              r = x * x + y * y;
            } while (!r || r > 1);
            return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
          };
        },
        logNormal: function () {
          var random = d3.random.normal.apply(d3, arguments);
          return function () {
            return Math.exp(random());
          };
        },
        bates: function (m) {
          var random = d3.random.irwinHall(m);
          return function () {
            return random() / m;
          };
        },
        irwinHall: function (m) {
          return function () {
            for (var s = 0, j = 0; j < m; j++) s += Math.random();
            return s;
          };
        }
      };
      d3.scale = {};
      function d3_scaleExtent(domain) {
        var start = domain[0],
            stop = domain[domain.length - 1];
        return start < stop ? [start, stop] : [stop, start];
      }
      function d3_scaleRange(scale) {
        return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
      }
      function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
        var u = uninterpolate(domain[0], domain[1]),
            i = interpolate(range[0], range[1]);
        return function (x) {
          return i(u(x));
        };
      }
      function d3_scale_nice(domain, nice) {
        var i0 = 0,
            i1 = domain.length - 1,
            x0 = domain[i0],
            x1 = domain[i1],
            dx;
        if (x1 < x0) {
          dx = i0, i0 = i1, i1 = dx;
          dx = x0, x0 = x1, x1 = dx;
        }
        domain[i0] = nice.floor(x0);
        domain[i1] = nice.ceil(x1);
        return domain;
      }
      function d3_scale_niceStep(step) {
        return step ? {
          floor: function (x) {
            return Math.floor(x / step) * step;
          },
          ceil: function (x) {
            return Math.ceil(x / step) * step;
          }
        } : d3_scale_niceIdentity;
      }
      var d3_scale_niceIdentity = {
        floor: d3_identity,
        ceil: d3_identity
      };
      function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
        var u = [],
            i = [],
            j = 0,
            k = Math.min(domain.length, range.length) - 1;
        if (domain[k] < domain[0]) {
          domain = domain.slice().reverse();
          range = range.slice().reverse();
        }
        while (++j <= k) {
          u.push(uninterpolate(domain[j - 1], domain[j]));
          i.push(interpolate(range[j - 1], range[j]));
        }
        return function (x) {
          var j = d3.bisect(domain, x, 1, k) - 1;
          return i[j](u[j](x));
        };
      }
      d3.scale.linear = function () {
        return d3_scale_linear([0, 1], [0, 1], d3_interpolate, false);
      };
      function d3_scale_linear(domain, range, interpolate, clamp) {
        var output, input;
        function rescale() {
          var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear,
              uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
          output = linear(domain, range, uninterpolate, interpolate);
          input = linear(range, domain, uninterpolate, d3_interpolate);
          return scale;
        }
        function scale(x) {
          return output(x);
        }
        scale.invert = function (y) {
          return input(y);
        };
        scale.domain = function (x) {
          if (!arguments.length) return domain;
          domain = x.map(Number);
          return rescale();
        };
        scale.range = function (x) {
          if (!arguments.length) return range;
          range = x;
          return rescale();
        };
        scale.rangeRound = function (x) {
          return scale.range(x).interpolate(d3_interpolateRound);
        };
        scale.clamp = function (x) {
          if (!arguments.length) return clamp;
          clamp = x;
          return rescale();
        };
        scale.interpolate = function (x) {
          if (!arguments.length) return interpolate;
          interpolate = x;
          return rescale();
        };
        scale.ticks = function (m) {
          return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function (m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function (m) {
          d3_scale_linearNice(domain, m);
          return rescale();
        };
        scale.copy = function () {
          return d3_scale_linear(domain, range, interpolate, clamp);
        };
        return rescale();
      }
      function d3_scale_linearRebind(scale, linear) {
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
      }
      function d3_scale_linearNice(domain, m) {
        d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
        d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
        return domain;
      }
      function d3_scale_linearTickRange(domain, m) {
        if (m == null) m = 10;
        var extent = d3_scaleExtent(domain),
            span = extent[1] - extent[0],
            step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)),
            err = m / span * step;
        if (err <= .15) step *= 10;else if (err <= .35) step *= 5;else if (err <= .75) step *= 2;
        extent[0] = Math.ceil(extent[0] / step) * step;
        extent[1] = Math.floor(extent[1] / step) * step + step * .5;
        extent[2] = step;
        return extent;
      }
      function d3_scale_linearTicks(domain, m) {
        return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
      }
      function d3_scale_linearTickFormat(domain, m, format) {
        var range = d3_scale_linearTickRange(domain, m);
        if (format) {
          var match = d3_format_re.exec(format);
          match.shift();
          if (match[8] === "s") {
            var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
            if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
            match[8] = "f";
            format = d3.format(match.join(""));
            return function (d) {
              return format(prefix.scale(d)) + prefix.symbol;
            };
          }
          if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
          format = match.join("");
        } else {
          format = ",." + d3_scale_linearPrecision(range[2]) + "f";
        }
        return d3.format(format);
      }
      var d3_scale_linearFormatSignificant = {
        s: 1,
        g: 1,
        p: 1,
        r: 1,
        e: 1
      };
      function d3_scale_linearPrecision(value) {
        return -Math.floor(Math.log(value) / Math.LN10 + .01);
      }
      function d3_scale_linearFormatPrecision(type, range) {
        var p = d3_scale_linearPrecision(range[2]);
        return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
      }
      d3.scale.log = function () {
        return d3_scale_log(d3.scale.linear().domain([0, 1]), 10, true, [1, 10]);
      };
      function d3_scale_log(linear, base, positive, domain) {
        function log(x) {
          return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
        }
        function pow(x) {
          return positive ? Math.pow(base, x) : -Math.pow(base, -x);
        }
        function scale(x) {
          return linear(log(x));
        }
        scale.invert = function (x) {
          return pow(linear.invert(x));
        };
        scale.domain = function (x) {
          if (!arguments.length) return domain;
          positive = x[0] >= 0;
          linear.domain((domain = x.map(Number)).map(log));
          return scale;
        };
        scale.base = function (_) {
          if (!arguments.length) return base;
          base = +_;
          linear.domain(domain.map(log));
          return scale;
        };
        scale.nice = function () {
          var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
          linear.domain(niced);
          domain = niced.map(pow);
          return scale;
        };
        scale.ticks = function () {
          var extent = d3_scaleExtent(domain),
              ticks = [],
              u = extent[0],
              v = extent[1],
              i = Math.floor(log(u)),
              j = Math.ceil(log(v)),
              n = base % 1 ? 2 : base;
          if (isFinite(j - i)) {
            if (positive) {
              for (; i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
              ticks.push(pow(i));
            } else {
              ticks.push(pow(i));
              for (; i++ < j;) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
            }
            for (i = 0; ticks[i] < u; i++) {}
            for (j = ticks.length; ticks[j - 1] > v; j--) {}
            ticks = ticks.slice(i, j);
          }
          return ticks;
        };
        scale.tickFormat = function (n, format) {
          if (!arguments.length) return d3_scale_logFormat;
          if (arguments.length < 2) format = d3_scale_logFormat;else if (typeof format !== "function") format = d3.format(format);
          var k = Math.max(1, base * n / scale.ticks().length);
          return function (d) {
            var i = d / pow(Math.round(log(d)));
            if (i * base < base - .5) i *= base;
            return i <= k ? format(d) : "";
          };
        };
        scale.copy = function () {
          return d3_scale_log(linear.copy(), base, positive, domain);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      var d3_scale_logFormat = d3.format(".0e"),
          d3_scale_logNiceNegative = {
        floor: function (x) {
          return -Math.ceil(-x);
        },
        ceil: function (x) {
          return -Math.floor(-x);
        }
      };
      d3.scale.pow = function () {
        return d3_scale_pow(d3.scale.linear(), 1, [0, 1]);
      };
      function d3_scale_pow(linear, exponent, domain) {
        var powp = d3_scale_powPow(exponent),
            powb = d3_scale_powPow(1 / exponent);
        function scale(x) {
          return linear(powp(x));
        }
        scale.invert = function (x) {
          return powb(linear.invert(x));
        };
        scale.domain = function (x) {
          if (!arguments.length) return domain;
          linear.domain((domain = x.map(Number)).map(powp));
          return scale;
        };
        scale.ticks = function (m) {
          return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function (m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function (m) {
          return scale.domain(d3_scale_linearNice(domain, m));
        };
        scale.exponent = function (x) {
          if (!arguments.length) return exponent;
          powp = d3_scale_powPow(exponent = x);
          powb = d3_scale_powPow(1 / exponent);
          linear.domain(domain.map(powp));
          return scale;
        };
        scale.copy = function () {
          return d3_scale_pow(linear.copy(), exponent, domain);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      function d3_scale_powPow(e) {
        return function (x) {
          return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
        };
      }
      d3.scale.sqrt = function () {
        return d3.scale.pow().exponent(.5);
      };
      d3.scale.ordinal = function () {
        return d3_scale_ordinal([], {
          t: "range",
          a: [[]]
        });
      };
      function d3_scale_ordinal(domain, ranger) {
        var index, range, rangeBand;
        function scale(x) {
          return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
        }
        function steps(start, step) {
          return d3.range(domain.length).map(function (i) {
            return start + step * i;
          });
        }
        scale.domain = function (x) {
          if (!arguments.length) return domain;
          domain = [];
          index = new d3_Map();
          var i = -1,
              n = x.length,
              xi;
          while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
          return scale[ranger.t].apply(scale, ranger.a);
        };
        scale.range = function (x) {
          if (!arguments.length) return range;
          range = x;
          rangeBand = 0;
          ranger = {
            t: "range",
            a: arguments
          };
          return scale;
        };
        scale.rangePoints = function (x, padding) {
          if (arguments.length < 2) padding = 0;
          var start = x[0],
              stop = x[1],
              step = domain.length < 2 ? (start = (start + stop) / 2, 0) : (stop - start) / (domain.length - 1 + padding);
          range = steps(start + step * padding / 2, step);
          rangeBand = 0;
          ranger = {
            t: "rangePoints",
            a: arguments
          };
          return scale;
        };
        scale.rangeRoundPoints = function (x, padding) {
          if (arguments.length < 2) padding = 0;
          var start = x[0],
              stop = x[1],
              step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 0) : (stop - start) / (domain.length - 1 + padding) | 0;
          range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
          rangeBand = 0;
          ranger = {
            t: "rangeRoundPoints",
            a: arguments
          };
          return scale;
        };
        scale.rangeBands = function (x, padding, outerPadding) {
          if (arguments.length < 2) padding = 0;
          if (arguments.length < 3) outerPadding = padding;
          var reverse = x[1] < x[0],
              start = x[reverse - 0],
              stop = x[1 - reverse],
              step = (stop - start) / (domain.length - padding + 2 * outerPadding);
          range = steps(start + step * outerPadding, step);
          if (reverse) range.reverse();
          rangeBand = step * (1 - padding);
          ranger = {
            t: "rangeBands",
            a: arguments
          };
          return scale;
        };
        scale.rangeRoundBands = function (x, padding, outerPadding) {
          if (arguments.length < 2) padding = 0;
          if (arguments.length < 3) outerPadding = padding;
          var reverse = x[1] < x[0],
              start = x[reverse - 0],
              stop = x[1 - reverse],
              step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
          range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
          if (reverse) range.reverse();
          rangeBand = Math.round(step * (1 - padding));
          ranger = {
            t: "rangeRoundBands",
            a: arguments
          };
          return scale;
        };
        scale.rangeBand = function () {
          return rangeBand;
        };
        scale.rangeExtent = function () {
          return d3_scaleExtent(ranger.a[0]);
        };
        scale.copy = function () {
          return d3_scale_ordinal(domain, ranger);
        };
        return scale.domain(domain);
      }
      d3.scale.category10 = function () {
        return d3.scale.ordinal().range(d3_category10);
      };
      d3.scale.category20 = function () {
        return d3.scale.ordinal().range(d3_category20);
      };
      d3.scale.category20b = function () {
        return d3.scale.ordinal().range(d3_category20b);
      };
      d3.scale.category20c = function () {
        return d3.scale.ordinal().range(d3_category20c);
      };
      var d3_category10 = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(d3_rgbString);
      var d3_category20 = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(d3_rgbString);
      var d3_category20b = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(d3_rgbString);
      var d3_category20c = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(d3_rgbString);
      d3.scale.quantile = function () {
        return d3_scale_quantile([], []);
      };
      function d3_scale_quantile(domain, range) {
        var thresholds;
        function rescale() {
          var k = 0,
              q = range.length;
          thresholds = [];
          while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
          return scale;
        }
        function scale(x) {
          if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
        }
        scale.domain = function (x) {
          if (!arguments.length) return domain;
          domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
          return rescale();
        };
        scale.range = function (x) {
          if (!arguments.length) return range;
          range = x;
          return rescale();
        };
        scale.quantiles = function () {
          return thresholds;
        };
        scale.invertExtent = function (y) {
          y = range.indexOf(y);
          return y < 0 ? [NaN, NaN] : [y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1]];
        };
        scale.copy = function () {
          return d3_scale_quantile(domain, range);
        };
        return rescale();
      }
      d3.scale.quantize = function () {
        return d3_scale_quantize(0, 1, [0, 1]);
      };
      function d3_scale_quantize(x0, x1, range) {
        var kx, i;
        function scale(x) {
          return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
        }
        function rescale() {
          kx = range.length / (x1 - x0);
          i = range.length - 1;
          return scale;
        }
        scale.domain = function (x) {
          if (!arguments.length) return [x0, x1];
          x0 = +x[0];
          x1 = +x[x.length - 1];
          return rescale();
        };
        scale.range = function (x) {
          if (!arguments.length) return range;
          range = x;
          return rescale();
        };
        scale.invertExtent = function (y) {
          y = range.indexOf(y);
          y = y < 0 ? NaN : y / kx + x0;
          return [y, y + 1 / kx];
        };
        scale.copy = function () {
          return d3_scale_quantize(x0, x1, range);
        };
        return rescale();
      }
      d3.scale.threshold = function () {
        return d3_scale_threshold([.5], [0, 1]);
      };
      function d3_scale_threshold(domain, range) {
        function scale(x) {
          if (x <= x) return range[d3.bisect(domain, x)];
        }
        scale.domain = function (_) {
          if (!arguments.length) return domain;
          domain = _;
          return scale;
        };
        scale.range = function (_) {
          if (!arguments.length) return range;
          range = _;
          return scale;
        };
        scale.invertExtent = function (y) {
          y = range.indexOf(y);
          return [domain[y - 1], domain[y]];
        };
        scale.copy = function () {
          return d3_scale_threshold(domain, range);
        };
        return scale;
      }
      d3.scale.identity = function () {
        return d3_scale_identity([0, 1]);
      };
      function d3_scale_identity(domain) {
        function identity(x) {
          return +x;
        }
        identity.invert = identity;
        identity.domain = identity.range = function (x) {
          if (!arguments.length) return domain;
          domain = x.map(identity);
          return identity;
        };
        identity.ticks = function (m) {
          return d3_scale_linearTicks(domain, m);
        };
        identity.tickFormat = function (m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        identity.copy = function () {
          return d3_scale_identity(domain);
        };
        return identity;
      }
      d3.svg = {};
      function d3_zero() {
        return 0;
      }
      d3.svg.arc = function () {
        var innerRadius = d3_svg_arcInnerRadius,
            outerRadius = d3_svg_arcOuterRadius,
            cornerRadius = d3_zero,
            padRadius = d3_svg_arcAuto,
            startAngle = d3_svg_arcStartAngle,
            endAngle = d3_svg_arcEndAngle,
            padAngle = d3_svg_arcPadAngle;
        function arc() {
          var r0 = Math.max(0, +innerRadius.apply(this, arguments)),
              r1 = Math.max(0, +outerRadius.apply(this, arguments)),
              a0 = startAngle.apply(this, arguments) - halfπ,
              a1 = endAngle.apply(this, arguments) - halfπ,
              da = Math.abs(a1 - a0),
              cw = a0 > a1 ? 0 : 1;
          if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
          if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
          var rc,
              cr,
              rp,
              ap,
              p0 = 0,
              p1 = 0,
              x0,
              y0,
              x1,
              y1,
              x2,
              y2,
              x3,
              y3,
              path = [];
          if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
            rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
            if (!cw) p1 *= -1;
            if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
            if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
          }
          if (r1) {
            x0 = r1 * Math.cos(a0 + p1);
            y0 = r1 * Math.sin(a0 + p1);
            x1 = r1 * Math.cos(a1 - p1);
            y1 = r1 * Math.sin(a1 - p1);
            var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
            if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
              var h1 = (a0 + a1) / 2;
              x0 = r1 * Math.cos(h1);
              y0 = r1 * Math.sin(h1);
              x1 = y1 = null;
            }
          } else {
            x0 = y0 = 0;
          }
          if (r0) {
            x2 = r0 * Math.cos(a1 - p0);
            y2 = r0 * Math.sin(a1 - p0);
            x3 = r0 * Math.cos(a0 + p0);
            y3 = r0 * Math.sin(a0 + p0);
            var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
            if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
              var h0 = (a0 + a1) / 2;
              x2 = r0 * Math.cos(h0);
              y2 = r0 * Math.sin(h0);
              x3 = y3 = null;
            }
          } else {
            x2 = y2 = 0;
          }
          if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
            cr = r0 < r1 ^ cw ? 0 : 1;
            var rc1 = rc,
                rc0 = rc;
            if (da < π) {
              var oc = x3 == null ? [x2, y2] : x1 == null ? [x0, y0] : d3_geom_polygonIntersect([x0, y0], [x3, y3], [x1, y1], [x2, y2]),
                  ax = x0 - oc[0],
                  ay = y0 - oc[1],
                  bx = x1 - oc[0],
                  by = y1 - oc[1],
                  kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
                  lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
              rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
              rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
            }
            if (x1 != null) {
              var t30 = d3_svg_arcCornerTangents(x3 == null ? [x2, y2] : [x3, y3], [x0, y0], r1, rc1, cw),
                  t12 = d3_svg_arcCornerTangents([x1, y1], [x2, y2], r1, rc1, cw);
              if (rc === rc1) {
                path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
              } else {
                path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
              }
            } else {
              path.push("M", x0, ",", y0);
            }
            if (x3 != null) {
              var t03 = d3_svg_arcCornerTangents([x0, y0], [x3, y3], r0, -rc0, cw),
                  t21 = d3_svg_arcCornerTangents([x2, y2], x1 == null ? [x0, y0] : [x1, y1], r0, -rc0, cw);
              if (rc === rc0) {
                path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
              } else {
                path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
              }
            } else {
              path.push("L", x2, ",", y2);
            }
          } else {
            path.push("M", x0, ",", y0);
            if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
            path.push("L", x2, ",", y2);
            if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
          }
          path.push("Z");
          return path.join("");
        }
        function circleSegment(r1, cw) {
          return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
        }
        arc.innerRadius = function (v) {
          if (!arguments.length) return innerRadius;
          innerRadius = d3_functor(v);
          return arc;
        };
        arc.outerRadius = function (v) {
          if (!arguments.length) return outerRadius;
          outerRadius = d3_functor(v);
          return arc;
        };
        arc.cornerRadius = function (v) {
          if (!arguments.length) return cornerRadius;
          cornerRadius = d3_functor(v);
          return arc;
        };
        arc.padRadius = function (v) {
          if (!arguments.length) return padRadius;
          padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
          return arc;
        };
        arc.startAngle = function (v) {
          if (!arguments.length) return startAngle;
          startAngle = d3_functor(v);
          return arc;
        };
        arc.endAngle = function (v) {
          if (!arguments.length) return endAngle;
          endAngle = d3_functor(v);
          return arc;
        };
        arc.padAngle = function (v) {
          if (!arguments.length) return padAngle;
          padAngle = d3_functor(v);
          return arc;
        };
        arc.centroid = function () {
          var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
              a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
          return [Math.cos(a) * r, Math.sin(a) * r];
        };
        return arc;
      };
      var d3_svg_arcAuto = "auto";
      function d3_svg_arcInnerRadius(d) {
        return d.innerRadius;
      }
      function d3_svg_arcOuterRadius(d) {
        return d.outerRadius;
      }
      function d3_svg_arcStartAngle(d) {
        return d.startAngle;
      }
      function d3_svg_arcEndAngle(d) {
        return d.endAngle;
      }
      function d3_svg_arcPadAngle(d) {
        return d && d.padAngle;
      }
      function d3_svg_arcSweep(x0, y0, x1, y1) {
        return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
      }
      function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
        var x01 = p0[0] - p1[0],
            y01 = p0[1] - p1[1],
            lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
            ox = lo * y01,
            oy = -lo * x01,
            x1 = p0[0] + ox,
            y1 = p0[1] + oy,
            x2 = p1[0] + ox,
            y2 = p1[1] + oy,
            x3 = (x1 + x2) / 2,
            y3 = (y1 + y2) / 2,
            dx = x2 - x1,
            dy = y2 - y1,
            d2 = dx * dx + dy * dy,
            r = r1 - rc,
            D = x1 * y2 - x2 * y1,
            d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
            cx0 = (D * dy - dx * d) / d2,
            cy0 = (-D * dx - dy * d) / d2,
            cx1 = (D * dy + dx * d) / d2,
            cy1 = (-D * dx + dy * d) / d2,
            dx0 = cx0 - x3,
            dy0 = cy0 - y3,
            dx1 = cx1 - x3,
            dy1 = cy1 - y3;
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
        return [[cx0 - ox, cy0 - oy], [cx0 * r1 / r, cy0 * r1 / r]];
      }
      function d3_svg_line(projection) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            defined = d3_true,
            interpolate = d3_svg_lineLinear,
            interpolateKey = interpolate.key,
            tension = .7;
        function line(data) {
          var segments = [],
              points = [],
              i = -1,
              n = data.length,
              d,
              fx = d3_functor(x),
              fy = d3_functor(y);
          function segment() {
            segments.push("M", interpolate(projection(points), tension));
          }
          while (++i < n) {
            if (defined.call(this, d = data[i], i)) {
              points.push([+fx.call(this, d, i), +fy.call(this, d, i)]);
            } else if (points.length) {
              segment();
              points = [];
            }
          }
          if (points.length) segment();
          return segments.length ? segments.join("") : null;
        }
        line.x = function (_) {
          if (!arguments.length) return x;
          x = _;
          return line;
        };
        line.y = function (_) {
          if (!arguments.length) return y;
          y = _;
          return line;
        };
        line.defined = function (_) {
          if (!arguments.length) return defined;
          defined = _;
          return line;
        };
        line.interpolate = function (_) {
          if (!arguments.length) return interpolateKey;
          if (typeof _ === "function") interpolateKey = interpolate = _;else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
          return line;
        };
        line.tension = function (_) {
          if (!arguments.length) return tension;
          tension = _;
          return line;
        };
        return line;
      }
      d3.svg.line = function () {
        return d3_svg_line(d3_identity);
      };
      var d3_svg_lineInterpolators = d3.map({
        linear: d3_svg_lineLinear,
        "linear-closed": d3_svg_lineLinearClosed,
        step: d3_svg_lineStep,
        "step-before": d3_svg_lineStepBefore,
        "step-after": d3_svg_lineStepAfter,
        basis: d3_svg_lineBasis,
        "basis-open": d3_svg_lineBasisOpen,
        "basis-closed": d3_svg_lineBasisClosed,
        bundle: d3_svg_lineBundle,
        cardinal: d3_svg_lineCardinal,
        "cardinal-open": d3_svg_lineCardinalOpen,
        "cardinal-closed": d3_svg_lineCardinalClosed,
        monotone: d3_svg_lineMonotone
      });
      d3_svg_lineInterpolators.forEach(function (key, value) {
        value.key = key;
        value.closed = /-closed$/.test(key);
      });
      function d3_svg_lineLinear(points) {
        return points.length > 1 ? points.join("L") : points + "Z";
      }
      function d3_svg_lineLinearClosed(points) {
        return points.join("L") + "Z";
      }
      function d3_svg_lineStep(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
        if (n > 1) path.push("H", p[0]);
        return path.join("");
      }
      function d3_svg_lineStepBefore(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
        return path.join("");
      }
      function d3_svg_lineStepAfter(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
        return path.join("");
      }
      function d3_svg_lineCardinalOpen(points, tension) {
        return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
      }
      function d3_svg_lineCardinalClosed(points, tension) {
        return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([points[points.length - 2]].concat(points, [points[1]]), tension));
      }
      function d3_svg_lineCardinal(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
      }
      function d3_svg_lineHermite(points, tangents) {
        if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
          return d3_svg_lineLinear(points);
        }
        var quad = points.length != tangents.length,
            path = "",
            p0 = points[0],
            p = points[1],
            t0 = tangents[0],
            t = t0,
            pi = 1;
        if (quad) {
          path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
          p0 = points[1];
          pi = 2;
        }
        if (tangents.length > 1) {
          t = tangents[1];
          p = points[pi];
          pi++;
          path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
          for (var i = 2; i < tangents.length; i++, pi++) {
            p = points[pi];
            t = tangents[i];
            path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
          }
        }
        if (quad) {
          var lp = points[pi];
          path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
        }
        return path;
      }
      function d3_svg_lineCardinalTangents(points, tension) {
        var tangents = [],
            a = (1 - tension) / 2,
            p0,
            p1 = points[0],
            p2 = points[1],
            i = 1,
            n = points.length;
        while (++i < n) {
          p0 = p1;
          p1 = p2;
          p2 = points[i];
          tangents.push([a * (p2[0] - p0[0]), a * (p2[1] - p0[1])]);
        }
        return tangents;
      }
      function d3_svg_lineBasis(points) {
        if (points.length < 3) return d3_svg_lineLinear(points);
        var i = 1,
            n = points.length,
            pi = points[0],
            x0 = pi[0],
            y0 = pi[1],
            px = [x0, x0, x0, (pi = points[1])[0]],
            py = [y0, y0, y0, pi[1]],
            path = [x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
        points.push(points[n - 1]);
        while (++i <= n) {
          pi = points[i];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        points.pop();
        path.push("L", pi);
        return path.join("");
      }
      function d3_svg_lineBasisOpen(points) {
        if (points.length < 4) return d3_svg_lineLinear(points);
        var path = [],
            i = -1,
            n = points.length,
            pi,
            px = [0],
            py = [0];
        while (++i < 3) {
          pi = points[i];
          px.push(pi[0]);
          py.push(pi[1]);
        }
        path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
        --i;
        while (++i < n) {
          pi = points[i];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
      }
      function d3_svg_lineBasisClosed(points) {
        var path,
            i = -1,
            n = points.length,
            m = n + 4,
            pi,
            px = [],
            py = [];
        while (++i < 4) {
          pi = points[i % n];
          px.push(pi[0]);
          py.push(pi[1]);
        }
        path = [d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
        --i;
        while (++i < m) {
          pi = points[i % n];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
      }
      function d3_svg_lineBundle(points, tension) {
        var n = points.length - 1;
        if (n) {
          var x0 = points[0][0],
              y0 = points[0][1],
              dx = points[n][0] - x0,
              dy = points[n][1] - y0,
              i = -1,
              p,
              t;
          while (++i <= n) {
            p = points[i];
            t = i / n;
            p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
            p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
          }
        }
        return d3_svg_lineBasis(points);
      }
      function d3_svg_lineDot4(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
      }
      var d3_svg_lineBasisBezier1 = [0, 2 / 3, 1 / 3, 0],
          d3_svg_lineBasisBezier2 = [0, 1 / 3, 2 / 3, 0],
          d3_svg_lineBasisBezier3 = [0, 1 / 6, 2 / 3, 1 / 6];
      function d3_svg_lineBasisBezier(path, x, y) {
        path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
      }
      function d3_svg_lineSlope(p0, p1) {
        return (p1[1] - p0[1]) / (p1[0] - p0[0]);
      }
      function d3_svg_lineFiniteDifferences(points) {
        var i = 0,
            j = points.length - 1,
            m = [],
            p0 = points[0],
            p1 = points[1],
            d = m[0] = d3_svg_lineSlope(p0, p1);
        while (++i < j) {
          m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
        }
        m[i] = d;
        return m;
      }
      function d3_svg_lineMonotoneTangents(points) {
        var tangents = [],
            d,
            a,
            b,
            s,
            m = d3_svg_lineFiniteDifferences(points),
            i = -1,
            j = points.length - 1;
        while (++i < j) {
          d = d3_svg_lineSlope(points[i], points[i + 1]);
          if (abs(d) < ε) {
            m[i] = m[i + 1] = 0;
          } else {
            a = m[i] / d;
            b = m[i + 1] / d;
            s = a * a + b * b;
            if (s > 9) {
              s = d * 3 / Math.sqrt(s);
              m[i] = s * a;
              m[i + 1] = s * b;
            }
          }
        }
        i = -1;
        while (++i <= j) {
          s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
          tangents.push([s || 0, m[i] * s || 0]);
        }
        return tangents;
      }
      function d3_svg_lineMonotone(points) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
      }
      d3.svg.line.radial = function () {
        var line = d3_svg_line(d3_svg_lineRadial);
        line.radius = line.x, delete line.x;
        line.angle = line.y, delete line.y;
        return line;
      };
      function d3_svg_lineRadial(points) {
        var point,
            i = -1,
            n = points.length,
            r,
            a;
        while (++i < n) {
          point = points[i];
          r = point[0];
          a = point[1] - halfπ;
          point[0] = r * Math.cos(a);
          point[1] = r * Math.sin(a);
        }
        return points;
      }
      function d3_svg_area(projection) {
        var x0 = d3_geom_pointX,
            x1 = d3_geom_pointX,
            y0 = 0,
            y1 = d3_geom_pointY,
            defined = d3_true,
            interpolate = d3_svg_lineLinear,
            interpolateKey = interpolate.key,
            interpolateReverse = interpolate,
            L = "L",
            tension = .7;
        function area(data) {
          var segments = [],
              points0 = [],
              points1 = [],
              i = -1,
              n = data.length,
              d,
              fx0 = d3_functor(x0),
              fy0 = d3_functor(y0),
              fx1 = x0 === x1 ? function () {
            return x;
          } : d3_functor(x1),
              fy1 = y0 === y1 ? function () {
            return y;
          } : d3_functor(y1),
              x,
              y;
          function segment() {
            segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
          }
          while (++i < n) {
            if (defined.call(this, d = data[i], i)) {
              points0.push([x = +fx0.call(this, d, i), y = +fy0.call(this, d, i)]);
              points1.push([+fx1.call(this, d, i), +fy1.call(this, d, i)]);
            } else if (points0.length) {
              segment();
              points0 = [];
              points1 = [];
            }
          }
          if (points0.length) segment();
          return segments.length ? segments.join("") : null;
        }
        area.x = function (_) {
          if (!arguments.length) return x1;
          x0 = x1 = _;
          return area;
        };
        area.x0 = function (_) {
          if (!arguments.length) return x0;
          x0 = _;
          return area;
        };
        area.x1 = function (_) {
          if (!arguments.length) return x1;
          x1 = _;
          return area;
        };
        area.y = function (_) {
          if (!arguments.length) return y1;
          y0 = y1 = _;
          return area;
        };
        area.y0 = function (_) {
          if (!arguments.length) return y0;
          y0 = _;
          return area;
        };
        area.y1 = function (_) {
          if (!arguments.length) return y1;
          y1 = _;
          return area;
        };
        area.defined = function (_) {
          if (!arguments.length) return defined;
          defined = _;
          return area;
        };
        area.interpolate = function (_) {
          if (!arguments.length) return interpolateKey;
          if (typeof _ === "function") interpolateKey = interpolate = _;else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
          interpolateReverse = interpolate.reverse || interpolate;
          L = interpolate.closed ? "M" : "L";
          return area;
        };
        area.tension = function (_) {
          if (!arguments.length) return tension;
          tension = _;
          return area;
        };
        return area;
      }
      d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
      d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
      d3.svg.area = function () {
        return d3_svg_area(d3_identity);
      };
      d3.svg.area.radial = function () {
        var area = d3_svg_area(d3_svg_lineRadial);
        area.radius = area.x, delete area.x;
        area.innerRadius = area.x0, delete area.x0;
        area.outerRadius = area.x1, delete area.x1;
        area.angle = area.y, delete area.y;
        area.startAngle = area.y0, delete area.y0;
        area.endAngle = area.y1, delete area.y1;
        return area;
      };
      d3.svg.chord = function () {
        var source = d3_source,
            target = d3_target,
            radius = d3_svg_chordRadius,
            startAngle = d3_svg_arcStartAngle,
            endAngle = d3_svg_arcEndAngle;
        function chord(d, i) {
          var s = subgroup(this, source, d, i),
              t = subgroup(this, target, d, i);
          return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
        }
        function subgroup(self, f, d, i) {
          var subgroup = f.call(self, d, i),
              r = radius.call(self, subgroup, i),
              a0 = startAngle.call(self, subgroup, i) - halfπ,
              a1 = endAngle.call(self, subgroup, i) - halfπ;
          return {
            r: r,
            a0: a0,
            a1: a1,
            p0: [r * Math.cos(a0), r * Math.sin(a0)],
            p1: [r * Math.cos(a1), r * Math.sin(a1)]
          };
        }
        function equals(a, b) {
          return a.a0 == b.a0 && a.a1 == b.a1;
        }
        function arc(r, p, a) {
          return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
        }
        function curve(r0, p0, r1, p1) {
          return "Q 0,0 " + p1;
        }
        chord.radius = function (v) {
          if (!arguments.length) return radius;
          radius = d3_functor(v);
          return chord;
        };
        chord.source = function (v) {
          if (!arguments.length) return source;
          source = d3_functor(v);
          return chord;
        };
        chord.target = function (v) {
          if (!arguments.length) return target;
          target = d3_functor(v);
          return chord;
        };
        chord.startAngle = function (v) {
          if (!arguments.length) return startAngle;
          startAngle = d3_functor(v);
          return chord;
        };
        chord.endAngle = function (v) {
          if (!arguments.length) return endAngle;
          endAngle = d3_functor(v);
          return chord;
        };
        return chord;
      };
      function d3_svg_chordRadius(d) {
        return d.radius;
      }
      d3.svg.diagonal = function () {
        var source = d3_source,
            target = d3_target,
            projection = d3_svg_diagonalProjection;
        function diagonal(d, i) {
          var p0 = source.call(this, d, i),
              p3 = target.call(this, d, i),
              m = (p0.y + p3.y) / 2,
              p = [p0, {
            x: p0.x,
            y: m
          }, {
            x: p3.x,
            y: m
          }, p3];
          p = p.map(projection);
          return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
        }
        diagonal.source = function (x) {
          if (!arguments.length) return source;
          source = d3_functor(x);
          return diagonal;
        };
        diagonal.target = function (x) {
          if (!arguments.length) return target;
          target = d3_functor(x);
          return diagonal;
        };
        diagonal.projection = function (x) {
          if (!arguments.length) return projection;
          projection = x;
          return diagonal;
        };
        return diagonal;
      };
      function d3_svg_diagonalProjection(d) {
        return [d.x, d.y];
      }
      d3.svg.diagonal.radial = function () {
        var diagonal = d3.svg.diagonal(),
            projection = d3_svg_diagonalProjection,
            projection_ = diagonal.projection;
        diagonal.projection = function (x) {
          return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
        };
        return diagonal;
      };
      function d3_svg_diagonalRadialProjection(projection) {
        return function () {
          var d = projection.apply(this, arguments),
              r = d[0],
              a = d[1] - halfπ;
          return [r * Math.cos(a), r * Math.sin(a)];
        };
      }
      d3.svg.symbol = function () {
        var type = d3_svg_symbolType,
            size = d3_svg_symbolSize;
        function symbol(d, i) {
          return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
        }
        symbol.type = function (x) {
          if (!arguments.length) return type;
          type = d3_functor(x);
          return symbol;
        };
        symbol.size = function (x) {
          if (!arguments.length) return size;
          size = d3_functor(x);
          return symbol;
        };
        return symbol;
      };
      function d3_svg_symbolSize() {
        return 64;
      }
      function d3_svg_symbolType() {
        return "circle";
      }
      function d3_svg_symbolCircle(size) {
        var r = Math.sqrt(size / π);
        return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
      }
      var d3_svg_symbols = d3.map({
        circle: d3_svg_symbolCircle,
        cross: function (size) {
          var r = Math.sqrt(size / 5) / 2;
          return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
        },
        diamond: function (size) {
          var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)),
              rx = ry * d3_svg_symbolTan30;
          return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
        },
        square: function (size) {
          var r = Math.sqrt(size) / 2;
          return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
        },
        "triangle-down": function (size) {
          var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
              ry = rx * d3_svg_symbolSqrt3 / 2;
          return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
        },
        "triangle-up": function (size) {
          var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
              ry = rx * d3_svg_symbolSqrt3 / 2;
          return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
        }
      });
      d3.svg.symbolTypes = d3_svg_symbols.keys();
      var d3_svg_symbolSqrt3 = Math.sqrt(3),
          d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
      d3_selectionPrototype.transition = function (name) {
        var id = d3_transitionInheritId || ++d3_transitionId,
            ns = d3_transitionNamespace(name),
            subgroups = [],
            subgroup,
            node,
            transition = d3_transitionInherit || {
          time: Date.now(),
          ease: d3_ease_cubicInOut,
          delay: 0,
          duration: 250
        };
        for (var j = -1, m = this.length; ++j < m;) {
          subgroups.push(subgroup = []);
          for (var group = this[j], i = -1, n = group.length; ++i < n;) {
            if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
            subgroup.push(node);
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_selectionPrototype.interrupt = function (name) {
        return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
      };
      var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
      function d3_selection_interruptNS(ns) {
        return function () {
          var lock, activeId, active;
          if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
            active.timer.c = null;
            active.timer.t = NaN;
            if (--lock.count) delete lock[activeId];else delete this[ns];
            lock.active += .5;
            active.event && active.event.interrupt.call(this, this.__data__, active.index);
          }
        };
      }
      function d3_transition(groups, ns, id) {
        d3_subclass(groups, d3_transitionPrototype);
        groups.namespace = ns;
        groups.id = id;
        return groups;
      }
      var d3_transitionPrototype = [],
          d3_transitionId = 0,
          d3_transitionInheritId,
          d3_transitionInherit;
      d3_transitionPrototype.call = d3_selectionPrototype.call;
      d3_transitionPrototype.empty = d3_selectionPrototype.empty;
      d3_transitionPrototype.node = d3_selectionPrototype.node;
      d3_transitionPrototype.size = d3_selectionPrototype.size;
      d3.transition = function (selection, name) {
        return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
      };
      d3.transition.prototype = d3_transitionPrototype;
      d3_transitionPrototype.select = function (selector) {
        var id = this.id,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            subnode,
            node;
        selector = d3_selection_selector(selector);
        for (var j = -1, m = this.length; ++j < m;) {
          subgroups.push(subgroup = []);
          for (var group = this[j], i = -1, n = group.length; ++i < n;) {
            if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
              if ("__data__" in node) subnode.__data__ = node.__data__;
              d3_transitionNode(subnode, i, ns, id, node[ns][id]);
              subgroup.push(subnode);
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_transitionPrototype.selectAll = function (selector) {
        var id = this.id,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            subnodes,
            node,
            subnode,
            transition;
        selector = d3_selection_selectorAll(selector);
        for (var j = -1, m = this.length; ++j < m;) {
          for (var group = this[j], i = -1, n = group.length; ++i < n;) {
            if (node = group[i]) {
              transition = node[ns][id];
              subnodes = selector.call(node, node.__data__, i, j);
              subgroups.push(subgroup = []);
              for (var k = -1, o = subnodes.length; ++k < o;) {
                if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
                subgroup.push(subnode);
              }
            }
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_transitionPrototype.filter = function (filter) {
        var subgroups = [],
            subgroup,
            group,
            node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for (var j = 0, m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          for (var group = this[j], i = 0, n = group.length; i < n; i++) {
            if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
              subgroup.push(node);
            }
          }
        }
        return d3_transition(subgroups, this.namespace, this.id);
      };
      d3_transitionPrototype.tween = function (name, tween) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
        return d3_selection_each(this, tween == null ? function (node) {
          node[ns][id].tween.remove(name);
        } : function (node) {
          node[ns][id].tween.set(name, tween);
        });
      };
      function d3_transition_tween(groups, name, value, tween) {
        var id = groups.id,
            ns = groups.namespace;
        return d3_selection_each(groups, typeof value === "function" ? function (node, i, j) {
          node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
        } : (value = tween(value), function (node) {
          node[ns][id].tween.set(name, value);
        }));
      }
      d3_transitionPrototype.attr = function (nameNS, value) {
        if (arguments.length < 2) {
          for (value in nameNS) this.attr(value, nameNS[value]);
          return this;
        }
        var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate,
            name = d3.ns.qualify(nameNS);
        function attrNull() {
          this.removeAttribute(name);
        }
        function attrNullNS() {
          this.removeAttributeNS(name.space, name.local);
        }
        function attrTween(b) {
          return b == null ? attrNull : (b += "", function () {
            var a = this.getAttribute(name),
                i;
            return a !== b && (i = interpolate(a, b), function (t) {
              this.setAttribute(name, i(t));
            });
          });
        }
        function attrTweenNS(b) {
          return b == null ? attrNullNS : (b += "", function () {
            var a = this.getAttributeNS(name.space, name.local),
                i;
            return a !== b && (i = interpolate(a, b), function (t) {
              this.setAttributeNS(name.space, name.local, i(t));
            });
          });
        }
        return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
      };
      d3_transitionPrototype.attrTween = function (nameNS, tween) {
        var name = d3.ns.qualify(nameNS);
        function attrTween(d, i) {
          var f = tween.call(this, d, i, this.getAttribute(name));
          return f && function (t) {
            this.setAttribute(name, f(t));
          };
        }
        function attrTweenNS(d, i) {
          var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
          return f && function (t) {
            this.setAttributeNS(name.space, name.local, f(t));
          };
        }
        return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
      };
      d3_transitionPrototype.style = function (name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof name !== "string") {
            if (n < 2) value = "";
            for (priority in name) this.style(priority, name[priority], value);
            return this;
          }
          priority = "";
        }
        function styleNull() {
          this.style.removeProperty(name);
        }
        function styleString(b) {
          return b == null ? styleNull : (b += "", function () {
            var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name),
                i;
            return a !== b && (i = d3_interpolate(a, b), function (t) {
              this.style.setProperty(name, i(t), priority);
            });
          });
        }
        return d3_transition_tween(this, "style." + name, value, styleString);
      };
      d3_transitionPrototype.styleTween = function (name, tween, priority) {
        if (arguments.length < 3) priority = "";
        function styleTween(d, i) {
          var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
          return f && function (t) {
            this.style.setProperty(name, f(t), priority);
          };
        }
        return this.tween("style." + name, styleTween);
      };
      d3_transitionPrototype.text = function (value) {
        return d3_transition_tween(this, "text", value, d3_transition_text);
      };
      function d3_transition_text(b) {
        if (b == null) b = "";
        return function () {
          this.textContent = b;
        };
      }
      d3_transitionPrototype.remove = function () {
        var ns = this.namespace;
        return this.each("end.transition", function () {
          var p;
          if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
        });
      };
      d3_transitionPrototype.ease = function (value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1) return this.node()[ns][id].ease;
        if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
        return d3_selection_each(this, function (node) {
          node[ns][id].ease = value;
        });
      };
      d3_transitionPrototype.delay = function (value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1) return this.node()[ns][id].delay;
        return d3_selection_each(this, typeof value === "function" ? function (node, i, j) {
          node[ns][id].delay = +value.call(node, node.__data__, i, j);
        } : (value = +value, function (node) {
          node[ns][id].delay = value;
        }));
      };
      d3_transitionPrototype.duration = function (value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1) return this.node()[ns][id].duration;
        return d3_selection_each(this, typeof value === "function" ? function (node, i, j) {
          node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
        } : (value = Math.max(1, value), function (node) {
          node[ns][id].duration = value;
        }));
      };
      d3_transitionPrototype.each = function (type, listener) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 2) {
          var inherit = d3_transitionInherit,
              inheritId = d3_transitionInheritId;
          try {
            d3_transitionInheritId = id;
            d3_selection_each(this, function (node, i, j) {
              d3_transitionInherit = node[ns][id];
              type.call(node, node.__data__, i, j);
            });
          } finally {
            d3_transitionInherit = inherit;
            d3_transitionInheritId = inheritId;
          }
        } else {
          d3_selection_each(this, function (node) {
            var transition = node[ns][id];
            (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
          });
        }
        return this;
      };
      d3_transitionPrototype.transition = function () {
        var id0 = this.id,
            id1 = ++d3_transitionId,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            group,
            node,
            transition;
        for (var j = 0, m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          for (var group = this[j], i = 0, n = group.length; i < n; i++) {
            if (node = group[i]) {
              transition = node[ns][id0];
              d3_transitionNode(node, i, ns, id1, {
                time: transition.time,
                ease: transition.ease,
                delay: transition.delay + transition.duration,
                duration: transition.duration
              });
            }
            subgroup.push(node);
          }
        }
        return d3_transition(subgroups, ns, id1);
      };
      function d3_transitionNamespace(name) {
        return name == null ? "__transition__" : "__transition_" + name + "__";
      }
      function d3_transitionNode(node, i, ns, id, inherit) {
        var lock = node[ns] || (node[ns] = {
          active: 0,
          count: 0
        }),
            transition = lock[id],
            time,
            timer,
            duration,
            ease,
            tweens;
        function schedule(elapsed) {
          var delay = transition.delay;
          timer.t = delay + time;
          if (delay <= elapsed) return start(elapsed - delay);
          timer.c = start;
        }
        function start(elapsed) {
          var activeId = lock.active,
              active = lock[activeId];
          if (active) {
            active.timer.c = null;
            active.timer.t = NaN;
            --lock.count;
            delete lock[activeId];
            active.event && active.event.interrupt.call(node, node.__data__, active.index);
          }
          for (var cancelId in lock) {
            if (+cancelId < id) {
              var cancel = lock[cancelId];
              cancel.timer.c = null;
              cancel.timer.t = NaN;
              --lock.count;
              delete lock[cancelId];
            }
          }
          timer.c = tick;
          d3_timer(function () {
            if (timer.c && tick(elapsed || 1)) {
              timer.c = null;
              timer.t = NaN;
            }
            return 1;
          }, 0, time);
          lock.active = id;
          transition.event && transition.event.start.call(node, node.__data__, i);
          tweens = [];
          transition.tween.forEach(function (key, value) {
            if (value = value.call(node, node.__data__, i)) {
              tweens.push(value);
            }
          });
          ease = transition.ease;
          duration = transition.duration;
        }
        function tick(elapsed) {
          var t = elapsed / duration,
              e = ease(t),
              n = tweens.length;
          while (n > 0) {
            tweens[--n].call(node, e);
          }
          if (t >= 1) {
            transition.event && transition.event.end.call(node, node.__data__, i);
            if (--lock.count) delete lock[id];else delete node[ns];
            return 1;
          }
        }
        if (!transition) {
          time = inherit.time;
          timer = d3_timer(schedule, 0, time);
          transition = lock[id] = {
            tween: new d3_Map(),
            time: time,
            timer: timer,
            delay: inherit.delay,
            duration: inherit.duration,
            ease: inherit.ease,
            index: i
          };
          inherit = null;
          ++lock.count;
        }
      }
      d3.svg.axis = function () {
        var scale = d3.scale.linear(),
            orient = d3_svg_axisDefaultOrient,
            innerTickSize = 6,
            outerTickSize = 6,
            tickPadding = 3,
            tickArguments_ = [10],
            tickValues = null,
            tickFormat_;
        function axis(g) {
          g.each(function () {
            var g = d3.select(this);
            var scale0 = this.__chart__ || scale,
                scale1 = this.__chart__ = scale.copy();
            var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues,
                tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_,
                tick = g.selectAll(".tick").data(ticks, scale1),
                tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε),
                tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(),
                tickUpdate = d3.transition(tick.order()).style("opacity", 1),
                tickSpacing = Math.max(innerTickSize, 0) + tickPadding,
                tickTransform;
            var range = d3_scaleRange(scale1),
                path = g.selectAll(".domain").data([0]),
                pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
            tickEnter.append("line");
            tickEnter.append("text");
            var lineEnter = tickEnter.select("line"),
                lineUpdate = tickUpdate.select("line"),
                text = tick.select("text").text(tickFormat),
                textEnter = tickEnter.select("text"),
                textUpdate = tickUpdate.select("text"),
                sign = orient === "top" || orient === "left" ? -1 : 1,
                x1,
                x2,
                y1,
                y2;
            if (orient === "bottom" || orient === "top") {
              tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
              text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
              pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
            } else {
              tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
              text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
              pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
            }
            lineEnter.attr(y2, sign * innerTickSize);
            textEnter.attr(y1, sign * tickSpacing);
            lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
            textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
            if (scale1.rangeBand) {
              var x = scale1,
                  dx = x.rangeBand() / 2;
              scale0 = scale1 = function (d) {
                return x(d) + dx;
              };
            } else if (scale0.rangeBand) {
              scale0 = scale1;
            } else {
              tickExit.call(tickTransform, scale1, scale0);
            }
            tickEnter.call(tickTransform, scale0, scale1);
            tickUpdate.call(tickTransform, scale1, scale1);
          });
        }
        axis.scale = function (x) {
          if (!arguments.length) return scale;
          scale = x;
          return axis;
        };
        axis.orient = function (x) {
          if (!arguments.length) return orient;
          orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
          return axis;
        };
        axis.ticks = function () {
          if (!arguments.length) return tickArguments_;
          tickArguments_ = d3_array(arguments);
          return axis;
        };
        axis.tickValues = function (x) {
          if (!arguments.length) return tickValues;
          tickValues = x;
          return axis;
        };
        axis.tickFormat = function (x) {
          if (!arguments.length) return tickFormat_;
          tickFormat_ = x;
          return axis;
        };
        axis.tickSize = function (x) {
          var n = arguments.length;
          if (!n) return innerTickSize;
          innerTickSize = +x;
          outerTickSize = +arguments[n - 1];
          return axis;
        };
        axis.innerTickSize = function (x) {
          if (!arguments.length) return innerTickSize;
          innerTickSize = +x;
          return axis;
        };
        axis.outerTickSize = function (x) {
          if (!arguments.length) return outerTickSize;
          outerTickSize = +x;
          return axis;
        };
        axis.tickPadding = function (x) {
          if (!arguments.length) return tickPadding;
          tickPadding = +x;
          return axis;
        };
        axis.tickSubdivide = function () {
          return arguments.length && axis;
        };
        return axis;
      };
      var d3_svg_axisDefaultOrient = "bottom",
          d3_svg_axisOrients = {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
      };
      function d3_svg_axisX(selection, x0, x1) {
        selection.attr("transform", function (d) {
          var v0 = x0(d);
          return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
        });
      }
      function d3_svg_axisY(selection, y0, y1) {
        selection.attr("transform", function (d) {
          var v0 = y0(d);
          return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
        });
      }
      d3.svg.brush = function () {
        var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"),
            x = null,
            y = null,
            xExtent = [0, 0],
            yExtent = [0, 0],
            xExtentDomain,
            yExtentDomain,
            xClamp = true,
            yClamp = true,
            resizes = d3_svg_brushResizes[0];
        function brush(g) {
          g.each(function () {
            var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
            var background = g.selectAll(".background").data([0]);
            background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
            g.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
            var resize = g.selectAll(".resize").data(resizes, d3_identity);
            resize.exit().remove();
            resize.enter().append("g").attr("class", function (d) {
              return "resize " + d;
            }).style("cursor", function (d) {
              return d3_svg_brushCursor[d];
            }).append("rect").attr("x", function (d) {
              return (/[ew]$/.test(d) ? -3 : null
              );
            }).attr("y", function (d) {
              return (/^[ns]/.test(d) ? -3 : null
              );
            }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
            resize.style("display", brush.empty() ? "none" : null);
            var gUpdate = d3.transition(g),
                backgroundUpdate = d3.transition(background),
                range;
            if (x) {
              range = d3_scaleRange(x);
              backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
              redrawX(gUpdate);
            }
            if (y) {
              range = d3_scaleRange(y);
              backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
              redrawY(gUpdate);
            }
            redraw(gUpdate);
          });
        }
        brush.event = function (g) {
          g.each(function () {
            var event_ = event.of(this, arguments),
                extent1 = {
              x: xExtent,
              y: yExtent,
              i: xExtentDomain,
              j: yExtentDomain
            },
                extent0 = this.__chart__ || extent1;
            this.__chart__ = extent1;
            if (d3_transitionInheritId) {
              d3.select(this).transition().each("start.brush", function () {
                xExtentDomain = extent0.i;
                yExtentDomain = extent0.j;
                xExtent = extent0.x;
                yExtent = extent0.y;
                event_({
                  type: "brushstart"
                });
              }).tween("brush:brush", function () {
                var xi = d3_interpolateArray(xExtent, extent1.x),
                    yi = d3_interpolateArray(yExtent, extent1.y);
                xExtentDomain = yExtentDomain = null;
                return function (t) {
                  xExtent = extent1.x = xi(t);
                  yExtent = extent1.y = yi(t);
                  event_({
                    type: "brush",
                    mode: "resize"
                  });
                };
              }).each("end.brush", function () {
                xExtentDomain = extent1.i;
                yExtentDomain = extent1.j;
                event_({
                  type: "brush",
                  mode: "resize"
                });
                event_({
                  type: "brushend"
                });
              });
            } else {
              event_({
                type: "brushstart"
              });
              event_({
                type: "brush",
                mode: "resize"
              });
              event_({
                type: "brushend"
              });
            }
          });
        };
        function redraw(g) {
          g.selectAll(".resize").attr("transform", function (d) {
            return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
          });
        }
        function redrawX(g) {
          g.select(".extent").attr("x", xExtent[0]);
          g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
        }
        function redrawY(g) {
          g.select(".extent").attr("y", yExtent[0]);
          g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
        }
        function brushstart() {
          var target = this,
              eventTarget = d3.select(d3.event.target),
              event_ = event.of(target, arguments),
              g = d3.select(target),
              resizing = eventTarget.datum(),
              resizingX = !/^(n|s)$/.test(resizing) && x,
              resizingY = !/^(e|w)$/.test(resizing) && y,
              dragging = eventTarget.classed("extent"),
              dragRestore = d3_event_dragSuppress(target),
              center,
              origin = d3.mouse(target),
              offset;
          var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
          if (d3.event.changedTouches) {
            w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
          } else {
            w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
          }
          g.interrupt().selectAll("*").interrupt();
          if (dragging) {
            origin[0] = xExtent[0] - origin[0];
            origin[1] = yExtent[0] - origin[1];
          } else if (resizing) {
            var ex = +/w$/.test(resizing),
                ey = +/^n/.test(resizing);
            offset = [xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1]];
            origin[0] = xExtent[ex];
            origin[1] = yExtent[ey];
          } else if (d3.event.altKey) center = origin.slice();
          g.style("pointer-events", "none").selectAll(".resize").style("display", null);
          d3.select("body").style("cursor", eventTarget.style("cursor"));
          event_({
            type: "brushstart"
          });
          brushmove();
          function keydown() {
            if (d3.event.keyCode == 32) {
              if (!dragging) {
                center = null;
                origin[0] -= xExtent[1];
                origin[1] -= yExtent[1];
                dragging = 2;
              }
              d3_eventPreventDefault();
            }
          }
          function keyup() {
            if (d3.event.keyCode == 32 && dragging == 2) {
              origin[0] += xExtent[1];
              origin[1] += yExtent[1];
              dragging = 0;
              d3_eventPreventDefault();
            }
          }
          function brushmove() {
            var point = d3.mouse(target),
                moved = false;
            if (offset) {
              point[0] += offset[0];
              point[1] += offset[1];
            }
            if (!dragging) {
              if (d3.event.altKey) {
                if (!center) center = [(xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2];
                origin[0] = xExtent[+(point[0] < center[0])];
                origin[1] = yExtent[+(point[1] < center[1])];
              } else center = null;
            }
            if (resizingX && move1(point, x, 0)) {
              redrawX(g);
              moved = true;
            }
            if (resizingY && move1(point, y, 1)) {
              redrawY(g);
              moved = true;
            }
            if (moved) {
              redraw(g);
              event_({
                type: "brush",
                mode: dragging ? "move" : "resize"
              });
            }
          }
          function move1(point, scale, i) {
            var range = d3_scaleRange(scale),
                r0 = range[0],
                r1 = range[1],
                position = origin[i],
                extent = i ? yExtent : xExtent,
                size = extent[1] - extent[0],
                min,
                max;
            if (dragging) {
              r0 -= position;
              r1 -= size + position;
            }
            min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
            if (dragging) {
              max = (min += position) + size;
            } else {
              if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
              if (position < min) {
                max = min;
                min = position;
              } else {
                max = position;
              }
            }
            if (extent[0] != min || extent[1] != max) {
              if (i) yExtentDomain = null;else xExtentDomain = null;
              extent[0] = min;
              extent[1] = max;
              return true;
            }
          }
          function brushend() {
            brushmove();
            g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
            d3.select("body").style("cursor", null);
            w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
            dragRestore();
            event_({
              type: "brushend"
            });
          }
        }
        brush.x = function (z) {
          if (!arguments.length) return x;
          x = z;
          resizes = d3_svg_brushResizes[!x << 1 | !y];
          return brush;
        };
        brush.y = function (z) {
          if (!arguments.length) return y;
          y = z;
          resizes = d3_svg_brushResizes[!x << 1 | !y];
          return brush;
        };
        brush.clamp = function (z) {
          if (!arguments.length) return x && y ? [xClamp, yClamp] : x ? xClamp : y ? yClamp : null;
          if (x && y) xClamp = !!z[0], yClamp = !!z[1];else if (x) xClamp = !!z;else if (y) yClamp = !!z;
          return brush;
        };
        brush.extent = function (z) {
          var x0, x1, y0, y1, t;
          if (!arguments.length) {
            if (x) {
              if (xExtentDomain) {
                x0 = xExtentDomain[0], x1 = xExtentDomain[1];
              } else {
                x0 = xExtent[0], x1 = xExtent[1];
                if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
                if (x1 < x0) t = x0, x0 = x1, x1 = t;
              }
            }
            if (y) {
              if (yExtentDomain) {
                y0 = yExtentDomain[0], y1 = yExtentDomain[1];
              } else {
                y0 = yExtent[0], y1 = yExtent[1];
                if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
                if (y1 < y0) t = y0, y0 = y1, y1 = t;
              }
            }
            return x && y ? [[x0, y0], [x1, y1]] : x ? [x0, x1] : y && [y0, y1];
          }
          if (x) {
            x0 = z[0], x1 = z[1];
            if (y) x0 = x0[0], x1 = x1[0];
            xExtentDomain = [x0, x1];
            if (x.invert) x0 = x(x0), x1 = x(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
            if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [x0, x1];
          }
          if (y) {
            y0 = z[0], y1 = z[1];
            if (x) y0 = y0[1], y1 = y1[1];
            yExtentDomain = [y0, y1];
            if (y.invert) y0 = y(y0), y1 = y(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
            if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [y0, y1];
          }
          return brush;
        };
        brush.clear = function () {
          if (!brush.empty()) {
            xExtent = [0, 0], yExtent = [0, 0];
            xExtentDomain = yExtentDomain = null;
          }
          return brush;
        };
        brush.empty = function () {
          return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
        };
        return d3.rebind(brush, event, "on");
      };
      var d3_svg_brushCursor = {
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
      };
      var d3_svg_brushResizes = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
      var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
      var d3_time_formatUtc = d3_time_format.utc;
      var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
      d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
      function d3_time_formatIsoNative(date) {
        return date.toISOString();
      }
      d3_time_formatIsoNative.parse = function (string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
      };
      d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
      d3_time.second = d3_time_interval(function (date) {
        return new d3_date(Math.floor(date / 1e3) * 1e3);
      }, function (date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 1e3);
      }, function (date) {
        return date.getSeconds();
      });
      d3_time.seconds = d3_time.second.range;
      d3_time.seconds.utc = d3_time.second.utc.range;
      d3_time.minute = d3_time_interval(function (date) {
        return new d3_date(Math.floor(date / 6e4) * 6e4);
      }, function (date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 6e4);
      }, function (date) {
        return date.getMinutes();
      });
      d3_time.minutes = d3_time.minute.range;
      d3_time.minutes.utc = d3_time.minute.utc.range;
      d3_time.hour = d3_time_interval(function (date) {
        var timezone = date.getTimezoneOffset() / 60;
        return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
      }, function (date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 36e5);
      }, function (date) {
        return date.getHours();
      });
      d3_time.hours = d3_time.hour.range;
      d3_time.hours.utc = d3_time.hour.utc.range;
      d3_time.month = d3_time_interval(function (date) {
        date = d3_time.day(date);
        date.setDate(1);
        return date;
      }, function (date, offset) {
        date.setMonth(date.getMonth() + offset);
      }, function (date) {
        return date.getMonth();
      });
      d3_time.months = d3_time.month.range;
      d3_time.months.utc = d3_time.month.utc.range;
      function d3_time_scale(linear, methods, format) {
        function scale(x) {
          return linear(x);
        }
        scale.invert = function (x) {
          return d3_time_scaleDate(linear.invert(x));
        };
        scale.domain = function (x) {
          if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
          linear.domain(x);
          return scale;
        };
        function tickMethod(extent, count) {
          var span = extent[1] - extent[0],
              target = span / count,
              i = d3.bisect(d3_time_scaleSteps, target);
          return i == d3_time_scaleSteps.length ? [methods.year, d3_scale_linearTickRange(extent.map(function (d) {
            return d / 31536e6;
          }), count)[2]] : !i ? [d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2]] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
        }
        scale.nice = function (interval, skip) {
          var domain = scale.domain(),
              extent = d3_scaleExtent(domain),
              method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
          if (method) interval = method[0], skip = method[1];
          function skipped(date) {
            return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
          }
          return scale.domain(d3_scale_nice(domain, skip > 1 ? {
            floor: function (date) {
              while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
              return date;
            },
            ceil: function (date) {
              while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
              return date;
            }
          } : interval));
        };
        scale.ticks = function (interval, skip) {
          var extent = d3_scaleExtent(scale.domain()),
              method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [{
            range: interval
          }, skip];
          if (method) interval = method[0], skip = method[1];
          return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
        };
        scale.tickFormat = function () {
          return format;
        };
        scale.copy = function () {
          return d3_time_scale(linear.copy(), methods, format);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      function d3_time_scaleDate(t) {
        return new Date(t);
      }
      var d3_time_scaleSteps = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6];
      var d3_time_scaleLocalMethods = [[d3_time.second, 1], [d3_time.second, 5], [d3_time.second, 15], [d3_time.second, 30], [d3_time.minute, 1], [d3_time.minute, 5], [d3_time.minute, 15], [d3_time.minute, 30], [d3_time.hour, 1], [d3_time.hour, 3], [d3_time.hour, 6], [d3_time.hour, 12], [d3_time.day, 1], [d3_time.day, 2], [d3_time.week, 1], [d3_time.month, 1], [d3_time.month, 3], [d3_time.year, 1]];
      var d3_time_scaleLocalFormat = d3_time_format.multi([[".%L", function (d) {
        return d.getMilliseconds();
      }], [":%S", function (d) {
        return d.getSeconds();
      }], ["%I:%M", function (d) {
        return d.getMinutes();
      }], ["%I %p", function (d) {
        return d.getHours();
      }], ["%a %d", function (d) {
        return d.getDay() && d.getDate() != 1;
      }], ["%b %d", function (d) {
        return d.getDate() != 1;
      }], ["%B", function (d) {
        return d.getMonth();
      }], ["%Y", d3_true]]);
      var d3_time_scaleMilliseconds = {
        range: function (start, stop, step) {
          return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
        },
        floor: d3_identity,
        ceil: d3_identity
      };
      d3_time_scaleLocalMethods.year = d3_time.year;
      d3_time.scale = function () {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
      };
      var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function (m) {
        return [m[0].utc, m[1]];
      });
      var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([[".%L", function (d) {
        return d.getUTCMilliseconds();
      }], [":%S", function (d) {
        return d.getUTCSeconds();
      }], ["%I:%M", function (d) {
        return d.getUTCMinutes();
      }], ["%I %p", function (d) {
        return d.getUTCHours();
      }], ["%a %d", function (d) {
        return d.getUTCDay() && d.getUTCDate() != 1;
      }], ["%b %d", function (d) {
        return d.getUTCDate() != 1;
      }], ["%B", function (d) {
        return d.getUTCMonth();
      }], ["%Y", d3_true]]);
      d3_time_scaleUtcMethods.year = d3_time.year.utc;
      d3_time.scale.utc = function () {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
      };
      d3.text = d3_xhrType(function (request) {
        return request.responseText;
      });
      d3.json = function (url, callback) {
        return d3_xhr(url, "application/json", d3_json, callback);
      };
      function d3_json(request) {
        return JSON.parse(request.responseText);
      }
      d3.html = function (url, callback) {
        return d3_xhr(url, "text/html", d3_html, callback);
      };
      function d3_html(request) {
        var range = d3_document.createRange();
        range.selectNode(d3_document.body);
        return range.createContextualFragment(request.responseText);
      }
      d3.xml = d3_xhrType(function (request) {
        return request.responseXML;
      });
      if (typeof define === "function" && define.amd) this.d3 = d3, define(d3);else if (typeof module === "object" && module.exports) module.exports = d3;else this.d3 = d3;
    }();
  })(this);

  return _retrieveGlobal();
});
$__System.registerDynamic("1d", ["229"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("229");
});
$__System.registerDynamic("22a", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {
    // vim: ts=2 sw=2
    (function () {
      d3.timeline = function () {
        var DISPLAY_TYPES = ["circle", "rect"];

        var hover = function () {},
            mouseover = function () {},
            mouseout = function () {},
            click = function () {},
            scroll = function () {},
            labelFunction = function () {},
            orient = "bottom",
            width = null,
            height = null,
            rowSeperatorsColor = null,
            backgroundColor = null,
            tickFormat = { format: d3.time.format("%I %p"),
          tickTime: d3.time.hours,
          tickInterval: 1,
          tickSize: 6 },
            colorCycle = d3.scale.category20(),
            colorPropertyName = null,
            display = "rect",
            beginning = 0,
            ending = 0,
            margin = { left: 30, right: 30, top: 30, bottom: 30 },
            stacked = false,
            rotateTicks = false,
            timeIsRelative = false,
            itemHeight = 20,
            itemMargin = 5,
            showTimeAxis = true,
            showTodayLine = false,
            timeAxisTick = false,
            timeAxisTickFormat = { stroke: "stroke-dasharray", spacing: "4 10" },
            showTodayFormat = { marginTop: 25, marginBottom: 0, width: 1, color: colorCycle },
            showBorderLine = false,
            showBorderFormat = { marginTop: 25, marginBottom: 0, width: 1, color: colorCycle };

        function timeline(gParent) {
          var g = gParent.append("g");
          var gParentSize = gParent[0][0].getBoundingClientRect();

          var gParentItem = d3.select(gParent[0][0]);

          var yAxisMapping = {},
              maxStack = 1,
              minTime = 0,
              maxTime = 0;

          setWidth();

          // check if the user wants relative time
          // if so, substract the first timestamp from each subsequent timestamps
          if (timeIsRelative) {
            g.each(function (d, i) {
              d.forEach(function (datum, index) {
                datum.times.forEach(function (time, j) {
                  if (index === 0 && j === 0) {
                    originTime = time.starting_time; //Store the timestamp that will serve as origin
                    time.starting_time = 0; //Set the origin
                    time.ending_time = time.ending_time - originTime; //Store the relative time (millis)
                  } else {
                    time.starting_time = time.starting_time - originTime;
                    time.ending_time = time.ending_time - originTime;
                  }
                });
              });
            });
          }

          // check how many stacks we're gonna need
          // do this here so that we can draw the axis before the graph
          if (stacked || ending === 0 || beginning === 0) {
            g.each(function (d, i) {
              d.forEach(function (datum, index) {

                // create y mapping for stacked graph
                if (stacked && Object.keys(yAxisMapping).indexOf(index) == -1) {
                  yAxisMapping[index] = maxStack;
                  maxStack++;
                }

                // figure out beginning and ending times if they are unspecified
                datum.times.forEach(function (time, i) {
                  if (beginning === 0) if (time.starting_time < minTime || minTime === 0 && timeIsRelative === false) minTime = time.starting_time;
                  if (ending === 0) if (time.ending_time > maxTime) maxTime = time.ending_time;
                });
              });
            });

            if (ending === 0) {
              ending = maxTime;
            }
            if (beginning === 0) {
              beginning = minTime;
            }
          }

          var scaleFactor = 1 / (ending - beginning) * (width - margin.left - margin.right);

          // draw the axis
          var xScale = d3.time.scale().domain([beginning, ending]).range([margin.left, width - margin.right]);

          var xAxis = d3.svg.axis().scale(xScale).orient(orient).tickFormat(tickFormat.format).ticks(tickFormat.numTicks || tickFormat.tickTime, tickFormat.tickInterval).tickSize(tickFormat.tickSize);

          if (showTimeAxis) {
            g.append("g").attr("class", "axis").attr("transform", "translate(" + 0 + "," + (margin.top + (itemHeight + itemMargin) * maxStack) + ")").call(xAxis);
          }

          if (timeAxisTick) {
            g.append("g").attr("class", "axis").attr("transform", "translate(" + 0 + "," + (margin.top + (itemHeight + itemMargin) * maxStack) + ")").attr(timeAxisTickFormat.stroke, timeAxisTickFormat.spacing).call(xAxis.tickFormat("").tickSize(-(margin.top + (itemHeight + itemMargin) * (maxStack - 1) + 3), 0, 0));
          }

          // draw the chart
          g.each(function (d, i) {
            d.forEach(function (datum, index) {
              var data = datum.times;
              var hasLabel = typeof datum.label != "undefined";
              var getLabel = function (label) {
                if (labelFunction == null) {
                  return label;
                } else {
                  return labelFunction(label);
                }
              };

              // issue warning about using id per data set. Ids should be individual to data elements
              if (typeof datum.id != "undefined") {
                console.warn("d3Timeline Warning: Ids per dataset is deprecated in favor of a 'class' key. Ids are now per data element.");
              }

              if (backgroundColor) {
                var greenbarYAxis = (itemHeight + itemMargin) * yAxisMapping[index];
                g.selectAll("svg").data(data).enter().insert("rect").attr("class", "row-green-bar").attr("x", 0 + margin.left).attr("width", width - margin.right - margin.left).attr("y", greenbarYAxis).attr("height", itemHeight).attr("fill", backgroundColor);
              }

              g.selectAll("svg").data(data).enter().append(function (d, i) {
                return document.createElementNS(d3.ns.prefix.svg, "display" in d ? d.display : display);
              }).attr("x", getXPos).attr("y", getStackPosition).attr("width", function (d, i) {
                return (d.ending_time - d.starting_time) * scaleFactor;
              }).attr("cy", function (d, i) {
                return getStackPosition(d, i) + itemHeight / 2;
              }).attr("cx", getXPos).attr("r", itemHeight / 2).attr("height", itemHeight).style("fill", function (d, i) {
                var dColorPropName;
                if (d.color) return d.color;
                if (colorPropertyName) {
                  dColorPropName = d[colorPropertyName];
                  if (dColorPropName) {
                    return colorCycle(dColorPropName);
                  } else {
                    return colorCycle(datum[colorPropertyName]);
                  }
                }
                return colorCycle(index);
              }).on("mousemove", function (d, i) {
                hover(d, index, datum);
              }).on("mouseover", function (d, i) {
                mouseover(d, i, datum);
              }).on("mouseout", function (d, i) {
                mouseout(d, i, datum);
              }).on("click", function (d, i) {
                click(d, index, datum);
              }).attr("class", function (d, i) {
                return datum.class ? "timelineSeries_" + datum.class : "timelineSeries_" + index;
              }).attr("id", function (d, i) {
                // use deprecated id field
                if (datum.id && !d.id) {
                  return 'timelineItem_' + datum.id;
                }

                return d.id ? d.id : "timelineItem_" + index + "_" + i;
              });

              g.selectAll("svg").data(data).enter().append("text").attr("x", getXTextPos).attr("y", getStackTextPosition).text(function (d) {
                return d.label;
              });

              if (rowSeperatorsColor) {
                var lineYAxis = itemHeight + itemMargin / 2 + margin.top + (itemHeight + itemMargin) * yAxisMapping[index];
                gParent.append("svg:line").attr("class", "row-seperator").attr("x1", 0 + margin.left).attr("x2", width - margin.right).attr("y1", lineYAxis).attr("y2", lineYAxis).attr("stroke-width", 1).attr("stroke", rowSeperatorsColor);
                ;
              }

              // add the label
              if (hasLabel) {
                gParent.append("text").attr("class", "timeline-label").attr("transform", "translate(" + 0 + "," + (itemHeight * 0.75 + margin.top + (itemHeight + itemMargin) * yAxisMapping[index]) + ")").text(hasLabel ? getLabel(datum.label) : datum.id).on("click", function (d, i) {
                  click(d, index, datum);
                });
              }

              if (typeof datum.icon !== "undefined") {
                gParent.append("image").attr("class", "timeline-label").attr("transform", "translate(" + 0 + "," + (margin.top + (itemHeight + itemMargin) * yAxisMapping[index]) + ")").attr("xlink:href", datum.icon).attr("width", margin.left).attr("height", itemHeight);
              }

              function getStackPosition(d, i) {
                if (stacked) {
                  return margin.top + (itemHeight + itemMargin) * yAxisMapping[index];
                }
                return margin.top;
              }
              function getStackTextPosition(d, i) {
                if (stacked) {
                  return margin.top + (itemHeight + itemMargin) * yAxisMapping[index] + itemHeight * 0.75;
                }
                return margin.top + itemHeight * 0.75;
              }
            });
          });

          if (width > gParentSize.width) {
            var move = function () {
              var x = Math.min(0, Math.max(gParentSize.width - width, d3.event.translate[0]));
              zoom.translate([x, 0]);
              g.attr("transform", "translate(" + x + ",0)");
              scroll(x * scaleFactor, xScale);
            };

            var zoom = d3.behavior.zoom().x(xScale).on("zoom", move);

            gParent.attr("class", "scrollable").call(zoom);
          }

          if (rotateTicks) {
            g.selectAll(".tick text").attr("transform", function (d) {
              return "rotate(" + rotateTicks + ")translate(" + (this.getBBox().width / 2 + 10) + "," // TODO: change this 10
              + this.getBBox().height / 2 + ")";
            });
          }

          var gSize = g[0][0].getBoundingClientRect();
          setHeight();

          if (showBorderLine) {
            g.each(function (d, i) {
              d.forEach(function (datum) {
                var times = datum.times;
                times.forEach(function (time) {
                  appendLine(xScale(time.starting_time), showBorderFormat);
                  appendLine(xScale(time.ending_time), showBorderFormat);
                });
              });
            });
          }

          if (showTodayLine) {
            var todayLine = xScale(new Date());
            appendLine(todayLine, showTodayFormat);
          }

          function getXPos(d, i) {
            return margin.left + (d.starting_time - beginning) * scaleFactor;
          }

          function getXTextPos(d, i) {
            return margin.left + (d.starting_time - beginning) * scaleFactor + 5;
          }

          function setHeight() {
            if (!height && !gParentItem.attr("height")) {
              if (itemHeight) {
                // set height based off of item height
                height = gSize.height + gSize.top - gParentSize.top;
                // set bounding rectangle height
                d3.select(gParent[0][0]).attr("height", height);
              } else {
                throw "height of the timeline is not set";
              }
            } else {
              if (!height) {
                height = gParentItem.attr("height");
              } else {
                gParentItem.attr("height", height);
              }
            }
          }

          function setWidth() {
            if (!width && !gParentSize.width) {
              try {
                width = gParentItem.attr("width");
                if (!width) {
                  throw "width of the timeline is not set. As of Firefox 27, timeline().with(x) needs to be explicitly set in order to render";
                }
              } catch (err) {
                console.log(err);
              }
            } else if (!(width && gParentSize.width)) {
              try {
                width = gParentItem.attr("width");
              } catch (err) {
                console.log(err);
              }
            }
            // if both are set, do nothing
          }

          function appendLine(lineScale, lineFormat) {
            gParent.append("svg:line").attr("x1", lineScale).attr("y1", lineFormat.marginTop).attr("x2", lineScale).attr("y2", height - lineFormat.marginBottom).style("stroke", lineFormat.color) //"rgb(6,120,155)")
            .style("stroke-width", lineFormat.width);
          }
        }

        // SETTINGS

        timeline.margin = function (p) {
          if (!arguments.length) return margin;
          margin = p;
          return timeline;
        };

        timeline.orient = function (orientation) {
          if (!arguments.length) return orient;
          orient = orientation;
          return timeline;
        };

        timeline.itemHeight = function (h) {
          if (!arguments.length) return itemHeight;
          itemHeight = h;
          return timeline;
        };

        timeline.itemMargin = function (h) {
          if (!arguments.length) return itemMargin;
          itemMargin = h;
          return timeline;
        };

        timeline.height = function (h) {
          if (!arguments.length) return height;
          height = h;
          return timeline;
        };

        timeline.width = function (w) {
          if (!arguments.length) return width;
          width = w;
          return timeline;
        };

        timeline.display = function (displayType) {
          if (!arguments.length || DISPLAY_TYPES.indexOf(displayType) == -1) return display;
          display = displayType;
          return timeline;
        };

        timeline.labelFormat = function (f) {
          if (!arguments.length) return null;
          labelFunction = f;
          return timeline;
        };

        timeline.tickFormat = function (format) {
          if (!arguments.length) return tickFormat;
          tickFormat = format;
          return timeline;
        };

        timeline.hover = function (hoverFunc) {
          if (!arguments.length) return hover;
          hover = hoverFunc;
          return timeline;
        };

        timeline.mouseover = function (mouseoverFunc) {
          if (!arguments.length) return mouseoverFunc;
          mouseover = mouseoverFunc;
          return timeline;
        };

        timeline.mouseout = function (mouseoverFunc) {
          if (!arguments.length) return mouseoverFunc;
          mouseout = mouseoverFunc;
          return timeline;
        };

        timeline.click = function (clickFunc) {
          if (!arguments.length) return click;
          click = clickFunc;
          return timeline;
        };

        timeline.scroll = function (scrollFunc) {
          if (!arguments.length) return scroll;
          scroll = scrollFunc;
          return timeline;
        };

        timeline.colors = function (colorFormat) {
          if (!arguments.length) return colorCycle;
          colorCycle = colorFormat;
          return timeline;
        };

        timeline.beginning = function (b) {
          if (!arguments.length) return beginning;
          beginning = b;
          return timeline;
        };

        timeline.ending = function (e) {
          if (!arguments.length) return ending;
          ending = e;
          return timeline;
        };

        timeline.rotateTicks = function (degrees) {
          rotateTicks = degrees;
          return timeline;
        };

        timeline.stack = function () {
          stacked = !stacked;
          return timeline;
        };

        timeline.relativeTime = function () {
          timeIsRelative = !timeIsRelative;
          return timeline;
        };

        timeline.showBorderLine = function () {
          showBorderLine = !showBorderLine;
          return timeline;
        };

        timeline.showBorderFormat = function (borderFormat) {
          if (!arguments.length) return showBorderFormat;
          showBorderFormat = borderFormat;
          return timeline;
        };

        timeline.showToday = function () {
          showTodayLine = !showTodayLine;
          return timeline;
        };

        timeline.showTodayFormat = function (todayFormat) {
          if (!arguments.length) return showTodayFormat;
          showTodayFormat = todayFormat;
          return timeline;
        };

        timeline.colorProperty = function (colorProp) {
          if (!arguments.length) return colorPropertyName;
          colorPropertyName = colorProp;
          return timeline;
        };

        timeline.rowSeperators = function (color) {
          if (!arguments.length) return rowSeperatorsColor;
          rowSeperatorsColor = color;
          return timeline;
        };

        timeline.background = function (color) {
          if (!arguments.length) return backgroundColor;
          backgroundColor = color;
          return timeline;
        };

        timeline.showTimeAxis = function () {
          showTimeAxis = !showTimeAxis;
          return timeline;
        };

        timeline.showTimeAxisTick = function () {
          timeAxisTick = !timeAxisTick;
          return timeline;
        };

        timeline.showTimeAxisTickFormat = function (format) {
          if (!arguments.length) return timeAxisTickFormat;
          timeAxisTickFormat = format;
          return timeline;
        };

        return timeline;
      };
    })();
  })(this);

  return _retrieveGlobal();
});
$__System.registerDynamic("22b", ["22a"], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = $__require("22a");
});
$__System.register('22c', ['1d', '22b'], function (_export) {
  'use strict';

  var d3, activityTimeline;
  return {
    setters: [function (_d) {
      d3 = _d['default'];
    }, function (_b) {}],
    execute: function () {
      activityTimeline = {
        template: '\n    <div class="timeline-holder">\n      <div id="timeline"></div>\n      <div id="label"></div>\n    </div>\n  ',
        bindings: {
          notifications: '<'
        },
        controllerAs: 'aTC',
        controller: function controller($element, moment) {

          var aTC = this;

          aTC.$onInit = function () {
            drawGraph(mapData(aTC.notifications));
          };

          function mapData(data) {
            var converted = _.map(data, function (msg) {
              return {
                //d3 timeline data
                'class': msg.subject_type,
                starting_time: msg.unixTimestamp * 1000,
                display: 'circle',

                //Grouping
                alias: msg.alias,
                id: msg.subject_id, //Potential id key collision

                //Popup
                message: msg.alias + ' ' + msg.event + ' ' + (msg.linking || '') + (msg.data || '') + ' ' + (msg.initiator_type ? msg.initiator_type + ' ' + msg.initiator_id : '')
              };
            });

            var grouped = _.groupBy(converted, function (item) {
              return item.alias + ' (' + item.id + ')';
            });

            var finalData = _.map(grouped, function (group, name, parentObject) {
              return {
                'class': group[0]['class'],
                label: name,
                times: group
              };
            });

            console.log(finalData);

            return { data: finalData, start: _.last(converted).starting_time, end: converted[0].starting_time };
          }

          function drawGraph(graphDataObj) {

            var width = $element.find('#timeline')[0].clientWidth;
            var label = $element.find('#label');

            label.hide();

            // let customTimeFormat = d3.time.format.multi([
            //   ['.%L', function(d) { return d.getMilliseconds(); }],
            //   [':%S', function(d) { return d.getSeconds(); }],
            //   ['%I:%M', function(d) { return d.getMinutes(); }],
            //   ['%I %p', function(d) { return d.getHours(); }],
            //   ['%a %d', function(d) { return d.getDay() && d.getDate() !== 1; }],
            //   ['%b %d', function(d) { return d.getDate() !== 1; }],
            //   ['%B', function(d) { return d.getMonth(); }],
            //   ['%Y', function() { return true; }]
            // ]);

            var chart = d3.timeline().rotateTicks(45).tickFormat({
              format: function format(d) {
                return d3.time.format('%I:%M %p %a')(d);
              },
              tickTime: d3.time.hours,
              tickInterval: 2,
              tickSize: 15
            })
            //.tickPadding(10)
            //.tickFormat(d3.time.format('%Y-%m-%d'))
            //.tickFormat(customTimeFormat)
            . //tickPadding: 30
            beginning(graphDataObj.start) // we can optionally add beginning and ending times to speed up rendering a little
            .ending(graphDataObj.end).showTimeAxisTick() // toggles tick marks
            .stack() // toggles graph stacking
            .margin({ left: 250, right: 10, top: 0, bottom: 0 });

            // Define the div for the tooltip
            //let label = d3.select('body').append('div')
            //  .attr('class', 'tooltip')
            //.attr('id', 'label')      
            //.style('opacity', 0);

            var svg = d3.select('#timeline').append('svg').attr('width', width).datum(graphDataObj.data).call(chart);

            //Better tooltips
            svg.selectAll('circle').on('mouseenter', function (d, i, datum) {
              // d is the current rendering object
              // i is the index during d3 rendering
              // datum is the data object
              label.html('<p><span class="strong">' + d.message + '<span></p><p><span>' + moment(d.starting_time).format() + '</span></p>').attr('style', 'left: ' + d3.event.pageX + 'px; top: ' + (d3.event.pageY - 90) + 'px;').show();
            }).on('mouseleave', function () {
              //code for transition
              label.hide();
            });

            // svg.selectAll('.timeline-label')
            //   .call(getBB)
            //   .insert('rect','text')
            //   .attr('x', function(d){return d.bbox.x;})
            //   .attr('y', function(d){return d.bbox.y;})
            //   .attr('width', function(d, i, datum){return d.bbox.width; })
            //   .attr('height', function(d){return d.bbox.height;})
            //   .style('fill', 'white');

            function getBB(selection) {
              selection.each(function (d) {
                d.bbox = this.getBBox();
              });
            }
          }
        }
      };

      _export('default', activityTimeline);
    }
  };
});

$__System.register('22d', [], function (_export) {
  'use strict';

  var activityStates;
  return {
    setters: [],
    execute: function () {
      activityStates = {
        name: 'Activity',
        url: '/site/{siteId:[0-9]{1,24}}/activity/{userSelectedFilter}',
        resolve: {
          //Resolve site data
          initialSessionData: function initialSessionData($stateParams, $state$, $transition$, $q, $rootScope, Session, LcCache) {

            var to = $transition$.to();
            var toParams = $transition$.params('to');
            var fromState = $transition$.from();
            var fromParams = $transition$.params('from');
            var extraSections = to.params.extraSections || null;

            //
            //
            // Set up master view session data and extra sections required
            //
            //
            return Session.getSiteData(true, extraSections).then(function (data) {
              //
              // Kick off site list process for menu
              // Is a promise but we won't hold the resolve on it, can swap to eager resolves ?
              //

              console.log('Master Structure state change here...');

              LcCache.setCurrentOrg(data.org);

              return data;
            });
          },
          initialSessionSitesListPromise: function initialSessionSitesListPromise(initialSessionData, Session, $q) {
            var sitesListDeferred = $q.defer();

            Session.getSitesList(initialSessionData.id, initialSessionData.org.uuid).then(function (list) {
              sitesListDeferred.resolve(list);
            });

            return sitesListDeferred; // Return Deferred NOT promise, to avoid wait on transition
          },
          initialSelectedIds: function initialSelectedIds($stateParams, Session) {
            return Session.getUrlParamsUserSelection();
          },
          viewNavContext: function viewNavContext($transition$) {
            var to = $transition$.to();
            //
            // Some views will require different arrangements than default listed below
            //
            // - 'default' ('grouped-zones' view)
            // - 'devices'
            // - 'scenes'
            // 
            //   
            return to.params.leftMenuSpecialContext ? to.params.leftMenuSpecialContext : 'default';
          }
        },

        component: 'activityMasterBase',

        params: {
          siteId: null,
          userSelectedFilter: null,
          extraSections: ['notifications']
        },

        title: 'Activity Overview'
      };

      _export('activityStates', activityStates);
    }
  };
});

$__System.register('22e', ['3', '211', '220', '222', '223', '224', '226', '227', '228', '20c', '20d', '5a', '20f', '21e', '22c', '22d'], function (_export) {
    //import { CsGatewayBoxToastDirective } from './gateway/csGatewayBoxToastDirective';

    //import workerFactory from './worker/worker';
    //import IndexerService from './worker/indexerService';

    'use strict';

    var angular, csBarSearchComponent, CsBarSearchInputDirective, csSiteEditFormComponent, csOrgEditFormComponent, CsGatewayBoxComponent, CsGatewayDetailsComponent, activityMasterBase, activityBase, orgsService, globalCtrl, ratesModalCtrl, csBarComponent, gatewayAssignWizardComponent, activityTimeline, activityStates, customerService;
    return {
        setters: [function (_) {
            angular = _['default'];
        }, function (_2) {
            csBarSearchComponent = _2['default'];
        }, function (_3) {
            CsBarSearchInputDirective = _3.CsBarSearchInputDirective;
        }, function (_4) {
            csSiteEditFormComponent = _4['default'];
        }, function (_5) {
            csOrgEditFormComponent = _5['default'];
        }, function (_6) {
            CsGatewayBoxComponent = _6['default'];
        }, function (_7) {
            CsGatewayDetailsComponent = _7['default'];
        }, function (_8) {
            activityMasterBase = _8['default'];
        }, function (_9) {
            activityBase = _9['default'];
        }, function (_c) {
            orgsService = _c['default'];
        }, function (_d) {
            globalCtrl = _d['default'];
        }, function (_a) {
            ratesModalCtrl = _a['default'];
        }, function (_f) {
            csBarComponent = _f['default'];
        }, function (_e) {
            gatewayAssignWizardComponent = _e['default'];
        }, function (_c2) {
            activityTimeline = _c2['default'];
        }, function (_d2) {
            activityStates = _d2.activityStates;
        }],
        execute: function () {
            customerService = angular.module('customer-service', [])

            //Core
            .service('Orgs', orgsService).controller('globalCtrl', globalCtrl).controller('ratesModalCtrl', ratesModalCtrl)

            //Worker
            //.factory('Worker',workerFactory)
            //.service('Indexer',IndexerService)

            //Bar 
            .component('csBar', csBarComponent).component('csBarSearch', csBarSearchComponent).component('gatewayAssignWizard', gatewayAssignWizardComponent).component('csOrgEditForm', csOrgEditFormComponent).component('csSiteEditForm', csSiteEditFormComponent).directive('csBarSearchInputDirective', function () {
                return new CsBarSearchInputDirective();
            })

            //Gateway   
            .component('csGatewayBox', CsGatewayBoxComponent).component('csGatewayDetails', CsGatewayDetailsComponent)

            //Activity
            .component('activityMasterBase', activityMasterBase).component('activityBase', activityBase).component('activityTimeline', activityTimeline).config(['$stateRegistryProvider', function ($stateRegistry) {
                $stateRegistry.register(activityStates);
            }]);

            _export('default', customerService);
        }
    };
});

$__System.registerDynamic("22f", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = { "common": { "actions": "Actions", "add": "Add", "all": "All", "apply": "Apply", "activity": "Activity", "activityLog": "Activity Log", "automations": "Automations", "assign": "Assign", "back": "Back", "backend": "backend", "behaviors": "Behaviors", "calibration": "Calibration", "cancel": "Cancel", "close": "Close", "clear": "Clear", "confirm": "Confirm", "confirmDelete": "Confirm Delete", "control": "Control", "copy": "Copy", "delete": "Delete", "deleting": "Deleting", "device": "device", "devices": "Devices", "disabled": "Disabled", "dismiss": "Dismiss", "done": "Done", "doneEditAll": "Done Edit All", "edit": "Edit", "editAll": "Edit All", "emergencyActive": "EMERGENCY MODE IS ACTIVE!!!", "endOfLog": "End Of Log", "energy": "Energy", "errors": "Errors", "event": "event", "goSite": "Manage", "home": "Home", "indicate": "Indicate", "language": "language: ", "latestInterface": "You are using the latest version of the Lightcloud interface. To switch back to the classic version, use the link under the top right menu.", "loadingEllipsis": "Loading...", "location": "location", "logout": "Logout", "map": "Map", "max": "Max", "mins": "MINs", "next": "Next", "organize": "Organize", "overview": "Overview", "on": "On", "off": "Off", "paste": "Paste", "plural": "s", "rab": "RAB!", "remove": "Remove", "rename": "Rename", "renaming": "Renaming", "repeat": "Repeat", "unassign": "Unassign", "unavailable": "Unavailable", "update": "UPDATE", "save": "Save", "saving": "Saving", "secs": "secs", "set": "set", "schedule": "schedule", "schedules": "schedules", "scenes": "Scenes", "selecting": "Selecting", "setup": "Devices", "sensors": "Sensors", "search": "Search", "selectAnExisting": "Select existing from left or create one with the plus button", "sites": "sites", "siteScenes": "Scenes", "shows": "Shows", "success": "Success!", "updates": "Updates", "user": "User", "users": "Users", "view": "View", "viewing": "Viewing", "viewAll": "View All", "working": "Working", "uniqueName": "Name must be unique" }, "area": { "allAreas": "All Areas", "areaName": "Area Name", "delete": "Are you sure you want to delete these Areas and their Zones?", "editArea": "Edit Area", "renameArea": "Rename Area", "searchForArea": "Search Areas", "unique": "Area names must be unique", "unassignedZone": "Unassigned Zone", "viewYourScenes": "View Your Scenes" }, "automation": { "addAutomation": "Add Automation", "addAction": "Add Action", "automation": "automation", "automations": "automations", "automationSchedules": "Automation Schedules", "choseTriggerMode": "Choose trigger mode to set automation", "whenTriggerIs": "when the trigger is", "whenTheLightLevelIs": "when the light level is", "whenSensorIndicate": "when sensor indicates ", "zoneSceneSchedule": "Zone & Scene Schedules" }, "behaviors": { "sensorSearch": "Search Sensors" }, "billing": { "addCard": "Add Card", "amount": "Amount", "balance": "Balance", "billing": "Billing", "billData": "Bill Data", "billingHistory": "Billing History", "billSMS": "Bill SMS", "billVoice": "Bill Voice", "currentUsage": "Current Usage", "createServicePlan": "Create Service Plan", "date": "Date", "noActiveCoupons": "No Active Coupons", "paid": "Paid", "paymentDetails": "Payment Details", "paymentNotSaved": "Payment Not Saved", "prelude": "Prelude", "savePaymentMethod": "Save Payment Method", "servicePlan": "Service Plan", "selectAPlan": "-- Select a Plan Length --", "summary": "Summary", "terminalId": "Terminal ID", "year": "Year" }, "customerService": { "accountAdministrator": "Account Administrator", "accountOverview": "Account Overview", "addAccountAdministrator": "Add Account Administrator(s)", "address": "Address", "address1": "Address Line 1", "address2": "Address Line 2", "allFieldsRequired": "All fields required, No special characters allowed", "applyCredit": "Apply Credit", "city": "City", "createHardInvoice": "Create Hard Invoice", "confirmCredit": "Confirm Credit", "company": "Company", "country_code": "Country", "description": "Description", "deleteThisOrg": "Delete This Org", "deleteThisSite": "Delete This Site", "details": "Details", "editOrg": "Edit Org", "electricianInfo": "Electrician Info", "eg": "e.g 'My home office'", "gatewayName": "Gateway Name", "gateways": "Gateways", "gatewayVersion": "Gateway Version: ", "globalSettings": "Global Settings", "gotoThisSite": "Goto This Site", "lightcloudCustomerSercive": "Lightcloud Customer Service", "lastMonthCellUsage": "Last Billing Cycle Cell Usage", "name": "Name", "installerApp": "Installer App Upload", "invoicing": "Invoicing", "organization": "Organization", "organizationName": "Organization Name", "organizationTimeout": "Organization Timeout", "rates": "Rates", "saveFailed": "Save Failed", "setPaymentMethod": "Set Payment Method", "setTaxRates": "Set Tax Rates", "setupMode": "Setup Mode: ", "servicePlan": "Service Plan", "searchOrgs": "Search Orgs", "selectAPayment": "-- Select a Payment Option --", "selectAnOrg": "-- Select an Org --", "sites": "Sites", "siteName": "Site Name", "state": "State", "stateCode": "State: ['Ensure this field has no more than 2 characters.']", "pincode": "Pin Code", "zipCode": "Zip Code", "thisGatewayIsUnavailable": "This Gateway is currently Unavailable", "twoCharacterState": "two character state", "users": "Users", "useOrgAddress": "Use Org Address", "viewRates": "View Rates", "zip": "Zip" }, "devices": { "allDevices": "All Devices", "alsControlState": "Photocell Controlled", "activityLogEmpty": "Activity log empty", "actionBtn": "Power Data", "addDevicesMode": "Add Devices Mode", "addDeviceModeHint": "This site is in Add Devices Mode", "advance_trigger": "Occupancy Local", "advance_trigger_no_actuator": "Occupancy Custom", "afterLostSignal": "After Lost Signal", "afterPowerLoss": "After Power Loss", "ambientLightSensorSensitivity": "ambient light sensor sensitivity", "alsReport": "ALS report", "ALSTrigger": "ALS Trigger", "AssignToExisting": "Assign to an Existing Area", "baseline_wattage": "Baseline Wattage", "blinkBeforeUnoccupied": "Blink Before Unoccupied", "calibrateEnergy": "Calibrate Energy", "calibrateAllDevices": "Calibrate All Devices", "calibrationIniciated": "Calibration Iniciated Successfully", "checkForFirmwareUpdate": "Check for Firmware Update", "controller": "Controller", "custom": "Custom", "custom_on_level": "Custom on level", "cellType": "Cell Type", "createNewArea": "Create New Area and Assign", "downloadDeviceTable": "Generate Device Table", "daylightAverageSinceLastValue": "daylight average since last value", "daylightAverageValue": "daylight average value", "daylightvalue": "daylight value", "deleteDevice": "Delete Device", "deviceId": "Device ID", "deviceICCID": "Device ICCID", "deviceMode": "Device Mode", "deviceSettings": "Device Settings", "dimmer": "dimmer", "dimming": "Dimming", "dimmingCurve": "Dimming Curve", "dimmerOffSlopeTime": "dimmer off slope time", "digiFirmware": "Gateway Firmware", "disabled": "Disabled", "enabled": "Enabled", "emergencyMode": "Emergency Mode", "existingDevices": "Existing Devices", "faultDetection": "Fault Detection", "faultNotificationThreshold": "Fault Alert Threshold", "fullPowerReading": "full power reading", "footCandles": "foot candles", "gatewayMAC": "Gateway MAC", "gatewayID": "Gateway ID", "greaterThan": "greater than or equal to", "groupSameMessage": "Please Select Matching Device Types To Edit Settings", "hasSensorToggle": "Has Sensor", "hideAdvanced": "Hide Advanced", "high": "High", "health": "Health", "info": "Info", "id_string": "Zone Name", "indicatorLED": "Indicator LED", "latLong": "Lat Long", "lastState": "Last State", "last_state": "Last State", "last": "Last State", "lastOnLevel": "Last On Level", "last_on": "Last On Level", "legacyUpdate": "Legacy Update", "lostSignal": "Lost Signal", "lostSignalEnable": "Lost Signal Enable", "lostSignalDimLevel": "Lost Signal Dim Level", "lostSignalMode": "Lost Signal Mode", "lessThan": "less than", "linear": "Linear", "lightsOn": "Lights On", "lightsOff": "Lights Off", "LCDeviceType": "LC Device Type", "LCVersion": "LC Version", "location": "Location", "low": "Low", "mainTitle": "Main Title", "manualOverride": "Manual Override", "manual_override_length": "Override Timeout", "manual_override_restore_state": "Return To System State", "masterDevicesControls": "Master Devices Controls", "maxTrimLevel": "Max Trim Level", "med": "Medium", "micEnable": "MIC Enable", "microphoneSensor": "Microphone Sensor", "motion_timeout": "Motion Timeout", "multiple": "Multiple", "multiple_passcode_mode": "Multiple Passcode Mode", "newDevices": "New Devices", "no_actuator": "Custom", "uncommissionedDevices": "Uncommissioned Devices", "update": "Update", "updateAllDevices": "Update All Devices", "updateMultipleDevices": "Update Multiple Devices", "occupancy": "Occupancy", "occupancyCustom": "Occupancy Custom", "occupancyLocal": "Occupancy Local", "occupancy_led_enable": "Indicator LED", "off": "off", "offlineNotification": "Offline Notification", "offlineNotificationThreshold": "Offline Notification Threshold", "offToUnoccupied": "Off To Unoccupied", "panel": "Panel", "panId": "Pan ID", "passcode": "Passcode", "passcodeEnabled": "Passcode Enabled", "passcode_mode": "Passcode Mode", "powerReportInterval": "power report interval", "powerDrawsByDecile": "Power Draws by Decile", "powerMonitoring": "Power Monitoring", "powerLossMode": "Power Loss Mode", "powerUpState": "Power Up State", "power_on_mode": "Power Up State", "power_on_level": "Power On Level", "powerUpOnLevel": "Power On Level", "previousSet": "Previous Set", "reentryTimeout": "Re-entry Timeout", "remain": "Remain", "repeatInMinutes": "Repeat In Minutes", "repeater": "Repeater", "reset": "Reset", "return": "Return", "scene": "Scene", "searchDevices": "Search Devices", "selectDeviceLeft": "Please select a device on the left.", "setPowerLossModeValue": "Send Loss Mode Value", "setupMode": "Setup Mode", "sensitivity": "Sensitivity", "sensor_sensitivity": "Sensor Sensitivity", "siteId": "Site ID", "siteCreationDate": "Site Creation Date", "single": "Single", "softDim": "Soft Dim", "soft_dim_enable": "Soft Dim", "showAdvanced": "Show Advanced", "startCalibration": "Start Calibration", "clearCalibration": "Clear Calibration", "switch": "switch", "square": "square", "square_root": "Square Root", "subTitle": "Sub Title", "screenBrightness": "Screen Brightness", "screenLockTimeout": "Screen Lock Timeout", "timeout": "Timeout", "testMode": "Test Mode", "temperatureSensor": "temperature sensor", "trigger": "Trigger", "watts": "Watts", "whenOccupied": "When Occupied", "whenOccupiedZoneLevel": "When Occupied Zone Level", "whenUnoccupied": "When Unoccupied", "vacancy": "Vacancy", "visible_in_control": "Load Mode", "zoneName": "Zone Name", "device_mode": "Device Mode", "power_report": "Power Monitoring", "default_actuator_state": "Lost Signal", "false": "Off", "true": "on", "description": "Description", "test_mode": "Test Mode", "pirSensitivity": "Sensitivity", "pir_sensitivity": "Sensitivity", "turn_off_time_delay": "Timeout", "max_dimmer_level": "When Occupied", "min_dimmer_level": "When Unoccupied", "blink_number": "Blink before Unoccupied", "vacancies_mode_return_time": "Re-Enter Timeout", "power_report_frequency": "Power Report Interval", "dimming_curve_type": "Dimming Curve", "als_sensitivity": "Ambient Light Sensor", "dimmer_off_slope_time": "Dimmer Off Slope Time", "temp_sensor_report_enable": "Temperature Sensor", "als_report_enable": "ALS Report", "passcode_enable": "Passcode Enable", "xbeeFirmwareVersion": "XBee Version" }, "demand": { "activate": "Activate", "activated": "Activated", "addZone": "Add Zone", "creatPreSet": "Create pre-set collections of actions across multiple zones", "siteScenes": "Scenes", "siteScenesScenes": "Scenes", "demandResponse": "Demand Response", "demandResponseScenes": "Demand Response Scenes", "disableLiveMode": "Disable Live Mode", "enableLiveMode": "Enable Live Mode", "energyDemand": "Energy Demand", "entireArea": "Entire Area", "responseToYourEnergy": "Respond to your energy demand needs", "searchScenes": "Search Scenes" }, "energy": { "allTimes": "All Times", "allTimesUTC": "All Times UTC", "calculateWith": "Calculated with actual power usage data.", "currentDemand": "Current Demand", "currentYear": "Current Year", "currentNoReport": "Currently there is no energy report for this week", "downloadLastMonthReport": "Download Last Month Report", "download15MinuteReport": "Download 15 Minute Energy Report", "energyUsage": "Energy Usage", "energyReport": "Energy Reports", "energyReportRequestHistory": "Energy Reports Requests History", "fifteenMinuteReport": "Fifteen Minute Report", "hiddenZonesUsing": "Hidden Zones Using", "last7Days": "Last 7 Days", "last30Days": "Last 30 Days", "learnMore": "Learn More", "monthlyUsagePdf": "Daily Energy Report", "noEnergyData": "No Recorded Energy Data For This Selection", "reportReal": "Device Power Data", "reportSynth": "Self-reported Watts Field", "selfReport": "Self-reported power usage.", "smartShiftExplanation": "Some of your zones are part of a Smart Shift schedule and will automatically adjust their color temperature.", "smartShift": "Smart Shift", "warning": "Warning", "weNotice": "We noticed you have Zones that aren't reporting any demand. Either enable Power Monitoring or self-report using the Watts field.", "powerMonitoring": "Power monitoring enabled but no data yet.", "usageCSVReport": "Zone CSV Report", "zonesShareOfAreaUsage": "zones share of area usage: ", "zoneStateHistory": "Zone State History" }, "fault": { "addByEmail": "Add By Email", "addByUser": "Add By User", "addUserOrEmail": "Add User Or Email", "email": "Email", "emailAddress": "Email Address:", "faultNotification": "Fault Notification", "notARegistered": "Not a registered User", "inputEmail": "Input Email:", "select": "Select", "siteName": "Site Name:", "subscribers": "# Subscribers:", "subscribedUserEmails": "Subscribed Users & Emails", "user": "User", "userName": "User Name:" }, "home": { "calculating": "calculating", "currentCost": "Current Cost", "latestActivity": "Latest Activity", "lightcloudSavings": "Lightcloud Savings", "perHour": "per hour", "potentialSavings": "Potential Savings", "viewAllActivity": "View All Activity", "viewMyOtherOrgs": "View My Other Organizations" }, "login": { "userOrEmail": "Username or Email", "signIn": "Sign In", "signingIn": "Signing In...", "password": "Password", "emailAddress": "Email Address", "expired": "Sorry, the request has been expired. Please submit your request again.", "incorrect": "Your email or password was incorrect.", "accountLockedOut": "Your account has been locked. Please contact your administrator.", "forgotYourPassword": "Forgot password?", "getVerificationCodeFailed": "Get verification code failed, please try again.", "getVerificationCode": "Get Verification Code", "mobileNumber": "Mobile Number", "mobileNumberForAuth": "Mobile Number for Authentication", "noConnection": "No Connection to Server", "newPassword": "New Password", "passwordResetEmailSent": "The password reset email has been sent.", "passwordError": "Error! Password must be minimum 12 characters, one uppercase, one lowercase and one number.", "samePassword": "Error! New password must be different from existing one.", "passwordMatching": "Error! Please make sure the passwords you entered are matching.", "passwordRest": "Success! Please try logging in with your new password.", "twoFactorAuth": "Two Factor Authentication", "thisMobileNumberHasBeenVerified": "This mobile number has been verified.", "unableToFindEmail": "Unable to find the provided email.", "validationCode": "Validation Code", "validationCodeHasBeenSentToYourPhone": "Validation Code has been sent to your phone", "verificationCode": "Verification Code", "verifyPhoneNumber": "Verify Phone Number", "verificationCodeHasBeenSentToYourPhone": "Verification code has been sent to your phone.", "verifyPhoneNumberFailed": "Verify phone number failed, please try again.", "goingToLogin": "Going to login in ", "resetPassword": "Reset Password", "reenterPassword": "Re-Enter Password", "logout": "Logout" }, "menu": { "assign": "Create new area", "auto": "Auto Configure", "createMulti": "Create Multi-Zone", "createGroup": "Create Group", "delete": "Delete", "edit": "Edit", "quickAdd": "Quick Add", "rename": "Rename", "switchToLegacy": "Switch to Legacy UI", "toggle": "Toggle Select All", "unassign": "Unassign", "update": "Update" }, "notificationSubjects": { "User": "user", "Zone": "zone", "Area": "area", "Scene": "scene", "Schedule": "Schedule", "Device": "device", "Daylight": "daylight-harvestor", "Node": "node", "notifications": "Notifications", "Gateway": "gateway", "Automation": "automation", "Behavior2": "automation" }, "notificationEvents": { "0": "Event", "1": "Logged In", "2": "Logged Out", "3": "Turned On", "4": "Turned Off", "5": "Dim Changed", "6": "Added To Area", "7": "Removed From Area", "8": "Name Changed", "9": "Name Changed", "10": "Activated By User", "11": "Activated By Device", "12": "Detected Motion", "13": "Added To Area", "14": "Name Changed", "15": "Config Changed", "16": "Joined Site", "17": "ID Button Pressed", "18": "Not Responding", "19": "Lost Power", "20": "Regained Power", "21": "Unavailable", "22": "Available", "23": "Changed", "24": "Reported Aberrant Power Draw", "25": "Gateway Entered Join Mode", "26": "Gateway Exited Join Mode", "27": "Gateway Could Not Reach Backend", "28": "Gateway Sent ECIO", "29": "Gateway Sent RSSI", "30": "Gateway Reported OP Failure", "31": "Gateway Reported Bad Object Graph", "32": "Gateway Reported Event Failed", "33": "Gateway Reported Unknown Node", "34": "Gateway Firmware Update", "35": "Device Firmware Update", "36": "Gateway Message Schedule Activated", "37": "Gateway Message Scene Activated", "38": "Gateway Message Behavior Activated", "41": "Color Temperature Changed", "901": "Setup Mode", "902": "Status", "903": "Reported Current Daylight Value", "904": "Reported Power Value", "905": "State Changed" }, "org": { "accountName": "Account Name", "errors": "# Errors", "payment": "Payment", "sites": "# Sites", "users": "# Users", "warnings": "# Warnings" }, "scenes": { "actions": "Actions", "cct_transition_time": "Color Duration", "demand": "Demand: ", "fadeTime": "Fade Time", "manageScenes": "Manage Scenes", "nextEvent": "Next Event", "selectScene": "Select Scene", "sceneDemand": "Scene demand" }, "schedules": { "addEvent": "Add Event", "addSchedule": "Add Schedule", "areYouSure": "Are you sure you want to delete?", "areYouSureCopy": "Are you sure you want to copy these days?", "byline": "Configure schedules for zones, scenes, and automations.", "selectAnExistingSchedule": "To begin, select an existing schedule from the list on the left, or create a new one by clicking the plus (+) button.", "createSchedule": "Create Schedule", "daysOfTheWeek": "Days of the week", "events": "Events", "manageSchedules": "Manage Schedules", "nextEvent": "Next Event: ", "noEvents": "No Events", "noSchedule": "No Schedule", "repeat": "Repeat", "pleaseSelectDate": "Please select recurrence date detail", "schedules": "Schedules", "scheduleName": "Schedule Name", "scheduledEvents": "Scheduled Events", "selectEvent": "Select Event", "searchForSchedules": "Search Schedules", "selectSchedule": "Select Schedule", "switchToDefaultSchedule": "Switch to Default Schedule", "switchToSmartShift": "Switch to Smart Shift", "toEditThisScheduleUpdate": "To edit this schedule, please update your gateway software. Call Lightcloud support on 1(844) LIGHTCLOUD.", "zoneSceneSchedules": "Zone & Scene Schedules" }, "settings": { "settings": "Settings", "answer": "Answer", "basicUser": "Basic User", "createUser": "Create a User", "changeAndModifyUser": "Change & Modify your User Information", "changePassword": "Change Password", "chooseOwnPassword": "Choose Own Password", "clearForm": "Clear Form", "deleteUser": "Delete User", "editUser": "Edit User", "email": "E-Mail", "firstName": "First Name", "faultNotifications": "Notification Management", "hideAreas": "Hide Areas", "hideZones": "Hide Zones", "lastName": "Last Name", "noZones": "No Zones", "noAreas": "No Areas", "noMoreThan": "and no more 30 characters", "phoneNumber": "Phone Number", "phoneCode": "Phone Code", "permissionsUserManagement": "Permissions Management", "releaseNotes": "Release Notes", "title": "Title", "temporaryPassword": "Temporary Password ", "created": " created.", "reEnterPassword": "Re-Enter Password", "releaseDate": "Release Date", "errorMsg": "Please enter a valid ", "sitePermissions": "Site Permissions", "areaPermissions": "Area Permissions", "zonePermissions": "Zone Permissions", "searchForUsers": "Search for users", "securityQuestion": "Security Question", "securityPin": "Security PIN", "showAreas": "Show Areas", "showZones": "Show Zones", "softwareRelease": "Software Release Notes", "selectAUser": "Select a User", "users": "User", "userManagement": "User Management", "userPermissions": "User Permissions", "useCurrentPassword": "Use Current Password", "useGeneratedPassword": "Use Generated Password", "viewManageFaultNotificationEmail": "View & Manage Fault Notification Emails", "viewYourPhoneCode": "View Your Phone Code", "viewSoftwareRelease": "View Software Release Notes", "version": "Version" }, "sensors": { "searchSensors": "Search Sensors" }, "shows": { "addDevice": "Add Device", "askRABConfigure": "Ask Your RAB Representative to Configure Show Presets", "askRABaddNew": "Please ask your organization's administrator to add new shows", "controlShow": "Control Show", "selectDevice": "Select Devices to Run Shows" }, "site": { "bridged": "Bridged", "searchForSite": "Search for a site", "refreshSiteList": "Refresh Site List", "refreshGatewayList": "Refresh Gateway List", "restartGatewayApp": "Restart Gateway App", "rebootGateway": "Reboot Gateway" }, "updates": { "deviceFirmwareVersionSummary": "Site Devices Firmware Version Summary", "failed": "Failed", "globalFirmwareVersionSummary": "Global Firmware Version Summary", "inProgress": "In Progress", "recentUpdateMessages": "Recent Upgrage Messages", "retrieveGlobal": "Retrieve Global Update Status (can take a while)", "updateAvailable": "Update Available", "upToDate": "Up To Date" }, "zones": { "addAZone": "Add a Zone", "baselineWattage": "Baseline Wattage", "confirmRemove": "Are you sure you want to remove these Zones?", "circuitNumber": "Circuit Number", "dimming": "Dimming", "dismissAlert": "Dismiss Alert", "dismissThisTime": "The operation will dismiss this alert for only this time period.", "dismissThisPeriod": "The operation will dismiss this alert and also reset the baseline wattage.", "faultDetected": "Are you sure you want to clear the fault notification?", "faultDescription": "There is a fault detected in this Zone. If you want to dismiss this alert, click here to check different options.", "groupControl": "Group Control", "maxTrimLevel": "Max Trim Level", "noZone": "No Zones", "noZonesInArea": "There are no Zones in Area", "inputWatts": "Input Watts", "noAssignedZones": "There are no unassigned Zones.", "resetBaseline": "& Reset Baseline", "searchByNameOrId": "Search by Name or ID", "setAllZones": "Set All Zones", "zones": "Zones", "zone": "Zone", "zoneName": "Zone Name", "zoneSettings": "Zone Settings" }, "#": { "0": "0", "1": "Healthy", "480v-controller": "480v Controller", "automations_enabled": "Automation On", "automations_supported": "Automation Ready", "ceiling-sensor": "Ceiling Sensor", "className": "Device Type", "controller": "Controller", "controller-mini": "Controller Mini", "controller_health_flagged": "Controller Health", "daylighting_enabled": "Daylighting On", "daylighting_supported": "Daylighting Ready", "daylight-harvester": "Daylight Harvester", "demand_response": "Demand Response", "dimmer": "Dimmer", "dimmer-v2": "Dimmer V2", "driver-plus": "Driver Plus", "emergency_mode": "Emergency Mode", "enabled": "Enabled", "false": "No", "fault_recipients_alerted": "Fault Alerted", "fixture-controller": "Fixture Controller", "fixture_health_detection": "Fault Detected", "full_power_reading": "Full Power Reading", "gateway": "Gateway", "high-bay-sensor": "High Bay Sensor", "indicating": "Indicating", "is_active": "Active User", "is_dimmable": "Dimmable", "is_staff": "Staff", "is_superuser": "Superuser", "last_firmware_version": "Firmware Version", "lclc3gen2": "LC 3 Gen 2", "light-show": "Light Show", "mac_addr": "Mac Address", "node_health": "Device Health", "phase-cut-dimmer": "Phase Cut Dimmer", "power_draws_by_decile_as_dictionary": "Has Calibration", "power_reporting": "Power Reporting", "reported_dim_level": "Dim Level", "smartdriver": "Smart Driver", "touch": "Touch", "trim_high": "Trim High", "trim_low": "Trim Low", "true": "Yes", "tunable-lamp": "Tunable Lamp", "twistlock": "Twistlock", "zone_health": "Zone Health", "zone_state": "Zone State" } };
});
$__System.registerDynamic("230", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = { "rab": "RAB!", "common": { "add": "添加", "all": "全部", "apply": "应用", "activity": "活动记录", "activityLog": "活动记录", "assign": "指定", "back": "后退", "behaviors": "行为", "cancel": "取消", "close": "关闭", "clear": "清除", "confirm": "确认", "confirmDelete": "确认删除", "control": "控制", "delete": "删除", "deleting": "删除中", "siteScenes": "需求响应", "device": "设备", "devices": "设备", "disabled": "关闭", "done": "完成", "doneEditAll": "完成编辑", "edit": "编辑", "editAll": "编辑全部", "energy": "能耗", "errors": "错误", "event": "事件", "goSite": "管理", "indicate": "指示", "language": "语言: ", "loadingEllipsis": "加载...", "location": "位置", "logout": "登出", "max": "最大值", "mins": "分钟", "organize": "组织", "overview": "概况", "on": "开启", "off": "关闭", "plural": " ", "remove": "移除", "rename": "重命名", "renaming": "重命名中", "repeat": "重复", "unassign": "移除", "update": "升级", "save": "保存", "saving": "保存中", "set": "设定", "schedule": "计划", "schedules": "计划", "scenes": "场景", "selectAnExisting": "选择已有的需求响应或点击“加”按钮创建一个", "selecting": "应用中", "setup": "设备", "sensors": "传感器", "search": "搜索", "success": "成功!", "view": "查看", "viewAll": "查看全部", "working": "处理中", "uniqueName": "名称必须是唯一的" }, "area": { "allAreas": "所有区域", "areaName": "区域名称", "delete": "您确定要删除这些区域以及它们的局域么?", "editArea": "编辑区域", "renameArea": "重命名区域", "searchForArea": "搜索局域", "unique": "区域名称必须独特唯一", "unassignedZone": "未指定的局域", "viewYourScenes": "查看您的场景" }, "automation": { "addAutomation": "添加自动控制", "addAction": "添加动作", "automation": "自动", "automations": "自动控制", "automationSchedules": "智能计划", "choseTriggerMode": "选择触发模式设定自动控制", "whenTriggerIs": "当触发器是", "whenTheLightLevelIs": "当灯光强度是", "whenSensorIndicate": "当传感器指示", "zoneSceneSchedule": "局域 & 场景计划" }, "behaviors": { "sensorSearch": "搜索传感器" }, "billing": { "addCard": "添加银行卡", "amount": "金额", "balance": "余额", "billing": "账单", "billData": "账单数据", "billingHistory": "账单历史", "billSMS": "账单SMS", "billVoice": "Bill Voice", "currentUsage": "当前用量", "createServicePlan": "创建服务计划", "date": "日期", "noActiveCoupons": "无可用优惠券", "paid": "支付", "paymentDetails": "付款详情", "paymentNotSaved": "付款信息未保存", "prelude": "先导", "savePaymentMethod": "保存付款信息", "servicePlan": "服务方案", "selectAPlan": "-- 选择服务方案时限 --", "summary": "汇总", "terminalId": "终端ID", "year": "年" }, "customerService": { "accountAdministrator": "账户管理员", "accountOverview": "账户概况", "addAccountAdministrator": "添加账户管理员", "address": "地址", "address1": "地址第一行", "address2": "地址第二行", "allFieldsRequired": "所有栏目都必填,不允许特殊符号", "applyCredit": "Apply Credit", "city": "城市", "createHardInvoice": "Create Hard Invoice", "confirmCredit": "Confirm Credit", "company": "公司", "description": "描述", "deleteThisOrg": "删除这个机构", "deleteThisSite": "删除这个站", "details": "详情", "editOrg": "编辑机构", "electricianInfo": "电工信息", "eg": "例如：我的办公室", "gateways": "网关", "gatewayVersion": "网关版本: ", "globalSettings": "全局设置", "gotoThisSite": "前往这个站", "lightcloudCustomerSercive": "Lightcloud客户服务", "lastMonthCellUsage": "上个账单周期移动流量", "name": "名字", "invoicing": "Invoicing", "organizationName": "机构名称", "organizationTimeout": "机构延迟", "rates": "估价", "saveFailed": "保存失败", "setPaymentMethod": "设定付费方式", "setTaxRates": "设定税率", "setupMode": "设定模式: ", "servicePlan": "服务方案", "searchOrgs": "搜索机构", "selectAPayment": "-- 选择一个支付方式 --", "selectAnOrg": "-- 选择一个机构 --", "sites": "站", "siteName": "站命", "state": "州", "stateCode": "状态：['请确保此字段不超过 2 个字符。']", "pincode": "通行码", "zipCode": "邮编", "thisGatewayIsUnavailable": "这个网关不可用", "twoCharacterState": "双字母州名", "users": "用户", "useOrgAddress": "使用机构地址", "viewRates": "查看估价", "zip": "邮编" }, "devices": { "allDevices": "所有设备", "activityLogEmpty": "活动记录不存在", "actionBtn": "", "addDevicesMode": "添加设备模式", "addDeviceModeHint": "这个站处在添加设备模式", "advance_trigger": "占用本地模式", "advance_trigger_no_actuator": "占用自定义", "afterLostSignal": "失去信号后", "afterPowerLoss": "失去电力后", "ambientLightSensorSensitivity": "环境光线传感器灵敏度", "alsReport": "ALS报告", "AssignToExisting": "指定给已存在的区域", "blinkBeforeUnoccupied": "未占用前闪烁", "calibrateEnergy": "校准能耗", "calibrateAllDevices": "校准所有设备", "calibrationIniciated": "校准初始化成功", "checkForFirmwareUpdate": "检查固件可用升级", "controller": "控制器", "custom": "自定义", "cellType": "移动网络类型", "createNewArea": "创建新区域并指定", "downloadDeviceTable": "下载设备表单", "daylightAverageSinceLastValue": "上一日光值后平均日光值", "daylightAverageValue": "日光平均值", "daylightvalue": "日光值", "deleteDevice": "删除设备", "deviceId": "设备ID", "deviceICCID": "设备ICCID", "deviceMode": "设备模式", "deviceSettings": "设备设置", "dimmer": "调光器", "dimmingCurve": "调光曲线", "dimmerOffSlopeTime": "dimmer off slope time", "digiFirmware": "DIGI固件", "disabled": "关闭", "enabled": "开启", "existingDevices": "现有设备", "faultNotificationThreshold": "预警阈值", "fullPowerReading": "全部能耗读数", "footCandles": "英尺烛光", "gatewayMAC": "网关MAC", "gatewayID": "网关ID", "greaterThan": "大于或等于", "hideAdvanced": "隐藏高级设置", "health": "健康", "info": "信息", "indicatorLED": "指示灯", "last": "最终状态", "latLong": "Lat Long", "lastState": "最终状态", "lastOnLevel": "最终所在等级", "last_on": "最终所在等级", "lostSignal": "失去信号", "lessThan": "小于", "linear": "Linear", "lightsOn": "开启灯光", "lightsOff": "关闭灯光", "LCDeviceType": "LC设备类型", "LCVersion": "LC版本", "mainTitle": "主要名称", "micEnable": "MIC开启", "microphoneSensor": "麦克风传感器", "newDevices": "新设备", "no_actuator": "自定义", "uncommissionedDevices": "未指定的设备", "update": "升级", "updateAllDevices": "升级所有设备", "updateMultipleDevices": "升级部分设备", "occupancy": "占用", "occupancyCustom": "占用自定义", "occupancyLocal": "占用本地模式", "occupancy_led_enable": "指示灯LED", "off": "关", "offlineNotification": "离线通知", "offlineNotificationThreshold": "离线通知阈值", "offToUnoccupied": "Off To Unoccupied", "panId": "Pan ID", "passcode": "安全码", "passcodeEnabled": "通行码开启", "powerReportInterval": "能源报告间隔", "powerDrawsByDecile": "Power Draws by Decile", "powerMonitoring": "能耗监控", "powerLossMode": "Power Loss Mode", "powerUpState": "电力恢复状态", "previousSet": "上次设定", "scene": "场景", "searchDevices": "搜索设备", "selectDeviceLeft": "请从左侧选择一个设备。", "setPowerLossModeValue": "Set Power Loss Mode Value", "setupMode": "设置模式", "sensitivity": "敏感度", "siteId": "站ID", "siteCreationDate": "网站创建日期", "softDim": "软调节", "showAdvanced": "显示高级设置", "startCalibration": "开始校准", "clearCalibration": "清除校准", "switch": "switch", "square": "square", "squareRoot": "Square Root", "subTitle": "次要名称", "screenBrightness": "屏幕亮度", "screenLockTimeout": "屏幕锁延时", "repeatInMinutes": "分钟重复", "repeater": "重复器", "reentryTimeout": "再次进入延迟", "timeout": "延迟", "testMode": "测试模式", "temperatureSensor": "温度传感器", "trigger": "触发器", "whenOccupied": "当占用时", "whenUnoccupied": "当未占用时", "vacancy": "闲置", "visible_in_control": "负载模式", "zoneName": "局域名称", "device_mode": "设备模式", "power_report": "Power Monitoring", "default_actuator_state": "Lost Signal", "false": "关闭", "true": "开启", "description": "描述", "test_mode": "测试模式", "pirSensitivity": "灵敏度", "turn_off_time_delay": "延迟", "max_dimmer_level": "当占用", "min_dimmer_level": "当空闲", "blink_number": "空闲前闪烁", "vacancies_mode_return_time": "再次进入延迟", "power_report_frequency": "能耗报告间隔", "dimming_curve_type": "暗淡曲线", "als_sensitivity": "Ambient Light Sensor", "dimmer_off_slope_time": "Dimmer Off Slope Time", "temp_sensor_report_enable": "温度传感器", "als_report_enable": "ALS报告", "passcode_enable": "安全码开启", "xbeeFirmwareVersion": "XBee固件版本" }, "demand": { "activate": "启动", "activated": "已启动", "addZone": "添加局域", "creatPreSet": "创建跨多局域的预设动作集", "siteScenes": "场景", "siteScenesScenes": "场景", "demandResponse": "需求响应", "demandResponseScenes": "需求响应场景", "disableLiveMode": "关闭实时模式", "enableLiveMode": "开启实时模式", "energyDemand": "能耗需求", "entireArea": "整个区域", "responseToYourEnergy": "响应您的能耗需求", "searchScenes": "搜索场景" }, "energy": { "calculateWith": "用实际能量相关数据计算。", "currentDemand": "当前需求", "currentYear": "当前年分", "currentNoReport": "当前没有这周的能耗报告", "downloadLastMonthReport": "下载上月能耗报告", "download15MinuteReport": "下载15分钟能耗报告", "energyByZone": "局域的能耗", "energyUsage": "能量用量", "energyReport": "能量报告", "energyReportRequestHistory": "能源報告請求歷史", "last7Days": "过去7天", "last30Days": "过去30天", "learnMore": "获取更多信息", "selfReport": "能耗自报告。", "warning": "警告", "weNotice": "我们发现您的一些局域没有需求报告。打开能耗监控或者在瓦特区域开启自报告。", "powerMonitoring": "能耗监控开启但是没有实际数据。", "zonesShareOfAreaUsage": "局域占整个区域比例：" }, "fault": { "addByEmail": "通过电子邮箱添加", "addByUser": "通过用户添加", "addUserOrEmail": "添加用户或电子邮箱", "email": "电子邮箱", "emailAddress": "电子邮箱地址:", "faultNotification": "故障提醒", "notARegistered": "非注册用户", "inputEmail": "输入Email:", "select": "选择", "siteName": "站名:", "subscribers": "# 订阅者:", "subscribedUserEmails": "已订阅的用户和电子邮箱", "user": "用户", "userName": "用户名:" }, "login": { "userOrEmail": "用户名或邮箱", "signIn": "登入", "signingIn": "登入中...", "password": "密码", "emailAddress": "邮箱地址", "expired": "对不起，请求已过期。请重新提交请求。", "incorrect": "您的邮箱或密码不正确", "accountLockedOut": "你的账户被锁了。请联系您的管理员。", "forgotYourPassword": "忘记密码?", "getVerificationCodeFailed": "获取验证码失败，请重试。", "getVerificationCode": "获取验证码", "mobileNumber": "手机号码", "mobileNumberForAuth": "验证所用手机号码", "noConnection": "无法连接服务器", "newPassword": "新密码", "passwordResetEmailSent": "密码重置邮件已发出", "passwordError": "错误！密码必须至少包含 12 个字符，一个大写字母、一个小写字母和一个数字。", "samePassword": "错误！新密码必须与现有密码不同。", "passwordMatching": "错误！请确保您输入的密码一致。", "passwordRest": "重置密码成功！请用新密码重新登入", "twoFactorAuth": "二元认证", "thisMobileNumberHasBeenVerified": "此手机号码验证成功。", "unableToFindEmail": "无法找到匹配的邮箱地址", "validationCode": "验证码", "validationCodeHasBeenSentToYourPhone": "验证码已经发送到您的手机", "verificationCode": "验证码", "verifyPhoneNumber": "验证手机号码", "verificationCodeHasBeenSentToYourPhone": "验证码已经发送到您的手机。", "verifyPhoneNumberFailed": "验证手机号码失败，请重试", "goingToLogin": "前往登入界面", "resetPassword": "重设密码", "reenterPassword": "再次输入密码", "logout": "登出" }, "notificationSubjects": { "User": "用户", "Zone": "局域", "Area": "区域", "Scene": "场景", "Device": "设备", "Node": "节点", "notifications": "通知", "Gateway": "网关", "Automation": "自动控制" }, "menu": { "assign": "创建新区域", "auto": "自动设置", "createMulti": "Create Multi-Zone", "createGroup": "创建组", "delete": "删除", "edit": "编辑", "quickAdd": "快速添加", "rename": "重命名", "toggle": "Toggle Select All", "unassign": "Unassign", "update": "升级" }, "notificationEvents": { "0": "事件", "1": "登入", "2": "登出", "3": "打开", "4": "关闭", "5": "Dim Changed", "6": "添加至区域", "7": "从区域中移除", "8": "名字改变", "9": "名字改变", "10": "被用户启动", "11": "被设备启动", "12": "检测到动作", "13": "添加至区域", "14": "名字改变", "15": "确认更改", "16": "加入站", "17": "ID按钮按下", "18": "没有响应", "19": "Lost Power", "20": "Regained Power", "21": "不可用", "22": "可用", "23": "改变", "24": "报告能耗异常变动", "901": "设置模式", "902": "状态" }, "org": { "accountName": "账户名称", "errors": "# 错误", "payment": "付款", "sites": "# 站", "users": "# 用户", "warnings": "# 警告" }, "scenes": { "actions": "动作", "demand": "需求: ", "manageScenes": "管理场景", "nextEvent": "下一个事件", "selectScene": "选择场景", "sceneDemand": "场景需求" }, "schedules": { "addEvent": "添加事件", "addSchedule": "添加计划", "areYouSure": "您确定删除么?", "areYouSureCopy": "您确定要复制这些天的内容么?", "byline": "配置区域、场景和自动化的时间表。", "selectAnExistingSchedule": "首先，从左侧列表中选择一个现有计划，或者单击加号 (+) 按钮创建一个新的计划。", "createSchedule": "创建计划", "daysOfTheWeek": "星期日程", "events": "事件", "manageSchedules": "管理计划", "nextEvent": "下一个事件: ", "noEvents": "无事件", "noSchedule": "无计划", "repeat": "重复", "pleaseSelectDate": "请选择日期详情", "schedules": "Schedules", "scheduleName": "计划名称", "scheduledEvents": "已计划的事件", "selectEvent": "选择事件", "searchForSchedules": "搜索计划", "selectSchedule": "选择计划", "toEditThisScheduleUpdate": "为了编辑计划,请升级你的网关. 致电Lightcloud 1(844) LIGHTCLOUD获取更多帮助.", "zoneSceneSchedules": "局域及场景计划" }, "settings": { "settings": "设置", "answer": "答案", "basicUser": "基本用户", "createUser": "创建用户", "changeAndModifyUser": "更改或者调整用户信息", "changePassword": "更改密码", "chooseOwnPassword": "选择自定义密码", "deleteUser": "删除用户", "editUser": "编辑用户", "email": "E-Mail", "firstName": "名字", "faultNotifications": "通知管理", "hideAreas": "隐藏区域", "hideZones": "隐藏局域", "lastName": "姓氏", "noZones": "无局域", "noAreas": "无区域", "noMoreThan": "并且不超过30个字符", "phoneNumber": "电话号码", "phoneCode": "电话验证码", "permissionsUserManagement": "权限管理", "releaseNotes": "版本日志", "title": "名称", "temporaryPassword": "临时密码 ", "created": " 创建了。", "reEnterPassword": "再次输入密码", "releaseDate": "发布时间", "errorMsg": "请输入一个有效的", "sitePermissions": "站权限", "areaPermissions": "区域权限", "zonePermissions": "局域权限", "searchForUsers": "搜索用户", "securityQuestion": "安全问题", "securityPin": "安全码", "showAreas": "显示区域", "showZones": "显示局域", "softwareRelease": "软件版本日志", "selectAUser": "选择一个用户", "users": "用户", "userManagement": "用户管理", "userPermissions": "用户权限", "useCurrentPassword": "使用当前的密码", "useGeneratedPassword": "使用生成的密码", "viewManageFaultNotificationEmail": "查看 & 管理故障提示邮件", "viewYourPhoneCode": "查看你的电话通行码", "viewSoftwareRelease": "查看软件版本日志", "version": "版本" }, "sensors": { "searchSensors": "搜索传感器" }, "site": { "searchForSite": "搜索站", "refreshSiteList": "刷新站列表", "refreshGatewayList": "刷新网关列表" }, "zones": { "addAZone": "添加一个局域", "baselineWattage": "基准功率", "confirmRemove": "你确定想要移除这些局域?", "circuitNumber": "电路编码", "dimming": "调光", "dismissAlert": "解除警告", "dismissThisTime": "此操作只会在一段时间内解除警告。", "dismissThisPeriod": "此操作不仅会解除此警告，并且会将基准功率重新校准以适应新的能耗需求。", "faultDetected": "你确认要清空提醒么", "faultDescription": "在这个局域中检测到故障。如果你想要解除警告，点击这里选择不同的选项。", "groupControl": "组群控制", "maxTrimLevel": "预设最大值", "noZone": "没有局域", "noZonesInArea": "这里区域中没有任何局域", "inputWatts": "输入瓦特", "noAssignedZones": "没有未指派的局域", "resetBaseline": "同时重置基准功率", "searchByNameOrId": "以名称或ID搜索", "setAllZones": "设定全部局域", "zones": "局域", "zone": "局域", "zoneName": "局域名称", "zoneSettings": "局域设定" }, "advance_trigger": "占用本地模式", "advance_trigger_no_actuator": "占用自定义", "controller": "控制器", "dimmer": "调光器", "no_actuator": "自定义", "scene": "场景", "occupancy": "占用", "trigger": "触发器", "repeater": "重复器", "vacancy": "闲置", "#": { "0": "0", "1": "健康", "className": "设备类型", "automations_enabled": "自动化开启", "automations_supported": "支持自动化", "daylighting_enabled": "Daylighting On", "daylighting_supported": "Daylighting Ready", "daylight-harvester": "Daylight Harvester", "demand_response": "Demand Response", "enabled": "开启", "is_active": "活跃用户", "is_staff": "员工", "is_superuser": "超级用户", "last_firmware_version": "固件版本", "node_health": "设备健康", "controller": "控制器", "ceiling-sensor": "天花板传感器", "high-bay-sensor": "High Bay Sensor", "fixture-controller": "设备控制器", "phase-cut-dimmer": "Phase Cut Dimmer", "touch": "Touch", "dimmer": "Dimmer", "true": "是", "false": "否", "controller_health_flagged": "控制器健康度", "fault_recipients_alerted": "故障已提醒", "fixture_health_detection": "故障监测", "emergency_mode": "紧急模式", "indicating": "指示中", "is_dimmable": "亮度可调节", "power_reporting": "Power Reporting", "reported_dim_level": "亮度值", "trim_high": "Trim High", "trim_low": "Trim Low", "zone_health": "局域健康", "zone_state": "局域状态" } };
});
$__System.registerDynamic("231", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = { "rab": "RAB!", "common": { "add": "Agregar", "all": "Todo", "apply": "Aplicar", "activity": "Actividad", "activityLog": "Récord de Actividad", "assign": "Asignar", "back": "Ir atrás", "behaviors": "Comportamiento", "cancel": "Cancelar", "close": "Cerrar", "clear": "Borrar", "confirm": "Confirm", "confirmDelete": "Confirmar Eliminación", "control": "Control", "delete": "Eliminar", "deleting": "Deleting", "siteScenes": "Respuesta a Demanda", "device": "Dispositivo", "devices": "Dispositivos", "disabled": "Deshabilitado", "done": "Completo", "doneEditAll": "Done Edit All", "edit": "Edit", "editAll": "Edit All", "energy": "Energía", "errors": "Errores", "event": "event", "goSite": "Manage", "home": "Inicio", "indicate": "Indicar", "language": "language: ", "loadingEllipsis": "Cargando...", "location": "Locación", "logout": "Cerrar sesión", "max": "Max", "mins": "MINs", "organize": "Organizar", "overview": "Resumen", "on": "Encender", "off": "Apagar", "plural": "s", "remove": "Remover", "rename": "Renonmbrar", "renaming": "Renaming", "repeat": "Repetir", "unassign": "Unassign", "update": "Actualizar", "save": "Guardar", "saving": "Saving", "set": "Colocar", "schedule": "Horario", "schedules": "Horarios", "scenes": "Escenas", "selectAnExisting": "Seleccionar respuesta a existente o crear una nueva con el botón de más", "selecting": "Selecting", "setup": "Devices", "sensors": "Sensores", "search": "Search", "success": "¡Éxito!", "view": "Ver", "viewAll": "Ver Todo", "working": "Working", "uniqueName": "El nombre debe ser único" }, "area": { "allAreas": "Todas Las Áreas", "areaName": "Nombre del Área", "delete": "¿Está seguro que quiere eliminar todas éstas Áreas y sus Zonas?", "editArea": "Editar Área", "renameArea": "Renombrar Área ", "searchForArea": "Buscar Áreas", "unique": "Nombres para el Área deben ser únicos", "unassignedZone": "Zona sin asignar", "viewYourScenes": "Vea sus Escenas" }, "automation": { "addAutomation": "Agregar Automatización", "addAction": "Agregar Acción", "automation": "automation", "automations": "automatizaciones", "automationSchedules": "Automation Schedules", "choseTriggerMode": "Escoger modo de operación para establecer automatización", "whenTriggerIs": "cuando la operación es", "whenTheLightLevelIs": "cuando el nivel de luz es", "whenSensorIndicate": "cuando el sensor indica", "zoneSceneSchedule": "Zone & Scene Schedules" }, "behaviors": { "sensorSearch": "Buscar Sensores" }, "billing": { "addCard": "Agregar Tarjeta", "amount": "Cantidad", "balance": "Balance", "billing": "Cargos", "billData": "Información de Cargos", "billingHistory": "Historial de Cargos", "billSMS": "Mensajes de texto de Cargos", "billVoice": "Voz de Cargos", "currentUsage": "Uso Actual", "createServicePlan": "Crear Plan de Servicio", "date": "Fecha", "noActiveCoupons": "No hay Cupones Activos", "paid": "Pagado", "paymentDetails": "Detalles de Pago", "paymentNotSaved": "Pago Sin Guardar", "prelude": "Preludio", "savePaymentMethod": "Guardar Método de Pago", "servicePlan": "Plan de Servicio", "selectAPlan": "—Escoger la Duración del Plan--", "summary": "Resumen", "terminalId": "Identificación Final", "year": "año" }, "customerService": { "accountAdministrator": "Administrador de la Cuenta", "accountOverview": "Resumen de la Cuenta", "addAccountAdministrator": "Agregar Admistrador(es) de la Cuenta", "address": "Dirección", "address1": "Dirección Línea 1", "address2": "Dirección Línea 2", "allFieldsRequired": "Todos los campos son requeridos, No se permiten caracteres especiales", "applyCredit": "Aplicar Crédito", "city": "Ciudad", "createHardInvoice": "Crear Factura Impreso", "confirmCredit": "Confirmar Crédito", "company": "Compañía", "description": "Descripción", "deleteThisOrg": "Eliminar Esta Organización", "deleteThisSite": "Eliminar Esta Página", "details": "Detalles", "editOrg": "Editar Org", "electricianInfo": "Información del Electricista", "eg": "e.g 'My oficina en casa'", "gateways": "Portales", "gatewayVersion": "Versión de Portales: ", "globalSettings": "Ajustes Globales", "gotoThisSite": "Ir a Esta Página", "lightcloudCustomerSercive": "Servicio al Cliente de Lightcloud", "lastMonthCellUsage": "Uso de Celular en el Último Mes", "name": "Nombre", "invoicing": "Facturar", "organizationName": "Nombre de Organización", "organizationTimeout": "Tiempo de Descanso de la Organización", "rates": "Tarifas", "saveFailed": "Error al Guardar", "setPaymentMethod": "Escoger Método de Pago", "setTaxRates": "Escoger Tarifa de Impuesto", "setupMode": "Modo de Inicio", "servicePlan": "Plan de Servicio", "searchOrgs": "Buscar Orgs", "selectAPayment": "—Escoger Opción de Pago --", "selectAnOrg": "—Seleccionar una Org --", "sites": "Páginas", "siteName": "Nombre de la Página", "state": "Estado", "stateCode": "Estado: ['Asegúrese de que este campo no tenga más de 2 caracteres.']", "pincode": "Número de Pin", "zipCode": "Código Postal", "thisGatewayIsUnavailable": "Este Portal No Está Disponible en este momento", "twoCharacterState": "Estado en Dos Caracteres", "users": "Usuarios", "useOrgAddress": "Usar Dirección de la Org", "viewRates": "Ver Tarifas", "zip": "Zip" }, "devices": { "allDevices": "Todos los Dispositivos", "activityLogEmpty": "Récord de Actividad Vacío", "actionBtn": "", "addDevicesMode": "Modo para Agregar Dispositivos", "addDeviceModeHint": "Esta página está en el Modo para Agregar Dispositivos", "advance_trigger": "Occupancy Local", "advance_trigger_no_actuator": "Occupancy Custom", "afterLostSignal": "After Lost Signal", "afterPowerLoss": "After Power Loss", "ambientLightSensorSensitivity": "Sensor de sensibilidad de luz ambiental", "alsReport": "Reporte ALS", "AssignToExisting": "Asignar a un Área Existente", "blinkBeforeUnoccupied": "Blink Before Unoccupied", "calibrateEnergy": "Calibrar Energía", "calibrateAllDevices": "Calibrate All Devices", "calibrationIniciated": "Inización de Calibración Exitosa", "checkForFirmwareUpdate": "Revisar Actualización del Firmware", "controller": "Control", "custom": "Personalizar", "cellType": "Tipo de Celular", "createNewArea": "Crear Nueva Área y Asignar", "downloadDeviceTable": "Descargar Tabla del Dispositivo", "daylightAverageSinceLastValue": "Promedio de Luz Natural desde el último valor", "daylightAverageValue": "Valor Promedio de Luz Natural", "daylightvalue": "Valor de Luz Natural", "deleteDevice": "Eliminar Dispositivo", "deviceId": "Identification del Dispositivo", "deviceICCID": "ICCID del Dispositivo", "deviceMode": "Modo del Dispositivo", "deviceSettings": "Ajustes del Dispositivo", "dimmer": "Regulador de intensidad", "dimmingCurve": "Curva de Regulación de Intensidad", "dimmerOffSlopeTime": "Pendiente de Tiempo de Atenuación", "digiFirmware": "DIGI Firmware", "disabled": "Deshabilitado", "enabled": "Habilitado", "existingDevices": "Dispostivos Existentes", "faultNotificationThreshold": "Alert Threshold", "fullPowerReading": "Lectura de Energía completa", "footCandles": "Pie-candela", "gatewayMAC": "Portal de MAC", "gatewayID": "Portal de Identificación", "greaterThan": "Más grande o igual a", "hideAdvanced": "Esconder Avanzado", "health": "Salud", "info": "Información", "indicatorLED": "Indicator LED", "last": "Last State", "latLong": "Lat Long", "lastState": "Last State", "lastOnLevel": "Last On Level", "last_on": "Last On Level", "lostSignal": "Señal Perdida", "legacyUpdate": "Actualización Heredada", "lessThan": "menos que", "linear": "Lineal", "lightsOn": "Encender Luces", "lightsOff": "Apagar Luces", "LCDeviceType": "Dispositivo Tipo LC", "LCVersion": "Versión LC", "mainTitle": "Título Principal", "masterDevicesControls": "Controles de Dispositivos Maestros", "micEnable": "Habilitar MIC", "microphoneSensor": "Microphone Sensor", "newDevices": "Nuevos Dispositivos", "no_actuator": "Custom", "uncommissionedDevices": "Dispositivos Sin Agregar", "update": "Actualizar", "updateAllDevices": "Actualizar Todos los Dispositivos", "updateMultipleDevices": "Actualizar Múltiples Dispositivos", "occupancy": "Ocupantes", "occupancyCustom": "Occupancy Custom", "occupancyLocal": "Occupancy Local", "occupancy_led_enable": "Indicator LED", "off": "off", "offlineNotification": "Offline Notification", "offlineNotificationThreshold": "Offline Notification Threshold", "offToUnoccupied": "Off To Unoccupied", "panId": "Identificación PAN", "passcode": "Passcode", "passcodeEnabled": "Código de Acceso Habilitado", "powerReportInterval": "Intervalo del Reporte de Energía", "powerDrawsByDecile": "Extracción de Energía en Décimos", "powerMonitoring": "Supervisión de Energía", "powerLossMode": "Modo de Pérdida de Energía", "powerUpState": "Power Up State", "previousSet": "Set Previo", "scene": "Scene", "searchDevices": "Buscar Dispositivos", "selectDeviceLeft": "Por favor seleccione un dispositivo a la izquierda.", "setPowerLossModeValue": "Seleccionar el Valor del Modo de Pérdida de Energía", "setupMode": "Modo de Inicio", "sensitivity": "Sensibilidad", "siteId": "Identificación de la Página", "siteCreationDate": "Fecha de Creación del Sitio", "softDim": "Atenuación Suave", "showAdvanced": "Mostrar Avanzado", "startCalibration": "Iniciar Calibración", "clearCalibration": "Calibración Clara", "switch": "interruptor", "square": "cuadrado", "squareRoot": "Raíz Cuadrada", "subTitle": "Subtítulo", "screenBrightness": "Brillo de la Pantalla", "screenLockTimeout": "Tiempo de Descanso del Block de la Pantalla", "repeatInMinutes": "Repetir En Minutos", "repeater": "Repetidor", "reentryTimeout": "Re-seleccionar Tiempo de Descanso", "timeout": "Tiempo de Descanso", "testMode": "Modo de Prueba", "temperatureSensor": "Sensor de temperatura", "trigger": "Hacer funcionar", "whenOccupied": "Cuando esté Ocupado", "whenUnoccupied": "Cuando esté Desocupado", "vacancy": "Vacante", "visible_in_control": "Load Mode", "zoneName": "Zone Name", "device_mode": "Device Mode", "power_report": "Power Monitoring", "default_actuator_state": "Lost Signal", "false": "Off", "true": "on", "description": "Description", "test_mode": "Test Mode", "pirSensitivity": "Sensitivity", "turn_off_time_delay": "Timeout", "max_dimmer_level": "When Occupied", "min_dimmer_level": "When Unoccupied", "blink_number": "Blink before Unoccupied", "vacancies_mode_return_time": "Re-Enter Timeout", "power_report_frequency": "Power Report Interval", "dimming_curve_type": "Dimming Curve", "als_sensitivity": "Ambient Light Sensor", "dimmer_off_slope_time": "Dimmer Off Slope Time", "temp_sensor_report_enable": "Temperature Sensor", "als_report_enable": "ALS Report", "passcode_enable": "Passcode Enable", "xbeeFirmwareVersion": "XBee Firmware Version" }, "demand": { "activate": "Activar", "activated": "Activado", "addZone": "Agregar Zona", "creatPreSet": "Create pre-set collections of actions across multiple zones", "siteScenes": "Scenes", "siteScenesScenes": "Scenes", "demandResponse": "Demand Response", "demandResponseScenes": "Demand Response Scenes", "disableLiveMode": "Deshabilitar Modo En Vivo", "enableLiveMode": "Habilitar Modo En Vivo", "energyDemand": "Demanda de Energía", "entireArea": "Área Completa", "responseToYourEnergy": "Responder a sus necesidades de demanda de energía", "searchScenes": "Buscar Escenas" }, "energy": { "calculateWith": "Calculada con datos actuales del uso de energía.", "currentDemand": "Demanda Presente", "currentYear": "Año Presente", "currentNoReport": "En este momento no hay un reporte de energía para esta semana", "downloadLastMonthReport": "Descargar Reporte del Último Mes", "download15MinuteReport": "Descargar Reporte de Energía de 15 Minutos", "energyByZone": "Energy By Zone", "energyUsage": "Uso de Energía", "energyReport": "Reporte de Energía", "energyReportRequestHistory": "Historial de solicitudes de informes de energía", "last7Days": "Últimos 7 Días", "last30Days": " Últimos 30 Días", "learnMore": "Aprender Más", "selfReport": "Auto-reporte de Uso de energía.", "warning": "Advertencia", "weNotice": "Hemos notado que tiene Zonas que no están reportando ninguna demanda. Habilite la Supervisión de Energía o Auto-reporte usando el campo de Watts.", "powerMonitoring": "Supervisión de Energía está habilitada pero no hay datos todavía.", "zonesShareOfAreaUsage": "zones share of area usage: " }, "fault": { "addByEmail": "Add By Email", "addByUser": "Add By User", "addUserOrEmail": "Add User Or Email", "email": "Email", "emailAddress": "Email Address:", "faultNotification": "Fault Notification", "notARegistered": "Not a registered User", "inputEmail": "Input Email:", "select": "Select", "siteName": "Site Name:", "subscribers": "# Subscribers:", "subscribedUserEmails": "Subscribed Users & Emails", "user": "User", "userName": "User Name:" }, "home": { "latestActivity": "Última Actividad", "viewAllActivity": "Ver Toda la Actividad", "viewMyOtherOrgs": "Ver Mis Otras Organizaciones" }, "login": { "userOrEmail": "Usuario o correo electrónico", "signIn": "Iniciar Sesión", "signingIn": "Iniciando Sesión...", "password": "Contraseña", "emailAddress": "Correo Electrónico", "expired": "Lo sentimos, su solicitud ha expirado. Por favor envíela otra vez.", "incorrect": "Su correo electrónico o contraseña es incorrecto.", "accountLockedOut": "Su cuenta ha sido bloqueada. Por favor contacte a su administrador.", "forgotYourPassword": "¿Olvidó su contraseña?", "getVerificationCodeFailed": "Get verification code failed, please try again.", "getVerificationCode": "Get Verification Code", "mobileNumber": "Mobile Number", "mobileNumberForAuth": "Mobile Number for Authentication", "noConnection": "No Hay Conección al Servidor", "newPassword": "Contraseña Nueva", "passwordResetEmailSent": "El correo electrónico con su contraseña nueva ha sido enviado.", "passwordError": "¡Error! La contraseña debe tener al menos 12 caracteres: una mayúscula, una minúscula y un número.", "samePassword": "¡Error! La nueva contraseña debe ser diferente de la actual.", "passwordMatching": "¡Error! Por favor asegúrese que las contraseñas que usó sean las mismas.", "passwordRest": "¡Éxito! Por favor trate de iniciar la sesión con su contraseña nueva.", "twoFactorAuth": "Two Factor Authentication", "thisMobileNumberHasBeenVerified": "This mobile number has been verified.", "unableToFindEmail": "No encontramos el correo electrónico que ha usado.", "validationCode": "Validation Code", "validationCodeHasBeenSentToYourPhone": "Validation Code has been sent to your phone", "verificationCode": "Verification Code", "verifyPhoneNumber": "Verify Phone Number", "verificationCodeHasBeenSentToYourPhone": "Verification code has been sent to your phone.", "verifyPhoneNumberFailed": "Verify phone number failed, please try again.", "goingToLogin": "Va a Iniciar sesión", "resetPassword": "Cambiar Contraseña", "reenterPassword": "Re-introducir Contraseña ", "logout": "Finalizar Sesión" }, "notificationSubjects": { "User": "usuario", "Zone": "zona", "Area": "área", "Scene": "escena", "Device": "dispositivo", "Node": "node", "notifications": "Notifications", "Gateway": "portal", "Automation": "automatización" }, "menu": { "assign": "Create new area", "auto": "Auto Configure", "createMulti": "Create Multi-Zone", "createGroup": "Create Group", "delete": "Delete", "edit": "Edit", "quickAdd": "Quick Add", "rename": "Rename", "toggle": "Toggle Select All", "unassign": "Unassign", "update": "Update" }, "notificationEvents": { "0": "Event", "1": "Conectado", "2": "Desconectado", "3": "Encendido", "4": "Apagado", "5": "Atenuación Cambiada", "6": "Agregado Al Área", "7": "Removido del Área ", "8": "Nombre Cambiado", "9": "Nombre Cambiado", "10": "Activado Por el Usuario", "11": "Activado por el Dispositivo", "12": "Movimiento Detectado", "13": "Agregado Al Área", "14": "Nombre Cambiado", "15": "Configuración Cambiada", "16": "Se Unió a la Página", "17": "Botón de Identificación Presionado", "18": "No Responde", "19": "Energía Perdida", "20": "Energía Recuperada", "21": "No Disponible", "22": "Disponible", "23": "Cambiado", "24": "Reported Aberrant Power Draw", "901": "Setup Mode", "902": "Status" }, "org": { "accountName": "Nombre de la Cuenta", "errors": "# Errores", "payment": "Pago", "sites": "# Páginas", "users": "# Usuarios", "warnings": "# Advertencias" }, "scenes": { "actions": "Acciones", "demand": "Demanda: ", "manageScenes": "Manejar Escenas", "nextEvent": "Siguiente Evento", "selectScene": "Seleccionar Escena", "sceneDemand": "Demanda de Escena" }, "schedules": { "addEvent": "Agregar Evento", "addSchedule": "Agregar Horario", "areYouSure": "¿Está seguro que quiere borrarlo?", "areYouSureCopy": "¿Está seguro que quiere copiar estos días?", "byline": "Configurar horarios para zonas, escenas y automatizaciones.", "selectAnExistingSchedule": "Para comenzar, seleccione un programa existente de la lista de la izquierda o cree uno nuevo haciendo clic en el botón más (+).", "createSchedule": "Crear Horario", "daysOfTheWeek": "Días de la semana", "events": "Eventos", "manageSchedules": "Manejar Horarios", "nextEvent": "Siguiente Evento: ", "noEvents": "No Hay Eventos", "noSchedule": "No Hay Horarios", "repeat": "Repetir", "pleaseSelectDate": "Please select recurrence date detail", "schedules": "Schedules", "scheduleName": "Schedule Name", "scheduledEvents": "Scheduled Events", "selectEvent": "Select Event", "searchForSchedules": "Search Schedules", "selectSchedule": "Seleccionar Horario", "toEditThisScheduleUpdate": "To edit this schedule, please update your gateway software. Call Lightcloud support on 1(844) LIGHTCLOUD.", "zoneSceneSchedules": "Zone & Scene Schedules" }, "settings": { "settings": "Ajustes", "answer": "Respuesta", "basicUser": "Usuario Básico", "createUser": "Crear un Usuario", "changeAndModifyUser": "Cambiar y Modificar su Información de Usuario", "changePassword": "Cambiar Contraseña", "chooseOwnPassword": "Escoger Contraseña Propia", "deleteUser": "Eliminar Usuario", "editUser": "Editar Usuario", "email": "Correo Electrónico", "firstName": "Primer Nombre", "faultNotifications": "Notification Management", "hideAreas": "Esconder Áreas", "hideZones": "Esconder Zonas", "lastName": "Apellido", "noZones": "No Hay Zonas", "noAreas": "No Hay Áreas", "noMoreThan": "and no more 30 characters", "phoneNumber": "Número de Teléfono", "phoneCode": "Código Telefónico", "permissionsUserManagement": "Permisos y Manejo del Usuario", "releaseNotes": "Notas Publicadas", "title": "Título", "temporaryPassword": "Contraseña Temporal ", "created": " Creado.", "reEnterPassword": "Re-introducir Contraseña", "releaseDate": "Fecha de Publicación", "errorMsg": "Por favor introduzca un(a)válido(a) ", "sitePermissions": "Permisos de la Página", "areaPermissions": "Permisos del Área", "zonePermissions": "Permisos de la Zona", "searchForUsers": "Buscar usuarios", "securityQuestion": "Pregunta de Seguridad", "securityPin": "Pin de Seguridad", "showAreas": "Mostrar Áreas", "showZones": "Mostrar Zonas", "softwareRelease": "Notas Publicadas del Software", "selectAUser": "Seleccionar un Usuario", "users": "Usuarios", "userManagement": "Manejo del Usuario", "userPermissions": "Permisos del Usuario", "useCurrentPassword": "Usar Contraseña Actual", "useGeneratedPassword": "Usar Contraseña Generada", "viewManageFaultNotificationEmail": "View & Manage Fault Notification Emails", "viewYourPhoneCode": "Ver Su Código Telefónico", "viewSoftwareRelease": "Ver Notas Publicadas del Software", "version": "Version" }, "sensors": { "searchSensors": "Buscar Sensores" }, "site": { "searchForSite": "Buscar Páginas", "refreshSiteList": "Refrescar Lista de Páginas", "refreshGatewayList": "Refresh Gateway List" }, "zones": { "addAZone": "Agregar Zona", "baselineWattage": "Vatios Base", "confirmRemove": "¿Está seguro que quiere remover estas Zonas?", "circuitNumber": "Número de Circuito", "dimming": "Bajar la luz", "dismissAlert": "Dismiss Alert", "dismissThisTime": "The operation will dismiss this alert for only this time period.", "dismissThisPeriod": "The operation will dismiss this alert and also reset the baseline wattage.", "faultDetected": "Are you sure you want to clear the fault notification?", "faultDescription": "There is a fault detected in this Zone. If you want to dismiss this alert, click here to check different options.", "groupControl": "Group Control", "maxTrimLevel": "Nivel Máximo de Corte", "noZone": "No Zonas", "noZonesInArea": "No hay Zonas en el Área", "inputWatts": "Vatios aportados", "noAssignedZones": "No hay Zonas sin asignar.", "resetBaseline": "& Reset Baseline", "searchByNameOrId": "Buscar por Nombre o Identificación", "setAllZones": "Set All Zones", "zones": "Zonas", "zone": "Zona", "zoneName": "Nombre de Zona", "zoneSettings": "Ajustes de Zona" }, "advance_trigger": "Occupancy Local", "advance_trigger_no_actuator": "Occupancy Custom", "controller": "Controller", "dimmer": "dimmer", "no_actuator": "Custom", "scene": "Scene", "occupancy": "Occupancy", "trigger": "Trigger", "repeater": "Repeater", "vacancy": "Vacancy", "#": { "0": "0", "1": "Healthy", "className": "Device Type", "automations_enabled": "Automation On", "automations_supported": "Automation Ready", "daylighting_enabled": "Daylighting On", "daylighting_supported": "Daylighting Ready", "daylight-harvester": "Daylight Harvester", "demand_response": "Demand Response", "enabled": "Enabled", "is_active": "Active User", "is_staff": "Staff", "is_superuser": "Superuser", "last_firmware_version": "Firmware Version", "node_health": "Device Health", "controller": "Controller", "ceiling-sensor": "Ceiling Sensor", "high-bay-sensor": "High Bay Sensor", "fixture-controller": "Fixture Controller", "phase-cut-dimmer": "Phase Cut Dimmer", "touch": "Touch", "dimmer": "Dimmer", "true": "Yes", "false": "No", "controller_health_flagged": "Controller Health", "fault_recipients_alerted": "Fault Alerted", "fixture_health_detection": "Fault Detected", "emergency_mode": "Emergency Mode", "indicating": "Indicating", "is_dimmable": "Dimmable", "power_reporting": "Power Reporting", "reported_dim_level": "Dim Level", "trim_high": "Trim High", "trim_low": "Trim Low", "zone_health": "Zone Health", "zone_state": "Zone State" } };
});
$__System.register('1', ['3', '4', '10', '11', '199', '230', '231', '18d', '20a', '22e', '22f'], function (_export) {
    /* Vendor */

    //import 'normalize.css';

    //IE polyfill
    'use strict';

    /* Languages */

    var angular, moment, _, Base, translationsZH, translationsES, Admin, CustomerService, translationsEN, lightcloudModule, container, noAngularDOM;

    _export('__unload', __unload);

    function __unload() {
        container = document.getElementById('app-container');
        container.remove();
        document.body.appendChild(noAngularDOM.cloneNode(true));
    }

    return {
        setters: [function (_2) {
            angular = _2['default'];
        }, function (_3) {}, function (_5) {
            moment = _5['default'];
        }, function (_4) {
            _ = _4['default'];
        }, function (_6) {
            Base = _6['default'];
        }, function (_7) {
            translationsZH = _7['default'];
        }, function (_8) {
            translationsES = _8['default'];
        }, function (_d) {}, function (_a) {
            Admin = _a['default'];
        }, function (_e) {
            CustomerService = _e['default'];
        }, function (_f) {
            translationsEN = _f['default'];
        }],
        execute: function () {
            if (!window.location.origin) {
                window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }

            lightcloudModule = angular.module('lightcloud', ['ui.router',
            //'ngIdle',
            'pascalprecht.translate', Base.name, Admin.name, CustomerService.name])

            //Issue provider for angular DI injection   
            .provider('moment', function () {
                this.$get = [function () {
                    return moment;
                }];
            }).provider('_', function () {
                this.$get = [function () {
                    return _;
                }];
            }).config(['$compileProvider', function ($compileProvider) {
                $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|blob):/);
                $compileProvider.debugInfoEnabled(false);
            }]).config(['$httpProvider', function ($httpProvider) {
                $httpProvider.defaults.cache = false;

                $httpProvider.defaults.xsrfCookieName = 'csrftoken';
                $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

                $httpProvider.interceptors.push('prefix');
                $httpProvider.interceptors.push('apiKey');
                $httpProvider.interceptors.push('responses');

                $httpProvider.useApplyAsync(true);
            }]).config(['$translateProvider', function ($translateProvider) {
                $translateProvider.useSanitizeValueStrategy(null);
                $translateProvider.translations('en', translationsEN);
                $translateProvider.translations('zh', translationsZH);
                $translateProvider.translations('es', translationsES);
                $translateProvider.preferredLanguage('en');

                // function translationsAudit(source, translations){
                //     let missingTranslations = [];

                //     function compareTranslations(source, other){
                //         console.log('TRANSLATION COMPARATOR: Comparing '+source.name+' with '+other.name);

                //         _.each(source.set, (category,categoryName) => {

                //             //Exit on missing category
                //             if(!other.set[categoryName]){
                //                 missingTranslations.push('MAJOR: Missing Translation Category: '+categoryName);
                //             } else {
                //                 _.each(category, (entry,entryName) => {
                //                     if(!other.set[categoryName][entryName]){
                //                         missingTranslations.push('Missing Translation: '+other.name+ ' : '+categoryName+' : '+entryName);
                //                     }
                //                 });
                //             }
                //         });
                //     }

                //     _.each(translations, translation => {
                //         compareTranslations(source, translation);
                //     });

                //     console.log(missingTranslations);
                // }   

                // console.time('Translation Audit');
                // translationsAudit({name: 'English', set: translationsEN}, [{name: 'Chinese', set: translationsZH},{name: 'Spanish', set: translationsES}]);
                // console.timeEnd('Translation Audit');
            }]).config(['$urlRouterProvider', function ($urlRouterProvider) {
                // if the path doesn't match any of the urls you configured
                // otherwise will take care of routing the user to the specified url
                //$urlRouterProvider.otherwise('/home');

                $urlRouterProvider.otherwise(function ($injector, $location) {
                    var $state = $injector.get('$state');
                    console.log('State Not Found');
                    $state.go('Home');
                });
            }]).decorator('$http', ['$delegate', '$q', function ($delegate, $q) {
                // NOTE: $delegate is the original service

                //Find this out somewhere
                var webWorkerSupport = false;

                if (webWorkerSupport) {
                    //
                    // Push all gets to the WW to improve performance
                    //
                    var newGet = function newGet(config) {
                        //
                        //
                        // - This is fucking up for template cache fetches - ignore for now?
                        //
                        //

                        // Ignore template fetches
                        if (typeof config === 'string') {
                            //
                            // Wrapped in $q to provide a finally to state service
                            //
                            return $q(function (resolve, reject) {
                                resolve($delegate.get);
                            });
                        } else {
                            //
                            // Use WW for AJAX in future?
                            //
                            // return Indexer.ajax('GET',config).then(result => {
                            //     // Mimic $http data wrap
                            //     return {data: result};
                            // });
                        }
                    };

                    $delegate.get = newGet;
                }

                return $delegate;
            }]).run(['$rootScope', '$state', '$window', '$location', '$q', '$transitions', '$trace', 'Local',
            //'Idle',
            'moment', 'Track', 'Sockets', 'Login', 'Messages', 'Session', 'Modals', 'HttpPendingRequestsService', 'LcCache', 'LcFn', 'Undo', function ($rootScope, $state, $window, $location, $q, $transitions, $trace, Local, /*Idle*/moment, Track, Sockets, Login, Messages, Session, Modals, HttpPendingRequestsService, LcCache, LcFn, Undo) {

                $trace.enable('TRANSITION');

                // $http.defaults.cache = CacheFactory('defaultCache', {
                //     maxAge: 1 * 1 * 1, // Items added to this cache expire after 3 seconds
                //     //maxAge: 1 * 3 * 1000, // Items added to this cache expire after 3 seconds
                //     //maxAge: 1 * 60 * 1000, // Items added to this cache expire after 1 minutes
                //     cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
                //     deleteOnExpire: 'aggressive' // Items will be deleted from this cache when they expire
                // });

                Track.register();

                $rootScope.$on('IdleStart', function () {
                    // the user appears to have gone idle
                    // $rootScope.$broadcast('event:showConfirmModal','Cancel','Delete','You gone idle mofo');
                    if ($location.path() !== '/login' || '/password-reset') {
                        //This needs to be a global 'are we logged in/ secure' message
                        Messages.popUp('You have been idle for 30 minutes and will be logged out soon');
                    }
                });

                $rootScope.$on('IdleTimeout', function () {
                    // the user has timed out (meaning idleDuration + timeout has passed without any activity)
                    if ($location.path() !== '/login' || '/password-reset') {
                        //This needs to be a global 'are we logged in/ secure' message
                        Messages.popUp('You have been logged out');

                        Login.logout().then(function () {
                            // Moved to service
                        })['catch'](function (data, status) {
                            $('.overlay').hide();
                            if (!data) {
                                console.log('Bad response - assuming for now its unauthorized');
                            } else {
                                if (status === 401) {
                                    // @todo This should be the handling
                                    $rootScope.unauthorized = true;
                                    $rootScope.loginState = 'Sign In';
                                }
                            }
                        });
                    }
                });

                $rootScope.$on('IdleEnd', function () {
                    // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
                });

                $rootScope.$on('Keepalive', function () {
                    // do something to keep the user's session alive
                });

                var accessAllowed = function accessAllowed(stateName) {
                    var access = true;
                    var user = Local.get('lcUser') || {};

                    var isAdmin = user.org_admin ? true : user.permissions ? _.find(user.permissions, function (perm) {
                        return perm.permission === 'org_admin';
                    }) : false;

                    $rootScope['super'] = user.is_superuser;
                    $rootScope.staff = user.is_staff;

                    if (user && !user.is_staff && !user.is_superuser && !isAdmin) {
                        if (LcFn.baseUserExclusionList.indexOf(stateName) > -1) {
                            access = false;
                        }
                    }

                    return access;
                };

                //
                //
                // Master state transition manager - single point in app where we watch all transitions
                // Handles the following:
                //
                // - Cheap auth check (is API key present, if not, no need to ask backend for true auth)
                // - Cancels outstanding AJAX
                // - Sets urlParams to cache (used by Session)
                // - Sends to last URL, runs state complete func
                //
                //
                $transitions.onBefore({}, function (transition) {
                    var toStateName = transition.$to().name;

                    var resolver = Undo.checkOutstanding();

                    if (toStateName === 'Settings') {
                        //
                        // We can remove this after a few months of BETA being live
                        //
                        console.log('No settings page anymore');

                        //HttpPendingRequestsService.cancelAll();

                        resolver = transition.router.stateService.target('Home');
                    }

                    if (LcFn.nonAuthStates.indexOf(toStateName) > -1) {
                        // Can go here without auth
                    } else {
                            // check if the state should be protected
                            if (!Local.get('apiKey') || !accessAllowed(toStateName)) {
                                console.log('No auth key / access');

                                HttpPendingRequestsService.cancelAll();
                                Login.logoutCleanup();

                                // redirect to the 'login' state
                                resolver = transition.router.stateService.target('login');
                            }
                        }

                    //
                    // Check for outstanding changes before navigation
                    //
                    return resolver;
                });

                $transitions.onStart({}, function (transition) {
                    var fromParams = transition.params('from');
                    var toParams = transition.params('to');
                    var transitionToTitle = transition.$to().title;
                    var toStateName = transition.$to().name;

                    // Cancel outstanding AJAX for old routes
                    HttpPendingRequestsService.cancelAll();

                    // Cache params for other services
                    LcCache.setUrlParams(toParams);

                    // On success
                    transition.promise.then(function () {
                        $window.document.title = transitionToTitle ? 'Lightcloud - ' + transitionToTitle : 'Lightcloud';

                        if (toStateName === 'login') {
                            //Attempted login navigation , if session is ok then goto history
                            if (Local.get('lcUser')) {
                                Session.goLastUrl();
                            }
                        } else if (toStateName === 'password-reset' || toStateName === 'agreement') {
                            //Do nothing..
                        } else {
                                stateTransitionComplete(toStateName, fromParams, toParams);
                            }
                    })['catch'](function (error) {
                        if (error && (error.detail.status === 404 || error.detail.status === 400)) {
                            //
                            //
                            // This replaces 'otherwise' in routes.js
                            //
                            //
                            $state.go('Home');
                        }
                    });
                });

                //
                // Only on successful transitions
                //
                // - Tell Sockets to join correct room
                // - Temp set currentArea (@refactor remove)
                // - Track pageview
                // - Set idle counter - maybe get rid of this
                // - Set History
                //
                function stateTransitionComplete(toStateName, fromParams, toParams) {
                    // Tell sockets to join the right room
                    if (toParams.siteId !== fromParams.siteId) {
                        Sockets.joinRoom(fromParams.siteId, toParams.siteId);
                    }

                    //Set Current Area here
                    $rootScope.currentArea = toParams.areaId ? $rootScope.currentSite.areas.filter(function (area) {
                        return area.id === toParams.areaId;
                    })[0] : false;

                    //Track pageview for GA
                    Track.event('send', 'pageview', $location.path());

                    //Page idle setup
                    //Idle.watch();

                    var localUser = Local.get('lcUser');
                    if (localUser.org && localUser.org.session_timeout) {
                        Session.setIdletime(localUser.org.session_timeout);
                    }

                    //Set history
                    urlHistorySetter();
                }

                //bind state to $rootScope, add aux function to determin view layout
                $rootScope.$state = $state;

                $rootScope.$state.isSelection = function () {
                    if (!$rootScope.$state.current.name) {
                        return false;
                    }
                    return !(LcFn.notSelectionStates.indexOf($rootScope.$state.current.name) >= 0); //@todo Better
                };

                function urlHistorySetter() {
                    var allHistory = Local.get('urlHistory') || {};

                    allHistory[Local.get('lcUser').username] = {
                        url: $location.path(), //Use ui-router $state instead of $location here
                        timestamp: moment().unix()
                    };

                    Local.set('urlHistory', allHistory);
                }

                $rootScope.mobile = LcFn.mobileCheck(); //Use this to enable / disable the slider
            }]);

            /*
             * As we are using ES6 with Angular 1.x we can't use ng-app directive
             * to bootstrap the application as modules are loaded asynchronously.
             * Instead, we need to bootstrap the application manually
             */
            container = document.getElementById('app-container');

            angular.element(document).ready(function () {
                if (location.origin.match(/localhost/) || location.origin.match(/0.0.0.0/)) {
                    // - Will fail if gulp serve static called on localhost
                    System.trace = true;
                    noAngularDOM = container.cloneNode(true);
                    if (!System.hotReloader) {
                        System['import']('capaj/systemjs-hot-reloader').then(function (HotReloader) {
                            System.hotReloader = new HotReloader['default']('http://localhost:8081/');
                            System.hotReloader.on('change', function (name) {
                                console.log(name, 'changed');
                            });
                        });
                    }
                }

                angular.bootstrap(container, [lightcloudModule.name]), {
                    strictDi: true
                };
            });

            _export('default', lightcloudModule);
        }
    };
});

//import 'ng-idle';

(function(c){if (typeof document == 'undefined') return; var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[a](d.createTextNode(c));})
("table.dataTable{width:100%;margin:0 auto;clear:both;border-collapse:separate;border-spacing:0}table.dataTable tfoot th,table.dataTable thead th{font-weight:700}table.dataTable thead td,table.dataTable thead th{padding:10px 18px;border-bottom:1px solid #111}table.dataTable thead td:active,table.dataTable thead th:active{outline:none}table.dataTable tfoot td,table.dataTable tfoot th{padding:10px 18px 6px;border-top:1px solid #111}table.dataTable thead .sorting,table.dataTable thead .sorting_asc,table.dataTable thead .sorting_asc_disabled,table.dataTable thead .sorting_desc,table.dataTable thead .sorting_desc_disabled{cursor:pointer;*cursor:hand;background-repeat:no-repeat;background-position:100%}table.dataTable thead .sorting{background-image:url(\"jspm_packages/npm/datatables@1.10.18/media/images/sort_both.png\")}table.dataTable thead .sorting_asc{background-image:url(\"jspm_packages/npm/datatables@1.10.18/media/images/sort_asc.png\")}table.dataTable thead .sorting_desc{background-image:url(\"jspm_packages/npm/datatables@1.10.18/media/images/sort_desc.png\")}table.dataTable thead .sorting_asc_disabled{background-image:url(\"jspm_packages/npm/datatables@1.10.18/media/images/sort_asc_disabled.png\")}table.dataTable thead .sorting_desc_disabled{background-image:url(\"jspm_packages/npm/datatables@1.10.18/media/images/sort_desc_disabled.png\")}table.dataTable tbody tr{background-color:#fff}table.dataTable tbody tr.selected{background-color:#b0bed9}table.dataTable tbody td,table.dataTable tbody th{padding:8px 10px}table.dataTable.display tbody td,table.dataTable.display tbody th,table.dataTable.row-border tbody td,table.dataTable.row-border tbody th{border-top:1px solid #ddd}table.dataTable.display tbody tr:first-child td,table.dataTable.display tbody tr:first-child th,table.dataTable.row-border tbody tr:first-child td,table.dataTable.row-border tbody tr:first-child th{border-top:none}table.dataTable.cell-border tbody td,table.dataTable.cell-border tbody th{border-top:1px solid #ddd;border-right:1px solid #ddd}table.dataTable.cell-border tbody tr td:first-child,table.dataTable.cell-border tbody tr th:first-child{border-left:1px solid #ddd}table.dataTable.cell-border tbody tr:first-child td,table.dataTable.cell-border tbody tr:first-child th{border-top:none}table.dataTable.display tbody tr.odd,table.dataTable.stripe tbody tr.odd{background-color:#f9f9f9}table.dataTable.display tbody tr.odd.selected,table.dataTable.stripe tbody tr.odd.selected{background-color:#acbad4}table.dataTable.display tbody tr:hover,table.dataTable.hover tbody tr:hover{background-color:#f6f6f6}table.dataTable.display tbody tr:hover.selected,table.dataTable.hover tbody tr:hover.selected{background-color:#aab7d1}table.dataTable.display tbody tr>.sorting_1,table.dataTable.display tbody tr>.sorting_2,table.dataTable.display tbody tr>.sorting_3,table.dataTable.order-column tbody tr>.sorting_1,table.dataTable.order-column tbody tr>.sorting_2,table.dataTable.order-column tbody tr>.sorting_3{background-color:#fafafa}table.dataTable.display tbody tr.selected>.sorting_1,table.dataTable.display tbody tr.selected>.sorting_2,table.dataTable.display tbody tr.selected>.sorting_3,table.dataTable.order-column tbody tr.selected>.sorting_1,table.dataTable.order-column tbody tr.selected>.sorting_2,table.dataTable.order-column tbody tr.selected>.sorting_3{background-color:#acbad5}table.dataTable.display tbody tr.odd>.sorting_1,table.dataTable.order-column.stripe tbody tr.odd>.sorting_1{background-color:#f1f1f1}table.dataTable.display tbody tr.odd>.sorting_2,table.dataTable.order-column.stripe tbody tr.odd>.sorting_2{background-color:#f3f3f3}table.dataTable.display tbody tr.odd>.sorting_3,table.dataTable.order-column.stripe tbody tr.odd>.sorting_3{background-color:#f5f5f5}table.dataTable.display tbody tr.odd.selected>.sorting_1,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_1{background-color:#a6b4cd}table.dataTable.display tbody tr.odd.selected>.sorting_2,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_2{background-color:#a8b5cf}table.dataTable.display tbody tr.odd.selected>.sorting_3,table.dataTable.order-column.stripe tbody tr.odd.selected>.sorting_3{background-color:#a9b7d1}table.dataTable.display tbody tr.even>.sorting_1,table.dataTable.order-column.stripe tbody tr.even>.sorting_1{background-color:#fafafa}table.dataTable.display tbody tr.even>.sorting_2,table.dataTable.order-column.stripe tbody tr.even>.sorting_2{background-color:#fcfcfc}table.dataTable.display tbody tr.even>.sorting_3,table.dataTable.order-column.stripe tbody tr.even>.sorting_3{background-color:#fefefe}table.dataTable.display tbody tr.even.selected>.sorting_1,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_1{background-color:#acbad5}table.dataTable.display tbody tr.even.selected>.sorting_2,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_2{background-color:#aebcd6}table.dataTable.display tbody tr.even.selected>.sorting_3,table.dataTable.order-column.stripe tbody tr.even.selected>.sorting_3{background-color:#afbdd8}table.dataTable.display tbody tr:hover>.sorting_1,table.dataTable.order-column.hover tbody tr:hover>.sorting_1{background-color:#eaeaea}table.dataTable.display tbody tr:hover>.sorting_2,table.dataTable.order-column.hover tbody tr:hover>.sorting_2{background-color:#ececec}table.dataTable.display tbody tr:hover>.sorting_3,table.dataTable.order-column.hover tbody tr:hover>.sorting_3{background-color:#efefef}table.dataTable.display tbody tr:hover.selected>.sorting_1,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_1{background-color:#a2aec7}table.dataTable.display tbody tr:hover.selected>.sorting_2,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_2{background-color:#a3b0c9}table.dataTable.display tbody tr:hover.selected>.sorting_3,table.dataTable.order-column.hover tbody tr:hover.selected>.sorting_3{background-color:#a5b2cb}table.dataTable.no-footer{border-bottom:1px solid #111}table.dataTable.nowrap td,table.dataTable.nowrap th{white-space:nowrap}table.dataTable.compact thead td,table.dataTable.compact thead th{padding:4px 17px 4px 4px}table.dataTable.compact tbody td,table.dataTable.compact tbody th,table.dataTable.compact tfoot td,table.dataTable.compact tfoot th{padding:4px}table.dataTable td.dt-left,table.dataTable th.dt-left{text-align:left}table.dataTable td.dataTables_empty,table.dataTable td.dt-center,table.dataTable th.dt-center{text-align:center}table.dataTable td.dt-right,table.dataTable th.dt-right{text-align:right}table.dataTable td.dt-justify,table.dataTable th.dt-justify{text-align:justify}table.dataTable td.dt-nowrap,table.dataTable th.dt-nowrap{white-space:nowrap}table.dataTable tfoot td.dt-head-left,table.dataTable tfoot th.dt-head-left,table.dataTable thead td.dt-head-left,table.dataTable thead th.dt-head-left{text-align:left}table.dataTable tfoot td.dt-head-center,table.dataTable tfoot th.dt-head-center,table.dataTable thead td.dt-head-center,table.dataTable thead th.dt-head-center{text-align:center}table.dataTable tfoot td.dt-head-right,table.dataTable tfoot th.dt-head-right,table.dataTable thead td.dt-head-right,table.dataTable thead th.dt-head-right{text-align:right}table.dataTable tfoot td.dt-head-justify,table.dataTable tfoot th.dt-head-justify,table.dataTable thead td.dt-head-justify,table.dataTable thead th.dt-head-justify{text-align:justify}table.dataTable tfoot td.dt-head-nowrap,table.dataTable tfoot th.dt-head-nowrap,table.dataTable thead td.dt-head-nowrap,table.dataTable thead th.dt-head-nowrap{white-space:nowrap}table.dataTable tbody td.dt-body-left,table.dataTable tbody th.dt-body-left{text-align:left}table.dataTable tbody td.dt-body-center,table.dataTable tbody th.dt-body-center{text-align:center}table.dataTable tbody td.dt-body-right,table.dataTable tbody th.dt-body-right{text-align:right}table.dataTable tbody td.dt-body-justify,table.dataTable tbody th.dt-body-justify{text-align:justify}table.dataTable tbody td.dt-body-nowrap,table.dataTable tbody th.dt-body-nowrap{white-space:nowrap}table.dataTable,table.dataTable td,table.dataTable th{box-sizing:content-box}.dataTables_wrapper{position:relative;clear:both;zoom:1}.dataTables_wrapper .dataTables_length{float:left}.dataTables_wrapper .dataTables_filter{float:right;text-align:right}.dataTables_wrapper .dataTables_filter input{margin-left:.5em}.dataTables_wrapper .dataTables_info{clear:both;float:left;padding-top:.755em}.dataTables_wrapper .dataTables_paginate{float:right;text-align:right;padding-top:.25em}.dataTables_wrapper .dataTables_paginate .paginate_button{box-sizing:border-box;display:inline-block;min-width:1.5em;padding:.5em 1em;margin-left:2px;text-align:center;text-decoration:none!important;cursor:pointer;*cursor:hand;color:#333!important;border:1px solid transparent;border-radius:2px}.dataTables_wrapper .dataTables_paginate .paginate_button.current,.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover{color:#333!important;border:1px solid #979797;background-color:#fff;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#dcdcdc));background:-webkit-linear-gradient(top,#fff,#dcdcdc);background:linear-gradient(180deg,#fff 0,#dcdcdc)}.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active,.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover{cursor:default;color:#666!important;border:1px solid transparent;background:transparent;box-shadow:none}.dataTables_wrapper .dataTables_paginate .paginate_button:hover{color:#fff!important;border:1px solid #111;background-color:#585858;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#585858),color-stop(100%,#111));background:-webkit-linear-gradient(top,#585858,#111);background:linear-gradient(180deg,#585858 0,#111)}.dataTables_wrapper .dataTables_paginate .paginate_button:active{outline:none;background-color:#2b2b2b;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#2b2b2b),color-stop(100%,#0c0c0c));background:-webkit-linear-gradient(top,#2b2b2b,#0c0c0c);background:linear-gradient(180deg,#2b2b2b 0,#0c0c0c);box-shadow:inset 0 0 3px #111}.dataTables_wrapper .dataTables_paginate .ellipsis{padding:0 1em}.dataTables_wrapper .dataTables_processing{position:absolute;top:50%;left:50%;width:100%;height:40px;margin-left:-50%;margin-top:-25px;padding-top:20px;text-align:center;font-size:1.2em;background-color:#fff;background:-webkit-gradient(linear,left top,right top,color-stop(0,hsla(0,0%,100%,0)),color-stop(25%,hsla(0,0%,100%,.9)),color-stop(75%,hsla(0,0%,100%,.9)),color-stop(100%,hsla(0,0%,100%,0)));background:-webkit-linear-gradient(left,hsla(0,0%,100%,0),hsla(0,0%,100%,.9) 25%,hsla(0,0%,100%,.9) 75%,hsla(0,0%,100%,0));background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.9) 25%,hsla(0,0%,100%,.9) 75%,hsla(0,0%,100%,0))}.dataTables_wrapper .dataTables_filter,.dataTables_wrapper .dataTables_info,.dataTables_wrapper .dataTables_length,.dataTables_wrapper .dataTables_paginate,.dataTables_wrapper .dataTables_processing{color:#333}.dataTables_wrapper .dataTables_scroll{clear:both}.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody{*margin-top:-1px;-webkit-overflow-scrolling:touch}.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>tbody>tr>td,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>tbody>tr>th,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>thead>tr>td,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>thead>tr>th{vertical-align:middle}.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>tbody>tr>td>div.dataTables_sizing,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>tbody>tr>th>div.dataTables_sizing,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>thead>tr>td>div.dataTables_sizing,.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody>table>thead>tr>th>div.dataTables_sizing{height:0;overflow:hidden;margin:0!important;padding:0!important}.dataTables_wrapper.no-footer .dataTables_scrollBody{border-bottom:1px solid #111}.dataTables_wrapper.no-footer div.dataTables_scrollBody>table,.dataTables_wrapper.no-footer div.dataTables_scrollHead table.dataTable{border-bottom:none}.dataTables_wrapper:after{visibility:hidden;display:block;content:\"\";clear:both;height:0}@media screen and (max-width:767px){.dataTables_wrapper .dataTables_info,.dataTables_wrapper .dataTables_paginate{float:none;text-align:center}.dataTables_wrapper .dataTables_paginate{margin-top:.5em}}@media screen and (max-width:640px){.dataTables_wrapper .dataTables_filter,.dataTables_wrapper .dataTables_length{float:none;text-align:center}.dataTables_wrapper .dataTables_filter{margin-top:.5em}}\n/*# sourceMappingURL=__.css.map */");
})
(function(factory) {
  factory();
});